/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(3);
	
	__webpack_require__(7);
	
	__webpack_require__(9);
	
	var _services = __webpack_require__(18);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _config = __webpack_require__(197);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _components = __webpack_require__(202);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _auth = __webpack_require__(308);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _home = __webpack_require__(318);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _detail = __webpack_require__(339);
	
	var _detail2 = _interopRequireDefault(_detail);
	
	var _reports = __webpack_require__(360);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _axios = __webpack_require__(19);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(366);
	__webpack_require__(369);
	
	_angular2.default.module('app', [
	// Third party dependencies
	__webpack_require__(370), __webpack_require__(372), __webpack_require__(374), __webpack_require__(375), 'mgcrea.ngStrap',
	
	// Application specific modules
	_services2.default, _config2.default, _components2.default, _auth2.default, _home2.default, _detail2.default, _reports2.default]).run(function () {
	    var element = document.getElementById('appLoadingDiv');
	    element.parentNode.removeChild(element);
	});
	
	// Bootstrap angular until manifest has been fetched
	window.onload = function getManifest() {
	    var manifestURL = 'https://1u31fuekv5.execute-api.eu-west-1.amazonaws.com/prod/manifest';
	    window.iofAxios = new _axios2.default();
	
	    var appLoadingDiv = document.createElement('div');
	    appLoadingDiv.setAttribute('id', 'appLoadingDiv');
	    appLoadingDiv.setAttribute('class', 'sb-app-loading-splash');
	    appLoadingDiv.innerHTML = 'Loading Scanbox Connect...';
	    document.body.appendChild(appLoadingDiv);
	
	    window.iofAxios.http.get(manifestURL).then(function (_ref) {
	        var data = _ref.data;
	
	        window.manifest = data;
	
	        // Start Angular
	        _angular2.default.bootstrap(document.body, ['app']);
	    }).catch(function () {
	        appLoadingDiv.innerHTML = 'Failed to load Scanbox Connect';
	    });
	};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	module.exports = angular;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/
	
	var minErrConfig = {
	  objectMaxDepth: 5,
	  urlErrorParamsEnabled: true
	};
	
	/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 *
	 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies whether the generated error url will
	 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
	 *   generated error url is very long.
	 *
	 *   Default: true. When used without argument, it returns the current value.
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	    if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
	      minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * AngularJS. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace'). Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	
	  var url = 'https://errors.angularjs.org/1.8.3/';
	  var regex = url.replace('.', '\\.') + '[\\s\\S]*';
	  var errRegExp = new RegExp(regex, 'g');
	
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    // A minErr message has two parts: the message itself and the url that contains the
	    // encoded message.
	    // The message's parameters can contain other error messages which also include error urls.
	    // To prevent the messages from getting too long, we strip the error urls from the parameters.
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index].replace(errRegExp, '');
	      }
	
	      return match;
	    });
	
	    message += '\n' + url + (module ? module + '/' : '') + code;
	
	    if (minErrConfig.urlErrorParamsEnabled) {
	      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	      }
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  addDateMinutes,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	  UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (key !== '__proto__') {
	            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	            baseExtend(dst[key], [src], true);
	          }
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest using another, similar library for all-purpose merging,
	* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* `angular.merge` also does not support merging objects with circular references.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	function isArray(arr) {
	  return Array.isArray(arr) || arr instanceof Array;
	}
	
	/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */
	function isError(value) {
	  var tag = toString.call(value);
	  switch (tag) {
	    case '[object Error]': return true;
	    case '[object Exception]': return true;
	    case '[object DOMException]': return true;
	    default: return value instanceof Error;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
	 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
	 * function, and has several limitations (see below).
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 *
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 *   `angular.copy` does not check if destination and source are of the same type. It's the
	 *   developer's responsibility to make sure they are compatible.
	 * </div>
	 *
	 * @knownIssue
	 * This is a non-exhaustive list of object types / features that are not handled correctly by
	 * `angular.copy`. Note that since this functions is used by the change detection code, this
	 * means binding or watching objects of these types (or that include these types) might not work
	 * correctly.
	 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
	 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
	 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
	 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
	 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
	 * - [`getter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
	 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)
	 *
	 * @param {*} source The source that will be used to make a copy. Can be any type, including
	 *     primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
	 *     must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>leader = {{leader | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.leader = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.leader);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.leader);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since AngularJS uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-15+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone().empty();
	  var elemHtml = jqLite('<div></div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // Support: IE 9-11 only
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for banned URL schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * @example
	 *
	 * ### Simple Usage
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * @example
	 *
	 * ### With `ngStrictDi`
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up AngularJS application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of AngularJS try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of AngularJS on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	  } else {
	    jqLite = JQLite;
	  }
	
	  // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
	  // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
	  // the $destroy event on all removed nodes.
	  originalCleanData = jqLite.cleanData;
	  jqLite.cleanData = function(elems) {
	    var events;
	    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	      events = (jqLite._data(elem) || {}).events;
	      if (events && events.$destroy) {
	        jqLite(elem).triggerHandler('$destroy');
	      }
	    }
	    originalCleanData(elems);
	  };
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Restores the pre-1.8 behavior of jqLite that turns XHTML-like strings like
	 * `<div /><span />` to `<div></div><span></span>` instead of `<div><span></span></div>`.
	 * The new behavior is a security fix. Thus, if you need to call this function, please try to adjust
	 * your code for this change and remove your use of this function as soon as possible.
	
	 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
	 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
	 * about the workarounds.
	 */
	function UNSAFE_restoreLegacyJqLiteXHTMLReplacement() {
	  JQLite.legacyXHTMLReplacement = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring AngularJS {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
	     * modules.
	     * All modules (AngularJS core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	           *    or an object map of components where the keys are the names and the values are the component definition objects.
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to configure services by injecting their
	           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
	           * {@link ngRoute.$routeProvider $routeProvider}.
	           *
	           * Note that you can only inject {@link angular.Module#provider `providers`} and
	           * {@link angular.Module#constant `constants`} into this function.
	           *
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* exported toDebugString */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    // This file is also included in `angular-loader`, so `copy()` might not always be available in
	    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	    obj = angular.copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  hiddenInputBrowserCacheDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRefDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $$IntervalFactoryProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $$TaskTrackerFactoryProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.8.3',
	  major: 1,
	  minor: 8,
	  dot: 3,
	  codeName: 'ultimate-farewell'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    'UNSAFE_restoreLegacyJqLiteXHTMLReplacement': UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$lowercase': lowercase,
	    '$$stringify': stringify,
	    '$$uppercase': uppercase
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRef: ngRefDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective,
	          input: hiddenInputBrowserCacheDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $$intervalFactory: $$IntervalFactoryProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.8.3' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## AngularJS's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
	 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * jqLite also provides a method restoring pre-1.8 insecure treatment of XHTML-like tags.
	 * This legacy behavior turns input like `<div /><span />` to `<div></div><span></span>`
	 * instead of `<div><span></span></div>` like version 1.8 & newer do. To restore it, invoke:
	 * ```js
	 * angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement();
	 * ```
	 * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
	 * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
	 * about the workarounds.
	 *
	 * ## jQuery/jqLite Extras
	 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	// Table parts need to be wrapped with `<table>` or they're
	// stripped to their contents when put in a div.
	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do, so we cannot shorten
	// this by omitting <tbody> or other required elements.
	var wrapMap = {
	  thead: ['table'],
	  col: ['colgroup', 'table'],
	  tr: ['tbody', 'table'],
	  td: ['tr', 'tbody', 'table']
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <10 only
	// IE 9 requires an option wrapper & it needs to have the whole table structure
	// set up in advance; assigning `"<td></td>"` to `tr.innerHTML` doesn't work, etc.
	var wrapMapIE9 = {
	  option: [1, '<select multiple="multiple">', '</select>'],
	  _default: [0, '', '']
	};
	
	for (var key in wrapMap) {
	  var wrapMapValueClosing = wrapMap[key];
	  var wrapMapValue = wrapMapValueClosing.slice().reverse();
	  wrapMapIE9[key] = [wrapMapValue.length, '<' + wrapMapValue.join('><') + '>', '</' + wrapMapValueClosing.join('></') + '>'];
	}
	
	wrapMapIE9.optgroup = wrapMapIE9.option;
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap, finalHtml,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    finalHtml = JQLite.legacyXHTMLReplacement ?
	      html.replace(XHTML_TAG_REGEXP, '<$1></$2>') :
	      html;
	
	    if (msie < 10) {
	      wrap = wrapMapIE9[tag] || wrapMapIE9._default;
	      tmp.innerHTML = wrap[1] + finalHtml + wrap[2];
	
	      // Descend through wrappers to the right content
	      i = wrap[0];
	      while (i--) {
	        tmp = tmp.firstChild;
	      }
	    } else {
	      wrap = wrapMap[tag] || [];
	
	      // Create wrappers & descend into them
	      i = wrap.length;
	      while (--i > -1) {
	        tmp.appendChild(window.document.createElement(wrap[i]));
	        tmp = tmp.firstChild;
	      }
	
	      tmp.innerHTML = finalHtml;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function isEmptyObject(obj) {
	  var name;
	
	  for (name in obj) {
	    return false;
	  }
	  return true;
	}
	
	function removeIfEmptyData(element) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  var events = expandoStore && expandoStore.events;
	  var data = expandoStore && expandoStore.data;
	
	  if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	
	  removeIfEmptyData(element);
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	    } else {
	      expandoStore.data = {};
	    }
	
	    removeIfEmptyData(element);
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        newClasses += cssClass + ' ';
	      }
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	      jqLiteOff(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key !== this._lastKey) {
	      this._lastKey = key;
	      this._lastIndex = this._keys.indexOf(key);
	    }
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  has: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    return idx !== -1;
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running AngularJS app
	 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * ## Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ### Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ### `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ### Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * #### Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * #### The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * #### The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	/**
	 * @ngdoc method
	 * @name $injector#loadNewModules
	 *
	 * @description
	 *
	 * **This is a dangerous API, which you use at your own risk!**
	 *
	 * Add the specified modules to the current injector.
	 *
	 * This method will add each of the injectables to the injector and execute all of the config and run
	 * blocks for each module passed to the method.
	 *
	 * If a module has already been loaded into the injector then it will not be loaded again.
	 *
	 * * The application developer is responsible for loading the code containing the modules; and for
	 * ensuring that lazy scripts are not downloaded and executed more often that desired.
	 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
	 * * Modules cannot be unloaded.
	 *
	 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
	 * into the injector, which may indicate whether the script has been executed already.
	 *
	 * @example
	 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
	 *
	 * ```javascript
	 * app.factory('loadModule', function($injector) {
	 *   return function loadModule(moduleName, bundleUrl) {
	 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
	 *   };
	 * })
	 * ```
	 *
	 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * It is possible to inject other providers into the provider function,
	 * but the injected provider must have been defined before the one that requires it.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  instanceInjector.loadNewModules = function(mods) {
	    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
	  };
	
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	  var customFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */
	  this.customFilter = function(filterFn) {
	    if (arguments.length === 1) {
	      customFilter = isFunction(filterFn) ? filterFn : null;
	    }
	
	    return customFilter;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * <div class="alert alert-warning">
	       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
	       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
	       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
	       * However, there are two exceptions:
	       *
	       * <ul>
	       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
	       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
	       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
	       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
	       *   the `setClass` event, but if it either removes or adds classes,
	       *   it will fire `animate` instead.</li>
	       * </ul>
	       *
	       * </div>
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered.
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       * * `data` - an object with these properties:
	       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
	       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
	       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
	       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
	       *
	       * Note that the callback does not trigger a scope digest. Wrap your call into a
	       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation and applies the end state of the animation.
	       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
	       * adding the element to the DOM.
	       *
	       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
	       *
	       * @example
	        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
	          <file name="app.js">
	            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
	              templateUrl: 'template.html',
	              controller: function($element, $animate) {
	                this.runner = null;
	
	                this.addClass = function() {
	                  this.runner = $animate.addClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.removeClass = function() {
	                  this.runner = $animate.removeClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.cancel = function() {
	                  $animate.cancel(this.runner);
	                };
	              }
	            });
	          </file>
	          <file name="template.html">
	            <p>
	              <button id="add" ng-click="$ctrl.addClass()">Add</button>
	              <button ng-click="$ctrl.removeClass()">Remove</button>
	              <br>
	              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
	              <br>
	              <div id="target">CSS-Animated Text</div>
	            </p>
	          </file>
	          <file name="index.html">
	            <cancel-example></cancel-example>
	          </file>
	          <file name="style.css">
	            .red-add, .red-remove {
	              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
	            }
	
	            .red,
	            .red-add.red-add-active {
	              color: #FF0000;
	              font-size: 40px;
	            }
	
	            .red-remove.red-remove-active {
	              font-size: 10px;
	              color: black;
	            }
	
	          </file>
	        </example>
	       */
	      cancel: function(runner) {
	        if (runner.cancel) {
	          runner.cancel();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} animationRunner the animation runner
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global getHash: true, stripHash: false */
	
	function getHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? '' : url.substr(index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/#$/, '');
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {},
	      taskTracker = $$taskTrackerFactory($log);
	
	  self.isMock = false;
	
	  //////////////////////////////////////////////////////////////
	  // Task-tracking API
	  //////////////////////////////////////////////////////////////
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = taskTracker.completeTask;
	  self.$$incOutstandingRequestCount = taskTracker.incTaskCount;
	
	  // TODO(vojta): prefix this method with $$ ?
	  self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of `location.href` (with a
	   * trailing `#` stripped of if the hash is empty).
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
	   * `location.href`/`location.replace` is used.
	   * Returns its own instance to allow chaining.
	   *
	   * NOTE: this api is intended for use only by the `$location` service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state State object to use with `pushState`/`replaceState`
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Normalize the inputted URL
	      url = urlResolve(url).href;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      return trimEmptyHash(pendingLocation || location.href);
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of AngularJS:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of AngularJS.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay, taskType) {
	    var timeoutId;
	
	    delay = delay || 0;
	    taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;
	
	    taskTracker.incTaskCount(taskType);
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      taskTracker.completeTask(fn, taskType);
	    }, delay);
	    pendingDeferIds[timeoutId] = taskType;
	
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds.hasOwnProperty(deferId)) {
	      var taskType = pendingDeferIds[deferId];
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      taskTracker.completeTask(noop, taskType);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory',
	       function($window,   $log,   $sniffer,   $document,   $$taskTrackerFactory) {
	    return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
	       * directive to cache templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
	 * {@link ng.$cacheFactory $cacheFactory}.
	 *
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
	 * or by consuming the `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
	 * element with {@link ngApp} attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with life-cycle hooks in the new Angular
	 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
	 *
	 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
	 *   `ngDoCheck` in Angular.
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance.)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
	 *   isn't  optional and doesn't exist, an exception
	 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
	 *   to the local value, since it will be impossible to sync them back to the parent scope.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr`
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   It's also possible to watch the evaluated value shallowly with
	 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
	 * The marker must come after the mode and before the attribute name.
	 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
	 * This is useful to refine the interface directives provide.
	 * One subtle difference between optional and non-optional happens **when the binding attribute is not
	 * set**:
	 * - the binding is optional: the property will not be defined
	 * - the binding is not optional: the property is defined
	 *
	 * ```js
	 *app.directive('testDir', function() {
	    return {
	      scope: {
	        notoptional: '=',
	        optional: '=?',
	      },
	      bindToController: true,
	      controller: function() {
	        this.$onInit = function() {
	          console.log(this.hasOwnProperty('notoptional')) // true
	          console.log(this.hasOwnProperty('optional')) // false
	        }
	      }
	    }
	  })
	 *```
	 *
	 *
	 * ##### Combining directives with different scope defintions
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace`
	 * <div class="alert alert-danger">
	 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
	 * </div>
	 *
	 * Specifies what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that are defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
	 *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // Configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects '$compile'.
	        $compileProvider.directive('compile', function($compile) {
	          // The directive factory creates a link function.
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                // Watch the 'compile' expression for changes.
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // When the 'compile' expression changes
	                // assign it into the current DOM.
	                element.html(value);
	
	                // Compile the new DOM and link it to the current scope.
	                // NOTE: we only compile '.childNodes' so that we
	                // don't get into an infinite loop compiling ourselves.
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'AngularJS';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello AngularJS'.
	       expect(output.getText()).toBe('Hello AngularJS');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('AngularJS!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
	 *        elements (e.g. SVG elements). See also the `directive.controller` property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to `$digest`, which typically is done by
	 * AngularJS automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = angular.element('<p>{{total}}</p>');
	 *     $compile(element)(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
	 *   linking function:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>');
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       // Attach the clone to DOM document at the right place.
	 *     });
	 *
	 *     // Now we have reference to the cloned DOM via `clonedElement`.
	 *     // NOTE: The `clonedElement` returned by the linking function is the same as the
	 *     //       `clonedElement` passed to `cloneAttachFn`.
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	
	 * @knownIssue
	
	   ### Issues with `replace: true`
	 *
	 * <div class="alert alert-danger">
	 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
	 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
	 * </div>
	 *
	 * #### Attribute values are not merged
	 *
	 * When a `replace` directive encounters the same attribute on the original and the replace node,
	 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
	 * the `style` attribute.
	 * ```html
	 * Original Node: <span class="original" style="color: red;"></span>
	 * Replace Template: <span class="replaced" style="background: blue;"></span>
	 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
	 * ```
	 *
	 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
	 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
	 *
	 * ```html
	 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
	 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
	 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
	 * ```
	 *
	 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
	 *
	 * #### Directives are not deduplicated before compilation
	 *
	 * When the original node and the replace template declare the same directive(s), they will be
	 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
	 * does not deduplicate them. In many cases, this is not noticeable, but e.g. {@link ngModel} will
	 * attach `$formatters` and `$parsers` twice.
	 *
	 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
	 *
	 * #### `transclude: element` in the replace template root can have unexpected effects
	 *
	 * When the replace template has a directive at the root node that uses
	 * {@link $compile#-transclude- `transclude: element`}, e.g.
	 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
	 * See the following issues:
	 *
	 * - Incorrect scope on replaced element:
	 * [#9837](https://github.com/angular/angular.js/issues/9837)
	 * - Different DOM between `template` and `templateUrl`:
	 * [#10612](https://github.com/angular/angular.js/issues/14326)
	 *
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngProp
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-prop-propname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "propName"):
	 *
	 *
	 * ```html
	 * <ANY ng-prop-prop_name="expression">
	 * </ANY>
	 * ```
	 *
	 *
	 * @description
	 * The `ngProp` directive binds an expression to a DOM element property.
	 * `ngProp` allows writing to arbitrary properties by including
	 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
	 * the `value` property.
	 *
	 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
	 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
	 *
	 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
	 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
	 * custom elements.
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
	 * example, and for binding HTML {@link ngBindHtml} should be used.
	 *
	 * ## Security
	 *
	 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
	 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
	 * malicious code.
	 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
	 * This means vulnerable properties require their content to be "trusted", based on the
	 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
	 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
	 * this property are trusted as a `RESOURCE_URL`.
	 *
	 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
	 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
	 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
	 *
	 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
	 *
	 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
	 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
	 * the {@link $sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList()}
	 * and {@link $sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList()}.
	 *
	 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
	 *
	 * ### HTML Sanitization
	 *
	 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
	 * content.
	 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
	 * potentially dangerous HTML, e.g. strip non-trusted tags and attributes when binding to
	 * `innerHTML`.
	 *
	 * @example
	 * ### Binding to different contexts
	 *
	 * <example name="ngProp" module="exampleNgProp">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         Binding to a property without security context:
	 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerText</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... so that actually dangerous content cannot be executed:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Binding to innerHTML with ngSanitize
	 *
	 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', ['ngSanitize'])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         "Safe" content will be sanitized ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... as will dangerous content:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 */
	
	/** @ngdoc directive
	 * @name ngOn
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-on-eventname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "eventName"):
	 *
	 *
	 * ```html
	 * <ANY ng-on-event_name="expression">
	 * </ANY>
	 * ```
	 *
	 * @description
	 * The `ngOn` directive adds an event listener to a DOM element via
	 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
	 * fired.
	 * `ngOn` allows adding listeners for arbitrary events by including
	 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
	 * when the `drop` event is fired.
	 *
	 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
	 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
	 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
	 * standards.
	 *
	 * Another use-case for `ngOn` is listening to
	 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
	 * fired by
	 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `myEvent` must be written as `ng-on-my_event="expression"`.
	 *
	 * @example
	 * ### Bind to built-in DOM events
	 *
	 * <example name="ngOn" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.clickCount = 0;
	 *           this.mouseoverCount = 0;
	 *
	 *           this.loadingState = 0;
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
	 *       <button
	 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
	 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
	 *       clickCount: {{$ctrl.clickCount}}<br>
	 *       mouseover: {{$ctrl.mouseoverCount}}
	 *
	 *       <hr>
	 *
	 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
	 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
	 *       <div ng-switch="$ctrl.loadingState">
	 *         <span ng-switch-when="0">Image is loading</span>
	 *         <span ng-switch-when="-1">Image load error</span>
	 *         <span ng-switch-when="1">Image loaded successfully</span>
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Bind to custom DOM events
	 *
	 * <example name="ngOnCustom" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.eventLog = '';
	 *
	 *           this.listener = function($event) {
	 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
	 *           };
	 *         }
	 *       })
	 *       .component('childComponent', {
	 *         templateUrl: 'child.html',
	 *         controller: function($element) {
	 *           this.fireEvent = function() {
	 *             var event = new CustomEvent('customtype', { detail: new Date()});
	 *
	 *             $element[0].dispatchEvent(event);
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
	 *     <span>Event log: {{$ctrl.eventLog}}</span>
	 *   </file>
	 *   <file name="child.html">
	      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      definition = definition.trim();
	
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
	   *    as `ng-bind`), or an object map of directives where the keys are the names and the values
	   *    are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    if (!isString(name)) {
	      forEach(name, reverseParams(bind(this, registerComponent)));
	      return this;
	    }
	
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationTrustedUrlList
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationTrustedUrlList`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $compileProvider#aHrefSanitizationTrustedUrlList
	   * aHrefSanitizationTrustedUrlList} instead.
	   */
	  Object.defineProperty(this, 'aHrefSanitizationWhitelist', {
	    get: function() {
	      return this.aHrefSanitizationTrustedUrlList;
	    },
	    set: function(value) {
	      this.aHrefSanitizationTrustedUrlList = value;
	    }
	  });
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationTrustedUrlList
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationTrustedUrlList`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $compileProvider#imgSrcSanitizationTrustedUrlList
	   * imgSrcSanitizationTrustedUrlList} instead.
	   */
	  Object.defineProperty(this, 'imgSrcSanitizationWhitelist', {
	    get: function() {
	      return this.imgSrcSanitizationTrustedUrlList;
	    },
	    set: function(value) {
	      this.imgSrcSanitizationTrustedUrlList = value;
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `ng-scope` and `ng-isolated-scope` CSS classes
	   * * `$binding` data property containing an array of the binding expressions
	   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
	   *   the element's scope.
	   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
	   *   E.g. `<!-- ngIf: shouldShow() -->`.
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
	   * otherwise return the current strictComponentBindingsEnabled state.
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable / disable the strict component bindings check. If enabled, the
	   * compiler will enforce that all scope / controller bindings of a
	   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
	   * that are not set as optional with `?`, must be provided when the directive is instantiated.
	   * If not provided, the compiler will throw the
	   * {@link error/$compile/missingattr $compile:missingattr error}.
	   *
	   * The default value is false.
	   */
	  var strictComponentBindingsEnabled = false;
	  this.strictComponentBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      strictComponentBindingsEnabled = enabled;
	      return this;
	    }
	    return strictComponentBindingsEnabled;
	  };
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	
	  /**
	   * The security context of DOM Properties.
	   * @private
	   */
	  var PROP_CONTEXTS = createMap();
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#addPropertySecurityContext
	   * @description
	   *
	   * Defines the security context for DOM properties bound by ng-prop-*.
	   *
	   * @param {string} elementName The element name or '*' to match any element.
	   * @param {string} propertyName The DOM property name.
	   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
	   * @returns {object} `this` for chaining
	   */
	  this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
	    var key = (elementName.toLowerCase() + '|' + propertyName.toLowerCase());
	
	    if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
	      throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
	    }
	
	    PROP_CONTEXTS[key] = ctx;
	    return this;
	  };
	
	  /* Default property contexts.
	   *
	   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
	   * Changing:
	   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
	   * - STYLE => CSS
	   * - various URL => MEDIA_URL
	   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
	   */
	  (function registerNativePropertyContexts() {
	    function registerContext(ctx, values) {
	      forEach(values, function(v) { PROP_CONTEXTS[v.toLowerCase()] = ctx; });
	    }
	
	    registerContext(SCE_CONTEXTS.HTML, [
	      'iframe|srcdoc',
	      '*|innerHTML',
	      '*|outerHTML'
	    ]);
	    registerContext(SCE_CONTEXTS.CSS, ['*|style']);
	    registerContext(SCE_CONTEXTS.URL, [
	      'area|href',       'area|ping',
	      'a|href',          'a|ping',
	      'blockquote|cite',
	      'body|background',
	      'del|cite',
	      'input|src',
	      'ins|cite',
	      'q|cite'
	    ]);
	    registerContext(SCE_CONTEXTS.MEDIA_URL, [
	      'audio|src',
	      'img|src',    'img|srcset',
	      'source|src', 'source|srcset',
	      'track|src',
	      'video|src',  'video|poster'
	    ]);
	    registerContext(SCE_CONTEXTS.RESOURCE_URL, [
	      '*|formAction',
	      'applet|code',      'applet|codebase',
	      'base|href',
	      'embed|src',
	      'frame|src',
	      'form|action',
	      'head|profile',
	      'html|manifest',
	      'iframe|src',
	      'link|href',
	      'media|src',
	      'object|codebase',  'object|data',
	      'script|src'
	    ]);
	  })();
	
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function sanitizeSrcset(value, invokeType) {
	      if (!value) {
	        return value;
	      }
	      if (!isString(value)) {
	        throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
	      }
	
	      // Such values are a bit too complex to handle automatically inside $sce.
	      // Instead, we sanitize each of the URIs individually, which works, even dynamically.
	
	      // It's not possible to work around this using `$sce.trustAsMediaUrl`.
	      // If you want to programmatically set explicitly trusted unsafe URLs, you should use
	      // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
	      // `ng-bind-html` directive.
	
	      var result = '';
	
	      // first check if there are spaces because it's not the same pattern
	      var trimmedSrcset = trim(value);
	      //                (   999x   ,|   999w   ,|   ,|,   )
	      var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	      var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	      // split srcset into tuple of uri and descriptor except for the last item
	      var rawUris = trimmedSrcset.split(pattern);
	
	      // for each tuples
	      var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	      for (var i = 0; i < nbrUrisWith2parts; i++) {
	        var innerIdx = i * 2;
	        // sanitize the uri
	        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
	        // add the descriptor
	        result += ' ' + trim(rawUris[innerIdx + 1]);
	      }
	
	      // split the last item into uri and descriptor
	      var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	      // sanitize the last uri
	      result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));
	
	      // and add the last descriptor if any
	      if (lastTuple.length === 2) {
	        result += (' ' + trim(lastTuple[1]));
	      }
	      return result;
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        // is set through this function since it may cause $updateClass to
	        // become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        // Sanitize img[srcset] values.
	        if (nodeName === 'img' && key === 'srcset') {
	          this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              // jQuery skips special boolean attrs treatment in XML nodes for
	              // historical reasons and hence AngularJS cannot freely call
	              // `.attr(attrName, false) with such attributes. To avoid issues
	              // in XHTML, call `removeAttr` in such cases instead.
	              // See https://github.com/jquery/jquery/issues/4249
	              if (booleanKey && value === false) {
	                this.$$element.removeAttr(attrName);
	              } else {
	                this.$$element.attr(attrName, value);
	              }
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            var isNgAttr = false, isNgProp = false, isNgEvent = false;
	            var multiElementMatch;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            nName = directiveNormalize(name.toLowerCase());
	
	            // Support ng-attr-*, ng-prop-* and ng-on-*
	            if ((ngPrefixMatch = nName.match(NG_PREFIX_BINDING))) {
	              isNgAttr = ngPrefixMatch[1] === 'Attr';
	              isNgProp = ngPrefixMatch[1] === 'Prop';
	              isNgEvent = ngPrefixMatch[1] === 'On';
	
	              // Normalize the non-prefixed name
	              name = name.replace(PREFIX_REGEXP, '')
	                .toLowerCase()
	                .substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	
	            // Support *-start / *-end multi element directives
	            } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            if (isNgProp || isNgEvent) {
	              attrs[nName] = value;
	              attrsMap[nName] = attr.name;
	
	              if (isNgProp) {
	                addPropertyDirective(node, directives, nName, name);
	              } else {
	                addEventDirective(directives, nName, name);
	              }
	            } else {
	              // Update nName for cases where a prefix was removed
	              // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
	              nName = directiveNormalize(name.toLowerCase());
	              attrsMap[nName] = name;
	
	              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	              }
	
	              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                            attrEndName);
	            }
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = window.document.createDocumentFragment();
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
	                  slots[slotName].appendChild(node);
	                } else {
	                  $template.appendChild(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  var slotCompileNodes = jqLite(slots[slotName].childNodes);
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
	                }
	              }
	
	              $template = jqLite($template.childNodes);
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          controller.instance = controller();
	          $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	          controller.bindingInfo =
	            initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	
	          if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
	            // inheritedData() uses the documentElement when it finds the document, so we would
	            // require from the element itself.
	            value = null;
	          } else {
	            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	          }
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (isError(error)) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedAttrContext(nodeName, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      // All nodes with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media nodes, which require the MEDIA_URL context.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	        return $sce.MEDIA_URL;
	      } else if (attrNormalizedName === 'xlinkHref') {
	        // Some xlink:href are okay, most aren't
	        if (nodeName === 'image') return $sce.MEDIA_URL;
	        if (nodeName === 'a') return $sce.URL;
	        return $sce.RESOURCE_URL;
	      } else if (
	          // Formaction
	          (nodeName === 'form' && attrNormalizedName === 'action') ||
	          // If relative URLs can go where they are not expected to, then
	          // all sorts of trust issues can arise.
	          (nodeName === 'base' && attrNormalizedName === 'href') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (nodeName === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      } else if (nodeName === 'a' && (attrNormalizedName === 'href' ||
	                                 attrNormalizedName === 'ngHref')) {
	        return $sce.URL;
	      }
	    }
	
	    function getTrustedPropContext(nodeName, propNormalizedName) {
	      var prop = propNormalizedName.toLowerCase();
	      return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
	    }
	
	    function sanitizeSrcsetPropertyValue(value) {
	      return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
	    }
	    function addPropertyDirective(node, directives, attrName, propName) {
	      if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
	        throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
	      }
	
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedPropContext(nodeName, propName);
	
	      var sanitizer = identity;
	      // Sanitize img[srcset] + source[srcset] values.
	      if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
	        sanitizer = sanitizeSrcsetPropertyValue;
	      } else if (trustedContext) {
	        sanitizer = $sce.getTrusted.bind($sce, trustedContext);
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function ngPropCompileFn(_, attr) {
	          var ngPropGetter = $parse(attr[attrName]);
	          var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
	            // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	            return $sce.valueOf(val);
	          });
	
	          return {
	            pre: function ngPropPreLinkFn(scope, $element) {
	              function applyPropValue() {
	                var propValue = ngPropGetter(scope);
	                $element[0][propName] = sanitizer(propValue);
	              }
	
	              applyPropValue();
	              scope.$watch(ngPropWatch, applyPropValue);
	            }
	          };
	        }
	      });
	    }
	
	    function addEventDirective(directives, attrName, eventName) {
	      directives.push(
	        createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false)
	      );
	    }
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedAttrContext(nodeName, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	    function strictBindingsCheck(attrName, directiveName) {
	      if (strictComponentBindingsEnabled) {
	        throw $compileMinErr('missingattr',
	          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
	          attrName, directiveName);
	      }
	    }
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	              destination[scopeName] = attrs[attrName] = undefined;
	
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var isLiteral = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (isLiteral && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            });
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	            }
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in AngularJS:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by AngularJS to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {};
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in AngularJS expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value) || isFunction(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          if (isFunction(toSerialize)) {
	            toSerialize = toSerialize();
	          }
	          parts.push(encodeUriQuery(prefix) + '=' +
	              (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
	
	      if (hasJsonContentType || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          if (!hasJsonContentType) {
	            return data;
	          }
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   */
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   */
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   */
	  var interceptorFactories = this.interceptors = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfTrustedOrigins
	   * @description
	   *
	   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
	   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
	   * XSRF.
	   *
	   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
	   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
	   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
	   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
	   * Examples: `http://example.com`, `https://api.example.com:9876`
	   *
	   * <div class="alert alert-warning">
	   *   It is not possible to trust specific URLs/paths. The `path`, `query` and `fragment` parts
	   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
	   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
	   *   `https://foo.com/` will include the XSRF token.
	   * </div>
	   *
	   * @example
	   *
	   * ```js
	   * // App served from `https://example.com/`.
	   * angular.
	   *   module('xsrfTrustedOriginsExample', []).
	   *   config(['$httpProvider', function($httpProvider) {
	   *     $httpProvider.xsrfTrustedOrigins.push('https://api.example.com');
	   *   }]).
	   *   run(['$http', function($http) {
	   *     // The XSRF token will be sent.
	   *     $http.get('https://api.example.com/preferences').then(...);
	   *
	   *     // The XSRF token will NOT be sent.
	   *     $http.get('https://stats.example.com/activity').then(...);
	   *   }]);
	   * ```
	   */
	  var xsrfTrustedOrigins = this.xsrfTrustedOrigins = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfWhitelistedOrigins
	   * @description
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This property is deprecated. Use {@link $httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}
	   * instead.
	   */
	  Object.defineProperty(this, 'xsrfWhitelistedOrigins', {
	    get: function() {
	      return this.xsrfTrustedOrigins;
	    },
	    set: function(origins) {
	      this.xsrfTrustedOrigins = origins;
	    }
	  });
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * A function to check request URLs against a list of allowed origins.
	     */
	    var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfTrustedOrigins);
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core AngularJS service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
	     * resolved (request success) or rejected (request failure) with a
	     * {@link ng.$http#$http-returns response} object.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * AngularJS provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * AngularJS will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * AngularJS will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
	     * the cookie, your server can be assured that the XHR came from JavaScript running on your
	     * domain.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
	     * sure that only JavaScript running on your domain could have sent the request. The token must
	     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
	     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
	     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
	     * want to, you can trust additional origins to also receive the XSRF token, by adding them
	     * to {@link ng.$httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}. This might be
	     * useful, for example, if your application, served from `example.com`, needs to access your API
	     * at `api.example.com`.
	     * See {@link ng.$httpProvider#xsrfTrustedOrigins $httpProvider.xsrfTrustedOrigins} for
	     * more details.
	     *
	     * <div class="alert alert-danger">
	     *   **Warning**<br />
	     *   Only trusted origins that you have control over and make sure you understand the
	     *   implications of doing so.
	     * </div>
	     *
	     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
	     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
	     * `$http.defaults` at run-time, or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple AngularJS apps share the
	     * same domain or subdomain, we recommend that each application uses a unique cookie name.
	     *
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *
	     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
	     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
	     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
	     *
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
	     *   or rejected (request failure) with a response object.
	     *
	     *   The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with
	     *     the transform functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used
	     *     to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
	     *     (`complete`, `error`, `timeout` or `abort`).
	     *
	     *
	     *   A response status code between 200 and 299 is considered a success status
	     *   and will result in the success callback being called. Any response status
	     *   code outside of that range is considered an error status and will result
	     *   in the error callback being called.
	     *   Also, status codes less than -1 are normalized to zero. -1 usually means
	     *   the request was aborted, e.g. using a `config.timeout`. More information
	     *   about the status might be available in the `xhrStatus` property.
	     *
	     *   Note that if the response is a redirect, XMLHttpRequest will transparently
	     *   follow it, meaning that the outcome (success or error) will be determined
	     *   by the final response status code.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must add the JSONP endpoint that we are using to the trusted list to show that we trust it
	      $sceDelegateProvider.trustedResourceUrlList([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount('$http');
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop, '$http');
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the trusted resource URL list via
	     * {@link $sceDelegateProvider#trustedResourceUrlList  `$sceDelegateProvider.trustedResourceUrlList`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * You should avoid generating the URL for the JSONP request from user provided data.
	     * Provide additional query parameters via `params` property of the `config` parameter, rather than
	     * modifying the URL itself.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	      * See {@link ng.$http#$http-returns `$http()` return value}.
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsAllowedOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText, xhrStatus) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText, xhrStatus);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText, xhrStatus) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText,
	          xhrStatus: xhrStatus
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, cbKey) {
	      var parts = url.split('?');
	      if (parts.length > 2) {
	        // Throw if the url contains more than one `?` query indicator
	        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
	      }
	      var params = parseKeyValue(parts[1]);
	      forEach(params, function(value, key) {
	        if (value === 'JSON_CALLBACK') {
	          // Throw if the url already contains a reference to JSON_CALLBACK
	          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	        }
	        if (key === cbKey) {
	          // Throw if the callback param was already provided
	          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
	        }
	      });
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text, 'complete');
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	      var abortedByTimeout = false;
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText,
	            'complete');
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'error');
	      };
	
	      var requestAborted = function() {
	        completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
	      };
	
	      var requestTimeout = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'timeout');
	      };
	
	      xhr.onerror = requestError;
	      xhr.ontimeout = requestTimeout;
	      xhr.onabort = requestAborted;
	
	      forEach(eventHandlers, function(value, key) {
	        xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    // Since we are using xhr.abort() when a request times out, we have to set a flag that
	    // indicates to requestAborted if the request timed out or was aborted.
	    //
	    // http.timeout = numerical timeout   timeout
	    // http.timeout = $timeout            timeout
	    // http.timeout = promise             abort
	    // xhr.abort()                        abort (The xhr object is normally inaccessible, but
	    //                                    can be exposed with the xhrFactory)
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(function() {
	        timeoutRequest('timeout');
	      }, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(function() {
	        timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
	      });
	    }
	
	    function timeoutRequest(reason) {
	      abortedByTimeout = reason === 'timeout';
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText, xhrStatus);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    }
	    return startSymbol;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    }
	    return endSymbol;
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'AngularJS';
	     *   expect(exp(context)).toEqual('Hello AngularJS!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;
	
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        if (mustHaveExpression) return;
	
	        var unescapedText = unescapeText(text);
	        if (contextAllowsConcatenation) {
	          unescapedText = $sce.getTrusted(trustedContext, unescapedText);
	        }
	        var constantInterp = valueFn(unescapedText);
	        constantInterp.exp = text;
	        constantInterp.expressions = [];
	        constantInterp.$$watchDelegate = constantWatchDelegate;
	
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns,
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [],
	          singleExpression;
	
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push(''); // Placeholder that will get replaced with the evaluated expression.
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      singleExpression = concat.length === 1 && expressionPositions.length === 1;
	      // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
	      // objects rather than simple strings
	      // (we don't modify the expression if the input consists of only a single trusted input)
	      var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
	      parseFns = expressions.map(function(exp) { return $parse(exp, interceptor); });
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
	      // we ensure that the value that's used is assigned or constructed by some JS code somewhere
	      // that is more testable or make it obvious that you bound the value to some user controlled
	      // value.  This helps reduce the load when auditing for XSS issues.
	
	      // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
	      // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
	      // or on the overall concatenated string (losing trusted types used in the mix, by design).
	      // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
	      // only used in srcdoc attributes, this would not be very useful.
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	
	          if (contextAllowsConcatenation) {
	            // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
	            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
	          } else if (trustedContext && concat.length > 1) {
	            // This context does not allow more than one part, e.g. expr + string or exp + exp.
	            $interpolateMinErr.throwNoconcat(text);
	          }
	          // In an unprivileged context or only one part: just concatenate and return.
	          return concat.join('');
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
	          // parts of a full URL. We don't care about losing the trustedness here.
	          // In non-concatenable contexts, where there is only one expression, this interceptor is
	          // not applied to the expression.
	          value = (trustedContext && !contextAllowsConcatenation) ?
	                    $sce.getTrusted(trustedContext, value) :
	                    $sce.valueOf(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	var $intervalMinErr = minErr('$interval');
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$$intervalFactory', '$window',
	       function($$intervalFactory,   $window) {
	    var intervals = {};
	    var setIntervalFn = function(tick, delay, deferred) {
	      var id = $window.setInterval(tick, delay);
	      intervals[id] = deferred;
	      return id;
	    };
	    var clearIntervalFn = function(id) {
	      $window.clearInterval(id);
	      delete intervals[id];
	    };
	
	    /**
	     * @ngdoc service
	     * @name $interval
	     *
	     * @description
	     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	     * milliseconds.
	     *
	     * The return value of registering an interval function is a promise. This promise will be
	     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	     * run indefinitely if `count` is not defined. The value of the notification will be the
	     * number of iterations that have run.
	     * To cancel an interval, call `$interval.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	     * time.
	     *
	     * <div class="alert alert-warning">
	     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	     * with them.  In particular they are not automatically destroyed when a controller's scope or a
	     * directive's element are destroyed.
	     * You should take this into consideration and make sure to always cancel the interval at the
	     * appropriate moment.  See the example below for more details on how and when to do this.
	     * </div>
	     *
	     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	     *   are passed (see below), the function is called with the current iteration count.
	     * @param {number} delay Number of milliseconds between each function call.
	     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	     *   indefinitely.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	     *
	     * @example
	     * <example module="intervalExample" name="interval-service">
	     * <file name="index.html">
	     *   <script>
	     *     angular.module('intervalExample', [])
	     *       .controller('ExampleController', ['$scope', '$interval',
	     *         function($scope, $interval) {
	     *           $scope.format = 'M/d/yy h:mm:ss a';
	     *           $scope.blood_1 = 100;
	     *           $scope.blood_2 = 120;
	     *
	     *           var stop;
	     *           $scope.fight = function() {
	     *             // Don't start a new fight if we are already fighting
	     *             if ( angular.isDefined(stop) ) return;
	     *
	     *             stop = $interval(function() {
	     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	     *                 $scope.blood_1 = $scope.blood_1 - 3;
	     *                 $scope.blood_2 = $scope.blood_2 - 4;
	     *               } else {
	     *                 $scope.stopFight();
	     *               }
	     *             }, 100);
	     *           };
	     *
	     *           $scope.stopFight = function() {
	     *             if (angular.isDefined(stop)) {
	     *               $interval.cancel(stop);
	     *               stop = undefined;
	     *             }
	     *           };
	     *
	     *           $scope.resetFight = function() {
	     *             $scope.blood_1 = 100;
	     *             $scope.blood_2 = 120;
	     *           };
	     *
	     *           $scope.$on('$destroy', function() {
	     *             // Make sure that the interval is destroyed too
	     *             $scope.stopFight();
	     *           });
	     *         }])
	     *       // Register the 'myCurrentTime' directive factory method.
	     *       // We inject $interval and dateFilter service since the factory method is DI.
	     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	     *         function($interval, dateFilter) {
	     *           // return the directive link function. (compile function not needed)
	     *           return function(scope, element, attrs) {
	     *             var format,  // date format
	     *                 stopTime; // so that we can cancel the time updates
	     *
	     *             // used to update the UI
	     *             function updateTime() {
	     *               element.text(dateFilter(new Date(), format));
	     *             }
	     *
	     *             // watch the expression, and update the UI on change.
	     *             scope.$watch(attrs.myCurrentTime, function(value) {
	     *               format = value;
	     *               updateTime();
	     *             });
	     *
	     *             stopTime = $interval(updateTime, 1000);
	     *
	     *             // listen on DOM destroy (removal) event, and cancel the next UI update
	     *             // to prevent updating time after the DOM element was removed.
	     *             element.on('$destroy', function() {
	     *               $interval.cancel(stopTime);
	     *             });
	     *           }
	     *         }]);
	     *   </script>
	     *
	     *   <div>
	     *     <div ng-controller="ExampleController">
	     *       <label>Date format: <input ng-model="format"></label> <hr/>
	     *       Current time is: <span my-current-time="format"></span>
	     *       <hr/>
	     *       Blood 1 : <font color='red'>{{blood_1}}</font>
	     *       Blood 2 : <font color='red'>{{blood_2}}</font>
	     *       <button type="button" data-ng-click="fight()">Fight</button>
	     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	     *     </div>
	     *   </div>
	     *
	     * </file>
	     * </example>
	     */
	    var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);
	
	    /**
	     * @ngdoc method
	     * @name $interval#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`.
	     *
	     * @param {Promise=} promise returned by the `$interval` function.
	     * @returns {boolean} Returns `true` if the task was successfully canceled.
	     */
	    interval.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$intervalId')) {
	        throw $intervalMinErr('badprom',
	            '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
	      }
	
	      if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;
	
	      var id = promise.$$intervalId;
	      var deferred = intervals[id];
	
	      // Interval cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      clearIntervalFn(id);
	
	      return true;
	    };
	
	    return interval;
	  }];
	}
	
	/** @this */
	function $$IntervalFactoryProvider() {
	  this.$get = ['$browser', '$q', '$$q', '$rootScope',
	       function($browser,   $q,   $$q,   $rootScope) {
	    return function intervalFactory(setIntervalFn, clearIntervalFn) {
	      return function intervalFn(fn, delay, count, invokeApply) {
	        var hasParams = arguments.length > 4,
	            args = hasParams ? sliceArgs(arguments, 4) : [],
	            iteration = 0,
	            skipApply = isDefined(invokeApply) && !invokeApply,
	            deferred = (skipApply ? $$q : $q).defer(),
	            promise = deferred.promise;
	
	        count = isDefined(count) ? count : 0;
	
	        function callback() {
	          if (!hasParams) {
	            fn(iteration);
	          } else {
	            fn.apply(null, args);
	          }
	        }
	
	        function tick() {
	          if (skipApply) {
	            $browser.defer(callback);
	          } else {
	            $rootScope.$evalAsync(callback);
	          }
	          deferred.notify(iteration++);
	
	          if (count > 0 && iteration >= count) {
	            deferred.resolve(iteration);
	            clearIntervalFn(promise.$$intervalId);
	          }
	
	          if (!skipApply) $rootScope.$apply();
	        }
	
	        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);
	
	        return promise;
	      };
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various AngularJS components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	/* global stripHash: true */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    // decode forward slashes to prevent them from being double encoded
	    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
	  }
	
	  return segments.join('/');
	}
	
	function decodePath(path, html5Mode) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = decodeURIComponent(segments[i]);
	    if (html5Mode) {
	      // encode forward slashes to prevent them from being mistaken for path separators
	      segments[i] = segments[i].replace(/\//g, '%2F');
	    }
	  }
	
	  return segments.join('/');
	}
	
	function normalizePath(pathValue, searchValue, hashValue) {
	  var search = toKeyValue(searchValue),
	    hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
	    path = encodePath(pathValue);
	
	  return path + (search ? '?' + search : '') + hash;
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj, html5Mode) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
	  locationObj.$$path = decodePath(path, html5Mode);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this, true);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBaseNoFile + url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this, false);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of AngularJS, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBase + (url ? hashPrefix + url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$normalizeUrl = function(url) {
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    return appBase + hashPrefix + url;
	  };
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * Compose url and update `url` and `absUrl` property
	   * @private
	   */
	  $$compose: function() {
	    this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
	    this.$$absUrl = this.$$normalizeUrl(this.$$url);
	    this.$$urlUpdatedByLocation = true;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    // Determine if two URLs are equal despite potentially having different encoding/normalizing
	    //  such as $location.absUrl() vs $browser.url()
	    // See https://github.com/angular/angular.js/issues/16592
	    function urlsEqual(a, b) {
	      return a === b || urlResolve(a).href === urlResolve(b).href;
	    }
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the AngularJS application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if ($location.absUrl() !== initialUrl) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = $browser.url();
	        var newUrl = $location.absUrl();
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (isError(arg)) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop;
	
	      return function() {
	        var args = [];
	        forEach(arguments, function(arg) {
	          args.push(formatError(arg));
	        });
	        // Support: IE 9 only
	        // console methods don't inherit from Function.prototype in IE 9 so we can't
	        // call `logFn.apply(console, args)` directly.
	        return Function.prototype.apply.call(logFn, console, args);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing AngularJS Expressions
	// ------------------------------
	// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following AngularJS expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	var PURITY_ABSOLUTE = 1;
	var PURITY_RELATIVE = 2;
	
	// Detect nodes which could depend on non-shallow state of objects
	function isPure(node, parentIsPure) {
	  switch (node.type) {
	    // Computed members might invoke a stateful toString()
	    case AST.MemberExpression:
	      if (node.computed) {
	        return false;
	      }
	      break;
	
	    // Unary always convert to primative
	    case AST.UnaryExpression:
	      return PURITY_ABSOLUTE;
	
	    // The binary + operator can invoke a stateful toString().
	    case AST.BinaryExpression:
	      return node.operator !== '+' ? PURITY_ABSOLUTE : false;
	
	    // Functions / filters probably read state from within objects
	    case AST.CallExpression:
	      return false;
	  }
	
	  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
	}
	
	function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	
	  var astIsPure = ast.isPure = isPure(ast, parentIsPure);
	
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
	      allConstants = allConstants && property.value.constant;
	      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      if (property.computed) {
	        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
	        allConstants = allConstants && property.key.constant;
	        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var inputs = this.state.inputs;
	    var self = this;
	    forEach(inputs, function(input) {
	      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
	      if (input.isPure) {
	        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
	      }
	    });
	    if (inputs.length) {
	      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        input.isPure = watch.isPure;
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.getAst(text);
	    var fn = this.astCompiler.compile(ast.ast);
	    fn.literal = isLiteral(ast.ast);
	    fn.constant = isConstant(ast.ast);
	    fn.oneTime = ast.oneTime;
	    return fn;
	  },
	
	  getAst: function(exp) {
	    var oneTime = false;
	    exp = exp.trim();
	
	    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	      oneTime = true;
	      exp = exp.substring(2);
	    }
	    return {
	      ast: this.ast.ast(exp),
	      oneTime: oneTime
	    };
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts AngularJS {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'AngularJS'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('AngularJS');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    $parse.$$getAst = $$getAst;
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	
	            cache[cacheKey] = addWatchDelegate(parsedExpression);
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function $$getAst(exp) {
	      var lexer = new Lexer($parseOptions);
	      var parser = new Parser(lexer, $filter, $parseOptions);
	      return parser.getAst(exp).ast;
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	      var unwatch, lastValue;
	
	      var exp = parsedExpression.$$intercepted || parsedExpression;
	      var post = parsedExpression.$$interceptor || identity;
	
	      var useInputs = parsedExpression.inputs && !exp.inputs;
	
	      // Propagate the literal/inputs/constant attributes
	      // ... but not oneTime since we are handling it
	      oneTimeWatch.literal = parsedExpression.literal;
	      oneTimeWatch.constant = parsedExpression.constant;
	      oneTimeWatch.inputs = parsedExpression.inputs;
	
	      // Allow other delegates to run on this wrapped expression
	      addWatchDelegate(oneTimeWatch);
	
	      unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);
	
	      return unwatch;
	
	      function unwatchIfDone() {
	        if (isDone(lastValue)) {
	          unwatch();
	        }
	      }
	
	      function oneTimeWatch(scope, locals, assign, inputs) {
	        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
	        if (isDone(lastValue)) {
	          scope.$$postDigest(unwatchIfDone);
	        }
	        return post(lastValue);
	      }
	    }
	
	    function isAllDefined(value) {
	      var allDefined = true;
	      forEach(value, function(val) {
	        if (!isDefined(val)) allDefined = false;
	      });
	      return allDefined;
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addWatchDelegate(parsedExpression) {
	      if (parsedExpression.constant) {
	        parsedExpression.$$watchDelegate = constantWatchDelegate;
	      } else if (parsedExpression.oneTime) {
	        parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
	      } else if (parsedExpression.inputs) {
	        parsedExpression.$$watchDelegate = inputsWatchDelegate;
	      }
	
	      return parsedExpression;
	    }
	
	    function chainInterceptors(first, second) {
	      function chainedInterceptor(value) {
	        return second(first(value));
	      }
	      chainedInterceptor.$stateful = first.$stateful || second.$stateful;
	      chainedInterceptor.$$pure = first.$$pure && second.$$pure;
	
	      return chainedInterceptor;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	
	      // Extract any existing interceptors out of the parsedExpression
	      // to ensure the original parsedExpression is always the $$intercepted
	      if (parsedExpression.$$interceptor) {
	        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
	        parsedExpression = parsedExpression.$$intercepted;
	      }
	
	      var useInputs = false;
	
	      var fn = function interceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value);
	      };
	
	      // Maintain references to the interceptor/intercepted
	      fn.$$intercepted = parsedExpression;
	      fn.$$interceptor = interceptorFn;
	
	      // Propagate the literal/oneTime/constant attributes
	      fn.literal = parsedExpression.literal;
	      fn.oneTime = parsedExpression.oneTime;
	      fn.constant = parsedExpression.constant;
	
	      // Treat the interceptor like filters.
	      // If it is not $stateful then only watch its inputs.
	      // If the expression itself has no inputs then use the full expression as an input.
	      if (!interceptorFn.$stateful) {
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	
	        if (!interceptorFn.$$pure) {
	          fn.inputs = fn.inputs.map(function(e) {
	              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	              // non-pure interceptor function.
	              if (e.isPure === PURITY_RELATIVE) {
	                return function depurifier(s) { return e(s); };
	              }
	              return e;
	            });
	        }
	      }
	
	      return addWatchDelegate(fn);
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * ## $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * ## The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * ## The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * ## Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * ## Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * ## Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        markQStateExceptionHandled(state);
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	          // This error is explicitly marked for being passed to the $exceptionHandler
	          if (e && e.$$passToExceptionHandler === true) {
	            exceptionHandler(e);
	          }
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!isStateExceptionHandled(toCheck)) {
	        markQStateExceptionHandled(toCheck);
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (isError(toCheck.value)) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function isStateExceptionHandled(state) {
	  return !!state.pur;
	}
	function markQStateExceptionHandled(state) {
	  state.pur = true;
	}
	function markQExceptionHandled(q) {
	  // Built-in `$q` promises will always have a `$$state` property. This check is to allow
	  // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
	  // (Currently, this is the only method that might be called with a promise, even if it is not
	  // created by the built-in `$q`.)
	  if (q.$$state) {
	    markQStateExceptionHandled(q.$$state);
	  }
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	      this.$$suspended = false;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * ## Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$suspended = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are (or contain)
	       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * @example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	        var fn = isFunction(listener) ? listener : noop;
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: fn,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
	            newValues[i] = value;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          try {
	            if (firstRun) {
	              firstRun = false;
	              listener(newValues, newValues, self);
	            } else {
	              listener(newValues, oldValues, self);
	            }
	          } finally {
	            for (var i = 0; i < watchExpressions.length; i++) {
	              oldValues[i] = newValues[i];
	            }
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * @example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        // Mark the interceptor as
	        // ... $$pure when literal since the instance will change when any input changes
	        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
	        // ... $stateful when non-literal since we must read the state of the collection
	        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * @example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = asyncQueue.length ? $rootScope : this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = !current.$$suspended && current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            // (though it differs due to having the extra check for $$suspended and does not
	            // check $$listenerCount)
	            if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$suspend
	       * @kind function
	       *
	       * @description
	       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
	       *
	       * This can be used to optimize your application when you know that running those watchers
	       * is redundant.
	       *
	       * **Warning**
	       *
	       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
	       * Only use this approach if you are confident that you know what you are doing and have
	       * ample tests to ensure that bindings get updated as you expect.
	       *
	       * Some of the things to consider are:
	       *
	       * * Any external event on a directive/component will not trigger a digest while the hosting
	       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
	       * * Transcluded content exists on a scope that inherits from outside a directive but exists
	       *   as a child of the directive's containing scope. If the containing scope is suspended the
	       *   transcluded scope will also be suspended, even if the scope from which the transcluded
	       *   scope inherits is not suspended.
	       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
	       *    * A call to `$suspend()` on an already suspended scope is a no-op.
	       *    * A call to `$resume()` on a non-suspended scope is a no-op.
	       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
	       *      longer be suspended. This could result in the other directive believing a scope to be
	       *      suspended when it is not.
	       * * If a parent scope is suspended then all its descendants will be also excluded from future
	       *   digests whether or not they have been suspended themselves. Note that this also applies to
	       *   isolate child scopes.
	       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
	       *   for that scope and its descendants. When digesting we only check whether the current scope is
	       *   locally suspended, rather than checking whether it has a suspended ancestor.
	       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
	       *   included in future digests until all its ancestors have been resumed.
	       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
	       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
	       *   initiated by a component that lives on a suspended scope.
	       */
	      $suspend: function() {
	        this.$$suspended = true;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$isSuspended
	       * @kind function
	       *
	       * @description
	       * Call this method to determine if this scope has been explicitly suspended. It will not
	       * tell you whether an ancestor has been suspended.
	       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
	       * for example, you must check all its ancestors:
	       *
	       * ```
	       * function isExcludedFromDigest(scope) {
	       *   while(scope) {
	       *     if (scope.$isSuspended()) return true;
	       *     scope = scope.$parent;
	       *   }
	       *   return false;
	       * ```
	       *
	       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
	       * even if `$isSuspended()` returns false.
	       *
	       * @returns true if the current scope has been suspended.
	       */
	      $isSuspended: function() {
	        return this.$$suspended;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$resume
	       * @kind function
	       *
	       * @description
	       * Resume watchers of this scope subtree in case it was suspended.
	       *
	       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
	       */
	      $resume: function() {
	        this.$$suspended = false;
	      },
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
	       * expressions.
	       *
	       * @example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          }, null, '$evalAsync');
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the AngularJS framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * **Life cycle: Pseudo-Code of `$apply()`**
	       *
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            // Use delete in the hope of the browser deallocating the memory for the array entry,
	            // while not shifting the array indexes of other listeners.
	            // See issue https://github.com/angular/angular.js/issues/16135
	            delete namedListeners[indexOfListener];
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            break;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount and
	          // does not check $$suspended)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        }, null, '$applyAsync');
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of AngularJS application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	
	  var aHrefSanitizationTrustedUrlList = /^\s*(https?|s?ftp|mailto|tel|file):/,
	    imgSrcSanitizationTrustedUrlList = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
	   *
	   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
	   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
	   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
	   *
	   * If the URL matches the `aHrefSanitizationTrustedUrlList` regular expression, it is returned unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationTrustedUrlList = regexp;
	      return this;
	    }
	    return aHrefSanitizationTrustedUrlList;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for determining trusted safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
	   *
	   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
	   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
	   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
	   * the potentially malicious URL.
	   *
	   * If the URL matches the `imgSrcSanitizationTrustedUrlList` regular expression, it is returned
	   * unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to trust urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationTrustedUrlList = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationTrustedUrlList = regexp;
	      return this;
	    }
	    return imgSrcSanitizationTrustedUrlList;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isMediaUrl) {
	      // if (!uri) return uri;
	      var regex = isMediaUrl ? imgSrcSanitizationTrustedUrlList : aHrefSanitizationTrustedUrlList;
	      var normalizedVal = urlResolve(uri && uri.trim()).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it refers to the source of media, which are not expected to be run
	  // as scripts, such as an image, audio, video, etc.
	  MEDIA_URL: 'mediaUrl',
	
	  // An URL used in a context where it does not refer to a resource that loads code.
	  // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own trusted and banned resource lists for trusting URLs used for loading AngularJS resources
	 * such as templates.  Refer {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * $sceDelegateProvider.trustedResourceUrlList} and {@link
	 * ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the `trustedResourceUrlList` and
	 * `bannedResourceUrlList` used to ensure that the URLs used for sourcing AngularJS templates and
	 * other script-running URLs are safe (all places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * $sceDelegateProvider.trustedResourceUrlList} and
	 * {@link ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList},
	 *
	 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.trustedResourceUrlList([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The banned resource URL list overrides the trusted resource URL list so the open redirect
	 *    // here is blocked.
	 *    $sceDelegateProvider.bannedResourceUrlList([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty trusted resource URL list will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from the trusted resource URL lsit. This helps to mitigate the security impact of certain types
	 * of issues, like for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var trustedResourceUrlList = ['self'],
	      bannedResourceUrlList = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#trustedResourceUrlList
	   * @kind function
	   *
	   * @param {Array=} trustedResourceUrlList When provided, replaces the trustedResourceUrlList with
	   *     the value provided.  This must be an array or null.  A snapshot of this array is used so
	   *     further changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set trusted resource URL array.
	   *
	   * @description
	   * Sets/Gets the list trusted of resource URLs.
	   *
	   * The **default value** when no `trustedResourceUrlList` has been explicitly set is `['self']`
	   * allowing only same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default `trustedResourceUrlList` of 'self' is not recommended if your app shares
	   * its origin with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.trustedResourceUrlList = function(value) {
	    if (arguments.length) {
	      trustedResourceUrlList = adjustMatchers(value);
	    }
	    return trustedResourceUrlList;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $sceDelegateProvider#trustedResourceUrlList
	   * trustedResourceUrlList} instead.
	   */
	  Object.defineProperty(this, 'resourceUrlWhitelist', {
	    get: function() {
	      return this.trustedResourceUrlList;
	    },
	    set: function(value) {
	      this.trustedResourceUrlList = value;
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#bannedResourceUrlList
	   * @kind function
	   *
	   * @param {Array=} bannedResourceUrlList When provided, replaces the `bannedResourceUrlList` with
	   *     the value provided. This must be an array or null. A snapshot of this array is used so
	   *     further changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the `bannedResourceUrlList` is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the banned resource URL list overrides the trusted resource URL list** and has
	   *     the final say.
	   *
	   * @return {Array} The currently set `bannedResourceUrlList` array.
	   *
	   * @description
	   * Sets/Gets the `bannedResourceUrlList` of trusted resource URLs.
	   *
	   * The **default value** when no trusted resource URL list has been explicitly set is the empty
	   * array (i.e. there is no `bannedResourceUrlList`.)
	   */
	  this.bannedResourceUrlList = function(value) {
	    if (arguments.length) {
	      bannedResourceUrlList = adjustMatchers(value);
	    }
	    return bannedResourceUrlList;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @deprecated
	   * sinceVersion="1.8.1"
	   *
	   * This method is deprecated. Use {@link $sceDelegateProvider#bannedResourceUrlList
	   * bannedResourceUrlList} instead.
	   */
	  Object.defineProperty(this, 'resourceUrlBlacklist', {
	    get: function() {
	      return this.bannedResourceUrlList;
	    },
	    set: function(value) {
	      this.bannedResourceUrlList = value;
	    }
	  });
	
	  this.$get = ['$injector', '$$sanitizeUri', function($injector, $$sanitizeUri) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the trusted resource URL list allows this url.
	      for (i = 0, n = trustedResourceUrlList.length; i < n; i++) {
	        if (matchUrl(trustedResourceUrlList[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the banned resource URL list has blocked this url.
	        for (i = 0, n = bannedResourceUrlList.length; i < n; i++) {
	          if (matchUrl(bannedResourceUrlList[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Given an object and a security context in which to assign it, returns a value that's safe to
	     * use in this context, which was represented by the parameter. To do so, this function either
	     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
	     * the context and sanitizer availablility.
	     *
	     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
	     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
	     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
	     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#trustedResourceUrlList
	     * `$sceDelegateProvider.trustedResourceUrlList`} and {@link ng.$sceDelegateProvider#bannedResourceUrlList
	     * `$sceDelegateProvider.bannedResourceUrlList`} accepts that resource.
	     *
	     * This function will throw if the safe type isn't appropriate for this context, or if the
	     * value given cannot be accepted in the context (which might be caused by sanitization not
	     * being available, or the value not being recognized as safe).
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If maybeTrusted is a trusted class instance but not of the correct trusted type
	      // then unwrap it and allow it to pass through to the rest of the checks
	      if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
	        maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If we get here, then we will either sanitize the value or throw an exception.
	      if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
	        // we attempt to sanitize non-resource URLs
	        return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
	      } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * ## Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ### Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, trusted URL resource, depending on context), or throw
	 * when it cannot guarantee the security of the result. That behavior depends strongly on contexts:
	 * HTML can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ### In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ### How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ### Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, AngularJS only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either add them to the {@link ng.$sceDelegateProvider#trustedResourceUrlList
	 * trustedResourceUrlList} or {@link ng.$sce#trustAsResourceUrl wrap them} into trusted values.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ### This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
	 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
	 * when binding untrusted values to `$sce.HTML` context.
	 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#trustedResourceUrlList trusted resource URL list} and {@link
	 * ng.$sceDelegateProvider#bannedResourceUrlList banned resource URL list} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ### What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#trustedResourceUrlList $sceDelegateProvider#trustedResourceUrlList()} and {@link $sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider#bannedResourceUrlList()} can be used to restrict trusted origins for `RESOURCE_URL` |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 *
	 * <div class="alert alert-warning">
	 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
	 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
	 *
	 * **As of 1.7.0, this is no longer the case.**
	 *
	 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
	 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
	 * service evaluates the expressions.
	 * </div>
	 *
	 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
	 * functions aren't useful yet. This might evolve.
	 *
	 * ### Format of items in {@link ng.$sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList}/{@link ng.$sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      for matching resource URL lists.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ### Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $$taskTrackerFactory
	 * @description
	 * A function to create `TaskTracker` instances.
	 *
	 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
	 * parties when all pending tasks (or tasks of a specific type) have been completed.
	 *
	 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
	 *     execution.
	 *
	 * @this
	 */
	function $$TaskTrackerFactoryProvider() {
	  this.$get = valueFn(function(log) { return new TaskTracker(log); });
	}
	
	function TaskTracker(log) {
	  var self = this;
	  var taskCounts = {};
	  var taskCallbacks = [];
	
	  var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
	  var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';
	
	  /**
	   * Execute the specified function and decrement the appropriate `taskCounts` counter.
	   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
	   *
	   * @param {Function} fn - The function to execute.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
	   */
	  self.completeTask = completeTask;
	
	  /**
	   * Increase the task count for the specified task type (or the default task type if non is
	   * specified).
	   *
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
	   */
	  self.incTaskCount = incTaskCount;
	
	  /**
	   * Execute the specified callback when all pending tasks have been completed.
	   *
	   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
	   * the tasks that will be waited for to a specific type, by passing a `taskType`.
	   *
	   * @param {function} callback - The function to call when there are no pending tasks.
	   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
	   */
	  self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;
	
	  function completeTask(fn, taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	
	    try {
	      fn();
	    } finally {
	      decTaskCount(taskType);
	
	      var countForType = taskCounts[taskType];
	      var countForAll = taskCounts[ALL_TASKS_TYPE];
	
	      // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
	      if (!countForAll || !countForType) {
	        var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
	        var nextCb;
	
	        while ((nextCb = getNextCallback(taskType))) {
	          try {
	            nextCb();
	          } catch (e) {
	            log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function decTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    if (taskCounts[taskType]) {
	      taskCounts[taskType]--;
	      taskCounts[ALL_TASKS_TYPE]--;
	    }
	  }
	
	  function getLastCallback() {
	    var cbInfo = taskCallbacks.pop();
	    return cbInfo && cbInfo.cb;
	  }
	
	  function getLastCallbackForType(taskType) {
	    for (var i = taskCallbacks.length - 1; i >= 0; --i) {
	      var cbInfo = taskCallbacks[i];
	      if (cbInfo.type === taskType) {
	        taskCallbacks.splice(i, 1);
	        return cbInfo.cb;
	      }
	    }
	  }
	
	  function incTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
	    taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
	  }
	
	  function notifyWhenNoPendingTasks(callback, taskType) {
	    taskType = taskType || ALL_TASKS_TYPE;
	    if (!taskCounts[taskType]) {
	      callback();
	    } else {
	      taskCallbacks.push({type: taskType, cb: callback});
	    }
	  }
	}
	
	var $templateRequestMinErr = minErr('$templateRequest');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
	   * as {@link ngInclude} to download and cache templates.
	   *
	   * 3rd party modules should use `$templateRequest` if their services or directives are loading
	   * templates.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through adding the template again to the trusted
	        // resources for keys that already are included in there. This also makes
	        // AngularJS accept any script directive, no matter its name. However, we
	        // still need to unwrap trusted types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            return $templateCache.put(tpl, response.data);
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when all pending tasks are completed.
	     *
	     * Types of tasks waited for include:
	     * - Pending timeouts (via {@link $timeout}).
	     * - Pending HTTP requests (via {@link $http}).
	     * - In-progress route transitions (via {@link $route}).
	     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
	     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
	     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	var $timeoutMinErr = minErr('$timeout');
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	    /**
	     * @ngdoc service
	     * @name $timeout
	     *
	     * @description
	     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	     * block and delegates any exceptions to
	     * {@link ng.$exceptionHandler $exceptionHandler} service.
	     *
	     * The return value of calling `$timeout` is a promise, which will be resolved when
	     * the delay has passed and the timeout function, if provided, is executed.
	     *
	     * To cancel a timeout request, call `$timeout.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	     * synchronously flush the queue of deferred functions.
	     *
	     * If you only want a promise that will be resolved after some specified delay
	     * then you can call `$timeout` without the `fn` function.
	     *
	     * @param {function()=} fn A function, whose execution should be delayed.
	     * @param {number=} [delay=0] Delay in milliseconds.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	     *   will be resolved with the return value of the `fn` function.
	     *
	     */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay, '$timeout');
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $timeout#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`. As a result of this, the promise will be
	     * resolved with a rejection.
	     *
	     * @param {Promise=} promise Promise returned by the `$timeout` function.
	     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	     *   canceled.
	     */
	    timeout.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$timeoutId')) {
	        throw $timeoutMinErr('badprom',
	            '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
	      }
	
	      if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;
	
	      var id = promise.$$timeoutId;
	      var deferred = deferreds[id];
	
	      // Timeout cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      delete deferreds[id];
	
	      return $browser.defer.cancel(id);
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	var baseUrlParsingNode;
	
	urlParsingNode.href = 'http://[::1]';
	
	// Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
	// IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
	// when parsed out of an anchor element.
	var ipv6InBrackets = urlParsingNode.hostname === '[::1]';
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
	 *     unchanged.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description                                                            |
	 *   |---------------|------------------------------------------------------------------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol without the trailing colon                                |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol                                 |
	 *   | hostname      | The hostname                                                           |
	 *   | port          | The port, without ":"                                                  |
	 *   | pathname      | The pathname, beginning with "/"                                       |
	 *
	 */
	function urlResolve(url) {
	  if (!isString(url)) return url;
	
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  var hostname = urlParsingNode.hostname;
	
	  if (!ipv6InBrackets && hostname.indexOf(':') > -1) {
	    hostname = '[' + hostname + ']';
	  }
	
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application
	 * document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, originUrl);
	}
	
	/**
	 * Parse a request URL and determine whether it is same-origin as the current document base URL.
	 *
	 * Note: The base URL is usually the same as the document location (`location.href`) but can
	 * be overriden by using the `<base>` tag.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the URL is same-origin as the document base URL.
	 */
	function urlIsSameOriginAsBaseUrl(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, getBaseUrl());
	}
	
	/**
	 * Create a function that can check a URL's origin against a list of allowed/trusted origins.
	 * The current location's origin is implicitly trusted.
	 *
	 * @param {string[]} trustedOriginUrls - A list of URLs (strings), whose origins are trusted.
	 *
	 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
	 *     whether it is of an allowed origin.
	 */
	function urlIsAllowedOriginFactory(trustedOriginUrls) {
	  var parsedAllowedOriginUrls = [originUrl].concat(trustedOriginUrls.map(urlResolve));
	
	  /**
	   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
	   * based on a list of trusted-origin URLs. The current location's origin is implicitly
	   * trusted.
	   *
	   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
	   *     resolved or a parsed URL object).
	   *
	   * @returns {boolean} - Whether the specified URL is of an allowed origin.
	   */
	  return function urlIsAllowedOrigin(requestUrl) {
	    var parsedUrl = urlResolve(requestUrl);
	    return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
	  };
	}
	
	/**
	 * Determine if two URLs share the same origin.
	 *
	 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
	 *     a dictionary object returned by `urlResolve()`.
	 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
	 *     of a dictionary object returned by `urlResolve()`.
	 *
	 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
	 */
	function urlsAreSameOrigin(url1, url2) {
	  url1 = urlResolve(url1);
	  url2 = urlResolve(url2);
	
	  return (url1.protocol === url2.protocol &&
	          url1.host === url2.host);
	}
	
	/**
	 * Returns the current document base URL.
	 * @returns {string}
	 */
	function getBaseUrl() {
	  if (window.document.baseURI) {
	    return window.document.baseURI;
	  }
	
	  // `document.baseURI` is available everywhere except IE
	  if (!baseUrlParsingNode) {
	    baseUrlParsingNode = window.document.createElement('a');
	    baseUrlParsingNode.href = '.';
	
	    // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
	    // suitable here because we need to track changes to the base URL.
	    baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
	  }
	  return baseUrlParsingNode.href;
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In AngularJS we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how AngularJS filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the AngularJS Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services. AngularJS comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // If the currency symbol is empty, trim whitespace around the symbol
	    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(currencySymbolRe, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 *    **Note:** `null` values use `'null'` as their type.
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, sorts values of different types by type and puts
	 * `undefined` and `null` values at the end of the sorted list.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types:
	 *    - If one of the values is undefined, consider it "greater than" the other.
	 *    - Else if one of the values is null, consider it "greater than" the other.
	 *    - Else compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
	 *           any other value (with undefined "greater than" null). This effectively means that `null`
	 *           and `undefined` values end up at the end of a list sorted in ascending order.
	 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = (type1 === 'undefined') ? 1 :
	        (type2 === 'undefined') ? -1 :
	        (type1 === 'null') ? 1 :
	        (type2 === 'null') ? -1 :
	        (type1 < type2) ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * AngularJS has a chance to replace the `{{hash}}` markup with its
	 * value. Until AngularJS replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
	        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
	          element(by.model('leader')).click();
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = ['$sce', function($sce) {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        // We need to sanitize the url at least once, in case it is a constant
	        // non-interpolated attribute.
	        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set might have sanitized the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  }];
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $getControls: valueFn([]),
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop,
	  $$setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$getControls
	   * @returns {Array} the controls that are currently part of this form
	   *
	   * @description
	   * This method returns a **shallow copy** of the controls that are currently part of this form.
	   * The controls can be instances of {@link form.FormController `FormController`}
	   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
	   * If you need access to the controls of child-forms, you have to call `$getControls()`
	   * recursively on them.
	   * This can be used for example to iterate over all controls to validate them.
	   *
	   * The controls can be accessed normally, but adding to, or removing controls from the array has
	   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
	   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
	   * Likewise, adding a control to, or removing a control from the form is not reflected
	   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
	   * you need access to the controls.
	   */
	  $getControls: function() {
	    return shallowCopy(this.$$controls);
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
	   * parent forms of the form.
	   */
	  $setSubmitted: function() {
	    var rootForm = this;
	    while (rootForm.$$parentForm && (rootForm.$$parentForm !== nullFormCtrl)) {
	      rootForm = rootForm.$$parentForm;
	    }
	    rootForm.$$setSubmitted();
	  },
	
	  $$setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    forEach(this.$$controls, function(control) {
	      if (control.$$setSubmitted) {
	        control.$$setSubmitted();
	      }
	    });
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Helper directive that makes it possible to create control groups inside a
	 * {@link ng.directive:form `form`} directive.
	 * These "child forms" can be used, for example, to determine the validity of a sub-group of
	 * controls.
	 *
	 * <div class="alert alert-danger">
	 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
	 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
	 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
	 * you cannot send data to the server with `ngForm`, or integrate it with
	 * {@link ng.directive:ngSubmit `ngSubmit`}.
	 * </div>
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
	 *                              be published into the related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * ## Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * ## CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * ## Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side AngularJS applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * @animations
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise AngularJS will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * The format of the displayed time can be adjusted with the
	    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	    * and `timeStripZeroSeconds`.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
	   * this is the timezone of the browser.
	   *
	   * The format of the displayed time can be adjusted with the
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	   * and `timeStripZeroSeconds`.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
	    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
	    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise AngularJS will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   *
	   *
	   * @knownIssue
	   *
	   * ### HTML5 constraint validation and `allowInvalid`
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   * @knownIssue
	   *
	   * ### Large numbers and `step` validation
	   *
	   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
	   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
	   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
	   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
	   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
	   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
	   * point for both implementations.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium, which may not fulfill your app's requirements.
	   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
	   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
	   * modify the built-in validators (see the {@link guide/forms Forms guide}).
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * **Note:**<br>
	   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
	   * value of their `name` attribute to determine the property under which their
	   * {@link ngModel.NgModelController NgModelController} will be published on the parent
	   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
	   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
	   * published on the parent `FormController` under that name. The rest of the controllers will
	   * continue to work as expected, but you won't be able to access them as properties on the parent
	   * `FormController`.
	   *
	   * <div class="alert alert-info">
	   *   <p>
	   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
	   *     that the browser can manage their state (checked/unchecked) based on the state of other
	   *     inputs in the same group.
	   *   </p>
	   *   <p>
	   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
	   *     value of the underlying model data.
	   *   </p>
	   * </div>
	   *
	   * <div class="alert alert-success">
	   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
	   *   unique name.
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for AngularJS:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, AngularJS will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
	   *                      to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    // Support: IE9+
	    element.on('compositionupdate', function(ev) {
	      // End composition when ev.data is empty string on 'compositionupdate' event.
	      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
	      // instead of 'compositionend'.
	      if (isUndefined(ev.data) || ev.data === '') {
	        composing = false;
	      }
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut drop', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, previousDate) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (previousDate) {
	          map = {
	            yyyy: previousDate.getFullYear(),
	            MM: previousDate.getMonth() + 1,
	            dd: previousDate.getDate(),
	            HH: previousDate.getHours(),
	            mm: previousDate.getMinutes(),
	            ss: previousDate.getSeconds(),
	            sss: previousDate.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	
	        var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	        if (map.yyyy < 100) {
	          // In the constructor, 2-digit years map to 1900-1999.
	          // Use `setFullYear()` to set the correct year.
	          date.setFullYear(map.yyyy);
	        }
	
	        return date;
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	    badInputChecker(scope, element, attr, ctrl, type);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	    var isTimeType = type === 'time' || type === 'datetimelocal';
	    var previousDate;
	    var previousTimezone;
	
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        return parseDateAndConvertTimeZoneToLocal(value, previousDate);
	      }
	      ctrl.$$parserName = type;
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        var timezone = ctrl.$options.getOption('timezone');
	
	        if (timezone) {
	          previousTimezone = timezone;
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	
	        return formatter(value, timezone);
	      } else {
	        previousDate = null;
	        previousTimezone = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal = attr.min || $parse(attr.ngMin)(scope);
	      var parsedMinVal = parseObservedDateValue(minVal);
	
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
	      };
	      attr.$observe('min', function(val) {
	        if (val !== minVal) {
	          parsedMinVal = parseObservedDateValue(val);
	          minVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal = attr.max || $parse(attr.ngMax)(scope);
	      var parsedMaxVal = parseObservedDateValue(maxVal);
	
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
	      };
	      attr.$observe('max', function(val) {
	        if (val !== maxVal) {
	          parsedMaxVal = parseObservedDateValue(val);
	          maxVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
	    }
	
	    function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
	      var timezone = ctrl.$options.getOption('timezone');
	
	      if (previousTimezone && previousTimezone !== timezone) {
	        // If the timezone has changed, adjust the previousDate to the default timezone
	        // so that the new date is converted with the correct timezone offset
	        previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
	      }
	
	      var parsedDate = parseDate(value, previousDate);
	
	      if (!isNaN(parsedDate) && timezone) {
	        parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	      }
	      return parsedDate;
	    }
	
	    function formatter(value, timezone) {
	      var targetFormat = format;
	
	      if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
	        targetFormat = format
	          .replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat'))
	          .replace(/:$/, '');
	      }
	
	      var formatted =  $filter('date')(value, targetFormat, timezone);
	
	      if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
	        formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
	      }
	
	      return formatted;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl, parserName) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      if (validity.badInput || validity.typeMismatch) {
	        ctrl.$$parserName = parserName;
	        return undefined;
	      }
	
	      return value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	
	    ctrl.$$parserName = 'number';
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  badInputChecker(scope, element, attr, ctrl, 'number');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var parsedMinVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal = attr.min || $parse(attr.ngMin)(scope);
	    parsedMinVal = parseNumberAttrVal(minVal);
	
	    ctrl.$validators.min = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (val !== minVal) {
	        parsedMinVal = parseNumberAttrVal(val);
	        minVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal = attr.max || $parse(attr.ngMax)(scope);
	    var parsedMaxVal = parseNumberAttrVal(maxVal);
	
	    ctrl.$validators.max = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (val !== maxVal) {
	        parsedMaxVal = parseNumberAttrVal(val);
	        maxVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal = attr.step || $parse(attr.ngStep)(scope);
	    var parsedStepVal = parseNumberAttrVal(stepVal);
	
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) ||
	        isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      if (val !== stepVal) {
	        parsedStepVal = parseNumberAttrVal(val);
	        stepVal = val;
	        ctrl.$validate();
	      }
	
	    });
	
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl, 'range');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    minVal = parseNumberAttrVal(attr.min);
	
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    maxVal = parseNumberAttrVal(attr.max);
	
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    stepVal = parseNumberAttrVal(attr.step);
	
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    var oldVal = attr[htmlAttrName];
	    attr.$observe(htmlAttrName, function wrappedObserver(val) {
	      if (val !== oldVal) {
	        oldVal = val;
	        changeFn(val);
	      }
	    });
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (!supportsRange) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    } else if (ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	var hiddenInputBrowserCacheDirective = function() {
	  var valueProperty = {
	    configurable: true,
	    enumerable: false,
	    get: function() {
	      return this.getAttribute('value') || '';
	    },
	    set: function(val) {
	      this.setAttribute('value', val);
	    }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 200,
	    compile: function(_, attr) {
	      if (lowercase(attr.type) !== 'hidden') {
	        return;
	      }
	
	      return {
	        pre: function(scope, element, attr, ctrls) {
	          var node = element[0];
	
	          // Support: Edge
	          // Moving the DOM around prevents autofillling
	          if (node.parentNode) {
	            node.parentNode.insertBefore(node, node.nextSibling);
	          }
	
	          // Support: FF, IE
	          // Avoiding direct assignment to .value prevents autofillling
	          if (Object.defineProperty) {
	            Object.defineProperty(node, 'value', valueProperty);
	          }
	        }
	      };
	    }
	  };
	};
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element ANY
	 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 * @restrict A
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element ANY
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClassWatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClassWatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    if (!classValue) return classValue;
	
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    } else if (!isString(classValue)) {
	      classString = classValue + '';
	    }
	
	    return classString;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 * @element ANY
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
	 *
	 * ### ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 *
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example
	 * ### Basic
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   @example
	   ### Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassOdd`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-odd="'odd'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .odd {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .odd-add, .odd-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add odd class to odd entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassEven`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-even="'even'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .even {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .even-add, .even-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add even class to even entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the AngularJS community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * AngularJS has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect AngularJS:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related AngularJS features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 *
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	
	  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	  <example name="example.csp" module="cspExample" ng-csp="true">
	    <file name="index.html">
	      <div ng-controller="MainController as ctrl">
	        <div>
	          <button ng-click="ctrl.inc()" id="inc">Increment</button>
	          <span id="counter">
	            {{ctrl.counter}}
	          </span>
	        </div>
	
	        <div>
	          <button ng-click="ctrl.evil()" id="evil">Evil</button>
	          <span id="evilError">
	            {{ctrl.evilError}}
	          </span>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	       angular.module('cspExample', [])
	         .controller('MainController', function MainController() {
	            this.counter = 0;
	            this.inc = function() {
	              this.counter++;
	            };
	            this.evil = function() {
	              try {
	                eval('1+2'); // eslint-disable-line no-eval
	              } catch (e) {
	                this.evilError = e.message;
	              }
	            };
	          });
	    </file>
	    <file name="protractor.js" type="protractor">
	      var util, webdriver;
	
	      var incBtn = element(by.id('inc'));
	      var counter = element(by.id('counter'));
	      var evilBtn = element(by.id('evil'));
	      var evilError = element(by.id('evilError'));
	
	      function getAndClearSevereErrors() {
	        return browser.manage().logs().get('browser').then(function(browserLog) {
	          return browserLog.filter(function(logEntry) {
	            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	          });
	        });
	      }
	
	      function clearErrors() {
	        getAndClearSevereErrors();
	      }
	
	      function expectNoErrors() {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          expect(filteredLog.length).toEqual(0);
	          if (filteredLog.length) {
	            console.log('browser console errors: ' + util.inspect(filteredLog));
	          }
	        });
	      }
	
	      function expectError(regex) {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          var found = false;
	          filteredLog.forEach(function(log) {
	            if (log.message.match(regex)) {
	              found = true;
	            }
	          });
	          if (!found) {
	            throw new Error('expected an error that matches ' + regex);
	          }
	        });
	      }
	
	      beforeEach(function() {
	        util = require('util');
	        webdriver = require('selenium-webdriver');
	      });
	
	      // For now, we only test on Chrome,
	      // as Safari does not load the page with Protractor's injected scripts,
	      // and Firefox webdriver always disables content security policy (#6358)
	      if (browser.params.browser !== 'chrome') {
	        return;
	      }
	
	      it('should not report errors when the page is loaded', function() {
	        // clear errors so we are not dependent on previous tests
	        clearErrors();
	        // Need to reload the page as the page is already loaded when
	        // we come here
	        browser.driver.getCurrentUrl().then(function(url) {
	          browser.get(url);
	        });
	        expectNoErrors();
	      });
	
	      it('should evaluate expressions', function() {
	        expect(counter.getText()).toEqual('0');
	        incBtn.click();
	        expect(counter.getText()).toEqual('1');
	        expectNoErrors();
	      });
	
	      it('should throw and report an error when using "eval"', function() {
	        evilBtn.click();
	        expect(evilError.getText()).toMatch(/Content Security Policy/);
	        expectError(/Content Security Policy/);
	      });
	    </file>
	  </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * AngularJS expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function($parse, $rootScope, $exceptionHandler) {
	      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
	    }];
	  }
	);
	
	function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
	  return {
	    restrict: 'A',
	    compile: function($element, attr) {
	      // NOTE:
	      // We expose the powerful `$event` object on the scope that provides access to the Window,
	      // etc. This is OK, because expressions are not sandboxed any more (and the expression
	      // sandbox was never meant to be a security feature anyway).
	      var fn = $parse(attr[directiveName]);
	      return function ngEventHandler(scope, element) {
	        element.on(eventName, function(event) {
	          var callback = function() {
	            fn(scope, {$event: event});
	          };
	
	          if (!$rootScope.$$phase) {
	            scope.$apply(callback);
	          } else if (forceAsync) {
	            scope.$evalAsync(callback);
	          } else {
	            try {
	              callback();
	            } catch (error) {
	              $exceptionHandler(error);
	            }
	          }
	        });
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 * @restrict A
	 * @element ANY
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 * @restrict A
	 * @element form
	 * @priority 0
	 *
	 * @description
	 * Enables binding AngularJS expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 * @scope
	 * @priority -400
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either add them to your {@link ng.$sceDelegateProvider#trustedResourceUrlList trusted
	 * resource URL list} or {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to
	 * AngularJS's {@link ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 * @priority 450
	 * @element ANY
	 *
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`:
	 * <ul>
	 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
	 *     as seen in the demo below.</li>
	 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
	 *   <li>injecting data via server side scripting.</li>
	 * </ul>
	 *
	 * Besides these few cases, you should use {@link guide/component Components} or
	 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 * @restrict A
	 * @priority 100
	 *
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * @example
	 * ### Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Splitting on newline
	 *
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
	 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
	 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
	 *     It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * AngularJS provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	  this.$$updateEvents = '';
	  // Attach the correct context to the event handler function for updateOn
	  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	  this.$$parserName = 'parse';
	
	  this.$$currentValidationRunId = 0;
	
	  this.$$scope = $scope;
	  this.$$rootScope = $scope.$root;
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * @example
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName;
	
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    // Reset any previous parse error
	    this.$setValidity(this.$$parserName, null);
	    this.$$parserName = 'parse';
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default']) &&
	      this.$options.getOption('updateOn').indexOf(trigger) === -1
	    ) {
	      debounceDelay = debounceDelay['default'];
	    } else if (isNumber(debounceDelay['*'])) {
	      debounceDelay = debounceDelay['*'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$rootScope.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** this function only affects the options set on the `ngModelController`,
	   * and not the options on the {@link ngModelOptions} directive from which they might have been
	   * obtained initially.
	   * </div>
	   *
	   * <div class="alert alert-danger">
	   * **Note:** it is not possible to override the `getterSetter` option.
	   * </div>
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	    this.$$setUpdateOnEvents();
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name  ngModel.NgModelController#$processModelValue
	
	   * @description
	   *
	   * Runs the model -> view pipeline on the current
	   * {@link ngModel.NgModelController#$modelValue $modelValue}.
	   *
	   * The following actions are performed by this method:
	   *
	   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
	   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
	   * - the `ng-empty` or `ng-not-empty` class is set on the element
	   * - if the `$viewValue` has changed:
	   *   - {@link ngModel.NgModelController#$render $render} is called on the control
	   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
	   *   the validation status is set.
	   *
	   * This method is called by ngModel internally when the bound scope value changes.
	   * Application developers usually do not have to call this function themselves.
	   *
	   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
	   * formatted and the `$modelValue` must be run through the `$formatters` again.
	   *
	   * @example
	   * Consider a text input with an autocomplete list (for fruit), where the items are
	   * objects with a name and an id.
	   * A user enters `ap` and then selects `Apricot` from the list.
	   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
	   * but the rendered value will still be `ap`.
	   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
	   * pipeline again, which formats the object to the string `Apricot`,
	   * then updates the `$viewValue`, and finally renders it in the DOM.
	   *
	   * <example module="inputExample" name="ng-model-process">
	     <file name="index.html">
	      <div ng-controller="inputController" style="display: flex;">
	        <div style="margin-right: 30px;">
	          Search Fruit:
	          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
	        </div>
	        <div>
	          Model:<br>
	          <pre>{{selectedFruit | json}}</pre>
	        </div>
	      </div>
	     </file>
	     <file name="app.js">
	      angular.module('inputExample', [])
	        .controller('inputController', function($scope) {
	          $scope.items = [
	            {name: 'Apricot', id: 443},
	            {name: 'Clementine', id: 972},
	            {name: 'Durian', id: 169},
	            {name: 'Jackfruit', id: 982},
	            {name: 'Strawberry', id: 863}
	          ];
	        })
	        .component('basicAutocomplete', {
	          bindings: {
	            items: '<',
	            onSelect: '&'
	          },
	          templateUrl: 'autocomplete.html',
	          controller: function($element, $scope) {
	            var that = this;
	            var ngModel;
	
	            that.$postLink = function() {
	              ngModel = $element.find('input').controller('ngModel');
	
	              ngModel.$formatters.push(function(value) {
	                return (value && value.name) || value;
	              });
	
	              ngModel.$parsers.push(function(value) {
	                var match = value;
	                for (var i = 0; i < that.items.length; i++) {
	                  if (that.items[i].name === value) {
	                    match = that.items[i];
	                    break;
	                  }
	                }
	
	                return match;
	              });
	            };
	
	            that.selectItem = function(item) {
	              ngModel.$setViewValue(item);
	              ngModel.$processModelValue();
	              that.onSelect({item: item});
	            };
	          }
	        });
	     </file>
	     <file name="autocomplete.html">
	       <div>
	         <input type="search" ng-model="$ctrl.searchTerm" />
	         <ul>
	           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
	             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
	           </li>
	         </ul>
	       </div>
	     </file>
	   * </example>
	   *
	   */
	  $processModelValue: function() {
	    var viewValue = this.$$format();
	
	    if (this.$viewValue !== viewValue) {
	      this.$$updateEmptyClasses(viewValue);
	      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
	      this.$render();
	      // It is possible that model and view value have been updated during render
	      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
	    }
	  },
	
	  /**
	   * This method is called internally to run the $formatters on the $modelValue
	   */
	  $$format: function() {
	    var formatters = this.$formatters,
	        idx = formatters.length;
	
	    var viewValue = this.$modelValue;
	    while (idx--) {
	      viewValue = formatters[idx](viewValue);
	    }
	
	    return viewValue;
	  },
	
	  /**
	   * This method is called internally when the bound scope value changes.
	   */
	  $$setModelValue: function(modelValue) {
	    this.$modelValue = this.$$rawModelValue = modelValue;
	    this.$$parserValid = undefined;
	    this.$processModelValue();
	  },
	
	  $$setUpdateOnEvents: function() {
	    if (this.$$updateEvents) {
	      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
	    }
	
	    this.$$updateEvents = this.$options.getOption('updateOn');
	    if (this.$$updateEvents) {
	      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
	    }
	  },
	
	  $$updateEventHandler: function(ev) {
	    this.$$debounceViewValueCommit(ev && ev.type);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // This cannot be moved to the action function, because it would not catch the
	    // case where the model is changed in the ngChange function or the model setter
	    if (modelValue !== ctrl.$modelValue &&
	      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	      // eslint-disable-next-line no-self-compare
	      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$$setModelValue(modelValue);
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 * @restrict A
	 * @priority 1
	 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * ## CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * @animations
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * ### Basic Usage
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * @example
	 * ### Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          modelCtrl.$$setUpdateOnEvents();
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /** @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 * @restrict A
	 * @priority 10
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ### Overriding immediate updates
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Debouncing updates
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ### Default events, extra triggers, and catch-all debounce values
	 *
	 * This example shows the relationship between "default" update events and
	 * additional `updateOn` triggers.
	 *
	 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
	 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
	 * in `updateOn` is considered a "default" event, since different control types have different
	 * default events.
	 *
	 * The control in this example updates by "default", "click", and "blur", with different `debounce`
	 * values. You can see that "click" doesn't have an individual `debounce` value -
	 * therefore it uses the `*` debounce value.
	 *
	 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
	 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
	 * it is considered a "default" event and will update the
	 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
	 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
	 *
	 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
	 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
	 *
	  <example name="ngModelOptions-advanced" module="optionsExample">
	    <file name="index.html">
	       <model-update-demo></model-update-demo>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .component('modelUpdateDemo', {
	          templateUrl: 'template.html',
	          controller: function() {
	            this.name = 'Chinua';
	
	            this.options = {
	              updateOn: 'default blur click',
	              debounce: {
	                default: 2000,
	                blur: 0,
	                '*': 1000
	              }
	            };
	
	            this.updateEvents = function() {
	              var eventList = this.options.updateOn.split(' ');
	              eventList.push('*');
	              var events = {};
	
	              for (var i = 0; i < eventList.length; i++) {
	                events[eventList[i]] = this.options.debounce[eventList[i]];
	              }
	
	              this.events = events;
	            };
	
	            this.updateOptions = function() {
	              var options = angular.extend(this.options, {
	                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
	                debounce: this.events
	              });
	
	              this.form.input.$overrideModelOptions(options);
	            };
	
	            // Initialize the event form
	            this.updateEvents();
	          }
	        });
	    </file>
	    <file name="template.html">
	      <form name="$ctrl.form">
	        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
	      </form>
	      Model: <tt>{{$ctrl.name}}</tt>
	      <hr>
	      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>
	
	      <hr>
	      <form ng-submit="$ctrl.updateOptions()">
	        <b>updateOn</b><br>
	        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">
	
	        <table>
	          <tr>
	            <th>Option</th>
	            <th>Debounce value</th>
	          </tr>
	          <tr ng-repeat="(key, value) in $ctrl.events">
	            <td>{{key}}</td>
	            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
	          </tr>
	        </table>
	
	        <br>
	        <input type="submit" value="Update options">
	      </form>
	    </file>
	  </example>
	 *
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Programmatically changing options
	 *
	 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
	 * watched for changes. However, it is possible to override the options on a single
	 * {@link ngModel.NgModelController} instance with
	 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
	 * See also the example for
	 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
	 * Default events, extra triggers, and catch-all debounce values}.
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 *
	 * ## Formatting the value of `time` and `datetime-local`
	 *
	 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
	 * that is displayed in the control. Note that browsers may apply their own formatting
	 * in the user interface.
	 *
	   <example name="ngModelOptions-time-format" module="timeExample">
	     <file name="index.html">
	       <time-example></time-example>
	     </file>
	     <file name="script.js">
	        angular.module('timeExample', [])
	          .component('timeExample', {
	            templateUrl: 'timeExample.html',
	            controller: function() {
	              this.time = new Date(1970, 0, 1, 14, 57, 0);
	
	              this.options = {
	                timeSecondsFormat: 'ss',
	                timeStripZeroSeconds: true
	              };
	
	              this.optionChange = function() {
	                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
	                this.time = new Date(this.time);
	              };
	            }
	          });
	     </file>
	     <file name="timeExample.html">
	       <form name="$ctrl.timeForm">
	         <strong>Default</strong>:
	         <input type="time" ng-model="$ctrl.time" step="any" /><br>
	         <strong>With options</strong>:
	         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
	         <br>
	
	         Options:<br>
	         <code>timeSecondsFormat</code>:
	         <input
	           type="text"
	           ng-model="$ctrl.options.timeSecondsFormat"
	           ng-change="$ctrl.optionChange()">
	         <br>
	         <code>timeStripZeroSeconds</code>:
	         <input
	           type="checkbox"
	           ng-model="$ctrl.options.timeStripZeroSeconds"
	           ng-change="$ctrl.optionChange()">
	        </form>
	      </file>
	 *  </example>
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents.
	 *
	 * **General options**:
	 *
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control. These are the events that are bound to
	 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
	 *
	 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
	 *     since different control types use different default events.
	 *
	 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
	 *     Triggering and debouncing model updates}.
	 *
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *     You can use the `*` key to specify a debounce value that applies to all events that are not
	 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur mouseup',
	 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *
	 *
	 *  **Input-type specific options**:
	 *
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *     Note that changing the timezone will have no effect on the current date, and is only applied after
	 *     the next input / model change.
	 *
	 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
	 *     milliseconds. The option follows the format string of {@link date date filter}.
	 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
	 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
	 *     seconds and milliseconds.
	 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
	 *     part of the time string, and may show the value differently in the user interface.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
	 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
	 *     after `timeSecondsFormat`.
	 *     This option can be used to make the formatting consistent over different browsers, as some
	 *     browsers with support for `time` will natively hide the milliseconds and
	 *     seconds if they are zero, but others won't, and browsers that don't implement these input
	 *     types will always show the full string.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 * @element ANY
	 *
	 * @description
	 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
	 * DOM element, including directives on the element itself that have a lower priority than
	 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
	 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
	 * that displays snippets of code, for instance.
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	  <example name="ng-non-bindable">
	    <file name="index.html">
	      <div>Normal: {{1 + 2}}</div>
	      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	    </file>
	    <file name="protractor.js" type="protractor">
	     it('should check ng-non-bindable', function() {
	       expect(element(by.binding('1 + 2')).getText()).toContain('3');
	       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	     });
	    </file>
	  </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      // The empty option will be compiled and rendered before we first generate the options
	      selectElement.empty();
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            selectCtrl.selectUnknownOrEmptyOption(value);
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        selectElement.prepend(selectCtrl.emptyOption);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                var needsRerender = selectCtrl.$isEmptyOptionSelected();
	
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	
	                if (needsRerender) ngModelCtrl.$render();
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // Support: IE 11 only, Edge 12-13 only
	        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * ## Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in AngularJS's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * ## Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * AngularJS expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * ## Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRef
	 * @restrict A
	 *
	 * @description
	 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
	 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
	 * element to the scope.
	 *
	 * If the element with `ngRef` is destroyed `null` is assigned to the property.
	 *
	 * Note that if you want to assign from a child into the parent scope, you must initialize the
	 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
	 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
	 * {@link ngRepeat}. See the second example below.
	 *
	 *
	 * @element ANY
	 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
	 *                       controller or jqlite-wrapped DOM element will be bound.
	 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
	 *                            or the special string `$element`. If a name is provided, `ngRef` will
	 *                            assign the matching controller. If `$element` is provided, the element
	 *                            itself is assigned (even if a controller is available).
	 *
	 *
	 * @example
	 * ### Simple toggle
	 * This example shows how the controller of the component toggle
	 * is reused in the template through the scope to use its logic.
	 * <example name="ng-ref-component" module="myApp">
	 *   <file name="index.html">
	 *     <my-toggle ng-ref="myToggle"></my-toggle>
	 *     <button ng-click="myToggle.toggle()">Toggle</button>
	 *     <div ng-show="myToggle.isOpen()">
	 *       You are using a component in the same template to show it.
	 *     </div>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myToggle', {
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should publish the toggle into the scope', function() {
	 *        var toggle = element(by.buttonText('Toggle'));
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
	 *        toggle.click();
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### ngRef inside scopes
	 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
	 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
	 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
	 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
	 * because the target property has not been initialized on the `myRoot` component controller.
	 *
	 * <example name="ng-ref-scopes" module="myApp">
	 *   <file name="index.html">
	 *     <my-root></my-root>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myRoot', {
	 *       templateUrl: 'root.html',
	 *       controller: function() {
	 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
	 *       }
	 *     })
	 *     .component('myToggle', {
	 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
	 *       transclude: true,
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     })
	 *     .component('myWrapper', {
	 *       transclude: true,
	 *       template: '<strong>myWrapper</strong>' +
	 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
	 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
	 *     });
	 *   </file>
	 *   <file name="root.html">
	 *     <strong>myRoot</strong>
	 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
	 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     <div><em>wrappers assigned to root</em><br>
	 *     <div ng-repeat="wrapper in $ctrl.wrappers">
	 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
	 *     </div>
	 *
	 *     <ul>
	 *       <li ng-repeat="(index, value) in [1,2,3]">
	 *         <strong>ngRepeat</strong>
	 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
	 *       </li>
	 *     </ul>
	 *
	 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
	 *       assigned to the child scope created by ngIf.
	 *     </div>
	 *     <div ng-if="true">
	          <strong>ngIf</strong>
	 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
	 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
	 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     </div>
	 *   </file>
	 *   <file name="styles.css">
	 *     ul {
	 *       list-style: none;
	 *       padding-left: 0;
	 *     }
	 *
	 *     li[ng-repeat] {
	 *       background: lightgreen;
	 *       padding: 8px;
	 *       margin: 8px;
	 *     }
	 *
	 *     [ng-if] {
	 *       background: lightgrey;
	 *       padding: 8px;
	 *     }
	 *
	 *     my-root {
	 *       background: lightgoldenrodyellow;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-wrapper {
	 *       background: lightsalmon;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-toggle {
	 *       background: lightblue;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      var OuterToggle = function() {
	 *        this.toggle = function() {
	 *          element(by.buttonText('Outer Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
	 *        };
	 *      };
	 *      var NgRepeatToggle = function(i) {
	 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *      var NgRepeatToggles = function() {
	 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
	 *        this.forEach = function(fn) {
	 *          toggles.forEach(fn);
	 *        };
	 *        this.isOuterOpen = function(i) {
	 *          return toggles[i - 1].isOuterOpen();
	 *        };
	 *      };
	 *      var NgIfToggle = function() {
	 *        var parent = element(by.css('[ng-if]'));
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngIf Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return by.binding('ngIfToggle.isOpen() | json').getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *
	 *      it('should toggle the outer toggle', function() {
	 *        var outerToggle = new OuterToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle all outer toggles', function() {
	 *        var outerToggle = new OuterToggle();
	 *        var repeatToggles = new NgRepeatToggles();
	 *        var ifToggle = new NgIfToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle each repeat iteration separately', function() {
	 *        var repeatToggles = new NgRepeatToggles();
	 *
	 *        repeatToggles.forEach(function(repeatToggle) {
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *          repeatToggle.toggle();
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        });
	 *      });
	 *   </file>
	 * </example>
	 *
	 */
	
	var ngRefMinErr = minErr('ngRef');
	
	var ngRefDirective = ['$parse', function($parse) {
	  return {
	    priority: -1, // Needed for compatibility with element transclusion on the same element
	    restrict: 'A',
	    compile: function(tElement, tAttrs) {
	      // Get the expected controller name, converts <data-some-thing> into "someThing"
	      var controllerName = directiveNormalize(nodeName_(tElement));
	
	      // Get the expression for value binding
	      var getter = $parse(tAttrs.ngRef);
	      var setter = getter.assign || function() {
	        throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
	      };
	
	      return function(scope, element, attrs) {
	        var refValue;
	
	        if (attrs.hasOwnProperty('ngRefRead')) {
	          if (attrs.ngRefRead === '$element') {
	            refValue = element;
	          } else {
	            refValue = element.data('$' + attrs.ngRefRead + 'Controller');
	
	            if (!refValue) {
	              throw ngRefMinErr(
	                'noctrl',
	                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
	                attrs.ngRefRead,
	                tAttrs.ngRef
	              );
	            }
	          }
	        } else {
	          refValue = element.data('$' + controllerName + 'Controller');
	        }
	
	        refValue = refValue || element;
	
	        setter(scope, refValue);
	
	        // when the element is removed, remove it (nullify it)
	        element.on('$destroy', function() {
	          // only remove it if value has not changed,
	          // because animations (and other procedures) may duplicate elements
	          if (getter(scope) === refValue) {
	            setter(scope, null);
	          }
	        });
	      };
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * ## Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so AngularJS relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * ## Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * All different types of tracking functions, their syntax, and their support for duplicate
	 * items in collections can be found in the
	 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** If you are working with objects that have a unique identifier property, you
	 * should track by this identifier instead of the object instance,
	 * e.g. `item in items track by item.id`.
	 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
	 * it has already rendered, even if the JavaScript objects in the collection have been substituted
	 * for new ones. For large collections, this significantly improves rendering performance.
	 * </div>
	 *
	 * ### Effects of DOM Element re-use
	 *
	 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
	 * automatically update any active bindings on the template. However, other
	 * functionality will not be updated, because the element is not re-created:
	 *
	 * - Directives are not re-compiled
	 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
	 * updated if they have stabilized.
	 *
	 * The above affects all kinds of element re-use due to tracking, but may be especially visible
	 * when tracking by `$index` due to the way ngRepeat re-uses elements.
	 *
	 * The following example shows the effects of different actions with tracking:
	
	  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        var friends = [
	          {name:'John', age:25},
	          {name:'Mary', age:40},
	          {name:'Peter', age:85}
	        ];
	
	        $scope.removeFirst = function() {
	          $scope.friends.shift();
	        };
	
	        $scope.updateAge = function() {
	          $scope.friends.forEach(function(el) {
	            el.age = el.age + 5;
	          });
	        };
	
	        $scope.copy = function() {
	          $scope.friends = angular.copy($scope.friends);
	        };
	
	        $scope.reset = function() {
	          $scope.friends = angular.copy(friends);
	        };
	
	        $scope.reset();
	      });
	    </file>
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        <ol>
	          <li>When you click "Update Age", only the first list updates the age, because all others have
	          a one-time binding on the age property. If you then click "Copy", the current friend list
	          is copied, and now the second list updates the age, because the identity of the collection items
	          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
	          items are already known according to their tracking functions.
	          </li>
	          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
	          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
	          DOM element for the new first collection item, and so on. Since the age property is one-time
	          bound, the value remains from the collection item which was previously at this index.
	          </li>
	        </ol>
	
	        <button ng-click="removeFirst()">Remove First</button>
	        <button ng-click="updateAge()">Update Age</button>
	        <button ng-click="copy()">Copy</button>
	        <br><button ng-click="reset()">Reset List</button>
	        <br>
	        <code>track by $id(friend)</code> (default):
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $id(friend)</code> (default), with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by friend.name</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
	            {{friend.name}}  is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $index</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	  </example>
	
	 *
	 * ## Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
	 *     This implies that the DOM elements will be associated by item identity in the collection.
	 *
	 *     The built-in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the collection by identity. Moving the same object would move
	 *     the DOM element in the same way in the DOM.
	 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
	 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
	 *
	 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
	 *     id, for example with a function, or using a property on the collection items.
	 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
	 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
	 *     equivalent as long as their `id` property is same.
	 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
	 *
	 *     *$index*: This special property tracks the collection items by their index, and
	 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
	 *     be used for a performance improvement if no unique identfier is available and the identity of
	 *     the collection items cannot be easily computed. It also allows duplicates.
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
	 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
	 *       more info.
	 *     </div>
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
	 *       `item in items | filter:searchText as results  track by item.id`
	 *     </div>
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name]` is not an operator but rather a part of ngRepeat
	 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	  var trackByIdArrayFn = function($scope, key, value) {
	    return hashKey(value);
	  };
	
	  var trackByIdObjFn = function($scope, key) {
	    return key;
	  };
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByIdExpFn;
	
	      if (trackByExp) {
	        var hashFnLocals = {$id: hashKey};
	        var trackByExpGetter = $parse(trackByExp);
	
	        trackByIdExpFn = function($scope, key, value, index) {
	          // assign key, value, and $index to the locals so that they can be used in hash functions
	          if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	          hashFnLocals[valueIdentifier] = value;
	          hashFnLocals.$index = index;
	          return trackByExpGetter($scope, hashFnLocals);
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - clone: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn($scope, key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // Clear the value property from the hashFnLocals object to prevent a reference to the last value
	          // being leaked into the ngRepeatCompile function scope
	          if (hashFnLocals) {
	            hashFnLocals[valueIdentifier] = undefined;
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngShow to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngHide to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(255, 0, 0, 1\)|rgb\(255, 0, 0\)/);
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, ''); });
	    }
	    if (newStyles) element.css(newStyles);
	  });
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value);
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
	 *       Error: The current model doesn't match any option</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 *  it('should show the error message when the unknown option is selected', function() {
	
	      var error = element(by.className('error'));
	
	      expect(error.getText()).toBe('Error: Please select a value');
	
	      element(by.cssContainingText('option', 'Option 1')).click();
	
	      expect(error.isPresent()).toBe(false);
	
	      element(by.tagName('button')).click();
	
	      expect(error.getText()).toBe('Error: Please select a value');
	    });
	 * </file>
	 *</example>
	 *
	 *
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that the application developer can
	  // provide inside the select. It is always selectable and indicates that a "null" selection has
	  // been made by the user.
	  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
	  // the empty option is selected.
	  // If the model is set to a different unmatched value, the unknown option is rendered and
	  // selected, i.e both are present, because a "null" selection and an unknown value are different.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      setOptionSelectedStatus(self.emptyOption, false);
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      self.selectUnknownOrEmptyOption(value);
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */
	  self.$hasEmptyOption = function() {
	    return self.hasEmptyOption;
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */
	  self.$isUnknownOptionSelected = function() {
	    // Presence of the unknown option means it is selected
	    return $element[0].options[0] === self.unknownOption[0];
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */
	  self.$isEmptyOptionSelected = function() {
	    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
	  };
	
	  self.selectUnknownOrEmptyOption = function(value) {
	    if (value == null && self.emptyOption) {
	      self.removeUnknownOption();
	      self.selectEmptyOption();
	    } else if (self.unknownOption.parent().length) {
	      self.updateUnknownOption(value);
	    } else {
	      self.renderUnknownOption(value);
	    }
	  };
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with AngularJS data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // Support: IE 9-11 only, Edge 12-15+
	            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if necessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
	 *                                `required` attribute to the element and adds the `required`
	 *                                {@link ngModel.NgModelController#$validators `validator`}.
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the AngularJS expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      // For boolean attributes like required, presence means true
	      var value = attr.hasOwnProperty('required') || $parse(attr.ngRequired)(scope);
	
	      if (!attr.ngRequired) {
	        // force truthy in case we are on non input element
	        // (input elements do this automatically for boolean attributes like required)
	        attr.required = true;
	      }
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !value || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function(newVal) {
	
	        if (value !== newVal) {
	          value = newVal;
	          ctrl.$validate();
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 * @restrict A
	 *
	 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
	 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
	 *                                      more details.
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
	 * - the value is an AngularJS expression:
	 *   - If the expression evaluates to a RegExp object, then this is used directly.
	 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    compile: function(tElm, tAttr) {
	      var patternExp;
	      var parseFn;
	
	      if (tAttr.ngPattern) {
	        patternExp = tAttr.ngPattern;
	
	        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
	        // We get value of the attribute here, so we can compare the old and the new value
	        // in the observer to avoid unnecessary validations
	        if (tAttr.ngPattern.charAt(0) === '/' && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) {
	          parseFn = function() { return tAttr.ngPattern; };
	        } else {
	          parseFn = $parse(tAttr.ngPattern);
	        }
	      }
	
	      return function(scope, elm, attr, ctrl) {
	        if (!ctrl) return;
	
	        var attrVal = attr.pattern;
	
	        if (attr.ngPattern) {
	          attrVal = parseFn(scope);
	        } else {
	          patternExp = attr.pattern;
	        }
	
	        var regexp = parsePatternAttr(attrVal, patternExp, elm);
	
	        attr.$observe('pattern', function(newVal) {
	          var oldRegexp = regexp;
	
	          regexp = parsePatternAttr(newVal, patternExp, elm);
	
	          if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) {
	            ctrl.$validate();
	          }
	        });
	
	        ctrl.$validators.pattern = function(modelValue, viewValue) {
	          // HTML5 pattern constraint validates the input value, so we validate the viewValue
	          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	        };
	      };
	    }
	
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 * @restrict A
	 *
	 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `maxlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
	      var maxlengthParsed = parseLength(maxlength);
	
	      attr.$observe('maxlength', function(value) {
	        if (maxlength !== value) {
	          maxlengthParsed = parseLength(value);
	          maxlength = value;
	          ctrl.$validate();
	        }
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlengthParsed < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlengthParsed);
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 * @restrict A
	 *
	 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `minlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
	      var minlengthParsed = parseLength(minlength) || -1;
	
	      attr.$observe('minlength', function(value) {
	        if (minlength !== value) {
	          minlengthParsed = parseLength(value) || -1;
	          minlength = value;
	          ctrl.$validate();
	        }
	
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
	      };
	    }
	  };
	}];
	
	
	function parsePatternAttr(regex, patternExp, elm) {
	  if (!regex) return undefined;
	
	  if (isString(regex)) {
	    regex = new RegExp('^' + regex + '$');
	  }
	
	  if (!regex.test) {
	    throw minErr('ngPattern')('noregexp',
	      'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	      regex, startingTag(elm));
	  }
	
	  return regex;
	}
	
	function parseLength(val) {
	  var intVal = toInt(val);
	  return isNumberNaN(intVal) ? -1 : intVal;
	}
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load AngularJS more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element('<style>').text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
3,
/* 8 */,
/* 9 */
3,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _axios = __webpack_require__(19);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _aws = __webpack_require__(23);
	
	var _aws2 = _interopRequireDefault(_aws);
	
	var _manifest = __webpack_require__(47);
	
	var _manifest2 = _interopRequireDefault(_manifest);
	
	var _map = __webpack_require__(48);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _shadow = __webpack_require__(56);
	
	var _shadow2 = _interopRequireDefault(_shadow);
	
	var _events = __webpack_require__(57);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _moment = __webpack_require__(58);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('app.services', []).service('AxiosService', _axios2.default).service('AwsService', _aws2.default).service('ManifestService', _manifest2.default).service('MapService', _map2.default).service('ShadowService', _shadow2.default).service('EventsService', _events2.default).service('MomentService', _moment2.default);
	
	exports.default = _module.name;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _axios = __webpack_require__(21);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AxiosService =
	/* @ngInject */
	function AxiosService() {
	    (0, _classCallCheck3.default)(this, AxiosService);
	
	    this.baseURL = 'https://2vwwhov5gc.execute-api.eu-west-1.amazonaws.com';
	    this.hostname = 'scanbox.cc.telenorconnexion.com';
	    this.account = '080159586263';
	    this.env = 'prod';
	    this.apikey = '14mDeoVpjx6DZqaPpGx3q2LbX0gmJUhs5htQRv2A';
	
	    this.http = _axios2.default.create({
	        baseURL: this.baseURL + '/' + this.env,
	        params: {
	            hostname: this.hostname,
	            account: this.account,
	            env: this.env
	        },
	        headers: {
	            'x-api-key': this.apikey
	
	        }
	    });
	};
	
	exports.default = AxiosService;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/* axios v0.21.4 | (c) 2021 by Matt Zabriskie */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["axios"] = factory();
		else
			root["axios"] = factory();
	})(window, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = "./index.js");
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ "./index.js":
	/*!******************!*\
	  !*** ./index.js ***!
	  \******************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(/*! ./lib/axios */ "./lib/axios.js");
	
	/***/ }),
	
	/***/ "./lib/adapters/xhr.js":
	/*!*****************************!*\
	  !*** ./lib/adapters/xhr.js ***!
	  \*****************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ./../utils */ "./lib/utils.js");
	var settle = __webpack_require__(/*! ./../core/settle */ "./lib/core/settle.js");
	var cookies = __webpack_require__(/*! ./../helpers/cookies */ "./lib/helpers/cookies.js");
	var buildURL = __webpack_require__(/*! ./../helpers/buildURL */ "./lib/helpers/buildURL.js");
	var buildFullPath = __webpack_require__(/*! ../core/buildFullPath */ "./lib/core/buildFullPath.js");
	var parseHeaders = __webpack_require__(/*! ./../helpers/parseHeaders */ "./lib/helpers/parseHeaders.js");
	var isURLSameOrigin = __webpack_require__(/*! ./../helpers/isURLSameOrigin */ "./lib/helpers/isURLSameOrigin.js");
	var createError = __webpack_require__(/*! ../core/createError */ "./lib/core/createError.js");
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    }
	
	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }
	
	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(
	        timeoutErrorMessage,
	        config,
	        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};
	
	
	/***/ }),
	
	/***/ "./lib/axios.js":
	/*!**********************!*\
	  !*** ./lib/axios.js ***!
	  \**********************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ./utils */ "./lib/utils.js");
	var bind = __webpack_require__(/*! ./helpers/bind */ "./lib/helpers/bind.js");
	var Axios = __webpack_require__(/*! ./core/Axios */ "./lib/core/Axios.js");
	var mergeConfig = __webpack_require__(/*! ./core/mergeConfig */ "./lib/core/mergeConfig.js");
	var defaults = __webpack_require__(/*! ./defaults */ "./lib/defaults.js");
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(/*! ./cancel/Cancel */ "./lib/cancel/Cancel.js");
	axios.CancelToken = __webpack_require__(/*! ./cancel/CancelToken */ "./lib/cancel/CancelToken.js");
	axios.isCancel = __webpack_require__(/*! ./cancel/isCancel */ "./lib/cancel/isCancel.js");
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(/*! ./helpers/spread */ "./lib/helpers/spread.js");
	
	// Expose isAxiosError
	axios.isAxiosError = __webpack_require__(/*! ./helpers/isAxiosError */ "./lib/helpers/isAxiosError.js");
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;
	
	
	/***/ }),
	
	/***/ "./lib/cancel/Cancel.js":
	/*!******************************!*\
	  !*** ./lib/cancel/Cancel.js ***!
	  \******************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;
	
	
	/***/ }),
	
	/***/ "./lib/cancel/CancelToken.js":
	/*!***********************************!*\
	  !*** ./lib/cancel/CancelToken.js ***!
	  \***********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var Cancel = __webpack_require__(/*! ./Cancel */ "./lib/cancel/Cancel.js");
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;
	
	
	/***/ }),
	
	/***/ "./lib/cancel/isCancel.js":
	/*!********************************!*\
	  !*** ./lib/cancel/isCancel.js ***!
	  \********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};
	
	
	/***/ }),
	
	/***/ "./lib/core/Axios.js":
	/*!***************************!*\
	  !*** ./lib/core/Axios.js ***!
	  \***************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ./../utils */ "./lib/utils.js");
	var buildURL = __webpack_require__(/*! ../helpers/buildURL */ "./lib/helpers/buildURL.js");
	var InterceptorManager = __webpack_require__(/*! ./InterceptorManager */ "./lib/core/InterceptorManager.js");
	var dispatchRequest = __webpack_require__(/*! ./dispatchRequest */ "./lib/core/dispatchRequest.js");
	var mergeConfig = __webpack_require__(/*! ./mergeConfig */ "./lib/core/mergeConfig.js");
	var validator = __webpack_require__(/*! ../helpers/validator */ "./lib/helpers/validator.js");
	
	var validators = validator.validators;
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  var transitional = config.transitional;
	
	  if (transitional !== undefined) {
	    validator.assertOptions(transitional, {
	      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
	      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
	      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
	    }, false);
	  }
	
	  // filter out skipped interceptors
	  var requestInterceptorChain = [];
	  var synchronousRequestInterceptors = true;
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
	      return;
	    }
	
	    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
	
	    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var responseInterceptorChain = [];
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  var promise;
	
	  if (!synchronousRequestInterceptors) {
	    var chain = [dispatchRequest, undefined];
	
	    Array.prototype.unshift.apply(chain, requestInterceptorChain);
	    chain = chain.concat(responseInterceptorChain);
	
	    promise = Promise.resolve(config);
	    while (chain.length) {
	      promise = promise.then(chain.shift(), chain.shift());
	    }
	
	    return promise;
	  }
	
	
	  var newConfig = config;
	  while (requestInterceptorChain.length) {
	    var onFulfilled = requestInterceptorChain.shift();
	    var onRejected = requestInterceptorChain.shift();
	    try {
	      newConfig = onFulfilled(newConfig);
	    } catch (error) {
	      onRejected(error);
	      break;
	    }
	  }
	
	  try {
	    promise = dispatchRequest(newConfig);
	  } catch (error) {
	    return Promise.reject(error);
	  }
	
	  while (responseInterceptorChain.length) {
	    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;
	
	
	/***/ }),
	
	/***/ "./lib/core/InterceptorManager.js":
	/*!****************************************!*\
	  !*** ./lib/core/InterceptorManager.js ***!
	  \****************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ./../utils */ "./lib/utils.js");
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected,
	    synchronous: options ? options.synchronous : false,
	    runWhen: options ? options.runWhen : null
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;
	
	
	/***/ }),
	
	/***/ "./lib/core/buildFullPath.js":
	/*!***********************************!*\
	  !*** ./lib/core/buildFullPath.js ***!
	  \***********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var isAbsoluteURL = __webpack_require__(/*! ../helpers/isAbsoluteURL */ "./lib/helpers/isAbsoluteURL.js");
	var combineURLs = __webpack_require__(/*! ../helpers/combineURLs */ "./lib/helpers/combineURLs.js");
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};
	
	
	/***/ }),
	
	/***/ "./lib/core/createError.js":
	/*!*********************************!*\
	  !*** ./lib/core/createError.js ***!
	  \*********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var enhanceError = __webpack_require__(/*! ./enhanceError */ "./lib/core/enhanceError.js");
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};
	
	
	/***/ }),
	
	/***/ "./lib/core/dispatchRequest.js":
	/*!*************************************!*\
	  !*** ./lib/core/dispatchRequest.js ***!
	  \*************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ./../utils */ "./lib/utils.js");
	var transformData = __webpack_require__(/*! ./transformData */ "./lib/core/transformData.js");
	var isCancel = __webpack_require__(/*! ../cancel/isCancel */ "./lib/cancel/isCancel.js");
	var defaults = __webpack_require__(/*! ../defaults */ "./lib/defaults.js");
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData.call(
	    config,
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData.call(
	      config,
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData.call(
	          config,
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};
	
	
	/***/ }),
	
	/***/ "./lib/core/enhanceError.js":
	/*!**********************************!*\
	  !*** ./lib/core/enhanceError.js ***!
	  \**********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};
	
	
	/***/ }),
	
	/***/ "./lib/core/mergeConfig.js":
	/*!*********************************!*\
	  !*** ./lib/core/mergeConfig.js ***!
	  \*********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ../utils */ "./lib/utils.js");
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  var valueFromConfig2Keys = ['url', 'method', 'data'];
	  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
	  var defaultToConfig2Keys = [
	    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
	    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
	    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
	  ];
	  var directMergeKeys = ['validateStatus'];
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    }
	  });
	
	  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
	
	  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  utils.forEach(directMergeKeys, function merge(prop) {
	    if (prop in config2) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  var axiosKeys = valueFromConfig2Keys
	    .concat(mergeDeepPropertiesKeys)
	    .concat(defaultToConfig2Keys)
	    .concat(directMergeKeys);
	
	  var otherKeys = Object
	    .keys(config1)
	    .concat(Object.keys(config2))
	    .filter(function filterAxiosKeys(key) {
	      return axiosKeys.indexOf(key) === -1;
	    });
	
	  utils.forEach(otherKeys, mergeDeepProperties);
	
	  return config;
	};
	
	
	/***/ }),
	
	/***/ "./lib/core/settle.js":
	/*!****************************!*\
	  !*** ./lib/core/settle.js ***!
	  \****************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var createError = __webpack_require__(/*! ./createError */ "./lib/core/createError.js");
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};
	
	
	/***/ }),
	
	/***/ "./lib/core/transformData.js":
	/*!***********************************!*\
	  !*** ./lib/core/transformData.js ***!
	  \***********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ./../utils */ "./lib/utils.js");
	var defaults = __webpack_require__(/*! ./../defaults */ "./lib/defaults.js");
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  var context = this || defaults;
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn.call(context, data, headers);
	  });
	
	  return data;
	};
	
	
	/***/ }),
	
	/***/ "./lib/defaults.js":
	/*!*************************!*\
	  !*** ./lib/defaults.js ***!
	  \*************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ./utils */ "./lib/utils.js");
	var normalizeHeaderName = __webpack_require__(/*! ./helpers/normalizeHeaderName */ "./lib/helpers/normalizeHeaderName.js");
	var enhanceError = __webpack_require__(/*! ./core/enhanceError */ "./lib/core/enhanceError.js");
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(/*! ./adapters/xhr */ "./lib/adapters/xhr.js");
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(/*! ./adapters/http */ "./lib/adapters/xhr.js");
	  }
	  return adapter;
	}
	
	function stringifySafely(rawValue, parser, encoder) {
	  if (utils.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }
	
	  return (encoder || JSON.stringify)(rawValue);
	}
	
	var defaults = {
	
	  transitional: {
	    silentJSONParsing: true,
	    forcedJSONParsing: true,
	    clarifyTimeoutError: false
	  },
	
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
	
	    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw enhanceError(e, this, 'E_JSON_PARSE');
	          }
	          throw e;
	        }
	      }
	    }
	
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	
	/***/ }),
	
	/***/ "./lib/helpers/bind.js":
	/*!*****************************!*\
	  !*** ./lib/helpers/bind.js ***!
	  \*****************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};
	
	
	/***/ }),
	
	/***/ "./lib/helpers/buildURL.js":
	/*!*********************************!*\
	  !*** ./lib/helpers/buildURL.js ***!
	  \*********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ./../utils */ "./lib/utils.js");
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};
	
	
	/***/ }),
	
	/***/ "./lib/helpers/combineURLs.js":
	/*!************************************!*\
	  !*** ./lib/helpers/combineURLs.js ***!
	  \************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};
	
	
	/***/ }),
	
	/***/ "./lib/helpers/cookies.js":
	/*!********************************!*\
	  !*** ./lib/helpers/cookies.js ***!
	  \********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ./../utils */ "./lib/utils.js");
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);
	
	
	/***/ }),
	
	/***/ "./lib/helpers/isAbsoluteURL.js":
	/*!**************************************!*\
	  !*** ./lib/helpers/isAbsoluteURL.js ***!
	  \**************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};
	
	
	/***/ }),
	
	/***/ "./lib/helpers/isAxiosError.js":
	/*!*************************************!*\
	  !*** ./lib/helpers/isAxiosError.js ***!
	  \*************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	module.exports = function isAxiosError(payload) {
	  return (typeof payload === 'object') && (payload.isAxiosError === true);
	};
	
	
	/***/ }),
	
	/***/ "./lib/helpers/isURLSameOrigin.js":
	/*!****************************************!*\
	  !*** ./lib/helpers/isURLSameOrigin.js ***!
	  \****************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ./../utils */ "./lib/utils.js");
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);
	
	
	/***/ }),
	
	/***/ "./lib/helpers/normalizeHeaderName.js":
	/*!********************************************!*\
	  !*** ./lib/helpers/normalizeHeaderName.js ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ../utils */ "./lib/utils.js");
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};
	
	
	/***/ }),
	
	/***/ "./lib/helpers/parseHeaders.js":
	/*!*************************************!*\
	  !*** ./lib/helpers/parseHeaders.js ***!
	  \*************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var utils = __webpack_require__(/*! ./../utils */ "./lib/utils.js");
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};
	
	
	/***/ }),
	
	/***/ "./lib/helpers/spread.js":
	/*!*******************************!*\
	  !*** ./lib/helpers/spread.js ***!
	  \*******************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};
	
	
	/***/ }),
	
	/***/ "./lib/helpers/validator.js":
	/*!**********************************!*\
	  !*** ./lib/helpers/validator.js ***!
	  \**********************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var pkg = __webpack_require__(/*! ./../../package.json */ "./package.json");
	
	var validators = {};
	
	// eslint-disable-next-line func-names
	['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
	  validators[type] = function validator(thing) {
	    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
	  };
	});
	
	var deprecatedWarnings = {};
	var currentVerArr = pkg.version.split('.');
	
	/**
	 * Compare package versions
	 * @param {string} version
	 * @param {string?} thanVersion
	 * @returns {boolean}
	 */
	function isOlderVersion(version, thanVersion) {
	  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
	  var destVer = version.split('.');
	  for (var i = 0; i < 3; i++) {
	    if (pkgVersionArr[i] > destVer[i]) {
	      return true;
	    } else if (pkgVersionArr[i] < destVer[i]) {
	      return false;
	    }
	  }
	  return false;
	}
	
	/**
	 * Transitional option validator
	 * @param {function|boolean?} validator
	 * @param {string?} version
	 * @param {string} message
	 * @returns {function}
	 */
	validators.transitional = function transitional(validator, version, message) {
	  var isDeprecated = version && isOlderVersion(version);
	
	  function formatMessage(opt, desc) {
	    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
	  }
	
	  // eslint-disable-next-line func-names
	  return function(value, opt, opts) {
	    if (validator === false) {
	      throw new Error(formatMessage(opt, ' has been removed in ' + version));
	    }
	
	    if (isDeprecated && !deprecatedWarnings[opt]) {
	      deprecatedWarnings[opt] = true;
	      // eslint-disable-next-line no-console
	      console.warn(
	        formatMessage(
	          opt,
	          ' has been deprecated since v' + version + ' and will be removed in the near future'
	        )
	      );
	    }
	
	    return validator ? validator(value, opt, opts) : true;
	  };
	};
	
	/**
	 * Assert object's properties type
	 * @param {object} options
	 * @param {object} schema
	 * @param {boolean?} allowUnknown
	 */
	
	function assertOptions(options, schema, allowUnknown) {
	  if (typeof options !== 'object') {
	    throw new TypeError('options must be an object');
	  }
	  var keys = Object.keys(options);
	  var i = keys.length;
	  while (i-- > 0) {
	    var opt = keys[i];
	    var validator = schema[opt];
	    if (validator) {
	      var value = options[opt];
	      var result = value === undefined || validator(value, opt, options);
	      if (result !== true) {
	        throw new TypeError('option ' + opt + ' must be ' + result);
	      }
	      continue;
	    }
	    if (allowUnknown !== true) {
	      throw Error('Unknown option ' + opt);
	    }
	  }
	}
	
	module.exports = {
	  isOlderVersion: isOlderVersion,
	  assertOptions: assertOptions,
	  validators: validators
	};
	
	
	/***/ }),
	
	/***/ "./lib/utils.js":
	/*!**********************!*\
	  !*** ./lib/utils.js ***!
	  \**********************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var bind = __webpack_require__(/*! ./helpers/bind */ "./lib/helpers/bind.js");
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (toString.call(val) !== '[object Object]') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM
	};
	
	
	/***/ }),
	
	/***/ "./package.json":
	/*!**********************!*\
	  !*** ./package.json ***!
	  \**********************/
	/*! exports provided: name, version, description, main, scripts, repository, keywords, author, license, bugs, homepage, devDependencies, browser, jsdelivr, unpkg, typings, dependencies, bundlesize, default */
	/***/ (function(module) {
	
	module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.4\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");
	
	/***/ })
	
	/******/ });
	});
	//# sourceMappingURL=axios.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(24);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AwsService = function () {
	    /* @ngInject */
	    function AwsService($q, $window, ManifestService) {
	        (0, _classCallCheck3.default)(this, AwsService);
	
	        this.$q = $q;
	        this.AWS = $window.AWS;
	        this.ManifestService = ManifestService;
	    }
	
	    /**
	     * Invoke a Lambda function and return the result wrapped in a $q
	     * promise
	     *
	     * @param {String} functionName The name of the lambda function to invoke
	     *            as specified in the Cloud Connect API Specification.
	     * @param {String|Object} payload The payload to include in the lambda invokation
	     */
	
	
	    (0, _createClass3.default)(AwsService, [{
	        key: 'invoke',
	        value: function invoke(functionName, payload) {
	            var _this = this;
	
	            return this.$q(function (resolve, reject) {
	                var lambda = new _this.AWS.Lambda();
	                var p = payload instanceof String ? payload : (0, _stringify2.default)(payload);
	                var params = {
	                    FunctionName: _this.ManifestService.getValue(functionName),
	                    Payload: p
	                };
	
	                lambda.invoke(params, function (err, res) {
	                    if (err) {
	                        reject(err);
	                    } else {
	                        var resultPayload = JSON.parse(res.Payload);
	                        if (resultPayload.errorMessage) {
	                            reject(resultPayload.errorMessage);
	                        } else {
	                            resolve(resultPayload);
	                        }
	                    }
	                });
	            });
	        }
	    }]);
	    return AwsService;
	}();
	
	exports.default = AwsService;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(25), __esModule: true };

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(26);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(28);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(29), __esModule: true };

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(30);
	var $Object = __webpack_require__(26).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(31);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(40), 'Object', { defineProperty: __webpack_require__(36).f });


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(32);
	var core = __webpack_require__(26);
	var ctx = __webpack_require__(33);
	var hide = __webpack_require__(35);
	var has = __webpack_require__(45);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(34);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(36);
	var createDesc = __webpack_require__(44);
	module.exports = __webpack_require__(40) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(37);
	var IE8_DOM_DEFINE = __webpack_require__(39);
	var toPrimitive = __webpack_require__(43);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(40) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(38);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(40) && !__webpack_require__(41)(function () {
	  return Object.defineProperty(__webpack_require__(42)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(41)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(38);
	var document = __webpack_require__(32).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(38);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	// AWS SDK for JavaScript v2.1163.0
	// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
	// License at https://sdk.amazonaws.com/js/BUNDLE_LICENSE.txt
	(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-12-08",
	    "endpointPrefix": "acm",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "ACM",
	    "serviceFullName": "AWS Certificate Manager",
	    "serviceId": "ACM",
	    "signatureVersion": "v4",
	    "targetPrefix": "CertificateManager",
	    "uid": "acm-2015-12-08"
	  },
	  "operations": {
	    "AddTagsToCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateArn",
	          "Tags"
	        ],
	        "members": {
	          "CertificateArn": {},
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      }
	    },
	    "DeleteCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateArn"
	        ],
	        "members": {
	          "CertificateArn": {}
	        }
	      }
	    },
	    "DescribeCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateArn"
	        ],
	        "members": {
	          "CertificateArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Certificate": {
	            "type": "structure",
	            "members": {
	              "CertificateArn": {},
	              "DomainName": {},
	              "SubjectAlternativeNames": {
	                "shape": "Sc"
	              },
	              "DomainValidationOptions": {
	                "shape": "Sd"
	              },
	              "Serial": {},
	              "Subject": {},
	              "Issuer": {},
	              "CreatedAt": {
	                "type": "timestamp"
	              },
	              "IssuedAt": {
	                "type": "timestamp"
	              },
	              "ImportedAt": {
	                "type": "timestamp"
	              },
	              "Status": {},
	              "RevokedAt": {
	                "type": "timestamp"
	              },
	              "RevocationReason": {},
	              "NotBefore": {
	                "type": "timestamp"
	              },
	              "NotAfter": {
	                "type": "timestamp"
	              },
	              "KeyAlgorithm": {},
	              "SignatureAlgorithm": {},
	              "InUseBy": {
	                "type": "list",
	                "member": {}
	              },
	              "FailureReason": {},
	              "Type": {},
	              "RenewalSummary": {
	                "type": "structure",
	                "required": [
	                  "RenewalStatus",
	                  "DomainValidationOptions",
	                  "UpdatedAt"
	                ],
	                "members": {
	                  "RenewalStatus": {},
	                  "DomainValidationOptions": {
	                    "shape": "Sd"
	                  },
	                  "RenewalStatusReason": {},
	                  "UpdatedAt": {
	                    "type": "timestamp"
	                  }
	                }
	              },
	              "KeyUsages": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {}
	                  }
	                }
	              },
	              "ExtendedKeyUsages": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {},
	                    "OID": {}
	                  }
	                }
	              },
	              "CertificateAuthorityArn": {},
	              "RenewalEligibility": {},
	              "Options": {
	                "shape": "S11"
	              }
	            }
	          }
	        }
	      }
	    },
	    "ExportCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateArn",
	          "Passphrase"
	        ],
	        "members": {
	          "CertificateArn": {},
	          "Passphrase": {
	            "type": "blob",
	            "sensitive": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Certificate": {},
	          "CertificateChain": {},
	          "PrivateKey": {
	            "type": "string",
	            "sensitive": true
	          }
	        }
	      }
	    },
	    "GetAccountConfiguration": {
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExpiryEvents": {
	            "shape": "S1a"
	          }
	        }
	      }
	    },
	    "GetCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateArn"
	        ],
	        "members": {
	          "CertificateArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Certificate": {},
	          "CertificateChain": {}
	        }
	      }
	    },
	    "ImportCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Certificate",
	          "PrivateKey"
	        ],
	        "members": {
	          "CertificateArn": {},
	          "Certificate": {
	            "type": "blob"
	          },
	          "PrivateKey": {
	            "type": "blob",
	            "sensitive": true
	          },
	          "CertificateChain": {
	            "type": "blob"
	          },
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CertificateArn": {}
	        }
	      }
	    },
	    "ListCertificates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CertificateStatuses": {
	            "type": "list",
	            "member": {}
	          },
	          "Includes": {
	            "type": "structure",
	            "members": {
	              "extendedKeyUsage": {
	                "type": "list",
	                "member": {}
	              },
	              "keyUsage": {
	                "type": "list",
	                "member": {}
	              },
	              "keyTypes": {
	                "type": "list",
	                "member": {}
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "CertificateSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "CertificateArn": {},
	                "DomainName": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListTagsForCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateArn"
	        ],
	        "members": {
	          "CertificateArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      }
	    },
	    "PutAccountConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdempotencyToken"
	        ],
	        "members": {
	          "ExpiryEvents": {
	            "shape": "S1a"
	          },
	          "IdempotencyToken": {}
	        }
	      }
	    },
	    "RemoveTagsFromCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateArn",
	          "Tags"
	        ],
	        "members": {
	          "CertificateArn": {},
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      }
	    },
	    "RenewCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateArn"
	        ],
	        "members": {
	          "CertificateArn": {}
	        }
	      }
	    },
	    "RequestCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {},
	          "ValidationMethod": {},
	          "SubjectAlternativeNames": {
	            "shape": "Sc"
	          },
	          "IdempotencyToken": {},
	          "DomainValidationOptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "DomainName",
	                "ValidationDomain"
	              ],
	              "members": {
	                "DomainName": {},
	                "ValidationDomain": {}
	              }
	            }
	          },
	          "Options": {
	            "shape": "S11"
	          },
	          "CertificateAuthorityArn": {},
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CertificateArn": {}
	        }
	      }
	    },
	    "ResendValidationEmail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateArn",
	          "Domain",
	          "ValidationDomain"
	        ],
	        "members": {
	          "CertificateArn": {},
	          "Domain": {},
	          "ValidationDomain": {}
	        }
	      }
	    },
	    "UpdateCertificateOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateArn",
	          "Options"
	        ],
	        "members": {
	          "CertificateArn": {},
	          "Options": {
	            "shape": "S11"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S3": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sc": {
	      "type": "list",
	      "member": {}
	    },
	    "Sd": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {},
	          "ValidationEmails": {
	            "type": "list",
	            "member": {}
	          },
	          "ValidationDomain": {},
	          "ValidationStatus": {},
	          "ResourceRecord": {
	            "type": "structure",
	            "required": [
	              "Name",
	              "Type",
	              "Value"
	            ],
	            "members": {
	              "Name": {},
	              "Type": {},
	              "Value": {}
	            }
	          },
	          "ValidationMethod": {}
	        }
	      }
	    },
	    "S11": {
	      "type": "structure",
	      "members": {
	        "CertificateTransparencyLoggingPreference": {}
	      }
	    },
	    "S1a": {
	      "type": "structure",
	      "members": {
	        "DaysBeforeExpiry": {
	          "type": "integer"
	        }
	      }
	    }
	  }
	}
	},{}],2:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListCertificates": {
	      "input_token": "NextToken",
	      "limit_key": "MaxItems",
	      "output_token": "NextToken",
	      "result_key": "CertificateSummaryList"
	    }
	  }
	}
	},{}],3:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "CertificateValidated": {
	      "delay": 60,
	      "maxAttempts": 40,
	      "operation": "DescribeCertificate",
	      "acceptors": [
	        {
	          "matcher": "pathAll",
	          "expected": "SUCCESS",
	          "argument": "Certificate.DomainValidationOptions[].ValidationStatus",
	          "state": "success"
	        },
	        {
	          "matcher": "pathAny",
	          "expected": "PENDING_VALIDATION",
	          "argument": "Certificate.DomainValidationOptions[].ValidationStatus",
	          "state": "retry"
	        },
	        {
	          "matcher": "path",
	          "expected": "FAILED",
	          "argument": "Certificate.Status",
	          "state": "failure"
	        },
	        {
	          "matcher": "error",
	          "expected": "ResourceNotFoundException",
	          "state": "failure"
	        }
	      ]
	    }
	  }
	}
	
	},{}],4:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-07-09",
	    "endpointPrefix": "apigateway",
	    "protocol": "rest-json",
	    "serviceFullName": "Amazon API Gateway",
	    "serviceId": "API Gateway",
	    "signatureVersion": "v4",
	    "uid": "apigateway-2015-07-09"
	  },
	  "operations": {
	    "CreateApiKey": {
	      "http": {
	        "requestUri": "/apikeys",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "enabled": {
	            "type": "boolean"
	          },
	          "generateDistinctId": {
	            "type": "boolean"
	          },
	          "value": {},
	          "stageKeys": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "restApiId": {},
	                "stageName": {}
	              }
	            }
	          },
	          "customerId": {},
	          "tags": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "shape": "S7"
	      }
	    },
	    "CreateAuthorizer": {
	      "http": {
	        "requestUri": "/restapis/{restapi_id}/authorizers",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "name",
	          "type"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "name": {},
	          "type": {},
	          "providerARNs": {
	            "shape": "Sc"
	          },
	          "authType": {},
	          "authorizerUri": {},
	          "authorizerCredentials": {},
	          "identitySource": {},
	          "identityValidationExpression": {},
	          "authorizerResultTtlInSeconds": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sf"
	      }
	    },
	    "CreateBasePathMapping": {
	      "http": {
	        "requestUri": "/domainnames/{domain_name}/basepathmappings",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainName",
	          "restApiId"
	        ],
	        "members": {
	          "domainName": {
	            "location": "uri",
	            "locationName": "domain_name"
	          },
	          "basePath": {},
	          "restApiId": {},
	          "stage": {}
	        }
	      },
	      "output": {
	        "shape": "Sh"
	      }
	    },
	    "CreateDeployment": {
	      "http": {
	        "requestUri": "/restapis/{restapi_id}/deployments",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "stageName": {},
	          "stageDescription": {},
	          "description": {},
	          "cacheClusterEnabled": {
	            "type": "boolean"
	          },
	          "cacheClusterSize": {},
	          "variables": {
	            "shape": "S6"
	          },
	          "canarySettings": {
	            "type": "structure",
	            "members": {
	              "percentTraffic": {
	                "type": "double"
	              },
	              "stageVariableOverrides": {
	                "shape": "S6"
	              },
	              "useStageCache": {
	                "type": "boolean"
	              }
	            }
	          },
	          "tracingEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sn"
	      }
	    },
	    "CreateDocumentationPart": {
	      "http": {
	        "requestUri": "/restapis/{restapi_id}/documentation/parts",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "location",
	          "properties"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "location": {
	            "shape": "Ss"
	          },
	          "properties": {}
	        }
	      },
	      "output": {
	        "shape": "Sv"
	      }
	    },
	    "CreateDocumentationVersion": {
	      "http": {
	        "requestUri": "/restapis/{restapi_id}/documentation/versions",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "documentationVersion"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "documentationVersion": {},
	          "stageName": {},
	          "description": {}
	        }
	      },
	      "output": {
	        "shape": "Sx"
	      }
	    },
	    "CreateDomainName": {
	      "http": {
	        "requestUri": "/domainnames",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainName"
	        ],
	        "members": {
	          "domainName": {},
	          "certificateName": {},
	          "certificateBody": {},
	          "certificatePrivateKey": {},
	          "certificateChain": {},
	          "certificateArn": {},
	          "regionalCertificateName": {},
	          "regionalCertificateArn": {},
	          "endpointConfiguration": {
	            "shape": "Sz"
	          },
	          "tags": {
	            "shape": "S6"
	          },
	          "securityPolicy": {},
	          "mutualTlsAuthentication": {
	            "type": "structure",
	            "members": {
	              "truststoreUri": {},
	              "truststoreVersion": {}
	            }
	          },
	          "ownershipVerificationCertificateArn": {}
	        }
	      },
	      "output": {
	        "shape": "S14"
	      }
	    },
	    "CreateModel": {
	      "http": {
	        "requestUri": "/restapis/{restapi_id}/models",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "name",
	          "contentType"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "name": {},
	          "description": {},
	          "schema": {},
	          "contentType": {}
	        }
	      },
	      "output": {
	        "shape": "S18"
	      }
	    },
	    "CreateRequestValidator": {
	      "http": {
	        "requestUri": "/restapis/{restapi_id}/requestvalidators",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "name": {},
	          "validateRequestBody": {
	            "type": "boolean"
	          },
	          "validateRequestParameters": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1a"
	      }
	    },
	    "CreateResource": {
	      "http": {
	        "requestUri": "/restapis/{restapi_id}/resources/{parent_id}",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "parentId",
	          "pathPart"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "parentId": {
	            "location": "uri",
	            "locationName": "parent_id"
	          },
	          "pathPart": {}
	        }
	      },
	      "output": {
	        "shape": "S1c"
	      }
	    },
	    "CreateRestApi": {
	      "http": {
	        "requestUri": "/restapis",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {},
	          "description": {},
	          "version": {},
	          "cloneFrom": {},
	          "binaryMediaTypes": {
	            "shape": "S9"
	          },
	          "minimumCompressionSize": {
	            "type": "integer"
	          },
	          "apiKeySource": {},
	          "endpointConfiguration": {
	            "shape": "Sz"
	          },
	          "policy": {},
	          "tags": {
	            "shape": "S6"
	          },
	          "disableExecuteApiEndpoint": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1t"
	      }
	    },
	    "CreateStage": {
	      "http": {
	        "requestUri": "/restapis/{restapi_id}/stages",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "stageName",
	          "deploymentId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "stageName": {},
	          "deploymentId": {},
	          "description": {},
	          "cacheClusterEnabled": {
	            "type": "boolean"
	          },
	          "cacheClusterSize": {},
	          "variables": {
	            "shape": "S6"
	          },
	          "documentationVersion": {},
	          "canarySettings": {
	            "shape": "S1v"
	          },
	          "tracingEnabled": {
	            "type": "boolean"
	          },
	          "tags": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1w"
	      }
	    },
	    "CreateUsagePlan": {
	      "http": {
	        "requestUri": "/usageplans",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {},
	          "description": {},
	          "apiStages": {
	            "shape": "S23"
	          },
	          "throttle": {
	            "shape": "S26"
	          },
	          "quota": {
	            "shape": "S27"
	          },
	          "tags": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "shape": "S29"
	      }
	    },
	    "CreateUsagePlanKey": {
	      "http": {
	        "requestUri": "/usageplans/{usageplanId}/keys",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "usagePlanId",
	          "keyId",
	          "keyType"
	        ],
	        "members": {
	          "usagePlanId": {
	            "location": "uri",
	            "locationName": "usageplanId"
	          },
	          "keyId": {},
	          "keyType": {}
	        }
	      },
	      "output": {
	        "shape": "S2b"
	      }
	    },
	    "CreateVpcLink": {
	      "http": {
	        "requestUri": "/vpclinks",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "targetArns"
	        ],
	        "members": {
	          "name": {},
	          "description": {},
	          "targetArns": {
	            "shape": "S9"
	          },
	          "tags": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2d"
	      }
	    },
	    "DeleteApiKey": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/apikeys/{api_Key}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "apiKey"
	        ],
	        "members": {
	          "apiKey": {
	            "location": "uri",
	            "locationName": "api_Key"
	          }
	        }
	      }
	    },
	    "DeleteAuthorizer": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "authorizerId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "authorizerId": {
	            "location": "uri",
	            "locationName": "authorizer_id"
	          }
	        }
	      }
	    },
	    "DeleteBasePathMapping": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainName",
	          "basePath"
	        ],
	        "members": {
	          "domainName": {
	            "location": "uri",
	            "locationName": "domain_name"
	          },
	          "basePath": {
	            "location": "uri",
	            "locationName": "base_path"
	          }
	        }
	      }
	    },
	    "DeleteClientCertificate": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/clientcertificates/{clientcertificate_id}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "clientCertificateId"
	        ],
	        "members": {
	          "clientCertificateId": {
	            "location": "uri",
	            "locationName": "clientcertificate_id"
	          }
	        }
	      }
	    },
	    "DeleteDeployment": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "deploymentId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "deploymentId": {
	            "location": "uri",
	            "locationName": "deployment_id"
	          }
	        }
	      }
	    },
	    "DeleteDocumentationPart": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "documentationPartId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "documentationPartId": {
	            "location": "uri",
	            "locationName": "part_id"
	          }
	        }
	      }
	    },
	    "DeleteDocumentationVersion": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "documentationVersion"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "documentationVersion": {
	            "location": "uri",
	            "locationName": "doc_version"
	          }
	        }
	      }
	    },
	    "DeleteDomainName": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/domainnames/{domain_name}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainName"
	        ],
	        "members": {
	          "domainName": {
	            "location": "uri",
	            "locationName": "domain_name"
	          }
	        }
	      }
	    },
	    "DeleteGatewayResponse": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "responseType"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "responseType": {
	            "location": "uri",
	            "locationName": "response_type"
	          }
	        }
	      }
	    },
	    "DeleteIntegration": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          }
	        }
	      }
	    },
	    "DeleteIntegrationResponse": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod",
	          "statusCode"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "statusCode": {
	            "location": "uri",
	            "locationName": "status_code"
	          }
	        }
	      }
	    },
	    "DeleteMethod": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          }
	        }
	      }
	    },
	    "DeleteMethodResponse": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod",
	          "statusCode"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "statusCode": {
	            "location": "uri",
	            "locationName": "status_code"
	          }
	        }
	      }
	    },
	    "DeleteModel": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/models/{model_name}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "modelName"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "modelName": {
	            "location": "uri",
	            "locationName": "model_name"
	          }
	        }
	      }
	    },
	    "DeleteRequestValidator": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "requestValidatorId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "requestValidatorId": {
	            "location": "uri",
	            "locationName": "requestvalidator_id"
	          }
	        }
	      }
	    },
	    "DeleteResource": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          }
	        }
	      }
	    },
	    "DeleteRestApi": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          }
	        }
	      }
	    },
	    "DeleteStage": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/stages/{stage_name}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "stageName"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "stageName": {
	            "location": "uri",
	            "locationName": "stage_name"
	          }
	        }
	      }
	    },
	    "DeleteUsagePlan": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/usageplans/{usageplanId}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "usagePlanId"
	        ],
	        "members": {
	          "usagePlanId": {
	            "location": "uri",
	            "locationName": "usageplanId"
	          }
	        }
	      }
	    },
	    "DeleteUsagePlanKey": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/usageplans/{usageplanId}/keys/{keyId}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "usagePlanId",
	          "keyId"
	        ],
	        "members": {
	          "usagePlanId": {
	            "location": "uri",
	            "locationName": "usageplanId"
	          },
	          "keyId": {
	            "location": "uri",
	            "locationName": "keyId"
	          }
	        }
	      }
	    },
	    "DeleteVpcLink": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/vpclinks/{vpclink_id}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "vpcLinkId"
	        ],
	        "members": {
	          "vpcLinkId": {
	            "location": "uri",
	            "locationName": "vpclink_id"
	          }
	        }
	      }
	    },
	    "FlushStageAuthorizersCache": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/stages/{stage_name}/cache/authorizers",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "stageName"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "stageName": {
	            "location": "uri",
	            "locationName": "stage_name"
	          }
	        }
	      }
	    },
	    "FlushStageCache": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/restapis/{restapi_id}/stages/{stage_name}/cache/data",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "stageName"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "stageName": {
	            "location": "uri",
	            "locationName": "stage_name"
	          }
	        }
	      }
	    },
	    "GenerateClientCertificate": {
	      "http": {
	        "requestUri": "/clientcertificates",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "description": {},
	          "tags": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "shape": "S34"
	      }
	    },
	    "GetAccount": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/account"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "shape": "S36"
	      }
	    },
	    "GetApiKey": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/apikeys/{api_Key}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "apiKey"
	        ],
	        "members": {
	          "apiKey": {
	            "location": "uri",
	            "locationName": "api_Key"
	          },
	          "includeValue": {
	            "location": "querystring",
	            "locationName": "includeValue",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S7"
	      }
	    },
	    "GetApiKeys": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/apikeys"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "nameQuery": {
	            "location": "querystring",
	            "locationName": "name"
	          },
	          "customerId": {
	            "location": "querystring",
	            "locationName": "customerId"
	          },
	          "includeValues": {
	            "location": "querystring",
	            "locationName": "includeValues",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "warnings": {
	            "shape": "S9"
	          },
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S7"
	            }
	          }
	        }
	      }
	    },
	    "GetAuthorizer": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "authorizerId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "authorizerId": {
	            "location": "uri",
	            "locationName": "authorizer_id"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sf"
	      }
	    },
	    "GetAuthorizers": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/authorizers"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "Sf"
	            }
	          }
	        }
	      }
	    },
	    "GetBasePathMapping": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainName",
	          "basePath"
	        ],
	        "members": {
	          "domainName": {
	            "location": "uri",
	            "locationName": "domain_name"
	          },
	          "basePath": {
	            "location": "uri",
	            "locationName": "base_path"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sh"
	      }
	    },
	    "GetBasePathMappings": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/domainnames/{domain_name}/basepathmappings"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainName"
	        ],
	        "members": {
	          "domainName": {
	            "location": "uri",
	            "locationName": "domain_name"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "Sh"
	            }
	          }
	        }
	      }
	    },
	    "GetClientCertificate": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/clientcertificates/{clientcertificate_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "clientCertificateId"
	        ],
	        "members": {
	          "clientCertificateId": {
	            "location": "uri",
	            "locationName": "clientcertificate_id"
	          }
	        }
	      },
	      "output": {
	        "shape": "S34"
	      }
	    },
	    "GetClientCertificates": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/clientcertificates"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S34"
	            }
	          }
	        }
	      }
	    },
	    "GetDeployment": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "deploymentId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "deploymentId": {
	            "location": "uri",
	            "locationName": "deployment_id"
	          },
	          "embed": {
	            "shape": "S9",
	            "location": "querystring",
	            "locationName": "embed"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sn"
	      }
	    },
	    "GetDeployments": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/deployments"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "Sn"
	            }
	          }
	        }
	      }
	    },
	    "GetDocumentationPart": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "documentationPartId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "documentationPartId": {
	            "location": "uri",
	            "locationName": "part_id"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sv"
	      }
	    },
	    "GetDocumentationParts": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/documentation/parts"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "type": {
	            "location": "querystring",
	            "locationName": "type"
	          },
	          "nameQuery": {
	            "location": "querystring",
	            "locationName": "name"
	          },
	          "path": {
	            "location": "querystring",
	            "locationName": "path"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "locationStatus": {
	            "location": "querystring",
	            "locationName": "locationStatus"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "Sv"
	            }
	          }
	        }
	      }
	    },
	    "GetDocumentationVersion": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "documentationVersion"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "documentationVersion": {
	            "location": "uri",
	            "locationName": "doc_version"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sx"
	      }
	    },
	    "GetDocumentationVersions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/documentation/versions"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "Sx"
	            }
	          }
	        }
	      }
	    },
	    "GetDomainName": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/domainnames/{domain_name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainName"
	        ],
	        "members": {
	          "domainName": {
	            "location": "uri",
	            "locationName": "domain_name"
	          }
	        }
	      },
	      "output": {
	        "shape": "S14"
	      }
	    },
	    "GetDomainNames": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/domainnames"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S14"
	            }
	          }
	        }
	      }
	    },
	    "GetExport": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/stages/{stage_name}/exports/{export_type}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "stageName",
	          "exportType"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "stageName": {
	            "location": "uri",
	            "locationName": "stage_name"
	          },
	          "exportType": {
	            "location": "uri",
	            "locationName": "export_type"
	          },
	          "parameters": {
	            "shape": "S6",
	            "location": "querystring"
	          },
	          "accepts": {
	            "location": "header",
	            "locationName": "Accept"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "contentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "contentDisposition": {
	            "location": "header",
	            "locationName": "Content-Disposition"
	          },
	          "body": {
	            "type": "blob"
	          }
	        },
	        "payload": "body"
	      }
	    },
	    "GetGatewayResponse": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "responseType"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "responseType": {
	            "location": "uri",
	            "locationName": "response_type"
	          }
	        }
	      },
	      "output": {
	        "shape": "S48"
	      }
	    },
	    "GetGatewayResponses": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/gatewayresponses"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S48"
	            }
	          }
	        }
	      }
	    },
	    "GetIntegration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1j"
	      }
	    },
	    "GetIntegrationResponse": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod",
	          "statusCode"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "statusCode": {
	            "location": "uri",
	            "locationName": "status_code"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1p"
	      }
	    },
	    "GetMethod": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1e"
	      }
	    },
	    "GetMethodResponse": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod",
	          "statusCode"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "statusCode": {
	            "location": "uri",
	            "locationName": "status_code"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1h"
	      }
	    },
	    "GetModel": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/models/{model_name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "modelName"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "modelName": {
	            "location": "uri",
	            "locationName": "model_name"
	          },
	          "flatten": {
	            "location": "querystring",
	            "locationName": "flatten",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S18"
	      }
	    },
	    "GetModelTemplate": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/models/{model_name}/default_template"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "modelName"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "modelName": {
	            "location": "uri",
	            "locationName": "model_name"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "value": {}
	        }
	      }
	    },
	    "GetModels": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/models"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S18"
	            }
	          }
	        }
	      }
	    },
	    "GetRequestValidator": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "requestValidatorId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "requestValidatorId": {
	            "location": "uri",
	            "locationName": "requestvalidator_id"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1a"
	      }
	    },
	    "GetRequestValidators": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/requestvalidators"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S1a"
	            }
	          }
	        }
	      }
	    },
	    "GetResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "embed": {
	            "shape": "S9",
	            "location": "querystring",
	            "locationName": "embed"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1c"
	      }
	    },
	    "GetResources": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/resources"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "embed": {
	            "shape": "S9",
	            "location": "querystring",
	            "locationName": "embed"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S1c"
	            }
	          }
	        }
	      }
	    },
	    "GetRestApi": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1t"
	      }
	    },
	    "GetRestApis": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S1t"
	            }
	          }
	        }
	      }
	    },
	    "GetSdk": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/stages/{stage_name}/sdks/{sdk_type}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "stageName",
	          "sdkType"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "stageName": {
	            "location": "uri",
	            "locationName": "stage_name"
	          },
	          "sdkType": {
	            "location": "uri",
	            "locationName": "sdk_type"
	          },
	          "parameters": {
	            "shape": "S6",
	            "location": "querystring"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "contentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "contentDisposition": {
	            "location": "header",
	            "locationName": "Content-Disposition"
	          },
	          "body": {
	            "type": "blob"
	          }
	        },
	        "payload": "body"
	      }
	    },
	    "GetSdkType": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/sdktypes/{sdktype_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "id"
	        ],
	        "members": {
	          "id": {
	            "location": "uri",
	            "locationName": "sdktype_id"
	          }
	        }
	      },
	      "output": {
	        "shape": "S51"
	      }
	    },
	    "GetSdkTypes": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/sdktypes"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S51"
	            }
	          }
	        }
	      }
	    },
	    "GetStage": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/stages/{stage_name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "stageName"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "stageName": {
	            "location": "uri",
	            "locationName": "stage_name"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1w"
	      }
	    },
	    "GetStages": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/restapis/{restapi_id}/stages"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "deploymentId": {
	            "location": "querystring",
	            "locationName": "deploymentId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "item": {
	            "type": "list",
	            "member": {
	              "shape": "S1w"
	            }
	          }
	        }
	      }
	    },
	    "GetTags": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/tags/{resource_arn}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "uri",
	            "locationName": "resource_arn"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tags": {
	            "shape": "S6"
	          }
	        }
	      }
	    },
	    "GetUsage": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/usageplans/{usageplanId}/usage"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "usagePlanId",
	          "startDate",
	          "endDate"
	        ],
	        "members": {
	          "usagePlanId": {
	            "location": "uri",
	            "locationName": "usageplanId"
	          },
	          "keyId": {
	            "location": "querystring",
	            "locationName": "keyId"
	          },
	          "startDate": {
	            "location": "querystring",
	            "locationName": "startDate"
	          },
	          "endDate": {
	            "location": "querystring",
	            "locationName": "endDate"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "shape": "S5e"
	      }
	    },
	    "GetUsagePlan": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/usageplans/{usageplanId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "usagePlanId"
	        ],
	        "members": {
	          "usagePlanId": {
	            "location": "uri",
	            "locationName": "usageplanId"
	          }
	        }
	      },
	      "output": {
	        "shape": "S29"
	      }
	    },
	    "GetUsagePlanKey": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/usageplans/{usageplanId}/keys/{keyId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "usagePlanId",
	          "keyId"
	        ],
	        "members": {
	          "usagePlanId": {
	            "location": "uri",
	            "locationName": "usageplanId"
	          },
	          "keyId": {
	            "location": "uri",
	            "locationName": "keyId"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2b"
	      }
	    },
	    "GetUsagePlanKeys": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/usageplans/{usageplanId}/keys"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "usagePlanId"
	        ],
	        "members": {
	          "usagePlanId": {
	            "location": "uri",
	            "locationName": "usageplanId"
	          },
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "nameQuery": {
	            "location": "querystring",
	            "locationName": "name"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S2b"
	            }
	          }
	        }
	      }
	    },
	    "GetUsagePlans": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/usageplans"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "keyId": {
	            "location": "querystring",
	            "locationName": "keyId"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S29"
	            }
	          }
	        }
	      }
	    },
	    "GetVpcLink": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/vpclinks/{vpclink_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "vpcLinkId"
	        ],
	        "members": {
	          "vpcLinkId": {
	            "location": "uri",
	            "locationName": "vpclink_id"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2d"
	      }
	    },
	    "GetVpcLinks": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/vpclinks"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "position": {
	            "location": "querystring",
	            "locationName": "position"
	          },
	          "limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "position": {},
	          "items": {
	            "locationName": "item",
	            "type": "list",
	            "member": {
	              "shape": "S2d"
	            }
	          }
	        }
	      }
	    },
	    "ImportApiKeys": {
	      "http": {
	        "requestUri": "/apikeys?mode=import",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "body",
	          "format"
	        ],
	        "members": {
	          "body": {
	            "type": "blob"
	          },
	          "format": {
	            "location": "querystring",
	            "locationName": "format"
	          },
	          "failOnWarnings": {
	            "location": "querystring",
	            "locationName": "failonwarnings",
	            "type": "boolean"
	          }
	        },
	        "payload": "body"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ids": {
	            "shape": "S9"
	          },
	          "warnings": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "ImportDocumentationParts": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/restapis/{restapi_id}/documentation/parts"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "body"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "mode": {
	            "location": "querystring",
	            "locationName": "mode"
	          },
	          "failOnWarnings": {
	            "location": "querystring",
	            "locationName": "failonwarnings",
	            "type": "boolean"
	          },
	          "body": {
	            "type": "blob"
	          }
	        },
	        "payload": "body"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ids": {
	            "shape": "S9"
	          },
	          "warnings": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "ImportRestApi": {
	      "http": {
	        "requestUri": "/restapis?mode=import",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "body"
	        ],
	        "members": {
	          "failOnWarnings": {
	            "location": "querystring",
	            "locationName": "failonwarnings",
	            "type": "boolean"
	          },
	          "parameters": {
	            "shape": "S6",
	            "location": "querystring"
	          },
	          "body": {
	            "type": "blob"
	          }
	        },
	        "payload": "body"
	      },
	      "output": {
	        "shape": "S1t"
	      }
	    },
	    "PutGatewayResponse": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "responseType"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "responseType": {
	            "location": "uri",
	            "locationName": "response_type"
	          },
	          "statusCode": {},
	          "responseParameters": {
	            "shape": "S6"
	          },
	          "responseTemplates": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "shape": "S48"
	      }
	    },
	    "PutIntegration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod",
	          "type"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "type": {},
	          "integrationHttpMethod": {
	            "locationName": "httpMethod"
	          },
	          "uri": {},
	          "connectionType": {},
	          "connectionId": {},
	          "credentials": {},
	          "requestParameters": {
	            "shape": "S6"
	          },
	          "requestTemplates": {
	            "shape": "S6"
	          },
	          "passthroughBehavior": {},
	          "cacheNamespace": {},
	          "cacheKeyParameters": {
	            "shape": "S9"
	          },
	          "contentHandling": {},
	          "timeoutInMillis": {
	            "type": "integer"
	          },
	          "tlsConfig": {
	            "shape": "S1q"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1j"
	      }
	    },
	    "PutIntegrationResponse": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod",
	          "statusCode"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "statusCode": {
	            "location": "uri",
	            "locationName": "status_code"
	          },
	          "selectionPattern": {},
	          "responseParameters": {
	            "shape": "S6"
	          },
	          "responseTemplates": {
	            "shape": "S6"
	          },
	          "contentHandling": {}
	        }
	      },
	      "output": {
	        "shape": "S1p"
	      }
	    },
	    "PutMethod": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod",
	          "authorizationType"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "authorizationType": {},
	          "authorizerId": {},
	          "apiKeyRequired": {
	            "type": "boolean"
	          },
	          "operationName": {},
	          "requestParameters": {
	            "shape": "S1f"
	          },
	          "requestModels": {
	            "shape": "S6"
	          },
	          "requestValidatorId": {},
	          "authorizationScopes": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1e"
	      }
	    },
	    "PutMethodResponse": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod",
	          "statusCode"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "statusCode": {
	            "location": "uri",
	            "locationName": "status_code"
	          },
	          "responseParameters": {
	            "shape": "S1f"
	          },
	          "responseModels": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1h"
	      }
	    },
	    "PutRestApi": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/restapis/{restapi_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "body"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "mode": {
	            "location": "querystring",
	            "locationName": "mode"
	          },
	          "failOnWarnings": {
	            "location": "querystring",
	            "locationName": "failonwarnings",
	            "type": "boolean"
	          },
	          "parameters": {
	            "shape": "S6",
	            "location": "querystring"
	          },
	          "body": {
	            "type": "blob"
	          }
	        },
	        "payload": "body"
	      },
	      "output": {
	        "shape": "S1t"
	      }
	    },
	    "TagResource": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/tags/{resource_arn}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tags"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "uri",
	            "locationName": "resource_arn"
	          },
	          "tags": {
	            "shape": "S6"
	          }
	        }
	      }
	    },
	    "TestInvokeAuthorizer": {
	      "http": {
	        "requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "authorizerId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "authorizerId": {
	            "location": "uri",
	            "locationName": "authorizer_id"
	          },
	          "headers": {
	            "shape": "S6"
	          },
	          "multiValueHeaders": {
	            "shape": "S6a"
	          },
	          "pathWithQueryString": {},
	          "body": {},
	          "stageVariables": {
	            "shape": "S6"
	          },
	          "additionalContext": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "clientStatus": {
	            "type": "integer"
	          },
	          "log": {},
	          "latency": {
	            "type": "long"
	          },
	          "principalId": {},
	          "policy": {},
	          "authorization": {
	            "shape": "S6a"
	          },
	          "claims": {
	            "shape": "S6"
	          }
	        }
	      }
	    },
	    "TestInvokeMethod": {
	      "http": {
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "pathWithQueryString": {},
	          "body": {},
	          "headers": {
	            "shape": "S6"
	          },
	          "multiValueHeaders": {
	            "shape": "S6a"
	          },
	          "clientCertificateId": {},
	          "stageVariables": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "status": {
	            "type": "integer"
	          },
	          "body": {},
	          "headers": {
	            "shape": "S6"
	          },
	          "multiValueHeaders": {
	            "shape": "S6a"
	          },
	          "log": {},
	          "latency": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/tags/{resource_arn}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tagKeys"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "uri",
	            "locationName": "resource_arn"
	          },
	          "tagKeys": {
	            "shape": "S9",
	            "location": "querystring",
	            "locationName": "tagKeys"
	          }
	        }
	      }
	    },
	    "UpdateAccount": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/account"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S36"
	      }
	    },
	    "UpdateApiKey": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/apikeys/{api_Key}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "apiKey"
	        ],
	        "members": {
	          "apiKey": {
	            "location": "uri",
	            "locationName": "api_Key"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S7"
	      }
	    },
	    "UpdateAuthorizer": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "authorizerId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "authorizerId": {
	            "location": "uri",
	            "locationName": "authorizer_id"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sf"
	      }
	    },
	    "UpdateBasePathMapping": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainName",
	          "basePath"
	        ],
	        "members": {
	          "domainName": {
	            "location": "uri",
	            "locationName": "domain_name"
	          },
	          "basePath": {
	            "location": "uri",
	            "locationName": "base_path"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sh"
	      }
	    },
	    "UpdateClientCertificate": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/clientcertificates/{clientcertificate_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "clientCertificateId"
	        ],
	        "members": {
	          "clientCertificateId": {
	            "location": "uri",
	            "locationName": "clientcertificate_id"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S34"
	      }
	    },
	    "UpdateDeployment": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "deploymentId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "deploymentId": {
	            "location": "uri",
	            "locationName": "deployment_id"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sn"
	      }
	    },
	    "UpdateDocumentationPart": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "documentationPartId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "documentationPartId": {
	            "location": "uri",
	            "locationName": "part_id"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sv"
	      }
	    },
	    "UpdateDocumentationVersion": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "documentationVersion"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "documentationVersion": {
	            "location": "uri",
	            "locationName": "doc_version"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sx"
	      }
	    },
	    "UpdateDomainName": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/domainnames/{domain_name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainName"
	        ],
	        "members": {
	          "domainName": {
	            "location": "uri",
	            "locationName": "domain_name"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S14"
	      }
	    },
	    "UpdateGatewayResponse": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "responseType"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "responseType": {
	            "location": "uri",
	            "locationName": "response_type"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S48"
	      }
	    },
	    "UpdateIntegration": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1j"
	      }
	    },
	    "UpdateIntegrationResponse": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod",
	          "statusCode"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "statusCode": {
	            "location": "uri",
	            "locationName": "status_code"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1p"
	      }
	    },
	    "UpdateMethod": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1e"
	      }
	    },
	    "UpdateMethodResponse": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId",
	          "httpMethod",
	          "statusCode"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "httpMethod": {
	            "location": "uri",
	            "locationName": "http_method"
	          },
	          "statusCode": {
	            "location": "uri",
	            "locationName": "status_code"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1h"
	      }
	    },
	    "UpdateModel": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/models/{model_name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "modelName"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "modelName": {
	            "location": "uri",
	            "locationName": "model_name"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S18"
	      }
	    },
	    "UpdateRequestValidator": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "requestValidatorId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "requestValidatorId": {
	            "location": "uri",
	            "locationName": "requestvalidator_id"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1a"
	      }
	    },
	    "UpdateResource": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/resources/{resource_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "resourceId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "resourceId": {
	            "location": "uri",
	            "locationName": "resource_id"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1c"
	      }
	    },
	    "UpdateRestApi": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1t"
	      }
	    },
	    "UpdateStage": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/restapis/{restapi_id}/stages/{stage_name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "restApiId",
	          "stageName"
	        ],
	        "members": {
	          "restApiId": {
	            "location": "uri",
	            "locationName": "restapi_id"
	          },
	          "stageName": {
	            "location": "uri",
	            "locationName": "stage_name"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1w"
	      }
	    },
	    "UpdateUsage": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/usageplans/{usageplanId}/keys/{keyId}/usage"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "usagePlanId",
	          "keyId"
	        ],
	        "members": {
	          "usagePlanId": {
	            "location": "uri",
	            "locationName": "usageplanId"
	          },
	          "keyId": {
	            "location": "uri",
	            "locationName": "keyId"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S5e"
	      }
	    },
	    "UpdateUsagePlan": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/usageplans/{usageplanId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "usagePlanId"
	        ],
	        "members": {
	          "usagePlanId": {
	            "location": "uri",
	            "locationName": "usageplanId"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S29"
	      }
	    },
	    "UpdateVpcLink": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/vpclinks/{vpclink_id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "vpcLinkId"
	        ],
	        "members": {
	          "vpcLinkId": {
	            "location": "uri",
	            "locationName": "vpclink_id"
	          },
	          "patchOperations": {
	            "shape": "S6g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2d"
	      }
	    }
	  },
	  "shapes": {
	    "S6": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S7": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "value": {},
	        "name": {},
	        "customerId": {},
	        "description": {},
	        "enabled": {
	          "type": "boolean"
	        },
	        "createdDate": {
	          "type": "timestamp"
	        },
	        "lastUpdatedDate": {
	          "type": "timestamp"
	        },
	        "stageKeys": {
	          "shape": "S9"
	        },
	        "tags": {
	          "shape": "S6"
	        }
	      }
	    },
	    "S9": {
	      "type": "list",
	      "member": {}
	    },
	    "Sc": {
	      "type": "list",
	      "member": {}
	    },
	    "Sf": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "name": {},
	        "type": {},
	        "providerARNs": {
	          "shape": "Sc"
	        },
	        "authType": {},
	        "authorizerUri": {},
	        "authorizerCredentials": {},
	        "identitySource": {},
	        "identityValidationExpression": {},
	        "authorizerResultTtlInSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "Sh": {
	      "type": "structure",
	      "members": {
	        "basePath": {},
	        "restApiId": {},
	        "stage": {}
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "description": {},
	        "createdDate": {
	          "type": "timestamp"
	        },
	        "apiSummary": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "members": {
	                "authorizationType": {},
	                "apiKeyRequired": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Ss": {
	      "type": "structure",
	      "required": [
	        "type"
	      ],
	      "members": {
	        "type": {},
	        "path": {},
	        "method": {},
	        "statusCode": {},
	        "name": {}
	      }
	    },
	    "Sv": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "location": {
	          "shape": "Ss"
	        },
	        "properties": {}
	      }
	    },
	    "Sx": {
	      "type": "structure",
	      "members": {
	        "version": {},
	        "createdDate": {
	          "type": "timestamp"
	        },
	        "description": {}
	      }
	    },
	    "Sz": {
	      "type": "structure",
	      "members": {
	        "types": {
	          "type": "list",
	          "member": {}
	        },
	        "vpcEndpointIds": {
	          "shape": "S9"
	        }
	      }
	    },
	    "S14": {
	      "type": "structure",
	      "members": {
	        "domainName": {},
	        "certificateName": {},
	        "certificateArn": {},
	        "certificateUploadDate": {
	          "type": "timestamp"
	        },
	        "regionalDomainName": {},
	        "regionalHostedZoneId": {},
	        "regionalCertificateName": {},
	        "regionalCertificateArn": {},
	        "distributionDomainName": {},
	        "distributionHostedZoneId": {},
	        "endpointConfiguration": {
	          "shape": "Sz"
	        },
	        "domainNameStatus": {},
	        "domainNameStatusMessage": {},
	        "securityPolicy": {},
	        "tags": {
	          "shape": "S6"
	        },
	        "mutualTlsAuthentication": {
	          "type": "structure",
	          "members": {
	            "truststoreUri": {},
	            "truststoreVersion": {},
	            "truststoreWarnings": {
	              "shape": "S9"
	            }
	          }
	        },
	        "ownershipVerificationCertificateArn": {}
	      }
	    },
	    "S18": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "name": {},
	        "description": {},
	        "schema": {},
	        "contentType": {}
	      }
	    },
	    "S1a": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "name": {},
	        "validateRequestBody": {
	          "type": "boolean"
	        },
	        "validateRequestParameters": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1c": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "parentId": {},
	        "pathPart": {},
	        "path": {},
	        "resourceMethods": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "shape": "S1e"
	          }
	        }
	      }
	    },
	    "S1e": {
	      "type": "structure",
	      "members": {
	        "httpMethod": {},
	        "authorizationType": {},
	        "authorizerId": {},
	        "apiKeyRequired": {
	          "type": "boolean"
	        },
	        "requestValidatorId": {},
	        "operationName": {},
	        "requestParameters": {
	          "shape": "S1f"
	        },
	        "requestModels": {
	          "shape": "S6"
	        },
	        "methodResponses": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "shape": "S1h"
	          }
	        },
	        "methodIntegration": {
	          "shape": "S1j"
	        },
	        "authorizationScopes": {
	          "shape": "S9"
	        }
	      }
	    },
	    "S1f": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "boolean"
	      }
	    },
	    "S1h": {
	      "type": "structure",
	      "members": {
	        "statusCode": {},
	        "responseParameters": {
	          "shape": "S1f"
	        },
	        "responseModels": {
	          "shape": "S6"
	        }
	      }
	    },
	    "S1j": {
	      "type": "structure",
	      "members": {
	        "type": {},
	        "httpMethod": {},
	        "uri": {},
	        "connectionType": {},
	        "connectionId": {},
	        "credentials": {},
	        "requestParameters": {
	          "shape": "S6"
	        },
	        "requestTemplates": {
	          "shape": "S6"
	        },
	        "passthroughBehavior": {},
	        "contentHandling": {},
	        "timeoutInMillis": {
	          "type": "integer"
	        },
	        "cacheNamespace": {},
	        "cacheKeyParameters": {
	          "shape": "S9"
	        },
	        "integrationResponses": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "shape": "S1p"
	          }
	        },
	        "tlsConfig": {
	          "shape": "S1q"
	        }
	      }
	    },
	    "S1p": {
	      "type": "structure",
	      "members": {
	        "statusCode": {},
	        "selectionPattern": {},
	        "responseParameters": {
	          "shape": "S6"
	        },
	        "responseTemplates": {
	          "shape": "S6"
	        },
	        "contentHandling": {}
	      }
	    },
	    "S1q": {
	      "type": "structure",
	      "members": {
	        "insecureSkipVerification": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1t": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "name": {},
	        "description": {},
	        "createdDate": {
	          "type": "timestamp"
	        },
	        "version": {},
	        "warnings": {
	          "shape": "S9"
	        },
	        "binaryMediaTypes": {
	          "shape": "S9"
	        },
	        "minimumCompressionSize": {
	          "type": "integer"
	        },
	        "apiKeySource": {},
	        "endpointConfiguration": {
	          "shape": "Sz"
	        },
	        "policy": {},
	        "tags": {
	          "shape": "S6"
	        },
	        "disableExecuteApiEndpoint": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1v": {
	      "type": "structure",
	      "members": {
	        "percentTraffic": {
	          "type": "double"
	        },
	        "deploymentId": {},
	        "stageVariableOverrides": {
	          "shape": "S6"
	        },
	        "useStageCache": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1w": {
	      "type": "structure",
	      "members": {
	        "deploymentId": {},
	        "clientCertificateId": {},
	        "stageName": {},
	        "description": {},
	        "cacheClusterEnabled": {
	          "type": "boolean"
	        },
	        "cacheClusterSize": {},
	        "cacheClusterStatus": {},
	        "methodSettings": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "type": "structure",
	            "members": {
	              "metricsEnabled": {
	                "type": "boolean"
	              },
	              "loggingLevel": {},
	              "dataTraceEnabled": {
	                "type": "boolean"
	              },
	              "throttlingBurstLimit": {
	                "type": "integer"
	              },
	              "throttlingRateLimit": {
	                "type": "double"
	              },
	              "cachingEnabled": {
	                "type": "boolean"
	              },
	              "cacheTtlInSeconds": {
	                "type": "integer"
	              },
	              "cacheDataEncrypted": {
	                "type": "boolean"
	              },
	              "requireAuthorizationForCacheControl": {
	                "type": "boolean"
	              },
	              "unauthorizedCacheControlHeaderStrategy": {}
	            }
	          }
	        },
	        "variables": {
	          "shape": "S6"
	        },
	        "documentationVersion": {},
	        "accessLogSettings": {
	          "type": "structure",
	          "members": {
	            "format": {},
	            "destinationArn": {}
	          }
	        },
	        "canarySettings": {
	          "shape": "S1v"
	        },
	        "tracingEnabled": {
	          "type": "boolean"
	        },
	        "webAclArn": {},
	        "tags": {
	          "shape": "S6"
	        },
	        "createdDate": {
	          "type": "timestamp"
	        },
	        "lastUpdatedDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S23": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "apiId": {},
	          "stage": {},
	          "throttle": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "shape": "S26"
	            }
	          }
	        }
	      }
	    },
	    "S26": {
	      "type": "structure",
	      "members": {
	        "burstLimit": {
	          "type": "integer"
	        },
	        "rateLimit": {
	          "type": "double"
	        }
	      }
	    },
	    "S27": {
	      "type": "structure",
	      "members": {
	        "limit": {
	          "type": "integer"
	        },
	        "offset": {
	          "type": "integer"
	        },
	        "period": {}
	      }
	    },
	    "S29": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "name": {},
	        "description": {},
	        "apiStages": {
	          "shape": "S23"
	        },
	        "throttle": {
	          "shape": "S26"
	        },
	        "quota": {
	          "shape": "S27"
	        },
	        "productCode": {},
	        "tags": {
	          "shape": "S6"
	        }
	      }
	    },
	    "S2b": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "type": {},
	        "value": {},
	        "name": {}
	      }
	    },
	    "S2d": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "name": {},
	        "description": {},
	        "targetArns": {
	          "shape": "S9"
	        },
	        "status": {},
	        "statusMessage": {},
	        "tags": {
	          "shape": "S6"
	        }
	      }
	    },
	    "S34": {
	      "type": "structure",
	      "members": {
	        "clientCertificateId": {},
	        "description": {},
	        "pemEncodedCertificate": {},
	        "createdDate": {
	          "type": "timestamp"
	        },
	        "expirationDate": {
	          "type": "timestamp"
	        },
	        "tags": {
	          "shape": "S6"
	        }
	      }
	    },
	    "S36": {
	      "type": "structure",
	      "members": {
	        "cloudwatchRoleArn": {},
	        "throttleSettings": {
	          "shape": "S26"
	        },
	        "features": {
	          "shape": "S9"
	        },
	        "apiKeyVersion": {}
	      }
	    },
	    "S48": {
	      "type": "structure",
	      "members": {
	        "responseType": {},
	        "statusCode": {},
	        "responseParameters": {
	          "shape": "S6"
	        },
	        "responseTemplates": {
	          "shape": "S6"
	        },
	        "defaultResponse": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S51": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "friendlyName": {},
	        "description": {},
	        "configurationProperties": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "friendlyName": {},
	              "description": {},
	              "required": {
	                "type": "boolean"
	              },
	              "defaultValue": {}
	            }
	          }
	        }
	      }
	    },
	    "S5e": {
	      "type": "structure",
	      "members": {
	        "usagePlanId": {},
	        "startDate": {},
	        "endDate": {},
	        "position": {},
	        "items": {
	          "locationName": "values",
	          "type": "map",
	          "key": {},
	          "value": {
	            "type": "list",
	            "member": {
	              "type": "list",
	              "member": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S6a": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "S9"
	      }
	    },
	    "S6g": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "op": {},
	          "path": {},
	          "value": {},
	          "from": {}
	        }
	      }
	    }
	  }
	}
	},{}],5:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "GetApiKeys": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "output_token": "position",
	      "result_key": "items"
	    },
	    "GetBasePathMappings": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "output_token": "position",
	      "result_key": "items"
	    },
	    "GetClientCertificates": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "output_token": "position",
	      "result_key": "items"
	    },
	    "GetDeployments": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "output_token": "position",
	      "result_key": "items"
	    },
	    "GetDomainNames": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "output_token": "position",
	      "result_key": "items"
	    },
	    "GetModels": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "output_token": "position",
	      "result_key": "items"
	    },
	    "GetResources": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "output_token": "position",
	      "result_key": "items"
	    },
	    "GetRestApis": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "output_token": "position",
	      "result_key": "items"
	    },
	    "GetUsage": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "non_aggregate_keys": [
	        "usagePlanId",
	        "startDate",
	        "endDate"
	      ],
	      "output_token": "position",
	      "result_key": "items"
	    },
	    "GetUsagePlanKeys": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "output_token": "position",
	      "result_key": "items"
	    },
	    "GetUsagePlans": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "output_token": "position",
	      "result_key": "items"
	    },
	    "GetVpcLinks": {
	      "input_token": "position",
	      "limit_key": "limit",
	      "output_token": "position",
	      "result_key": "items"
	    }
	  }
	}
	},{}],6:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2016-02-06",
	    "endpointPrefix": "application-autoscaling",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Application Auto Scaling",
	    "serviceId": "Application Auto Scaling",
	    "signatureVersion": "v4",
	    "signingName": "application-autoscaling",
	    "targetPrefix": "AnyScaleFrontendService",
	    "uid": "application-autoscaling-2016-02-06"
	  },
	  "operations": {
	    "DeleteScalingPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyName",
	          "ServiceNamespace",
	          "ResourceId",
	          "ScalableDimension"
	        ],
	        "members": {
	          "PolicyName": {},
	          "ServiceNamespace": {},
	          "ResourceId": {},
	          "ScalableDimension": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteScheduledAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceNamespace",
	          "ScheduledActionName",
	          "ResourceId",
	          "ScalableDimension"
	        ],
	        "members": {
	          "ServiceNamespace": {},
	          "ScheduledActionName": {},
	          "ResourceId": {},
	          "ScalableDimension": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeregisterScalableTarget": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceNamespace",
	          "ResourceId",
	          "ScalableDimension"
	        ],
	        "members": {
	          "ServiceNamespace": {},
	          "ResourceId": {},
	          "ScalableDimension": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeScalableTargets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceNamespace"
	        ],
	        "members": {
	          "ServiceNamespace": {},
	          "ResourceIds": {
	            "shape": "Sb"
	          },
	          "ScalableDimension": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ScalableTargets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ServiceNamespace",
	                "ResourceId",
	                "ScalableDimension",
	                "MinCapacity",
	                "MaxCapacity",
	                "RoleARN",
	                "CreationTime"
	              ],
	              "members": {
	                "ServiceNamespace": {},
	                "ResourceId": {},
	                "ScalableDimension": {},
	                "MinCapacity": {
	                  "type": "integer"
	                },
	                "MaxCapacity": {
	                  "type": "integer"
	                },
	                "RoleARN": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "SuspendedState": {
	                  "shape": "Sj"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeScalingActivities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceNamespace"
	        ],
	        "members": {
	          "ServiceNamespace": {},
	          "ResourceId": {},
	          "ScalableDimension": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ScalingActivities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ActivityId",
	                "ServiceNamespace",
	                "ResourceId",
	                "ScalableDimension",
	                "Description",
	                "Cause",
	                "StartTime",
	                "StatusCode"
	              ],
	              "members": {
	                "ActivityId": {},
	                "ServiceNamespace": {},
	                "ResourceId": {},
	                "ScalableDimension": {},
	                "Description": {},
	                "Cause": {},
	                "StartTime": {
	                  "type": "timestamp"
	                },
	                "EndTime": {
	                  "type": "timestamp"
	                },
	                "StatusCode": {},
	                "StatusMessage": {},
	                "Details": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeScalingPolicies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceNamespace"
	        ],
	        "members": {
	          "PolicyNames": {
	            "shape": "Sb"
	          },
	          "ServiceNamespace": {},
	          "ResourceId": {},
	          "ScalableDimension": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ScalingPolicies": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "PolicyARN",
	                "PolicyName",
	                "ServiceNamespace",
	                "ResourceId",
	                "ScalableDimension",
	                "PolicyType",
	                "CreationTime"
	              ],
	              "members": {
	                "PolicyARN": {},
	                "PolicyName": {},
	                "ServiceNamespace": {},
	                "ResourceId": {},
	                "ScalableDimension": {},
	                "PolicyType": {},
	                "StepScalingPolicyConfiguration": {
	                  "shape": "Sx"
	                },
	                "TargetTrackingScalingPolicyConfiguration": {
	                  "shape": "S16"
	                },
	                "Alarms": {
	                  "shape": "S1k"
	                },
	                "CreationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeScheduledActions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceNamespace"
	        ],
	        "members": {
	          "ScheduledActionNames": {
	            "shape": "Sb"
	          },
	          "ServiceNamespace": {},
	          "ResourceId": {},
	          "ScalableDimension": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ScheduledActions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ScheduledActionName",
	                "ScheduledActionARN",
	                "ServiceNamespace",
	                "Schedule",
	                "ResourceId",
	                "CreationTime"
	              ],
	              "members": {
	                "ScheduledActionName": {},
	                "ScheduledActionARN": {},
	                "ServiceNamespace": {},
	                "Schedule": {},
	                "Timezone": {},
	                "ResourceId": {},
	                "ScalableDimension": {},
	                "StartTime": {
	                  "type": "timestamp"
	                },
	                "EndTime": {
	                  "type": "timestamp"
	                },
	                "ScalableTargetAction": {
	                  "shape": "S1r"
	                },
	                "CreationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PutScalingPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyName",
	          "ServiceNamespace",
	          "ResourceId",
	          "ScalableDimension"
	        ],
	        "members": {
	          "PolicyName": {},
	          "ServiceNamespace": {},
	          "ResourceId": {},
	          "ScalableDimension": {},
	          "PolicyType": {},
	          "StepScalingPolicyConfiguration": {
	            "shape": "Sx"
	          },
	          "TargetTrackingScalingPolicyConfiguration": {
	            "shape": "S16"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "PolicyARN"
	        ],
	        "members": {
	          "PolicyARN": {},
	          "Alarms": {
	            "shape": "S1k"
	          }
	        }
	      }
	    },
	    "PutScheduledAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceNamespace",
	          "ScheduledActionName",
	          "ResourceId",
	          "ScalableDimension"
	        ],
	        "members": {
	          "ServiceNamespace": {},
	          "Schedule": {},
	          "Timezone": {},
	          "ScheduledActionName": {},
	          "ResourceId": {},
	          "ScalableDimension": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "ScalableTargetAction": {
	            "shape": "S1r"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RegisterScalableTarget": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceNamespace",
	          "ResourceId",
	          "ScalableDimension"
	        ],
	        "members": {
	          "ServiceNamespace": {},
	          "ResourceId": {},
	          "ScalableDimension": {},
	          "MinCapacity": {
	            "type": "integer"
	          },
	          "MaxCapacity": {
	            "type": "integer"
	          },
	          "RoleARN": {},
	          "SuspendedState": {
	            "shape": "Sj"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "Sb": {
	      "type": "list",
	      "member": {}
	    },
	    "Sj": {
	      "type": "structure",
	      "members": {
	        "DynamicScalingInSuspended": {
	          "type": "boolean"
	        },
	        "DynamicScalingOutSuspended": {
	          "type": "boolean"
	        },
	        "ScheduledScalingSuspended": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Sx": {
	      "type": "structure",
	      "members": {
	        "AdjustmentType": {},
	        "StepAdjustments": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "ScalingAdjustment"
	            ],
	            "members": {
	              "MetricIntervalLowerBound": {
	                "type": "double"
	              },
	              "MetricIntervalUpperBound": {
	                "type": "double"
	              },
	              "ScalingAdjustment": {
	                "type": "integer"
	              }
	            }
	          }
	        },
	        "MinAdjustmentMagnitude": {
	          "type": "integer"
	        },
	        "Cooldown": {
	          "type": "integer"
	        },
	        "MetricAggregationType": {}
	      }
	    },
	    "S16": {
	      "type": "structure",
	      "required": [
	        "TargetValue"
	      ],
	      "members": {
	        "TargetValue": {
	          "type": "double"
	        },
	        "PredefinedMetricSpecification": {
	          "type": "structure",
	          "required": [
	            "PredefinedMetricType"
	          ],
	          "members": {
	            "PredefinedMetricType": {},
	            "ResourceLabel": {}
	          }
	        },
	        "CustomizedMetricSpecification": {
	          "type": "structure",
	          "required": [
	            "MetricName",
	            "Namespace",
	            "Statistic"
	          ],
	          "members": {
	            "MetricName": {},
	            "Namespace": {},
	            "Dimensions": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "required": [
	                  "Name",
	                  "Value"
	                ],
	                "members": {
	                  "Name": {},
	                  "Value": {}
	                }
	              }
	            },
	            "Statistic": {},
	            "Unit": {}
	          }
	        },
	        "ScaleOutCooldown": {
	          "type": "integer"
	        },
	        "ScaleInCooldown": {
	          "type": "integer"
	        },
	        "DisableScaleIn": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1k": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "AlarmName",
	          "AlarmARN"
	        ],
	        "members": {
	          "AlarmName": {},
	          "AlarmARN": {}
	        }
	      }
	    },
	    "S1r": {
	      "type": "structure",
	      "members": {
	        "MinCapacity": {
	          "type": "integer"
	        },
	        "MaxCapacity": {
	          "type": "integer"
	        }
	      }
	    }
	  }
	}
	},{}],7:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeScalableTargets": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ScalableTargets"
	    },
	    "DescribeScalingActivities": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ScalingActivities"
	    },
	    "DescribeScalingPolicies": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ScalingPolicies"
	    },
	    "DescribeScheduledActions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ScheduledActions"
	    }
	  }
	}
	},{}],8:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-05-18",
	    "endpointPrefix": "athena",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Athena",
	    "serviceId": "Athena",
	    "signatureVersion": "v4",
	    "targetPrefix": "AmazonAthena",
	    "uid": "athena-2017-05-18"
	  },
	  "operations": {
	    "BatchGetNamedQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NamedQueryIds"
	        ],
	        "members": {
	          "NamedQueryIds": {
	            "shape": "S2"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NamedQueries": {
	            "type": "list",
	            "member": {
	              "shape": "S6"
	            }
	          },
	          "UnprocessedNamedQueryIds": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "NamedQueryId": {},
	                "ErrorCode": {},
	                "ErrorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "BatchGetQueryExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueryExecutionIds"
	        ],
	        "members": {
	          "QueryExecutionIds": {
	            "shape": "Sh"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QueryExecutions": {
	            "type": "list",
	            "member": {
	              "shape": "Sl"
	            }
	          },
	          "UnprocessedQueryExecutionIds": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "QueryExecutionId": {},
	                "ErrorCode": {},
	                "ErrorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "CreateDataCatalog": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Type"
	        ],
	        "members": {
	          "Name": {},
	          "Type": {},
	          "Description": {},
	          "Parameters": {
	            "shape": "S19"
	          },
	          "Tags": {
	            "shape": "S1c"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateNamedQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Database",
	          "QueryString"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "Database": {},
	          "QueryString": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "WorkGroup": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NamedQueryId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "CreatePreparedStatement": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StatementName",
	          "WorkGroup",
	          "QueryStatement"
	        ],
	        "members": {
	          "StatementName": {},
	          "WorkGroup": {},
	          "QueryStatement": {},
	          "Description": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateWorkGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Configuration": {
	            "shape": "S1o"
	          },
	          "Description": {},
	          "Tags": {
	            "shape": "S1c"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteDataCatalog": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteNamedQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NamedQueryId"
	        ],
	        "members": {
	          "NamedQueryId": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "DeletePreparedStatement": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StatementName",
	          "WorkGroup"
	        ],
	        "members": {
	          "StatementName": {},
	          "WorkGroup": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteWorkGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WorkGroup"
	        ],
	        "members": {
	          "WorkGroup": {},
	          "RecursiveDeleteOption": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "GetDataCatalog": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DataCatalog": {
	            "type": "structure",
	            "required": [
	              "Name",
	              "Type"
	            ],
	            "members": {
	              "Name": {},
	              "Description": {},
	              "Type": {},
	              "Parameters": {
	                "shape": "S19"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetDatabase": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CatalogName",
	          "DatabaseName"
	        ],
	        "members": {
	          "CatalogName": {},
	          "DatabaseName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Database": {
	            "shape": "S26"
	          }
	        }
	      }
	    },
	    "GetNamedQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NamedQueryId"
	        ],
	        "members": {
	          "NamedQueryId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NamedQuery": {
	            "shape": "S6"
	          }
	        }
	      }
	    },
	    "GetPreparedStatement": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StatementName",
	          "WorkGroup"
	        ],
	        "members": {
	          "StatementName": {},
	          "WorkGroup": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PreparedStatement": {
	            "type": "structure",
	            "members": {
	              "StatementName": {},
	              "QueryStatement": {},
	              "WorkGroupName": {},
	              "Description": {},
	              "LastModifiedTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetQueryExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueryExecutionId"
	        ],
	        "members": {
	          "QueryExecutionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QueryExecution": {
	            "shape": "Sl"
	          }
	        }
	      }
	    },
	    "GetQueryResults": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueryExecutionId"
	        ],
	        "members": {
	          "QueryExecutionId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UpdateCount": {
	            "type": "long"
	          },
	          "ResultSet": {
	            "type": "structure",
	            "members": {
	              "Rows": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Data": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "members": {
	                          "VarCharValue": {}
	                        }
	                      }
	                    }
	                  }
	                }
	              },
	              "ResultSetMetadata": {
	                "type": "structure",
	                "members": {
	                  "ColumnInfo": {
	                    "type": "list",
	                    "member": {
	                      "type": "structure",
	                      "required": [
	                        "Name",
	                        "Type"
	                      ],
	                      "members": {
	                        "CatalogName": {},
	                        "SchemaName": {},
	                        "TableName": {},
	                        "Name": {},
	                        "Label": {},
	                        "Type": {},
	                        "Precision": {
	                          "type": "integer"
	                        },
	                        "Scale": {
	                          "type": "integer"
	                        },
	                        "Nullable": {},
	                        "CaseSensitive": {
	                          "type": "boolean"
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetTableMetadata": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CatalogName",
	          "DatabaseName",
	          "TableName"
	        ],
	        "members": {
	          "CatalogName": {},
	          "DatabaseName": {},
	          "TableName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableMetadata": {
	            "shape": "S2v"
	          }
	        }
	      }
	    },
	    "GetWorkGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WorkGroup"
	        ],
	        "members": {
	          "WorkGroup": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WorkGroup": {
	            "type": "structure",
	            "required": [
	              "Name"
	            ],
	            "members": {
	              "Name": {},
	              "State": {},
	              "Configuration": {
	                "shape": "S1o"
	              },
	              "Description": {},
	              "CreationTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListDataCatalogs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DataCatalogsSummary": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "CatalogName": {},
	                "Type": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListDatabases": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CatalogName"
	        ],
	        "members": {
	          "CatalogName": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatabaseList": {
	            "type": "list",
	            "member": {
	              "shape": "S26"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListEngineVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EngineVersions": {
	            "type": "list",
	            "member": {
	              "shape": "S14"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListNamedQueries": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "WorkGroup": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NamedQueryIds": {
	            "shape": "S2"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListPreparedStatements": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WorkGroup"
	        ],
	        "members": {
	          "WorkGroup": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PreparedStatements": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "StatementName": {},
	                "LastModifiedTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListQueryExecutions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "WorkGroup": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QueryExecutionIds": {
	            "shape": "Sh"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTableMetadata": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CatalogName",
	          "DatabaseName"
	        ],
	        "members": {
	          "CatalogName": {},
	          "DatabaseName": {},
	          "Expression": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableMetadataList": {
	            "type": "list",
	            "member": {
	              "shape": "S2v"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S1c"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListWorkGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WorkGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "State": {},
	                "Description": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "EngineVersion": {
	                  "shape": "S14"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "StartQueryExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueryString"
	        ],
	        "members": {
	          "QueryString": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "QueryExecutionContext": {
	            "shape": "St"
	          },
	          "ResultConfiguration": {
	            "shape": "Sn"
	          },
	          "WorkGroup": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QueryExecutionId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StopQueryExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueryExecutionId"
	        ],
	        "members": {
	          "QueryExecutionId": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "Tags"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "Tags": {
	            "shape": "S1c"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateDataCatalog": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Type"
	        ],
	        "members": {
	          "Name": {},
	          "Type": {},
	          "Description": {},
	          "Parameters": {
	            "shape": "S19"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateNamedQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NamedQueryId",
	          "Name",
	          "QueryString"
	        ],
	        "members": {
	          "NamedQueryId": {},
	          "Name": {},
	          "Description": {},
	          "QueryString": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "UpdatePreparedStatement": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StatementName",
	          "WorkGroup",
	          "QueryStatement"
	        ],
	        "members": {
	          "StatementName": {},
	          "WorkGroup": {},
	          "QueryStatement": {},
	          "Description": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateWorkGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WorkGroup"
	        ],
	        "members": {
	          "WorkGroup": {},
	          "Description": {},
	          "ConfigurationUpdates": {
	            "type": "structure",
	            "members": {
	              "EnforceWorkGroupConfiguration": {
	                "type": "boolean"
	              },
	              "ResultConfigurationUpdates": {
	                "type": "structure",
	                "members": {
	                  "OutputLocation": {},
	                  "RemoveOutputLocation": {
	                    "type": "boolean"
	                  },
	                  "EncryptionConfiguration": {
	                    "shape": "Sp"
	                  },
	                  "RemoveEncryptionConfiguration": {
	                    "type": "boolean"
	                  },
	                  "ExpectedBucketOwner": {},
	                  "RemoveExpectedBucketOwner": {
	                    "type": "boolean"
	                  },
	                  "AclConfiguration": {
	                    "shape": "Sr"
	                  },
	                  "RemoveAclConfiguration": {
	                    "type": "boolean"
	                  }
	                }
	              },
	              "PublishCloudWatchMetricsEnabled": {
	                "type": "boolean"
	              },
	              "BytesScannedCutoffPerQuery": {
	                "type": "long"
	              },
	              "RemoveBytesScannedCutoffPerQuery": {
	                "type": "boolean"
	              },
	              "RequesterPaysEnabled": {
	                "type": "boolean"
	              },
	              "EngineVersion": {
	                "shape": "S14"
	              }
	            }
	          },
	          "State": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "list",
	      "member": {}
	    },
	    "S6": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "Database",
	        "QueryString"
	      ],
	      "members": {
	        "Name": {},
	        "Description": {},
	        "Database": {},
	        "QueryString": {},
	        "NamedQueryId": {},
	        "WorkGroup": {}
	      }
	    },
	    "Sh": {
	      "type": "list",
	      "member": {}
	    },
	    "Sl": {
	      "type": "structure",
	      "members": {
	        "QueryExecutionId": {},
	        "Query": {},
	        "StatementType": {},
	        "ResultConfiguration": {
	          "shape": "Sn"
	        },
	        "QueryExecutionContext": {
	          "shape": "St"
	        },
	        "Status": {
	          "type": "structure",
	          "members": {
	            "State": {},
	            "StateChangeReason": {},
	            "SubmissionDateTime": {
	              "type": "timestamp"
	            },
	            "CompletionDateTime": {
	              "type": "timestamp"
	            },
	            "AthenaError": {
	              "type": "structure",
	              "members": {
	                "ErrorCategory": {
	                  "type": "integer"
	                },
	                "ErrorType": {
	                  "type": "integer"
	                },
	                "Retryable": {
	                  "type": "boolean"
	                },
	                "ErrorMessage": {}
	              }
	            }
	          }
	        },
	        "Statistics": {
	          "type": "structure",
	          "members": {
	            "EngineExecutionTimeInMillis": {
	              "type": "long"
	            },
	            "DataScannedInBytes": {
	              "type": "long"
	            },
	            "DataManifestLocation": {},
	            "TotalExecutionTimeInMillis": {
	              "type": "long"
	            },
	            "QueryQueueTimeInMillis": {
	              "type": "long"
	            },
	            "QueryPlanningTimeInMillis": {
	              "type": "long"
	            },
	            "ServiceProcessingTimeInMillis": {
	              "type": "long"
	            }
	          }
	        },
	        "WorkGroup": {},
	        "EngineVersion": {
	          "shape": "S14"
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "members": {
	        "OutputLocation": {},
	        "EncryptionConfiguration": {
	          "shape": "Sp"
	        },
	        "ExpectedBucketOwner": {},
	        "AclConfiguration": {
	          "shape": "Sr"
	        }
	      }
	    },
	    "Sp": {
	      "type": "structure",
	      "required": [
	        "EncryptionOption"
	      ],
	      "members": {
	        "EncryptionOption": {},
	        "KmsKey": {}
	      }
	    },
	    "Sr": {
	      "type": "structure",
	      "required": [
	        "S3AclOption"
	      ],
	      "members": {
	        "S3AclOption": {}
	      }
	    },
	    "St": {
	      "type": "structure",
	      "members": {
	        "Database": {},
	        "Catalog": {}
	      }
	    },
	    "S14": {
	      "type": "structure",
	      "members": {
	        "SelectedEngineVersion": {},
	        "EffectiveEngineVersion": {}
	      }
	    },
	    "S19": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S1c": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S1o": {
	      "type": "structure",
	      "members": {
	        "ResultConfiguration": {
	          "shape": "Sn"
	        },
	        "EnforceWorkGroupConfiguration": {
	          "type": "boolean"
	        },
	        "PublishCloudWatchMetricsEnabled": {
	          "type": "boolean"
	        },
	        "BytesScannedCutoffPerQuery": {
	          "type": "long"
	        },
	        "RequesterPaysEnabled": {
	          "type": "boolean"
	        },
	        "EngineVersion": {
	          "shape": "S14"
	        }
	      }
	    },
	    "S26": {
	      "type": "structure",
	      "required": [
	        "Name"
	      ],
	      "members": {
	        "Name": {},
	        "Description": {},
	        "Parameters": {
	          "shape": "S19"
	        }
	      }
	    },
	    "S2v": {
	      "type": "structure",
	      "required": [
	        "Name"
	      ],
	      "members": {
	        "Name": {},
	        "CreateTime": {
	          "type": "timestamp"
	        },
	        "LastAccessTime": {
	          "type": "timestamp"
	        },
	        "TableType": {},
	        "Columns": {
	          "shape": "S2y"
	        },
	        "PartitionKeys": {
	          "shape": "S2y"
	        },
	        "Parameters": {
	          "shape": "S19"
	        }
	      }
	    },
	    "S2y": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Type": {},
	          "Comment": {}
	        }
	      }
	    }
	  }
	}
	},{}],9:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "GetQueryResults": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListDataCatalogs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "DataCatalogsSummary"
	    },
	    "ListDatabases": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "DatabaseList"
	    },
	    "ListNamedQueries": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListPreparedStatements": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListQueryExecutions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListTableMetadata": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TableMetadataList"
	    },
	    "ListTagsForResource": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Tags"
	    },
	    "ListWorkGroups": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    }
	  }
	}
	},{}],10:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2011-01-01",
	    "endpointPrefix": "autoscaling",
	    "protocol": "query",
	    "serviceFullName": "Auto Scaling",
	    "serviceId": "Auto Scaling",
	    "signatureVersion": "v4",
	    "uid": "autoscaling-2011-01-01",
	    "xmlNamespace": "http://autoscaling.amazonaws.com/doc/2011-01-01/"
	  },
	  "operations": {
	    "AttachInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "S2"
	          },
	          "AutoScalingGroupName": {}
	        }
	      }
	    },
	    "AttachLoadBalancerTargetGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "TargetGroupARNs"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "TargetGroupARNs": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "AttachLoadBalancerTargetGroupsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AttachLoadBalancers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "LoadBalancerNames"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "LoadBalancerNames": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "AttachLoadBalancersResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "BatchDeleteScheduledAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "ScheduledActionNames"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "ScheduledActionNames": {
	            "shape": "Sd"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "BatchDeleteScheduledActionResult",
	        "type": "structure",
	        "members": {
	          "FailedScheduledActions": {
	            "shape": "Sf"
	          }
	        }
	      }
	    },
	    "BatchPutScheduledUpdateGroupAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "ScheduledUpdateGroupActions"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "ScheduledUpdateGroupActions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ScheduledActionName"
	              ],
	              "members": {
	                "ScheduledActionName": {},
	                "StartTime": {
	                  "type": "timestamp"
	                },
	                "EndTime": {
	                  "type": "timestamp"
	                },
	                "Recurrence": {},
	                "MinSize": {
	                  "type": "integer"
	                },
	                "MaxSize": {
	                  "type": "integer"
	                },
	                "DesiredCapacity": {
	                  "type": "integer"
	                },
	                "TimeZone": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "BatchPutScheduledUpdateGroupActionResult",
	        "type": "structure",
	        "members": {
	          "FailedScheduledUpdateGroupActions": {
	            "shape": "Sf"
	          }
	        }
	      }
	    },
	    "CancelInstanceRefresh": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CancelInstanceRefreshResult",
	        "type": "structure",
	        "members": {
	          "InstanceRefreshId": {}
	        }
	      }
	    },
	    "CompleteLifecycleAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LifecycleHookName",
	          "AutoScalingGroupName",
	          "LifecycleActionResult"
	        ],
	        "members": {
	          "LifecycleHookName": {},
	          "AutoScalingGroupName": {},
	          "LifecycleActionToken": {},
	          "LifecycleActionResult": {},
	          "InstanceId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CompleteLifecycleActionResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateAutoScalingGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "MinSize",
	          "MaxSize"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "LaunchConfigurationName": {},
	          "LaunchTemplate": {
	            "shape": "S10"
	          },
	          "MixedInstancesPolicy": {
	            "shape": "S12"
	          },
	          "InstanceId": {},
	          "MinSize": {
	            "type": "integer"
	          },
	          "MaxSize": {
	            "type": "integer"
	          },
	          "DesiredCapacity": {
	            "type": "integer"
	          },
	          "DefaultCooldown": {
	            "type": "integer"
	          },
	          "AvailabilityZones": {
	            "shape": "S26"
	          },
	          "LoadBalancerNames": {
	            "shape": "Sa"
	          },
	          "TargetGroupARNs": {
	            "shape": "S6"
	          },
	          "HealthCheckType": {},
	          "HealthCheckGracePeriod": {
	            "type": "integer"
	          },
	          "PlacementGroup": {},
	          "VPCZoneIdentifier": {},
	          "TerminationPolicies": {
	            "shape": "S29"
	          },
	          "NewInstancesProtectedFromScaleIn": {
	            "type": "boolean"
	          },
	          "CapacityRebalance": {
	            "type": "boolean"
	          },
	          "LifecycleHookSpecificationList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "LifecycleHookName",
	                "LifecycleTransition"
	              ],
	              "members": {
	                "LifecycleHookName": {},
	                "LifecycleTransition": {},
	                "NotificationMetadata": {},
	                "HeartbeatTimeout": {
	                  "type": "integer"
	                },
	                "DefaultResult": {},
	                "NotificationTargetARN": {},
	                "RoleARN": {}
	              }
	            }
	          },
	          "Tags": {
	            "shape": "S2j"
	          },
	          "ServiceLinkedRoleARN": {},
	          "MaxInstanceLifetime": {
	            "type": "integer"
	          },
	          "Context": {},
	          "DesiredCapacityType": {},
	          "DefaultInstanceWarmup": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "CreateLaunchConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LaunchConfigurationName"
	        ],
	        "members": {
	          "LaunchConfigurationName": {},
	          "ImageId": {},
	          "KeyName": {},
	          "SecurityGroups": {
	            "shape": "S2s"
	          },
	          "ClassicLinkVPCId": {},
	          "ClassicLinkVPCSecurityGroups": {
	            "shape": "S2t"
	          },
	          "UserData": {},
	          "InstanceId": {},
	          "InstanceType": {},
	          "KernelId": {},
	          "RamdiskId": {},
	          "BlockDeviceMappings": {
	            "shape": "S2v"
	          },
	          "InstanceMonitoring": {
	            "shape": "S35"
	          },
	          "SpotPrice": {},
	          "IamInstanceProfile": {},
	          "EbsOptimized": {
	            "type": "boolean"
	          },
	          "AssociatePublicIpAddress": {
	            "type": "boolean"
	          },
	          "PlacementTenancy": {},
	          "MetadataOptions": {
	            "shape": "S3a"
	          }
	        }
	      }
	    },
	    "CreateOrUpdateTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "S2j"
	          }
	        }
	      }
	    },
	    "DeleteAutoScalingGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "ForceDelete": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteLaunchConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LaunchConfigurationName"
	        ],
	        "members": {
	          "LaunchConfigurationName": {}
	        }
	      }
	    },
	    "DeleteLifecycleHook": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LifecycleHookName",
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "LifecycleHookName": {},
	          "AutoScalingGroupName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteLifecycleHookResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteNotificationConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "TopicARN"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "TopicARN": {}
	        }
	      }
	    },
	    "DeletePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "PolicyName": {}
	        }
	      }
	    },
	    "DeleteScheduledAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "ScheduledActionName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "ScheduledActionName": {}
	        }
	      }
	    },
	    "DeleteTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "S2j"
	          }
	        }
	      }
	    },
	    "DeleteWarmPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "ForceDelete": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteWarmPoolResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeAccountLimits": {
	      "output": {
	        "resultWrapper": "DescribeAccountLimitsResult",
	        "type": "structure",
	        "members": {
	          "MaxNumberOfAutoScalingGroups": {
	            "type": "integer"
	          },
	          "MaxNumberOfLaunchConfigurations": {
	            "type": "integer"
	          },
	          "NumberOfAutoScalingGroups": {
	            "type": "integer"
	          },
	          "NumberOfLaunchConfigurations": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "DescribeAdjustmentTypes": {
	      "output": {
	        "resultWrapper": "DescribeAdjustmentTypesResult",
	        "type": "structure",
	        "members": {
	          "AdjustmentTypes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AdjustmentType": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeAutoScalingGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AutoScalingGroupNames": {
	            "shape": "S3z"
	          },
	          "NextToken": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "S41"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeAutoScalingGroupsResult",
	        "type": "structure",
	        "required": [
	          "AutoScalingGroups"
	        ],
	        "members": {
	          "AutoScalingGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "AutoScalingGroupName",
	                "MinSize",
	                "MaxSize",
	                "DesiredCapacity",
	                "DefaultCooldown",
	                "AvailabilityZones",
	                "HealthCheckType",
	                "CreatedTime"
	              ],
	              "members": {
	                "AutoScalingGroupName": {},
	                "AutoScalingGroupARN": {},
	                "LaunchConfigurationName": {},
	                "LaunchTemplate": {
	                  "shape": "S10"
	                },
	                "MixedInstancesPolicy": {
	                  "shape": "S12"
	                },
	                "MinSize": {
	                  "type": "integer"
	                },
	                "MaxSize": {
	                  "type": "integer"
	                },
	                "DesiredCapacity": {
	                  "type": "integer"
	                },
	                "PredictedCapacity": {
	                  "type": "integer"
	                },
	                "DefaultCooldown": {
	                  "type": "integer"
	                },
	                "AvailabilityZones": {
	                  "shape": "S26"
	                },
	                "LoadBalancerNames": {
	                  "shape": "Sa"
	                },
	                "TargetGroupARNs": {
	                  "shape": "S6"
	                },
	                "HealthCheckType": {},
	                "HealthCheckGracePeriod": {
	                  "type": "integer"
	                },
	                "Instances": {
	                  "shape": "S48"
	                },
	                "CreatedTime": {
	                  "type": "timestamp"
	                },
	                "SuspendedProcesses": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "ProcessName": {},
	                      "SuspensionReason": {}
	                    }
	                  }
	                },
	                "PlacementGroup": {},
	                "VPCZoneIdentifier": {},
	                "EnabledMetrics": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Metric": {},
	                      "Granularity": {}
	                    }
	                  }
	                },
	                "Status": {},
	                "Tags": {
	                  "shape": "S4f"
	                },
	                "TerminationPolicies": {
	                  "shape": "S29"
	                },
	                "NewInstancesProtectedFromScaleIn": {
	                  "type": "boolean"
	                },
	                "ServiceLinkedRoleARN": {},
	                "MaxInstanceLifetime": {
	                  "type": "integer"
	                },
	                "CapacityRebalance": {
	                  "type": "boolean"
	                },
	                "WarmPoolConfiguration": {
	                  "shape": "S4h"
	                },
	                "WarmPoolSize": {
	                  "type": "integer"
	                },
	                "Context": {},
	                "DesiredCapacityType": {},
	                "DefaultInstanceWarmup": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAutoScalingInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "InstanceIds": {
	            "shape": "S2"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeAutoScalingInstancesResult",
	        "type": "structure",
	        "members": {
	          "AutoScalingInstances": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "InstanceId",
	                "AutoScalingGroupName",
	                "AvailabilityZone",
	                "LifecycleState",
	                "HealthStatus",
	                "ProtectedFromScaleIn"
	              ],
	              "members": {
	                "InstanceId": {},
	                "InstanceType": {},
	                "AutoScalingGroupName": {},
	                "AvailabilityZone": {},
	                "LifecycleState": {},
	                "HealthStatus": {},
	                "LaunchConfigurationName": {},
	                "LaunchTemplate": {
	                  "shape": "S10"
	                },
	                "ProtectedFromScaleIn": {
	                  "type": "boolean"
	                },
	                "WeightedCapacity": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAutoScalingNotificationTypes": {
	      "output": {
	        "resultWrapper": "DescribeAutoScalingNotificationTypesResult",
	        "type": "structure",
	        "members": {
	          "AutoScalingNotificationTypes": {
	            "shape": "S4u"
	          }
	        }
	      }
	    },
	    "DescribeInstanceRefreshes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "InstanceRefreshIds": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeInstanceRefreshesResult",
	        "type": "structure",
	        "members": {
	          "InstanceRefreshes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "InstanceRefreshId": {},
	                "AutoScalingGroupName": {},
	                "Status": {},
	                "StatusReason": {},
	                "StartTime": {
	                  "type": "timestamp"
	                },
	                "EndTime": {
	                  "type": "timestamp"
	                },
	                "PercentageComplete": {
	                  "type": "integer"
	                },
	                "InstancesToUpdate": {
	                  "type": "integer"
	                },
	                "ProgressDetails": {
	                  "type": "structure",
	                  "members": {
	                    "LivePoolProgress": {
	                      "type": "structure",
	                      "members": {
	                        "PercentageComplete": {
	                          "type": "integer"
	                        },
	                        "InstancesToUpdate": {
	                          "type": "integer"
	                        }
	                      }
	                    },
	                    "WarmPoolProgress": {
	                      "type": "structure",
	                      "members": {
	                        "PercentageComplete": {
	                          "type": "integer"
	                        },
	                        "InstancesToUpdate": {
	                          "type": "integer"
	                        }
	                      }
	                    }
	                  }
	                },
	                "Preferences": {
	                  "shape": "S56"
	                },
	                "DesiredConfiguration": {
	                  "shape": "S5c"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeLaunchConfigurations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LaunchConfigurationNames": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeLaunchConfigurationsResult",
	        "type": "structure",
	        "required": [
	          "LaunchConfigurations"
	        ],
	        "members": {
	          "LaunchConfigurations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "LaunchConfigurationName",
	                "ImageId",
	                "InstanceType",
	                "CreatedTime"
	              ],
	              "members": {
	                "LaunchConfigurationName": {},
	                "LaunchConfigurationARN": {},
	                "ImageId": {},
	                "KeyName": {},
	                "SecurityGroups": {
	                  "shape": "S2s"
	                },
	                "ClassicLinkVPCId": {},
	                "ClassicLinkVPCSecurityGroups": {
	                  "shape": "S2t"
	                },
	                "UserData": {},
	                "InstanceType": {},
	                "KernelId": {},
	                "RamdiskId": {},
	                "BlockDeviceMappings": {
	                  "shape": "S2v"
	                },
	                "InstanceMonitoring": {
	                  "shape": "S35"
	                },
	                "SpotPrice": {},
	                "IamInstanceProfile": {},
	                "CreatedTime": {
	                  "type": "timestamp"
	                },
	                "EbsOptimized": {
	                  "type": "boolean"
	                },
	                "AssociatePublicIpAddress": {
	                  "type": "boolean"
	                },
	                "PlacementTenancy": {},
	                "MetadataOptions": {
	                  "shape": "S3a"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeLifecycleHookTypes": {
	      "output": {
	        "resultWrapper": "DescribeLifecycleHookTypesResult",
	        "type": "structure",
	        "members": {
	          "LifecycleHookTypes": {
	            "shape": "S4u"
	          }
	        }
	      }
	    },
	    "DescribeLifecycleHooks": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "LifecycleHookNames": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeLifecycleHooksResult",
	        "type": "structure",
	        "members": {
	          "LifecycleHooks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "LifecycleHookName": {},
	                "AutoScalingGroupName": {},
	                "LifecycleTransition": {},
	                "NotificationTargetARN": {},
	                "RoleARN": {},
	                "NotificationMetadata": {},
	                "HeartbeatTimeout": {
	                  "type": "integer"
	                },
	                "GlobalTimeout": {
	                  "type": "integer"
	                },
	                "DefaultResult": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeLoadBalancerTargetGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "NextToken": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeLoadBalancerTargetGroupsResult",
	        "type": "structure",
	        "members": {
	          "LoadBalancerTargetGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "LoadBalancerTargetGroupARN": {},
	                "State": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeLoadBalancers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "NextToken": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeLoadBalancersResult",
	        "type": "structure",
	        "members": {
	          "LoadBalancers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "LoadBalancerName": {},
	                "State": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMetricCollectionTypes": {
	      "output": {
	        "resultWrapper": "DescribeMetricCollectionTypesResult",
	        "type": "structure",
	        "members": {
	          "Metrics": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Metric": {}
	              }
	            }
	          },
	          "Granularities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Granularity": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeNotificationConfigurations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AutoScalingGroupNames": {
	            "shape": "S3z"
	          },
	          "NextToken": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeNotificationConfigurationsResult",
	        "type": "structure",
	        "required": [
	          "NotificationConfigurations"
	        ],
	        "members": {
	          "NotificationConfigurations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AutoScalingGroupName": {},
	                "TopicARN": {},
	                "NotificationType": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribePolicies": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AutoScalingGroupName": {},
	          "PolicyNames": {
	            "type": "list",
	            "member": {}
	          },
	          "PolicyTypes": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribePoliciesResult",
	        "type": "structure",
	        "members": {
	          "ScalingPolicies": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AutoScalingGroupName": {},
	                "PolicyName": {},
	                "PolicyARN": {},
	                "PolicyType": {},
	                "AdjustmentType": {},
	                "MinAdjustmentStep": {
	                  "shape": "S6c"
	                },
	                "MinAdjustmentMagnitude": {
	                  "type": "integer"
	                },
	                "ScalingAdjustment": {
	                  "type": "integer"
	                },
	                "Cooldown": {
	                  "type": "integer"
	                },
	                "StepAdjustments": {
	                  "shape": "S6f"
	                },
	                "MetricAggregationType": {},
	                "EstimatedInstanceWarmup": {
	                  "type": "integer"
	                },
	                "Alarms": {
	                  "shape": "S6j"
	                },
	                "TargetTrackingConfiguration": {
	                  "shape": "S6l"
	                },
	                "Enabled": {
	                  "type": "boolean"
	                },
	                "PredictiveScalingConfiguration": {
	                  "shape": "S6z"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeScalingActivities": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ActivityIds": {
	            "type": "list",
	            "member": {}
	          },
	          "AutoScalingGroupName": {},
	          "IncludeDeletedGroups": {
	            "type": "boolean"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeScalingActivitiesResult",
	        "type": "structure",
	        "required": [
	          "Activities"
	        ],
	        "members": {
	          "Activities": {
	            "shape": "S7q"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeScalingProcessTypes": {
	      "output": {
	        "resultWrapper": "DescribeScalingProcessTypesResult",
	        "type": "structure",
	        "members": {
	          "Processes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ProcessName"
	              ],
	              "members": {
	                "ProcessName": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeScheduledActions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AutoScalingGroupName": {},
	          "ScheduledActionNames": {
	            "shape": "Sd"
	          },
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "NextToken": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeScheduledActionsResult",
	        "type": "structure",
	        "members": {
	          "ScheduledUpdateGroupActions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AutoScalingGroupName": {},
	                "ScheduledActionName": {},
	                "ScheduledActionARN": {},
	                "Time": {
	                  "type": "timestamp"
	                },
	                "StartTime": {
	                  "type": "timestamp"
	                },
	                "EndTime": {
	                  "type": "timestamp"
	                },
	                "Recurrence": {},
	                "MinSize": {
	                  "type": "integer"
	                },
	                "MaxSize": {
	                  "type": "integer"
	                },
	                "DesiredCapacity": {
	                  "type": "integer"
	                },
	                "TimeZone": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeTags": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "S41"
	          },
	          "NextToken": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeTagsResult",
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S4f"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeTerminationPolicyTypes": {
	      "output": {
	        "resultWrapper": "DescribeTerminationPolicyTypesResult",
	        "type": "structure",
	        "members": {
	          "TerminationPolicyTypes": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "DescribeWarmPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeWarmPoolResult",
	        "type": "structure",
	        "members": {
	          "WarmPoolConfiguration": {
	            "shape": "S4h"
	          },
	          "Instances": {
	            "shape": "S48"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DetachInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "ShouldDecrementDesiredCapacity"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "S2"
	          },
	          "AutoScalingGroupName": {},
	          "ShouldDecrementDesiredCapacity": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DetachInstancesResult",
	        "type": "structure",
	        "members": {
	          "Activities": {
	            "shape": "S7q"
	          }
	        }
	      }
	    },
	    "DetachLoadBalancerTargetGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "TargetGroupARNs"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "TargetGroupARNs": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DetachLoadBalancerTargetGroupsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DetachLoadBalancers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "LoadBalancerNames"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "LoadBalancerNames": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DetachLoadBalancersResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DisableMetricsCollection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "Metrics": {
	            "shape": "S8f"
	          }
	        }
	      }
	    },
	    "EnableMetricsCollection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "Granularity"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "Metrics": {
	            "shape": "S8f"
	          },
	          "Granularity": {}
	        }
	      }
	    },
	    "EnterStandby": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "ShouldDecrementDesiredCapacity"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "S2"
	          },
	          "AutoScalingGroupName": {},
	          "ShouldDecrementDesiredCapacity": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "EnterStandbyResult",
	        "type": "structure",
	        "members": {
	          "Activities": {
	            "shape": "S7q"
	          }
	        }
	      }
	    },
	    "ExecutePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "PolicyName": {},
	          "HonorCooldown": {
	            "type": "boolean"
	          },
	          "MetricValue": {
	            "type": "double"
	          },
	          "BreachThreshold": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "ExitStandby": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "S2"
	          },
	          "AutoScalingGroupName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ExitStandbyResult",
	        "type": "structure",
	        "members": {
	          "Activities": {
	            "shape": "S7q"
	          }
	        }
	      }
	    },
	    "GetPredictiveScalingForecast": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "PolicyName",
	          "StartTime",
	          "EndTime"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "PolicyName": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetPredictiveScalingForecastResult",
	        "type": "structure",
	        "required": [
	          "LoadForecast",
	          "CapacityForecast",
	          "UpdateTime"
	        ],
	        "members": {
	          "LoadForecast": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Timestamps",
	                "Values",
	                "MetricSpecification"
	              ],
	              "members": {
	                "Timestamps": {
	                  "shape": "S8r"
	                },
	                "Values": {
	                  "shape": "S8s"
	                },
	                "MetricSpecification": {
	                  "shape": "S71"
	                }
	              }
	            }
	          },
	          "CapacityForecast": {
	            "type": "structure",
	            "required": [
	              "Timestamps",
	              "Values"
	            ],
	            "members": {
	              "Timestamps": {
	                "shape": "S8r"
	              },
	              "Values": {
	                "shape": "S8s"
	              }
	            }
	          },
	          "UpdateTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "PutLifecycleHook": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LifecycleHookName",
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "LifecycleHookName": {},
	          "AutoScalingGroupName": {},
	          "LifecycleTransition": {},
	          "RoleARN": {},
	          "NotificationTargetARN": {},
	          "NotificationMetadata": {},
	          "HeartbeatTimeout": {
	            "type": "integer"
	          },
	          "DefaultResult": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "PutLifecycleHookResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "PutNotificationConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "TopicARN",
	          "NotificationTypes"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "TopicARN": {},
	          "NotificationTypes": {
	            "shape": "S4u"
	          }
	        }
	      }
	    },
	    "PutScalingPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "PolicyName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "PolicyName": {},
	          "PolicyType": {},
	          "AdjustmentType": {},
	          "MinAdjustmentStep": {
	            "shape": "S6c"
	          },
	          "MinAdjustmentMagnitude": {
	            "type": "integer"
	          },
	          "ScalingAdjustment": {
	            "type": "integer"
	          },
	          "Cooldown": {
	            "type": "integer"
	          },
	          "MetricAggregationType": {},
	          "StepAdjustments": {
	            "shape": "S6f"
	          },
	          "EstimatedInstanceWarmup": {
	            "type": "integer"
	          },
	          "TargetTrackingConfiguration": {
	            "shape": "S6l"
	          },
	          "Enabled": {
	            "type": "boolean"
	          },
	          "PredictiveScalingConfiguration": {
	            "shape": "S6z"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PutScalingPolicyResult",
	        "type": "structure",
	        "members": {
	          "PolicyARN": {},
	          "Alarms": {
	            "shape": "S6j"
	          }
	        }
	      }
	    },
	    "PutScheduledUpdateGroupAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "ScheduledActionName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "ScheduledActionName": {},
	          "Time": {
	            "type": "timestamp"
	          },
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Recurrence": {},
	          "MinSize": {
	            "type": "integer"
	          },
	          "MaxSize": {
	            "type": "integer"
	          },
	          "DesiredCapacity": {
	            "type": "integer"
	          },
	          "TimeZone": {}
	        }
	      }
	    },
	    "PutWarmPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "MaxGroupPreparedCapacity": {
	            "type": "integer"
	          },
	          "MinSize": {
	            "type": "integer"
	          },
	          "PoolState": {},
	          "InstanceReusePolicy": {
	            "shape": "S4m"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PutWarmPoolResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RecordLifecycleActionHeartbeat": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LifecycleHookName",
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "LifecycleHookName": {},
	          "AutoScalingGroupName": {},
	          "LifecycleActionToken": {},
	          "InstanceId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RecordLifecycleActionHeartbeatResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ResumeProcesses": {
	      "input": {
	        "shape": "S94"
	      }
	    },
	    "SetDesiredCapacity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName",
	          "DesiredCapacity"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "DesiredCapacity": {
	            "type": "integer"
	          },
	          "HonorCooldown": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "SetInstanceHealth": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "HealthStatus"
	        ],
	        "members": {
	          "InstanceId": {},
	          "HealthStatus": {},
	          "ShouldRespectGracePeriod": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "SetInstanceProtection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceIds",
	          "AutoScalingGroupName",
	          "ProtectedFromScaleIn"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "S2"
	          },
	          "AutoScalingGroupName": {},
	          "ProtectedFromScaleIn": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SetInstanceProtectionResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "StartInstanceRefresh": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "Strategy": {},
	          "DesiredConfiguration": {
	            "shape": "S5c"
	          },
	          "Preferences": {
	            "shape": "S56"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "StartInstanceRefreshResult",
	        "type": "structure",
	        "members": {
	          "InstanceRefreshId": {}
	        }
	      }
	    },
	    "SuspendProcesses": {
	      "input": {
	        "shape": "S94"
	      }
	    },
	    "TerminateInstanceInAutoScalingGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ShouldDecrementDesiredCapacity"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ShouldDecrementDesiredCapacity": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "TerminateInstanceInAutoScalingGroupResult",
	        "type": "structure",
	        "members": {
	          "Activity": {
	            "shape": "S7r"
	          }
	        }
	      }
	    },
	    "UpdateAutoScalingGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutoScalingGroupName"
	        ],
	        "members": {
	          "AutoScalingGroupName": {},
	          "LaunchConfigurationName": {},
	          "LaunchTemplate": {
	            "shape": "S10"
	          },
	          "MixedInstancesPolicy": {
	            "shape": "S12"
	          },
	          "MinSize": {
	            "type": "integer"
	          },
	          "MaxSize": {
	            "type": "integer"
	          },
	          "DesiredCapacity": {
	            "type": "integer"
	          },
	          "DefaultCooldown": {
	            "type": "integer"
	          },
	          "AvailabilityZones": {
	            "shape": "S26"
	          },
	          "HealthCheckType": {},
	          "HealthCheckGracePeriod": {
	            "type": "integer"
	          },
	          "PlacementGroup": {},
	          "VPCZoneIdentifier": {},
	          "TerminationPolicies": {
	            "shape": "S29"
	          },
	          "NewInstancesProtectedFromScaleIn": {
	            "type": "boolean"
	          },
	          "ServiceLinkedRoleARN": {},
	          "MaxInstanceLifetime": {
	            "type": "integer"
	          },
	          "CapacityRebalance": {
	            "type": "boolean"
	          },
	          "Context": {},
	          "DesiredCapacityType": {},
	          "DefaultInstanceWarmup": {
	            "type": "integer"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "list",
	      "member": {}
	    },
	    "S6": {
	      "type": "list",
	      "member": {}
	    },
	    "Sa": {
	      "type": "list",
	      "member": {}
	    },
	    "Sd": {
	      "type": "list",
	      "member": {}
	    },
	    "Sf": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "ScheduledActionName"
	        ],
	        "members": {
	          "ScheduledActionName": {},
	          "ErrorCode": {},
	          "ErrorMessage": {}
	        }
	      }
	    },
	    "S10": {
	      "type": "structure",
	      "members": {
	        "LaunchTemplateId": {},
	        "LaunchTemplateName": {},
	        "Version": {}
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "members": {
	        "LaunchTemplate": {
	          "type": "structure",
	          "members": {
	            "LaunchTemplateSpecification": {
	              "shape": "S10"
	            },
	            "Overrides": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "InstanceType": {},
	                  "WeightedCapacity": {},
	                  "LaunchTemplateSpecification": {
	                    "shape": "S10"
	                  },
	                  "InstanceRequirements": {
	                    "type": "structure",
	                    "required": [
	                      "VCpuCount",
	                      "MemoryMiB"
	                    ],
	                    "members": {
	                      "VCpuCount": {
	                        "type": "structure",
	                        "required": [
	                          "Min"
	                        ],
	                        "members": {
	                          "Min": {
	                            "type": "integer"
	                          },
	                          "Max": {
	                            "type": "integer"
	                          }
	                        }
	                      },
	                      "MemoryMiB": {
	                        "type": "structure",
	                        "required": [
	                          "Min"
	                        ],
	                        "members": {
	                          "Min": {
	                            "type": "integer"
	                          },
	                          "Max": {
	                            "type": "integer"
	                          }
	                        }
	                      },
	                      "CpuManufacturers": {
	                        "type": "list",
	                        "member": {}
	                      },
	                      "MemoryGiBPerVCpu": {
	                        "type": "structure",
	                        "members": {
	                          "Min": {
	                            "type": "double"
	                          },
	                          "Max": {
	                            "type": "double"
	                          }
	                        }
	                      },
	                      "ExcludedInstanceTypes": {
	                        "type": "list",
	                        "member": {}
	                      },
	                      "InstanceGenerations": {
	                        "type": "list",
	                        "member": {}
	                      },
	                      "SpotMaxPricePercentageOverLowestPrice": {
	                        "type": "integer"
	                      },
	                      "OnDemandMaxPricePercentageOverLowestPrice": {
	                        "type": "integer"
	                      },
	                      "BareMetal": {},
	                      "BurstablePerformance": {},
	                      "RequireHibernateSupport": {
	                        "type": "boolean"
	                      },
	                      "NetworkInterfaceCount": {
	                        "type": "structure",
	                        "members": {
	                          "Min": {
	                            "type": "integer"
	                          },
	                          "Max": {
	                            "type": "integer"
	                          }
	                        }
	                      },
	                      "LocalStorage": {},
	                      "LocalStorageTypes": {
	                        "type": "list",
	                        "member": {}
	                      },
	                      "TotalLocalStorageGB": {
	                        "type": "structure",
	                        "members": {
	                          "Min": {
	                            "type": "double"
	                          },
	                          "Max": {
	                            "type": "double"
	                          }
	                        }
	                      },
	                      "BaselineEbsBandwidthMbps": {
	                        "type": "structure",
	                        "members": {
	                          "Min": {
	                            "type": "integer"
	                          },
	                          "Max": {
	                            "type": "integer"
	                          }
	                        }
	                      },
	                      "AcceleratorTypes": {
	                        "type": "list",
	                        "member": {}
	                      },
	                      "AcceleratorCount": {
	                        "type": "structure",
	                        "members": {
	                          "Min": {
	                            "type": "integer"
	                          },
	                          "Max": {
	                            "type": "integer"
	                          }
	                        }
	                      },
	                      "AcceleratorManufacturers": {
	                        "type": "list",
	                        "member": {}
	                      },
	                      "AcceleratorNames": {
	                        "type": "list",
	                        "member": {}
	                      },
	                      "AcceleratorTotalMemoryMiB": {
	                        "type": "structure",
	                        "members": {
	                          "Min": {
	                            "type": "integer"
	                          },
	                          "Max": {
	                            "type": "integer"
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "InstancesDistribution": {
	          "type": "structure",
	          "members": {
	            "OnDemandAllocationStrategy": {},
	            "OnDemandBaseCapacity": {
	              "type": "integer"
	            },
	            "OnDemandPercentageAboveBaseCapacity": {
	              "type": "integer"
	            },
	            "SpotAllocationStrategy": {},
	            "SpotInstancePools": {
	              "type": "integer"
	            },
	            "SpotMaxPrice": {}
	          }
	        }
	      }
	    },
	    "S26": {
	      "type": "list",
	      "member": {}
	    },
	    "S29": {
	      "type": "list",
	      "member": {}
	    },
	    "S2j": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key"
	        ],
	        "members": {
	          "ResourceId": {},
	          "ResourceType": {},
	          "Key": {},
	          "Value": {},
	          "PropagateAtLaunch": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S2s": {
	      "type": "list",
	      "member": {}
	    },
	    "S2t": {
	      "type": "list",
	      "member": {}
	    },
	    "S2v": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "DeviceName"
	        ],
	        "members": {
	          "VirtualName": {},
	          "DeviceName": {},
	          "Ebs": {
	            "type": "structure",
	            "members": {
	              "SnapshotId": {},
	              "VolumeSize": {
	                "type": "integer"
	              },
	              "VolumeType": {},
	              "DeleteOnTermination": {
	                "type": "boolean"
	              },
	              "Iops": {
	                "type": "integer"
	              },
	              "Encrypted": {
	                "type": "boolean"
	              },
	              "Throughput": {
	                "type": "integer"
	              }
	            }
	          },
	          "NoDevice": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S35": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S3a": {
	      "type": "structure",
	      "members": {
	        "HttpTokens": {},
	        "HttpPutResponseHopLimit": {
	          "type": "integer"
	        },
	        "HttpEndpoint": {}
	      }
	    },
	    "S3z": {
	      "type": "list",
	      "member": {}
	    },
	    "S41": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Values": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "S48": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "AvailabilityZone",
	          "LifecycleState",
	          "HealthStatus",
	          "ProtectedFromScaleIn"
	        ],
	        "members": {
	          "InstanceId": {},
	          "InstanceType": {},
	          "AvailabilityZone": {},
	          "LifecycleState": {},
	          "HealthStatus": {},
	          "LaunchConfigurationName": {},
	          "LaunchTemplate": {
	            "shape": "S10"
	          },
	          "ProtectedFromScaleIn": {
	            "type": "boolean"
	          },
	          "WeightedCapacity": {}
	        }
	      }
	    },
	    "S4f": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ResourceId": {},
	          "ResourceType": {},
	          "Key": {},
	          "Value": {},
	          "PropagateAtLaunch": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S4h": {
	      "type": "structure",
	      "members": {
	        "MaxGroupPreparedCapacity": {
	          "type": "integer"
	        },
	        "MinSize": {
	          "type": "integer"
	        },
	        "PoolState": {},
	        "Status": {},
	        "InstanceReusePolicy": {
	          "shape": "S4m"
	        }
	      }
	    },
	    "S4m": {
	      "type": "structure",
	      "members": {
	        "ReuseOnScaleIn": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S4u": {
	      "type": "list",
	      "member": {}
	    },
	    "S56": {
	      "type": "structure",
	      "members": {
	        "MinHealthyPercentage": {
	          "type": "integer"
	        },
	        "InstanceWarmup": {
	          "type": "integer"
	        },
	        "CheckpointPercentages": {
	          "type": "list",
	          "member": {
	            "type": "integer"
	          }
	        },
	        "CheckpointDelay": {
	          "type": "integer"
	        },
	        "SkipMatching": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S5c": {
	      "type": "structure",
	      "members": {
	        "LaunchTemplate": {
	          "shape": "S10"
	        },
	        "MixedInstancesPolicy": {
	          "shape": "S12"
	        }
	      }
	    },
	    "S6c": {
	      "type": "integer",
	      "deprecated": true
	    },
	    "S6f": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "ScalingAdjustment"
	        ],
	        "members": {
	          "MetricIntervalLowerBound": {
	            "type": "double"
	          },
	          "MetricIntervalUpperBound": {
	            "type": "double"
	          },
	          "ScalingAdjustment": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S6j": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "AlarmName": {},
	          "AlarmARN": {}
	        }
	      }
	    },
	    "S6l": {
	      "type": "structure",
	      "required": [
	        "TargetValue"
	      ],
	      "members": {
	        "PredefinedMetricSpecification": {
	          "type": "structure",
	          "required": [
	            "PredefinedMetricType"
	          ],
	          "members": {
	            "PredefinedMetricType": {},
	            "ResourceLabel": {}
	          }
	        },
	        "CustomizedMetricSpecification": {
	          "type": "structure",
	          "required": [
	            "MetricName",
	            "Namespace",
	            "Statistic"
	          ],
	          "members": {
	            "MetricName": {},
	            "Namespace": {},
	            "Dimensions": {
	              "shape": "S6r"
	            },
	            "Statistic": {},
	            "Unit": {}
	          }
	        },
	        "TargetValue": {
	          "type": "double"
	        },
	        "DisableScaleIn": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S6r": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Value"
	        ],
	        "members": {
	          "Name": {},
	          "Value": {}
	        }
	      }
	    },
	    "S6z": {
	      "type": "structure",
	      "required": [
	        "MetricSpecifications"
	      ],
	      "members": {
	        "MetricSpecifications": {
	          "type": "list",
	          "member": {
	            "shape": "S71"
	          }
	        },
	        "Mode": {},
	        "SchedulingBufferTime": {
	          "type": "integer"
	        },
	        "MaxCapacityBreachBehavior": {},
	        "MaxCapacityBuffer": {
	          "type": "integer"
	        }
	      }
	    },
	    "S71": {
	      "type": "structure",
	      "required": [
	        "TargetValue"
	      ],
	      "members": {
	        "TargetValue": {
	          "type": "double"
	        },
	        "PredefinedMetricPairSpecification": {
	          "type": "structure",
	          "required": [
	            "PredefinedMetricType"
	          ],
	          "members": {
	            "PredefinedMetricType": {},
	            "ResourceLabel": {}
	          }
	        },
	        "PredefinedScalingMetricSpecification": {
	          "type": "structure",
	          "required": [
	            "PredefinedMetricType"
	          ],
	          "members": {
	            "PredefinedMetricType": {},
	            "ResourceLabel": {}
	          }
	        },
	        "PredefinedLoadMetricSpecification": {
	          "type": "structure",
	          "required": [
	            "PredefinedMetricType"
	          ],
	          "members": {
	            "PredefinedMetricType": {},
	            "ResourceLabel": {}
	          }
	        },
	        "CustomizedScalingMetricSpecification": {
	          "type": "structure",
	          "required": [
	            "MetricDataQueries"
	          ],
	          "members": {
	            "MetricDataQueries": {
	              "shape": "S79"
	            }
	          }
	        },
	        "CustomizedLoadMetricSpecification": {
	          "type": "structure",
	          "required": [
	            "MetricDataQueries"
	          ],
	          "members": {
	            "MetricDataQueries": {
	              "shape": "S79"
	            }
	          }
	        },
	        "CustomizedCapacityMetricSpecification": {
	          "type": "structure",
	          "required": [
	            "MetricDataQueries"
	          ],
	          "members": {
	            "MetricDataQueries": {
	              "shape": "S79"
	            }
	          }
	        }
	      }
	    },
	    "S79": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {},
	          "Expression": {},
	          "MetricStat": {
	            "type": "structure",
	            "required": [
	              "Metric",
	              "Stat"
	            ],
	            "members": {
	              "Metric": {
	                "type": "structure",
	                "required": [
	                  "Namespace",
	                  "MetricName"
	                ],
	                "members": {
	                  "Namespace": {},
	                  "MetricName": {},
	                  "Dimensions": {
	                    "shape": "S6r"
	                  }
	                }
	              },
	              "Stat": {},
	              "Unit": {}
	            }
	          },
	          "Label": {},
	          "ReturnData": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S7q": {
	      "type": "list",
	      "member": {
	        "shape": "S7r"
	      }
	    },
	    "S7r": {
	      "type": "structure",
	      "required": [
	        "ActivityId",
	        "AutoScalingGroupName",
	        "Cause",
	        "StartTime",
	        "StatusCode"
	      ],
	      "members": {
	        "ActivityId": {},
	        "AutoScalingGroupName": {},
	        "Description": {},
	        "Cause": {},
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "StatusCode": {},
	        "StatusMessage": {},
	        "Progress": {
	          "type": "integer"
	        },
	        "Details": {},
	        "AutoScalingGroupState": {},
	        "AutoScalingGroupARN": {}
	      }
	    },
	    "S8f": {
	      "type": "list",
	      "member": {}
	    },
	    "S8r": {
	      "type": "list",
	      "member": {
	        "type": "timestamp"
	      }
	    },
	    "S8s": {
	      "type": "list",
	      "member": {
	        "type": "double"
	      }
	    },
	    "S94": {
	      "type": "structure",
	      "required": [
	        "AutoScalingGroupName"
	      ],
	      "members": {
	        "AutoScalingGroupName": {},
	        "ScalingProcesses": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    }
	  }
	}
	},{}],11:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeAutoScalingGroups": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": "AutoScalingGroups"
	    },
	    "DescribeAutoScalingInstances": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": "AutoScalingInstances"
	    },
	    "DescribeLaunchConfigurations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": "LaunchConfigurations"
	    },
	    "DescribeNotificationConfigurations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": "NotificationConfigurations"
	    },
	    "DescribePolicies": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": "ScalingPolicies"
	    },
	    "DescribeScalingActivities": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": "Activities"
	    },
	    "DescribeScheduledActions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": "ScheduledUpdateGroupActions"
	    },
	    "DescribeTags": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": "Tags"
	    }
	  }
	}
	},{}],12:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-10-25",
	    "endpointPrefix": "ce",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "AWS Cost Explorer",
	    "serviceFullName": "AWS Cost Explorer Service",
	    "serviceId": "Cost Explorer",
	    "signatureVersion": "v4",
	    "signingName": "ce",
	    "targetPrefix": "AWSInsightsIndexService",
	    "uid": "ce-2017-10-25"
	  },
	  "operations": {
	    "CreateAnomalyMonitor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AnomalyMonitor"
	        ],
	        "members": {
	          "AnomalyMonitor": {
	            "shape": "S2"
	          },
	          "ResourceTags": {
	            "shape": "Sk"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "MonitorArn"
	        ],
	        "members": {
	          "MonitorArn": {}
	        }
	      }
	    },
	    "CreateAnomalySubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AnomalySubscription"
	        ],
	        "members": {
	          "AnomalySubscription": {
	            "shape": "Sq"
	          },
	          "ResourceTags": {
	            "shape": "Sk"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "SubscriptionArn"
	        ],
	        "members": {
	          "SubscriptionArn": {}
	        }
	      }
	    },
	    "CreateCostCategoryDefinition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "RuleVersion",
	          "Rules"
	        ],
	        "members": {
	          "Name": {},
	          "RuleVersion": {},
	          "Rules": {
	            "shape": "S13"
	          },
	          "DefaultValue": {},
	          "SplitChargeRules": {
	            "shape": "S19"
	          },
	          "ResourceTags": {
	            "shape": "Sk"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CostCategoryArn": {},
	          "EffectiveStart": {}
	        }
	      }
	    },
	    "DeleteAnomalyMonitor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MonitorArn"
	        ],
	        "members": {
	          "MonitorArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteAnomalySubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionArn"
	        ],
	        "members": {
	          "SubscriptionArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteCostCategoryDefinition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CostCategoryArn"
	        ],
	        "members": {
	          "CostCategoryArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CostCategoryArn": {},
	          "EffectiveEnd": {}
	        }
	      }
	    },
	    "DescribeCostCategoryDefinition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CostCategoryArn"
	        ],
	        "members": {
	          "CostCategoryArn": {},
	          "EffectiveOn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CostCategory": {
	            "type": "structure",
	            "required": [
	              "CostCategoryArn",
	              "EffectiveStart",
	              "Name",
	              "RuleVersion",
	              "Rules"
	            ],
	            "members": {
	              "CostCategoryArn": {},
	              "EffectiveStart": {},
	              "EffectiveEnd": {},
	              "Name": {},
	              "RuleVersion": {},
	              "Rules": {
	                "shape": "S13"
	              },
	              "SplitChargeRules": {
	                "shape": "S19"
	              },
	              "ProcessingStatus": {
	                "shape": "S1s"
	              },
	              "DefaultValue": {}
	            }
	          }
	        }
	      }
	    },
	    "GetAnomalies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DateInterval"
	        ],
	        "members": {
	          "MonitorArn": {},
	          "DateInterval": {
	            "type": "structure",
	            "required": [
	              "StartDate"
	            ],
	            "members": {
	              "StartDate": {},
	              "EndDate": {}
	            }
	          },
	          "Feedback": {},
	          "TotalImpact": {
	            "type": "structure",
	            "required": [
	              "NumericOperator",
	              "StartValue"
	            ],
	            "members": {
	              "NumericOperator": {},
	              "StartValue": {
	                "type": "double"
	              },
	              "EndValue": {
	                "type": "double"
	              }
	            }
	          },
	          "NextPageToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Anomalies"
	        ],
	        "members": {
	          "Anomalies": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "AnomalyId",
	                "AnomalyScore",
	                "Impact",
	                "MonitorArn"
	              ],
	              "members": {
	                "AnomalyId": {},
	                "AnomalyStartDate": {},
	                "AnomalyEndDate": {},
	                "DimensionValue": {},
	                "RootCauses": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Service": {},
	                      "Region": {},
	                      "LinkedAccount": {},
	                      "UsageType": {}
	                    }
	                  }
	                },
	                "AnomalyScore": {
	                  "type": "structure",
	                  "required": [
	                    "MaxScore",
	                    "CurrentScore"
	                  ],
	                  "members": {
	                    "MaxScore": {
	                      "type": "double"
	                    },
	                    "CurrentScore": {
	                      "type": "double"
	                    }
	                  }
	                },
	                "Impact": {
	                  "type": "structure",
	                  "required": [
	                    "MaxImpact"
	                  ],
	                  "members": {
	                    "MaxImpact": {
	                      "type": "double"
	                    },
	                    "TotalImpact": {
	                      "type": "double"
	                    }
	                  }
	                },
	                "MonitorArn": {},
	                "Feedback": {}
	              }
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "GetAnomalyMonitors": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "MonitorArnList": {
	            "shape": "Sb"
	          },
	          "NextPageToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "AnomalyMonitors"
	        ],
	        "members": {
	          "AnomalyMonitors": {
	            "type": "list",
	            "member": {
	              "shape": "S2"
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "GetAnomalySubscriptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SubscriptionArnList": {
	            "shape": "Sb"
	          },
	          "MonitorArn": {},
	          "NextPageToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "AnomalySubscriptions"
	        ],
	        "members": {
	          "AnomalySubscriptions": {
	            "type": "list",
	            "member": {
	              "shape": "Sq"
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "GetCostAndUsage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod",
	          "Granularity",
	          "Metrics"
	        ],
	        "members": {
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "Granularity": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "Metrics": {
	            "shape": "S2k"
	          },
	          "GroupBy": {
	            "shape": "S2m"
	          },
	          "NextPageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextPageToken": {},
	          "GroupDefinitions": {
	            "shape": "S2m"
	          },
	          "ResultsByTime": {
	            "shape": "S2r"
	          },
	          "DimensionValueAttributes": {
	            "shape": "S32"
	          }
	        }
	      }
	    },
	    "GetCostAndUsageWithResources": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod",
	          "Granularity",
	          "Filter"
	        ],
	        "members": {
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "Granularity": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "Metrics": {
	            "shape": "S2k"
	          },
	          "GroupBy": {
	            "shape": "S2m"
	          },
	          "NextPageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextPageToken": {},
	          "GroupDefinitions": {
	            "shape": "S2m"
	          },
	          "ResultsByTime": {
	            "shape": "S2r"
	          },
	          "DimensionValueAttributes": {
	            "shape": "S32"
	          }
	        }
	      }
	    },
	    "GetCostCategories": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod"
	        ],
	        "members": {
	          "SearchString": {},
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "CostCategoryName": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "SortBy": {
	            "shape": "S3b"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextPageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ReturnSize",
	          "TotalSize"
	        ],
	        "members": {
	          "NextPageToken": {},
	          "CostCategoryNames": {
	            "type": "list",
	            "member": {}
	          },
	          "CostCategoryValues": {
	            "shape": "S3i"
	          },
	          "ReturnSize": {
	            "type": "integer"
	          },
	          "TotalSize": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "GetCostForecast": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod",
	          "Metric",
	          "Granularity"
	        ],
	        "members": {
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "Metric": {},
	          "Granularity": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "PredictionIntervalLevel": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Total": {
	            "shape": "S2u"
	          },
	          "ForecastResultsByTime": {
	            "shape": "S3n"
	          }
	        }
	      }
	    },
	    "GetDimensionValues": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod",
	          "Dimension"
	        ],
	        "members": {
	          "SearchString": {},
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "Dimension": {},
	          "Context": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "SortBy": {
	            "shape": "S3b"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextPageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "DimensionValues",
	          "ReturnSize",
	          "TotalSize"
	        ],
	        "members": {
	          "DimensionValues": {
	            "shape": "S32"
	          },
	          "ReturnSize": {
	            "type": "integer"
	          },
	          "TotalSize": {
	            "type": "integer"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "GetReservationCoverage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod"
	        ],
	        "members": {
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "GroupBy": {
	            "shape": "S2m"
	          },
	          "Granularity": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "Metrics": {
	            "shape": "S2k"
	          },
	          "NextPageToken": {},
	          "SortBy": {
	            "shape": "S3c"
	          },
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CoveragesByTime"
	        ],
	        "members": {
	          "CoveragesByTime": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TimePeriod": {
	                  "shape": "S2i"
	                },
	                "Groups": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Attributes": {
	                        "shape": "S34"
	                      },
	                      "Coverage": {
	                        "shape": "S3y"
	                      }
	                    }
	                  }
	                },
	                "Total": {
	                  "shape": "S3y"
	                }
	              }
	            }
	          },
	          "Total": {
	            "shape": "S3y"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "GetReservationPurchaseRecommendation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Service"
	        ],
	        "members": {
	          "AccountId": {},
	          "Service": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "AccountScope": {},
	          "LookbackPeriodInDays": {},
	          "TermInYears": {},
	          "PaymentOption": {},
	          "ServiceSpecification": {
	            "shape": "S4g"
	          },
	          "PageSize": {
	            "type": "integer"
	          },
	          "NextPageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Metadata": {
	            "type": "structure",
	            "members": {
	              "RecommendationId": {},
	              "GenerationTimestamp": {}
	            }
	          },
	          "Recommendations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AccountScope": {},
	                "LookbackPeriodInDays": {},
	                "TermInYears": {},
	                "PaymentOption": {},
	                "ServiceSpecification": {
	                  "shape": "S4g"
	                },
	                "RecommendationDetails": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "AccountId": {},
	                      "InstanceDetails": {
	                        "type": "structure",
	                        "members": {
	                          "EC2InstanceDetails": {
	                            "type": "structure",
	                            "members": {
	                              "Family": {},
	                              "InstanceType": {},
	                              "Region": {},
	                              "AvailabilityZone": {},
	                              "Platform": {},
	                              "Tenancy": {},
	                              "CurrentGeneration": {
	                                "type": "boolean"
	                              },
	                              "SizeFlexEligible": {
	                                "type": "boolean"
	                              }
	                            }
	                          },
	                          "RDSInstanceDetails": {
	                            "type": "structure",
	                            "members": {
	                              "Family": {},
	                              "InstanceType": {},
	                              "Region": {},
	                              "DatabaseEngine": {},
	                              "DatabaseEdition": {},
	                              "DeploymentOption": {},
	                              "LicenseModel": {},
	                              "CurrentGeneration": {
	                                "type": "boolean"
	                              },
	                              "SizeFlexEligible": {
	                                "type": "boolean"
	                              }
	                            }
	                          },
	                          "RedshiftInstanceDetails": {
	                            "type": "structure",
	                            "members": {
	                              "Family": {},
	                              "NodeType": {},
	                              "Region": {},
	                              "CurrentGeneration": {
	                                "type": "boolean"
	                              },
	                              "SizeFlexEligible": {
	                                "type": "boolean"
	                              }
	                            }
	                          },
	                          "ElastiCacheInstanceDetails": {
	                            "type": "structure",
	                            "members": {
	                              "Family": {},
	                              "NodeType": {},
	                              "Region": {},
	                              "ProductDescription": {},
	                              "CurrentGeneration": {
	                                "type": "boolean"
	                              },
	                              "SizeFlexEligible": {
	                                "type": "boolean"
	                              }
	                            }
	                          },
	                          "ESInstanceDetails": {
	                            "type": "structure",
	                            "members": {
	                              "InstanceClass": {},
	                              "InstanceSize": {},
	                              "Region": {},
	                              "CurrentGeneration": {
	                                "type": "boolean"
	                              },
	                              "SizeFlexEligible": {
	                                "type": "boolean"
	                              }
	                            }
	                          }
	                        }
	                      },
	                      "RecommendedNumberOfInstancesToPurchase": {},
	                      "RecommendedNormalizedUnitsToPurchase": {},
	                      "MinimumNumberOfInstancesUsedPerHour": {},
	                      "MinimumNormalizedUnitsUsedPerHour": {},
	                      "MaximumNumberOfInstancesUsedPerHour": {},
	                      "MaximumNormalizedUnitsUsedPerHour": {},
	                      "AverageNumberOfInstancesUsedPerHour": {},
	                      "AverageNormalizedUnitsUsedPerHour": {},
	                      "AverageUtilization": {},
	                      "EstimatedBreakEvenInMonths": {},
	                      "CurrencyCode": {},
	                      "EstimatedMonthlySavingsAmount": {},
	                      "EstimatedMonthlySavingsPercentage": {},
	                      "EstimatedMonthlyOnDemandCost": {},
	                      "EstimatedReservationCostForLookbackPeriod": {},
	                      "UpfrontCost": {},
	                      "RecurringStandardMonthlyCost": {}
	                    }
	                  }
	                },
	                "RecommendationSummary": {
	                  "type": "structure",
	                  "members": {
	                    "TotalEstimatedMonthlySavingsAmount": {},
	                    "TotalEstimatedMonthlySavingsPercentage": {},
	                    "CurrencyCode": {}
	                  }
	                }
	              }
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "GetReservationUtilization": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod"
	        ],
	        "members": {
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "GroupBy": {
	            "shape": "S2m"
	          },
	          "Granularity": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "SortBy": {
	            "shape": "S3c"
	          },
	          "NextPageToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "UtilizationsByTime"
	        ],
	        "members": {
	          "UtilizationsByTime": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TimePeriod": {
	                  "shape": "S2i"
	                },
	                "Groups": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Key": {},
	                      "Value": {},
	                      "Attributes": {
	                        "shape": "S34"
	                      },
	                      "Utilization": {
	                        "shape": "S55"
	                      }
	                    }
	                  }
	                },
	                "Total": {
	                  "shape": "S55"
	                }
	              }
	            }
	          },
	          "Total": {
	            "shape": "S55"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "GetRightsizingRecommendation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Service"
	        ],
	        "members": {
	          "Filter": {
	            "shape": "S7"
	          },
	          "Configuration": {
	            "shape": "S5o"
	          },
	          "Service": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "NextPageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Metadata": {
	            "type": "structure",
	            "members": {
	              "RecommendationId": {},
	              "GenerationTimestamp": {},
	              "LookbackPeriodInDays": {},
	              "AdditionalMetadata": {}
	            }
	          },
	          "Summary": {
	            "type": "structure",
	            "members": {
	              "TotalRecommendationCount": {},
	              "EstimatedTotalMonthlySavingsAmount": {},
	              "SavingsCurrencyCode": {},
	              "SavingsPercentage": {}
	            }
	          },
	          "RightsizingRecommendations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AccountId": {},
	                "CurrentInstance": {
	                  "type": "structure",
	                  "members": {
	                    "ResourceId": {},
	                    "InstanceName": {},
	                    "Tags": {
	                      "type": "list",
	                      "member": {
	                        "shape": "Sf"
	                      }
	                    },
	                    "ResourceDetails": {
	                      "shape": "S5x"
	                    },
	                    "ResourceUtilization": {
	                      "shape": "S5z"
	                    },
	                    "ReservationCoveredHoursInLookbackPeriod": {},
	                    "SavingsPlansCoveredHoursInLookbackPeriod": {},
	                    "OnDemandHoursInLookbackPeriod": {},
	                    "TotalRunningHoursInLookbackPeriod": {},
	                    "MonthlyCost": {},
	                    "CurrencyCode": {}
	                  }
	                },
	                "RightsizingType": {},
	                "ModifyRecommendationDetail": {
	                  "type": "structure",
	                  "members": {
	                    "TargetInstances": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "members": {
	                          "EstimatedMonthlyCost": {},
	                          "EstimatedMonthlySavings": {},
	                          "CurrencyCode": {},
	                          "DefaultTargetInstance": {
	                            "type": "boolean"
	                          },
	                          "ResourceDetails": {
	                            "shape": "S5x"
	                          },
	                          "ExpectedResourceUtilization": {
	                            "shape": "S5z"
	                          },
	                          "PlatformDifferences": {
	                            "type": "list",
	                            "member": {}
	                          }
	                        }
	                      }
	                    }
	                  }
	                },
	                "TerminateRecommendationDetail": {
	                  "type": "structure",
	                  "members": {
	                    "EstimatedMonthlySavings": {},
	                    "CurrencyCode": {}
	                  }
	                },
	                "FindingReasonCodes": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "NextPageToken": {},
	          "Configuration": {
	            "shape": "S5o"
	          }
	        }
	      }
	    },
	    "GetSavingsPlansCoverage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod"
	        ],
	        "members": {
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "GroupBy": {
	            "shape": "S2m"
	          },
	          "Granularity": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "Metrics": {
	            "shape": "S2k"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "SortBy": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "SavingsPlansCoverages"
	        ],
	        "members": {
	          "SavingsPlansCoverages": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Attributes": {
	                  "shape": "S34"
	                },
	                "Coverage": {
	                  "type": "structure",
	                  "members": {
	                    "SpendCoveredBySavingsPlans": {},
	                    "OnDemandCost": {},
	                    "TotalCost": {},
	                    "CoveragePercentage": {}
	                  }
	                },
	                "TimePeriod": {
	                  "shape": "S2i"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetSavingsPlansPurchaseRecommendation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SavingsPlansType",
	          "TermInYears",
	          "PaymentOption",
	          "LookbackPeriodInDays"
	        ],
	        "members": {
	          "SavingsPlansType": {},
	          "TermInYears": {},
	          "PaymentOption": {},
	          "AccountScope": {},
	          "NextPageToken": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "LookbackPeriodInDays": {},
	          "Filter": {
	            "shape": "S7"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Metadata": {
	            "type": "structure",
	            "members": {
	              "RecommendationId": {},
	              "GenerationTimestamp": {},
	              "AdditionalMetadata": {}
	            }
	          },
	          "SavingsPlansPurchaseRecommendation": {
	            "type": "structure",
	            "members": {
	              "AccountScope": {},
	              "SavingsPlansType": {},
	              "TermInYears": {},
	              "PaymentOption": {},
	              "LookbackPeriodInDays": {},
	              "SavingsPlansPurchaseRecommendationDetails": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "SavingsPlansDetails": {
	                      "type": "structure",
	                      "members": {
	                        "Region": {},
	                        "InstanceFamily": {},
	                        "OfferingId": {}
	                      }
	                    },
	                    "AccountId": {},
	                    "UpfrontCost": {},
	                    "EstimatedROI": {},
	                    "CurrencyCode": {},
	                    "EstimatedSPCost": {},
	                    "EstimatedOnDemandCost": {},
	                    "EstimatedOnDemandCostWithCurrentCommitment": {},
	                    "EstimatedSavingsAmount": {},
	                    "EstimatedSavingsPercentage": {},
	                    "HourlyCommitmentToPurchase": {},
	                    "EstimatedAverageUtilization": {},
	                    "EstimatedMonthlySavingsAmount": {},
	                    "CurrentMinimumHourlyOnDemandSpend": {},
	                    "CurrentMaximumHourlyOnDemandSpend": {},
	                    "CurrentAverageHourlyOnDemandSpend": {}
	                  }
	                }
	              },
	              "SavingsPlansPurchaseRecommendationSummary": {
	                "type": "structure",
	                "members": {
	                  "EstimatedROI": {},
	                  "CurrencyCode": {},
	                  "EstimatedTotalCost": {},
	                  "CurrentOnDemandSpend": {},
	                  "EstimatedSavingsAmount": {},
	                  "TotalRecommendationCount": {},
	                  "DailyCommitmentToPurchase": {},
	                  "HourlyCommitmentToPurchase": {},
	                  "EstimatedSavingsPercentage": {},
	                  "EstimatedMonthlySavingsAmount": {},
	                  "EstimatedOnDemandCostWithCurrentCommitment": {}
	                }
	              }
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "GetSavingsPlansUtilization": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod"
	        ],
	        "members": {
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "Granularity": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "SortBy": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Total"
	        ],
	        "members": {
	          "SavingsPlansUtilizationsByTime": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "TimePeriod",
	                "Utilization"
	              ],
	              "members": {
	                "TimePeriod": {
	                  "shape": "S2i"
	                },
	                "Utilization": {
	                  "shape": "S6v"
	                },
	                "Savings": {
	                  "shape": "S6w"
	                },
	                "AmortizedCommitment": {
	                  "shape": "S6x"
	                }
	              }
	            }
	          },
	          "Total": {
	            "shape": "S6y"
	          }
	        }
	      }
	    },
	    "GetSavingsPlansUtilizationDetails": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod"
	        ],
	        "members": {
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "Filter": {
	            "shape": "S7"
	          },
	          "DataType": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "SortBy": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "SavingsPlansUtilizationDetails",
	          "TimePeriod"
	        ],
	        "members": {
	          "SavingsPlansUtilizationDetails": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "SavingsPlanArn": {},
	                "Attributes": {
	                  "shape": "S34"
	                },
	                "Utilization": {
	                  "shape": "S6v"
	                },
	                "Savings": {
	                  "shape": "S6w"
	                },
	                "AmortizedCommitment": {
	                  "shape": "S6x"
	                }
	              }
	            }
	          },
	          "Total": {
	            "shape": "S6y"
	          },
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod"
	        ],
	        "members": {
	          "SearchString": {},
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "TagKey": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "SortBy": {
	            "shape": "S3b"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextPageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Tags",
	          "ReturnSize",
	          "TotalSize"
	        ],
	        "members": {
	          "NextPageToken": {},
	          "Tags": {
	            "type": "list",
	            "member": {}
	          },
	          "ReturnSize": {
	            "type": "integer"
	          },
	          "TotalSize": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "GetUsageForecast": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TimePeriod",
	          "Metric",
	          "Granularity"
	        ],
	        "members": {
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "Metric": {},
	          "Granularity": {},
	          "Filter": {
	            "shape": "S7"
	          },
	          "PredictionIntervalLevel": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Total": {
	            "shape": "S2u"
	          },
	          "ForecastResultsByTime": {
	            "shape": "S3n"
	          }
	        }
	      }
	    },
	    "ListCostAllocationTags": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Status": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          },
	          "Type": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CostAllocationTags": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "TagKey",
	                "Type",
	                "Status"
	              ],
	              "members": {
	                "TagKey": {},
	                "Type": {},
	                "Status": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListCostCategoryDefinitions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EffectiveOn": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CostCategoryReferences": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "CostCategoryArn": {},
	                "Name": {},
	                "EffectiveStart": {},
	                "EffectiveEnd": {},
	                "NumberOfRules": {
	                  "type": "integer"
	                },
	                "ProcessingStatus": {
	                  "shape": "S1s"
	                },
	                "Values": {
	                  "shape": "S3i"
	                },
	                "DefaultValue": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceTags": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "ProvideAnomalyFeedback": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AnomalyId",
	          "Feedback"
	        ],
	        "members": {
	          "AnomalyId": {},
	          "Feedback": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "AnomalyId"
	        ],
	        "members": {
	          "AnomalyId": {}
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "ResourceTags"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "ResourceTags": {
	            "shape": "Sk"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "ResourceTagKeys"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "ResourceTagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateAnomalyMonitor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MonitorArn"
	        ],
	        "members": {
	          "MonitorArn": {},
	          "MonitorName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "MonitorArn"
	        ],
	        "members": {
	          "MonitorArn": {}
	        }
	      }
	    },
	    "UpdateAnomalySubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionArn"
	        ],
	        "members": {
	          "SubscriptionArn": {},
	          "Threshold": {
	            "type": "double"
	          },
	          "Frequency": {},
	          "MonitorArnList": {
	            "shape": "Sr"
	          },
	          "Subscribers": {
	            "shape": "St"
	          },
	          "SubscriptionName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "SubscriptionArn"
	        ],
	        "members": {
	          "SubscriptionArn": {}
	        }
	      }
	    },
	    "UpdateCostAllocationTagsStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CostAllocationTagsStatus"
	        ],
	        "members": {
	          "CostAllocationTagsStatus": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "TagKey",
	                "Status"
	              ],
	              "members": {
	                "TagKey": {},
	                "Status": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TagKey": {},
	                "Code": {},
	                "Message": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "UpdateCostCategoryDefinition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CostCategoryArn",
	          "RuleVersion",
	          "Rules"
	        ],
	        "members": {
	          "CostCategoryArn": {},
	          "RuleVersion": {},
	          "Rules": {
	            "shape": "S13"
	          },
	          "DefaultValue": {},
	          "SplitChargeRules": {
	            "shape": "S19"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CostCategoryArn": {},
	          "EffectiveStart": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "structure",
	      "required": [
	        "MonitorName",
	        "MonitorType"
	      ],
	      "members": {
	        "MonitorArn": {},
	        "MonitorName": {},
	        "CreationDate": {},
	        "LastUpdatedDate": {},
	        "LastEvaluatedDate": {},
	        "MonitorType": {},
	        "MonitorDimension": {},
	        "MonitorSpecification": {
	          "shape": "S7"
	        },
	        "DimensionalValueCount": {
	          "type": "integer"
	        }
	      }
	    },
	    "S7": {
	      "type": "structure",
	      "members": {
	        "Or": {
	          "shape": "S8"
	        },
	        "And": {
	          "shape": "S8"
	        },
	        "Not": {
	          "shape": "S7"
	        },
	        "Dimensions": {
	          "type": "structure",
	          "members": {
	            "Key": {},
	            "Values": {
	              "shape": "Sb"
	            },
	            "MatchOptions": {
	              "shape": "Sd"
	            }
	          }
	        },
	        "Tags": {
	          "shape": "Sf"
	        },
	        "CostCategories": {
	          "type": "structure",
	          "members": {
	            "Key": {},
	            "Values": {
	              "shape": "Sb"
	            },
	            "MatchOptions": {
	              "shape": "Sd"
	            }
	          }
	        }
	      }
	    },
	    "S8": {
	      "type": "list",
	      "member": {
	        "shape": "S7"
	      }
	    },
	    "Sb": {
	      "type": "list",
	      "member": {}
	    },
	    "Sd": {
	      "type": "list",
	      "member": {}
	    },
	    "Sf": {
	      "type": "structure",
	      "members": {
	        "Key": {},
	        "Values": {
	          "shape": "Sb"
	        },
	        "MatchOptions": {
	          "shape": "Sd"
	        }
	      }
	    },
	    "Sk": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sq": {
	      "type": "structure",
	      "required": [
	        "MonitorArnList",
	        "Subscribers",
	        "Threshold",
	        "Frequency",
	        "SubscriptionName"
	      ],
	      "members": {
	        "SubscriptionArn": {},
	        "AccountId": {},
	        "MonitorArnList": {
	          "shape": "Sr"
	        },
	        "Subscribers": {
	          "shape": "St"
	        },
	        "Threshold": {
	          "type": "double"
	        },
	        "Frequency": {},
	        "SubscriptionName": {}
	      }
	    },
	    "Sr": {
	      "type": "list",
	      "member": {}
	    },
	    "St": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Address": {},
	          "Type": {},
	          "Status": {}
	        }
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Value": {},
	          "Rule": {
	            "shape": "S7"
	          },
	          "InheritedValue": {
	            "type": "structure",
	            "members": {
	              "DimensionName": {},
	              "DimensionKey": {}
	            }
	          },
	          "Type": {}
	        }
	      }
	    },
	    "S19": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Source",
	          "Targets",
	          "Method"
	        ],
	        "members": {
	          "Source": {},
	          "Targets": {
	            "type": "list",
	            "member": {}
	          },
	          "Method": {},
	          "Parameters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Type",
	                "Values"
	              ],
	              "members": {
	                "Type": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1s": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Component": {},
	          "Status": {}
	        }
	      }
	    },
	    "S2i": {
	      "type": "structure",
	      "required": [
	        "Start",
	        "End"
	      ],
	      "members": {
	        "Start": {},
	        "End": {}
	      }
	    },
	    "S2k": {
	      "type": "list",
	      "member": {}
	    },
	    "S2m": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "Key": {}
	        }
	      }
	    },
	    "S2r": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "Total": {
	            "shape": "S2t"
	          },
	          "Groups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Keys": {
	                  "type": "list",
	                  "member": {}
	                },
	                "Metrics": {
	                  "shape": "S2t"
	                }
	              }
	            }
	          },
	          "Estimated": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S2t": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "S2u"
	      }
	    },
	    "S2u": {
	      "type": "structure",
	      "members": {
	        "Amount": {},
	        "Unit": {}
	      }
	    },
	    "S32": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Value": {},
	          "Attributes": {
	            "shape": "S34"
	          }
	        }
	      }
	    },
	    "S34": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S3b": {
	      "type": "list",
	      "member": {
	        "shape": "S3c"
	      }
	    },
	    "S3c": {
	      "type": "structure",
	      "required": [
	        "Key"
	      ],
	      "members": {
	        "Key": {},
	        "SortOrder": {}
	      }
	    },
	    "S3i": {
	      "type": "list",
	      "member": {}
	    },
	    "S3n": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "TimePeriod": {
	            "shape": "S2i"
	          },
	          "MeanValue": {},
	          "PredictionIntervalLowerBound": {},
	          "PredictionIntervalUpperBound": {}
	        }
	      }
	    },
	    "S3y": {
	      "type": "structure",
	      "members": {
	        "CoverageHours": {
	          "type": "structure",
	          "members": {
	            "OnDemandHours": {},
	            "ReservedHours": {},
	            "TotalRunningHours": {},
	            "CoverageHoursPercentage": {}
	          }
	        },
	        "CoverageNormalizedUnits": {
	          "type": "structure",
	          "members": {
	            "OnDemandNormalizedUnits": {},
	            "ReservedNormalizedUnits": {},
	            "TotalRunningNormalizedUnits": {},
	            "CoverageNormalizedUnitsPercentage": {}
	          }
	        },
	        "CoverageCost": {
	          "type": "structure",
	          "members": {
	            "OnDemandCost": {}
	          }
	        }
	      }
	    },
	    "S4g": {
	      "type": "structure",
	      "members": {
	        "EC2Specification": {
	          "type": "structure",
	          "members": {
	            "OfferingClass": {}
	          }
	        }
	      }
	    },
	    "S55": {
	      "type": "structure",
	      "members": {
	        "UtilizationPercentage": {},
	        "UtilizationPercentageInUnits": {},
	        "PurchasedHours": {},
	        "PurchasedUnits": {},
	        "TotalActualHours": {},
	        "TotalActualUnits": {},
	        "UnusedHours": {},
	        "UnusedUnits": {},
	        "OnDemandCostOfRIHoursUsed": {},
	        "NetRISavings": {},
	        "TotalPotentialRISavings": {},
	        "AmortizedUpfrontFee": {},
	        "AmortizedRecurringFee": {},
	        "TotalAmortizedFee": {},
	        "RICostForUnusedHours": {},
	        "RealizedSavings": {},
	        "UnrealizedSavings": {}
	      }
	    },
	    "S5o": {
	      "type": "structure",
	      "required": [
	        "RecommendationTarget",
	        "BenefitsConsidered"
	      ],
	      "members": {
	        "RecommendationTarget": {},
	        "BenefitsConsidered": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S5x": {
	      "type": "structure",
	      "members": {
	        "EC2ResourceDetails": {
	          "type": "structure",
	          "members": {
	            "HourlyOnDemandRate": {},
	            "InstanceType": {},
	            "Platform": {},
	            "Region": {},
	            "Sku": {},
	            "Memory": {},
	            "NetworkPerformance": {},
	            "Storage": {},
	            "Vcpu": {}
	          }
	        }
	      }
	    },
	    "S5z": {
	      "type": "structure",
	      "members": {
	        "EC2ResourceUtilization": {
	          "type": "structure",
	          "members": {
	            "MaxCpuUtilizationPercentage": {},
	            "MaxMemoryUtilizationPercentage": {},
	            "MaxStorageUtilizationPercentage": {},
	            "EBSResourceUtilization": {
	              "type": "structure",
	              "members": {
	                "EbsReadOpsPerSecond": {},
	                "EbsWriteOpsPerSecond": {},
	                "EbsReadBytesPerSecond": {},
	                "EbsWriteBytesPerSecond": {}
	              }
	            },
	            "DiskResourceUtilization": {
	              "type": "structure",
	              "members": {
	                "DiskReadOpsPerSecond": {},
	                "DiskWriteOpsPerSecond": {},
	                "DiskReadBytesPerSecond": {},
	                "DiskWriteBytesPerSecond": {}
	              }
	            },
	            "NetworkResourceUtilization": {
	              "type": "structure",
	              "members": {
	                "NetworkInBytesPerSecond": {},
	                "NetworkOutBytesPerSecond": {},
	                "NetworkPacketsInPerSecond": {},
	                "NetworkPacketsOutPerSecond": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "S6v": {
	      "type": "structure",
	      "members": {
	        "TotalCommitment": {},
	        "UsedCommitment": {},
	        "UnusedCommitment": {},
	        "UtilizationPercentage": {}
	      }
	    },
	    "S6w": {
	      "type": "structure",
	      "members": {
	        "NetSavings": {},
	        "OnDemandCostEquivalent": {}
	      }
	    },
	    "S6x": {
	      "type": "structure",
	      "members": {
	        "AmortizedRecurringCommitment": {},
	        "AmortizedUpfrontCommitment": {},
	        "TotalAmortizedCommitment": {}
	      }
	    },
	    "S6y": {
	      "type": "structure",
	      "required": [
	        "Utilization"
	      ],
	      "members": {
	        "Utilization": {
	          "shape": "S6v"
	        },
	        "Savings": {
	          "shape": "S6w"
	        },
	        "AmortizedCommitment": {
	          "shape": "S6x"
	        }
	      }
	    }
	  }
	}
	},{}],13:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "GetSavingsPlansCoverage": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "GetSavingsPlansUtilizationDetails": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListCostAllocationTags": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListCostCategoryDefinitions": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    }
	  }
	}
	
	},{}],14:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2010-05-15",
	    "endpointPrefix": "cloudformation",
	    "protocol": "query",
	    "serviceFullName": "AWS CloudFormation",
	    "serviceId": "CloudFormation",
	    "signatureVersion": "v4",
	    "uid": "cloudformation-2010-05-15",
	    "xmlNamespace": "http://cloudformation.amazonaws.com/doc/2010-05-15/"
	  },
	  "operations": {
	    "ActivateType": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "PublicTypeArn": {},
	          "PublisherId": {},
	          "TypeName": {},
	          "TypeNameAlias": {},
	          "AutoUpdate": {
	            "type": "boolean"
	          },
	          "LoggingConfig": {
	            "shape": "S7"
	          },
	          "ExecutionRoleArn": {},
	          "VersionBump": {},
	          "MajorVersion": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ActivateTypeResult",
	        "type": "structure",
	        "members": {
	          "Arn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "BatchDescribeTypeConfigurations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TypeConfigurationIdentifiers"
	        ],
	        "members": {
	          "TypeConfigurationIdentifiers": {
	            "type": "list",
	            "member": {
	              "shape": "Sg"
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "BatchDescribeTypeConfigurationsResult",
	        "type": "structure",
	        "members": {
	          "Errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ErrorCode": {},
	                "ErrorMessage": {},
	                "TypeConfigurationIdentifier": {
	                  "shape": "Sg"
	                }
	              }
	            }
	          },
	          "UnprocessedTypeConfigurations": {
	            "type": "list",
	            "member": {
	              "shape": "Sg"
	            }
	          },
	          "TypeConfigurations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Arn": {},
	                "Alias": {},
	                "Configuration": {},
	                "LastUpdated": {
	                  "type": "timestamp"
	                },
	                "TypeArn": {},
	                "TypeName": {},
	                "IsDefaultConfiguration": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "CancelUpdateStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {},
	          "ClientRequestToken": {}
	        }
	      }
	    },
	    "ContinueUpdateRollback": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {},
	          "RoleARN": {},
	          "ResourcesToSkip": {
	            "type": "list",
	            "member": {}
	          },
	          "ClientRequestToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ContinueUpdateRollbackResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateChangeSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName",
	          "ChangeSetName"
	        ],
	        "members": {
	          "StackName": {},
	          "TemplateBody": {},
	          "TemplateURL": {},
	          "UsePreviousTemplate": {
	            "type": "boolean"
	          },
	          "Parameters": {
	            "shape": "S18"
	          },
	          "Capabilities": {
	            "shape": "S1d"
	          },
	          "ResourceTypes": {
	            "shape": "S1f"
	          },
	          "RoleARN": {},
	          "RollbackConfiguration": {
	            "shape": "S1h"
	          },
	          "NotificationARNs": {
	            "shape": "S1n"
	          },
	          "Tags": {
	            "shape": "S1p"
	          },
	          "ChangeSetName": {},
	          "ClientToken": {},
	          "Description": {},
	          "ChangeSetType": {},
	          "ResourcesToImport": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ResourceType",
	                "LogicalResourceId",
	                "ResourceIdentifier"
	              ],
	              "members": {
	                "ResourceType": {},
	                "LogicalResourceId": {},
	                "ResourceIdentifier": {
	                  "type": "map",
	                  "key": {},
	                  "value": {}
	                }
	              }
	            }
	          },
	          "IncludeNestedStacks": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateChangeSetResult",
	        "type": "structure",
	        "members": {
	          "Id": {},
	          "StackId": {}
	        }
	      }
	    },
	    "CreateStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {},
	          "TemplateBody": {},
	          "TemplateURL": {},
	          "Parameters": {
	            "shape": "S18"
	          },
	          "DisableRollback": {
	            "type": "boolean"
	          },
	          "RollbackConfiguration": {
	            "shape": "S1h"
	          },
	          "TimeoutInMinutes": {
	            "type": "integer"
	          },
	          "NotificationARNs": {
	            "shape": "S1n"
	          },
	          "Capabilities": {
	            "shape": "S1d"
	          },
	          "ResourceTypes": {
	            "shape": "S1f"
	          },
	          "RoleARN": {},
	          "OnFailure": {},
	          "StackPolicyBody": {},
	          "StackPolicyURL": {},
	          "Tags": {
	            "shape": "S1p"
	          },
	          "ClientRequestToken": {},
	          "EnableTerminationProtection": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateStackResult",
	        "type": "structure",
	        "members": {
	          "StackId": {}
	        }
	      }
	    },
	    "CreateStackInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName",
	          "Regions"
	        ],
	        "members": {
	          "StackSetName": {},
	          "Accounts": {
	            "shape": "S2h"
	          },
	          "DeploymentTargets": {
	            "shape": "S2j"
	          },
	          "Regions": {
	            "shape": "S2n"
	          },
	          "ParameterOverrides": {
	            "shape": "S18"
	          },
	          "OperationPreferences": {
	            "shape": "S2p"
	          },
	          "OperationId": {
	            "idempotencyToken": true
	          },
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateStackInstancesResult",
	        "type": "structure",
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "CreateStackSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName"
	        ],
	        "members": {
	          "StackSetName": {},
	          "Description": {},
	          "TemplateBody": {},
	          "TemplateURL": {},
	          "StackId": {},
	          "Parameters": {
	            "shape": "S18"
	          },
	          "Capabilities": {
	            "shape": "S1d"
	          },
	          "Tags": {
	            "shape": "S1p"
	          },
	          "AdministrationRoleARN": {},
	          "ExecutionRoleName": {},
	          "PermissionModel": {},
	          "AutoDeployment": {
	            "shape": "S30"
	          },
	          "CallAs": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "ManagedExecution": {
	            "shape": "S33"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateStackSetResult",
	        "type": "structure",
	        "members": {
	          "StackSetId": {}
	        }
	      }
	    },
	    "DeactivateType": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TypeName": {},
	          "Type": {},
	          "Arn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeactivateTypeResult",
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "DeleteChangeSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ChangeSetName"
	        ],
	        "members": {
	          "ChangeSetName": {},
	          "StackName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteChangeSetResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {},
	          "RetainResources": {
	            "type": "list",
	            "member": {}
	          },
	          "RoleARN": {},
	          "ClientRequestToken": {}
	        }
	      }
	    },
	    "DeleteStackInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName",
	          "Regions",
	          "RetainStacks"
	        ],
	        "members": {
	          "StackSetName": {},
	          "Accounts": {
	            "shape": "S2h"
	          },
	          "DeploymentTargets": {
	            "shape": "S2j"
	          },
	          "Regions": {
	            "shape": "S2n"
	          },
	          "OperationPreferences": {
	            "shape": "S2p"
	          },
	          "RetainStacks": {
	            "type": "boolean"
	          },
	          "OperationId": {
	            "idempotencyToken": true
	          },
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteStackInstancesResult",
	        "type": "structure",
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "DeleteStackSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName"
	        ],
	        "members": {
	          "StackSetName": {},
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteStackSetResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeregisterType": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Arn": {},
	          "Type": {},
	          "TypeName": {},
	          "VersionId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeregisterTypeResult",
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "DescribeAccountLimits": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeAccountLimitsResult",
	        "type": "structure",
	        "members": {
	          "AccountLimits": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Value": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeChangeSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ChangeSetName"
	        ],
	        "members": {
	          "ChangeSetName": {},
	          "StackName": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeChangeSetResult",
	        "type": "structure",
	        "members": {
	          "ChangeSetName": {},
	          "ChangeSetId": {},
	          "StackId": {},
	          "StackName": {},
	          "Description": {},
	          "Parameters": {
	            "shape": "S18"
	          },
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "ExecutionStatus": {},
	          "Status": {},
	          "StatusReason": {},
	          "NotificationARNs": {
	            "shape": "S1n"
	          },
	          "RollbackConfiguration": {
	            "shape": "S1h"
	          },
	          "Capabilities": {
	            "shape": "S1d"
	          },
	          "Tags": {
	            "shape": "S1p"
	          },
	          "Changes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Type": {},
	                "HookInvocationCount": {
	                  "type": "integer"
	                },
	                "ResourceChange": {
	                  "type": "structure",
	                  "members": {
	                    "Action": {},
	                    "LogicalResourceId": {},
	                    "PhysicalResourceId": {},
	                    "ResourceType": {},
	                    "Replacement": {},
	                    "Scope": {
	                      "type": "list",
	                      "member": {}
	                    },
	                    "Details": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "members": {
	                          "Target": {
	                            "type": "structure",
	                            "members": {
	                              "Attribute": {},
	                              "Name": {},
	                              "RequiresRecreation": {}
	                            }
	                          },
	                          "Evaluation": {},
	                          "ChangeSource": {},
	                          "CausingEntity": {}
	                        }
	                      }
	                    },
	                    "ChangeSetId": {},
	                    "ModuleInfo": {
	                      "shape": "S4i"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {},
	          "IncludeNestedStacks": {
	            "type": "boolean"
	          },
	          "ParentChangeSetId": {},
	          "RootChangeSetId": {}
	        }
	      }
	    },
	    "DescribeChangeSetHooks": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ChangeSetName"
	        ],
	        "members": {
	          "ChangeSetName": {},
	          "StackName": {},
	          "NextToken": {},
	          "LogicalResourceId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeChangeSetHooksResult",
	        "type": "structure",
	        "members": {
	          "ChangeSetId": {},
	          "ChangeSetName": {},
	          "Hooks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "InvocationPoint": {},
	                "FailureMode": {},
	                "TypeName": {},
	                "TypeVersionId": {},
	                "TypeConfigurationVersionId": {},
	                "TargetDetails": {
	                  "type": "structure",
	                  "members": {
	                    "TargetType": {},
	                    "ResourceTargetDetails": {
	                      "type": "structure",
	                      "members": {
	                        "LogicalResourceId": {},
	                        "ResourceType": {},
	                        "ResourceAction": {}
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Status": {},
	          "NextToken": {},
	          "StackId": {},
	          "StackName": {}
	        }
	      }
	    },
	    "DescribePublisher": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PublisherId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribePublisherResult",
	        "type": "structure",
	        "members": {
	          "PublisherId": {},
	          "PublisherStatus": {},
	          "IdentityProvider": {},
	          "PublisherProfile": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeStackDriftDetectionStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackDriftDetectionId"
	        ],
	        "members": {
	          "StackDriftDetectionId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeStackDriftDetectionStatusResult",
	        "type": "structure",
	        "required": [
	          "StackId",
	          "StackDriftDetectionId",
	          "DetectionStatus",
	          "Timestamp"
	        ],
	        "members": {
	          "StackId": {},
	          "StackDriftDetectionId": {},
	          "StackDriftStatus": {},
	          "DetectionStatus": {},
	          "DetectionStatusReason": {},
	          "DriftedStackResourceCount": {
	            "type": "integer"
	          },
	          "Timestamp": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeStackEvents": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackName": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeStackEventsResult",
	        "type": "structure",
	        "members": {
	          "StackEvents": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "StackId",
	                "EventId",
	                "StackName",
	                "Timestamp"
	              ],
	              "members": {
	                "StackId": {},
	                "EventId": {},
	                "StackName": {},
	                "LogicalResourceId": {},
	                "PhysicalResourceId": {},
	                "ResourceType": {},
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "ResourceStatus": {},
	                "ResourceStatusReason": {},
	                "ResourceProperties": {},
	                "ClientRequestToken": {},
	                "HookType": {},
	                "HookStatus": {},
	                "HookStatusReason": {},
	                "HookInvocationPoint": {},
	                "HookFailureMode": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeStackInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName",
	          "StackInstanceAccount",
	          "StackInstanceRegion"
	        ],
	        "members": {
	          "StackSetName": {},
	          "StackInstanceAccount": {},
	          "StackInstanceRegion": {},
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeStackInstanceResult",
	        "type": "structure",
	        "members": {
	          "StackInstance": {
	            "type": "structure",
	            "members": {
	              "StackSetId": {},
	              "Region": {},
	              "Account": {},
	              "StackId": {},
	              "ParameterOverrides": {
	                "shape": "S18"
	              },
	              "Status": {},
	              "StackInstanceStatus": {
	                "shape": "S5q"
	              },
	              "StatusReason": {},
	              "OrganizationalUnitId": {},
	              "DriftStatus": {},
	              "LastDriftCheckTimestamp": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeStackResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName",
	          "LogicalResourceId"
	        ],
	        "members": {
	          "StackName": {},
	          "LogicalResourceId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeStackResourceResult",
	        "type": "structure",
	        "members": {
	          "StackResourceDetail": {
	            "type": "structure",
	            "required": [
	              "LogicalResourceId",
	              "ResourceType",
	              "LastUpdatedTimestamp",
	              "ResourceStatus"
	            ],
	            "members": {
	              "StackName": {},
	              "StackId": {},
	              "LogicalResourceId": {},
	              "PhysicalResourceId": {},
	              "ResourceType": {},
	              "LastUpdatedTimestamp": {
	                "type": "timestamp"
	              },
	              "ResourceStatus": {},
	              "ResourceStatusReason": {},
	              "Description": {},
	              "Metadata": {},
	              "DriftInformation": {
	                "shape": "S5x"
	              },
	              "ModuleInfo": {
	                "shape": "S4i"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeStackResourceDrifts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {},
	          "StackResourceDriftStatusFilters": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeStackResourceDriftsResult",
	        "type": "structure",
	        "required": [
	          "StackResourceDrifts"
	        ],
	        "members": {
	          "StackResourceDrifts": {
	            "type": "list",
	            "member": {
	              "shape": "S64"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeStackResources": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackName": {},
	          "LogicalResourceId": {},
	          "PhysicalResourceId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeStackResourcesResult",
	        "type": "structure",
	        "members": {
	          "StackResources": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "LogicalResourceId",
	                "ResourceType",
	                "Timestamp",
	                "ResourceStatus"
	              ],
	              "members": {
	                "StackName": {},
	                "StackId": {},
	                "LogicalResourceId": {},
	                "PhysicalResourceId": {},
	                "ResourceType": {},
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "ResourceStatus": {},
	                "ResourceStatusReason": {},
	                "Description": {},
	                "DriftInformation": {
	                  "shape": "S5x"
	                },
	                "ModuleInfo": {
	                  "shape": "S4i"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeStackSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName"
	        ],
	        "members": {
	          "StackSetName": {},
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeStackSetResult",
	        "type": "structure",
	        "members": {
	          "StackSet": {
	            "type": "structure",
	            "members": {
	              "StackSetName": {},
	              "StackSetId": {},
	              "Description": {},
	              "Status": {},
	              "TemplateBody": {},
	              "Parameters": {
	                "shape": "S18"
	              },
	              "Capabilities": {
	                "shape": "S1d"
	              },
	              "Tags": {
	                "shape": "S1p"
	              },
	              "StackSetARN": {},
	              "AdministrationRoleARN": {},
	              "ExecutionRoleName": {},
	              "StackSetDriftDetectionDetails": {
	                "shape": "S6o"
	              },
	              "AutoDeployment": {
	                "shape": "S30"
	              },
	              "PermissionModel": {},
	              "OrganizationalUnitIds": {
	                "shape": "S2l"
	              },
	              "ManagedExecution": {
	                "shape": "S33"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeStackSetOperation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName",
	          "OperationId"
	        ],
	        "members": {
	          "StackSetName": {},
	          "OperationId": {},
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeStackSetOperationResult",
	        "type": "structure",
	        "members": {
	          "StackSetOperation": {
	            "type": "structure",
	            "members": {
	              "OperationId": {},
	              "StackSetId": {},
	              "Action": {},
	              "Status": {},
	              "OperationPreferences": {
	                "shape": "S2p"
	              },
	              "RetainStacks": {
	                "type": "boolean"
	              },
	              "AdministrationRoleARN": {},
	              "ExecutionRoleName": {},
	              "CreationTimestamp": {
	                "type": "timestamp"
	              },
	              "EndTimestamp": {
	                "type": "timestamp"
	              },
	              "DeploymentTargets": {
	                "shape": "S2j"
	              },
	              "StackSetDriftDetectionDetails": {
	                "shape": "S6o"
	              },
	              "StatusReason": {}
	            }
	          }
	        }
	      }
	    },
	    "DescribeStacks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackName": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeStacksResult",
	        "type": "structure",
	        "members": {
	          "Stacks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "StackName",
	                "CreationTime",
	                "StackStatus"
	              ],
	              "members": {
	                "StackId": {},
	                "StackName": {},
	                "ChangeSetId": {},
	                "Description": {},
	                "Parameters": {
	                  "shape": "S18"
	                },
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "DeletionTime": {
	                  "type": "timestamp"
	                },
	                "LastUpdatedTime": {
	                  "type": "timestamp"
	                },
	                "RollbackConfiguration": {
	                  "shape": "S1h"
	                },
	                "StackStatus": {},
	                "StackStatusReason": {},
	                "DisableRollback": {
	                  "type": "boolean"
	                },
	                "NotificationARNs": {
	                  "shape": "S1n"
	                },
	                "TimeoutInMinutes": {
	                  "type": "integer"
	                },
	                "Capabilities": {
	                  "shape": "S1d"
	                },
	                "Outputs": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "OutputKey": {},
	                      "OutputValue": {},
	                      "Description": {},
	                      "ExportName": {}
	                    }
	                  }
	                },
	                "RoleARN": {},
	                "Tags": {
	                  "shape": "S1p"
	                },
	                "EnableTerminationProtection": {
	                  "type": "boolean"
	                },
	                "ParentId": {},
	                "RootId": {},
	                "DriftInformation": {
	                  "type": "structure",
	                  "required": [
	                    "StackDriftStatus"
	                  ],
	                  "members": {
	                    "StackDriftStatus": {},
	                    "LastCheckTimestamp": {
	                      "type": "timestamp"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeType": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "TypeName": {},
	          "Arn": {},
	          "VersionId": {},
	          "PublisherId": {},
	          "PublicVersionNumber": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeTypeResult",
	        "type": "structure",
	        "members": {
	          "Arn": {},
	          "Type": {},
	          "TypeName": {},
	          "DefaultVersionId": {},
	          "IsDefaultVersion": {
	            "type": "boolean"
	          },
	          "TypeTestsStatus": {},
	          "TypeTestsStatusDescription": {},
	          "Description": {},
	          "Schema": {},
	          "ProvisioningType": {},
	          "DeprecatedStatus": {},
	          "LoggingConfig": {
	            "shape": "S7"
	          },
	          "RequiredActivatedTypes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TypeNameAlias": {},
	                "OriginalTypeName": {},
	                "PublisherId": {},
	                "SupportedMajorVersions": {
	                  "type": "list",
	                  "member": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          },
	          "ExecutionRoleArn": {},
	          "Visibility": {},
	          "SourceUrl": {},
	          "DocumentationUrl": {},
	          "LastUpdated": {
	            "type": "timestamp"
	          },
	          "TimeCreated": {
	            "type": "timestamp"
	          },
	          "ConfigurationSchema": {},
	          "PublisherId": {},
	          "OriginalTypeName": {},
	          "OriginalTypeArn": {},
	          "PublicVersionNumber": {},
	          "LatestPublicVersion": {},
	          "IsActivated": {
	            "type": "boolean"
	          },
	          "AutoUpdate": {
	            "type": "boolean"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeTypeRegistration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RegistrationToken"
	        ],
	        "members": {
	          "RegistrationToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeTypeRegistrationResult",
	        "type": "structure",
	        "members": {
	          "ProgressStatus": {},
	          "Description": {},
	          "TypeArn": {},
	          "TypeVersionArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DetectStackDrift": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {},
	          "LogicalResourceIds": {
	            "shape": "S83"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DetectStackDriftResult",
	        "type": "structure",
	        "required": [
	          "StackDriftDetectionId"
	        ],
	        "members": {
	          "StackDriftDetectionId": {}
	        }
	      }
	    },
	    "DetectStackResourceDrift": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName",
	          "LogicalResourceId"
	        ],
	        "members": {
	          "StackName": {},
	          "LogicalResourceId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DetectStackResourceDriftResult",
	        "type": "structure",
	        "required": [
	          "StackResourceDrift"
	        ],
	        "members": {
	          "StackResourceDrift": {
	            "shape": "S64"
	          }
	        }
	      }
	    },
	    "DetectStackSetDrift": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName"
	        ],
	        "members": {
	          "StackSetName": {},
	          "OperationPreferences": {
	            "shape": "S2p"
	          },
	          "OperationId": {
	            "idempotencyToken": true
	          },
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DetectStackSetDriftResult",
	        "type": "structure",
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "EstimateTemplateCost": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TemplateBody": {},
	          "TemplateURL": {},
	          "Parameters": {
	            "shape": "S18"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "EstimateTemplateCostResult",
	        "type": "structure",
	        "members": {
	          "Url": {}
	        }
	      }
	    },
	    "ExecuteChangeSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ChangeSetName"
	        ],
	        "members": {
	          "ChangeSetName": {},
	          "StackName": {},
	          "ClientRequestToken": {},
	          "DisableRollback": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ExecuteChangeSetResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "GetStackPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetStackPolicyResult",
	        "type": "structure",
	        "members": {
	          "StackPolicyBody": {}
	        }
	      }
	    },
	    "GetTemplate": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackName": {},
	          "ChangeSetName": {},
	          "TemplateStage": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetTemplateResult",
	        "type": "structure",
	        "members": {
	          "TemplateBody": {},
	          "StagesAvailable": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "GetTemplateSummary": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TemplateBody": {},
	          "TemplateURL": {},
	          "StackName": {},
	          "StackSetName": {},
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetTemplateSummaryResult",
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ParameterKey": {},
	                "DefaultValue": {},
	                "ParameterType": {},
	                "NoEcho": {
	                  "type": "boolean"
	                },
	                "Description": {},
	                "ParameterConstraints": {
	                  "type": "structure",
	                  "members": {
	                    "AllowedValues": {
	                      "type": "list",
	                      "member": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Description": {},
	          "Capabilities": {
	            "shape": "S1d"
	          },
	          "CapabilitiesReason": {},
	          "ResourceTypes": {
	            "shape": "S1f"
	          },
	          "Version": {},
	          "Metadata": {},
	          "DeclaredTransforms": {
	            "shape": "S8w"
	          },
	          "ResourceIdentifierSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ResourceType": {},
	                "LogicalResourceIds": {
	                  "shape": "S83"
	                },
	                "ResourceIdentifiers": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ImportStacksToStackSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName"
	        ],
	        "members": {
	          "StackSetName": {},
	          "StackIds": {
	            "type": "list",
	            "member": {}
	          },
	          "StackIdsUrl": {},
	          "OrganizationalUnitIds": {
	            "shape": "S2l"
	          },
	          "OperationPreferences": {
	            "shape": "S2p"
	          },
	          "OperationId": {
	            "idempotencyToken": true
	          },
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ImportStacksToStackSetResult",
	        "type": "structure",
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "ListChangeSets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListChangeSetsResult",
	        "type": "structure",
	        "members": {
	          "Summaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "StackId": {},
	                "StackName": {},
	                "ChangeSetId": {},
	                "ChangeSetName": {},
	                "ExecutionStatus": {},
	                "Status": {},
	                "StatusReason": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "Description": {},
	                "IncludeNestedStacks": {
	                  "type": "boolean"
	                },
	                "ParentChangeSetId": {},
	                "RootChangeSetId": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListExports": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListExportsResult",
	        "type": "structure",
	        "members": {
	          "Exports": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ExportingStackId": {},
	                "Name": {},
	                "Value": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListImports": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExportName"
	        ],
	        "members": {
	          "ExportName": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListImportsResult",
	        "type": "structure",
	        "members": {
	          "Imports": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListStackInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName"
	        ],
	        "members": {
	          "StackSetName": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Values": {}
	              }
	            }
	          },
	          "StackInstanceAccount": {},
	          "StackInstanceRegion": {},
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListStackInstancesResult",
	        "type": "structure",
	        "members": {
	          "Summaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "StackSetId": {},
	                "Region": {},
	                "Account": {},
	                "StackId": {},
	                "Status": {},
	                "StatusReason": {},
	                "StackInstanceStatus": {
	                  "shape": "S5q"
	                },
	                "OrganizationalUnitId": {},
	                "DriftStatus": {},
	                "LastDriftCheckTimestamp": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListStackResources": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListStackResourcesResult",
	        "type": "structure",
	        "members": {
	          "StackResourceSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "LogicalResourceId",
	                "ResourceType",
	                "LastUpdatedTimestamp",
	                "ResourceStatus"
	              ],
	              "members": {
	                "LogicalResourceId": {},
	                "PhysicalResourceId": {},
	                "ResourceType": {},
	                "LastUpdatedTimestamp": {
	                  "type": "timestamp"
	                },
	                "ResourceStatus": {},
	                "ResourceStatusReason": {},
	                "DriftInformation": {
	                  "type": "structure",
	                  "required": [
	                    "StackResourceDriftStatus"
	                  ],
	                  "members": {
	                    "StackResourceDriftStatus": {},
	                    "LastCheckTimestamp": {
	                      "type": "timestamp"
	                    }
	                  }
	                },
	                "ModuleInfo": {
	                  "shape": "S4i"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListStackSetOperationResults": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName",
	          "OperationId"
	        ],
	        "members": {
	          "StackSetName": {},
	          "OperationId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListStackSetOperationResultsResult",
	        "type": "structure",
	        "members": {
	          "Summaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Account": {},
	                "Region": {},
	                "Status": {},
	                "StatusReason": {},
	                "AccountGateResult": {
	                  "type": "structure",
	                  "members": {
	                    "Status": {},
	                    "StatusReason": {}
	                  }
	                },
	                "OrganizationalUnitId": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListStackSetOperations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName"
	        ],
	        "members": {
	          "StackSetName": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListStackSetOperationsResult",
	        "type": "structure",
	        "members": {
	          "Summaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "OperationId": {},
	                "Action": {},
	                "Status": {},
	                "CreationTimestamp": {
	                  "type": "timestamp"
	                },
	                "EndTimestamp": {
	                  "type": "timestamp"
	                },
	                "StatusReason": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListStackSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Status": {},
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListStackSetsResult",
	        "type": "structure",
	        "members": {
	          "Summaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "StackSetName": {},
	                "StackSetId": {},
	                "Description": {},
	                "Status": {},
	                "AutoDeployment": {
	                  "shape": "S30"
	                },
	                "PermissionModel": {},
	                "DriftStatus": {},
	                "LastDriftCheckTimestamp": {
	                  "type": "timestamp"
	                },
	                "ManagedExecution": {
	                  "shape": "S33"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListStacks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "StackStatusFilter": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListStacksResult",
	        "type": "structure",
	        "members": {
	          "StackSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "StackName",
	                "CreationTime",
	                "StackStatus"
	              ],
	              "members": {
	                "StackId": {},
	                "StackName": {},
	                "TemplateDescription": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastUpdatedTime": {
	                  "type": "timestamp"
	                },
	                "DeletionTime": {
	                  "type": "timestamp"
	                },
	                "StackStatus": {},
	                "StackStatusReason": {},
	                "ParentId": {},
	                "RootId": {},
	                "DriftInformation": {
	                  "type": "structure",
	                  "required": [
	                    "StackDriftStatus"
	                  ],
	                  "members": {
	                    "StackDriftStatus": {},
	                    "LastCheckTimestamp": {
	                      "type": "timestamp"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTypeRegistrations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "TypeName": {},
	          "TypeArn": {},
	          "RegistrationStatusFilter": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTypeRegistrationsResult",
	        "type": "structure",
	        "members": {
	          "RegistrationTokenList": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListTypeVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "TypeName": {},
	          "Arn": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DeprecatedStatus": {},
	          "PublisherId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTypeVersionsResult",
	        "type": "structure",
	        "members": {
	          "TypeVersionSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Type": {},
	                "TypeName": {},
	                "VersionId": {},
	                "IsDefaultVersion": {
	                  "type": "boolean"
	                },
	                "Arn": {},
	                "TimeCreated": {
	                  "type": "timestamp"
	                },
	                "Description": {},
	                "PublicVersionNumber": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListTypes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Visibility": {},
	          "ProvisioningType": {},
	          "DeprecatedStatus": {},
	          "Type": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "Category": {},
	              "PublisherId": {},
	              "TypeNamePrefix": {}
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTypesResult",
	        "type": "structure",
	        "members": {
	          "TypeSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Type": {},
	                "TypeName": {},
	                "DefaultVersionId": {},
	                "TypeArn": {},
	                "LastUpdated": {
	                  "type": "timestamp"
	                },
	                "Description": {},
	                "PublisherId": {},
	                "OriginalTypeName": {},
	                "PublicVersionNumber": {},
	                "LatestPublicVersion": {},
	                "PublisherIdentity": {},
	                "PublisherName": {},
	                "IsActivated": {
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "PublishType": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "Arn": {},
	          "TypeName": {},
	          "PublicVersionNumber": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "PublishTypeResult",
	        "type": "structure",
	        "members": {
	          "PublicTypeArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "RecordHandlerProgress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BearerToken",
	          "OperationStatus"
	        ],
	        "members": {
	          "BearerToken": {},
	          "OperationStatus": {},
	          "CurrentOperationStatus": {},
	          "StatusMessage": {},
	          "ErrorCode": {},
	          "ResourceModel": {},
	          "ClientRequestToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RecordHandlerProgressResult",
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "RegisterPublisher": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptTermsAndConditions": {
	            "type": "boolean"
	          },
	          "ConnectionArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RegisterPublisherResult",
	        "type": "structure",
	        "members": {
	          "PublisherId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "RegisterType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TypeName",
	          "SchemaHandlerPackage"
	        ],
	        "members": {
	          "Type": {},
	          "TypeName": {},
	          "SchemaHandlerPackage": {},
	          "LoggingConfig": {
	            "shape": "S7"
	          },
	          "ExecutionRoleArn": {},
	          "ClientRequestToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RegisterTypeResult",
	        "type": "structure",
	        "members": {
	          "RegistrationToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "RollbackStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {},
	          "RoleARN": {},
	          "ClientRequestToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RollbackStackResult",
	        "type": "structure",
	        "members": {
	          "StackId": {}
	        }
	      }
	    },
	    "SetStackPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {},
	          "StackPolicyBody": {},
	          "StackPolicyURL": {}
	        }
	      }
	    },
	    "SetTypeConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Configuration"
	        ],
	        "members": {
	          "TypeArn": {},
	          "Configuration": {},
	          "ConfigurationAlias": {},
	          "TypeName": {},
	          "Type": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SetTypeConfigurationResult",
	        "type": "structure",
	        "members": {
	          "ConfigurationArn": {}
	        }
	      }
	    },
	    "SetTypeDefaultVersion": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Arn": {},
	          "Type": {},
	          "TypeName": {},
	          "VersionId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SetTypeDefaultVersionResult",
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "SignalResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName",
	          "LogicalResourceId",
	          "UniqueId",
	          "Status"
	        ],
	        "members": {
	          "StackName": {},
	          "LogicalResourceId": {},
	          "UniqueId": {},
	          "Status": {}
	        }
	      }
	    },
	    "StopStackSetOperation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName",
	          "OperationId"
	        ],
	        "members": {
	          "StackSetName": {},
	          "OperationId": {},
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "StopStackSetOperationResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TestType": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Arn": {},
	          "Type": {},
	          "TypeName": {},
	          "VersionId": {},
	          "LogDeliveryBucket": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "TestTypeResult",
	        "type": "structure",
	        "members": {
	          "TypeVersionArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "UpdateStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackName"
	        ],
	        "members": {
	          "StackName": {},
	          "TemplateBody": {},
	          "TemplateURL": {},
	          "UsePreviousTemplate": {
	            "type": "boolean"
	          },
	          "StackPolicyDuringUpdateBody": {},
	          "StackPolicyDuringUpdateURL": {},
	          "Parameters": {
	            "shape": "S18"
	          },
	          "Capabilities": {
	            "shape": "S1d"
	          },
	          "ResourceTypes": {
	            "shape": "S1f"
	          },
	          "RoleARN": {},
	          "RollbackConfiguration": {
	            "shape": "S1h"
	          },
	          "StackPolicyBody": {},
	          "StackPolicyURL": {},
	          "NotificationARNs": {
	            "shape": "S1n"
	          },
	          "Tags": {
	            "shape": "S1p"
	          },
	          "DisableRollback": {
	            "type": "boolean"
	          },
	          "ClientRequestToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateStackResult",
	        "type": "structure",
	        "members": {
	          "StackId": {}
	        }
	      }
	    },
	    "UpdateStackInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName",
	          "Regions"
	        ],
	        "members": {
	          "StackSetName": {},
	          "Accounts": {
	            "shape": "S2h"
	          },
	          "DeploymentTargets": {
	            "shape": "S2j"
	          },
	          "Regions": {
	            "shape": "S2n"
	          },
	          "ParameterOverrides": {
	            "shape": "S18"
	          },
	          "OperationPreferences": {
	            "shape": "S2p"
	          },
	          "OperationId": {
	            "idempotencyToken": true
	          },
	          "CallAs": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateStackInstancesResult",
	        "type": "structure",
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "UpdateStackSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackSetName"
	        ],
	        "members": {
	          "StackSetName": {},
	          "Description": {},
	          "TemplateBody": {},
	          "TemplateURL": {},
	          "UsePreviousTemplate": {
	            "type": "boolean"
	          },
	          "Parameters": {
	            "shape": "S18"
	          },
	          "Capabilities": {
	            "shape": "S1d"
	          },
	          "Tags": {
	            "shape": "S1p"
	          },
	          "OperationPreferences": {
	            "shape": "S2p"
	          },
	          "AdministrationRoleARN": {},
	          "ExecutionRoleName": {},
	          "DeploymentTargets": {
	            "shape": "S2j"
	          },
	          "PermissionModel": {},
	          "AutoDeployment": {
	            "shape": "S30"
	          },
	          "OperationId": {
	            "idempotencyToken": true
	          },
	          "Accounts": {
	            "shape": "S2h"
	          },
	          "Regions": {
	            "shape": "S2n"
	          },
	          "CallAs": {},
	          "ManagedExecution": {
	            "shape": "S33"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateStackSetResult",
	        "type": "structure",
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "UpdateTerminationProtection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EnableTerminationProtection",
	          "StackName"
	        ],
	        "members": {
	          "EnableTerminationProtection": {
	            "type": "boolean"
	          },
	          "StackName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateTerminationProtectionResult",
	        "type": "structure",
	        "members": {
	          "StackId": {}
	        }
	      }
	    },
	    "ValidateTemplate": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TemplateBody": {},
	          "TemplateURL": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ValidateTemplateResult",
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ParameterKey": {},
	                "DefaultValue": {},
	                "NoEcho": {
	                  "type": "boolean"
	                },
	                "Description": {}
	              }
	            }
	          },
	          "Description": {},
	          "Capabilities": {
	            "shape": "S1d"
	          },
	          "CapabilitiesReason": {},
	          "DeclaredTransforms": {
	            "shape": "S8w"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S7": {
	      "type": "structure",
	      "required": [
	        "LogRoleArn",
	        "LogGroupName"
	      ],
	      "members": {
	        "LogRoleArn": {},
	        "LogGroupName": {}
	      }
	    },
	    "Sg": {
	      "type": "structure",
	      "members": {
	        "TypeArn": {},
	        "TypeConfigurationAlias": {},
	        "TypeConfigurationArn": {},
	        "Type": {},
	        "TypeName": {}
	      }
	    },
	    "S18": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ParameterKey": {},
	          "ParameterValue": {},
	          "UsePreviousValue": {
	            "type": "boolean"
	          },
	          "ResolvedValue": {}
	        }
	      }
	    },
	    "S1d": {
	      "type": "list",
	      "member": {}
	    },
	    "S1f": {
	      "type": "list",
	      "member": {}
	    },
	    "S1h": {
	      "type": "structure",
	      "members": {
	        "RollbackTriggers": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Arn",
	              "Type"
	            ],
	            "members": {
	              "Arn": {},
	              "Type": {}
	            }
	          }
	        },
	        "MonitoringTimeInMinutes": {
	          "type": "integer"
	        }
	      }
	    },
	    "S1n": {
	      "type": "list",
	      "member": {}
	    },
	    "S1p": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S2h": {
	      "type": "list",
	      "member": {}
	    },
	    "S2j": {
	      "type": "structure",
	      "members": {
	        "Accounts": {
	          "shape": "S2h"
	        },
	        "AccountsUrl": {},
	        "OrganizationalUnitIds": {
	          "shape": "S2l"
	        }
	      }
	    },
	    "S2l": {
	      "type": "list",
	      "member": {}
	    },
	    "S2n": {
	      "type": "list",
	      "member": {}
	    },
	    "S2p": {
	      "type": "structure",
	      "members": {
	        "RegionConcurrencyType": {},
	        "RegionOrder": {
	          "shape": "S2n"
	        },
	        "FailureToleranceCount": {
	          "type": "integer"
	        },
	        "FailureTolerancePercentage": {
	          "type": "integer"
	        },
	        "MaxConcurrentCount": {
	          "type": "integer"
	        },
	        "MaxConcurrentPercentage": {
	          "type": "integer"
	        }
	      }
	    },
	    "S30": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "RetainStacksOnAccountRemoval": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S33": {
	      "type": "structure",
	      "members": {
	        "Active": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S4i": {
	      "type": "structure",
	      "members": {
	        "TypeHierarchy": {},
	        "LogicalIdHierarchy": {}
	      }
	    },
	    "S5q": {
	      "type": "structure",
	      "members": {
	        "DetailedStatus": {}
	      }
	    },
	    "S5x": {
	      "type": "structure",
	      "required": [
	        "StackResourceDriftStatus"
	      ],
	      "members": {
	        "StackResourceDriftStatus": {},
	        "LastCheckTimestamp": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S64": {
	      "type": "structure",
	      "required": [
	        "StackId",
	        "LogicalResourceId",
	        "ResourceType",
	        "StackResourceDriftStatus",
	        "Timestamp"
	      ],
	      "members": {
	        "StackId": {},
	        "LogicalResourceId": {},
	        "PhysicalResourceId": {},
	        "PhysicalResourceIdContext": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Key",
	              "Value"
	            ],
	            "members": {
	              "Key": {},
	              "Value": {}
	            }
	          }
	        },
	        "ResourceType": {},
	        "ExpectedProperties": {},
	        "ActualProperties": {},
	        "PropertyDifferences": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "PropertyPath",
	              "ExpectedValue",
	              "ActualValue",
	              "DifferenceType"
	            ],
	            "members": {
	              "PropertyPath": {},
	              "ExpectedValue": {},
	              "ActualValue": {},
	              "DifferenceType": {}
	            }
	          }
	        },
	        "StackResourceDriftStatus": {},
	        "Timestamp": {
	          "type": "timestamp"
	        },
	        "ModuleInfo": {
	          "shape": "S4i"
	        }
	      }
	    },
	    "S6o": {
	      "type": "structure",
	      "members": {
	        "DriftStatus": {},
	        "DriftDetectionStatus": {},
	        "LastDriftCheckTimestamp": {
	          "type": "timestamp"
	        },
	        "TotalStackInstancesCount": {
	          "type": "integer"
	        },
	        "DriftedStackInstancesCount": {
	          "type": "integer"
	        },
	        "InSyncStackInstancesCount": {
	          "type": "integer"
	        },
	        "InProgressStackInstancesCount": {
	          "type": "integer"
	        },
	        "FailedStackInstancesCount": {
	          "type": "integer"
	        }
	      }
	    },
	    "S83": {
	      "type": "list",
	      "member": {}
	    },
	    "S8w": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],15:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeAccountLimits": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "AccountLimits"
	    },
	    "DescribeStackEvents": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "StackEvents"
	    },
	    "DescribeStackResourceDrifts": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "DescribeStackResources": {
	      "result_key": "StackResources"
	    },
	    "DescribeStacks": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Stacks"
	    },
	    "ListChangeSets": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Summaries"
	    },
	    "ListExports": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Exports"
	    },
	    "ListImports": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Imports"
	    },
	    "ListStackInstances": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Summaries"
	    },
	    "ListStackResources": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "StackResourceSummaries"
	    },
	    "ListStackSetOperationResults": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Summaries"
	    },
	    "ListStackSetOperations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Summaries"
	    },
	    "ListStackSets": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Summaries"
	    },
	    "ListStacks": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "StackSummaries"
	    },
	    "ListTypeRegistrations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListTypeVersions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListTypes": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TypeSummaries"
	    }
	  }
	}
	},{}],16:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "StackExists": {
	      "delay": 5,
	      "operation": "DescribeStacks",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "matcher": "status",
	          "expected": 200,
	          "state": "success"
	        },
	        {
	          "matcher": "error",
	          "expected": "ValidationError",
	          "state": "retry"
	        }
	      ]
	    },
	    "StackCreateComplete": {
	      "delay": 30,
	      "operation": "DescribeStacks",
	      "maxAttempts": 120,
	      "description": "Wait until stack status is CREATE_COMPLETE.",
	      "acceptors": [
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "CREATE_COMPLETE",
	          "matcher": "pathAll",
	          "state": "success"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "CREATE_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "DELETE_COMPLETE",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "DELETE_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "ROLLBACK_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "ROLLBACK_COMPLETE",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "expected": "ValidationError",
	          "matcher": "error",
	          "state": "failure"
	        }
	      ]
	    },
	    "StackDeleteComplete": {
	      "delay": 30,
	      "operation": "DescribeStacks",
	      "maxAttempts": 120,
	      "description": "Wait until stack status is DELETE_COMPLETE.",
	      "acceptors": [
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "DELETE_COMPLETE",
	          "matcher": "pathAll",
	          "state": "success"
	        },
	        {
	          "expected": "ValidationError",
	          "matcher": "error",
	          "state": "success"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "DELETE_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "CREATE_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "ROLLBACK_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "UPDATE_ROLLBACK_IN_PROGRESS",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "UPDATE_ROLLBACK_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "UPDATE_ROLLBACK_COMPLETE",
	          "matcher": "pathAny",
	          "state": "failure"
	        }
	      ]
	    },
	    "StackUpdateComplete": {
	      "delay": 30,
	      "maxAttempts": 120,
	      "operation": "DescribeStacks",
	      "description": "Wait until stack status is UPDATE_COMPLETE.",
	      "acceptors": [
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "UPDATE_COMPLETE",
	          "matcher": "pathAll",
	          "state": "success"
	        },
	        {
	          "expected": "UPDATE_FAILED",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Stacks[].StackStatus"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "UPDATE_ROLLBACK_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "expected": "UPDATE_ROLLBACK_COMPLETE",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Stacks[].StackStatus"
	        },
	        {
	          "expected": "ValidationError",
	          "matcher": "error",
	          "state": "failure"
	        }
	      ]
	    },
	    "StackImportComplete": {
	      "delay": 30,
	      "maxAttempts": 120,
	      "operation": "DescribeStacks",
	      "description": "Wait until stack status is IMPORT_COMPLETE.",
	      "acceptors": [
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "IMPORT_COMPLETE",
	          "matcher": "pathAll",
	          "state": "success"
	        },
	        {
	          "expected": "ROLLBACK_COMPLETE",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Stacks[].StackStatus"
	        },
	        {
	          "expected": "ROLLBACK_FAILED",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Stacks[].StackStatus"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "IMPORT_ROLLBACK_IN_PROGRESS",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "IMPORT_ROLLBACK_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "expected": "IMPORT_ROLLBACK_COMPLETE",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Stacks[].StackStatus"
	        },
	        {
	          "expected": "ValidationError",
	          "matcher": "error",
	          "state": "failure"
	        }
	      ]
	    },
	    "StackRollbackComplete": {
	      "delay": 30,
	      "operation": "DescribeStacks",
	      "maxAttempts": 120,
	      "description": "Wait until stack status is UPDATE_ROLLBACK_COMPLETE.",
	      "acceptors": [
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "UPDATE_ROLLBACK_COMPLETE",
	          "matcher": "pathAll",
	          "state": "success"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "UPDATE_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "UPDATE_ROLLBACK_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "argument": "Stacks[].StackStatus",
	          "expected": "DELETE_FAILED",
	          "matcher": "pathAny",
	          "state": "failure"
	        },
	        {
	          "expected": "ValidationError",
	          "matcher": "error",
	          "state": "failure"
	        }
	      ]
	    },
	    "ChangeSetCreateComplete": {
	      "delay": 30,
	      "operation": "DescribeChangeSet",
	      "maxAttempts": 120,
	      "description": "Wait until change set status is CREATE_COMPLETE.",
	      "acceptors": [
	        {
	          "argument": "Status",
	          "expected": "CREATE_COMPLETE",
	          "matcher": "path",
	          "state": "success"
	        },
	        {
	          "argument": "Status",
	          "expected": "FAILED",
	          "matcher": "path",
	          "state": "failure"
	        },
	        {
	          "expected": "ValidationError",
	          "matcher": "error",
	          "state": "failure"
	        }
	      ]
	    },
	    "TypeRegistrationComplete": {
	      "delay": 30,
	      "operation": "DescribeTypeRegistration",
	      "maxAttempts": 120,
	      "description": "Wait until type registration is COMPLETE.",
	      "acceptors": [
	        {
	          "argument": "ProgressStatus",
	          "expected": "COMPLETE",
	          "matcher": "path",
	          "state": "success"
	        },
	        {
	          "argument": "ProgressStatus",
	          "expected": "FAILED",
	          "matcher": "path",
	          "state": "failure"
	        }
	      ]
	    }
	  }
	}
	
	},{}],17:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2016-11-25",
	    "endpointPrefix": "cloudfront",
	    "globalEndpoint": "cloudfront.amazonaws.com",
	    "protocol": "rest-xml",
	    "serviceAbbreviation": "CloudFront",
	    "serviceFullName": "Amazon CloudFront",
	    "serviceId": "CloudFront",
	    "signatureVersion": "v4",
	    "uid": "cloudfront-2016-11-25"
	  },
	  "operations": {
	    "CreateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "requestUri": "/2016-11-25/origin-access-identity/cloudfront",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "CreateDistribution": {
	      "http": {
	        "requestUri": "/2016-11-25/distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
	            }
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1s"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateDistributionWithTags": {
	      "http": {
	        "requestUri": "/2016-11-25/distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfigWithTags"
	        ],
	        "members": {
	          "DistributionConfigWithTags": {
	            "locationName": "DistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
	            },
	            "type": "structure",
	            "required": [
	              "DistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "DistributionConfig": {
	                "shape": "S7"
	              },
	              "Tags": {
	                "shape": "S21"
	              }
	            }
	          }
	        },
	        "payload": "DistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1s"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateInvalidation": {
	      "http": {
	        "requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "InvalidationBatch"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "InvalidationBatch": {
	            "shape": "S28",
	            "locationName": "InvalidationBatch",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
	            }
	          }
	        },
	        "payload": "InvalidationBatch"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "Invalidation": {
	            "shape": "S2c"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "CreateStreamingDistribution": {
	      "http": {
	        "requestUri": "/2016-11-25/streaming-distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S2e",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S2i"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "CreateStreamingDistributionWithTags": {
	      "http": {
	        "requestUri": "/2016-11-25/streaming-distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfigWithTags"
	        ],
	        "members": {
	          "StreamingDistributionConfigWithTags": {
	            "locationName": "StreamingDistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
	            },
	            "type": "structure",
	            "required": [
	              "StreamingDistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "StreamingDistributionConfig": {
	                "shape": "S2e"
	              },
	              "Tags": {
	                "shape": "S21"
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S2i"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "DeleteCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2016-11-25/distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteStreamingDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2016-11-25/streaming-distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "GetCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "GetCloudFrontOriginAccessIdentityConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      }
	    },
	    "GetDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1s"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "GetDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "DistributionConfig"
	      }
	    },
	    "GetInvalidation": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "Id"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Invalidation": {
	            "shape": "S2c"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "GetStreamingDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/streaming-distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S2i"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "GetStreamingDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S2e"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      }
	    },
	    "ListCloudFrontOriginAccessIdentities": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/origin-access-identity/cloudfront"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "CloudFrontOriginAccessIdentitySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "S3CanonicalUserId",
	                    "Comment"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "S3CanonicalUserId": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityList"
	      }
	    },
	    "ListDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S3a"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListDistributionsByWebACLId": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/distributionsByWebACLId/{WebACLId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebACLId"
	        ],
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "WebACLId": {
	            "location": "uri",
	            "locationName": "WebACLId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S3a"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListInvalidations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InvalidationList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "InvalidationSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "CreateTime",
	                    "Status"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "CreateTime": {
	                      "type": "timestamp"
	                    },
	                    "Status": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "InvalidationList"
	      }
	    },
	    "ListStreamingDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/streaming-distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "StreamingDistributionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "ARN",
	                    "Status",
	                    "LastModifiedTime",
	                    "DomainName",
	                    "S3Origin",
	                    "Aliases",
	                    "TrustedSigners",
	                    "Comment",
	                    "PriceClass",
	                    "Enabled"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "ARN": {},
	                    "Status": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "DomainName": {},
	                    "S3Origin": {
	                      "shape": "S2f"
	                    },
	                    "Aliases": {
	                      "shape": "S8"
	                    },
	                    "TrustedSigners": {
	                      "shape": "Sy"
	                    },
	                    "Comment": {},
	                    "PriceClass": {},
	                    "Enabled": {
	                      "type": "boolean"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionList"
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-11-25/tagging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "S21"
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/2016-11-25/tagging?Operation=Tag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "Tags"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "Tags": {
	            "shape": "S21",
	            "locationName": "Tags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
	            }
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "requestUri": "/2016-11-25/tagging?Operation=Untag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "TagKeys"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "TagKeys": {
	            "locationName": "TagKeys",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
	            },
	            "type": "structure",
	            "members": {
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "Key"
	                }
	              }
	            }
	          }
	        },
	        "payload": "TagKeys"
	      }
	    },
	    "UpdateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig",
	          "Id"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "UpdateDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2016-11-25/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1s"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "UpdateStreamingDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2016-11-25/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S2e",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S2i"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Comment"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {}
	      }
	    },
	    "S5": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "S3CanonicalUserId"
	      ],
	      "members": {
	        "Id": {},
	        "S3CanonicalUserId": {},
	        "CloudFrontOriginAccessIdentityConfig": {
	          "shape": "S2"
	        }
	      }
	    },
	    "S7": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Origins",
	        "DefaultCacheBehavior",
	        "Comment",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Aliases": {
	          "shape": "S8"
	        },
	        "DefaultRootObject": {},
	        "Origins": {
	          "shape": "Sb"
	        },
	        "DefaultCacheBehavior": {
	          "shape": "Sn"
	        },
	        "CacheBehaviors": {
	          "shape": "S1a"
	        },
	        "CustomErrorResponses": {
	          "shape": "S1d"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "IncludeCookies",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "IncludeCookies": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        },
	        "ViewerCertificate": {
	          "shape": "S1i"
	        },
	        "Restrictions": {
	          "shape": "S1m"
	        },
	        "WebACLId": {},
	        "HttpVersion": {},
	        "IsIPV6Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S8": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CNAME"
	          }
	        }
	      }
	    },
	    "Sb": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Origin",
	            "type": "structure",
	            "required": [
	              "Id",
	              "DomainName"
	            ],
	            "members": {
	              "Id": {},
	              "DomainName": {},
	              "OriginPath": {},
	              "CustomHeaders": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "OriginCustomHeader",
	                      "type": "structure",
	                      "required": [
	                        "HeaderName",
	                        "HeaderValue"
	                      ],
	                      "members": {
	                        "HeaderName": {},
	                        "HeaderValue": {}
	                      }
	                    }
	                  }
	                }
	              },
	              "S3OriginConfig": {
	                "type": "structure",
	                "required": [
	                  "OriginAccessIdentity"
	                ],
	                "members": {
	                  "OriginAccessIdentity": {}
	                }
	              },
	              "CustomOriginConfig": {
	                "type": "structure",
	                "required": [
	                  "HTTPPort",
	                  "HTTPSPort",
	                  "OriginProtocolPolicy"
	                ],
	                "members": {
	                  "HTTPPort": {
	                    "type": "integer"
	                  },
	                  "HTTPSPort": {
	                    "type": "integer"
	                  },
	                  "OriginProtocolPolicy": {},
	                  "OriginSslProtocols": {
	                    "type": "structure",
	                    "required": [
	                      "Quantity",
	                      "Items"
	                    ],
	                    "members": {
	                      "Quantity": {
	                        "type": "integer"
	                      },
	                      "Items": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "SslProtocol"
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "required": [
	        "TargetOriginId",
	        "ForwardedValues",
	        "TrustedSigners",
	        "ViewerProtocolPolicy",
	        "MinTTL"
	      ],
	      "members": {
	        "TargetOriginId": {},
	        "ForwardedValues": {
	          "shape": "So"
	        },
	        "TrustedSigners": {
	          "shape": "Sy"
	        },
	        "ViewerProtocolPolicy": {},
	        "MinTTL": {
	          "type": "long"
	        },
	        "AllowedMethods": {
	          "shape": "S12"
	        },
	        "SmoothStreaming": {
	          "type": "boolean"
	        },
	        "DefaultTTL": {
	          "type": "long"
	        },
	        "MaxTTL": {
	          "type": "long"
	        },
	        "Compress": {
	          "type": "boolean"
	        },
	        "LambdaFunctionAssociations": {
	          "shape": "S16"
	        }
	      }
	    },
	    "So": {
	      "type": "structure",
	      "required": [
	        "QueryString",
	        "Cookies"
	      ],
	      "members": {
	        "QueryString": {
	          "type": "boolean"
	        },
	        "Cookies": {
	          "type": "structure",
	          "required": [
	            "Forward"
	          ],
	          "members": {
	            "Forward": {},
	            "WhitelistedNames": {
	              "type": "structure",
	              "required": [
	                "Quantity"
	              ],
	              "members": {
	                "Quantity": {
	                  "type": "integer"
	                },
	                "Items": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "Name"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "Headers": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        },
	        "QueryStringCacheKeys": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sy": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "AwsAccountNumber"
	          }
	        }
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "required": [
	        "Quantity",
	        "Items"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "shape": "S13"
	        },
	        "CachedMethods": {
	          "type": "structure",
	          "required": [
	            "Quantity",
	            "Items"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "shape": "S13"
	            }
	          }
	        }
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {
	        "locationName": "Method"
	      }
	    },
	    "S16": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "LambdaFunctionAssociation",
	            "type": "structure",
	            "members": {
	              "LambdaFunctionARN": {},
	              "EventType": {}
	            }
	          }
	        }
	      }
	    },
	    "S1a": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CacheBehavior",
	            "type": "structure",
	            "required": [
	              "PathPattern",
	              "TargetOriginId",
	              "ForwardedValues",
	              "TrustedSigners",
	              "ViewerProtocolPolicy",
	              "MinTTL"
	            ],
	            "members": {
	              "PathPattern": {},
	              "TargetOriginId": {},
	              "ForwardedValues": {
	                "shape": "So"
	              },
	              "TrustedSigners": {
	                "shape": "Sy"
	              },
	              "ViewerProtocolPolicy": {},
	              "MinTTL": {
	                "type": "long"
	              },
	              "AllowedMethods": {
	                "shape": "S12"
	              },
	              "SmoothStreaming": {
	                "type": "boolean"
	              },
	              "DefaultTTL": {
	                "type": "long"
	              },
	              "MaxTTL": {
	                "type": "long"
	              },
	              "Compress": {
	                "type": "boolean"
	              },
	              "LambdaFunctionAssociations": {
	                "shape": "S16"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1d": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CustomErrorResponse",
	            "type": "structure",
	            "required": [
	              "ErrorCode"
	            ],
	            "members": {
	              "ErrorCode": {
	                "type": "integer"
	              },
	              "ResponsePagePath": {},
	              "ResponseCode": {},
	              "ErrorCachingMinTTL": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1i": {
	      "type": "structure",
	      "members": {
	        "CloudFrontDefaultCertificate": {
	          "type": "boolean"
	        },
	        "IAMCertificateId": {},
	        "ACMCertificateArn": {},
	        "SSLSupportMethod": {},
	        "MinimumProtocolVersion": {},
	        "Certificate": {
	          "deprecated": true
	        },
	        "CertificateSource": {
	          "deprecated": true
	        }
	      }
	    },
	    "S1m": {
	      "type": "structure",
	      "required": [
	        "GeoRestriction"
	      ],
	      "members": {
	        "GeoRestriction": {
	          "type": "structure",
	          "required": [
	            "RestrictionType",
	            "Quantity"
	          ],
	          "members": {
	            "RestrictionType": {},
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Location"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1s": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "LastModifiedTime",
	        "InProgressInvalidationBatches",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "DistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "InProgressInvalidationBatches": {
	          "type": "integer"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S1u"
	        },
	        "DistributionConfig": {
	          "shape": "S7"
	        }
	      }
	    },
	    "S1u": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Signer",
	            "type": "structure",
	            "members": {
	              "AwsAccountNumber": {},
	              "KeyPairIds": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "KeyPairId"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S21": {
	      "type": "structure",
	      "members": {
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Tag",
	            "type": "structure",
	            "required": [
	              "Key"
	            ],
	            "members": {
	              "Key": {},
	              "Value": {}
	            }
	          }
	        }
	      }
	    },
	    "S28": {
	      "type": "structure",
	      "required": [
	        "Paths",
	        "CallerReference"
	      ],
	      "members": {
	        "Paths": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Path"
	              }
	            }
	          }
	        },
	        "CallerReference": {}
	      }
	    },
	    "S2c": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "Status",
	        "CreateTime",
	        "InvalidationBatch"
	      ],
	      "members": {
	        "Id": {},
	        "Status": {},
	        "CreateTime": {
	          "type": "timestamp"
	        },
	        "InvalidationBatch": {
	          "shape": "S28"
	        }
	      }
	    },
	    "S2e": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "S3Origin",
	        "Comment",
	        "TrustedSigners",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "S3Origin": {
	          "shape": "S2f"
	        },
	        "Aliases": {
	          "shape": "S8"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "TrustedSigners": {
	          "shape": "Sy"
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S2f": {
	      "type": "structure",
	      "required": [
	        "DomainName",
	        "OriginAccessIdentity"
	      ],
	      "members": {
	        "DomainName": {},
	        "OriginAccessIdentity": {}
	      }
	    },
	    "S2i": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "StreamingDistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S1u"
	        },
	        "StreamingDistributionConfig": {
	          "shape": "S2e"
	        }
	      }
	    },
	    "S3a": {
	      "type": "structure",
	      "required": [
	        "Marker",
	        "MaxItems",
	        "IsTruncated",
	        "Quantity"
	      ],
	      "members": {
	        "Marker": {},
	        "NextMarker": {},
	        "MaxItems": {
	          "type": "integer"
	        },
	        "IsTruncated": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "DistributionSummary",
	            "type": "structure",
	            "required": [
	              "Id",
	              "ARN",
	              "Status",
	              "LastModifiedTime",
	              "DomainName",
	              "Aliases",
	              "Origins",
	              "DefaultCacheBehavior",
	              "CacheBehaviors",
	              "CustomErrorResponses",
	              "Comment",
	              "PriceClass",
	              "Enabled",
	              "ViewerCertificate",
	              "Restrictions",
	              "WebACLId",
	              "HttpVersion",
	              "IsIPV6Enabled"
	            ],
	            "members": {
	              "Id": {},
	              "ARN": {},
	              "Status": {},
	              "LastModifiedTime": {
	                "type": "timestamp"
	              },
	              "DomainName": {},
	              "Aliases": {
	                "shape": "S8"
	              },
	              "Origins": {
	                "shape": "Sb"
	              },
	              "DefaultCacheBehavior": {
	                "shape": "Sn"
	              },
	              "CacheBehaviors": {
	                "shape": "S1a"
	              },
	              "CustomErrorResponses": {
	                "shape": "S1d"
	              },
	              "Comment": {},
	              "PriceClass": {},
	              "Enabled": {
	                "type": "boolean"
	              },
	              "ViewerCertificate": {
	                "shape": "S1i"
	              },
	              "Restrictions": {
	                "shape": "S1m"
	              },
	              "WebACLId": {},
	              "HttpVersion": {},
	              "IsIPV6Enabled": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	}
	},{}],18:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListCloudFrontOriginAccessIdentities": {
	      "input_token": "Marker",
	      "output_token": "CloudFrontOriginAccessIdentityList.NextMarker",
	      "limit_key": "MaxItems",
	      "more_results": "CloudFrontOriginAccessIdentityList.IsTruncated",
	      "result_key": "CloudFrontOriginAccessIdentityList.Items"
	    },
	    "ListDistributions": {
	      "input_token": "Marker",
	      "output_token": "DistributionList.NextMarker",
	      "limit_key": "MaxItems",
	      "more_results": "DistributionList.IsTruncated",
	      "result_key": "DistributionList.Items"
	    },
	    "ListInvalidations": {
	      "input_token": "Marker",
	      "output_token": "InvalidationList.NextMarker",
	      "limit_key": "MaxItems",
	      "more_results": "InvalidationList.IsTruncated",
	      "result_key": "InvalidationList.Items"
	    },
	    "ListStreamingDistributions": {
	      "input_token": "Marker",
	      "output_token": "StreamingDistributionList.NextMarker",
	      "limit_key": "MaxItems",
	      "more_results": "StreamingDistributionList.IsTruncated",
	      "result_key": "StreamingDistributionList.Items"
	    }
	  }
	}
	
	},{}],19:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "DistributionDeployed": {
	      "delay": 60,
	      "operation": "GetDistribution",
	      "maxAttempts": 25,
	      "description": "Wait until a distribution is deployed.",
	      "acceptors": [
	        {
	          "expected": "Deployed",
	          "matcher": "path",
	          "state": "success",
	          "argument": "Distribution.Status"
	        }
	      ]
	    },
	    "InvalidationCompleted": {
	      "delay": 20,
	      "operation": "GetInvalidation",
	      "maxAttempts": 30,
	      "description": "Wait until an invalidation has completed.",
	      "acceptors": [
	        {
	          "expected": "Completed",
	          "matcher": "path",
	          "state": "success",
	          "argument": "Invalidation.Status"
	        }
	      ]
	    },
	    "StreamingDistributionDeployed": {
	      "delay": 60,
	      "operation": "GetStreamingDistribution",
	      "maxAttempts": 25,
	      "description": "Wait until a streaming distribution is deployed.",
	      "acceptors": [
	        {
	          "expected": "Deployed",
	          "matcher": "path",
	          "state": "success",
	          "argument": "StreamingDistribution.Status"
	        }
	      ]
	    }
	  }
	}
	
	},{}],20:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-03-25",
	    "endpointPrefix": "cloudfront",
	    "globalEndpoint": "cloudfront.amazonaws.com",
	    "protocol": "rest-xml",
	    "serviceAbbreviation": "CloudFront",
	    "serviceFullName": "Amazon CloudFront",
	    "serviceId": "CloudFront",
	    "signatureVersion": "v4",
	    "uid": "cloudfront-2017-03-25"
	  },
	  "operations": {
	    "CreateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "requestUri": "/2017-03-25/origin-access-identity/cloudfront",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "CreateDistribution": {
	      "http": {
	        "requestUri": "/2017-03-25/distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
	            }
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1s"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateDistributionWithTags": {
	      "http": {
	        "requestUri": "/2017-03-25/distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfigWithTags"
	        ],
	        "members": {
	          "DistributionConfigWithTags": {
	            "locationName": "DistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
	            },
	            "type": "structure",
	            "required": [
	              "DistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "DistributionConfig": {
	                "shape": "S7"
	              },
	              "Tags": {
	                "shape": "S21"
	              }
	            }
	          }
	        },
	        "payload": "DistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1s"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateInvalidation": {
	      "http": {
	        "requestUri": "/2017-03-25/distribution/{DistributionId}/invalidation",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "InvalidationBatch"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "InvalidationBatch": {
	            "shape": "S28",
	            "locationName": "InvalidationBatch",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
	            }
	          }
	        },
	        "payload": "InvalidationBatch"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "Invalidation": {
	            "shape": "S2c"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "CreateStreamingDistribution": {
	      "http": {
	        "requestUri": "/2017-03-25/streaming-distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S2e",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S2i"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "CreateStreamingDistributionWithTags": {
	      "http": {
	        "requestUri": "/2017-03-25/streaming-distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfigWithTags"
	        ],
	        "members": {
	          "StreamingDistributionConfigWithTags": {
	            "locationName": "StreamingDistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
	            },
	            "type": "structure",
	            "required": [
	              "StreamingDistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "StreamingDistributionConfig": {
	                "shape": "S2e"
	              },
	              "Tags": {
	                "shape": "S21"
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S2i"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "DeleteCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-03-25/distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteServiceLinkedRole": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-03-25/service-linked-role/{RoleName}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName"
	        ],
	        "members": {
	          "RoleName": {
	            "location": "uri",
	            "locationName": "RoleName"
	          }
	        }
	      }
	    },
	    "DeleteStreamingDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-03-25/streaming-distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "GetCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "GetCloudFrontOriginAccessIdentityConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      }
	    },
	    "GetDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1s"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "GetDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "DistributionConfig"
	      }
	    },
	    "GetInvalidation": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/distribution/{DistributionId}/invalidation/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "Id"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Invalidation": {
	            "shape": "S2c"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "GetStreamingDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/streaming-distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S2i"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "GetStreamingDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S2e"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      }
	    },
	    "ListCloudFrontOriginAccessIdentities": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/origin-access-identity/cloudfront"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "CloudFrontOriginAccessIdentitySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "S3CanonicalUserId",
	                    "Comment"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "S3CanonicalUserId": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityList"
	      }
	    },
	    "ListDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S3b"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListDistributionsByWebACLId": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/distributionsByWebACLId/{WebACLId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebACLId"
	        ],
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "WebACLId": {
	            "location": "uri",
	            "locationName": "WebACLId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S3b"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListInvalidations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/distribution/{DistributionId}/invalidation"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InvalidationList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "InvalidationSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "CreateTime",
	                    "Status"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "CreateTime": {
	                      "type": "timestamp"
	                    },
	                    "Status": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "InvalidationList"
	      }
	    },
	    "ListStreamingDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/streaming-distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "StreamingDistributionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "ARN",
	                    "Status",
	                    "LastModifiedTime",
	                    "DomainName",
	                    "S3Origin",
	                    "Aliases",
	                    "TrustedSigners",
	                    "Comment",
	                    "PriceClass",
	                    "Enabled"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "ARN": {},
	                    "Status": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "DomainName": {},
	                    "S3Origin": {
	                      "shape": "S2f"
	                    },
	                    "Aliases": {
	                      "shape": "S8"
	                    },
	                    "TrustedSigners": {
	                      "shape": "Sy"
	                    },
	                    "Comment": {},
	                    "PriceClass": {},
	                    "Enabled": {
	                      "type": "boolean"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionList"
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-25/tagging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "S21"
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/2017-03-25/tagging?Operation=Tag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "Tags"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "Tags": {
	            "shape": "S21",
	            "locationName": "Tags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
	            }
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "requestUri": "/2017-03-25/tagging?Operation=Untag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "TagKeys"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "TagKeys": {
	            "locationName": "TagKeys",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
	            },
	            "type": "structure",
	            "members": {
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "Key"
	                }
	              }
	            }
	          }
	        },
	        "payload": "TagKeys"
	      }
	    },
	    "UpdateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig",
	          "Id"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "UpdateDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2017-03-25/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1s"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "UpdateStreamingDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2017-03-25/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S2e",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S2i"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Comment"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {}
	      }
	    },
	    "S5": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "S3CanonicalUserId"
	      ],
	      "members": {
	        "Id": {},
	        "S3CanonicalUserId": {},
	        "CloudFrontOriginAccessIdentityConfig": {
	          "shape": "S2"
	        }
	      }
	    },
	    "S7": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Origins",
	        "DefaultCacheBehavior",
	        "Comment",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Aliases": {
	          "shape": "S8"
	        },
	        "DefaultRootObject": {},
	        "Origins": {
	          "shape": "Sb"
	        },
	        "DefaultCacheBehavior": {
	          "shape": "Sn"
	        },
	        "CacheBehaviors": {
	          "shape": "S1a"
	        },
	        "CustomErrorResponses": {
	          "shape": "S1d"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "IncludeCookies",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "IncludeCookies": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        },
	        "ViewerCertificate": {
	          "shape": "S1i"
	        },
	        "Restrictions": {
	          "shape": "S1m"
	        },
	        "WebACLId": {},
	        "HttpVersion": {},
	        "IsIPV6Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S8": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CNAME"
	          }
	        }
	      }
	    },
	    "Sb": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Origin",
	            "type": "structure",
	            "required": [
	              "Id",
	              "DomainName"
	            ],
	            "members": {
	              "Id": {},
	              "DomainName": {},
	              "OriginPath": {},
	              "CustomHeaders": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "OriginCustomHeader",
	                      "type": "structure",
	                      "required": [
	                        "HeaderName",
	                        "HeaderValue"
	                      ],
	                      "members": {
	                        "HeaderName": {},
	                        "HeaderValue": {}
	                      }
	                    }
	                  }
	                }
	              },
	              "S3OriginConfig": {
	                "type": "structure",
	                "required": [
	                  "OriginAccessIdentity"
	                ],
	                "members": {
	                  "OriginAccessIdentity": {}
	                }
	              },
	              "CustomOriginConfig": {
	                "type": "structure",
	                "required": [
	                  "HTTPPort",
	                  "HTTPSPort",
	                  "OriginProtocolPolicy"
	                ],
	                "members": {
	                  "HTTPPort": {
	                    "type": "integer"
	                  },
	                  "HTTPSPort": {
	                    "type": "integer"
	                  },
	                  "OriginProtocolPolicy": {},
	                  "OriginSslProtocols": {
	                    "type": "structure",
	                    "required": [
	                      "Quantity",
	                      "Items"
	                    ],
	                    "members": {
	                      "Quantity": {
	                        "type": "integer"
	                      },
	                      "Items": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "SslProtocol"
	                        }
	                      }
	                    }
	                  },
	                  "OriginReadTimeout": {
	                    "type": "integer"
	                  },
	                  "OriginKeepaliveTimeout": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "required": [
	        "TargetOriginId",
	        "ForwardedValues",
	        "TrustedSigners",
	        "ViewerProtocolPolicy",
	        "MinTTL"
	      ],
	      "members": {
	        "TargetOriginId": {},
	        "ForwardedValues": {
	          "shape": "So"
	        },
	        "TrustedSigners": {
	          "shape": "Sy"
	        },
	        "ViewerProtocolPolicy": {},
	        "MinTTL": {
	          "type": "long"
	        },
	        "AllowedMethods": {
	          "shape": "S12"
	        },
	        "SmoothStreaming": {
	          "type": "boolean"
	        },
	        "DefaultTTL": {
	          "type": "long"
	        },
	        "MaxTTL": {
	          "type": "long"
	        },
	        "Compress": {
	          "type": "boolean"
	        },
	        "LambdaFunctionAssociations": {
	          "shape": "S16"
	        }
	      }
	    },
	    "So": {
	      "type": "structure",
	      "required": [
	        "QueryString",
	        "Cookies"
	      ],
	      "members": {
	        "QueryString": {
	          "type": "boolean"
	        },
	        "Cookies": {
	          "type": "structure",
	          "required": [
	            "Forward"
	          ],
	          "members": {
	            "Forward": {},
	            "WhitelistedNames": {
	              "type": "structure",
	              "required": [
	                "Quantity"
	              ],
	              "members": {
	                "Quantity": {
	                  "type": "integer"
	                },
	                "Items": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "Name"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "Headers": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        },
	        "QueryStringCacheKeys": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sy": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "AwsAccountNumber"
	          }
	        }
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "required": [
	        "Quantity",
	        "Items"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "shape": "S13"
	        },
	        "CachedMethods": {
	          "type": "structure",
	          "required": [
	            "Quantity",
	            "Items"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "shape": "S13"
	            }
	          }
	        }
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {
	        "locationName": "Method"
	      }
	    },
	    "S16": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "LambdaFunctionAssociation",
	            "type": "structure",
	            "members": {
	              "LambdaFunctionARN": {},
	              "EventType": {}
	            }
	          }
	        }
	      }
	    },
	    "S1a": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CacheBehavior",
	            "type": "structure",
	            "required": [
	              "PathPattern",
	              "TargetOriginId",
	              "ForwardedValues",
	              "TrustedSigners",
	              "ViewerProtocolPolicy",
	              "MinTTL"
	            ],
	            "members": {
	              "PathPattern": {},
	              "TargetOriginId": {},
	              "ForwardedValues": {
	                "shape": "So"
	              },
	              "TrustedSigners": {
	                "shape": "Sy"
	              },
	              "ViewerProtocolPolicy": {},
	              "MinTTL": {
	                "type": "long"
	              },
	              "AllowedMethods": {
	                "shape": "S12"
	              },
	              "SmoothStreaming": {
	                "type": "boolean"
	              },
	              "DefaultTTL": {
	                "type": "long"
	              },
	              "MaxTTL": {
	                "type": "long"
	              },
	              "Compress": {
	                "type": "boolean"
	              },
	              "LambdaFunctionAssociations": {
	                "shape": "S16"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1d": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CustomErrorResponse",
	            "type": "structure",
	            "required": [
	              "ErrorCode"
	            ],
	            "members": {
	              "ErrorCode": {
	                "type": "integer"
	              },
	              "ResponsePagePath": {},
	              "ResponseCode": {},
	              "ErrorCachingMinTTL": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1i": {
	      "type": "structure",
	      "members": {
	        "CloudFrontDefaultCertificate": {
	          "type": "boolean"
	        },
	        "IAMCertificateId": {},
	        "ACMCertificateArn": {},
	        "SSLSupportMethod": {},
	        "MinimumProtocolVersion": {},
	        "Certificate": {
	          "deprecated": true
	        },
	        "CertificateSource": {
	          "deprecated": true
	        }
	      }
	    },
	    "S1m": {
	      "type": "structure",
	      "required": [
	        "GeoRestriction"
	      ],
	      "members": {
	        "GeoRestriction": {
	          "type": "structure",
	          "required": [
	            "RestrictionType",
	            "Quantity"
	          ],
	          "members": {
	            "RestrictionType": {},
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Location"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1s": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "LastModifiedTime",
	        "InProgressInvalidationBatches",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "DistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "InProgressInvalidationBatches": {
	          "type": "integer"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S1u"
	        },
	        "DistributionConfig": {
	          "shape": "S7"
	        }
	      }
	    },
	    "S1u": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Signer",
	            "type": "structure",
	            "members": {
	              "AwsAccountNumber": {},
	              "KeyPairIds": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "KeyPairId"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S21": {
	      "type": "structure",
	      "members": {
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Tag",
	            "type": "structure",
	            "required": [
	              "Key"
	            ],
	            "members": {
	              "Key": {},
	              "Value": {}
	            }
	          }
	        }
	      }
	    },
	    "S28": {
	      "type": "structure",
	      "required": [
	        "Paths",
	        "CallerReference"
	      ],
	      "members": {
	        "Paths": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Path"
	              }
	            }
	          }
	        },
	        "CallerReference": {}
	      }
	    },
	    "S2c": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "Status",
	        "CreateTime",
	        "InvalidationBatch"
	      ],
	      "members": {
	        "Id": {},
	        "Status": {},
	        "CreateTime": {
	          "type": "timestamp"
	        },
	        "InvalidationBatch": {
	          "shape": "S28"
	        }
	      }
	    },
	    "S2e": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "S3Origin",
	        "Comment",
	        "TrustedSigners",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "S3Origin": {
	          "shape": "S2f"
	        },
	        "Aliases": {
	          "shape": "S8"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "TrustedSigners": {
	          "shape": "Sy"
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S2f": {
	      "type": "structure",
	      "required": [
	        "DomainName",
	        "OriginAccessIdentity"
	      ],
	      "members": {
	        "DomainName": {},
	        "OriginAccessIdentity": {}
	      }
	    },
	    "S2i": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "StreamingDistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S1u"
	        },
	        "StreamingDistributionConfig": {
	          "shape": "S2e"
	        }
	      }
	    },
	    "S3b": {
	      "type": "structure",
	      "required": [
	        "Marker",
	        "MaxItems",
	        "IsTruncated",
	        "Quantity"
	      ],
	      "members": {
	        "Marker": {},
	        "NextMarker": {},
	        "MaxItems": {
	          "type": "integer"
	        },
	        "IsTruncated": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "DistributionSummary",
	            "type": "structure",
	            "required": [
	              "Id",
	              "ARN",
	              "Status",
	              "LastModifiedTime",
	              "DomainName",
	              "Aliases",
	              "Origins",
	              "DefaultCacheBehavior",
	              "CacheBehaviors",
	              "CustomErrorResponses",
	              "Comment",
	              "PriceClass",
	              "Enabled",
	              "ViewerCertificate",
	              "Restrictions",
	              "WebACLId",
	              "HttpVersion",
	              "IsIPV6Enabled"
	            ],
	            "members": {
	              "Id": {},
	              "ARN": {},
	              "Status": {},
	              "LastModifiedTime": {
	                "type": "timestamp"
	              },
	              "DomainName": {},
	              "Aliases": {
	                "shape": "S8"
	              },
	              "Origins": {
	                "shape": "Sb"
	              },
	              "DefaultCacheBehavior": {
	                "shape": "Sn"
	              },
	              "CacheBehaviors": {
	                "shape": "S1a"
	              },
	              "CustomErrorResponses": {
	                "shape": "S1d"
	              },
	              "Comment": {},
	              "PriceClass": {},
	              "Enabled": {
	                "type": "boolean"
	              },
	              "ViewerCertificate": {
	                "shape": "S1i"
	              },
	              "Restrictions": {
	                "shape": "S1m"
	              },
	              "WebACLId": {},
	              "HttpVersion": {},
	              "IsIPV6Enabled": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	}
	},{}],21:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListCloudFrontOriginAccessIdentities": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "CloudFrontOriginAccessIdentityList.IsTruncated",
	      "output_token": "CloudFrontOriginAccessIdentityList.NextMarker",
	      "result_key": "CloudFrontOriginAccessIdentityList.Items"
	    },
	    "ListDistributions": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "DistributionList.IsTruncated",
	      "output_token": "DistributionList.NextMarker",
	      "result_key": "DistributionList.Items"
	    },
	    "ListInvalidations": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "InvalidationList.IsTruncated",
	      "output_token": "InvalidationList.NextMarker",
	      "result_key": "InvalidationList.Items"
	    },
	    "ListStreamingDistributions": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "StreamingDistributionList.IsTruncated",
	      "output_token": "StreamingDistributionList.NextMarker",
	      "result_key": "StreamingDistributionList.Items"
	    }
	  }
	}
	},{}],22:[function(require,module,exports){
	arguments[4][19][0].apply(exports,arguments)
	},{"dup":19}],23:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-10-30",
	    "endpointPrefix": "cloudfront",
	    "globalEndpoint": "cloudfront.amazonaws.com",
	    "protocol": "rest-xml",
	    "serviceAbbreviation": "CloudFront",
	    "serviceFullName": "Amazon CloudFront",
	    "serviceId": "CloudFront",
	    "signatureVersion": "v4",
	    "uid": "cloudfront-2017-10-30"
	  },
	  "operations": {
	    "CreateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "requestUri": "/2017-10-30/origin-access-identity/cloudfront",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "CreateDistribution": {
	      "http": {
	        "requestUri": "/2017-10-30/distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1t"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateDistributionWithTags": {
	      "http": {
	        "requestUri": "/2017-10-30/distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfigWithTags"
	        ],
	        "members": {
	          "DistributionConfigWithTags": {
	            "locationName": "DistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            },
	            "type": "structure",
	            "required": [
	              "DistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "DistributionConfig": {
	                "shape": "S7"
	              },
	              "Tags": {
	                "shape": "S22"
	              }
	            }
	          }
	        },
	        "payload": "DistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1t"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateFieldLevelEncryptionConfig": {
	      "http": {
	        "requestUri": "/2017-10-30/field-level-encryption",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionConfig"
	        ],
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S29",
	            "locationName": "FieldLevelEncryptionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2k"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "CreateFieldLevelEncryptionProfile": {
	      "http": {
	        "requestUri": "/2017-10-30/field-level-encryption-profile",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionProfileConfig"
	        ],
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2m",
	            "locationName": "FieldLevelEncryptionProfileConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S2t"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "CreateInvalidation": {
	      "http": {
	        "requestUri": "/2017-10-30/distribution/{DistributionId}/invalidation",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "InvalidationBatch"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "InvalidationBatch": {
	            "shape": "S2v",
	            "locationName": "InvalidationBatch",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          }
	        },
	        "payload": "InvalidationBatch"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "Invalidation": {
	            "shape": "S2z"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "CreatePublicKey": {
	      "http": {
	        "requestUri": "/2017-10-30/public-key",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicKeyConfig"
	        ],
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S31",
	            "locationName": "PublicKeyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          }
	        },
	        "payload": "PublicKeyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S33"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "CreateStreamingDistribution": {
	      "http": {
	        "requestUri": "/2017-10-30/streaming-distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S35",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S39"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "CreateStreamingDistributionWithTags": {
	      "http": {
	        "requestUri": "/2017-10-30/streaming-distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfigWithTags"
	        ],
	        "members": {
	          "StreamingDistributionConfigWithTags": {
	            "locationName": "StreamingDistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            },
	            "type": "structure",
	            "required": [
	              "StreamingDistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "StreamingDistributionConfig": {
	                "shape": "S35"
	              },
	              "Tags": {
	                "shape": "S22"
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S39"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "DeleteCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-10-30/origin-access-identity/cloudfront/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-10-30/distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-10-30/field-level-encryption/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-10-30/field-level-encryption-profile/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeletePublicKey": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-10-30/public-key/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteStreamingDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-10-30/streaming-distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "GetCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/origin-access-identity/cloudfront/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "GetCloudFrontOriginAccessIdentityConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      }
	    },
	    "GetDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1t"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "GetDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "DistributionConfig"
	      }
	    },
	    "GetFieldLevelEncryption": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/field-level-encryption/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2k"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "GetFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/field-level-encryption/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S29"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      }
	    },
	    "GetFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/field-level-encryption-profile/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S2t"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "GetFieldLevelEncryptionProfileConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/field-level-encryption-profile/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2m"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      }
	    },
	    "GetInvalidation": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/distribution/{DistributionId}/invalidation/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "Id"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Invalidation": {
	            "shape": "S2z"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "GetPublicKey": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/public-key/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S33"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "GetPublicKeyConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/public-key/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S31"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKeyConfig"
	      }
	    },
	    "GetStreamingDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/streaming-distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S39"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "GetStreamingDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S35"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      }
	    },
	    "ListCloudFrontOriginAccessIdentities": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/origin-access-identity/cloudfront"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "CloudFrontOriginAccessIdentitySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "S3CanonicalUserId",
	                    "Comment"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "S3CanonicalUserId": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityList"
	      }
	    },
	    "ListDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S4g"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListDistributionsByWebACLId": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/distributionsByWebACLId/{WebACLId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebACLId"
	        ],
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "WebACLId": {
	            "location": "uri",
	            "locationName": "WebACLId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S4g"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListFieldLevelEncryptionConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/field-level-encryption"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "FieldLevelEncryptionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "LastModifiedTime"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "Comment": {},
	                    "QueryArgProfileConfig": {
	                      "shape": "S2a"
	                    },
	                    "ContentTypeProfileConfig": {
	                      "shape": "S2e"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionList"
	      }
	    },
	    "ListFieldLevelEncryptionProfiles": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/field-level-encryption-profile"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfileList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "FieldLevelEncryptionProfileSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "LastModifiedTime",
	                    "Name",
	                    "EncryptionEntities"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "Name": {},
	                    "EncryptionEntities": {
	                      "shape": "S2n"
	                    },
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileList"
	      }
	    },
	    "ListInvalidations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/distribution/{DistributionId}/invalidation"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InvalidationList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "InvalidationSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "CreateTime",
	                    "Status"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "CreateTime": {
	                      "type": "timestamp"
	                    },
	                    "Status": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "InvalidationList"
	      }
	    },
	    "ListPublicKeys": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/public-key"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKeyList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "PublicKeySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "Name",
	                    "CreatedTime",
	                    "EncodedKey"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "Name": {},
	                    "CreatedTime": {
	                      "type": "timestamp"
	                    },
	                    "EncodedKey": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "PublicKeyList"
	      }
	    },
	    "ListStreamingDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/streaming-distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "StreamingDistributionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "ARN",
	                    "Status",
	                    "LastModifiedTime",
	                    "DomainName",
	                    "S3Origin",
	                    "Aliases",
	                    "TrustedSigners",
	                    "Comment",
	                    "PriceClass",
	                    "Enabled"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "ARN": {},
	                    "Status": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "DomainName": {},
	                    "S3Origin": {
	                      "shape": "S36"
	                    },
	                    "Aliases": {
	                      "shape": "S8"
	                    },
	                    "TrustedSigners": {
	                      "shape": "Sy"
	                    },
	                    "Comment": {},
	                    "PriceClass": {},
	                    "Enabled": {
	                      "type": "boolean"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionList"
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-10-30/tagging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "S22"
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/2017-10-30/tagging?Operation=Tag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "Tags"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "Tags": {
	            "shape": "S22",
	            "locationName": "Tags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "requestUri": "/2017-10-30/tagging?Operation=Untag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "TagKeys"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "TagKeys": {
	            "locationName": "TagKeys",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            },
	            "type": "structure",
	            "members": {
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "Key"
	                }
	              }
	            }
	          }
	        },
	        "payload": "TagKeys"
	      }
	    },
	    "UpdateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2017-10-30/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig",
	          "Id"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "UpdateDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2017-10-30/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1t"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "UpdateFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2017-10-30/field-level-encryption/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionConfig",
	          "Id"
	        ],
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S29",
	            "locationName": "FieldLevelEncryptionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2k"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "UpdateFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2017-10-30/field-level-encryption-profile/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionProfileConfig",
	          "Id"
	        ],
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2m",
	            "locationName": "FieldLevelEncryptionProfileConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S2t"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "UpdatePublicKey": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2017-10-30/public-key/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicKeyConfig",
	          "Id"
	        ],
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S31",
	            "locationName": "PublicKeyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "PublicKeyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S33"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "UpdateStreamingDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2017-10-30/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S35",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S39"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Comment"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {}
	      }
	    },
	    "S5": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "S3CanonicalUserId"
	      ],
	      "members": {
	        "Id": {},
	        "S3CanonicalUserId": {},
	        "CloudFrontOriginAccessIdentityConfig": {
	          "shape": "S2"
	        }
	      }
	    },
	    "S7": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Origins",
	        "DefaultCacheBehavior",
	        "Comment",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Aliases": {
	          "shape": "S8"
	        },
	        "DefaultRootObject": {},
	        "Origins": {
	          "shape": "Sb"
	        },
	        "DefaultCacheBehavior": {
	          "shape": "Sn"
	        },
	        "CacheBehaviors": {
	          "shape": "S1b"
	        },
	        "CustomErrorResponses": {
	          "shape": "S1e"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "IncludeCookies",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "IncludeCookies": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        },
	        "ViewerCertificate": {
	          "shape": "S1j"
	        },
	        "Restrictions": {
	          "shape": "S1n"
	        },
	        "WebACLId": {},
	        "HttpVersion": {},
	        "IsIPV6Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S8": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CNAME"
	          }
	        }
	      }
	    },
	    "Sb": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Origin",
	            "type": "structure",
	            "required": [
	              "Id",
	              "DomainName"
	            ],
	            "members": {
	              "Id": {},
	              "DomainName": {},
	              "OriginPath": {},
	              "CustomHeaders": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "OriginCustomHeader",
	                      "type": "structure",
	                      "required": [
	                        "HeaderName",
	                        "HeaderValue"
	                      ],
	                      "members": {
	                        "HeaderName": {},
	                        "HeaderValue": {}
	                      }
	                    }
	                  }
	                }
	              },
	              "S3OriginConfig": {
	                "type": "structure",
	                "required": [
	                  "OriginAccessIdentity"
	                ],
	                "members": {
	                  "OriginAccessIdentity": {}
	                }
	              },
	              "CustomOriginConfig": {
	                "type": "structure",
	                "required": [
	                  "HTTPPort",
	                  "HTTPSPort",
	                  "OriginProtocolPolicy"
	                ],
	                "members": {
	                  "HTTPPort": {
	                    "type": "integer"
	                  },
	                  "HTTPSPort": {
	                    "type": "integer"
	                  },
	                  "OriginProtocolPolicy": {},
	                  "OriginSslProtocols": {
	                    "type": "structure",
	                    "required": [
	                      "Quantity",
	                      "Items"
	                    ],
	                    "members": {
	                      "Quantity": {
	                        "type": "integer"
	                      },
	                      "Items": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "SslProtocol"
	                        }
	                      }
	                    }
	                  },
	                  "OriginReadTimeout": {
	                    "type": "integer"
	                  },
	                  "OriginKeepaliveTimeout": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "required": [
	        "TargetOriginId",
	        "ForwardedValues",
	        "TrustedSigners",
	        "ViewerProtocolPolicy",
	        "MinTTL"
	      ],
	      "members": {
	        "TargetOriginId": {},
	        "ForwardedValues": {
	          "shape": "So"
	        },
	        "TrustedSigners": {
	          "shape": "Sy"
	        },
	        "ViewerProtocolPolicy": {},
	        "MinTTL": {
	          "type": "long"
	        },
	        "AllowedMethods": {
	          "shape": "S12"
	        },
	        "SmoothStreaming": {
	          "type": "boolean"
	        },
	        "DefaultTTL": {
	          "type": "long"
	        },
	        "MaxTTL": {
	          "type": "long"
	        },
	        "Compress": {
	          "type": "boolean"
	        },
	        "LambdaFunctionAssociations": {
	          "shape": "S16"
	        },
	        "FieldLevelEncryptionId": {}
	      }
	    },
	    "So": {
	      "type": "structure",
	      "required": [
	        "QueryString",
	        "Cookies"
	      ],
	      "members": {
	        "QueryString": {
	          "type": "boolean"
	        },
	        "Cookies": {
	          "type": "structure",
	          "required": [
	            "Forward"
	          ],
	          "members": {
	            "Forward": {},
	            "WhitelistedNames": {
	              "type": "structure",
	              "required": [
	                "Quantity"
	              ],
	              "members": {
	                "Quantity": {
	                  "type": "integer"
	                },
	                "Items": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "Name"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "Headers": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        },
	        "QueryStringCacheKeys": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sy": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "AwsAccountNumber"
	          }
	        }
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "required": [
	        "Quantity",
	        "Items"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "shape": "S13"
	        },
	        "CachedMethods": {
	          "type": "structure",
	          "required": [
	            "Quantity",
	            "Items"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "shape": "S13"
	            }
	          }
	        }
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {
	        "locationName": "Method"
	      }
	    },
	    "S16": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "LambdaFunctionAssociation",
	            "type": "structure",
	            "required": [
	              "LambdaFunctionARN",
	              "EventType"
	            ],
	            "members": {
	              "LambdaFunctionARN": {},
	              "EventType": {}
	            }
	          }
	        }
	      }
	    },
	    "S1b": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CacheBehavior",
	            "type": "structure",
	            "required": [
	              "PathPattern",
	              "TargetOriginId",
	              "ForwardedValues",
	              "TrustedSigners",
	              "ViewerProtocolPolicy",
	              "MinTTL"
	            ],
	            "members": {
	              "PathPattern": {},
	              "TargetOriginId": {},
	              "ForwardedValues": {
	                "shape": "So"
	              },
	              "TrustedSigners": {
	                "shape": "Sy"
	              },
	              "ViewerProtocolPolicy": {},
	              "MinTTL": {
	                "type": "long"
	              },
	              "AllowedMethods": {
	                "shape": "S12"
	              },
	              "SmoothStreaming": {
	                "type": "boolean"
	              },
	              "DefaultTTL": {
	                "type": "long"
	              },
	              "MaxTTL": {
	                "type": "long"
	              },
	              "Compress": {
	                "type": "boolean"
	              },
	              "LambdaFunctionAssociations": {
	                "shape": "S16"
	              },
	              "FieldLevelEncryptionId": {}
	            }
	          }
	        }
	      }
	    },
	    "S1e": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CustomErrorResponse",
	            "type": "structure",
	            "required": [
	              "ErrorCode"
	            ],
	            "members": {
	              "ErrorCode": {
	                "type": "integer"
	              },
	              "ResponsePagePath": {},
	              "ResponseCode": {},
	              "ErrorCachingMinTTL": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1j": {
	      "type": "structure",
	      "members": {
	        "CloudFrontDefaultCertificate": {
	          "type": "boolean"
	        },
	        "IAMCertificateId": {},
	        "ACMCertificateArn": {},
	        "SSLSupportMethod": {},
	        "MinimumProtocolVersion": {},
	        "Certificate": {
	          "deprecated": true
	        },
	        "CertificateSource": {
	          "deprecated": true
	        }
	      }
	    },
	    "S1n": {
	      "type": "structure",
	      "required": [
	        "GeoRestriction"
	      ],
	      "members": {
	        "GeoRestriction": {
	          "type": "structure",
	          "required": [
	            "RestrictionType",
	            "Quantity"
	          ],
	          "members": {
	            "RestrictionType": {},
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Location"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1t": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "LastModifiedTime",
	        "InProgressInvalidationBatches",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "DistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "InProgressInvalidationBatches": {
	          "type": "integer"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S1v"
	        },
	        "DistributionConfig": {
	          "shape": "S7"
	        }
	      }
	    },
	    "S1v": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Signer",
	            "type": "structure",
	            "members": {
	              "AwsAccountNumber": {},
	              "KeyPairIds": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "KeyPairId"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S22": {
	      "type": "structure",
	      "members": {
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Tag",
	            "type": "structure",
	            "required": [
	              "Key"
	            ],
	            "members": {
	              "Key": {},
	              "Value": {}
	            }
	          }
	        }
	      }
	    },
	    "S29": {
	      "type": "structure",
	      "required": [
	        "CallerReference"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {},
	        "QueryArgProfileConfig": {
	          "shape": "S2a"
	        },
	        "ContentTypeProfileConfig": {
	          "shape": "S2e"
	        }
	      }
	    },
	    "S2a": {
	      "type": "structure",
	      "required": [
	        "ForwardWhenQueryArgProfileIsUnknown"
	      ],
	      "members": {
	        "ForwardWhenQueryArgProfileIsUnknown": {
	          "type": "boolean"
	        },
	        "QueryArgProfiles": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "QueryArgProfile",
	                "type": "structure",
	                "required": [
	                  "QueryArg",
	                  "ProfileId"
	                ],
	                "members": {
	                  "QueryArg": {},
	                  "ProfileId": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2e": {
	      "type": "structure",
	      "required": [
	        "ForwardWhenContentTypeIsUnknown"
	      ],
	      "members": {
	        "ForwardWhenContentTypeIsUnknown": {
	          "type": "boolean"
	        },
	        "ContentTypeProfiles": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "ContentTypeProfile",
	                "type": "structure",
	                "required": [
	                  "Format",
	                  "ContentType"
	                ],
	                "members": {
	                  "Format": {},
	                  "ProfileId": {},
	                  "ContentType": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2k": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "FieldLevelEncryptionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "FieldLevelEncryptionConfig": {
	          "shape": "S29"
	        }
	      }
	    },
	    "S2m": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "CallerReference",
	        "EncryptionEntities"
	      ],
	      "members": {
	        "Name": {},
	        "CallerReference": {},
	        "Comment": {},
	        "EncryptionEntities": {
	          "shape": "S2n"
	        }
	      }
	    },
	    "S2n": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "EncryptionEntity",
	            "type": "structure",
	            "required": [
	              "PublicKeyId",
	              "ProviderId",
	              "FieldPatterns"
	            ],
	            "members": {
	              "PublicKeyId": {},
	              "ProviderId": {},
	              "FieldPatterns": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "FieldPattern"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2t": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "FieldLevelEncryptionProfileConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "FieldLevelEncryptionProfileConfig": {
	          "shape": "S2m"
	        }
	      }
	    },
	    "S2v": {
	      "type": "structure",
	      "required": [
	        "Paths",
	        "CallerReference"
	      ],
	      "members": {
	        "Paths": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Path"
	              }
	            }
	          }
	        },
	        "CallerReference": {}
	      }
	    },
	    "S2z": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "Status",
	        "CreateTime",
	        "InvalidationBatch"
	      ],
	      "members": {
	        "Id": {},
	        "Status": {},
	        "CreateTime": {
	          "type": "timestamp"
	        },
	        "InvalidationBatch": {
	          "shape": "S2v"
	        }
	      }
	    },
	    "S31": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Name",
	        "EncodedKey"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Name": {},
	        "EncodedKey": {},
	        "Comment": {}
	      }
	    },
	    "S33": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "CreatedTime",
	        "PublicKeyConfig"
	      ],
	      "members": {
	        "Id": {},
	        "CreatedTime": {
	          "type": "timestamp"
	        },
	        "PublicKeyConfig": {
	          "shape": "S31"
	        }
	      }
	    },
	    "S35": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "S3Origin",
	        "Comment",
	        "TrustedSigners",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "S3Origin": {
	          "shape": "S36"
	        },
	        "Aliases": {
	          "shape": "S8"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "TrustedSigners": {
	          "shape": "Sy"
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S36": {
	      "type": "structure",
	      "required": [
	        "DomainName",
	        "OriginAccessIdentity"
	      ],
	      "members": {
	        "DomainName": {},
	        "OriginAccessIdentity": {}
	      }
	    },
	    "S39": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "StreamingDistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S1v"
	        },
	        "StreamingDistributionConfig": {
	          "shape": "S35"
	        }
	      }
	    },
	    "S4g": {
	      "type": "structure",
	      "required": [
	        "Marker",
	        "MaxItems",
	        "IsTruncated",
	        "Quantity"
	      ],
	      "members": {
	        "Marker": {},
	        "NextMarker": {},
	        "MaxItems": {
	          "type": "integer"
	        },
	        "IsTruncated": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "DistributionSummary",
	            "type": "structure",
	            "required": [
	              "Id",
	              "ARN",
	              "Status",
	              "LastModifiedTime",
	              "DomainName",
	              "Aliases",
	              "Origins",
	              "DefaultCacheBehavior",
	              "CacheBehaviors",
	              "CustomErrorResponses",
	              "Comment",
	              "PriceClass",
	              "Enabled",
	              "ViewerCertificate",
	              "Restrictions",
	              "WebACLId",
	              "HttpVersion",
	              "IsIPV6Enabled"
	            ],
	            "members": {
	              "Id": {},
	              "ARN": {},
	              "Status": {},
	              "LastModifiedTime": {
	                "type": "timestamp"
	              },
	              "DomainName": {},
	              "Aliases": {
	                "shape": "S8"
	              },
	              "Origins": {
	                "shape": "Sb"
	              },
	              "DefaultCacheBehavior": {
	                "shape": "Sn"
	              },
	              "CacheBehaviors": {
	                "shape": "S1b"
	              },
	              "CustomErrorResponses": {
	                "shape": "S1e"
	              },
	              "Comment": {},
	              "PriceClass": {},
	              "Enabled": {
	                "type": "boolean"
	              },
	              "ViewerCertificate": {
	                "shape": "S1j"
	              },
	              "Restrictions": {
	                "shape": "S1n"
	              },
	              "WebACLId": {},
	              "HttpVersion": {},
	              "IsIPV6Enabled": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	}
	},{}],24:[function(require,module,exports){
	arguments[4][21][0].apply(exports,arguments)
	},{"dup":21}],25:[function(require,module,exports){
	arguments[4][19][0].apply(exports,arguments)
	},{"dup":19}],26:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2018-06-18",
	    "endpointPrefix": "cloudfront",
	    "globalEndpoint": "cloudfront.amazonaws.com",
	    "protocol": "rest-xml",
	    "serviceAbbreviation": "CloudFront",
	    "serviceFullName": "Amazon CloudFront",
	    "serviceId": "CloudFront",
	    "signatureVersion": "v4",
	    "uid": "cloudfront-2018-06-18"
	  },
	  "operations": {
	    "CreateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "requestUri": "/2018-06-18/origin-access-identity/cloudfront",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "CreateDistribution": {
	      "http": {
	        "requestUri": "/2018-06-18/distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1t"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateDistributionWithTags": {
	      "http": {
	        "requestUri": "/2018-06-18/distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfigWithTags"
	        ],
	        "members": {
	          "DistributionConfigWithTags": {
	            "locationName": "DistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            },
	            "type": "structure",
	            "required": [
	              "DistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "DistributionConfig": {
	                "shape": "S7"
	              },
	              "Tags": {
	                "shape": "S22"
	              }
	            }
	          }
	        },
	        "payload": "DistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1t"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateFieldLevelEncryptionConfig": {
	      "http": {
	        "requestUri": "/2018-06-18/field-level-encryption",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionConfig"
	        ],
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S29",
	            "locationName": "FieldLevelEncryptionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2k"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "CreateFieldLevelEncryptionProfile": {
	      "http": {
	        "requestUri": "/2018-06-18/field-level-encryption-profile",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionProfileConfig"
	        ],
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2m",
	            "locationName": "FieldLevelEncryptionProfileConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S2t"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "CreateInvalidation": {
	      "http": {
	        "requestUri": "/2018-06-18/distribution/{DistributionId}/invalidation",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "InvalidationBatch"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "InvalidationBatch": {
	            "shape": "S2v",
	            "locationName": "InvalidationBatch",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          }
	        },
	        "payload": "InvalidationBatch"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "Invalidation": {
	            "shape": "S2z"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "CreatePublicKey": {
	      "http": {
	        "requestUri": "/2018-06-18/public-key",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicKeyConfig"
	        ],
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S31",
	            "locationName": "PublicKeyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          }
	        },
	        "payload": "PublicKeyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S33"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "CreateStreamingDistribution": {
	      "http": {
	        "requestUri": "/2018-06-18/streaming-distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S35",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S39"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "CreateStreamingDistributionWithTags": {
	      "http": {
	        "requestUri": "/2018-06-18/streaming-distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfigWithTags"
	        ],
	        "members": {
	          "StreamingDistributionConfigWithTags": {
	            "locationName": "StreamingDistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            },
	            "type": "structure",
	            "required": [
	              "StreamingDistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "StreamingDistributionConfig": {
	                "shape": "S35"
	              },
	              "Tags": {
	                "shape": "S22"
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S39"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "DeleteCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-06-18/origin-access-identity/cloudfront/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-06-18/distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-06-18/field-level-encryption/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-06-18/field-level-encryption-profile/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeletePublicKey": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-06-18/public-key/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteStreamingDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-06-18/streaming-distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "GetCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/origin-access-identity/cloudfront/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "GetCloudFrontOriginAccessIdentityConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      }
	    },
	    "GetDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1t"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "GetDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "DistributionConfig"
	      }
	    },
	    "GetFieldLevelEncryption": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/field-level-encryption/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2k"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "GetFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/field-level-encryption/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S29"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      }
	    },
	    "GetFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/field-level-encryption-profile/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S2t"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "GetFieldLevelEncryptionProfileConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/field-level-encryption-profile/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2m"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      }
	    },
	    "GetInvalidation": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/distribution/{DistributionId}/invalidation/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "Id"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Invalidation": {
	            "shape": "S2z"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "GetPublicKey": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/public-key/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S33"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "GetPublicKeyConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/public-key/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S31"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKeyConfig"
	      }
	    },
	    "GetStreamingDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/streaming-distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S39"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "GetStreamingDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S35"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      }
	    },
	    "ListCloudFrontOriginAccessIdentities": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/origin-access-identity/cloudfront"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "CloudFrontOriginAccessIdentitySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "S3CanonicalUserId",
	                    "Comment"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "S3CanonicalUserId": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityList"
	      }
	    },
	    "ListDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S4g"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListDistributionsByWebACLId": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/distributionsByWebACLId/{WebACLId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebACLId"
	        ],
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "WebACLId": {
	            "location": "uri",
	            "locationName": "WebACLId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S4g"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListFieldLevelEncryptionConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/field-level-encryption"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "FieldLevelEncryptionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "LastModifiedTime"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "Comment": {},
	                    "QueryArgProfileConfig": {
	                      "shape": "S2a"
	                    },
	                    "ContentTypeProfileConfig": {
	                      "shape": "S2e"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionList"
	      }
	    },
	    "ListFieldLevelEncryptionProfiles": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/field-level-encryption-profile"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfileList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "FieldLevelEncryptionProfileSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "LastModifiedTime",
	                    "Name",
	                    "EncryptionEntities"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "Name": {},
	                    "EncryptionEntities": {
	                      "shape": "S2n"
	                    },
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileList"
	      }
	    },
	    "ListInvalidations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/distribution/{DistributionId}/invalidation"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InvalidationList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "InvalidationSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "CreateTime",
	                    "Status"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "CreateTime": {
	                      "type": "timestamp"
	                    },
	                    "Status": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "InvalidationList"
	      }
	    },
	    "ListPublicKeys": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/public-key"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKeyList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "PublicKeySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "Name",
	                    "CreatedTime",
	                    "EncodedKey"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "Name": {},
	                    "CreatedTime": {
	                      "type": "timestamp"
	                    },
	                    "EncodedKey": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "PublicKeyList"
	      }
	    },
	    "ListStreamingDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/streaming-distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "StreamingDistributionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "ARN",
	                    "Status",
	                    "LastModifiedTime",
	                    "DomainName",
	                    "S3Origin",
	                    "Aliases",
	                    "TrustedSigners",
	                    "Comment",
	                    "PriceClass",
	                    "Enabled"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "ARN": {},
	                    "Status": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "DomainName": {},
	                    "S3Origin": {
	                      "shape": "S36"
	                    },
	                    "Aliases": {
	                      "shape": "S8"
	                    },
	                    "TrustedSigners": {
	                      "shape": "Sy"
	                    },
	                    "Comment": {},
	                    "PriceClass": {},
	                    "Enabled": {
	                      "type": "boolean"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionList"
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-06-18/tagging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "S22"
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/2018-06-18/tagging?Operation=Tag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "Tags"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "Tags": {
	            "shape": "S22",
	            "locationName": "Tags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "requestUri": "/2018-06-18/tagging?Operation=Untag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "TagKeys"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "TagKeys": {
	            "locationName": "TagKeys",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            },
	            "type": "structure",
	            "members": {
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "Key"
	                }
	              }
	            }
	          }
	        },
	        "payload": "TagKeys"
	      }
	    },
	    "UpdateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-06-18/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig",
	          "Id"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "UpdateDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-06-18/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S1t"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "UpdateFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-06-18/field-level-encryption/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionConfig",
	          "Id"
	        ],
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S29",
	            "locationName": "FieldLevelEncryptionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2k"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "UpdateFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-06-18/field-level-encryption-profile/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionProfileConfig",
	          "Id"
	        ],
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2m",
	            "locationName": "FieldLevelEncryptionProfileConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S2t"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "UpdatePublicKey": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-06-18/public-key/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicKeyConfig",
	          "Id"
	        ],
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S31",
	            "locationName": "PublicKeyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "PublicKeyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S33"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "UpdateStreamingDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-06-18/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S35",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S39"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Comment"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {}
	      }
	    },
	    "S5": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "S3CanonicalUserId"
	      ],
	      "members": {
	        "Id": {},
	        "S3CanonicalUserId": {},
	        "CloudFrontOriginAccessIdentityConfig": {
	          "shape": "S2"
	        }
	      }
	    },
	    "S7": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Origins",
	        "DefaultCacheBehavior",
	        "Comment",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Aliases": {
	          "shape": "S8"
	        },
	        "DefaultRootObject": {},
	        "Origins": {
	          "shape": "Sb"
	        },
	        "DefaultCacheBehavior": {
	          "shape": "Sn"
	        },
	        "CacheBehaviors": {
	          "shape": "S1b"
	        },
	        "CustomErrorResponses": {
	          "shape": "S1e"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "IncludeCookies",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "IncludeCookies": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        },
	        "ViewerCertificate": {
	          "shape": "S1j"
	        },
	        "Restrictions": {
	          "shape": "S1n"
	        },
	        "WebACLId": {},
	        "HttpVersion": {},
	        "IsIPV6Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S8": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CNAME"
	          }
	        }
	      }
	    },
	    "Sb": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Origin",
	            "type": "structure",
	            "required": [
	              "Id",
	              "DomainName"
	            ],
	            "members": {
	              "Id": {},
	              "DomainName": {},
	              "OriginPath": {},
	              "CustomHeaders": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "OriginCustomHeader",
	                      "type": "structure",
	                      "required": [
	                        "HeaderName",
	                        "HeaderValue"
	                      ],
	                      "members": {
	                        "HeaderName": {},
	                        "HeaderValue": {}
	                      }
	                    }
	                  }
	                }
	              },
	              "S3OriginConfig": {
	                "type": "structure",
	                "required": [
	                  "OriginAccessIdentity"
	                ],
	                "members": {
	                  "OriginAccessIdentity": {}
	                }
	              },
	              "CustomOriginConfig": {
	                "type": "structure",
	                "required": [
	                  "HTTPPort",
	                  "HTTPSPort",
	                  "OriginProtocolPolicy"
	                ],
	                "members": {
	                  "HTTPPort": {
	                    "type": "integer"
	                  },
	                  "HTTPSPort": {
	                    "type": "integer"
	                  },
	                  "OriginProtocolPolicy": {},
	                  "OriginSslProtocols": {
	                    "type": "structure",
	                    "required": [
	                      "Quantity",
	                      "Items"
	                    ],
	                    "members": {
	                      "Quantity": {
	                        "type": "integer"
	                      },
	                      "Items": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "SslProtocol"
	                        }
	                      }
	                    }
	                  },
	                  "OriginReadTimeout": {
	                    "type": "integer"
	                  },
	                  "OriginKeepaliveTimeout": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "required": [
	        "TargetOriginId",
	        "ForwardedValues",
	        "TrustedSigners",
	        "ViewerProtocolPolicy",
	        "MinTTL"
	      ],
	      "members": {
	        "TargetOriginId": {},
	        "ForwardedValues": {
	          "shape": "So"
	        },
	        "TrustedSigners": {
	          "shape": "Sy"
	        },
	        "ViewerProtocolPolicy": {},
	        "MinTTL": {
	          "type": "long"
	        },
	        "AllowedMethods": {
	          "shape": "S12"
	        },
	        "SmoothStreaming": {
	          "type": "boolean"
	        },
	        "DefaultTTL": {
	          "type": "long"
	        },
	        "MaxTTL": {
	          "type": "long"
	        },
	        "Compress": {
	          "type": "boolean"
	        },
	        "LambdaFunctionAssociations": {
	          "shape": "S16"
	        },
	        "FieldLevelEncryptionId": {}
	      }
	    },
	    "So": {
	      "type": "structure",
	      "required": [
	        "QueryString",
	        "Cookies"
	      ],
	      "members": {
	        "QueryString": {
	          "type": "boolean"
	        },
	        "Cookies": {
	          "type": "structure",
	          "required": [
	            "Forward"
	          ],
	          "members": {
	            "Forward": {},
	            "WhitelistedNames": {
	              "type": "structure",
	              "required": [
	                "Quantity"
	              ],
	              "members": {
	                "Quantity": {
	                  "type": "integer"
	                },
	                "Items": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "Name"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "Headers": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        },
	        "QueryStringCacheKeys": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sy": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "AwsAccountNumber"
	          }
	        }
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "required": [
	        "Quantity",
	        "Items"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "shape": "S13"
	        },
	        "CachedMethods": {
	          "type": "structure",
	          "required": [
	            "Quantity",
	            "Items"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "shape": "S13"
	            }
	          }
	        }
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {
	        "locationName": "Method"
	      }
	    },
	    "S16": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "LambdaFunctionAssociation",
	            "type": "structure",
	            "required": [
	              "LambdaFunctionARN",
	              "EventType"
	            ],
	            "members": {
	              "LambdaFunctionARN": {},
	              "EventType": {},
	              "IncludeBody": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1b": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CacheBehavior",
	            "type": "structure",
	            "required": [
	              "PathPattern",
	              "TargetOriginId",
	              "ForwardedValues",
	              "TrustedSigners",
	              "ViewerProtocolPolicy",
	              "MinTTL"
	            ],
	            "members": {
	              "PathPattern": {},
	              "TargetOriginId": {},
	              "ForwardedValues": {
	                "shape": "So"
	              },
	              "TrustedSigners": {
	                "shape": "Sy"
	              },
	              "ViewerProtocolPolicy": {},
	              "MinTTL": {
	                "type": "long"
	              },
	              "AllowedMethods": {
	                "shape": "S12"
	              },
	              "SmoothStreaming": {
	                "type": "boolean"
	              },
	              "DefaultTTL": {
	                "type": "long"
	              },
	              "MaxTTL": {
	                "type": "long"
	              },
	              "Compress": {
	                "type": "boolean"
	              },
	              "LambdaFunctionAssociations": {
	                "shape": "S16"
	              },
	              "FieldLevelEncryptionId": {}
	            }
	          }
	        }
	      }
	    },
	    "S1e": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CustomErrorResponse",
	            "type": "structure",
	            "required": [
	              "ErrorCode"
	            ],
	            "members": {
	              "ErrorCode": {
	                "type": "integer"
	              },
	              "ResponsePagePath": {},
	              "ResponseCode": {},
	              "ErrorCachingMinTTL": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1j": {
	      "type": "structure",
	      "members": {
	        "CloudFrontDefaultCertificate": {
	          "type": "boolean"
	        },
	        "IAMCertificateId": {},
	        "ACMCertificateArn": {},
	        "SSLSupportMethod": {},
	        "MinimumProtocolVersion": {},
	        "Certificate": {
	          "deprecated": true
	        },
	        "CertificateSource": {
	          "deprecated": true
	        }
	      }
	    },
	    "S1n": {
	      "type": "structure",
	      "required": [
	        "GeoRestriction"
	      ],
	      "members": {
	        "GeoRestriction": {
	          "type": "structure",
	          "required": [
	            "RestrictionType",
	            "Quantity"
	          ],
	          "members": {
	            "RestrictionType": {},
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Location"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1t": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "LastModifiedTime",
	        "InProgressInvalidationBatches",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "DistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "InProgressInvalidationBatches": {
	          "type": "integer"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S1v"
	        },
	        "DistributionConfig": {
	          "shape": "S7"
	        }
	      }
	    },
	    "S1v": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Signer",
	            "type": "structure",
	            "members": {
	              "AwsAccountNumber": {},
	              "KeyPairIds": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "KeyPairId"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S22": {
	      "type": "structure",
	      "members": {
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Tag",
	            "type": "structure",
	            "required": [
	              "Key"
	            ],
	            "members": {
	              "Key": {},
	              "Value": {}
	            }
	          }
	        }
	      }
	    },
	    "S29": {
	      "type": "structure",
	      "required": [
	        "CallerReference"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {},
	        "QueryArgProfileConfig": {
	          "shape": "S2a"
	        },
	        "ContentTypeProfileConfig": {
	          "shape": "S2e"
	        }
	      }
	    },
	    "S2a": {
	      "type": "structure",
	      "required": [
	        "ForwardWhenQueryArgProfileIsUnknown"
	      ],
	      "members": {
	        "ForwardWhenQueryArgProfileIsUnknown": {
	          "type": "boolean"
	        },
	        "QueryArgProfiles": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "QueryArgProfile",
	                "type": "structure",
	                "required": [
	                  "QueryArg",
	                  "ProfileId"
	                ],
	                "members": {
	                  "QueryArg": {},
	                  "ProfileId": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2e": {
	      "type": "structure",
	      "required": [
	        "ForwardWhenContentTypeIsUnknown"
	      ],
	      "members": {
	        "ForwardWhenContentTypeIsUnknown": {
	          "type": "boolean"
	        },
	        "ContentTypeProfiles": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "ContentTypeProfile",
	                "type": "structure",
	                "required": [
	                  "Format",
	                  "ContentType"
	                ],
	                "members": {
	                  "Format": {},
	                  "ProfileId": {},
	                  "ContentType": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2k": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "FieldLevelEncryptionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "FieldLevelEncryptionConfig": {
	          "shape": "S29"
	        }
	      }
	    },
	    "S2m": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "CallerReference",
	        "EncryptionEntities"
	      ],
	      "members": {
	        "Name": {},
	        "CallerReference": {},
	        "Comment": {},
	        "EncryptionEntities": {
	          "shape": "S2n"
	        }
	      }
	    },
	    "S2n": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "EncryptionEntity",
	            "type": "structure",
	            "required": [
	              "PublicKeyId",
	              "ProviderId",
	              "FieldPatterns"
	            ],
	            "members": {
	              "PublicKeyId": {},
	              "ProviderId": {},
	              "FieldPatterns": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "FieldPattern"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2t": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "FieldLevelEncryptionProfileConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "FieldLevelEncryptionProfileConfig": {
	          "shape": "S2m"
	        }
	      }
	    },
	    "S2v": {
	      "type": "structure",
	      "required": [
	        "Paths",
	        "CallerReference"
	      ],
	      "members": {
	        "Paths": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Path"
	              }
	            }
	          }
	        },
	        "CallerReference": {}
	      }
	    },
	    "S2z": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "Status",
	        "CreateTime",
	        "InvalidationBatch"
	      ],
	      "members": {
	        "Id": {},
	        "Status": {},
	        "CreateTime": {
	          "type": "timestamp"
	        },
	        "InvalidationBatch": {
	          "shape": "S2v"
	        }
	      }
	    },
	    "S31": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Name",
	        "EncodedKey"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Name": {},
	        "EncodedKey": {},
	        "Comment": {}
	      }
	    },
	    "S33": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "CreatedTime",
	        "PublicKeyConfig"
	      ],
	      "members": {
	        "Id": {},
	        "CreatedTime": {
	          "type": "timestamp"
	        },
	        "PublicKeyConfig": {
	          "shape": "S31"
	        }
	      }
	    },
	    "S35": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "S3Origin",
	        "Comment",
	        "TrustedSigners",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "S3Origin": {
	          "shape": "S36"
	        },
	        "Aliases": {
	          "shape": "S8"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "TrustedSigners": {
	          "shape": "Sy"
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S36": {
	      "type": "structure",
	      "required": [
	        "DomainName",
	        "OriginAccessIdentity"
	      ],
	      "members": {
	        "DomainName": {},
	        "OriginAccessIdentity": {}
	      }
	    },
	    "S39": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "StreamingDistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S1v"
	        },
	        "StreamingDistributionConfig": {
	          "shape": "S35"
	        }
	      }
	    },
	    "S4g": {
	      "type": "structure",
	      "required": [
	        "Marker",
	        "MaxItems",
	        "IsTruncated",
	        "Quantity"
	      ],
	      "members": {
	        "Marker": {},
	        "NextMarker": {},
	        "MaxItems": {
	          "type": "integer"
	        },
	        "IsTruncated": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "DistributionSummary",
	            "type": "structure",
	            "required": [
	              "Id",
	              "ARN",
	              "Status",
	              "LastModifiedTime",
	              "DomainName",
	              "Aliases",
	              "Origins",
	              "DefaultCacheBehavior",
	              "CacheBehaviors",
	              "CustomErrorResponses",
	              "Comment",
	              "PriceClass",
	              "Enabled",
	              "ViewerCertificate",
	              "Restrictions",
	              "WebACLId",
	              "HttpVersion",
	              "IsIPV6Enabled"
	            ],
	            "members": {
	              "Id": {},
	              "ARN": {},
	              "Status": {},
	              "LastModifiedTime": {
	                "type": "timestamp"
	              },
	              "DomainName": {},
	              "Aliases": {
	                "shape": "S8"
	              },
	              "Origins": {
	                "shape": "Sb"
	              },
	              "DefaultCacheBehavior": {
	                "shape": "Sn"
	              },
	              "CacheBehaviors": {
	                "shape": "S1b"
	              },
	              "CustomErrorResponses": {
	                "shape": "S1e"
	              },
	              "Comment": {},
	              "PriceClass": {},
	              "Enabled": {
	                "type": "boolean"
	              },
	              "ViewerCertificate": {
	                "shape": "S1j"
	              },
	              "Restrictions": {
	                "shape": "S1n"
	              },
	              "WebACLId": {},
	              "HttpVersion": {},
	              "IsIPV6Enabled": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	}
	},{}],27:[function(require,module,exports){
	arguments[4][21][0].apply(exports,arguments)
	},{"dup":21}],28:[function(require,module,exports){
	arguments[4][19][0].apply(exports,arguments)
	},{"dup":19}],29:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2018-11-05",
	    "endpointPrefix": "cloudfront",
	    "globalEndpoint": "cloudfront.amazonaws.com",
	    "protocol": "rest-xml",
	    "serviceAbbreviation": "CloudFront",
	    "serviceFullName": "Amazon CloudFront",
	    "serviceId": "CloudFront",
	    "signatureVersion": "v4",
	    "uid": "cloudfront-2018-11-05"
	  },
	  "operations": {
	    "CreateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "requestUri": "/2018-11-05/origin-access-identity/cloudfront",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "CreateDistribution": {
	      "http": {
	        "requestUri": "/2018-11-05/distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S22"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateDistributionWithTags": {
	      "http": {
	        "requestUri": "/2018-11-05/distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfigWithTags"
	        ],
	        "members": {
	          "DistributionConfigWithTags": {
	            "locationName": "DistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            },
	            "type": "structure",
	            "required": [
	              "DistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "DistributionConfig": {
	                "shape": "S7"
	              },
	              "Tags": {
	                "shape": "S2b"
	              }
	            }
	          }
	        },
	        "payload": "DistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S22"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateFieldLevelEncryptionConfig": {
	      "http": {
	        "requestUri": "/2018-11-05/field-level-encryption",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionConfig"
	        ],
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S2i",
	            "locationName": "FieldLevelEncryptionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2t"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "CreateFieldLevelEncryptionProfile": {
	      "http": {
	        "requestUri": "/2018-11-05/field-level-encryption-profile",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionProfileConfig"
	        ],
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2v",
	            "locationName": "FieldLevelEncryptionProfileConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S32"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "CreateInvalidation": {
	      "http": {
	        "requestUri": "/2018-11-05/distribution/{DistributionId}/invalidation",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "InvalidationBatch"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "InvalidationBatch": {
	            "shape": "S34",
	            "locationName": "InvalidationBatch",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          }
	        },
	        "payload": "InvalidationBatch"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "Invalidation": {
	            "shape": "S38"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "CreatePublicKey": {
	      "http": {
	        "requestUri": "/2018-11-05/public-key",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicKeyConfig"
	        ],
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S3a",
	            "locationName": "PublicKeyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          }
	        },
	        "payload": "PublicKeyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S3c"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "CreateStreamingDistribution": {
	      "http": {
	        "requestUri": "/2018-11-05/streaming-distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S3e",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S3i"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "CreateStreamingDistributionWithTags": {
	      "http": {
	        "requestUri": "/2018-11-05/streaming-distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfigWithTags"
	        ],
	        "members": {
	          "StreamingDistributionConfigWithTags": {
	            "locationName": "StreamingDistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            },
	            "type": "structure",
	            "required": [
	              "StreamingDistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "StreamingDistributionConfig": {
	                "shape": "S3e"
	              },
	              "Tags": {
	                "shape": "S2b"
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S3i"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "DeleteCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-11-05/origin-access-identity/cloudfront/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-11-05/distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-11-05/field-level-encryption/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-11-05/field-level-encryption-profile/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeletePublicKey": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-11-05/public-key/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteStreamingDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-11-05/streaming-distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "GetCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/origin-access-identity/cloudfront/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "GetCloudFrontOriginAccessIdentityConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      }
	    },
	    "GetDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S22"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "GetDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "DistributionConfig"
	      }
	    },
	    "GetFieldLevelEncryption": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/field-level-encryption/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2t"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "GetFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/field-level-encryption/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S2i"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      }
	    },
	    "GetFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/field-level-encryption-profile/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S32"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "GetFieldLevelEncryptionProfileConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/field-level-encryption-profile/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2v"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      }
	    },
	    "GetInvalidation": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/distribution/{DistributionId}/invalidation/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "Id"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Invalidation": {
	            "shape": "S38"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "GetPublicKey": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/public-key/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S3c"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "GetPublicKeyConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/public-key/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S3a"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKeyConfig"
	      }
	    },
	    "GetStreamingDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/streaming-distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S3i"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "GetStreamingDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S3e"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      }
	    },
	    "ListCloudFrontOriginAccessIdentities": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/origin-access-identity/cloudfront"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "CloudFrontOriginAccessIdentitySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "S3CanonicalUserId",
	                    "Comment"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "S3CanonicalUserId": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityList"
	      }
	    },
	    "ListDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S4p"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListDistributionsByWebACLId": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/distributionsByWebACLId/{WebACLId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebACLId"
	        ],
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "WebACLId": {
	            "location": "uri",
	            "locationName": "WebACLId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S4p"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListFieldLevelEncryptionConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/field-level-encryption"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "FieldLevelEncryptionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "LastModifiedTime"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "Comment": {},
	                    "QueryArgProfileConfig": {
	                      "shape": "S2j"
	                    },
	                    "ContentTypeProfileConfig": {
	                      "shape": "S2n"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionList"
	      }
	    },
	    "ListFieldLevelEncryptionProfiles": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/field-level-encryption-profile"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfileList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "FieldLevelEncryptionProfileSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "LastModifiedTime",
	                    "Name",
	                    "EncryptionEntities"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "Name": {},
	                    "EncryptionEntities": {
	                      "shape": "S2w"
	                    },
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileList"
	      }
	    },
	    "ListInvalidations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/distribution/{DistributionId}/invalidation"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InvalidationList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "InvalidationSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "CreateTime",
	                    "Status"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "CreateTime": {
	                      "type": "timestamp"
	                    },
	                    "Status": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "InvalidationList"
	      }
	    },
	    "ListPublicKeys": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/public-key"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKeyList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "PublicKeySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "Name",
	                    "CreatedTime",
	                    "EncodedKey"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "Name": {},
	                    "CreatedTime": {
	                      "type": "timestamp"
	                    },
	                    "EncodedKey": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "PublicKeyList"
	      }
	    },
	    "ListStreamingDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/streaming-distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "StreamingDistributionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "ARN",
	                    "Status",
	                    "LastModifiedTime",
	                    "DomainName",
	                    "S3Origin",
	                    "Aliases",
	                    "TrustedSigners",
	                    "Comment",
	                    "PriceClass",
	                    "Enabled"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "ARN": {},
	                    "Status": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "DomainName": {},
	                    "S3Origin": {
	                      "shape": "S3f"
	                    },
	                    "Aliases": {
	                      "shape": "S8"
	                    },
	                    "TrustedSigners": {
	                      "shape": "S17"
	                    },
	                    "Comment": {},
	                    "PriceClass": {},
	                    "Enabled": {
	                      "type": "boolean"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionList"
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-11-05/tagging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "S2b"
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/2018-11-05/tagging?Operation=Tag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "Tags"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "Tags": {
	            "shape": "S2b",
	            "locationName": "Tags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "requestUri": "/2018-11-05/tagging?Operation=Untag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "TagKeys"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "TagKeys": {
	            "locationName": "TagKeys",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            },
	            "type": "structure",
	            "members": {
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "Key"
	                }
	              }
	            }
	          }
	        },
	        "payload": "TagKeys"
	      }
	    },
	    "UpdateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-11-05/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig",
	          "Id"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "UpdateDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-11-05/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S22"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "UpdateFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-11-05/field-level-encryption/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionConfig",
	          "Id"
	        ],
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S2i",
	            "locationName": "FieldLevelEncryptionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2t"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "UpdateFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-11-05/field-level-encryption-profile/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionProfileConfig",
	          "Id"
	        ],
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2v",
	            "locationName": "FieldLevelEncryptionProfileConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S32"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "UpdatePublicKey": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-11-05/public-key/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicKeyConfig",
	          "Id"
	        ],
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S3a",
	            "locationName": "PublicKeyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "PublicKeyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S3c"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "UpdateStreamingDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2018-11-05/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S3e",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S3i"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Comment"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {}
	      }
	    },
	    "S5": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "S3CanonicalUserId"
	      ],
	      "members": {
	        "Id": {},
	        "S3CanonicalUserId": {},
	        "CloudFrontOriginAccessIdentityConfig": {
	          "shape": "S2"
	        }
	      }
	    },
	    "S7": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Origins",
	        "DefaultCacheBehavior",
	        "Comment",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Aliases": {
	          "shape": "S8"
	        },
	        "DefaultRootObject": {},
	        "Origins": {
	          "shape": "Sb"
	        },
	        "OriginGroups": {
	          "shape": "Sn"
	        },
	        "DefaultCacheBehavior": {
	          "shape": "Sw"
	        },
	        "CacheBehaviors": {
	          "shape": "S1k"
	        },
	        "CustomErrorResponses": {
	          "shape": "S1n"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "IncludeCookies",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "IncludeCookies": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        },
	        "ViewerCertificate": {
	          "shape": "S1s"
	        },
	        "Restrictions": {
	          "shape": "S1w"
	        },
	        "WebACLId": {},
	        "HttpVersion": {},
	        "IsIPV6Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S8": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CNAME"
	          }
	        }
	      }
	    },
	    "Sb": {
	      "type": "structure",
	      "required": [
	        "Quantity",
	        "Items"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Origin",
	            "type": "structure",
	            "required": [
	              "Id",
	              "DomainName"
	            ],
	            "members": {
	              "Id": {},
	              "DomainName": {},
	              "OriginPath": {},
	              "CustomHeaders": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "OriginCustomHeader",
	                      "type": "structure",
	                      "required": [
	                        "HeaderName",
	                        "HeaderValue"
	                      ],
	                      "members": {
	                        "HeaderName": {},
	                        "HeaderValue": {}
	                      }
	                    }
	                  }
	                }
	              },
	              "S3OriginConfig": {
	                "type": "structure",
	                "required": [
	                  "OriginAccessIdentity"
	                ],
	                "members": {
	                  "OriginAccessIdentity": {}
	                }
	              },
	              "CustomOriginConfig": {
	                "type": "structure",
	                "required": [
	                  "HTTPPort",
	                  "HTTPSPort",
	                  "OriginProtocolPolicy"
	                ],
	                "members": {
	                  "HTTPPort": {
	                    "type": "integer"
	                  },
	                  "HTTPSPort": {
	                    "type": "integer"
	                  },
	                  "OriginProtocolPolicy": {},
	                  "OriginSslProtocols": {
	                    "type": "structure",
	                    "required": [
	                      "Quantity",
	                      "Items"
	                    ],
	                    "members": {
	                      "Quantity": {
	                        "type": "integer"
	                      },
	                      "Items": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "SslProtocol"
	                        }
	                      }
	                    }
	                  },
	                  "OriginReadTimeout": {
	                    "type": "integer"
	                  },
	                  "OriginKeepaliveTimeout": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "OriginGroup",
	            "type": "structure",
	            "required": [
	              "Id",
	              "FailoverCriteria",
	              "Members"
	            ],
	            "members": {
	              "Id": {},
	              "FailoverCriteria": {
	                "type": "structure",
	                "required": [
	                  "StatusCodes"
	                ],
	                "members": {
	                  "StatusCodes": {
	                    "type": "structure",
	                    "required": [
	                      "Quantity",
	                      "Items"
	                    ],
	                    "members": {
	                      "Quantity": {
	                        "type": "integer"
	                      },
	                      "Items": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "StatusCode",
	                          "type": "integer"
	                        }
	                      }
	                    }
	                  }
	                }
	              },
	              "Members": {
	                "type": "structure",
	                "required": [
	                  "Quantity",
	                  "Items"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "OriginGroupMember",
	                      "type": "structure",
	                      "required": [
	                        "OriginId"
	                      ],
	                      "members": {
	                        "OriginId": {}
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sw": {
	      "type": "structure",
	      "required": [
	        "TargetOriginId",
	        "ForwardedValues",
	        "TrustedSigners",
	        "ViewerProtocolPolicy",
	        "MinTTL"
	      ],
	      "members": {
	        "TargetOriginId": {},
	        "ForwardedValues": {
	          "shape": "Sx"
	        },
	        "TrustedSigners": {
	          "shape": "S17"
	        },
	        "ViewerProtocolPolicy": {},
	        "MinTTL": {
	          "type": "long"
	        },
	        "AllowedMethods": {
	          "shape": "S1b"
	        },
	        "SmoothStreaming": {
	          "type": "boolean"
	        },
	        "DefaultTTL": {
	          "type": "long"
	        },
	        "MaxTTL": {
	          "type": "long"
	        },
	        "Compress": {
	          "type": "boolean"
	        },
	        "LambdaFunctionAssociations": {
	          "shape": "S1f"
	        },
	        "FieldLevelEncryptionId": {}
	      }
	    },
	    "Sx": {
	      "type": "structure",
	      "required": [
	        "QueryString",
	        "Cookies"
	      ],
	      "members": {
	        "QueryString": {
	          "type": "boolean"
	        },
	        "Cookies": {
	          "type": "structure",
	          "required": [
	            "Forward"
	          ],
	          "members": {
	            "Forward": {},
	            "WhitelistedNames": {
	              "type": "structure",
	              "required": [
	                "Quantity"
	              ],
	              "members": {
	                "Quantity": {
	                  "type": "integer"
	                },
	                "Items": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "Name"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "Headers": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        },
	        "QueryStringCacheKeys": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S17": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "AwsAccountNumber"
	          }
	        }
	      }
	    },
	    "S1b": {
	      "type": "structure",
	      "required": [
	        "Quantity",
	        "Items"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "shape": "S1c"
	        },
	        "CachedMethods": {
	          "type": "structure",
	          "required": [
	            "Quantity",
	            "Items"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "shape": "S1c"
	            }
	          }
	        }
	      }
	    },
	    "S1c": {
	      "type": "list",
	      "member": {
	        "locationName": "Method"
	      }
	    },
	    "S1f": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "LambdaFunctionAssociation",
	            "type": "structure",
	            "required": [
	              "LambdaFunctionARN",
	              "EventType"
	            ],
	            "members": {
	              "LambdaFunctionARN": {},
	              "EventType": {},
	              "IncludeBody": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1k": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CacheBehavior",
	            "type": "structure",
	            "required": [
	              "PathPattern",
	              "TargetOriginId",
	              "ForwardedValues",
	              "TrustedSigners",
	              "ViewerProtocolPolicy",
	              "MinTTL"
	            ],
	            "members": {
	              "PathPattern": {},
	              "TargetOriginId": {},
	              "ForwardedValues": {
	                "shape": "Sx"
	              },
	              "TrustedSigners": {
	                "shape": "S17"
	              },
	              "ViewerProtocolPolicy": {},
	              "MinTTL": {
	                "type": "long"
	              },
	              "AllowedMethods": {
	                "shape": "S1b"
	              },
	              "SmoothStreaming": {
	                "type": "boolean"
	              },
	              "DefaultTTL": {
	                "type": "long"
	              },
	              "MaxTTL": {
	                "type": "long"
	              },
	              "Compress": {
	                "type": "boolean"
	              },
	              "LambdaFunctionAssociations": {
	                "shape": "S1f"
	              },
	              "FieldLevelEncryptionId": {}
	            }
	          }
	        }
	      }
	    },
	    "S1n": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CustomErrorResponse",
	            "type": "structure",
	            "required": [
	              "ErrorCode"
	            ],
	            "members": {
	              "ErrorCode": {
	                "type": "integer"
	              },
	              "ResponsePagePath": {},
	              "ResponseCode": {},
	              "ErrorCachingMinTTL": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1s": {
	      "type": "structure",
	      "members": {
	        "CloudFrontDefaultCertificate": {
	          "type": "boolean"
	        },
	        "IAMCertificateId": {},
	        "ACMCertificateArn": {},
	        "SSLSupportMethod": {},
	        "MinimumProtocolVersion": {},
	        "Certificate": {
	          "deprecated": true
	        },
	        "CertificateSource": {
	          "deprecated": true
	        }
	      }
	    },
	    "S1w": {
	      "type": "structure",
	      "required": [
	        "GeoRestriction"
	      ],
	      "members": {
	        "GeoRestriction": {
	          "type": "structure",
	          "required": [
	            "RestrictionType",
	            "Quantity"
	          ],
	          "members": {
	            "RestrictionType": {},
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Location"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S22": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "LastModifiedTime",
	        "InProgressInvalidationBatches",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "DistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "InProgressInvalidationBatches": {
	          "type": "integer"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S24"
	        },
	        "DistributionConfig": {
	          "shape": "S7"
	        }
	      }
	    },
	    "S24": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Signer",
	            "type": "structure",
	            "members": {
	              "AwsAccountNumber": {},
	              "KeyPairIds": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "KeyPairId"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2b": {
	      "type": "structure",
	      "members": {
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Tag",
	            "type": "structure",
	            "required": [
	              "Key"
	            ],
	            "members": {
	              "Key": {},
	              "Value": {}
	            }
	          }
	        }
	      }
	    },
	    "S2i": {
	      "type": "structure",
	      "required": [
	        "CallerReference"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {},
	        "QueryArgProfileConfig": {
	          "shape": "S2j"
	        },
	        "ContentTypeProfileConfig": {
	          "shape": "S2n"
	        }
	      }
	    },
	    "S2j": {
	      "type": "structure",
	      "required": [
	        "ForwardWhenQueryArgProfileIsUnknown"
	      ],
	      "members": {
	        "ForwardWhenQueryArgProfileIsUnknown": {
	          "type": "boolean"
	        },
	        "QueryArgProfiles": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "QueryArgProfile",
	                "type": "structure",
	                "required": [
	                  "QueryArg",
	                  "ProfileId"
	                ],
	                "members": {
	                  "QueryArg": {},
	                  "ProfileId": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2n": {
	      "type": "structure",
	      "required": [
	        "ForwardWhenContentTypeIsUnknown"
	      ],
	      "members": {
	        "ForwardWhenContentTypeIsUnknown": {
	          "type": "boolean"
	        },
	        "ContentTypeProfiles": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "ContentTypeProfile",
	                "type": "structure",
	                "required": [
	                  "Format",
	                  "ContentType"
	                ],
	                "members": {
	                  "Format": {},
	                  "ProfileId": {},
	                  "ContentType": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2t": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "FieldLevelEncryptionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "FieldLevelEncryptionConfig": {
	          "shape": "S2i"
	        }
	      }
	    },
	    "S2v": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "CallerReference",
	        "EncryptionEntities"
	      ],
	      "members": {
	        "Name": {},
	        "CallerReference": {},
	        "Comment": {},
	        "EncryptionEntities": {
	          "shape": "S2w"
	        }
	      }
	    },
	    "S2w": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "EncryptionEntity",
	            "type": "structure",
	            "required": [
	              "PublicKeyId",
	              "ProviderId",
	              "FieldPatterns"
	            ],
	            "members": {
	              "PublicKeyId": {},
	              "ProviderId": {},
	              "FieldPatterns": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "FieldPattern"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S32": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "FieldLevelEncryptionProfileConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "FieldLevelEncryptionProfileConfig": {
	          "shape": "S2v"
	        }
	      }
	    },
	    "S34": {
	      "type": "structure",
	      "required": [
	        "Paths",
	        "CallerReference"
	      ],
	      "members": {
	        "Paths": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Path"
	              }
	            }
	          }
	        },
	        "CallerReference": {}
	      }
	    },
	    "S38": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "Status",
	        "CreateTime",
	        "InvalidationBatch"
	      ],
	      "members": {
	        "Id": {},
	        "Status": {},
	        "CreateTime": {
	          "type": "timestamp"
	        },
	        "InvalidationBatch": {
	          "shape": "S34"
	        }
	      }
	    },
	    "S3a": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Name",
	        "EncodedKey"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Name": {},
	        "EncodedKey": {},
	        "Comment": {}
	      }
	    },
	    "S3c": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "CreatedTime",
	        "PublicKeyConfig"
	      ],
	      "members": {
	        "Id": {},
	        "CreatedTime": {
	          "type": "timestamp"
	        },
	        "PublicKeyConfig": {
	          "shape": "S3a"
	        }
	      }
	    },
	    "S3e": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "S3Origin",
	        "Comment",
	        "TrustedSigners",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "S3Origin": {
	          "shape": "S3f"
	        },
	        "Aliases": {
	          "shape": "S8"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "TrustedSigners": {
	          "shape": "S17"
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S3f": {
	      "type": "structure",
	      "required": [
	        "DomainName",
	        "OriginAccessIdentity"
	      ],
	      "members": {
	        "DomainName": {},
	        "OriginAccessIdentity": {}
	      }
	    },
	    "S3i": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "StreamingDistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S24"
	        },
	        "StreamingDistributionConfig": {
	          "shape": "S3e"
	        }
	      }
	    },
	    "S4p": {
	      "type": "structure",
	      "required": [
	        "Marker",
	        "MaxItems",
	        "IsTruncated",
	        "Quantity"
	      ],
	      "members": {
	        "Marker": {},
	        "NextMarker": {},
	        "MaxItems": {
	          "type": "integer"
	        },
	        "IsTruncated": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "DistributionSummary",
	            "type": "structure",
	            "required": [
	              "Id",
	              "ARN",
	              "Status",
	              "LastModifiedTime",
	              "DomainName",
	              "Aliases",
	              "Origins",
	              "DefaultCacheBehavior",
	              "CacheBehaviors",
	              "CustomErrorResponses",
	              "Comment",
	              "PriceClass",
	              "Enabled",
	              "ViewerCertificate",
	              "Restrictions",
	              "WebACLId",
	              "HttpVersion",
	              "IsIPV6Enabled"
	            ],
	            "members": {
	              "Id": {},
	              "ARN": {},
	              "Status": {},
	              "LastModifiedTime": {
	                "type": "timestamp"
	              },
	              "DomainName": {},
	              "Aliases": {
	                "shape": "S8"
	              },
	              "Origins": {
	                "shape": "Sb"
	              },
	              "OriginGroups": {
	                "shape": "Sn"
	              },
	              "DefaultCacheBehavior": {
	                "shape": "Sw"
	              },
	              "CacheBehaviors": {
	                "shape": "S1k"
	              },
	              "CustomErrorResponses": {
	                "shape": "S1n"
	              },
	              "Comment": {},
	              "PriceClass": {},
	              "Enabled": {
	                "type": "boolean"
	              },
	              "ViewerCertificate": {
	                "shape": "S1s"
	              },
	              "Restrictions": {
	                "shape": "S1w"
	              },
	              "WebACLId": {},
	              "HttpVersion": {},
	              "IsIPV6Enabled": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	}
	},{}],30:[function(require,module,exports){
	arguments[4][21][0].apply(exports,arguments)
	},{"dup":21}],31:[function(require,module,exports){
	arguments[4][19][0].apply(exports,arguments)
	},{"dup":19}],32:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2019-03-26",
	    "endpointPrefix": "cloudfront",
	    "globalEndpoint": "cloudfront.amazonaws.com",
	    "protocol": "rest-xml",
	    "serviceAbbreviation": "CloudFront",
	    "serviceFullName": "Amazon CloudFront",
	    "serviceId": "CloudFront",
	    "signatureVersion": "v4",
	    "uid": "cloudfront-2019-03-26"
	  },
	  "operations": {
	    "CreateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "requestUri": "/2019-03-26/origin-access-identity/cloudfront",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "CreateDistribution": {
	      "http": {
	        "requestUri": "/2019-03-26/distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S23"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateDistributionWithTags": {
	      "http": {
	        "requestUri": "/2019-03-26/distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfigWithTags"
	        ],
	        "members": {
	          "DistributionConfigWithTags": {
	            "locationName": "DistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            },
	            "type": "structure",
	            "required": [
	              "DistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "DistributionConfig": {
	                "shape": "S7"
	              },
	              "Tags": {
	                "shape": "S2f"
	              }
	            }
	          }
	        },
	        "payload": "DistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S23"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateFieldLevelEncryptionConfig": {
	      "http": {
	        "requestUri": "/2019-03-26/field-level-encryption",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionConfig"
	        ],
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S2m",
	            "locationName": "FieldLevelEncryptionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2x"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "CreateFieldLevelEncryptionProfile": {
	      "http": {
	        "requestUri": "/2019-03-26/field-level-encryption-profile",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionProfileConfig"
	        ],
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2z",
	            "locationName": "FieldLevelEncryptionProfileConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S36"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "CreateInvalidation": {
	      "http": {
	        "requestUri": "/2019-03-26/distribution/{DistributionId}/invalidation",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "InvalidationBatch"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "InvalidationBatch": {
	            "shape": "S38",
	            "locationName": "InvalidationBatch",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          }
	        },
	        "payload": "InvalidationBatch"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "Invalidation": {
	            "shape": "S3c"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "CreatePublicKey": {
	      "http": {
	        "requestUri": "/2019-03-26/public-key",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicKeyConfig"
	        ],
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S3e",
	            "locationName": "PublicKeyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          }
	        },
	        "payload": "PublicKeyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S3g"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "CreateStreamingDistribution": {
	      "http": {
	        "requestUri": "/2019-03-26/streaming-distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S3i",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S3m"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "CreateStreamingDistributionWithTags": {
	      "http": {
	        "requestUri": "/2019-03-26/streaming-distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfigWithTags"
	        ],
	        "members": {
	          "StreamingDistributionConfigWithTags": {
	            "locationName": "StreamingDistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            },
	            "type": "structure",
	            "required": [
	              "StreamingDistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "StreamingDistributionConfig": {
	                "shape": "S3i"
	              },
	              "Tags": {
	                "shape": "S2f"
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S3m"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "DeleteCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2019-03-26/origin-access-identity/cloudfront/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2019-03-26/distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2019-03-26/field-level-encryption/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2019-03-26/field-level-encryption-profile/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeletePublicKey": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2019-03-26/public-key/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteStreamingDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2019-03-26/streaming-distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "GetCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/origin-access-identity/cloudfront/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "GetCloudFrontOriginAccessIdentityConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      }
	    },
	    "GetDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S23"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "GetDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "DistributionConfig"
	      }
	    },
	    "GetFieldLevelEncryption": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/field-level-encryption/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2x"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "GetFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/field-level-encryption/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S2m"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      }
	    },
	    "GetFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/field-level-encryption-profile/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S36"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "GetFieldLevelEncryptionProfileConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/field-level-encryption-profile/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2z"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      }
	    },
	    "GetInvalidation": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/distribution/{DistributionId}/invalidation/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "Id"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Invalidation": {
	            "shape": "S3c"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "GetPublicKey": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/public-key/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S3g"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "GetPublicKeyConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/public-key/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S3e"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKeyConfig"
	      }
	    },
	    "GetStreamingDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/streaming-distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S3m"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "GetStreamingDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S3i"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      }
	    },
	    "ListCloudFrontOriginAccessIdentities": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/origin-access-identity/cloudfront"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "CloudFrontOriginAccessIdentitySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "S3CanonicalUserId",
	                    "Comment"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "S3CanonicalUserId": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityList"
	      }
	    },
	    "ListDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S4t"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListDistributionsByWebACLId": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/distributionsByWebACLId/{WebACLId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebACLId"
	        ],
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "WebACLId": {
	            "location": "uri",
	            "locationName": "WebACLId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S4t"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListFieldLevelEncryptionConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/field-level-encryption"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "FieldLevelEncryptionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "LastModifiedTime"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "Comment": {},
	                    "QueryArgProfileConfig": {
	                      "shape": "S2n"
	                    },
	                    "ContentTypeProfileConfig": {
	                      "shape": "S2r"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionList"
	      }
	    },
	    "ListFieldLevelEncryptionProfiles": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/field-level-encryption-profile"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfileList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "FieldLevelEncryptionProfileSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "LastModifiedTime",
	                    "Name",
	                    "EncryptionEntities"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "Name": {},
	                    "EncryptionEntities": {
	                      "shape": "S30"
	                    },
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileList"
	      }
	    },
	    "ListInvalidations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/distribution/{DistributionId}/invalidation"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InvalidationList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "InvalidationSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "CreateTime",
	                    "Status"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "CreateTime": {
	                      "type": "timestamp"
	                    },
	                    "Status": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "InvalidationList"
	      }
	    },
	    "ListPublicKeys": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/public-key"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKeyList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "PublicKeySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "Name",
	                    "CreatedTime",
	                    "EncodedKey"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "Name": {},
	                    "CreatedTime": {
	                      "type": "timestamp"
	                    },
	                    "EncodedKey": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "PublicKeyList"
	      }
	    },
	    "ListStreamingDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/streaming-distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "StreamingDistributionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "ARN",
	                    "Status",
	                    "LastModifiedTime",
	                    "DomainName",
	                    "S3Origin",
	                    "Aliases",
	                    "TrustedSigners",
	                    "Comment",
	                    "PriceClass",
	                    "Enabled"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "ARN": {},
	                    "Status": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "DomainName": {},
	                    "S3Origin": {
	                      "shape": "S3j"
	                    },
	                    "Aliases": {
	                      "shape": "S8"
	                    },
	                    "TrustedSigners": {
	                      "shape": "S17"
	                    },
	                    "Comment": {},
	                    "PriceClass": {},
	                    "Enabled": {
	                      "type": "boolean"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionList"
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-03-26/tagging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "S2f"
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/2019-03-26/tagging?Operation=Tag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "Tags"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "Tags": {
	            "shape": "S2f",
	            "locationName": "Tags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "requestUri": "/2019-03-26/tagging?Operation=Untag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "TagKeys"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "TagKeys": {
	            "locationName": "TagKeys",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            },
	            "type": "structure",
	            "members": {
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "Key"
	                }
	              }
	            }
	          }
	        },
	        "payload": "TagKeys"
	      }
	    },
	    "UpdateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2019-03-26/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig",
	          "Id"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "S2",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "S5"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "UpdateDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2019-03-26/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "S7",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S23"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "UpdateFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2019-03-26/field-level-encryption/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionConfig",
	          "Id"
	        ],
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S2m",
	            "locationName": "FieldLevelEncryptionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S2x"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "UpdateFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2019-03-26/field-level-encryption-profile/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionProfileConfig",
	          "Id"
	        ],
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S2z",
	            "locationName": "FieldLevelEncryptionProfileConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S36"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "UpdatePublicKey": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2019-03-26/public-key/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicKeyConfig",
	          "Id"
	        ],
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S3e",
	            "locationName": "PublicKeyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "PublicKeyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S3g"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "UpdateStreamingDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2019-03-26/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S3i",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S3m"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Comment"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {}
	      }
	    },
	    "S5": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "S3CanonicalUserId"
	      ],
	      "members": {
	        "Id": {},
	        "S3CanonicalUserId": {},
	        "CloudFrontOriginAccessIdentityConfig": {
	          "shape": "S2"
	        }
	      }
	    },
	    "S7": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Origins",
	        "DefaultCacheBehavior",
	        "Comment",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Aliases": {
	          "shape": "S8"
	        },
	        "DefaultRootObject": {},
	        "Origins": {
	          "shape": "Sb"
	        },
	        "OriginGroups": {
	          "shape": "Sn"
	        },
	        "DefaultCacheBehavior": {
	          "shape": "Sw"
	        },
	        "CacheBehaviors": {
	          "shape": "S1k"
	        },
	        "CustomErrorResponses": {
	          "shape": "S1n"
	        },
	        "Comment": {
	          "type": "string",
	          "sensitive": true
	        },
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "IncludeCookies",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "IncludeCookies": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        },
	        "ViewerCertificate": {
	          "shape": "S1t"
	        },
	        "Restrictions": {
	          "shape": "S1x"
	        },
	        "WebACLId": {},
	        "HttpVersion": {},
	        "IsIPV6Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S8": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CNAME"
	          }
	        }
	      }
	    },
	    "Sb": {
	      "type": "structure",
	      "required": [
	        "Quantity",
	        "Items"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Origin",
	            "type": "structure",
	            "required": [
	              "Id",
	              "DomainName"
	            ],
	            "members": {
	              "Id": {},
	              "DomainName": {},
	              "OriginPath": {},
	              "CustomHeaders": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "OriginCustomHeader",
	                      "type": "structure",
	                      "required": [
	                        "HeaderName",
	                        "HeaderValue"
	                      ],
	                      "members": {
	                        "HeaderName": {},
	                        "HeaderValue": {}
	                      }
	                    }
	                  }
	                }
	              },
	              "S3OriginConfig": {
	                "type": "structure",
	                "required": [
	                  "OriginAccessIdentity"
	                ],
	                "members": {
	                  "OriginAccessIdentity": {}
	                }
	              },
	              "CustomOriginConfig": {
	                "type": "structure",
	                "required": [
	                  "HTTPPort",
	                  "HTTPSPort",
	                  "OriginProtocolPolicy"
	                ],
	                "members": {
	                  "HTTPPort": {
	                    "type": "integer"
	                  },
	                  "HTTPSPort": {
	                    "type": "integer"
	                  },
	                  "OriginProtocolPolicy": {},
	                  "OriginSslProtocols": {
	                    "type": "structure",
	                    "required": [
	                      "Quantity",
	                      "Items"
	                    ],
	                    "members": {
	                      "Quantity": {
	                        "type": "integer"
	                      },
	                      "Items": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "SslProtocol"
	                        }
	                      }
	                    }
	                  },
	                  "OriginReadTimeout": {
	                    "type": "integer"
	                  },
	                  "OriginKeepaliveTimeout": {
	                    "type": "integer"
	                  }
	                }
	              },
	              "ConnectionAttempts": {
	                "type": "integer"
	              },
	              "ConnectionTimeout": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "OriginGroup",
	            "type": "structure",
	            "required": [
	              "Id",
	              "FailoverCriteria",
	              "Members"
	            ],
	            "members": {
	              "Id": {},
	              "FailoverCriteria": {
	                "type": "structure",
	                "required": [
	                  "StatusCodes"
	                ],
	                "members": {
	                  "StatusCodes": {
	                    "type": "structure",
	                    "required": [
	                      "Quantity",
	                      "Items"
	                    ],
	                    "members": {
	                      "Quantity": {
	                        "type": "integer"
	                      },
	                      "Items": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "StatusCode",
	                          "type": "integer"
	                        }
	                      }
	                    }
	                  }
	                }
	              },
	              "Members": {
	                "type": "structure",
	                "required": [
	                  "Quantity",
	                  "Items"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "OriginGroupMember",
	                      "type": "structure",
	                      "required": [
	                        "OriginId"
	                      ],
	                      "members": {
	                        "OriginId": {}
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sw": {
	      "type": "structure",
	      "required": [
	        "TargetOriginId",
	        "ForwardedValues",
	        "TrustedSigners",
	        "ViewerProtocolPolicy",
	        "MinTTL"
	      ],
	      "members": {
	        "TargetOriginId": {},
	        "ForwardedValues": {
	          "shape": "Sx"
	        },
	        "TrustedSigners": {
	          "shape": "S17"
	        },
	        "ViewerProtocolPolicy": {},
	        "MinTTL": {
	          "type": "long"
	        },
	        "AllowedMethods": {
	          "shape": "S1b"
	        },
	        "SmoothStreaming": {
	          "type": "boolean"
	        },
	        "DefaultTTL": {
	          "type": "long"
	        },
	        "MaxTTL": {
	          "type": "long"
	        },
	        "Compress": {
	          "type": "boolean"
	        },
	        "LambdaFunctionAssociations": {
	          "shape": "S1f"
	        },
	        "FieldLevelEncryptionId": {}
	      }
	    },
	    "Sx": {
	      "type": "structure",
	      "required": [
	        "QueryString",
	        "Cookies"
	      ],
	      "members": {
	        "QueryString": {
	          "type": "boolean"
	        },
	        "Cookies": {
	          "type": "structure",
	          "required": [
	            "Forward"
	          ],
	          "members": {
	            "Forward": {},
	            "WhitelistedNames": {
	              "type": "structure",
	              "required": [
	                "Quantity"
	              ],
	              "members": {
	                "Quantity": {
	                  "type": "integer"
	                },
	                "Items": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "Name"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "Headers": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        },
	        "QueryStringCacheKeys": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S17": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "AwsAccountNumber"
	          }
	        }
	      }
	    },
	    "S1b": {
	      "type": "structure",
	      "required": [
	        "Quantity",
	        "Items"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "shape": "S1c"
	        },
	        "CachedMethods": {
	          "type": "structure",
	          "required": [
	            "Quantity",
	            "Items"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "shape": "S1c"
	            }
	          }
	        }
	      }
	    },
	    "S1c": {
	      "type": "list",
	      "member": {
	        "locationName": "Method"
	      }
	    },
	    "S1f": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "LambdaFunctionAssociation",
	            "type": "structure",
	            "required": [
	              "LambdaFunctionARN",
	              "EventType"
	            ],
	            "members": {
	              "LambdaFunctionARN": {},
	              "EventType": {},
	              "IncludeBody": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1k": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CacheBehavior",
	            "type": "structure",
	            "required": [
	              "PathPattern",
	              "TargetOriginId",
	              "ForwardedValues",
	              "TrustedSigners",
	              "ViewerProtocolPolicy",
	              "MinTTL"
	            ],
	            "members": {
	              "PathPattern": {},
	              "TargetOriginId": {},
	              "ForwardedValues": {
	                "shape": "Sx"
	              },
	              "TrustedSigners": {
	                "shape": "S17"
	              },
	              "ViewerProtocolPolicy": {},
	              "MinTTL": {
	                "type": "long"
	              },
	              "AllowedMethods": {
	                "shape": "S1b"
	              },
	              "SmoothStreaming": {
	                "type": "boolean"
	              },
	              "DefaultTTL": {
	                "type": "long"
	              },
	              "MaxTTL": {
	                "type": "long"
	              },
	              "Compress": {
	                "type": "boolean"
	              },
	              "LambdaFunctionAssociations": {
	                "shape": "S1f"
	              },
	              "FieldLevelEncryptionId": {}
	            }
	          }
	        }
	      }
	    },
	    "S1n": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CustomErrorResponse",
	            "type": "structure",
	            "required": [
	              "ErrorCode"
	            ],
	            "members": {
	              "ErrorCode": {
	                "type": "integer"
	              },
	              "ResponsePagePath": {},
	              "ResponseCode": {},
	              "ErrorCachingMinTTL": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1t": {
	      "type": "structure",
	      "members": {
	        "CloudFrontDefaultCertificate": {
	          "type": "boolean"
	        },
	        "IAMCertificateId": {},
	        "ACMCertificateArn": {},
	        "SSLSupportMethod": {},
	        "MinimumProtocolVersion": {},
	        "Certificate": {
	          "deprecated": true
	        },
	        "CertificateSource": {
	          "deprecated": true
	        }
	      }
	    },
	    "S1x": {
	      "type": "structure",
	      "required": [
	        "GeoRestriction"
	      ],
	      "members": {
	        "GeoRestriction": {
	          "type": "structure",
	          "required": [
	            "RestrictionType",
	            "Quantity"
	          ],
	          "members": {
	            "RestrictionType": {},
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Location"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S23": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "LastModifiedTime",
	        "InProgressInvalidationBatches",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "DistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "InProgressInvalidationBatches": {
	          "type": "integer"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S25"
	        },
	        "DistributionConfig": {
	          "shape": "S7"
	        },
	        "AliasICPRecordals": {
	          "shape": "S2a"
	        }
	      }
	    },
	    "S25": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Signer",
	            "type": "structure",
	            "members": {
	              "AwsAccountNumber": {},
	              "KeyPairIds": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "KeyPairId"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2a": {
	      "type": "list",
	      "member": {
	        "locationName": "AliasICPRecordal",
	        "type": "structure",
	        "members": {
	          "CNAME": {},
	          "ICPRecordalStatus": {}
	        }
	      }
	    },
	    "S2f": {
	      "type": "structure",
	      "members": {
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Tag",
	            "type": "structure",
	            "required": [
	              "Key"
	            ],
	            "members": {
	              "Key": {},
	              "Value": {}
	            }
	          }
	        }
	      }
	    },
	    "S2m": {
	      "type": "structure",
	      "required": [
	        "CallerReference"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {},
	        "QueryArgProfileConfig": {
	          "shape": "S2n"
	        },
	        "ContentTypeProfileConfig": {
	          "shape": "S2r"
	        }
	      }
	    },
	    "S2n": {
	      "type": "structure",
	      "required": [
	        "ForwardWhenQueryArgProfileIsUnknown"
	      ],
	      "members": {
	        "ForwardWhenQueryArgProfileIsUnknown": {
	          "type": "boolean"
	        },
	        "QueryArgProfiles": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "QueryArgProfile",
	                "type": "structure",
	                "required": [
	                  "QueryArg",
	                  "ProfileId"
	                ],
	                "members": {
	                  "QueryArg": {},
	                  "ProfileId": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2r": {
	      "type": "structure",
	      "required": [
	        "ForwardWhenContentTypeIsUnknown"
	      ],
	      "members": {
	        "ForwardWhenContentTypeIsUnknown": {
	          "type": "boolean"
	        },
	        "ContentTypeProfiles": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "ContentTypeProfile",
	                "type": "structure",
	                "required": [
	                  "Format",
	                  "ContentType"
	                ],
	                "members": {
	                  "Format": {},
	                  "ProfileId": {},
	                  "ContentType": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2x": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "FieldLevelEncryptionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "FieldLevelEncryptionConfig": {
	          "shape": "S2m"
	        }
	      }
	    },
	    "S2z": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "CallerReference",
	        "EncryptionEntities"
	      ],
	      "members": {
	        "Name": {},
	        "CallerReference": {},
	        "Comment": {},
	        "EncryptionEntities": {
	          "shape": "S30"
	        }
	      }
	    },
	    "S30": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "EncryptionEntity",
	            "type": "structure",
	            "required": [
	              "PublicKeyId",
	              "ProviderId",
	              "FieldPatterns"
	            ],
	            "members": {
	              "PublicKeyId": {},
	              "ProviderId": {},
	              "FieldPatterns": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "FieldPattern"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S36": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "FieldLevelEncryptionProfileConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "FieldLevelEncryptionProfileConfig": {
	          "shape": "S2z"
	        }
	      }
	    },
	    "S38": {
	      "type": "structure",
	      "required": [
	        "Paths",
	        "CallerReference"
	      ],
	      "members": {
	        "Paths": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Path"
	              }
	            }
	          }
	        },
	        "CallerReference": {}
	      }
	    },
	    "S3c": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "Status",
	        "CreateTime",
	        "InvalidationBatch"
	      ],
	      "members": {
	        "Id": {},
	        "Status": {},
	        "CreateTime": {
	          "type": "timestamp"
	        },
	        "InvalidationBatch": {
	          "shape": "S38"
	        }
	      }
	    },
	    "S3e": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Name",
	        "EncodedKey"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Name": {},
	        "EncodedKey": {},
	        "Comment": {}
	      }
	    },
	    "S3g": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "CreatedTime",
	        "PublicKeyConfig"
	      ],
	      "members": {
	        "Id": {},
	        "CreatedTime": {
	          "type": "timestamp"
	        },
	        "PublicKeyConfig": {
	          "shape": "S3e"
	        }
	      }
	    },
	    "S3i": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "S3Origin",
	        "Comment",
	        "TrustedSigners",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "S3Origin": {
	          "shape": "S3j"
	        },
	        "Aliases": {
	          "shape": "S8"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "TrustedSigners": {
	          "shape": "S17"
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S3j": {
	      "type": "structure",
	      "required": [
	        "DomainName",
	        "OriginAccessIdentity"
	      ],
	      "members": {
	        "DomainName": {},
	        "OriginAccessIdentity": {}
	      }
	    },
	    "S3m": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "StreamingDistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S25"
	        },
	        "StreamingDistributionConfig": {
	          "shape": "S3i"
	        }
	      }
	    },
	    "S4t": {
	      "type": "structure",
	      "required": [
	        "Marker",
	        "MaxItems",
	        "IsTruncated",
	        "Quantity"
	      ],
	      "members": {
	        "Marker": {},
	        "NextMarker": {},
	        "MaxItems": {
	          "type": "integer"
	        },
	        "IsTruncated": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "DistributionSummary",
	            "type": "structure",
	            "required": [
	              "Id",
	              "ARN",
	              "Status",
	              "LastModifiedTime",
	              "DomainName",
	              "Aliases",
	              "Origins",
	              "DefaultCacheBehavior",
	              "CacheBehaviors",
	              "CustomErrorResponses",
	              "Comment",
	              "PriceClass",
	              "Enabled",
	              "ViewerCertificate",
	              "Restrictions",
	              "WebACLId",
	              "HttpVersion",
	              "IsIPV6Enabled"
	            ],
	            "members": {
	              "Id": {},
	              "ARN": {},
	              "Status": {},
	              "LastModifiedTime": {
	                "type": "timestamp"
	              },
	              "DomainName": {},
	              "Aliases": {
	                "shape": "S8"
	              },
	              "Origins": {
	                "shape": "Sb"
	              },
	              "OriginGroups": {
	                "shape": "Sn"
	              },
	              "DefaultCacheBehavior": {
	                "shape": "Sw"
	              },
	              "CacheBehaviors": {
	                "shape": "S1k"
	              },
	              "CustomErrorResponses": {
	                "shape": "S1n"
	              },
	              "Comment": {},
	              "PriceClass": {},
	              "Enabled": {
	                "type": "boolean"
	              },
	              "ViewerCertificate": {
	                "shape": "S1t"
	              },
	              "Restrictions": {
	                "shape": "S1x"
	              },
	              "WebACLId": {},
	              "HttpVersion": {},
	              "IsIPV6Enabled": {
	                "type": "boolean"
	              },
	              "AliasICPRecordals": {
	                "shape": "S2a"
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	}
	},{}],33:[function(require,module,exports){
	arguments[4][21][0].apply(exports,arguments)
	},{"dup":21}],34:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "DistributionDeployed": {
	      "delay": 60,
	      "operation": "GetDistribution",
	      "maxAttempts": 35,
	      "description": "Wait until a distribution is deployed.",
	      "acceptors": [
	        {
	          "expected": "Deployed",
	          "matcher": "path",
	          "state": "success",
	          "argument": "Distribution.Status"
	        }
	      ]
	    },
	    "InvalidationCompleted": {
	      "delay": 20,
	      "operation": "GetInvalidation",
	      "maxAttempts": 30,
	      "description": "Wait until an invalidation has completed.",
	      "acceptors": [
	        {
	          "expected": "Completed",
	          "matcher": "path",
	          "state": "success",
	          "argument": "Invalidation.Status"
	        }
	      ]
	    },
	    "StreamingDistributionDeployed": {
	      "delay": 60,
	      "operation": "GetStreamingDistribution",
	      "maxAttempts": 25,
	      "description": "Wait until a streaming distribution is deployed.",
	      "acceptors": [
	        {
	          "expected": "Deployed",
	          "matcher": "path",
	          "state": "success",
	          "argument": "StreamingDistribution.Status"
	        }
	      ]
	    }
	  }
	}
	
	},{}],35:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2020-05-31",
	    "endpointPrefix": "cloudfront",
	    "globalEndpoint": "cloudfront.amazonaws.com",
	    "protocol": "rest-xml",
	    "serviceAbbreviation": "CloudFront",
	    "serviceFullName": "Amazon CloudFront",
	    "serviceId": "CloudFront",
	    "signatureVersion": "v4",
	    "uid": "cloudfront-2020-05-31"
	  },
	  "operations": {
	    "AssociateAlias": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/distribution/{TargetDistributionId}/associate-alias",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetDistributionId",
	          "Alias"
	        ],
	        "members": {
	          "TargetDistributionId": {
	            "location": "uri",
	            "locationName": "TargetDistributionId"
	          },
	          "Alias": {
	            "location": "querystring",
	            "locationName": "Alias"
	          }
	        }
	      }
	    },
	    "CreateCachePolicy": {
	      "http": {
	        "requestUri": "/2020-05-31/cache-policy",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CachePolicyConfig"
	        ],
	        "members": {
	          "CachePolicyConfig": {
	            "shape": "S4",
	            "locationName": "CachePolicyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "CachePolicyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CachePolicy": {
	            "shape": "Sm"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CachePolicy"
	      }
	    },
	    "CreateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "requestUri": "/2020-05-31/origin-access-identity/cloudfront",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "Sp",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "Sr"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "CreateDistribution": {
	      "http": {
	        "requestUri": "/2020-05-31/distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "St",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S2r"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateDistributionWithTags": {
	      "http": {
	        "requestUri": "/2020-05-31/distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfigWithTags"
	        ],
	        "members": {
	          "DistributionConfigWithTags": {
	            "locationName": "DistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            },
	            "type": "structure",
	            "required": [
	              "DistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "DistributionConfig": {
	                "shape": "St"
	              },
	              "Tags": {
	                "shape": "S35"
	              }
	            }
	          }
	        },
	        "payload": "DistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S2r"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "CreateFieldLevelEncryptionConfig": {
	      "http": {
	        "requestUri": "/2020-05-31/field-level-encryption",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionConfig"
	        ],
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S3c",
	            "locationName": "FieldLevelEncryptionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S3n"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "CreateFieldLevelEncryptionProfile": {
	      "http": {
	        "requestUri": "/2020-05-31/field-level-encryption-profile",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionProfileConfig"
	        ],
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S3p",
	            "locationName": "FieldLevelEncryptionProfileConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S3w"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "CreateFunction": {
	      "http": {
	        "requestUri": "/2020-05-31/function",
	        "responseCode": 201
	      },
	      "input": {
	        "locationName": "CreateFunctionRequest",
	        "xmlNamespace": {
	          "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	        },
	        "type": "structure",
	        "required": [
	          "Name",
	          "FunctionConfig",
	          "FunctionCode"
	        ],
	        "members": {
	          "Name": {},
	          "FunctionConfig": {
	            "shape": "S3z"
	          },
	          "FunctionCode": {
	            "shape": "S41"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FunctionSummary": {
	            "shape": "S43"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FunctionSummary"
	      }
	    },
	    "CreateInvalidation": {
	      "http": {
	        "requestUri": "/2020-05-31/distribution/{DistributionId}/invalidation",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "InvalidationBatch"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "InvalidationBatch": {
	            "shape": "S47",
	            "locationName": "InvalidationBatch",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "InvalidationBatch"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "Invalidation": {
	            "shape": "S4b"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "CreateKeyGroup": {
	      "http": {
	        "requestUri": "/2020-05-31/key-group",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyGroupConfig"
	        ],
	        "members": {
	          "KeyGroupConfig": {
	            "shape": "S4d",
	            "locationName": "KeyGroupConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "KeyGroupConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyGroup": {
	            "shape": "S4g"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "KeyGroup"
	      }
	    },
	    "CreateMonitoringSubscription": {
	      "http": {
	        "requestUri": "/2020-05-31/distributions/{DistributionId}/monitoring-subscription"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "MonitoringSubscription",
	          "DistributionId"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "MonitoringSubscription": {
	            "shape": "S4i",
	            "locationName": "MonitoringSubscription",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "MonitoringSubscription"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MonitoringSubscription": {
	            "shape": "S4i"
	          }
	        },
	        "payload": "MonitoringSubscription"
	      }
	    },
	    "CreateOriginRequestPolicy": {
	      "http": {
	        "requestUri": "/2020-05-31/origin-request-policy",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "OriginRequestPolicyConfig"
	        ],
	        "members": {
	          "OriginRequestPolicyConfig": {
	            "shape": "S4n",
	            "locationName": "OriginRequestPolicyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "OriginRequestPolicyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OriginRequestPolicy": {
	            "shape": "S4v"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "OriginRequestPolicy"
	      }
	    },
	    "CreatePublicKey": {
	      "http": {
	        "requestUri": "/2020-05-31/public-key",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicKeyConfig"
	        ],
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S4x",
	            "locationName": "PublicKeyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "PublicKeyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S4z"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "CreateRealtimeLogConfig": {
	      "http": {
	        "requestUri": "/2020-05-31/realtime-log-config",
	        "responseCode": 201
	      },
	      "input": {
	        "locationName": "CreateRealtimeLogConfigRequest",
	        "xmlNamespace": {
	          "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	        },
	        "type": "structure",
	        "required": [
	          "EndPoints",
	          "Fields",
	          "Name",
	          "SamplingRate"
	        ],
	        "members": {
	          "EndPoints": {
	            "shape": "S51"
	          },
	          "Fields": {
	            "shape": "S54"
	          },
	          "Name": {},
	          "SamplingRate": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RealtimeLogConfig": {
	            "shape": "S56"
	          }
	        }
	      }
	    },
	    "CreateResponseHeadersPolicy": {
	      "http": {
	        "requestUri": "/2020-05-31/response-headers-policy",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResponseHeadersPolicyConfig"
	        ],
	        "members": {
	          "ResponseHeadersPolicyConfig": {
	            "shape": "S58",
	            "locationName": "ResponseHeadersPolicyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "ResponseHeadersPolicyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResponseHeadersPolicy": {
	            "shape": "S5y"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "ResponseHeadersPolicy"
	      }
	    },
	    "CreateStreamingDistribution": {
	      "http": {
	        "requestUri": "/2020-05-31/streaming-distribution",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S60",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S64"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "CreateStreamingDistributionWithTags": {
	      "http": {
	        "requestUri": "/2020-05-31/streaming-distribution?WithTags",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfigWithTags"
	        ],
	        "members": {
	          "StreamingDistributionConfigWithTags": {
	            "locationName": "StreamingDistributionConfigWithTags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            },
	            "type": "structure",
	            "required": [
	              "StreamingDistributionConfig",
	              "Tags"
	            ],
	            "members": {
	              "StreamingDistributionConfig": {
	                "shape": "S60"
	              },
	              "Tags": {
	                "shape": "S35"
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionConfigWithTags"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S64"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "DeleteCachePolicy": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/cache-policy/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/origin-access-identity/cloudfront/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/field-level-encryption/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/field-level-encryption-profile/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteFunction": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/function/{Name}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IfMatch",
	          "Name"
	        ],
	        "members": {
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteKeyGroup": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/key-group/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteMonitoringSubscription": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/distributions/{DistributionId}/monitoring-subscription"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteOriginRequestPolicy": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/origin-request-policy/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeletePublicKey": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/public-key/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteRealtimeLogConfig": {
	      "http": {
	        "requestUri": "/2020-05-31/delete-realtime-log-config/",
	        "responseCode": 204
	      },
	      "input": {
	        "locationName": "DeleteRealtimeLogConfigRequest",
	        "xmlNamespace": {
	          "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	        },
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "ARN": {}
	        }
	      }
	    },
	    "DeleteResponseHeadersPolicy": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/response-headers-policy/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DeleteStreamingDistribution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-05-31/streaming-distribution/{Id}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      }
	    },
	    "DescribeFunction": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/function/{Name}/describe"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          },
	          "Stage": {
	            "location": "querystring",
	            "locationName": "Stage"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FunctionSummary": {
	            "shape": "S43"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FunctionSummary"
	      }
	    },
	    "GetCachePolicy": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/cache-policy/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CachePolicy": {
	            "shape": "Sm"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CachePolicy"
	      }
	    },
	    "GetCachePolicyConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/cache-policy/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CachePolicyConfig": {
	            "shape": "S4"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CachePolicyConfig"
	      }
	    },
	    "GetCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/origin-access-identity/cloudfront/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "Sr"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "GetCloudFrontOriginAccessIdentityConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "Sp"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      }
	    },
	    "GetDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S2r"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "GetDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionConfig": {
	            "shape": "St"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "DistributionConfig"
	      }
	    },
	    "GetFieldLevelEncryption": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/field-level-encryption/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S3n"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "GetFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/field-level-encryption/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S3c"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      }
	    },
	    "GetFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/field-level-encryption-profile/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S3w"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "GetFieldLevelEncryptionProfileConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/field-level-encryption-profile/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S3p"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      }
	    },
	    "GetFunction": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/function/{Name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          },
	          "Stage": {
	            "location": "querystring",
	            "locationName": "Stage"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FunctionCode": {
	            "shape": "S41"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          }
	        },
	        "payload": "FunctionCode"
	      }
	    },
	    "GetInvalidation": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/distribution/{DistributionId}/invalidation/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "Id"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Invalidation": {
	            "shape": "S4b"
	          }
	        },
	        "payload": "Invalidation"
	      }
	    },
	    "GetKeyGroup": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/key-group/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyGroup": {
	            "shape": "S4g"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "KeyGroup"
	      }
	    },
	    "GetKeyGroupConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/key-group/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyGroupConfig": {
	            "shape": "S4d"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "KeyGroupConfig"
	      }
	    },
	    "GetMonitoringSubscription": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/distributions/{DistributionId}/monitoring-subscription"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MonitoringSubscription": {
	            "shape": "S4i"
	          }
	        },
	        "payload": "MonitoringSubscription"
	      }
	    },
	    "GetOriginRequestPolicy": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/origin-request-policy/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OriginRequestPolicy": {
	            "shape": "S4v"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "OriginRequestPolicy"
	      }
	    },
	    "GetOriginRequestPolicyConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/origin-request-policy/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OriginRequestPolicyConfig": {
	            "shape": "S4n"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "OriginRequestPolicyConfig"
	      }
	    },
	    "GetPublicKey": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/public-key/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S4z"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "GetPublicKeyConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/public-key/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S4x"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKeyConfig"
	      }
	    },
	    "GetRealtimeLogConfig": {
	      "http": {
	        "requestUri": "/2020-05-31/get-realtime-log-config/"
	      },
	      "input": {
	        "locationName": "GetRealtimeLogConfigRequest",
	        "xmlNamespace": {
	          "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	        },
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "ARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RealtimeLogConfig": {
	            "shape": "S56"
	          }
	        }
	      }
	    },
	    "GetResponseHeadersPolicy": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/response-headers-policy/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResponseHeadersPolicy": {
	            "shape": "S5y"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "ResponseHeadersPolicy"
	      }
	    },
	    "GetResponseHeadersPolicyConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/response-headers-policy/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResponseHeadersPolicyConfig": {
	            "shape": "S58"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "ResponseHeadersPolicyConfig"
	      }
	    },
	    "GetStreamingDistribution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/streaming-distribution/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S64"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    },
	    "GetStreamingDistributionConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S60"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      }
	    },
	    "ListCachePolicies": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/cache-policy"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Type": {
	            "location": "querystring",
	            "locationName": "Type"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CachePolicyList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "CachePolicySummary",
	                  "type": "structure",
	                  "required": [
	                    "Type",
	                    "CachePolicy"
	                  ],
	                  "members": {
	                    "Type": {},
	                    "CachePolicy": {
	                      "shape": "Sm"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "CachePolicyList"
	      }
	    },
	    "ListCloudFrontOriginAccessIdentities": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/origin-access-identity/cloudfront"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentityList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "CloudFrontOriginAccessIdentitySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "S3CanonicalUserId",
	                    "Comment"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "S3CanonicalUserId": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityList"
	      }
	    },
	    "ListConflictingAliases": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/conflicting-alias",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId",
	          "Alias"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "querystring",
	            "locationName": "DistributionId"
	          },
	          "Alias": {
	            "location": "querystring",
	            "locationName": "Alias"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConflictingAliasesList": {
	            "type": "structure",
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "ConflictingAlias",
	                  "type": "structure",
	                  "members": {
	                    "Alias": {},
	                    "DistributionId": {},
	                    "AccountId": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "ConflictingAliasesList"
	      }
	    },
	    "ListDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S8l"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListDistributionsByCachePolicyId": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/distributionsByCachePolicyId/{CachePolicyId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CachePolicyId"
	        ],
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "CachePolicyId": {
	            "location": "uri",
	            "locationName": "CachePolicyId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionIdList": {
	            "shape": "S8q"
	          }
	        },
	        "payload": "DistributionIdList"
	      }
	    },
	    "ListDistributionsByKeyGroup": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/distributionsByKeyGroupId/{KeyGroupId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyGroupId"
	        ],
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "KeyGroupId": {
	            "location": "uri",
	            "locationName": "KeyGroupId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionIdList": {
	            "shape": "S8q"
	          }
	        },
	        "payload": "DistributionIdList"
	      }
	    },
	    "ListDistributionsByOriginRequestPolicyId": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/distributionsByOriginRequestPolicyId/{OriginRequestPolicyId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "OriginRequestPolicyId"
	        ],
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "OriginRequestPolicyId": {
	            "location": "uri",
	            "locationName": "OriginRequestPolicyId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionIdList": {
	            "shape": "S8q"
	          }
	        },
	        "payload": "DistributionIdList"
	      }
	    },
	    "ListDistributionsByRealtimeLogConfig": {
	      "http": {
	        "requestUri": "/2020-05-31/distributionsByRealtimeLogConfig/"
	      },
	      "input": {
	        "locationName": "ListDistributionsByRealtimeLogConfigRequest",
	        "xmlNamespace": {
	          "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	        },
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "MaxItems": {},
	          "RealtimeLogConfigName": {},
	          "RealtimeLogConfigArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S8l"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListDistributionsByResponseHeadersPolicyId": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/distributionsByResponseHeadersPolicyId/{ResponseHeadersPolicyId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResponseHeadersPolicyId"
	        ],
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "ResponseHeadersPolicyId": {
	            "location": "uri",
	            "locationName": "ResponseHeadersPolicyId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionIdList": {
	            "shape": "S8q"
	          }
	        },
	        "payload": "DistributionIdList"
	      }
	    },
	    "ListDistributionsByWebACLId": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/distributionsByWebACLId/{WebACLId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebACLId"
	        ],
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "WebACLId": {
	            "location": "uri",
	            "locationName": "WebACLId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DistributionList": {
	            "shape": "S8l"
	          }
	        },
	        "payload": "DistributionList"
	      }
	    },
	    "ListFieldLevelEncryptionConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/field-level-encryption"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "FieldLevelEncryptionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "LastModifiedTime"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "Comment": {},
	                    "QueryArgProfileConfig": {
	                      "shape": "S3d"
	                    },
	                    "ContentTypeProfileConfig": {
	                      "shape": "S3h"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionList"
	      }
	    },
	    "ListFieldLevelEncryptionProfiles": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/field-level-encryption-profile"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfileList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "FieldLevelEncryptionProfileSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "LastModifiedTime",
	                    "Name",
	                    "EncryptionEntities"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "Name": {},
	                    "EncryptionEntities": {
	                      "shape": "S3q"
	                    },
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileList"
	      }
	    },
	    "ListFunctions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/function"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "Stage": {
	            "location": "querystring",
	            "locationName": "Stage"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FunctionList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "shape": "S43",
	                  "locationName": "FunctionSummary"
	                }
	              }
	            }
	          }
	        },
	        "payload": "FunctionList"
	      }
	    },
	    "ListInvalidations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/distribution/{DistributionId}/invalidation"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionId"
	        ],
	        "members": {
	          "DistributionId": {
	            "location": "uri",
	            "locationName": "DistributionId"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InvalidationList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "InvalidationSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "CreateTime",
	                    "Status"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "CreateTime": {
	                      "type": "timestamp"
	                    },
	                    "Status": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "InvalidationList"
	      }
	    },
	    "ListKeyGroups": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/key-group"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyGroupList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "KeyGroupSummary",
	                  "type": "structure",
	                  "required": [
	                    "KeyGroup"
	                  ],
	                  "members": {
	                    "KeyGroup": {
	                      "shape": "S4g"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "KeyGroupList"
	      }
	    },
	    "ListOriginRequestPolicies": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/origin-request-policy"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Type": {
	            "location": "querystring",
	            "locationName": "Type"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OriginRequestPolicyList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "OriginRequestPolicySummary",
	                  "type": "structure",
	                  "required": [
	                    "Type",
	                    "OriginRequestPolicy"
	                  ],
	                  "members": {
	                    "Type": {},
	                    "OriginRequestPolicy": {
	                      "shape": "S4v"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "OriginRequestPolicyList"
	      }
	    },
	    "ListPublicKeys": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/public-key"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKeyList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "PublicKeySummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "Name",
	                    "CreatedTime",
	                    "EncodedKey"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "Name": {},
	                    "CreatedTime": {
	                      "type": "timestamp"
	                    },
	                    "EncodedKey": {},
	                    "Comment": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "PublicKeyList"
	      }
	    },
	    "ListRealtimeLogConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/realtime-log-config"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RealtimeLogConfigs": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "IsTruncated",
	              "Marker"
	            ],
	            "members": {
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "shape": "S56"
	                }
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Marker": {},
	              "NextMarker": {}
	            }
	          }
	        },
	        "payload": "RealtimeLogConfigs"
	      }
	    },
	    "ListResponseHeadersPolicies": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/response-headers-policy"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Type": {
	            "location": "querystring",
	            "locationName": "Type"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResponseHeadersPolicyList": {
	            "type": "structure",
	            "required": [
	              "MaxItems",
	              "Quantity"
	            ],
	            "members": {
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "ResponseHeadersPolicySummary",
	                  "type": "structure",
	                  "required": [
	                    "Type",
	                    "ResponseHeadersPolicy"
	                  ],
	                  "members": {
	                    "Type": {},
	                    "ResponseHeadersPolicy": {
	                      "shape": "S5y"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "ResponseHeadersPolicyList"
	      }
	    },
	    "ListStreamingDistributions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/streaming-distribution"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistributionList": {
	            "type": "structure",
	            "required": [
	              "Marker",
	              "MaxItems",
	              "IsTruncated",
	              "Quantity"
	            ],
	            "members": {
	              "Marker": {},
	              "NextMarker": {},
	              "MaxItems": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Quantity": {
	                "type": "integer"
	              },
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "StreamingDistributionSummary",
	                  "type": "structure",
	                  "required": [
	                    "Id",
	                    "ARN",
	                    "Status",
	                    "LastModifiedTime",
	                    "DomainName",
	                    "S3Origin",
	                    "Aliases",
	                    "TrustedSigners",
	                    "Comment",
	                    "PriceClass",
	                    "Enabled"
	                  ],
	                  "members": {
	                    "Id": {},
	                    "ARN": {},
	                    "Status": {},
	                    "LastModifiedTime": {
	                      "type": "timestamp"
	                    },
	                    "DomainName": {},
	                    "S3Origin": {
	                      "shape": "S61"
	                    },
	                    "Aliases": {
	                      "shape": "Su"
	                    },
	                    "TrustedSigners": {
	                      "shape": "S1l"
	                    },
	                    "Comment": {},
	                    "PriceClass": {},
	                    "Enabled": {
	                      "type": "boolean"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "payload": "StreamingDistributionList"
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-05-31/tagging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "S35"
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "PublishFunction": {
	      "http": {
	        "requestUri": "/2020-05-31/function/{Name}/publish"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "IfMatch"
	        ],
	        "members": {
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FunctionSummary": {
	            "shape": "S43"
	          }
	        },
	        "payload": "FunctionSummary"
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/2020-05-31/tagging?Operation=Tag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "Tags"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "Tags": {
	            "shape": "S35",
	            "locationName": "Tags",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          }
	        },
	        "payload": "Tags"
	      }
	    },
	    "TestFunction": {
	      "http": {
	        "requestUri": "/2020-05-31/function/{Name}/test"
	      },
	      "input": {
	        "locationName": "TestFunctionRequest",
	        "xmlNamespace": {
	          "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	        },
	        "type": "structure",
	        "required": [
	          "Name",
	          "IfMatch",
	          "EventObject"
	        ],
	        "members": {
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          },
	          "Stage": {},
	          "EventObject": {
	            "type": "blob",
	            "sensitive": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TestResult": {
	            "type": "structure",
	            "members": {
	              "FunctionSummary": {
	                "shape": "S43"
	              },
	              "ComputeUtilization": {},
	              "FunctionExecutionLogs": {
	                "type": "list",
	                "member": {},
	                "sensitive": true
	              },
	              "FunctionErrorMessage": {
	                "shape": "S12"
	              },
	              "FunctionOutput": {
	                "shape": "S12"
	              }
	            }
	          }
	        },
	        "payload": "TestResult"
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "requestUri": "/2020-05-31/tagging?Operation=Untag",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "TagKeys"
	        ],
	        "members": {
	          "Resource": {
	            "location": "querystring",
	            "locationName": "Resource"
	          },
	          "TagKeys": {
	            "locationName": "TagKeys",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            },
	            "type": "structure",
	            "members": {
	              "Items": {
	                "type": "list",
	                "member": {
	                  "locationName": "Key"
	                }
	              }
	            }
	          }
	        },
	        "payload": "TagKeys"
	      }
	    },
	    "UpdateCachePolicy": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/cache-policy/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CachePolicyConfig",
	          "Id"
	        ],
	        "members": {
	          "CachePolicyConfig": {
	            "shape": "S4",
	            "locationName": "CachePolicyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "CachePolicyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CachePolicy": {
	            "shape": "Sm"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CachePolicy"
	      }
	    },
	    "UpdateCloudFrontOriginAccessIdentity": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/origin-access-identity/cloudfront/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CloudFrontOriginAccessIdentityConfig",
	          "Id"
	        ],
	        "members": {
	          "CloudFrontOriginAccessIdentityConfig": {
	            "shape": "Sp",
	            "locationName": "CloudFrontOriginAccessIdentityConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentityConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontOriginAccessIdentity": {
	            "shape": "Sr"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "CloudFrontOriginAccessIdentity"
	      }
	    },
	    "UpdateDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "DistributionConfig": {
	            "shape": "St",
	            "locationName": "DistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "DistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Distribution": {
	            "shape": "S2r"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "Distribution"
	      }
	    },
	    "UpdateFieldLevelEncryptionConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/field-level-encryption/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionConfig",
	          "Id"
	        ],
	        "members": {
	          "FieldLevelEncryptionConfig": {
	            "shape": "S3c",
	            "locationName": "FieldLevelEncryptionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "FieldLevelEncryptionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryption": {
	            "shape": "S3n"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryption"
	      }
	    },
	    "UpdateFieldLevelEncryptionProfile": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/field-level-encryption-profile/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FieldLevelEncryptionProfileConfig",
	          "Id"
	        ],
	        "members": {
	          "FieldLevelEncryptionProfileConfig": {
	            "shape": "S3p",
	            "locationName": "FieldLevelEncryptionProfileConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfileConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FieldLevelEncryptionProfile": {
	            "shape": "S3w"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "FieldLevelEncryptionProfile"
	      }
	    },
	    "UpdateFunction": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/function/{Name}"
	      },
	      "input": {
	        "locationName": "UpdateFunctionRequest",
	        "xmlNamespace": {
	          "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	        },
	        "type": "structure",
	        "required": [
	          "IfMatch",
	          "FunctionConfig",
	          "FunctionCode",
	          "Name"
	        ],
	        "members": {
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          },
	          "FunctionConfig": {
	            "shape": "S3z"
	          },
	          "FunctionCode": {
	            "shape": "S41"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FunctionSummary": {
	            "shape": "S43"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETtag"
	          }
	        },
	        "payload": "FunctionSummary"
	      }
	    },
	    "UpdateKeyGroup": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/key-group/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyGroupConfig",
	          "Id"
	        ],
	        "members": {
	          "KeyGroupConfig": {
	            "shape": "S4d",
	            "locationName": "KeyGroupConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "KeyGroupConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyGroup": {
	            "shape": "S4g"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "KeyGroup"
	      }
	    },
	    "UpdateOriginRequestPolicy": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/origin-request-policy/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "OriginRequestPolicyConfig",
	          "Id"
	        ],
	        "members": {
	          "OriginRequestPolicyConfig": {
	            "shape": "S4n",
	            "locationName": "OriginRequestPolicyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "OriginRequestPolicyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OriginRequestPolicy": {
	            "shape": "S4v"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "OriginRequestPolicy"
	      }
	    },
	    "UpdatePublicKey": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/public-key/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicKeyConfig",
	          "Id"
	        ],
	        "members": {
	          "PublicKeyConfig": {
	            "shape": "S4x",
	            "locationName": "PublicKeyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "PublicKeyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKey": {
	            "shape": "S4z"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "PublicKey"
	      }
	    },
	    "UpdateRealtimeLogConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/realtime-log-config/"
	      },
	      "input": {
	        "locationName": "UpdateRealtimeLogConfigRequest",
	        "xmlNamespace": {
	          "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	        },
	        "type": "structure",
	        "members": {
	          "EndPoints": {
	            "shape": "S51"
	          },
	          "Fields": {
	            "shape": "S54"
	          },
	          "Name": {},
	          "ARN": {},
	          "SamplingRate": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RealtimeLogConfig": {
	            "shape": "S56"
	          }
	        }
	      }
	    },
	    "UpdateResponseHeadersPolicy": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/response-headers-policy/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResponseHeadersPolicyConfig",
	          "Id"
	        ],
	        "members": {
	          "ResponseHeadersPolicyConfig": {
	            "shape": "S58",
	            "locationName": "ResponseHeadersPolicyConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "ResponseHeadersPolicyConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResponseHeadersPolicy": {
	            "shape": "S5y"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "ResponseHeadersPolicy"
	      }
	    },
	    "UpdateStreamingDistribution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-05-31/streaming-distribution/{Id}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamingDistributionConfig",
	          "Id"
	        ],
	        "members": {
	          "StreamingDistributionConfig": {
	            "shape": "S60",
	            "locationName": "StreamingDistributionConfig",
	            "xmlNamespace": {
	              "uri": "http://cloudfront.amazonaws.com/doc/2020-05-31/"
	            }
	          },
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          }
	        },
	        "payload": "StreamingDistributionConfig"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamingDistribution": {
	            "shape": "S64"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          }
	        },
	        "payload": "StreamingDistribution"
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "MinTTL"
	      ],
	      "members": {
	        "Comment": {},
	        "Name": {},
	        "DefaultTTL": {
	          "type": "long"
	        },
	        "MaxTTL": {
	          "type": "long"
	        },
	        "MinTTL": {
	          "type": "long"
	        },
	        "ParametersInCacheKeyAndForwardedToOrigin": {
	          "type": "structure",
	          "required": [
	            "EnableAcceptEncodingGzip",
	            "HeadersConfig",
	            "CookiesConfig",
	            "QueryStringsConfig"
	          ],
	          "members": {
	            "EnableAcceptEncodingGzip": {
	              "type": "boolean"
	            },
	            "EnableAcceptEncodingBrotli": {
	              "type": "boolean"
	            },
	            "HeadersConfig": {
	              "type": "structure",
	              "required": [
	                "HeaderBehavior"
	              ],
	              "members": {
	                "HeaderBehavior": {},
	                "Headers": {
	                  "shape": "Sa"
	                }
	              }
	            },
	            "CookiesConfig": {
	              "type": "structure",
	              "required": [
	                "CookieBehavior"
	              ],
	              "members": {
	                "CookieBehavior": {},
	                "Cookies": {
	                  "shape": "Sf"
	                }
	              }
	            },
	            "QueryStringsConfig": {
	              "type": "structure",
	              "required": [
	                "QueryStringBehavior"
	              ],
	              "members": {
	                "QueryStringBehavior": {},
	                "QueryStrings": {
	                  "shape": "Sj"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sa": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Name"
	          }
	        }
	      }
	    },
	    "Sf": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Name"
	          }
	        }
	      }
	    },
	    "Sj": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Name"
	          }
	        }
	      }
	    },
	    "Sm": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "CachePolicyConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "CachePolicyConfig": {
	          "shape": "S4"
	        }
	      }
	    },
	    "Sp": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Comment"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {}
	      }
	    },
	    "Sr": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "S3CanonicalUserId"
	      ],
	      "members": {
	        "Id": {},
	        "S3CanonicalUserId": {},
	        "CloudFrontOriginAccessIdentityConfig": {
	          "shape": "Sp"
	        }
	      }
	    },
	    "St": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Origins",
	        "DefaultCacheBehavior",
	        "Comment",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Aliases": {
	          "shape": "Su"
	        },
	        "DefaultRootObject": {},
	        "Origins": {
	          "shape": "Sw"
	        },
	        "OriginGroups": {
	          "shape": "S1b"
	        },
	        "DefaultCacheBehavior": {
	          "shape": "S1k"
	        },
	        "CacheBehaviors": {
	          "shape": "S28"
	        },
	        "CustomErrorResponses": {
	          "shape": "S2b"
	        },
	        "Comment": {
	          "type": "string",
	          "sensitive": true
	        },
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "IncludeCookies",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "IncludeCookies": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        },
	        "ViewerCertificate": {
	          "shape": "S2h"
	        },
	        "Restrictions": {
	          "shape": "S2l"
	        },
	        "WebACLId": {},
	        "HttpVersion": {},
	        "IsIPV6Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Su": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CNAME"
	          }
	        }
	      }
	    },
	    "Sw": {
	      "type": "structure",
	      "required": [
	        "Quantity",
	        "Items"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Origin",
	            "type": "structure",
	            "required": [
	              "Id",
	              "DomainName"
	            ],
	            "members": {
	              "Id": {},
	              "DomainName": {},
	              "OriginPath": {},
	              "CustomHeaders": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "OriginCustomHeader",
	                      "type": "structure",
	                      "required": [
	                        "HeaderName",
	                        "HeaderValue"
	                      ],
	                      "members": {
	                        "HeaderName": {},
	                        "HeaderValue": {
	                          "shape": "S12"
	                        }
	                      }
	                    }
	                  }
	                }
	              },
	              "S3OriginConfig": {
	                "type": "structure",
	                "required": [
	                  "OriginAccessIdentity"
	                ],
	                "members": {
	                  "OriginAccessIdentity": {}
	                }
	              },
	              "CustomOriginConfig": {
	                "type": "structure",
	                "required": [
	                  "HTTPPort",
	                  "HTTPSPort",
	                  "OriginProtocolPolicy"
	                ],
	                "members": {
	                  "HTTPPort": {
	                    "type": "integer"
	                  },
	                  "HTTPSPort": {
	                    "type": "integer"
	                  },
	                  "OriginProtocolPolicy": {},
	                  "OriginSslProtocols": {
	                    "type": "structure",
	                    "required": [
	                      "Quantity",
	                      "Items"
	                    ],
	                    "members": {
	                      "Quantity": {
	                        "type": "integer"
	                      },
	                      "Items": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "SslProtocol"
	                        }
	                      }
	                    }
	                  },
	                  "OriginReadTimeout": {
	                    "type": "integer"
	                  },
	                  "OriginKeepaliveTimeout": {
	                    "type": "integer"
	                  }
	                }
	              },
	              "ConnectionAttempts": {
	                "type": "integer"
	              },
	              "ConnectionTimeout": {
	                "type": "integer"
	              },
	              "OriginShield": {
	                "type": "structure",
	                "required": [
	                  "Enabled"
	                ],
	                "members": {
	                  "Enabled": {
	                    "type": "boolean"
	                  },
	                  "OriginShieldRegion": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S12": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S1b": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "OriginGroup",
	            "type": "structure",
	            "required": [
	              "Id",
	              "FailoverCriteria",
	              "Members"
	            ],
	            "members": {
	              "Id": {},
	              "FailoverCriteria": {
	                "type": "structure",
	                "required": [
	                  "StatusCodes"
	                ],
	                "members": {
	                  "StatusCodes": {
	                    "type": "structure",
	                    "required": [
	                      "Quantity",
	                      "Items"
	                    ],
	                    "members": {
	                      "Quantity": {
	                        "type": "integer"
	                      },
	                      "Items": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "StatusCode",
	                          "type": "integer"
	                        }
	                      }
	                    }
	                  }
	                }
	              },
	              "Members": {
	                "type": "structure",
	                "required": [
	                  "Quantity",
	                  "Items"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "OriginGroupMember",
	                      "type": "structure",
	                      "required": [
	                        "OriginId"
	                      ],
	                      "members": {
	                        "OriginId": {}
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1k": {
	      "type": "structure",
	      "required": [
	        "TargetOriginId",
	        "ViewerProtocolPolicy"
	      ],
	      "members": {
	        "TargetOriginId": {},
	        "TrustedSigners": {
	          "shape": "S1l"
	        },
	        "TrustedKeyGroups": {
	          "shape": "S1n"
	        },
	        "ViewerProtocolPolicy": {},
	        "AllowedMethods": {
	          "shape": "S1q"
	        },
	        "SmoothStreaming": {
	          "type": "boolean"
	        },
	        "Compress": {
	          "type": "boolean"
	        },
	        "LambdaFunctionAssociations": {
	          "shape": "S1u"
	        },
	        "FunctionAssociations": {
	          "shape": "S1z"
	        },
	        "FieldLevelEncryptionId": {},
	        "RealtimeLogConfigArn": {},
	        "CachePolicyId": {},
	        "OriginRequestPolicyId": {},
	        "ResponseHeadersPolicyId": {},
	        "ForwardedValues": {
	          "shape": "S23",
	          "deprecated": true
	        },
	        "MinTTL": {
	          "deprecated": true,
	          "type": "long"
	        },
	        "DefaultTTL": {
	          "deprecated": true,
	          "type": "long"
	        },
	        "MaxTTL": {
	          "deprecated": true,
	          "type": "long"
	        }
	      }
	    },
	    "S1l": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "AwsAccountNumber"
	          }
	        }
	      }
	    },
	    "S1n": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "KeyGroup"
	          }
	        }
	      }
	    },
	    "S1q": {
	      "type": "structure",
	      "required": [
	        "Quantity",
	        "Items"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "shape": "S1r"
	        },
	        "CachedMethods": {
	          "type": "structure",
	          "required": [
	            "Quantity",
	            "Items"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "shape": "S1r"
	            }
	          }
	        }
	      }
	    },
	    "S1r": {
	      "type": "list",
	      "member": {
	        "locationName": "Method"
	      }
	    },
	    "S1u": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "LambdaFunctionAssociation",
	            "type": "structure",
	            "required": [
	              "LambdaFunctionARN",
	              "EventType"
	            ],
	            "members": {
	              "LambdaFunctionARN": {},
	              "EventType": {},
	              "IncludeBody": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1z": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "FunctionAssociation",
	            "type": "structure",
	            "required": [
	              "FunctionARN",
	              "EventType"
	            ],
	            "members": {
	              "FunctionARN": {},
	              "EventType": {}
	            }
	          }
	        }
	      }
	    },
	    "S23": {
	      "type": "structure",
	      "required": [
	        "QueryString",
	        "Cookies"
	      ],
	      "members": {
	        "QueryString": {
	          "type": "boolean"
	        },
	        "Cookies": {
	          "type": "structure",
	          "required": [
	            "Forward"
	          ],
	          "members": {
	            "Forward": {},
	            "WhitelistedNames": {
	              "shape": "Sf"
	            }
	          }
	        },
	        "Headers": {
	          "shape": "Sa"
	        },
	        "QueryStringCacheKeys": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Name"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S28": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CacheBehavior",
	            "type": "structure",
	            "required": [
	              "PathPattern",
	              "TargetOriginId",
	              "ViewerProtocolPolicy"
	            ],
	            "members": {
	              "PathPattern": {},
	              "TargetOriginId": {},
	              "TrustedSigners": {
	                "shape": "S1l"
	              },
	              "TrustedKeyGroups": {
	                "shape": "S1n"
	              },
	              "ViewerProtocolPolicy": {},
	              "AllowedMethods": {
	                "shape": "S1q"
	              },
	              "SmoothStreaming": {
	                "type": "boolean"
	              },
	              "Compress": {
	                "type": "boolean"
	              },
	              "LambdaFunctionAssociations": {
	                "shape": "S1u"
	              },
	              "FunctionAssociations": {
	                "shape": "S1z"
	              },
	              "FieldLevelEncryptionId": {},
	              "RealtimeLogConfigArn": {},
	              "CachePolicyId": {},
	              "OriginRequestPolicyId": {},
	              "ResponseHeadersPolicyId": {},
	              "ForwardedValues": {
	                "shape": "S23",
	                "deprecated": true
	              },
	              "MinTTL": {
	                "deprecated": true,
	                "type": "long"
	              },
	              "DefaultTTL": {
	                "deprecated": true,
	                "type": "long"
	              },
	              "MaxTTL": {
	                "deprecated": true,
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2b": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "CustomErrorResponse",
	            "type": "structure",
	            "required": [
	              "ErrorCode"
	            ],
	            "members": {
	              "ErrorCode": {
	                "type": "integer"
	              },
	              "ResponsePagePath": {},
	              "ResponseCode": {},
	              "ErrorCachingMinTTL": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2h": {
	      "type": "structure",
	      "members": {
	        "CloudFrontDefaultCertificate": {
	          "type": "boolean"
	        },
	        "IAMCertificateId": {},
	        "ACMCertificateArn": {},
	        "SSLSupportMethod": {},
	        "MinimumProtocolVersion": {},
	        "Certificate": {
	          "deprecated": true
	        },
	        "CertificateSource": {
	          "deprecated": true
	        }
	      }
	    },
	    "S2l": {
	      "type": "structure",
	      "required": [
	        "GeoRestriction"
	      ],
	      "members": {
	        "GeoRestriction": {
	          "type": "structure",
	          "required": [
	            "RestrictionType",
	            "Quantity"
	          ],
	          "members": {
	            "RestrictionType": {},
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Location"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2r": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "LastModifiedTime",
	        "InProgressInvalidationBatches",
	        "DomainName",
	        "DistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "InProgressInvalidationBatches": {
	          "type": "integer"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S2s"
	        },
	        "ActiveTrustedKeyGroups": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "Quantity"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "KeyGroup",
	                "type": "structure",
	                "members": {
	                  "KeyGroupId": {},
	                  "KeyPairIds": {
	                    "shape": "S2v"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "DistributionConfig": {
	          "shape": "St"
	        },
	        "AliasICPRecordals": {
	          "shape": "S30"
	        }
	      }
	    },
	    "S2s": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "Quantity"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Signer",
	            "type": "structure",
	            "members": {
	              "AwsAccountNumber": {},
	              "KeyPairIds": {
	                "shape": "S2v"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2v": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "KeyPairId"
	          }
	        }
	      }
	    },
	    "S30": {
	      "type": "list",
	      "member": {
	        "locationName": "AliasICPRecordal",
	        "type": "structure",
	        "members": {
	          "CNAME": {},
	          "ICPRecordalStatus": {}
	        }
	      }
	    },
	    "S35": {
	      "type": "structure",
	      "members": {
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "Tag",
	            "type": "structure",
	            "required": [
	              "Key"
	            ],
	            "members": {
	              "Key": {},
	              "Value": {}
	            }
	          }
	        }
	      }
	    },
	    "S3c": {
	      "type": "structure",
	      "required": [
	        "CallerReference"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Comment": {},
	        "QueryArgProfileConfig": {
	          "shape": "S3d"
	        },
	        "ContentTypeProfileConfig": {
	          "shape": "S3h"
	        }
	      }
	    },
	    "S3d": {
	      "type": "structure",
	      "required": [
	        "ForwardWhenQueryArgProfileIsUnknown"
	      ],
	      "members": {
	        "ForwardWhenQueryArgProfileIsUnknown": {
	          "type": "boolean"
	        },
	        "QueryArgProfiles": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "QueryArgProfile",
	                "type": "structure",
	                "required": [
	                  "QueryArg",
	                  "ProfileId"
	                ],
	                "members": {
	                  "QueryArg": {},
	                  "ProfileId": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S3h": {
	      "type": "structure",
	      "required": [
	        "ForwardWhenContentTypeIsUnknown"
	      ],
	      "members": {
	        "ForwardWhenContentTypeIsUnknown": {
	          "type": "boolean"
	        },
	        "ContentTypeProfiles": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "ContentTypeProfile",
	                "type": "structure",
	                "required": [
	                  "Format",
	                  "ContentType"
	                ],
	                "members": {
	                  "Format": {},
	                  "ProfileId": {},
	                  "ContentType": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S3n": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "FieldLevelEncryptionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "FieldLevelEncryptionConfig": {
	          "shape": "S3c"
	        }
	      }
	    },
	    "S3p": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "CallerReference",
	        "EncryptionEntities"
	      ],
	      "members": {
	        "Name": {},
	        "CallerReference": {},
	        "Comment": {},
	        "EncryptionEntities": {
	          "shape": "S3q"
	        }
	      }
	    },
	    "S3q": {
	      "type": "structure",
	      "required": [
	        "Quantity"
	      ],
	      "members": {
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "EncryptionEntity",
	            "type": "structure",
	            "required": [
	              "PublicKeyId",
	              "ProviderId",
	              "FieldPatterns"
	            ],
	            "members": {
	              "PublicKeyId": {},
	              "ProviderId": {},
	              "FieldPatterns": {
	                "type": "structure",
	                "required": [
	                  "Quantity"
	                ],
	                "members": {
	                  "Quantity": {
	                    "type": "integer"
	                  },
	                  "Items": {
	                    "type": "list",
	                    "member": {
	                      "locationName": "FieldPattern"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S3w": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "FieldLevelEncryptionProfileConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "FieldLevelEncryptionProfileConfig": {
	          "shape": "S3p"
	        }
	      }
	    },
	    "S3z": {
	      "type": "structure",
	      "required": [
	        "Comment",
	        "Runtime"
	      ],
	      "members": {
	        "Comment": {},
	        "Runtime": {}
	      }
	    },
	    "S41": {
	      "type": "blob",
	      "sensitive": true
	    },
	    "S43": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "FunctionConfig",
	        "FunctionMetadata"
	      ],
	      "members": {
	        "Name": {},
	        "Status": {},
	        "FunctionConfig": {
	          "shape": "S3z"
	        },
	        "FunctionMetadata": {
	          "type": "structure",
	          "required": [
	            "FunctionARN",
	            "LastModifiedTime"
	          ],
	          "members": {
	            "FunctionARN": {},
	            "Stage": {},
	            "CreatedTime": {
	              "type": "timestamp"
	            },
	            "LastModifiedTime": {
	              "type": "timestamp"
	            }
	          }
	        }
	      }
	    },
	    "S47": {
	      "type": "structure",
	      "required": [
	        "Paths",
	        "CallerReference"
	      ],
	      "members": {
	        "Paths": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "Path"
	              }
	            }
	          }
	        },
	        "CallerReference": {}
	      }
	    },
	    "S4b": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "Status",
	        "CreateTime",
	        "InvalidationBatch"
	      ],
	      "members": {
	        "Id": {},
	        "Status": {},
	        "CreateTime": {
	          "type": "timestamp"
	        },
	        "InvalidationBatch": {
	          "shape": "S47"
	        }
	      }
	    },
	    "S4d": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "Items"
	      ],
	      "members": {
	        "Name": {},
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "PublicKey"
	          }
	        },
	        "Comment": {}
	      }
	    },
	    "S4g": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "KeyGroupConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "KeyGroupConfig": {
	          "shape": "S4d"
	        }
	      }
	    },
	    "S4i": {
	      "type": "structure",
	      "members": {
	        "RealtimeMetricsSubscriptionConfig": {
	          "type": "structure",
	          "required": [
	            "RealtimeMetricsSubscriptionStatus"
	          ],
	          "members": {
	            "RealtimeMetricsSubscriptionStatus": {}
	          }
	        }
	      }
	    },
	    "S4n": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "HeadersConfig",
	        "CookiesConfig",
	        "QueryStringsConfig"
	      ],
	      "members": {
	        "Comment": {},
	        "Name": {},
	        "HeadersConfig": {
	          "type": "structure",
	          "required": [
	            "HeaderBehavior"
	          ],
	          "members": {
	            "HeaderBehavior": {},
	            "Headers": {
	              "shape": "Sa"
	            }
	          }
	        },
	        "CookiesConfig": {
	          "type": "structure",
	          "required": [
	            "CookieBehavior"
	          ],
	          "members": {
	            "CookieBehavior": {},
	            "Cookies": {
	              "shape": "Sf"
	            }
	          }
	        },
	        "QueryStringsConfig": {
	          "type": "structure",
	          "required": [
	            "QueryStringBehavior"
	          ],
	          "members": {
	            "QueryStringBehavior": {},
	            "QueryStrings": {
	              "shape": "Sj"
	            }
	          }
	        }
	      }
	    },
	    "S4v": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "OriginRequestPolicyConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "OriginRequestPolicyConfig": {
	          "shape": "S4n"
	        }
	      }
	    },
	    "S4x": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "Name",
	        "EncodedKey"
	      ],
	      "members": {
	        "CallerReference": {},
	        "Name": {},
	        "EncodedKey": {},
	        "Comment": {}
	      }
	    },
	    "S4z": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "CreatedTime",
	        "PublicKeyConfig"
	      ],
	      "members": {
	        "Id": {},
	        "CreatedTime": {
	          "type": "timestamp"
	        },
	        "PublicKeyConfig": {
	          "shape": "S4x"
	        }
	      }
	    },
	    "S51": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "StreamType"
	        ],
	        "members": {
	          "StreamType": {},
	          "KinesisStreamConfig": {
	            "type": "structure",
	            "required": [
	              "RoleARN",
	              "StreamARN"
	            ],
	            "members": {
	              "RoleARN": {},
	              "StreamARN": {}
	            }
	          }
	        }
	      }
	    },
	    "S54": {
	      "type": "list",
	      "member": {
	        "locationName": "Field"
	      }
	    },
	    "S56": {
	      "type": "structure",
	      "required": [
	        "ARN",
	        "Name",
	        "SamplingRate",
	        "EndPoints",
	        "Fields"
	      ],
	      "members": {
	        "ARN": {},
	        "Name": {},
	        "SamplingRate": {
	          "type": "long"
	        },
	        "EndPoints": {
	          "shape": "S51"
	        },
	        "Fields": {
	          "shape": "S54"
	        }
	      }
	    },
	    "S58": {
	      "type": "structure",
	      "required": [
	        "Name"
	      ],
	      "members": {
	        "Comment": {},
	        "Name": {},
	        "CorsConfig": {
	          "type": "structure",
	          "required": [
	            "AccessControlAllowOrigins",
	            "AccessControlAllowHeaders",
	            "AccessControlAllowMethods",
	            "AccessControlAllowCredentials",
	            "OriginOverride"
	          ],
	          "members": {
	            "AccessControlAllowOrigins": {
	              "type": "structure",
	              "required": [
	                "Quantity",
	                "Items"
	              ],
	              "members": {
	                "Quantity": {
	                  "type": "integer"
	                },
	                "Items": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "Origin"
	                  }
	                }
	              }
	            },
	            "AccessControlAllowHeaders": {
	              "type": "structure",
	              "required": [
	                "Quantity",
	                "Items"
	              ],
	              "members": {
	                "Quantity": {
	                  "type": "integer"
	                },
	                "Items": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "Header"
	                  }
	                }
	              }
	            },
	            "AccessControlAllowMethods": {
	              "type": "structure",
	              "required": [
	                "Quantity",
	                "Items"
	              ],
	              "members": {
	                "Quantity": {
	                  "type": "integer"
	                },
	                "Items": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "Method"
	                  }
	                }
	              }
	            },
	            "AccessControlAllowCredentials": {
	              "type": "boolean"
	            },
	            "AccessControlExposeHeaders": {
	              "type": "structure",
	              "required": [
	                "Quantity"
	              ],
	              "members": {
	                "Quantity": {
	                  "type": "integer"
	                },
	                "Items": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "Header"
	                  }
	                }
	              }
	            },
	            "AccessControlMaxAgeSec": {
	              "type": "integer"
	            },
	            "OriginOverride": {
	              "type": "boolean"
	            }
	          }
	        },
	        "SecurityHeadersConfig": {
	          "type": "structure",
	          "members": {
	            "XSSProtection": {
	              "type": "structure",
	              "required": [
	                "Override",
	                "Protection"
	              ],
	              "members": {
	                "Override": {
	                  "type": "boolean"
	                },
	                "Protection": {
	                  "type": "boolean"
	                },
	                "ModeBlock": {
	                  "type": "boolean"
	                },
	                "ReportUri": {}
	              }
	            },
	            "FrameOptions": {
	              "type": "structure",
	              "required": [
	                "Override",
	                "FrameOption"
	              ],
	              "members": {
	                "Override": {
	                  "type": "boolean"
	                },
	                "FrameOption": {}
	              }
	            },
	            "ReferrerPolicy": {
	              "type": "structure",
	              "required": [
	                "Override",
	                "ReferrerPolicy"
	              ],
	              "members": {
	                "Override": {
	                  "type": "boolean"
	                },
	                "ReferrerPolicy": {}
	              }
	            },
	            "ContentSecurityPolicy": {
	              "type": "structure",
	              "required": [
	                "Override",
	                "ContentSecurityPolicy"
	              ],
	              "members": {
	                "Override": {
	                  "type": "boolean"
	                },
	                "ContentSecurityPolicy": {}
	              }
	            },
	            "ContentTypeOptions": {
	              "type": "structure",
	              "required": [
	                "Override"
	              ],
	              "members": {
	                "Override": {
	                  "type": "boolean"
	                }
	              }
	            },
	            "StrictTransportSecurity": {
	              "type": "structure",
	              "required": [
	                "Override",
	                "AccessControlMaxAgeSec"
	              ],
	              "members": {
	                "Override": {
	                  "type": "boolean"
	                },
	                "IncludeSubdomains": {
	                  "type": "boolean"
	                },
	                "Preload": {
	                  "type": "boolean"
	                },
	                "AccessControlMaxAgeSec": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        },
	        "CustomHeadersConfig": {
	          "type": "structure",
	          "required": [
	            "Quantity"
	          ],
	          "members": {
	            "Quantity": {
	              "type": "integer"
	            },
	            "Items": {
	              "type": "list",
	              "member": {
	                "locationName": "ResponseHeadersPolicyCustomHeader",
	                "type": "structure",
	                "required": [
	                  "Header",
	                  "Value",
	                  "Override"
	                ],
	                "members": {
	                  "Header": {},
	                  "Value": {},
	                  "Override": {
	                    "type": "boolean"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "ServerTimingHeadersConfig": {
	          "type": "structure",
	          "required": [
	            "Enabled"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "SamplingRate": {
	              "type": "double"
	            }
	          }
	        }
	      }
	    },
	    "S5y": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "LastModifiedTime",
	        "ResponseHeadersPolicyConfig"
	      ],
	      "members": {
	        "Id": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "ResponseHeadersPolicyConfig": {
	          "shape": "S58"
	        }
	      }
	    },
	    "S60": {
	      "type": "structure",
	      "required": [
	        "CallerReference",
	        "S3Origin",
	        "Comment",
	        "TrustedSigners",
	        "Enabled"
	      ],
	      "members": {
	        "CallerReference": {},
	        "S3Origin": {
	          "shape": "S61"
	        },
	        "Aliases": {
	          "shape": "Su"
	        },
	        "Comment": {},
	        "Logging": {
	          "type": "structure",
	          "required": [
	            "Enabled",
	            "Bucket",
	            "Prefix"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "Bucket": {},
	            "Prefix": {}
	          }
	        },
	        "TrustedSigners": {
	          "shape": "S1l"
	        },
	        "PriceClass": {},
	        "Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S61": {
	      "type": "structure",
	      "required": [
	        "DomainName",
	        "OriginAccessIdentity"
	      ],
	      "members": {
	        "DomainName": {},
	        "OriginAccessIdentity": {}
	      }
	    },
	    "S64": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "ARN",
	        "Status",
	        "DomainName",
	        "ActiveTrustedSigners",
	        "StreamingDistributionConfig"
	      ],
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "Status": {},
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "DomainName": {},
	        "ActiveTrustedSigners": {
	          "shape": "S2s"
	        },
	        "StreamingDistributionConfig": {
	          "shape": "S60"
	        }
	      }
	    },
	    "S8l": {
	      "type": "structure",
	      "required": [
	        "Marker",
	        "MaxItems",
	        "IsTruncated",
	        "Quantity"
	      ],
	      "members": {
	        "Marker": {},
	        "NextMarker": {},
	        "MaxItems": {
	          "type": "integer"
	        },
	        "IsTruncated": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "DistributionSummary",
	            "type": "structure",
	            "required": [
	              "Id",
	              "ARN",
	              "Status",
	              "LastModifiedTime",
	              "DomainName",
	              "Aliases",
	              "Origins",
	              "DefaultCacheBehavior",
	              "CacheBehaviors",
	              "CustomErrorResponses",
	              "Comment",
	              "PriceClass",
	              "Enabled",
	              "ViewerCertificate",
	              "Restrictions",
	              "WebACLId",
	              "HttpVersion",
	              "IsIPV6Enabled"
	            ],
	            "members": {
	              "Id": {},
	              "ARN": {},
	              "Status": {},
	              "LastModifiedTime": {
	                "type": "timestamp"
	              },
	              "DomainName": {},
	              "Aliases": {
	                "shape": "Su"
	              },
	              "Origins": {
	                "shape": "Sw"
	              },
	              "OriginGroups": {
	                "shape": "S1b"
	              },
	              "DefaultCacheBehavior": {
	                "shape": "S1k"
	              },
	              "CacheBehaviors": {
	                "shape": "S28"
	              },
	              "CustomErrorResponses": {
	                "shape": "S2b"
	              },
	              "Comment": {},
	              "PriceClass": {},
	              "Enabled": {
	                "type": "boolean"
	              },
	              "ViewerCertificate": {
	                "shape": "S2h"
	              },
	              "Restrictions": {
	                "shape": "S2l"
	              },
	              "WebACLId": {},
	              "HttpVersion": {},
	              "IsIPV6Enabled": {
	                "type": "boolean"
	              },
	              "AliasICPRecordals": {
	                "shape": "S30"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S8q": {
	      "type": "structure",
	      "required": [
	        "Marker",
	        "MaxItems",
	        "IsTruncated",
	        "Quantity"
	      ],
	      "members": {
	        "Marker": {},
	        "NextMarker": {},
	        "MaxItems": {
	          "type": "integer"
	        },
	        "IsTruncated": {
	          "type": "boolean"
	        },
	        "Quantity": {
	          "type": "integer"
	        },
	        "Items": {
	          "type": "list",
	          "member": {
	            "locationName": "DistributionId"
	          }
	        }
	      }
	    }
	  }
	}
	},{}],36:[function(require,module,exports){
	arguments[4][21][0].apply(exports,arguments)
	},{"dup":21}],37:[function(require,module,exports){
	arguments[4][34][0].apply(exports,arguments)
	},{"dup":34}],38:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-05-30",
	    "endpointPrefix": "cloudhsm",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "CloudHSM",
	    "serviceFullName": "Amazon CloudHSM",
	    "serviceId": "CloudHSM",
	    "signatureVersion": "v4",
	    "targetPrefix": "CloudHsmFrontendService",
	    "uid": "cloudhsm-2014-05-30"
	  },
	  "operations": {
	    "AddTagsToResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagList"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagList": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Status"
	        ],
	        "members": {
	          "Status": {}
	        }
	      }
	    },
	    "CreateHapg": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Label"
	        ],
	        "members": {
	          "Label": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HapgArn": {}
	        }
	      }
	    },
	    "CreateHsm": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubnetId",
	          "SshKey",
	          "IamRoleArn",
	          "SubscriptionType"
	        ],
	        "members": {
	          "SubnetId": {},
	          "SshKey": {},
	          "EniIp": {},
	          "IamRoleArn": {},
	          "ExternalId": {},
	          "SubscriptionType": {},
	          "ClientToken": {},
	          "SyslogIp": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HsmArn": {}
	        }
	      }
	    },
	    "CreateLunaClient": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Certificate"
	        ],
	        "members": {
	          "Label": {},
	          "Certificate": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientArn": {}
	        }
	      }
	    },
	    "DeleteHapg": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HapgArn"
	        ],
	        "members": {
	          "HapgArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Status"
	        ],
	        "members": {
	          "Status": {}
	        }
	      }
	    },
	    "DeleteHsm": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HsmArn"
	        ],
	        "members": {
	          "HsmArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Status"
	        ],
	        "members": {
	          "Status": {}
	        }
	      }
	    },
	    "DeleteLunaClient": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientArn"
	        ],
	        "members": {
	          "ClientArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Status"
	        ],
	        "members": {
	          "Status": {}
	        }
	      }
	    },
	    "DescribeHapg": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HapgArn"
	        ],
	        "members": {
	          "HapgArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HapgArn": {},
	          "HapgSerial": {},
	          "HsmsLastActionFailed": {
	            "shape": "Sz"
	          },
	          "HsmsPendingDeletion": {
	            "shape": "Sz"
	          },
	          "HsmsPendingRegistration": {
	            "shape": "Sz"
	          },
	          "Label": {},
	          "LastModifiedTimestamp": {},
	          "PartitionSerialList": {
	            "shape": "S11"
	          },
	          "State": {}
	        }
	      }
	    },
	    "DescribeHsm": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "HsmArn": {},
	          "HsmSerialNumber": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HsmArn": {},
	          "Status": {},
	          "StatusDetails": {},
	          "AvailabilityZone": {},
	          "EniId": {},
	          "EniIp": {},
	          "SubscriptionType": {},
	          "SubscriptionStartDate": {},
	          "SubscriptionEndDate": {},
	          "VpcId": {},
	          "SubnetId": {},
	          "IamRoleArn": {},
	          "SerialNumber": {},
	          "VendorName": {},
	          "HsmType": {},
	          "SoftwareVersion": {},
	          "SshPublicKey": {},
	          "SshKeyLastUpdated": {},
	          "ServerCertUri": {},
	          "ServerCertLastUpdated": {},
	          "Partitions": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "DescribeLunaClient": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClientArn": {},
	          "CertificateFingerprint": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientArn": {},
	          "Certificate": {},
	          "CertificateFingerprint": {},
	          "LastModifiedTimestamp": {},
	          "Label": {}
	        }
	      }
	    },
	    "GetConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientArn",
	          "ClientVersion",
	          "HapgList"
	        ],
	        "members": {
	          "ClientArn": {},
	          "ClientVersion": {},
	          "HapgList": {
	            "shape": "S1i"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConfigType": {},
	          "ConfigFile": {},
	          "ConfigCred": {}
	        }
	      }
	    },
	    "ListAvailableZones": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AZList": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "ListHapgs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HapgList"
	        ],
	        "members": {
	          "HapgList": {
	            "shape": "S1i"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListHsms": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HsmList": {
	            "shape": "Sz"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListLunaClients": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ClientList"
	        ],
	        "members": {
	          "ClientList": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TagList"
	        ],
	        "members": {
	          "TagList": {
	            "shape": "S3"
	          }
	        }
	      }
	    },
	    "ModifyHapg": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HapgArn"
	        ],
	        "members": {
	          "HapgArn": {},
	          "Label": {},
	          "PartitionSerialList": {
	            "shape": "S11"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HapgArn": {}
	        }
	      }
	    },
	    "ModifyHsm": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HsmArn"
	        ],
	        "members": {
	          "HsmArn": {},
	          "SubnetId": {},
	          "EniIp": {},
	          "IamRoleArn": {},
	          "ExternalId": {},
	          "SyslogIp": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HsmArn": {}
	        }
	      }
	    },
	    "ModifyLunaClient": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientArn",
	          "Certificate"
	        ],
	        "members": {
	          "ClientArn": {},
	          "Certificate": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientArn": {}
	        }
	      }
	    },
	    "RemoveTagsFromResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeyList"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagKeyList": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Status"
	        ],
	        "members": {
	          "Status": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S3": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sz": {
	      "type": "list",
	      "member": {}
	    },
	    "S11": {
	      "type": "list",
	      "member": {}
	    },
	    "S1i": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],39:[function(require,module,exports){
	module.exports={
	  "pagination": {
	  }
	}
	
	},{}],40:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-04-28",
	    "endpointPrefix": "cloudhsmv2",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "CloudHSM V2",
	    "serviceFullName": "AWS CloudHSM V2",
	    "serviceId": "CloudHSM V2",
	    "signatureVersion": "v4",
	    "signingName": "cloudhsm",
	    "targetPrefix": "BaldrApiService",
	    "uid": "cloudhsmv2-2017-04-28"
	  },
	  "operations": {
	    "CopyBackupToRegion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DestinationRegion",
	          "BackupId"
	        ],
	        "members": {
	          "DestinationRegion": {},
	          "BackupId": {},
	          "TagList": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DestinationBackup": {
	            "type": "structure",
	            "members": {
	              "CreateTimestamp": {
	                "type": "timestamp"
	              },
	              "SourceRegion": {},
	              "SourceBackup": {},
	              "SourceCluster": {}
	            }
	          }
	        }
	      }
	    },
	    "CreateCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HsmType",
	          "SubnetIds"
	        ],
	        "members": {
	          "BackupRetentionPolicy": {
	            "shape": "Sd"
	          },
	          "HsmType": {},
	          "SourceBackupId": {},
	          "SubnetIds": {
	            "type": "list",
	            "member": {}
	          },
	          "TagList": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "CreateHsm": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId",
	          "AvailabilityZone"
	        ],
	        "members": {
	          "ClusterId": {},
	          "AvailabilityZone": {},
	          "IpAddress": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Hsm": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "DeleteBackup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BackupId"
	        ],
	        "members": {
	          "BackupId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Backup": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "DeleteCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "DeleteHsm": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {},
	          "HsmId": {},
	          "EniId": {},
	          "EniIp": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HsmId": {}
	        }
	      }
	    },
	    "DescribeBackups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "S1g"
	          },
	          "SortAscending": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Backups": {
	            "type": "list",
	            "member": {
	              "shape": "S16"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeClusters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "S1g"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Clusters": {
	            "type": "list",
	            "member": {
	              "shape": "Sk"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "InitializeCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId",
	          "SignedCert",
	          "TrustAnchor"
	        ],
	        "members": {
	          "ClusterId": {},
	          "SignedCert": {},
	          "TrustAnchor": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "State": {},
	          "StateMessage": {}
	        }
	      }
	    },
	    "ListTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId"
	        ],
	        "members": {
	          "ResourceId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TagList"
	        ],
	        "members": {
	          "TagList": {
	            "shape": "S4"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ModifyBackupAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BackupId",
	          "NeverExpires"
	        ],
	        "members": {
	          "BackupId": {},
	          "NeverExpires": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Backup": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "ModifyCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BackupRetentionPolicy",
	          "ClusterId"
	        ],
	        "members": {
	          "BackupRetentionPolicy": {
	            "shape": "Sd"
	          },
	          "ClusterId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "RestoreBackup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BackupId"
	        ],
	        "members": {
	          "BackupId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Backup": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "TagList"
	        ],
	        "members": {
	          "ResourceId": {},
	          "TagList": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "TagKeyList"
	        ],
	        "members": {
	          "ResourceId": {},
	          "TagKeyList": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sd": {
	      "type": "structure",
	      "members": {
	        "Type": {},
	        "Value": {}
	      }
	    },
	    "Sk": {
	      "type": "structure",
	      "members": {
	        "BackupPolicy": {},
	        "BackupRetentionPolicy": {
	          "shape": "Sd"
	        },
	        "ClusterId": {},
	        "CreateTimestamp": {
	          "type": "timestamp"
	        },
	        "Hsms": {
	          "type": "list",
	          "member": {
	            "shape": "Sn"
	          }
	        },
	        "HsmType": {},
	        "PreCoPassword": {},
	        "SecurityGroup": {},
	        "SourceBackupId": {},
	        "State": {},
	        "StateMessage": {},
	        "SubnetMapping": {
	          "type": "map",
	          "key": {},
	          "value": {}
	        },
	        "VpcId": {},
	        "Certificates": {
	          "type": "structure",
	          "members": {
	            "ClusterCsr": {},
	            "HsmCertificate": {},
	            "AwsHardwareCertificate": {},
	            "ManufacturerHardwareCertificate": {},
	            "ClusterCertificate": {}
	          }
	        },
	        "TagList": {
	          "shape": "S4"
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "required": [
	        "HsmId"
	      ],
	      "members": {
	        "AvailabilityZone": {},
	        "ClusterId": {},
	        "SubnetId": {},
	        "EniId": {},
	        "EniIp": {},
	        "HsmId": {},
	        "State": {},
	        "StateMessage": {}
	      }
	    },
	    "S16": {
	      "type": "structure",
	      "required": [
	        "BackupId"
	      ],
	      "members": {
	        "BackupId": {},
	        "BackupState": {},
	        "ClusterId": {},
	        "CreateTimestamp": {
	          "type": "timestamp"
	        },
	        "CopyTimestamp": {
	          "type": "timestamp"
	        },
	        "NeverExpires": {
	          "type": "boolean"
	        },
	        "SourceRegion": {},
	        "SourceBackup": {},
	        "SourceCluster": {},
	        "DeleteTimestamp": {
	          "type": "timestamp"
	        },
	        "TagList": {
	          "shape": "S4"
	        }
	      }
	    },
	    "S1g": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "list",
	        "member": {}
	      }
	    }
	  }
	}
	},{}],41:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeBackups": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "DescribeClusters": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListTags": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    }
	  }
	}
	
	},{}],42:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2013-11-01",
	    "endpointPrefix": "cloudtrail",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "CloudTrail",
	    "serviceFullName": "AWS CloudTrail",
	    "serviceId": "CloudTrail",
	    "signatureVersion": "v4",
	    "targetPrefix": "com.amazonaws.cloudtrail.v20131101.CloudTrail_20131101",
	    "uid": "cloudtrail-2013-11-01"
	  },
	  "operations": {
	    "AddTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "TagsList"
	        ],
	        "members": {
	          "ResourceId": {},
	          "TagsList": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "CancelQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EventDataStore",
	          "QueryId"
	        ],
	        "members": {
	          "EventDataStore": {},
	          "QueryId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "QueryId",
	          "QueryStatus"
	        ],
	        "members": {
	          "QueryId": {},
	          "QueryStatus": {}
	        }
	      },
	      "idempotent": true
	    },
	    "CreateEventDataStore": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "AdvancedEventSelectors": {
	            "shape": "Sf"
	          },
	          "MultiRegionEnabled": {
	            "type": "boolean"
	          },
	          "OrganizationEnabled": {
	            "type": "boolean"
	          },
	          "RetentionPeriod": {
	            "type": "integer"
	          },
	          "TerminationProtectionEnabled": {
	            "type": "boolean"
	          },
	          "TagsList": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EventDataStoreArn": {},
	          "Name": {},
	          "Status": {},
	          "AdvancedEventSelectors": {
	            "shape": "Sf"
	          },
	          "MultiRegionEnabled": {
	            "type": "boolean"
	          },
	          "OrganizationEnabled": {
	            "type": "boolean"
	          },
	          "RetentionPeriod": {
	            "type": "integer"
	          },
	          "TerminationProtectionEnabled": {
	            "type": "boolean"
	          },
	          "TagsList": {
	            "shape": "S3"
	          },
	          "CreatedTimestamp": {
	            "type": "timestamp"
	          },
	          "UpdatedTimestamp": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "CreateTrail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "S3BucketName"
	        ],
	        "members": {
	          "Name": {},
	          "S3BucketName": {},
	          "S3KeyPrefix": {},
	          "SnsTopicName": {},
	          "IncludeGlobalServiceEvents": {
	            "type": "boolean"
	          },
	          "IsMultiRegionTrail": {
	            "type": "boolean"
	          },
	          "EnableLogFileValidation": {
	            "type": "boolean"
	          },
	          "CloudWatchLogsLogGroupArn": {},
	          "CloudWatchLogsRoleArn": {},
	          "KmsKeyId": {},
	          "IsOrganizationTrail": {
	            "type": "boolean"
	          },
	          "TagsList": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "S3BucketName": {},
	          "S3KeyPrefix": {},
	          "SnsTopicName": {
	            "deprecated": true
	          },
	          "SnsTopicARN": {},
	          "IncludeGlobalServiceEvents": {
	            "type": "boolean"
	          },
	          "IsMultiRegionTrail": {
	            "type": "boolean"
	          },
	          "TrailARN": {},
	          "LogFileValidationEnabled": {
	            "type": "boolean"
	          },
	          "CloudWatchLogsLogGroupArn": {},
	          "CloudWatchLogsRoleArn": {},
	          "KmsKeyId": {},
	          "IsOrganizationTrail": {
	            "type": "boolean"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteEventDataStore": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EventDataStore"
	        ],
	        "members": {
	          "EventDataStore": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteTrail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "DescribeQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EventDataStore",
	          "QueryId"
	        ],
	        "members": {
	          "EventDataStore": {},
	          "QueryId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QueryId": {},
	          "QueryString": {},
	          "QueryStatus": {},
	          "QueryStatistics": {
	            "type": "structure",
	            "members": {
	              "EventsMatched": {
	                "type": "long"
	              },
	              "EventsScanned": {
	                "type": "long"
	              },
	              "BytesScanned": {
	                "type": "long"
	              },
	              "ExecutionTimeInMillis": {
	                "type": "integer"
	              },
	              "CreationTime": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "ErrorMessage": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeTrails": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "trailNameList": {
	            "type": "list",
	            "member": {}
	          },
	          "includeShadowTrails": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "trailList": {
	            "type": "list",
	            "member": {
	              "shape": "S1a"
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "GetEventDataStore": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EventDataStore"
	        ],
	        "members": {
	          "EventDataStore": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EventDataStoreArn": {},
	          "Name": {},
	          "Status": {},
	          "AdvancedEventSelectors": {
	            "shape": "Sf"
	          },
	          "MultiRegionEnabled": {
	            "type": "boolean"
	          },
	          "OrganizationEnabled": {
	            "type": "boolean"
	          },
	          "RetentionPeriod": {
	            "type": "integer"
	          },
	          "TerminationProtectionEnabled": {
	            "type": "boolean"
	          },
	          "CreatedTimestamp": {
	            "type": "timestamp"
	          },
	          "UpdatedTimestamp": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "GetEventSelectors": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrailName"
	        ],
	        "members": {
	          "TrailName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrailARN": {},
	          "EventSelectors": {
	            "shape": "S1f"
	          },
	          "AdvancedEventSelectors": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "GetInsightSelectors": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrailName"
	        ],
	        "members": {
	          "TrailName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrailARN": {},
	          "InsightSelectors": {
	            "shape": "S1o"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "GetQueryResults": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EventDataStore",
	          "QueryId"
	        ],
	        "members": {
	          "EventDataStore": {},
	          "QueryId": {},
	          "NextToken": {},
	          "MaxQueryResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QueryStatus": {},
	          "QueryStatistics": {
	            "type": "structure",
	            "members": {
	              "ResultsCount": {
	                "type": "integer"
	              },
	              "TotalResultsCount": {
	                "type": "integer"
	              },
	              "BytesScanned": {
	                "type": "long"
	              }
	            }
	          },
	          "QueryResultRows": {
	            "type": "list",
	            "member": {
	              "type": "list",
	              "member": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              }
	            }
	          },
	          "NextToken": {},
	          "ErrorMessage": {}
	        }
	      }
	    },
	    "GetTrail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Trail": {
	            "shape": "S1a"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "GetTrailStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IsLogging": {
	            "type": "boolean"
	          },
	          "LatestDeliveryError": {},
	          "LatestNotificationError": {},
	          "LatestDeliveryTime": {
	            "type": "timestamp"
	          },
	          "LatestNotificationTime": {
	            "type": "timestamp"
	          },
	          "StartLoggingTime": {
	            "type": "timestamp"
	          },
	          "StopLoggingTime": {
	            "type": "timestamp"
	          },
	          "LatestCloudWatchLogsDeliveryError": {},
	          "LatestCloudWatchLogsDeliveryTime": {
	            "type": "timestamp"
	          },
	          "LatestDigestDeliveryTime": {
	            "type": "timestamp"
	          },
	          "LatestDigestDeliveryError": {},
	          "LatestDeliveryAttemptTime": {},
	          "LatestNotificationAttemptTime": {},
	          "LatestNotificationAttemptSucceeded": {},
	          "LatestDeliveryAttemptSucceeded": {},
	          "TimeLoggingStarted": {},
	          "TimeLoggingStopped": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListEventDataStores": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EventDataStores": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EventDataStoreArn": {},
	                "Name": {},
	                "TerminationProtectionEnabled": {
	                  "deprecated": true,
	                  "deprecatedMessage": "TerminationProtectionEnabled is no longer returned by ListEventDataStores",
	                  "type": "boolean"
	                },
	                "Status": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Status is no longer returned by ListEventDataStores"
	                },
	                "AdvancedEventSelectors": {
	                  "shape": "Sf",
	                  "deprecated": true,
	                  "deprecatedMessage": "AdvancedEventSelectors is no longer returned by ListEventDataStores"
	                },
	                "MultiRegionEnabled": {
	                  "deprecated": true,
	                  "deprecatedMessage": "MultiRegionEnabled is no longer returned by ListEventDataStores",
	                  "type": "boolean"
	                },
	                "OrganizationEnabled": {
	                  "deprecated": true,
	                  "deprecatedMessage": "OrganizationEnabled is no longer returned by ListEventDataStores",
	                  "type": "boolean"
	                },
	                "RetentionPeriod": {
	                  "deprecated": true,
	                  "deprecatedMessage": "RetentionPeriod is no longer returned by ListEventDataStores",
	                  "type": "integer"
	                },
	                "CreatedTimestamp": {
	                  "deprecated": true,
	                  "deprecatedMessage": "CreatedTimestamp is no longer returned by ListEventDataStores",
	                  "type": "timestamp"
	                },
	                "UpdatedTimestamp": {
	                  "deprecated": true,
	                  "deprecatedMessage": "UpdatedTimestamp is no longer returned by ListEventDataStores",
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListPublicKeys": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicKeyList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Value": {
	                  "type": "blob"
	                },
	                "ValidityStartTime": {
	                  "type": "timestamp"
	                },
	                "ValidityEndTime": {
	                  "type": "timestamp"
	                },
	                "Fingerprint": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListQueries": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EventDataStore"
	        ],
	        "members": {
	          "EventDataStore": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "QueryStatus": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Queries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "QueryId": {},
	                "QueryStatus": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceIdList"
	        ],
	        "members": {
	          "ResourceIdList": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceTagList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ResourceId": {},
	                "TagsList": {
	                  "shape": "S3"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListTrails": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Trails": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TrailARN": {},
	                "Name": {},
	                "HomeRegion": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "LookupEvents": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LookupAttributes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "AttributeKey",
	                "AttributeValue"
	              ],
	              "members": {
	                "AttributeKey": {},
	                "AttributeValue": {}
	              }
	            }
	          },
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "EventCategory": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Events": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EventId": {},
	                "EventName": {},
	                "ReadOnly": {},
	                "AccessKeyId": {},
	                "EventTime": {
	                  "type": "timestamp"
	                },
	                "EventSource": {},
	                "Username": {},
	                "Resources": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "ResourceType": {},
	                      "ResourceName": {}
	                    }
	                  }
	                },
	                "CloudTrailEvent": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "PutEventSelectors": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrailName"
	        ],
	        "members": {
	          "TrailName": {},
	          "EventSelectors": {
	            "shape": "S1f"
	          },
	          "AdvancedEventSelectors": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrailARN": {},
	          "EventSelectors": {
	            "shape": "S1f"
	          },
	          "AdvancedEventSelectors": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "PutInsightSelectors": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrailName",
	          "InsightSelectors"
	        ],
	        "members": {
	          "TrailName": {},
	          "InsightSelectors": {
	            "shape": "S1o"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrailARN": {},
	          "InsightSelectors": {
	            "shape": "S1o"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "RemoveTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "TagsList"
	        ],
	        "members": {
	          "ResourceId": {},
	          "TagsList": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "RestoreEventDataStore": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EventDataStore"
	        ],
	        "members": {
	          "EventDataStore": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EventDataStoreArn": {},
	          "Name": {},
	          "Status": {},
	          "AdvancedEventSelectors": {
	            "shape": "Sf"
	          },
	          "MultiRegionEnabled": {
	            "type": "boolean"
	          },
	          "OrganizationEnabled": {
	            "type": "boolean"
	          },
	          "RetentionPeriod": {
	            "type": "integer"
	          },
	          "TerminationProtectionEnabled": {
	            "type": "boolean"
	          },
	          "CreatedTimestamp": {
	            "type": "timestamp"
	          },
	          "UpdatedTimestamp": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "StartLogging": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "StartQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueryStatement"
	        ],
	        "members": {
	          "QueryStatement": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QueryId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StopLogging": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "UpdateEventDataStore": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EventDataStore"
	        ],
	        "members": {
	          "EventDataStore": {},
	          "Name": {},
	          "AdvancedEventSelectors": {
	            "shape": "Sf"
	          },
	          "MultiRegionEnabled": {
	            "type": "boolean"
	          },
	          "OrganizationEnabled": {
	            "type": "boolean"
	          },
	          "RetentionPeriod": {
	            "type": "integer"
	          },
	          "TerminationProtectionEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EventDataStoreArn": {},
	          "Name": {},
	          "Status": {},
	          "AdvancedEventSelectors": {
	            "shape": "Sf"
	          },
	          "MultiRegionEnabled": {
	            "type": "boolean"
	          },
	          "OrganizationEnabled": {
	            "type": "boolean"
	          },
	          "RetentionPeriod": {
	            "type": "integer"
	          },
	          "TerminationProtectionEnabled": {
	            "type": "boolean"
	          },
	          "CreatedTimestamp": {
	            "type": "timestamp"
	          },
	          "UpdatedTimestamp": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "UpdateTrail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "S3BucketName": {},
	          "S3KeyPrefix": {},
	          "SnsTopicName": {},
	          "IncludeGlobalServiceEvents": {
	            "type": "boolean"
	          },
	          "IsMultiRegionTrail": {
	            "type": "boolean"
	          },
	          "EnableLogFileValidation": {
	            "type": "boolean"
	          },
	          "CloudWatchLogsLogGroupArn": {},
	          "CloudWatchLogsRoleArn": {},
	          "KmsKeyId": {},
	          "IsOrganizationTrail": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "S3BucketName": {},
	          "S3KeyPrefix": {},
	          "SnsTopicName": {
	            "deprecated": true
	          },
	          "SnsTopicARN": {},
	          "IncludeGlobalServiceEvents": {
	            "type": "boolean"
	          },
	          "IsMultiRegionTrail": {
	            "type": "boolean"
	          },
	          "TrailARN": {},
	          "LogFileValidationEnabled": {
	            "type": "boolean"
	          },
	          "CloudWatchLogsLogGroupArn": {},
	          "CloudWatchLogsRoleArn": {},
	          "KmsKeyId": {},
	          "IsOrganizationTrail": {
	            "type": "boolean"
	          }
	        }
	      },
	      "idempotent": true
	    }
	  },
	  "shapes": {
	    "S3": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sf": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "FieldSelectors"
	        ],
	        "members": {
	          "Name": {},
	          "FieldSelectors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Field"
	              ],
	              "members": {
	                "Field": {},
	                "Equals": {
	                  "shape": "Sl"
	                },
	                "StartsWith": {
	                  "shape": "Sl"
	                },
	                "EndsWith": {
	                  "shape": "Sl"
	                },
	                "NotEquals": {
	                  "shape": "Sl"
	                },
	                "NotStartsWith": {
	                  "shape": "Sl"
	                },
	                "NotEndsWith": {
	                  "shape": "Sl"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sl": {
	      "type": "list",
	      "member": {}
	    },
	    "S1a": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "S3BucketName": {},
	        "S3KeyPrefix": {},
	        "SnsTopicName": {
	          "deprecated": true
	        },
	        "SnsTopicARN": {},
	        "IncludeGlobalServiceEvents": {
	          "type": "boolean"
	        },
	        "IsMultiRegionTrail": {
	          "type": "boolean"
	        },
	        "HomeRegion": {},
	        "TrailARN": {},
	        "LogFileValidationEnabled": {
	          "type": "boolean"
	        },
	        "CloudWatchLogsLogGroupArn": {},
	        "CloudWatchLogsRoleArn": {},
	        "KmsKeyId": {},
	        "HasCustomEventSelectors": {
	          "type": "boolean"
	        },
	        "HasInsightSelectors": {
	          "type": "boolean"
	        },
	        "IsOrganizationTrail": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1f": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ReadWriteType": {},
	          "IncludeManagementEvents": {
	            "type": "boolean"
	          },
	          "DataResources": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Type": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "ExcludeManagementEventSources": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "S1o": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "InsightType": {}
	        }
	      }
	    }
	  }
	}
	},{}],43:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeTrails": {
	      "result_key": "trailList"
	    },
	    "GetQueryResults": {
	      "input_token": "NextToken",
	      "output_token": "NextToken"
	    },
	    "ListEventDataStores": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListPublicKeys": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "PublicKeyList"
	    },
	    "ListQueries": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListTags": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "ResourceTagList"
	    },
	    "ListTrails": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Trails"
	    },
	    "LookupEvents": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Events"
	    }
	  }
	}
	},{}],44:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2016-10-06",
	    "endpointPrefix": "codebuild",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "AWS CodeBuild",
	    "serviceId": "CodeBuild",
	    "signatureVersion": "v4",
	    "targetPrefix": "CodeBuild_20161006",
	    "uid": "codebuild-2016-10-06"
	  },
	  "operations": {
	    "BatchDeleteBuilds": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ids"
	        ],
	        "members": {
	          "ids": {
	            "shape": "S2"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "buildsDeleted": {
	            "shape": "S2"
	          },
	          "buildsNotDeleted": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "BatchGetBuildBatches": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ids"
	        ],
	        "members": {
	          "ids": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "buildBatches": {
	            "type": "list",
	            "member": {
	              "shape": "Sc"
	            }
	          },
	          "buildBatchesNotFound": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "BatchGetBuilds": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ids"
	        ],
	        "members": {
	          "ids": {
	            "shape": "S2"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "builds": {
	            "type": "list",
	            "member": {
	              "shape": "S23"
	            }
	          },
	          "buildsNotFound": {
	            "shape": "S2"
	          }
	        }
	      }
	    },
	    "BatchGetProjects": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "names"
	        ],
	        "members": {
	          "names": {
	            "shape": "S2e"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "projects": {
	            "type": "list",
	            "member": {
	              "shape": "S2h"
	            }
	          },
	          "projectsNotFound": {
	            "shape": "S2e"
	          }
	        }
	      }
	    },
	    "BatchGetReportGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "reportGroupArns"
	        ],
	        "members": {
	          "reportGroupArns": {
	            "shape": "S32"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "reportGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S35"
	            }
	          },
	          "reportGroupsNotFound": {
	            "shape": "S32"
	          }
	        }
	      }
	    },
	    "BatchGetReports": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "reportArns"
	        ],
	        "members": {
	          "reportArns": {
	            "shape": "S3e"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "reports": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "arn": {},
	                "type": {},
	                "name": {},
	                "reportGroupArn": {},
	                "executionId": {},
	                "status": {},
	                "created": {
	                  "type": "timestamp"
	                },
	                "expired": {
	                  "type": "timestamp"
	                },
	                "exportConfig": {
	                  "shape": "S38"
	                },
	                "truncated": {
	                  "type": "boolean"
	                },
	                "testSummary": {
	                  "type": "structure",
	                  "required": [
	                    "total",
	                    "statusCounts",
	                    "durationInNanoSeconds"
	                  ],
	                  "members": {
	                    "total": {
	                      "type": "integer"
	                    },
	                    "statusCounts": {
	                      "type": "map",
	                      "key": {},
	                      "value": {
	                        "type": "integer"
	                      }
	                    },
	                    "durationInNanoSeconds": {
	                      "type": "long"
	                    }
	                  }
	                },
	                "codeCoverageSummary": {
	                  "type": "structure",
	                  "members": {
	                    "lineCoveragePercentage": {
	                      "type": "double"
	                    },
	                    "linesCovered": {
	                      "type": "integer"
	                    },
	                    "linesMissed": {
	                      "type": "integer"
	                    },
	                    "branchCoveragePercentage": {
	                      "type": "double"
	                    },
	                    "branchesCovered": {
	                      "type": "integer"
	                    },
	                    "branchesMissed": {
	                      "type": "integer"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "reportsNotFound": {
	            "shape": "S3e"
	          }
	        }
	      }
	    },
	    "CreateProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "source",
	          "artifacts",
	          "environment",
	          "serviceRole"
	        ],
	        "members": {
	          "name": {},
	          "description": {},
	          "source": {
	            "shape": "Sl"
	          },
	          "secondarySources": {
	            "shape": "St"
	          },
	          "sourceVersion": {},
	          "secondarySourceVersions": {
	            "shape": "Su"
	          },
	          "artifacts": {
	            "shape": "S2k"
	          },
	          "secondaryArtifacts": {
	            "shape": "S2n"
	          },
	          "cache": {
	            "shape": "Sz"
	          },
	          "environment": {
	            "shape": "S13"
	          },
	          "serviceRole": {},
	          "timeoutInMinutes": {
	            "type": "integer"
	          },
	          "queuedTimeoutInMinutes": {
	            "type": "integer"
	          },
	          "encryptionKey": {},
	          "tags": {
	            "shape": "S2p"
	          },
	          "vpcConfig": {
	            "shape": "S1i"
	          },
	          "badgeEnabled": {
	            "type": "boolean"
	          },
	          "logsConfig": {
	            "shape": "S1c"
	          },
	          "fileSystemLocations": {
	            "shape": "S1l"
	          },
	          "buildBatchConfig": {
	            "shape": "S1o"
	          },
	          "concurrentBuildLimit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "project": {
	            "shape": "S2h"
	          }
	        }
	      }
	    },
	    "CreateReportGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "type",
	          "exportConfig"
	        ],
	        "members": {
	          "name": {},
	          "type": {},
	          "exportConfig": {
	            "shape": "S38"
	          },
	          "tags": {
	            "shape": "S2p"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "reportGroup": {
	            "shape": "S35"
	          }
	        }
	      }
	    },
	    "CreateWebhook": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectName"
	        ],
	        "members": {
	          "projectName": {},
	          "branchFilter": {},
	          "filterGroups": {
	            "shape": "S2u"
	          },
	          "buildType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "webhook": {
	            "shape": "S2t"
	          }
	        }
	      }
	    },
	    "DeleteBuildBatch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "id"
	        ],
	        "members": {
	          "id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "statusCode": {},
	          "buildsDeleted": {
	            "shape": "S2"
	          },
	          "buildsNotDeleted": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "DeleteProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteReport": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteReportGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "deleteReports": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteSourceCredentials": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "arn": {}
	        }
	      }
	    },
	    "DeleteWebhook": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectName"
	        ],
	        "members": {
	          "projectName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeCodeCoverages": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "reportArn"
	        ],
	        "members": {
	          "reportArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "sortOrder": {},
	          "sortBy": {},
	          "minLineCoveragePercentage": {
	            "type": "double"
	          },
	          "maxLineCoveragePercentage": {
	            "type": "double"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "codeCoverages": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "id": {},
	                "reportARN": {},
	                "filePath": {},
	                "lineCoveragePercentage": {
	                  "type": "double"
	                },
	                "linesCovered": {
	                  "type": "integer"
	                },
	                "linesMissed": {
	                  "type": "integer"
	                },
	                "branchCoveragePercentage": {
	                  "type": "double"
	                },
	                "branchesCovered": {
	                  "type": "integer"
	                },
	                "branchesMissed": {
	                  "type": "integer"
	                },
	                "expired": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeTestCases": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "reportArn"
	        ],
	        "members": {
	          "reportArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "filter": {
	            "type": "structure",
	            "members": {
	              "status": {},
	              "keyword": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "testCases": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "reportArn": {},
	                "testRawDataPath": {},
	                "prefix": {},
	                "name": {},
	                "status": {},
	                "durationInNanoSeconds": {
	                  "type": "long"
	                },
	                "message": {},
	                "expired": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetReportGroupTrend": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "reportGroupArn",
	          "trendField"
	        ],
	        "members": {
	          "reportGroupArn": {},
	          "numOfReports": {
	            "type": "integer"
	          },
	          "trendField": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "stats": {
	            "type": "structure",
	            "members": {
	              "average": {},
	              "max": {},
	              "min": {}
	            }
	          },
	          "rawData": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "reportArn": {},
	                "data": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "policy": {}
	        }
	      }
	    },
	    "ImportSourceCredentials": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "token",
	          "serverType",
	          "authType"
	        ],
	        "members": {
	          "username": {},
	          "token": {
	            "type": "string",
	            "sensitive": true
	          },
	          "serverType": {},
	          "authType": {},
	          "shouldOverwrite": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "arn": {}
	        }
	      }
	    },
	    "InvalidateProjectCache": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectName"
	        ],
	        "members": {
	          "projectName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ListBuildBatches": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "filter": {
	            "shape": "S50"
	          },
	          "maxResults": {
	            "type": "integer"
	          },
	          "sortOrder": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ids": {
	            "shape": "S9"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListBuildBatchesForProject": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "projectName": {},
	          "filter": {
	            "shape": "S50"
	          },
	          "maxResults": {
	            "type": "integer"
	          },
	          "sortOrder": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ids": {
	            "shape": "S9"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListBuilds": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "sortOrder": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ids": {
	            "shape": "S2"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListBuildsForProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectName"
	        ],
	        "members": {
	          "projectName": {},
	          "sortOrder": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ids": {
	            "shape": "S2"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListCuratedEnvironmentImages": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "platforms": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "platform": {},
	                "languages": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "language": {},
	                      "images": {
	                        "type": "list",
	                        "member": {
	                          "type": "structure",
	                          "members": {
	                            "name": {},
	                            "description": {},
	                            "versions": {
	                              "type": "list",
	                              "member": {}
	                            }
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListProjects": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "sortBy": {},
	          "sortOrder": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "projects": {
	            "shape": "S2e"
	          }
	        }
	      }
	    },
	    "ListReportGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "sortOrder": {},
	          "sortBy": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "reportGroups": {
	            "shape": "S32"
	          }
	        }
	      }
	    },
	    "ListReports": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "sortOrder": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "filter": {
	            "shape": "S5q"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "reports": {
	            "shape": "S3e"
	          }
	        }
	      }
	    },
	    "ListReportsForReportGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "reportGroupArn"
	        ],
	        "members": {
	          "reportGroupArn": {},
	          "nextToken": {},
	          "sortOrder": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "filter": {
	            "shape": "S5q"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "reports": {
	            "shape": "S3e"
	          }
	        }
	      }
	    },
	    "ListSharedProjects": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "sortBy": {},
	          "sortOrder": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "projects": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "ListSharedReportGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "sortOrder": {},
	          "sortBy": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "reportGroups": {
	            "shape": "S32"
	          }
	        }
	      }
	    },
	    "ListSourceCredentials": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "sourceCredentialsInfos": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "arn": {},
	                "serverType": {},
	                "authType": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "policy",
	          "resourceArn"
	        ],
	        "members": {
	          "policy": {},
	          "resourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "resourceArn": {}
	        }
	      }
	    },
	    "RetryBuild": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "id": {},
	          "idempotencyToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "build": {
	            "shape": "S23"
	          }
	        }
	      }
	    },
	    "RetryBuildBatch": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "id": {},
	          "idempotencyToken": {},
	          "retryType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "buildBatch": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "StartBuild": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectName"
	        ],
	        "members": {
	          "projectName": {},
	          "secondarySourcesOverride": {
	            "shape": "St"
	          },
	          "secondarySourcesVersionOverride": {
	            "shape": "Su"
	          },
	          "sourceVersion": {},
	          "artifactsOverride": {
	            "shape": "S2k"
	          },
	          "secondaryArtifactsOverride": {
	            "shape": "S2n"
	          },
	          "environmentVariablesOverride": {
	            "shape": "S16"
	          },
	          "sourceTypeOverride": {},
	          "sourceLocationOverride": {},
	          "sourceAuthOverride": {
	            "shape": "Sq"
	          },
	          "gitCloneDepthOverride": {
	            "type": "integer"
	          },
	          "gitSubmodulesConfigOverride": {
	            "shape": "So"
	          },
	          "buildspecOverride": {},
	          "insecureSslOverride": {
	            "type": "boolean"
	          },
	          "reportBuildStatusOverride": {
	            "type": "boolean"
	          },
	          "buildStatusConfigOverride": {
	            "shape": "Ss"
	          },
	          "environmentTypeOverride": {},
	          "imageOverride": {},
	          "computeTypeOverride": {},
	          "certificateOverride": {},
	          "cacheOverride": {
	            "shape": "Sz"
	          },
	          "serviceRoleOverride": {},
	          "privilegedModeOverride": {
	            "type": "boolean"
	          },
	          "timeoutInMinutesOverride": {
	            "type": "integer"
	          },
	          "queuedTimeoutInMinutesOverride": {
	            "type": "integer"
	          },
	          "encryptionKeyOverride": {},
	          "idempotencyToken": {},
	          "logsConfigOverride": {
	            "shape": "S1c"
	          },
	          "registryCredentialOverride": {
	            "shape": "S19"
	          },
	          "imagePullCredentialsTypeOverride": {},
	          "debugSessionEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "build": {
	            "shape": "S23"
	          }
	        }
	      }
	    },
	    "StartBuildBatch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectName"
	        ],
	        "members": {
	          "projectName": {},
	          "secondarySourcesOverride": {
	            "shape": "St"
	          },
	          "secondarySourcesVersionOverride": {
	            "shape": "Su"
	          },
	          "sourceVersion": {},
	          "artifactsOverride": {
	            "shape": "S2k"
	          },
	          "secondaryArtifactsOverride": {
	            "shape": "S2n"
	          },
	          "environmentVariablesOverride": {
	            "shape": "S16"
	          },
	          "sourceTypeOverride": {},
	          "sourceLocationOverride": {},
	          "sourceAuthOverride": {
	            "shape": "Sq"
	          },
	          "gitCloneDepthOverride": {
	            "type": "integer"
	          },
	          "gitSubmodulesConfigOverride": {
	            "shape": "So"
	          },
	          "buildspecOverride": {},
	          "insecureSslOverride": {
	            "type": "boolean"
	          },
	          "reportBuildBatchStatusOverride": {
	            "type": "boolean"
	          },
	          "environmentTypeOverride": {},
	          "imageOverride": {},
	          "computeTypeOverride": {},
	          "certificateOverride": {},
	          "cacheOverride": {
	            "shape": "Sz"
	          },
	          "serviceRoleOverride": {},
	          "privilegedModeOverride": {
	            "type": "boolean"
	          },
	          "buildTimeoutInMinutesOverride": {
	            "type": "integer"
	          },
	          "queuedTimeoutInMinutesOverride": {
	            "type": "integer"
	          },
	          "encryptionKeyOverride": {},
	          "idempotencyToken": {},
	          "logsConfigOverride": {
	            "shape": "S1c"
	          },
	          "registryCredentialOverride": {
	            "shape": "S19"
	          },
	          "imagePullCredentialsTypeOverride": {},
	          "buildBatchConfigOverride": {
	            "shape": "S1o"
	          },
	          "debugSessionEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "buildBatch": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "StopBuild": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "id"
	        ],
	        "members": {
	          "id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "build": {
	            "shape": "S23"
	          }
	        }
	      }
	    },
	    "StopBuildBatch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "id"
	        ],
	        "members": {
	          "id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "buildBatch": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "UpdateProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {},
	          "description": {},
	          "source": {
	            "shape": "Sl"
	          },
	          "secondarySources": {
	            "shape": "St"
	          },
	          "sourceVersion": {},
	          "secondarySourceVersions": {
	            "shape": "Su"
	          },
	          "artifacts": {
	            "shape": "S2k"
	          },
	          "secondaryArtifacts": {
	            "shape": "S2n"
	          },
	          "cache": {
	            "shape": "Sz"
	          },
	          "environment": {
	            "shape": "S13"
	          },
	          "serviceRole": {},
	          "timeoutInMinutes": {
	            "type": "integer"
	          },
	          "queuedTimeoutInMinutes": {
	            "type": "integer"
	          },
	          "encryptionKey": {},
	          "tags": {
	            "shape": "S2p"
	          },
	          "vpcConfig": {
	            "shape": "S1i"
	          },
	          "badgeEnabled": {
	            "type": "boolean"
	          },
	          "logsConfig": {
	            "shape": "S1c"
	          },
	          "fileSystemLocations": {
	            "shape": "S1l"
	          },
	          "buildBatchConfig": {
	            "shape": "S1o"
	          },
	          "concurrentBuildLimit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "project": {
	            "shape": "S2h"
	          }
	        }
	      }
	    },
	    "UpdateProjectVisibility": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectArn",
	          "projectVisibility"
	        ],
	        "members": {
	          "projectArn": {},
	          "projectVisibility": {},
	          "resourceAccessRole": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "projectArn": {},
	          "publicProjectAlias": {},
	          "projectVisibility": {}
	        }
	      }
	    },
	    "UpdateReportGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "exportConfig": {
	            "shape": "S38"
	          },
	          "tags": {
	            "shape": "S2p"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "reportGroup": {
	            "shape": "S35"
	          }
	        }
	      }
	    },
	    "UpdateWebhook": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectName"
	        ],
	        "members": {
	          "projectName": {},
	          "branchFilter": {},
	          "rotateSecret": {
	            "type": "boolean"
	          },
	          "filterGroups": {
	            "shape": "S2u"
	          },
	          "buildType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "webhook": {
	            "shape": "S2t"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "list",
	      "member": {}
	    },
	    "S5": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "id": {},
	          "statusCode": {}
	        }
	      }
	    },
	    "S9": {
	      "type": "list",
	      "member": {}
	    },
	    "Sc": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "arn": {},
	        "startTime": {
	          "type": "timestamp"
	        },
	        "endTime": {
	          "type": "timestamp"
	        },
	        "currentPhase": {},
	        "buildBatchStatus": {},
	        "sourceVersion": {},
	        "resolvedSourceVersion": {},
	        "projectName": {},
	        "phases": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "phaseType": {},
	              "phaseStatus": {},
	              "startTime": {
	                "type": "timestamp"
	              },
	              "endTime": {
	                "type": "timestamp"
	              },
	              "durationInSeconds": {
	                "type": "long"
	              },
	              "contexts": {
	                "shape": "Sj"
	              }
	            }
	          }
	        },
	        "source": {
	          "shape": "Sl"
	        },
	        "secondarySources": {
	          "shape": "St"
	        },
	        "secondarySourceVersions": {
	          "shape": "Su"
	        },
	        "artifacts": {
	          "shape": "Sw"
	        },
	        "secondaryArtifacts": {
	          "shape": "Sy"
	        },
	        "cache": {
	          "shape": "Sz"
	        },
	        "environment": {
	          "shape": "S13"
	        },
	        "serviceRole": {},
	        "logConfig": {
	          "shape": "S1c"
	        },
	        "buildTimeoutInMinutes": {
	          "type": "integer"
	        },
	        "queuedTimeoutInMinutes": {
	          "type": "integer"
	        },
	        "complete": {
	          "type": "boolean"
	        },
	        "initiator": {},
	        "vpcConfig": {
	          "shape": "S1i"
	        },
	        "encryptionKey": {},
	        "buildBatchNumber": {
	          "type": "long"
	        },
	        "fileSystemLocations": {
	          "shape": "S1l"
	        },
	        "buildBatchConfig": {
	          "shape": "S1o"
	        },
	        "buildGroups": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "identifier": {},
	              "dependsOn": {
	                "type": "list",
	                "member": {}
	              },
	              "ignoreFailure": {
	                "type": "boolean"
	              },
	              "currentBuildSummary": {
	                "shape": "S1v"
	              },
	              "priorBuildSummaryList": {
	                "type": "list",
	                "member": {
	                  "shape": "S1v"
	                }
	              }
	            }
	          }
	        },
	        "debugSessionEnabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Sj": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "statusCode": {},
	          "message": {}
	        }
	      }
	    },
	    "Sl": {
	      "type": "structure",
	      "required": [
	        "type"
	      ],
	      "members": {
	        "type": {},
	        "location": {},
	        "gitCloneDepth": {
	          "type": "integer"
	        },
	        "gitSubmodulesConfig": {
	          "shape": "So"
	        },
	        "buildspec": {},
	        "auth": {
	          "shape": "Sq"
	        },
	        "reportBuildStatus": {
	          "type": "boolean"
	        },
	        "buildStatusConfig": {
	          "shape": "Ss"
	        },
	        "insecureSsl": {
	          "type": "boolean"
	        },
	        "sourceIdentifier": {}
	      }
	    },
	    "So": {
	      "type": "structure",
	      "required": [
	        "fetchSubmodules"
	      ],
	      "members": {
	        "fetchSubmodules": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Sq": {
	      "type": "structure",
	      "required": [
	        "type"
	      ],
	      "members": {
	        "type": {},
	        "resource": {}
	      }
	    },
	    "Ss": {
	      "type": "structure",
	      "members": {
	        "context": {},
	        "targetUrl": {}
	      }
	    },
	    "St": {
	      "type": "list",
	      "member": {
	        "shape": "Sl"
	      }
	    },
	    "Su": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "sourceIdentifier",
	          "sourceVersion"
	        ],
	        "members": {
	          "sourceIdentifier": {},
	          "sourceVersion": {}
	        }
	      }
	    },
	    "Sw": {
	      "type": "structure",
	      "members": {
	        "location": {},
	        "sha256sum": {},
	        "md5sum": {},
	        "overrideArtifactName": {
	          "type": "boolean"
	        },
	        "encryptionDisabled": {
	          "type": "boolean"
	        },
	        "artifactIdentifier": {},
	        "bucketOwnerAccess": {}
	      }
	    },
	    "Sy": {
	      "type": "list",
	      "member": {
	        "shape": "Sw"
	      }
	    },
	    "Sz": {
	      "type": "structure",
	      "required": [
	        "type"
	      ],
	      "members": {
	        "type": {},
	        "location": {},
	        "modes": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S13": {
	      "type": "structure",
	      "required": [
	        "type",
	        "image",
	        "computeType"
	      ],
	      "members": {
	        "type": {},
	        "image": {},
	        "computeType": {},
	        "environmentVariables": {
	          "shape": "S16"
	        },
	        "privilegedMode": {
	          "type": "boolean"
	        },
	        "certificate": {},
	        "registryCredential": {
	          "shape": "S19"
	        },
	        "imagePullCredentialsType": {}
	      }
	    },
	    "S16": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "name",
	          "value"
	        ],
	        "members": {
	          "name": {},
	          "value": {},
	          "type": {}
	        }
	      }
	    },
	    "S19": {
	      "type": "structure",
	      "required": [
	        "credential",
	        "credentialProvider"
	      ],
	      "members": {
	        "credential": {},
	        "credentialProvider": {}
	      }
	    },
	    "S1c": {
	      "type": "structure",
	      "members": {
	        "cloudWatchLogs": {
	          "shape": "S1d"
	        },
	        "s3Logs": {
	          "shape": "S1f"
	        }
	      }
	    },
	    "S1d": {
	      "type": "structure",
	      "required": [
	        "status"
	      ],
	      "members": {
	        "status": {},
	        "groupName": {},
	        "streamName": {}
	      }
	    },
	    "S1f": {
	      "type": "structure",
	      "required": [
	        "status"
	      ],
	      "members": {
	        "status": {},
	        "location": {},
	        "encryptionDisabled": {
	          "type": "boolean"
	        },
	        "bucketOwnerAccess": {}
	      }
	    },
	    "S1i": {
	      "type": "structure",
	      "members": {
	        "vpcId": {},
	        "subnets": {
	          "type": "list",
	          "member": {}
	        },
	        "securityGroupIds": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S1l": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "type": {},
	          "location": {},
	          "mountPoint": {},
	          "identifier": {},
	          "mountOptions": {}
	        }
	      }
	    },
	    "S1o": {
	      "type": "structure",
	      "members": {
	        "serviceRole": {},
	        "combineArtifacts": {
	          "type": "boolean"
	        },
	        "restrictions": {
	          "type": "structure",
	          "members": {
	            "maximumBuildsAllowed": {
	              "type": "integer"
	            },
	            "computeTypesAllowed": {
	              "type": "list",
	              "member": {}
	            }
	          }
	        },
	        "timeoutInMins": {
	          "type": "integer"
	        },
	        "batchReportMode": {}
	      }
	    },
	    "S1v": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "requestedOn": {
	          "type": "timestamp"
	        },
	        "buildStatus": {},
	        "primaryArtifact": {
	          "shape": "S1w"
	        },
	        "secondaryArtifacts": {
	          "type": "list",
	          "member": {
	            "shape": "S1w"
	          }
	        }
	      }
	    },
	    "S1w": {
	      "type": "structure",
	      "members": {
	        "type": {},
	        "location": {},
	        "identifier": {}
	      }
	    },
	    "S23": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "arn": {},
	        "buildNumber": {
	          "type": "long"
	        },
	        "startTime": {
	          "type": "timestamp"
	        },
	        "endTime": {
	          "type": "timestamp"
	        },
	        "currentPhase": {},
	        "buildStatus": {},
	        "sourceVersion": {},
	        "resolvedSourceVersion": {},
	        "projectName": {},
	        "phases": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "phaseType": {},
	              "phaseStatus": {},
	              "startTime": {
	                "type": "timestamp"
	              },
	              "endTime": {
	                "type": "timestamp"
	              },
	              "durationInSeconds": {
	                "type": "long"
	              },
	              "contexts": {
	                "shape": "Sj"
	              }
	            }
	          }
	        },
	        "source": {
	          "shape": "Sl"
	        },
	        "secondarySources": {
	          "shape": "St"
	        },
	        "secondarySourceVersions": {
	          "shape": "Su"
	        },
	        "artifacts": {
	          "shape": "Sw"
	        },
	        "secondaryArtifacts": {
	          "shape": "Sy"
	        },
	        "cache": {
	          "shape": "Sz"
	        },
	        "environment": {
	          "shape": "S13"
	        },
	        "serviceRole": {},
	        "logs": {
	          "type": "structure",
	          "members": {
	            "groupName": {},
	            "streamName": {},
	            "deepLink": {},
	            "s3DeepLink": {},
	            "cloudWatchLogsArn": {},
	            "s3LogsArn": {},
	            "cloudWatchLogs": {
	              "shape": "S1d"
	            },
	            "s3Logs": {
	              "shape": "S1f"
	            }
	          }
	        },
	        "timeoutInMinutes": {
	          "type": "integer"
	        },
	        "queuedTimeoutInMinutes": {
	          "type": "integer"
	        },
	        "buildComplete": {
	          "type": "boolean"
	        },
	        "initiator": {},
	        "vpcConfig": {
	          "shape": "S1i"
	        },
	        "networkInterface": {
	          "type": "structure",
	          "members": {
	            "subnetId": {},
	            "networkInterfaceId": {}
	          }
	        },
	        "encryptionKey": {},
	        "exportedEnvironmentVariables": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "value": {}
	            }
	          }
	        },
	        "reportArns": {
	          "type": "list",
	          "member": {}
	        },
	        "fileSystemLocations": {
	          "shape": "S1l"
	        },
	        "debugSession": {
	          "type": "structure",
	          "members": {
	            "sessionEnabled": {
	              "type": "boolean"
	            },
	            "sessionTarget": {}
	          }
	        },
	        "buildBatchArn": {}
	      }
	    },
	    "S2e": {
	      "type": "list",
	      "member": {}
	    },
	    "S2h": {
	      "type": "structure",
	      "members": {
	        "name": {},
	        "arn": {},
	        "description": {},
	        "source": {
	          "shape": "Sl"
	        },
	        "secondarySources": {
	          "shape": "St"
	        },
	        "sourceVersion": {},
	        "secondarySourceVersions": {
	          "shape": "Su"
	        },
	        "artifacts": {
	          "shape": "S2k"
	        },
	        "secondaryArtifacts": {
	          "shape": "S2n"
	        },
	        "cache": {
	          "shape": "Sz"
	        },
	        "environment": {
	          "shape": "S13"
	        },
	        "serviceRole": {},
	        "timeoutInMinutes": {
	          "type": "integer"
	        },
	        "queuedTimeoutInMinutes": {
	          "type": "integer"
	        },
	        "encryptionKey": {},
	        "tags": {
	          "shape": "S2p"
	        },
	        "created": {
	          "type": "timestamp"
	        },
	        "lastModified": {
	          "type": "timestamp"
	        },
	        "webhook": {
	          "shape": "S2t"
	        },
	        "vpcConfig": {
	          "shape": "S1i"
	        },
	        "badge": {
	          "type": "structure",
	          "members": {
	            "badgeEnabled": {
	              "type": "boolean"
	            },
	            "badgeRequestUrl": {}
	          }
	        },
	        "logsConfig": {
	          "shape": "S1c"
	        },
	        "fileSystemLocations": {
	          "shape": "S1l"
	        },
	        "buildBatchConfig": {
	          "shape": "S1o"
	        },
	        "concurrentBuildLimit": {
	          "type": "integer"
	        },
	        "projectVisibility": {},
	        "publicProjectAlias": {},
	        "resourceAccessRole": {}
	      }
	    },
	    "S2k": {
	      "type": "structure",
	      "required": [
	        "type"
	      ],
	      "members": {
	        "type": {},
	        "location": {},
	        "path": {},
	        "namespaceType": {},
	        "name": {},
	        "packaging": {},
	        "overrideArtifactName": {
	          "type": "boolean"
	        },
	        "encryptionDisabled": {
	          "type": "boolean"
	        },
	        "artifactIdentifier": {},
	        "bucketOwnerAccess": {}
	      }
	    },
	    "S2n": {
	      "type": "list",
	      "member": {
	        "shape": "S2k"
	      }
	    },
	    "S2p": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "key": {},
	          "value": {}
	        }
	      }
	    },
	    "S2t": {
	      "type": "structure",
	      "members": {
	        "url": {},
	        "payloadUrl": {},
	        "secret": {},
	        "branchFilter": {},
	        "filterGroups": {
	          "shape": "S2u"
	        },
	        "buildType": {},
	        "lastModifiedSecret": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S2u": {
	      "type": "list",
	      "member": {
	        "type": "list",
	        "member": {
	          "type": "structure",
	          "required": [
	            "type",
	            "pattern"
	          ],
	          "members": {
	            "type": {},
	            "pattern": {},
	            "excludeMatchedPattern": {
	              "type": "boolean"
	            }
	          }
	        }
	      }
	    },
	    "S32": {
	      "type": "list",
	      "member": {}
	    },
	    "S35": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "type": {},
	        "exportConfig": {
	          "shape": "S38"
	        },
	        "created": {
	          "type": "timestamp"
	        },
	        "lastModified": {
	          "type": "timestamp"
	        },
	        "tags": {
	          "shape": "S2p"
	        },
	        "status": {}
	      }
	    },
	    "S38": {
	      "type": "structure",
	      "members": {
	        "exportConfigType": {},
	        "s3Destination": {
	          "type": "structure",
	          "members": {
	            "bucket": {},
	            "bucketOwner": {},
	            "path": {},
	            "packaging": {},
	            "encryptionKey": {},
	            "encryptionDisabled": {
	              "type": "boolean"
	            }
	          }
	        }
	      }
	    },
	    "S3e": {
	      "type": "list",
	      "member": {}
	    },
	    "S50": {
	      "type": "structure",
	      "members": {
	        "status": {}
	      }
	    },
	    "S5q": {
	      "type": "structure",
	      "members": {
	        "status": {}
	      }
	    }
	  }
	}
	},{}],45:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeCodeCoverages": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "codeCoverages"
	    },
	    "DescribeTestCases": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "testCases"
	    },
	    "ListBuildBatches": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "ids"
	    },
	    "ListBuildBatchesForProject": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "ids"
	    },
	    "ListBuilds": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "ids"
	    },
	    "ListBuildsForProject": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "ids"
	    },
	    "ListProjects": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "projects"
	    },
	    "ListReportGroups": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "reportGroups"
	    },
	    "ListReports": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "reports"
	    },
	    "ListReportsForReportGroup": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "reports"
	    },
	    "ListSharedProjects": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "projects"
	    },
	    "ListSharedReportGroups": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "reportGroups"
	    }
	  }
	}
	},{}],46:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-04-13",
	    "endpointPrefix": "codecommit",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "CodeCommit",
	    "serviceFullName": "AWS CodeCommit",
	    "serviceId": "CodeCommit",
	    "signatureVersion": "v4",
	    "targetPrefix": "CodeCommit_20150413",
	    "uid": "codecommit-2015-04-13"
	  },
	  "operations": {
	    "AssociateApprovalRuleTemplateWithRepository": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplateName",
	          "repositoryName"
	        ],
	        "members": {
	          "approvalRuleTemplateName": {},
	          "repositoryName": {}
	        }
	      }
	    },
	    "BatchAssociateApprovalRuleTemplateWithRepositories": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplateName",
	          "repositoryNames"
	        ],
	        "members": {
	          "approvalRuleTemplateName": {},
	          "repositoryNames": {
	            "shape": "S5"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "associatedRepositoryNames",
	          "errors"
	        ],
	        "members": {
	          "associatedRepositoryNames": {
	            "shape": "S5"
	          },
	          "errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "repositoryName": {},
	                "errorCode": {},
	                "errorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "BatchDescribeMergeConflicts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "destinationCommitSpecifier",
	          "sourceCommitSpecifier",
	          "mergeOption"
	        ],
	        "members": {
	          "repositoryName": {},
	          "destinationCommitSpecifier": {},
	          "sourceCommitSpecifier": {},
	          "mergeOption": {},
	          "maxMergeHunks": {
	            "type": "integer"
	          },
	          "maxConflictFiles": {
	            "type": "integer"
	          },
	          "filePaths": {
	            "type": "list",
	            "member": {}
	          },
	          "conflictDetailLevel": {},
	          "conflictResolutionStrategy": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "conflicts",
	          "destinationCommitId",
	          "sourceCommitId"
	        ],
	        "members": {
	          "conflicts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "conflictMetadata": {
	                  "shape": "Sn"
	                },
	                "mergeHunks": {
	                  "shape": "S12"
	                }
	              }
	            }
	          },
	          "nextToken": {},
	          "errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "filePath",
	                "exceptionName",
	                "message"
	              ],
	              "members": {
	                "filePath": {},
	                "exceptionName": {},
	                "message": {}
	              }
	            }
	          },
	          "destinationCommitId": {},
	          "sourceCommitId": {},
	          "baseCommitId": {}
	        }
	      }
	    },
	    "BatchDisassociateApprovalRuleTemplateFromRepositories": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplateName",
	          "repositoryNames"
	        ],
	        "members": {
	          "approvalRuleTemplateName": {},
	          "repositoryNames": {
	            "shape": "S5"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "disassociatedRepositoryNames",
	          "errors"
	        ],
	        "members": {
	          "disassociatedRepositoryNames": {
	            "shape": "S5"
	          },
	          "errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "repositoryName": {},
	                "errorCode": {},
	                "errorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "BatchGetCommits": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "commitIds",
	          "repositoryName"
	        ],
	        "members": {
	          "commitIds": {
	            "type": "list",
	            "member": {}
	          },
	          "repositoryName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "commits": {
	            "type": "list",
	            "member": {
	              "shape": "S1l"
	            }
	          },
	          "errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "commitId": {},
	                "errorCode": {},
	                "errorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "BatchGetRepositories": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryNames"
	        ],
	        "members": {
	          "repositoryNames": {
	            "shape": "S5"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repositories": {
	            "type": "list",
	            "member": {
	              "shape": "S1x"
	            }
	          },
	          "repositoriesNotFound": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "CreateApprovalRuleTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplateName",
	          "approvalRuleTemplateContent"
	        ],
	        "members": {
	          "approvalRuleTemplateName": {},
	          "approvalRuleTemplateContent": {},
	          "approvalRuleTemplateDescription": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplate"
	        ],
	        "members": {
	          "approvalRuleTemplate": {
	            "shape": "S2c"
	          }
	        }
	      }
	    },
	    "CreateBranch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "branchName",
	          "commitId"
	        ],
	        "members": {
	          "repositoryName": {},
	          "branchName": {},
	          "commitId": {}
	        }
	      }
	    },
	    "CreateCommit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "branchName"
	        ],
	        "members": {
	          "repositoryName": {},
	          "branchName": {},
	          "parentCommitId": {},
	          "authorName": {},
	          "email": {},
	          "commitMessage": {},
	          "keepEmptyFolders": {
	            "type": "boolean"
	          },
	          "putFiles": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "filePath"
	              ],
	              "members": {
	                "filePath": {},
	                "fileMode": {},
	                "fileContent": {
	                  "type": "blob"
	                },
	                "sourceFile": {
	                  "type": "structure",
	                  "required": [
	                    "filePath"
	                  ],
	                  "members": {
	                    "filePath": {},
	                    "isMove": {
	                      "type": "boolean"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "deleteFiles": {
	            "shape": "S2o"
	          },
	          "setFileModes": {
	            "shape": "S2q"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "commitId": {},
	          "treeId": {},
	          "filesAdded": {
	            "shape": "S2t"
	          },
	          "filesUpdated": {
	            "shape": "S2t"
	          },
	          "filesDeleted": {
	            "shape": "S2t"
	          }
	        }
	      }
	    },
	    "CreatePullRequest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "title",
	          "targets"
	        ],
	        "members": {
	          "title": {},
	          "description": {},
	          "targets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "repositoryName",
	                "sourceReference"
	              ],
	              "members": {
	                "repositoryName": {},
	                "sourceReference": {},
	                "destinationReference": {}
	              }
	            }
	          },
	          "clientRequestToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "pullRequest"
	        ],
	        "members": {
	          "pullRequest": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "CreatePullRequestApprovalRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "approvalRuleName",
	          "approvalRuleContent"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "approvalRuleName": {},
	          "approvalRuleContent": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "approvalRule"
	        ],
	        "members": {
	          "approvalRule": {
	            "shape": "S3c"
	          }
	        }
	      }
	    },
	    "CreateRepository": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "repositoryName": {},
	          "repositoryDescription": {},
	          "tags": {
	            "shape": "S3k"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repositoryMetadata": {
	            "shape": "S1x"
	          }
	        }
	      }
	    },
	    "CreateUnreferencedMergeCommit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "sourceCommitSpecifier",
	          "destinationCommitSpecifier",
	          "mergeOption"
	        ],
	        "members": {
	          "repositoryName": {},
	          "sourceCommitSpecifier": {},
	          "destinationCommitSpecifier": {},
	          "mergeOption": {},
	          "conflictDetailLevel": {},
	          "conflictResolutionStrategy": {},
	          "authorName": {},
	          "email": {},
	          "commitMessage": {},
	          "keepEmptyFolders": {
	            "type": "boolean"
	          },
	          "conflictResolution": {
	            "shape": "S3p"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "commitId": {},
	          "treeId": {}
	        }
	      }
	    },
	    "DeleteApprovalRuleTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplateName"
	        ],
	        "members": {
	          "approvalRuleTemplateName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplateId"
	        ],
	        "members": {
	          "approvalRuleTemplateId": {}
	        }
	      }
	    },
	    "DeleteBranch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "branchName"
	        ],
	        "members": {
	          "repositoryName": {},
	          "branchName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deletedBranch": {
	            "shape": "S3y"
	          }
	        }
	      }
	    },
	    "DeleteCommentContent": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "commentId"
	        ],
	        "members": {
	          "commentId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "comment": {
	            "shape": "S42"
	          }
	        }
	      }
	    },
	    "DeleteFile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "branchName",
	          "filePath",
	          "parentCommitId"
	        ],
	        "members": {
	          "repositoryName": {},
	          "branchName": {},
	          "filePath": {},
	          "parentCommitId": {},
	          "keepEmptyFolders": {
	            "type": "boolean"
	          },
	          "commitMessage": {},
	          "name": {},
	          "email": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "commitId",
	          "blobId",
	          "treeId",
	          "filePath"
	        ],
	        "members": {
	          "commitId": {},
	          "blobId": {},
	          "treeId": {},
	          "filePath": {}
	        }
	      }
	    },
	    "DeletePullRequestApprovalRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "approvalRuleName"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "approvalRuleName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "approvalRuleId"
	        ],
	        "members": {
	          "approvalRuleId": {}
	        }
	      }
	    },
	    "DeleteRepository": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "repositoryName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repositoryId": {}
	        }
	      }
	    },
	    "DescribeMergeConflicts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "destinationCommitSpecifier",
	          "sourceCommitSpecifier",
	          "mergeOption",
	          "filePath"
	        ],
	        "members": {
	          "repositoryName": {},
	          "destinationCommitSpecifier": {},
	          "sourceCommitSpecifier": {},
	          "mergeOption": {},
	          "maxMergeHunks": {
	            "type": "integer"
	          },
	          "filePath": {},
	          "conflictDetailLevel": {},
	          "conflictResolutionStrategy": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "conflictMetadata",
	          "mergeHunks",
	          "destinationCommitId",
	          "sourceCommitId"
	        ],
	        "members": {
	          "conflictMetadata": {
	            "shape": "Sn"
	          },
	          "mergeHunks": {
	            "shape": "S12"
	          },
	          "nextToken": {},
	          "destinationCommitId": {},
	          "sourceCommitId": {},
	          "baseCommitId": {}
	        }
	      }
	    },
	    "DescribePullRequestEvents": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "pullRequestEventType": {},
	          "actorArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "pullRequestEvents"
	        ],
	        "members": {
	          "pullRequestEvents": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "pullRequestId": {},
	                "eventDate": {
	                  "type": "timestamp"
	                },
	                "pullRequestEventType": {},
	                "actorArn": {},
	                "pullRequestCreatedEventMetadata": {
	                  "type": "structure",
	                  "members": {
	                    "repositoryName": {},
	                    "sourceCommitId": {},
	                    "destinationCommitId": {},
	                    "mergeBase": {}
	                  }
	                },
	                "pullRequestStatusChangedEventMetadata": {
	                  "type": "structure",
	                  "members": {
	                    "pullRequestStatus": {}
	                  }
	                },
	                "pullRequestSourceReferenceUpdatedEventMetadata": {
	                  "type": "structure",
	                  "members": {
	                    "repositoryName": {},
	                    "beforeCommitId": {},
	                    "afterCommitId": {},
	                    "mergeBase": {}
	                  }
	                },
	                "pullRequestMergedStateChangedEventMetadata": {
	                  "type": "structure",
	                  "members": {
	                    "repositoryName": {},
	                    "destinationReference": {},
	                    "mergeMetadata": {
	                      "shape": "S38"
	                    }
	                  }
	                },
	                "approvalRuleEventMetadata": {
	                  "type": "structure",
	                  "members": {
	                    "approvalRuleName": {},
	                    "approvalRuleId": {},
	                    "approvalRuleContent": {}
	                  }
	                },
	                "approvalStateChangedEventMetadata": {
	                  "type": "structure",
	                  "members": {
	                    "revisionId": {},
	                    "approvalStatus": {}
	                  }
	                },
	                "approvalRuleOverriddenEventMetadata": {
	                  "type": "structure",
	                  "members": {
	                    "revisionId": {},
	                    "overrideStatus": {}
	                  }
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DisassociateApprovalRuleTemplateFromRepository": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplateName",
	          "repositoryName"
	        ],
	        "members": {
	          "approvalRuleTemplateName": {},
	          "repositoryName": {}
	        }
	      }
	    },
	    "EvaluatePullRequestApprovalRules": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "revisionId"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "revisionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "evaluation"
	        ],
	        "members": {
	          "evaluation": {
	            "type": "structure",
	            "members": {
	              "approved": {
	                "type": "boolean"
	              },
	              "overridden": {
	                "type": "boolean"
	              },
	              "approvalRulesSatisfied": {
	                "type": "list",
	                "member": {}
	              },
	              "approvalRulesNotSatisfied": {
	                "type": "list",
	                "member": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetApprovalRuleTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplateName"
	        ],
	        "members": {
	          "approvalRuleTemplateName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplate"
	        ],
	        "members": {
	          "approvalRuleTemplate": {
	            "shape": "S2c"
	          }
	        }
	      }
	    },
	    "GetBlob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "blobId"
	        ],
	        "members": {
	          "repositoryName": {},
	          "blobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "content"
	        ],
	        "members": {
	          "content": {
	            "type": "blob"
	          }
	        }
	      }
	    },
	    "GetBranch": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "repositoryName": {},
	          "branchName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "branch": {
	            "shape": "S3y"
	          }
	        }
	      }
	    },
	    "GetComment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "commentId"
	        ],
	        "members": {
	          "commentId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "comment": {
	            "shape": "S42"
	          }
	        }
	      }
	    },
	    "GetCommentReactions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "commentId"
	        ],
	        "members": {
	          "commentId": {},
	          "reactionUserArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "reactionsForComment"
	        ],
	        "members": {
	          "reactionsForComment": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "reaction": {
	                  "type": "structure",
	                  "members": {
	                    "emoji": {},
	                    "shortCode": {},
	                    "unicode": {}
	                  }
	                },
	                "reactionUsers": {
	                  "type": "list",
	                  "member": {}
	                },
	                "reactionsFromDeletedUsersCount": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetCommentsForComparedCommit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "afterCommitId"
	        ],
	        "members": {
	          "repositoryName": {},
	          "beforeCommitId": {},
	          "afterCommitId": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "commentsForComparedCommitData": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "repositoryName": {},
	                "beforeCommitId": {},
	                "afterCommitId": {},
	                "beforeBlobId": {},
	                "afterBlobId": {},
	                "location": {
	                  "shape": "S5q"
	                },
	                "comments": {
	                  "shape": "S5t"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetCommentsForPullRequest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "repositoryName": {},
	          "beforeCommitId": {},
	          "afterCommitId": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "commentsForPullRequestData": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "pullRequestId": {},
	                "repositoryName": {},
	                "beforeCommitId": {},
	                "afterCommitId": {},
	                "beforeBlobId": {},
	                "afterBlobId": {},
	                "location": {
	                  "shape": "S5q"
	                },
	                "comments": {
	                  "shape": "S5t"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetCommit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "commitId"
	        ],
	        "members": {
	          "repositoryName": {},
	          "commitId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "commit"
	        ],
	        "members": {
	          "commit": {
	            "shape": "S1l"
	          }
	        }
	      }
	    },
	    "GetDifferences": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "afterCommitSpecifier"
	        ],
	        "members": {
	          "repositoryName": {},
	          "beforeCommitSpecifier": {},
	          "afterCommitSpecifier": {},
	          "beforePath": {},
	          "afterPath": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "differences": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "beforeBlob": {
	                  "shape": "S65"
	                },
	                "afterBlob": {
	                  "shape": "S65"
	                },
	                "changeType": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetFile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "filePath"
	        ],
	        "members": {
	          "repositoryName": {},
	          "commitSpecifier": {},
	          "filePath": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "commitId",
	          "blobId",
	          "filePath",
	          "fileMode",
	          "fileSize",
	          "fileContent"
	        ],
	        "members": {
	          "commitId": {},
	          "blobId": {},
	          "filePath": {},
	          "fileMode": {},
	          "fileSize": {
	            "type": "long"
	          },
	          "fileContent": {
	            "type": "blob"
	          }
	        }
	      }
	    },
	    "GetFolder": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "folderPath"
	        ],
	        "members": {
	          "repositoryName": {},
	          "commitSpecifier": {},
	          "folderPath": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "commitId",
	          "folderPath"
	        ],
	        "members": {
	          "commitId": {},
	          "folderPath": {},
	          "treeId": {},
	          "subFolders": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "treeId": {},
	                "absolutePath": {},
	                "relativePath": {}
	              }
	            }
	          },
	          "files": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "blobId": {},
	                "absolutePath": {},
	                "relativePath": {},
	                "fileMode": {}
	              }
	            }
	          },
	          "symbolicLinks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "blobId": {},
	                "absolutePath": {},
	                "relativePath": {},
	                "fileMode": {}
	              }
	            }
	          },
	          "subModules": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "commitId": {},
	                "absolutePath": {},
	                "relativePath": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetMergeCommit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "sourceCommitSpecifier",
	          "destinationCommitSpecifier"
	        ],
	        "members": {
	          "repositoryName": {},
	          "sourceCommitSpecifier": {},
	          "destinationCommitSpecifier": {},
	          "conflictDetailLevel": {},
	          "conflictResolutionStrategy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "sourceCommitId": {},
	          "destinationCommitId": {},
	          "baseCommitId": {},
	          "mergedCommitId": {}
	        }
	      }
	    },
	    "GetMergeConflicts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "destinationCommitSpecifier",
	          "sourceCommitSpecifier",
	          "mergeOption"
	        ],
	        "members": {
	          "repositoryName": {},
	          "destinationCommitSpecifier": {},
	          "sourceCommitSpecifier": {},
	          "mergeOption": {},
	          "conflictDetailLevel": {},
	          "maxConflictFiles": {
	            "type": "integer"
	          },
	          "conflictResolutionStrategy": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "mergeable",
	          "destinationCommitId",
	          "sourceCommitId",
	          "conflictMetadataList"
	        ],
	        "members": {
	          "mergeable": {
	            "type": "boolean"
	          },
	          "destinationCommitId": {},
	          "sourceCommitId": {},
	          "baseCommitId": {},
	          "conflictMetadataList": {
	            "type": "list",
	            "member": {
	              "shape": "Sn"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetMergeOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "sourceCommitSpecifier",
	          "destinationCommitSpecifier"
	        ],
	        "members": {
	          "repositoryName": {},
	          "sourceCommitSpecifier": {},
	          "destinationCommitSpecifier": {},
	          "conflictDetailLevel": {},
	          "conflictResolutionStrategy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "mergeOptions",
	          "sourceCommitId",
	          "destinationCommitId",
	          "baseCommitId"
	        ],
	        "members": {
	          "mergeOptions": {
	            "type": "list",
	            "member": {}
	          },
	          "sourceCommitId": {},
	          "destinationCommitId": {},
	          "baseCommitId": {}
	        }
	      }
	    },
	    "GetPullRequest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId"
	        ],
	        "members": {
	          "pullRequestId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "pullRequest"
	        ],
	        "members": {
	          "pullRequest": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "GetPullRequestApprovalStates": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "revisionId"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "revisionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "approvals": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "userArn": {},
	                "approvalState": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetPullRequestOverrideState": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "revisionId"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "revisionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "overridden": {
	            "type": "boolean"
	          },
	          "overrider": {}
	        }
	      }
	    },
	    "GetRepository": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "repositoryName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repositoryMetadata": {
	            "shape": "S1x"
	          }
	        }
	      }
	    },
	    "GetRepositoryTriggers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "repositoryName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "configurationId": {},
	          "triggers": {
	            "shape": "S76"
	          }
	        }
	      }
	    },
	    "ListApprovalRuleTemplates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "approvalRuleTemplateNames": {
	            "shape": "S7f"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListAssociatedApprovalRuleTemplatesForRepository": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "repositoryName": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "approvalRuleTemplateNames": {
	            "shape": "S7f"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListBranches": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "repositoryName": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "branches": {
	            "shape": "S7a"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListPullRequests": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "repositoryName": {},
	          "authorArn": {},
	          "pullRequestStatus": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "pullRequestIds"
	        ],
	        "members": {
	          "pullRequestIds": {
	            "type": "list",
	            "member": {}
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListRepositories": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "sortBy": {},
	          "order": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repositories": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "repositoryName": {},
	                "repositoryId": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListRepositoriesForApprovalRuleTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplateName"
	        ],
	        "members": {
	          "approvalRuleTemplateName": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repositoryNames": {
	            "shape": "S5"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tags": {
	            "shape": "S3k"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "MergeBranchesByFastForward": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "sourceCommitSpecifier",
	          "destinationCommitSpecifier"
	        ],
	        "members": {
	          "repositoryName": {},
	          "sourceCommitSpecifier": {},
	          "destinationCommitSpecifier": {},
	          "targetBranch": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "commitId": {},
	          "treeId": {}
	        }
	      }
	    },
	    "MergeBranchesBySquash": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "sourceCommitSpecifier",
	          "destinationCommitSpecifier"
	        ],
	        "members": {
	          "repositoryName": {},
	          "sourceCommitSpecifier": {},
	          "destinationCommitSpecifier": {},
	          "targetBranch": {},
	          "conflictDetailLevel": {},
	          "conflictResolutionStrategy": {},
	          "authorName": {},
	          "email": {},
	          "commitMessage": {},
	          "keepEmptyFolders": {
	            "type": "boolean"
	          },
	          "conflictResolution": {
	            "shape": "S3p"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "commitId": {},
	          "treeId": {}
	        }
	      }
	    },
	    "MergeBranchesByThreeWay": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "sourceCommitSpecifier",
	          "destinationCommitSpecifier"
	        ],
	        "members": {
	          "repositoryName": {},
	          "sourceCommitSpecifier": {},
	          "destinationCommitSpecifier": {},
	          "targetBranch": {},
	          "conflictDetailLevel": {},
	          "conflictResolutionStrategy": {},
	          "authorName": {},
	          "email": {},
	          "commitMessage": {},
	          "keepEmptyFolders": {
	            "type": "boolean"
	          },
	          "conflictResolution": {
	            "shape": "S3p"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "commitId": {},
	          "treeId": {}
	        }
	      }
	    },
	    "MergePullRequestByFastForward": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "repositoryName"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "repositoryName": {},
	          "sourceCommitId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pullRequest": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "MergePullRequestBySquash": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "repositoryName"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "repositoryName": {},
	          "sourceCommitId": {},
	          "conflictDetailLevel": {},
	          "conflictResolutionStrategy": {},
	          "commitMessage": {},
	          "authorName": {},
	          "email": {},
	          "keepEmptyFolders": {
	            "type": "boolean"
	          },
	          "conflictResolution": {
	            "shape": "S3p"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pullRequest": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "MergePullRequestByThreeWay": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "repositoryName"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "repositoryName": {},
	          "sourceCommitId": {},
	          "conflictDetailLevel": {},
	          "conflictResolutionStrategy": {},
	          "commitMessage": {},
	          "authorName": {},
	          "email": {},
	          "keepEmptyFolders": {
	            "type": "boolean"
	          },
	          "conflictResolution": {
	            "shape": "S3p"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pullRequest": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "OverridePullRequestApprovalRules": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "revisionId",
	          "overrideStatus"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "revisionId": {},
	          "overrideStatus": {}
	        }
	      }
	    },
	    "PostCommentForComparedCommit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "afterCommitId",
	          "content"
	        ],
	        "members": {
	          "repositoryName": {},
	          "beforeCommitId": {},
	          "afterCommitId": {},
	          "location": {
	            "shape": "S5q"
	          },
	          "content": {},
	          "clientRequestToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repositoryName": {},
	          "beforeCommitId": {},
	          "afterCommitId": {},
	          "beforeBlobId": {},
	          "afterBlobId": {},
	          "location": {
	            "shape": "S5q"
	          },
	          "comment": {
	            "shape": "S42"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "PostCommentForPullRequest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "repositoryName",
	          "beforeCommitId",
	          "afterCommitId",
	          "content"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "repositoryName": {},
	          "beforeCommitId": {},
	          "afterCommitId": {},
	          "location": {
	            "shape": "S5q"
	          },
	          "content": {},
	          "clientRequestToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repositoryName": {},
	          "pullRequestId": {},
	          "beforeCommitId": {},
	          "afterCommitId": {},
	          "beforeBlobId": {},
	          "afterBlobId": {},
	          "location": {
	            "shape": "S5q"
	          },
	          "comment": {
	            "shape": "S42"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "PostCommentReply": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "inReplyTo",
	          "content"
	        ],
	        "members": {
	          "inReplyTo": {},
	          "clientRequestToken": {
	            "idempotencyToken": true
	          },
	          "content": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "comment": {
	            "shape": "S42"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "PutCommentReaction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "commentId",
	          "reactionValue"
	        ],
	        "members": {
	          "commentId": {},
	          "reactionValue": {}
	        }
	      }
	    },
	    "PutFile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "branchName",
	          "fileContent",
	          "filePath"
	        ],
	        "members": {
	          "repositoryName": {},
	          "branchName": {},
	          "fileContent": {
	            "type": "blob"
	          },
	          "filePath": {},
	          "fileMode": {},
	          "parentCommitId": {},
	          "commitMessage": {},
	          "name": {},
	          "email": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "commitId",
	          "blobId",
	          "treeId"
	        ],
	        "members": {
	          "commitId": {},
	          "blobId": {},
	          "treeId": {}
	        }
	      }
	    },
	    "PutRepositoryTriggers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "triggers"
	        ],
	        "members": {
	          "repositoryName": {},
	          "triggers": {
	            "shape": "S76"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "configurationId": {}
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tags"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tags": {
	            "shape": "S3k"
	          }
	        }
	      }
	    },
	    "TestRepositoryTriggers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "triggers"
	        ],
	        "members": {
	          "repositoryName": {},
	          "triggers": {
	            "shape": "S76"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "successfulExecutions": {
	            "type": "list",
	            "member": {}
	          },
	          "failedExecutions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "trigger": {},
	                "failureMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tagKeys"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "UpdateApprovalRuleTemplateContent": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplateName",
	          "newRuleContent"
	        ],
	        "members": {
	          "approvalRuleTemplateName": {},
	          "newRuleContent": {},
	          "existingRuleContentSha256": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplate"
	        ],
	        "members": {
	          "approvalRuleTemplate": {
	            "shape": "S2c"
	          }
	        }
	      }
	    },
	    "UpdateApprovalRuleTemplateDescription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplateName",
	          "approvalRuleTemplateDescription"
	        ],
	        "members": {
	          "approvalRuleTemplateName": {},
	          "approvalRuleTemplateDescription": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplate"
	        ],
	        "members": {
	          "approvalRuleTemplate": {
	            "shape": "S2c"
	          }
	        }
	      }
	    },
	    "UpdateApprovalRuleTemplateName": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "oldApprovalRuleTemplateName",
	          "newApprovalRuleTemplateName"
	        ],
	        "members": {
	          "oldApprovalRuleTemplateName": {},
	          "newApprovalRuleTemplateName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "approvalRuleTemplate"
	        ],
	        "members": {
	          "approvalRuleTemplate": {
	            "shape": "S2c"
	          }
	        }
	      }
	    },
	    "UpdateComment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "commentId",
	          "content"
	        ],
	        "members": {
	          "commentId": {},
	          "content": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "comment": {
	            "shape": "S42"
	          }
	        }
	      }
	    },
	    "UpdateDefaultBranch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "defaultBranchName"
	        ],
	        "members": {
	          "repositoryName": {},
	          "defaultBranchName": {}
	        }
	      }
	    },
	    "UpdatePullRequestApprovalRuleContent": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "approvalRuleName",
	          "newRuleContent"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "approvalRuleName": {},
	          "existingRuleContentSha256": {},
	          "newRuleContent": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "approvalRule"
	        ],
	        "members": {
	          "approvalRule": {
	            "shape": "S3c"
	          }
	        }
	      }
	    },
	    "UpdatePullRequestApprovalState": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "revisionId",
	          "approvalState"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "revisionId": {},
	          "approvalState": {}
	        }
	      }
	    },
	    "UpdatePullRequestDescription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "description"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "description": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "pullRequest"
	        ],
	        "members": {
	          "pullRequest": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "UpdatePullRequestStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "pullRequestStatus"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "pullRequestStatus": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "pullRequest"
	        ],
	        "members": {
	          "pullRequest": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "UpdatePullRequestTitle": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pullRequestId",
	          "title"
	        ],
	        "members": {
	          "pullRequestId": {},
	          "title": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "pullRequest"
	        ],
	        "members": {
	          "pullRequest": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "UpdateRepositoryDescription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "repositoryName": {},
	          "repositoryDescription": {}
	        }
	      }
	    },
	    "UpdateRepositoryName": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "oldName",
	          "newName"
	        ],
	        "members": {
	          "oldName": {},
	          "newName": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S5": {
	      "type": "list",
	      "member": {}
	    },
	    "Sn": {
	      "type": "structure",
	      "members": {
	        "filePath": {},
	        "fileSizes": {
	          "type": "structure",
	          "members": {
	            "source": {
	              "type": "long"
	            },
	            "destination": {
	              "type": "long"
	            },
	            "base": {
	              "type": "long"
	            }
	          }
	        },
	        "fileModes": {
	          "type": "structure",
	          "members": {
	            "source": {},
	            "destination": {},
	            "base": {}
	          }
	        },
	        "objectTypes": {
	          "type": "structure",
	          "members": {
	            "source": {},
	            "destination": {},
	            "base": {}
	          }
	        },
	        "numberOfConflicts": {
	          "type": "integer"
	        },
	        "isBinaryFile": {
	          "type": "structure",
	          "members": {
	            "source": {
	              "type": "boolean"
	            },
	            "destination": {
	              "type": "boolean"
	            },
	            "base": {
	              "type": "boolean"
	            }
	          }
	        },
	        "contentConflict": {
	          "type": "boolean"
	        },
	        "fileModeConflict": {
	          "type": "boolean"
	        },
	        "objectTypeConflict": {
	          "type": "boolean"
	        },
	        "mergeOperations": {
	          "type": "structure",
	          "members": {
	            "source": {},
	            "destination": {}
	          }
	        }
	      }
	    },
	    "S12": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "isConflict": {
	            "type": "boolean"
	          },
	          "source": {
	            "shape": "S15"
	          },
	          "destination": {
	            "shape": "S15"
	          },
	          "base": {
	            "shape": "S15"
	          }
	        }
	      }
	    },
	    "S15": {
	      "type": "structure",
	      "members": {
	        "startLine": {
	          "type": "integer"
	        },
	        "endLine": {
	          "type": "integer"
	        },
	        "hunkContent": {}
	      }
	    },
	    "S1l": {
	      "type": "structure",
	      "members": {
	        "commitId": {},
	        "treeId": {},
	        "parents": {
	          "type": "list",
	          "member": {}
	        },
	        "message": {},
	        "author": {
	          "shape": "S1n"
	        },
	        "committer": {
	          "shape": "S1n"
	        },
	        "additionalData": {}
	      }
	    },
	    "S1n": {
	      "type": "structure",
	      "members": {
	        "name": {},
	        "email": {},
	        "date": {}
	      }
	    },
	    "S1x": {
	      "type": "structure",
	      "members": {
	        "accountId": {},
	        "repositoryId": {},
	        "repositoryName": {},
	        "repositoryDescription": {},
	        "defaultBranch": {},
	        "lastModifiedDate": {
	          "type": "timestamp"
	        },
	        "creationDate": {
	          "type": "timestamp"
	        },
	        "cloneUrlHttp": {},
	        "cloneUrlSsh": {},
	        "Arn": {}
	      }
	    },
	    "S2c": {
	      "type": "structure",
	      "members": {
	        "approvalRuleTemplateId": {},
	        "approvalRuleTemplateName": {},
	        "approvalRuleTemplateDescription": {},
	        "approvalRuleTemplateContent": {},
	        "ruleContentSha256": {},
	        "lastModifiedDate": {
	          "type": "timestamp"
	        },
	        "creationDate": {
	          "type": "timestamp"
	        },
	        "lastModifiedUser": {}
	      }
	    },
	    "S2o": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "filePath"
	        ],
	        "members": {
	          "filePath": {}
	        }
	      }
	    },
	    "S2q": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "filePath",
	          "fileMode"
	        ],
	        "members": {
	          "filePath": {},
	          "fileMode": {}
	        }
	      }
	    },
	    "S2t": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "absolutePath": {},
	          "blobId": {},
	          "fileMode": {}
	        }
	      }
	    },
	    "S33": {
	      "type": "structure",
	      "members": {
	        "pullRequestId": {},
	        "title": {},
	        "description": {},
	        "lastActivityDate": {
	          "type": "timestamp"
	        },
	        "creationDate": {
	          "type": "timestamp"
	        },
	        "pullRequestStatus": {},
	        "authorArn": {},
	        "pullRequestTargets": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "repositoryName": {},
	              "sourceReference": {},
	              "destinationReference": {},
	              "destinationCommit": {},
	              "sourceCommit": {},
	              "mergeBase": {},
	              "mergeMetadata": {
	                "shape": "S38"
	              }
	            }
	          }
	        },
	        "clientRequestToken": {},
	        "revisionId": {},
	        "approvalRules": {
	          "type": "list",
	          "member": {
	            "shape": "S3c"
	          }
	        }
	      }
	    },
	    "S38": {
	      "type": "structure",
	      "members": {
	        "isMerged": {
	          "type": "boolean"
	        },
	        "mergedBy": {},
	        "mergeCommitId": {},
	        "mergeOption": {}
	      }
	    },
	    "S3c": {
	      "type": "structure",
	      "members": {
	        "approvalRuleId": {},
	        "approvalRuleName": {},
	        "approvalRuleContent": {},
	        "ruleContentSha256": {},
	        "lastModifiedDate": {
	          "type": "timestamp"
	        },
	        "creationDate": {
	          "type": "timestamp"
	        },
	        "lastModifiedUser": {},
	        "originApprovalRuleTemplate": {
	          "type": "structure",
	          "members": {
	            "approvalRuleTemplateId": {},
	            "approvalRuleTemplateName": {}
	          }
	        }
	      }
	    },
	    "S3k": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S3p": {
	      "type": "structure",
	      "members": {
	        "replaceContents": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "filePath",
	              "replacementType"
	            ],
	            "members": {
	              "filePath": {},
	              "replacementType": {},
	              "content": {
	                "type": "blob"
	              },
	              "fileMode": {}
	            }
	          }
	        },
	        "deleteFiles": {
	          "shape": "S2o"
	        },
	        "setFileModes": {
	          "shape": "S2q"
	        }
	      }
	    },
	    "S3y": {
	      "type": "structure",
	      "members": {
	        "branchName": {},
	        "commitId": {}
	      }
	    },
	    "S42": {
	      "type": "structure",
	      "members": {
	        "commentId": {},
	        "content": {},
	        "inReplyTo": {},
	        "creationDate": {
	          "type": "timestamp"
	        },
	        "lastModifiedDate": {
	          "type": "timestamp"
	        },
	        "authorArn": {},
	        "deleted": {
	          "type": "boolean"
	        },
	        "clientRequestToken": {},
	        "callerReactions": {
	          "type": "list",
	          "member": {}
	        },
	        "reactionCounts": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S5q": {
	      "type": "structure",
	      "members": {
	        "filePath": {},
	        "filePosition": {
	          "type": "long"
	        },
	        "relativeFileVersion": {}
	      }
	    },
	    "S5t": {
	      "type": "list",
	      "member": {
	        "shape": "S42"
	      }
	    },
	    "S65": {
	      "type": "structure",
	      "members": {
	        "blobId": {},
	        "path": {},
	        "mode": {}
	      }
	    },
	    "S76": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "name",
	          "destinationArn",
	          "events"
	        ],
	        "members": {
	          "name": {},
	          "destinationArn": {},
	          "customData": {},
	          "branches": {
	            "shape": "S7a"
	          },
	          "events": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "S7a": {
	      "type": "list",
	      "member": {}
	    },
	    "S7f": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],47:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeMergeConflicts": {
	      "input_token": "nextToken",
	      "limit_key": "maxMergeHunks",
	      "output_token": "nextToken"
	    },
	    "DescribePullRequestEvents": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken"
	    },
	    "GetCommentReactions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken"
	    },
	    "GetCommentsForComparedCommit": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken"
	    },
	    "GetCommentsForPullRequest": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken"
	    },
	    "GetDifferences": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetMergeConflicts": {
	      "input_token": "nextToken",
	      "limit_key": "maxConflictFiles",
	      "output_token": "nextToken"
	    },
	    "ListApprovalRuleTemplates": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken"
	    },
	    "ListAssociatedApprovalRuleTemplatesForRepository": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken"
	    },
	    "ListBranches": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "branches"
	    },
	    "ListPullRequests": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken"
	    },
	    "ListRepositories": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "repositories"
	    },
	    "ListRepositoriesForApprovalRuleTemplate": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken"
	    }
	  }
	}
	},{}],48:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-10-06",
	    "endpointPrefix": "codedeploy",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "CodeDeploy",
	    "serviceFullName": "AWS CodeDeploy",
	    "serviceId": "CodeDeploy",
	    "signatureVersion": "v4",
	    "targetPrefix": "CodeDeploy_20141006",
	    "uid": "codedeploy-2014-10-06"
	  },
	  "operations": {
	    "AddTagsToOnPremisesInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "tags",
	          "instanceNames"
	        ],
	        "members": {
	          "tags": {
	            "shape": "S2"
	          },
	          "instanceNames": {
	            "shape": "S6"
	          }
	        }
	      }
	    },
	    "BatchGetApplicationRevisions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName",
	          "revisions"
	        ],
	        "members": {
	          "applicationName": {},
	          "revisions": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "applicationName": {},
	          "errorMessage": {},
	          "revisions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "revisionLocation": {
	                  "shape": "Sb"
	                },
	                "genericRevisionInfo": {
	                  "shape": "Su"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "BatchGetApplications": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationNames"
	        ],
	        "members": {
	          "applicationNames": {
	            "shape": "S10"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "applicationsInfo": {
	            "type": "list",
	            "member": {
	              "shape": "S13"
	            }
	          }
	        }
	      }
	    },
	    "BatchGetDeploymentGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName",
	          "deploymentGroupNames"
	        ],
	        "members": {
	          "applicationName": {},
	          "deploymentGroupNames": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deploymentGroupsInfo": {
	            "type": "list",
	            "member": {
	              "shape": "S1b"
	            }
	          },
	          "errorMessage": {}
	        }
	      }
	    },
	    "BatchGetDeploymentInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "deploymentId",
	          "instanceIds"
	        ],
	        "members": {
	          "deploymentId": {},
	          "instanceIds": {
	            "shape": "S32"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "instancesSummary": {
	            "type": "list",
	            "member": {
	              "shape": "S36"
	            }
	          },
	          "errorMessage": {}
	        }
	      },
	      "deprecated": true,
	      "deprecatedMessage": "This operation is deprecated, use BatchGetDeploymentTargets instead."
	    },
	    "BatchGetDeploymentTargets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "deploymentId": {},
	          "targetIds": {
	            "shape": "S3j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deploymentTargets": {
	            "type": "list",
	            "member": {
	              "shape": "S3n"
	            }
	          }
	        }
	      }
	    },
	    "BatchGetDeployments": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "deploymentIds"
	        ],
	        "members": {
	          "deploymentIds": {
	            "shape": "S49"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deploymentsInfo": {
	            "type": "list",
	            "member": {
	              "shape": "S4c"
	            }
	          }
	        }
	      }
	    },
	    "BatchGetOnPremisesInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "instanceNames"
	        ],
	        "members": {
	          "instanceNames": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "instanceInfos": {
	            "type": "list",
	            "member": {
	              "shape": "S4t"
	            }
	          }
	        }
	      }
	    },
	    "ContinueDeployment": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "deploymentId": {},
	          "deploymentWaitType": {}
	        }
	      }
	    },
	    "CreateApplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName"
	        ],
	        "members": {
	          "applicationName": {},
	          "computePlatform": {},
	          "tags": {
	            "shape": "S2"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "applicationId": {}
	        }
	      }
	    },
	    "CreateDeployment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName"
	        ],
	        "members": {
	          "applicationName": {},
	          "deploymentGroupName": {},
	          "revision": {
	            "shape": "Sb"
	          },
	          "deploymentConfigName": {},
	          "description": {},
	          "ignoreApplicationStopFailures": {
	            "type": "boolean"
	          },
	          "targetInstances": {
	            "shape": "S4j"
	          },
	          "autoRollbackConfiguration": {
	            "shape": "S1z"
	          },
	          "updateOutdatedInstancesOnly": {
	            "type": "boolean"
	          },
	          "fileExistsBehavior": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deploymentId": {}
	        }
	      }
	    },
	    "CreateDeploymentConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "deploymentConfigName"
	        ],
	        "members": {
	          "deploymentConfigName": {},
	          "minimumHealthyHosts": {
	            "shape": "S54"
	          },
	          "trafficRoutingConfig": {
	            "shape": "S57"
	          },
	          "computePlatform": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deploymentConfigId": {}
	        }
	      }
	    },
	    "CreateDeploymentGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName",
	          "deploymentGroupName",
	          "serviceRoleArn"
	        ],
	        "members": {
	          "applicationName": {},
	          "deploymentGroupName": {},
	          "deploymentConfigName": {},
	          "ec2TagFilters": {
	            "shape": "S1e"
	          },
	          "onPremisesInstanceTagFilters": {
	            "shape": "S1h"
	          },
	          "autoScalingGroups": {
	            "shape": "S4k"
	          },
	          "serviceRoleArn": {},
	          "triggerConfigurations": {
	            "shape": "S1p"
	          },
	          "alarmConfiguration": {
	            "shape": "S1v"
	          },
	          "autoRollbackConfiguration": {
	            "shape": "S1z"
	          },
	          "outdatedInstancesStrategy": {},
	          "deploymentStyle": {
	            "shape": "S22"
	          },
	          "blueGreenDeploymentConfiguration": {
	            "shape": "S26"
	          },
	          "loadBalancerInfo": {
	            "shape": "S2e"
	          },
	          "ec2TagSet": {
	            "shape": "S2t"
	          },
	          "ecsServices": {
	            "shape": "S2x"
	          },
	          "onPremisesTagSet": {
	            "shape": "S2v"
	          },
	          "tags": {
	            "shape": "S2"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deploymentGroupId": {}
	        }
	      }
	    },
	    "DeleteApplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName"
	        ],
	        "members": {
	          "applicationName": {}
	        }
	      }
	    },
	    "DeleteDeploymentConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "deploymentConfigName"
	        ],
	        "members": {
	          "deploymentConfigName": {}
	        }
	      }
	    },
	    "DeleteDeploymentGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName",
	          "deploymentGroupName"
	        ],
	        "members": {
	          "applicationName": {},
	          "deploymentGroupName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "hooksNotCleanedUp": {
	            "shape": "S1k"
	          }
	        }
	      }
	    },
	    "DeleteGitHubAccountToken": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "tokenName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tokenName": {}
	        }
	      }
	    },
	    "DeleteResourcesByExternalId": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "externalId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeregisterOnPremisesInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "instanceName"
	        ],
	        "members": {
	          "instanceName": {}
	        }
	      }
	    },
	    "GetApplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName"
	        ],
	        "members": {
	          "applicationName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "application": {
	            "shape": "S13"
	          }
	        }
	      }
	    },
	    "GetApplicationRevision": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName",
	          "revision"
	        ],
	        "members": {
	          "applicationName": {},
	          "revision": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "applicationName": {},
	          "revision": {
	            "shape": "Sb"
	          },
	          "revisionInfo": {
	            "shape": "Su"
	          }
	        }
	      }
	    },
	    "GetDeployment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "deploymentId"
	        ],
	        "members": {
	          "deploymentId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deploymentInfo": {
	            "shape": "S4c"
	          }
	        }
	      }
	    },
	    "GetDeploymentConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "deploymentConfigName"
	        ],
	        "members": {
	          "deploymentConfigName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deploymentConfigInfo": {
	            "type": "structure",
	            "members": {
	              "deploymentConfigId": {},
	              "deploymentConfigName": {},
	              "minimumHealthyHosts": {
	                "shape": "S54"
	              },
	              "createTime": {
	                "type": "timestamp"
	              },
	              "computePlatform": {},
	              "trafficRoutingConfig": {
	                "shape": "S57"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetDeploymentGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName",
	          "deploymentGroupName"
	        ],
	        "members": {
	          "applicationName": {},
	          "deploymentGroupName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deploymentGroupInfo": {
	            "shape": "S1b"
	          }
	        }
	      }
	    },
	    "GetDeploymentInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "deploymentId",
	          "instanceId"
	        ],
	        "members": {
	          "deploymentId": {},
	          "instanceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "instanceSummary": {
	            "shape": "S36"
	          }
	        }
	      },
	      "deprecated": true,
	      "deprecatedMessage": "This operation is deprecated, use GetDeploymentTarget instead."
	    },
	    "GetDeploymentTarget": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "deploymentId": {},
	          "targetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deploymentTarget": {
	            "shape": "S3n"
	          }
	        }
	      }
	    },
	    "GetOnPremisesInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "instanceName"
	        ],
	        "members": {
	          "instanceName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "instanceInfo": {
	            "shape": "S4t"
	          }
	        }
	      }
	    },
	    "ListApplicationRevisions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName"
	        ],
	        "members": {
	          "applicationName": {},
	          "sortBy": {},
	          "sortOrder": {},
	          "s3Bucket": {},
	          "s3KeyPrefix": {},
	          "deployed": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "revisions": {
	            "shape": "Sa"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListApplications": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "applications": {
	            "shape": "S10"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDeploymentConfigs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deploymentConfigsList": {
	            "type": "list",
	            "member": {}
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDeploymentGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName"
	        ],
	        "members": {
	          "applicationName": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "applicationName": {},
	          "deploymentGroups": {
	            "shape": "Sw"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDeploymentInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "deploymentId"
	        ],
	        "members": {
	          "deploymentId": {},
	          "nextToken": {},
	          "instanceStatusFilter": {
	            "type": "list",
	            "member": {
	              "shape": "S37"
	            }
	          },
	          "instanceTypeFilter": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "instancesList": {
	            "shape": "S32"
	          },
	          "nextToken": {}
	        }
	      },
	      "deprecated": true,
	      "deprecatedMessage": "This operation is deprecated, use ListDeploymentTargets instead."
	    },
	    "ListDeploymentTargets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "deploymentId": {},
	          "nextToken": {},
	          "targetFilters": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "list",
	              "member": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "targetIds": {
	            "shape": "S3j"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDeployments": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "applicationName": {},
	          "deploymentGroupName": {},
	          "externalId": {},
	          "includeOnlyStatuses": {
	            "type": "list",
	            "member": {}
	          },
	          "createTimeRange": {
	            "type": "structure",
	            "members": {
	              "start": {
	                "type": "timestamp"
	              },
	              "end": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deployments": {
	            "shape": "S49"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListGitHubAccountTokenNames": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tokenNameList": {
	            "type": "list",
	            "member": {}
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListOnPremisesInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "registrationStatus": {},
	          "tagFilters": {
	            "shape": "S1h"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "instanceNames": {
	            "shape": "S6"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S2"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PutLifecycleEventHookExecutionStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "deploymentId": {},
	          "lifecycleEventHookExecutionId": {},
	          "status": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "lifecycleEventHookExecutionId": {}
	        }
	      }
	    },
	    "RegisterApplicationRevision": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName",
	          "revision"
	        ],
	        "members": {
	          "applicationName": {},
	          "description": {},
	          "revision": {
	            "shape": "Sb"
	          }
	        }
	      }
	    },
	    "RegisterOnPremisesInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "instanceName"
	        ],
	        "members": {
	          "instanceName": {},
	          "iamSessionArn": {},
	          "iamUserArn": {}
	        }
	      }
	    },
	    "RemoveTagsFromOnPremisesInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "tags",
	          "instanceNames"
	        ],
	        "members": {
	          "tags": {
	            "shape": "S2"
	          },
	          "instanceNames": {
	            "shape": "S6"
	          }
	        }
	      }
	    },
	    "SkipWaitTimeForInstanceTermination": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "deploymentId": {}
	        }
	      },
	      "deprecated": true,
	      "deprecatedMessage": "This operation is deprecated, use ContinueDeployment with DeploymentWaitType instead."
	    },
	    "StopDeployment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "deploymentId"
	        ],
	        "members": {
	          "deploymentId": {},
	          "autoRollbackEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "status": {},
	          "statusMessage": {}
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "S2"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateApplication": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "applicationName": {},
	          "newApplicationName": {}
	        }
	      }
	    },
	    "UpdateDeploymentGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "applicationName",
	          "currentDeploymentGroupName"
	        ],
	        "members": {
	          "applicationName": {},
	          "currentDeploymentGroupName": {},
	          "newDeploymentGroupName": {},
	          "deploymentConfigName": {},
	          "ec2TagFilters": {
	            "shape": "S1e"
	          },
	          "onPremisesInstanceTagFilters": {
	            "shape": "S1h"
	          },
	          "autoScalingGroups": {
	            "shape": "S4k"
	          },
	          "serviceRoleArn": {},
	          "triggerConfigurations": {
	            "shape": "S1p"
	          },
	          "alarmConfiguration": {
	            "shape": "S1v"
	          },
	          "autoRollbackConfiguration": {
	            "shape": "S1z"
	          },
	          "outdatedInstancesStrategy": {},
	          "deploymentStyle": {
	            "shape": "S22"
	          },
	          "blueGreenDeploymentConfiguration": {
	            "shape": "S26"
	          },
	          "loadBalancerInfo": {
	            "shape": "S2e"
	          },
	          "ec2TagSet": {
	            "shape": "S2t"
	          },
	          "ecsServices": {
	            "shape": "S2x"
	          },
	          "onPremisesTagSet": {
	            "shape": "S2v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "hooksNotCleanedUp": {
	            "shape": "S1k"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S6": {
	      "type": "list",
	      "member": {}
	    },
	    "Sa": {
	      "type": "list",
	      "member": {
	        "shape": "Sb"
	      }
	    },
	    "Sb": {
	      "type": "structure",
	      "members": {
	        "revisionType": {},
	        "s3Location": {
	          "type": "structure",
	          "members": {
	            "bucket": {},
	            "key": {},
	            "bundleType": {},
	            "version": {},
	            "eTag": {}
	          }
	        },
	        "gitHubLocation": {
	          "type": "structure",
	          "members": {
	            "repository": {},
	            "commitId": {}
	          }
	        },
	        "string": {
	          "type": "structure",
	          "members": {
	            "content": {},
	            "sha256": {}
	          },
	          "deprecated": true,
	          "deprecatedMessage": "RawString and String revision type are deprecated, use AppSpecContent type instead."
	        },
	        "appSpecContent": {
	          "type": "structure",
	          "members": {
	            "content": {},
	            "sha256": {}
	          }
	        }
	      }
	    },
	    "Su": {
	      "type": "structure",
	      "members": {
	        "description": {},
	        "deploymentGroups": {
	          "shape": "Sw"
	        },
	        "firstUsedTime": {
	          "type": "timestamp"
	        },
	        "lastUsedTime": {
	          "type": "timestamp"
	        },
	        "registerTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sw": {
	      "type": "list",
	      "member": {}
	    },
	    "S10": {
	      "type": "list",
	      "member": {}
	    },
	    "S13": {
	      "type": "structure",
	      "members": {
	        "applicationId": {},
	        "applicationName": {},
	        "createTime": {
	          "type": "timestamp"
	        },
	        "linkedToGitHub": {
	          "type": "boolean"
	        },
	        "gitHubAccountName": {},
	        "computePlatform": {}
	      }
	    },
	    "S1b": {
	      "type": "structure",
	      "members": {
	        "applicationName": {},
	        "deploymentGroupId": {},
	        "deploymentGroupName": {},
	        "deploymentConfigName": {},
	        "ec2TagFilters": {
	          "shape": "S1e"
	        },
	        "onPremisesInstanceTagFilters": {
	          "shape": "S1h"
	        },
	        "autoScalingGroups": {
	          "shape": "S1k"
	        },
	        "serviceRoleArn": {},
	        "targetRevision": {
	          "shape": "Sb"
	        },
	        "triggerConfigurations": {
	          "shape": "S1p"
	        },
	        "alarmConfiguration": {
	          "shape": "S1v"
	        },
	        "autoRollbackConfiguration": {
	          "shape": "S1z"
	        },
	        "deploymentStyle": {
	          "shape": "S22"
	        },
	        "outdatedInstancesStrategy": {},
	        "blueGreenDeploymentConfiguration": {
	          "shape": "S26"
	        },
	        "loadBalancerInfo": {
	          "shape": "S2e"
	        },
	        "lastSuccessfulDeployment": {
	          "shape": "S2q"
	        },
	        "lastAttemptedDeployment": {
	          "shape": "S2q"
	        },
	        "ec2TagSet": {
	          "shape": "S2t"
	        },
	        "onPremisesTagSet": {
	          "shape": "S2v"
	        },
	        "computePlatform": {},
	        "ecsServices": {
	          "shape": "S2x"
	        }
	      }
	    },
	    "S1e": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {},
	          "Type": {}
	        }
	      }
	    },
	    "S1h": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {},
	          "Type": {}
	        }
	      }
	    },
	    "S1k": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "hook": {}
	        }
	      }
	    },
	    "S1p": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "triggerName": {},
	          "triggerTargetArn": {},
	          "triggerEvents": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "S1v": {
	      "type": "structure",
	      "members": {
	        "enabled": {
	          "type": "boolean"
	        },
	        "ignorePollAlarmFailure": {
	          "type": "boolean"
	        },
	        "alarms": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "name": {}
	            }
	          }
	        }
	      }
	    },
	    "S1z": {
	      "type": "structure",
	      "members": {
	        "enabled": {
	          "type": "boolean"
	        },
	        "events": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S22": {
	      "type": "structure",
	      "members": {
	        "deploymentType": {},
	        "deploymentOption": {}
	      }
	    },
	    "S26": {
	      "type": "structure",
	      "members": {
	        "terminateBlueInstancesOnDeploymentSuccess": {
	          "type": "structure",
	          "members": {
	            "action": {},
	            "terminationWaitTimeInMinutes": {
	              "type": "integer"
	            }
	          }
	        },
	        "deploymentReadyOption": {
	          "type": "structure",
	          "members": {
	            "actionOnTimeout": {},
	            "waitTimeInMinutes": {
	              "type": "integer"
	            }
	          }
	        },
	        "greenFleetProvisioningOption": {
	          "type": "structure",
	          "members": {
	            "action": {}
	          }
	        }
	      }
	    },
	    "S2e": {
	      "type": "structure",
	      "members": {
	        "elbInfoList": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "name": {}
	            }
	          }
	        },
	        "targetGroupInfoList": {
	          "shape": "S2i"
	        },
	        "targetGroupPairInfoList": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "targetGroups": {
	                "shape": "S2i"
	              },
	              "prodTrafficRoute": {
	                "shape": "S2n"
	              },
	              "testTrafficRoute": {
	                "shape": "S2n"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2i": {
	      "type": "list",
	      "member": {
	        "shape": "S2j"
	      }
	    },
	    "S2j": {
	      "type": "structure",
	      "members": {
	        "name": {}
	      }
	    },
	    "S2n": {
	      "type": "structure",
	      "members": {
	        "listenerArns": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S2q": {
	      "type": "structure",
	      "members": {
	        "deploymentId": {},
	        "status": {},
	        "endTime": {
	          "type": "timestamp"
	        },
	        "createTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S2t": {
	      "type": "structure",
	      "members": {
	        "ec2TagSetList": {
	          "type": "list",
	          "member": {
	            "shape": "S1e"
	          }
	        }
	      }
	    },
	    "S2v": {
	      "type": "structure",
	      "members": {
	        "onPremisesTagSetList": {
	          "type": "list",
	          "member": {
	            "shape": "S1h"
	          }
	        }
	      }
	    },
	    "S2x": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "serviceName": {},
	          "clusterName": {}
	        }
	      }
	    },
	    "S32": {
	      "type": "list",
	      "member": {}
	    },
	    "S36": {
	      "type": "structure",
	      "members": {
	        "deploymentId": {},
	        "instanceId": {},
	        "status": {
	          "shape": "S37"
	        },
	        "lastUpdatedAt": {
	          "type": "timestamp"
	        },
	        "lifecycleEvents": {
	          "shape": "S38"
	        },
	        "instanceType": {}
	      },
	      "deprecated": true,
	      "deprecatedMessage": "InstanceSummary is deprecated, use DeploymentTarget instead."
	    },
	    "S37": {
	      "type": "string",
	      "deprecated": true,
	      "deprecatedMessage": "InstanceStatus is deprecated, use TargetStatus instead."
	    },
	    "S38": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "lifecycleEventName": {},
	          "diagnostics": {
	            "type": "structure",
	            "members": {
	              "errorCode": {},
	              "scriptName": {},
	              "message": {},
	              "logTail": {}
	            }
	          },
	          "startTime": {
	            "type": "timestamp"
	          },
	          "endTime": {
	            "type": "timestamp"
	          },
	          "status": {}
	        }
	      }
	    },
	    "S3j": {
	      "type": "list",
	      "member": {}
	    },
	    "S3n": {
	      "type": "structure",
	      "members": {
	        "deploymentTargetType": {},
	        "instanceTarget": {
	          "type": "structure",
	          "members": {
	            "deploymentId": {},
	            "targetId": {},
	            "targetArn": {},
	            "status": {},
	            "lastUpdatedAt": {
	              "type": "timestamp"
	            },
	            "lifecycleEvents": {
	              "shape": "S38"
	            },
	            "instanceLabel": {}
	          }
	        },
	        "lambdaTarget": {
	          "type": "structure",
	          "members": {
	            "deploymentId": {},
	            "targetId": {},
	            "targetArn": {},
	            "status": {},
	            "lastUpdatedAt": {
	              "type": "timestamp"
	            },
	            "lifecycleEvents": {
	              "shape": "S38"
	            },
	            "lambdaFunctionInfo": {
	              "type": "structure",
	              "members": {
	                "functionName": {},
	                "functionAlias": {},
	                "currentVersion": {},
	                "targetVersion": {},
	                "targetVersionWeight": {
	                  "type": "double"
	                }
	              }
	            }
	          }
	        },
	        "ecsTarget": {
	          "type": "structure",
	          "members": {
	            "deploymentId": {},
	            "targetId": {},
	            "targetArn": {},
	            "lastUpdatedAt": {
	              "type": "timestamp"
	            },
	            "lifecycleEvents": {
	              "shape": "S38"
	            },
	            "status": {},
	            "taskSetsInfo": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "identifer": {},
	                  "desiredCount": {
	                    "type": "long"
	                  },
	                  "pendingCount": {
	                    "type": "long"
	                  },
	                  "runningCount": {
	                    "type": "long"
	                  },
	                  "status": {},
	                  "trafficWeight": {
	                    "type": "double"
	                  },
	                  "targetGroup": {
	                    "shape": "S2j"
	                  },
	                  "taskSetLabel": {}
	                }
	              }
	            }
	          }
	        },
	        "cloudFormationTarget": {
	          "type": "structure",
	          "members": {
	            "deploymentId": {},
	            "targetId": {},
	            "lastUpdatedAt": {
	              "type": "timestamp"
	            },
	            "lifecycleEvents": {
	              "shape": "S38"
	            },
	            "status": {},
	            "resourceType": {},
	            "targetVersionWeight": {
	              "type": "double"
	            }
	          }
	        }
	      }
	    },
	    "S49": {
	      "type": "list",
	      "member": {}
	    },
	    "S4c": {
	      "type": "structure",
	      "members": {
	        "applicationName": {},
	        "deploymentGroupName": {},
	        "deploymentConfigName": {},
	        "deploymentId": {},
	        "previousRevision": {
	          "shape": "Sb"
	        },
	        "revision": {
	          "shape": "Sb"
	        },
	        "status": {},
	        "errorInformation": {
	          "type": "structure",
	          "members": {
	            "code": {},
	            "message": {}
	          }
	        },
	        "createTime": {
	          "type": "timestamp"
	        },
	        "startTime": {
	          "type": "timestamp"
	        },
	        "completeTime": {
	          "type": "timestamp"
	        },
	        "deploymentOverview": {
	          "type": "structure",
	          "members": {
	            "Pending": {
	              "type": "long"
	            },
	            "InProgress": {
	              "type": "long"
	            },
	            "Succeeded": {
	              "type": "long"
	            },
	            "Failed": {
	              "type": "long"
	            },
	            "Skipped": {
	              "type": "long"
	            },
	            "Ready": {
	              "type": "long"
	            }
	          }
	        },
	        "description": {},
	        "creator": {},
	        "ignoreApplicationStopFailures": {
	          "type": "boolean"
	        },
	        "autoRollbackConfiguration": {
	          "shape": "S1z"
	        },
	        "updateOutdatedInstancesOnly": {
	          "type": "boolean"
	        },
	        "rollbackInfo": {
	          "type": "structure",
	          "members": {
	            "rollbackDeploymentId": {},
	            "rollbackTriggeringDeploymentId": {},
	            "rollbackMessage": {}
	          }
	        },
	        "deploymentStyle": {
	          "shape": "S22"
	        },
	        "targetInstances": {
	          "shape": "S4j"
	        },
	        "instanceTerminationWaitTimeStarted": {
	          "type": "boolean"
	        },
	        "blueGreenDeploymentConfiguration": {
	          "shape": "S26"
	        },
	        "loadBalancerInfo": {
	          "shape": "S2e"
	        },
	        "additionalDeploymentStatusInfo": {
	          "type": "string",
	          "deprecated": true,
	          "deprecatedMessage": "AdditionalDeploymentStatusInfo is deprecated, use DeploymentStatusMessageList instead."
	        },
	        "fileExistsBehavior": {},
	        "deploymentStatusMessages": {
	          "type": "list",
	          "member": {}
	        },
	        "computePlatform": {},
	        "externalId": {},
	        "relatedDeployments": {
	          "type": "structure",
	          "members": {
	            "autoUpdateOutdatedInstancesRootDeploymentId": {},
	            "autoUpdateOutdatedInstancesDeploymentIds": {
	              "shape": "S49"
	            }
	          }
	        }
	      }
	    },
	    "S4j": {
	      "type": "structure",
	      "members": {
	        "tagFilters": {
	          "shape": "S1e"
	        },
	        "autoScalingGroups": {
	          "shape": "S4k"
	        },
	        "ec2TagSet": {
	          "shape": "S2t"
	        }
	      }
	    },
	    "S4k": {
	      "type": "list",
	      "member": {}
	    },
	    "S4t": {
	      "type": "structure",
	      "members": {
	        "instanceName": {},
	        "iamSessionArn": {},
	        "iamUserArn": {},
	        "instanceArn": {},
	        "registerTime": {
	          "type": "timestamp"
	        },
	        "deregisterTime": {
	          "type": "timestamp"
	        },
	        "tags": {
	          "shape": "S2"
	        }
	      }
	    },
	    "S54": {
	      "type": "structure",
	      "members": {
	        "type": {},
	        "value": {
	          "type": "integer"
	        }
	      }
	    },
	    "S57": {
	      "type": "structure",
	      "members": {
	        "type": {},
	        "timeBasedCanary": {
	          "type": "structure",
	          "members": {
	            "canaryPercentage": {
	              "type": "integer"
	            },
	            "canaryInterval": {
	              "type": "integer"
	            }
	          }
	        },
	        "timeBasedLinear": {
	          "type": "structure",
	          "members": {
	            "linearPercentage": {
	              "type": "integer"
	            },
	            "linearInterval": {
	              "type": "integer"
	            }
	          }
	        }
	      }
	    }
	  }
	}
	},{}],49:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListApplicationRevisions": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "revisions"
	    },
	    "ListApplications": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "applications"
	    },
	    "ListDeploymentConfigs": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "deploymentConfigsList"
	    },
	    "ListDeploymentGroups": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "deploymentGroups"
	    },
	    "ListDeploymentInstances": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "instancesList"
	    },
	    "ListDeployments": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "deployments"
	    }
	  }
	}
	},{}],50:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "DeploymentSuccessful": {
	      "delay": 15,
	      "operation": "GetDeployment",
	      "maxAttempts": 120,
	      "acceptors": [
	        {
	          "expected": "Succeeded",
	          "matcher": "path",
	          "state": "success",
	          "argument": "deploymentInfo.status"
	        },
	        {
	          "expected": "Failed",
	          "matcher": "path",
	          "state": "failure",
	          "argument": "deploymentInfo.status"
	        },
	        {
	          "expected": "Stopped",
	          "matcher": "path",
	          "state": "failure",
	          "argument": "deploymentInfo.status"
	        }
	      ]
	    }
	  }
	}
	
	},{}],51:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-07-09",
	    "endpointPrefix": "codepipeline",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "CodePipeline",
	    "serviceFullName": "AWS CodePipeline",
	    "serviceId": "CodePipeline",
	    "signatureVersion": "v4",
	    "targetPrefix": "CodePipeline_20150709",
	    "uid": "codepipeline-2015-07-09"
	  },
	  "operations": {
	    "AcknowledgeJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId",
	          "nonce"
	        ],
	        "members": {
	          "jobId": {},
	          "nonce": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "status": {}
	        }
	      }
	    },
	    "AcknowledgeThirdPartyJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId",
	          "nonce",
	          "clientToken"
	        ],
	        "members": {
	          "jobId": {},
	          "nonce": {},
	          "clientToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "status": {}
	        }
	      }
	    },
	    "CreateCustomActionType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "category",
	          "provider",
	          "version",
	          "inputArtifactDetails",
	          "outputArtifactDetails"
	        ],
	        "members": {
	          "category": {},
	          "provider": {},
	          "version": {},
	          "settings": {
	            "shape": "Se"
	          },
	          "configurationProperties": {
	            "shape": "Sh"
	          },
	          "inputArtifactDetails": {
	            "shape": "Sn"
	          },
	          "outputArtifactDetails": {
	            "shape": "Sn"
	          },
	          "tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "actionType"
	        ],
	        "members": {
	          "actionType": {
	            "shape": "Sv"
	          },
	          "tags": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "CreatePipeline": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipeline"
	        ],
	        "members": {
	          "pipeline": {
	            "shape": "Sz"
	          },
	          "tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipeline": {
	            "shape": "Sz"
	          },
	          "tags": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "DeleteCustomActionType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "category",
	          "provider",
	          "version"
	        ],
	        "members": {
	          "category": {},
	          "provider": {},
	          "version": {}
	        }
	      }
	    },
	    "DeletePipeline": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {}
	        }
	      }
	    },
	    "DeleteWebhook": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeregisterWebhookWithThirdParty": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "webhookName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DisableStageTransition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName",
	          "stageName",
	          "transitionType",
	          "reason"
	        ],
	        "members": {
	          "pipelineName": {},
	          "stageName": {},
	          "transitionType": {},
	          "reason": {}
	        }
	      }
	    },
	    "EnableStageTransition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName",
	          "stageName",
	          "transitionType"
	        ],
	        "members": {
	          "pipelineName": {},
	          "stageName": {},
	          "transitionType": {}
	        }
	      }
	    },
	    "GetActionType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "category",
	          "owner",
	          "provider",
	          "version"
	        ],
	        "members": {
	          "category": {},
	          "owner": {},
	          "provider": {},
	          "version": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "actionType": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "GetJobDetails": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId"
	        ],
	        "members": {
	          "jobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobDetails": {
	            "type": "structure",
	            "members": {
	              "id": {},
	              "data": {
	                "shape": "S31"
	              },
	              "accountId": {}
	            }
	          }
	        }
	      }
	    },
	    "GetPipeline": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {},
	          "version": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipeline": {
	            "shape": "Sz"
	          },
	          "metadata": {
	            "type": "structure",
	            "members": {
	              "pipelineArn": {},
	              "created": {
	                "type": "timestamp"
	              },
	              "updated": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetPipelineExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName",
	          "pipelineExecutionId"
	        ],
	        "members": {
	          "pipelineName": {},
	          "pipelineExecutionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipelineExecution": {
	            "type": "structure",
	            "members": {
	              "pipelineName": {},
	              "pipelineVersion": {
	                "type": "integer"
	              },
	              "pipelineExecutionId": {},
	              "status": {},
	              "statusSummary": {},
	              "artifactRevisions": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "name": {},
	                    "revisionId": {},
	                    "revisionChangeIdentifier": {},
	                    "revisionSummary": {},
	                    "created": {
	                      "type": "timestamp"
	                    },
	                    "revisionUrl": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetPipelineState": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipelineName": {},
	          "pipelineVersion": {
	            "type": "integer"
	          },
	          "stageStates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "stageName": {},
	                "inboundExecution": {
	                  "shape": "S43"
	                },
	                "inboundTransitionState": {
	                  "type": "structure",
	                  "members": {
	                    "enabled": {
	                      "type": "boolean"
	                    },
	                    "lastChangedBy": {},
	                    "lastChangedAt": {
	                      "type": "timestamp"
	                    },
	                    "disabledReason": {}
	                  }
	                },
	                "actionStates": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "actionName": {},
	                      "currentRevision": {
	                        "shape": "S4b"
	                      },
	                      "latestExecution": {
	                        "type": "structure",
	                        "members": {
	                          "actionExecutionId": {},
	                          "status": {},
	                          "summary": {},
	                          "lastStatusChange": {
	                            "type": "timestamp"
	                          },
	                          "token": {},
	                          "lastUpdatedBy": {},
	                          "externalExecutionId": {},
	                          "externalExecutionUrl": {},
	                          "percentComplete": {
	                            "type": "integer"
	                          },
	                          "errorDetails": {
	                            "type": "structure",
	                            "members": {
	                              "code": {},
	                              "message": {}
	                            }
	                          }
	                        }
	                      },
	                      "entityUrl": {},
	                      "revisionUrl": {}
	                    }
	                  }
	                },
	                "latestExecution": {
	                  "shape": "S43"
	                }
	              }
	            }
	          },
	          "created": {
	            "type": "timestamp"
	          },
	          "updated": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetThirdPartyJobDetails": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId",
	          "clientToken"
	        ],
	        "members": {
	          "jobId": {},
	          "clientToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobDetails": {
	            "type": "structure",
	            "members": {
	              "id": {},
	              "data": {
	                "type": "structure",
	                "members": {
	                  "actionTypeId": {
	                    "shape": "Sw"
	                  },
	                  "actionConfiguration": {
	                    "shape": "S32"
	                  },
	                  "pipelineContext": {
	                    "shape": "S33"
	                  },
	                  "inputArtifacts": {
	                    "shape": "S39"
	                  },
	                  "outputArtifacts": {
	                    "shape": "S39"
	                  },
	                  "artifactCredentials": {
	                    "shape": "S3h"
	                  },
	                  "continuationToken": {},
	                  "encryptionKey": {
	                    "shape": "S15"
	                  }
	                }
	              },
	              "nonce": {}
	            }
	          }
	        }
	      }
	    },
	    "ListActionExecutions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName"
	        ],
	        "members": {
	          "pipelineName": {},
	          "filter": {
	            "type": "structure",
	            "members": {
	              "pipelineExecutionId": {}
	            }
	          },
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "actionExecutionDetails": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "pipelineExecutionId": {},
	                "actionExecutionId": {},
	                "pipelineVersion": {
	                  "type": "integer"
	                },
	                "stageName": {},
	                "actionName": {},
	                "startTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdateTime": {
	                  "type": "timestamp"
	                },
	                "status": {},
	                "input": {
	                  "type": "structure",
	                  "members": {
	                    "actionTypeId": {
	                      "shape": "Sw"
	                    },
	                    "configuration": {
	                      "shape": "S1l"
	                    },
	                    "resolvedConfiguration": {
	                      "type": "map",
	                      "key": {},
	                      "value": {}
	                    },
	                    "roleArn": {},
	                    "region": {},
	                    "inputArtifacts": {
	                      "shape": "S50"
	                    },
	                    "namespace": {}
	                  }
	                },
	                "output": {
	                  "type": "structure",
	                  "members": {
	                    "outputArtifacts": {
	                      "shape": "S50"
	                    },
	                    "executionResult": {
	                      "type": "structure",
	                      "members": {
	                        "externalExecutionId": {},
	                        "externalExecutionSummary": {},
	                        "externalExecutionUrl": {}
	                      }
	                    },
	                    "outputVariables": {
	                      "shape": "S59"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListActionTypes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "actionOwnerFilter": {},
	          "nextToken": {},
	          "regionFilter": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "actionTypes"
	        ],
	        "members": {
	          "actionTypes": {
	            "type": "list",
	            "member": {
	              "shape": "Sv"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListPipelineExecutions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName"
	        ],
	        "members": {
	          "pipelineName": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipelineExecutionSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "pipelineExecutionId": {},
	                "status": {},
	                "startTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdateTime": {
	                  "type": "timestamp"
	                },
	                "sourceRevisions": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "required": [
	                      "actionName"
	                    ],
	                    "members": {
	                      "actionName": {},
	                      "revisionId": {},
	                      "revisionSummary": {},
	                      "revisionUrl": {}
	                    }
	                  }
	                },
	                "trigger": {
	                  "type": "structure",
	                  "members": {
	                    "triggerType": {},
	                    "triggerDetail": {}
	                  }
	                },
	                "stopTrigger": {
	                  "type": "structure",
	                  "members": {
	                    "reason": {}
	                  }
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListPipelines": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipelines": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "version": {
	                  "type": "integer"
	                },
	                "created": {
	                  "type": "timestamp"
	                },
	                "updated": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tags": {
	            "shape": "Sq"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListWebhooks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "webhooks": {
	            "type": "list",
	            "member": {
	              "shape": "S61"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PollForJobs": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "actionTypeId"
	        ],
	        "members": {
	          "actionTypeId": {
	            "shape": "Sw"
	          },
	          "maxBatchSize": {
	            "type": "integer"
	          },
	          "queryParam": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "id": {},
	                "data": {
	                  "shape": "S31"
	                },
	                "nonce": {},
	                "accountId": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "PollForThirdPartyJobs": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "actionTypeId"
	        ],
	        "members": {
	          "actionTypeId": {
	            "shape": "Sw"
	          },
	          "maxBatchSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "clientId": {},
	                "jobId": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutActionRevision": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName",
	          "stageName",
	          "actionName",
	          "actionRevision"
	        ],
	        "members": {
	          "pipelineName": {},
	          "stageName": {},
	          "actionName": {},
	          "actionRevision": {
	            "shape": "S4b"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "newRevision": {
	            "type": "boolean"
	          },
	          "pipelineExecutionId": {}
	        }
	      }
	    },
	    "PutApprovalResult": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName",
	          "stageName",
	          "actionName",
	          "result",
	          "token"
	        ],
	        "members": {
	          "pipelineName": {},
	          "stageName": {},
	          "actionName": {},
	          "result": {
	            "type": "structure",
	            "required": [
	              "summary",
	              "status"
	            ],
	            "members": {
	              "summary": {},
	              "status": {}
	            }
	          },
	          "token": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "approvedAt": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "PutJobFailureResult": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId",
	          "failureDetails"
	        ],
	        "members": {
	          "jobId": {},
	          "failureDetails": {
	            "shape": "S71"
	          }
	        }
	      }
	    },
	    "PutJobSuccessResult": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId"
	        ],
	        "members": {
	          "jobId": {},
	          "currentRevision": {
	            "shape": "S74"
	          },
	          "continuationToken": {},
	          "executionDetails": {
	            "shape": "S76"
	          },
	          "outputVariables": {
	            "shape": "S59"
	          }
	        }
	      }
	    },
	    "PutThirdPartyJobFailureResult": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId",
	          "clientToken",
	          "failureDetails"
	        ],
	        "members": {
	          "jobId": {},
	          "clientToken": {},
	          "failureDetails": {
	            "shape": "S71"
	          }
	        }
	      }
	    },
	    "PutThirdPartyJobSuccessResult": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId",
	          "clientToken"
	        ],
	        "members": {
	          "jobId": {},
	          "clientToken": {},
	          "currentRevision": {
	            "shape": "S74"
	          },
	          "continuationToken": {},
	          "executionDetails": {
	            "shape": "S76"
	          }
	        }
	      }
	    },
	    "PutWebhook": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "webhook"
	        ],
	        "members": {
	          "webhook": {
	            "shape": "S62"
	          },
	          "tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "webhook": {
	            "shape": "S61"
	          }
	        }
	      }
	    },
	    "RegisterWebhookWithThirdParty": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "webhookName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RetryStageExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName",
	          "stageName",
	          "pipelineExecutionId",
	          "retryMode"
	        ],
	        "members": {
	          "pipelineName": {},
	          "stageName": {},
	          "pipelineExecutionId": {},
	          "retryMode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipelineExecutionId": {}
	        }
	      }
	    },
	    "StartPipelineExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {},
	          "clientRequestToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipelineExecutionId": {}
	        }
	      }
	    },
	    "StopPipelineExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName",
	          "pipelineExecutionId"
	        ],
	        "members": {
	          "pipelineName": {},
	          "pipelineExecutionId": {},
	          "abandon": {
	            "type": "boolean"
	          },
	          "reason": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipelineExecutionId": {}
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tags"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tagKeys"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateActionType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "actionType"
	        ],
	        "members": {
	          "actionType": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "UpdatePipeline": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipeline"
	        ],
	        "members": {
	          "pipeline": {
	            "shape": "Sz"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipeline": {
	            "shape": "Sz"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Se": {
	      "type": "structure",
	      "members": {
	        "thirdPartyConfigurationUrl": {},
	        "entityUrlTemplate": {},
	        "executionUrlTemplate": {},
	        "revisionUrlTemplate": {}
	      }
	    },
	    "Sh": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "name",
	          "required",
	          "key",
	          "secret"
	        ],
	        "members": {
	          "name": {},
	          "required": {
	            "type": "boolean"
	          },
	          "key": {
	            "type": "boolean"
	          },
	          "secret": {
	            "type": "boolean"
	          },
	          "queryable": {
	            "type": "boolean"
	          },
	          "description": {},
	          "type": {}
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "required": [
	        "minimumCount",
	        "maximumCount"
	      ],
	      "members": {
	        "minimumCount": {
	          "type": "integer"
	        },
	        "maximumCount": {
	          "type": "integer"
	        }
	      }
	    },
	    "Sq": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "key",
	          "value"
	        ],
	        "members": {
	          "key": {},
	          "value": {}
	        }
	      }
	    },
	    "Sv": {
	      "type": "structure",
	      "required": [
	        "id",
	        "inputArtifactDetails",
	        "outputArtifactDetails"
	      ],
	      "members": {
	        "id": {
	          "shape": "Sw"
	        },
	        "settings": {
	          "shape": "Se"
	        },
	        "actionConfigurationProperties": {
	          "shape": "Sh"
	        },
	        "inputArtifactDetails": {
	          "shape": "Sn"
	        },
	        "outputArtifactDetails": {
	          "shape": "Sn"
	        }
	      }
	    },
	    "Sw": {
	      "type": "structure",
	      "required": [
	        "category",
	        "owner",
	        "provider",
	        "version"
	      ],
	      "members": {
	        "category": {},
	        "owner": {},
	        "provider": {},
	        "version": {}
	      }
	    },
	    "Sz": {
	      "type": "structure",
	      "required": [
	        "name",
	        "roleArn",
	        "stages"
	      ],
	      "members": {
	        "name": {},
	        "roleArn": {},
	        "artifactStore": {
	          "shape": "S12"
	        },
	        "artifactStores": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "shape": "S12"
	          }
	        },
	        "stages": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "name",
	              "actions"
	            ],
	            "members": {
	              "name": {},
	              "blockers": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "name",
	                    "type"
	                  ],
	                  "members": {
	                    "name": {},
	                    "type": {}
	                  }
	                }
	              },
	              "actions": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "name",
	                    "actionTypeId"
	                  ],
	                  "members": {
	                    "name": {},
	                    "actionTypeId": {
	                      "shape": "Sw"
	                    },
	                    "runOrder": {
	                      "type": "integer"
	                    },
	                    "configuration": {
	                      "shape": "S1l"
	                    },
	                    "outputArtifacts": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "required": [
	                          "name"
	                        ],
	                        "members": {
	                          "name": {}
	                        }
	                      }
	                    },
	                    "inputArtifacts": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "required": [
	                          "name"
	                        ],
	                        "members": {
	                          "name": {}
	                        }
	                      }
	                    },
	                    "roleArn": {},
	                    "region": {},
	                    "namespace": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "version": {
	          "type": "integer"
	        }
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "required": [
	        "type",
	        "location"
	      ],
	      "members": {
	        "type": {},
	        "location": {},
	        "encryptionKey": {
	          "shape": "S15"
	        }
	      }
	    },
	    "S15": {
	      "type": "structure",
	      "required": [
	        "id",
	        "type"
	      ],
	      "members": {
	        "id": {},
	        "type": {}
	      }
	    },
	    "S1l": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S29": {
	      "type": "structure",
	      "required": [
	        "executor",
	        "id",
	        "inputArtifactDetails",
	        "outputArtifactDetails"
	      ],
	      "members": {
	        "description": {},
	        "executor": {
	          "type": "structure",
	          "required": [
	            "configuration",
	            "type"
	          ],
	          "members": {
	            "configuration": {
	              "type": "structure",
	              "members": {
	                "lambdaExecutorConfiguration": {
	                  "type": "structure",
	                  "required": [
	                    "lambdaFunctionArn"
	                  ],
	                  "members": {
	                    "lambdaFunctionArn": {}
	                  }
	                },
	                "jobWorkerExecutorConfiguration": {
	                  "type": "structure",
	                  "members": {
	                    "pollingAccounts": {
	                      "type": "list",
	                      "member": {}
	                    },
	                    "pollingServicePrincipals": {
	                      "type": "list",
	                      "member": {}
	                    }
	                  }
	                }
	              }
	            },
	            "type": {},
	            "policyStatementsTemplate": {},
	            "jobTimeout": {
	              "type": "integer"
	            }
	          }
	        },
	        "id": {
	          "type": "structure",
	          "required": [
	            "category",
	            "owner",
	            "provider",
	            "version"
	          ],
	          "members": {
	            "category": {},
	            "owner": {},
	            "provider": {},
	            "version": {}
	          }
	        },
	        "inputArtifactDetails": {
	          "shape": "S2o"
	        },
	        "outputArtifactDetails": {
	          "shape": "S2o"
	        },
	        "permissions": {
	          "type": "structure",
	          "required": [
	            "allowedAccounts"
	          ],
	          "members": {
	            "allowedAccounts": {
	              "type": "list",
	              "member": {}
	            }
	          }
	        },
	        "properties": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "name",
	              "optional",
	              "key",
	              "noEcho"
	            ],
	            "members": {
	              "name": {},
	              "optional": {
	                "type": "boolean"
	              },
	              "key": {
	                "type": "boolean"
	              },
	              "noEcho": {
	                "type": "boolean"
	              },
	              "queryable": {
	                "type": "boolean"
	              },
	              "description": {}
	            }
	          }
	        },
	        "urls": {
	          "type": "structure",
	          "members": {
	            "configurationUrl": {},
	            "entityUrlTemplate": {},
	            "executionUrlTemplate": {},
	            "revisionUrlTemplate": {}
	          }
	        }
	      }
	    },
	    "S2o": {
	      "type": "structure",
	      "required": [
	        "minimumCount",
	        "maximumCount"
	      ],
	      "members": {
	        "minimumCount": {
	          "type": "integer"
	        },
	        "maximumCount": {
	          "type": "integer"
	        }
	      }
	    },
	    "S31": {
	      "type": "structure",
	      "members": {
	        "actionTypeId": {
	          "shape": "Sw"
	        },
	        "actionConfiguration": {
	          "shape": "S32"
	        },
	        "pipelineContext": {
	          "shape": "S33"
	        },
	        "inputArtifacts": {
	          "shape": "S39"
	        },
	        "outputArtifacts": {
	          "shape": "S39"
	        },
	        "artifactCredentials": {
	          "shape": "S3h"
	        },
	        "continuationToken": {},
	        "encryptionKey": {
	          "shape": "S15"
	        }
	      }
	    },
	    "S32": {
	      "type": "structure",
	      "members": {
	        "configuration": {
	          "shape": "S1l"
	        }
	      }
	    },
	    "S33": {
	      "type": "structure",
	      "members": {
	        "pipelineName": {},
	        "stage": {
	          "type": "structure",
	          "members": {
	            "name": {}
	          }
	        },
	        "action": {
	          "type": "structure",
	          "members": {
	            "name": {},
	            "actionExecutionId": {}
	          }
	        },
	        "pipelineArn": {},
	        "pipelineExecutionId": {}
	      }
	    },
	    "S39": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "revision": {},
	          "location": {
	            "type": "structure",
	            "members": {
	              "type": {},
	              "s3Location": {
	                "type": "structure",
	                "required": [
	                  "bucketName",
	                  "objectKey"
	                ],
	                "members": {
	                  "bucketName": {},
	                  "objectKey": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S3h": {
	      "type": "structure",
	      "required": [
	        "accessKeyId",
	        "secretAccessKey",
	        "sessionToken"
	      ],
	      "members": {
	        "accessKeyId": {
	          "type": "string",
	          "sensitive": true
	        },
	        "secretAccessKey": {
	          "type": "string",
	          "sensitive": true
	        },
	        "sessionToken": {
	          "type": "string",
	          "sensitive": true
	        }
	      },
	      "sensitive": true
	    },
	    "S43": {
	      "type": "structure",
	      "required": [
	        "pipelineExecutionId",
	        "status"
	      ],
	      "members": {
	        "pipelineExecutionId": {},
	        "status": {}
	      }
	    },
	    "S4b": {
	      "type": "structure",
	      "required": [
	        "revisionId",
	        "revisionChangeId",
	        "created"
	      ],
	      "members": {
	        "revisionId": {},
	        "revisionChangeId": {},
	        "created": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S50": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "s3location": {
	            "type": "structure",
	            "members": {
	              "bucket": {},
	              "key": {}
	            }
	          }
	        }
	      }
	    },
	    "S59": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S61": {
	      "type": "structure",
	      "required": [
	        "definition",
	        "url"
	      ],
	      "members": {
	        "definition": {
	          "shape": "S62"
	        },
	        "url": {},
	        "errorMessage": {},
	        "errorCode": {},
	        "lastTriggered": {
	          "type": "timestamp"
	        },
	        "arn": {},
	        "tags": {
	          "shape": "Sq"
	        }
	      }
	    },
	    "S62": {
	      "type": "structure",
	      "required": [
	        "name",
	        "targetPipeline",
	        "targetAction",
	        "filters",
	        "authentication",
	        "authenticationConfiguration"
	      ],
	      "members": {
	        "name": {},
	        "targetPipeline": {},
	        "targetAction": {},
	        "filters": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "jsonPath"
	            ],
	            "members": {
	              "jsonPath": {},
	              "matchEquals": {}
	            }
	          }
	        },
	        "authentication": {},
	        "authenticationConfiguration": {
	          "type": "structure",
	          "members": {
	            "AllowedIPRange": {},
	            "SecretToken": {}
	          }
	        }
	      }
	    },
	    "S71": {
	      "type": "structure",
	      "required": [
	        "type",
	        "message"
	      ],
	      "members": {
	        "type": {},
	        "message": {},
	        "externalExecutionId": {}
	      }
	    },
	    "S74": {
	      "type": "structure",
	      "required": [
	        "revision",
	        "changeIdentifier"
	      ],
	      "members": {
	        "revision": {},
	        "changeIdentifier": {},
	        "created": {
	          "type": "timestamp"
	        },
	        "revisionSummary": {}
	      }
	    },
	    "S76": {
	      "type": "structure",
	      "members": {
	        "summary": {},
	        "externalExecutionId": {},
	        "percentComplete": {
	          "type": "integer"
	        }
	      }
	    }
	  }
	}
	},{}],52:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListActionExecutions": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults",
	      "result_key": "actionExecutionDetails"
	    },
	    "ListActionTypes": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "actionTypes"
	    },
	    "ListPipelineExecutions": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults",
	      "result_key": "pipelineExecutionSummaries"
	    },
	    "ListPipelines": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults",
	      "result_key": "pipelines"
	    },
	    "ListTagsForResource": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults",
	      "result_key": "tags"
	    },
	    "ListWebhooks": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults",
	      "result_key": "webhooks"
	    }
	  }
	}
	
	},{}],53:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-06-30",
	    "endpointPrefix": "cognito-identity",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Cognito Identity",
	    "serviceId": "Cognito Identity",
	    "signatureVersion": "v4",
	    "targetPrefix": "AWSCognitoIdentityService",
	    "uid": "cognito-identity-2014-06-30"
	  },
	  "operations": {
	    "CreateIdentityPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolName",
	          "AllowUnauthenticatedIdentities"
	        ],
	        "members": {
	          "IdentityPoolName": {},
	          "AllowUnauthenticatedIdentities": {
	            "type": "boolean"
	          },
	          "AllowClassicFlow": {
	            "type": "boolean"
	          },
	          "SupportedLoginProviders": {
	            "shape": "S5"
	          },
	          "DeveloperProviderName": {},
	          "OpenIdConnectProviderARNs": {
	            "shape": "S9"
	          },
	          "CognitoIdentityProviders": {
	            "shape": "Sb"
	          },
	          "SamlProviderARNs": {
	            "shape": "Sg"
	          },
	          "IdentityPoolTags": {
	            "shape": "Sh"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sk"
	      }
	    },
	    "DeleteIdentities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityIdsToDelete"
	        ],
	        "members": {
	          "IdentityIdsToDelete": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UnprocessedIdentityIds": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "IdentityId": {},
	                "ErrorCode": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DeleteIdentityPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId"
	        ],
	        "members": {
	          "IdentityPoolId": {}
	        }
	      }
	    },
	    "DescribeIdentity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityId"
	        ],
	        "members": {
	          "IdentityId": {}
	        }
	      },
	      "output": {
	        "shape": "Sv"
	      }
	    },
	    "DescribeIdentityPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId"
	        ],
	        "members": {
	          "IdentityPoolId": {}
	        }
	      },
	      "output": {
	        "shape": "Sk"
	      }
	    },
	    "GetCredentialsForIdentity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityId"
	        ],
	        "members": {
	          "IdentityId": {},
	          "Logins": {
	            "shape": "S10"
	          },
	          "CustomRoleArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityId": {},
	          "Credentials": {
	            "type": "structure",
	            "members": {
	              "AccessKeyId": {},
	              "SecretKey": {},
	              "SessionToken": {},
	              "Expiration": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      },
	      "authtype": "none"
	    },
	    "GetId": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId"
	        ],
	        "members": {
	          "AccountId": {},
	          "IdentityPoolId": {},
	          "Logins": {
	            "shape": "S10"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityId": {}
	        }
	      },
	      "authtype": "none"
	    },
	    "GetIdentityPoolRoles": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId"
	        ],
	        "members": {
	          "IdentityPoolId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityPoolId": {},
	          "Roles": {
	            "shape": "S1c"
	          },
	          "RoleMappings": {
	            "shape": "S1e"
	          }
	        }
	      }
	    },
	    "GetOpenIdToken": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityId"
	        ],
	        "members": {
	          "IdentityId": {},
	          "Logins": {
	            "shape": "S10"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityId": {},
	          "Token": {}
	        }
	      },
	      "authtype": "none"
	    },
	    "GetOpenIdTokenForDeveloperIdentity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "Logins"
	        ],
	        "members": {
	          "IdentityPoolId": {},
	          "IdentityId": {},
	          "Logins": {
	            "shape": "S10"
	          },
	          "PrincipalTags": {
	            "shape": "S1s"
	          },
	          "TokenDuration": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityId": {},
	          "Token": {}
	        }
	      }
	    },
	    "GetPrincipalTagAttributeMap": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "IdentityProviderName"
	        ],
	        "members": {
	          "IdentityPoolId": {},
	          "IdentityProviderName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityPoolId": {},
	          "IdentityProviderName": {},
	          "UseDefaults": {
	            "type": "boolean"
	          },
	          "PrincipalTags": {
	            "shape": "S1s"
	          }
	        }
	      }
	    },
	    "ListIdentities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "MaxResults"
	        ],
	        "members": {
	          "IdentityPoolId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "HideDisabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityPoolId": {},
	          "Identities": {
	            "type": "list",
	            "member": {
	              "shape": "Sv"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListIdentityPools": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MaxResults"
	        ],
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityPools": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "IdentityPoolId": {},
	                "IdentityPoolName": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "Sh"
	          }
	        }
	      }
	    },
	    "LookupDeveloperIdentity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId"
	        ],
	        "members": {
	          "IdentityPoolId": {},
	          "IdentityId": {},
	          "DeveloperUserIdentifier": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityId": {},
	          "DeveloperUserIdentifierList": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "MergeDeveloperIdentities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceUserIdentifier",
	          "DestinationUserIdentifier",
	          "DeveloperProviderName",
	          "IdentityPoolId"
	        ],
	        "members": {
	          "SourceUserIdentifier": {},
	          "DestinationUserIdentifier": {},
	          "DeveloperProviderName": {},
	          "IdentityPoolId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityId": {}
	        }
	      }
	    },
	    "SetIdentityPoolRoles": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "Roles"
	        ],
	        "members": {
	          "IdentityPoolId": {},
	          "Roles": {
	            "shape": "S1c"
	          },
	          "RoleMappings": {
	            "shape": "S1e"
	          }
	        }
	      }
	    },
	    "SetPrincipalTagAttributeMap": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "IdentityProviderName"
	        ],
	        "members": {
	          "IdentityPoolId": {},
	          "IdentityProviderName": {},
	          "UseDefaults": {
	            "type": "boolean"
	          },
	          "PrincipalTags": {
	            "shape": "S1s"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityPoolId": {},
	          "IdentityProviderName": {},
	          "UseDefaults": {
	            "type": "boolean"
	          },
	          "PrincipalTags": {
	            "shape": "S1s"
	          }
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "Sh"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UnlinkDeveloperIdentity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityId",
	          "IdentityPoolId",
	          "DeveloperProviderName",
	          "DeveloperUserIdentifier"
	        ],
	        "members": {
	          "IdentityId": {},
	          "IdentityPoolId": {},
	          "DeveloperProviderName": {},
	          "DeveloperUserIdentifier": {}
	        }
	      }
	    },
	    "UnlinkIdentity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityId",
	          "Logins",
	          "LoginsToRemove"
	        ],
	        "members": {
	          "IdentityId": {},
	          "Logins": {
	            "shape": "S10"
	          },
	          "LoginsToRemove": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "authtype": "none"
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateIdentityPool": {
	      "input": {
	        "shape": "Sk"
	      },
	      "output": {
	        "shape": "Sk"
	      }
	    }
	  },
	  "shapes": {
	    "S5": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S9": {
	      "type": "list",
	      "member": {}
	    },
	    "Sb": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ProviderName": {},
	          "ClientId": {},
	          "ServerSideTokenCheck": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "Sg": {
	      "type": "list",
	      "member": {}
	    },
	    "Sh": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sk": {
	      "type": "structure",
	      "required": [
	        "IdentityPoolId",
	        "IdentityPoolName",
	        "AllowUnauthenticatedIdentities"
	      ],
	      "members": {
	        "IdentityPoolId": {},
	        "IdentityPoolName": {},
	        "AllowUnauthenticatedIdentities": {
	          "type": "boolean"
	        },
	        "AllowClassicFlow": {
	          "type": "boolean"
	        },
	        "SupportedLoginProviders": {
	          "shape": "S5"
	        },
	        "DeveloperProviderName": {},
	        "OpenIdConnectProviderARNs": {
	          "shape": "S9"
	        },
	        "CognitoIdentityProviders": {
	          "shape": "Sb"
	        },
	        "SamlProviderARNs": {
	          "shape": "Sg"
	        },
	        "IdentityPoolTags": {
	          "shape": "Sh"
	        }
	      }
	    },
	    "Sv": {
	      "type": "structure",
	      "members": {
	        "IdentityId": {},
	        "Logins": {
	          "shape": "Sw"
	        },
	        "CreationDate": {
	          "type": "timestamp"
	        },
	        "LastModifiedDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sw": {
	      "type": "list",
	      "member": {}
	    },
	    "S10": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S1c": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S1e": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "required": [
	          "Type"
	        ],
	        "members": {
	          "Type": {},
	          "AmbiguousRoleResolution": {},
	          "RulesConfiguration": {
	            "type": "structure",
	            "required": [
	              "Rules"
	            ],
	            "members": {
	              "Rules": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "Claim",
	                    "MatchType",
	                    "Value",
	                    "RoleARN"
	                  ],
	                  "members": {
	                    "Claim": {},
	                    "MatchType": {},
	                    "Value": {},
	                    "RoleARN": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1s": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    }
	  }
	}
	},{}],54:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListIdentityPools": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "IdentityPools"
	    }
	  }
	}
	},{}],55:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2016-04-18",
	    "endpointPrefix": "cognito-idp",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Cognito Identity Provider",
	    "serviceId": "Cognito Identity Provider",
	    "signatureVersion": "v4",
	    "targetPrefix": "AWSCognitoIdentityProviderService",
	    "uid": "cognito-idp-2016-04-18"
	  },
	  "operations": {
	    "AddCustomAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "CustomAttributes"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "CustomAttributes": {
	            "type": "list",
	            "member": {
	              "shape": "S4"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminAddUserToGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username",
	          "GroupName"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "GroupName": {}
	        }
	      }
	    },
	    "AdminConfirmSignUp": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminCreateUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "UserAttributes": {
	            "shape": "Sj"
	          },
	          "ValidationData": {
	            "shape": "Sj"
	          },
	          "TemporaryPassword": {
	            "shape": "Sn"
	          },
	          "ForceAliasCreation": {
	            "type": "boolean"
	          },
	          "MessageAction": {},
	          "DesiredDeliveryMediums": {
	            "type": "list",
	            "member": {}
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "User": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "AdminDeleteUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "AdminDeleteUserAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username",
	          "UserAttributeNames"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "UserAttributeNames": {
	            "shape": "S10"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminDisableProviderForUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "User"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "User": {
	            "shape": "S13"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminDisableUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminEnableUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminForgetDevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username",
	          "DeviceKey"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "DeviceKey": {}
	        }
	      }
	    },
	    "AdminGetDevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeviceKey",
	          "UserPoolId",
	          "Username"
	        ],
	        "members": {
	          "DeviceKey": {},
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Device"
	        ],
	        "members": {
	          "Device": {
	            "shape": "S1e"
	          }
	        }
	      }
	    },
	    "AdminGetUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Username"
	        ],
	        "members": {
	          "Username": {
	            "shape": "Sd"
	          },
	          "UserAttributes": {
	            "shape": "Sj"
	          },
	          "UserCreateDate": {
	            "type": "timestamp"
	          },
	          "UserLastModifiedDate": {
	            "type": "timestamp"
	          },
	          "Enabled": {
	            "type": "boolean"
	          },
	          "UserStatus": {},
	          "MFAOptions": {
	            "shape": "Sw"
	          },
	          "PreferredMfaSetting": {},
	          "UserMFASettingList": {
	            "shape": "S1h"
	          }
	        }
	      }
	    },
	    "AdminInitiateAuth": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "ClientId",
	          "AuthFlow"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "AuthFlow": {},
	          "AuthParameters": {
	            "shape": "S1l"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          },
	          "AnalyticsMetadata": {
	            "shape": "S1m"
	          },
	          "ContextData": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChallengeName": {},
	          "Session": {},
	          "ChallengeParameters": {
	            "shape": "S1t"
	          },
	          "AuthenticationResult": {
	            "shape": "S1u"
	          }
	        }
	      }
	    },
	    "AdminLinkProviderForUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "DestinationUser",
	          "SourceUser"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "DestinationUser": {
	            "shape": "S13"
	          },
	          "SourceUser": {
	            "shape": "S13"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminListDevices": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "PaginationToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Devices": {
	            "shape": "S24"
	          },
	          "PaginationToken": {}
	        }
	      }
	    },
	    "AdminListGroupsForUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Username",
	          "UserPoolId"
	        ],
	        "members": {
	          "Username": {
	            "shape": "Sd"
	          },
	          "UserPoolId": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Groups": {
	            "shape": "S28"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "AdminListUserAuthEvents": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AuthEvents": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EventId": {},
	                "EventType": {},
	                "CreationDate": {
	                  "type": "timestamp"
	                },
	                "EventResponse": {},
	                "EventRisk": {
	                  "type": "structure",
	                  "members": {
	                    "RiskDecision": {},
	                    "RiskLevel": {},
	                    "CompromisedCredentialsDetected": {
	                      "type": "boolean"
	                    }
	                  }
	                },
	                "ChallengeResponses": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "ChallengeName": {},
	                      "ChallengeResponse": {}
	                    }
	                  }
	                },
	                "EventContextData": {
	                  "type": "structure",
	                  "members": {
	                    "IpAddress": {},
	                    "DeviceName": {},
	                    "Timezone": {},
	                    "City": {},
	                    "Country": {}
	                  }
	                },
	                "EventFeedback": {
	                  "type": "structure",
	                  "required": [
	                    "FeedbackValue",
	                    "Provider"
	                  ],
	                  "members": {
	                    "FeedbackValue": {},
	                    "Provider": {},
	                    "FeedbackDate": {
	                      "type": "timestamp"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "AdminRemoveUserFromGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username",
	          "GroupName"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "GroupName": {}
	        }
	      }
	    },
	    "AdminResetUserPassword": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminRespondToAuthChallenge": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "ClientId",
	          "ChallengeName"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "ChallengeName": {},
	          "ChallengeResponses": {
	            "shape": "S2y"
	          },
	          "Session": {},
	          "AnalyticsMetadata": {
	            "shape": "S1m"
	          },
	          "ContextData": {
	            "shape": "S1n"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChallengeName": {},
	          "Session": {},
	          "ChallengeParameters": {
	            "shape": "S1t"
	          },
	          "AuthenticationResult": {
	            "shape": "S1u"
	          }
	        }
	      }
	    },
	    "AdminSetUserMFAPreference": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Username",
	          "UserPoolId"
	        ],
	        "members": {
	          "SMSMfaSettings": {
	            "shape": "S31"
	          },
	          "SoftwareTokenMfaSettings": {
	            "shape": "S32"
	          },
	          "Username": {
	            "shape": "Sd"
	          },
	          "UserPoolId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminSetUserPassword": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username",
	          "Password"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "Password": {
	            "shape": "Sn"
	          },
	          "Permanent": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminSetUserSettings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username",
	          "MFAOptions"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "MFAOptions": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminUpdateAuthEventFeedback": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username",
	          "EventId",
	          "FeedbackValue"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "EventId": {},
	          "FeedbackValue": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminUpdateDeviceStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username",
	          "DeviceKey"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "DeviceKey": {},
	          "DeviceRememberedStatus": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminUpdateUserAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username",
	          "UserAttributes"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "UserAttributes": {
	            "shape": "Sj"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AdminUserGlobalSignOut": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AssociateSoftwareToken": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          },
	          "Session": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SecretCode": {
	            "type": "string",
	            "sensitive": true
	          },
	          "Session": {}
	        }
	      }
	    },
	    "ChangePassword": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PreviousPassword",
	          "ProposedPassword",
	          "AccessToken"
	        ],
	        "members": {
	          "PreviousPassword": {
	            "shape": "Sn"
	          },
	          "ProposedPassword": {
	            "shape": "Sn"
	          },
	          "AccessToken": {
	            "shape": "S1v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "authtype": "none"
	    },
	    "ConfirmDevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessToken",
	          "DeviceKey"
	        ],
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          },
	          "DeviceKey": {},
	          "DeviceSecretVerifierConfig": {
	            "type": "structure",
	            "members": {
	              "PasswordVerifier": {},
	              "Salt": {}
	            }
	          },
	          "DeviceName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserConfirmationNecessary": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ConfirmForgotPassword": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientId",
	          "Username",
	          "ConfirmationCode",
	          "Password"
	        ],
	        "members": {
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "SecretHash": {
	            "shape": "S3s"
	          },
	          "Username": {
	            "shape": "Sd"
	          },
	          "ConfirmationCode": {},
	          "Password": {
	            "shape": "Sn"
	          },
	          "AnalyticsMetadata": {
	            "shape": "S1m"
	          },
	          "UserContextData": {
	            "shape": "S3u"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "authtype": "none"
	    },
	    "ConfirmSignUp": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientId",
	          "Username",
	          "ConfirmationCode"
	        ],
	        "members": {
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "SecretHash": {
	            "shape": "S3s"
	          },
	          "Username": {
	            "shape": "Sd"
	          },
	          "ConfirmationCode": {},
	          "ForceAliasCreation": {
	            "type": "boolean"
	          },
	          "AnalyticsMetadata": {
	            "shape": "S1m"
	          },
	          "UserContextData": {
	            "shape": "S3u"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "authtype": "none"
	    },
	    "CreateGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "UserPoolId"
	        ],
	        "members": {
	          "GroupName": {},
	          "UserPoolId": {},
	          "Description": {},
	          "RoleArn": {},
	          "Precedence": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Group": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "CreateIdentityProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "ProviderName",
	          "ProviderType",
	          "ProviderDetails"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ProviderName": {},
	          "ProviderType": {},
	          "ProviderDetails": {
	            "shape": "S43"
	          },
	          "AttributeMapping": {
	            "shape": "S44"
	          },
	          "IdpIdentifiers": {
	            "shape": "S46"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "IdentityProvider"
	        ],
	        "members": {
	          "IdentityProvider": {
	            "shape": "S49"
	          }
	        }
	      }
	    },
	    "CreateResourceServer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Identifier",
	          "Name"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Identifier": {},
	          "Name": {},
	          "Scopes": {
	            "shape": "S4d"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResourceServer"
	        ],
	        "members": {
	          "ResourceServer": {
	            "shape": "S4i"
	          }
	        }
	      }
	    },
	    "CreateUserImportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobName",
	          "UserPoolId",
	          "CloudWatchLogsRoleArn"
	        ],
	        "members": {
	          "JobName": {},
	          "UserPoolId": {},
	          "CloudWatchLogsRoleArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserImportJob": {
	            "shape": "S4m"
	          }
	        }
	      }
	    },
	    "CreateUserPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PoolName"
	        ],
	        "members": {
	          "PoolName": {},
	          "Policies": {
	            "shape": "S4u"
	          },
	          "LambdaConfig": {
	            "shape": "S4y"
	          },
	          "AutoVerifiedAttributes": {
	            "shape": "S53"
	          },
	          "AliasAttributes": {
	            "shape": "S55"
	          },
	          "UsernameAttributes": {
	            "shape": "S57"
	          },
	          "SmsVerificationMessage": {},
	          "EmailVerificationMessage": {},
	          "EmailVerificationSubject": {},
	          "VerificationMessageTemplate": {
	            "shape": "S5c"
	          },
	          "SmsAuthenticationMessage": {},
	          "MfaConfiguration": {},
	          "UserAttributeUpdateSettings": {
	            "shape": "S5h"
	          },
	          "DeviceConfiguration": {
	            "shape": "S5j"
	          },
	          "EmailConfiguration": {
	            "shape": "S5k"
	          },
	          "SmsConfiguration": {
	            "shape": "S5o"
	          },
	          "UserPoolTags": {
	            "shape": "S5q"
	          },
	          "AdminCreateUserConfig": {
	            "shape": "S5t"
	          },
	          "Schema": {
	            "shape": "S5w"
	          },
	          "UserPoolAddOns": {
	            "shape": "S5x"
	          },
	          "UsernameConfiguration": {
	            "shape": "S5z"
	          },
	          "AccountRecoverySetting": {
	            "shape": "S60"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserPool": {
	            "shape": "S66"
	          }
	        }
	      }
	    },
	    "CreateUserPoolClient": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "ClientName"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ClientName": {},
	          "GenerateSecret": {
	            "type": "boolean"
	          },
	          "RefreshTokenValidity": {
	            "type": "integer"
	          },
	          "AccessTokenValidity": {
	            "type": "integer"
	          },
	          "IdTokenValidity": {
	            "type": "integer"
	          },
	          "TokenValidityUnits": {
	            "shape": "S6f"
	          },
	          "ReadAttributes": {
	            "shape": "S6h"
	          },
	          "WriteAttributes": {
	            "shape": "S6h"
	          },
	          "ExplicitAuthFlows": {
	            "shape": "S6j"
	          },
	          "SupportedIdentityProviders": {
	            "shape": "S6l"
	          },
	          "CallbackURLs": {
	            "shape": "S6m"
	          },
	          "LogoutURLs": {
	            "shape": "S6o"
	          },
	          "DefaultRedirectURI": {},
	          "AllowedOAuthFlows": {
	            "shape": "S6p"
	          },
	          "AllowedOAuthScopes": {
	            "shape": "S6r"
	          },
	          "AllowedOAuthFlowsUserPoolClient": {
	            "type": "boolean"
	          },
	          "AnalyticsConfiguration": {
	            "shape": "S6t"
	          },
	          "PreventUserExistenceErrors": {},
	          "EnableTokenRevocation": {
	            "type": "boolean"
	          },
	          "EnablePropagateAdditionalUserContextData": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserPoolClient": {
	            "shape": "S6x"
	          }
	        }
	      }
	    },
	    "CreateUserPoolDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Domain",
	          "UserPoolId"
	        ],
	        "members": {
	          "Domain": {},
	          "UserPoolId": {},
	          "CustomDomainConfig": {
	            "shape": "S70"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontDomain": {}
	        }
	      }
	    },
	    "DeleteGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "UserPoolId"
	        ],
	        "members": {
	          "GroupName": {},
	          "UserPoolId": {}
	        }
	      }
	    },
	    "DeleteIdentityProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "ProviderName"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ProviderName": {}
	        }
	      }
	    },
	    "DeleteResourceServer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Identifier"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Identifier": {}
	        }
	      }
	    },
	    "DeleteUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessToken"
	        ],
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          }
	        }
	      },
	      "authtype": "none"
	    },
	    "DeleteUserAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserAttributeNames",
	          "AccessToken"
	        ],
	        "members": {
	          "UserAttributeNames": {
	            "shape": "S10"
	          },
	          "AccessToken": {
	            "shape": "S1v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "authtype": "none"
	    },
	    "DeleteUserPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {}
	        }
	      }
	    },
	    "DeleteUserPoolClient": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "ClientId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ClientId": {
	            "shape": "S1j"
	          }
	        }
	      }
	    },
	    "DeleteUserPoolDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Domain",
	          "UserPoolId"
	        ],
	        "members": {
	          "Domain": {},
	          "UserPoolId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeIdentityProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "ProviderName"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ProviderName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "IdentityProvider"
	        ],
	        "members": {
	          "IdentityProvider": {
	            "shape": "S49"
	          }
	        }
	      }
	    },
	    "DescribeResourceServer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Identifier"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Identifier": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResourceServer"
	        ],
	        "members": {
	          "ResourceServer": {
	            "shape": "S4i"
	          }
	        }
	      }
	    },
	    "DescribeRiskConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ClientId": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "RiskConfiguration"
	        ],
	        "members": {
	          "RiskConfiguration": {
	            "shape": "S7i"
	          }
	        }
	      }
	    },
	    "DescribeUserImportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "JobId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserImportJob": {
	            "shape": "S4m"
	          }
	        }
	      }
	    },
	    "DescribeUserPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserPool": {
	            "shape": "S66"
	          }
	        }
	      }
	    },
	    "DescribeUserPoolClient": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "ClientId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ClientId": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserPoolClient": {
	            "shape": "S6x"
	          }
	        }
	      }
	    },
	    "DescribeUserPoolDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Domain"
	        ],
	        "members": {
	          "Domain": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DomainDescription": {
	            "type": "structure",
	            "members": {
	              "UserPoolId": {},
	              "AWSAccountId": {},
	              "Domain": {},
	              "S3Bucket": {},
	              "CloudFrontDistribution": {},
	              "Version": {},
	              "Status": {},
	              "CustomDomainConfig": {
	                "shape": "S70"
	              }
	            }
	          }
	        }
	      }
	    },
	    "ForgetDevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeviceKey"
	        ],
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          },
	          "DeviceKey": {}
	        }
	      }
	    },
	    "ForgotPassword": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientId",
	          "Username"
	        ],
	        "members": {
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "SecretHash": {
	            "shape": "S3s"
	          },
	          "UserContextData": {
	            "shape": "S3u"
	          },
	          "Username": {
	            "shape": "Sd"
	          },
	          "AnalyticsMetadata": {
	            "shape": "S1m"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CodeDeliveryDetails": {
	            "shape": "S8g"
	          }
	        }
	      },
	      "authtype": "none"
	    },
	    "GetCSVHeader": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserPoolId": {},
	          "CSVHeader": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "GetDevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeviceKey"
	        ],
	        "members": {
	          "DeviceKey": {},
	          "AccessToken": {
	            "shape": "S1v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Device"
	        ],
	        "members": {
	          "Device": {
	            "shape": "S1e"
	          }
	        }
	      }
	    },
	    "GetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "UserPoolId"
	        ],
	        "members": {
	          "GroupName": {},
	          "UserPoolId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Group": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "GetIdentityProviderByIdentifier": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "IdpIdentifier"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "IdpIdentifier": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "IdentityProvider"
	        ],
	        "members": {
	          "IdentityProvider": {
	            "shape": "S49"
	          }
	        }
	      }
	    },
	    "GetSigningCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Certificate": {}
	        }
	      }
	    },
	    "GetUICustomization": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ClientId": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "UICustomization"
	        ],
	        "members": {
	          "UICustomization": {
	            "shape": "S8u"
	          }
	        }
	      }
	    },
	    "GetUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessToken"
	        ],
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Username",
	          "UserAttributes"
	        ],
	        "members": {
	          "Username": {
	            "shape": "Sd"
	          },
	          "UserAttributes": {
	            "shape": "Sj"
	          },
	          "MFAOptions": {
	            "shape": "Sw"
	          },
	          "PreferredMfaSetting": {},
	          "UserMFASettingList": {
	            "shape": "S1h"
	          }
	        }
	      },
	      "authtype": "none"
	    },
	    "GetUserAttributeVerificationCode": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessToken",
	          "AttributeName"
	        ],
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          },
	          "AttributeName": {},
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CodeDeliveryDetails": {
	            "shape": "S8g"
	          }
	        }
	      },
	      "authtype": "none"
	    },
	    "GetUserPoolMfaConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SmsMfaConfiguration": {
	            "shape": "S94"
	          },
	          "SoftwareTokenMfaConfiguration": {
	            "shape": "S95"
	          },
	          "MfaConfiguration": {}
	        }
	      }
	    },
	    "GlobalSignOut": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessToken"
	        ],
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "InitiateAuth": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AuthFlow",
	          "ClientId"
	        ],
	        "members": {
	          "AuthFlow": {},
	          "AuthParameters": {
	            "shape": "S1l"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          },
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "AnalyticsMetadata": {
	            "shape": "S1m"
	          },
	          "UserContextData": {
	            "shape": "S3u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChallengeName": {},
	          "Session": {},
	          "ChallengeParameters": {
	            "shape": "S1t"
	          },
	          "AuthenticationResult": {
	            "shape": "S1u"
	          }
	        }
	      },
	      "authtype": "none"
	    },
	    "ListDevices": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessToken"
	        ],
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "PaginationToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Devices": {
	            "shape": "S24"
	          },
	          "PaginationToken": {}
	        }
	      }
	    },
	    "ListGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Groups": {
	            "shape": "S28"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListIdentityProviders": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Providers"
	        ],
	        "members": {
	          "Providers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ProviderName": {},
	                "ProviderType": {},
	                "LastModifiedDate": {
	                  "type": "timestamp"
	                },
	                "CreationDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListResourceServers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResourceServers"
	        ],
	        "members": {
	          "ResourceServers": {
	            "type": "list",
	            "member": {
	              "shape": "S4i"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S5q"
	          }
	        }
	      }
	    },
	    "ListUserImportJobs": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "MaxResults"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "PaginationToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserImportJobs": {
	            "type": "list",
	            "member": {
	              "shape": "S4m"
	            }
	          },
	          "PaginationToken": {}
	        }
	      }
	    },
	    "ListUserPoolClients": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserPoolClients": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ClientId": {
	                  "shape": "S1j"
	                },
	                "UserPoolId": {},
	                "ClientName": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListUserPools": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MaxResults"
	        ],
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserPools": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Name": {},
	                "LambdaConfig": {
	                  "shape": "S4y"
	                },
	                "Status": {},
	                "LastModifiedDate": {
	                  "type": "timestamp"
	                },
	                "CreationDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListUsers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "AttributesToGet": {
	            "type": "list",
	            "member": {}
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "PaginationToken": {},
	          "Filter": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Users": {
	            "shape": "Sa7"
	          },
	          "PaginationToken": {}
	        }
	      }
	    },
	    "ListUsersInGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "GroupName"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "GroupName": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Users": {
	            "shape": "Sa7"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ResendConfirmationCode": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientId",
	          "Username"
	        ],
	        "members": {
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "SecretHash": {
	            "shape": "S3s"
	          },
	          "UserContextData": {
	            "shape": "S3u"
	          },
	          "Username": {
	            "shape": "Sd"
	          },
	          "AnalyticsMetadata": {
	            "shape": "S1m"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CodeDeliveryDetails": {
	            "shape": "S8g"
	          }
	        }
	      },
	      "authtype": "none"
	    },
	    "RespondToAuthChallenge": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientId",
	          "ChallengeName"
	        ],
	        "members": {
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "ChallengeName": {},
	          "Session": {},
	          "ChallengeResponses": {
	            "shape": "S2y"
	          },
	          "AnalyticsMetadata": {
	            "shape": "S1m"
	          },
	          "UserContextData": {
	            "shape": "S3u"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChallengeName": {},
	          "Session": {},
	          "ChallengeParameters": {
	            "shape": "S1t"
	          },
	          "AuthenticationResult": {
	            "shape": "S1u"
	          }
	        }
	      },
	      "authtype": "none"
	    },
	    "RevokeToken": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Token",
	          "ClientId"
	        ],
	        "members": {
	          "Token": {
	            "shape": "S1v"
	          },
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "ClientSecret": {
	            "shape": "S6y"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetRiskConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "CompromisedCredentialsRiskConfiguration": {
	            "shape": "S7j"
	          },
	          "AccountTakeoverRiskConfiguration": {
	            "shape": "S7o"
	          },
	          "RiskExceptionConfiguration": {
	            "shape": "S7x"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "RiskConfiguration"
	        ],
	        "members": {
	          "RiskConfiguration": {
	            "shape": "S7i"
	          }
	        }
	      }
	    },
	    "SetUICustomization": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "CSS": {},
	          "ImageFile": {
	            "type": "blob"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "UICustomization"
	        ],
	        "members": {
	          "UICustomization": {
	            "shape": "S8u"
	          }
	        }
	      }
	    },
	    "SetUserMFAPreference": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessToken"
	        ],
	        "members": {
	          "SMSMfaSettings": {
	            "shape": "S31"
	          },
	          "SoftwareTokenMfaSettings": {
	            "shape": "S32"
	          },
	          "AccessToken": {
	            "shape": "S1v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetUserPoolMfaConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "SmsMfaConfiguration": {
	            "shape": "S94"
	          },
	          "SoftwareTokenMfaConfiguration": {
	            "shape": "S95"
	          },
	          "MfaConfiguration": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SmsMfaConfiguration": {
	            "shape": "S94"
	          },
	          "SoftwareTokenMfaConfiguration": {
	            "shape": "S95"
	          },
	          "MfaConfiguration": {}
	        }
	      }
	    },
	    "SetUserSettings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessToken",
	          "MFAOptions"
	        ],
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          },
	          "MFAOptions": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "authtype": "none"
	    },
	    "SignUp": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientId",
	          "Username",
	          "Password"
	        ],
	        "members": {
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "SecretHash": {
	            "shape": "S3s"
	          },
	          "Username": {
	            "shape": "Sd"
	          },
	          "Password": {
	            "shape": "Sn"
	          },
	          "UserAttributes": {
	            "shape": "Sj"
	          },
	          "ValidationData": {
	            "shape": "Sj"
	          },
	          "AnalyticsMetadata": {
	            "shape": "S1m"
	          },
	          "UserContextData": {
	            "shape": "S3u"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "UserConfirmed",
	          "UserSub"
	        ],
	        "members": {
	          "UserConfirmed": {
	            "type": "boolean"
	          },
	          "CodeDeliveryDetails": {
	            "shape": "S8g"
	          },
	          "UserSub": {}
	        }
	      },
	      "authtype": "none"
	    },
	    "StartUserImportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "JobId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserImportJob": {
	            "shape": "S4m"
	          }
	        }
	      }
	    },
	    "StopUserImportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "JobId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserImportJob": {
	            "shape": "S4m"
	          }
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "S5q"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateAuthEventFeedback": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Username",
	          "EventId",
	          "FeedbackToken",
	          "FeedbackValue"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Username": {
	            "shape": "Sd"
	          },
	          "EventId": {},
	          "FeedbackToken": {
	            "shape": "S1v"
	          },
	          "FeedbackValue": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateDeviceStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessToken",
	          "DeviceKey"
	        ],
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          },
	          "DeviceKey": {},
	          "DeviceRememberedStatus": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "UserPoolId"
	        ],
	        "members": {
	          "GroupName": {},
	          "UserPoolId": {},
	          "Description": {},
	          "RoleArn": {},
	          "Precedence": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Group": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "UpdateIdentityProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "ProviderName"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ProviderName": {},
	          "ProviderDetails": {
	            "shape": "S43"
	          },
	          "AttributeMapping": {
	            "shape": "S44"
	          },
	          "IdpIdentifiers": {
	            "shape": "S46"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "IdentityProvider"
	        ],
	        "members": {
	          "IdentityProvider": {
	            "shape": "S49"
	          }
	        }
	      }
	    },
	    "UpdateResourceServer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "Identifier",
	          "Name"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Identifier": {},
	          "Name": {},
	          "Scopes": {
	            "shape": "S4d"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResourceServer"
	        ],
	        "members": {
	          "ResourceServer": {
	            "shape": "S4i"
	          }
	        }
	      }
	    },
	    "UpdateUserAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserAttributes",
	          "AccessToken"
	        ],
	        "members": {
	          "UserAttributes": {
	            "shape": "Sj"
	          },
	          "AccessToken": {
	            "shape": "S1v"
	          },
	          "ClientMetadata": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CodeDeliveryDetailsList": {
	            "type": "list",
	            "member": {
	              "shape": "S8g"
	            }
	          }
	        }
	      },
	      "authtype": "none"
	    },
	    "UpdateUserPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "Policies": {
	            "shape": "S4u"
	          },
	          "LambdaConfig": {
	            "shape": "S4y"
	          },
	          "AutoVerifiedAttributes": {
	            "shape": "S53"
	          },
	          "SmsVerificationMessage": {},
	          "EmailVerificationMessage": {},
	          "EmailVerificationSubject": {},
	          "VerificationMessageTemplate": {
	            "shape": "S5c"
	          },
	          "SmsAuthenticationMessage": {},
	          "UserAttributeUpdateSettings": {
	            "shape": "S5h"
	          },
	          "MfaConfiguration": {},
	          "DeviceConfiguration": {
	            "shape": "S5j"
	          },
	          "EmailConfiguration": {
	            "shape": "S5k"
	          },
	          "SmsConfiguration": {
	            "shape": "S5o"
	          },
	          "UserPoolTags": {
	            "shape": "S5q"
	          },
	          "AdminCreateUserConfig": {
	            "shape": "S5t"
	          },
	          "UserPoolAddOns": {
	            "shape": "S5x"
	          },
	          "AccountRecoverySetting": {
	            "shape": "S60"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateUserPoolClient": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserPoolId",
	          "ClientId"
	        ],
	        "members": {
	          "UserPoolId": {},
	          "ClientId": {
	            "shape": "S1j"
	          },
	          "ClientName": {},
	          "RefreshTokenValidity": {
	            "type": "integer"
	          },
	          "AccessTokenValidity": {
	            "type": "integer"
	          },
	          "IdTokenValidity": {
	            "type": "integer"
	          },
	          "TokenValidityUnits": {
	            "shape": "S6f"
	          },
	          "ReadAttributes": {
	            "shape": "S6h"
	          },
	          "WriteAttributes": {
	            "shape": "S6h"
	          },
	          "ExplicitAuthFlows": {
	            "shape": "S6j"
	          },
	          "SupportedIdentityProviders": {
	            "shape": "S6l"
	          },
	          "CallbackURLs": {
	            "shape": "S6m"
	          },
	          "LogoutURLs": {
	            "shape": "S6o"
	          },
	          "DefaultRedirectURI": {},
	          "AllowedOAuthFlows": {
	            "shape": "S6p"
	          },
	          "AllowedOAuthScopes": {
	            "shape": "S6r"
	          },
	          "AllowedOAuthFlowsUserPoolClient": {
	            "type": "boolean"
	          },
	          "AnalyticsConfiguration": {
	            "shape": "S6t"
	          },
	          "PreventUserExistenceErrors": {},
	          "EnableTokenRevocation": {
	            "type": "boolean"
	          },
	          "EnablePropagateAdditionalUserContextData": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserPoolClient": {
	            "shape": "S6x"
	          }
	        }
	      }
	    },
	    "UpdateUserPoolDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Domain",
	          "UserPoolId",
	          "CustomDomainConfig"
	        ],
	        "members": {
	          "Domain": {},
	          "UserPoolId": {},
	          "CustomDomainConfig": {
	            "shape": "S70"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CloudFrontDomain": {}
	        }
	      }
	    },
	    "VerifySoftwareToken": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserCode"
	        ],
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          },
	          "Session": {},
	          "UserCode": {},
	          "FriendlyDeviceName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {},
	          "Session": {}
	        }
	      }
	    },
	    "VerifyUserAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessToken",
	          "AttributeName",
	          "Code"
	        ],
	        "members": {
	          "AccessToken": {
	            "shape": "S1v"
	          },
	          "AttributeName": {},
	          "Code": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "authtype": "none"
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "AttributeDataType": {},
	        "DeveloperOnlyAttribute": {
	          "type": "boolean"
	        },
	        "Mutable": {
	          "type": "boolean"
	        },
	        "Required": {
	          "type": "boolean"
	        },
	        "NumberAttributeConstraints": {
	          "type": "structure",
	          "members": {
	            "MinValue": {},
	            "MaxValue": {}
	          }
	        },
	        "StringAttributeConstraints": {
	          "type": "structure",
	          "members": {
	            "MinLength": {},
	            "MaxLength": {}
	          }
	        }
	      }
	    },
	    "Sd": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Sg": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sj": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Value": {
	            "type": "string",
	            "sensitive": true
	          }
	        }
	      }
	    },
	    "Sn": {
	      "type": "string",
	      "sensitive": true
	    },
	    "St": {
	      "type": "structure",
	      "members": {
	        "Username": {
	          "shape": "Sd"
	        },
	        "Attributes": {
	          "shape": "Sj"
	        },
	        "UserCreateDate": {
	          "type": "timestamp"
	        },
	        "UserLastModifiedDate": {
	          "type": "timestamp"
	        },
	        "Enabled": {
	          "type": "boolean"
	        },
	        "UserStatus": {},
	        "MFAOptions": {
	          "shape": "Sw"
	        }
	      }
	    },
	    "Sw": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "DeliveryMedium": {},
	          "AttributeName": {}
	        }
	      }
	    },
	    "S10": {
	      "type": "list",
	      "member": {}
	    },
	    "S13": {
	      "type": "structure",
	      "members": {
	        "ProviderName": {},
	        "ProviderAttributeName": {},
	        "ProviderAttributeValue": {}
	      }
	    },
	    "S1e": {
	      "type": "structure",
	      "members": {
	        "DeviceKey": {},
	        "DeviceAttributes": {
	          "shape": "Sj"
	        },
	        "DeviceCreateDate": {
	          "type": "timestamp"
	        },
	        "DeviceLastModifiedDate": {
	          "type": "timestamp"
	        },
	        "DeviceLastAuthenticatedDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S1h": {
	      "type": "list",
	      "member": {}
	    },
	    "S1j": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S1l": {
	      "type": "map",
	      "key": {},
	      "value": {},
	      "sensitive": true
	    },
	    "S1m": {
	      "type": "structure",
	      "members": {
	        "AnalyticsEndpointId": {}
	      }
	    },
	    "S1n": {
	      "type": "structure",
	      "required": [
	        "IpAddress",
	        "ServerName",
	        "ServerPath",
	        "HttpHeaders"
	      ],
	      "members": {
	        "IpAddress": {},
	        "ServerName": {},
	        "ServerPath": {},
	        "HttpHeaders": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "headerName": {},
	              "headerValue": {}
	            }
	          }
	        },
	        "EncodedData": {}
	      }
	    },
	    "S1t": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S1u": {
	      "type": "structure",
	      "members": {
	        "AccessToken": {
	          "shape": "S1v"
	        },
	        "ExpiresIn": {
	          "type": "integer"
	        },
	        "TokenType": {},
	        "RefreshToken": {
	          "shape": "S1v"
	        },
	        "IdToken": {
	          "shape": "S1v"
	        },
	        "NewDeviceMetadata": {
	          "type": "structure",
	          "members": {
	            "DeviceKey": {},
	            "DeviceGroupKey": {}
	          }
	        }
	      }
	    },
	    "S1v": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S24": {
	      "type": "list",
	      "member": {
	        "shape": "S1e"
	      }
	    },
	    "S28": {
	      "type": "list",
	      "member": {
	        "shape": "S29"
	      }
	    },
	    "S29": {
	      "type": "structure",
	      "members": {
	        "GroupName": {},
	        "UserPoolId": {},
	        "Description": {},
	        "RoleArn": {},
	        "Precedence": {
	          "type": "integer"
	        },
	        "LastModifiedDate": {
	          "type": "timestamp"
	        },
	        "CreationDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S2y": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S31": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "PreferredMfa": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S32": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "PreferredMfa": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S3s": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S3u": {
	      "type": "structure",
	      "members": {
	        "IpAddress": {},
	        "EncodedData": {}
	      }
	    },
	    "S43": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S44": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S46": {
	      "type": "list",
	      "member": {}
	    },
	    "S49": {
	      "type": "structure",
	      "members": {
	        "UserPoolId": {},
	        "ProviderName": {},
	        "ProviderType": {},
	        "ProviderDetails": {
	          "shape": "S43"
	        },
	        "AttributeMapping": {
	          "shape": "S44"
	        },
	        "IdpIdentifiers": {
	          "shape": "S46"
	        },
	        "LastModifiedDate": {
	          "type": "timestamp"
	        },
	        "CreationDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S4d": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "ScopeName",
	          "ScopeDescription"
	        ],
	        "members": {
	          "ScopeName": {},
	          "ScopeDescription": {}
	        }
	      }
	    },
	    "S4i": {
	      "type": "structure",
	      "members": {
	        "UserPoolId": {},
	        "Identifier": {},
	        "Name": {},
	        "Scopes": {
	          "shape": "S4d"
	        }
	      }
	    },
	    "S4m": {
	      "type": "structure",
	      "members": {
	        "JobName": {},
	        "JobId": {},
	        "UserPoolId": {},
	        "PreSignedUrl": {},
	        "CreationDate": {
	          "type": "timestamp"
	        },
	        "StartDate": {
	          "type": "timestamp"
	        },
	        "CompletionDate": {
	          "type": "timestamp"
	        },
	        "Status": {},
	        "CloudWatchLogsRoleArn": {},
	        "ImportedUsers": {
	          "type": "long"
	        },
	        "SkippedUsers": {
	          "type": "long"
	        },
	        "FailedUsers": {
	          "type": "long"
	        },
	        "CompletionMessage": {}
	      }
	    },
	    "S4u": {
	      "type": "structure",
	      "members": {
	        "PasswordPolicy": {
	          "type": "structure",
	          "members": {
	            "MinimumLength": {
	              "type": "integer"
	            },
	            "RequireUppercase": {
	              "type": "boolean"
	            },
	            "RequireLowercase": {
	              "type": "boolean"
	            },
	            "RequireNumbers": {
	              "type": "boolean"
	            },
	            "RequireSymbols": {
	              "type": "boolean"
	            },
	            "TemporaryPasswordValidityDays": {
	              "type": "integer"
	            }
	          }
	        }
	      }
	    },
	    "S4y": {
	      "type": "structure",
	      "members": {
	        "PreSignUp": {},
	        "CustomMessage": {},
	        "PostConfirmation": {},
	        "PreAuthentication": {},
	        "PostAuthentication": {},
	        "DefineAuthChallenge": {},
	        "CreateAuthChallenge": {},
	        "VerifyAuthChallengeResponse": {},
	        "PreTokenGeneration": {},
	        "UserMigration": {},
	        "CustomSMSSender": {
	          "type": "structure",
	          "required": [
	            "LambdaVersion",
	            "LambdaArn"
	          ],
	          "members": {
	            "LambdaVersion": {},
	            "LambdaArn": {}
	          }
	        },
	        "CustomEmailSender": {
	          "type": "structure",
	          "required": [
	            "LambdaVersion",
	            "LambdaArn"
	          ],
	          "members": {
	            "LambdaVersion": {},
	            "LambdaArn": {}
	          }
	        },
	        "KMSKeyID": {}
	      }
	    },
	    "S53": {
	      "type": "list",
	      "member": {}
	    },
	    "S55": {
	      "type": "list",
	      "member": {}
	    },
	    "S57": {
	      "type": "list",
	      "member": {}
	    },
	    "S5c": {
	      "type": "structure",
	      "members": {
	        "SmsMessage": {},
	        "EmailMessage": {},
	        "EmailSubject": {},
	        "EmailMessageByLink": {},
	        "EmailSubjectByLink": {},
	        "DefaultEmailOption": {}
	      }
	    },
	    "S5h": {
	      "type": "structure",
	      "members": {
	        "AttributesRequireVerificationBeforeUpdate": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S5j": {
	      "type": "structure",
	      "members": {
	        "ChallengeRequiredOnNewDevice": {
	          "type": "boolean"
	        },
	        "DeviceOnlyRememberedOnUserPrompt": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S5k": {
	      "type": "structure",
	      "members": {
	        "SourceArn": {},
	        "ReplyToEmailAddress": {},
	        "EmailSendingAccount": {},
	        "From": {},
	        "ConfigurationSet": {}
	      }
	    },
	    "S5o": {
	      "type": "structure",
	      "required": [
	        "SnsCallerArn"
	      ],
	      "members": {
	        "SnsCallerArn": {},
	        "ExternalId": {},
	        "SnsRegion": {}
	      }
	    },
	    "S5q": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S5t": {
	      "type": "structure",
	      "members": {
	        "AllowAdminCreateUserOnly": {
	          "type": "boolean"
	        },
	        "UnusedAccountValidityDays": {
	          "type": "integer"
	        },
	        "InviteMessageTemplate": {
	          "type": "structure",
	          "members": {
	            "SMSMessage": {},
	            "EmailMessage": {},
	            "EmailSubject": {}
	          }
	        }
	      }
	    },
	    "S5w": {
	      "type": "list",
	      "member": {
	        "shape": "S4"
	      }
	    },
	    "S5x": {
	      "type": "structure",
	      "required": [
	        "AdvancedSecurityMode"
	      ],
	      "members": {
	        "AdvancedSecurityMode": {}
	      }
	    },
	    "S5z": {
	      "type": "structure",
	      "required": [
	        "CaseSensitive"
	      ],
	      "members": {
	        "CaseSensitive": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S60": {
	      "type": "structure",
	      "members": {
	        "RecoveryMechanisms": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Priority",
	              "Name"
	            ],
	            "members": {
	              "Priority": {
	                "type": "integer"
	              },
	              "Name": {}
	            }
	          }
	        }
	      }
	    },
	    "S66": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Name": {},
	        "Policies": {
	          "shape": "S4u"
	        },
	        "LambdaConfig": {
	          "shape": "S4y"
	        },
	        "Status": {},
	        "LastModifiedDate": {
	          "type": "timestamp"
	        },
	        "CreationDate": {
	          "type": "timestamp"
	        },
	        "SchemaAttributes": {
	          "shape": "S5w"
	        },
	        "AutoVerifiedAttributes": {
	          "shape": "S53"
	        },
	        "AliasAttributes": {
	          "shape": "S55"
	        },
	        "UsernameAttributes": {
	          "shape": "S57"
	        },
	        "SmsVerificationMessage": {},
	        "EmailVerificationMessage": {},
	        "EmailVerificationSubject": {},
	        "VerificationMessageTemplate": {
	          "shape": "S5c"
	        },
	        "SmsAuthenticationMessage": {},
	        "UserAttributeUpdateSettings": {
	          "shape": "S5h"
	        },
	        "MfaConfiguration": {},
	        "DeviceConfiguration": {
	          "shape": "S5j"
	        },
	        "EstimatedNumberOfUsers": {
	          "type": "integer"
	        },
	        "EmailConfiguration": {
	          "shape": "S5k"
	        },
	        "SmsConfiguration": {
	          "shape": "S5o"
	        },
	        "UserPoolTags": {
	          "shape": "S5q"
	        },
	        "SmsConfigurationFailure": {},
	        "EmailConfigurationFailure": {},
	        "Domain": {},
	        "CustomDomain": {},
	        "AdminCreateUserConfig": {
	          "shape": "S5t"
	        },
	        "UserPoolAddOns": {
	          "shape": "S5x"
	        },
	        "UsernameConfiguration": {
	          "shape": "S5z"
	        },
	        "Arn": {},
	        "AccountRecoverySetting": {
	          "shape": "S60"
	        }
	      }
	    },
	    "S6f": {
	      "type": "structure",
	      "members": {
	        "AccessToken": {},
	        "IdToken": {},
	        "RefreshToken": {}
	      }
	    },
	    "S6h": {
	      "type": "list",
	      "member": {}
	    },
	    "S6j": {
	      "type": "list",
	      "member": {}
	    },
	    "S6l": {
	      "type": "list",
	      "member": {}
	    },
	    "S6m": {
	      "type": "list",
	      "member": {}
	    },
	    "S6o": {
	      "type": "list",
	      "member": {}
	    },
	    "S6p": {
	      "type": "list",
	      "member": {}
	    },
	    "S6r": {
	      "type": "list",
	      "member": {}
	    },
	    "S6t": {
	      "type": "structure",
	      "members": {
	        "ApplicationId": {},
	        "ApplicationArn": {},
	        "RoleArn": {},
	        "ExternalId": {},
	        "UserDataShared": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S6x": {
	      "type": "structure",
	      "members": {
	        "UserPoolId": {},
	        "ClientName": {},
	        "ClientId": {
	          "shape": "S1j"
	        },
	        "ClientSecret": {
	          "shape": "S6y"
	        },
	        "LastModifiedDate": {
	          "type": "timestamp"
	        },
	        "CreationDate": {
	          "type": "timestamp"
	        },
	        "RefreshTokenValidity": {
	          "type": "integer"
	        },
	        "AccessTokenValidity": {
	          "type": "integer"
	        },
	        "IdTokenValidity": {
	          "type": "integer"
	        },
	        "TokenValidityUnits": {
	          "shape": "S6f"
	        },
	        "ReadAttributes": {
	          "shape": "S6h"
	        },
	        "WriteAttributes": {
	          "shape": "S6h"
	        },
	        "ExplicitAuthFlows": {
	          "shape": "S6j"
	        },
	        "SupportedIdentityProviders": {
	          "shape": "S6l"
	        },
	        "CallbackURLs": {
	          "shape": "S6m"
	        },
	        "LogoutURLs": {
	          "shape": "S6o"
	        },
	        "DefaultRedirectURI": {},
	        "AllowedOAuthFlows": {
	          "shape": "S6p"
	        },
	        "AllowedOAuthScopes": {
	          "shape": "S6r"
	        },
	        "AllowedOAuthFlowsUserPoolClient": {
	          "type": "boolean"
	        },
	        "AnalyticsConfiguration": {
	          "shape": "S6t"
	        },
	        "PreventUserExistenceErrors": {},
	        "EnableTokenRevocation": {
	          "type": "boolean"
	        },
	        "EnablePropagateAdditionalUserContextData": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S6y": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S70": {
	      "type": "structure",
	      "required": [
	        "CertificateArn"
	      ],
	      "members": {
	        "CertificateArn": {}
	      }
	    },
	    "S7i": {
	      "type": "structure",
	      "members": {
	        "UserPoolId": {},
	        "ClientId": {
	          "shape": "S1j"
	        },
	        "CompromisedCredentialsRiskConfiguration": {
	          "shape": "S7j"
	        },
	        "AccountTakeoverRiskConfiguration": {
	          "shape": "S7o"
	        },
	        "RiskExceptionConfiguration": {
	          "shape": "S7x"
	        },
	        "LastModifiedDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S7j": {
	      "type": "structure",
	      "required": [
	        "Actions"
	      ],
	      "members": {
	        "EventFilter": {
	          "type": "list",
	          "member": {}
	        },
	        "Actions": {
	          "type": "structure",
	          "required": [
	            "EventAction"
	          ],
	          "members": {
	            "EventAction": {}
	          }
	        }
	      }
	    },
	    "S7o": {
	      "type": "structure",
	      "required": [
	        "Actions"
	      ],
	      "members": {
	        "NotifyConfiguration": {
	          "type": "structure",
	          "required": [
	            "SourceArn"
	          ],
	          "members": {
	            "From": {},
	            "ReplyTo": {},
	            "SourceArn": {},
	            "BlockEmail": {
	              "shape": "S7q"
	            },
	            "NoActionEmail": {
	              "shape": "S7q"
	            },
	            "MfaEmail": {
	              "shape": "S7q"
	            }
	          }
	        },
	        "Actions": {
	          "type": "structure",
	          "members": {
	            "LowAction": {
	              "shape": "S7u"
	            },
	            "MediumAction": {
	              "shape": "S7u"
	            },
	            "HighAction": {
	              "shape": "S7u"
	            }
	          }
	        }
	      }
	    },
	    "S7q": {
	      "type": "structure",
	      "required": [
	        "Subject"
	      ],
	      "members": {
	        "Subject": {},
	        "HtmlBody": {},
	        "TextBody": {}
	      }
	    },
	    "S7u": {
	      "type": "structure",
	      "required": [
	        "Notify",
	        "EventAction"
	      ],
	      "members": {
	        "Notify": {
	          "type": "boolean"
	        },
	        "EventAction": {}
	      }
	    },
	    "S7x": {
	      "type": "structure",
	      "members": {
	        "BlockedIPRangeList": {
	          "type": "list",
	          "member": {}
	        },
	        "SkippedIPRangeList": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S8g": {
	      "type": "structure",
	      "members": {
	        "Destination": {},
	        "DeliveryMedium": {},
	        "AttributeName": {}
	      }
	    },
	    "S8u": {
	      "type": "structure",
	      "members": {
	        "UserPoolId": {},
	        "ClientId": {
	          "shape": "S1j"
	        },
	        "ImageUrl": {},
	        "CSS": {},
	        "CSSVersion": {},
	        "LastModifiedDate": {
	          "type": "timestamp"
	        },
	        "CreationDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S94": {
	      "type": "structure",
	      "members": {
	        "SmsAuthenticationMessage": {},
	        "SmsConfiguration": {
	          "shape": "S5o"
	        }
	      }
	    },
	    "S95": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Sa7": {
	      "type": "list",
	      "member": {
	        "shape": "St"
	      }
	    }
	  }
	}
	},{}],56:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "AdminListGroupsForUser": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "Groups"
	    },
	    "AdminListUserAuthEvents": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "AuthEvents"
	    },
	    "ListGroups": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "Groups"
	    },
	    "ListIdentityProviders": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Providers"
	    },
	    "ListResourceServers": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ResourceServers"
	    },
	    "ListUserPoolClients": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "UserPoolClients"
	    },
	    "ListUserPools": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "UserPools"
	    },
	    "ListUsers": {
	      "input_token": "PaginationToken",
	      "limit_key": "Limit",
	      "output_token": "PaginationToken",
	      "result_key": "Users"
	    },
	    "ListUsersInGroup": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "Users"
	    }
	  }
	}
	},{}],57:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-06-30",
	    "endpointPrefix": "cognito-sync",
	    "jsonVersion": "1.1",
	    "protocol": "rest-json",
	    "serviceFullName": "Amazon Cognito Sync",
	    "serviceId": "Cognito Sync",
	    "signatureVersion": "v4",
	    "uid": "cognito-sync-2014-06-30"
	  },
	  "operations": {
	    "BulkPublish": {
	      "http": {
	        "requestUri": "/identitypools/{IdentityPoolId}/bulkpublish",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityPoolId": {}
	        }
	      }
	    },
	    "DeleteDataset": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "IdentityId",
	          "DatasetName"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          },
	          "IdentityId": {
	            "location": "uri",
	            "locationName": "IdentityId"
	          },
	          "DatasetName": {
	            "location": "uri",
	            "locationName": "DatasetName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Dataset": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "DescribeDataset": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "IdentityId",
	          "DatasetName"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          },
	          "IdentityId": {
	            "location": "uri",
	            "locationName": "IdentityId"
	          },
	          "DatasetName": {
	            "location": "uri",
	            "locationName": "DatasetName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Dataset": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "DescribeIdentityPoolUsage": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/identitypools/{IdentityPoolId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityPoolUsage": {
	            "shape": "Sg"
	          }
	        }
	      }
	    },
	    "DescribeIdentityUsage": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "IdentityId"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          },
	          "IdentityId": {
	            "location": "uri",
	            "locationName": "IdentityId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityUsage": {
	            "type": "structure",
	            "members": {
	              "IdentityId": {},
	              "IdentityPoolId": {},
	              "LastModifiedDate": {
	                "type": "timestamp"
	              },
	              "DatasetCount": {
	                "type": "integer"
	              },
	              "DataStorage": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetBulkPublishDetails": {
	      "http": {
	        "requestUri": "/identitypools/{IdentityPoolId}/getBulkPublishDetails",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityPoolId": {},
	          "BulkPublishStartTime": {
	            "type": "timestamp"
	          },
	          "BulkPublishCompleteTime": {
	            "type": "timestamp"
	          },
	          "BulkPublishStatus": {},
	          "FailureMessage": {}
	        }
	      }
	    },
	    "GetCognitoEvents": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/identitypools/{IdentityPoolId}/events",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Events": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "GetIdentityPoolConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/identitypools/{IdentityPoolId}/configuration",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityPoolId": {},
	          "PushSync": {
	            "shape": "Sv"
	          },
	          "CognitoStreams": {
	            "shape": "Sz"
	          }
	        }
	      }
	    },
	    "ListDatasets": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityId",
	          "IdentityPoolId"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          },
	          "IdentityId": {
	            "location": "uri",
	            "locationName": "IdentityId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Datasets": {
	            "type": "list",
	            "member": {
	              "shape": "S8"
	            }
	          },
	          "Count": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListIdentityPoolUsage": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/identitypools",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityPoolUsages": {
	            "type": "list",
	            "member": {
	              "shape": "Sg"
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Count": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListRecords": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/records",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "IdentityId",
	          "DatasetName"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          },
	          "IdentityId": {
	            "location": "uri",
	            "locationName": "IdentityId"
	          },
	          "DatasetName": {
	            "location": "uri",
	            "locationName": "DatasetName"
	          },
	          "LastSyncCount": {
	            "location": "querystring",
	            "locationName": "lastSyncCount",
	            "type": "long"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "SyncSessionToken": {
	            "location": "querystring",
	            "locationName": "syncSessionToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Records": {
	            "shape": "S1c"
	          },
	          "NextToken": {},
	          "Count": {
	            "type": "integer"
	          },
	          "DatasetSyncCount": {
	            "type": "long"
	          },
	          "LastModifiedBy": {},
	          "MergedDatasetNames": {
	            "type": "list",
	            "member": {}
	          },
	          "DatasetExists": {
	            "type": "boolean"
	          },
	          "DatasetDeletedAfterRequestedSyncCount": {
	            "type": "boolean"
	          },
	          "SyncSessionToken": {}
	        }
	      }
	    },
	    "RegisterDevice": {
	      "http": {
	        "requestUri": "/identitypools/{IdentityPoolId}/identity/{IdentityId}/device",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "IdentityId",
	          "Platform",
	          "Token"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          },
	          "IdentityId": {
	            "location": "uri",
	            "locationName": "IdentityId"
	          },
	          "Platform": {},
	          "Token": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeviceId": {}
	        }
	      }
	    },
	    "SetCognitoEvents": {
	      "http": {
	        "requestUri": "/identitypools/{IdentityPoolId}/events",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "Events"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          },
	          "Events": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "SetIdentityPoolConfiguration": {
	      "http": {
	        "requestUri": "/identitypools/{IdentityPoolId}/configuration",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          },
	          "PushSync": {
	            "shape": "Sv"
	          },
	          "CognitoStreams": {
	            "shape": "Sz"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IdentityPoolId": {},
	          "PushSync": {
	            "shape": "Sv"
	          },
	          "CognitoStreams": {
	            "shape": "Sz"
	          }
	        }
	      }
	    },
	    "SubscribeToDataset": {
	      "http": {
	        "requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "IdentityId",
	          "DatasetName",
	          "DeviceId"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          },
	          "IdentityId": {
	            "location": "uri",
	            "locationName": "IdentityId"
	          },
	          "DatasetName": {
	            "location": "uri",
	            "locationName": "DatasetName"
	          },
	          "DeviceId": {
	            "location": "uri",
	            "locationName": "DeviceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UnsubscribeFromDataset": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "IdentityId",
	          "DatasetName",
	          "DeviceId"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          },
	          "IdentityId": {
	            "location": "uri",
	            "locationName": "IdentityId"
	          },
	          "DatasetName": {
	            "location": "uri",
	            "locationName": "DatasetName"
	          },
	          "DeviceId": {
	            "location": "uri",
	            "locationName": "DeviceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateRecords": {
	      "http": {
	        "requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityPoolId",
	          "IdentityId",
	          "DatasetName",
	          "SyncSessionToken"
	        ],
	        "members": {
	          "IdentityPoolId": {
	            "location": "uri",
	            "locationName": "IdentityPoolId"
	          },
	          "IdentityId": {
	            "location": "uri",
	            "locationName": "IdentityId"
	          },
	          "DatasetName": {
	            "location": "uri",
	            "locationName": "DatasetName"
	          },
	          "DeviceId": {},
	          "RecordPatches": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Op",
	                "Key",
	                "SyncCount"
	              ],
	              "members": {
	                "Op": {},
	                "Key": {},
	                "Value": {},
	                "SyncCount": {
	                  "type": "long"
	                },
	                "DeviceLastModifiedDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "SyncSessionToken": {},
	          "ClientContext": {
	            "location": "header",
	            "locationName": "x-amz-Client-Context"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Records": {
	            "shape": "S1c"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S8": {
	      "type": "structure",
	      "members": {
	        "IdentityId": {},
	        "DatasetName": {},
	        "CreationDate": {
	          "type": "timestamp"
	        },
	        "LastModifiedDate": {
	          "type": "timestamp"
	        },
	        "LastModifiedBy": {},
	        "DataStorage": {
	          "type": "long"
	        },
	        "NumRecords": {
	          "type": "long"
	        }
	      }
	    },
	    "Sg": {
	      "type": "structure",
	      "members": {
	        "IdentityPoolId": {},
	        "SyncSessionsCount": {
	          "type": "long"
	        },
	        "DataStorage": {
	          "type": "long"
	        },
	        "LastModifiedDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sq": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sv": {
	      "type": "structure",
	      "members": {
	        "ApplicationArns": {
	          "type": "list",
	          "member": {}
	        },
	        "RoleArn": {}
	      }
	    },
	    "Sz": {
	      "type": "structure",
	      "members": {
	        "StreamName": {},
	        "RoleArn": {},
	        "StreamingStatus": {}
	      }
	    },
	    "S1c": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {},
	          "SyncCount": {
	            "type": "long"
	          },
	          "LastModifiedDate": {
	            "type": "timestamp"
	          },
	          "LastModifiedBy": {},
	          "DeviceLastModifiedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    }
	  }
	}
	},{}],58:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],59:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-11-27",
	    "endpointPrefix": "comprehend",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Comprehend",
	    "serviceId": "Comprehend",
	    "signatureVersion": "v4",
	    "signingName": "comprehend",
	    "targetPrefix": "Comprehend_20171127",
	    "uid": "comprehend-2017-11-27"
	  },
	  "operations": {
	    "BatchDetectDominantLanguage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TextList"
	        ],
	        "members": {
	          "TextList": {
	            "shape": "S2"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResultList",
	          "ErrorList"
	        ],
	        "members": {
	          "ResultList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Index": {
	                  "type": "integer"
	                },
	                "Languages": {
	                  "shape": "S8"
	                }
	              }
	            }
	          },
	          "ErrorList": {
	            "shape": "Sc"
	          }
	        },
	        "sensitive": true
	      }
	    },
	    "BatchDetectEntities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TextList",
	          "LanguageCode"
	        ],
	        "members": {
	          "TextList": {
	            "shape": "S2"
	          },
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResultList",
	          "ErrorList"
	        ],
	        "members": {
	          "ResultList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Index": {
	                  "type": "integer"
	                },
	                "Entities": {
	                  "shape": "Sj"
	                }
	              }
	            }
	          },
	          "ErrorList": {
	            "shape": "Sc"
	          }
	        },
	        "sensitive": true
	      }
	    },
	    "BatchDetectKeyPhrases": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TextList",
	          "LanguageCode"
	        ],
	        "members": {
	          "TextList": {
	            "shape": "S2"
	          },
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResultList",
	          "ErrorList"
	        ],
	        "members": {
	          "ResultList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Index": {
	                  "type": "integer"
	                },
	                "KeyPhrases": {
	                  "shape": "Sq"
	                }
	              }
	            }
	          },
	          "ErrorList": {
	            "shape": "Sc"
	          }
	        },
	        "sensitive": true
	      }
	    },
	    "BatchDetectSentiment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TextList",
	          "LanguageCode"
	        ],
	        "members": {
	          "TextList": {
	            "shape": "S2"
	          },
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResultList",
	          "ErrorList"
	        ],
	        "members": {
	          "ResultList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Index": {
	                  "type": "integer"
	                },
	                "Sentiment": {},
	                "SentimentScore": {
	                  "shape": "Sx"
	                }
	              }
	            }
	          },
	          "ErrorList": {
	            "shape": "Sc"
	          }
	        },
	        "sensitive": true
	      }
	    },
	    "BatchDetectSyntax": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TextList",
	          "LanguageCode"
	        ],
	        "members": {
	          "TextList": {
	            "shape": "S2"
	          },
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResultList",
	          "ErrorList"
	        ],
	        "members": {
	          "ResultList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Index": {
	                  "type": "integer"
	                },
	                "SyntaxTokens": {
	                  "shape": "S13"
	                }
	              }
	            }
	          },
	          "ErrorList": {
	            "shape": "Sc"
	          }
	        },
	        "sensitive": true
	      }
	    },
	    "ClassifyDocument": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text",
	          "EndpointArn"
	        ],
	        "members": {
	          "Text": {
	            "shape": "S3"
	          },
	          "EndpointArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Classes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Score": {
	                  "type": "float"
	                }
	              }
	            }
	          },
	          "Labels": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Score": {
	                  "type": "float"
	                }
	              }
	            }
	          }
	        },
	        "sensitive": true
	      }
	    },
	    "ContainsPiiEntities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text",
	          "LanguageCode"
	        ],
	        "members": {
	          "Text": {},
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Labels": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Score": {
	                  "type": "float"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "CreateDocumentClassifier": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentClassifierName",
	          "DataAccessRoleArn",
	          "InputDataConfig",
	          "LanguageCode"
	        ],
	        "members": {
	          "DocumentClassifierName": {},
	          "VersionName": {},
	          "DataAccessRoleArn": {},
	          "Tags": {
	            "shape": "S1n"
	          },
	          "InputDataConfig": {
	            "shape": "S1r"
	          },
	          "OutputDataConfig": {
	            "shape": "S21"
	          },
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "LanguageCode": {},
	          "VolumeKmsKeyId": {},
	          "VpcConfig": {
	            "shape": "S24"
	          },
	          "Mode": {},
	          "ModelKmsKeyId": {},
	          "ModelPolicy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DocumentClassifierArn": {}
	        }
	      }
	    },
	    "CreateEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EndpointName",
	          "ModelArn",
	          "DesiredInferenceUnits"
	        ],
	        "members": {
	          "EndpointName": {},
	          "ModelArn": {},
	          "DesiredInferenceUnits": {
	            "type": "integer"
	          },
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "Tags": {
	            "shape": "S1n"
	          },
	          "DataAccessRoleArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EndpointArn": {}
	        }
	      }
	    },
	    "CreateEntityRecognizer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RecognizerName",
	          "DataAccessRoleArn",
	          "InputDataConfig",
	          "LanguageCode"
	        ],
	        "members": {
	          "RecognizerName": {},
	          "VersionName": {},
	          "DataAccessRoleArn": {},
	          "Tags": {
	            "shape": "S1n"
	          },
	          "InputDataConfig": {
	            "shape": "S2k"
	          },
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "LanguageCode": {},
	          "VolumeKmsKeyId": {},
	          "VpcConfig": {
	            "shape": "S24"
	          },
	          "ModelKmsKeyId": {},
	          "ModelPolicy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EntityRecognizerArn": {}
	        }
	      }
	    },
	    "DeleteDocumentClassifier": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentClassifierArn"
	        ],
	        "members": {
	          "DocumentClassifierArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EndpointArn"
	        ],
	        "members": {
	          "EndpointArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteEntityRecognizer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EntityRecognizerArn"
	        ],
	        "members": {
	          "EntityRecognizerArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "PolicyRevisionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeDocumentClassificationJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DocumentClassificationJobProperties": {
	            "shape": "S38"
	          }
	        }
	      }
	    },
	    "DescribeDocumentClassifier": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentClassifierArn"
	        ],
	        "members": {
	          "DocumentClassifierArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DocumentClassifierProperties": {
	            "shape": "S3n"
	          }
	        }
	      }
	    },
	    "DescribeDominantLanguageDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DominantLanguageDetectionJobProperties": {
	            "shape": "S3u"
	          }
	        }
	      }
	    },
	    "DescribeEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EndpointArn"
	        ],
	        "members": {
	          "EndpointArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EndpointProperties": {
	            "shape": "S3x"
	          }
	        }
	      }
	    },
	    "DescribeEntitiesDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EntitiesDetectionJobProperties": {
	            "shape": "S41"
	          }
	        }
	      }
	    },
	    "DescribeEntityRecognizer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EntityRecognizerArn"
	        ],
	        "members": {
	          "EntityRecognizerArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EntityRecognizerProperties": {
	            "shape": "S44"
	          }
	        }
	      }
	    },
	    "DescribeEventsDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EventsDetectionJobProperties": {
	            "shape": "S4c"
	          }
	        }
	      }
	    },
	    "DescribeKeyPhrasesDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyPhrasesDetectionJobProperties": {
	            "shape": "S4h"
	          }
	        }
	      }
	    },
	    "DescribePiiEntitiesDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PiiEntitiesDetectionJobProperties": {
	            "shape": "S4k"
	          }
	        }
	      }
	    },
	    "DescribeResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourcePolicy": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModifiedTime": {
	            "type": "timestamp"
	          },
	          "PolicyRevisionId": {}
	        }
	      }
	    },
	    "DescribeSentimentDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SentimentDetectionJobProperties": {
	            "shape": "S4v"
	          }
	        }
	      }
	    },
	    "DescribeTargetedSentimentDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TargetedSentimentDetectionJobProperties": {
	            "shape": "S4y"
	          }
	        }
	      }
	    },
	    "DescribeTopicsDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TopicsDetectionJobProperties": {
	            "shape": "S51"
	          }
	        }
	      }
	    },
	    "DetectDominantLanguage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text"
	        ],
	        "members": {
	          "Text": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Languages": {
	            "shape": "S8"
	          }
	        },
	        "sensitive": true
	      }
	    },
	    "DetectEntities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text"
	        ],
	        "members": {
	          "Text": {
	            "shape": "S3"
	          },
	          "LanguageCode": {},
	          "EndpointArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Entities": {
	            "shape": "Sj"
	          }
	        },
	        "sensitive": true
	      }
	    },
	    "DetectKeyPhrases": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text",
	          "LanguageCode"
	        ],
	        "members": {
	          "Text": {
	            "shape": "S3"
	          },
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyPhrases": {
	            "shape": "Sq"
	          }
	        },
	        "sensitive": true
	      }
	    },
	    "DetectPiiEntities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text",
	          "LanguageCode"
	        ],
	        "members": {
	          "Text": {},
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Entities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Score": {
	                  "type": "float"
	                },
	                "Type": {},
	                "BeginOffset": {
	                  "type": "integer"
	                },
	                "EndOffset": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DetectSentiment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text",
	          "LanguageCode"
	        ],
	        "members": {
	          "Text": {
	            "shape": "S3"
	          },
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Sentiment": {},
	          "SentimentScore": {
	            "shape": "Sx"
	          }
	        },
	        "sensitive": true
	      }
	    },
	    "DetectSyntax": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text",
	          "LanguageCode"
	        ],
	        "members": {
	          "Text": {
	            "shape": "S3"
	          },
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SyntaxTokens": {
	            "shape": "S13"
	          }
	        },
	        "sensitive": true
	      }
	    },
	    "ImportModel": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceModelArn"
	        ],
	        "members": {
	          "SourceModelArn": {},
	          "ModelName": {},
	          "VersionName": {},
	          "ModelKmsKeyId": {},
	          "DataAccessRoleArn": {},
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ModelArn": {}
	        }
	      }
	    },
	    "ListDocumentClassificationJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "JobName": {},
	              "JobStatus": {},
	              "SubmitTimeBefore": {
	                "type": "timestamp"
	              },
	              "SubmitTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DocumentClassificationJobPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S38"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListDocumentClassifierSummaries": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DocumentClassifierSummariesList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DocumentClassifierName": {},
	                "NumberOfVersions": {
	                  "type": "integer"
	                },
	                "LatestVersionCreatedAt": {
	                  "type": "timestamp"
	                },
	                "LatestVersionName": {},
	                "LatestVersionStatus": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListDocumentClassifiers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "DocumentClassifierName": {},
	              "SubmitTimeBefore": {
	                "type": "timestamp"
	              },
	              "SubmitTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DocumentClassifierPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S3n"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListDominantLanguageDetectionJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "JobName": {},
	              "JobStatus": {},
	              "SubmitTimeBefore": {
	                "type": "timestamp"
	              },
	              "SubmitTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DominantLanguageDetectionJobPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S3u"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListEndpoints": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "ModelArn": {},
	              "Status": {},
	              "CreationTimeBefore": {
	                "type": "timestamp"
	              },
	              "CreationTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EndpointPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S3x"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListEntitiesDetectionJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "JobName": {},
	              "JobStatus": {},
	              "SubmitTimeBefore": {
	                "type": "timestamp"
	              },
	              "SubmitTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EntitiesDetectionJobPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S41"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListEntityRecognizerSummaries": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EntityRecognizerSummariesList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "RecognizerName": {},
	                "NumberOfVersions": {
	                  "type": "integer"
	                },
	                "LatestVersionCreatedAt": {
	                  "type": "timestamp"
	                },
	                "LatestVersionName": {},
	                "LatestVersionStatus": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListEntityRecognizers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "RecognizerName": {},
	              "SubmitTimeBefore": {
	                "type": "timestamp"
	              },
	              "SubmitTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EntityRecognizerPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S44"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListEventsDetectionJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "JobName": {},
	              "JobStatus": {},
	              "SubmitTimeBefore": {
	                "type": "timestamp"
	              },
	              "SubmitTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EventsDetectionJobPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S4c"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListKeyPhrasesDetectionJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "JobName": {},
	              "JobStatus": {},
	              "SubmitTimeBefore": {
	                "type": "timestamp"
	              },
	              "SubmitTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyPhrasesDetectionJobPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S4h"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListPiiEntitiesDetectionJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "JobName": {},
	              "JobStatus": {},
	              "SubmitTimeBefore": {
	                "type": "timestamp"
	              },
	              "SubmitTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PiiEntitiesDetectionJobPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S4k"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListSentimentDetectionJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "JobName": {},
	              "JobStatus": {},
	              "SubmitTimeBefore": {
	                "type": "timestamp"
	              },
	              "SubmitTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SentimentDetectionJobPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S4v"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      }
	    },
	    "ListTargetedSentimentDetectionJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "JobName": {},
	              "JobStatus": {},
	              "SubmitTimeBefore": {
	                "type": "timestamp"
	              },
	              "SubmitTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TargetedSentimentDetectionJobPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S4y"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTopicsDetectionJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "JobName": {},
	              "JobStatus": {},
	              "SubmitTimeBefore": {
	                "type": "timestamp"
	              },
	              "SubmitTimeAfter": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TopicsDetectionJobPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S51"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PutResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "ResourcePolicy"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "ResourcePolicy": {},
	          "PolicyRevisionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PolicyRevisionId": {}
	        }
	      }
	    },
	    "StartDocumentClassificationJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentClassifierArn",
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn"
	        ],
	        "members": {
	          "JobName": {},
	          "DocumentClassifierArn": {},
	          "InputDataConfig": {
	            "shape": "S3e"
	          },
	          "OutputDataConfig": {
	            "shape": "S3k"
	          },
	          "DataAccessRoleArn": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "VolumeKmsKeyId": {},
	          "VpcConfig": {
	            "shape": "S24"
	          },
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobArn": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StartDominantLanguageDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S3e"
	          },
	          "OutputDataConfig": {
	            "shape": "S3k"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "VolumeKmsKeyId": {},
	          "VpcConfig": {
	            "shape": "S24"
	          },
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobArn": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StartEntitiesDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn",
	          "LanguageCode"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S3e"
	          },
	          "OutputDataConfig": {
	            "shape": "S3k"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "EntityRecognizerArn": {},
	          "LanguageCode": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "VolumeKmsKeyId": {},
	          "VpcConfig": {
	            "shape": "S24"
	          },
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobArn": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StartEventsDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn",
	          "LanguageCode",
	          "TargetEventTypes"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S3e"
	          },
	          "OutputDataConfig": {
	            "shape": "S3k"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "LanguageCode": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "TargetEventTypes": {
	            "shape": "S4d"
	          },
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobArn": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StartKeyPhrasesDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn",
	          "LanguageCode"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S3e"
	          },
	          "OutputDataConfig": {
	            "shape": "S3k"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "LanguageCode": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "VolumeKmsKeyId": {},
	          "VpcConfig": {
	            "shape": "S24"
	          },
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobArn": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StartPiiEntitiesDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "Mode",
	          "DataAccessRoleArn",
	          "LanguageCode"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S3e"
	          },
	          "OutputDataConfig": {
	            "shape": "S3k"
	          },
	          "Mode": {},
	          "RedactionConfig": {
	            "shape": "S4m"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "LanguageCode": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobArn": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StartSentimentDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn",
	          "LanguageCode"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S3e"
	          },
	          "OutputDataConfig": {
	            "shape": "S3k"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "LanguageCode": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "VolumeKmsKeyId": {},
	          "VpcConfig": {
	            "shape": "S24"
	          },
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobArn": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StartTargetedSentimentDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn",
	          "LanguageCode"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S3e"
	          },
	          "OutputDataConfig": {
	            "shape": "S3k"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "LanguageCode": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "VolumeKmsKeyId": {},
	          "VpcConfig": {
	            "shape": "S24"
	          },
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobArn": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StartTopicsDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S3e"
	          },
	          "OutputDataConfig": {
	            "shape": "S3k"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "NumberOfTopics": {
	            "type": "integer"
	          },
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "VolumeKmsKeyId": {},
	          "VpcConfig": {
	            "shape": "S24"
	          },
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobArn": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StopDominantLanguageDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StopEntitiesDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StopEventsDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StopKeyPhrasesDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StopPiiEntitiesDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StopSentimentDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StopTargetedSentimentDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StopTrainingDocumentClassifier": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentClassifierArn"
	        ],
	        "members": {
	          "DocumentClassifierArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "StopTrainingEntityRecognizer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EntityRecognizerArn"
	        ],
	        "members": {
	          "EntityRecognizerArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EndpointArn"
	        ],
	        "members": {
	          "EndpointArn": {},
	          "DesiredModelArn": {},
	          "DesiredInferenceUnits": {
	            "type": "integer"
	          },
	          "DesiredDataAccessRoleArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "list",
	      "member": {
	        "shape": "S3"
	      },
	      "sensitive": true
	    },
	    "S3": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S8": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "LanguageCode": {},
	          "Score": {
	            "type": "float"
	          }
	        }
	      }
	    },
	    "Sc": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Index": {
	            "type": "integer"
	          },
	          "ErrorCode": {},
	          "ErrorMessage": {}
	        }
	      }
	    },
	    "Sj": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Score": {
	            "type": "float"
	          },
	          "Type": {},
	          "Text": {},
	          "BeginOffset": {
	            "type": "integer"
	          },
	          "EndOffset": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "Sq": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Score": {
	            "type": "float"
	          },
	          "Text": {},
	          "BeginOffset": {
	            "type": "integer"
	          },
	          "EndOffset": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "Sx": {
	      "type": "structure",
	      "members": {
	        "Positive": {
	          "type": "float"
	        },
	        "Negative": {
	          "type": "float"
	        },
	        "Neutral": {
	          "type": "float"
	        },
	        "Mixed": {
	          "type": "float"
	        }
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "TokenId": {
	            "type": "integer"
	          },
	          "Text": {},
	          "BeginOffset": {
	            "type": "integer"
	          },
	          "EndOffset": {
	            "type": "integer"
	          },
	          "PartOfSpeech": {
	            "type": "structure",
	            "members": {
	              "Tag": {},
	              "Score": {
	                "type": "float"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1n": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S1r": {
	      "type": "structure",
	      "members": {
	        "DataFormat": {},
	        "S3Uri": {},
	        "TestS3Uri": {},
	        "LabelDelimiter": {},
	        "AugmentedManifests": {
	          "type": "list",
	          "member": {
	            "shape": "S1w"
	          }
	        }
	      }
	    },
	    "S1w": {
	      "type": "structure",
	      "required": [
	        "S3Uri",
	        "AttributeNames"
	      ],
	      "members": {
	        "S3Uri": {},
	        "Split": {},
	        "AttributeNames": {
	          "type": "list",
	          "member": {}
	        },
	        "AnnotationDataS3Uri": {},
	        "SourceDocumentsS3Uri": {},
	        "DocumentType": {}
	      }
	    },
	    "S21": {
	      "type": "structure",
	      "members": {
	        "S3Uri": {},
	        "KmsKeyId": {}
	      }
	    },
	    "S24": {
	      "type": "structure",
	      "required": [
	        "SecurityGroupIds",
	        "Subnets"
	      ],
	      "members": {
	        "SecurityGroupIds": {
	          "type": "list",
	          "member": {}
	        },
	        "Subnets": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S2k": {
	      "type": "structure",
	      "required": [
	        "EntityTypes"
	      ],
	      "members": {
	        "DataFormat": {},
	        "EntityTypes": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Type"
	            ],
	            "members": {
	              "Type": {}
	            }
	          }
	        },
	        "Documents": {
	          "type": "structure",
	          "required": [
	            "S3Uri"
	          ],
	          "members": {
	            "S3Uri": {},
	            "TestS3Uri": {},
	            "InputFormat": {}
	          }
	        },
	        "Annotations": {
	          "type": "structure",
	          "required": [
	            "S3Uri"
	          ],
	          "members": {
	            "S3Uri": {},
	            "TestS3Uri": {}
	          }
	        },
	        "EntityList": {
	          "type": "structure",
	          "required": [
	            "S3Uri"
	          ],
	          "members": {
	            "S3Uri": {}
	          }
	        },
	        "AugmentedManifests": {
	          "type": "list",
	          "member": {
	            "shape": "S1w"
	          }
	        }
	      }
	    },
	    "S38": {
	      "type": "structure",
	      "members": {
	        "JobId": {},
	        "JobArn": {},
	        "JobName": {},
	        "JobStatus": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "DocumentClassifierArn": {},
	        "InputDataConfig": {
	          "shape": "S3e"
	        },
	        "OutputDataConfig": {
	          "shape": "S3k"
	        },
	        "DataAccessRoleArn": {},
	        "VolumeKmsKeyId": {},
	        "VpcConfig": {
	          "shape": "S24"
	        }
	      }
	    },
	    "S3e": {
	      "type": "structure",
	      "required": [
	        "S3Uri"
	      ],
	      "members": {
	        "S3Uri": {},
	        "InputFormat": {},
	        "DocumentReaderConfig": {
	          "type": "structure",
	          "required": [
	            "DocumentReadAction"
	          ],
	          "members": {
	            "DocumentReadAction": {},
	            "DocumentReadMode": {},
	            "FeatureTypes": {
	              "type": "list",
	              "member": {}
	            }
	          }
	        }
	      }
	    },
	    "S3k": {
	      "type": "structure",
	      "required": [
	        "S3Uri"
	      ],
	      "members": {
	        "S3Uri": {},
	        "KmsKeyId": {}
	      }
	    },
	    "S3n": {
	      "type": "structure",
	      "members": {
	        "DocumentClassifierArn": {},
	        "LanguageCode": {},
	        "Status": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "TrainingStartTime": {
	          "type": "timestamp"
	        },
	        "TrainingEndTime": {
	          "type": "timestamp"
	        },
	        "InputDataConfig": {
	          "shape": "S1r"
	        },
	        "OutputDataConfig": {
	          "shape": "S21"
	        },
	        "ClassifierMetadata": {
	          "type": "structure",
	          "members": {
	            "NumberOfLabels": {
	              "type": "integer"
	            },
	            "NumberOfTrainedDocuments": {
	              "type": "integer"
	            },
	            "NumberOfTestDocuments": {
	              "type": "integer"
	            },
	            "EvaluationMetrics": {
	              "type": "structure",
	              "members": {
	                "Accuracy": {
	                  "type": "double"
	                },
	                "Precision": {
	                  "type": "double"
	                },
	                "Recall": {
	                  "type": "double"
	                },
	                "F1Score": {
	                  "type": "double"
	                },
	                "MicroPrecision": {
	                  "type": "double"
	                },
	                "MicroRecall": {
	                  "type": "double"
	                },
	                "MicroF1Score": {
	                  "type": "double"
	                },
	                "HammingLoss": {
	                  "type": "double"
	                }
	              }
	            }
	          },
	          "sensitive": true
	        },
	        "DataAccessRoleArn": {},
	        "VolumeKmsKeyId": {},
	        "VpcConfig": {
	          "shape": "S24"
	        },
	        "Mode": {},
	        "ModelKmsKeyId": {},
	        "VersionName": {},
	        "SourceModelArn": {}
	      }
	    },
	    "S3u": {
	      "type": "structure",
	      "members": {
	        "JobId": {},
	        "JobArn": {},
	        "JobName": {},
	        "JobStatus": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "InputDataConfig": {
	          "shape": "S3e"
	        },
	        "OutputDataConfig": {
	          "shape": "S3k"
	        },
	        "DataAccessRoleArn": {},
	        "VolumeKmsKeyId": {},
	        "VpcConfig": {
	          "shape": "S24"
	        }
	      }
	    },
	    "S3x": {
	      "type": "structure",
	      "members": {
	        "EndpointArn": {},
	        "Status": {},
	        "Message": {},
	        "ModelArn": {},
	        "DesiredModelArn": {},
	        "DesiredInferenceUnits": {
	          "type": "integer"
	        },
	        "CurrentInferenceUnits": {
	          "type": "integer"
	        },
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "LastModifiedTime": {
	          "type": "timestamp"
	        },
	        "DataAccessRoleArn": {},
	        "DesiredDataAccessRoleArn": {}
	      }
	    },
	    "S41": {
	      "type": "structure",
	      "members": {
	        "JobId": {},
	        "JobArn": {},
	        "JobName": {},
	        "JobStatus": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "EntityRecognizerArn": {},
	        "InputDataConfig": {
	          "shape": "S3e"
	        },
	        "OutputDataConfig": {
	          "shape": "S3k"
	        },
	        "LanguageCode": {},
	        "DataAccessRoleArn": {},
	        "VolumeKmsKeyId": {},
	        "VpcConfig": {
	          "shape": "S24"
	        }
	      }
	    },
	    "S44": {
	      "type": "structure",
	      "members": {
	        "EntityRecognizerArn": {},
	        "LanguageCode": {},
	        "Status": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "TrainingStartTime": {
	          "type": "timestamp"
	        },
	        "TrainingEndTime": {
	          "type": "timestamp"
	        },
	        "InputDataConfig": {
	          "shape": "S2k"
	        },
	        "RecognizerMetadata": {
	          "type": "structure",
	          "members": {
	            "NumberOfTrainedDocuments": {
	              "type": "integer"
	            },
	            "NumberOfTestDocuments": {
	              "type": "integer"
	            },
	            "EvaluationMetrics": {
	              "type": "structure",
	              "members": {
	                "Precision": {
	                  "type": "double"
	                },
	                "Recall": {
	                  "type": "double"
	                },
	                "F1Score": {
	                  "type": "double"
	                }
	              }
	            },
	            "EntityTypes": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "Type": {},
	                  "EvaluationMetrics": {
	                    "type": "structure",
	                    "members": {
	                      "Precision": {
	                        "type": "double"
	                      },
	                      "Recall": {
	                        "type": "double"
	                      },
	                      "F1Score": {
	                        "type": "double"
	                      }
	                    }
	                  },
	                  "NumberOfTrainMentions": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          },
	          "sensitive": true
	        },
	        "DataAccessRoleArn": {},
	        "VolumeKmsKeyId": {},
	        "VpcConfig": {
	          "shape": "S24"
	        },
	        "ModelKmsKeyId": {},
	        "VersionName": {},
	        "SourceModelArn": {}
	      }
	    },
	    "S4c": {
	      "type": "structure",
	      "members": {
	        "JobId": {},
	        "JobArn": {},
	        "JobName": {},
	        "JobStatus": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "InputDataConfig": {
	          "shape": "S3e"
	        },
	        "OutputDataConfig": {
	          "shape": "S3k"
	        },
	        "LanguageCode": {},
	        "DataAccessRoleArn": {},
	        "TargetEventTypes": {
	          "shape": "S4d"
	        }
	      }
	    },
	    "S4d": {
	      "type": "list",
	      "member": {}
	    },
	    "S4h": {
	      "type": "structure",
	      "members": {
	        "JobId": {},
	        "JobArn": {},
	        "JobName": {},
	        "JobStatus": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "InputDataConfig": {
	          "shape": "S3e"
	        },
	        "OutputDataConfig": {
	          "shape": "S3k"
	        },
	        "LanguageCode": {},
	        "DataAccessRoleArn": {},
	        "VolumeKmsKeyId": {},
	        "VpcConfig": {
	          "shape": "S24"
	        }
	      }
	    },
	    "S4k": {
	      "type": "structure",
	      "members": {
	        "JobId": {},
	        "JobArn": {},
	        "JobName": {},
	        "JobStatus": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "InputDataConfig": {
	          "shape": "S3e"
	        },
	        "OutputDataConfig": {
	          "type": "structure",
	          "required": [
	            "S3Uri"
	          ],
	          "members": {
	            "S3Uri": {},
	            "KmsKeyId": {}
	          }
	        },
	        "RedactionConfig": {
	          "shape": "S4m"
	        },
	        "LanguageCode": {},
	        "DataAccessRoleArn": {},
	        "Mode": {}
	      }
	    },
	    "S4m": {
	      "type": "structure",
	      "members": {
	        "PiiEntityTypes": {
	          "type": "list",
	          "member": {}
	        },
	        "MaskMode": {},
	        "MaskCharacter": {}
	      }
	    },
	    "S4v": {
	      "type": "structure",
	      "members": {
	        "JobId": {},
	        "JobArn": {},
	        "JobName": {},
	        "JobStatus": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "InputDataConfig": {
	          "shape": "S3e"
	        },
	        "OutputDataConfig": {
	          "shape": "S3k"
	        },
	        "LanguageCode": {},
	        "DataAccessRoleArn": {},
	        "VolumeKmsKeyId": {},
	        "VpcConfig": {
	          "shape": "S24"
	        }
	      }
	    },
	    "S4y": {
	      "type": "structure",
	      "members": {
	        "JobId": {},
	        "JobArn": {},
	        "JobName": {},
	        "JobStatus": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "InputDataConfig": {
	          "shape": "S3e"
	        },
	        "OutputDataConfig": {
	          "shape": "S3k"
	        },
	        "LanguageCode": {},
	        "DataAccessRoleArn": {},
	        "VolumeKmsKeyId": {},
	        "VpcConfig": {
	          "shape": "S24"
	        }
	      }
	    },
	    "S51": {
	      "type": "structure",
	      "members": {
	        "JobId": {},
	        "JobArn": {},
	        "JobName": {},
	        "JobStatus": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "InputDataConfig": {
	          "shape": "S3e"
	        },
	        "OutputDataConfig": {
	          "shape": "S3k"
	        },
	        "NumberOfTopics": {
	          "type": "integer"
	        },
	        "DataAccessRoleArn": {},
	        "VolumeKmsKeyId": {},
	        "VpcConfig": {
	          "shape": "S24"
	        }
	      }
	    }
	  }
	}
	},{}],60:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListDocumentClassificationJobs": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListDocumentClassifierSummaries": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListDocumentClassifiers": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListDominantLanguageDetectionJobs": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListEntitiesDetectionJobs": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListEntityRecognizerSummaries": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListEntityRecognizers": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListEventsDetectionJobs": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListKeyPhrasesDetectionJobs": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListSentimentDetectionJobs": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListTargetedSentimentDetectionJobs": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListTopicsDetectionJobs": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    }
	  }
	}
	
	},{}],61:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2018-10-30",
	    "endpointPrefix": "comprehendmedical",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "ComprehendMedical",
	    "serviceFullName": "AWS Comprehend Medical",
	    "serviceId": "ComprehendMedical",
	    "signatureVersion": "v4",
	    "signingName": "comprehendmedical",
	    "targetPrefix": "ComprehendMedical_20181030",
	    "uid": "comprehendmedical-2018-10-30"
	  },
	  "operations": {
	    "DescribeEntitiesDetectionV2Job": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComprehendMedicalAsyncJobProperties": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "DescribeICD10CMInferenceJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComprehendMedicalAsyncJobProperties": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "DescribePHIDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComprehendMedicalAsyncJobProperties": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "DescribeRxNormInferenceJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComprehendMedicalAsyncJobProperties": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "DescribeSNOMEDCTInferenceJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComprehendMedicalAsyncJobProperties": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "DetectEntities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text"
	        ],
	        "members": {
	          "Text": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entities",
	          "ModelVersion"
	        ],
	        "members": {
	          "Entities": {
	            "shape": "St"
	          },
	          "UnmappedAttributes": {
	            "shape": "S16"
	          },
	          "PaginationToken": {},
	          "ModelVersion": {}
	        }
	      },
	      "deprecated": true,
	      "deprecatedMessage": "This operation is deprecated, use DetectEntitiesV2 instead."
	    },
	    "DetectEntitiesV2": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text"
	        ],
	        "members": {
	          "Text": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entities",
	          "ModelVersion"
	        ],
	        "members": {
	          "Entities": {
	            "shape": "St"
	          },
	          "UnmappedAttributes": {
	            "shape": "S16"
	          },
	          "PaginationToken": {},
	          "ModelVersion": {}
	        }
	      }
	    },
	    "DetectPHI": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text"
	        ],
	        "members": {
	          "Text": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entities",
	          "ModelVersion"
	        ],
	        "members": {
	          "Entities": {
	            "shape": "St"
	          },
	          "PaginationToken": {},
	          "ModelVersion": {}
	        }
	      }
	    },
	    "InferICD10CM": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text"
	        ],
	        "members": {
	          "Text": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entities"
	        ],
	        "members": {
	          "Entities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {
	                  "type": "integer"
	                },
	                "Text": {},
	                "Category": {},
	                "Type": {},
	                "Score": {
	                  "type": "float"
	                },
	                "BeginOffset": {
	                  "type": "integer"
	                },
	                "EndOffset": {
	                  "type": "integer"
	                },
	                "Attributes": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Type": {},
	                      "Score": {
	                        "type": "float"
	                      },
	                      "RelationshipScore": {
	                        "type": "float"
	                      },
	                      "Id": {
	                        "type": "integer"
	                      },
	                      "BeginOffset": {
	                        "type": "integer"
	                      },
	                      "EndOffset": {
	                        "type": "integer"
	                      },
	                      "Text": {},
	                      "Traits": {
	                        "shape": "S1m"
	                      },
	                      "Category": {},
	                      "RelationshipType": {}
	                    }
	                  }
	                },
	                "Traits": {
	                  "shape": "S1m"
	                },
	                "ICD10CMConcepts": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Description": {},
	                      "Code": {},
	                      "Score": {
	                        "type": "float"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "PaginationToken": {},
	          "ModelVersion": {}
	        }
	      }
	    },
	    "InferRxNorm": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text"
	        ],
	        "members": {
	          "Text": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entities"
	        ],
	        "members": {
	          "Entities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {
	                  "type": "integer"
	                },
	                "Text": {},
	                "Category": {},
	                "Type": {},
	                "Score": {
	                  "type": "float"
	                },
	                "BeginOffset": {
	                  "type": "integer"
	                },
	                "EndOffset": {
	                  "type": "integer"
	                },
	                "Attributes": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Type": {},
	                      "Score": {
	                        "type": "float"
	                      },
	                      "RelationshipScore": {
	                        "type": "float"
	                      },
	                      "Id": {
	                        "type": "integer"
	                      },
	                      "BeginOffset": {
	                        "type": "integer"
	                      },
	                      "EndOffset": {
	                        "type": "integer"
	                      },
	                      "Text": {},
	                      "Traits": {
	                        "shape": "S21"
	                      }
	                    }
	                  }
	                },
	                "Traits": {
	                  "shape": "S21"
	                },
	                "RxNormConcepts": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Description": {},
	                      "Code": {},
	                      "Score": {
	                        "type": "float"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "PaginationToken": {},
	          "ModelVersion": {}
	        }
	      }
	    },
	    "InferSNOMEDCT": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text"
	        ],
	        "members": {
	          "Text": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entities"
	        ],
	        "members": {
	          "Entities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {
	                  "type": "integer"
	                },
	                "Text": {},
	                "Category": {},
	                "Type": {},
	                "Score": {
	                  "type": "float"
	                },
	                "BeginOffset": {
	                  "type": "integer"
	                },
	                "EndOffset": {
	                  "type": "integer"
	                },
	                "Attributes": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Category": {},
	                      "Type": {},
	                      "Score": {
	                        "type": "float"
	                      },
	                      "RelationshipScore": {
	                        "type": "float"
	                      },
	                      "RelationshipType": {},
	                      "Id": {
	                        "type": "integer"
	                      },
	                      "BeginOffset": {
	                        "type": "integer"
	                      },
	                      "EndOffset": {
	                        "type": "integer"
	                      },
	                      "Text": {},
	                      "Traits": {
	                        "shape": "S2g"
	                      },
	                      "SNOMEDCTConcepts": {
	                        "shape": "S2j"
	                      }
	                    }
	                  }
	                },
	                "Traits": {
	                  "shape": "S2g"
	                },
	                "SNOMEDCTConcepts": {
	                  "shape": "S2j"
	                }
	              }
	            }
	          },
	          "PaginationToken": {},
	          "ModelVersion": {},
	          "SNOMEDCTDetails": {
	            "type": "structure",
	            "members": {
	              "Edition": {},
	              "Language": {},
	              "VersionDate": {}
	            }
	          },
	          "Characters": {
	            "type": "structure",
	            "members": {
	              "OriginalTextCharacters": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListEntitiesDetectionV2Jobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "shape": "S2o"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComprehendMedicalAsyncJobPropertiesList": {
	            "shape": "S2r"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListICD10CMInferenceJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "shape": "S2o"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComprehendMedicalAsyncJobPropertiesList": {
	            "shape": "S2r"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListPHIDetectionJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "shape": "S2o"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComprehendMedicalAsyncJobPropertiesList": {
	            "shape": "S2r"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListRxNormInferenceJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "shape": "S2o"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComprehendMedicalAsyncJobPropertiesList": {
	            "shape": "S2r"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListSNOMEDCTInferenceJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "shape": "S2o"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComprehendMedicalAsyncJobPropertiesList": {
	            "shape": "S2r"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "StartEntitiesDetectionV2Job": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn",
	          "LanguageCode"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S9"
	          },
	          "OutputDataConfig": {
	            "shape": "Sc"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "KMSKey": {},
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    },
	    "StartICD10CMInferenceJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn",
	          "LanguageCode"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S9"
	          },
	          "OutputDataConfig": {
	            "shape": "Sc"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "KMSKey": {},
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    },
	    "StartPHIDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn",
	          "LanguageCode"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S9"
	          },
	          "OutputDataConfig": {
	            "shape": "Sc"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "KMSKey": {},
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    },
	    "StartRxNormInferenceJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn",
	          "LanguageCode"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S9"
	          },
	          "OutputDataConfig": {
	            "shape": "Sc"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "KMSKey": {},
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    },
	    "StartSNOMEDCTInferenceJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn",
	          "LanguageCode"
	        ],
	        "members": {
	          "InputDataConfig": {
	            "shape": "S9"
	          },
	          "OutputDataConfig": {
	            "shape": "Sc"
	          },
	          "DataAccessRoleArn": {},
	          "JobName": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "KMSKey": {},
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    },
	    "StopEntitiesDetectionV2Job": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    },
	    "StopICD10CMInferenceJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    },
	    "StopPHIDetectionJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    },
	    "StopRxNormInferenceJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    },
	    "StopSNOMEDCTInferenceJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "members": {
	        "JobId": {},
	        "JobName": {},
	        "JobStatus": {},
	        "Message": {},
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "ExpirationTime": {
	          "type": "timestamp"
	        },
	        "InputDataConfig": {
	          "shape": "S9"
	        },
	        "OutputDataConfig": {
	          "shape": "Sc"
	        },
	        "LanguageCode": {},
	        "DataAccessRoleArn": {},
	        "ManifestFilePath": {},
	        "KMSKey": {},
	        "ModelVersion": {}
	      }
	    },
	    "S9": {
	      "type": "structure",
	      "required": [
	        "S3Bucket"
	      ],
	      "members": {
	        "S3Bucket": {},
	        "S3Key": {}
	      }
	    },
	    "Sc": {
	      "type": "structure",
	      "required": [
	        "S3Bucket"
	      ],
	      "members": {
	        "S3Bucket": {},
	        "S3Key": {}
	      }
	    },
	    "St": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Id": {
	            "type": "integer"
	          },
	          "BeginOffset": {
	            "type": "integer"
	          },
	          "EndOffset": {
	            "type": "integer"
	          },
	          "Score": {
	            "type": "float"
	          },
	          "Text": {},
	          "Category": {},
	          "Type": {},
	          "Traits": {
	            "shape": "S10"
	          },
	          "Attributes": {
	            "type": "list",
	            "member": {
	              "shape": "S14"
	            }
	          }
	        }
	      }
	    },
	    "S10": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Score": {
	            "type": "float"
	          }
	        }
	      }
	    },
	    "S14": {
	      "type": "structure",
	      "members": {
	        "Type": {},
	        "Score": {
	          "type": "float"
	        },
	        "RelationshipScore": {
	          "type": "float"
	        },
	        "RelationshipType": {},
	        "Id": {
	          "type": "integer"
	        },
	        "BeginOffset": {
	          "type": "integer"
	        },
	        "EndOffset": {
	          "type": "integer"
	        },
	        "Text": {},
	        "Category": {},
	        "Traits": {
	          "shape": "S10"
	        }
	      }
	    },
	    "S16": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "Attribute": {
	            "shape": "S14"
	          }
	        }
	      }
	    },
	    "S1m": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Score": {
	            "type": "float"
	          }
	        }
	      }
	    },
	    "S21": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Score": {
	            "type": "float"
	          }
	        }
	      }
	    },
	    "S2g": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Score": {
	            "type": "float"
	          }
	        }
	      }
	    },
	    "S2j": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Description": {},
	          "Code": {},
	          "Score": {
	            "type": "float"
	          }
	        }
	      }
	    },
	    "S2o": {
	      "type": "structure",
	      "members": {
	        "JobName": {},
	        "JobStatus": {},
	        "SubmitTimeBefore": {
	          "type": "timestamp"
	        },
	        "SubmitTimeAfter": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S2r": {
	      "type": "list",
	      "member": {
	        "shape": "S4"
	      }
	    }
	  }
	}
	},{}],62:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],63:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-11-12",
	    "endpointPrefix": "config",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "Config Service",
	    "serviceFullName": "AWS Config",
	    "serviceId": "Config Service",
	    "signatureVersion": "v4",
	    "targetPrefix": "StarlingDoveService",
	    "uid": "config-2014-11-12"
	  },
	  "operations": {
	    "BatchGetAggregateResourceConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName",
	          "ResourceIdentifiers"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {},
	          "ResourceIdentifiers": {
	            "type": "list",
	            "member": {
	              "shape": "S4"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BaseConfigurationItems": {
	            "shape": "Sb"
	          },
	          "UnprocessedResourceIdentifiers": {
	            "type": "list",
	            "member": {
	              "shape": "S4"
	            }
	          }
	        }
	      }
	    },
	    "BatchGetResourceConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceKeys"
	        ],
	        "members": {
	          "resourceKeys": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "baseConfigurationItems": {
	            "shape": "Sb"
	          },
	          "unprocessedResourceKeys": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "DeleteAggregationAuthorization": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AuthorizedAccountId",
	          "AuthorizedAwsRegion"
	        ],
	        "members": {
	          "AuthorizedAccountId": {},
	          "AuthorizedAwsRegion": {}
	        }
	      }
	    },
	    "DeleteConfigRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName"
	        ],
	        "members": {
	          "ConfigRuleName": {}
	        }
	      }
	    },
	    "DeleteConfigurationAggregator": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {}
	        }
	      }
	    },
	    "DeleteConfigurationRecorder": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationRecorderName"
	        ],
	        "members": {
	          "ConfigurationRecorderName": {}
	        }
	      }
	    },
	    "DeleteConformancePack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConformancePackName"
	        ],
	        "members": {
	          "ConformancePackName": {}
	        }
	      }
	    },
	    "DeleteDeliveryChannel": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryChannelName"
	        ],
	        "members": {
	          "DeliveryChannelName": {}
	        }
	      }
	    },
	    "DeleteEvaluationResults": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName"
	        ],
	        "members": {
	          "ConfigRuleName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteOrganizationConfigRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OrganizationConfigRuleName"
	        ],
	        "members": {
	          "OrganizationConfigRuleName": {}
	        }
	      }
	    },
	    "DeleteOrganizationConformancePack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OrganizationConformancePackName"
	        ],
	        "members": {
	          "OrganizationConformancePackName": {}
	        }
	      }
	    },
	    "DeletePendingAggregationRequest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RequesterAccountId",
	          "RequesterAwsRegion"
	        ],
	        "members": {
	          "RequesterAccountId": {},
	          "RequesterAwsRegion": {}
	        }
	      }
	    },
	    "DeleteRemediationConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName"
	        ],
	        "members": {
	          "ConfigRuleName": {},
	          "ResourceType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteRemediationExceptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName",
	          "ResourceKeys"
	        ],
	        "members": {
	          "ConfigRuleName": {},
	          "ResourceKeys": {
	            "shape": "S1f"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FailedBatches": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FailureMessage": {},
	                "FailedItems": {
	                  "shape": "S1f"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DeleteResourceConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceType",
	          "ResourceId"
	        ],
	        "members": {
	          "ResourceType": {},
	          "ResourceId": {}
	        }
	      }
	    },
	    "DeleteRetentionConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RetentionConfigurationName"
	        ],
	        "members": {
	          "RetentionConfigurationName": {}
	        }
	      }
	    },
	    "DeleteStoredQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueryName"
	        ],
	        "members": {
	          "QueryName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeliverConfigSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "deliveryChannelName"
	        ],
	        "members": {
	          "deliveryChannelName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "configSnapshotId": {}
	        }
	      }
	    },
	    "DescribeAggregateComplianceByConfigRules": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "ConfigRuleName": {},
	              "ComplianceType": {},
	              "AccountId": {},
	              "AwsRegion": {}
	            }
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AggregateComplianceByConfigRules": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ConfigRuleName": {},
	                "Compliance": {
	                  "shape": "S23"
	                },
	                "AccountId": {},
	                "AwsRegion": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAggregateComplianceByConformancePacks": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "ConformancePackName": {},
	              "ComplianceType": {},
	              "AccountId": {},
	              "AwsRegion": {}
	            }
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AggregateComplianceByConformancePacks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ConformancePackName": {},
	                "Compliance": {
	                  "type": "structure",
	                  "members": {
	                    "ComplianceType": {},
	                    "CompliantRuleCount": {
	                      "type": "integer"
	                    },
	                    "NonCompliantRuleCount": {
	                      "type": "integer"
	                    },
	                    "TotalRuleCount": {
	                      "type": "integer"
	                    }
	                  }
	                },
	                "AccountId": {},
	                "AwsRegion": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAggregationAuthorizations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AggregationAuthorizations": {
	            "type": "list",
	            "member": {
	              "shape": "S2i"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeComplianceByConfigRule": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConfigRuleNames": {
	            "shape": "S2l"
	          },
	          "ComplianceTypes": {
	            "shape": "S2m"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComplianceByConfigRules": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ConfigRuleName": {},
	                "Compliance": {
	                  "shape": "S23"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeComplianceByResource": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ResourceType": {},
	          "ResourceId": {},
	          "ComplianceTypes": {
	            "shape": "S2m"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComplianceByResources": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ResourceType": {},
	                "ResourceId": {},
	                "Compliance": {
	                  "shape": "S23"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeConfigRuleEvaluationStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConfigRuleNames": {
	            "shape": "S2l"
	          },
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConfigRulesEvaluationStatus": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ConfigRuleName": {},
	                "ConfigRuleArn": {},
	                "ConfigRuleId": {},
	                "LastSuccessfulInvocationTime": {
	                  "type": "timestamp"
	                },
	                "LastFailedInvocationTime": {
	                  "type": "timestamp"
	                },
	                "LastSuccessfulEvaluationTime": {
	                  "type": "timestamp"
	                },
	                "LastFailedEvaluationTime": {
	                  "type": "timestamp"
	                },
	                "FirstActivatedTime": {
	                  "type": "timestamp"
	                },
	                "LastDeactivatedTime": {
	                  "type": "timestamp"
	                },
	                "LastErrorCode": {},
	                "LastErrorMessage": {},
	                "FirstEvaluationStarted": {
	                  "type": "boolean"
	                },
	                "LastDebugLogDeliveryStatus": {},
	                "LastDebugLogDeliveryStatusReason": {},
	                "LastDebugLogDeliveryTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeConfigRules": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConfigRuleNames": {
	            "shape": "S2l"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConfigRules": {
	            "type": "list",
	            "member": {
	              "shape": "S33"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeConfigurationAggregatorSourcesStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {},
	          "UpdateStatus": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AggregatedSourceStatusList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "SourceId": {},
	                "SourceType": {},
	                "AwsRegion": {},
	                "LastUpdateStatus": {},
	                "LastUpdateTime": {
	                  "type": "timestamp"
	                },
	                "LastErrorCode": {},
	                "LastErrorMessage": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeConfigurationAggregators": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConfigurationAggregatorNames": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConfigurationAggregators": {
	            "type": "list",
	            "member": {
	              "shape": "S3u"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeConfigurationRecorderStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConfigurationRecorderNames": {
	            "shape": "S42"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConfigurationRecordersStatus": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "lastStartTime": {
	                  "type": "timestamp"
	                },
	                "lastStopTime": {
	                  "type": "timestamp"
	                },
	                "recording": {
	                  "type": "boolean"
	                },
	                "lastStatus": {},
	                "lastErrorCode": {},
	                "lastErrorMessage": {},
	                "lastStatusChangeTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeConfigurationRecorders": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConfigurationRecorderNames": {
	            "shape": "S42"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConfigurationRecorders": {
	            "type": "list",
	            "member": {
	              "shape": "S4a"
	            }
	          }
	        }
	      }
	    },
	    "DescribeConformancePackCompliance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConformancePackName"
	        ],
	        "members": {
	          "ConformancePackName": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "ConfigRuleNames": {
	                "shape": "S4h"
	              },
	              "ComplianceType": {}
	            }
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ConformancePackName",
	          "ConformancePackRuleComplianceList"
	        ],
	        "members": {
	          "ConformancePackName": {},
	          "ConformancePackRuleComplianceList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ConfigRuleName": {},
	                "ComplianceType": {},
	                "Controls": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeConformancePackStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConformancePackNames": {
	            "shape": "S4o"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConformancePackStatusDetails": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ConformancePackName",
	                "ConformancePackId",
	                "ConformancePackArn",
	                "ConformancePackState",
	                "StackArn",
	                "LastUpdateRequestedTime"
	              ],
	              "members": {
	                "ConformancePackName": {},
	                "ConformancePackId": {},
	                "ConformancePackArn": {},
	                "ConformancePackState": {},
	                "StackArn": {},
	                "ConformancePackStatusReason": {},
	                "LastUpdateRequestedTime": {
	                  "type": "timestamp"
	                },
	                "LastUpdateCompletedTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeConformancePacks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConformancePackNames": {
	            "shape": "S4o"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConformancePackDetails": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ConformancePackName",
	                "ConformancePackArn",
	                "ConformancePackId"
	              ],
	              "members": {
	                "ConformancePackName": {},
	                "ConformancePackArn": {},
	                "ConformancePackId": {},
	                "DeliveryS3Bucket": {},
	                "DeliveryS3KeyPrefix": {},
	                "ConformancePackInputParameters": {
	                  "shape": "S54"
	                },
	                "LastUpdateRequestedTime": {
	                  "type": "timestamp"
	                },
	                "CreatedBy": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeDeliveryChannelStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DeliveryChannelNames": {
	            "shape": "S59"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeliveryChannelsStatus": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "configSnapshotDeliveryInfo": {
	                  "shape": "S5d"
	                },
	                "configHistoryDeliveryInfo": {
	                  "shape": "S5d"
	                },
	                "configStreamDeliveryInfo": {
	                  "type": "structure",
	                  "members": {
	                    "lastStatus": {},
	                    "lastErrorCode": {},
	                    "lastErrorMessage": {},
	                    "lastStatusChangeTime": {
	                      "type": "timestamp"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeDeliveryChannels": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DeliveryChannelNames": {
	            "shape": "S59"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeliveryChannels": {
	            "type": "list",
	            "member": {
	              "shape": "S5j"
	            }
	          }
	        }
	      }
	    },
	    "DescribeOrganizationConfigRuleStatuses": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OrganizationConfigRuleNames": {
	            "shape": "S5m"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OrganizationConfigRuleStatuses": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "OrganizationConfigRuleName",
	                "OrganizationRuleStatus"
	              ],
	              "members": {
	                "OrganizationConfigRuleName": {},
	                "OrganizationRuleStatus": {},
	                "ErrorCode": {},
	                "ErrorMessage": {},
	                "LastUpdateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeOrganizationConfigRules": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OrganizationConfigRuleNames": {
	            "shape": "S5m"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OrganizationConfigRules": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "OrganizationConfigRuleName",
	                "OrganizationConfigRuleArn"
	              ],
	              "members": {
	                "OrganizationConfigRuleName": {},
	                "OrganizationConfigRuleArn": {},
	                "OrganizationManagedRuleMetadata": {
	                  "shape": "S5w"
	                },
	                "OrganizationCustomRuleMetadata": {
	                  "shape": "S61"
	                },
	                "ExcludedAccounts": {
	                  "shape": "S64"
	                },
	                "LastUpdateTime": {
	                  "type": "timestamp"
	                },
	                "OrganizationCustomPolicyRuleMetadata": {
	                  "type": "structure",
	                  "members": {
	                    "Description": {},
	                    "OrganizationConfigRuleTriggerTypes": {
	                      "shape": "S66"
	                    },
	                    "InputParameters": {},
	                    "MaximumExecutionFrequency": {},
	                    "ResourceTypesScope": {
	                      "shape": "S5z"
	                    },
	                    "ResourceIdScope": {},
	                    "TagKeyScope": {},
	                    "TagValueScope": {},
	                    "PolicyRuntime": {},
	                    "DebugLogDeliveryAccounts": {
	                      "shape": "S68"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeOrganizationConformancePackStatuses": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OrganizationConformancePackNames": {
	            "shape": "S6a"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OrganizationConformancePackStatuses": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "OrganizationConformancePackName",
	                "Status"
	              ],
	              "members": {
	                "OrganizationConformancePackName": {},
	                "Status": {},
	                "ErrorCode": {},
	                "ErrorMessage": {},
	                "LastUpdateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeOrganizationConformancePacks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OrganizationConformancePackNames": {
	            "shape": "S6a"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OrganizationConformancePacks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "OrganizationConformancePackName",
	                "OrganizationConformancePackArn",
	                "LastUpdateTime"
	              ],
	              "members": {
	                "OrganizationConformancePackName": {},
	                "OrganizationConformancePackArn": {},
	                "DeliveryS3Bucket": {},
	                "DeliveryS3KeyPrefix": {},
	                "ConformancePackInputParameters": {
	                  "shape": "S54"
	                },
	                "ExcludedAccounts": {
	                  "shape": "S64"
	                },
	                "LastUpdateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribePendingAggregationRequests": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PendingAggregationRequests": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "RequesterAccountId": {},
	                "RequesterAwsRegion": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeRemediationConfigurations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleNames"
	        ],
	        "members": {
	          "ConfigRuleNames": {
	            "shape": "S2l"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RemediationConfigurations": {
	            "shape": "S6q"
	          }
	        }
	      }
	    },
	    "DescribeRemediationExceptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName"
	        ],
	        "members": {
	          "ConfigRuleName": {},
	          "ResourceKeys": {
	            "shape": "S1f"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RemediationExceptions": {
	            "shape": "S76"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeRemediationExecutionStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName"
	        ],
	        "members": {
	          "ConfigRuleName": {},
	          "ResourceKeys": {
	            "shape": "Sq"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RemediationExecutionStatuses": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ResourceKey": {
	                  "shape": "Sr"
	                },
	                "State": {},
	                "StepDetails": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Name": {},
	                      "State": {},
	                      "ErrorMessage": {},
	                      "StartTime": {
	                        "type": "timestamp"
	                      },
	                      "StopTime": {
	                        "type": "timestamp"
	                      }
	                    }
	                  }
	                },
	                "InvocationTime": {
	                  "type": "timestamp"
	                },
	                "LastUpdatedTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeRetentionConfigurations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "RetentionConfigurationNames": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RetentionConfigurations": {
	            "type": "list",
	            "member": {
	              "shape": "S7k"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetAggregateComplianceDetailsByConfigRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName",
	          "ConfigRuleName",
	          "AccountId",
	          "AwsRegion"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {},
	          "ConfigRuleName": {},
	          "AccountId": {},
	          "AwsRegion": {},
	          "ComplianceType": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AggregateEvaluationResults": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EvaluationResultIdentifier": {
	                  "shape": "S7q"
	                },
	                "ComplianceType": {},
	                "ResultRecordedTime": {
	                  "type": "timestamp"
	                },
	                "ConfigRuleInvokedTime": {
	                  "type": "timestamp"
	                },
	                "Annotation": {},
	                "AccountId": {},
	                "AwsRegion": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetAggregateConfigRuleComplianceSummary": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "AccountId": {},
	              "AwsRegion": {}
	            }
	          },
	          "GroupByKey": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GroupByKey": {},
	          "AggregateComplianceCounts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "GroupName": {},
	                "ComplianceSummary": {
	                  "shape": "S7y"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetAggregateConformancePackComplianceSummary": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "AccountId": {},
	              "AwsRegion": {}
	            }
	          },
	          "GroupByKey": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AggregateConformancePackComplianceSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ComplianceSummary": {
	                  "type": "structure",
	                  "members": {
	                    "CompliantConformancePackCount": {
	                      "type": "integer"
	                    },
	                    "NonCompliantConformancePackCount": {
	                      "type": "integer"
	                    }
	                  }
	                },
	                "GroupName": {}
	              }
	            }
	          },
	          "GroupByKey": {},
	          "NextToken": {}
	        }
	      }
	    },
	    "GetAggregateDiscoveredResourceCounts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "ResourceType": {},
	              "AccountId": {},
	              "Region": {}
	            }
	          },
	          "GroupByKey": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TotalDiscoveredResources"
	        ],
	        "members": {
	          "TotalDiscoveredResources": {
	            "type": "long"
	          },
	          "GroupByKey": {},
	          "GroupedResourceCounts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "GroupName",
	                "ResourceCount"
	              ],
	              "members": {
	                "GroupName": {},
	                "ResourceCount": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetAggregateResourceConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName",
	          "ResourceIdentifier"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {},
	          "ResourceIdentifier": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConfigurationItem": {
	            "shape": "S8f"
	          }
	        }
	      }
	    },
	    "GetComplianceDetailsByConfigRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName"
	        ],
	        "members": {
	          "ConfigRuleName": {},
	          "ComplianceTypes": {
	            "shape": "S2m"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EvaluationResults": {
	            "shape": "S8r"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetComplianceDetailsByResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceType",
	          "ResourceId"
	        ],
	        "members": {
	          "ResourceType": {},
	          "ResourceId": {},
	          "ComplianceTypes": {
	            "shape": "S2m"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EvaluationResults": {
	            "shape": "S8r"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetComplianceSummaryByConfigRule": {
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComplianceSummary": {
	            "shape": "S7y"
	          }
	        }
	      }
	    },
	    "GetComplianceSummaryByResourceType": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ResourceTypes": {
	            "shape": "S8x"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComplianceSummariesByResourceType": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ResourceType": {},
	                "ComplianceSummary": {
	                  "shape": "S7y"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetConformancePackComplianceDetails": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConformancePackName"
	        ],
	        "members": {
	          "ConformancePackName": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "ConfigRuleNames": {
	                "shape": "S4h"
	              },
	              "ComplianceType": {},
	              "ResourceType": {},
	              "ResourceIds": {
	                "type": "list",
	                "member": {}
	              }
	            }
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ConformancePackName"
	        ],
	        "members": {
	          "ConformancePackName": {},
	          "ConformancePackRuleEvaluationResults": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ComplianceType",
	                "EvaluationResultIdentifier",
	                "ConfigRuleInvokedTime",
	                "ResultRecordedTime"
	              ],
	              "members": {
	                "ComplianceType": {},
	                "EvaluationResultIdentifier": {
	                  "shape": "S7q"
	                },
	                "ConfigRuleInvokedTime": {
	                  "type": "timestamp"
	                },
	                "ResultRecordedTime": {
	                  "type": "timestamp"
	                },
	                "Annotation": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetConformancePackComplianceSummary": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConformancePackNames"
	        ],
	        "members": {
	          "ConformancePackNames": {
	            "type": "list",
	            "member": {}
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConformancePackComplianceSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ConformancePackName",
	                "ConformancePackComplianceStatus"
	              ],
	              "members": {
	                "ConformancePackName": {},
	                "ConformancePackComplianceStatus": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetCustomRulePolicy": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConfigRuleName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PolicyText": {}
	        }
	      }
	    },
	    "GetDiscoveredResourceCounts": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "resourceTypes": {
	            "shape": "S8x"
	          },
	          "limit": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "totalDiscoveredResources": {
	            "type": "long"
	          },
	          "resourceCounts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "resourceType": {},
	                "count": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetOrganizationConfigRuleDetailedStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OrganizationConfigRuleName"
	        ],
	        "members": {
	          "OrganizationConfigRuleName": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "AccountId": {},
	              "MemberAccountRuleStatus": {}
	            }
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OrganizationConfigRuleDetailedStatus": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "AccountId",
	                "ConfigRuleName",
	                "MemberAccountRuleStatus"
	              ],
	              "members": {
	                "AccountId": {},
	                "ConfigRuleName": {},
	                "MemberAccountRuleStatus": {},
	                "ErrorCode": {},
	                "ErrorMessage": {},
	                "LastUpdateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetOrganizationConformancePackDetailedStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OrganizationConformancePackName"
	        ],
	        "members": {
	          "OrganizationConformancePackName": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "AccountId": {},
	              "Status": {}
	            }
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OrganizationConformancePackDetailedStatuses": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "AccountId",
	                "ConformancePackName",
	                "Status"
	              ],
	              "members": {
	                "AccountId": {},
	                "ConformancePackName": {},
	                "Status": {},
	                "ErrorCode": {},
	                "ErrorMessage": {},
	                "LastUpdateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetOrganizationCustomRulePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OrganizationConfigRuleName"
	        ],
	        "members": {
	          "OrganizationConfigRuleName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PolicyText": {}
	        }
	      }
	    },
	    "GetResourceConfigHistory": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceType",
	          "resourceId"
	        ],
	        "members": {
	          "resourceType": {},
	          "resourceId": {},
	          "laterTime": {
	            "type": "timestamp"
	          },
	          "earlierTime": {
	            "type": "timestamp"
	          },
	          "chronologicalOrder": {},
	          "limit": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "configurationItems": {
	            "type": "list",
	            "member": {
	              "shape": "S8f"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetStoredQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueryName"
	        ],
	        "members": {
	          "QueryName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StoredQuery": {
	            "shape": "Sa6"
	          }
	        }
	      }
	    },
	    "ListAggregateDiscoveredResources": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName",
	          "ResourceType"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {},
	          "ResourceType": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "AccountId": {},
	              "ResourceId": {},
	              "ResourceName": {},
	              "Region": {}
	            }
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceIdentifiers": {
	            "type": "list",
	            "member": {
	              "shape": "S4"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListDiscoveredResources": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceType"
	        ],
	        "members": {
	          "resourceType": {},
	          "resourceIds": {
	            "type": "list",
	            "member": {}
	          },
	          "resourceName": {},
	          "limit": {
	            "type": "integer"
	          },
	          "includeDeletedResources": {
	            "type": "boolean"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "resourceIdentifiers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "resourceType": {},
	                "resourceId": {},
	                "resourceName": {},
	                "resourceDeletionTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListStoredQueries": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StoredQueryMetadata": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "QueryId",
	                "QueryArn",
	                "QueryName"
	              ],
	              "members": {
	                "QueryId": {},
	                "QueryArn": {},
	                "QueryName": {},
	                "Description": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "Sas"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PutAggregationAuthorization": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AuthorizedAccountId",
	          "AuthorizedAwsRegion"
	        ],
	        "members": {
	          "AuthorizedAccountId": {},
	          "AuthorizedAwsRegion": {},
	          "Tags": {
	            "shape": "Sax"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AggregationAuthorization": {
	            "shape": "S2i"
	          }
	        }
	      }
	    },
	    "PutConfigRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRule"
	        ],
	        "members": {
	          "ConfigRule": {
	            "shape": "S33"
	          },
	          "Tags": {
	            "shape": "Sax"
	          }
	        }
	      }
	    },
	    "PutConfigurationAggregator": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationAggregatorName"
	        ],
	        "members": {
	          "ConfigurationAggregatorName": {},
	          "AccountAggregationSources": {
	            "shape": "S3w"
	          },
	          "OrganizationAggregationSource": {
	            "shape": "S40"
	          },
	          "Tags": {
	            "shape": "Sax"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConfigurationAggregator": {
	            "shape": "S3u"
	          }
	        }
	      }
	    },
	    "PutConfigurationRecorder": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationRecorder"
	        ],
	        "members": {
	          "ConfigurationRecorder": {
	            "shape": "S4a"
	          }
	        }
	      }
	    },
	    "PutConformancePack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConformancePackName"
	        ],
	        "members": {
	          "ConformancePackName": {},
	          "TemplateS3Uri": {},
	          "TemplateBody": {},
	          "DeliveryS3Bucket": {},
	          "DeliveryS3KeyPrefix": {},
	          "ConformancePackInputParameters": {
	            "shape": "S54"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConformancePackArn": {}
	        }
	      }
	    },
	    "PutDeliveryChannel": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryChannel"
	        ],
	        "members": {
	          "DeliveryChannel": {
	            "shape": "S5j"
	          }
	        }
	      }
	    },
	    "PutEvaluations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResultToken"
	        ],
	        "members": {
	          "Evaluations": {
	            "shape": "Sb9"
	          },
	          "ResultToken": {},
	          "TestMode": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FailedEvaluations": {
	            "shape": "Sb9"
	          }
	        }
	      }
	    },
	    "PutExternalEvaluation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName",
	          "ExternalEvaluation"
	        ],
	        "members": {
	          "ConfigRuleName": {},
	          "ExternalEvaluation": {
	            "type": "structure",
	            "required": [
	              "ComplianceResourceType",
	              "ComplianceResourceId",
	              "ComplianceType",
	              "OrderingTimestamp"
	            ],
	            "members": {
	              "ComplianceResourceType": {},
	              "ComplianceResourceId": {},
	              "ComplianceType": {},
	              "Annotation": {},
	              "OrderingTimestamp": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "PutOrganizationConfigRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OrganizationConfigRuleName"
	        ],
	        "members": {
	          "OrganizationConfigRuleName": {},
	          "OrganizationManagedRuleMetadata": {
	            "shape": "S5w"
	          },
	          "OrganizationCustomRuleMetadata": {
	            "shape": "S61"
	          },
	          "ExcludedAccounts": {
	            "shape": "S64"
	          },
	          "OrganizationCustomPolicyRuleMetadata": {
	            "type": "structure",
	            "required": [
	              "PolicyRuntime",
	              "PolicyText"
	            ],
	            "members": {
	              "Description": {},
	              "OrganizationConfigRuleTriggerTypes": {
	                "shape": "S66"
	              },
	              "InputParameters": {},
	              "MaximumExecutionFrequency": {},
	              "ResourceTypesScope": {
	                "shape": "S5z"
	              },
	              "ResourceIdScope": {},
	              "TagKeyScope": {},
	              "TagValueScope": {},
	              "PolicyRuntime": {},
	              "PolicyText": {},
	              "DebugLogDeliveryAccounts": {
	                "shape": "S68"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OrganizationConfigRuleArn": {}
	        }
	      }
	    },
	    "PutOrganizationConformancePack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OrganizationConformancePackName"
	        ],
	        "members": {
	          "OrganizationConformancePackName": {},
	          "TemplateS3Uri": {},
	          "TemplateBody": {},
	          "DeliveryS3Bucket": {},
	          "DeliveryS3KeyPrefix": {},
	          "ConformancePackInputParameters": {
	            "shape": "S54"
	          },
	          "ExcludedAccounts": {
	            "shape": "S64"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OrganizationConformancePackArn": {}
	        }
	      }
	    },
	    "PutRemediationConfigurations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RemediationConfigurations"
	        ],
	        "members": {
	          "RemediationConfigurations": {
	            "shape": "S6q"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FailedBatches": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FailureMessage": {},
	                "FailedItems": {
	                  "shape": "S6q"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutRemediationExceptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName",
	          "ResourceKeys"
	        ],
	        "members": {
	          "ConfigRuleName": {},
	          "ResourceKeys": {
	            "shape": "S1f"
	          },
	          "Message": {},
	          "ExpirationTime": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FailedBatches": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FailureMessage": {},
	                "FailedItems": {
	                  "shape": "S76"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutResourceConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceType",
	          "SchemaVersionId",
	          "ResourceId",
	          "Configuration"
	        ],
	        "members": {
	          "ResourceType": {},
	          "SchemaVersionId": {},
	          "ResourceId": {},
	          "ResourceName": {},
	          "Configuration": {},
	          "Tags": {
	            "shape": "S8h"
	          }
	        }
	      }
	    },
	    "PutRetentionConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RetentionPeriodInDays"
	        ],
	        "members": {
	          "RetentionPeriodInDays": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RetentionConfiguration": {
	            "shape": "S7k"
	          }
	        }
	      }
	    },
	    "PutStoredQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StoredQuery"
	        ],
	        "members": {
	          "StoredQuery": {
	            "shape": "Sa6"
	          },
	          "Tags": {
	            "shape": "Sax"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QueryArn": {}
	        }
	      }
	    },
	    "SelectAggregateResourceConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Expression",
	          "ConfigurationAggregatorName"
	        ],
	        "members": {
	          "Expression": {},
	          "ConfigurationAggregatorName": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Results": {
	            "shape": "Sc2"
	          },
	          "QueryInfo": {
	            "shape": "Sc3"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "SelectResourceConfig": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Expression"
	        ],
	        "members": {
	          "Expression": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Results": {
	            "shape": "Sc2"
	          },
	          "QueryInfo": {
	            "shape": "Sc3"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "StartConfigRulesEvaluation": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConfigRuleNames": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "StartConfigurationRecorder": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationRecorderName"
	        ],
	        "members": {
	          "ConfigurationRecorderName": {}
	        }
	      }
	    },
	    "StartRemediationExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName",
	          "ResourceKeys"
	        ],
	        "members": {
	          "ConfigRuleName": {},
	          "ResourceKeys": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FailureMessage": {},
	          "FailedItems": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "StopConfigurationRecorder": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationRecorderName"
	        ],
	        "members": {
	          "ConfigurationRecorderName": {}
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "Sas"
	          }
	        }
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "required": [
	        "SourceAccountId",
	        "SourceRegion",
	        "ResourceId",
	        "ResourceType"
	      ],
	      "members": {
	        "SourceAccountId": {},
	        "SourceRegion": {},
	        "ResourceId": {},
	        "ResourceType": {},
	        "ResourceName": {}
	      }
	    },
	    "Sb": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "version": {},
	          "accountId": {},
	          "configurationItemCaptureTime": {
	            "type": "timestamp"
	          },
	          "configurationItemStatus": {},
	          "configurationStateId": {},
	          "arn": {},
	          "resourceType": {},
	          "resourceId": {},
	          "resourceName": {},
	          "awsRegion": {},
	          "availabilityZone": {},
	          "resourceCreationTime": {
	            "type": "timestamp"
	          },
	          "configuration": {},
	          "supplementaryConfiguration": {
	            "shape": "Sl"
	          }
	        }
	      }
	    },
	    "Sl": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sq": {
	      "type": "list",
	      "member": {
	        "shape": "Sr"
	      }
	    },
	    "Sr": {
	      "type": "structure",
	      "required": [
	        "resourceType",
	        "resourceId"
	      ],
	      "members": {
	        "resourceType": {},
	        "resourceId": {}
	      }
	    },
	    "S1f": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ResourceType": {},
	          "ResourceId": {}
	        }
	      }
	    },
	    "S23": {
	      "type": "structure",
	      "members": {
	        "ComplianceType": {},
	        "ComplianceContributorCount": {
	          "shape": "S24"
	        }
	      }
	    },
	    "S24": {
	      "type": "structure",
	      "members": {
	        "CappedCount": {
	          "type": "integer"
	        },
	        "CapExceeded": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S2i": {
	      "type": "structure",
	      "members": {
	        "AggregationAuthorizationArn": {},
	        "AuthorizedAccountId": {},
	        "AuthorizedAwsRegion": {},
	        "CreationTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S2l": {
	      "type": "list",
	      "member": {}
	    },
	    "S2m": {
	      "type": "list",
	      "member": {}
	    },
	    "S33": {
	      "type": "structure",
	      "required": [
	        "Source"
	      ],
	      "members": {
	        "ConfigRuleName": {},
	        "ConfigRuleArn": {},
	        "ConfigRuleId": {},
	        "Description": {},
	        "Scope": {
	          "type": "structure",
	          "members": {
	            "ComplianceResourceTypes": {
	              "type": "list",
	              "member": {}
	            },
	            "TagKey": {},
	            "TagValue": {},
	            "ComplianceResourceId": {}
	          }
	        },
	        "Source": {
	          "type": "structure",
	          "required": [
	            "Owner"
	          ],
	          "members": {
	            "Owner": {},
	            "SourceIdentifier": {},
	            "SourceDetails": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "EventSource": {},
	                  "MessageType": {},
	                  "MaximumExecutionFrequency": {}
	                }
	              }
	            },
	            "CustomPolicyDetails": {
	              "type": "structure",
	              "required": [
	                "PolicyRuntime",
	                "PolicyText"
	              ],
	              "members": {
	                "PolicyRuntime": {},
	                "PolicyText": {},
	                "EnableDebugLogDelivery": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        },
	        "InputParameters": {},
	        "MaximumExecutionFrequency": {},
	        "ConfigRuleState": {},
	        "CreatedBy": {}
	      }
	    },
	    "S3u": {
	      "type": "structure",
	      "members": {
	        "ConfigurationAggregatorName": {},
	        "ConfigurationAggregatorArn": {},
	        "AccountAggregationSources": {
	          "shape": "S3w"
	        },
	        "OrganizationAggregationSource": {
	          "shape": "S40"
	        },
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "LastUpdatedTime": {
	          "type": "timestamp"
	        },
	        "CreatedBy": {}
	      }
	    },
	    "S3w": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "AccountIds"
	        ],
	        "members": {
	          "AccountIds": {
	            "type": "list",
	            "member": {}
	          },
	          "AllAwsRegions": {
	            "type": "boolean"
	          },
	          "AwsRegions": {
	            "shape": "S3z"
	          }
	        }
	      }
	    },
	    "S3z": {
	      "type": "list",
	      "member": {}
	    },
	    "S40": {
	      "type": "structure",
	      "required": [
	        "RoleArn"
	      ],
	      "members": {
	        "RoleArn": {},
	        "AwsRegions": {
	          "shape": "S3z"
	        },
	        "AllAwsRegions": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S42": {
	      "type": "list",
	      "member": {}
	    },
	    "S4a": {
	      "type": "structure",
	      "members": {
	        "name": {},
	        "roleARN": {},
	        "recordingGroup": {
	          "type": "structure",
	          "members": {
	            "allSupported": {
	              "type": "boolean"
	            },
	            "includeGlobalResourceTypes": {
	              "type": "boolean"
	            },
	            "resourceTypes": {
	              "type": "list",
	              "member": {}
	            }
	          }
	        }
	      }
	    },
	    "S4h": {
	      "type": "list",
	      "member": {}
	    },
	    "S4o": {
	      "type": "list",
	      "member": {}
	    },
	    "S54": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "ParameterName",
	          "ParameterValue"
	        ],
	        "members": {
	          "ParameterName": {},
	          "ParameterValue": {}
	        }
	      }
	    },
	    "S59": {
	      "type": "list",
	      "member": {}
	    },
	    "S5d": {
	      "type": "structure",
	      "members": {
	        "lastStatus": {},
	        "lastErrorCode": {},
	        "lastErrorMessage": {},
	        "lastAttemptTime": {
	          "type": "timestamp"
	        },
	        "lastSuccessfulTime": {
	          "type": "timestamp"
	        },
	        "nextDeliveryTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S5j": {
	      "type": "structure",
	      "members": {
	        "name": {},
	        "s3BucketName": {},
	        "s3KeyPrefix": {},
	        "s3KmsKeyArn": {},
	        "snsTopicARN": {},
	        "configSnapshotDeliveryProperties": {
	          "type": "structure",
	          "members": {
	            "deliveryFrequency": {}
	          }
	        }
	      }
	    },
	    "S5m": {
	      "type": "list",
	      "member": {}
	    },
	    "S5w": {
	      "type": "structure",
	      "required": [
	        "RuleIdentifier"
	      ],
	      "members": {
	        "Description": {},
	        "RuleIdentifier": {},
	        "InputParameters": {},
	        "MaximumExecutionFrequency": {},
	        "ResourceTypesScope": {
	          "shape": "S5z"
	        },
	        "ResourceIdScope": {},
	        "TagKeyScope": {},
	        "TagValueScope": {}
	      }
	    },
	    "S5z": {
	      "type": "list",
	      "member": {}
	    },
	    "S61": {
	      "type": "structure",
	      "required": [
	        "LambdaFunctionArn",
	        "OrganizationConfigRuleTriggerTypes"
	      ],
	      "members": {
	        "Description": {},
	        "LambdaFunctionArn": {},
	        "OrganizationConfigRuleTriggerTypes": {
	          "type": "list",
	          "member": {}
	        },
	        "InputParameters": {},
	        "MaximumExecutionFrequency": {},
	        "ResourceTypesScope": {
	          "shape": "S5z"
	        },
	        "ResourceIdScope": {},
	        "TagKeyScope": {},
	        "TagValueScope": {}
	      }
	    },
	    "S64": {
	      "type": "list",
	      "member": {}
	    },
	    "S66": {
	      "type": "list",
	      "member": {}
	    },
	    "S68": {
	      "type": "list",
	      "member": {}
	    },
	    "S6a": {
	      "type": "list",
	      "member": {}
	    },
	    "S6q": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName",
	          "TargetType",
	          "TargetId"
	        ],
	        "members": {
	          "ConfigRuleName": {},
	          "TargetType": {},
	          "TargetId": {},
	          "TargetVersion": {},
	          "Parameters": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "members": {
	                "ResourceValue": {
	                  "type": "structure",
	                  "required": [
	                    "Value"
	                  ],
	                  "members": {
	                    "Value": {}
	                  }
	                },
	                "StaticValue": {
	                  "type": "structure",
	                  "required": [
	                    "Values"
	                  ],
	                  "members": {
	                    "Values": {
	                      "type": "list",
	                      "member": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "ResourceType": {},
	          "Automatic": {
	            "type": "boolean"
	          },
	          "ExecutionControls": {
	            "type": "structure",
	            "members": {
	              "SsmControls": {
	                "type": "structure",
	                "members": {
	                  "ConcurrentExecutionRatePercentage": {
	                    "type": "integer"
	                  },
	                  "ErrorPercentage": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          },
	          "MaximumAutomaticAttempts": {
	            "type": "integer"
	          },
	          "RetryAttemptSeconds": {
	            "type": "long"
	          },
	          "Arn": {},
	          "CreatedByService": {}
	        }
	      }
	    },
	    "S76": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "ConfigRuleName",
	          "ResourceType",
	          "ResourceId"
	        ],
	        "members": {
	          "ConfigRuleName": {},
	          "ResourceType": {},
	          "ResourceId": {},
	          "Message": {},
	          "ExpirationTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "S7k": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "RetentionPeriodInDays"
	      ],
	      "members": {
	        "Name": {},
	        "RetentionPeriodInDays": {
	          "type": "integer"
	        }
	      }
	    },
	    "S7q": {
	      "type": "structure",
	      "members": {
	        "EvaluationResultQualifier": {
	          "type": "structure",
	          "members": {
	            "ConfigRuleName": {},
	            "ResourceType": {},
	            "ResourceId": {}
	          }
	        },
	        "OrderingTimestamp": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S7y": {
	      "type": "structure",
	      "members": {
	        "CompliantResourceCount": {
	          "shape": "S24"
	        },
	        "NonCompliantResourceCount": {
	          "shape": "S24"
	        },
	        "ComplianceSummaryTimestamp": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S8f": {
	      "type": "structure",
	      "members": {
	        "version": {},
	        "accountId": {},
	        "configurationItemCaptureTime": {
	          "type": "timestamp"
	        },
	        "configurationItemStatus": {},
	        "configurationStateId": {},
	        "configurationItemMD5Hash": {},
	        "arn": {},
	        "resourceType": {},
	        "resourceId": {},
	        "resourceName": {},
	        "awsRegion": {},
	        "availabilityZone": {},
	        "resourceCreationTime": {
	          "type": "timestamp"
	        },
	        "tags": {
	          "shape": "S8h"
	        },
	        "relatedEvents": {
	          "type": "list",
	          "member": {}
	        },
	        "relationships": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "resourceType": {},
	              "resourceId": {},
	              "resourceName": {},
	              "relationshipName": {}
	            }
	          }
	        },
	        "configuration": {},
	        "supplementaryConfiguration": {
	          "shape": "Sl"
	        }
	      }
	    },
	    "S8h": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S8r": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "EvaluationResultIdentifier": {
	            "shape": "S7q"
	          },
	          "ComplianceType": {},
	          "ResultRecordedTime": {
	            "type": "timestamp"
	          },
	          "ConfigRuleInvokedTime": {
	            "type": "timestamp"
	          },
	          "Annotation": {},
	          "ResultToken": {}
	        }
	      }
	    },
	    "S8x": {
	      "type": "list",
	      "member": {}
	    },
	    "Sa6": {
	      "type": "structure",
	      "required": [
	        "QueryName"
	      ],
	      "members": {
	        "QueryId": {},
	        "QueryArn": {},
	        "QueryName": {},
	        "Description": {},
	        "Expression": {}
	      }
	    },
	    "Sas": {
	      "type": "list",
	      "member": {
	        "shape": "Sat"
	      }
	    },
	    "Sat": {
	      "type": "structure",
	      "members": {
	        "Key": {},
	        "Value": {}
	      }
	    },
	    "Sax": {
	      "type": "list",
	      "member": {
	        "shape": "Sat"
	      }
	    },
	    "Sb9": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "ComplianceResourceType",
	          "ComplianceResourceId",
	          "ComplianceType",
	          "OrderingTimestamp"
	        ],
	        "members": {
	          "ComplianceResourceType": {},
	          "ComplianceResourceId": {},
	          "ComplianceType": {},
	          "Annotation": {},
	          "OrderingTimestamp": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "Sc2": {
	      "type": "list",
	      "member": {}
	    },
	    "Sc3": {
	      "type": "structure",
	      "members": {
	        "SelectFields": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Name": {}
	            }
	          }
	        }
	      }
	    }
	  }
	}
	},{}],64:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeAggregateComplianceByConfigRules": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken"
	    },
	    "DescribeAggregateComplianceByConformancePacks": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "AggregateComplianceByConformancePacks"
	    },
	    "DescribeAggregationAuthorizations": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "AggregationAuthorizations"
	    },
	    "DescribeComplianceByConfigRule": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "ComplianceByConfigRules"
	    },
	    "DescribeComplianceByResource": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "ComplianceByResources"
	    },
	    "DescribeConfigRuleEvaluationStatus": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "ConfigRulesEvaluationStatus"
	    },
	    "DescribeConfigRules": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "ConfigRules"
	    },
	    "DescribeConfigurationAggregatorSourcesStatus": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "AggregatedSourceStatusList"
	    },
	    "DescribeConfigurationAggregators": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "ConfigurationAggregators"
	    },
	    "DescribeConformancePackCompliance": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken"
	    },
	    "DescribeConformancePackStatus": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "ConformancePackStatusDetails"
	    },
	    "DescribeConformancePacks": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "ConformancePackDetails"
	    },
	    "DescribeOrganizationConfigRuleStatuses": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "OrganizationConfigRuleStatuses"
	    },
	    "DescribeOrganizationConfigRules": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "OrganizationConfigRules"
	    },
	    "DescribeOrganizationConformancePackStatuses": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "OrganizationConformancePackStatuses"
	    },
	    "DescribeOrganizationConformancePacks": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "OrganizationConformancePacks"
	    },
	    "DescribePendingAggregationRequests": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "PendingAggregationRequests"
	    },
	    "DescribeRemediationExceptions": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken"
	    },
	    "DescribeRemediationExecutionStatus": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "RemediationExecutionStatuses"
	    },
	    "DescribeRetentionConfigurations": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "RetentionConfigurations"
	    },
	    "GetAggregateComplianceDetailsByConfigRule": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "AggregateEvaluationResults"
	    },
	    "GetAggregateConfigRuleComplianceSummary": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken"
	    },
	    "GetAggregateConformancePackComplianceSummary": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken"
	    },
	    "GetAggregateDiscoveredResourceCounts": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken"
	    },
	    "GetComplianceDetailsByConfigRule": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "EvaluationResults"
	    },
	    "GetComplianceDetailsByResource": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "EvaluationResults"
	    },
	    "GetConformancePackComplianceDetails": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken"
	    },
	    "GetConformancePackComplianceSummary": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "ConformancePackComplianceSummaryList"
	    },
	    "GetDiscoveredResourceCounts": {
	      "input_token": "nextToken",
	      "limit_key": "limit",
	      "output_token": "nextToken"
	    },
	    "GetOrganizationConfigRuleDetailedStatus": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "OrganizationConfigRuleDetailedStatus"
	    },
	    "GetOrganizationConformancePackDetailedStatus": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "OrganizationConformancePackDetailedStatuses"
	    },
	    "GetResourceConfigHistory": {
	      "input_token": "nextToken",
	      "limit_key": "limit",
	      "output_token": "nextToken",
	      "result_key": "configurationItems"
	    },
	    "ListAggregateDiscoveredResources": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "ResourceIdentifiers"
	    },
	    "ListDiscoveredResources": {
	      "input_token": "nextToken",
	      "limit_key": "limit",
	      "output_token": "nextToken",
	      "result_key": "resourceIdentifiers"
	    },
	    "ListStoredQueries": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListTagsForResource": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "Tags"
	    },
	    "SelectAggregateResourceConfig": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "non_aggregate_keys": [
	        "QueryInfo"
	      ],
	      "output_token": "NextToken",
	      "result_key": "Results"
	    },
	    "SelectResourceConfig": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "non_aggregate_keys": [
	        "QueryInfo"
	      ],
	      "output_token": "NextToken",
	      "result_key": "Results"
	    }
	  }
	}
	},{}],65:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-08-08",
	    "endpointPrefix": "connect",
	    "jsonVersion": "1.1",
	    "protocol": "rest-json",
	    "serviceAbbreviation": "Amazon Connect",
	    "serviceFullName": "Amazon Connect Service",
	    "serviceId": "Connect",
	    "signatureVersion": "v4",
	    "signingName": "connect",
	    "uid": "connect-2017-08-08"
	  },
	  "operations": {
	    "AssociateApprovedOrigin": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/instance/{InstanceId}/approved-origin"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Origin"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Origin": {}
	        }
	      }
	    },
	    "AssociateBot": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/instance/{InstanceId}/bot"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "LexBot": {
	            "shape": "S5"
	          },
	          "LexV2Bot": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "AssociateDefaultVocabulary": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/default-vocabulary/{InstanceId}/{LanguageCode}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "LanguageCode"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "LanguageCode": {
	            "location": "uri",
	            "locationName": "LanguageCode"
	          },
	          "VocabularyId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AssociateInstanceStorageConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/instance/{InstanceId}/storage-config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ResourceType",
	          "StorageConfig"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ResourceType": {},
	          "StorageConfig": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationId": {}
	        }
	      }
	    },
	    "AssociateLambdaFunction": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/instance/{InstanceId}/lambda-function"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "FunctionArn"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "FunctionArn": {}
	        }
	      }
	    },
	    "AssociateLexBot": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/instance/{InstanceId}/lex-bot"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "LexBot"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "LexBot": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "AssociatePhoneNumberContactFlow": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/phone-number/{PhoneNumberId}/contact-flow"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PhoneNumberId",
	          "InstanceId",
	          "ContactFlowId"
	        ],
	        "members": {
	          "PhoneNumberId": {
	            "location": "uri",
	            "locationName": "PhoneNumberId"
	          },
	          "InstanceId": {},
	          "ContactFlowId": {}
	        }
	      }
	    },
	    "AssociateQueueQuickConnects": {
	      "http": {
	        "requestUri": "/queues/{InstanceId}/{QueueId}/associate-quick-connects"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QueueId",
	          "QuickConnectIds"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QueueId": {
	            "location": "uri",
	            "locationName": "QueueId"
	          },
	          "QuickConnectIds": {
	            "shape": "S13"
	          }
	        }
	      }
	    },
	    "AssociateRoutingProfileQueues": {
	      "http": {
	        "requestUri": "/routing-profiles/{InstanceId}/{RoutingProfileId}/associate-queues"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "RoutingProfileId",
	          "QueueConfigs"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "RoutingProfileId": {
	            "location": "uri",
	            "locationName": "RoutingProfileId"
	          },
	          "QueueConfigs": {
	            "shape": "S17"
	          }
	        }
	      }
	    },
	    "AssociateSecurityKey": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/instance/{InstanceId}/security-key"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Key"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Key": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationId": {}
	        }
	      }
	    },
	    "ClaimPhoneNumber": {
	      "http": {
	        "requestUri": "/phone-number/claim"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetArn",
	          "PhoneNumber"
	        ],
	        "members": {
	          "TargetArn": {},
	          "PhoneNumber": {},
	          "PhoneNumberDescription": {},
	          "Tags": {
	            "shape": "S1j"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PhoneNumberId": {},
	          "PhoneNumberArn": {}
	        }
	      }
	    },
	    "CreateAgentStatus": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/agent-status/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Name",
	          "State"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Name": {},
	          "Description": {},
	          "State": {},
	          "DisplayOrder": {
	            "type": "integer"
	          },
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AgentStatusARN": {},
	          "AgentStatusId": {}
	        }
	      }
	    },
	    "CreateContactFlow": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/contact-flows/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Name",
	          "Type",
	          "Content"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Name": {},
	          "Type": {},
	          "Description": {},
	          "Content": {},
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContactFlowId": {},
	          "ContactFlowArn": {}
	        }
	      }
	    },
	    "CreateContactFlowModule": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/contact-flow-modules/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Name",
	          "Content"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Name": {},
	          "Description": {},
	          "Content": {},
	          "Tags": {
	            "shape": "S1j"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Id": {},
	          "Arn": {}
	        }
	      }
	    },
	    "CreateHoursOfOperation": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/hours-of-operations/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Name",
	          "TimeZone",
	          "Config"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Name": {},
	          "Description": {},
	          "TimeZone": {},
	          "Config": {
	            "shape": "S2b"
	          },
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HoursOfOperationId": {},
	          "HoursOfOperationArn": {}
	        }
	      }
	    },
	    "CreateInstance": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/instance"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityManagementType",
	          "InboundCallsEnabled",
	          "OutboundCallsEnabled"
	        ],
	        "members": {
	          "ClientToken": {},
	          "IdentityManagementType": {},
	          "InstanceAlias": {
	            "shape": "S2l"
	          },
	          "DirectoryId": {},
	          "InboundCallsEnabled": {
	            "type": "boolean"
	          },
	          "OutboundCallsEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Id": {},
	          "Arn": {}
	        }
	      }
	    },
	    "CreateIntegrationAssociation": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/instance/{InstanceId}/integration-associations"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "IntegrationType",
	          "IntegrationArn"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "IntegrationType": {},
	          "IntegrationArn": {},
	          "SourceApplicationUrl": {},
	          "SourceApplicationName": {},
	          "SourceType": {},
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IntegrationAssociationId": {},
	          "IntegrationAssociationArn": {}
	        }
	      }
	    },
	    "CreateQueue": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/queues/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Name",
	          "HoursOfOperationId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Name": {},
	          "Description": {},
	          "OutboundCallerConfig": {
	            "shape": "S2z"
	          },
	          "HoursOfOperationId": {},
	          "MaxContacts": {
	            "type": "integer"
	          },
	          "QuickConnectIds": {
	            "shape": "S13"
	          },
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QueueArn": {},
	          "QueueId": {}
	        }
	      }
	    },
	    "CreateQuickConnect": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/quick-connects/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Name",
	          "QuickConnectConfig"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Name": {},
	          "Description": {},
	          "QuickConnectConfig": {
	            "shape": "S36"
	          },
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QuickConnectARN": {},
	          "QuickConnectId": {}
	        }
	      }
	    },
	    "CreateRoutingProfile": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/routing-profiles/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Name",
	          "Description",
	          "DefaultOutboundQueueId",
	          "MediaConcurrencies"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Name": {},
	          "Description": {},
	          "DefaultOutboundQueueId": {},
	          "QueueConfigs": {
	            "shape": "S17"
	          },
	          "MediaConcurrencies": {
	            "shape": "S3g"
	          },
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RoutingProfileArn": {},
	          "RoutingProfileId": {}
	        }
	      }
	    },
	    "CreateSecurityProfile": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/security-profiles/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecurityProfileName",
	          "InstanceId"
	        ],
	        "members": {
	          "SecurityProfileName": {},
	          "Description": {},
	          "Permissions": {
	            "shape": "S3n"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SecurityProfileId": {},
	          "SecurityProfileArn": {}
	        }
	      }
	    },
	    "CreateTaskTemplate": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/instance/{InstanceId}/task/template"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Name",
	          "Fields"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Name": {},
	          "Description": {},
	          "ContactFlowId": {},
	          "Constraints": {
	            "shape": "S3u"
	          },
	          "Defaults": {
	            "shape": "S43"
	          },
	          "Status": {},
	          "Fields": {
	            "shape": "S48"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Id",
	          "Arn"
	        ],
	        "members": {
	          "Id": {},
	          "Arn": {}
	        }
	      }
	    },
	    "CreateUseCase": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}/use-cases"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "IntegrationAssociationId",
	          "UseCaseType"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "IntegrationAssociationId": {
	            "location": "uri",
	            "locationName": "IntegrationAssociationId"
	          },
	          "UseCaseType": {},
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UseCaseId": {},
	          "UseCaseArn": {}
	        }
	      }
	    },
	    "CreateUser": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/users/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Username",
	          "PhoneConfig",
	          "SecurityProfileIds",
	          "RoutingProfileId",
	          "InstanceId"
	        ],
	        "members": {
	          "Username": {},
	          "Password": {},
	          "IdentityInfo": {
	            "shape": "S4o"
	          },
	          "PhoneConfig": {
	            "shape": "S4s"
	          },
	          "DirectoryUserId": {},
	          "SecurityProfileIds": {
	            "shape": "S4x"
	          },
	          "RoutingProfileId": {},
	          "HierarchyGroupId": {},
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserId": {},
	          "UserArn": {}
	        }
	      }
	    },
	    "CreateUserHierarchyGroup": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/user-hierarchy-groups/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "InstanceId"
	        ],
	        "members": {
	          "Name": {},
	          "ParentGroupId": {},
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HierarchyGroupId": {},
	          "HierarchyGroupArn": {}
	        }
	      }
	    },
	    "CreateVocabulary": {
	      "http": {
	        "requestUri": "/vocabulary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "VocabularyName",
	          "LanguageCode",
	          "Content"
	        ],
	        "members": {
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "VocabularyName": {},
	          "LanguageCode": {},
	          "Content": {},
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "VocabularyArn",
	          "VocabularyId",
	          "State"
	        ],
	        "members": {
	          "VocabularyArn": {},
	          "VocabularyId": {},
	          "State": {}
	        }
	      }
	    },
	    "DeleteContactFlow": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/contact-flows/{InstanceId}/{ContactFlowId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactFlowId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactFlowId": {
	            "location": "uri",
	            "locationName": "ContactFlowId"
	          }
	        }
	      }
	    },
	    "DeleteContactFlowModule": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactFlowModuleId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactFlowModuleId": {
	            "location": "uri",
	            "locationName": "ContactFlowModuleId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteHoursOfOperation": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/hours-of-operations/{InstanceId}/{HoursOfOperationId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "HoursOfOperationId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "HoursOfOperationId": {
	            "location": "uri",
	            "locationName": "HoursOfOperationId"
	          }
	        }
	      }
	    },
	    "DeleteInstance": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/instance/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      }
	    },
	    "DeleteIntegrationAssociation": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "IntegrationAssociationId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "IntegrationAssociationId": {
	            "location": "uri",
	            "locationName": "IntegrationAssociationId"
	          }
	        }
	      }
	    },
	    "DeleteQuickConnect": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/quick-connects/{InstanceId}/{QuickConnectId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QuickConnectId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QuickConnectId": {
	            "location": "uri",
	            "locationName": "QuickConnectId"
	          }
	        }
	      }
	    },
	    "DeleteSecurityProfile": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/security-profiles/{InstanceId}/{SecurityProfileId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "SecurityProfileId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "SecurityProfileId": {
	            "location": "uri",
	            "locationName": "SecurityProfileId"
	          }
	        }
	      }
	    },
	    "DeleteTaskTemplate": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/instance/{InstanceId}/task/template/{TaskTemplateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "TaskTemplateId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "TaskTemplateId": {
	            "location": "uri",
	            "locationName": "TaskTemplateId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteUseCase": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}/use-cases/{UseCaseId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "IntegrationAssociationId",
	          "UseCaseId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "IntegrationAssociationId": {
	            "location": "uri",
	            "locationName": "IntegrationAssociationId"
	          },
	          "UseCaseId": {
	            "location": "uri",
	            "locationName": "UseCaseId"
	          }
	        }
	      }
	    },
	    "DeleteUser": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/users/{InstanceId}/{UserId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "UserId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          }
	        }
	      }
	    },
	    "DeleteUserHierarchyGroup": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/user-hierarchy-groups/{InstanceId}/{HierarchyGroupId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HierarchyGroupId",
	          "InstanceId"
	        ],
	        "members": {
	          "HierarchyGroupId": {
	            "location": "uri",
	            "locationName": "HierarchyGroupId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      }
	    },
	    "DeleteVocabulary": {
	      "http": {
	        "requestUri": "/vocabulary-remove/{InstanceId}/{VocabularyId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "VocabularyId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "VocabularyId": {
	            "location": "uri",
	            "locationName": "VocabularyId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "VocabularyArn",
	          "VocabularyId",
	          "State"
	        ],
	        "members": {
	          "VocabularyArn": {},
	          "VocabularyId": {},
	          "State": {}
	        }
	      }
	    },
	    "DescribeAgentStatus": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/agent-status/{InstanceId}/{AgentStatusId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "AgentStatusId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "AgentStatusId": {
	            "location": "uri",
	            "locationName": "AgentStatusId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AgentStatus": {
	            "type": "structure",
	            "members": {
	              "AgentStatusARN": {},
	              "AgentStatusId": {},
	              "Name": {},
	              "Description": {},
	              "Type": {},
	              "DisplayOrder": {
	                "type": "integer"
	              },
	              "State": {},
	              "Tags": {
	                "shape": "S1j"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeContact": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/contacts/{InstanceId}/{ContactId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactId": {
	            "location": "uri",
	            "locationName": "ContactId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Contact": {
	            "type": "structure",
	            "members": {
	              "Arn": {},
	              "Id": {},
	              "InitialContactId": {},
	              "PreviousContactId": {},
	              "InitiationMethod": {},
	              "Name": {},
	              "Description": {},
	              "Channel": {},
	              "QueueInfo": {
	                "type": "structure",
	                "members": {
	                  "Id": {},
	                  "EnqueueTimestamp": {
	                    "type": "timestamp"
	                  }
	                }
	              },
	              "AgentInfo": {
	                "type": "structure",
	                "members": {
	                  "Id": {},
	                  "ConnectedToAgentTimestamp": {
	                    "type": "timestamp"
	                  }
	                }
	              },
	              "InitiationTimestamp": {
	                "type": "timestamp"
	              },
	              "DisconnectTimestamp": {
	                "type": "timestamp"
	              },
	              "LastUpdateTimestamp": {
	                "type": "timestamp"
	              },
	              "ScheduledTimestamp": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeContactFlow": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/contact-flows/{InstanceId}/{ContactFlowId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactFlowId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactFlowId": {
	            "location": "uri",
	            "locationName": "ContactFlowId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContactFlow": {
	            "type": "structure",
	            "members": {
	              "Arn": {},
	              "Id": {},
	              "Name": {},
	              "Type": {},
	              "State": {},
	              "Description": {},
	              "Content": {},
	              "Tags": {
	                "shape": "S1j"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeContactFlowModule": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactFlowModuleId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactFlowModuleId": {
	            "location": "uri",
	            "locationName": "ContactFlowModuleId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContactFlowModule": {
	            "type": "structure",
	            "members": {
	              "Arn": {},
	              "Id": {},
	              "Name": {},
	              "Content": {},
	              "Description": {},
	              "State": {},
	              "Status": {},
	              "Tags": {
	                "shape": "S1j"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeHoursOfOperation": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/hours-of-operations/{InstanceId}/{HoursOfOperationId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "HoursOfOperationId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "HoursOfOperationId": {
	            "location": "uri",
	            "locationName": "HoursOfOperationId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HoursOfOperation": {
	            "type": "structure",
	            "members": {
	              "HoursOfOperationId": {},
	              "HoursOfOperationArn": {},
	              "Name": {},
	              "Description": {},
	              "TimeZone": {},
	              "Config": {
	                "shape": "S2b"
	              },
	              "Tags": {
	                "shape": "S1j"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeInstance": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Instance": {
	            "type": "structure",
	            "members": {
	              "Id": {},
	              "Arn": {},
	              "IdentityManagementType": {},
	              "InstanceAlias": {
	                "shape": "S2l"
	              },
	              "CreatedTime": {
	                "type": "timestamp"
	              },
	              "ServiceRole": {},
	              "InstanceStatus": {},
	              "StatusReason": {
	                "type": "structure",
	                "members": {
	                  "Message": {}
	                }
	              },
	              "InboundCallsEnabled": {
	                "type": "boolean"
	              },
	              "OutboundCallsEnabled": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeInstanceAttribute": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/attribute/{AttributeType}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "AttributeType"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "AttributeType": {
	            "location": "uri",
	            "locationName": "AttributeType"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Attribute": {
	            "shape": "S6o"
	          }
	        }
	      }
	    },
	    "DescribeInstanceStorageConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/storage-config/{AssociationId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "AssociationId",
	          "ResourceType"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "AssociationId": {
	            "location": "uri",
	            "locationName": "AssociationId"
	          },
	          "ResourceType": {
	            "location": "querystring",
	            "locationName": "resourceType"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StorageConfig": {
	            "shape": "Sg"
	          }
	        }
	      }
	    },
	    "DescribePhoneNumber": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/phone-number/{PhoneNumberId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PhoneNumberId"
	        ],
	        "members": {
	          "PhoneNumberId": {
	            "location": "uri",
	            "locationName": "PhoneNumberId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClaimedPhoneNumberSummary": {
	            "type": "structure",
	            "members": {
	              "PhoneNumberId": {},
	              "PhoneNumberArn": {},
	              "PhoneNumber": {},
	              "PhoneNumberCountryCode": {},
	              "PhoneNumberType": {},
	              "PhoneNumberDescription": {},
	              "TargetArn": {},
	              "Tags": {
	                "shape": "S1j"
	              },
	              "PhoneNumberStatus": {
	                "type": "structure",
	                "members": {
	                  "Status": {},
	                  "Message": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeQueue": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/queues/{InstanceId}/{QueueId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QueueId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QueueId": {
	            "location": "uri",
	            "locationName": "QueueId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Queue": {
	            "type": "structure",
	            "members": {
	              "Name": {},
	              "QueueArn": {},
	              "QueueId": {},
	              "Description": {},
	              "OutboundCallerConfig": {
	                "shape": "S2z"
	              },
	              "HoursOfOperationId": {},
	              "MaxContacts": {
	                "type": "integer"
	              },
	              "Status": {},
	              "Tags": {
	                "shape": "S1j"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeQuickConnect": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/quick-connects/{InstanceId}/{QuickConnectId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QuickConnectId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QuickConnectId": {
	            "location": "uri",
	            "locationName": "QuickConnectId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QuickConnect": {
	            "type": "structure",
	            "members": {
	              "QuickConnectARN": {},
	              "QuickConnectId": {},
	              "Name": {},
	              "Description": {},
	              "QuickConnectConfig": {
	                "shape": "S36"
	              },
	              "Tags": {
	                "shape": "S1j"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeRoutingProfile": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/routing-profiles/{InstanceId}/{RoutingProfileId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "RoutingProfileId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "RoutingProfileId": {
	            "location": "uri",
	            "locationName": "RoutingProfileId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RoutingProfile": {
	            "type": "structure",
	            "members": {
	              "InstanceId": {},
	              "Name": {},
	              "RoutingProfileArn": {},
	              "RoutingProfileId": {},
	              "Description": {},
	              "MediaConcurrencies": {
	                "shape": "S3g"
	              },
	              "DefaultOutboundQueueId": {},
	              "Tags": {
	                "shape": "S1j"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeSecurityProfile": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/security-profiles/{InstanceId}/{SecurityProfileId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecurityProfileId",
	          "InstanceId"
	        ],
	        "members": {
	          "SecurityProfileId": {
	            "location": "uri",
	            "locationName": "SecurityProfileId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SecurityProfile": {
	            "type": "structure",
	            "members": {
	              "Id": {},
	              "OrganizationResourceId": {},
	              "Arn": {},
	              "SecurityProfileName": {},
	              "Description": {},
	              "Tags": {
	                "shape": "S1j"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeUser": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/users/{InstanceId}/{UserId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserId",
	          "InstanceId"
	        ],
	        "members": {
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "User": {
	            "type": "structure",
	            "members": {
	              "Id": {},
	              "Arn": {},
	              "Username": {},
	              "IdentityInfo": {
	                "shape": "S4o"
	              },
	              "PhoneConfig": {
	                "shape": "S4s"
	              },
	              "DirectoryUserId": {},
	              "SecurityProfileIds": {
	                "shape": "S4x"
	              },
	              "RoutingProfileId": {},
	              "HierarchyGroupId": {},
	              "Tags": {
	                "shape": "S1j"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeUserHierarchyGroup": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/user-hierarchy-groups/{InstanceId}/{HierarchyGroupId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HierarchyGroupId",
	          "InstanceId"
	        ],
	        "members": {
	          "HierarchyGroupId": {
	            "location": "uri",
	            "locationName": "HierarchyGroupId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HierarchyGroup": {
	            "type": "structure",
	            "members": {
	              "Id": {},
	              "Arn": {},
	              "Name": {},
	              "LevelId": {},
	              "HierarchyPath": {
	                "type": "structure",
	                "members": {
	                  "LevelOne": {
	                    "shape": "S7l"
	                  },
	                  "LevelTwo": {
	                    "shape": "S7l"
	                  },
	                  "LevelThree": {
	                    "shape": "S7l"
	                  },
	                  "LevelFour": {
	                    "shape": "S7l"
	                  },
	                  "LevelFive": {
	                    "shape": "S7l"
	                  }
	                }
	              },
	              "Tags": {
	                "shape": "S1j"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeUserHierarchyStructure": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/user-hierarchy-structure/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HierarchyStructure": {
	            "type": "structure",
	            "members": {
	              "LevelOne": {
	                "shape": "S7p"
	              },
	              "LevelTwo": {
	                "shape": "S7p"
	              },
	              "LevelThree": {
	                "shape": "S7p"
	              },
	              "LevelFour": {
	                "shape": "S7p"
	              },
	              "LevelFive": {
	                "shape": "S7p"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeVocabulary": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/vocabulary/{InstanceId}/{VocabularyId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "VocabularyId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "VocabularyId": {
	            "location": "uri",
	            "locationName": "VocabularyId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Vocabulary"
	        ],
	        "members": {
	          "Vocabulary": {
	            "type": "structure",
	            "required": [
	              "Name",
	              "Id",
	              "Arn",
	              "LanguageCode",
	              "State",
	              "LastModifiedTime"
	            ],
	            "members": {
	              "Name": {},
	              "Id": {},
	              "Arn": {},
	              "LanguageCode": {},
	              "State": {},
	              "LastModifiedTime": {
	                "type": "timestamp"
	              },
	              "FailureReason": {},
	              "Content": {},
	              "Tags": {
	                "shape": "S1j"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DisassociateApprovedOrigin": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/instance/{InstanceId}/approved-origin"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Origin"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Origin": {
	            "location": "querystring",
	            "locationName": "origin"
	          }
	        }
	      }
	    },
	    "DisassociateBot": {
	      "http": {
	        "requestUri": "/instance/{InstanceId}/bot"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "LexBot": {
	            "shape": "S5"
	          },
	          "LexV2Bot": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "DisassociateInstanceStorageConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/instance/{InstanceId}/storage-config/{AssociationId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "AssociationId",
	          "ResourceType"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "AssociationId": {
	            "location": "uri",
	            "locationName": "AssociationId"
	          },
	          "ResourceType": {
	            "location": "querystring",
	            "locationName": "resourceType"
	          }
	        }
	      }
	    },
	    "DisassociateLambdaFunction": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/instance/{InstanceId}/lambda-function"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "FunctionArn"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "FunctionArn": {
	            "location": "querystring",
	            "locationName": "functionArn"
	          }
	        }
	      }
	    },
	    "DisassociateLexBot": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/instance/{InstanceId}/lex-bot"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "BotName",
	          "LexRegion"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "BotName": {
	            "location": "querystring",
	            "locationName": "botName"
	          },
	          "LexRegion": {
	            "location": "querystring",
	            "locationName": "lexRegion"
	          }
	        }
	      }
	    },
	    "DisassociatePhoneNumberContactFlow": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/phone-number/{PhoneNumberId}/contact-flow"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PhoneNumberId",
	          "InstanceId"
	        ],
	        "members": {
	          "PhoneNumberId": {
	            "location": "uri",
	            "locationName": "PhoneNumberId"
	          },
	          "InstanceId": {
	            "location": "querystring",
	            "locationName": "instanceId"
	          }
	        }
	      }
	    },
	    "DisassociateQueueQuickConnects": {
	      "http": {
	        "requestUri": "/queues/{InstanceId}/{QueueId}/disassociate-quick-connects"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QueueId",
	          "QuickConnectIds"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QueueId": {
	            "location": "uri",
	            "locationName": "QueueId"
	          },
	          "QuickConnectIds": {
	            "shape": "S13"
	          }
	        }
	      }
	    },
	    "DisassociateRoutingProfileQueues": {
	      "http": {
	        "requestUri": "/routing-profiles/{InstanceId}/{RoutingProfileId}/disassociate-queues"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "RoutingProfileId",
	          "QueueReferences"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "RoutingProfileId": {
	            "location": "uri",
	            "locationName": "RoutingProfileId"
	          },
	          "QueueReferences": {
	            "type": "list",
	            "member": {
	              "shape": "S19"
	            }
	          }
	        }
	      }
	    },
	    "DisassociateSecurityKey": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/instance/{InstanceId}/security-key/{AssociationId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "AssociationId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "AssociationId": {
	            "location": "uri",
	            "locationName": "AssociationId"
	          }
	        }
	      }
	    },
	    "GetContactAttributes": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/contact/attributes/{InstanceId}/{InitialContactId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "InitialContactId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "InitialContactId": {
	            "location": "uri",
	            "locationName": "InitialContactId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "S88"
	          }
	        }
	      }
	    },
	    "GetCurrentMetricData": {
	      "http": {
	        "requestUri": "/metrics/current/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Filters",
	          "CurrentMetrics"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Filters": {
	            "shape": "S8c"
	          },
	          "Groupings": {
	            "shape": "S8f"
	          },
	          "CurrentMetrics": {
	            "type": "list",
	            "member": {
	              "shape": "S8i"
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MetricResults": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Dimensions": {
	                  "shape": "S8q"
	                },
	                "Collections": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Metric": {
	                        "shape": "S8i"
	                      },
	                      "Value": {
	                        "type": "double"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "DataSnapshotTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetCurrentUserData": {
	      "http": {
	        "requestUri": "/metrics/userdata/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Filters"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "Queues": {
	                "shape": "S8d"
	              },
	              "ContactFilter": {
	                "type": "structure",
	                "members": {
	                  "ContactStates": {
	                    "type": "list",
	                    "member": {}
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "UserDataList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "User": {
	                  "type": "structure",
	                  "members": {
	                    "Id": {},
	                    "Arn": {}
	                  }
	                },
	                "RoutingProfile": {
	                  "type": "structure",
	                  "members": {
	                    "Id": {},
	                    "Arn": {}
	                  }
	                },
	                "HierarchyPath": {
	                  "type": "structure",
	                  "members": {
	                    "LevelOne": {
	                      "shape": "S96"
	                    },
	                    "LevelTwo": {
	                      "shape": "S96"
	                    },
	                    "LevelThree": {
	                      "shape": "S96"
	                    },
	                    "LevelFour": {
	                      "shape": "S96"
	                    },
	                    "LevelFive": {
	                      "shape": "S96"
	                    }
	                  }
	                },
	                "Status": {
	                  "type": "structure",
	                  "members": {
	                    "StatusStartTimestamp": {
	                      "type": "timestamp"
	                    },
	                    "StatusArn": {}
	                  }
	                },
	                "AvailableSlotsByChannel": {
	                  "shape": "S98"
	                },
	                "MaxSlotsByChannel": {
	                  "shape": "S98"
	                },
	                "ActiveSlotsByChannel": {
	                  "shape": "S98"
	                },
	                "Contacts": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "ContactId": {},
	                      "Channel": {},
	                      "InitiationMethod": {},
	                      "AgentContactState": {},
	                      "StateStartTimestamp": {
	                        "type": "timestamp"
	                      },
	                      "ConnectedToAgentTimestamp": {
	                        "type": "timestamp"
	                      },
	                      "Queue": {
	                        "shape": "S8r"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetFederationToken": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/user/federate/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Credentials": {
	            "type": "structure",
	            "members": {
	              "AccessToken": {
	                "shape": "S9f"
	              },
	              "AccessTokenExpiration": {
	                "type": "timestamp"
	              },
	              "RefreshToken": {
	                "shape": "S9f"
	              },
	              "RefreshTokenExpiration": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetMetricData": {
	      "http": {
	        "requestUri": "/metrics/historical/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "StartTime",
	          "EndTime",
	          "Filters",
	          "HistoricalMetrics"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Filters": {
	            "shape": "S8c"
	          },
	          "Groupings": {
	            "shape": "S8f"
	          },
	          "HistoricalMetrics": {
	            "type": "list",
	            "member": {
	              "shape": "S9i"
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MetricResults": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Dimensions": {
	                  "shape": "S8q"
	                },
	                "Collections": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Metric": {
	                        "shape": "S9i"
	                      },
	                      "Value": {
	                        "type": "double"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetTaskTemplate": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/task/template/{TaskTemplateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "TaskTemplateId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "TaskTemplateId": {
	            "location": "uri",
	            "locationName": "TaskTemplateId"
	          },
	          "SnapshotVersion": {
	            "location": "querystring",
	            "locationName": "snapshotVersion"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Id",
	          "Arn",
	          "Name"
	        ],
	        "members": {
	          "InstanceId": {},
	          "Id": {},
	          "Arn": {},
	          "Name": {},
	          "Description": {},
	          "ContactFlowId": {},
	          "Constraints": {
	            "shape": "S3u"
	          },
	          "Defaults": {
	            "shape": "S43"
	          },
	          "Fields": {
	            "shape": "S48"
	          },
	          "Status": {},
	          "LastModifiedTime": {
	            "type": "timestamp"
	          },
	          "CreatedTime": {
	            "type": "timestamp"
	          },
	          "Tags": {
	            "shape": "S1j"
	          }
	        }
	      }
	    },
	    "ListAgentStatuses": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/agent-status/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "AgentStatusTypes": {
	            "location": "querystring",
	            "locationName": "AgentStatusTypes",
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "AgentStatusSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "Name": {},
	                "Type": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListApprovedOrigins": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/approved-origins"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Origins": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListBots": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/bots"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "LexVersion"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "LexVersion": {
	            "location": "querystring",
	            "locationName": "lexVersion"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LexBots": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "LexBot": {
	                  "shape": "S5"
	                },
	                "LexV2Bot": {
	                  "shape": "S8"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListContactFlowModules": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/contact-flow-modules-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "ContactFlowModuleState": {
	            "location": "querystring",
	            "locationName": "state"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContactFlowModulesSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "Name": {},
	                "State": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListContactFlows": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/contact-flows-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactFlowTypes": {
	            "location": "querystring",
	            "locationName": "contactFlowTypes",
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContactFlowSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "Name": {},
	                "ContactFlowType": {},
	                "ContactFlowState": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListContactReferences": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/contact/references/{InstanceId}/{ContactId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactId",
	          "ReferenceTypes"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactId": {
	            "location": "uri",
	            "locationName": "ContactId"
	          },
	          "ReferenceTypes": {
	            "location": "querystring",
	            "locationName": "referenceTypes",
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReferenceSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Url": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {},
	                    "Value": {}
	                  }
	                },
	                "Attachment": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {},
	                    "Value": {},
	                    "Status": {}
	                  }
	                },
	                "String": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {},
	                    "Value": {}
	                  }
	                },
	                "Number": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {},
	                    "Value": {}
	                  }
	                },
	                "Date": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {},
	                    "Value": {}
	                  }
	                },
	                "Email": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {},
	                    "Value": {}
	                  }
	                }
	              },
	              "union": true
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListDefaultVocabularies": {
	      "http": {
	        "requestUri": "/default-vocabulary-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "LanguageCode": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "DefaultVocabularyList"
	        ],
	        "members": {
	          "DefaultVocabularyList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "InstanceId",
	                "LanguageCode",
	                "VocabularyId",
	                "VocabularyName"
	              ],
	              "members": {
	                "InstanceId": {},
	                "LanguageCode": {},
	                "VocabularyId": {},
	                "VocabularyName": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListHoursOfOperations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/hours-of-operations-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HoursOfOperationSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "Name": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListInstanceAttributes": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/attributes"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "type": "list",
	            "member": {
	              "shape": "S6o"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListInstanceStorageConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/storage-configs"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ResourceType"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ResourceType": {
	            "location": "querystring",
	            "locationName": "resourceType"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StorageConfigs": {
	            "type": "list",
	            "member": {
	              "shape": "Sg"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListInstances": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "IdentityManagementType": {},
	                "InstanceAlias": {
	                  "shape": "S2l"
	                },
	                "CreatedTime": {
	                  "type": "timestamp"
	                },
	                "ServiceRole": {},
	                "InstanceStatus": {},
	                "InboundCallsEnabled": {
	                  "type": "boolean"
	                },
	                "OutboundCallsEnabled": {
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListIntegrationAssociations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/integration-associations"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "IntegrationType": {
	            "location": "querystring",
	            "locationName": "integrationType"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IntegrationAssociationSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "IntegrationAssociationId": {},
	                "IntegrationAssociationArn": {},
	                "InstanceId": {},
	                "IntegrationType": {},
	                "IntegrationArn": {},
	                "SourceApplicationUrl": {},
	                "SourceApplicationName": {},
	                "SourceType": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListLambdaFunctions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/lambda-functions"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LambdaFunctions": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListLexBots": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/lex-bots"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LexBots": {
	            "type": "list",
	            "member": {
	              "shape": "S5"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListPhoneNumbers": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/phone-numbers-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "PhoneNumberTypes": {
	            "shape": "Sbw",
	            "location": "querystring",
	            "locationName": "phoneNumberTypes"
	          },
	          "PhoneNumberCountryCodes": {
	            "shape": "Sbx",
	            "location": "querystring",
	            "locationName": "phoneNumberCountryCodes"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PhoneNumberSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "PhoneNumber": {},
	                "PhoneNumberType": {},
	                "PhoneNumberCountryCode": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListPhoneNumbersV2": {
	      "http": {
	        "requestUri": "/phone-number/list"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "TargetArn": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "PhoneNumberCountryCodes": {
	            "shape": "Sbx"
	          },
	          "PhoneNumberTypes": {
	            "shape": "Sbw"
	          },
	          "PhoneNumberPrefix": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "ListPhoneNumbersSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PhoneNumberId": {},
	                "PhoneNumberArn": {},
	                "PhoneNumber": {},
	                "PhoneNumberCountryCode": {},
	                "PhoneNumberType": {},
	                "TargetArn": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListPrompts": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/prompts-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PromptSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "Name": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListQueueQuickConnects": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/queues/{InstanceId}/{QueueId}/quick-connects"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QueueId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QueueId": {
	            "location": "uri",
	            "locationName": "QueueId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "QuickConnectSummaryList": {
	            "shape": "Scf"
	          }
	        }
	      }
	    },
	    "ListQueues": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/queues-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QueueTypes": {
	            "location": "querystring",
	            "locationName": "queueTypes",
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QueueSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "Name": {},
	                "QueueType": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListQuickConnects": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/quick-connects/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "QuickConnectTypes": {
	            "location": "querystring",
	            "locationName": "QuickConnectTypes",
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QuickConnectSummaryList": {
	            "shape": "Scf"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListRoutingProfileQueues": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/routing-profiles/{InstanceId}/{RoutingProfileId}/queues"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "RoutingProfileId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "RoutingProfileId": {
	            "location": "uri",
	            "locationName": "RoutingProfileId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "RoutingProfileQueueConfigSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "QueueId",
	                "QueueArn",
	                "QueueName",
	                "Priority",
	                "Delay",
	                "Channel"
	              ],
	              "members": {
	                "QueueId": {},
	                "QueueArn": {},
	                "QueueName": {},
	                "Priority": {
	                  "type": "integer"
	                },
	                "Delay": {
	                  "type": "integer"
	                },
	                "Channel": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListRoutingProfiles": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/routing-profiles-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RoutingProfileSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "Name": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListSecurityKeys": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/security-keys"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SecurityKeys": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AssociationId": {},
	                "Key": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListSecurityProfilePermissions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/security-profiles-permissions/{InstanceId}/{SecurityProfileId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecurityProfileId",
	          "InstanceId"
	        ],
	        "members": {
	          "SecurityProfileId": {
	            "location": "uri",
	            "locationName": "SecurityProfileId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Permissions": {
	            "shape": "S3n"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListSecurityProfiles": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/security-profiles-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SecurityProfileSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "Name": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/tags/{resourceArn}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "uri",
	            "locationName": "resourceArn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tags": {
	            "shape": "S1j"
	          }
	        }
	      }
	    },
	    "ListTaskTemplates": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/task/template"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "Status": {
	            "location": "querystring",
	            "locationName": "status"
	          },
	          "Name": {
	            "location": "querystring",
	            "locationName": "name"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TaskTemplates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "Name": {},
	                "Description": {},
	                "Status": {},
	                "LastModifiedTime": {
	                  "type": "timestamp"
	                },
	                "CreatedTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListUseCases": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}/use-cases"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "IntegrationAssociationId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "IntegrationAssociationId": {
	            "location": "uri",
	            "locationName": "IntegrationAssociationId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UseCaseSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "UseCaseId": {},
	                "UseCaseArn": {},
	                "UseCaseType": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListUserHierarchyGroups": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/user-hierarchy-groups-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserHierarchyGroupSummaryList": {
	            "type": "list",
	            "member": {
	              "shape": "S7l"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListUsers": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/users-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Arn": {},
	                "Username": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PutUserStatus": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/users/{InstanceId}/{UserId}/status"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserId",
	          "InstanceId",
	          "AgentStatusId"
	        ],
	        "members": {
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "AgentStatusId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ReleasePhoneNumber": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/phone-number/{PhoneNumberId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PhoneNumberId"
	        ],
	        "members": {
	          "PhoneNumberId": {
	            "location": "uri",
	            "locationName": "PhoneNumberId"
	          },
	          "ClientToken": {
	            "idempotencyToken": true,
	            "location": "querystring",
	            "locationName": "clientToken"
	          }
	        }
	      }
	    },
	    "ResumeContactRecording": {
	      "http": {
	        "requestUri": "/contact/resume-recording"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactId",
	          "InitialContactId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ContactId": {},
	          "InitialContactId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SearchAvailablePhoneNumbers": {
	      "http": {
	        "requestUri": "/phone-number/search-available"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetArn",
	          "PhoneNumberCountryCode",
	          "PhoneNumberType"
	        ],
	        "members": {
	          "TargetArn": {},
	          "PhoneNumberCountryCode": {},
	          "PhoneNumberType": {},
	          "PhoneNumberPrefix": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "AvailableNumbersList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PhoneNumber": {},
	                "PhoneNumberCountryCode": {},
	                "PhoneNumberType": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "SearchUsers": {
	      "http": {
	        "requestUri": "/search-users"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "SearchFilter": {
	            "type": "structure",
	            "members": {
	              "TagFilter": {
	                "type": "structure",
	                "members": {
	                  "OrConditions": {
	                    "type": "list",
	                    "member": {
	                      "shape": "Se5"
	                    }
	                  },
	                  "AndConditions": {
	                    "shape": "Se5"
	                  },
	                  "TagCondition": {
	                    "shape": "Se6"
	                  }
	                }
	              }
	            }
	          },
	          "SearchCriteria": {
	            "shape": "Se7"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Users": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Arn": {},
	                "DirectoryUserId": {},
	                "HierarchyGroupId": {},
	                "Id": {},
	                "IdentityInfo": {
	                  "type": "structure",
	                  "members": {
	                    "FirstName": {},
	                    "LastName": {}
	                  }
	                },
	                "PhoneConfig": {
	                  "shape": "S4s"
	                },
	                "RoutingProfileId": {},
	                "SecurityProfileIds": {
	                  "shape": "S4x"
	                },
	                "Tags": {
	                  "shape": "S1j"
	                },
	                "Username": {}
	              }
	            }
	          },
	          "NextToken": {},
	          "ApproximateTotalCount": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "SearchVocabularies": {
	      "http": {
	        "requestUri": "/vocabulary-summary/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "State": {},
	          "NameStartsWith": {},
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VocabularySummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Name",
	                "Id",
	                "Arn",
	                "LanguageCode",
	                "State",
	                "LastModifiedTime"
	              ],
	              "members": {
	                "Name": {},
	                "Id": {},
	                "Arn": {},
	                "LanguageCode": {},
	                "State": {},
	                "LastModifiedTime": {
	                  "type": "timestamp"
	                },
	                "FailureReason": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "StartChatContact": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/contact/chat"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactFlowId",
	          "ParticipantDetails"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ContactFlowId": {},
	          "Attributes": {
	            "shape": "S88"
	          },
	          "ParticipantDetails": {
	            "type": "structure",
	            "required": [
	              "DisplayName"
	            ],
	            "members": {
	              "DisplayName": {}
	            }
	          },
	          "InitialMessage": {
	            "type": "structure",
	            "required": [
	              "ContentType",
	              "Content"
	            ],
	            "members": {
	              "ContentType": {},
	              "Content": {}
	            }
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "ChatDurationInMinutes": {
	            "type": "integer"
	          },
	          "SupportedMessagingContentTypes": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContactId": {},
	          "ParticipantId": {},
	          "ParticipantToken": {}
	        }
	      }
	    },
	    "StartContactRecording": {
	      "http": {
	        "requestUri": "/contact/start-recording"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactId",
	          "InitialContactId",
	          "VoiceRecordingConfiguration"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ContactId": {},
	          "InitialContactId": {},
	          "VoiceRecordingConfiguration": {
	            "type": "structure",
	            "members": {
	              "VoiceRecordingTrack": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "StartContactStreaming": {
	      "http": {
	        "requestUri": "/contact/start-streaming"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactId",
	          "ChatStreamingConfiguration",
	          "ClientToken"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ContactId": {},
	          "ChatStreamingConfiguration": {
	            "type": "structure",
	            "required": [
	              "StreamingEndpointArn"
	            ],
	            "members": {
	              "StreamingEndpointArn": {}
	            }
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "StreamingId"
	        ],
	        "members": {
	          "StreamingId": {}
	        }
	      }
	    },
	    "StartOutboundVoiceContact": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/contact/outbound-voice"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DestinationPhoneNumber",
	          "ContactFlowId",
	          "InstanceId"
	        ],
	        "members": {
	          "DestinationPhoneNumber": {},
	          "ContactFlowId": {},
	          "InstanceId": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "SourcePhoneNumber": {},
	          "QueueId": {},
	          "Attributes": {
	            "shape": "S88"
	          },
	          "AnswerMachineDetectionConfig": {
	            "type": "structure",
	            "members": {
	              "EnableAnswerMachineDetection": {
	                "type": "boolean"
	              },
	              "AwaitAnswerMachinePrompt": {
	                "type": "boolean"
	              }
	            }
	          },
	          "CampaignId": {},
	          "TrafficType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContactId": {}
	        }
	      }
	    },
	    "StartTaskContact": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/contact/task"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Name"
	        ],
	        "members": {
	          "InstanceId": {},
	          "PreviousContactId": {},
	          "ContactFlowId": {},
	          "Attributes": {
	            "shape": "S88"
	          },
	          "Name": {},
	          "References": {
	            "shape": "Sfe"
	          },
	          "Description": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "ScheduledTime": {
	            "type": "timestamp"
	          },
	          "TaskTemplateId": {},
	          "QuickConnectId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContactId": {}
	        }
	      }
	    },
	    "StopContact": {
	      "http": {
	        "requestUri": "/contact/stop"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ContactId",
	          "InstanceId"
	        ],
	        "members": {
	          "ContactId": {},
	          "InstanceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "StopContactRecording": {
	      "http": {
	        "requestUri": "/contact/stop-recording"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactId",
	          "InitialContactId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ContactId": {},
	          "InitialContactId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "StopContactStreaming": {
	      "http": {
	        "requestUri": "/contact/stop-streaming"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactId",
	          "StreamingId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ContactId": {},
	          "StreamingId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SuspendContactRecording": {
	      "http": {
	        "requestUri": "/contact/suspend-recording"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactId",
	          "InitialContactId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ContactId": {},
	          "InitialContactId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/tags/{resourceArn}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tags"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "uri",
	            "locationName": "resourceArn"
	          },
	          "tags": {
	            "shape": "S1j"
	          }
	        }
	      }
	    },
	    "TransferContact": {
	      "http": {
	        "requestUri": "/contact/transfer"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactId",
	          "ContactFlowId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ContactId": {},
	          "QueueId": {},
	          "UserId": {},
	          "ContactFlowId": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContactId": {},
	          "ContactArn": {}
	        }
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/tags/{resourceArn}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tagKeys"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "uri",
	            "locationName": "resourceArn"
	          },
	          "tagKeys": {
	            "location": "querystring",
	            "locationName": "tagKeys",
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "UpdateAgentStatus": {
	      "http": {
	        "requestUri": "/agent-status/{InstanceId}/{AgentStatusId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "AgentStatusId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "AgentStatusId": {
	            "location": "uri",
	            "locationName": "AgentStatusId"
	          },
	          "Name": {},
	          "Description": {},
	          "State": {},
	          "DisplayOrder": {
	            "type": "integer"
	          },
	          "ResetOrderNumber": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "UpdateContact": {
	      "http": {
	        "requestUri": "/contacts/{InstanceId}/{ContactId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactId": {
	            "location": "uri",
	            "locationName": "ContactId"
	          },
	          "Name": {},
	          "Description": {},
	          "References": {
	            "shape": "Sfe"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateContactAttributes": {
	      "http": {
	        "requestUri": "/contact/attributes"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InitialContactId",
	          "InstanceId",
	          "Attributes"
	        ],
	        "members": {
	          "InitialContactId": {},
	          "InstanceId": {},
	          "Attributes": {
	            "shape": "S88"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateContactFlowContent": {
	      "http": {
	        "requestUri": "/contact-flows/{InstanceId}/{ContactFlowId}/content"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactFlowId",
	          "Content"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactFlowId": {
	            "location": "uri",
	            "locationName": "ContactFlowId"
	          },
	          "Content": {}
	        }
	      }
	    },
	    "UpdateContactFlowMetadata": {
	      "http": {
	        "requestUri": "/contact-flows/{InstanceId}/{ContactFlowId}/metadata"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactFlowId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactFlowId": {
	            "location": "uri",
	            "locationName": "ContactFlowId"
	          },
	          "Name": {},
	          "Description": {},
	          "ContactFlowState": {}
	        }
	      }
	    },
	    "UpdateContactFlowModuleContent": {
	      "http": {
	        "requestUri": "/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}/content"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactFlowModuleId",
	          "Content"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactFlowModuleId": {
	            "location": "uri",
	            "locationName": "ContactFlowModuleId"
	          },
	          "Content": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateContactFlowModuleMetadata": {
	      "http": {
	        "requestUri": "/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}/metadata"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactFlowModuleId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactFlowModuleId": {
	            "location": "uri",
	            "locationName": "ContactFlowModuleId"
	          },
	          "Name": {},
	          "Description": {},
	          "State": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateContactFlowName": {
	      "http": {
	        "requestUri": "/contact-flows/{InstanceId}/{ContactFlowId}/name"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactFlowId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "ContactFlowId": {
	            "location": "uri",
	            "locationName": "ContactFlowId"
	          },
	          "Name": {},
	          "Description": {}
	        }
	      }
	    },
	    "UpdateContactSchedule": {
	      "http": {
	        "requestUri": "/contact/schedule"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ContactId",
	          "ScheduledTime"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ContactId": {},
	          "ScheduledTime": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateHoursOfOperation": {
	      "http": {
	        "requestUri": "/hours-of-operations/{InstanceId}/{HoursOfOperationId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "HoursOfOperationId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "HoursOfOperationId": {
	            "location": "uri",
	            "locationName": "HoursOfOperationId"
	          },
	          "Name": {},
	          "Description": {},
	          "TimeZone": {},
	          "Config": {
	            "shape": "S2b"
	          }
	        }
	      }
	    },
	    "UpdateInstanceAttribute": {
	      "http": {
	        "requestUri": "/instance/{InstanceId}/attribute/{AttributeType}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "AttributeType",
	          "Value"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "AttributeType": {
	            "location": "uri",
	            "locationName": "AttributeType"
	          },
	          "Value": {}
	        }
	      }
	    },
	    "UpdateInstanceStorageConfig": {
	      "http": {
	        "requestUri": "/instance/{InstanceId}/storage-config/{AssociationId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "AssociationId",
	          "ResourceType",
	          "StorageConfig"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "AssociationId": {
	            "location": "uri",
	            "locationName": "AssociationId"
	          },
	          "ResourceType": {
	            "location": "querystring",
	            "locationName": "resourceType"
	          },
	          "StorageConfig": {
	            "shape": "Sg"
	          }
	        }
	      }
	    },
	    "UpdatePhoneNumber": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/phone-number/{PhoneNumberId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PhoneNumberId",
	          "TargetArn"
	        ],
	        "members": {
	          "PhoneNumberId": {
	            "location": "uri",
	            "locationName": "PhoneNumberId"
	          },
	          "TargetArn": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PhoneNumberId": {},
	          "PhoneNumberArn": {}
	        }
	      }
	    },
	    "UpdateQueueHoursOfOperation": {
	      "http": {
	        "requestUri": "/queues/{InstanceId}/{QueueId}/hours-of-operation"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QueueId",
	          "HoursOfOperationId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QueueId": {
	            "location": "uri",
	            "locationName": "QueueId"
	          },
	          "HoursOfOperationId": {}
	        }
	      }
	    },
	    "UpdateQueueMaxContacts": {
	      "http": {
	        "requestUri": "/queues/{InstanceId}/{QueueId}/max-contacts"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QueueId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QueueId": {
	            "location": "uri",
	            "locationName": "QueueId"
	          },
	          "MaxContacts": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "UpdateQueueName": {
	      "http": {
	        "requestUri": "/queues/{InstanceId}/{QueueId}/name"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QueueId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QueueId": {
	            "location": "uri",
	            "locationName": "QueueId"
	          },
	          "Name": {},
	          "Description": {}
	        }
	      }
	    },
	    "UpdateQueueOutboundCallerConfig": {
	      "http": {
	        "requestUri": "/queues/{InstanceId}/{QueueId}/outbound-caller-config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QueueId",
	          "OutboundCallerConfig"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QueueId": {
	            "location": "uri",
	            "locationName": "QueueId"
	          },
	          "OutboundCallerConfig": {
	            "shape": "S2z"
	          }
	        }
	      }
	    },
	    "UpdateQueueStatus": {
	      "http": {
	        "requestUri": "/queues/{InstanceId}/{QueueId}/status"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QueueId",
	          "Status"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QueueId": {
	            "location": "uri",
	            "locationName": "QueueId"
	          },
	          "Status": {}
	        }
	      }
	    },
	    "UpdateQuickConnectConfig": {
	      "http": {
	        "requestUri": "/quick-connects/{InstanceId}/{QuickConnectId}/config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QuickConnectId",
	          "QuickConnectConfig"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QuickConnectId": {
	            "location": "uri",
	            "locationName": "QuickConnectId"
	          },
	          "QuickConnectConfig": {
	            "shape": "S36"
	          }
	        }
	      }
	    },
	    "UpdateQuickConnectName": {
	      "http": {
	        "requestUri": "/quick-connects/{InstanceId}/{QuickConnectId}/name"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "QuickConnectId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "QuickConnectId": {
	            "location": "uri",
	            "locationName": "QuickConnectId"
	          },
	          "Name": {},
	          "Description": {}
	        }
	      }
	    },
	    "UpdateRoutingProfileConcurrency": {
	      "http": {
	        "requestUri": "/routing-profiles/{InstanceId}/{RoutingProfileId}/concurrency"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "RoutingProfileId",
	          "MediaConcurrencies"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "RoutingProfileId": {
	            "location": "uri",
	            "locationName": "RoutingProfileId"
	          },
	          "MediaConcurrencies": {
	            "shape": "S3g"
	          }
	        }
	      }
	    },
	    "UpdateRoutingProfileDefaultOutboundQueue": {
	      "http": {
	        "requestUri": "/routing-profiles/{InstanceId}/{RoutingProfileId}/default-outbound-queue"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "RoutingProfileId",
	          "DefaultOutboundQueueId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "RoutingProfileId": {
	            "location": "uri",
	            "locationName": "RoutingProfileId"
	          },
	          "DefaultOutboundQueueId": {}
	        }
	      }
	    },
	    "UpdateRoutingProfileName": {
	      "http": {
	        "requestUri": "/routing-profiles/{InstanceId}/{RoutingProfileId}/name"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "RoutingProfileId"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "RoutingProfileId": {
	            "location": "uri",
	            "locationName": "RoutingProfileId"
	          },
	          "Name": {},
	          "Description": {}
	        }
	      }
	    },
	    "UpdateRoutingProfileQueues": {
	      "http": {
	        "requestUri": "/routing-profiles/{InstanceId}/{RoutingProfileId}/queues"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "RoutingProfileId",
	          "QueueConfigs"
	        ],
	        "members": {
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "RoutingProfileId": {
	            "location": "uri",
	            "locationName": "RoutingProfileId"
	          },
	          "QueueConfigs": {
	            "shape": "S17"
	          }
	        }
	      }
	    },
	    "UpdateSecurityProfile": {
	      "http": {
	        "requestUri": "/security-profiles/{InstanceId}/{SecurityProfileId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecurityProfileId",
	          "InstanceId"
	        ],
	        "members": {
	          "Description": {},
	          "Permissions": {
	            "shape": "S3n"
	          },
	          "SecurityProfileId": {
	            "location": "uri",
	            "locationName": "SecurityProfileId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      }
	    },
	    "UpdateTaskTemplate": {
	      "http": {
	        "requestUri": "/instance/{InstanceId}/task/template/{TaskTemplateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TaskTemplateId",
	          "InstanceId"
	        ],
	        "members": {
	          "TaskTemplateId": {
	            "location": "uri",
	            "locationName": "TaskTemplateId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          },
	          "Name": {},
	          "Description": {},
	          "ContactFlowId": {},
	          "Constraints": {
	            "shape": "S3u"
	          },
	          "Defaults": {
	            "shape": "S43"
	          },
	          "Status": {},
	          "Fields": {
	            "shape": "S48"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {},
	          "Id": {},
	          "Arn": {},
	          "Name": {},
	          "Description": {},
	          "ContactFlowId": {},
	          "Constraints": {
	            "shape": "S3u"
	          },
	          "Defaults": {
	            "shape": "S43"
	          },
	          "Fields": {
	            "shape": "S48"
	          },
	          "Status": {},
	          "LastModifiedTime": {
	            "type": "timestamp"
	          },
	          "CreatedTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "UpdateUserHierarchy": {
	      "http": {
	        "requestUri": "/users/{InstanceId}/{UserId}/hierarchy"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserId",
	          "InstanceId"
	        ],
	        "members": {
	          "HierarchyGroupId": {},
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      }
	    },
	    "UpdateUserHierarchyGroupName": {
	      "http": {
	        "requestUri": "/user-hierarchy-groups/{InstanceId}/{HierarchyGroupId}/name"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "HierarchyGroupId",
	          "InstanceId"
	        ],
	        "members": {
	          "Name": {},
	          "HierarchyGroupId": {
	            "location": "uri",
	            "locationName": "HierarchyGroupId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      }
	    },
	    "UpdateUserHierarchyStructure": {
	      "http": {
	        "requestUri": "/user-hierarchy-structure/{InstanceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HierarchyStructure",
	          "InstanceId"
	        ],
	        "members": {
	          "HierarchyStructure": {
	            "type": "structure",
	            "members": {
	              "LevelOne": {
	                "shape": "Sgy"
	              },
	              "LevelTwo": {
	                "shape": "Sgy"
	              },
	              "LevelThree": {
	                "shape": "Sgy"
	              },
	              "LevelFour": {
	                "shape": "Sgy"
	              },
	              "LevelFive": {
	                "shape": "Sgy"
	              }
	            }
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      }
	    },
	    "UpdateUserIdentityInfo": {
	      "http": {
	        "requestUri": "/users/{InstanceId}/{UserId}/identity-info"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IdentityInfo",
	          "UserId",
	          "InstanceId"
	        ],
	        "members": {
	          "IdentityInfo": {
	            "shape": "S4o"
	          },
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      }
	    },
	    "UpdateUserPhoneConfig": {
	      "http": {
	        "requestUri": "/users/{InstanceId}/{UserId}/phone-config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PhoneConfig",
	          "UserId",
	          "InstanceId"
	        ],
	        "members": {
	          "PhoneConfig": {
	            "shape": "S4s"
	          },
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      }
	    },
	    "UpdateUserRoutingProfile": {
	      "http": {
	        "requestUri": "/users/{InstanceId}/{UserId}/routing-profile"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoutingProfileId",
	          "UserId",
	          "InstanceId"
	        ],
	        "members": {
	          "RoutingProfileId": {},
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      }
	    },
	    "UpdateUserSecurityProfiles": {
	      "http": {
	        "requestUri": "/users/{InstanceId}/{UserId}/security-profiles"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecurityProfileIds",
	          "UserId",
	          "InstanceId"
	        ],
	        "members": {
	          "SecurityProfileIds": {
	            "shape": "S4x"
	          },
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          },
	          "InstanceId": {
	            "location": "uri",
	            "locationName": "InstanceId"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S5": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "LexRegion": {}
	      }
	    },
	    "S8": {
	      "type": "structure",
	      "members": {
	        "AliasArn": {}
	      }
	    },
	    "Sg": {
	      "type": "structure",
	      "required": [
	        "StorageType"
	      ],
	      "members": {
	        "AssociationId": {},
	        "StorageType": {},
	        "S3Config": {
	          "type": "structure",
	          "required": [
	            "BucketName",
	            "BucketPrefix"
	          ],
	          "members": {
	            "BucketName": {},
	            "BucketPrefix": {},
	            "EncryptionConfig": {
	              "shape": "Sm"
	            }
	          }
	        },
	        "KinesisVideoStreamConfig": {
	          "type": "structure",
	          "required": [
	            "Prefix",
	            "RetentionPeriodHours",
	            "EncryptionConfig"
	          ],
	          "members": {
	            "Prefix": {},
	            "RetentionPeriodHours": {
	              "type": "integer"
	            },
	            "EncryptionConfig": {
	              "shape": "Sm"
	            }
	          }
	        },
	        "KinesisStreamConfig": {
	          "type": "structure",
	          "required": [
	            "StreamArn"
	          ],
	          "members": {
	            "StreamArn": {}
	          }
	        },
	        "KinesisFirehoseConfig": {
	          "type": "structure",
	          "required": [
	            "FirehoseArn"
	          ],
	          "members": {
	            "FirehoseArn": {}
	          }
	        }
	      }
	    },
	    "Sm": {
	      "type": "structure",
	      "required": [
	        "EncryptionType",
	        "KeyId"
	      ],
	      "members": {
	        "EncryptionType": {},
	        "KeyId": {}
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {}
	    },
	    "S17": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "QueueReference",
	          "Priority",
	          "Delay"
	        ],
	        "members": {
	          "QueueReference": {
	            "shape": "S19"
	          },
	          "Priority": {
	            "type": "integer"
	          },
	          "Delay": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S19": {
	      "type": "structure",
	      "required": [
	        "QueueId",
	        "Channel"
	      ],
	      "members": {
	        "QueueId": {},
	        "Channel": {}
	      }
	    },
	    "S1j": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S2b": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Day",
	          "StartTime",
	          "EndTime"
	        ],
	        "members": {
	          "Day": {},
	          "StartTime": {
	            "shape": "S2e"
	          },
	          "EndTime": {
	            "shape": "S2e"
	          }
	        }
	      }
	    },
	    "S2e": {
	      "type": "structure",
	      "required": [
	        "Hours",
	        "Minutes"
	      ],
	      "members": {
	        "Hours": {
	          "type": "integer"
	        },
	        "Minutes": {
	          "type": "integer"
	        }
	      }
	    },
	    "S2l": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S2z": {
	      "type": "structure",
	      "members": {
	        "OutboundCallerIdName": {},
	        "OutboundCallerIdNumberId": {},
	        "OutboundFlowId": {}
	      }
	    },
	    "S36": {
	      "type": "structure",
	      "required": [
	        "QuickConnectType"
	      ],
	      "members": {
	        "QuickConnectType": {},
	        "UserConfig": {
	          "type": "structure",
	          "required": [
	            "UserId",
	            "ContactFlowId"
	          ],
	          "members": {
	            "UserId": {},
	            "ContactFlowId": {}
	          }
	        },
	        "QueueConfig": {
	          "type": "structure",
	          "required": [
	            "QueueId",
	            "ContactFlowId"
	          ],
	          "members": {
	            "QueueId": {},
	            "ContactFlowId": {}
	          }
	        },
	        "PhoneConfig": {
	          "type": "structure",
	          "required": [
	            "PhoneNumber"
	          ],
	          "members": {
	            "PhoneNumber": {}
	          }
	        }
	      }
	    },
	    "S3g": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Channel",
	          "Concurrency"
	        ],
	        "members": {
	          "Channel": {},
	          "Concurrency": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S3n": {
	      "type": "list",
	      "member": {}
	    },
	    "S3u": {
	      "type": "structure",
	      "members": {
	        "RequiredFields": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Id": {
	                "shape": "S3x"
	              }
	            }
	          }
	        },
	        "ReadOnlyFields": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Id": {
	                "shape": "S3x"
	              }
	            }
	          }
	        },
	        "InvisibleFields": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Id": {
	                "shape": "S3x"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S3x": {
	      "type": "structure",
	      "members": {
	        "Name": {}
	      }
	    },
	    "S43": {
	      "type": "structure",
	      "members": {
	        "DefaultFieldValues": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Id": {
	                "shape": "S3x"
	              },
	              "DefaultValue": {}
	            }
	          }
	        }
	      }
	    },
	    "S48": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "shape": "S3x"
	          },
	          "Description": {},
	          "Type": {},
	          "SingleSelectOptions": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "S4o": {
	      "type": "structure",
	      "members": {
	        "FirstName": {},
	        "LastName": {},
	        "Email": {}
	      }
	    },
	    "S4s": {
	      "type": "structure",
	      "required": [
	        "PhoneType"
	      ],
	      "members": {
	        "PhoneType": {},
	        "AutoAccept": {
	          "type": "boolean"
	        },
	        "AfterContactWorkTimeLimit": {
	          "type": "integer"
	        },
	        "DeskPhoneNumber": {}
	      }
	    },
	    "S4x": {
	      "type": "list",
	      "member": {}
	    },
	    "S6o": {
	      "type": "structure",
	      "members": {
	        "AttributeType": {},
	        "Value": {}
	      }
	    },
	    "S7l": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Arn": {},
	        "Name": {}
	      }
	    },
	    "S7p": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Arn": {},
	        "Name": {}
	      }
	    },
	    "S88": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S8c": {
	      "type": "structure",
	      "members": {
	        "Queues": {
	          "shape": "S8d"
	        },
	        "Channels": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S8d": {
	      "type": "list",
	      "member": {}
	    },
	    "S8f": {
	      "type": "list",
	      "member": {}
	    },
	    "S8i": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Unit": {}
	      }
	    },
	    "S8q": {
	      "type": "structure",
	      "members": {
	        "Queue": {
	          "shape": "S8r"
	        },
	        "Channel": {}
	      }
	    },
	    "S8r": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Arn": {}
	      }
	    },
	    "S96": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Arn": {}
	      }
	    },
	    "S98": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "integer"
	      }
	    },
	    "S9f": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S9i": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Threshold": {
	          "type": "structure",
	          "members": {
	            "Comparison": {},
	            "ThresholdValue": {
	              "type": "double"
	            }
	          }
	        },
	        "Statistic": {},
	        "Unit": {}
	      }
	    },
	    "Sbw": {
	      "type": "list",
	      "member": {}
	    },
	    "Sbx": {
	      "type": "list",
	      "member": {}
	    },
	    "Scf": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Id": {},
	          "Arn": {},
	          "Name": {},
	          "QuickConnectType": {}
	        }
	      }
	    },
	    "Se5": {
	      "type": "list",
	      "member": {
	        "shape": "Se6"
	      }
	    },
	    "Se6": {
	      "type": "structure",
	      "members": {
	        "TagKey": {},
	        "TagValue": {}
	      }
	    },
	    "Se7": {
	      "type": "structure",
	      "members": {
	        "OrConditions": {
	          "shape": "Se8"
	        },
	        "AndConditions": {
	          "shape": "Se8"
	        },
	        "StringCondition": {
	          "type": "structure",
	          "members": {
	            "FieldName": {},
	            "Value": {},
	            "ComparisonType": {}
	          }
	        },
	        "HierarchyGroupCondition": {
	          "type": "structure",
	          "members": {
	            "Value": {},
	            "HierarchyGroupMatchType": {}
	          }
	        }
	      }
	    },
	    "Se8": {
	      "type": "list",
	      "member": {
	        "shape": "Se7"
	      }
	    },
	    "Sfe": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "required": [
	          "Value",
	          "Type"
	        ],
	        "members": {
	          "Value": {},
	          "Type": {}
	        }
	      }
	    },
	    "Sgy": {
	      "type": "structure",
	      "required": [
	        "Name"
	      ],
	      "members": {
	        "Name": {}
	      }
	    }
	  }
	}
	},{}],66:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "GetCurrentMetricData": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetCurrentUserData": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetMetricData": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListAgentStatuses": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "AgentStatusSummaryList"
	    },
	    "ListApprovedOrigins": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Origins"
	    },
	    "ListBots": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "LexBots"
	    },
	    "ListContactFlowModules": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ContactFlowModulesSummaryList"
	    },
	    "ListContactFlows": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ContactFlowSummaryList"
	    },
	    "ListContactReferences": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "ReferenceSummaryList"
	    },
	    "ListDefaultVocabularies": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "DefaultVocabularyList"
	    },
	    "ListHoursOfOperations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "HoursOfOperationSummaryList"
	    },
	    "ListInstanceAttributes": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Attributes"
	    },
	    "ListInstanceStorageConfigs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "StorageConfigs"
	    },
	    "ListInstances": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InstanceSummaryList"
	    },
	    "ListIntegrationAssociations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "IntegrationAssociationSummaryList"
	    },
	    "ListLambdaFunctions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "LambdaFunctions"
	    },
	    "ListLexBots": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "LexBots"
	    },
	    "ListPhoneNumbers": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "PhoneNumberSummaryList"
	    },
	    "ListPhoneNumbersV2": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ListPhoneNumbersSummaryList"
	    },
	    "ListPrompts": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "PromptSummaryList"
	    },
	    "ListQueueQuickConnects": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "QuickConnectSummaryList"
	    },
	    "ListQueues": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "QueueSummaryList"
	    },
	    "ListQuickConnects": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "QuickConnectSummaryList"
	    },
	    "ListRoutingProfileQueues": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "RoutingProfileQueueConfigSummaryList"
	    },
	    "ListRoutingProfiles": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "RoutingProfileSummaryList"
	    },
	    "ListSecurityKeys": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "SecurityKeys"
	    },
	    "ListSecurityProfilePermissions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Permissions"
	    },
	    "ListSecurityProfiles": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "SecurityProfileSummaryList"
	    },
	    "ListTaskTemplates": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TaskTemplates"
	    },
	    "ListUseCases": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "UseCaseSummaryList"
	    },
	    "ListUserHierarchyGroups": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "UserHierarchyGroupSummaryList"
	    },
	    "ListUsers": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "UserSummaryList"
	    },
	    "SearchAvailablePhoneNumbers": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "AvailableNumbersList"
	    },
	    "SearchUsers": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "non_aggregate_keys": [
	        "ApproximateTotalCount"
	      ],
	      "output_token": "NextToken",
	      "result_key": "Users"
	    },
	    "SearchVocabularies": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "VocabularySummaryList"
	    }
	  }
	}
	},{}],67:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-01-06",
	    "endpointPrefix": "cur",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "AWS Cost and Usage Report Service",
	    "serviceId": "Cost and Usage Report Service",
	    "signatureVersion": "v4",
	    "signingName": "cur",
	    "targetPrefix": "AWSOrigamiServiceGatewayService",
	    "uid": "cur-2017-01-06"
	  },
	  "operations": {
	    "DeleteReportDefinition": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReportName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResponseMessage": {}
	        }
	      }
	    },
	    "DescribeReportDefinitions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReportDefinitions": {
	            "type": "list",
	            "member": {
	              "shape": "Sa"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ModifyReportDefinition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReportName",
	          "ReportDefinition"
	        ],
	        "members": {
	          "ReportName": {},
	          "ReportDefinition": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "PutReportDefinition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReportDefinition"
	        ],
	        "members": {
	          "ReportDefinition": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "Sa": {
	      "type": "structure",
	      "required": [
	        "ReportName",
	        "TimeUnit",
	        "Format",
	        "Compression",
	        "AdditionalSchemaElements",
	        "S3Bucket",
	        "S3Prefix",
	        "S3Region"
	      ],
	      "members": {
	        "ReportName": {},
	        "TimeUnit": {},
	        "Format": {},
	        "Compression": {},
	        "AdditionalSchemaElements": {
	          "type": "list",
	          "member": {}
	        },
	        "S3Bucket": {},
	        "S3Prefix": {},
	        "S3Region": {},
	        "AdditionalArtifacts": {
	          "type": "list",
	          "member": {}
	        },
	        "RefreshClosedReports": {
	          "type": "boolean"
	        },
	        "ReportVersioning": {},
	        "BillingViewArn": {}
	      }
	    }
	  }
	}
	},{}],68:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeReportDefinitions": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    }
	  }
	}
	
	},{}],69:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-06-23",
	    "endpointPrefix": "devicefarm",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "AWS Device Farm",
	    "serviceId": "Device Farm",
	    "signatureVersion": "v4",
	    "targetPrefix": "DeviceFarm_20150623",
	    "uid": "devicefarm-2015-06-23"
	  },
	  "operations": {
	    "CreateDevicePool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectArn",
	          "name",
	          "rules"
	        ],
	        "members": {
	          "projectArn": {},
	          "name": {},
	          "description": {},
	          "rules": {
	            "shape": "S5"
	          },
	          "maxDevices": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "devicePool": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "CreateInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {},
	          "description": {},
	          "packageCleanup": {
	            "type": "boolean"
	          },
	          "excludeAppPackagesFromCleanup": {
	            "shape": "Sg"
	          },
	          "rebootAfterUse": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "instanceProfile": {
	            "shape": "Si"
	          }
	        }
	      }
	    },
	    "CreateNetworkProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectArn",
	          "name"
	        ],
	        "members": {
	          "projectArn": {},
	          "name": {},
	          "description": {},
	          "type": {},
	          "uplinkBandwidthBits": {
	            "type": "long"
	          },
	          "downlinkBandwidthBits": {
	            "type": "long"
	          },
	          "uplinkDelayMs": {
	            "type": "long"
	          },
	          "downlinkDelayMs": {
	            "type": "long"
	          },
	          "uplinkJitterMs": {
	            "type": "long"
	          },
	          "downlinkJitterMs": {
	            "type": "long"
	          },
	          "uplinkLossPercent": {
	            "type": "integer"
	          },
	          "downlinkLossPercent": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "networkProfile": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "CreateProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {},
	          "defaultJobTimeoutMinutes": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "project": {
	            "shape": "Ss"
	          }
	        }
	      }
	    },
	    "CreateRemoteAccessSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectArn",
	          "deviceArn"
	        ],
	        "members": {
	          "projectArn": {},
	          "deviceArn": {},
	          "instanceArn": {},
	          "sshPublicKey": {},
	          "remoteDebugEnabled": {
	            "type": "boolean"
	          },
	          "remoteRecordEnabled": {
	            "type": "boolean"
	          },
	          "remoteRecordAppArn": {},
	          "name": {},
	          "clientId": {},
	          "configuration": {
	            "type": "structure",
	            "members": {
	              "billingMethod": {},
	              "vpceConfigurationArns": {
	                "shape": "Sz"
	              }
	            }
	          },
	          "interactionMode": {},
	          "skipAppResign": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "remoteAccessSession": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "CreateTestGridProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {},
	          "description": {},
	          "vpcConfig": {
	            "shape": "S1m"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "testGridProject": {
	            "shape": "S1r"
	          }
	        }
	      }
	    },
	    "CreateTestGridUrl": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectArn",
	          "expiresInSeconds"
	        ],
	        "members": {
	          "projectArn": {},
	          "expiresInSeconds": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "url": {
	            "shape": "S1w"
	          },
	          "expires": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "CreateUpload": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectArn",
	          "name",
	          "type"
	        ],
	        "members": {
	          "projectArn": {},
	          "name": {},
	          "type": {},
	          "contentType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "upload": {
	            "shape": "S21"
	          }
	        }
	      }
	    },
	    "CreateVPCEConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "vpceConfigurationName",
	          "vpceServiceName",
	          "serviceDnsName"
	        ],
	        "members": {
	          "vpceConfigurationName": {},
	          "vpceServiceName": {},
	          "serviceDnsName": {},
	          "vpceConfigurationDescription": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "vpceConfiguration": {
	            "shape": "S2c"
	          }
	        }
	      }
	    },
	    "DeleteDevicePool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteNetworkProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteRemoteAccessSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteRun": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteTestGridProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectArn"
	        ],
	        "members": {
	          "projectArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteUpload": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteVPCEConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "GetAccountSettings": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "accountSettings": {
	            "type": "structure",
	            "members": {
	              "awsAccountNumber": {},
	              "unmeteredDevices": {
	                "shape": "S2z"
	              },
	              "unmeteredRemoteAccessDevices": {
	                "shape": "S2z"
	              },
	              "maxJobTimeoutMinutes": {
	                "type": "integer"
	              },
	              "trialMinutes": {
	                "type": "structure",
	                "members": {
	                  "total": {
	                    "type": "double"
	                  },
	                  "remaining": {
	                    "type": "double"
	                  }
	                }
	              },
	              "maxSlots": {
	                "type": "map",
	                "key": {},
	                "value": {
	                  "type": "integer"
	                }
	              },
	              "defaultJobTimeoutMinutes": {
	                "type": "integer"
	              },
	              "skipAppResign": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetDevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "device": {
	            "shape": "S15"
	          }
	        }
	      }
	    },
	    "GetDeviceInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deviceInstance": {
	            "shape": "S1c"
	          }
	        }
	      }
	    },
	    "GetDevicePool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "devicePool": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "GetDevicePoolCompatibility": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "devicePoolArn"
	        ],
	        "members": {
	          "devicePoolArn": {},
	          "appArn": {},
	          "testType": {},
	          "test": {
	            "shape": "S3a"
	          },
	          "configuration": {
	            "shape": "S3d"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "compatibleDevices": {
	            "shape": "S3l"
	          },
	          "incompatibleDevices": {
	            "shape": "S3l"
	          }
	        }
	      }
	    },
	    "GetInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "instanceProfile": {
	            "shape": "Si"
	          }
	        }
	      }
	    },
	    "GetJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "job": {
	            "shape": "S3t"
	          }
	        }
	      }
	    },
	    "GetNetworkProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "networkProfile": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "GetOfferingStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "current": {
	            "shape": "S41"
	          },
	          "nextPeriod": {
	            "shape": "S41"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "project": {
	            "shape": "Ss"
	          }
	        }
	      }
	    },
	    "GetRemoteAccessSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "remoteAccessSession": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "GetRun": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "run": {
	            "shape": "S4i"
	          }
	        }
	      }
	    },
	    "GetSuite": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "suite": {
	            "shape": "S4r"
	          }
	        }
	      }
	    },
	    "GetTest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "test": {
	            "shape": "S4u"
	          }
	        }
	      }
	    },
	    "GetTestGridProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectArn"
	        ],
	        "members": {
	          "projectArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "testGridProject": {
	            "shape": "S1r"
	          }
	        }
	      }
	    },
	    "GetTestGridSession": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "projectArn": {},
	          "sessionId": {},
	          "sessionArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "testGridSession": {
	            "shape": "S50"
	          }
	        }
	      }
	    },
	    "GetUpload": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "upload": {
	            "shape": "S21"
	          }
	        }
	      }
	    },
	    "GetVPCEConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "vpceConfiguration": {
	            "shape": "S2c"
	          }
	        }
	      }
	    },
	    "InstallToRemoteAccessSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "remoteAccessSessionArn",
	          "appArn"
	        ],
	        "members": {
	          "remoteAccessSessionArn": {},
	          "appArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "appUpload": {
	            "shape": "S21"
	          }
	        }
	      }
	    },
	    "ListArtifacts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn",
	          "type"
	        ],
	        "members": {
	          "arn": {},
	          "type": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "artifacts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "arn": {},
	                "name": {},
	                "type": {},
	                "extension": {},
	                "url": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDeviceInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deviceInstances": {
	            "shape": "S1b"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDevicePools": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "type": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "devicePools": {
	            "type": "list",
	            "member": {
	              "shape": "Sc"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDevices": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "arn": {},
	          "nextToken": {},
	          "filters": {
	            "shape": "S4l"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "devices": {
	            "type": "list",
	            "member": {
	              "shape": "S15"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListInstanceProfiles": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "instanceProfiles": {
	            "type": "list",
	            "member": {
	              "shape": "Si"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListJobs": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobs": {
	            "type": "list",
	            "member": {
	              "shape": "S3t"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListNetworkProfiles": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "type": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "networkProfiles": {
	            "type": "list",
	            "member": {
	              "shape": "So"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListOfferingPromotions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "offeringPromotions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "id": {},
	                "description": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListOfferingTransactions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "offeringTransactions": {
	            "type": "list",
	            "member": {
	              "shape": "S64"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListOfferings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "offerings": {
	            "type": "list",
	            "member": {
	              "shape": "S45"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListProjects": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "arn": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "projects": {
	            "type": "list",
	            "member": {
	              "shape": "Ss"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListRemoteAccessSessions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "remoteAccessSessions": {
	            "type": "list",
	            "member": {
	              "shape": "S12"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListRuns": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "runs": {
	            "type": "list",
	            "member": {
	              "shape": "S4i"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListSamples": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "samples": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "arn": {},
	                "type": {},
	                "url": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListSuites": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "suites": {
	            "type": "list",
	            "member": {
	              "shape": "S4r"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN"
	        ],
	        "members": {
	          "ResourceARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S6s"
	          }
	        }
	      }
	    },
	    "ListTestGridProjects": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "maxResult": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "testGridProjects": {
	            "type": "list",
	            "member": {
	              "shape": "S1r"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTestGridSessionActions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "sessionArn"
	        ],
	        "members": {
	          "sessionArn": {},
	          "maxResult": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "actions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "action": {},
	                "started": {
	                  "type": "timestamp"
	                },
	                "duration": {
	                  "type": "long"
	                },
	                "statusCode": {},
	                "requestMethod": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTestGridSessionArtifacts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "sessionArn"
	        ],
	        "members": {
	          "sessionArn": {},
	          "type": {},
	          "maxResult": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "artifacts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "filename": {},
	                "type": {},
	                "url": {
	                  "shape": "S1w"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTestGridSessions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectArn"
	        ],
	        "members": {
	          "projectArn": {},
	          "status": {},
	          "creationTimeAfter": {
	            "type": "timestamp"
	          },
	          "creationTimeBefore": {
	            "type": "timestamp"
	          },
	          "endTimeAfter": {
	            "type": "timestamp"
	          },
	          "endTimeBefore": {
	            "type": "timestamp"
	          },
	          "maxResult": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "testGridSessions": {
	            "type": "list",
	            "member": {
	              "shape": "S50"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTests": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tests": {
	            "type": "list",
	            "member": {
	              "shape": "S4u"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListUniqueProblems": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "uniqueProblems": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "message": {},
	                  "problems": {
	                    "type": "list",
	                    "member": {
	                      "type": "structure",
	                      "members": {
	                        "run": {
	                          "shape": "S7n"
	                        },
	                        "job": {
	                          "shape": "S7n"
	                        },
	                        "suite": {
	                          "shape": "S7n"
	                        },
	                        "test": {
	                          "shape": "S7n"
	                        },
	                        "device": {
	                          "shape": "S15"
	                        },
	                        "result": {},
	                        "message": {}
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListUploads": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "type": {},
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "uploads": {
	            "type": "list",
	            "member": {
	              "shape": "S21"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListVPCEConfigurations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "vpceConfigurations": {
	            "type": "list",
	            "member": {
	              "shape": "S2c"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "PurchaseOffering": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "offeringId",
	          "quantity"
	        ],
	        "members": {
	          "offeringId": {},
	          "quantity": {
	            "type": "integer"
	          },
	          "offeringPromotionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "offeringTransaction": {
	            "shape": "S64"
	          }
	        }
	      }
	    },
	    "RenewOffering": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "offeringId",
	          "quantity"
	        ],
	        "members": {
	          "offeringId": {},
	          "quantity": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "offeringTransaction": {
	            "shape": "S64"
	          }
	        }
	      }
	    },
	    "ScheduleRun": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectArn",
	          "test"
	        ],
	        "members": {
	          "projectArn": {},
	          "appArn": {},
	          "devicePoolArn": {},
	          "deviceSelectionConfiguration": {
	            "type": "structure",
	            "required": [
	              "filters",
	              "maxDevices"
	            ],
	            "members": {
	              "filters": {
	                "shape": "S4l"
	              },
	              "maxDevices": {
	                "type": "integer"
	              }
	            }
	          },
	          "name": {},
	          "test": {
	            "shape": "S3a"
	          },
	          "configuration": {
	            "shape": "S3d"
	          },
	          "executionConfiguration": {
	            "type": "structure",
	            "members": {
	              "jobTimeoutMinutes": {
	                "type": "integer"
	              },
	              "accountsCleanup": {
	                "type": "boolean"
	              },
	              "appPackagesCleanup": {
	                "type": "boolean"
	              },
	              "videoCapture": {
	                "type": "boolean"
	              },
	              "skipAppResign": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "run": {
	            "shape": "S4i"
	          }
	        }
	      }
	    },
	    "StopJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "job": {
	            "shape": "S3t"
	          }
	        }
	      }
	    },
	    "StopRemoteAccessSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "remoteAccessSession": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "StopRun": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "run": {
	            "shape": "S4i"
	          }
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "Tags"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "Tags": {
	            "shape": "S6s"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateDeviceInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "profileArn": {},
	          "labels": {
	            "shape": "S1d"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "deviceInstance": {
	            "shape": "S1c"
	          }
	        }
	      }
	    },
	    "UpdateDevicePool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "name": {},
	          "description": {},
	          "rules": {
	            "shape": "S5"
	          },
	          "maxDevices": {
	            "type": "integer"
	          },
	          "clearMaxDevices": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "devicePool": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "UpdateInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "name": {},
	          "description": {},
	          "packageCleanup": {
	            "type": "boolean"
	          },
	          "excludeAppPackagesFromCleanup": {
	            "shape": "Sg"
	          },
	          "rebootAfterUse": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "instanceProfile": {
	            "shape": "Si"
	          }
	        }
	      }
	    },
	    "UpdateNetworkProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "name": {},
	          "description": {},
	          "type": {},
	          "uplinkBandwidthBits": {
	            "type": "long"
	          },
	          "downlinkBandwidthBits": {
	            "type": "long"
	          },
	          "uplinkDelayMs": {
	            "type": "long"
	          },
	          "downlinkDelayMs": {
	            "type": "long"
	          },
	          "uplinkJitterMs": {
	            "type": "long"
	          },
	          "downlinkJitterMs": {
	            "type": "long"
	          },
	          "uplinkLossPercent": {
	            "type": "integer"
	          },
	          "downlinkLossPercent": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "networkProfile": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "UpdateProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "name": {},
	          "defaultJobTimeoutMinutes": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "project": {
	            "shape": "Ss"
	          }
	        }
	      }
	    },
	    "UpdateTestGridProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "projectArn"
	        ],
	        "members": {
	          "projectArn": {},
	          "name": {},
	          "description": {},
	          "vpcConfig": {
	            "shape": "S1m"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "testGridProject": {
	            "shape": "S1r"
	          }
	        }
	      }
	    },
	    "UpdateUpload": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "name": {},
	          "contentType": {},
	          "editContent": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "upload": {
	            "shape": "S21"
	          }
	        }
	      }
	    },
	    "UpdateVPCEConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {},
	          "vpceConfigurationName": {},
	          "vpceServiceName": {},
	          "serviceDnsName": {},
	          "vpceConfigurationDescription": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "vpceConfiguration": {
	            "shape": "S2c"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S5": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "attribute": {},
	          "operator": {},
	          "value": {}
	        }
	      }
	    },
	    "Sc": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "description": {},
	        "type": {},
	        "rules": {
	          "shape": "S5"
	        },
	        "maxDevices": {
	          "type": "integer"
	        }
	      }
	    },
	    "Sg": {
	      "type": "list",
	      "member": {}
	    },
	    "Si": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "packageCleanup": {
	          "type": "boolean"
	        },
	        "excludeAppPackagesFromCleanup": {
	          "shape": "Sg"
	        },
	        "rebootAfterUse": {
	          "type": "boolean"
	        },
	        "name": {},
	        "description": {}
	      }
	    },
	    "So": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "description": {},
	        "type": {},
	        "uplinkBandwidthBits": {
	          "type": "long"
	        },
	        "downlinkBandwidthBits": {
	          "type": "long"
	        },
	        "uplinkDelayMs": {
	          "type": "long"
	        },
	        "downlinkDelayMs": {
	          "type": "long"
	        },
	        "uplinkJitterMs": {
	          "type": "long"
	        },
	        "downlinkJitterMs": {
	          "type": "long"
	        },
	        "uplinkLossPercent": {
	          "type": "integer"
	        },
	        "downlinkLossPercent": {
	          "type": "integer"
	        }
	      }
	    },
	    "Ss": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "defaultJobTimeoutMinutes": {
	          "type": "integer"
	        },
	        "created": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sz": {
	      "type": "list",
	      "member": {}
	    },
	    "S12": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "created": {
	          "type": "timestamp"
	        },
	        "status": {},
	        "result": {},
	        "message": {},
	        "started": {
	          "type": "timestamp"
	        },
	        "stopped": {
	          "type": "timestamp"
	        },
	        "device": {
	          "shape": "S15"
	        },
	        "instanceArn": {},
	        "remoteDebugEnabled": {
	          "type": "boolean"
	        },
	        "remoteRecordEnabled": {
	          "type": "boolean"
	        },
	        "remoteRecordAppArn": {},
	        "hostAddress": {},
	        "clientId": {},
	        "billingMethod": {},
	        "deviceMinutes": {
	          "shape": "S1h"
	        },
	        "endpoint": {},
	        "deviceUdid": {},
	        "interactionMode": {},
	        "skipAppResign": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S15": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "manufacturer": {},
	        "model": {},
	        "modelId": {},
	        "formFactor": {},
	        "platform": {},
	        "os": {},
	        "cpu": {
	          "type": "structure",
	          "members": {
	            "frequency": {},
	            "architecture": {},
	            "clock": {
	              "type": "double"
	            }
	          }
	        },
	        "resolution": {
	          "type": "structure",
	          "members": {
	            "width": {
	              "type": "integer"
	            },
	            "height": {
	              "type": "integer"
	            }
	          }
	        },
	        "heapSize": {
	          "type": "long"
	        },
	        "memory": {
	          "type": "long"
	        },
	        "image": {},
	        "carrier": {},
	        "radio": {},
	        "remoteAccessEnabled": {
	          "type": "boolean"
	        },
	        "remoteDebugEnabled": {
	          "type": "boolean"
	        },
	        "fleetType": {},
	        "fleetName": {},
	        "instances": {
	          "shape": "S1b"
	        },
	        "availability": {}
	      }
	    },
	    "S1b": {
	      "type": "list",
	      "member": {
	        "shape": "S1c"
	      }
	    },
	    "S1c": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "deviceArn": {},
	        "labels": {
	          "shape": "S1d"
	        },
	        "status": {},
	        "udid": {},
	        "instanceProfile": {
	          "shape": "Si"
	        }
	      }
	    },
	    "S1d": {
	      "type": "list",
	      "member": {}
	    },
	    "S1h": {
	      "type": "structure",
	      "members": {
	        "total": {
	          "type": "double"
	        },
	        "metered": {
	          "type": "double"
	        },
	        "unmetered": {
	          "type": "double"
	        }
	      }
	    },
	    "S1m": {
	      "type": "structure",
	      "required": [
	        "securityGroupIds",
	        "subnetIds",
	        "vpcId"
	      ],
	      "members": {
	        "securityGroupIds": {
	          "type": "list",
	          "member": {}
	        },
	        "subnetIds": {
	          "type": "list",
	          "member": {}
	        },
	        "vpcId": {}
	      }
	    },
	    "S1r": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "description": {},
	        "vpcConfig": {
	          "shape": "S1m"
	        },
	        "created": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S1w": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S21": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "created": {
	          "type": "timestamp"
	        },
	        "type": {},
	        "status": {},
	        "url": {
	          "type": "string",
	          "sensitive": true
	        },
	        "metadata": {},
	        "contentType": {},
	        "message": {},
	        "category": {}
	      }
	    },
	    "S2c": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "vpceConfigurationName": {},
	        "vpceServiceName": {},
	        "serviceDnsName": {},
	        "vpceConfigurationDescription": {}
	      }
	    },
	    "S2z": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "integer"
	      }
	    },
	    "S3a": {
	      "type": "structure",
	      "required": [
	        "type"
	      ],
	      "members": {
	        "type": {},
	        "testPackageArn": {},
	        "testSpecArn": {},
	        "filter": {},
	        "parameters": {
	          "type": "map",
	          "key": {},
	          "value": {}
	        }
	      }
	    },
	    "S3d": {
	      "type": "structure",
	      "members": {
	        "extraDataPackageArn": {},
	        "networkProfileArn": {},
	        "locale": {},
	        "location": {
	          "shape": "S3e"
	        },
	        "vpceConfigurationArns": {
	          "shape": "Sz"
	        },
	        "customerArtifactPaths": {
	          "shape": "S3f"
	        },
	        "radios": {
	          "shape": "S3j"
	        },
	        "auxiliaryApps": {
	          "shape": "Sz"
	        },
	        "billingMethod": {}
	      }
	    },
	    "S3e": {
	      "type": "structure",
	      "required": [
	        "latitude",
	        "longitude"
	      ],
	      "members": {
	        "latitude": {
	          "type": "double"
	        },
	        "longitude": {
	          "type": "double"
	        }
	      }
	    },
	    "S3f": {
	      "type": "structure",
	      "members": {
	        "iosPaths": {
	          "type": "list",
	          "member": {}
	        },
	        "androidPaths": {
	          "type": "list",
	          "member": {}
	        },
	        "deviceHostPaths": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S3j": {
	      "type": "structure",
	      "members": {
	        "wifi": {
	          "type": "boolean"
	        },
	        "bluetooth": {
	          "type": "boolean"
	        },
	        "nfc": {
	          "type": "boolean"
	        },
	        "gps": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S3l": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "device": {
	            "shape": "S15"
	          },
	          "compatible": {
	            "type": "boolean"
	          },
	          "incompatibilityMessages": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "message": {},
	                "type": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "S3t": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "type": {},
	        "created": {
	          "type": "timestamp"
	        },
	        "status": {},
	        "result": {},
	        "started": {
	          "type": "timestamp"
	        },
	        "stopped": {
	          "type": "timestamp"
	        },
	        "counters": {
	          "shape": "S3u"
	        },
	        "message": {},
	        "device": {
	          "shape": "S15"
	        },
	        "instanceArn": {},
	        "deviceMinutes": {
	          "shape": "S1h"
	        },
	        "videoEndpoint": {},
	        "videoCapture": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S3u": {
	      "type": "structure",
	      "members": {
	        "total": {
	          "type": "integer"
	        },
	        "passed": {
	          "type": "integer"
	        },
	        "failed": {
	          "type": "integer"
	        },
	        "warned": {
	          "type": "integer"
	        },
	        "errored": {
	          "type": "integer"
	        },
	        "stopped": {
	          "type": "integer"
	        },
	        "skipped": {
	          "type": "integer"
	        }
	      }
	    },
	    "S41": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "S43"
	      }
	    },
	    "S43": {
	      "type": "structure",
	      "members": {
	        "type": {},
	        "offering": {
	          "shape": "S45"
	        },
	        "quantity": {
	          "type": "integer"
	        },
	        "effectiveOn": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S45": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "description": {},
	        "type": {},
	        "platform": {},
	        "recurringCharges": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "cost": {
	                "shape": "S49"
	              },
	              "frequency": {}
	            }
	          }
	        }
	      }
	    },
	    "S49": {
	      "type": "structure",
	      "members": {
	        "amount": {
	          "type": "double"
	        },
	        "currencyCode": {}
	      }
	    },
	    "S4i": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "type": {},
	        "platform": {},
	        "created": {
	          "type": "timestamp"
	        },
	        "status": {},
	        "result": {},
	        "started": {
	          "type": "timestamp"
	        },
	        "stopped": {
	          "type": "timestamp"
	        },
	        "counters": {
	          "shape": "S3u"
	        },
	        "message": {},
	        "totalJobs": {
	          "type": "integer"
	        },
	        "completedJobs": {
	          "type": "integer"
	        },
	        "billingMethod": {},
	        "deviceMinutes": {
	          "shape": "S1h"
	        },
	        "networkProfile": {
	          "shape": "So"
	        },
	        "parsingResultUrl": {},
	        "resultCode": {},
	        "seed": {
	          "type": "integer"
	        },
	        "appUpload": {},
	        "eventCount": {
	          "type": "integer"
	        },
	        "jobTimeoutMinutes": {
	          "type": "integer"
	        },
	        "devicePoolArn": {},
	        "locale": {},
	        "radios": {
	          "shape": "S3j"
	        },
	        "location": {
	          "shape": "S3e"
	        },
	        "customerArtifactPaths": {
	          "shape": "S3f"
	        },
	        "webUrl": {},
	        "skipAppResign": {
	          "type": "boolean"
	        },
	        "testSpecArn": {},
	        "deviceSelectionResult": {
	          "type": "structure",
	          "members": {
	            "filters": {
	              "shape": "S4l"
	            },
	            "matchedDevicesCount": {
	              "type": "integer"
	            },
	            "maxDevices": {
	              "type": "integer"
	            }
	          }
	        }
	      }
	    },
	    "S4l": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "attribute",
	          "operator",
	          "values"
	        ],
	        "members": {
	          "attribute": {},
	          "operator": {},
	          "values": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "S4r": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "type": {},
	        "created": {
	          "type": "timestamp"
	        },
	        "status": {},
	        "result": {},
	        "started": {
	          "type": "timestamp"
	        },
	        "stopped": {
	          "type": "timestamp"
	        },
	        "counters": {
	          "shape": "S3u"
	        },
	        "message": {},
	        "deviceMinutes": {
	          "shape": "S1h"
	        }
	      }
	    },
	    "S4u": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {},
	        "type": {},
	        "created": {
	          "type": "timestamp"
	        },
	        "status": {},
	        "result": {},
	        "started": {
	          "type": "timestamp"
	        },
	        "stopped": {
	          "type": "timestamp"
	        },
	        "counters": {
	          "shape": "S3u"
	        },
	        "message": {},
	        "deviceMinutes": {
	          "shape": "S1h"
	        }
	      }
	    },
	    "S50": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "status": {},
	        "created": {
	          "type": "timestamp"
	        },
	        "ended": {
	          "type": "timestamp"
	        },
	        "billingMinutes": {
	          "type": "double"
	        },
	        "seleniumProperties": {}
	      }
	    },
	    "S64": {
	      "type": "structure",
	      "members": {
	        "offeringStatus": {
	          "shape": "S43"
	        },
	        "transactionId": {},
	        "offeringPromotionId": {},
	        "createdOn": {
	          "type": "timestamp"
	        },
	        "cost": {
	          "shape": "S49"
	        }
	      }
	    },
	    "S6s": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S7n": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "name": {}
	      }
	    }
	  }
	}
	},{}],70:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "GetOfferingStatus": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": [
	        "current",
	        "nextPeriod"
	      ]
	    },
	    "ListArtifacts": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "artifacts"
	    },
	    "ListDevicePools": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "devicePools"
	    },
	    "ListDevices": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "devices"
	    },
	    "ListJobs": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "jobs"
	    },
	    "ListOfferingTransactions": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "offeringTransactions"
	    },
	    "ListOfferings": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "offerings"
	    },
	    "ListProjects": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "projects"
	    },
	    "ListRuns": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "runs"
	    },
	    "ListSamples": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "samples"
	    },
	    "ListSuites": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "suites"
	    },
	    "ListTestGridProjects": {
	      "input_token": "nextToken",
	      "limit_key": "maxResult",
	      "output_token": "nextToken"
	    },
	    "ListTestGridSessionActions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResult",
	      "output_token": "nextToken"
	    },
	    "ListTestGridSessionArtifacts": {
	      "input_token": "nextToken",
	      "limit_key": "maxResult",
	      "output_token": "nextToken"
	    },
	    "ListTestGridSessions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResult",
	      "output_token": "nextToken"
	    },
	    "ListTests": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "tests"
	    },
	    "ListUniqueProblems": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "uniqueProblems"
	    },
	    "ListUploads": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "uploads"
	    }
	  }
	}
	},{}],71:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2012-10-25",
	    "endpointPrefix": "directconnect",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "AWS Direct Connect",
	    "serviceId": "Direct Connect",
	    "signatureVersion": "v4",
	    "targetPrefix": "OvertureService",
	    "uid": "directconnect-2012-10-25"
	  },
	  "operations": {
	    "AcceptDirectConnectGatewayAssociationProposal": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "directConnectGatewayId",
	          "proposalId",
	          "associatedGatewayOwnerAccount"
	        ],
	        "members": {
	          "directConnectGatewayId": {},
	          "proposalId": {},
	          "associatedGatewayOwnerAccount": {},
	          "overrideAllowedPrefixesToDirectConnectGateway": {
	            "shape": "S5"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayAssociation": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "AllocateConnectionOnInterconnect": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "bandwidth",
	          "connectionName",
	          "ownerAccount",
	          "interconnectId",
	          "vlan"
	        ],
	        "members": {
	          "bandwidth": {},
	          "connectionName": {},
	          "ownerAccount": {},
	          "interconnectId": {},
	          "vlan": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "shape": "So"
	      },
	      "deprecated": true
	    },
	    "AllocateHostedConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId",
	          "ownerAccount",
	          "bandwidth",
	          "connectionName",
	          "vlan"
	        ],
	        "members": {
	          "connectionId": {},
	          "ownerAccount": {},
	          "bandwidth": {},
	          "connectionName": {},
	          "vlan": {
	            "type": "integer"
	          },
	          "tags": {
	            "shape": "S10"
	          }
	        }
	      },
	      "output": {
	        "shape": "So"
	      }
	    },
	    "AllocatePrivateVirtualInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId",
	          "ownerAccount",
	          "newPrivateVirtualInterfaceAllocation"
	        ],
	        "members": {
	          "connectionId": {},
	          "ownerAccount": {},
	          "newPrivateVirtualInterfaceAllocation": {
	            "type": "structure",
	            "required": [
	              "virtualInterfaceName",
	              "vlan",
	              "asn"
	            ],
	            "members": {
	              "virtualInterfaceName": {},
	              "vlan": {
	                "type": "integer"
	              },
	              "asn": {
	                "type": "integer"
	              },
	              "mtu": {
	                "type": "integer"
	              },
	              "authKey": {},
	              "amazonAddress": {},
	              "addressFamily": {},
	              "customerAddress": {},
	              "tags": {
	                "shape": "S10"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "shape": "S1o"
	      }
	    },
	    "AllocatePublicVirtualInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId",
	          "ownerAccount",
	          "newPublicVirtualInterfaceAllocation"
	        ],
	        "members": {
	          "connectionId": {},
	          "ownerAccount": {},
	          "newPublicVirtualInterfaceAllocation": {
	            "type": "structure",
	            "required": [
	              "virtualInterfaceName",
	              "vlan",
	              "asn"
	            ],
	            "members": {
	              "virtualInterfaceName": {},
	              "vlan": {
	                "type": "integer"
	              },
	              "asn": {
	                "type": "integer"
	              },
	              "authKey": {},
	              "amazonAddress": {},
	              "customerAddress": {},
	              "addressFamily": {},
	              "routeFilterPrefixes": {
	                "shape": "S5"
	              },
	              "tags": {
	                "shape": "S10"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "shape": "S1o"
	      }
	    },
	    "AllocateTransitVirtualInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId",
	          "ownerAccount",
	          "newTransitVirtualInterfaceAllocation"
	        ],
	        "members": {
	          "connectionId": {},
	          "ownerAccount": {},
	          "newTransitVirtualInterfaceAllocation": {
	            "type": "structure",
	            "members": {
	              "virtualInterfaceName": {},
	              "vlan": {
	                "type": "integer"
	              },
	              "asn": {
	                "type": "integer"
	              },
	              "mtu": {
	                "type": "integer"
	              },
	              "authKey": {},
	              "amazonAddress": {},
	              "customerAddress": {},
	              "addressFamily": {},
	              "tags": {
	                "shape": "S10"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterface": {
	            "shape": "S1o"
	          }
	        }
	      }
	    },
	    "AssociateConnectionWithLag": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId",
	          "lagId"
	        ],
	        "members": {
	          "connectionId": {},
	          "lagId": {}
	        }
	      },
	      "output": {
	        "shape": "So"
	      }
	    },
	    "AssociateHostedConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId",
	          "parentConnectionId"
	        ],
	        "members": {
	          "connectionId": {},
	          "parentConnectionId": {}
	        }
	      },
	      "output": {
	        "shape": "So"
	      }
	    },
	    "AssociateMacSecKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId"
	        ],
	        "members": {
	          "connectionId": {},
	          "secretARN": {},
	          "ckn": {},
	          "cak": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "connectionId": {},
	          "macSecKeys": {
	            "shape": "S18"
	          }
	        }
	      }
	    },
	    "AssociateVirtualInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "virtualInterfaceId",
	          "connectionId"
	        ],
	        "members": {
	          "virtualInterfaceId": {},
	          "connectionId": {}
	        }
	      },
	      "output": {
	        "shape": "S1o"
	      }
	    },
	    "ConfirmConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId"
	        ],
	        "members": {
	          "connectionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "connectionState": {}
	        }
	      }
	    },
	    "ConfirmCustomerAgreement": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "agreementName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "status": {}
	        }
	      }
	    },
	    "ConfirmPrivateVirtualInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "virtualInterfaceId"
	        ],
	        "members": {
	          "virtualInterfaceId": {},
	          "virtualGatewayId": {},
	          "directConnectGatewayId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterfaceState": {}
	        }
	      }
	    },
	    "ConfirmPublicVirtualInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "virtualInterfaceId"
	        ],
	        "members": {
	          "virtualInterfaceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterfaceState": {}
	        }
	      }
	    },
	    "ConfirmTransitVirtualInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "virtualInterfaceId",
	          "directConnectGatewayId"
	        ],
	        "members": {
	          "virtualInterfaceId": {},
	          "directConnectGatewayId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterfaceState": {}
	        }
	      }
	    },
	    "CreateBGPPeer": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "virtualInterfaceId": {},
	          "newBGPPeer": {
	            "type": "structure",
	            "members": {
	              "asn": {
	                "type": "integer"
	              },
	              "authKey": {},
	              "addressFamily": {},
	              "amazonAddress": {},
	              "customerAddress": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterface": {
	            "shape": "S1o"
	          }
	        }
	      }
	    },
	    "CreateConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "location",
	          "bandwidth",
	          "connectionName"
	        ],
	        "members": {
	          "location": {},
	          "bandwidth": {},
	          "connectionName": {},
	          "lagId": {},
	          "tags": {
	            "shape": "S10"
	          },
	          "providerName": {},
	          "requestMACSec": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "So"
	      }
	    },
	    "CreateDirectConnectGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "directConnectGatewayName"
	        ],
	        "members": {
	          "directConnectGatewayName": {},
	          "amazonSideAsn": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGateway": {
	            "shape": "S2v"
	          }
	        }
	      }
	    },
	    "CreateDirectConnectGatewayAssociation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "directConnectGatewayId"
	        ],
	        "members": {
	          "directConnectGatewayId": {},
	          "gatewayId": {},
	          "addAllowedPrefixesToDirectConnectGateway": {
	            "shape": "S5"
	          },
	          "virtualGatewayId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayAssociation": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "CreateDirectConnectGatewayAssociationProposal": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "directConnectGatewayId",
	          "directConnectGatewayOwnerAccount",
	          "gatewayId"
	        ],
	        "members": {
	          "directConnectGatewayId": {},
	          "directConnectGatewayOwnerAccount": {},
	          "gatewayId": {},
	          "addAllowedPrefixesToDirectConnectGateway": {
	            "shape": "S5"
	          },
	          "removeAllowedPrefixesToDirectConnectGateway": {
	            "shape": "S5"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayAssociationProposal": {
	            "shape": "S32"
	          }
	        }
	      }
	    },
	    "CreateInterconnect": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "interconnectName",
	          "bandwidth",
	          "location"
	        ],
	        "members": {
	          "interconnectName": {},
	          "bandwidth": {},
	          "location": {},
	          "lagId": {},
	          "tags": {
	            "shape": "S10"
	          },
	          "providerName": {}
	        }
	      },
	      "output": {
	        "shape": "S36"
	      }
	    },
	    "CreateLag": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "numberOfConnections",
	          "location",
	          "connectionsBandwidth",
	          "lagName"
	        ],
	        "members": {
	          "numberOfConnections": {
	            "type": "integer"
	          },
	          "location": {},
	          "connectionsBandwidth": {},
	          "lagName": {},
	          "connectionId": {},
	          "tags": {
	            "shape": "S10"
	          },
	          "childConnectionTags": {
	            "shape": "S10"
	          },
	          "providerName": {},
	          "requestMACSec": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3b"
	      }
	    },
	    "CreatePrivateVirtualInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId",
	          "newPrivateVirtualInterface"
	        ],
	        "members": {
	          "connectionId": {},
	          "newPrivateVirtualInterface": {
	            "type": "structure",
	            "required": [
	              "virtualInterfaceName",
	              "vlan",
	              "asn"
	            ],
	            "members": {
	              "virtualInterfaceName": {},
	              "vlan": {
	                "type": "integer"
	              },
	              "asn": {
	                "type": "integer"
	              },
	              "mtu": {
	                "type": "integer"
	              },
	              "authKey": {},
	              "amazonAddress": {},
	              "customerAddress": {},
	              "addressFamily": {},
	              "virtualGatewayId": {},
	              "directConnectGatewayId": {},
	              "tags": {
	                "shape": "S10"
	              },
	              "enableSiteLink": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "shape": "S1o"
	      }
	    },
	    "CreatePublicVirtualInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId",
	          "newPublicVirtualInterface"
	        ],
	        "members": {
	          "connectionId": {},
	          "newPublicVirtualInterface": {
	            "type": "structure",
	            "required": [
	              "virtualInterfaceName",
	              "vlan",
	              "asn"
	            ],
	            "members": {
	              "virtualInterfaceName": {},
	              "vlan": {
	                "type": "integer"
	              },
	              "asn": {
	                "type": "integer"
	              },
	              "authKey": {},
	              "amazonAddress": {},
	              "customerAddress": {},
	              "addressFamily": {},
	              "routeFilterPrefixes": {
	                "shape": "S5"
	              },
	              "tags": {
	                "shape": "S10"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "shape": "S1o"
	      }
	    },
	    "CreateTransitVirtualInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId",
	          "newTransitVirtualInterface"
	        ],
	        "members": {
	          "connectionId": {},
	          "newTransitVirtualInterface": {
	            "type": "structure",
	            "members": {
	              "virtualInterfaceName": {},
	              "vlan": {
	                "type": "integer"
	              },
	              "asn": {
	                "type": "integer"
	              },
	              "mtu": {
	                "type": "integer"
	              },
	              "authKey": {},
	              "amazonAddress": {},
	              "customerAddress": {},
	              "addressFamily": {},
	              "directConnectGatewayId": {},
	              "tags": {
	                "shape": "S10"
	              },
	              "enableSiteLink": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterface": {
	            "shape": "S1o"
	          }
	        }
	      }
	    },
	    "DeleteBGPPeer": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "virtualInterfaceId": {},
	          "asn": {
	            "type": "integer"
	          },
	          "customerAddress": {},
	          "bgpPeerId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterface": {
	            "shape": "S1o"
	          }
	        }
	      }
	    },
	    "DeleteConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId"
	        ],
	        "members": {
	          "connectionId": {}
	        }
	      },
	      "output": {
	        "shape": "So"
	      }
	    },
	    "DeleteDirectConnectGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "directConnectGatewayId"
	        ],
	        "members": {
	          "directConnectGatewayId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGateway": {
	            "shape": "S2v"
	          }
	        }
	      }
	    },
	    "DeleteDirectConnectGatewayAssociation": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "associationId": {},
	          "directConnectGatewayId": {},
	          "virtualGatewayId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayAssociation": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "DeleteDirectConnectGatewayAssociationProposal": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "proposalId"
	        ],
	        "members": {
	          "proposalId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayAssociationProposal": {
	            "shape": "S32"
	          }
	        }
	      }
	    },
	    "DeleteInterconnect": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "interconnectId"
	        ],
	        "members": {
	          "interconnectId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "interconnectState": {}
	        }
	      }
	    },
	    "DeleteLag": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "lagId"
	        ],
	        "members": {
	          "lagId": {}
	        }
	      },
	      "output": {
	        "shape": "S3b"
	      }
	    },
	    "DeleteVirtualInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "virtualInterfaceId"
	        ],
	        "members": {
	          "virtualInterfaceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterfaceState": {}
	        }
	      }
	    },
	    "DescribeConnectionLoa": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId"
	        ],
	        "members": {
	          "connectionId": {},
	          "providerName": {},
	          "loaContentType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "loa": {
	            "shape": "S44"
	          }
	        }
	      },
	      "deprecated": true
	    },
	    "DescribeConnections": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "connectionId": {}
	        }
	      },
	      "output": {
	        "shape": "S47"
	      }
	    },
	    "DescribeConnectionsOnInterconnect": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "interconnectId"
	        ],
	        "members": {
	          "interconnectId": {}
	        }
	      },
	      "output": {
	        "shape": "S47"
	      },
	      "deprecated": true
	    },
	    "DescribeCustomerMetadata": {
	      "output": {
	        "type": "structure",
	        "members": {
	          "agreements": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "agreementName": {},
	                "status": {}
	              }
	            }
	          },
	          "nniPartnerType": {}
	        }
	      }
	    },
	    "DescribeDirectConnectGatewayAssociationProposals": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayId": {},
	          "proposalId": {},
	          "associatedGatewayId": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayAssociationProposals": {
	            "type": "list",
	            "member": {
	              "shape": "S32"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeDirectConnectGatewayAssociations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "associationId": {},
	          "associatedGatewayId": {},
	          "directConnectGatewayId": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {},
	          "virtualGatewayId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayAssociations": {
	            "type": "list",
	            "member": {
	              "shape": "S9"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeDirectConnectGatewayAttachments": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayId": {},
	          "virtualInterfaceId": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayAttachments": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "directConnectGatewayId": {},
	                "virtualInterfaceId": {},
	                "virtualInterfaceRegion": {},
	                "virtualInterfaceOwnerAccount": {},
	                "attachmentState": {},
	                "attachmentType": {},
	                "stateChangeError": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeDirectConnectGateways": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayId": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGateways": {
	            "type": "list",
	            "member": {
	              "shape": "S2v"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeHostedConnections": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId"
	        ],
	        "members": {
	          "connectionId": {}
	        }
	      },
	      "output": {
	        "shape": "S47"
	      }
	    },
	    "DescribeInterconnectLoa": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "interconnectId"
	        ],
	        "members": {
	          "interconnectId": {},
	          "providerName": {},
	          "loaContentType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "loa": {
	            "shape": "S44"
	          }
	        }
	      },
	      "deprecated": true
	    },
	    "DescribeInterconnects": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "interconnectId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "interconnects": {
	            "type": "list",
	            "member": {
	              "shape": "S36"
	            }
	          }
	        }
	      }
	    },
	    "DescribeLags": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "lagId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "lags": {
	            "type": "list",
	            "member": {
	              "shape": "S3b"
	            }
	          }
	        }
	      }
	    },
	    "DescribeLoa": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId"
	        ],
	        "members": {
	          "connectionId": {},
	          "providerName": {},
	          "loaContentType": {}
	        }
	      },
	      "output": {
	        "shape": "S44"
	      }
	    },
	    "DescribeLocations": {
	      "output": {
	        "type": "structure",
	        "members": {
	          "locations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "locationCode": {},
	                "locationName": {},
	                "region": {},
	                "availablePortSpeeds": {
	                  "type": "list",
	                  "member": {}
	                },
	                "availableProviders": {
	                  "type": "list",
	                  "member": {}
	                },
	                "availableMacSecPortSpeeds": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeRouterConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "virtualInterfaceId"
	        ],
	        "members": {
	          "virtualInterfaceId": {},
	          "routerTypeIdentifier": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "customerRouterConfig": {},
	          "router": {
	            "type": "structure",
	            "members": {
	              "vendor": {},
	              "platform": {},
	              "software": {},
	              "xsltTemplateName": {},
	              "xsltTemplateNameForMacSec": {},
	              "routerTypeIdentifier": {}
	            }
	          },
	          "virtualInterfaceId": {},
	          "virtualInterfaceName": {}
	        }
	      }
	    },
	    "DescribeTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArns"
	        ],
	        "members": {
	          "resourceArns": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "resourceTags": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "resourceArn": {},
	                "tags": {
	                  "shape": "S10"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeVirtualGateways": {
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualGateways": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "virtualGatewayId": {},
	                "virtualGatewayState": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeVirtualInterfaces": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "connectionId": {},
	          "virtualInterfaceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterfaces": {
	            "type": "list",
	            "member": {
	              "shape": "S1o"
	            }
	          }
	        }
	      }
	    },
	    "DisassociateConnectionFromLag": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId",
	          "lagId"
	        ],
	        "members": {
	          "connectionId": {},
	          "lagId": {}
	        }
	      },
	      "output": {
	        "shape": "So"
	      }
	    },
	    "DisassociateMacSecKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId",
	          "secretARN"
	        ],
	        "members": {
	          "connectionId": {},
	          "secretARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "connectionId": {},
	          "macSecKeys": {
	            "shape": "S18"
	          }
	        }
	      }
	    },
	    "ListVirtualInterfaceTestHistory": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "testId": {},
	          "virtualInterfaceId": {},
	          "bgpPeers": {
	            "shape": "S65"
	          },
	          "status": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterfaceTestHistory": {
	            "type": "list",
	            "member": {
	              "shape": "S69"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "StartBgpFailoverTest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "virtualInterfaceId"
	        ],
	        "members": {
	          "virtualInterfaceId": {},
	          "bgpPeers": {
	            "shape": "S65"
	          },
	          "testDurationInMinutes": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterfaceTest": {
	            "shape": "S69"
	          }
	        }
	      }
	    },
	    "StopBgpFailoverTest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "virtualInterfaceId"
	        ],
	        "members": {
	          "virtualInterfaceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "virtualInterfaceTest": {
	            "shape": "S69"
	          }
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tags"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tags": {
	            "shape": "S10"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tagKeys"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "connectionId"
	        ],
	        "members": {
	          "connectionId": {},
	          "connectionName": {},
	          "encryptionMode": {}
	        }
	      },
	      "output": {
	        "shape": "So"
	      }
	    },
	    "UpdateDirectConnectGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "directConnectGatewayId",
	          "newDirectConnectGatewayName"
	        ],
	        "members": {
	          "directConnectGatewayId": {},
	          "newDirectConnectGatewayName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGateway": {
	            "shape": "S2v"
	          }
	        }
	      }
	    },
	    "UpdateDirectConnectGatewayAssociation": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "associationId": {},
	          "addAllowedPrefixesToDirectConnectGateway": {
	            "shape": "S5"
	          },
	          "removeAllowedPrefixesToDirectConnectGateway": {
	            "shape": "S5"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "directConnectGatewayAssociation": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "UpdateLag": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "lagId"
	        ],
	        "members": {
	          "lagId": {},
	          "lagName": {},
	          "minimumLinks": {
	            "type": "integer"
	          },
	          "encryptionMode": {}
	        }
	      },
	      "output": {
	        "shape": "S3b"
	      }
	    },
	    "UpdateVirtualInterfaceAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "virtualInterfaceId"
	        ],
	        "members": {
	          "virtualInterfaceId": {},
	          "mtu": {
	            "type": "integer"
	          },
	          "enableSiteLink": {
	            "type": "boolean"
	          },
	          "virtualInterfaceName": {}
	        }
	      },
	      "output": {
	        "shape": "S1o"
	      }
	    }
	  },
	  "shapes": {
	    "S5": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "cidr": {}
	        }
	      }
	    },
	    "S9": {
	      "type": "structure",
	      "members": {
	        "directConnectGatewayId": {},
	        "directConnectGatewayOwnerAccount": {},
	        "associationState": {},
	        "stateChangeError": {},
	        "associatedGateway": {
	          "shape": "Sc"
	        },
	        "associationId": {},
	        "allowedPrefixesToDirectConnectGateway": {
	          "shape": "S5"
	        },
	        "virtualGatewayId": {},
	        "virtualGatewayRegion": {
	          "type": "string",
	          "deprecated": true
	        },
	        "virtualGatewayOwnerAccount": {}
	      }
	    },
	    "Sc": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "type": {},
	        "ownerAccount": {},
	        "region": {}
	      }
	    },
	    "So": {
	      "type": "structure",
	      "members": {
	        "ownerAccount": {},
	        "connectionId": {},
	        "connectionName": {},
	        "connectionState": {},
	        "region": {},
	        "location": {},
	        "bandwidth": {},
	        "vlan": {
	          "type": "integer"
	        },
	        "partnerName": {},
	        "loaIssueTime": {
	          "type": "timestamp"
	        },
	        "lagId": {},
	        "awsDevice": {
	          "shape": "Sv"
	        },
	        "jumboFrameCapable": {
	          "type": "boolean"
	        },
	        "awsDeviceV2": {},
	        "awsLogicalDeviceId": {},
	        "hasLogicalRedundancy": {},
	        "tags": {
	          "shape": "S10"
	        },
	        "providerName": {},
	        "macSecCapable": {
	          "type": "boolean"
	        },
	        "portEncryptionStatus": {},
	        "encryptionMode": {},
	        "macSecKeys": {
	          "shape": "S18"
	        }
	      }
	    },
	    "Sv": {
	      "type": "string",
	      "deprecated": true
	    },
	    "S10": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "key"
	        ],
	        "members": {
	          "key": {},
	          "value": {}
	        }
	      }
	    },
	    "S18": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "secretARN": {},
	          "ckn": {},
	          "state": {},
	          "startOn": {}
	        }
	      }
	    },
	    "S1o": {
	      "type": "structure",
	      "members": {
	        "ownerAccount": {},
	        "virtualInterfaceId": {},
	        "location": {},
	        "connectionId": {},
	        "virtualInterfaceType": {},
	        "virtualInterfaceName": {},
	        "vlan": {
	          "type": "integer"
	        },
	        "asn": {
	          "type": "integer"
	        },
	        "amazonSideAsn": {
	          "type": "long"
	        },
	        "authKey": {},
	        "amazonAddress": {},
	        "customerAddress": {},
	        "addressFamily": {},
	        "virtualInterfaceState": {},
	        "customerRouterConfig": {},
	        "mtu": {
	          "type": "integer"
	        },
	        "jumboFrameCapable": {
	          "type": "boolean"
	        },
	        "virtualGatewayId": {},
	        "directConnectGatewayId": {},
	        "routeFilterPrefixes": {
	          "shape": "S5"
	        },
	        "bgpPeers": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "bgpPeerId": {},
	              "asn": {
	                "type": "integer"
	              },
	              "authKey": {},
	              "addressFamily": {},
	              "amazonAddress": {},
	              "customerAddress": {},
	              "bgpPeerState": {},
	              "bgpStatus": {},
	              "awsDeviceV2": {},
	              "awsLogicalDeviceId": {}
	            }
	          }
	        },
	        "region": {},
	        "awsDeviceV2": {},
	        "awsLogicalDeviceId": {},
	        "tags": {
	          "shape": "S10"
	        },
	        "siteLinkEnabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S2v": {
	      "type": "structure",
	      "members": {
	        "directConnectGatewayId": {},
	        "directConnectGatewayName": {},
	        "amazonSideAsn": {
	          "type": "long"
	        },
	        "ownerAccount": {},
	        "directConnectGatewayState": {},
	        "stateChangeError": {}
	      }
	    },
	    "S32": {
	      "type": "structure",
	      "members": {
	        "proposalId": {},
	        "directConnectGatewayId": {},
	        "directConnectGatewayOwnerAccount": {},
	        "proposalState": {},
	        "associatedGateway": {
	          "shape": "Sc"
	        },
	        "existingAllowedPrefixesToDirectConnectGateway": {
	          "shape": "S5"
	        },
	        "requestedAllowedPrefixesToDirectConnectGateway": {
	          "shape": "S5"
	        }
	      }
	    },
	    "S36": {
	      "type": "structure",
	      "members": {
	        "interconnectId": {},
	        "interconnectName": {},
	        "interconnectState": {},
	        "region": {},
	        "location": {},
	        "bandwidth": {},
	        "loaIssueTime": {
	          "type": "timestamp"
	        },
	        "lagId": {},
	        "awsDevice": {
	          "shape": "Sv"
	        },
	        "jumboFrameCapable": {
	          "type": "boolean"
	        },
	        "awsDeviceV2": {},
	        "awsLogicalDeviceId": {},
	        "hasLogicalRedundancy": {},
	        "tags": {
	          "shape": "S10"
	        },
	        "providerName": {}
	      }
	    },
	    "S3b": {
	      "type": "structure",
	      "members": {
	        "connectionsBandwidth": {},
	        "numberOfConnections": {
	          "type": "integer"
	        },
	        "lagId": {},
	        "ownerAccount": {},
	        "lagName": {},
	        "lagState": {},
	        "location": {},
	        "region": {},
	        "minimumLinks": {
	          "type": "integer"
	        },
	        "awsDevice": {
	          "shape": "Sv"
	        },
	        "awsDeviceV2": {},
	        "awsLogicalDeviceId": {},
	        "connections": {
	          "shape": "S3d"
	        },
	        "allowsHostedConnections": {
	          "type": "boolean"
	        },
	        "jumboFrameCapable": {
	          "type": "boolean"
	        },
	        "hasLogicalRedundancy": {},
	        "tags": {
	          "shape": "S10"
	        },
	        "providerName": {},
	        "macSecCapable": {
	          "type": "boolean"
	        },
	        "encryptionMode": {},
	        "macSecKeys": {
	          "shape": "S18"
	        }
	      }
	    },
	    "S3d": {
	      "type": "list",
	      "member": {
	        "shape": "So"
	      }
	    },
	    "S44": {
	      "type": "structure",
	      "members": {
	        "loaContent": {
	          "type": "blob"
	        },
	        "loaContentType": {}
	      }
	    },
	    "S47": {
	      "type": "structure",
	      "members": {
	        "connections": {
	          "shape": "S3d"
	        }
	      }
	    },
	    "S65": {
	      "type": "list",
	      "member": {}
	    },
	    "S69": {
	      "type": "structure",
	      "members": {
	        "testId": {},
	        "virtualInterfaceId": {},
	        "bgpPeers": {
	          "shape": "S65"
	        },
	        "status": {},
	        "ownerAccount": {},
	        "testDurationInMinutes": {
	          "type": "integer"
	        },
	        "startTime": {
	          "type": "timestamp"
	        },
	        "endTime": {
	          "type": "timestamp"
	        }
	      }
	    }
	  }
	}
	},{}],72:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeConnections": {
	      "result_key": "connections"
	    },
	    "DescribeConnectionsOnInterconnect": {
	      "result_key": "connections"
	    },
	    "DescribeInterconnects": {
	      "result_key": "interconnects"
	    },
	    "DescribeLocations": {
	      "result_key": "locations"
	    },
	    "DescribeVirtualGateways": {
	      "result_key": "virtualGateways"
	    },
	    "DescribeVirtualInterfaces": {
	      "result_key": "virtualInterfaces"
	    }
	  }
	}
	},{}],73:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2011-12-05",
	    "endpointPrefix": "dynamodb",
	    "jsonVersion": "1.0",
	    "protocol": "json",
	    "serviceAbbreviation": "DynamoDB",
	    "serviceFullName": "Amazon DynamoDB",
	    "serviceId": "DynamoDB",
	    "signatureVersion": "v4",
	    "targetPrefix": "DynamoDB_20111205",
	    "uid": "dynamodb-2011-12-05"
	  },
	  "operations": {
	    "BatchGetItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RequestItems"
	        ],
	        "members": {
	          "RequestItems": {
	            "shape": "S2"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Responses": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "members": {
	                "Items": {
	                  "shape": "Sk"
	                },
	                "ConsumedCapacityUnits": {
	                  "type": "double"
	                }
	              }
	            }
	          },
	          "UnprocessedKeys": {
	            "shape": "S2"
	          }
	        }
	      }
	    },
	    "BatchWriteItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RequestItems"
	        ],
	        "members": {
	          "RequestItems": {
	            "shape": "So"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Responses": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "members": {
	                "ConsumedCapacityUnits": {
	                  "type": "double"
	                }
	              }
	            }
	          },
	          "UnprocessedItems": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "CreateTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "KeySchema",
	          "ProvisionedThroughput"
	        ],
	        "members": {
	          "TableName": {},
	          "KeySchema": {
	            "shape": "Sy"
	          },
	          "ProvisionedThroughput": {
	            "shape": "S12"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableDescription": {
	            "shape": "S15"
	          }
	        }
	      }
	    },
	    "DeleteItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "Key"
	        ],
	        "members": {
	          "TableName": {},
	          "Key": {
	            "shape": "S6"
	          },
	          "Expected": {
	            "shape": "S1b"
	          },
	          "ReturnValues": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "Sl"
	          },
	          "ConsumedCapacityUnits": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "DeleteTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableDescription": {
	            "shape": "S15"
	          }
	        }
	      }
	    },
	    "DescribeTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Table": {
	            "shape": "S15"
	          }
	        }
	      }
	    },
	    "GetItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "Key"
	        ],
	        "members": {
	          "TableName": {},
	          "Key": {
	            "shape": "S6"
	          },
	          "AttributesToGet": {
	            "shape": "Se"
	          },
	          "ConsistentRead": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Item": {
	            "shape": "Sl"
	          },
	          "ConsumedCapacityUnits": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "ListTables": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ExclusiveStartTableName": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableNames": {
	            "type": "list",
	            "member": {}
	          },
	          "LastEvaluatedTableName": {}
	        }
	      }
	    },
	    "PutItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "Item"
	        ],
	        "members": {
	          "TableName": {},
	          "Item": {
	            "shape": "Ss"
	          },
	          "Expected": {
	            "shape": "S1b"
	          },
	          "ReturnValues": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "Sl"
	          },
	          "ConsumedCapacityUnits": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "Query": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "HashKeyValue"
	        ],
	        "members": {
	          "TableName": {},
	          "AttributesToGet": {
	            "shape": "Se"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "ConsistentRead": {
	            "type": "boolean"
	          },
	          "Count": {
	            "type": "boolean"
	          },
	          "HashKeyValue": {
	            "shape": "S7"
	          },
	          "RangeKeyCondition": {
	            "shape": "S1u"
	          },
	          "ScanIndexForward": {
	            "type": "boolean"
	          },
	          "ExclusiveStartKey": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Items": {
	            "shape": "Sk"
	          },
	          "Count": {
	            "type": "integer"
	          },
	          "LastEvaluatedKey": {
	            "shape": "S6"
	          },
	          "ConsumedCapacityUnits": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "Scan": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {},
	          "AttributesToGet": {
	            "shape": "Se"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "Count": {
	            "type": "boolean"
	          },
	          "ScanFilter": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "shape": "S1u"
	            }
	          },
	          "ExclusiveStartKey": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Items": {
	            "shape": "Sk"
	          },
	          "Count": {
	            "type": "integer"
	          },
	          "ScannedCount": {
	            "type": "integer"
	          },
	          "LastEvaluatedKey": {
	            "shape": "S6"
	          },
	          "ConsumedCapacityUnits": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "UpdateItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "Key",
	          "AttributeUpdates"
	        ],
	        "members": {
	          "TableName": {},
	          "Key": {
	            "shape": "S6"
	          },
	          "AttributeUpdates": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "members": {
	                "Value": {
	                  "shape": "S7"
	                },
	                "Action": {}
	              }
	            }
	          },
	          "Expected": {
	            "shape": "S1b"
	          },
	          "ReturnValues": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "Sl"
	          },
	          "ConsumedCapacityUnits": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "UpdateTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "ProvisionedThroughput"
	        ],
	        "members": {
	          "TableName": {},
	          "ProvisionedThroughput": {
	            "shape": "S12"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableDescription": {
	            "shape": "S15"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "required": [
	          "Keys"
	        ],
	        "members": {
	          "Keys": {
	            "type": "list",
	            "member": {
	              "shape": "S6"
	            }
	          },
	          "AttributesToGet": {
	            "shape": "Se"
	          },
	          "ConsistentRead": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S6": {
	      "type": "structure",
	      "required": [
	        "HashKeyElement"
	      ],
	      "members": {
	        "HashKeyElement": {
	          "shape": "S7"
	        },
	        "RangeKeyElement": {
	          "shape": "S7"
	        }
	      }
	    },
	    "S7": {
	      "type": "structure",
	      "members": {
	        "S": {},
	        "N": {},
	        "B": {
	          "type": "blob"
	        },
	        "SS": {
	          "type": "list",
	          "member": {}
	        },
	        "NS": {
	          "type": "list",
	          "member": {}
	        },
	        "BS": {
	          "type": "list",
	          "member": {
	            "type": "blob"
	          }
	        }
	      }
	    },
	    "Se": {
	      "type": "list",
	      "member": {}
	    },
	    "Sk": {
	      "type": "list",
	      "member": {
	        "shape": "Sl"
	      }
	    },
	    "Sl": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "S7"
	      }
	    },
	    "So": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "list",
	        "member": {
	          "type": "structure",
	          "members": {
	            "PutRequest": {
	              "type": "structure",
	              "required": [
	                "Item"
	              ],
	              "members": {
	                "Item": {
	                  "shape": "Ss"
	                }
	              }
	            },
	            "DeleteRequest": {
	              "type": "structure",
	              "required": [
	                "Key"
	              ],
	              "members": {
	                "Key": {
	                  "shape": "S6"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Ss": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "S7"
	      }
	    },
	    "Sy": {
	      "type": "structure",
	      "required": [
	        "HashKeyElement"
	      ],
	      "members": {
	        "HashKeyElement": {
	          "shape": "Sz"
	        },
	        "RangeKeyElement": {
	          "shape": "Sz"
	        }
	      }
	    },
	    "Sz": {
	      "type": "structure",
	      "required": [
	        "AttributeName",
	        "AttributeType"
	      ],
	      "members": {
	        "AttributeName": {},
	        "AttributeType": {}
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "required": [
	        "ReadCapacityUnits",
	        "WriteCapacityUnits"
	      ],
	      "members": {
	        "ReadCapacityUnits": {
	          "type": "long"
	        },
	        "WriteCapacityUnits": {
	          "type": "long"
	        }
	      }
	    },
	    "S15": {
	      "type": "structure",
	      "members": {
	        "TableName": {},
	        "KeySchema": {
	          "shape": "Sy"
	        },
	        "TableStatus": {},
	        "CreationDateTime": {
	          "type": "timestamp"
	        },
	        "ProvisionedThroughput": {
	          "type": "structure",
	          "members": {
	            "LastIncreaseDateTime": {
	              "type": "timestamp"
	            },
	            "LastDecreaseDateTime": {
	              "type": "timestamp"
	            },
	            "NumberOfDecreasesToday": {
	              "type": "long"
	            },
	            "ReadCapacityUnits": {
	              "type": "long"
	            },
	            "WriteCapacityUnits": {
	              "type": "long"
	            }
	          }
	        },
	        "TableSizeBytes": {
	          "type": "long"
	        },
	        "ItemCount": {
	          "type": "long"
	        }
	      }
	    },
	    "S1b": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "members": {
	          "Value": {
	            "shape": "S7"
	          },
	          "Exists": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S1u": {
	      "type": "structure",
	      "required": [
	        "ComparisonOperator"
	      ],
	      "members": {
	        "AttributeValueList": {
	          "type": "list",
	          "member": {
	            "shape": "S7"
	          }
	        },
	        "ComparisonOperator": {}
	      }
	    }
	  }
	}
	},{}],74:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "BatchGetItem": {
	      "input_token": "RequestItems",
	      "output_token": "UnprocessedKeys"
	    },
	    "ListTables": {
	      "input_token": "ExclusiveStartTableName",
	      "limit_key": "Limit",
	      "output_token": "LastEvaluatedTableName",
	      "result_key": "TableNames"
	    },
	    "Query": {
	      "input_token": "ExclusiveStartKey",
	      "limit_key": "Limit",
	      "output_token": "LastEvaluatedKey",
	      "result_key": "Items"
	    },
	    "Scan": {
	      "input_token": "ExclusiveStartKey",
	      "limit_key": "Limit",
	      "output_token": "LastEvaluatedKey",
	      "result_key": "Items"
	    }
	  }
	}
	},{}],75:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "TableExists": {
	      "delay": 20,
	      "operation": "DescribeTable",
	      "maxAttempts": 25,
	      "acceptors": [
	        {
	          "expected": "ACTIVE",
	          "matcher": "path",
	          "state": "success",
	          "argument": "Table.TableStatus"
	        },
	        {
	          "expected": "ResourceNotFoundException",
	          "matcher": "error",
	          "state": "retry"
	        }
	      ]
	    },
	    "TableNotExists": {
	      "delay": 20,
	      "operation": "DescribeTable",
	      "maxAttempts": 25,
	      "acceptors": [
	        {
	          "expected": "ResourceNotFoundException",
	          "matcher": "error",
	          "state": "success"
	        }
	      ]
	    }
	  }
	}
	
	},{}],76:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2012-08-10",
	    "endpointPrefix": "dynamodb",
	    "jsonVersion": "1.0",
	    "protocol": "json",
	    "serviceAbbreviation": "DynamoDB",
	    "serviceFullName": "Amazon DynamoDB",
	    "serviceId": "DynamoDB",
	    "signatureVersion": "v4",
	    "targetPrefix": "DynamoDB_20120810",
	    "uid": "dynamodb-2012-08-10"
	  },
	  "operations": {
	    "BatchExecuteStatement": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Statements"
	        ],
	        "members": {
	          "Statements": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Statement"
	              ],
	              "members": {
	                "Statement": {},
	                "Parameters": {
	                  "shape": "S5"
	                },
	                "ConsistentRead": {
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "ReturnConsumedCapacity": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Responses": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Error": {
	                  "type": "structure",
	                  "members": {
	                    "Code": {},
	                    "Message": {}
	                  }
	                },
	                "TableName": {},
	                "Item": {
	                  "shape": "Sr"
	                }
	              }
	            }
	          },
	          "ConsumedCapacity": {
	            "shape": "Ss"
	          }
	        }
	      }
	    },
	    "BatchGetItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RequestItems"
	        ],
	        "members": {
	          "RequestItems": {
	            "shape": "Sz"
	          },
	          "ReturnConsumedCapacity": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Responses": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "shape": "S19"
	            }
	          },
	          "UnprocessedKeys": {
	            "shape": "Sz"
	          },
	          "ConsumedCapacity": {
	            "shape": "Ss"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "BatchWriteItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RequestItems"
	        ],
	        "members": {
	          "RequestItems": {
	            "shape": "S1b"
	          },
	          "ReturnConsumedCapacity": {},
	          "ReturnItemCollectionMetrics": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UnprocessedItems": {
	            "shape": "S1b"
	          },
	          "ItemCollectionMetrics": {
	            "shape": "S1j"
	          },
	          "ConsumedCapacity": {
	            "shape": "Ss"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "CreateBackup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "BackupName"
	        ],
	        "members": {
	          "TableName": {},
	          "BackupName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BackupDetails": {
	            "shape": "S1s"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "CreateGlobalTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalTableName",
	          "ReplicationGroup"
	        ],
	        "members": {
	          "GlobalTableName": {},
	          "ReplicationGroup": {
	            "shape": "S20"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GlobalTableDescription": {
	            "shape": "S24"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "CreateTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AttributeDefinitions",
	          "TableName",
	          "KeySchema"
	        ],
	        "members": {
	          "AttributeDefinitions": {
	            "shape": "S2k"
	          },
	          "TableName": {},
	          "KeySchema": {
	            "shape": "S2o"
	          },
	          "LocalSecondaryIndexes": {
	            "shape": "S2r"
	          },
	          "GlobalSecondaryIndexes": {
	            "shape": "S2x"
	          },
	          "BillingMode": {},
	          "ProvisionedThroughput": {
	            "shape": "S2z"
	          },
	          "StreamSpecification": {
	            "shape": "S31"
	          },
	          "SSESpecification": {
	            "shape": "S34"
	          },
	          "Tags": {
	            "shape": "S37"
	          },
	          "TableClass": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableDescription": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DeleteBackup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BackupArn"
	        ],
	        "members": {
	          "BackupArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BackupDescription": {
	            "shape": "S40"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DeleteItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "Key"
	        ],
	        "members": {
	          "TableName": {},
	          "Key": {
	            "shape": "S12"
	          },
	          "Expected": {
	            "shape": "S4d"
	          },
	          "ConditionalOperator": {},
	          "ReturnValues": {},
	          "ReturnConsumedCapacity": {},
	          "ReturnItemCollectionMetrics": {},
	          "ConditionExpression": {},
	          "ExpressionAttributeNames": {
	            "shape": "S15"
	          },
	          "ExpressionAttributeValues": {
	            "shape": "S4l"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "Sr"
	          },
	          "ConsumedCapacity": {
	            "shape": "St"
	          },
	          "ItemCollectionMetrics": {
	            "shape": "S1l"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DeleteTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableDescription": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DescribeBackup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BackupArn"
	        ],
	        "members": {
	          "BackupArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BackupDescription": {
	            "shape": "S40"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DescribeContinuousBackups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContinuousBackupsDescription": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DescribeContributorInsights": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {},
	          "IndexName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableName": {},
	          "IndexName": {},
	          "ContributorInsightsRuleList": {
	            "type": "list",
	            "member": {}
	          },
	          "ContributorInsightsStatus": {},
	          "LastUpdateDateTime": {
	            "type": "timestamp"
	          },
	          "FailureException": {
	            "type": "structure",
	            "members": {
	              "ExceptionName": {},
	              "ExceptionDescription": {}
	            }
	          }
	        }
	      }
	    },
	    "DescribeEndpoints": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Endpoints"
	        ],
	        "members": {
	          "Endpoints": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Address",
	                "CachePeriodInMinutes"
	              ],
	              "members": {
	                "Address": {},
	                "CachePeriodInMinutes": {
	                  "type": "long"
	                }
	              }
	            }
	          }
	        }
	      },
	      "endpointoperation": true
	    },
	    "DescribeExport": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExportArn"
	        ],
	        "members": {
	          "ExportArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExportDescription": {
	            "shape": "S5e"
	          }
	        }
	      }
	    },
	    "DescribeGlobalTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalTableName"
	        ],
	        "members": {
	          "GlobalTableName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GlobalTableDescription": {
	            "shape": "S24"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DescribeGlobalTableSettings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalTableName"
	        ],
	        "members": {
	          "GlobalTableName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GlobalTableName": {},
	          "ReplicaSettings": {
	            "shape": "S5y"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DescribeKinesisStreamingDestination": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableName": {},
	          "KinesisDataStreamDestinations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "StreamArn": {},
	                "DestinationStatus": {},
	                "DestinationStatusDescription": {}
	              }
	            }
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DescribeLimits": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AccountMaxReadCapacityUnits": {
	            "type": "long"
	          },
	          "AccountMaxWriteCapacityUnits": {
	            "type": "long"
	          },
	          "TableMaxReadCapacityUnits": {
	            "type": "long"
	          },
	          "TableMaxWriteCapacityUnits": {
	            "type": "long"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DescribeTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Table": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DescribeTableReplicaAutoScaling": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableAutoScalingDescription": {
	            "shape": "S6k"
	          }
	        }
	      }
	    },
	    "DescribeTimeToLive": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TimeToLiveDescription": {
	            "shape": "S49"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "DisableKinesisStreamingDestination": {
	      "input": {
	        "shape": "S6r"
	      },
	      "output": {
	        "shape": "S6s"
	      },
	      "endpointdiscovery": {}
	    },
	    "EnableKinesisStreamingDestination": {
	      "input": {
	        "shape": "S6r"
	      },
	      "output": {
	        "shape": "S6s"
	      },
	      "endpointdiscovery": {}
	    },
	    "ExecuteStatement": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Statement"
	        ],
	        "members": {
	          "Statement": {},
	          "Parameters": {
	            "shape": "S5"
	          },
	          "ConsistentRead": {
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "ReturnConsumedCapacity": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Items": {
	            "shape": "S19"
	          },
	          "NextToken": {},
	          "ConsumedCapacity": {
	            "shape": "St"
	          },
	          "LastEvaluatedKey": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "ExecuteTransaction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransactStatements"
	        ],
	        "members": {
	          "TransactStatements": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Statement"
	              ],
	              "members": {
	                "Statement": {},
	                "Parameters": {
	                  "shape": "S5"
	                }
	              }
	            }
	          },
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "ReturnConsumedCapacity": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Responses": {
	            "shape": "S72"
	          },
	          "ConsumedCapacity": {
	            "shape": "Ss"
	          }
	        }
	      }
	    },
	    "ExportTableToPointInTime": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableArn",
	          "S3Bucket"
	        ],
	        "members": {
	          "TableArn": {},
	          "ExportTime": {
	            "type": "timestamp"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "S3Bucket": {},
	          "S3BucketOwner": {},
	          "S3Prefix": {},
	          "S3SseAlgorithm": {},
	          "S3SseKmsKeyId": {},
	          "ExportFormat": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExportDescription": {
	            "shape": "S5e"
	          }
	        }
	      }
	    },
	    "GetItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "Key"
	        ],
	        "members": {
	          "TableName": {},
	          "Key": {
	            "shape": "S12"
	          },
	          "AttributesToGet": {
	            "shape": "S13"
	          },
	          "ConsistentRead": {
	            "type": "boolean"
	          },
	          "ReturnConsumedCapacity": {},
	          "ProjectionExpression": {},
	          "ExpressionAttributeNames": {
	            "shape": "S15"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Item": {
	            "shape": "Sr"
	          },
	          "ConsumedCapacity": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "ListBackups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TableName": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "TimeRangeLowerBound": {
	            "type": "timestamp"
	          },
	          "TimeRangeUpperBound": {
	            "type": "timestamp"
	          },
	          "ExclusiveStartBackupArn": {},
	          "BackupType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BackupSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TableName": {},
	                "TableId": {},
	                "TableArn": {},
	                "BackupArn": {},
	                "BackupName": {},
	                "BackupCreationDateTime": {
	                  "type": "timestamp"
	                },
	                "BackupExpiryDateTime": {
	                  "type": "timestamp"
	                },
	                "BackupStatus": {},
	                "BackupType": {},
	                "BackupSizeBytes": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "LastEvaluatedBackupArn": {}
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "ListContributorInsights": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TableName": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContributorInsightsSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TableName": {},
	                "IndexName": {},
	                "ContributorInsightsStatus": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListExports": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TableArn": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExportSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ExportArn": {},
	                "ExportStatus": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListGlobalTables": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ExclusiveStartGlobalTableName": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "RegionName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GlobalTables": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "GlobalTableName": {},
	                "ReplicationGroup": {
	                  "shape": "S20"
	                }
	              }
	            }
	          },
	          "LastEvaluatedGlobalTableName": {}
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "ListTables": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ExclusiveStartTableName": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableNames": {
	            "type": "list",
	            "member": {}
	          },
	          "LastEvaluatedTableName": {}
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "ListTagsOfResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S37"
	          },
	          "NextToken": {}
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "PutItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "Item"
	        ],
	        "members": {
	          "TableName": {},
	          "Item": {
	            "shape": "S1f"
	          },
	          "Expected": {
	            "shape": "S4d"
	          },
	          "ReturnValues": {},
	          "ReturnConsumedCapacity": {},
	          "ReturnItemCollectionMetrics": {},
	          "ConditionalOperator": {},
	          "ConditionExpression": {},
	          "ExpressionAttributeNames": {
	            "shape": "S15"
	          },
	          "ExpressionAttributeValues": {
	            "shape": "S4l"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "Sr"
	          },
	          "ConsumedCapacity": {
	            "shape": "St"
	          },
	          "ItemCollectionMetrics": {
	            "shape": "S1l"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "Query": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {},
	          "IndexName": {},
	          "Select": {},
	          "AttributesToGet": {
	            "shape": "S13"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "ConsistentRead": {
	            "type": "boolean"
	          },
	          "KeyConditions": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "shape": "S88"
	            }
	          },
	          "QueryFilter": {
	            "shape": "S89"
	          },
	          "ConditionalOperator": {},
	          "ScanIndexForward": {
	            "type": "boolean"
	          },
	          "ExclusiveStartKey": {
	            "shape": "S12"
	          },
	          "ReturnConsumedCapacity": {},
	          "ProjectionExpression": {},
	          "FilterExpression": {},
	          "KeyConditionExpression": {},
	          "ExpressionAttributeNames": {
	            "shape": "S15"
	          },
	          "ExpressionAttributeValues": {
	            "shape": "S4l"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Items": {
	            "shape": "S19"
	          },
	          "Count": {
	            "type": "integer"
	          },
	          "ScannedCount": {
	            "type": "integer"
	          },
	          "LastEvaluatedKey": {
	            "shape": "S12"
	          },
	          "ConsumedCapacity": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "RestoreTableFromBackup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetTableName",
	          "BackupArn"
	        ],
	        "members": {
	          "TargetTableName": {},
	          "BackupArn": {},
	          "BillingModeOverride": {},
	          "GlobalSecondaryIndexOverride": {
	            "shape": "S2x"
	          },
	          "LocalSecondaryIndexOverride": {
	            "shape": "S2r"
	          },
	          "ProvisionedThroughputOverride": {
	            "shape": "S2z"
	          },
	          "SSESpecificationOverride": {
	            "shape": "S34"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableDescription": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "RestoreTableToPointInTime": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetTableName"
	        ],
	        "members": {
	          "SourceTableArn": {},
	          "SourceTableName": {},
	          "TargetTableName": {},
	          "UseLatestRestorableTime": {
	            "type": "boolean"
	          },
	          "RestoreDateTime": {
	            "type": "timestamp"
	          },
	          "BillingModeOverride": {},
	          "GlobalSecondaryIndexOverride": {
	            "shape": "S2x"
	          },
	          "LocalSecondaryIndexOverride": {
	            "shape": "S2r"
	          },
	          "ProvisionedThroughputOverride": {
	            "shape": "S2z"
	          },
	          "SSESpecificationOverride": {
	            "shape": "S34"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableDescription": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "Scan": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "TableName": {},
	          "IndexName": {},
	          "AttributesToGet": {
	            "shape": "S13"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "Select": {},
	          "ScanFilter": {
	            "shape": "S89"
	          },
	          "ConditionalOperator": {},
	          "ExclusiveStartKey": {
	            "shape": "S12"
	          },
	          "ReturnConsumedCapacity": {},
	          "TotalSegments": {
	            "type": "integer"
	          },
	          "Segment": {
	            "type": "integer"
	          },
	          "ProjectionExpression": {},
	          "FilterExpression": {},
	          "ExpressionAttributeNames": {
	            "shape": "S15"
	          },
	          "ExpressionAttributeValues": {
	            "shape": "S4l"
	          },
	          "ConsistentRead": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Items": {
	            "shape": "S19"
	          },
	          "Count": {
	            "type": "integer"
	          },
	          "ScannedCount": {
	            "type": "integer"
	          },
	          "LastEvaluatedKey": {
	            "shape": "S12"
	          },
	          "ConsumedCapacity": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "S37"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "TransactGetItems": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransactItems"
	        ],
	        "members": {
	          "TransactItems": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Get"
	              ],
	              "members": {
	                "Get": {
	                  "type": "structure",
	                  "required": [
	                    "Key",
	                    "TableName"
	                  ],
	                  "members": {
	                    "Key": {
	                      "shape": "S12"
	                    },
	                    "TableName": {},
	                    "ProjectionExpression": {},
	                    "ExpressionAttributeNames": {
	                      "shape": "S15"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "ReturnConsumedCapacity": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConsumedCapacity": {
	            "shape": "Ss"
	          },
	          "Responses": {
	            "shape": "S72"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "TransactWriteItems": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransactItems"
	        ],
	        "members": {
	          "TransactItems": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ConditionCheck": {
	                  "type": "structure",
	                  "required": [
	                    "Key",
	                    "TableName",
	                    "ConditionExpression"
	                  ],
	                  "members": {
	                    "Key": {
	                      "shape": "S12"
	                    },
	                    "TableName": {},
	                    "ConditionExpression": {},
	                    "ExpressionAttributeNames": {
	                      "shape": "S15"
	                    },
	                    "ExpressionAttributeValues": {
	                      "shape": "S4l"
	                    },
	                    "ReturnValuesOnConditionCheckFailure": {}
	                  }
	                },
	                "Put": {
	                  "type": "structure",
	                  "required": [
	                    "Item",
	                    "TableName"
	                  ],
	                  "members": {
	                    "Item": {
	                      "shape": "S1f"
	                    },
	                    "TableName": {},
	                    "ConditionExpression": {},
	                    "ExpressionAttributeNames": {
	                      "shape": "S15"
	                    },
	                    "ExpressionAttributeValues": {
	                      "shape": "S4l"
	                    },
	                    "ReturnValuesOnConditionCheckFailure": {}
	                  }
	                },
	                "Delete": {
	                  "type": "structure",
	                  "required": [
	                    "Key",
	                    "TableName"
	                  ],
	                  "members": {
	                    "Key": {
	                      "shape": "S12"
	                    },
	                    "TableName": {},
	                    "ConditionExpression": {},
	                    "ExpressionAttributeNames": {
	                      "shape": "S15"
	                    },
	                    "ExpressionAttributeValues": {
	                      "shape": "S4l"
	                    },
	                    "ReturnValuesOnConditionCheckFailure": {}
	                  }
	                },
	                "Update": {
	                  "type": "structure",
	                  "required": [
	                    "Key",
	                    "UpdateExpression",
	                    "TableName"
	                  ],
	                  "members": {
	                    "Key": {
	                      "shape": "S12"
	                    },
	                    "UpdateExpression": {},
	                    "TableName": {},
	                    "ConditionExpression": {},
	                    "ExpressionAttributeNames": {
	                      "shape": "S15"
	                    },
	                    "ExpressionAttributeValues": {
	                      "shape": "S4l"
	                    },
	                    "ReturnValuesOnConditionCheckFailure": {}
	                  }
	                }
	              }
	            }
	          },
	          "ReturnConsumedCapacity": {},
	          "ReturnItemCollectionMetrics": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConsumedCapacity": {
	            "shape": "Ss"
	          },
	          "ItemCollectionMetrics": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "UpdateContinuousBackups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "PointInTimeRecoverySpecification"
	        ],
	        "members": {
	          "TableName": {},
	          "PointInTimeRecoverySpecification": {
	            "type": "structure",
	            "required": [
	              "PointInTimeRecoveryEnabled"
	            ],
	            "members": {
	              "PointInTimeRecoveryEnabled": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContinuousBackupsDescription": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "UpdateContributorInsights": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "ContributorInsightsAction"
	        ],
	        "members": {
	          "TableName": {},
	          "IndexName": {},
	          "ContributorInsightsAction": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableName": {},
	          "IndexName": {},
	          "ContributorInsightsStatus": {}
	        }
	      }
	    },
	    "UpdateGlobalTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalTableName",
	          "ReplicaUpdates"
	        ],
	        "members": {
	          "GlobalTableName": {},
	          "ReplicaUpdates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Create": {
	                  "type": "structure",
	                  "required": [
	                    "RegionName"
	                  ],
	                  "members": {
	                    "RegionName": {}
	                  }
	                },
	                "Delete": {
	                  "type": "structure",
	                  "required": [
	                    "RegionName"
	                  ],
	                  "members": {
	                    "RegionName": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GlobalTableDescription": {
	            "shape": "S24"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "UpdateGlobalTableSettings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalTableName"
	        ],
	        "members": {
	          "GlobalTableName": {},
	          "GlobalTableBillingMode": {},
	          "GlobalTableProvisionedWriteCapacityUnits": {
	            "type": "long"
	          },
	          "GlobalTableProvisionedWriteCapacityAutoScalingSettingsUpdate": {
	            "shape": "S9g"
	          },
	          "GlobalTableGlobalSecondaryIndexSettingsUpdate": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "IndexName"
	              ],
	              "members": {
	                "IndexName": {},
	                "ProvisionedWriteCapacityUnits": {
	                  "type": "long"
	                },
	                "ProvisionedWriteCapacityAutoScalingSettingsUpdate": {
	                  "shape": "S9g"
	                }
	              }
	            }
	          },
	          "ReplicaSettingsUpdate": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "RegionName"
	              ],
	              "members": {
	                "RegionName": {},
	                "ReplicaProvisionedReadCapacityUnits": {
	                  "type": "long"
	                },
	                "ReplicaProvisionedReadCapacityAutoScalingSettingsUpdate": {
	                  "shape": "S9g"
	                },
	                "ReplicaGlobalSecondaryIndexSettingsUpdate": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "required": [
	                      "IndexName"
	                    ],
	                    "members": {
	                      "IndexName": {},
	                      "ProvisionedReadCapacityUnits": {
	                        "type": "long"
	                      },
	                      "ProvisionedReadCapacityAutoScalingSettingsUpdate": {
	                        "shape": "S9g"
	                      }
	                    }
	                  }
	                },
	                "ReplicaTableClass": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GlobalTableName": {},
	          "ReplicaSettings": {
	            "shape": "S5y"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "UpdateItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "Key"
	        ],
	        "members": {
	          "TableName": {},
	          "Key": {
	            "shape": "S12"
	          },
	          "AttributeUpdates": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "members": {
	                "Value": {
	                  "shape": "S6"
	                },
	                "Action": {}
	              }
	            }
	          },
	          "Expected": {
	            "shape": "S4d"
	          },
	          "ConditionalOperator": {},
	          "ReturnValues": {},
	          "ReturnConsumedCapacity": {},
	          "ReturnItemCollectionMetrics": {},
	          "UpdateExpression": {},
	          "ConditionExpression": {},
	          "ExpressionAttributeNames": {
	            "shape": "S15"
	          },
	          "ExpressionAttributeValues": {
	            "shape": "S4l"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "Sr"
	          },
	          "ConsumedCapacity": {
	            "shape": "St"
	          },
	          "ItemCollectionMetrics": {
	            "shape": "S1l"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "UpdateTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "AttributeDefinitions": {
	            "shape": "S2k"
	          },
	          "TableName": {},
	          "BillingMode": {},
	          "ProvisionedThroughput": {
	            "shape": "S2z"
	          },
	          "GlobalSecondaryIndexUpdates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Update": {
	                  "type": "structure",
	                  "required": [
	                    "IndexName",
	                    "ProvisionedThroughput"
	                  ],
	                  "members": {
	                    "IndexName": {},
	                    "ProvisionedThroughput": {
	                      "shape": "S2z"
	                    }
	                  }
	                },
	                "Create": {
	                  "type": "structure",
	                  "required": [
	                    "IndexName",
	                    "KeySchema",
	                    "Projection"
	                  ],
	                  "members": {
	                    "IndexName": {},
	                    "KeySchema": {
	                      "shape": "S2o"
	                    },
	                    "Projection": {
	                      "shape": "S2t"
	                    },
	                    "ProvisionedThroughput": {
	                      "shape": "S2z"
	                    }
	                  }
	                },
	                "Delete": {
	                  "type": "structure",
	                  "required": [
	                    "IndexName"
	                  ],
	                  "members": {
	                    "IndexName": {}
	                  }
	                }
	              }
	            }
	          },
	          "StreamSpecification": {
	            "shape": "S31"
	          },
	          "SSESpecification": {
	            "shape": "S34"
	          },
	          "ReplicaUpdates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Create": {
	                  "type": "structure",
	                  "required": [
	                    "RegionName"
	                  ],
	                  "members": {
	                    "RegionName": {},
	                    "KMSMasterKeyId": {},
	                    "ProvisionedThroughputOverride": {
	                      "shape": "S2b"
	                    },
	                    "GlobalSecondaryIndexes": {
	                      "shape": "Sa5"
	                    },
	                    "TableClassOverride": {}
	                  }
	                },
	                "Update": {
	                  "type": "structure",
	                  "required": [
	                    "RegionName"
	                  ],
	                  "members": {
	                    "RegionName": {},
	                    "KMSMasterKeyId": {},
	                    "ProvisionedThroughputOverride": {
	                      "shape": "S2b"
	                    },
	                    "GlobalSecondaryIndexes": {
	                      "shape": "Sa5"
	                    },
	                    "TableClassOverride": {}
	                  }
	                },
	                "Delete": {
	                  "type": "structure",
	                  "required": [
	                    "RegionName"
	                  ],
	                  "members": {
	                    "RegionName": {}
	                  }
	                }
	              }
	            }
	          },
	          "TableClass": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableDescription": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    },
	    "UpdateTableReplicaAutoScaling": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName"
	        ],
	        "members": {
	          "GlobalSecondaryIndexUpdates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "IndexName": {},
	                "ProvisionedWriteCapacityAutoScalingUpdate": {
	                  "shape": "S9g"
	                }
	              }
	            }
	          },
	          "TableName": {},
	          "ProvisionedWriteCapacityAutoScalingUpdate": {
	            "shape": "S9g"
	          },
	          "ReplicaUpdates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "RegionName"
	              ],
	              "members": {
	                "RegionName": {},
	                "ReplicaGlobalSecondaryIndexUpdates": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "IndexName": {},
	                      "ProvisionedReadCapacityAutoScalingUpdate": {
	                        "shape": "S9g"
	                      }
	                    }
	                  }
	                },
	                "ReplicaProvisionedReadCapacityAutoScalingUpdate": {
	                  "shape": "S9g"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TableAutoScalingDescription": {
	            "shape": "S6k"
	          }
	        }
	      }
	    },
	    "UpdateTimeToLive": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TableName",
	          "TimeToLiveSpecification"
	        ],
	        "members": {
	          "TableName": {},
	          "TimeToLiveSpecification": {
	            "shape": "Saj"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TimeToLiveSpecification": {
	            "shape": "Saj"
	          }
	        }
	      },
	      "endpointdiscovery": {}
	    }
	  },
	  "shapes": {
	    "S5": {
	      "type": "list",
	      "member": {
	        "shape": "S6"
	      }
	    },
	    "S6": {
	      "type": "structure",
	      "members": {
	        "S": {},
	        "N": {},
	        "B": {
	          "type": "blob"
	        },
	        "SS": {
	          "type": "list",
	          "member": {}
	        },
	        "NS": {
	          "type": "list",
	          "member": {}
	        },
	        "BS": {
	          "type": "list",
	          "member": {
	            "type": "blob"
	          }
	        },
	        "M": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "shape": "S6"
	          }
	        },
	        "L": {
	          "type": "list",
	          "member": {
	            "shape": "S6"
	          }
	        },
	        "NULL": {
	          "type": "boolean"
	        },
	        "BOOL": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Sr": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "S6"
	      }
	    },
	    "Ss": {
	      "type": "list",
	      "member": {
	        "shape": "St"
	      }
	    },
	    "St": {
	      "type": "structure",
	      "members": {
	        "TableName": {},
	        "CapacityUnits": {
	          "type": "double"
	        },
	        "ReadCapacityUnits": {
	          "type": "double"
	        },
	        "WriteCapacityUnits": {
	          "type": "double"
	        },
	        "Table": {
	          "shape": "Sv"
	        },
	        "LocalSecondaryIndexes": {
	          "shape": "Sw"
	        },
	        "GlobalSecondaryIndexes": {
	          "shape": "Sw"
	        }
	      }
	    },
	    "Sv": {
	      "type": "structure",
	      "members": {
	        "ReadCapacityUnits": {
	          "type": "double"
	        },
	        "WriteCapacityUnits": {
	          "type": "double"
	        },
	        "CapacityUnits": {
	          "type": "double"
	        }
	      }
	    },
	    "Sw": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "Sv"
	      }
	    },
	    "Sz": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "required": [
	          "Keys"
	        ],
	        "members": {
	          "Keys": {
	            "type": "list",
	            "member": {
	              "shape": "S12"
	            }
	          },
	          "AttributesToGet": {
	            "shape": "S13"
	          },
	          "ConsistentRead": {
	            "type": "boolean"
	          },
	          "ProjectionExpression": {},
	          "ExpressionAttributeNames": {
	            "shape": "S15"
	          }
	        }
	      }
	    },
	    "S12": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "S6"
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {}
	    },
	    "S15": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S19": {
	      "type": "list",
	      "member": {
	        "shape": "Sr"
	      }
	    },
	    "S1b": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "list",
	        "member": {
	          "type": "structure",
	          "members": {
	            "PutRequest": {
	              "type": "structure",
	              "required": [
	                "Item"
	              ],
	              "members": {
	                "Item": {
	                  "shape": "S1f"
	                }
	              }
	            },
	            "DeleteRequest": {
	              "type": "structure",
	              "required": [
	                "Key"
	              ],
	              "members": {
	                "Key": {
	                  "shape": "S12"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1f": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "S6"
	      }
	    },
	    "S1j": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "list",
	        "member": {
	          "shape": "S1l"
	        }
	      }
	    },
	    "S1l": {
	      "type": "structure",
	      "members": {
	        "ItemCollectionKey": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "shape": "S6"
	          }
	        },
	        "SizeEstimateRangeGB": {
	          "type": "list",
	          "member": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "S1s": {
	      "type": "structure",
	      "required": [
	        "BackupArn",
	        "BackupName",
	        "BackupStatus",
	        "BackupType",
	        "BackupCreationDateTime"
	      ],
	      "members": {
	        "BackupArn": {},
	        "BackupName": {},
	        "BackupSizeBytes": {
	          "type": "long"
	        },
	        "BackupStatus": {},
	        "BackupType": {},
	        "BackupCreationDateTime": {
	          "type": "timestamp"
	        },
	        "BackupExpiryDateTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S20": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "RegionName": {}
	        }
	      }
	    },
	    "S24": {
	      "type": "structure",
	      "members": {
	        "ReplicationGroup": {
	          "shape": "S25"
	        },
	        "GlobalTableArn": {},
	        "CreationDateTime": {
	          "type": "timestamp"
	        },
	        "GlobalTableStatus": {},
	        "GlobalTableName": {}
	      }
	    },
	    "S25": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "RegionName": {},
	          "ReplicaStatus": {},
	          "ReplicaStatusDescription": {},
	          "ReplicaStatusPercentProgress": {},
	          "KMSMasterKeyId": {},
	          "ProvisionedThroughputOverride": {
	            "shape": "S2b"
	          },
	          "GlobalSecondaryIndexes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "IndexName": {},
	                "ProvisionedThroughputOverride": {
	                  "shape": "S2b"
	                }
	              }
	            }
	          },
	          "ReplicaInaccessibleDateTime": {
	            "type": "timestamp"
	          },
	          "ReplicaTableClassSummary": {
	            "shape": "S2f"
	          }
	        }
	      }
	    },
	    "S2b": {
	      "type": "structure",
	      "members": {
	        "ReadCapacityUnits": {
	          "type": "long"
	        }
	      }
	    },
	    "S2f": {
	      "type": "structure",
	      "members": {
	        "TableClass": {},
	        "LastUpdateDateTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S2k": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "AttributeName",
	          "AttributeType"
	        ],
	        "members": {
	          "AttributeName": {},
	          "AttributeType": {}
	        }
	      }
	    },
	    "S2o": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "AttributeName",
	          "KeyType"
	        ],
	        "members": {
	          "AttributeName": {},
	          "KeyType": {}
	        }
	      }
	    },
	    "S2r": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "IndexName",
	          "KeySchema",
	          "Projection"
	        ],
	        "members": {
	          "IndexName": {},
	          "KeySchema": {
	            "shape": "S2o"
	          },
	          "Projection": {
	            "shape": "S2t"
	          }
	        }
	      }
	    },
	    "S2t": {
	      "type": "structure",
	      "members": {
	        "ProjectionType": {},
	        "NonKeyAttributes": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S2x": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "IndexName",
	          "KeySchema",
	          "Projection"
	        ],
	        "members": {
	          "IndexName": {},
	          "KeySchema": {
	            "shape": "S2o"
	          },
	          "Projection": {
	            "shape": "S2t"
	          },
	          "ProvisionedThroughput": {
	            "shape": "S2z"
	          }
	        }
	      }
	    },
	    "S2z": {
	      "type": "structure",
	      "required": [
	        "ReadCapacityUnits",
	        "WriteCapacityUnits"
	      ],
	      "members": {
	        "ReadCapacityUnits": {
	          "type": "long"
	        },
	        "WriteCapacityUnits": {
	          "type": "long"
	        }
	      }
	    },
	    "S31": {
	      "type": "structure",
	      "required": [
	        "StreamEnabled"
	      ],
	      "members": {
	        "StreamEnabled": {
	          "type": "boolean"
	        },
	        "StreamViewType": {}
	      }
	    },
	    "S34": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "SSEType": {},
	        "KMSMasterKeyId": {}
	      }
	    },
	    "S37": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S3c": {
	      "type": "structure",
	      "members": {
	        "AttributeDefinitions": {
	          "shape": "S2k"
	        },
	        "TableName": {},
	        "KeySchema": {
	          "shape": "S2o"
	        },
	        "TableStatus": {},
	        "CreationDateTime": {
	          "type": "timestamp"
	        },
	        "ProvisionedThroughput": {
	          "shape": "S3e"
	        },
	        "TableSizeBytes": {
	          "type": "long"
	        },
	        "ItemCount": {
	          "type": "long"
	        },
	        "TableArn": {},
	        "TableId": {},
	        "BillingModeSummary": {
	          "shape": "S3i"
	        },
	        "LocalSecondaryIndexes": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "IndexName": {},
	              "KeySchema": {
	                "shape": "S2o"
	              },
	              "Projection": {
	                "shape": "S2t"
	              },
	              "IndexSizeBytes": {
	                "type": "long"
	              },
	              "ItemCount": {
	                "type": "long"
	              },
	              "IndexArn": {}
	            }
	          }
	        },
	        "GlobalSecondaryIndexes": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "IndexName": {},
	              "KeySchema": {
	                "shape": "S2o"
	              },
	              "Projection": {
	                "shape": "S2t"
	              },
	              "IndexStatus": {},
	              "Backfilling": {
	                "type": "boolean"
	              },
	              "ProvisionedThroughput": {
	                "shape": "S3e"
	              },
	              "IndexSizeBytes": {
	                "type": "long"
	              },
	              "ItemCount": {
	                "type": "long"
	              },
	              "IndexArn": {}
	            }
	          }
	        },
	        "StreamSpecification": {
	          "shape": "S31"
	        },
	        "LatestStreamLabel": {},
	        "LatestStreamArn": {},
	        "GlobalTableVersion": {},
	        "Replicas": {
	          "shape": "S25"
	        },
	        "RestoreSummary": {
	          "type": "structure",
	          "required": [
	            "RestoreDateTime",
	            "RestoreInProgress"
	          ],
	          "members": {
	            "SourceBackupArn": {},
	            "SourceTableArn": {},
	            "RestoreDateTime": {
	              "type": "timestamp"
	            },
	            "RestoreInProgress": {
	              "type": "boolean"
	            }
	          }
	        },
	        "SSEDescription": {
	          "shape": "S3t"
	        },
	        "ArchivalSummary": {
	          "type": "structure",
	          "members": {
	            "ArchivalDateTime": {
	              "type": "timestamp"
	            },
	            "ArchivalReason": {},
	            "ArchivalBackupArn": {}
	          }
	        },
	        "TableClassSummary": {
	          "shape": "S2f"
	        }
	      }
	    },
	    "S3e": {
	      "type": "structure",
	      "members": {
	        "LastIncreaseDateTime": {
	          "type": "timestamp"
	        },
	        "LastDecreaseDateTime": {
	          "type": "timestamp"
	        },
	        "NumberOfDecreasesToday": {
	          "type": "long"
	        },
	        "ReadCapacityUnits": {
	          "type": "long"
	        },
	        "WriteCapacityUnits": {
	          "type": "long"
	        }
	      }
	    },
	    "S3i": {
	      "type": "structure",
	      "members": {
	        "BillingMode": {},
	        "LastUpdateToPayPerRequestDateTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S3t": {
	      "type": "structure",
	      "members": {
	        "Status": {},
	        "SSEType": {},
	        "KMSMasterKeyArn": {},
	        "InaccessibleEncryptionDateTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S40": {
	      "type": "structure",
	      "members": {
	        "BackupDetails": {
	          "shape": "S1s"
	        },
	        "SourceTableDetails": {
	          "type": "structure",
	          "required": [
	            "TableName",
	            "TableId",
	            "KeySchema",
	            "TableCreationDateTime",
	            "ProvisionedThroughput"
	          ],
	          "members": {
	            "TableName": {},
	            "TableId": {},
	            "TableArn": {},
	            "TableSizeBytes": {
	              "type": "long"
	            },
	            "KeySchema": {
	              "shape": "S2o"
	            },
	            "TableCreationDateTime": {
	              "type": "timestamp"
	            },
	            "ProvisionedThroughput": {
	              "shape": "S2z"
	            },
	            "ItemCount": {
	              "type": "long"
	            },
	            "BillingMode": {}
	          }
	        },
	        "SourceTableFeatureDetails": {
	          "type": "structure",
	          "members": {
	            "LocalSecondaryIndexes": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "IndexName": {},
	                  "KeySchema": {
	                    "shape": "S2o"
	                  },
	                  "Projection": {
	                    "shape": "S2t"
	                  }
	                }
	              }
	            },
	            "GlobalSecondaryIndexes": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "IndexName": {},
	                  "KeySchema": {
	                    "shape": "S2o"
	                  },
	                  "Projection": {
	                    "shape": "S2t"
	                  },
	                  "ProvisionedThroughput": {
	                    "shape": "S2z"
	                  }
	                }
	              }
	            },
	            "StreamDescription": {
	              "shape": "S31"
	            },
	            "TimeToLiveDescription": {
	              "shape": "S49"
	            },
	            "SSEDescription": {
	              "shape": "S3t"
	            }
	          }
	        }
	      }
	    },
	    "S49": {
	      "type": "structure",
	      "members": {
	        "TimeToLiveStatus": {},
	        "AttributeName": {}
	      }
	    },
	    "S4d": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "members": {
	          "Value": {
	            "shape": "S6"
	          },
	          "Exists": {
	            "type": "boolean"
	          },
	          "ComparisonOperator": {},
	          "AttributeValueList": {
	            "shape": "S4h"
	          }
	        }
	      }
	    },
	    "S4h": {
	      "type": "list",
	      "member": {
	        "shape": "S6"
	      }
	    },
	    "S4l": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "S6"
	      }
	    },
	    "S4u": {
	      "type": "structure",
	      "required": [
	        "ContinuousBackupsStatus"
	      ],
	      "members": {
	        "ContinuousBackupsStatus": {},
	        "PointInTimeRecoveryDescription": {
	          "type": "structure",
	          "members": {
	            "PointInTimeRecoveryStatus": {},
	            "EarliestRestorableDateTime": {
	              "type": "timestamp"
	            },
	            "LatestRestorableDateTime": {
	              "type": "timestamp"
	            }
	          }
	        }
	      }
	    },
	    "S5e": {
	      "type": "structure",
	      "members": {
	        "ExportArn": {},
	        "ExportStatus": {},
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "ExportManifest": {},
	        "TableArn": {},
	        "TableId": {},
	        "ExportTime": {
	          "type": "timestamp"
	        },
	        "ClientToken": {},
	        "S3Bucket": {},
	        "S3BucketOwner": {},
	        "S3Prefix": {},
	        "S3SseAlgorithm": {},
	        "S3SseKmsKeyId": {},
	        "FailureCode": {},
	        "FailureMessage": {},
	        "ExportFormat": {},
	        "BilledSizeBytes": {
	          "type": "long"
	        },
	        "ItemCount": {
	          "type": "long"
	        }
	      }
	    },
	    "S5y": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "RegionName"
	        ],
	        "members": {
	          "RegionName": {},
	          "ReplicaStatus": {},
	          "ReplicaBillingModeSummary": {
	            "shape": "S3i"
	          },
	          "ReplicaProvisionedReadCapacityUnits": {
	            "type": "long"
	          },
	          "ReplicaProvisionedReadCapacityAutoScalingSettings": {
	            "shape": "S60"
	          },
	          "ReplicaProvisionedWriteCapacityUnits": {
	            "type": "long"
	          },
	          "ReplicaProvisionedWriteCapacityAutoScalingSettings": {
	            "shape": "S60"
	          },
	          "ReplicaGlobalSecondaryIndexSettings": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "IndexName"
	              ],
	              "members": {
	                "IndexName": {},
	                "IndexStatus": {},
	                "ProvisionedReadCapacityUnits": {
	                  "type": "long"
	                },
	                "ProvisionedReadCapacityAutoScalingSettings": {
	                  "shape": "S60"
	                },
	                "ProvisionedWriteCapacityUnits": {
	                  "type": "long"
	                },
	                "ProvisionedWriteCapacityAutoScalingSettings": {
	                  "shape": "S60"
	                }
	              }
	            }
	          },
	          "ReplicaTableClassSummary": {
	            "shape": "S2f"
	          }
	        }
	      }
	    },
	    "S60": {
	      "type": "structure",
	      "members": {
	        "MinimumUnits": {
	          "type": "long"
	        },
	        "MaximumUnits": {
	          "type": "long"
	        },
	        "AutoScalingDisabled": {
	          "type": "boolean"
	        },
	        "AutoScalingRoleArn": {},
	        "ScalingPolicies": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "PolicyName": {},
	              "TargetTrackingScalingPolicyConfiguration": {
	                "type": "structure",
	                "required": [
	                  "TargetValue"
	                ],
	                "members": {
	                  "DisableScaleIn": {
	                    "type": "boolean"
	                  },
	                  "ScaleInCooldown": {
	                    "type": "integer"
	                  },
	                  "ScaleOutCooldown": {
	                    "type": "integer"
	                  },
	                  "TargetValue": {
	                    "type": "double"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S6k": {
	      "type": "structure",
	      "members": {
	        "TableName": {},
	        "TableStatus": {},
	        "Replicas": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "RegionName": {},
	              "GlobalSecondaryIndexes": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "IndexName": {},
	                    "IndexStatus": {},
	                    "ProvisionedReadCapacityAutoScalingSettings": {
	                      "shape": "S60"
	                    },
	                    "ProvisionedWriteCapacityAutoScalingSettings": {
	                      "shape": "S60"
	                    }
	                  }
	                }
	              },
	              "ReplicaProvisionedReadCapacityAutoScalingSettings": {
	                "shape": "S60"
	              },
	              "ReplicaProvisionedWriteCapacityAutoScalingSettings": {
	                "shape": "S60"
	              },
	              "ReplicaStatus": {}
	            }
	          }
	        }
	      }
	    },
	    "S6r": {
	      "type": "structure",
	      "required": [
	        "TableName",
	        "StreamArn"
	      ],
	      "members": {
	        "TableName": {},
	        "StreamArn": {}
	      }
	    },
	    "S6s": {
	      "type": "structure",
	      "members": {
	        "TableName": {},
	        "StreamArn": {},
	        "DestinationStatus": {}
	      }
	    },
	    "S72": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Item": {
	            "shape": "Sr"
	          }
	        }
	      }
	    },
	    "S88": {
	      "type": "structure",
	      "required": [
	        "ComparisonOperator"
	      ],
	      "members": {
	        "AttributeValueList": {
	          "shape": "S4h"
	        },
	        "ComparisonOperator": {}
	      }
	    },
	    "S89": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "S88"
	      }
	    },
	    "S9g": {
	      "type": "structure",
	      "members": {
	        "MinimumUnits": {
	          "type": "long"
	        },
	        "MaximumUnits": {
	          "type": "long"
	        },
	        "AutoScalingDisabled": {
	          "type": "boolean"
	        },
	        "AutoScalingRoleArn": {},
	        "ScalingPolicyUpdate": {
	          "type": "structure",
	          "required": [
	            "TargetTrackingScalingPolicyConfiguration"
	          ],
	          "members": {
	            "PolicyName": {},
	            "TargetTrackingScalingPolicyConfiguration": {
	              "type": "structure",
	              "required": [
	                "TargetValue"
	              ],
	              "members": {
	                "DisableScaleIn": {
	                  "type": "boolean"
	                },
	                "ScaleInCooldown": {
	                  "type": "integer"
	                },
	                "ScaleOutCooldown": {
	                  "type": "integer"
	                },
	                "TargetValue": {
	                  "type": "double"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sa5": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "IndexName"
	        ],
	        "members": {
	          "IndexName": {},
	          "ProvisionedThroughputOverride": {
	            "shape": "S2b"
	          }
	        }
	      }
	    },
	    "Saj": {
	      "type": "structure",
	      "required": [
	        "Enabled",
	        "AttributeName"
	      ],
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "AttributeName": {}
	      }
	    }
	  }
	}
	},{}],77:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "BatchGetItem": {
	      "input_token": "RequestItems",
	      "output_token": "UnprocessedKeys"
	    },
	    "ListContributorInsights": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListExports": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListTables": {
	      "input_token": "ExclusiveStartTableName",
	      "limit_key": "Limit",
	      "output_token": "LastEvaluatedTableName",
	      "result_key": "TableNames"
	    },
	    "Query": {
	      "input_token": "ExclusiveStartKey",
	      "limit_key": "Limit",
	      "output_token": "LastEvaluatedKey",
	      "result_key": "Items"
	    },
	    "Scan": {
	      "input_token": "ExclusiveStartKey",
	      "limit_key": "Limit",
	      "output_token": "LastEvaluatedKey",
	      "result_key": "Items"
	    }
	  }
	}
	},{}],78:[function(require,module,exports){
	arguments[4][75][0].apply(exports,arguments)
	},{"dup":75}],79:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2016-11-15",
	    "endpointPrefix": "ec2",
	    "protocol": "ec2",
	    "serviceAbbreviation": "Amazon EC2",
	    "serviceFullName": "Amazon Elastic Compute Cloud",
	    "serviceId": "EC2",
	    "signatureVersion": "v4",
	    "uid": "ec2-2016-11-15",
	    "xmlNamespace": "http://ec2.amazonaws.com/doc/2016-11-15"
	  },
	  "operations": {
	    "AcceptReservedInstancesExchangeQuote": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedInstanceIds"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ReservedInstanceIds": {
	            "shape": "S3",
	            "locationName": "ReservedInstanceId"
	          },
	          "TargetConfigurations": {
	            "shape": "S5",
	            "locationName": "TargetConfiguration"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExchangeId": {
	            "locationName": "exchangeId"
	          }
	        }
	      }
	    },
	    "AcceptTransitGatewayMulticastDomainAssociations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomainId": {},
	          "TransitGatewayAttachmentId": {},
	          "SubnetIds": {
	            "shape": "Se"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Associations": {
	            "shape": "Sg",
	            "locationName": "associations"
	          }
	        }
	      }
	    },
	    "AcceptTransitGatewayPeeringAttachment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayAttachmentId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayPeeringAttachment": {
	            "shape": "Sn",
	            "locationName": "transitGatewayPeeringAttachment"
	          }
	        }
	      }
	    },
	    "AcceptTransitGatewayVpcAttachment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayAttachmentId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayVpcAttachment": {
	            "shape": "Sw",
	            "locationName": "transitGatewayVpcAttachment"
	          }
	        }
	      }
	    },
	    "AcceptVpcEndpointConnections": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceId",
	          "VpcEndpointIds"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ServiceId": {},
	          "VpcEndpointIds": {
	            "shape": "S13",
	            "locationName": "VpcEndpointId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Unsuccessful": {
	            "shape": "S16",
	            "locationName": "unsuccessful"
	          }
	        }
	      }
	    },
	    "AcceptVpcPeeringConnection": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VpcPeeringConnectionId": {
	            "locationName": "vpcPeeringConnectionId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpcPeeringConnection": {
	            "shape": "S1c",
	            "locationName": "vpcPeeringConnection"
	          }
	        }
	      }
	    },
	    "AdvertiseByoipCidr": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Cidr"
	        ],
	        "members": {
	          "Cidr": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ByoipCidr": {
	            "shape": "S1n",
	            "locationName": "byoipCidr"
	          }
	        }
	      }
	    },
	    "AllocateAddress": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Domain": {},
	          "Address": {},
	          "PublicIpv4Pool": {},
	          "NetworkBorderGroup": {},
	          "CustomerOwnedIpv4Pool": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicIp": {
	            "locationName": "publicIp"
	          },
	          "AllocationId": {
	            "locationName": "allocationId"
	          },
	          "PublicIpv4Pool": {
	            "locationName": "publicIpv4Pool"
	          },
	          "NetworkBorderGroup": {
	            "locationName": "networkBorderGroup"
	          },
	          "Domain": {
	            "locationName": "domain"
	          },
	          "CustomerOwnedIp": {
	            "locationName": "customerOwnedIp"
	          },
	          "CustomerOwnedIpv4Pool": {
	            "locationName": "customerOwnedIpv4Pool"
	          },
	          "CarrierIp": {
	            "locationName": "carrierIp"
	          }
	        }
	      }
	    },
	    "AllocateHosts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AvailabilityZone",
	          "Quantity"
	        ],
	        "members": {
	          "AutoPlacement": {
	            "locationName": "autoPlacement"
	          },
	          "AvailabilityZone": {
	            "locationName": "availabilityZone"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          },
	          "InstanceType": {
	            "locationName": "instanceType"
	          },
	          "InstanceFamily": {},
	          "Quantity": {
	            "locationName": "quantity",
	            "type": "integer"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "HostRecovery": {},
	          "OutpostArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HostIds": {
	            "shape": "S21",
	            "locationName": "hostIdSet"
	          }
	        }
	      }
	    },
	    "AllocateIpamPoolCidr": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamPoolId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamPoolId": {},
	          "Cidr": {},
	          "NetmaskLength": {
	            "type": "integer"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "Description": {},
	          "PreviewNextCidr": {
	            "type": "boolean"
	          },
	          "DisallowedCidrs": {
	            "locationName": "DisallowedCidr",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamPoolAllocation": {
	            "shape": "S26",
	            "locationName": "ipamPoolAllocation"
	          }
	        }
	      }
	    },
	    "ApplySecurityGroupsToClientVpnTargetNetwork": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId",
	          "VpcId",
	          "SecurityGroupIds"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "VpcId": {},
	          "SecurityGroupIds": {
	            "shape": "S2c",
	            "locationName": "SecurityGroupId"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SecurityGroupIds": {
	            "shape": "S2c",
	            "locationName": "securityGroupIds"
	          }
	        }
	      }
	    },
	    "AssignIpv6Addresses": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInterfaceId"
	        ],
	        "members": {
	          "Ipv6AddressCount": {
	            "locationName": "ipv6AddressCount",
	            "type": "integer"
	          },
	          "Ipv6Addresses": {
	            "shape": "S2g",
	            "locationName": "ipv6Addresses"
	          },
	          "Ipv6PrefixCount": {
	            "type": "integer"
	          },
	          "Ipv6Prefixes": {
	            "shape": "S2h",
	            "locationName": "Ipv6Prefix"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssignedIpv6Addresses": {
	            "shape": "S2g",
	            "locationName": "assignedIpv6Addresses"
	          },
	          "AssignedIpv6Prefixes": {
	            "shape": "S2h",
	            "locationName": "assignedIpv6PrefixSet"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          }
	        }
	      }
	    },
	    "AssignPrivateIpAddresses": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInterfaceId"
	        ],
	        "members": {
	          "AllowReassignment": {
	            "locationName": "allowReassignment",
	            "type": "boolean"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "PrivateIpAddresses": {
	            "shape": "S2l",
	            "locationName": "privateIpAddress"
	          },
	          "SecondaryPrivateIpAddressCount": {
	            "locationName": "secondaryPrivateIpAddressCount",
	            "type": "integer"
	          },
	          "Ipv4Prefixes": {
	            "shape": "S2h",
	            "locationName": "Ipv4Prefix"
	          },
	          "Ipv4PrefixCount": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "AssignedPrivateIpAddresses": {
	            "locationName": "assignedPrivateIpAddressesSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "PrivateIpAddress": {
	                  "locationName": "privateIpAddress"
	                }
	              }
	            }
	          },
	          "AssignedIpv4Prefixes": {
	            "shape": "S2p",
	            "locationName": "assignedIpv4PrefixSet"
	          }
	        }
	      }
	    },
	    "AssociateAddress": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AllocationId": {},
	          "InstanceId": {},
	          "PublicIp": {},
	          "AllowReassociation": {
	            "locationName": "allowReassociation",
	            "type": "boolean"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "PrivateIpAddress": {
	            "locationName": "privateIpAddress"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationId": {
	            "locationName": "associationId"
	          }
	        }
	      }
	    },
	    "AssociateClientVpnTargetNetwork": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId",
	          "SubnetId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "SubnetId": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationId": {
	            "locationName": "associationId"
	          },
	          "Status": {
	            "shape": "S2y",
	            "locationName": "status"
	          }
	        }
	      }
	    },
	    "AssociateDhcpOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DhcpOptionsId",
	          "VpcId"
	        ],
	        "members": {
	          "DhcpOptionsId": {},
	          "VpcId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "AssociateEnclaveCertificateIamRole": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CertificateArn": {},
	          "RoleArn": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CertificateS3BucketName": {
	            "locationName": "certificateS3BucketName"
	          },
	          "CertificateS3ObjectKey": {
	            "locationName": "certificateS3ObjectKey"
	          },
	          "EncryptionKmsKeyId": {
	            "locationName": "encryptionKmsKeyId"
	          }
	        }
	      }
	    },
	    "AssociateIamInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IamInstanceProfile",
	          "InstanceId"
	        ],
	        "members": {
	          "IamInstanceProfile": {
	            "shape": "S36"
	          },
	          "InstanceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IamInstanceProfileAssociation": {
	            "shape": "S38",
	            "locationName": "iamInstanceProfileAssociation"
	          }
	        }
	      }
	    },
	    "AssociateInstanceEventWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceEventWindowId",
	          "AssociationTarget"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceEventWindowId": {},
	          "AssociationTarget": {
	            "type": "structure",
	            "members": {
	              "InstanceIds": {
	                "shape": "S3e",
	                "locationName": "InstanceId"
	              },
	              "InstanceTags": {
	                "shape": "Ss",
	                "locationName": "InstanceTag"
	              },
	              "DedicatedHostIds": {
	                "shape": "S3f",
	                "locationName": "DedicatedHostId"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceEventWindow": {
	            "shape": "S3i",
	            "locationName": "instanceEventWindow"
	          }
	        }
	      }
	    },
	    "AssociateRouteTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RouteTableId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "RouteTableId": {
	            "locationName": "routeTableId"
	          },
	          "SubnetId": {
	            "locationName": "subnetId"
	          },
	          "GatewayId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationId": {
	            "locationName": "associationId"
	          },
	          "AssociationState": {
	            "shape": "S3u",
	            "locationName": "associationState"
	          }
	        }
	      }
	    },
	    "AssociateSubnetCidrBlock": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Ipv6CidrBlock",
	          "SubnetId"
	        ],
	        "members": {
	          "Ipv6CidrBlock": {
	            "locationName": "ipv6CidrBlock"
	          },
	          "SubnetId": {
	            "locationName": "subnetId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Ipv6CidrBlockAssociation": {
	            "shape": "S3y",
	            "locationName": "ipv6CidrBlockAssociation"
	          },
	          "SubnetId": {
	            "locationName": "subnetId"
	          }
	        }
	      }
	    },
	    "AssociateTransitGatewayMulticastDomain": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomainId": {},
	          "TransitGatewayAttachmentId": {},
	          "SubnetIds": {
	            "shape": "S43"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Associations": {
	            "shape": "Sg",
	            "locationName": "associations"
	          }
	        }
	      }
	    },
	    "AssociateTransitGatewayRouteTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId",
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "TransitGatewayAttachmentId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Association": {
	            "shape": "S48",
	            "locationName": "association"
	          }
	        }
	      }
	    },
	    "AssociateTrunkInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BranchInterfaceId",
	          "TrunkInterfaceId"
	        ],
	        "members": {
	          "BranchInterfaceId": {},
	          "TrunkInterfaceId": {},
	          "VlanId": {
	            "type": "integer"
	          },
	          "GreKey": {
	            "type": "integer"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InterfaceAssociation": {
	            "shape": "S4c",
	            "locationName": "interfaceAssociation"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          }
	        }
	      }
	    },
	    "AssociateVpcCidrBlock": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId"
	        ],
	        "members": {
	          "AmazonProvidedIpv6CidrBlock": {
	            "locationName": "amazonProvidedIpv6CidrBlock",
	            "type": "boolean"
	          },
	          "CidrBlock": {},
	          "VpcId": {
	            "locationName": "vpcId"
	          },
	          "Ipv6CidrBlockNetworkBorderGroup": {},
	          "Ipv6Pool": {},
	          "Ipv6CidrBlock": {},
	          "Ipv4IpamPoolId": {},
	          "Ipv4NetmaskLength": {
	            "type": "integer"
	          },
	          "Ipv6IpamPoolId": {},
	          "Ipv6NetmaskLength": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Ipv6CidrBlockAssociation": {
	            "shape": "S4j",
	            "locationName": "ipv6CidrBlockAssociation"
	          },
	          "CidrBlockAssociation": {
	            "shape": "S4m",
	            "locationName": "cidrBlockAssociation"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          }
	        }
	      }
	    },
	    "AttachClassicLinkVpc": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Groups",
	          "InstanceId",
	          "VpcId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Groups": {
	            "shape": "S4o",
	            "locationName": "SecurityGroupId"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "AttachInternetGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InternetGatewayId",
	          "VpcId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InternetGatewayId": {
	            "locationName": "internetGatewayId"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          }
	        }
	      }
	    },
	    "AttachNetworkInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeviceIndex",
	          "InstanceId",
	          "NetworkInterfaceId"
	        ],
	        "members": {
	          "DeviceIndex": {
	            "locationName": "deviceIndex",
	            "type": "integer"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "NetworkCardIndex": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AttachmentId": {
	            "locationName": "attachmentId"
	          },
	          "NetworkCardIndex": {
	            "locationName": "networkCardIndex",
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "AttachVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Device",
	          "InstanceId",
	          "VolumeId"
	        ],
	        "members": {
	          "Device": {},
	          "InstanceId": {},
	          "VolumeId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4w"
	      }
	    },
	    "AttachVpnGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId",
	          "VpnGatewayId"
	        ],
	        "members": {
	          "VpcId": {},
	          "VpnGatewayId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpcAttachment": {
	            "shape": "S51",
	            "locationName": "attachment"
	          }
	        }
	      }
	    },
	    "AuthorizeClientVpnIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId",
	          "TargetNetworkCidr"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "TargetNetworkCidr": {},
	          "AccessGroupId": {},
	          "AuthorizeAllGroups": {
	            "type": "boolean"
	          },
	          "Description": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {
	            "shape": "S55",
	            "locationName": "status"
	          }
	        }
	      }
	    },
	    "AuthorizeSecurityGroupEgress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "GroupId": {
	            "locationName": "groupId"
	          },
	          "IpPermissions": {
	            "shape": "S58",
	            "locationName": "ipPermissions"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "CidrIp": {
	            "locationName": "cidrIp"
	          },
	          "FromPort": {
	            "locationName": "fromPort",
	            "type": "integer"
	          },
	          "IpProtocol": {
	            "locationName": "ipProtocol"
	          },
	          "ToPort": {
	            "locationName": "toPort",
	            "type": "integer"
	          },
	          "SourceSecurityGroupName": {
	            "locationName": "sourceSecurityGroupName"
	          },
	          "SourceSecurityGroupOwnerId": {
	            "locationName": "sourceSecurityGroupOwnerId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          },
	          "SecurityGroupRules": {
	            "shape": "S5j",
	            "locationName": "securityGroupRuleSet"
	          }
	        }
	      }
	    },
	    "AuthorizeSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CidrIp": {},
	          "FromPort": {
	            "type": "integer"
	          },
	          "GroupId": {},
	          "GroupName": {},
	          "IpPermissions": {
	            "shape": "S58"
	          },
	          "IpProtocol": {},
	          "SourceSecurityGroupName": {},
	          "SourceSecurityGroupOwnerId": {},
	          "ToPort": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          },
	          "SecurityGroupRules": {
	            "shape": "S5j",
	            "locationName": "securityGroupRuleSet"
	          }
	        }
	      }
	    },
	    "BundleInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Storage"
	        ],
	        "members": {
	          "InstanceId": {},
	          "Storage": {
	            "shape": "S5s"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BundleTask": {
	            "shape": "S5w",
	            "locationName": "bundleInstanceTask"
	          }
	        }
	      }
	    },
	    "CancelBundleTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BundleId"
	        ],
	        "members": {
	          "BundleId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BundleTask": {
	            "shape": "S5w",
	            "locationName": "bundleInstanceTask"
	          }
	        }
	      }
	    },
	    "CancelCapacityReservation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CapacityReservationId"
	        ],
	        "members": {
	          "CapacityReservationId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "CancelCapacityReservationFleets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CapacityReservationFleetIds"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "CapacityReservationFleetIds": {
	            "shape": "S66",
	            "locationName": "CapacityReservationFleetId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SuccessfulFleetCancellations": {
	            "locationName": "successfulFleetCancellationSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "CurrentFleetState": {
	                  "locationName": "currentFleetState"
	                },
	                "PreviousFleetState": {
	                  "locationName": "previousFleetState"
	                },
	                "CapacityReservationFleetId": {
	                  "locationName": "capacityReservationFleetId"
	                }
	              }
	            }
	          },
	          "FailedFleetCancellations": {
	            "locationName": "failedFleetCancellationSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "CapacityReservationFleetId": {
	                  "locationName": "capacityReservationFleetId"
	                },
	                "CancelCapacityReservationFleetError": {
	                  "locationName": "cancelCapacityReservationFleetError",
	                  "type": "structure",
	                  "members": {
	                    "Code": {
	                      "locationName": "code"
	                    },
	                    "Message": {
	                      "locationName": "message"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "CancelConversionTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConversionTaskId"
	        ],
	        "members": {
	          "ConversionTaskId": {
	            "locationName": "conversionTaskId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "ReasonMessage": {
	            "locationName": "reasonMessage"
	          }
	        }
	      }
	    },
	    "CancelExportTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExportTaskId"
	        ],
	        "members": {
	          "ExportTaskId": {
	            "locationName": "exportTaskId"
	          }
	        }
	      }
	    },
	    "CancelImportTask": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CancelReason": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ImportTaskId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ImportTaskId": {
	            "locationName": "importTaskId"
	          },
	          "PreviousState": {
	            "locationName": "previousState"
	          },
	          "State": {
	            "locationName": "state"
	          }
	        }
	      }
	    },
	    "CancelReservedInstancesListing": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedInstancesListingId"
	        ],
	        "members": {
	          "ReservedInstancesListingId": {
	            "locationName": "reservedInstancesListingId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReservedInstancesListings": {
	            "shape": "S6r",
	            "locationName": "reservedInstancesListingsSet"
	          }
	        }
	      }
	    },
	    "CancelSpotFleetRequests": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SpotFleetRequestIds",
	          "TerminateInstances"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "SpotFleetRequestIds": {
	            "shape": "S73",
	            "locationName": "spotFleetRequestId"
	          },
	          "TerminateInstances": {
	            "locationName": "terminateInstances",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SuccessfulFleetRequests": {
	            "locationName": "successfulFleetRequestSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "CurrentSpotFleetRequestState": {
	                  "locationName": "currentSpotFleetRequestState"
	                },
	                "PreviousSpotFleetRequestState": {
	                  "locationName": "previousSpotFleetRequestState"
	                },
	                "SpotFleetRequestId": {
	                  "locationName": "spotFleetRequestId"
	                }
	              }
	            }
	          },
	          "UnsuccessfulFleetRequests": {
	            "locationName": "unsuccessfulFleetRequestSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Error": {
	                  "locationName": "error",
	                  "type": "structure",
	                  "members": {
	                    "Code": {
	                      "locationName": "code"
	                    },
	                    "Message": {
	                      "locationName": "message"
	                    }
	                  }
	                },
	                "SpotFleetRequestId": {
	                  "locationName": "spotFleetRequestId"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "CancelSpotInstanceRequests": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SpotInstanceRequestIds"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "SpotInstanceRequestIds": {
	            "shape": "S7e",
	            "locationName": "SpotInstanceRequestId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CancelledSpotInstanceRequests": {
	            "locationName": "spotInstanceRequestSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "SpotInstanceRequestId": {
	                  "locationName": "spotInstanceRequestId"
	                },
	                "State": {
	                  "locationName": "state"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ConfirmProductInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "ProductCode"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ProductCode": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OwnerId": {
	            "locationName": "ownerId"
	          },
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "CopyFpgaImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceFpgaImageId",
	          "SourceRegion"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "SourceFpgaImageId": {},
	          "Description": {},
	          "Name": {},
	          "SourceRegion": {},
	          "ClientToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FpgaImageId": {
	            "locationName": "fpgaImageId"
	          }
	        }
	      }
	    },
	    "CopyImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "SourceImageId",
	          "SourceRegion"
	        ],
	        "members": {
	          "ClientToken": {},
	          "Description": {},
	          "Encrypted": {
	            "locationName": "encrypted",
	            "type": "boolean"
	          },
	          "KmsKeyId": {
	            "locationName": "kmsKeyId"
	          },
	          "Name": {},
	          "SourceImageId": {},
	          "SourceRegion": {},
	          "DestinationOutpostArn": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ImageId": {
	            "locationName": "imageId"
	          }
	        }
	      }
	    },
	    "CopySnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceRegion",
	          "SourceSnapshotId"
	        ],
	        "members": {
	          "Description": {},
	          "DestinationOutpostArn": {},
	          "DestinationRegion": {
	            "locationName": "destinationRegion"
	          },
	          "Encrypted": {
	            "locationName": "encrypted",
	            "type": "boolean"
	          },
	          "KmsKeyId": {
	            "locationName": "kmsKeyId"
	          },
	          "PresignedUrl": {
	            "locationName": "presignedUrl"
	          },
	          "SourceRegion": {},
	          "SourceSnapshotId": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SnapshotId": {
	            "locationName": "snapshotId"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tagSet"
	          }
	        }
	      }
	    },
	    "CreateCapacityReservation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceType",
	          "InstancePlatform",
	          "InstanceCount"
	        ],
	        "members": {
	          "ClientToken": {},
	          "InstanceType": {},
	          "InstancePlatform": {},
	          "AvailabilityZone": {},
	          "AvailabilityZoneId": {},
	          "Tenancy": {},
	          "InstanceCount": {
	            "type": "integer"
	          },
	          "EbsOptimized": {
	            "type": "boolean"
	          },
	          "EphemeralStorage": {
	            "type": "boolean"
	          },
	          "EndDate": {
	            "type": "timestamp"
	          },
	          "EndDateType": {},
	          "InstanceMatchCriteria": {},
	          "TagSpecifications": {
	            "shape": "S1t"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "OutpostArn": {},
	          "PlacementGroupArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CapacityReservation": {
	            "shape": "S81",
	            "locationName": "capacityReservation"
	          }
	        }
	      }
	    },
	    "CreateCapacityReservationFleet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceTypeSpecifications",
	          "TotalTargetCapacity"
	        ],
	        "members": {
	          "AllocationStrategy": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "InstanceTypeSpecifications": {
	            "locationName": "InstanceTypeSpecification",
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "InstanceType": {},
	                "InstancePlatform": {},
	                "Weight": {
	                  "type": "double"
	                },
	                "AvailabilityZone": {},
	                "AvailabilityZoneId": {},
	                "EbsOptimized": {
	                  "type": "boolean"
	                },
	                "Priority": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "Tenancy": {},
	          "TotalTargetCapacity": {
	            "type": "integer"
	          },
	          "EndDate": {
	            "type": "timestamp"
	          },
	          "InstanceMatchCriteria": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CapacityReservationFleetId": {
	            "locationName": "capacityReservationFleetId"
	          },
	          "State": {
	            "locationName": "state"
	          },
	          "TotalTargetCapacity": {
	            "locationName": "totalTargetCapacity",
	            "type": "integer"
	          },
	          "TotalFulfilledCapacity": {
	            "locationName": "totalFulfilledCapacity",
	            "type": "double"
	          },
	          "InstanceMatchCriteria": {
	            "locationName": "instanceMatchCriteria"
	          },
	          "AllocationStrategy": {
	            "locationName": "allocationStrategy"
	          },
	          "CreateTime": {
	            "locationName": "createTime",
	            "type": "timestamp"
	          },
	          "EndDate": {
	            "locationName": "endDate",
	            "type": "timestamp"
	          },
	          "Tenancy": {
	            "locationName": "tenancy"
	          },
	          "FleetCapacityReservations": {
	            "shape": "S8d",
	            "locationName": "fleetCapacityReservationSet"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tagSet"
	          }
	        }
	      }
	    },
	    "CreateCarrierGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId"
	        ],
	        "members": {
	          "VpcId": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CarrierGateway": {
	            "shape": "S8h",
	            "locationName": "carrierGateway"
	          }
	        }
	      }
	    },
	    "CreateClientVpnEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientCidrBlock",
	          "ServerCertificateArn",
	          "AuthenticationOptions",
	          "ConnectionLogOptions"
	        ],
	        "members": {
	          "ClientCidrBlock": {},
	          "ServerCertificateArn": {},
	          "AuthenticationOptions": {
	            "locationName": "Authentication",
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Type": {},
	                "ActiveDirectory": {
	                  "type": "structure",
	                  "members": {
	                    "DirectoryId": {}
	                  }
	                },
	                "MutualAuthentication": {
	                  "type": "structure",
	                  "members": {
	                    "ClientRootCertificateChainArn": {}
	                  }
	                },
	                "FederatedAuthentication": {
	                  "type": "structure",
	                  "members": {
	                    "SAMLProviderArn": {},
	                    "SelfServiceSAMLProviderArn": {}
	                  }
	                }
	              }
	            }
	          },
	          "ConnectionLogOptions": {
	            "shape": "S8r"
	          },
	          "DnsServers": {
	            "shape": "Se"
	          },
	          "TransportProtocol": {},
	          "VpnPort": {
	            "type": "integer"
	          },
	          "Description": {},
	          "SplitTunnel": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "SecurityGroupIds": {
	            "shape": "S2c",
	            "locationName": "SecurityGroupId"
	          },
	          "VpcId": {},
	          "SelfServicePortal": {},
	          "ClientConnectOptions": {
	            "shape": "S8u"
	          },
	          "SessionTimeoutHours": {
	            "type": "integer"
	          },
	          "ClientLoginBannerOptions": {
	            "shape": "S8v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientVpnEndpointId": {
	            "locationName": "clientVpnEndpointId"
	          },
	          "Status": {
	            "shape": "S8x",
	            "locationName": "status"
	          },
	          "DnsName": {
	            "locationName": "dnsName"
	          }
	        }
	      }
	    },
	    "CreateClientVpnRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId",
	          "DestinationCidrBlock",
	          "TargetVpcSubnetId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "DestinationCidrBlock": {},
	          "TargetVpcSubnetId": {},
	          "Description": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {
	            "shape": "S91",
	            "locationName": "status"
	          }
	        }
	      }
	    },
	    "CreateCustomerGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BgpAsn",
	          "Type"
	        ],
	        "members": {
	          "BgpAsn": {
	            "type": "integer"
	          },
	          "PublicIp": {},
	          "CertificateArn": {},
	          "Type": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DeviceName": {},
	          "IpAddress": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CustomerGateway": {
	            "shape": "S96",
	            "locationName": "customerGateway"
	          }
	        }
	      }
	    },
	    "CreateDefaultSubnet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AvailabilityZone"
	        ],
	        "members": {
	          "AvailabilityZone": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Ipv6Native": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Subnet": {
	            "shape": "S99",
	            "locationName": "subnet"
	          }
	        }
	      }
	    },
	    "CreateDefaultVpc": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Vpc": {
	            "shape": "S9h",
	            "locationName": "vpc"
	          }
	        }
	      }
	    },
	    "CreateDhcpOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DhcpConfigurations"
	        ],
	        "members": {
	          "DhcpConfigurations": {
	            "locationName": "dhcpConfiguration",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Key": {
	                  "locationName": "key"
	                },
	                "Values": {
	                  "shape": "Se",
	                  "locationName": "Value"
	                }
	              }
	            }
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DhcpOptions": {
	            "shape": "S9q",
	            "locationName": "dhcpOptions"
	          }
	        }
	      }
	    },
	    "CreateEgressOnlyInternetGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId"
	        ],
	        "members": {
	          "ClientToken": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "VpcId": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientToken": {
	            "locationName": "clientToken"
	          },
	          "EgressOnlyInternetGateway": {
	            "shape": "S9x",
	            "locationName": "egressOnlyInternetGateway"
	          }
	        }
	      }
	    },
	    "CreateFleet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LaunchTemplateConfigs",
	          "TargetCapacitySpecification"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {},
	          "SpotOptions": {
	            "type": "structure",
	            "members": {
	              "AllocationStrategy": {},
	              "MaintenanceStrategies": {
	                "type": "structure",
	                "members": {
	                  "CapacityRebalance": {
	                    "type": "structure",
	                    "members": {
	                      "ReplacementStrategy": {},
	                      "TerminationDelay": {
	                        "type": "integer"
	                      }
	                    }
	                  }
	                }
	              },
	              "InstanceInterruptionBehavior": {},
	              "InstancePoolsToUseCount": {
	                "type": "integer"
	              },
	              "SingleInstanceType": {
	                "type": "boolean"
	              },
	              "SingleAvailabilityZone": {
	                "type": "boolean"
	              },
	              "MinTargetCapacity": {
	                "type": "integer"
	              },
	              "MaxTotalPrice": {}
	            }
	          },
	          "OnDemandOptions": {
	            "type": "structure",
	            "members": {
	              "AllocationStrategy": {},
	              "CapacityReservationOptions": {
	                "type": "structure",
	                "members": {
	                  "UsageStrategy": {}
	                }
	              },
	              "SingleInstanceType": {
	                "type": "boolean"
	              },
	              "SingleAvailabilityZone": {
	                "type": "boolean"
	              },
	              "MinTargetCapacity": {
	                "type": "integer"
	              },
	              "MaxTotalPrice": {}
	            }
	          },
	          "ExcessCapacityTerminationPolicy": {},
	          "LaunchTemplateConfigs": {
	            "shape": "Sad"
	          },
	          "TargetCapacitySpecification": {
	            "shape": "Sbc"
	          },
	          "TerminateInstancesWithExpiration": {
	            "type": "boolean"
	          },
	          "Type": {},
	          "ValidFrom": {
	            "type": "timestamp"
	          },
	          "ValidUntil": {
	            "type": "timestamp"
	          },
	          "ReplaceUnhealthyInstances": {
	            "type": "boolean"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "Context": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetId": {
	            "locationName": "fleetId"
	          },
	          "Errors": {
	            "locationName": "errorSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "LaunchTemplateAndOverrides": {
	                  "shape": "Sbk",
	                  "locationName": "launchTemplateAndOverrides"
	                },
	                "Lifecycle": {
	                  "locationName": "lifecycle"
	                },
	                "ErrorCode": {
	                  "locationName": "errorCode"
	                },
	                "ErrorMessage": {
	                  "locationName": "errorMessage"
	                }
	              }
	            }
	          },
	          "Instances": {
	            "locationName": "fleetInstanceSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "LaunchTemplateAndOverrides": {
	                  "shape": "Sbk",
	                  "locationName": "launchTemplateAndOverrides"
	                },
	                "Lifecycle": {
	                  "locationName": "lifecycle"
	                },
	                "InstanceIds": {
	                  "shape": "Sc0",
	                  "locationName": "instanceIds"
	                },
	                "InstanceType": {
	                  "locationName": "instanceType"
	                },
	                "Platform": {
	                  "locationName": "platform"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "CreateFlowLogs": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceIds",
	          "ResourceType",
	          "TrafficType"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {},
	          "DeliverLogsPermissionArn": {},
	          "LogGroupName": {},
	          "ResourceIds": {
	            "locationName": "ResourceId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "ResourceType": {},
	          "TrafficType": {},
	          "LogDestinationType": {},
	          "LogDestination": {},
	          "LogFormat": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "MaxAggregationInterval": {
	            "type": "integer"
	          },
	          "DestinationOptions": {
	            "type": "structure",
	            "members": {
	              "FileFormat": {},
	              "HiveCompatiblePartitions": {
	                "type": "boolean"
	              },
	              "PerHourPartition": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientToken": {
	            "locationName": "clientToken"
	          },
	          "FlowLogIds": {
	            "shape": "Se",
	            "locationName": "flowLogIdSet"
	          },
	          "Unsuccessful": {
	            "shape": "S16",
	            "locationName": "unsuccessful"
	          }
	        }
	      }
	    },
	    "CreateFpgaImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputStorageLocation"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InputStorageLocation": {
	            "shape": "Scc"
	          },
	          "LogsStorageLocation": {
	            "shape": "Scc"
	          },
	          "Description": {},
	          "Name": {},
	          "ClientToken": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FpgaImageId": {
	            "locationName": "fpgaImageId"
	          },
	          "FpgaImageGlobalId": {
	            "locationName": "fpgaImageGlobalId"
	          }
	        }
	      }
	    },
	    "CreateImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Name"
	        ],
	        "members": {
	          "BlockDeviceMappings": {
	            "shape": "Scf",
	            "locationName": "blockDeviceMapping"
	          },
	          "Description": {
	            "locationName": "description"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "Name": {
	            "locationName": "name"
	          },
	          "NoReboot": {
	            "locationName": "noReboot",
	            "type": "boolean"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ImageId": {
	            "locationName": "imageId"
	          }
	        }
	      }
	    },
	    "CreateInstanceEventWindow": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Name": {},
	          "TimeRanges": {
	            "shape": "Scm",
	            "locationName": "TimeRange"
	          },
	          "CronExpression": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceEventWindow": {
	            "shape": "S3i",
	            "locationName": "instanceEventWindow"
	          }
	        }
	      }
	    },
	    "CreateInstanceExportTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExportToS3Task",
	          "InstanceId",
	          "TargetEnvironment"
	        ],
	        "members": {
	          "Description": {
	            "locationName": "description"
	          },
	          "ExportToS3Task": {
	            "locationName": "exportToS3",
	            "type": "structure",
	            "members": {
	              "ContainerFormat": {
	                "locationName": "containerFormat"
	              },
	              "DiskImageFormat": {
	                "locationName": "diskImageFormat"
	              },
	              "S3Bucket": {
	                "locationName": "s3Bucket"
	              },
	              "S3Prefix": {
	                "locationName": "s3Prefix"
	              }
	            }
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "TargetEnvironment": {
	            "locationName": "targetEnvironment"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExportTask": {
	            "shape": "Scv",
	            "locationName": "exportTask"
	          }
	        }
	      }
	    },
	    "CreateInternetGateway": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InternetGateway": {
	            "shape": "Sd1",
	            "locationName": "internetGateway"
	          }
	        }
	      }
	    },
	    "CreateIpam": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Description": {},
	          "OperatingRegions": {
	            "shape": "Sd3",
	            "locationName": "OperatingRegion"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Ipam": {
	            "shape": "Sd6",
	            "locationName": "ipam"
	          }
	        }
	      }
	    },
	    "CreateIpamPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamScopeId",
	          "AddressFamily"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamScopeId": {},
	          "Locale": {},
	          "SourceIpamPoolId": {},
	          "Description": {},
	          "AddressFamily": {},
	          "AutoImport": {
	            "type": "boolean"
	          },
	          "PubliclyAdvertisable": {
	            "type": "boolean"
	          },
	          "AllocationMinNetmaskLength": {
	            "type": "integer"
	          },
	          "AllocationMaxNetmaskLength": {
	            "type": "integer"
	          },
	          "AllocationDefaultNetmaskLength": {
	            "type": "integer"
	          },
	          "AllocationResourceTags": {
	            "shape": "Sdf",
	            "locationName": "AllocationResourceTag"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "AwsService": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamPool": {
	            "shape": "Sdj",
	            "locationName": "ipamPool"
	          }
	        }
	      }
	    },
	    "CreateIpamScope": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamId": {},
	          "Description": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamScope": {
	            "shape": "Sdq",
	            "locationName": "ipamScope"
	          }
	        }
	      }
	    },
	    "CreateKeyPair": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyName"
	        ],
	        "members": {
	          "KeyName": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "KeyType": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "KeyFormat": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyFingerprint": {
	            "locationName": "keyFingerprint"
	          },
	          "KeyMaterial": {
	            "locationName": "keyMaterial",
	            "type": "string",
	            "sensitive": true
	          },
	          "KeyName": {
	            "locationName": "keyName"
	          },
	          "KeyPairId": {
	            "locationName": "keyPairId"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tagSet"
	          }
	        }
	      }
	    },
	    "CreateLaunchTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LaunchTemplateName",
	          "LaunchTemplateData"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {},
	          "LaunchTemplateName": {},
	          "VersionDescription": {},
	          "LaunchTemplateData": {
	            "shape": "Sdz"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LaunchTemplate": {
	            "shape": "Sfh",
	            "locationName": "launchTemplate"
	          },
	          "Warning": {
	            "shape": "Sfi",
	            "locationName": "warning"
	          }
	        }
	      }
	    },
	    "CreateLaunchTemplateVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LaunchTemplateData"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {},
	          "LaunchTemplateId": {},
	          "LaunchTemplateName": {},
	          "SourceVersion": {},
	          "VersionDescription": {},
	          "LaunchTemplateData": {
	            "shape": "Sdz"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LaunchTemplateVersion": {
	            "shape": "Sfn",
	            "locationName": "launchTemplateVersion"
	          },
	          "Warning": {
	            "shape": "Sfi",
	            "locationName": "warning"
	          }
	        }
	      }
	    },
	    "CreateLocalGatewayRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DestinationCidrBlock",
	          "LocalGatewayRouteTableId",
	          "LocalGatewayVirtualInterfaceGroupId"
	        ],
	        "members": {
	          "DestinationCidrBlock": {},
	          "LocalGatewayRouteTableId": {},
	          "LocalGatewayVirtualInterfaceGroupId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Route": {
	            "shape": "Sgr",
	            "locationName": "route"
	          }
	        }
	      }
	    },
	    "CreateLocalGatewayRouteTableVpcAssociation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LocalGatewayRouteTableId",
	          "VpcId"
	        ],
	        "members": {
	          "LocalGatewayRouteTableId": {},
	          "VpcId": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayRouteTableVpcAssociation": {
	            "shape": "Sgw",
	            "locationName": "localGatewayRouteTableVpcAssociation"
	          }
	        }
	      }
	    },
	    "CreateManagedPrefixList": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PrefixListName",
	          "MaxEntries",
	          "AddressFamily"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "PrefixListName": {},
	          "Entries": {
	            "shape": "Sgz",
	            "locationName": "Entry"
	          },
	          "MaxEntries": {
	            "type": "integer"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "AddressFamily": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PrefixList": {
	            "shape": "Sh2",
	            "locationName": "prefixList"
	          }
	        }
	      }
	    },
	    "CreateNatGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubnetId"
	        ],
	        "members": {
	          "AllocationId": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "SubnetId": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "ConnectivityType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientToken": {
	            "locationName": "clientToken"
	          },
	          "NatGateway": {
	            "shape": "Sh7",
	            "locationName": "natGateway"
	          }
	        }
	      }
	    },
	    "CreateNetworkAcl": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkAcl": {
	            "shape": "She",
	            "locationName": "networkAcl"
	          }
	        }
	      }
	    },
	    "CreateNetworkAclEntry": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Egress",
	          "NetworkAclId",
	          "Protocol",
	          "RuleAction",
	          "RuleNumber"
	        ],
	        "members": {
	          "CidrBlock": {
	            "locationName": "cidrBlock"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Egress": {
	            "locationName": "egress",
	            "type": "boolean"
	          },
	          "IcmpTypeCode": {
	            "shape": "Shj",
	            "locationName": "Icmp"
	          },
	          "Ipv6CidrBlock": {
	            "locationName": "ipv6CidrBlock"
	          },
	          "NetworkAclId": {
	            "locationName": "networkAclId"
	          },
	          "PortRange": {
	            "shape": "Shk",
	            "locationName": "portRange"
	          },
	          "Protocol": {
	            "locationName": "protocol"
	          },
	          "RuleAction": {
	            "locationName": "ruleAction"
	          },
	          "RuleNumber": {
	            "locationName": "ruleNumber",
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "CreateNetworkInsightsAccessScope": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientToken"
	        ],
	        "members": {
	          "MatchPaths": {
	            "shape": "Shp",
	            "locationName": "MatchPath"
	          },
	          "ExcludePaths": {
	            "shape": "Shp",
	            "locationName": "ExcludePath"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAccessScope": {
	            "shape": "Shz",
	            "locationName": "networkInsightsAccessScope"
	          },
	          "NetworkInsightsAccessScopeContent": {
	            "shape": "Si1",
	            "locationName": "networkInsightsAccessScopeContent"
	          }
	        }
	      }
	    },
	    "CreateNetworkInsightsPath": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Source",
	          "Destination",
	          "Protocol",
	          "ClientToken"
	        ],
	        "members": {
	          "SourceIp": {},
	          "DestinationIp": {},
	          "Source": {},
	          "Destination": {},
	          "Protocol": {},
	          "DestinationPort": {
	            "type": "integer"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsPath": {
	            "shape": "Sie",
	            "locationName": "networkInsightsPath"
	          }
	        }
	      }
	    },
	    "CreateNetworkInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubnetId"
	        ],
	        "members": {
	          "Description": {
	            "locationName": "description"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Groups": {
	            "shape": "Se7",
	            "locationName": "SecurityGroupId"
	          },
	          "Ipv6AddressCount": {
	            "locationName": "ipv6AddressCount",
	            "type": "integer"
	          },
	          "Ipv6Addresses": {
	            "shape": "Sfv",
	            "locationName": "ipv6Addresses"
	          },
	          "PrivateIpAddress": {
	            "locationName": "privateIpAddress"
	          },
	          "PrivateIpAddresses": {
	            "shape": "Sea",
	            "locationName": "privateIpAddresses"
	          },
	          "SecondaryPrivateIpAddressCount": {
	            "locationName": "secondaryPrivateIpAddressCount",
	            "type": "integer"
	          },
	          "Ipv4Prefixes": {
	            "shape": "Sec",
	            "locationName": "Ipv4Prefix"
	          },
	          "Ipv4PrefixCount": {
	            "type": "integer"
	          },
	          "Ipv6Prefixes": {
	            "shape": "See",
	            "locationName": "Ipv6Prefix"
	          },
	          "Ipv6PrefixCount": {
	            "type": "integer"
	          },
	          "InterfaceType": {},
	          "SubnetId": {
	            "locationName": "subnetId"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInterface": {
	            "shape": "Sij",
	            "locationName": "networkInterface"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          }
	        }
	      }
	    },
	    "CreateNetworkInterfacePermission": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInterfaceId",
	          "Permission"
	        ],
	        "members": {
	          "NetworkInterfaceId": {},
	          "AwsAccountId": {},
	          "AwsService": {},
	          "Permission": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InterfacePermission": {
	            "shape": "Siz",
	            "locationName": "interfacePermission"
	          }
	        }
	      }
	    },
	    "CreatePlacementGroup": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "GroupName": {
	            "locationName": "groupName"
	          },
	          "Strategy": {
	            "locationName": "strategy"
	          },
	          "PartitionCount": {
	            "type": "integer"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PlacementGroup": {
	            "shape": "Sj5",
	            "locationName": "placementGroup"
	          }
	        }
	      }
	    },
	    "CreatePublicIpv4Pool": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PoolId": {
	            "locationName": "poolId"
	          }
	        }
	      }
	    },
	    "CreateReplaceRootVolumeTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "SnapshotId": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReplaceRootVolumeTask": {
	            "shape": "Sjb",
	            "locationName": "replaceRootVolumeTask"
	          }
	        }
	      }
	    },
	    "CreateReservedInstancesListing": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientToken",
	          "InstanceCount",
	          "PriceSchedules",
	          "ReservedInstancesId"
	        ],
	        "members": {
	          "ClientToken": {
	            "locationName": "clientToken"
	          },
	          "InstanceCount": {
	            "locationName": "instanceCount",
	            "type": "integer"
	          },
	          "PriceSchedules": {
	            "locationName": "priceSchedules",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "CurrencyCode": {
	                  "locationName": "currencyCode"
	                },
	                "Price": {
	                  "locationName": "price",
	                  "type": "double"
	                },
	                "Term": {
	                  "locationName": "term",
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "ReservedInstancesId": {
	            "locationName": "reservedInstancesId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReservedInstancesListings": {
	            "shape": "S6r",
	            "locationName": "reservedInstancesListingsSet"
	          }
	        }
	      }
	    },
	    "CreateRestoreImageTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "ObjectKey"
	        ],
	        "members": {
	          "Bucket": {},
	          "ObjectKey": {},
	          "Name": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ImageId": {
	            "locationName": "imageId"
	          }
	        }
	      }
	    },
	    "CreateRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RouteTableId"
	        ],
	        "members": {
	          "DestinationCidrBlock": {
	            "locationName": "destinationCidrBlock"
	          },
	          "DestinationIpv6CidrBlock": {
	            "locationName": "destinationIpv6CidrBlock"
	          },
	          "DestinationPrefixListId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VpcEndpointId": {},
	          "EgressOnlyInternetGatewayId": {
	            "locationName": "egressOnlyInternetGatewayId"
	          },
	          "GatewayId": {
	            "locationName": "gatewayId"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "NatGatewayId": {
	            "locationName": "natGatewayId"
	          },
	          "TransitGatewayId": {},
	          "LocalGatewayId": {},
	          "CarrierGatewayId": {},
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "RouteTableId": {
	            "locationName": "routeTableId"
	          },
	          "VpcPeeringConnectionId": {
	            "locationName": "vpcPeeringConnectionId"
	          },
	          "CoreNetworkArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "CreateRouteTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RouteTable": {
	            "shape": "Sjs",
	            "locationName": "routeTable"
	          }
	        }
	      }
	    },
	    "CreateSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Description",
	          "GroupName"
	        ],
	        "members": {
	          "Description": {
	            "locationName": "GroupDescription"
	          },
	          "GroupName": {},
	          "VpcId": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GroupId": {
	            "locationName": "groupId"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tagSet"
	          }
	        }
	      }
	    },
	    "CreateSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeId"
	        ],
	        "members": {
	          "Description": {},
	          "OutpostArn": {},
	          "VolumeId": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sk4"
	      }
	    },
	    "CreateSnapshots": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceSpecification"
	        ],
	        "members": {
	          "Description": {},
	          "InstanceSpecification": {
	            "type": "structure",
	            "members": {
	              "InstanceId": {},
	              "ExcludeBootVolume": {
	                "type": "boolean"
	              }
	            }
	          },
	          "OutpostArn": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "CopyTagsFromSource": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Snapshots": {
	            "locationName": "snapshotSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Description": {
	                  "locationName": "description"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "Encrypted": {
	                  "locationName": "encrypted",
	                  "type": "boolean"
	                },
	                "VolumeId": {
	                  "locationName": "volumeId"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "VolumeSize": {
	                  "locationName": "volumeSize",
	                  "type": "integer"
	                },
	                "StartTime": {
	                  "locationName": "startTime",
	                  "type": "timestamp"
	                },
	                "Progress": {
	                  "locationName": "progress"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "SnapshotId": {
	                  "locationName": "snapshotId"
	                },
	                "OutpostArn": {
	                  "locationName": "outpostArn"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "CreateSpotDatafeedSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "locationName": "bucket"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Prefix": {
	            "locationName": "prefix"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SpotDatafeedSubscription": {
	            "shape": "Skf",
	            "locationName": "spotDatafeedSubscription"
	          }
	        }
	      }
	    },
	    "CreateStoreImageTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ImageId",
	          "Bucket"
	        ],
	        "members": {
	          "ImageId": {},
	          "Bucket": {},
	          "S3ObjectTags": {
	            "locationName": "S3ObjectTag",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Key": {},
	                "Value": {}
	              }
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ObjectKey": {
	            "locationName": "objectKey"
	          }
	        }
	      }
	    },
	    "CreateSubnet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId"
	        ],
	        "members": {
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "AvailabilityZone": {},
	          "AvailabilityZoneId": {},
	          "CidrBlock": {},
	          "Ipv6CidrBlock": {},
	          "OutpostArn": {},
	          "VpcId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Ipv6Native": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Subnet": {
	            "shape": "S99",
	            "locationName": "subnet"
	          }
	        }
	      }
	    },
	    "CreateSubnetCidrReservation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubnetId",
	          "Cidr",
	          "ReservationType"
	        ],
	        "members": {
	          "SubnetId": {},
	          "Cidr": {},
	          "ReservationType": {},
	          "Description": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SubnetCidrReservation": {
	            "shape": "Skr",
	            "locationName": "subnetCidrReservation"
	          }
	        }
	      }
	    },
	    "CreateTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resources",
	          "Tags"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Resources": {
	            "shape": "Sku",
	            "locationName": "ResourceId"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "Tag"
	          }
	        }
	      }
	    },
	    "CreateTrafficMirrorFilter": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Description": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorFilter": {
	            "shape": "Sky",
	            "locationName": "trafficMirrorFilter"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          }
	        }
	      }
	    },
	    "CreateTrafficMirrorFilterRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrafficMirrorFilterId",
	          "TrafficDirection",
	          "RuleNumber",
	          "RuleAction",
	          "DestinationCidrBlock",
	          "SourceCidrBlock"
	        ],
	        "members": {
	          "TrafficMirrorFilterId": {},
	          "TrafficDirection": {},
	          "RuleNumber": {
	            "type": "integer"
	          },
	          "RuleAction": {},
	          "DestinationPortRange": {
	            "shape": "Sl8"
	          },
	          "SourcePortRange": {
	            "shape": "Sl8"
	          },
	          "Protocol": {
	            "type": "integer"
	          },
	          "DestinationCidrBlock": {},
	          "SourceCidrBlock": {},
	          "Description": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorFilterRule": {
	            "shape": "Sl0",
	            "locationName": "trafficMirrorFilterRule"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          }
	        }
	      }
	    },
	    "CreateTrafficMirrorSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInterfaceId",
	          "TrafficMirrorTargetId",
	          "TrafficMirrorFilterId",
	          "SessionNumber"
	        ],
	        "members": {
	          "NetworkInterfaceId": {},
	          "TrafficMirrorTargetId": {},
	          "TrafficMirrorFilterId": {},
	          "PacketLength": {
	            "type": "integer"
	          },
	          "SessionNumber": {
	            "type": "integer"
	          },
	          "VirtualNetworkId": {
	            "type": "integer"
	          },
	          "Description": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorSession": {
	            "shape": "Sld",
	            "locationName": "trafficMirrorSession"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          }
	        }
	      }
	    },
	    "CreateTrafficMirrorTarget": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NetworkInterfaceId": {},
	          "NetworkLoadBalancerArn": {},
	          "Description": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "GatewayLoadBalancerEndpointId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorTarget": {
	            "shape": "Slg",
	            "locationName": "trafficMirrorTarget"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          }
	        }
	      }
	    },
	    "CreateTransitGateway": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Description": {},
	          "Options": {
	            "type": "structure",
	            "members": {
	              "AmazonSideAsn": {
	                "type": "long"
	              },
	              "AutoAcceptSharedAttachments": {},
	              "DefaultRouteTableAssociation": {},
	              "DefaultRouteTablePropagation": {},
	              "VpnEcmpSupport": {},
	              "DnsSupport": {},
	              "MulticastSupport": {},
	              "TransitGatewayCidrBlocks": {
	                "shape": "Slp"
	              }
	            }
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGateway": {
	            "shape": "Slr",
	            "locationName": "transitGateway"
	          }
	        }
	      }
	    },
	    "CreateTransitGatewayConnect": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransportTransitGatewayAttachmentId",
	          "Options"
	        ],
	        "members": {
	          "TransportTransitGatewayAttachmentId": {},
	          "Options": {
	            "type": "structure",
	            "required": [
	              "Protocol"
	            ],
	            "members": {
	              "Protocol": {}
	            }
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayConnect": {
	            "shape": "Sly",
	            "locationName": "transitGatewayConnect"
	          }
	        }
	      }
	    },
	    "CreateTransitGatewayConnectPeer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayAttachmentId",
	          "PeerAddress",
	          "InsideCidrBlocks"
	        ],
	        "members": {
	          "TransitGatewayAttachmentId": {},
	          "TransitGatewayAddress": {},
	          "PeerAddress": {},
	          "BgpOptions": {
	            "type": "structure",
	            "members": {
	              "PeerAsn": {
	                "type": "long"
	              }
	            }
	          },
	          "InsideCidrBlocks": {
	            "shape": "Sm2"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayConnectPeer": {
	            "shape": "Sm4",
	            "locationName": "transitGatewayConnectPeer"
	          }
	        }
	      }
	    },
	    "CreateTransitGatewayMulticastDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayId"
	        ],
	        "members": {
	          "TransitGatewayId": {},
	          "Options": {
	            "type": "structure",
	            "members": {
	              "Igmpv2Support": {},
	              "StaticSourcesSupport": {},
	              "AutoAcceptSharedAssociations": {}
	            }
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomain": {
	            "shape": "Smh",
	            "locationName": "transitGatewayMulticastDomain"
	          }
	        }
	      }
	    },
	    "CreateTransitGatewayPeeringAttachment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayId",
	          "PeerTransitGatewayId",
	          "PeerAccountId",
	          "PeerRegion"
	        ],
	        "members": {
	          "TransitGatewayId": {},
	          "PeerTransitGatewayId": {},
	          "PeerAccountId": {},
	          "PeerRegion": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayPeeringAttachment": {
	            "shape": "Sn",
	            "locationName": "transitGatewayPeeringAttachment"
	          }
	        }
	      }
	    },
	    "CreateTransitGatewayPrefixListReference": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId",
	          "PrefixListId"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "PrefixListId": {},
	          "TransitGatewayAttachmentId": {},
	          "Blackhole": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayPrefixListReference": {
	            "shape": "Smp",
	            "locationName": "transitGatewayPrefixListReference"
	          }
	        }
	      }
	    },
	    "CreateTransitGatewayRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DestinationCidrBlock",
	          "TransitGatewayRouteTableId"
	        ],
	        "members": {
	          "DestinationCidrBlock": {},
	          "TransitGatewayRouteTableId": {},
	          "TransitGatewayAttachmentId": {},
	          "Blackhole": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Route": {
	            "shape": "Smu",
	            "locationName": "route"
	          }
	        }
	      }
	    },
	    "CreateTransitGatewayRouteTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayId"
	        ],
	        "members": {
	          "TransitGatewayId": {},
	          "TagSpecifications": {
	            "shape": "S1t"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayRouteTable": {
	            "shape": "Sn1",
	            "locationName": "transitGatewayRouteTable"
	          }
	        }
	      }
	    },
	    "CreateTransitGatewayVpcAttachment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayId",
	          "VpcId",
	          "SubnetIds"
	        ],
	        "members": {
	          "TransitGatewayId": {},
	          "VpcId": {},
	          "SubnetIds": {
	            "shape": "S43"
	          },
	          "Options": {
	            "type": "structure",
	            "members": {
	              "DnsSupport": {},
	              "Ipv6Support": {},
	              "ApplianceModeSupport": {}
	            }
	          },
	          "TagSpecifications": {
	            "shape": "S1t"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayVpcAttachment": {
	            "shape": "Sw",
	            "locationName": "transitGatewayVpcAttachment"
	          }
	        }
	      }
	    },
	    "CreateVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AvailabilityZone"
	        ],
	        "members": {
	          "AvailabilityZone": {},
	          "Encrypted": {
	            "locationName": "encrypted",
	            "type": "boolean"
	          },
	          "Iops": {
	            "type": "integer"
	          },
	          "KmsKeyId": {},
	          "OutpostArn": {},
	          "Size": {
	            "type": "integer"
	          },
	          "SnapshotId": {},
	          "VolumeType": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "MultiAttachEnabled": {
	            "type": "boolean"
	          },
	          "Throughput": {
	            "type": "integer"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "shape": "Sn7"
	      }
	    },
	    "CreateVpc": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CidrBlock": {},
	          "AmazonProvidedIpv6CidrBlock": {
	            "locationName": "amazonProvidedIpv6CidrBlock",
	            "type": "boolean"
	          },
	          "Ipv6Pool": {},
	          "Ipv6CidrBlock": {},
	          "Ipv4IpamPoolId": {},
	          "Ipv4NetmaskLength": {
	            "type": "integer"
	          },
	          "Ipv6IpamPoolId": {},
	          "Ipv6NetmaskLength": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InstanceTenancy": {
	            "locationName": "instanceTenancy"
	          },
	          "Ipv6CidrBlockNetworkBorderGroup": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Vpc": {
	            "shape": "S9h",
	            "locationName": "vpc"
	          }
	        }
	      }
	    },
	    "CreateVpcEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId",
	          "ServiceName"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "VpcEndpointType": {},
	          "VpcId": {},
	          "ServiceName": {},
	          "PolicyDocument": {},
	          "RouteTableIds": {
	            "shape": "Sne",
	            "locationName": "RouteTableId"
	          },
	          "SubnetIds": {
	            "shape": "Snf",
	            "locationName": "SubnetId"
	          },
	          "SecurityGroupIds": {
	            "shape": "Sng",
	            "locationName": "SecurityGroupId"
	          },
	          "IpAddressType": {},
	          "DnsOptions": {
	            "shape": "Sni"
	          },
	          "ClientToken": {},
	          "PrivateDnsEnabled": {
	            "type": "boolean"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpcEndpoint": {
	            "shape": "Snl",
	            "locationName": "vpcEndpoint"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          }
	        }
	      }
	    },
	    "CreateVpcEndpointConnectionNotification": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConnectionNotificationArn",
	          "ConnectionEvents"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ServiceId": {},
	          "VpcEndpointId": {},
	          "ConnectionNotificationArn": {},
	          "ConnectionEvents": {
	            "shape": "Se"
	          },
	          "ClientToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConnectionNotification": {
	            "shape": "Snv",
	            "locationName": "connectionNotification"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          }
	        }
	      }
	    },
	    "CreateVpcEndpointServiceConfiguration": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "AcceptanceRequired": {
	            "type": "boolean"
	          },
	          "PrivateDnsName": {},
	          "NetworkLoadBalancerArns": {
	            "shape": "Se",
	            "locationName": "NetworkLoadBalancerArn"
	          },
	          "GatewayLoadBalancerArns": {
	            "shape": "Se",
	            "locationName": "GatewayLoadBalancerArn"
	          },
	          "SupportedIpAddressTypes": {
	            "shape": "Se",
	            "locationName": "SupportedIpAddressType"
	          },
	          "ClientToken": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceConfiguration": {
	            "shape": "So0",
	            "locationName": "serviceConfiguration"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          }
	        }
	      }
	    },
	    "CreateVpcPeeringConnection": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "PeerOwnerId": {
	            "locationName": "peerOwnerId"
	          },
	          "PeerVpcId": {
	            "locationName": "peerVpcId"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          },
	          "PeerRegion": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpcPeeringConnection": {
	            "shape": "S1c",
	            "locationName": "vpcPeeringConnection"
	          }
	        }
	      }
	    },
	    "CreateVpnConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CustomerGatewayId",
	          "Type"
	        ],
	        "members": {
	          "CustomerGatewayId": {},
	          "Type": {},
	          "VpnGatewayId": {},
	          "TransitGatewayId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Options": {
	            "locationName": "options",
	            "type": "structure",
	            "members": {
	              "EnableAcceleration": {
	                "type": "boolean"
	              },
	              "StaticRoutesOnly": {
	                "locationName": "staticRoutesOnly",
	                "type": "boolean"
	              },
	              "TunnelInsideIpVersion": {},
	              "TunnelOptions": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "TunnelInsideCidr": {},
	                    "TunnelInsideIpv6Cidr": {},
	                    "PreSharedKey": {},
	                    "Phase1LifetimeSeconds": {
	                      "type": "integer"
	                    },
	                    "Phase2LifetimeSeconds": {
	                      "type": "integer"
	                    },
	                    "RekeyMarginTimeSeconds": {
	                      "type": "integer"
	                    },
	                    "RekeyFuzzPercentage": {
	                      "type": "integer"
	                    },
	                    "ReplayWindowSize": {
	                      "type": "integer"
	                    },
	                    "DPDTimeoutSeconds": {
	                      "type": "integer"
	                    },
	                    "DPDTimeoutAction": {},
	                    "Phase1EncryptionAlgorithms": {
	                      "shape": "Soi",
	                      "locationName": "Phase1EncryptionAlgorithm"
	                    },
	                    "Phase2EncryptionAlgorithms": {
	                      "shape": "Sok",
	                      "locationName": "Phase2EncryptionAlgorithm"
	                    },
	                    "Phase1IntegrityAlgorithms": {
	                      "shape": "Som",
	                      "locationName": "Phase1IntegrityAlgorithm"
	                    },
	                    "Phase2IntegrityAlgorithms": {
	                      "shape": "Soo",
	                      "locationName": "Phase2IntegrityAlgorithm"
	                    },
	                    "Phase1DHGroupNumbers": {
	                      "shape": "Soq",
	                      "locationName": "Phase1DHGroupNumber"
	                    },
	                    "Phase2DHGroupNumbers": {
	                      "shape": "Sos",
	                      "locationName": "Phase2DHGroupNumber"
	                    },
	                    "IKEVersions": {
	                      "shape": "Sou",
	                      "locationName": "IKEVersion"
	                    },
	                    "StartupAction": {}
	                  }
	                }
	              },
	              "LocalIpv4NetworkCidr": {},
	              "RemoteIpv4NetworkCidr": {},
	              "LocalIpv6NetworkCidr": {},
	              "RemoteIpv6NetworkCidr": {},
	              "OutsideIpAddressType": {},
	              "TransportTransitGatewayAttachmentId": {}
	            }
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpnConnection": {
	            "shape": "Sox",
	            "locationName": "vpnConnection"
	          }
	        }
	      }
	    },
	    "CreateVpnConnectionRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DestinationCidrBlock",
	          "VpnConnectionId"
	        ],
	        "members": {
	          "DestinationCidrBlock": {},
	          "VpnConnectionId": {}
	        }
	      }
	    },
	    "CreateVpnGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Type"
	        ],
	        "members": {
	          "AvailabilityZone": {},
	          "Type": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "AmazonSideAsn": {
	            "type": "long"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpnGateway": {
	            "shape": "Spr",
	            "locationName": "vpnGateway"
	          }
	        }
	      }
	    },
	    "DeleteCarrierGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CarrierGatewayId"
	        ],
	        "members": {
	          "CarrierGatewayId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CarrierGateway": {
	            "shape": "S8h",
	            "locationName": "carrierGateway"
	          }
	        }
	      }
	    },
	    "DeleteClientVpnEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {
	            "shape": "S8x",
	            "locationName": "status"
	          }
	        }
	      }
	    },
	    "DeleteClientVpnRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId",
	          "DestinationCidrBlock"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "TargetVpcSubnetId": {},
	          "DestinationCidrBlock": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {
	            "shape": "S91",
	            "locationName": "status"
	          }
	        }
	      }
	    },
	    "DeleteCustomerGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CustomerGatewayId"
	        ],
	        "members": {
	          "CustomerGatewayId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteDhcpOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DhcpOptionsId"
	        ],
	        "members": {
	          "DhcpOptionsId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteEgressOnlyInternetGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EgressOnlyInternetGatewayId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "EgressOnlyInternetGatewayId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReturnCode": {
	            "locationName": "returnCode",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteFleets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetIds",
	          "TerminateInstances"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "FleetIds": {
	            "shape": "Sq5",
	            "locationName": "FleetId"
	          },
	          "TerminateInstances": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SuccessfulFleetDeletions": {
	            "locationName": "successfulFleetDeletionSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "CurrentFleetState": {
	                  "locationName": "currentFleetState"
	                },
	                "PreviousFleetState": {
	                  "locationName": "previousFleetState"
	                },
	                "FleetId": {
	                  "locationName": "fleetId"
	                }
	              }
	            }
	          },
	          "UnsuccessfulFleetDeletions": {
	            "locationName": "unsuccessfulFleetDeletionSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Error": {
	                  "locationName": "error",
	                  "type": "structure",
	                  "members": {
	                    "Code": {
	                      "locationName": "code"
	                    },
	                    "Message": {
	                      "locationName": "message"
	                    }
	                  }
	                },
	                "FleetId": {
	                  "locationName": "fleetId"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DeleteFlowLogs": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FlowLogIds"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "FlowLogIds": {
	            "shape": "Sqf",
	            "locationName": "FlowLogId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Unsuccessful": {
	            "shape": "S16",
	            "locationName": "unsuccessful"
	          }
	        }
	      }
	    },
	    "DeleteFpgaImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FpgaImageId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "FpgaImageId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteInstanceEventWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceEventWindowId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ForceDelete": {
	            "type": "boolean"
	          },
	          "InstanceEventWindowId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceEventWindowState": {
	            "locationName": "instanceEventWindowState",
	            "type": "structure",
	            "members": {
	              "InstanceEventWindowId": {
	                "locationName": "instanceEventWindowId"
	              },
	              "State": {
	                "locationName": "state"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DeleteInternetGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InternetGatewayId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InternetGatewayId": {
	            "locationName": "internetGatewayId"
	          }
	        }
	      }
	    },
	    "DeleteIpam": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamId": {},
	          "Cascade": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Ipam": {
	            "shape": "Sd6",
	            "locationName": "ipam"
	          }
	        }
	      }
	    },
	    "DeleteIpamPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamPoolId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamPoolId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamPool": {
	            "shape": "Sdj",
	            "locationName": "ipamPool"
	          }
	        }
	      }
	    },
	    "DeleteIpamScope": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamScopeId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamScopeId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamScope": {
	            "shape": "Sdq",
	            "locationName": "ipamScope"
	          }
	        }
	      }
	    },
	    "DeleteKeyPair": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "KeyName": {},
	          "KeyPairId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteLaunchTemplate": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "LaunchTemplateId": {},
	          "LaunchTemplateName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LaunchTemplate": {
	            "shape": "Sfh",
	            "locationName": "launchTemplate"
	          }
	        }
	      }
	    },
	    "DeleteLaunchTemplateVersions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Versions"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "LaunchTemplateId": {},
	          "LaunchTemplateName": {},
	          "Versions": {
	            "shape": "Sr0",
	            "locationName": "LaunchTemplateVersion"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SuccessfullyDeletedLaunchTemplateVersions": {
	            "locationName": "successfullyDeletedLaunchTemplateVersionSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "LaunchTemplateId": {
	                  "locationName": "launchTemplateId"
	                },
	                "LaunchTemplateName": {
	                  "locationName": "launchTemplateName"
	                },
	                "VersionNumber": {
	                  "locationName": "versionNumber",
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "UnsuccessfullyDeletedLaunchTemplateVersions": {
	            "locationName": "unsuccessfullyDeletedLaunchTemplateVersionSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "LaunchTemplateId": {
	                  "locationName": "launchTemplateId"
	                },
	                "LaunchTemplateName": {
	                  "locationName": "launchTemplateName"
	                },
	                "VersionNumber": {
	                  "locationName": "versionNumber",
	                  "type": "long"
	                },
	                "ResponseError": {
	                  "locationName": "responseError",
	                  "type": "structure",
	                  "members": {
	                    "Code": {
	                      "locationName": "code"
	                    },
	                    "Message": {
	                      "locationName": "message"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DeleteLocalGatewayRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DestinationCidrBlock",
	          "LocalGatewayRouteTableId"
	        ],
	        "members": {
	          "DestinationCidrBlock": {},
	          "LocalGatewayRouteTableId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Route": {
	            "shape": "Sgr",
	            "locationName": "route"
	          }
	        }
	      }
	    },
	    "DeleteLocalGatewayRouteTableVpcAssociation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LocalGatewayRouteTableVpcAssociationId"
	        ],
	        "members": {
	          "LocalGatewayRouteTableVpcAssociationId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayRouteTableVpcAssociation": {
	            "shape": "Sgw",
	            "locationName": "localGatewayRouteTableVpcAssociation"
	          }
	        }
	      }
	    },
	    "DeleteManagedPrefixList": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PrefixListId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "PrefixListId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PrefixList": {
	            "shape": "Sh2",
	            "locationName": "prefixList"
	          }
	        }
	      }
	    },
	    "DeleteNatGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NatGatewayId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NatGatewayId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NatGatewayId": {
	            "locationName": "natGatewayId"
	          }
	        }
	      }
	    },
	    "DeleteNetworkAcl": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkAclId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NetworkAclId": {
	            "locationName": "networkAclId"
	          }
	        }
	      }
	    },
	    "DeleteNetworkAclEntry": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Egress",
	          "NetworkAclId",
	          "RuleNumber"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Egress": {
	            "locationName": "egress",
	            "type": "boolean"
	          },
	          "NetworkAclId": {
	            "locationName": "networkAclId"
	          },
	          "RuleNumber": {
	            "locationName": "ruleNumber",
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "DeleteNetworkInsightsAccessScope": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInsightsAccessScopeId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NetworkInsightsAccessScopeId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAccessScopeId": {
	            "locationName": "networkInsightsAccessScopeId"
	          }
	        }
	      }
	    },
	    "DeleteNetworkInsightsAccessScopeAnalysis": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInsightsAccessScopeAnalysisId"
	        ],
	        "members": {
	          "NetworkInsightsAccessScopeAnalysisId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAccessScopeAnalysisId": {
	            "locationName": "networkInsightsAccessScopeAnalysisId"
	          }
	        }
	      }
	    },
	    "DeleteNetworkInsightsAnalysis": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInsightsAnalysisId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NetworkInsightsAnalysisId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAnalysisId": {
	            "locationName": "networkInsightsAnalysisId"
	          }
	        }
	      }
	    },
	    "DeleteNetworkInsightsPath": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInsightsPathId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NetworkInsightsPathId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsPathId": {
	            "locationName": "networkInsightsPathId"
	          }
	        }
	      }
	    },
	    "DeleteNetworkInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInterfaceId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          }
	        }
	      }
	    },
	    "DeleteNetworkInterfacePermission": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInterfacePermissionId"
	        ],
	        "members": {
	          "NetworkInterfacePermissionId": {},
	          "Force": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeletePlacementGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "GroupName": {
	            "locationName": "groupName"
	          }
	        }
	      }
	    },
	    "DeletePublicIpv4Pool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PoolId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "PoolId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReturnValue": {
	            "locationName": "returnValue",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteQueuedReservedInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedInstancesIds"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ReservedInstancesIds": {
	            "locationName": "ReservedInstancesId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SuccessfulQueuedPurchaseDeletions": {
	            "locationName": "successfulQueuedPurchaseDeletionSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ReservedInstancesId": {
	                  "locationName": "reservedInstancesId"
	                }
	              }
	            }
	          },
	          "FailedQueuedPurchaseDeletions": {
	            "locationName": "failedQueuedPurchaseDeletionSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Error": {
	                  "locationName": "error",
	                  "type": "structure",
	                  "members": {
	                    "Code": {
	                      "locationName": "code"
	                    },
	                    "Message": {
	                      "locationName": "message"
	                    }
	                  }
	                },
	                "ReservedInstancesId": {
	                  "locationName": "reservedInstancesId"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DeleteRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RouteTableId"
	        ],
	        "members": {
	          "DestinationCidrBlock": {
	            "locationName": "destinationCidrBlock"
	          },
	          "DestinationIpv6CidrBlock": {
	            "locationName": "destinationIpv6CidrBlock"
	          },
	          "DestinationPrefixListId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "RouteTableId": {
	            "locationName": "routeTableId"
	          }
	        }
	      }
	    },
	    "DeleteRouteTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RouteTableId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "RouteTableId": {
	            "locationName": "routeTableId"
	          }
	        }
	      }
	    },
	    "DeleteSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GroupId": {},
	          "GroupName": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotId"
	        ],
	        "members": {
	          "SnapshotId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteSpotDatafeedSubscription": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteSubnet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubnetId"
	        ],
	        "members": {
	          "SubnetId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteSubnetCidrReservation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubnetCidrReservationId"
	        ],
	        "members": {
	          "SubnetCidrReservationId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeletedSubnetCidrReservation": {
	            "shape": "Skr",
	            "locationName": "deletedSubnetCidrReservation"
	          }
	        }
	      }
	    },
	    "DeleteTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resources"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Resources": {
	            "shape": "Sku",
	            "locationName": "resourceId"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tag"
	          }
	        }
	      }
	    },
	    "DeleteTrafficMirrorFilter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrafficMirrorFilterId"
	        ],
	        "members": {
	          "TrafficMirrorFilterId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorFilterId": {
	            "locationName": "trafficMirrorFilterId"
	          }
	        }
	      }
	    },
	    "DeleteTrafficMirrorFilterRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrafficMirrorFilterRuleId"
	        ],
	        "members": {
	          "TrafficMirrorFilterRuleId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorFilterRuleId": {
	            "locationName": "trafficMirrorFilterRuleId"
	          }
	        }
	      }
	    },
	    "DeleteTrafficMirrorSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrafficMirrorSessionId"
	        ],
	        "members": {
	          "TrafficMirrorSessionId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorSessionId": {
	            "locationName": "trafficMirrorSessionId"
	          }
	        }
	      }
	    },
	    "DeleteTrafficMirrorTarget": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrafficMirrorTargetId"
	        ],
	        "members": {
	          "TrafficMirrorTargetId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorTargetId": {
	            "locationName": "trafficMirrorTargetId"
	          }
	        }
	      }
	    },
	    "DeleteTransitGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayId"
	        ],
	        "members": {
	          "TransitGatewayId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGateway": {
	            "shape": "Slr",
	            "locationName": "transitGateway"
	          }
	        }
	      }
	    },
	    "DeleteTransitGatewayConnect": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayAttachmentId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayConnect": {
	            "shape": "Sly",
	            "locationName": "transitGatewayConnect"
	          }
	        }
	      }
	    },
	    "DeleteTransitGatewayConnectPeer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayConnectPeerId"
	        ],
	        "members": {
	          "TransitGatewayConnectPeerId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayConnectPeer": {
	            "shape": "Sm4",
	            "locationName": "transitGatewayConnectPeer"
	          }
	        }
	      }
	    },
	    "DeleteTransitGatewayMulticastDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayMulticastDomainId"
	        ],
	        "members": {
	          "TransitGatewayMulticastDomainId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomain": {
	            "shape": "Smh",
	            "locationName": "transitGatewayMulticastDomain"
	          }
	        }
	      }
	    },
	    "DeleteTransitGatewayPeeringAttachment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayAttachmentId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayPeeringAttachment": {
	            "shape": "Sn",
	            "locationName": "transitGatewayPeeringAttachment"
	          }
	        }
	      }
	    },
	    "DeleteTransitGatewayPrefixListReference": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId",
	          "PrefixListId"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "PrefixListId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayPrefixListReference": {
	            "shape": "Smp",
	            "locationName": "transitGatewayPrefixListReference"
	          }
	        }
	      }
	    },
	    "DeleteTransitGatewayRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId",
	          "DestinationCidrBlock"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "DestinationCidrBlock": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Route": {
	            "shape": "Smu",
	            "locationName": "route"
	          }
	        }
	      }
	    },
	    "DeleteTransitGatewayRouteTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayRouteTable": {
	            "shape": "Sn1",
	            "locationName": "transitGatewayRouteTable"
	          }
	        }
	      }
	    },
	    "DeleteTransitGatewayVpcAttachment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayAttachmentId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayVpcAttachment": {
	            "shape": "Sw",
	            "locationName": "transitGatewayVpcAttachment"
	          }
	        }
	      }
	    },
	    "DeleteVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeId"
	        ],
	        "members": {
	          "VolumeId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteVpc": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId"
	        ],
	        "members": {
	          "VpcId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteVpcEndpointConnectionNotifications": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConnectionNotificationIds"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ConnectionNotificationIds": {
	            "locationName": "ConnectionNotificationId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Unsuccessful": {
	            "shape": "S16",
	            "locationName": "unsuccessful"
	          }
	        }
	      }
	    },
	    "DeleteVpcEndpointServiceConfigurations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceIds"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ServiceIds": {
	            "shape": "Stg",
	            "locationName": "ServiceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Unsuccessful": {
	            "shape": "S16",
	            "locationName": "unsuccessful"
	          }
	        }
	      }
	    },
	    "DeleteVpcEndpoints": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcEndpointIds"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "VpcEndpointIds": {
	            "shape": "S13",
	            "locationName": "VpcEndpointId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Unsuccessful": {
	            "shape": "S16",
	            "locationName": "unsuccessful"
	          }
	        }
	      }
	    },
	    "DeleteVpcPeeringConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcPeeringConnectionId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VpcPeeringConnectionId": {
	            "locationName": "vpcPeeringConnectionId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteVpnConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpnConnectionId"
	        ],
	        "members": {
	          "VpnConnectionId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteVpnConnectionRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DestinationCidrBlock",
	          "VpnConnectionId"
	        ],
	        "members": {
	          "DestinationCidrBlock": {},
	          "VpnConnectionId": {}
	        }
	      }
	    },
	    "DeleteVpnGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpnGatewayId"
	        ],
	        "members": {
	          "VpnGatewayId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeprovisionByoipCidr": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Cidr"
	        ],
	        "members": {
	          "Cidr": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ByoipCidr": {
	            "shape": "S1n",
	            "locationName": "byoipCidr"
	          }
	        }
	      }
	    },
	    "DeprovisionIpamPoolCidr": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamPoolId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamPoolId": {},
	          "Cidr": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamPoolCidr": {
	            "shape": "Stt",
	            "locationName": "ipamPoolCidr"
	          }
	        }
	      }
	    },
	    "DeprovisionPublicIpv4PoolCidr": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PoolId",
	          "Cidr"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "PoolId": {},
	          "Cidr": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PoolId": {
	            "locationName": "poolId"
	          },
	          "DeprovisionedAddresses": {
	            "locationName": "deprovisionedAddressSet",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DeregisterImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ImageId"
	        ],
	        "members": {
	          "ImageId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeregisterInstanceEventNotificationAttributes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceTagAttribute": {
	            "type": "structure",
	            "members": {
	              "IncludeAllTagsOfInstance": {
	                "type": "boolean"
	              },
	              "InstanceTagKeys": {
	                "shape": "Su3",
	                "locationName": "InstanceTagKey"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceTagAttribute": {
	            "shape": "Su5",
	            "locationName": "instanceTagAttribute"
	          }
	        }
	      }
	    },
	    "DeregisterTransitGatewayMulticastGroupMembers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomainId": {},
	          "GroupIpAddress": {},
	          "NetworkInterfaceIds": {
	            "shape": "Su7"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeregisteredMulticastGroupMembers": {
	            "locationName": "deregisteredMulticastGroupMembers",
	            "type": "structure",
	            "members": {
	              "TransitGatewayMulticastDomainId": {
	                "locationName": "transitGatewayMulticastDomainId"
	              },
	              "DeregisteredNetworkInterfaceIds": {
	                "shape": "Se",
	                "locationName": "deregisteredNetworkInterfaceIds"
	              },
	              "GroupIpAddress": {
	                "locationName": "groupIpAddress"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DeregisterTransitGatewayMulticastGroupSources": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomainId": {},
	          "GroupIpAddress": {},
	          "NetworkInterfaceIds": {
	            "shape": "Su7"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeregisteredMulticastGroupSources": {
	            "locationName": "deregisteredMulticastGroupSources",
	            "type": "structure",
	            "members": {
	              "TransitGatewayMulticastDomainId": {
	                "locationName": "transitGatewayMulticastDomainId"
	              },
	              "DeregisteredNetworkInterfaceIds": {
	                "shape": "Se",
	                "locationName": "deregisteredNetworkInterfaceIds"
	              },
	              "GroupIpAddress": {
	                "locationName": "groupIpAddress"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeAccountAttributes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AttributeNames": {
	            "locationName": "attributeName",
	            "type": "list",
	            "member": {
	              "locationName": "attributeName"
	            }
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AccountAttributes": {
	            "locationName": "accountAttributeSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AttributeName": {
	                  "locationName": "attributeName"
	                },
	                "AttributeValues": {
	                  "locationName": "attributeValueSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "AttributeValue": {
	                        "locationName": "attributeValue"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeAddresses": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "PublicIps": {
	            "locationName": "PublicIp",
	            "type": "list",
	            "member": {
	              "locationName": "PublicIp"
	            }
	          },
	          "AllocationIds": {
	            "locationName": "AllocationId",
	            "type": "list",
	            "member": {
	              "locationName": "AllocationId"
	            }
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Addresses": {
	            "locationName": "addressesSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "InstanceId": {
	                  "locationName": "instanceId"
	                },
	                "PublicIp": {
	                  "locationName": "publicIp"
	                },
	                "AllocationId": {
	                  "locationName": "allocationId"
	                },
	                "AssociationId": {
	                  "locationName": "associationId"
	                },
	                "Domain": {
	                  "locationName": "domain"
	                },
	                "NetworkInterfaceId": {
	                  "locationName": "networkInterfaceId"
	                },
	                "NetworkInterfaceOwnerId": {
	                  "locationName": "networkInterfaceOwnerId"
	                },
	                "PrivateIpAddress": {
	                  "locationName": "privateIpAddress"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "PublicIpv4Pool": {
	                  "locationName": "publicIpv4Pool"
	                },
	                "NetworkBorderGroup": {
	                  "locationName": "networkBorderGroup"
	                },
	                "CustomerOwnedIp": {
	                  "locationName": "customerOwnedIp"
	                },
	                "CustomerOwnedIpv4Pool": {
	                  "locationName": "customerOwnedIpv4Pool"
	                },
	                "CarrierIp": {
	                  "locationName": "carrierIp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeAddressesAttribute": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AllocationIds": {
	            "locationName": "AllocationId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Attribute": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Addresses": {
	            "locationName": "addressSet",
	            "type": "list",
	            "member": {
	              "shape": "Sv0",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeAggregateIdFormat": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UseLongIdsAggregated": {
	            "locationName": "useLongIdsAggregated",
	            "type": "boolean"
	          },
	          "Statuses": {
	            "shape": "Sv4",
	            "locationName": "statusSet"
	          }
	        }
	      }
	    },
	    "DescribeAvailabilityZones": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "ZoneNames": {
	            "locationName": "ZoneName",
	            "type": "list",
	            "member": {
	              "locationName": "ZoneName"
	            }
	          },
	          "ZoneIds": {
	            "locationName": "ZoneId",
	            "type": "list",
	            "member": {
	              "locationName": "ZoneId"
	            }
	          },
	          "AllAvailabilityZones": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AvailabilityZones": {
	            "locationName": "availabilityZoneInfo",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "State": {
	                  "locationName": "zoneState"
	                },
	                "OptInStatus": {
	                  "locationName": "optInStatus"
	                },
	                "Messages": {
	                  "locationName": "messageSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "Message": {
	                        "locationName": "message"
	                      }
	                    }
	                  }
	                },
	                "RegionName": {
	                  "locationName": "regionName"
	                },
	                "ZoneName": {
	                  "locationName": "zoneName"
	                },
	                "ZoneId": {
	                  "locationName": "zoneId"
	                },
	                "GroupName": {
	                  "locationName": "groupName"
	                },
	                "NetworkBorderGroup": {
	                  "locationName": "networkBorderGroup"
	                },
	                "ZoneType": {
	                  "locationName": "zoneType"
	                },
	                "ParentZoneName": {
	                  "locationName": "parentZoneName"
	                },
	                "ParentZoneId": {
	                  "locationName": "parentZoneId"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeBundleTasks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "BundleIds": {
	            "locationName": "BundleId",
	            "type": "list",
	            "member": {
	              "locationName": "BundleId"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BundleTasks": {
	            "locationName": "bundleInstanceTasksSet",
	            "type": "list",
	            "member": {
	              "shape": "S5w",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribeByoipCidrs": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MaxResults"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ByoipCidrs": {
	            "locationName": "byoipCidrSet",
	            "type": "list",
	            "member": {
	              "shape": "S1n",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeCapacityReservationFleets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CapacityReservationFleetIds": {
	            "shape": "S66",
	            "locationName": "CapacityReservationFleetId"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CapacityReservationFleets": {
	            "locationName": "capacityReservationFleetSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "CapacityReservationFleetId": {
	                  "locationName": "capacityReservationFleetId"
	                },
	                "CapacityReservationFleetArn": {
	                  "locationName": "capacityReservationFleetArn"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "TotalTargetCapacity": {
	                  "locationName": "totalTargetCapacity",
	                  "type": "integer"
	                },
	                "TotalFulfilledCapacity": {
	                  "locationName": "totalFulfilledCapacity",
	                  "type": "double"
	                },
	                "Tenancy": {
	                  "locationName": "tenancy"
	                },
	                "EndDate": {
	                  "locationName": "endDate",
	                  "type": "timestamp"
	                },
	                "CreateTime": {
	                  "locationName": "createTime",
	                  "type": "timestamp"
	                },
	                "InstanceMatchCriteria": {
	                  "locationName": "instanceMatchCriteria"
	                },
	                "AllocationStrategy": {
	                  "locationName": "allocationStrategy"
	                },
	                "InstanceTypeSpecifications": {
	                  "shape": "S8d",
	                  "locationName": "instanceTypeSpecificationSet"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeCapacityReservations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CapacityReservationIds": {
	            "locationName": "CapacityReservationId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "CapacityReservations": {
	            "locationName": "capacityReservationSet",
	            "type": "list",
	            "member": {
	              "shape": "S81",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribeCarrierGateways": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CarrierGatewayIds": {
	            "locationName": "CarrierGatewayId",
	            "type": "list",
	            "member": {}
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CarrierGateways": {
	            "locationName": "carrierGatewaySet",
	            "type": "list",
	            "member": {
	              "shape": "S8h",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeClassicLinkInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InstanceIds": {
	            "shape": "Sw4",
	            "locationName": "InstanceId"
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Instances": {
	            "locationName": "instancesSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Groups": {
	                  "shape": "Sim",
	                  "locationName": "groupSet"
	                },
	                "InstanceId": {
	                  "locationName": "instanceId"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "VpcId": {
	                  "locationName": "vpcId"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeClientVpnAuthorizationRules": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AuthorizationRules": {
	            "locationName": "authorizationRule",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ClientVpnEndpointId": {
	                  "locationName": "clientVpnEndpointId"
	                },
	                "Description": {
	                  "locationName": "description"
	                },
	                "GroupId": {
	                  "locationName": "groupId"
	                },
	                "AccessAll": {
	                  "locationName": "accessAll",
	                  "type": "boolean"
	                },
	                "DestinationCidr": {
	                  "locationName": "destinationCidr"
	                },
	                "Status": {
	                  "shape": "S55",
	                  "locationName": "status"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeClientVpnConnections": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Connections": {
	            "locationName": "connections",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ClientVpnEndpointId": {
	                  "locationName": "clientVpnEndpointId"
	                },
	                "Timestamp": {
	                  "locationName": "timestamp"
	                },
	                "ConnectionId": {
	                  "locationName": "connectionId"
	                },
	                "Username": {
	                  "locationName": "username"
	                },
	                "ConnectionEstablishedTime": {
	                  "locationName": "connectionEstablishedTime"
	                },
	                "IngressBytes": {
	                  "locationName": "ingressBytes"
	                },
	                "EgressBytes": {
	                  "locationName": "egressBytes"
	                },
	                "IngressPackets": {
	                  "locationName": "ingressPackets"
	                },
	                "EgressPackets": {
	                  "locationName": "egressPackets"
	                },
	                "ClientIp": {
	                  "locationName": "clientIp"
	                },
	                "CommonName": {
	                  "locationName": "commonName"
	                },
	                "Status": {
	                  "shape": "Swj",
	                  "locationName": "status"
	                },
	                "ConnectionEndTime": {
	                  "locationName": "connectionEndTime"
	                },
	                "PostureComplianceStatuses": {
	                  "shape": "Se",
	                  "locationName": "postureComplianceStatusSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeClientVpnEndpoints": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClientVpnEndpointIds": {
	            "locationName": "ClientVpnEndpointId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientVpnEndpoints": {
	            "locationName": "clientVpnEndpoint",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ClientVpnEndpointId": {
	                  "locationName": "clientVpnEndpointId"
	                },
	                "Description": {
	                  "locationName": "description"
	                },
	                "Status": {
	                  "shape": "S8x",
	                  "locationName": "status"
	                },
	                "CreationTime": {
	                  "locationName": "creationTime"
	                },
	                "DeletionTime": {
	                  "locationName": "deletionTime"
	                },
	                "DnsName": {
	                  "locationName": "dnsName"
	                },
	                "ClientCidrBlock": {
	                  "locationName": "clientCidrBlock"
	                },
	                "DnsServers": {
	                  "shape": "Se",
	                  "locationName": "dnsServer"
	                },
	                "SplitTunnel": {
	                  "locationName": "splitTunnel",
	                  "type": "boolean"
	                },
	                "VpnProtocol": {
	                  "locationName": "vpnProtocol"
	                },
	                "TransportProtocol": {
	                  "locationName": "transportProtocol"
	                },
	                "VpnPort": {
	                  "locationName": "vpnPort",
	                  "type": "integer"
	                },
	                "AssociatedTargetNetworks": {
	                  "deprecated": true,
	                  "deprecatedMessage": "This property is deprecated. To view the target networks associated with a Client VPN endpoint, call DescribeClientVpnTargetNetworks and inspect the clientVpnTargetNetworks response element.",
	                  "locationName": "associatedTargetNetwork",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "NetworkId": {
	                        "locationName": "networkId"
	                      },
	                      "NetworkType": {
	                        "locationName": "networkType"
	                      }
	                    }
	                  }
	                },
	                "ServerCertificateArn": {
	                  "locationName": "serverCertificateArn"
	                },
	                "AuthenticationOptions": {
	                  "locationName": "authenticationOptions",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "Type": {
	                        "locationName": "type"
	                      },
	                      "ActiveDirectory": {
	                        "locationName": "activeDirectory",
	                        "type": "structure",
	                        "members": {
	                          "DirectoryId": {
	                            "locationName": "directoryId"
	                          }
	                        }
	                      },
	                      "MutualAuthentication": {
	                        "locationName": "mutualAuthentication",
	                        "type": "structure",
	                        "members": {
	                          "ClientRootCertificateChain": {
	                            "locationName": "clientRootCertificateChain"
	                          }
	                        }
	                      },
	                      "FederatedAuthentication": {
	                        "locationName": "federatedAuthentication",
	                        "type": "structure",
	                        "members": {
	                          "SamlProviderArn": {
	                            "locationName": "samlProviderArn"
	                          },
	                          "SelfServiceSamlProviderArn": {
	                            "locationName": "selfServiceSamlProviderArn"
	                          }
	                        }
	                      }
	                    }
	                  }
	                },
	                "ConnectionLogOptions": {
	                  "locationName": "connectionLogOptions",
	                  "type": "structure",
	                  "members": {
	                    "Enabled": {
	                      "type": "boolean"
	                    },
	                    "CloudwatchLogGroup": {},
	                    "CloudwatchLogStream": {}
	                  }
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "SecurityGroupIds": {
	                  "shape": "S2c",
	                  "locationName": "securityGroupIdSet"
	                },
	                "VpcId": {
	                  "locationName": "vpcId"
	                },
	                "SelfServicePortalUrl": {
	                  "locationName": "selfServicePortalUrl"
	                },
	                "ClientConnectOptions": {
	                  "locationName": "clientConnectOptions",
	                  "type": "structure",
	                  "members": {
	                    "Enabled": {
	                      "locationName": "enabled",
	                      "type": "boolean"
	                    },
	                    "LambdaFunctionArn": {
	                      "locationName": "lambdaFunctionArn"
	                    },
	                    "Status": {
	                      "locationName": "status",
	                      "type": "structure",
	                      "members": {
	                        "Code": {
	                          "locationName": "code"
	                        },
	                        "Message": {
	                          "locationName": "message"
	                        }
	                      }
	                    }
	                  }
	                },
	                "SessionTimeoutHours": {
	                  "locationName": "sessionTimeoutHours",
	                  "type": "integer"
	                },
	                "ClientLoginBannerOptions": {
	                  "locationName": "clientLoginBannerOptions",
	                  "type": "structure",
	                  "members": {
	                    "Enabled": {
	                      "locationName": "enabled",
	                      "type": "boolean"
	                    },
	                    "BannerText": {
	                      "locationName": "bannerText"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeClientVpnRoutes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Routes": {
	            "locationName": "routes",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ClientVpnEndpointId": {
	                  "locationName": "clientVpnEndpointId"
	                },
	                "DestinationCidr": {
	                  "locationName": "destinationCidr"
	                },
	                "TargetSubnet": {
	                  "locationName": "targetSubnet"
	                },
	                "Type": {
	                  "locationName": "type"
	                },
	                "Origin": {
	                  "locationName": "origin"
	                },
	                "Status": {
	                  "shape": "S91",
	                  "locationName": "status"
	                },
	                "Description": {
	                  "locationName": "description"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeClientVpnTargetNetworks": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "AssociationIds": {
	            "shape": "Se"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientVpnTargetNetworks": {
	            "locationName": "clientVpnTargetNetworks",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AssociationId": {
	                  "locationName": "associationId"
	                },
	                "VpcId": {
	                  "locationName": "vpcId"
	                },
	                "TargetNetworkId": {
	                  "locationName": "targetNetworkId"
	                },
	                "ClientVpnEndpointId": {
	                  "locationName": "clientVpnEndpointId"
	                },
	                "Status": {
	                  "shape": "S2y",
	                  "locationName": "status"
	                },
	                "SecurityGroups": {
	                  "shape": "Se",
	                  "locationName": "securityGroups"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeCoipPools": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PoolIds": {
	            "locationName": "PoolId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CoipPools": {
	            "locationName": "coipPoolSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "PoolId": {
	                  "locationName": "poolId"
	                },
	                "PoolCidrs": {
	                  "shape": "Se",
	                  "locationName": "poolCidrSet"
	                },
	                "LocalGatewayRouteTableId": {
	                  "locationName": "localGatewayRouteTableId"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "PoolArn": {
	                  "locationName": "poolArn"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeConversionTasks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConversionTaskIds": {
	            "locationName": "conversionTaskId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConversionTasks": {
	            "locationName": "conversionTasks",
	            "type": "list",
	            "member": {
	              "shape": "Sxq",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribeCustomerGateways": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CustomerGatewayIds": {
	            "locationName": "CustomerGatewayId",
	            "type": "list",
	            "member": {
	              "locationName": "CustomerGatewayId"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CustomerGateways": {
	            "locationName": "customerGatewaySet",
	            "type": "list",
	            "member": {
	              "shape": "S96",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDhcpOptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DhcpOptionsIds": {
	            "locationName": "DhcpOptionsId",
	            "type": "list",
	            "member": {
	              "locationName": "DhcpOptionsId"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DhcpOptions": {
	            "locationName": "dhcpOptionsSet",
	            "type": "list",
	            "member": {
	              "shape": "S9q",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeEgressOnlyInternetGateways": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "EgressOnlyInternetGatewayIds": {
	            "locationName": "EgressOnlyInternetGatewayId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EgressOnlyInternetGateways": {
	            "locationName": "egressOnlyInternetGatewaySet",
	            "type": "list",
	            "member": {
	              "shape": "S9x",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeElasticGpus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ElasticGpuIds": {
	            "locationName": "ElasticGpuId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ElasticGpuSet": {
	            "locationName": "elasticGpuSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ElasticGpuId": {
	                  "locationName": "elasticGpuId"
	                },
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "ElasticGpuType": {
	                  "locationName": "elasticGpuType"
	                },
	                "ElasticGpuHealth": {
	                  "locationName": "elasticGpuHealth",
	                  "type": "structure",
	                  "members": {
	                    "Status": {
	                      "locationName": "status"
	                    }
	                  }
	                },
	                "ElasticGpuState": {
	                  "locationName": "elasticGpuState"
	                },
	                "InstanceId": {
	                  "locationName": "instanceId"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeExportImageTasks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "ExportImageTaskIds": {
	            "locationName": "ExportImageTaskId",
	            "type": "list",
	            "member": {
	              "locationName": "ExportImageTaskId"
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExportImageTasks": {
	            "locationName": "exportImageTaskSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Description": {
	                  "locationName": "description"
	                },
	                "ExportImageTaskId": {
	                  "locationName": "exportImageTaskId"
	                },
	                "ImageId": {
	                  "locationName": "imageId"
	                },
	                "Progress": {
	                  "locationName": "progress"
	                },
	                "S3ExportLocation": {
	                  "shape": "Syt",
	                  "locationName": "s3ExportLocation"
	                },
	                "Status": {
	                  "locationName": "status"
	                },
	                "StatusMessage": {
	                  "locationName": "statusMessage"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeExportTasks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ExportTaskIds": {
	            "locationName": "exportTaskId",
	            "type": "list",
	            "member": {
	              "locationName": "ExportTaskId"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExportTasks": {
	            "locationName": "exportTaskSet",
	            "type": "list",
	            "member": {
	              "shape": "Scv",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribeFastLaunchImages": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ImageIds": {
	            "locationName": "ImageId",
	            "type": "list",
	            "member": {
	              "locationName": "ImageId"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FastLaunchImages": {
	            "locationName": "fastLaunchImageSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ImageId": {
	                  "locationName": "imageId"
	                },
	                "ResourceType": {
	                  "locationName": "resourceType"
	                },
	                "SnapshotConfiguration": {
	                  "shape": "Sz6",
	                  "locationName": "snapshotConfiguration"
	                },
	                "LaunchTemplate": {
	                  "shape": "Sz7",
	                  "locationName": "launchTemplate"
	                },
	                "MaxParallelLaunches": {
	                  "locationName": "maxParallelLaunches",
	                  "type": "integer"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "StateTransitionReason": {
	                  "locationName": "stateTransitionReason"
	                },
	                "StateTransitionTime": {
	                  "locationName": "stateTransitionTime",
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeFastSnapshotRestores": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FastSnapshotRestores": {
	            "locationName": "fastSnapshotRestoreSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "SnapshotId": {
	                  "locationName": "snapshotId"
	                },
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "StateTransitionReason": {
	                  "locationName": "stateTransitionReason"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "OwnerAlias": {
	                  "locationName": "ownerAlias"
	                },
	                "EnablingTime": {
	                  "locationName": "enablingTime",
	                  "type": "timestamp"
	                },
	                "OptimizingTime": {
	                  "locationName": "optimizingTime",
	                  "type": "timestamp"
	                },
	                "EnabledTime": {
	                  "locationName": "enabledTime",
	                  "type": "timestamp"
	                },
	                "DisablingTime": {
	                  "locationName": "disablingTime",
	                  "type": "timestamp"
	                },
	                "DisabledTime": {
	                  "locationName": "disabledTime",
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeFleetHistory": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId",
	          "StartTime"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "EventType": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "FleetId": {},
	          "StartTime": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HistoryRecords": {
	            "locationName": "historyRecordSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "EventInformation": {
	                  "shape": "Szk",
	                  "locationName": "eventInformation"
	                },
	                "EventType": {
	                  "locationName": "eventType"
	                },
	                "Timestamp": {
	                  "locationName": "timestamp",
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "LastEvaluatedTime": {
	            "locationName": "lastEvaluatedTime",
	            "type": "timestamp"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "FleetId": {
	            "locationName": "fleetId"
	          },
	          "StartTime": {
	            "locationName": "startTime",
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeFleetInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "FleetId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ActiveInstances": {
	            "shape": "Szn",
	            "locationName": "activeInstanceSet"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "FleetId": {
	            "locationName": "fleetId"
	          }
	        }
	      }
	    },
	    "DescribeFleets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "FleetIds": {
	            "shape": "Sq5",
	            "locationName": "FleetId"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "Fleets": {
	            "locationName": "fleetSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ActivityStatus": {
	                  "locationName": "activityStatus"
	                },
	                "CreateTime": {
	                  "locationName": "createTime",
	                  "type": "timestamp"
	                },
	                "FleetId": {
	                  "locationName": "fleetId"
	                },
	                "FleetState": {
	                  "locationName": "fleetState"
	                },
	                "ClientToken": {
	                  "locationName": "clientToken"
	                },
	                "ExcessCapacityTerminationPolicy": {
	                  "locationName": "excessCapacityTerminationPolicy"
	                },
	                "FulfilledCapacity": {
	                  "locationName": "fulfilledCapacity",
	                  "type": "double"
	                },
	                "FulfilledOnDemandCapacity": {
	                  "locationName": "fulfilledOnDemandCapacity",
	                  "type": "double"
	                },
	                "LaunchTemplateConfigs": {
	                  "locationName": "launchTemplateConfigs",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "LaunchTemplateSpecification": {
	                        "shape": "Sbl",
	                        "locationName": "launchTemplateSpecification"
	                      },
	                      "Overrides": {
	                        "locationName": "overrides",
	                        "type": "list",
	                        "member": {
	                          "shape": "Sbm",
	                          "locationName": "item"
	                        }
	                      }
	                    }
	                  }
	                },
	                "TargetCapacitySpecification": {
	                  "locationName": "targetCapacitySpecification",
	                  "type": "structure",
	                  "members": {
	                    "TotalTargetCapacity": {
	                      "locationName": "totalTargetCapacity",
	                      "type": "integer"
	                    },
	                    "OnDemandTargetCapacity": {
	                      "locationName": "onDemandTargetCapacity",
	                      "type": "integer"
	                    },
	                    "SpotTargetCapacity": {
	                      "locationName": "spotTargetCapacity",
	                      "type": "integer"
	                    },
	                    "DefaultTargetCapacityType": {
	                      "locationName": "defaultTargetCapacityType"
	                    },
	                    "TargetCapacityUnitType": {
	                      "locationName": "targetCapacityUnitType"
	                    }
	                  }
	                },
	                "TerminateInstancesWithExpiration": {
	                  "locationName": "terminateInstancesWithExpiration",
	                  "type": "boolean"
	                },
	                "Type": {
	                  "locationName": "type"
	                },
	                "ValidFrom": {
	                  "locationName": "validFrom",
	                  "type": "timestamp"
	                },
	                "ValidUntil": {
	                  "locationName": "validUntil",
	                  "type": "timestamp"
	                },
	                "ReplaceUnhealthyInstances": {
	                  "locationName": "replaceUnhealthyInstances",
	                  "type": "boolean"
	                },
	                "SpotOptions": {
	                  "locationName": "spotOptions",
	                  "type": "structure",
	                  "members": {
	                    "AllocationStrategy": {
	                      "locationName": "allocationStrategy"
	                    },
	                    "MaintenanceStrategies": {
	                      "locationName": "maintenanceStrategies",
	                      "type": "structure",
	                      "members": {
	                        "CapacityRebalance": {
	                          "locationName": "capacityRebalance",
	                          "type": "structure",
	                          "members": {
	                            "ReplacementStrategy": {
	                              "locationName": "replacementStrategy"
	                            },
	                            "TerminationDelay": {
	                              "locationName": "terminationDelay",
	                              "type": "integer"
	                            }
	                          }
	                        }
	                      }
	                    },
	                    "InstanceInterruptionBehavior": {
	                      "locationName": "instanceInterruptionBehavior"
	                    },
	                    "InstancePoolsToUseCount": {
	                      "locationName": "instancePoolsToUseCount",
	                      "type": "integer"
	                    },
	                    "SingleInstanceType": {
	                      "locationName": "singleInstanceType",
	                      "type": "boolean"
	                    },
	                    "SingleAvailabilityZone": {
	                      "locationName": "singleAvailabilityZone",
	                      "type": "boolean"
	                    },
	                    "MinTargetCapacity": {
	                      "locationName": "minTargetCapacity",
	                      "type": "integer"
	                    },
	                    "MaxTotalPrice": {
	                      "locationName": "maxTotalPrice"
	                    }
	                  }
	                },
	                "OnDemandOptions": {
	                  "locationName": "onDemandOptions",
	                  "type": "structure",
	                  "members": {
	                    "AllocationStrategy": {
	                      "locationName": "allocationStrategy"
	                    },
	                    "CapacityReservationOptions": {
	                      "locationName": "capacityReservationOptions",
	                      "type": "structure",
	                      "members": {
	                        "UsageStrategy": {
	                          "locationName": "usageStrategy"
	                        }
	                      }
	                    },
	                    "SingleInstanceType": {
	                      "locationName": "singleInstanceType",
	                      "type": "boolean"
	                    },
	                    "SingleAvailabilityZone": {
	                      "locationName": "singleAvailabilityZone",
	                      "type": "boolean"
	                    },
	                    "MinTargetCapacity": {
	                      "locationName": "minTargetCapacity",
	                      "type": "integer"
	                    },
	                    "MaxTotalPrice": {
	                      "locationName": "maxTotalPrice"
	                    }
	                  }
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "Errors": {
	                  "locationName": "errorSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "LaunchTemplateAndOverrides": {
	                        "shape": "Sbk",
	                        "locationName": "launchTemplateAndOverrides"
	                      },
	                      "Lifecycle": {
	                        "locationName": "lifecycle"
	                      },
	                      "ErrorCode": {
	                        "locationName": "errorCode"
	                      },
	                      "ErrorMessage": {
	                        "locationName": "errorMessage"
	                      }
	                    }
	                  }
	                },
	                "Instances": {
	                  "locationName": "fleetInstanceSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "LaunchTemplateAndOverrides": {
	                        "shape": "Sbk",
	                        "locationName": "launchTemplateAndOverrides"
	                      },
	                      "Lifecycle": {
	                        "locationName": "lifecycle"
	                      },
	                      "InstanceIds": {
	                        "shape": "Sc0",
	                        "locationName": "instanceIds"
	                      },
	                      "InstanceType": {
	                        "locationName": "instanceType"
	                      },
	                      "Platform": {
	                        "locationName": "platform"
	                      }
	                    }
	                  }
	                },
	                "Context": {
	                  "locationName": "context"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeFlowLogs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filter": {
	            "shape": "Sum"
	          },
	          "FlowLogIds": {
	            "shape": "Sqf",
	            "locationName": "FlowLogId"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FlowLogs": {
	            "locationName": "flowLogSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "CreationTime": {
	                  "locationName": "creationTime",
	                  "type": "timestamp"
	                },
	                "DeliverLogsErrorMessage": {
	                  "locationName": "deliverLogsErrorMessage"
	                },
	                "DeliverLogsPermissionArn": {
	                  "locationName": "deliverLogsPermissionArn"
	                },
	                "DeliverLogsStatus": {
	                  "locationName": "deliverLogsStatus"
	                },
	                "FlowLogId": {
	                  "locationName": "flowLogId"
	                },
	                "FlowLogStatus": {
	                  "locationName": "flowLogStatus"
	                },
	                "LogGroupName": {
	                  "locationName": "logGroupName"
	                },
	                "ResourceId": {
	                  "locationName": "resourceId"
	                },
	                "TrafficType": {
	                  "locationName": "trafficType"
	                },
	                "LogDestinationType": {
	                  "locationName": "logDestinationType"
	                },
	                "LogDestination": {
	                  "locationName": "logDestination"
	                },
	                "LogFormat": {
	                  "locationName": "logFormat"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "MaxAggregationInterval": {
	                  "locationName": "maxAggregationInterval",
	                  "type": "integer"
	                },
	                "DestinationOptions": {
	                  "locationName": "destinationOptions",
	                  "type": "structure",
	                  "members": {
	                    "FileFormat": {
	                      "locationName": "fileFormat"
	                    },
	                    "HiveCompatiblePartitions": {
	                      "locationName": "hiveCompatiblePartitions",
	                      "type": "boolean"
	                    },
	                    "PerHourPartition": {
	                      "locationName": "perHourPartition",
	                      "type": "boolean"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeFpgaImageAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FpgaImageId",
	          "Attribute"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "FpgaImageId": {},
	          "Attribute": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FpgaImageAttribute": {
	            "shape": "S10g",
	            "locationName": "fpgaImageAttribute"
	          }
	        }
	      }
	    },
	    "DescribeFpgaImages": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "FpgaImageIds": {
	            "locationName": "FpgaImageId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Owners": {
	            "shape": "S10p",
	            "locationName": "Owner"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FpgaImages": {
	            "locationName": "fpgaImageSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "FpgaImageId": {
	                  "locationName": "fpgaImageId"
	                },
	                "FpgaImageGlobalId": {
	                  "locationName": "fpgaImageGlobalId"
	                },
	                "Name": {
	                  "locationName": "name"
	                },
	                "Description": {
	                  "locationName": "description"
	                },
	                "ShellVersion": {
	                  "locationName": "shellVersion"
	                },
	                "PciId": {
	                  "locationName": "pciId",
	                  "type": "structure",
	                  "members": {
	                    "DeviceId": {},
	                    "VendorId": {},
	                    "SubsystemId": {},
	                    "SubsystemVendorId": {}
	                  }
	                },
	                "State": {
	                  "locationName": "state",
	                  "type": "structure",
	                  "members": {
	                    "Code": {
	                      "locationName": "code"
	                    },
	                    "Message": {
	                      "locationName": "message"
	                    }
	                  }
	                },
	                "CreateTime": {
	                  "locationName": "createTime",
	                  "type": "timestamp"
	                },
	                "UpdateTime": {
	                  "locationName": "updateTime",
	                  "type": "timestamp"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "OwnerAlias": {
	                  "locationName": "ownerAlias"
	                },
	                "ProductCodes": {
	                  "shape": "S10k",
	                  "locationName": "productCodes"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tags"
	                },
	                "Public": {
	                  "locationName": "public",
	                  "type": "boolean"
	                },
	                "DataRetentionSupport": {
	                  "locationName": "dataRetentionSupport",
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeHostReservationOfferings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "shape": "Sum"
	          },
	          "MaxDuration": {
	            "type": "integer"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "MinDuration": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "OfferingId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "OfferingSet": {
	            "locationName": "offeringSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "CurrencyCode": {
	                  "locationName": "currencyCode"
	                },
	                "Duration": {
	                  "locationName": "duration",
	                  "type": "integer"
	                },
	                "HourlyPrice": {
	                  "locationName": "hourlyPrice"
	                },
	                "InstanceFamily": {
	                  "locationName": "instanceFamily"
	                },
	                "OfferingId": {
	                  "locationName": "offeringId"
	                },
	                "PaymentOption": {
	                  "locationName": "paymentOption"
	                },
	                "UpfrontPrice": {
	                  "locationName": "upfrontPrice"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeHostReservations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "shape": "Sum"
	          },
	          "HostReservationIdSet": {
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HostReservationSet": {
	            "locationName": "hostReservationSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Count": {
	                  "locationName": "count",
	                  "type": "integer"
	                },
	                "CurrencyCode": {
	                  "locationName": "currencyCode"
	                },
	                "Duration": {
	                  "locationName": "duration",
	                  "type": "integer"
	                },
	                "End": {
	                  "locationName": "end",
	                  "type": "timestamp"
	                },
	                "HostIdSet": {
	                  "shape": "S11a",
	                  "locationName": "hostIdSet"
	                },
	                "HostReservationId": {
	                  "locationName": "hostReservationId"
	                },
	                "HourlyPrice": {
	                  "locationName": "hourlyPrice"
	                },
	                "InstanceFamily": {
	                  "locationName": "instanceFamily"
	                },
	                "OfferingId": {
	                  "locationName": "offeringId"
	                },
	                "PaymentOption": {
	                  "locationName": "paymentOption"
	                },
	                "Start": {
	                  "locationName": "start",
	                  "type": "timestamp"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "UpfrontPrice": {
	                  "locationName": "upfrontPrice"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeHosts": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "shape": "Sum",
	            "locationName": "filter"
	          },
	          "HostIds": {
	            "shape": "S11d",
	            "locationName": "hostId"
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Hosts": {
	            "locationName": "hostSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AutoPlacement": {
	                  "locationName": "autoPlacement"
	                },
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "AvailableCapacity": {
	                  "locationName": "availableCapacity",
	                  "type": "structure",
	                  "members": {
	                    "AvailableInstanceCapacity": {
	                      "locationName": "availableInstanceCapacity",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item",
	                        "type": "structure",
	                        "members": {
	                          "AvailableCapacity": {
	                            "locationName": "availableCapacity",
	                            "type": "integer"
	                          },
	                          "InstanceType": {
	                            "locationName": "instanceType"
	                          },
	                          "TotalCapacity": {
	                            "locationName": "totalCapacity",
	                            "type": "integer"
	                          }
	                        }
	                      }
	                    },
	                    "AvailableVCpus": {
	                      "locationName": "availableVCpus",
	                      "type": "integer"
	                    }
	                  }
	                },
	                "ClientToken": {
	                  "locationName": "clientToken"
	                },
	                "HostId": {
	                  "locationName": "hostId"
	                },
	                "HostProperties": {
	                  "locationName": "hostProperties",
	                  "type": "structure",
	                  "members": {
	                    "Cores": {
	                      "locationName": "cores",
	                      "type": "integer"
	                    },
	                    "InstanceType": {
	                      "locationName": "instanceType"
	                    },
	                    "InstanceFamily": {
	                      "locationName": "instanceFamily"
	                    },
	                    "Sockets": {
	                      "locationName": "sockets",
	                      "type": "integer"
	                    },
	                    "TotalVCpus": {
	                      "locationName": "totalVCpus",
	                      "type": "integer"
	                    }
	                  }
	                },
	                "HostReservationId": {
	                  "locationName": "hostReservationId"
	                },
	                "Instances": {
	                  "locationName": "instances",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "InstanceId": {
	                        "locationName": "instanceId"
	                      },
	                      "InstanceType": {
	                        "locationName": "instanceType"
	                      },
	                      "OwnerId": {
	                        "locationName": "ownerId"
	                      }
	                    }
	                  }
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "AllocationTime": {
	                  "locationName": "allocationTime",
	                  "type": "timestamp"
	                },
	                "ReleaseTime": {
	                  "locationName": "releaseTime",
	                  "type": "timestamp"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "HostRecovery": {
	                  "locationName": "hostRecovery"
	                },
	                "AllowsMultipleInstanceTypes": {
	                  "locationName": "allowsMultipleInstanceTypes"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "AvailabilityZoneId": {
	                  "locationName": "availabilityZoneId"
	                },
	                "MemberOfServiceLinkedResourceGroup": {
	                  "locationName": "memberOfServiceLinkedResourceGroup",
	                  "type": "boolean"
	                },
	                "OutpostArn": {
	                  "locationName": "outpostArn"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeIamInstanceProfileAssociations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AssociationIds": {
	            "locationName": "AssociationId",
	            "type": "list",
	            "member": {
	              "locationName": "AssociationId"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IamInstanceProfileAssociations": {
	            "locationName": "iamInstanceProfileAssociationSet",
	            "type": "list",
	            "member": {
	              "shape": "S38",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeIdFormat": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Resource": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Statuses": {
	            "shape": "Sv4",
	            "locationName": "statusSet"
	          }
	        }
	      }
	    },
	    "DescribeIdentityIdFormat": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PrincipalArn"
	        ],
	        "members": {
	          "PrincipalArn": {
	            "locationName": "principalArn"
	          },
	          "Resource": {
	            "locationName": "resource"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Statuses": {
	            "shape": "Sv4",
	            "locationName": "statusSet"
	          }
	        }
	      }
	    },
	    "DescribeImageAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Attribute",
	          "ImageId"
	        ],
	        "members": {
	          "Attribute": {},
	          "ImageId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BlockDeviceMappings": {
	            "shape": "S122",
	            "locationName": "blockDeviceMapping"
	          },
	          "ImageId": {
	            "locationName": "imageId"
	          },
	          "LaunchPermissions": {
	            "shape": "S123",
	            "locationName": "launchPermission"
	          },
	          "ProductCodes": {
	            "shape": "S10k",
	            "locationName": "productCodes"
	          },
	          "Description": {
	            "shape": "S9u",
	            "locationName": "description"
	          },
	          "KernelId": {
	            "shape": "S9u",
	            "locationName": "kernel"
	          },
	          "RamdiskId": {
	            "shape": "S9u",
	            "locationName": "ramdisk"
	          },
	          "SriovNetSupport": {
	            "shape": "S9u",
	            "locationName": "sriovNetSupport"
	          },
	          "BootMode": {
	            "shape": "S9u",
	            "locationName": "bootMode"
	          },
	          "TpmSupport": {
	            "shape": "S9u",
	            "locationName": "tpmSupport"
	          },
	          "UefiData": {
	            "shape": "S9u",
	            "locationName": "uefiData"
	          },
	          "LastLaunchedTime": {
	            "shape": "S9u",
	            "locationName": "lastLaunchedTime"
	          }
	        }
	      }
	    },
	    "DescribeImages": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ExecutableUsers": {
	            "locationName": "ExecutableBy",
	            "type": "list",
	            "member": {
	              "locationName": "ExecutableBy"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "ImageIds": {
	            "shape": "S127",
	            "locationName": "ImageId"
	          },
	          "Owners": {
	            "shape": "S10p",
	            "locationName": "Owner"
	          },
	          "IncludeDeprecated": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Images": {
	            "locationName": "imagesSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Architecture": {
	                  "locationName": "architecture"
	                },
	                "CreationDate": {
	                  "locationName": "creationDate"
	                },
	                "ImageId": {
	                  "locationName": "imageId"
	                },
	                "ImageLocation": {
	                  "locationName": "imageLocation"
	                },
	                "ImageType": {
	                  "locationName": "imageType"
	                },
	                "Public": {
	                  "locationName": "isPublic",
	                  "type": "boolean"
	                },
	                "KernelId": {
	                  "locationName": "kernelId"
	                },
	                "OwnerId": {
	                  "locationName": "imageOwnerId"
	                },
	                "Platform": {
	                  "locationName": "platform"
	                },
	                "PlatformDetails": {
	                  "locationName": "platformDetails"
	                },
	                "UsageOperation": {
	                  "locationName": "usageOperation"
	                },
	                "ProductCodes": {
	                  "shape": "S10k",
	                  "locationName": "productCodes"
	                },
	                "RamdiskId": {
	                  "locationName": "ramdiskId"
	                },
	                "State": {
	                  "locationName": "imageState"
	                },
	                "BlockDeviceMappings": {
	                  "shape": "S122",
	                  "locationName": "blockDeviceMapping"
	                },
	                "Description": {
	                  "locationName": "description"
	                },
	                "EnaSupport": {
	                  "locationName": "enaSupport",
	                  "type": "boolean"
	                },
	                "Hypervisor": {
	                  "locationName": "hypervisor"
	                },
	                "ImageOwnerAlias": {
	                  "locationName": "imageOwnerAlias"
	                },
	                "Name": {
	                  "locationName": "name"
	                },
	                "RootDeviceName": {
	                  "locationName": "rootDeviceName"
	                },
	                "RootDeviceType": {
	                  "locationName": "rootDeviceType"
	                },
	                "SriovNetSupport": {
	                  "locationName": "sriovNetSupport"
	                },
	                "StateReason": {
	                  "shape": "S12g",
	                  "locationName": "stateReason"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "VirtualizationType": {
	                  "locationName": "virtualizationType"
	                },
	                "BootMode": {
	                  "locationName": "bootMode"
	                },
	                "TpmSupport": {
	                  "locationName": "tpmSupport"
	                },
	                "DeprecationTime": {
	                  "locationName": "deprecationTime"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeImportImageTasks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum"
	          },
	          "ImportTaskIds": {
	            "locationName": "ImportTaskId",
	            "type": "list",
	            "member": {
	              "locationName": "ImportTaskId"
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ImportImageTasks": {
	            "locationName": "importImageTaskSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Architecture": {
	                  "locationName": "architecture"
	                },
	                "Description": {
	                  "locationName": "description"
	                },
	                "Encrypted": {
	                  "locationName": "encrypted",
	                  "type": "boolean"
	                },
	                "Hypervisor": {
	                  "locationName": "hypervisor"
	                },
	                "ImageId": {
	                  "locationName": "imageId"
	                },
	                "ImportTaskId": {
	                  "locationName": "importTaskId"
	                },
	                "KmsKeyId": {
	                  "locationName": "kmsKeyId"
	                },
	                "LicenseType": {
	                  "locationName": "licenseType"
	                },
	                "Platform": {
	                  "locationName": "platform"
	                },
	                "Progress": {
	                  "locationName": "progress"
	                },
	                "SnapshotDetails": {
	                  "shape": "S12q",
	                  "locationName": "snapshotDetailSet"
	                },
	                "Status": {
	                  "locationName": "status"
	                },
	                "StatusMessage": {
	                  "locationName": "statusMessage"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "LicenseSpecifications": {
	                  "shape": "S12t",
	                  "locationName": "licenseSpecifications"
	                },
	                "UsageOperation": {
	                  "locationName": "usageOperation"
	                },
	                "BootMode": {
	                  "locationName": "bootMode"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeImportSnapshotTasks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum"
	          },
	          "ImportTaskIds": {
	            "locationName": "ImportTaskId",
	            "type": "list",
	            "member": {
	              "locationName": "ImportTaskId"
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ImportSnapshotTasks": {
	            "locationName": "importSnapshotTaskSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Description": {
	                  "locationName": "description"
	                },
	                "ImportTaskId": {
	                  "locationName": "importTaskId"
	                },
	                "SnapshotTaskDetail": {
	                  "shape": "S131",
	                  "locationName": "snapshotTaskDetail"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeInstanceAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Attribute",
	          "InstanceId"
	        ],
	        "members": {
	          "Attribute": {
	            "locationName": "attribute"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Groups": {
	            "shape": "Sim",
	            "locationName": "groupSet"
	          },
	          "BlockDeviceMappings": {
	            "shape": "S135",
	            "locationName": "blockDeviceMapping"
	          },
	          "DisableApiTermination": {
	            "shape": "S138",
	            "locationName": "disableApiTermination"
	          },
	          "EnaSupport": {
	            "shape": "S138",
	            "locationName": "enaSupport"
	          },
	          "EnclaveOptions": {
	            "shape": "S139",
	            "locationName": "enclaveOptions"
	          },
	          "EbsOptimized": {
	            "shape": "S138",
	            "locationName": "ebsOptimized"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "InstanceInitiatedShutdownBehavior": {
	            "shape": "S9u",
	            "locationName": "instanceInitiatedShutdownBehavior"
	          },
	          "InstanceType": {
	            "shape": "S9u",
	            "locationName": "instanceType"
	          },
	          "KernelId": {
	            "shape": "S9u",
	            "locationName": "kernel"
	          },
	          "ProductCodes": {
	            "shape": "S10k",
	            "locationName": "productCodes"
	          },
	          "RamdiskId": {
	            "shape": "S9u",
	            "locationName": "ramdisk"
	          },
	          "RootDeviceName": {
	            "shape": "S9u",
	            "locationName": "rootDeviceName"
	          },
	          "SourceDestCheck": {
	            "shape": "S138",
	            "locationName": "sourceDestCheck"
	          },
	          "SriovNetSupport": {
	            "shape": "S9u",
	            "locationName": "sriovNetSupport"
	          },
	          "UserData": {
	            "shape": "S9u",
	            "locationName": "userData"
	          },
	          "DisableApiStop": {
	            "shape": "S138",
	            "locationName": "disableApiStop"
	          }
	        }
	      }
	    },
	    "DescribeInstanceCreditSpecifications": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "InstanceIds": {
	            "shape": "Sw4",
	            "locationName": "InstanceId"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceCreditSpecifications": {
	            "locationName": "instanceCreditSpecificationSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "InstanceId": {
	                  "locationName": "instanceId"
	                },
	                "CpuCredits": {
	                  "locationName": "cpuCredits"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeInstanceEventNotificationAttributes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceTagAttribute": {
	            "shape": "Su5",
	            "locationName": "instanceTagAttribute"
	          }
	        }
	      }
	    },
	    "DescribeInstanceEventWindows": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceEventWindowIds": {
	            "locationName": "InstanceEventWindowId",
	            "type": "list",
	            "member": {
	              "locationName": "InstanceEventWindowId"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceEventWindows": {
	            "locationName": "instanceEventWindowSet",
	            "type": "list",
	            "member": {
	              "shape": "S3i",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeInstanceStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "InstanceIds": {
	            "shape": "Sw4",
	            "locationName": "InstanceId"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "IncludeAllInstances": {
	            "locationName": "includeAllInstances",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceStatuses": {
	            "locationName": "instanceStatusSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "OutpostArn": {
	                  "locationName": "outpostArn"
	                },
	                "Events": {
	                  "locationName": "eventsSet",
	                  "type": "list",
	                  "member": {
	                    "shape": "S13r",
	                    "locationName": "item"
	                  }
	                },
	                "InstanceId": {
	                  "locationName": "instanceId"
	                },
	                "InstanceState": {
	                  "shape": "S13u",
	                  "locationName": "instanceState"
	                },
	                "InstanceStatus": {
	                  "shape": "S13w",
	                  "locationName": "instanceStatus"
	                },
	                "SystemStatus": {
	                  "shape": "S13w",
	                  "locationName": "systemStatus"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeInstanceTypeOfferings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "LocationType": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceTypeOfferings": {
	            "locationName": "instanceTypeOfferingSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "InstanceType": {
	                  "locationName": "instanceType"
	                },
	                "LocationType": {
	                  "locationName": "locationType"
	                },
	                "Location": {
	                  "locationName": "location"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeInstanceTypes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceTypes": {
	            "locationName": "InstanceType",
	            "type": "list",
	            "member": {}
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceTypes": {
	            "locationName": "instanceTypeSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "InstanceType": {
	                  "locationName": "instanceType"
	                },
	                "CurrentGeneration": {
	                  "locationName": "currentGeneration",
	                  "type": "boolean"
	                },
	                "FreeTierEligible": {
	                  "locationName": "freeTierEligible",
	                  "type": "boolean"
	                },
	                "SupportedUsageClasses": {
	                  "locationName": "supportedUsageClasses",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item"
	                  }
	                },
	                "SupportedRootDeviceTypes": {
	                  "locationName": "supportedRootDeviceTypes",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item"
	                  }
	                },
	                "SupportedVirtualizationTypes": {
	                  "locationName": "supportedVirtualizationTypes",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item"
	                  }
	                },
	                "BareMetal": {
	                  "locationName": "bareMetal",
	                  "type": "boolean"
	                },
	                "Hypervisor": {
	                  "locationName": "hypervisor"
	                },
	                "ProcessorInfo": {
	                  "locationName": "processorInfo",
	                  "type": "structure",
	                  "members": {
	                    "SupportedArchitectures": {
	                      "locationName": "supportedArchitectures",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item"
	                      }
	                    },
	                    "SustainedClockSpeedInGhz": {
	                      "locationName": "sustainedClockSpeedInGhz",
	                      "type": "double"
	                    }
	                  }
	                },
	                "VCpuInfo": {
	                  "locationName": "vCpuInfo",
	                  "type": "structure",
	                  "members": {
	                    "DefaultVCpus": {
	                      "locationName": "defaultVCpus",
	                      "type": "integer"
	                    },
	                    "DefaultCores": {
	                      "locationName": "defaultCores",
	                      "type": "integer"
	                    },
	                    "DefaultThreadsPerCore": {
	                      "locationName": "defaultThreadsPerCore",
	                      "type": "integer"
	                    },
	                    "ValidCores": {
	                      "locationName": "validCores",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item",
	                        "type": "integer"
	                      }
	                    },
	                    "ValidThreadsPerCore": {
	                      "locationName": "validThreadsPerCore",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item",
	                        "type": "integer"
	                      }
	                    }
	                  }
	                },
	                "MemoryInfo": {
	                  "locationName": "memoryInfo",
	                  "type": "structure",
	                  "members": {
	                    "SizeInMiB": {
	                      "locationName": "sizeInMiB",
	                      "type": "long"
	                    }
	                  }
	                },
	                "InstanceStorageSupported": {
	                  "locationName": "instanceStorageSupported",
	                  "type": "boolean"
	                },
	                "InstanceStorageInfo": {
	                  "locationName": "instanceStorageInfo",
	                  "type": "structure",
	                  "members": {
	                    "TotalSizeInGB": {
	                      "locationName": "totalSizeInGB",
	                      "type": "long"
	                    },
	                    "Disks": {
	                      "locationName": "disks",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item",
	                        "type": "structure",
	                        "members": {
	                          "SizeInGB": {
	                            "locationName": "sizeInGB",
	                            "type": "long"
	                          },
	                          "Count": {
	                            "locationName": "count",
	                            "type": "integer"
	                          },
	                          "Type": {
	                            "locationName": "type"
	                          }
	                        }
	                      }
	                    },
	                    "NvmeSupport": {
	                      "locationName": "nvmeSupport"
	                    },
	                    "EncryptionSupport": {
	                      "locationName": "encryptionSupport"
	                    }
	                  }
	                },
	                "EbsInfo": {
	                  "locationName": "ebsInfo",
	                  "type": "structure",
	                  "members": {
	                    "EbsOptimizedSupport": {
	                      "locationName": "ebsOptimizedSupport"
	                    },
	                    "EncryptionSupport": {
	                      "locationName": "encryptionSupport"
	                    },
	                    "EbsOptimizedInfo": {
	                      "locationName": "ebsOptimizedInfo",
	                      "type": "structure",
	                      "members": {
	                        "BaselineBandwidthInMbps": {
	                          "locationName": "baselineBandwidthInMbps",
	                          "type": "integer"
	                        },
	                        "BaselineThroughputInMBps": {
	                          "locationName": "baselineThroughputInMBps",
	                          "type": "double"
	                        },
	                        "BaselineIops": {
	                          "locationName": "baselineIops",
	                          "type": "integer"
	                        },
	                        "MaximumBandwidthInMbps": {
	                          "locationName": "maximumBandwidthInMbps",
	                          "type": "integer"
	                        },
	                        "MaximumThroughputInMBps": {
	                          "locationName": "maximumThroughputInMBps",
	                          "type": "double"
	                        },
	                        "MaximumIops": {
	                          "locationName": "maximumIops",
	                          "type": "integer"
	                        }
	                      }
	                    },
	                    "NvmeSupport": {
	                      "locationName": "nvmeSupport"
	                    }
	                  }
	                },
	                "NetworkInfo": {
	                  "locationName": "networkInfo",
	                  "type": "structure",
	                  "members": {
	                    "NetworkPerformance": {
	                      "locationName": "networkPerformance"
	                    },
	                    "MaximumNetworkInterfaces": {
	                      "locationName": "maximumNetworkInterfaces",
	                      "type": "integer"
	                    },
	                    "MaximumNetworkCards": {
	                      "locationName": "maximumNetworkCards",
	                      "type": "integer"
	                    },
	                    "DefaultNetworkCardIndex": {
	                      "locationName": "defaultNetworkCardIndex",
	                      "type": "integer"
	                    },
	                    "NetworkCards": {
	                      "locationName": "networkCards",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item",
	                        "type": "structure",
	                        "members": {
	                          "NetworkCardIndex": {
	                            "locationName": "networkCardIndex",
	                            "type": "integer"
	                          },
	                          "NetworkPerformance": {
	                            "locationName": "networkPerformance"
	                          },
	                          "MaximumNetworkInterfaces": {
	                            "locationName": "maximumNetworkInterfaces",
	                            "type": "integer"
	                          }
	                        }
	                      }
	                    },
	                    "Ipv4AddressesPerInterface": {
	                      "locationName": "ipv4AddressesPerInterface",
	                      "type": "integer"
	                    },
	                    "Ipv6AddressesPerInterface": {
	                      "locationName": "ipv6AddressesPerInterface",
	                      "type": "integer"
	                    },
	                    "Ipv6Supported": {
	                      "locationName": "ipv6Supported",
	                      "type": "boolean"
	                    },
	                    "EnaSupport": {
	                      "locationName": "enaSupport"
	                    },
	                    "EfaSupported": {
	                      "locationName": "efaSupported",
	                      "type": "boolean"
	                    },
	                    "EfaInfo": {
	                      "locationName": "efaInfo",
	                      "type": "structure",
	                      "members": {
	                        "MaximumEfaInterfaces": {
	                          "locationName": "maximumEfaInterfaces",
	                          "type": "integer"
	                        }
	                      }
	                    },
	                    "EncryptionInTransitSupported": {
	                      "locationName": "encryptionInTransitSupported",
	                      "type": "boolean"
	                    }
	                  }
	                },
	                "GpuInfo": {
	                  "locationName": "gpuInfo",
	                  "type": "structure",
	                  "members": {
	                    "Gpus": {
	                      "locationName": "gpus",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item",
	                        "type": "structure",
	                        "members": {
	                          "Name": {
	                            "locationName": "name"
	                          },
	                          "Manufacturer": {
	                            "locationName": "manufacturer"
	                          },
	                          "Count": {
	                            "locationName": "count",
	                            "type": "integer"
	                          },
	                          "MemoryInfo": {
	                            "locationName": "memoryInfo",
	                            "type": "structure",
	                            "members": {
	                              "SizeInMiB": {
	                                "locationName": "sizeInMiB",
	                                "type": "integer"
	                              }
	                            }
	                          }
	                        }
	                      }
	                    },
	                    "TotalGpuMemoryInMiB": {
	                      "locationName": "totalGpuMemoryInMiB",
	                      "type": "integer"
	                    }
	                  }
	                },
	                "FpgaInfo": {
	                  "locationName": "fpgaInfo",
	                  "type": "structure",
	                  "members": {
	                    "Fpgas": {
	                      "locationName": "fpgas",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item",
	                        "type": "structure",
	                        "members": {
	                          "Name": {
	                            "locationName": "name"
	                          },
	                          "Manufacturer": {
	                            "locationName": "manufacturer"
	                          },
	                          "Count": {
	                            "locationName": "count",
	                            "type": "integer"
	                          },
	                          "MemoryInfo": {
	                            "locationName": "memoryInfo",
	                            "type": "structure",
	                            "members": {
	                              "SizeInMiB": {
	                                "locationName": "sizeInMiB",
	                                "type": "integer"
	                              }
	                            }
	                          }
	                        }
	                      }
	                    },
	                    "TotalFpgaMemoryInMiB": {
	                      "locationName": "totalFpgaMemoryInMiB",
	                      "type": "integer"
	                    }
	                  }
	                },
	                "PlacementGroupInfo": {
	                  "locationName": "placementGroupInfo",
	                  "type": "structure",
	                  "members": {
	                    "SupportedStrategies": {
	                      "locationName": "supportedStrategies",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item"
	                      }
	                    }
	                  }
	                },
	                "InferenceAcceleratorInfo": {
	                  "locationName": "inferenceAcceleratorInfo",
	                  "type": "structure",
	                  "members": {
	                    "Accelerators": {
	                      "locationName": "item",
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "members": {
	                          "Count": {
	                            "locationName": "count",
	                            "type": "integer"
	                          },
	                          "Name": {
	                            "locationName": "name"
	                          },
	                          "Manufacturer": {
	                            "locationName": "manufacturer"
	                          }
	                        }
	                      }
	                    }
	                  }
	                },
	                "HibernationSupported": {
	                  "locationName": "hibernationSupported",
	                  "type": "boolean"
	                },
	                "BurstablePerformanceSupported": {
	                  "locationName": "burstablePerformanceSupported",
	                  "type": "boolean"
	                },
	                "DedicatedHostsSupported": {
	                  "locationName": "dedicatedHostsSupported",
	                  "type": "boolean"
	                },
	                "AutoRecoverySupported": {
	                  "locationName": "autoRecoverySupported",
	                  "type": "boolean"
	                },
	                "SupportedBootModes": {
	                  "locationName": "supportedBootModes",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item"
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "InstanceIds": {
	            "shape": "Sw4",
	            "locationName": "InstanceId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Reservations": {
	            "locationName": "reservationSet",
	            "type": "list",
	            "member": {
	              "shape": "S170",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeInternetGateways": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InternetGatewayIds": {
	            "locationName": "internetGatewayId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InternetGateways": {
	            "locationName": "internetGatewaySet",
	            "type": "list",
	            "member": {
	              "shape": "Sd1",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeIpamPools": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "IpamPoolIds": {
	            "shape": "Se",
	            "locationName": "IpamPoolId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "IpamPools": {
	            "locationName": "ipamPoolSet",
	            "type": "list",
	            "member": {
	              "shape": "Sdj",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribeIpamScopes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "IpamScopeIds": {
	            "shape": "Se",
	            "locationName": "IpamScopeId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "IpamScopes": {
	            "locationName": "ipamScopeSet",
	            "type": "list",
	            "member": {
	              "shape": "Sdq",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribeIpams": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "IpamIds": {
	            "shape": "Se",
	            "locationName": "IpamId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "Ipams": {
	            "locationName": "ipamSet",
	            "type": "list",
	            "member": {
	              "shape": "Sd6",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribeIpv6Pools": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PoolIds": {
	            "locationName": "PoolId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Ipv6Pools": {
	            "locationName": "ipv6PoolSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "PoolId": {
	                  "locationName": "poolId"
	                },
	                "Description": {
	                  "locationName": "description"
	                },
	                "PoolCidrBlocks": {
	                  "locationName": "poolCidrBlockSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "Cidr": {
	                        "locationName": "poolCidrBlock"
	                      }
	                    }
	                  }
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeKeyPairs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "KeyNames": {
	            "locationName": "KeyName",
	            "type": "list",
	            "member": {
	              "locationName": "KeyName"
	            }
	          },
	          "KeyPairIds": {
	            "locationName": "KeyPairId",
	            "type": "list",
	            "member": {
	              "locationName": "KeyPairId"
	            }
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "IncludePublicKey": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyPairs": {
	            "locationName": "keySet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "KeyPairId": {
	                  "locationName": "keyPairId"
	                },
	                "KeyFingerprint": {
	                  "locationName": "keyFingerprint"
	                },
	                "KeyName": {
	                  "locationName": "keyName"
	                },
	                "KeyType": {
	                  "locationName": "keyType"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "PublicKey": {
	                  "locationName": "publicKey"
	                },
	                "CreateTime": {
	                  "locationName": "createTime",
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeLaunchTemplateVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "LaunchTemplateId": {},
	          "LaunchTemplateName": {},
	          "Versions": {
	            "shape": "Sr0",
	            "locationName": "LaunchTemplateVersion"
	          },
	          "MinVersion": {},
	          "MaxVersion": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LaunchTemplateVersions": {
	            "locationName": "launchTemplateVersionSet",
	            "type": "list",
	            "member": {
	              "shape": "Sfn",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeLaunchTemplates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "LaunchTemplateIds": {
	            "locationName": "LaunchTemplateId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "LaunchTemplateNames": {
	            "locationName": "LaunchTemplateName",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LaunchTemplates": {
	            "locationName": "launchTemplates",
	            "type": "list",
	            "member": {
	              "shape": "Sfh",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayRouteTableVirtualInterfaceGroupAssociationIds": {
	            "locationName": "LocalGatewayRouteTableVirtualInterfaceGroupAssociationId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayRouteTableVirtualInterfaceGroupAssociations": {
	            "locationName": "localGatewayRouteTableVirtualInterfaceGroupAssociationSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "LocalGatewayRouteTableVirtualInterfaceGroupAssociationId": {
	                  "locationName": "localGatewayRouteTableVirtualInterfaceGroupAssociationId"
	                },
	                "LocalGatewayVirtualInterfaceGroupId": {
	                  "locationName": "localGatewayVirtualInterfaceGroupId"
	                },
	                "LocalGatewayId": {
	                  "locationName": "localGatewayId"
	                },
	                "LocalGatewayRouteTableId": {
	                  "locationName": "localGatewayRouteTableId"
	                },
	                "LocalGatewayRouteTableArn": {
	                  "locationName": "localGatewayRouteTableArn"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeLocalGatewayRouteTableVpcAssociations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayRouteTableVpcAssociationIds": {
	            "locationName": "LocalGatewayRouteTableVpcAssociationId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayRouteTableVpcAssociations": {
	            "locationName": "localGatewayRouteTableVpcAssociationSet",
	            "type": "list",
	            "member": {
	              "shape": "Sgw",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeLocalGatewayRouteTables": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayRouteTableIds": {
	            "locationName": "LocalGatewayRouteTableId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayRouteTables": {
	            "locationName": "localGatewayRouteTableSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "LocalGatewayRouteTableId": {
	                  "locationName": "localGatewayRouteTableId"
	                },
	                "LocalGatewayRouteTableArn": {
	                  "locationName": "localGatewayRouteTableArn"
	                },
	                "LocalGatewayId": {
	                  "locationName": "localGatewayId"
	                },
	                "OutpostArn": {
	                  "locationName": "outpostArn"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeLocalGatewayVirtualInterfaceGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayVirtualInterfaceGroupIds": {
	            "locationName": "LocalGatewayVirtualInterfaceGroupId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayVirtualInterfaceGroups": {
	            "locationName": "localGatewayVirtualInterfaceGroupSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "LocalGatewayVirtualInterfaceGroupId": {
	                  "locationName": "localGatewayVirtualInterfaceGroupId"
	                },
	                "LocalGatewayVirtualInterfaceIds": {
	                  "shape": "S19l",
	                  "locationName": "localGatewayVirtualInterfaceIdSet"
	                },
	                "LocalGatewayId": {
	                  "locationName": "localGatewayId"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeLocalGatewayVirtualInterfaces": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayVirtualInterfaceIds": {
	            "shape": "S19l",
	            "locationName": "LocalGatewayVirtualInterfaceId"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayVirtualInterfaces": {
	            "locationName": "localGatewayVirtualInterfaceSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "LocalGatewayVirtualInterfaceId": {
	                  "locationName": "localGatewayVirtualInterfaceId"
	                },
	                "LocalGatewayId": {
	                  "locationName": "localGatewayId"
	                },
	                "Vlan": {
	                  "locationName": "vlan",
	                  "type": "integer"
	                },
	                "LocalAddress": {
	                  "locationName": "localAddress"
	                },
	                "PeerAddress": {
	                  "locationName": "peerAddress"
	                },
	                "LocalBgpAsn": {
	                  "locationName": "localBgpAsn",
	                  "type": "integer"
	                },
	                "PeerBgpAsn": {
	                  "locationName": "peerBgpAsn",
	                  "type": "integer"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeLocalGateways": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LocalGatewayIds": {
	            "locationName": "LocalGatewayId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LocalGateways": {
	            "locationName": "localGatewaySet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "LocalGatewayId": {
	                  "locationName": "localGatewayId"
	                },
	                "OutpostArn": {
	                  "locationName": "outpostArn"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeManagedPrefixLists": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "PrefixListIds": {
	            "shape": "Se",
	            "locationName": "PrefixListId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "PrefixLists": {
	            "locationName": "prefixListSet",
	            "type": "list",
	            "member": {
	              "shape": "Sh2",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribeMovingAddresses": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "PublicIps": {
	            "shape": "Se",
	            "locationName": "publicIp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MovingAddressStatuses": {
	            "locationName": "movingAddressStatusSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "MoveStatus": {
	                  "locationName": "moveStatus"
	                },
	                "PublicIp": {
	                  "locationName": "publicIp"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeNatGateways": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filter": {
	            "shape": "Sum"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NatGatewayIds": {
	            "locationName": "NatGatewayId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NatGateways": {
	            "locationName": "natGatewaySet",
	            "type": "list",
	            "member": {
	              "shape": "Sh7",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeNetworkAcls": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NetworkAclIds": {
	            "locationName": "NetworkAclId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkAcls": {
	            "locationName": "networkAclSet",
	            "type": "list",
	            "member": {
	              "shape": "She",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeNetworkInsightsAccessScopeAnalyses": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAccessScopeAnalysisIds": {
	            "locationName": "NetworkInsightsAccessScopeAnalysisId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "NetworkInsightsAccessScopeId": {},
	          "AnalysisStartTimeBegin": {
	            "type": "timestamp"
	          },
	          "AnalysisStartTimeEnd": {
	            "type": "timestamp"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAccessScopeAnalyses": {
	            "locationName": "networkInsightsAccessScopeAnalysisSet",
	            "type": "list",
	            "member": {
	              "shape": "S1al",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeNetworkInsightsAccessScopes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAccessScopeIds": {
	            "locationName": "NetworkInsightsAccessScopeId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAccessScopes": {
	            "locationName": "networkInsightsAccessScopeSet",
	            "type": "list",
	            "member": {
	              "shape": "Shz",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeNetworkInsightsAnalyses": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAnalysisIds": {
	            "locationName": "NetworkInsightsAnalysisId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "NetworkInsightsPathId": {},
	          "AnalysisStartTime": {
	            "type": "timestamp"
	          },
	          "AnalysisEndTime": {
	            "type": "timestamp"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAnalyses": {
	            "locationName": "networkInsightsAnalysisSet",
	            "type": "list",
	            "member": {
	              "shape": "S1aw",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeNetworkInsightsPaths": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsPathIds": {
	            "locationName": "NetworkInsightsPathId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsPaths": {
	            "locationName": "networkInsightsPathSet",
	            "type": "list",
	            "member": {
	              "shape": "Sie",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeNetworkInterfaceAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInterfaceId"
	        ],
	        "members": {
	          "Attribute": {
	            "locationName": "attribute"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Attachment": {
	            "shape": "Sil",
	            "locationName": "attachment"
	          },
	          "Description": {
	            "shape": "S9u",
	            "locationName": "description"
	          },
	          "Groups": {
	            "shape": "Sim",
	            "locationName": "groupSet"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "SourceDestCheck": {
	            "shape": "S138",
	            "locationName": "sourceDestCheck"
	          }
	        }
	      }
	    },
	    "DescribeNetworkInterfacePermissions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NetworkInterfacePermissionIds": {
	            "locationName": "NetworkInterfacePermissionId",
	            "type": "list",
	            "member": {}
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInterfacePermissions": {
	            "locationName": "networkInterfacePermissions",
	            "type": "list",
	            "member": {
	              "shape": "Siz",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeNetworkInterfaces": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NetworkInterfaceIds": {
	            "locationName": "NetworkInterfaceId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInterfaces": {
	            "locationName": "networkInterfaceSet",
	            "type": "list",
	            "member": {
	              "shape": "Sij",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribePlacementGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "GroupNames": {
	            "locationName": "groupName",
	            "type": "list",
	            "member": {}
	          },
	          "GroupIds": {
	            "locationName": "GroupId",
	            "type": "list",
	            "member": {
	              "locationName": "GroupId"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PlacementGroups": {
	            "locationName": "placementGroupSet",
	            "type": "list",
	            "member": {
	              "shape": "Sj5",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribePrefixLists": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "PrefixListIds": {
	            "locationName": "PrefixListId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "PrefixLists": {
	            "locationName": "prefixListSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Cidrs": {
	                  "shape": "Se",
	                  "locationName": "cidrSet"
	                },
	                "PrefixListId": {
	                  "locationName": "prefixListId"
	                },
	                "PrefixListName": {
	                  "locationName": "prefixListName"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribePrincipalIdFormat": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Resources": {
	            "locationName": "Resource",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Principals": {
	            "locationName": "principalSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Arn": {
	                  "locationName": "arn"
	                },
	                "Statuses": {
	                  "shape": "Sv4",
	                  "locationName": "statusSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribePublicIpv4Pools": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PoolIds": {
	            "locationName": "PoolId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicIpv4Pools": {
	            "locationName": "publicIpv4PoolSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "PoolId": {
	                  "locationName": "poolId"
	                },
	                "Description": {
	                  "locationName": "description"
	                },
	                "PoolAddressRanges": {
	                  "locationName": "poolAddressRangeSet",
	                  "type": "list",
	                  "member": {
	                    "shape": "S1cn",
	                    "locationName": "item"
	                  }
	                },
	                "TotalAddressCount": {
	                  "locationName": "totalAddressCount",
	                  "type": "integer"
	                },
	                "TotalAvailableAddressCount": {
	                  "locationName": "totalAvailableAddressCount",
	                  "type": "integer"
	                },
	                "NetworkBorderGroup": {
	                  "locationName": "networkBorderGroup"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeRegions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "RegionNames": {
	            "locationName": "RegionName",
	            "type": "list",
	            "member": {
	              "locationName": "RegionName"
	            }
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "AllRegions": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Regions": {
	            "locationName": "regionInfo",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Endpoint": {
	                  "locationName": "regionEndpoint"
	                },
	                "RegionName": {
	                  "locationName": "regionName"
	                },
	                "OptInStatus": {
	                  "locationName": "optInStatus"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeReplaceRootVolumeTasks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReplaceRootVolumeTaskIds": {
	            "locationName": "ReplaceRootVolumeTaskId",
	            "type": "list",
	            "member": {
	              "locationName": "ReplaceRootVolumeTaskId"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReplaceRootVolumeTasks": {
	            "locationName": "replaceRootVolumeTaskSet",
	            "type": "list",
	            "member": {
	              "shape": "Sjb",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeReservedInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "OfferingClass": {},
	          "ReservedInstancesIds": {
	            "shape": "S1d0",
	            "locationName": "ReservedInstancesId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "OfferingType": {
	            "locationName": "offeringType"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReservedInstances": {
	            "locationName": "reservedInstancesSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "Duration": {
	                  "locationName": "duration",
	                  "type": "long"
	                },
	                "End": {
	                  "locationName": "end",
	                  "type": "timestamp"
	                },
	                "FixedPrice": {
	                  "locationName": "fixedPrice",
	                  "type": "float"
	                },
	                "InstanceCount": {
	                  "locationName": "instanceCount",
	                  "type": "integer"
	                },
	                "InstanceType": {
	                  "locationName": "instanceType"
	                },
	                "ProductDescription": {
	                  "locationName": "productDescription"
	                },
	                "ReservedInstancesId": {
	                  "locationName": "reservedInstancesId"
	                },
	                "Start": {
	                  "locationName": "start",
	                  "type": "timestamp"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "UsagePrice": {
	                  "locationName": "usagePrice",
	                  "type": "float"
	                },
	                "CurrencyCode": {
	                  "locationName": "currencyCode"
	                },
	                "InstanceTenancy": {
	                  "locationName": "instanceTenancy"
	                },
	                "OfferingClass": {
	                  "locationName": "offeringClass"
	                },
	                "OfferingType": {
	                  "locationName": "offeringType"
	                },
	                "RecurringCharges": {
	                  "shape": "S1d8",
	                  "locationName": "recurringCharges"
	                },
	                "Scope": {
	                  "locationName": "scope"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeReservedInstancesListings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "ReservedInstancesId": {
	            "locationName": "reservedInstancesId"
	          },
	          "ReservedInstancesListingId": {
	            "locationName": "reservedInstancesListingId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReservedInstancesListings": {
	            "shape": "S6r",
	            "locationName": "reservedInstancesListingsSet"
	          }
	        }
	      }
	    },
	    "DescribeReservedInstancesModifications": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "ReservedInstancesModificationIds": {
	            "locationName": "ReservedInstancesModificationId",
	            "type": "list",
	            "member": {
	              "locationName": "ReservedInstancesModificationId"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "ReservedInstancesModifications": {
	            "locationName": "reservedInstancesModificationsSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ClientToken": {
	                  "locationName": "clientToken"
	                },
	                "CreateDate": {
	                  "locationName": "createDate",
	                  "type": "timestamp"
	                },
	                "EffectiveDate": {
	                  "locationName": "effectiveDate",
	                  "type": "timestamp"
	                },
	                "ModificationResults": {
	                  "locationName": "modificationResultSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "ReservedInstancesId": {
	                        "locationName": "reservedInstancesId"
	                      },
	                      "TargetConfiguration": {
	                        "shape": "S1dm",
	                        "locationName": "targetConfiguration"
	                      }
	                    }
	                  }
	                },
	                "ReservedInstancesIds": {
	                  "locationName": "reservedInstancesSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "ReservedInstancesId": {
	                        "locationName": "reservedInstancesId"
	                      }
	                    }
	                  }
	                },
	                "ReservedInstancesModificationId": {
	                  "locationName": "reservedInstancesModificationId"
	                },
	                "Status": {
	                  "locationName": "status"
	                },
	                "StatusMessage": {
	                  "locationName": "statusMessage"
	                },
	                "UpdateDate": {
	                  "locationName": "updateDate",
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeReservedInstancesOfferings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AvailabilityZone": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "IncludeMarketplace": {
	            "type": "boolean"
	          },
	          "InstanceType": {},
	          "MaxDuration": {
	            "type": "long"
	          },
	          "MaxInstanceCount": {
	            "type": "integer"
	          },
	          "MinDuration": {
	            "type": "long"
	          },
	          "OfferingClass": {},
	          "ProductDescription": {},
	          "ReservedInstancesOfferingIds": {
	            "locationName": "ReservedInstancesOfferingId",
	            "type": "list",
	            "member": {}
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InstanceTenancy": {
	            "locationName": "instanceTenancy"
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "OfferingType": {
	            "locationName": "offeringType"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReservedInstancesOfferings": {
	            "locationName": "reservedInstancesOfferingsSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "Duration": {
	                  "locationName": "duration",
	                  "type": "long"
	                },
	                "FixedPrice": {
	                  "locationName": "fixedPrice",
	                  "type": "float"
	                },
	                "InstanceType": {
	                  "locationName": "instanceType"
	                },
	                "ProductDescription": {
	                  "locationName": "productDescription"
	                },
	                "ReservedInstancesOfferingId": {
	                  "locationName": "reservedInstancesOfferingId"
	                },
	                "UsagePrice": {
	                  "locationName": "usagePrice",
	                  "type": "float"
	                },
	                "CurrencyCode": {
	                  "locationName": "currencyCode"
	                },
	                "InstanceTenancy": {
	                  "locationName": "instanceTenancy"
	                },
	                "Marketplace": {
	                  "locationName": "marketplace",
	                  "type": "boolean"
	                },
	                "OfferingClass": {
	                  "locationName": "offeringClass"
	                },
	                "OfferingType": {
	                  "locationName": "offeringType"
	                },
	                "PricingDetails": {
	                  "locationName": "pricingDetailsSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "Count": {
	                        "locationName": "count",
	                        "type": "integer"
	                      },
	                      "Price": {
	                        "locationName": "price",
	                        "type": "double"
	                      }
	                    }
	                  }
	                },
	                "RecurringCharges": {
	                  "shape": "S1d8",
	                  "locationName": "recurringCharges"
	                },
	                "Scope": {
	                  "locationName": "scope"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeRouteTables": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "RouteTableIds": {
	            "locationName": "RouteTableId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RouteTables": {
	            "locationName": "routeTableSet",
	            "type": "list",
	            "member": {
	              "shape": "Sjs",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeScheduledInstanceAvailability": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FirstSlotStartTimeRange",
	          "Recurrence"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "FirstSlotStartTimeRange": {
	            "type": "structure",
	            "required": [
	              "EarliestTime",
	              "LatestTime"
	            ],
	            "members": {
	              "EarliestTime": {
	                "type": "timestamp"
	              },
	              "LatestTime": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "MaxSlotDurationInHours": {
	            "type": "integer"
	          },
	          "MinSlotDurationInHours": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "Recurrence": {
	            "type": "structure",
	            "members": {
	              "Frequency": {},
	              "Interval": {
	                "type": "integer"
	              },
	              "OccurrenceDays": {
	                "locationName": "OccurrenceDay",
	                "type": "list",
	                "member": {
	                  "locationName": "OccurenceDay",
	                  "type": "integer"
	                }
	              },
	              "OccurrenceRelativeToEnd": {
	                "type": "boolean"
	              },
	              "OccurrenceUnit": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "ScheduledInstanceAvailabilitySet": {
	            "locationName": "scheduledInstanceAvailabilitySet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "AvailableInstanceCount": {
	                  "locationName": "availableInstanceCount",
	                  "type": "integer"
	                },
	                "FirstSlotStartTime": {
	                  "locationName": "firstSlotStartTime",
	                  "type": "timestamp"
	                },
	                "HourlyPrice": {
	                  "locationName": "hourlyPrice"
	                },
	                "InstanceType": {
	                  "locationName": "instanceType"
	                },
	                "MaxTermDurationInDays": {
	                  "locationName": "maxTermDurationInDays",
	                  "type": "integer"
	                },
	                "MinTermDurationInDays": {
	                  "locationName": "minTermDurationInDays",
	                  "type": "integer"
	                },
	                "NetworkPlatform": {
	                  "locationName": "networkPlatform"
	                },
	                "Platform": {
	                  "locationName": "platform"
	                },
	                "PurchaseToken": {
	                  "locationName": "purchaseToken"
	                },
	                "Recurrence": {
	                  "shape": "S1e9",
	                  "locationName": "recurrence"
	                },
	                "SlotDurationInHours": {
	                  "locationName": "slotDurationInHours",
	                  "type": "integer"
	                },
	                "TotalScheduledInstanceHours": {
	                  "locationName": "totalScheduledInstanceHours",
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeScheduledInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "ScheduledInstanceIds": {
	            "locationName": "ScheduledInstanceId",
	            "type": "list",
	            "member": {
	              "locationName": "ScheduledInstanceId"
	            }
	          },
	          "SlotStartTimeRange": {
	            "type": "structure",
	            "members": {
	              "EarliestTime": {
	                "type": "timestamp"
	              },
	              "LatestTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "ScheduledInstanceSet": {
	            "locationName": "scheduledInstanceSet",
	            "type": "list",
	            "member": {
	              "shape": "S1eh",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribeSecurityGroupReferences": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "GroupId": {
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SecurityGroupReferenceSet": {
	            "locationName": "securityGroupReferenceSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "GroupId": {
	                  "locationName": "groupId"
	                },
	                "ReferencingVpcId": {
	                  "locationName": "referencingVpcId"
	                },
	                "VpcPeeringConnectionId": {
	                  "locationName": "vpcPeeringConnectionId"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeSecurityGroupRules": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "SecurityGroupRuleIds": {
	            "shape": "S1eo",
	            "locationName": "SecurityGroupRuleId"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SecurityGroupRules": {
	            "shape": "S5j",
	            "locationName": "securityGroupRuleSet"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeSecurityGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "GroupIds": {
	            "shape": "S4o",
	            "locationName": "GroupId"
	          },
	          "GroupNames": {
	            "shape": "S1es",
	            "locationName": "GroupName"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SecurityGroups": {
	            "locationName": "securityGroupInfo",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Description": {
	                  "locationName": "groupDescription"
	                },
	                "GroupName": {
	                  "locationName": "groupName"
	                },
	                "IpPermissions": {
	                  "shape": "S58",
	                  "locationName": "ipPermissions"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "GroupId": {
	                  "locationName": "groupId"
	                },
	                "IpPermissionsEgress": {
	                  "shape": "S58",
	                  "locationName": "ipPermissionsEgress"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "VpcId": {
	                  "locationName": "vpcId"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeSnapshotAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Attribute",
	          "SnapshotId"
	        ],
	        "members": {
	          "Attribute": {},
	          "SnapshotId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CreateVolumePermissions": {
	            "shape": "S1f0",
	            "locationName": "createVolumePermission"
	          },
	          "ProductCodes": {
	            "shape": "S10k",
	            "locationName": "productCodes"
	          },
	          "SnapshotId": {
	            "locationName": "snapshotId"
	          }
	        }
	      }
	    },
	    "DescribeSnapshotTierStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SnapshotTierStatuses": {
	            "locationName": "snapshotTierStatusSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "SnapshotId": {
	                  "locationName": "snapshotId"
	                },
	                "VolumeId": {
	                  "locationName": "volumeId"
	                },
	                "Status": {
	                  "locationName": "status"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "StorageTier": {
	                  "locationName": "storageTier"
	                },
	                "LastTieringStartTime": {
	                  "locationName": "lastTieringStartTime",
	                  "type": "timestamp"
	                },
	                "LastTieringProgress": {
	                  "locationName": "lastTieringProgress",
	                  "type": "integer"
	                },
	                "LastTieringOperationStatus": {
	                  "locationName": "lastTieringOperationStatus"
	                },
	                "LastTieringOperationStatusDetail": {
	                  "locationName": "lastTieringOperationStatusDetail"
	                },
	                "ArchivalCompleteTime": {
	                  "locationName": "archivalCompleteTime",
	                  "type": "timestamp"
	                },
	                "RestoreExpiryTime": {
	                  "locationName": "restoreExpiryTime",
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeSnapshots": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "OwnerIds": {
	            "shape": "S10p",
	            "locationName": "Owner"
	          },
	          "RestorableByUserIds": {
	            "locationName": "RestorableBy",
	            "type": "list",
	            "member": {}
	          },
	          "SnapshotIds": {
	            "shape": "S1fa",
	            "locationName": "SnapshotId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Snapshots": {
	            "locationName": "snapshotSet",
	            "type": "list",
	            "member": {
	              "shape": "Sk4",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeSpotDatafeedSubscription": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SpotDatafeedSubscription": {
	            "shape": "Skf",
	            "locationName": "spotDatafeedSubscription"
	          }
	        }
	      }
	    },
	    "DescribeSpotFleetInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SpotFleetRequestId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "SpotFleetRequestId": {
	            "locationName": "spotFleetRequestId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ActiveInstances": {
	            "shape": "Szn",
	            "locationName": "activeInstanceSet"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "SpotFleetRequestId": {
	            "locationName": "spotFleetRequestId"
	          }
	        }
	      }
	    },
	    "DescribeSpotFleetRequestHistory": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SpotFleetRequestId",
	          "StartTime"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "EventType": {
	            "locationName": "eventType"
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "SpotFleetRequestId": {
	            "locationName": "spotFleetRequestId"
	          },
	          "StartTime": {
	            "locationName": "startTime",
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HistoryRecords": {
	            "locationName": "historyRecordSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "EventInformation": {
	                  "shape": "Szk",
	                  "locationName": "eventInformation"
	                },
	                "EventType": {
	                  "locationName": "eventType"
	                },
	                "Timestamp": {
	                  "locationName": "timestamp",
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "LastEvaluatedTime": {
	            "locationName": "lastEvaluatedTime",
	            "type": "timestamp"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "SpotFleetRequestId": {
	            "locationName": "spotFleetRequestId"
	          },
	          "StartTime": {
	            "locationName": "startTime",
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeSpotFleetRequests": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "SpotFleetRequestIds": {
	            "shape": "S73",
	            "locationName": "spotFleetRequestId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "SpotFleetRequestConfigs": {
	            "locationName": "spotFleetRequestConfigSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ActivityStatus": {
	                  "locationName": "activityStatus"
	                },
	                "CreateTime": {
	                  "locationName": "createTime",
	                  "type": "timestamp"
	                },
	                "SpotFleetRequestConfig": {
	                  "shape": "S1ft",
	                  "locationName": "spotFleetRequestConfig"
	                },
	                "SpotFleetRequestId": {
	                  "locationName": "spotFleetRequestId"
	                },
	                "SpotFleetRequestState": {
	                  "locationName": "spotFleetRequestState"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeSpotInstanceRequests": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "SpotInstanceRequestIds": {
	            "shape": "S7e",
	            "locationName": "SpotInstanceRequestId"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SpotInstanceRequests": {
	            "shape": "S1gl",
	            "locationName": "spotInstanceRequestSet"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeSpotPriceHistory": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "AvailabilityZone": {
	            "locationName": "availabilityZone"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "EndTime": {
	            "locationName": "endTime",
	            "type": "timestamp"
	          },
	          "InstanceTypes": {
	            "locationName": "InstanceType",
	            "type": "list",
	            "member": {}
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "ProductDescriptions": {
	            "locationName": "ProductDescription",
	            "type": "list",
	            "member": {}
	          },
	          "StartTime": {
	            "locationName": "startTime",
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "SpotPriceHistory": {
	            "locationName": "spotPriceHistorySet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "InstanceType": {
	                  "locationName": "instanceType"
	                },
	                "ProductDescription": {
	                  "locationName": "productDescription"
	                },
	                "SpotPrice": {
	                  "locationName": "spotPrice"
	                },
	                "Timestamp": {
	                  "locationName": "timestamp",
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeStaleSecurityGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "VpcId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "StaleSecurityGroupSet": {
	            "locationName": "staleSecurityGroupSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Description": {
	                  "locationName": "description"
	                },
	                "GroupId": {
	                  "locationName": "groupId"
	                },
	                "GroupName": {
	                  "locationName": "groupName"
	                },
	                "StaleIpPermissions": {
	                  "shape": "S1h3",
	                  "locationName": "staleIpPermissions"
	                },
	                "StaleIpPermissionsEgress": {
	                  "shape": "S1h3",
	                  "locationName": "staleIpPermissionsEgress"
	                },
	                "VpcId": {
	                  "locationName": "vpcId"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeStoreImageTasks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ImageIds": {
	            "locationName": "ImageId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StoreImageTaskResults": {
	            "locationName": "storeImageTaskResultSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AmiId": {
	                  "locationName": "amiId"
	                },
	                "TaskStartTime": {
	                  "locationName": "taskStartTime",
	                  "type": "timestamp"
	                },
	                "Bucket": {
	                  "locationName": "bucket"
	                },
	                "S3objectKey": {
	                  "locationName": "s3objectKey"
	                },
	                "ProgressPercentage": {
	                  "locationName": "progressPercentage",
	                  "type": "integer"
	                },
	                "StoreTaskState": {
	                  "locationName": "storeTaskState"
	                },
	                "StoreTaskFailureReason": {
	                  "locationName": "storeTaskFailureReason"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeSubnets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "SubnetIds": {
	            "locationName": "SubnetId",
	            "type": "list",
	            "member": {
	              "locationName": "SubnetId"
	            }
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Subnets": {
	            "locationName": "subnetSet",
	            "type": "list",
	            "member": {
	              "shape": "S99",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTags": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "Tags": {
	            "locationName": "tagSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Key": {
	                  "locationName": "key"
	                },
	                "ResourceId": {
	                  "locationName": "resourceId"
	                },
	                "ResourceType": {
	                  "locationName": "resourceType"
	                },
	                "Value": {
	                  "locationName": "value"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeTrafficMirrorFilters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorFilterIds": {
	            "locationName": "TrafficMirrorFilterId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorFilters": {
	            "locationName": "trafficMirrorFilterSet",
	            "type": "list",
	            "member": {
	              "shape": "Sky",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTrafficMirrorSessions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorSessionIds": {
	            "locationName": "TrafficMirrorSessionId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorSessions": {
	            "locationName": "trafficMirrorSessionSet",
	            "type": "list",
	            "member": {
	              "shape": "Sld",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTrafficMirrorTargets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorTargetIds": {
	            "locationName": "TrafficMirrorTargetId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorTargets": {
	            "locationName": "trafficMirrorTargetSet",
	            "type": "list",
	            "member": {
	              "shape": "Slg",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTransitGatewayAttachments": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayAttachmentIds": {
	            "shape": "S1i1"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayAttachments": {
	            "locationName": "transitGatewayAttachments",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "TransitGatewayAttachmentId": {
	                  "locationName": "transitGatewayAttachmentId"
	                },
	                "TransitGatewayId": {
	                  "locationName": "transitGatewayId"
	                },
	                "TransitGatewayOwnerId": {
	                  "locationName": "transitGatewayOwnerId"
	                },
	                "ResourceOwnerId": {
	                  "locationName": "resourceOwnerId"
	                },
	                "ResourceType": {
	                  "locationName": "resourceType"
	                },
	                "ResourceId": {
	                  "locationName": "resourceId"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "Association": {
	                  "locationName": "association",
	                  "type": "structure",
	                  "members": {
	                    "TransitGatewayRouteTableId": {
	                      "locationName": "transitGatewayRouteTableId"
	                    },
	                    "State": {
	                      "locationName": "state"
	                    }
	                  }
	                },
	                "CreationTime": {
	                  "locationName": "creationTime",
	                  "type": "timestamp"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTransitGatewayConnectPeers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayConnectPeerIds": {
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayConnectPeers": {
	            "locationName": "transitGatewayConnectPeerSet",
	            "type": "list",
	            "member": {
	              "shape": "Sm4",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTransitGatewayConnects": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayAttachmentIds": {
	            "shape": "S1i1"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayConnects": {
	            "locationName": "transitGatewayConnectSet",
	            "type": "list",
	            "member": {
	              "shape": "Sly",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTransitGatewayMulticastDomains": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomainIds": {
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomains": {
	            "locationName": "transitGatewayMulticastDomains",
	            "type": "list",
	            "member": {
	              "shape": "Smh",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTransitGatewayPeeringAttachments": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayAttachmentIds": {
	            "shape": "S1i1"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayPeeringAttachments": {
	            "locationName": "transitGatewayPeeringAttachments",
	            "type": "list",
	            "member": {
	              "shape": "Sn",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTransitGatewayRouteTables": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayRouteTableIds": {
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayRouteTables": {
	            "locationName": "transitGatewayRouteTables",
	            "type": "list",
	            "member": {
	              "shape": "Sn1",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTransitGatewayVpcAttachments": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayAttachmentIds": {
	            "shape": "S1i1"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayVpcAttachments": {
	            "locationName": "transitGatewayVpcAttachments",
	            "type": "list",
	            "member": {
	              "shape": "Sw",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTransitGateways": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayIds": {
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGateways": {
	            "locationName": "transitGatewaySet",
	            "type": "list",
	            "member": {
	              "shape": "Slr",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeTrunkInterfaceAssociations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AssociationIds": {
	            "locationName": "AssociationId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InterfaceAssociations": {
	            "locationName": "interfaceAssociationSet",
	            "type": "list",
	            "member": {
	              "shape": "S4c",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeVolumeAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Attribute",
	          "VolumeId"
	        ],
	        "members": {
	          "Attribute": {},
	          "VolumeId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AutoEnableIO": {
	            "shape": "S138",
	            "locationName": "autoEnableIO"
	          },
	          "ProductCodes": {
	            "shape": "S10k",
	            "locationName": "productCodes"
	          },
	          "VolumeId": {
	            "locationName": "volumeId"
	          }
	        }
	      }
	    },
	    "DescribeVolumeStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "VolumeIds": {
	            "shape": "S1j5",
	            "locationName": "VolumeId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "VolumeStatuses": {
	            "locationName": "volumeStatusSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Actions": {
	                  "locationName": "actionsSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "Code": {
	                        "locationName": "code"
	                      },
	                      "Description": {
	                        "locationName": "description"
	                      },
	                      "EventId": {
	                        "locationName": "eventId"
	                      },
	                      "EventType": {
	                        "locationName": "eventType"
	                      }
	                    }
	                  }
	                },
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "OutpostArn": {
	                  "locationName": "outpostArn"
	                },
	                "Events": {
	                  "locationName": "eventsSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "Description": {
	                        "locationName": "description"
	                      },
	                      "EventId": {
	                        "locationName": "eventId"
	                      },
	                      "EventType": {
	                        "locationName": "eventType"
	                      },
	                      "NotAfter": {
	                        "locationName": "notAfter",
	                        "type": "timestamp"
	                      },
	                      "NotBefore": {
	                        "locationName": "notBefore",
	                        "type": "timestamp"
	                      },
	                      "InstanceId": {
	                        "locationName": "instanceId"
	                      }
	                    }
	                  }
	                },
	                "VolumeId": {
	                  "locationName": "volumeId"
	                },
	                "VolumeStatus": {
	                  "locationName": "volumeStatus",
	                  "type": "structure",
	                  "members": {
	                    "Details": {
	                      "locationName": "details",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item",
	                        "type": "structure",
	                        "members": {
	                          "Name": {
	                            "locationName": "name"
	                          },
	                          "Status": {
	                            "locationName": "status"
	                          }
	                        }
	                      }
	                    },
	                    "Status": {
	                      "locationName": "status"
	                    }
	                  }
	                },
	                "AttachmentStatuses": {
	                  "locationName": "attachmentStatuses",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "IoPerformance": {
	                        "locationName": "ioPerformance"
	                      },
	                      "InstanceId": {
	                        "locationName": "instanceId"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeVolumes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "VolumeIds": {
	            "shape": "S1j5",
	            "locationName": "VolumeId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Volumes": {
	            "locationName": "volumeSet",
	            "type": "list",
	            "member": {
	              "shape": "Sn7",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeVolumesModifications": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "VolumeIds": {
	            "shape": "S1j5",
	            "locationName": "VolumeId"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumesModifications": {
	            "locationName": "volumeModificationSet",
	            "type": "list",
	            "member": {
	              "shape": "S1jq",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeVpcAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Attribute",
	          "VpcId"
	        ],
	        "members": {
	          "Attribute": {},
	          "VpcId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpcId": {
	            "locationName": "vpcId"
	          },
	          "EnableDnsHostnames": {
	            "shape": "S138",
	            "locationName": "enableDnsHostnames"
	          },
	          "EnableDnsSupport": {
	            "shape": "S138",
	            "locationName": "enableDnsSupport"
	          }
	        }
	      }
	    },
	    "DescribeVpcClassicLink": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VpcIds": {
	            "shape": "S1jw",
	            "locationName": "VpcId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Vpcs": {
	            "locationName": "vpcSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ClassicLinkEnabled": {
	                  "locationName": "classicLinkEnabled",
	                  "type": "boolean"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "VpcId": {
	                  "locationName": "vpcId"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeVpcClassicLinkDnsSupport": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "VpcIds": {
	            "shape": "S1jw"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "Vpcs": {
	            "locationName": "vpcs",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ClassicLinkDnsSupported": {
	                  "locationName": "classicLinkDnsSupported",
	                  "type": "boolean"
	                },
	                "VpcId": {
	                  "locationName": "vpcId"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeVpcEndpointConnectionNotifications": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ConnectionNotificationId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConnectionNotificationSet": {
	            "locationName": "connectionNotificationSet",
	            "type": "list",
	            "member": {
	              "shape": "Snv",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeVpcEndpointConnections": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpcEndpointConnections": {
	            "locationName": "vpcEndpointConnectionSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ServiceId": {
	                  "locationName": "serviceId"
	                },
	                "VpcEndpointId": {
	                  "locationName": "vpcEndpointId"
	                },
	                "VpcEndpointOwner": {
	                  "locationName": "vpcEndpointOwner"
	                },
	                "VpcEndpointState": {
	                  "locationName": "vpcEndpointState"
	                },
	                "CreationTimestamp": {
	                  "locationName": "creationTimestamp",
	                  "type": "timestamp"
	                },
	                "DnsEntries": {
	                  "shape": "Snq",
	                  "locationName": "dnsEntrySet"
	                },
	                "NetworkLoadBalancerArns": {
	                  "shape": "Se",
	                  "locationName": "networkLoadBalancerArnSet"
	                },
	                "GatewayLoadBalancerArns": {
	                  "shape": "Se",
	                  "locationName": "gatewayLoadBalancerArnSet"
	                },
	                "IpAddressType": {
	                  "locationName": "ipAddressType"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeVpcEndpointServiceConfigurations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ServiceIds": {
	            "shape": "Stg",
	            "locationName": "ServiceId"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceConfigurations": {
	            "locationName": "serviceConfigurationSet",
	            "type": "list",
	            "member": {
	              "shape": "So0",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeVpcEndpointServicePermissions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ServiceId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AllowedPrincipals": {
	            "locationName": "allowedPrincipals",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "PrincipalType": {
	                  "locationName": "principalType"
	                },
	                "Principal": {
	                  "locationName": "principal"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeVpcEndpointServices": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ServiceNames": {
	            "shape": "Se",
	            "locationName": "ServiceName"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceNames": {
	            "shape": "Se",
	            "locationName": "serviceNameSet"
	          },
	          "ServiceDetails": {
	            "locationName": "serviceDetailSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ServiceName": {
	                  "locationName": "serviceName"
	                },
	                "ServiceId": {
	                  "locationName": "serviceId"
	                },
	                "ServiceType": {
	                  "shape": "So1",
	                  "locationName": "serviceType"
	                },
	                "AvailabilityZones": {
	                  "shape": "Se",
	                  "locationName": "availabilityZoneSet"
	                },
	                "Owner": {
	                  "locationName": "owner"
	                },
	                "BaseEndpointDnsNames": {
	                  "shape": "Se",
	                  "locationName": "baseEndpointDnsNameSet"
	                },
	                "PrivateDnsName": {
	                  "locationName": "privateDnsName"
	                },
	                "PrivateDnsNames": {
	                  "locationName": "privateDnsNameSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "PrivateDnsName": {
	                        "locationName": "privateDnsName"
	                      }
	                    }
	                  }
	                },
	                "VpcEndpointPolicySupported": {
	                  "locationName": "vpcEndpointPolicySupported",
	                  "type": "boolean"
	                },
	                "AcceptanceRequired": {
	                  "locationName": "acceptanceRequired",
	                  "type": "boolean"
	                },
	                "ManagesVpcEndpoints": {
	                  "locationName": "managesVpcEndpoints",
	                  "type": "boolean"
	                },
	                "PayerResponsibility": {
	                  "locationName": "payerResponsibility"
	                },
	                "Tags": {
	                  "shape": "Ss",
	                  "locationName": "tagSet"
	                },
	                "PrivateDnsNameVerificationState": {
	                  "locationName": "privateDnsNameVerificationState"
	                },
	                "SupportedIpAddressTypes": {
	                  "shape": "So5",
	                  "locationName": "supportedIpAddressTypeSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeVpcEndpoints": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "VpcEndpointIds": {
	            "shape": "S13",
	            "locationName": "VpcEndpointId"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpcEndpoints": {
	            "locationName": "vpcEndpointSet",
	            "type": "list",
	            "member": {
	              "shape": "Snl",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeVpcPeeringConnections": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VpcPeeringConnectionIds": {
	            "locationName": "VpcPeeringConnectionId",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpcPeeringConnections": {
	            "locationName": "vpcPeeringConnectionSet",
	            "type": "list",
	            "member": {
	              "shape": "S1c",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeVpcs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "VpcIds": {
	            "locationName": "VpcId",
	            "type": "list",
	            "member": {
	              "locationName": "VpcId"
	            }
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Vpcs": {
	            "locationName": "vpcSet",
	            "type": "list",
	            "member": {
	              "shape": "S9h",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "DescribeVpnConnections": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "VpnConnectionIds": {
	            "locationName": "VpnConnectionId",
	            "type": "list",
	            "member": {
	              "locationName": "VpnConnectionId"
	            }
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpnConnections": {
	            "locationName": "vpnConnectionSet",
	            "type": "list",
	            "member": {
	              "shape": "Sox",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DescribeVpnGateways": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "VpnGatewayIds": {
	            "locationName": "VpnGatewayId",
	            "type": "list",
	            "member": {
	              "locationName": "VpnGatewayId"
	            }
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpnGateways": {
	            "locationName": "vpnGatewaySet",
	            "type": "list",
	            "member": {
	              "shape": "Spr",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "DetachClassicLinkVpc": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "VpcId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DetachInternetGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InternetGatewayId",
	          "VpcId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InternetGatewayId": {
	            "locationName": "internetGatewayId"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          }
	        }
	      }
	    },
	    "DetachNetworkInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AttachmentId"
	        ],
	        "members": {
	          "AttachmentId": {
	            "locationName": "attachmentId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Force": {
	            "locationName": "force",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DetachVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeId"
	        ],
	        "members": {
	          "Device": {},
	          "Force": {
	            "type": "boolean"
	          },
	          "InstanceId": {},
	          "VolumeId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4w"
	      }
	    },
	    "DetachVpnGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId",
	          "VpnGatewayId"
	        ],
	        "members": {
	          "VpcId": {},
	          "VpnGatewayId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DisableEbsEncryptionByDefault": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EbsEncryptionByDefault": {
	            "locationName": "ebsEncryptionByDefault",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DisableFastLaunch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ImageId"
	        ],
	        "members": {
	          "ImageId": {},
	          "Force": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ImageId": {
	            "locationName": "imageId"
	          },
	          "ResourceType": {
	            "locationName": "resourceType"
	          },
	          "SnapshotConfiguration": {
	            "shape": "Sz6",
	            "locationName": "snapshotConfiguration"
	          },
	          "LaunchTemplate": {
	            "shape": "Sz7",
	            "locationName": "launchTemplate"
	          },
	          "MaxParallelLaunches": {
	            "locationName": "maxParallelLaunches",
	            "type": "integer"
	          },
	          "OwnerId": {
	            "locationName": "ownerId"
	          },
	          "State": {
	            "locationName": "state"
	          },
	          "StateTransitionReason": {
	            "locationName": "stateTransitionReason"
	          },
	          "StateTransitionTime": {
	            "locationName": "stateTransitionTime",
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DisableFastSnapshotRestores": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AvailabilityZones",
	          "SourceSnapshotIds"
	        ],
	        "members": {
	          "AvailabilityZones": {
	            "shape": "S1lo",
	            "locationName": "AvailabilityZone"
	          },
	          "SourceSnapshotIds": {
	            "shape": "S1fa",
	            "locationName": "SourceSnapshotId"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Successful": {
	            "locationName": "successful",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "SnapshotId": {
	                  "locationName": "snapshotId"
	                },
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "StateTransitionReason": {
	                  "locationName": "stateTransitionReason"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "OwnerAlias": {
	                  "locationName": "ownerAlias"
	                },
	                "EnablingTime": {
	                  "locationName": "enablingTime",
	                  "type": "timestamp"
	                },
	                "OptimizingTime": {
	                  "locationName": "optimizingTime",
	                  "type": "timestamp"
	                },
	                "EnabledTime": {
	                  "locationName": "enabledTime",
	                  "type": "timestamp"
	                },
	                "DisablingTime": {
	                  "locationName": "disablingTime",
	                  "type": "timestamp"
	                },
	                "DisabledTime": {
	                  "locationName": "disabledTime",
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "Unsuccessful": {
	            "locationName": "unsuccessful",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "SnapshotId": {
	                  "locationName": "snapshotId"
	                },
	                "FastSnapshotRestoreStateErrors": {
	                  "locationName": "fastSnapshotRestoreStateErrorSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "AvailabilityZone": {
	                        "locationName": "availabilityZone"
	                      },
	                      "Error": {
	                        "locationName": "error",
	                        "type": "structure",
	                        "members": {
	                          "Code": {
	                            "locationName": "code"
	                          },
	                          "Message": {
	                            "locationName": "message"
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DisableImageDeprecation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ImageId"
	        ],
	        "members": {
	          "ImageId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DisableIpamOrganizationAdminAccount": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DelegatedAdminAccountId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "DelegatedAdminAccountId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Success": {
	            "locationName": "success",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DisableSerialConsoleAccess": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SerialConsoleAccessEnabled": {
	            "locationName": "serialConsoleAccessEnabled",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DisableTransitGatewayRouteTablePropagation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId",
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "TransitGatewayAttachmentId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Propagation": {
	            "shape": "S1m5",
	            "locationName": "propagation"
	          }
	        }
	      }
	    },
	    "DisableVgwRoutePropagation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayId",
	          "RouteTableId"
	        ],
	        "members": {
	          "GatewayId": {},
	          "RouteTableId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DisableVpcClassicLink": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DisableVpcClassicLinkDnsSupport": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "VpcId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DisassociateAddress": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AssociationId": {},
	          "PublicIp": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DisassociateClientVpnTargetNetwork": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId",
	          "AssociationId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "AssociationId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationId": {
	            "locationName": "associationId"
	          },
	          "Status": {
	            "shape": "S2y",
	            "locationName": "status"
	          }
	        }
	      }
	    },
	    "DisassociateEnclaveCertificateIamRole": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CertificateArn": {},
	          "RoleArn": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DisassociateIamInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationId"
	        ],
	        "members": {
	          "AssociationId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IamInstanceProfileAssociation": {
	            "shape": "S38",
	            "locationName": "iamInstanceProfileAssociation"
	          }
	        }
	      }
	    },
	    "DisassociateInstanceEventWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceEventWindowId",
	          "AssociationTarget"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceEventWindowId": {},
	          "AssociationTarget": {
	            "type": "structure",
	            "members": {
	              "InstanceIds": {
	                "shape": "S3e",
	                "locationName": "InstanceId"
	              },
	              "InstanceTags": {
	                "shape": "Ss",
	                "locationName": "InstanceTag"
	              },
	              "DedicatedHostIds": {
	                "shape": "S3f",
	                "locationName": "DedicatedHostId"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceEventWindow": {
	            "shape": "S3i",
	            "locationName": "instanceEventWindow"
	          }
	        }
	      }
	    },
	    "DisassociateRouteTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationId"
	        ],
	        "members": {
	          "AssociationId": {
	            "locationName": "associationId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DisassociateSubnetCidrBlock": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationId"
	        ],
	        "members": {
	          "AssociationId": {
	            "locationName": "associationId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Ipv6CidrBlockAssociation": {
	            "shape": "S3y",
	            "locationName": "ipv6CidrBlockAssociation"
	          },
	          "SubnetId": {
	            "locationName": "subnetId"
	          }
	        }
	      }
	    },
	    "DisassociateTransitGatewayMulticastDomain": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomainId": {},
	          "TransitGatewayAttachmentId": {},
	          "SubnetIds": {
	            "shape": "S43"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Associations": {
	            "shape": "Sg",
	            "locationName": "associations"
	          }
	        }
	      }
	    },
	    "DisassociateTransitGatewayRouteTable": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId",
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "TransitGatewayAttachmentId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Association": {
	            "shape": "S48",
	            "locationName": "association"
	          }
	        }
	      }
	    },
	    "DisassociateTrunkInterface": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationId"
	        ],
	        "members": {
	          "AssociationId": {},
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          }
	        }
	      }
	    },
	    "DisassociateVpcCidrBlock": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationId"
	        ],
	        "members": {
	          "AssociationId": {
	            "locationName": "associationId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Ipv6CidrBlockAssociation": {
	            "shape": "S4j",
	            "locationName": "ipv6CidrBlockAssociation"
	          },
	          "CidrBlockAssociation": {
	            "shape": "S4m",
	            "locationName": "cidrBlockAssociation"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          }
	        }
	      }
	    },
	    "EnableEbsEncryptionByDefault": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EbsEncryptionByDefault": {
	            "locationName": "ebsEncryptionByDefault",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "EnableFastLaunch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ImageId"
	        ],
	        "members": {
	          "ImageId": {},
	          "ResourceType": {},
	          "SnapshotConfiguration": {
	            "type": "structure",
	            "members": {
	              "TargetResourceCount": {
	                "type": "integer"
	              }
	            }
	          },
	          "LaunchTemplate": {
	            "type": "structure",
	            "required": [
	              "Version"
	            ],
	            "members": {
	              "LaunchTemplateId": {},
	              "LaunchTemplateName": {},
	              "Version": {}
	            }
	          },
	          "MaxParallelLaunches": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ImageId": {
	            "locationName": "imageId"
	          },
	          "ResourceType": {
	            "locationName": "resourceType"
	          },
	          "SnapshotConfiguration": {
	            "shape": "Sz6",
	            "locationName": "snapshotConfiguration"
	          },
	          "LaunchTemplate": {
	            "shape": "Sz7",
	            "locationName": "launchTemplate"
	          },
	          "MaxParallelLaunches": {
	            "locationName": "maxParallelLaunches",
	            "type": "integer"
	          },
	          "OwnerId": {
	            "locationName": "ownerId"
	          },
	          "State": {
	            "locationName": "state"
	          },
	          "StateTransitionReason": {
	            "locationName": "stateTransitionReason"
	          },
	          "StateTransitionTime": {
	            "locationName": "stateTransitionTime",
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "EnableFastSnapshotRestores": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AvailabilityZones",
	          "SourceSnapshotIds"
	        ],
	        "members": {
	          "AvailabilityZones": {
	            "shape": "S1lo",
	            "locationName": "AvailabilityZone"
	          },
	          "SourceSnapshotIds": {
	            "shape": "S1fa",
	            "locationName": "SourceSnapshotId"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Successful": {
	            "locationName": "successful",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "SnapshotId": {
	                  "locationName": "snapshotId"
	                },
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "State": {
	                  "locationName": "state"
	                },
	                "StateTransitionReason": {
	                  "locationName": "stateTransitionReason"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                },
	                "OwnerAlias": {
	                  "locationName": "ownerAlias"
	                },
	                "EnablingTime": {
	                  "locationName": "enablingTime",
	                  "type": "timestamp"
	                },
	                "OptimizingTime": {
	                  "locationName": "optimizingTime",
	                  "type": "timestamp"
	                },
	                "EnabledTime": {
	                  "locationName": "enabledTime",
	                  "type": "timestamp"
	                },
	                "DisablingTime": {
	                  "locationName": "disablingTime",
	                  "type": "timestamp"
	                },
	                "DisabledTime": {
	                  "locationName": "disabledTime",
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "Unsuccessful": {
	            "locationName": "unsuccessful",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "SnapshotId": {
	                  "locationName": "snapshotId"
	                },
	                "FastSnapshotRestoreStateErrors": {
	                  "locationName": "fastSnapshotRestoreStateErrorSet",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "AvailabilityZone": {
	                        "locationName": "availabilityZone"
	                      },
	                      "Error": {
	                        "locationName": "error",
	                        "type": "structure",
	                        "members": {
	                          "Code": {
	                            "locationName": "code"
	                          },
	                          "Message": {
	                            "locationName": "message"
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "EnableImageDeprecation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ImageId",
	          "DeprecateAt"
	        ],
	        "members": {
	          "ImageId": {},
	          "DeprecateAt": {
	            "type": "timestamp"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "EnableIpamOrganizationAdminAccount": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DelegatedAdminAccountId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "DelegatedAdminAccountId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Success": {
	            "locationName": "success",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "EnableSerialConsoleAccess": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SerialConsoleAccessEnabled": {
	            "locationName": "serialConsoleAccessEnabled",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "EnableTransitGatewayRouteTablePropagation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId",
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "TransitGatewayAttachmentId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Propagation": {
	            "shape": "S1m5",
	            "locationName": "propagation"
	          }
	        }
	      }
	    },
	    "EnableVgwRoutePropagation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayId",
	          "RouteTableId"
	        ],
	        "members": {
	          "GatewayId": {},
	          "RouteTableId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "EnableVolumeIO": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VolumeId": {
	            "locationName": "volumeId"
	          }
	        }
	      }
	    },
	    "EnableVpcClassicLink": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "EnableVpcClassicLinkDnsSupport": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "VpcId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ExportClientVpnClientCertificateRevocationList": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CertificateRevocationList": {
	            "locationName": "certificateRevocationList"
	          },
	          "Status": {
	            "locationName": "status",
	            "type": "structure",
	            "members": {
	              "Code": {
	                "locationName": "code"
	              },
	              "Message": {
	                "locationName": "message"
	              }
	            }
	          }
	        }
	      }
	    },
	    "ExportClientVpnClientConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientConfiguration": {
	            "locationName": "clientConfiguration"
	          }
	        }
	      }
	    },
	    "ExportImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DiskImageFormat",
	          "ImageId",
	          "S3ExportLocation"
	        ],
	        "members": {
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "Description": {},
	          "DiskImageFormat": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ImageId": {},
	          "S3ExportLocation": {
	            "type": "structure",
	            "required": [
	              "S3Bucket"
	            ],
	            "members": {
	              "S3Bucket": {},
	              "S3Prefix": {}
	            }
	          },
	          "RoleName": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Description": {
	            "locationName": "description"
	          },
	          "DiskImageFormat": {
	            "locationName": "diskImageFormat"
	          },
	          "ExportImageTaskId": {
	            "locationName": "exportImageTaskId"
	          },
	          "ImageId": {
	            "locationName": "imageId"
	          },
	          "RoleName": {
	            "locationName": "roleName"
	          },
	          "Progress": {
	            "locationName": "progress"
	          },
	          "S3ExportLocation": {
	            "shape": "Syt",
	            "locationName": "s3ExportLocation"
	          },
	          "Status": {
	            "locationName": "status"
	          },
	          "StatusMessage": {
	            "locationName": "statusMessage"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tagSet"
	          }
	        }
	      }
	    },
	    "ExportTransitGatewayRoutes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId",
	          "S3Bucket"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "S3Bucket": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "S3Location": {
	            "locationName": "s3Location"
	          }
	        }
	      }
	    },
	    "GetAssociatedEnclaveCertificateIamRoles": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CertificateArn": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociatedRoles": {
	            "locationName": "associatedRoleSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AssociatedRoleArn": {
	                  "locationName": "associatedRoleArn"
	                },
	                "CertificateS3BucketName": {
	                  "locationName": "certificateS3BucketName"
	                },
	                "CertificateS3ObjectKey": {
	                  "locationName": "certificateS3ObjectKey"
	                },
	                "EncryptionKmsKeyId": {
	                  "locationName": "encryptionKmsKeyId"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetAssociatedIpv6PoolCidrs": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PoolId"
	        ],
	        "members": {
	          "PoolId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Ipv6CidrAssociations": {
	            "locationName": "ipv6CidrAssociationSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Ipv6Cidr": {
	                  "locationName": "ipv6Cidr"
	                },
	                "AssociatedResource": {
	                  "locationName": "associatedResource"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetCapacityReservationUsage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CapacityReservationId"
	        ],
	        "members": {
	          "CapacityReservationId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "CapacityReservationId": {
	            "locationName": "capacityReservationId"
	          },
	          "InstanceType": {
	            "locationName": "instanceType"
	          },
	          "TotalInstanceCount": {
	            "locationName": "totalInstanceCount",
	            "type": "integer"
	          },
	          "AvailableInstanceCount": {
	            "locationName": "availableInstanceCount",
	            "type": "integer"
	          },
	          "State": {
	            "locationName": "state"
	          },
	          "InstanceUsages": {
	            "locationName": "instanceUsageSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AccountId": {
	                  "locationName": "accountId"
	                },
	                "UsedInstanceCount": {
	                  "locationName": "usedInstanceCount",
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetCoipPoolUsage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PoolId"
	        ],
	        "members": {
	          "PoolId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CoipPoolId": {
	            "locationName": "coipPoolId"
	          },
	          "CoipAddressUsages": {
	            "locationName": "coipAddressUsageSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AllocationId": {
	                  "locationName": "allocationId"
	                },
	                "AwsAccountId": {
	                  "locationName": "awsAccountId"
	                },
	                "AwsService": {
	                  "locationName": "awsService"
	                },
	                "CoIp": {
	                  "locationName": "coIp"
	                }
	              }
	            }
	          },
	          "LocalGatewayRouteTableId": {
	            "locationName": "localGatewayRouteTableId"
	          }
	        }
	      }
	    },
	    "GetConsoleOutput": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Latest": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "Output": {
	            "locationName": "output"
	          },
	          "Timestamp": {
	            "locationName": "timestamp",
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetConsoleScreenshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceId": {},
	          "WakeUp": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ImageData": {
	            "locationName": "imageData"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          }
	        }
	      }
	    },
	    "GetDefaultCreditSpecification": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceFamily"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceFamily": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceFamilyCreditSpecification": {
	            "shape": "S1ot",
	            "locationName": "instanceFamilyCreditSpecification"
	          }
	        }
	      }
	    },
	    "GetEbsDefaultKmsKeyId": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KmsKeyId": {
	            "locationName": "kmsKeyId"
	          }
	        }
	      }
	    },
	    "GetEbsEncryptionByDefault": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EbsEncryptionByDefault": {
	            "locationName": "ebsEncryptionByDefault",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "GetFlowLogsIntegrationTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FlowLogId",
	          "ConfigDeliveryS3DestinationArn",
	          "IntegrateServices"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "FlowLogId": {},
	          "ConfigDeliveryS3DestinationArn": {},
	          "IntegrateServices": {
	            "locationName": "IntegrateService",
	            "type": "structure",
	            "members": {
	              "AthenaIntegrations": {
	                "locationName": "AthenaIntegration",
	                "type": "list",
	                "member": {
	                  "locationName": "item",
	                  "type": "structure",
	                  "required": [
	                    "IntegrationResultS3DestinationArn",
	                    "PartitionLoadFrequency"
	                  ],
	                  "members": {
	                    "IntegrationResultS3DestinationArn": {},
	                    "PartitionLoadFrequency": {},
	                    "PartitionStartDate": {
	                      "type": "timestamp"
	                    },
	                    "PartitionEndDate": {
	                      "type": "timestamp"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Result": {
	            "locationName": "result"
	          }
	        }
	      }
	    },
	    "GetGroupsForCapacityReservation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CapacityReservationId"
	        ],
	        "members": {
	          "CapacityReservationId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "CapacityReservationGroups": {
	            "locationName": "capacityReservationGroupSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "GroupArn": {
	                  "locationName": "groupArn"
	                },
	                "OwnerId": {
	                  "locationName": "ownerId"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetHostReservationPurchasePreview": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostIdSet",
	          "OfferingId"
	        ],
	        "members": {
	          "HostIdSet": {
	            "shape": "S1pa"
	          },
	          "OfferingId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CurrencyCode": {
	            "locationName": "currencyCode"
	          },
	          "Purchase": {
	            "shape": "S1pc",
	            "locationName": "purchase"
	          },
	          "TotalHourlyPrice": {
	            "locationName": "totalHourlyPrice"
	          },
	          "TotalUpfrontPrice": {
	            "locationName": "totalUpfrontPrice"
	          }
	        }
	      }
	    },
	    "GetInstanceTypesFromInstanceRequirements": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ArchitectureTypes",
	          "VirtualizationTypes",
	          "InstanceRequirements"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ArchitectureTypes": {
	            "shape": "S1pf",
	            "locationName": "ArchitectureType"
	          },
	          "VirtualizationTypes": {
	            "shape": "S1pg",
	            "locationName": "VirtualizationType"
	          },
	          "InstanceRequirements": {
	            "shape": "Sam"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceTypes": {
	            "locationName": "instanceTypeSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "InstanceType": {
	                  "locationName": "instanceType"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetInstanceUefiData": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "UefiData": {
	            "locationName": "uefiData"
	          }
	        }
	      }
	    },
	    "GetIpamAddressHistory": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Cidr",
	          "IpamScopeId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Cidr": {},
	          "IpamScopeId": {},
	          "VpcId": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HistoryRecords": {
	            "locationName": "historyRecordSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ResourceOwnerId": {
	                  "locationName": "resourceOwnerId"
	                },
	                "ResourceRegion": {
	                  "locationName": "resourceRegion"
	                },
	                "ResourceType": {
	                  "locationName": "resourceType"
	                },
	                "ResourceId": {
	                  "locationName": "resourceId"
	                },
	                "ResourceCidr": {
	                  "locationName": "resourceCidr"
	                },
	                "ResourceName": {
	                  "locationName": "resourceName"
	                },
	                "ResourceComplianceStatus": {
	                  "locationName": "resourceComplianceStatus"
	                },
	                "ResourceOverlapStatus": {
	                  "locationName": "resourceOverlapStatus"
	                },
	                "VpcId": {
	                  "locationName": "vpcId"
	                },
	                "SampledStartTime": {
	                  "locationName": "sampledStartTime",
	                  "type": "timestamp"
	                },
	                "SampledEndTime": {
	                  "locationName": "sampledEndTime",
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetIpamPoolAllocations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamPoolId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamPoolId": {},
	          "IpamPoolAllocationId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamPoolAllocations": {
	            "locationName": "ipamPoolAllocationSet",
	            "type": "list",
	            "member": {
	              "shape": "S26",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetIpamPoolCidrs": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamPoolId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamPoolId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamPoolCidrs": {
	            "locationName": "ipamPoolCidrSet",
	            "type": "list",
	            "member": {
	              "shape": "Stt",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetIpamResourceCidrs": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamScopeId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "IpamScopeId": {},
	          "IpamPoolId": {},
	          "ResourceId": {},
	          "ResourceType": {},
	          "ResourceTag": {
	            "shape": "Sdg"
	          },
	          "ResourceOwner": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "locationName": "nextToken"
	          },
	          "IpamResourceCidrs": {
	            "locationName": "ipamResourceCidrSet",
	            "type": "list",
	            "member": {
	              "shape": "S1q5",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "GetLaunchTemplateData": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LaunchTemplateData": {
	            "shape": "Sfo",
	            "locationName": "launchTemplateData"
	          }
	        }
	      }
	    },
	    "GetManagedPrefixListAssociations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PrefixListId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "PrefixListId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PrefixListAssociations": {
	            "locationName": "prefixListAssociationSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ResourceId": {
	                  "locationName": "resourceId"
	                },
	                "ResourceOwner": {
	                  "locationName": "resourceOwner"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetManagedPrefixListEntries": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PrefixListId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "PrefixListId": {},
	          "TargetVersion": {
	            "type": "long"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Entries": {
	            "locationName": "entrySet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Cidr": {
	                  "locationName": "cidr"
	                },
	                "Description": {
	                  "locationName": "description"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetNetworkInsightsAccessScopeAnalysisFindings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInsightsAccessScopeAnalysisId"
	        ],
	        "members": {
	          "NetworkInsightsAccessScopeAnalysisId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAccessScopeAnalysisId": {
	            "locationName": "networkInsightsAccessScopeAnalysisId"
	          },
	          "AnalysisStatus": {
	            "locationName": "analysisStatus"
	          },
	          "AnalysisFindings": {
	            "locationName": "analysisFindingSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "NetworkInsightsAccessScopeAnalysisId": {
	                  "locationName": "networkInsightsAccessScopeAnalysisId"
	                },
	                "NetworkInsightsAccessScopeId": {
	                  "locationName": "networkInsightsAccessScopeId"
	                },
	                "FindingId": {
	                  "locationName": "findingId"
	                },
	                "FindingComponents": {
	                  "shape": "S1ay",
	                  "locationName": "findingComponentSet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetNetworkInsightsAccessScopeContent": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInsightsAccessScopeId"
	        ],
	        "members": {
	          "NetworkInsightsAccessScopeId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAccessScopeContent": {
	            "shape": "Si1",
	            "locationName": "networkInsightsAccessScopeContent"
	          }
	        }
	      }
	    },
	    "GetPasswordData": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "PasswordData": {
	            "locationName": "passwordData"
	          },
	          "Timestamp": {
	            "locationName": "timestamp",
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetReservedInstancesExchangeQuote": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedInstanceIds"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ReservedInstanceIds": {
	            "shape": "S3",
	            "locationName": "ReservedInstanceId"
	          },
	          "TargetConfigurations": {
	            "shape": "S5",
	            "locationName": "TargetConfiguration"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CurrencyCode": {
	            "locationName": "currencyCode"
	          },
	          "IsValidExchange": {
	            "locationName": "isValidExchange",
	            "type": "boolean"
	          },
	          "OutputReservedInstancesWillExpireAt": {
	            "locationName": "outputReservedInstancesWillExpireAt",
	            "type": "timestamp"
	          },
	          "PaymentDue": {
	            "locationName": "paymentDue"
	          },
	          "ReservedInstanceValueRollup": {
	            "shape": "S1qt",
	            "locationName": "reservedInstanceValueRollup"
	          },
	          "ReservedInstanceValueSet": {
	            "locationName": "reservedInstanceValueSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ReservationValue": {
	                  "shape": "S1qt",
	                  "locationName": "reservationValue"
	                },
	                "ReservedInstanceId": {
	                  "locationName": "reservedInstanceId"
	                }
	              }
	            }
	          },
	          "TargetConfigurationValueRollup": {
	            "shape": "S1qt",
	            "locationName": "targetConfigurationValueRollup"
	          },
	          "TargetConfigurationValueSet": {
	            "locationName": "targetConfigurationValueSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ReservationValue": {
	                  "shape": "S1qt",
	                  "locationName": "reservationValue"
	                },
	                "TargetConfiguration": {
	                  "locationName": "targetConfiguration",
	                  "type": "structure",
	                  "members": {
	                    "InstanceCount": {
	                      "locationName": "instanceCount",
	                      "type": "integer"
	                    },
	                    "OfferingId": {
	                      "locationName": "offeringId"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "ValidationFailureReason": {
	            "locationName": "validationFailureReason"
	          }
	        }
	      }
	    },
	    "GetSerialConsoleAccessStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SerialConsoleAccessEnabled": {
	            "locationName": "serialConsoleAccessEnabled",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "GetSpotPlacementScores": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetCapacity"
	        ],
	        "members": {
	          "InstanceTypes": {
	            "locationName": "InstanceType",
	            "type": "list",
	            "member": {}
	          },
	          "TargetCapacity": {
	            "type": "integer"
	          },
	          "TargetCapacityUnitType": {},
	          "SingleAvailabilityZone": {
	            "type": "boolean"
	          },
	          "RegionNames": {
	            "locationName": "RegionName",
	            "type": "list",
	            "member": {}
	          },
	          "InstanceRequirementsWithMetadata": {
	            "type": "structure",
	            "members": {
	              "ArchitectureTypes": {
	                "shape": "S1pf",
	                "locationName": "ArchitectureType"
	              },
	              "VirtualizationTypes": {
	                "shape": "S1pg",
	                "locationName": "VirtualizationType"
	              },
	              "InstanceRequirements": {
	                "shape": "Sam"
	              }
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SpotPlacementScores": {
	            "locationName": "spotPlacementScoreSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Region": {
	                  "locationName": "region"
	                },
	                "AvailabilityZoneId": {
	                  "locationName": "availabilityZoneId"
	                },
	                "Score": {
	                  "locationName": "score",
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetSubnetCidrReservations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubnetId"
	        ],
	        "members": {
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "SubnetId": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SubnetIpv4CidrReservations": {
	            "shape": "S1rd",
	            "locationName": "subnetIpv4CidrReservationSet"
	          },
	          "SubnetIpv6CidrReservations": {
	            "shape": "S1rd",
	            "locationName": "subnetIpv6CidrReservationSet"
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetTransitGatewayAttachmentPropagations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayAttachmentId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayAttachmentPropagations": {
	            "locationName": "transitGatewayAttachmentPropagations",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "TransitGatewayRouteTableId": {
	                  "locationName": "transitGatewayRouteTableId"
	                },
	                "State": {
	                  "locationName": "state"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetTransitGatewayMulticastDomainAssociations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomainId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MulticastDomainAssociations": {
	            "locationName": "multicastDomainAssociations",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "TransitGatewayAttachmentId": {
	                  "locationName": "transitGatewayAttachmentId"
	                },
	                "ResourceId": {
	                  "locationName": "resourceId"
	                },
	                "ResourceType": {
	                  "locationName": "resourceType"
	                },
	                "ResourceOwnerId": {
	                  "locationName": "resourceOwnerId"
	                },
	                "Subnet": {
	                  "shape": "Sj",
	                  "locationName": "subnet"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetTransitGatewayPrefixListReferences": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayPrefixListReferences": {
	            "locationName": "transitGatewayPrefixListReferenceSet",
	            "type": "list",
	            "member": {
	              "shape": "Smp",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetTransitGatewayRouteTableAssociations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Associations": {
	            "locationName": "associations",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "TransitGatewayAttachmentId": {
	                  "locationName": "transitGatewayAttachmentId"
	                },
	                "ResourceId": {
	                  "locationName": "resourceId"
	                },
	                "ResourceType": {
	                  "locationName": "resourceType"
	                },
	                "State": {
	                  "locationName": "state"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetTransitGatewayRouteTablePropagations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayRouteTablePropagations": {
	            "locationName": "transitGatewayRouteTablePropagations",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "TransitGatewayAttachmentId": {
	                  "locationName": "transitGatewayAttachmentId"
	                },
	                "ResourceId": {
	                  "locationName": "resourceId"
	                },
	                "ResourceType": {
	                  "locationName": "resourceType"
	                },
	                "State": {
	                  "locationName": "state"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "GetVpnConnectionDeviceSampleConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpnConnectionId",
	          "VpnConnectionDeviceTypeId"
	        ],
	        "members": {
	          "VpnConnectionId": {},
	          "VpnConnectionDeviceTypeId": {},
	          "InternetKeyExchangeVersion": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpnConnectionDeviceSampleConfiguration": {
	            "locationName": "vpnConnectionDeviceSampleConfiguration",
	            "type": "string",
	            "sensitive": true
	          }
	        }
	      }
	    },
	    "GetVpnConnectionDeviceTypes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpnConnectionDeviceTypes": {
	            "locationName": "vpnConnectionDeviceTypeSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "VpnConnectionDeviceTypeId": {
	                  "locationName": "vpnConnectionDeviceTypeId"
	                },
	                "Vendor": {
	                  "locationName": "vendor"
	                },
	                "Platform": {
	                  "locationName": "platform"
	                },
	                "Software": {
	                  "locationName": "software"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "ImportClientVpnClientCertificateRevocationList": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId",
	          "CertificateRevocationList"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "CertificateRevocationList": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ImportImage": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Architecture": {},
	          "ClientData": {
	            "shape": "S1s9"
	          },
	          "ClientToken": {},
	          "Description": {},
	          "DiskContainers": {
	            "locationName": "DiskContainer",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Description": {},
	                "DeviceName": {},
	                "Format": {},
	                "SnapshotId": {},
	                "Url": {},
	                "UserBucket": {
	                  "shape": "S1sc"
	                }
	              }
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Encrypted": {
	            "type": "boolean"
	          },
	          "Hypervisor": {},
	          "KmsKeyId": {},
	          "LicenseType": {},
	          "Platform": {},
	          "RoleName": {},
	          "LicenseSpecifications": {
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "LicenseConfigurationArn": {}
	              }
	            }
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "UsageOperation": {},
	          "BootMode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Architecture": {
	            "locationName": "architecture"
	          },
	          "Description": {
	            "locationName": "description"
	          },
	          "Encrypted": {
	            "locationName": "encrypted",
	            "type": "boolean"
	          },
	          "Hypervisor": {
	            "locationName": "hypervisor"
	          },
	          "ImageId": {
	            "locationName": "imageId"
	          },
	          "ImportTaskId": {
	            "locationName": "importTaskId"
	          },
	          "KmsKeyId": {
	            "locationName": "kmsKeyId"
	          },
	          "LicenseType": {
	            "locationName": "licenseType"
	          },
	          "Platform": {
	            "locationName": "platform"
	          },
	          "Progress": {
	            "locationName": "progress"
	          },
	          "SnapshotDetails": {
	            "shape": "S12q",
	            "locationName": "snapshotDetailSet"
	          },
	          "Status": {
	            "locationName": "status"
	          },
	          "StatusMessage": {
	            "locationName": "statusMessage"
	          },
	          "LicenseSpecifications": {
	            "shape": "S12t",
	            "locationName": "licenseSpecifications"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tagSet"
	          },
	          "UsageOperation": {
	            "locationName": "usageOperation"
	          }
	        }
	      }
	    },
	    "ImportInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Platform"
	        ],
	        "members": {
	          "Description": {
	            "locationName": "description"
	          },
	          "DiskImages": {
	            "locationName": "diskImage",
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Description": {},
	                "Image": {
	                  "shape": "S1sj"
	                },
	                "Volume": {
	                  "shape": "S1sk"
	                }
	              }
	            }
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "LaunchSpecification": {
	            "locationName": "launchSpecification",
	            "type": "structure",
	            "members": {
	              "AdditionalInfo": {
	                "locationName": "additionalInfo"
	              },
	              "Architecture": {
	                "locationName": "architecture"
	              },
	              "GroupIds": {
	                "shape": "Se7",
	                "locationName": "GroupId"
	              },
	              "GroupNames": {
	                "shape": "Set",
	                "locationName": "GroupName"
	              },
	              "InstanceInitiatedShutdownBehavior": {
	                "locationName": "instanceInitiatedShutdownBehavior"
	              },
	              "InstanceType": {
	                "locationName": "instanceType"
	              },
	              "Monitoring": {
	                "locationName": "monitoring",
	                "type": "boolean"
	              },
	              "Placement": {
	                "shape": "Sak",
	                "locationName": "placement"
	              },
	              "PrivateIpAddress": {
	                "locationName": "privateIpAddress"
	              },
	              "SubnetId": {
	                "locationName": "subnetId"
	              },
	              "UserData": {
	                "locationName": "userData",
	                "type": "structure",
	                "members": {
	                  "Data": {
	                    "locationName": "data"
	                  }
	                },
	                "sensitive": true
	              }
	            }
	          },
	          "Platform": {
	            "locationName": "platform"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConversionTask": {
	            "shape": "Sxq",
	            "locationName": "conversionTask"
	          }
	        }
	      }
	    },
	    "ImportKeyPair": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyName",
	          "PublicKeyMaterial"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "KeyName": {
	            "locationName": "keyName"
	          },
	          "PublicKeyMaterial": {
	            "locationName": "publicKeyMaterial",
	            "type": "blob"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyFingerprint": {
	            "locationName": "keyFingerprint"
	          },
	          "KeyName": {
	            "locationName": "keyName"
	          },
	          "KeyPairId": {
	            "locationName": "keyPairId"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tagSet"
	          }
	        }
	      }
	    },
	    "ImportSnapshot": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClientData": {
	            "shape": "S1s9"
	          },
	          "ClientToken": {},
	          "Description": {},
	          "DiskContainer": {
	            "type": "structure",
	            "members": {
	              "Description": {},
	              "Format": {},
	              "Url": {},
	              "UserBucket": {
	                "shape": "S1sc"
	              }
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Encrypted": {
	            "type": "boolean"
	          },
	          "KmsKeyId": {},
	          "RoleName": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Description": {
	            "locationName": "description"
	          },
	          "ImportTaskId": {
	            "locationName": "importTaskId"
	          },
	          "SnapshotTaskDetail": {
	            "shape": "S131",
	            "locationName": "snapshotTaskDetail"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tagSet"
	          }
	        }
	      }
	    },
	    "ImportVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AvailabilityZone",
	          "Image",
	          "Volume"
	        ],
	        "members": {
	          "AvailabilityZone": {
	            "locationName": "availabilityZone"
	          },
	          "Description": {
	            "locationName": "description"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Image": {
	            "shape": "S1sj",
	            "locationName": "image"
	          },
	          "Volume": {
	            "shape": "S1sk",
	            "locationName": "volume"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConversionTask": {
	            "shape": "Sxq",
	            "locationName": "conversionTask"
	          }
	        }
	      }
	    },
	    "ListImagesInRecycleBin": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ImageIds": {
	            "shape": "S127",
	            "locationName": "ImageId"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Images": {
	            "locationName": "imageSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ImageId": {
	                  "locationName": "imageId"
	                },
	                "Name": {
	                  "locationName": "name"
	                },
	                "Description": {
	                  "locationName": "description"
	                },
	                "RecycleBinEnterTime": {
	                  "locationName": "recycleBinEnterTime",
	                  "type": "timestamp"
	                },
	                "RecycleBinExitTime": {
	                  "locationName": "recycleBinExitTime",
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "ListSnapshotsInRecycleBin": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "SnapshotIds": {
	            "shape": "S1fa",
	            "locationName": "SnapshotId"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Snapshots": {
	            "locationName": "snapshotSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "SnapshotId": {
	                  "locationName": "snapshotId"
	                },
	                "RecycleBinEnterTime": {
	                  "locationName": "recycleBinEnterTime",
	                  "type": "timestamp"
	                },
	                "RecycleBinExitTime": {
	                  "locationName": "recycleBinExitTime",
	                  "type": "timestamp"
	                },
	                "Description": {
	                  "locationName": "description"
	                },
	                "VolumeId": {
	                  "locationName": "volumeId"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "ModifyAddressAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AllocationId"
	        ],
	        "members": {
	          "AllocationId": {},
	          "DomainName": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Address": {
	            "shape": "Sv0",
	            "locationName": "address"
	          }
	        }
	      }
	    },
	    "ModifyAvailabilityZoneGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "OptInStatus"
	        ],
	        "members": {
	          "GroupName": {},
	          "OptInStatus": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyCapacityReservation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CapacityReservationId"
	        ],
	        "members": {
	          "CapacityReservationId": {},
	          "InstanceCount": {
	            "type": "integer"
	          },
	          "EndDate": {
	            "type": "timestamp"
	          },
	          "EndDateType": {},
	          "Accept": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "AdditionalInfo": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyCapacityReservationFleet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CapacityReservationFleetId"
	        ],
	        "members": {
	          "CapacityReservationFleetId": {},
	          "TotalTargetCapacity": {
	            "type": "integer"
	          },
	          "EndDate": {
	            "type": "timestamp"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "RemoveEndDate": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyClientVpnEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "ServerCertificateArn": {},
	          "ConnectionLogOptions": {
	            "shape": "S8r"
	          },
	          "DnsServers": {
	            "type": "structure",
	            "members": {
	              "CustomDnsServers": {
	                "shape": "Se"
	              },
	              "Enabled": {
	                "type": "boolean"
	              }
	            }
	          },
	          "VpnPort": {
	            "type": "integer"
	          },
	          "Description": {},
	          "SplitTunnel": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "SecurityGroupIds": {
	            "shape": "S2c",
	            "locationName": "SecurityGroupId"
	          },
	          "VpcId": {},
	          "SelfServicePortal": {},
	          "ClientConnectOptions": {
	            "shape": "S8u"
	          },
	          "SessionTimeoutHours": {
	            "type": "integer"
	          },
	          "ClientLoginBannerOptions": {
	            "shape": "S8v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyDefaultCreditSpecification": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceFamily",
	          "CpuCredits"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceFamily": {},
	          "CpuCredits": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceFamilyCreditSpecification": {
	            "shape": "S1ot",
	            "locationName": "instanceFamilyCreditSpecification"
	          }
	        }
	      }
	    },
	    "ModifyEbsDefaultKmsKeyId": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KmsKeyId"
	        ],
	        "members": {
	          "KmsKeyId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KmsKeyId": {
	            "locationName": "kmsKeyId"
	          }
	        }
	      }
	    },
	    "ModifyFleet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ExcessCapacityTerminationPolicy": {},
	          "LaunchTemplateConfigs": {
	            "shape": "Sad",
	            "locationName": "LaunchTemplateConfig"
	          },
	          "FleetId": {},
	          "TargetCapacitySpecification": {
	            "shape": "Sbc"
	          },
	          "Context": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyFpgaImageAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FpgaImageId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "FpgaImageId": {},
	          "Attribute": {},
	          "OperationType": {},
	          "UserIds": {
	            "shape": "S1tp",
	            "locationName": "UserId"
	          },
	          "UserGroups": {
	            "shape": "S1tq",
	            "locationName": "UserGroup"
	          },
	          "ProductCodes": {
	            "shape": "S1tr",
	            "locationName": "ProductCode"
	          },
	          "LoadPermission": {
	            "type": "structure",
	            "members": {
	              "Add": {
	                "shape": "S1tt"
	              },
	              "Remove": {
	                "shape": "S1tt"
	              }
	            }
	          },
	          "Description": {},
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FpgaImageAttribute": {
	            "shape": "S10g",
	            "locationName": "fpgaImageAttribute"
	          }
	        }
	      }
	    },
	    "ModifyHosts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostIds"
	        ],
	        "members": {
	          "AutoPlacement": {
	            "locationName": "autoPlacement"
	          },
	          "HostIds": {
	            "shape": "S11d",
	            "locationName": "hostId"
	          },
	          "HostRecovery": {},
	          "InstanceType": {},
	          "InstanceFamily": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Successful": {
	            "shape": "S21",
	            "locationName": "successful"
	          },
	          "Unsuccessful": {
	            "shape": "S1ty",
	            "locationName": "unsuccessful"
	          }
	        }
	      }
	    },
	    "ModifyIdFormat": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "UseLongIds"
	        ],
	        "members": {
	          "Resource": {},
	          "UseLongIds": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyIdentityIdFormat": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PrincipalArn",
	          "Resource",
	          "UseLongIds"
	        ],
	        "members": {
	          "PrincipalArn": {
	            "locationName": "principalArn"
	          },
	          "Resource": {
	            "locationName": "resource"
	          },
	          "UseLongIds": {
	            "locationName": "useLongIds",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyImageAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ImageId"
	        ],
	        "members": {
	          "Attribute": {},
	          "Description": {
	            "shape": "S9u"
	          },
	          "ImageId": {},
	          "LaunchPermission": {
	            "type": "structure",
	            "members": {
	              "Add": {
	                "shape": "S123"
	              },
	              "Remove": {
	                "shape": "S123"
	              }
	            }
	          },
	          "OperationType": {},
	          "ProductCodes": {
	            "shape": "S1tr",
	            "locationName": "ProductCode"
	          },
	          "UserGroups": {
	            "shape": "S1tq",
	            "locationName": "UserGroup"
	          },
	          "UserIds": {
	            "shape": "S1tp",
	            "locationName": "UserId"
	          },
	          "Value": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "OrganizationArns": {
	            "locationName": "OrganizationArn",
	            "type": "list",
	            "member": {
	              "locationName": "OrganizationArn"
	            }
	          },
	          "OrganizationalUnitArns": {
	            "locationName": "OrganizationalUnitArn",
	            "type": "list",
	            "member": {
	              "locationName": "OrganizationalUnitArn"
	            }
	          }
	        }
	      }
	    },
	    "ModifyInstanceAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "SourceDestCheck": {
	            "shape": "S138"
	          },
	          "Attribute": {
	            "locationName": "attribute"
	          },
	          "BlockDeviceMappings": {
	            "locationName": "blockDeviceMapping",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "DeviceName": {
	                  "locationName": "deviceName"
	                },
	                "Ebs": {
	                  "locationName": "ebs",
	                  "type": "structure",
	                  "members": {
	                    "DeleteOnTermination": {
	                      "locationName": "deleteOnTermination",
	                      "type": "boolean"
	                    },
	                    "VolumeId": {
	                      "locationName": "volumeId"
	                    }
	                  }
	                },
	                "NoDevice": {
	                  "locationName": "noDevice"
	                },
	                "VirtualName": {
	                  "locationName": "virtualName"
	                }
	              }
	            }
	          },
	          "DisableApiTermination": {
	            "shape": "S138",
	            "locationName": "disableApiTermination"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "EbsOptimized": {
	            "shape": "S138",
	            "locationName": "ebsOptimized"
	          },
	          "EnaSupport": {
	            "shape": "S138",
	            "locationName": "enaSupport"
	          },
	          "Groups": {
	            "shape": "S4o",
	            "locationName": "GroupId"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "InstanceInitiatedShutdownBehavior": {
	            "shape": "S9u",
	            "locationName": "instanceInitiatedShutdownBehavior"
	          },
	          "InstanceType": {
	            "shape": "S9u",
	            "locationName": "instanceType"
	          },
	          "Kernel": {
	            "shape": "S9u",
	            "locationName": "kernel"
	          },
	          "Ramdisk": {
	            "shape": "S9u",
	            "locationName": "ramdisk"
	          },
	          "SriovNetSupport": {
	            "shape": "S9u",
	            "locationName": "sriovNetSupport"
	          },
	          "UserData": {
	            "locationName": "userData",
	            "type": "structure",
	            "members": {
	              "Value": {
	                "locationName": "value",
	                "type": "blob"
	              }
	            }
	          },
	          "Value": {
	            "locationName": "value"
	          },
	          "DisableApiStop": {
	            "shape": "S138"
	          }
	        }
	      }
	    },
	    "ModifyInstanceCapacityReservationAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "CapacityReservationSpecification"
	        ],
	        "members": {
	          "InstanceId": {},
	          "CapacityReservationSpecification": {
	            "shape": "S1ub"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyInstanceCreditSpecification": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceCreditSpecifications"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {},
	          "InstanceCreditSpecifications": {
	            "locationName": "InstanceCreditSpecification",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "InstanceId": {},
	                "CpuCredits": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SuccessfulInstanceCreditSpecifications": {
	            "locationName": "successfulInstanceCreditSpecificationSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "InstanceId": {
	                  "locationName": "instanceId"
	                }
	              }
	            }
	          },
	          "UnsuccessfulInstanceCreditSpecifications": {
	            "locationName": "unsuccessfulInstanceCreditSpecificationSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "InstanceId": {
	                  "locationName": "instanceId"
	                },
	                "Error": {
	                  "locationName": "error",
	                  "type": "structure",
	                  "members": {
	                    "Code": {
	                      "locationName": "code"
	                    },
	                    "Message": {
	                      "locationName": "message"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ModifyInstanceEventStartTime": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "InstanceEventId",
	          "NotBefore"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceId": {},
	          "InstanceEventId": {},
	          "NotBefore": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Event": {
	            "shape": "S13r",
	            "locationName": "event"
	          }
	        }
	      }
	    },
	    "ModifyInstanceEventWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceEventWindowId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Name": {},
	          "InstanceEventWindowId": {},
	          "TimeRanges": {
	            "shape": "Scm",
	            "locationName": "TimeRange"
	          },
	          "CronExpression": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceEventWindow": {
	            "shape": "S3i",
	            "locationName": "instanceEventWindow"
	          }
	        }
	      }
	    },
	    "ModifyInstanceMaintenanceOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "AutoRecovery": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "AutoRecovery": {
	            "locationName": "autoRecovery"
	          }
	        }
	      }
	    },
	    "ModifyInstanceMetadataOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "HttpTokens": {},
	          "HttpPutResponseHopLimit": {
	            "type": "integer"
	          },
	          "HttpEndpoint": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "HttpProtocolIpv6": {},
	          "InstanceMetadataTags": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "InstanceMetadataOptions": {
	            "shape": "S17p",
	            "locationName": "instanceMetadataOptions"
	          }
	        }
	      }
	    },
	    "ModifyInstancePlacement": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "Affinity": {
	            "locationName": "affinity"
	          },
	          "GroupName": {},
	          "HostId": {
	            "locationName": "hostId"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "Tenancy": {
	            "locationName": "tenancy"
	          },
	          "PartitionNumber": {
	            "type": "integer"
	          },
	          "HostResourceGroupArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyIpam": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamId": {},
	          "Description": {},
	          "AddOperatingRegions": {
	            "shape": "Sd3",
	            "locationName": "AddOperatingRegion"
	          },
	          "RemoveOperatingRegions": {
	            "locationName": "RemoveOperatingRegion",
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "RegionName": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Ipam": {
	            "shape": "Sd6",
	            "locationName": "ipam"
	          }
	        }
	      }
	    },
	    "ModifyIpamPool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamPoolId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamPoolId": {},
	          "Description": {},
	          "AutoImport": {
	            "type": "boolean"
	          },
	          "AllocationMinNetmaskLength": {
	            "type": "integer"
	          },
	          "AllocationMaxNetmaskLength": {
	            "type": "integer"
	          },
	          "AllocationDefaultNetmaskLength": {
	            "type": "integer"
	          },
	          "ClearAllocationDefaultNetmaskLength": {
	            "type": "boolean"
	          },
	          "AddAllocationResourceTags": {
	            "shape": "Sdf",
	            "locationName": "AddAllocationResourceTag"
	          },
	          "RemoveAllocationResourceTags": {
	            "shape": "Sdf",
	            "locationName": "RemoveAllocationResourceTag"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamPool": {
	            "shape": "Sdj",
	            "locationName": "ipamPool"
	          }
	        }
	      }
	    },
	    "ModifyIpamResourceCidr": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "ResourceCidr",
	          "ResourceRegion",
	          "CurrentIpamScopeId",
	          "Monitored"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ResourceId": {},
	          "ResourceCidr": {},
	          "ResourceRegion": {},
	          "CurrentIpamScopeId": {},
	          "DestinationIpamScopeId": {},
	          "Monitored": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamResourceCidr": {
	            "shape": "S1q5",
	            "locationName": "ipamResourceCidr"
	          }
	        }
	      }
	    },
	    "ModifyIpamScope": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamScopeId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamScopeId": {},
	          "Description": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamScope": {
	            "shape": "Sdq",
	            "locationName": "ipamScope"
	          }
	        }
	      }
	    },
	    "ModifyLaunchTemplate": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {},
	          "LaunchTemplateId": {},
	          "LaunchTemplateName": {},
	          "DefaultVersion": {
	            "locationName": "SetDefaultVersion"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LaunchTemplate": {
	            "shape": "Sfh",
	            "locationName": "launchTemplate"
	          }
	        }
	      }
	    },
	    "ModifyManagedPrefixList": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PrefixListId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "PrefixListId": {},
	          "CurrentVersion": {
	            "type": "long"
	          },
	          "PrefixListName": {},
	          "AddEntries": {
	            "shape": "Sgz",
	            "locationName": "AddEntry"
	          },
	          "RemoveEntries": {
	            "locationName": "RemoveEntry",
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Cidr"
	              ],
	              "members": {
	                "Cidr": {}
	              }
	            }
	          },
	          "MaxEntries": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PrefixList": {
	            "shape": "Sh2",
	            "locationName": "prefixList"
	          }
	        }
	      }
	    },
	    "ModifyNetworkInterfaceAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInterfaceId"
	        ],
	        "members": {
	          "Attachment": {
	            "locationName": "attachment",
	            "type": "structure",
	            "members": {
	              "AttachmentId": {
	                "locationName": "attachmentId"
	              },
	              "DeleteOnTermination": {
	                "locationName": "deleteOnTermination",
	                "type": "boolean"
	              }
	            }
	          },
	          "Description": {
	            "shape": "S9u",
	            "locationName": "description"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Groups": {
	            "shape": "Se7",
	            "locationName": "SecurityGroupId"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "SourceDestCheck": {
	            "shape": "S138",
	            "locationName": "sourceDestCheck"
	          }
	        }
	      }
	    },
	    "ModifyPrivateDnsNameOptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceId": {},
	          "PrivateDnsHostnameType": {},
	          "EnableResourceNameDnsARecord": {
	            "type": "boolean"
	          },
	          "EnableResourceNameDnsAAAARecord": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyReservedInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedInstancesIds",
	          "TargetConfigurations"
	        ],
	        "members": {
	          "ReservedInstancesIds": {
	            "shape": "S1d0",
	            "locationName": "ReservedInstancesId"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          },
	          "TargetConfigurations": {
	            "locationName": "ReservedInstancesConfigurationSetItemType",
	            "type": "list",
	            "member": {
	              "shape": "S1dm",
	              "locationName": "item"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReservedInstancesModificationId": {
	            "locationName": "reservedInstancesModificationId"
	          }
	        }
	      }
	    },
	    "ModifySecurityGroupRules": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupId",
	          "SecurityGroupRules"
	        ],
	        "members": {
	          "GroupId": {},
	          "SecurityGroupRules": {
	            "locationName": "SecurityGroupRule",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "SecurityGroupRuleId": {},
	                "SecurityGroupRule": {
	                  "type": "structure",
	                  "members": {
	                    "IpProtocol": {},
	                    "FromPort": {
	                      "type": "integer"
	                    },
	                    "ToPort": {
	                      "type": "integer"
	                    },
	                    "CidrIpv4": {},
	                    "CidrIpv6": {},
	                    "PrefixListId": {},
	                    "ReferencedGroupId": {},
	                    "Description": {}
	                  }
	                }
	              }
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifySnapshotAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotId"
	        ],
	        "members": {
	          "Attribute": {},
	          "CreateVolumePermission": {
	            "type": "structure",
	            "members": {
	              "Add": {
	                "shape": "S1f0"
	              },
	              "Remove": {
	                "shape": "S1f0"
	              }
	            }
	          },
	          "GroupNames": {
	            "shape": "S1es",
	            "locationName": "UserGroup"
	          },
	          "OperationType": {},
	          "SnapshotId": {},
	          "UserIds": {
	            "shape": "S1tp",
	            "locationName": "UserId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifySnapshotTier": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotId"
	        ],
	        "members": {
	          "SnapshotId": {},
	          "StorageTier": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SnapshotId": {
	            "locationName": "snapshotId"
	          },
	          "TieringStartTime": {
	            "locationName": "tieringStartTime",
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "ModifySpotFleetRequest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SpotFleetRequestId"
	        ],
	        "members": {
	          "ExcessCapacityTerminationPolicy": {
	            "locationName": "excessCapacityTerminationPolicy"
	          },
	          "LaunchTemplateConfigs": {
	            "shape": "S1g8",
	            "locationName": "LaunchTemplateConfig"
	          },
	          "SpotFleetRequestId": {
	            "locationName": "spotFleetRequestId"
	          },
	          "TargetCapacity": {
	            "locationName": "targetCapacity",
	            "type": "integer"
	          },
	          "OnDemandTargetCapacity": {
	            "type": "integer"
	          },
	          "Context": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifySubnetAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubnetId"
	        ],
	        "members": {
	          "AssignIpv6AddressOnCreation": {
	            "shape": "S138"
	          },
	          "MapPublicIpOnLaunch": {
	            "shape": "S138"
	          },
	          "SubnetId": {
	            "locationName": "subnetId"
	          },
	          "MapCustomerOwnedIpOnLaunch": {
	            "shape": "S138"
	          },
	          "CustomerOwnedIpv4Pool": {},
	          "EnableDns64": {
	            "shape": "S138"
	          },
	          "PrivateDnsHostnameTypeOnLaunch": {},
	          "EnableResourceNameDnsARecordOnLaunch": {
	            "shape": "S138"
	          },
	          "EnableResourceNameDnsAAAARecordOnLaunch": {
	            "shape": "S138"
	          },
	          "EnableLniAtDeviceIndex": {
	            "type": "integer"
	          },
	          "DisableLniAtDeviceIndex": {
	            "shape": "S138"
	          }
	        }
	      }
	    },
	    "ModifyTrafficMirrorFilterNetworkServices": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrafficMirrorFilterId"
	        ],
	        "members": {
	          "TrafficMirrorFilterId": {},
	          "AddNetworkServices": {
	            "shape": "Sl4",
	            "locationName": "AddNetworkService"
	          },
	          "RemoveNetworkServices": {
	            "shape": "Sl4",
	            "locationName": "RemoveNetworkService"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorFilter": {
	            "shape": "Sky",
	            "locationName": "trafficMirrorFilter"
	          }
	        }
	      }
	    },
	    "ModifyTrafficMirrorFilterRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrafficMirrorFilterRuleId"
	        ],
	        "members": {
	          "TrafficMirrorFilterRuleId": {},
	          "TrafficDirection": {},
	          "RuleNumber": {
	            "type": "integer"
	          },
	          "RuleAction": {},
	          "DestinationPortRange": {
	            "shape": "Sl8"
	          },
	          "SourcePortRange": {
	            "shape": "Sl8"
	          },
	          "Protocol": {
	            "type": "integer"
	          },
	          "DestinationCidrBlock": {},
	          "SourceCidrBlock": {},
	          "Description": {},
	          "RemoveFields": {
	            "locationName": "RemoveField",
	            "type": "list",
	            "member": {}
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorFilterRule": {
	            "shape": "Sl0",
	            "locationName": "trafficMirrorFilterRule"
	          }
	        }
	      }
	    },
	    "ModifyTrafficMirrorSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrafficMirrorSessionId"
	        ],
	        "members": {
	          "TrafficMirrorSessionId": {},
	          "TrafficMirrorTargetId": {},
	          "TrafficMirrorFilterId": {},
	          "PacketLength": {
	            "type": "integer"
	          },
	          "SessionNumber": {
	            "type": "integer"
	          },
	          "VirtualNetworkId": {
	            "type": "integer"
	          },
	          "Description": {},
	          "RemoveFields": {
	            "locationName": "RemoveField",
	            "type": "list",
	            "member": {}
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TrafficMirrorSession": {
	            "shape": "Sld",
	            "locationName": "trafficMirrorSession"
	          }
	        }
	      }
	    },
	    "ModifyTransitGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayId"
	        ],
	        "members": {
	          "TransitGatewayId": {},
	          "Description": {},
	          "Options": {
	            "type": "structure",
	            "members": {
	              "AddTransitGatewayCidrBlocks": {
	                "shape": "Slp"
	              },
	              "RemoveTransitGatewayCidrBlocks": {
	                "shape": "Slp"
	              },
	              "VpnEcmpSupport": {},
	              "DnsSupport": {},
	              "AutoAcceptSharedAttachments": {},
	              "DefaultRouteTableAssociation": {},
	              "AssociationDefaultRouteTableId": {},
	              "DefaultRouteTablePropagation": {},
	              "PropagationDefaultRouteTableId": {}
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGateway": {
	            "shape": "Slr",
	            "locationName": "transitGateway"
	          }
	        }
	      }
	    },
	    "ModifyTransitGatewayPrefixListReference": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId",
	          "PrefixListId"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "PrefixListId": {},
	          "TransitGatewayAttachmentId": {},
	          "Blackhole": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayPrefixListReference": {
	            "shape": "Smp",
	            "locationName": "transitGatewayPrefixListReference"
	          }
	        }
	      }
	    },
	    "ModifyTransitGatewayVpcAttachment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayAttachmentId": {},
	          "AddSubnetIds": {
	            "shape": "S43"
	          },
	          "RemoveSubnetIds": {
	            "shape": "S43"
	          },
	          "Options": {
	            "type": "structure",
	            "members": {
	              "DnsSupport": {},
	              "Ipv6Support": {},
	              "ApplianceModeSupport": {}
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayVpcAttachment": {
	            "shape": "Sw",
	            "locationName": "transitGatewayVpcAttachment"
	          }
	        }
	      }
	    },
	    "ModifyVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "VolumeId": {},
	          "Size": {
	            "type": "integer"
	          },
	          "VolumeType": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "Throughput": {
	            "type": "integer"
	          },
	          "MultiAttachEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumeModification": {
	            "shape": "S1jq",
	            "locationName": "volumeModification"
	          }
	        }
	      }
	    },
	    "ModifyVolumeAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeId"
	        ],
	        "members": {
	          "AutoEnableIO": {
	            "shape": "S138"
	          },
	          "VolumeId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyVpcAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId"
	        ],
	        "members": {
	          "EnableDnsHostnames": {
	            "shape": "S138"
	          },
	          "EnableDnsSupport": {
	            "shape": "S138"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          }
	        }
	      }
	    },
	    "ModifyVpcEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcEndpointId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "VpcEndpointId": {},
	          "ResetPolicy": {
	            "type": "boolean"
	          },
	          "PolicyDocument": {},
	          "AddRouteTableIds": {
	            "shape": "Sne",
	            "locationName": "AddRouteTableId"
	          },
	          "RemoveRouteTableIds": {
	            "shape": "Sne",
	            "locationName": "RemoveRouteTableId"
	          },
	          "AddSubnetIds": {
	            "shape": "Snf",
	            "locationName": "AddSubnetId"
	          },
	          "RemoveSubnetIds": {
	            "shape": "Snf",
	            "locationName": "RemoveSubnetId"
	          },
	          "AddSecurityGroupIds": {
	            "shape": "Sng",
	            "locationName": "AddSecurityGroupId"
	          },
	          "RemoveSecurityGroupIds": {
	            "shape": "Sng",
	            "locationName": "RemoveSecurityGroupId"
	          },
	          "IpAddressType": {},
	          "DnsOptions": {
	            "shape": "Sni"
	          },
	          "PrivateDnsEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyVpcEndpointConnectionNotification": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConnectionNotificationId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ConnectionNotificationId": {},
	          "ConnectionNotificationArn": {},
	          "ConnectionEvents": {
	            "shape": "Se"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReturnValue": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyVpcEndpointServiceConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ServiceId": {},
	          "PrivateDnsName": {},
	          "RemovePrivateDnsName": {
	            "type": "boolean"
	          },
	          "AcceptanceRequired": {
	            "type": "boolean"
	          },
	          "AddNetworkLoadBalancerArns": {
	            "shape": "Se",
	            "locationName": "AddNetworkLoadBalancerArn"
	          },
	          "RemoveNetworkLoadBalancerArns": {
	            "shape": "Se",
	            "locationName": "RemoveNetworkLoadBalancerArn"
	          },
	          "AddGatewayLoadBalancerArns": {
	            "shape": "Se",
	            "locationName": "AddGatewayLoadBalancerArn"
	          },
	          "RemoveGatewayLoadBalancerArns": {
	            "shape": "Se",
	            "locationName": "RemoveGatewayLoadBalancerArn"
	          },
	          "AddSupportedIpAddressTypes": {
	            "shape": "Se",
	            "locationName": "AddSupportedIpAddressType"
	          },
	          "RemoveSupportedIpAddressTypes": {
	            "shape": "Se",
	            "locationName": "RemoveSupportedIpAddressType"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyVpcEndpointServicePayerResponsibility": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceId",
	          "PayerResponsibility"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ServiceId": {},
	          "PayerResponsibility": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReturnValue": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyVpcEndpointServicePermissions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ServiceId": {},
	          "AddAllowedPrincipals": {
	            "shape": "Se"
	          },
	          "RemoveAllowedPrincipals": {
	            "shape": "Se"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReturnValue": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyVpcPeeringConnectionOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcPeeringConnectionId"
	        ],
	        "members": {
	          "AccepterPeeringConnectionOptions": {
	            "shape": "S1ww"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "RequesterPeeringConnectionOptions": {
	            "shape": "S1ww"
	          },
	          "VpcPeeringConnectionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AccepterPeeringConnectionOptions": {
	            "shape": "S1wy",
	            "locationName": "accepterPeeringConnectionOptions"
	          },
	          "RequesterPeeringConnectionOptions": {
	            "shape": "S1wy",
	            "locationName": "requesterPeeringConnectionOptions"
	          }
	        }
	      }
	    },
	    "ModifyVpcTenancy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcId",
	          "InstanceTenancy"
	        ],
	        "members": {
	          "VpcId": {},
	          "InstanceTenancy": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReturnValue": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyVpnConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpnConnectionId"
	        ],
	        "members": {
	          "VpnConnectionId": {},
	          "TransitGatewayId": {},
	          "CustomerGatewayId": {},
	          "VpnGatewayId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpnConnection": {
	            "shape": "Sox",
	            "locationName": "vpnConnection"
	          }
	        }
	      }
	    },
	    "ModifyVpnConnectionOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpnConnectionId"
	        ],
	        "members": {
	          "VpnConnectionId": {},
	          "LocalIpv4NetworkCidr": {},
	          "RemoteIpv4NetworkCidr": {},
	          "LocalIpv6NetworkCidr": {},
	          "RemoteIpv6NetworkCidr": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpnConnection": {
	            "shape": "Sox",
	            "locationName": "vpnConnection"
	          }
	        }
	      }
	    },
	    "ModifyVpnTunnelCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpnConnectionId",
	          "VpnTunnelOutsideIpAddress"
	        ],
	        "members": {
	          "VpnConnectionId": {},
	          "VpnTunnelOutsideIpAddress": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpnConnection": {
	            "shape": "Sox",
	            "locationName": "vpnConnection"
	          }
	        }
	      }
	    },
	    "ModifyVpnTunnelOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpnConnectionId",
	          "VpnTunnelOutsideIpAddress",
	          "TunnelOptions"
	        ],
	        "members": {
	          "VpnConnectionId": {},
	          "VpnTunnelOutsideIpAddress": {},
	          "TunnelOptions": {
	            "type": "structure",
	            "members": {
	              "TunnelInsideCidr": {},
	              "TunnelInsideIpv6Cidr": {},
	              "PreSharedKey": {},
	              "Phase1LifetimeSeconds": {
	                "type": "integer"
	              },
	              "Phase2LifetimeSeconds": {
	                "type": "integer"
	              },
	              "RekeyMarginTimeSeconds": {
	                "type": "integer"
	              },
	              "RekeyFuzzPercentage": {
	                "type": "integer"
	              },
	              "ReplayWindowSize": {
	                "type": "integer"
	              },
	              "DPDTimeoutSeconds": {
	                "type": "integer"
	              },
	              "DPDTimeoutAction": {},
	              "Phase1EncryptionAlgorithms": {
	                "shape": "Soi",
	                "locationName": "Phase1EncryptionAlgorithm"
	              },
	              "Phase2EncryptionAlgorithms": {
	                "shape": "Sok",
	                "locationName": "Phase2EncryptionAlgorithm"
	              },
	              "Phase1IntegrityAlgorithms": {
	                "shape": "Som",
	                "locationName": "Phase1IntegrityAlgorithm"
	              },
	              "Phase2IntegrityAlgorithms": {
	                "shape": "Soo",
	                "locationName": "Phase2IntegrityAlgorithm"
	              },
	              "Phase1DHGroupNumbers": {
	                "shape": "Soq",
	                "locationName": "Phase1DHGroupNumber"
	              },
	              "Phase2DHGroupNumbers": {
	                "shape": "Sos",
	                "locationName": "Phase2DHGroupNumber"
	              },
	              "IKEVersions": {
	                "shape": "Sou",
	                "locationName": "IKEVersion"
	              },
	              "StartupAction": {}
	            }
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpnConnection": {
	            "shape": "Sox",
	            "locationName": "vpnConnection"
	          }
	        }
	      }
	    },
	    "MonitorInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceIds"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "Sw4",
	            "locationName": "InstanceId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceMonitorings": {
	            "shape": "S1xd",
	            "locationName": "instancesSet"
	          }
	        }
	      }
	    },
	    "MoveAddressToVpc": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicIp"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "PublicIp": {
	            "locationName": "publicIp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AllocationId": {
	            "locationName": "allocationId"
	          },
	          "Status": {
	            "locationName": "status"
	          }
	        }
	      }
	    },
	    "MoveByoipCidrToIpam": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Cidr",
	          "IpamPoolId",
	          "IpamPoolOwner"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "Cidr": {},
	          "IpamPoolId": {},
	          "IpamPoolOwner": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ByoipCidr": {
	            "shape": "S1n",
	            "locationName": "byoipCidr"
	          }
	        }
	      }
	    },
	    "ProvisionByoipCidr": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Cidr"
	        ],
	        "members": {
	          "Cidr": {},
	          "CidrAuthorizationContext": {
	            "type": "structure",
	            "required": [
	              "Message",
	              "Signature"
	            ],
	            "members": {
	              "Message": {},
	              "Signature": {}
	            }
	          },
	          "PubliclyAdvertisable": {
	            "type": "boolean"
	          },
	          "Description": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "PoolTagSpecifications": {
	            "shape": "S1t",
	            "locationName": "PoolTagSpecification"
	          },
	          "MultiRegion": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ByoipCidr": {
	            "shape": "S1n",
	            "locationName": "byoipCidr"
	          }
	        }
	      }
	    },
	    "ProvisionIpamPoolCidr": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamPoolId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamPoolId": {},
	          "Cidr": {},
	          "CidrAuthorizationContext": {
	            "type": "structure",
	            "members": {
	              "Message": {},
	              "Signature": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IpamPoolCidr": {
	            "shape": "Stt",
	            "locationName": "ipamPoolCidr"
	          }
	        }
	      }
	    },
	    "ProvisionPublicIpv4PoolCidr": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamPoolId",
	          "PoolId",
	          "NetmaskLength"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamPoolId": {},
	          "PoolId": {},
	          "NetmaskLength": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PoolId": {
	            "locationName": "poolId"
	          },
	          "PoolAddressRange": {
	            "shape": "S1cn",
	            "locationName": "poolAddressRange"
	          }
	        }
	      }
	    },
	    "PurchaseHostReservation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostIdSet",
	          "OfferingId"
	        ],
	        "members": {
	          "ClientToken": {},
	          "CurrencyCode": {},
	          "HostIdSet": {
	            "shape": "S1pa"
	          },
	          "LimitPrice": {},
	          "OfferingId": {},
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientToken": {
	            "locationName": "clientToken"
	          },
	          "CurrencyCode": {
	            "locationName": "currencyCode"
	          },
	          "Purchase": {
	            "shape": "S1pc",
	            "locationName": "purchase"
	          },
	          "TotalHourlyPrice": {
	            "locationName": "totalHourlyPrice"
	          },
	          "TotalUpfrontPrice": {
	            "locationName": "totalUpfrontPrice"
	          }
	        }
	      }
	    },
	    "PurchaseReservedInstancesOffering": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceCount",
	          "ReservedInstancesOfferingId"
	        ],
	        "members": {
	          "InstanceCount": {
	            "type": "integer"
	          },
	          "ReservedInstancesOfferingId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "LimitPrice": {
	            "locationName": "limitPrice",
	            "type": "structure",
	            "members": {
	              "Amount": {
	                "locationName": "amount",
	                "type": "double"
	              },
	              "CurrencyCode": {
	                "locationName": "currencyCode"
	              }
	            }
	          },
	          "PurchaseTime": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReservedInstancesId": {
	            "locationName": "reservedInstancesId"
	          }
	        }
	      }
	    },
	    "PurchaseScheduledInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PurchaseRequests"
	        ],
	        "members": {
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "PurchaseRequests": {
	            "locationName": "PurchaseRequest",
	            "type": "list",
	            "member": {
	              "locationName": "PurchaseRequest",
	              "type": "structure",
	              "required": [
	                "InstanceCount",
	                "PurchaseToken"
	              ],
	              "members": {
	                "InstanceCount": {
	                  "type": "integer"
	                },
	                "PurchaseToken": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ScheduledInstanceSet": {
	            "locationName": "scheduledInstanceSet",
	            "type": "list",
	            "member": {
	              "shape": "S1eh",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "RebootInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceIds"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "Sw4",
	            "locationName": "InstanceId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "RegisterImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "ImageLocation": {},
	          "Architecture": {
	            "locationName": "architecture"
	          },
	          "BlockDeviceMappings": {
	            "shape": "Scf",
	            "locationName": "BlockDeviceMapping"
	          },
	          "Description": {
	            "locationName": "description"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "EnaSupport": {
	            "locationName": "enaSupport",
	            "type": "boolean"
	          },
	          "KernelId": {
	            "locationName": "kernelId"
	          },
	          "Name": {
	            "locationName": "name"
	          },
	          "BillingProducts": {
	            "locationName": "BillingProduct",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "RamdiskId": {
	            "locationName": "ramdiskId"
	          },
	          "RootDeviceName": {
	            "locationName": "rootDeviceName"
	          },
	          "SriovNetSupport": {
	            "locationName": "sriovNetSupport"
	          },
	          "VirtualizationType": {
	            "locationName": "virtualizationType"
	          },
	          "BootMode": {},
	          "TpmSupport": {},
	          "UefiData": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ImageId": {
	            "locationName": "imageId"
	          }
	        }
	      }
	    },
	    "RegisterInstanceEventNotificationAttributes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceTagAttribute": {
	            "type": "structure",
	            "members": {
	              "IncludeAllTagsOfInstance": {
	                "type": "boolean"
	              },
	              "InstanceTagKeys": {
	                "shape": "Su3",
	                "locationName": "InstanceTagKey"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceTagAttribute": {
	            "shape": "Su5",
	            "locationName": "instanceTagAttribute"
	          }
	        }
	      }
	    },
	    "RegisterTransitGatewayMulticastGroupMembers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomainId": {},
	          "GroupIpAddress": {},
	          "NetworkInterfaceIds": {
	            "shape": "Su7"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RegisteredMulticastGroupMembers": {
	            "locationName": "registeredMulticastGroupMembers",
	            "type": "structure",
	            "members": {
	              "TransitGatewayMulticastDomainId": {
	                "locationName": "transitGatewayMulticastDomainId"
	              },
	              "RegisteredNetworkInterfaceIds": {
	                "shape": "Se",
	                "locationName": "registeredNetworkInterfaceIds"
	              },
	              "GroupIpAddress": {
	                "locationName": "groupIpAddress"
	              }
	            }
	          }
	        }
	      }
	    },
	    "RegisterTransitGatewayMulticastGroupSources": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomainId": {},
	          "GroupIpAddress": {},
	          "NetworkInterfaceIds": {
	            "shape": "Su7"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RegisteredMulticastGroupSources": {
	            "locationName": "registeredMulticastGroupSources",
	            "type": "structure",
	            "members": {
	              "TransitGatewayMulticastDomainId": {
	                "locationName": "transitGatewayMulticastDomainId"
	              },
	              "RegisteredNetworkInterfaceIds": {
	                "shape": "Se",
	                "locationName": "registeredNetworkInterfaceIds"
	              },
	              "GroupIpAddress": {
	                "locationName": "groupIpAddress"
	              }
	            }
	          }
	        }
	      }
	    },
	    "RejectTransitGatewayMulticastDomainAssociations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomainId": {},
	          "TransitGatewayAttachmentId": {},
	          "SubnetIds": {
	            "shape": "Se"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Associations": {
	            "shape": "Sg",
	            "locationName": "associations"
	          }
	        }
	      }
	    },
	    "RejectTransitGatewayPeeringAttachment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayAttachmentId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayPeeringAttachment": {
	            "shape": "Sn",
	            "locationName": "transitGatewayPeeringAttachment"
	          }
	        }
	      }
	    },
	    "RejectTransitGatewayVpcAttachment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayAttachmentId"
	        ],
	        "members": {
	          "TransitGatewayAttachmentId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayVpcAttachment": {
	            "shape": "Sw",
	            "locationName": "transitGatewayVpcAttachment"
	          }
	        }
	      }
	    },
	    "RejectVpcEndpointConnections": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceId",
	          "VpcEndpointIds"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ServiceId": {},
	          "VpcEndpointIds": {
	            "shape": "S13",
	            "locationName": "VpcEndpointId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Unsuccessful": {
	            "shape": "S16",
	            "locationName": "unsuccessful"
	          }
	        }
	      }
	    },
	    "RejectVpcPeeringConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VpcPeeringConnectionId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VpcPeeringConnectionId": {
	            "locationName": "vpcPeeringConnectionId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ReleaseAddress": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AllocationId": {},
	          "PublicIp": {},
	          "NetworkBorderGroup": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ReleaseHosts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostIds"
	        ],
	        "members": {
	          "HostIds": {
	            "shape": "S11d",
	            "locationName": "hostId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Successful": {
	            "shape": "S21",
	            "locationName": "successful"
	          },
	          "Unsuccessful": {
	            "shape": "S1ty",
	            "locationName": "unsuccessful"
	          }
	        }
	      }
	    },
	    "ReleaseIpamPoolAllocation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IpamPoolId",
	          "Cidr",
	          "IpamPoolAllocationId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "IpamPoolId": {},
	          "Cidr": {},
	          "IpamPoolAllocationId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Success": {
	            "locationName": "success",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ReplaceIamInstanceProfileAssociation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IamInstanceProfile",
	          "AssociationId"
	        ],
	        "members": {
	          "IamInstanceProfile": {
	            "shape": "S36"
	          },
	          "AssociationId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IamInstanceProfileAssociation": {
	            "shape": "S38",
	            "locationName": "iamInstanceProfileAssociation"
	          }
	        }
	      }
	    },
	    "ReplaceNetworkAclAssociation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationId",
	          "NetworkAclId"
	        ],
	        "members": {
	          "AssociationId": {
	            "locationName": "associationId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NetworkAclId": {
	            "locationName": "networkAclId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NewAssociationId": {
	            "locationName": "newAssociationId"
	          }
	        }
	      }
	    },
	    "ReplaceNetworkAclEntry": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Egress",
	          "NetworkAclId",
	          "Protocol",
	          "RuleAction",
	          "RuleNumber"
	        ],
	        "members": {
	          "CidrBlock": {
	            "locationName": "cidrBlock"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Egress": {
	            "locationName": "egress",
	            "type": "boolean"
	          },
	          "IcmpTypeCode": {
	            "shape": "Shj",
	            "locationName": "Icmp"
	          },
	          "Ipv6CidrBlock": {
	            "locationName": "ipv6CidrBlock"
	          },
	          "NetworkAclId": {
	            "locationName": "networkAclId"
	          },
	          "PortRange": {
	            "shape": "Shk",
	            "locationName": "portRange"
	          },
	          "Protocol": {
	            "locationName": "protocol"
	          },
	          "RuleAction": {
	            "locationName": "ruleAction"
	          },
	          "RuleNumber": {
	            "locationName": "ruleNumber",
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "ReplaceRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RouteTableId"
	        ],
	        "members": {
	          "DestinationCidrBlock": {
	            "locationName": "destinationCidrBlock"
	          },
	          "DestinationIpv6CidrBlock": {
	            "locationName": "destinationIpv6CidrBlock"
	          },
	          "DestinationPrefixListId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "VpcEndpointId": {},
	          "EgressOnlyInternetGatewayId": {
	            "locationName": "egressOnlyInternetGatewayId"
	          },
	          "GatewayId": {
	            "locationName": "gatewayId"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "LocalTarget": {
	            "type": "boolean"
	          },
	          "NatGatewayId": {
	            "locationName": "natGatewayId"
	          },
	          "TransitGatewayId": {},
	          "LocalGatewayId": {},
	          "CarrierGatewayId": {},
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "RouteTableId": {
	            "locationName": "routeTableId"
	          },
	          "VpcPeeringConnectionId": {
	            "locationName": "vpcPeeringConnectionId"
	          },
	          "CoreNetworkArn": {}
	        }
	      }
	    },
	    "ReplaceRouteTableAssociation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationId",
	          "RouteTableId"
	        ],
	        "members": {
	          "AssociationId": {
	            "locationName": "associationId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "RouteTableId": {
	            "locationName": "routeTableId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NewAssociationId": {
	            "locationName": "newAssociationId"
	          },
	          "AssociationState": {
	            "shape": "S3u",
	            "locationName": "associationState"
	          }
	        }
	      }
	    },
	    "ReplaceTransitGatewayRoute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DestinationCidrBlock",
	          "TransitGatewayRouteTableId"
	        ],
	        "members": {
	          "DestinationCidrBlock": {},
	          "TransitGatewayRouteTableId": {},
	          "TransitGatewayAttachmentId": {},
	          "Blackhole": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Route": {
	            "shape": "Smu",
	            "locationName": "route"
	          }
	        }
	      }
	    },
	    "ReportInstanceStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Instances",
	          "ReasonCodes",
	          "Status"
	        ],
	        "members": {
	          "Description": {
	            "locationName": "description"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "EndTime": {
	            "locationName": "endTime",
	            "type": "timestamp"
	          },
	          "Instances": {
	            "shape": "Sw4",
	            "locationName": "instanceId"
	          },
	          "ReasonCodes": {
	            "locationName": "reasonCode",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "StartTime": {
	            "locationName": "startTime",
	            "type": "timestamp"
	          },
	          "Status": {
	            "locationName": "status"
	          }
	        }
	      }
	    },
	    "RequestSpotFleet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SpotFleetRequestConfig"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "SpotFleetRequestConfig": {
	            "shape": "S1ft",
	            "locationName": "spotFleetRequestConfig"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SpotFleetRequestId": {
	            "locationName": "spotFleetRequestId"
	          }
	        }
	      }
	    },
	    "RequestSpotInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AvailabilityZoneGroup": {
	            "locationName": "availabilityZoneGroup"
	          },
	          "BlockDurationMinutes": {
	            "locationName": "blockDurationMinutes",
	            "type": "integer"
	          },
	          "ClientToken": {
	            "locationName": "clientToken"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InstanceCount": {
	            "locationName": "instanceCount",
	            "type": "integer"
	          },
	          "LaunchGroup": {
	            "locationName": "launchGroup"
	          },
	          "LaunchSpecification": {
	            "type": "structure",
	            "members": {
	              "SecurityGroupIds": {
	                "locationName": "SecurityGroupId",
	                "type": "list",
	                "member": {
	                  "locationName": "item"
	                }
	              },
	              "SecurityGroups": {
	                "locationName": "SecurityGroup",
	                "type": "list",
	                "member": {
	                  "locationName": "item"
	                }
	              },
	              "AddressingType": {
	                "locationName": "addressingType"
	              },
	              "BlockDeviceMappings": {
	                "shape": "S122",
	                "locationName": "blockDeviceMapping"
	              },
	              "EbsOptimized": {
	                "locationName": "ebsOptimized",
	                "type": "boolean"
	              },
	              "IamInstanceProfile": {
	                "shape": "S36",
	                "locationName": "iamInstanceProfile"
	              },
	              "ImageId": {
	                "locationName": "imageId"
	              },
	              "InstanceType": {
	                "locationName": "instanceType"
	              },
	              "KernelId": {
	                "locationName": "kernelId"
	              },
	              "KeyName": {
	                "locationName": "keyName"
	              },
	              "Monitoring": {
	                "shape": "S1go",
	                "locationName": "monitoring"
	              },
	              "NetworkInterfaces": {
	                "shape": "S1g3",
	                "locationName": "NetworkInterface"
	              },
	              "Placement": {
	                "shape": "S1g5",
	                "locationName": "placement"
	              },
	              "RamdiskId": {
	                "locationName": "ramdiskId"
	              },
	              "SubnetId": {
	                "locationName": "subnetId"
	              },
	              "UserData": {
	                "locationName": "userData"
	              }
	            }
	          },
	          "SpotPrice": {
	            "locationName": "spotPrice"
	          },
	          "Type": {
	            "locationName": "type"
	          },
	          "ValidFrom": {
	            "locationName": "validFrom",
	            "type": "timestamp"
	          },
	          "ValidUntil": {
	            "locationName": "validUntil",
	            "type": "timestamp"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "InstanceInterruptionBehavior": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SpotInstanceRequests": {
	            "shape": "S1gl",
	            "locationName": "spotInstanceRequestSet"
	          }
	        }
	      }
	    },
	    "ResetAddressAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AllocationId",
	          "Attribute"
	        ],
	        "members": {
	          "AllocationId": {},
	          "Attribute": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Address": {
	            "shape": "Sv0",
	            "locationName": "address"
	          }
	        }
	      }
	    },
	    "ResetEbsDefaultKmsKeyId": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KmsKeyId": {
	            "locationName": "kmsKeyId"
	          }
	        }
	      }
	    },
	    "ResetFpgaImageAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FpgaImageId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "FpgaImageId": {},
	          "Attribute": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ResetImageAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Attribute",
	          "ImageId"
	        ],
	        "members": {
	          "Attribute": {},
	          "ImageId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ResetInstanceAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Attribute",
	          "InstanceId"
	        ],
	        "members": {
	          "Attribute": {
	            "locationName": "attribute"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          }
	        }
	      }
	    },
	    "ResetNetworkInterfaceAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInterfaceId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "SourceDestCheck": {
	            "locationName": "sourceDestCheck"
	          }
	        }
	      }
	    },
	    "ResetSnapshotAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Attribute",
	          "SnapshotId"
	        ],
	        "members": {
	          "Attribute": {},
	          "SnapshotId": {},
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "RestoreAddressToClassic": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PublicIp"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "PublicIp": {
	            "locationName": "publicIp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicIp": {
	            "locationName": "publicIp"
	          },
	          "Status": {
	            "locationName": "status"
	          }
	        }
	      }
	    },
	    "RestoreImageFromRecycleBin": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ImageId"
	        ],
	        "members": {
	          "ImageId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "RestoreManagedPrefixListVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PrefixListId",
	          "PreviousVersion",
	          "CurrentVersion"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "PrefixListId": {},
	          "PreviousVersion": {
	            "type": "long"
	          },
	          "CurrentVersion": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PrefixList": {
	            "shape": "Sh2",
	            "locationName": "prefixList"
	          }
	        }
	      }
	    },
	    "RestoreSnapshotFromRecycleBin": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotId"
	        ],
	        "members": {
	          "SnapshotId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SnapshotId": {
	            "locationName": "snapshotId"
	          },
	          "OutpostArn": {
	            "locationName": "outpostArn"
	          },
	          "Description": {
	            "locationName": "description"
	          },
	          "Encrypted": {
	            "locationName": "encrypted",
	            "type": "boolean"
	          },
	          "OwnerId": {
	            "locationName": "ownerId"
	          },
	          "Progress": {
	            "locationName": "progress"
	          },
	          "StartTime": {
	            "locationName": "startTime",
	            "type": "timestamp"
	          },
	          "State": {
	            "locationName": "status"
	          },
	          "VolumeId": {
	            "locationName": "volumeId"
	          },
	          "VolumeSize": {
	            "locationName": "volumeSize",
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "RestoreSnapshotTier": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotId"
	        ],
	        "members": {
	          "SnapshotId": {},
	          "TemporaryRestoreDays": {
	            "type": "integer"
	          },
	          "PermanentRestore": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SnapshotId": {
	            "locationName": "snapshotId"
	          },
	          "RestoreStartTime": {
	            "locationName": "restoreStartTime",
	            "type": "timestamp"
	          },
	          "RestoreDuration": {
	            "locationName": "restoreDuration",
	            "type": "integer"
	          },
	          "IsPermanentRestore": {
	            "locationName": "isPermanentRestore",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "RevokeClientVpnIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId",
	          "TargetNetworkCidr"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "TargetNetworkCidr": {},
	          "AccessGroupId": {},
	          "RevokeAllGroups": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {
	            "shape": "S55",
	            "locationName": "status"
	          }
	        }
	      }
	    },
	    "RevokeSecurityGroupEgress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupId"
	        ],
	        "members": {
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "GroupId": {
	            "locationName": "groupId"
	          },
	          "IpPermissions": {
	            "shape": "S58",
	            "locationName": "ipPermissions"
	          },
	          "SecurityGroupRuleIds": {
	            "shape": "S1eo",
	            "locationName": "SecurityGroupRuleId"
	          },
	          "CidrIp": {
	            "locationName": "cidrIp"
	          },
	          "FromPort": {
	            "locationName": "fromPort",
	            "type": "integer"
	          },
	          "IpProtocol": {
	            "locationName": "ipProtocol"
	          },
	          "ToPort": {
	            "locationName": "toPort",
	            "type": "integer"
	          },
	          "SourceSecurityGroupName": {
	            "locationName": "sourceSecurityGroupName"
	          },
	          "SourceSecurityGroupOwnerId": {
	            "locationName": "sourceSecurityGroupOwnerId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          },
	          "UnknownIpPermissions": {
	            "shape": "S58",
	            "locationName": "unknownIpPermissionSet"
	          }
	        }
	      }
	    },
	    "RevokeSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CidrIp": {},
	          "FromPort": {
	            "type": "integer"
	          },
	          "GroupId": {},
	          "GroupName": {},
	          "IpPermissions": {
	            "shape": "S58"
	          },
	          "IpProtocol": {},
	          "SourceSecurityGroupName": {},
	          "SourceSecurityGroupOwnerId": {},
	          "ToPort": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "SecurityGroupRuleIds": {
	            "shape": "S1eo",
	            "locationName": "SecurityGroupRuleId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          },
	          "UnknownIpPermissions": {
	            "shape": "S58",
	            "locationName": "unknownIpPermissionSet"
	          }
	        }
	      }
	    },
	    "RunInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MaxCount",
	          "MinCount"
	        ],
	        "members": {
	          "BlockDeviceMappings": {
	            "shape": "Scf",
	            "locationName": "BlockDeviceMapping"
	          },
	          "ImageId": {},
	          "InstanceType": {},
	          "Ipv6AddressCount": {
	            "type": "integer"
	          },
	          "Ipv6Addresses": {
	            "shape": "Sfv",
	            "locationName": "Ipv6Address"
	          },
	          "KernelId": {},
	          "KeyName": {},
	          "MaxCount": {
	            "type": "integer"
	          },
	          "MinCount": {
	            "type": "integer"
	          },
	          "Monitoring": {
	            "shape": "S1go"
	          },
	          "Placement": {
	            "shape": "Sak"
	          },
	          "RamdiskId": {},
	          "SecurityGroupIds": {
	            "shape": "Se7",
	            "locationName": "SecurityGroupId"
	          },
	          "SecurityGroups": {
	            "shape": "Set",
	            "locationName": "SecurityGroup"
	          },
	          "SubnetId": {},
	          "UserData": {
	            "type": "string",
	            "sensitive": true
	          },
	          "AdditionalInfo": {
	            "locationName": "additionalInfo"
	          },
	          "ClientToken": {
	            "idempotencyToken": true,
	            "locationName": "clientToken"
	          },
	          "DisableApiTermination": {
	            "locationName": "disableApiTermination",
	            "type": "boolean"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "EbsOptimized": {
	            "locationName": "ebsOptimized",
	            "type": "boolean"
	          },
	          "IamInstanceProfile": {
	            "shape": "S36",
	            "locationName": "iamInstanceProfile"
	          },
	          "InstanceInitiatedShutdownBehavior": {
	            "locationName": "instanceInitiatedShutdownBehavior"
	          },
	          "NetworkInterfaces": {
	            "shape": "S1g3",
	            "locationName": "networkInterface"
	          },
	          "PrivateIpAddress": {
	            "locationName": "privateIpAddress"
	          },
	          "ElasticGpuSpecification": {
	            "type": "list",
	            "member": {
	              "shape": "Sep",
	              "locationName": "item"
	            }
	          },
	          "ElasticInferenceAccelerators": {
	            "locationName": "ElasticInferenceAccelerator",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "required": [
	                "Type"
	              ],
	              "members": {
	                "Type": {},
	                "Count": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "LaunchTemplate": {
	            "type": "structure",
	            "members": {
	              "LaunchTemplateId": {},
	              "LaunchTemplateName": {},
	              "Version": {}
	            }
	          },
	          "InstanceMarketOptions": {
	            "type": "structure",
	            "members": {
	              "MarketType": {},
	              "SpotOptions": {
	                "type": "structure",
	                "members": {
	                  "MaxPrice": {},
	                  "SpotInstanceType": {},
	                  "BlockDurationMinutes": {
	                    "type": "integer"
	                  },
	                  "ValidUntil": {
	                    "type": "timestamp"
	                  },
	                  "InstanceInterruptionBehavior": {}
	                }
	              }
	            }
	          },
	          "CreditSpecification": {
	            "shape": "Sez"
	          },
	          "CpuOptions": {
	            "type": "structure",
	            "members": {
	              "CoreCount": {
	                "type": "integer"
	              },
	              "ThreadsPerCore": {
	                "type": "integer"
	              }
	            }
	          },
	          "CapacityReservationSpecification": {
	            "shape": "S1ub"
	          },
	          "HibernationOptions": {
	            "type": "structure",
	            "members": {
	              "Configured": {
	                "type": "boolean"
	              }
	            }
	          },
	          "LicenseSpecifications": {
	            "locationName": "LicenseSpecification",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "LicenseConfigurationArn": {}
	              }
	            }
	          },
	          "MetadataOptions": {
	            "type": "structure",
	            "members": {
	              "HttpTokens": {},
	              "HttpPutResponseHopLimit": {
	                "type": "integer"
	              },
	              "HttpEndpoint": {},
	              "HttpProtocolIpv6": {},
	              "InstanceMetadataTags": {}
	            }
	          },
	          "EnclaveOptions": {
	            "type": "structure",
	            "members": {
	              "Enabled": {
	                "type": "boolean"
	              }
	            }
	          },
	          "PrivateDnsNameOptions": {
	            "type": "structure",
	            "members": {
	              "HostnameType": {},
	              "EnableResourceNameDnsARecord": {
	                "type": "boolean"
	              },
	              "EnableResourceNameDnsAAAARecord": {
	                "type": "boolean"
	              }
	            }
	          },
	          "MaintenanceOptions": {
	            "type": "structure",
	            "members": {
	              "AutoRecovery": {}
	            }
	          },
	          "DisableApiStop": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S170"
	      }
	    },
	    "RunScheduledInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LaunchSpecification",
	          "ScheduledInstanceId"
	        ],
	        "members": {
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "InstanceCount": {
	            "type": "integer"
	          },
	          "LaunchSpecification": {
	            "type": "structure",
	            "required": [
	              "ImageId"
	            ],
	            "members": {
	              "BlockDeviceMappings": {
	                "locationName": "BlockDeviceMapping",
	                "type": "list",
	                "member": {
	                  "locationName": "BlockDeviceMapping",
	                  "type": "structure",
	                  "members": {
	                    "DeviceName": {},
	                    "Ebs": {
	                      "type": "structure",
	                      "members": {
	                        "DeleteOnTermination": {
	                          "type": "boolean"
	                        },
	                        "Encrypted": {
	                          "type": "boolean"
	                        },
	                        "Iops": {
	                          "type": "integer"
	                        },
	                        "SnapshotId": {},
	                        "VolumeSize": {
	                          "type": "integer"
	                        },
	                        "VolumeType": {}
	                      }
	                    },
	                    "NoDevice": {},
	                    "VirtualName": {}
	                  }
	                }
	              },
	              "EbsOptimized": {
	                "type": "boolean"
	              },
	              "IamInstanceProfile": {
	                "type": "structure",
	                "members": {
	                  "Arn": {},
	                  "Name": {}
	                }
	              },
	              "ImageId": {},
	              "InstanceType": {},
	              "KernelId": {},
	              "KeyName": {},
	              "Monitoring": {
	                "type": "structure",
	                "members": {
	                  "Enabled": {
	                    "type": "boolean"
	                  }
	                }
	              },
	              "NetworkInterfaces": {
	                "locationName": "NetworkInterface",
	                "type": "list",
	                "member": {
	                  "locationName": "NetworkInterface",
	                  "type": "structure",
	                  "members": {
	                    "AssociatePublicIpAddress": {
	                      "type": "boolean"
	                    },
	                    "DeleteOnTermination": {
	                      "type": "boolean"
	                    },
	                    "Description": {},
	                    "DeviceIndex": {
	                      "type": "integer"
	                    },
	                    "Groups": {
	                      "shape": "S210",
	                      "locationName": "Group"
	                    },
	                    "Ipv6AddressCount": {
	                      "type": "integer"
	                    },
	                    "Ipv6Addresses": {
	                      "locationName": "Ipv6Address",
	                      "type": "list",
	                      "member": {
	                        "locationName": "Ipv6Address",
	                        "type": "structure",
	                        "members": {
	                          "Ipv6Address": {}
	                        }
	                      }
	                    },
	                    "NetworkInterfaceId": {},
	                    "PrivateIpAddress": {},
	                    "PrivateIpAddressConfigs": {
	                      "locationName": "PrivateIpAddressConfig",
	                      "type": "list",
	                      "member": {
	                        "locationName": "PrivateIpAddressConfigSet",
	                        "type": "structure",
	                        "members": {
	                          "Primary": {
	                            "type": "boolean"
	                          },
	                          "PrivateIpAddress": {}
	                        }
	                      }
	                    },
	                    "SecondaryPrivateIpAddressCount": {
	                      "type": "integer"
	                    },
	                    "SubnetId": {}
	                  }
	                }
	              },
	              "Placement": {
	                "type": "structure",
	                "members": {
	                  "AvailabilityZone": {},
	                  "GroupName": {}
	                }
	              },
	              "RamdiskId": {},
	              "SecurityGroupIds": {
	                "shape": "S210",
	                "locationName": "SecurityGroupId"
	              },
	              "SubnetId": {},
	              "UserData": {}
	            }
	          },
	          "ScheduledInstanceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceIdSet": {
	            "locationName": "instanceIdSet",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "SearchLocalGatewayRoutes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LocalGatewayRouteTableId"
	        ],
	        "members": {
	          "LocalGatewayRouteTableId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Routes": {
	            "locationName": "routeSet",
	            "type": "list",
	            "member": {
	              "shape": "Sgr",
	              "locationName": "item"
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "SearchTransitGatewayMulticastGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TransitGatewayMulticastDomainId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MulticastGroups": {
	            "locationName": "multicastGroups",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "GroupIpAddress": {
	                  "locationName": "groupIpAddress"
	                },
	                "TransitGatewayAttachmentId": {
	                  "locationName": "transitGatewayAttachmentId"
	                },
	                "SubnetId": {
	                  "locationName": "subnetId"
	                },
	                "ResourceId": {
	                  "locationName": "resourceId"
	                },
	                "ResourceType": {
	                  "locationName": "resourceType"
	                },
	                "ResourceOwnerId": {
	                  "locationName": "resourceOwnerId"
	                },
	                "NetworkInterfaceId": {
	                  "locationName": "networkInterfaceId"
	                },
	                "GroupMember": {
	                  "locationName": "groupMember",
	                  "type": "boolean"
	                },
	                "GroupSource": {
	                  "locationName": "groupSource",
	                  "type": "boolean"
	                },
	                "MemberType": {
	                  "locationName": "memberType"
	                },
	                "SourceType": {
	                  "locationName": "sourceType"
	                }
	              }
	            }
	          },
	          "NextToken": {
	            "locationName": "nextToken"
	          }
	        }
	      }
	    },
	    "SearchTransitGatewayRoutes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TransitGatewayRouteTableId",
	          "Filters"
	        ],
	        "members": {
	          "TransitGatewayRouteTableId": {},
	          "Filters": {
	            "shape": "Sum",
	            "locationName": "Filter"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Routes": {
	            "locationName": "routeSet",
	            "type": "list",
	            "member": {
	              "shape": "Smu",
	              "locationName": "item"
	            }
	          },
	          "AdditionalRoutesAvailable": {
	            "locationName": "additionalRoutesAvailable",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "SendDiagnosticInterrupt": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "StartInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceIds"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "Sw4",
	            "locationName": "InstanceId"
	          },
	          "AdditionalInfo": {
	            "locationName": "additionalInfo"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StartingInstances": {
	            "shape": "S21o",
	            "locationName": "instancesSet"
	          }
	        }
	      }
	    },
	    "StartNetworkInsightsAccessScopeAnalysis": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInsightsAccessScopeId",
	          "ClientToken"
	        ],
	        "members": {
	          "NetworkInsightsAccessScopeId": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAccessScopeAnalysis": {
	            "shape": "S1al",
	            "locationName": "networkInsightsAccessScopeAnalysis"
	          }
	        }
	      }
	    },
	    "StartNetworkInsightsAnalysis": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInsightsPathId",
	          "ClientToken"
	        ],
	        "members": {
	          "NetworkInsightsPathId": {},
	          "FilterInArns": {
	            "shape": "S1ax",
	            "locationName": "FilterInArn"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "TagSpecifications": {
	            "shape": "S1t",
	            "locationName": "TagSpecification"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInsightsAnalysis": {
	            "shape": "S1aw",
	            "locationName": "networkInsightsAnalysis"
	          }
	        }
	      }
	    },
	    "StartVpcEndpointServicePrivateDnsVerification": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceId"
	        ],
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ServiceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReturnValue": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "StopInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceIds"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "Sw4",
	            "locationName": "InstanceId"
	          },
	          "Hibernate": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          },
	          "Force": {
	            "locationName": "force",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StoppingInstances": {
	            "shape": "S21o",
	            "locationName": "instancesSet"
	          }
	        }
	      }
	    },
	    "TerminateClientVpnConnections": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientVpnEndpointId"
	        ],
	        "members": {
	          "ClientVpnEndpointId": {},
	          "ConnectionId": {},
	          "Username": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClientVpnEndpointId": {
	            "locationName": "clientVpnEndpointId"
	          },
	          "Username": {
	            "locationName": "username"
	          },
	          "ConnectionStatuses": {
	            "locationName": "connectionStatuses",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ConnectionId": {
	                  "locationName": "connectionId"
	                },
	                "PreviousStatus": {
	                  "shape": "Swj",
	                  "locationName": "previousStatus"
	                },
	                "CurrentStatus": {
	                  "shape": "Swj",
	                  "locationName": "currentStatus"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "TerminateInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceIds"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "Sw4",
	            "locationName": "InstanceId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TerminatingInstances": {
	            "shape": "S21o",
	            "locationName": "instancesSet"
	          }
	        }
	      }
	    },
	    "UnassignIpv6Addresses": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInterfaceId"
	        ],
	        "members": {
	          "Ipv6Addresses": {
	            "shape": "S2g",
	            "locationName": "ipv6Addresses"
	          },
	          "Ipv6Prefixes": {
	            "shape": "S2h",
	            "locationName": "Ipv6Prefix"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "UnassignedIpv6Addresses": {
	            "shape": "S2g",
	            "locationName": "unassignedIpv6Addresses"
	          },
	          "UnassignedIpv6Prefixes": {
	            "shape": "S2h",
	            "locationName": "unassignedIpv6PrefixSet"
	          }
	        }
	      }
	    },
	    "UnassignPrivateIpAddresses": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NetworkInterfaceId"
	        ],
	        "members": {
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "PrivateIpAddresses": {
	            "shape": "S2l",
	            "locationName": "privateIpAddress"
	          },
	          "Ipv4Prefixes": {
	            "shape": "S2h",
	            "locationName": "Ipv4Prefix"
	          }
	        }
	      }
	    },
	    "UnmonitorInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceIds"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "Sw4",
	            "locationName": "InstanceId"
	          },
	          "DryRun": {
	            "locationName": "dryRun",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceMonitorings": {
	            "shape": "S1xd",
	            "locationName": "instancesSet"
	          }
	        }
	      }
	    },
	    "UpdateSecurityGroupRuleDescriptionsEgress": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "GroupId": {},
	          "GroupName": {},
	          "IpPermissions": {
	            "shape": "S58"
	          },
	          "SecurityGroupRuleDescriptions": {
	            "shape": "S22a",
	            "locationName": "SecurityGroupRuleDescription"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "UpdateSecurityGroupRuleDescriptionsIngress": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DryRun": {
	            "type": "boolean"
	          },
	          "GroupId": {},
	          "GroupName": {},
	          "IpPermissions": {
	            "shape": "S58"
	          },
	          "SecurityGroupRuleDescriptions": {
	            "shape": "S22a",
	            "locationName": "SecurityGroupRuleDescription"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Return": {
	            "locationName": "return",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "WithdrawByoipCidr": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Cidr"
	        ],
	        "members": {
	          "Cidr": {},
	          "DryRun": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ByoipCidr": {
	            "shape": "S1n",
	            "locationName": "byoipCidr"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S3": {
	      "type": "list",
	      "member": {
	        "locationName": "ReservedInstanceId"
	      }
	    },
	    "S5": {
	      "type": "list",
	      "member": {
	        "locationName": "TargetConfigurationRequest",
	        "type": "structure",
	        "required": [
	          "OfferingId"
	        ],
	        "members": {
	          "InstanceCount": {
	            "type": "integer"
	          },
	          "OfferingId": {}
	        }
	      }
	    },
	    "Se": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sg": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayMulticastDomainId": {
	          "locationName": "transitGatewayMulticastDomainId"
	        },
	        "TransitGatewayAttachmentId": {
	          "locationName": "transitGatewayAttachmentId"
	        },
	        "ResourceId": {
	          "locationName": "resourceId"
	        },
	        "ResourceType": {
	          "locationName": "resourceType"
	        },
	        "ResourceOwnerId": {
	          "locationName": "resourceOwnerId"
	        },
	        "Subnets": {
	          "locationName": "subnets",
	          "type": "list",
	          "member": {
	            "shape": "Sj",
	            "locationName": "item"
	          }
	        }
	      }
	    },
	    "Sj": {
	      "type": "structure",
	      "members": {
	        "SubnetId": {
	          "locationName": "subnetId"
	        },
	        "State": {
	          "locationName": "state"
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayAttachmentId": {
	          "locationName": "transitGatewayAttachmentId"
	        },
	        "RequesterTgwInfo": {
	          "shape": "So",
	          "locationName": "requesterTgwInfo"
	        },
	        "AccepterTgwInfo": {
	          "shape": "So",
	          "locationName": "accepterTgwInfo"
	        },
	        "Status": {
	          "locationName": "status",
	          "type": "structure",
	          "members": {
	            "Code": {
	              "locationName": "code"
	            },
	            "Message": {
	              "locationName": "message"
	            }
	          }
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "CreationTime": {
	          "locationName": "creationTime",
	          "type": "timestamp"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "So": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayId": {
	          "locationName": "transitGatewayId"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "Region": {
	          "locationName": "region"
	        }
	      }
	    },
	    "Ss": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Key": {
	            "locationName": "key"
	          },
	          "Value": {
	            "locationName": "value"
	          }
	        }
	      }
	    },
	    "Sw": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayAttachmentId": {
	          "locationName": "transitGatewayAttachmentId"
	        },
	        "TransitGatewayId": {
	          "locationName": "transitGatewayId"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "VpcOwnerId": {
	          "locationName": "vpcOwnerId"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "SubnetIds": {
	          "shape": "Se",
	          "locationName": "subnetIds"
	        },
	        "CreationTime": {
	          "locationName": "creationTime",
	          "type": "timestamp"
	        },
	        "Options": {
	          "locationName": "options",
	          "type": "structure",
	          "members": {
	            "DnsSupport": {
	              "locationName": "dnsSupport"
	            },
	            "Ipv6Support": {
	              "locationName": "ipv6Support"
	            },
	            "ApplianceModeSupport": {
	              "locationName": "applianceModeSupport"
	            }
	          }
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S16": {
	      "type": "list",
	      "member": {
	        "shape": "S17",
	        "locationName": "item"
	      }
	    },
	    "S17": {
	      "type": "structure",
	      "members": {
	        "Error": {
	          "locationName": "error",
	          "type": "structure",
	          "members": {
	            "Code": {
	              "locationName": "code"
	            },
	            "Message": {
	              "locationName": "message"
	            }
	          }
	        },
	        "ResourceId": {
	          "locationName": "resourceId"
	        }
	      }
	    },
	    "S1c": {
	      "type": "structure",
	      "members": {
	        "AccepterVpcInfo": {
	          "shape": "S1d",
	          "locationName": "accepterVpcInfo"
	        },
	        "ExpirationTime": {
	          "locationName": "expirationTime",
	          "type": "timestamp"
	        },
	        "RequesterVpcInfo": {
	          "shape": "S1d",
	          "locationName": "requesterVpcInfo"
	        },
	        "Status": {
	          "locationName": "status",
	          "type": "structure",
	          "members": {
	            "Code": {
	              "locationName": "code"
	            },
	            "Message": {
	              "locationName": "message"
	            }
	          }
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "VpcPeeringConnectionId": {
	          "locationName": "vpcPeeringConnectionId"
	        }
	      }
	    },
	    "S1d": {
	      "type": "structure",
	      "members": {
	        "CidrBlock": {
	          "locationName": "cidrBlock"
	        },
	        "Ipv6CidrBlockSet": {
	          "locationName": "ipv6CidrBlockSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "Ipv6CidrBlock": {
	                "locationName": "ipv6CidrBlock"
	              }
	            }
	          }
	        },
	        "CidrBlockSet": {
	          "locationName": "cidrBlockSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "CidrBlock": {
	                "locationName": "cidrBlock"
	              }
	            }
	          }
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "PeeringOptions": {
	          "locationName": "peeringOptions",
	          "type": "structure",
	          "members": {
	            "AllowDnsResolutionFromRemoteVpc": {
	              "locationName": "allowDnsResolutionFromRemoteVpc",
	              "type": "boolean"
	            },
	            "AllowEgressFromLocalClassicLinkToRemoteVpc": {
	              "locationName": "allowEgressFromLocalClassicLinkToRemoteVpc",
	              "type": "boolean"
	            },
	            "AllowEgressFromLocalVpcToRemoteClassicLink": {
	              "locationName": "allowEgressFromLocalVpcToRemoteClassicLink",
	              "type": "boolean"
	            }
	          }
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "Region": {
	          "locationName": "region"
	        }
	      }
	    },
	    "S1n": {
	      "type": "structure",
	      "members": {
	        "Cidr": {
	          "locationName": "cidr"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "StatusMessage": {
	          "locationName": "statusMessage"
	        },
	        "State": {
	          "locationName": "state"
	        }
	      }
	    },
	    "S1t": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "ResourceType": {
	            "locationName": "resourceType"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "Tag"
	          }
	        }
	      }
	    },
	    "S21": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S26": {
	      "type": "structure",
	      "members": {
	        "Cidr": {
	          "locationName": "cidr"
	        },
	        "IpamPoolAllocationId": {
	          "locationName": "ipamPoolAllocationId"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "ResourceId": {
	          "locationName": "resourceId"
	        },
	        "ResourceType": {
	          "locationName": "resourceType"
	        },
	        "ResourceRegion": {
	          "locationName": "resourceRegion"
	        },
	        "ResourceOwner": {
	          "locationName": "resourceOwner"
	        }
	      }
	    },
	    "S2c": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S2g": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S2h": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S2l": {
	      "type": "list",
	      "member": {
	        "locationName": "PrivateIpAddress"
	      }
	    },
	    "S2p": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Ipv4Prefix": {
	            "locationName": "ipv4Prefix"
	          }
	        }
	      }
	    },
	    "S2y": {
	      "type": "structure",
	      "members": {
	        "Code": {
	          "locationName": "code"
	        },
	        "Message": {
	          "locationName": "message"
	        }
	      }
	    },
	    "S36": {
	      "type": "structure",
	      "members": {
	        "Arn": {
	          "locationName": "arn"
	        },
	        "Name": {
	          "locationName": "name"
	        }
	      }
	    },
	    "S38": {
	      "type": "structure",
	      "members": {
	        "AssociationId": {
	          "locationName": "associationId"
	        },
	        "InstanceId": {
	          "locationName": "instanceId"
	        },
	        "IamInstanceProfile": {
	          "shape": "S39",
	          "locationName": "iamInstanceProfile"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "Timestamp": {
	          "locationName": "timestamp",
	          "type": "timestamp"
	        }
	      }
	    },
	    "S39": {
	      "type": "structure",
	      "members": {
	        "Arn": {
	          "locationName": "arn"
	        },
	        "Id": {
	          "locationName": "id"
	        }
	      }
	    },
	    "S3e": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S3f": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S3i": {
	      "type": "structure",
	      "members": {
	        "InstanceEventWindowId": {
	          "locationName": "instanceEventWindowId"
	        },
	        "TimeRanges": {
	          "locationName": "timeRangeSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "StartWeekDay": {
	                "locationName": "startWeekDay"
	              },
	              "StartHour": {
	                "locationName": "startHour",
	                "type": "integer"
	              },
	              "EndWeekDay": {
	                "locationName": "endWeekDay"
	              },
	              "EndHour": {
	                "locationName": "endHour",
	                "type": "integer"
	              }
	            }
	          }
	        },
	        "Name": {
	          "locationName": "name"
	        },
	        "CronExpression": {
	          "locationName": "cronExpression"
	        },
	        "AssociationTarget": {
	          "locationName": "associationTarget",
	          "type": "structure",
	          "members": {
	            "InstanceIds": {
	              "shape": "S3e",
	              "locationName": "instanceIdSet"
	            },
	            "Tags": {
	              "shape": "Ss",
	              "locationName": "tagSet"
	            },
	            "DedicatedHostIds": {
	              "shape": "S3f",
	              "locationName": "dedicatedHostIdSet"
	            }
	          }
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "S3u": {
	      "type": "structure",
	      "members": {
	        "State": {
	          "locationName": "state"
	        },
	        "StatusMessage": {
	          "locationName": "statusMessage"
	        }
	      }
	    },
	    "S3y": {
	      "type": "structure",
	      "members": {
	        "AssociationId": {
	          "locationName": "associationId"
	        },
	        "Ipv6CidrBlock": {
	          "locationName": "ipv6CidrBlock"
	        },
	        "Ipv6CidrBlockState": {
	          "locationName": "ipv6CidrBlockState",
	          "type": "structure",
	          "members": {
	            "State": {
	              "locationName": "state"
	            },
	            "StatusMessage": {
	              "locationName": "statusMessage"
	            }
	          }
	        }
	      }
	    },
	    "S43": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S48": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayRouteTableId": {
	          "locationName": "transitGatewayRouteTableId"
	        },
	        "TransitGatewayAttachmentId": {
	          "locationName": "transitGatewayAttachmentId"
	        },
	        "ResourceId": {
	          "locationName": "resourceId"
	        },
	        "ResourceType": {
	          "locationName": "resourceType"
	        },
	        "State": {
	          "locationName": "state"
	        }
	      }
	    },
	    "S4c": {
	      "type": "structure",
	      "members": {
	        "AssociationId": {
	          "locationName": "associationId"
	        },
	        "BranchInterfaceId": {
	          "locationName": "branchInterfaceId"
	        },
	        "TrunkInterfaceId": {
	          "locationName": "trunkInterfaceId"
	        },
	        "InterfaceProtocol": {
	          "locationName": "interfaceProtocol"
	        },
	        "VlanId": {
	          "locationName": "vlanId",
	          "type": "integer"
	        },
	        "GreKey": {
	          "locationName": "greKey",
	          "type": "integer"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "S4j": {
	      "type": "structure",
	      "members": {
	        "AssociationId": {
	          "locationName": "associationId"
	        },
	        "Ipv6CidrBlock": {
	          "locationName": "ipv6CidrBlock"
	        },
	        "Ipv6CidrBlockState": {
	          "shape": "S4k",
	          "locationName": "ipv6CidrBlockState"
	        },
	        "NetworkBorderGroup": {
	          "locationName": "networkBorderGroup"
	        },
	        "Ipv6Pool": {
	          "locationName": "ipv6Pool"
	        }
	      }
	    },
	    "S4k": {
	      "type": "structure",
	      "members": {
	        "State": {
	          "locationName": "state"
	        },
	        "StatusMessage": {
	          "locationName": "statusMessage"
	        }
	      }
	    },
	    "S4m": {
	      "type": "structure",
	      "members": {
	        "AssociationId": {
	          "locationName": "associationId"
	        },
	        "CidrBlock": {
	          "locationName": "cidrBlock"
	        },
	        "CidrBlockState": {
	          "shape": "S4k",
	          "locationName": "cidrBlockState"
	        }
	      }
	    },
	    "S4o": {
	      "type": "list",
	      "member": {
	        "locationName": "groupId"
	      }
	    },
	    "S4w": {
	      "type": "structure",
	      "members": {
	        "AttachTime": {
	          "locationName": "attachTime",
	          "type": "timestamp"
	        },
	        "Device": {
	          "locationName": "device"
	        },
	        "InstanceId": {
	          "locationName": "instanceId"
	        },
	        "State": {
	          "locationName": "status"
	        },
	        "VolumeId": {
	          "locationName": "volumeId"
	        },
	        "DeleteOnTermination": {
	          "locationName": "deleteOnTermination",
	          "type": "boolean"
	        }
	      }
	    },
	    "S51": {
	      "type": "structure",
	      "members": {
	        "State": {
	          "locationName": "state"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        }
	      }
	    },
	    "S55": {
	      "type": "structure",
	      "members": {
	        "Code": {
	          "locationName": "code"
	        },
	        "Message": {
	          "locationName": "message"
	        }
	      }
	    },
	    "S58": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "FromPort": {
	            "locationName": "fromPort",
	            "type": "integer"
	          },
	          "IpProtocol": {
	            "locationName": "ipProtocol"
	          },
	          "IpRanges": {
	            "locationName": "ipRanges",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "CidrIp": {
	                  "locationName": "cidrIp"
	                },
	                "Description": {
	                  "locationName": "description"
	                }
	              }
	            }
	          },
	          "Ipv6Ranges": {
	            "locationName": "ipv6Ranges",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "CidrIpv6": {
	                  "locationName": "cidrIpv6"
	                },
	                "Description": {
	                  "locationName": "description"
	                }
	              }
	            }
	          },
	          "PrefixListIds": {
	            "locationName": "prefixListIds",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Description": {
	                  "locationName": "description"
	                },
	                "PrefixListId": {
	                  "locationName": "prefixListId"
	                }
	              }
	            }
	          },
	          "ToPort": {
	            "locationName": "toPort",
	            "type": "integer"
	          },
	          "UserIdGroupPairs": {
	            "locationName": "groups",
	            "type": "list",
	            "member": {
	              "shape": "S5h",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "S5h": {
	      "type": "structure",
	      "members": {
	        "Description": {
	          "locationName": "description"
	        },
	        "GroupId": {
	          "locationName": "groupId"
	        },
	        "GroupName": {
	          "locationName": "groupName"
	        },
	        "PeeringStatus": {
	          "locationName": "peeringStatus"
	        },
	        "UserId": {
	          "locationName": "userId"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "VpcPeeringConnectionId": {
	          "locationName": "vpcPeeringConnectionId"
	        }
	      }
	    },
	    "S5j": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "SecurityGroupRuleId": {
	            "locationName": "securityGroupRuleId"
	          },
	          "GroupId": {
	            "locationName": "groupId"
	          },
	          "GroupOwnerId": {
	            "locationName": "groupOwnerId"
	          },
	          "IsEgress": {
	            "locationName": "isEgress",
	            "type": "boolean"
	          },
	          "IpProtocol": {
	            "locationName": "ipProtocol"
	          },
	          "FromPort": {
	            "locationName": "fromPort",
	            "type": "integer"
	          },
	          "ToPort": {
	            "locationName": "toPort",
	            "type": "integer"
	          },
	          "CidrIpv4": {
	            "locationName": "cidrIpv4"
	          },
	          "CidrIpv6": {
	            "locationName": "cidrIpv6"
	          },
	          "PrefixListId": {
	            "locationName": "prefixListId"
	          },
	          "ReferencedGroupInfo": {
	            "locationName": "referencedGroupInfo",
	            "type": "structure",
	            "members": {
	              "GroupId": {
	                "locationName": "groupId"
	              },
	              "PeeringStatus": {
	                "locationName": "peeringStatus"
	              },
	              "UserId": {
	                "locationName": "userId"
	              },
	              "VpcId": {
	                "locationName": "vpcId"
	              },
	              "VpcPeeringConnectionId": {
	                "locationName": "vpcPeeringConnectionId"
	              }
	            }
	          },
	          "Description": {
	            "locationName": "description"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tagSet"
	          }
	        }
	      }
	    },
	    "S5s": {
	      "type": "structure",
	      "members": {
	        "S3": {
	          "type": "structure",
	          "members": {
	            "AWSAccessKeyId": {},
	            "Bucket": {
	              "locationName": "bucket"
	            },
	            "Prefix": {
	              "locationName": "prefix"
	            },
	            "UploadPolicy": {
	              "locationName": "uploadPolicy",
	              "type": "blob"
	            },
	            "UploadPolicySignature": {
	              "locationName": "uploadPolicySignature"
	            }
	          }
	        }
	      }
	    },
	    "S5w": {
	      "type": "structure",
	      "members": {
	        "BundleId": {
	          "locationName": "bundleId"
	        },
	        "BundleTaskError": {
	          "locationName": "error",
	          "type": "structure",
	          "members": {
	            "Code": {
	              "locationName": "code"
	            },
	            "Message": {
	              "locationName": "message"
	            }
	          }
	        },
	        "InstanceId": {
	          "locationName": "instanceId"
	        },
	        "Progress": {
	          "locationName": "progress"
	        },
	        "StartTime": {
	          "locationName": "startTime",
	          "type": "timestamp"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "Storage": {
	          "shape": "S5s",
	          "locationName": "storage"
	        },
	        "UpdateTime": {
	          "locationName": "updateTime",
	          "type": "timestamp"
	        }
	      }
	    },
	    "S66": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S6r": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "ClientToken": {
	            "locationName": "clientToken"
	          },
	          "CreateDate": {
	            "locationName": "createDate",
	            "type": "timestamp"
	          },
	          "InstanceCounts": {
	            "locationName": "instanceCounts",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "InstanceCount": {
	                  "locationName": "instanceCount",
	                  "type": "integer"
	                },
	                "State": {
	                  "locationName": "state"
	                }
	              }
	            }
	          },
	          "PriceSchedules": {
	            "locationName": "priceSchedules",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "Active": {
	                  "locationName": "active",
	                  "type": "boolean"
	                },
	                "CurrencyCode": {
	                  "locationName": "currencyCode"
	                },
	                "Price": {
	                  "locationName": "price",
	                  "type": "double"
	                },
	                "Term": {
	                  "locationName": "term",
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "ReservedInstancesId": {
	            "locationName": "reservedInstancesId"
	          },
	          "ReservedInstancesListingId": {
	            "locationName": "reservedInstancesListingId"
	          },
	          "Status": {
	            "locationName": "status"
	          },
	          "StatusMessage": {
	            "locationName": "statusMessage"
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tagSet"
	          },
	          "UpdateDate": {
	            "locationName": "updateDate",
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "S73": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S7e": {
	      "type": "list",
	      "member": {
	        "locationName": "SpotInstanceRequestId"
	      }
	    },
	    "S81": {
	      "type": "structure",
	      "members": {
	        "CapacityReservationId": {
	          "locationName": "capacityReservationId"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "CapacityReservationArn": {
	          "locationName": "capacityReservationArn"
	        },
	        "AvailabilityZoneId": {
	          "locationName": "availabilityZoneId"
	        },
	        "InstanceType": {
	          "locationName": "instanceType"
	        },
	        "InstancePlatform": {
	          "locationName": "instancePlatform"
	        },
	        "AvailabilityZone": {
	          "locationName": "availabilityZone"
	        },
	        "Tenancy": {
	          "locationName": "tenancy"
	        },
	        "TotalInstanceCount": {
	          "locationName": "totalInstanceCount",
	          "type": "integer"
	        },
	        "AvailableInstanceCount": {
	          "locationName": "availableInstanceCount",
	          "type": "integer"
	        },
	        "EbsOptimized": {
	          "locationName": "ebsOptimized",
	          "type": "boolean"
	        },
	        "EphemeralStorage": {
	          "locationName": "ephemeralStorage",
	          "type": "boolean"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "StartDate": {
	          "locationName": "startDate",
	          "type": "timestamp"
	        },
	        "EndDate": {
	          "locationName": "endDate",
	          "type": "timestamp"
	        },
	        "EndDateType": {
	          "locationName": "endDateType"
	        },
	        "InstanceMatchCriteria": {
	          "locationName": "instanceMatchCriteria"
	        },
	        "CreateDate": {
	          "locationName": "createDate",
	          "type": "timestamp"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "OutpostArn": {
	          "locationName": "outpostArn"
	        },
	        "CapacityReservationFleetId": {
	          "locationName": "capacityReservationFleetId"
	        },
	        "PlacementGroupArn": {
	          "locationName": "placementGroupArn"
	        }
	      }
	    },
	    "S8d": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "CapacityReservationId": {
	            "locationName": "capacityReservationId"
	          },
	          "AvailabilityZoneId": {
	            "locationName": "availabilityZoneId"
	          },
	          "InstanceType": {
	            "locationName": "instanceType"
	          },
	          "InstancePlatform": {
	            "locationName": "instancePlatform"
	          },
	          "AvailabilityZone": {
	            "locationName": "availabilityZone"
	          },
	          "TotalInstanceCount": {
	            "locationName": "totalInstanceCount",
	            "type": "integer"
	          },
	          "FulfilledCapacity": {
	            "locationName": "fulfilledCapacity",
	            "type": "double"
	          },
	          "EbsOptimized": {
	            "locationName": "ebsOptimized",
	            "type": "boolean"
	          },
	          "CreateDate": {
	            "locationName": "createDate",
	            "type": "timestamp"
	          },
	          "Weight": {
	            "locationName": "weight",
	            "type": "double"
	          },
	          "Priority": {
	            "locationName": "priority",
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S8h": {
	      "type": "structure",
	      "members": {
	        "CarrierGatewayId": {
	          "locationName": "carrierGatewayId"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "S8r": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "CloudwatchLogGroup": {},
	        "CloudwatchLogStream": {}
	      }
	    },
	    "S8u": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "LambdaFunctionArn": {}
	      }
	    },
	    "S8v": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "BannerText": {}
	      }
	    },
	    "S8x": {
	      "type": "structure",
	      "members": {
	        "Code": {
	          "locationName": "code"
	        },
	        "Message": {
	          "locationName": "message"
	        }
	      }
	    },
	    "S91": {
	      "type": "structure",
	      "members": {
	        "Code": {
	          "locationName": "code"
	        },
	        "Message": {
	          "locationName": "message"
	        }
	      }
	    },
	    "S96": {
	      "type": "structure",
	      "members": {
	        "BgpAsn": {
	          "locationName": "bgpAsn"
	        },
	        "CustomerGatewayId": {
	          "locationName": "customerGatewayId"
	        },
	        "IpAddress": {
	          "locationName": "ipAddress"
	        },
	        "CertificateArn": {
	          "locationName": "certificateArn"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "Type": {
	          "locationName": "type"
	        },
	        "DeviceName": {
	          "locationName": "deviceName"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "S99": {
	      "type": "structure",
	      "members": {
	        "AvailabilityZone": {
	          "locationName": "availabilityZone"
	        },
	        "AvailabilityZoneId": {
	          "locationName": "availabilityZoneId"
	        },
	        "AvailableIpAddressCount": {
	          "locationName": "availableIpAddressCount",
	          "type": "integer"
	        },
	        "CidrBlock": {
	          "locationName": "cidrBlock"
	        },
	        "DefaultForAz": {
	          "locationName": "defaultForAz",
	          "type": "boolean"
	        },
	        "EnableLniAtDeviceIndex": {
	          "locationName": "enableLniAtDeviceIndex",
	          "type": "integer"
	        },
	        "MapPublicIpOnLaunch": {
	          "locationName": "mapPublicIpOnLaunch",
	          "type": "boolean"
	        },
	        "MapCustomerOwnedIpOnLaunch": {
	          "locationName": "mapCustomerOwnedIpOnLaunch",
	          "type": "boolean"
	        },
	        "CustomerOwnedIpv4Pool": {
	          "locationName": "customerOwnedIpv4Pool"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "SubnetId": {
	          "locationName": "subnetId"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "AssignIpv6AddressOnCreation": {
	          "locationName": "assignIpv6AddressOnCreation",
	          "type": "boolean"
	        },
	        "Ipv6CidrBlockAssociationSet": {
	          "locationName": "ipv6CidrBlockAssociationSet",
	          "type": "list",
	          "member": {
	            "shape": "S3y",
	            "locationName": "item"
	          }
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "SubnetArn": {
	          "locationName": "subnetArn"
	        },
	        "OutpostArn": {
	          "locationName": "outpostArn"
	        },
	        "EnableDns64": {
	          "locationName": "enableDns64",
	          "type": "boolean"
	        },
	        "Ipv6Native": {
	          "locationName": "ipv6Native",
	          "type": "boolean"
	        },
	        "PrivateDnsNameOptionsOnLaunch": {
	          "locationName": "privateDnsNameOptionsOnLaunch",
	          "type": "structure",
	          "members": {
	            "HostnameType": {
	              "locationName": "hostnameType"
	            },
	            "EnableResourceNameDnsARecord": {
	              "locationName": "enableResourceNameDnsARecord",
	              "type": "boolean"
	            },
	            "EnableResourceNameDnsAAAARecord": {
	              "locationName": "enableResourceNameDnsAAAARecord",
	              "type": "boolean"
	            }
	          }
	        }
	      }
	    },
	    "S9h": {
	      "type": "structure",
	      "members": {
	        "CidrBlock": {
	          "locationName": "cidrBlock"
	        },
	        "DhcpOptionsId": {
	          "locationName": "dhcpOptionsId"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "InstanceTenancy": {
	          "locationName": "instanceTenancy"
	        },
	        "Ipv6CidrBlockAssociationSet": {
	          "locationName": "ipv6CidrBlockAssociationSet",
	          "type": "list",
	          "member": {
	            "shape": "S4j",
	            "locationName": "item"
	          }
	        },
	        "CidrBlockAssociationSet": {
	          "locationName": "cidrBlockAssociationSet",
	          "type": "list",
	          "member": {
	            "shape": "S4m",
	            "locationName": "item"
	          }
	        },
	        "IsDefault": {
	          "locationName": "isDefault",
	          "type": "boolean"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "S9q": {
	      "type": "structure",
	      "members": {
	        "DhcpConfigurations": {
	          "locationName": "dhcpConfigurationSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "Key": {
	                "locationName": "key"
	              },
	              "Values": {
	                "locationName": "valueSet",
	                "type": "list",
	                "member": {
	                  "shape": "S9u",
	                  "locationName": "item"
	                }
	              }
	            }
	          }
	        },
	        "DhcpOptionsId": {
	          "locationName": "dhcpOptionsId"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "S9u": {
	      "type": "structure",
	      "members": {
	        "Value": {
	          "locationName": "value"
	        }
	      }
	    },
	    "S9x": {
	      "type": "structure",
	      "members": {
	        "Attachments": {
	          "shape": "S9y",
	          "locationName": "attachmentSet"
	        },
	        "EgressOnlyInternetGatewayId": {
	          "locationName": "egressOnlyInternetGatewayId"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "S9y": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "State": {
	            "locationName": "state"
	          },
	          "VpcId": {
	            "locationName": "vpcId"
	          }
	        }
	      }
	    },
	    "Sad": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "LaunchTemplateSpecification": {
	            "type": "structure",
	            "members": {
	              "LaunchTemplateId": {},
	              "LaunchTemplateName": {},
	              "Version": {}
	            }
	          },
	          "Overrides": {
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "InstanceType": {},
	                "MaxPrice": {},
	                "SubnetId": {},
	                "AvailabilityZone": {},
	                "WeightedCapacity": {
	                  "type": "double"
	                },
	                "Priority": {
	                  "type": "double"
	                },
	                "Placement": {
	                  "shape": "Sak"
	                },
	                "InstanceRequirements": {
	                  "shape": "Sam"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sak": {
	      "type": "structure",
	      "members": {
	        "AvailabilityZone": {
	          "locationName": "availabilityZone"
	        },
	        "Affinity": {
	          "locationName": "affinity"
	        },
	        "GroupName": {
	          "locationName": "groupName"
	        },
	        "PartitionNumber": {
	          "locationName": "partitionNumber",
	          "type": "integer"
	        },
	        "HostId": {
	          "locationName": "hostId"
	        },
	        "Tenancy": {
	          "locationName": "tenancy"
	        },
	        "SpreadDomain": {
	          "locationName": "spreadDomain"
	        },
	        "HostResourceGroupArn": {
	          "locationName": "hostResourceGroupArn"
	        }
	      }
	    },
	    "Sam": {
	      "type": "structure",
	      "required": [
	        "VCpuCount",
	        "MemoryMiB"
	      ],
	      "members": {
	        "VCpuCount": {
	          "type": "structure",
	          "required": [
	            "Min"
	          ],
	          "members": {
	            "Min": {
	              "type": "integer"
	            },
	            "Max": {
	              "type": "integer"
	            }
	          }
	        },
	        "MemoryMiB": {
	          "type": "structure",
	          "required": [
	            "Min"
	          ],
	          "members": {
	            "Min": {
	              "type": "integer"
	            },
	            "Max": {
	              "type": "integer"
	            }
	          }
	        },
	        "CpuManufacturers": {
	          "shape": "Sap",
	          "locationName": "CpuManufacturer"
	        },
	        "MemoryGiBPerVCpu": {
	          "type": "structure",
	          "members": {
	            "Min": {
	              "type": "double"
	            },
	            "Max": {
	              "type": "double"
	            }
	          }
	        },
	        "ExcludedInstanceTypes": {
	          "shape": "Sas",
	          "locationName": "ExcludedInstanceType"
	        },
	        "InstanceGenerations": {
	          "shape": "Sau",
	          "locationName": "InstanceGeneration"
	        },
	        "SpotMaxPricePercentageOverLowestPrice": {
	          "type": "integer"
	        },
	        "OnDemandMaxPricePercentageOverLowestPrice": {
	          "type": "integer"
	        },
	        "BareMetal": {},
	        "BurstablePerformance": {},
	        "RequireHibernateSupport": {
	          "type": "boolean"
	        },
	        "NetworkInterfaceCount": {
	          "type": "structure",
	          "members": {
	            "Min": {
	              "type": "integer"
	            },
	            "Max": {
	              "type": "integer"
	            }
	          }
	        },
	        "LocalStorage": {},
	        "LocalStorageTypes": {
	          "shape": "Sb0",
	          "locationName": "LocalStorageType"
	        },
	        "TotalLocalStorageGB": {
	          "type": "structure",
	          "members": {
	            "Min": {
	              "type": "double"
	            },
	            "Max": {
	              "type": "double"
	            }
	          }
	        },
	        "BaselineEbsBandwidthMbps": {
	          "type": "structure",
	          "members": {
	            "Min": {
	              "type": "integer"
	            },
	            "Max": {
	              "type": "integer"
	            }
	          }
	        },
	        "AcceleratorTypes": {
	          "shape": "Sb4",
	          "locationName": "AcceleratorType"
	        },
	        "AcceleratorCount": {
	          "type": "structure",
	          "members": {
	            "Min": {
	              "type": "integer"
	            },
	            "Max": {
	              "type": "integer"
	            }
	          }
	        },
	        "AcceleratorManufacturers": {
	          "shape": "Sb7",
	          "locationName": "AcceleratorManufacturer"
	        },
	        "AcceleratorNames": {
	          "shape": "Sb9",
	          "locationName": "AcceleratorName"
	        },
	        "AcceleratorTotalMemoryMiB": {
	          "type": "structure",
	          "members": {
	            "Min": {
	              "type": "integer"
	            },
	            "Max": {
	              "type": "integer"
	            }
	          }
	        }
	      }
	    },
	    "Sap": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sas": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sau": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sb0": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sb4": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sb7": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sb9": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sbc": {
	      "type": "structure",
	      "required": [
	        "TotalTargetCapacity"
	      ],
	      "members": {
	        "TotalTargetCapacity": {
	          "type": "integer"
	        },
	        "OnDemandTargetCapacity": {
	          "type": "integer"
	        },
	        "SpotTargetCapacity": {
	          "type": "integer"
	        },
	        "DefaultTargetCapacityType": {},
	        "TargetCapacityUnitType": {}
	      }
	    },
	    "Sbk": {
	      "type": "structure",
	      "members": {
	        "LaunchTemplateSpecification": {
	          "shape": "Sbl",
	          "locationName": "launchTemplateSpecification"
	        },
	        "Overrides": {
	          "shape": "Sbm",
	          "locationName": "overrides"
	        }
	      }
	    },
	    "Sbl": {
	      "type": "structure",
	      "members": {
	        "LaunchTemplateId": {
	          "locationName": "launchTemplateId"
	        },
	        "LaunchTemplateName": {
	          "locationName": "launchTemplateName"
	        },
	        "Version": {
	          "locationName": "version"
	        }
	      }
	    },
	    "Sbm": {
	      "type": "structure",
	      "members": {
	        "InstanceType": {
	          "locationName": "instanceType"
	        },
	        "MaxPrice": {
	          "locationName": "maxPrice"
	        },
	        "SubnetId": {
	          "locationName": "subnetId"
	        },
	        "AvailabilityZone": {
	          "locationName": "availabilityZone"
	        },
	        "WeightedCapacity": {
	          "locationName": "weightedCapacity",
	          "type": "double"
	        },
	        "Priority": {
	          "locationName": "priority",
	          "type": "double"
	        },
	        "Placement": {
	          "locationName": "placement",
	          "type": "structure",
	          "members": {
	            "GroupName": {
	              "locationName": "groupName"
	            }
	          }
	        },
	        "InstanceRequirements": {
	          "shape": "Sbo",
	          "locationName": "instanceRequirements"
	        }
	      }
	    },
	    "Sbo": {
	      "type": "structure",
	      "members": {
	        "VCpuCount": {
	          "locationName": "vCpuCount",
	          "type": "structure",
	          "members": {
	            "Min": {
	              "locationName": "min",
	              "type": "integer"
	            },
	            "Max": {
	              "locationName": "max",
	              "type": "integer"
	            }
	          }
	        },
	        "MemoryMiB": {
	          "locationName": "memoryMiB",
	          "type": "structure",
	          "members": {
	            "Min": {
	              "locationName": "min",
	              "type": "integer"
	            },
	            "Max": {
	              "locationName": "max",
	              "type": "integer"
	            }
	          }
	        },
	        "CpuManufacturers": {
	          "shape": "Sap",
	          "locationName": "cpuManufacturerSet"
	        },
	        "MemoryGiBPerVCpu": {
	          "locationName": "memoryGiBPerVCpu",
	          "type": "structure",
	          "members": {
	            "Min": {
	              "locationName": "min",
	              "type": "double"
	            },
	            "Max": {
	              "locationName": "max",
	              "type": "double"
	            }
	          }
	        },
	        "ExcludedInstanceTypes": {
	          "shape": "Sas",
	          "locationName": "excludedInstanceTypeSet"
	        },
	        "InstanceGenerations": {
	          "shape": "Sau",
	          "locationName": "instanceGenerationSet"
	        },
	        "SpotMaxPricePercentageOverLowestPrice": {
	          "locationName": "spotMaxPricePercentageOverLowestPrice",
	          "type": "integer"
	        },
	        "OnDemandMaxPricePercentageOverLowestPrice": {
	          "locationName": "onDemandMaxPricePercentageOverLowestPrice",
	          "type": "integer"
	        },
	        "BareMetal": {
	          "locationName": "bareMetal"
	        },
	        "BurstablePerformance": {
	          "locationName": "burstablePerformance"
	        },
	        "RequireHibernateSupport": {
	          "locationName": "requireHibernateSupport",
	          "type": "boolean"
	        },
	        "NetworkInterfaceCount": {
	          "locationName": "networkInterfaceCount",
	          "type": "structure",
	          "members": {
	            "Min": {
	              "locationName": "min",
	              "type": "integer"
	            },
	            "Max": {
	              "locationName": "max",
	              "type": "integer"
	            }
	          }
	        },
	        "LocalStorage": {
	          "locationName": "localStorage"
	        },
	        "LocalStorageTypes": {
	          "shape": "Sb0",
	          "locationName": "localStorageTypeSet"
	        },
	        "TotalLocalStorageGB": {
	          "locationName": "totalLocalStorageGB",
	          "type": "structure",
	          "members": {
	            "Min": {
	              "locationName": "min",
	              "type": "double"
	            },
	            "Max": {
	              "locationName": "max",
	              "type": "double"
	            }
	          }
	        },
	        "BaselineEbsBandwidthMbps": {
	          "locationName": "baselineEbsBandwidthMbps",
	          "type": "structure",
	          "members": {
	            "Min": {
	              "locationName": "min",
	              "type": "integer"
	            },
	            "Max": {
	              "locationName": "max",
	              "type": "integer"
	            }
	          }
	        },
	        "AcceleratorTypes": {
	          "shape": "Sb4",
	          "locationName": "acceleratorTypeSet"
	        },
	        "AcceleratorCount": {
	          "locationName": "acceleratorCount",
	          "type": "structure",
	          "members": {
	            "Min": {
	              "locationName": "min",
	              "type": "integer"
	            },
	            "Max": {
	              "locationName": "max",
	              "type": "integer"
	            }
	          }
	        },
	        "AcceleratorManufacturers": {
	          "shape": "Sb7",
	          "locationName": "acceleratorManufacturerSet"
	        },
	        "AcceleratorNames": {
	          "shape": "Sb9",
	          "locationName": "acceleratorNameSet"
	        },
	        "AcceleratorTotalMemoryMiB": {
	          "locationName": "acceleratorTotalMemoryMiB",
	          "type": "structure",
	          "members": {
	            "Min": {
	              "locationName": "min",
	              "type": "integer"
	            },
	            "Max": {
	              "locationName": "max",
	              "type": "integer"
	            }
	          }
	        }
	      }
	    },
	    "Sc0": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Scc": {
	      "type": "structure",
	      "members": {
	        "Bucket": {},
	        "Key": {}
	      }
	    },
	    "Scf": {
	      "type": "list",
	      "member": {
	        "shape": "Scg",
	        "locationName": "BlockDeviceMapping"
	      }
	    },
	    "Scg": {
	      "type": "structure",
	      "members": {
	        "DeviceName": {
	          "locationName": "deviceName"
	        },
	        "VirtualName": {
	          "locationName": "virtualName"
	        },
	        "Ebs": {
	          "locationName": "ebs",
	          "type": "structure",
	          "members": {
	            "DeleteOnTermination": {
	              "locationName": "deleteOnTermination",
	              "type": "boolean"
	            },
	            "Iops": {
	              "locationName": "iops",
	              "type": "integer"
	            },
	            "SnapshotId": {
	              "locationName": "snapshotId"
	            },
	            "VolumeSize": {
	              "locationName": "volumeSize",
	              "type": "integer"
	            },
	            "VolumeType": {
	              "locationName": "volumeType"
	            },
	            "KmsKeyId": {},
	            "Throughput": {
	              "locationName": "throughput",
	              "type": "integer"
	            },
	            "OutpostArn": {
	              "locationName": "outpostArn"
	            },
	            "Encrypted": {
	              "locationName": "encrypted",
	              "type": "boolean"
	            }
	          }
	        },
	        "NoDevice": {
	          "locationName": "noDevice"
	        }
	      }
	    },
	    "Scm": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "StartWeekDay": {},
	          "StartHour": {
	            "type": "integer"
	          },
	          "EndWeekDay": {},
	          "EndHour": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "Scv": {
	      "type": "structure",
	      "members": {
	        "Description": {
	          "locationName": "description"
	        },
	        "ExportTaskId": {
	          "locationName": "exportTaskId"
	        },
	        "ExportToS3Task": {
	          "locationName": "exportToS3",
	          "type": "structure",
	          "members": {
	            "ContainerFormat": {
	              "locationName": "containerFormat"
	            },
	            "DiskImageFormat": {
	              "locationName": "diskImageFormat"
	            },
	            "S3Bucket": {
	              "locationName": "s3Bucket"
	            },
	            "S3Key": {
	              "locationName": "s3Key"
	            }
	          }
	        },
	        "InstanceExportDetails": {
	          "locationName": "instanceExport",
	          "type": "structure",
	          "members": {
	            "InstanceId": {
	              "locationName": "instanceId"
	            },
	            "TargetEnvironment": {
	              "locationName": "targetEnvironment"
	            }
	          }
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "StatusMessage": {
	          "locationName": "statusMessage"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sd1": {
	      "type": "structure",
	      "members": {
	        "Attachments": {
	          "shape": "S9y",
	          "locationName": "attachmentSet"
	        },
	        "InternetGatewayId": {
	          "locationName": "internetGatewayId"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sd3": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "RegionName": {}
	        }
	      }
	    },
	    "Sd6": {
	      "type": "structure",
	      "members": {
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "IpamId": {
	          "locationName": "ipamId"
	        },
	        "IpamArn": {
	          "locationName": "ipamArn"
	        },
	        "IpamRegion": {
	          "locationName": "ipamRegion"
	        },
	        "PublicDefaultScopeId": {
	          "locationName": "publicDefaultScopeId"
	        },
	        "PrivateDefaultScopeId": {
	          "locationName": "privateDefaultScopeId"
	        },
	        "ScopeCount": {
	          "locationName": "scopeCount",
	          "type": "integer"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "OperatingRegions": {
	          "locationName": "operatingRegionSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "RegionName": {
	                "locationName": "regionName"
	              }
	            }
	          }
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sdf": {
	      "type": "list",
	      "member": {
	        "shape": "Sdg",
	        "locationName": "item"
	      }
	    },
	    "Sdg": {
	      "type": "structure",
	      "members": {
	        "Key": {},
	        "Value": {}
	      }
	    },
	    "Sdj": {
	      "type": "structure",
	      "members": {
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "IpamPoolId": {
	          "locationName": "ipamPoolId"
	        },
	        "SourceIpamPoolId": {
	          "locationName": "sourceIpamPoolId"
	        },
	        "IpamPoolArn": {
	          "locationName": "ipamPoolArn"
	        },
	        "IpamScopeArn": {
	          "locationName": "ipamScopeArn"
	        },
	        "IpamScopeType": {
	          "locationName": "ipamScopeType"
	        },
	        "IpamArn": {
	          "locationName": "ipamArn"
	        },
	        "IpamRegion": {
	          "locationName": "ipamRegion"
	        },
	        "Locale": {
	          "locationName": "locale"
	        },
	        "PoolDepth": {
	          "locationName": "poolDepth",
	          "type": "integer"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "StateMessage": {
	          "locationName": "stateMessage"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "AutoImport": {
	          "locationName": "autoImport",
	          "type": "boolean"
	        },
	        "PubliclyAdvertisable": {
	          "locationName": "publiclyAdvertisable",
	          "type": "boolean"
	        },
	        "AddressFamily": {
	          "locationName": "addressFamily"
	        },
	        "AllocationMinNetmaskLength": {
	          "locationName": "allocationMinNetmaskLength",
	          "type": "integer"
	        },
	        "AllocationMaxNetmaskLength": {
	          "locationName": "allocationMaxNetmaskLength",
	          "type": "integer"
	        },
	        "AllocationDefaultNetmaskLength": {
	          "locationName": "allocationDefaultNetmaskLength",
	          "type": "integer"
	        },
	        "AllocationResourceTags": {
	          "shape": "Sdm",
	          "locationName": "allocationResourceTagSet"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "AwsService": {
	          "locationName": "awsService"
	        }
	      }
	    },
	    "Sdm": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Key": {
	            "locationName": "key"
	          },
	          "Value": {
	            "locationName": "value"
	          }
	        }
	      }
	    },
	    "Sdq": {
	      "type": "structure",
	      "members": {
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "IpamScopeId": {
	          "locationName": "ipamScopeId"
	        },
	        "IpamScopeArn": {
	          "locationName": "ipamScopeArn"
	        },
	        "IpamArn": {
	          "locationName": "ipamArn"
	        },
	        "IpamRegion": {
	          "locationName": "ipamRegion"
	        },
	        "IpamScopeType": {
	          "locationName": "ipamScopeType"
	        },
	        "IsDefault": {
	          "locationName": "isDefault",
	          "type": "boolean"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "PoolCount": {
	          "locationName": "poolCount",
	          "type": "integer"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sdz": {
	      "type": "structure",
	      "members": {
	        "KernelId": {},
	        "EbsOptimized": {
	          "type": "boolean"
	        },
	        "IamInstanceProfile": {
	          "type": "structure",
	          "members": {
	            "Arn": {},
	            "Name": {}
	          }
	        },
	        "BlockDeviceMappings": {
	          "locationName": "BlockDeviceMapping",
	          "type": "list",
	          "member": {
	            "locationName": "BlockDeviceMapping",
	            "type": "structure",
	            "members": {
	              "DeviceName": {},
	              "VirtualName": {},
	              "Ebs": {
	                "type": "structure",
	                "members": {
	                  "Encrypted": {
	                    "type": "boolean"
	                  },
	                  "DeleteOnTermination": {
	                    "type": "boolean"
	                  },
	                  "Iops": {
	                    "type": "integer"
	                  },
	                  "KmsKeyId": {},
	                  "SnapshotId": {},
	                  "VolumeSize": {
	                    "type": "integer"
	                  },
	                  "VolumeType": {},
	                  "Throughput": {
	                    "type": "integer"
	                  }
	                }
	              },
	              "NoDevice": {}
	            }
	          }
	        },
	        "NetworkInterfaces": {
	          "locationName": "NetworkInterface",
	          "type": "list",
	          "member": {
	            "locationName": "InstanceNetworkInterfaceSpecification",
	            "type": "structure",
	            "members": {
	              "AssociateCarrierIpAddress": {
	                "type": "boolean"
	              },
	              "AssociatePublicIpAddress": {
	                "type": "boolean"
	              },
	              "DeleteOnTermination": {
	                "type": "boolean"
	              },
	              "Description": {},
	              "DeviceIndex": {
	                "type": "integer"
	              },
	              "Groups": {
	                "shape": "Se7",
	                "locationName": "SecurityGroupId"
	              },
	              "InterfaceType": {},
	              "Ipv6AddressCount": {
	                "type": "integer"
	              },
	              "Ipv6Addresses": {
	                "type": "list",
	                "member": {
	                  "locationName": "InstanceIpv6Address",
	                  "type": "structure",
	                  "members": {
	                    "Ipv6Address": {}
	                  }
	                }
	              },
	              "NetworkInterfaceId": {},
	              "PrivateIpAddress": {},
	              "PrivateIpAddresses": {
	                "shape": "Sea"
	              },
	              "SecondaryPrivateIpAddressCount": {
	                "type": "integer"
	              },
	              "SubnetId": {},
	              "NetworkCardIndex": {
	                "type": "integer"
	              },
	              "Ipv4Prefixes": {
	                "shape": "Sec",
	                "locationName": "Ipv4Prefix"
	              },
	              "Ipv4PrefixCount": {
	                "type": "integer"
	              },
	              "Ipv6Prefixes": {
	                "shape": "See",
	                "locationName": "Ipv6Prefix"
	              },
	              "Ipv6PrefixCount": {
	                "type": "integer"
	              }
	            }
	          }
	        },
	        "ImageId": {},
	        "InstanceType": {},
	        "KeyName": {},
	        "Monitoring": {
	          "type": "structure",
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            }
	          }
	        },
	        "Placement": {
	          "type": "structure",
	          "members": {
	            "AvailabilityZone": {},
	            "Affinity": {},
	            "GroupName": {},
	            "HostId": {},
	            "Tenancy": {},
	            "SpreadDomain": {},
	            "HostResourceGroupArn": {},
	            "PartitionNumber": {
	              "type": "integer"
	            }
	          }
	        },
	        "RamDiskId": {},
	        "DisableApiTermination": {
	          "type": "boolean"
	        },
	        "InstanceInitiatedShutdownBehavior": {},
	        "UserData": {},
	        "TagSpecifications": {
	          "locationName": "TagSpecification",
	          "type": "list",
	          "member": {
	            "locationName": "LaunchTemplateTagSpecificationRequest",
	            "type": "structure",
	            "members": {
	              "ResourceType": {},
	              "Tags": {
	                "shape": "Ss",
	                "locationName": "Tag"
	              }
	            }
	          }
	        },
	        "ElasticGpuSpecifications": {
	          "locationName": "ElasticGpuSpecification",
	          "type": "list",
	          "member": {
	            "shape": "Sep",
	            "locationName": "ElasticGpuSpecification"
	          }
	        },
	        "ElasticInferenceAccelerators": {
	          "locationName": "ElasticInferenceAccelerator",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "required": [
	              "Type"
	            ],
	            "members": {
	              "Type": {},
	              "Count": {
	                "type": "integer"
	              }
	            }
	          }
	        },
	        "SecurityGroupIds": {
	          "shape": "Se7",
	          "locationName": "SecurityGroupId"
	        },
	        "SecurityGroups": {
	          "shape": "Set",
	          "locationName": "SecurityGroup"
	        },
	        "InstanceMarketOptions": {
	          "type": "structure",
	          "members": {
	            "MarketType": {},
	            "SpotOptions": {
	              "type": "structure",
	              "members": {
	                "MaxPrice": {},
	                "SpotInstanceType": {},
	                "BlockDurationMinutes": {
	                  "type": "integer"
	                },
	                "ValidUntil": {
	                  "type": "timestamp"
	                },
	                "InstanceInterruptionBehavior": {}
	              }
	            }
	          }
	        },
	        "CreditSpecification": {
	          "shape": "Sez"
	        },
	        "CpuOptions": {
	          "type": "structure",
	          "members": {
	            "CoreCount": {
	              "type": "integer"
	            },
	            "ThreadsPerCore": {
	              "type": "integer"
	            }
	          }
	        },
	        "CapacityReservationSpecification": {
	          "type": "structure",
	          "members": {
	            "CapacityReservationPreference": {},
	            "CapacityReservationTarget": {
	              "shape": "Sf3"
	            }
	          }
	        },
	        "LicenseSpecifications": {
	          "locationName": "LicenseSpecification",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "LicenseConfigurationArn": {}
	            }
	          }
	        },
	        "HibernationOptions": {
	          "type": "structure",
	          "members": {
	            "Configured": {
	              "type": "boolean"
	            }
	          }
	        },
	        "MetadataOptions": {
	          "type": "structure",
	          "members": {
	            "HttpTokens": {},
	            "HttpPutResponseHopLimit": {
	              "type": "integer"
	            },
	            "HttpEndpoint": {},
	            "HttpProtocolIpv6": {},
	            "InstanceMetadataTags": {}
	          }
	        },
	        "EnclaveOptions": {
	          "type": "structure",
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            }
	          }
	        },
	        "InstanceRequirements": {
	          "shape": "Sam"
	        },
	        "PrivateDnsNameOptions": {
	          "type": "structure",
	          "members": {
	            "HostnameType": {},
	            "EnableResourceNameDnsARecord": {
	              "type": "boolean"
	            },
	            "EnableResourceNameDnsAAAARecord": {
	              "type": "boolean"
	            }
	          }
	        },
	        "MaintenanceOptions": {
	          "type": "structure",
	          "members": {
	            "AutoRecovery": {}
	          }
	        },
	        "DisableApiStop": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Se7": {
	      "type": "list",
	      "member": {
	        "locationName": "SecurityGroupId"
	      }
	    },
	    "Sea": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Primary": {
	            "locationName": "primary",
	            "type": "boolean"
	          },
	          "PrivateIpAddress": {
	            "locationName": "privateIpAddress"
	          }
	        }
	      }
	    },
	    "Sec": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Ipv4Prefix": {}
	        }
	      }
	    },
	    "See": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Ipv6Prefix": {}
	        }
	      }
	    },
	    "Sep": {
	      "type": "structure",
	      "required": [
	        "Type"
	      ],
	      "members": {
	        "Type": {}
	      }
	    },
	    "Set": {
	      "type": "list",
	      "member": {
	        "locationName": "SecurityGroup"
	      }
	    },
	    "Sez": {
	      "type": "structure",
	      "required": [
	        "CpuCredits"
	      ],
	      "members": {
	        "CpuCredits": {}
	      }
	    },
	    "Sf3": {
	      "type": "structure",
	      "members": {
	        "CapacityReservationId": {},
	        "CapacityReservationResourceGroupArn": {}
	      }
	    },
	    "Sfh": {
	      "type": "structure",
	      "members": {
	        "LaunchTemplateId": {
	          "locationName": "launchTemplateId"
	        },
	        "LaunchTemplateName": {
	          "locationName": "launchTemplateName"
	        },
	        "CreateTime": {
	          "locationName": "createTime",
	          "type": "timestamp"
	        },
	        "CreatedBy": {
	          "locationName": "createdBy"
	        },
	        "DefaultVersionNumber": {
	          "locationName": "defaultVersionNumber",
	          "type": "long"
	        },
	        "LatestVersionNumber": {
	          "locationName": "latestVersionNumber",
	          "type": "long"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sfi": {
	      "type": "structure",
	      "members": {
	        "Errors": {
	          "locationName": "errorSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "Code": {
	                "locationName": "code"
	              },
	              "Message": {
	                "locationName": "message"
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sfn": {
	      "type": "structure",
	      "members": {
	        "LaunchTemplateId": {
	          "locationName": "launchTemplateId"
	        },
	        "LaunchTemplateName": {
	          "locationName": "launchTemplateName"
	        },
	        "VersionNumber": {
	          "locationName": "versionNumber",
	          "type": "long"
	        },
	        "VersionDescription": {
	          "locationName": "versionDescription"
	        },
	        "CreateTime": {
	          "locationName": "createTime",
	          "type": "timestamp"
	        },
	        "CreatedBy": {
	          "locationName": "createdBy"
	        },
	        "DefaultVersion": {
	          "locationName": "defaultVersion",
	          "type": "boolean"
	        },
	        "LaunchTemplateData": {
	          "shape": "Sfo",
	          "locationName": "launchTemplateData"
	        }
	      }
	    },
	    "Sfo": {
	      "type": "structure",
	      "members": {
	        "KernelId": {
	          "locationName": "kernelId"
	        },
	        "EbsOptimized": {
	          "locationName": "ebsOptimized",
	          "type": "boolean"
	        },
	        "IamInstanceProfile": {
	          "locationName": "iamInstanceProfile",
	          "type": "structure",
	          "members": {
	            "Arn": {
	              "locationName": "arn"
	            },
	            "Name": {
	              "locationName": "name"
	            }
	          }
	        },
	        "BlockDeviceMappings": {
	          "locationName": "blockDeviceMappingSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "DeviceName": {
	                "locationName": "deviceName"
	              },
	              "VirtualName": {
	                "locationName": "virtualName"
	              },
	              "Ebs": {
	                "locationName": "ebs",
	                "type": "structure",
	                "members": {
	                  "Encrypted": {
	                    "locationName": "encrypted",
	                    "type": "boolean"
	                  },
	                  "DeleteOnTermination": {
	                    "locationName": "deleteOnTermination",
	                    "type": "boolean"
	                  },
	                  "Iops": {
	                    "locationName": "iops",
	                    "type": "integer"
	                  },
	                  "KmsKeyId": {
	                    "locationName": "kmsKeyId"
	                  },
	                  "SnapshotId": {
	                    "locationName": "snapshotId"
	                  },
	                  "VolumeSize": {
	                    "locationName": "volumeSize",
	                    "type": "integer"
	                  },
	                  "VolumeType": {
	                    "locationName": "volumeType"
	                  },
	                  "Throughput": {
	                    "locationName": "throughput",
	                    "type": "integer"
	                  }
	                }
	              },
	              "NoDevice": {
	                "locationName": "noDevice"
	              }
	            }
	          }
	        },
	        "NetworkInterfaces": {
	          "locationName": "networkInterfaceSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "AssociateCarrierIpAddress": {
	                "locationName": "associateCarrierIpAddress",
	                "type": "boolean"
	              },
	              "AssociatePublicIpAddress": {
	                "locationName": "associatePublicIpAddress",
	                "type": "boolean"
	              },
	              "DeleteOnTermination": {
	                "locationName": "deleteOnTermination",
	                "type": "boolean"
	              },
	              "Description": {
	                "locationName": "description"
	              },
	              "DeviceIndex": {
	                "locationName": "deviceIndex",
	                "type": "integer"
	              },
	              "Groups": {
	                "shape": "S4o",
	                "locationName": "groupSet"
	              },
	              "InterfaceType": {
	                "locationName": "interfaceType"
	              },
	              "Ipv6AddressCount": {
	                "locationName": "ipv6AddressCount",
	                "type": "integer"
	              },
	              "Ipv6Addresses": {
	                "shape": "Sfv",
	                "locationName": "ipv6AddressesSet"
	              },
	              "NetworkInterfaceId": {
	                "locationName": "networkInterfaceId"
	              },
	              "PrivateIpAddress": {
	                "locationName": "privateIpAddress"
	              },
	              "PrivateIpAddresses": {
	                "shape": "Sea",
	                "locationName": "privateIpAddressesSet"
	              },
	              "SecondaryPrivateIpAddressCount": {
	                "locationName": "secondaryPrivateIpAddressCount",
	                "type": "integer"
	              },
	              "SubnetId": {
	                "locationName": "subnetId"
	              },
	              "NetworkCardIndex": {
	                "locationName": "networkCardIndex",
	                "type": "integer"
	              },
	              "Ipv4Prefixes": {
	                "locationName": "ipv4PrefixSet",
	                "type": "list",
	                "member": {
	                  "locationName": "item",
	                  "type": "structure",
	                  "members": {
	                    "Ipv4Prefix": {
	                      "locationName": "ipv4Prefix"
	                    }
	                  }
	                }
	              },
	              "Ipv4PrefixCount": {
	                "locationName": "ipv4PrefixCount",
	                "type": "integer"
	              },
	              "Ipv6Prefixes": {
	                "locationName": "ipv6PrefixSet",
	                "type": "list",
	                "member": {
	                  "locationName": "item",
	                  "type": "structure",
	                  "members": {
	                    "Ipv6Prefix": {
	                      "locationName": "ipv6Prefix"
	                    }
	                  }
	                }
	              },
	              "Ipv6PrefixCount": {
	                "locationName": "ipv6PrefixCount",
	                "type": "integer"
	              }
	            }
	          }
	        },
	        "ImageId": {
	          "locationName": "imageId"
	        },
	        "InstanceType": {
	          "locationName": "instanceType"
	        },
	        "KeyName": {
	          "locationName": "keyName"
	        },
	        "Monitoring": {
	          "locationName": "monitoring",
	          "type": "structure",
	          "members": {
	            "Enabled": {
	              "locationName": "enabled",
	              "type": "boolean"
	            }
	          }
	        },
	        "Placement": {
	          "locationName": "placement",
	          "type": "structure",
	          "members": {
	            "AvailabilityZone": {
	              "locationName": "availabilityZone"
	            },
	            "Affinity": {
	              "locationName": "affinity"
	            },
	            "GroupName": {
	              "locationName": "groupName"
	            },
	            "HostId": {
	              "locationName": "hostId"
	            },
	            "Tenancy": {
	              "locationName": "tenancy"
	            },
	            "SpreadDomain": {
	              "locationName": "spreadDomain"
	            },
	            "HostResourceGroupArn": {
	              "locationName": "hostResourceGroupArn"
	            },
	            "PartitionNumber": {
	              "locationName": "partitionNumber",
	              "type": "integer"
	            }
	          }
	        },
	        "RamDiskId": {
	          "locationName": "ramDiskId"
	        },
	        "DisableApiTermination": {
	          "locationName": "disableApiTermination",
	          "type": "boolean"
	        },
	        "InstanceInitiatedShutdownBehavior": {
	          "locationName": "instanceInitiatedShutdownBehavior"
	        },
	        "UserData": {
	          "locationName": "userData"
	        },
	        "TagSpecifications": {
	          "locationName": "tagSpecificationSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "ResourceType": {
	                "locationName": "resourceType"
	              },
	              "Tags": {
	                "shape": "Ss",
	                "locationName": "tagSet"
	              }
	            }
	          }
	        },
	        "ElasticGpuSpecifications": {
	          "locationName": "elasticGpuSpecificationSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "Type": {
	                "locationName": "type"
	              }
	            }
	          }
	        },
	        "ElasticInferenceAccelerators": {
	          "locationName": "elasticInferenceAcceleratorSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "Type": {
	                "locationName": "type"
	              },
	              "Count": {
	                "locationName": "count",
	                "type": "integer"
	              }
	            }
	          }
	        },
	        "SecurityGroupIds": {
	          "shape": "Se",
	          "locationName": "securityGroupIdSet"
	        },
	        "SecurityGroups": {
	          "shape": "Se",
	          "locationName": "securityGroupSet"
	        },
	        "InstanceMarketOptions": {
	          "locationName": "instanceMarketOptions",
	          "type": "structure",
	          "members": {
	            "MarketType": {
	              "locationName": "marketType"
	            },
	            "SpotOptions": {
	              "locationName": "spotOptions",
	              "type": "structure",
	              "members": {
	                "MaxPrice": {
	                  "locationName": "maxPrice"
	                },
	                "SpotInstanceType": {
	                  "locationName": "spotInstanceType"
	                },
	                "BlockDurationMinutes": {
	                  "locationName": "blockDurationMinutes",
	                  "type": "integer"
	                },
	                "ValidUntil": {
	                  "locationName": "validUntil",
	                  "type": "timestamp"
	                },
	                "InstanceInterruptionBehavior": {
	                  "locationName": "instanceInterruptionBehavior"
	                }
	              }
	            }
	          }
	        },
	        "CreditSpecification": {
	          "locationName": "creditSpecification",
	          "type": "structure",
	          "members": {
	            "CpuCredits": {
	              "locationName": "cpuCredits"
	            }
	          }
	        },
	        "CpuOptions": {
	          "locationName": "cpuOptions",
	          "type": "structure",
	          "members": {
	            "CoreCount": {
	              "locationName": "coreCount",
	              "type": "integer"
	            },
	            "ThreadsPerCore": {
	              "locationName": "threadsPerCore",
	              "type": "integer"
	            }
	          }
	        },
	        "CapacityReservationSpecification": {
	          "locationName": "capacityReservationSpecification",
	          "type": "structure",
	          "members": {
	            "CapacityReservationPreference": {
	              "locationName": "capacityReservationPreference"
	            },
	            "CapacityReservationTarget": {
	              "shape": "Sge",
	              "locationName": "capacityReservationTarget"
	            }
	          }
	        },
	        "LicenseSpecifications": {
	          "locationName": "licenseSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "LicenseConfigurationArn": {
	                "locationName": "licenseConfigurationArn"
	              }
	            }
	          }
	        },
	        "HibernationOptions": {
	          "locationName": "hibernationOptions",
	          "type": "structure",
	          "members": {
	            "Configured": {
	              "locationName": "configured",
	              "type": "boolean"
	            }
	          }
	        },
	        "MetadataOptions": {
	          "locationName": "metadataOptions",
	          "type": "structure",
	          "members": {
	            "State": {
	              "locationName": "state"
	            },
	            "HttpTokens": {
	              "locationName": "httpTokens"
	            },
	            "HttpPutResponseHopLimit": {
	              "locationName": "httpPutResponseHopLimit",
	              "type": "integer"
	            },
	            "HttpEndpoint": {
	              "locationName": "httpEndpoint"
	            },
	            "HttpProtocolIpv6": {
	              "locationName": "httpProtocolIpv6"
	            },
	            "InstanceMetadataTags": {
	              "locationName": "instanceMetadataTags"
	            }
	          }
	        },
	        "EnclaveOptions": {
	          "locationName": "enclaveOptions",
	          "type": "structure",
	          "members": {
	            "Enabled": {
	              "locationName": "enabled",
	              "type": "boolean"
	            }
	          }
	        },
	        "InstanceRequirements": {
	          "shape": "Sbo",
	          "locationName": "instanceRequirements"
	        },
	        "PrivateDnsNameOptions": {
	          "locationName": "privateDnsNameOptions",
	          "type": "structure",
	          "members": {
	            "HostnameType": {
	              "locationName": "hostnameType"
	            },
	            "EnableResourceNameDnsARecord": {
	              "locationName": "enableResourceNameDnsARecord",
	              "type": "boolean"
	            },
	            "EnableResourceNameDnsAAAARecord": {
	              "locationName": "enableResourceNameDnsAAAARecord",
	              "type": "boolean"
	            }
	          }
	        },
	        "MaintenanceOptions": {
	          "locationName": "maintenanceOptions",
	          "type": "structure",
	          "members": {
	            "AutoRecovery": {
	              "locationName": "autoRecovery"
	            }
	          }
	        },
	        "DisableApiStop": {
	          "locationName": "disableApiStop",
	          "type": "boolean"
	        }
	      }
	    },
	    "Sfv": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Ipv6Address": {
	            "locationName": "ipv6Address"
	          }
	        }
	      }
	    },
	    "Sge": {
	      "type": "structure",
	      "members": {
	        "CapacityReservationId": {
	          "locationName": "capacityReservationId"
	        },
	        "CapacityReservationResourceGroupArn": {
	          "locationName": "capacityReservationResourceGroupArn"
	        }
	      }
	    },
	    "Sgr": {
	      "type": "structure",
	      "members": {
	        "DestinationCidrBlock": {
	          "locationName": "destinationCidrBlock"
	        },
	        "LocalGatewayVirtualInterfaceGroupId": {
	          "locationName": "localGatewayVirtualInterfaceGroupId"
	        },
	        "Type": {
	          "locationName": "type"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "LocalGatewayRouteTableId": {
	          "locationName": "localGatewayRouteTableId"
	        },
	        "LocalGatewayRouteTableArn": {
	          "locationName": "localGatewayRouteTableArn"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        }
	      }
	    },
	    "Sgw": {
	      "type": "structure",
	      "members": {
	        "LocalGatewayRouteTableVpcAssociationId": {
	          "locationName": "localGatewayRouteTableVpcAssociationId"
	        },
	        "LocalGatewayRouteTableId": {
	          "locationName": "localGatewayRouteTableId"
	        },
	        "LocalGatewayRouteTableArn": {
	          "locationName": "localGatewayRouteTableArn"
	        },
	        "LocalGatewayId": {
	          "locationName": "localGatewayId"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sgz": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Cidr"
	        ],
	        "members": {
	          "Cidr": {},
	          "Description": {}
	        }
	      }
	    },
	    "Sh2": {
	      "type": "structure",
	      "members": {
	        "PrefixListId": {
	          "locationName": "prefixListId"
	        },
	        "AddressFamily": {
	          "locationName": "addressFamily"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "StateMessage": {
	          "locationName": "stateMessage"
	        },
	        "PrefixListArn": {
	          "locationName": "prefixListArn"
	        },
	        "PrefixListName": {
	          "locationName": "prefixListName"
	        },
	        "MaxEntries": {
	          "locationName": "maxEntries",
	          "type": "integer"
	        },
	        "Version": {
	          "locationName": "version",
	          "type": "long"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        }
	      }
	    },
	    "Sh7": {
	      "type": "structure",
	      "members": {
	        "CreateTime": {
	          "locationName": "createTime",
	          "type": "timestamp"
	        },
	        "DeleteTime": {
	          "locationName": "deleteTime",
	          "type": "timestamp"
	        },
	        "FailureCode": {
	          "locationName": "failureCode"
	        },
	        "FailureMessage": {
	          "locationName": "failureMessage"
	        },
	        "NatGatewayAddresses": {
	          "locationName": "natGatewayAddressSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "AllocationId": {
	                "locationName": "allocationId"
	              },
	              "NetworkInterfaceId": {
	                "locationName": "networkInterfaceId"
	              },
	              "PrivateIp": {
	                "locationName": "privateIp"
	              },
	              "PublicIp": {
	                "locationName": "publicIp"
	              }
	            }
	          }
	        },
	        "NatGatewayId": {
	          "locationName": "natGatewayId"
	        },
	        "ProvisionedBandwidth": {
	          "locationName": "provisionedBandwidth",
	          "type": "structure",
	          "members": {
	            "ProvisionTime": {
	              "locationName": "provisionTime",
	              "type": "timestamp"
	            },
	            "Provisioned": {
	              "locationName": "provisioned"
	            },
	            "RequestTime": {
	              "locationName": "requestTime",
	              "type": "timestamp"
	            },
	            "Requested": {
	              "locationName": "requested"
	            },
	            "Status": {
	              "locationName": "status"
	            }
	          }
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "SubnetId": {
	          "locationName": "subnetId"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "ConnectivityType": {
	          "locationName": "connectivityType"
	        }
	      }
	    },
	    "She": {
	      "type": "structure",
	      "members": {
	        "Associations": {
	          "locationName": "associationSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "NetworkAclAssociationId": {
	                "locationName": "networkAclAssociationId"
	              },
	              "NetworkAclId": {
	                "locationName": "networkAclId"
	              },
	              "SubnetId": {
	                "locationName": "subnetId"
	              }
	            }
	          }
	        },
	        "Entries": {
	          "locationName": "entrySet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "CidrBlock": {
	                "locationName": "cidrBlock"
	              },
	              "Egress": {
	                "locationName": "egress",
	                "type": "boolean"
	              },
	              "IcmpTypeCode": {
	                "shape": "Shj",
	                "locationName": "icmpTypeCode"
	              },
	              "Ipv6CidrBlock": {
	                "locationName": "ipv6CidrBlock"
	              },
	              "PortRange": {
	                "shape": "Shk",
	                "locationName": "portRange"
	              },
	              "Protocol": {
	                "locationName": "protocol"
	              },
	              "RuleAction": {
	                "locationName": "ruleAction"
	              },
	              "RuleNumber": {
	                "locationName": "ruleNumber",
	                "type": "integer"
	              }
	            }
	          }
	        },
	        "IsDefault": {
	          "locationName": "default",
	          "type": "boolean"
	        },
	        "NetworkAclId": {
	          "locationName": "networkAclId"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        }
	      }
	    },
	    "Shj": {
	      "type": "structure",
	      "members": {
	        "Code": {
	          "locationName": "code",
	          "type": "integer"
	        },
	        "Type": {
	          "locationName": "type",
	          "type": "integer"
	        }
	      }
	    },
	    "Shk": {
	      "type": "structure",
	      "members": {
	        "From": {
	          "locationName": "from",
	          "type": "integer"
	        },
	        "To": {
	          "locationName": "to",
	          "type": "integer"
	        }
	      }
	    },
	    "Shp": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Source": {
	            "shape": "Shr"
	          },
	          "Destination": {
	            "shape": "Shr"
	          },
	          "ThroughResources": {
	            "locationName": "ThroughResource",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ResourceStatement": {
	                  "shape": "Shv"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Shr": {
	      "type": "structure",
	      "members": {
	        "PacketHeaderStatement": {
	          "type": "structure",
	          "members": {
	            "SourceAddresses": {
	              "shape": "Se",
	              "locationName": "SourceAddress"
	            },
	            "DestinationAddresses": {
	              "shape": "Se",
	              "locationName": "DestinationAddress"
	            },
	            "SourcePorts": {
	              "shape": "Se",
	              "locationName": "SourcePort"
	            },
	            "DestinationPorts": {
	              "shape": "Se",
	              "locationName": "DestinationPort"
	            },
	            "SourcePrefixLists": {
	              "shape": "Se",
	              "locationName": "SourcePrefixList"
	            },
	            "DestinationPrefixLists": {
	              "shape": "Se",
	              "locationName": "DestinationPrefixList"
	            },
	            "Protocols": {
	              "shape": "Sht",
	              "locationName": "Protocol"
	            }
	          }
	        },
	        "ResourceStatement": {
	          "shape": "Shv"
	        }
	      }
	    },
	    "Sht": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Shv": {
	      "type": "structure",
	      "members": {
	        "Resources": {
	          "shape": "Se",
	          "locationName": "Resource"
	        },
	        "ResourceTypes": {
	          "shape": "Se",
	          "locationName": "ResourceType"
	        }
	      }
	    },
	    "Shz": {
	      "type": "structure",
	      "members": {
	        "NetworkInsightsAccessScopeId": {
	          "locationName": "networkInsightsAccessScopeId"
	        },
	        "NetworkInsightsAccessScopeArn": {
	          "locationName": "networkInsightsAccessScopeArn"
	        },
	        "CreatedDate": {
	          "locationName": "createdDate",
	          "type": "timestamp"
	        },
	        "UpdatedDate": {
	          "locationName": "updatedDate",
	          "type": "timestamp"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Si1": {
	      "type": "structure",
	      "members": {
	        "NetworkInsightsAccessScopeId": {
	          "locationName": "networkInsightsAccessScopeId"
	        },
	        "MatchPaths": {
	          "shape": "Si2",
	          "locationName": "matchPathSet"
	        },
	        "ExcludePaths": {
	          "shape": "Si2",
	          "locationName": "excludePathSet"
	        }
	      }
	    },
	    "Si2": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Source": {
	            "shape": "Si4",
	            "locationName": "source"
	          },
	          "Destination": {
	            "shape": "Si4",
	            "locationName": "destination"
	          },
	          "ThroughResources": {
	            "locationName": "throughResourceSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "ResourceStatement": {
	                  "shape": "Si6",
	                  "locationName": "resourceStatement"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Si4": {
	      "type": "structure",
	      "members": {
	        "PacketHeaderStatement": {
	          "locationName": "packetHeaderStatement",
	          "type": "structure",
	          "members": {
	            "SourceAddresses": {
	              "shape": "Se",
	              "locationName": "sourceAddressSet"
	            },
	            "DestinationAddresses": {
	              "shape": "Se",
	              "locationName": "destinationAddressSet"
	            },
	            "SourcePorts": {
	              "shape": "Se",
	              "locationName": "sourcePortSet"
	            },
	            "DestinationPorts": {
	              "shape": "Se",
	              "locationName": "destinationPortSet"
	            },
	            "SourcePrefixLists": {
	              "shape": "Se",
	              "locationName": "sourcePrefixListSet"
	            },
	            "DestinationPrefixLists": {
	              "shape": "Se",
	              "locationName": "destinationPrefixListSet"
	            },
	            "Protocols": {
	              "shape": "Sht",
	              "locationName": "protocolSet"
	            }
	          }
	        },
	        "ResourceStatement": {
	          "shape": "Si6",
	          "locationName": "resourceStatement"
	        }
	      }
	    },
	    "Si6": {
	      "type": "structure",
	      "members": {
	        "Resources": {
	          "shape": "Se",
	          "locationName": "resourceSet"
	        },
	        "ResourceTypes": {
	          "shape": "Se",
	          "locationName": "resourceTypeSet"
	        }
	      }
	    },
	    "Sie": {
	      "type": "structure",
	      "members": {
	        "NetworkInsightsPathId": {
	          "locationName": "networkInsightsPathId"
	        },
	        "NetworkInsightsPathArn": {
	          "locationName": "networkInsightsPathArn"
	        },
	        "CreatedDate": {
	          "locationName": "createdDate",
	          "type": "timestamp"
	        },
	        "Source": {
	          "locationName": "source"
	        },
	        "Destination": {
	          "locationName": "destination"
	        },
	        "SourceIp": {
	          "locationName": "sourceIp"
	        },
	        "DestinationIp": {
	          "locationName": "destinationIp"
	        },
	        "Protocol": {
	          "locationName": "protocol"
	        },
	        "DestinationPort": {
	          "locationName": "destinationPort",
	          "type": "integer"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sij": {
	      "type": "structure",
	      "members": {
	        "Association": {
	          "shape": "Sik",
	          "locationName": "association"
	        },
	        "Attachment": {
	          "shape": "Sil",
	          "locationName": "attachment"
	        },
	        "AvailabilityZone": {
	          "locationName": "availabilityZone"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "Groups": {
	          "shape": "Sim",
	          "locationName": "groupSet"
	        },
	        "InterfaceType": {
	          "locationName": "interfaceType"
	        },
	        "Ipv6Addresses": {
	          "locationName": "ipv6AddressesSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "Ipv6Address": {
	                "locationName": "ipv6Address"
	              }
	            }
	          }
	        },
	        "MacAddress": {
	          "locationName": "macAddress"
	        },
	        "NetworkInterfaceId": {
	          "locationName": "networkInterfaceId"
	        },
	        "OutpostArn": {
	          "locationName": "outpostArn"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "PrivateDnsName": {
	          "locationName": "privateDnsName"
	        },
	        "PrivateIpAddress": {
	          "locationName": "privateIpAddress"
	        },
	        "PrivateIpAddresses": {
	          "locationName": "privateIpAddressesSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "Association": {
	                "shape": "Sik",
	                "locationName": "association"
	              },
	              "Primary": {
	                "locationName": "primary",
	                "type": "boolean"
	              },
	              "PrivateDnsName": {
	                "locationName": "privateDnsName"
	              },
	              "PrivateIpAddress": {
	                "locationName": "privateIpAddress"
	              }
	            }
	          }
	        },
	        "Ipv4Prefixes": {
	          "shape": "S2p",
	          "locationName": "ipv4PrefixSet"
	        },
	        "Ipv6Prefixes": {
	          "locationName": "ipv6PrefixSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "Ipv6Prefix": {
	                "locationName": "ipv6Prefix"
	              }
	            }
	          }
	        },
	        "RequesterId": {
	          "locationName": "requesterId"
	        },
	        "RequesterManaged": {
	          "locationName": "requesterManaged",
	          "type": "boolean"
	        },
	        "SourceDestCheck": {
	          "locationName": "sourceDestCheck",
	          "type": "boolean"
	        },
	        "Status": {
	          "locationName": "status"
	        },
	        "SubnetId": {
	          "locationName": "subnetId"
	        },
	        "TagSet": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "DenyAllIgwTraffic": {
	          "locationName": "denyAllIgwTraffic",
	          "type": "boolean"
	        },
	        "Ipv6Native": {
	          "locationName": "ipv6Native",
	          "type": "boolean"
	        },
	        "Ipv6Address": {
	          "locationName": "ipv6Address"
	        }
	      }
	    },
	    "Sik": {
	      "type": "structure",
	      "members": {
	        "AllocationId": {
	          "locationName": "allocationId"
	        },
	        "AssociationId": {
	          "locationName": "associationId"
	        },
	        "IpOwnerId": {
	          "locationName": "ipOwnerId"
	        },
	        "PublicDnsName": {
	          "locationName": "publicDnsName"
	        },
	        "PublicIp": {
	          "locationName": "publicIp"
	        },
	        "CustomerOwnedIp": {
	          "locationName": "customerOwnedIp"
	        },
	        "CarrierIp": {
	          "locationName": "carrierIp"
	        }
	      }
	    },
	    "Sil": {
	      "type": "structure",
	      "members": {
	        "AttachTime": {
	          "locationName": "attachTime",
	          "type": "timestamp"
	        },
	        "AttachmentId": {
	          "locationName": "attachmentId"
	        },
	        "DeleteOnTermination": {
	          "locationName": "deleteOnTermination",
	          "type": "boolean"
	        },
	        "DeviceIndex": {
	          "locationName": "deviceIndex",
	          "type": "integer"
	        },
	        "NetworkCardIndex": {
	          "locationName": "networkCardIndex",
	          "type": "integer"
	        },
	        "InstanceId": {
	          "locationName": "instanceId"
	        },
	        "InstanceOwnerId": {
	          "locationName": "instanceOwnerId"
	        },
	        "Status": {
	          "locationName": "status"
	        }
	      }
	    },
	    "Sim": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "GroupName": {
	            "locationName": "groupName"
	          },
	          "GroupId": {
	            "locationName": "groupId"
	          }
	        }
	      }
	    },
	    "Siz": {
	      "type": "structure",
	      "members": {
	        "NetworkInterfacePermissionId": {
	          "locationName": "networkInterfacePermissionId"
	        },
	        "NetworkInterfaceId": {
	          "locationName": "networkInterfaceId"
	        },
	        "AwsAccountId": {
	          "locationName": "awsAccountId"
	        },
	        "AwsService": {
	          "locationName": "awsService"
	        },
	        "Permission": {
	          "locationName": "permission"
	        },
	        "PermissionState": {
	          "locationName": "permissionState",
	          "type": "structure",
	          "members": {
	            "State": {
	              "locationName": "state"
	            },
	            "StatusMessage": {
	              "locationName": "statusMessage"
	            }
	          }
	        }
	      }
	    },
	    "Sj5": {
	      "type": "structure",
	      "members": {
	        "GroupName": {
	          "locationName": "groupName"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "Strategy": {
	          "locationName": "strategy"
	        },
	        "PartitionCount": {
	          "locationName": "partitionCount",
	          "type": "integer"
	        },
	        "GroupId": {
	          "locationName": "groupId"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "GroupArn": {
	          "locationName": "groupArn"
	        }
	      }
	    },
	    "Sjb": {
	      "type": "structure",
	      "members": {
	        "ReplaceRootVolumeTaskId": {
	          "locationName": "replaceRootVolumeTaskId"
	        },
	        "InstanceId": {
	          "locationName": "instanceId"
	        },
	        "TaskState": {
	          "locationName": "taskState"
	        },
	        "StartTime": {
	          "locationName": "startTime"
	        },
	        "CompleteTime": {
	          "locationName": "completeTime"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sjs": {
	      "type": "structure",
	      "members": {
	        "Associations": {
	          "locationName": "associationSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "Main": {
	                "locationName": "main",
	                "type": "boolean"
	              },
	              "RouteTableAssociationId": {
	                "locationName": "routeTableAssociationId"
	              },
	              "RouteTableId": {
	                "locationName": "routeTableId"
	              },
	              "SubnetId": {
	                "locationName": "subnetId"
	              },
	              "GatewayId": {
	                "locationName": "gatewayId"
	              },
	              "AssociationState": {
	                "shape": "S3u",
	                "locationName": "associationState"
	              }
	            }
	          }
	        },
	        "PropagatingVgws": {
	          "locationName": "propagatingVgwSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "GatewayId": {
	                "locationName": "gatewayId"
	              }
	            }
	          }
	        },
	        "RouteTableId": {
	          "locationName": "routeTableId"
	        },
	        "Routes": {
	          "locationName": "routeSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "DestinationCidrBlock": {
	                "locationName": "destinationCidrBlock"
	              },
	              "DestinationIpv6CidrBlock": {
	                "locationName": "destinationIpv6CidrBlock"
	              },
	              "DestinationPrefixListId": {
	                "locationName": "destinationPrefixListId"
	              },
	              "EgressOnlyInternetGatewayId": {
	                "locationName": "egressOnlyInternetGatewayId"
	              },
	              "GatewayId": {
	                "locationName": "gatewayId"
	              },
	              "InstanceId": {
	                "locationName": "instanceId"
	              },
	              "InstanceOwnerId": {
	                "locationName": "instanceOwnerId"
	              },
	              "NatGatewayId": {
	                "locationName": "natGatewayId"
	              },
	              "TransitGatewayId": {
	                "locationName": "transitGatewayId"
	              },
	              "LocalGatewayId": {
	                "locationName": "localGatewayId"
	              },
	              "CarrierGatewayId": {
	                "locationName": "carrierGatewayId"
	              },
	              "NetworkInterfaceId": {
	                "locationName": "networkInterfaceId"
	              },
	              "Origin": {
	                "locationName": "origin"
	              },
	              "State": {
	                "locationName": "state"
	              },
	              "VpcPeeringConnectionId": {
	                "locationName": "vpcPeeringConnectionId"
	              },
	              "CoreNetworkArn": {
	                "locationName": "coreNetworkArn"
	              }
	            }
	          }
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        }
	      }
	    },
	    "Sk4": {
	      "type": "structure",
	      "members": {
	        "DataEncryptionKeyId": {
	          "locationName": "dataEncryptionKeyId"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "Encrypted": {
	          "locationName": "encrypted",
	          "type": "boolean"
	        },
	        "KmsKeyId": {
	          "locationName": "kmsKeyId"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "Progress": {
	          "locationName": "progress"
	        },
	        "SnapshotId": {
	          "locationName": "snapshotId"
	        },
	        "StartTime": {
	          "locationName": "startTime",
	          "type": "timestamp"
	        },
	        "State": {
	          "locationName": "status"
	        },
	        "StateMessage": {
	          "locationName": "statusMessage"
	        },
	        "VolumeId": {
	          "locationName": "volumeId"
	        },
	        "VolumeSize": {
	          "locationName": "volumeSize",
	          "type": "integer"
	        },
	        "OwnerAlias": {
	          "locationName": "ownerAlias"
	        },
	        "OutpostArn": {
	          "locationName": "outpostArn"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "StorageTier": {
	          "locationName": "storageTier"
	        },
	        "RestoreExpiryTime": {
	          "locationName": "restoreExpiryTime",
	          "type": "timestamp"
	        }
	      }
	    },
	    "Skf": {
	      "type": "structure",
	      "members": {
	        "Bucket": {
	          "locationName": "bucket"
	        },
	        "Fault": {
	          "shape": "Skg",
	          "locationName": "fault"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "Prefix": {
	          "locationName": "prefix"
	        },
	        "State": {
	          "locationName": "state"
	        }
	      }
	    },
	    "Skg": {
	      "type": "structure",
	      "members": {
	        "Code": {
	          "locationName": "code"
	        },
	        "Message": {
	          "locationName": "message"
	        }
	      }
	    },
	    "Skr": {
	      "type": "structure",
	      "members": {
	        "SubnetCidrReservationId": {
	          "locationName": "subnetCidrReservationId"
	        },
	        "SubnetId": {
	          "locationName": "subnetId"
	        },
	        "Cidr": {
	          "locationName": "cidr"
	        },
	        "ReservationType": {
	          "locationName": "reservationType"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sku": {
	      "type": "list",
	      "member": {}
	    },
	    "Sky": {
	      "type": "structure",
	      "members": {
	        "TrafficMirrorFilterId": {
	          "locationName": "trafficMirrorFilterId"
	        },
	        "IngressFilterRules": {
	          "shape": "Skz",
	          "locationName": "ingressFilterRuleSet"
	        },
	        "EgressFilterRules": {
	          "shape": "Skz",
	          "locationName": "egressFilterRuleSet"
	        },
	        "NetworkServices": {
	          "shape": "Sl4",
	          "locationName": "networkServiceSet"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Skz": {
	      "type": "list",
	      "member": {
	        "shape": "Sl0",
	        "locationName": "item"
	      }
	    },
	    "Sl0": {
	      "type": "structure",
	      "members": {
	        "TrafficMirrorFilterRuleId": {
	          "locationName": "trafficMirrorFilterRuleId"
	        },
	        "TrafficMirrorFilterId": {
	          "locationName": "trafficMirrorFilterId"
	        },
	        "TrafficDirection": {
	          "locationName": "trafficDirection"
	        },
	        "RuleNumber": {
	          "locationName": "ruleNumber",
	          "type": "integer"
	        },
	        "RuleAction": {
	          "locationName": "ruleAction"
	        },
	        "Protocol": {
	          "locationName": "protocol",
	          "type": "integer"
	        },
	        "DestinationPortRange": {
	          "shape": "Sl3",
	          "locationName": "destinationPortRange"
	        },
	        "SourcePortRange": {
	          "shape": "Sl3",
	          "locationName": "sourcePortRange"
	        },
	        "DestinationCidrBlock": {
	          "locationName": "destinationCidrBlock"
	        },
	        "SourceCidrBlock": {
	          "locationName": "sourceCidrBlock"
	        },
	        "Description": {
	          "locationName": "description"
	        }
	      }
	    },
	    "Sl3": {
	      "type": "structure",
	      "members": {
	        "FromPort": {
	          "locationName": "fromPort",
	          "type": "integer"
	        },
	        "ToPort": {
	          "locationName": "toPort",
	          "type": "integer"
	        }
	      }
	    },
	    "Sl4": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sl8": {
	      "type": "structure",
	      "members": {
	        "FromPort": {
	          "type": "integer"
	        },
	        "ToPort": {
	          "type": "integer"
	        }
	      }
	    },
	    "Sld": {
	      "type": "structure",
	      "members": {
	        "TrafficMirrorSessionId": {
	          "locationName": "trafficMirrorSessionId"
	        },
	        "TrafficMirrorTargetId": {
	          "locationName": "trafficMirrorTargetId"
	        },
	        "TrafficMirrorFilterId": {
	          "locationName": "trafficMirrorFilterId"
	        },
	        "NetworkInterfaceId": {
	          "locationName": "networkInterfaceId"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "PacketLength": {
	          "locationName": "packetLength",
	          "type": "integer"
	        },
	        "SessionNumber": {
	          "locationName": "sessionNumber",
	          "type": "integer"
	        },
	        "VirtualNetworkId": {
	          "locationName": "virtualNetworkId",
	          "type": "integer"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Slg": {
	      "type": "structure",
	      "members": {
	        "TrafficMirrorTargetId": {
	          "locationName": "trafficMirrorTargetId"
	        },
	        "NetworkInterfaceId": {
	          "locationName": "networkInterfaceId"
	        },
	        "NetworkLoadBalancerArn": {
	          "locationName": "networkLoadBalancerArn"
	        },
	        "Type": {
	          "locationName": "type"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "GatewayLoadBalancerEndpointId": {
	          "locationName": "gatewayLoadBalancerEndpointId"
	        }
	      }
	    },
	    "Slp": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Slr": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayId": {
	          "locationName": "transitGatewayId"
	        },
	        "TransitGatewayArn": {
	          "locationName": "transitGatewayArn"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "CreationTime": {
	          "locationName": "creationTime",
	          "type": "timestamp"
	        },
	        "Options": {
	          "locationName": "options",
	          "type": "structure",
	          "members": {
	            "AmazonSideAsn": {
	              "locationName": "amazonSideAsn",
	              "type": "long"
	            },
	            "TransitGatewayCidrBlocks": {
	              "shape": "Se",
	              "locationName": "transitGatewayCidrBlocks"
	            },
	            "AutoAcceptSharedAttachments": {
	              "locationName": "autoAcceptSharedAttachments"
	            },
	            "DefaultRouteTableAssociation": {
	              "locationName": "defaultRouteTableAssociation"
	            },
	            "AssociationDefaultRouteTableId": {
	              "locationName": "associationDefaultRouteTableId"
	            },
	            "DefaultRouteTablePropagation": {
	              "locationName": "defaultRouteTablePropagation"
	            },
	            "PropagationDefaultRouteTableId": {
	              "locationName": "propagationDefaultRouteTableId"
	            },
	            "VpnEcmpSupport": {
	              "locationName": "vpnEcmpSupport"
	            },
	            "DnsSupport": {
	              "locationName": "dnsSupport"
	            },
	            "MulticastSupport": {
	              "locationName": "multicastSupport"
	            }
	          }
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sly": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayAttachmentId": {
	          "locationName": "transitGatewayAttachmentId"
	        },
	        "TransportTransitGatewayAttachmentId": {
	          "locationName": "transportTransitGatewayAttachmentId"
	        },
	        "TransitGatewayId": {
	          "locationName": "transitGatewayId"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "CreationTime": {
	          "locationName": "creationTime",
	          "type": "timestamp"
	        },
	        "Options": {
	          "locationName": "options",
	          "type": "structure",
	          "members": {
	            "Protocol": {
	              "locationName": "protocol"
	            }
	          }
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sm2": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sm4": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayAttachmentId": {
	          "locationName": "transitGatewayAttachmentId"
	        },
	        "TransitGatewayConnectPeerId": {
	          "locationName": "transitGatewayConnectPeerId"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "CreationTime": {
	          "locationName": "creationTime",
	          "type": "timestamp"
	        },
	        "ConnectPeerConfiguration": {
	          "locationName": "connectPeerConfiguration",
	          "type": "structure",
	          "members": {
	            "TransitGatewayAddress": {
	              "locationName": "transitGatewayAddress"
	            },
	            "PeerAddress": {
	              "locationName": "peerAddress"
	            },
	            "InsideCidrBlocks": {
	              "shape": "Sm2",
	              "locationName": "insideCidrBlocks"
	            },
	            "Protocol": {
	              "locationName": "protocol"
	            },
	            "BgpConfigurations": {
	              "locationName": "bgpConfigurations",
	              "type": "list",
	              "member": {
	                "locationName": "item",
	                "type": "structure",
	                "members": {
	                  "TransitGatewayAsn": {
	                    "locationName": "transitGatewayAsn",
	                    "type": "long"
	                  },
	                  "PeerAsn": {
	                    "locationName": "peerAsn",
	                    "type": "long"
	                  },
	                  "TransitGatewayAddress": {
	                    "locationName": "transitGatewayAddress"
	                  },
	                  "PeerAddress": {
	                    "locationName": "peerAddress"
	                  },
	                  "BgpStatus": {
	                    "locationName": "bgpStatus"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Smh": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayMulticastDomainId": {
	          "locationName": "transitGatewayMulticastDomainId"
	        },
	        "TransitGatewayId": {
	          "locationName": "transitGatewayId"
	        },
	        "TransitGatewayMulticastDomainArn": {
	          "locationName": "transitGatewayMulticastDomainArn"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "Options": {
	          "locationName": "options",
	          "type": "structure",
	          "members": {
	            "Igmpv2Support": {
	              "locationName": "igmpv2Support"
	            },
	            "StaticSourcesSupport": {
	              "locationName": "staticSourcesSupport"
	            },
	            "AutoAcceptSharedAssociations": {
	              "locationName": "autoAcceptSharedAssociations"
	            }
	          }
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "CreationTime": {
	          "locationName": "creationTime",
	          "type": "timestamp"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Smp": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayRouteTableId": {
	          "locationName": "transitGatewayRouteTableId"
	        },
	        "PrefixListId": {
	          "locationName": "prefixListId"
	        },
	        "PrefixListOwnerId": {
	          "locationName": "prefixListOwnerId"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "Blackhole": {
	          "locationName": "blackhole",
	          "type": "boolean"
	        },
	        "TransitGatewayAttachment": {
	          "locationName": "transitGatewayAttachment",
	          "type": "structure",
	          "members": {
	            "TransitGatewayAttachmentId": {
	              "locationName": "transitGatewayAttachmentId"
	            },
	            "ResourceType": {
	              "locationName": "resourceType"
	            },
	            "ResourceId": {
	              "locationName": "resourceId"
	            }
	          }
	        }
	      }
	    },
	    "Smu": {
	      "type": "structure",
	      "members": {
	        "DestinationCidrBlock": {
	          "locationName": "destinationCidrBlock"
	        },
	        "PrefixListId": {
	          "locationName": "prefixListId"
	        },
	        "TransitGatewayAttachments": {
	          "locationName": "transitGatewayAttachments",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "ResourceId": {
	                "locationName": "resourceId"
	              },
	              "TransitGatewayAttachmentId": {
	                "locationName": "transitGatewayAttachmentId"
	              },
	              "ResourceType": {
	                "locationName": "resourceType"
	              }
	            }
	          }
	        },
	        "Type": {
	          "locationName": "type"
	        },
	        "State": {
	          "locationName": "state"
	        }
	      }
	    },
	    "Sn1": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayRouteTableId": {
	          "locationName": "transitGatewayRouteTableId"
	        },
	        "TransitGatewayId": {
	          "locationName": "transitGatewayId"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "DefaultAssociationRouteTable": {
	          "locationName": "defaultAssociationRouteTable",
	          "type": "boolean"
	        },
	        "DefaultPropagationRouteTable": {
	          "locationName": "defaultPropagationRouteTable",
	          "type": "boolean"
	        },
	        "CreationTime": {
	          "locationName": "creationTime",
	          "type": "timestamp"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sn7": {
	      "type": "structure",
	      "members": {
	        "Attachments": {
	          "locationName": "attachmentSet",
	          "type": "list",
	          "member": {
	            "shape": "S4w",
	            "locationName": "item"
	          }
	        },
	        "AvailabilityZone": {
	          "locationName": "availabilityZone"
	        },
	        "CreateTime": {
	          "locationName": "createTime",
	          "type": "timestamp"
	        },
	        "Encrypted": {
	          "locationName": "encrypted",
	          "type": "boolean"
	        },
	        "KmsKeyId": {
	          "locationName": "kmsKeyId"
	        },
	        "OutpostArn": {
	          "locationName": "outpostArn"
	        },
	        "Size": {
	          "locationName": "size",
	          "type": "integer"
	        },
	        "SnapshotId": {
	          "locationName": "snapshotId"
	        },
	        "State": {
	          "locationName": "status"
	        },
	        "VolumeId": {
	          "locationName": "volumeId"
	        },
	        "Iops": {
	          "locationName": "iops",
	          "type": "integer"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "VolumeType": {
	          "locationName": "volumeType"
	        },
	        "FastRestored": {
	          "locationName": "fastRestored",
	          "type": "boolean"
	        },
	        "MultiAttachEnabled": {
	          "locationName": "multiAttachEnabled",
	          "type": "boolean"
	        },
	        "Throughput": {
	          "locationName": "throughput",
	          "type": "integer"
	        }
	      }
	    },
	    "Sne": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Snf": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sng": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sni": {
	      "type": "structure",
	      "members": {
	        "DnsRecordIpType": {}
	      }
	    },
	    "Snl": {
	      "type": "structure",
	      "members": {
	        "VpcEndpointId": {
	          "locationName": "vpcEndpointId"
	        },
	        "VpcEndpointType": {
	          "locationName": "vpcEndpointType"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        },
	        "ServiceName": {
	          "locationName": "serviceName"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "PolicyDocument": {
	          "locationName": "policyDocument"
	        },
	        "RouteTableIds": {
	          "shape": "Se",
	          "locationName": "routeTableIdSet"
	        },
	        "SubnetIds": {
	          "shape": "Se",
	          "locationName": "subnetIdSet"
	        },
	        "Groups": {
	          "locationName": "groupSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "GroupId": {
	                "locationName": "groupId"
	              },
	              "GroupName": {
	                "locationName": "groupName"
	              }
	            }
	          }
	        },
	        "IpAddressType": {
	          "locationName": "ipAddressType"
	        },
	        "DnsOptions": {
	          "locationName": "dnsOptions",
	          "type": "structure",
	          "members": {
	            "DnsRecordIpType": {
	              "locationName": "dnsRecordIpType"
	            }
	          }
	        },
	        "PrivateDnsEnabled": {
	          "locationName": "privateDnsEnabled",
	          "type": "boolean"
	        },
	        "RequesterManaged": {
	          "locationName": "requesterManaged",
	          "type": "boolean"
	        },
	        "NetworkInterfaceIds": {
	          "shape": "Se",
	          "locationName": "networkInterfaceIdSet"
	        },
	        "DnsEntries": {
	          "shape": "Snq",
	          "locationName": "dnsEntrySet"
	        },
	        "CreationTimestamp": {
	          "locationName": "creationTimestamp",
	          "type": "timestamp"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "LastError": {
	          "locationName": "lastError",
	          "type": "structure",
	          "members": {
	            "Message": {
	              "locationName": "message"
	            },
	            "Code": {
	              "locationName": "code"
	            }
	          }
	        }
	      }
	    },
	    "Snq": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "DnsName": {
	            "locationName": "dnsName"
	          },
	          "HostedZoneId": {
	            "locationName": "hostedZoneId"
	          }
	        }
	      }
	    },
	    "Snv": {
	      "type": "structure",
	      "members": {
	        "ConnectionNotificationId": {
	          "locationName": "connectionNotificationId"
	        },
	        "ServiceId": {
	          "locationName": "serviceId"
	        },
	        "VpcEndpointId": {
	          "locationName": "vpcEndpointId"
	        },
	        "ConnectionNotificationType": {
	          "locationName": "connectionNotificationType"
	        },
	        "ConnectionNotificationArn": {
	          "locationName": "connectionNotificationArn"
	        },
	        "ConnectionEvents": {
	          "shape": "Se",
	          "locationName": "connectionEvents"
	        },
	        "ConnectionNotificationState": {
	          "locationName": "connectionNotificationState"
	        }
	      }
	    },
	    "So0": {
	      "type": "structure",
	      "members": {
	        "ServiceType": {
	          "shape": "So1",
	          "locationName": "serviceType"
	        },
	        "ServiceId": {
	          "locationName": "serviceId"
	        },
	        "ServiceName": {
	          "locationName": "serviceName"
	        },
	        "ServiceState": {
	          "locationName": "serviceState"
	        },
	        "AvailabilityZones": {
	          "shape": "Se",
	          "locationName": "availabilityZoneSet"
	        },
	        "AcceptanceRequired": {
	          "locationName": "acceptanceRequired",
	          "type": "boolean"
	        },
	        "ManagesVpcEndpoints": {
	          "locationName": "managesVpcEndpoints",
	          "type": "boolean"
	        },
	        "NetworkLoadBalancerArns": {
	          "shape": "Se",
	          "locationName": "networkLoadBalancerArnSet"
	        },
	        "GatewayLoadBalancerArns": {
	          "shape": "Se",
	          "locationName": "gatewayLoadBalancerArnSet"
	        },
	        "SupportedIpAddressTypes": {
	          "shape": "So5",
	          "locationName": "supportedIpAddressTypeSet"
	        },
	        "BaseEndpointDnsNames": {
	          "shape": "Se",
	          "locationName": "baseEndpointDnsNameSet"
	        },
	        "PrivateDnsName": {
	          "locationName": "privateDnsName"
	        },
	        "PrivateDnsNameConfiguration": {
	          "locationName": "privateDnsNameConfiguration",
	          "type": "structure",
	          "members": {
	            "State": {
	              "locationName": "state"
	            },
	            "Type": {
	              "locationName": "type"
	            },
	            "Value": {
	              "locationName": "value"
	            },
	            "Name": {
	              "locationName": "name"
	            }
	          }
	        },
	        "PayerResponsibility": {
	          "locationName": "payerResponsibility"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "So1": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "ServiceType": {
	            "locationName": "serviceType"
	          }
	        }
	      }
	    },
	    "So5": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Soi": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Value": {}
	        }
	      }
	    },
	    "Sok": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Value": {}
	        }
	      }
	    },
	    "Som": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Value": {}
	        }
	      }
	    },
	    "Soo": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Value": {}
	        }
	      }
	    },
	    "Soq": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Value": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "Sos": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Value": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "Sou": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Value": {}
	        }
	      }
	    },
	    "Sox": {
	      "type": "structure",
	      "members": {
	        "CustomerGatewayConfiguration": {
	          "locationName": "customerGatewayConfiguration"
	        },
	        "CustomerGatewayId": {
	          "locationName": "customerGatewayId"
	        },
	        "Category": {
	          "locationName": "category"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "Type": {
	          "locationName": "type"
	        },
	        "VpnConnectionId": {
	          "locationName": "vpnConnectionId"
	        },
	        "VpnGatewayId": {
	          "locationName": "vpnGatewayId"
	        },
	        "TransitGatewayId": {
	          "locationName": "transitGatewayId"
	        },
	        "CoreNetworkArn": {
	          "locationName": "coreNetworkArn"
	        },
	        "CoreNetworkAttachmentArn": {
	          "locationName": "coreNetworkAttachmentArn"
	        },
	        "GatewayAssociationState": {
	          "locationName": "gatewayAssociationState"
	        },
	        "Options": {
	          "locationName": "options",
	          "type": "structure",
	          "members": {
	            "EnableAcceleration": {
	              "locationName": "enableAcceleration",
	              "type": "boolean"
	            },
	            "StaticRoutesOnly": {
	              "locationName": "staticRoutesOnly",
	              "type": "boolean"
	            },
	            "LocalIpv4NetworkCidr": {
	              "locationName": "localIpv4NetworkCidr"
	            },
	            "RemoteIpv4NetworkCidr": {
	              "locationName": "remoteIpv4NetworkCidr"
	            },
	            "LocalIpv6NetworkCidr": {
	              "locationName": "localIpv6NetworkCidr"
	            },
	            "RemoteIpv6NetworkCidr": {
	              "locationName": "remoteIpv6NetworkCidr"
	            },
	            "OutsideIpAddressType": {
	              "locationName": "outsideIpAddressType"
	            },
	            "TransportTransitGatewayAttachmentId": {
	              "locationName": "transportTransitGatewayAttachmentId"
	            },
	            "TunnelInsideIpVersion": {
	              "locationName": "tunnelInsideIpVersion"
	            },
	            "TunnelOptions": {
	              "locationName": "tunnelOptionSet",
	              "type": "list",
	              "member": {
	                "locationName": "item",
	                "type": "structure",
	                "members": {
	                  "OutsideIpAddress": {
	                    "locationName": "outsideIpAddress"
	                  },
	                  "TunnelInsideCidr": {
	                    "locationName": "tunnelInsideCidr"
	                  },
	                  "TunnelInsideIpv6Cidr": {
	                    "locationName": "tunnelInsideIpv6Cidr"
	                  },
	                  "PreSharedKey": {
	                    "locationName": "preSharedKey"
	                  },
	                  "Phase1LifetimeSeconds": {
	                    "locationName": "phase1LifetimeSeconds",
	                    "type": "integer"
	                  },
	                  "Phase2LifetimeSeconds": {
	                    "locationName": "phase2LifetimeSeconds",
	                    "type": "integer"
	                  },
	                  "RekeyMarginTimeSeconds": {
	                    "locationName": "rekeyMarginTimeSeconds",
	                    "type": "integer"
	                  },
	                  "RekeyFuzzPercentage": {
	                    "locationName": "rekeyFuzzPercentage",
	                    "type": "integer"
	                  },
	                  "ReplayWindowSize": {
	                    "locationName": "replayWindowSize",
	                    "type": "integer"
	                  },
	                  "DpdTimeoutSeconds": {
	                    "locationName": "dpdTimeoutSeconds",
	                    "type": "integer"
	                  },
	                  "DpdTimeoutAction": {
	                    "locationName": "dpdTimeoutAction"
	                  },
	                  "Phase1EncryptionAlgorithms": {
	                    "locationName": "phase1EncryptionAlgorithmSet",
	                    "type": "list",
	                    "member": {
	                      "locationName": "item",
	                      "type": "structure",
	                      "members": {
	                        "Value": {
	                          "locationName": "value"
	                        }
	                      }
	                    }
	                  },
	                  "Phase2EncryptionAlgorithms": {
	                    "locationName": "phase2EncryptionAlgorithmSet",
	                    "type": "list",
	                    "member": {
	                      "locationName": "item",
	                      "type": "structure",
	                      "members": {
	                        "Value": {
	                          "locationName": "value"
	                        }
	                      }
	                    }
	                  },
	                  "Phase1IntegrityAlgorithms": {
	                    "locationName": "phase1IntegrityAlgorithmSet",
	                    "type": "list",
	                    "member": {
	                      "locationName": "item",
	                      "type": "structure",
	                      "members": {
	                        "Value": {
	                          "locationName": "value"
	                        }
	                      }
	                    }
	                  },
	                  "Phase2IntegrityAlgorithms": {
	                    "locationName": "phase2IntegrityAlgorithmSet",
	                    "type": "list",
	                    "member": {
	                      "locationName": "item",
	                      "type": "structure",
	                      "members": {
	                        "Value": {
	                          "locationName": "value"
	                        }
	                      }
	                    }
	                  },
	                  "Phase1DHGroupNumbers": {
	                    "locationName": "phase1DHGroupNumberSet",
	                    "type": "list",
	                    "member": {
	                      "locationName": "item",
	                      "type": "structure",
	                      "members": {
	                        "Value": {
	                          "locationName": "value",
	                          "type": "integer"
	                        }
	                      }
	                    }
	                  },
	                  "Phase2DHGroupNumbers": {
	                    "locationName": "phase2DHGroupNumberSet",
	                    "type": "list",
	                    "member": {
	                      "locationName": "item",
	                      "type": "structure",
	                      "members": {
	                        "Value": {
	                          "locationName": "value",
	                          "type": "integer"
	                        }
	                      }
	                    }
	                  },
	                  "IkeVersions": {
	                    "locationName": "ikeVersionSet",
	                    "type": "list",
	                    "member": {
	                      "locationName": "item",
	                      "type": "structure",
	                      "members": {
	                        "Value": {
	                          "locationName": "value"
	                        }
	                      }
	                    }
	                  },
	                  "StartupAction": {
	                    "locationName": "startupAction"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "Routes": {
	          "locationName": "routes",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "DestinationCidrBlock": {
	                "locationName": "destinationCidrBlock"
	              },
	              "Source": {
	                "locationName": "source"
	              },
	              "State": {
	                "locationName": "state"
	              }
	            }
	          }
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        },
	        "VgwTelemetry": {
	          "locationName": "vgwTelemetry",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "AcceptedRouteCount": {
	                "locationName": "acceptedRouteCount",
	                "type": "integer"
	              },
	              "LastStatusChange": {
	                "locationName": "lastStatusChange",
	                "type": "timestamp"
	              },
	              "OutsideIpAddress": {
	                "locationName": "outsideIpAddress"
	              },
	              "Status": {
	                "locationName": "status"
	              },
	              "StatusMessage": {
	                "locationName": "statusMessage"
	              },
	              "CertificateArn": {
	                "locationName": "certificateArn"
	              }
	            }
	          }
	        }
	      }
	    },
	    "Spr": {
	      "type": "structure",
	      "members": {
	        "AvailabilityZone": {
	          "locationName": "availabilityZone"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "Type": {
	          "locationName": "type"
	        },
	        "VpcAttachments": {
	          "locationName": "attachments",
	          "type": "list",
	          "member": {
	            "shape": "S51",
	            "locationName": "item"
	          }
	        },
	        "VpnGatewayId": {
	          "locationName": "vpnGatewayId"
	        },
	        "AmazonSideAsn": {
	          "locationName": "amazonSideAsn",
	          "type": "long"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sq5": {
	      "type": "list",
	      "member": {}
	    },
	    "Sqf": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sr0": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Stg": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Stt": {
	      "type": "structure",
	      "members": {
	        "Cidr": {
	          "locationName": "cidr"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "FailureReason": {
	          "locationName": "failureReason",
	          "type": "structure",
	          "members": {
	            "Code": {
	              "locationName": "code"
	            },
	            "Message": {
	              "locationName": "message"
	            }
	          }
	        }
	      }
	    },
	    "Su3": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Su5": {
	      "type": "structure",
	      "members": {
	        "InstanceTagKeys": {
	          "shape": "Su3",
	          "locationName": "instanceTagKeySet"
	        },
	        "IncludeAllTagsOfInstance": {
	          "locationName": "includeAllTagsOfInstance",
	          "type": "boolean"
	        }
	      }
	    },
	    "Su7": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "Sum": {
	      "type": "list",
	      "member": {
	        "locationName": "Filter",
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Values": {
	            "shape": "Se",
	            "locationName": "Value"
	          }
	        }
	      }
	    },
	    "Sv0": {
	      "type": "structure",
	      "members": {
	        "PublicIp": {
	          "locationName": "publicIp"
	        },
	        "AllocationId": {
	          "locationName": "allocationId"
	        },
	        "PtrRecord": {
	          "locationName": "ptrRecord"
	        },
	        "PtrRecordUpdate": {
	          "locationName": "ptrRecordUpdate",
	          "type": "structure",
	          "members": {
	            "Value": {
	              "locationName": "value"
	            },
	            "Status": {
	              "locationName": "status"
	            },
	            "Reason": {
	              "locationName": "reason"
	            }
	          }
	        }
	      }
	    },
	    "Sv4": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Deadline": {
	            "locationName": "deadline",
	            "type": "timestamp"
	          },
	          "Resource": {
	            "locationName": "resource"
	          },
	          "UseLongIds": {
	            "locationName": "useLongIds",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "Sw4": {
	      "type": "list",
	      "member": {
	        "locationName": "InstanceId"
	      }
	    },
	    "Swj": {
	      "type": "structure",
	      "members": {
	        "Code": {
	          "locationName": "code"
	        },
	        "Message": {
	          "locationName": "message"
	        }
	      }
	    },
	    "Sxq": {
	      "type": "structure",
	      "members": {
	        "ConversionTaskId": {
	          "locationName": "conversionTaskId"
	        },
	        "ExpirationTime": {
	          "locationName": "expirationTime"
	        },
	        "ImportInstance": {
	          "locationName": "importInstance",
	          "type": "structure",
	          "members": {
	            "Description": {
	              "locationName": "description"
	            },
	            "InstanceId": {
	              "locationName": "instanceId"
	            },
	            "Platform": {
	              "locationName": "platform"
	            },
	            "Volumes": {
	              "locationName": "volumes",
	              "type": "list",
	              "member": {
	                "locationName": "item",
	                "type": "structure",
	                "members": {
	                  "AvailabilityZone": {
	                    "locationName": "availabilityZone"
	                  },
	                  "BytesConverted": {
	                    "locationName": "bytesConverted",
	                    "type": "long"
	                  },
	                  "Description": {
	                    "locationName": "description"
	                  },
	                  "Image": {
	                    "shape": "Sxu",
	                    "locationName": "image"
	                  },
	                  "Status": {
	                    "locationName": "status"
	                  },
	                  "StatusMessage": {
	                    "locationName": "statusMessage"
	                  },
	                  "Volume": {
	                    "shape": "Sxv",
	                    "locationName": "volume"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "ImportVolume": {
	          "locationName": "importVolume",
	          "type": "structure",
	          "members": {
	            "AvailabilityZone": {
	              "locationName": "availabilityZone"
	            },
	            "BytesConverted": {
	              "locationName": "bytesConverted",
	              "type": "long"
	            },
	            "Description": {
	              "locationName": "description"
	            },
	            "Image": {
	              "shape": "Sxu",
	              "locationName": "image"
	            },
	            "Volume": {
	              "shape": "Sxv",
	              "locationName": "volume"
	            }
	          }
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "StatusMessage": {
	          "locationName": "statusMessage"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "Sxu": {
	      "type": "structure",
	      "members": {
	        "Checksum": {
	          "locationName": "checksum"
	        },
	        "Format": {
	          "locationName": "format"
	        },
	        "ImportManifestUrl": {
	          "locationName": "importManifestUrl"
	        },
	        "Size": {
	          "locationName": "size",
	          "type": "long"
	        }
	      }
	    },
	    "Sxv": {
	      "type": "structure",
	      "members": {
	        "Id": {
	          "locationName": "id"
	        },
	        "Size": {
	          "locationName": "size",
	          "type": "long"
	        }
	      }
	    },
	    "Syt": {
	      "type": "structure",
	      "members": {
	        "S3Bucket": {
	          "locationName": "s3Bucket"
	        },
	        "S3Prefix": {
	          "locationName": "s3Prefix"
	        }
	      }
	    },
	    "Sz6": {
	      "type": "structure",
	      "members": {
	        "TargetResourceCount": {
	          "locationName": "targetResourceCount",
	          "type": "integer"
	        }
	      }
	    },
	    "Sz7": {
	      "type": "structure",
	      "members": {
	        "LaunchTemplateId": {
	          "locationName": "launchTemplateId"
	        },
	        "LaunchTemplateName": {
	          "locationName": "launchTemplateName"
	        },
	        "Version": {
	          "locationName": "version"
	        }
	      }
	    },
	    "Szk": {
	      "type": "structure",
	      "members": {
	        "EventDescription": {
	          "locationName": "eventDescription"
	        },
	        "EventSubType": {
	          "locationName": "eventSubType"
	        },
	        "InstanceId": {
	          "locationName": "instanceId"
	        }
	      }
	    },
	    "Szn": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "InstanceType": {
	            "locationName": "instanceType"
	          },
	          "SpotInstanceRequestId": {
	            "locationName": "spotInstanceRequestId"
	          },
	          "InstanceHealth": {
	            "locationName": "instanceHealth"
	          }
	        }
	      }
	    },
	    "S10g": {
	      "type": "structure",
	      "members": {
	        "FpgaImageId": {
	          "locationName": "fpgaImageId"
	        },
	        "Name": {
	          "locationName": "name"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "LoadPermissions": {
	          "locationName": "loadPermissions",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "UserId": {
	                "locationName": "userId"
	              },
	              "Group": {
	                "locationName": "group"
	              }
	            }
	          }
	        },
	        "ProductCodes": {
	          "shape": "S10k",
	          "locationName": "productCodes"
	        }
	      }
	    },
	    "S10k": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "ProductCodeId": {
	            "locationName": "productCode"
	          },
	          "ProductCodeType": {
	            "locationName": "type"
	          }
	        }
	      }
	    },
	    "S10p": {
	      "type": "list",
	      "member": {
	        "locationName": "Owner"
	      }
	    },
	    "S11a": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S11d": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S122": {
	      "type": "list",
	      "member": {
	        "shape": "Scg",
	        "locationName": "item"
	      }
	    },
	    "S123": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Group": {
	            "locationName": "group"
	          },
	          "UserId": {
	            "locationName": "userId"
	          },
	          "OrganizationArn": {
	            "locationName": "organizationArn"
	          },
	          "OrganizationalUnitArn": {
	            "locationName": "organizationalUnitArn"
	          }
	        }
	      }
	    },
	    "S127": {
	      "type": "list",
	      "member": {
	        "locationName": "ImageId"
	      }
	    },
	    "S12g": {
	      "type": "structure",
	      "members": {
	        "Code": {
	          "locationName": "code"
	        },
	        "Message": {
	          "locationName": "message"
	        }
	      }
	    },
	    "S12q": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Description": {
	            "locationName": "description"
	          },
	          "DeviceName": {
	            "locationName": "deviceName"
	          },
	          "DiskImageSize": {
	            "locationName": "diskImageSize",
	            "type": "double"
	          },
	          "Format": {
	            "locationName": "format"
	          },
	          "Progress": {
	            "locationName": "progress"
	          },
	          "SnapshotId": {
	            "locationName": "snapshotId"
	          },
	          "Status": {
	            "locationName": "status"
	          },
	          "StatusMessage": {
	            "locationName": "statusMessage"
	          },
	          "Url": {
	            "locationName": "url"
	          },
	          "UserBucket": {
	            "shape": "S12s",
	            "locationName": "userBucket"
	          }
	        }
	      }
	    },
	    "S12s": {
	      "type": "structure",
	      "members": {
	        "S3Bucket": {
	          "locationName": "s3Bucket"
	        },
	        "S3Key": {
	          "locationName": "s3Key"
	        }
	      }
	    },
	    "S12t": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "LicenseConfigurationArn": {
	            "locationName": "licenseConfigurationArn"
	          }
	        }
	      }
	    },
	    "S131": {
	      "type": "structure",
	      "members": {
	        "Description": {
	          "locationName": "description"
	        },
	        "DiskImageSize": {
	          "locationName": "diskImageSize",
	          "type": "double"
	        },
	        "Encrypted": {
	          "locationName": "encrypted",
	          "type": "boolean"
	        },
	        "Format": {
	          "locationName": "format"
	        },
	        "KmsKeyId": {
	          "locationName": "kmsKeyId"
	        },
	        "Progress": {
	          "locationName": "progress"
	        },
	        "SnapshotId": {
	          "locationName": "snapshotId"
	        },
	        "Status": {
	          "locationName": "status"
	        },
	        "StatusMessage": {
	          "locationName": "statusMessage"
	        },
	        "Url": {
	          "locationName": "url"
	        },
	        "UserBucket": {
	          "shape": "S12s",
	          "locationName": "userBucket"
	        }
	      }
	    },
	    "S135": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "DeviceName": {
	            "locationName": "deviceName"
	          },
	          "Ebs": {
	            "locationName": "ebs",
	            "type": "structure",
	            "members": {
	              "AttachTime": {
	                "locationName": "attachTime",
	                "type": "timestamp"
	              },
	              "DeleteOnTermination": {
	                "locationName": "deleteOnTermination",
	                "type": "boolean"
	              },
	              "Status": {
	                "locationName": "status"
	              },
	              "VolumeId": {
	                "locationName": "volumeId"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S138": {
	      "type": "structure",
	      "members": {
	        "Value": {
	          "locationName": "value",
	          "type": "boolean"
	        }
	      }
	    },
	    "S139": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "locationName": "enabled",
	          "type": "boolean"
	        }
	      }
	    },
	    "S13r": {
	      "type": "structure",
	      "members": {
	        "InstanceEventId": {
	          "locationName": "instanceEventId"
	        },
	        "Code": {
	          "locationName": "code"
	        },
	        "Description": {
	          "locationName": "description"
	        },
	        "NotAfter": {
	          "locationName": "notAfter",
	          "type": "timestamp"
	        },
	        "NotBefore": {
	          "locationName": "notBefore",
	          "type": "timestamp"
	        },
	        "NotBeforeDeadline": {
	          "locationName": "notBeforeDeadline",
	          "type": "timestamp"
	        }
	      }
	    },
	    "S13u": {
	      "type": "structure",
	      "members": {
	        "Code": {
	          "locationName": "code",
	          "type": "integer"
	        },
	        "Name": {
	          "locationName": "name"
	        }
	      }
	    },
	    "S13w": {
	      "type": "structure",
	      "members": {
	        "Details": {
	          "locationName": "details",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "ImpairedSince": {
	                "locationName": "impairedSince",
	                "type": "timestamp"
	              },
	              "Name": {
	                "locationName": "name"
	              },
	              "Status": {
	                "locationName": "status"
	              }
	            }
	          }
	        },
	        "Status": {
	          "locationName": "status"
	        }
	      }
	    },
	    "S170": {
	      "type": "structure",
	      "members": {
	        "Groups": {
	          "shape": "Sim",
	          "locationName": "groupSet"
	        },
	        "Instances": {
	          "locationName": "instancesSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "AmiLaunchIndex": {
	                "locationName": "amiLaunchIndex",
	                "type": "integer"
	              },
	              "ImageId": {
	                "locationName": "imageId"
	              },
	              "InstanceId": {
	                "locationName": "instanceId"
	              },
	              "InstanceType": {
	                "locationName": "instanceType"
	              },
	              "KernelId": {
	                "locationName": "kernelId"
	              },
	              "KeyName": {
	                "locationName": "keyName"
	              },
	              "LaunchTime": {
	                "locationName": "launchTime",
	                "type": "timestamp"
	              },
	              "Monitoring": {
	                "shape": "S173",
	                "locationName": "monitoring"
	              },
	              "Placement": {
	                "shape": "Sak",
	                "locationName": "placement"
	              },
	              "Platform": {
	                "locationName": "platform"
	              },
	              "PrivateDnsName": {
	                "locationName": "privateDnsName"
	              },
	              "PrivateIpAddress": {
	                "locationName": "privateIpAddress"
	              },
	              "ProductCodes": {
	                "shape": "S10k",
	                "locationName": "productCodes"
	              },
	              "PublicDnsName": {
	                "locationName": "dnsName"
	              },
	              "PublicIpAddress": {
	                "locationName": "ipAddress"
	              },
	              "RamdiskId": {
	                "locationName": "ramdiskId"
	              },
	              "State": {
	                "shape": "S13u",
	                "locationName": "instanceState"
	              },
	              "StateTransitionReason": {
	                "locationName": "reason"
	              },
	              "SubnetId": {
	                "locationName": "subnetId"
	              },
	              "VpcId": {
	                "locationName": "vpcId"
	              },
	              "Architecture": {
	                "locationName": "architecture"
	              },
	              "BlockDeviceMappings": {
	                "shape": "S135",
	                "locationName": "blockDeviceMapping"
	              },
	              "ClientToken": {
	                "locationName": "clientToken"
	              },
	              "EbsOptimized": {
	                "locationName": "ebsOptimized",
	                "type": "boolean"
	              },
	              "EnaSupport": {
	                "locationName": "enaSupport",
	                "type": "boolean"
	              },
	              "Hypervisor": {
	                "locationName": "hypervisor"
	              },
	              "IamInstanceProfile": {
	                "shape": "S39",
	                "locationName": "iamInstanceProfile"
	              },
	              "InstanceLifecycle": {
	                "locationName": "instanceLifecycle"
	              },
	              "ElasticGpuAssociations": {
	                "locationName": "elasticGpuAssociationSet",
	                "type": "list",
	                "member": {
	                  "locationName": "item",
	                  "type": "structure",
	                  "members": {
	                    "ElasticGpuId": {
	                      "locationName": "elasticGpuId"
	                    },
	                    "ElasticGpuAssociationId": {
	                      "locationName": "elasticGpuAssociationId"
	                    },
	                    "ElasticGpuAssociationState": {
	                      "locationName": "elasticGpuAssociationState"
	                    },
	                    "ElasticGpuAssociationTime": {
	                      "locationName": "elasticGpuAssociationTime"
	                    }
	                  }
	                }
	              },
	              "ElasticInferenceAcceleratorAssociations": {
	                "locationName": "elasticInferenceAcceleratorAssociationSet",
	                "type": "list",
	                "member": {
	                  "locationName": "item",
	                  "type": "structure",
	                  "members": {
	                    "ElasticInferenceAcceleratorArn": {
	                      "locationName": "elasticInferenceAcceleratorArn"
	                    },
	                    "ElasticInferenceAcceleratorAssociationId": {
	                      "locationName": "elasticInferenceAcceleratorAssociationId"
	                    },
	                    "ElasticInferenceAcceleratorAssociationState": {
	                      "locationName": "elasticInferenceAcceleratorAssociationState"
	                    },
	                    "ElasticInferenceAcceleratorAssociationTime": {
	                      "locationName": "elasticInferenceAcceleratorAssociationTime",
	                      "type": "timestamp"
	                    }
	                  }
	                }
	              },
	              "NetworkInterfaces": {
	                "locationName": "networkInterfaceSet",
	                "type": "list",
	                "member": {
	                  "locationName": "item",
	                  "type": "structure",
	                  "members": {
	                    "Association": {
	                      "shape": "S17c",
	                      "locationName": "association"
	                    },
	                    "Attachment": {
	                      "locationName": "attachment",
	                      "type": "structure",
	                      "members": {
	                        "AttachTime": {
	                          "locationName": "attachTime",
	                          "type": "timestamp"
	                        },
	                        "AttachmentId": {
	                          "locationName": "attachmentId"
	                        },
	                        "DeleteOnTermination": {
	                          "locationName": "deleteOnTermination",
	                          "type": "boolean"
	                        },
	                        "DeviceIndex": {
	                          "locationName": "deviceIndex",
	                          "type": "integer"
	                        },
	                        "Status": {
	                          "locationName": "status"
	                        },
	                        "NetworkCardIndex": {
	                          "locationName": "networkCardIndex",
	                          "type": "integer"
	                        }
	                      }
	                    },
	                    "Description": {
	                      "locationName": "description"
	                    },
	                    "Groups": {
	                      "shape": "Sim",
	                      "locationName": "groupSet"
	                    },
	                    "Ipv6Addresses": {
	                      "shape": "Sfv",
	                      "locationName": "ipv6AddressesSet"
	                    },
	                    "MacAddress": {
	                      "locationName": "macAddress"
	                    },
	                    "NetworkInterfaceId": {
	                      "locationName": "networkInterfaceId"
	                    },
	                    "OwnerId": {
	                      "locationName": "ownerId"
	                    },
	                    "PrivateDnsName": {
	                      "locationName": "privateDnsName"
	                    },
	                    "PrivateIpAddress": {
	                      "locationName": "privateIpAddress"
	                    },
	                    "PrivateIpAddresses": {
	                      "locationName": "privateIpAddressesSet",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item",
	                        "type": "structure",
	                        "members": {
	                          "Association": {
	                            "shape": "S17c",
	                            "locationName": "association"
	                          },
	                          "Primary": {
	                            "locationName": "primary",
	                            "type": "boolean"
	                          },
	                          "PrivateDnsName": {
	                            "locationName": "privateDnsName"
	                          },
	                          "PrivateIpAddress": {
	                            "locationName": "privateIpAddress"
	                          }
	                        }
	                      }
	                    },
	                    "SourceDestCheck": {
	                      "locationName": "sourceDestCheck",
	                      "type": "boolean"
	                    },
	                    "Status": {
	                      "locationName": "status"
	                    },
	                    "SubnetId": {
	                      "locationName": "subnetId"
	                    },
	                    "VpcId": {
	                      "locationName": "vpcId"
	                    },
	                    "InterfaceType": {
	                      "locationName": "interfaceType"
	                    },
	                    "Ipv4Prefixes": {
	                      "locationName": "ipv4PrefixSet",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item",
	                        "type": "structure",
	                        "members": {
	                          "Ipv4Prefix": {
	                            "locationName": "ipv4Prefix"
	                          }
	                        }
	                      }
	                    },
	                    "Ipv6Prefixes": {
	                      "locationName": "ipv6PrefixSet",
	                      "type": "list",
	                      "member": {
	                        "locationName": "item",
	                        "type": "structure",
	                        "members": {
	                          "Ipv6Prefix": {
	                            "locationName": "ipv6Prefix"
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	              },
	              "OutpostArn": {
	                "locationName": "outpostArn"
	              },
	              "RootDeviceName": {
	                "locationName": "rootDeviceName"
	              },
	              "RootDeviceType": {
	                "locationName": "rootDeviceType"
	              },
	              "SecurityGroups": {
	                "shape": "Sim",
	                "locationName": "groupSet"
	              },
	              "SourceDestCheck": {
	                "locationName": "sourceDestCheck",
	                "type": "boolean"
	              },
	              "SpotInstanceRequestId": {
	                "locationName": "spotInstanceRequestId"
	              },
	              "SriovNetSupport": {
	                "locationName": "sriovNetSupport"
	              },
	              "StateReason": {
	                "shape": "S12g",
	                "locationName": "stateReason"
	              },
	              "Tags": {
	                "shape": "Ss",
	                "locationName": "tagSet"
	              },
	              "VirtualizationType": {
	                "locationName": "virtualizationType"
	              },
	              "CpuOptions": {
	                "locationName": "cpuOptions",
	                "type": "structure",
	                "members": {
	                  "CoreCount": {
	                    "locationName": "coreCount",
	                    "type": "integer"
	                  },
	                  "ThreadsPerCore": {
	                    "locationName": "threadsPerCore",
	                    "type": "integer"
	                  }
	                }
	              },
	              "CapacityReservationId": {
	                "locationName": "capacityReservationId"
	              },
	              "CapacityReservationSpecification": {
	                "locationName": "capacityReservationSpecification",
	                "type": "structure",
	                "members": {
	                  "CapacityReservationPreference": {
	                    "locationName": "capacityReservationPreference"
	                  },
	                  "CapacityReservationTarget": {
	                    "shape": "Sge",
	                    "locationName": "capacityReservationTarget"
	                  }
	                }
	              },
	              "HibernationOptions": {
	                "locationName": "hibernationOptions",
	                "type": "structure",
	                "members": {
	                  "Configured": {
	                    "locationName": "configured",
	                    "type": "boolean"
	                  }
	                }
	              },
	              "Licenses": {
	                "locationName": "licenseSet",
	                "type": "list",
	                "member": {
	                  "locationName": "item",
	                  "type": "structure",
	                  "members": {
	                    "LicenseConfigurationArn": {
	                      "locationName": "licenseConfigurationArn"
	                    }
	                  }
	                }
	              },
	              "MetadataOptions": {
	                "shape": "S17p",
	                "locationName": "metadataOptions"
	              },
	              "EnclaveOptions": {
	                "shape": "S139",
	                "locationName": "enclaveOptions"
	              },
	              "BootMode": {
	                "locationName": "bootMode"
	              },
	              "PlatformDetails": {
	                "locationName": "platformDetails"
	              },
	              "UsageOperation": {
	                "locationName": "usageOperation"
	              },
	              "UsageOperationUpdateTime": {
	                "locationName": "usageOperationUpdateTime",
	                "type": "timestamp"
	              },
	              "PrivateDnsNameOptions": {
	                "locationName": "privateDnsNameOptions",
	                "type": "structure",
	                "members": {
	                  "HostnameType": {
	                    "locationName": "hostnameType"
	                  },
	                  "EnableResourceNameDnsARecord": {
	                    "locationName": "enableResourceNameDnsARecord",
	                    "type": "boolean"
	                  },
	                  "EnableResourceNameDnsAAAARecord": {
	                    "locationName": "enableResourceNameDnsAAAARecord",
	                    "type": "boolean"
	                  }
	                }
	              },
	              "Ipv6Address": {
	                "locationName": "ipv6Address"
	              },
	              "TpmSupport": {
	                "locationName": "tpmSupport"
	              },
	              "MaintenanceOptions": {
	                "locationName": "maintenanceOptions",
	                "type": "structure",
	                "members": {
	                  "AutoRecovery": {
	                    "locationName": "autoRecovery"
	                  }
	                }
	              }
	            }
	          }
	        },
	        "OwnerId": {
	          "locationName": "ownerId"
	        },
	        "RequesterId": {
	          "locationName": "requesterId"
	        },
	        "ReservationId": {
	          "locationName": "reservationId"
	        }
	      }
	    },
	    "S173": {
	      "type": "structure",
	      "members": {
	        "State": {
	          "locationName": "state"
	        }
	      }
	    },
	    "S17c": {
	      "type": "structure",
	      "members": {
	        "CarrierIp": {
	          "locationName": "carrierIp"
	        },
	        "CustomerOwnedIp": {
	          "locationName": "customerOwnedIp"
	        },
	        "IpOwnerId": {
	          "locationName": "ipOwnerId"
	        },
	        "PublicDnsName": {
	          "locationName": "publicDnsName"
	        },
	        "PublicIp": {
	          "locationName": "publicIp"
	        }
	      }
	    },
	    "S17p": {
	      "type": "structure",
	      "members": {
	        "State": {
	          "locationName": "state"
	        },
	        "HttpTokens": {
	          "locationName": "httpTokens"
	        },
	        "HttpPutResponseHopLimit": {
	          "locationName": "httpPutResponseHopLimit",
	          "type": "integer"
	        },
	        "HttpEndpoint": {
	          "locationName": "httpEndpoint"
	        },
	        "HttpProtocolIpv6": {
	          "locationName": "httpProtocolIpv6"
	        },
	        "InstanceMetadataTags": {
	          "locationName": "instanceMetadataTags"
	        }
	      }
	    },
	    "S19l": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S1al": {
	      "type": "structure",
	      "members": {
	        "NetworkInsightsAccessScopeAnalysisId": {
	          "locationName": "networkInsightsAccessScopeAnalysisId"
	        },
	        "NetworkInsightsAccessScopeAnalysisArn": {
	          "locationName": "networkInsightsAccessScopeAnalysisArn"
	        },
	        "NetworkInsightsAccessScopeId": {
	          "locationName": "networkInsightsAccessScopeId"
	        },
	        "Status": {
	          "locationName": "status"
	        },
	        "StatusMessage": {
	          "locationName": "statusMessage"
	        },
	        "WarningMessage": {
	          "locationName": "warningMessage"
	        },
	        "StartDate": {
	          "locationName": "startDate",
	          "type": "timestamp"
	        },
	        "EndDate": {
	          "locationName": "endDate",
	          "type": "timestamp"
	        },
	        "FindingsFound": {
	          "locationName": "findingsFound"
	        },
	        "AnalyzedEniCount": {
	          "locationName": "analyzedEniCount",
	          "type": "integer"
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "S1aw": {
	      "type": "structure",
	      "members": {
	        "NetworkInsightsAnalysisId": {
	          "locationName": "networkInsightsAnalysisId"
	        },
	        "NetworkInsightsAnalysisArn": {
	          "locationName": "networkInsightsAnalysisArn"
	        },
	        "NetworkInsightsPathId": {
	          "locationName": "networkInsightsPathId"
	        },
	        "FilterInArns": {
	          "shape": "S1ax",
	          "locationName": "filterInArnSet"
	        },
	        "StartDate": {
	          "locationName": "startDate",
	          "type": "timestamp"
	        },
	        "Status": {
	          "locationName": "status"
	        },
	        "StatusMessage": {
	          "locationName": "statusMessage"
	        },
	        "WarningMessage": {
	          "locationName": "warningMessage"
	        },
	        "NetworkPathFound": {
	          "locationName": "networkPathFound",
	          "type": "boolean"
	        },
	        "ForwardPathComponents": {
	          "shape": "S1ay",
	          "locationName": "forwardPathComponentSet"
	        },
	        "ReturnPathComponents": {
	          "shape": "S1ay",
	          "locationName": "returnPathComponentSet"
	        },
	        "Explanations": {
	          "locationName": "explanationSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "Acl": {
	                "shape": "S1b1",
	                "locationName": "acl"
	              },
	              "AclRule": {
	                "shape": "S1b0",
	                "locationName": "aclRule"
	              },
	              "Address": {
	                "locationName": "address"
	              },
	              "Addresses": {
	                "shape": "S1b3",
	                "locationName": "addressSet"
	              },
	              "AttachedTo": {
	                "shape": "S1b1",
	                "locationName": "attachedTo"
	              },
	              "AvailabilityZones": {
	                "shape": "Se",
	                "locationName": "availabilityZoneSet"
	              },
	              "Cidrs": {
	                "shape": "Se",
	                "locationName": "cidrSet"
	              },
	              "Component": {
	                "shape": "S1b1",
	                "locationName": "component"
	              },
	              "CustomerGateway": {
	                "shape": "S1b1",
	                "locationName": "customerGateway"
	              },
	              "Destination": {
	                "shape": "S1b1",
	                "locationName": "destination"
	              },
	              "DestinationVpc": {
	                "shape": "S1b1",
	                "locationName": "destinationVpc"
	              },
	              "Direction": {
	                "locationName": "direction"
	              },
	              "ExplanationCode": {
	                "locationName": "explanationCode"
	              },
	              "IngressRouteTable": {
	                "shape": "S1b1",
	                "locationName": "ingressRouteTable"
	              },
	              "InternetGateway": {
	                "shape": "S1b1",
	                "locationName": "internetGateway"
	              },
	              "LoadBalancerArn": {
	                "locationName": "loadBalancerArn"
	              },
	              "ClassicLoadBalancerListener": {
	                "locationName": "classicLoadBalancerListener",
	                "type": "structure",
	                "members": {
	                  "LoadBalancerPort": {
	                    "locationName": "loadBalancerPort",
	                    "type": "integer"
	                  },
	                  "InstancePort": {
	                    "locationName": "instancePort",
	                    "type": "integer"
	                  }
	                }
	              },
	              "LoadBalancerListenerPort": {
	                "locationName": "loadBalancerListenerPort",
	                "type": "integer"
	              },
	              "LoadBalancerTarget": {
	                "locationName": "loadBalancerTarget",
	                "type": "structure",
	                "members": {
	                  "Address": {
	                    "locationName": "address"
	                  },
	                  "AvailabilityZone": {
	                    "locationName": "availabilityZone"
	                  },
	                  "Instance": {
	                    "shape": "S1b1",
	                    "locationName": "instance"
	                  },
	                  "Port": {
	                    "locationName": "port",
	                    "type": "integer"
	                  }
	                }
	              },
	              "LoadBalancerTargetGroup": {
	                "shape": "S1b1",
	                "locationName": "loadBalancerTargetGroup"
	              },
	              "LoadBalancerTargetGroups": {
	                "shape": "S1be",
	                "locationName": "loadBalancerTargetGroupSet"
	              },
	              "LoadBalancerTargetPort": {
	                "locationName": "loadBalancerTargetPort",
	                "type": "integer"
	              },
	              "ElasticLoadBalancerListener": {
	                "shape": "S1b1",
	                "locationName": "elasticLoadBalancerListener"
	              },
	              "MissingComponent": {
	                "locationName": "missingComponent"
	              },
	              "NatGateway": {
	                "shape": "S1b1",
	                "locationName": "natGateway"
	              },
	              "NetworkInterface": {
	                "shape": "S1b1",
	                "locationName": "networkInterface"
	              },
	              "PacketField": {
	                "locationName": "packetField"
	              },
	              "VpcPeeringConnection": {
	                "shape": "S1b1",
	                "locationName": "vpcPeeringConnection"
	              },
	              "Port": {
	                "locationName": "port",
	                "type": "integer"
	              },
	              "PortRanges": {
	                "shape": "S1b4",
	                "locationName": "portRangeSet"
	              },
	              "PrefixList": {
	                "shape": "S1b1",
	                "locationName": "prefixList"
	              },
	              "Protocols": {
	                "locationName": "protocolSet",
	                "type": "list",
	                "member": {
	                  "locationName": "item"
	                }
	              },
	              "RouteTableRoute": {
	                "shape": "S1b5",
	                "locationName": "routeTableRoute"
	              },
	              "RouteTable": {
	                "shape": "S1b1",
	                "locationName": "routeTable"
	              },
	              "SecurityGroup": {
	                "shape": "S1b1",
	                "locationName": "securityGroup"
	              },
	              "SecurityGroupRule": {
	                "shape": "S1b6",
	                "locationName": "securityGroupRule"
	              },
	              "SecurityGroups": {
	                "shape": "S1be",
	                "locationName": "securityGroupSet"
	              },
	              "SourceVpc": {
	                "shape": "S1b1",
	                "locationName": "sourceVpc"
	              },
	              "State": {
	                "locationName": "state"
	              },
	              "Subnet": {
	                "shape": "S1b1",
	                "locationName": "subnet"
	              },
	              "SubnetRouteTable": {
	                "shape": "S1b1",
	                "locationName": "subnetRouteTable"
	              },
	              "Vpc": {
	                "shape": "S1b1",
	                "locationName": "vpc"
	              },
	              "VpcEndpoint": {
	                "shape": "S1b1",
	                "locationName": "vpcEndpoint"
	              },
	              "VpnConnection": {
	                "shape": "S1b1",
	                "locationName": "vpnConnection"
	              },
	              "VpnGateway": {
	                "shape": "S1b1",
	                "locationName": "vpnGateway"
	              },
	              "TransitGateway": {
	                "shape": "S1b1",
	                "locationName": "transitGateway"
	              },
	              "TransitGatewayRouteTable": {
	                "shape": "S1b1",
	                "locationName": "transitGatewayRouteTable"
	              },
	              "TransitGatewayRouteTableRoute": {
	                "shape": "S1b9",
	                "locationName": "transitGatewayRouteTableRoute"
	              },
	              "TransitGatewayAttachment": {
	                "shape": "S1b1",
	                "locationName": "transitGatewayAttachment"
	              }
	            }
	          }
	        },
	        "AlternatePathHints": {
	          "locationName": "alternatePathHintSet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "ComponentId": {
	                "locationName": "componentId"
	              },
	              "ComponentArn": {
	                "locationName": "componentArn"
	              }
	            }
	          }
	        },
	        "Tags": {
	          "shape": "Ss",
	          "locationName": "tagSet"
	        }
	      }
	    },
	    "S1ax": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S1ay": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "SequenceNumber": {
	            "locationName": "sequenceNumber",
	            "type": "integer"
	          },
	          "AclRule": {
	            "shape": "S1b0",
	            "locationName": "aclRule"
	          },
	          "AttachedTo": {
	            "shape": "S1b1",
	            "locationName": "attachedTo"
	          },
	          "Component": {
	            "shape": "S1b1",
	            "locationName": "component"
	          },
	          "DestinationVpc": {
	            "shape": "S1b1",
	            "locationName": "destinationVpc"
	          },
	          "OutboundHeader": {
	            "shape": "S1b2",
	            "locationName": "outboundHeader"
	          },
	          "InboundHeader": {
	            "shape": "S1b2",
	            "locationName": "inboundHeader"
	          },
	          "RouteTableRoute": {
	            "shape": "S1b5",
	            "locationName": "routeTableRoute"
	          },
	          "SecurityGroupRule": {
	            "shape": "S1b6",
	            "locationName": "securityGroupRule"
	          },
	          "SourceVpc": {
	            "shape": "S1b1",
	            "locationName": "sourceVpc"
	          },
	          "Subnet": {
	            "shape": "S1b1",
	            "locationName": "subnet"
	          },
	          "Vpc": {
	            "shape": "S1b1",
	            "locationName": "vpc"
	          },
	          "AdditionalDetails": {
	            "locationName": "additionalDetailSet",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "AdditionalDetailType": {
	                  "locationName": "additionalDetailType"
	                },
	                "Component": {
	                  "shape": "S1b1",
	                  "locationName": "component"
	                }
	              }
	            }
	          },
	          "TransitGateway": {
	            "shape": "S1b1",
	            "locationName": "transitGateway"
	          },
	          "TransitGatewayRouteTableRoute": {
	            "shape": "S1b9",
	            "locationName": "transitGatewayRouteTableRoute"
	          }
	        }
	      }
	    },
	    "S1b0": {
	      "type": "structure",
	      "members": {
	        "Cidr": {
	          "locationName": "cidr"
	        },
	        "Egress": {
	          "locationName": "egress",
	          "type": "boolean"
	        },
	        "PortRange": {
	          "shape": "Shk",
	          "locationName": "portRange"
	        },
	        "Protocol": {
	          "locationName": "protocol"
	        },
	        "RuleAction": {
	          "locationName": "ruleAction"
	        },
	        "RuleNumber": {
	          "locationName": "ruleNumber",
	          "type": "integer"
	        }
	      }
	    },
	    "S1b1": {
	      "type": "structure",
	      "members": {
	        "Id": {
	          "locationName": "id"
	        },
	        "Arn": {
	          "locationName": "arn"
	        },
	        "Name": {
	          "locationName": "name"
	        }
	      }
	    },
	    "S1b2": {
	      "type": "structure",
	      "members": {
	        "DestinationAddresses": {
	          "shape": "S1b3",
	          "locationName": "destinationAddressSet"
	        },
	        "DestinationPortRanges": {
	          "shape": "S1b4",
	          "locationName": "destinationPortRangeSet"
	        },
	        "Protocol": {
	          "locationName": "protocol"
	        },
	        "SourceAddresses": {
	          "shape": "S1b3",
	          "locationName": "sourceAddressSet"
	        },
	        "SourcePortRanges": {
	          "shape": "S1b4",
	          "locationName": "sourcePortRangeSet"
	        }
	      }
	    },
	    "S1b3": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S1b4": {
	      "type": "list",
	      "member": {
	        "shape": "Shk",
	        "locationName": "item"
	      }
	    },
	    "S1b5": {
	      "type": "structure",
	      "members": {
	        "DestinationCidr": {
	          "locationName": "destinationCidr"
	        },
	        "DestinationPrefixListId": {
	          "locationName": "destinationPrefixListId"
	        },
	        "EgressOnlyInternetGatewayId": {
	          "locationName": "egressOnlyInternetGatewayId"
	        },
	        "GatewayId": {
	          "locationName": "gatewayId"
	        },
	        "InstanceId": {
	          "locationName": "instanceId"
	        },
	        "NatGatewayId": {
	          "locationName": "natGatewayId"
	        },
	        "NetworkInterfaceId": {
	          "locationName": "networkInterfaceId"
	        },
	        "Origin": {
	          "locationName": "origin"
	        },
	        "TransitGatewayId": {
	          "locationName": "transitGatewayId"
	        },
	        "VpcPeeringConnectionId": {
	          "locationName": "vpcPeeringConnectionId"
	        }
	      }
	    },
	    "S1b6": {
	      "type": "structure",
	      "members": {
	        "Cidr": {
	          "locationName": "cidr"
	        },
	        "Direction": {
	          "locationName": "direction"
	        },
	        "SecurityGroupId": {
	          "locationName": "securityGroupId"
	        },
	        "PortRange": {
	          "shape": "Shk",
	          "locationName": "portRange"
	        },
	        "PrefixListId": {
	          "locationName": "prefixListId"
	        },
	        "Protocol": {
	          "locationName": "protocol"
	        }
	      }
	    },
	    "S1b9": {
	      "type": "structure",
	      "members": {
	        "DestinationCidr": {
	          "locationName": "destinationCidr"
	        },
	        "State": {
	          "locationName": "state"
	        },
	        "RouteOrigin": {
	          "locationName": "routeOrigin"
	        },
	        "PrefixListId": {
	          "locationName": "prefixListId"
	        },
	        "AttachmentId": {
	          "locationName": "attachmentId"
	        },
	        "ResourceId": {
	          "locationName": "resourceId"
	        },
	        "ResourceType": {
	          "locationName": "resourceType"
	        }
	      }
	    },
	    "S1be": {
	      "type": "list",
	      "member": {
	        "shape": "S1b1",
	        "locationName": "item"
	      }
	    },
	    "S1cn": {
	      "type": "structure",
	      "members": {
	        "FirstAddress": {
	          "locationName": "firstAddress"
	        },
	        "LastAddress": {
	          "locationName": "lastAddress"
	        },
	        "AddressCount": {
	          "locationName": "addressCount",
	          "type": "integer"
	        },
	        "AvailableAddressCount": {
	          "locationName": "availableAddressCount",
	          "type": "integer"
	        }
	      }
	    },
	    "S1d0": {
	      "type": "list",
	      "member": {
	        "locationName": "ReservedInstancesId"
	      }
	    },
	    "S1d8": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Amount": {
	            "locationName": "amount",
	            "type": "double"
	          },
	          "Frequency": {
	            "locationName": "frequency"
	          }
	        }
	      }
	    },
	    "S1dm": {
	      "type": "structure",
	      "members": {
	        "AvailabilityZone": {
	          "locationName": "availabilityZone"
	        },
	        "InstanceCount": {
	          "locationName": "instanceCount",
	          "type": "integer"
	        },
	        "InstanceType": {
	          "locationName": "instanceType"
	        },
	        "Platform": {
	          "locationName": "platform"
	        },
	        "Scope": {
	          "locationName": "scope"
	        }
	      }
	    },
	    "S1e9": {
	      "type": "structure",
	      "members": {
	        "Frequency": {
	          "locationName": "frequency"
	        },
	        "Interval": {
	          "locationName": "interval",
	          "type": "integer"
	        },
	        "OccurrenceDaySet": {
	          "locationName": "occurrenceDaySet",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "integer"
	          }
	        },
	        "OccurrenceRelativeToEnd": {
	          "locationName": "occurrenceRelativeToEnd",
	          "type": "boolean"
	        },
	        "OccurrenceUnit": {
	          "locationName": "occurrenceUnit"
	        }
	      }
	    },
	    "S1eh": {
	      "type": "structure",
	      "members": {
	        "AvailabilityZone": {
	          "locationName": "availabilityZone"
	        },
	        "CreateDate": {
	          "locationName": "createDate",
	          "type": "timestamp"
	        },
	        "HourlyPrice": {
	          "locationName": "hourlyPrice"
	        },
	        "InstanceCount": {
	          "locationName": "instanceCount",
	          "type": "integer"
	        },
	        "InstanceType": {
	          "locationName": "instanceType"
	        },
	        "NetworkPlatform": {
	          "locationName": "networkPlatform"
	        },
	        "NextSlotStartTime": {
	          "locationName": "nextSlotStartTime",
	          "type": "timestamp"
	        },
	        "Platform": {
	          "locationName": "platform"
	        },
	        "PreviousSlotEndTime": {
	          "locationName": "previousSlotEndTime",
	          "type": "timestamp"
	        },
	        "Recurrence": {
	          "shape": "S1e9",
	          "locationName": "recurrence"
	        },
	        "ScheduledInstanceId": {
	          "locationName": "scheduledInstanceId"
	        },
	        "SlotDurationInHours": {
	          "locationName": "slotDurationInHours",
	          "type": "integer"
	        },
	        "TermEndDate": {
	          "locationName": "termEndDate",
	          "type": "timestamp"
	        },
	        "TermStartDate": {
	          "locationName": "termStartDate",
	          "type": "timestamp"
	        },
	        "TotalScheduledInstanceHours": {
	          "locationName": "totalScheduledInstanceHours",
	          "type": "integer"
	        }
	      }
	    },
	    "S1eo": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S1es": {
	      "type": "list",
	      "member": {
	        "locationName": "GroupName"
	      }
	    },
	    "S1f0": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Group": {
	            "locationName": "group"
	          },
	          "UserId": {
	            "locationName": "userId"
	          }
	        }
	      }
	    },
	    "S1fa": {
	      "type": "list",
	      "member": {
	        "locationName": "SnapshotId"
	      }
	    },
	    "S1ft": {
	      "type": "structure",
	      "required": [
	        "IamFleetRole",
	        "TargetCapacity"
	      ],
	      "members": {
	        "AllocationStrategy": {
	          "locationName": "allocationStrategy"
	        },
	        "OnDemandAllocationStrategy": {
	          "locationName": "onDemandAllocationStrategy"
	        },
	        "SpotMaintenanceStrategies": {
	          "locationName": "spotMaintenanceStrategies",
	          "type": "structure",
	          "members": {
	            "CapacityRebalance": {
	              "locationName": "capacityRebalance",
	              "type": "structure",
	              "members": {
	                "ReplacementStrategy": {
	                  "locationName": "replacementStrategy"
	                },
	                "TerminationDelay": {
	                  "locationName": "terminationDelay",
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        },
	        "ClientToken": {
	          "locationName": "clientToken"
	        },
	        "ExcessCapacityTerminationPolicy": {
	          "locationName": "excessCapacityTerminationPolicy"
	        },
	        "FulfilledCapacity": {
	          "locationName": "fulfilledCapacity",
	          "type": "double"
	        },
	        "OnDemandFulfilledCapacity": {
	          "locationName": "onDemandFulfilledCapacity",
	          "type": "double"
	        },
	        "IamFleetRole": {
	          "locationName": "iamFleetRole"
	        },
	        "LaunchSpecifications": {
	          "locationName": "launchSpecifications",
	          "type": "list",
	          "member": {
	            "locationName": "item",
	            "type": "structure",
	            "members": {
	              "SecurityGroups": {
	                "shape": "Sim",
	                "locationName": "groupSet"
	              },
	              "AddressingType": {
	                "locationName": "addressingType"
	              },
	              "BlockDeviceMappings": {
	                "shape": "S122",
	                "locationName": "blockDeviceMapping"
	              },
	              "EbsOptimized": {
	                "locationName": "ebsOptimized",
	                "type": "boolean"
	              },
	              "IamInstanceProfile": {
	                "shape": "S36",
	                "locationName": "iamInstanceProfile"
	              },
	              "ImageId": {
	                "locationName": "imageId"
	              },
	              "InstanceType": {
	                "locationName": "instanceType"
	              },
	              "KernelId": {
	                "locationName": "kernelId"
	              },
	              "KeyName": {
	                "locationName": "keyName"
	              },
	              "Monitoring": {
	                "locationName": "monitoring",
	                "type": "structure",
	                "members": {
	                  "Enabled": {
	                    "locationName": "enabled",
	                    "type": "boolean"
	                  }
	                }
	              },
	              "NetworkInterfaces": {
	                "shape": "S1g3",
	                "locationName": "networkInterfaceSet"
	              },
	              "Placement": {
	                "shape": "S1g5",
	                "locationName": "placement"
	              },
	              "RamdiskId": {
	                "locationName": "ramdiskId"
	              },
	              "SpotPrice": {
	                "locationName": "spotPrice"
	              },
	              "SubnetId": {
	                "locationName": "subnetId"
	              },
	              "UserData": {
	                "locationName": "userData"
	              },
	              "WeightedCapacity": {
	                "locationName": "weightedCapacity",
	                "type": "double"
	              },
	              "TagSpecifications": {
	                "locationName": "tagSpecificationSet",
	                "type": "list",
	                "member": {
	                  "locationName": "item",
	                  "type": "structure",
	                  "members": {
	                    "ResourceType": {
	                      "locationName": "resourceType"
	                    },
	                    "Tags": {
	                      "shape": "Ss",
	                      "locationName": "tag"
	                    }
	                  }
	                }
	              },
	              "InstanceRequirements": {
	                "shape": "Sbo",
	                "locationName": "instanceRequirements"
	              }
	            }
	          }
	        },
	        "LaunchTemplateConfigs": {
	          "shape": "S1g8",
	          "locationName": "launchTemplateConfigs"
	        },
	        "SpotPrice": {
	          "locationName": "spotPrice"
	        },
	        "TargetCapacity": {
	          "locationName": "targetCapacity",
	          "type": "integer"
	        },
	        "OnDemandTargetCapacity": {
	          "locationName": "onDemandTargetCapacity",
	          "type": "integer"
	        },
	        "OnDemandMaxTotalPrice": {
	          "locationName": "onDemandMaxTotalPrice"
	        },
	        "SpotMaxTotalPrice": {
	          "locationName": "spotMaxTotalPrice"
	        },
	        "TerminateInstancesWithExpiration": {
	          "locationName": "terminateInstancesWithExpiration",
	          "type": "boolean"
	        },
	        "Type": {
	          "locationName": "type"
	        },
	        "ValidFrom": {
	          "locationName": "validFrom",
	          "type": "timestamp"
	        },
	        "ValidUntil": {
	          "locationName": "validUntil",
	          "type": "timestamp"
	        },
	        "ReplaceUnhealthyInstances": {
	          "locationName": "replaceUnhealthyInstances",
	          "type": "boolean"
	        },
	        "InstanceInterruptionBehavior": {
	          "locationName": "instanceInterruptionBehavior"
	        },
	        "LoadBalancersConfig": {
	          "locationName": "loadBalancersConfig",
	          "type": "structure",
	          "members": {
	            "ClassicLoadBalancersConfig": {
	              "locationName": "classicLoadBalancersConfig",
	              "type": "structure",
	              "members": {
	                "ClassicLoadBalancers": {
	                  "locationName": "classicLoadBalancers",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "Name": {
	                        "locationName": "name"
	                      }
	                    }
	                  }
	                }
	              }
	            },
	            "TargetGroupsConfig": {
	              "locationName": "targetGroupsConfig",
	              "type": "structure",
	              "members": {
	                "TargetGroups": {
	                  "locationName": "targetGroups",
	                  "type": "list",
	                  "member": {
	                    "locationName": "item",
	                    "type": "structure",
	                    "members": {
	                      "Arn": {
	                        "locationName": "arn"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "InstancePoolsToUseCount": {
	          "locationName": "instancePoolsToUseCount",
	          "type": "integer"
	        },
	        "Context": {
	          "locationName": "context"
	        },
	        "TargetCapacityUnitType": {
	          "locationName": "targetCapacityUnitType"
	        },
	        "TagSpecifications": {
	          "shape": "S1t",
	          "locationName": "TagSpecification"
	        }
	      }
	    },
	    "S1g3": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "AssociatePublicIpAddress": {
	            "locationName": "associatePublicIpAddress",
	            "type": "boolean"
	          },
	          "DeleteOnTermination": {
	            "locationName": "deleteOnTermination",
	            "type": "boolean"
	          },
	          "Description": {
	            "locationName": "description"
	          },
	          "DeviceIndex": {
	            "locationName": "deviceIndex",
	            "type": "integer"
	          },
	          "Groups": {
	            "shape": "Se7",
	            "locationName": "SecurityGroupId"
	          },
	          "Ipv6AddressCount": {
	            "locationName": "ipv6AddressCount",
	            "type": "integer"
	          },
	          "Ipv6Addresses": {
	            "shape": "Sfv",
	            "locationName": "ipv6AddressesSet",
	            "queryName": "Ipv6Addresses"
	          },
	          "NetworkInterfaceId": {
	            "locationName": "networkInterfaceId"
	          },
	          "PrivateIpAddress": {
	            "locationName": "privateIpAddress"
	          },
	          "PrivateIpAddresses": {
	            "shape": "Sea",
	            "locationName": "privateIpAddressesSet",
	            "queryName": "PrivateIpAddresses"
	          },
	          "SecondaryPrivateIpAddressCount": {
	            "locationName": "secondaryPrivateIpAddressCount",
	            "type": "integer"
	          },
	          "SubnetId": {
	            "locationName": "subnetId"
	          },
	          "AssociateCarrierIpAddress": {
	            "type": "boolean"
	          },
	          "InterfaceType": {},
	          "NetworkCardIndex": {
	            "type": "integer"
	          },
	          "Ipv4Prefixes": {
	            "shape": "Sec",
	            "locationName": "Ipv4Prefix"
	          },
	          "Ipv4PrefixCount": {
	            "type": "integer"
	          },
	          "Ipv6Prefixes": {
	            "shape": "See",
	            "locationName": "Ipv6Prefix"
	          },
	          "Ipv6PrefixCount": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S1g5": {
	      "type": "structure",
	      "members": {
	        "AvailabilityZone": {
	          "locationName": "availabilityZone"
	        },
	        "GroupName": {
	          "locationName": "groupName"
	        },
	        "Tenancy": {
	          "locationName": "tenancy"
	        }
	      }
	    },
	    "S1g8": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "LaunchTemplateSpecification": {
	            "shape": "Sbl",
	            "locationName": "launchTemplateSpecification"
	          },
	          "Overrides": {
	            "locationName": "overrides",
	            "type": "list",
	            "member": {
	              "locationName": "item",
	              "type": "structure",
	              "members": {
	                "InstanceType": {
	                  "locationName": "instanceType"
	                },
	                "SpotPrice": {
	                  "locationName": "spotPrice"
	                },
	                "SubnetId": {
	                  "locationName": "subnetId"
	                },
	                "AvailabilityZone": {
	                  "locationName": "availabilityZone"
	                },
	                "WeightedCapacity": {
	                  "locationName": "weightedCapacity",
	                  "type": "double"
	                },
	                "Priority": {
	                  "locationName": "priority",
	                  "type": "double"
	                },
	                "InstanceRequirements": {
	                  "shape": "Sbo",
	                  "locationName": "instanceRequirements"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1gl": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "ActualBlockHourlyPrice": {
	            "locationName": "actualBlockHourlyPrice"
	          },
	          "AvailabilityZoneGroup": {
	            "locationName": "availabilityZoneGroup"
	          },
	          "BlockDurationMinutes": {
	            "locationName": "blockDurationMinutes",
	            "type": "integer"
	          },
	          "CreateTime": {
	            "locationName": "createTime",
	            "type": "timestamp"
	          },
	          "Fault": {
	            "shape": "Skg",
	            "locationName": "fault"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "LaunchGroup": {
	            "locationName": "launchGroup"
	          },
	          "LaunchSpecification": {
	            "locationName": "launchSpecification",
	            "type": "structure",
	            "members": {
	              "UserData": {
	                "locationName": "userData"
	              },
	              "SecurityGroups": {
	                "shape": "Sim",
	                "locationName": "groupSet"
	              },
	              "AddressingType": {
	                "locationName": "addressingType"
	              },
	              "BlockDeviceMappings": {
	                "shape": "S122",
	                "locationName": "blockDeviceMapping"
	              },
	              "EbsOptimized": {
	                "locationName": "ebsOptimized",
	                "type": "boolean"
	              },
	              "IamInstanceProfile": {
	                "shape": "S36",
	                "locationName": "iamInstanceProfile"
	              },
	              "ImageId": {
	                "locationName": "imageId"
	              },
	              "InstanceType": {
	                "locationName": "instanceType"
	              },
	              "KernelId": {
	                "locationName": "kernelId"
	              },
	              "KeyName": {
	                "locationName": "keyName"
	              },
	              "NetworkInterfaces": {
	                "shape": "S1g3",
	                "locationName": "networkInterfaceSet"
	              },
	              "Placement": {
	                "shape": "S1g5",
	                "locationName": "placement"
	              },
	              "RamdiskId": {
	                "locationName": "ramdiskId"
	              },
	              "SubnetId": {
	                "locationName": "subnetId"
	              },
	              "Monitoring": {
	                "shape": "S1go",
	                "locationName": "monitoring"
	              }
	            }
	          },
	          "LaunchedAvailabilityZone": {
	            "locationName": "launchedAvailabilityZone"
	          },
	          "ProductDescription": {
	            "locationName": "productDescription"
	          },
	          "SpotInstanceRequestId": {
	            "locationName": "spotInstanceRequestId"
	          },
	          "SpotPrice": {
	            "locationName": "spotPrice"
	          },
	          "State": {
	            "locationName": "state"
	          },
	          "Status": {
	            "locationName": "status",
	            "type": "structure",
	            "members": {
	              "Code": {
	                "locationName": "code"
	              },
	              "Message": {
	                "locationName": "message"
	              },
	              "UpdateTime": {
	                "locationName": "updateTime",
	                "type": "timestamp"
	              }
	            }
	          },
	          "Tags": {
	            "shape": "Ss",
	            "locationName": "tagSet"
	          },
	          "Type": {
	            "locationName": "type"
	          },
	          "ValidFrom": {
	            "locationName": "validFrom",
	            "type": "timestamp"
	          },
	          "ValidUntil": {
	            "locationName": "validUntil",
	            "type": "timestamp"
	          },
	          "InstanceInterruptionBehavior": {
	            "locationName": "instanceInterruptionBehavior"
	          }
	        }
	      }
	    },
	    "S1go": {
	      "type": "structure",
	      "required": [
	        "Enabled"
	      ],
	      "members": {
	        "Enabled": {
	          "locationName": "enabled",
	          "type": "boolean"
	        }
	      }
	    },
	    "S1h3": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "FromPort": {
	            "locationName": "fromPort",
	            "type": "integer"
	          },
	          "IpProtocol": {
	            "locationName": "ipProtocol"
	          },
	          "IpRanges": {
	            "locationName": "ipRanges",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "PrefixListIds": {
	            "locationName": "prefixListIds",
	            "type": "list",
	            "member": {
	              "locationName": "item"
	            }
	          },
	          "ToPort": {
	            "locationName": "toPort",
	            "type": "integer"
	          },
	          "UserIdGroupPairs": {
	            "locationName": "groups",
	            "type": "list",
	            "member": {
	              "shape": "S5h",
	              "locationName": "item"
	            }
	          }
	        }
	      }
	    },
	    "S1i1": {
	      "type": "list",
	      "member": {}
	    },
	    "S1j5": {
	      "type": "list",
	      "member": {
	        "locationName": "VolumeId"
	      }
	    },
	    "S1jq": {
	      "type": "structure",
	      "members": {
	        "VolumeId": {
	          "locationName": "volumeId"
	        },
	        "ModificationState": {
	          "locationName": "modificationState"
	        },
	        "StatusMessage": {
	          "locationName": "statusMessage"
	        },
	        "TargetSize": {
	          "locationName": "targetSize",
	          "type": "integer"
	        },
	        "TargetIops": {
	          "locationName": "targetIops",
	          "type": "integer"
	        },
	        "TargetVolumeType": {
	          "locationName": "targetVolumeType"
	        },
	        "TargetThroughput": {
	          "locationName": "targetThroughput",
	          "type": "integer"
	        },
	        "TargetMultiAttachEnabled": {
	          "locationName": "targetMultiAttachEnabled",
	          "type": "boolean"
	        },
	        "OriginalSize": {
	          "locationName": "originalSize",
	          "type": "integer"
	        },
	        "OriginalIops": {
	          "locationName": "originalIops",
	          "type": "integer"
	        },
	        "OriginalVolumeType": {
	          "locationName": "originalVolumeType"
	        },
	        "OriginalThroughput": {
	          "locationName": "originalThroughput",
	          "type": "integer"
	        },
	        "OriginalMultiAttachEnabled": {
	          "locationName": "originalMultiAttachEnabled",
	          "type": "boolean"
	        },
	        "Progress": {
	          "locationName": "progress",
	          "type": "long"
	        },
	        "StartTime": {
	          "locationName": "startTime",
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "locationName": "endTime",
	          "type": "timestamp"
	        }
	      }
	    },
	    "S1jw": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcId"
	      }
	    },
	    "S1lo": {
	      "type": "list",
	      "member": {
	        "locationName": "AvailabilityZone"
	      }
	    },
	    "S1m5": {
	      "type": "structure",
	      "members": {
	        "TransitGatewayAttachmentId": {
	          "locationName": "transitGatewayAttachmentId"
	        },
	        "ResourceId": {
	          "locationName": "resourceId"
	        },
	        "ResourceType": {
	          "locationName": "resourceType"
	        },
	        "TransitGatewayRouteTableId": {
	          "locationName": "transitGatewayRouteTableId"
	        },
	        "State": {
	          "locationName": "state"
	        }
	      }
	    },
	    "S1ot": {
	      "type": "structure",
	      "members": {
	        "InstanceFamily": {
	          "locationName": "instanceFamily"
	        },
	        "CpuCredits": {
	          "locationName": "cpuCredits"
	        }
	      }
	    },
	    "S1pa": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S1pc": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "CurrencyCode": {
	            "locationName": "currencyCode"
	          },
	          "Duration": {
	            "locationName": "duration",
	            "type": "integer"
	          },
	          "HostIdSet": {
	            "shape": "S11a",
	            "locationName": "hostIdSet"
	          },
	          "HostReservationId": {
	            "locationName": "hostReservationId"
	          },
	          "HourlyPrice": {
	            "locationName": "hourlyPrice"
	          },
	          "InstanceFamily": {
	            "locationName": "instanceFamily"
	          },
	          "PaymentOption": {
	            "locationName": "paymentOption"
	          },
	          "UpfrontPrice": {
	            "locationName": "upfrontPrice"
	          }
	        }
	      }
	    },
	    "S1pf": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S1pg": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S1q5": {
	      "type": "structure",
	      "members": {
	        "IpamId": {
	          "locationName": "ipamId"
	        },
	        "IpamScopeId": {
	          "locationName": "ipamScopeId"
	        },
	        "IpamPoolId": {
	          "locationName": "ipamPoolId"
	        },
	        "ResourceRegion": {
	          "locationName": "resourceRegion"
	        },
	        "ResourceOwnerId": {
	          "locationName": "resourceOwnerId"
	        },
	        "ResourceId": {
	          "locationName": "resourceId"
	        },
	        "ResourceName": {
	          "locationName": "resourceName"
	        },
	        "ResourceCidr": {
	          "locationName": "resourceCidr"
	        },
	        "ResourceType": {
	          "locationName": "resourceType"
	        },
	        "ResourceTags": {
	          "shape": "Sdm",
	          "locationName": "resourceTagSet"
	        },
	        "IpUsage": {
	          "locationName": "ipUsage",
	          "type": "double"
	        },
	        "ComplianceStatus": {
	          "locationName": "complianceStatus"
	        },
	        "ManagementState": {
	          "locationName": "managementState"
	        },
	        "OverlapStatus": {
	          "locationName": "overlapStatus"
	        },
	        "VpcId": {
	          "locationName": "vpcId"
	        }
	      }
	    },
	    "S1qt": {
	      "type": "structure",
	      "members": {
	        "HourlyPrice": {
	          "locationName": "hourlyPrice"
	        },
	        "RemainingTotalValue": {
	          "locationName": "remainingTotalValue"
	        },
	        "RemainingUpfrontValue": {
	          "locationName": "remainingUpfrontValue"
	        }
	      }
	    },
	    "S1rd": {
	      "type": "list",
	      "member": {
	        "shape": "Skr",
	        "locationName": "item"
	      }
	    },
	    "S1s9": {
	      "type": "structure",
	      "members": {
	        "Comment": {},
	        "UploadEnd": {
	          "type": "timestamp"
	        },
	        "UploadSize": {
	          "type": "double"
	        },
	        "UploadStart": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S1sc": {
	      "type": "structure",
	      "members": {
	        "S3Bucket": {},
	        "S3Key": {}
	      }
	    },
	    "S1sj": {
	      "type": "structure",
	      "required": [
	        "Bytes",
	        "Format",
	        "ImportManifestUrl"
	      ],
	      "members": {
	        "Bytes": {
	          "locationName": "bytes",
	          "type": "long"
	        },
	        "Format": {
	          "locationName": "format"
	        },
	        "ImportManifestUrl": {
	          "locationName": "importManifestUrl"
	        }
	      }
	    },
	    "S1sk": {
	      "type": "structure",
	      "required": [
	        "Size"
	      ],
	      "members": {
	        "Size": {
	          "locationName": "size",
	          "type": "long"
	        }
	      }
	    },
	    "S1tp": {
	      "type": "list",
	      "member": {
	        "locationName": "UserId"
	      }
	    },
	    "S1tq": {
	      "type": "list",
	      "member": {
	        "locationName": "UserGroup"
	      }
	    },
	    "S1tr": {
	      "type": "list",
	      "member": {
	        "locationName": "ProductCode"
	      }
	    },
	    "S1tt": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "Group": {},
	          "UserId": {}
	        }
	      }
	    },
	    "S1ty": {
	      "type": "list",
	      "member": {
	        "shape": "S17",
	        "locationName": "item"
	      }
	    },
	    "S1ub": {
	      "type": "structure",
	      "members": {
	        "CapacityReservationPreference": {},
	        "CapacityReservationTarget": {
	          "shape": "Sf3"
	        }
	      }
	    },
	    "S1ww": {
	      "type": "structure",
	      "members": {
	        "AllowDnsResolutionFromRemoteVpc": {
	          "type": "boolean"
	        },
	        "AllowEgressFromLocalClassicLinkToRemoteVpc": {
	          "type": "boolean"
	        },
	        "AllowEgressFromLocalVpcToRemoteClassicLink": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1wy": {
	      "type": "structure",
	      "members": {
	        "AllowDnsResolutionFromRemoteVpc": {
	          "locationName": "allowDnsResolutionFromRemoteVpc",
	          "type": "boolean"
	        },
	        "AllowEgressFromLocalClassicLinkToRemoteVpc": {
	          "locationName": "allowEgressFromLocalClassicLinkToRemoteVpc",
	          "type": "boolean"
	        },
	        "AllowEgressFromLocalVpcToRemoteClassicLink": {
	          "locationName": "allowEgressFromLocalVpcToRemoteClassicLink",
	          "type": "boolean"
	        }
	      }
	    },
	    "S1xd": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "Monitoring": {
	            "shape": "S173",
	            "locationName": "monitoring"
	          }
	        }
	      }
	    },
	    "S210": {
	      "type": "list",
	      "member": {
	        "locationName": "SecurityGroupId"
	      }
	    },
	    "S21o": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "CurrentState": {
	            "shape": "S13u",
	            "locationName": "currentState"
	          },
	          "InstanceId": {
	            "locationName": "instanceId"
	          },
	          "PreviousState": {
	            "shape": "S13u",
	            "locationName": "previousState"
	          }
	        }
	      }
	    },
	    "S22a": {
	      "type": "list",
	      "member": {
	        "locationName": "item",
	        "type": "structure",
	        "members": {
	          "SecurityGroupRuleId": {},
	          "Description": {}
	        }
	      }
	    }
	  }
	}
	},{}],80:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeAccountAttributes": {
	      "result_key": "AccountAttributes"
	    },
	    "DescribeAddresses": {
	      "result_key": "Addresses"
	    },
	    "DescribeAddressesAttribute": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Addresses"
	    },
	    "DescribeAvailabilityZones": {
	      "result_key": "AvailabilityZones"
	    },
	    "DescribeBundleTasks": {
	      "result_key": "BundleTasks"
	    },
	    "DescribeByoipCidrs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ByoipCidrs"
	    },
	    "DescribeCapacityReservationFleets": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "CapacityReservationFleets"
	    },
	    "DescribeCapacityReservations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "CapacityReservations"
	    },
	    "DescribeCarrierGateways": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "CarrierGateways"
	    },
	    "DescribeClassicLinkInstances": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Instances"
	    },
	    "DescribeClientVpnAuthorizationRules": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "AuthorizationRules"
	    },
	    "DescribeClientVpnConnections": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Connections"
	    },
	    "DescribeClientVpnEndpoints": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ClientVpnEndpoints"
	    },
	    "DescribeClientVpnRoutes": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Routes"
	    },
	    "DescribeClientVpnTargetNetworks": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ClientVpnTargetNetworks"
	    },
	    "DescribeCoipPools": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "CoipPools"
	    },
	    "DescribeConversionTasks": {
	      "result_key": "ConversionTasks"
	    },
	    "DescribeCustomerGateways": {
	      "result_key": "CustomerGateways"
	    },
	    "DescribeDhcpOptions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "DhcpOptions"
	    },
	    "DescribeEgressOnlyInternetGateways": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "EgressOnlyInternetGateways"
	    },
	    "DescribeExportImageTasks": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ExportImageTasks"
	    },
	    "DescribeExportTasks": {
	      "result_key": "ExportTasks"
	    },
	    "DescribeFastLaunchImages": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "FastLaunchImages"
	    },
	    "DescribeFastSnapshotRestores": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "FastSnapshotRestores"
	    },
	    "DescribeFleets": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Fleets"
	    },
	    "DescribeFlowLogs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "FlowLogs"
	    },
	    "DescribeFpgaImages": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "FpgaImages"
	    },
	    "DescribeHostReservationOfferings": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "OfferingSet"
	    },
	    "DescribeHostReservations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "HostReservationSet"
	    },
	    "DescribeHosts": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Hosts"
	    },
	    "DescribeIamInstanceProfileAssociations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "IamInstanceProfileAssociations"
	    },
	    "DescribeImages": {
	      "result_key": "Images"
	    },
	    "DescribeImportImageTasks": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ImportImageTasks"
	    },
	    "DescribeImportSnapshotTasks": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ImportSnapshotTasks"
	    },
	    "DescribeInstanceCreditSpecifications": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InstanceCreditSpecifications"
	    },
	    "DescribeInstanceEventWindows": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InstanceEventWindows"
	    },
	    "DescribeInstanceStatus": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InstanceStatuses"
	    },
	    "DescribeInstanceTypeOfferings": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InstanceTypeOfferings"
	    },
	    "DescribeInstanceTypes": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InstanceTypes"
	    },
	    "DescribeInstances": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Reservations"
	    },
	    "DescribeInternetGateways": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InternetGateways"
	    },
	    "DescribeIpamPools": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "IpamPools"
	    },
	    "DescribeIpamScopes": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "IpamScopes"
	    },
	    "DescribeIpams": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Ipams"
	    },
	    "DescribeIpv6Pools": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Ipv6Pools"
	    },
	    "DescribeKeyPairs": {
	      "result_key": "KeyPairs"
	    },
	    "DescribeLaunchTemplateVersions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "LaunchTemplateVersions"
	    },
	    "DescribeLaunchTemplates": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "LaunchTemplates"
	    },
	    "DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "LocalGatewayRouteTableVirtualInterfaceGroupAssociations"
	    },
	    "DescribeLocalGatewayRouteTableVpcAssociations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "LocalGatewayRouteTableVpcAssociations"
	    },
	    "DescribeLocalGatewayRouteTables": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "LocalGatewayRouteTables"
	    },
	    "DescribeLocalGatewayVirtualInterfaceGroups": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "LocalGatewayVirtualInterfaceGroups"
	    },
	    "DescribeLocalGatewayVirtualInterfaces": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "LocalGatewayVirtualInterfaces"
	    },
	    "DescribeLocalGateways": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "LocalGateways"
	    },
	    "DescribeManagedPrefixLists": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "PrefixLists"
	    },
	    "DescribeMovingAddresses": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "MovingAddressStatuses"
	    },
	    "DescribeNatGateways": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "NatGateways"
	    },
	    "DescribeNetworkAcls": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "NetworkAcls"
	    },
	    "DescribeNetworkInsightsAccessScopeAnalyses": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "NetworkInsightsAccessScopeAnalyses"
	    },
	    "DescribeNetworkInsightsAccessScopes": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "NetworkInsightsAccessScopes"
	    },
	    "DescribeNetworkInsightsAnalyses": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "NetworkInsightsAnalyses"
	    },
	    "DescribeNetworkInsightsPaths": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "NetworkInsightsPaths"
	    },
	    "DescribeNetworkInterfacePermissions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "NetworkInterfacePermissions"
	    },
	    "DescribeNetworkInterfaces": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "NetworkInterfaces"
	    },
	    "DescribePlacementGroups": {
	      "result_key": "PlacementGroups"
	    },
	    "DescribePrefixLists": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "PrefixLists"
	    },
	    "DescribePrincipalIdFormat": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Principals"
	    },
	    "DescribePublicIpv4Pools": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "PublicIpv4Pools"
	    },
	    "DescribeRegions": {
	      "result_key": "Regions"
	    },
	    "DescribeReplaceRootVolumeTasks": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ReplaceRootVolumeTasks"
	    },
	    "DescribeReservedInstances": {
	      "result_key": "ReservedInstances"
	    },
	    "DescribeReservedInstancesListings": {
	      "result_key": "ReservedInstancesListings"
	    },
	    "DescribeReservedInstancesModifications": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "ReservedInstancesModifications"
	    },
	    "DescribeReservedInstancesOfferings": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ReservedInstancesOfferings"
	    },
	    "DescribeRouteTables": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "RouteTables"
	    },
	    "DescribeScheduledInstanceAvailability": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ScheduledInstanceAvailabilitySet"
	    },
	    "DescribeScheduledInstances": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ScheduledInstanceSet"
	    },
	    "DescribeSecurityGroupRules": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "SecurityGroupRules"
	    },
	    "DescribeSecurityGroups": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "SecurityGroups"
	    },
	    "DescribeSnapshotTierStatus": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "SnapshotTierStatuses"
	    },
	    "DescribeSnapshots": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Snapshots"
	    },
	    "DescribeSpotFleetRequests": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "SpotFleetRequestConfigs"
	    },
	    "DescribeSpotInstanceRequests": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "SpotInstanceRequests"
	    },
	    "DescribeSpotPriceHistory": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "SpotPriceHistory"
	    },
	    "DescribeStaleSecurityGroups": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "StaleSecurityGroupSet"
	    },
	    "DescribeStoreImageTasks": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "StoreImageTaskResults"
	    },
	    "DescribeSubnets": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Subnets"
	    },
	    "DescribeTags": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Tags"
	    },
	    "DescribeTrafficMirrorFilters": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TrafficMirrorFilters"
	    },
	    "DescribeTrafficMirrorSessions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TrafficMirrorSessions"
	    },
	    "DescribeTrafficMirrorTargets": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TrafficMirrorTargets"
	    },
	    "DescribeTransitGatewayAttachments": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TransitGatewayAttachments"
	    },
	    "DescribeTransitGatewayConnectPeers": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TransitGatewayConnectPeers"
	    },
	    "DescribeTransitGatewayConnects": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TransitGatewayConnects"
	    },
	    "DescribeTransitGatewayMulticastDomains": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TransitGatewayMulticastDomains"
	    },
	    "DescribeTransitGatewayPeeringAttachments": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TransitGatewayPeeringAttachments"
	    },
	    "DescribeTransitGatewayRouteTables": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TransitGatewayRouteTables"
	    },
	    "DescribeTransitGatewayVpcAttachments": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TransitGatewayVpcAttachments"
	    },
	    "DescribeTransitGateways": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TransitGateways"
	    },
	    "DescribeTrunkInterfaceAssociations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InterfaceAssociations"
	    },
	    "DescribeVolumeStatus": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "VolumeStatuses"
	    },
	    "DescribeVolumes": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Volumes"
	    },
	    "DescribeVolumesModifications": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "VolumesModifications"
	    },
	    "DescribeVpcClassicLinkDnsSupport": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Vpcs"
	    },
	    "DescribeVpcEndpointConnectionNotifications": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ConnectionNotificationSet"
	    },
	    "DescribeVpcEndpointConnections": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "VpcEndpointConnections"
	    },
	    "DescribeVpcEndpointServiceConfigurations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ServiceConfigurations"
	    },
	    "DescribeVpcEndpointServicePermissions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "AllowedPrincipals"
	    },
	    "DescribeVpcEndpoints": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "VpcEndpoints"
	    },
	    "DescribeVpcPeeringConnections": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "VpcPeeringConnections"
	    },
	    "DescribeVpcs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Vpcs"
	    },
	    "DescribeVpnConnections": {
	      "result_key": "VpnConnections"
	    },
	    "DescribeVpnGateways": {
	      "result_key": "VpnGateways"
	    },
	    "GetAssociatedIpv6PoolCidrs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Ipv6CidrAssociations"
	    },
	    "GetGroupsForCapacityReservation": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "CapacityReservationGroups"
	    },
	    "GetInstanceTypesFromInstanceRequirements": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InstanceTypes"
	    },
	    "GetIpamAddressHistory": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "HistoryRecords"
	    },
	    "GetIpamPoolAllocations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "IpamPoolAllocations"
	    },
	    "GetIpamPoolCidrs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "IpamPoolCidrs"
	    },
	    "GetIpamResourceCidrs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "IpamResourceCidrs"
	    },
	    "GetManagedPrefixListAssociations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "PrefixListAssociations"
	    },
	    "GetManagedPrefixListEntries": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Entries"
	    },
	    "GetSpotPlacementScores": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "SpotPlacementScores"
	    },
	    "GetTransitGatewayAttachmentPropagations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TransitGatewayAttachmentPropagations"
	    },
	    "GetTransitGatewayMulticastDomainAssociations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "MulticastDomainAssociations"
	    },
	    "GetTransitGatewayPrefixListReferences": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TransitGatewayPrefixListReferences"
	    },
	    "GetTransitGatewayRouteTableAssociations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Associations"
	    },
	    "GetTransitGatewayRouteTablePropagations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "TransitGatewayRouteTablePropagations"
	    },
	    "GetVpnConnectionDeviceTypes": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "VpnConnectionDeviceTypes"
	    },
	    "ListImagesInRecycleBin": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Images"
	    },
	    "ListSnapshotsInRecycleBin": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Snapshots"
	    },
	    "SearchLocalGatewayRoutes": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Routes"
	    },
	    "SearchTransitGatewayMulticastGroups": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "MulticastGroups"
	    }
	  }
	}
	},{}],81:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "InstanceExists": {
	      "delay": 5,
	      "maxAttempts": 40,
	      "operation": "DescribeInstances",
	      "acceptors": [
	        {
	          "matcher": "path",
	          "expected": true,
	          "argument": "length(Reservations[]) > `0`",
	          "state": "success"
	        },
	        {
	          "matcher": "error",
	          "expected": "InvalidInstanceID.NotFound",
	          "state": "retry"
	        }
	      ]
	    },
	    "BundleTaskComplete": {
	      "delay": 15,
	      "operation": "DescribeBundleTasks",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "complete",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "BundleTasks[].State"
	        },
	        {
	          "expected": "failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "BundleTasks[].State"
	        }
	      ]
	    },
	    "ConversionTaskCancelled": {
	      "delay": 15,
	      "operation": "DescribeConversionTasks",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "cancelled",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "ConversionTasks[].State"
	        }
	      ]
	    },
	    "ConversionTaskCompleted": {
	      "delay": 15,
	      "operation": "DescribeConversionTasks",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "completed",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "ConversionTasks[].State"
	        },
	        {
	          "expected": "cancelled",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "ConversionTasks[].State"
	        },
	        {
	          "expected": "cancelling",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "ConversionTasks[].State"
	        }
	      ]
	    },
	    "ConversionTaskDeleted": {
	      "delay": 15,
	      "operation": "DescribeConversionTasks",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "deleted",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "ConversionTasks[].State"
	        }
	      ]
	    },
	    "CustomerGatewayAvailable": {
	      "delay": 15,
	      "operation": "DescribeCustomerGateways",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "CustomerGateways[].State"
	        },
	        {
	          "expected": "deleted",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "CustomerGateways[].State"
	        },
	        {
	          "expected": "deleting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "CustomerGateways[].State"
	        }
	      ]
	    },
	    "ExportTaskCancelled": {
	      "delay": 15,
	      "operation": "DescribeExportTasks",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "cancelled",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "ExportTasks[].State"
	        }
	      ]
	    },
	    "ExportTaskCompleted": {
	      "delay": 15,
	      "operation": "DescribeExportTasks",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "completed",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "ExportTasks[].State"
	        }
	      ]
	    },
	    "ImageExists": {
	      "operation": "DescribeImages",
	      "maxAttempts": 40,
	      "delay": 15,
	      "acceptors": [
	        {
	          "matcher": "path",
	          "expected": true,
	          "argument": "length(Images[]) > `0`",
	          "state": "success"
	        },
	        {
	          "matcher": "error",
	          "expected": "InvalidAMIID.NotFound",
	          "state": "retry"
	        }
	      ]
	    },
	    "ImageAvailable": {
	      "operation": "DescribeImages",
	      "maxAttempts": 40,
	      "delay": 15,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "Images[].State",
	          "expected": "available"
	        },
	        {
	          "state": "failure",
	          "matcher": "pathAny",
	          "argument": "Images[].State",
	          "expected": "failed"
	        }
	      ]
	    },
	    "InstanceRunning": {
	      "delay": 15,
	      "operation": "DescribeInstances",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "running",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Reservations[].Instances[].State.Name"
	        },
	        {
	          "expected": "shutting-down",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Reservations[].Instances[].State.Name"
	        },
	        {
	          "expected": "terminated",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Reservations[].Instances[].State.Name"
	        },
	        {
	          "expected": "stopping",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Reservations[].Instances[].State.Name"
	        },
	        {
	          "matcher": "error",
	          "expected": "InvalidInstanceID.NotFound",
	          "state": "retry"
	        }
	      ]
	    },
	    "InstanceStatusOk": {
	      "operation": "DescribeInstanceStatus",
	      "maxAttempts": 40,
	      "delay": 15,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "InstanceStatuses[].InstanceStatus.Status",
	          "expected": "ok"
	        },
	        {
	          "matcher": "error",
	          "expected": "InvalidInstanceID.NotFound",
	          "state": "retry"
	        }
	      ]
	    },
	    "InstanceStopped": {
	      "delay": 15,
	      "operation": "DescribeInstances",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "stopped",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Reservations[].Instances[].State.Name"
	        },
	        {
	          "expected": "pending",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Reservations[].Instances[].State.Name"
	        },
	        {
	          "expected": "terminated",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Reservations[].Instances[].State.Name"
	        }
	      ]
	    },
	    "InstanceTerminated": {
	      "delay": 15,
	      "operation": "DescribeInstances",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "terminated",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Reservations[].Instances[].State.Name"
	        },
	        {
	          "expected": "pending",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Reservations[].Instances[].State.Name"
	        },
	        {
	          "expected": "stopping",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Reservations[].Instances[].State.Name"
	        }
	      ]
	    },
	    "InternetGatewayExists": {
	      "operation": "DescribeInternetGateways",
	      "delay": 5,
	      "maxAttempts": 6,
	      "acceptors": [
	        {
	          "expected": true,
	          "matcher": "path",
	          "state": "success",
	          "argument": "length(InternetGateways[].InternetGatewayId) > `0`"
	        },
	        {
	          "expected": "InvalidInternetGateway.NotFound",
	          "matcher": "error",
	          "state": "retry"
	        }
	      ]
	    },
	    "KeyPairExists": {
	      "operation": "DescribeKeyPairs",
	      "delay": 5,
	      "maxAttempts": 6,
	      "acceptors": [
	        {
	          "expected": true,
	          "matcher": "path",
	          "state": "success",
	          "argument": "length(KeyPairs[].KeyName) > `0`"
	        },
	        {
	          "expected": "InvalidKeyPair.NotFound",
	          "matcher": "error",
	          "state": "retry"
	        }
	      ]
	    },
	    "NatGatewayAvailable": {
	      "operation": "DescribeNatGateways",
	      "delay": 15,
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "NatGateways[].State",
	          "expected": "available"
	        },
	        {
	          "state": "failure",
	          "matcher": "pathAny",
	          "argument": "NatGateways[].State",
	          "expected": "failed"
	        },
	        {
	          "state": "failure",
	          "matcher": "pathAny",
	          "argument": "NatGateways[].State",
	          "expected": "deleting"
	        },
	        {
	          "state": "failure",
	          "matcher": "pathAny",
	          "argument": "NatGateways[].State",
	          "expected": "deleted"
	        },
	        {
	          "state": "retry",
	          "matcher": "error",
	          "expected": "NatGatewayNotFound"
	        }
	      ]
	    },
	    "NatGatewayDeleted": {
	      "operation": "DescribeNatGateways",
	      "delay": 15,
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "NatGateways[].State",
	          "expected": "deleted"
	        },
	        {
	          "state": "success",
	          "matcher": "error",
	          "expected": "NatGatewayNotFound"
	        }
	      ]
	    },
	    "NetworkInterfaceAvailable": {
	      "operation": "DescribeNetworkInterfaces",
	      "delay": 20,
	      "maxAttempts": 10,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "NetworkInterfaces[].Status"
	        },
	        {
	          "expected": "InvalidNetworkInterfaceID.NotFound",
	          "matcher": "error",
	          "state": "failure"
	        }
	      ]
	    },
	    "PasswordDataAvailable": {
	      "operation": "GetPasswordData",
	      "maxAttempts": 40,
	      "delay": 15,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "path",
	          "argument": "length(PasswordData) > `0`",
	          "expected": true
	        }
	      ]
	    },
	    "SnapshotCompleted": {
	      "delay": 15,
	      "operation": "DescribeSnapshots",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "completed",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Snapshots[].State"
	        },
	        {
	          "expected": "error",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Snapshots[].State"
	        }
	      ]
	    },
	    "SecurityGroupExists": {
	      "operation": "DescribeSecurityGroups",
	      "delay": 5,
	      "maxAttempts": 6,
	      "acceptors": [
	        {
	          "expected": true,
	          "matcher": "path",
	          "state": "success",
	          "argument": "length(SecurityGroups[].GroupId) > `0`"
	        },
	        {
	          "expected": "InvalidGroup.NotFound",
	          "matcher": "error",
	          "state": "retry"
	        }
	      ]
	    },
	    "SpotInstanceRequestFulfilled": {
	      "operation": "DescribeSpotInstanceRequests",
	      "maxAttempts": 40,
	      "delay": 15,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "SpotInstanceRequests[].Status.Code",
	          "expected": "fulfilled"
	        },
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "SpotInstanceRequests[].Status.Code",
	          "expected": "request-canceled-and-instance-running"
	        },
	        {
	          "state": "failure",
	          "matcher": "pathAny",
	          "argument": "SpotInstanceRequests[].Status.Code",
	          "expected": "schedule-expired"
	        },
	        {
	          "state": "failure",
	          "matcher": "pathAny",
	          "argument": "SpotInstanceRequests[].Status.Code",
	          "expected": "canceled-before-fulfillment"
	        },
	        {
	          "state": "failure",
	          "matcher": "pathAny",
	          "argument": "SpotInstanceRequests[].Status.Code",
	          "expected": "bad-parameters"
	        },
	        {
	          "state": "failure",
	          "matcher": "pathAny",
	          "argument": "SpotInstanceRequests[].Status.Code",
	          "expected": "system-error"
	        },
	        {
	          "state": "retry",
	          "matcher": "error",
	          "expected": "InvalidSpotInstanceRequestID.NotFound"
	        }
	      ]
	    },
	    "SubnetAvailable": {
	      "delay": 15,
	      "operation": "DescribeSubnets",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Subnets[].State"
	        }
	      ]
	    },
	    "SystemStatusOk": {
	      "operation": "DescribeInstanceStatus",
	      "maxAttempts": 40,
	      "delay": 15,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "InstanceStatuses[].SystemStatus.Status",
	          "expected": "ok"
	        }
	      ]
	    },
	    "VolumeAvailable": {
	      "delay": 15,
	      "operation": "DescribeVolumes",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Volumes[].State"
	        },
	        {
	          "expected": "deleted",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Volumes[].State"
	        }
	      ]
	    },
	    "VolumeDeleted": {
	      "delay": 15,
	      "operation": "DescribeVolumes",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "deleted",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Volumes[].State"
	        },
	        {
	          "matcher": "error",
	          "expected": "InvalidVolume.NotFound",
	          "state": "success"
	        }
	      ]
	    },
	    "VolumeInUse": {
	      "delay": 15,
	      "operation": "DescribeVolumes",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "in-use",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Volumes[].State"
	        },
	        {
	          "expected": "deleted",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Volumes[].State"
	        }
	      ]
	    },
	    "VpcAvailable": {
	      "delay": 15,
	      "operation": "DescribeVpcs",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Vpcs[].State"
	        }
	      ]
	    },
	    "VpcExists": {
	      "operation": "DescribeVpcs",
	      "delay": 1,
	      "maxAttempts": 5,
	      "acceptors": [
	        {
	          "matcher": "status",
	          "expected": 200,
	          "state": "success"
	        },
	        {
	          "matcher": "error",
	          "expected": "InvalidVpcID.NotFound",
	          "state": "retry"
	        }
	      ]
	    },
	    "VpnConnectionAvailable": {
	      "delay": 15,
	      "operation": "DescribeVpnConnections",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "VpnConnections[].State"
	        },
	        {
	          "expected": "deleting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "VpnConnections[].State"
	        },
	        {
	          "expected": "deleted",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "VpnConnections[].State"
	        }
	      ]
	    },
	    "VpnConnectionDeleted": {
	      "delay": 15,
	      "operation": "DescribeVpnConnections",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "deleted",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "VpnConnections[].State"
	        },
	        {
	          "expected": "pending",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "VpnConnections[].State"
	        }
	      ]
	    },
	    "VpcPeeringConnectionExists": {
	      "delay": 15,
	      "operation": "DescribeVpcPeeringConnections",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "matcher": "status",
	          "expected": 200,
	          "state": "success"
	        },
	        {
	          "matcher": "error",
	          "expected": "InvalidVpcPeeringConnectionID.NotFound",
	          "state": "retry"
	        }
	      ]
	    },
	    "VpcPeeringConnectionDeleted": {
	      "delay": 15,
	      "operation": "DescribeVpcPeeringConnections",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "deleted",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "VpcPeeringConnections[].Status.Code"
	        },
	        {
	          "matcher": "error",
	          "expected": "InvalidVpcPeeringConnectionID.NotFound",
	          "state": "success"
	        }
	      ]
	    }
	  }
	}
	
	},{}],82:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-09-21",
	    "endpointPrefix": "api.ecr",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "Amazon ECR",
	    "serviceFullName": "Amazon EC2 Container Registry",
	    "serviceId": "ECR",
	    "signatureVersion": "v4",
	    "signingName": "ecr",
	    "targetPrefix": "AmazonEC2ContainerRegistry_V20150921",
	    "uid": "ecr-2015-09-21"
	  },
	  "operations": {
	    "BatchCheckLayerAvailability": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "layerDigests"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "layerDigests": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "layers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "layerDigest": {},
	                "layerAvailability": {},
	                "layerSize": {
	                  "type": "long"
	                },
	                "mediaType": {}
	              }
	            }
	          },
	          "failures": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "layerDigest": {},
	                "failureCode": {},
	                "failureReason": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "BatchDeleteImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "imageIds"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageIds": {
	            "shape": "Si"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "imageIds": {
	            "shape": "Si"
	          },
	          "failures": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "BatchGetImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "imageIds"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageIds": {
	            "shape": "Si"
	          },
	          "acceptedMediaTypes": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "images": {
	            "type": "list",
	            "member": {
	              "shape": "Sv"
	            }
	          },
	          "failures": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "BatchGetRepositoryScanningConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryNames"
	        ],
	        "members": {
	          "repositoryNames": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "scanningConfigurations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "repositoryArn": {},
	                "repositoryName": {},
	                "scanOnPush": {
	                  "type": "boolean"
	                },
	                "scanFrequency": {},
	                "appliedScanFilters": {
	                  "shape": "S15"
	                }
	              }
	            }
	          },
	          "failures": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "repositoryName": {},
	                "failureCode": {},
	                "failureReason": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "CompleteLayerUpload": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "uploadId",
	          "layerDigests"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "uploadId": {},
	          "layerDigests": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "uploadId": {},
	          "layerDigest": {}
	        }
	      }
	    },
	    "CreatePullThroughCacheRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ecrRepositoryPrefix",
	          "upstreamRegistryUrl"
	        ],
	        "members": {
	          "ecrRepositoryPrefix": {},
	          "upstreamRegistryUrl": {},
	          "registryId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ecrRepositoryPrefix": {},
	          "upstreamRegistryUrl": {},
	          "createdAt": {
	            "type": "timestamp"
	          },
	          "registryId": {}
	        }
	      }
	    },
	    "CreateRepository": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "tags": {
	            "shape": "S1n"
	          },
	          "imageTagMutability": {},
	          "imageScanningConfiguration": {
	            "shape": "S1s"
	          },
	          "encryptionConfiguration": {
	            "shape": "S1t"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repository": {
	            "shape": "S1x"
	          }
	        }
	      }
	    },
	    "DeleteLifecyclePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "lifecyclePolicyText": {},
	          "lastEvaluatedAt": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DeletePullThroughCacheRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ecrRepositoryPrefix"
	        ],
	        "members": {
	          "ecrRepositoryPrefix": {},
	          "registryId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ecrRepositoryPrefix": {},
	          "upstreamRegistryUrl": {},
	          "createdAt": {
	            "type": "timestamp"
	          },
	          "registryId": {}
	        }
	      }
	    },
	    "DeleteRegistryPolicy": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "policyText": {}
	        }
	      }
	    },
	    "DeleteRepository": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "force": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repository": {
	            "shape": "S1x"
	          }
	        }
	      }
	    },
	    "DeleteRepositoryPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "policyText": {}
	        }
	      }
	    },
	    "DescribeImageReplicationStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "imageId"
	        ],
	        "members": {
	          "repositoryName": {},
	          "imageId": {
	            "shape": "Sj"
	          },
	          "registryId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repositoryName": {},
	          "imageId": {
	            "shape": "Sj"
	          },
	          "replicationStatuses": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "region": {},
	                "registryId": {},
	                "status": {},
	                "failureCode": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeImageScanFindings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "imageId"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageId": {
	            "shape": "Sj"
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageId": {
	            "shape": "Sj"
	          },
	          "imageScanStatus": {
	            "shape": "S2o"
	          },
	          "imageScanFindings": {
	            "type": "structure",
	            "members": {
	              "imageScanCompletedAt": {
	                "type": "timestamp"
	              },
	              "vulnerabilitySourceUpdatedAt": {
	                "type": "timestamp"
	              },
	              "findingSeverityCounts": {
	                "shape": "S2u"
	              },
	              "findings": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "name": {},
	                    "description": {},
	                    "uri": {},
	                    "severity": {},
	                    "attributes": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "required": [
	                          "key"
	                        ],
	                        "members": {
	                          "key": {},
	                          "value": {}
	                        }
	                      }
	                    }
	                  }
	                }
	              },
	              "enhancedFindings": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "awsAccountId": {},
	                    "description": {},
	                    "findingArn": {},
	                    "firstObservedAt": {
	                      "type": "timestamp"
	                    },
	                    "lastObservedAt": {
	                      "type": "timestamp"
	                    },
	                    "packageVulnerabilityDetails": {
	                      "type": "structure",
	                      "members": {
	                        "cvss": {
	                          "type": "list",
	                          "member": {
	                            "type": "structure",
	                            "members": {
	                              "baseScore": {
	                                "type": "double"
	                              },
	                              "scoringVector": {},
	                              "source": {},
	                              "version": {}
	                            }
	                          }
	                        },
	                        "referenceUrls": {
	                          "type": "list",
	                          "member": {}
	                        },
	                        "relatedVulnerabilities": {
	                          "type": "list",
	                          "member": {}
	                        },
	                        "source": {},
	                        "sourceUrl": {},
	                        "vendorCreatedAt": {
	                          "type": "timestamp"
	                        },
	                        "vendorSeverity": {},
	                        "vendorUpdatedAt": {
	                          "type": "timestamp"
	                        },
	                        "vulnerabilityId": {},
	                        "vulnerablePackages": {
	                          "type": "list",
	                          "member": {
	                            "type": "structure",
	                            "members": {
	                              "arch": {},
	                              "epoch": {
	                                "type": "integer"
	                              },
	                              "filePath": {},
	                              "name": {},
	                              "packageManager": {},
	                              "release": {},
	                              "sourceLayerHash": {},
	                              "version": {}
	                            }
	                          }
	                        }
	                      }
	                    },
	                    "remediation": {
	                      "type": "structure",
	                      "members": {
	                        "recommendation": {
	                          "type": "structure",
	                          "members": {
	                            "url": {},
	                            "text": {}
	                          }
	                        }
	                      }
	                    },
	                    "resources": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "members": {
	                          "details": {
	                            "type": "structure",
	                            "members": {
	                              "awsEcrContainerImage": {
	                                "type": "structure",
	                                "members": {
	                                  "architecture": {},
	                                  "author": {},
	                                  "imageHash": {},
	                                  "imageTags": {
	                                    "type": "list",
	                                    "member": {}
	                                  },
	                                  "platform": {},
	                                  "pushedAt": {
	                                    "type": "timestamp"
	                                  },
	                                  "registry": {},
	                                  "repositoryName": {}
	                                }
	                              }
	                            }
	                          },
	                          "id": {},
	                          "tags": {
	                            "type": "map",
	                            "key": {},
	                            "value": {}
	                          },
	                          "type": {}
	                        }
	                      }
	                    },
	                    "score": {
	                      "type": "double"
	                    },
	                    "scoreDetails": {
	                      "type": "structure",
	                      "members": {
	                        "cvss": {
	                          "type": "structure",
	                          "members": {
	                            "adjustments": {
	                              "type": "list",
	                              "member": {
	                                "type": "structure",
	                                "members": {
	                                  "metric": {},
	                                  "reason": {}
	                                }
	                              }
	                            },
	                            "score": {
	                              "type": "double"
	                            },
	                            "scoreSource": {},
	                            "scoringVector": {},
	                            "version": {}
	                          }
	                        }
	                      }
	                    },
	                    "severity": {},
	                    "status": {},
	                    "title": {},
	                    "type": {},
	                    "updatedAt": {
	                      "type": "timestamp"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeImages": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageIds": {
	            "shape": "Si"
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "filter": {
	            "type": "structure",
	            "members": {
	              "tagStatus": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "imageDetails": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "registryId": {},
	                "repositoryName": {},
	                "imageDigest": {},
	                "imageTags": {
	                  "shape": "S4m"
	                },
	                "imageSizeInBytes": {
	                  "type": "long"
	                },
	                "imagePushedAt": {
	                  "type": "timestamp"
	                },
	                "imageScanStatus": {
	                  "shape": "S2o"
	                },
	                "imageScanFindingsSummary": {
	                  "type": "structure",
	                  "members": {
	                    "imageScanCompletedAt": {
	                      "type": "timestamp"
	                    },
	                    "vulnerabilitySourceUpdatedAt": {
	                      "type": "timestamp"
	                    },
	                    "findingSeverityCounts": {
	                      "shape": "S2u"
	                    }
	                  }
	                },
	                "imageManifestMediaType": {},
	                "artifactMediaType": {},
	                "lastRecordedPullTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribePullThroughCacheRules": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "ecrRepositoryPrefixes": {
	            "type": "list",
	            "member": {}
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pullThroughCacheRules": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ecrRepositoryPrefix": {},
	                "upstreamRegistryUrl": {},
	                "createdAt": {
	                  "type": "timestamp"
	                },
	                "registryId": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeRegistry": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "replicationConfiguration": {
	            "shape": "S4y"
	          }
	        }
	      }
	    },
	    "DescribeRepositories": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryNames": {
	            "type": "list",
	            "member": {}
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "repositories": {
	            "type": "list",
	            "member": {
	              "shape": "S1x"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetAuthorizationToken": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "registryIds": {
	            "deprecated": true,
	            "deprecatedMessage": "This field is deprecated. The returned authorization token can be used to access any Amazon ECR registry that the IAM principal has access to, specifying a registry ID doesn't change the permissions scope of the authorization token.",
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "authorizationData": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "authorizationToken": {},
	                "expiresAt": {
	                  "type": "timestamp"
	                },
	                "proxyEndpoint": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetDownloadUrlForLayer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "layerDigest"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "layerDigest": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "downloadUrl": {},
	          "layerDigest": {}
	        }
	      }
	    },
	    "GetLifecyclePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "lifecyclePolicyText": {},
	          "lastEvaluatedAt": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetLifecyclePolicyPreview": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageIds": {
	            "shape": "Si"
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "filter": {
	            "type": "structure",
	            "members": {
	              "tagStatus": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "lifecyclePolicyText": {},
	          "status": {},
	          "nextToken": {},
	          "previewResults": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "imageTags": {
	                  "shape": "S4m"
	                },
	                "imageDigest": {},
	                "imagePushedAt": {
	                  "type": "timestamp"
	                },
	                "action": {
	                  "type": "structure",
	                  "members": {
	                    "type": {}
	                  }
	                },
	                "appliedRulePriority": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "summary": {
	            "type": "structure",
	            "members": {
	              "expiringImageTotalCount": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetRegistryPolicy": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "policyText": {}
	        }
	      }
	    },
	    "GetRegistryScanningConfiguration": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "scanningConfiguration": {
	            "shape": "S63"
	          }
	        }
	      }
	    },
	    "GetRepositoryPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "policyText": {}
	        }
	      }
	    },
	    "InitiateLayerUpload": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "uploadId": {},
	          "partSize": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "ListImages": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "filter": {
	            "type": "structure",
	            "members": {
	              "tagStatus": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "imageIds": {
	            "shape": "Si"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tags": {
	            "shape": "S1n"
	          }
	        }
	      }
	    },
	    "PutImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "imageManifest"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageManifest": {},
	          "imageManifestMediaType": {},
	          "imageTag": {},
	          "imageDigest": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "image": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "PutImageScanningConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "imageScanningConfiguration"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageScanningConfiguration": {
	            "shape": "S1s"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageScanningConfiguration": {
	            "shape": "S1s"
	          }
	        }
	      }
	    },
	    "PutImageTagMutability": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "imageTagMutability"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageTagMutability": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageTagMutability": {}
	        }
	      }
	    },
	    "PutLifecyclePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "lifecyclePolicyText"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "lifecyclePolicyText": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "lifecyclePolicyText": {}
	        }
	      }
	    },
	    "PutRegistryPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyText"
	        ],
	        "members": {
	          "policyText": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "policyText": {}
	        }
	      }
	    },
	    "PutRegistryScanningConfiguration": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "scanType": {},
	          "rules": {
	            "shape": "S65"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryScanningConfiguration": {
	            "shape": "S63"
	          }
	        }
	      }
	    },
	    "PutReplicationConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "replicationConfiguration"
	        ],
	        "members": {
	          "replicationConfiguration": {
	            "shape": "S4y"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "replicationConfiguration": {
	            "shape": "S4y"
	          }
	        }
	      }
	    },
	    "SetRepositoryPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "policyText"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "policyText": {},
	          "force": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "policyText": {}
	        }
	      }
	    },
	    "StartImageScan": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "imageId"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageId": {
	            "shape": "Sj"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "imageId": {
	            "shape": "Sj"
	          },
	          "imageScanStatus": {
	            "shape": "S2o"
	          }
	        }
	      }
	    },
	    "StartLifecyclePolicyPreview": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "lifecyclePolicyText": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "lifecyclePolicyText": {},
	          "status": {}
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tags"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tags": {
	            "shape": "S1n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tagKeys"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UploadLayerPart": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "repositoryName",
	          "uploadId",
	          "partFirstByte",
	          "partLastByte",
	          "layerPartBlob"
	        ],
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "uploadId": {},
	          "partFirstByte": {
	            "type": "long"
	          },
	          "partLastByte": {
	            "type": "long"
	          },
	          "layerPartBlob": {
	            "type": "blob"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registryId": {},
	          "repositoryName": {},
	          "uploadId": {},
	          "lastByteReceived": {
	            "type": "long"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Si": {
	      "type": "list",
	      "member": {
	        "shape": "Sj"
	      }
	    },
	    "Sj": {
	      "type": "structure",
	      "members": {
	        "imageDigest": {},
	        "imageTag": {}
	      }
	    },
	    "Sn": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "imageId": {
	            "shape": "Sj"
	          },
	          "failureCode": {},
	          "failureReason": {}
	        }
	      }
	    },
	    "Sv": {
	      "type": "structure",
	      "members": {
	        "registryId": {},
	        "repositoryName": {},
	        "imageId": {
	          "shape": "Sj"
	        },
	        "imageManifest": {},
	        "imageManifestMediaType": {}
	      }
	    },
	    "S15": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "filter",
	          "filterType"
	        ],
	        "members": {
	          "filter": {},
	          "filterType": {}
	        }
	      }
	    },
	    "S1n": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S1s": {
	      "type": "structure",
	      "members": {
	        "scanOnPush": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1t": {
	      "type": "structure",
	      "required": [
	        "encryptionType"
	      ],
	      "members": {
	        "encryptionType": {},
	        "kmsKey": {}
	      }
	    },
	    "S1x": {
	      "type": "structure",
	      "members": {
	        "repositoryArn": {},
	        "registryId": {},
	        "repositoryName": {},
	        "repositoryUri": {},
	        "createdAt": {
	          "type": "timestamp"
	        },
	        "imageTagMutability": {},
	        "imageScanningConfiguration": {
	          "shape": "S1s"
	        },
	        "encryptionConfiguration": {
	          "shape": "S1t"
	        }
	      }
	    },
	    "S2o": {
	      "type": "structure",
	      "members": {
	        "status": {},
	        "description": {}
	      }
	    },
	    "S2u": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "integer"
	      }
	    },
	    "S4m": {
	      "type": "list",
	      "member": {}
	    },
	    "S4y": {
	      "type": "structure",
	      "required": [
	        "rules"
	      ],
	      "members": {
	        "rules": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "destinations"
	            ],
	            "members": {
	              "destinations": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "region",
	                    "registryId"
	                  ],
	                  "members": {
	                    "region": {},
	                    "registryId": {}
	                  }
	                }
	              },
	              "repositoryFilters": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "filter",
	                    "filterType"
	                  ],
	                  "members": {
	                    "filter": {},
	                    "filterType": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S63": {
	      "type": "structure",
	      "members": {
	        "scanType": {},
	        "rules": {
	          "shape": "S65"
	        }
	      }
	    },
	    "S65": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "scanFrequency",
	          "repositoryFilters"
	        ],
	        "members": {
	          "scanFrequency": {},
	          "repositoryFilters": {
	            "shape": "S15"
	          }
	        }
	      }
	    }
	  }
	}
	},{}],83:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeImageScanFindings": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "non_aggregate_keys": [
	        "registryId",
	        "repositoryName",
	        "imageId",
	        "imageScanStatus",
	        "imageScanFindings"
	      ],
	      "output_token": "nextToken",
	      "result_key": [
	        "imageScanFindings.findings",
	        "imageScanFindings.enhancedFindings"
	      ]
	    },
	    "DescribeImages": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "imageDetails"
	    },
	    "DescribePullThroughCacheRules": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "pullThroughCacheRules"
	    },
	    "DescribeRepositories": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "repositories"
	    },
	    "GetLifecyclePolicyPreview": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "non_aggregate_keys": [
	        "registryId",
	        "repositoryName",
	        "lifecyclePolicyText",
	        "status",
	        "summary"
	      ],
	      "output_token": "nextToken",
	      "result_key": "previewResults"
	    },
	    "ListImages": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "imageIds"
	    }
	  }
	}
	},{}],84:[function(require,module,exports){
	module.exports={
	    "version": 2,
	    "waiters": {
	        "ImageScanComplete": {
	            "description": "Wait until an image scan is complete and findings can be accessed",
	            "operation": "DescribeImageScanFindings",
	            "delay": 5,
	            "maxAttempts": 60,
	            "acceptors": [
	                {
	                    "state": "success",
	                    "matcher": "path",
	                    "argument": "imageScanStatus.status",
	                    "expected": "COMPLETE"
	                },
	                {
	                    "state": "failure",
	                    "matcher": "path",
	                    "argument": "imageScanStatus.status",
	                    "expected": "FAILED"
	                }
	            ]
	        },
	        "LifecyclePolicyPreviewComplete": {
	            "description": "Wait until a lifecycle policy preview request is complete and results can be accessed",
	            "operation": "GetLifecyclePolicyPreview",
	            "delay": 5,
	            "maxAttempts": 20,
	            "acceptors": [
	                {
	                    "state": "success",
	                    "matcher": "path",
	                    "argument": "status",
	                    "expected": "COMPLETE"
	                },
	                {
	                    "state": "failure",
	                    "matcher": "path",
	                    "argument": "status",
	                    "expected": "FAILED"
	                }
	            ]
	        }
	    }
	}
	},{}],85:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-11-13",
	    "endpointPrefix": "ecs",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "Amazon ECS",
	    "serviceFullName": "Amazon EC2 Container Service",
	    "serviceId": "ECS",
	    "signatureVersion": "v4",
	    "targetPrefix": "AmazonEC2ContainerServiceV20141113",
	    "uid": "ecs-2014-11-13"
	  },
	  "operations": {
	    "CreateCapacityProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "autoScalingGroupProvider"
	        ],
	        "members": {
	          "name": {},
	          "autoScalingGroupProvider": {
	            "shape": "S3"
	          },
	          "tags": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "capacityProvider": {
	            "shape": "Sf"
	          }
	        }
	      }
	    },
	    "CreateCluster": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "clusterName": {},
	          "tags": {
	            "shape": "Sa"
	          },
	          "settings": {
	            "shape": "Sj"
	          },
	          "configuration": {
	            "shape": "Sm"
	          },
	          "capacityProviders": {
	            "shape": "Sr"
	          },
	          "defaultCapacityProviderStrategy": {
	            "shape": "Ss"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "cluster": {
	            "shape": "Sx"
	          }
	        }
	      }
	    },
	    "CreateService": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "serviceName"
	        ],
	        "members": {
	          "cluster": {},
	          "serviceName": {},
	          "taskDefinition": {},
	          "loadBalancers": {
	            "shape": "S15"
	          },
	          "serviceRegistries": {
	            "shape": "S18"
	          },
	          "desiredCount": {
	            "type": "integer"
	          },
	          "clientToken": {},
	          "launchType": {},
	          "capacityProviderStrategy": {
	            "shape": "Ss"
	          },
	          "platformVersion": {},
	          "role": {},
	          "deploymentConfiguration": {
	            "shape": "S1b"
	          },
	          "placementConstraints": {
	            "shape": "S1d"
	          },
	          "placementStrategy": {
	            "shape": "S1g"
	          },
	          "networkConfiguration": {
	            "shape": "S1j"
	          },
	          "healthCheckGracePeriodSeconds": {
	            "type": "integer"
	          },
	          "schedulingStrategy": {},
	          "deploymentController": {
	            "shape": "S1n"
	          },
	          "tags": {
	            "shape": "Sa"
	          },
	          "enableECSManagedTags": {
	            "type": "boolean"
	          },
	          "propagateTags": {},
	          "enableExecuteCommand": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "service": {
	            "shape": "S1r"
	          }
	        }
	      }
	    },
	    "CreateTaskSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "service",
	          "cluster",
	          "taskDefinition"
	        ],
	        "members": {
	          "service": {},
	          "cluster": {},
	          "externalId": {},
	          "taskDefinition": {},
	          "networkConfiguration": {
	            "shape": "S1j"
	          },
	          "loadBalancers": {
	            "shape": "S15"
	          },
	          "serviceRegistries": {
	            "shape": "S18"
	          },
	          "launchType": {},
	          "capacityProviderStrategy": {
	            "shape": "Ss"
	          },
	          "platformVersion": {},
	          "scale": {
	            "shape": "S1v"
	          },
	          "clientToken": {},
	          "tags": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskSet": {
	            "shape": "S1t"
	          }
	        }
	      }
	    },
	    "DeleteAccountSetting": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {},
	          "principalArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "setting": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "DeleteAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "attributes"
	        ],
	        "members": {
	          "cluster": {},
	          "attributes": {
	            "shape": "S2b"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "attributes": {
	            "shape": "S2b"
	          }
	        }
	      }
	    },
	    "DeleteCapacityProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "capacityProvider"
	        ],
	        "members": {
	          "capacityProvider": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "capacityProvider": {
	            "shape": "Sf"
	          }
	        }
	      }
	    },
	    "DeleteCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "cluster"
	        ],
	        "members": {
	          "cluster": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "cluster": {
	            "shape": "Sx"
	          }
	        }
	      }
	    },
	    "DeleteService": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "service"
	        ],
	        "members": {
	          "cluster": {},
	          "service": {},
	          "force": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "service": {
	            "shape": "S1r"
	          }
	        }
	      }
	    },
	    "DeleteTaskSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "cluster",
	          "service",
	          "taskSet"
	        ],
	        "members": {
	          "cluster": {},
	          "service": {},
	          "taskSet": {},
	          "force": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskSet": {
	            "shape": "S1t"
	          }
	        }
	      }
	    },
	    "DeregisterContainerInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "containerInstance"
	        ],
	        "members": {
	          "cluster": {},
	          "containerInstance": {},
	          "force": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "containerInstance": {
	            "shape": "S2q"
	          }
	        }
	      }
	    },
	    "DeregisterTaskDefinition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskDefinition"
	        ],
	        "members": {
	          "taskDefinition": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskDefinition": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "DescribeCapacityProviders": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "capacityProviders": {
	            "shape": "Sr"
	          },
	          "include": {
	            "type": "list",
	            "member": {}
	          },
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "capacityProviders": {
	            "type": "list",
	            "member": {
	              "shape": "Sf"
	            }
	          },
	          "failures": {
	            "shape": "S5d"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeClusters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "clusters": {
	            "shape": "Sr"
	          },
	          "include": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "clusters": {
	            "type": "list",
	            "member": {
	              "shape": "Sx"
	            }
	          },
	          "failures": {
	            "shape": "S5d"
	          }
	        }
	      }
	    },
	    "DescribeContainerInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "containerInstances"
	        ],
	        "members": {
	          "cluster": {},
	          "containerInstances": {
	            "shape": "Sr"
	          },
	          "include": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "containerInstances": {
	            "shape": "S5o"
	          },
	          "failures": {
	            "shape": "S5d"
	          }
	        }
	      }
	    },
	    "DescribeServices": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "services"
	        ],
	        "members": {
	          "cluster": {},
	          "services": {
	            "shape": "Sr"
	          },
	          "include": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "services": {
	            "type": "list",
	            "member": {
	              "shape": "S1r"
	            }
	          },
	          "failures": {
	            "shape": "S5d"
	          }
	        }
	      }
	    },
	    "DescribeTaskDefinition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskDefinition"
	        ],
	        "members": {
	          "taskDefinition": {},
	          "include": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskDefinition": {
	            "shape": "S33"
	          },
	          "tags": {
	            "shape": "Sa"
	          }
	        }
	      }
	    },
	    "DescribeTaskSets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "cluster",
	          "service"
	        ],
	        "members": {
	          "cluster": {},
	          "service": {},
	          "taskSets": {
	            "shape": "Sr"
	          },
	          "include": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskSets": {
	            "shape": "S1s"
	          },
	          "failures": {
	            "shape": "S5d"
	          }
	        }
	      }
	    },
	    "DescribeTasks": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "tasks"
	        ],
	        "members": {
	          "cluster": {},
	          "tasks": {
	            "shape": "Sr"
	          },
	          "include": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tasks": {
	            "shape": "S66"
	          },
	          "failures": {
	            "shape": "S5d"
	          }
	        }
	      }
	    },
	    "DiscoverPollEndpoint": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "containerInstance": {},
	          "cluster": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "endpoint": {},
	          "telemetryEndpoint": {}
	        }
	      }
	    },
	    "ExecuteCommand": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "command",
	          "interactive",
	          "task"
	        ],
	        "members": {
	          "cluster": {},
	          "container": {},
	          "command": {},
	          "interactive": {
	            "type": "boolean"
	          },
	          "task": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "clusterArn": {},
	          "containerArn": {},
	          "containerName": {},
	          "interactive": {
	            "type": "boolean"
	          },
	          "session": {
	            "type": "structure",
	            "members": {
	              "sessionId": {},
	              "streamUrl": {},
	              "tokenValue": {
	                "type": "string",
	                "sensitive": true
	              }
	            }
	          },
	          "taskArn": {}
	        }
	      }
	    },
	    "ListAccountSettings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "value": {},
	          "principalArn": {},
	          "effectiveSettings": {
	            "type": "boolean"
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "settings": {
	            "type": "list",
	            "member": {
	              "shape": "S29"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "targetType"
	        ],
	        "members": {
	          "cluster": {},
	          "targetType": {},
	          "attributeName": {},
	          "attributeValue": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "attributes": {
	            "shape": "S2b"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListClusters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "clusterArns": {
	            "shape": "Sr"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListContainerInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "cluster": {},
	          "filter": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "status": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "containerInstanceArns": {
	            "shape": "Sr"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListServices": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "cluster": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "launchType": {},
	          "schedulingStrategy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "serviceArns": {
	            "shape": "Sr"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tags": {
	            "shape": "Sa"
	          }
	        }
	      }
	    },
	    "ListTaskDefinitionFamilies": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "familyPrefix": {},
	          "status": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "families": {
	            "shape": "Sr"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTaskDefinitions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "familyPrefix": {},
	          "status": {},
	          "sort": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskDefinitionArns": {
	            "shape": "Sr"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTasks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "cluster": {},
	          "containerInstance": {},
	          "family": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "startedBy": {},
	          "serviceName": {},
	          "desiredStatus": {},
	          "launchType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskArns": {
	            "shape": "Sr"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "PutAccountSetting": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "value"
	        ],
	        "members": {
	          "name": {},
	          "value": {},
	          "principalArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "setting": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "PutAccountSettingDefault": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "value"
	        ],
	        "members": {
	          "name": {},
	          "value": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "setting": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "PutAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "attributes"
	        ],
	        "members": {
	          "cluster": {},
	          "attributes": {
	            "shape": "S2b"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "attributes": {
	            "shape": "S2b"
	          }
	        }
	      }
	    },
	    "PutClusterCapacityProviders": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "cluster",
	          "capacityProviders",
	          "defaultCapacityProviderStrategy"
	        ],
	        "members": {
	          "cluster": {},
	          "capacityProviders": {
	            "shape": "Sr"
	          },
	          "defaultCapacityProviderStrategy": {
	            "shape": "Ss"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "cluster": {
	            "shape": "Sx"
	          }
	        }
	      }
	    },
	    "RegisterContainerInstance": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "cluster": {},
	          "instanceIdentityDocument": {},
	          "instanceIdentityDocumentSignature": {},
	          "totalResources": {
	            "shape": "S2t"
	          },
	          "versionInfo": {
	            "shape": "S2s"
	          },
	          "containerInstanceArn": {},
	          "attributes": {
	            "shape": "S2b"
	          },
	          "platformDevices": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "id",
	                "type"
	              ],
	              "members": {
	                "id": {},
	                "type": {}
	              }
	            }
	          },
	          "tags": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "containerInstance": {
	            "shape": "S2q"
	          }
	        }
	      }
	    },
	    "RegisterTaskDefinition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "family",
	          "containerDefinitions"
	        ],
	        "members": {
	          "family": {},
	          "taskRoleArn": {},
	          "executionRoleArn": {},
	          "networkMode": {},
	          "containerDefinitions": {
	            "shape": "S34"
	          },
	          "volumes": {
	            "shape": "S4e"
	          },
	          "placementConstraints": {
	            "shape": "S4s"
	          },
	          "requiresCompatibilities": {
	            "shape": "S4v"
	          },
	          "cpu": {},
	          "memory": {},
	          "tags": {
	            "shape": "Sa"
	          },
	          "pidMode": {},
	          "ipcMode": {},
	          "proxyConfiguration": {
	            "shape": "S54"
	          },
	          "inferenceAccelerators": {
	            "shape": "S50"
	          },
	          "ephemeralStorage": {
	            "shape": "S57"
	          },
	          "runtimePlatform": {
	            "shape": "S4x"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskDefinition": {
	            "shape": "S33"
	          },
	          "tags": {
	            "shape": "Sa"
	          }
	        }
	      }
	    },
	    "RunTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskDefinition"
	        ],
	        "members": {
	          "capacityProviderStrategy": {
	            "shape": "Ss"
	          },
	          "cluster": {},
	          "count": {
	            "type": "integer"
	          },
	          "enableECSManagedTags": {
	            "type": "boolean"
	          },
	          "enableExecuteCommand": {
	            "type": "boolean"
	          },
	          "group": {},
	          "launchType": {},
	          "networkConfiguration": {
	            "shape": "S1j"
	          },
	          "overrides": {
	            "shape": "S6k"
	          },
	          "placementConstraints": {
	            "shape": "S1d"
	          },
	          "placementStrategy": {
	            "shape": "S1g"
	          },
	          "platformVersion": {},
	          "propagateTags": {},
	          "referenceId": {},
	          "startedBy": {},
	          "tags": {
	            "shape": "Sa"
	          },
	          "taskDefinition": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tasks": {
	            "shape": "S66"
	          },
	          "failures": {
	            "shape": "S5d"
	          }
	        }
	      }
	    },
	    "StartTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "containerInstances",
	          "taskDefinition"
	        ],
	        "members": {
	          "cluster": {},
	          "containerInstances": {
	            "shape": "Sr"
	          },
	          "enableECSManagedTags": {
	            "type": "boolean"
	          },
	          "enableExecuteCommand": {
	            "type": "boolean"
	          },
	          "group": {},
	          "networkConfiguration": {
	            "shape": "S1j"
	          },
	          "overrides": {
	            "shape": "S6k"
	          },
	          "propagateTags": {},
	          "referenceId": {},
	          "startedBy": {},
	          "tags": {
	            "shape": "Sa"
	          },
	          "taskDefinition": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tasks": {
	            "shape": "S66"
	          },
	          "failures": {
	            "shape": "S5d"
	          }
	        }
	      }
	    },
	    "StopTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "task"
	        ],
	        "members": {
	          "cluster": {},
	          "task": {},
	          "reason": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "task": {
	            "shape": "S67"
	          }
	        }
	      }
	    },
	    "SubmitAttachmentStateChanges": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "attachments"
	        ],
	        "members": {
	          "cluster": {},
	          "attachments": {
	            "shape": "S85"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "acknowledgment": {}
	        }
	      }
	    },
	    "SubmitContainerStateChange": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "cluster": {},
	          "task": {},
	          "containerName": {},
	          "runtimeId": {},
	          "status": {},
	          "exitCode": {
	            "type": "integer"
	          },
	          "reason": {},
	          "networkBindings": {
	            "shape": "S6b"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "acknowledgment": {}
	        }
	      }
	    },
	    "SubmitTaskStateChange": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "cluster": {},
	          "task": {},
	          "status": {},
	          "reason": {},
	          "containers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "containerName": {},
	                "imageDigest": {},
	                "runtimeId": {},
	                "exitCode": {
	                  "type": "integer"
	                },
	                "networkBindings": {
	                  "shape": "S6b"
	                },
	                "reason": {},
	                "status": {}
	              }
	            }
	          },
	          "attachments": {
	            "shape": "S85"
	          },
	          "managedAgents": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "containerName",
	                "managedAgentName",
	                "status"
	              ],
	              "members": {
	                "containerName": {},
	                "managedAgentName": {},
	                "status": {},
	                "reason": {}
	              }
	            }
	          },
	          "pullStartedAt": {
	            "type": "timestamp"
	          },
	          "pullStoppedAt": {
	            "type": "timestamp"
	          },
	          "executionStoppedAt": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "acknowledgment": {}
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tags"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tags": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tagKeys"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateCapacityProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "autoScalingGroupProvider"
	        ],
	        "members": {
	          "name": {},
	          "autoScalingGroupProvider": {
	            "type": "structure",
	            "members": {
	              "managedScaling": {
	                "shape": "S4"
	              },
	              "managedTerminationProtection": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "capacityProvider": {
	            "shape": "Sf"
	          }
	        }
	      }
	    },
	    "UpdateCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "cluster"
	        ],
	        "members": {
	          "cluster": {},
	          "settings": {
	            "shape": "Sj"
	          },
	          "configuration": {
	            "shape": "Sm"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "cluster": {
	            "shape": "Sx"
	          }
	        }
	      }
	    },
	    "UpdateClusterSettings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "cluster",
	          "settings"
	        ],
	        "members": {
	          "cluster": {},
	          "settings": {
	            "shape": "Sj"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "cluster": {
	            "shape": "Sx"
	          }
	        }
	      }
	    },
	    "UpdateContainerAgent": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "containerInstance"
	        ],
	        "members": {
	          "cluster": {},
	          "containerInstance": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "containerInstance": {
	            "shape": "S2q"
	          }
	        }
	      }
	    },
	    "UpdateContainerInstancesState": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "containerInstances",
	          "status"
	        ],
	        "members": {
	          "cluster": {},
	          "containerInstances": {
	            "shape": "Sr"
	          },
	          "status": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "containerInstances": {
	            "shape": "S5o"
	          },
	          "failures": {
	            "shape": "S5d"
	          }
	        }
	      }
	    },
	    "UpdateService": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "service"
	        ],
	        "members": {
	          "cluster": {},
	          "service": {},
	          "desiredCount": {
	            "type": "integer"
	          },
	          "taskDefinition": {},
	          "capacityProviderStrategy": {
	            "shape": "Ss"
	          },
	          "deploymentConfiguration": {
	            "shape": "S1b"
	          },
	          "networkConfiguration": {
	            "shape": "S1j"
	          },
	          "placementConstraints": {
	            "shape": "S1d"
	          },
	          "placementStrategy": {
	            "shape": "S1g"
	          },
	          "platformVersion": {},
	          "forceNewDeployment": {
	            "type": "boolean"
	          },
	          "healthCheckGracePeriodSeconds": {
	            "type": "integer"
	          },
	          "enableExecuteCommand": {
	            "type": "boolean"
	          },
	          "enableECSManagedTags": {
	            "type": "boolean"
	          },
	          "loadBalancers": {
	            "shape": "S15"
	          },
	          "propagateTags": {},
	          "serviceRegistries": {
	            "shape": "S18"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "service": {
	            "shape": "S1r"
	          }
	        }
	      }
	    },
	    "UpdateServicePrimaryTaskSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "cluster",
	          "service",
	          "primaryTaskSet"
	        ],
	        "members": {
	          "cluster": {},
	          "service": {},
	          "primaryTaskSet": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskSet": {
	            "shape": "S1t"
	          }
	        }
	      }
	    },
	    "UpdateTaskSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "cluster",
	          "service",
	          "taskSet",
	          "scale"
	        ],
	        "members": {
	          "cluster": {},
	          "service": {},
	          "taskSet": {},
	          "scale": {
	            "shape": "S1v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskSet": {
	            "shape": "S1t"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S3": {
	      "type": "structure",
	      "required": [
	        "autoScalingGroupArn"
	      ],
	      "members": {
	        "autoScalingGroupArn": {},
	        "managedScaling": {
	          "shape": "S4"
	        },
	        "managedTerminationProtection": {}
	      }
	    },
	    "S4": {
	      "type": "structure",
	      "members": {
	        "status": {},
	        "targetCapacity": {
	          "type": "integer"
	        },
	        "minimumScalingStepSize": {
	          "type": "integer"
	        },
	        "maximumScalingStepSize": {
	          "type": "integer"
	        },
	        "instanceWarmupPeriod": {
	          "type": "integer"
	        }
	      }
	    },
	    "Sa": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "key": {},
	          "value": {}
	        }
	      }
	    },
	    "Sf": {
	      "type": "structure",
	      "members": {
	        "capacityProviderArn": {},
	        "name": {},
	        "status": {},
	        "autoScalingGroupProvider": {
	          "shape": "S3"
	        },
	        "updateStatus": {},
	        "updateStatusReason": {},
	        "tags": {
	          "shape": "Sa"
	        }
	      }
	    },
	    "Sj": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "value": {}
	        }
	      }
	    },
	    "Sm": {
	      "type": "structure",
	      "members": {
	        "executeCommandConfiguration": {
	          "type": "structure",
	          "members": {
	            "kmsKeyId": {},
	            "logging": {},
	            "logConfiguration": {
	              "type": "structure",
	              "members": {
	                "cloudWatchLogGroupName": {},
	                "cloudWatchEncryptionEnabled": {
	                  "type": "boolean"
	                },
	                "s3BucketName": {},
	                "s3EncryptionEnabled": {
	                  "type": "boolean"
	                },
	                "s3KeyPrefix": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sr": {
	      "type": "list",
	      "member": {}
	    },
	    "Ss": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "capacityProvider"
	        ],
	        "members": {
	          "capacityProvider": {},
	          "weight": {
	            "type": "integer"
	          },
	          "base": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "Sx": {
	      "type": "structure",
	      "members": {
	        "clusterArn": {},
	        "clusterName": {},
	        "configuration": {
	          "shape": "Sm"
	        },
	        "status": {},
	        "registeredContainerInstancesCount": {
	          "type": "integer"
	        },
	        "runningTasksCount": {
	          "type": "integer"
	        },
	        "pendingTasksCount": {
	          "type": "integer"
	        },
	        "activeServicesCount": {
	          "type": "integer"
	        },
	        "statistics": {
	          "type": "list",
	          "member": {
	            "shape": "S10"
	          }
	        },
	        "tags": {
	          "shape": "Sa"
	        },
	        "settings": {
	          "shape": "Sj"
	        },
	        "capacityProviders": {
	          "shape": "Sr"
	        },
	        "defaultCapacityProviderStrategy": {
	          "shape": "Ss"
	        },
	        "attachments": {
	          "shape": "S11"
	        },
	        "attachmentsStatus": {}
	      }
	    },
	    "S10": {
	      "type": "structure",
	      "members": {
	        "name": {},
	        "value": {}
	      }
	    },
	    "S11": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "id": {},
	          "type": {},
	          "status": {},
	          "details": {
	            "type": "list",
	            "member": {
	              "shape": "S10"
	            }
	          }
	        }
	      }
	    },
	    "S15": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "targetGroupArn": {},
	          "loadBalancerName": {},
	          "containerName": {},
	          "containerPort": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S18": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "registryArn": {},
	          "port": {
	            "type": "integer"
	          },
	          "containerName": {},
	          "containerPort": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S1b": {
	      "type": "structure",
	      "members": {
	        "deploymentCircuitBreaker": {
	          "type": "structure",
	          "required": [
	            "enable",
	            "rollback"
	          ],
	          "members": {
	            "enable": {
	              "type": "boolean"
	            },
	            "rollback": {
	              "type": "boolean"
	            }
	          }
	        },
	        "maximumPercent": {
	          "type": "integer"
	        },
	        "minimumHealthyPercent": {
	          "type": "integer"
	        }
	      }
	    },
	    "S1d": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "type": {},
	          "expression": {}
	        }
	      }
	    },
	    "S1g": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "type": {},
	          "field": {}
	        }
	      }
	    },
	    "S1j": {
	      "type": "structure",
	      "members": {
	        "awsvpcConfiguration": {
	          "type": "structure",
	          "required": [
	            "subnets"
	          ],
	          "members": {
	            "subnets": {
	              "shape": "Sr"
	            },
	            "securityGroups": {
	              "shape": "Sr"
	            },
	            "assignPublicIp": {}
	          }
	        }
	      }
	    },
	    "S1n": {
	      "type": "structure",
	      "required": [
	        "type"
	      ],
	      "members": {
	        "type": {}
	      }
	    },
	    "S1r": {
	      "type": "structure",
	      "members": {
	        "serviceArn": {},
	        "serviceName": {},
	        "clusterArn": {},
	        "loadBalancers": {
	          "shape": "S15"
	        },
	        "serviceRegistries": {
	          "shape": "S18"
	        },
	        "status": {},
	        "desiredCount": {
	          "type": "integer"
	        },
	        "runningCount": {
	          "type": "integer"
	        },
	        "pendingCount": {
	          "type": "integer"
	        },
	        "launchType": {},
	        "capacityProviderStrategy": {
	          "shape": "Ss"
	        },
	        "platformVersion": {},
	        "platformFamily": {},
	        "taskDefinition": {},
	        "deploymentConfiguration": {
	          "shape": "S1b"
	        },
	        "taskSets": {
	          "shape": "S1s"
	        },
	        "deployments": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "id": {},
	              "status": {},
	              "taskDefinition": {},
	              "desiredCount": {
	                "type": "integer"
	              },
	              "pendingCount": {
	                "type": "integer"
	              },
	              "runningCount": {
	                "type": "integer"
	              },
	              "failedTasks": {
	                "type": "integer"
	              },
	              "createdAt": {
	                "type": "timestamp"
	              },
	              "updatedAt": {
	                "type": "timestamp"
	              },
	              "capacityProviderStrategy": {
	                "shape": "Ss"
	              },
	              "launchType": {},
	              "platformVersion": {},
	              "platformFamily": {},
	              "networkConfiguration": {
	                "shape": "S1j"
	              },
	              "rolloutState": {},
	              "rolloutStateReason": {}
	            }
	          }
	        },
	        "roleArn": {},
	        "events": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "id": {},
	              "createdAt": {
	                "type": "timestamp"
	              },
	              "message": {}
	            }
	          }
	        },
	        "createdAt": {
	          "type": "timestamp"
	        },
	        "placementConstraints": {
	          "shape": "S1d"
	        },
	        "placementStrategy": {
	          "shape": "S1g"
	        },
	        "networkConfiguration": {
	          "shape": "S1j"
	        },
	        "healthCheckGracePeriodSeconds": {
	          "type": "integer"
	        },
	        "schedulingStrategy": {},
	        "deploymentController": {
	          "shape": "S1n"
	        },
	        "tags": {
	          "shape": "Sa"
	        },
	        "createdBy": {},
	        "enableECSManagedTags": {
	          "type": "boolean"
	        },
	        "propagateTags": {},
	        "enableExecuteCommand": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1s": {
	      "type": "list",
	      "member": {
	        "shape": "S1t"
	      }
	    },
	    "S1t": {
	      "type": "structure",
	      "members": {
	        "id": {},
	        "taskSetArn": {},
	        "serviceArn": {},
	        "clusterArn": {},
	        "startedBy": {},
	        "externalId": {},
	        "status": {},
	        "taskDefinition": {},
	        "computedDesiredCount": {
	          "type": "integer"
	        },
	        "pendingCount": {
	          "type": "integer"
	        },
	        "runningCount": {
	          "type": "integer"
	        },
	        "createdAt": {
	          "type": "timestamp"
	        },
	        "updatedAt": {
	          "type": "timestamp"
	        },
	        "launchType": {},
	        "capacityProviderStrategy": {
	          "shape": "Ss"
	        },
	        "platformVersion": {},
	        "platformFamily": {},
	        "networkConfiguration": {
	          "shape": "S1j"
	        },
	        "loadBalancers": {
	          "shape": "S15"
	        },
	        "serviceRegistries": {
	          "shape": "S18"
	        },
	        "scale": {
	          "shape": "S1v"
	        },
	        "stabilityStatus": {},
	        "stabilityStatusAt": {
	          "type": "timestamp"
	        },
	        "tags": {
	          "shape": "Sa"
	        }
	      }
	    },
	    "S1v": {
	      "type": "structure",
	      "members": {
	        "value": {
	          "type": "double"
	        },
	        "unit": {}
	      }
	    },
	    "S29": {
	      "type": "structure",
	      "members": {
	        "name": {},
	        "value": {},
	        "principalArn": {}
	      }
	    },
	    "S2b": {
	      "type": "list",
	      "member": {
	        "shape": "S2c"
	      }
	    },
	    "S2c": {
	      "type": "structure",
	      "required": [
	        "name"
	      ],
	      "members": {
	        "name": {},
	        "value": {},
	        "targetType": {},
	        "targetId": {}
	      }
	    },
	    "S2q": {
	      "type": "structure",
	      "members": {
	        "containerInstanceArn": {},
	        "ec2InstanceId": {},
	        "capacityProviderName": {},
	        "version": {
	          "type": "long"
	        },
	        "versionInfo": {
	          "shape": "S2s"
	        },
	        "remainingResources": {
	          "shape": "S2t"
	        },
	        "registeredResources": {
	          "shape": "S2t"
	        },
	        "status": {},
	        "statusReason": {},
	        "agentConnected": {
	          "type": "boolean"
	        },
	        "runningTasksCount": {
	          "type": "integer"
	        },
	        "pendingTasksCount": {
	          "type": "integer"
	        },
	        "agentUpdateStatus": {},
	        "attributes": {
	          "shape": "S2b"
	        },
	        "registeredAt": {
	          "type": "timestamp"
	        },
	        "attachments": {
	          "shape": "S11"
	        },
	        "tags": {
	          "shape": "Sa"
	        },
	        "healthStatus": {
	          "type": "structure",
	          "members": {
	            "overallStatus": {},
	            "details": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "type": {},
	                  "status": {},
	                  "lastUpdated": {
	                    "type": "timestamp"
	                  },
	                  "lastStatusChange": {
	                    "type": "timestamp"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2s": {
	      "type": "structure",
	      "members": {
	        "agentVersion": {},
	        "agentHash": {},
	        "dockerVersion": {}
	      }
	    },
	    "S2t": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "type": {},
	          "doubleValue": {
	            "type": "double"
	          },
	          "longValue": {
	            "type": "long"
	          },
	          "integerValue": {
	            "type": "integer"
	          },
	          "stringSetValue": {
	            "shape": "Sr"
	          }
	        }
	      }
	    },
	    "S33": {
	      "type": "structure",
	      "members": {
	        "taskDefinitionArn": {},
	        "containerDefinitions": {
	          "shape": "S34"
	        },
	        "family": {},
	        "taskRoleArn": {},
	        "executionRoleArn": {},
	        "networkMode": {},
	        "revision": {
	          "type": "integer"
	        },
	        "volumes": {
	          "shape": "S4e"
	        },
	        "status": {},
	        "requiresAttributes": {
	          "type": "list",
	          "member": {
	            "shape": "S2c"
	          }
	        },
	        "placementConstraints": {
	          "shape": "S4s"
	        },
	        "compatibilities": {
	          "shape": "S4v"
	        },
	        "runtimePlatform": {
	          "shape": "S4x"
	        },
	        "requiresCompatibilities": {
	          "shape": "S4v"
	        },
	        "cpu": {},
	        "memory": {},
	        "inferenceAccelerators": {
	          "shape": "S50"
	        },
	        "pidMode": {},
	        "ipcMode": {},
	        "proxyConfiguration": {
	          "shape": "S54"
	        },
	        "registeredAt": {
	          "type": "timestamp"
	        },
	        "deregisteredAt": {
	          "type": "timestamp"
	        },
	        "registeredBy": {},
	        "ephemeralStorage": {
	          "shape": "S57"
	        }
	      }
	    },
	    "S34": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "image": {},
	          "repositoryCredentials": {
	            "type": "structure",
	            "required": [
	              "credentialsParameter"
	            ],
	            "members": {
	              "credentialsParameter": {}
	            }
	          },
	          "cpu": {
	            "type": "integer"
	          },
	          "memory": {
	            "type": "integer"
	          },
	          "memoryReservation": {
	            "type": "integer"
	          },
	          "links": {
	            "shape": "Sr"
	          },
	          "portMappings": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "containerPort": {
	                  "type": "integer"
	                },
	                "hostPort": {
	                  "type": "integer"
	                },
	                "protocol": {}
	              }
	            }
	          },
	          "essential": {
	            "type": "boolean"
	          },
	          "entryPoint": {
	            "shape": "Sr"
	          },
	          "command": {
	            "shape": "Sr"
	          },
	          "environment": {
	            "shape": "S3a"
	          },
	          "environmentFiles": {
	            "shape": "S3b"
	          },
	          "mountPoints": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "sourceVolume": {},
	                "containerPath": {},
	                "readOnly": {
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "volumesFrom": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "sourceContainer": {},
	                "readOnly": {
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "linuxParameters": {
	            "type": "structure",
	            "members": {
	              "capabilities": {
	                "type": "structure",
	                "members": {
	                  "add": {
	                    "shape": "Sr"
	                  },
	                  "drop": {
	                    "shape": "Sr"
	                  }
	                }
	              },
	              "devices": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "hostPath"
	                  ],
	                  "members": {
	                    "hostPath": {},
	                    "containerPath": {},
	                    "permissions": {
	                      "type": "list",
	                      "member": {}
	                    }
	                  }
	                }
	              },
	              "initProcessEnabled": {
	                "type": "boolean"
	              },
	              "sharedMemorySize": {
	                "type": "integer"
	              },
	              "tmpfs": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "containerPath",
	                    "size"
	                  ],
	                  "members": {
	                    "containerPath": {},
	                    "size": {
	                      "type": "integer"
	                    },
	                    "mountOptions": {
	                      "shape": "Sr"
	                    }
	                  }
	                }
	              },
	              "maxSwap": {
	                "type": "integer"
	              },
	              "swappiness": {
	                "type": "integer"
	              }
	            }
	          },
	          "secrets": {
	            "shape": "S3q"
	          },
	          "dependsOn": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "containerName",
	                "condition"
	              ],
	              "members": {
	                "containerName": {},
	                "condition": {}
	              }
	            }
	          },
	          "startTimeout": {
	            "type": "integer"
	          },
	          "stopTimeout": {
	            "type": "integer"
	          },
	          "hostname": {},
	          "user": {},
	          "workingDirectory": {},
	          "disableNetworking": {
	            "type": "boolean"
	          },
	          "privileged": {
	            "type": "boolean"
	          },
	          "readonlyRootFilesystem": {
	            "type": "boolean"
	          },
	          "dnsServers": {
	            "shape": "Sr"
	          },
	          "dnsSearchDomains": {
	            "shape": "Sr"
	          },
	          "extraHosts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "hostname",
	                "ipAddress"
	              ],
	              "members": {
	                "hostname": {},
	                "ipAddress": {}
	              }
	            }
	          },
	          "dockerSecurityOptions": {
	            "shape": "Sr"
	          },
	          "interactive": {
	            "type": "boolean"
	          },
	          "pseudoTerminal": {
	            "type": "boolean"
	          },
	          "dockerLabels": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          },
	          "ulimits": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "name",
	                "softLimit",
	                "hardLimit"
	              ],
	              "members": {
	                "name": {},
	                "softLimit": {
	                  "type": "integer"
	                },
	                "hardLimit": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "logConfiguration": {
	            "type": "structure",
	            "required": [
	              "logDriver"
	            ],
	            "members": {
	              "logDriver": {},
	              "options": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              },
	              "secretOptions": {
	                "shape": "S3q"
	              }
	            }
	          },
	          "healthCheck": {
	            "type": "structure",
	            "required": [
	              "command"
	            ],
	            "members": {
	              "command": {
	                "shape": "Sr"
	              },
	              "interval": {
	                "type": "integer"
	              },
	              "timeout": {
	                "type": "integer"
	              },
	              "retries": {
	                "type": "integer"
	              },
	              "startPeriod": {
	                "type": "integer"
	              }
	            }
	          },
	          "systemControls": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "namespace": {},
	                "value": {}
	              }
	            }
	          },
	          "resourceRequirements": {
	            "shape": "S47"
	          },
	          "firelensConfiguration": {
	            "type": "structure",
	            "required": [
	              "type"
	            ],
	            "members": {
	              "type": {},
	              "options": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "S3a": {
	      "type": "list",
	      "member": {
	        "shape": "S10"
	      }
	    },
	    "S3b": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "value",
	          "type"
	        ],
	        "members": {
	          "value": {},
	          "type": {}
	        }
	      }
	    },
	    "S3q": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "name",
	          "valueFrom"
	        ],
	        "members": {
	          "name": {},
	          "valueFrom": {}
	        }
	      }
	    },
	    "S47": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "value",
	          "type"
	        ],
	        "members": {
	          "value": {},
	          "type": {}
	        }
	      }
	    },
	    "S4e": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "host": {
	            "type": "structure",
	            "members": {
	              "sourcePath": {}
	            }
	          },
	          "dockerVolumeConfiguration": {
	            "type": "structure",
	            "members": {
	              "scope": {},
	              "autoprovision": {
	                "type": "boolean"
	              },
	              "driver": {},
	              "driverOpts": {
	                "shape": "S4j"
	              },
	              "labels": {
	                "shape": "S4j"
	              }
	            }
	          },
	          "efsVolumeConfiguration": {
	            "type": "structure",
	            "required": [
	              "fileSystemId"
	            ],
	            "members": {
	              "fileSystemId": {},
	              "rootDirectory": {},
	              "transitEncryption": {},
	              "transitEncryptionPort": {
	                "type": "integer"
	              },
	              "authorizationConfig": {
	                "type": "structure",
	                "members": {
	                  "accessPointId": {},
	                  "iam": {}
	                }
	              }
	            }
	          },
	          "fsxWindowsFileServerVolumeConfiguration": {
	            "type": "structure",
	            "required": [
	              "fileSystemId",
	              "rootDirectory",
	              "authorizationConfig"
	            ],
	            "members": {
	              "fileSystemId": {},
	              "rootDirectory": {},
	              "authorizationConfig": {
	                "type": "structure",
	                "required": [
	                  "credentialsParameter",
	                  "domain"
	                ],
	                "members": {
	                  "credentialsParameter": {},
	                  "domain": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S4j": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S4s": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "type": {},
	          "expression": {}
	        }
	      }
	    },
	    "S4v": {
	      "type": "list",
	      "member": {}
	    },
	    "S4x": {
	      "type": "structure",
	      "members": {
	        "cpuArchitecture": {},
	        "operatingSystemFamily": {}
	      }
	    },
	    "S50": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "deviceName",
	          "deviceType"
	        ],
	        "members": {
	          "deviceName": {},
	          "deviceType": {}
	        }
	      }
	    },
	    "S54": {
	      "type": "structure",
	      "required": [
	        "containerName"
	      ],
	      "members": {
	        "type": {},
	        "containerName": {},
	        "properties": {
	          "type": "list",
	          "member": {
	            "shape": "S10"
	          }
	        }
	      }
	    },
	    "S57": {
	      "type": "structure",
	      "required": [
	        "sizeInGiB"
	      ],
	      "members": {
	        "sizeInGiB": {
	          "type": "integer"
	        }
	      }
	    },
	    "S5d": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "arn": {},
	          "reason": {},
	          "detail": {}
	        }
	      }
	    },
	    "S5o": {
	      "type": "list",
	      "member": {
	        "shape": "S2q"
	      }
	    },
	    "S66": {
	      "type": "list",
	      "member": {
	        "shape": "S67"
	      }
	    },
	    "S67": {
	      "type": "structure",
	      "members": {
	        "attachments": {
	          "shape": "S11"
	        },
	        "attributes": {
	          "shape": "S2b"
	        },
	        "availabilityZone": {},
	        "capacityProviderName": {},
	        "clusterArn": {},
	        "connectivity": {},
	        "connectivityAt": {
	          "type": "timestamp"
	        },
	        "containerInstanceArn": {},
	        "containers": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "containerArn": {},
	              "taskArn": {},
	              "name": {},
	              "image": {},
	              "imageDigest": {},
	              "runtimeId": {},
	              "lastStatus": {},
	              "exitCode": {
	                "type": "integer"
	              },
	              "reason": {},
	              "networkBindings": {
	                "shape": "S6b"
	              },
	              "networkInterfaces": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "attachmentId": {},
	                    "privateIpv4Address": {},
	                    "ipv6Address": {}
	                  }
	                }
	              },
	              "healthStatus": {},
	              "managedAgents": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "lastStartedAt": {
	                      "type": "timestamp"
	                    },
	                    "name": {},
	                    "reason": {},
	                    "lastStatus": {}
	                  }
	                }
	              },
	              "cpu": {},
	              "memory": {},
	              "memoryReservation": {},
	              "gpuIds": {
	                "type": "list",
	                "member": {}
	              }
	            }
	          }
	        },
	        "cpu": {},
	        "createdAt": {
	          "type": "timestamp"
	        },
	        "desiredStatus": {},
	        "enableExecuteCommand": {
	          "type": "boolean"
	        },
	        "executionStoppedAt": {
	          "type": "timestamp"
	        },
	        "group": {},
	        "healthStatus": {},
	        "inferenceAccelerators": {
	          "shape": "S50"
	        },
	        "lastStatus": {},
	        "launchType": {},
	        "memory": {},
	        "overrides": {
	          "shape": "S6k"
	        },
	        "platformVersion": {},
	        "platformFamily": {},
	        "pullStartedAt": {
	          "type": "timestamp"
	        },
	        "pullStoppedAt": {
	          "type": "timestamp"
	        },
	        "startedAt": {
	          "type": "timestamp"
	        },
	        "startedBy": {},
	        "stopCode": {},
	        "stoppedAt": {
	          "type": "timestamp"
	        },
	        "stoppedReason": {},
	        "stoppingAt": {
	          "type": "timestamp"
	        },
	        "tags": {
	          "shape": "Sa"
	        },
	        "taskArn": {},
	        "taskDefinitionArn": {},
	        "version": {
	          "type": "long"
	        },
	        "ephemeralStorage": {
	          "shape": "S57"
	        }
	      }
	    },
	    "S6b": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "bindIP": {},
	          "containerPort": {
	            "type": "integer"
	          },
	          "hostPort": {
	            "type": "integer"
	          },
	          "protocol": {}
	        }
	      }
	    },
	    "S6k": {
	      "type": "structure",
	      "members": {
	        "containerOverrides": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "command": {
	                "shape": "Sr"
	              },
	              "environment": {
	                "shape": "S3a"
	              },
	              "environmentFiles": {
	                "shape": "S3b"
	              },
	              "cpu": {
	                "type": "integer"
	              },
	              "memory": {
	                "type": "integer"
	              },
	              "memoryReservation": {
	                "type": "integer"
	              },
	              "resourceRequirements": {
	                "shape": "S47"
	              }
	            }
	          }
	        },
	        "cpu": {},
	        "inferenceAcceleratorOverrides": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "deviceName": {},
	              "deviceType": {}
	            }
	          }
	        },
	        "executionRoleArn": {},
	        "memory": {},
	        "taskRoleArn": {},
	        "ephemeralStorage": {
	          "shape": "S57"
	        }
	      }
	    },
	    "S85": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "attachmentArn",
	          "status"
	        ],
	        "members": {
	          "attachmentArn": {},
	          "status": {}
	        }
	      }
	    }
	  }
	}
	},{}],86:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListAccountSettings": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "settings"
	    },
	    "ListAttributes": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "attributes"
	    },
	    "ListClusters": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "clusterArns"
	    },
	    "ListContainerInstances": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "containerInstanceArns"
	    },
	    "ListServices": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "serviceArns"
	    },
	    "ListTaskDefinitionFamilies": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "families"
	    },
	    "ListTaskDefinitions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "taskDefinitionArns"
	    },
	    "ListTasks": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "taskArns"
	    }
	  }
	}
	},{}],87:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "TasksRunning": {
	      "delay": 6,
	      "operation": "DescribeTasks",
	      "maxAttempts": 100,
	      "acceptors": [
	        {
	          "expected": "STOPPED",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "tasks[].lastStatus"
	        },
	        {
	          "expected": "MISSING",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "failures[].reason"
	        },
	        {
	          "expected": "RUNNING",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "tasks[].lastStatus"
	        }
	      ]
	    },
	    "TasksStopped": {
	      "delay": 6,
	      "operation": "DescribeTasks",
	      "maxAttempts": 100,
	      "acceptors": [
	        {
	          "expected": "STOPPED",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "tasks[].lastStatus"
	        }
	      ]
	    },
	    "ServicesStable": {
	      "delay": 15,
	      "operation": "DescribeServices",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "MISSING",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "failures[].reason"
	        },
	        {
	          "expected": "DRAINING",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "services[].status"
	        },
	        {
	          "expected": "INACTIVE",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "services[].status"
	        },
	        {
	          "expected": true,
	          "matcher": "path",
	          "state": "success",
	          "argument": "length(services[?!(length(deployments) == `1` && runningCount == desiredCount)]) == `0`"
	        }
	      ]
	    },
	    "ServicesInactive": {
	      "delay": 15,
	      "operation": "DescribeServices",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": "MISSING",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "failures[].reason"
	        },
	        {
	          "expected": "INACTIVE",
	          "matcher": "pathAny",
	          "state": "success",
	          "argument": "services[].status"
	        }
	      ]
	    }
	  }
	}
	
	},{}],88:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-02-02",
	    "endpointPrefix": "elasticache",
	    "protocol": "query",
	    "serviceFullName": "Amazon ElastiCache",
	    "serviceId": "ElastiCache",
	    "signatureVersion": "v4",
	    "uid": "elasticache-2015-02-02",
	    "xmlNamespace": "http://elasticache.amazonaws.com/doc/2015-02-02/"
	  },
	  "operations": {
	    "AddTagsToResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "Tags"
	        ],
	        "members": {
	          "ResourceName": {},
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "shape": "S5",
	        "resultWrapper": "AddTagsToResourceResult"
	      }
	    },
	    "AuthorizeCacheSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheSecurityGroupName",
	          "EC2SecurityGroupName",
	          "EC2SecurityGroupOwnerId"
	        ],
	        "members": {
	          "CacheSecurityGroupName": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AuthorizeCacheSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "CacheSecurityGroup": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "BatchApplyUpdateAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceUpdateName"
	        ],
	        "members": {
	          "ReplicationGroupIds": {
	            "shape": "Sc"
	          },
	          "CacheClusterIds": {
	            "shape": "Sd"
	          },
	          "ServiceUpdateName": {}
	        }
	      },
	      "output": {
	        "shape": "Se",
	        "resultWrapper": "BatchApplyUpdateActionResult"
	      }
	    },
	    "BatchStopUpdateAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceUpdateName"
	        ],
	        "members": {
	          "ReplicationGroupIds": {
	            "shape": "Sc"
	          },
	          "CacheClusterIds": {
	            "shape": "Sd"
	          },
	          "ServiceUpdateName": {}
	        }
	      },
	      "output": {
	        "shape": "Se",
	        "resultWrapper": "BatchStopUpdateActionResult"
	      }
	    },
	    "CompleteMigration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplicationGroupId"
	        ],
	        "members": {
	          "ReplicationGroupId": {},
	          "Force": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CompleteMigrationResult",
	        "type": "structure",
	        "members": {
	          "ReplicationGroup": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "CopySnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceSnapshotName",
	          "TargetSnapshotName"
	        ],
	        "members": {
	          "SourceSnapshotName": {},
	          "TargetSnapshotName": {},
	          "TargetBucket": {},
	          "KmsKeyId": {},
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CopySnapshotResult",
	        "type": "structure",
	        "members": {
	          "Snapshot": {
	            "shape": "S1q"
	          }
	        }
	      }
	    },
	    "CreateCacheCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheClusterId"
	        ],
	        "members": {
	          "CacheClusterId": {},
	          "ReplicationGroupId": {},
	          "AZMode": {},
	          "PreferredAvailabilityZone": {},
	          "PreferredAvailabilityZones": {
	            "shape": "S1z"
	          },
	          "NumCacheNodes": {
	            "type": "integer"
	          },
	          "CacheNodeType": {},
	          "Engine": {},
	          "EngineVersion": {},
	          "CacheParameterGroupName": {},
	          "CacheSubnetGroupName": {},
	          "CacheSecurityGroupNames": {
	            "shape": "S20"
	          },
	          "SecurityGroupIds": {
	            "shape": "S21"
	          },
	          "Tags": {
	            "shape": "S3"
	          },
	          "SnapshotArns": {
	            "shape": "S22"
	          },
	          "SnapshotName": {},
	          "PreferredMaintenanceWindow": {},
	          "Port": {
	            "type": "integer"
	          },
	          "NotificationTopicArn": {},
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "SnapshotRetentionLimit": {
	            "type": "integer"
	          },
	          "SnapshotWindow": {},
	          "AuthToken": {},
	          "OutpostMode": {},
	          "PreferredOutpostArn": {},
	          "PreferredOutpostArns": {
	            "shape": "S24"
	          },
	          "LogDeliveryConfigurations": {
	            "shape": "S25"
	          },
	          "TransitEncryptionEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateCacheClusterResult",
	        "type": "structure",
	        "members": {
	          "CacheCluster": {
	            "shape": "S28"
	          }
	        }
	      }
	    },
	    "CreateCacheParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheParameterGroupName",
	          "CacheParameterGroupFamily",
	          "Description"
	        ],
	        "members": {
	          "CacheParameterGroupName": {},
	          "CacheParameterGroupFamily": {},
	          "Description": {},
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateCacheParameterGroupResult",
	        "type": "structure",
	        "members": {
	          "CacheParameterGroup": {
	            "shape": "S2l"
	          }
	        }
	      }
	    },
	    "CreateCacheSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheSecurityGroupName",
	          "Description"
	        ],
	        "members": {
	          "CacheSecurityGroupName": {},
	          "Description": {},
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateCacheSecurityGroupResult",
	        "type": "structure",
	        "members": {
	          "CacheSecurityGroup": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "CreateCacheSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheSubnetGroupName",
	          "CacheSubnetGroupDescription",
	          "SubnetIds"
	        ],
	        "members": {
	          "CacheSubnetGroupName": {},
	          "CacheSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S2p"
	          },
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateCacheSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "CacheSubnetGroup": {
	            "shape": "S2r"
	          }
	        }
	      }
	    },
	    "CreateGlobalReplicationGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalReplicationGroupIdSuffix",
	          "PrimaryReplicationGroupId"
	        ],
	        "members": {
	          "GlobalReplicationGroupIdSuffix": {},
	          "GlobalReplicationGroupDescription": {},
	          "PrimaryReplicationGroupId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateGlobalReplicationGroupResult",
	        "type": "structure",
	        "members": {
	          "GlobalReplicationGroup": {
	            "shape": "S2y"
	          }
	        }
	      }
	    },
	    "CreateReplicationGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplicationGroupId",
	          "ReplicationGroupDescription"
	        ],
	        "members": {
	          "ReplicationGroupId": {},
	          "ReplicationGroupDescription": {},
	          "GlobalReplicationGroupId": {},
	          "PrimaryClusterId": {},
	          "AutomaticFailoverEnabled": {
	            "type": "boolean"
	          },
	          "MultiAZEnabled": {
	            "type": "boolean"
	          },
	          "NumCacheClusters": {
	            "type": "integer"
	          },
	          "PreferredCacheClusterAZs": {
	            "shape": "S1v"
	          },
	          "NumNodeGroups": {
	            "type": "integer"
	          },
	          "ReplicasPerNodeGroup": {
	            "type": "integer"
	          },
	          "NodeGroupConfiguration": {
	            "type": "list",
	            "member": {
	              "shape": "S1t",
	              "locationName": "NodeGroupConfiguration"
	            }
	          },
	          "CacheNodeType": {},
	          "Engine": {},
	          "EngineVersion": {},
	          "CacheParameterGroupName": {},
	          "CacheSubnetGroupName": {},
	          "CacheSecurityGroupNames": {
	            "shape": "S20"
	          },
	          "SecurityGroupIds": {
	            "shape": "S21"
	          },
	          "Tags": {
	            "shape": "S3"
	          },
	          "SnapshotArns": {
	            "shape": "S22"
	          },
	          "SnapshotName": {},
	          "PreferredMaintenanceWindow": {},
	          "Port": {
	            "type": "integer"
	          },
	          "NotificationTopicArn": {},
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "SnapshotRetentionLimit": {
	            "type": "integer"
	          },
	          "SnapshotWindow": {},
	          "AuthToken": {},
	          "TransitEncryptionEnabled": {
	            "type": "boolean"
	          },
	          "AtRestEncryptionEnabled": {
	            "type": "boolean"
	          },
	          "KmsKeyId": {},
	          "UserGroupIds": {
	            "type": "list",
	            "member": {}
	          },
	          "LogDeliveryConfigurations": {
	            "shape": "S25"
	          },
	          "DataTieringEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateReplicationGroupResult",
	        "type": "structure",
	        "members": {
	          "ReplicationGroup": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "CreateSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotName"
	        ],
	        "members": {
	          "ReplicationGroupId": {},
	          "CacheClusterId": {},
	          "SnapshotName": {},
	          "KmsKeyId": {},
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateSnapshotResult",
	        "type": "structure",
	        "members": {
	          "Snapshot": {
	            "shape": "S1q"
	          }
	        }
	      }
	    },
	    "CreateUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserId",
	          "UserName",
	          "Engine",
	          "AccessString"
	        ],
	        "members": {
	          "UserId": {},
	          "UserName": {},
	          "Engine": {},
	          "Passwords": {
	            "shape": "S3d"
	          },
	          "AccessString": {},
	          "NoPasswordRequired": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3f",
	        "resultWrapper": "CreateUserResult"
	      }
	    },
	    "CreateUserGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserGroupId",
	          "Engine"
	        ],
	        "members": {
	          "UserGroupId": {},
	          "Engine": {},
	          "UserIds": {
	            "shape": "S3j"
	          },
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3k",
	        "resultWrapper": "CreateUserGroupResult"
	      }
	    },
	    "DecreaseNodeGroupsInGlobalReplicationGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalReplicationGroupId",
	          "NodeGroupCount",
	          "ApplyImmediately"
	        ],
	        "members": {
	          "GlobalReplicationGroupId": {},
	          "NodeGroupCount": {
	            "type": "integer"
	          },
	          "GlobalNodeGroupsToRemove": {
	            "shape": "S3p"
	          },
	          "GlobalNodeGroupsToRetain": {
	            "shape": "S3p"
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DecreaseNodeGroupsInGlobalReplicationGroupResult",
	        "type": "structure",
	        "members": {
	          "GlobalReplicationGroup": {
	            "shape": "S2y"
	          }
	        }
	      }
	    },
	    "DecreaseReplicaCount": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplicationGroupId",
	          "ApplyImmediately"
	        ],
	        "members": {
	          "ReplicationGroupId": {},
	          "NewReplicaCount": {
	            "type": "integer"
	          },
	          "ReplicaConfiguration": {
	            "shape": "S3s"
	          },
	          "ReplicasToRemove": {
	            "type": "list",
	            "member": {}
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DecreaseReplicaCountResult",
	        "type": "structure",
	        "members": {
	          "ReplicationGroup": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "DeleteCacheCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheClusterId"
	        ],
	        "members": {
	          "CacheClusterId": {},
	          "FinalSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteCacheClusterResult",
	        "type": "structure",
	        "members": {
	          "CacheCluster": {
	            "shape": "S28"
	          }
	        }
	      }
	    },
	    "DeleteCacheParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheParameterGroupName"
	        ],
	        "members": {
	          "CacheParameterGroupName": {}
	        }
	      }
	    },
	    "DeleteCacheSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheSecurityGroupName"
	        ],
	        "members": {
	          "CacheSecurityGroupName": {}
	        }
	      }
	    },
	    "DeleteCacheSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheSubnetGroupName"
	        ],
	        "members": {
	          "CacheSubnetGroupName": {}
	        }
	      }
	    },
	    "DeleteGlobalReplicationGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalReplicationGroupId",
	          "RetainPrimaryReplicationGroup"
	        ],
	        "members": {
	          "GlobalReplicationGroupId": {},
	          "RetainPrimaryReplicationGroup": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteGlobalReplicationGroupResult",
	        "type": "structure",
	        "members": {
	          "GlobalReplicationGroup": {
	            "shape": "S2y"
	          }
	        }
	      }
	    },
	    "DeleteReplicationGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplicationGroupId"
	        ],
	        "members": {
	          "ReplicationGroupId": {},
	          "RetainPrimaryCluster": {
	            "type": "boolean"
	          },
	          "FinalSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteReplicationGroupResult",
	        "type": "structure",
	        "members": {
	          "ReplicationGroup": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "DeleteSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotName"
	        ],
	        "members": {
	          "SnapshotName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteSnapshotResult",
	        "type": "structure",
	        "members": {
	          "Snapshot": {
	            "shape": "S1q"
	          }
	        }
	      }
	    },
	    "DeleteUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserId"
	        ],
	        "members": {
	          "UserId": {}
	        }
	      },
	      "output": {
	        "shape": "S3f",
	        "resultWrapper": "DeleteUserResult"
	      }
	    },
	    "DeleteUserGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserGroupId"
	        ],
	        "members": {
	          "UserGroupId": {}
	        }
	      },
	      "output": {
	        "shape": "S3k",
	        "resultWrapper": "DeleteUserGroupResult"
	      }
	    },
	    "DescribeCacheClusters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CacheClusterId": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "ShowCacheNodeInfo": {
	            "type": "boolean"
	          },
	          "ShowCacheClustersNotInReplicationGroups": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeCacheClustersResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "CacheClusters": {
	            "type": "list",
	            "member": {
	              "shape": "S28",
	              "locationName": "CacheCluster"
	            }
	          }
	        }
	      }
	    },
	    "DescribeCacheEngineVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "CacheParameterGroupFamily": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "DefaultOnly": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeCacheEngineVersionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "CacheEngineVersions": {
	            "type": "list",
	            "member": {
	              "locationName": "CacheEngineVersion",
	              "type": "structure",
	              "members": {
	                "Engine": {},
	                "EngineVersion": {},
	                "CacheParameterGroupFamily": {},
	                "CacheEngineDescription": {},
	                "CacheEngineVersionDescription": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeCacheParameterGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CacheParameterGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeCacheParameterGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "CacheParameterGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S2l",
	              "locationName": "CacheParameterGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeCacheParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheParameterGroupName"
	        ],
	        "members": {
	          "CacheParameterGroupName": {},
	          "Source": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeCacheParametersResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Parameters": {
	            "shape": "S4l"
	          },
	          "CacheNodeTypeSpecificParameters": {
	            "shape": "S4o"
	          }
	        }
	      }
	    },
	    "DescribeCacheSecurityGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CacheSecurityGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeCacheSecurityGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "CacheSecurityGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S8",
	              "locationName": "CacheSecurityGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeCacheSubnetGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CacheSubnetGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeCacheSubnetGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "CacheSubnetGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S2r",
	              "locationName": "CacheSubnetGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEngineDefaultParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheParameterGroupFamily"
	        ],
	        "members": {
	          "CacheParameterGroupFamily": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEngineDefaultParametersResult",
	        "type": "structure",
	        "members": {
	          "EngineDefaults": {
	            "type": "structure",
	            "members": {
	              "CacheParameterGroupFamily": {},
	              "Marker": {},
	              "Parameters": {
	                "shape": "S4l"
	              },
	              "CacheNodeTypeSpecificParameters": {
	                "shape": "S4o"
	              }
	            },
	            "wrapper": true
	          }
	        }
	      }
	    },
	    "DescribeEvents": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceIdentifier": {},
	          "SourceType": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Duration": {
	            "type": "integer"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Events": {
	            "type": "list",
	            "member": {
	              "locationName": "Event",
	              "type": "structure",
	              "members": {
	                "SourceIdentifier": {},
	                "SourceType": {},
	                "Message": {},
	                "Date": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeGlobalReplicationGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GlobalReplicationGroupId": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "ShowMemberInfo": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeGlobalReplicationGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "GlobalReplicationGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S2y",
	              "locationName": "GlobalReplicationGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeReplicationGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReplicationGroupId": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReplicationGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReplicationGroups": {
	            "type": "list",
	            "member": {
	              "shape": "So",
	              "locationName": "ReplicationGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeReservedCacheNodes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedCacheNodeId": {},
	          "ReservedCacheNodesOfferingId": {},
	          "CacheNodeType": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedCacheNodesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedCacheNodes": {
	            "type": "list",
	            "member": {
	              "shape": "S5f",
	              "locationName": "ReservedCacheNode"
	            }
	          }
	        }
	      }
	    },
	    "DescribeReservedCacheNodesOfferings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedCacheNodesOfferingId": {},
	          "CacheNodeType": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedCacheNodesOfferingsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedCacheNodesOfferings": {
	            "type": "list",
	            "member": {
	              "locationName": "ReservedCacheNodesOffering",
	              "type": "structure",
	              "members": {
	                "ReservedCacheNodesOfferingId": {},
	                "CacheNodeType": {},
	                "Duration": {
	                  "type": "integer"
	                },
	                "FixedPrice": {
	                  "type": "double"
	                },
	                "UsagePrice": {
	                  "type": "double"
	                },
	                "ProductDescription": {},
	                "OfferingType": {},
	                "RecurringCharges": {
	                  "shape": "S5g"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DescribeServiceUpdates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ServiceUpdateName": {},
	          "ServiceUpdateStatus": {
	            "shape": "S5n"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeServiceUpdatesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ServiceUpdates": {
	            "type": "list",
	            "member": {
	              "locationName": "ServiceUpdate",
	              "type": "structure",
	              "members": {
	                "ServiceUpdateName": {},
	                "ServiceUpdateReleaseDate": {
	                  "type": "timestamp"
	                },
	                "ServiceUpdateEndDate": {
	                  "type": "timestamp"
	                },
	                "ServiceUpdateSeverity": {},
	                "ServiceUpdateRecommendedApplyByDate": {
	                  "type": "timestamp"
	                },
	                "ServiceUpdateStatus": {},
	                "ServiceUpdateDescription": {},
	                "ServiceUpdateType": {},
	                "Engine": {},
	                "EngineVersion": {},
	                "AutoUpdateAfterRecommendedApplyByDate": {
	                  "type": "boolean"
	                },
	                "EstimatedUpdateTime": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeSnapshots": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReplicationGroupId": {},
	          "CacheClusterId": {},
	          "SnapshotName": {},
	          "SnapshotSource": {},
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "ShowNodeGroupConfig": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeSnapshotsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Snapshots": {
	            "type": "list",
	            "member": {
	              "shape": "S1q",
	              "locationName": "Snapshot"
	            }
	          }
	        }
	      }
	    },
	    "DescribeUpdateActions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ServiceUpdateName": {},
	          "ReplicationGroupIds": {
	            "shape": "Sc"
	          },
	          "CacheClusterIds": {
	            "shape": "Sd"
	          },
	          "Engine": {},
	          "ServiceUpdateStatus": {
	            "shape": "S5n"
	          },
	          "ServiceUpdateTimeRange": {
	            "type": "structure",
	            "members": {
	              "StartTime": {
	                "type": "timestamp"
	              },
	              "EndTime": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "UpdateActionStatus": {
	            "type": "list",
	            "member": {}
	          },
	          "ShowNodeLevelUpdateStatus": {
	            "type": "boolean"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeUpdateActionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "UpdateActions": {
	            "type": "list",
	            "member": {
	              "locationName": "UpdateAction",
	              "type": "structure",
	              "members": {
	                "ReplicationGroupId": {},
	                "CacheClusterId": {},
	                "ServiceUpdateName": {},
	                "ServiceUpdateReleaseDate": {
	                  "type": "timestamp"
	                },
	                "ServiceUpdateSeverity": {},
	                "ServiceUpdateStatus": {},
	                "ServiceUpdateRecommendedApplyByDate": {
	                  "type": "timestamp"
	                },
	                "ServiceUpdateType": {},
	                "UpdateActionAvailableDate": {
	                  "type": "timestamp"
	                },
	                "UpdateActionStatus": {},
	                "NodesUpdated": {},
	                "UpdateActionStatusModifiedDate": {
	                  "type": "timestamp"
	                },
	                "SlaMet": {},
	                "NodeGroupUpdateStatus": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "NodeGroupUpdateStatus",
	                    "type": "structure",
	                    "members": {
	                      "NodeGroupId": {},
	                      "NodeGroupMemberUpdateStatus": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "NodeGroupMemberUpdateStatus",
	                          "type": "structure",
	                          "members": {
	                            "CacheClusterId": {},
	                            "CacheNodeId": {},
	                            "NodeUpdateStatus": {},
	                            "NodeDeletionDate": {
	                              "type": "timestamp"
	                            },
	                            "NodeUpdateStartDate": {
	                              "type": "timestamp"
	                            },
	                            "NodeUpdateEndDate": {
	                              "type": "timestamp"
	                            },
	                            "NodeUpdateInitiatedBy": {},
	                            "NodeUpdateInitiatedDate": {
	                              "type": "timestamp"
	                            },
	                            "NodeUpdateStatusModifiedDate": {
	                              "type": "timestamp"
	                            }
	                          }
	                        }
	                      }
	                    }
	                  }
	                },
	                "CacheNodeUpdateStatus": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "CacheNodeUpdateStatus",
	                    "type": "structure",
	                    "members": {
	                      "CacheNodeId": {},
	                      "NodeUpdateStatus": {},
	                      "NodeDeletionDate": {
	                        "type": "timestamp"
	                      },
	                      "NodeUpdateStartDate": {
	                        "type": "timestamp"
	                      },
	                      "NodeUpdateEndDate": {
	                        "type": "timestamp"
	                      },
	                      "NodeUpdateInitiatedBy": {},
	                      "NodeUpdateInitiatedDate": {
	                        "type": "timestamp"
	                      },
	                      "NodeUpdateStatusModifiedDate": {
	                        "type": "timestamp"
	                      }
	                    }
	                  }
	                },
	                "EstimatedUpdateTime": {},
	                "Engine": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeUserGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "UserGroupId": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeUserGroupsResult",
	        "type": "structure",
	        "members": {
	          "UserGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S3k"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeUsers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Engine": {},
	          "UserId": {},
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Name",
	                "Values"
	              ],
	              "members": {
	                "Name": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeUsersResult",
	        "type": "structure",
	        "members": {
	          "Users": {
	            "type": "list",
	            "member": {
	              "shape": "S3f"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DisassociateGlobalReplicationGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalReplicationGroupId",
	          "ReplicationGroupId",
	          "ReplicationGroupRegion"
	        ],
	        "members": {
	          "GlobalReplicationGroupId": {},
	          "ReplicationGroupId": {},
	          "ReplicationGroupRegion": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DisassociateGlobalReplicationGroupResult",
	        "type": "structure",
	        "members": {
	          "GlobalReplicationGroup": {
	            "shape": "S2y"
	          }
	        }
	      }
	    },
	    "FailoverGlobalReplicationGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalReplicationGroupId",
	          "PrimaryRegion",
	          "PrimaryReplicationGroupId"
	        ],
	        "members": {
	          "GlobalReplicationGroupId": {},
	          "PrimaryRegion": {},
	          "PrimaryReplicationGroupId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "FailoverGlobalReplicationGroupResult",
	        "type": "structure",
	        "members": {
	          "GlobalReplicationGroup": {
	            "shape": "S2y"
	          }
	        }
	      }
	    },
	    "IncreaseNodeGroupsInGlobalReplicationGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalReplicationGroupId",
	          "NodeGroupCount",
	          "ApplyImmediately"
	        ],
	        "members": {
	          "GlobalReplicationGroupId": {},
	          "NodeGroupCount": {
	            "type": "integer"
	          },
	          "RegionalConfigurations": {
	            "type": "list",
	            "member": {
	              "locationName": "RegionalConfiguration",
	              "type": "structure",
	              "required": [
	                "ReplicationGroupId",
	                "ReplicationGroupRegion",
	                "ReshardingConfiguration"
	              ],
	              "members": {
	                "ReplicationGroupId": {},
	                "ReplicationGroupRegion": {},
	                "ReshardingConfiguration": {
	                  "shape": "S6u"
	                }
	              }
	            }
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "IncreaseNodeGroupsInGlobalReplicationGroupResult",
	        "type": "structure",
	        "members": {
	          "GlobalReplicationGroup": {
	            "shape": "S2y"
	          }
	        }
	      }
	    },
	    "IncreaseReplicaCount": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplicationGroupId",
	          "ApplyImmediately"
	        ],
	        "members": {
	          "ReplicationGroupId": {},
	          "NewReplicaCount": {
	            "type": "integer"
	          },
	          "ReplicaConfiguration": {
	            "shape": "S3s"
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "IncreaseReplicaCountResult",
	        "type": "structure",
	        "members": {
	          "ReplicationGroup": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "ListAllowedNodeTypeModifications": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CacheClusterId": {},
	          "ReplicationGroupId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListAllowedNodeTypeModificationsResult",
	        "type": "structure",
	        "members": {
	          "ScaleUpModifications": {
	            "shape": "S71"
	          },
	          "ScaleDownModifications": {
	            "shape": "S71"
	          }
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName"
	        ],
	        "members": {
	          "ResourceName": {}
	        }
	      },
	      "output": {
	        "shape": "S5",
	        "resultWrapper": "ListTagsForResourceResult"
	      }
	    },
	    "ModifyCacheCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheClusterId"
	        ],
	        "members": {
	          "CacheClusterId": {},
	          "NumCacheNodes": {
	            "type": "integer"
	          },
	          "CacheNodeIdsToRemove": {
	            "shape": "S2a"
	          },
	          "AZMode": {},
	          "NewAvailabilityZones": {
	            "shape": "S1z"
	          },
	          "CacheSecurityGroupNames": {
	            "shape": "S20"
	          },
	          "SecurityGroupIds": {
	            "shape": "S21"
	          },
	          "PreferredMaintenanceWindow": {},
	          "NotificationTopicArn": {},
	          "CacheParameterGroupName": {},
	          "NotificationTopicStatus": {},
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "SnapshotRetentionLimit": {
	            "type": "integer"
	          },
	          "SnapshotWindow": {},
	          "CacheNodeType": {},
	          "AuthToken": {},
	          "AuthTokenUpdateStrategy": {},
	          "LogDeliveryConfigurations": {
	            "shape": "S25"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyCacheClusterResult",
	        "type": "structure",
	        "members": {
	          "CacheCluster": {
	            "shape": "S28"
	          }
	        }
	      }
	    },
	    "ModifyCacheParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheParameterGroupName",
	          "ParameterNameValues"
	        ],
	        "members": {
	          "CacheParameterGroupName": {},
	          "ParameterNameValues": {
	            "shape": "S77"
	          }
	        }
	      },
	      "output": {
	        "shape": "S79",
	        "resultWrapper": "ModifyCacheParameterGroupResult"
	      }
	    },
	    "ModifyCacheSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheSubnetGroupName"
	        ],
	        "members": {
	          "CacheSubnetGroupName": {},
	          "CacheSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S2p"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyCacheSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "CacheSubnetGroup": {
	            "shape": "S2r"
	          }
	        }
	      }
	    },
	    "ModifyGlobalReplicationGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalReplicationGroupId",
	          "ApplyImmediately"
	        ],
	        "members": {
	          "GlobalReplicationGroupId": {},
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "CacheNodeType": {},
	          "EngineVersion": {},
	          "CacheParameterGroupName": {},
	          "GlobalReplicationGroupDescription": {},
	          "AutomaticFailoverEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyGlobalReplicationGroupResult",
	        "type": "structure",
	        "members": {
	          "GlobalReplicationGroup": {
	            "shape": "S2y"
	          }
	        }
	      }
	    },
	    "ModifyReplicationGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplicationGroupId"
	        ],
	        "members": {
	          "ReplicationGroupId": {},
	          "ReplicationGroupDescription": {},
	          "PrimaryClusterId": {},
	          "SnapshottingClusterId": {},
	          "AutomaticFailoverEnabled": {
	            "type": "boolean"
	          },
	          "MultiAZEnabled": {
	            "type": "boolean"
	          },
	          "NodeGroupId": {
	            "deprecated": true
	          },
	          "CacheSecurityGroupNames": {
	            "shape": "S20"
	          },
	          "SecurityGroupIds": {
	            "shape": "S21"
	          },
	          "PreferredMaintenanceWindow": {},
	          "NotificationTopicArn": {},
	          "CacheParameterGroupName": {},
	          "NotificationTopicStatus": {},
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "SnapshotRetentionLimit": {
	            "type": "integer"
	          },
	          "SnapshotWindow": {},
	          "CacheNodeType": {},
	          "AuthToken": {},
	          "AuthTokenUpdateStrategy": {},
	          "UserGroupIdsToAdd": {
	            "shape": "Sx"
	          },
	          "UserGroupIdsToRemove": {
	            "shape": "Sx"
	          },
	          "RemoveUserGroups": {
	            "type": "boolean"
	          },
	          "LogDeliveryConfigurations": {
	            "shape": "S25"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyReplicationGroupResult",
	        "type": "structure",
	        "members": {
	          "ReplicationGroup": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "ModifyReplicationGroupShardConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplicationGroupId",
	          "NodeGroupCount",
	          "ApplyImmediately"
	        ],
	        "members": {
	          "ReplicationGroupId": {},
	          "NodeGroupCount": {
	            "type": "integer"
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "ReshardingConfiguration": {
	            "shape": "S6u"
	          },
	          "NodeGroupsToRemove": {
	            "type": "list",
	            "member": {
	              "locationName": "NodeGroupToRemove"
	            }
	          },
	          "NodeGroupsToRetain": {
	            "type": "list",
	            "member": {
	              "locationName": "NodeGroupToRetain"
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyReplicationGroupShardConfigurationResult",
	        "type": "structure",
	        "members": {
	          "ReplicationGroup": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "ModifyUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserId"
	        ],
	        "members": {
	          "UserId": {},
	          "AccessString": {},
	          "AppendAccessString": {},
	          "Passwords": {
	            "shape": "S3d"
	          },
	          "NoPasswordRequired": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3f",
	        "resultWrapper": "ModifyUserResult"
	      }
	    },
	    "ModifyUserGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserGroupId"
	        ],
	        "members": {
	          "UserGroupId": {},
	          "UserIdsToAdd": {
	            "shape": "S3j"
	          },
	          "UserIdsToRemove": {
	            "shape": "S3j"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3k",
	        "resultWrapper": "ModifyUserGroupResult"
	      }
	    },
	    "PurchaseReservedCacheNodesOffering": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedCacheNodesOfferingId"
	        ],
	        "members": {
	          "ReservedCacheNodesOfferingId": {},
	          "ReservedCacheNodeId": {},
	          "CacheNodeCount": {
	            "type": "integer"
	          },
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PurchaseReservedCacheNodesOfferingResult",
	        "type": "structure",
	        "members": {
	          "ReservedCacheNode": {
	            "shape": "S5f"
	          }
	        }
	      }
	    },
	    "RebalanceSlotsInGlobalReplicationGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalReplicationGroupId",
	          "ApplyImmediately"
	        ],
	        "members": {
	          "GlobalReplicationGroupId": {},
	          "ApplyImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RebalanceSlotsInGlobalReplicationGroupResult",
	        "type": "structure",
	        "members": {
	          "GlobalReplicationGroup": {
	            "shape": "S2y"
	          }
	        }
	      }
	    },
	    "RebootCacheCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheClusterId",
	          "CacheNodeIdsToReboot"
	        ],
	        "members": {
	          "CacheClusterId": {},
	          "CacheNodeIdsToReboot": {
	            "shape": "S2a"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RebootCacheClusterResult",
	        "type": "structure",
	        "members": {
	          "CacheCluster": {
	            "shape": "S28"
	          }
	        }
	      }
	    },
	    "RemoveTagsFromResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceName": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "shape": "S5",
	        "resultWrapper": "RemoveTagsFromResourceResult"
	      }
	    },
	    "ResetCacheParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheParameterGroupName"
	        ],
	        "members": {
	          "CacheParameterGroupName": {},
	          "ResetAllParameters": {
	            "type": "boolean"
	          },
	          "ParameterNameValues": {
	            "shape": "S77"
	          }
	        }
	      },
	      "output": {
	        "shape": "S79",
	        "resultWrapper": "ResetCacheParameterGroupResult"
	      }
	    },
	    "RevokeCacheSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CacheSecurityGroupName",
	          "EC2SecurityGroupName",
	          "EC2SecurityGroupOwnerId"
	        ],
	        "members": {
	          "CacheSecurityGroupName": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RevokeCacheSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "CacheSecurityGroup": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "StartMigration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplicationGroupId",
	          "CustomerNodeEndpointList"
	        ],
	        "members": {
	          "ReplicationGroupId": {},
	          "CustomerNodeEndpointList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Address": {},
	                "Port": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "StartMigrationResult",
	        "type": "structure",
	        "members": {
	          "ReplicationGroup": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "TestFailover": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplicationGroupId",
	          "NodeGroupId"
	        ],
	        "members": {
	          "ReplicationGroupId": {},
	          "NodeGroupId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "TestFailoverResult",
	        "type": "structure",
	        "members": {
	          "ReplicationGroup": {
	            "shape": "So"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S3": {
	      "type": "list",
	      "member": {
	        "locationName": "Tag",
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S5": {
	      "type": "structure",
	      "members": {
	        "TagList": {
	          "shape": "S3"
	        }
	      }
	    },
	    "S8": {
	      "type": "structure",
	      "members": {
	        "OwnerId": {},
	        "CacheSecurityGroupName": {},
	        "Description": {},
	        "EC2SecurityGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "EC2SecurityGroup",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "EC2SecurityGroupName": {},
	              "EC2SecurityGroupOwnerId": {}
	            }
	          }
	        },
	        "ARN": {}
	      },
	      "wrapper": true
	    },
	    "Sc": {
	      "type": "list",
	      "member": {}
	    },
	    "Sd": {
	      "type": "list",
	      "member": {}
	    },
	    "Se": {
	      "type": "structure",
	      "members": {
	        "ProcessedUpdateActions": {
	          "type": "list",
	          "member": {
	            "locationName": "ProcessedUpdateAction",
	            "type": "structure",
	            "members": {
	              "ReplicationGroupId": {},
	              "CacheClusterId": {},
	              "ServiceUpdateName": {},
	              "UpdateActionStatus": {}
	            }
	          }
	        },
	        "UnprocessedUpdateActions": {
	          "type": "list",
	          "member": {
	            "locationName": "UnprocessedUpdateAction",
	            "type": "structure",
	            "members": {
	              "ReplicationGroupId": {},
	              "CacheClusterId": {},
	              "ServiceUpdateName": {},
	              "ErrorType": {},
	              "ErrorMessage": {}
	            }
	          }
	        }
	      }
	    },
	    "So": {
	      "type": "structure",
	      "members": {
	        "ReplicationGroupId": {},
	        "Description": {},
	        "GlobalReplicationGroupInfo": {
	          "type": "structure",
	          "members": {
	            "GlobalReplicationGroupId": {},
	            "GlobalReplicationGroupMemberRole": {}
	          }
	        },
	        "Status": {},
	        "PendingModifiedValues": {
	          "type": "structure",
	          "members": {
	            "PrimaryClusterId": {},
	            "AutomaticFailoverStatus": {},
	            "Resharding": {
	              "type": "structure",
	              "members": {
	                "SlotMigration": {
	                  "type": "structure",
	                  "members": {
	                    "ProgressPercentage": {
	                      "type": "double"
	                    }
	                  }
	                }
	              }
	            },
	            "AuthTokenStatus": {},
	            "UserGroups": {
	              "type": "structure",
	              "members": {
	                "UserGroupIdsToAdd": {
	                  "shape": "Sx"
	                },
	                "UserGroupIdsToRemove": {
	                  "shape": "Sx"
	                }
	              }
	            },
	            "LogDeliveryConfigurations": {
	              "shape": "Sz"
	            }
	          }
	        },
	        "MemberClusters": {
	          "type": "list",
	          "member": {
	            "locationName": "ClusterId"
	          }
	        },
	        "NodeGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "NodeGroup",
	            "type": "structure",
	            "members": {
	              "NodeGroupId": {},
	              "Status": {},
	              "PrimaryEndpoint": {
	                "shape": "S1a"
	              },
	              "ReaderEndpoint": {
	                "shape": "S1a"
	              },
	              "Slots": {},
	              "NodeGroupMembers": {
	                "type": "list",
	                "member": {
	                  "locationName": "NodeGroupMember",
	                  "type": "structure",
	                  "members": {
	                    "CacheClusterId": {},
	                    "CacheNodeId": {},
	                    "ReadEndpoint": {
	                      "shape": "S1a"
	                    },
	                    "PreferredAvailabilityZone": {},
	                    "PreferredOutpostArn": {},
	                    "CurrentRole": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "SnapshottingClusterId": {},
	        "AutomaticFailover": {},
	        "MultiAZ": {},
	        "ConfigurationEndpoint": {
	          "shape": "S1a"
	        },
	        "SnapshotRetentionLimit": {
	          "type": "integer"
	        },
	        "SnapshotWindow": {},
	        "ClusterEnabled": {
	          "type": "boolean"
	        },
	        "CacheNodeType": {},
	        "AuthTokenEnabled": {
	          "type": "boolean"
	        },
	        "AuthTokenLastModifiedDate": {
	          "type": "timestamp"
	        },
	        "TransitEncryptionEnabled": {
	          "type": "boolean"
	        },
	        "AtRestEncryptionEnabled": {
	          "type": "boolean"
	        },
	        "MemberClustersOutpostArns": {
	          "type": "list",
	          "member": {
	            "locationName": "ReplicationGroupOutpostArn"
	          }
	        },
	        "KmsKeyId": {},
	        "ARN": {},
	        "UserGroupIds": {
	          "shape": "Sx"
	        },
	        "LogDeliveryConfigurations": {
	          "shape": "S1k"
	        },
	        "ReplicationGroupCreateTime": {
	          "type": "timestamp"
	        },
	        "DataTiering": {}
	      },
	      "wrapper": true
	    },
	    "Sx": {
	      "type": "list",
	      "member": {}
	    },
	    "Sz": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "LogType": {},
	          "DestinationType": {},
	          "DestinationDetails": {
	            "shape": "S13"
	          },
	          "LogFormat": {}
	        }
	      },
	      "locationName": "PendingLogDeliveryConfiguration"
	    },
	    "S13": {
	      "type": "structure",
	      "members": {
	        "CloudWatchLogsDetails": {
	          "type": "structure",
	          "members": {
	            "LogGroup": {}
	          }
	        },
	        "KinesisFirehoseDetails": {
	          "type": "structure",
	          "members": {
	            "DeliveryStream": {}
	          }
	        }
	      }
	    },
	    "S1a": {
	      "type": "structure",
	      "members": {
	        "Address": {},
	        "Port": {
	          "type": "integer"
	        }
	      }
	    },
	    "S1k": {
	      "type": "list",
	      "member": {
	        "locationName": "LogDeliveryConfiguration",
	        "type": "structure",
	        "members": {
	          "LogType": {},
	          "DestinationType": {},
	          "DestinationDetails": {
	            "shape": "S13"
	          },
	          "LogFormat": {},
	          "Status": {},
	          "Message": {}
	        }
	      }
	    },
	    "S1q": {
	      "type": "structure",
	      "members": {
	        "SnapshotName": {},
	        "ReplicationGroupId": {},
	        "ReplicationGroupDescription": {},
	        "CacheClusterId": {},
	        "SnapshotStatus": {},
	        "SnapshotSource": {},
	        "CacheNodeType": {},
	        "Engine": {},
	        "EngineVersion": {},
	        "NumCacheNodes": {
	          "type": "integer"
	        },
	        "PreferredAvailabilityZone": {},
	        "PreferredOutpostArn": {},
	        "CacheClusterCreateTime": {
	          "type": "timestamp"
	        },
	        "PreferredMaintenanceWindow": {},
	        "TopicArn": {},
	        "Port": {
	          "type": "integer"
	        },
	        "CacheParameterGroupName": {},
	        "CacheSubnetGroupName": {},
	        "VpcId": {},
	        "AutoMinorVersionUpgrade": {
	          "type": "boolean"
	        },
	        "SnapshotRetentionLimit": {
	          "type": "integer"
	        },
	        "SnapshotWindow": {},
	        "NumNodeGroups": {
	          "type": "integer"
	        },
	        "AutomaticFailover": {},
	        "NodeSnapshots": {
	          "type": "list",
	          "member": {
	            "locationName": "NodeSnapshot",
	            "type": "structure",
	            "members": {
	              "CacheClusterId": {},
	              "NodeGroupId": {},
	              "CacheNodeId": {},
	              "NodeGroupConfiguration": {
	                "shape": "S1t"
	              },
	              "CacheSize": {},
	              "CacheNodeCreateTime": {
	                "type": "timestamp"
	              },
	              "SnapshotCreateTime": {
	                "type": "timestamp"
	              }
	            },
	            "wrapper": true
	          }
	        },
	        "KmsKeyId": {},
	        "ARN": {},
	        "DataTiering": {}
	      },
	      "wrapper": true
	    },
	    "S1t": {
	      "type": "structure",
	      "members": {
	        "NodeGroupId": {},
	        "Slots": {},
	        "ReplicaCount": {
	          "type": "integer"
	        },
	        "PrimaryAvailabilityZone": {},
	        "ReplicaAvailabilityZones": {
	          "shape": "S1v"
	        },
	        "PrimaryOutpostArn": {},
	        "ReplicaOutpostArns": {
	          "type": "list",
	          "member": {
	            "locationName": "OutpostArn"
	          }
	        }
	      }
	    },
	    "S1v": {
	      "type": "list",
	      "member": {
	        "locationName": "AvailabilityZone"
	      }
	    },
	    "S1z": {
	      "type": "list",
	      "member": {
	        "locationName": "PreferredAvailabilityZone"
	      }
	    },
	    "S20": {
	      "type": "list",
	      "member": {
	        "locationName": "CacheSecurityGroupName"
	      }
	    },
	    "S21": {
	      "type": "list",
	      "member": {
	        "locationName": "SecurityGroupId"
	      }
	    },
	    "S22": {
	      "type": "list",
	      "member": {
	        "locationName": "SnapshotArn"
	      }
	    },
	    "S24": {
	      "type": "list",
	      "member": {
	        "locationName": "PreferredOutpostArn"
	      }
	    },
	    "S25": {
	      "type": "list",
	      "member": {
	        "locationName": "LogDeliveryConfigurationRequest",
	        "type": "structure",
	        "members": {
	          "LogType": {},
	          "DestinationType": {},
	          "DestinationDetails": {
	            "shape": "S13"
	          },
	          "LogFormat": {},
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S28": {
	      "type": "structure",
	      "members": {
	        "CacheClusterId": {},
	        "ConfigurationEndpoint": {
	          "shape": "S1a"
	        },
	        "ClientDownloadLandingPage": {},
	        "CacheNodeType": {},
	        "Engine": {},
	        "EngineVersion": {},
	        "CacheClusterStatus": {},
	        "NumCacheNodes": {
	          "type": "integer"
	        },
	        "PreferredAvailabilityZone": {},
	        "PreferredOutpostArn": {},
	        "CacheClusterCreateTime": {
	          "type": "timestamp"
	        },
	        "PreferredMaintenanceWindow": {},
	        "PendingModifiedValues": {
	          "type": "structure",
	          "members": {
	            "NumCacheNodes": {
	              "type": "integer"
	            },
	            "CacheNodeIdsToRemove": {
	              "shape": "S2a"
	            },
	            "EngineVersion": {},
	            "CacheNodeType": {},
	            "AuthTokenStatus": {},
	            "LogDeliveryConfigurations": {
	              "shape": "Sz"
	            }
	          }
	        },
	        "NotificationConfiguration": {
	          "type": "structure",
	          "members": {
	            "TopicArn": {},
	            "TopicStatus": {}
	          }
	        },
	        "CacheSecurityGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "CacheSecurityGroup",
	            "type": "structure",
	            "members": {
	              "CacheSecurityGroupName": {},
	              "Status": {}
	            }
	          }
	        },
	        "CacheParameterGroup": {
	          "type": "structure",
	          "members": {
	            "CacheParameterGroupName": {},
	            "ParameterApplyStatus": {},
	            "CacheNodeIdsToReboot": {
	              "shape": "S2a"
	            }
	          }
	        },
	        "CacheSubnetGroupName": {},
	        "CacheNodes": {
	          "type": "list",
	          "member": {
	            "locationName": "CacheNode",
	            "type": "structure",
	            "members": {
	              "CacheNodeId": {},
	              "CacheNodeStatus": {},
	              "CacheNodeCreateTime": {
	                "type": "timestamp"
	              },
	              "Endpoint": {
	                "shape": "S1a"
	              },
	              "ParameterGroupStatus": {},
	              "SourceCacheNodeId": {},
	              "CustomerAvailabilityZone": {},
	              "CustomerOutpostArn": {}
	            }
	          }
	        },
	        "AutoMinorVersionUpgrade": {
	          "type": "boolean"
	        },
	        "SecurityGroups": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "SecurityGroupId": {},
	              "Status": {}
	            }
	          }
	        },
	        "ReplicationGroupId": {},
	        "SnapshotRetentionLimit": {
	          "type": "integer"
	        },
	        "SnapshotWindow": {},
	        "AuthTokenEnabled": {
	          "type": "boolean"
	        },
	        "AuthTokenLastModifiedDate": {
	          "type": "timestamp"
	        },
	        "TransitEncryptionEnabled": {
	          "type": "boolean"
	        },
	        "AtRestEncryptionEnabled": {
	          "type": "boolean"
	        },
	        "ARN": {},
	        "ReplicationGroupLogDeliveryEnabled": {
	          "type": "boolean"
	        },
	        "LogDeliveryConfigurations": {
	          "shape": "S1k"
	        }
	      },
	      "wrapper": true
	    },
	    "S2a": {
	      "type": "list",
	      "member": {
	        "locationName": "CacheNodeId"
	      }
	    },
	    "S2l": {
	      "type": "structure",
	      "members": {
	        "CacheParameterGroupName": {},
	        "CacheParameterGroupFamily": {},
	        "Description": {},
	        "IsGlobal": {
	          "type": "boolean"
	        },
	        "ARN": {}
	      },
	      "wrapper": true
	    },
	    "S2p": {
	      "type": "list",
	      "member": {
	        "locationName": "SubnetIdentifier"
	      }
	    },
	    "S2r": {
	      "type": "structure",
	      "members": {
	        "CacheSubnetGroupName": {},
	        "CacheSubnetGroupDescription": {},
	        "VpcId": {},
	        "Subnets": {
	          "type": "list",
	          "member": {
	            "locationName": "Subnet",
	            "type": "structure",
	            "members": {
	              "SubnetIdentifier": {},
	              "SubnetAvailabilityZone": {
	                "type": "structure",
	                "members": {
	                  "Name": {}
	                },
	                "wrapper": true
	              },
	              "SubnetOutpost": {
	                "type": "structure",
	                "members": {
	                  "SubnetOutpostArn": {}
	                }
	              }
	            }
	          }
	        },
	        "ARN": {}
	      },
	      "wrapper": true
	    },
	    "S2y": {
	      "type": "structure",
	      "members": {
	        "GlobalReplicationGroupId": {},
	        "GlobalReplicationGroupDescription": {},
	        "Status": {},
	        "CacheNodeType": {},
	        "Engine": {},
	        "EngineVersion": {},
	        "Members": {
	          "type": "list",
	          "member": {
	            "locationName": "GlobalReplicationGroupMember",
	            "type": "structure",
	            "members": {
	              "ReplicationGroupId": {},
	              "ReplicationGroupRegion": {},
	              "Role": {},
	              "AutomaticFailover": {},
	              "Status": {}
	            },
	            "wrapper": true
	          }
	        },
	        "ClusterEnabled": {
	          "type": "boolean"
	        },
	        "GlobalNodeGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "GlobalNodeGroup",
	            "type": "structure",
	            "members": {
	              "GlobalNodeGroupId": {},
	              "Slots": {}
	            }
	          }
	        },
	        "AuthTokenEnabled": {
	          "type": "boolean"
	        },
	        "TransitEncryptionEnabled": {
	          "type": "boolean"
	        },
	        "AtRestEncryptionEnabled": {
	          "type": "boolean"
	        },
	        "ARN": {}
	      },
	      "wrapper": true
	    },
	    "S3d": {
	      "type": "list",
	      "member": {}
	    },
	    "S3f": {
	      "type": "structure",
	      "members": {
	        "UserId": {},
	        "UserName": {},
	        "Status": {},
	        "Engine": {},
	        "MinimumEngineVersion": {},
	        "AccessString": {},
	        "UserGroupIds": {
	          "shape": "Sx"
	        },
	        "Authentication": {
	          "type": "structure",
	          "members": {
	            "Type": {},
	            "PasswordCount": {
	              "type": "integer"
	            }
	          }
	        },
	        "ARN": {}
	      }
	    },
	    "S3j": {
	      "type": "list",
	      "member": {}
	    },
	    "S3k": {
	      "type": "structure",
	      "members": {
	        "UserGroupId": {},
	        "Status": {},
	        "Engine": {},
	        "UserIds": {
	          "shape": "S3l"
	        },
	        "MinimumEngineVersion": {},
	        "PendingChanges": {
	          "type": "structure",
	          "members": {
	            "UserIdsToRemove": {
	              "shape": "S3l"
	            },
	            "UserIdsToAdd": {
	              "shape": "S3l"
	            }
	          }
	        },
	        "ReplicationGroups": {
	          "type": "list",
	          "member": {}
	        },
	        "ARN": {}
	      }
	    },
	    "S3l": {
	      "type": "list",
	      "member": {}
	    },
	    "S3p": {
	      "type": "list",
	      "member": {
	        "locationName": "GlobalNodeGroupId"
	      }
	    },
	    "S3s": {
	      "type": "list",
	      "member": {
	        "locationName": "ConfigureShard",
	        "type": "structure",
	        "required": [
	          "NodeGroupId",
	          "NewReplicaCount"
	        ],
	        "members": {
	          "NodeGroupId": {},
	          "NewReplicaCount": {
	            "type": "integer"
	          },
	          "PreferredAvailabilityZones": {
	            "shape": "S1z"
	          },
	          "PreferredOutpostArns": {
	            "shape": "S24"
	          }
	        }
	      }
	    },
	    "S4l": {
	      "type": "list",
	      "member": {
	        "locationName": "Parameter",
	        "type": "structure",
	        "members": {
	          "ParameterName": {},
	          "ParameterValue": {},
	          "Description": {},
	          "Source": {},
	          "DataType": {},
	          "AllowedValues": {},
	          "IsModifiable": {
	            "type": "boolean"
	          },
	          "MinimumEngineVersion": {},
	          "ChangeType": {}
	        }
	      }
	    },
	    "S4o": {
	      "type": "list",
	      "member": {
	        "locationName": "CacheNodeTypeSpecificParameter",
	        "type": "structure",
	        "members": {
	          "ParameterName": {},
	          "Description": {},
	          "Source": {},
	          "DataType": {},
	          "AllowedValues": {},
	          "IsModifiable": {
	            "type": "boolean"
	          },
	          "MinimumEngineVersion": {},
	          "CacheNodeTypeSpecificValues": {
	            "type": "list",
	            "member": {
	              "locationName": "CacheNodeTypeSpecificValue",
	              "type": "structure",
	              "members": {
	                "CacheNodeType": {},
	                "Value": {}
	              }
	            }
	          },
	          "ChangeType": {}
	        }
	      }
	    },
	    "S5f": {
	      "type": "structure",
	      "members": {
	        "ReservedCacheNodeId": {},
	        "ReservedCacheNodesOfferingId": {},
	        "CacheNodeType": {},
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "Duration": {
	          "type": "integer"
	        },
	        "FixedPrice": {
	          "type": "double"
	        },
	        "UsagePrice": {
	          "type": "double"
	        },
	        "CacheNodeCount": {
	          "type": "integer"
	        },
	        "ProductDescription": {},
	        "OfferingType": {},
	        "State": {},
	        "RecurringCharges": {
	          "shape": "S5g"
	        },
	        "ReservationARN": {}
	      },
	      "wrapper": true
	    },
	    "S5g": {
	      "type": "list",
	      "member": {
	        "locationName": "RecurringCharge",
	        "type": "structure",
	        "members": {
	          "RecurringChargeAmount": {
	            "type": "double"
	          },
	          "RecurringChargeFrequency": {}
	        },
	        "wrapper": true
	      }
	    },
	    "S5n": {
	      "type": "list",
	      "member": {}
	    },
	    "S6u": {
	      "type": "list",
	      "member": {
	        "locationName": "ReshardingConfiguration",
	        "type": "structure",
	        "members": {
	          "NodeGroupId": {},
	          "PreferredAvailabilityZones": {
	            "shape": "S1v"
	          }
	        }
	      }
	    },
	    "S71": {
	      "type": "list",
	      "member": {}
	    },
	    "S77": {
	      "type": "list",
	      "member": {
	        "locationName": "ParameterNameValue",
	        "type": "structure",
	        "members": {
	          "ParameterName": {},
	          "ParameterValue": {}
	        }
	      }
	    },
	    "S79": {
	      "type": "structure",
	      "members": {
	        "CacheParameterGroupName": {}
	      }
	    }
	  }
	}
	},{}],89:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeCacheClusters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "CacheClusters"
	    },
	    "DescribeCacheEngineVersions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "CacheEngineVersions"
	    },
	    "DescribeCacheParameterGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "CacheParameterGroups"
	    },
	    "DescribeCacheParameters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Parameters"
	    },
	    "DescribeCacheSecurityGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "CacheSecurityGroups"
	    },
	    "DescribeCacheSubnetGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "CacheSubnetGroups"
	    },
	    "DescribeEngineDefaultParameters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "EngineDefaults.Marker",
	      "result_key": "EngineDefaults.Parameters"
	    },
	    "DescribeEvents": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Events"
	    },
	    "DescribeGlobalReplicationGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "GlobalReplicationGroups"
	    },
	    "DescribeReplicationGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReplicationGroups"
	    },
	    "DescribeReservedCacheNodes": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedCacheNodes"
	    },
	    "DescribeReservedCacheNodesOfferings": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedCacheNodesOfferings"
	    },
	    "DescribeServiceUpdates": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ServiceUpdates"
	    },
	    "DescribeSnapshots": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Snapshots"
	    },
	    "DescribeUpdateActions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "UpdateActions"
	    },
	    "DescribeUserGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "UserGroups"
	    },
	    "DescribeUsers": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Users"
	    }
	  }
	}
	},{}],90:[function(require,module,exports){
	module.exports={
	    "version":2,
	    "waiters":{
	        "CacheClusterAvailable":{
	            "acceptors":[
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"available",
	                    "matcher":"pathAll",
	                    "state":"success"
	                },
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"deleted",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                },
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"deleting",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                },
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"incompatible-network",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                },
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"restore-failed",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                }
	            ],
	            "delay":15,
	            "description":"Wait until ElastiCache cluster is available.",
	            "maxAttempts":40,
	            "operation":"DescribeCacheClusters"
	        },
	        "CacheClusterDeleted":{
	            "acceptors":[
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"deleted",
	                    "matcher":"pathAll",
	                    "state":"success"
	                },
	                {
	                    "expected":"CacheClusterNotFound",
	                    "matcher":"error",
	                    "state":"success"
	                },
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"available",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                },
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"creating",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                },
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"incompatible-network",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                },
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"modifying",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                },
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"restore-failed",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                },
	                {
	                    "argument":"CacheClusters[].CacheClusterStatus",
	                    "expected":"snapshotting",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                }
	            ],
	            "delay":15,
	            "description":"Wait until ElastiCache cluster is deleted.",
	            "maxAttempts":40,
	            "operation":"DescribeCacheClusters"
	        },
	        "ReplicationGroupAvailable":{
	            "acceptors":[
	                {
	                    "argument":"ReplicationGroups[].Status",
	                    "expected":"available",
	                    "matcher":"pathAll",
	                    "state":"success"
	                },
	                {
	                    "argument":"ReplicationGroups[].Status",
	                    "expected":"deleted",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                }
	            ],
	            "delay":15,
	            "description":"Wait until ElastiCache replication group is available.",
	            "maxAttempts":40,
	            "operation":"DescribeReplicationGroups"
	        },
	        "ReplicationGroupDeleted":{
	            "acceptors":[
	                {
	                    "argument":"ReplicationGroups[].Status",
	                    "expected":"deleted",
	                    "matcher":"pathAll",
	                    "state":"success"
	                },
	                {
	                    "argument":"ReplicationGroups[].Status",
	                    "expected":"available",
	                    "matcher":"pathAny",
	                    "state":"failure"
	                },
	                {
	                    "expected":"ReplicationGroupNotFoundFault",
	                    "matcher":"error",
	                    "state":"success"
	                }
	            ],
	            "delay":15,
	            "description":"Wait until ElastiCache replication group is deleted.",
	            "maxAttempts":40,
	            "operation":"DescribeReplicationGroups"
	        }
	    }
	}
	
	},{}],91:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2010-12-01",
	    "endpointPrefix": "elasticbeanstalk",
	    "protocol": "query",
	    "serviceAbbreviation": "Elastic Beanstalk",
	    "serviceFullName": "AWS Elastic Beanstalk",
	    "serviceId": "Elastic Beanstalk",
	    "signatureVersion": "v4",
	    "uid": "elasticbeanstalk-2010-12-01",
	    "xmlNamespace": "http://elasticbeanstalk.amazonaws.com/docs/2010-12-01/"
	  },
	  "operations": {
	    "AbortEnvironmentUpdate": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EnvironmentId": {},
	          "EnvironmentName": {}
	        }
	      }
	    },
	    "ApplyEnvironmentManagedAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ActionId"
	        ],
	        "members": {
	          "EnvironmentName": {},
	          "EnvironmentId": {},
	          "ActionId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ApplyEnvironmentManagedActionResult",
	        "type": "structure",
	        "members": {
	          "ActionId": {},
	          "ActionDescription": {},
	          "ActionType": {},
	          "Status": {}
	        }
	      }
	    },
	    "AssociateEnvironmentOperationsRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EnvironmentName",
	          "OperationsRole"
	        ],
	        "members": {
	          "EnvironmentName": {},
	          "OperationsRole": {}
	        }
	      }
	    },
	    "CheckDNSAvailability": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CNAMEPrefix"
	        ],
	        "members": {
	          "CNAMEPrefix": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CheckDNSAvailabilityResult",
	        "type": "structure",
	        "members": {
	          "Available": {
	            "type": "boolean"
	          },
	          "FullyQualifiedCNAME": {}
	        }
	      }
	    },
	    "ComposeEnvironments": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ApplicationName": {},
	          "GroupName": {},
	          "VersionLabels": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "shape": "Sk",
	        "resultWrapper": "ComposeEnvironmentsResult"
	      }
	    },
	    "CreateApplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "Description": {},
	          "ResourceLifecycleConfig": {
	            "shape": "S19"
	          },
	          "Tags": {
	            "shape": "S1f"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1j",
	        "resultWrapper": "CreateApplicationResult"
	      }
	    },
	    "CreateApplicationVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName",
	          "VersionLabel"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "VersionLabel": {},
	          "Description": {},
	          "SourceBuildInformation": {
	            "shape": "S1p"
	          },
	          "SourceBundle": {
	            "shape": "S1t"
	          },
	          "BuildConfiguration": {
	            "type": "structure",
	            "required": [
	              "CodeBuildServiceRole",
	              "Image"
	            ],
	            "members": {
	              "ArtifactName": {},
	              "CodeBuildServiceRole": {},
	              "ComputeType": {},
	              "Image": {},
	              "TimeoutInMinutes": {
	                "type": "integer"
	              }
	            }
	          },
	          "AutoCreateApplication": {
	            "type": "boolean"
	          },
	          "Process": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S1f"
	          }
	        }
	      },
	      "output": {
	        "shape": "S21",
	        "resultWrapper": "CreateApplicationVersionResult"
	      }
	    },
	    "CreateConfigurationTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName",
	          "TemplateName"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "TemplateName": {},
	          "SolutionStackName": {},
	          "PlatformArn": {},
	          "SourceConfiguration": {
	            "type": "structure",
	            "members": {
	              "ApplicationName": {},
	              "TemplateName": {}
	            }
	          },
	          "EnvironmentId": {},
	          "Description": {},
	          "OptionSettings": {
	            "shape": "S27"
	          },
	          "Tags": {
	            "shape": "S1f"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2d",
	        "resultWrapper": "CreateConfigurationTemplateResult"
	      }
	    },
	    "CreateEnvironment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "EnvironmentName": {},
	          "GroupName": {},
	          "Description": {},
	          "CNAMEPrefix": {},
	          "Tier": {
	            "shape": "S13"
	          },
	          "Tags": {
	            "shape": "S1f"
	          },
	          "VersionLabel": {},
	          "TemplateName": {},
	          "SolutionStackName": {},
	          "PlatformArn": {},
	          "OptionSettings": {
	            "shape": "S27"
	          },
	          "OptionsToRemove": {
	            "shape": "S2g"
	          },
	          "OperationsRole": {}
	        }
	      },
	      "output": {
	        "shape": "Sm",
	        "resultWrapper": "CreateEnvironmentResult"
	      }
	    },
	    "CreatePlatformVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlatformName",
	          "PlatformVersion",
	          "PlatformDefinitionBundle"
	        ],
	        "members": {
	          "PlatformName": {},
	          "PlatformVersion": {},
	          "PlatformDefinitionBundle": {
	            "shape": "S1t"
	          },
	          "EnvironmentName": {},
	          "OptionSettings": {
	            "shape": "S27"
	          },
	          "Tags": {
	            "shape": "S1f"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreatePlatformVersionResult",
	        "type": "structure",
	        "members": {
	          "PlatformSummary": {
	            "shape": "S2m"
	          },
	          "Builder": {
	            "type": "structure",
	            "members": {
	              "ARN": {}
	            }
	          }
	        }
	      }
	    },
	    "CreateStorageLocation": {
	      "output": {
	        "resultWrapper": "CreateStorageLocationResult",
	        "type": "structure",
	        "members": {
	          "S3Bucket": {}
	        }
	      }
	    },
	    "DeleteApplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "TerminateEnvByForce": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteApplicationVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName",
	          "VersionLabel"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "VersionLabel": {},
	          "DeleteSourceBundle": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteConfigurationTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName",
	          "TemplateName"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "TemplateName": {}
	        }
	      }
	    },
	    "DeleteEnvironmentConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName",
	          "EnvironmentName"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "EnvironmentName": {}
	        }
	      }
	    },
	    "DeletePlatformVersion": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PlatformArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeletePlatformVersionResult",
	        "type": "structure",
	        "members": {
	          "PlatformSummary": {
	            "shape": "S2m"
	          }
	        }
	      }
	    },
	    "DescribeAccountAttributes": {
	      "output": {
	        "resultWrapper": "DescribeAccountAttributesResult",
	        "type": "structure",
	        "members": {
	          "ResourceQuotas": {
	            "type": "structure",
	            "members": {
	              "ApplicationQuota": {
	                "shape": "S3c"
	              },
	              "ApplicationVersionQuota": {
	                "shape": "S3c"
	              },
	              "EnvironmentQuota": {
	                "shape": "S3c"
	              },
	              "ConfigurationTemplateQuota": {
	                "shape": "S3c"
	              },
	              "CustomPlatformQuota": {
	                "shape": "S3c"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeApplicationVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ApplicationName": {},
	          "VersionLabels": {
	            "shape": "S1m"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeApplicationVersionsResult",
	        "type": "structure",
	        "members": {
	          "ApplicationVersions": {
	            "type": "list",
	            "member": {
	              "shape": "S22"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeApplications": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ApplicationNames": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeApplicationsResult",
	        "type": "structure",
	        "members": {
	          "Applications": {
	            "type": "list",
	            "member": {
	              "shape": "S1k"
	            }
	          }
	        }
	      }
	    },
	    "DescribeConfigurationOptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ApplicationName": {},
	          "TemplateName": {},
	          "EnvironmentName": {},
	          "SolutionStackName": {},
	          "PlatformArn": {},
	          "Options": {
	            "shape": "S2g"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeConfigurationOptionsResult",
	        "type": "structure",
	        "members": {
	          "SolutionStackName": {},
	          "PlatformArn": {},
	          "Options": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Namespace": {},
	                "Name": {},
	                "DefaultValue": {},
	                "ChangeSeverity": {},
	                "UserDefined": {
	                  "type": "boolean"
	                },
	                "ValueType": {},
	                "ValueOptions": {
	                  "type": "list",
	                  "member": {}
	                },
	                "MinValue": {
	                  "type": "integer"
	                },
	                "MaxValue": {
	                  "type": "integer"
	                },
	                "MaxLength": {
	                  "type": "integer"
	                },
	                "Regex": {
	                  "type": "structure",
	                  "members": {
	                    "Pattern": {},
	                    "Label": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeConfigurationSettings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "TemplateName": {},
	          "EnvironmentName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeConfigurationSettingsResult",
	        "type": "structure",
	        "members": {
	          "ConfigurationSettings": {
	            "type": "list",
	            "member": {
	              "shape": "S2d"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEnvironmentHealth": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EnvironmentName": {},
	          "EnvironmentId": {},
	          "AttributeNames": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEnvironmentHealthResult",
	        "type": "structure",
	        "members": {
	          "EnvironmentName": {},
	          "HealthStatus": {},
	          "Status": {},
	          "Color": {},
	          "Causes": {
	            "shape": "S48"
	          },
	          "ApplicationMetrics": {
	            "shape": "S4a"
	          },
	          "InstancesHealth": {
	            "type": "structure",
	            "members": {
	              "NoData": {
	                "type": "integer"
	              },
	              "Unknown": {
	                "type": "integer"
	              },
	              "Pending": {
	                "type": "integer"
	              },
	              "Ok": {
	                "type": "integer"
	              },
	              "Info": {
	                "type": "integer"
	              },
	              "Warning": {
	                "type": "integer"
	              },
	              "Degraded": {
	                "type": "integer"
	              },
	              "Severe": {
	                "type": "integer"
	              }
	            }
	          },
	          "RefreshedAt": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeEnvironmentManagedActionHistory": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EnvironmentId": {},
	          "EnvironmentName": {},
	          "NextToken": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEnvironmentManagedActionHistoryResult",
	        "type": "structure",
	        "members": {
	          "ManagedActionHistoryItems": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ActionId": {},
	                "ActionType": {},
	                "ActionDescription": {},
	                "FailureType": {},
	                "Status": {},
	                "FailureDescription": {},
	                "ExecutedTime": {
	                  "type": "timestamp"
	                },
	                "FinishedTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeEnvironmentManagedActions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EnvironmentName": {},
	          "EnvironmentId": {},
	          "Status": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEnvironmentManagedActionsResult",
	        "type": "structure",
	        "members": {
	          "ManagedActions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ActionId": {},
	                "ActionDescription": {},
	                "ActionType": {},
	                "Status": {},
	                "WindowStartTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeEnvironmentResources": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EnvironmentId": {},
	          "EnvironmentName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEnvironmentResourcesResult",
	        "type": "structure",
	        "members": {
	          "EnvironmentResources": {
	            "type": "structure",
	            "members": {
	              "EnvironmentName": {},
	              "AutoScalingGroups": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {}
	                  }
	                }
	              },
	              "Instances": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Id": {}
	                  }
	                }
	              },
	              "LaunchConfigurations": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {}
	                  }
	                }
	              },
	              "LaunchTemplates": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Id": {}
	                  }
	                }
	              },
	              "LoadBalancers": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {}
	                  }
	                }
	              },
	              "Triggers": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {}
	                  }
	                }
	              },
	              "Queues": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {},
	                    "URL": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeEnvironments": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ApplicationName": {},
	          "VersionLabel": {},
	          "EnvironmentIds": {
	            "type": "list",
	            "member": {}
	          },
	          "EnvironmentNames": {
	            "type": "list",
	            "member": {}
	          },
	          "IncludeDeleted": {
	            "type": "boolean"
	          },
	          "IncludedDeletedBackTo": {
	            "type": "timestamp"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "shape": "Sk",
	        "resultWrapper": "DescribeEnvironmentsResult"
	      }
	    },
	    "DescribeEvents": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ApplicationName": {},
	          "VersionLabel": {},
	          "TemplateName": {},
	          "EnvironmentId": {},
	          "EnvironmentName": {},
	          "PlatformArn": {},
	          "RequestId": {},
	          "Severity": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventsResult",
	        "type": "structure",
	        "members": {
	          "Events": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EventDate": {
	                  "type": "timestamp"
	                },
	                "Message": {},
	                "ApplicationName": {},
	                "VersionLabel": {},
	                "TemplateName": {},
	                "EnvironmentName": {},
	                "PlatformArn": {},
	                "RequestId": {},
	                "Severity": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeInstancesHealth": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EnvironmentName": {},
	          "EnvironmentId": {},
	          "AttributeNames": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeInstancesHealthResult",
	        "type": "structure",
	        "members": {
	          "InstanceHealthList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "InstanceId": {},
	                "HealthStatus": {},
	                "Color": {},
	                "Causes": {
	                  "shape": "S48"
	                },
	                "LaunchedAt": {
	                  "type": "timestamp"
	                },
	                "ApplicationMetrics": {
	                  "shape": "S4a"
	                },
	                "System": {
	                  "type": "structure",
	                  "members": {
	                    "CPUUtilization": {
	                      "type": "structure",
	                      "members": {
	                        "User": {
	                          "type": "double"
	                        },
	                        "Nice": {
	                          "type": "double"
	                        },
	                        "System": {
	                          "type": "double"
	                        },
	                        "Idle": {
	                          "type": "double"
	                        },
	                        "IOWait": {
	                          "type": "double"
	                        },
	                        "IRQ": {
	                          "type": "double"
	                        },
	                        "SoftIRQ": {
	                          "type": "double"
	                        },
	                        "Privileged": {
	                          "type": "double"
	                        }
	                      }
	                    },
	                    "LoadAverage": {
	                      "type": "list",
	                      "member": {
	                        "type": "double"
	                      }
	                    }
	                  }
	                },
	                "Deployment": {
	                  "type": "structure",
	                  "members": {
	                    "VersionLabel": {},
	                    "DeploymentId": {
	                      "type": "long"
	                    },
	                    "Status": {},
	                    "DeploymentTime": {
	                      "type": "timestamp"
	                    }
	                  }
	                },
	                "AvailabilityZone": {},
	                "InstanceType": {}
	              }
	            }
	          },
	          "RefreshedAt": {
	            "type": "timestamp"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribePlatformVersion": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PlatformArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribePlatformVersionResult",
	        "type": "structure",
	        "members": {
	          "PlatformDescription": {
	            "type": "structure",
	            "members": {
	              "PlatformArn": {},
	              "PlatformOwner": {},
	              "PlatformName": {},
	              "PlatformVersion": {},
	              "SolutionStackName": {},
	              "PlatformStatus": {},
	              "DateCreated": {
	                "type": "timestamp"
	              },
	              "DateUpdated": {
	                "type": "timestamp"
	              },
	              "PlatformCategory": {},
	              "Description": {},
	              "Maintainer": {},
	              "OperatingSystemName": {},
	              "OperatingSystemVersion": {},
	              "ProgrammingLanguages": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {},
	                    "Version": {}
	                  }
	                }
	              },
	              "Frameworks": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {},
	                    "Version": {}
	                  }
	                }
	              },
	              "CustomAmiList": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "VirtualizationType": {},
	                    "ImageId": {}
	                  }
	                }
	              },
	              "SupportedTierList": {
	                "shape": "S2s"
	              },
	              "SupportedAddonList": {
	                "shape": "S2u"
	              },
	              "PlatformLifecycleState": {},
	              "PlatformBranchName": {},
	              "PlatformBranchLifecycleState": {}
	            }
	          }
	        }
	      }
	    },
	    "DisassociateEnvironmentOperationsRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EnvironmentName"
	        ],
	        "members": {
	          "EnvironmentName": {}
	        }
	      }
	    },
	    "ListAvailableSolutionStacks": {
	      "output": {
	        "resultWrapper": "ListAvailableSolutionStacksResult",
	        "type": "structure",
	        "members": {
	          "SolutionStacks": {
	            "type": "list",
	            "member": {}
	          },
	          "SolutionStackDetails": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "SolutionStackName": {},
	                "PermittedFileTypes": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListPlatformBranches": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Attribute": {},
	                "Operator": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListPlatformBranchesResult",
	        "type": "structure",
	        "members": {
	          "PlatformBranchSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PlatformName": {},
	                "BranchName": {},
	                "LifecycleState": {},
	                "BranchOrder": {
	                  "type": "integer"
	                },
	                "SupportedTierList": {
	                  "shape": "S2s"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListPlatformVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Type": {},
	                "Operator": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListPlatformVersionsResult",
	        "type": "structure",
	        "members": {
	          "PlatformSummaryList": {
	            "type": "list",
	            "member": {
	              "shape": "S2m"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTagsForResourceResult",
	        "type": "structure",
	        "members": {
	          "ResourceArn": {},
	          "ResourceTags": {
	            "shape": "S7g"
	          }
	        }
	      }
	    },
	    "RebuildEnvironment": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EnvironmentId": {},
	          "EnvironmentName": {}
	        }
	      }
	    },
	    "RequestEnvironmentInfo": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InfoType"
	        ],
	        "members": {
	          "EnvironmentId": {},
	          "EnvironmentName": {},
	          "InfoType": {}
	        }
	      }
	    },
	    "RestartAppServer": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EnvironmentId": {},
	          "EnvironmentName": {}
	        }
	      }
	    },
	    "RetrieveEnvironmentInfo": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InfoType"
	        ],
	        "members": {
	          "EnvironmentId": {},
	          "EnvironmentName": {},
	          "InfoType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RetrieveEnvironmentInfoResult",
	        "type": "structure",
	        "members": {
	          "EnvironmentInfo": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "InfoType": {},
	                "Ec2InstanceId": {},
	                "SampleTimestamp": {
	                  "type": "timestamp"
	                },
	                "Message": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "SwapEnvironmentCNAMEs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceEnvironmentId": {},
	          "SourceEnvironmentName": {},
	          "DestinationEnvironmentId": {},
	          "DestinationEnvironmentName": {}
	        }
	      }
	    },
	    "TerminateEnvironment": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EnvironmentId": {},
	          "EnvironmentName": {},
	          "TerminateResources": {
	            "type": "boolean"
	          },
	          "ForceTerminate": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sm",
	        "resultWrapper": "TerminateEnvironmentResult"
	      }
	    },
	    "UpdateApplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "Description": {}
	        }
	      },
	      "output": {
	        "shape": "S1j",
	        "resultWrapper": "UpdateApplicationResult"
	      }
	    },
	    "UpdateApplicationResourceLifecycle": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName",
	          "ResourceLifecycleConfig"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "ResourceLifecycleConfig": {
	            "shape": "S19"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateApplicationResourceLifecycleResult",
	        "type": "structure",
	        "members": {
	          "ApplicationName": {},
	          "ResourceLifecycleConfig": {
	            "shape": "S19"
	          }
	        }
	      }
	    },
	    "UpdateApplicationVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName",
	          "VersionLabel"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "VersionLabel": {},
	          "Description": {}
	        }
	      },
	      "output": {
	        "shape": "S21",
	        "resultWrapper": "UpdateApplicationVersionResult"
	      }
	    },
	    "UpdateConfigurationTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName",
	          "TemplateName"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "TemplateName": {},
	          "Description": {},
	          "OptionSettings": {
	            "shape": "S27"
	          },
	          "OptionsToRemove": {
	            "shape": "S2g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2d",
	        "resultWrapper": "UpdateConfigurationTemplateResult"
	      }
	    },
	    "UpdateEnvironment": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ApplicationName": {},
	          "EnvironmentId": {},
	          "EnvironmentName": {},
	          "GroupName": {},
	          "Description": {},
	          "Tier": {
	            "shape": "S13"
	          },
	          "VersionLabel": {},
	          "TemplateName": {},
	          "SolutionStackName": {},
	          "PlatformArn": {},
	          "OptionSettings": {
	            "shape": "S27"
	          },
	          "OptionsToRemove": {
	            "shape": "S2g"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sm",
	        "resultWrapper": "UpdateEnvironmentResult"
	      }
	    },
	    "UpdateTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagsToAdd": {
	            "shape": "S7g"
	          },
	          "TagsToRemove": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "ValidateConfigurationSettings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ApplicationName",
	          "OptionSettings"
	        ],
	        "members": {
	          "ApplicationName": {},
	          "TemplateName": {},
	          "EnvironmentName": {},
	          "OptionSettings": {
	            "shape": "S27"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ValidateConfigurationSettingsResult",
	        "type": "structure",
	        "members": {
	          "Messages": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Message": {},
	                "Severity": {},
	                "Namespace": {},
	                "OptionName": {}
	              }
	            }
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sk": {
	      "type": "structure",
	      "members": {
	        "Environments": {
	          "type": "list",
	          "member": {
	            "shape": "Sm"
	          }
	        },
	        "NextToken": {}
	      }
	    },
	    "Sm": {
	      "type": "structure",
	      "members": {
	        "EnvironmentName": {},
	        "EnvironmentId": {},
	        "ApplicationName": {},
	        "VersionLabel": {},
	        "SolutionStackName": {},
	        "PlatformArn": {},
	        "TemplateName": {},
	        "Description": {},
	        "EndpointURL": {},
	        "CNAME": {},
	        "DateCreated": {
	          "type": "timestamp"
	        },
	        "DateUpdated": {
	          "type": "timestamp"
	        },
	        "Status": {},
	        "AbortableOperationInProgress": {
	          "type": "boolean"
	        },
	        "Health": {},
	        "HealthStatus": {},
	        "Resources": {
	          "type": "structure",
	          "members": {
	            "LoadBalancer": {
	              "type": "structure",
	              "members": {
	                "LoadBalancerName": {},
	                "Domain": {},
	                "Listeners": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Protocol": {},
	                      "Port": {
	                        "type": "integer"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "Tier": {
	          "shape": "S13"
	        },
	        "EnvironmentLinks": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "LinkName": {},
	              "EnvironmentName": {}
	            }
	          }
	        },
	        "EnvironmentArn": {},
	        "OperationsRole": {}
	      }
	    },
	    "S13": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Type": {},
	        "Version": {}
	      }
	    },
	    "S19": {
	      "type": "structure",
	      "members": {
	        "ServiceRole": {},
	        "VersionLifecycleConfig": {
	          "type": "structure",
	          "members": {
	            "MaxCountRule": {
	              "type": "structure",
	              "required": [
	                "Enabled"
	              ],
	              "members": {
	                "Enabled": {
	                  "type": "boolean"
	                },
	                "MaxCount": {
	                  "type": "integer"
	                },
	                "DeleteSourceFromS3": {
	                  "type": "boolean"
	                }
	              }
	            },
	            "MaxAgeRule": {
	              "type": "structure",
	              "required": [
	                "Enabled"
	              ],
	              "members": {
	                "Enabled": {
	                  "type": "boolean"
	                },
	                "MaxAgeInDays": {
	                  "type": "integer"
	                },
	                "DeleteSourceFromS3": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1f": {
	      "type": "list",
	      "member": {
	        "shape": "S1g"
	      }
	    },
	    "S1g": {
	      "type": "structure",
	      "members": {
	        "Key": {},
	        "Value": {}
	      }
	    },
	    "S1j": {
	      "type": "structure",
	      "members": {
	        "Application": {
	          "shape": "S1k"
	        }
	      }
	    },
	    "S1k": {
	      "type": "structure",
	      "members": {
	        "ApplicationArn": {},
	        "ApplicationName": {},
	        "Description": {},
	        "DateCreated": {
	          "type": "timestamp"
	        },
	        "DateUpdated": {
	          "type": "timestamp"
	        },
	        "Versions": {
	          "shape": "S1m"
	        },
	        "ConfigurationTemplates": {
	          "type": "list",
	          "member": {}
	        },
	        "ResourceLifecycleConfig": {
	          "shape": "S19"
	        }
	      }
	    },
	    "S1m": {
	      "type": "list",
	      "member": {}
	    },
	    "S1p": {
	      "type": "structure",
	      "required": [
	        "SourceType",
	        "SourceRepository",
	        "SourceLocation"
	      ],
	      "members": {
	        "SourceType": {},
	        "SourceRepository": {},
	        "SourceLocation": {}
	      }
	    },
	    "S1t": {
	      "type": "structure",
	      "members": {
	        "S3Bucket": {},
	        "S3Key": {}
	      }
	    },
	    "S21": {
	      "type": "structure",
	      "members": {
	        "ApplicationVersion": {
	          "shape": "S22"
	        }
	      }
	    },
	    "S22": {
	      "type": "structure",
	      "members": {
	        "ApplicationVersionArn": {},
	        "ApplicationName": {},
	        "Description": {},
	        "VersionLabel": {},
	        "SourceBuildInformation": {
	          "shape": "S1p"
	        },
	        "BuildArn": {},
	        "SourceBundle": {
	          "shape": "S1t"
	        },
	        "DateCreated": {
	          "type": "timestamp"
	        },
	        "DateUpdated": {
	          "type": "timestamp"
	        },
	        "Status": {}
	      }
	    },
	    "S27": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ResourceName": {},
	          "Namespace": {},
	          "OptionName": {},
	          "Value": {}
	        }
	      }
	    },
	    "S2d": {
	      "type": "structure",
	      "members": {
	        "SolutionStackName": {},
	        "PlatformArn": {},
	        "ApplicationName": {},
	        "TemplateName": {},
	        "Description": {},
	        "EnvironmentName": {},
	        "DeploymentStatus": {},
	        "DateCreated": {
	          "type": "timestamp"
	        },
	        "DateUpdated": {
	          "type": "timestamp"
	        },
	        "OptionSettings": {
	          "shape": "S27"
	        }
	      }
	    },
	    "S2g": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ResourceName": {},
	          "Namespace": {},
	          "OptionName": {}
	        }
	      }
	    },
	    "S2m": {
	      "type": "structure",
	      "members": {
	        "PlatformArn": {},
	        "PlatformOwner": {},
	        "PlatformStatus": {},
	        "PlatformCategory": {},
	        "OperatingSystemName": {},
	        "OperatingSystemVersion": {},
	        "SupportedTierList": {
	          "shape": "S2s"
	        },
	        "SupportedAddonList": {
	          "shape": "S2u"
	        },
	        "PlatformLifecycleState": {},
	        "PlatformVersion": {},
	        "PlatformBranchName": {},
	        "PlatformBranchLifecycleState": {}
	      }
	    },
	    "S2s": {
	      "type": "list",
	      "member": {}
	    },
	    "S2u": {
	      "type": "list",
	      "member": {}
	    },
	    "S3c": {
	      "type": "structure",
	      "members": {
	        "Maximum": {
	          "type": "integer"
	        }
	      }
	    },
	    "S48": {
	      "type": "list",
	      "member": {}
	    },
	    "S4a": {
	      "type": "structure",
	      "members": {
	        "Duration": {
	          "type": "integer"
	        },
	        "RequestCount": {
	          "type": "integer"
	        },
	        "StatusCodes": {
	          "type": "structure",
	          "members": {
	            "Status2xx": {
	              "type": "integer"
	            },
	            "Status3xx": {
	              "type": "integer"
	            },
	            "Status4xx": {
	              "type": "integer"
	            },
	            "Status5xx": {
	              "type": "integer"
	            }
	          }
	        },
	        "Latency": {
	          "type": "structure",
	          "members": {
	            "P999": {
	              "type": "double"
	            },
	            "P99": {
	              "type": "double"
	            },
	            "P95": {
	              "type": "double"
	            },
	            "P90": {
	              "type": "double"
	            },
	            "P85": {
	              "type": "double"
	            },
	            "P75": {
	              "type": "double"
	            },
	            "P50": {
	              "type": "double"
	            },
	            "P10": {
	              "type": "double"
	            }
	          }
	        }
	      }
	    },
	    "S7g": {
	      "type": "list",
	      "member": {
	        "shape": "S1g"
	      }
	    }
	  }
	}
	},{}],92:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeApplicationVersions": {
	      "result_key": "ApplicationVersions"
	    },
	    "DescribeApplications": {
	      "result_key": "Applications"
	    },
	    "DescribeConfigurationOptions": {
	      "result_key": "Options"
	    },
	    "DescribeEnvironmentManagedActionHistory": {
	      "input_token": "NextToken",
	      "limit_key": "MaxItems",
	      "output_token": "NextToken",
	      "result_key": "ManagedActionHistoryItems"
	    },
	    "DescribeEnvironments": {
	      "result_key": "Environments"
	    },
	    "DescribeEvents": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": "Events"
	    },
	    "ListAvailableSolutionStacks": {
	      "result_key": "SolutionStacks"
	    },
	    "ListPlatformBranches": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken"
	    },
	    "ListPlatformVersions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": "PlatformSummaryList"
	    }
	  }
	}
	},{}],93:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "EnvironmentExists": {
	      "delay": 20,
	      "maxAttempts": 20,
	      "operation": "DescribeEnvironments",
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "Environments[].Status",
	          "expected": "Ready"
	        },
	        {
	          "state": "retry",
	          "matcher": "pathAll",
	          "argument": "Environments[].Status",
	          "expected": "Launching"
	        }
	      ]
	    },
	    "EnvironmentUpdated": {
	      "delay": 20,
	      "maxAttempts": 20,
	      "operation": "DescribeEnvironments",
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "Environments[].Status",
	          "expected": "Ready"
	        },
	        {
	          "state": "retry",
	          "matcher": "pathAll",
	          "argument": "Environments[].Status",
	          "expected": "Updating"
	        }
	      ]
	    },
	    "EnvironmentTerminated": {
	      "delay": 20,
	      "maxAttempts": 20,
	      "operation": "DescribeEnvironments",
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "Environments[].Status",
	          "expected": "Terminated"
	        },
	        {
	          "state": "retry",
	          "matcher": "pathAll",
	          "argument": "Environments[].Status",
	          "expected": "Terminating"
	        }
	      ]
	    }
	  }
	}
	
	
	},{}],94:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-02-01",
	    "endpointPrefix": "elasticfilesystem",
	    "protocol": "rest-json",
	    "serviceAbbreviation": "EFS",
	    "serviceFullName": "Amazon Elastic File System",
	    "serviceId": "EFS",
	    "signatureVersion": "v4",
	    "uid": "elasticfilesystem-2015-02-01"
	  },
	  "operations": {
	    "CreateAccessPoint": {
	      "http": {
	        "requestUri": "/2015-02-01/access-points",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientToken",
	          "FileSystemId"
	        ],
	        "members": {
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "Tags": {
	            "shape": "S3"
	          },
	          "FileSystemId": {},
	          "PosixUser": {
	            "shape": "S8"
	          },
	          "RootDirectory": {
	            "shape": "Sc"
	          }
	        }
	      },
	      "output": {
	        "shape": "Si"
	      }
	    },
	    "CreateFileSystem": {
	      "http": {
	        "requestUri": "/2015-02-01/file-systems",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CreationToken"
	        ],
	        "members": {
	          "CreationToken": {
	            "idempotencyToken": true
	          },
	          "PerformanceMode": {},
	          "Encrypted": {
	            "type": "boolean"
	          },
	          "KmsKeyId": {},
	          "ThroughputMode": {},
	          "ProvisionedThroughputInMibps": {
	            "type": "double"
	          },
	          "AvailabilityZoneName": {},
	          "Backup": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sx"
	      }
	    },
	    "CreateMountTarget": {
	      "http": {
	        "requestUri": "/2015-02-01/mount-targets",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId",
	          "SubnetId"
	        ],
	        "members": {
	          "FileSystemId": {},
	          "SubnetId": {},
	          "IpAddress": {},
	          "SecurityGroups": {
	            "shape": "S18"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1a"
	      }
	    },
	    "CreateReplicationConfiguration": {
	      "http": {
	        "requestUri": "/2015-02-01/file-systems/{SourceFileSystemId}/replication-configuration",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceFileSystemId",
	          "Destinations"
	        ],
	        "members": {
	          "SourceFileSystemId": {
	            "location": "uri",
	            "locationName": "SourceFileSystemId"
	          },
	          "Destinations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Region": {},
	                "AvailabilityZoneName": {},
	                "KmsKeyId": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "shape": "S1i"
	      }
	    },
	    "CreateTags": {
	      "http": {
	        "requestUri": "/2015-02-01/create-tags/{FileSystemId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId",
	          "Tags"
	        ],
	        "members": {
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          },
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      },
	      "deprecated": true,
	      "deprecatedMessage": "Use TagResource."
	    },
	    "DeleteAccessPoint": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2015-02-01/access-points/{AccessPointId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessPointId"
	        ],
	        "members": {
	          "AccessPointId": {
	            "location": "uri",
	            "locationName": "AccessPointId"
	          }
	        }
	      }
	    },
	    "DeleteFileSystem": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2015-02-01/file-systems/{FileSystemId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId"
	        ],
	        "members": {
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          }
	        }
	      }
	    },
	    "DeleteFileSystemPolicy": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2015-02-01/file-systems/{FileSystemId}/policy",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId"
	        ],
	        "members": {
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          }
	        }
	      }
	    },
	    "DeleteMountTarget": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2015-02-01/mount-targets/{MountTargetId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "MountTargetId"
	        ],
	        "members": {
	          "MountTargetId": {
	            "location": "uri",
	            "locationName": "MountTargetId"
	          }
	        }
	      }
	    },
	    "DeleteReplicationConfiguration": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2015-02-01/file-systems/{SourceFileSystemId}/replication-configuration",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceFileSystemId"
	        ],
	        "members": {
	          "SourceFileSystemId": {
	            "location": "uri",
	            "locationName": "SourceFileSystemId"
	          }
	        }
	      }
	    },
	    "DeleteTags": {
	      "http": {
	        "requestUri": "/2015-02-01/delete-tags/{FileSystemId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId",
	          "TagKeys"
	        ],
	        "members": {
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          },
	          "TagKeys": {
	            "shape": "S1t"
	          }
	        }
	      },
	      "deprecated": true,
	      "deprecatedMessage": "Use UntagResource."
	    },
	    "DescribeAccessPoints": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-02-01/access-points",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "MaxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "NextToken"
	          },
	          "AccessPointId": {
	            "location": "querystring",
	            "locationName": "AccessPointId"
	          },
	          "FileSystemId": {
	            "location": "querystring",
	            "locationName": "FileSystemId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AccessPoints": {
	            "type": "list",
	            "member": {
	              "shape": "Si"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAccountPreferences": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-02-01/account-preferences",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceIdPreference": {
	            "shape": "S21"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeBackupPolicy": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-02-01/file-systems/{FileSystemId}/backup-policy",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId"
	        ],
	        "members": {
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          }
	        }
	      },
	      "output": {
	        "shape": "S26"
	      }
	    },
	    "DescribeFileSystemPolicy": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-02-01/file-systems/{FileSystemId}/policy",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId"
	        ],
	        "members": {
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2a"
	      }
	    },
	    "DescribeFileSystems": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-02-01/file-systems",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "CreationToken": {
	            "location": "querystring",
	            "locationName": "CreationToken"
	          },
	          "FileSystemId": {
	            "location": "querystring",
	            "locationName": "FileSystemId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "FileSystems": {
	            "type": "list",
	            "member": {
	              "shape": "Sx"
	            }
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "DescribeLifecycleConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId"
	        ],
	        "members": {
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2i"
	      }
	    },
	    "DescribeMountTargetSecurityGroups": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-02-01/mount-targets/{MountTargetId}/security-groups",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "MountTargetId"
	        ],
	        "members": {
	          "MountTargetId": {
	            "location": "uri",
	            "locationName": "MountTargetId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "SecurityGroups"
	        ],
	        "members": {
	          "SecurityGroups": {
	            "shape": "S18"
	          }
	        }
	      }
	    },
	    "DescribeMountTargets": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-02-01/mount-targets",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "FileSystemId": {
	            "location": "querystring",
	            "locationName": "FileSystemId"
	          },
	          "MountTargetId": {
	            "location": "querystring",
	            "locationName": "MountTargetId"
	          },
	          "AccessPointId": {
	            "location": "querystring",
	            "locationName": "AccessPointId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "MountTargets": {
	            "type": "list",
	            "member": {
	              "shape": "S1a"
	            }
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "DescribeReplicationConfigurations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-02-01/file-systems/replication-configurations",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "FileSystemId": {
	            "location": "querystring",
	            "locationName": "FileSystemId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "NextToken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "MaxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Replications": {
	            "type": "list",
	            "member": {
	              "shape": "S1i"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeTags": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-02-01/tags/{FileSystemId}/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId"
	        ],
	        "members": {
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Marker": {},
	          "Tags": {
	            "shape": "S3"
	          },
	          "NextMarker": {}
	        }
	      },
	      "deprecated": true,
	      "deprecatedMessage": "Use ListTagsForResource."
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-02-01/resource-tags/{ResourceId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId"
	        ],
	        "members": {
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "MaxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "NextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S3"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ModifyMountTargetSecurityGroups": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2015-02-01/mount-targets/{MountTargetId}/security-groups",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "MountTargetId"
	        ],
	        "members": {
	          "MountTargetId": {
	            "location": "uri",
	            "locationName": "MountTargetId"
	          },
	          "SecurityGroups": {
	            "shape": "S18"
	          }
	        }
	      }
	    },
	    "PutAccountPreferences": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2015-02-01/account-preferences",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceIdType"
	        ],
	        "members": {
	          "ResourceIdType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceIdPreference": {
	            "shape": "S21"
	          }
	        }
	      }
	    },
	    "PutBackupPolicy": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2015-02-01/file-systems/{FileSystemId}/backup-policy",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId",
	          "BackupPolicy"
	        ],
	        "members": {
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          },
	          "BackupPolicy": {
	            "shape": "S27"
	          }
	        }
	      },
	      "output": {
	        "shape": "S26"
	      }
	    },
	    "PutFileSystemPolicy": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2015-02-01/file-systems/{FileSystemId}/policy",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId",
	          "Policy"
	        ],
	        "members": {
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          },
	          "Policy": {},
	          "BypassPolicyLockoutSafetyCheck": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2a"
	      }
	    },
	    "PutLifecycleConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId",
	          "LifecyclePolicies"
	        ],
	        "members": {
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          },
	          "LifecyclePolicies": {
	            "shape": "S2j"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2i"
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/2015-02-01/resource-tags/{ResourceId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "Tags"
	        ],
	        "members": {
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          },
	          "Tags": {
	            "shape": "S3"
	          }
	        }
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2015-02-01/resource-tags/{ResourceId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          },
	          "TagKeys": {
	            "shape": "S1t",
	            "location": "querystring",
	            "locationName": "tagKeys"
	          }
	        }
	      }
	    },
	    "UpdateFileSystem": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2015-02-01/file-systems/{FileSystemId}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemId"
	        ],
	        "members": {
	          "FileSystemId": {
	            "location": "uri",
	            "locationName": "FileSystemId"
	          },
	          "ThroughputMode": {},
	          "ProvisionedThroughputInMibps": {
	            "type": "double"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sx"
	      }
	    }
	  },
	  "shapes": {
	    "S3": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S8": {
	      "type": "structure",
	      "required": [
	        "Uid",
	        "Gid"
	      ],
	      "members": {
	        "Uid": {
	          "type": "long"
	        },
	        "Gid": {
	          "type": "long"
	        },
	        "SecondaryGids": {
	          "type": "list",
	          "member": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "Sc": {
	      "type": "structure",
	      "members": {
	        "Path": {},
	        "CreationInfo": {
	          "type": "structure",
	          "required": [
	            "OwnerUid",
	            "OwnerGid",
	            "Permissions"
	          ],
	          "members": {
	            "OwnerUid": {
	              "type": "long"
	            },
	            "OwnerGid": {
	              "type": "long"
	            },
	            "Permissions": {}
	          }
	        }
	      }
	    },
	    "Si": {
	      "type": "structure",
	      "members": {
	        "ClientToken": {},
	        "Name": {},
	        "Tags": {
	          "shape": "S3"
	        },
	        "AccessPointId": {},
	        "AccessPointArn": {},
	        "FileSystemId": {},
	        "PosixUser": {
	          "shape": "S8"
	        },
	        "RootDirectory": {
	          "shape": "Sc"
	        },
	        "OwnerId": {},
	        "LifeCycleState": {}
	      }
	    },
	    "Sx": {
	      "type": "structure",
	      "required": [
	        "OwnerId",
	        "CreationToken",
	        "FileSystemId",
	        "CreationTime",
	        "LifeCycleState",
	        "NumberOfMountTargets",
	        "SizeInBytes",
	        "PerformanceMode",
	        "Tags"
	      ],
	      "members": {
	        "OwnerId": {},
	        "CreationToken": {},
	        "FileSystemId": {},
	        "FileSystemArn": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "LifeCycleState": {},
	        "Name": {},
	        "NumberOfMountTargets": {
	          "type": "integer"
	        },
	        "SizeInBytes": {
	          "type": "structure",
	          "required": [
	            "Value"
	          ],
	          "members": {
	            "Value": {
	              "type": "long"
	            },
	            "Timestamp": {
	              "type": "timestamp"
	            },
	            "ValueInIA": {
	              "type": "long"
	            },
	            "ValueInStandard": {
	              "type": "long"
	            }
	          }
	        },
	        "PerformanceMode": {},
	        "Encrypted": {
	          "type": "boolean"
	        },
	        "KmsKeyId": {},
	        "ThroughputMode": {},
	        "ProvisionedThroughputInMibps": {
	          "type": "double"
	        },
	        "AvailabilityZoneName": {},
	        "AvailabilityZoneId": {},
	        "Tags": {
	          "shape": "S3"
	        }
	      }
	    },
	    "S18": {
	      "type": "list",
	      "member": {}
	    },
	    "S1a": {
	      "type": "structure",
	      "required": [
	        "MountTargetId",
	        "FileSystemId",
	        "SubnetId",
	        "LifeCycleState"
	      ],
	      "members": {
	        "OwnerId": {},
	        "MountTargetId": {},
	        "FileSystemId": {},
	        "SubnetId": {},
	        "LifeCycleState": {},
	        "IpAddress": {},
	        "NetworkInterfaceId": {},
	        "AvailabilityZoneId": {},
	        "AvailabilityZoneName": {},
	        "VpcId": {}
	      }
	    },
	    "S1i": {
	      "type": "structure",
	      "required": [
	        "SourceFileSystemId",
	        "SourceFileSystemRegion",
	        "SourceFileSystemArn",
	        "OriginalSourceFileSystemArn",
	        "CreationTime",
	        "Destinations"
	      ],
	      "members": {
	        "SourceFileSystemId": {},
	        "SourceFileSystemRegion": {},
	        "SourceFileSystemArn": {},
	        "OriginalSourceFileSystemArn": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "Destinations": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Status",
	              "FileSystemId",
	              "Region"
	            ],
	            "members": {
	              "Status": {},
	              "FileSystemId": {},
	              "Region": {},
	              "LastReplicatedTimestamp": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1t": {
	      "type": "list",
	      "member": {}
	    },
	    "S21": {
	      "type": "structure",
	      "members": {
	        "ResourceIdType": {},
	        "Resources": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S26": {
	      "type": "structure",
	      "members": {
	        "BackupPolicy": {
	          "shape": "S27"
	        }
	      }
	    },
	    "S27": {
	      "type": "structure",
	      "required": [
	        "Status"
	      ],
	      "members": {
	        "Status": {}
	      }
	    },
	    "S2a": {
	      "type": "structure",
	      "members": {
	        "FileSystemId": {},
	        "Policy": {}
	      }
	    },
	    "S2i": {
	      "type": "structure",
	      "members": {
	        "LifecyclePolicies": {
	          "shape": "S2j"
	        }
	      }
	    },
	    "S2j": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "TransitionToIA": {},
	          "TransitionToPrimaryStorageClass": {}
	        }
	      }
	    }
	  }
	}
	},{}],95:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeAccessPoints": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "DescribeFileSystems": {
	      "input_token": "Marker",
	      "output_token": "NextMarker",
	      "limit_key": "MaxItems"
	    },
	    "DescribeTags": {
	      "input_token": "Marker",
	      "output_token": "NextMarker",
	      "limit_key": "MaxItems"
	    },
	    "ListTagsForResource": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    }
	  }
	}
	
	},{}],96:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2012-06-01",
	    "endpointPrefix": "elasticloadbalancing",
	    "protocol": "query",
	    "serviceFullName": "Elastic Load Balancing",
	    "serviceId": "Elastic Load Balancing",
	    "signatureVersion": "v4",
	    "uid": "elasticloadbalancing-2012-06-01",
	    "xmlNamespace": "http://elasticloadbalancing.amazonaws.com/doc/2012-06-01/"
	  },
	  "operations": {
	    "AddTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerNames",
	          "Tags"
	        ],
	        "members": {
	          "LoadBalancerNames": {
	            "shape": "S2"
	          },
	          "Tags": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "AddTagsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ApplySecurityGroupsToLoadBalancer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "SecurityGroups"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "SecurityGroups": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ApplySecurityGroupsToLoadBalancerResult",
	        "type": "structure",
	        "members": {
	          "SecurityGroups": {
	            "shape": "Sa"
	          }
	        }
	      }
	    },
	    "AttachLoadBalancerToSubnets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "Subnets"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "Subnets": {
	            "shape": "Se"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "AttachLoadBalancerToSubnetsResult",
	        "type": "structure",
	        "members": {
	          "Subnets": {
	            "shape": "Se"
	          }
	        }
	      }
	    },
	    "ConfigureHealthCheck": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "HealthCheck"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "HealthCheck": {
	            "shape": "Si"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ConfigureHealthCheckResult",
	        "type": "structure",
	        "members": {
	          "HealthCheck": {
	            "shape": "Si"
	          }
	        }
	      }
	    },
	    "CreateAppCookieStickinessPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "PolicyName",
	          "CookieName"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "PolicyName": {},
	          "CookieName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateAppCookieStickinessPolicyResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateLBCookieStickinessPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "PolicyName"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "PolicyName": {},
	          "CookieExpirationPeriod": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateLBCookieStickinessPolicyResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateLoadBalancer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "Listeners"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "Listeners": {
	            "shape": "Sx"
	          },
	          "AvailabilityZones": {
	            "shape": "S13"
	          },
	          "Subnets": {
	            "shape": "Se"
	          },
	          "SecurityGroups": {
	            "shape": "Sa"
	          },
	          "Scheme": {},
	          "Tags": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateLoadBalancerResult",
	        "type": "structure",
	        "members": {
	          "DNSName": {}
	        }
	      }
	    },
	    "CreateLoadBalancerListeners": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "Listeners"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "Listeners": {
	            "shape": "Sx"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateLoadBalancerListenersResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateLoadBalancerPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "PolicyName",
	          "PolicyTypeName"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "PolicyName": {},
	          "PolicyTypeName": {},
	          "PolicyAttributes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AttributeName": {},
	                "AttributeValue": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateLoadBalancerPolicyResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteLoadBalancer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName"
	        ],
	        "members": {
	          "LoadBalancerName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteLoadBalancerResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteLoadBalancerListeners": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "LoadBalancerPorts"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "LoadBalancerPorts": {
	            "type": "list",
	            "member": {
	              "type": "integer"
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteLoadBalancerListenersResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteLoadBalancerPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "PolicyName"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "PolicyName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteLoadBalancerPolicyResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeregisterInstancesFromLoadBalancer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "Instances"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "Instances": {
	            "shape": "S1p"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeregisterInstancesFromLoadBalancerResult",
	        "type": "structure",
	        "members": {
	          "Instances": {
	            "shape": "S1p"
	          }
	        }
	      }
	    },
	    "DescribeAccountLimits": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeAccountLimitsResult",
	        "type": "structure",
	        "members": {
	          "Limits": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Max": {}
	              }
	            }
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "DescribeInstanceHealth": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "Instances": {
	            "shape": "S1p"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeInstanceHealthResult",
	        "type": "structure",
	        "members": {
	          "InstanceStates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "InstanceId": {},
	                "State": {},
	                "ReasonCode": {},
	                "Description": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeLoadBalancerAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName"
	        ],
	        "members": {
	          "LoadBalancerName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeLoadBalancerAttributesResult",
	        "type": "structure",
	        "members": {
	          "LoadBalancerAttributes": {
	            "shape": "S2a"
	          }
	        }
	      }
	    },
	    "DescribeLoadBalancerPolicies": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LoadBalancerName": {},
	          "PolicyNames": {
	            "shape": "S2s"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeLoadBalancerPoliciesResult",
	        "type": "structure",
	        "members": {
	          "PolicyDescriptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PolicyName": {},
	                "PolicyTypeName": {},
	                "PolicyAttributeDescriptions": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "AttributeName": {},
	                      "AttributeValue": {}
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeLoadBalancerPolicyTypes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PolicyTypeNames": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeLoadBalancerPolicyTypesResult",
	        "type": "structure",
	        "members": {
	          "PolicyTypeDescriptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PolicyTypeName": {},
	                "Description": {},
	                "PolicyAttributeTypeDescriptions": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "AttributeName": {},
	                      "AttributeType": {},
	                      "Description": {},
	                      "DefaultValue": {},
	                      "Cardinality": {}
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeLoadBalancers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LoadBalancerNames": {
	            "shape": "S2"
	          },
	          "Marker": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeLoadBalancersResult",
	        "type": "structure",
	        "members": {
	          "LoadBalancerDescriptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "LoadBalancerName": {},
	                "DNSName": {},
	                "CanonicalHostedZoneName": {},
	                "CanonicalHostedZoneNameID": {},
	                "ListenerDescriptions": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Listener": {
	                        "shape": "Sy"
	                      },
	                      "PolicyNames": {
	                        "shape": "S2s"
	                      }
	                    }
	                  }
	                },
	                "Policies": {
	                  "type": "structure",
	                  "members": {
	                    "AppCookieStickinessPolicies": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "members": {
	                          "PolicyName": {},
	                          "CookieName": {}
	                        }
	                      }
	                    },
	                    "LBCookieStickinessPolicies": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "members": {
	                          "PolicyName": {},
	                          "CookieExpirationPeriod": {
	                            "type": "long"
	                          }
	                        }
	                      }
	                    },
	                    "OtherPolicies": {
	                      "shape": "S2s"
	                    }
	                  }
	                },
	                "BackendServerDescriptions": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "InstancePort": {
	                        "type": "integer"
	                      },
	                      "PolicyNames": {
	                        "shape": "S2s"
	                      }
	                    }
	                  }
	                },
	                "AvailabilityZones": {
	                  "shape": "S13"
	                },
	                "Subnets": {
	                  "shape": "Se"
	                },
	                "VPCId": {},
	                "Instances": {
	                  "shape": "S1p"
	                },
	                "HealthCheck": {
	                  "shape": "Si"
	                },
	                "SourceSecurityGroup": {
	                  "type": "structure",
	                  "members": {
	                    "OwnerAlias": {},
	                    "GroupName": {}
	                  }
	                },
	                "SecurityGroups": {
	                  "shape": "Sa"
	                },
	                "CreatedTime": {
	                  "type": "timestamp"
	                },
	                "Scheme": {}
	              }
	            }
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "DescribeTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerNames"
	        ],
	        "members": {
	          "LoadBalancerNames": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeTagsResult",
	        "type": "structure",
	        "members": {
	          "TagDescriptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "LoadBalancerName": {},
	                "Tags": {
	                  "shape": "S4"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DetachLoadBalancerFromSubnets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "Subnets"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "Subnets": {
	            "shape": "Se"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DetachLoadBalancerFromSubnetsResult",
	        "type": "structure",
	        "members": {
	          "Subnets": {
	            "shape": "Se"
	          }
	        }
	      }
	    },
	    "DisableAvailabilityZonesForLoadBalancer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "AvailabilityZones"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "AvailabilityZones": {
	            "shape": "S13"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DisableAvailabilityZonesForLoadBalancerResult",
	        "type": "structure",
	        "members": {
	          "AvailabilityZones": {
	            "shape": "S13"
	          }
	        }
	      }
	    },
	    "EnableAvailabilityZonesForLoadBalancer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "AvailabilityZones"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "AvailabilityZones": {
	            "shape": "S13"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "EnableAvailabilityZonesForLoadBalancerResult",
	        "type": "structure",
	        "members": {
	          "AvailabilityZones": {
	            "shape": "S13"
	          }
	        }
	      }
	    },
	    "ModifyLoadBalancerAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "LoadBalancerAttributes"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "LoadBalancerAttributes": {
	            "shape": "S2a"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyLoadBalancerAttributesResult",
	        "type": "structure",
	        "members": {
	          "LoadBalancerName": {},
	          "LoadBalancerAttributes": {
	            "shape": "S2a"
	          }
	        }
	      }
	    },
	    "RegisterInstancesWithLoadBalancer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "Instances"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "Instances": {
	            "shape": "S1p"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RegisterInstancesWithLoadBalancerResult",
	        "type": "structure",
	        "members": {
	          "Instances": {
	            "shape": "S1p"
	          }
	        }
	      }
	    },
	    "RemoveTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerNames",
	          "Tags"
	        ],
	        "members": {
	          "LoadBalancerNames": {
	            "shape": "S2"
	          },
	          "Tags": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Key": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RemoveTagsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetLoadBalancerListenerSSLCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "LoadBalancerPort",
	          "SSLCertificateId"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "LoadBalancerPort": {
	            "type": "integer"
	          },
	          "SSLCertificateId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SetLoadBalancerListenerSSLCertificateResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetLoadBalancerPoliciesForBackendServer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "InstancePort",
	          "PolicyNames"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "InstancePort": {
	            "type": "integer"
	          },
	          "PolicyNames": {
	            "shape": "S2s"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SetLoadBalancerPoliciesForBackendServerResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetLoadBalancerPoliciesOfListener": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerName",
	          "LoadBalancerPort",
	          "PolicyNames"
	        ],
	        "members": {
	          "LoadBalancerName": {},
	          "LoadBalancerPort": {
	            "type": "integer"
	          },
	          "PolicyNames": {
	            "shape": "S2s"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SetLoadBalancerPoliciesOfListenerResult",
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "list",
	      "member": {}
	    },
	    "S4": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sa": {
	      "type": "list",
	      "member": {}
	    },
	    "Se": {
	      "type": "list",
	      "member": {}
	    },
	    "Si": {
	      "type": "structure",
	      "required": [
	        "Target",
	        "Interval",
	        "Timeout",
	        "UnhealthyThreshold",
	        "HealthyThreshold"
	      ],
	      "members": {
	        "Target": {},
	        "Interval": {
	          "type": "integer"
	        },
	        "Timeout": {
	          "type": "integer"
	        },
	        "UnhealthyThreshold": {
	          "type": "integer"
	        },
	        "HealthyThreshold": {
	          "type": "integer"
	        }
	      }
	    },
	    "Sx": {
	      "type": "list",
	      "member": {
	        "shape": "Sy"
	      }
	    },
	    "Sy": {
	      "type": "structure",
	      "required": [
	        "Protocol",
	        "LoadBalancerPort",
	        "InstancePort"
	      ],
	      "members": {
	        "Protocol": {},
	        "LoadBalancerPort": {
	          "type": "integer"
	        },
	        "InstanceProtocol": {},
	        "InstancePort": {
	          "type": "integer"
	        },
	        "SSLCertificateId": {}
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {}
	    },
	    "S1p": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {}
	        }
	      }
	    },
	    "S2a": {
	      "type": "structure",
	      "members": {
	        "CrossZoneLoadBalancing": {
	          "type": "structure",
	          "required": [
	            "Enabled"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            }
	          }
	        },
	        "AccessLog": {
	          "type": "structure",
	          "required": [
	            "Enabled"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "S3BucketName": {},
	            "EmitInterval": {
	              "type": "integer"
	            },
	            "S3BucketPrefix": {}
	          }
	        },
	        "ConnectionDraining": {
	          "type": "structure",
	          "required": [
	            "Enabled"
	          ],
	          "members": {
	            "Enabled": {
	              "type": "boolean"
	            },
	            "Timeout": {
	              "type": "integer"
	            }
	          }
	        },
	        "ConnectionSettings": {
	          "type": "structure",
	          "required": [
	            "IdleTimeout"
	          ],
	          "members": {
	            "IdleTimeout": {
	              "type": "integer"
	            }
	          }
	        },
	        "AdditionalAttributes": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Key": {},
	              "Value": {}
	            }
	          }
	        }
	      }
	    },
	    "S2s": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],97:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeInstanceHealth": {
	      "result_key": "InstanceStates"
	    },
	    "DescribeLoadBalancerPolicies": {
	      "result_key": "PolicyDescriptions"
	    },
	    "DescribeLoadBalancerPolicyTypes": {
	      "result_key": "PolicyTypeDescriptions"
	    },
	    "DescribeLoadBalancers": {
	      "input_token": "Marker",
	      "output_token": "NextMarker",
	      "result_key": "LoadBalancerDescriptions"
	    }
	  }
	}
	},{}],98:[function(require,module,exports){
	module.exports={
	    "version":2,
	    "waiters":{
	        "InstanceDeregistered": {
	          "delay": 15,
	          "operation": "DescribeInstanceHealth",
	          "maxAttempts": 40,
	          "acceptors": [
	            {
	              "expected": "OutOfService",
	              "matcher": "pathAll",
	              "state": "success",
	              "argument": "InstanceStates[].State"
	            },
	            {
	              "matcher": "error",
	              "expected": "InvalidInstance",
	              "state": "success"
	            }
	          ]
	        },
	        "AnyInstanceInService":{
	            "acceptors":[
	                {
	                    "argument":"InstanceStates[].State",
	                    "expected":"InService",
	                    "matcher":"pathAny",
	                    "state":"success"
	                }
	            ],
	            "delay":15,
	            "maxAttempts":40,
	            "operation":"DescribeInstanceHealth"
	        },
	        "InstanceInService":{
	            "acceptors":[
	                {
	                    "argument":"InstanceStates[].State",
	                    "expected":"InService",
	                    "matcher":"pathAll",
	                    "state":"success"
	                },
	                {
	                    "matcher": "error",
	                    "expected": "InvalidInstance",
	                    "state": "retry"
	                }
	            ],
	            "delay":15,
	            "maxAttempts":40,
	            "operation":"DescribeInstanceHealth"
	        }
	    }
	}
	
	},{}],99:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-12-01",
	    "endpointPrefix": "elasticloadbalancing",
	    "protocol": "query",
	    "serviceAbbreviation": "Elastic Load Balancing v2",
	    "serviceFullName": "Elastic Load Balancing",
	    "serviceId": "Elastic Load Balancing v2",
	    "signatureVersion": "v4",
	    "uid": "elasticloadbalancingv2-2015-12-01",
	    "xmlNamespace": "http://elasticloadbalancing.amazonaws.com/doc/2015-12-01/"
	  },
	  "operations": {
	    "AddListenerCertificates": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ListenerArn",
	          "Certificates"
	        ],
	        "members": {
	          "ListenerArn": {},
	          "Certificates": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "AddListenerCertificatesResult",
	        "type": "structure",
	        "members": {
	          "Certificates": {
	            "shape": "S3"
	          }
	        }
	      }
	    },
	    "AddTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArns",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArns": {
	            "shape": "S9"
	          },
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "AddTagsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateListener": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerArn",
	          "DefaultActions"
	        ],
	        "members": {
	          "LoadBalancerArn": {},
	          "Protocol": {},
	          "Port": {
	            "type": "integer"
	          },
	          "SslPolicy": {},
	          "Certificates": {
	            "shape": "S3"
	          },
	          "DefaultActions": {
	            "shape": "Sl"
	          },
	          "AlpnPolicy": {
	            "shape": "S1y"
	          },
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateListenerResult",
	        "type": "structure",
	        "members": {
	          "Listeners": {
	            "shape": "S21"
	          }
	        }
	      }
	    },
	    "CreateLoadBalancer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Subnets": {
	            "shape": "S25"
	          },
	          "SubnetMappings": {
	            "shape": "S27"
	          },
	          "SecurityGroups": {
	            "shape": "S2c"
	          },
	          "Scheme": {},
	          "Tags": {
	            "shape": "Sb"
	          },
	          "Type": {},
	          "IpAddressType": {},
	          "CustomerOwnedIpv4Pool": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateLoadBalancerResult",
	        "type": "structure",
	        "members": {
	          "LoadBalancers": {
	            "shape": "S2j"
	          }
	        }
	      }
	    },
	    "CreateRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ListenerArn",
	          "Conditions",
	          "Priority",
	          "Actions"
	        ],
	        "members": {
	          "ListenerArn": {},
	          "Conditions": {
	            "shape": "S30"
	          },
	          "Priority": {
	            "type": "integer"
	          },
	          "Actions": {
	            "shape": "Sl"
	          },
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateRuleResult",
	        "type": "structure",
	        "members": {
	          "Rules": {
	            "shape": "S3g"
	          }
	        }
	      }
	    },
	    "CreateTargetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Protocol": {},
	          "ProtocolVersion": {},
	          "Port": {
	            "type": "integer"
	          },
	          "VpcId": {},
	          "HealthCheckProtocol": {},
	          "HealthCheckPort": {},
	          "HealthCheckEnabled": {
	            "type": "boolean"
	          },
	          "HealthCheckPath": {},
	          "HealthCheckIntervalSeconds": {
	            "type": "integer"
	          },
	          "HealthCheckTimeoutSeconds": {
	            "type": "integer"
	          },
	          "HealthyThresholdCount": {
	            "type": "integer"
	          },
	          "UnhealthyThresholdCount": {
	            "type": "integer"
	          },
	          "Matcher": {
	            "shape": "S3u"
	          },
	          "TargetType": {},
	          "Tags": {
	            "shape": "Sb"
	          },
	          "IpAddressType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateTargetGroupResult",
	        "type": "structure",
	        "members": {
	          "TargetGroups": {
	            "shape": "S40"
	          }
	        }
	      }
	    },
	    "DeleteListener": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ListenerArn"
	        ],
	        "members": {
	          "ListenerArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteListenerResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteLoadBalancer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerArn"
	        ],
	        "members": {
	          "LoadBalancerArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteLoadBalancerResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleArn"
	        ],
	        "members": {
	          "RuleArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteRuleResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteTargetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetGroupArn"
	        ],
	        "members": {
	          "TargetGroupArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteTargetGroupResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeregisterTargets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetGroupArn",
	          "Targets"
	        ],
	        "members": {
	          "TargetGroupArn": {},
	          "Targets": {
	            "shape": "S4c"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeregisterTargetsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeAccountLimits": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeAccountLimitsResult",
	        "type": "structure",
	        "members": {
	          "Limits": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Max": {}
	              }
	            }
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "DescribeListenerCertificates": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ListenerArn"
	        ],
	        "members": {
	          "ListenerArn": {},
	          "Marker": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeListenerCertificatesResult",
	        "type": "structure",
	        "members": {
	          "Certificates": {
	            "shape": "S3"
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "DescribeListeners": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LoadBalancerArn": {},
	          "ListenerArns": {
	            "type": "list",
	            "member": {}
	          },
	          "Marker": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeListenersResult",
	        "type": "structure",
	        "members": {
	          "Listeners": {
	            "shape": "S21"
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "DescribeLoadBalancerAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerArn"
	        ],
	        "members": {
	          "LoadBalancerArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeLoadBalancerAttributesResult",
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "S4v"
	          }
	        }
	      }
	    },
	    "DescribeLoadBalancers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LoadBalancerArns": {
	            "shape": "S42"
	          },
	          "Names": {
	            "type": "list",
	            "member": {}
	          },
	          "Marker": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeLoadBalancersResult",
	        "type": "structure",
	        "members": {
	          "LoadBalancers": {
	            "shape": "S2j"
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "DescribeRules": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ListenerArn": {},
	          "RuleArns": {
	            "type": "list",
	            "member": {}
	          },
	          "Marker": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeRulesResult",
	        "type": "structure",
	        "members": {
	          "Rules": {
	            "shape": "S3g"
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "DescribeSSLPolicies": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Names": {
	            "type": "list",
	            "member": {}
	          },
	          "Marker": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "LoadBalancerType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeSSLPoliciesResult",
	        "type": "structure",
	        "members": {
	          "SslPolicies": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "SslProtocols": {
	                  "type": "list",
	                  "member": {}
	                },
	                "Ciphers": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Name": {},
	                      "Priority": {
	                        "type": "integer"
	                      }
	                    }
	                  }
	                },
	                "Name": {},
	                "SupportedLoadBalancerTypes": {
	                  "shape": "S33"
	                }
	              }
	            }
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "DescribeTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArns"
	        ],
	        "members": {
	          "ResourceArns": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeTagsResult",
	        "type": "structure",
	        "members": {
	          "TagDescriptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ResourceArn": {},
	                "Tags": {
	                  "shape": "Sb"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeTargetGroupAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetGroupArn"
	        ],
	        "members": {
	          "TargetGroupArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeTargetGroupAttributesResult",
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "S5m"
	          }
	        }
	      }
	    },
	    "DescribeTargetGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "LoadBalancerArn": {},
	          "TargetGroupArns": {
	            "type": "list",
	            "member": {}
	          },
	          "Names": {
	            "type": "list",
	            "member": {}
	          },
	          "Marker": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeTargetGroupsResult",
	        "type": "structure",
	        "members": {
	          "TargetGroups": {
	            "shape": "S40"
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "DescribeTargetHealth": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetGroupArn"
	        ],
	        "members": {
	          "TargetGroupArn": {},
	          "Targets": {
	            "shape": "S4c"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeTargetHealthResult",
	        "type": "structure",
	        "members": {
	          "TargetHealthDescriptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Target": {
	                  "shape": "S4d"
	                },
	                "HealthCheckPort": {},
	                "TargetHealth": {
	                  "type": "structure",
	                  "members": {
	                    "State": {},
	                    "Reason": {},
	                    "Description": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ModifyListener": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ListenerArn"
	        ],
	        "members": {
	          "ListenerArn": {},
	          "Port": {
	            "type": "integer"
	          },
	          "Protocol": {},
	          "SslPolicy": {},
	          "Certificates": {
	            "shape": "S3"
	          },
	          "DefaultActions": {
	            "shape": "Sl"
	          },
	          "AlpnPolicy": {
	            "shape": "S1y"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyListenerResult",
	        "type": "structure",
	        "members": {
	          "Listeners": {
	            "shape": "S21"
	          }
	        }
	      }
	    },
	    "ModifyLoadBalancerAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerArn",
	          "Attributes"
	        ],
	        "members": {
	          "LoadBalancerArn": {},
	          "Attributes": {
	            "shape": "S4v"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyLoadBalancerAttributesResult",
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "S4v"
	          }
	        }
	      }
	    },
	    "ModifyRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleArn"
	        ],
	        "members": {
	          "RuleArn": {},
	          "Conditions": {
	            "shape": "S30"
	          },
	          "Actions": {
	            "shape": "Sl"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyRuleResult",
	        "type": "structure",
	        "members": {
	          "Rules": {
	            "shape": "S3g"
	          }
	        }
	      }
	    },
	    "ModifyTargetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetGroupArn"
	        ],
	        "members": {
	          "TargetGroupArn": {},
	          "HealthCheckProtocol": {},
	          "HealthCheckPort": {},
	          "HealthCheckPath": {},
	          "HealthCheckEnabled": {
	            "type": "boolean"
	          },
	          "HealthCheckIntervalSeconds": {
	            "type": "integer"
	          },
	          "HealthCheckTimeoutSeconds": {
	            "type": "integer"
	          },
	          "HealthyThresholdCount": {
	            "type": "integer"
	          },
	          "UnhealthyThresholdCount": {
	            "type": "integer"
	          },
	          "Matcher": {
	            "shape": "S3u"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyTargetGroupResult",
	        "type": "structure",
	        "members": {
	          "TargetGroups": {
	            "shape": "S40"
	          }
	        }
	      }
	    },
	    "ModifyTargetGroupAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetGroupArn",
	          "Attributes"
	        ],
	        "members": {
	          "TargetGroupArn": {},
	          "Attributes": {
	            "shape": "S5m"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyTargetGroupAttributesResult",
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "S5m"
	          }
	        }
	      }
	    },
	    "RegisterTargets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetGroupArn",
	          "Targets"
	        ],
	        "members": {
	          "TargetGroupArn": {},
	          "Targets": {
	            "shape": "S4c"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RegisterTargetsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RemoveListenerCertificates": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ListenerArn",
	          "Certificates"
	        ],
	        "members": {
	          "ListenerArn": {},
	          "Certificates": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RemoveListenerCertificatesResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RemoveTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArns",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArns": {
	            "shape": "S9"
	          },
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RemoveTagsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetIpAddressType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerArn",
	          "IpAddressType"
	        ],
	        "members": {
	          "LoadBalancerArn": {},
	          "IpAddressType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SetIpAddressTypeResult",
	        "type": "structure",
	        "members": {
	          "IpAddressType": {}
	        }
	      }
	    },
	    "SetRulePriorities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RulePriorities"
	        ],
	        "members": {
	          "RulePriorities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "RuleArn": {},
	                "Priority": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SetRulePrioritiesResult",
	        "type": "structure",
	        "members": {
	          "Rules": {
	            "shape": "S3g"
	          }
	        }
	      }
	    },
	    "SetSecurityGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerArn",
	          "SecurityGroups"
	        ],
	        "members": {
	          "LoadBalancerArn": {},
	          "SecurityGroups": {
	            "shape": "S2c"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SetSecurityGroupsResult",
	        "type": "structure",
	        "members": {
	          "SecurityGroupIds": {
	            "shape": "S2c"
	          }
	        }
	      }
	    },
	    "SetSubnets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoadBalancerArn"
	        ],
	        "members": {
	          "LoadBalancerArn": {},
	          "Subnets": {
	            "shape": "S25"
	          },
	          "SubnetMappings": {
	            "shape": "S27"
	          },
	          "IpAddressType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SetSubnetsResult",
	        "type": "structure",
	        "members": {
	          "AvailabilityZones": {
	            "shape": "S2s"
	          },
	          "IpAddressType": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S3": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "CertificateArn": {},
	          "IsDefault": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S9": {
	      "type": "list",
	      "member": {}
	    },
	    "Sb": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sl": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Type"
	        ],
	        "members": {
	          "Type": {},
	          "TargetGroupArn": {},
	          "AuthenticateOidcConfig": {
	            "type": "structure",
	            "required": [
	              "Issuer",
	              "AuthorizationEndpoint",
	              "TokenEndpoint",
	              "UserInfoEndpoint",
	              "ClientId"
	            ],
	            "members": {
	              "Issuer": {},
	              "AuthorizationEndpoint": {},
	              "TokenEndpoint": {},
	              "UserInfoEndpoint": {},
	              "ClientId": {},
	              "ClientSecret": {},
	              "SessionCookieName": {},
	              "Scope": {},
	              "SessionTimeout": {
	                "type": "long"
	              },
	              "AuthenticationRequestExtraParams": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              },
	              "OnUnauthenticatedRequest": {},
	              "UseExistingClientSecret": {
	                "type": "boolean"
	              }
	            }
	          },
	          "AuthenticateCognitoConfig": {
	            "type": "structure",
	            "required": [
	              "UserPoolArn",
	              "UserPoolClientId",
	              "UserPoolDomain"
	            ],
	            "members": {
	              "UserPoolArn": {},
	              "UserPoolClientId": {},
	              "UserPoolDomain": {},
	              "SessionCookieName": {},
	              "Scope": {},
	              "SessionTimeout": {
	                "type": "long"
	              },
	              "AuthenticationRequestExtraParams": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              },
	              "OnUnauthenticatedRequest": {}
	            }
	          },
	          "Order": {
	            "type": "integer"
	          },
	          "RedirectConfig": {
	            "type": "structure",
	            "required": [
	              "StatusCode"
	            ],
	            "members": {
	              "Protocol": {},
	              "Port": {},
	              "Host": {},
	              "Path": {},
	              "Query": {},
	              "StatusCode": {}
	            }
	          },
	          "FixedResponseConfig": {
	            "type": "structure",
	            "required": [
	              "StatusCode"
	            ],
	            "members": {
	              "MessageBody": {},
	              "StatusCode": {},
	              "ContentType": {}
	            }
	          },
	          "ForwardConfig": {
	            "type": "structure",
	            "members": {
	              "TargetGroups": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "TargetGroupArn": {},
	                    "Weight": {
	                      "type": "integer"
	                    }
	                  }
	                }
	              },
	              "TargetGroupStickinessConfig": {
	                "type": "structure",
	                "members": {
	                  "Enabled": {
	                    "type": "boolean"
	                  },
	                  "DurationSeconds": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1y": {
	      "type": "list",
	      "member": {}
	    },
	    "S21": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ListenerArn": {},
	          "LoadBalancerArn": {},
	          "Port": {
	            "type": "integer"
	          },
	          "Protocol": {},
	          "Certificates": {
	            "shape": "S3"
	          },
	          "SslPolicy": {},
	          "DefaultActions": {
	            "shape": "Sl"
	          },
	          "AlpnPolicy": {
	            "shape": "S1y"
	          }
	        }
	      }
	    },
	    "S25": {
	      "type": "list",
	      "member": {}
	    },
	    "S27": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "SubnetId": {},
	          "AllocationId": {},
	          "PrivateIPv4Address": {},
	          "IPv6Address": {}
	        }
	      }
	    },
	    "S2c": {
	      "type": "list",
	      "member": {}
	    },
	    "S2j": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "LoadBalancerArn": {},
	          "DNSName": {},
	          "CanonicalHostedZoneId": {},
	          "CreatedTime": {
	            "type": "timestamp"
	          },
	          "LoadBalancerName": {},
	          "Scheme": {},
	          "VpcId": {},
	          "State": {
	            "type": "structure",
	            "members": {
	              "Code": {},
	              "Reason": {}
	            }
	          },
	          "Type": {},
	          "AvailabilityZones": {
	            "shape": "S2s"
	          },
	          "SecurityGroups": {
	            "shape": "S2c"
	          },
	          "IpAddressType": {},
	          "CustomerOwnedIpv4Pool": {}
	        }
	      }
	    },
	    "S2s": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ZoneName": {},
	          "SubnetId": {},
	          "OutpostId": {},
	          "LoadBalancerAddresses": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "IpAddress": {},
	                "AllocationId": {},
	                "PrivateIPv4Address": {},
	                "IPv6Address": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "S30": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Field": {},
	          "Values": {
	            "shape": "S33"
	          },
	          "HostHeaderConfig": {
	            "type": "structure",
	            "members": {
	              "Values": {
	                "shape": "S33"
	              }
	            }
	          },
	          "PathPatternConfig": {
	            "type": "structure",
	            "members": {
	              "Values": {
	                "shape": "S33"
	              }
	            }
	          },
	          "HttpHeaderConfig": {
	            "type": "structure",
	            "members": {
	              "HttpHeaderName": {},
	              "Values": {
	                "shape": "S33"
	              }
	            }
	          },
	          "QueryStringConfig": {
	            "type": "structure",
	            "members": {
	              "Values": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Key": {},
	                    "Value": {}
	                  }
	                }
	              }
	            }
	          },
	          "HttpRequestMethodConfig": {
	            "type": "structure",
	            "members": {
	              "Values": {
	                "shape": "S33"
	              }
	            }
	          },
	          "SourceIpConfig": {
	            "type": "structure",
	            "members": {
	              "Values": {
	                "shape": "S33"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S33": {
	      "type": "list",
	      "member": {}
	    },
	    "S3g": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "RuleArn": {},
	          "Priority": {},
	          "Conditions": {
	            "shape": "S30"
	          },
	          "Actions": {
	            "shape": "Sl"
	          },
	          "IsDefault": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S3u": {
	      "type": "structure",
	      "members": {
	        "HttpCode": {},
	        "GrpcCode": {}
	      }
	    },
	    "S40": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "TargetGroupArn": {},
	          "TargetGroupName": {},
	          "Protocol": {},
	          "Port": {
	            "type": "integer"
	          },
	          "VpcId": {},
	          "HealthCheckProtocol": {},
	          "HealthCheckPort": {},
	          "HealthCheckEnabled": {
	            "type": "boolean"
	          },
	          "HealthCheckIntervalSeconds": {
	            "type": "integer"
	          },
	          "HealthCheckTimeoutSeconds": {
	            "type": "integer"
	          },
	          "HealthyThresholdCount": {
	            "type": "integer"
	          },
	          "UnhealthyThresholdCount": {
	            "type": "integer"
	          },
	          "HealthCheckPath": {},
	          "Matcher": {
	            "shape": "S3u"
	          },
	          "LoadBalancerArns": {
	            "shape": "S42"
	          },
	          "TargetType": {},
	          "ProtocolVersion": {},
	          "IpAddressType": {}
	        }
	      }
	    },
	    "S42": {
	      "type": "list",
	      "member": {}
	    },
	    "S4c": {
	      "type": "list",
	      "member": {
	        "shape": "S4d"
	      }
	    },
	    "S4d": {
	      "type": "structure",
	      "required": [
	        "Id"
	      ],
	      "members": {
	        "Id": {},
	        "Port": {
	          "type": "integer"
	        },
	        "AvailabilityZone": {}
	      }
	    },
	    "S4v": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S5m": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    }
	  }
	}
	},{}],100:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeListeners": {
	      "input_token": "Marker",
	      "output_token": "NextMarker",
	      "result_key": "Listeners"
	    },
	    "DescribeLoadBalancers": {
	      "input_token": "Marker",
	      "output_token": "NextMarker",
	      "result_key": "LoadBalancers"
	    },
	    "DescribeTargetGroups": {
	      "input_token": "Marker",
	      "output_token": "NextMarker",
	      "result_key": "TargetGroups"
	    }
	  }
	}
	},{}],101:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "LoadBalancerExists": {
	      "delay": 15,
	      "operation": "DescribeLoadBalancers",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "matcher": "status",
	          "expected": 200,
	          "state": "success"
	        },
	        {
	          "matcher": "error",
	          "expected": "LoadBalancerNotFound",
	          "state": "retry"
	        }
	      ]
	    },
	    "LoadBalancerAvailable": {
	      "delay": 15,
	      "operation": "DescribeLoadBalancers",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "LoadBalancers[].State.Code",
	          "expected": "active"
	        },
	        {
	          "state": "retry",
	          "matcher": "pathAny",
	          "argument": "LoadBalancers[].State.Code",
	          "expected": "provisioning"
	        },
	        {
	          "state": "retry",
	          "matcher": "error",
	          "expected": "LoadBalancerNotFound"
	        }
	      ]
	    },
	    "LoadBalancersDeleted": {
	      "delay": 15,
	      "operation": "DescribeLoadBalancers",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "state": "retry",
	          "matcher": "pathAll",
	          "argument": "LoadBalancers[].State.Code",
	          "expected": "active"
	        },
	        {
	          "matcher": "error",
	          "expected": "LoadBalancerNotFound",
	          "state": "success"
	        }
	      ]
	    },
	    "TargetInService":{
	      "delay":15,
	      "maxAttempts":40,
	      "operation":"DescribeTargetHealth",
	      "acceptors":[
	        {
	          "argument":"TargetHealthDescriptions[].TargetHealth.State",
	          "expected":"healthy",
	          "matcher":"pathAll",
	          "state":"success"
	        },
	        {
	          "matcher": "error",
	          "expected": "InvalidInstance",
	          "state": "retry"
	        }
	      ]
	    },
	    "TargetDeregistered": {
	      "delay": 15,
	      "maxAttempts": 40,
	      "operation": "DescribeTargetHealth",
	      "acceptors": [
	        {
	          "matcher": "error",
	          "expected": "InvalidTarget",
	          "state": "success"
	        },
	        {
	          "argument":"TargetHealthDescriptions[].TargetHealth.State",
	          "expected":"unused",
	          "matcher":"pathAll",
	          "state":"success"
	        }
	      ]
	    }
	  }
	}
	
	},{}],102:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2009-03-31",
	    "endpointPrefix": "elasticmapreduce",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "Amazon EMR",
	    "serviceFullName": "Amazon EMR",
	    "serviceId": "EMR",
	    "signatureVersion": "v4",
	    "targetPrefix": "ElasticMapReduce",
	    "uid": "elasticmapreduce-2009-03-31"
	  },
	  "operations": {
	    "AddInstanceFleet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId",
	          "InstanceFleet"
	        ],
	        "members": {
	          "ClusterId": {},
	          "InstanceFleet": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClusterId": {},
	          "InstanceFleetId": {},
	          "ClusterArn": {}
	        }
	      }
	    },
	    "AddInstanceGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceGroups",
	          "JobFlowId"
	        ],
	        "members": {
	          "InstanceGroups": {
	            "shape": "Sx"
	          },
	          "JobFlowId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobFlowId": {},
	          "InstanceGroupIds": {
	            "type": "list",
	            "member": {}
	          },
	          "ClusterArn": {}
	        }
	      }
	    },
	    "AddJobFlowSteps": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobFlowId",
	          "Steps"
	        ],
	        "members": {
	          "JobFlowId": {},
	          "Steps": {
	            "shape": "S1i"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StepIds": {
	            "shape": "S1r"
	          }
	        }
	      }
	    },
	    "AddTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "Tags"
	        ],
	        "members": {
	          "ResourceId": {},
	          "Tags": {
	            "shape": "S1u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CancelSteps": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId",
	          "StepIds"
	        ],
	        "members": {
	          "ClusterId": {},
	          "StepIds": {
	            "shape": "S1r"
	          },
	          "StepCancellationOption": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CancelStepsInfoList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "StepId": {},
	                "Status": {},
	                "Reason": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "CreateSecurityConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "SecurityConfiguration"
	        ],
	        "members": {
	          "Name": {},
	          "SecurityConfiguration": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "CreationDateTime"
	        ],
	        "members": {
	          "Name": {},
	          "CreationDateTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "CreateStudio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "AuthMode",
	          "VpcId",
	          "SubnetIds",
	          "ServiceRole",
	          "WorkspaceSecurityGroupId",
	          "EngineSecurityGroupId",
	          "DefaultS3Location"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "AuthMode": {},
	          "VpcId": {},
	          "SubnetIds": {
	            "shape": "S29"
	          },
	          "ServiceRole": {},
	          "UserRole": {},
	          "WorkspaceSecurityGroupId": {},
	          "EngineSecurityGroupId": {},
	          "DefaultS3Location": {},
	          "IdpAuthUrl": {},
	          "IdpRelayStateParameterName": {},
	          "Tags": {
	            "shape": "S1u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StudioId": {},
	          "Url": {}
	        }
	      }
	    },
	    "CreateStudioSessionMapping": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StudioId",
	          "IdentityType",
	          "SessionPolicyArn"
	        ],
	        "members": {
	          "StudioId": {},
	          "IdentityId": {},
	          "IdentityName": {},
	          "IdentityType": {},
	          "SessionPolicyArn": {}
	        }
	      }
	    },
	    "DeleteSecurityConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteStudio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StudioId"
	        ],
	        "members": {
	          "StudioId": {}
	        }
	      }
	    },
	    "DeleteStudioSessionMapping": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StudioId",
	          "IdentityType"
	        ],
	        "members": {
	          "StudioId": {},
	          "IdentityId": {},
	          "IdentityName": {},
	          "IdentityType": {}
	        }
	      }
	    },
	    "DescribeCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "type": "structure",
	            "members": {
	              "Id": {},
	              "Name": {},
	              "Status": {
	                "shape": "S2l"
	              },
	              "Ec2InstanceAttributes": {
	                "type": "structure",
	                "members": {
	                  "Ec2KeyName": {},
	                  "Ec2SubnetId": {},
	                  "RequestedEc2SubnetIds": {
	                    "shape": "S2r"
	                  },
	                  "Ec2AvailabilityZone": {},
	                  "RequestedEc2AvailabilityZones": {
	                    "shape": "S2r"
	                  },
	                  "IamInstanceProfile": {},
	                  "EmrManagedMasterSecurityGroup": {},
	                  "EmrManagedSlaveSecurityGroup": {},
	                  "ServiceAccessSecurityGroup": {},
	                  "AdditionalMasterSecurityGroups": {
	                    "shape": "S2s"
	                  },
	                  "AdditionalSlaveSecurityGroups": {
	                    "shape": "S2s"
	                  }
	                }
	              },
	              "InstanceCollectionType": {},
	              "LogUri": {},
	              "LogEncryptionKmsKeyId": {},
	              "RequestedAmiVersion": {},
	              "RunningAmiVersion": {},
	              "ReleaseLabel": {},
	              "AutoTerminate": {
	                "type": "boolean"
	              },
	              "TerminationProtected": {
	                "type": "boolean"
	              },
	              "VisibleToAllUsers": {
	                "type": "boolean"
	              },
	              "Applications": {
	                "shape": "S2v"
	              },
	              "Tags": {
	                "shape": "S1u"
	              },
	              "ServiceRole": {},
	              "NormalizedInstanceHours": {
	                "type": "integer"
	              },
	              "MasterPublicDnsName": {},
	              "Configurations": {
	                "shape": "Sh"
	              },
	              "SecurityConfiguration": {},
	              "AutoScalingRole": {},
	              "ScaleDownBehavior": {},
	              "CustomAmiId": {},
	              "EbsRootVolumeSize": {
	                "type": "integer"
	              },
	              "RepoUpgradeOnBoot": {},
	              "KerberosAttributes": {
	                "shape": "S2z"
	              },
	              "ClusterArn": {},
	              "OutpostArn": {},
	              "StepConcurrencyLevel": {
	                "type": "integer"
	              },
	              "PlacementGroups": {
	                "shape": "S31"
	              },
	              "OSReleaseLabel": {}
	            }
	          }
	        }
	      }
	    },
	    "DescribeJobFlows": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CreatedAfter": {
	            "type": "timestamp"
	          },
	          "CreatedBefore": {
	            "type": "timestamp"
	          },
	          "JobFlowIds": {
	            "shape": "S1p"
	          },
	          "JobFlowStates": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobFlows": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "JobFlowId",
	                "Name",
	                "ExecutionStatusDetail",
	                "Instances"
	              ],
	              "members": {
	                "JobFlowId": {},
	                "Name": {},
	                "LogUri": {},
	                "LogEncryptionKmsKeyId": {},
	                "AmiVersion": {},
	                "ExecutionStatusDetail": {
	                  "type": "structure",
	                  "required": [
	                    "State",
	                    "CreationDateTime"
	                  ],
	                  "members": {
	                    "State": {},
	                    "CreationDateTime": {
	                      "type": "timestamp"
	                    },
	                    "StartDateTime": {
	                      "type": "timestamp"
	                    },
	                    "ReadyDateTime": {
	                      "type": "timestamp"
	                    },
	                    "EndDateTime": {
	                      "type": "timestamp"
	                    },
	                    "LastStateChangeReason": {}
	                  }
	                },
	                "Instances": {
	                  "type": "structure",
	                  "required": [
	                    "MasterInstanceType",
	                    "SlaveInstanceType",
	                    "InstanceCount"
	                  ],
	                  "members": {
	                    "MasterInstanceType": {},
	                    "MasterPublicDnsName": {},
	                    "MasterInstanceId": {},
	                    "SlaveInstanceType": {},
	                    "InstanceCount": {
	                      "type": "integer"
	                    },
	                    "InstanceGroups": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "required": [
	                          "Market",
	                          "InstanceRole",
	                          "InstanceType",
	                          "InstanceRequestCount",
	                          "InstanceRunningCount",
	                          "State",
	                          "CreationDateTime"
	                        ],
	                        "members": {
	                          "InstanceGroupId": {},
	                          "Name": {},
	                          "Market": {},
	                          "InstanceRole": {},
	                          "BidPrice": {},
	                          "InstanceType": {},
	                          "InstanceRequestCount": {
	                            "type": "integer"
	                          },
	                          "InstanceRunningCount": {
	                            "type": "integer"
	                          },
	                          "State": {},
	                          "LastStateChangeReason": {},
	                          "CreationDateTime": {
	                            "type": "timestamp"
	                          },
	                          "StartDateTime": {
	                            "type": "timestamp"
	                          },
	                          "ReadyDateTime": {
	                            "type": "timestamp"
	                          },
	                          "EndDateTime": {
	                            "type": "timestamp"
	                          },
	                          "CustomAmiId": {}
	                        }
	                      }
	                    },
	                    "NormalizedInstanceHours": {
	                      "type": "integer"
	                    },
	                    "Ec2KeyName": {},
	                    "Ec2SubnetId": {},
	                    "Placement": {
	                      "shape": "S3f"
	                    },
	                    "KeepJobFlowAliveWhenNoSteps": {
	                      "type": "boolean"
	                    },
	                    "TerminationProtected": {
	                      "type": "boolean"
	                    },
	                    "HadoopVersion": {}
	                  }
	                },
	                "Steps": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "required": [
	                      "StepConfig",
	                      "ExecutionStatusDetail"
	                    ],
	                    "members": {
	                      "StepConfig": {
	                        "shape": "S1j"
	                      },
	                      "ExecutionStatusDetail": {
	                        "type": "structure",
	                        "required": [
	                          "State",
	                          "CreationDateTime"
	                        ],
	                        "members": {
	                          "State": {},
	                          "CreationDateTime": {
	                            "type": "timestamp"
	                          },
	                          "StartDateTime": {
	                            "type": "timestamp"
	                          },
	                          "EndDateTime": {
	                            "type": "timestamp"
	                          },
	                          "LastStateChangeReason": {}
	                        }
	                      }
	                    }
	                  }
	                },
	                "BootstrapActions": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "BootstrapActionConfig": {
	                        "shape": "S3m"
	                      }
	                    }
	                  }
	                },
	                "SupportedProducts": {
	                  "shape": "S3o"
	                },
	                "VisibleToAllUsers": {
	                  "type": "boolean"
	                },
	                "JobFlowRole": {},
	                "ServiceRole": {},
	                "AutoScalingRole": {},
	                "ScaleDownBehavior": {}
	              }
	            }
	          }
	        }
	      },
	      "deprecated": true
	    },
	    "DescribeNotebookExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NotebookExecutionId"
	        ],
	        "members": {
	          "NotebookExecutionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NotebookExecution": {
	            "type": "structure",
	            "members": {
	              "NotebookExecutionId": {},
	              "EditorId": {},
	              "ExecutionEngine": {
	                "shape": "S3s"
	              },
	              "NotebookExecutionName": {},
	              "NotebookParams": {},
	              "Status": {},
	              "StartTime": {
	                "type": "timestamp"
	              },
	              "EndTime": {
	                "type": "timestamp"
	              },
	              "Arn": {},
	              "OutputNotebookURI": {},
	              "LastStateChangeReason": {},
	              "NotebookInstanceSecurityGroupId": {},
	              "Tags": {
	                "shape": "S1u"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeReleaseLabel": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReleaseLabel": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReleaseLabel": {},
	          "Applications": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Version": {}
	              }
	            }
	          },
	          "NextToken": {},
	          "AvailableOSReleases": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Label": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeSecurityConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "SecurityConfiguration": {},
	          "CreationDateTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeStep": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId",
	          "StepId"
	        ],
	        "members": {
	          "ClusterId": {},
	          "StepId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Step": {
	            "type": "structure",
	            "members": {
	              "Id": {},
	              "Name": {},
	              "Config": {
	                "shape": "S47"
	              },
	              "ActionOnFailure": {},
	              "Status": {
	                "shape": "S48"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeStudio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StudioId"
	        ],
	        "members": {
	          "StudioId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Studio": {
	            "type": "structure",
	            "members": {
	              "StudioId": {},
	              "StudioArn": {},
	              "Name": {},
	              "Description": {},
	              "AuthMode": {},
	              "VpcId": {},
	              "SubnetIds": {
	                "shape": "S29"
	              },
	              "ServiceRole": {},
	              "UserRole": {},
	              "WorkspaceSecurityGroupId": {},
	              "EngineSecurityGroupId": {},
	              "Url": {},
	              "CreationTime": {
	                "type": "timestamp"
	              },
	              "DefaultS3Location": {},
	              "IdpAuthUrl": {},
	              "IdpRelayStateParameterName": {},
	              "Tags": {
	                "shape": "S1u"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetAutoTerminationPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AutoTerminationPolicy": {
	            "shape": "S4j"
	          }
	        }
	      }
	    },
	    "GetBlockPublicAccessConfiguration": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "BlockPublicAccessConfiguration",
	          "BlockPublicAccessConfigurationMetadata"
	        ],
	        "members": {
	          "BlockPublicAccessConfiguration": {
	            "shape": "S4n"
	          },
	          "BlockPublicAccessConfigurationMetadata": {
	            "type": "structure",
	            "required": [
	              "CreationDateTime",
	              "CreatedByArn"
	            ],
	            "members": {
	              "CreationDateTime": {
	                "type": "timestamp"
	              },
	              "CreatedByArn": {}
	            }
	          }
	        }
	      }
	    },
	    "GetManagedScalingPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ManagedScalingPolicy": {
	            "shape": "S4u"
	          }
	        }
	      }
	    },
	    "GetStudioSessionMapping": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StudioId",
	          "IdentityType"
	        ],
	        "members": {
	          "StudioId": {},
	          "IdentityId": {},
	          "IdentityName": {},
	          "IdentityType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SessionMapping": {
	            "type": "structure",
	            "members": {
	              "StudioId": {},
	              "IdentityId": {},
	              "IdentityName": {},
	              "IdentityType": {},
	              "SessionPolicyArn": {},
	              "CreationTime": {
	                "type": "timestamp"
	              },
	              "LastModifiedTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListBootstrapActions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {},
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BootstrapActions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "ScriptPath": {},
	                "Args": {
	                  "shape": "S2s"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListClusters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CreatedAfter": {
	            "type": "timestamp"
	          },
	          "CreatedBefore": {
	            "type": "timestamp"
	          },
	          "ClusterStates": {
	            "type": "list",
	            "member": {}
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Clusters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Name": {},
	                "Status": {
	                  "shape": "S2l"
	                },
	                "NormalizedInstanceHours": {
	                  "type": "integer"
	                },
	                "ClusterArn": {},
	                "OutpostArn": {}
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListInstanceFleets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {},
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceFleets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Name": {},
	                "Status": {
	                  "type": "structure",
	                  "members": {
	                    "State": {},
	                    "StateChangeReason": {
	                      "type": "structure",
	                      "members": {
	                        "Code": {},
	                        "Message": {}
	                      }
	                    },
	                    "Timeline": {
	                      "type": "structure",
	                      "members": {
	                        "CreationDateTime": {
	                          "type": "timestamp"
	                        },
	                        "ReadyDateTime": {
	                          "type": "timestamp"
	                        },
	                        "EndDateTime": {
	                          "type": "timestamp"
	                        }
	                      }
	                    }
	                  }
	                },
	                "InstanceFleetType": {},
	                "TargetOnDemandCapacity": {
	                  "type": "integer"
	                },
	                "TargetSpotCapacity": {
	                  "type": "integer"
	                },
	                "ProvisionedOnDemandCapacity": {
	                  "type": "integer"
	                },
	                "ProvisionedSpotCapacity": {
	                  "type": "integer"
	                },
	                "InstanceTypeSpecifications": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "InstanceType": {},
	                      "WeightedCapacity": {
	                        "type": "integer"
	                      },
	                      "BidPrice": {},
	                      "BidPriceAsPercentageOfOnDemandPrice": {
	                        "type": "double"
	                      },
	                      "Configurations": {
	                        "shape": "Sh"
	                      },
	                      "EbsBlockDevices": {
	                        "shape": "S5l"
	                      },
	                      "EbsOptimized": {
	                        "type": "boolean"
	                      },
	                      "CustomAmiId": {}
	                    }
	                  }
	                },
	                "LaunchSpecifications": {
	                  "shape": "Sk"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListInstanceGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {},
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Name": {},
	                "Market": {},
	                "InstanceGroupType": {},
	                "BidPrice": {},
	                "InstanceType": {},
	                "RequestedInstanceCount": {
	                  "type": "integer"
	                },
	                "RunningInstanceCount": {
	                  "type": "integer"
	                },
	                "Status": {
	                  "type": "structure",
	                  "members": {
	                    "State": {},
	                    "StateChangeReason": {
	                      "type": "structure",
	                      "members": {
	                        "Code": {},
	                        "Message": {}
	                      }
	                    },
	                    "Timeline": {
	                      "type": "structure",
	                      "members": {
	                        "CreationDateTime": {
	                          "type": "timestamp"
	                        },
	                        "ReadyDateTime": {
	                          "type": "timestamp"
	                        },
	                        "EndDateTime": {
	                          "type": "timestamp"
	                        }
	                      }
	                    }
	                  }
	                },
	                "Configurations": {
	                  "shape": "Sh"
	                },
	                "ConfigurationsVersion": {
	                  "type": "long"
	                },
	                "LastSuccessfullyAppliedConfigurations": {
	                  "shape": "Sh"
	                },
	                "LastSuccessfullyAppliedConfigurationsVersion": {
	                  "type": "long"
	                },
	                "EbsBlockDevices": {
	                  "shape": "S5l"
	                },
	                "EbsOptimized": {
	                  "type": "boolean"
	                },
	                "ShrinkPolicy": {
	                  "shape": "S5x"
	                },
	                "AutoScalingPolicy": {
	                  "shape": "S61"
	                },
	                "CustomAmiId": {}
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {},
	          "InstanceGroupId": {},
	          "InstanceGroupTypes": {
	            "type": "list",
	            "member": {}
	          },
	          "InstanceFleetId": {},
	          "InstanceFleetType": {},
	          "InstanceStates": {
	            "type": "list",
	            "member": {}
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Instances": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Ec2InstanceId": {},
	                "PublicDnsName": {},
	                "PublicIpAddress": {},
	                "PrivateDnsName": {},
	                "PrivateIpAddress": {},
	                "Status": {
	                  "type": "structure",
	                  "members": {
	                    "State": {},
	                    "StateChangeReason": {
	                      "type": "structure",
	                      "members": {
	                        "Code": {},
	                        "Message": {}
	                      }
	                    },
	                    "Timeline": {
	                      "type": "structure",
	                      "members": {
	                        "CreationDateTime": {
	                          "type": "timestamp"
	                        },
	                        "ReadyDateTime": {
	                          "type": "timestamp"
	                        },
	                        "EndDateTime": {
	                          "type": "timestamp"
	                        }
	                      }
	                    }
	                  }
	                },
	                "InstanceGroupId": {},
	                "InstanceFleetId": {},
	                "Market": {},
	                "InstanceType": {},
	                "EbsVolumes": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Device": {},
	                      "VolumeId": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListNotebookExecutions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EditorId": {},
	          "Status": {},
	          "From": {
	            "type": "timestamp"
	          },
	          "To": {
	            "type": "timestamp"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NotebookExecutions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "NotebookExecutionId": {},
	                "EditorId": {},
	                "NotebookExecutionName": {},
	                "Status": {},
	                "StartTime": {
	                  "type": "timestamp"
	                },
	                "EndTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListReleaseLabels": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "Prefix": {},
	              "Application": {}
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReleaseLabels": {
	            "shape": "S2s"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListSecurityConfigurations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SecurityConfigurations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "CreationDateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListSteps": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {},
	          "StepStates": {
	            "type": "list",
	            "member": {}
	          },
	          "StepIds": {
	            "shape": "S1p"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Steps": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Name": {},
	                "Config": {
	                  "shape": "S47"
	                },
	                "ActionOnFailure": {},
	                "Status": {
	                  "shape": "S48"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListStudioSessionMappings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StudioId": {},
	          "IdentityType": {},
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SessionMappings": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "StudioId": {},
	                "IdentityId": {},
	                "IdentityName": {},
	                "IdentityType": {},
	                "SessionPolicyArn": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListStudios": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Studios": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "StudioId": {},
	                "Name": {},
	                "VpcId": {},
	                "Description": {},
	                "Url": {},
	                "AuthMode": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ModifyCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {},
	          "StepConcurrencyLevel": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StepConcurrencyLevel": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "ModifyInstanceFleet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId",
	          "InstanceFleet"
	        ],
	        "members": {
	          "ClusterId": {},
	          "InstanceFleet": {
	            "type": "structure",
	            "required": [
	              "InstanceFleetId"
	            ],
	            "members": {
	              "InstanceFleetId": {},
	              "TargetOnDemandCapacity": {
	                "type": "integer"
	              },
	              "TargetSpotCapacity": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "ModifyInstanceGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterId": {},
	          "InstanceGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "InstanceGroupId"
	              ],
	              "members": {
	                "InstanceGroupId": {},
	                "InstanceCount": {
	                  "type": "integer"
	                },
	                "EC2InstanceIdsToTerminate": {
	                  "type": "list",
	                  "member": {}
	                },
	                "ShrinkPolicy": {
	                  "shape": "S5x"
	                },
	                "ReconfigurationType": {},
	                "Configurations": {
	                  "shape": "Sh"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutAutoScalingPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId",
	          "InstanceGroupId",
	          "AutoScalingPolicy"
	        ],
	        "members": {
	          "ClusterId": {},
	          "InstanceGroupId": {},
	          "AutoScalingPolicy": {
	            "shape": "S11"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ClusterId": {},
	          "InstanceGroupId": {},
	          "AutoScalingPolicy": {
	            "shape": "S61"
	          },
	          "ClusterArn": {}
	        }
	      }
	    },
	    "PutAutoTerminationPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {},
	          "AutoTerminationPolicy": {
	            "shape": "S4j"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "PutBlockPublicAccessConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BlockPublicAccessConfiguration"
	        ],
	        "members": {
	          "BlockPublicAccessConfiguration": {
	            "shape": "S4n"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "PutManagedScalingPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId",
	          "ManagedScalingPolicy"
	        ],
	        "members": {
	          "ClusterId": {},
	          "ManagedScalingPolicy": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RemoveAutoScalingPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId",
	          "InstanceGroupId"
	        ],
	        "members": {
	          "ClusterId": {},
	          "InstanceGroupId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RemoveAutoTerminationPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RemoveManagedScalingPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterId"
	        ],
	        "members": {
	          "ClusterId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RemoveTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceId": {},
	          "TagKeys": {
	            "shape": "S2s"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RunJobFlow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Instances"
	        ],
	        "members": {
	          "Name": {},
	          "LogUri": {},
	          "LogEncryptionKmsKeyId": {},
	          "AdditionalInfo": {},
	          "AmiVersion": {},
	          "ReleaseLabel": {},
	          "Instances": {
	            "type": "structure",
	            "members": {
	              "MasterInstanceType": {},
	              "SlaveInstanceType": {},
	              "InstanceCount": {
	                "type": "integer"
	              },
	              "InstanceGroups": {
	                "shape": "Sx"
	              },
	              "InstanceFleets": {
	                "type": "list",
	                "member": {
	                  "shape": "S3"
	                }
	              },
	              "Ec2KeyName": {},
	              "Placement": {
	                "shape": "S3f"
	              },
	              "KeepJobFlowAliveWhenNoSteps": {
	                "type": "boolean"
	              },
	              "TerminationProtected": {
	                "type": "boolean"
	              },
	              "HadoopVersion": {},
	              "Ec2SubnetId": {},
	              "Ec2SubnetIds": {
	                "shape": "S2r"
	              },
	              "EmrManagedMasterSecurityGroup": {},
	              "EmrManagedSlaveSecurityGroup": {},
	              "ServiceAccessSecurityGroup": {},
	              "AdditionalMasterSecurityGroups": {
	                "shape": "S7z"
	              },
	              "AdditionalSlaveSecurityGroups": {
	                "shape": "S7z"
	              }
	            }
	          },
	          "Steps": {
	            "shape": "S1i"
	          },
	          "BootstrapActions": {
	            "type": "list",
	            "member": {
	              "shape": "S3m"
	            }
	          },
	          "SupportedProducts": {
	            "shape": "S3o"
	          },
	          "NewSupportedProducts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Args": {
	                  "shape": "S1p"
	                }
	              }
	            }
	          },
	          "Applications": {
	            "shape": "S2v"
	          },
	          "Configurations": {
	            "shape": "Sh"
	          },
	          "VisibleToAllUsers": {
	            "type": "boolean"
	          },
	          "JobFlowRole": {},
	          "ServiceRole": {},
	          "Tags": {
	            "shape": "S1u"
	          },
	          "SecurityConfiguration": {},
	          "AutoScalingRole": {},
	          "ScaleDownBehavior": {},
	          "CustomAmiId": {},
	          "EbsRootVolumeSize": {
	            "type": "integer"
	          },
	          "RepoUpgradeOnBoot": {},
	          "KerberosAttributes": {
	            "shape": "S2z"
	          },
	          "StepConcurrencyLevel": {
	            "type": "integer"
	          },
	          "ManagedScalingPolicy": {
	            "shape": "S4u"
	          },
	          "PlacementGroupConfigs": {
	            "shape": "S31"
	          },
	          "AutoTerminationPolicy": {
	            "shape": "S4j"
	          },
	          "OSReleaseLabel": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobFlowId": {},
	          "ClusterArn": {}
	        }
	      }
	    },
	    "SetTerminationProtection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobFlowIds",
	          "TerminationProtected"
	        ],
	        "members": {
	          "JobFlowIds": {
	            "shape": "S1p"
	          },
	          "TerminationProtected": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "SetVisibleToAllUsers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobFlowIds",
	          "VisibleToAllUsers"
	        ],
	        "members": {
	          "JobFlowIds": {
	            "shape": "S1p"
	          },
	          "VisibleToAllUsers": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "StartNotebookExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EditorId",
	          "RelativePath",
	          "ExecutionEngine",
	          "ServiceRole"
	        ],
	        "members": {
	          "EditorId": {},
	          "RelativePath": {},
	          "NotebookExecutionName": {},
	          "NotebookParams": {},
	          "ExecutionEngine": {
	            "shape": "S3s"
	          },
	          "ServiceRole": {},
	          "NotebookInstanceSecurityGroupId": {},
	          "Tags": {
	            "shape": "S1u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NotebookExecutionId": {}
	        }
	      }
	    },
	    "StopNotebookExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NotebookExecutionId"
	        ],
	        "members": {
	          "NotebookExecutionId": {}
	        }
	      }
	    },
	    "TerminateJobFlows": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobFlowIds"
	        ],
	        "members": {
	          "JobFlowIds": {
	            "shape": "S1p"
	          }
	        }
	      }
	    },
	    "UpdateStudio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StudioId"
	        ],
	        "members": {
	          "StudioId": {},
	          "Name": {},
	          "Description": {},
	          "SubnetIds": {
	            "shape": "S29"
	          },
	          "DefaultS3Location": {}
	        }
	      }
	    },
	    "UpdateStudioSessionMapping": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StudioId",
	          "IdentityType",
	          "SessionPolicyArn"
	        ],
	        "members": {
	          "StudioId": {},
	          "IdentityId": {},
	          "IdentityName": {},
	          "IdentityType": {},
	          "SessionPolicyArn": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S3": {
	      "type": "structure",
	      "required": [
	        "InstanceFleetType"
	      ],
	      "members": {
	        "Name": {},
	        "InstanceFleetType": {},
	        "TargetOnDemandCapacity": {
	          "type": "integer"
	        },
	        "TargetSpotCapacity": {
	          "type": "integer"
	        },
	        "InstanceTypeConfigs": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "InstanceType"
	            ],
	            "members": {
	              "InstanceType": {},
	              "WeightedCapacity": {
	                "type": "integer"
	              },
	              "BidPrice": {},
	              "BidPriceAsPercentageOfOnDemandPrice": {
	                "type": "double"
	              },
	              "EbsConfiguration": {
	                "shape": "Sa"
	              },
	              "Configurations": {
	                "shape": "Sh"
	              },
	              "CustomAmiId": {}
	            }
	          }
	        },
	        "LaunchSpecifications": {
	          "shape": "Sk"
	        }
	      }
	    },
	    "Sa": {
	      "type": "structure",
	      "members": {
	        "EbsBlockDeviceConfigs": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "VolumeSpecification"
	            ],
	            "members": {
	              "VolumeSpecification": {
	                "shape": "Sd"
	              },
	              "VolumesPerInstance": {
	                "type": "integer"
	              }
	            }
	          }
	        },
	        "EbsOptimized": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Sd": {
	      "type": "structure",
	      "required": [
	        "VolumeType",
	        "SizeInGB"
	      ],
	      "members": {
	        "VolumeType": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "SizeInGB": {
	          "type": "integer"
	        }
	      }
	    },
	    "Sh": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Classification": {},
	          "Configurations": {
	            "shape": "Sh"
	          },
	          "Properties": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "Sj": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sk": {
	      "type": "structure",
	      "members": {
	        "SpotSpecification": {
	          "type": "structure",
	          "required": [
	            "TimeoutDurationMinutes",
	            "TimeoutAction"
	          ],
	          "members": {
	            "TimeoutDurationMinutes": {
	              "type": "integer"
	            },
	            "TimeoutAction": {},
	            "BlockDurationMinutes": {
	              "type": "integer"
	            },
	            "AllocationStrategy": {}
	          }
	        },
	        "OnDemandSpecification": {
	          "type": "structure",
	          "required": [
	            "AllocationStrategy"
	          ],
	          "members": {
	            "AllocationStrategy": {},
	            "CapacityReservationOptions": {
	              "type": "structure",
	              "members": {
	                "UsageStrategy": {},
	                "CapacityReservationPreference": {},
	                "CapacityReservationResourceGroupArn": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sx": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "InstanceRole",
	          "InstanceType",
	          "InstanceCount"
	        ],
	        "members": {
	          "Name": {},
	          "Market": {},
	          "InstanceRole": {},
	          "BidPrice": {},
	          "InstanceType": {},
	          "InstanceCount": {
	            "type": "integer"
	          },
	          "Configurations": {
	            "shape": "Sh"
	          },
	          "EbsConfiguration": {
	            "shape": "Sa"
	          },
	          "AutoScalingPolicy": {
	            "shape": "S11"
	          },
	          "CustomAmiId": {}
	        }
	      }
	    },
	    "S11": {
	      "type": "structure",
	      "required": [
	        "Constraints",
	        "Rules"
	      ],
	      "members": {
	        "Constraints": {
	          "shape": "S12"
	        },
	        "Rules": {
	          "shape": "S13"
	        }
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "required": [
	        "MinCapacity",
	        "MaxCapacity"
	      ],
	      "members": {
	        "MinCapacity": {
	          "type": "integer"
	        },
	        "MaxCapacity": {
	          "type": "integer"
	        }
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Action",
	          "Trigger"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "Action": {
	            "type": "structure",
	            "required": [
	              "SimpleScalingPolicyConfiguration"
	            ],
	            "members": {
	              "Market": {},
	              "SimpleScalingPolicyConfiguration": {
	                "type": "structure",
	                "required": [
	                  "ScalingAdjustment"
	                ],
	                "members": {
	                  "AdjustmentType": {},
	                  "ScalingAdjustment": {
	                    "type": "integer"
	                  },
	                  "CoolDown": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          },
	          "Trigger": {
	            "type": "structure",
	            "required": [
	              "CloudWatchAlarmDefinition"
	            ],
	            "members": {
	              "CloudWatchAlarmDefinition": {
	                "type": "structure",
	                "required": [
	                  "ComparisonOperator",
	                  "MetricName",
	                  "Period",
	                  "Threshold"
	                ],
	                "members": {
	                  "ComparisonOperator": {},
	                  "EvaluationPeriods": {
	                    "type": "integer"
	                  },
	                  "MetricName": {},
	                  "Namespace": {},
	                  "Period": {
	                    "type": "integer"
	                  },
	                  "Statistic": {},
	                  "Threshold": {
	                    "type": "double"
	                  },
	                  "Unit": {},
	                  "Dimensions": {
	                    "type": "list",
	                    "member": {
	                      "type": "structure",
	                      "members": {
	                        "Key": {},
	                        "Value": {}
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1i": {
	      "type": "list",
	      "member": {
	        "shape": "S1j"
	      }
	    },
	    "S1j": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "HadoopJarStep"
	      ],
	      "members": {
	        "Name": {},
	        "ActionOnFailure": {},
	        "HadoopJarStep": {
	          "type": "structure",
	          "required": [
	            "Jar"
	          ],
	          "members": {
	            "Properties": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "Key": {},
	                  "Value": {}
	                }
	              }
	            },
	            "Jar": {},
	            "MainClass": {},
	            "Args": {
	              "shape": "S1p"
	            }
	          }
	        }
	      }
	    },
	    "S1p": {
	      "type": "list",
	      "member": {}
	    },
	    "S1r": {
	      "type": "list",
	      "member": {}
	    },
	    "S1u": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S29": {
	      "type": "list",
	      "member": {}
	    },
	    "S2l": {
	      "type": "structure",
	      "members": {
	        "State": {},
	        "StateChangeReason": {
	          "type": "structure",
	          "members": {
	            "Code": {},
	            "Message": {}
	          }
	        },
	        "Timeline": {
	          "type": "structure",
	          "members": {
	            "CreationDateTime": {
	              "type": "timestamp"
	            },
	            "ReadyDateTime": {
	              "type": "timestamp"
	            },
	            "EndDateTime": {
	              "type": "timestamp"
	            }
	          }
	        }
	      }
	    },
	    "S2r": {
	      "type": "list",
	      "member": {}
	    },
	    "S2s": {
	      "type": "list",
	      "member": {}
	    },
	    "S2v": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Version": {},
	          "Args": {
	            "shape": "S2s"
	          },
	          "AdditionalInfo": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "S2z": {
	      "type": "structure",
	      "required": [
	        "Realm",
	        "KdcAdminPassword"
	      ],
	      "members": {
	        "Realm": {},
	        "KdcAdminPassword": {},
	        "CrossRealmTrustPrincipalPassword": {},
	        "ADDomainJoinUser": {},
	        "ADDomainJoinPassword": {}
	      }
	    },
	    "S31": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "InstanceRole"
	        ],
	        "members": {
	          "InstanceRole": {},
	          "PlacementStrategy": {}
	        }
	      }
	    },
	    "S3f": {
	      "type": "structure",
	      "members": {
	        "AvailabilityZone": {},
	        "AvailabilityZones": {
	          "shape": "S2r"
	        }
	      }
	    },
	    "S3m": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "ScriptBootstrapAction"
	      ],
	      "members": {
	        "Name": {},
	        "ScriptBootstrapAction": {
	          "type": "structure",
	          "required": [
	            "Path"
	          ],
	          "members": {
	            "Path": {},
	            "Args": {
	              "shape": "S1p"
	            }
	          }
	        }
	      }
	    },
	    "S3o": {
	      "type": "list",
	      "member": {}
	    },
	    "S3s": {
	      "type": "structure",
	      "required": [
	        "Id"
	      ],
	      "members": {
	        "Id": {},
	        "Type": {},
	        "MasterInstanceSecurityGroupId": {}
	      }
	    },
	    "S47": {
	      "type": "structure",
	      "members": {
	        "Jar": {},
	        "Properties": {
	          "shape": "Sj"
	        },
	        "MainClass": {},
	        "Args": {
	          "shape": "S2s"
	        }
	      }
	    },
	    "S48": {
	      "type": "structure",
	      "members": {
	        "State": {},
	        "StateChangeReason": {
	          "type": "structure",
	          "members": {
	            "Code": {},
	            "Message": {}
	          }
	        },
	        "FailureDetails": {
	          "type": "structure",
	          "members": {
	            "Reason": {},
	            "Message": {},
	            "LogFile": {}
	          }
	        },
	        "Timeline": {
	          "type": "structure",
	          "members": {
	            "CreationDateTime": {
	              "type": "timestamp"
	            },
	            "StartDateTime": {
	              "type": "timestamp"
	            },
	            "EndDateTime": {
	              "type": "timestamp"
	            }
	          }
	        }
	      }
	    },
	    "S4j": {
	      "type": "structure",
	      "members": {
	        "IdleTimeout": {
	          "type": "long"
	        }
	      }
	    },
	    "S4n": {
	      "type": "structure",
	      "required": [
	        "BlockPublicSecurityGroupRules"
	      ],
	      "members": {
	        "BlockPublicSecurityGroupRules": {
	          "type": "boolean"
	        },
	        "PermittedPublicSecurityGroupRuleRanges": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "MinRange"
	            ],
	            "members": {
	              "MinRange": {
	                "type": "integer"
	              },
	              "MaxRange": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S4u": {
	      "type": "structure",
	      "members": {
	        "ComputeLimits": {
	          "type": "structure",
	          "required": [
	            "UnitType",
	            "MinimumCapacityUnits",
	            "MaximumCapacityUnits"
	          ],
	          "members": {
	            "UnitType": {},
	            "MinimumCapacityUnits": {
	              "type": "integer"
	            },
	            "MaximumCapacityUnits": {
	              "type": "integer"
	            },
	            "MaximumOnDemandCapacityUnits": {
	              "type": "integer"
	            },
	            "MaximumCoreCapacityUnits": {
	              "type": "integer"
	            }
	          }
	        }
	      }
	    },
	    "S5l": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "VolumeSpecification": {
	            "shape": "Sd"
	          },
	          "Device": {}
	        }
	      }
	    },
	    "S5x": {
	      "type": "structure",
	      "members": {
	        "DecommissionTimeout": {
	          "type": "integer"
	        },
	        "InstanceResizePolicy": {
	          "type": "structure",
	          "members": {
	            "InstancesToTerminate": {
	              "shape": "S5z"
	            },
	            "InstancesToProtect": {
	              "shape": "S5z"
	            },
	            "InstanceTerminationTimeout": {
	              "type": "integer"
	            }
	          }
	        }
	      }
	    },
	    "S5z": {
	      "type": "list",
	      "member": {}
	    },
	    "S61": {
	      "type": "structure",
	      "members": {
	        "Status": {
	          "type": "structure",
	          "members": {
	            "State": {},
	            "StateChangeReason": {
	              "type": "structure",
	              "members": {
	                "Code": {},
	                "Message": {}
	              }
	            }
	          }
	        },
	        "Constraints": {
	          "shape": "S12"
	        },
	        "Rules": {
	          "shape": "S13"
	        }
	      }
	    },
	    "S7z": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],103:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeJobFlows": {
	      "result_key": "JobFlows"
	    },
	    "ListBootstrapActions": {
	      "input_token": "Marker",
	      "output_token": "Marker",
	      "result_key": "BootstrapActions"
	    },
	    "ListClusters": {
	      "input_token": "Marker",
	      "output_token": "Marker",
	      "result_key": "Clusters"
	    },
	    "ListInstanceFleets": {
	      "input_token": "Marker",
	      "output_token": "Marker",
	      "result_key": "InstanceFleets"
	    },
	    "ListInstanceGroups": {
	      "input_token": "Marker",
	      "output_token": "Marker",
	      "result_key": "InstanceGroups"
	    },
	    "ListInstances": {
	      "input_token": "Marker",
	      "output_token": "Marker",
	      "result_key": "Instances"
	    },
	    "ListNotebookExecutions": {
	      "input_token": "Marker",
	      "output_token": "Marker",
	      "result_key": "NotebookExecutions"
	    },
	    "ListReleaseLabels": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListSecurityConfigurations": {
	      "input_token": "Marker",
	      "output_token": "Marker",
	      "result_key": "SecurityConfigurations"
	    },
	    "ListSteps": {
	      "input_token": "Marker",
	      "output_token": "Marker",
	      "result_key": "Steps"
	    },
	    "ListStudioSessionMappings": {
	      "input_token": "Marker",
	      "output_token": "Marker",
	      "result_key": "SessionMappings"
	    },
	    "ListStudios": {
	      "input_token": "Marker",
	      "output_token": "Marker",
	      "result_key": "Studios"
	    }
	  }
	}
	},{}],104:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "ClusterRunning": {
	      "delay": 30,
	      "operation": "DescribeCluster",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "path",
	          "argument": "Cluster.Status.State",
	          "expected": "RUNNING"
	        },
	        {
	          "state": "success",
	          "matcher": "path",
	          "argument": "Cluster.Status.State",
	          "expected": "WAITING"
	        },
	        {
	          "state": "failure",
	          "matcher": "path",
	          "argument": "Cluster.Status.State",
	          "expected": "TERMINATING"
	        },
	        {
	          "state": "failure",
	          "matcher": "path",
	          "argument": "Cluster.Status.State",
	          "expected": "TERMINATED"
	        },
	        {
	          "state": "failure",
	          "matcher": "path",
	          "argument": "Cluster.Status.State",
	          "expected": "TERMINATED_WITH_ERRORS"
	        }
	      ]
	    },
	    "StepComplete": {
	      "delay": 30,
	      "operation": "DescribeStep",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "path",
	          "argument": "Step.Status.State",
	          "expected": "COMPLETED"
	        },
	        {
	          "state": "failure",
	          "matcher": "path",
	          "argument": "Step.Status.State",
	          "expected": "FAILED"
	        },
	        {
	          "state": "failure",
	          "matcher": "path",
	          "argument": "Step.Status.State",
	          "expected": "CANCELLED"
	        }
	      ]
	    },
	    "ClusterTerminated": {
	      "delay": 30,
	      "operation": "DescribeCluster",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "path",
	          "argument": "Cluster.Status.State",
	          "expected": "TERMINATED"
	        },
	        {
	          "state": "failure",
	          "matcher": "path",
	          "argument": "Cluster.Status.State",
	          "expected": "TERMINATED_WITH_ERRORS"
	        }
	      ]
	    }
	  }
	}
	
	},{}],105:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2012-09-25",
	    "endpointPrefix": "elastictranscoder",
	    "protocol": "rest-json",
	    "serviceFullName": "Amazon Elastic Transcoder",
	    "serviceId": "Elastic Transcoder",
	    "signatureVersion": "v4",
	    "uid": "elastictranscoder-2012-09-25"
	  },
	  "operations": {
	    "CancelJob": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2012-09-25/jobs/{Id}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateJob": {
	      "http": {
	        "requestUri": "/2012-09-25/jobs",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PipelineId"
	        ],
	        "members": {
	          "PipelineId": {},
	          "Input": {
	            "shape": "S5"
	          },
	          "Inputs": {
	            "shape": "St"
	          },
	          "Output": {
	            "shape": "Su"
	          },
	          "Outputs": {
	            "type": "list",
	            "member": {
	              "shape": "Su"
	            }
	          },
	          "OutputKeyPrefix": {},
	          "Playlists": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Format": {},
	                "OutputKeys": {
	                  "shape": "S1l"
	                },
	                "HlsContentProtection": {
	                  "shape": "S1m"
	                },
	                "PlayReadyDrm": {
	                  "shape": "S1q"
	                }
	              }
	            }
	          },
	          "UserMetadata": {
	            "shape": "S1v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Job": {
	            "shape": "S1y"
	          }
	        }
	      }
	    },
	    "CreatePipeline": {
	      "http": {
	        "requestUri": "/2012-09-25/pipelines",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "InputBucket",
	          "Role"
	        ],
	        "members": {
	          "Name": {},
	          "InputBucket": {},
	          "OutputBucket": {},
	          "Role": {},
	          "AwsKmsKeyArn": {},
	          "Notifications": {
	            "shape": "S2a"
	          },
	          "ContentConfig": {
	            "shape": "S2c"
	          },
	          "ThumbnailConfig": {
	            "shape": "S2c"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Pipeline": {
	            "shape": "S2l"
	          },
	          "Warnings": {
	            "shape": "S2n"
	          }
	        }
	      }
	    },
	    "CreatePreset": {
	      "http": {
	        "requestUri": "/2012-09-25/presets",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Container"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "Container": {},
	          "Video": {
	            "shape": "S2r"
	          },
	          "Audio": {
	            "shape": "S37"
	          },
	          "Thumbnails": {
	            "shape": "S3i"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Preset": {
	            "shape": "S3m"
	          },
	          "Warning": {}
	        }
	      }
	    },
	    "DeletePipeline": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2012-09-25/pipelines/{Id}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeletePreset": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2012-09-25/presets/{Id}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ListJobsByPipeline": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2012-09-25/jobsByPipeline/{PipelineId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "PipelineId"
	        ],
	        "members": {
	          "PipelineId": {
	            "location": "uri",
	            "locationName": "PipelineId"
	          },
	          "Ascending": {
	            "location": "querystring",
	            "locationName": "Ascending"
	          },
	          "PageToken": {
	            "location": "querystring",
	            "locationName": "PageToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Jobs": {
	            "shape": "S3v"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListJobsByStatus": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2012-09-25/jobsByStatus/{Status}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Status"
	        ],
	        "members": {
	          "Status": {
	            "location": "uri",
	            "locationName": "Status"
	          },
	          "Ascending": {
	            "location": "querystring",
	            "locationName": "Ascending"
	          },
	          "PageToken": {
	            "location": "querystring",
	            "locationName": "PageToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Jobs": {
	            "shape": "S3v"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListPipelines": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2012-09-25/pipelines"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Ascending": {
	            "location": "querystring",
	            "locationName": "Ascending"
	          },
	          "PageToken": {
	            "location": "querystring",
	            "locationName": "PageToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Pipelines": {
	            "type": "list",
	            "member": {
	              "shape": "S2l"
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListPresets": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2012-09-25/presets"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Ascending": {
	            "location": "querystring",
	            "locationName": "Ascending"
	          },
	          "PageToken": {
	            "location": "querystring",
	            "locationName": "PageToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Presets": {
	            "type": "list",
	            "member": {
	              "shape": "S3m"
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ReadJob": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2012-09-25/jobs/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Job": {
	            "shape": "S1y"
	          }
	        }
	      }
	    },
	    "ReadPipeline": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2012-09-25/pipelines/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Pipeline": {
	            "shape": "S2l"
	          },
	          "Warnings": {
	            "shape": "S2n"
	          }
	        }
	      }
	    },
	    "ReadPreset": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2012-09-25/presets/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Preset": {
	            "shape": "S3m"
	          }
	        }
	      }
	    },
	    "TestRole": {
	      "http": {
	        "requestUri": "/2012-09-25/roleTests",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Role",
	          "InputBucket",
	          "OutputBucket",
	          "Topics"
	        ],
	        "members": {
	          "Role": {},
	          "InputBucket": {},
	          "OutputBucket": {},
	          "Topics": {
	            "type": "list",
	            "member": {}
	          }
	        },
	        "deprecated": true
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Success": {},
	          "Messages": {
	            "type": "list",
	            "member": {}
	          }
	        },
	        "deprecated": true
	      },
	      "deprecated": true
	    },
	    "UpdatePipeline": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2012-09-25/pipelines/{Id}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "Name": {},
	          "InputBucket": {},
	          "Role": {},
	          "AwsKmsKeyArn": {},
	          "Notifications": {
	            "shape": "S2a"
	          },
	          "ContentConfig": {
	            "shape": "S2c"
	          },
	          "ThumbnailConfig": {
	            "shape": "S2c"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Pipeline": {
	            "shape": "S2l"
	          },
	          "Warnings": {
	            "shape": "S2n"
	          }
	        }
	      }
	    },
	    "UpdatePipelineNotifications": {
	      "http": {
	        "requestUri": "/2012-09-25/pipelines/{Id}/notifications"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id",
	          "Notifications"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "Notifications": {
	            "shape": "S2a"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Pipeline": {
	            "shape": "S2l"
	          }
	        }
	      }
	    },
	    "UpdatePipelineStatus": {
	      "http": {
	        "requestUri": "/2012-09-25/pipelines/{Id}/status"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id",
	          "Status"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "Status": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Pipeline": {
	            "shape": "S2l"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S5": {
	      "type": "structure",
	      "members": {
	        "Key": {},
	        "FrameRate": {},
	        "Resolution": {},
	        "AspectRatio": {},
	        "Interlaced": {},
	        "Container": {},
	        "Encryption": {
	          "shape": "Sc"
	        },
	        "TimeSpan": {
	          "shape": "Sg"
	        },
	        "InputCaptions": {
	          "type": "structure",
	          "members": {
	            "MergePolicy": {},
	            "CaptionSources": {
	              "shape": "Sk"
	            }
	          }
	        },
	        "DetectedProperties": {
	          "type": "structure",
	          "members": {
	            "Width": {
	              "type": "integer"
	            },
	            "Height": {
	              "type": "integer"
	            },
	            "FrameRate": {},
	            "FileSize": {
	              "type": "long"
	            },
	            "DurationMillis": {
	              "type": "long"
	            }
	          }
	        }
	      }
	    },
	    "Sc": {
	      "type": "structure",
	      "members": {
	        "Mode": {},
	        "Key": {},
	        "KeyMd5": {},
	        "InitializationVector": {}
	      }
	    },
	    "Sg": {
	      "type": "structure",
	      "members": {
	        "StartTime": {},
	        "Duration": {}
	      }
	    },
	    "Sk": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Language": {},
	          "TimeOffset": {},
	          "Label": {},
	          "Encryption": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "St": {
	      "type": "list",
	      "member": {
	        "shape": "S5"
	      }
	    },
	    "Su": {
	      "type": "structure",
	      "members": {
	        "Key": {},
	        "ThumbnailPattern": {},
	        "ThumbnailEncryption": {
	          "shape": "Sc"
	        },
	        "Rotate": {},
	        "PresetId": {},
	        "SegmentDuration": {},
	        "Watermarks": {
	          "shape": "Sx"
	        },
	        "AlbumArt": {
	          "shape": "S11"
	        },
	        "Composition": {
	          "shape": "S19",
	          "deprecated": true
	        },
	        "Captions": {
	          "shape": "S1b"
	        },
	        "Encryption": {
	          "shape": "Sc"
	        }
	      }
	    },
	    "Sx": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "PresetWatermarkId": {},
	          "InputKey": {},
	          "Encryption": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "S11": {
	      "type": "structure",
	      "members": {
	        "MergePolicy": {},
	        "Artwork": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "InputKey": {},
	              "MaxWidth": {},
	              "MaxHeight": {},
	              "SizingPolicy": {},
	              "PaddingPolicy": {},
	              "AlbumArtFormat": {},
	              "Encryption": {
	                "shape": "Sc"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S19": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "TimeSpan": {
	            "shape": "Sg"
	          }
	        },
	        "deprecated": true
	      },
	      "deprecated": true
	    },
	    "S1b": {
	      "type": "structure",
	      "members": {
	        "MergePolicy": {
	          "deprecated": true
	        },
	        "CaptionSources": {
	          "shape": "Sk",
	          "deprecated": true
	        },
	        "CaptionFormats": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Format": {},
	              "Pattern": {},
	              "Encryption": {
	                "shape": "Sc"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1l": {
	      "type": "list",
	      "member": {}
	    },
	    "S1m": {
	      "type": "structure",
	      "members": {
	        "Method": {},
	        "Key": {},
	        "KeyMd5": {},
	        "InitializationVector": {},
	        "LicenseAcquisitionUrl": {},
	        "KeyStoragePolicy": {}
	      }
	    },
	    "S1q": {
	      "type": "structure",
	      "members": {
	        "Format": {},
	        "Key": {},
	        "KeyMd5": {},
	        "KeyId": {},
	        "InitializationVector": {},
	        "LicenseAcquisitionUrl": {}
	      }
	    },
	    "S1v": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S1y": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Arn": {},
	        "PipelineId": {},
	        "Input": {
	          "shape": "S5"
	        },
	        "Inputs": {
	          "shape": "St"
	        },
	        "Output": {
	          "shape": "S1z"
	        },
	        "Outputs": {
	          "type": "list",
	          "member": {
	            "shape": "S1z"
	          }
	        },
	        "OutputKeyPrefix": {},
	        "Playlists": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Name": {},
	              "Format": {},
	              "OutputKeys": {
	                "shape": "S1l"
	              },
	              "HlsContentProtection": {
	                "shape": "S1m"
	              },
	              "PlayReadyDrm": {
	                "shape": "S1q"
	              },
	              "Status": {},
	              "StatusDetail": {}
	            }
	          }
	        },
	        "Status": {},
	        "UserMetadata": {
	          "shape": "S1v"
	        },
	        "Timing": {
	          "type": "structure",
	          "members": {
	            "SubmitTimeMillis": {
	              "type": "long"
	            },
	            "StartTimeMillis": {
	              "type": "long"
	            },
	            "FinishTimeMillis": {
	              "type": "long"
	            }
	          }
	        }
	      }
	    },
	    "S1z": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Key": {},
	        "ThumbnailPattern": {},
	        "ThumbnailEncryption": {
	          "shape": "Sc"
	        },
	        "Rotate": {},
	        "PresetId": {},
	        "SegmentDuration": {},
	        "Status": {},
	        "StatusDetail": {},
	        "Duration": {
	          "type": "long"
	        },
	        "Width": {
	          "type": "integer"
	        },
	        "Height": {
	          "type": "integer"
	        },
	        "FrameRate": {},
	        "FileSize": {
	          "type": "long"
	        },
	        "DurationMillis": {
	          "type": "long"
	        },
	        "Watermarks": {
	          "shape": "Sx"
	        },
	        "AlbumArt": {
	          "shape": "S11"
	        },
	        "Composition": {
	          "shape": "S19",
	          "deprecated": true
	        },
	        "Captions": {
	          "shape": "S1b"
	        },
	        "Encryption": {
	          "shape": "Sc"
	        },
	        "AppliedColorSpaceConversion": {}
	      }
	    },
	    "S2a": {
	      "type": "structure",
	      "members": {
	        "Progressing": {},
	        "Completed": {},
	        "Warning": {},
	        "Error": {}
	      }
	    },
	    "S2c": {
	      "type": "structure",
	      "members": {
	        "Bucket": {},
	        "StorageClass": {},
	        "Permissions": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "GranteeType": {},
	              "Grantee": {},
	              "Access": {
	                "type": "list",
	                "member": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2l": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Arn": {},
	        "Name": {},
	        "Status": {},
	        "InputBucket": {},
	        "OutputBucket": {},
	        "Role": {},
	        "AwsKmsKeyArn": {},
	        "Notifications": {
	          "shape": "S2a"
	        },
	        "ContentConfig": {
	          "shape": "S2c"
	        },
	        "ThumbnailConfig": {
	          "shape": "S2c"
	        }
	      }
	    },
	    "S2n": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Code": {},
	          "Message": {}
	        }
	      }
	    },
	    "S2r": {
	      "type": "structure",
	      "members": {
	        "Codec": {},
	        "CodecOptions": {
	          "type": "map",
	          "key": {},
	          "value": {}
	        },
	        "KeyframesMaxDist": {},
	        "FixedGOP": {},
	        "BitRate": {},
	        "FrameRate": {},
	        "MaxFrameRate": {},
	        "Resolution": {},
	        "AspectRatio": {},
	        "MaxWidth": {},
	        "MaxHeight": {},
	        "DisplayAspectRatio": {},
	        "SizingPolicy": {},
	        "PaddingPolicy": {},
	        "Watermarks": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Id": {},
	              "MaxWidth": {},
	              "MaxHeight": {},
	              "SizingPolicy": {},
	              "HorizontalAlign": {},
	              "HorizontalOffset": {},
	              "VerticalAlign": {},
	              "VerticalOffset": {},
	              "Opacity": {},
	              "Target": {}
	            }
	          }
	        }
	      }
	    },
	    "S37": {
	      "type": "structure",
	      "members": {
	        "Codec": {},
	        "SampleRate": {},
	        "BitRate": {},
	        "Channels": {},
	        "AudioPackingMode": {},
	        "CodecOptions": {
	          "type": "structure",
	          "members": {
	            "Profile": {},
	            "BitDepth": {},
	            "BitOrder": {},
	            "Signed": {}
	          }
	        }
	      }
	    },
	    "S3i": {
	      "type": "structure",
	      "members": {
	        "Format": {},
	        "Interval": {},
	        "Resolution": {},
	        "AspectRatio": {},
	        "MaxWidth": {},
	        "MaxHeight": {},
	        "SizingPolicy": {},
	        "PaddingPolicy": {}
	      }
	    },
	    "S3m": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Arn": {},
	        "Name": {},
	        "Description": {},
	        "Container": {},
	        "Audio": {
	          "shape": "S37"
	        },
	        "Video": {
	          "shape": "S2r"
	        },
	        "Thumbnails": {
	          "shape": "S3i"
	        },
	        "Type": {}
	      }
	    },
	    "S3v": {
	      "type": "list",
	      "member": {
	        "shape": "S1y"
	      }
	    }
	  }
	}
	},{}],106:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListJobsByPipeline": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "result_key": "Jobs"
	    },
	    "ListJobsByStatus": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "result_key": "Jobs"
	    },
	    "ListPipelines": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "result_key": "Pipelines"
	    },
	    "ListPresets": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "result_key": "Presets"
	    }
	  }
	}
	},{}],107:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "JobComplete": {
	      "delay": 30,
	      "operation": "ReadJob",
	      "maxAttempts": 120,
	      "acceptors": [
	        {
	          "expected": "Complete",
	          "matcher": "path",
	          "state": "success",
	          "argument": "Job.Status"
	        },
	        {
	          "expected": "Canceled",
	          "matcher": "path",
	          "state": "failure",
	          "argument": "Job.Status"
	        },
	        {
	          "expected": "Error",
	          "matcher": "path",
	          "state": "failure",
	          "argument": "Job.Status"
	        }
	      ]
	    }
	  }
	}
	
	},{}],108:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2010-12-01",
	    "endpointPrefix": "email",
	    "protocol": "query",
	    "serviceAbbreviation": "Amazon SES",
	    "serviceFullName": "Amazon Simple Email Service",
	    "serviceId": "SES",
	    "signatureVersion": "v4",
	    "signingName": "ses",
	    "uid": "email-2010-12-01",
	    "xmlNamespace": "http://ses.amazonaws.com/doc/2010-12-01/"
	  },
	  "operations": {
	    "CloneReceiptRuleSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleSetName",
	          "OriginalRuleSetName"
	        ],
	        "members": {
	          "RuleSetName": {},
	          "OriginalRuleSetName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CloneReceiptRuleSetResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateConfigurationSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSet"
	        ],
	        "members": {
	          "ConfigurationSet": {
	            "shape": "S5"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateConfigurationSetResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateConfigurationSetEventDestination": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSetName",
	          "EventDestination"
	        ],
	        "members": {
	          "ConfigurationSetName": {},
	          "EventDestination": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateConfigurationSetEventDestinationResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateConfigurationSetTrackingOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSetName",
	          "TrackingOptions"
	        ],
	        "members": {
	          "ConfigurationSetName": {},
	          "TrackingOptions": {
	            "shape": "Sp"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateConfigurationSetTrackingOptionsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateCustomVerificationEmailTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TemplateName",
	          "FromEmailAddress",
	          "TemplateSubject",
	          "TemplateContent",
	          "SuccessRedirectionURL",
	          "FailureRedirectionURL"
	        ],
	        "members": {
	          "TemplateName": {},
	          "FromEmailAddress": {},
	          "TemplateSubject": {},
	          "TemplateContent": {},
	          "SuccessRedirectionURL": {},
	          "FailureRedirectionURL": {}
	        }
	      }
	    },
	    "CreateReceiptFilter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Filter"
	        ],
	        "members": {
	          "Filter": {
	            "shape": "S10"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateReceiptFilterResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateReceiptRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleSetName",
	          "Rule"
	        ],
	        "members": {
	          "RuleSetName": {},
	          "After": {},
	          "Rule": {
	            "shape": "S18"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateReceiptRuleResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateReceiptRuleSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleSetName"
	        ],
	        "members": {
	          "RuleSetName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateReceiptRuleSetResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Template"
	        ],
	        "members": {
	          "Template": {
	            "shape": "S20"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateTemplateResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteConfigurationSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSetName"
	        ],
	        "members": {
	          "ConfigurationSetName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteConfigurationSetResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteConfigurationSetEventDestination": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSetName",
	          "EventDestinationName"
	        ],
	        "members": {
	          "ConfigurationSetName": {},
	          "EventDestinationName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteConfigurationSetEventDestinationResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteConfigurationSetTrackingOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSetName"
	        ],
	        "members": {
	          "ConfigurationSetName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteConfigurationSetTrackingOptionsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteCustomVerificationEmailTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TemplateName"
	        ],
	        "members": {
	          "TemplateName": {}
	        }
	      }
	    },
	    "DeleteIdentity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identity"
	        ],
	        "members": {
	          "Identity": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteIdentityResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteIdentityPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identity",
	          "PolicyName"
	        ],
	        "members": {
	          "Identity": {},
	          "PolicyName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteIdentityPolicyResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteReceiptFilter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FilterName"
	        ],
	        "members": {
	          "FilterName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteReceiptFilterResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteReceiptRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleSetName",
	          "RuleName"
	        ],
	        "members": {
	          "RuleSetName": {},
	          "RuleName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteReceiptRuleResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteReceiptRuleSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleSetName"
	        ],
	        "members": {
	          "RuleSetName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteReceiptRuleSetResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TemplateName"
	        ],
	        "members": {
	          "TemplateName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteTemplateResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteVerifiedEmailAddress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EmailAddress"
	        ],
	        "members": {
	          "EmailAddress": {}
	        }
	      }
	    },
	    "DescribeActiveReceiptRuleSet": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "resultWrapper": "DescribeActiveReceiptRuleSetResult",
	        "type": "structure",
	        "members": {
	          "Metadata": {
	            "shape": "S2t"
	          },
	          "Rules": {
	            "shape": "S2v"
	          }
	        }
	      }
	    },
	    "DescribeConfigurationSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSetName"
	        ],
	        "members": {
	          "ConfigurationSetName": {},
	          "ConfigurationSetAttributeNames": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeConfigurationSetResult",
	        "type": "structure",
	        "members": {
	          "ConfigurationSet": {
	            "shape": "S5"
	          },
	          "EventDestinations": {
	            "type": "list",
	            "member": {
	              "shape": "S9"
	            }
	          },
	          "TrackingOptions": {
	            "shape": "Sp"
	          },
	          "DeliveryOptions": {
	            "shape": "S31"
	          },
	          "ReputationOptions": {
	            "type": "structure",
	            "members": {
	              "SendingEnabled": {
	                "type": "boolean"
	              },
	              "ReputationMetricsEnabled": {
	                "type": "boolean"
	              },
	              "LastFreshStart": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeReceiptRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleSetName",
	          "RuleName"
	        ],
	        "members": {
	          "RuleSetName": {},
	          "RuleName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReceiptRuleResult",
	        "type": "structure",
	        "members": {
	          "Rule": {
	            "shape": "S18"
	          }
	        }
	      }
	    },
	    "DescribeReceiptRuleSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleSetName"
	        ],
	        "members": {
	          "RuleSetName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReceiptRuleSetResult",
	        "type": "structure",
	        "members": {
	          "Metadata": {
	            "shape": "S2t"
	          },
	          "Rules": {
	            "shape": "S2v"
	          }
	        }
	      }
	    },
	    "GetAccountSendingEnabled": {
	      "output": {
	        "resultWrapper": "GetAccountSendingEnabledResult",
	        "type": "structure",
	        "members": {
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "GetCustomVerificationEmailTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TemplateName"
	        ],
	        "members": {
	          "TemplateName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetCustomVerificationEmailTemplateResult",
	        "type": "structure",
	        "members": {
	          "TemplateName": {},
	          "FromEmailAddress": {},
	          "TemplateSubject": {},
	          "TemplateContent": {},
	          "SuccessRedirectionURL": {},
	          "FailureRedirectionURL": {}
	        }
	      }
	    },
	    "GetIdentityDkimAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identities"
	        ],
	        "members": {
	          "Identities": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetIdentityDkimAttributesResult",
	        "type": "structure",
	        "required": [
	          "DkimAttributes"
	        ],
	        "members": {
	          "DkimAttributes": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "required": [
	                "DkimEnabled",
	                "DkimVerificationStatus"
	              ],
	              "members": {
	                "DkimEnabled": {
	                  "type": "boolean"
	                },
	                "DkimVerificationStatus": {},
	                "DkimTokens": {
	                  "shape": "S3h"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetIdentityMailFromDomainAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identities"
	        ],
	        "members": {
	          "Identities": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetIdentityMailFromDomainAttributesResult",
	        "type": "structure",
	        "required": [
	          "MailFromDomainAttributes"
	        ],
	        "members": {
	          "MailFromDomainAttributes": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "required": [
	                "MailFromDomain",
	                "MailFromDomainStatus",
	                "BehaviorOnMXFailure"
	              ],
	              "members": {
	                "MailFromDomain": {},
	                "MailFromDomainStatus": {},
	                "BehaviorOnMXFailure": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetIdentityNotificationAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identities"
	        ],
	        "members": {
	          "Identities": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetIdentityNotificationAttributesResult",
	        "type": "structure",
	        "required": [
	          "NotificationAttributes"
	        ],
	        "members": {
	          "NotificationAttributes": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "required": [
	                "BounceTopic",
	                "ComplaintTopic",
	                "DeliveryTopic",
	                "ForwardingEnabled"
	              ],
	              "members": {
	                "BounceTopic": {},
	                "ComplaintTopic": {},
	                "DeliveryTopic": {},
	                "ForwardingEnabled": {
	                  "type": "boolean"
	                },
	                "HeadersInBounceNotificationsEnabled": {
	                  "type": "boolean"
	                },
	                "HeadersInComplaintNotificationsEnabled": {
	                  "type": "boolean"
	                },
	                "HeadersInDeliveryNotificationsEnabled": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetIdentityPolicies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identity",
	          "PolicyNames"
	        ],
	        "members": {
	          "Identity": {},
	          "PolicyNames": {
	            "shape": "S3w"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetIdentityPoliciesResult",
	        "type": "structure",
	        "required": [
	          "Policies"
	        ],
	        "members": {
	          "Policies": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          }
	        }
	      }
	    },
	    "GetIdentityVerificationAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identities"
	        ],
	        "members": {
	          "Identities": {
	            "shape": "S3c"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetIdentityVerificationAttributesResult",
	        "type": "structure",
	        "required": [
	          "VerificationAttributes"
	        ],
	        "members": {
	          "VerificationAttributes": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "required": [
	                "VerificationStatus"
	              ],
	              "members": {
	                "VerificationStatus": {},
	                "VerificationToken": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetSendQuota": {
	      "output": {
	        "resultWrapper": "GetSendQuotaResult",
	        "type": "structure",
	        "members": {
	          "Max24HourSend": {
	            "type": "double"
	          },
	          "MaxSendRate": {
	            "type": "double"
	          },
	          "SentLast24Hours": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "GetSendStatistics": {
	      "output": {
	        "resultWrapper": "GetSendStatisticsResult",
	        "type": "structure",
	        "members": {
	          "SendDataPoints": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "DeliveryAttempts": {
	                  "type": "long"
	                },
	                "Bounces": {
	                  "type": "long"
	                },
	                "Complaints": {
	                  "type": "long"
	                },
	                "Rejects": {
	                  "type": "long"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TemplateName"
	        ],
	        "members": {
	          "TemplateName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetTemplateResult",
	        "type": "structure",
	        "members": {
	          "Template": {
	            "shape": "S20"
	          }
	        }
	      }
	    },
	    "ListConfigurationSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListConfigurationSetsResult",
	        "type": "structure",
	        "members": {
	          "ConfigurationSets": {
	            "type": "list",
	            "member": {
	              "shape": "S5"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListCustomVerificationEmailTemplates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListCustomVerificationEmailTemplatesResult",
	        "type": "structure",
	        "members": {
	          "CustomVerificationEmailTemplates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TemplateName": {},
	                "FromEmailAddress": {},
	                "TemplateSubject": {},
	                "SuccessRedirectionURL": {},
	                "FailureRedirectionURL": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListIdentities": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "IdentityType": {},
	          "NextToken": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListIdentitiesResult",
	        "type": "structure",
	        "required": [
	          "Identities"
	        ],
	        "members": {
	          "Identities": {
	            "shape": "S3c"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListIdentityPolicies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identity"
	        ],
	        "members": {
	          "Identity": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListIdentityPoliciesResult",
	        "type": "structure",
	        "required": [
	          "PolicyNames"
	        ],
	        "members": {
	          "PolicyNames": {
	            "shape": "S3w"
	          }
	        }
	      }
	    },
	    "ListReceiptFilters": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "resultWrapper": "ListReceiptFiltersResult",
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "list",
	            "member": {
	              "shape": "S10"
	            }
	          }
	        }
	      }
	    },
	    "ListReceiptRuleSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListReceiptRuleSetsResult",
	        "type": "structure",
	        "members": {
	          "RuleSets": {
	            "type": "list",
	            "member": {
	              "shape": "S2t"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTemplates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTemplatesResult",
	        "type": "structure",
	        "members": {
	          "TemplatesMetadata": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "CreatedTimestamp": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListVerifiedEmailAddresses": {
	      "output": {
	        "resultWrapper": "ListVerifiedEmailAddressesResult",
	        "type": "structure",
	        "members": {
	          "VerifiedEmailAddresses": {
	            "shape": "S54"
	          }
	        }
	      }
	    },
	    "PutConfigurationSetDeliveryOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSetName"
	        ],
	        "members": {
	          "ConfigurationSetName": {},
	          "DeliveryOptions": {
	            "shape": "S31"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PutConfigurationSetDeliveryOptionsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "PutIdentityPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identity",
	          "PolicyName",
	          "Policy"
	        ],
	        "members": {
	          "Identity": {},
	          "PolicyName": {},
	          "Policy": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "PutIdentityPolicyResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ReorderReceiptRuleSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleSetName",
	          "RuleNames"
	        ],
	        "members": {
	          "RuleSetName": {},
	          "RuleNames": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ReorderReceiptRuleSetResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SendBounce": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OriginalMessageId",
	          "BounceSender",
	          "BouncedRecipientInfoList"
	        ],
	        "members": {
	          "OriginalMessageId": {},
	          "BounceSender": {},
	          "Explanation": {},
	          "MessageDsn": {
	            "type": "structure",
	            "required": [
	              "ReportingMta"
	            ],
	            "members": {
	              "ReportingMta": {},
	              "ArrivalDate": {
	                "type": "timestamp"
	              },
	              "ExtensionFields": {
	                "shape": "S5i"
	              }
	            }
	          },
	          "BouncedRecipientInfoList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Recipient"
	              ],
	              "members": {
	                "Recipient": {},
	                "RecipientArn": {},
	                "BounceType": {},
	                "RecipientDsnFields": {
	                  "type": "structure",
	                  "required": [
	                    "Action",
	                    "Status"
	                  ],
	                  "members": {
	                    "FinalRecipient": {},
	                    "Action": {},
	                    "RemoteMta": {},
	                    "Status": {},
	                    "DiagnosticCode": {},
	                    "LastAttemptDate": {
	                      "type": "timestamp"
	                    },
	                    "ExtensionFields": {
	                      "shape": "S5i"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "BounceSenderArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SendBounceResult",
	        "type": "structure",
	        "members": {
	          "MessageId": {}
	        }
	      }
	    },
	    "SendBulkTemplatedEmail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Source",
	          "Template",
	          "Destinations"
	        ],
	        "members": {
	          "Source": {},
	          "SourceArn": {},
	          "ReplyToAddresses": {
	            "shape": "S54"
	          },
	          "ReturnPath": {},
	          "ReturnPathArn": {},
	          "ConfigurationSetName": {},
	          "DefaultTags": {
	            "shape": "S5x"
	          },
	          "Template": {},
	          "TemplateArn": {},
	          "DefaultTemplateData": {},
	          "Destinations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Destination"
	              ],
	              "members": {
	                "Destination": {
	                  "shape": "S64"
	                },
	                "ReplacementTags": {
	                  "shape": "S5x"
	                },
	                "ReplacementTemplateData": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SendBulkTemplatedEmailResult",
	        "type": "structure",
	        "required": [
	          "Status"
	        ],
	        "members": {
	          "Status": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Status": {},
	                "Error": {},
	                "MessageId": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "SendCustomVerificationEmail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EmailAddress",
	          "TemplateName"
	        ],
	        "members": {
	          "EmailAddress": {},
	          "TemplateName": {},
	          "ConfigurationSetName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SendCustomVerificationEmailResult",
	        "type": "structure",
	        "members": {
	          "MessageId": {}
	        }
	      }
	    },
	    "SendEmail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Source",
	          "Destination",
	          "Message"
	        ],
	        "members": {
	          "Source": {},
	          "Destination": {
	            "shape": "S64"
	          },
	          "Message": {
	            "type": "structure",
	            "required": [
	              "Subject",
	              "Body"
	            ],
	            "members": {
	              "Subject": {
	                "shape": "S6e"
	              },
	              "Body": {
	                "type": "structure",
	                "members": {
	                  "Text": {
	                    "shape": "S6e"
	                  },
	                  "Html": {
	                    "shape": "S6e"
	                  }
	                }
	              }
	            }
	          },
	          "ReplyToAddresses": {
	            "shape": "S54"
	          },
	          "ReturnPath": {},
	          "SourceArn": {},
	          "ReturnPathArn": {},
	          "Tags": {
	            "shape": "S5x"
	          },
	          "ConfigurationSetName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SendEmailResult",
	        "type": "structure",
	        "required": [
	          "MessageId"
	        ],
	        "members": {
	          "MessageId": {}
	        }
	      }
	    },
	    "SendRawEmail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RawMessage"
	        ],
	        "members": {
	          "Source": {},
	          "Destinations": {
	            "shape": "S54"
	          },
	          "RawMessage": {
	            "type": "structure",
	            "required": [
	              "Data"
	            ],
	            "members": {
	              "Data": {
	                "type": "blob"
	              }
	            }
	          },
	          "FromArn": {},
	          "SourceArn": {},
	          "ReturnPathArn": {},
	          "Tags": {
	            "shape": "S5x"
	          },
	          "ConfigurationSetName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SendRawEmailResult",
	        "type": "structure",
	        "required": [
	          "MessageId"
	        ],
	        "members": {
	          "MessageId": {}
	        }
	      }
	    },
	    "SendTemplatedEmail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Source",
	          "Destination",
	          "Template",
	          "TemplateData"
	        ],
	        "members": {
	          "Source": {},
	          "Destination": {
	            "shape": "S64"
	          },
	          "ReplyToAddresses": {
	            "shape": "S54"
	          },
	          "ReturnPath": {},
	          "SourceArn": {},
	          "ReturnPathArn": {},
	          "Tags": {
	            "shape": "S5x"
	          },
	          "ConfigurationSetName": {},
	          "Template": {},
	          "TemplateArn": {},
	          "TemplateData": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SendTemplatedEmailResult",
	        "type": "structure",
	        "required": [
	          "MessageId"
	        ],
	        "members": {
	          "MessageId": {}
	        }
	      }
	    },
	    "SetActiveReceiptRuleSet": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "RuleSetName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SetActiveReceiptRuleSetResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetIdentityDkimEnabled": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identity",
	          "DkimEnabled"
	        ],
	        "members": {
	          "Identity": {},
	          "DkimEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SetIdentityDkimEnabledResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetIdentityFeedbackForwardingEnabled": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identity",
	          "ForwardingEnabled"
	        ],
	        "members": {
	          "Identity": {},
	          "ForwardingEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SetIdentityFeedbackForwardingEnabledResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetIdentityHeadersInNotificationsEnabled": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identity",
	          "NotificationType",
	          "Enabled"
	        ],
	        "members": {
	          "Identity": {},
	          "NotificationType": {},
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SetIdentityHeadersInNotificationsEnabledResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetIdentityMailFromDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identity"
	        ],
	        "members": {
	          "Identity": {},
	          "MailFromDomain": {},
	          "BehaviorOnMXFailure": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SetIdentityMailFromDomainResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetIdentityNotificationTopic": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identity",
	          "NotificationType"
	        ],
	        "members": {
	          "Identity": {},
	          "NotificationType": {},
	          "SnsTopic": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SetIdentityNotificationTopicResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetReceiptRulePosition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleSetName",
	          "RuleName"
	        ],
	        "members": {
	          "RuleSetName": {},
	          "RuleName": {},
	          "After": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SetReceiptRulePositionResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TestRenderTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TemplateName",
	          "TemplateData"
	        ],
	        "members": {
	          "TemplateName": {},
	          "TemplateData": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "TestRenderTemplateResult",
	        "type": "structure",
	        "members": {
	          "RenderedTemplate": {}
	        }
	      }
	    },
	    "UpdateAccountSendingEnabled": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "UpdateConfigurationSetEventDestination": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSetName",
	          "EventDestination"
	        ],
	        "members": {
	          "ConfigurationSetName": {},
	          "EventDestination": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateConfigurationSetEventDestinationResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateConfigurationSetReputationMetricsEnabled": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSetName",
	          "Enabled"
	        ],
	        "members": {
	          "ConfigurationSetName": {},
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "UpdateConfigurationSetSendingEnabled": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSetName",
	          "Enabled"
	        ],
	        "members": {
	          "ConfigurationSetName": {},
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "UpdateConfigurationSetTrackingOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationSetName",
	          "TrackingOptions"
	        ],
	        "members": {
	          "ConfigurationSetName": {},
	          "TrackingOptions": {
	            "shape": "Sp"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateConfigurationSetTrackingOptionsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateCustomVerificationEmailTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TemplateName"
	        ],
	        "members": {
	          "TemplateName": {},
	          "FromEmailAddress": {},
	          "TemplateSubject": {},
	          "TemplateContent": {},
	          "SuccessRedirectionURL": {},
	          "FailureRedirectionURL": {}
	        }
	      }
	    },
	    "UpdateReceiptRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleSetName",
	          "Rule"
	        ],
	        "members": {
	          "RuleSetName": {},
	          "Rule": {
	            "shape": "S18"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateReceiptRuleResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Template"
	        ],
	        "members": {
	          "Template": {
	            "shape": "S20"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateTemplateResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "VerifyDomainDkim": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Domain"
	        ],
	        "members": {
	          "Domain": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "VerifyDomainDkimResult",
	        "type": "structure",
	        "required": [
	          "DkimTokens"
	        ],
	        "members": {
	          "DkimTokens": {
	            "shape": "S3h"
	          }
	        }
	      }
	    },
	    "VerifyDomainIdentity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Domain"
	        ],
	        "members": {
	          "Domain": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "VerifyDomainIdentityResult",
	        "type": "structure",
	        "required": [
	          "VerificationToken"
	        ],
	        "members": {
	          "VerificationToken": {}
	        }
	      }
	    },
	    "VerifyEmailAddress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EmailAddress"
	        ],
	        "members": {
	          "EmailAddress": {}
	        }
	      }
	    },
	    "VerifyEmailIdentity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EmailAddress"
	        ],
	        "members": {
	          "EmailAddress": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "VerifyEmailIdentityResult",
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "S5": {
	      "type": "structure",
	      "required": [
	        "Name"
	      ],
	      "members": {
	        "Name": {}
	      }
	    },
	    "S9": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "MatchingEventTypes"
	      ],
	      "members": {
	        "Name": {},
	        "Enabled": {
	          "type": "boolean"
	        },
	        "MatchingEventTypes": {
	          "type": "list",
	          "member": {}
	        },
	        "KinesisFirehoseDestination": {
	          "type": "structure",
	          "required": [
	            "IAMRoleARN",
	            "DeliveryStreamARN"
	          ],
	          "members": {
	            "IAMRoleARN": {},
	            "DeliveryStreamARN": {}
	          }
	        },
	        "CloudWatchDestination": {
	          "type": "structure",
	          "required": [
	            "DimensionConfigurations"
	          ],
	          "members": {
	            "DimensionConfigurations": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "required": [
	                  "DimensionName",
	                  "DimensionValueSource",
	                  "DefaultDimensionValue"
	                ],
	                "members": {
	                  "DimensionName": {},
	                  "DimensionValueSource": {},
	                  "DefaultDimensionValue": {}
	                }
	              }
	            }
	          }
	        },
	        "SNSDestination": {
	          "type": "structure",
	          "required": [
	            "TopicARN"
	          ],
	          "members": {
	            "TopicARN": {}
	          }
	        }
	      }
	    },
	    "Sp": {
	      "type": "structure",
	      "members": {
	        "CustomRedirectDomain": {}
	      }
	    },
	    "S10": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "IpFilter"
	      ],
	      "members": {
	        "Name": {},
	        "IpFilter": {
	          "type": "structure",
	          "required": [
	            "Policy",
	            "Cidr"
	          ],
	          "members": {
	            "Policy": {},
	            "Cidr": {}
	          }
	        }
	      }
	    },
	    "S18": {
	      "type": "structure",
	      "required": [
	        "Name"
	      ],
	      "members": {
	        "Name": {},
	        "Enabled": {
	          "type": "boolean"
	        },
	        "TlsPolicy": {},
	        "Recipients": {
	          "type": "list",
	          "member": {}
	        },
	        "Actions": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "S3Action": {
	                "type": "structure",
	                "required": [
	                  "BucketName"
	                ],
	                "members": {
	                  "TopicArn": {},
	                  "BucketName": {},
	                  "ObjectKeyPrefix": {},
	                  "KmsKeyArn": {}
	                }
	              },
	              "BounceAction": {
	                "type": "structure",
	                "required": [
	                  "SmtpReplyCode",
	                  "Message",
	                  "Sender"
	                ],
	                "members": {
	                  "TopicArn": {},
	                  "SmtpReplyCode": {},
	                  "StatusCode": {},
	                  "Message": {},
	                  "Sender": {}
	                }
	              },
	              "WorkmailAction": {
	                "type": "structure",
	                "required": [
	                  "OrganizationArn"
	                ],
	                "members": {
	                  "TopicArn": {},
	                  "OrganizationArn": {}
	                }
	              },
	              "LambdaAction": {
	                "type": "structure",
	                "required": [
	                  "FunctionArn"
	                ],
	                "members": {
	                  "TopicArn": {},
	                  "FunctionArn": {},
	                  "InvocationType": {}
	                }
	              },
	              "StopAction": {
	                "type": "structure",
	                "required": [
	                  "Scope"
	                ],
	                "members": {
	                  "Scope": {},
	                  "TopicArn": {}
	                }
	              },
	              "AddHeaderAction": {
	                "type": "structure",
	                "required": [
	                  "HeaderName",
	                  "HeaderValue"
	                ],
	                "members": {
	                  "HeaderName": {},
	                  "HeaderValue": {}
	                }
	              },
	              "SNSAction": {
	                "type": "structure",
	                "required": [
	                  "TopicArn"
	                ],
	                "members": {
	                  "TopicArn": {},
	                  "Encoding": {}
	                }
	              }
	            }
	          }
	        },
	        "ScanEnabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S20": {
	      "type": "structure",
	      "required": [
	        "TemplateName"
	      ],
	      "members": {
	        "TemplateName": {},
	        "SubjectPart": {},
	        "TextPart": {},
	        "HtmlPart": {}
	      }
	    },
	    "S2t": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "CreatedTimestamp": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S2v": {
	      "type": "list",
	      "member": {
	        "shape": "S18"
	      }
	    },
	    "S31": {
	      "type": "structure",
	      "members": {
	        "TlsPolicy": {}
	      }
	    },
	    "S3c": {
	      "type": "list",
	      "member": {}
	    },
	    "S3h": {
	      "type": "list",
	      "member": {}
	    },
	    "S3w": {
	      "type": "list",
	      "member": {}
	    },
	    "S54": {
	      "type": "list",
	      "member": {}
	    },
	    "S5i": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Value"
	        ],
	        "members": {
	          "Name": {},
	          "Value": {}
	        }
	      }
	    },
	    "S5x": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Value"
	        ],
	        "members": {
	          "Name": {},
	          "Value": {}
	        }
	      }
	    },
	    "S64": {
	      "type": "structure",
	      "members": {
	        "ToAddresses": {
	          "shape": "S54"
	        },
	        "CcAddresses": {
	          "shape": "S54"
	        },
	        "BccAddresses": {
	          "shape": "S54"
	        }
	      }
	    },
	    "S6e": {
	      "type": "structure",
	      "required": [
	        "Data"
	      ],
	      "members": {
	        "Data": {},
	        "Charset": {}
	      }
	    }
	  }
	}
	},{}],109:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListCustomVerificationEmailTemplates": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListIdentities": {
	      "input_token": "NextToken",
	      "limit_key": "MaxItems",
	      "output_token": "NextToken",
	      "result_key": "Identities"
	    },
	    "ListVerifiedEmailAddresses": {
	      "result_key": "VerifiedEmailAddresses"
	    }
	  }
	}
	},{}],110:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "IdentityExists": {
	      "delay": 3,
	      "operation": "GetIdentityVerificationAttributes",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "expected": "Success",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "VerificationAttributes.*.VerificationStatus"
	        }
	      ]
	    }
	  }
	}
	
	},{}],111:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-10-07",
	    "endpointPrefix": "events",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon CloudWatch Events",
	    "serviceId": "CloudWatch Events",
	    "signatureVersion": "v4",
	    "targetPrefix": "AWSEvents",
	    "uid": "events-2015-10-07"
	  },
	  "operations": {
	    "ActivateEventSource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      }
	    },
	    "CancelReplay": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplayName"
	        ],
	        "members": {
	          "ReplayName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReplayArn": {},
	          "State": {},
	          "StateReason": {}
	        }
	      }
	    },
	    "CreateApiDestination": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ConnectionArn",
	          "InvocationEndpoint",
	          "HttpMethod"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "ConnectionArn": {},
	          "InvocationEndpoint": {},
	          "HttpMethod": {},
	          "InvocationRateLimitPerSecond": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ApiDestinationArn": {},
	          "ApiDestinationState": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModifiedTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "CreateArchive": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ArchiveName",
	          "EventSourceArn"
	        ],
	        "members": {
	          "ArchiveName": {},
	          "EventSourceArn": {},
	          "Description": {},
	          "EventPattern": {},
	          "RetentionDays": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ArchiveArn": {},
	          "State": {},
	          "StateReason": {},
	          "CreationTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "CreateConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "AuthorizationType",
	          "AuthParameters"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "AuthorizationType": {},
	          "AuthParameters": {
	            "type": "structure",
	            "members": {
	              "BasicAuthParameters": {
	                "type": "structure",
	                "required": [
	                  "Username",
	                  "Password"
	                ],
	                "members": {
	                  "Username": {},
	                  "Password": {}
	                }
	              },
	              "OAuthParameters": {
	                "type": "structure",
	                "required": [
	                  "ClientParameters",
	                  "AuthorizationEndpoint",
	                  "HttpMethod"
	                ],
	                "members": {
	                  "ClientParameters": {
	                    "type": "structure",
	                    "required": [
	                      "ClientID",
	                      "ClientSecret"
	                    ],
	                    "members": {
	                      "ClientID": {},
	                      "ClientSecret": {}
	                    }
	                  },
	                  "AuthorizationEndpoint": {},
	                  "HttpMethod": {},
	                  "OAuthHttpParameters": {
	                    "shape": "S14"
	                  }
	                }
	              },
	              "ApiKeyAuthParameters": {
	                "type": "structure",
	                "required": [
	                  "ApiKeyName",
	                  "ApiKeyValue"
	                ],
	                "members": {
	                  "ApiKeyName": {},
	                  "ApiKeyValue": {}
	                }
	              },
	              "InvocationHttpParameters": {
	                "shape": "S14"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConnectionArn": {},
	          "ConnectionState": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModifiedTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "CreateEventBus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "EventSourceName": {},
	          "Tags": {
	            "shape": "S1m"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EventBusArn": {}
	        }
	      }
	    },
	    "CreatePartnerEventSource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Account"
	        ],
	        "members": {
	          "Name": {},
	          "Account": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EventSourceArn": {}
	        }
	      }
	    },
	    "DeactivateEventSource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      }
	    },
	    "DeauthorizeConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConnectionArn": {},
	          "ConnectionState": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModifiedTime": {
	            "type": "timestamp"
	          },
	          "LastAuthorizedTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DeleteApiDestination": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteArchive": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ArchiveName"
	        ],
	        "members": {
	          "ArchiveName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConnectionArn": {},
	          "ConnectionState": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModifiedTime": {
	            "type": "timestamp"
	          },
	          "LastAuthorizedTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DeleteEventBus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      }
	    },
	    "DeletePartnerEventSource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Account"
	        ],
	        "members": {
	          "Name": {},
	          "Account": {}
	        }
	      }
	    },
	    "DeleteRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "EventBusName": {},
	          "Force": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DescribeApiDestination": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ApiDestinationArn": {},
	          "Name": {},
	          "Description": {},
	          "ApiDestinationState": {},
	          "ConnectionArn": {},
	          "InvocationEndpoint": {},
	          "HttpMethod": {},
	          "InvocationRateLimitPerSecond": {
	            "type": "integer"
	          },
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModifiedTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeArchive": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ArchiveName"
	        ],
	        "members": {
	          "ArchiveName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ArchiveArn": {},
	          "ArchiveName": {},
	          "EventSourceArn": {},
	          "Description": {},
	          "EventPattern": {},
	          "State": {},
	          "StateReason": {},
	          "RetentionDays": {
	            "type": "integer"
	          },
	          "SizeBytes": {
	            "type": "long"
	          },
	          "EventCount": {
	            "type": "long"
	          },
	          "CreationTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConnectionArn": {},
	          "Name": {},
	          "Description": {},
	          "ConnectionState": {},
	          "StateReason": {},
	          "AuthorizationType": {},
	          "SecretArn": {},
	          "AuthParameters": {
	            "type": "structure",
	            "members": {
	              "BasicAuthParameters": {
	                "type": "structure",
	                "members": {
	                  "Username": {}
	                }
	              },
	              "OAuthParameters": {
	                "type": "structure",
	                "members": {
	                  "ClientParameters": {
	                    "type": "structure",
	                    "members": {
	                      "ClientID": {}
	                    }
	                  },
	                  "AuthorizationEndpoint": {},
	                  "HttpMethod": {},
	                  "OAuthHttpParameters": {
	                    "shape": "S14"
	                  }
	                }
	              },
	              "ApiKeyAuthParameters": {
	                "type": "structure",
	                "members": {
	                  "ApiKeyName": {}
	                }
	              },
	              "InvocationHttpParameters": {
	                "shape": "S14"
	              }
	            }
	          },
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModifiedTime": {
	            "type": "timestamp"
	          },
	          "LastAuthorizedTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeEventBus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Arn": {},
	          "Policy": {}
	        }
	      }
	    },
	    "DescribeEventSource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Arn": {},
	          "CreatedBy": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "ExpirationTime": {
	            "type": "timestamp"
	          },
	          "Name": {},
	          "State": {}
	        }
	      }
	    },
	    "DescribePartnerEventSource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Arn": {},
	          "Name": {}
	        }
	      }
	    },
	    "DescribeReplay": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplayName"
	        ],
	        "members": {
	          "ReplayName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReplayName": {},
	          "ReplayArn": {},
	          "Description": {},
	          "State": {},
	          "StateReason": {},
	          "EventSourceArn": {},
	          "Destination": {
	            "shape": "S2w"
	          },
	          "EventStartTime": {
	            "type": "timestamp"
	          },
	          "EventEndTime": {
	            "type": "timestamp"
	          },
	          "EventLastReplayedTime": {
	            "type": "timestamp"
	          },
	          "ReplayStartTime": {
	            "type": "timestamp"
	          },
	          "ReplayEndTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "EventBusName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Arn": {},
	          "EventPattern": {},
	          "ScheduleExpression": {},
	          "State": {},
	          "Description": {},
	          "RoleArn": {},
	          "ManagedBy": {},
	          "EventBusName": {},
	          "CreatedBy": {}
	        }
	      }
	    },
	    "DisableRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "EventBusName": {}
	        }
	      }
	    },
	    "EnableRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "EventBusName": {}
	        }
	      }
	    },
	    "ListApiDestinations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NamePrefix": {},
	          "ConnectionArn": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ApiDestinations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ApiDestinationArn": {},
	                "Name": {},
	                "ApiDestinationState": {},
	                "ConnectionArn": {},
	                "InvocationEndpoint": {},
	                "HttpMethod": {},
	                "InvocationRateLimitPerSecond": {
	                  "type": "integer"
	                },
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModifiedTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListArchives": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NamePrefix": {},
	          "EventSourceArn": {},
	          "State": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Archives": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ArchiveName": {},
	                "EventSourceArn": {},
	                "State": {},
	                "StateReason": {},
	                "RetentionDays": {
	                  "type": "integer"
	                },
	                "SizeBytes": {
	                  "type": "long"
	                },
	                "EventCount": {
	                  "type": "long"
	                },
	                "CreationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListConnections": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NamePrefix": {},
	          "ConnectionState": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Connections": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ConnectionArn": {},
	                "Name": {},
	                "ConnectionState": {},
	                "StateReason": {},
	                "AuthorizationType": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModifiedTime": {
	                  "type": "timestamp"
	                },
	                "LastAuthorizedTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListEventBuses": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NamePrefix": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EventBuses": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Arn": {},
	                "Policy": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListEventSources": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NamePrefix": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EventSources": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Arn": {},
	                "CreatedBy": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "ExpirationTime": {
	                  "type": "timestamp"
	                },
	                "Name": {},
	                "State": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListPartnerEventSourceAccounts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EventSourceName"
	        ],
	        "members": {
	          "EventSourceName": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PartnerEventSourceAccounts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Account": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "ExpirationTime": {
	                  "type": "timestamp"
	                },
	                "State": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListPartnerEventSources": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "NamePrefix"
	        ],
	        "members": {
	          "NamePrefix": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PartnerEventSources": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Arn": {},
	                "Name": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListReplays": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NamePrefix": {},
	          "State": {},
	          "EventSourceArn": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Replays": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ReplayName": {},
	                "EventSourceArn": {},
	                "State": {},
	                "StateReason": {},
	                "EventStartTime": {
	                  "type": "timestamp"
	                },
	                "EventEndTime": {
	                  "type": "timestamp"
	                },
	                "EventLastReplayedTime": {
	                  "type": "timestamp"
	                },
	                "ReplayStartTime": {
	                  "type": "timestamp"
	                },
	                "ReplayEndTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListRuleNamesByTarget": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetArn"
	        ],
	        "members": {
	          "TargetArn": {},
	          "EventBusName": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RuleNames": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListRules": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NamePrefix": {},
	          "EventBusName": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Rules": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Arn": {},
	                "EventPattern": {},
	                "State": {},
	                "Description": {},
	                "ScheduleExpression": {},
	                "RoleArn": {},
	                "ManagedBy": {},
	                "EventBusName": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN"
	        ],
	        "members": {
	          "ResourceARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S1m"
	          }
	        }
	      }
	    },
	    "ListTargetsByRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Rule"
	        ],
	        "members": {
	          "Rule": {},
	          "EventBusName": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Targets": {
	            "shape": "S4l"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PutEvents": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Entries"
	        ],
	        "members": {
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Time": {
	                  "type": "timestamp"
	                },
	                "Source": {},
	                "Resources": {
	                  "shape": "S6j"
	                },
	                "DetailType": {},
	                "Detail": {},
	                "EventBusName": {},
	                "TraceHeader": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FailedEntryCount": {
	            "type": "integer"
	          },
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EventId": {},
	                "ErrorCode": {},
	                "ErrorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutPartnerEvents": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Entries"
	        ],
	        "members": {
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Time": {
	                  "type": "timestamp"
	                },
	                "Source": {},
	                "Resources": {
	                  "shape": "S6j"
	                },
	                "DetailType": {},
	                "Detail": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FailedEntryCount": {
	            "type": "integer"
	          },
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EventId": {},
	                "ErrorCode": {},
	                "ErrorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutPermission": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EventBusName": {},
	          "Action": {},
	          "Principal": {},
	          "StatementId": {},
	          "Condition": {
	            "type": "structure",
	            "required": [
	              "Type",
	              "Key",
	              "Value"
	            ],
	            "members": {
	              "Type": {},
	              "Key": {},
	              "Value": {}
	            }
	          },
	          "Policy": {}
	        }
	      }
	    },
	    "PutRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "ScheduleExpression": {},
	          "EventPattern": {},
	          "State": {},
	          "Description": {},
	          "RoleArn": {},
	          "Tags": {
	            "shape": "S1m"
	          },
	          "EventBusName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RuleArn": {}
	        }
	      }
	    },
	    "PutTargets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Rule",
	          "Targets"
	        ],
	        "members": {
	          "Rule": {},
	          "EventBusName": {},
	          "Targets": {
	            "shape": "S4l"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FailedEntryCount": {
	            "type": "integer"
	          },
	          "FailedEntries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TargetId": {},
	                "ErrorCode": {},
	                "ErrorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "RemovePermission": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StatementId": {},
	          "RemoveAllPermissions": {
	            "type": "boolean"
	          },
	          "EventBusName": {}
	        }
	      }
	    },
	    "RemoveTargets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Rule",
	          "Ids"
	        ],
	        "members": {
	          "Rule": {},
	          "EventBusName": {},
	          "Ids": {
	            "type": "list",
	            "member": {}
	          },
	          "Force": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FailedEntryCount": {
	            "type": "integer"
	          },
	          "FailedEntries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TargetId": {},
	                "ErrorCode": {},
	                "ErrorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "StartReplay": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReplayName",
	          "EventSourceArn",
	          "EventStartTime",
	          "EventEndTime",
	          "Destination"
	        ],
	        "members": {
	          "ReplayName": {},
	          "Description": {},
	          "EventSourceArn": {},
	          "EventStartTime": {
	            "type": "timestamp"
	          },
	          "EventEndTime": {
	            "type": "timestamp"
	          },
	          "Destination": {
	            "shape": "S2w"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReplayArn": {},
	          "State": {},
	          "StateReason": {},
	          "ReplayStartTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "Tags"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "Tags": {
	            "shape": "S1m"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TestEventPattern": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EventPattern",
	          "Event"
	        ],
	        "members": {
	          "EventPattern": {},
	          "Event": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Result": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateApiDestination": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "ConnectionArn": {},
	          "InvocationEndpoint": {},
	          "HttpMethod": {},
	          "InvocationRateLimitPerSecond": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ApiDestinationArn": {},
	          "ApiDestinationState": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModifiedTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "UpdateArchive": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ArchiveName"
	        ],
	        "members": {
	          "ArchiveName": {},
	          "Description": {},
	          "EventPattern": {},
	          "RetentionDays": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ArchiveArn": {},
	          "State": {},
	          "StateReason": {},
	          "CreationTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "UpdateConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "AuthorizationType": {},
	          "AuthParameters": {
	            "type": "structure",
	            "members": {
	              "BasicAuthParameters": {
	                "type": "structure",
	                "members": {
	                  "Username": {},
	                  "Password": {}
	                }
	              },
	              "OAuthParameters": {
	                "type": "structure",
	                "members": {
	                  "ClientParameters": {
	                    "type": "structure",
	                    "members": {
	                      "ClientID": {},
	                      "ClientSecret": {}
	                    }
	                  },
	                  "AuthorizationEndpoint": {},
	                  "HttpMethod": {},
	                  "OAuthHttpParameters": {
	                    "shape": "S14"
	                  }
	                }
	              },
	              "ApiKeyAuthParameters": {
	                "type": "structure",
	                "members": {
	                  "ApiKeyName": {},
	                  "ApiKeyValue": {}
	                }
	              },
	              "InvocationHttpParameters": {
	                "shape": "S14"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConnectionArn": {},
	          "ConnectionState": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModifiedTime": {
	            "type": "timestamp"
	          },
	          "LastAuthorizedTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S14": {
	      "type": "structure",
	      "members": {
	        "HeaderParameters": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Key": {},
	              "Value": {},
	              "IsValueSecret": {
	                "type": "boolean"
	              }
	            }
	          }
	        },
	        "QueryStringParameters": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Key": {},
	              "Value": {},
	              "IsValueSecret": {
	                "type": "boolean"
	              }
	            }
	          }
	        },
	        "BodyParameters": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Key": {},
	              "Value": {},
	              "IsValueSecret": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1m": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S2w": {
	      "type": "structure",
	      "required": [
	        "Arn"
	      ],
	      "members": {
	        "Arn": {},
	        "FilterArns": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S4l": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Id",
	          "Arn"
	        ],
	        "members": {
	          "Id": {},
	          "Arn": {},
	          "RoleArn": {},
	          "Input": {},
	          "InputPath": {},
	          "InputTransformer": {
	            "type": "structure",
	            "required": [
	              "InputTemplate"
	            ],
	            "members": {
	              "InputPathsMap": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              },
	              "InputTemplate": {}
	            }
	          },
	          "KinesisParameters": {
	            "type": "structure",
	            "required": [
	              "PartitionKeyPath"
	            ],
	            "members": {
	              "PartitionKeyPath": {}
	            }
	          },
	          "RunCommandParameters": {
	            "type": "structure",
	            "required": [
	              "RunCommandTargets"
	            ],
	            "members": {
	              "RunCommandTargets": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "Key",
	                    "Values"
	                  ],
	                  "members": {
	                    "Key": {},
	                    "Values": {
	                      "type": "list",
	                      "member": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "EcsParameters": {
	            "type": "structure",
	            "required": [
	              "TaskDefinitionArn"
	            ],
	            "members": {
	              "TaskDefinitionArn": {},
	              "TaskCount": {
	                "type": "integer"
	              },
	              "LaunchType": {},
	              "NetworkConfiguration": {
	                "type": "structure",
	                "members": {
	                  "awsvpcConfiguration": {
	                    "type": "structure",
	                    "required": [
	                      "Subnets"
	                    ],
	                    "members": {
	                      "Subnets": {
	                        "shape": "S57"
	                      },
	                      "SecurityGroups": {
	                        "shape": "S57"
	                      },
	                      "AssignPublicIp": {}
	                    }
	                  }
	                }
	              },
	              "PlatformVersion": {},
	              "Group": {},
	              "CapacityProviderStrategy": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "capacityProvider"
	                  ],
	                  "members": {
	                    "capacityProvider": {},
	                    "weight": {
	                      "type": "integer"
	                    },
	                    "base": {
	                      "type": "integer"
	                    }
	                  }
	                }
	              },
	              "EnableECSManagedTags": {
	                "type": "boolean"
	              },
	              "EnableExecuteCommand": {
	                "type": "boolean"
	              },
	              "PlacementConstraints": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "type": {},
	                    "expression": {}
	                  }
	                }
	              },
	              "PlacementStrategy": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "type": {},
	                    "field": {}
	                  }
	                }
	              },
	              "PropagateTags": {},
	              "ReferenceId": {},
	              "Tags": {
	                "shape": "S1m"
	              }
	            }
	          },
	          "BatchParameters": {
	            "type": "structure",
	            "required": [
	              "JobDefinition",
	              "JobName"
	            ],
	            "members": {
	              "JobDefinition": {},
	              "JobName": {},
	              "ArrayProperties": {
	                "type": "structure",
	                "members": {
	                  "Size": {
	                    "type": "integer"
	                  }
	                }
	              },
	              "RetryStrategy": {
	                "type": "structure",
	                "members": {
	                  "Attempts": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          },
	          "SqsParameters": {
	            "type": "structure",
	            "members": {
	              "MessageGroupId": {}
	            }
	          },
	          "HttpParameters": {
	            "type": "structure",
	            "members": {
	              "PathParameterValues": {
	                "type": "list",
	                "member": {}
	              },
	              "HeaderParameters": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              },
	              "QueryStringParameters": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              }
	            }
	          },
	          "RedshiftDataParameters": {
	            "type": "structure",
	            "required": [
	              "Database",
	              "Sql"
	            ],
	            "members": {
	              "SecretManagerArn": {},
	              "Database": {},
	              "DbUser": {},
	              "Sql": {},
	              "StatementName": {},
	              "WithEvent": {
	                "type": "boolean"
	              }
	            }
	          },
	          "SageMakerPipelineParameters": {
	            "type": "structure",
	            "members": {
	              "PipelineParameterList": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "Name",
	                    "Value"
	                  ],
	                  "members": {
	                    "Name": {},
	                    "Value": {}
	                  }
	                }
	              }
	            }
	          },
	          "DeadLetterConfig": {
	            "type": "structure",
	            "members": {
	              "Arn": {}
	            }
	          },
	          "RetryPolicy": {
	            "type": "structure",
	            "members": {
	              "MaximumRetryAttempts": {
	                "type": "integer"
	              },
	              "MaximumEventAgeInSeconds": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S57": {
	      "type": "list",
	      "member": {}
	    },
	    "S6j": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],112:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],113:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-08-04",
	    "endpointPrefix": "firehose",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "Firehose",
	    "serviceFullName": "Amazon Kinesis Firehose",
	    "serviceId": "Firehose",
	    "signatureVersion": "v4",
	    "targetPrefix": "Firehose_20150804",
	    "uid": "firehose-2015-08-04"
	  },
	  "operations": {
	    "CreateDeliveryStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamName"
	        ],
	        "members": {
	          "DeliveryStreamName": {},
	          "DeliveryStreamType": {},
	          "KinesisStreamSourceConfiguration": {
	            "type": "structure",
	            "required": [
	              "KinesisStreamARN",
	              "RoleARN"
	            ],
	            "members": {
	              "KinesisStreamARN": {},
	              "RoleARN": {}
	            }
	          },
	          "DeliveryStreamEncryptionConfigurationInput": {
	            "shape": "S7"
	          },
	          "S3DestinationConfiguration": {
	            "shape": "Sa",
	            "deprecated": true
	          },
	          "ExtendedS3DestinationConfiguration": {
	            "type": "structure",
	            "required": [
	              "RoleARN",
	              "BucketARN"
	            ],
	            "members": {
	              "RoleARN": {},
	              "BucketARN": {},
	              "Prefix": {},
	              "ErrorOutputPrefix": {},
	              "BufferingHints": {
	                "shape": "Se"
	              },
	              "CompressionFormat": {},
	              "EncryptionConfiguration": {
	                "shape": "Si"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "S3BackupMode": {},
	              "S3BackupConfiguration": {
	                "shape": "Sa"
	              },
	              "DataFormatConversionConfiguration": {
	                "shape": "Sz"
	              },
	              "DynamicPartitioningConfiguration": {
	                "shape": "S1o"
	              }
	            }
	          },
	          "RedshiftDestinationConfiguration": {
	            "type": "structure",
	            "required": [
	              "RoleARN",
	              "ClusterJDBCURL",
	              "CopyCommand",
	              "Username",
	              "Password",
	              "S3Configuration"
	            ],
	            "members": {
	              "RoleARN": {},
	              "ClusterJDBCURL": {},
	              "CopyCommand": {
	                "shape": "S1t"
	              },
	              "Username": {
	                "shape": "S1x"
	              },
	              "Password": {
	                "shape": "S1y"
	              },
	              "RetryOptions": {
	                "shape": "S1z"
	              },
	              "S3Configuration": {
	                "shape": "Sa"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "S3BackupMode": {},
	              "S3BackupConfiguration": {
	                "shape": "Sa"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              }
	            }
	          },
	          "ElasticsearchDestinationConfiguration": {
	            "type": "structure",
	            "required": [
	              "RoleARN",
	              "IndexName",
	              "S3Configuration"
	            ],
	            "members": {
	              "RoleARN": {},
	              "DomainARN": {},
	              "ClusterEndpoint": {},
	              "IndexName": {},
	              "TypeName": {},
	              "IndexRotationPeriod": {},
	              "BufferingHints": {
	                "shape": "S28"
	              },
	              "RetryOptions": {
	                "shape": "S2b"
	              },
	              "S3BackupMode": {},
	              "S3Configuration": {
	                "shape": "Sa"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              },
	              "VpcConfiguration": {
	                "shape": "S2e"
	              }
	            }
	          },
	          "AmazonopensearchserviceDestinationConfiguration": {
	            "type": "structure",
	            "required": [
	              "RoleARN",
	              "IndexName",
	              "S3Configuration"
	            ],
	            "members": {
	              "RoleARN": {},
	              "DomainARN": {},
	              "ClusterEndpoint": {},
	              "IndexName": {},
	              "TypeName": {},
	              "IndexRotationPeriod": {},
	              "BufferingHints": {
	                "shape": "S2n"
	              },
	              "RetryOptions": {
	                "shape": "S2q"
	              },
	              "S3BackupMode": {},
	              "S3Configuration": {
	                "shape": "Sa"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              },
	              "VpcConfiguration": {
	                "shape": "S2e"
	              }
	            }
	          },
	          "SplunkDestinationConfiguration": {
	            "type": "structure",
	            "required": [
	              "HECEndpoint",
	              "HECEndpointType",
	              "HECToken",
	              "S3Configuration"
	            ],
	            "members": {
	              "HECEndpoint": {},
	              "HECEndpointType": {},
	              "HECToken": {},
	              "HECAcknowledgmentTimeoutInSeconds": {
	                "type": "integer"
	              },
	              "RetryOptions": {
	                "shape": "S2y"
	              },
	              "S3BackupMode": {},
	              "S3Configuration": {
	                "shape": "Sa"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              }
	            }
	          },
	          "HttpEndpointDestinationConfiguration": {
	            "type": "structure",
	            "required": [
	              "EndpointConfiguration",
	              "S3Configuration"
	            ],
	            "members": {
	              "EndpointConfiguration": {
	                "shape": "S32"
	              },
	              "BufferingHints": {
	                "shape": "S36"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              },
	              "RequestConfiguration": {
	                "shape": "S39"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "RoleARN": {},
	              "RetryOptions": {
	                "shape": "S3f"
	              },
	              "S3BackupMode": {},
	              "S3Configuration": {
	                "shape": "Sa"
	              }
	            }
	          },
	          "Tags": {
	            "shape": "S3i"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeliveryStreamARN": {}
	        }
	      }
	    },
	    "DeleteDeliveryStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamName"
	        ],
	        "members": {
	          "DeliveryStreamName": {},
	          "AllowForceDelete": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeDeliveryStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamName"
	        ],
	        "members": {
	          "DeliveryStreamName": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "ExclusiveStartDestinationId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamDescription"
	        ],
	        "members": {
	          "DeliveryStreamDescription": {
	            "type": "structure",
	            "required": [
	              "DeliveryStreamName",
	              "DeliveryStreamARN",
	              "DeliveryStreamStatus",
	              "DeliveryStreamType",
	              "VersionId",
	              "Destinations",
	              "HasMoreDestinations"
	            ],
	            "members": {
	              "DeliveryStreamName": {},
	              "DeliveryStreamARN": {},
	              "DeliveryStreamStatus": {},
	              "FailureDescription": {
	                "shape": "S3w"
	              },
	              "DeliveryStreamEncryptionConfiguration": {
	                "type": "structure",
	                "members": {
	                  "KeyARN": {},
	                  "KeyType": {},
	                  "Status": {},
	                  "FailureDescription": {
	                    "shape": "S3w"
	                  }
	                }
	              },
	              "DeliveryStreamType": {},
	              "VersionId": {},
	              "CreateTimestamp": {
	                "type": "timestamp"
	              },
	              "LastUpdateTimestamp": {
	                "type": "timestamp"
	              },
	              "Source": {
	                "type": "structure",
	                "members": {
	                  "KinesisStreamSourceDescription": {
	                    "type": "structure",
	                    "members": {
	                      "KinesisStreamARN": {},
	                      "RoleARN": {},
	                      "DeliveryStartTimestamp": {
	                        "type": "timestamp"
	                      }
	                    }
	                  }
	                }
	              },
	              "Destinations": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "DestinationId"
	                  ],
	                  "members": {
	                    "DestinationId": {},
	                    "S3DestinationDescription": {
	                      "shape": "S47"
	                    },
	                    "ExtendedS3DestinationDescription": {
	                      "type": "structure",
	                      "required": [
	                        "RoleARN",
	                        "BucketARN",
	                        "BufferingHints",
	                        "CompressionFormat",
	                        "EncryptionConfiguration"
	                      ],
	                      "members": {
	                        "RoleARN": {},
	                        "BucketARN": {},
	                        "Prefix": {},
	                        "ErrorOutputPrefix": {},
	                        "BufferingHints": {
	                          "shape": "Se"
	                        },
	                        "CompressionFormat": {},
	                        "EncryptionConfiguration": {
	                          "shape": "Si"
	                        },
	                        "CloudWatchLoggingOptions": {
	                          "shape": "Sl"
	                        },
	                        "ProcessingConfiguration": {
	                          "shape": "Sq"
	                        },
	                        "S3BackupMode": {},
	                        "S3BackupDescription": {
	                          "shape": "S47"
	                        },
	                        "DataFormatConversionConfiguration": {
	                          "shape": "Sz"
	                        },
	                        "DynamicPartitioningConfiguration": {
	                          "shape": "S1o"
	                        }
	                      }
	                    },
	                    "RedshiftDestinationDescription": {
	                      "type": "structure",
	                      "required": [
	                        "RoleARN",
	                        "ClusterJDBCURL",
	                        "CopyCommand",
	                        "Username",
	                        "S3DestinationDescription"
	                      ],
	                      "members": {
	                        "RoleARN": {},
	                        "ClusterJDBCURL": {},
	                        "CopyCommand": {
	                          "shape": "S1t"
	                        },
	                        "Username": {
	                          "shape": "S1x"
	                        },
	                        "RetryOptions": {
	                          "shape": "S1z"
	                        },
	                        "S3DestinationDescription": {
	                          "shape": "S47"
	                        },
	                        "ProcessingConfiguration": {
	                          "shape": "Sq"
	                        },
	                        "S3BackupMode": {},
	                        "S3BackupDescription": {
	                          "shape": "S47"
	                        },
	                        "CloudWatchLoggingOptions": {
	                          "shape": "Sl"
	                        }
	                      }
	                    },
	                    "ElasticsearchDestinationDescription": {
	                      "type": "structure",
	                      "members": {
	                        "RoleARN": {},
	                        "DomainARN": {},
	                        "ClusterEndpoint": {},
	                        "IndexName": {},
	                        "TypeName": {},
	                        "IndexRotationPeriod": {},
	                        "BufferingHints": {
	                          "shape": "S28"
	                        },
	                        "RetryOptions": {
	                          "shape": "S2b"
	                        },
	                        "S3BackupMode": {},
	                        "S3DestinationDescription": {
	                          "shape": "S47"
	                        },
	                        "ProcessingConfiguration": {
	                          "shape": "Sq"
	                        },
	                        "CloudWatchLoggingOptions": {
	                          "shape": "Sl"
	                        },
	                        "VpcConfigurationDescription": {
	                          "shape": "S4b"
	                        }
	                      }
	                    },
	                    "AmazonopensearchserviceDestinationDescription": {
	                      "type": "structure",
	                      "members": {
	                        "RoleARN": {},
	                        "DomainARN": {},
	                        "ClusterEndpoint": {},
	                        "IndexName": {},
	                        "TypeName": {},
	                        "IndexRotationPeriod": {},
	                        "BufferingHints": {
	                          "shape": "S2n"
	                        },
	                        "RetryOptions": {
	                          "shape": "S2q"
	                        },
	                        "S3BackupMode": {},
	                        "S3DestinationDescription": {
	                          "shape": "S47"
	                        },
	                        "ProcessingConfiguration": {
	                          "shape": "Sq"
	                        },
	                        "CloudWatchLoggingOptions": {
	                          "shape": "Sl"
	                        },
	                        "VpcConfigurationDescription": {
	                          "shape": "S4b"
	                        }
	                      }
	                    },
	                    "SplunkDestinationDescription": {
	                      "type": "structure",
	                      "members": {
	                        "HECEndpoint": {},
	                        "HECEndpointType": {},
	                        "HECToken": {},
	                        "HECAcknowledgmentTimeoutInSeconds": {
	                          "type": "integer"
	                        },
	                        "RetryOptions": {
	                          "shape": "S2y"
	                        },
	                        "S3BackupMode": {},
	                        "S3DestinationDescription": {
	                          "shape": "S47"
	                        },
	                        "ProcessingConfiguration": {
	                          "shape": "Sq"
	                        },
	                        "CloudWatchLoggingOptions": {
	                          "shape": "Sl"
	                        }
	                      }
	                    },
	                    "HttpEndpointDestinationDescription": {
	                      "type": "structure",
	                      "members": {
	                        "EndpointConfiguration": {
	                          "type": "structure",
	                          "members": {
	                            "Url": {
	                              "shape": "S33"
	                            },
	                            "Name": {}
	                          }
	                        },
	                        "BufferingHints": {
	                          "shape": "S36"
	                        },
	                        "CloudWatchLoggingOptions": {
	                          "shape": "Sl"
	                        },
	                        "RequestConfiguration": {
	                          "shape": "S39"
	                        },
	                        "ProcessingConfiguration": {
	                          "shape": "Sq"
	                        },
	                        "RoleARN": {},
	                        "RetryOptions": {
	                          "shape": "S3f"
	                        },
	                        "S3BackupMode": {},
	                        "S3DestinationDescription": {
	                          "shape": "S47"
	                        }
	                      }
	                    }
	                  }
	                }
	              },
	              "HasMoreDestinations": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListDeliveryStreams": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Limit": {
	            "type": "integer"
	          },
	          "DeliveryStreamType": {},
	          "ExclusiveStartDeliveryStreamName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamNames",
	          "HasMoreDeliveryStreams"
	        ],
	        "members": {
	          "DeliveryStreamNames": {
	            "type": "list",
	            "member": {}
	          },
	          "HasMoreDeliveryStreams": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ListTagsForDeliveryStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamName"
	        ],
	        "members": {
	          "DeliveryStreamName": {},
	          "ExclusiveStartTagKey": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Tags",
	          "HasMoreTags"
	        ],
	        "members": {
	          "Tags": {
	            "type": "list",
	            "member": {
	              "shape": "S3j"
	            }
	          },
	          "HasMoreTags": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "PutRecord": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamName",
	          "Record"
	        ],
	        "members": {
	          "DeliveryStreamName": {},
	          "Record": {
	            "shape": "S4p"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "RecordId"
	        ],
	        "members": {
	          "RecordId": {},
	          "Encrypted": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "PutRecordBatch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamName",
	          "Records"
	        ],
	        "members": {
	          "DeliveryStreamName": {},
	          "Records": {
	            "type": "list",
	            "member": {
	              "shape": "S4p"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "FailedPutCount",
	          "RequestResponses"
	        ],
	        "members": {
	          "FailedPutCount": {
	            "type": "integer"
	          },
	          "Encrypted": {
	            "type": "boolean"
	          },
	          "RequestResponses": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "RecordId": {},
	                "ErrorCode": {},
	                "ErrorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "StartDeliveryStreamEncryption": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamName"
	        ],
	        "members": {
	          "DeliveryStreamName": {},
	          "DeliveryStreamEncryptionConfigurationInput": {
	            "shape": "S7"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "StopDeliveryStreamEncryption": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamName"
	        ],
	        "members": {
	          "DeliveryStreamName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TagDeliveryStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamName",
	          "Tags"
	        ],
	        "members": {
	          "DeliveryStreamName": {},
	          "Tags": {
	            "shape": "S3i"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagDeliveryStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamName",
	          "TagKeys"
	        ],
	        "members": {
	          "DeliveryStreamName": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateDestination": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeliveryStreamName",
	          "CurrentDeliveryStreamVersionId",
	          "DestinationId"
	        ],
	        "members": {
	          "DeliveryStreamName": {},
	          "CurrentDeliveryStreamVersionId": {},
	          "DestinationId": {},
	          "S3DestinationUpdate": {
	            "shape": "S5a",
	            "deprecated": true
	          },
	          "ExtendedS3DestinationUpdate": {
	            "type": "structure",
	            "members": {
	              "RoleARN": {},
	              "BucketARN": {},
	              "Prefix": {},
	              "ErrorOutputPrefix": {},
	              "BufferingHints": {
	                "shape": "Se"
	              },
	              "CompressionFormat": {},
	              "EncryptionConfiguration": {
	                "shape": "Si"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "S3BackupMode": {},
	              "S3BackupUpdate": {
	                "shape": "S5a"
	              },
	              "DataFormatConversionConfiguration": {
	                "shape": "Sz"
	              },
	              "DynamicPartitioningConfiguration": {
	                "shape": "S1o"
	              }
	            }
	          },
	          "RedshiftDestinationUpdate": {
	            "type": "structure",
	            "members": {
	              "RoleARN": {},
	              "ClusterJDBCURL": {},
	              "CopyCommand": {
	                "shape": "S1t"
	              },
	              "Username": {
	                "shape": "S1x"
	              },
	              "Password": {
	                "shape": "S1y"
	              },
	              "RetryOptions": {
	                "shape": "S1z"
	              },
	              "S3Update": {
	                "shape": "S5a"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "S3BackupMode": {},
	              "S3BackupUpdate": {
	                "shape": "S5a"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              }
	            }
	          },
	          "ElasticsearchDestinationUpdate": {
	            "type": "structure",
	            "members": {
	              "RoleARN": {},
	              "DomainARN": {},
	              "ClusterEndpoint": {},
	              "IndexName": {},
	              "TypeName": {},
	              "IndexRotationPeriod": {},
	              "BufferingHints": {
	                "shape": "S28"
	              },
	              "RetryOptions": {
	                "shape": "S2b"
	              },
	              "S3Update": {
	                "shape": "S5a"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              }
	            }
	          },
	          "AmazonopensearchserviceDestinationUpdate": {
	            "type": "structure",
	            "members": {
	              "RoleARN": {},
	              "DomainARN": {},
	              "ClusterEndpoint": {},
	              "IndexName": {},
	              "TypeName": {},
	              "IndexRotationPeriod": {},
	              "BufferingHints": {
	                "shape": "S2n"
	              },
	              "RetryOptions": {
	                "shape": "S2q"
	              },
	              "S3Update": {
	                "shape": "S5a"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              }
	            }
	          },
	          "SplunkDestinationUpdate": {
	            "type": "structure",
	            "members": {
	              "HECEndpoint": {},
	              "HECEndpointType": {},
	              "HECToken": {},
	              "HECAcknowledgmentTimeoutInSeconds": {
	                "type": "integer"
	              },
	              "RetryOptions": {
	                "shape": "S2y"
	              },
	              "S3BackupMode": {},
	              "S3Update": {
	                "shape": "S5a"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              }
	            }
	          },
	          "HttpEndpointDestinationUpdate": {
	            "type": "structure",
	            "members": {
	              "EndpointConfiguration": {
	                "shape": "S32"
	              },
	              "BufferingHints": {
	                "shape": "S36"
	              },
	              "CloudWatchLoggingOptions": {
	                "shape": "Sl"
	              },
	              "RequestConfiguration": {
	                "shape": "S39"
	              },
	              "ProcessingConfiguration": {
	                "shape": "Sq"
	              },
	              "RoleARN": {},
	              "RetryOptions": {
	                "shape": "S3f"
	              },
	              "S3BackupMode": {},
	              "S3Update": {
	                "shape": "S5a"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "S7": {
	      "type": "structure",
	      "required": [
	        "KeyType"
	      ],
	      "members": {
	        "KeyARN": {},
	        "KeyType": {}
	      }
	    },
	    "Sa": {
	      "type": "structure",
	      "required": [
	        "RoleARN",
	        "BucketARN"
	      ],
	      "members": {
	        "RoleARN": {},
	        "BucketARN": {},
	        "Prefix": {},
	        "ErrorOutputPrefix": {},
	        "BufferingHints": {
	          "shape": "Se"
	        },
	        "CompressionFormat": {},
	        "EncryptionConfiguration": {
	          "shape": "Si"
	        },
	        "CloudWatchLoggingOptions": {
	          "shape": "Sl"
	        }
	      }
	    },
	    "Se": {
	      "type": "structure",
	      "members": {
	        "SizeInMBs": {
	          "type": "integer"
	        },
	        "IntervalInSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "Si": {
	      "type": "structure",
	      "members": {
	        "NoEncryptionConfig": {},
	        "KMSEncryptionConfig": {
	          "type": "structure",
	          "required": [
	            "AWSKMSKeyARN"
	          ],
	          "members": {
	            "AWSKMSKeyARN": {}
	          }
	        }
	      }
	    },
	    "Sl": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "LogGroupName": {},
	        "LogStreamName": {}
	      }
	    },
	    "Sq": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Processors": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Type"
	            ],
	            "members": {
	              "Type": {},
	              "Parameters": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "ParameterName",
	                    "ParameterValue"
	                  ],
	                  "members": {
	                    "ParameterName": {},
	                    "ParameterValue": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sz": {
	      "type": "structure",
	      "members": {
	        "SchemaConfiguration": {
	          "type": "structure",
	          "members": {
	            "RoleARN": {},
	            "CatalogId": {},
	            "DatabaseName": {},
	            "TableName": {},
	            "Region": {},
	            "VersionId": {}
	          }
	        },
	        "InputFormatConfiguration": {
	          "type": "structure",
	          "members": {
	            "Deserializer": {
	              "type": "structure",
	              "members": {
	                "OpenXJsonSerDe": {
	                  "type": "structure",
	                  "members": {
	                    "ConvertDotsInJsonKeysToUnderscores": {
	                      "type": "boolean"
	                    },
	                    "CaseInsensitive": {
	                      "type": "boolean"
	                    },
	                    "ColumnToJsonKeyMappings": {
	                      "type": "map",
	                      "key": {},
	                      "value": {}
	                    }
	                  }
	                },
	                "HiveJsonSerDe": {
	                  "type": "structure",
	                  "members": {
	                    "TimestampFormats": {
	                      "type": "list",
	                      "member": {}
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "OutputFormatConfiguration": {
	          "type": "structure",
	          "members": {
	            "Serializer": {
	              "type": "structure",
	              "members": {
	                "ParquetSerDe": {
	                  "type": "structure",
	                  "members": {
	                    "BlockSizeBytes": {
	                      "type": "integer"
	                    },
	                    "PageSizeBytes": {
	                      "type": "integer"
	                    },
	                    "Compression": {},
	                    "EnableDictionaryCompression": {
	                      "type": "boolean"
	                    },
	                    "MaxPaddingBytes": {
	                      "type": "integer"
	                    },
	                    "WriterVersion": {}
	                  }
	                },
	                "OrcSerDe": {
	                  "type": "structure",
	                  "members": {
	                    "StripeSizeBytes": {
	                      "type": "integer"
	                    },
	                    "BlockSizeBytes": {
	                      "type": "integer"
	                    },
	                    "RowIndexStride": {
	                      "type": "integer"
	                    },
	                    "EnablePadding": {
	                      "type": "boolean"
	                    },
	                    "PaddingTolerance": {
	                      "type": "double"
	                    },
	                    "Compression": {},
	                    "BloomFilterColumns": {
	                      "type": "list",
	                      "member": {}
	                    },
	                    "BloomFilterFalsePositiveProbability": {
	                      "type": "double"
	                    },
	                    "DictionaryKeyThreshold": {
	                      "type": "double"
	                    },
	                    "FormatVersion": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1o": {
	      "type": "structure",
	      "members": {
	        "RetryOptions": {
	          "type": "structure",
	          "members": {
	            "DurationInSeconds": {
	              "type": "integer"
	            }
	          }
	        },
	        "Enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1t": {
	      "type": "structure",
	      "required": [
	        "DataTableName"
	      ],
	      "members": {
	        "DataTableName": {},
	        "DataTableColumns": {},
	        "CopyOptions": {}
	      }
	    },
	    "S1x": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S1y": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S1z": {
	      "type": "structure",
	      "members": {
	        "DurationInSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "S28": {
	      "type": "structure",
	      "members": {
	        "IntervalInSeconds": {
	          "type": "integer"
	        },
	        "SizeInMBs": {
	          "type": "integer"
	        }
	      }
	    },
	    "S2b": {
	      "type": "structure",
	      "members": {
	        "DurationInSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "S2e": {
	      "type": "structure",
	      "required": [
	        "SubnetIds",
	        "RoleARN",
	        "SecurityGroupIds"
	      ],
	      "members": {
	        "SubnetIds": {
	          "shape": "S2f"
	        },
	        "RoleARN": {},
	        "SecurityGroupIds": {
	          "shape": "S2g"
	        }
	      }
	    },
	    "S2f": {
	      "type": "list",
	      "member": {}
	    },
	    "S2g": {
	      "type": "list",
	      "member": {}
	    },
	    "S2n": {
	      "type": "structure",
	      "members": {
	        "IntervalInSeconds": {
	          "type": "integer"
	        },
	        "SizeInMBs": {
	          "type": "integer"
	        }
	      }
	    },
	    "S2q": {
	      "type": "structure",
	      "members": {
	        "DurationInSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "S2y": {
	      "type": "structure",
	      "members": {
	        "DurationInSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "S32": {
	      "type": "structure",
	      "required": [
	        "Url"
	      ],
	      "members": {
	        "Url": {
	          "shape": "S33"
	        },
	        "Name": {},
	        "AccessKey": {
	          "type": "string",
	          "sensitive": true
	        }
	      }
	    },
	    "S33": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S36": {
	      "type": "structure",
	      "members": {
	        "SizeInMBs": {
	          "type": "integer"
	        },
	        "IntervalInSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "S39": {
	      "type": "structure",
	      "members": {
	        "ContentEncoding": {},
	        "CommonAttributes": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "AttributeName",
	              "AttributeValue"
	            ],
	            "members": {
	              "AttributeName": {
	                "type": "string",
	                "sensitive": true
	              },
	              "AttributeValue": {
	                "type": "string",
	                "sensitive": true
	              }
	            }
	          }
	        }
	      }
	    },
	    "S3f": {
	      "type": "structure",
	      "members": {
	        "DurationInSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "S3i": {
	      "type": "list",
	      "member": {
	        "shape": "S3j"
	      }
	    },
	    "S3j": {
	      "type": "structure",
	      "required": [
	        "Key"
	      ],
	      "members": {
	        "Key": {},
	        "Value": {}
	      }
	    },
	    "S3w": {
	      "type": "structure",
	      "required": [
	        "Type",
	        "Details"
	      ],
	      "members": {
	        "Type": {},
	        "Details": {}
	      }
	    },
	    "S47": {
	      "type": "structure",
	      "required": [
	        "RoleARN",
	        "BucketARN",
	        "BufferingHints",
	        "CompressionFormat",
	        "EncryptionConfiguration"
	      ],
	      "members": {
	        "RoleARN": {},
	        "BucketARN": {},
	        "Prefix": {},
	        "ErrorOutputPrefix": {},
	        "BufferingHints": {
	          "shape": "Se"
	        },
	        "CompressionFormat": {},
	        "EncryptionConfiguration": {
	          "shape": "Si"
	        },
	        "CloudWatchLoggingOptions": {
	          "shape": "Sl"
	        }
	      }
	    },
	    "S4b": {
	      "type": "structure",
	      "required": [
	        "SubnetIds",
	        "RoleARN",
	        "SecurityGroupIds",
	        "VpcId"
	      ],
	      "members": {
	        "SubnetIds": {
	          "shape": "S2f"
	        },
	        "RoleARN": {},
	        "SecurityGroupIds": {
	          "shape": "S2g"
	        },
	        "VpcId": {}
	      }
	    },
	    "S4p": {
	      "type": "structure",
	      "required": [
	        "Data"
	      ],
	      "members": {
	        "Data": {
	          "type": "blob"
	        }
	      }
	    },
	    "S5a": {
	      "type": "structure",
	      "members": {
	        "RoleARN": {},
	        "BucketARN": {},
	        "Prefix": {},
	        "ErrorOutputPrefix": {},
	        "BufferingHints": {
	          "shape": "Se"
	        },
	        "CompressionFormat": {},
	        "EncryptionConfiguration": {
	          "shape": "Si"
	        },
	        "CloudWatchLoggingOptions": {
	          "shape": "Sl"
	        }
	      }
	    }
	  }
	}
	},{}],114:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],115:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2018-06-26",
	    "endpointPrefix": "forecast",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Forecast Service",
	    "serviceId": "forecast",
	    "signatureVersion": "v4",
	    "signingName": "forecast",
	    "targetPrefix": "AmazonForecast",
	    "uid": "forecast-2018-06-26"
	  },
	  "operations": {
	    "CreateAutoPredictor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PredictorName"
	        ],
	        "members": {
	          "PredictorName": {},
	          "ForecastHorizon": {
	            "type": "integer"
	          },
	          "ForecastTypes": {
	            "shape": "S4"
	          },
	          "ForecastDimensions": {
	            "shape": "S6"
	          },
	          "ForecastFrequency": {},
	          "DataConfig": {
	            "shape": "S8"
	          },
	          "EncryptionConfig": {
	            "shape": "Si"
	          },
	          "ReferencePredictorArn": {},
	          "OptimizationMetric": {},
	          "ExplainPredictor": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "Sm"
	          },
	          "MonitorConfig": {
	            "type": "structure",
	            "required": [
	              "MonitorName"
	            ],
	            "members": {
	              "MonitorName": {}
	            }
	          },
	          "TimeAlignmentBoundary": {
	            "shape": "Sr"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PredictorArn": {}
	        }
	      }
	    },
	    "CreateDataset": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetName",
	          "Domain",
	          "DatasetType",
	          "Schema"
	        ],
	        "members": {
	          "DatasetName": {},
	          "Domain": {},
	          "DatasetType": {},
	          "DataFrequency": {},
	          "Schema": {
	            "shape": "S10"
	          },
	          "EncryptionConfig": {
	            "shape": "Si"
	          },
	          "Tags": {
	            "shape": "Sm"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetArn": {}
	        }
	      }
	    },
	    "CreateDatasetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetGroupName",
	          "Domain"
	        ],
	        "members": {
	          "DatasetGroupName": {},
	          "Domain": {},
	          "DatasetArns": {
	            "shape": "S16"
	          },
	          "Tags": {
	            "shape": "Sm"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetGroupArn": {}
	        }
	      }
	    },
	    "CreateDatasetImportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetImportJobName",
	          "DatasetArn",
	          "DataSource"
	        ],
	        "members": {
	          "DatasetImportJobName": {},
	          "DatasetArn": {},
	          "DataSource": {
	            "shape": "S19"
	          },
	          "TimestampFormat": {},
	          "TimeZone": {},
	          "UseGeolocationForTimeZone": {
	            "type": "boolean"
	          },
	          "GeolocationFormat": {},
	          "Tags": {
	            "shape": "Sm"
	          },
	          "Format": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetImportJobArn": {}
	        }
	      }
	    },
	    "CreateExplainability": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExplainabilityName",
	          "ResourceArn",
	          "ExplainabilityConfig"
	        ],
	        "members": {
	          "ExplainabilityName": {},
	          "ResourceArn": {},
	          "ExplainabilityConfig": {
	            "shape": "S1j"
	          },
	          "DataSource": {
	            "shape": "S19"
	          },
	          "Schema": {
	            "shape": "S10"
	          },
	          "EnableVisualization": {
	            "type": "boolean"
	          },
	          "StartDateTime": {},
	          "EndDateTime": {},
	          "Tags": {
	            "shape": "Sm"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExplainabilityArn": {}
	        }
	      }
	    },
	    "CreateExplainabilityExport": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExplainabilityExportName",
	          "ExplainabilityArn",
	          "Destination"
	        ],
	        "members": {
	          "ExplainabilityExportName": {},
	          "ExplainabilityArn": {},
	          "Destination": {
	            "shape": "S1p"
	          },
	          "Tags": {
	            "shape": "Sm"
	          },
	          "Format": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExplainabilityExportArn": {}
	        }
	      }
	    },
	    "CreateForecast": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ForecastName",
	          "PredictorArn"
	        ],
	        "members": {
	          "ForecastName": {},
	          "PredictorArn": {},
	          "ForecastTypes": {
	            "shape": "S4"
	          },
	          "Tags": {
	            "shape": "Sm"
	          },
	          "TimeSeriesSelector": {
	            "shape": "S1s"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ForecastArn": {}
	        }
	      }
	    },
	    "CreateForecastExportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ForecastExportJobName",
	          "ForecastArn",
	          "Destination"
	        ],
	        "members": {
	          "ForecastExportJobName": {},
	          "ForecastArn": {},
	          "Destination": {
	            "shape": "S1p"
	          },
	          "Tags": {
	            "shape": "Sm"
	          },
	          "Format": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ForecastExportJobArn": {}
	        }
	      }
	    },
	    "CreateMonitor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MonitorName",
	          "ResourceArn"
	        ],
	        "members": {
	          "MonitorName": {},
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "Sm"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MonitorArn": {}
	        }
	      }
	    },
	    "CreatePredictor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PredictorName",
	          "ForecastHorizon",
	          "InputDataConfig",
	          "FeaturizationConfig"
	        ],
	        "members": {
	          "PredictorName": {},
	          "AlgorithmArn": {},
	          "ForecastHorizon": {
	            "type": "integer"
	          },
	          "ForecastTypes": {
	            "shape": "S4"
	          },
	          "PerformAutoML": {
	            "type": "boolean"
	          },
	          "AutoMLOverrideStrategy": {},
	          "PerformHPO": {
	            "type": "boolean"
	          },
	          "TrainingParameters": {
	            "shape": "S21"
	          },
	          "EvaluationParameters": {
	            "shape": "S24"
	          },
	          "HPOConfig": {
	            "shape": "S25"
	          },
	          "InputDataConfig": {
	            "shape": "S2f"
	          },
	          "FeaturizationConfig": {
	            "shape": "S2i"
	          },
	          "EncryptionConfig": {
	            "shape": "Si"
	          },
	          "Tags": {
	            "shape": "Sm"
	          },
	          "OptimizationMetric": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PredictorArn": {}
	        }
	      }
	    },
	    "CreatePredictorBacktestExportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PredictorBacktestExportJobName",
	          "PredictorArn",
	          "Destination"
	        ],
	        "members": {
	          "PredictorBacktestExportJobName": {},
	          "PredictorArn": {},
	          "Destination": {
	            "shape": "S1p"
	          },
	          "Tags": {
	            "shape": "Sm"
	          },
	          "Format": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PredictorBacktestExportJobArn": {}
	        }
	      }
	    },
	    "DeleteDataset": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetArn"
	        ],
	        "members": {
	          "DatasetArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteDatasetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetGroupArn"
	        ],
	        "members": {
	          "DatasetGroupArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteDatasetImportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetImportJobArn"
	        ],
	        "members": {
	          "DatasetImportJobArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteExplainability": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExplainabilityArn"
	        ],
	        "members": {
	          "ExplainabilityArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteExplainabilityExport": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExplainabilityExportArn"
	        ],
	        "members": {
	          "ExplainabilityExportArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteForecast": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ForecastArn"
	        ],
	        "members": {
	          "ForecastArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteForecastExportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ForecastExportJobArn"
	        ],
	        "members": {
	          "ForecastExportJobArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteMonitor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MonitorArn"
	        ],
	        "members": {
	          "MonitorArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeletePredictor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PredictorArn"
	        ],
	        "members": {
	          "PredictorArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeletePredictorBacktestExportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PredictorBacktestExportJobArn"
	        ],
	        "members": {
	          "PredictorBacktestExportJobArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteResourceTree": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeAutoPredictor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PredictorArn"
	        ],
	        "members": {
	          "PredictorArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PredictorArn": {},
	          "PredictorName": {},
	          "ForecastHorizon": {
	            "type": "integer"
	          },
	          "ForecastTypes": {
	            "shape": "S4"
	          },
	          "ForecastFrequency": {},
	          "ForecastDimensions": {
	            "shape": "S6"
	          },
	          "DatasetImportJobArns": {
	            "shape": "S16"
	          },
	          "DataConfig": {
	            "shape": "S8"
	          },
	          "EncryptionConfig": {
	            "shape": "Si"
	          },
	          "ReferencePredictorSummary": {
	            "shape": "S35"
	          },
	          "EstimatedTimeRemainingInMinutes": {
	            "type": "long"
	          },
	          "Status": {},
	          "Message": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModificationTime": {
	            "type": "timestamp"
	          },
	          "OptimizationMetric": {},
	          "ExplainabilityInfo": {
	            "type": "structure",
	            "members": {
	              "ExplainabilityArn": {},
	              "Status": {}
	            }
	          },
	          "MonitorInfo": {
	            "type": "structure",
	            "members": {
	              "MonitorArn": {},
	              "Status": {}
	            }
	          },
	          "TimeAlignmentBoundary": {
	            "shape": "Sr"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeDataset": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetArn"
	        ],
	        "members": {
	          "DatasetArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetArn": {},
	          "DatasetName": {},
	          "Domain": {},
	          "DatasetType": {},
	          "DataFrequency": {},
	          "Schema": {
	            "shape": "S10"
	          },
	          "EncryptionConfig": {
	            "shape": "Si"
	          },
	          "Status": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModificationTime": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeDatasetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetGroupArn"
	        ],
	        "members": {
	          "DatasetGroupArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetGroupName": {},
	          "DatasetGroupArn": {},
	          "DatasetArns": {
	            "shape": "S16"
	          },
	          "Domain": {},
	          "Status": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModificationTime": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeDatasetImportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetImportJobArn"
	        ],
	        "members": {
	          "DatasetImportJobArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetImportJobName": {},
	          "DatasetImportJobArn": {},
	          "DatasetArn": {},
	          "TimestampFormat": {},
	          "TimeZone": {},
	          "UseGeolocationForTimeZone": {
	            "type": "boolean"
	          },
	          "GeolocationFormat": {},
	          "DataSource": {
	            "shape": "S19"
	          },
	          "EstimatedTimeRemainingInMinutes": {
	            "type": "long"
	          },
	          "FieldStatistics": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "members": {
	                "Count": {
	                  "type": "integer"
	                },
	                "CountDistinct": {
	                  "type": "integer"
	                },
	                "CountNull": {
	                  "type": "integer"
	                },
	                "CountNan": {
	                  "type": "integer"
	                },
	                "Min": {},
	                "Max": {},
	                "Avg": {
	                  "type": "double"
	                },
	                "Stddev": {
	                  "type": "double"
	                },
	                "CountLong": {
	                  "type": "long"
	                },
	                "CountDistinctLong": {
	                  "type": "long"
	                },
	                "CountNullLong": {
	                  "type": "long"
	                },
	                "CountNanLong": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "DataSize": {
	            "type": "double"
	          },
	          "Status": {},
	          "Message": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModificationTime": {
	            "type": "timestamp"
	          },
	          "Format": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeExplainability": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExplainabilityArn"
	        ],
	        "members": {
	          "ExplainabilityArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExplainabilityArn": {},
	          "ExplainabilityName": {},
	          "ResourceArn": {},
	          "ExplainabilityConfig": {
	            "shape": "S1j"
	          },
	          "EnableVisualization": {
	            "type": "boolean"
	          },
	          "DataSource": {
	            "shape": "S19"
	          },
	          "Schema": {
	            "shape": "S10"
	          },
	          "StartDateTime": {},
	          "EndDateTime": {},
	          "EstimatedTimeRemainingInMinutes": {
	            "type": "long"
	          },
	          "Message": {},
	          "Status": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModificationTime": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeExplainabilityExport": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExplainabilityExportArn"
	        ],
	        "members": {
	          "ExplainabilityExportArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExplainabilityExportArn": {},
	          "ExplainabilityExportName": {},
	          "ExplainabilityArn": {},
	          "Destination": {
	            "shape": "S1p"
	          },
	          "Message": {},
	          "Status": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModificationTime": {
	            "type": "timestamp"
	          },
	          "Format": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeForecast": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ForecastArn"
	        ],
	        "members": {
	          "ForecastArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ForecastArn": {},
	          "ForecastName": {},
	          "ForecastTypes": {
	            "shape": "S4"
	          },
	          "PredictorArn": {},
	          "DatasetGroupArn": {},
	          "EstimatedTimeRemainingInMinutes": {
	            "type": "long"
	          },
	          "Status": {},
	          "Message": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModificationTime": {
	            "type": "timestamp"
	          },
	          "TimeSeriesSelector": {
	            "shape": "S1s"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeForecastExportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ForecastExportJobArn"
	        ],
	        "members": {
	          "ForecastExportJobArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ForecastExportJobArn": {},
	          "ForecastExportJobName": {},
	          "ForecastArn": {},
	          "Destination": {
	            "shape": "S1p"
	          },
	          "Message": {},
	          "Status": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModificationTime": {
	            "type": "timestamp"
	          },
	          "Format": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeMonitor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MonitorArn"
	        ],
	        "members": {
	          "MonitorArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MonitorName": {},
	          "MonitorArn": {},
	          "ResourceArn": {},
	          "Status": {},
	          "LastEvaluationTime": {
	            "type": "timestamp"
	          },
	          "LastEvaluationState": {},
	          "Baseline": {
	            "type": "structure",
	            "members": {
	              "PredictorBaseline": {
	                "type": "structure",
	                "members": {
	                  "BaselineMetrics": {
	                    "type": "list",
	                    "member": {
	                      "type": "structure",
	                      "members": {
	                        "Name": {},
	                        "Value": {
	                          "type": "double"
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Message": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModificationTime": {
	            "type": "timestamp"
	          },
	          "EstimatedEvaluationTimeRemainingInMinutes": {
	            "type": "long"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribePredictor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PredictorArn"
	        ],
	        "members": {
	          "PredictorArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PredictorArn": {},
	          "PredictorName": {},
	          "AlgorithmArn": {},
	          "AutoMLAlgorithmArns": {
	            "shape": "S16"
	          },
	          "ForecastHorizon": {
	            "type": "integer"
	          },
	          "ForecastTypes": {
	            "shape": "S4"
	          },
	          "PerformAutoML": {
	            "type": "boolean"
	          },
	          "AutoMLOverrideStrategy": {},
	          "PerformHPO": {
	            "type": "boolean"
	          },
	          "TrainingParameters": {
	            "shape": "S21"
	          },
	          "EvaluationParameters": {
	            "shape": "S24"
	          },
	          "HPOConfig": {
	            "shape": "S25"
	          },
	          "InputDataConfig": {
	            "shape": "S2f"
	          },
	          "FeaturizationConfig": {
	            "shape": "S2i"
	          },
	          "EncryptionConfig": {
	            "shape": "Si"
	          },
	          "PredictorExecutionDetails": {
	            "type": "structure",
	            "members": {
	              "PredictorExecutions": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "AlgorithmArn": {},
	                    "TestWindows": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "members": {
	                          "TestWindowStart": {
	                            "type": "timestamp"
	                          },
	                          "TestWindowEnd": {
	                            "type": "timestamp"
	                          },
	                          "Status": {},
	                          "Message": {}
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "EstimatedTimeRemainingInMinutes": {
	            "type": "long"
	          },
	          "IsAutoPredictor": {
	            "type": "boolean"
	          },
	          "DatasetImportJobArns": {
	            "shape": "S16"
	          },
	          "Status": {},
	          "Message": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModificationTime": {
	            "type": "timestamp"
	          },
	          "OptimizationMetric": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DescribePredictorBacktestExportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PredictorBacktestExportJobArn"
	        ],
	        "members": {
	          "PredictorBacktestExportJobArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PredictorBacktestExportJobArn": {},
	          "PredictorBacktestExportJobName": {},
	          "PredictorArn": {},
	          "Destination": {
	            "shape": "S1p"
	          },
	          "Message": {},
	          "Status": {},
	          "CreationTime": {
	            "type": "timestamp"
	          },
	          "LastModificationTime": {
	            "type": "timestamp"
	          },
	          "Format": {}
	        }
	      },
	      "idempotent": true
	    },
	    "GetAccuracyMetrics": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PredictorArn"
	        ],
	        "members": {
	          "PredictorArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PredictorEvaluationResults": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AlgorithmArn": {},
	                "TestWindows": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "TestWindowStart": {
	                        "type": "timestamp"
	                      },
	                      "TestWindowEnd": {
	                        "type": "timestamp"
	                      },
	                      "ItemCount": {
	                        "type": "integer"
	                      },
	                      "EvaluationType": {},
	                      "Metrics": {
	                        "type": "structure",
	                        "members": {
	                          "RMSE": {
	                            "deprecated": true,
	                            "deprecatedMessage": "This property is deprecated, please refer to ErrorMetrics for both RMSE and WAPE",
	                            "type": "double"
	                          },
	                          "WeightedQuantileLosses": {
	                            "type": "list",
	                            "member": {
	                              "type": "structure",
	                              "members": {
	                                "Quantile": {
	                                  "type": "double"
	                                },
	                                "LossValue": {
	                                  "type": "double"
	                                }
	                              }
	                            }
	                          },
	                          "ErrorMetrics": {
	                            "type": "list",
	                            "member": {
	                              "type": "structure",
	                              "members": {
	                                "ForecastType": {},
	                                "WAPE": {
	                                  "type": "double"
	                                },
	                                "RMSE": {
	                                  "type": "double"
	                                },
	                                "MASE": {
	                                  "type": "double"
	                                },
	                                "MAPE": {
	                                  "type": "double"
	                                }
	                              }
	                            }
	                          },
	                          "AverageWeightedQuantileLoss": {
	                            "type": "double"
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "IsAutoPredictor": {
	            "type": "boolean"
	          },
	          "AutoMLOverrideStrategy": {},
	          "OptimizationMetric": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListDatasetGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DatasetGroupArn": {},
	                "DatasetGroupName": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModificationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListDatasetImportJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetImportJobs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DatasetImportJobArn": {},
	                "DatasetImportJobName": {},
	                "DataSource": {
	                  "shape": "S19"
	                },
	                "Status": {},
	                "Message": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModificationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListDatasets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Datasets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DatasetArn": {},
	                "DatasetName": {},
	                "DatasetType": {},
	                "Domain": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModificationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListExplainabilities": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Explainabilities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ExplainabilityArn": {},
	                "ExplainabilityName": {},
	                "ResourceArn": {},
	                "ExplainabilityConfig": {
	                  "shape": "S1j"
	                },
	                "Status": {},
	                "Message": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModificationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListExplainabilityExports": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ExplainabilityExports": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ExplainabilityExportArn": {},
	                "ExplainabilityExportName": {},
	                "Destination": {
	                  "shape": "S1p"
	                },
	                "Status": {},
	                "Message": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModificationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListForecastExportJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ForecastExportJobs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ForecastExportJobArn": {},
	                "ForecastExportJobName": {},
	                "Destination": {
	                  "shape": "S1p"
	                },
	                "Status": {},
	                "Message": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModificationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListForecasts": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Forecasts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ForecastArn": {},
	                "ForecastName": {},
	                "PredictorArn": {},
	                "CreatedUsingAutoPredictor": {
	                  "type": "boolean"
	                },
	                "DatasetGroupArn": {},
	                "Status": {},
	                "Message": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModificationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListMonitorEvaluations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MonitorArn"
	        ],
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "MonitorArn": {},
	          "Filters": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "PredictorMonitorEvaluations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ResourceArn": {},
	                "MonitorArn": {},
	                "EvaluationTime": {
	                  "type": "timestamp"
	                },
	                "EvaluationState": {},
	                "WindowStartDatetime": {
	                  "type": "timestamp"
	                },
	                "WindowEndDatetime": {
	                  "type": "timestamp"
	                },
	                "PredictorEvent": {
	                  "type": "structure",
	                  "members": {
	                    "Detail": {},
	                    "Datetime": {
	                      "type": "timestamp"
	                    }
	                  }
	                },
	                "MonitorDataSource": {
	                  "type": "structure",
	                  "members": {
	                    "DatasetImportJobArn": {},
	                    "ForecastArn": {},
	                    "PredictorArn": {}
	                  }
	                },
	                "MetricResults": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "MetricName": {},
	                      "MetricValue": {
	                        "type": "double"
	                      }
	                    }
	                  }
	                },
	                "NumItemsEvaluated": {
	                  "type": "long"
	                },
	                "Message": {}
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "ListMonitors": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Monitors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "MonitorArn": {},
	                "MonitorName": {},
	                "ResourceArn": {},
	                "Status": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModificationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListPredictorBacktestExportJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PredictorBacktestExportJobs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PredictorBacktestExportJobArn": {},
	                "PredictorBacktestExportJobName": {},
	                "Destination": {
	                  "shape": "S1p"
	                },
	                "Status": {},
	                "Message": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModificationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListPredictors": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "S4u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Predictors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PredictorArn": {},
	                "PredictorName": {},
	                "DatasetGroupArn": {},
	                "IsAutoPredictor": {
	                  "type": "boolean"
	                },
	                "ReferencePredictorSummary": {
	                  "shape": "S35"
	                },
	                "Status": {},
	                "Message": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "LastModificationTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "Sm"
	          }
	        }
	      }
	    },
	    "ResumeResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StopResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "Sm"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {
	              "shape": "So"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateDatasetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetGroupArn",
	          "DatasetArns"
	        ],
	        "members": {
	          "DatasetGroupArn": {},
	          "DatasetArns": {
	            "shape": "S16"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "list",
	      "member": {}
	    },
	    "S6": {
	      "type": "list",
	      "member": {}
	    },
	    "S8": {
	      "type": "structure",
	      "required": [
	        "DatasetGroupArn"
	      ],
	      "members": {
	        "DatasetGroupArn": {},
	        "AttributeConfigs": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "AttributeName",
	              "Transformations"
	            ],
	            "members": {
	              "AttributeName": {},
	              "Transformations": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              }
	            }
	          }
	        },
	        "AdditionalDatasets": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Name"
	            ],
	            "members": {
	              "Name": {},
	              "Configuration": {
	                "type": "map",
	                "key": {},
	                "value": {
	                  "shape": "Sh"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sh": {
	      "type": "list",
	      "member": {}
	    },
	    "Si": {
	      "type": "structure",
	      "required": [
	        "RoleArn",
	        "KMSKeyArn"
	      ],
	      "members": {
	        "RoleArn": {},
	        "KMSKeyArn": {}
	      }
	    },
	    "Sm": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {
	            "shape": "So"
	          },
	          "Value": {
	            "type": "string",
	            "sensitive": true
	          }
	        }
	      }
	    },
	    "So": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Sr": {
	      "type": "structure",
	      "members": {
	        "Month": {},
	        "DayOfMonth": {
	          "type": "integer"
	        },
	        "DayOfWeek": {},
	        "Hour": {
	          "type": "integer"
	        }
	      }
	    },
	    "S10": {
	      "type": "structure",
	      "members": {
	        "Attributes": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "AttributeName": {},
	              "AttributeType": {}
	            }
	          }
	        }
	      }
	    },
	    "S16": {
	      "type": "list",
	      "member": {}
	    },
	    "S19": {
	      "type": "structure",
	      "required": [
	        "S3Config"
	      ],
	      "members": {
	        "S3Config": {
	          "shape": "S1a"
	        }
	      }
	    },
	    "S1a": {
	      "type": "structure",
	      "required": [
	        "Path",
	        "RoleArn"
	      ],
	      "members": {
	        "Path": {},
	        "RoleArn": {},
	        "KMSKeyArn": {}
	      }
	    },
	    "S1j": {
	      "type": "structure",
	      "required": [
	        "TimeSeriesGranularity",
	        "TimePointGranularity"
	      ],
	      "members": {
	        "TimeSeriesGranularity": {},
	        "TimePointGranularity": {}
	      }
	    },
	    "S1p": {
	      "type": "structure",
	      "required": [
	        "S3Config"
	      ],
	      "members": {
	        "S3Config": {
	          "shape": "S1a"
	        }
	      }
	    },
	    "S1s": {
	      "type": "structure",
	      "members": {
	        "TimeSeriesIdentifiers": {
	          "type": "structure",
	          "members": {
	            "DataSource": {
	              "shape": "S19"
	            },
	            "Schema": {
	              "shape": "S10"
	            },
	            "Format": {}
	          }
	        }
	      }
	    },
	    "S21": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S24": {
	      "type": "structure",
	      "members": {
	        "NumberOfBacktestWindows": {
	          "type": "integer"
	        },
	        "BackTestWindowOffset": {
	          "type": "integer"
	        }
	      }
	    },
	    "S25": {
	      "type": "structure",
	      "members": {
	        "ParameterRanges": {
	          "type": "structure",
	          "members": {
	            "CategoricalParameterRanges": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "required": [
	                  "Name",
	                  "Values"
	                ],
	                "members": {
	                  "Name": {},
	                  "Values": {
	                    "shape": "Sh"
	                  }
	                }
	              }
	            },
	            "ContinuousParameterRanges": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "required": [
	                  "Name",
	                  "MaxValue",
	                  "MinValue"
	                ],
	                "members": {
	                  "Name": {},
	                  "MaxValue": {
	                    "type": "double"
	                  },
	                  "MinValue": {
	                    "type": "double"
	                  },
	                  "ScalingType": {}
	                }
	              }
	            },
	            "IntegerParameterRanges": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "required": [
	                  "Name",
	                  "MaxValue",
	                  "MinValue"
	                ],
	                "members": {
	                  "Name": {},
	                  "MaxValue": {
	                    "type": "integer"
	                  },
	                  "MinValue": {
	                    "type": "integer"
	                  },
	                  "ScalingType": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2f": {
	      "type": "structure",
	      "required": [
	        "DatasetGroupArn"
	      ],
	      "members": {
	        "DatasetGroupArn": {},
	        "SupplementaryFeatures": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Name",
	              "Value"
	            ],
	            "members": {
	              "Name": {},
	              "Value": {}
	            }
	          }
	        }
	      }
	    },
	    "S2i": {
	      "type": "structure",
	      "required": [
	        "ForecastFrequency"
	      ],
	      "members": {
	        "ForecastFrequency": {},
	        "ForecastDimensions": {
	          "shape": "S6"
	        },
	        "Featurizations": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "AttributeName"
	            ],
	            "members": {
	              "AttributeName": {},
	              "FeaturizationPipeline": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "FeaturizationMethodName"
	                  ],
	                  "members": {
	                    "FeaturizationMethodName": {},
	                    "FeaturizationMethodParameters": {
	                      "type": "map",
	                      "key": {},
	                      "value": {}
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S35": {
	      "type": "structure",
	      "members": {
	        "Arn": {},
	        "State": {}
	      }
	    },
	    "S4u": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value",
	          "Condition"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {},
	          "Condition": {}
	        }
	      }
	    }
	  }
	}
	},{}],116:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListDatasetGroups": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "DatasetGroups"
	    },
	    "ListDatasetImportJobs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "DatasetImportJobs"
	    },
	    "ListDatasets": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Datasets"
	    },
	    "ListExplainabilities": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Explainabilities"
	    },
	    "ListExplainabilityExports": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ExplainabilityExports"
	    },
	    "ListForecastExportJobs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ForecastExportJobs"
	    },
	    "ListForecasts": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Forecasts"
	    },
	    "ListMonitorEvaluations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "PredictorMonitorEvaluations"
	    },
	    "ListMonitors": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Monitors"
	    },
	    "ListPredictorBacktestExportJobs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "PredictorBacktestExportJobs"
	    },
	    "ListPredictors": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Predictors"
	    }
	  }
	}
	},{}],117:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2018-06-26",
	    "endpointPrefix": "forecastquery",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Forecast Query Service",
	    "serviceId": "forecastquery",
	    "signatureVersion": "v4",
	    "signingName": "forecast",
	    "targetPrefix": "AmazonForecastRuntime",
	    "uid": "forecastquery-2018-06-26"
	  },
	  "operations": {
	    "QueryForecast": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ForecastArn",
	          "Filters"
	        ],
	        "members": {
	          "ForecastArn": {},
	          "StartDate": {},
	          "EndDate": {},
	          "Filters": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Forecast": {
	            "type": "structure",
	            "members": {
	              "Predictions": {
	                "type": "map",
	                "key": {},
	                "value": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Timestamp": {},
	                      "Value": {
	                        "type": "double"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	  },
	  "shapes": {}
	}
	},{}],118:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],119:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-10-01",
	    "endpointPrefix": "gamelift",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon GameLift",
	    "serviceId": "GameLift",
	    "signatureVersion": "v4",
	    "targetPrefix": "GameLift",
	    "uid": "gamelift-2015-10-01"
	  },
	  "operations": {
	    "AcceptMatch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TicketId",
	          "PlayerIds",
	          "AcceptanceType"
	        ],
	        "members": {
	          "TicketId": {},
	          "PlayerIds": {
	            "shape": "S3"
	          },
	          "AcceptanceType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ClaimGameServer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "GameServerId": {},
	          "GameServerData": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServer": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "CreateAlias": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "RoutingStrategy"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "RoutingStrategy": {
	            "shape": "Sm"
	          },
	          "Tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Alias": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "CreateBuild": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Version": {},
	          "StorageLocation": {
	            "shape": "Sz"
	          },
	          "OperatingSystem": {},
	          "Tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Build": {
	            "shape": "S13"
	          },
	          "UploadCredentials": {
	            "shape": "S18"
	          },
	          "StorageLocation": {
	            "shape": "Sz"
	          }
	        }
	      }
	    },
	    "CreateFleet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "EC2InstanceType"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "BuildId": {},
	          "ScriptId": {},
	          "ServerLaunchPath": {},
	          "ServerLaunchParameters": {},
	          "LogPaths": {
	            "shape": "S3"
	          },
	          "EC2InstanceType": {},
	          "EC2InboundPermissions": {
	            "shape": "S1f"
	          },
	          "NewGameSessionProtectionPolicy": {},
	          "RuntimeConfiguration": {
	            "shape": "S1l"
	          },
	          "ResourceCreationLimitPolicy": {
	            "shape": "S1r"
	          },
	          "MetricGroups": {
	            "shape": "S1t"
	          },
	          "PeerVpcAwsAccountId": {},
	          "PeerVpcId": {},
	          "FleetType": {},
	          "InstanceRoleArn": {},
	          "CertificateConfiguration": {
	            "shape": "S1w"
	          },
	          "Locations": {
	            "shape": "S1y"
	          },
	          "Tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetAttributes": {
	            "shape": "S22"
	          },
	          "LocationStates": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "CreateFleetLocations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId",
	          "Locations"
	        ],
	        "members": {
	          "FleetId": {},
	          "Locations": {
	            "shape": "S1y"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetId": {},
	          "FleetArn": {},
	          "LocationStates": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "CreateGameServerGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName",
	          "RoleArn",
	          "MinSize",
	          "MaxSize",
	          "LaunchTemplate",
	          "InstanceDefinitions"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "RoleArn": {},
	          "MinSize": {
	            "type": "integer"
	          },
	          "MaxSize": {
	            "type": "integer"
	          },
	          "LaunchTemplate": {
	            "type": "structure",
	            "members": {
	              "LaunchTemplateId": {},
	              "LaunchTemplateName": {},
	              "Version": {}
	            }
	          },
	          "InstanceDefinitions": {
	            "shape": "S2k"
	          },
	          "AutoScalingPolicy": {
	            "type": "structure",
	            "required": [
	              "TargetTrackingConfiguration"
	            ],
	            "members": {
	              "EstimatedInstanceWarmup": {
	                "type": "integer"
	              },
	              "TargetTrackingConfiguration": {
	                "type": "structure",
	                "required": [
	                  "TargetValue"
	                ],
	                "members": {
	                  "TargetValue": {
	                    "type": "double"
	                  }
	                }
	              }
	            }
	          },
	          "BalancingStrategy": {},
	          "GameServerProtectionPolicy": {},
	          "VpcSubnets": {
	            "type": "list",
	            "member": {}
	          },
	          "Tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServerGroup": {
	            "shape": "S2w"
	          }
	        }
	      }
	    },
	    "CreateGameSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MaximumPlayerSessionCount"
	        ],
	        "members": {
	          "FleetId": {},
	          "AliasId": {},
	          "MaximumPlayerSessionCount": {
	            "type": "integer"
	          },
	          "Name": {},
	          "GameProperties": {
	            "shape": "S33"
	          },
	          "CreatorId": {},
	          "GameSessionId": {},
	          "IdempotencyToken": {},
	          "GameSessionData": {},
	          "Location": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameSession": {
	            "shape": "S3a"
	          }
	        }
	      }
	    },
	    "CreateGameSessionQueue": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "TimeoutInSeconds": {
	            "type": "integer"
	          },
	          "PlayerLatencyPolicies": {
	            "shape": "S3j"
	          },
	          "Destinations": {
	            "shape": "S3l"
	          },
	          "FilterConfiguration": {
	            "shape": "S3o"
	          },
	          "PriorityConfiguration": {
	            "shape": "S3q"
	          },
	          "CustomEventData": {},
	          "NotificationTarget": {},
	          "Tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameSessionQueue": {
	            "shape": "S3w"
	          }
	        }
	      }
	    },
	    "CreateMatchmakingConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "RequestTimeoutSeconds",
	          "AcceptanceRequired",
	          "RuleSetName"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "GameSessionQueueArns": {
	            "shape": "S3z"
	          },
	          "RequestTimeoutSeconds": {
	            "type": "integer"
	          },
	          "AcceptanceTimeoutSeconds": {
	            "type": "integer"
	          },
	          "AcceptanceRequired": {
	            "type": "boolean"
	          },
	          "RuleSetName": {},
	          "NotificationTarget": {},
	          "AdditionalPlayerCount": {
	            "type": "integer"
	          },
	          "CustomEventData": {},
	          "GameProperties": {
	            "shape": "S33"
	          },
	          "GameSessionData": {},
	          "BackfillMode": {},
	          "FlexMatchMode": {},
	          "Tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Configuration": {
	            "shape": "S4a"
	          }
	        }
	      }
	    },
	    "CreateMatchmakingRuleSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "RuleSetBody"
	        ],
	        "members": {
	          "Name": {},
	          "RuleSetBody": {},
	          "Tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "RuleSet"
	        ],
	        "members": {
	          "RuleSet": {
	            "shape": "S4g"
	          }
	        }
	      }
	    },
	    "CreatePlayerSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameSessionId",
	          "PlayerId"
	        ],
	        "members": {
	          "GameSessionId": {},
	          "PlayerId": {},
	          "PlayerData": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PlayerSession": {
	            "shape": "S4k"
	          }
	        }
	      }
	    },
	    "CreatePlayerSessions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameSessionId",
	          "PlayerIds"
	        ],
	        "members": {
	          "GameSessionId": {},
	          "PlayerIds": {
	            "type": "list",
	            "member": {}
	          },
	          "PlayerDataMap": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PlayerSessions": {
	            "shape": "S4r"
	          }
	        }
	      }
	    },
	    "CreateScript": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Version": {},
	          "StorageLocation": {
	            "shape": "Sz"
	          },
	          "ZipFile": {
	            "type": "blob"
	          },
	          "Tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Script": {
	            "shape": "S4v"
	          }
	        }
	      }
	    },
	    "CreateVpcPeeringAuthorization": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameLiftAwsAccountId",
	          "PeerVpcId"
	        ],
	        "members": {
	          "GameLiftAwsAccountId": {},
	          "PeerVpcId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpcPeeringAuthorization": {
	            "shape": "S4y"
	          }
	        }
	      }
	    },
	    "CreateVpcPeeringConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId",
	          "PeerVpcAwsAccountId",
	          "PeerVpcId"
	        ],
	        "members": {
	          "FleetId": {},
	          "PeerVpcAwsAccountId": {},
	          "PeerVpcId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteAlias": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AliasId"
	        ],
	        "members": {
	          "AliasId": {}
	        }
	      }
	    },
	    "DeleteBuild": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BuildId"
	        ],
	        "members": {
	          "BuildId": {}
	        }
	      }
	    },
	    "DeleteFleet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "FleetId": {}
	        }
	      }
	    },
	    "DeleteFleetLocations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId",
	          "Locations"
	        ],
	        "members": {
	          "FleetId": {},
	          "Locations": {
	            "shape": "S3p"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetId": {},
	          "FleetArn": {},
	          "LocationStates": {
	            "shape": "S29"
	          }
	        }
	      }
	    },
	    "DeleteGameServerGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "DeleteOption": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServerGroup": {
	            "shape": "S2w"
	          }
	        }
	      }
	    },
	    "DeleteGameSessionQueue": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteMatchmakingConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteMatchmakingRuleSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteScalingPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "FleetId"
	        ],
	        "members": {
	          "Name": {},
	          "FleetId": {}
	        }
	      }
	    },
	    "DeleteScript": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ScriptId"
	        ],
	        "members": {
	          "ScriptId": {}
	        }
	      }
	    },
	    "DeleteVpcPeeringAuthorization": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameLiftAwsAccountId",
	          "PeerVpcId"
	        ],
	        "members": {
	          "GameLiftAwsAccountId": {},
	          "PeerVpcId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteVpcPeeringConnection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId",
	          "VpcPeeringConnectionId"
	        ],
	        "members": {
	          "FleetId": {},
	          "VpcPeeringConnectionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeregisterGameServer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName",
	          "GameServerId"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "GameServerId": {}
	        }
	      }
	    },
	    "DescribeAlias": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AliasId"
	        ],
	        "members": {
	          "AliasId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Alias": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "DescribeBuild": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BuildId"
	        ],
	        "members": {
	          "BuildId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Build": {
	            "shape": "S13"
	          }
	        }
	      }
	    },
	    "DescribeEC2InstanceLimits": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EC2InstanceType": {},
	          "Location": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EC2InstanceLimits": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EC2InstanceType": {},
	                "CurrentInstances": {
	                  "type": "integer"
	                },
	                "InstanceLimit": {
	                  "type": "integer"
	                },
	                "Location": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeFleetAttributes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FleetIds": {
	            "shape": "S5x"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetAttributes": {
	            "type": "list",
	            "member": {
	              "shape": "S22"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeFleetCapacity": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FleetIds": {
	            "shape": "S5x"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetCapacity": {
	            "type": "list",
	            "member": {
	              "shape": "S63"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeFleetEvents": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "FleetId": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Events": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EventId": {},
	                "ResourceId": {},
	                "EventCode": {},
	                "Message": {},
	                "EventTime": {
	                  "type": "timestamp"
	                },
	                "PreSignedLogUrl": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeFleetLocationAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "FleetId": {},
	          "Locations": {
	            "shape": "S3p"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetId": {},
	          "FleetArn": {},
	          "LocationAttributes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "LocationState": {
	                  "shape": "S2a"
	                },
	                "StoppedActions": {
	                  "shape": "S27"
	                },
	                "UpdateStatus": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeFleetLocationCapacity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId",
	          "Location"
	        ],
	        "members": {
	          "FleetId": {},
	          "Location": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetCapacity": {
	            "shape": "S63"
	          }
	        }
	      }
	    },
	    "DescribeFleetLocationUtilization": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId",
	          "Location"
	        ],
	        "members": {
	          "FleetId": {},
	          "Location": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetUtilization": {
	            "shape": "S6j"
	          }
	        }
	      }
	    },
	    "DescribeFleetPortSettings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "FleetId": {},
	          "Location": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetId": {},
	          "FleetArn": {},
	          "InboundPermissions": {
	            "shape": "S1f"
	          },
	          "UpdateStatus": {},
	          "Location": {}
	        }
	      }
	    },
	    "DescribeFleetUtilization": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FleetIds": {
	            "shape": "S5x"
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetUtilization": {
	            "type": "list",
	            "member": {
	              "shape": "S6j"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeGameServer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName",
	          "GameServerId"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "GameServerId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServer": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "DescribeGameServerGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName"
	        ],
	        "members": {
	          "GameServerGroupName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServerGroup": {
	            "shape": "S2w"
	          }
	        }
	      }
	    },
	    "DescribeGameServerInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "InstanceIds": {
	            "type": "list",
	            "member": {}
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServerInstances": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "GameServerGroupName": {},
	                "GameServerGroupArn": {},
	                "InstanceId": {},
	                "InstanceStatus": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeGameSessionDetails": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FleetId": {},
	          "GameSessionId": {},
	          "AliasId": {},
	          "Location": {},
	          "StatusFilter": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameSessionDetails": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "GameSession": {
	                  "shape": "S3a"
	                },
	                "ProtectionPolicy": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeGameSessionPlacement": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlacementId"
	        ],
	        "members": {
	          "PlacementId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameSessionPlacement": {
	            "shape": "S75"
	          }
	        }
	      }
	    },
	    "DescribeGameSessionQueues": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Names": {
	            "type": "list",
	            "member": {}
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameSessionQueues": {
	            "type": "list",
	            "member": {
	              "shape": "S3w"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeGameSessions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FleetId": {},
	          "GameSessionId": {},
	          "AliasId": {},
	          "Location": {},
	          "StatusFilter": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameSessions": {
	            "shape": "S7i"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "FleetId": {},
	          "InstanceId": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "Location": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Instances": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FleetId": {},
	                "FleetArn": {},
	                "InstanceId": {},
	                "IpAddress": {},
	                "DnsName": {},
	                "OperatingSystem": {},
	                "Type": {},
	                "Status": {},
	                "CreationTime": {
	                  "type": "timestamp"
	                },
	                "Location": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMatchmaking": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TicketIds"
	        ],
	        "members": {
	          "TicketIds": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TicketList": {
	            "type": "list",
	            "member": {
	              "shape": "S7t"
	            }
	          }
	        }
	      }
	    },
	    "DescribeMatchmakingConfigurations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Names": {
	            "type": "list",
	            "member": {}
	          },
	          "RuleSetName": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Configurations": {
	            "type": "list",
	            "member": {
	              "shape": "S4a"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMatchmakingRuleSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Names": {
	            "type": "list",
	            "member": {}
	          },
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "RuleSets"
	        ],
	        "members": {
	          "RuleSets": {
	            "type": "list",
	            "member": {
	              "shape": "S4g"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribePlayerSessions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GameSessionId": {},
	          "PlayerId": {},
	          "PlayerSessionId": {},
	          "PlayerSessionStatusFilter": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PlayerSessions": {
	            "shape": "S4r"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeRuntimeConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "FleetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RuntimeConfiguration": {
	            "shape": "S1l"
	          }
	        }
	      }
	    },
	    "DescribeScalingPolicies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "FleetId": {},
	          "StatusFilter": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "Location": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ScalingPolicies": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FleetId": {},
	                "FleetArn": {},
	                "Name": {},
	                "Status": {},
	                "ScalingAdjustment": {
	                  "type": "integer"
	                },
	                "ScalingAdjustmentType": {},
	                "ComparisonOperator": {},
	                "Threshold": {
	                  "type": "double"
	                },
	                "EvaluationPeriods": {
	                  "type": "integer"
	                },
	                "MetricName": {},
	                "PolicyType": {},
	                "TargetConfiguration": {
	                  "shape": "S8u"
	                },
	                "UpdateStatus": {},
	                "Location": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeScript": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ScriptId"
	        ],
	        "members": {
	          "ScriptId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Script": {
	            "shape": "S4v"
	          }
	        }
	      }
	    },
	    "DescribeVpcPeeringAuthorizations": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpcPeeringAuthorizations": {
	            "type": "list",
	            "member": {
	              "shape": "S4y"
	            }
	          }
	        }
	      }
	    },
	    "DescribeVpcPeeringConnections": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FleetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VpcPeeringConnections": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FleetId": {},
	                "FleetArn": {},
	                "IpV4CidrBlock": {},
	                "VpcPeeringConnectionId": {},
	                "Status": {
	                  "type": "structure",
	                  "members": {
	                    "Code": {},
	                    "Message": {}
	                  }
	                },
	                "PeerVpcId": {},
	                "GameLiftVpcId": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetGameSessionLogUrl": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameSessionId"
	        ],
	        "members": {
	          "GameSessionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PreSignedUrl": {}
	        }
	      }
	    },
	    "GetInstanceAccess": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId",
	          "InstanceId"
	        ],
	        "members": {
	          "FleetId": {},
	          "InstanceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceAccess": {
	            "type": "structure",
	            "members": {
	              "FleetId": {},
	              "InstanceId": {},
	              "IpAddress": {},
	              "OperatingSystem": {},
	              "Credentials": {
	                "type": "structure",
	                "members": {
	                  "UserName": {},
	                  "Secret": {}
	                },
	                "sensitive": true
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListAliases": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "RoutingStrategyType": {},
	          "Name": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Aliases": {
	            "type": "list",
	            "member": {
	              "shape": "Sv"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListBuilds": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Status": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Builds": {
	            "type": "list",
	            "member": {
	              "shape": "S13"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListFleets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "BuildId": {},
	          "ScriptId": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetIds": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListGameServerGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServerGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S2w"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListGameServers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "SortOrder": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServers": {
	            "type": "list",
	            "member": {
	              "shape": "Sc"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListScripts": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Scripts": {
	            "type": "list",
	            "member": {
	              "shape": "S4v"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN"
	        ],
	        "members": {
	          "ResourceARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "PutScalingPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "FleetId",
	          "MetricName"
	        ],
	        "members": {
	          "Name": {},
	          "FleetId": {},
	          "ScalingAdjustment": {
	            "type": "integer"
	          },
	          "ScalingAdjustmentType": {},
	          "Threshold": {
	            "type": "double"
	          },
	          "ComparisonOperator": {},
	          "EvaluationPeriods": {
	            "type": "integer"
	          },
	          "MetricName": {},
	          "PolicyType": {},
	          "TargetConfiguration": {
	            "shape": "S8u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {}
	        }
	      }
	    },
	    "RegisterGameServer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName",
	          "GameServerId",
	          "InstanceId"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "GameServerId": {},
	          "InstanceId": {},
	          "ConnectionInfo": {},
	          "GameServerData": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServer": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "RequestUploadCredentials": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BuildId"
	        ],
	        "members": {
	          "BuildId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UploadCredentials": {
	            "shape": "S18"
	          },
	          "StorageLocation": {
	            "shape": "Sz"
	          }
	        }
	      }
	    },
	    "ResolveAlias": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AliasId"
	        ],
	        "members": {
	          "AliasId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetId": {},
	          "FleetArn": {}
	        }
	      }
	    },
	    "ResumeGameServerGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName",
	          "ResumeActions"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "ResumeActions": {
	            "shape": "S2z"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServerGroup": {
	            "shape": "S2w"
	          }
	        }
	      }
	    },
	    "SearchGameSessions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FleetId": {},
	          "AliasId": {},
	          "Location": {},
	          "FilterExpression": {},
	          "SortExpression": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameSessions": {
	            "shape": "S7i"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "StartFleetActions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId",
	          "Actions"
	        ],
	        "members": {
	          "FleetId": {},
	          "Actions": {
	            "shape": "S27"
	          },
	          "Location": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetId": {},
	          "FleetArn": {}
	        }
	      }
	    },
	    "StartGameSessionPlacement": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlacementId",
	          "GameSessionQueueName",
	          "MaximumPlayerSessionCount"
	        ],
	        "members": {
	          "PlacementId": {},
	          "GameSessionQueueName": {},
	          "GameProperties": {
	            "shape": "S33"
	          },
	          "MaximumPlayerSessionCount": {
	            "type": "integer"
	          },
	          "GameSessionName": {},
	          "PlayerLatencies": {
	            "shape": "S77"
	          },
	          "DesiredPlayerSessions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PlayerId": {},
	                "PlayerData": {}
	              }
	            }
	          },
	          "GameSessionData": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameSessionPlacement": {
	            "shape": "S75"
	          }
	        }
	      }
	    },
	    "StartMatchBackfill": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationName",
	          "Players"
	        ],
	        "members": {
	          "TicketId": {},
	          "ConfigurationName": {},
	          "GameSessionArn": {},
	          "Players": {
	            "shape": "S7w"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MatchmakingTicket": {
	            "shape": "S7t"
	          }
	        }
	      }
	    },
	    "StartMatchmaking": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConfigurationName",
	          "Players"
	        ],
	        "members": {
	          "TicketId": {},
	          "ConfigurationName": {},
	          "Players": {
	            "shape": "S7w"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MatchmakingTicket": {
	            "shape": "S7t"
	          }
	        }
	      }
	    },
	    "StopFleetActions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId",
	          "Actions"
	        ],
	        "members": {
	          "FleetId": {},
	          "Actions": {
	            "shape": "S27"
	          },
	          "Location": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetId": {},
	          "FleetArn": {}
	        }
	      }
	    },
	    "StopGameSessionPlacement": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlacementId"
	        ],
	        "members": {
	          "PlacementId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameSessionPlacement": {
	            "shape": "S75"
	          }
	        }
	      }
	    },
	    "StopMatchmaking": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TicketId"
	        ],
	        "members": {
	          "TicketId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SuspendGameServerGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName",
	          "SuspendActions"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "SuspendActions": {
	            "shape": "S2z"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServerGroup": {
	            "shape": "S2w"
	          }
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "Tags"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "Tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateAlias": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AliasId"
	        ],
	        "members": {
	          "AliasId": {},
	          "Name": {},
	          "Description": {},
	          "RoutingStrategy": {
	            "shape": "Sm"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Alias": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "UpdateBuild": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BuildId"
	        ],
	        "members": {
	          "BuildId": {},
	          "Name": {},
	          "Version": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Build": {
	            "shape": "S13"
	          }
	        }
	      }
	    },
	    "UpdateFleetAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "FleetId": {},
	          "Name": {},
	          "Description": {},
	          "NewGameSessionProtectionPolicy": {},
	          "ResourceCreationLimitPolicy": {
	            "shape": "S1r"
	          },
	          "MetricGroups": {
	            "shape": "S1t"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetId": {}
	        }
	      }
	    },
	    "UpdateFleetCapacity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "FleetId": {},
	          "DesiredInstances": {
	            "type": "integer"
	          },
	          "MinSize": {
	            "type": "integer"
	          },
	          "MaxSize": {
	            "type": "integer"
	          },
	          "Location": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetId": {},
	          "FleetArn": {},
	          "Location": {}
	        }
	      }
	    },
	    "UpdateFleetPortSettings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId"
	        ],
	        "members": {
	          "FleetId": {},
	          "InboundPermissionAuthorizations": {
	            "shape": "S1f"
	          },
	          "InboundPermissionRevocations": {
	            "shape": "S1f"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FleetId": {}
	        }
	      }
	    },
	    "UpdateGameServer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName",
	          "GameServerId"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "GameServerId": {},
	          "GameServerData": {},
	          "UtilizationStatus": {},
	          "HealthCheck": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServer": {
	            "shape": "Sc"
	          }
	        }
	      }
	    },
	    "UpdateGameServerGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameServerGroupName"
	        ],
	        "members": {
	          "GameServerGroupName": {},
	          "RoleArn": {},
	          "InstanceDefinitions": {
	            "shape": "S2k"
	          },
	          "GameServerProtectionPolicy": {},
	          "BalancingStrategy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameServerGroup": {
	            "shape": "S2w"
	          }
	        }
	      }
	    },
	    "UpdateGameSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GameSessionId"
	        ],
	        "members": {
	          "GameSessionId": {},
	          "MaximumPlayerSessionCount": {
	            "type": "integer"
	          },
	          "Name": {},
	          "PlayerSessionCreationPolicy": {},
	          "ProtectionPolicy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameSession": {
	            "shape": "S3a"
	          }
	        }
	      }
	    },
	    "UpdateGameSessionQueue": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "TimeoutInSeconds": {
	            "type": "integer"
	          },
	          "PlayerLatencyPolicies": {
	            "shape": "S3j"
	          },
	          "Destinations": {
	            "shape": "S3l"
	          },
	          "FilterConfiguration": {
	            "shape": "S3o"
	          },
	          "PriorityConfiguration": {
	            "shape": "S3q"
	          },
	          "CustomEventData": {},
	          "NotificationTarget": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GameSessionQueue": {
	            "shape": "S3w"
	          }
	        }
	      }
	    },
	    "UpdateMatchmakingConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "GameSessionQueueArns": {
	            "shape": "S3z"
	          },
	          "RequestTimeoutSeconds": {
	            "type": "integer"
	          },
	          "AcceptanceTimeoutSeconds": {
	            "type": "integer"
	          },
	          "AcceptanceRequired": {
	            "type": "boolean"
	          },
	          "RuleSetName": {},
	          "NotificationTarget": {},
	          "AdditionalPlayerCount": {
	            "type": "integer"
	          },
	          "CustomEventData": {},
	          "GameProperties": {
	            "shape": "S33"
	          },
	          "GameSessionData": {},
	          "BackfillMode": {},
	          "FlexMatchMode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Configuration": {
	            "shape": "S4a"
	          }
	        }
	      }
	    },
	    "UpdateRuntimeConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FleetId",
	          "RuntimeConfiguration"
	        ],
	        "members": {
	          "FleetId": {},
	          "RuntimeConfiguration": {
	            "shape": "S1l"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RuntimeConfiguration": {
	            "shape": "S1l"
	          }
	        }
	      }
	    },
	    "UpdateScript": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ScriptId"
	        ],
	        "members": {
	          "ScriptId": {},
	          "Name": {},
	          "Version": {},
	          "StorageLocation": {
	            "shape": "Sz"
	          },
	          "ZipFile": {
	            "type": "blob"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Script": {
	            "shape": "S4v"
	          }
	        }
	      }
	    },
	    "ValidateMatchmakingRuleSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleSetBody"
	        ],
	        "members": {
	          "RuleSetBody": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Valid": {
	            "type": "boolean"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S3": {
	      "type": "list",
	      "member": {}
	    },
	    "Sc": {
	      "type": "structure",
	      "members": {
	        "GameServerGroupName": {},
	        "GameServerGroupArn": {},
	        "GameServerId": {},
	        "InstanceId": {},
	        "ConnectionInfo": {},
	        "GameServerData": {},
	        "ClaimStatus": {},
	        "UtilizationStatus": {},
	        "RegistrationTime": {
	          "type": "timestamp"
	        },
	        "LastClaimTime": {
	          "type": "timestamp"
	        },
	        "LastHealthCheckTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sm": {
	      "type": "structure",
	      "members": {
	        "Type": {},
	        "FleetId": {},
	        "Message": {}
	      }
	    },
	    "Sq": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sv": {
	      "type": "structure",
	      "members": {
	        "AliasId": {},
	        "Name": {},
	        "AliasArn": {},
	        "Description": {},
	        "RoutingStrategy": {
	          "shape": "Sm"
	        },
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "LastUpdatedTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sz": {
	      "type": "structure",
	      "members": {
	        "Bucket": {},
	        "Key": {},
	        "RoleArn": {},
	        "ObjectVersion": {}
	      }
	    },
	    "S13": {
	      "type": "structure",
	      "members": {
	        "BuildId": {},
	        "BuildArn": {},
	        "Name": {},
	        "Version": {},
	        "Status": {},
	        "SizeOnDisk": {
	          "type": "long"
	        },
	        "OperatingSystem": {},
	        "CreationTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S18": {
	      "type": "structure",
	      "members": {
	        "AccessKeyId": {},
	        "SecretAccessKey": {},
	        "SessionToken": {}
	      },
	      "sensitive": true
	    },
	    "S1f": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "FromPort",
	          "ToPort",
	          "IpRange",
	          "Protocol"
	        ],
	        "members": {
	          "FromPort": {
	            "type": "integer"
	          },
	          "ToPort": {
	            "type": "integer"
	          },
	          "IpRange": {},
	          "Protocol": {}
	        }
	      }
	    },
	    "S1l": {
	      "type": "structure",
	      "members": {
	        "ServerProcesses": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "LaunchPath",
	              "ConcurrentExecutions"
	            ],
	            "members": {
	              "LaunchPath": {},
	              "Parameters": {},
	              "ConcurrentExecutions": {
	                "type": "integer"
	              }
	            }
	          }
	        },
	        "MaxConcurrentGameSessionActivations": {
	          "type": "integer"
	        },
	        "GameSessionActivationTimeoutSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "S1r": {
	      "type": "structure",
	      "members": {
	        "NewGameSessionsPerCreator": {
	          "type": "integer"
	        },
	        "PolicyPeriodInMinutes": {
	          "type": "integer"
	        }
	      }
	    },
	    "S1t": {
	      "type": "list",
	      "member": {}
	    },
	    "S1w": {
	      "type": "structure",
	      "required": [
	        "CertificateType"
	      ],
	      "members": {
	        "CertificateType": {}
	      }
	    },
	    "S1y": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Location": {}
	        }
	      }
	    },
	    "S22": {
	      "type": "structure",
	      "members": {
	        "FleetId": {},
	        "FleetArn": {},
	        "FleetType": {},
	        "InstanceType": {},
	        "Description": {},
	        "Name": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "TerminationTime": {
	          "type": "timestamp"
	        },
	        "Status": {},
	        "BuildId": {},
	        "BuildArn": {},
	        "ScriptId": {},
	        "ScriptArn": {},
	        "ServerLaunchPath": {},
	        "ServerLaunchParameters": {},
	        "LogPaths": {
	          "shape": "S3"
	        },
	        "NewGameSessionProtectionPolicy": {},
	        "OperatingSystem": {},
	        "ResourceCreationLimitPolicy": {
	          "shape": "S1r"
	        },
	        "MetricGroups": {
	          "shape": "S1t"
	        },
	        "StoppedActions": {
	          "shape": "S27"
	        },
	        "InstanceRoleArn": {},
	        "CertificateConfiguration": {
	          "shape": "S1w"
	        }
	      }
	    },
	    "S27": {
	      "type": "list",
	      "member": {}
	    },
	    "S29": {
	      "type": "list",
	      "member": {
	        "shape": "S2a"
	      }
	    },
	    "S2a": {
	      "type": "structure",
	      "members": {
	        "Location": {},
	        "Status": {}
	      }
	    },
	    "S2k": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "InstanceType"
	        ],
	        "members": {
	          "InstanceType": {},
	          "WeightedCapacity": {}
	        }
	      }
	    },
	    "S2w": {
	      "type": "structure",
	      "members": {
	        "GameServerGroupName": {},
	        "GameServerGroupArn": {},
	        "RoleArn": {},
	        "InstanceDefinitions": {
	          "shape": "S2k"
	        },
	        "BalancingStrategy": {},
	        "GameServerProtectionPolicy": {},
	        "AutoScalingGroupArn": {},
	        "Status": {},
	        "StatusReason": {},
	        "SuspendedActions": {
	          "shape": "S2z"
	        },
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "LastUpdatedTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S2z": {
	      "type": "list",
	      "member": {}
	    },
	    "S33": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S3a": {
	      "type": "structure",
	      "members": {
	        "GameSessionId": {},
	        "Name": {},
	        "FleetId": {},
	        "FleetArn": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "TerminationTime": {
	          "type": "timestamp"
	        },
	        "CurrentPlayerSessionCount": {
	          "type": "integer"
	        },
	        "MaximumPlayerSessionCount": {
	          "type": "integer"
	        },
	        "Status": {},
	        "StatusReason": {},
	        "GameProperties": {
	          "shape": "S33"
	        },
	        "IpAddress": {},
	        "DnsName": {},
	        "Port": {
	          "type": "integer"
	        },
	        "PlayerSessionCreationPolicy": {},
	        "CreatorId": {},
	        "GameSessionData": {},
	        "MatchmakerData": {},
	        "Location": {}
	      }
	    },
	    "S3j": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "MaximumIndividualPlayerLatencyMilliseconds": {
	            "type": "integer"
	          },
	          "PolicyDurationSeconds": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S3l": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "DestinationArn": {}
	        }
	      }
	    },
	    "S3o": {
	      "type": "structure",
	      "members": {
	        "AllowedLocations": {
	          "shape": "S3p"
	        }
	      }
	    },
	    "S3p": {
	      "type": "list",
	      "member": {}
	    },
	    "S3q": {
	      "type": "structure",
	      "members": {
	        "PriorityOrder": {
	          "type": "list",
	          "member": {}
	        },
	        "LocationOrder": {
	          "shape": "S3p"
	        }
	      }
	    },
	    "S3w": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "GameSessionQueueArn": {},
	        "TimeoutInSeconds": {
	          "type": "integer"
	        },
	        "PlayerLatencyPolicies": {
	          "shape": "S3j"
	        },
	        "Destinations": {
	          "shape": "S3l"
	        },
	        "FilterConfiguration": {
	          "shape": "S3o"
	        },
	        "PriorityConfiguration": {
	          "shape": "S3q"
	        },
	        "CustomEventData": {},
	        "NotificationTarget": {}
	      }
	    },
	    "S3z": {
	      "type": "list",
	      "member": {}
	    },
	    "S4a": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "ConfigurationArn": {},
	        "Description": {},
	        "GameSessionQueueArns": {
	          "shape": "S3z"
	        },
	        "RequestTimeoutSeconds": {
	          "type": "integer"
	        },
	        "AcceptanceTimeoutSeconds": {
	          "type": "integer"
	        },
	        "AcceptanceRequired": {
	          "type": "boolean"
	        },
	        "RuleSetName": {},
	        "RuleSetArn": {},
	        "NotificationTarget": {},
	        "AdditionalPlayerCount": {
	          "type": "integer"
	        },
	        "CustomEventData": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "GameProperties": {
	          "shape": "S33"
	        },
	        "GameSessionData": {},
	        "BackfillMode": {},
	        "FlexMatchMode": {}
	      }
	    },
	    "S4g": {
	      "type": "structure",
	      "required": [
	        "RuleSetBody"
	      ],
	      "members": {
	        "RuleSetName": {},
	        "RuleSetArn": {},
	        "RuleSetBody": {},
	        "CreationTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S4k": {
	      "type": "structure",
	      "members": {
	        "PlayerSessionId": {},
	        "PlayerId": {},
	        "GameSessionId": {},
	        "FleetId": {},
	        "FleetArn": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "TerminationTime": {
	          "type": "timestamp"
	        },
	        "Status": {},
	        "IpAddress": {},
	        "DnsName": {},
	        "Port": {
	          "type": "integer"
	        },
	        "PlayerData": {}
	      }
	    },
	    "S4r": {
	      "type": "list",
	      "member": {
	        "shape": "S4k"
	      }
	    },
	    "S4v": {
	      "type": "structure",
	      "members": {
	        "ScriptId": {},
	        "ScriptArn": {},
	        "Name": {},
	        "Version": {},
	        "SizeOnDisk": {
	          "type": "long"
	        },
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "StorageLocation": {
	          "shape": "Sz"
	        }
	      }
	    },
	    "S4y": {
	      "type": "structure",
	      "members": {
	        "GameLiftAwsAccountId": {},
	        "PeerVpcAwsAccountId": {},
	        "PeerVpcId": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "ExpirationTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S5x": {
	      "type": "list",
	      "member": {}
	    },
	    "S63": {
	      "type": "structure",
	      "members": {
	        "FleetId": {},
	        "FleetArn": {},
	        "InstanceType": {},
	        "InstanceCounts": {
	          "type": "structure",
	          "members": {
	            "DESIRED": {
	              "type": "integer"
	            },
	            "MINIMUM": {
	              "type": "integer"
	            },
	            "MAXIMUM": {
	              "type": "integer"
	            },
	            "PENDING": {
	              "type": "integer"
	            },
	            "ACTIVE": {
	              "type": "integer"
	            },
	            "IDLE": {
	              "type": "integer"
	            },
	            "TERMINATING": {
	              "type": "integer"
	            }
	          }
	        },
	        "Location": {}
	      }
	    },
	    "S6j": {
	      "type": "structure",
	      "members": {
	        "FleetId": {},
	        "FleetArn": {},
	        "ActiveServerProcessCount": {
	          "type": "integer"
	        },
	        "ActiveGameSessionCount": {
	          "type": "integer"
	        },
	        "CurrentPlayerSessionCount": {
	          "type": "integer"
	        },
	        "MaximumPlayerSessionCount": {
	          "type": "integer"
	        },
	        "Location": {}
	      }
	    },
	    "S75": {
	      "type": "structure",
	      "members": {
	        "PlacementId": {},
	        "GameSessionQueueName": {},
	        "Status": {},
	        "GameProperties": {
	          "shape": "S33"
	        },
	        "MaximumPlayerSessionCount": {
	          "type": "integer"
	        },
	        "GameSessionName": {},
	        "GameSessionId": {},
	        "GameSessionArn": {},
	        "GameSessionRegion": {},
	        "PlayerLatencies": {
	          "shape": "S77"
	        },
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "IpAddress": {},
	        "DnsName": {},
	        "Port": {
	          "type": "integer"
	        },
	        "PlacedPlayerSessions": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "PlayerId": {},
	              "PlayerSessionId": {}
	            }
	          }
	        },
	        "GameSessionData": {},
	        "MatchmakerData": {}
	      }
	    },
	    "S77": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "PlayerId": {},
	          "RegionIdentifier": {},
	          "LatencyInMilliseconds": {
	            "type": "float"
	          }
	        }
	      }
	    },
	    "S7i": {
	      "type": "list",
	      "member": {
	        "shape": "S3a"
	      }
	    },
	    "S7t": {
	      "type": "structure",
	      "members": {
	        "TicketId": {},
	        "ConfigurationName": {},
	        "ConfigurationArn": {},
	        "Status": {},
	        "StatusReason": {},
	        "StatusMessage": {},
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "Players": {
	          "shape": "S7w"
	        },
	        "GameSessionConnectionInfo": {
	          "type": "structure",
	          "members": {
	            "GameSessionArn": {},
	            "IpAddress": {},
	            "DnsName": {},
	            "Port": {
	              "type": "integer"
	            },
	            "MatchedPlayerSessions": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "PlayerId": {},
	                  "PlayerSessionId": {}
	                }
	              }
	            }
	          }
	        },
	        "EstimatedWaitTime": {
	          "type": "integer"
	        }
	      }
	    },
	    "S7w": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "PlayerId": {},
	          "PlayerAttributes": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "members": {
	                "S": {},
	                "N": {
	                  "type": "double"
	                },
	                "SL": {
	                  "shape": "S3"
	                },
	                "SDM": {
	                  "type": "map",
	                  "key": {},
	                  "value": {
	                    "type": "double"
	                  }
	                }
	              }
	            }
	          },
	          "Team": {},
	          "LatencyInMs": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "integer"
	            }
	          }
	        }
	      }
	    },
	    "S8u": {
	      "type": "structure",
	      "required": [
	        "TargetValue"
	      ],
	      "members": {
	        "TargetValue": {
	          "type": "double"
	        }
	      }
	    }
	  }
	}
	},{}],120:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeFleetAttributes": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "FleetAttributes"
	    },
	    "DescribeFleetCapacity": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "FleetCapacity"
	    },
	    "DescribeFleetEvents": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "Events"
	    },
	    "DescribeFleetLocationAttributes": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit"
	    },
	    "DescribeFleetUtilization": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "FleetUtilization"
	    },
	    "DescribeGameServerInstances": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "GameServerInstances"
	    },
	    "DescribeGameSessionDetails": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "GameSessionDetails"
	    },
	    "DescribeGameSessionQueues": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "GameSessionQueues"
	    },
	    "DescribeGameSessions": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "GameSessions"
	    },
	    "DescribeInstances": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "Instances"
	    },
	    "DescribeMatchmakingConfigurations": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "Configurations"
	    },
	    "DescribeMatchmakingRuleSets": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "RuleSets"
	    },
	    "DescribePlayerSessions": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "PlayerSessions"
	    },
	    "DescribeScalingPolicies": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "ScalingPolicies"
	    },
	    "ListAliases": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "Aliases"
	    },
	    "ListBuilds": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "Builds"
	    },
	    "ListFleets": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "FleetIds"
	    },
	    "ListGameServerGroups": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "GameServerGroups"
	    },
	    "ListGameServers": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "GameServers"
	    },
	    "ListScripts": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "Scripts"
	    },
	    "SearchGameSessions": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "Limit",
	      "result_key": "GameSessions"
	    }
	  }
	}
	
	},{}],121:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2010-05-08",
	    "endpointPrefix": "iam",
	    "globalEndpoint": "iam.amazonaws.com",
	    "protocol": "query",
	    "serviceAbbreviation": "IAM",
	    "serviceFullName": "AWS Identity and Access Management",
	    "serviceId": "IAM",
	    "signatureVersion": "v4",
	    "uid": "iam-2010-05-08",
	    "xmlNamespace": "https://iam.amazonaws.com/doc/2010-05-08/"
	  },
	  "operations": {
	    "AddClientIDToOpenIDConnectProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpenIDConnectProviderArn",
	          "ClientID"
	        ],
	        "members": {
	          "OpenIDConnectProviderArn": {},
	          "ClientID": {}
	        }
	      }
	    },
	    "AddRoleToInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceProfileName",
	          "RoleName"
	        ],
	        "members": {
	          "InstanceProfileName": {},
	          "RoleName": {}
	        }
	      }
	    },
	    "AddUserToGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "UserName"
	        ],
	        "members": {
	          "GroupName": {},
	          "UserName": {}
	        }
	      }
	    },
	    "AttachGroupPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "PolicyArn"
	        ],
	        "members": {
	          "GroupName": {},
	          "PolicyArn": {}
	        }
	      }
	    },
	    "AttachRolePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "PolicyArn"
	        ],
	        "members": {
	          "RoleName": {},
	          "PolicyArn": {}
	        }
	      }
	    },
	    "AttachUserPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "PolicyArn"
	        ],
	        "members": {
	          "UserName": {},
	          "PolicyArn": {}
	        }
	      }
	    },
	    "ChangePassword": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OldPassword",
	          "NewPassword"
	        ],
	        "members": {
	          "OldPassword": {
	            "shape": "Sf"
	          },
	          "NewPassword": {
	            "shape": "Sf"
	          }
	        }
	      }
	    },
	    "CreateAccessKey": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "UserName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateAccessKeyResult",
	        "type": "structure",
	        "required": [
	          "AccessKey"
	        ],
	        "members": {
	          "AccessKey": {
	            "type": "structure",
	            "required": [
	              "UserName",
	              "AccessKeyId",
	              "Status",
	              "SecretAccessKey"
	            ],
	            "members": {
	              "UserName": {},
	              "AccessKeyId": {},
	              "Status": {},
	              "SecretAccessKey": {
	                "type": "string",
	                "sensitive": true
	              },
	              "CreateDate": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "CreateAccountAlias": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccountAlias"
	        ],
	        "members": {
	          "AccountAlias": {}
	        }
	      }
	    },
	    "CreateGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName"
	        ],
	        "members": {
	          "Path": {},
	          "GroupName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateGroupResult",
	        "type": "structure",
	        "required": [
	          "Group"
	        ],
	        "members": {
	          "Group": {
	            "shape": "Ss"
	          }
	        }
	      }
	    },
	    "CreateInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceProfileName"
	        ],
	        "members": {
	          "InstanceProfileName": {},
	          "Path": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateInstanceProfileResult",
	        "type": "structure",
	        "required": [
	          "InstanceProfile"
	        ],
	        "members": {
	          "InstanceProfile": {
	            "shape": "S10"
	          }
	        }
	      }
	    },
	    "CreateLoginProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "Password"
	        ],
	        "members": {
	          "UserName": {},
	          "Password": {
	            "shape": "Sf"
	          },
	          "PasswordResetRequired": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateLoginProfileResult",
	        "type": "structure",
	        "required": [
	          "LoginProfile"
	        ],
	        "members": {
	          "LoginProfile": {
	            "shape": "S1d"
	          }
	        }
	      }
	    },
	    "CreateOpenIDConnectProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Url",
	          "ThumbprintList"
	        ],
	        "members": {
	          "Url": {},
	          "ClientIDList": {
	            "shape": "S1g"
	          },
	          "ThumbprintList": {
	            "shape": "S1h"
	          },
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateOpenIDConnectProviderResult",
	        "type": "structure",
	        "members": {
	          "OpenIDConnectProviderArn": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "CreatePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyName",
	          "PolicyDocument"
	        ],
	        "members": {
	          "PolicyName": {},
	          "Path": {},
	          "PolicyDocument": {},
	          "Description": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreatePolicyResult",
	        "type": "structure",
	        "members": {
	          "Policy": {
	            "shape": "S1p"
	          }
	        }
	      }
	    },
	    "CreatePolicyVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyArn",
	          "PolicyDocument"
	        ],
	        "members": {
	          "PolicyArn": {},
	          "PolicyDocument": {},
	          "SetAsDefault": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreatePolicyVersionResult",
	        "type": "structure",
	        "members": {
	          "PolicyVersion": {
	            "shape": "S1u"
	          }
	        }
	      }
	    },
	    "CreateRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "AssumeRolePolicyDocument"
	        ],
	        "members": {
	          "Path": {},
	          "RoleName": {},
	          "AssumeRolePolicyDocument": {},
	          "Description": {},
	          "MaxSessionDuration": {
	            "type": "integer"
	          },
	          "PermissionsBoundary": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateRoleResult",
	        "type": "structure",
	        "required": [
	          "Role"
	        ],
	        "members": {
	          "Role": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "CreateSAMLProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SAMLMetadataDocument",
	          "Name"
	        ],
	        "members": {
	          "SAMLMetadataDocument": {},
	          "Name": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateSAMLProviderResult",
	        "type": "structure",
	        "members": {
	          "SAMLProviderArn": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "CreateServiceLinkedRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AWSServiceName"
	        ],
	        "members": {
	          "AWSServiceName": {},
	          "Description": {},
	          "CustomSuffix": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateServiceLinkedRoleResult",
	        "type": "structure",
	        "members": {
	          "Role": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "CreateServiceSpecificCredential": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "ServiceName"
	        ],
	        "members": {
	          "UserName": {},
	          "ServiceName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateServiceSpecificCredentialResult",
	        "type": "structure",
	        "members": {
	          "ServiceSpecificCredential": {
	            "shape": "S27"
	          }
	        }
	      }
	    },
	    "CreateUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName"
	        ],
	        "members": {
	          "Path": {},
	          "UserName": {},
	          "PermissionsBoundary": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateUserResult",
	        "type": "structure",
	        "members": {
	          "User": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "CreateVirtualMFADevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VirtualMFADeviceName"
	        ],
	        "members": {
	          "Path": {},
	          "VirtualMFADeviceName": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateVirtualMFADeviceResult",
	        "type": "structure",
	        "required": [
	          "VirtualMFADevice"
	        ],
	        "members": {
	          "VirtualMFADevice": {
	            "shape": "S2h"
	          }
	        }
	      }
	    },
	    "DeactivateMFADevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "SerialNumber"
	        ],
	        "members": {
	          "UserName": {},
	          "SerialNumber": {}
	        }
	      }
	    },
	    "DeleteAccessKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessKeyId"
	        ],
	        "members": {
	          "UserName": {},
	          "AccessKeyId": {}
	        }
	      }
	    },
	    "DeleteAccountAlias": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccountAlias"
	        ],
	        "members": {
	          "AccountAlias": {}
	        }
	      }
	    },
	    "DeleteAccountPasswordPolicy": {},
	    "DeleteGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName"
	        ],
	        "members": {
	          "GroupName": {}
	        }
	      }
	    },
	    "DeleteGroupPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "PolicyName"
	        ],
	        "members": {
	          "GroupName": {},
	          "PolicyName": {}
	        }
	      }
	    },
	    "DeleteInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceProfileName"
	        ],
	        "members": {
	          "InstanceProfileName": {}
	        }
	      }
	    },
	    "DeleteLoginProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName"
	        ],
	        "members": {
	          "UserName": {}
	        }
	      }
	    },
	    "DeleteOpenIDConnectProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpenIDConnectProviderArn"
	        ],
	        "members": {
	          "OpenIDConnectProviderArn": {}
	        }
	      }
	    },
	    "DeletePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyArn"
	        ],
	        "members": {
	          "PolicyArn": {}
	        }
	      }
	    },
	    "DeletePolicyVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyArn",
	          "VersionId"
	        ],
	        "members": {
	          "PolicyArn": {},
	          "VersionId": {}
	        }
	      }
	    },
	    "DeleteRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName"
	        ],
	        "members": {
	          "RoleName": {}
	        }
	      }
	    },
	    "DeleteRolePermissionsBoundary": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName"
	        ],
	        "members": {
	          "RoleName": {}
	        }
	      }
	    },
	    "DeleteRolePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "PolicyName"
	        ],
	        "members": {
	          "RoleName": {},
	          "PolicyName": {}
	        }
	      }
	    },
	    "DeleteSAMLProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SAMLProviderArn"
	        ],
	        "members": {
	          "SAMLProviderArn": {}
	        }
	      }
	    },
	    "DeleteSSHPublicKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "SSHPublicKeyId"
	        ],
	        "members": {
	          "UserName": {},
	          "SSHPublicKeyId": {}
	        }
	      }
	    },
	    "DeleteServerCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServerCertificateName"
	        ],
	        "members": {
	          "ServerCertificateName": {}
	        }
	      }
	    },
	    "DeleteServiceLinkedRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName"
	        ],
	        "members": {
	          "RoleName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteServiceLinkedRoleResult",
	        "type": "structure",
	        "required": [
	          "DeletionTaskId"
	        ],
	        "members": {
	          "DeletionTaskId": {}
	        }
	      }
	    },
	    "DeleteServiceSpecificCredential": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceSpecificCredentialId"
	        ],
	        "members": {
	          "UserName": {},
	          "ServiceSpecificCredentialId": {}
	        }
	      }
	    },
	    "DeleteSigningCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateId"
	        ],
	        "members": {
	          "UserName": {},
	          "CertificateId": {}
	        }
	      }
	    },
	    "DeleteUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName"
	        ],
	        "members": {
	          "UserName": {}
	        }
	      }
	    },
	    "DeleteUserPermissionsBoundary": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName"
	        ],
	        "members": {
	          "UserName": {}
	        }
	      }
	    },
	    "DeleteUserPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "PolicyName"
	        ],
	        "members": {
	          "UserName": {},
	          "PolicyName": {}
	        }
	      }
	    },
	    "DeleteVirtualMFADevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SerialNumber"
	        ],
	        "members": {
	          "SerialNumber": {}
	        }
	      }
	    },
	    "DetachGroupPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "PolicyArn"
	        ],
	        "members": {
	          "GroupName": {},
	          "PolicyArn": {}
	        }
	      }
	    },
	    "DetachRolePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "PolicyArn"
	        ],
	        "members": {
	          "RoleName": {},
	          "PolicyArn": {}
	        }
	      }
	    },
	    "DetachUserPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "PolicyArn"
	        ],
	        "members": {
	          "UserName": {},
	          "PolicyArn": {}
	        }
	      }
	    },
	    "EnableMFADevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "SerialNumber",
	          "AuthenticationCode1",
	          "AuthenticationCode2"
	        ],
	        "members": {
	          "UserName": {},
	          "SerialNumber": {},
	          "AuthenticationCode1": {},
	          "AuthenticationCode2": {}
	        }
	      }
	    },
	    "GenerateCredentialReport": {
	      "output": {
	        "resultWrapper": "GenerateCredentialReportResult",
	        "type": "structure",
	        "members": {
	          "State": {},
	          "Description": {}
	        }
	      }
	    },
	    "GenerateOrganizationsAccessReport": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EntityPath"
	        ],
	        "members": {
	          "EntityPath": {},
	          "OrganizationsPolicyId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GenerateOrganizationsAccessReportResult",
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    },
	    "GenerateServiceLastAccessedDetails": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Arn"
	        ],
	        "members": {
	          "Arn": {},
	          "Granularity": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GenerateServiceLastAccessedDetailsResult",
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      }
	    },
	    "GetAccessKeyLastUsed": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessKeyId"
	        ],
	        "members": {
	          "AccessKeyId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetAccessKeyLastUsedResult",
	        "type": "structure",
	        "members": {
	          "UserName": {},
	          "AccessKeyLastUsed": {
	            "type": "structure",
	            "required": [
	              "LastUsedDate",
	              "ServiceName",
	              "Region"
	            ],
	            "members": {
	              "LastUsedDate": {
	                "type": "timestamp"
	              },
	              "ServiceName": {},
	              "Region": {}
	            }
	          }
	        }
	      }
	    },
	    "GetAccountAuthorizationDetails": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "list",
	            "member": {}
	          },
	          "MaxItems": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetAccountAuthorizationDetailsResult",
	        "type": "structure",
	        "members": {
	          "UserDetailList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Path": {},
	                "UserName": {},
	                "UserId": {},
	                "Arn": {},
	                "CreateDate": {
	                  "type": "timestamp"
	                },
	                "UserPolicyList": {
	                  "shape": "S43"
	                },
	                "GroupList": {
	                  "type": "list",
	                  "member": {}
	                },
	                "AttachedManagedPolicies": {
	                  "shape": "S46"
	                },
	                "PermissionsBoundary": {
	                  "shape": "S16"
	                },
	                "Tags": {
	                  "shape": "Sv"
	                }
	              }
	            }
	          },
	          "GroupDetailList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Path": {},
	                "GroupName": {},
	                "GroupId": {},
	                "Arn": {},
	                "CreateDate": {
	                  "type": "timestamp"
	                },
	                "GroupPolicyList": {
	                  "shape": "S43"
	                },
	                "AttachedManagedPolicies": {
	                  "shape": "S46"
	                }
	              }
	            }
	          },
	          "RoleDetailList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Path": {},
	                "RoleName": {},
	                "RoleId": {},
	                "Arn": {},
	                "CreateDate": {
	                  "type": "timestamp"
	                },
	                "AssumeRolePolicyDocument": {},
	                "InstanceProfileList": {
	                  "shape": "S4c"
	                },
	                "RolePolicyList": {
	                  "shape": "S43"
	                },
	                "AttachedManagedPolicies": {
	                  "shape": "S46"
	                },
	                "PermissionsBoundary": {
	                  "shape": "S16"
	                },
	                "Tags": {
	                  "shape": "Sv"
	                },
	                "RoleLastUsed": {
	                  "shape": "S18"
	                }
	              }
	            }
	          },
	          "Policies": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PolicyName": {},
	                "PolicyId": {},
	                "Arn": {},
	                "Path": {},
	                "DefaultVersionId": {},
	                "AttachmentCount": {
	                  "type": "integer"
	                },
	                "PermissionsBoundaryUsageCount": {
	                  "type": "integer"
	                },
	                "IsAttachable": {
	                  "type": "boolean"
	                },
	                "Description": {},
	                "CreateDate": {
	                  "type": "timestamp"
	                },
	                "UpdateDate": {
	                  "type": "timestamp"
	                },
	                "PolicyVersionList": {
	                  "shape": "S4f"
	                }
	              }
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "GetAccountPasswordPolicy": {
	      "output": {
	        "resultWrapper": "GetAccountPasswordPolicyResult",
	        "type": "structure",
	        "required": [
	          "PasswordPolicy"
	        ],
	        "members": {
	          "PasswordPolicy": {
	            "type": "structure",
	            "members": {
	              "MinimumPasswordLength": {
	                "type": "integer"
	              },
	              "RequireSymbols": {
	                "type": "boolean"
	              },
	              "RequireNumbers": {
	                "type": "boolean"
	              },
	              "RequireUppercaseCharacters": {
	                "type": "boolean"
	              },
	              "RequireLowercaseCharacters": {
	                "type": "boolean"
	              },
	              "AllowUsersToChangePassword": {
	                "type": "boolean"
	              },
	              "ExpirePasswords": {
	                "type": "boolean"
	              },
	              "MaxPasswordAge": {
	                "type": "integer"
	              },
	              "PasswordReusePrevention": {
	                "type": "integer"
	              },
	              "HardExpiry": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetAccountSummary": {
	      "output": {
	        "resultWrapper": "GetAccountSummaryResult",
	        "type": "structure",
	        "members": {
	          "SummaryMap": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "integer"
	            }
	          }
	        }
	      }
	    },
	    "GetContextKeysForCustomPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyInputList"
	        ],
	        "members": {
	          "PolicyInputList": {
	            "shape": "S4s"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4t",
	        "resultWrapper": "GetContextKeysForCustomPolicyResult"
	      }
	    },
	    "GetContextKeysForPrincipalPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicySourceArn"
	        ],
	        "members": {
	          "PolicySourceArn": {},
	          "PolicyInputList": {
	            "shape": "S4s"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4t",
	        "resultWrapper": "GetContextKeysForPrincipalPolicyResult"
	      }
	    },
	    "GetCredentialReport": {
	      "output": {
	        "resultWrapper": "GetCredentialReportResult",
	        "type": "structure",
	        "members": {
	          "Content": {
	            "type": "blob"
	          },
	          "ReportFormat": {},
	          "GeneratedTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName"
	        ],
	        "members": {
	          "GroupName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetGroupResult",
	        "type": "structure",
	        "required": [
	          "Group",
	          "Users"
	        ],
	        "members": {
	          "Group": {
	            "shape": "Ss"
	          },
	          "Users": {
	            "shape": "S52"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "GetGroupPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "PolicyName"
	        ],
	        "members": {
	          "GroupName": {},
	          "PolicyName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetGroupPolicyResult",
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "PolicyName",
	          "PolicyDocument"
	        ],
	        "members": {
	          "GroupName": {},
	          "PolicyName": {},
	          "PolicyDocument": {}
	        }
	      }
	    },
	    "GetInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceProfileName"
	        ],
	        "members": {
	          "InstanceProfileName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetInstanceProfileResult",
	        "type": "structure",
	        "required": [
	          "InstanceProfile"
	        ],
	        "members": {
	          "InstanceProfile": {
	            "shape": "S10"
	          }
	        }
	      }
	    },
	    "GetLoginProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName"
	        ],
	        "members": {
	          "UserName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetLoginProfileResult",
	        "type": "structure",
	        "required": [
	          "LoginProfile"
	        ],
	        "members": {
	          "LoginProfile": {
	            "shape": "S1d"
	          }
	        }
	      }
	    },
	    "GetOpenIDConnectProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpenIDConnectProviderArn"
	        ],
	        "members": {
	          "OpenIDConnectProviderArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetOpenIDConnectProviderResult",
	        "type": "structure",
	        "members": {
	          "Url": {},
	          "ClientIDList": {
	            "shape": "S1g"
	          },
	          "ThumbprintList": {
	            "shape": "S1h"
	          },
	          "CreateDate": {
	            "type": "timestamp"
	          },
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "GetOrganizationsAccessReport": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {},
	          "MaxItems": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "SortKey": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetOrganizationsAccessReportResult",
	        "type": "structure",
	        "required": [
	          "JobStatus",
	          "JobCreationDate"
	        ],
	        "members": {
	          "JobStatus": {},
	          "JobCreationDate": {
	            "type": "timestamp"
	          },
	          "JobCompletionDate": {
	            "type": "timestamp"
	          },
	          "NumberOfServicesAccessible": {
	            "type": "integer"
	          },
	          "NumberOfServicesNotAccessed": {
	            "type": "integer"
	          },
	          "AccessDetails": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ServiceName",
	                "ServiceNamespace"
	              ],
	              "members": {
	                "ServiceName": {},
	                "ServiceNamespace": {},
	                "Region": {},
	                "EntityPath": {},
	                "LastAuthenticatedTime": {
	                  "type": "timestamp"
	                },
	                "TotalAuthenticatedEntities": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {},
	          "ErrorDetails": {
	            "shape": "S5k"
	          }
	        }
	      }
	    },
	    "GetPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyArn"
	        ],
	        "members": {
	          "PolicyArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetPolicyResult",
	        "type": "structure",
	        "members": {
	          "Policy": {
	            "shape": "S1p"
	          }
	        }
	      }
	    },
	    "GetPolicyVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyArn",
	          "VersionId"
	        ],
	        "members": {
	          "PolicyArn": {},
	          "VersionId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetPolicyVersionResult",
	        "type": "structure",
	        "members": {
	          "PolicyVersion": {
	            "shape": "S1u"
	          }
	        }
	      }
	    },
	    "GetRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName"
	        ],
	        "members": {
	          "RoleName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetRoleResult",
	        "type": "structure",
	        "required": [
	          "Role"
	        ],
	        "members": {
	          "Role": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "GetRolePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "PolicyName"
	        ],
	        "members": {
	          "RoleName": {},
	          "PolicyName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetRolePolicyResult",
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "PolicyName",
	          "PolicyDocument"
	        ],
	        "members": {
	          "RoleName": {},
	          "PolicyName": {},
	          "PolicyDocument": {}
	        }
	      }
	    },
	    "GetSAMLProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SAMLProviderArn"
	        ],
	        "members": {
	          "SAMLProviderArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetSAMLProviderResult",
	        "type": "structure",
	        "members": {
	          "SAMLMetadataDocument": {},
	          "CreateDate": {
	            "type": "timestamp"
	          },
	          "ValidUntil": {
	            "type": "timestamp"
	          },
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "GetSSHPublicKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "SSHPublicKeyId",
	          "Encoding"
	        ],
	        "members": {
	          "UserName": {},
	          "SSHPublicKeyId": {},
	          "Encoding": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetSSHPublicKeyResult",
	        "type": "structure",
	        "members": {
	          "SSHPublicKey": {
	            "shape": "S5y"
	          }
	        }
	      }
	    },
	    "GetServerCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServerCertificateName"
	        ],
	        "members": {
	          "ServerCertificateName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetServerCertificateResult",
	        "type": "structure",
	        "required": [
	          "ServerCertificate"
	        ],
	        "members": {
	          "ServerCertificate": {
	            "type": "structure",
	            "required": [
	              "ServerCertificateMetadata",
	              "CertificateBody"
	            ],
	            "members": {
	              "ServerCertificateMetadata": {
	                "shape": "S64"
	              },
	              "CertificateBody": {},
	              "CertificateChain": {},
	              "Tags": {
	                "shape": "Sv"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetServiceLastAccessedDetails": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {},
	          "MaxItems": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetServiceLastAccessedDetailsResult",
	        "type": "structure",
	        "required": [
	          "JobStatus",
	          "JobCreationDate",
	          "ServicesLastAccessed",
	          "JobCompletionDate"
	        ],
	        "members": {
	          "JobStatus": {},
	          "JobType": {},
	          "JobCreationDate": {
	            "type": "timestamp"
	          },
	          "ServicesLastAccessed": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ServiceName",
	                "ServiceNamespace"
	              ],
	              "members": {
	                "ServiceName": {},
	                "LastAuthenticated": {
	                  "type": "timestamp"
	                },
	                "ServiceNamespace": {},
	                "LastAuthenticatedEntity": {},
	                "LastAuthenticatedRegion": {},
	                "TotalAuthenticatedEntities": {
	                  "type": "integer"
	                },
	                "TrackedActionsLastAccessed": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "ActionName": {},
	                      "LastAccessedEntity": {},
	                      "LastAccessedTime": {
	                        "type": "timestamp"
	                      },
	                      "LastAccessedRegion": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "JobCompletionDate": {
	            "type": "timestamp"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {},
	          "Error": {
	            "shape": "S5k"
	          }
	        }
	      }
	    },
	    "GetServiceLastAccessedDetailsWithEntities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId",
	          "ServiceNamespace"
	        ],
	        "members": {
	          "JobId": {},
	          "ServiceNamespace": {},
	          "MaxItems": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetServiceLastAccessedDetailsWithEntitiesResult",
	        "type": "structure",
	        "required": [
	          "JobStatus",
	          "JobCreationDate",
	          "JobCompletionDate",
	          "EntityDetailsList"
	        ],
	        "members": {
	          "JobStatus": {},
	          "JobCreationDate": {
	            "type": "timestamp"
	          },
	          "JobCompletionDate": {
	            "type": "timestamp"
	          },
	          "EntityDetailsList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "EntityInfo"
	              ],
	              "members": {
	                "EntityInfo": {
	                  "type": "structure",
	                  "required": [
	                    "Arn",
	                    "Name",
	                    "Type",
	                    "Id"
	                  ],
	                  "members": {
	                    "Arn": {},
	                    "Name": {},
	                    "Type": {},
	                    "Id": {},
	                    "Path": {}
	                  }
	                },
	                "LastAuthenticated": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {},
	          "Error": {
	            "shape": "S5k"
	          }
	        }
	      }
	    },
	    "GetServiceLinkedRoleDeletionStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeletionTaskId"
	        ],
	        "members": {
	          "DeletionTaskId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetServiceLinkedRoleDeletionStatusResult",
	        "type": "structure",
	        "required": [
	          "Status"
	        ],
	        "members": {
	          "Status": {},
	          "Reason": {
	            "type": "structure",
	            "members": {
	              "Reason": {},
	              "RoleUsageList": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Region": {},
	                    "Resources": {
	                      "type": "list",
	                      "member": {}
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetUser": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "UserName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetUserResult",
	        "type": "structure",
	        "required": [
	          "User"
	        ],
	        "members": {
	          "User": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "GetUserPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "PolicyName"
	        ],
	        "members": {
	          "UserName": {},
	          "PolicyName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetUserPolicyResult",
	        "type": "structure",
	        "required": [
	          "UserName",
	          "PolicyName",
	          "PolicyDocument"
	        ],
	        "members": {
	          "UserName": {},
	          "PolicyName": {},
	          "PolicyDocument": {}
	        }
	      }
	    },
	    "ListAccessKeys": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "UserName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListAccessKeysResult",
	        "type": "structure",
	        "required": [
	          "AccessKeyMetadata"
	        ],
	        "members": {
	          "AccessKeyMetadata": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "UserName": {},
	                "AccessKeyId": {},
	                "Status": {},
	                "CreateDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListAccountAliases": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListAccountAliasesResult",
	        "type": "structure",
	        "required": [
	          "AccountAliases"
	        ],
	        "members": {
	          "AccountAliases": {
	            "type": "list",
	            "member": {}
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListAttachedGroupPolicies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName"
	        ],
	        "members": {
	          "GroupName": {},
	          "PathPrefix": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListAttachedGroupPoliciesResult",
	        "type": "structure",
	        "members": {
	          "AttachedPolicies": {
	            "shape": "S46"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListAttachedRolePolicies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName"
	        ],
	        "members": {
	          "RoleName": {},
	          "PathPrefix": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListAttachedRolePoliciesResult",
	        "type": "structure",
	        "members": {
	          "AttachedPolicies": {
	            "shape": "S46"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListAttachedUserPolicies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName"
	        ],
	        "members": {
	          "UserName": {},
	          "PathPrefix": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListAttachedUserPoliciesResult",
	        "type": "structure",
	        "members": {
	          "AttachedPolicies": {
	            "shape": "S46"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListEntitiesForPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyArn"
	        ],
	        "members": {
	          "PolicyArn": {},
	          "EntityFilter": {},
	          "PathPrefix": {},
	          "PolicyUsageFilter": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListEntitiesForPolicyResult",
	        "type": "structure",
	        "members": {
	          "PolicyGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "GroupName": {},
	                "GroupId": {}
	              }
	            }
	          },
	          "PolicyUsers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "UserName": {},
	                "UserId": {}
	              }
	            }
	          },
	          "PolicyRoles": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "RoleName": {},
	                "RoleId": {}
	              }
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListGroupPolicies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName"
	        ],
	        "members": {
	          "GroupName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListGroupPoliciesResult",
	        "type": "structure",
	        "required": [
	          "PolicyNames"
	        ],
	        "members": {
	          "PolicyNames": {
	            "shape": "S7k"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PathPrefix": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListGroupsResult",
	        "type": "structure",
	        "required": [
	          "Groups"
	        ],
	        "members": {
	          "Groups": {
	            "shape": "S7o"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListGroupsForUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName"
	        ],
	        "members": {
	          "UserName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListGroupsForUserResult",
	        "type": "structure",
	        "required": [
	          "Groups"
	        ],
	        "members": {
	          "Groups": {
	            "shape": "S7o"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListInstanceProfileTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceProfileName"
	        ],
	        "members": {
	          "InstanceProfileName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListInstanceProfileTagsResult",
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "Sv"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListInstanceProfiles": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PathPrefix": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListInstanceProfilesResult",
	        "type": "structure",
	        "required": [
	          "InstanceProfiles"
	        ],
	        "members": {
	          "InstanceProfiles": {
	            "shape": "S4c"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListInstanceProfilesForRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName"
	        ],
	        "members": {
	          "RoleName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListInstanceProfilesForRoleResult",
	        "type": "structure",
	        "required": [
	          "InstanceProfiles"
	        ],
	        "members": {
	          "InstanceProfiles": {
	            "shape": "S4c"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListMFADeviceTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SerialNumber"
	        ],
	        "members": {
	          "SerialNumber": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListMFADeviceTagsResult",
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "Sv"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListMFADevices": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "UserName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListMFADevicesResult",
	        "type": "structure",
	        "required": [
	          "MFADevices"
	        ],
	        "members": {
	          "MFADevices": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "UserName",
	                "SerialNumber",
	                "EnableDate"
	              ],
	              "members": {
	                "UserName": {},
	                "SerialNumber": {},
	                "EnableDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListOpenIDConnectProviderTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpenIDConnectProviderArn"
	        ],
	        "members": {
	          "OpenIDConnectProviderArn": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListOpenIDConnectProviderTagsResult",
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "Sv"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListOpenIDConnectProviders": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "resultWrapper": "ListOpenIDConnectProvidersResult",
	        "type": "structure",
	        "members": {
	          "OpenIDConnectProviderList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Arn": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListPolicies": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Scope": {},
	          "OnlyAttached": {
	            "type": "boolean"
	          },
	          "PathPrefix": {},
	          "PolicyUsageFilter": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListPoliciesResult",
	        "type": "structure",
	        "members": {
	          "Policies": {
	            "type": "list",
	            "member": {
	              "shape": "S1p"
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListPoliciesGrantingServiceAccess": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Arn",
	          "ServiceNamespaces"
	        ],
	        "members": {
	          "Marker": {},
	          "Arn": {},
	          "ServiceNamespaces": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListPoliciesGrantingServiceAccessResult",
	        "type": "structure",
	        "required": [
	          "PoliciesGrantingServiceAccess"
	        ],
	        "members": {
	          "PoliciesGrantingServiceAccess": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ServiceNamespace": {},
	                "Policies": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "required": [
	                      "PolicyName",
	                      "PolicyType"
	                    ],
	                    "members": {
	                      "PolicyName": {},
	                      "PolicyType": {},
	                      "PolicyArn": {},
	                      "EntityType": {},
	                      "EntityName": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListPolicyTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyArn"
	        ],
	        "members": {
	          "PolicyArn": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListPolicyTagsResult",
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "Sv"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListPolicyVersions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyArn"
	        ],
	        "members": {
	          "PolicyArn": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListPolicyVersionsResult",
	        "type": "structure",
	        "members": {
	          "Versions": {
	            "shape": "S4f"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListRolePolicies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName"
	        ],
	        "members": {
	          "RoleName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListRolePoliciesResult",
	        "type": "structure",
	        "required": [
	          "PolicyNames"
	        ],
	        "members": {
	          "PolicyNames": {
	            "shape": "S7k"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListRoleTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName"
	        ],
	        "members": {
	          "RoleName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListRoleTagsResult",
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "Sv"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListRoles": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PathPrefix": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListRolesResult",
	        "type": "structure",
	        "required": [
	          "Roles"
	        ],
	        "members": {
	          "Roles": {
	            "shape": "S11"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListSAMLProviderTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SAMLProviderArn"
	        ],
	        "members": {
	          "SAMLProviderArn": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListSAMLProviderTagsResult",
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "Sv"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListSAMLProviders": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "resultWrapper": "ListSAMLProvidersResult",
	        "type": "structure",
	        "members": {
	          "SAMLProviderList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Arn": {},
	                "ValidUntil": {
	                  "type": "timestamp"
	                },
	                "CreateDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListSSHPublicKeys": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "UserName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListSSHPublicKeysResult",
	        "type": "structure",
	        "members": {
	          "SSHPublicKeys": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "UserName",
	                "SSHPublicKeyId",
	                "Status",
	                "UploadDate"
	              ],
	              "members": {
	                "UserName": {},
	                "SSHPublicKeyId": {},
	                "Status": {},
	                "UploadDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListServerCertificateTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServerCertificateName"
	        ],
	        "members": {
	          "ServerCertificateName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListServerCertificateTagsResult",
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "Sv"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListServerCertificates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PathPrefix": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListServerCertificatesResult",
	        "type": "structure",
	        "required": [
	          "ServerCertificateMetadataList"
	        ],
	        "members": {
	          "ServerCertificateMetadataList": {
	            "type": "list",
	            "member": {
	              "shape": "S64"
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListServiceSpecificCredentials": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "UserName": {},
	          "ServiceName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListServiceSpecificCredentialsResult",
	        "type": "structure",
	        "members": {
	          "ServiceSpecificCredentials": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "UserName",
	                "Status",
	                "ServiceUserName",
	                "CreateDate",
	                "ServiceSpecificCredentialId",
	                "ServiceName"
	              ],
	              "members": {
	                "UserName": {},
	                "Status": {},
	                "ServiceUserName": {},
	                "CreateDate": {
	                  "type": "timestamp"
	                },
	                "ServiceSpecificCredentialId": {},
	                "ServiceName": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListSigningCertificates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "UserName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListSigningCertificatesResult",
	        "type": "structure",
	        "required": [
	          "Certificates"
	        ],
	        "members": {
	          "Certificates": {
	            "type": "list",
	            "member": {
	              "shape": "S9i"
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListUserPolicies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName"
	        ],
	        "members": {
	          "UserName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListUserPoliciesResult",
	        "type": "structure",
	        "required": [
	          "PolicyNames"
	        ],
	        "members": {
	          "PolicyNames": {
	            "shape": "S7k"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListUserTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName"
	        ],
	        "members": {
	          "UserName": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListUserTagsResult",
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "Sv"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListUsers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PathPrefix": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListUsersResult",
	        "type": "structure",
	        "required": [
	          "Users"
	        ],
	        "members": {
	          "Users": {
	            "shape": "S52"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListVirtualMFADevices": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AssignmentStatus": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListVirtualMFADevicesResult",
	        "type": "structure",
	        "required": [
	          "VirtualMFADevices"
	        ],
	        "members": {
	          "VirtualMFADevices": {
	            "type": "list",
	            "member": {
	              "shape": "S2h"
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "PutGroupPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "PolicyName",
	          "PolicyDocument"
	        ],
	        "members": {
	          "GroupName": {},
	          "PolicyName": {},
	          "PolicyDocument": {}
	        }
	      }
	    },
	    "PutRolePermissionsBoundary": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "PermissionsBoundary"
	        ],
	        "members": {
	          "RoleName": {},
	          "PermissionsBoundary": {}
	        }
	      }
	    },
	    "PutRolePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "PolicyName",
	          "PolicyDocument"
	        ],
	        "members": {
	          "RoleName": {},
	          "PolicyName": {},
	          "PolicyDocument": {}
	        }
	      }
	    },
	    "PutUserPermissionsBoundary": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "PermissionsBoundary"
	        ],
	        "members": {
	          "UserName": {},
	          "PermissionsBoundary": {}
	        }
	      }
	    },
	    "PutUserPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "PolicyName",
	          "PolicyDocument"
	        ],
	        "members": {
	          "UserName": {},
	          "PolicyName": {},
	          "PolicyDocument": {}
	        }
	      }
	    },
	    "RemoveClientIDFromOpenIDConnectProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpenIDConnectProviderArn",
	          "ClientID"
	        ],
	        "members": {
	          "OpenIDConnectProviderArn": {},
	          "ClientID": {}
	        }
	      }
	    },
	    "RemoveRoleFromInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceProfileName",
	          "RoleName"
	        ],
	        "members": {
	          "InstanceProfileName": {},
	          "RoleName": {}
	        }
	      }
	    },
	    "RemoveUserFromGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName",
	          "UserName"
	        ],
	        "members": {
	          "GroupName": {},
	          "UserName": {}
	        }
	      }
	    },
	    "ResetServiceSpecificCredential": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceSpecificCredentialId"
	        ],
	        "members": {
	          "UserName": {},
	          "ServiceSpecificCredentialId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ResetServiceSpecificCredentialResult",
	        "type": "structure",
	        "members": {
	          "ServiceSpecificCredential": {
	            "shape": "S27"
	          }
	        }
	      }
	    },
	    "ResyncMFADevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "SerialNumber",
	          "AuthenticationCode1",
	          "AuthenticationCode2"
	        ],
	        "members": {
	          "UserName": {},
	          "SerialNumber": {},
	          "AuthenticationCode1": {},
	          "AuthenticationCode2": {}
	        }
	      }
	    },
	    "SetDefaultPolicyVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyArn",
	          "VersionId"
	        ],
	        "members": {
	          "PolicyArn": {},
	          "VersionId": {}
	        }
	      }
	    },
	    "SetSecurityTokenServicePreferences": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalEndpointTokenVersion"
	        ],
	        "members": {
	          "GlobalEndpointTokenVersion": {}
	        }
	      }
	    },
	    "SimulateCustomPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyInputList",
	          "ActionNames"
	        ],
	        "members": {
	          "PolicyInputList": {
	            "shape": "S4s"
	          },
	          "PermissionsBoundaryPolicyInputList": {
	            "shape": "S4s"
	          },
	          "ActionNames": {
	            "shape": "Sa8"
	          },
	          "ResourceArns": {
	            "shape": "Saa"
	          },
	          "ResourcePolicy": {},
	          "ResourceOwner": {},
	          "CallerArn": {},
	          "ContextEntries": {
	            "shape": "Sac"
	          },
	          "ResourceHandlingOption": {},
	          "MaxItems": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "shape": "Sai",
	        "resultWrapper": "SimulateCustomPolicyResult"
	      }
	    },
	    "SimulatePrincipalPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicySourceArn",
	          "ActionNames"
	        ],
	        "members": {
	          "PolicySourceArn": {},
	          "PolicyInputList": {
	            "shape": "S4s"
	          },
	          "PermissionsBoundaryPolicyInputList": {
	            "shape": "S4s"
	          },
	          "ActionNames": {
	            "shape": "Sa8"
	          },
	          "ResourceArns": {
	            "shape": "Saa"
	          },
	          "ResourcePolicy": {},
	          "ResourceOwner": {},
	          "CallerArn": {},
	          "ContextEntries": {
	            "shape": "Sac"
	          },
	          "ResourceHandlingOption": {},
	          "MaxItems": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "shape": "Sai",
	        "resultWrapper": "SimulatePrincipalPolicyResult"
	      }
	    },
	    "TagInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceProfileName",
	          "Tags"
	        ],
	        "members": {
	          "InstanceProfileName": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "TagMFADevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SerialNumber",
	          "Tags"
	        ],
	        "members": {
	          "SerialNumber": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "TagOpenIDConnectProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpenIDConnectProviderArn",
	          "Tags"
	        ],
	        "members": {
	          "OpenIDConnectProviderArn": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "TagPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyArn",
	          "Tags"
	        ],
	        "members": {
	          "PolicyArn": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "TagRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "Tags"
	        ],
	        "members": {
	          "RoleName": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "TagSAMLProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SAMLProviderArn",
	          "Tags"
	        ],
	        "members": {
	          "SAMLProviderArn": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "TagServerCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServerCertificateName",
	          "Tags"
	        ],
	        "members": {
	          "ServerCertificateName": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "TagUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "Tags"
	        ],
	        "members": {
	          "UserName": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "UntagInstanceProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceProfileName",
	          "TagKeys"
	        ],
	        "members": {
	          "InstanceProfileName": {},
	          "TagKeys": {
	            "shape": "Sb9"
	          }
	        }
	      }
	    },
	    "UntagMFADevice": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SerialNumber",
	          "TagKeys"
	        ],
	        "members": {
	          "SerialNumber": {},
	          "TagKeys": {
	            "shape": "Sb9"
	          }
	        }
	      }
	    },
	    "UntagOpenIDConnectProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpenIDConnectProviderArn",
	          "TagKeys"
	        ],
	        "members": {
	          "OpenIDConnectProviderArn": {},
	          "TagKeys": {
	            "shape": "Sb9"
	          }
	        }
	      }
	    },
	    "UntagPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PolicyArn",
	          "TagKeys"
	        ],
	        "members": {
	          "PolicyArn": {},
	          "TagKeys": {
	            "shape": "Sb9"
	          }
	        }
	      }
	    },
	    "UntagRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "TagKeys"
	        ],
	        "members": {
	          "RoleName": {},
	          "TagKeys": {
	            "shape": "Sb9"
	          }
	        }
	      }
	    },
	    "UntagSAMLProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SAMLProviderArn",
	          "TagKeys"
	        ],
	        "members": {
	          "SAMLProviderArn": {},
	          "TagKeys": {
	            "shape": "Sb9"
	          }
	        }
	      }
	    },
	    "UntagServerCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServerCertificateName",
	          "TagKeys"
	        ],
	        "members": {
	          "ServerCertificateName": {},
	          "TagKeys": {
	            "shape": "Sb9"
	          }
	        }
	      }
	    },
	    "UntagUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "TagKeys"
	        ],
	        "members": {
	          "UserName": {},
	          "TagKeys": {
	            "shape": "Sb9"
	          }
	        }
	      }
	    },
	    "UpdateAccessKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessKeyId",
	          "Status"
	        ],
	        "members": {
	          "UserName": {},
	          "AccessKeyId": {},
	          "Status": {}
	        }
	      }
	    },
	    "UpdateAccountPasswordPolicy": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "MinimumPasswordLength": {
	            "type": "integer"
	          },
	          "RequireSymbols": {
	            "type": "boolean"
	          },
	          "RequireNumbers": {
	            "type": "boolean"
	          },
	          "RequireUppercaseCharacters": {
	            "type": "boolean"
	          },
	          "RequireLowercaseCharacters": {
	            "type": "boolean"
	          },
	          "AllowUsersToChangePassword": {
	            "type": "boolean"
	          },
	          "MaxPasswordAge": {
	            "type": "integer"
	          },
	          "PasswordReusePrevention": {
	            "type": "integer"
	          },
	          "HardExpiry": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "UpdateAssumeRolePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "PolicyDocument"
	        ],
	        "members": {
	          "RoleName": {},
	          "PolicyDocument": {}
	        }
	      }
	    },
	    "UpdateGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName"
	        ],
	        "members": {
	          "GroupName": {},
	          "NewPath": {},
	          "NewGroupName": {}
	        }
	      }
	    },
	    "UpdateLoginProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName"
	        ],
	        "members": {
	          "UserName": {},
	          "Password": {
	            "shape": "Sf"
	          },
	          "PasswordResetRequired": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "UpdateOpenIDConnectProviderThumbprint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpenIDConnectProviderArn",
	          "ThumbprintList"
	        ],
	        "members": {
	          "OpenIDConnectProviderArn": {},
	          "ThumbprintList": {
	            "shape": "S1h"
	          }
	        }
	      }
	    },
	    "UpdateRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName"
	        ],
	        "members": {
	          "RoleName": {},
	          "Description": {},
	          "MaxSessionDuration": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateRoleResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateRoleDescription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleName",
	          "Description"
	        ],
	        "members": {
	          "RoleName": {},
	          "Description": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateRoleDescriptionResult",
	        "type": "structure",
	        "members": {
	          "Role": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "UpdateSAMLProvider": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SAMLMetadataDocument",
	          "SAMLProviderArn"
	        ],
	        "members": {
	          "SAMLMetadataDocument": {},
	          "SAMLProviderArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "UpdateSAMLProviderResult",
	        "type": "structure",
	        "members": {
	          "SAMLProviderArn": {}
	        }
	      }
	    },
	    "UpdateSSHPublicKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "SSHPublicKeyId",
	          "Status"
	        ],
	        "members": {
	          "UserName": {},
	          "SSHPublicKeyId": {},
	          "Status": {}
	        }
	      }
	    },
	    "UpdateServerCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServerCertificateName"
	        ],
	        "members": {
	          "ServerCertificateName": {},
	          "NewPath": {},
	          "NewServerCertificateName": {}
	        }
	      }
	    },
	    "UpdateServiceSpecificCredential": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceSpecificCredentialId",
	          "Status"
	        ],
	        "members": {
	          "UserName": {},
	          "ServiceSpecificCredentialId": {},
	          "Status": {}
	        }
	      }
	    },
	    "UpdateSigningCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateId",
	          "Status"
	        ],
	        "members": {
	          "UserName": {},
	          "CertificateId": {},
	          "Status": {}
	        }
	      }
	    },
	    "UpdateUser": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName"
	        ],
	        "members": {
	          "UserName": {},
	          "NewPath": {},
	          "NewUserName": {}
	        }
	      }
	    },
	    "UploadSSHPublicKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "SSHPublicKeyBody"
	        ],
	        "members": {
	          "UserName": {},
	          "SSHPublicKeyBody": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "UploadSSHPublicKeyResult",
	        "type": "structure",
	        "members": {
	          "SSHPublicKey": {
	            "shape": "S5y"
	          }
	        }
	      }
	    },
	    "UploadServerCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServerCertificateName",
	          "CertificateBody",
	          "PrivateKey"
	        ],
	        "members": {
	          "Path": {},
	          "ServerCertificateName": {},
	          "CertificateBody": {},
	          "PrivateKey": {
	            "type": "string",
	            "sensitive": true
	          },
	          "CertificateChain": {},
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "UploadServerCertificateResult",
	        "type": "structure",
	        "members": {
	          "ServerCertificateMetadata": {
	            "shape": "S64"
	          },
	          "Tags": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "UploadSigningCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CertificateBody"
	        ],
	        "members": {
	          "UserName": {},
	          "CertificateBody": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "UploadSigningCertificateResult",
	        "type": "structure",
	        "required": [
	          "Certificate"
	        ],
	        "members": {
	          "Certificate": {
	            "shape": "S9i"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sf": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Ss": {
	      "type": "structure",
	      "required": [
	        "Path",
	        "GroupName",
	        "GroupId",
	        "Arn",
	        "CreateDate"
	      ],
	      "members": {
	        "Path": {},
	        "GroupName": {},
	        "GroupId": {},
	        "Arn": {},
	        "CreateDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sv": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S10": {
	      "type": "structure",
	      "required": [
	        "Path",
	        "InstanceProfileName",
	        "InstanceProfileId",
	        "Arn",
	        "CreateDate",
	        "Roles"
	      ],
	      "members": {
	        "Path": {},
	        "InstanceProfileName": {},
	        "InstanceProfileId": {},
	        "Arn": {},
	        "CreateDate": {
	          "type": "timestamp"
	        },
	        "Roles": {
	          "shape": "S11"
	        },
	        "Tags": {
	          "shape": "Sv"
	        }
	      }
	    },
	    "S11": {
	      "type": "list",
	      "member": {
	        "shape": "S12"
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "required": [
	        "Path",
	        "RoleName",
	        "RoleId",
	        "Arn",
	        "CreateDate"
	      ],
	      "members": {
	        "Path": {},
	        "RoleName": {},
	        "RoleId": {},
	        "Arn": {},
	        "CreateDate": {
	          "type": "timestamp"
	        },
	        "AssumeRolePolicyDocument": {},
	        "Description": {},
	        "MaxSessionDuration": {
	          "type": "integer"
	        },
	        "PermissionsBoundary": {
	          "shape": "S16"
	        },
	        "Tags": {
	          "shape": "Sv"
	        },
	        "RoleLastUsed": {
	          "shape": "S18"
	        }
	      }
	    },
	    "S16": {
	      "type": "structure",
	      "members": {
	        "PermissionsBoundaryType": {},
	        "PermissionsBoundaryArn": {}
	      }
	    },
	    "S18": {
	      "type": "structure",
	      "members": {
	        "LastUsedDate": {
	          "type": "timestamp"
	        },
	        "Region": {}
	      }
	    },
	    "S1d": {
	      "type": "structure",
	      "required": [
	        "UserName",
	        "CreateDate"
	      ],
	      "members": {
	        "UserName": {},
	        "CreateDate": {
	          "type": "timestamp"
	        },
	        "PasswordResetRequired": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1g": {
	      "type": "list",
	      "member": {}
	    },
	    "S1h": {
	      "type": "list",
	      "member": {}
	    },
	    "S1p": {
	      "type": "structure",
	      "members": {
	        "PolicyName": {},
	        "PolicyId": {},
	        "Arn": {},
	        "Path": {},
	        "DefaultVersionId": {},
	        "AttachmentCount": {
	          "type": "integer"
	        },
	        "PermissionsBoundaryUsageCount": {
	          "type": "integer"
	        },
	        "IsAttachable": {
	          "type": "boolean"
	        },
	        "Description": {},
	        "CreateDate": {
	          "type": "timestamp"
	        },
	        "UpdateDate": {
	          "type": "timestamp"
	        },
	        "Tags": {
	          "shape": "Sv"
	        }
	      }
	    },
	    "S1u": {
	      "type": "structure",
	      "members": {
	        "Document": {},
	        "VersionId": {},
	        "IsDefaultVersion": {
	          "type": "boolean"
	        },
	        "CreateDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S27": {
	      "type": "structure",
	      "required": [
	        "CreateDate",
	        "ServiceName",
	        "ServiceUserName",
	        "ServicePassword",
	        "ServiceSpecificCredentialId",
	        "UserName",
	        "Status"
	      ],
	      "members": {
	        "CreateDate": {
	          "type": "timestamp"
	        },
	        "ServiceName": {},
	        "ServiceUserName": {},
	        "ServicePassword": {
	          "type": "string",
	          "sensitive": true
	        },
	        "ServiceSpecificCredentialId": {},
	        "UserName": {},
	        "Status": {}
	      }
	    },
	    "S2d": {
	      "type": "structure",
	      "required": [
	        "Path",
	        "UserName",
	        "UserId",
	        "Arn",
	        "CreateDate"
	      ],
	      "members": {
	        "Path": {},
	        "UserName": {},
	        "UserId": {},
	        "Arn": {},
	        "CreateDate": {
	          "type": "timestamp"
	        },
	        "PasswordLastUsed": {
	          "type": "timestamp"
	        },
	        "PermissionsBoundary": {
	          "shape": "S16"
	        },
	        "Tags": {
	          "shape": "Sv"
	        }
	      }
	    },
	    "S2h": {
	      "type": "structure",
	      "required": [
	        "SerialNumber"
	      ],
	      "members": {
	        "SerialNumber": {},
	        "Base32StringSeed": {
	          "shape": "S2j"
	        },
	        "QRCodePNG": {
	          "shape": "S2j"
	        },
	        "User": {
	          "shape": "S2d"
	        },
	        "EnableDate": {
	          "type": "timestamp"
	        },
	        "Tags": {
	          "shape": "Sv"
	        }
	      }
	    },
	    "S2j": {
	      "type": "blob",
	      "sensitive": true
	    },
	    "S43": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "PolicyName": {},
	          "PolicyDocument": {}
	        }
	      }
	    },
	    "S46": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "PolicyName": {},
	          "PolicyArn": {}
	        }
	      }
	    },
	    "S4c": {
	      "type": "list",
	      "member": {
	        "shape": "S10"
	      }
	    },
	    "S4f": {
	      "type": "list",
	      "member": {
	        "shape": "S1u"
	      }
	    },
	    "S4s": {
	      "type": "list",
	      "member": {}
	    },
	    "S4t": {
	      "type": "structure",
	      "members": {
	        "ContextKeyNames": {
	          "shape": "S4u"
	        }
	      }
	    },
	    "S4u": {
	      "type": "list",
	      "member": {}
	    },
	    "S52": {
	      "type": "list",
	      "member": {
	        "shape": "S2d"
	      }
	    },
	    "S5k": {
	      "type": "structure",
	      "required": [
	        "Message",
	        "Code"
	      ],
	      "members": {
	        "Message": {},
	        "Code": {}
	      }
	    },
	    "S5y": {
	      "type": "structure",
	      "required": [
	        "UserName",
	        "SSHPublicKeyId",
	        "Fingerprint",
	        "SSHPublicKeyBody",
	        "Status"
	      ],
	      "members": {
	        "UserName": {},
	        "SSHPublicKeyId": {},
	        "Fingerprint": {},
	        "SSHPublicKeyBody": {},
	        "Status": {},
	        "UploadDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S64": {
	      "type": "structure",
	      "required": [
	        "Path",
	        "ServerCertificateName",
	        "ServerCertificateId",
	        "Arn"
	      ],
	      "members": {
	        "Path": {},
	        "ServerCertificateName": {},
	        "ServerCertificateId": {},
	        "Arn": {},
	        "UploadDate": {
	          "type": "timestamp"
	        },
	        "Expiration": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S7k": {
	      "type": "list",
	      "member": {}
	    },
	    "S7o": {
	      "type": "list",
	      "member": {
	        "shape": "Ss"
	      }
	    },
	    "S9i": {
	      "type": "structure",
	      "required": [
	        "UserName",
	        "CertificateId",
	        "CertificateBody",
	        "Status"
	      ],
	      "members": {
	        "UserName": {},
	        "CertificateId": {},
	        "CertificateBody": {},
	        "Status": {},
	        "UploadDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sa8": {
	      "type": "list",
	      "member": {}
	    },
	    "Saa": {
	      "type": "list",
	      "member": {}
	    },
	    "Sac": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ContextKeyName": {},
	          "ContextKeyValues": {
	            "type": "list",
	            "member": {}
	          },
	          "ContextKeyType": {}
	        }
	      }
	    },
	    "Sai": {
	      "type": "structure",
	      "members": {
	        "EvaluationResults": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "EvalActionName",
	              "EvalDecision"
	            ],
	            "members": {
	              "EvalActionName": {},
	              "EvalResourceName": {},
	              "EvalDecision": {},
	              "MatchedStatements": {
	                "shape": "Sam"
	              },
	              "MissingContextValues": {
	                "shape": "S4u"
	              },
	              "OrganizationsDecisionDetail": {
	                "type": "structure",
	                "members": {
	                  "AllowedByOrganizations": {
	                    "type": "boolean"
	                  }
	                }
	              },
	              "PermissionsBoundaryDecisionDetail": {
	                "shape": "Sau"
	              },
	              "EvalDecisionDetails": {
	                "shape": "Sav"
	              },
	              "ResourceSpecificResults": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "EvalResourceName",
	                    "EvalResourceDecision"
	                  ],
	                  "members": {
	                    "EvalResourceName": {},
	                    "EvalResourceDecision": {},
	                    "MatchedStatements": {
	                      "shape": "Sam"
	                    },
	                    "MissingContextValues": {
	                      "shape": "S4u"
	                    },
	                    "EvalDecisionDetails": {
	                      "shape": "Sav"
	                    },
	                    "PermissionsBoundaryDecisionDetail": {
	                      "shape": "Sau"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "IsTruncated": {
	          "type": "boolean"
	        },
	        "Marker": {}
	      }
	    },
	    "Sam": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "SourcePolicyId": {},
	          "SourcePolicyType": {},
	          "StartPosition": {
	            "shape": "Saq"
	          },
	          "EndPosition": {
	            "shape": "Saq"
	          }
	        }
	      }
	    },
	    "Saq": {
	      "type": "structure",
	      "members": {
	        "Line": {
	          "type": "integer"
	        },
	        "Column": {
	          "type": "integer"
	        }
	      }
	    },
	    "Sau": {
	      "type": "structure",
	      "members": {
	        "AllowedByPermissionsBoundary": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Sav": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sb9": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],122:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "GetAccountAuthorizationDetails": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": [
	        "UserDetailList",
	        "GroupDetailList",
	        "RoleDetailList",
	        "Policies"
	      ]
	    },
	    "GetGroup": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "Users"
	    },
	    "ListAccessKeys": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "AccessKeyMetadata"
	    },
	    "ListAccountAliases": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "AccountAliases"
	    },
	    "ListAttachedGroupPolicies": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "AttachedPolicies"
	    },
	    "ListAttachedRolePolicies": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "AttachedPolicies"
	    },
	    "ListAttachedUserPolicies": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "AttachedPolicies"
	    },
	    "ListEntitiesForPolicy": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": [
	        "PolicyGroups",
	        "PolicyUsers",
	        "PolicyRoles"
	      ]
	    },
	    "ListGroupPolicies": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "PolicyNames"
	    },
	    "ListGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "Groups"
	    },
	    "ListGroupsForUser": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "Groups"
	    },
	    "ListInstanceProfiles": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "InstanceProfiles"
	    },
	    "ListInstanceProfilesForRole": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "InstanceProfiles"
	    },
	    "ListMFADevices": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "MFADevices"
	    },
	    "ListPolicies": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "Policies"
	    },
	    "ListPolicyVersions": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "Versions"
	    },
	    "ListRolePolicies": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "PolicyNames"
	    },
	    "ListRoles": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "Roles"
	    },
	    "ListSAMLProviders": {
	      "result_key": "SAMLProviderList"
	    },
	    "ListSSHPublicKeys": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "SSHPublicKeys"
	    },
	    "ListServerCertificates": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "ServerCertificateMetadataList"
	    },
	    "ListSigningCertificates": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "Certificates"
	    },
	    "ListUserPolicies": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "PolicyNames"
	    },
	    "ListUserTags": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "Tags"
	    },
	    "ListUsers": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "Users"
	    },
	    "ListVirtualMFADevices": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "VirtualMFADevices"
	    },
	    "SimulateCustomPolicy": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "EvaluationResults"
	    },
	    "SimulatePrincipalPolicy": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "Marker",
	      "result_key": "EvaluationResults"
	    }
	  }
	}
	},{}],123:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "InstanceProfileExists": {
	      "delay": 1,
	      "operation": "GetInstanceProfile",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": 200,
	          "matcher": "status",
	          "state": "success"
	        },
	        {
	          "state": "retry",
	          "matcher": "status",
	          "expected": 404
	        }
	      ]
	    },
	    "UserExists": {
	      "delay": 1,
	      "operation": "GetUser",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "status",
	          "expected": 200
	        },
	        {
	          "state": "retry",
	          "matcher": "error",
	          "expected": "NoSuchEntity"
	        }
	      ]
	    },
	    "RoleExists": {
	      "delay": 1,
	      "operation": "GetRole",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "status",
	          "expected": 200
	        },
	        {
	          "state": "retry",
	          "matcher": "error",
	          "expected": "NoSuchEntity"
	        }
	      ]
	    },
	    "PolicyExists": {
	      "delay": 1,
	      "operation": "GetPolicy",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "status",
	          "expected": 200
	        },
	        {
	          "state": "retry",
	          "matcher": "error",
	          "expected": "NoSuchEntity"
	        }
	      ]
	    }
	  }
	}
	
	},{}],124:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2016-02-16",
	    "endpointPrefix": "inspector",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Inspector",
	    "serviceId": "Inspector",
	    "signatureVersion": "v4",
	    "targetPrefix": "InspectorService",
	    "uid": "inspector-2016-02-16"
	  },
	  "operations": {
	    "AddAttributesToFindings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "findingArns",
	          "attributes"
	        ],
	        "members": {
	          "findingArns": {
	            "shape": "S2"
	          },
	          "attributes": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "failedItems"
	        ],
	        "members": {
	          "failedItems": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "CreateAssessmentTarget": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentTargetName"
	        ],
	        "members": {
	          "assessmentTargetName": {},
	          "resourceGroupArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "assessmentTargetArn"
	        ],
	        "members": {
	          "assessmentTargetArn": {}
	        }
	      }
	    },
	    "CreateAssessmentTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentTargetArn",
	          "assessmentTemplateName",
	          "durationInSeconds",
	          "rulesPackageArns"
	        ],
	        "members": {
	          "assessmentTargetArn": {},
	          "assessmentTemplateName": {},
	          "durationInSeconds": {
	            "type": "integer"
	          },
	          "rulesPackageArns": {
	            "shape": "Sj"
	          },
	          "userAttributesForFindings": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "assessmentTemplateArn"
	        ],
	        "members": {
	          "assessmentTemplateArn": {}
	        }
	      }
	    },
	    "CreateExclusionsPreview": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentTemplateArn"
	        ],
	        "members": {
	          "assessmentTemplateArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "previewToken"
	        ],
	        "members": {
	          "previewToken": {}
	        }
	      }
	    },
	    "CreateResourceGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceGroupTags"
	        ],
	        "members": {
	          "resourceGroupTags": {
	            "shape": "Sp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "resourceGroupArn"
	        ],
	        "members": {
	          "resourceGroupArn": {}
	        }
	      }
	    },
	    "DeleteAssessmentRun": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentRunArn"
	        ],
	        "members": {
	          "assessmentRunArn": {}
	        }
	      }
	    },
	    "DeleteAssessmentTarget": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentTargetArn"
	        ],
	        "members": {
	          "assessmentTargetArn": {}
	        }
	      }
	    },
	    "DeleteAssessmentTemplate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentTemplateArn"
	        ],
	        "members": {
	          "assessmentTemplateArn": {}
	        }
	      }
	    },
	    "DescribeAssessmentRuns": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentRunArns"
	        ],
	        "members": {
	          "assessmentRunArns": {
	            "shape": "Sy"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "assessmentRuns",
	          "failedItems"
	        ],
	        "members": {
	          "assessmentRuns": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "arn",
	                "name",
	                "assessmentTemplateArn",
	                "state",
	                "durationInSeconds",
	                "rulesPackageArns",
	                "userAttributesForFindings",
	                "createdAt",
	                "stateChangedAt",
	                "dataCollected",
	                "stateChanges",
	                "notifications",
	                "findingCounts"
	              ],
	              "members": {
	                "arn": {},
	                "name": {},
	                "assessmentTemplateArn": {},
	                "state": {},
	                "durationInSeconds": {
	                  "type": "integer"
	                },
	                "rulesPackageArns": {
	                  "type": "list",
	                  "member": {}
	                },
	                "userAttributesForFindings": {
	                  "shape": "S4"
	                },
	                "createdAt": {
	                  "type": "timestamp"
	                },
	                "startedAt": {
	                  "type": "timestamp"
	                },
	                "completedAt": {
	                  "type": "timestamp"
	                },
	                "stateChangedAt": {
	                  "type": "timestamp"
	                },
	                "dataCollected": {
	                  "type": "boolean"
	                },
	                "stateChanges": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "required": [
	                      "stateChangedAt",
	                      "state"
	                    ],
	                    "members": {
	                      "stateChangedAt": {
	                        "type": "timestamp"
	                      },
	                      "state": {}
	                    }
	                  }
	                },
	                "notifications": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "required": [
	                      "date",
	                      "event",
	                      "error"
	                    ],
	                    "members": {
	                      "date": {
	                        "type": "timestamp"
	                      },
	                      "event": {},
	                      "message": {},
	                      "error": {
	                        "type": "boolean"
	                      },
	                      "snsTopicArn": {},
	                      "snsPublishStatusCode": {}
	                    }
	                  }
	                },
	                "findingCounts": {
	                  "type": "map",
	                  "key": {},
	                  "value": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          },
	          "failedItems": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "DescribeAssessmentTargets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentTargetArns"
	        ],
	        "members": {
	          "assessmentTargetArns": {
	            "shape": "Sy"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "assessmentTargets",
	          "failedItems"
	        ],
	        "members": {
	          "assessmentTargets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "arn",
	                "name",
	                "createdAt",
	                "updatedAt"
	              ],
	              "members": {
	                "arn": {},
	                "name": {},
	                "resourceGroupArn": {},
	                "createdAt": {
	                  "type": "timestamp"
	                },
	                "updatedAt": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "failedItems": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "DescribeAssessmentTemplates": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentTemplateArns"
	        ],
	        "members": {
	          "assessmentTemplateArns": {
	            "shape": "Sy"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "assessmentTemplates",
	          "failedItems"
	        ],
	        "members": {
	          "assessmentTemplates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "arn",
	                "name",
	                "assessmentTargetArn",
	                "durationInSeconds",
	                "rulesPackageArns",
	                "userAttributesForFindings",
	                "assessmentRunCount",
	                "createdAt"
	              ],
	              "members": {
	                "arn": {},
	                "name": {},
	                "assessmentTargetArn": {},
	                "durationInSeconds": {
	                  "type": "integer"
	                },
	                "rulesPackageArns": {
	                  "shape": "Sj"
	                },
	                "userAttributesForFindings": {
	                  "shape": "S4"
	                },
	                "lastAssessmentRunArn": {},
	                "assessmentRunCount": {
	                  "type": "integer"
	                },
	                "createdAt": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "failedItems": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "DescribeCrossAccountAccessRole": {
	      "output": {
	        "type": "structure",
	        "required": [
	          "roleArn",
	          "valid",
	          "registeredAt"
	        ],
	        "members": {
	          "roleArn": {},
	          "valid": {
	            "type": "boolean"
	          },
	          "registeredAt": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeExclusions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "exclusionArns"
	        ],
	        "members": {
	          "exclusionArns": {
	            "type": "list",
	            "member": {}
	          },
	          "locale": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "exclusions",
	          "failedItems"
	        ],
	        "members": {
	          "exclusions": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "required": [
	                "arn",
	                "title",
	                "description",
	                "recommendation",
	                "scopes"
	              ],
	              "members": {
	                "arn": {},
	                "title": {},
	                "description": {},
	                "recommendation": {},
	                "scopes": {
	                  "shape": "S1x"
	                },
	                "attributes": {
	                  "shape": "S21"
	                }
	              }
	            }
	          },
	          "failedItems": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "DescribeFindings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "findingArns"
	        ],
	        "members": {
	          "findingArns": {
	            "shape": "Sy"
	          },
	          "locale": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "findings",
	          "failedItems"
	        ],
	        "members": {
	          "findings": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "arn",
	                "attributes",
	                "userAttributes",
	                "createdAt",
	                "updatedAt"
	              ],
	              "members": {
	                "arn": {},
	                "schemaVersion": {
	                  "type": "integer"
	                },
	                "service": {},
	                "serviceAttributes": {
	                  "type": "structure",
	                  "required": [
	                    "schemaVersion"
	                  ],
	                  "members": {
	                    "schemaVersion": {
	                      "type": "integer"
	                    },
	                    "assessmentRunArn": {},
	                    "rulesPackageArn": {}
	                  }
	                },
	                "assetType": {},
	                "assetAttributes": {
	                  "type": "structure",
	                  "required": [
	                    "schemaVersion"
	                  ],
	                  "members": {
	                    "schemaVersion": {
	                      "type": "integer"
	                    },
	                    "agentId": {},
	                    "autoScalingGroup": {},
	                    "amiId": {},
	                    "hostname": {},
	                    "ipv4Addresses": {
	                      "type": "list",
	                      "member": {}
	                    },
	                    "tags": {
	                      "type": "list",
	                      "member": {
	                        "shape": "S2i"
	                      }
	                    },
	                    "networkInterfaces": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "members": {
	                          "networkInterfaceId": {},
	                          "subnetId": {},
	                          "vpcId": {},
	                          "privateDnsName": {},
	                          "privateIpAddress": {},
	                          "privateIpAddresses": {
	                            "type": "list",
	                            "member": {
	                              "type": "structure",
	                              "members": {
	                                "privateDnsName": {},
	                                "privateIpAddress": {}
	                              }
	                            }
	                          },
	                          "publicDnsName": {},
	                          "publicIp": {},
	                          "ipv6Addresses": {
	                            "type": "list",
	                            "member": {}
	                          },
	                          "securityGroups": {
	                            "type": "list",
	                            "member": {
	                              "type": "structure",
	                              "members": {
	                                "groupName": {},
	                                "groupId": {}
	                              }
	                            }
	                          }
	                        }
	                      }
	                    }
	                  }
	                },
	                "id": {},
	                "title": {},
	                "description": {},
	                "recommendation": {},
	                "severity": {},
	                "numericSeverity": {
	                  "type": "double"
	                },
	                "confidence": {
	                  "type": "integer"
	                },
	                "indicatorOfCompromise": {
	                  "type": "boolean"
	                },
	                "attributes": {
	                  "shape": "S21"
	                },
	                "userAttributes": {
	                  "shape": "S4"
	                },
	                "createdAt": {
	                  "type": "timestamp"
	                },
	                "updatedAt": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "failedItems": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "DescribeResourceGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceGroupArns"
	        ],
	        "members": {
	          "resourceGroupArns": {
	            "shape": "Sy"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "resourceGroups",
	          "failedItems"
	        ],
	        "members": {
	          "resourceGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "arn",
	                "tags",
	                "createdAt"
	              ],
	              "members": {
	                "arn": {},
	                "tags": {
	                  "shape": "Sp"
	                },
	                "createdAt": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "failedItems": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "DescribeRulesPackages": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "rulesPackageArns"
	        ],
	        "members": {
	          "rulesPackageArns": {
	            "shape": "Sy"
	          },
	          "locale": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "rulesPackages",
	          "failedItems"
	        ],
	        "members": {
	          "rulesPackages": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "arn",
	                "name",
	                "version",
	                "provider"
	              ],
	              "members": {
	                "arn": {},
	                "name": {},
	                "version": {},
	                "provider": {},
	                "description": {}
	              }
	            }
	          },
	          "failedItems": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "GetAssessmentReport": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentRunArn",
	          "reportFileFormat",
	          "reportType"
	        ],
	        "members": {
	          "assessmentRunArn": {},
	          "reportFileFormat": {},
	          "reportType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "status"
	        ],
	        "members": {
	          "status": {},
	          "url": {}
	        }
	      }
	    },
	    "GetExclusionsPreview": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentTemplateArn",
	          "previewToken"
	        ],
	        "members": {
	          "assessmentTemplateArn": {},
	          "previewToken": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "locale": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "previewStatus"
	        ],
	        "members": {
	          "previewStatus": {},
	          "exclusionPreviews": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "title",
	                "description",
	                "recommendation",
	                "scopes"
	              ],
	              "members": {
	                "title": {},
	                "description": {},
	                "recommendation": {},
	                "scopes": {
	                  "shape": "S1x"
	                },
	                "attributes": {
	                  "shape": "S21"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetTelemetryMetadata": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentRunArn"
	        ],
	        "members": {
	          "assessmentRunArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "telemetryMetadata"
	        ],
	        "members": {
	          "telemetryMetadata": {
	            "shape": "S3j"
	          }
	        }
	      }
	    },
	    "ListAssessmentRunAgents": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentRunArn"
	        ],
	        "members": {
	          "assessmentRunArn": {},
	          "filter": {
	            "type": "structure",
	            "required": [
	              "agentHealths",
	              "agentHealthCodes"
	            ],
	            "members": {
	              "agentHealths": {
	                "type": "list",
	                "member": {}
	              },
	              "agentHealthCodes": {
	                "type": "list",
	                "member": {}
	              }
	            }
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "assessmentRunAgents"
	        ],
	        "members": {
	          "assessmentRunAgents": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "agentId",
	                "assessmentRunArn",
	                "agentHealth",
	                "agentHealthCode",
	                "telemetryMetadata"
	              ],
	              "members": {
	                "agentId": {},
	                "assessmentRunArn": {},
	                "agentHealth": {},
	                "agentHealthCode": {},
	                "agentHealthDetails": {},
	                "autoScalingGroup": {},
	                "telemetryMetadata": {
	                  "shape": "S3j"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListAssessmentRuns": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "assessmentTemplateArns": {
	            "shape": "S3x"
	          },
	          "filter": {
	            "type": "structure",
	            "members": {
	              "namePattern": {},
	              "states": {
	                "type": "list",
	                "member": {}
	              },
	              "durationRange": {
	                "shape": "S41"
	              },
	              "rulesPackageArns": {
	                "shape": "S42"
	              },
	              "startTimeRange": {
	                "shape": "S43"
	              },
	              "completionTimeRange": {
	                "shape": "S43"
	              },
	              "stateChangeTimeRange": {
	                "shape": "S43"
	              }
	            }
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "assessmentRunArns"
	        ],
	        "members": {
	          "assessmentRunArns": {
	            "shape": "S45"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListAssessmentTargets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "filter": {
	            "type": "structure",
	            "members": {
	              "assessmentTargetNamePattern": {}
	            }
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "assessmentTargetArns"
	        ],
	        "members": {
	          "assessmentTargetArns": {
	            "shape": "S45"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListAssessmentTemplates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "assessmentTargetArns": {
	            "shape": "S3x"
	          },
	          "filter": {
	            "type": "structure",
	            "members": {
	              "namePattern": {},
	              "durationRange": {
	                "shape": "S41"
	              },
	              "rulesPackageArns": {
	                "shape": "S42"
	              }
	            }
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "assessmentTemplateArns"
	        ],
	        "members": {
	          "assessmentTemplateArns": {
	            "shape": "S45"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListEventSubscriptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "resourceArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "subscriptions"
	        ],
	        "members": {
	          "subscriptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "resourceArn",
	                "topicArn",
	                "eventSubscriptions"
	              ],
	              "members": {
	                "resourceArn": {},
	                "topicArn": {},
	                "eventSubscriptions": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "required": [
	                      "event",
	                      "subscribedAt"
	                    ],
	                    "members": {
	                      "event": {},
	                      "subscribedAt": {
	                        "type": "timestamp"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListExclusions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentRunArn"
	        ],
	        "members": {
	          "assessmentRunArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "exclusionArns"
	        ],
	        "members": {
	          "exclusionArns": {
	            "shape": "S45"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListFindings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "assessmentRunArns": {
	            "shape": "S3x"
	          },
	          "filter": {
	            "type": "structure",
	            "members": {
	              "agentIds": {
	                "type": "list",
	                "member": {}
	              },
	              "autoScalingGroups": {
	                "type": "list",
	                "member": {}
	              },
	              "ruleNames": {
	                "type": "list",
	                "member": {}
	              },
	              "severities": {
	                "type": "list",
	                "member": {}
	              },
	              "rulesPackageArns": {
	                "shape": "S42"
	              },
	              "attributes": {
	                "shape": "S21"
	              },
	              "userAttributes": {
	                "shape": "S21"
	              },
	              "creationTimeRange": {
	                "shape": "S43"
	              }
	            }
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "findingArns"
	        ],
	        "members": {
	          "findingArns": {
	            "shape": "S45"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListRulesPackages": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "rulesPackageArns"
	        ],
	        "members": {
	          "rulesPackageArns": {
	            "shape": "S45"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "tags"
	        ],
	        "members": {
	          "tags": {
	            "shape": "S4x"
	          }
	        }
	      }
	    },
	    "PreviewAgents": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "previewAgentsArn"
	        ],
	        "members": {
	          "previewAgentsArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "agentPreviews"
	        ],
	        "members": {
	          "agentPreviews": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "agentId"
	              ],
	              "members": {
	                "hostname": {},
	                "agentId": {},
	                "autoScalingGroup": {},
	                "agentHealth": {},
	                "agentVersion": {},
	                "operatingSystem": {},
	                "kernelVersion": {},
	                "ipv4Address": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "RegisterCrossAccountAccessRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "roleArn"
	        ],
	        "members": {
	          "roleArn": {}
	        }
	      }
	    },
	    "RemoveAttributesFromFindings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "findingArns",
	          "attributeKeys"
	        ],
	        "members": {
	          "findingArns": {
	            "shape": "S2"
	          },
	          "attributeKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "failedItems"
	        ],
	        "members": {
	          "failedItems": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "SetTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tags": {
	            "shape": "S4x"
	          }
	        }
	      }
	    },
	    "StartAssessmentRun": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentTemplateArn"
	        ],
	        "members": {
	          "assessmentTemplateArn": {},
	          "assessmentRunName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "assessmentRunArn"
	        ],
	        "members": {
	          "assessmentRunArn": {}
	        }
	      }
	    },
	    "StopAssessmentRun": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentRunArn"
	        ],
	        "members": {
	          "assessmentRunArn": {},
	          "stopAction": {}
	        }
	      }
	    },
	    "SubscribeToEvent": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "event",
	          "topicArn"
	        ],
	        "members": {
	          "resourceArn": {},
	          "event": {},
	          "topicArn": {}
	        }
	      }
	    },
	    "UnsubscribeFromEvent": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "event",
	          "topicArn"
	        ],
	        "members": {
	          "resourceArn": {},
	          "event": {},
	          "topicArn": {}
	        }
	      }
	    },
	    "UpdateAssessmentTarget": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "assessmentTargetArn",
	          "assessmentTargetName"
	        ],
	        "members": {
	          "assessmentTargetArn": {},
	          "assessmentTargetName": {},
	          "resourceGroupArn": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "list",
	      "member": {}
	    },
	    "S4": {
	      "type": "list",
	      "member": {
	        "shape": "S5"
	      }
	    },
	    "S5": {
	      "type": "structure",
	      "required": [
	        "key"
	      ],
	      "members": {
	        "key": {},
	        "value": {}
	      }
	    },
	    "S9": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "required": [
	          "failureCode",
	          "retryable"
	        ],
	        "members": {
	          "failureCode": {},
	          "retryable": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "Sj": {
	      "type": "list",
	      "member": {}
	    },
	    "Sp": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "key"
	        ],
	        "members": {
	          "key": {},
	          "value": {}
	        }
	      }
	    },
	    "Sy": {
	      "type": "list",
	      "member": {}
	    },
	    "S1x": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "key": {},
	          "value": {}
	        }
	      }
	    },
	    "S21": {
	      "type": "list",
	      "member": {
	        "shape": "S5"
	      }
	    },
	    "S2i": {
	      "type": "structure",
	      "required": [
	        "key"
	      ],
	      "members": {
	        "key": {},
	        "value": {}
	      }
	    },
	    "S3j": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "messageType",
	          "count"
	        ],
	        "members": {
	          "messageType": {},
	          "count": {
	            "type": "long"
	          },
	          "dataSize": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "S3x": {
	      "type": "list",
	      "member": {}
	    },
	    "S41": {
	      "type": "structure",
	      "members": {
	        "minSeconds": {
	          "type": "integer"
	        },
	        "maxSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "S42": {
	      "type": "list",
	      "member": {}
	    },
	    "S43": {
	      "type": "structure",
	      "members": {
	        "beginDate": {
	          "type": "timestamp"
	        },
	        "endDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S45": {
	      "type": "list",
	      "member": {}
	    },
	    "S4x": {
	      "type": "list",
	      "member": {
	        "shape": "S2i"
	      }
	    }
	  }
	}
	},{}],125:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "GetExclusionsPreview": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListAssessmentRunAgents": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListAssessmentRuns": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListAssessmentTargets": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListAssessmentTemplates": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListEventSubscriptions": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListExclusions": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListFindings": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListRulesPackages": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "PreviewAgents": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    }
	  }
	}
	
	},{}],126:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-05-28",
	    "endpointPrefix": "iot",
	    "protocol": "rest-json",
	    "serviceFullName": "AWS IoT",
	    "serviceId": "IoT",
	    "signatureVersion": "v4",
	    "signingName": "execute-api",
	    "uid": "iot-2015-05-28"
	  },
	  "operations": {
	    "AcceptCertificateTransfer": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/accept-certificate-transfer/{certificateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificateId"
	        ],
	        "members": {
	          "certificateId": {
	            "location": "uri",
	            "locationName": "certificateId"
	          },
	          "setAsActive": {
	            "location": "querystring",
	            "locationName": "setAsActive",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "AddThingToBillingGroup": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/billing-groups/addThingToBillingGroup"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "billingGroupName": {},
	          "billingGroupArn": {},
	          "thingName": {},
	          "thingArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AddThingToThingGroup": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/thing-groups/addThingToThingGroup"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "thingGroupName": {},
	          "thingGroupArn": {},
	          "thingName": {},
	          "thingArn": {},
	          "overrideDynamicGroups": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AssociateTargetsWithJob": {
	      "http": {
	        "requestUri": "/jobs/{jobId}/targets"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "targets",
	          "jobId"
	        ],
	        "members": {
	          "targets": {
	            "shape": "Sg"
	          },
	          "jobId": {
	            "location": "uri",
	            "locationName": "jobId"
	          },
	          "comment": {},
	          "namespaceId": {
	            "location": "querystring",
	            "locationName": "namespaceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobArn": {},
	          "jobId": {},
	          "description": {}
	        }
	      }
	    },
	    "AttachPolicy": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/target-policies/{policyName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName",
	          "target"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          },
	          "target": {}
	        }
	      }
	    },
	    "AttachPrincipalPolicy": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/principal-policies/{policyName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName",
	          "principal"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          },
	          "principal": {
	            "location": "header",
	            "locationName": "x-amzn-iot-principal"
	          }
	        }
	      },
	      "deprecated": true
	    },
	    "AttachSecurityProfile": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/security-profiles/{securityProfileName}/targets"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "securityProfileName",
	          "securityProfileTargetArn"
	        ],
	        "members": {
	          "securityProfileName": {
	            "location": "uri",
	            "locationName": "securityProfileName"
	          },
	          "securityProfileTargetArn": {
	            "location": "querystring",
	            "locationName": "securityProfileTargetArn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AttachThingPrincipal": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/things/{thingName}/principals"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName",
	          "principal"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "principal": {
	            "location": "header",
	            "locationName": "x-amzn-principal"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CancelAuditMitigationActionsTask": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/audit/mitigationactions/tasks/{taskId}/cancel"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId"
	        ],
	        "members": {
	          "taskId": {
	            "location": "uri",
	            "locationName": "taskId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CancelAuditTask": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/audit/tasks/{taskId}/cancel"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId"
	        ],
	        "members": {
	          "taskId": {
	            "location": "uri",
	            "locationName": "taskId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CancelCertificateTransfer": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/cancel-certificate-transfer/{certificateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificateId"
	        ],
	        "members": {
	          "certificateId": {
	            "location": "uri",
	            "locationName": "certificateId"
	          }
	        }
	      }
	    },
	    "CancelDetectMitigationActionsTask": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/detect/mitigationactions/tasks/{taskId}/cancel"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId"
	        ],
	        "members": {
	          "taskId": {
	            "location": "uri",
	            "locationName": "taskId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CancelJob": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/jobs/{jobId}/cancel"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId"
	        ],
	        "members": {
	          "jobId": {
	            "location": "uri",
	            "locationName": "jobId"
	          },
	          "reasonCode": {},
	          "comment": {},
	          "force": {
	            "location": "querystring",
	            "locationName": "force",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobArn": {},
	          "jobId": {},
	          "description": {}
	        }
	      }
	    },
	    "CancelJobExecution": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/things/{thingName}/jobs/{jobId}/cancel"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId",
	          "thingName"
	        ],
	        "members": {
	          "jobId": {
	            "location": "uri",
	            "locationName": "jobId"
	          },
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "force": {
	            "location": "querystring",
	            "locationName": "force",
	            "type": "boolean"
	          },
	          "expectedVersion": {
	            "type": "long"
	          },
	          "statusDetails": {
	            "shape": "S1e"
	          }
	        }
	      }
	    },
	    "ClearDefaultAuthorizer": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/default-authorizer"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ConfirmTopicRuleDestination": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/confirmdestination/{confirmationToken+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "confirmationToken"
	        ],
	        "members": {
	          "confirmationToken": {
	            "location": "uri",
	            "locationName": "confirmationToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateAuditSuppression": {
	      "http": {
	        "requestUri": "/audit/suppressions/create"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "checkName",
	          "resourceIdentifier",
	          "clientRequestToken"
	        ],
	        "members": {
	          "checkName": {},
	          "resourceIdentifier": {
	            "shape": "S1o"
	          },
	          "expirationDate": {
	            "type": "timestamp"
	          },
	          "suppressIndefinitely": {
	            "type": "boolean"
	          },
	          "description": {},
	          "clientRequestToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateAuthorizer": {
	      "http": {
	        "requestUri": "/authorizer/{authorizerName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "authorizerName",
	          "authorizerFunctionArn"
	        ],
	        "members": {
	          "authorizerName": {
	            "location": "uri",
	            "locationName": "authorizerName"
	          },
	          "authorizerFunctionArn": {},
	          "tokenKeyName": {},
	          "tokenSigningPublicKeys": {
	            "shape": "S25"
	          },
	          "status": {},
	          "tags": {
	            "shape": "S29"
	          },
	          "signingDisabled": {
	            "type": "boolean"
	          },
	          "enableCachingForHttp": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "authorizerName": {},
	          "authorizerArn": {}
	        }
	      }
	    },
	    "CreateBillingGroup": {
	      "http": {
	        "requestUri": "/billing-groups/{billingGroupName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "billingGroupName"
	        ],
	        "members": {
	          "billingGroupName": {
	            "location": "uri",
	            "locationName": "billingGroupName"
	          },
	          "billingGroupProperties": {
	            "shape": "S2i"
	          },
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "billingGroupName": {},
	          "billingGroupArn": {},
	          "billingGroupId": {}
	        }
	      }
	    },
	    "CreateCertificateFromCsr": {
	      "http": {
	        "requestUri": "/certificates"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificateSigningRequest"
	        ],
	        "members": {
	          "certificateSigningRequest": {},
	          "setAsActive": {
	            "location": "querystring",
	            "locationName": "setAsActive",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificateArn": {},
	          "certificateId": {},
	          "certificatePem": {}
	        }
	      }
	    },
	    "CreateCustomMetric": {
	      "http": {
	        "requestUri": "/custom-metric/{metricName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "metricName",
	          "metricType",
	          "clientRequestToken"
	        ],
	        "members": {
	          "metricName": {
	            "location": "uri",
	            "locationName": "metricName"
	          },
	          "displayName": {},
	          "metricType": {},
	          "tags": {
	            "shape": "S29"
	          },
	          "clientRequestToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "metricName": {},
	          "metricArn": {}
	        }
	      }
	    },
	    "CreateDimension": {
	      "http": {
	        "requestUri": "/dimensions/{name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "type",
	          "stringValues",
	          "clientRequestToken"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "type": {},
	          "stringValues": {
	            "shape": "S30"
	          },
	          "tags": {
	            "shape": "S29"
	          },
	          "clientRequestToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "arn": {}
	        }
	      }
	    },
	    "CreateDomainConfiguration": {
	      "http": {
	        "requestUri": "/domainConfigurations/{domainConfigurationName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainConfigurationName"
	        ],
	        "members": {
	          "domainConfigurationName": {
	            "location": "uri",
	            "locationName": "domainConfigurationName"
	          },
	          "domainName": {},
	          "serverCertificateArns": {
	            "type": "list",
	            "member": {}
	          },
	          "validationCertificateArn": {},
	          "authorizerConfig": {
	            "shape": "S39"
	          },
	          "serviceType": {},
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "domainConfigurationName": {},
	          "domainConfigurationArn": {}
	        }
	      }
	    },
	    "CreateDynamicThingGroup": {
	      "http": {
	        "requestUri": "/dynamic-thing-groups/{thingGroupName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingGroupName",
	          "queryString"
	        ],
	        "members": {
	          "thingGroupName": {
	            "location": "uri",
	            "locationName": "thingGroupName"
	          },
	          "thingGroupProperties": {
	            "shape": "S3f"
	          },
	          "indexName": {},
	          "queryString": {},
	          "queryVersion": {},
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "thingGroupName": {},
	          "thingGroupArn": {},
	          "thingGroupId": {},
	          "indexName": {},
	          "queryString": {},
	          "queryVersion": {}
	        }
	      }
	    },
	    "CreateFleetMetric": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/fleet-metric/{metricName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "metricName",
	          "queryString",
	          "aggregationType",
	          "period",
	          "aggregationField"
	        ],
	        "members": {
	          "metricName": {
	            "location": "uri",
	            "locationName": "metricName"
	          },
	          "queryString": {},
	          "aggregationType": {
	            "shape": "S3t"
	          },
	          "period": {
	            "type": "integer"
	          },
	          "aggregationField": {},
	          "description": {},
	          "queryVersion": {},
	          "indexName": {},
	          "unit": {},
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "metricName": {},
	          "metricArn": {}
	        }
	      }
	    },
	    "CreateJob": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/jobs/{jobId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId",
	          "targets"
	        ],
	        "members": {
	          "jobId": {
	            "location": "uri",
	            "locationName": "jobId"
	          },
	          "targets": {
	            "shape": "Sg"
	          },
	          "documentSource": {},
	          "document": {},
	          "description": {},
	          "presignedUrlConfig": {
	            "shape": "S46"
	          },
	          "targetSelection": {},
	          "jobExecutionsRolloutConfig": {
	            "shape": "S49"
	          },
	          "abortConfig": {
	            "shape": "S4g"
	          },
	          "timeoutConfig": {
	            "shape": "S4n"
	          },
	          "tags": {
	            "shape": "S29"
	          },
	          "namespaceId": {},
	          "jobTemplateArn": {},
	          "jobExecutionsRetryConfig": {
	            "shape": "S4q"
	          },
	          "documentParameters": {
	            "shape": "S4v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobArn": {},
	          "jobId": {},
	          "description": {}
	        }
	      }
	    },
	    "CreateJobTemplate": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/job-templates/{jobTemplateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobTemplateId",
	          "description"
	        ],
	        "members": {
	          "jobTemplateId": {
	            "location": "uri",
	            "locationName": "jobTemplateId"
	          },
	          "jobArn": {},
	          "documentSource": {},
	          "document": {},
	          "description": {},
	          "presignedUrlConfig": {
	            "shape": "S46"
	          },
	          "jobExecutionsRolloutConfig": {
	            "shape": "S49"
	          },
	          "abortConfig": {
	            "shape": "S4g"
	          },
	          "timeoutConfig": {
	            "shape": "S4n"
	          },
	          "tags": {
	            "shape": "S29"
	          },
	          "jobExecutionsRetryConfig": {
	            "shape": "S4q"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobTemplateArn": {},
	          "jobTemplateId": {}
	        }
	      }
	    },
	    "CreateKeysAndCertificate": {
	      "http": {
	        "requestUri": "/keys-and-certificate"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "setAsActive": {
	            "location": "querystring",
	            "locationName": "setAsActive",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificateArn": {},
	          "certificateId": {},
	          "certificatePem": {},
	          "keyPair": {
	            "shape": "S54"
	          }
	        }
	      }
	    },
	    "CreateMitigationAction": {
	      "http": {
	        "requestUri": "/mitigationactions/actions/{actionName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "actionName",
	          "roleArn",
	          "actionParams"
	        ],
	        "members": {
	          "actionName": {
	            "location": "uri",
	            "locationName": "actionName"
	          },
	          "roleArn": {},
	          "actionParams": {
	            "shape": "S59"
	          },
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "actionArn": {},
	          "actionId": {}
	        }
	      }
	    },
	    "CreateOTAUpdate": {
	      "http": {
	        "requestUri": "/otaUpdates/{otaUpdateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "otaUpdateId",
	          "targets",
	          "files",
	          "roleArn"
	        ],
	        "members": {
	          "otaUpdateId": {
	            "location": "uri",
	            "locationName": "otaUpdateId"
	          },
	          "description": {},
	          "targets": {
	            "shape": "S5t"
	          },
	          "protocols": {
	            "shape": "S5v"
	          },
	          "targetSelection": {},
	          "awsJobExecutionsRolloutConfig": {
	            "shape": "S5x"
	          },
	          "awsJobPresignedUrlConfig": {
	            "shape": "S64"
	          },
	          "awsJobAbortConfig": {
	            "type": "structure",
	            "required": [
	              "abortCriteriaList"
	            ],
	            "members": {
	              "abortCriteriaList": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "failureType",
	                    "action",
	                    "thresholdPercentage",
	                    "minNumberOfExecutedThings"
	                  ],
	                  "members": {
	                    "failureType": {},
	                    "action": {},
	                    "thresholdPercentage": {
	                      "type": "double"
	                    },
	                    "minNumberOfExecutedThings": {
	                      "type": "integer"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "awsJobTimeoutConfig": {
	            "type": "structure",
	            "members": {
	              "inProgressTimeoutInMinutes": {
	                "type": "long"
	              }
	            }
	          },
	          "files": {
	            "shape": "S6f"
	          },
	          "roleArn": {},
	          "additionalParameters": {
	            "shape": "S7d"
	          },
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "otaUpdateId": {},
	          "awsIotJobId": {},
	          "otaUpdateArn": {},
	          "awsIotJobArn": {},
	          "otaUpdateStatus": {}
	        }
	      }
	    },
	    "CreatePolicy": {
	      "http": {
	        "requestUri": "/policies/{policyName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName",
	          "policyDocument"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          },
	          "policyDocument": {},
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "policyName": {},
	          "policyArn": {},
	          "policyDocument": {},
	          "policyVersionId": {}
	        }
	      }
	    },
	    "CreatePolicyVersion": {
	      "http": {
	        "requestUri": "/policies/{policyName}/version"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName",
	          "policyDocument"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          },
	          "policyDocument": {},
	          "setAsDefault": {
	            "location": "querystring",
	            "locationName": "setAsDefault",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "policyArn": {},
	          "policyDocument": {},
	          "policyVersionId": {},
	          "isDefaultVersion": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "CreateProvisioningClaim": {
	      "http": {
	        "requestUri": "/provisioning-templates/{templateName}/provisioning-claim"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateName"
	        ],
	        "members": {
	          "templateName": {
	            "location": "uri",
	            "locationName": "templateName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificateId": {},
	          "certificatePem": {},
	          "keyPair": {
	            "shape": "S54"
	          },
	          "expiration": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "CreateProvisioningTemplate": {
	      "http": {
	        "requestUri": "/provisioning-templates"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateName",
	          "templateBody",
	          "provisioningRoleArn"
	        ],
	        "members": {
	          "templateName": {},
	          "description": {},
	          "templateBody": {},
	          "enabled": {
	            "type": "boolean"
	          },
	          "provisioningRoleArn": {},
	          "preProvisioningHook": {
	            "shape": "S7z"
	          },
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "templateArn": {},
	          "templateName": {},
	          "defaultVersionId": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "CreateProvisioningTemplateVersion": {
	      "http": {
	        "requestUri": "/provisioning-templates/{templateName}/versions"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateName",
	          "templateBody"
	        ],
	        "members": {
	          "templateName": {
	            "location": "uri",
	            "locationName": "templateName"
	          },
	          "templateBody": {},
	          "setAsDefault": {
	            "location": "querystring",
	            "locationName": "setAsDefault",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "templateArn": {},
	          "templateName": {},
	          "versionId": {
	            "type": "integer"
	          },
	          "isDefaultVersion": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "CreateRoleAlias": {
	      "http": {
	        "requestUri": "/role-aliases/{roleAlias}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "roleAlias",
	          "roleArn"
	        ],
	        "members": {
	          "roleAlias": {
	            "location": "uri",
	            "locationName": "roleAlias"
	          },
	          "roleArn": {},
	          "credentialDurationSeconds": {
	            "type": "integer"
	          },
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "roleAlias": {},
	          "roleAliasArn": {}
	        }
	      }
	    },
	    "CreateScheduledAudit": {
	      "http": {
	        "requestUri": "/audit/scheduledaudits/{scheduledAuditName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "frequency",
	          "targetCheckNames",
	          "scheduledAuditName"
	        ],
	        "members": {
	          "frequency": {},
	          "dayOfMonth": {},
	          "dayOfWeek": {},
	          "targetCheckNames": {
	            "shape": "S8e"
	          },
	          "scheduledAuditName": {
	            "location": "uri",
	            "locationName": "scheduledAuditName"
	          },
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "scheduledAuditArn": {}
	        }
	      }
	    },
	    "CreateSecurityProfile": {
	      "http": {
	        "requestUri": "/security-profiles/{securityProfileName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "securityProfileName"
	        ],
	        "members": {
	          "securityProfileName": {
	            "location": "uri",
	            "locationName": "securityProfileName"
	          },
	          "securityProfileDescription": {},
	          "behaviors": {
	            "shape": "S8k"
	          },
	          "alertTargets": {
	            "shape": "S9a"
	          },
	          "additionalMetricsToRetain": {
	            "shape": "S9e",
	            "deprecated": true,
	            "deprecatedMessage": "Use additionalMetricsToRetainV2."
	          },
	          "additionalMetricsToRetainV2": {
	            "shape": "S9f"
	          },
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "securityProfileName": {},
	          "securityProfileArn": {}
	        }
	      }
	    },
	    "CreateStream": {
	      "http": {
	        "requestUri": "/streams/{streamId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "streamId",
	          "files",
	          "roleArn"
	        ],
	        "members": {
	          "streamId": {
	            "location": "uri",
	            "locationName": "streamId"
	          },
	          "description": {},
	          "files": {
	            "shape": "S9l"
	          },
	          "roleArn": {},
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "streamId": {},
	          "streamArn": {},
	          "description": {},
	          "streamVersion": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "CreateThing": {
	      "http": {
	        "requestUri": "/things/{thingName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "thingTypeName": {},
	          "attributePayload": {
	            "shape": "S3h"
	          },
	          "billingGroupName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "thingName": {},
	          "thingArn": {},
	          "thingId": {}
	        }
	      }
	    },
	    "CreateThingGroup": {
	      "http": {
	        "requestUri": "/thing-groups/{thingGroupName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingGroupName"
	        ],
	        "members": {
	          "thingGroupName": {
	            "location": "uri",
	            "locationName": "thingGroupName"
	          },
	          "parentGroupName": {},
	          "thingGroupProperties": {
	            "shape": "S3f"
	          },
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "thingGroupName": {},
	          "thingGroupArn": {},
	          "thingGroupId": {}
	        }
	      }
	    },
	    "CreateThingType": {
	      "http": {
	        "requestUri": "/thing-types/{thingTypeName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingTypeName"
	        ],
	        "members": {
	          "thingTypeName": {
	            "location": "uri",
	            "locationName": "thingTypeName"
	          },
	          "thingTypeProperties": {
	            "shape": "S9x"
	          },
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "thingTypeName": {},
	          "thingTypeArn": {},
	          "thingTypeId": {}
	        }
	      }
	    },
	    "CreateTopicRule": {
	      "http": {
	        "requestUri": "/rules/{ruleName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ruleName",
	          "topicRulePayload"
	        ],
	        "members": {
	          "ruleName": {
	            "location": "uri",
	            "locationName": "ruleName"
	          },
	          "topicRulePayload": {
	            "shape": "Sa5"
	          },
	          "tags": {
	            "location": "header",
	            "locationName": "x-amz-tagging"
	          }
	        },
	        "payload": "topicRulePayload"
	      }
	    },
	    "CreateTopicRuleDestination": {
	      "http": {
	        "requestUri": "/destinations"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "destinationConfiguration"
	        ],
	        "members": {
	          "destinationConfiguration": {
	            "type": "structure",
	            "members": {
	              "httpUrlConfiguration": {
	                "type": "structure",
	                "required": [
	                  "confirmationUrl"
	                ],
	                "members": {
	                  "confirmationUrl": {}
	                }
	              },
	              "vpcConfiguration": {
	                "type": "structure",
	                "required": [
	                  "subnetIds",
	                  "vpcId",
	                  "roleArn"
	                ],
	                "members": {
	                  "subnetIds": {
	                    "shape": "Sd6"
	                  },
	                  "securityGroups": {
	                    "shape": "Sd8"
	                  },
	                  "vpcId": {},
	                  "roleArn": {}
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "topicRuleDestination": {
	            "shape": "Sdc"
	          }
	        }
	      }
	    },
	    "DeleteAccountAuditConfiguration": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/audit/configuration"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "deleteScheduledAudits": {
	            "location": "querystring",
	            "locationName": "deleteScheduledAudits",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteAuditSuppression": {
	      "http": {
	        "requestUri": "/audit/suppressions/delete"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "checkName",
	          "resourceIdentifier"
	        ],
	        "members": {
	          "checkName": {},
	          "resourceIdentifier": {
	            "shape": "S1o"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteAuthorizer": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/authorizer/{authorizerName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "authorizerName"
	        ],
	        "members": {
	          "authorizerName": {
	            "location": "uri",
	            "locationName": "authorizerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteBillingGroup": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/billing-groups/{billingGroupName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "billingGroupName"
	        ],
	        "members": {
	          "billingGroupName": {
	            "location": "uri",
	            "locationName": "billingGroupName"
	          },
	          "expectedVersion": {
	            "location": "querystring",
	            "locationName": "expectedVersion",
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteCACertificate": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/cacertificate/{caCertificateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificateId"
	        ],
	        "members": {
	          "certificateId": {
	            "location": "uri",
	            "locationName": "caCertificateId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteCertificate": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/certificates/{certificateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificateId"
	        ],
	        "members": {
	          "certificateId": {
	            "location": "uri",
	            "locationName": "certificateId"
	          },
	          "forceDelete": {
	            "location": "querystring",
	            "locationName": "forceDelete",
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteCustomMetric": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/custom-metric/{metricName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "metricName"
	        ],
	        "members": {
	          "metricName": {
	            "location": "uri",
	            "locationName": "metricName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteDimension": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/dimensions/{name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteDomainConfiguration": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/domainConfigurations/{domainConfigurationName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainConfigurationName"
	        ],
	        "members": {
	          "domainConfigurationName": {
	            "location": "uri",
	            "locationName": "domainConfigurationName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteDynamicThingGroup": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/dynamic-thing-groups/{thingGroupName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingGroupName"
	        ],
	        "members": {
	          "thingGroupName": {
	            "location": "uri",
	            "locationName": "thingGroupName"
	          },
	          "expectedVersion": {
	            "location": "querystring",
	            "locationName": "expectedVersion",
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteFleetMetric": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/fleet-metric/{metricName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "metricName"
	        ],
	        "members": {
	          "metricName": {
	            "location": "uri",
	            "locationName": "metricName"
	          },
	          "expectedVersion": {
	            "location": "querystring",
	            "locationName": "expectedVersion",
	            "type": "long"
	          }
	        }
	      }
	    },
	    "DeleteJob": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/jobs/{jobId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId"
	        ],
	        "members": {
	          "jobId": {
	            "location": "uri",
	            "locationName": "jobId"
	          },
	          "force": {
	            "location": "querystring",
	            "locationName": "force",
	            "type": "boolean"
	          },
	          "namespaceId": {
	            "location": "querystring",
	            "locationName": "namespaceId"
	          }
	        }
	      }
	    },
	    "DeleteJobExecution": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/things/{thingName}/jobs/{jobId}/executionNumber/{executionNumber}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId",
	          "thingName",
	          "executionNumber"
	        ],
	        "members": {
	          "jobId": {
	            "location": "uri",
	            "locationName": "jobId"
	          },
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "executionNumber": {
	            "location": "uri",
	            "locationName": "executionNumber",
	            "type": "long"
	          },
	          "force": {
	            "location": "querystring",
	            "locationName": "force",
	            "type": "boolean"
	          },
	          "namespaceId": {
	            "location": "querystring",
	            "locationName": "namespaceId"
	          }
	        }
	      }
	    },
	    "DeleteJobTemplate": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/job-templates/{jobTemplateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobTemplateId"
	        ],
	        "members": {
	          "jobTemplateId": {
	            "location": "uri",
	            "locationName": "jobTemplateId"
	          }
	        }
	      }
	    },
	    "DeleteMitigationAction": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/mitigationactions/actions/{actionName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "actionName"
	        ],
	        "members": {
	          "actionName": {
	            "location": "uri",
	            "locationName": "actionName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteOTAUpdate": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/otaUpdates/{otaUpdateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "otaUpdateId"
	        ],
	        "members": {
	          "otaUpdateId": {
	            "location": "uri",
	            "locationName": "otaUpdateId"
	          },
	          "deleteStream": {
	            "location": "querystring",
	            "locationName": "deleteStream",
	            "type": "boolean"
	          },
	          "forceDeleteAWSJob": {
	            "location": "querystring",
	            "locationName": "forceDeleteAWSJob",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeletePolicy": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/policies/{policyName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          }
	        }
	      }
	    },
	    "DeletePolicyVersion": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/policies/{policyName}/version/{policyVersionId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName",
	          "policyVersionId"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          },
	          "policyVersionId": {
	            "location": "uri",
	            "locationName": "policyVersionId"
	          }
	        }
	      }
	    },
	    "DeleteProvisioningTemplate": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/provisioning-templates/{templateName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateName"
	        ],
	        "members": {
	          "templateName": {
	            "location": "uri",
	            "locationName": "templateName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteProvisioningTemplateVersion": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/provisioning-templates/{templateName}/versions/{versionId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateName",
	          "versionId"
	        ],
	        "members": {
	          "templateName": {
	            "location": "uri",
	            "locationName": "templateName"
	          },
	          "versionId": {
	            "location": "uri",
	            "locationName": "versionId",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteRegistrationCode": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/registrationcode"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteRoleAlias": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/role-aliases/{roleAlias}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "roleAlias"
	        ],
	        "members": {
	          "roleAlias": {
	            "location": "uri",
	            "locationName": "roleAlias"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteScheduledAudit": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/audit/scheduledaudits/{scheduledAuditName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "scheduledAuditName"
	        ],
	        "members": {
	          "scheduledAuditName": {
	            "location": "uri",
	            "locationName": "scheduledAuditName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteSecurityProfile": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/security-profiles/{securityProfileName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "securityProfileName"
	        ],
	        "members": {
	          "securityProfileName": {
	            "location": "uri",
	            "locationName": "securityProfileName"
	          },
	          "expectedVersion": {
	            "location": "querystring",
	            "locationName": "expectedVersion",
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteStream": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/streams/{streamId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "streamId"
	        ],
	        "members": {
	          "streamId": {
	            "location": "uri",
	            "locationName": "streamId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteThing": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/things/{thingName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "expectedVersion": {
	            "location": "querystring",
	            "locationName": "expectedVersion",
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteThingGroup": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/thing-groups/{thingGroupName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingGroupName"
	        ],
	        "members": {
	          "thingGroupName": {
	            "location": "uri",
	            "locationName": "thingGroupName"
	          },
	          "expectedVersion": {
	            "location": "querystring",
	            "locationName": "expectedVersion",
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteThingType": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/thing-types/{thingTypeName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingTypeName"
	        ],
	        "members": {
	          "thingTypeName": {
	            "location": "uri",
	            "locationName": "thingTypeName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteTopicRule": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/rules/{ruleName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ruleName"
	        ],
	        "members": {
	          "ruleName": {
	            "location": "uri",
	            "locationName": "ruleName"
	          }
	        }
	      }
	    },
	    "DeleteTopicRuleDestination": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/destinations/{arn+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {
	            "location": "uri",
	            "locationName": "arn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteV2LoggingLevel": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/v2LoggingLevel"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "targetType",
	          "targetName"
	        ],
	        "members": {
	          "targetType": {
	            "location": "querystring",
	            "locationName": "targetType"
	          },
	          "targetName": {
	            "location": "querystring",
	            "locationName": "targetName"
	          }
	        }
	      }
	    },
	    "DeprecateThingType": {
	      "http": {
	        "requestUri": "/thing-types/{thingTypeName}/deprecate"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingTypeName"
	        ],
	        "members": {
	          "thingTypeName": {
	            "location": "uri",
	            "locationName": "thingTypeName"
	          },
	          "undoDeprecate": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeAccountAuditConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/audit/configuration"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "roleArn": {},
	          "auditNotificationTargetConfigurations": {
	            "shape": "Sfc"
	          },
	          "auditCheckConfigurations": {
	            "shape": "Sff"
	          }
	        }
	      }
	    },
	    "DescribeAuditFinding": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/audit/findings/{findingId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "findingId"
	        ],
	        "members": {
	          "findingId": {
	            "location": "uri",
	            "locationName": "findingId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "finding": {
	            "shape": "Sfk"
	          }
	        }
	      }
	    },
	    "DescribeAuditMitigationActionsTask": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/audit/mitigationactions/tasks/{taskId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId"
	        ],
	        "members": {
	          "taskId": {
	            "location": "uri",
	            "locationName": "taskId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskStatus": {},
	          "startTime": {
	            "type": "timestamp"
	          },
	          "endTime": {
	            "type": "timestamp"
	          },
	          "taskStatistics": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "members": {
	                "totalFindingsCount": {
	                  "type": "long"
	                },
	                "failedFindingsCount": {
	                  "type": "long"
	                },
	                "succeededFindingsCount": {
	                  "type": "long"
	                },
	                "skippedFindingsCount": {
	                  "type": "long"
	                },
	                "canceledFindingsCount": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "target": {
	            "shape": "Sg4"
	          },
	          "auditCheckToActionsMapping": {
	            "shape": "Sg8"
	          },
	          "actionsDefinition": {
	            "shape": "Sga"
	          }
	        }
	      }
	    },
	    "DescribeAuditSuppression": {
	      "http": {
	        "requestUri": "/audit/suppressions/describe"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "checkName",
	          "resourceIdentifier"
	        ],
	        "members": {
	          "checkName": {},
	          "resourceIdentifier": {
	            "shape": "S1o"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "checkName": {},
	          "resourceIdentifier": {
	            "shape": "S1o"
	          },
	          "expirationDate": {
	            "type": "timestamp"
	          },
	          "suppressIndefinitely": {
	            "type": "boolean"
	          },
	          "description": {}
	        }
	      }
	    },
	    "DescribeAuditTask": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/audit/tasks/{taskId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId"
	        ],
	        "members": {
	          "taskId": {
	            "location": "uri",
	            "locationName": "taskId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskStatus": {},
	          "taskType": {},
	          "taskStartTime": {
	            "type": "timestamp"
	          },
	          "taskStatistics": {
	            "type": "structure",
	            "members": {
	              "totalChecks": {
	                "type": "integer"
	              },
	              "inProgressChecks": {
	                "type": "integer"
	              },
	              "waitingForDataCollectionChecks": {
	                "type": "integer"
	              },
	              "compliantChecks": {
	                "type": "integer"
	              },
	              "nonCompliantChecks": {
	                "type": "integer"
	              },
	              "failedChecks": {
	                "type": "integer"
	              },
	              "canceledChecks": {
	                "type": "integer"
	              }
	            }
	          },
	          "scheduledAuditName": {},
	          "auditDetails": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "structure",
	              "members": {
	                "checkRunStatus": {},
	                "checkCompliant": {
	                  "type": "boolean"
	                },
	                "totalResourcesCount": {
	                  "type": "long"
	                },
	                "nonCompliantResourcesCount": {
	                  "type": "long"
	                },
	                "suppressedNonCompliantResourcesCount": {
	                  "type": "long"
	                },
	                "errorCode": {},
	                "message": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeAuthorizer": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/authorizer/{authorizerName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "authorizerName"
	        ],
	        "members": {
	          "authorizerName": {
	            "location": "uri",
	            "locationName": "authorizerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "authorizerDescription": {
	            "shape": "Sh1"
	          }
	        }
	      }
	    },
	    "DescribeBillingGroup": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/billing-groups/{billingGroupName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "billingGroupName"
	        ],
	        "members": {
	          "billingGroupName": {
	            "location": "uri",
	            "locationName": "billingGroupName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "billingGroupName": {},
	          "billingGroupId": {},
	          "billingGroupArn": {},
	          "version": {
	            "type": "long"
	          },
	          "billingGroupProperties": {
	            "shape": "S2i"
	          },
	          "billingGroupMetadata": {
	            "type": "structure",
	            "members": {
	              "creationDate": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeCACertificate": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/cacertificate/{caCertificateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificateId"
	        ],
	        "members": {
	          "certificateId": {
	            "location": "uri",
	            "locationName": "caCertificateId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificateDescription": {
	            "type": "structure",
	            "members": {
	              "certificateArn": {},
	              "certificateId": {},
	              "status": {},
	              "certificatePem": {},
	              "ownedBy": {},
	              "creationDate": {
	                "type": "timestamp"
	              },
	              "autoRegistrationStatus": {},
	              "lastModifiedDate": {
	                "type": "timestamp"
	              },
	              "customerVersion": {
	                "type": "integer"
	              },
	              "generationId": {},
	              "validity": {
	                "shape": "She"
	              }
	            }
	          },
	          "registrationConfig": {
	            "shape": "Shf"
	          }
	        }
	      }
	    },
	    "DescribeCertificate": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/certificates/{certificateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificateId"
	        ],
	        "members": {
	          "certificateId": {
	            "location": "uri",
	            "locationName": "certificateId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificateDescription": {
	            "type": "structure",
	            "members": {
	              "certificateArn": {},
	              "certificateId": {},
	              "caCertificateId": {},
	              "status": {},
	              "certificatePem": {},
	              "ownedBy": {},
	              "previousOwnedBy": {},
	              "creationDate": {
	                "type": "timestamp"
	              },
	              "lastModifiedDate": {
	                "type": "timestamp"
	              },
	              "customerVersion": {
	                "type": "integer"
	              },
	              "transferData": {
	                "type": "structure",
	                "members": {
	                  "transferMessage": {},
	                  "rejectReason": {},
	                  "transferDate": {
	                    "type": "timestamp"
	                  },
	                  "acceptDate": {
	                    "type": "timestamp"
	                  },
	                  "rejectDate": {
	                    "type": "timestamp"
	                  }
	                }
	              },
	              "generationId": {},
	              "validity": {
	                "shape": "She"
	              },
	              "certificateMode": {}
	            }
	          }
	        }
	      }
	    },
	    "DescribeCustomMetric": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/custom-metric/{metricName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "metricName"
	        ],
	        "members": {
	          "metricName": {
	            "location": "uri",
	            "locationName": "metricName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "metricName": {},
	          "metricArn": {},
	          "metricType": {},
	          "displayName": {},
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeDefaultAuthorizer": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/default-authorizer"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "authorizerDescription": {
	            "shape": "Sh1"
	          }
	        }
	      }
	    },
	    "DescribeDetectMitigationActionsTask": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/detect/mitigationactions/tasks/{taskId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId"
	        ],
	        "members": {
	          "taskId": {
	            "location": "uri",
	            "locationName": "taskId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskSummary": {
	            "shape": "Sht"
	          }
	        }
	      }
	    },
	    "DescribeDimension": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/dimensions/{name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "arn": {},
	          "type": {},
	          "stringValues": {
	            "shape": "S30"
	          },
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeDomainConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/domainConfigurations/{domainConfigurationName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainConfigurationName"
	        ],
	        "members": {
	          "domainConfigurationName": {
	            "location": "uri",
	            "locationName": "domainConfigurationName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "domainConfigurationName": {},
	          "domainConfigurationArn": {},
	          "domainName": {},
	          "serverCertificates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "serverCertificateArn": {},
	                "serverCertificateStatus": {},
	                "serverCertificateStatusDetail": {}
	              }
	            }
	          },
	          "authorizerConfig": {
	            "shape": "S39"
	          },
	          "domainConfigurationStatus": {},
	          "serviceType": {},
	          "domainType": {},
	          "lastStatusChangeDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeEndpoint": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/endpoint"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "endpointType": {
	            "location": "querystring",
	            "locationName": "endpointType"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "endpointAddress": {}
	        }
	      }
	    },
	    "DescribeEventConfigurations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/event-configurations"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "eventConfigurations": {
	            "shape": "Sij"
	          },
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeFleetMetric": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/fleet-metric/{metricName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "metricName"
	        ],
	        "members": {
	          "metricName": {
	            "location": "uri",
	            "locationName": "metricName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "metricName": {},
	          "queryString": {},
	          "aggregationType": {
	            "shape": "S3t"
	          },
	          "period": {
	            "type": "integer"
	          },
	          "aggregationField": {},
	          "description": {},
	          "queryVersion": {},
	          "indexName": {},
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          },
	          "unit": {},
	          "version": {
	            "type": "long"
	          },
	          "metricArn": {}
	        }
	      }
	    },
	    "DescribeIndex": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/indices/{indexName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "indexName"
	        ],
	        "members": {
	          "indexName": {
	            "location": "uri",
	            "locationName": "indexName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "indexName": {},
	          "indexStatus": {},
	          "schema": {}
	        }
	      }
	    },
	    "DescribeJob": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/jobs/{jobId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId"
	        ],
	        "members": {
	          "jobId": {
	            "location": "uri",
	            "locationName": "jobId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "documentSource": {},
	          "job": {
	            "type": "structure",
	            "members": {
	              "jobArn": {},
	              "jobId": {},
	              "targetSelection": {},
	              "status": {},
	              "forceCanceled": {
	                "type": "boolean"
	              },
	              "reasonCode": {},
	              "comment": {},
	              "targets": {
	                "shape": "Sg"
	              },
	              "description": {},
	              "presignedUrlConfig": {
	                "shape": "S46"
	              },
	              "jobExecutionsRolloutConfig": {
	                "shape": "S49"
	              },
	              "abortConfig": {
	                "shape": "S4g"
	              },
	              "createdAt": {
	                "type": "timestamp"
	              },
	              "lastUpdatedAt": {
	                "type": "timestamp"
	              },
	              "completedAt": {
	                "type": "timestamp"
	              },
	              "jobProcessDetails": {
	                "type": "structure",
	                "members": {
	                  "processingTargets": {
	                    "type": "list",
	                    "member": {}
	                  },
	                  "numberOfCanceledThings": {
	                    "type": "integer"
	                  },
	                  "numberOfSucceededThings": {
	                    "type": "integer"
	                  },
	                  "numberOfFailedThings": {
	                    "type": "integer"
	                  },
	                  "numberOfRejectedThings": {
	                    "type": "integer"
	                  },
	                  "numberOfQueuedThings": {
	                    "type": "integer"
	                  },
	                  "numberOfInProgressThings": {
	                    "type": "integer"
	                  },
	                  "numberOfRemovedThings": {
	                    "type": "integer"
	                  },
	                  "numberOfTimedOutThings": {
	                    "type": "integer"
	                  }
	                }
	              },
	              "timeoutConfig": {
	                "shape": "S4n"
	              },
	              "namespaceId": {},
	              "jobTemplateArn": {},
	              "jobExecutionsRetryConfig": {
	                "shape": "S4q"
	              },
	              "documentParameters": {
	                "shape": "S4v"
	              },
	              "isConcurrent": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeJobExecution": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/things/{thingName}/jobs/{jobId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId",
	          "thingName"
	        ],
	        "members": {
	          "jobId": {
	            "location": "uri",
	            "locationName": "jobId"
	          },
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "executionNumber": {
	            "location": "querystring",
	            "locationName": "executionNumber",
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "execution": {
	            "type": "structure",
	            "members": {
	              "jobId": {},
	              "status": {},
	              "forceCanceled": {
	                "type": "boolean"
	              },
	              "statusDetails": {
	                "type": "structure",
	                "members": {
	                  "detailsMap": {
	                    "shape": "S1e"
	                  }
	                }
	              },
	              "thingArn": {},
	              "queuedAt": {
	                "type": "timestamp"
	              },
	              "startedAt": {
	                "type": "timestamp"
	              },
	              "lastUpdatedAt": {
	                "type": "timestamp"
	              },
	              "executionNumber": {
	                "type": "long"
	              },
	              "versionNumber": {
	                "type": "long"
	              },
	              "approximateSecondsBeforeTimedOut": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeJobTemplate": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/job-templates/{jobTemplateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobTemplateId"
	        ],
	        "members": {
	          "jobTemplateId": {
	            "location": "uri",
	            "locationName": "jobTemplateId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobTemplateArn": {},
	          "jobTemplateId": {},
	          "description": {},
	          "documentSource": {},
	          "document": {},
	          "createdAt": {
	            "type": "timestamp"
	          },
	          "presignedUrlConfig": {
	            "shape": "S46"
	          },
	          "jobExecutionsRolloutConfig": {
	            "shape": "S49"
	          },
	          "abortConfig": {
	            "shape": "S4g"
	          },
	          "timeoutConfig": {
	            "shape": "S4n"
	          },
	          "jobExecutionsRetryConfig": {
	            "shape": "S4q"
	          }
	        }
	      }
	    },
	    "DescribeManagedJobTemplate": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/managed-job-templates/{templateName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateName"
	        ],
	        "members": {
	          "templateName": {
	            "location": "uri",
	            "locationName": "templateName"
	          },
	          "templateVersion": {
	            "location": "querystring",
	            "locationName": "templateVersion"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "templateName": {},
	          "templateArn": {},
	          "description": {},
	          "templateVersion": {},
	          "environments": {
	            "shape": "Sjn"
	          },
	          "documentParameters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "key": {},
	                "description": {},
	                "regex": {},
	                "example": {},
	                "optional": {
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "document": {}
	        }
	      }
	    },
	    "DescribeMitigationAction": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/mitigationactions/actions/{actionName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "actionName"
	        ],
	        "members": {
	          "actionName": {
	            "location": "uri",
	            "locationName": "actionName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "actionName": {},
	          "actionType": {},
	          "actionArn": {},
	          "actionId": {},
	          "roleArn": {},
	          "actionParams": {
	            "shape": "S59"
	          },
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeProvisioningTemplate": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/provisioning-templates/{templateName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateName"
	        ],
	        "members": {
	          "templateName": {
	            "location": "uri",
	            "locationName": "templateName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "templateArn": {},
	          "templateName": {},
	          "description": {},
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          },
	          "defaultVersionId": {
	            "type": "integer"
	          },
	          "templateBody": {},
	          "enabled": {
	            "type": "boolean"
	          },
	          "provisioningRoleArn": {},
	          "preProvisioningHook": {
	            "shape": "S7z"
	          }
	        }
	      }
	    },
	    "DescribeProvisioningTemplateVersion": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/provisioning-templates/{templateName}/versions/{versionId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateName",
	          "versionId"
	        ],
	        "members": {
	          "templateName": {
	            "location": "uri",
	            "locationName": "templateName"
	          },
	          "versionId": {
	            "location": "uri",
	            "locationName": "versionId",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "versionId": {
	            "type": "integer"
	          },
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "templateBody": {},
	          "isDefaultVersion": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DescribeRoleAlias": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/role-aliases/{roleAlias}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "roleAlias"
	        ],
	        "members": {
	          "roleAlias": {
	            "location": "uri",
	            "locationName": "roleAlias"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "roleAliasDescription": {
	            "type": "structure",
	            "members": {
	              "roleAlias": {},
	              "roleAliasArn": {},
	              "roleArn": {},
	              "owner": {},
	              "credentialDurationSeconds": {
	                "type": "integer"
	              },
	              "creationDate": {
	                "type": "timestamp"
	              },
	              "lastModifiedDate": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeScheduledAudit": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/audit/scheduledaudits/{scheduledAuditName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "scheduledAuditName"
	        ],
	        "members": {
	          "scheduledAuditName": {
	            "location": "uri",
	            "locationName": "scheduledAuditName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "frequency": {},
	          "dayOfMonth": {},
	          "dayOfWeek": {},
	          "targetCheckNames": {
	            "shape": "S8e"
	          },
	          "scheduledAuditName": {},
	          "scheduledAuditArn": {}
	        }
	      }
	    },
	    "DescribeSecurityProfile": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/security-profiles/{securityProfileName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "securityProfileName"
	        ],
	        "members": {
	          "securityProfileName": {
	            "location": "uri",
	            "locationName": "securityProfileName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "securityProfileName": {},
	          "securityProfileArn": {},
	          "securityProfileDescription": {},
	          "behaviors": {
	            "shape": "S8k"
	          },
	          "alertTargets": {
	            "shape": "S9a"
	          },
	          "additionalMetricsToRetain": {
	            "shape": "S9e",
	            "deprecated": true,
	            "deprecatedMessage": "Use additionalMetricsToRetainV2."
	          },
	          "additionalMetricsToRetainV2": {
	            "shape": "S9f"
	          },
	          "version": {
	            "type": "long"
	          },
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeStream": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/streams/{streamId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "streamId"
	        ],
	        "members": {
	          "streamId": {
	            "location": "uri",
	            "locationName": "streamId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "streamInfo": {
	            "type": "structure",
	            "members": {
	              "streamId": {},
	              "streamArn": {},
	              "streamVersion": {
	                "type": "integer"
	              },
	              "description": {},
	              "files": {
	                "shape": "S9l"
	              },
	              "createdAt": {
	                "type": "timestamp"
	              },
	              "lastUpdatedAt": {
	                "type": "timestamp"
	              },
	              "roleArn": {}
	            }
	          }
	        }
	      }
	    },
	    "DescribeThing": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/things/{thingName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "defaultClientId": {},
	          "thingName": {},
	          "thingId": {},
	          "thingArn": {},
	          "thingTypeName": {},
	          "attributes": {
	            "shape": "S3i"
	          },
	          "version": {
	            "type": "long"
	          },
	          "billingGroupName": {}
	        }
	      }
	    },
	    "DescribeThingGroup": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/thing-groups/{thingGroupName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingGroupName"
	        ],
	        "members": {
	          "thingGroupName": {
	            "location": "uri",
	            "locationName": "thingGroupName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "thingGroupName": {},
	          "thingGroupId": {},
	          "thingGroupArn": {},
	          "version": {
	            "type": "long"
	          },
	          "thingGroupProperties": {
	            "shape": "S3f"
	          },
	          "thingGroupMetadata": {
	            "type": "structure",
	            "members": {
	              "parentGroupName": {},
	              "rootToParentThingGroups": {
	                "shape": "Skg"
	              },
	              "creationDate": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "indexName": {},
	          "queryString": {},
	          "queryVersion": {},
	          "status": {}
	        }
	      }
	    },
	    "DescribeThingRegistrationTask": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/thing-registration-tasks/{taskId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId"
	        ],
	        "members": {
	          "taskId": {
	            "location": "uri",
	            "locationName": "taskId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskId": {},
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          },
	          "templateBody": {},
	          "inputFileBucket": {},
	          "inputFileKey": {},
	          "roleArn": {},
	          "status": {},
	          "message": {},
	          "successCount": {
	            "type": "integer"
	          },
	          "failureCount": {
	            "type": "integer"
	          },
	          "percentageProgress": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "DescribeThingType": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/thing-types/{thingTypeName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingTypeName"
	        ],
	        "members": {
	          "thingTypeName": {
	            "location": "uri",
	            "locationName": "thingTypeName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "thingTypeName": {},
	          "thingTypeId": {},
	          "thingTypeArn": {},
	          "thingTypeProperties": {
	            "shape": "S9x"
	          },
	          "thingTypeMetadata": {
	            "shape": "Skt"
	          }
	        }
	      }
	    },
	    "DetachPolicy": {
	      "http": {
	        "requestUri": "/target-policies/{policyName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName",
	          "target"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          },
	          "target": {}
	        }
	      }
	    },
	    "DetachPrincipalPolicy": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/principal-policies/{policyName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName",
	          "principal"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          },
	          "principal": {
	            "location": "header",
	            "locationName": "x-amzn-iot-principal"
	          }
	        }
	      },
	      "deprecated": true
	    },
	    "DetachSecurityProfile": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/security-profiles/{securityProfileName}/targets"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "securityProfileName",
	          "securityProfileTargetArn"
	        ],
	        "members": {
	          "securityProfileName": {
	            "location": "uri",
	            "locationName": "securityProfileName"
	          },
	          "securityProfileTargetArn": {
	            "location": "querystring",
	            "locationName": "securityProfileTargetArn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DetachThingPrincipal": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/things/{thingName}/principals"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName",
	          "principal"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "principal": {
	            "location": "header",
	            "locationName": "x-amzn-principal"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DisableTopicRule": {
	      "http": {
	        "requestUri": "/rules/{ruleName}/disable"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ruleName"
	        ],
	        "members": {
	          "ruleName": {
	            "location": "uri",
	            "locationName": "ruleName"
	          }
	        }
	      }
	    },
	    "EnableTopicRule": {
	      "http": {
	        "requestUri": "/rules/{ruleName}/enable"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ruleName"
	        ],
	        "members": {
	          "ruleName": {
	            "location": "uri",
	            "locationName": "ruleName"
	          }
	        }
	      }
	    },
	    "GetBehaviorModelTrainingSummaries": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/behavior-model-training/summaries"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "securityProfileName": {
	            "location": "querystring",
	            "locationName": "securityProfileName"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "summaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "securityProfileName": {},
	                "behaviorName": {},
	                "trainingDataCollectionStartDate": {
	                  "type": "timestamp"
	                },
	                "modelStatus": {},
	                "datapointsCollectionPercentage": {
	                  "type": "double"
	                },
	                "lastModelRefreshDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetBucketsAggregation": {
	      "http": {
	        "requestUri": "/indices/buckets"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "queryString",
	          "aggregationField",
	          "bucketsAggregationType"
	        ],
	        "members": {
	          "indexName": {},
	          "queryString": {},
	          "aggregationField": {},
	          "queryVersion": {},
	          "bucketsAggregationType": {
	            "type": "structure",
	            "members": {
	              "termsAggregation": {
	                "type": "structure",
	                "members": {
	                  "maxBuckets": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "totalCount": {
	            "type": "integer"
	          },
	          "buckets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "keyValue": {},
	                "count": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetCardinality": {
	      "http": {
	        "requestUri": "/indices/cardinality"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "queryString"
	        ],
	        "members": {
	          "indexName": {},
	          "queryString": {},
	          "aggregationField": {},
	          "queryVersion": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "cardinality": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "GetEffectivePolicies": {
	      "http": {
	        "requestUri": "/effective-policies"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "principal": {},
	          "cognitoIdentityPoolId": {},
	          "thingName": {
	            "location": "querystring",
	            "locationName": "thingName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "effectivePolicies": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "policyName": {},
	                "policyArn": {},
	                "policyDocument": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetIndexingConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/indexing/config"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "thingIndexingConfiguration": {
	            "shape": "Sls"
	          },
	          "thingGroupIndexingConfiguration": {
	            "shape": "Sm1"
	          }
	        }
	      }
	    },
	    "GetJobDocument": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/jobs/{jobId}/job-document"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId"
	        ],
	        "members": {
	          "jobId": {
	            "location": "uri",
	            "locationName": "jobId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "document": {}
	        }
	      }
	    },
	    "GetLoggingOptions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/loggingOptions"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "roleArn": {},
	          "logLevel": {}
	        }
	      }
	    },
	    "GetOTAUpdate": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/otaUpdates/{otaUpdateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "otaUpdateId"
	        ],
	        "members": {
	          "otaUpdateId": {
	            "location": "uri",
	            "locationName": "otaUpdateId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "otaUpdateInfo": {
	            "type": "structure",
	            "members": {
	              "otaUpdateId": {},
	              "otaUpdateArn": {},
	              "creationDate": {
	                "type": "timestamp"
	              },
	              "lastModifiedDate": {
	                "type": "timestamp"
	              },
	              "description": {},
	              "targets": {
	                "shape": "S5t"
	              },
	              "protocols": {
	                "shape": "S5v"
	              },
	              "awsJobExecutionsRolloutConfig": {
	                "shape": "S5x"
	              },
	              "awsJobPresignedUrlConfig": {
	                "shape": "S64"
	              },
	              "targetSelection": {},
	              "otaUpdateFiles": {
	                "shape": "S6f"
	              },
	              "otaUpdateStatus": {},
	              "awsIotJobId": {},
	              "awsIotJobArn": {},
	              "errorInfo": {
	                "type": "structure",
	                "members": {
	                  "code": {},
	                  "message": {}
	                }
	              },
	              "additionalParameters": {
	                "shape": "S7d"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetPercentiles": {
	      "http": {
	        "requestUri": "/indices/percentiles"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "queryString"
	        ],
	        "members": {
	          "indexName": {},
	          "queryString": {},
	          "aggregationField": {},
	          "queryVersion": {},
	          "percents": {
	            "type": "list",
	            "member": {
	              "type": "double"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "percentiles": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "percent": {
	                  "type": "double"
	                },
	                "value": {
	                  "type": "double"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetPolicy": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/policies/{policyName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "policyName": {},
	          "policyArn": {},
	          "policyDocument": {},
	          "defaultVersionId": {},
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          },
	          "generationId": {}
	        }
	      }
	    },
	    "GetPolicyVersion": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/policies/{policyName}/version/{policyVersionId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName",
	          "policyVersionId"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          },
	          "policyVersionId": {
	            "location": "uri",
	            "locationName": "policyVersionId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "policyArn": {},
	          "policyName": {},
	          "policyDocument": {},
	          "policyVersionId": {},
	          "isDefaultVersion": {
	            "type": "boolean"
	          },
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          },
	          "generationId": {}
	        }
	      }
	    },
	    "GetRegistrationCode": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/registrationcode"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "registrationCode": {}
	        }
	      }
	    },
	    "GetStatistics": {
	      "http": {
	        "requestUri": "/indices/statistics"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "queryString"
	        ],
	        "members": {
	          "indexName": {},
	          "queryString": {},
	          "aggregationField": {},
	          "queryVersion": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "statistics": {
	            "type": "structure",
	            "members": {
	              "count": {
	                "type": "integer"
	              },
	              "average": {
	                "type": "double"
	              },
	              "sum": {
	                "type": "double"
	              },
	              "minimum": {
	                "type": "double"
	              },
	              "maximum": {
	                "type": "double"
	              },
	              "sumOfSquares": {
	                "type": "double"
	              },
	              "variance": {
	                "type": "double"
	              },
	              "stdDeviation": {
	                "type": "double"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetTopicRule": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/rules/{ruleName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ruleName"
	        ],
	        "members": {
	          "ruleName": {
	            "location": "uri",
	            "locationName": "ruleName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ruleArn": {},
	          "rule": {
	            "type": "structure",
	            "members": {
	              "ruleName": {},
	              "sql": {},
	              "description": {},
	              "createdAt": {
	                "type": "timestamp"
	              },
	              "actions": {
	                "shape": "Sa8"
	              },
	              "ruleDisabled": {
	                "type": "boolean"
	              },
	              "awsIotSqlVersion": {},
	              "errorAction": {
	                "shape": "Sa9"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetTopicRuleDestination": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/destinations/{arn+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn"
	        ],
	        "members": {
	          "arn": {
	            "location": "uri",
	            "locationName": "arn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "topicRuleDestination": {
	            "shape": "Sdc"
	          }
	        }
	      }
	    },
	    "GetV2LoggingOptions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/v2LoggingOptions"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "roleArn": {},
	          "defaultLogLevel": {},
	          "disableAllLogs": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ListActiveViolations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/active-violations"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "thingName": {
	            "location": "querystring",
	            "locationName": "thingName"
	          },
	          "securityProfileName": {
	            "location": "querystring",
	            "locationName": "securityProfileName"
	          },
	          "behaviorCriteriaType": {
	            "location": "querystring",
	            "locationName": "behaviorCriteriaType"
	          },
	          "listSuppressedAlerts": {
	            "location": "querystring",
	            "locationName": "listSuppressedAlerts",
	            "type": "boolean"
	          },
	          "verificationState": {
	            "location": "querystring",
	            "locationName": "verificationState"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "activeViolations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "violationId": {},
	                "thingName": {},
	                "securityProfileName": {},
	                "behavior": {
	                  "shape": "S8l"
	                },
	                "lastViolationValue": {
	                  "shape": "S8s"
	                },
	                "violationEventAdditionalInfo": {
	                  "shape": "Snj"
	                },
	                "verificationState": {},
	                "verificationStateDescription": {},
	                "lastViolationTime": {
	                  "type": "timestamp"
	                },
	                "violationStartTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListAttachedPolicies": {
	      "http": {
	        "requestUri": "/attached-policies/{target}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "target"
	        ],
	        "members": {
	          "target": {
	            "location": "uri",
	            "locationName": "target"
	          },
	          "recursive": {
	            "location": "querystring",
	            "locationName": "recursive",
	            "type": "boolean"
	          },
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "policies": {
	            "shape": "Snq"
	          },
	          "nextMarker": {}
	        }
	      }
	    },
	    "ListAuditFindings": {
	      "http": {
	        "requestUri": "/audit/findings"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "taskId": {},
	          "checkName": {},
	          "resourceIdentifier": {
	            "shape": "S1o"
	          },
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {},
	          "startTime": {
	            "type": "timestamp"
	          },
	          "endTime": {
	            "type": "timestamp"
	          },
	          "listSuppressedFindings": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "findings": {
	            "type": "list",
	            "member": {
	              "shape": "Sfk"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListAuditMitigationActionsExecutions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/audit/mitigationactions/executions"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId",
	          "findingId"
	        ],
	        "members": {
	          "taskId": {
	            "location": "querystring",
	            "locationName": "taskId"
	          },
	          "actionStatus": {
	            "location": "querystring",
	            "locationName": "actionStatus"
	          },
	          "findingId": {
	            "location": "querystring",
	            "locationName": "findingId"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "actionsExecutions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "taskId": {},
	                "findingId": {},
	                "actionName": {},
	                "actionId": {},
	                "status": {},
	                "startTime": {
	                  "type": "timestamp"
	                },
	                "endTime": {
	                  "type": "timestamp"
	                },
	                "errorCode": {},
	                "message": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListAuditMitigationActionsTasks": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/audit/mitigationactions/tasks"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "startTime",
	          "endTime"
	        ],
	        "members": {
	          "auditTaskId": {
	            "location": "querystring",
	            "locationName": "auditTaskId"
	          },
	          "findingId": {
	            "location": "querystring",
	            "locationName": "findingId"
	          },
	          "taskStatus": {
	            "location": "querystring",
	            "locationName": "taskStatus"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "startTime": {
	            "location": "querystring",
	            "locationName": "startTime",
	            "type": "timestamp"
	          },
	          "endTime": {
	            "location": "querystring",
	            "locationName": "endTime",
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tasks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "taskId": {},
	                "startTime": {
	                  "type": "timestamp"
	                },
	                "taskStatus": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListAuditSuppressions": {
	      "http": {
	        "requestUri": "/audit/suppressions/list"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "checkName": {},
	          "resourceIdentifier": {
	            "shape": "S1o"
	          },
	          "ascendingOrder": {
	            "type": "boolean"
	          },
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "suppressions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "checkName",
	                "resourceIdentifier"
	              ],
	              "members": {
	                "checkName": {},
	                "resourceIdentifier": {
	                  "shape": "S1o"
	                },
	                "expirationDate": {
	                  "type": "timestamp"
	                },
	                "suppressIndefinitely": {
	                  "type": "boolean"
	                },
	                "description": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListAuditTasks": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/audit/tasks"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "startTime",
	          "endTime"
	        ],
	        "members": {
	          "startTime": {
	            "location": "querystring",
	            "locationName": "startTime",
	            "type": "timestamp"
	          },
	          "endTime": {
	            "location": "querystring",
	            "locationName": "endTime",
	            "type": "timestamp"
	          },
	          "taskType": {
	            "location": "querystring",
	            "locationName": "taskType"
	          },
	          "taskStatus": {
	            "location": "querystring",
	            "locationName": "taskStatus"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tasks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "taskId": {},
	                "taskStatus": {},
	                "taskType": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListAuthorizers": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/authorizers/"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          },
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "ascendingOrder": {
	            "location": "querystring",
	            "locationName": "isAscendingOrder",
	            "type": "boolean"
	          },
	          "status": {
	            "location": "querystring",
	            "locationName": "status"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "authorizers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "authorizerName": {},
	                "authorizerArn": {}
	              }
	            }
	          },
	          "nextMarker": {}
	        }
	      }
	    },
	    "ListBillingGroups": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/billing-groups"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "namePrefixFilter": {
	            "location": "querystring",
	            "locationName": "namePrefixFilter"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "billingGroups": {
	            "type": "list",
	            "member": {
	              "shape": "Skh"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListCACertificates": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/cacertificates"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          },
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "ascendingOrder": {
	            "location": "querystring",
	            "locationName": "isAscendingOrder",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "certificateArn": {},
	                "certificateId": {},
	                "status": {},
	                "creationDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextMarker": {}
	        }
	      }
	    },
	    "ListCertificates": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/certificates"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          },
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "ascendingOrder": {
	            "location": "querystring",
	            "locationName": "isAscendingOrder",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificates": {
	            "shape": "Sos"
	          },
	          "nextMarker": {}
	        }
	      }
	    },
	    "ListCertificatesByCA": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/certificates-by-ca/{caCertificateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "caCertificateId"
	        ],
	        "members": {
	          "caCertificateId": {
	            "location": "uri",
	            "locationName": "caCertificateId"
	          },
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          },
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "ascendingOrder": {
	            "location": "querystring",
	            "locationName": "isAscendingOrder",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificates": {
	            "shape": "Sos"
	          },
	          "nextMarker": {}
	        }
	      }
	    },
	    "ListCustomMetrics": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/custom-metrics"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "metricNames": {
	            "type": "list",
	            "member": {}
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDetectMitigationActionsExecutions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/detect/mitigationactions/executions"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "taskId": {
	            "location": "querystring",
	            "locationName": "taskId"
	          },
	          "violationId": {
	            "location": "querystring",
	            "locationName": "violationId"
	          },
	          "thingName": {
	            "location": "querystring",
	            "locationName": "thingName"
	          },
	          "startTime": {
	            "location": "querystring",
	            "locationName": "startTime",
	            "type": "timestamp"
	          },
	          "endTime": {
	            "location": "querystring",
	            "locationName": "endTime",
	            "type": "timestamp"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "actionsExecutions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "taskId": {},
	                "violationId": {},
	                "actionName": {},
	                "thingName": {},
	                "executionStartDate": {
	                  "type": "timestamp"
	                },
	                "executionEndDate": {
	                  "type": "timestamp"
	                },
	                "status": {},
	                "errorCode": {},
	                "message": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDetectMitigationActionsTasks": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/detect/mitigationactions/tasks"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "startTime",
	          "endTime"
	        ],
	        "members": {
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "startTime": {
	            "location": "querystring",
	            "locationName": "startTime",
	            "type": "timestamp"
	          },
	          "endTime": {
	            "location": "querystring",
	            "locationName": "endTime",
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tasks": {
	            "type": "list",
	            "member": {
	              "shape": "Sht"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDimensions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/dimensions"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "dimensionNames": {
	            "type": "list",
	            "member": {}
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDomainConfigurations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/domainConfigurations"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          },
	          "serviceType": {
	            "location": "querystring",
	            "locationName": "serviceType"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "domainConfigurations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "domainConfigurationName": {},
	                "domainConfigurationArn": {},
	                "serviceType": {}
	              }
	            }
	          },
	          "nextMarker": {}
	        }
	      }
	    },
	    "ListFleetMetrics": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/fleet-metrics"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "fleetMetrics": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "metricName": {},
	                "metricArn": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListIndices": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/indices"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "indexNames": {
	            "type": "list",
	            "member": {}
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListJobExecutionsForJob": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/jobs/{jobId}/things"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId"
	        ],
	        "members": {
	          "jobId": {
	            "location": "uri",
	            "locationName": "jobId"
	          },
	          "status": {
	            "location": "querystring",
	            "locationName": "status"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "executionSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "thingArn": {},
	                "jobExecutionSummary": {
	                  "shape": "Sps"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListJobExecutionsForThing": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/things/{thingName}/jobs"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "status": {
	            "location": "querystring",
	            "locationName": "status"
	          },
	          "namespaceId": {
	            "location": "querystring",
	            "locationName": "namespaceId"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "jobId": {
	            "location": "querystring",
	            "locationName": "jobId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "executionSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "jobId": {},
	                "jobExecutionSummary": {
	                  "shape": "Sps"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListJobTemplates": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/job-templates"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobTemplates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "jobTemplateArn": {},
	                "jobTemplateId": {},
	                "description": {},
	                "createdAt": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListJobs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/jobs"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "status": {
	            "location": "querystring",
	            "locationName": "status"
	          },
	          "targetSelection": {
	            "location": "querystring",
	            "locationName": "targetSelection"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "thingGroupName": {
	            "location": "querystring",
	            "locationName": "thingGroupName"
	          },
	          "thingGroupId": {
	            "location": "querystring",
	            "locationName": "thingGroupId"
	          },
	          "namespaceId": {
	            "location": "querystring",
	            "locationName": "namespaceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "jobs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "jobArn": {},
	                "jobId": {},
	                "thingGroupId": {},
	                "targetSelection": {},
	                "status": {},
	                "createdAt": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedAt": {
	                  "type": "timestamp"
	                },
	                "completedAt": {
	                  "type": "timestamp"
	                },
	                "isConcurrent": {
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListManagedJobTemplates": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/managed-job-templates"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "templateName": {
	            "location": "querystring",
	            "locationName": "templateName"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "managedJobTemplates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "templateArn": {},
	                "templateName": {},
	                "description": {},
	                "environments": {
	                  "shape": "Sjn"
	                },
	                "templateVersion": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListMetricValues": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/metric-values"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName",
	          "metricName",
	          "startTime",
	          "endTime"
	        ],
	        "members": {
	          "thingName": {
	            "location": "querystring",
	            "locationName": "thingName"
	          },
	          "metricName": {
	            "location": "querystring",
	            "locationName": "metricName"
	          },
	          "dimensionName": {
	            "location": "querystring",
	            "locationName": "dimensionName"
	          },
	          "dimensionValueOperator": {
	            "location": "querystring",
	            "locationName": "dimensionValueOperator"
	          },
	          "startTime": {
	            "location": "querystring",
	            "locationName": "startTime",
	            "type": "timestamp"
	          },
	          "endTime": {
	            "location": "querystring",
	            "locationName": "endTime",
	            "type": "timestamp"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "metricDatumList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "timestamp": {
	                  "type": "timestamp"
	                },
	                "value": {
	                  "shape": "S8s"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListMitigationActions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/mitigationactions/actions"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "actionType": {
	            "location": "querystring",
	            "locationName": "actionType"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "actionIdentifiers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "actionName": {},
	                "actionArn": {},
	                "creationDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListOTAUpdates": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/otaUpdates"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "otaUpdateStatus": {
	            "location": "querystring",
	            "locationName": "otaUpdateStatus"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "otaUpdates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "otaUpdateId": {},
	                "otaUpdateArn": {},
	                "creationDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListOutgoingCertificates": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/certificates-out-going"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          },
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "ascendingOrder": {
	            "location": "querystring",
	            "locationName": "isAscendingOrder",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "outgoingCertificates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "certificateArn": {},
	                "certificateId": {},
	                "transferredTo": {},
	                "transferDate": {
	                  "type": "timestamp"
	                },
	                "transferMessage": {},
	                "creationDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextMarker": {}
	        }
	      }
	    },
	    "ListPolicies": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/policies"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          },
	          "ascendingOrder": {
	            "location": "querystring",
	            "locationName": "isAscendingOrder",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "policies": {
	            "shape": "Snq"
	          },
	          "nextMarker": {}
	        }
	      }
	    },
	    "ListPolicyPrincipals": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/policy-principals"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName"
	        ],
	        "members": {
	          "policyName": {
	            "location": "header",
	            "locationName": "x-amzn-iot-policy"
	          },
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          },
	          "ascendingOrder": {
	            "location": "querystring",
	            "locationName": "isAscendingOrder",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "principals": {
	            "shape": "Squ"
	          },
	          "nextMarker": {}
	        }
	      },
	      "deprecated": true
	    },
	    "ListPolicyVersions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/policies/{policyName}/version"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "policyVersions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "versionId": {},
	                "isDefaultVersion": {
	                  "type": "boolean"
	                },
	                "createDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListPrincipalPolicies": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/principal-policies"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "principal"
	        ],
	        "members": {
	          "principal": {
	            "location": "header",
	            "locationName": "x-amzn-iot-principal"
	          },
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          },
	          "ascendingOrder": {
	            "location": "querystring",
	            "locationName": "isAscendingOrder",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "policies": {
	            "shape": "Snq"
	          },
	          "nextMarker": {}
	        }
	      },
	      "deprecated": true
	    },
	    "ListPrincipalThings": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/principals/things"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "principal"
	        ],
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "principal": {
	            "location": "header",
	            "locationName": "x-amzn-principal"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "things": {
	            "shape": "Sr4"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListProvisioningTemplateVersions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/provisioning-templates/{templateName}/versions"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateName"
	        ],
	        "members": {
	          "templateName": {
	            "location": "uri",
	            "locationName": "templateName"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "versions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "versionId": {
	                  "type": "integer"
	                },
	                "creationDate": {
	                  "type": "timestamp"
	                },
	                "isDefaultVersion": {
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListProvisioningTemplates": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/provisioning-templates"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "templates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "templateArn": {},
	                "templateName": {},
	                "description": {},
	                "creationDate": {
	                  "type": "timestamp"
	                },
	                "lastModifiedDate": {
	                  "type": "timestamp"
	                },
	                "enabled": {
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListRoleAliases": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/role-aliases"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          },
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "ascendingOrder": {
	            "location": "querystring",
	            "locationName": "isAscendingOrder",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "roleAliases": {
	            "type": "list",
	            "member": {}
	          },
	          "nextMarker": {}
	        }
	      }
	    },
	    "ListScheduledAudits": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/audit/scheduledaudits"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "scheduledAudits": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "scheduledAuditName": {},
	                "scheduledAuditArn": {},
	                "frequency": {},
	                "dayOfMonth": {},
	                "dayOfWeek": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListSecurityProfiles": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/security-profiles"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "dimensionName": {
	            "location": "querystring",
	            "locationName": "dimensionName"
	          },
	          "metricName": {
	            "location": "querystring",
	            "locationName": "metricName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "securityProfileIdentifiers": {
	            "type": "list",
	            "member": {
	              "shape": "Srn"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListSecurityProfilesForTarget": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/security-profiles-for-target"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "securityProfileTargetArn"
	        ],
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "recursive": {
	            "location": "querystring",
	            "locationName": "recursive",
	            "type": "boolean"
	          },
	          "securityProfileTargetArn": {
	            "location": "querystring",
	            "locationName": "securityProfileTargetArn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "securityProfileTargetMappings": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "securityProfileIdentifier": {
	                  "shape": "Srn"
	                },
	                "target": {
	                  "shape": "Srs"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListStreams": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/streams"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "ascendingOrder": {
	            "location": "querystring",
	            "locationName": "isAscendingOrder",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "streams": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "streamId": {},
	                "streamArn": {},
	                "streamVersion": {
	                  "type": "integer"
	                },
	                "description": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/tags"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "querystring",
	            "locationName": "resourceArn"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tags": {
	            "shape": "S29"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTargetsForPolicy": {
	      "http": {
	        "requestUri": "/policy-targets/{policyName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          },
	          "marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "targets": {
	            "type": "list",
	            "member": {}
	          },
	          "nextMarker": {}
	        }
	      }
	    },
	    "ListTargetsForSecurityProfile": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/security-profiles/{securityProfileName}/targets"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "securityProfileName"
	        ],
	        "members": {
	          "securityProfileName": {
	            "location": "uri",
	            "locationName": "securityProfileName"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "securityProfileTargets": {
	            "type": "list",
	            "member": {
	              "shape": "Srs"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListThingGroups": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/thing-groups"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "parentGroup": {
	            "location": "querystring",
	            "locationName": "parentGroup"
	          },
	          "namePrefixFilter": {
	            "location": "querystring",
	            "locationName": "namePrefixFilter"
	          },
	          "recursive": {
	            "location": "querystring",
	            "locationName": "recursive",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "thingGroups": {
	            "shape": "Skg"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListThingGroupsForThing": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/things/{thingName}/thing-groups"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "thingGroups": {
	            "shape": "Skg"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListThingPrincipals": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/things/{thingName}/principals"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName"
	        ],
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "principals": {
	            "shape": "Squ"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListThingRegistrationTaskReports": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/thing-registration-tasks/{taskId}/reports"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId",
	          "reportType"
	        ],
	        "members": {
	          "taskId": {
	            "location": "uri",
	            "locationName": "taskId"
	          },
	          "reportType": {
	            "location": "querystring",
	            "locationName": "reportType"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "resourceLinks": {
	            "type": "list",
	            "member": {}
	          },
	          "reportType": {},
	          "nextToken": {}
	        }
	      }
	    },
	    "ListThingRegistrationTasks": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/thing-registration-tasks"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "status": {
	            "location": "querystring",
	            "locationName": "status"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskIds": {
	            "type": "list",
	            "member": {}
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListThingTypes": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/thing-types"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "thingTypeName": {
	            "location": "querystring",
	            "locationName": "thingTypeName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "thingTypes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "thingTypeName": {},
	                "thingTypeArn": {},
	                "thingTypeProperties": {
	                  "shape": "S9x"
	                },
	                "thingTypeMetadata": {
	                  "shape": "Skt"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListThings": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/things"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "attributeName": {
	            "location": "querystring",
	            "locationName": "attributeName"
	          },
	          "attributeValue": {
	            "location": "querystring",
	            "locationName": "attributeValue"
	          },
	          "thingTypeName": {
	            "location": "querystring",
	            "locationName": "thingTypeName"
	          },
	          "usePrefixAttributeValue": {
	            "location": "querystring",
	            "locationName": "usePrefixAttributeValue",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "things": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "thingName": {},
	                "thingTypeName": {},
	                "thingArn": {},
	                "attributes": {
	                  "shape": "S3i"
	                },
	                "version": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListThingsInBillingGroup": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/billing-groups/{billingGroupName}/things"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "billingGroupName"
	        ],
	        "members": {
	          "billingGroupName": {
	            "location": "uri",
	            "locationName": "billingGroupName"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "things": {
	            "shape": "Sr4"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListThingsInThingGroup": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/thing-groups/{thingGroupName}/things"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingGroupName"
	        ],
	        "members": {
	          "thingGroupName": {
	            "location": "uri",
	            "locationName": "thingGroupName"
	          },
	          "recursive": {
	            "location": "querystring",
	            "locationName": "recursive",
	            "type": "boolean"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "things": {
	            "shape": "Sr4"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTopicRuleDestinations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/destinations"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "destinationSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "arn": {},
	                "status": {},
	                "createdAt": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedAt": {
	                  "type": "timestamp"
	                },
	                "statusReason": {},
	                "httpUrlSummary": {
	                  "type": "structure",
	                  "members": {
	                    "confirmationUrl": {}
	                  }
	                },
	                "vpcDestinationSummary": {
	                  "type": "structure",
	                  "members": {
	                    "subnetIds": {
	                      "shape": "Sd6"
	                    },
	                    "securityGroups": {
	                      "shape": "Sd8"
	                    },
	                    "vpcId": {},
	                    "roleArn": {}
	                  }
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTopicRules": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/rules"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "topic": {
	            "location": "querystring",
	            "locationName": "topic"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "ruleDisabled": {
	            "location": "querystring",
	            "locationName": "ruleDisabled",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "rules": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ruleArn": {},
	                "ruleName": {},
	                "topicPattern": {},
	                "createdAt": {
	                  "type": "timestamp"
	                },
	                "ruleDisabled": {
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListV2LoggingLevels": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/v2LoggingLevel"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "targetType": {
	            "location": "querystring",
	            "locationName": "targetType"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "logTargetConfigurations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "logTarget": {
	                  "shape": "Stg"
	                },
	                "logLevel": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListViolationEvents": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/violation-events"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "startTime",
	          "endTime"
	        ],
	        "members": {
	          "startTime": {
	            "location": "querystring",
	            "locationName": "startTime",
	            "type": "timestamp"
	          },
	          "endTime": {
	            "location": "querystring",
	            "locationName": "endTime",
	            "type": "timestamp"
	          },
	          "thingName": {
	            "location": "querystring",
	            "locationName": "thingName"
	          },
	          "securityProfileName": {
	            "location": "querystring",
	            "locationName": "securityProfileName"
	          },
	          "behaviorCriteriaType": {
	            "location": "querystring",
	            "locationName": "behaviorCriteriaType"
	          },
	          "listSuppressedAlerts": {
	            "location": "querystring",
	            "locationName": "listSuppressedAlerts",
	            "type": "boolean"
	          },
	          "verificationState": {
	            "location": "querystring",
	            "locationName": "verificationState"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "violationEvents": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "violationId": {},
	                "thingName": {},
	                "securityProfileName": {},
	                "behavior": {
	                  "shape": "S8l"
	                },
	                "metricValue": {
	                  "shape": "S8s"
	                },
	                "violationEventAdditionalInfo": {
	                  "shape": "Snj"
	                },
	                "violationEventType": {},
	                "verificationState": {},
	                "verificationStateDescription": {},
	                "violationEventTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "PutVerificationStateOnViolation": {
	      "http": {
	        "requestUri": "/violations/verification-state/{violationId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "violationId",
	          "verificationState"
	        ],
	        "members": {
	          "violationId": {
	            "location": "uri",
	            "locationName": "violationId"
	          },
	          "verificationState": {},
	          "verificationStateDescription": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RegisterCACertificate": {
	      "http": {
	        "requestUri": "/cacertificate"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "caCertificate",
	          "verificationCertificate"
	        ],
	        "members": {
	          "caCertificate": {},
	          "verificationCertificate": {},
	          "setAsActive": {
	            "location": "querystring",
	            "locationName": "setAsActive",
	            "type": "boolean"
	          },
	          "allowAutoRegistration": {
	            "location": "querystring",
	            "locationName": "allowAutoRegistration",
	            "type": "boolean"
	          },
	          "registrationConfig": {
	            "shape": "Shf"
	          },
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificateArn": {},
	          "certificateId": {}
	        }
	      }
	    },
	    "RegisterCertificate": {
	      "http": {
	        "requestUri": "/certificate/register"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificatePem"
	        ],
	        "members": {
	          "certificatePem": {},
	          "caCertificatePem": {},
	          "setAsActive": {
	            "deprecated": true,
	            "location": "querystring",
	            "locationName": "setAsActive",
	            "type": "boolean"
	          },
	          "status": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificateArn": {},
	          "certificateId": {}
	        }
	      }
	    },
	    "RegisterCertificateWithoutCA": {
	      "http": {
	        "requestUri": "/certificate/register-no-ca"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificatePem"
	        ],
	        "members": {
	          "certificatePem": {},
	          "status": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificateArn": {},
	          "certificateId": {}
	        }
	      }
	    },
	    "RegisterThing": {
	      "http": {
	        "requestUri": "/things"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateBody"
	        ],
	        "members": {
	          "templateBody": {},
	          "parameters": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "certificatePem": {},
	          "resourceArns": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          }
	        }
	      }
	    },
	    "RejectCertificateTransfer": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/reject-certificate-transfer/{certificateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificateId"
	        ],
	        "members": {
	          "certificateId": {
	            "location": "uri",
	            "locationName": "certificateId"
	          },
	          "rejectReason": {}
	        }
	      }
	    },
	    "RemoveThingFromBillingGroup": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/billing-groups/removeThingFromBillingGroup"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "billingGroupName": {},
	          "billingGroupArn": {},
	          "thingName": {},
	          "thingArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "RemoveThingFromThingGroup": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/thing-groups/removeThingFromThingGroup"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "thingGroupName": {},
	          "thingGroupArn": {},
	          "thingName": {},
	          "thingArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ReplaceTopicRule": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/rules/{ruleName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ruleName",
	          "topicRulePayload"
	        ],
	        "members": {
	          "ruleName": {
	            "location": "uri",
	            "locationName": "ruleName"
	          },
	          "topicRulePayload": {
	            "shape": "Sa5"
	          }
	        },
	        "payload": "topicRulePayload"
	      }
	    },
	    "SearchIndex": {
	      "http": {
	        "requestUri": "/indices/search"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "queryString"
	        ],
	        "members": {
	          "indexName": {},
	          "queryString": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "queryVersion": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "things": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "thingName": {},
	                "thingId": {},
	                "thingTypeName": {},
	                "thingGroupNames": {
	                  "shape": "Suc"
	                },
	                "attributes": {
	                  "shape": "S3i"
	                },
	                "shadow": {},
	                "deviceDefender": {},
	                "connectivity": {
	                  "type": "structure",
	                  "members": {
	                    "connected": {
	                      "type": "boolean"
	                    },
	                    "timestamp": {
	                      "type": "long"
	                    },
	                    "disconnectReason": {}
	                  }
	                }
	              }
	            }
	          },
	          "thingGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "thingGroupName": {},
	                "thingGroupId": {},
	                "thingGroupDescription": {},
	                "attributes": {
	                  "shape": "S3i"
	                },
	                "parentGroupNames": {
	                  "shape": "Suc"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "SetDefaultAuthorizer": {
	      "http": {
	        "requestUri": "/default-authorizer"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "authorizerName"
	        ],
	        "members": {
	          "authorizerName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "authorizerName": {},
	          "authorizerArn": {}
	        }
	      }
	    },
	    "SetDefaultPolicyVersion": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/policies/{policyName}/version/{policyVersionId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "policyName",
	          "policyVersionId"
	        ],
	        "members": {
	          "policyName": {
	            "location": "uri",
	            "locationName": "policyName"
	          },
	          "policyVersionId": {
	            "location": "uri",
	            "locationName": "policyVersionId"
	          }
	        }
	      }
	    },
	    "SetLoggingOptions": {
	      "http": {
	        "requestUri": "/loggingOptions"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "loggingOptionsPayload"
	        ],
	        "members": {
	          "loggingOptionsPayload": {
	            "type": "structure",
	            "required": [
	              "roleArn"
	            ],
	            "members": {
	              "roleArn": {},
	              "logLevel": {}
	            }
	          }
	        },
	        "payload": "loggingOptionsPayload"
	      }
	    },
	    "SetV2LoggingLevel": {
	      "http": {
	        "requestUri": "/v2LoggingLevel"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "logTarget",
	          "logLevel"
	        ],
	        "members": {
	          "logTarget": {
	            "shape": "Stg"
	          },
	          "logLevel": {}
	        }
	      }
	    },
	    "SetV2LoggingOptions": {
	      "http": {
	        "requestUri": "/v2LoggingOptions"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "roleArn": {},
	          "defaultLogLevel": {},
	          "disableAllLogs": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "StartAuditMitigationActionsTask": {
	      "http": {
	        "requestUri": "/audit/mitigationactions/tasks/{taskId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId",
	          "target",
	          "auditCheckToActionsMapping",
	          "clientRequestToken"
	        ],
	        "members": {
	          "taskId": {
	            "location": "uri",
	            "locationName": "taskId"
	          },
	          "target": {
	            "shape": "Sg4"
	          },
	          "auditCheckToActionsMapping": {
	            "shape": "Sg8"
	          },
	          "clientRequestToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskId": {}
	        }
	      }
	    },
	    "StartDetectMitigationActionsTask": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/detect/mitigationactions/tasks/{taskId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId",
	          "target",
	          "actions",
	          "clientRequestToken"
	        ],
	        "members": {
	          "taskId": {
	            "location": "uri",
	            "locationName": "taskId"
	          },
	          "target": {
	            "shape": "Shv"
	          },
	          "actions": {
	            "type": "list",
	            "member": {}
	          },
	          "violationEventOccurrenceRange": {
	            "shape": "Shy"
	          },
	          "includeOnlyActiveViolations": {
	            "type": "boolean"
	          },
	          "includeSuppressedAlerts": {
	            "type": "boolean"
	          },
	          "clientRequestToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskId": {}
	        }
	      }
	    },
	    "StartOnDemandAuditTask": {
	      "http": {
	        "requestUri": "/audit/tasks"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "targetCheckNames"
	        ],
	        "members": {
	          "targetCheckNames": {
	            "shape": "S8e"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskId": {}
	        }
	      }
	    },
	    "StartThingRegistrationTask": {
	      "http": {
	        "requestUri": "/thing-registration-tasks"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateBody",
	          "inputFileBucket",
	          "inputFileKey",
	          "roleArn"
	        ],
	        "members": {
	          "templateBody": {},
	          "inputFileBucket": {},
	          "inputFileKey": {},
	          "roleArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskId": {}
	        }
	      }
	    },
	    "StopThingRegistrationTask": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/thing-registration-tasks/{taskId}/cancel"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId"
	        ],
	        "members": {
	          "taskId": {
	            "location": "uri",
	            "locationName": "taskId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/tags"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tags"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tags": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TestAuthorization": {
	      "http": {
	        "requestUri": "/test-authorization"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "authInfos"
	        ],
	        "members": {
	          "principal": {},
	          "cognitoIdentityPoolId": {},
	          "authInfos": {
	            "type": "list",
	            "member": {
	              "shape": "Sv5"
	            }
	          },
	          "clientId": {
	            "location": "querystring",
	            "locationName": "clientId"
	          },
	          "policyNamesToAdd": {
	            "shape": "Sv9"
	          },
	          "policyNamesToSkip": {
	            "shape": "Sv9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "authResults": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "authInfo": {
	                  "shape": "Sv5"
	                },
	                "allowed": {
	                  "type": "structure",
	                  "members": {
	                    "policies": {
	                      "shape": "Snq"
	                    }
	                  }
	                },
	                "denied": {
	                  "type": "structure",
	                  "members": {
	                    "implicitDeny": {
	                      "type": "structure",
	                      "members": {
	                        "policies": {
	                          "shape": "Snq"
	                        }
	                      }
	                    },
	                    "explicitDeny": {
	                      "type": "structure",
	                      "members": {
	                        "policies": {
	                          "shape": "Snq"
	                        }
	                      }
	                    }
	                  }
	                },
	                "authDecision": {},
	                "missingContextValues": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "TestInvokeAuthorizer": {
	      "http": {
	        "requestUri": "/authorizer/{authorizerName}/test"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "authorizerName"
	        ],
	        "members": {
	          "authorizerName": {
	            "location": "uri",
	            "locationName": "authorizerName"
	          },
	          "token": {},
	          "tokenSignature": {},
	          "httpContext": {
	            "type": "structure",
	            "members": {
	              "headers": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              },
	              "queryString": {}
	            }
	          },
	          "mqttContext": {
	            "type": "structure",
	            "members": {
	              "username": {},
	              "password": {
	                "type": "blob"
	              },
	              "clientId": {}
	            }
	          },
	          "tlsContext": {
	            "type": "structure",
	            "members": {
	              "serverName": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "isAuthenticated": {
	            "type": "boolean"
	          },
	          "principalId": {},
	          "policyDocuments": {
	            "type": "list",
	            "member": {}
	          },
	          "refreshAfterInSeconds": {
	            "type": "integer"
	          },
	          "disconnectAfterInSeconds": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "TransferCertificate": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/transfer-certificate/{certificateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificateId",
	          "targetAwsAccount"
	        ],
	        "members": {
	          "certificateId": {
	            "location": "uri",
	            "locationName": "certificateId"
	          },
	          "targetAwsAccount": {
	            "location": "querystring",
	            "locationName": "targetAwsAccount"
	          },
	          "transferMessage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "transferredCertificateArn": {}
	        }
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "requestUri": "/untag"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tagKeys"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateAccountAuditConfiguration": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/audit/configuration"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "roleArn": {},
	          "auditNotificationTargetConfigurations": {
	            "shape": "Sfc"
	          },
	          "auditCheckConfigurations": {
	            "shape": "Sff"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateAuditSuppression": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/audit/suppressions/update"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "checkName",
	          "resourceIdentifier"
	        ],
	        "members": {
	          "checkName": {},
	          "resourceIdentifier": {
	            "shape": "S1o"
	          },
	          "expirationDate": {
	            "type": "timestamp"
	          },
	          "suppressIndefinitely": {
	            "type": "boolean"
	          },
	          "description": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateAuthorizer": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/authorizer/{authorizerName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "authorizerName"
	        ],
	        "members": {
	          "authorizerName": {
	            "location": "uri",
	            "locationName": "authorizerName"
	          },
	          "authorizerFunctionArn": {},
	          "tokenKeyName": {},
	          "tokenSigningPublicKeys": {
	            "shape": "S25"
	          },
	          "status": {},
	          "enableCachingForHttp": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "authorizerName": {},
	          "authorizerArn": {}
	        }
	      }
	    },
	    "UpdateBillingGroup": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/billing-groups/{billingGroupName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "billingGroupName",
	          "billingGroupProperties"
	        ],
	        "members": {
	          "billingGroupName": {
	            "location": "uri",
	            "locationName": "billingGroupName"
	          },
	          "billingGroupProperties": {
	            "shape": "S2i"
	          },
	          "expectedVersion": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "version": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "UpdateCACertificate": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/cacertificate/{caCertificateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificateId"
	        ],
	        "members": {
	          "certificateId": {
	            "location": "uri",
	            "locationName": "caCertificateId"
	          },
	          "newStatus": {
	            "location": "querystring",
	            "locationName": "newStatus"
	          },
	          "newAutoRegistrationStatus": {
	            "location": "querystring",
	            "locationName": "newAutoRegistrationStatus"
	          },
	          "registrationConfig": {
	            "shape": "Shf"
	          },
	          "removeAutoRegistration": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "UpdateCertificate": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/certificates/{certificateId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "certificateId",
	          "newStatus"
	        ],
	        "members": {
	          "certificateId": {
	            "location": "uri",
	            "locationName": "certificateId"
	          },
	          "newStatus": {
	            "location": "querystring",
	            "locationName": "newStatus"
	          }
	        }
	      }
	    },
	    "UpdateCustomMetric": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/custom-metric/{metricName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "metricName",
	          "displayName"
	        ],
	        "members": {
	          "metricName": {
	            "location": "uri",
	            "locationName": "metricName"
	          },
	          "displayName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "metricName": {},
	          "metricArn": {},
	          "metricType": {},
	          "displayName": {},
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "UpdateDimension": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/dimensions/{name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "stringValues"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "stringValues": {
	            "shape": "S30"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "arn": {},
	          "type": {},
	          "stringValues": {
	            "shape": "S30"
	          },
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "UpdateDomainConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/domainConfigurations/{domainConfigurationName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "domainConfigurationName"
	        ],
	        "members": {
	          "domainConfigurationName": {
	            "location": "uri",
	            "locationName": "domainConfigurationName"
	          },
	          "authorizerConfig": {
	            "shape": "S39"
	          },
	          "domainConfigurationStatus": {},
	          "removeAuthorizerConfig": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "domainConfigurationName": {},
	          "domainConfigurationArn": {}
	        }
	      }
	    },
	    "UpdateDynamicThingGroup": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/dynamic-thing-groups/{thingGroupName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingGroupName",
	          "thingGroupProperties"
	        ],
	        "members": {
	          "thingGroupName": {
	            "location": "uri",
	            "locationName": "thingGroupName"
	          },
	          "thingGroupProperties": {
	            "shape": "S3f"
	          },
	          "expectedVersion": {
	            "type": "long"
	          },
	          "indexName": {},
	          "queryString": {},
	          "queryVersion": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "version": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "UpdateEventConfigurations": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/event-configurations"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "eventConfigurations": {
	            "shape": "Sij"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateFleetMetric": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/fleet-metric/{metricName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "metricName",
	          "indexName"
	        ],
	        "members": {
	          "metricName": {
	            "location": "uri",
	            "locationName": "metricName"
	          },
	          "queryString": {},
	          "aggregationType": {
	            "shape": "S3t"
	          },
	          "period": {
	            "type": "integer"
	          },
	          "aggregationField": {},
	          "description": {},
	          "queryVersion": {},
	          "indexName": {},
	          "unit": {},
	          "expectedVersion": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "UpdateIndexingConfiguration": {
	      "http": {
	        "requestUri": "/indexing/config"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "thingIndexingConfiguration": {
	            "shape": "Sls"
	          },
	          "thingGroupIndexingConfiguration": {
	            "shape": "Sm1"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateJob": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/jobs/{jobId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobId"
	        ],
	        "members": {
	          "jobId": {
	            "location": "uri",
	            "locationName": "jobId"
	          },
	          "description": {},
	          "presignedUrlConfig": {
	            "shape": "S46"
	          },
	          "jobExecutionsRolloutConfig": {
	            "shape": "S49"
	          },
	          "abortConfig": {
	            "shape": "S4g"
	          },
	          "timeoutConfig": {
	            "shape": "S4n"
	          },
	          "namespaceId": {
	            "location": "querystring",
	            "locationName": "namespaceId"
	          },
	          "jobExecutionsRetryConfig": {
	            "shape": "S4q"
	          }
	        }
	      }
	    },
	    "UpdateMitigationAction": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/mitigationactions/actions/{actionName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "actionName"
	        ],
	        "members": {
	          "actionName": {
	            "location": "uri",
	            "locationName": "actionName"
	          },
	          "roleArn": {},
	          "actionParams": {
	            "shape": "S59"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "actionArn": {},
	          "actionId": {}
	        }
	      }
	    },
	    "UpdateProvisioningTemplate": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/provisioning-templates/{templateName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "templateName"
	        ],
	        "members": {
	          "templateName": {
	            "location": "uri",
	            "locationName": "templateName"
	          },
	          "description": {},
	          "enabled": {
	            "type": "boolean"
	          },
	          "defaultVersionId": {
	            "type": "integer"
	          },
	          "provisioningRoleArn": {},
	          "preProvisioningHook": {
	            "shape": "S7z"
	          },
	          "removePreProvisioningHook": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateRoleAlias": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/role-aliases/{roleAlias}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "roleAlias"
	        ],
	        "members": {
	          "roleAlias": {
	            "location": "uri",
	            "locationName": "roleAlias"
	          },
	          "roleArn": {},
	          "credentialDurationSeconds": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "roleAlias": {},
	          "roleAliasArn": {}
	        }
	      }
	    },
	    "UpdateScheduledAudit": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/audit/scheduledaudits/{scheduledAuditName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "scheduledAuditName"
	        ],
	        "members": {
	          "frequency": {},
	          "dayOfMonth": {},
	          "dayOfWeek": {},
	          "targetCheckNames": {
	            "shape": "S8e"
	          },
	          "scheduledAuditName": {
	            "location": "uri",
	            "locationName": "scheduledAuditName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "scheduledAuditArn": {}
	        }
	      }
	    },
	    "UpdateSecurityProfile": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/security-profiles/{securityProfileName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "securityProfileName"
	        ],
	        "members": {
	          "securityProfileName": {
	            "location": "uri",
	            "locationName": "securityProfileName"
	          },
	          "securityProfileDescription": {},
	          "behaviors": {
	            "shape": "S8k"
	          },
	          "alertTargets": {
	            "shape": "S9a"
	          },
	          "additionalMetricsToRetain": {
	            "shape": "S9e",
	            "deprecated": true,
	            "deprecatedMessage": "Use additionalMetricsToRetainV2."
	          },
	          "additionalMetricsToRetainV2": {
	            "shape": "S9f"
	          },
	          "deleteBehaviors": {
	            "type": "boolean"
	          },
	          "deleteAlertTargets": {
	            "type": "boolean"
	          },
	          "deleteAdditionalMetricsToRetain": {
	            "type": "boolean"
	          },
	          "expectedVersion": {
	            "location": "querystring",
	            "locationName": "expectedVersion",
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "securityProfileName": {},
	          "securityProfileArn": {},
	          "securityProfileDescription": {},
	          "behaviors": {
	            "shape": "S8k"
	          },
	          "alertTargets": {
	            "shape": "S9a"
	          },
	          "additionalMetricsToRetain": {
	            "shape": "S9e",
	            "deprecated": true,
	            "deprecatedMessage": "Use additionalMetricsToRetainV2."
	          },
	          "additionalMetricsToRetainV2": {
	            "shape": "S9f"
	          },
	          "version": {
	            "type": "long"
	          },
	          "creationDate": {
	            "type": "timestamp"
	          },
	          "lastModifiedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "UpdateStream": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/streams/{streamId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "streamId"
	        ],
	        "members": {
	          "streamId": {
	            "location": "uri",
	            "locationName": "streamId"
	          },
	          "description": {},
	          "files": {
	            "shape": "S9l"
	          },
	          "roleArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "streamId": {},
	          "streamArn": {},
	          "description": {},
	          "streamVersion": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "UpdateThing": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/things/{thingName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "thingTypeName": {},
	          "attributePayload": {
	            "shape": "S3h"
	          },
	          "expectedVersion": {
	            "type": "long"
	          },
	          "removeThingType": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateThingGroup": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/thing-groups/{thingGroupName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingGroupName",
	          "thingGroupProperties"
	        ],
	        "members": {
	          "thingGroupName": {
	            "location": "uri",
	            "locationName": "thingGroupName"
	          },
	          "thingGroupProperties": {
	            "shape": "S3f"
	          },
	          "expectedVersion": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "version": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "UpdateThingGroupsForThing": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/thing-groups/updateThingGroupsForThing"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "thingName": {},
	          "thingGroupsToAdd": {
	            "shape": "Sxk"
	          },
	          "thingGroupsToRemove": {
	            "shape": "Sxk"
	          },
	          "overrideDynamicGroups": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateTopicRuleDestination": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/destinations"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "arn",
	          "status"
	        ],
	        "members": {
	          "arn": {},
	          "status": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ValidateSecurityProfileBehaviors": {
	      "http": {
	        "requestUri": "/security-profile-behaviors/validate"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "behaviors"
	        ],
	        "members": {
	          "behaviors": {
	            "shape": "S8k"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "valid": {
	            "type": "boolean"
	          },
	          "validationErrors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "errorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sg": {
	      "type": "list",
	      "member": {}
	    },
	    "S1e": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S1o": {
	      "type": "structure",
	      "members": {
	        "deviceCertificateId": {},
	        "caCertificateId": {},
	        "cognitoIdentityPoolId": {},
	        "clientId": {},
	        "policyVersionIdentifier": {
	          "type": "structure",
	          "members": {
	            "policyName": {},
	            "policyVersionId": {}
	          }
	        },
	        "account": {},
	        "iamRoleArn": {},
	        "roleAliasArn": {}
	      }
	    },
	    "S25": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S29": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S2i": {
	      "type": "structure",
	      "members": {
	        "billingGroupDescription": {}
	      }
	    },
	    "S30": {
	      "type": "list",
	      "member": {}
	    },
	    "S39": {
	      "type": "structure",
	      "members": {
	        "defaultAuthorizerName": {},
	        "allowAuthorizerOverride": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S3f": {
	      "type": "structure",
	      "members": {
	        "thingGroupDescription": {},
	        "attributePayload": {
	          "shape": "S3h"
	        }
	      }
	    },
	    "S3h": {
	      "type": "structure",
	      "members": {
	        "attributes": {
	          "shape": "S3i"
	        },
	        "merge": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S3i": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S3t": {
	      "type": "structure",
	      "required": [
	        "name"
	      ],
	      "members": {
	        "name": {},
	        "values": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S46": {
	      "type": "structure",
	      "members": {
	        "roleArn": {},
	        "expiresInSec": {
	          "type": "long"
	        }
	      }
	    },
	    "S49": {
	      "type": "structure",
	      "members": {
	        "maximumPerMinute": {
	          "type": "integer"
	        },
	        "exponentialRate": {
	          "type": "structure",
	          "required": [
	            "baseRatePerMinute",
	            "incrementFactor",
	            "rateIncreaseCriteria"
	          ],
	          "members": {
	            "baseRatePerMinute": {
	              "type": "integer"
	            },
	            "incrementFactor": {
	              "type": "double"
	            },
	            "rateIncreaseCriteria": {
	              "type": "structure",
	              "members": {
	                "numberOfNotifiedThings": {
	                  "type": "integer"
	                },
	                "numberOfSucceededThings": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S4g": {
	      "type": "structure",
	      "required": [
	        "criteriaList"
	      ],
	      "members": {
	        "criteriaList": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "failureType",
	              "action",
	              "thresholdPercentage",
	              "minNumberOfExecutedThings"
	            ],
	            "members": {
	              "failureType": {},
	              "action": {},
	              "thresholdPercentage": {
	                "type": "double"
	              },
	              "minNumberOfExecutedThings": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S4n": {
	      "type": "structure",
	      "members": {
	        "inProgressTimeoutInMinutes": {
	          "type": "long"
	        }
	      }
	    },
	    "S4q": {
	      "type": "structure",
	      "required": [
	        "criteriaList"
	      ],
	      "members": {
	        "criteriaList": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "failureType",
	              "numberOfRetries"
	            ],
	            "members": {
	              "failureType": {},
	              "numberOfRetries": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S4v": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S54": {
	      "type": "structure",
	      "members": {
	        "PublicKey": {},
	        "PrivateKey": {
	          "type": "string",
	          "sensitive": true
	        }
	      }
	    },
	    "S59": {
	      "type": "structure",
	      "members": {
	        "updateDeviceCertificateParams": {
	          "type": "structure",
	          "required": [
	            "action"
	          ],
	          "members": {
	            "action": {}
	          }
	        },
	        "updateCACertificateParams": {
	          "type": "structure",
	          "required": [
	            "action"
	          ],
	          "members": {
	            "action": {}
	          }
	        },
	        "addThingsToThingGroupParams": {
	          "type": "structure",
	          "required": [
	            "thingGroupNames"
	          ],
	          "members": {
	            "thingGroupNames": {
	              "type": "list",
	              "member": {}
	            },
	            "overrideDynamicGroups": {
	              "type": "boolean"
	            }
	          }
	        },
	        "replaceDefaultPolicyVersionParams": {
	          "type": "structure",
	          "required": [
	            "templateName"
	          ],
	          "members": {
	            "templateName": {}
	          }
	        },
	        "enableIoTLoggingParams": {
	          "type": "structure",
	          "required": [
	            "roleArnForLogging",
	            "logLevel"
	          ],
	          "members": {
	            "roleArnForLogging": {},
	            "logLevel": {}
	          }
	        },
	        "publishFindingToSnsParams": {
	          "type": "structure",
	          "required": [
	            "topicArn"
	          ],
	          "members": {
	            "topicArn": {}
	          }
	        }
	      }
	    },
	    "S5t": {
	      "type": "list",
	      "member": {}
	    },
	    "S5v": {
	      "type": "list",
	      "member": {}
	    },
	    "S5x": {
	      "type": "structure",
	      "members": {
	        "maximumPerMinute": {
	          "type": "integer"
	        },
	        "exponentialRate": {
	          "type": "structure",
	          "required": [
	            "baseRatePerMinute",
	            "incrementFactor",
	            "rateIncreaseCriteria"
	          ],
	          "members": {
	            "baseRatePerMinute": {
	              "type": "integer"
	            },
	            "incrementFactor": {
	              "type": "double"
	            },
	            "rateIncreaseCriteria": {
	              "type": "structure",
	              "members": {
	                "numberOfNotifiedThings": {
	                  "type": "integer"
	                },
	                "numberOfSucceededThings": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S64": {
	      "type": "structure",
	      "members": {
	        "expiresInSec": {
	          "type": "long"
	        }
	      }
	    },
	    "S6f": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "fileName": {},
	          "fileType": {
	            "type": "integer"
	          },
	          "fileVersion": {},
	          "fileLocation": {
	            "type": "structure",
	            "members": {
	              "stream": {
	                "type": "structure",
	                "members": {
	                  "streamId": {},
	                  "fileId": {
	                    "type": "integer"
	                  }
	                }
	              },
	              "s3Location": {
	                "shape": "S6o"
	              }
	            }
	          },
	          "codeSigning": {
	            "type": "structure",
	            "members": {
	              "awsSignerJobId": {},
	              "startSigningJobParameter": {
	                "type": "structure",
	                "members": {
	                  "signingProfileParameter": {
	                    "type": "structure",
	                    "members": {
	                      "certificateArn": {},
	                      "platform": {},
	                      "certificatePathOnDevice": {}
	                    }
	                  },
	                  "signingProfileName": {},
	                  "destination": {
	                    "type": "structure",
	                    "members": {
	                      "s3Destination": {
	                        "type": "structure",
	                        "members": {
	                          "bucket": {},
	                          "prefix": {}
	                        }
	                      }
	                    }
	                  }
	                }
	              },
	              "customCodeSigning": {
	                "type": "structure",
	                "members": {
	                  "signature": {
	                    "type": "structure",
	                    "members": {
	                      "inlineDocument": {
	                        "type": "blob"
	                      }
	                    }
	                  },
	                  "certificateChain": {
	                    "type": "structure",
	                    "members": {
	                      "certificateName": {},
	                      "inlineDocument": {}
	                    }
	                  },
	                  "hashAlgorithm": {},
	                  "signatureAlgorithm": {}
	                }
	              }
	            }
	          },
	          "attributes": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          }
	        }
	      }
	    },
	    "S6o": {
	      "type": "structure",
	      "members": {
	        "bucket": {},
	        "key": {},
	        "version": {}
	      }
	    },
	    "S7d": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S7z": {
	      "type": "structure",
	      "required": [
	        "targetArn"
	      ],
	      "members": {
	        "payloadVersion": {},
	        "targetArn": {}
	      }
	    },
	    "S8e": {
	      "type": "list",
	      "member": {}
	    },
	    "S8k": {
	      "type": "list",
	      "member": {
	        "shape": "S8l"
	      }
	    },
	    "S8l": {
	      "type": "structure",
	      "required": [
	        "name"
	      ],
	      "members": {
	        "name": {},
	        "metric": {},
	        "metricDimension": {
	          "shape": "S8o"
	        },
	        "criteria": {
	          "type": "structure",
	          "members": {
	            "comparisonOperator": {},
	            "value": {
	              "shape": "S8s"
	            },
	            "durationSeconds": {
	              "type": "integer"
	            },
	            "consecutiveDatapointsToAlarm": {
	              "type": "integer"
	            },
	            "consecutiveDatapointsToClear": {
	              "type": "integer"
	            },
	            "statisticalThreshold": {
	              "type": "structure",
	              "members": {
	                "statistic": {}
	              }
	            },
	            "mlDetectionConfig": {
	              "type": "structure",
	              "required": [
	                "confidenceLevel"
	              ],
	              "members": {
	                "confidenceLevel": {}
	              }
	            }
	          }
	        },
	        "suppressAlerts": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S8o": {
	      "type": "structure",
	      "required": [
	        "dimensionName"
	      ],
	      "members": {
	        "dimensionName": {},
	        "operator": {}
	      }
	    },
	    "S8s": {
	      "type": "structure",
	      "members": {
	        "count": {
	          "type": "long"
	        },
	        "cidrs": {
	          "type": "list",
	          "member": {}
	        },
	        "ports": {
	          "type": "list",
	          "member": {
	            "type": "integer"
	          }
	        },
	        "number": {
	          "type": "double"
	        },
	        "numbers": {
	          "type": "list",
	          "member": {
	            "type": "double"
	          }
	        },
	        "strings": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S9a": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "required": [
	          "alertTargetArn",
	          "roleArn"
	        ],
	        "members": {
	          "alertTargetArn": {},
	          "roleArn": {}
	        }
	      }
	    },
	    "S9e": {
	      "type": "list",
	      "member": {}
	    },
	    "S9f": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "metric"
	        ],
	        "members": {
	          "metric": {},
	          "metricDimension": {
	            "shape": "S8o"
	          }
	        }
	      }
	    },
	    "S9l": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "fileId": {
	            "type": "integer"
	          },
	          "s3Location": {
	            "shape": "S6o"
	          }
	        }
	      }
	    },
	    "S9x": {
	      "type": "structure",
	      "members": {
	        "thingTypeDescription": {},
	        "searchableAttributes": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "Sa5": {
	      "type": "structure",
	      "required": [
	        "sql",
	        "actions"
	      ],
	      "members": {
	        "sql": {},
	        "description": {},
	        "actions": {
	          "shape": "Sa8"
	        },
	        "ruleDisabled": {
	          "type": "boolean"
	        },
	        "awsIotSqlVersion": {},
	        "errorAction": {
	          "shape": "Sa9"
	        }
	      }
	    },
	    "Sa8": {
	      "type": "list",
	      "member": {
	        "shape": "Sa9"
	      }
	    },
	    "Sa9": {
	      "type": "structure",
	      "members": {
	        "dynamoDB": {
	          "type": "structure",
	          "required": [
	            "tableName",
	            "roleArn",
	            "hashKeyField",
	            "hashKeyValue"
	          ],
	          "members": {
	            "tableName": {},
	            "roleArn": {},
	            "operation": {},
	            "hashKeyField": {},
	            "hashKeyValue": {},
	            "hashKeyType": {},
	            "rangeKeyField": {},
	            "rangeKeyValue": {},
	            "rangeKeyType": {},
	            "payloadField": {}
	          }
	        },
	        "dynamoDBv2": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "putItem"
	          ],
	          "members": {
	            "roleArn": {},
	            "putItem": {
	              "type": "structure",
	              "required": [
	                "tableName"
	              ],
	              "members": {
	                "tableName": {}
	              }
	            }
	          }
	        },
	        "lambda": {
	          "type": "structure",
	          "required": [
	            "functionArn"
	          ],
	          "members": {
	            "functionArn": {}
	          }
	        },
	        "sns": {
	          "type": "structure",
	          "required": [
	            "targetArn",
	            "roleArn"
	          ],
	          "members": {
	            "targetArn": {},
	            "roleArn": {},
	            "messageFormat": {}
	          }
	        },
	        "sqs": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "queueUrl"
	          ],
	          "members": {
	            "roleArn": {},
	            "queueUrl": {},
	            "useBase64": {
	              "type": "boolean"
	            }
	          }
	        },
	        "kinesis": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "streamName"
	          ],
	          "members": {
	            "roleArn": {},
	            "streamName": {},
	            "partitionKey": {}
	          }
	        },
	        "republish": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "topic"
	          ],
	          "members": {
	            "roleArn": {},
	            "topic": {},
	            "qos": {
	              "type": "integer"
	            }
	          }
	        },
	        "s3": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "bucketName",
	            "key"
	          ],
	          "members": {
	            "roleArn": {},
	            "bucketName": {},
	            "key": {},
	            "cannedAcl": {}
	          }
	        },
	        "firehose": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "deliveryStreamName"
	          ],
	          "members": {
	            "roleArn": {},
	            "deliveryStreamName": {},
	            "separator": {},
	            "batchMode": {
	              "type": "boolean"
	            }
	          }
	        },
	        "cloudwatchMetric": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "metricNamespace",
	            "metricName",
	            "metricValue",
	            "metricUnit"
	          ],
	          "members": {
	            "roleArn": {},
	            "metricNamespace": {},
	            "metricName": {},
	            "metricValue": {},
	            "metricUnit": {},
	            "metricTimestamp": {}
	          }
	        },
	        "cloudwatchAlarm": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "alarmName",
	            "stateReason",
	            "stateValue"
	          ],
	          "members": {
	            "roleArn": {},
	            "alarmName": {},
	            "stateReason": {},
	            "stateValue": {}
	          }
	        },
	        "cloudwatchLogs": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "logGroupName"
	          ],
	          "members": {
	            "roleArn": {},
	            "logGroupName": {}
	          }
	        },
	        "elasticsearch": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "endpoint",
	            "index",
	            "type",
	            "id"
	          ],
	          "members": {
	            "roleArn": {},
	            "endpoint": {},
	            "index": {},
	            "type": {},
	            "id": {}
	          }
	        },
	        "salesforce": {
	          "type": "structure",
	          "required": [
	            "token",
	            "url"
	          ],
	          "members": {
	            "token": {},
	            "url": {}
	          }
	        },
	        "iotAnalytics": {
	          "type": "structure",
	          "members": {
	            "channelArn": {},
	            "channelName": {},
	            "batchMode": {
	              "type": "boolean"
	            },
	            "roleArn": {}
	          }
	        },
	        "iotEvents": {
	          "type": "structure",
	          "required": [
	            "inputName",
	            "roleArn"
	          ],
	          "members": {
	            "inputName": {},
	            "messageId": {},
	            "batchMode": {
	              "type": "boolean"
	            },
	            "roleArn": {}
	          }
	        },
	        "iotSiteWise": {
	          "type": "structure",
	          "required": [
	            "putAssetPropertyValueEntries",
	            "roleArn"
	          ],
	          "members": {
	            "putAssetPropertyValueEntries": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "required": [
	                  "propertyValues"
	                ],
	                "members": {
	                  "entryId": {},
	                  "assetId": {},
	                  "propertyId": {},
	                  "propertyAlias": {},
	                  "propertyValues": {
	                    "type": "list",
	                    "member": {
	                      "type": "structure",
	                      "required": [
	                        "value",
	                        "timestamp"
	                      ],
	                      "members": {
	                        "value": {
	                          "type": "structure",
	                          "members": {
	                            "stringValue": {},
	                            "integerValue": {},
	                            "doubleValue": {},
	                            "booleanValue": {}
	                          }
	                        },
	                        "timestamp": {
	                          "type": "structure",
	                          "required": [
	                            "timeInSeconds"
	                          ],
	                          "members": {
	                            "timeInSeconds": {},
	                            "offsetInNanos": {}
	                          }
	                        },
	                        "quality": {}
	                      }
	                    }
	                  }
	                }
	              }
	            },
	            "roleArn": {}
	          }
	        },
	        "stepFunctions": {
	          "type": "structure",
	          "required": [
	            "stateMachineName",
	            "roleArn"
	          ],
	          "members": {
	            "executionNamePrefix": {},
	            "stateMachineName": {},
	            "roleArn": {}
	          }
	        },
	        "timestream": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "databaseName",
	            "tableName",
	            "dimensions"
	          ],
	          "members": {
	            "roleArn": {},
	            "databaseName": {},
	            "tableName": {},
	            "dimensions": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "required": [
	                  "name",
	                  "value"
	                ],
	                "members": {
	                  "name": {},
	                  "value": {}
	                }
	              }
	            },
	            "timestamp": {
	              "type": "structure",
	              "required": [
	                "value",
	                "unit"
	              ],
	              "members": {
	                "value": {},
	                "unit": {}
	              }
	            }
	          }
	        },
	        "http": {
	          "type": "structure",
	          "required": [
	            "url"
	          ],
	          "members": {
	            "url": {},
	            "confirmationUrl": {},
	            "headers": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "required": [
	                  "key",
	                  "value"
	                ],
	                "members": {
	                  "key": {},
	                  "value": {}
	                }
	              }
	            },
	            "auth": {
	              "type": "structure",
	              "members": {
	                "sigv4": {
	                  "type": "structure",
	                  "required": [
	                    "signingRegion",
	                    "serviceName",
	                    "roleArn"
	                  ],
	                  "members": {
	                    "signingRegion": {},
	                    "serviceName": {},
	                    "roleArn": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "kafka": {
	          "type": "structure",
	          "required": [
	            "destinationArn",
	            "topic",
	            "clientProperties"
	          ],
	          "members": {
	            "destinationArn": {},
	            "topic": {},
	            "key": {},
	            "partition": {},
	            "clientProperties": {
	              "type": "map",
	              "key": {},
	              "value": {}
	            }
	          }
	        },
	        "openSearch": {
	          "type": "structure",
	          "required": [
	            "roleArn",
	            "endpoint",
	            "index",
	            "type",
	            "id"
	          ],
	          "members": {
	            "roleArn": {},
	            "endpoint": {},
	            "index": {},
	            "type": {},
	            "id": {}
	          }
	        }
	      }
	    },
	    "Sd6": {
	      "type": "list",
	      "member": {}
	    },
	    "Sd8": {
	      "type": "list",
	      "member": {}
	    },
	    "Sdc": {
	      "type": "structure",
	      "members": {
	        "arn": {},
	        "status": {},
	        "createdAt": {
	          "type": "timestamp"
	        },
	        "lastUpdatedAt": {
	          "type": "timestamp"
	        },
	        "statusReason": {},
	        "httpUrlProperties": {
	          "type": "structure",
	          "members": {
	            "confirmationUrl": {}
	          }
	        },
	        "vpcProperties": {
	          "type": "structure",
	          "members": {
	            "subnetIds": {
	              "shape": "Sd6"
	            },
	            "securityGroups": {
	              "shape": "Sd8"
	            },
	            "vpcId": {},
	            "roleArn": {}
	          }
	        }
	      }
	    },
	    "Sfc": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "members": {
	          "targetArn": {},
	          "roleArn": {},
	          "enabled": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "Sff": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "members": {
	          "enabled": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "Sfk": {
	      "type": "structure",
	      "members": {
	        "findingId": {},
	        "taskId": {},
	        "checkName": {},
	        "taskStartTime": {
	          "type": "timestamp"
	        },
	        "findingTime": {
	          "type": "timestamp"
	        },
	        "severity": {},
	        "nonCompliantResource": {
	          "type": "structure",
	          "members": {
	            "resourceType": {},
	            "resourceIdentifier": {
	              "shape": "S1o"
	            },
	            "additionalInfo": {
	              "shape": "Sfo"
	            }
	          }
	        },
	        "relatedResources": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "resourceType": {},
	              "resourceIdentifier": {
	                "shape": "S1o"
	              },
	              "additionalInfo": {
	                "shape": "Sfo"
	              }
	            }
	          }
	        },
	        "reasonForNonCompliance": {},
	        "reasonForNonComplianceCode": {},
	        "isSuppressed": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Sfo": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sg4": {
	      "type": "structure",
	      "members": {
	        "auditTaskId": {},
	        "findingIds": {
	          "type": "list",
	          "member": {}
	        },
	        "auditCheckToReasonCodeFilter": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "Sg8": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "list",
	        "member": {}
	      }
	    },
	    "Sga": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "id": {},
	          "roleArn": {},
	          "actionParams": {
	            "shape": "S59"
	          }
	        }
	      }
	    },
	    "Sh1": {
	      "type": "structure",
	      "members": {
	        "authorizerName": {},
	        "authorizerArn": {},
	        "authorizerFunctionArn": {},
	        "tokenKeyName": {},
	        "tokenSigningPublicKeys": {
	          "shape": "S25"
	        },
	        "status": {},
	        "creationDate": {
	          "type": "timestamp"
	        },
	        "lastModifiedDate": {
	          "type": "timestamp"
	        },
	        "signingDisabled": {
	          "type": "boolean"
	        },
	        "enableCachingForHttp": {
	          "type": "boolean"
	        }
	      }
	    },
	    "She": {
	      "type": "structure",
	      "members": {
	        "notBefore": {
	          "type": "timestamp"
	        },
	        "notAfter": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Shf": {
	      "type": "structure",
	      "members": {
	        "templateBody": {},
	        "roleArn": {}
	      }
	    },
	    "Sht": {
	      "type": "structure",
	      "members": {
	        "taskId": {},
	        "taskStatus": {},
	        "taskStartTime": {
	          "type": "timestamp"
	        },
	        "taskEndTime": {
	          "type": "timestamp"
	        },
	        "target": {
	          "shape": "Shv"
	        },
	        "violationEventOccurrenceRange": {
	          "shape": "Shy"
	        },
	        "onlyActiveViolationsIncluded": {
	          "type": "boolean"
	        },
	        "suppressedAlertsIncluded": {
	          "type": "boolean"
	        },
	        "actionsDefinition": {
	          "shape": "Sga"
	        },
	        "taskStatistics": {
	          "type": "structure",
	          "members": {
	            "actionsExecuted": {
	              "type": "long"
	            },
	            "actionsSkipped": {
	              "type": "long"
	            },
	            "actionsFailed": {
	              "type": "long"
	            }
	          }
	        }
	      }
	    },
	    "Shv": {
	      "type": "structure",
	      "members": {
	        "violationIds": {
	          "type": "list",
	          "member": {}
	        },
	        "securityProfileName": {},
	        "behaviorName": {}
	      }
	    },
	    "Shy": {
	      "type": "structure",
	      "required": [
	        "startTime",
	        "endTime"
	      ],
	      "members": {
	        "startTime": {
	          "type": "timestamp"
	        },
	        "endTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sij": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "members": {
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "Sjn": {
	      "type": "list",
	      "member": {}
	    },
	    "Skg": {
	      "type": "list",
	      "member": {
	        "shape": "Skh"
	      }
	    },
	    "Skh": {
	      "type": "structure",
	      "members": {
	        "groupName": {},
	        "groupArn": {}
	      }
	    },
	    "Skt": {
	      "type": "structure",
	      "members": {
	        "deprecated": {
	          "type": "boolean"
	        },
	        "deprecationDate": {
	          "type": "timestamp"
	        },
	        "creationDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sls": {
	      "type": "structure",
	      "required": [
	        "thingIndexingMode"
	      ],
	      "members": {
	        "thingIndexingMode": {},
	        "thingConnectivityIndexingMode": {},
	        "deviceDefenderIndexingMode": {},
	        "namedShadowIndexingMode": {},
	        "managedFields": {
	          "shape": "Slx"
	        },
	        "customFields": {
	          "shape": "Slx"
	        }
	      }
	    },
	    "Slx": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "type": {}
	        }
	      }
	    },
	    "Sm1": {
	      "type": "structure",
	      "required": [
	        "thingGroupIndexingMode"
	      ],
	      "members": {
	        "thingGroupIndexingMode": {},
	        "managedFields": {
	          "shape": "Slx"
	        },
	        "customFields": {
	          "shape": "Slx"
	        }
	      }
	    },
	    "Snj": {
	      "type": "structure",
	      "members": {
	        "confidenceLevel": {}
	      }
	    },
	    "Snq": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "policyName": {},
	          "policyArn": {}
	        }
	      }
	    },
	    "Sos": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "certificateArn": {},
	          "certificateId": {},
	          "status": {},
	          "certificateMode": {},
	          "creationDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "Sps": {
	      "type": "structure",
	      "members": {
	        "status": {},
	        "queuedAt": {
	          "type": "timestamp"
	        },
	        "startedAt": {
	          "type": "timestamp"
	        },
	        "lastUpdatedAt": {
	          "type": "timestamp"
	        },
	        "executionNumber": {
	          "type": "long"
	        },
	        "retryAttempt": {
	          "type": "integer"
	        }
	      }
	    },
	    "Squ": {
	      "type": "list",
	      "member": {}
	    },
	    "Sr4": {
	      "type": "list",
	      "member": {}
	    },
	    "Srn": {
	      "type": "structure",
	      "required": [
	        "name",
	        "arn"
	      ],
	      "members": {
	        "name": {},
	        "arn": {}
	      }
	    },
	    "Srs": {
	      "type": "structure",
	      "required": [
	        "arn"
	      ],
	      "members": {
	        "arn": {}
	      }
	    },
	    "Stg": {
	      "type": "structure",
	      "required": [
	        "targetType"
	      ],
	      "members": {
	        "targetType": {},
	        "targetName": {}
	      }
	    },
	    "Suc": {
	      "type": "list",
	      "member": {}
	    },
	    "Sv5": {
	      "type": "structure",
	      "required": [
	        "resources"
	      ],
	      "members": {
	        "actionType": {},
	        "resources": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "Sv9": {
	      "type": "list",
	      "member": {}
	    },
	    "Sxk": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],127:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "GetBehaviorModelTrainingSummaries": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "summaries"
	    },
	    "ListActiveViolations": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "activeViolations"
	    },
	    "ListAttachedPolicies": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "policies"
	    },
	    "ListAuditFindings": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "findings"
	    },
	    "ListAuditMitigationActionsExecutions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "actionsExecutions"
	    },
	    "ListAuditMitigationActionsTasks": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "tasks"
	    },
	    "ListAuditSuppressions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "suppressions"
	    },
	    "ListAuditTasks": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "tasks"
	    },
	    "ListAuthorizers": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "authorizers"
	    },
	    "ListBillingGroups": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "billingGroups"
	    },
	    "ListCACertificates": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "certificates"
	    },
	    "ListCertificates": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "certificates"
	    },
	    "ListCertificatesByCA": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "certificates"
	    },
	    "ListCustomMetrics": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "metricNames"
	    },
	    "ListDetectMitigationActionsExecutions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "actionsExecutions"
	    },
	    "ListDetectMitigationActionsTasks": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "tasks"
	    },
	    "ListDimensions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "dimensionNames"
	    },
	    "ListDomainConfigurations": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "domainConfigurations"
	    },
	    "ListFleetMetrics": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "fleetMetrics"
	    },
	    "ListIndices": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "indexNames"
	    },
	    "ListJobExecutionsForJob": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "executionSummaries"
	    },
	    "ListJobExecutionsForThing": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "executionSummaries"
	    },
	    "ListJobTemplates": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "jobTemplates"
	    },
	    "ListJobs": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "jobs"
	    },
	    "ListMetricValues": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "metricDatumList"
	    },
	    "ListMitigationActions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "actionIdentifiers"
	    },
	    "ListOTAUpdates": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "otaUpdates"
	    },
	    "ListOutgoingCertificates": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "outgoingCertificates"
	    },
	    "ListPolicies": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "policies"
	    },
	    "ListPolicyPrincipals": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "principals"
	    },
	    "ListPrincipalPolicies": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "policies"
	    },
	    "ListPrincipalThings": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "things"
	    },
	    "ListProvisioningTemplateVersions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "versions"
	    },
	    "ListProvisioningTemplates": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "templates"
	    },
	    "ListRoleAliases": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "roleAliases"
	    },
	    "ListScheduledAudits": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "scheduledAudits"
	    },
	    "ListSecurityProfiles": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "securityProfileIdentifiers"
	    },
	    "ListSecurityProfilesForTarget": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "securityProfileTargetMappings"
	    },
	    "ListStreams": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "streams"
	    },
	    "ListTagsForResource": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "tags"
	    },
	    "ListTargetsForPolicy": {
	      "input_token": "marker",
	      "limit_key": "pageSize",
	      "output_token": "nextMarker",
	      "result_key": "targets"
	    },
	    "ListTargetsForSecurityProfile": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "securityProfileTargets"
	    },
	    "ListThingGroups": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "thingGroups"
	    },
	    "ListThingGroupsForThing": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "thingGroups"
	    },
	    "ListThingPrincipals": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "principals"
	    },
	    "ListThingRegistrationTaskReports": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "non_aggregate_keys": [
	        "reportType"
	      ],
	      "output_token": "nextToken",
	      "result_key": "resourceLinks"
	    },
	    "ListThingRegistrationTasks": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "taskIds"
	    },
	    "ListThingTypes": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "thingTypes"
	    },
	    "ListThings": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "things"
	    },
	    "ListThingsInBillingGroup": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "things"
	    },
	    "ListThingsInThingGroup": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "things"
	    },
	    "ListTopicRuleDestinations": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "destinationSummaries"
	    },
	    "ListTopicRules": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "rules"
	    },
	    "ListV2LoggingLevels": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "logTargetConfigurations"
	    },
	    "ListViolationEvents": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "violationEvents"
	    }
	  }
	}
	},{}],128:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-05-28",
	    "endpointPrefix": "data-ats.iot",
	    "protocol": "rest-json",
	    "serviceFullName": "AWS IoT Data Plane",
	    "serviceId": "IoT Data Plane",
	    "signatureVersion": "v4",
	    "signingName": "iotdata",
	    "uid": "iot-data-2015-05-28"
	  },
	  "operations": {
	    "DeleteThingShadow": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/things/{thingName}/shadow"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "shadowName": {
	            "location": "querystring",
	            "locationName": "name"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "payload"
	        ],
	        "members": {
	          "payload": {
	            "type": "blob"
	          }
	        },
	        "payload": "payload"
	      }
	    },
	    "GetRetainedMessage": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/retainedMessage/{topic}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "topic"
	        ],
	        "members": {
	          "topic": {
	            "location": "uri",
	            "locationName": "topic"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "topic": {},
	          "payload": {
	            "type": "blob"
	          },
	          "qos": {
	            "type": "integer"
	          },
	          "lastModifiedTime": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "GetThingShadow": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/things/{thingName}/shadow"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "shadowName": {
	            "location": "querystring",
	            "locationName": "name"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "payload": {
	            "type": "blob"
	          }
	        },
	        "payload": "payload"
	      }
	    },
	    "ListNamedShadowsForThing": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/things/shadow/ListNamedShadowsForThing/{thingName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "pageSize": {
	            "location": "querystring",
	            "locationName": "pageSize",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "results": {
	            "type": "list",
	            "member": {}
	          },
	          "nextToken": {},
	          "timestamp": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "ListRetainedMessages": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/retainedMessage"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "retainedTopics": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "topic": {},
	                "payloadSize": {
	                  "type": "long"
	                },
	                "qos": {
	                  "type": "integer"
	                },
	                "lastModifiedTime": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "Publish": {
	      "http": {
	        "requestUri": "/topics/{topic}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "topic"
	        ],
	        "members": {
	          "topic": {
	            "location": "uri",
	            "locationName": "topic"
	          },
	          "qos": {
	            "location": "querystring",
	            "locationName": "qos",
	            "type": "integer"
	          },
	          "retain": {
	            "location": "querystring",
	            "locationName": "retain",
	            "type": "boolean"
	          },
	          "payload": {
	            "type": "blob"
	          }
	        },
	        "payload": "payload"
	      }
	    },
	    "UpdateThingShadow": {
	      "http": {
	        "requestUri": "/things/{thingName}/shadow"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "thingName",
	          "payload"
	        ],
	        "members": {
	          "thingName": {
	            "location": "uri",
	            "locationName": "thingName"
	          },
	          "shadowName": {
	            "location": "querystring",
	            "locationName": "name"
	          },
	          "payload": {
	            "type": "blob"
	          }
	        },
	        "payload": "payload"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "payload": {
	            "type": "blob"
	          }
	        },
	        "payload": "payload"
	      }
	    }
	  },
	  "shapes": {}
	}
	},{}],129:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListRetainedMessages": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "retainedTopics"
	    }
	  }
	}
	},{}],130:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-11-27",
	    "endpointPrefix": "iotanalytics",
	    "protocol": "rest-json",
	    "serviceFullName": "AWS IoT Analytics",
	    "serviceId": "IoTAnalytics",
	    "signatureVersion": "v4",
	    "signingName": "iotanalytics",
	    "uid": "iotanalytics-2017-11-27"
	  },
	  "operations": {
	    "BatchPutMessage": {
	      "http": {
	        "requestUri": "/messages/batch",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "channelName",
	          "messages"
	        ],
	        "members": {
	          "channelName": {},
	          "messages": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "messageId",
	                "payload"
	              ],
	              "members": {
	                "messageId": {},
	                "payload": {
	                  "type": "blob"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "batchPutMessageErrorEntries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "messageId": {},
	                "errorCode": {},
	                "errorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "CancelPipelineReprocessing": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/pipelines/{pipelineName}/reprocessing/{reprocessingId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName",
	          "reprocessingId"
	        ],
	        "members": {
	          "pipelineName": {
	            "location": "uri",
	            "locationName": "pipelineName"
	          },
	          "reprocessingId": {
	            "location": "uri",
	            "locationName": "reprocessingId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateChannel": {
	      "http": {
	        "requestUri": "/channels",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "channelName"
	        ],
	        "members": {
	          "channelName": {},
	          "channelStorage": {
	            "shape": "Sh"
	          },
	          "retentionPeriod": {
	            "shape": "Sn"
	          },
	          "tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "channelName": {},
	          "channelArn": {},
	          "retentionPeriod": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "CreateDataset": {
	      "http": {
	        "requestUri": "/datasets",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetName",
	          "actions"
	        ],
	        "members": {
	          "datasetName": {},
	          "actions": {
	            "shape": "Sy"
	          },
	          "triggers": {
	            "shape": "S1l"
	          },
	          "contentDeliveryRules": {
	            "shape": "S1q"
	          },
	          "retentionPeriod": {
	            "shape": "Sn"
	          },
	          "versioningConfiguration": {
	            "shape": "S21"
	          },
	          "tags": {
	            "shape": "Sq"
	          },
	          "lateDataRules": {
	            "shape": "S24"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetName": {},
	          "datasetArn": {},
	          "retentionPeriod": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "CreateDatasetContent": {
	      "http": {
	        "requestUri": "/datasets/{datasetName}/content"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetName"
	        ],
	        "members": {
	          "datasetName": {
	            "location": "uri",
	            "locationName": "datasetName"
	          },
	          "versionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "versionId": {}
	        }
	      }
	    },
	    "CreateDatastore": {
	      "http": {
	        "requestUri": "/datastores",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datastoreName"
	        ],
	        "members": {
	          "datastoreName": {},
	          "datastoreStorage": {
	            "shape": "S2h"
	          },
	          "retentionPeriod": {
	            "shape": "Sn"
	          },
	          "tags": {
	            "shape": "Sq"
	          },
	          "fileFormatConfiguration": {
	            "shape": "S2m"
	          },
	          "datastorePartitions": {
	            "shape": "S2u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datastoreName": {},
	          "datastoreArn": {},
	          "retentionPeriod": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "CreatePipeline": {
	      "http": {
	        "requestUri": "/pipelines",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName",
	          "pipelineActivities"
	        ],
	        "members": {
	          "pipelineName": {},
	          "pipelineActivities": {
	            "shape": "S34"
	          },
	          "tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipelineName": {},
	          "pipelineArn": {}
	        }
	      }
	    },
	    "DeleteChannel": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/channels/{channelName}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "channelName"
	        ],
	        "members": {
	          "channelName": {
	            "location": "uri",
	            "locationName": "channelName"
	          }
	        }
	      }
	    },
	    "DeleteDataset": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/datasets/{datasetName}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetName"
	        ],
	        "members": {
	          "datasetName": {
	            "location": "uri",
	            "locationName": "datasetName"
	          }
	        }
	      }
	    },
	    "DeleteDatasetContent": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/datasets/{datasetName}/content",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetName"
	        ],
	        "members": {
	          "datasetName": {
	            "location": "uri",
	            "locationName": "datasetName"
	          },
	          "versionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          }
	        }
	      }
	    },
	    "DeleteDatastore": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/datastores/{datastoreName}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datastoreName"
	        ],
	        "members": {
	          "datastoreName": {
	            "location": "uri",
	            "locationName": "datastoreName"
	          }
	        }
	      }
	    },
	    "DeletePipeline": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/pipelines/{pipelineName}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName"
	        ],
	        "members": {
	          "pipelineName": {
	            "location": "uri",
	            "locationName": "pipelineName"
	          }
	        }
	      }
	    },
	    "DescribeChannel": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/channels/{channelName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "channelName"
	        ],
	        "members": {
	          "channelName": {
	            "location": "uri",
	            "locationName": "channelName"
	          },
	          "includeStatistics": {
	            "location": "querystring",
	            "locationName": "includeStatistics",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "channel": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "storage": {
	                "shape": "Sh"
	              },
	              "arn": {},
	              "status": {},
	              "retentionPeriod": {
	                "shape": "Sn"
	              },
	              "creationTime": {
	                "type": "timestamp"
	              },
	              "lastUpdateTime": {
	                "type": "timestamp"
	              },
	              "lastMessageArrivalTime": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "statistics": {
	            "type": "structure",
	            "members": {
	              "size": {
	                "shape": "S42"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeDataset": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/datasets/{datasetName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetName"
	        ],
	        "members": {
	          "datasetName": {
	            "location": "uri",
	            "locationName": "datasetName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "dataset": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "arn": {},
	              "actions": {
	                "shape": "Sy"
	              },
	              "triggers": {
	                "shape": "S1l"
	              },
	              "contentDeliveryRules": {
	                "shape": "S1q"
	              },
	              "status": {},
	              "creationTime": {
	                "type": "timestamp"
	              },
	              "lastUpdateTime": {
	                "type": "timestamp"
	              },
	              "retentionPeriod": {
	                "shape": "Sn"
	              },
	              "versioningConfiguration": {
	                "shape": "S21"
	              },
	              "lateDataRules": {
	                "shape": "S24"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeDatastore": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/datastores/{datastoreName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datastoreName"
	        ],
	        "members": {
	          "datastoreName": {
	            "location": "uri",
	            "locationName": "datastoreName"
	          },
	          "includeStatistics": {
	            "location": "querystring",
	            "locationName": "includeStatistics",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datastore": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "storage": {
	                "shape": "S2h"
	              },
	              "arn": {},
	              "status": {},
	              "retentionPeriod": {
	                "shape": "Sn"
	              },
	              "creationTime": {
	                "type": "timestamp"
	              },
	              "lastUpdateTime": {
	                "type": "timestamp"
	              },
	              "lastMessageArrivalTime": {
	                "type": "timestamp"
	              },
	              "fileFormatConfiguration": {
	                "shape": "S2m"
	              },
	              "datastorePartitions": {
	                "shape": "S2u"
	              }
	            }
	          },
	          "statistics": {
	            "type": "structure",
	            "members": {
	              "size": {
	                "shape": "S42"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeLoggingOptions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/logging"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "loggingOptions": {
	            "shape": "S4f"
	          }
	        }
	      }
	    },
	    "DescribePipeline": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/pipelines/{pipelineName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName"
	        ],
	        "members": {
	          "pipelineName": {
	            "location": "uri",
	            "locationName": "pipelineName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipeline": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "arn": {},
	              "activities": {
	                "shape": "S34"
	              },
	              "reprocessingSummaries": {
	                "shape": "S4l"
	              },
	              "creationTime": {
	                "type": "timestamp"
	              },
	              "lastUpdateTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetDatasetContent": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/datasets/{datasetName}/content"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetName"
	        ],
	        "members": {
	          "datasetName": {
	            "location": "uri",
	            "locationName": "datasetName"
	          },
	          "versionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "entryName": {},
	                "dataURI": {}
	              }
	            }
	          },
	          "timestamp": {
	            "type": "timestamp"
	          },
	          "status": {
	            "shape": "S4t"
	          }
	        }
	      }
	    },
	    "ListChannels": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/channels"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "channelSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "channelName": {},
	                "channelStorage": {
	                  "type": "structure",
	                  "members": {
	                    "serviceManagedS3": {
	                      "type": "structure",
	                      "members": {}
	                    },
	                    "customerManagedS3": {
	                      "type": "structure",
	                      "members": {
	                        "bucket": {},
	                        "keyPrefix": {},
	                        "roleArn": {}
	                      }
	                    }
	                  }
	                },
	                "status": {},
	                "creationTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdateTime": {
	                  "type": "timestamp"
	                },
	                "lastMessageArrivalTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDatasetContents": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/datasets/{datasetName}/contents"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetName"
	        ],
	        "members": {
	          "datasetName": {
	            "location": "uri",
	            "locationName": "datasetName"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "scheduledOnOrAfter": {
	            "location": "querystring",
	            "locationName": "scheduledOnOrAfter",
	            "type": "timestamp"
	          },
	          "scheduledBefore": {
	            "location": "querystring",
	            "locationName": "scheduledBefore",
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetContentSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "version": {},
	                "status": {
	                  "shape": "S4t"
	                },
	                "creationTime": {
	                  "type": "timestamp"
	                },
	                "scheduleTime": {
	                  "type": "timestamp"
	                },
	                "completionTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDatasets": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/datasets"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "datasetName": {},
	                "status": {},
	                "creationTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdateTime": {
	                  "type": "timestamp"
	                },
	                "triggers": {
	                  "shape": "S1l"
	                },
	                "actions": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "actionName": {},
	                      "actionType": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListDatastores": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/datastores"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datastoreSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "datastoreName": {},
	                "datastoreStorage": {
	                  "type": "structure",
	                  "members": {
	                    "serviceManagedS3": {
	                      "type": "structure",
	                      "members": {}
	                    },
	                    "customerManagedS3": {
	                      "type": "structure",
	                      "members": {
	                        "bucket": {},
	                        "keyPrefix": {},
	                        "roleArn": {}
	                      }
	                    },
	                    "iotSiteWiseMultiLayerStorage": {
	                      "type": "structure",
	                      "members": {
	                        "customerManagedS3Storage": {
	                          "type": "structure",
	                          "members": {
	                            "bucket": {},
	                            "keyPrefix": {}
	                          }
	                        }
	                      }
	                    }
	                  }
	                },
	                "status": {},
	                "creationTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdateTime": {
	                  "type": "timestamp"
	                },
	                "lastMessageArrivalTime": {
	                  "type": "timestamp"
	                },
	                "fileFormatType": {},
	                "datastorePartitions": {
	                  "shape": "S2u"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListPipelines": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/pipelines"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "pipelineSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "pipelineName": {},
	                "reprocessingSummaries": {
	                  "shape": "S4l"
	                },
	                "creationTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/tags"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "querystring",
	            "locationName": "resourceArn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tags": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "PutLoggingOptions": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/logging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "loggingOptions"
	        ],
	        "members": {
	          "loggingOptions": {
	            "shape": "S4f"
	          }
	        }
	      }
	    },
	    "RunPipelineActivity": {
	      "http": {
	        "requestUri": "/pipelineactivities/run"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineActivity",
	          "payloads"
	        ],
	        "members": {
	          "pipelineActivity": {
	            "shape": "S35"
	          },
	          "payloads": {
	            "shape": "S5z"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "payloads": {
	            "shape": "S5z"
	          },
	          "logResult": {}
	        }
	      }
	    },
	    "SampleChannelData": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/channels/{channelName}/sample"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "channelName"
	        ],
	        "members": {
	          "channelName": {
	            "location": "uri",
	            "locationName": "channelName"
	          },
	          "maxMessages": {
	            "location": "querystring",
	            "locationName": "maxMessages",
	            "type": "integer"
	          },
	          "startTime": {
	            "location": "querystring",
	            "locationName": "startTime",
	            "type": "timestamp"
	          },
	          "endTime": {
	            "location": "querystring",
	            "locationName": "endTime",
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "payloads": {
	            "shape": "S5z"
	          }
	        }
	      }
	    },
	    "StartPipelineReprocessing": {
	      "http": {
	        "requestUri": "/pipelines/{pipelineName}/reprocessing"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName"
	        ],
	        "members": {
	          "pipelineName": {
	            "location": "uri",
	            "locationName": "pipelineName"
	          },
	          "startTime": {
	            "type": "timestamp"
	          },
	          "endTime": {
	            "type": "timestamp"
	          },
	          "channelMessages": {
	            "type": "structure",
	            "members": {
	              "s3Paths": {
	                "type": "list",
	                "member": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "reprocessingId": {}
	        }
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/tags",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tags"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "querystring",
	            "locationName": "resourceArn"
	          },
	          "tags": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/tags",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tagKeys"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "querystring",
	            "locationName": "resourceArn"
	          },
	          "tagKeys": {
	            "location": "querystring",
	            "locationName": "tagKeys",
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateChannel": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/channels/{channelName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "channelName"
	        ],
	        "members": {
	          "channelName": {
	            "location": "uri",
	            "locationName": "channelName"
	          },
	          "channelStorage": {
	            "shape": "Sh"
	          },
	          "retentionPeriod": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "UpdateDataset": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/datasets/{datasetName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetName",
	          "actions"
	        ],
	        "members": {
	          "datasetName": {
	            "location": "uri",
	            "locationName": "datasetName"
	          },
	          "actions": {
	            "shape": "Sy"
	          },
	          "triggers": {
	            "shape": "S1l"
	          },
	          "contentDeliveryRules": {
	            "shape": "S1q"
	          },
	          "retentionPeriod": {
	            "shape": "Sn"
	          },
	          "versioningConfiguration": {
	            "shape": "S21"
	          },
	          "lateDataRules": {
	            "shape": "S24"
	          }
	        }
	      }
	    },
	    "UpdateDatastore": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/datastores/{datastoreName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datastoreName"
	        ],
	        "members": {
	          "datastoreName": {
	            "location": "uri",
	            "locationName": "datastoreName"
	          },
	          "retentionPeriod": {
	            "shape": "Sn"
	          },
	          "datastoreStorage": {
	            "shape": "S2h"
	          },
	          "fileFormatConfiguration": {
	            "shape": "S2m"
	          }
	        }
	      }
	    },
	    "UpdatePipeline": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/pipelines/{pipelineName}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "pipelineName",
	          "pipelineActivities"
	        ],
	        "members": {
	          "pipelineName": {
	            "location": "uri",
	            "locationName": "pipelineName"
	          },
	          "pipelineActivities": {
	            "shape": "S34"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sh": {
	      "type": "structure",
	      "members": {
	        "serviceManagedS3": {
	          "type": "structure",
	          "members": {}
	        },
	        "customerManagedS3": {
	          "type": "structure",
	          "required": [
	            "bucket",
	            "roleArn"
	          ],
	          "members": {
	            "bucket": {},
	            "keyPrefix": {},
	            "roleArn": {}
	          }
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "members": {
	        "unlimited": {
	          "type": "boolean"
	        },
	        "numberOfDays": {
	          "type": "integer"
	        }
	      }
	    },
	    "Sq": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "key",
	          "value"
	        ],
	        "members": {
	          "key": {},
	          "value": {}
	        }
	      }
	    },
	    "Sy": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "actionName": {},
	          "queryAction": {
	            "type": "structure",
	            "required": [
	              "sqlQuery"
	            ],
	            "members": {
	              "sqlQuery": {},
	              "filters": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "deltaTime": {
	                      "type": "structure",
	                      "required": [
	                        "offsetSeconds",
	                        "timeExpression"
	                      ],
	                      "members": {
	                        "offsetSeconds": {
	                          "type": "integer"
	                        },
	                        "timeExpression": {}
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "containerAction": {
	            "type": "structure",
	            "required": [
	              "image",
	              "executionRoleArn",
	              "resourceConfiguration"
	            ],
	            "members": {
	              "image": {},
	              "executionRoleArn": {},
	              "resourceConfiguration": {
	                "type": "structure",
	                "required": [
	                  "computeType",
	                  "volumeSizeInGB"
	                ],
	                "members": {
	                  "computeType": {},
	                  "volumeSizeInGB": {
	                    "type": "integer"
	                  }
	                }
	              },
	              "variables": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "name"
	                  ],
	                  "members": {
	                    "name": {},
	                    "stringValue": {},
	                    "doubleValue": {
	                      "type": "double"
	                    },
	                    "datasetContentVersionValue": {
	                      "type": "structure",
	                      "required": [
	                        "datasetName"
	                      ],
	                      "members": {
	                        "datasetName": {}
	                      }
	                    },
	                    "outputFileUriValue": {
	                      "type": "structure",
	                      "required": [
	                        "fileName"
	                      ],
	                      "members": {
	                        "fileName": {}
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1l": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "schedule": {
	            "type": "structure",
	            "members": {
	              "expression": {}
	            }
	          },
	          "dataset": {
	            "type": "structure",
	            "required": [
	              "name"
	            ],
	            "members": {
	              "name": {}
	            }
	          }
	        }
	      }
	    },
	    "S1q": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "destination"
	        ],
	        "members": {
	          "entryName": {},
	          "destination": {
	            "type": "structure",
	            "members": {
	              "iotEventsDestinationConfiguration": {
	                "type": "structure",
	                "required": [
	                  "inputName",
	                  "roleArn"
	                ],
	                "members": {
	                  "inputName": {},
	                  "roleArn": {}
	                }
	              },
	              "s3DestinationConfiguration": {
	                "type": "structure",
	                "required": [
	                  "bucket",
	                  "key",
	                  "roleArn"
	                ],
	                "members": {
	                  "bucket": {},
	                  "key": {},
	                  "glueConfiguration": {
	                    "type": "structure",
	                    "required": [
	                      "tableName",
	                      "databaseName"
	                    ],
	                    "members": {
	                      "tableName": {},
	                      "databaseName": {}
	                    }
	                  },
	                  "roleArn": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S21": {
	      "type": "structure",
	      "members": {
	        "unlimited": {
	          "type": "boolean"
	        },
	        "maxVersions": {
	          "type": "integer"
	        }
	      }
	    },
	    "S24": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "ruleConfiguration"
	        ],
	        "members": {
	          "ruleName": {},
	          "ruleConfiguration": {
	            "type": "structure",
	            "members": {
	              "deltaTimeSessionWindowConfiguration": {
	                "type": "structure",
	                "required": [
	                  "timeoutInMinutes"
	                ],
	                "members": {
	                  "timeoutInMinutes": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2h": {
	      "type": "structure",
	      "members": {
	        "serviceManagedS3": {
	          "type": "structure",
	          "members": {}
	        },
	        "customerManagedS3": {
	          "type": "structure",
	          "required": [
	            "bucket",
	            "roleArn"
	          ],
	          "members": {
	            "bucket": {},
	            "keyPrefix": {},
	            "roleArn": {}
	          }
	        },
	        "iotSiteWiseMultiLayerStorage": {
	          "type": "structure",
	          "required": [
	            "customerManagedS3Storage"
	          ],
	          "members": {
	            "customerManagedS3Storage": {
	              "type": "structure",
	              "required": [
	                "bucket"
	              ],
	              "members": {
	                "bucket": {},
	                "keyPrefix": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2m": {
	      "type": "structure",
	      "members": {
	        "jsonConfiguration": {
	          "type": "structure",
	          "members": {}
	        },
	        "parquetConfiguration": {
	          "type": "structure",
	          "members": {
	            "schemaDefinition": {
	              "type": "structure",
	              "members": {
	                "columns": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "required": [
	                      "name",
	                      "type"
	                    ],
	                    "members": {
	                      "name": {},
	                      "type": {}
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2u": {
	      "type": "structure",
	      "members": {
	        "partitions": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "attributePartition": {
	                "type": "structure",
	                "required": [
	                  "attributeName"
	                ],
	                "members": {
	                  "attributeName": {}
	                }
	              },
	              "timestampPartition": {
	                "type": "structure",
	                "required": [
	                  "attributeName"
	                ],
	                "members": {
	                  "attributeName": {},
	                  "timestampFormat": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S34": {
	      "type": "list",
	      "member": {
	        "shape": "S35"
	      }
	    },
	    "S35": {
	      "type": "structure",
	      "members": {
	        "channel": {
	          "type": "structure",
	          "required": [
	            "name",
	            "channelName"
	          ],
	          "members": {
	            "name": {},
	            "channelName": {},
	            "next": {}
	          }
	        },
	        "lambda": {
	          "type": "structure",
	          "required": [
	            "name",
	            "lambdaName",
	            "batchSize"
	          ],
	          "members": {
	            "name": {},
	            "lambdaName": {},
	            "batchSize": {
	              "type": "integer"
	            },
	            "next": {}
	          }
	        },
	        "datastore": {
	          "type": "structure",
	          "required": [
	            "name",
	            "datastoreName"
	          ],
	          "members": {
	            "name": {},
	            "datastoreName": {}
	          }
	        },
	        "addAttributes": {
	          "type": "structure",
	          "required": [
	            "name",
	            "attributes"
	          ],
	          "members": {
	            "name": {},
	            "attributes": {
	              "type": "map",
	              "key": {},
	              "value": {}
	            },
	            "next": {}
	          }
	        },
	        "removeAttributes": {
	          "type": "structure",
	          "required": [
	            "name",
	            "attributes"
	          ],
	          "members": {
	            "name": {},
	            "attributes": {
	              "shape": "S3g"
	            },
	            "next": {}
	          }
	        },
	        "selectAttributes": {
	          "type": "structure",
	          "required": [
	            "name",
	            "attributes"
	          ],
	          "members": {
	            "name": {},
	            "attributes": {
	              "shape": "S3g"
	            },
	            "next": {}
	          }
	        },
	        "filter": {
	          "type": "structure",
	          "required": [
	            "name",
	            "filter"
	          ],
	          "members": {
	            "name": {},
	            "filter": {},
	            "next": {}
	          }
	        },
	        "math": {
	          "type": "structure",
	          "required": [
	            "name",
	            "attribute",
	            "math"
	          ],
	          "members": {
	            "name": {},
	            "attribute": {},
	            "math": {},
	            "next": {}
	          }
	        },
	        "deviceRegistryEnrich": {
	          "type": "structure",
	          "required": [
	            "name",
	            "attribute",
	            "thingName",
	            "roleArn"
	          ],
	          "members": {
	            "name": {},
	            "attribute": {},
	            "thingName": {},
	            "roleArn": {},
	            "next": {}
	          }
	        },
	        "deviceShadowEnrich": {
	          "type": "structure",
	          "required": [
	            "name",
	            "attribute",
	            "thingName",
	            "roleArn"
	          ],
	          "members": {
	            "name": {},
	            "attribute": {},
	            "thingName": {},
	            "roleArn": {},
	            "next": {}
	          }
	        }
	      }
	    },
	    "S3g": {
	      "type": "list",
	      "member": {}
	    },
	    "S42": {
	      "type": "structure",
	      "members": {
	        "estimatedSizeInBytes": {
	          "type": "double"
	        },
	        "estimatedOn": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S4f": {
	      "type": "structure",
	      "required": [
	        "roleArn",
	        "level",
	        "enabled"
	      ],
	      "members": {
	        "roleArn": {},
	        "level": {},
	        "enabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S4l": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "id": {},
	          "status": {},
	          "creationTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "S4t": {
	      "type": "structure",
	      "members": {
	        "state": {},
	        "reason": {}
	      }
	    },
	    "S5z": {
	      "type": "list",
	      "member": {
	        "type": "blob"
	      }
	    }
	  }
	}
	},{}],131:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListChannels": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListDatasetContents": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListDatasets": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListDatastores": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "ListPipelines": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    }
	  }
	}
	
	},{}],132:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2013-12-02",
	    "endpointPrefix": "kinesis",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "protocolSettings": {
	      "h2": "eventstream"
	    },
	    "serviceAbbreviation": "Kinesis",
	    "serviceFullName": "Amazon Kinesis",
	    "serviceId": "Kinesis",
	    "signatureVersion": "v4",
	    "targetPrefix": "Kinesis_20131202",
	    "uid": "kinesis-2013-12-02"
	  },
	  "operations": {
	    "AddTagsToStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "Tags"
	        ],
	        "members": {
	          "StreamName": {},
	          "Tags": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          }
	        }
	      }
	    },
	    "CreateStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName"
	        ],
	        "members": {
	          "StreamName": {},
	          "ShardCount": {
	            "type": "integer"
	          },
	          "StreamModeDetails": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "DecreaseStreamRetentionPeriod": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "RetentionPeriodHours"
	        ],
	        "members": {
	          "StreamName": {},
	          "RetentionPeriodHours": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "DeleteStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName"
	        ],
	        "members": {
	          "StreamName": {},
	          "EnforceConsumerDeletion": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeregisterStreamConsumer": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StreamARN": {},
	          "ConsumerName": {},
	          "ConsumerARN": {}
	        }
	      }
	    },
	    "DescribeLimits": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ShardLimit",
	          "OpenShardCount",
	          "OnDemandStreamCount",
	          "OnDemandStreamCountLimit"
	        ],
	        "members": {
	          "ShardLimit": {
	            "type": "integer"
	          },
	          "OpenShardCount": {
	            "type": "integer"
	          },
	          "OnDemandStreamCount": {
	            "type": "integer"
	          },
	          "OnDemandStreamCountLimit": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "DescribeStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName"
	        ],
	        "members": {
	          "StreamName": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "ExclusiveStartShardId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "StreamDescription"
	        ],
	        "members": {
	          "StreamDescription": {
	            "type": "structure",
	            "required": [
	              "StreamName",
	              "StreamARN",
	              "StreamStatus",
	              "Shards",
	              "HasMoreShards",
	              "RetentionPeriodHours",
	              "StreamCreationTimestamp",
	              "EnhancedMonitoring"
	            ],
	            "members": {
	              "StreamName": {},
	              "StreamARN": {},
	              "StreamStatus": {},
	              "StreamModeDetails": {
	                "shape": "S8"
	              },
	              "Shards": {
	                "shape": "St"
	              },
	              "HasMoreShards": {
	                "type": "boolean"
	              },
	              "RetentionPeriodHours": {
	                "type": "integer"
	              },
	              "StreamCreationTimestamp": {
	                "type": "timestamp"
	              },
	              "EnhancedMonitoring": {
	                "shape": "S10"
	              },
	              "EncryptionType": {},
	              "KeyId": {}
	            }
	          }
	        }
	      }
	    },
	    "DescribeStreamConsumer": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StreamARN": {},
	          "ConsumerName": {},
	          "ConsumerARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ConsumerDescription"
	        ],
	        "members": {
	          "ConsumerDescription": {
	            "type": "structure",
	            "required": [
	              "ConsumerName",
	              "ConsumerARN",
	              "ConsumerStatus",
	              "ConsumerCreationTimestamp",
	              "StreamARN"
	            ],
	            "members": {
	              "ConsumerName": {},
	              "ConsumerARN": {},
	              "ConsumerStatus": {},
	              "ConsumerCreationTimestamp": {
	                "type": "timestamp"
	              },
	              "StreamARN": {}
	            }
	          }
	        }
	      }
	    },
	    "DescribeStreamSummary": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName"
	        ],
	        "members": {
	          "StreamName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "StreamDescriptionSummary"
	        ],
	        "members": {
	          "StreamDescriptionSummary": {
	            "type": "structure",
	            "required": [
	              "StreamName",
	              "StreamARN",
	              "StreamStatus",
	              "RetentionPeriodHours",
	              "StreamCreationTimestamp",
	              "EnhancedMonitoring",
	              "OpenShardCount"
	            ],
	            "members": {
	              "StreamName": {},
	              "StreamARN": {},
	              "StreamStatus": {},
	              "StreamModeDetails": {
	                "shape": "S8"
	              },
	              "RetentionPeriodHours": {
	                "type": "integer"
	              },
	              "StreamCreationTimestamp": {
	                "type": "timestamp"
	              },
	              "EnhancedMonitoring": {
	                "shape": "S10"
	              },
	              "EncryptionType": {},
	              "KeyId": {},
	              "OpenShardCount": {
	                "type": "integer"
	              },
	              "ConsumerCount": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DisableEnhancedMonitoring": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "ShardLevelMetrics"
	        ],
	        "members": {
	          "StreamName": {},
	          "ShardLevelMetrics": {
	            "shape": "S12"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1f"
	      }
	    },
	    "EnableEnhancedMonitoring": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "ShardLevelMetrics"
	        ],
	        "members": {
	          "StreamName": {},
	          "ShardLevelMetrics": {
	            "shape": "S12"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1f"
	      }
	    },
	    "GetRecords": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ShardIterator"
	        ],
	        "members": {
	          "ShardIterator": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Records"
	        ],
	        "members": {
	          "Records": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "SequenceNumber",
	                "Data",
	                "PartitionKey"
	              ],
	              "members": {
	                "SequenceNumber": {},
	                "ApproximateArrivalTimestamp": {
	                  "type": "timestamp"
	                },
	                "Data": {
	                  "type": "blob"
	                },
	                "PartitionKey": {},
	                "EncryptionType": {}
	              }
	            }
	          },
	          "NextShardIterator": {},
	          "MillisBehindLatest": {
	            "type": "long"
	          },
	          "ChildShards": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ShardId",
	                "ParentShards",
	                "HashKeyRange"
	              ],
	              "members": {
	                "ShardId": {},
	                "ParentShards": {
	                  "type": "list",
	                  "member": {}
	                },
	                "HashKeyRange": {
	                  "shape": "Sv"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetShardIterator": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "ShardId",
	          "ShardIteratorType"
	        ],
	        "members": {
	          "StreamName": {},
	          "ShardId": {},
	          "ShardIteratorType": {},
	          "StartingSequenceNumber": {},
	          "Timestamp": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ShardIterator": {}
	        }
	      }
	    },
	    "IncreaseStreamRetentionPeriod": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "RetentionPeriodHours"
	        ],
	        "members": {
	          "StreamName": {},
	          "RetentionPeriodHours": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "ListShards": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StreamName": {},
	          "NextToken": {},
	          "ExclusiveStartShardId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "StreamCreationTimestamp": {
	            "type": "timestamp"
	          },
	          "ShardFilter": {
	            "type": "structure",
	            "required": [
	              "Type"
	            ],
	            "members": {
	              "Type": {},
	              "ShardId": {},
	              "Timestamp": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Shards": {
	            "shape": "St"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListStreamConsumers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamARN"
	        ],
	        "members": {
	          "StreamARN": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "StreamCreationTimestamp": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Consumers": {
	            "type": "list",
	            "member": {
	              "shape": "S27"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListStreams": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Limit": {
	            "type": "integer"
	          },
	          "ExclusiveStartStreamName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "StreamNames",
	          "HasMoreStreams"
	        ],
	        "members": {
	          "StreamNames": {
	            "type": "list",
	            "member": {}
	          },
	          "HasMoreStreams": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ListTagsForStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName"
	        ],
	        "members": {
	          "StreamName": {},
	          "ExclusiveStartTagKey": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Tags",
	          "HasMoreTags"
	        ],
	        "members": {
	          "Tags": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key"
	              ],
	              "members": {
	                "Key": {},
	                "Value": {}
	              }
	            }
	          },
	          "HasMoreTags": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "MergeShards": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "ShardToMerge",
	          "AdjacentShardToMerge"
	        ],
	        "members": {
	          "StreamName": {},
	          "ShardToMerge": {},
	          "AdjacentShardToMerge": {}
	        }
	      }
	    },
	    "PutRecord": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "Data",
	          "PartitionKey"
	        ],
	        "members": {
	          "StreamName": {},
	          "Data": {
	            "type": "blob"
	          },
	          "PartitionKey": {},
	          "ExplicitHashKey": {},
	          "SequenceNumberForOrdering": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ShardId",
	          "SequenceNumber"
	        ],
	        "members": {
	          "ShardId": {},
	          "SequenceNumber": {},
	          "EncryptionType": {}
	        }
	      }
	    },
	    "PutRecords": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Records",
	          "StreamName"
	        ],
	        "members": {
	          "Records": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Data",
	                "PartitionKey"
	              ],
	              "members": {
	                "Data": {
	                  "type": "blob"
	                },
	                "ExplicitHashKey": {},
	                "PartitionKey": {}
	              }
	            }
	          },
	          "StreamName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Records"
	        ],
	        "members": {
	          "FailedRecordCount": {
	            "type": "integer"
	          },
	          "Records": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "SequenceNumber": {},
	                "ShardId": {},
	                "ErrorCode": {},
	                "ErrorMessage": {}
	              }
	            }
	          },
	          "EncryptionType": {}
	        }
	      }
	    },
	    "RegisterStreamConsumer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamARN",
	          "ConsumerName"
	        ],
	        "members": {
	          "StreamARN": {},
	          "ConsumerName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Consumer"
	        ],
	        "members": {
	          "Consumer": {
	            "shape": "S27"
	          }
	        }
	      }
	    },
	    "RemoveTagsFromStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "TagKeys"
	        ],
	        "members": {
	          "StreamName": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "SplitShard": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "ShardToSplit",
	          "NewStartingHashKey"
	        ],
	        "members": {
	          "StreamName": {},
	          "ShardToSplit": {},
	          "NewStartingHashKey": {}
	        }
	      }
	    },
	    "StartStreamEncryption": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "EncryptionType",
	          "KeyId"
	        ],
	        "members": {
	          "StreamName": {},
	          "EncryptionType": {},
	          "KeyId": {}
	        }
	      }
	    },
	    "StopStreamEncryption": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "EncryptionType",
	          "KeyId"
	        ],
	        "members": {
	          "StreamName": {},
	          "EncryptionType": {},
	          "KeyId": {}
	        }
	      }
	    },
	    "UpdateShardCount": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName",
	          "TargetShardCount",
	          "ScalingType"
	        ],
	        "members": {
	          "StreamName": {},
	          "TargetShardCount": {
	            "type": "integer"
	          },
	          "ScalingType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamName": {},
	          "CurrentShardCount": {
	            "type": "integer"
	          },
	          "TargetShardCount": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "UpdateStreamMode": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamARN",
	          "StreamModeDetails"
	        ],
	        "members": {
	          "StreamARN": {},
	          "StreamModeDetails": {
	            "shape": "S8"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S8": {
	      "type": "structure",
	      "required": [
	        "StreamMode"
	      ],
	      "members": {
	        "StreamMode": {}
	      }
	    },
	    "St": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "ShardId",
	          "HashKeyRange",
	          "SequenceNumberRange"
	        ],
	        "members": {
	          "ShardId": {},
	          "ParentShardId": {},
	          "AdjacentParentShardId": {},
	          "HashKeyRange": {
	            "shape": "Sv"
	          },
	          "SequenceNumberRange": {
	            "type": "structure",
	            "required": [
	              "StartingSequenceNumber"
	            ],
	            "members": {
	              "StartingSequenceNumber": {},
	              "EndingSequenceNumber": {}
	            }
	          }
	        }
	      }
	    },
	    "Sv": {
	      "type": "structure",
	      "required": [
	        "StartingHashKey",
	        "EndingHashKey"
	      ],
	      "members": {
	        "StartingHashKey": {},
	        "EndingHashKey": {}
	      }
	    },
	    "S10": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ShardLevelMetrics": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "S12": {
	      "type": "list",
	      "member": {}
	    },
	    "S1f": {
	      "type": "structure",
	      "members": {
	        "StreamName": {},
	        "CurrentShardLevelMetrics": {
	          "shape": "S12"
	        },
	        "DesiredShardLevelMetrics": {
	          "shape": "S12"
	        }
	      }
	    },
	    "S27": {
	      "type": "structure",
	      "required": [
	        "ConsumerName",
	        "ConsumerARN",
	        "ConsumerStatus",
	        "ConsumerCreationTimestamp"
	      ],
	      "members": {
	        "ConsumerName": {},
	        "ConsumerARN": {},
	        "ConsumerStatus": {},
	        "ConsumerCreationTimestamp": {
	          "type": "timestamp"
	        }
	      }
	    }
	  }
	}
	},{}],133:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeStream": {
	      "input_token": "ExclusiveStartShardId",
	      "limit_key": "Limit",
	      "more_results": "StreamDescription.HasMoreShards",
	      "output_token": "StreamDescription.Shards[-1].ShardId",
	      "result_key": "StreamDescription.Shards"
	    },
	    "ListStreamConsumers": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListStreams": {
	      "input_token": "ExclusiveStartStreamName",
	      "limit_key": "Limit",
	      "more_results": "HasMoreStreams",
	      "output_token": "StreamNames[-1]",
	      "result_key": "StreamNames"
	    }
	  }
	}
	},{}],134:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "StreamExists": {
	      "delay": 10,
	      "operation": "DescribeStream",
	      "maxAttempts": 18,
	      "acceptors": [
	        {
	          "expected": "ACTIVE",
	          "matcher": "path",
	          "state": "success",
	          "argument": "StreamDescription.StreamStatus"
	        }
	      ]
	    },
	    "StreamNotExists": {
	      "delay": 10,
	      "operation": "DescribeStream",
	      "maxAttempts": 18,
	      "acceptors": [
	        {
	          "expected": "ResourceNotFoundException",
	          "matcher": "error",
	          "state": "success"
	        }
	      ]
	    }
	  }
	}
	
	},{}],135:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-09-30",
	    "endpointPrefix": "kinesisvideo",
	    "protocol": "rest-json",
	    "serviceAbbreviation": "Kinesis Video Archived Media",
	    "serviceFullName": "Amazon Kinesis Video Streams Archived Media",
	    "serviceId": "Kinesis Video Archived Media",
	    "signatureVersion": "v4",
	    "uid": "kinesis-video-archived-media-2017-09-30"
	  },
	  "operations": {
	    "GetClip": {
	      "http": {
	        "requestUri": "/getClip"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClipFragmentSelector"
	        ],
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "ClipFragmentSelector": {
	            "type": "structure",
	            "required": [
	              "FragmentSelectorType",
	              "TimestampRange"
	            ],
	            "members": {
	              "FragmentSelectorType": {},
	              "TimestampRange": {
	                "type": "structure",
	                "required": [
	                  "StartTimestamp",
	                  "EndTimestamp"
	                ],
	                "members": {
	                  "StartTimestamp": {
	                    "type": "timestamp"
	                  },
	                  "EndTimestamp": {
	                    "type": "timestamp"
	                  }
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "Payload": {
	            "shape": "Sa"
	          }
	        },
	        "payload": "Payload"
	      }
	    },
	    "GetDASHStreamingSessionURL": {
	      "http": {
	        "requestUri": "/getDASHStreamingSessionURL"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "PlaybackMode": {},
	          "DisplayFragmentTimestamp": {},
	          "DisplayFragmentNumber": {},
	          "DASHFragmentSelector": {
	            "type": "structure",
	            "members": {
	              "FragmentSelectorType": {},
	              "TimestampRange": {
	                "type": "structure",
	                "members": {
	                  "StartTimestamp": {
	                    "type": "timestamp"
	                  },
	                  "EndTimestamp": {
	                    "type": "timestamp"
	                  }
	                }
	              }
	            }
	          },
	          "Expires": {
	            "type": "integer"
	          },
	          "MaxManifestFragmentResults": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DASHStreamingSessionURL": {}
	        }
	      }
	    },
	    "GetHLSStreamingSessionURL": {
	      "http": {
	        "requestUri": "/getHLSStreamingSessionURL"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "PlaybackMode": {},
	          "HLSFragmentSelector": {
	            "type": "structure",
	            "members": {
	              "FragmentSelectorType": {},
	              "TimestampRange": {
	                "type": "structure",
	                "members": {
	                  "StartTimestamp": {
	                    "type": "timestamp"
	                  },
	                  "EndTimestamp": {
	                    "type": "timestamp"
	                  }
	                }
	              }
	            }
	          },
	          "ContainerFormat": {},
	          "DiscontinuityMode": {},
	          "DisplayFragmentTimestamp": {},
	          "Expires": {
	            "type": "integer"
	          },
	          "MaxMediaPlaylistFragmentResults": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HLSStreamingSessionURL": {}
	        }
	      }
	    },
	    "GetImages": {
	      "http": {
	        "requestUri": "/getImages"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ImageSelectorType",
	          "StartTimestamp",
	          "EndTimestamp",
	          "SamplingInterval",
	          "Format"
	        ],
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "ImageSelectorType": {},
	          "StartTimestamp": {
	            "type": "timestamp"
	          },
	          "EndTimestamp": {
	            "type": "timestamp"
	          },
	          "SamplingInterval": {
	            "type": "integer"
	          },
	          "Format": {},
	          "FormatConfig": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          },
	          "WidthPixels": {
	            "type": "integer"
	          },
	          "HeightPixels": {
	            "type": "integer"
	          },
	          "MaxResults": {
	            "type": "long"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Images": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TimeStamp": {
	                  "type": "timestamp"
	                },
	                "Error": {},
	                "ImageContent": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetMediaForFragmentList": {
	      "http": {
	        "requestUri": "/getMediaForFragmentList"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Fragments"
	        ],
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "Fragments": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "Payload": {
	            "shape": "Sa"
	          }
	        },
	        "payload": "Payload"
	      }
	    },
	    "ListFragments": {
	      "http": {
	        "requestUri": "/listFragments"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "MaxResults": {
	            "type": "long"
	          },
	          "NextToken": {},
	          "FragmentSelector": {
	            "type": "structure",
	            "required": [
	              "FragmentSelectorType",
	              "TimestampRange"
	            ],
	            "members": {
	              "FragmentSelectorType": {},
	              "TimestampRange": {
	                "type": "structure",
	                "required": [
	                  "StartTimestamp",
	                  "EndTimestamp"
	                ],
	                "members": {
	                  "StartTimestamp": {
	                    "type": "timestamp"
	                  },
	                  "EndTimestamp": {
	                    "type": "timestamp"
	                  }
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Fragments": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FragmentNumber": {},
	                "FragmentSizeInBytes": {
	                  "type": "long"
	                },
	                "ProducerTimestamp": {
	                  "type": "timestamp"
	                },
	                "ServerTimestamp": {
	                  "type": "timestamp"
	                },
	                "FragmentLengthInMilliseconds": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sa": {
	      "type": "blob",
	      "streaming": true
	    }
	  }
	}
	},{}],136:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "GetImages": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Images"
	    },
	    "ListFragments": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Fragments"
	    }
	  }
	}
	},{}],137:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-09-30",
	    "endpointPrefix": "kinesisvideo",
	    "protocol": "rest-json",
	    "serviceAbbreviation": "Kinesis Video Media",
	    "serviceFullName": "Amazon Kinesis Video Streams Media",
	    "serviceId": "Kinesis Video Media",
	    "signatureVersion": "v4",
	    "uid": "kinesis-video-media-2017-09-30"
	  },
	  "operations": {
	    "GetMedia": {
	      "http": {
	        "requestUri": "/getMedia"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StartSelector"
	        ],
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "StartSelector": {
	            "type": "structure",
	            "required": [
	              "StartSelectorType"
	            ],
	            "members": {
	              "StartSelectorType": {},
	              "AfterFragmentNumber": {},
	              "StartTimestamp": {
	                "type": "timestamp"
	              },
	              "ContinuationToken": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "Payload": {
	            "type": "blob",
	            "streaming": true
	          }
	        },
	        "payload": "Payload"
	      }
	    }
	  },
	  "shapes": {}
	}
	},{}],138:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],139:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2019-12-04",
	    "endpointPrefix": "kinesisvideo",
	    "protocol": "rest-json",
	    "serviceAbbreviation": "Amazon Kinesis Video Signaling Channels",
	    "serviceFullName": "Amazon Kinesis Video Signaling Channels",
	    "serviceId": "Kinesis Video Signaling",
	    "signatureVersion": "v4",
	    "uid": "kinesis-video-signaling-2019-12-04"
	  },
	  "operations": {
	    "GetIceServerConfig": {
	      "http": {
	        "requestUri": "/v1/get-ice-server-config"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ChannelARN"
	        ],
	        "members": {
	          "ChannelARN": {},
	          "ClientId": {},
	          "Service": {},
	          "Username": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IceServerList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Uris": {
	                  "type": "list",
	                  "member": {}
	                },
	                "Username": {},
	                "Password": {},
	                "Ttl": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "SendAlexaOfferToMaster": {
	      "http": {
	        "requestUri": "/v1/send-alexa-offer-to-master"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ChannelARN",
	          "SenderClientId",
	          "MessagePayload"
	        ],
	        "members": {
	          "ChannelARN": {},
	          "SenderClientId": {},
	          "MessagePayload": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Answer": {}
	        }
	      }
	    }
	  },
	  "shapes": {}
	}
	},{}],140:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],141:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-09-30",
	    "endpointPrefix": "kinesisvideo",
	    "protocol": "rest-json",
	    "serviceAbbreviation": "Kinesis Video",
	    "serviceFullName": "Amazon Kinesis Video Streams",
	    "serviceId": "Kinesis Video",
	    "signatureVersion": "v4",
	    "uid": "kinesisvideo-2017-09-30"
	  },
	  "operations": {
	    "CreateSignalingChannel": {
	      "http": {
	        "requestUri": "/createSignalingChannel"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ChannelName"
	        ],
	        "members": {
	          "ChannelName": {},
	          "ChannelType": {},
	          "SingleMasterConfiguration": {
	            "shape": "S4"
	          },
	          "Tags": {
	            "type": "list",
	            "member": {
	              "shape": "S7"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChannelARN": {}
	        }
	      }
	    },
	    "CreateStream": {
	      "http": {
	        "requestUri": "/createStream"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamName"
	        ],
	        "members": {
	          "DeviceName": {},
	          "StreamName": {},
	          "MediaType": {},
	          "KmsKeyId": {},
	          "DataRetentionInHours": {
	            "type": "integer"
	          },
	          "Tags": {
	            "shape": "Si"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamARN": {}
	        }
	      }
	    },
	    "DeleteSignalingChannel": {
	      "http": {
	        "requestUri": "/deleteSignalingChannel"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ChannelARN"
	        ],
	        "members": {
	          "ChannelARN": {},
	          "CurrentVersion": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteStream": {
	      "http": {
	        "requestUri": "/deleteStream"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamARN"
	        ],
	        "members": {
	          "StreamARN": {},
	          "CurrentVersion": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeImageGenerationConfiguration": {
	      "http": {
	        "requestUri": "/describeImageGenerationConfiguration"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "StreamName": {},
	          "StreamARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ImageGenerationConfiguration": {
	            "shape": "Sr"
	          }
	        }
	      }
	    },
	    "DescribeNotificationConfiguration": {
	      "http": {
	        "requestUri": "/describeNotificationConfiguration"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "StreamName": {},
	          "StreamARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NotificationConfiguration": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "DescribeSignalingChannel": {
	      "http": {
	        "requestUri": "/describeSignalingChannel"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "ChannelName": {},
	          "ChannelARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChannelInfo": {
	            "shape": "S1a"
	          }
	        }
	      }
	    },
	    "DescribeStream": {
	      "http": {
	        "requestUri": "/describeStream"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "StreamName": {},
	          "StreamARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamInfo": {
	            "shape": "S1f"
	          }
	        }
	      }
	    },
	    "GetDataEndpoint": {
	      "http": {
	        "requestUri": "/getDataEndpoint"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "APIName"
	        ],
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "APIName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DataEndpoint": {}
	        }
	      }
	    },
	    "GetSignalingChannelEndpoint": {
	      "http": {
	        "requestUri": "/getSignalingChannelEndpoint"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ChannelARN"
	        ],
	        "members": {
	          "ChannelARN": {},
	          "SingleMasterChannelEndpointConfiguration": {
	            "type": "structure",
	            "members": {
	              "Protocols": {
	                "type": "list",
	                "member": {}
	              },
	              "Role": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceEndpointList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Protocol": {},
	                "ResourceEndpoint": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListSignalingChannels": {
	      "http": {
	        "requestUri": "/listSignalingChannels"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "ChannelNameCondition": {
	            "type": "structure",
	            "members": {
	              "ComparisonOperator": {},
	              "ComparisonValue": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChannelInfoList": {
	            "type": "list",
	            "member": {
	              "shape": "S1a"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListStreams": {
	      "http": {
	        "requestUri": "/listStreams"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "StreamNameCondition": {
	            "type": "structure",
	            "members": {
	              "ComparisonOperator": {},
	              "ComparisonValue": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamInfoList": {
	            "type": "list",
	            "member": {
	              "shape": "S1f"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "requestUri": "/ListTagsForResource"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN"
	        ],
	        "members": {
	          "NextToken": {},
	          "ResourceARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "Tags": {
	            "shape": "Si"
	          }
	        }
	      }
	    },
	    "ListTagsForStream": {
	      "http": {
	        "requestUri": "/listTagsForStream"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "StreamARN": {},
	          "StreamName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "Tags": {
	            "shape": "Si"
	          }
	        }
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/TagResource"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "Tags"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "Tags": {
	            "type": "list",
	            "member": {
	              "shape": "S7"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TagStream": {
	      "http": {
	        "requestUri": "/tagStream"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Tags"
	        ],
	        "members": {
	          "StreamARN": {},
	          "StreamName": {},
	          "Tags": {
	            "shape": "Si"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "requestUri": "/UntagResource"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "TagKeyList"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "TagKeyList": {
	            "shape": "S2e"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagStream": {
	      "http": {
	        "requestUri": "/untagStream"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TagKeyList"
	        ],
	        "members": {
	          "StreamARN": {},
	          "StreamName": {},
	          "TagKeyList": {
	            "shape": "S2e"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateDataRetention": {
	      "http": {
	        "requestUri": "/updateDataRetention"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CurrentVersion",
	          "Operation",
	          "DataRetentionChangeInHours"
	        ],
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "CurrentVersion": {},
	          "Operation": {},
	          "DataRetentionChangeInHours": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateImageGenerationConfiguration": {
	      "http": {
	        "requestUri": "/updateImageGenerationConfiguration"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "ImageGenerationConfiguration": {
	            "shape": "Sr"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateNotificationConfiguration": {
	      "http": {
	        "requestUri": "/updateNotificationConfiguration"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "NotificationConfiguration": {
	            "shape": "S16"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateSignalingChannel": {
	      "http": {
	        "requestUri": "/updateSignalingChannel"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ChannelARN",
	          "CurrentVersion"
	        ],
	        "members": {
	          "ChannelARN": {},
	          "CurrentVersion": {},
	          "SingleMasterConfiguration": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateStream": {
	      "http": {
	        "requestUri": "/updateStream"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CurrentVersion"
	        ],
	        "members": {
	          "StreamName": {},
	          "StreamARN": {},
	          "CurrentVersion": {},
	          "DeviceName": {},
	          "MediaType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "members": {
	        "MessageTtlSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "S7": {
	      "type": "structure",
	      "required": [
	        "Key",
	        "Value"
	      ],
	      "members": {
	        "Key": {},
	        "Value": {}
	      }
	    },
	    "Si": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sr": {
	      "type": "structure",
	      "required": [
	        "Status",
	        "ImageSelectorType",
	        "DestinationConfig",
	        "SamplingInterval",
	        "Format"
	      ],
	      "members": {
	        "Status": {},
	        "ImageSelectorType": {},
	        "DestinationConfig": {
	          "type": "structure",
	          "required": [
	            "Uri",
	            "DestinationRegion"
	          ],
	          "members": {
	            "Uri": {},
	            "DestinationRegion": {}
	          }
	        },
	        "SamplingInterval": {
	          "type": "integer"
	        },
	        "Format": {},
	        "FormatConfig": {
	          "type": "map",
	          "key": {},
	          "value": {}
	        },
	        "WidthPixels": {
	          "type": "integer"
	        },
	        "HeightPixels": {
	          "type": "integer"
	        }
	      }
	    },
	    "S16": {
	      "type": "structure",
	      "required": [
	        "Status",
	        "DestinationConfig"
	      ],
	      "members": {
	        "Status": {},
	        "DestinationConfig": {
	          "type": "structure",
	          "required": [
	            "Uri"
	          ],
	          "members": {
	            "Uri": {}
	          }
	        }
	      }
	    },
	    "S1a": {
	      "type": "structure",
	      "members": {
	        "ChannelName": {},
	        "ChannelARN": {},
	        "ChannelType": {},
	        "ChannelStatus": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "SingleMasterConfiguration": {
	          "shape": "S4"
	        },
	        "Version": {}
	      }
	    },
	    "S1f": {
	      "type": "structure",
	      "members": {
	        "DeviceName": {},
	        "StreamName": {},
	        "StreamARN": {},
	        "MediaType": {},
	        "KmsKeyId": {},
	        "Version": {},
	        "Status": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "DataRetentionInHours": {
	          "type": "integer"
	        }
	      }
	    },
	    "S2e": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],142:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListSignalingChannels": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ChannelInfoList"
	    },
	    "ListStreams": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "StreamInfoList"
	    }
	  }
	}
	},{}],143:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-11-01",
	    "endpointPrefix": "kms",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "KMS",
	    "serviceFullName": "AWS Key Management Service",
	    "serviceId": "KMS",
	    "signatureVersion": "v4",
	    "targetPrefix": "TrentService",
	    "uid": "kms-2014-11-01"
	  },
	  "operations": {
	    "CancelKeyDeletion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyId": {}
	        }
	      }
	    },
	    "ConnectCustomKeyStore": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CustomKeyStoreId"
	        ],
	        "members": {
	          "CustomKeyStoreId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateAlias": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AliasName",
	          "TargetKeyId"
	        ],
	        "members": {
	          "AliasName": {},
	          "TargetKeyId": {}
	        }
	      }
	    },
	    "CreateCustomKeyStore": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CustomKeyStoreName",
	          "CloudHsmClusterId",
	          "TrustAnchorCertificate",
	          "KeyStorePassword"
	        ],
	        "members": {
	          "CustomKeyStoreName": {},
	          "CloudHsmClusterId": {},
	          "TrustAnchorCertificate": {},
	          "KeyStorePassword": {
	            "shape": "Sd"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CustomKeyStoreId": {}
	        }
	      }
	    },
	    "CreateGrant": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "GranteePrincipal",
	          "Operations"
	        ],
	        "members": {
	          "KeyId": {},
	          "GranteePrincipal": {},
	          "RetiringPrincipal": {},
	          "Operations": {
	            "shape": "Sh"
	          },
	          "Constraints": {
	            "shape": "Sj"
	          },
	          "GrantTokens": {
	            "shape": "Sn"
	          },
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GrantToken": {},
	          "GrantId": {}
	        }
	      }
	    },
	    "CreateKey": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Policy": {},
	          "Description": {},
	          "KeyUsage": {},
	          "CustomerMasterKeySpec": {
	            "shape": "Sw",
	            "deprecated": true,
	            "deprecatedMessage": "This parameter has been deprecated. Instead, use the KeySpec parameter."
	          },
	          "KeySpec": {},
	          "Origin": {},
	          "CustomKeyStoreId": {},
	          "BypassPolicyLockoutSafetyCheck": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S10"
	          },
	          "MultiRegion": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyMetadata": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "Decrypt": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CiphertextBlob"
	        ],
	        "members": {
	          "CiphertextBlob": {
	            "type": "blob"
	          },
	          "EncryptionContext": {
	            "shape": "Sk"
	          },
	          "GrantTokens": {
	            "shape": "Sn"
	          },
	          "KeyId": {},
	          "EncryptionAlgorithm": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyId": {},
	          "Plaintext": {
	            "shape": "S1s"
	          },
	          "EncryptionAlgorithm": {}
	        }
	      }
	    },
	    "DeleteAlias": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AliasName"
	        ],
	        "members": {
	          "AliasName": {}
	        }
	      }
	    },
	    "DeleteCustomKeyStore": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CustomKeyStoreId"
	        ],
	        "members": {
	          "CustomKeyStoreId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteImportedKeyMaterial": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {}
	        }
	      }
	    },
	    "DescribeCustomKeyStores": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CustomKeyStoreId": {},
	          "CustomKeyStoreName": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CustomKeyStores": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "CustomKeyStoreId": {},
	                "CustomKeyStoreName": {},
	                "CloudHsmClusterId": {},
	                "TrustAnchorCertificate": {},
	                "ConnectionState": {},
	                "ConnectionErrorCode": {},
	                "CreationDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextMarker": {},
	          "Truncated": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DescribeKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {},
	          "GrantTokens": {
	            "shape": "Sn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyMetadata": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "DisableKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {}
	        }
	      }
	    },
	    "DisableKeyRotation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {}
	        }
	      }
	    },
	    "DisconnectCustomKeyStore": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CustomKeyStoreId"
	        ],
	        "members": {
	          "CustomKeyStoreId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "EnableKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {}
	        }
	      }
	    },
	    "EnableKeyRotation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {}
	        }
	      }
	    },
	    "Encrypt": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "Plaintext"
	        ],
	        "members": {
	          "KeyId": {},
	          "Plaintext": {
	            "shape": "S1s"
	          },
	          "EncryptionContext": {
	            "shape": "Sk"
	          },
	          "GrantTokens": {
	            "shape": "Sn"
	          },
	          "EncryptionAlgorithm": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CiphertextBlob": {
	            "type": "blob"
	          },
	          "KeyId": {},
	          "EncryptionAlgorithm": {}
	        }
	      }
	    },
	    "GenerateDataKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {},
	          "EncryptionContext": {
	            "shape": "Sk"
	          },
	          "NumberOfBytes": {
	            "type": "integer"
	          },
	          "KeySpec": {},
	          "GrantTokens": {
	            "shape": "Sn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CiphertextBlob": {
	            "type": "blob"
	          },
	          "Plaintext": {
	            "shape": "S1s"
	          },
	          "KeyId": {}
	        }
	      }
	    },
	    "GenerateDataKeyPair": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "KeyPairSpec"
	        ],
	        "members": {
	          "EncryptionContext": {
	            "shape": "Sk"
	          },
	          "KeyId": {},
	          "KeyPairSpec": {},
	          "GrantTokens": {
	            "shape": "Sn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PrivateKeyCiphertextBlob": {
	            "type": "blob"
	          },
	          "PrivateKeyPlaintext": {
	            "shape": "S1s"
	          },
	          "PublicKey": {
	            "type": "blob"
	          },
	          "KeyId": {},
	          "KeyPairSpec": {}
	        }
	      }
	    },
	    "GenerateDataKeyPairWithoutPlaintext": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "KeyPairSpec"
	        ],
	        "members": {
	          "EncryptionContext": {
	            "shape": "Sk"
	          },
	          "KeyId": {},
	          "KeyPairSpec": {},
	          "GrantTokens": {
	            "shape": "Sn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PrivateKeyCiphertextBlob": {
	            "type": "blob"
	          },
	          "PublicKey": {
	            "type": "blob"
	          },
	          "KeyId": {},
	          "KeyPairSpec": {}
	        }
	      }
	    },
	    "GenerateDataKeyWithoutPlaintext": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {},
	          "EncryptionContext": {
	            "shape": "Sk"
	          },
	          "KeySpec": {},
	          "NumberOfBytes": {
	            "type": "integer"
	          },
	          "GrantTokens": {
	            "shape": "Sn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CiphertextBlob": {
	            "type": "blob"
	          },
	          "KeyId": {}
	        }
	      }
	    },
	    "GenerateMac": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Message",
	          "KeyId",
	          "MacAlgorithm"
	        ],
	        "members": {
	          "Message": {
	            "shape": "S1s"
	          },
	          "KeyId": {},
	          "MacAlgorithm": {},
	          "GrantTokens": {
	            "shape": "Sn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Mac": {
	            "type": "blob"
	          },
	          "MacAlgorithm": {},
	          "KeyId": {}
	        }
	      }
	    },
	    "GenerateRandom": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NumberOfBytes": {
	            "type": "integer"
	          },
	          "CustomKeyStoreId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Plaintext": {
	            "shape": "S1s"
	          }
	        }
	      }
	    },
	    "GetKeyPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "PolicyName"
	        ],
	        "members": {
	          "KeyId": {},
	          "PolicyName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Policy": {}
	        }
	      }
	    },
	    "GetKeyRotationStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyRotationEnabled": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "GetParametersForImport": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "WrappingAlgorithm",
	          "WrappingKeySpec"
	        ],
	        "members": {
	          "KeyId": {},
	          "WrappingAlgorithm": {},
	          "WrappingKeySpec": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyId": {},
	          "ImportToken": {
	            "type": "blob"
	          },
	          "PublicKey": {
	            "shape": "S1s"
	          },
	          "ParametersValidTo": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetPublicKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {},
	          "GrantTokens": {
	            "shape": "Sn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyId": {},
	          "PublicKey": {
	            "type": "blob"
	          },
	          "CustomerMasterKeySpec": {
	            "shape": "Sw",
	            "deprecated": true,
	            "deprecatedMessage": "This field has been deprecated. Instead, use the KeySpec field."
	          },
	          "KeySpec": {},
	          "KeyUsage": {},
	          "EncryptionAlgorithms": {
	            "shape": "S1d"
	          },
	          "SigningAlgorithms": {
	            "shape": "S1f"
	          }
	        }
	      }
	    },
	    "ImportKeyMaterial": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "ImportToken",
	          "EncryptedKeyMaterial"
	        ],
	        "members": {
	          "KeyId": {},
	          "ImportToken": {
	            "type": "blob"
	          },
	          "EncryptedKeyMaterial": {
	            "type": "blob"
	          },
	          "ValidTo": {
	            "type": "timestamp"
	          },
	          "ExpirationModel": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ListAliases": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "KeyId": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Aliases": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AliasName": {},
	                "AliasArn": {},
	                "TargetKeyId": {},
	                "CreationDate": {
	                  "type": "timestamp"
	                },
	                "LastUpdatedDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextMarker": {},
	          "Truncated": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ListGrants": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "Limit": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "KeyId": {},
	          "GrantId": {},
	          "GranteePrincipal": {}
	        }
	      },
	      "output": {
	        "shape": "S3d"
	      }
	    },
	    "ListKeyPolicies": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PolicyNames": {
	            "type": "list",
	            "member": {}
	          },
	          "NextMarker": {},
	          "Truncated": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ListKeys": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Limit": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Keys": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "KeyId": {},
	                "KeyArn": {}
	              }
	            }
	          },
	          "NextMarker": {},
	          "Truncated": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ListResourceTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S10"
	          },
	          "NextMarker": {},
	          "Truncated": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ListRetirableGrants": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RetiringPrincipal"
	        ],
	        "members": {
	          "Limit": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "RetiringPrincipal": {}
	        }
	      },
	      "output": {
	        "shape": "S3d"
	      }
	    },
	    "PutKeyPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "PolicyName",
	          "Policy"
	        ],
	        "members": {
	          "KeyId": {},
	          "PolicyName": {},
	          "Policy": {},
	          "BypassPolicyLockoutSafetyCheck": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ReEncrypt": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CiphertextBlob",
	          "DestinationKeyId"
	        ],
	        "members": {
	          "CiphertextBlob": {
	            "type": "blob"
	          },
	          "SourceEncryptionContext": {
	            "shape": "Sk"
	          },
	          "SourceKeyId": {},
	          "DestinationKeyId": {},
	          "DestinationEncryptionContext": {
	            "shape": "Sk"
	          },
	          "SourceEncryptionAlgorithm": {},
	          "DestinationEncryptionAlgorithm": {},
	          "GrantTokens": {
	            "shape": "Sn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CiphertextBlob": {
	            "type": "blob"
	          },
	          "SourceKeyId": {},
	          "KeyId": {},
	          "SourceEncryptionAlgorithm": {},
	          "DestinationEncryptionAlgorithm": {}
	        }
	      }
	    },
	    "ReplicateKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "ReplicaRegion"
	        ],
	        "members": {
	          "KeyId": {},
	          "ReplicaRegion": {},
	          "Policy": {},
	          "BypassPolicyLockoutSafetyCheck": {
	            "type": "boolean"
	          },
	          "Description": {},
	          "Tags": {
	            "shape": "S10"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReplicaKeyMetadata": {
	            "shape": "S16"
	          },
	          "ReplicaPolicy": {},
	          "ReplicaTags": {
	            "shape": "S10"
	          }
	        }
	      }
	    },
	    "RetireGrant": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GrantToken": {},
	          "KeyId": {},
	          "GrantId": {}
	        }
	      }
	    },
	    "RevokeGrant": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "GrantId"
	        ],
	        "members": {
	          "KeyId": {},
	          "GrantId": {}
	        }
	      }
	    },
	    "ScheduleKeyDeletion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId"
	        ],
	        "members": {
	          "KeyId": {},
	          "PendingWindowInDays": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyId": {},
	          "DeletionDate": {
	            "type": "timestamp"
	          },
	          "KeyState": {},
	          "PendingWindowInDays": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "Sign": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "Message",
	          "SigningAlgorithm"
	        ],
	        "members": {
	          "KeyId": {},
	          "Message": {
	            "shape": "S1s"
	          },
	          "MessageType": {},
	          "GrantTokens": {
	            "shape": "Sn"
	          },
	          "SigningAlgorithm": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyId": {},
	          "Signature": {
	            "type": "blob"
	          },
	          "SigningAlgorithm": {}
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "Tags"
	        ],
	        "members": {
	          "KeyId": {},
	          "Tags": {
	            "shape": "S10"
	          }
	        }
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "TagKeys"
	        ],
	        "members": {
	          "KeyId": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "UpdateAlias": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AliasName",
	          "TargetKeyId"
	        ],
	        "members": {
	          "AliasName": {},
	          "TargetKeyId": {}
	        }
	      }
	    },
	    "UpdateCustomKeyStore": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CustomKeyStoreId"
	        ],
	        "members": {
	          "CustomKeyStoreId": {},
	          "NewCustomKeyStoreName": {},
	          "KeyStorePassword": {
	            "shape": "Sd"
	          },
	          "CloudHsmClusterId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateKeyDescription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "Description"
	        ],
	        "members": {
	          "KeyId": {},
	          "Description": {}
	        }
	      }
	    },
	    "UpdatePrimaryRegion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "PrimaryRegion"
	        ],
	        "members": {
	          "KeyId": {},
	          "PrimaryRegion": {}
	        }
	      }
	    },
	    "Verify": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "KeyId",
	          "Message",
	          "Signature",
	          "SigningAlgorithm"
	        ],
	        "members": {
	          "KeyId": {},
	          "Message": {
	            "shape": "S1s"
	          },
	          "MessageType": {},
	          "Signature": {
	            "type": "blob"
	          },
	          "SigningAlgorithm": {},
	          "GrantTokens": {
	            "shape": "Sn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyId": {},
	          "SignatureValid": {
	            "type": "boolean"
	          },
	          "SigningAlgorithm": {}
	        }
	      }
	    },
	    "VerifyMac": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Message",
	          "KeyId",
	          "MacAlgorithm",
	          "Mac"
	        ],
	        "members": {
	          "Message": {
	            "shape": "S1s"
	          },
	          "KeyId": {},
	          "MacAlgorithm": {},
	          "Mac": {
	            "type": "blob"
	          },
	          "GrantTokens": {
	            "shape": "Sn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "KeyId": {},
	          "MacValid": {
	            "type": "boolean"
	          },
	          "MacAlgorithm": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sd": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Sh": {
	      "type": "list",
	      "member": {}
	    },
	    "Sj": {
	      "type": "structure",
	      "members": {
	        "EncryptionContextSubset": {
	          "shape": "Sk"
	        },
	        "EncryptionContextEquals": {
	          "shape": "Sk"
	        }
	      }
	    },
	    "Sk": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sn": {
	      "type": "list",
	      "member": {}
	    },
	    "Sw": {
	      "type": "string",
	      "deprecated": true,
	      "deprecatedMessage": "This enum has been deprecated. Instead, use the KeySpec enum."
	    },
	    "S10": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "TagKey",
	          "TagValue"
	        ],
	        "members": {
	          "TagKey": {},
	          "TagValue": {}
	        }
	      }
	    },
	    "S16": {
	      "type": "structure",
	      "required": [
	        "KeyId"
	      ],
	      "members": {
	        "AWSAccountId": {},
	        "KeyId": {},
	        "Arn": {},
	        "CreationDate": {
	          "type": "timestamp"
	        },
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Description": {},
	        "KeyUsage": {},
	        "KeyState": {},
	        "DeletionDate": {
	          "type": "timestamp"
	        },
	        "ValidTo": {
	          "type": "timestamp"
	        },
	        "Origin": {},
	        "CustomKeyStoreId": {},
	        "CloudHsmClusterId": {},
	        "ExpirationModel": {},
	        "KeyManager": {},
	        "CustomerMasterKeySpec": {
	          "shape": "Sw",
	          "deprecated": true,
	          "deprecatedMessage": "This field has been deprecated. Instead, use the KeySpec field."
	        },
	        "KeySpec": {},
	        "EncryptionAlgorithms": {
	          "shape": "S1d"
	        },
	        "SigningAlgorithms": {
	          "shape": "S1f"
	        },
	        "MultiRegion": {
	          "type": "boolean"
	        },
	        "MultiRegionConfiguration": {
	          "type": "structure",
	          "members": {
	            "MultiRegionKeyType": {},
	            "PrimaryKey": {
	              "shape": "S1j"
	            },
	            "ReplicaKeys": {
	              "type": "list",
	              "member": {
	                "shape": "S1j"
	              }
	            }
	          }
	        },
	        "PendingDeletionWindowInDays": {
	          "type": "integer"
	        },
	        "MacAlgorithms": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S1d": {
	      "type": "list",
	      "member": {}
	    },
	    "S1f": {
	      "type": "list",
	      "member": {}
	    },
	    "S1j": {
	      "type": "structure",
	      "members": {
	        "Arn": {},
	        "Region": {}
	      }
	    },
	    "S1s": {
	      "type": "blob",
	      "sensitive": true
	    },
	    "S3d": {
	      "type": "structure",
	      "members": {
	        "Grants": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "KeyId": {},
	              "GrantId": {},
	              "Name": {},
	              "CreationDate": {
	                "type": "timestamp"
	              },
	              "GranteePrincipal": {},
	              "RetiringPrincipal": {},
	              "IssuingAccount": {},
	              "Operations": {
	                "shape": "Sh"
	              },
	              "Constraints": {
	                "shape": "Sj"
	              }
	            }
	          }
	        },
	        "NextMarker": {},
	        "Truncated": {
	          "type": "boolean"
	        }
	      }
	    }
	  }
	}
	},{}],144:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListAliases": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "more_results": "Truncated",
	      "output_token": "NextMarker",
	      "result_key": "Aliases"
	    },
	    "ListGrants": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "more_results": "Truncated",
	      "output_token": "NextMarker",
	      "result_key": "Grants"
	    },
	    "ListKeyPolicies": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "more_results": "Truncated",
	      "output_token": "NextMarker",
	      "result_key": "PolicyNames"
	    },
	    "ListKeys": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "more_results": "Truncated",
	      "output_token": "NextMarker",
	      "result_key": "Keys"
	    }
	  }
	}
	},{}],145:[function(require,module,exports){
	module.exports={
	  "metadata": {
	    "apiVersion": "2014-11-11",
	    "endpointPrefix": "lambda",
	    "serviceFullName": "AWS Lambda",
	    "serviceId": "Lambda",
	    "signatureVersion": "v4",
	    "protocol": "rest-json"
	  },
	  "operations": {
	    "AddEventSource": {
	      "http": {
	        "requestUri": "/2014-11-13/event-source-mappings/"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "EventSource",
	          "FunctionName",
	          "Role"
	        ],
	        "members": {
	          "EventSource": {},
	          "FunctionName": {},
	          "Role": {},
	          "BatchSize": {
	            "type": "integer"
	          },
	          "Parameters": {
	            "shape": "S6"
	          }
	        }
	      },
	      "output": {
	        "shape": "S7"
	      }
	    },
	    "DeleteFunction": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2014-11-13/functions/{FunctionName}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          }
	        }
	      }
	    },
	    "GetEventSource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2014-11-13/event-source-mappings/{UUID}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UUID"
	        ],
	        "members": {
	          "UUID": {
	            "location": "uri",
	            "locationName": "UUID"
	          }
	        }
	      },
	      "output": {
	        "shape": "S7"
	      }
	    },
	    "GetFunction": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2014-11-13/functions/{FunctionName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Configuration": {
	            "shape": "Se"
	          },
	          "Code": {
	            "type": "structure",
	            "members": {
	              "RepositoryType": {},
	              "Location": {}
	            }
	          }
	        }
	      }
	    },
	    "GetFunctionConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2014-11-13/functions/{FunctionName}/configuration",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          }
	        }
	      },
	      "output": {
	        "shape": "Se"
	      }
	    },
	    "InvokeAsync": {
	      "http": {
	        "requestUri": "/2014-11-13/functions/{FunctionName}/invoke-async/",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "InvokeArgs"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "InvokeArgs": {
	            "shape": "Sq"
	          }
	        },
	        "payload": "InvokeArgs"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {
	            "location": "statusCode",
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "ListEventSources": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2014-11-13/event-source-mappings/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "EventSourceArn": {
	            "location": "querystring",
	            "locationName": "EventSource"
	          },
	          "FunctionName": {
	            "location": "querystring",
	            "locationName": "FunctionName"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "EventSources": {
	            "type": "list",
	            "member": {
	              "shape": "S7"
	            }
	          }
	        }
	      }
	    },
	    "ListFunctions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2014-11-13/functions/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Functions": {
	            "type": "list",
	            "member": {
	              "shape": "Se"
	            }
	          }
	        }
	      }
	    },
	    "RemoveEventSource": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2014-11-13/event-source-mappings/{UUID}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UUID"
	        ],
	        "members": {
	          "UUID": {
	            "location": "uri",
	            "locationName": "UUID"
	          }
	        }
	      }
	    },
	    "UpdateFunctionConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2014-11-13/functions/{FunctionName}/configuration",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Role": {
	            "location": "querystring",
	            "locationName": "Role"
	          },
	          "Handler": {
	            "location": "querystring",
	            "locationName": "Handler"
	          },
	          "Description": {
	            "location": "querystring",
	            "locationName": "Description"
	          },
	          "Timeout": {
	            "location": "querystring",
	            "locationName": "Timeout",
	            "type": "integer"
	          },
	          "MemorySize": {
	            "location": "querystring",
	            "locationName": "MemorySize",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "shape": "Se"
	      }
	    },
	    "UploadFunction": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2014-11-13/functions/{FunctionName}",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "FunctionZip",
	          "Runtime",
	          "Role",
	          "Handler",
	          "Mode"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "FunctionZip": {
	            "shape": "Sq"
	          },
	          "Runtime": {
	            "location": "querystring",
	            "locationName": "Runtime"
	          },
	          "Role": {
	            "location": "querystring",
	            "locationName": "Role"
	          },
	          "Handler": {
	            "location": "querystring",
	            "locationName": "Handler"
	          },
	          "Mode": {
	            "location": "querystring",
	            "locationName": "Mode"
	          },
	          "Description": {
	            "location": "querystring",
	            "locationName": "Description"
	          },
	          "Timeout": {
	            "location": "querystring",
	            "locationName": "Timeout",
	            "type": "integer"
	          },
	          "MemorySize": {
	            "location": "querystring",
	            "locationName": "MemorySize",
	            "type": "integer"
	          }
	        },
	        "payload": "FunctionZip"
	      },
	      "output": {
	        "shape": "Se"
	      }
	    }
	  },
	  "shapes": {
	    "S6": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S7": {
	      "type": "structure",
	      "members": {
	        "UUID": {},
	        "BatchSize": {
	          "type": "integer"
	        },
	        "EventSource": {},
	        "FunctionName": {},
	        "Parameters": {
	          "shape": "S6"
	        },
	        "Role": {},
	        "LastModified": {
	          "type": "timestamp"
	        },
	        "IsActive": {
	          "type": "boolean"
	        },
	        "Status": {}
	      }
	    },
	    "Se": {
	      "type": "structure",
	      "members": {
	        "FunctionName": {},
	        "FunctionARN": {},
	        "ConfigurationId": {},
	        "Runtime": {},
	        "Role": {},
	        "Handler": {},
	        "Mode": {},
	        "CodeSize": {
	          "type": "long"
	        },
	        "Description": {},
	        "Timeout": {
	          "type": "integer"
	        },
	        "MemorySize": {
	          "type": "integer"
	        },
	        "LastModified": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sq": {
	      "type": "blob",
	      "streaming": true
	    }
	  }
	}
	},{}],146:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListEventSources": {
	      "input_token": "Marker",
	      "output_token": "NextMarker",
	      "limit_key": "MaxItems",
	      "result_key": "EventSources"
	    },
	    "ListFunctions": {
	      "input_token": "Marker",
	      "output_token": "NextMarker",
	      "limit_key": "MaxItems",
	      "result_key": "Functions"
	    }
	  }
	}
	
	},{}],147:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-03-31",
	    "endpointPrefix": "lambda",
	    "protocol": "rest-json",
	    "serviceFullName": "AWS Lambda",
	    "serviceId": "Lambda",
	    "signatureVersion": "v4",
	    "uid": "lambda-2015-03-31"
	  },
	  "operations": {
	    "AddLayerVersionPermission": {
	      "http": {
	        "requestUri": "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerName",
	          "VersionNumber",
	          "StatementId",
	          "Action",
	          "Principal"
	        ],
	        "members": {
	          "LayerName": {
	            "location": "uri",
	            "locationName": "LayerName"
	          },
	          "VersionNumber": {
	            "location": "uri",
	            "locationName": "VersionNumber",
	            "type": "long"
	          },
	          "StatementId": {},
	          "Action": {},
	          "Principal": {},
	          "OrganizationId": {},
	          "RevisionId": {
	            "location": "querystring",
	            "locationName": "RevisionId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Statement": {},
	          "RevisionId": {}
	        }
	      }
	    },
	    "AddPermission": {
	      "http": {
	        "requestUri": "/2015-03-31/functions/{FunctionName}/policy",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "StatementId",
	          "Action",
	          "Principal"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "StatementId": {},
	          "Action": {},
	          "Principal": {},
	          "SourceArn": {},
	          "SourceAccount": {},
	          "EventSourceToken": {},
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          },
	          "RevisionId": {},
	          "PrincipalOrgID": {},
	          "FunctionUrlAuthType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Statement": {}
	        }
	      }
	    },
	    "CreateAlias": {
	      "http": {
	        "requestUri": "/2015-03-31/functions/{FunctionName}/aliases",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "Name",
	          "FunctionVersion"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Name": {},
	          "FunctionVersion": {},
	          "Description": {},
	          "RoutingConfig": {
	            "shape": "Sp"
	          }
	        }
	      },
	      "output": {
	        "shape": "St"
	      }
	    },
	    "CreateCodeSigningConfig": {
	      "http": {
	        "requestUri": "/2020-04-22/code-signing-configs/",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "AllowedPublishers"
	        ],
	        "members": {
	          "Description": {},
	          "AllowedPublishers": {
	            "shape": "Sw"
	          },
	          "CodeSigningPolicies": {
	            "shape": "Sy"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CodeSigningConfig"
	        ],
	        "members": {
	          "CodeSigningConfig": {
	            "shape": "S11"
	          }
	        }
	      }
	    },
	    "CreateEventSourceMapping": {
	      "http": {
	        "requestUri": "/2015-03-31/event-source-mappings/",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "EventSourceArn": {},
	          "FunctionName": {},
	          "Enabled": {
	            "type": "boolean"
	          },
	          "BatchSize": {
	            "type": "integer"
	          },
	          "FilterCriteria": {
	            "shape": "S18"
	          },
	          "MaximumBatchingWindowInSeconds": {
	            "type": "integer"
	          },
	          "ParallelizationFactor": {
	            "type": "integer"
	          },
	          "StartingPosition": {},
	          "StartingPositionTimestamp": {
	            "type": "timestamp"
	          },
	          "DestinationConfig": {
	            "shape": "S1g"
	          },
	          "MaximumRecordAgeInSeconds": {
	            "type": "integer"
	          },
	          "BisectBatchOnFunctionError": {
	            "type": "boolean"
	          },
	          "MaximumRetryAttempts": {
	            "type": "integer"
	          },
	          "TumblingWindowInSeconds": {
	            "type": "integer"
	          },
	          "Topics": {
	            "shape": "S1o"
	          },
	          "Queues": {
	            "shape": "S1q"
	          },
	          "SourceAccessConfigurations": {
	            "shape": "S1s"
	          },
	          "SelfManagedEventSource": {
	            "shape": "S1w"
	          },
	          "FunctionResponseTypes": {
	            "shape": "S21"
	          }
	        }
	      },
	      "output": {
	        "shape": "S23"
	      }
	    },
	    "CreateFunction": {
	      "http": {
	        "requestUri": "/2015-03-31/functions",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "Role",
	          "Code"
	        ],
	        "members": {
	          "FunctionName": {},
	          "Runtime": {},
	          "Role": {},
	          "Handler": {},
	          "Code": {
	            "type": "structure",
	            "members": {
	              "ZipFile": {
	                "shape": "S29"
	              },
	              "S3Bucket": {},
	              "S3Key": {},
	              "S3ObjectVersion": {},
	              "ImageUri": {}
	            }
	          },
	          "Description": {},
	          "Timeout": {
	            "type": "integer"
	          },
	          "MemorySize": {
	            "type": "integer"
	          },
	          "Publish": {
	            "type": "boolean"
	          },
	          "VpcConfig": {
	            "shape": "S2g"
	          },
	          "PackageType": {},
	          "DeadLetterConfig": {
	            "shape": "S2m"
	          },
	          "Environment": {
	            "shape": "S2o"
	          },
	          "KMSKeyArn": {},
	          "TracingConfig": {
	            "shape": "S2t"
	          },
	          "Tags": {
	            "shape": "S2v"
	          },
	          "Layers": {
	            "shape": "S2y"
	          },
	          "FileSystemConfigs": {
	            "shape": "S30"
	          },
	          "ImageConfig": {
	            "shape": "S34"
	          },
	          "CodeSigningConfigArn": {},
	          "Architectures": {
	            "shape": "S37"
	          },
	          "EphemeralStorage": {
	            "shape": "S39"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3b"
	      }
	    },
	    "CreateFunctionUrlConfig": {
	      "http": {
	        "requestUri": "/2021-10-31/functions/{FunctionName}/url",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "AuthType"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          },
	          "AuthType": {},
	          "Cors": {
	            "shape": "S3x"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "FunctionUrl",
	          "FunctionArn",
	          "AuthType",
	          "CreationTime"
	        ],
	        "members": {
	          "FunctionUrl": {},
	          "FunctionArn": {},
	          "AuthType": {},
	          "Cors": {
	            "shape": "S3x"
	          },
	          "CreationTime": {}
	        }
	      }
	    },
	    "DeleteAlias": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "Name"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          }
	        }
	      }
	    },
	    "DeleteCodeSigningConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-04-22/code-signing-configs/{CodeSigningConfigArn}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CodeSigningConfigArn"
	        ],
	        "members": {
	          "CodeSigningConfigArn": {
	            "location": "uri",
	            "locationName": "CodeSigningConfigArn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteEventSourceMapping": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2015-03-31/event-source-mappings/{UUID}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UUID"
	        ],
	        "members": {
	          "UUID": {
	            "location": "uri",
	            "locationName": "UUID"
	          }
	        }
	      },
	      "output": {
	        "shape": "S23"
	      }
	    },
	    "DeleteFunction": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2015-03-31/functions/{FunctionName}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          }
	        }
	      }
	    },
	    "DeleteFunctionCodeSigningConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2020-06-30/functions/{FunctionName}/code-signing-config",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          }
	        }
	      }
	    },
	    "DeleteFunctionConcurrency": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-10-31/functions/{FunctionName}/concurrency",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          }
	        }
	      }
	    },
	    "DeleteFunctionEventInvokeConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2019-09-25/functions/{FunctionName}/event-invoke-config",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          }
	        }
	      }
	    },
	    "DeleteFunctionUrlConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2021-10-31/functions/{FunctionName}/url",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          }
	        }
	      }
	    },
	    "DeleteLayerVersion": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerName",
	          "VersionNumber"
	        ],
	        "members": {
	          "LayerName": {
	            "location": "uri",
	            "locationName": "LayerName"
	          },
	          "VersionNumber": {
	            "location": "uri",
	            "locationName": "VersionNumber",
	            "type": "long"
	          }
	        }
	      }
	    },
	    "DeleteProvisionedConcurrencyConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2019-09-30/functions/{FunctionName}/provisioned-concurrency",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "Qualifier"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          }
	        }
	      }
	    },
	    "GetAccountSettings": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2016-08-19/account-settings/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AccountLimit": {
	            "type": "structure",
	            "members": {
	              "TotalCodeSize": {
	                "type": "long"
	              },
	              "CodeSizeUnzipped": {
	                "type": "long"
	              },
	              "CodeSizeZipped": {
	                "type": "long"
	              },
	              "ConcurrentExecutions": {
	                "type": "integer"
	              },
	              "UnreservedConcurrentExecutions": {
	                "type": "integer"
	              }
	            }
	          },
	          "AccountUsage": {
	            "type": "structure",
	            "members": {
	              "TotalCodeSize": {
	                "type": "long"
	              },
	              "FunctionCount": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetAlias": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "Name"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          }
	        }
	      },
	      "output": {
	        "shape": "St"
	      }
	    },
	    "GetCodeSigningConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-04-22/code-signing-configs/{CodeSigningConfigArn}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CodeSigningConfigArn"
	        ],
	        "members": {
	          "CodeSigningConfigArn": {
	            "location": "uri",
	            "locationName": "CodeSigningConfigArn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CodeSigningConfig"
	        ],
	        "members": {
	          "CodeSigningConfig": {
	            "shape": "S11"
	          }
	        }
	      }
	    },
	    "GetEventSourceMapping": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-03-31/event-source-mappings/{UUID}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UUID"
	        ],
	        "members": {
	          "UUID": {
	            "location": "uri",
	            "locationName": "UUID"
	          }
	        }
	      },
	      "output": {
	        "shape": "S23"
	      }
	    },
	    "GetFunction": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-03-31/functions/{FunctionName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Configuration": {
	            "shape": "S3b"
	          },
	          "Code": {
	            "type": "structure",
	            "members": {
	              "RepositoryType": {},
	              "Location": {},
	              "ImageUri": {},
	              "ResolvedImageUri": {}
	            }
	          },
	          "Tags": {
	            "shape": "S2v"
	          },
	          "Concurrency": {
	            "shape": "S4w"
	          }
	        }
	      }
	    },
	    "GetFunctionCodeSigningConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-06-30/functions/{FunctionName}/code-signing-config",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CodeSigningConfigArn",
	          "FunctionName"
	        ],
	        "members": {
	          "CodeSigningConfigArn": {},
	          "FunctionName": {}
	        }
	      }
	    },
	    "GetFunctionConcurrency": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-09-30/functions/{FunctionName}/concurrency",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReservedConcurrentExecutions": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "GetFunctionConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-03-31/functions/{FunctionName}/configuration",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3b"
	      }
	    },
	    "GetFunctionEventInvokeConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-09-25/functions/{FunctionName}/event-invoke-config",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          }
	        }
	      },
	      "output": {
	        "shape": "S54"
	      }
	    },
	    "GetFunctionUrlConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2021-10-31/functions/{FunctionName}/url",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "FunctionUrl",
	          "FunctionArn",
	          "AuthType",
	          "CreationTime",
	          "LastModifiedTime"
	        ],
	        "members": {
	          "FunctionUrl": {},
	          "FunctionArn": {},
	          "AuthType": {},
	          "Cors": {
	            "shape": "S3x"
	          },
	          "CreationTime": {},
	          "LastModifiedTime": {}
	        }
	      }
	    },
	    "GetLayerVersion": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerName",
	          "VersionNumber"
	        ],
	        "members": {
	          "LayerName": {
	            "location": "uri",
	            "locationName": "LayerName"
	          },
	          "VersionNumber": {
	            "location": "uri",
	            "locationName": "VersionNumber",
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "shape": "S5a"
	      }
	    },
	    "GetLayerVersionByArn": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-10-31/layers?find=LayerVersion",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Arn"
	        ],
	        "members": {
	          "Arn": {
	            "location": "querystring",
	            "locationName": "Arn"
	          }
	        }
	      },
	      "output": {
	        "shape": "S5a"
	      }
	    },
	    "GetLayerVersionPolicy": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerName",
	          "VersionNumber"
	        ],
	        "members": {
	          "LayerName": {
	            "location": "uri",
	            "locationName": "LayerName"
	          },
	          "VersionNumber": {
	            "location": "uri",
	            "locationName": "VersionNumber",
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Policy": {},
	          "RevisionId": {}
	        }
	      }
	    },
	    "GetPolicy": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-03-31/functions/{FunctionName}/policy",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Policy": {},
	          "RevisionId": {}
	        }
	      }
	    },
	    "GetProvisionedConcurrencyConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-09-30/functions/{FunctionName}/provisioned-concurrency",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "Qualifier"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RequestedProvisionedConcurrentExecutions": {
	            "type": "integer"
	          },
	          "AvailableProvisionedConcurrentExecutions": {
	            "type": "integer"
	          },
	          "AllocatedProvisionedConcurrentExecutions": {
	            "type": "integer"
	          },
	          "Status": {},
	          "StatusReason": {},
	          "LastModified": {}
	        }
	      }
	    },
	    "Invoke": {
	      "http": {
	        "requestUri": "/2015-03-31/functions/{FunctionName}/invocations"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "InvocationType": {
	            "location": "header",
	            "locationName": "X-Amz-Invocation-Type"
	          },
	          "LogType": {
	            "location": "header",
	            "locationName": "X-Amz-Log-Type"
	          },
	          "ClientContext": {
	            "location": "header",
	            "locationName": "X-Amz-Client-Context"
	          },
	          "Payload": {
	            "shape": "S29"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          }
	        },
	        "payload": "Payload"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StatusCode": {
	            "location": "statusCode",
	            "type": "integer"
	          },
	          "FunctionError": {
	            "location": "header",
	            "locationName": "X-Amz-Function-Error"
	          },
	          "LogResult": {
	            "location": "header",
	            "locationName": "X-Amz-Log-Result"
	          },
	          "Payload": {
	            "shape": "S29"
	          },
	          "ExecutedVersion": {
	            "location": "header",
	            "locationName": "X-Amz-Executed-Version"
	          }
	        },
	        "payload": "Payload"
	      }
	    },
	    "InvokeAsync": {
	      "http": {
	        "requestUri": "/2014-11-13/functions/{FunctionName}/invoke-async/",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "InvokeArgs"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "InvokeArgs": {
	            "type": "blob",
	            "streaming": true
	          }
	        },
	        "deprecated": true,
	        "payload": "InvokeArgs"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {
	            "location": "statusCode",
	            "type": "integer"
	          }
	        },
	        "deprecated": true
	      },
	      "deprecated": true
	    },
	    "ListAliases": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-03-31/functions/{FunctionName}/aliases",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "FunctionVersion": {
	            "location": "querystring",
	            "locationName": "FunctionVersion"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Aliases": {
	            "type": "list",
	            "member": {
	              "shape": "St"
	            }
	          }
	        }
	      }
	    },
	    "ListCodeSigningConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-04-22/code-signing-configs/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "CodeSigningConfigs": {
	            "type": "list",
	            "member": {
	              "shape": "S11"
	            }
	          }
	        }
	      }
	    },
	    "ListEventSourceMappings": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-03-31/event-source-mappings/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "EventSourceArn": {
	            "location": "querystring",
	            "locationName": "EventSourceArn"
	          },
	          "FunctionName": {
	            "location": "querystring",
	            "locationName": "FunctionName"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "EventSourceMappings": {
	            "type": "list",
	            "member": {
	              "shape": "S23"
	            }
	          }
	        }
	      }
	    },
	    "ListFunctionEventInvokeConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-09-25/functions/{FunctionName}/event-invoke-config/list",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FunctionEventInvokeConfigs": {
	            "type": "list",
	            "member": {
	              "shape": "S54"
	            }
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "ListFunctionUrlConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2021-10-31/functions/{FunctionName}/urls",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "FunctionUrlConfigs"
	        ],
	        "members": {
	          "FunctionUrlConfigs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "FunctionUrl",
	                "FunctionArn",
	                "CreationTime",
	                "LastModifiedTime",
	                "AuthType"
	              ],
	              "members": {
	                "FunctionUrl": {},
	                "FunctionArn": {},
	                "CreationTime": {},
	                "LastModifiedTime": {},
	                "Cors": {
	                  "shape": "S3x"
	                },
	                "AuthType": {}
	              }
	            }
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "ListFunctions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-03-31/functions/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MasterRegion": {
	            "location": "querystring",
	            "locationName": "MasterRegion"
	          },
	          "FunctionVersion": {
	            "location": "querystring",
	            "locationName": "FunctionVersion"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Functions": {
	            "shape": "S6l"
	          }
	        }
	      }
	    },
	    "ListFunctionsByCodeSigningConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2020-04-22/code-signing-configs/{CodeSigningConfigArn}/functions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CodeSigningConfigArn"
	        ],
	        "members": {
	          "CodeSigningConfigArn": {
	            "location": "uri",
	            "locationName": "CodeSigningConfigArn"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "FunctionArns": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "ListLayerVersions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-10-31/layers/{LayerName}/versions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerName"
	        ],
	        "members": {
	          "CompatibleRuntime": {
	            "location": "querystring",
	            "locationName": "CompatibleRuntime"
	          },
	          "LayerName": {
	            "location": "uri",
	            "locationName": "LayerName"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          },
	          "CompatibleArchitecture": {
	            "location": "querystring",
	            "locationName": "CompatibleArchitecture"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "LayerVersions": {
	            "type": "list",
	            "member": {
	              "shape": "S6t"
	            }
	          }
	        }
	      }
	    },
	    "ListLayers": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2018-10-31/layers",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "CompatibleRuntime": {
	            "location": "querystring",
	            "locationName": "CompatibleRuntime"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          },
	          "CompatibleArchitecture": {
	            "location": "querystring",
	            "locationName": "CompatibleArchitecture"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Layers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "LayerName": {},
	                "LayerArn": {},
	                "LatestMatchingVersion": {
	                  "shape": "S6t"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListProvisionedConcurrencyConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2019-09-30/functions/{FunctionName}/provisioned-concurrency?List=ALL",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisionedConcurrencyConfigs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FunctionArn": {},
	                "RequestedProvisionedConcurrentExecutions": {
	                  "type": "integer"
	                },
	                "AvailableProvisionedConcurrentExecutions": {
	                  "type": "integer"
	                },
	                "AllocatedProvisionedConcurrentExecutions": {
	                  "type": "integer"
	                },
	                "Status": {},
	                "StatusReason": {},
	                "LastModified": {}
	              }
	            }
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "ListTags": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2017-03-31/tags/{ARN}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource"
	        ],
	        "members": {
	          "Resource": {
	            "location": "uri",
	            "locationName": "ARN"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S2v"
	          }
	        }
	      }
	    },
	    "ListVersionsByFunction": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2015-03-31/functions/{FunctionName}/versions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "Marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "MaxItems",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Versions": {
	            "shape": "S6l"
	          }
	        }
	      }
	    },
	    "PublishLayerVersion": {
	      "http": {
	        "requestUri": "/2018-10-31/layers/{LayerName}/versions",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerName",
	          "Content"
	        ],
	        "members": {
	          "LayerName": {
	            "location": "uri",
	            "locationName": "LayerName"
	          },
	          "Description": {},
	          "Content": {
	            "type": "structure",
	            "members": {
	              "S3Bucket": {},
	              "S3Key": {},
	              "S3ObjectVersion": {},
	              "ZipFile": {
	                "shape": "S29"
	              }
	            }
	          },
	          "CompatibleRuntimes": {
	            "shape": "S5d"
	          },
	          "LicenseInfo": {},
	          "CompatibleArchitectures": {
	            "shape": "S5f"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Content": {
	            "shape": "S5b"
	          },
	          "LayerArn": {},
	          "LayerVersionArn": {},
	          "Description": {},
	          "CreatedDate": {},
	          "Version": {
	            "type": "long"
	          },
	          "CompatibleRuntimes": {
	            "shape": "S5d"
	          },
	          "LicenseInfo": {},
	          "CompatibleArchitectures": {
	            "shape": "S5f"
	          }
	        }
	      }
	    },
	    "PublishVersion": {
	      "http": {
	        "requestUri": "/2015-03-31/functions/{FunctionName}/versions",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "CodeSha256": {},
	          "Description": {},
	          "RevisionId": {}
	        }
	      },
	      "output": {
	        "shape": "S3b"
	      }
	    },
	    "PutFunctionCodeSigningConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-06-30/functions/{FunctionName}/code-signing-config",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CodeSigningConfigArn",
	          "FunctionName"
	        ],
	        "members": {
	          "CodeSigningConfigArn": {},
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CodeSigningConfigArn",
	          "FunctionName"
	        ],
	        "members": {
	          "CodeSigningConfigArn": {},
	          "FunctionName": {}
	        }
	      }
	    },
	    "PutFunctionConcurrency": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2017-10-31/functions/{FunctionName}/concurrency",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "ReservedConcurrentExecutions"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "ReservedConcurrentExecutions": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4w"
	      }
	    },
	    "PutFunctionEventInvokeConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2019-09-25/functions/{FunctionName}/event-invoke-config",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          },
	          "MaximumRetryAttempts": {
	            "type": "integer"
	          },
	          "MaximumEventAgeInSeconds": {
	            "type": "integer"
	          },
	          "DestinationConfig": {
	            "shape": "S1g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S54"
	      }
	    },
	    "PutProvisionedConcurrencyConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2019-09-30/functions/{FunctionName}/provisioned-concurrency",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "Qualifier",
	          "ProvisionedConcurrentExecutions"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          },
	          "ProvisionedConcurrentExecutions": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RequestedProvisionedConcurrentExecutions": {
	            "type": "integer"
	          },
	          "AvailableProvisionedConcurrentExecutions": {
	            "type": "integer"
	          },
	          "AllocatedProvisionedConcurrentExecutions": {
	            "type": "integer"
	          },
	          "Status": {},
	          "StatusReason": {},
	          "LastModified": {}
	        }
	      }
	    },
	    "RemoveLayerVersionPermission": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy/{StatementId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerName",
	          "VersionNumber",
	          "StatementId"
	        ],
	        "members": {
	          "LayerName": {
	            "location": "uri",
	            "locationName": "LayerName"
	          },
	          "VersionNumber": {
	            "location": "uri",
	            "locationName": "VersionNumber",
	            "type": "long"
	          },
	          "StatementId": {
	            "location": "uri",
	            "locationName": "StatementId"
	          },
	          "RevisionId": {
	            "location": "querystring",
	            "locationName": "RevisionId"
	          }
	        }
	      }
	    },
	    "RemovePermission": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2015-03-31/functions/{FunctionName}/policy/{StatementId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "StatementId"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "StatementId": {
	            "location": "uri",
	            "locationName": "StatementId"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          },
	          "RevisionId": {
	            "location": "querystring",
	            "locationName": "RevisionId"
	          }
	        }
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/2017-03-31/tags/{ARN}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "Tags"
	        ],
	        "members": {
	          "Resource": {
	            "location": "uri",
	            "locationName": "ARN"
	          },
	          "Tags": {
	            "shape": "S2v"
	          }
	        }
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2017-03-31/tags/{ARN}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Resource",
	          "TagKeys"
	        ],
	        "members": {
	          "Resource": {
	            "location": "uri",
	            "locationName": "ARN"
	          },
	          "TagKeys": {
	            "location": "querystring",
	            "locationName": "tagKeys",
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "UpdateAlias": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName",
	          "Name"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          },
	          "FunctionVersion": {},
	          "Description": {},
	          "RoutingConfig": {
	            "shape": "Sp"
	          },
	          "RevisionId": {}
	        }
	      },
	      "output": {
	        "shape": "St"
	      }
	    },
	    "UpdateCodeSigningConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2020-04-22/code-signing-configs/{CodeSigningConfigArn}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CodeSigningConfigArn"
	        ],
	        "members": {
	          "CodeSigningConfigArn": {
	            "location": "uri",
	            "locationName": "CodeSigningConfigArn"
	          },
	          "Description": {},
	          "AllowedPublishers": {
	            "shape": "Sw"
	          },
	          "CodeSigningPolicies": {
	            "shape": "Sy"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CodeSigningConfig"
	        ],
	        "members": {
	          "CodeSigningConfig": {
	            "shape": "S11"
	          }
	        }
	      }
	    },
	    "UpdateEventSourceMapping": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2015-03-31/event-source-mappings/{UUID}",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UUID"
	        ],
	        "members": {
	          "UUID": {
	            "location": "uri",
	            "locationName": "UUID"
	          },
	          "FunctionName": {},
	          "Enabled": {
	            "type": "boolean"
	          },
	          "BatchSize": {
	            "type": "integer"
	          },
	          "FilterCriteria": {
	            "shape": "S18"
	          },
	          "MaximumBatchingWindowInSeconds": {
	            "type": "integer"
	          },
	          "DestinationConfig": {
	            "shape": "S1g"
	          },
	          "MaximumRecordAgeInSeconds": {
	            "type": "integer"
	          },
	          "BisectBatchOnFunctionError": {
	            "type": "boolean"
	          },
	          "MaximumRetryAttempts": {
	            "type": "integer"
	          },
	          "ParallelizationFactor": {
	            "type": "integer"
	          },
	          "SourceAccessConfigurations": {
	            "shape": "S1s"
	          },
	          "TumblingWindowInSeconds": {
	            "type": "integer"
	          },
	          "FunctionResponseTypes": {
	            "shape": "S21"
	          }
	        }
	      },
	      "output": {
	        "shape": "S23"
	      }
	    },
	    "UpdateFunctionCode": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2015-03-31/functions/{FunctionName}/code",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "ZipFile": {
	            "shape": "S29"
	          },
	          "S3Bucket": {},
	          "S3Key": {},
	          "S3ObjectVersion": {},
	          "ImageUri": {},
	          "Publish": {
	            "type": "boolean"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "RevisionId": {},
	          "Architectures": {
	            "shape": "S37"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3b"
	      }
	    },
	    "UpdateFunctionConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2015-03-31/functions/{FunctionName}/configuration",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Role": {},
	          "Handler": {},
	          "Description": {},
	          "Timeout": {
	            "type": "integer"
	          },
	          "MemorySize": {
	            "type": "integer"
	          },
	          "VpcConfig": {
	            "shape": "S2g"
	          },
	          "Environment": {
	            "shape": "S2o"
	          },
	          "Runtime": {},
	          "DeadLetterConfig": {
	            "shape": "S2m"
	          },
	          "KMSKeyArn": {},
	          "TracingConfig": {
	            "shape": "S2t"
	          },
	          "RevisionId": {},
	          "Layers": {
	            "shape": "S2y"
	          },
	          "FileSystemConfigs": {
	            "shape": "S30"
	          },
	          "ImageConfig": {
	            "shape": "S34"
	          },
	          "EphemeralStorage": {
	            "shape": "S39"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3b"
	      }
	    },
	    "UpdateFunctionEventInvokeConfig": {
	      "http": {
	        "requestUri": "/2019-09-25/functions/{FunctionName}/event-invoke-config",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          },
	          "MaximumRetryAttempts": {
	            "type": "integer"
	          },
	          "MaximumEventAgeInSeconds": {
	            "type": "integer"
	          },
	          "DestinationConfig": {
	            "shape": "S1g"
	          }
	        }
	      },
	      "output": {
	        "shape": "S54"
	      }
	    },
	    "UpdateFunctionUrlConfig": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/2021-10-31/functions/{FunctionName}/url",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FunctionName"
	        ],
	        "members": {
	          "FunctionName": {
	            "location": "uri",
	            "locationName": "FunctionName"
	          },
	          "Qualifier": {
	            "location": "querystring",
	            "locationName": "Qualifier"
	          },
	          "AuthType": {},
	          "Cors": {
	            "shape": "S3x"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "FunctionUrl",
	          "FunctionArn",
	          "AuthType",
	          "CreationTime",
	          "LastModifiedTime"
	        ],
	        "members": {
	          "FunctionUrl": {},
	          "FunctionArn": {},
	          "AuthType": {},
	          "Cors": {
	            "shape": "S3x"
	          },
	          "CreationTime": {},
	          "LastModifiedTime": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sp": {
	      "type": "structure",
	      "members": {
	        "AdditionalVersionWeights": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "St": {
	      "type": "structure",
	      "members": {
	        "AliasArn": {},
	        "Name": {},
	        "FunctionVersion": {},
	        "Description": {},
	        "RoutingConfig": {
	          "shape": "Sp"
	        },
	        "RevisionId": {}
	      }
	    },
	    "Sw": {
	      "type": "structure",
	      "required": [
	        "SigningProfileVersionArns"
	      ],
	      "members": {
	        "SigningProfileVersionArns": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "Sy": {
	      "type": "structure",
	      "members": {
	        "UntrustedArtifactOnDeployment": {}
	      }
	    },
	    "S11": {
	      "type": "structure",
	      "required": [
	        "CodeSigningConfigId",
	        "CodeSigningConfigArn",
	        "AllowedPublishers",
	        "CodeSigningPolicies",
	        "LastModified"
	      ],
	      "members": {
	        "CodeSigningConfigId": {},
	        "CodeSigningConfigArn": {},
	        "Description": {},
	        "AllowedPublishers": {
	          "shape": "Sw"
	        },
	        "CodeSigningPolicies": {
	          "shape": "Sy"
	        },
	        "LastModified": {}
	      }
	    },
	    "S18": {
	      "type": "structure",
	      "members": {
	        "Filters": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Pattern": {}
	            }
	          }
	        }
	      }
	    },
	    "S1g": {
	      "type": "structure",
	      "members": {
	        "OnSuccess": {
	          "type": "structure",
	          "members": {
	            "Destination": {}
	          }
	        },
	        "OnFailure": {
	          "type": "structure",
	          "members": {
	            "Destination": {}
	          }
	        }
	      }
	    },
	    "S1o": {
	      "type": "list",
	      "member": {}
	    },
	    "S1q": {
	      "type": "list",
	      "member": {}
	    },
	    "S1s": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "URI": {}
	        }
	      }
	    },
	    "S1w": {
	      "type": "structure",
	      "members": {
	        "Endpoints": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "S21": {
	      "type": "list",
	      "member": {}
	    },
	    "S23": {
	      "type": "structure",
	      "members": {
	        "UUID": {},
	        "StartingPosition": {},
	        "StartingPositionTimestamp": {
	          "type": "timestamp"
	        },
	        "BatchSize": {
	          "type": "integer"
	        },
	        "MaximumBatchingWindowInSeconds": {
	          "type": "integer"
	        },
	        "ParallelizationFactor": {
	          "type": "integer"
	        },
	        "EventSourceArn": {},
	        "FilterCriteria": {
	          "shape": "S18"
	        },
	        "FunctionArn": {},
	        "LastModified": {
	          "type": "timestamp"
	        },
	        "LastProcessingResult": {},
	        "State": {},
	        "StateTransitionReason": {},
	        "DestinationConfig": {
	          "shape": "S1g"
	        },
	        "Topics": {
	          "shape": "S1o"
	        },
	        "Queues": {
	          "shape": "S1q"
	        },
	        "SourceAccessConfigurations": {
	          "shape": "S1s"
	        },
	        "SelfManagedEventSource": {
	          "shape": "S1w"
	        },
	        "MaximumRecordAgeInSeconds": {
	          "type": "integer"
	        },
	        "BisectBatchOnFunctionError": {
	          "type": "boolean"
	        },
	        "MaximumRetryAttempts": {
	          "type": "integer"
	        },
	        "TumblingWindowInSeconds": {
	          "type": "integer"
	        },
	        "FunctionResponseTypes": {
	          "shape": "S21"
	        }
	      }
	    },
	    "S29": {
	      "type": "blob",
	      "sensitive": true
	    },
	    "S2g": {
	      "type": "structure",
	      "members": {
	        "SubnetIds": {
	          "shape": "S2h"
	        },
	        "SecurityGroupIds": {
	          "shape": "S2j"
	        }
	      }
	    },
	    "S2h": {
	      "type": "list",
	      "member": {}
	    },
	    "S2j": {
	      "type": "list",
	      "member": {}
	    },
	    "S2m": {
	      "type": "structure",
	      "members": {
	        "TargetArn": {}
	      }
	    },
	    "S2o": {
	      "type": "structure",
	      "members": {
	        "Variables": {
	          "shape": "S2p"
	        }
	      }
	    },
	    "S2p": {
	      "type": "map",
	      "key": {
	        "type": "string",
	        "sensitive": true
	      },
	      "value": {
	        "type": "string",
	        "sensitive": true
	      },
	      "sensitive": true
	    },
	    "S2t": {
	      "type": "structure",
	      "members": {
	        "Mode": {}
	      }
	    },
	    "S2v": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S2y": {
	      "type": "list",
	      "member": {}
	    },
	    "S30": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Arn",
	          "LocalMountPath"
	        ],
	        "members": {
	          "Arn": {},
	          "LocalMountPath": {}
	        }
	      }
	    },
	    "S34": {
	      "type": "structure",
	      "members": {
	        "EntryPoint": {
	          "shape": "S35"
	        },
	        "Command": {
	          "shape": "S35"
	        },
	        "WorkingDirectory": {}
	      }
	    },
	    "S35": {
	      "type": "list",
	      "member": {}
	    },
	    "S37": {
	      "type": "list",
	      "member": {}
	    },
	    "S39": {
	      "type": "structure",
	      "required": [
	        "Size"
	      ],
	      "members": {
	        "Size": {
	          "type": "integer"
	        }
	      }
	    },
	    "S3b": {
	      "type": "structure",
	      "members": {
	        "FunctionName": {},
	        "FunctionArn": {},
	        "Runtime": {},
	        "Role": {},
	        "Handler": {},
	        "CodeSize": {
	          "type": "long"
	        },
	        "Description": {},
	        "Timeout": {
	          "type": "integer"
	        },
	        "MemorySize": {
	          "type": "integer"
	        },
	        "LastModified": {},
	        "CodeSha256": {},
	        "Version": {},
	        "VpcConfig": {
	          "type": "structure",
	          "members": {
	            "SubnetIds": {
	              "shape": "S2h"
	            },
	            "SecurityGroupIds": {
	              "shape": "S2j"
	            },
	            "VpcId": {}
	          }
	        },
	        "DeadLetterConfig": {
	          "shape": "S2m"
	        },
	        "Environment": {
	          "type": "structure",
	          "members": {
	            "Variables": {
	              "shape": "S2p"
	            },
	            "Error": {
	              "type": "structure",
	              "members": {
	                "ErrorCode": {},
	                "Message": {
	                  "shape": "S3j"
	                }
	              }
	            }
	          }
	        },
	        "KMSKeyArn": {},
	        "TracingConfig": {
	          "type": "structure",
	          "members": {
	            "Mode": {}
	          }
	        },
	        "MasterArn": {},
	        "RevisionId": {},
	        "Layers": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Arn": {},
	              "CodeSize": {
	                "type": "long"
	              },
	              "SigningProfileVersionArn": {},
	              "SigningJobArn": {}
	            }
	          }
	        },
	        "State": {},
	        "StateReason": {},
	        "StateReasonCode": {},
	        "LastUpdateStatus": {},
	        "LastUpdateStatusReason": {},
	        "LastUpdateStatusReasonCode": {},
	        "FileSystemConfigs": {
	          "shape": "S30"
	        },
	        "PackageType": {},
	        "ImageConfigResponse": {
	          "type": "structure",
	          "members": {
	            "ImageConfig": {
	              "shape": "S34"
	            },
	            "Error": {
	              "type": "structure",
	              "members": {
	                "ErrorCode": {},
	                "Message": {
	                  "shape": "S3j"
	                }
	              }
	            }
	          }
	        },
	        "SigningProfileVersionArn": {},
	        "SigningJobArn": {},
	        "Architectures": {
	          "shape": "S37"
	        },
	        "EphemeralStorage": {
	          "shape": "S39"
	        }
	      }
	    },
	    "S3j": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S3x": {
	      "type": "structure",
	      "members": {
	        "AllowCredentials": {
	          "type": "boolean"
	        },
	        "AllowHeaders": {
	          "shape": "S3z"
	        },
	        "AllowMethods": {
	          "type": "list",
	          "member": {}
	        },
	        "AllowOrigins": {
	          "type": "list",
	          "member": {}
	        },
	        "ExposeHeaders": {
	          "shape": "S3z"
	        },
	        "MaxAge": {
	          "type": "integer"
	        }
	      }
	    },
	    "S3z": {
	      "type": "list",
	      "member": {}
	    },
	    "S4w": {
	      "type": "structure",
	      "members": {
	        "ReservedConcurrentExecutions": {
	          "type": "integer"
	        }
	      }
	    },
	    "S54": {
	      "type": "structure",
	      "members": {
	        "LastModified": {
	          "type": "timestamp"
	        },
	        "FunctionArn": {},
	        "MaximumRetryAttempts": {
	          "type": "integer"
	        },
	        "MaximumEventAgeInSeconds": {
	          "type": "integer"
	        },
	        "DestinationConfig": {
	          "shape": "S1g"
	        }
	      }
	    },
	    "S5a": {
	      "type": "structure",
	      "members": {
	        "Content": {
	          "shape": "S5b"
	        },
	        "LayerArn": {},
	        "LayerVersionArn": {},
	        "Description": {},
	        "CreatedDate": {},
	        "Version": {
	          "type": "long"
	        },
	        "CompatibleRuntimes": {
	          "shape": "S5d"
	        },
	        "LicenseInfo": {},
	        "CompatibleArchitectures": {
	          "shape": "S5f"
	        }
	      }
	    },
	    "S5b": {
	      "type": "structure",
	      "members": {
	        "Location": {},
	        "CodeSha256": {},
	        "CodeSize": {
	          "type": "long"
	        },
	        "SigningProfileVersionArn": {},
	        "SigningJobArn": {}
	      }
	    },
	    "S5d": {
	      "type": "list",
	      "member": {}
	    },
	    "S5f": {
	      "type": "list",
	      "member": {}
	    },
	    "S6l": {
	      "type": "list",
	      "member": {
	        "shape": "S3b"
	      }
	    },
	    "S6t": {
	      "type": "structure",
	      "members": {
	        "LayerVersionArn": {},
	        "Version": {
	          "type": "long"
	        },
	        "Description": {},
	        "CreatedDate": {},
	        "CompatibleRuntimes": {
	          "shape": "S5d"
	        },
	        "LicenseInfo": {},
	        "CompatibleArchitectures": {
	          "shape": "S5f"
	        }
	      }
	    }
	  }
	}
	},{}],148:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListAliases": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextMarker",
	      "result_key": "Aliases"
	    },
	    "ListCodeSigningConfigs": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextMarker",
	      "result_key": "CodeSigningConfigs"
	    },
	    "ListEventSourceMappings": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextMarker",
	      "result_key": "EventSourceMappings"
	    },
	    "ListFunctionEventInvokeConfigs": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextMarker",
	      "result_key": "FunctionEventInvokeConfigs"
	    },
	    "ListFunctionUrlConfigs": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextMarker",
	      "result_key": "FunctionUrlConfigs"
	    },
	    "ListFunctions": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextMarker",
	      "result_key": "Functions"
	    },
	    "ListFunctionsByCodeSigningConfig": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextMarker",
	      "result_key": "FunctionArns"
	    },
	    "ListLayerVersions": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextMarker",
	      "result_key": "LayerVersions"
	    },
	    "ListLayers": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextMarker",
	      "result_key": "Layers"
	    },
	    "ListProvisionedConcurrencyConfigs": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextMarker",
	      "result_key": "ProvisionedConcurrencyConfigs"
	    },
	    "ListVersionsByFunction": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextMarker",
	      "result_key": "Versions"
	    }
	  }
	}
	},{}],149:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "FunctionExists": {
	      "delay": 1,
	      "operation": "GetFunction",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "status",
	          "expected": 200
	        },
	        {
	          "state": "retry",
	          "matcher": "error",
	          "expected": "ResourceNotFoundException"
	        }
	      ]
	    },
	    "FunctionActive": {
	      "delay": 5,
	      "maxAttempts": 60,
	      "operation": "GetFunctionConfiguration",
	      "description": "Waits for the function's State to be Active. This waiter uses GetFunctionConfiguration API. This should be used after new function creation.",
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "path",
	          "argument": "State",
	          "expected": "Active"
	        },
	        {
	          "state": "failure",
	          "matcher": "path",
	          "argument": "State",
	          "expected": "Failed"
	        },
	        {
	          "state": "retry",
	          "matcher": "path",
	          "argument": "State",
	          "expected": "Pending"
	        }
	      ]
	    },
	    "FunctionUpdated": {
	      "delay": 5,
	      "maxAttempts": 60,
	      "operation": "GetFunctionConfiguration",
	      "description": "Waits for the function's LastUpdateStatus to be Successful. This waiter uses GetFunctionConfiguration API. This should be used after function updates.",
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "path",
	          "argument": "LastUpdateStatus",
	          "expected": "Successful"
	        },
	        {
	          "state": "failure",
	          "matcher": "path",
	          "argument": "LastUpdateStatus",
	          "expected": "Failed"
	        },
	        {
	          "state": "retry",
	          "matcher": "path",
	          "argument": "LastUpdateStatus",
	          "expected": "InProgress"
	        }
	      ]
	    },
	    "FunctionActiveV2": {
	      "delay": 1,
	      "maxAttempts": 300,
	      "operation": "GetFunction",
	      "description": "Waits for the function's State to be Active. This waiter uses GetFunction API. This should be used after new function creation.",
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "path",
	          "argument": "Configuration.State",
	          "expected": "Active"
	        },
	        {
	          "state": "failure",
	          "matcher": "path",
	          "argument": "Configuration.State",
	          "expected": "Failed"
	        },
	        {
	          "state": "retry",
	          "matcher": "path",
	          "argument": "Configuration.State",
	          "expected": "Pending"
	        }
	      ]
	    },
	    "FunctionUpdatedV2": {
	      "delay": 1,
	      "maxAttempts": 300,
	      "operation": "GetFunction",
	      "description": "Waits for the function's LastUpdateStatus to be Successful. This waiter uses GetFunction API. This should be used after function updates.",
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "path",
	          "argument": "Configuration.LastUpdateStatus",
	          "expected": "Successful"
	        },
	        {
	          "state": "failure",
	          "matcher": "path",
	          "argument": "Configuration.LastUpdateStatus",
	          "expected": "Failed"
	        },
	        {
	          "state": "retry",
	          "matcher": "path",
	          "argument": "Configuration.LastUpdateStatus",
	          "expected": "InProgress"
	        }
	      ]
	    }
	  }
	}
	
	},{}],150:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-04-19",
	    "endpointPrefix": "models.lex",
	    "jsonVersion": "1.1",
	    "protocol": "rest-json",
	    "serviceFullName": "Amazon Lex Model Building Service",
	    "serviceId": "Lex Model Building Service",
	    "signatureVersion": "v4",
	    "signingName": "lex",
	    "uid": "lex-models-2017-04-19"
	  },
	  "operations": {
	    "CreateBotVersion": {
	      "http": {
	        "requestUri": "/bots/{name}/versions",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "checksum": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "intents": {
	            "shape": "S6"
	          },
	          "clarificationPrompt": {
	            "shape": "Sa"
	          },
	          "abortStatement": {
	            "shape": "Si"
	          },
	          "status": {},
	          "failureReason": {},
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "idleSessionTTLInSeconds": {
	            "type": "integer"
	          },
	          "voiceId": {},
	          "checksum": {},
	          "version": {},
	          "locale": {},
	          "childDirected": {
	            "type": "boolean"
	          },
	          "enableModelImprovements": {
	            "type": "boolean"
	          },
	          "detectSentiment": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "CreateIntentVersion": {
	      "http": {
	        "requestUri": "/intents/{name}/versions",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "checksum": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "slots": {
	            "shape": "Sq"
	          },
	          "sampleUtterances": {
	            "shape": "S13"
	          },
	          "confirmationPrompt": {
	            "shape": "Sa"
	          },
	          "rejectionStatement": {
	            "shape": "Si"
	          },
	          "followUpPrompt": {
	            "shape": "S14"
	          },
	          "conclusionStatement": {
	            "shape": "Si"
	          },
	          "dialogCodeHook": {
	            "shape": "S15"
	          },
	          "fulfillmentActivity": {
	            "shape": "S18"
	          },
	          "parentIntentSignature": {},
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "version": {},
	          "checksum": {},
	          "kendraConfiguration": {
	            "shape": "S1b"
	          },
	          "inputContexts": {
	            "shape": "S1f"
	          },
	          "outputContexts": {
	            "shape": "S1i"
	          }
	        }
	      }
	    },
	    "CreateSlotTypeVersion": {
	      "http": {
	        "requestUri": "/slottypes/{name}/versions",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "checksum": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "enumerationValues": {
	            "shape": "S1q"
	          },
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "version": {},
	          "checksum": {},
	          "valueSelectionStrategy": {},
	          "parentSlotTypeSignature": {},
	          "slotTypeConfigurations": {
	            "shape": "S1v"
	          }
	        }
	      }
	    },
	    "DeleteBot": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/bots/{name}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          }
	        }
	      }
	    },
	    "DeleteBotAlias": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/bots/{botName}/aliases/{name}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "botName"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          }
	        }
	      }
	    },
	    "DeleteBotChannelAssociation": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/bots/{botName}/aliases/{aliasName}/channels/{name}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "botName",
	          "botAlias"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          },
	          "botAlias": {
	            "location": "uri",
	            "locationName": "aliasName"
	          }
	        }
	      }
	    },
	    "DeleteBotVersion": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/bots/{name}/versions/{version}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "version"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "version": {
	            "location": "uri",
	            "locationName": "version"
	          }
	        }
	      }
	    },
	    "DeleteIntent": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/intents/{name}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          }
	        }
	      }
	    },
	    "DeleteIntentVersion": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/intents/{name}/versions/{version}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "version"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "version": {
	            "location": "uri",
	            "locationName": "version"
	          }
	        }
	      }
	    },
	    "DeleteSlotType": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/slottypes/{name}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          }
	        }
	      }
	    },
	    "DeleteSlotTypeVersion": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/slottypes/{name}/version/{version}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "version"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "version": {
	            "location": "uri",
	            "locationName": "version"
	          }
	        }
	      }
	    },
	    "DeleteUtterances": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/bots/{botName}/utterances/{userId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botName",
	          "userId"
	        ],
	        "members": {
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          },
	          "userId": {
	            "location": "uri",
	            "locationName": "userId"
	          }
	        }
	      }
	    },
	    "GetBot": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/bots/{name}/versions/{versionoralias}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "versionOrAlias"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "versionOrAlias": {
	            "location": "uri",
	            "locationName": "versionoralias"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "intents": {
	            "shape": "S6"
	          },
	          "enableModelImprovements": {
	            "type": "boolean"
	          },
	          "nluIntentConfidenceThreshold": {
	            "type": "double"
	          },
	          "clarificationPrompt": {
	            "shape": "Sa"
	          },
	          "abortStatement": {
	            "shape": "Si"
	          },
	          "status": {},
	          "failureReason": {},
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "idleSessionTTLInSeconds": {
	            "type": "integer"
	          },
	          "voiceId": {},
	          "checksum": {},
	          "version": {},
	          "locale": {},
	          "childDirected": {
	            "type": "boolean"
	          },
	          "detectSentiment": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "GetBotAlias": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/bots/{botName}/aliases/{name}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "botName"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "botVersion": {},
	          "botName": {},
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "checksum": {},
	          "conversationLogs": {
	            "shape": "S2h"
	          }
	        }
	      }
	    },
	    "GetBotAliases": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/bots/{botName}/aliases/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botName"
	        ],
	        "members": {
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nameContains": {
	            "location": "querystring",
	            "locationName": "nameContains"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BotAliases": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "description": {},
	                "botVersion": {},
	                "botName": {},
	                "lastUpdatedDate": {
	                  "type": "timestamp"
	                },
	                "createdDate": {
	                  "type": "timestamp"
	                },
	                "checksum": {},
	                "conversationLogs": {
	                  "shape": "S2h"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetBotChannelAssociation": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/bots/{botName}/aliases/{aliasName}/channels/{name}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "botName",
	          "botAlias"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          },
	          "botAlias": {
	            "location": "uri",
	            "locationName": "aliasName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "botAlias": {},
	          "botName": {},
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "type": {},
	          "botConfiguration": {
	            "shape": "S2z"
	          },
	          "status": {},
	          "failureReason": {}
	        }
	      }
	    },
	    "GetBotChannelAssociations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/bots/{botName}/aliases/{aliasName}/channels/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botName",
	          "botAlias"
	        ],
	        "members": {
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          },
	          "botAlias": {
	            "location": "uri",
	            "locationName": "aliasName"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nameContains": {
	            "location": "querystring",
	            "locationName": "nameContains"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "botChannelAssociations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "description": {},
	                "botAlias": {},
	                "botName": {},
	                "createdDate": {
	                  "type": "timestamp"
	                },
	                "type": {},
	                "botConfiguration": {
	                  "shape": "S2z"
	                },
	                "status": {},
	                "failureReason": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetBotVersions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/bots/{name}/versions/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "bots": {
	            "shape": "S38"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetBots": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/bots/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nameContains": {
	            "location": "querystring",
	            "locationName": "nameContains"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "bots": {
	            "shape": "S38"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetBuiltinIntent": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/builtins/intents/{signature}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "signature"
	        ],
	        "members": {
	          "signature": {
	            "location": "uri",
	            "locationName": "signature"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "signature": {},
	          "supportedLocales": {
	            "shape": "S3e"
	          },
	          "slots": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetBuiltinIntents": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/builtins/intents/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "locale": {
	            "location": "querystring",
	            "locationName": "locale"
	          },
	          "signatureContains": {
	            "location": "querystring",
	            "locationName": "signatureContains"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "intents": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "signature": {},
	                "supportedLocales": {
	                  "shape": "S3e"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetBuiltinSlotTypes": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/builtins/slottypes/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "locale": {
	            "location": "querystring",
	            "locationName": "locale"
	          },
	          "signatureContains": {
	            "location": "querystring",
	            "locationName": "signatureContains"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "slotTypes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "signature": {},
	                "supportedLocales": {
	                  "shape": "S3e"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetExport": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/exports/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "version",
	          "resourceType",
	          "exportType"
	        ],
	        "members": {
	          "name": {
	            "location": "querystring",
	            "locationName": "name"
	          },
	          "version": {
	            "location": "querystring",
	            "locationName": "version"
	          },
	          "resourceType": {
	            "location": "querystring",
	            "locationName": "resourceType"
	          },
	          "exportType": {
	            "location": "querystring",
	            "locationName": "exportType"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "version": {},
	          "resourceType": {},
	          "exportType": {},
	          "exportStatus": {},
	          "failureReason": {},
	          "url": {}
	        }
	      }
	    },
	    "GetImport": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/imports/{importId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "importId"
	        ],
	        "members": {
	          "importId": {
	            "location": "uri",
	            "locationName": "importId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "resourceType": {},
	          "mergeStrategy": {},
	          "importId": {},
	          "importStatus": {},
	          "failureReason": {
	            "type": "list",
	            "member": {}
	          },
	          "createdDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetIntent": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/intents/{name}/versions/{version}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "version"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "version": {
	            "location": "uri",
	            "locationName": "version"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "slots": {
	            "shape": "Sq"
	          },
	          "sampleUtterances": {
	            "shape": "S13"
	          },
	          "confirmationPrompt": {
	            "shape": "Sa"
	          },
	          "rejectionStatement": {
	            "shape": "Si"
	          },
	          "followUpPrompt": {
	            "shape": "S14"
	          },
	          "conclusionStatement": {
	            "shape": "Si"
	          },
	          "dialogCodeHook": {
	            "shape": "S15"
	          },
	          "fulfillmentActivity": {
	            "shape": "S18"
	          },
	          "parentIntentSignature": {},
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "version": {},
	          "checksum": {},
	          "kendraConfiguration": {
	            "shape": "S1b"
	          },
	          "inputContexts": {
	            "shape": "S1f"
	          },
	          "outputContexts": {
	            "shape": "S1i"
	          }
	        }
	      }
	    },
	    "GetIntentVersions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/intents/{name}/versions/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "intents": {
	            "shape": "S45"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetIntents": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/intents/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nameContains": {
	            "location": "querystring",
	            "locationName": "nameContains"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "intents": {
	            "shape": "S45"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetMigration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/migrations/{migrationId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "migrationId"
	        ],
	        "members": {
	          "migrationId": {
	            "location": "uri",
	            "locationName": "migrationId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "migrationId": {},
	          "v1BotName": {},
	          "v1BotVersion": {},
	          "v1BotLocale": {},
	          "v2BotId": {},
	          "v2BotRole": {},
	          "migrationStatus": {},
	          "migrationStrategy": {},
	          "migrationTimestamp": {
	            "type": "timestamp"
	          },
	          "alerts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "type": {},
	                "message": {},
	                "details": {
	                  "type": "list",
	                  "member": {}
	                },
	                "referenceURLs": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetMigrations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/migrations",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "sortByAttribute": {
	            "location": "querystring",
	            "locationName": "sortByAttribute"
	          },
	          "sortByOrder": {
	            "location": "querystring",
	            "locationName": "sortByOrder"
	          },
	          "v1BotNameContains": {
	            "location": "querystring",
	            "locationName": "v1BotNameContains"
	          },
	          "migrationStatusEquals": {
	            "location": "querystring",
	            "locationName": "migrationStatusEquals"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "migrationSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "migrationId": {},
	                "v1BotName": {},
	                "v1BotVersion": {},
	                "v1BotLocale": {},
	                "v2BotId": {},
	                "v2BotRole": {},
	                "migrationStatus": {},
	                "migrationStrategy": {},
	                "migrationTimestamp": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetSlotType": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/slottypes/{name}/versions/{version}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "version"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "version": {
	            "location": "uri",
	            "locationName": "version"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "enumerationValues": {
	            "shape": "S1q"
	          },
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "version": {},
	          "checksum": {},
	          "valueSelectionStrategy": {},
	          "parentSlotTypeSignature": {},
	          "slotTypeConfigurations": {
	            "shape": "S1v"
	          }
	        }
	      }
	    },
	    "GetSlotTypeVersions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/slottypes/{name}/versions/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "slotTypes": {
	            "shape": "S4x"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetSlotTypes": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/slottypes/",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          },
	          "maxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "nameContains": {
	            "location": "querystring",
	            "locationName": "nameContains"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "slotTypes": {
	            "shape": "S4x"
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetUtterancesView": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/bots/{botname}/utterances?view=aggregation",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botName",
	          "botVersions",
	          "statusType"
	        ],
	        "members": {
	          "botName": {
	            "location": "uri",
	            "locationName": "botname"
	          },
	          "botVersions": {
	            "location": "querystring",
	            "locationName": "bot_versions",
	            "type": "list",
	            "member": {}
	          },
	          "statusType": {
	            "location": "querystring",
	            "locationName": "status_type"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "botName": {},
	          "utterances": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "botVersion": {},
	                "utterances": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "utteranceString": {},
	                      "count": {
	                        "type": "integer"
	                      },
	                      "distinctUsers": {
	                        "type": "integer"
	                      },
	                      "firstUtteredDate": {
	                        "type": "timestamp"
	                      },
	                      "lastUtteredDate": {
	                        "type": "timestamp"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/tags/{resourceArn}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "uri",
	            "locationName": "resourceArn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tags": {
	            "shape": "S5e"
	          }
	        }
	      }
	    },
	    "PutBot": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/bots/{name}/versions/$LATEST",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "locale",
	          "childDirected"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "description": {},
	          "intents": {
	            "shape": "S6"
	          },
	          "enableModelImprovements": {
	            "type": "boolean"
	          },
	          "nluIntentConfidenceThreshold": {
	            "type": "double"
	          },
	          "clarificationPrompt": {
	            "shape": "Sa"
	          },
	          "abortStatement": {
	            "shape": "Si"
	          },
	          "idleSessionTTLInSeconds": {
	            "type": "integer"
	          },
	          "voiceId": {},
	          "checksum": {},
	          "processBehavior": {},
	          "locale": {},
	          "childDirected": {
	            "type": "boolean"
	          },
	          "detectSentiment": {
	            "type": "boolean"
	          },
	          "createVersion": {
	            "type": "boolean"
	          },
	          "tags": {
	            "shape": "S5e"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "intents": {
	            "shape": "S6"
	          },
	          "enableModelImprovements": {
	            "type": "boolean"
	          },
	          "nluIntentConfidenceThreshold": {
	            "type": "double"
	          },
	          "clarificationPrompt": {
	            "shape": "Sa"
	          },
	          "abortStatement": {
	            "shape": "Si"
	          },
	          "status": {},
	          "failureReason": {},
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "idleSessionTTLInSeconds": {
	            "type": "integer"
	          },
	          "voiceId": {},
	          "checksum": {},
	          "version": {},
	          "locale": {},
	          "childDirected": {
	            "type": "boolean"
	          },
	          "createVersion": {
	            "type": "boolean"
	          },
	          "detectSentiment": {
	            "type": "boolean"
	          },
	          "tags": {
	            "shape": "S5e"
	          }
	        }
	      }
	    },
	    "PutBotAlias": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/bots/{botName}/aliases/{name}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "botVersion",
	          "botName"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "description": {},
	          "botVersion": {},
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          },
	          "checksum": {},
	          "conversationLogs": {
	            "type": "structure",
	            "required": [
	              "logSettings",
	              "iamRoleArn"
	            ],
	            "members": {
	              "logSettings": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "logType",
	                    "destination",
	                    "resourceArn"
	                  ],
	                  "members": {
	                    "logType": {},
	                    "destination": {},
	                    "kmsKeyArn": {},
	                    "resourceArn": {}
	                  }
	                }
	              },
	              "iamRoleArn": {}
	            }
	          },
	          "tags": {
	            "shape": "S5e"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "botVersion": {},
	          "botName": {},
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "checksum": {},
	          "conversationLogs": {
	            "shape": "S2h"
	          },
	          "tags": {
	            "shape": "S5e"
	          }
	        }
	      }
	    },
	    "PutIntent": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/intents/{name}/versions/$LATEST",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "description": {},
	          "slots": {
	            "shape": "Sq"
	          },
	          "sampleUtterances": {
	            "shape": "S13"
	          },
	          "confirmationPrompt": {
	            "shape": "Sa"
	          },
	          "rejectionStatement": {
	            "shape": "Si"
	          },
	          "followUpPrompt": {
	            "shape": "S14"
	          },
	          "conclusionStatement": {
	            "shape": "Si"
	          },
	          "dialogCodeHook": {
	            "shape": "S15"
	          },
	          "fulfillmentActivity": {
	            "shape": "S18"
	          },
	          "parentIntentSignature": {},
	          "checksum": {},
	          "createVersion": {
	            "type": "boolean"
	          },
	          "kendraConfiguration": {
	            "shape": "S1b"
	          },
	          "inputContexts": {
	            "shape": "S1f"
	          },
	          "outputContexts": {
	            "shape": "S1i"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "slots": {
	            "shape": "Sq"
	          },
	          "sampleUtterances": {
	            "shape": "S13"
	          },
	          "confirmationPrompt": {
	            "shape": "Sa"
	          },
	          "rejectionStatement": {
	            "shape": "Si"
	          },
	          "followUpPrompt": {
	            "shape": "S14"
	          },
	          "conclusionStatement": {
	            "shape": "Si"
	          },
	          "dialogCodeHook": {
	            "shape": "S15"
	          },
	          "fulfillmentActivity": {
	            "shape": "S18"
	          },
	          "parentIntentSignature": {},
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "version": {},
	          "checksum": {},
	          "createVersion": {
	            "type": "boolean"
	          },
	          "kendraConfiguration": {
	            "shape": "S1b"
	          },
	          "inputContexts": {
	            "shape": "S1f"
	          },
	          "outputContexts": {
	            "shape": "S1i"
	          }
	        }
	      }
	    },
	    "PutSlotType": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/slottypes/{name}/versions/$LATEST",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {
	            "location": "uri",
	            "locationName": "name"
	          },
	          "description": {},
	          "enumerationValues": {
	            "shape": "S1q"
	          },
	          "checksum": {},
	          "valueSelectionStrategy": {},
	          "createVersion": {
	            "type": "boolean"
	          },
	          "parentSlotTypeSignature": {},
	          "slotTypeConfigurations": {
	            "shape": "S1v"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "enumerationValues": {
	            "shape": "S1q"
	          },
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "version": {},
	          "checksum": {},
	          "valueSelectionStrategy": {},
	          "createVersion": {
	            "type": "boolean"
	          },
	          "parentSlotTypeSignature": {},
	          "slotTypeConfigurations": {
	            "shape": "S1v"
	          }
	        }
	      }
	    },
	    "StartImport": {
	      "http": {
	        "requestUri": "/imports/",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "payload",
	          "resourceType",
	          "mergeStrategy"
	        ],
	        "members": {
	          "payload": {
	            "type": "blob"
	          },
	          "resourceType": {},
	          "mergeStrategy": {},
	          "tags": {
	            "shape": "S5e"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "resourceType": {},
	          "mergeStrategy": {},
	          "importId": {},
	          "importStatus": {},
	          "tags": {
	            "shape": "S5e"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "StartMigration": {
	      "http": {
	        "requestUri": "/migrations",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "v1BotName",
	          "v1BotVersion",
	          "v2BotName",
	          "v2BotRole",
	          "migrationStrategy"
	        ],
	        "members": {
	          "v1BotName": {},
	          "v1BotVersion": {},
	          "v2BotName": {},
	          "v2BotRole": {},
	          "migrationStrategy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "v1BotName": {},
	          "v1BotVersion": {},
	          "v1BotLocale": {},
	          "v2BotId": {},
	          "v2BotRole": {},
	          "migrationId": {},
	          "migrationStrategy": {},
	          "migrationTimestamp": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/tags/{resourceArn}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tags"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "uri",
	            "locationName": "resourceArn"
	          },
	          "tags": {
	            "shape": "S5e"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/tags/{resourceArn}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tagKeys"
	        ],
	        "members": {
	          "resourceArn": {
	            "location": "uri",
	            "locationName": "resourceArn"
	          },
	          "tagKeys": {
	            "location": "querystring",
	            "locationName": "tagKeys",
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "S6": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "intentName",
	          "intentVersion"
	        ],
	        "members": {
	          "intentName": {},
	          "intentVersion": {}
	        }
	      }
	    },
	    "Sa": {
	      "type": "structure",
	      "required": [
	        "messages",
	        "maxAttempts"
	      ],
	      "members": {
	        "messages": {
	          "shape": "Sb"
	        },
	        "maxAttempts": {
	          "type": "integer"
	        },
	        "responseCard": {}
	      }
	    },
	    "Sb": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "contentType",
	          "content"
	        ],
	        "members": {
	          "contentType": {},
	          "content": {},
	          "groupNumber": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "Si": {
	      "type": "structure",
	      "required": [
	        "messages"
	      ],
	      "members": {
	        "messages": {
	          "shape": "Sb"
	        },
	        "responseCard": {}
	      }
	    },
	    "Sq": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "name",
	          "slotConstraint"
	        ],
	        "members": {
	          "name": {},
	          "description": {},
	          "slotConstraint": {},
	          "slotType": {},
	          "slotTypeVersion": {},
	          "valueElicitationPrompt": {
	            "shape": "Sa"
	          },
	          "priority": {
	            "type": "integer"
	          },
	          "sampleUtterances": {
	            "type": "list",
	            "member": {}
	          },
	          "responseCard": {},
	          "obfuscationSetting": {},
	          "defaultValueSpec": {
	            "type": "structure",
	            "required": [
	              "defaultValueList"
	            ],
	            "members": {
	              "defaultValueList": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "defaultValue"
	                  ],
	                  "members": {
	                    "defaultValue": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {}
	    },
	    "S14": {
	      "type": "structure",
	      "required": [
	        "prompt",
	        "rejectionStatement"
	      ],
	      "members": {
	        "prompt": {
	          "shape": "Sa"
	        },
	        "rejectionStatement": {
	          "shape": "Si"
	        }
	      }
	    },
	    "S15": {
	      "type": "structure",
	      "required": [
	        "uri",
	        "messageVersion"
	      ],
	      "members": {
	        "uri": {},
	        "messageVersion": {}
	      }
	    },
	    "S18": {
	      "type": "structure",
	      "required": [
	        "type"
	      ],
	      "members": {
	        "type": {},
	        "codeHook": {
	          "shape": "S15"
	        }
	      }
	    },
	    "S1b": {
	      "type": "structure",
	      "required": [
	        "kendraIndex",
	        "role"
	      ],
	      "members": {
	        "kendraIndex": {},
	        "queryFilterString": {},
	        "role": {}
	      }
	    },
	    "S1f": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {}
	        }
	      }
	    },
	    "S1i": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "name",
	          "timeToLiveInSeconds",
	          "turnsToLive"
	        ],
	        "members": {
	          "name": {},
	          "timeToLiveInSeconds": {
	            "type": "integer"
	          },
	          "turnsToLive": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S1q": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "value"
	        ],
	        "members": {
	          "value": {},
	          "synonyms": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "S1v": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "regexConfiguration": {
	            "type": "structure",
	            "required": [
	              "pattern"
	            ],
	            "members": {
	              "pattern": {}
	            }
	          }
	        }
	      }
	    },
	    "S2h": {
	      "type": "structure",
	      "members": {
	        "logSettings": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "logType": {},
	              "destination": {},
	              "kmsKeyArn": {},
	              "resourceArn": {},
	              "resourcePrefix": {}
	            }
	          }
	        },
	        "iamRoleArn": {}
	      }
	    },
	    "S2z": {
	      "type": "map",
	      "key": {},
	      "value": {},
	      "sensitive": true
	    },
	    "S38": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "status": {},
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "version": {}
	        }
	      }
	    },
	    "S3e": {
	      "type": "list",
	      "member": {}
	    },
	    "S45": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "version": {}
	        }
	      }
	    },
	    "S4x": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "name": {},
	          "description": {},
	          "lastUpdatedDate": {
	            "type": "timestamp"
	          },
	          "createdDate": {
	            "type": "timestamp"
	          },
	          "version": {}
	        }
	      }
	    },
	    "S5e": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "key",
	          "value"
	        ],
	        "members": {
	          "key": {},
	          "value": {}
	        }
	      }
	    }
	  }
	}
	},{}],151:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "GetBotAliases": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "GetBotChannelAssociations": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "GetBotVersions": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "GetBots": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "GetBuiltinIntents": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "GetBuiltinSlotTypes": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "GetIntentVersions": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "GetIntents": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "GetMigrations": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "GetSlotTypeVersions": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    },
	    "GetSlotTypes": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "limit_key": "maxResults"
	    }
	  }
	}
	
	},{}],152:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2020-11-19",
	    "endpointPrefix": "geo",
	    "jsonVersion": "1.1",
	    "protocol": "rest-json",
	    "serviceFullName": "Amazon Location Service",
	    "serviceId": "Location",
	    "signatureVersion": "v4",
	    "signingName": "geo",
	    "uid": "location-2020-11-19"
	  },
	  "operations": {
	    "AssociateTrackerConsumer": {
	      "http": {
	        "requestUri": "/tracking/v0/trackers/{TrackerName}/consumers",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConsumerArn",
	          "TrackerName"
	        ],
	        "members": {
	          "ConsumerArn": {},
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      }
	    },
	    "BatchDeleteDevicePositionHistory": {
	      "http": {
	        "requestUri": "/tracking/v0/trackers/{TrackerName}/delete-positions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeviceIds",
	          "TrackerName"
	        ],
	        "members": {
	          "DeviceIds": {
	            "type": "list",
	            "member": {}
	          },
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Errors"
	        ],
	        "members": {
	          "Errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "DeviceId",
	                "Error"
	              ],
	              "members": {
	                "DeviceId": {},
	                "Error": {
	                  "shape": "Sb"
	                }
	              }
	            }
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      }
	    },
	    "BatchDeleteGeofence": {
	      "http": {
	        "requestUri": "/geofencing/v0/collections/{CollectionName}/delete-geofences",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionName",
	          "GeofenceIds"
	        ],
	        "members": {
	          "CollectionName": {
	            "location": "uri",
	            "locationName": "CollectionName"
	          },
	          "GeofenceIds": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Errors"
	        ],
	        "members": {
	          "Errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Error",
	                "GeofenceId"
	              ],
	              "members": {
	                "Error": {
	                  "shape": "Sb"
	                },
	                "GeofenceId": {}
	              }
	            }
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "geofencing."
	      }
	    },
	    "BatchEvaluateGeofences": {
	      "http": {
	        "requestUri": "/geofencing/v0/collections/{CollectionName}/positions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionName",
	          "DevicePositionUpdates"
	        ],
	        "members": {
	          "CollectionName": {
	            "location": "uri",
	            "locationName": "CollectionName"
	          },
	          "DevicePositionUpdates": {
	            "type": "list",
	            "member": {
	              "shape": "Sl"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Errors"
	        ],
	        "members": {
	          "Errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "DeviceId",
	                "Error",
	                "SampleTime"
	              ],
	              "members": {
	                "DeviceId": {},
	                "Error": {
	                  "shape": "Sb"
	                },
	                "SampleTime": {
	                  "shape": "St"
	                }
	              }
	            }
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "geofencing."
	      }
	    },
	    "BatchGetDevicePosition": {
	      "http": {
	        "requestUri": "/tracking/v0/trackers/{TrackerName}/get-positions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeviceIds",
	          "TrackerName"
	        ],
	        "members": {
	          "DeviceIds": {
	            "type": "list",
	            "member": {}
	          },
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "DevicePositions",
	          "Errors"
	        ],
	        "members": {
	          "DevicePositions": {
	            "shape": "S11"
	          },
	          "Errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "DeviceId",
	                "Error"
	              ],
	              "members": {
	                "DeviceId": {},
	                "Error": {
	                  "shape": "Sb"
	                }
	              }
	            }
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      }
	    },
	    "BatchPutGeofence": {
	      "http": {
	        "requestUri": "/geofencing/v0/collections/{CollectionName}/put-geofences",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionName",
	          "Entries"
	        ],
	        "members": {
	          "CollectionName": {
	            "location": "uri",
	            "locationName": "CollectionName"
	          },
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "GeofenceId",
	                "Geometry"
	              ],
	              "members": {
	                "GeofenceId": {},
	                "Geometry": {
	                  "shape": "S18"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Errors",
	          "Successes"
	        ],
	        "members": {
	          "Errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Error",
	                "GeofenceId"
	              ],
	              "members": {
	                "Error": {
	                  "shape": "Sb"
	                },
	                "GeofenceId": {}
	              }
	            }
	          },
	          "Successes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "CreateTime",
	                "GeofenceId",
	                "UpdateTime"
	              ],
	              "members": {
	                "CreateTime": {
	                  "shape": "St"
	                },
	                "GeofenceId": {},
	                "UpdateTime": {
	                  "shape": "St"
	                }
	              }
	            }
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "geofencing."
	      }
	    },
	    "BatchUpdateDevicePosition": {
	      "http": {
	        "requestUri": "/tracking/v0/trackers/{TrackerName}/positions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrackerName",
	          "Updates"
	        ],
	        "members": {
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          },
	          "Updates": {
	            "type": "list",
	            "member": {
	              "shape": "Sl"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Errors"
	        ],
	        "members": {
	          "Errors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "DeviceId",
	                "Error",
	                "SampleTime"
	              ],
	              "members": {
	                "DeviceId": {},
	                "Error": {
	                  "shape": "Sb"
	                },
	                "SampleTime": {
	                  "shape": "St"
	                }
	              }
	            }
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      }
	    },
	    "CalculateRoute": {
	      "http": {
	        "requestUri": "/routes/v0/calculators/{CalculatorName}/calculate/route",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CalculatorName",
	          "DeparturePosition",
	          "DestinationPosition"
	        ],
	        "members": {
	          "CalculatorName": {
	            "location": "uri",
	            "locationName": "CalculatorName"
	          },
	          "CarModeOptions": {
	            "shape": "S1m"
	          },
	          "DepartNow": {
	            "type": "boolean"
	          },
	          "DeparturePosition": {
	            "shape": "So"
	          },
	          "DepartureTime": {
	            "shape": "St"
	          },
	          "DestinationPosition": {
	            "shape": "So"
	          },
	          "DistanceUnit": {},
	          "IncludeLegGeometry": {
	            "type": "boolean"
	          },
	          "TravelMode": {},
	          "TruckModeOptions": {
	            "shape": "S1q"
	          },
	          "WaypointPositions": {
	            "type": "list",
	            "member": {
	              "shape": "So"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Legs",
	          "Summary"
	        ],
	        "members": {
	          "Legs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Distance",
	                "DurationSeconds",
	                "EndPosition",
	                "StartPosition",
	                "Steps"
	              ],
	              "members": {
	                "Distance": {
	                  "type": "double"
	                },
	                "DurationSeconds": {
	                  "type": "double"
	                },
	                "EndPosition": {
	                  "shape": "So"
	                },
	                "Geometry": {
	                  "type": "structure",
	                  "members": {
	                    "LineString": {
	                      "type": "list",
	                      "member": {
	                        "shape": "So"
	                      }
	                    }
	                  }
	                },
	                "StartPosition": {
	                  "shape": "So"
	                },
	                "Steps": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "required": [
	                      "Distance",
	                      "DurationSeconds",
	                      "EndPosition",
	                      "StartPosition"
	                    ],
	                    "members": {
	                      "Distance": {
	                        "type": "double"
	                      },
	                      "DurationSeconds": {
	                        "type": "double"
	                      },
	                      "EndPosition": {
	                        "shape": "So"
	                      },
	                      "GeometryOffset": {
	                        "type": "integer"
	                      },
	                      "StartPosition": {
	                        "shape": "So"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Summary": {
	            "type": "structure",
	            "required": [
	              "DataSource",
	              "Distance",
	              "DistanceUnit",
	              "DurationSeconds",
	              "RouteBBox"
	            ],
	            "members": {
	              "DataSource": {},
	              "Distance": {
	                "type": "double"
	              },
	              "DistanceUnit": {},
	              "DurationSeconds": {
	                "type": "double"
	              },
	              "RouteBBox": {
	                "shape": "S2f"
	              }
	            }
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "routes."
	      }
	    },
	    "CalculateRouteMatrix": {
	      "http": {
	        "requestUri": "/routes/v0/calculators/{CalculatorName}/calculate/route-matrix",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CalculatorName",
	          "DeparturePositions",
	          "DestinationPositions"
	        ],
	        "members": {
	          "CalculatorName": {
	            "location": "uri",
	            "locationName": "CalculatorName"
	          },
	          "CarModeOptions": {
	            "shape": "S1m"
	          },
	          "DepartNow": {
	            "type": "boolean"
	          },
	          "DeparturePositions": {
	            "type": "list",
	            "member": {
	              "shape": "So"
	            }
	          },
	          "DepartureTime": {
	            "shape": "St"
	          },
	          "DestinationPositions": {
	            "type": "list",
	            "member": {
	              "shape": "So"
	            }
	          },
	          "DistanceUnit": {},
	          "TravelMode": {},
	          "TruckModeOptions": {
	            "shape": "S1q"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "RouteMatrix",
	          "Summary"
	        ],
	        "members": {
	          "RouteMatrix": {
	            "type": "list",
	            "member": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "Distance": {
	                    "type": "double"
	                  },
	                  "DurationSeconds": {
	                    "type": "double"
	                  },
	                  "Error": {
	                    "type": "structure",
	                    "required": [
	                      "Code"
	                    ],
	                    "members": {
	                      "Code": {},
	                      "Message": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "SnappedDeparturePositions": {
	            "type": "list",
	            "member": {
	              "shape": "So"
	            }
	          },
	          "SnappedDestinationPositions": {
	            "type": "list",
	            "member": {
	              "shape": "So"
	            }
	          },
	          "Summary": {
	            "type": "structure",
	            "required": [
	              "DataSource",
	              "DistanceUnit",
	              "ErrorCount",
	              "RouteCount"
	            ],
	            "members": {
	              "DataSource": {},
	              "DistanceUnit": {},
	              "ErrorCount": {
	                "type": "integer"
	              },
	              "RouteCount": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "routes."
	      }
	    },
	    "CreateGeofenceCollection": {
	      "http": {
	        "requestUri": "/geofencing/v0/collections",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionName"
	        ],
	        "members": {
	          "CollectionName": {},
	          "Description": {},
	          "KmsKeyId": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. If included, the only allowed value is RequestBasedUsage."
	          },
	          "PricingPlanDataSource": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. No longer allowed."
	          },
	          "Tags": {
	            "shape": "S30"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CollectionArn",
	          "CollectionName",
	          "CreateTime"
	        ],
	        "members": {
	          "CollectionArn": {},
	          "CollectionName": {},
	          "CreateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "geofencing."
	      },
	      "idempotent": true
	    },
	    "CreateMap": {
	      "http": {
	        "requestUri": "/maps/v0/maps",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Configuration",
	          "MapName"
	        ],
	        "members": {
	          "Configuration": {
	            "shape": "S35"
	          },
	          "Description": {},
	          "MapName": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. If included, the only allowed value is RequestBasedUsage."
	          },
	          "Tags": {
	            "shape": "S30"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CreateTime",
	          "MapArn",
	          "MapName"
	        ],
	        "members": {
	          "CreateTime": {
	            "shape": "St"
	          },
	          "MapArn": {},
	          "MapName": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "maps."
	      },
	      "idempotent": true
	    },
	    "CreatePlaceIndex": {
	      "http": {
	        "requestUri": "/places/v0/indexes",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataSource",
	          "IndexName"
	        ],
	        "members": {
	          "DataSource": {},
	          "DataSourceConfiguration": {
	            "shape": "S39"
	          },
	          "Description": {},
	          "IndexName": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. If included, the only allowed value is RequestBasedUsage."
	          },
	          "Tags": {
	            "shape": "S30"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CreateTime",
	          "IndexArn",
	          "IndexName"
	        ],
	        "members": {
	          "CreateTime": {
	            "shape": "St"
	          },
	          "IndexArn": {},
	          "IndexName": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "places."
	      },
	      "idempotent": true
	    },
	    "CreateRouteCalculator": {
	      "http": {
	        "requestUri": "/routes/v0/calculators",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CalculatorName",
	          "DataSource"
	        ],
	        "members": {
	          "CalculatorName": {},
	          "DataSource": {},
	          "Description": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. If included, the only allowed value is RequestBasedUsage."
	          },
	          "Tags": {
	            "shape": "S30"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CalculatorArn",
	          "CalculatorName",
	          "CreateTime"
	        ],
	        "members": {
	          "CalculatorArn": {},
	          "CalculatorName": {},
	          "CreateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "routes."
	      },
	      "idempotent": true
	    },
	    "CreateTracker": {
	      "http": {
	        "requestUri": "/tracking/v0/trackers",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrackerName"
	        ],
	        "members": {
	          "Description": {},
	          "KmsKeyId": {},
	          "PositionFiltering": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. If included, the only allowed value is RequestBasedUsage."
	          },
	          "PricingPlanDataSource": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. No longer allowed."
	          },
	          "Tags": {
	            "shape": "S30"
	          },
	          "TrackerName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CreateTime",
	          "TrackerArn",
	          "TrackerName"
	        ],
	        "members": {
	          "CreateTime": {
	            "shape": "St"
	          },
	          "TrackerArn": {},
	          "TrackerName": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      },
	      "idempotent": true
	    },
	    "DeleteGeofenceCollection": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/geofencing/v0/collections/{CollectionName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionName"
	        ],
	        "members": {
	          "CollectionName": {
	            "location": "uri",
	            "locationName": "CollectionName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "endpoint": {
	        "hostPrefix": "geofencing."
	      },
	      "idempotent": true
	    },
	    "DeleteMap": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/maps/v0/maps/{MapName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "MapName"
	        ],
	        "members": {
	          "MapName": {
	            "location": "uri",
	            "locationName": "MapName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "endpoint": {
	        "hostPrefix": "maps."
	      },
	      "idempotent": true
	    },
	    "DeletePlaceIndex": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/places/v0/indexes/{IndexName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IndexName"
	        ],
	        "members": {
	          "IndexName": {
	            "location": "uri",
	            "locationName": "IndexName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "endpoint": {
	        "hostPrefix": "places."
	      },
	      "idempotent": true
	    },
	    "DeleteRouteCalculator": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/routes/v0/calculators/{CalculatorName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CalculatorName"
	        ],
	        "members": {
	          "CalculatorName": {
	            "location": "uri",
	            "locationName": "CalculatorName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "endpoint": {
	        "hostPrefix": "routes."
	      },
	      "idempotent": true
	    },
	    "DeleteTracker": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/tracking/v0/trackers/{TrackerName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrackerName"
	        ],
	        "members": {
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      },
	      "idempotent": true
	    },
	    "DescribeGeofenceCollection": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/geofencing/v0/collections/{CollectionName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionName"
	        ],
	        "members": {
	          "CollectionName": {
	            "location": "uri",
	            "locationName": "CollectionName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CollectionArn",
	          "CollectionName",
	          "CreateTime",
	          "Description",
	          "UpdateTime"
	        ],
	        "members": {
	          "CollectionArn": {},
	          "CollectionName": {},
	          "CreateTime": {
	            "shape": "St"
	          },
	          "Description": {},
	          "KmsKeyId": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. Always returns RequestBasedUsage."
	          },
	          "PricingPlanDataSource": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. Unused."
	          },
	          "Tags": {
	            "shape": "S30"
	          },
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "geofencing."
	      }
	    },
	    "DescribeMap": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/maps/v0/maps/{MapName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "MapName"
	        ],
	        "members": {
	          "MapName": {
	            "location": "uri",
	            "locationName": "MapName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Configuration",
	          "CreateTime",
	          "DataSource",
	          "Description",
	          "MapArn",
	          "MapName",
	          "UpdateTime"
	        ],
	        "members": {
	          "Configuration": {
	            "shape": "S35"
	          },
	          "CreateTime": {
	            "shape": "St"
	          },
	          "DataSource": {},
	          "Description": {},
	          "MapArn": {},
	          "MapName": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. Always returns RequestBasedUsage."
	          },
	          "Tags": {
	            "shape": "S30"
	          },
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "maps."
	      }
	    },
	    "DescribePlaceIndex": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/places/v0/indexes/{IndexName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IndexName"
	        ],
	        "members": {
	          "IndexName": {
	            "location": "uri",
	            "locationName": "IndexName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CreateTime",
	          "DataSource",
	          "DataSourceConfiguration",
	          "Description",
	          "IndexArn",
	          "IndexName",
	          "UpdateTime"
	        ],
	        "members": {
	          "CreateTime": {
	            "shape": "St"
	          },
	          "DataSource": {},
	          "DataSourceConfiguration": {
	            "shape": "S39"
	          },
	          "Description": {},
	          "IndexArn": {},
	          "IndexName": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. Always returns RequestBasedUsage."
	          },
	          "Tags": {
	            "shape": "S30"
	          },
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "places."
	      }
	    },
	    "DescribeRouteCalculator": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/routes/v0/calculators/{CalculatorName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CalculatorName"
	        ],
	        "members": {
	          "CalculatorName": {
	            "location": "uri",
	            "locationName": "CalculatorName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CalculatorArn",
	          "CalculatorName",
	          "CreateTime",
	          "DataSource",
	          "Description",
	          "UpdateTime"
	        ],
	        "members": {
	          "CalculatorArn": {},
	          "CalculatorName": {},
	          "CreateTime": {
	            "shape": "St"
	          },
	          "DataSource": {},
	          "Description": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. Always returns RequestBasedUsage."
	          },
	          "Tags": {
	            "shape": "S30"
	          },
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "routes."
	      }
	    },
	    "DescribeTracker": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/tracking/v0/trackers/{TrackerName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrackerName"
	        ],
	        "members": {
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CreateTime",
	          "Description",
	          "TrackerArn",
	          "TrackerName",
	          "UpdateTime"
	        ],
	        "members": {
	          "CreateTime": {
	            "shape": "St"
	          },
	          "Description": {},
	          "KmsKeyId": {},
	          "PositionFiltering": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. Always returns RequestBasedUsage."
	          },
	          "PricingPlanDataSource": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. Unused."
	          },
	          "Tags": {
	            "shape": "S30"
	          },
	          "TrackerArn": {},
	          "TrackerName": {},
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      }
	    },
	    "DisassociateTrackerConsumer": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/tracking/v0/trackers/{TrackerName}/consumers/{ConsumerArn}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ConsumerArn",
	          "TrackerName"
	        ],
	        "members": {
	          "ConsumerArn": {
	            "location": "uri",
	            "locationName": "ConsumerArn"
	          },
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      }
	    },
	    "GetDevicePosition": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/positions/latest",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeviceId",
	          "TrackerName"
	        ],
	        "members": {
	          "DeviceId": {
	            "location": "uri",
	            "locationName": "DeviceId"
	          },
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Position",
	          "ReceivedTime",
	          "SampleTime"
	        ],
	        "members": {
	          "Accuracy": {
	            "shape": "Sm"
	          },
	          "DeviceId": {},
	          "Position": {
	            "shape": "So"
	          },
	          "PositionProperties": {
	            "shape": "Sq"
	          },
	          "ReceivedTime": {
	            "shape": "St"
	          },
	          "SampleTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      }
	    },
	    "GetDevicePositionHistory": {
	      "http": {
	        "requestUri": "/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/list-positions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DeviceId",
	          "TrackerName"
	        ],
	        "members": {
	          "DeviceId": {
	            "location": "uri",
	            "locationName": "DeviceId"
	          },
	          "EndTimeExclusive": {
	            "shape": "St"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "StartTimeInclusive": {
	            "shape": "St"
	          },
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "DevicePositions"
	        ],
	        "members": {
	          "DevicePositions": {
	            "shape": "S11"
	          },
	          "NextToken": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      }
	    },
	    "GetGeofence": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionName",
	          "GeofenceId"
	        ],
	        "members": {
	          "CollectionName": {
	            "location": "uri",
	            "locationName": "CollectionName"
	          },
	          "GeofenceId": {
	            "location": "uri",
	            "locationName": "GeofenceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CreateTime",
	          "GeofenceId",
	          "Geometry",
	          "Status",
	          "UpdateTime"
	        ],
	        "members": {
	          "CreateTime": {
	            "shape": "St"
	          },
	          "GeofenceId": {},
	          "Geometry": {
	            "shape": "S18"
	          },
	          "Status": {},
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "geofencing."
	      }
	    },
	    "GetMapGlyphs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/maps/v0/maps/{MapName}/glyphs/{FontStack}/{FontUnicodeRange}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FontStack",
	          "FontUnicodeRange",
	          "MapName"
	        ],
	        "members": {
	          "FontStack": {
	            "location": "uri",
	            "locationName": "FontStack"
	          },
	          "FontUnicodeRange": {
	            "location": "uri",
	            "locationName": "FontUnicodeRange"
	          },
	          "MapName": {
	            "location": "uri",
	            "locationName": "MapName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Blob": {
	            "type": "blob"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          }
	        },
	        "payload": "Blob"
	      },
	      "endpoint": {
	        "hostPrefix": "maps."
	      }
	    },
	    "GetMapSprites": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/maps/v0/maps/{MapName}/sprites/{FileName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileName",
	          "MapName"
	        ],
	        "members": {
	          "FileName": {
	            "location": "uri",
	            "locationName": "FileName"
	          },
	          "MapName": {
	            "location": "uri",
	            "locationName": "MapName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Blob": {
	            "type": "blob"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          }
	        },
	        "payload": "Blob"
	      },
	      "endpoint": {
	        "hostPrefix": "maps."
	      }
	    },
	    "GetMapStyleDescriptor": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/maps/v0/maps/{MapName}/style-descriptor",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "MapName"
	        ],
	        "members": {
	          "MapName": {
	            "location": "uri",
	            "locationName": "MapName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Blob": {
	            "type": "blob"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          }
	        },
	        "payload": "Blob"
	      },
	      "endpoint": {
	        "hostPrefix": "maps."
	      }
	    },
	    "GetMapTile": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/maps/v0/maps/{MapName}/tiles/{Z}/{X}/{Y}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "MapName",
	          "X",
	          "Y",
	          "Z"
	        ],
	        "members": {
	          "MapName": {
	            "location": "uri",
	            "locationName": "MapName"
	          },
	          "X": {
	            "location": "uri",
	            "locationName": "X"
	          },
	          "Y": {
	            "location": "uri",
	            "locationName": "Y"
	          },
	          "Z": {
	            "location": "uri",
	            "locationName": "Z"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Blob": {
	            "type": "blob"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          }
	        },
	        "payload": "Blob"
	      },
	      "endpoint": {
	        "hostPrefix": "maps."
	      }
	    },
	    "ListDevicePositions": {
	      "http": {
	        "requestUri": "/tracking/v0/trackers/{TrackerName}/list-positions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrackerName"
	        ],
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entries"
	        ],
	        "members": {
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "DeviceId",
	                "Position",
	                "SampleTime"
	              ],
	              "members": {
	                "Accuracy": {
	                  "shape": "Sm"
	                },
	                "DeviceId": {},
	                "Position": {
	                  "shape": "So"
	                },
	                "PositionProperties": {
	                  "shape": "Sq"
	                },
	                "SampleTime": {
	                  "shape": "St"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      }
	    },
	    "ListGeofenceCollections": {
	      "http": {
	        "requestUri": "/geofencing/v0/list-collections",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entries"
	        ],
	        "members": {
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "CollectionName",
	                "CreateTime",
	                "Description",
	                "UpdateTime"
	              ],
	              "members": {
	                "CollectionName": {},
	                "CreateTime": {
	                  "shape": "St"
	                },
	                "Description": {},
	                "PricingPlan": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Deprecated. Always returns RequestBasedUsage."
	                },
	                "PricingPlanDataSource": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Deprecated. Unused."
	                },
	                "UpdateTime": {
	                  "shape": "St"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "geofencing."
	      }
	    },
	    "ListGeofences": {
	      "http": {
	        "requestUri": "/geofencing/v0/collections/{CollectionName}/list-geofences",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionName"
	        ],
	        "members": {
	          "CollectionName": {
	            "location": "uri",
	            "locationName": "CollectionName"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entries"
	        ],
	        "members": {
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "CreateTime",
	                "GeofenceId",
	                "Geometry",
	                "Status",
	                "UpdateTime"
	              ],
	              "members": {
	                "CreateTime": {
	                  "shape": "St"
	                },
	                "GeofenceId": {},
	                "Geometry": {
	                  "shape": "S18"
	                },
	                "Status": {},
	                "UpdateTime": {
	                  "shape": "St"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "geofencing."
	      }
	    },
	    "ListMaps": {
	      "http": {
	        "requestUri": "/maps/v0/list-maps",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entries"
	        ],
	        "members": {
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "CreateTime",
	                "DataSource",
	                "Description",
	                "MapName",
	                "UpdateTime"
	              ],
	              "members": {
	                "CreateTime": {
	                  "shape": "St"
	                },
	                "DataSource": {},
	                "Description": {},
	                "MapName": {},
	                "PricingPlan": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Deprecated. Always returns RequestBasedUsage."
	                },
	                "UpdateTime": {
	                  "shape": "St"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "maps."
	      }
	    },
	    "ListPlaceIndexes": {
	      "http": {
	        "requestUri": "/places/v0/list-indexes",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entries"
	        ],
	        "members": {
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "CreateTime",
	                "DataSource",
	                "Description",
	                "IndexName",
	                "UpdateTime"
	              ],
	              "members": {
	                "CreateTime": {
	                  "shape": "St"
	                },
	                "DataSource": {},
	                "Description": {},
	                "IndexName": {},
	                "PricingPlan": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Deprecated. Always returns RequestBasedUsage."
	                },
	                "UpdateTime": {
	                  "shape": "St"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "places."
	      }
	    },
	    "ListRouteCalculators": {
	      "http": {
	        "requestUri": "/routes/v0/list-calculators",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entries"
	        ],
	        "members": {
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "CalculatorName",
	                "CreateTime",
	                "DataSource",
	                "Description",
	                "UpdateTime"
	              ],
	              "members": {
	                "CalculatorName": {},
	                "CreateTime": {
	                  "shape": "St"
	                },
	                "DataSource": {},
	                "Description": {},
	                "PricingPlan": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Deprecated. Always returns RequestBasedUsage."
	                },
	                "UpdateTime": {
	                  "shape": "St"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "routes."
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/tags/{ResourceArn}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {
	            "location": "uri",
	            "locationName": "ResourceArn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S30"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "metadata."
	      }
	    },
	    "ListTrackerConsumers": {
	      "http": {
	        "requestUri": "/tracking/v0/trackers/{TrackerName}/list-consumers",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrackerName"
	        ],
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ConsumerArns"
	        ],
	        "members": {
	          "ConsumerArns": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      }
	    },
	    "ListTrackers": {
	      "http": {
	        "requestUri": "/tracking/v0/list-trackers",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Entries"
	        ],
	        "members": {
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "CreateTime",
	                "Description",
	                "TrackerName",
	                "UpdateTime"
	              ],
	              "members": {
	                "CreateTime": {
	                  "shape": "St"
	                },
	                "Description": {},
	                "PricingPlan": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Deprecated. Always returns RequestBasedUsage."
	                },
	                "PricingPlanDataSource": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Deprecated. Unused."
	                },
	                "TrackerName": {},
	                "UpdateTime": {
	                  "shape": "St"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      }
	    },
	    "PutGeofence": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionName",
	          "GeofenceId",
	          "Geometry"
	        ],
	        "members": {
	          "CollectionName": {
	            "location": "uri",
	            "locationName": "CollectionName"
	          },
	          "GeofenceId": {
	            "location": "uri",
	            "locationName": "GeofenceId"
	          },
	          "Geometry": {
	            "shape": "S18"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CreateTime",
	          "GeofenceId",
	          "UpdateTime"
	        ],
	        "members": {
	          "CreateTime": {
	            "shape": "St"
	          },
	          "GeofenceId": {},
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "geofencing."
	      }
	    },
	    "SearchPlaceIndexForPosition": {
	      "http": {
	        "requestUri": "/places/v0/indexes/{IndexName}/search/position",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IndexName",
	          "Position"
	        ],
	        "members": {
	          "IndexName": {
	            "location": "uri",
	            "locationName": "IndexName"
	          },
	          "Language": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Position": {
	            "shape": "So"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Results",
	          "Summary"
	        ],
	        "members": {
	          "Results": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Distance",
	                "Place"
	              ],
	              "members": {
	                "Distance": {
	                  "type": "double"
	                },
	                "Place": {
	                  "shape": "S63"
	                }
	              }
	            }
	          },
	          "Summary": {
	            "type": "structure",
	            "required": [
	              "DataSource",
	              "Position"
	            ],
	            "members": {
	              "DataSource": {},
	              "Language": {},
	              "MaxResults": {
	                "type": "integer"
	              },
	              "Position": {
	                "shape": "So"
	              }
	            }
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "places."
	      }
	    },
	    "SearchPlaceIndexForSuggestions": {
	      "http": {
	        "requestUri": "/places/v0/indexes/{IndexName}/search/suggestions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IndexName",
	          "Text"
	        ],
	        "members": {
	          "BiasPosition": {
	            "shape": "So"
	          },
	          "FilterBBox": {
	            "shape": "S2f"
	          },
	          "FilterCountries": {
	            "shape": "S69"
	          },
	          "IndexName": {
	            "location": "uri",
	            "locationName": "IndexName"
	          },
	          "Language": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Text": {
	            "type": "string",
	            "sensitive": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Results",
	          "Summary"
	        ],
	        "members": {
	          "Results": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Text"
	              ],
	              "members": {
	                "Text": {}
	              }
	            }
	          },
	          "Summary": {
	            "type": "structure",
	            "required": [
	              "DataSource",
	              "Text"
	            ],
	            "members": {
	              "BiasPosition": {
	                "shape": "So"
	              },
	              "DataSource": {},
	              "FilterBBox": {
	                "shape": "S2f"
	              },
	              "FilterCountries": {
	                "shape": "S69"
	              },
	              "Language": {},
	              "MaxResults": {
	                "type": "integer"
	              },
	              "Text": {
	                "shape": "S6h"
	              }
	            }
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "places."
	      }
	    },
	    "SearchPlaceIndexForText": {
	      "http": {
	        "requestUri": "/places/v0/indexes/{IndexName}/search/text",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IndexName",
	          "Text"
	        ],
	        "members": {
	          "BiasPosition": {
	            "shape": "So"
	          },
	          "FilterBBox": {
	            "shape": "S2f"
	          },
	          "FilterCountries": {
	            "shape": "S69"
	          },
	          "IndexName": {
	            "location": "uri",
	            "locationName": "IndexName"
	          },
	          "Language": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Text": {
	            "type": "string",
	            "sensitive": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Results",
	          "Summary"
	        ],
	        "members": {
	          "Results": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Place"
	              ],
	              "members": {
	                "Distance": {
	                  "type": "double"
	                },
	                "Place": {
	                  "shape": "S63"
	                },
	                "Relevance": {
	                  "type": "double"
	                }
	              }
	            }
	          },
	          "Summary": {
	            "type": "structure",
	            "required": [
	              "DataSource",
	              "Text"
	            ],
	            "members": {
	              "BiasPosition": {
	                "shape": "So"
	              },
	              "DataSource": {},
	              "FilterBBox": {
	                "shape": "S2f"
	              },
	              "FilterCountries": {
	                "shape": "S69"
	              },
	              "Language": {},
	              "MaxResults": {
	                "type": "integer"
	              },
	              "ResultBBox": {
	                "shape": "S2f"
	              },
	              "Text": {
	                "shape": "S6h"
	              }
	            }
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "places."
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/tags/{ResourceArn}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArn": {
	            "location": "uri",
	            "locationName": "ResourceArn"
	          },
	          "Tags": {
	            "shape": "S30"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "endpoint": {
	        "hostPrefix": "metadata."
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/tags/{ResourceArn}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArn": {
	            "location": "uri",
	            "locationName": "ResourceArn"
	          },
	          "TagKeys": {
	            "location": "querystring",
	            "locationName": "tagKeys",
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "endpoint": {
	        "hostPrefix": "metadata."
	      },
	      "idempotent": true
	    },
	    "UpdateGeofenceCollection": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/geofencing/v0/collections/{CollectionName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionName"
	        ],
	        "members": {
	          "CollectionName": {
	            "location": "uri",
	            "locationName": "CollectionName"
	          },
	          "Description": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. If included, the only allowed value is RequestBasedUsage."
	          },
	          "PricingPlanDataSource": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. No longer allowed."
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CollectionArn",
	          "CollectionName",
	          "UpdateTime"
	        ],
	        "members": {
	          "CollectionArn": {},
	          "CollectionName": {},
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "geofencing."
	      },
	      "idempotent": true
	    },
	    "UpdateMap": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/maps/v0/maps/{MapName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "MapName"
	        ],
	        "members": {
	          "Description": {},
	          "MapName": {
	            "location": "uri",
	            "locationName": "MapName"
	          },
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. If included, the only allowed value is RequestBasedUsage."
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "MapArn",
	          "MapName",
	          "UpdateTime"
	        ],
	        "members": {
	          "MapArn": {},
	          "MapName": {},
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "maps."
	      },
	      "idempotent": true
	    },
	    "UpdatePlaceIndex": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/places/v0/indexes/{IndexName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "IndexName"
	        ],
	        "members": {
	          "DataSourceConfiguration": {
	            "shape": "S39"
	          },
	          "Description": {},
	          "IndexName": {
	            "location": "uri",
	            "locationName": "IndexName"
	          },
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. If included, the only allowed value is RequestBasedUsage."
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "IndexArn",
	          "IndexName",
	          "UpdateTime"
	        ],
	        "members": {
	          "IndexArn": {},
	          "IndexName": {},
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "places."
	      },
	      "idempotent": true
	    },
	    "UpdateRouteCalculator": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/routes/v0/calculators/{CalculatorName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CalculatorName"
	        ],
	        "members": {
	          "CalculatorName": {
	            "location": "uri",
	            "locationName": "CalculatorName"
	          },
	          "Description": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. If included, the only allowed value is RequestBasedUsage."
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CalculatorArn",
	          "CalculatorName",
	          "UpdateTime"
	        ],
	        "members": {
	          "CalculatorArn": {},
	          "CalculatorName": {},
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "routes."
	      },
	      "idempotent": true
	    },
	    "UpdateTracker": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/tracking/v0/trackers/{TrackerName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrackerName"
	        ],
	        "members": {
	          "Description": {},
	          "PositionFiltering": {},
	          "PricingPlan": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. If included, the only allowed value is RequestBasedUsage."
	          },
	          "PricingPlanDataSource": {
	            "deprecated": true,
	            "deprecatedMessage": "Deprecated. No longer allowed."
	          },
	          "TrackerName": {
	            "location": "uri",
	            "locationName": "TrackerName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrackerArn",
	          "TrackerName",
	          "UpdateTime"
	        ],
	        "members": {
	          "TrackerArn": {},
	          "TrackerName": {},
	          "UpdateTime": {
	            "shape": "St"
	          }
	        }
	      },
	      "endpoint": {
	        "hostPrefix": "tracking."
	      },
	      "idempotent": true
	    }
	  },
	  "shapes": {
	    "Sb": {
	      "type": "structure",
	      "members": {
	        "Code": {},
	        "Message": {}
	      }
	    },
	    "Sl": {
	      "type": "structure",
	      "required": [
	        "DeviceId",
	        "Position",
	        "SampleTime"
	      ],
	      "members": {
	        "Accuracy": {
	          "shape": "Sm"
	        },
	        "DeviceId": {},
	        "Position": {
	          "shape": "So"
	        },
	        "PositionProperties": {
	          "shape": "Sq"
	        },
	        "SampleTime": {
	          "shape": "St"
	        }
	      }
	    },
	    "Sm": {
	      "type": "structure",
	      "required": [
	        "Horizontal"
	      ],
	      "members": {
	        "Horizontal": {
	          "type": "double"
	        }
	      }
	    },
	    "So": {
	      "type": "list",
	      "member": {
	        "type": "double"
	      },
	      "sensitive": true
	    },
	    "Sq": {
	      "type": "map",
	      "key": {},
	      "value": {},
	      "sensitive": true
	    },
	    "St": {
	      "type": "timestamp",
	      "timestampFormat": "iso8601"
	    },
	    "S11": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Position",
	          "ReceivedTime",
	          "SampleTime"
	        ],
	        "members": {
	          "Accuracy": {
	            "shape": "Sm"
	          },
	          "DeviceId": {},
	          "Position": {
	            "shape": "So"
	          },
	          "PositionProperties": {
	            "shape": "Sq"
	          },
	          "ReceivedTime": {
	            "shape": "St"
	          },
	          "SampleTime": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "S18": {
	      "type": "structure",
	      "members": {
	        "Polygon": {
	          "type": "list",
	          "member": {
	            "type": "list",
	            "member": {
	              "shape": "So"
	            }
	          }
	        }
	      }
	    },
	    "S1m": {
	      "type": "structure",
	      "members": {
	        "AvoidFerries": {
	          "type": "boolean"
	        },
	        "AvoidTolls": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1q": {
	      "type": "structure",
	      "members": {
	        "AvoidFerries": {
	          "type": "boolean"
	        },
	        "AvoidTolls": {
	          "type": "boolean"
	        },
	        "Dimensions": {
	          "type": "structure",
	          "members": {
	            "Height": {
	              "type": "double"
	            },
	            "Length": {
	              "type": "double"
	            },
	            "Unit": {},
	            "Width": {
	              "type": "double"
	            }
	          }
	        },
	        "Weight": {
	          "type": "structure",
	          "members": {
	            "Total": {
	              "type": "double"
	            },
	            "Unit": {}
	          }
	        }
	      }
	    },
	    "S2f": {
	      "type": "list",
	      "member": {
	        "type": "double"
	      },
	      "sensitive": true
	    },
	    "S30": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S35": {
	      "type": "structure",
	      "required": [
	        "Style"
	      ],
	      "members": {
	        "Style": {}
	      }
	    },
	    "S39": {
	      "type": "structure",
	      "members": {
	        "IntendedUse": {}
	      }
	    },
	    "S63": {
	      "type": "structure",
	      "required": [
	        "Geometry"
	      ],
	      "members": {
	        "AddressNumber": {},
	        "Country": {},
	        "Geometry": {
	          "type": "structure",
	          "members": {
	            "Point": {
	              "shape": "So"
	            }
	          }
	        },
	        "Interpolated": {
	          "type": "boolean"
	        },
	        "Label": {},
	        "Municipality": {},
	        "Neighborhood": {},
	        "PostalCode": {},
	        "Region": {},
	        "Street": {},
	        "SubRegion": {},
	        "TimeZone": {
	          "type": "structure",
	          "required": [
	            "Name"
	          ],
	          "members": {
	            "Name": {},
	            "Offset": {
	              "type": "integer"
	            }
	          }
	        }
	      }
	    },
	    "S69": {
	      "type": "list",
	      "member": {}
	    },
	    "S6h": {
	      "type": "string",
	      "sensitive": true
	    }
	  }
	}
	},{}],153:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "GetDevicePositionHistory": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults",
	      "result_key": "DevicePositions"
	    },
	    "ListDevicePositions": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults",
	      "result_key": "Entries"
	    },
	    "ListGeofenceCollections": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults",
	      "result_key": "Entries"
	    },
	    "ListGeofences": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults",
	      "result_key": "Entries"
	    },
	    "ListMaps": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults",
	      "result_key": "Entries"
	    },
	    "ListPlaceIndexes": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults",
	      "result_key": "Entries"
	    },
	    "ListRouteCalculators": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults",
	      "result_key": "Entries"
	    },
	    "ListTrackerConsumers": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults",
	      "result_key": "ConsumerArns"
	    },
	    "ListTrackers": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults",
	      "result_key": "Entries"
	    }
	  }
	}
	
	},{}],154:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-03-28",
	    "endpointPrefix": "logs",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon CloudWatch Logs",
	    "serviceId": "CloudWatch Logs",
	    "signatureVersion": "v4",
	    "targetPrefix": "Logs_20140328",
	    "uid": "logs-2014-03-28"
	  },
	  "operations": {
	    "AssociateKmsKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "kmsKeyId"
	        ],
	        "members": {
	          "logGroupName": {},
	          "kmsKeyId": {}
	        }
	      }
	    },
	    "CancelExportTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "taskId"
	        ],
	        "members": {
	          "taskId": {}
	        }
	      }
	    },
	    "CreateExportTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "from",
	          "to",
	          "destination"
	        ],
	        "members": {
	          "taskName": {},
	          "logGroupName": {},
	          "logStreamNamePrefix": {},
	          "from": {
	            "type": "long"
	          },
	          "to": {
	            "type": "long"
	          },
	          "destination": {},
	          "destinationPrefix": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "taskId": {}
	        }
	      }
	    },
	    "CreateLogGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName"
	        ],
	        "members": {
	          "logGroupName": {},
	          "kmsKeyId": {},
	          "tags": {
	            "shape": "Se"
	          }
	        }
	      }
	    },
	    "CreateLogStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "logStreamName"
	        ],
	        "members": {
	          "logGroupName": {},
	          "logStreamName": {}
	        }
	      }
	    },
	    "DeleteDestination": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "destinationName"
	        ],
	        "members": {
	          "destinationName": {}
	        }
	      }
	    },
	    "DeleteLogGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName"
	        ],
	        "members": {
	          "logGroupName": {}
	        }
	      }
	    },
	    "DeleteLogStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "logStreamName"
	        ],
	        "members": {
	          "logGroupName": {},
	          "logStreamName": {}
	        }
	      }
	    },
	    "DeleteMetricFilter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "filterName"
	        ],
	        "members": {
	          "logGroupName": {},
	          "filterName": {}
	        }
	      }
	    },
	    "DeleteQueryDefinition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "queryDefinitionId"
	        ],
	        "members": {
	          "queryDefinitionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "success": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "policyName": {}
	        }
	      }
	    },
	    "DeleteRetentionPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName"
	        ],
	        "members": {
	          "logGroupName": {}
	        }
	      }
	    },
	    "DeleteSubscriptionFilter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "filterName"
	        ],
	        "members": {
	          "logGroupName": {},
	          "filterName": {}
	        }
	      }
	    },
	    "DescribeDestinations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DestinationNamePrefix": {},
	          "nextToken": {},
	          "limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "destinations": {
	            "type": "list",
	            "member": {
	              "shape": "S11"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeExportTasks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "taskId": {},
	          "statusCode": {},
	          "nextToken": {},
	          "limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "exportTasks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "taskId": {},
	                "taskName": {},
	                "logGroupName": {},
	                "from": {
	                  "type": "long"
	                },
	                "to": {
	                  "type": "long"
	                },
	                "destination": {},
	                "destinationPrefix": {},
	                "status": {
	                  "type": "structure",
	                  "members": {
	                    "code": {},
	                    "message": {}
	                  }
	                },
	                "executionInfo": {
	                  "type": "structure",
	                  "members": {
	                    "creationTime": {
	                      "type": "long"
	                    },
	                    "completionTime": {
	                      "type": "long"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeLogGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "logGroupNamePrefix": {},
	          "nextToken": {},
	          "limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "logGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "logGroupName": {},
	                "creationTime": {
	                  "type": "long"
	                },
	                "retentionInDays": {
	                  "type": "integer"
	                },
	                "metricFilterCount": {
	                  "type": "integer"
	                },
	                "arn": {},
	                "storedBytes": {
	                  "type": "long"
	                },
	                "kmsKeyId": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeLogStreams": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName"
	        ],
	        "members": {
	          "logGroupName": {},
	          "logStreamNamePrefix": {},
	          "orderBy": {},
	          "descending": {
	            "type": "boolean"
	          },
	          "nextToken": {},
	          "limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "logStreams": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "logStreamName": {},
	                "creationTime": {
	                  "type": "long"
	                },
	                "firstEventTimestamp": {
	                  "type": "long"
	                },
	                "lastEventTimestamp": {
	                  "type": "long"
	                },
	                "lastIngestionTime": {
	                  "type": "long"
	                },
	                "uploadSequenceToken": {},
	                "arn": {},
	                "storedBytes": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Starting on June 17, 2019, this parameter will be deprecated for log streams, and will be reported as zero. This change applies only to log streams. The storedBytes parameter for log groups is not affected.",
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeMetricFilters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "logGroupName": {},
	          "filterNamePrefix": {},
	          "nextToken": {},
	          "limit": {
	            "type": "integer"
	          },
	          "metricName": {},
	          "metricNamespace": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "metricFilters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "filterName": {},
	                "filterPattern": {},
	                "metricTransformations": {
	                  "shape": "S1z"
	                },
	                "creationTime": {
	                  "type": "long"
	                },
	                "logGroupName": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeQueries": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "logGroupName": {},
	          "status": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "queries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "queryId": {},
	                "queryString": {},
	                "status": {},
	                "createTime": {
	                  "type": "long"
	                },
	                "logGroupName": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeQueryDefinitions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "queryDefinitionNamePrefix": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "queryDefinitions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "queryDefinitionId": {},
	                "name": {},
	                "queryString": {},
	                "lastModified": {
	                  "type": "long"
	                },
	                "logGroupNames": {
	                  "shape": "S2l"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeResourcePolicies": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "resourcePolicies": {
	            "type": "list",
	            "member": {
	              "shape": "S2p"
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DescribeSubscriptionFilters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName"
	        ],
	        "members": {
	          "logGroupName": {},
	          "filterNamePrefix": {},
	          "nextToken": {},
	          "limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "subscriptionFilters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "filterName": {},
	                "logGroupName": {},
	                "filterPattern": {},
	                "destinationArn": {},
	                "roleArn": {},
	                "distribution": {},
	                "creationTime": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "DisassociateKmsKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName"
	        ],
	        "members": {
	          "logGroupName": {}
	        }
	      }
	    },
	    "FilterLogEvents": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName"
	        ],
	        "members": {
	          "logGroupName": {},
	          "logStreamNames": {
	            "type": "list",
	            "member": {}
	          },
	          "logStreamNamePrefix": {},
	          "startTime": {
	            "type": "long"
	          },
	          "endTime": {
	            "type": "long"
	          },
	          "filterPattern": {},
	          "nextToken": {},
	          "limit": {
	            "type": "integer"
	          },
	          "interleaved": {
	            "deprecated": true,
	            "deprecatedMessage": "Starting on June 17, 2019, this parameter will be ignored and the value will be assumed to be true. The response from this operation will always interleave events from multiple log streams within a log group.",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "events": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "logStreamName": {},
	                "timestamp": {
	                  "type": "long"
	                },
	                "message": {},
	                "ingestionTime": {
	                  "type": "long"
	                },
	                "eventId": {}
	              }
	            }
	          },
	          "searchedLogStreams": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "logStreamName": {},
	                "searchedCompletely": {
	                  "type": "boolean"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "GetLogEvents": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "logStreamName"
	        ],
	        "members": {
	          "logGroupName": {},
	          "logStreamName": {},
	          "startTime": {
	            "type": "long"
	          },
	          "endTime": {
	            "type": "long"
	          },
	          "nextToken": {},
	          "limit": {
	            "type": "integer"
	          },
	          "startFromHead": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "events": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "timestamp": {
	                  "type": "long"
	                },
	                "message": {},
	                "ingestionTime": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "nextForwardToken": {},
	          "nextBackwardToken": {}
	        }
	      }
	    },
	    "GetLogGroupFields": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName"
	        ],
	        "members": {
	          "logGroupName": {},
	          "time": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "logGroupFields": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "percent": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetLogRecord": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logRecordPointer"
	        ],
	        "members": {
	          "logRecordPointer": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "logRecord": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          }
	        }
	      }
	    },
	    "GetQueryResults": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "queryId"
	        ],
	        "members": {
	          "queryId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "results": {
	            "type": "list",
	            "member": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "field": {},
	                  "value": {}
	                }
	              }
	            }
	          },
	          "statistics": {
	            "type": "structure",
	            "members": {
	              "recordsMatched": {
	                "type": "double"
	              },
	              "recordsScanned": {
	                "type": "double"
	              },
	              "bytesScanned": {
	                "type": "double"
	              }
	            }
	          },
	          "status": {}
	        }
	      }
	    },
	    "ListTagsLogGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName"
	        ],
	        "members": {
	          "logGroupName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tags": {
	            "shape": "Se"
	          }
	        }
	      }
	    },
	    "PutDestination": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "destinationName",
	          "targetArn",
	          "roleArn"
	        ],
	        "members": {
	          "destinationName": {},
	          "targetArn": {},
	          "roleArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "destination": {
	            "shape": "S11"
	          }
	        }
	      }
	    },
	    "PutDestinationPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "destinationName",
	          "accessPolicy"
	        ],
	        "members": {
	          "destinationName": {},
	          "accessPolicy": {},
	          "forceUpdate": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "PutLogEvents": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "logStreamName",
	          "logEvents"
	        ],
	        "members": {
	          "logGroupName": {},
	          "logStreamName": {},
	          "logEvents": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "timestamp",
	                "message"
	              ],
	              "members": {
	                "timestamp": {
	                  "type": "long"
	                },
	                "message": {}
	              }
	            }
	          },
	          "sequenceToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "nextSequenceToken": {},
	          "rejectedLogEventsInfo": {
	            "type": "structure",
	            "members": {
	              "tooNewLogEventStartIndex": {
	                "type": "integer"
	              },
	              "tooOldLogEventEndIndex": {
	                "type": "integer"
	              },
	              "expiredLogEventEndIndex": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutMetricFilter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "filterName",
	          "filterPattern",
	          "metricTransformations"
	        ],
	        "members": {
	          "logGroupName": {},
	          "filterName": {},
	          "filterPattern": {},
	          "metricTransformations": {
	            "shape": "S1z"
	          }
	        }
	      }
	    },
	    "PutQueryDefinition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "queryString"
	        ],
	        "members": {
	          "name": {},
	          "queryDefinitionId": {},
	          "logGroupNames": {
	            "shape": "S2l"
	          },
	          "queryString": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "queryDefinitionId": {}
	        }
	      }
	    },
	    "PutResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "policyName": {},
	          "policyDocument": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "resourcePolicy": {
	            "shape": "S2p"
	          }
	        }
	      }
	    },
	    "PutRetentionPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "retentionInDays"
	        ],
	        "members": {
	          "logGroupName": {},
	          "retentionInDays": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "PutSubscriptionFilter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "filterName",
	          "filterPattern",
	          "destinationArn"
	        ],
	        "members": {
	          "logGroupName": {},
	          "filterName": {},
	          "filterPattern": {},
	          "destinationArn": {},
	          "roleArn": {},
	          "distribution": {}
	        }
	      }
	    },
	    "StartQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "startTime",
	          "endTime",
	          "queryString"
	        ],
	        "members": {
	          "logGroupName": {},
	          "logGroupNames": {
	            "shape": "S2l"
	          },
	          "startTime": {
	            "type": "long"
	          },
	          "endTime": {
	            "type": "long"
	          },
	          "queryString": {},
	          "limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "queryId": {}
	        }
	      }
	    },
	    "StopQuery": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "queryId"
	        ],
	        "members": {
	          "queryId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "success": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "TagLogGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "tags"
	        ],
	        "members": {
	          "logGroupName": {},
	          "tags": {
	            "shape": "Se"
	          }
	        }
	      }
	    },
	    "TestMetricFilter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "filterPattern",
	          "logEventMessages"
	        ],
	        "members": {
	          "filterPattern": {},
	          "logEventMessages": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "matches": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "eventNumber": {
	                  "type": "long"
	                },
	                "eventMessage": {},
	                "extractedValues": {
	                  "type": "map",
	                  "key": {},
	                  "value": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "UntagLogGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "logGroupName",
	          "tags"
	        ],
	        "members": {
	          "logGroupName": {},
	          "tags": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Se": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S11": {
	      "type": "structure",
	      "members": {
	        "destinationName": {},
	        "targetArn": {},
	        "roleArn": {},
	        "accessPolicy": {},
	        "arn": {},
	        "creationTime": {
	          "type": "long"
	        }
	      }
	    },
	    "S1z": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "metricName",
	          "metricNamespace",
	          "metricValue"
	        ],
	        "members": {
	          "metricName": {},
	          "metricNamespace": {},
	          "metricValue": {},
	          "defaultValue": {
	            "type": "double"
	          },
	          "dimensions": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          },
	          "unit": {}
	        }
	      }
	    },
	    "S2l": {
	      "type": "list",
	      "member": {}
	    },
	    "S2p": {
	      "type": "structure",
	      "members": {
	        "policyName": {},
	        "policyDocument": {},
	        "lastUpdatedTime": {
	          "type": "long"
	        }
	      }
	    }
	  }
	}
	},{}],155:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeDestinations": {
	      "input_token": "nextToken",
	      "limit_key": "limit",
	      "output_token": "nextToken",
	      "result_key": "destinations"
	    },
	    "DescribeLogGroups": {
	      "input_token": "nextToken",
	      "limit_key": "limit",
	      "output_token": "nextToken",
	      "result_key": "logGroups"
	    },
	    "DescribeLogStreams": {
	      "input_token": "nextToken",
	      "limit_key": "limit",
	      "output_token": "nextToken",
	      "result_key": "logStreams"
	    },
	    "DescribeMetricFilters": {
	      "input_token": "nextToken",
	      "limit_key": "limit",
	      "output_token": "nextToken",
	      "result_key": "metricFilters"
	    },
	    "DescribeSubscriptionFilters": {
	      "input_token": "nextToken",
	      "limit_key": "limit",
	      "output_token": "nextToken",
	      "result_key": "subscriptionFilters"
	    },
	    "FilterLogEvents": {
	      "input_token": "nextToken",
	      "limit_key": "limit",
	      "output_token": "nextToken",
	      "result_key": [
	        "events",
	        "searchedLogStreams"
	      ]
	    },
	    "GetLogEvents": {
	      "input_token": "nextToken",
	      "limit_key": "limit",
	      "output_token": "nextForwardToken",
	      "result_key": "events"
	    }
	  }
	}
	},{}],156:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-12-12",
	    "endpointPrefix": "machinelearning",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Machine Learning",
	    "serviceId": "Machine Learning",
	    "signatureVersion": "v4",
	    "targetPrefix": "AmazonML_20141212",
	    "uid": "machinelearning-2014-12-12"
	  },
	  "operations": {
	    "AddTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Tags",
	          "ResourceId",
	          "ResourceType"
	        ],
	        "members": {
	          "Tags": {
	            "shape": "S2"
	          },
	          "ResourceId": {},
	          "ResourceType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceId": {},
	          "ResourceType": {}
	        }
	      }
	    },
	    "CreateBatchPrediction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BatchPredictionId",
	          "MLModelId",
	          "BatchPredictionDataSourceId",
	          "OutputUri"
	        ],
	        "members": {
	          "BatchPredictionId": {},
	          "BatchPredictionName": {},
	          "MLModelId": {},
	          "BatchPredictionDataSourceId": {},
	          "OutputUri": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BatchPredictionId": {}
	        }
	      }
	    },
	    "CreateDataSourceFromRDS": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataSourceId",
	          "RDSData",
	          "RoleARN"
	        ],
	        "members": {
	          "DataSourceId": {},
	          "DataSourceName": {},
	          "RDSData": {
	            "type": "structure",
	            "required": [
	              "DatabaseInformation",
	              "SelectSqlQuery",
	              "DatabaseCredentials",
	              "S3StagingLocation",
	              "ResourceRole",
	              "ServiceRole",
	              "SubnetId",
	              "SecurityGroupIds"
	            ],
	            "members": {
	              "DatabaseInformation": {
	                "shape": "Sf"
	              },
	              "SelectSqlQuery": {},
	              "DatabaseCredentials": {
	                "type": "structure",
	                "required": [
	                  "Username",
	                  "Password"
	                ],
	                "members": {
	                  "Username": {},
	                  "Password": {}
	                }
	              },
	              "S3StagingLocation": {},
	              "DataRearrangement": {},
	              "DataSchema": {},
	              "DataSchemaUri": {},
	              "ResourceRole": {},
	              "ServiceRole": {},
	              "SubnetId": {},
	              "SecurityGroupIds": {
	                "type": "list",
	                "member": {}
	              }
	            }
	          },
	          "RoleARN": {},
	          "ComputeStatistics": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DataSourceId": {}
	        }
	      }
	    },
	    "CreateDataSourceFromRedshift": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataSourceId",
	          "DataSpec",
	          "RoleARN"
	        ],
	        "members": {
	          "DataSourceId": {},
	          "DataSourceName": {},
	          "DataSpec": {
	            "type": "structure",
	            "required": [
	              "DatabaseInformation",
	              "SelectSqlQuery",
	              "DatabaseCredentials",
	              "S3StagingLocation"
	            ],
	            "members": {
	              "DatabaseInformation": {
	                "shape": "Sy"
	              },
	              "SelectSqlQuery": {},
	              "DatabaseCredentials": {
	                "type": "structure",
	                "required": [
	                  "Username",
	                  "Password"
	                ],
	                "members": {
	                  "Username": {},
	                  "Password": {}
	                }
	              },
	              "S3StagingLocation": {},
	              "DataRearrangement": {},
	              "DataSchema": {},
	              "DataSchemaUri": {}
	            }
	          },
	          "RoleARN": {},
	          "ComputeStatistics": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DataSourceId": {}
	        }
	      }
	    },
	    "CreateDataSourceFromS3": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataSourceId",
	          "DataSpec"
	        ],
	        "members": {
	          "DataSourceId": {},
	          "DataSourceName": {},
	          "DataSpec": {
	            "type": "structure",
	            "required": [
	              "DataLocationS3"
	            ],
	            "members": {
	              "DataLocationS3": {},
	              "DataRearrangement": {},
	              "DataSchema": {},
	              "DataSchemaLocationS3": {}
	            }
	          },
	          "ComputeStatistics": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DataSourceId": {}
	        }
	      }
	    },
	    "CreateEvaluation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EvaluationId",
	          "MLModelId",
	          "EvaluationDataSourceId"
	        ],
	        "members": {
	          "EvaluationId": {},
	          "EvaluationName": {},
	          "MLModelId": {},
	          "EvaluationDataSourceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EvaluationId": {}
	        }
	      }
	    },
	    "CreateMLModel": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MLModelId",
	          "MLModelType",
	          "TrainingDataSourceId"
	        ],
	        "members": {
	          "MLModelId": {},
	          "MLModelName": {},
	          "MLModelType": {},
	          "Parameters": {
	            "shape": "S1d"
	          },
	          "TrainingDataSourceId": {},
	          "Recipe": {},
	          "RecipeUri": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MLModelId": {}
	        }
	      }
	    },
	    "CreateRealtimeEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MLModelId"
	        ],
	        "members": {
	          "MLModelId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MLModelId": {},
	          "RealtimeEndpointInfo": {
	            "shape": "S1j"
	          }
	        }
	      }
	    },
	    "DeleteBatchPrediction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BatchPredictionId"
	        ],
	        "members": {
	          "BatchPredictionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BatchPredictionId": {}
	        }
	      }
	    },
	    "DeleteDataSource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataSourceId"
	        ],
	        "members": {
	          "DataSourceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DataSourceId": {}
	        }
	      }
	    },
	    "DeleteEvaluation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EvaluationId"
	        ],
	        "members": {
	          "EvaluationId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EvaluationId": {}
	        }
	      }
	    },
	    "DeleteMLModel": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MLModelId"
	        ],
	        "members": {
	          "MLModelId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MLModelId": {}
	        }
	      }
	    },
	    "DeleteRealtimeEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MLModelId"
	        ],
	        "members": {
	          "MLModelId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MLModelId": {},
	          "RealtimeEndpointInfo": {
	            "shape": "S1j"
	          }
	        }
	      }
	    },
	    "DeleteTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TagKeys",
	          "ResourceId",
	          "ResourceType"
	        ],
	        "members": {
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          },
	          "ResourceId": {},
	          "ResourceType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceId": {},
	          "ResourceType": {}
	        }
	      }
	    },
	    "DescribeBatchPredictions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FilterVariable": {},
	          "EQ": {},
	          "GT": {},
	          "LT": {},
	          "GE": {},
	          "LE": {},
	          "NE": {},
	          "Prefix": {},
	          "SortOrder": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Results": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "BatchPredictionId": {},
	                "MLModelId": {},
	                "BatchPredictionDataSourceId": {},
	                "InputDataLocationS3": {},
	                "CreatedByIamUser": {},
	                "CreatedAt": {
	                  "type": "timestamp"
	                },
	                "LastUpdatedAt": {
	                  "type": "timestamp"
	                },
	                "Name": {},
	                "Status": {},
	                "OutputUri": {},
	                "Message": {},
	                "ComputeTime": {
	                  "type": "long"
	                },
	                "FinishedAt": {
	                  "type": "timestamp"
	                },
	                "StartedAt": {
	                  "type": "timestamp"
	                },
	                "TotalRecordCount": {
	                  "type": "long"
	                },
	                "InvalidRecordCount": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeDataSources": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FilterVariable": {},
	          "EQ": {},
	          "GT": {},
	          "LT": {},
	          "GE": {},
	          "LE": {},
	          "NE": {},
	          "Prefix": {},
	          "SortOrder": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Results": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DataSourceId": {},
	                "DataLocationS3": {},
	                "DataRearrangement": {},
	                "CreatedByIamUser": {},
	                "CreatedAt": {
	                  "type": "timestamp"
	                },
	                "LastUpdatedAt": {
	                  "type": "timestamp"
	                },
	                "DataSizeInBytes": {
	                  "type": "long"
	                },
	                "NumberOfFiles": {
	                  "type": "long"
	                },
	                "Name": {},
	                "Status": {},
	                "Message": {},
	                "RedshiftMetadata": {
	                  "shape": "S2i"
	                },
	                "RDSMetadata": {
	                  "shape": "S2j"
	                },
	                "RoleARN": {},
	                "ComputeStatistics": {
	                  "type": "boolean"
	                },
	                "ComputeTime": {
	                  "type": "long"
	                },
	                "FinishedAt": {
	                  "type": "timestamp"
	                },
	                "StartedAt": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeEvaluations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FilterVariable": {},
	          "EQ": {},
	          "GT": {},
	          "LT": {},
	          "GE": {},
	          "LE": {},
	          "NE": {},
	          "Prefix": {},
	          "SortOrder": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Results": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EvaluationId": {},
	                "MLModelId": {},
	                "EvaluationDataSourceId": {},
	                "InputDataLocationS3": {},
	                "CreatedByIamUser": {},
	                "CreatedAt": {
	                  "type": "timestamp"
	                },
	                "LastUpdatedAt": {
	                  "type": "timestamp"
	                },
	                "Name": {},
	                "Status": {},
	                "PerformanceMetrics": {
	                  "shape": "S2q"
	                },
	                "Message": {},
	                "ComputeTime": {
	                  "type": "long"
	                },
	                "FinishedAt": {
	                  "type": "timestamp"
	                },
	                "StartedAt": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMLModels": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FilterVariable": {},
	          "EQ": {},
	          "GT": {},
	          "LT": {},
	          "GE": {},
	          "LE": {},
	          "NE": {},
	          "Prefix": {},
	          "SortOrder": {},
	          "NextToken": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Results": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "MLModelId": {},
	                "TrainingDataSourceId": {},
	                "CreatedByIamUser": {},
	                "CreatedAt": {
	                  "type": "timestamp"
	                },
	                "LastUpdatedAt": {
	                  "type": "timestamp"
	                },
	                "Name": {},
	                "Status": {},
	                "SizeInBytes": {
	                  "type": "long"
	                },
	                "EndpointInfo": {
	                  "shape": "S1j"
	                },
	                "TrainingParameters": {
	                  "shape": "S1d"
	                },
	                "InputDataLocationS3": {},
	                "Algorithm": {},
	                "MLModelType": {},
	                "ScoreThreshold": {
	                  "type": "float"
	                },
	                "ScoreThresholdLastUpdatedAt": {
	                  "type": "timestamp"
	                },
	                "Message": {},
	                "ComputeTime": {
	                  "type": "long"
	                },
	                "FinishedAt": {
	                  "type": "timestamp"
	                },
	                "StartedAt": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "ResourceType"
	        ],
	        "members": {
	          "ResourceId": {},
	          "ResourceType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceId": {},
	          "ResourceType": {},
	          "Tags": {
	            "shape": "S2"
	          }
	        }
	      }
	    },
	    "GetBatchPrediction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BatchPredictionId"
	        ],
	        "members": {
	          "BatchPredictionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BatchPredictionId": {},
	          "MLModelId": {},
	          "BatchPredictionDataSourceId": {},
	          "InputDataLocationS3": {},
	          "CreatedByIamUser": {},
	          "CreatedAt": {
	            "type": "timestamp"
	          },
	          "LastUpdatedAt": {
	            "type": "timestamp"
	          },
	          "Name": {},
	          "Status": {},
	          "OutputUri": {},
	          "LogUri": {},
	          "Message": {},
	          "ComputeTime": {
	            "type": "long"
	          },
	          "FinishedAt": {
	            "type": "timestamp"
	          },
	          "StartedAt": {
	            "type": "timestamp"
	          },
	          "TotalRecordCount": {
	            "type": "long"
	          },
	          "InvalidRecordCount": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "GetDataSource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataSourceId"
	        ],
	        "members": {
	          "DataSourceId": {},
	          "Verbose": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DataSourceId": {},
	          "DataLocationS3": {},
	          "DataRearrangement": {},
	          "CreatedByIamUser": {},
	          "CreatedAt": {
	            "type": "timestamp"
	          },
	          "LastUpdatedAt": {
	            "type": "timestamp"
	          },
	          "DataSizeInBytes": {
	            "type": "long"
	          },
	          "NumberOfFiles": {
	            "type": "long"
	          },
	          "Name": {},
	          "Status": {},
	          "LogUri": {},
	          "Message": {},
	          "RedshiftMetadata": {
	            "shape": "S2i"
	          },
	          "RDSMetadata": {
	            "shape": "S2j"
	          },
	          "RoleARN": {},
	          "ComputeStatistics": {
	            "type": "boolean"
	          },
	          "ComputeTime": {
	            "type": "long"
	          },
	          "FinishedAt": {
	            "type": "timestamp"
	          },
	          "StartedAt": {
	            "type": "timestamp"
	          },
	          "DataSourceSchema": {}
	        }
	      }
	    },
	    "GetEvaluation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EvaluationId"
	        ],
	        "members": {
	          "EvaluationId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EvaluationId": {},
	          "MLModelId": {},
	          "EvaluationDataSourceId": {},
	          "InputDataLocationS3": {},
	          "CreatedByIamUser": {},
	          "CreatedAt": {
	            "type": "timestamp"
	          },
	          "LastUpdatedAt": {
	            "type": "timestamp"
	          },
	          "Name": {},
	          "Status": {},
	          "PerformanceMetrics": {
	            "shape": "S2q"
	          },
	          "LogUri": {},
	          "Message": {},
	          "ComputeTime": {
	            "type": "long"
	          },
	          "FinishedAt": {
	            "type": "timestamp"
	          },
	          "StartedAt": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetMLModel": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MLModelId"
	        ],
	        "members": {
	          "MLModelId": {},
	          "Verbose": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MLModelId": {},
	          "TrainingDataSourceId": {},
	          "CreatedByIamUser": {},
	          "CreatedAt": {
	            "type": "timestamp"
	          },
	          "LastUpdatedAt": {
	            "type": "timestamp"
	          },
	          "Name": {},
	          "Status": {},
	          "SizeInBytes": {
	            "type": "long"
	          },
	          "EndpointInfo": {
	            "shape": "S1j"
	          },
	          "TrainingParameters": {
	            "shape": "S1d"
	          },
	          "InputDataLocationS3": {},
	          "MLModelType": {},
	          "ScoreThreshold": {
	            "type": "float"
	          },
	          "ScoreThresholdLastUpdatedAt": {
	            "type": "timestamp"
	          },
	          "LogUri": {},
	          "Message": {},
	          "ComputeTime": {
	            "type": "long"
	          },
	          "FinishedAt": {
	            "type": "timestamp"
	          },
	          "StartedAt": {
	            "type": "timestamp"
	          },
	          "Recipe": {},
	          "Schema": {}
	        }
	      }
	    },
	    "Predict": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MLModelId",
	          "Record",
	          "PredictEndpoint"
	        ],
	        "members": {
	          "MLModelId": {},
	          "Record": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          },
	          "PredictEndpoint": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Prediction": {
	            "type": "structure",
	            "members": {
	              "predictedLabel": {},
	              "predictedValue": {
	                "type": "float"
	              },
	              "predictedScores": {
	                "type": "map",
	                "key": {},
	                "value": {
	                  "type": "float"
	                }
	              },
	              "details": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "UpdateBatchPrediction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BatchPredictionId",
	          "BatchPredictionName"
	        ],
	        "members": {
	          "BatchPredictionId": {},
	          "BatchPredictionName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BatchPredictionId": {}
	        }
	      }
	    },
	    "UpdateDataSource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataSourceId",
	          "DataSourceName"
	        ],
	        "members": {
	          "DataSourceId": {},
	          "DataSourceName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DataSourceId": {}
	        }
	      }
	    },
	    "UpdateEvaluation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EvaluationId",
	          "EvaluationName"
	        ],
	        "members": {
	          "EvaluationId": {},
	          "EvaluationName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EvaluationId": {}
	        }
	      }
	    },
	    "UpdateMLModel": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MLModelId"
	        ],
	        "members": {
	          "MLModelId": {},
	          "MLModelName": {},
	          "ScoreThreshold": {
	            "type": "float"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MLModelId": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sf": {
	      "type": "structure",
	      "required": [
	        "InstanceIdentifier",
	        "DatabaseName"
	      ],
	      "members": {
	        "InstanceIdentifier": {},
	        "DatabaseName": {}
	      }
	    },
	    "Sy": {
	      "type": "structure",
	      "required": [
	        "DatabaseName",
	        "ClusterIdentifier"
	      ],
	      "members": {
	        "DatabaseName": {},
	        "ClusterIdentifier": {}
	      }
	    },
	    "S1d": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S1j": {
	      "type": "structure",
	      "members": {
	        "PeakRequestsPerSecond": {
	          "type": "integer"
	        },
	        "CreatedAt": {
	          "type": "timestamp"
	        },
	        "EndpointUrl": {},
	        "EndpointStatus": {}
	      }
	    },
	    "S2i": {
	      "type": "structure",
	      "members": {
	        "RedshiftDatabase": {
	          "shape": "Sy"
	        },
	        "DatabaseUserName": {},
	        "SelectSqlQuery": {}
	      }
	    },
	    "S2j": {
	      "type": "structure",
	      "members": {
	        "Database": {
	          "shape": "Sf"
	        },
	        "DatabaseUserName": {},
	        "SelectSqlQuery": {},
	        "ResourceRole": {},
	        "ServiceRole": {},
	        "DataPipelineId": {}
	      }
	    },
	    "S2q": {
	      "type": "structure",
	      "members": {
	        "Properties": {
	          "type": "map",
	          "key": {},
	          "value": {}
	        }
	      }
	    }
	  }
	}
	},{}],157:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeBatchPredictions": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "Results"
	    },
	    "DescribeDataSources": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "Results"
	    },
	    "DescribeEvaluations": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "Results"
	    },
	    "DescribeMLModels": {
	      "input_token": "NextToken",
	      "limit_key": "Limit",
	      "output_token": "NextToken",
	      "result_key": "Results"
	    }
	  }
	}
	},{}],158:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "DataSourceAvailable": {
	      "delay": 30,
	      "operation": "DescribeDataSources",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": "COMPLETED",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Results[].Status"
	        },
	        {
	          "expected": "FAILED",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Results[].Status"
	        }
	      ]
	    },
	    "MLModelAvailable": {
	      "delay": 30,
	      "operation": "DescribeMLModels",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": "COMPLETED",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Results[].Status"
	        },
	        {
	          "expected": "FAILED",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Results[].Status"
	        }
	      ]
	    },
	    "EvaluationAvailable": {
	      "delay": 30,
	      "operation": "DescribeEvaluations",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": "COMPLETED",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Results[].Status"
	        },
	        {
	          "expected": "FAILED",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Results[].Status"
	        }
	      ]
	    },
	    "BatchPredictionAvailable": {
	      "delay": 30,
	      "operation": "DescribeBatchPredictions",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": "COMPLETED",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Results[].Status"
	        },
	        {
	          "expected": "FAILED",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Results[].Status"
	        }
	      ]
	    }
	  }
	}
	
	},{}],159:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-07-01",
	    "endpointPrefix": "marketplacecommerceanalytics",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "AWS Marketplace Commerce Analytics",
	    "serviceId": "Marketplace Commerce Analytics",
	    "signatureVersion": "v4",
	    "signingName": "marketplacecommerceanalytics",
	    "targetPrefix": "MarketplaceCommerceAnalytics20150701",
	    "uid": "marketplacecommerceanalytics-2015-07-01"
	  },
	  "operations": {
	    "GenerateDataSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "dataSetType",
	          "dataSetPublicationDate",
	          "roleNameArn",
	          "destinationS3BucketName",
	          "snsTopicArn"
	        ],
	        "members": {
	          "dataSetType": {},
	          "dataSetPublicationDate": {
	            "type": "timestamp"
	          },
	          "roleNameArn": {},
	          "destinationS3BucketName": {},
	          "destinationS3Prefix": {},
	          "snsTopicArn": {},
	          "customerDefinedValues": {
	            "shape": "S8"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "dataSetRequestId": {}
	        }
	      }
	    },
	    "StartSupportDataExport": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "dataSetType",
	          "fromDate",
	          "roleNameArn",
	          "destinationS3BucketName",
	          "snsTopicArn"
	        ],
	        "members": {
	          "dataSetType": {},
	          "fromDate": {
	            "type": "timestamp"
	          },
	          "roleNameArn": {},
	          "destinationS3BucketName": {},
	          "destinationS3Prefix": {},
	          "snsTopicArn": {},
	          "customerDefinedValues": {
	            "shape": "S8"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "dataSetRequestId": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S8": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    }
	  }
	}
	},{}],160:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],161:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-09-01",
	    "endpointPrefix": "data.mediastore",
	    "protocol": "rest-json",
	    "serviceAbbreviation": "MediaStore Data",
	    "serviceFullName": "AWS Elemental MediaStore Data Plane",
	    "serviceId": "MediaStore Data",
	    "signatureVersion": "v4",
	    "signingName": "mediastore",
	    "uid": "mediastore-data-2017-09-01"
	  },
	  "operations": {
	    "DeleteObject": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Path+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Path"
	        ],
	        "members": {
	          "Path": {
	            "location": "uri",
	            "locationName": "Path"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeObject": {
	      "http": {
	        "method": "HEAD",
	        "requestUri": "/{Path+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Path"
	        ],
	        "members": {
	          "Path": {
	            "location": "uri",
	            "locationName": "Path"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "ContentLength": {
	            "location": "header",
	            "locationName": "Content-Length",
	            "type": "long"
	          },
	          "CacheControl": {
	            "location": "header",
	            "locationName": "Cache-Control"
	          },
	          "LastModified": {
	            "location": "header",
	            "locationName": "Last-Modified",
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetObject": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Path+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Path"
	        ],
	        "members": {
	          "Path": {
	            "location": "uri",
	            "locationName": "Path"
	          },
	          "Range": {
	            "location": "header",
	            "locationName": "Range"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "StatusCode"
	        ],
	        "members": {
	          "Body": {
	            "shape": "Se"
	          },
	          "CacheControl": {
	            "location": "header",
	            "locationName": "Cache-Control"
	          },
	          "ContentRange": {
	            "location": "header",
	            "locationName": "Content-Range"
	          },
	          "ContentLength": {
	            "location": "header",
	            "locationName": "Content-Length",
	            "type": "long"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          },
	          "LastModified": {
	            "location": "header",
	            "locationName": "Last-Modified",
	            "type": "timestamp"
	          },
	          "StatusCode": {
	            "location": "statusCode",
	            "type": "integer"
	          }
	        },
	        "payload": "Body"
	      }
	    },
	    "ListItems": {
	      "http": {
	        "method": "GET"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Path": {
	            "location": "querystring",
	            "locationName": "Path"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "MaxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "NextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Items": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Type": {},
	                "ETag": {},
	                "LastModified": {
	                  "type": "timestamp"
	                },
	                "ContentType": {},
	                "ContentLength": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PutObject": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Path+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Body",
	          "Path"
	        ],
	        "members": {
	          "Body": {
	            "shape": "Se"
	          },
	          "Path": {
	            "location": "uri",
	            "locationName": "Path"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "CacheControl": {
	            "location": "header",
	            "locationName": "Cache-Control"
	          },
	          "StorageClass": {
	            "location": "header",
	            "locationName": "x-amz-storage-class"
	          },
	          "UploadAvailability": {
	            "location": "header",
	            "locationName": "x-amz-upload-availability"
	          }
	        },
	        "payload": "Body"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContentSHA256": {},
	          "ETag": {},
	          "StorageClass": {}
	        }
	      },
	      "authtype": "v4-unsigned-body"
	    }
	  },
	  "shapes": {
	    "Se": {
	      "type": "blob",
	      "streaming": true
	    }
	  }
	}
	},{}],162:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListItems": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    }
	  }
	}
	
	},{}],163:[function(require,module,exports){
	module.exports={
	  "acm": {
	    "name": "ACM",
	    "cors": true
	  },
	  "apigateway": {
	    "name": "APIGateway",
	    "cors": true
	  },
	  "applicationautoscaling": {
	    "prefix": "application-autoscaling",
	    "name": "ApplicationAutoScaling",
	    "cors": true
	  },
	  "appstream": {
	    "name": "AppStream"
	  },
	  "autoscaling": {
	    "name": "AutoScaling",
	    "cors": true
	  },
	  "batch": {
	    "name": "Batch"
	  },
	  "budgets": {
	    "name": "Budgets"
	  },
	  "clouddirectory": {
	    "name": "CloudDirectory",
	    "versions": [
	      "2016-05-10*"
	    ]
	  },
	  "cloudformation": {
	    "name": "CloudFormation",
	    "cors": true
	  },
	  "cloudfront": {
	    "name": "CloudFront",
	    "versions": [
	      "2013-05-12*",
	      "2013-11-11*",
	      "2014-05-31*",
	      "2014-10-21*",
	      "2014-11-06*",
	      "2015-04-17*",
	      "2015-07-27*",
	      "2015-09-17*",
	      "2016-01-13*",
	      "2016-01-28*",
	      "2016-08-01*",
	      "2016-08-20*",
	      "2016-09-07*",
	      "2016-09-29*",
	      "2016-11-25*",
	      "2017-03-25*",
	      "2017-10-30*",
	      "2018-06-18*",
	      "2018-11-05*",
	      "2019-03-26*"
	    ],
	    "cors": true
	  },
	  "cloudhsm": {
	    "name": "CloudHSM",
	    "cors": true
	  },
	  "cloudsearch": {
	    "name": "CloudSearch"
	  },
	  "cloudsearchdomain": {
	    "name": "CloudSearchDomain"
	  },
	  "cloudtrail": {
	    "name": "CloudTrail",
	    "cors": true
	  },
	  "cloudwatch": {
	    "prefix": "monitoring",
	    "name": "CloudWatch",
	    "cors": true
	  },
	  "cloudwatchevents": {
	    "prefix": "events",
	    "name": "CloudWatchEvents",
	    "versions": [
	      "2014-02-03*"
	    ],
	    "cors": true
	  },
	  "cloudwatchlogs": {
	    "prefix": "logs",
	    "name": "CloudWatchLogs",
	    "cors": true
	  },
	  "codebuild": {
	    "name": "CodeBuild",
	    "cors": true
	  },
	  "codecommit": {
	    "name": "CodeCommit",
	    "cors": true
	  },
	  "codedeploy": {
	    "name": "CodeDeploy",
	    "cors": true
	  },
	  "codepipeline": {
	    "name": "CodePipeline",
	    "cors": true
	  },
	  "cognitoidentity": {
	    "prefix": "cognito-identity",
	    "name": "CognitoIdentity",
	    "cors": true
	  },
	  "cognitoidentityserviceprovider": {
	    "prefix": "cognito-idp",
	    "name": "CognitoIdentityServiceProvider",
	    "cors": true
	  },
	  "cognitosync": {
	    "prefix": "cognito-sync",
	    "name": "CognitoSync",
	    "cors": true
	  },
	  "configservice": {
	    "prefix": "config",
	    "name": "ConfigService",
	    "cors": true
	  },
	  "cur": {
	    "name": "CUR",
	    "cors": true
	  },
	  "datapipeline": {
	    "name": "DataPipeline"
	  },
	  "devicefarm": {
	    "name": "DeviceFarm",
	    "cors": true
	  },
	  "directconnect": {
	    "name": "DirectConnect",
	    "cors": true
	  },
	  "directoryservice": {
	    "prefix": "ds",
	    "name": "DirectoryService"
	  },
	  "discovery": {
	    "name": "Discovery"
	  },
	  "dms": {
	    "name": "DMS"
	  },
	  "dynamodb": {
	    "name": "DynamoDB",
	    "cors": true
	  },
	  "dynamodbstreams": {
	    "prefix": "streams.dynamodb",
	    "name": "DynamoDBStreams",
	    "cors": true
	  },
	  "ec2": {
	    "name": "EC2",
	    "versions": [
	      "2013-06-15*",
	      "2013-10-15*",
	      "2014-02-01*",
	      "2014-05-01*",
	      "2014-06-15*",
	      "2014-09-01*",
	      "2014-10-01*",
	      "2015-03-01*",
	      "2015-04-15*",
	      "2015-10-01*",
	      "2016-04-01*",
	      "2016-09-15*"
	    ],
	    "cors": true
	  },
	  "ecr": {
	    "name": "ECR",
	    "cors": true
	  },
	  "ecs": {
	    "name": "ECS",
	    "cors": true
	  },
	  "efs": {
	    "prefix": "elasticfilesystem",
	    "name": "EFS",
	    "cors": true
	  },
	  "elasticache": {
	    "name": "ElastiCache",
	    "versions": [
	      "2012-11-15*",
	      "2014-03-24*",
	      "2014-07-15*",
	      "2014-09-30*"
	    ],
	    "cors": true
	  },
	  "elasticbeanstalk": {
	    "name": "ElasticBeanstalk",
	    "cors": true
	  },
	  "elb": {
	    "prefix": "elasticloadbalancing",
	    "name": "ELB",
	    "cors": true
	  },
	  "elbv2": {
	    "prefix": "elasticloadbalancingv2",
	    "name": "ELBv2",
	    "cors": true
	  },
	  "emr": {
	    "prefix": "elasticmapreduce",
	    "name": "EMR",
	    "cors": true
	  },
	  "es": {
	    "name": "ES"
	  },
	  "elastictranscoder": {
	    "name": "ElasticTranscoder",
	    "cors": true
	  },
	  "firehose": {
	    "name": "Firehose",
	    "cors": true
	  },
	  "gamelift": {
	    "name": "GameLift",
	    "cors": true
	  },
	  "glacier": {
	    "name": "Glacier"
	  },
	  "health": {
	    "name": "Health"
	  },
	  "iam": {
	    "name": "IAM",
	    "cors": true
	  },
	  "importexport": {
	    "name": "ImportExport"
	  },
	  "inspector": {
	    "name": "Inspector",
	    "versions": [
	      "2015-08-18*"
	    ],
	    "cors": true
	  },
	  "iot": {
	    "name": "Iot",
	    "cors": true
	  },
	  "iotdata": {
	    "prefix": "iot-data",
	    "name": "IotData",
	    "cors": true
	  },
	  "kinesis": {
	    "name": "Kinesis",
	    "cors": true
	  },
	  "kinesisanalytics": {
	    "name": "KinesisAnalytics"
	  },
	  "kms": {
	    "name": "KMS",
	    "cors": true
	  },
	  "lambda": {
	    "name": "Lambda",
	    "cors": true
	  },
	  "lexruntime": {
	    "prefix": "runtime.lex",
	    "name": "LexRuntime",
	    "cors": true
	  },
	  "lightsail": {
	    "name": "Lightsail"
	  },
	  "machinelearning": {
	    "name": "MachineLearning",
	    "cors": true
	  },
	  "marketplacecommerceanalytics": {
	    "name": "MarketplaceCommerceAnalytics",
	    "cors": true
	  },
	  "marketplacemetering": {
	    "prefix": "meteringmarketplace",
	    "name": "MarketplaceMetering"
	  },
	  "mturk": {
	    "prefix": "mturk-requester",
	    "name": "MTurk",
	    "cors": true
	  },
	  "mobileanalytics": {
	    "name": "MobileAnalytics",
	    "cors": true
	  },
	  "opsworks": {
	    "name": "OpsWorks",
	    "cors": true
	  },
	  "opsworkscm": {
	    "name": "OpsWorksCM"
	  },
	  "organizations": {
	    "name": "Organizations"
	  },
	  "pinpoint": {
	    "name": "Pinpoint"
	  },
	  "polly": {
	    "name": "Polly",
	    "cors": true
	  },
	  "rds": {
	    "name": "RDS",
	    "versions": [
	      "2014-09-01*"
	    ],
	    "cors": true
	  },
	  "redshift": {
	    "name": "Redshift",
	    "cors": true
	  },
	  "rekognition": {
	    "name": "Rekognition",
	    "cors": true
	  },
	  "resourcegroupstaggingapi": {
	    "name": "ResourceGroupsTaggingAPI"
	  },
	  "route53": {
	    "name": "Route53",
	    "cors": true
	  },
	  "route53domains": {
	    "name": "Route53Domains",
	    "cors": true
	  },
	  "s3": {
	    "name": "S3",
	    "dualstackAvailable": true,
	    "cors": true
	  },
	  "s3control": {
	    "name": "S3Control",
	    "dualstackAvailable": true,
	    "xmlNoDefaultLists": true
	  },
	  "servicecatalog": {
	    "name": "ServiceCatalog",
	    "cors": true
	  },
	  "ses": {
	    "prefix": "email",
	    "name": "SES",
	    "cors": true
	  },
	  "shield": {
	    "name": "Shield"
	  },
	  "simpledb": {
	    "prefix": "sdb",
	    "name": "SimpleDB"
	  },
	  "sms": {
	    "name": "SMS"
	  },
	  "snowball": {
	    "name": "Snowball"
	  },
	  "sns": {
	    "name": "SNS",
	    "cors": true
	  },
	  "sqs": {
	    "name": "SQS",
	    "cors": true
	  },
	  "ssm": {
	    "name": "SSM",
	    "cors": true
	  },
	  "storagegateway": {
	    "name": "StorageGateway",
	    "cors": true
	  },
	  "stepfunctions": {
	    "prefix": "states",
	    "name": "StepFunctions"
	  },
	  "sts": {
	    "name": "STS",
	    "cors": true
	  },
	  "support": {
	    "name": "Support"
	  },
	  "swf": {
	    "name": "SWF"
	  },
	  "xray": {
	    "name": "XRay",
	    "cors": true
	  },
	  "waf": {
	    "name": "WAF",
	    "cors": true
	  },
	  "wafregional": {
	    "prefix": "waf-regional",
	    "name": "WAFRegional"
	  },
	  "workdocs": {
	    "name": "WorkDocs",
	    "cors": true
	  },
	  "workspaces": {
	    "name": "WorkSpaces"
	  },
	  "codestar": {
	    "name": "CodeStar"
	  },
	  "lexmodelbuildingservice": {
	    "prefix": "lex-models",
	    "name": "LexModelBuildingService",
	    "cors": true
	  },
	  "marketplaceentitlementservice": {
	    "prefix": "entitlement.marketplace",
	    "name": "MarketplaceEntitlementService"
	  },
	  "athena": {
	    "name": "Athena",
	    "cors": true
	  },
	  "greengrass": {
	    "name": "Greengrass"
	  },
	  "dax": {
	    "name": "DAX"
	  },
	  "migrationhub": {
	    "prefix": "AWSMigrationHub",
	    "name": "MigrationHub"
	  },
	  "cloudhsmv2": {
	    "name": "CloudHSMV2",
	    "cors": true
	  },
	  "glue": {
	    "name": "Glue"
	  },
	  "mobile": {
	    "name": "Mobile"
	  },
	  "pricing": {
	    "name": "Pricing",
	    "cors": true
	  },
	  "costexplorer": {
	    "prefix": "ce",
	    "name": "CostExplorer",
	    "cors": true
	  },
	  "mediaconvert": {
	    "name": "MediaConvert"
	  },
	  "medialive": {
	    "name": "MediaLive"
	  },
	  "mediapackage": {
	    "name": "MediaPackage"
	  },
	  "mediastore": {
	    "name": "MediaStore"
	  },
	  "mediastoredata": {
	    "prefix": "mediastore-data",
	    "name": "MediaStoreData",
	    "cors": true
	  },
	  "appsync": {
	    "name": "AppSync"
	  },
	  "guardduty": {
	    "name": "GuardDuty"
	  },
	  "mq": {
	    "name": "MQ"
	  },
	  "comprehend": {
	    "name": "Comprehend",
	    "cors": true
	  },
	  "iotjobsdataplane": {
	    "prefix": "iot-jobs-data",
	    "name": "IoTJobsDataPlane"
	  },
	  "kinesisvideoarchivedmedia": {
	    "prefix": "kinesis-video-archived-media",
	    "name": "KinesisVideoArchivedMedia",
	    "cors": true
	  },
	  "kinesisvideomedia": {
	    "prefix": "kinesis-video-media",
	    "name": "KinesisVideoMedia",
	    "cors": true
	  },
	  "kinesisvideo": {
	    "name": "KinesisVideo",
	    "cors": true
	  },
	  "sagemakerruntime": {
	    "prefix": "runtime.sagemaker",
	    "name": "SageMakerRuntime"
	  },
	  "sagemaker": {
	    "name": "SageMaker"
	  },
	  "translate": {
	    "name": "Translate",
	    "cors": true
	  },
	  "resourcegroups": {
	    "prefix": "resource-groups",
	    "name": "ResourceGroups",
	    "cors": true
	  },
	  "alexaforbusiness": {
	    "name": "AlexaForBusiness"
	  },
	  "cloud9": {
	    "name": "Cloud9"
	  },
	  "serverlessapplicationrepository": {
	    "prefix": "serverlessrepo",
	    "name": "ServerlessApplicationRepository"
	  },
	  "servicediscovery": {
	    "name": "ServiceDiscovery"
	  },
	  "workmail": {
	    "name": "WorkMail"
	  },
	  "autoscalingplans": {
	    "prefix": "autoscaling-plans",
	    "name": "AutoScalingPlans"
	  },
	  "transcribeservice": {
	    "prefix": "transcribe",
	    "name": "TranscribeService"
	  },
	  "connect": {
	    "name": "Connect",
	    "cors": true
	  },
	  "acmpca": {
	    "prefix": "acm-pca",
	    "name": "ACMPCA"
	  },
	  "fms": {
	    "name": "FMS"
	  },
	  "secretsmanager": {
	    "name": "SecretsManager",
	    "cors": true
	  },
	  "iotanalytics": {
	    "name": "IoTAnalytics",
	    "cors": true
	  },
	  "iot1clickdevicesservice": {
	    "prefix": "iot1click-devices",
	    "name": "IoT1ClickDevicesService"
	  },
	  "iot1clickprojects": {
	    "prefix": "iot1click-projects",
	    "name": "IoT1ClickProjects"
	  },
	  "pi": {
	    "name": "PI"
	  },
	  "neptune": {
	    "name": "Neptune"
	  },
	  "mediatailor": {
	    "name": "MediaTailor"
	  },
	  "eks": {
	    "name": "EKS"
	  },
	  "macie": {
	    "name": "Macie"
	  },
	  "dlm": {
	    "name": "DLM"
	  },
	  "signer": {
	    "name": "Signer"
	  },
	  "chime": {
	    "name": "Chime"
	  },
	  "pinpointemail": {
	    "prefix": "pinpoint-email",
	    "name": "PinpointEmail"
	  },
	  "ram": {
	    "name": "RAM"
	  },
	  "route53resolver": {
	    "name": "Route53Resolver"
	  },
	  "pinpointsmsvoice": {
	    "prefix": "sms-voice",
	    "name": "PinpointSMSVoice"
	  },
	  "quicksight": {
	    "name": "QuickSight"
	  },
	  "rdsdataservice": {
	    "prefix": "rds-data",
	    "name": "RDSDataService"
	  },
	  "amplify": {
	    "name": "Amplify"
	  },
	  "datasync": {
	    "name": "DataSync"
	  },
	  "robomaker": {
	    "name": "RoboMaker"
	  },
	  "transfer": {
	    "name": "Transfer"
	  },
	  "globalaccelerator": {
	    "name": "GlobalAccelerator"
	  },
	  "comprehendmedical": {
	    "name": "ComprehendMedical",
	    "cors": true
	  },
	  "kinesisanalyticsv2": {
	    "name": "KinesisAnalyticsV2"
	  },
	  "mediaconnect": {
	    "name": "MediaConnect"
	  },
	  "fsx": {
	    "name": "FSx"
	  },
	  "securityhub": {
	    "name": "SecurityHub"
	  },
	  "appmesh": {
	    "name": "AppMesh",
	    "versions": [
	      "2018-10-01*"
	    ]
	  },
	  "licensemanager": {
	    "prefix": "license-manager",
	    "name": "LicenseManager"
	  },
	  "kafka": {
	    "name": "Kafka"
	  },
	  "apigatewaymanagementapi": {
	    "name": "ApiGatewayManagementApi"
	  },
	  "apigatewayv2": {
	    "name": "ApiGatewayV2"
	  },
	  "docdb": {
	    "name": "DocDB"
	  },
	  "backup": {
	    "name": "Backup"
	  },
	  "worklink": {
	    "name": "WorkLink"
	  },
	  "textract": {
	    "name": "Textract"
	  },
	  "managedblockchain": {
	    "name": "ManagedBlockchain"
	  },
	  "mediapackagevod": {
	    "prefix": "mediapackage-vod",
	    "name": "MediaPackageVod"
	  },
	  "groundstation": {
	    "name": "GroundStation"
	  },
	  "iotthingsgraph": {
	    "name": "IoTThingsGraph"
	  },
	  "iotevents": {
	    "name": "IoTEvents"
	  },
	  "ioteventsdata": {
	    "prefix": "iotevents-data",
	    "name": "IoTEventsData"
	  },
	  "personalize": {
	    "name": "Personalize",
	    "cors": true
	  },
	  "personalizeevents": {
	    "prefix": "personalize-events",
	    "name": "PersonalizeEvents",
	    "cors": true
	  },
	  "personalizeruntime": {
	    "prefix": "personalize-runtime",
	    "name": "PersonalizeRuntime",
	    "cors": true
	  },
	  "applicationinsights": {
	    "prefix": "application-insights",
	    "name": "ApplicationInsights"
	  },
	  "servicequotas": {
	    "prefix": "service-quotas",
	    "name": "ServiceQuotas"
	  },
	  "ec2instanceconnect": {
	    "prefix": "ec2-instance-connect",
	    "name": "EC2InstanceConnect"
	  },
	  "eventbridge": {
	    "name": "EventBridge"
	  },
	  "lakeformation": {
	    "name": "LakeFormation"
	  },
	  "forecastservice": {
	    "prefix": "forecast",
	    "name": "ForecastService",
	    "cors": true
	  },
	  "forecastqueryservice": {
	    "prefix": "forecastquery",
	    "name": "ForecastQueryService",
	    "cors": true
	  },
	  "qldb": {
	    "name": "QLDB"
	  },
	  "qldbsession": {
	    "prefix": "qldb-session",
	    "name": "QLDBSession"
	  },
	  "workmailmessageflow": {
	    "name": "WorkMailMessageFlow"
	  },
	  "codestarnotifications": {
	    "prefix": "codestar-notifications",
	    "name": "CodeStarNotifications"
	  },
	  "savingsplans": {
	    "name": "SavingsPlans"
	  },
	  "sso": {
	    "name": "SSO"
	  },
	  "ssooidc": {
	    "prefix": "sso-oidc",
	    "name": "SSOOIDC"
	  },
	  "marketplacecatalog": {
	    "prefix": "marketplace-catalog",
	    "name": "MarketplaceCatalog"
	  },
	  "dataexchange": {
	    "name": "DataExchange"
	  },
	  "sesv2": {
	    "name": "SESV2"
	  },
	  "migrationhubconfig": {
	    "prefix": "migrationhub-config",
	    "name": "MigrationHubConfig"
	  },
	  "connectparticipant": {
	    "name": "ConnectParticipant"
	  },
	  "appconfig": {
	    "name": "AppConfig"
	  },
	  "iotsecuretunneling": {
	    "name": "IoTSecureTunneling"
	  },
	  "wafv2": {
	    "name": "WAFV2"
	  },
	  "elasticinference": {
	    "prefix": "elastic-inference",
	    "name": "ElasticInference"
	  },
	  "imagebuilder": {
	    "name": "Imagebuilder"
	  },
	  "schemas": {
	    "name": "Schemas"
	  },
	  "accessanalyzer": {
	    "name": "AccessAnalyzer"
	  },
	  "codegurureviewer": {
	    "prefix": "codeguru-reviewer",
	    "name": "CodeGuruReviewer"
	  },
	  "codeguruprofiler": {
	    "name": "CodeGuruProfiler"
	  },
	  "computeoptimizer": {
	    "prefix": "compute-optimizer",
	    "name": "ComputeOptimizer"
	  },
	  "frauddetector": {
	    "name": "FraudDetector"
	  },
	  "kendra": {
	    "name": "Kendra"
	  },
	  "networkmanager": {
	    "name": "NetworkManager"
	  },
	  "outposts": {
	    "name": "Outposts"
	  },
	  "augmentedairuntime": {
	    "prefix": "sagemaker-a2i-runtime",
	    "name": "AugmentedAIRuntime"
	  },
	  "ebs": {
	    "name": "EBS"
	  },
	  "kinesisvideosignalingchannels": {
	    "prefix": "kinesis-video-signaling",
	    "name": "KinesisVideoSignalingChannels",
	    "cors": true
	  },
	  "detective": {
	    "name": "Detective"
	  },
	  "codestarconnections": {
	    "prefix": "codestar-connections",
	    "name": "CodeStarconnections"
	  },
	  "synthetics": {
	    "name": "Synthetics"
	  },
	  "iotsitewise": {
	    "name": "IoTSiteWise"
	  },
	  "macie2": {
	    "name": "Macie2"
	  },
	  "codeartifact": {
	    "name": "CodeArtifact"
	  },
	  "honeycode": {
	    "name": "Honeycode"
	  },
	  "ivs": {
	    "name": "IVS"
	  },
	  "braket": {
	    "name": "Braket"
	  },
	  "identitystore": {
	    "name": "IdentityStore"
	  },
	  "appflow": {
	    "name": "Appflow"
	  },
	  "redshiftdata": {
	    "prefix": "redshift-data",
	    "name": "RedshiftData"
	  },
	  "ssoadmin": {
	    "prefix": "sso-admin",
	    "name": "SSOAdmin"
	  },
	  "timestreamquery": {
	    "prefix": "timestream-query",
	    "name": "TimestreamQuery"
	  },
	  "timestreamwrite": {
	    "prefix": "timestream-write",
	    "name": "TimestreamWrite"
	  },
	  "s3outposts": {
	    "name": "S3Outposts"
	  },
	  "databrew": {
	    "name": "DataBrew"
	  },
	  "servicecatalogappregistry": {
	    "prefix": "servicecatalog-appregistry",
	    "name": "ServiceCatalogAppRegistry"
	  },
	  "networkfirewall": {
	    "prefix": "network-firewall",
	    "name": "NetworkFirewall"
	  },
	  "mwaa": {
	    "name": "MWAA"
	  },
	  "amplifybackend": {
	    "name": "AmplifyBackend"
	  },
	  "appintegrations": {
	    "name": "AppIntegrations"
	  },
	  "connectcontactlens": {
	    "prefix": "connect-contact-lens",
	    "name": "ConnectContactLens"
	  },
	  "devopsguru": {
	    "prefix": "devops-guru",
	    "name": "DevOpsGuru"
	  },
	  "ecrpublic": {
	    "prefix": "ecr-public",
	    "name": "ECRPUBLIC"
	  },
	  "lookoutvision": {
	    "name": "LookoutVision"
	  },
	  "sagemakerfeaturestoreruntime": {
	    "prefix": "sagemaker-featurestore-runtime",
	    "name": "SageMakerFeatureStoreRuntime"
	  },
	  "customerprofiles": {
	    "prefix": "customer-profiles",
	    "name": "CustomerProfiles"
	  },
	  "auditmanager": {
	    "name": "AuditManager"
	  },
	  "emrcontainers": {
	    "prefix": "emr-containers",
	    "name": "EMRcontainers"
	  },
	  "healthlake": {
	    "name": "HealthLake"
	  },
	  "sagemakeredge": {
	    "prefix": "sagemaker-edge",
	    "name": "SagemakerEdge"
	  },
	  "amp": {
	    "name": "Amp"
	  },
	  "greengrassv2": {
	    "name": "GreengrassV2"
	  },
	  "iotdeviceadvisor": {
	    "name": "IotDeviceAdvisor"
	  },
	  "iotfleethub": {
	    "name": "IoTFleetHub"
	  },
	  "iotwireless": {
	    "name": "IoTWireless"
	  },
	  "location": {
	    "name": "Location",
	    "cors": true
	  },
	  "wellarchitected": {
	    "name": "WellArchitected"
	  },
	  "lexmodelsv2": {
	    "prefix": "models.lex.v2",
	    "name": "LexModelsV2"
	  },
	  "lexruntimev2": {
	    "prefix": "runtime.lex.v2",
	    "name": "LexRuntimeV2",
	    "cors": true
	  },
	  "fis": {
	    "name": "Fis"
	  },
	  "lookoutmetrics": {
	    "name": "LookoutMetrics"
	  },
	  "mgn": {
	    "name": "Mgn"
	  },
	  "lookoutequipment": {
	    "name": "LookoutEquipment"
	  },
	  "nimble": {
	    "name": "Nimble"
	  },
	  "finspace": {
	    "name": "Finspace"
	  },
	  "finspacedata": {
	    "prefix": "finspace-data",
	    "name": "Finspacedata"
	  },
	  "ssmcontacts": {
	    "prefix": "ssm-contacts",
	    "name": "SSMContacts"
	  },
	  "ssmincidents": {
	    "prefix": "ssm-incidents",
	    "name": "SSMIncidents"
	  },
	  "applicationcostprofiler": {
	    "name": "ApplicationCostProfiler"
	  },
	  "apprunner": {
	    "name": "AppRunner"
	  },
	  "proton": {
	    "name": "Proton"
	  },
	  "route53recoverycluster": {
	    "prefix": "route53-recovery-cluster",
	    "name": "Route53RecoveryCluster"
	  },
	  "route53recoverycontrolconfig": {
	    "prefix": "route53-recovery-control-config",
	    "name": "Route53RecoveryControlConfig"
	  },
	  "route53recoveryreadiness": {
	    "prefix": "route53-recovery-readiness",
	    "name": "Route53RecoveryReadiness"
	  },
	  "chimesdkidentity": {
	    "prefix": "chime-sdk-identity",
	    "name": "ChimeSDKIdentity"
	  },
	  "chimesdkmessaging": {
	    "prefix": "chime-sdk-messaging",
	    "name": "ChimeSDKMessaging"
	  },
	  "snowdevicemanagement": {
	    "prefix": "snow-device-management",
	    "name": "SnowDeviceManagement"
	  },
	  "memorydb": {
	    "name": "MemoryDB"
	  },
	  "opensearch": {
	    "name": "OpenSearch"
	  },
	  "kafkaconnect": {
	    "name": "KafkaConnect"
	  },
	  "voiceid": {
	    "prefix": "voice-id",
	    "name": "VoiceID"
	  },
	  "wisdom": {
	    "name": "Wisdom"
	  },
	  "account": {
	    "name": "Account"
	  },
	  "cloudcontrol": {
	    "name": "CloudControl"
	  },
	  "grafana": {
	    "name": "Grafana"
	  },
	  "panorama": {
	    "name": "Panorama"
	  },
	  "chimesdkmeetings": {
	    "prefix": "chime-sdk-meetings",
	    "name": "ChimeSDKMeetings"
	  },
	  "resiliencehub": {
	    "name": "Resiliencehub"
	  },
	  "migrationhubstrategy": {
	    "name": "MigrationHubStrategy"
	  },
	  "appconfigdata": {
	    "name": "AppConfigData"
	  },
	  "drs": {
	    "name": "Drs"
	  },
	  "migrationhubrefactorspaces": {
	    "prefix": "migration-hub-refactor-spaces",
	    "name": "MigrationHubRefactorSpaces"
	  },
	  "evidently": {
	    "name": "Evidently"
	  },
	  "inspector2": {
	    "name": "Inspector2"
	  },
	  "rbin": {
	    "name": "Rbin"
	  },
	  "rum": {
	    "name": "RUM"
	  },
	  "backupgateway": {
	    "prefix": "backup-gateway",
	    "name": "BackupGateway"
	  },
	  "iottwinmaker": {
	    "name": "IoTTwinMaker"
	  },
	  "workspacesweb": {
	    "prefix": "workspaces-web",
	    "name": "WorkSpacesWeb"
	  },
	  "amplifyuibuilder": {
	    "name": "AmplifyUIBuilder"
	  },
	  "keyspaces": {
	    "name": "Keyspaces"
	  },
	  "billingconductor": {
	    "name": "Billingconductor"
	  },
	  "gamesparks": {
	    "name": "GameSparks"
	  },
	  "pinpointsmsvoicev2": {
	    "prefix": "pinpoint-sms-voice-v2",
	    "name": "PinpointSMSVoiceV2"
	  },
	  "ivschat": {
	    "name": "Ivschat"
	  },
	  "chimesdkmediapipelines": {
	    "prefix": "chime-sdk-media-pipelines",
	    "name": "ChimeSDKMediaPipelines"
	  },
	  "emrserverless": {
	    "prefix": "emr-serverless",
	    "name": "EMRServerless"
	  },
	  "m2": {
	    "name": "M2"
	  },
	  "connectcampaigns": {
	    "name": "ConnectCampaigns"
	  }
	}
	},{}],164:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-06-05",
	    "endpointPrefix": "mobileanalytics",
	    "serviceFullName": "Amazon Mobile Analytics",
	    "serviceId": "Mobile Analytics",
	    "signatureVersion": "v4",
	    "protocol": "rest-json"
	  },
	  "operations": {
	    "PutEvents": {
	      "http": {
	        "requestUri": "/2014-06-05/events",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "events",
	          "clientContext"
	        ],
	        "members": {
	          "events": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "eventType",
	                "timestamp"
	              ],
	              "members": {
	                "eventType": {},
	                "timestamp": {},
	                "session": {
	                  "type": "structure",
	                  "members": {
	                    "id": {},
	                    "duration": {
	                      "type": "long"
	                    },
	                    "startTimestamp": {},
	                    "stopTimestamp": {}
	                  }
	                },
	                "version": {},
	                "attributes": {
	                  "type": "map",
	                  "key": {},
	                  "value": {}
	                },
	                "metrics": {
	                  "type": "map",
	                  "key": {},
	                  "value": {
	                    "type": "double"
	                  }
	                }
	              }
	            }
	          },
	          "clientContext": {
	            "location": "header",
	            "locationName": "x-amz-Client-Context"
	          },
	          "clientContextEncoding": {
	            "location": "header",
	            "locationName": "x-amz-Client-Context-Encoding"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {}
	}
	},{}],165:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2010-08-01",
	    "endpointPrefix": "monitoring",
	    "protocol": "query",
	    "serviceAbbreviation": "CloudWatch",
	    "serviceFullName": "Amazon CloudWatch",
	    "serviceId": "CloudWatch",
	    "signatureVersion": "v4",
	    "uid": "monitoring-2010-08-01",
	    "xmlNamespace": "http://monitoring.amazonaws.com/doc/2010-08-01/"
	  },
	  "operations": {
	    "DeleteAlarms": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AlarmNames"
	        ],
	        "members": {
	          "AlarmNames": {
	            "shape": "S2"
	          }
	        }
	      }
	    },
	    "DeleteAnomalyDetector": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Namespace": {
	            "deprecated": true,
	            "deprecatedMessage": "Use SingleMetricAnomalyDetector."
	          },
	          "MetricName": {
	            "deprecated": true,
	            "deprecatedMessage": "Use SingleMetricAnomalyDetector."
	          },
	          "Dimensions": {
	            "shape": "S7",
	            "deprecated": true,
	            "deprecatedMessage": "Use SingleMetricAnomalyDetector."
	          },
	          "Stat": {
	            "deprecated": true,
	            "deprecatedMessage": "Use SingleMetricAnomalyDetector."
	          },
	          "SingleMetricAnomalyDetector": {
	            "shape": "Sc"
	          },
	          "MetricMathAnomalyDetector": {
	            "shape": "Sd"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteAnomalyDetectorResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteDashboards": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DashboardNames"
	        ],
	        "members": {
	          "DashboardNames": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDashboardsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteInsightRules": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleNames"
	        ],
	        "members": {
	          "RuleNames": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteInsightRulesResult",
	        "type": "structure",
	        "members": {
	          "Failures": {
	            "shape": "Sz"
	          }
	        }
	      }
	    },
	    "DeleteMetricStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteMetricStreamResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeAlarmHistory": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AlarmName": {},
	          "AlarmTypes": {
	            "shape": "S19"
	          },
	          "HistoryItemType": {},
	          "StartDate": {
	            "type": "timestamp"
	          },
	          "EndDate": {
	            "type": "timestamp"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "ScanBy": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeAlarmHistoryResult",
	        "type": "structure",
	        "members": {
	          "AlarmHistoryItems": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AlarmName": {},
	                "AlarmType": {},
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "HistoryItemType": {},
	                "HistorySummary": {},
	                "HistoryData": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAlarms": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AlarmNames": {
	            "shape": "S2"
	          },
	          "AlarmNamePrefix": {},
	          "AlarmTypes": {
	            "shape": "S19"
	          },
	          "ChildrenOfAlarmName": {},
	          "ParentsOfAlarmName": {},
	          "StateValue": {},
	          "ActionPrefix": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeAlarmsResult",
	        "type": "structure",
	        "members": {
	          "CompositeAlarms": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ActionsEnabled": {
	                  "type": "boolean"
	                },
	                "AlarmActions": {
	                  "shape": "S1t"
	                },
	                "AlarmArn": {},
	                "AlarmConfigurationUpdatedTimestamp": {
	                  "type": "timestamp"
	                },
	                "AlarmDescription": {},
	                "AlarmName": {},
	                "AlarmRule": {},
	                "InsufficientDataActions": {
	                  "shape": "S1t"
	                },
	                "OKActions": {
	                  "shape": "S1t"
	                },
	                "StateReason": {},
	                "StateReasonData": {},
	                "StateUpdatedTimestamp": {
	                  "type": "timestamp"
	                },
	                "StateValue": {}
	              },
	              "xmlOrder": [
	                "ActionsEnabled",
	                "AlarmActions",
	                "AlarmArn",
	                "AlarmConfigurationUpdatedTimestamp",
	                "AlarmDescription",
	                "AlarmName",
	                "AlarmRule",
	                "InsufficientDataActions",
	                "OKActions",
	                "StateReason",
	                "StateReasonData",
	                "StateUpdatedTimestamp",
	                "StateValue"
	              ]
	            }
	          },
	          "MetricAlarms": {
	            "shape": "S20"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAlarmsForMetric": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MetricName",
	          "Namespace"
	        ],
	        "members": {
	          "MetricName": {},
	          "Namespace": {},
	          "Statistic": {},
	          "ExtendedStatistic": {},
	          "Dimensions": {
	            "shape": "S7"
	          },
	          "Period": {
	            "type": "integer"
	          },
	          "Unit": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeAlarmsForMetricResult",
	        "type": "structure",
	        "members": {
	          "MetricAlarms": {
	            "shape": "S20"
	          }
	        }
	      }
	    },
	    "DescribeAnomalyDetectors": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Namespace": {},
	          "MetricName": {},
	          "Dimensions": {
	            "shape": "S7"
	          },
	          "AnomalyDetectorTypes": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeAnomalyDetectorsResult",
	        "type": "structure",
	        "members": {
	          "AnomalyDetectors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Namespace": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Use SingleMetricAnomalyDetector.Namespace property."
	                },
	                "MetricName": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Use SingleMetricAnomalyDetector.MetricName property."
	                },
	                "Dimensions": {
	                  "shape": "S7",
	                  "deprecated": true,
	                  "deprecatedMessage": "Use SingleMetricAnomalyDetector.Dimensions property."
	                },
	                "Stat": {
	                  "deprecated": true,
	                  "deprecatedMessage": "Use SingleMetricAnomalyDetector.Stat property."
	                },
	                "Configuration": {
	                  "shape": "S2j"
	                },
	                "StateValue": {},
	                "SingleMetricAnomalyDetector": {
	                  "shape": "Sc"
	                },
	                "MetricMathAnomalyDetector": {
	                  "shape": "Sd"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeInsightRules": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeInsightRulesResult",
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "InsightRules": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Name",
	                "State",
	                "Schema",
	                "Definition"
	              ],
	              "members": {
	                "Name": {},
	                "State": {},
	                "Schema": {},
	                "Definition": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DisableAlarmActions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AlarmNames"
	        ],
	        "members": {
	          "AlarmNames": {
	            "shape": "S2"
	          }
	        }
	      }
	    },
	    "DisableInsightRules": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleNames"
	        ],
	        "members": {
	          "RuleNames": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DisableInsightRulesResult",
	        "type": "structure",
	        "members": {
	          "Failures": {
	            "shape": "Sz"
	          }
	        }
	      }
	    },
	    "EnableAlarmActions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AlarmNames"
	        ],
	        "members": {
	          "AlarmNames": {
	            "shape": "S2"
	          }
	        }
	      }
	    },
	    "EnableInsightRules": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleNames"
	        ],
	        "members": {
	          "RuleNames": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "EnableInsightRulesResult",
	        "type": "structure",
	        "members": {
	          "Failures": {
	            "shape": "Sz"
	          }
	        }
	      }
	    },
	    "GetDashboard": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DashboardName"
	        ],
	        "members": {
	          "DashboardName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetDashboardResult",
	        "type": "structure",
	        "members": {
	          "DashboardArn": {},
	          "DashboardBody": {},
	          "DashboardName": {}
	        }
	      }
	    },
	    "GetInsightRuleReport": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleName",
	          "StartTime",
	          "EndTime",
	          "Period"
	        ],
	        "members": {
	          "RuleName": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Period": {
	            "type": "integer"
	          },
	          "MaxContributorCount": {
	            "type": "integer"
	          },
	          "Metrics": {
	            "type": "list",
	            "member": {}
	          },
	          "OrderBy": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetInsightRuleReportResult",
	        "type": "structure",
	        "members": {
	          "KeyLabels": {
	            "type": "list",
	            "member": {}
	          },
	          "AggregationStatistic": {},
	          "AggregateValue": {
	            "type": "double"
	          },
	          "ApproximateUniqueCount": {
	            "type": "long"
	          },
	          "Contributors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Keys",
	                "ApproximateAggregateValue",
	                "Datapoints"
	              ],
	              "members": {
	                "Keys": {
	                  "type": "list",
	                  "member": {}
	                },
	                "ApproximateAggregateValue": {
	                  "type": "double"
	                },
	                "Datapoints": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "required": [
	                      "Timestamp",
	                      "ApproximateValue"
	                    ],
	                    "members": {
	                      "Timestamp": {
	                        "type": "timestamp"
	                      },
	                      "ApproximateValue": {
	                        "type": "double"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "MetricDatapoints": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Timestamp"
	              ],
	              "members": {
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "UniqueContributors": {
	                  "type": "double"
	                },
	                "MaxContributorValue": {
	                  "type": "double"
	                },
	                "SampleCount": {
	                  "type": "double"
	                },
	                "Average": {
	                  "type": "double"
	                },
	                "Sum": {
	                  "type": "double"
	                },
	                "Minimum": {
	                  "type": "double"
	                },
	                "Maximum": {
	                  "type": "double"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetMetricData": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MetricDataQueries",
	          "StartTime",
	          "EndTime"
	        ],
	        "members": {
	          "MetricDataQueries": {
	            "shape": "Se"
	          },
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "NextToken": {},
	          "ScanBy": {},
	          "MaxDatapoints": {
	            "type": "integer"
	          },
	          "LabelOptions": {
	            "type": "structure",
	            "members": {
	              "Timezone": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetMetricDataResult",
	        "type": "structure",
	        "members": {
	          "MetricDataResults": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Label": {},
	                "Timestamps": {
	                  "type": "list",
	                  "member": {
	                    "type": "timestamp"
	                  }
	                },
	                "Values": {
	                  "type": "list",
	                  "member": {
	                    "type": "double"
	                  }
	                },
	                "StatusCode": {},
	                "Messages": {
	                  "shape": "S40"
	                }
	              }
	            }
	          },
	          "NextToken": {},
	          "Messages": {
	            "shape": "S40"
	          }
	        }
	      }
	    },
	    "GetMetricStatistics": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Namespace",
	          "MetricName",
	          "StartTime",
	          "EndTime",
	          "Period"
	        ],
	        "members": {
	          "Namespace": {},
	          "MetricName": {},
	          "Dimensions": {
	            "shape": "S7"
	          },
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Period": {
	            "type": "integer"
	          },
	          "Statistics": {
	            "type": "list",
	            "member": {}
	          },
	          "ExtendedStatistics": {
	            "type": "list",
	            "member": {}
	          },
	          "Unit": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetMetricStatisticsResult",
	        "type": "structure",
	        "members": {
	          "Label": {},
	          "Datapoints": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "SampleCount": {
	                  "type": "double"
	                },
	                "Average": {
	                  "type": "double"
	                },
	                "Sum": {
	                  "type": "double"
	                },
	                "Minimum": {
	                  "type": "double"
	                },
	                "Maximum": {
	                  "type": "double"
	                },
	                "Unit": {},
	                "ExtendedStatistics": {
	                  "type": "map",
	                  "key": {},
	                  "value": {
	                    "type": "double"
	                  }
	                }
	              },
	              "xmlOrder": [
	                "Timestamp",
	                "SampleCount",
	                "Average",
	                "Sum",
	                "Minimum",
	                "Maximum",
	                "Unit",
	                "ExtendedStatistics"
	              ]
	            }
	          }
	        }
	      }
	    },
	    "GetMetricStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetMetricStreamResult",
	        "type": "structure",
	        "members": {
	          "Arn": {},
	          "Name": {},
	          "IncludeFilters": {
	            "shape": "S4e"
	          },
	          "ExcludeFilters": {
	            "shape": "S4e"
	          },
	          "FirehoseArn": {},
	          "RoleArn": {},
	          "State": {},
	          "CreationDate": {
	            "type": "timestamp"
	          },
	          "LastUpdateDate": {
	            "type": "timestamp"
	          },
	          "OutputFormat": {},
	          "StatisticsConfigurations": {
	            "shape": "S4i"
	          }
	        }
	      }
	    },
	    "GetMetricWidgetImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MetricWidget"
	        ],
	        "members": {
	          "MetricWidget": {},
	          "OutputFormat": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetMetricWidgetImageResult",
	        "type": "structure",
	        "members": {
	          "MetricWidgetImage": {
	            "type": "blob"
	          }
	        }
	      }
	    },
	    "ListDashboards": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DashboardNamePrefix": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListDashboardsResult",
	        "type": "structure",
	        "members": {
	          "DashboardEntries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DashboardName": {},
	                "DashboardArn": {},
	                "LastModified": {
	                  "type": "timestamp"
	                },
	                "Size": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListMetricStreams": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListMetricStreamsResult",
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "Entries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Arn": {},
	                "CreationDate": {
	                  "type": "timestamp"
	                },
	                "LastUpdateDate": {
	                  "type": "timestamp"
	                },
	                "Name": {},
	                "FirehoseArn": {},
	                "State": {},
	                "OutputFormat": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListMetrics": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Namespace": {},
	          "MetricName": {},
	          "Dimensions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Name"
	              ],
	              "members": {
	                "Name": {},
	                "Value": {}
	              }
	            }
	          },
	          "NextToken": {},
	          "RecentlyActive": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListMetricsResult",
	        "type": "structure",
	        "members": {
	          "Metrics": {
	            "type": "list",
	            "member": {
	              "shape": "Si"
	            }
	          },
	          "NextToken": {}
	        },
	        "xmlOrder": [
	          "Metrics",
	          "NextToken"
	        ]
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN"
	        ],
	        "members": {
	          "ResourceARN": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTagsForResourceResult",
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S5d"
	          }
	        }
	      }
	    },
	    "PutAnomalyDetector": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Namespace": {
	            "deprecated": true,
	            "deprecatedMessage": "Use SingleMetricAnomalyDetector."
	          },
	          "MetricName": {
	            "deprecated": true,
	            "deprecatedMessage": "Use SingleMetricAnomalyDetector."
	          },
	          "Dimensions": {
	            "shape": "S7",
	            "deprecated": true,
	            "deprecatedMessage": "Use SingleMetricAnomalyDetector."
	          },
	          "Stat": {
	            "deprecated": true,
	            "deprecatedMessage": "Use SingleMetricAnomalyDetector."
	          },
	          "Configuration": {
	            "shape": "S2j"
	          },
	          "SingleMetricAnomalyDetector": {
	            "shape": "Sc"
	          },
	          "MetricMathAnomalyDetector": {
	            "shape": "Sd"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PutAnomalyDetectorResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "PutCompositeAlarm": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AlarmName",
	          "AlarmRule"
	        ],
	        "members": {
	          "ActionsEnabled": {
	            "type": "boolean"
	          },
	          "AlarmActions": {
	            "shape": "S1t"
	          },
	          "AlarmDescription": {},
	          "AlarmName": {},
	          "AlarmRule": {},
	          "InsufficientDataActions": {
	            "shape": "S1t"
	          },
	          "OKActions": {
	            "shape": "S1t"
	          },
	          "Tags": {
	            "shape": "S5d"
	          }
	        }
	      }
	    },
	    "PutDashboard": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DashboardName",
	          "DashboardBody"
	        ],
	        "members": {
	          "DashboardName": {},
	          "DashboardBody": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "PutDashboardResult",
	        "type": "structure",
	        "members": {
	          "DashboardValidationMessages": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DataPath": {},
	                "Message": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutInsightRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleName",
	          "RuleDefinition"
	        ],
	        "members": {
	          "RuleName": {},
	          "RuleState": {},
	          "RuleDefinition": {},
	          "Tags": {
	            "shape": "S5d"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PutInsightRuleResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "PutMetricAlarm": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AlarmName",
	          "EvaluationPeriods",
	          "ComparisonOperator"
	        ],
	        "members": {
	          "AlarmName": {},
	          "AlarmDescription": {},
	          "ActionsEnabled": {
	            "type": "boolean"
	          },
	          "OKActions": {
	            "shape": "S1t"
	          },
	          "AlarmActions": {
	            "shape": "S1t"
	          },
	          "InsufficientDataActions": {
	            "shape": "S1t"
	          },
	          "MetricName": {},
	          "Namespace": {},
	          "Statistic": {},
	          "ExtendedStatistic": {},
	          "Dimensions": {
	            "shape": "S7"
	          },
	          "Period": {
	            "type": "integer"
	          },
	          "Unit": {},
	          "EvaluationPeriods": {
	            "type": "integer"
	          },
	          "DatapointsToAlarm": {
	            "type": "integer"
	          },
	          "Threshold": {
	            "type": "double"
	          },
	          "ComparisonOperator": {},
	          "TreatMissingData": {},
	          "EvaluateLowSampleCountPercentile": {},
	          "Metrics": {
	            "shape": "Se"
	          },
	          "Tags": {
	            "shape": "S5d"
	          },
	          "ThresholdMetricId": {}
	        }
	      }
	    },
	    "PutMetricData": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Namespace",
	          "MetricData"
	        ],
	        "members": {
	          "Namespace": {},
	          "MetricData": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "MetricName"
	              ],
	              "members": {
	                "MetricName": {},
	                "Dimensions": {
	                  "shape": "S7"
	                },
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "Value": {
	                  "type": "double"
	                },
	                "StatisticValues": {
	                  "type": "structure",
	                  "required": [
	                    "SampleCount",
	                    "Sum",
	                    "Minimum",
	                    "Maximum"
	                  ],
	                  "members": {
	                    "SampleCount": {
	                      "type": "double"
	                    },
	                    "Sum": {
	                      "type": "double"
	                    },
	                    "Minimum": {
	                      "type": "double"
	                    },
	                    "Maximum": {
	                      "type": "double"
	                    }
	                  }
	                },
	                "Values": {
	                  "type": "list",
	                  "member": {
	                    "type": "double"
	                  }
	                },
	                "Counts": {
	                  "type": "list",
	                  "member": {
	                    "type": "double"
	                  }
	                },
	                "Unit": {},
	                "StorageResolution": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutMetricStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "FirehoseArn",
	          "RoleArn",
	          "OutputFormat"
	        ],
	        "members": {
	          "Name": {},
	          "IncludeFilters": {
	            "shape": "S4e"
	          },
	          "ExcludeFilters": {
	            "shape": "S4e"
	          },
	          "FirehoseArn": {},
	          "RoleArn": {},
	          "OutputFormat": {},
	          "Tags": {
	            "shape": "S5d"
	          },
	          "StatisticsConfigurations": {
	            "shape": "S4i"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PutMetricStreamResult",
	        "type": "structure",
	        "members": {
	          "Arn": {}
	        }
	      }
	    },
	    "SetAlarmState": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AlarmName",
	          "StateValue",
	          "StateReason"
	        ],
	        "members": {
	          "AlarmName": {},
	          "StateValue": {},
	          "StateReason": {},
	          "StateReasonData": {}
	        }
	      }
	    },
	    "StartMetricStreams": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Names"
	        ],
	        "members": {
	          "Names": {
	            "shape": "S64"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "StartMetricStreamsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "StopMetricStreams": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Names"
	        ],
	        "members": {
	          "Names": {
	            "shape": "S64"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "StopMetricStreamsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "Tags"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "Tags": {
	            "shape": "S5d"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "TagResourceResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "UntagResourceResult",
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "list",
	      "member": {}
	    },
	    "S7": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Value"
	        ],
	        "members": {
	          "Name": {},
	          "Value": {}
	        },
	        "xmlOrder": [
	          "Name",
	          "Value"
	        ]
	      }
	    },
	    "Sc": {
	      "type": "structure",
	      "members": {
	        "Namespace": {},
	        "MetricName": {},
	        "Dimensions": {
	          "shape": "S7"
	        },
	        "Stat": {}
	      }
	    },
	    "Sd": {
	      "type": "structure",
	      "members": {
	        "MetricDataQueries": {
	          "shape": "Se"
	        }
	      }
	    },
	    "Se": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {},
	          "MetricStat": {
	            "type": "structure",
	            "required": [
	              "Metric",
	              "Period",
	              "Stat"
	            ],
	            "members": {
	              "Metric": {
	                "shape": "Si"
	              },
	              "Period": {
	                "type": "integer"
	              },
	              "Stat": {},
	              "Unit": {}
	            }
	          },
	          "Expression": {},
	          "Label": {},
	          "ReturnData": {
	            "type": "boolean"
	          },
	          "Period": {
	            "type": "integer"
	          },
	          "AccountId": {}
	        }
	      }
	    },
	    "Si": {
	      "type": "structure",
	      "members": {
	        "Namespace": {},
	        "MetricName": {},
	        "Dimensions": {
	          "shape": "S7"
	        }
	      },
	      "xmlOrder": [
	        "Namespace",
	        "MetricName",
	        "Dimensions"
	      ]
	    },
	    "Sw": {
	      "type": "list",
	      "member": {}
	    },
	    "Sz": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "FailureResource": {},
	          "ExceptionType": {},
	          "FailureCode": {},
	          "FailureDescription": {}
	        }
	      }
	    },
	    "S19": {
	      "type": "list",
	      "member": {}
	    },
	    "S1t": {
	      "type": "list",
	      "member": {}
	    },
	    "S20": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "AlarmName": {},
	          "AlarmArn": {},
	          "AlarmDescription": {},
	          "AlarmConfigurationUpdatedTimestamp": {
	            "type": "timestamp"
	          },
	          "ActionsEnabled": {
	            "type": "boolean"
	          },
	          "OKActions": {
	            "shape": "S1t"
	          },
	          "AlarmActions": {
	            "shape": "S1t"
	          },
	          "InsufficientDataActions": {
	            "shape": "S1t"
	          },
	          "StateValue": {},
	          "StateReason": {},
	          "StateReasonData": {},
	          "StateUpdatedTimestamp": {
	            "type": "timestamp"
	          },
	          "MetricName": {},
	          "Namespace": {},
	          "Statistic": {},
	          "ExtendedStatistic": {},
	          "Dimensions": {
	            "shape": "S7"
	          },
	          "Period": {
	            "type": "integer"
	          },
	          "Unit": {},
	          "EvaluationPeriods": {
	            "type": "integer"
	          },
	          "DatapointsToAlarm": {
	            "type": "integer"
	          },
	          "Threshold": {
	            "type": "double"
	          },
	          "ComparisonOperator": {},
	          "TreatMissingData": {},
	          "EvaluateLowSampleCountPercentile": {},
	          "Metrics": {
	            "shape": "Se"
	          },
	          "ThresholdMetricId": {}
	        },
	        "xmlOrder": [
	          "AlarmName",
	          "AlarmArn",
	          "AlarmDescription",
	          "AlarmConfigurationUpdatedTimestamp",
	          "ActionsEnabled",
	          "OKActions",
	          "AlarmActions",
	          "InsufficientDataActions",
	          "StateValue",
	          "StateReason",
	          "StateReasonData",
	          "StateUpdatedTimestamp",
	          "MetricName",
	          "Namespace",
	          "Statistic",
	          "Dimensions",
	          "Period",
	          "Unit",
	          "EvaluationPeriods",
	          "Threshold",
	          "ComparisonOperator",
	          "ExtendedStatistic",
	          "TreatMissingData",
	          "EvaluateLowSampleCountPercentile",
	          "DatapointsToAlarm",
	          "Metrics",
	          "ThresholdMetricId"
	        ]
	      }
	    },
	    "S2j": {
	      "type": "structure",
	      "members": {
	        "ExcludedTimeRanges": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "StartTime",
	              "EndTime"
	            ],
	            "members": {
	              "StartTime": {
	                "type": "timestamp"
	              },
	              "EndTime": {
	                "type": "timestamp"
	              }
	            },
	            "xmlOrder": [
	              "StartTime",
	              "EndTime"
	            ]
	          }
	        },
	        "MetricTimezone": {}
	      }
	    },
	    "S40": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Code": {},
	          "Value": {}
	        }
	      }
	    },
	    "S4e": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Namespace": {}
	        }
	      }
	    },
	    "S4i": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "IncludeMetrics",
	          "AdditionalStatistics"
	        ],
	        "members": {
	          "IncludeMetrics": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Namespace",
	                "MetricName"
	              ],
	              "members": {
	                "Namespace": {},
	                "MetricName": {}
	              }
	            }
	          },
	          "AdditionalStatistics": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "S5d": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S64": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],166:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeAlarmHistory": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": "AlarmHistoryItems"
	    },
	    "DescribeAlarms": {
	      "input_token": "NextToken",
	      "limit_key": "MaxRecords",
	      "output_token": "NextToken",
	      "result_key": [
	        "MetricAlarms",
	        "CompositeAlarms"
	      ]
	    },
	    "DescribeAlarmsForMetric": {
	      "result_key": "MetricAlarms"
	    },
	    "DescribeInsightRules": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetMetricData": {
	      "input_token": "NextToken",
	      "limit_key": "MaxDatapoints",
	      "output_token": "NextToken",
	      "result_key": [
	        "MetricDataResults",
	        "Messages"
	      ]
	    },
	    "ListDashboards": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "DashboardEntries"
	    },
	    "ListMetricStreams": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListMetrics": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Metrics"
	    }
	  }
	}
	},{}],167:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "AlarmExists": {
	      "delay": 5,
	      "maxAttempts": 40,
	      "operation": "DescribeAlarms",
	      "acceptors": [
	        {
	          "matcher": "path",
	          "expected": true,
	          "argument": "length(MetricAlarms[]) > `0`",
	          "state": "success"
	        }
	      ]
	    },
	    "CompositeAlarmExists": {
	      "delay": 5,
	      "maxAttempts": 40,
	      "operation": "DescribeAlarms",
	      "acceptors": [
	        {
	          "matcher": "path",
	          "expected": true,
	          "argument": "length(CompositeAlarms[]) > `0`",
	          "state": "success"
	        }
	      ]
	    }
	  }
	}
	
	},{}],168:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-01-17",
	    "endpointPrefix": "mturk-requester",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "Amazon MTurk",
	    "serviceFullName": "Amazon Mechanical Turk",
	    "serviceId": "MTurk",
	    "signatureVersion": "v4",
	    "targetPrefix": "MTurkRequesterServiceV20170117",
	    "uid": "mturk-requester-2017-01-17"
	  },
	  "operations": {
	    "AcceptQualificationRequest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QualificationRequestId"
	        ],
	        "members": {
	          "QualificationRequestId": {},
	          "IntegerValue": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ApproveAssignment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssignmentId"
	        ],
	        "members": {
	          "AssignmentId": {},
	          "RequesterFeedback": {},
	          "OverrideRejection": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "AssociateQualificationWithWorker": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QualificationTypeId",
	          "WorkerId"
	        ],
	        "members": {
	          "QualificationTypeId": {},
	          "WorkerId": {},
	          "IntegerValue": {
	            "type": "integer"
	          },
	          "SendNotification": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateAdditionalAssignmentsForHIT": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HITId",
	          "NumberOfAdditionalAssignments"
	        ],
	        "members": {
	          "HITId": {},
	          "NumberOfAdditionalAssignments": {
	            "type": "integer"
	          },
	          "UniqueRequestToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateHIT": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LifetimeInSeconds",
	          "AssignmentDurationInSeconds",
	          "Reward",
	          "Title",
	          "Description"
	        ],
	        "members": {
	          "MaxAssignments": {
	            "type": "integer"
	          },
	          "AutoApprovalDelayInSeconds": {
	            "type": "long"
	          },
	          "LifetimeInSeconds": {
	            "type": "long"
	          },
	          "AssignmentDurationInSeconds": {
	            "type": "long"
	          },
	          "Reward": {},
	          "Title": {},
	          "Keywords": {},
	          "Description": {},
	          "Question": {},
	          "RequesterAnnotation": {},
	          "QualificationRequirements": {
	            "shape": "Si"
	          },
	          "UniqueRequestToken": {},
	          "AssignmentReviewPolicy": {
	            "shape": "Sq"
	          },
	          "HITReviewPolicy": {
	            "shape": "Sq"
	          },
	          "HITLayoutId": {},
	          "HITLayoutParameters": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HIT": {
	            "shape": "Sz"
	          }
	        }
	      }
	    },
	    "CreateHITType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssignmentDurationInSeconds",
	          "Reward",
	          "Title",
	          "Description"
	        ],
	        "members": {
	          "AutoApprovalDelayInSeconds": {
	            "type": "long"
	          },
	          "AssignmentDurationInSeconds": {
	            "type": "long"
	          },
	          "Reward": {},
	          "Title": {},
	          "Keywords": {},
	          "Description": {},
	          "QualificationRequirements": {
	            "shape": "Si"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HITTypeId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "CreateHITWithHITType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HITTypeId",
	          "LifetimeInSeconds"
	        ],
	        "members": {
	          "HITTypeId": {},
	          "MaxAssignments": {
	            "type": "integer"
	          },
	          "LifetimeInSeconds": {
	            "type": "long"
	          },
	          "Question": {},
	          "RequesterAnnotation": {},
	          "UniqueRequestToken": {},
	          "AssignmentReviewPolicy": {
	            "shape": "Sq"
	          },
	          "HITReviewPolicy": {
	            "shape": "Sq"
	          },
	          "HITLayoutId": {},
	          "HITLayoutParameters": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HIT": {
	            "shape": "Sz"
	          }
	        }
	      }
	    },
	    "CreateQualificationType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Description",
	          "QualificationTypeStatus"
	        ],
	        "members": {
	          "Name": {},
	          "Keywords": {},
	          "Description": {},
	          "QualificationTypeStatus": {},
	          "RetryDelayInSeconds": {
	            "type": "long"
	          },
	          "Test": {},
	          "AnswerKey": {},
	          "TestDurationInSeconds": {
	            "type": "long"
	          },
	          "AutoGranted": {
	            "type": "boolean"
	          },
	          "AutoGrantedValue": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QualificationType": {
	            "shape": "S1a"
	          }
	        }
	      }
	    },
	    "CreateWorkerBlock": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WorkerId",
	          "Reason"
	        ],
	        "members": {
	          "WorkerId": {},
	          "Reason": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteHIT": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HITId"
	        ],
	        "members": {
	          "HITId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "DeleteQualificationType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QualificationTypeId"
	        ],
	        "members": {
	          "QualificationTypeId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "DeleteWorkerBlock": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WorkerId"
	        ],
	        "members": {
	          "WorkerId": {},
	          "Reason": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "DisassociateQualificationFromWorker": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WorkerId",
	          "QualificationTypeId"
	        ],
	        "members": {
	          "WorkerId": {},
	          "QualificationTypeId": {},
	          "Reason": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "GetAccountBalance": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AvailableBalance": {},
	          "OnHoldBalance": {}
	        }
	      },
	      "idempotent": true
	    },
	    "GetAssignment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssignmentId"
	        ],
	        "members": {
	          "AssignmentId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Assignment": {
	            "shape": "S1p"
	          },
	          "HIT": {
	            "shape": "Sz"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "GetFileUploadURL": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssignmentId",
	          "QuestionIdentifier"
	        ],
	        "members": {
	          "AssignmentId": {},
	          "QuestionIdentifier": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileUploadURL": {}
	        }
	      },
	      "idempotent": true
	    },
	    "GetHIT": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HITId"
	        ],
	        "members": {
	          "HITId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HIT": {
	            "shape": "Sz"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "GetQualificationScore": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QualificationTypeId",
	          "WorkerId"
	        ],
	        "members": {
	          "QualificationTypeId": {},
	          "WorkerId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Qualification": {
	            "shape": "S1x"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "GetQualificationType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QualificationTypeId"
	        ],
	        "members": {
	          "QualificationTypeId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QualificationType": {
	            "shape": "S1a"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "ListAssignmentsForHIT": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HITId"
	        ],
	        "members": {
	          "HITId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "AssignmentStatuses": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "NumResults": {
	            "type": "integer"
	          },
	          "Assignments": {
	            "type": "list",
	            "member": {
	              "shape": "S1p"
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "ListBonusPayments": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "HITId": {},
	          "AssignmentId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NumResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "BonusPayments": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "WorkerId": {},
	                "BonusAmount": {},
	                "AssignmentId": {},
	                "Reason": {},
	                "GrantTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "ListHITs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "NumResults": {
	            "type": "integer"
	          },
	          "HITs": {
	            "shape": "S2d"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "ListHITsForQualificationType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QualificationTypeId"
	        ],
	        "members": {
	          "QualificationTypeId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "NumResults": {
	            "type": "integer"
	          },
	          "HITs": {
	            "shape": "S2d"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "ListQualificationRequests": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "QualificationTypeId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NumResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "QualificationRequests": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "QualificationRequestId": {},
	                "QualificationTypeId": {},
	                "WorkerId": {},
	                "Test": {},
	                "Answer": {},
	                "SubmitTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "ListQualificationTypes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "MustBeRequestable"
	        ],
	        "members": {
	          "Query": {},
	          "MustBeRequestable": {
	            "type": "boolean"
	          },
	          "MustBeOwnedByCaller": {
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NumResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "QualificationTypes": {
	            "type": "list",
	            "member": {
	              "shape": "S1a"
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "ListReviewPolicyResultsForHIT": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HITId"
	        ],
	        "members": {
	          "HITId": {},
	          "PolicyLevels": {
	            "type": "list",
	            "member": {}
	          },
	          "RetrieveActions": {
	            "type": "boolean"
	          },
	          "RetrieveResults": {
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "HITId": {},
	          "AssignmentReviewPolicy": {
	            "shape": "Sq"
	          },
	          "HITReviewPolicy": {
	            "shape": "Sq"
	          },
	          "AssignmentReviewReport": {
	            "shape": "S2r"
	          },
	          "HITReviewReport": {
	            "shape": "S2r"
	          },
	          "NextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListReviewableHITs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "HITTypeId": {},
	          "Status": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "NumResults": {
	            "type": "integer"
	          },
	          "HITs": {
	            "shape": "S2d"
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "ListWorkerBlocks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "NumResults": {
	            "type": "integer"
	          },
	          "WorkerBlocks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "WorkerId": {},
	                "Reason": {}
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "ListWorkersWithQualificationType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QualificationTypeId"
	        ],
	        "members": {
	          "QualificationTypeId": {},
	          "Status": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "NumResults": {
	            "type": "integer"
	          },
	          "Qualifications": {
	            "type": "list",
	            "member": {
	              "shape": "S1x"
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "NotifyWorkers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Subject",
	          "MessageText",
	          "WorkerIds"
	        ],
	        "members": {
	          "Subject": {},
	          "MessageText": {},
	          "WorkerIds": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NotifyWorkersFailureStatuses": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "NotifyWorkersFailureCode": {},
	                "NotifyWorkersFailureMessage": {},
	                "WorkerId": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "RejectAssignment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssignmentId",
	          "RequesterFeedback"
	        ],
	        "members": {
	          "AssignmentId": {},
	          "RequesterFeedback": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "RejectQualificationRequest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QualificationRequestId"
	        ],
	        "members": {
	          "QualificationRequestId": {},
	          "Reason": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SendBonus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WorkerId",
	          "BonusAmount",
	          "AssignmentId",
	          "Reason"
	        ],
	        "members": {
	          "WorkerId": {},
	          "BonusAmount": {},
	          "AssignmentId": {},
	          "Reason": {},
	          "UniqueRequestToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SendTestEventNotification": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Notification",
	          "TestEventType"
	        ],
	        "members": {
	          "Notification": {
	            "shape": "S3k"
	          },
	          "TestEventType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateExpirationForHIT": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HITId",
	          "ExpireAt"
	        ],
	        "members": {
	          "HITId": {},
	          "ExpireAt": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "UpdateHITReviewStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HITId"
	        ],
	        "members": {
	          "HITId": {},
	          "Revert": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "UpdateHITTypeOfHIT": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HITId",
	          "HITTypeId"
	        ],
	        "members": {
	          "HITId": {},
	          "HITTypeId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "UpdateNotificationSettings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HITTypeId"
	        ],
	        "members": {
	          "HITTypeId": {},
	          "Notification": {
	            "shape": "S3k"
	          },
	          "Active": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      },
	      "idempotent": true
	    },
	    "UpdateQualificationType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QualificationTypeId"
	        ],
	        "members": {
	          "QualificationTypeId": {},
	          "Description": {},
	          "QualificationTypeStatus": {},
	          "Test": {},
	          "AnswerKey": {},
	          "TestDurationInSeconds": {
	            "type": "long"
	          },
	          "RetryDelayInSeconds": {
	            "type": "long"
	          },
	          "AutoGranted": {
	            "type": "boolean"
	          },
	          "AutoGrantedValue": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "QualificationType": {
	            "shape": "S1a"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Si": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "QualificationTypeId",
	          "Comparator"
	        ],
	        "members": {
	          "QualificationTypeId": {},
	          "Comparator": {},
	          "IntegerValues": {
	            "type": "list",
	            "member": {
	              "type": "integer"
	            }
	          },
	          "LocaleValues": {
	            "type": "list",
	            "member": {
	              "shape": "Sn"
	            }
	          },
	          "RequiredToPreview": {
	            "deprecated": true,
	            "type": "boolean"
	          },
	          "ActionsGuarded": {}
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "required": [
	        "Country"
	      ],
	      "members": {
	        "Country": {},
	        "Subdivision": {}
	      }
	    },
	    "Sq": {
	      "type": "structure",
	      "required": [
	        "PolicyName"
	      ],
	      "members": {
	        "PolicyName": {},
	        "Parameters": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Key": {},
	              "Values": {
	                "shape": "St"
	              },
	              "MapEntries": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Key": {},
	                    "Values": {
	                      "shape": "St"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "St": {
	      "type": "list",
	      "member": {}
	    },
	    "Sw": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Value"
	        ],
	        "members": {
	          "Name": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sz": {
	      "type": "structure",
	      "members": {
	        "HITId": {},
	        "HITTypeId": {},
	        "HITGroupId": {},
	        "HITLayoutId": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "Title": {},
	        "Description": {},
	        "Question": {},
	        "Keywords": {},
	        "HITStatus": {},
	        "MaxAssignments": {
	          "type": "integer"
	        },
	        "Reward": {},
	        "AutoApprovalDelayInSeconds": {
	          "type": "long"
	        },
	        "Expiration": {
	          "type": "timestamp"
	        },
	        "AssignmentDurationInSeconds": {
	          "type": "long"
	        },
	        "RequesterAnnotation": {},
	        "QualificationRequirements": {
	          "shape": "Si"
	        },
	        "HITReviewStatus": {},
	        "NumberOfAssignmentsPending": {
	          "type": "integer"
	        },
	        "NumberOfAssignmentsAvailable": {
	          "type": "integer"
	        },
	        "NumberOfAssignmentsCompleted": {
	          "type": "integer"
	        }
	      }
	    },
	    "S1a": {
	      "type": "structure",
	      "members": {
	        "QualificationTypeId": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "Name": {},
	        "Description": {},
	        "Keywords": {},
	        "QualificationTypeStatus": {},
	        "Test": {},
	        "TestDurationInSeconds": {
	          "type": "long"
	        },
	        "AnswerKey": {},
	        "RetryDelayInSeconds": {
	          "type": "long"
	        },
	        "IsRequestable": {
	          "type": "boolean"
	        },
	        "AutoGranted": {
	          "type": "boolean"
	        },
	        "AutoGrantedValue": {
	          "type": "integer"
	        }
	      }
	    },
	    "S1p": {
	      "type": "structure",
	      "members": {
	        "AssignmentId": {},
	        "WorkerId": {},
	        "HITId": {},
	        "AssignmentStatus": {},
	        "AutoApprovalTime": {
	          "type": "timestamp"
	        },
	        "AcceptTime": {
	          "type": "timestamp"
	        },
	        "SubmitTime": {
	          "type": "timestamp"
	        },
	        "ApprovalTime": {
	          "type": "timestamp"
	        },
	        "RejectionTime": {
	          "type": "timestamp"
	        },
	        "Deadline": {
	          "type": "timestamp"
	        },
	        "Answer": {},
	        "RequesterFeedback": {}
	      }
	    },
	    "S1x": {
	      "type": "structure",
	      "members": {
	        "QualificationTypeId": {},
	        "WorkerId": {},
	        "GrantTime": {
	          "type": "timestamp"
	        },
	        "IntegerValue": {
	          "type": "integer"
	        },
	        "LocaleValue": {
	          "shape": "Sn"
	        },
	        "Status": {}
	      }
	    },
	    "S2d": {
	      "type": "list",
	      "member": {
	        "shape": "Sz"
	      }
	    },
	    "S2r": {
	      "type": "structure",
	      "members": {
	        "ReviewResults": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "ActionId": {},
	              "SubjectId": {},
	              "SubjectType": {},
	              "QuestionId": {},
	              "Key": {},
	              "Value": {}
	            }
	          }
	        },
	        "ReviewActions": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "ActionId": {},
	              "ActionName": {},
	              "TargetId": {},
	              "TargetType": {},
	              "Status": {},
	              "CompleteTime": {
	                "type": "timestamp"
	              },
	              "Result": {},
	              "ErrorCode": {}
	            }
	          }
	        }
	      }
	    },
	    "S3k": {
	      "type": "structure",
	      "required": [
	        "Destination",
	        "Transport",
	        "Version",
	        "EventTypes"
	      ],
	      "members": {
	        "Destination": {},
	        "Transport": {},
	        "Version": {},
	        "EventTypes": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    }
	  }
	}
	},{}],169:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListAssignmentsForHIT": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListBonusPayments": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListHITs": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListHITsForQualificationType": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListQualificationRequests": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListQualificationTypes": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListReviewPolicyResultsForHIT": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListReviewableHITs": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListWorkerBlocks": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListWorkersWithQualificationType": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    }
	  }
	}
	
	},{}],170:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2013-02-18",
	    "endpointPrefix": "opsworks",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "AWS OpsWorks",
	    "serviceId": "OpsWorks",
	    "signatureVersion": "v4",
	    "targetPrefix": "OpsWorks_20130218",
	    "uid": "opsworks-2013-02-18"
	  },
	  "operations": {
	    "AssignInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "LayerIds"
	        ],
	        "members": {
	          "InstanceId": {},
	          "LayerIds": {
	            "shape": "S3"
	          }
	        }
	      }
	    },
	    "AssignVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeId"
	        ],
	        "members": {
	          "VolumeId": {},
	          "InstanceId": {}
	        }
	      }
	    },
	    "AssociateElasticIp": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ElasticIp"
	        ],
	        "members": {
	          "ElasticIp": {},
	          "InstanceId": {}
	        }
	      }
	    },
	    "AttachElasticLoadBalancer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ElasticLoadBalancerName",
	          "LayerId"
	        ],
	        "members": {
	          "ElasticLoadBalancerName": {},
	          "LayerId": {}
	        }
	      }
	    },
	    "CloneStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceStackId",
	          "ServiceRoleArn"
	        ],
	        "members": {
	          "SourceStackId": {},
	          "Name": {},
	          "Region": {},
	          "VpcId": {},
	          "Attributes": {
	            "shape": "S8"
	          },
	          "ServiceRoleArn": {},
	          "DefaultInstanceProfileArn": {},
	          "DefaultOs": {},
	          "HostnameTheme": {},
	          "DefaultAvailabilityZone": {},
	          "DefaultSubnetId": {},
	          "CustomJson": {},
	          "ConfigurationManager": {
	            "shape": "Sa"
	          },
	          "ChefConfiguration": {
	            "shape": "Sb"
	          },
	          "UseCustomCookbooks": {
	            "type": "boolean"
	          },
	          "UseOpsworksSecurityGroups": {
	            "type": "boolean"
	          },
	          "CustomCookbooksSource": {
	            "shape": "Sd"
	          },
	          "DefaultSshKeyName": {},
	          "ClonePermissions": {
	            "type": "boolean"
	          },
	          "CloneAppIds": {
	            "shape": "S3"
	          },
	          "DefaultRootDeviceType": {},
	          "AgentVersion": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StackId": {}
	        }
	      }
	    },
	    "CreateApp": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId",
	          "Name",
	          "Type"
	        ],
	        "members": {
	          "StackId": {},
	          "Shortname": {},
	          "Name": {},
	          "Description": {},
	          "DataSources": {
	            "shape": "Si"
	          },
	          "Type": {},
	          "AppSource": {
	            "shape": "Sd"
	          },
	          "Domains": {
	            "shape": "S3"
	          },
	          "EnableSsl": {
	            "type": "boolean"
	          },
	          "SslConfiguration": {
	            "shape": "Sl"
	          },
	          "Attributes": {
	            "shape": "Sm"
	          },
	          "Environment": {
	            "shape": "So"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AppId": {}
	        }
	      }
	    },
	    "CreateDeployment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId",
	          "Command"
	        ],
	        "members": {
	          "StackId": {},
	          "AppId": {},
	          "InstanceIds": {
	            "shape": "S3"
	          },
	          "LayerIds": {
	            "shape": "S3"
	          },
	          "Command": {
	            "shape": "Ss"
	          },
	          "Comment": {},
	          "CustomJson": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeploymentId": {}
	        }
	      }
	    },
	    "CreateInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId",
	          "LayerIds",
	          "InstanceType"
	        ],
	        "members": {
	          "StackId": {},
	          "LayerIds": {
	            "shape": "S3"
	          },
	          "InstanceType": {},
	          "AutoScalingType": {},
	          "Hostname": {},
	          "Os": {},
	          "AmiId": {},
	          "SshKeyName": {},
	          "AvailabilityZone": {},
	          "VirtualizationType": {},
	          "SubnetId": {},
	          "Architecture": {},
	          "RootDeviceType": {},
	          "BlockDeviceMappings": {
	            "shape": "Sz"
	          },
	          "InstallUpdatesOnBoot": {
	            "type": "boolean"
	          },
	          "EbsOptimized": {
	            "type": "boolean"
	          },
	          "AgentVersion": {},
	          "Tenancy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {}
	        }
	      }
	    },
	    "CreateLayer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId",
	          "Type",
	          "Name",
	          "Shortname"
	        ],
	        "members": {
	          "StackId": {},
	          "Type": {},
	          "Name": {},
	          "Shortname": {},
	          "Attributes": {
	            "shape": "S17"
	          },
	          "CloudWatchLogsConfiguration": {
	            "shape": "S19"
	          },
	          "CustomInstanceProfileArn": {},
	          "CustomJson": {},
	          "CustomSecurityGroupIds": {
	            "shape": "S3"
	          },
	          "Packages": {
	            "shape": "S3"
	          },
	          "VolumeConfigurations": {
	            "shape": "S1f"
	          },
	          "EnableAutoHealing": {
	            "type": "boolean"
	          },
	          "AutoAssignElasticIps": {
	            "type": "boolean"
	          },
	          "AutoAssignPublicIps": {
	            "type": "boolean"
	          },
	          "CustomRecipes": {
	            "shape": "S1h"
	          },
	          "InstallUpdatesOnBoot": {
	            "type": "boolean"
	          },
	          "UseEbsOptimizedInstances": {
	            "type": "boolean"
	          },
	          "LifecycleEventConfiguration": {
	            "shape": "S1i"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LayerId": {}
	        }
	      }
	    },
	    "CreateStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Region",
	          "ServiceRoleArn",
	          "DefaultInstanceProfileArn"
	        ],
	        "members": {
	          "Name": {},
	          "Region": {},
	          "VpcId": {},
	          "Attributes": {
	            "shape": "S8"
	          },
	          "ServiceRoleArn": {},
	          "DefaultInstanceProfileArn": {},
	          "DefaultOs": {},
	          "HostnameTheme": {},
	          "DefaultAvailabilityZone": {},
	          "DefaultSubnetId": {},
	          "CustomJson": {},
	          "ConfigurationManager": {
	            "shape": "Sa"
	          },
	          "ChefConfiguration": {
	            "shape": "Sb"
	          },
	          "UseCustomCookbooks": {
	            "type": "boolean"
	          },
	          "UseOpsworksSecurityGroups": {
	            "type": "boolean"
	          },
	          "CustomCookbooksSource": {
	            "shape": "Sd"
	          },
	          "DefaultSshKeyName": {},
	          "DefaultRootDeviceType": {},
	          "AgentVersion": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StackId": {}
	        }
	      }
	    },
	    "CreateUserProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IamUserArn"
	        ],
	        "members": {
	          "IamUserArn": {},
	          "SshUsername": {},
	          "SshPublicKey": {},
	          "AllowSelfManagement": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IamUserArn": {}
	        }
	      }
	    },
	    "DeleteApp": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AppId"
	        ],
	        "members": {
	          "AppId": {}
	        }
	      }
	    },
	    "DeleteInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "DeleteElasticIp": {
	            "type": "boolean"
	          },
	          "DeleteVolumes": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "DeleteLayer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerId"
	        ],
	        "members": {
	          "LayerId": {}
	        }
	      }
	    },
	    "DeleteStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId"
	        ],
	        "members": {
	          "StackId": {}
	        }
	      }
	    },
	    "DeleteUserProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IamUserArn"
	        ],
	        "members": {
	          "IamUserArn": {}
	        }
	      }
	    },
	    "DeregisterEcsCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EcsClusterArn"
	        ],
	        "members": {
	          "EcsClusterArn": {}
	        }
	      }
	    },
	    "DeregisterElasticIp": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ElasticIp"
	        ],
	        "members": {
	          "ElasticIp": {}
	        }
	      }
	    },
	    "DeregisterInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {}
	        }
	      }
	    },
	    "DeregisterRdsDbInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RdsDbInstanceArn"
	        ],
	        "members": {
	          "RdsDbInstanceArn": {}
	        }
	      }
	    },
	    "DeregisterVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeId"
	        ],
	        "members": {
	          "VolumeId": {}
	        }
	      }
	    },
	    "DescribeAgentVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackId": {},
	          "ConfigurationManager": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AgentVersions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Version": {},
	                "ConfigurationManager": {
	                  "shape": "Sa"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeApps": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackId": {},
	          "AppIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Apps": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AppId": {},
	                "StackId": {},
	                "Shortname": {},
	                "Name": {},
	                "Description": {},
	                "DataSources": {
	                  "shape": "Si"
	                },
	                "Type": {},
	                "AppSource": {
	                  "shape": "Sd"
	                },
	                "Domains": {
	                  "shape": "S3"
	                },
	                "EnableSsl": {
	                  "type": "boolean"
	                },
	                "SslConfiguration": {
	                  "shape": "Sl"
	                },
	                "Attributes": {
	                  "shape": "Sm"
	                },
	                "CreatedAt": {},
	                "Environment": {
	                  "shape": "So"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeCommands": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DeploymentId": {},
	          "InstanceId": {},
	          "CommandIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Commands": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "CommandId": {},
	                "InstanceId": {},
	                "DeploymentId": {},
	                "CreatedAt": {},
	                "AcknowledgedAt": {},
	                "CompletedAt": {},
	                "Status": {},
	                "ExitCode": {
	                  "type": "integer"
	                },
	                "LogUrl": {},
	                "Type": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeDeployments": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackId": {},
	          "AppId": {},
	          "DeploymentIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Deployments": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DeploymentId": {},
	                "StackId": {},
	                "AppId": {},
	                "CreatedAt": {},
	                "CompletedAt": {},
	                "Duration": {
	                  "type": "integer"
	                },
	                "IamUserArn": {},
	                "Comment": {},
	                "Command": {
	                  "shape": "Ss"
	                },
	                "Status": {},
	                "CustomJson": {},
	                "InstanceIds": {
	                  "shape": "S3"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeEcsClusters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "EcsClusterArns": {
	            "shape": "S3"
	          },
	          "StackId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EcsClusters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EcsClusterArn": {},
	                "EcsClusterName": {},
	                "StackId": {},
	                "RegisteredAt": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeElasticIps": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {},
	          "StackId": {},
	          "Ips": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ElasticIps": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Ip": {},
	                "Name": {},
	                "Domain": {},
	                "Region": {},
	                "InstanceId": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeElasticLoadBalancers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackId": {},
	          "LayerIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ElasticLoadBalancers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ElasticLoadBalancerName": {},
	                "Region": {},
	                "DnsName": {},
	                "StackId": {},
	                "LayerId": {},
	                "VpcId": {},
	                "AvailabilityZones": {
	                  "shape": "S3"
	                },
	                "SubnetIds": {
	                  "shape": "S3"
	                },
	                "Ec2InstanceIds": {
	                  "shape": "S3"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackId": {},
	          "LayerId": {},
	          "InstanceIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Instances": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AgentVersion": {},
	                "AmiId": {},
	                "Architecture": {},
	                "Arn": {},
	                "AutoScalingType": {},
	                "AvailabilityZone": {},
	                "BlockDeviceMappings": {
	                  "shape": "Sz"
	                },
	                "CreatedAt": {},
	                "EbsOptimized": {
	                  "type": "boolean"
	                },
	                "Ec2InstanceId": {},
	                "EcsClusterArn": {},
	                "EcsContainerInstanceArn": {},
	                "ElasticIp": {},
	                "Hostname": {},
	                "InfrastructureClass": {},
	                "InstallUpdatesOnBoot": {
	                  "type": "boolean"
	                },
	                "InstanceId": {},
	                "InstanceProfileArn": {},
	                "InstanceType": {},
	                "LastServiceErrorId": {},
	                "LayerIds": {
	                  "shape": "S3"
	                },
	                "Os": {},
	                "Platform": {},
	                "PrivateDns": {},
	                "PrivateIp": {},
	                "PublicDns": {},
	                "PublicIp": {},
	                "RegisteredBy": {},
	                "ReportedAgentVersion": {},
	                "ReportedOs": {
	                  "type": "structure",
	                  "members": {
	                    "Family": {},
	                    "Name": {},
	                    "Version": {}
	                  }
	                },
	                "RootDeviceType": {},
	                "RootDeviceVolumeId": {},
	                "SecurityGroupIds": {
	                  "shape": "S3"
	                },
	                "SshHostDsaKeyFingerprint": {},
	                "SshHostRsaKeyFingerprint": {},
	                "SshKeyName": {},
	                "StackId": {},
	                "Status": {},
	                "SubnetId": {},
	                "Tenancy": {},
	                "VirtualizationType": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeLayers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackId": {},
	          "LayerIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Layers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Arn": {},
	                "StackId": {},
	                "LayerId": {},
	                "Type": {},
	                "Name": {},
	                "Shortname": {},
	                "Attributes": {
	                  "shape": "S17"
	                },
	                "CloudWatchLogsConfiguration": {
	                  "shape": "S19"
	                },
	                "CustomInstanceProfileArn": {},
	                "CustomJson": {},
	                "CustomSecurityGroupIds": {
	                  "shape": "S3"
	                },
	                "DefaultSecurityGroupNames": {
	                  "shape": "S3"
	                },
	                "Packages": {
	                  "shape": "S3"
	                },
	                "VolumeConfigurations": {
	                  "shape": "S1f"
	                },
	                "EnableAutoHealing": {
	                  "type": "boolean"
	                },
	                "AutoAssignElasticIps": {
	                  "type": "boolean"
	                },
	                "AutoAssignPublicIps": {
	                  "type": "boolean"
	                },
	                "DefaultRecipes": {
	                  "shape": "S1h"
	                },
	                "CustomRecipes": {
	                  "shape": "S1h"
	                },
	                "CreatedAt": {},
	                "InstallUpdatesOnBoot": {
	                  "type": "boolean"
	                },
	                "UseEbsOptimizedInstances": {
	                  "type": "boolean"
	                },
	                "LifecycleEventConfiguration": {
	                  "shape": "S1i"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeLoadBasedAutoScaling": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerIds"
	        ],
	        "members": {
	          "LayerIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LoadBasedAutoScalingConfigurations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "LayerId": {},
	                "Enable": {
	                  "type": "boolean"
	                },
	                "UpScaling": {
	                  "shape": "S36"
	                },
	                "DownScaling": {
	                  "shape": "S36"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeMyUserProfile": {
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserProfile": {
	            "type": "structure",
	            "members": {
	              "IamUserArn": {},
	              "Name": {},
	              "SshUsername": {},
	              "SshPublicKey": {}
	            }
	          }
	        }
	      }
	    },
	    "DescribeOperatingSystems": {
	      "output": {
	        "type": "structure",
	        "members": {
	          "OperatingSystems": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Id": {},
	                "Type": {},
	                "ConfigurationManagers": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Name": {},
	                      "Version": {}
	                    }
	                  }
	                },
	                "ReportedName": {},
	                "ReportedVersion": {},
	                "Supported": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribePermissions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "IamUserArn": {},
	          "StackId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Permissions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "StackId": {},
	                "IamUserArn": {},
	                "AllowSsh": {
	                  "type": "boolean"
	                },
	                "AllowSudo": {
	                  "type": "boolean"
	                },
	                "Level": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeRaidArrays": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {},
	          "StackId": {},
	          "RaidArrayIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RaidArrays": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "RaidArrayId": {},
	                "InstanceId": {},
	                "Name": {},
	                "RaidLevel": {
	                  "type": "integer"
	                },
	                "NumberOfDisks": {
	                  "type": "integer"
	                },
	                "Size": {
	                  "type": "integer"
	                },
	                "Device": {},
	                "MountPoint": {},
	                "AvailabilityZone": {},
	                "CreatedAt": {},
	                "StackId": {},
	                "VolumeType": {},
	                "Iops": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeRdsDbInstances": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId"
	        ],
	        "members": {
	          "StackId": {},
	          "RdsDbInstanceArns": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RdsDbInstances": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "RdsDbInstanceArn": {},
	                "DbInstanceIdentifier": {},
	                "DbUser": {},
	                "DbPassword": {},
	                "Region": {},
	                "Address": {},
	                "Engine": {},
	                "StackId": {},
	                "MissingOnRds": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeServiceErrors": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackId": {},
	          "InstanceId": {},
	          "ServiceErrorIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceErrors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ServiceErrorId": {},
	                "StackId": {},
	                "InstanceId": {},
	                "Type": {},
	                "Message": {},
	                "CreatedAt": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeStackProvisioningParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId"
	        ],
	        "members": {
	          "StackId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AgentInstallerUrl": {},
	          "Parameters": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          }
	        }
	      }
	    },
	    "DescribeStackSummary": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId"
	        ],
	        "members": {
	          "StackId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StackSummary": {
	            "type": "structure",
	            "members": {
	              "StackId": {},
	              "Name": {},
	              "Arn": {},
	              "LayersCount": {
	                "type": "integer"
	              },
	              "AppsCount": {
	                "type": "integer"
	              },
	              "InstancesCount": {
	                "type": "structure",
	                "members": {
	                  "Assigning": {
	                    "type": "integer"
	                  },
	                  "Booting": {
	                    "type": "integer"
	                  },
	                  "ConnectionLost": {
	                    "type": "integer"
	                  },
	                  "Deregistering": {
	                    "type": "integer"
	                  },
	                  "Online": {
	                    "type": "integer"
	                  },
	                  "Pending": {
	                    "type": "integer"
	                  },
	                  "Rebooting": {
	                    "type": "integer"
	                  },
	                  "Registered": {
	                    "type": "integer"
	                  },
	                  "Registering": {
	                    "type": "integer"
	                  },
	                  "Requested": {
	                    "type": "integer"
	                  },
	                  "RunningSetup": {
	                    "type": "integer"
	                  },
	                  "SetupFailed": {
	                    "type": "integer"
	                  },
	                  "ShuttingDown": {
	                    "type": "integer"
	                  },
	                  "StartFailed": {
	                    "type": "integer"
	                  },
	                  "StopFailed": {
	                    "type": "integer"
	                  },
	                  "Stopped": {
	                    "type": "integer"
	                  },
	                  "Stopping": {
	                    "type": "integer"
	                  },
	                  "Terminated": {
	                    "type": "integer"
	                  },
	                  "Terminating": {
	                    "type": "integer"
	                  },
	                  "Unassigning": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeStacks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "StackIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Stacks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "StackId": {},
	                "Name": {},
	                "Arn": {},
	                "Region": {},
	                "VpcId": {},
	                "Attributes": {
	                  "shape": "S8"
	                },
	                "ServiceRoleArn": {},
	                "DefaultInstanceProfileArn": {},
	                "DefaultOs": {},
	                "HostnameTheme": {},
	                "DefaultAvailabilityZone": {},
	                "DefaultSubnetId": {},
	                "CustomJson": {},
	                "ConfigurationManager": {
	                  "shape": "Sa"
	                },
	                "ChefConfiguration": {
	                  "shape": "Sb"
	                },
	                "UseCustomCookbooks": {
	                  "type": "boolean"
	                },
	                "UseOpsworksSecurityGroups": {
	                  "type": "boolean"
	                },
	                "CustomCookbooksSource": {
	                  "shape": "Sd"
	                },
	                "DefaultSshKeyName": {},
	                "CreatedAt": {},
	                "DefaultRootDeviceType": {},
	                "AgentVersion": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeTimeBasedAutoScaling": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceIds"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TimeBasedAutoScalingConfigurations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "InstanceId": {},
	                "AutoScalingSchedule": {
	                  "shape": "S4b"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeUserProfiles": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "IamUserArns": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserProfiles": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "IamUserArn": {},
	                "Name": {},
	                "SshUsername": {},
	                "SshPublicKey": {},
	                "AllowSelfManagement": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeVolumes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {},
	          "StackId": {},
	          "RaidArrayId": {},
	          "VolumeIds": {
	            "shape": "S3"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Volumes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "VolumeId": {},
	                "Ec2VolumeId": {},
	                "Name": {},
	                "RaidArrayId": {},
	                "InstanceId": {},
	                "Status": {},
	                "Size": {
	                  "type": "integer"
	                },
	                "Device": {},
	                "MountPoint": {},
	                "Region": {},
	                "AvailabilityZone": {},
	                "VolumeType": {},
	                "Iops": {
	                  "type": "integer"
	                },
	                "Encrypted": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DetachElasticLoadBalancer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ElasticLoadBalancerName",
	          "LayerId"
	        ],
	        "members": {
	          "ElasticLoadBalancerName": {},
	          "LayerId": {}
	        }
	      }
	    },
	    "DisassociateElasticIp": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ElasticIp"
	        ],
	        "members": {
	          "ElasticIp": {}
	        }
	      }
	    },
	    "GetHostnameSuggestion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerId"
	        ],
	        "members": {
	          "LayerId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LayerId": {},
	          "Hostname": {}
	        }
	      }
	    },
	    "GrantAccess": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "ValidForInMinutes": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TemporaryCredential": {
	            "type": "structure",
	            "members": {
	              "Username": {},
	              "Password": {},
	              "ValidForInMinutes": {
	                "type": "integer"
	              },
	              "InstanceId": {}
	            }
	          }
	        }
	      }
	    },
	    "ListTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "S50"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "RebootInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {}
	        }
	      }
	    },
	    "RegisterEcsCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EcsClusterArn",
	          "StackId"
	        ],
	        "members": {
	          "EcsClusterArn": {},
	          "StackId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EcsClusterArn": {}
	        }
	      }
	    },
	    "RegisterElasticIp": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ElasticIp",
	          "StackId"
	        ],
	        "members": {
	          "ElasticIp": {},
	          "StackId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ElasticIp": {}
	        }
	      }
	    },
	    "RegisterInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId"
	        ],
	        "members": {
	          "StackId": {},
	          "Hostname": {},
	          "PublicIp": {},
	          "PrivateIp": {},
	          "RsaPublicKey": {},
	          "RsaPublicKeyFingerprint": {},
	          "InstanceIdentity": {
	            "type": "structure",
	            "members": {
	              "Document": {},
	              "Signature": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {}
	        }
	      }
	    },
	    "RegisterRdsDbInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId",
	          "RdsDbInstanceArn",
	          "DbUser",
	          "DbPassword"
	        ],
	        "members": {
	          "StackId": {},
	          "RdsDbInstanceArn": {},
	          "DbUser": {},
	          "DbPassword": {}
	        }
	      }
	    },
	    "RegisterVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId"
	        ],
	        "members": {
	          "Ec2VolumeId": {},
	          "StackId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumeId": {}
	        }
	      }
	    },
	    "SetLoadBasedAutoScaling": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerId"
	        ],
	        "members": {
	          "LayerId": {},
	          "Enable": {
	            "type": "boolean"
	          },
	          "UpScaling": {
	            "shape": "S36"
	          },
	          "DownScaling": {
	            "shape": "S36"
	          }
	        }
	      }
	    },
	    "SetPermission": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId",
	          "IamUserArn"
	        ],
	        "members": {
	          "StackId": {},
	          "IamUserArn": {},
	          "AllowSsh": {
	            "type": "boolean"
	          },
	          "AllowSudo": {
	            "type": "boolean"
	          },
	          "Level": {}
	        }
	      }
	    },
	    "SetTimeBasedAutoScaling": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "AutoScalingSchedule": {
	            "shape": "S4b"
	          }
	        }
	      }
	    },
	    "StartInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {}
	        }
	      }
	    },
	    "StartStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId"
	        ],
	        "members": {
	          "StackId": {}
	        }
	      }
	    },
	    "StopInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "Force": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "StopStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId"
	        ],
	        "members": {
	          "StackId": {}
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "S50"
	          }
	        }
	      }
	    },
	    "UnassignInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {}
	        }
	      }
	    },
	    "UnassignVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeId"
	        ],
	        "members": {
	          "VolumeId": {}
	        }
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "UpdateApp": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AppId"
	        ],
	        "members": {
	          "AppId": {},
	          "Name": {},
	          "Description": {},
	          "DataSources": {
	            "shape": "Si"
	          },
	          "Type": {},
	          "AppSource": {
	            "shape": "Sd"
	          },
	          "Domains": {
	            "shape": "S3"
	          },
	          "EnableSsl": {
	            "type": "boolean"
	          },
	          "SslConfiguration": {
	            "shape": "Sl"
	          },
	          "Attributes": {
	            "shape": "Sm"
	          },
	          "Environment": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "UpdateElasticIp": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ElasticIp"
	        ],
	        "members": {
	          "ElasticIp": {},
	          "Name": {}
	        }
	      }
	    },
	    "UpdateInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "LayerIds": {
	            "shape": "S3"
	          },
	          "InstanceType": {},
	          "AutoScalingType": {},
	          "Hostname": {},
	          "Os": {},
	          "AmiId": {},
	          "SshKeyName": {},
	          "Architecture": {},
	          "InstallUpdatesOnBoot": {
	            "type": "boolean"
	          },
	          "EbsOptimized": {
	            "type": "boolean"
	          },
	          "AgentVersion": {}
	        }
	      }
	    },
	    "UpdateLayer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LayerId"
	        ],
	        "members": {
	          "LayerId": {},
	          "Name": {},
	          "Shortname": {},
	          "Attributes": {
	            "shape": "S17"
	          },
	          "CloudWatchLogsConfiguration": {
	            "shape": "S19"
	          },
	          "CustomInstanceProfileArn": {},
	          "CustomJson": {},
	          "CustomSecurityGroupIds": {
	            "shape": "S3"
	          },
	          "Packages": {
	            "shape": "S3"
	          },
	          "VolumeConfigurations": {
	            "shape": "S1f"
	          },
	          "EnableAutoHealing": {
	            "type": "boolean"
	          },
	          "AutoAssignElasticIps": {
	            "type": "boolean"
	          },
	          "AutoAssignPublicIps": {
	            "type": "boolean"
	          },
	          "CustomRecipes": {
	            "shape": "S1h"
	          },
	          "InstallUpdatesOnBoot": {
	            "type": "boolean"
	          },
	          "UseEbsOptimizedInstances": {
	            "type": "boolean"
	          },
	          "LifecycleEventConfiguration": {
	            "shape": "S1i"
	          }
	        }
	      }
	    },
	    "UpdateMyUserProfile": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SshPublicKey": {}
	        }
	      }
	    },
	    "UpdateRdsDbInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RdsDbInstanceArn"
	        ],
	        "members": {
	          "RdsDbInstanceArn": {},
	          "DbUser": {},
	          "DbPassword": {}
	        }
	      }
	    },
	    "UpdateStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StackId"
	        ],
	        "members": {
	          "StackId": {},
	          "Name": {},
	          "Attributes": {
	            "shape": "S8"
	          },
	          "ServiceRoleArn": {},
	          "DefaultInstanceProfileArn": {},
	          "DefaultOs": {},
	          "HostnameTheme": {},
	          "DefaultAvailabilityZone": {},
	          "DefaultSubnetId": {},
	          "CustomJson": {},
	          "ConfigurationManager": {
	            "shape": "Sa"
	          },
	          "ChefConfiguration": {
	            "shape": "Sb"
	          },
	          "UseCustomCookbooks": {
	            "type": "boolean"
	          },
	          "CustomCookbooksSource": {
	            "shape": "Sd"
	          },
	          "DefaultSshKeyName": {},
	          "DefaultRootDeviceType": {},
	          "UseOpsworksSecurityGroups": {
	            "type": "boolean"
	          },
	          "AgentVersion": {}
	        }
	      }
	    },
	    "UpdateUserProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IamUserArn"
	        ],
	        "members": {
	          "IamUserArn": {},
	          "SshUsername": {},
	          "SshPublicKey": {},
	          "AllowSelfManagement": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "UpdateVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeId"
	        ],
	        "members": {
	          "VolumeId": {},
	          "Name": {},
	          "MountPoint": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S3": {
	      "type": "list",
	      "member": {}
	    },
	    "S8": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sa": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Version": {}
	      }
	    },
	    "Sb": {
	      "type": "structure",
	      "members": {
	        "ManageBerkshelf": {
	          "type": "boolean"
	        },
	        "BerkshelfVersion": {}
	      }
	    },
	    "Sd": {
	      "type": "structure",
	      "members": {
	        "Type": {},
	        "Url": {},
	        "Username": {},
	        "Password": {},
	        "SshKey": {},
	        "Revision": {}
	      }
	    },
	    "Si": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "Arn": {},
	          "DatabaseName": {}
	        }
	      }
	    },
	    "Sl": {
	      "type": "structure",
	      "required": [
	        "Certificate",
	        "PrivateKey"
	      ],
	      "members": {
	        "Certificate": {},
	        "PrivateKey": {},
	        "Chain": {}
	      }
	    },
	    "Sm": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "So": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {},
	          "Secure": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "Ss": {
	      "type": "structure",
	      "required": [
	        "Name"
	      ],
	      "members": {
	        "Name": {},
	        "Args": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "shape": "S3"
	          }
	        }
	      }
	    },
	    "Sz": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "DeviceName": {},
	          "NoDevice": {},
	          "VirtualName": {},
	          "Ebs": {
	            "type": "structure",
	            "members": {
	              "SnapshotId": {},
	              "Iops": {
	                "type": "integer"
	              },
	              "VolumeSize": {
	                "type": "integer"
	              },
	              "VolumeType": {},
	              "DeleteOnTermination": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S17": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S19": {
	      "type": "structure",
	      "members": {
	        "Enabled": {
	          "type": "boolean"
	        },
	        "LogStreams": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "LogGroupName": {},
	              "DatetimeFormat": {},
	              "TimeZone": {},
	              "File": {},
	              "FileFingerprintLines": {},
	              "MultiLineStartPattern": {},
	              "InitialPosition": {},
	              "Encoding": {},
	              "BufferDuration": {
	                "type": "integer"
	              },
	              "BatchCount": {
	                "type": "integer"
	              },
	              "BatchSize": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1f": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "MountPoint",
	          "NumberOfDisks",
	          "Size"
	        ],
	        "members": {
	          "MountPoint": {},
	          "RaidLevel": {
	            "type": "integer"
	          },
	          "NumberOfDisks": {
	            "type": "integer"
	          },
	          "Size": {
	            "type": "integer"
	          },
	          "VolumeType": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "Encrypted": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S1h": {
	      "type": "structure",
	      "members": {
	        "Setup": {
	          "shape": "S3"
	        },
	        "Configure": {
	          "shape": "S3"
	        },
	        "Deploy": {
	          "shape": "S3"
	        },
	        "Undeploy": {
	          "shape": "S3"
	        },
	        "Shutdown": {
	          "shape": "S3"
	        }
	      }
	    },
	    "S1i": {
	      "type": "structure",
	      "members": {
	        "Shutdown": {
	          "type": "structure",
	          "members": {
	            "ExecutionTimeout": {
	              "type": "integer"
	            },
	            "DelayUntilElbConnectionsDrained": {
	              "type": "boolean"
	            }
	          }
	        }
	      }
	    },
	    "S36": {
	      "type": "structure",
	      "members": {
	        "InstanceCount": {
	          "type": "integer"
	        },
	        "ThresholdsWaitTime": {
	          "type": "integer"
	        },
	        "IgnoreMetricsTime": {
	          "type": "integer"
	        },
	        "CpuThreshold": {
	          "type": "double"
	        },
	        "MemoryThreshold": {
	          "type": "double"
	        },
	        "LoadThreshold": {
	          "type": "double"
	        },
	        "Alarms": {
	          "shape": "S3"
	        }
	      }
	    },
	    "S4b": {
	      "type": "structure",
	      "members": {
	        "Monday": {
	          "shape": "S4c"
	        },
	        "Tuesday": {
	          "shape": "S4c"
	        },
	        "Wednesday": {
	          "shape": "S4c"
	        },
	        "Thursday": {
	          "shape": "S4c"
	        },
	        "Friday": {
	          "shape": "S4c"
	        },
	        "Saturday": {
	          "shape": "S4c"
	        },
	        "Sunday": {
	          "shape": "S4c"
	        }
	      }
	    },
	    "S4c": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S50": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    }
	  }
	}
	},{}],171:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeApps": {
	      "result_key": "Apps"
	    },
	    "DescribeCommands": {
	      "result_key": "Commands"
	    },
	    "DescribeDeployments": {
	      "result_key": "Deployments"
	    },
	    "DescribeEcsClusters": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "EcsClusters"
	    },
	    "DescribeElasticIps": {
	      "result_key": "ElasticIps"
	    },
	    "DescribeElasticLoadBalancers": {
	      "result_key": "ElasticLoadBalancers"
	    },
	    "DescribeInstances": {
	      "result_key": "Instances"
	    },
	    "DescribeLayers": {
	      "result_key": "Layers"
	    },
	    "DescribeLoadBasedAutoScaling": {
	      "result_key": "LoadBasedAutoScalingConfigurations"
	    },
	    "DescribePermissions": {
	      "result_key": "Permissions"
	    },
	    "DescribeRaidArrays": {
	      "result_key": "RaidArrays"
	    },
	    "DescribeServiceErrors": {
	      "result_key": "ServiceErrors"
	    },
	    "DescribeStacks": {
	      "result_key": "Stacks"
	    },
	    "DescribeTimeBasedAutoScaling": {
	      "result_key": "TimeBasedAutoScalingConfigurations"
	    },
	    "DescribeUserProfiles": {
	      "result_key": "UserProfiles"
	    },
	    "DescribeVolumes": {
	      "result_key": "Volumes"
	    }
	  }
	}
	},{}],172:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "AppExists": {
	      "delay": 1,
	      "operation": "DescribeApps",
	      "maxAttempts": 40,
	      "acceptors": [
	        {
	          "expected": 200,
	          "matcher": "status",
	          "state": "success"
	        },
	        {
	          "matcher": "status",
	          "expected": 400,
	          "state": "failure"
	        }
	      ]
	    },
	    "DeploymentSuccessful": {
	      "delay": 15,
	      "operation": "DescribeDeployments",
	      "maxAttempts": 40,
	      "description": "Wait until a deployment has completed successfully.",
	      "acceptors": [
	        {
	          "expected": "successful",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Deployments[].Status"
	        },
	        {
	          "expected": "failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Deployments[].Status"
	        }
	      ]
	    },
	    "InstanceOnline": {
	      "delay": 15,
	      "operation": "DescribeInstances",
	      "maxAttempts": 40,
	      "description": "Wait until OpsWorks instance is online.",
	      "acceptors": [
	        {
	          "expected": "online",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "setup_failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "shutting_down",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "start_failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "stopped",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "stopping",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "terminating",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "terminated",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "stop_failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        }
	      ]
	    },
	    "InstanceRegistered": {
	      "delay": 15,
	      "operation": "DescribeInstances",
	      "maxAttempts": 40,
	      "description": "Wait until OpsWorks instance is registered.",
	      "acceptors": [
	        {
	          "expected": "registered",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "setup_failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "shutting_down",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "stopped",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "stopping",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "terminating",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "terminated",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "stop_failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        }
	      ]
	    },
	    "InstanceStopped": {
	      "delay": 15,
	      "operation": "DescribeInstances",
	      "maxAttempts": 40,
	      "description": "Wait until OpsWorks instance is stopped.",
	      "acceptors": [
	        {
	          "expected": "stopped",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "booting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "pending",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "rebooting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "requested",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "running_setup",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "setup_failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "start_failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "stop_failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        }
	      ]
	    },
	    "InstanceTerminated": {
	      "delay": 15,
	      "operation": "DescribeInstances",
	      "maxAttempts": 40,
	      "description": "Wait until OpsWorks instance is terminated.",
	      "acceptors": [
	        {
	          "expected": "terminated",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "ResourceNotFoundException",
	          "matcher": "error",
	          "state": "success"
	        },
	        {
	          "expected": "booting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "online",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "pending",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "rebooting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "requested",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "running_setup",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "setup_failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        },
	        {
	          "expected": "start_failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Instances[].Status"
	        }
	      ]
	    }
	  }
	}
	
	},{}],173:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2018-05-22",
	    "endpointPrefix": "personalize",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Personalize",
	    "serviceId": "Personalize",
	    "signatureVersion": "v4",
	    "signingName": "personalize",
	    "targetPrefix": "AmazonPersonalize",
	    "uid": "personalize-2018-05-22"
	  },
	  "operations": {
	    "CreateBatchInferenceJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobName",
	          "solutionVersionArn",
	          "jobInput",
	          "jobOutput",
	          "roleArn"
	        ],
	        "members": {
	          "jobName": {},
	          "solutionVersionArn": {},
	          "filterArn": {},
	          "numResults": {
	            "type": "integer"
	          },
	          "jobInput": {
	            "shape": "S5"
	          },
	          "jobOutput": {
	            "shape": "S9"
	          },
	          "roleArn": {},
	          "batchInferenceJobConfig": {
	            "shape": "Sb"
	          },
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "batchInferenceJobArn": {}
	        }
	      }
	    },
	    "CreateBatchSegmentJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobName",
	          "solutionVersionArn",
	          "jobInput",
	          "jobOutput",
	          "roleArn"
	        ],
	        "members": {
	          "jobName": {},
	          "solutionVersionArn": {},
	          "filterArn": {},
	          "numResults": {
	            "type": "integer"
	          },
	          "jobInput": {
	            "shape": "Sl"
	          },
	          "jobOutput": {
	            "shape": "Sm"
	          },
	          "roleArn": {},
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "batchSegmentJobArn": {}
	        }
	      }
	    },
	    "CreateCampaign": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "solutionVersionArn"
	        ],
	        "members": {
	          "name": {},
	          "solutionVersionArn": {},
	          "minProvisionedTPS": {
	            "type": "integer"
	          },
	          "campaignConfig": {
	            "shape": "Sq"
	          },
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "campaignArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "CreateDataset": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "schemaArn",
	          "datasetGroupArn",
	          "datasetType"
	        ],
	        "members": {
	          "name": {},
	          "schemaArn": {},
	          "datasetGroupArn": {},
	          "datasetType": {},
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "CreateDatasetExportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobName",
	          "datasetArn",
	          "roleArn",
	          "jobOutput"
	        ],
	        "members": {
	          "jobName": {},
	          "datasetArn": {},
	          "ingestionMode": {},
	          "roleArn": {},
	          "jobOutput": {
	            "shape": "Sx"
	          },
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetExportJobArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "CreateDatasetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name"
	        ],
	        "members": {
	          "name": {},
	          "roleArn": {},
	          "kmsKeyArn": {},
	          "domain": {},
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetGroupArn": {},
	          "domain": {}
	        }
	      }
	    },
	    "CreateDatasetImportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "jobName",
	          "datasetArn",
	          "dataSource",
	          "roleArn"
	        ],
	        "members": {
	          "jobName": {},
	          "datasetArn": {},
	          "dataSource": {
	            "shape": "S13"
	          },
	          "roleArn": {},
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetImportJobArn": {}
	        }
	      }
	    },
	    "CreateEventTracker": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "datasetGroupArn"
	        ],
	        "members": {
	          "name": {},
	          "datasetGroupArn": {},
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "eventTrackerArn": {},
	          "trackingId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "CreateFilter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "datasetGroupArn",
	          "filterExpression"
	        ],
	        "members": {
	          "name": {},
	          "datasetGroupArn": {},
	          "filterExpression": {
	            "shape": "S19"
	          },
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "filterArn": {}
	        }
	      }
	    },
	    "CreateRecommender": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "datasetGroupArn",
	          "recipeArn"
	        ],
	        "members": {
	          "name": {},
	          "datasetGroupArn": {},
	          "recipeArn": {},
	          "recommenderConfig": {
	            "shape": "S1c"
	          },
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "recommenderArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "CreateSchema": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "schema"
	        ],
	        "members": {
	          "name": {},
	          "schema": {},
	          "domain": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "schemaArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "CreateSolution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "name",
	          "datasetGroupArn"
	        ],
	        "members": {
	          "name": {},
	          "performHPO": {
	            "type": "boolean"
	          },
	          "performAutoML": {
	            "type": "boolean"
	          },
	          "recipeArn": {},
	          "datasetGroupArn": {},
	          "eventType": {},
	          "solutionConfig": {
	            "shape": "S1l"
	          },
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "solutionArn": {}
	        }
	      }
	    },
	    "CreateSolutionVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "solutionArn"
	        ],
	        "members": {
	          "solutionArn": {},
	          "trainingMode": {},
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "solutionVersionArn": {}
	        }
	      }
	    },
	    "DeleteCampaign": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "campaignArn"
	        ],
	        "members": {
	          "campaignArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteDataset": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetArn"
	        ],
	        "members": {
	          "datasetArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteDatasetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetGroupArn"
	        ],
	        "members": {
	          "datasetGroupArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteEventTracker": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "eventTrackerArn"
	        ],
	        "members": {
	          "eventTrackerArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteFilter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "filterArn"
	        ],
	        "members": {
	          "filterArn": {}
	        }
	      }
	    },
	    "DeleteRecommender": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "recommenderArn"
	        ],
	        "members": {
	          "recommenderArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteSchema": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "schemaArn"
	        ],
	        "members": {
	          "schemaArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DeleteSolution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "solutionArn"
	        ],
	        "members": {
	          "solutionArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeAlgorithm": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "algorithmArn"
	        ],
	        "members": {
	          "algorithmArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "algorithm": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "algorithmArn": {},
	              "algorithmImage": {
	                "type": "structure",
	                "required": [
	                  "dockerURI"
	                ],
	                "members": {
	                  "name": {},
	                  "dockerURI": {}
	                }
	              },
	              "defaultHyperParameters": {
	                "shape": "Sc"
	              },
	              "defaultHyperParameterRanges": {
	                "type": "structure",
	                "members": {
	                  "integerHyperParameterRanges": {
	                    "type": "list",
	                    "member": {
	                      "type": "structure",
	                      "members": {
	                        "name": {},
	                        "minValue": {
	                          "type": "integer"
	                        },
	                        "maxValue": {
	                          "type": "integer"
	                        },
	                        "isTunable": {
	                          "type": "boolean"
	                        }
	                      }
	                    }
	                  },
	                  "continuousHyperParameterRanges": {
	                    "type": "list",
	                    "member": {
	                      "type": "structure",
	                      "members": {
	                        "name": {},
	                        "minValue": {
	                          "type": "double"
	                        },
	                        "maxValue": {
	                          "type": "double"
	                        },
	                        "isTunable": {
	                          "type": "boolean"
	                        }
	                      }
	                    }
	                  },
	                  "categoricalHyperParameterRanges": {
	                    "type": "list",
	                    "member": {
	                      "type": "structure",
	                      "members": {
	                        "name": {},
	                        "values": {
	                          "shape": "S25"
	                        },
	                        "isTunable": {
	                          "type": "boolean"
	                        }
	                      }
	                    }
	                  }
	                }
	              },
	              "defaultResourceConfig": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              },
	              "trainingInputMode": {},
	              "roleArn": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeBatchInferenceJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "batchInferenceJobArn"
	        ],
	        "members": {
	          "batchInferenceJobArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "batchInferenceJob": {
	            "type": "structure",
	            "members": {
	              "jobName": {},
	              "batchInferenceJobArn": {},
	              "filterArn": {},
	              "failureReason": {},
	              "solutionVersionArn": {},
	              "numResults": {
	                "type": "integer"
	              },
	              "jobInput": {
	                "shape": "S5"
	              },
	              "jobOutput": {
	                "shape": "S9"
	              },
	              "batchInferenceJobConfig": {
	                "shape": "Sb"
	              },
	              "roleArn": {},
	              "status": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeBatchSegmentJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "batchSegmentJobArn"
	        ],
	        "members": {
	          "batchSegmentJobArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "batchSegmentJob": {
	            "type": "structure",
	            "members": {
	              "jobName": {},
	              "batchSegmentJobArn": {},
	              "filterArn": {},
	              "failureReason": {},
	              "solutionVersionArn": {},
	              "numResults": {
	                "type": "integer"
	              },
	              "jobInput": {
	                "shape": "Sl"
	              },
	              "jobOutput": {
	                "shape": "Sm"
	              },
	              "roleArn": {},
	              "status": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeCampaign": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "campaignArn"
	        ],
	        "members": {
	          "campaignArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "campaign": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "campaignArn": {},
	              "solutionVersionArn": {},
	              "minProvisionedTPS": {
	                "type": "integer"
	              },
	              "campaignConfig": {
	                "shape": "Sq"
	              },
	              "status": {},
	              "failureReason": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              },
	              "latestCampaignUpdate": {
	                "type": "structure",
	                "members": {
	                  "solutionVersionArn": {},
	                  "minProvisionedTPS": {
	                    "type": "integer"
	                  },
	                  "campaignConfig": {
	                    "shape": "Sq"
	                  },
	                  "status": {},
	                  "failureReason": {},
	                  "creationDateTime": {
	                    "type": "timestamp"
	                  },
	                  "lastUpdatedDateTime": {
	                    "type": "timestamp"
	                  }
	                }
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeDataset": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetArn"
	        ],
	        "members": {
	          "datasetArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "dataset": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "datasetArn": {},
	              "datasetGroupArn": {},
	              "datasetType": {},
	              "schemaArn": {},
	              "status": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeDatasetExportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetExportJobArn"
	        ],
	        "members": {
	          "datasetExportJobArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetExportJob": {
	            "type": "structure",
	            "members": {
	              "jobName": {},
	              "datasetExportJobArn": {},
	              "datasetArn": {},
	              "ingestionMode": {},
	              "roleArn": {},
	              "status": {},
	              "jobOutput": {
	                "shape": "Sx"
	              },
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              },
	              "failureReason": {}
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeDatasetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetGroupArn"
	        ],
	        "members": {
	          "datasetGroupArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetGroup": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "datasetGroupArn": {},
	              "status": {},
	              "roleArn": {},
	              "kmsKeyArn": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              },
	              "failureReason": {},
	              "domain": {}
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeDatasetImportJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetImportJobArn"
	        ],
	        "members": {
	          "datasetImportJobArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetImportJob": {
	            "type": "structure",
	            "members": {
	              "jobName": {},
	              "datasetImportJobArn": {},
	              "datasetArn": {},
	              "dataSource": {
	                "shape": "S13"
	              },
	              "roleArn": {},
	              "status": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              },
	              "failureReason": {}
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeEventTracker": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "eventTrackerArn"
	        ],
	        "members": {
	          "eventTrackerArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "eventTracker": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "eventTrackerArn": {},
	              "accountId": {},
	              "trackingId": {},
	              "datasetGroupArn": {},
	              "status": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeFeatureTransformation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "featureTransformationArn"
	        ],
	        "members": {
	          "featureTransformationArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "featureTransformation": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "featureTransformationArn": {},
	              "defaultParameters": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              },
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              },
	              "status": {}
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeFilter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "filterArn"
	        ],
	        "members": {
	          "filterArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "filter": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "filterArn": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              },
	              "datasetGroupArn": {},
	              "failureReason": {},
	              "filterExpression": {
	                "shape": "S19"
	              },
	              "status": {}
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeRecipe": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "recipeArn"
	        ],
	        "members": {
	          "recipeArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "recipe": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "recipeArn": {},
	              "algorithmArn": {},
	              "featureTransformationArn": {},
	              "status": {},
	              "description": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "recipeType": {},
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeRecommender": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "recommenderArn"
	        ],
	        "members": {
	          "recommenderArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "recommender": {
	            "type": "structure",
	            "members": {
	              "recommenderArn": {},
	              "datasetGroupArn": {},
	              "name": {},
	              "recipeArn": {},
	              "recommenderConfig": {
	                "shape": "S1c"
	              },
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              },
	              "status": {},
	              "failureReason": {},
	              "latestRecommenderUpdate": {
	                "type": "structure",
	                "members": {
	                  "recommenderConfig": {
	                    "shape": "S1c"
	                  },
	                  "creationDateTime": {
	                    "type": "timestamp"
	                  },
	                  "lastUpdatedDateTime": {
	                    "type": "timestamp"
	                  },
	                  "status": {},
	                  "failureReason": {}
	                }
	              },
	              "modelMetrics": {
	                "shape": "S4d"
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeSchema": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "schemaArn"
	        ],
	        "members": {
	          "schemaArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "schema": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "schemaArn": {},
	              "schema": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              },
	              "domain": {}
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeSolution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "solutionArn"
	        ],
	        "members": {
	          "solutionArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "solution": {
	            "type": "structure",
	            "members": {
	              "name": {},
	              "solutionArn": {},
	              "performHPO": {
	                "type": "boolean"
	              },
	              "performAutoML": {
	                "type": "boolean"
	              },
	              "recipeArn": {},
	              "datasetGroupArn": {},
	              "eventType": {},
	              "solutionConfig": {
	                "shape": "S1l"
	              },
	              "autoMLResult": {
	                "type": "structure",
	                "members": {
	                  "bestRecipeArn": {}
	                }
	              },
	              "status": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              },
	              "latestSolutionVersion": {
	                "shape": "S4n"
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "DescribeSolutionVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "solutionVersionArn"
	        ],
	        "members": {
	          "solutionVersionArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "solutionVersion": {
	            "type": "structure",
	            "members": {
	              "solutionVersionArn": {},
	              "solutionArn": {},
	              "performHPO": {
	                "type": "boolean"
	              },
	              "performAutoML": {
	                "type": "boolean"
	              },
	              "recipeArn": {},
	              "eventType": {},
	              "datasetGroupArn": {},
	              "solutionConfig": {
	                "shape": "S1l"
	              },
	              "trainingHours": {
	                "type": "double"
	              },
	              "trainingMode": {},
	              "tunedHPOParams": {
	                "type": "structure",
	                "members": {
	                  "algorithmHyperParameters": {
	                    "shape": "Sc"
	                  }
	                }
	              },
	              "status": {},
	              "failureReason": {},
	              "creationDateTime": {
	                "type": "timestamp"
	              },
	              "lastUpdatedDateTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      },
	      "idempotent": true
	    },
	    "GetSolutionMetrics": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "solutionVersionArn"
	        ],
	        "members": {
	          "solutionVersionArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "solutionVersionArn": {},
	          "metrics": {
	            "shape": "S4d"
	          }
	        }
	      }
	    },
	    "ListBatchInferenceJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "solutionVersionArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "batchInferenceJobs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "batchInferenceJobArn": {},
	                "jobName": {},
	                "status": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                },
	                "failureReason": {},
	                "solutionVersionArn": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListBatchSegmentJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "solutionVersionArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "batchSegmentJobs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "batchSegmentJobArn": {},
	                "jobName": {},
	                "status": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                },
	                "failureReason": {},
	                "solutionVersionArn": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListCampaigns": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "solutionArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "campaigns": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "campaignArn": {},
	                "status": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                },
	                "failureReason": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListDatasetExportJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "datasetArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetExportJobs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "datasetExportJobArn": {},
	                "jobName": {},
	                "status": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                },
	                "failureReason": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListDatasetGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "datasetGroupArn": {},
	                "status": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                },
	                "failureReason": {},
	                "domain": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListDatasetImportJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "datasetArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasetImportJobs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "datasetImportJobArn": {},
	                "jobName": {},
	                "status": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                },
	                "failureReason": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListDatasets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "datasetGroupArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "datasets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "datasetArn": {},
	                "datasetType": {},
	                "status": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListEventTrackers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "datasetGroupArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "eventTrackers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "eventTrackerArn": {},
	                "status": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListFilters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "datasetGroupArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "filterArn": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                },
	                "datasetGroupArn": {},
	                "failureReason": {},
	                "status": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListRecipes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "recipeProvider": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          },
	          "domain": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "recipes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "recipeArn": {},
	                "status": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                },
	                "domain": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListRecommenders": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "datasetGroupArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "recommenders": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "recommenderArn": {},
	                "datasetGroupArn": {},
	                "recipeArn": {},
	                "recommenderConfig": {
	                  "shape": "S1c"
	                },
	                "status": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListSchemas": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "schemas": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "schemaArn": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                },
	                "domain": {}
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListSolutionVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "solutionArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "solutionVersions": {
	            "type": "list",
	            "member": {
	              "shape": "S4n"
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListSolutions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "datasetGroupArn": {},
	          "nextToken": {},
	          "maxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "solutions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "name": {},
	                "solutionArn": {},
	                "status": {},
	                "creationDateTime": {
	                  "type": "timestamp"
	                },
	                "lastUpdatedDateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "nextToken": {}
	        }
	      },
	      "idempotent": true
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn"
	        ],
	        "members": {
	          "resourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      }
	    },
	    "StartRecommender": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "recommenderArn"
	        ],
	        "members": {
	          "recommenderArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "recommenderArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StopRecommender": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "recommenderArn"
	        ],
	        "members": {
	          "recommenderArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "recommenderArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StopSolutionVersionCreation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "solutionVersionArn"
	        ],
	        "members": {
	          "solutionVersionArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tags"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tags": {
	            "shape": "Sf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "resourceArn",
	          "tagKeys"
	        ],
	        "members": {
	          "resourceArn": {},
	          "tagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateCampaign": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "campaignArn"
	        ],
	        "members": {
	          "campaignArn": {},
	          "solutionVersionArn": {},
	          "minProvisionedTPS": {
	            "type": "integer"
	          },
	          "campaignConfig": {
	            "shape": "Sq"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "campaignArn": {}
	        }
	      },
	      "idempotent": true
	    },
	    "UpdateRecommender": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "recommenderArn",
	          "recommenderConfig"
	        ],
	        "members": {
	          "recommenderArn": {},
	          "recommenderConfig": {
	            "shape": "S1c"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "recommenderArn": {}
	        }
	      },
	      "idempotent": true
	    }
	  },
	  "shapes": {
	    "S5": {
	      "type": "structure",
	      "required": [
	        "s3DataSource"
	      ],
	      "members": {
	        "s3DataSource": {
	          "shape": "S6"
	        }
	      }
	    },
	    "S6": {
	      "type": "structure",
	      "required": [
	        "path"
	      ],
	      "members": {
	        "path": {},
	        "kmsKeyArn": {}
	      }
	    },
	    "S9": {
	      "type": "structure",
	      "required": [
	        "s3DataDestination"
	      ],
	      "members": {
	        "s3DataDestination": {
	          "shape": "S6"
	        }
	      }
	    },
	    "Sb": {
	      "type": "structure",
	      "members": {
	        "itemExplorationConfig": {
	          "shape": "Sc"
	        }
	      }
	    },
	    "Sc": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sf": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "tagKey",
	          "tagValue"
	        ],
	        "members": {
	          "tagKey": {},
	          "tagValue": {}
	        }
	      }
	    },
	    "Sl": {
	      "type": "structure",
	      "required": [
	        "s3DataSource"
	      ],
	      "members": {
	        "s3DataSource": {
	          "shape": "S6"
	        }
	      }
	    },
	    "Sm": {
	      "type": "structure",
	      "required": [
	        "s3DataDestination"
	      ],
	      "members": {
	        "s3DataDestination": {
	          "shape": "S6"
	        }
	      }
	    },
	    "Sq": {
	      "type": "structure",
	      "members": {
	        "itemExplorationConfig": {
	          "shape": "Sc"
	        }
	      }
	    },
	    "Sx": {
	      "type": "structure",
	      "required": [
	        "s3DataDestination"
	      ],
	      "members": {
	        "s3DataDestination": {
	          "shape": "S6"
	        }
	      }
	    },
	    "S13": {
	      "type": "structure",
	      "members": {
	        "dataLocation": {}
	      }
	    },
	    "S19": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S1c": {
	      "type": "structure",
	      "members": {
	        "itemExplorationConfig": {
	          "shape": "Sc"
	        },
	        "minRecommendationRequestsPerSecond": {
	          "type": "integer"
	        }
	      }
	    },
	    "S1l": {
	      "type": "structure",
	      "members": {
	        "eventValueThreshold": {},
	        "hpoConfig": {
	          "type": "structure",
	          "members": {
	            "hpoObjective": {
	              "type": "structure",
	              "members": {
	                "type": {},
	                "metricName": {},
	                "metricRegex": {}
	              }
	            },
	            "hpoResourceConfig": {
	              "type": "structure",
	              "members": {
	                "maxNumberOfTrainingJobs": {},
	                "maxParallelTrainingJobs": {}
	              }
	            },
	            "algorithmHyperParameterRanges": {
	              "type": "structure",
	              "members": {
	                "integerHyperParameterRanges": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "name": {},
	                      "minValue": {
	                        "type": "integer"
	                      },
	                      "maxValue": {
	                        "type": "integer"
	                      }
	                    }
	                  }
	                },
	                "continuousHyperParameterRanges": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "name": {},
	                      "minValue": {
	                        "type": "double"
	                      },
	                      "maxValue": {
	                        "type": "double"
	                      }
	                    }
	                  }
	                },
	                "categoricalHyperParameterRanges": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "name": {},
	                      "values": {
	                        "shape": "S25"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "algorithmHyperParameters": {
	          "shape": "Sc"
	        },
	        "featureTransformationParameters": {
	          "type": "map",
	          "key": {},
	          "value": {}
	        },
	        "autoMLConfig": {
	          "type": "structure",
	          "members": {
	            "metricName": {},
	            "recipeList": {
	              "type": "list",
	              "member": {}
	            }
	          }
	        },
	        "optimizationObjective": {
	          "type": "structure",
	          "members": {
	            "itemAttribute": {},
	            "objectiveSensitivity": {}
	          }
	        }
	      }
	    },
	    "S25": {
	      "type": "list",
	      "member": {}
	    },
	    "S4d": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "double"
	      }
	    },
	    "S4n": {
	      "type": "structure",
	      "members": {
	        "solutionVersionArn": {},
	        "status": {},
	        "creationDateTime": {
	          "type": "timestamp"
	        },
	        "lastUpdatedDateTime": {
	          "type": "timestamp"
	        },
	        "failureReason": {}
	      }
	    }
	  }
	}
	},{}],174:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListBatchInferenceJobs": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "batchInferenceJobs"
	    },
	    "ListBatchSegmentJobs": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "batchSegmentJobs"
	    },
	    "ListCampaigns": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "campaigns"
	    },
	    "ListDatasetExportJobs": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "datasetExportJobs"
	    },
	    "ListDatasetGroups": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "datasetGroups"
	    },
	    "ListDatasetImportJobs": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "datasetImportJobs"
	    },
	    "ListDatasets": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "datasets"
	    },
	    "ListEventTrackers": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "eventTrackers"
	    },
	    "ListFilters": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "Filters"
	    },
	    "ListRecipes": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "recipes"
	    },
	    "ListRecommenders": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "recommenders"
	    },
	    "ListSchemas": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "schemas"
	    },
	    "ListSolutionVersions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "solutionVersions"
	    },
	    "ListSolutions": {
	      "input_token": "nextToken",
	      "limit_key": "maxResults",
	      "output_token": "nextToken",
	      "result_key": "solutions"
	    }
	  }
	}
	},{}],175:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2018-03-22",
	    "endpointPrefix": "personalize-events",
	    "jsonVersion": "1.1",
	    "protocol": "rest-json",
	    "serviceFullName": "Amazon Personalize Events",
	    "serviceId": "Personalize Events",
	    "signatureVersion": "v4",
	    "signingName": "personalize",
	    "uid": "personalize-events-2018-03-22"
	  },
	  "operations": {
	    "PutEvents": {
	      "http": {
	        "requestUri": "/events"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "trackingId",
	          "sessionId",
	          "eventList"
	        ],
	        "members": {
	          "trackingId": {},
	          "userId": {},
	          "sessionId": {},
	          "eventList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "eventType",
	                "sentAt"
	              ],
	              "members": {
	                "eventId": {},
	                "eventType": {},
	                "eventValue": {
	                  "type": "float"
	                },
	                "itemId": {},
	                "properties": {
	                  "jsonvalue": true
	                },
	                "sentAt": {
	                  "type": "timestamp"
	                },
	                "recommendationId": {},
	                "impression": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutItems": {
	      "http": {
	        "requestUri": "/items"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetArn",
	          "items"
	        ],
	        "members": {
	          "datasetArn": {},
	          "items": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "itemId"
	              ],
	              "members": {
	                "itemId": {},
	                "properties": {
	                  "jsonvalue": true
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutUsers": {
	      "http": {
	        "requestUri": "/users"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "datasetArn",
	          "users"
	        ],
	        "members": {
	          "datasetArn": {},
	          "users": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "userId"
	              ],
	              "members": {
	                "userId": {},
	                "properties": {
	                  "jsonvalue": true
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	  },
	  "shapes": {}
	}
	},{}],176:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],177:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2018-05-22",
	    "endpointPrefix": "personalize-runtime",
	    "jsonVersion": "1.1",
	    "protocol": "rest-json",
	    "serviceFullName": "Amazon Personalize Runtime",
	    "serviceId": "Personalize Runtime",
	    "signatureVersion": "v4",
	    "signingName": "personalize",
	    "uid": "personalize-runtime-2018-05-22"
	  },
	  "operations": {
	    "GetPersonalizedRanking": {
	      "http": {
	        "requestUri": "/personalize-ranking"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "campaignArn",
	          "inputList",
	          "userId"
	        ],
	        "members": {
	          "campaignArn": {},
	          "inputList": {
	            "type": "list",
	            "member": {}
	          },
	          "userId": {},
	          "context": {
	            "shape": "S6"
	          },
	          "filterArn": {},
	          "filterValues": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "personalizedRanking": {
	            "shape": "Sd"
	          },
	          "recommendationId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "GetRecommendations": {
	      "http": {
	        "requestUri": "/recommendations"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "campaignArn": {},
	          "itemId": {},
	          "userId": {},
	          "numResults": {
	            "type": "integer"
	          },
	          "context": {
	            "shape": "S6"
	          },
	          "filterArn": {},
	          "filterValues": {
	            "shape": "S9"
	          },
	          "recommenderArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "itemList": {
	            "shape": "Sd"
	          },
	          "recommendationId": {}
	        }
	      },
	      "idempotent": true
	    }
	  },
	  "shapes": {
	    "S6": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "string",
	        "sensitive": true
	      }
	    },
	    "S9": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "string",
	        "sensitive": true
	      }
	    },
	    "Sd": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "itemId": {},
	          "score": {
	            "type": "double"
	          }
	        }
	      }
	    }
	  }
	}
	},{}],178:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],179:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2016-06-10",
	    "endpointPrefix": "polly",
	    "protocol": "rest-json",
	    "serviceFullName": "Amazon Polly",
	    "serviceId": "Polly",
	    "signatureVersion": "v4",
	    "uid": "polly-2016-06-10"
	  },
	  "operations": {
	    "DeleteLexicon": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/v1/lexicons/{LexiconName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {
	            "location": "uri",
	            "locationName": "LexiconName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeVoices": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/v1/voices",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Engine": {
	            "location": "querystring",
	            "locationName": "Engine"
	          },
	          "LanguageCode": {
	            "location": "querystring",
	            "locationName": "LanguageCode"
	          },
	          "IncludeAdditionalLanguageCodes": {
	            "location": "querystring",
	            "locationName": "IncludeAdditionalLanguageCodes",
	            "type": "boolean"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "NextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Voices": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Gender": {},
	                "Id": {},
	                "LanguageCode": {},
	                "LanguageName": {},
	                "Name": {},
	                "AdditionalLanguageCodes": {
	                  "type": "list",
	                  "member": {}
	                },
	                "SupportedEngines": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetLexicon": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/v1/lexicons/{LexiconName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {
	            "location": "uri",
	            "locationName": "LexiconName"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Lexicon": {
	            "type": "structure",
	            "members": {
	              "Content": {
	                "shape": "Sl"
	              },
	              "Name": {}
	            }
	          },
	          "LexiconAttributes": {
	            "shape": "Sm"
	          }
	        }
	      }
	    },
	    "GetSpeechSynthesisTask": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/v1/synthesisTasks/{TaskId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TaskId"
	        ],
	        "members": {
	          "TaskId": {
	            "location": "uri",
	            "locationName": "TaskId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SynthesisTask": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "ListLexicons": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/v1/lexicons",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "NextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Lexicons": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Attributes": {
	                  "shape": "Sm"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListSpeechSynthesisTasks": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/v1/synthesisTasks",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "MaxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "NextToken"
	          },
	          "Status": {
	            "location": "querystring",
	            "locationName": "Status"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "SynthesisTasks": {
	            "type": "list",
	            "member": {
	              "shape": "Sv"
	            }
	          }
	        }
	      }
	    },
	    "PutLexicon": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/v1/lexicons/{LexiconName}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Content"
	        ],
	        "members": {
	          "Name": {
	            "location": "uri",
	            "locationName": "LexiconName"
	          },
	          "Content": {
	            "shape": "Sl"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "StartSpeechSynthesisTask": {
	      "http": {
	        "requestUri": "/v1/synthesisTasks",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "OutputFormat",
	          "OutputS3BucketName",
	          "Text",
	          "VoiceId"
	        ],
	        "members": {
	          "Engine": {},
	          "LanguageCode": {},
	          "LexiconNames": {
	            "shape": "S12"
	          },
	          "OutputFormat": {},
	          "OutputS3BucketName": {},
	          "OutputS3KeyPrefix": {},
	          "SampleRate": {},
	          "SnsTopicArn": {},
	          "SpeechMarkTypes": {
	            "shape": "S15"
	          },
	          "Text": {},
	          "TextType": {},
	          "VoiceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SynthesisTask": {
	            "shape": "Sv"
	          }
	        }
	      }
	    },
	    "SynthesizeSpeech": {
	      "http": {
	        "requestUri": "/v1/speech",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "OutputFormat",
	          "Text",
	          "VoiceId"
	        ],
	        "members": {
	          "Engine": {},
	          "LanguageCode": {},
	          "LexiconNames": {
	            "shape": "S12"
	          },
	          "OutputFormat": {},
	          "SampleRate": {},
	          "SpeechMarkTypes": {
	            "shape": "S15"
	          },
	          "Text": {},
	          "TextType": {},
	          "VoiceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AudioStream": {
	            "type": "blob",
	            "streaming": true
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "RequestCharacters": {
	            "location": "header",
	            "locationName": "x-amzn-RequestCharacters",
	            "type": "integer"
	          }
	        },
	        "payload": "AudioStream"
	      }
	    }
	  },
	  "shapes": {
	    "Sl": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Sm": {
	      "type": "structure",
	      "members": {
	        "Alphabet": {},
	        "LanguageCode": {},
	        "LastModified": {
	          "type": "timestamp"
	        },
	        "LexiconArn": {},
	        "LexemesCount": {
	          "type": "integer"
	        },
	        "Size": {
	          "type": "integer"
	        }
	      }
	    },
	    "Sv": {
	      "type": "structure",
	      "members": {
	        "Engine": {},
	        "TaskId": {},
	        "TaskStatus": {},
	        "TaskStatusReason": {},
	        "OutputUri": {},
	        "CreationTime": {
	          "type": "timestamp"
	        },
	        "RequestCharacters": {
	          "type": "integer"
	        },
	        "SnsTopicArn": {},
	        "LexiconNames": {
	          "shape": "S12"
	        },
	        "OutputFormat": {},
	        "SampleRate": {},
	        "SpeechMarkTypes": {
	          "shape": "S15"
	        },
	        "TextType": {},
	        "VoiceId": {},
	        "LanguageCode": {}
	      }
	    },
	    "S12": {
	      "type": "list",
	      "member": {}
	    },
	    "S15": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],180:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListSpeechSynthesisTasks": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    }
	  }
	}
	
	},{}],181:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-10-15",
	    "endpointPrefix": "api.pricing",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "AWS Pricing",
	    "serviceFullName": "AWS Price List Service",
	    "serviceId": "Pricing",
	    "signatureVersion": "v4",
	    "signingName": "pricing",
	    "targetPrefix": "AWSPriceListService",
	    "uid": "pricing-2017-10-15"
	  },
	  "operations": {
	    "DescribeServices": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ServiceCode": {},
	          "FormatVersion": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Services": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ServiceCode"
	              ],
	              "members": {
	                "ServiceCode": {},
	                "AttributeNames": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "FormatVersion": {},
	          "NextToken": {}
	        }
	      }
	    },
	    "GetAttributeValues": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceCode",
	          "AttributeName"
	        ],
	        "members": {
	          "ServiceCode": {},
	          "AttributeName": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AttributeValues": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Value": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetProducts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceCode"
	        ],
	        "members": {
	          "ServiceCode": {},
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Type",
	                "Field",
	                "Value"
	              ],
	              "members": {
	                "Type": {},
	                "Field": {},
	                "Value": {}
	              }
	            }
	          },
	          "FormatVersion": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FormatVersion": {},
	          "PriceList": {
	            "type": "list",
	            "member": {
	              "jsonvalue": true
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    }
	  },
	  "shapes": {}
	}
	},{}],182:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeServices": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "GetAttributeValues": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "GetProducts": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    }
	  }
	}
	
	},{}],183:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2013-01-10",
	    "endpointPrefix": "rds",
	    "protocol": "query",
	    "serviceAbbreviation": "Amazon RDS",
	    "serviceFullName": "Amazon Relational Database Service",
	    "serviceId": "RDS",
	    "signatureVersion": "v4",
	    "uid": "rds-2013-01-10",
	    "xmlNamespace": "http://rds.amazonaws.com/doc/2013-01-10/"
	  },
	  "operations": {
	    "AddSourceIdentifierToSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SourceIdentifier"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SourceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AddSourceIdentifierToSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "AddTagsToResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "Tags"
	        ],
	        "members": {
	          "ResourceName": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "AuthorizeDBSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupId": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "CopyDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBSnapshotIdentifier",
	          "TargetDBSnapshotIdentifier"
	        ],
	        "members": {
	          "SourceDBSnapshotIdentifier": {},
	          "TargetDBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "CreateDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "AllocatedStorage",
	          "DBInstanceClass",
	          "Engine",
	          "MasterUsername",
	          "MasterUserPassword"
	        ],
	        "members": {
	          "DBName": {},
	          "DBInstanceIdentifier": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "DBInstanceClass": {},
	          "Engine": {},
	          "MasterUsername": {},
	          "MasterUserPassword": {},
	          "DBSecurityGroups": {
	            "shape": "Sp"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "Sq"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "PreferredMaintenanceWindow": {},
	          "DBParameterGroupName": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {},
	          "Port": {
	            "type": "integer"
	          },
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "CharacterSetName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "CreateDBInstanceReadReplica": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "SourceDBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "SourceDBInstanceIdentifier": {},
	          "DBInstanceClass": {},
	          "AvailabilityZone": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBInstanceReadReplicaResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "CreateDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName",
	          "DBParameterGroupFamily",
	          "Description"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "DBParameterGroupFamily": {},
	          "Description": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBParameterGroupResult",
	        "type": "structure",
	        "members": {
	          "DBParameterGroup": {
	            "shape": "S1c"
	          }
	        }
	      }
	    },
	    "CreateDBSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName",
	          "DBSecurityGroupDescription"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "DBSecurityGroupDescription": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSecurityGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "CreateDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier",
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {},
	          "DBInstanceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "CreateDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName",
	          "DBSubnetGroupDescription",
	          "SubnetIds"
	        ],
	        "members": {
	          "DBSubnetGroupName": {},
	          "DBSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S1i"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSubnetGroup": {
	            "shape": "S11"
	          }
	        }
	      }
	    },
	    "CreateEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SnsTopicArn"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "SourceIds": {
	            "shape": "S5"
	          },
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "CreateOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName",
	          "EngineName",
	          "MajorEngineVersion",
	          "OptionGroupDescription"
	        ],
	        "members": {
	          "OptionGroupName": {},
	          "EngineName": {},
	          "MajorEngineVersion": {},
	          "OptionGroupDescription": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "S1o"
	          }
	        }
	      }
	    },
	    "DeleteDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "SkipFinalSnapshot": {
	            "type": "boolean"
	          },
	          "FinalDBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "DeleteDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {}
	        }
	      }
	    },
	    "DeleteDBSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {}
	        }
	      }
	    },
	    "DeleteDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "DeleteDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName"
	        ],
	        "members": {
	          "DBSubnetGroupName": {}
	        }
	      }
	    },
	    "DeleteEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "DeleteOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName"
	        ],
	        "members": {
	          "OptionGroupName": {}
	        }
	      }
	    },
	    "DescribeDBEngineVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "DBParameterGroupFamily": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "DefaultOnly": {
	            "type": "boolean"
	          },
	          "ListSupportedCharacterSets": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBEngineVersionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBEngineVersions": {
	            "type": "list",
	            "member": {
	              "locationName": "DBEngineVersion",
	              "type": "structure",
	              "members": {
	                "Engine": {},
	                "EngineVersion": {},
	                "DBParameterGroupFamily": {},
	                "DBEngineDescription": {},
	                "DBEngineVersionDescription": {},
	                "DefaultCharacterSet": {
	                  "shape": "S25"
	                },
	                "SupportedCharacterSets": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S25",
	                    "locationName": "CharacterSet"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBInstanceIdentifier": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBInstancesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBInstances": {
	            "type": "list",
	            "member": {
	              "shape": "St",
	              "locationName": "DBInstance"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBParameterGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBParameterGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBParameterGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBParameterGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S1c",
	              "locationName": "DBParameterGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "Source": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBParametersResult",
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "shape": "S2f"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBSecurityGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBSecurityGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSecurityGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSecurityGroups": {
	            "type": "list",
	            "member": {
	              "shape": "Sd",
	              "locationName": "DBSecurityGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBSnapshots": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBInstanceIdentifier": {},
	          "DBSnapshotIdentifier": {},
	          "SnapshotType": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSnapshotsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSnapshots": {
	            "type": "list",
	            "member": {
	              "shape": "Sk",
	              "locationName": "DBSnapshot"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBSubnetGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBSubnetGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSubnetGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSubnetGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S11",
	              "locationName": "DBSubnetGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEngineDefaultParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupFamily"
	        ],
	        "members": {
	          "DBParameterGroupFamily": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEngineDefaultParametersResult",
	        "type": "structure",
	        "members": {
	          "EngineDefaults": {
	            "type": "structure",
	            "members": {
	              "DBParameterGroupFamily": {},
	              "Marker": {},
	              "Parameters": {
	                "shape": "S2f"
	              }
	            },
	            "wrapper": true
	          }
	        }
	      }
	    },
	    "DescribeEventCategories": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventCategoriesResult",
	        "type": "structure",
	        "members": {
	          "EventCategoriesMapList": {
	            "type": "list",
	            "member": {
	              "locationName": "EventCategoriesMap",
	              "type": "structure",
	              "members": {
	                "SourceType": {},
	                "EventCategories": {
	                  "shape": "S6"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DescribeEventSubscriptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SubscriptionName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventSubscriptionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "EventSubscriptionsList": {
	            "type": "list",
	            "member": {
	              "shape": "S4",
	              "locationName": "EventSubscription"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEvents": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceIdentifier": {},
	          "SourceType": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Duration": {
	            "type": "integer"
	          },
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Events": {
	            "type": "list",
	            "member": {
	              "locationName": "Event",
	              "type": "structure",
	              "members": {
	                "SourceIdentifier": {},
	                "SourceType": {},
	                "Message": {},
	                "EventCategories": {
	                  "shape": "S6"
	                },
	                "Date": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeOptionGroupOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EngineName"
	        ],
	        "members": {
	          "EngineName": {},
	          "MajorEngineVersion": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOptionGroupOptionsResult",
	        "type": "structure",
	        "members": {
	          "OptionGroupOptions": {
	            "type": "list",
	            "member": {
	              "locationName": "OptionGroupOption",
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Description": {},
	                "EngineName": {},
	                "MajorEngineVersion": {},
	                "MinimumRequiredMinorEngineVersion": {},
	                "PortRequired": {
	                  "type": "boolean"
	                },
	                "DefaultPort": {
	                  "type": "integer"
	                },
	                "OptionsDependedOn": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "OptionName"
	                  }
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeOptionGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OptionGroupName": {},
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "EngineName": {},
	          "MajorEngineVersion": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOptionGroupsResult",
	        "type": "structure",
	        "members": {
	          "OptionGroupsList": {
	            "type": "list",
	            "member": {
	              "shape": "S1o",
	              "locationName": "OptionGroup"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeOrderableDBInstanceOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Engine"
	        ],
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "DBInstanceClass": {},
	          "LicenseModel": {},
	          "Vpc": {
	            "type": "boolean"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
	        "type": "structure",
	        "members": {
	          "OrderableDBInstanceOptions": {
	            "type": "list",
	            "member": {
	              "locationName": "OrderableDBInstanceOption",
	              "type": "structure",
	              "members": {
	                "Engine": {},
	                "EngineVersion": {},
	                "DBInstanceClass": {},
	                "LicenseModel": {},
	                "AvailabilityZones": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S14",
	                    "locationName": "AvailabilityZone"
	                  }
	                },
	                "MultiAZCapable": {
	                  "type": "boolean"
	                },
	                "ReadReplicaCapable": {
	                  "type": "boolean"
	                },
	                "Vpc": {
	                  "type": "boolean"
	                }
	              },
	              "wrapper": true
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeReservedDBInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedDBInstanceId": {},
	          "ReservedDBInstancesOfferingId": {},
	          "DBInstanceClass": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedDBInstancesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedDBInstances": {
	            "type": "list",
	            "member": {
	              "shape": "S3m",
	              "locationName": "ReservedDBInstance"
	            }
	          }
	        }
	      }
	    },
	    "DescribeReservedDBInstancesOfferings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedDBInstancesOfferingId": {},
	          "DBInstanceClass": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedDBInstancesOfferings": {
	            "type": "list",
	            "member": {
	              "locationName": "ReservedDBInstancesOffering",
	              "type": "structure",
	              "members": {
	                "ReservedDBInstancesOfferingId": {},
	                "DBInstanceClass": {},
	                "Duration": {
	                  "type": "integer"
	                },
	                "FixedPrice": {
	                  "type": "double"
	                },
	                "UsagePrice": {
	                  "type": "double"
	                },
	                "CurrencyCode": {},
	                "ProductDescription": {},
	                "OfferingType": {},
	                "MultiAZ": {
	                  "type": "boolean"
	                },
	                "RecurringCharges": {
	                  "shape": "S3o"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName"
	        ],
	        "members": {
	          "ResourceName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTagsForResourceResult",
	        "type": "structure",
	        "members": {
	          "TagList": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "ModifyDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "DBInstanceClass": {},
	          "DBSecurityGroups": {
	            "shape": "Sp"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "Sq"
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "MasterUserPassword": {},
	          "DBParameterGroupName": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {},
	          "PreferredMaintenanceWindow": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AllowMajorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "NewDBInstanceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "ModifyDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName",
	          "Parameters"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "Parameters": {
	            "shape": "S2f"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3z",
	        "resultWrapper": "ModifyDBParameterGroupResult"
	      }
	    },
	    "ModifyDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName",
	          "SubnetIds"
	        ],
	        "members": {
	          "DBSubnetGroupName": {},
	          "DBSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S1i"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSubnetGroup": {
	            "shape": "S11"
	          }
	        }
	      }
	    },
	    "ModifyEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "ModifyOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName"
	        ],
	        "members": {
	          "OptionGroupName": {},
	          "OptionsToInclude": {
	            "type": "list",
	            "member": {
	              "locationName": "OptionConfiguration",
	              "type": "structure",
	              "required": [
	                "OptionName"
	              ],
	              "members": {
	                "OptionName": {},
	                "Port": {
	                  "type": "integer"
	                },
	                "DBSecurityGroupMemberships": {
	                  "shape": "Sp"
	                },
	                "VpcSecurityGroupMemberships": {
	                  "shape": "Sq"
	                }
	              }
	            }
	          },
	          "OptionsToRemove": {
	            "type": "list",
	            "member": {}
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "S1o"
	          }
	        }
	      }
	    },
	    "PromoteReadReplica": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "PromoteReadReplicaResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "PurchaseReservedDBInstancesOffering": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedDBInstancesOfferingId"
	        ],
	        "members": {
	          "ReservedDBInstancesOfferingId": {},
	          "ReservedDBInstanceId": {},
	          "DBInstanceCount": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
	        "type": "structure",
	        "members": {
	          "ReservedDBInstance": {
	            "shape": "S3m"
	          }
	        }
	      }
	    },
	    "RebootDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "ForceFailover": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RebootDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "RemoveSourceIdentifierFromSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SourceIdentifier"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SourceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "RemoveTagsFromResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceName": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "ResetDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "ResetAllParameters": {
	            "type": "boolean"
	          },
	          "Parameters": {
	            "shape": "S2f"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3z",
	        "resultWrapper": "ResetDBParameterGroupResult"
	      }
	    },
	    "RestoreDBInstanceFromDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "DBSnapshotIdentifier": {},
	          "DBInstanceClass": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "DBName": {},
	          "Engine": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "RestoreDBInstanceToPointInTime": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBInstanceIdentifier",
	          "TargetDBInstanceIdentifier"
	        ],
	        "members": {
	          "SourceDBInstanceIdentifier": {},
	          "TargetDBInstanceIdentifier": {},
	          "RestoreTime": {
	            "type": "timestamp"
	          },
	          "UseLatestRestorableTime": {
	            "type": "boolean"
	          },
	          "DBInstanceClass": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "DBName": {},
	          "Engine": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBInstanceToPointInTimeResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "RevokeDBSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupId": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RevokeDBSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "CustomerAwsId": {},
	        "CustSubscriptionId": {},
	        "SnsTopicArn": {},
	        "Status": {},
	        "SubscriptionCreationTime": {},
	        "SourceType": {},
	        "SourceIdsList": {
	          "shape": "S5"
	        },
	        "EventCategoriesList": {
	          "shape": "S6"
	        },
	        "Enabled": {
	          "type": "boolean"
	        }
	      },
	      "wrapper": true
	    },
	    "S5": {
	      "type": "list",
	      "member": {
	        "locationName": "SourceId"
	      }
	    },
	    "S6": {
	      "type": "list",
	      "member": {
	        "locationName": "EventCategory"
	      }
	    },
	    "S9": {
	      "type": "list",
	      "member": {
	        "locationName": "Tag",
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sd": {
	      "type": "structure",
	      "members": {
	        "OwnerId": {},
	        "DBSecurityGroupName": {},
	        "DBSecurityGroupDescription": {},
	        "VpcId": {},
	        "EC2SecurityGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "EC2SecurityGroup",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "EC2SecurityGroupName": {},
	              "EC2SecurityGroupId": {},
	              "EC2SecurityGroupOwnerId": {}
	            }
	          }
	        },
	        "IPRanges": {
	          "type": "list",
	          "member": {
	            "locationName": "IPRange",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "CIDRIP": {}
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "Sk": {
	      "type": "structure",
	      "members": {
	        "DBSnapshotIdentifier": {},
	        "DBInstanceIdentifier": {},
	        "SnapshotCreateTime": {
	          "type": "timestamp"
	        },
	        "Engine": {},
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "Status": {},
	        "Port": {
	          "type": "integer"
	        },
	        "AvailabilityZone": {},
	        "VpcId": {},
	        "InstanceCreateTime": {
	          "type": "timestamp"
	        },
	        "MasterUsername": {},
	        "EngineVersion": {},
	        "LicenseModel": {},
	        "SnapshotType": {},
	        "Iops": {
	          "type": "integer"
	        }
	      },
	      "wrapper": true
	    },
	    "Sp": {
	      "type": "list",
	      "member": {
	        "locationName": "DBSecurityGroupName"
	      }
	    },
	    "Sq": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroupId"
	      }
	    },
	    "St": {
	      "type": "structure",
	      "members": {
	        "DBInstanceIdentifier": {},
	        "DBInstanceClass": {},
	        "Engine": {},
	        "DBInstanceStatus": {},
	        "MasterUsername": {},
	        "DBName": {},
	        "Endpoint": {
	          "type": "structure",
	          "members": {
	            "Address": {},
	            "Port": {
	              "type": "integer"
	            }
	          }
	        },
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "InstanceCreateTime": {
	          "type": "timestamp"
	        },
	        "PreferredBackupWindow": {},
	        "BackupRetentionPeriod": {
	          "type": "integer"
	        },
	        "DBSecurityGroups": {
	          "shape": "Sv"
	        },
	        "VpcSecurityGroups": {
	          "shape": "Sx"
	        },
	        "DBParameterGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "DBParameterGroup",
	            "type": "structure",
	            "members": {
	              "DBParameterGroupName": {},
	              "ParameterApplyStatus": {}
	            }
	          }
	        },
	        "AvailabilityZone": {},
	        "DBSubnetGroup": {
	          "shape": "S11"
	        },
	        "PreferredMaintenanceWindow": {},
	        "PendingModifiedValues": {
	          "type": "structure",
	          "members": {
	            "DBInstanceClass": {},
	            "AllocatedStorage": {
	              "type": "integer"
	            },
	            "MasterUserPassword": {},
	            "Port": {
	              "type": "integer"
	            },
	            "BackupRetentionPeriod": {
	              "type": "integer"
	            },
	            "MultiAZ": {
	              "type": "boolean"
	            },
	            "EngineVersion": {},
	            "Iops": {
	              "type": "integer"
	            },
	            "DBInstanceIdentifier": {}
	          }
	        },
	        "LatestRestorableTime": {
	          "type": "timestamp"
	        },
	        "MultiAZ": {
	          "type": "boolean"
	        },
	        "EngineVersion": {},
	        "AutoMinorVersionUpgrade": {
	          "type": "boolean"
	        },
	        "ReadReplicaSourceDBInstanceIdentifier": {},
	        "ReadReplicaDBInstanceIdentifiers": {
	          "type": "list",
	          "member": {
	            "locationName": "ReadReplicaDBInstanceIdentifier"
	          }
	        },
	        "LicenseModel": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "OptionGroupMembership": {
	          "type": "structure",
	          "members": {
	            "OptionGroupName": {},
	            "Status": {}
	          }
	        },
	        "CharacterSetName": {},
	        "SecondaryAvailabilityZone": {},
	        "PubliclyAccessible": {
	          "type": "boolean"
	        }
	      },
	      "wrapper": true
	    },
	    "Sv": {
	      "type": "list",
	      "member": {
	        "locationName": "DBSecurityGroup",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroupName": {},
	          "Status": {}
	        }
	      }
	    },
	    "Sx": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroupMembership",
	        "type": "structure",
	        "members": {
	          "VpcSecurityGroupId": {},
	          "Status": {}
	        }
	      }
	    },
	    "S11": {
	      "type": "structure",
	      "members": {
	        "DBSubnetGroupName": {},
	        "DBSubnetGroupDescription": {},
	        "VpcId": {},
	        "SubnetGroupStatus": {},
	        "Subnets": {
	          "type": "list",
	          "member": {
	            "locationName": "Subnet",
	            "type": "structure",
	            "members": {
	              "SubnetIdentifier": {},
	              "SubnetAvailabilityZone": {
	                "shape": "S14"
	              },
	              "SubnetStatus": {}
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "S14": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "ProvisionedIopsCapable": {
	          "type": "boolean"
	        }
	      },
	      "wrapper": true
	    },
	    "S1c": {
	      "type": "structure",
	      "members": {
	        "DBParameterGroupName": {},
	        "DBParameterGroupFamily": {},
	        "Description": {}
	      },
	      "wrapper": true
	    },
	    "S1i": {
	      "type": "list",
	      "member": {
	        "locationName": "SubnetIdentifier"
	      }
	    },
	    "S1o": {
	      "type": "structure",
	      "members": {
	        "OptionGroupName": {},
	        "OptionGroupDescription": {},
	        "EngineName": {},
	        "MajorEngineVersion": {},
	        "Options": {
	          "type": "list",
	          "member": {
	            "locationName": "Option",
	            "type": "structure",
	            "members": {
	              "OptionName": {},
	              "OptionDescription": {},
	              "Port": {
	                "type": "integer"
	              },
	              "DBSecurityGroupMemberships": {
	                "shape": "Sv"
	              },
	              "VpcSecurityGroupMemberships": {
	                "shape": "Sx"
	              }
	            }
	          }
	        },
	        "AllowsVpcAndNonVpcInstanceMemberships": {
	          "type": "boolean"
	        },
	        "VpcId": {}
	      },
	      "wrapper": true
	    },
	    "S25": {
	      "type": "structure",
	      "members": {
	        "CharacterSetName": {},
	        "CharacterSetDescription": {}
	      }
	    },
	    "S2f": {
	      "type": "list",
	      "member": {
	        "locationName": "Parameter",
	        "type": "structure",
	        "members": {
	          "ParameterName": {},
	          "ParameterValue": {},
	          "Description": {},
	          "Source": {},
	          "ApplyType": {},
	          "DataType": {},
	          "AllowedValues": {},
	          "IsModifiable": {
	            "type": "boolean"
	          },
	          "MinimumEngineVersion": {},
	          "ApplyMethod": {}
	        }
	      }
	    },
	    "S3m": {
	      "type": "structure",
	      "members": {
	        "ReservedDBInstanceId": {},
	        "ReservedDBInstancesOfferingId": {},
	        "DBInstanceClass": {},
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "Duration": {
	          "type": "integer"
	        },
	        "FixedPrice": {
	          "type": "double"
	        },
	        "UsagePrice": {
	          "type": "double"
	        },
	        "CurrencyCode": {},
	        "DBInstanceCount": {
	          "type": "integer"
	        },
	        "ProductDescription": {},
	        "OfferingType": {},
	        "MultiAZ": {
	          "type": "boolean"
	        },
	        "State": {},
	        "RecurringCharges": {
	          "shape": "S3o"
	        }
	      },
	      "wrapper": true
	    },
	    "S3o": {
	      "type": "list",
	      "member": {
	        "locationName": "RecurringCharge",
	        "type": "structure",
	        "members": {
	          "RecurringChargeAmount": {
	            "type": "double"
	          },
	          "RecurringChargeFrequency": {}
	        },
	        "wrapper": true
	      }
	    },
	    "S3z": {
	      "type": "structure",
	      "members": {
	        "DBParameterGroupName": {}
	      }
	    }
	  }
	}
	},{}],184:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeDBEngineVersions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBEngineVersions"
	    },
	    "DescribeDBInstances": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBInstances"
	    },
	    "DescribeDBParameterGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBParameterGroups"
	    },
	    "DescribeDBParameters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Parameters"
	    },
	    "DescribeDBSecurityGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBSecurityGroups"
	    },
	    "DescribeDBSnapshots": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBSnapshots"
	    },
	    "DescribeDBSubnetGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBSubnetGroups"
	    },
	    "DescribeEngineDefaultParameters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "EngineDefaults.Marker",
	      "result_key": "EngineDefaults.Parameters"
	    },
	    "DescribeEventSubscriptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "EventSubscriptionsList"
	    },
	    "DescribeEvents": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Events"
	    },
	    "DescribeOptionGroupOptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "OptionGroupOptions"
	    },
	    "DescribeOptionGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "OptionGroupsList"
	    },
	    "DescribeOrderableDBInstanceOptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "OrderableDBInstanceOptions"
	    },
	    "DescribeReservedDBInstances": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedDBInstances"
	    },
	    "DescribeReservedDBInstancesOfferings": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedDBInstancesOfferings"
	    },
	    "ListTagsForResource": {
	      "result_key": "TagList"
	    }
	  }
	}
	},{}],185:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2013-02-12",
	    "endpointPrefix": "rds",
	    "protocol": "query",
	    "serviceAbbreviation": "Amazon RDS",
	    "serviceFullName": "Amazon Relational Database Service",
	    "serviceId": "RDS",
	    "signatureVersion": "v4",
	    "uid": "rds-2013-02-12",
	    "xmlNamespace": "http://rds.amazonaws.com/doc/2013-02-12/"
	  },
	  "operations": {
	    "AddSourceIdentifierToSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SourceIdentifier"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SourceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AddSourceIdentifierToSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "AddTagsToResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "Tags"
	        ],
	        "members": {
	          "ResourceName": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "AuthorizeDBSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupId": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "CopyDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBSnapshotIdentifier",
	          "TargetDBSnapshotIdentifier"
	        ],
	        "members": {
	          "SourceDBSnapshotIdentifier": {},
	          "TargetDBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "CreateDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "AllocatedStorage",
	          "DBInstanceClass",
	          "Engine",
	          "MasterUsername",
	          "MasterUserPassword"
	        ],
	        "members": {
	          "DBName": {},
	          "DBInstanceIdentifier": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "DBInstanceClass": {},
	          "Engine": {},
	          "MasterUsername": {},
	          "MasterUserPassword": {},
	          "DBSecurityGroups": {
	            "shape": "Sp"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "Sq"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "PreferredMaintenanceWindow": {},
	          "DBParameterGroupName": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {},
	          "Port": {
	            "type": "integer"
	          },
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "CharacterSetName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "CreateDBInstanceReadReplica": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "SourceDBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "SourceDBInstanceIdentifier": {},
	          "DBInstanceClass": {},
	          "AvailabilityZone": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBInstanceReadReplicaResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "CreateDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName",
	          "DBParameterGroupFamily",
	          "Description"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "DBParameterGroupFamily": {},
	          "Description": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBParameterGroupResult",
	        "type": "structure",
	        "members": {
	          "DBParameterGroup": {
	            "shape": "S1d"
	          }
	        }
	      }
	    },
	    "CreateDBSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName",
	          "DBSecurityGroupDescription"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "DBSecurityGroupDescription": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSecurityGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "CreateDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier",
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {},
	          "DBInstanceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "CreateDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName",
	          "DBSubnetGroupDescription",
	          "SubnetIds"
	        ],
	        "members": {
	          "DBSubnetGroupName": {},
	          "DBSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSubnetGroup": {
	            "shape": "S11"
	          }
	        }
	      }
	    },
	    "CreateEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SnsTopicArn"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "SourceIds": {
	            "shape": "S5"
	          },
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "CreateOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName",
	          "EngineName",
	          "MajorEngineVersion",
	          "OptionGroupDescription"
	        ],
	        "members": {
	          "OptionGroupName": {},
	          "EngineName": {},
	          "MajorEngineVersion": {},
	          "OptionGroupDescription": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "S1p"
	          }
	        }
	      }
	    },
	    "DeleteDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "SkipFinalSnapshot": {
	            "type": "boolean"
	          },
	          "FinalDBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "DeleteDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {}
	        }
	      }
	    },
	    "DeleteDBSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {}
	        }
	      }
	    },
	    "DeleteDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "DeleteDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName"
	        ],
	        "members": {
	          "DBSubnetGroupName": {}
	        }
	      }
	    },
	    "DeleteEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "DeleteOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName"
	        ],
	        "members": {
	          "OptionGroupName": {}
	        }
	      }
	    },
	    "DescribeDBEngineVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "DBParameterGroupFamily": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "DefaultOnly": {
	            "type": "boolean"
	          },
	          "ListSupportedCharacterSets": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBEngineVersionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBEngineVersions": {
	            "type": "list",
	            "member": {
	              "locationName": "DBEngineVersion",
	              "type": "structure",
	              "members": {
	                "Engine": {},
	                "EngineVersion": {},
	                "DBParameterGroupFamily": {},
	                "DBEngineDescription": {},
	                "DBEngineVersionDescription": {},
	                "DefaultCharacterSet": {
	                  "shape": "S28"
	                },
	                "SupportedCharacterSets": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S28",
	                    "locationName": "CharacterSet"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBInstanceIdentifier": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBInstancesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBInstances": {
	            "type": "list",
	            "member": {
	              "shape": "St",
	              "locationName": "DBInstance"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBLogFiles": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "FilenameContains": {},
	          "FileLastWritten": {
	            "type": "long"
	          },
	          "FileSize": {
	            "type": "long"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBLogFilesResult",
	        "type": "structure",
	        "members": {
	          "DescribeDBLogFiles": {
	            "type": "list",
	            "member": {
	              "locationName": "DescribeDBLogFilesDetails",
	              "type": "structure",
	              "members": {
	                "LogFileName": {},
	                "LastWritten": {
	                  "type": "long"
	                },
	                "Size": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBParameterGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBParameterGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBParameterGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBParameterGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S1d",
	              "locationName": "DBParameterGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "Source": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBParametersResult",
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "shape": "S2n"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBSecurityGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBSecurityGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSecurityGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSecurityGroups": {
	            "type": "list",
	            "member": {
	              "shape": "Sd",
	              "locationName": "DBSecurityGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBSnapshots": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBInstanceIdentifier": {},
	          "DBSnapshotIdentifier": {},
	          "SnapshotType": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSnapshotsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSnapshots": {
	            "type": "list",
	            "member": {
	              "shape": "Sk",
	              "locationName": "DBSnapshot"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBSubnetGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBSubnetGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSubnetGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSubnetGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S11",
	              "locationName": "DBSubnetGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEngineDefaultParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupFamily"
	        ],
	        "members": {
	          "DBParameterGroupFamily": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEngineDefaultParametersResult",
	        "type": "structure",
	        "members": {
	          "EngineDefaults": {
	            "type": "structure",
	            "members": {
	              "DBParameterGroupFamily": {},
	              "Marker": {},
	              "Parameters": {
	                "shape": "S2n"
	              }
	            },
	            "wrapper": true
	          }
	        }
	      }
	    },
	    "DescribeEventCategories": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventCategoriesResult",
	        "type": "structure",
	        "members": {
	          "EventCategoriesMapList": {
	            "type": "list",
	            "member": {
	              "locationName": "EventCategoriesMap",
	              "type": "structure",
	              "members": {
	                "SourceType": {},
	                "EventCategories": {
	                  "shape": "S6"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DescribeEventSubscriptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SubscriptionName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventSubscriptionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "EventSubscriptionsList": {
	            "type": "list",
	            "member": {
	              "shape": "S4",
	              "locationName": "EventSubscription"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEvents": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceIdentifier": {},
	          "SourceType": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Duration": {
	            "type": "integer"
	          },
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Events": {
	            "type": "list",
	            "member": {
	              "locationName": "Event",
	              "type": "structure",
	              "members": {
	                "SourceIdentifier": {},
	                "SourceType": {},
	                "Message": {},
	                "EventCategories": {
	                  "shape": "S6"
	                },
	                "Date": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeOptionGroupOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EngineName"
	        ],
	        "members": {
	          "EngineName": {},
	          "MajorEngineVersion": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOptionGroupOptionsResult",
	        "type": "structure",
	        "members": {
	          "OptionGroupOptions": {
	            "type": "list",
	            "member": {
	              "locationName": "OptionGroupOption",
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Description": {},
	                "EngineName": {},
	                "MajorEngineVersion": {},
	                "MinimumRequiredMinorEngineVersion": {},
	                "PortRequired": {
	                  "type": "boolean"
	                },
	                "DefaultPort": {
	                  "type": "integer"
	                },
	                "OptionsDependedOn": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "OptionName"
	                  }
	                },
	                "Persistent": {
	                  "type": "boolean"
	                },
	                "OptionGroupOptionSettings": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "OptionGroupOptionSetting",
	                    "type": "structure",
	                    "members": {
	                      "SettingName": {},
	                      "SettingDescription": {},
	                      "DefaultValue": {},
	                      "ApplyType": {},
	                      "AllowedValues": {},
	                      "IsModifiable": {
	                        "type": "boolean"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeOptionGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OptionGroupName": {},
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "EngineName": {},
	          "MajorEngineVersion": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOptionGroupsResult",
	        "type": "structure",
	        "members": {
	          "OptionGroupsList": {
	            "type": "list",
	            "member": {
	              "shape": "S1p",
	              "locationName": "OptionGroup"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeOrderableDBInstanceOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Engine"
	        ],
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "DBInstanceClass": {},
	          "LicenseModel": {},
	          "Vpc": {
	            "type": "boolean"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
	        "type": "structure",
	        "members": {
	          "OrderableDBInstanceOptions": {
	            "type": "list",
	            "member": {
	              "locationName": "OrderableDBInstanceOption",
	              "type": "structure",
	              "members": {
	                "Engine": {},
	                "EngineVersion": {},
	                "DBInstanceClass": {},
	                "LicenseModel": {},
	                "AvailabilityZones": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S14",
	                    "locationName": "AvailabilityZone"
	                  }
	                },
	                "MultiAZCapable": {
	                  "type": "boolean"
	                },
	                "ReadReplicaCapable": {
	                  "type": "boolean"
	                },
	                "Vpc": {
	                  "type": "boolean"
	                }
	              },
	              "wrapper": true
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeReservedDBInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedDBInstanceId": {},
	          "ReservedDBInstancesOfferingId": {},
	          "DBInstanceClass": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedDBInstancesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedDBInstances": {
	            "type": "list",
	            "member": {
	              "shape": "S3w",
	              "locationName": "ReservedDBInstance"
	            }
	          }
	        }
	      }
	    },
	    "DescribeReservedDBInstancesOfferings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedDBInstancesOfferingId": {},
	          "DBInstanceClass": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedDBInstancesOfferings": {
	            "type": "list",
	            "member": {
	              "locationName": "ReservedDBInstancesOffering",
	              "type": "structure",
	              "members": {
	                "ReservedDBInstancesOfferingId": {},
	                "DBInstanceClass": {},
	                "Duration": {
	                  "type": "integer"
	                },
	                "FixedPrice": {
	                  "type": "double"
	                },
	                "UsagePrice": {
	                  "type": "double"
	                },
	                "CurrencyCode": {},
	                "ProductDescription": {},
	                "OfferingType": {},
	                "MultiAZ": {
	                  "type": "boolean"
	                },
	                "RecurringCharges": {
	                  "shape": "S3y"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DownloadDBLogFilePortion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "LogFileName"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "LogFileName": {},
	          "Marker": {},
	          "NumberOfLines": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DownloadDBLogFilePortionResult",
	        "type": "structure",
	        "members": {
	          "LogFileData": {},
	          "Marker": {},
	          "AdditionalDataPending": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName"
	        ],
	        "members": {
	          "ResourceName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTagsForResourceResult",
	        "type": "structure",
	        "members": {
	          "TagList": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "ModifyDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "DBInstanceClass": {},
	          "DBSecurityGroups": {
	            "shape": "Sp"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "Sq"
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "MasterUserPassword": {},
	          "DBParameterGroupName": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {},
	          "PreferredMaintenanceWindow": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AllowMajorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "NewDBInstanceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "ModifyDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName",
	          "Parameters"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "Parameters": {
	            "shape": "S2n"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4b",
	        "resultWrapper": "ModifyDBParameterGroupResult"
	      }
	    },
	    "ModifyDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName",
	          "SubnetIds"
	        ],
	        "members": {
	          "DBSubnetGroupName": {},
	          "DBSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S1j"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSubnetGroup": {
	            "shape": "S11"
	          }
	        }
	      }
	    },
	    "ModifyEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "ModifyOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName"
	        ],
	        "members": {
	          "OptionGroupName": {},
	          "OptionsToInclude": {
	            "type": "list",
	            "member": {
	              "locationName": "OptionConfiguration",
	              "type": "structure",
	              "required": [
	                "OptionName"
	              ],
	              "members": {
	                "OptionName": {},
	                "Port": {
	                  "type": "integer"
	                },
	                "DBSecurityGroupMemberships": {
	                  "shape": "Sp"
	                },
	                "VpcSecurityGroupMemberships": {
	                  "shape": "Sq"
	                },
	                "OptionSettings": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S1t",
	                    "locationName": "OptionSetting"
	                  }
	                }
	              }
	            }
	          },
	          "OptionsToRemove": {
	            "type": "list",
	            "member": {}
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "S1p"
	          }
	        }
	      }
	    },
	    "PromoteReadReplica": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "PromoteReadReplicaResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "PurchaseReservedDBInstancesOffering": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedDBInstancesOfferingId"
	        ],
	        "members": {
	          "ReservedDBInstancesOfferingId": {},
	          "ReservedDBInstanceId": {},
	          "DBInstanceCount": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
	        "type": "structure",
	        "members": {
	          "ReservedDBInstance": {
	            "shape": "S3w"
	          }
	        }
	      }
	    },
	    "RebootDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "ForceFailover": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RebootDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "RemoveSourceIdentifierFromSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SourceIdentifier"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SourceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "RemoveTagsFromResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceName": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "ResetDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "ResetAllParameters": {
	            "type": "boolean"
	          },
	          "Parameters": {
	            "shape": "S2n"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4b",
	        "resultWrapper": "ResetDBParameterGroupResult"
	      }
	    },
	    "RestoreDBInstanceFromDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "DBSnapshotIdentifier": {},
	          "DBInstanceClass": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "DBName": {},
	          "Engine": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "RestoreDBInstanceToPointInTime": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBInstanceIdentifier",
	          "TargetDBInstanceIdentifier"
	        ],
	        "members": {
	          "SourceDBInstanceIdentifier": {},
	          "TargetDBInstanceIdentifier": {},
	          "RestoreTime": {
	            "type": "timestamp"
	          },
	          "UseLatestRestorableTime": {
	            "type": "boolean"
	          },
	          "DBInstanceClass": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "DBName": {},
	          "Engine": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBInstanceToPointInTimeResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "RevokeDBSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupId": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RevokeDBSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "members": {
	        "CustomerAwsId": {},
	        "CustSubscriptionId": {},
	        "SnsTopicArn": {},
	        "Status": {},
	        "SubscriptionCreationTime": {},
	        "SourceType": {},
	        "SourceIdsList": {
	          "shape": "S5"
	        },
	        "EventCategoriesList": {
	          "shape": "S6"
	        },
	        "Enabled": {
	          "type": "boolean"
	        }
	      },
	      "wrapper": true
	    },
	    "S5": {
	      "type": "list",
	      "member": {
	        "locationName": "SourceId"
	      }
	    },
	    "S6": {
	      "type": "list",
	      "member": {
	        "locationName": "EventCategory"
	      }
	    },
	    "S9": {
	      "type": "list",
	      "member": {
	        "locationName": "Tag",
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sd": {
	      "type": "structure",
	      "members": {
	        "OwnerId": {},
	        "DBSecurityGroupName": {},
	        "DBSecurityGroupDescription": {},
	        "VpcId": {},
	        "EC2SecurityGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "EC2SecurityGroup",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "EC2SecurityGroupName": {},
	              "EC2SecurityGroupId": {},
	              "EC2SecurityGroupOwnerId": {}
	            }
	          }
	        },
	        "IPRanges": {
	          "type": "list",
	          "member": {
	            "locationName": "IPRange",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "CIDRIP": {}
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "Sk": {
	      "type": "structure",
	      "members": {
	        "DBSnapshotIdentifier": {},
	        "DBInstanceIdentifier": {},
	        "SnapshotCreateTime": {
	          "type": "timestamp"
	        },
	        "Engine": {},
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "Status": {},
	        "Port": {
	          "type": "integer"
	        },
	        "AvailabilityZone": {},
	        "VpcId": {},
	        "InstanceCreateTime": {
	          "type": "timestamp"
	        },
	        "MasterUsername": {},
	        "EngineVersion": {},
	        "LicenseModel": {},
	        "SnapshotType": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "OptionGroupName": {}
	      },
	      "wrapper": true
	    },
	    "Sp": {
	      "type": "list",
	      "member": {
	        "locationName": "DBSecurityGroupName"
	      }
	    },
	    "Sq": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroupId"
	      }
	    },
	    "St": {
	      "type": "structure",
	      "members": {
	        "DBInstanceIdentifier": {},
	        "DBInstanceClass": {},
	        "Engine": {},
	        "DBInstanceStatus": {},
	        "MasterUsername": {},
	        "DBName": {},
	        "Endpoint": {
	          "type": "structure",
	          "members": {
	            "Address": {},
	            "Port": {
	              "type": "integer"
	            }
	          }
	        },
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "InstanceCreateTime": {
	          "type": "timestamp"
	        },
	        "PreferredBackupWindow": {},
	        "BackupRetentionPeriod": {
	          "type": "integer"
	        },
	        "DBSecurityGroups": {
	          "shape": "Sv"
	        },
	        "VpcSecurityGroups": {
	          "shape": "Sx"
	        },
	        "DBParameterGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "DBParameterGroup",
	            "type": "structure",
	            "members": {
	              "DBParameterGroupName": {},
	              "ParameterApplyStatus": {}
	            }
	          }
	        },
	        "AvailabilityZone": {},
	        "DBSubnetGroup": {
	          "shape": "S11"
	        },
	        "PreferredMaintenanceWindow": {},
	        "PendingModifiedValues": {
	          "type": "structure",
	          "members": {
	            "DBInstanceClass": {},
	            "AllocatedStorage": {
	              "type": "integer"
	            },
	            "MasterUserPassword": {},
	            "Port": {
	              "type": "integer"
	            },
	            "BackupRetentionPeriod": {
	              "type": "integer"
	            },
	            "MultiAZ": {
	              "type": "boolean"
	            },
	            "EngineVersion": {},
	            "Iops": {
	              "type": "integer"
	            },
	            "DBInstanceIdentifier": {}
	          }
	        },
	        "LatestRestorableTime": {
	          "type": "timestamp"
	        },
	        "MultiAZ": {
	          "type": "boolean"
	        },
	        "EngineVersion": {},
	        "AutoMinorVersionUpgrade": {
	          "type": "boolean"
	        },
	        "ReadReplicaSourceDBInstanceIdentifier": {},
	        "ReadReplicaDBInstanceIdentifiers": {
	          "type": "list",
	          "member": {
	            "locationName": "ReadReplicaDBInstanceIdentifier"
	          }
	        },
	        "LicenseModel": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "OptionGroupMemberships": {
	          "type": "list",
	          "member": {
	            "locationName": "OptionGroupMembership",
	            "type": "structure",
	            "members": {
	              "OptionGroupName": {},
	              "Status": {}
	            }
	          }
	        },
	        "CharacterSetName": {},
	        "SecondaryAvailabilityZone": {},
	        "PubliclyAccessible": {
	          "type": "boolean"
	        }
	      },
	      "wrapper": true
	    },
	    "Sv": {
	      "type": "list",
	      "member": {
	        "locationName": "DBSecurityGroup",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroupName": {},
	          "Status": {}
	        }
	      }
	    },
	    "Sx": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroupMembership",
	        "type": "structure",
	        "members": {
	          "VpcSecurityGroupId": {},
	          "Status": {}
	        }
	      }
	    },
	    "S11": {
	      "type": "structure",
	      "members": {
	        "DBSubnetGroupName": {},
	        "DBSubnetGroupDescription": {},
	        "VpcId": {},
	        "SubnetGroupStatus": {},
	        "Subnets": {
	          "type": "list",
	          "member": {
	            "locationName": "Subnet",
	            "type": "structure",
	            "members": {
	              "SubnetIdentifier": {},
	              "SubnetAvailabilityZone": {
	                "shape": "S14"
	              },
	              "SubnetStatus": {}
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "S14": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "ProvisionedIopsCapable": {
	          "type": "boolean"
	        }
	      },
	      "wrapper": true
	    },
	    "S1d": {
	      "type": "structure",
	      "members": {
	        "DBParameterGroupName": {},
	        "DBParameterGroupFamily": {},
	        "Description": {}
	      },
	      "wrapper": true
	    },
	    "S1j": {
	      "type": "list",
	      "member": {
	        "locationName": "SubnetIdentifier"
	      }
	    },
	    "S1p": {
	      "type": "structure",
	      "members": {
	        "OptionGroupName": {},
	        "OptionGroupDescription": {},
	        "EngineName": {},
	        "MajorEngineVersion": {},
	        "Options": {
	          "type": "list",
	          "member": {
	            "locationName": "Option",
	            "type": "structure",
	            "members": {
	              "OptionName": {},
	              "OptionDescription": {},
	              "Persistent": {
	                "type": "boolean"
	              },
	              "Port": {
	                "type": "integer"
	              },
	              "OptionSettings": {
	                "type": "list",
	                "member": {
	                  "shape": "S1t",
	                  "locationName": "OptionSetting"
	                }
	              },
	              "DBSecurityGroupMemberships": {
	                "shape": "Sv"
	              },
	              "VpcSecurityGroupMemberships": {
	                "shape": "Sx"
	              }
	            }
	          }
	        },
	        "AllowsVpcAndNonVpcInstanceMemberships": {
	          "type": "boolean"
	        },
	        "VpcId": {}
	      },
	      "wrapper": true
	    },
	    "S1t": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Value": {},
	        "DefaultValue": {},
	        "Description": {},
	        "ApplyType": {},
	        "DataType": {},
	        "AllowedValues": {},
	        "IsModifiable": {
	          "type": "boolean"
	        },
	        "IsCollection": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S28": {
	      "type": "structure",
	      "members": {
	        "CharacterSetName": {},
	        "CharacterSetDescription": {}
	      }
	    },
	    "S2n": {
	      "type": "list",
	      "member": {
	        "locationName": "Parameter",
	        "type": "structure",
	        "members": {
	          "ParameterName": {},
	          "ParameterValue": {},
	          "Description": {},
	          "Source": {},
	          "ApplyType": {},
	          "DataType": {},
	          "AllowedValues": {},
	          "IsModifiable": {
	            "type": "boolean"
	          },
	          "MinimumEngineVersion": {},
	          "ApplyMethod": {}
	        }
	      }
	    },
	    "S3w": {
	      "type": "structure",
	      "members": {
	        "ReservedDBInstanceId": {},
	        "ReservedDBInstancesOfferingId": {},
	        "DBInstanceClass": {},
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "Duration": {
	          "type": "integer"
	        },
	        "FixedPrice": {
	          "type": "double"
	        },
	        "UsagePrice": {
	          "type": "double"
	        },
	        "CurrencyCode": {},
	        "DBInstanceCount": {
	          "type": "integer"
	        },
	        "ProductDescription": {},
	        "OfferingType": {},
	        "MultiAZ": {
	          "type": "boolean"
	        },
	        "State": {},
	        "RecurringCharges": {
	          "shape": "S3y"
	        }
	      },
	      "wrapper": true
	    },
	    "S3y": {
	      "type": "list",
	      "member": {
	        "locationName": "RecurringCharge",
	        "type": "structure",
	        "members": {
	          "RecurringChargeAmount": {
	            "type": "double"
	          },
	          "RecurringChargeFrequency": {}
	        },
	        "wrapper": true
	      }
	    },
	    "S4b": {
	      "type": "structure",
	      "members": {
	        "DBParameterGroupName": {}
	      }
	    }
	  }
	}
	},{}],186:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeDBEngineVersions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBEngineVersions"
	    },
	    "DescribeDBInstances": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBInstances"
	    },
	    "DescribeDBLogFiles": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DescribeDBLogFiles"
	    },
	    "DescribeDBParameterGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBParameterGroups"
	    },
	    "DescribeDBParameters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Parameters"
	    },
	    "DescribeDBSecurityGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBSecurityGroups"
	    },
	    "DescribeDBSnapshots": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBSnapshots"
	    },
	    "DescribeDBSubnetGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBSubnetGroups"
	    },
	    "DescribeEngineDefaultParameters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "EngineDefaults.Marker",
	      "result_key": "EngineDefaults.Parameters"
	    },
	    "DescribeEventSubscriptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "EventSubscriptionsList"
	    },
	    "DescribeEvents": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Events"
	    },
	    "DescribeOptionGroupOptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "OptionGroupOptions"
	    },
	    "DescribeOptionGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "OptionGroupsList"
	    },
	    "DescribeOrderableDBInstanceOptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "OrderableDBInstanceOptions"
	    },
	    "DescribeReservedDBInstances": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedDBInstances"
	    },
	    "DescribeReservedDBInstancesOfferings": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedDBInstancesOfferings"
	    },
	    "DownloadDBLogFilePortion": {
	      "input_token": "Marker",
	      "limit_key": "NumberOfLines",
	      "more_results": "AdditionalDataPending",
	      "output_token": "Marker",
	      "result_key": "LogFileData"
	    },
	    "ListTagsForResource": {
	      "result_key": "TagList"
	    }
	  }
	}
	},{}],187:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2013-09-09",
	    "endpointPrefix": "rds",
	    "protocol": "query",
	    "serviceAbbreviation": "Amazon RDS",
	    "serviceFullName": "Amazon Relational Database Service",
	    "serviceId": "RDS",
	    "signatureVersion": "v4",
	    "uid": "rds-2013-09-09",
	    "xmlNamespace": "http://rds.amazonaws.com/doc/2013-09-09/"
	  },
	  "operations": {
	    "AddSourceIdentifierToSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SourceIdentifier"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SourceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AddSourceIdentifierToSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "AddTagsToResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "Tags"
	        ],
	        "members": {
	          "ResourceName": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "AuthorizeDBSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupId": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "CopyDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBSnapshotIdentifier",
	          "TargetDBSnapshotIdentifier"
	        ],
	        "members": {
	          "SourceDBSnapshotIdentifier": {},
	          "TargetDBSnapshotIdentifier": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "CreateDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "AllocatedStorage",
	          "DBInstanceClass",
	          "Engine",
	          "MasterUsername",
	          "MasterUserPassword"
	        ],
	        "members": {
	          "DBName": {},
	          "DBInstanceIdentifier": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "DBInstanceClass": {},
	          "Engine": {},
	          "MasterUsername": {},
	          "MasterUserPassword": {},
	          "DBSecurityGroups": {
	            "shape": "Sp"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "Sq"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "PreferredMaintenanceWindow": {},
	          "DBParameterGroupName": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {},
	          "Port": {
	            "type": "integer"
	          },
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "CharacterSetName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "CreateDBInstanceReadReplica": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "SourceDBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "SourceDBInstanceIdentifier": {},
	          "DBInstanceClass": {},
	          "AvailabilityZone": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S9"
	          },
	          "DBSubnetGroupName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBInstanceReadReplicaResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "CreateDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName",
	          "DBParameterGroupFamily",
	          "Description"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "DBParameterGroupFamily": {},
	          "Description": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBParameterGroupResult",
	        "type": "structure",
	        "members": {
	          "DBParameterGroup": {
	            "shape": "S1f"
	          }
	        }
	      }
	    },
	    "CreateDBSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName",
	          "DBSecurityGroupDescription"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "DBSecurityGroupDescription": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSecurityGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "CreateDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier",
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {},
	          "DBInstanceIdentifier": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "CreateDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName",
	          "DBSubnetGroupDescription",
	          "SubnetIds"
	        ],
	        "members": {
	          "DBSubnetGroupName": {},
	          "DBSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S1l"
	          },
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSubnetGroup": {
	            "shape": "S11"
	          }
	        }
	      }
	    },
	    "CreateEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SnsTopicArn"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "SourceIds": {
	            "shape": "S5"
	          },
	          "Enabled": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "CreateOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName",
	          "EngineName",
	          "MajorEngineVersion",
	          "OptionGroupDescription"
	        ],
	        "members": {
	          "OptionGroupName": {},
	          "EngineName": {},
	          "MajorEngineVersion": {},
	          "OptionGroupDescription": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "S1r"
	          }
	        }
	      }
	    },
	    "DeleteDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "SkipFinalSnapshot": {
	            "type": "boolean"
	          },
	          "FinalDBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "DeleteDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {}
	        }
	      }
	    },
	    "DeleteDBSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {}
	        }
	      }
	    },
	    "DeleteDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "DeleteDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName"
	        ],
	        "members": {
	          "DBSubnetGroupName": {}
	        }
	      }
	    },
	    "DeleteEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "DeleteOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName"
	        ],
	        "members": {
	          "OptionGroupName": {}
	        }
	      }
	    },
	    "DescribeDBEngineVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "DBParameterGroupFamily": {},
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "DefaultOnly": {
	            "type": "boolean"
	          },
	          "ListSupportedCharacterSets": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBEngineVersionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBEngineVersions": {
	            "type": "list",
	            "member": {
	              "locationName": "DBEngineVersion",
	              "type": "structure",
	              "members": {
	                "Engine": {},
	                "EngineVersion": {},
	                "DBParameterGroupFamily": {},
	                "DBEngineDescription": {},
	                "DBEngineVersionDescription": {},
	                "DefaultCharacterSet": {
	                  "shape": "S2d"
	                },
	                "SupportedCharacterSets": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S2d",
	                    "locationName": "CharacterSet"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBInstanceIdentifier": {},
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBInstancesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBInstances": {
	            "type": "list",
	            "member": {
	              "shape": "St",
	              "locationName": "DBInstance"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBLogFiles": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "FilenameContains": {},
	          "FileLastWritten": {
	            "type": "long"
	          },
	          "FileSize": {
	            "type": "long"
	          },
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBLogFilesResult",
	        "type": "structure",
	        "members": {
	          "DescribeDBLogFiles": {
	            "type": "list",
	            "member": {
	              "locationName": "DescribeDBLogFilesDetails",
	              "type": "structure",
	              "members": {
	                "LogFileName": {},
	                "LastWritten": {
	                  "type": "long"
	                },
	                "Size": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBParameterGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBParameterGroupName": {},
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBParameterGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBParameterGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S1f",
	              "locationName": "DBParameterGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "Source": {},
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBParametersResult",
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "shape": "S2s"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBSecurityGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBSecurityGroupName": {},
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSecurityGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSecurityGroups": {
	            "type": "list",
	            "member": {
	              "shape": "Sd",
	              "locationName": "DBSecurityGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBSnapshots": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBInstanceIdentifier": {},
	          "DBSnapshotIdentifier": {},
	          "SnapshotType": {},
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSnapshotsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSnapshots": {
	            "type": "list",
	            "member": {
	              "shape": "Sk",
	              "locationName": "DBSnapshot"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBSubnetGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBSubnetGroupName": {},
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSubnetGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSubnetGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S11",
	              "locationName": "DBSubnetGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEngineDefaultParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupFamily"
	        ],
	        "members": {
	          "DBParameterGroupFamily": {},
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEngineDefaultParametersResult",
	        "type": "structure",
	        "members": {
	          "EngineDefaults": {
	            "type": "structure",
	            "members": {
	              "DBParameterGroupFamily": {},
	              "Marker": {},
	              "Parameters": {
	                "shape": "S2s"
	              }
	            },
	            "wrapper": true
	          }
	        }
	      }
	    },
	    "DescribeEventCategories": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceType": {},
	          "Filters": {
	            "shape": "S27"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventCategoriesResult",
	        "type": "structure",
	        "members": {
	          "EventCategoriesMapList": {
	            "type": "list",
	            "member": {
	              "locationName": "EventCategoriesMap",
	              "type": "structure",
	              "members": {
	                "SourceType": {},
	                "EventCategories": {
	                  "shape": "S6"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DescribeEventSubscriptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SubscriptionName": {},
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventSubscriptionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "EventSubscriptionsList": {
	            "type": "list",
	            "member": {
	              "shape": "S4",
	              "locationName": "EventSubscription"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEvents": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceIdentifier": {},
	          "SourceType": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Duration": {
	            "type": "integer"
	          },
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Events": {
	            "type": "list",
	            "member": {
	              "locationName": "Event",
	              "type": "structure",
	              "members": {
	                "SourceIdentifier": {},
	                "SourceType": {},
	                "Message": {},
	                "EventCategories": {
	                  "shape": "S6"
	                },
	                "Date": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeOptionGroupOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EngineName"
	        ],
	        "members": {
	          "EngineName": {},
	          "MajorEngineVersion": {},
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOptionGroupOptionsResult",
	        "type": "structure",
	        "members": {
	          "OptionGroupOptions": {
	            "type": "list",
	            "member": {
	              "locationName": "OptionGroupOption",
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Description": {},
	                "EngineName": {},
	                "MajorEngineVersion": {},
	                "MinimumRequiredMinorEngineVersion": {},
	                "PortRequired": {
	                  "type": "boolean"
	                },
	                "DefaultPort": {
	                  "type": "integer"
	                },
	                "OptionsDependedOn": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "OptionName"
	                  }
	                },
	                "Persistent": {
	                  "type": "boolean"
	                },
	                "Permanent": {
	                  "type": "boolean"
	                },
	                "OptionGroupOptionSettings": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "OptionGroupOptionSetting",
	                    "type": "structure",
	                    "members": {
	                      "SettingName": {},
	                      "SettingDescription": {},
	                      "DefaultValue": {},
	                      "ApplyType": {},
	                      "AllowedValues": {},
	                      "IsModifiable": {
	                        "type": "boolean"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeOptionGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OptionGroupName": {},
	          "Filters": {
	            "shape": "S27"
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "EngineName": {},
	          "MajorEngineVersion": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOptionGroupsResult",
	        "type": "structure",
	        "members": {
	          "OptionGroupsList": {
	            "type": "list",
	            "member": {
	              "shape": "S1r",
	              "locationName": "OptionGroup"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeOrderableDBInstanceOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Engine"
	        ],
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "DBInstanceClass": {},
	          "LicenseModel": {},
	          "Vpc": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
	        "type": "structure",
	        "members": {
	          "OrderableDBInstanceOptions": {
	            "type": "list",
	            "member": {
	              "locationName": "OrderableDBInstanceOption",
	              "type": "structure",
	              "members": {
	                "Engine": {},
	                "EngineVersion": {},
	                "DBInstanceClass": {},
	                "LicenseModel": {},
	                "AvailabilityZones": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S14",
	                    "locationName": "AvailabilityZone"
	                  }
	                },
	                "MultiAZCapable": {
	                  "type": "boolean"
	                },
	                "ReadReplicaCapable": {
	                  "type": "boolean"
	                },
	                "Vpc": {
	                  "type": "boolean"
	                }
	              },
	              "wrapper": true
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeReservedDBInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedDBInstanceId": {},
	          "ReservedDBInstancesOfferingId": {},
	          "DBInstanceClass": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedDBInstancesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedDBInstances": {
	            "type": "list",
	            "member": {
	              "shape": "S41",
	              "locationName": "ReservedDBInstance"
	            }
	          }
	        }
	      }
	    },
	    "DescribeReservedDBInstancesOfferings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedDBInstancesOfferingId": {},
	          "DBInstanceClass": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "S27"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedDBInstancesOfferings": {
	            "type": "list",
	            "member": {
	              "locationName": "ReservedDBInstancesOffering",
	              "type": "structure",
	              "members": {
	                "ReservedDBInstancesOfferingId": {},
	                "DBInstanceClass": {},
	                "Duration": {
	                  "type": "integer"
	                },
	                "FixedPrice": {
	                  "type": "double"
	                },
	                "UsagePrice": {
	                  "type": "double"
	                },
	                "CurrencyCode": {},
	                "ProductDescription": {},
	                "OfferingType": {},
	                "MultiAZ": {
	                  "type": "boolean"
	                },
	                "RecurringCharges": {
	                  "shape": "S43"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DownloadDBLogFilePortion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "LogFileName"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "LogFileName": {},
	          "Marker": {},
	          "NumberOfLines": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DownloadDBLogFilePortionResult",
	        "type": "structure",
	        "members": {
	          "LogFileData": {},
	          "Marker": {},
	          "AdditionalDataPending": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName"
	        ],
	        "members": {
	          "ResourceName": {},
	          "Filters": {
	            "shape": "S27"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTagsForResourceResult",
	        "type": "structure",
	        "members": {
	          "TagList": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "ModifyDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "DBInstanceClass": {},
	          "DBSecurityGroups": {
	            "shape": "Sp"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "Sq"
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "MasterUserPassword": {},
	          "DBParameterGroupName": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {},
	          "PreferredMaintenanceWindow": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AllowMajorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "NewDBInstanceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "ModifyDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName",
	          "Parameters"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "Parameters": {
	            "shape": "S2s"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4g",
	        "resultWrapper": "ModifyDBParameterGroupResult"
	      }
	    },
	    "ModifyDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName",
	          "SubnetIds"
	        ],
	        "members": {
	          "DBSubnetGroupName": {},
	          "DBSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S1l"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSubnetGroup": {
	            "shape": "S11"
	          }
	        }
	      }
	    },
	    "ModifyEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "ModifyOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName"
	        ],
	        "members": {
	          "OptionGroupName": {},
	          "OptionsToInclude": {
	            "type": "list",
	            "member": {
	              "locationName": "OptionConfiguration",
	              "type": "structure",
	              "required": [
	                "OptionName"
	              ],
	              "members": {
	                "OptionName": {},
	                "Port": {
	                  "type": "integer"
	                },
	                "DBSecurityGroupMemberships": {
	                  "shape": "Sp"
	                },
	                "VpcSecurityGroupMemberships": {
	                  "shape": "Sq"
	                },
	                "OptionSettings": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S1v",
	                    "locationName": "OptionSetting"
	                  }
	                }
	              }
	            }
	          },
	          "OptionsToRemove": {
	            "type": "list",
	            "member": {}
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "S1r"
	          }
	        }
	      }
	    },
	    "PromoteReadReplica": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "PromoteReadReplicaResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "PurchaseReservedDBInstancesOffering": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedDBInstancesOfferingId"
	        ],
	        "members": {
	          "ReservedDBInstancesOfferingId": {},
	          "ReservedDBInstanceId": {},
	          "DBInstanceCount": {
	            "type": "integer"
	          },
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
	        "type": "structure",
	        "members": {
	          "ReservedDBInstance": {
	            "shape": "S41"
	          }
	        }
	      }
	    },
	    "RebootDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "ForceFailover": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RebootDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "RemoveSourceIdentifierFromSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SourceIdentifier"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SourceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "RemoveTagsFromResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceName": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "ResetDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "ResetAllParameters": {
	            "type": "boolean"
	          },
	          "Parameters": {
	            "shape": "S2s"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4g",
	        "resultWrapper": "ResetDBParameterGroupResult"
	      }
	    },
	    "RestoreDBInstanceFromDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "DBSnapshotIdentifier": {},
	          "DBInstanceClass": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "DBName": {},
	          "Engine": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "RestoreDBInstanceToPointInTime": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBInstanceIdentifier",
	          "TargetDBInstanceIdentifier"
	        ],
	        "members": {
	          "SourceDBInstanceIdentifier": {},
	          "TargetDBInstanceIdentifier": {},
	          "RestoreTime": {
	            "type": "timestamp"
	          },
	          "UseLatestRestorableTime": {
	            "type": "boolean"
	          },
	          "DBInstanceClass": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "DBName": {},
	          "Engine": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBInstanceToPointInTimeResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "RevokeDBSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupId": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RevokeDBSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "members": {
	        "CustomerAwsId": {},
	        "CustSubscriptionId": {},
	        "SnsTopicArn": {},
	        "Status": {},
	        "SubscriptionCreationTime": {},
	        "SourceType": {},
	        "SourceIdsList": {
	          "shape": "S5"
	        },
	        "EventCategoriesList": {
	          "shape": "S6"
	        },
	        "Enabled": {
	          "type": "boolean"
	        }
	      },
	      "wrapper": true
	    },
	    "S5": {
	      "type": "list",
	      "member": {
	        "locationName": "SourceId"
	      }
	    },
	    "S6": {
	      "type": "list",
	      "member": {
	        "locationName": "EventCategory"
	      }
	    },
	    "S9": {
	      "type": "list",
	      "member": {
	        "locationName": "Tag",
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sd": {
	      "type": "structure",
	      "members": {
	        "OwnerId": {},
	        "DBSecurityGroupName": {},
	        "DBSecurityGroupDescription": {},
	        "VpcId": {},
	        "EC2SecurityGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "EC2SecurityGroup",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "EC2SecurityGroupName": {},
	              "EC2SecurityGroupId": {},
	              "EC2SecurityGroupOwnerId": {}
	            }
	          }
	        },
	        "IPRanges": {
	          "type": "list",
	          "member": {
	            "locationName": "IPRange",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "CIDRIP": {}
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "Sk": {
	      "type": "structure",
	      "members": {
	        "DBSnapshotIdentifier": {},
	        "DBInstanceIdentifier": {},
	        "SnapshotCreateTime": {
	          "type": "timestamp"
	        },
	        "Engine": {},
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "Status": {},
	        "Port": {
	          "type": "integer"
	        },
	        "AvailabilityZone": {},
	        "VpcId": {},
	        "InstanceCreateTime": {
	          "type": "timestamp"
	        },
	        "MasterUsername": {},
	        "EngineVersion": {},
	        "LicenseModel": {},
	        "SnapshotType": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "OptionGroupName": {},
	        "PercentProgress": {
	          "type": "integer"
	        },
	        "SourceRegion": {}
	      },
	      "wrapper": true
	    },
	    "Sp": {
	      "type": "list",
	      "member": {
	        "locationName": "DBSecurityGroupName"
	      }
	    },
	    "Sq": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroupId"
	      }
	    },
	    "St": {
	      "type": "structure",
	      "members": {
	        "DBInstanceIdentifier": {},
	        "DBInstanceClass": {},
	        "Engine": {},
	        "DBInstanceStatus": {},
	        "MasterUsername": {},
	        "DBName": {},
	        "Endpoint": {
	          "type": "structure",
	          "members": {
	            "Address": {},
	            "Port": {
	              "type": "integer"
	            }
	          }
	        },
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "InstanceCreateTime": {
	          "type": "timestamp"
	        },
	        "PreferredBackupWindow": {},
	        "BackupRetentionPeriod": {
	          "type": "integer"
	        },
	        "DBSecurityGroups": {
	          "shape": "Sv"
	        },
	        "VpcSecurityGroups": {
	          "shape": "Sx"
	        },
	        "DBParameterGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "DBParameterGroup",
	            "type": "structure",
	            "members": {
	              "DBParameterGroupName": {},
	              "ParameterApplyStatus": {}
	            }
	          }
	        },
	        "AvailabilityZone": {},
	        "DBSubnetGroup": {
	          "shape": "S11"
	        },
	        "PreferredMaintenanceWindow": {},
	        "PendingModifiedValues": {
	          "type": "structure",
	          "members": {
	            "DBInstanceClass": {},
	            "AllocatedStorage": {
	              "type": "integer"
	            },
	            "MasterUserPassword": {},
	            "Port": {
	              "type": "integer"
	            },
	            "BackupRetentionPeriod": {
	              "type": "integer"
	            },
	            "MultiAZ": {
	              "type": "boolean"
	            },
	            "EngineVersion": {},
	            "Iops": {
	              "type": "integer"
	            },
	            "DBInstanceIdentifier": {}
	          }
	        },
	        "LatestRestorableTime": {
	          "type": "timestamp"
	        },
	        "MultiAZ": {
	          "type": "boolean"
	        },
	        "EngineVersion": {},
	        "AutoMinorVersionUpgrade": {
	          "type": "boolean"
	        },
	        "ReadReplicaSourceDBInstanceIdentifier": {},
	        "ReadReplicaDBInstanceIdentifiers": {
	          "type": "list",
	          "member": {
	            "locationName": "ReadReplicaDBInstanceIdentifier"
	          }
	        },
	        "LicenseModel": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "OptionGroupMemberships": {
	          "type": "list",
	          "member": {
	            "locationName": "OptionGroupMembership",
	            "type": "structure",
	            "members": {
	              "OptionGroupName": {},
	              "Status": {}
	            }
	          }
	        },
	        "CharacterSetName": {},
	        "SecondaryAvailabilityZone": {},
	        "PubliclyAccessible": {
	          "type": "boolean"
	        },
	        "StatusInfos": {
	          "type": "list",
	          "member": {
	            "locationName": "DBInstanceStatusInfo",
	            "type": "structure",
	            "members": {
	              "StatusType": {},
	              "Normal": {
	                "type": "boolean"
	              },
	              "Status": {},
	              "Message": {}
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "Sv": {
	      "type": "list",
	      "member": {
	        "locationName": "DBSecurityGroup",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroupName": {},
	          "Status": {}
	        }
	      }
	    },
	    "Sx": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroupMembership",
	        "type": "structure",
	        "members": {
	          "VpcSecurityGroupId": {},
	          "Status": {}
	        }
	      }
	    },
	    "S11": {
	      "type": "structure",
	      "members": {
	        "DBSubnetGroupName": {},
	        "DBSubnetGroupDescription": {},
	        "VpcId": {},
	        "SubnetGroupStatus": {},
	        "Subnets": {
	          "type": "list",
	          "member": {
	            "locationName": "Subnet",
	            "type": "structure",
	            "members": {
	              "SubnetIdentifier": {},
	              "SubnetAvailabilityZone": {
	                "shape": "S14"
	              },
	              "SubnetStatus": {}
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "S14": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "ProvisionedIopsCapable": {
	          "type": "boolean"
	        }
	      },
	      "wrapper": true
	    },
	    "S1f": {
	      "type": "structure",
	      "members": {
	        "DBParameterGroupName": {},
	        "DBParameterGroupFamily": {},
	        "Description": {}
	      },
	      "wrapper": true
	    },
	    "S1l": {
	      "type": "list",
	      "member": {
	        "locationName": "SubnetIdentifier"
	      }
	    },
	    "S1r": {
	      "type": "structure",
	      "members": {
	        "OptionGroupName": {},
	        "OptionGroupDescription": {},
	        "EngineName": {},
	        "MajorEngineVersion": {},
	        "Options": {
	          "type": "list",
	          "member": {
	            "locationName": "Option",
	            "type": "structure",
	            "members": {
	              "OptionName": {},
	              "OptionDescription": {},
	              "Persistent": {
	                "type": "boolean"
	              },
	              "Permanent": {
	                "type": "boolean"
	              },
	              "Port": {
	                "type": "integer"
	              },
	              "OptionSettings": {
	                "type": "list",
	                "member": {
	                  "shape": "S1v",
	                  "locationName": "OptionSetting"
	                }
	              },
	              "DBSecurityGroupMemberships": {
	                "shape": "Sv"
	              },
	              "VpcSecurityGroupMemberships": {
	                "shape": "Sx"
	              }
	            }
	          }
	        },
	        "AllowsVpcAndNonVpcInstanceMemberships": {
	          "type": "boolean"
	        },
	        "VpcId": {}
	      },
	      "wrapper": true
	    },
	    "S1v": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Value": {},
	        "DefaultValue": {},
	        "Description": {},
	        "ApplyType": {},
	        "DataType": {},
	        "AllowedValues": {},
	        "IsModifiable": {
	          "type": "boolean"
	        },
	        "IsCollection": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S27": {
	      "type": "list",
	      "member": {
	        "locationName": "Filter",
	        "type": "structure",
	        "required": [
	          "Name",
	          "Values"
	        ],
	        "members": {
	          "Name": {},
	          "Values": {
	            "type": "list",
	            "member": {
	              "locationName": "Value"
	            }
	          }
	        }
	      }
	    },
	    "S2d": {
	      "type": "structure",
	      "members": {
	        "CharacterSetName": {},
	        "CharacterSetDescription": {}
	      }
	    },
	    "S2s": {
	      "type": "list",
	      "member": {
	        "locationName": "Parameter",
	        "type": "structure",
	        "members": {
	          "ParameterName": {},
	          "ParameterValue": {},
	          "Description": {},
	          "Source": {},
	          "ApplyType": {},
	          "DataType": {},
	          "AllowedValues": {},
	          "IsModifiable": {
	            "type": "boolean"
	          },
	          "MinimumEngineVersion": {},
	          "ApplyMethod": {}
	        }
	      }
	    },
	    "S41": {
	      "type": "structure",
	      "members": {
	        "ReservedDBInstanceId": {},
	        "ReservedDBInstancesOfferingId": {},
	        "DBInstanceClass": {},
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "Duration": {
	          "type": "integer"
	        },
	        "FixedPrice": {
	          "type": "double"
	        },
	        "UsagePrice": {
	          "type": "double"
	        },
	        "CurrencyCode": {},
	        "DBInstanceCount": {
	          "type": "integer"
	        },
	        "ProductDescription": {},
	        "OfferingType": {},
	        "MultiAZ": {
	          "type": "boolean"
	        },
	        "State": {},
	        "RecurringCharges": {
	          "shape": "S43"
	        }
	      },
	      "wrapper": true
	    },
	    "S43": {
	      "type": "list",
	      "member": {
	        "locationName": "RecurringCharge",
	        "type": "structure",
	        "members": {
	          "RecurringChargeAmount": {
	            "type": "double"
	          },
	          "RecurringChargeFrequency": {}
	        },
	        "wrapper": true
	      }
	    },
	    "S4g": {
	      "type": "structure",
	      "members": {
	        "DBParameterGroupName": {}
	      }
	    }
	  }
	}
	},{}],188:[function(require,module,exports){
	arguments[4][186][0].apply(exports,arguments)
	},{"dup":186}],189:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "DBInstanceAvailable": {
	      "delay": 30,
	      "operation": "DescribeDBInstances",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "deleted",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "deleting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "incompatible-restore",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "incompatible-parameters",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "incompatible-parameters",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "incompatible-restore",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        }
	      ]
	    },
	    "DBInstanceDeleted": {
	      "delay": 30,
	      "operation": "DescribeDBInstances",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": "deleted",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "creating",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "modifying",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "rebooting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "resetting-master-credentials",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        }
	      ]
	    }
	  }
	}
	
	},{}],190:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-09-01",
	    "endpointPrefix": "rds",
	    "protocol": "query",
	    "serviceAbbreviation": "Amazon RDS",
	    "serviceFullName": "Amazon Relational Database Service",
	    "serviceId": "RDS",
	    "signatureVersion": "v4",
	    "uid": "rds-2014-09-01",
	    "xmlNamespace": "http://rds.amazonaws.com/doc/2014-09-01/"
	  },
	  "operations": {
	    "AddSourceIdentifierToSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SourceIdentifier"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SourceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AddSourceIdentifierToSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "AddTagsToResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "Tags"
	        ],
	        "members": {
	          "ResourceName": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "AuthorizeDBSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupId": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "CopyDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBParameterGroupIdentifier",
	          "TargetDBParameterGroupIdentifier",
	          "TargetDBParameterGroupDescription"
	        ],
	        "members": {
	          "SourceDBParameterGroupIdentifier": {},
	          "TargetDBParameterGroupIdentifier": {},
	          "TargetDBParameterGroupDescription": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyDBParameterGroupResult",
	        "type": "structure",
	        "members": {
	          "DBParameterGroup": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "CopyDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBSnapshotIdentifier",
	          "TargetDBSnapshotIdentifier"
	        ],
	        "members": {
	          "SourceDBSnapshotIdentifier": {},
	          "TargetDBSnapshotIdentifier": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "CopyOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceOptionGroupIdentifier",
	          "TargetOptionGroupIdentifier",
	          "TargetOptionGroupDescription"
	        ],
	        "members": {
	          "SourceOptionGroupIdentifier": {},
	          "TargetOptionGroupIdentifier": {},
	          "TargetOptionGroupDescription": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "CreateDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "AllocatedStorage",
	          "DBInstanceClass",
	          "Engine",
	          "MasterUsername",
	          "MasterUserPassword"
	        ],
	        "members": {
	          "DBName": {},
	          "DBInstanceIdentifier": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "DBInstanceClass": {},
	          "Engine": {},
	          "MasterUsername": {},
	          "MasterUserPassword": {},
	          "DBSecurityGroups": {
	            "shape": "S13"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "S14"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "PreferredMaintenanceWindow": {},
	          "DBParameterGroupName": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {},
	          "Port": {
	            "type": "integer"
	          },
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "CharacterSetName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S9"
	          },
	          "StorageType": {},
	          "TdeCredentialArn": {},
	          "TdeCredentialPassword": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S17"
	          }
	        }
	      }
	    },
	    "CreateDBInstanceReadReplica": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "SourceDBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "SourceDBInstanceIdentifier": {},
	          "DBInstanceClass": {},
	          "AvailabilityZone": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S9"
	          },
	          "DBSubnetGroupName": {},
	          "StorageType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBInstanceReadReplicaResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S17"
	          }
	        }
	      }
	    },
	    "CreateDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName",
	          "DBParameterGroupFamily",
	          "Description"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "DBParameterGroupFamily": {},
	          "Description": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBParameterGroupResult",
	        "type": "structure",
	        "members": {
	          "DBParameterGroup": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "CreateDBSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName",
	          "DBSecurityGroupDescription"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "DBSecurityGroupDescription": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSecurityGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "CreateDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier",
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {},
	          "DBInstanceIdentifier": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "CreateDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName",
	          "DBSubnetGroupDescription",
	          "SubnetIds"
	        ],
	        "members": {
	          "DBSubnetGroupName": {},
	          "DBSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S1u"
	          },
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSubnetGroup": {
	            "shape": "S1b"
	          }
	        }
	      }
	    },
	    "CreateEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SnsTopicArn"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "SourceIds": {
	            "shape": "S5"
	          },
	          "Enabled": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "CreateOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName",
	          "EngineName",
	          "MajorEngineVersion",
	          "OptionGroupDescription"
	        ],
	        "members": {
	          "OptionGroupName": {},
	          "EngineName": {},
	          "MajorEngineVersion": {},
	          "OptionGroupDescription": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "DeleteDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "SkipFinalSnapshot": {
	            "type": "boolean"
	          },
	          "FinalDBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S17"
	          }
	        }
	      }
	    },
	    "DeleteDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {}
	        }
	      }
	    },
	    "DeleteDBSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {}
	        }
	      }
	    },
	    "DeleteDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "DeleteDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName"
	        ],
	        "members": {
	          "DBSubnetGroupName": {}
	        }
	      }
	    },
	    "DeleteEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "DeleteOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName"
	        ],
	        "members": {
	          "OptionGroupName": {}
	        }
	      }
	    },
	    "DescribeDBEngineVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "DBParameterGroupFamily": {},
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "DefaultOnly": {
	            "type": "boolean"
	          },
	          "ListSupportedCharacterSets": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBEngineVersionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBEngineVersions": {
	            "type": "list",
	            "member": {
	              "locationName": "DBEngineVersion",
	              "type": "structure",
	              "members": {
	                "Engine": {},
	                "EngineVersion": {},
	                "DBParameterGroupFamily": {},
	                "DBEngineDescription": {},
	                "DBEngineVersionDescription": {},
	                "DefaultCharacterSet": {
	                  "shape": "S2h"
	                },
	                "SupportedCharacterSets": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S2h",
	                    "locationName": "CharacterSet"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBInstanceIdentifier": {},
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBInstancesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBInstances": {
	            "type": "list",
	            "member": {
	              "shape": "S17",
	              "locationName": "DBInstance"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBLogFiles": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "FilenameContains": {},
	          "FileLastWritten": {
	            "type": "long"
	          },
	          "FileSize": {
	            "type": "long"
	          },
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBLogFilesResult",
	        "type": "structure",
	        "members": {
	          "DescribeDBLogFiles": {
	            "type": "list",
	            "member": {
	              "locationName": "DescribeDBLogFilesDetails",
	              "type": "structure",
	              "members": {
	                "LogFileName": {},
	                "LastWritten": {
	                  "type": "long"
	                },
	                "Size": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBParameterGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBParameterGroupName": {},
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBParameterGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBParameterGroups": {
	            "type": "list",
	            "member": {
	              "shape": "Sk",
	              "locationName": "DBParameterGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "Source": {},
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBParametersResult",
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "shape": "S2w"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBSecurityGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBSecurityGroupName": {},
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSecurityGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSecurityGroups": {
	            "type": "list",
	            "member": {
	              "shape": "Sd",
	              "locationName": "DBSecurityGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBSnapshots": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBInstanceIdentifier": {},
	          "DBSnapshotIdentifier": {},
	          "SnapshotType": {},
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSnapshotsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSnapshots": {
	            "type": "list",
	            "member": {
	              "shape": "Sn",
	              "locationName": "DBSnapshot"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBSubnetGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBSubnetGroupName": {},
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSubnetGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSubnetGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S1b",
	              "locationName": "DBSubnetGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEngineDefaultParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupFamily"
	        ],
	        "members": {
	          "DBParameterGroupFamily": {},
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEngineDefaultParametersResult",
	        "type": "structure",
	        "members": {
	          "EngineDefaults": {
	            "type": "structure",
	            "members": {
	              "DBParameterGroupFamily": {},
	              "Marker": {},
	              "Parameters": {
	                "shape": "S2w"
	              }
	            },
	            "wrapper": true
	          }
	        }
	      }
	    },
	    "DescribeEventCategories": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceType": {},
	          "Filters": {
	            "shape": "S2b"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventCategoriesResult",
	        "type": "structure",
	        "members": {
	          "EventCategoriesMapList": {
	            "type": "list",
	            "member": {
	              "locationName": "EventCategoriesMap",
	              "type": "structure",
	              "members": {
	                "SourceType": {},
	                "EventCategories": {
	                  "shape": "S6"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DescribeEventSubscriptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SubscriptionName": {},
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventSubscriptionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "EventSubscriptionsList": {
	            "type": "list",
	            "member": {
	              "shape": "S4",
	              "locationName": "EventSubscription"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEvents": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceIdentifier": {},
	          "SourceType": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Duration": {
	            "type": "integer"
	          },
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Events": {
	            "type": "list",
	            "member": {
	              "locationName": "Event",
	              "type": "structure",
	              "members": {
	                "SourceIdentifier": {},
	                "SourceType": {},
	                "Message": {},
	                "EventCategories": {
	                  "shape": "S6"
	                },
	                "Date": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeOptionGroupOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EngineName"
	        ],
	        "members": {
	          "EngineName": {},
	          "MajorEngineVersion": {},
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOptionGroupOptionsResult",
	        "type": "structure",
	        "members": {
	          "OptionGroupOptions": {
	            "type": "list",
	            "member": {
	              "locationName": "OptionGroupOption",
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Description": {},
	                "EngineName": {},
	                "MajorEngineVersion": {},
	                "MinimumRequiredMinorEngineVersion": {},
	                "PortRequired": {
	                  "type": "boolean"
	                },
	                "DefaultPort": {
	                  "type": "integer"
	                },
	                "OptionsDependedOn": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "OptionName"
	                  }
	                },
	                "Persistent": {
	                  "type": "boolean"
	                },
	                "Permanent": {
	                  "type": "boolean"
	                },
	                "OptionGroupOptionSettings": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "OptionGroupOptionSetting",
	                    "type": "structure",
	                    "members": {
	                      "SettingName": {},
	                      "SettingDescription": {},
	                      "DefaultValue": {},
	                      "ApplyType": {},
	                      "AllowedValues": {},
	                      "IsModifiable": {
	                        "type": "boolean"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeOptionGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OptionGroupName": {},
	          "Filters": {
	            "shape": "S2b"
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "EngineName": {},
	          "MajorEngineVersion": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOptionGroupsResult",
	        "type": "structure",
	        "members": {
	          "OptionGroupsList": {
	            "type": "list",
	            "member": {
	              "shape": "St",
	              "locationName": "OptionGroup"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeOrderableDBInstanceOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Engine"
	        ],
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "DBInstanceClass": {},
	          "LicenseModel": {},
	          "Vpc": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
	        "type": "structure",
	        "members": {
	          "OrderableDBInstanceOptions": {
	            "type": "list",
	            "member": {
	              "locationName": "OrderableDBInstanceOption",
	              "type": "structure",
	              "members": {
	                "Engine": {},
	                "EngineVersion": {},
	                "DBInstanceClass": {},
	                "LicenseModel": {},
	                "AvailabilityZones": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S1e",
	                    "locationName": "AvailabilityZone"
	                  }
	                },
	                "MultiAZCapable": {
	                  "type": "boolean"
	                },
	                "ReadReplicaCapable": {
	                  "type": "boolean"
	                },
	                "Vpc": {
	                  "type": "boolean"
	                },
	                "StorageType": {},
	                "SupportsIops": {
	                  "type": "boolean"
	                }
	              },
	              "wrapper": true
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeReservedDBInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedDBInstanceId": {},
	          "ReservedDBInstancesOfferingId": {},
	          "DBInstanceClass": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedDBInstancesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedDBInstances": {
	            "type": "list",
	            "member": {
	              "shape": "S45",
	              "locationName": "ReservedDBInstance"
	            }
	          }
	        }
	      }
	    },
	    "DescribeReservedDBInstancesOfferings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedDBInstancesOfferingId": {},
	          "DBInstanceClass": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "S2b"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedDBInstancesOfferings": {
	            "type": "list",
	            "member": {
	              "locationName": "ReservedDBInstancesOffering",
	              "type": "structure",
	              "members": {
	                "ReservedDBInstancesOfferingId": {},
	                "DBInstanceClass": {},
	                "Duration": {
	                  "type": "integer"
	                },
	                "FixedPrice": {
	                  "type": "double"
	                },
	                "UsagePrice": {
	                  "type": "double"
	                },
	                "CurrencyCode": {},
	                "ProductDescription": {},
	                "OfferingType": {},
	                "MultiAZ": {
	                  "type": "boolean"
	                },
	                "RecurringCharges": {
	                  "shape": "S47"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DownloadDBLogFilePortion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "LogFileName"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "LogFileName": {},
	          "Marker": {},
	          "NumberOfLines": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DownloadDBLogFilePortionResult",
	        "type": "structure",
	        "members": {
	          "LogFileData": {},
	          "Marker": {},
	          "AdditionalDataPending": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName"
	        ],
	        "members": {
	          "ResourceName": {},
	          "Filters": {
	            "shape": "S2b"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTagsForResourceResult",
	        "type": "structure",
	        "members": {
	          "TagList": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "ModifyDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "DBInstanceClass": {},
	          "DBSecurityGroups": {
	            "shape": "S13"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "S14"
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "MasterUserPassword": {},
	          "DBParameterGroupName": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {},
	          "PreferredMaintenanceWindow": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AllowMajorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "NewDBInstanceIdentifier": {},
	          "StorageType": {},
	          "TdeCredentialArn": {},
	          "TdeCredentialPassword": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S17"
	          }
	        }
	      }
	    },
	    "ModifyDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName",
	          "Parameters"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "Parameters": {
	            "shape": "S2w"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4k",
	        "resultWrapper": "ModifyDBParameterGroupResult"
	      }
	    },
	    "ModifyDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName",
	          "SubnetIds"
	        ],
	        "members": {
	          "DBSubnetGroupName": {},
	          "DBSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S1u"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSubnetGroup": {
	            "shape": "S1b"
	          }
	        }
	      }
	    },
	    "ModifyEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "EventCategories": {
	            "shape": "S6"
	          },
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "ModifyOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName"
	        ],
	        "members": {
	          "OptionGroupName": {},
	          "OptionsToInclude": {
	            "type": "list",
	            "member": {
	              "locationName": "OptionConfiguration",
	              "type": "structure",
	              "required": [
	                "OptionName"
	              ],
	              "members": {
	                "OptionName": {},
	                "Port": {
	                  "type": "integer"
	                },
	                "DBSecurityGroupMemberships": {
	                  "shape": "S13"
	                },
	                "VpcSecurityGroupMemberships": {
	                  "shape": "S14"
	                },
	                "OptionSettings": {
	                  "type": "list",
	                  "member": {
	                    "shape": "Sx",
	                    "locationName": "OptionSetting"
	                  }
	                }
	              }
	            }
	          },
	          "OptionsToRemove": {
	            "type": "list",
	            "member": {}
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "PromoteReadReplica": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "PromoteReadReplicaResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S17"
	          }
	        }
	      }
	    },
	    "PurchaseReservedDBInstancesOffering": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedDBInstancesOfferingId"
	        ],
	        "members": {
	          "ReservedDBInstancesOfferingId": {},
	          "ReservedDBInstanceId": {},
	          "DBInstanceCount": {
	            "type": "integer"
	          },
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
	        "type": "structure",
	        "members": {
	          "ReservedDBInstance": {
	            "shape": "S45"
	          }
	        }
	      }
	    },
	    "RebootDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "ForceFailover": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RebootDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S17"
	          }
	        }
	      }
	    },
	    "RemoveSourceIdentifierFromSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SourceIdentifier"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SourceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "RemoveTagsFromResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceName": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "ResetDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "ResetAllParameters": {
	            "type": "boolean"
	          },
	          "Parameters": {
	            "shape": "S2w"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4k",
	        "resultWrapper": "ResetDBParameterGroupResult"
	      }
	    },
	    "RestoreDBInstanceFromDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "DBSnapshotIdentifier": {},
	          "DBInstanceClass": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "DBName": {},
	          "Engine": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "Tags": {
	            "shape": "S9"
	          },
	          "StorageType": {},
	          "TdeCredentialArn": {},
	          "TdeCredentialPassword": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S17"
	          }
	        }
	      }
	    },
	    "RestoreDBInstanceToPointInTime": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBInstanceIdentifier",
	          "TargetDBInstanceIdentifier"
	        ],
	        "members": {
	          "SourceDBInstanceIdentifier": {},
	          "TargetDBInstanceIdentifier": {},
	          "RestoreTime": {
	            "type": "timestamp"
	          },
	          "UseLatestRestorableTime": {
	            "type": "boolean"
	          },
	          "DBInstanceClass": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "DBName": {},
	          "Engine": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "Tags": {
	            "shape": "S9"
	          },
	          "StorageType": {},
	          "TdeCredentialArn": {},
	          "TdeCredentialPassword": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBInstanceToPointInTimeResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S17"
	          }
	        }
	      }
	    },
	    "RevokeDBSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupId": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RevokeDBSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sd"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "members": {
	        "CustomerAwsId": {},
	        "CustSubscriptionId": {},
	        "SnsTopicArn": {},
	        "Status": {},
	        "SubscriptionCreationTime": {},
	        "SourceType": {},
	        "SourceIdsList": {
	          "shape": "S5"
	        },
	        "EventCategoriesList": {
	          "shape": "S6"
	        },
	        "Enabled": {
	          "type": "boolean"
	        }
	      },
	      "wrapper": true
	    },
	    "S5": {
	      "type": "list",
	      "member": {
	        "locationName": "SourceId"
	      }
	    },
	    "S6": {
	      "type": "list",
	      "member": {
	        "locationName": "EventCategory"
	      }
	    },
	    "S9": {
	      "type": "list",
	      "member": {
	        "locationName": "Tag",
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sd": {
	      "type": "structure",
	      "members": {
	        "OwnerId": {},
	        "DBSecurityGroupName": {},
	        "DBSecurityGroupDescription": {},
	        "VpcId": {},
	        "EC2SecurityGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "EC2SecurityGroup",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "EC2SecurityGroupName": {},
	              "EC2SecurityGroupId": {},
	              "EC2SecurityGroupOwnerId": {}
	            }
	          }
	        },
	        "IPRanges": {
	          "type": "list",
	          "member": {
	            "locationName": "IPRange",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "CIDRIP": {}
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "Sk": {
	      "type": "structure",
	      "members": {
	        "DBParameterGroupName": {},
	        "DBParameterGroupFamily": {},
	        "Description": {}
	      },
	      "wrapper": true
	    },
	    "Sn": {
	      "type": "structure",
	      "members": {
	        "DBSnapshotIdentifier": {},
	        "DBInstanceIdentifier": {},
	        "SnapshotCreateTime": {
	          "type": "timestamp"
	        },
	        "Engine": {},
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "Status": {},
	        "Port": {
	          "type": "integer"
	        },
	        "AvailabilityZone": {},
	        "VpcId": {},
	        "InstanceCreateTime": {
	          "type": "timestamp"
	        },
	        "MasterUsername": {},
	        "EngineVersion": {},
	        "LicenseModel": {},
	        "SnapshotType": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "OptionGroupName": {},
	        "PercentProgress": {
	          "type": "integer"
	        },
	        "SourceRegion": {},
	        "StorageType": {},
	        "TdeCredentialArn": {}
	      },
	      "wrapper": true
	    },
	    "St": {
	      "type": "structure",
	      "members": {
	        "OptionGroupName": {},
	        "OptionGroupDescription": {},
	        "EngineName": {},
	        "MajorEngineVersion": {},
	        "Options": {
	          "type": "list",
	          "member": {
	            "locationName": "Option",
	            "type": "structure",
	            "members": {
	              "OptionName": {},
	              "OptionDescription": {},
	              "Persistent": {
	                "type": "boolean"
	              },
	              "Permanent": {
	                "type": "boolean"
	              },
	              "Port": {
	                "type": "integer"
	              },
	              "OptionSettings": {
	                "type": "list",
	                "member": {
	                  "shape": "Sx",
	                  "locationName": "OptionSetting"
	                }
	              },
	              "DBSecurityGroupMemberships": {
	                "shape": "Sy"
	              },
	              "VpcSecurityGroupMemberships": {
	                "shape": "S10"
	              }
	            }
	          }
	        },
	        "AllowsVpcAndNonVpcInstanceMemberships": {
	          "type": "boolean"
	        },
	        "VpcId": {}
	      },
	      "wrapper": true
	    },
	    "Sx": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Value": {},
	        "DefaultValue": {},
	        "Description": {},
	        "ApplyType": {},
	        "DataType": {},
	        "AllowedValues": {},
	        "IsModifiable": {
	          "type": "boolean"
	        },
	        "IsCollection": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Sy": {
	      "type": "list",
	      "member": {
	        "locationName": "DBSecurityGroup",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroupName": {},
	          "Status": {}
	        }
	      }
	    },
	    "S10": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroupMembership",
	        "type": "structure",
	        "members": {
	          "VpcSecurityGroupId": {},
	          "Status": {}
	        }
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {
	        "locationName": "DBSecurityGroupName"
	      }
	    },
	    "S14": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroupId"
	      }
	    },
	    "S17": {
	      "type": "structure",
	      "members": {
	        "DBInstanceIdentifier": {},
	        "DBInstanceClass": {},
	        "Engine": {},
	        "DBInstanceStatus": {},
	        "MasterUsername": {},
	        "DBName": {},
	        "Endpoint": {
	          "type": "structure",
	          "members": {
	            "Address": {},
	            "Port": {
	              "type": "integer"
	            }
	          }
	        },
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "InstanceCreateTime": {
	          "type": "timestamp"
	        },
	        "PreferredBackupWindow": {},
	        "BackupRetentionPeriod": {
	          "type": "integer"
	        },
	        "DBSecurityGroups": {
	          "shape": "Sy"
	        },
	        "VpcSecurityGroups": {
	          "shape": "S10"
	        },
	        "DBParameterGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "DBParameterGroup",
	            "type": "structure",
	            "members": {
	              "DBParameterGroupName": {},
	              "ParameterApplyStatus": {}
	            }
	          }
	        },
	        "AvailabilityZone": {},
	        "DBSubnetGroup": {
	          "shape": "S1b"
	        },
	        "PreferredMaintenanceWindow": {},
	        "PendingModifiedValues": {
	          "type": "structure",
	          "members": {
	            "DBInstanceClass": {},
	            "AllocatedStorage": {
	              "type": "integer"
	            },
	            "MasterUserPassword": {},
	            "Port": {
	              "type": "integer"
	            },
	            "BackupRetentionPeriod": {
	              "type": "integer"
	            },
	            "MultiAZ": {
	              "type": "boolean"
	            },
	            "EngineVersion": {},
	            "Iops": {
	              "type": "integer"
	            },
	            "DBInstanceIdentifier": {},
	            "StorageType": {}
	          }
	        },
	        "LatestRestorableTime": {
	          "type": "timestamp"
	        },
	        "MultiAZ": {
	          "type": "boolean"
	        },
	        "EngineVersion": {},
	        "AutoMinorVersionUpgrade": {
	          "type": "boolean"
	        },
	        "ReadReplicaSourceDBInstanceIdentifier": {},
	        "ReadReplicaDBInstanceIdentifiers": {
	          "type": "list",
	          "member": {
	            "locationName": "ReadReplicaDBInstanceIdentifier"
	          }
	        },
	        "LicenseModel": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "OptionGroupMemberships": {
	          "type": "list",
	          "member": {
	            "locationName": "OptionGroupMembership",
	            "type": "structure",
	            "members": {
	              "OptionGroupName": {},
	              "Status": {}
	            }
	          }
	        },
	        "CharacterSetName": {},
	        "SecondaryAvailabilityZone": {},
	        "PubliclyAccessible": {
	          "type": "boolean"
	        },
	        "StatusInfos": {
	          "type": "list",
	          "member": {
	            "locationName": "DBInstanceStatusInfo",
	            "type": "structure",
	            "members": {
	              "StatusType": {},
	              "Normal": {
	                "type": "boolean"
	              },
	              "Status": {},
	              "Message": {}
	            }
	          }
	        },
	        "StorageType": {},
	        "TdeCredentialArn": {}
	      },
	      "wrapper": true
	    },
	    "S1b": {
	      "type": "structure",
	      "members": {
	        "DBSubnetGroupName": {},
	        "DBSubnetGroupDescription": {},
	        "VpcId": {},
	        "SubnetGroupStatus": {},
	        "Subnets": {
	          "type": "list",
	          "member": {
	            "locationName": "Subnet",
	            "type": "structure",
	            "members": {
	              "SubnetIdentifier": {},
	              "SubnetAvailabilityZone": {
	                "shape": "S1e"
	              },
	              "SubnetStatus": {}
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "S1e": {
	      "type": "structure",
	      "members": {
	        "Name": {}
	      },
	      "wrapper": true
	    },
	    "S1u": {
	      "type": "list",
	      "member": {
	        "locationName": "SubnetIdentifier"
	      }
	    },
	    "S2b": {
	      "type": "list",
	      "member": {
	        "locationName": "Filter",
	        "type": "structure",
	        "required": [
	          "Name",
	          "Values"
	        ],
	        "members": {
	          "Name": {},
	          "Values": {
	            "type": "list",
	            "member": {
	              "locationName": "Value"
	            }
	          }
	        }
	      }
	    },
	    "S2h": {
	      "type": "structure",
	      "members": {
	        "CharacterSetName": {},
	        "CharacterSetDescription": {}
	      }
	    },
	    "S2w": {
	      "type": "list",
	      "member": {
	        "locationName": "Parameter",
	        "type": "structure",
	        "members": {
	          "ParameterName": {},
	          "ParameterValue": {},
	          "Description": {},
	          "Source": {},
	          "ApplyType": {},
	          "DataType": {},
	          "AllowedValues": {},
	          "IsModifiable": {
	            "type": "boolean"
	          },
	          "MinimumEngineVersion": {},
	          "ApplyMethod": {}
	        }
	      }
	    },
	    "S45": {
	      "type": "structure",
	      "members": {
	        "ReservedDBInstanceId": {},
	        "ReservedDBInstancesOfferingId": {},
	        "DBInstanceClass": {},
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "Duration": {
	          "type": "integer"
	        },
	        "FixedPrice": {
	          "type": "double"
	        },
	        "UsagePrice": {
	          "type": "double"
	        },
	        "CurrencyCode": {},
	        "DBInstanceCount": {
	          "type": "integer"
	        },
	        "ProductDescription": {},
	        "OfferingType": {},
	        "MultiAZ": {
	          "type": "boolean"
	        },
	        "State": {},
	        "RecurringCharges": {
	          "shape": "S47"
	        }
	      },
	      "wrapper": true
	    },
	    "S47": {
	      "type": "list",
	      "member": {
	        "locationName": "RecurringCharge",
	        "type": "structure",
	        "members": {
	          "RecurringChargeAmount": {
	            "type": "double"
	          },
	          "RecurringChargeFrequency": {}
	        },
	        "wrapper": true
	      }
	    },
	    "S4k": {
	      "type": "structure",
	      "members": {
	        "DBParameterGroupName": {}
	      }
	    }
	  }
	}
	},{}],191:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],192:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-10-31",
	    "endpointPrefix": "rds",
	    "protocol": "query",
	    "serviceAbbreviation": "Amazon RDS",
	    "serviceFullName": "Amazon Relational Database Service",
	    "serviceId": "RDS",
	    "signatureVersion": "v4",
	    "uid": "rds-2014-10-31",
	    "xmlNamespace": "http://rds.amazonaws.com/doc/2014-10-31/"
	  },
	  "operations": {
	    "AddRoleToDBCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier",
	          "RoleArn"
	        ],
	        "members": {
	          "DBClusterIdentifier": {},
	          "RoleArn": {},
	          "FeatureName": {}
	        }
	      }
	    },
	    "AddRoleToDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "RoleArn",
	          "FeatureName"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "RoleArn": {},
	          "FeatureName": {}
	        }
	      }
	    },
	    "AddSourceIdentifierToSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SourceIdentifier"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SourceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AddSourceIdentifierToSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S6"
	          }
	        }
	      }
	    },
	    "AddTagsToResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "Tags"
	        ],
	        "members": {
	          "ResourceName": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      }
	    },
	    "ApplyPendingMaintenanceAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceIdentifier",
	          "ApplyAction",
	          "OptInType"
	        ],
	        "members": {
	          "ResourceIdentifier": {},
	          "ApplyAction": {},
	          "OptInType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ApplyPendingMaintenanceActionResult",
	        "type": "structure",
	        "members": {
	          "ResourcePendingMaintenanceActions": {
	            "shape": "Sf"
	          }
	        }
	      }
	    },
	    "AuthorizeDBSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupId": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sl"
	          }
	        }
	      }
	    },
	    "BacktrackDBCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier",
	          "BacktrackTo"
	        ],
	        "members": {
	          "DBClusterIdentifier": {},
	          "BacktrackTo": {
	            "type": "timestamp"
	          },
	          "Force": {
	            "type": "boolean"
	          },
	          "UseEarliestTimeOnPointInTimeUnavailable": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "Ss",
	        "resultWrapper": "BacktrackDBClusterResult"
	      }
	    },
	    "CancelExportTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExportTaskIdentifier"
	        ],
	        "members": {
	          "ExportTaskIdentifier": {}
	        }
	      },
	      "output": {
	        "shape": "Su",
	        "resultWrapper": "CancelExportTaskResult"
	      }
	    },
	    "CopyDBClusterParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBClusterParameterGroupIdentifier",
	          "TargetDBClusterParameterGroupIdentifier",
	          "TargetDBClusterParameterGroupDescription"
	        ],
	        "members": {
	          "SourceDBClusterParameterGroupIdentifier": {},
	          "TargetDBClusterParameterGroupIdentifier": {},
	          "TargetDBClusterParameterGroupDescription": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyDBClusterParameterGroupResult",
	        "type": "structure",
	        "members": {
	          "DBClusterParameterGroup": {
	            "shape": "Sz"
	          }
	        }
	      }
	    },
	    "CopyDBClusterSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBClusterSnapshotIdentifier",
	          "TargetDBClusterSnapshotIdentifier"
	        ],
	        "members": {
	          "SourceDBClusterSnapshotIdentifier": {},
	          "TargetDBClusterSnapshotIdentifier": {},
	          "KmsKeyId": {},
	          "PreSignedUrl": {},
	          "CopyTags": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "Sb"
	          },
	          "SourceRegion": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyDBClusterSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBClusterSnapshot": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "CopyDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBParameterGroupIdentifier",
	          "TargetDBParameterGroupIdentifier",
	          "TargetDBParameterGroupDescription"
	        ],
	        "members": {
	          "SourceDBParameterGroupIdentifier": {},
	          "TargetDBParameterGroupIdentifier": {},
	          "TargetDBParameterGroupDescription": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyDBParameterGroupResult",
	        "type": "structure",
	        "members": {
	          "DBParameterGroup": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "CopyDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBSnapshotIdentifier",
	          "TargetDBSnapshotIdentifier"
	        ],
	        "members": {
	          "SourceDBSnapshotIdentifier": {},
	          "TargetDBSnapshotIdentifier": {},
	          "KmsKeyId": {},
	          "Tags": {
	            "shape": "Sb"
	          },
	          "CopyTags": {
	            "type": "boolean"
	          },
	          "PreSignedUrl": {},
	          "OptionGroupName": {},
	          "TargetCustomAvailabilityZone": {},
	          "SourceRegion": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "S19"
	          }
	        }
	      }
	    },
	    "CopyOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceOptionGroupIdentifier",
	          "TargetOptionGroupIdentifier",
	          "TargetOptionGroupDescription"
	        ],
	        "members": {
	          "SourceOptionGroupIdentifier": {},
	          "TargetOptionGroupIdentifier": {},
	          "TargetOptionGroupDescription": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "S1f"
	          }
	        }
	      }
	    },
	    "CreateCustomDBEngineVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Engine",
	          "EngineVersion",
	          "DatabaseInstallationFilesS3BucketName",
	          "KMSKeyId",
	          "Manifest"
	        ],
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "DatabaseInstallationFilesS3BucketName": {},
	          "DatabaseInstallationFilesS3Prefix": {},
	          "KMSKeyId": {},
	          "Description": {},
	          "Manifest": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "shape": "S1w",
	        "resultWrapper": "CreateCustomDBEngineVersionResult"
	      }
	    },
	    "CreateDBCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier",
	          "Engine"
	        ],
	        "members": {
	          "AvailabilityZones": {
	            "shape": "S13"
	          },
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "CharacterSetName": {},
	          "DatabaseName": {},
	          "DBClusterIdentifier": {},
	          "DBClusterParameterGroupName": {},
	          "VpcSecurityGroupIds": {
	            "shape": "S27"
	          },
	          "DBSubnetGroupName": {},
	          "Engine": {},
	          "EngineVersion": {},
	          "Port": {
	            "type": "integer"
	          },
	          "MasterUsername": {},
	          "MasterUserPassword": {},
	          "OptionGroupName": {},
	          "PreferredBackupWindow": {},
	          "PreferredMaintenanceWindow": {},
	          "ReplicationSourceIdentifier": {},
	          "Tags": {
	            "shape": "Sb"
	          },
	          "StorageEncrypted": {
	            "type": "boolean"
	          },
	          "KmsKeyId": {},
	          "PreSignedUrl": {},
	          "EnableIAMDatabaseAuthentication": {
	            "type": "boolean"
	          },
	          "BacktrackWindow": {
	            "type": "long"
	          },
	          "EnableCloudwatchLogsExports": {
	            "shape": "S24"
	          },
	          "EngineMode": {},
	          "ScalingConfiguration": {
	            "shape": "S29"
	          },
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "GlobalClusterIdentifier": {},
	          "EnableHttpEndpoint": {
	            "type": "boolean"
	          },
	          "CopyTagsToSnapshot": {
	            "type": "boolean"
	          },
	          "Domain": {},
	          "DomainIAMRoleName": {},
	          "EnableGlobalWriteForwarding": {
	            "type": "boolean"
	          },
	          "DBClusterInstanceClass": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "StorageType": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "MonitoringInterval": {
	            "type": "integer"
	          },
	          "MonitoringRoleArn": {},
	          "EnablePerformanceInsights": {
	            "type": "boolean"
	          },
	          "PerformanceInsightsKMSKeyId": {},
	          "PerformanceInsightsRetentionPeriod": {
	            "type": "integer"
	          },
	          "ServerlessV2ScalingConfiguration": {
	            "shape": "S2a"
	          },
	          "SourceRegion": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBClusterResult",
	        "type": "structure",
	        "members": {
	          "DBCluster": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "CreateDBClusterEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier",
	          "DBClusterEndpointIdentifier",
	          "EndpointType"
	        ],
	        "members": {
	          "DBClusterIdentifier": {},
	          "DBClusterEndpointIdentifier": {},
	          "EndpointType": {},
	          "StaticMembers": {
	            "shape": "Sv"
	          },
	          "ExcludedMembers": {
	            "shape": "Sv"
	          },
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2v",
	        "resultWrapper": "CreateDBClusterEndpointResult"
	      }
	    },
	    "CreateDBClusterParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterParameterGroupName",
	          "DBParameterGroupFamily",
	          "Description"
	        ],
	        "members": {
	          "DBClusterParameterGroupName": {},
	          "DBParameterGroupFamily": {},
	          "Description": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBClusterParameterGroupResult",
	        "type": "structure",
	        "members": {
	          "DBClusterParameterGroup": {
	            "shape": "Sz"
	          }
	        }
	      }
	    },
	    "CreateDBClusterSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterSnapshotIdentifier",
	          "DBClusterIdentifier"
	        ],
	        "members": {
	          "DBClusterSnapshotIdentifier": {},
	          "DBClusterIdentifier": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBClusterSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBClusterSnapshot": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "CreateDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "DBInstanceClass",
	          "Engine"
	        ],
	        "members": {
	          "DBName": {},
	          "DBInstanceIdentifier": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "DBInstanceClass": {},
	          "Engine": {},
	          "MasterUsername": {},
	          "MasterUserPassword": {},
	          "DBSecurityGroups": {
	            "shape": "S31"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "S27"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "PreferredMaintenanceWindow": {},
	          "DBParameterGroupName": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {},
	          "Port": {
	            "type": "integer"
	          },
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "CharacterSetName": {},
	          "NcharCharacterSetName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "Sb"
	          },
	          "DBClusterIdentifier": {},
	          "StorageType": {},
	          "TdeCredentialArn": {},
	          "TdeCredentialPassword": {},
	          "StorageEncrypted": {
	            "type": "boolean"
	          },
	          "KmsKeyId": {},
	          "Domain": {},
	          "CopyTagsToSnapshot": {
	            "type": "boolean"
	          },
	          "MonitoringInterval": {
	            "type": "integer"
	          },
	          "MonitoringRoleArn": {},
	          "DomainIAMRoleName": {},
	          "PromotionTier": {
	            "type": "integer"
	          },
	          "Timezone": {},
	          "EnableIAMDatabaseAuthentication": {
	            "type": "boolean"
	          },
	          "EnablePerformanceInsights": {
	            "type": "boolean"
	          },
	          "PerformanceInsightsKMSKeyId": {},
	          "PerformanceInsightsRetentionPeriod": {
	            "type": "integer"
	          },
	          "EnableCloudwatchLogsExports": {
	            "shape": "S24"
	          },
	          "ProcessorFeatures": {
	            "shape": "S1b"
	          },
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "MaxAllocatedStorage": {
	            "type": "integer"
	          },
	          "EnableCustomerOwnedIp": {
	            "type": "boolean"
	          },
	          "CustomIamInstanceProfile": {},
	          "BackupTarget": {},
	          "NetworkType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "CreateDBInstanceReadReplica": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "SourceDBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "SourceDBInstanceIdentifier": {},
	          "DBInstanceClass": {},
	          "AvailabilityZone": {},
	          "Port": {
	            "type": "integer"
	          },
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "DBParameterGroupName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "Sb"
	          },
	          "DBSubnetGroupName": {},
	          "VpcSecurityGroupIds": {
	            "shape": "S27"
	          },
	          "StorageType": {},
	          "CopyTagsToSnapshot": {
	            "type": "boolean"
	          },
	          "MonitoringInterval": {
	            "type": "integer"
	          },
	          "MonitoringRoleArn": {},
	          "KmsKeyId": {},
	          "PreSignedUrl": {},
	          "EnableIAMDatabaseAuthentication": {
	            "type": "boolean"
	          },
	          "EnablePerformanceInsights": {
	            "type": "boolean"
	          },
	          "PerformanceInsightsKMSKeyId": {},
	          "PerformanceInsightsRetentionPeriod": {
	            "type": "integer"
	          },
	          "EnableCloudwatchLogsExports": {
	            "shape": "S24"
	          },
	          "ProcessorFeatures": {
	            "shape": "S1b"
	          },
	          "UseDefaultProcessorFeatures": {
	            "type": "boolean"
	          },
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "Domain": {},
	          "DomainIAMRoleName": {},
	          "ReplicaMode": {},
	          "MaxAllocatedStorage": {
	            "type": "integer"
	          },
	          "CustomIamInstanceProfile": {},
	          "NetworkType": {},
	          "SourceRegion": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBInstanceReadReplicaResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "CreateDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName",
	          "DBParameterGroupFamily",
	          "Description"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "DBParameterGroupFamily": {},
	          "Description": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBParameterGroupResult",
	        "type": "structure",
	        "members": {
	          "DBParameterGroup": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "CreateDBProxy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBProxyName",
	          "EngineFamily",
	          "Auth",
	          "RoleArn",
	          "VpcSubnetIds"
	        ],
	        "members": {
	          "DBProxyName": {},
	          "EngineFamily": {},
	          "Auth": {
	            "shape": "S3v"
	          },
	          "RoleArn": {},
	          "VpcSubnetIds": {
	            "shape": "Sv"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "Sv"
	          },
	          "RequireTLS": {
	            "type": "boolean"
	          },
	          "IdleClientTimeout": {
	            "type": "integer"
	          },
	          "DebugLogging": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBProxyResult",
	        "type": "structure",
	        "members": {
	          "DBProxy": {
	            "shape": "S40"
	          }
	        }
	      }
	    },
	    "CreateDBProxyEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBProxyName",
	          "DBProxyEndpointName",
	          "VpcSubnetIds"
	        ],
	        "members": {
	          "DBProxyName": {},
	          "DBProxyEndpointName": {},
	          "VpcSubnetIds": {
	            "shape": "Sv"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "Sv"
	          },
	          "TargetRole": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBProxyEndpointResult",
	        "type": "structure",
	        "members": {
	          "DBProxyEndpoint": {
	            "shape": "S49"
	          }
	        }
	      }
	    },
	    "CreateDBSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName",
	          "DBSecurityGroupDescription"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "DBSecurityGroupDescription": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSecurityGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sl"
	          }
	        }
	      }
	    },
	    "CreateDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier",
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {},
	          "DBInstanceIdentifier": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "S19"
	          }
	        }
	      }
	    },
	    "CreateDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName",
	          "DBSubnetGroupDescription",
	          "SubnetIds"
	        ],
	        "members": {
	          "DBSubnetGroupName": {},
	          "DBSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S4g"
	          },
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateDBSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSubnetGroup": {
	            "shape": "S37"
	          }
	        }
	      }
	    },
	    "CreateEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SnsTopicArn"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "EventCategories": {
	            "shape": "S8"
	          },
	          "SourceIds": {
	            "shape": "S7"
	          },
	          "Enabled": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S6"
	          }
	        }
	      }
	    },
	    "CreateGlobalCluster": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GlobalClusterIdentifier": {},
	          "SourceDBClusterIdentifier": {},
	          "Engine": {},
	          "EngineVersion": {},
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "DatabaseName": {},
	          "StorageEncrypted": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateGlobalClusterResult",
	        "type": "structure",
	        "members": {
	          "GlobalCluster": {
	            "shape": "S4m"
	          }
	        }
	      }
	    },
	    "CreateOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName",
	          "EngineName",
	          "MajorEngineVersion",
	          "OptionGroupDescription"
	        ],
	        "members": {
	          "OptionGroupName": {},
	          "EngineName": {},
	          "MajorEngineVersion": {},
	          "OptionGroupDescription": {},
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "S1f"
	          }
	        }
	      }
	    },
	    "DeleteCustomDBEngineVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Engine",
	          "EngineVersion"
	        ],
	        "members": {
	          "Engine": {},
	          "EngineVersion": {}
	        }
	      },
	      "output": {
	        "shape": "S1w",
	        "resultWrapper": "DeleteCustomDBEngineVersionResult"
	      }
	    },
	    "DeleteDBCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier"
	        ],
	        "members": {
	          "DBClusterIdentifier": {},
	          "SkipFinalSnapshot": {
	            "type": "boolean"
	          },
	          "FinalDBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBClusterResult",
	        "type": "structure",
	        "members": {
	          "DBCluster": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "DeleteDBClusterEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterEndpointIdentifier"
	        ],
	        "members": {
	          "DBClusterEndpointIdentifier": {}
	        }
	      },
	      "output": {
	        "shape": "S2v",
	        "resultWrapper": "DeleteDBClusterEndpointResult"
	      }
	    },
	    "DeleteDBClusterParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterParameterGroupName"
	        ],
	        "members": {
	          "DBClusterParameterGroupName": {}
	        }
	      }
	    },
	    "DeleteDBClusterSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterSnapshotIdentifier"
	        ],
	        "members": {
	          "DBClusterSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBClusterSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBClusterSnapshot": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "DeleteDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "SkipFinalSnapshot": {
	            "type": "boolean"
	          },
	          "FinalDBSnapshotIdentifier": {},
	          "DeleteAutomatedBackups": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "DeleteDBInstanceAutomatedBackup": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DbiResourceId": {},
	          "DBInstanceAutomatedBackupsArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBInstanceAutomatedBackupResult",
	        "type": "structure",
	        "members": {
	          "DBInstanceAutomatedBackup": {
	            "shape": "S55"
	          }
	        }
	      }
	    },
	    "DeleteDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {}
	        }
	      }
	    },
	    "DeleteDBProxy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBProxyName"
	        ],
	        "members": {
	          "DBProxyName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBProxyResult",
	        "type": "structure",
	        "members": {
	          "DBProxy": {
	            "shape": "S40"
	          }
	        }
	      }
	    },
	    "DeleteDBProxyEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBProxyEndpointName"
	        ],
	        "members": {
	          "DBProxyEndpointName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBProxyEndpointResult",
	        "type": "structure",
	        "members": {
	          "DBProxyEndpoint": {
	            "shape": "S49"
	          }
	        }
	      }
	    },
	    "DeleteDBSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {}
	        }
	      }
	    },
	    "DeleteDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "S19"
	          }
	        }
	      }
	    },
	    "DeleteDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName"
	        ],
	        "members": {
	          "DBSubnetGroupName": {}
	        }
	      }
	    },
	    "DeleteEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S6"
	          }
	        }
	      }
	    },
	    "DeleteGlobalCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalClusterIdentifier"
	        ],
	        "members": {
	          "GlobalClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteGlobalClusterResult",
	        "type": "structure",
	        "members": {
	          "GlobalCluster": {
	            "shape": "S4m"
	          }
	        }
	      }
	    },
	    "DeleteOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName"
	        ],
	        "members": {
	          "OptionGroupName": {}
	        }
	      }
	    },
	    "DeregisterDBProxyTargets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBProxyName"
	        ],
	        "members": {
	          "DBProxyName": {},
	          "TargetGroupName": {},
	          "DBInstanceIdentifiers": {
	            "shape": "Sv"
	          },
	          "DBClusterIdentifiers": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeregisterDBProxyTargetsResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeAccountAttributes": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "resultWrapper": "DescribeAccountAttributesResult",
	        "type": "structure",
	        "members": {
	          "AccountQuotas": {
	            "type": "list",
	            "member": {
	              "locationName": "AccountQuota",
	              "type": "structure",
	              "members": {
	                "AccountQuotaName": {},
	                "Used": {
	                  "type": "long"
	                },
	                "Max": {
	                  "type": "long"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DescribeCertificates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CertificateIdentifier": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeCertificatesResult",
	        "type": "structure",
	        "members": {
	          "Certificates": {
	            "type": "list",
	            "member": {
	              "shape": "S5y",
	              "locationName": "Certificate"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBClusterBacktracks": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier"
	        ],
	        "members": {
	          "DBClusterIdentifier": {},
	          "BacktrackIdentifier": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBClusterBacktracksResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBClusterBacktracks": {
	            "type": "list",
	            "member": {
	              "shape": "Ss",
	              "locationName": "DBClusterBacktrack"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBClusterEndpoints": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBClusterIdentifier": {},
	          "DBClusterEndpointIdentifier": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBClusterEndpointsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBClusterEndpoints": {
	            "type": "list",
	            "member": {
	              "shape": "S2v",
	              "locationName": "DBClusterEndpointList"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBClusterParameterGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBClusterParameterGroupName": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBClusterParameterGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBClusterParameterGroups": {
	            "type": "list",
	            "member": {
	              "shape": "Sz",
	              "locationName": "DBClusterParameterGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBClusterParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterParameterGroupName"
	        ],
	        "members": {
	          "DBClusterParameterGroupName": {},
	          "Source": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBClusterParametersResult",
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "shape": "S6a"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBClusterSnapshotAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterSnapshotIdentifier"
	        ],
	        "members": {
	          "DBClusterSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBClusterSnapshotAttributesResult",
	        "type": "structure",
	        "members": {
	          "DBClusterSnapshotAttributesResult": {
	            "shape": "S6f"
	          }
	        }
	      }
	    },
	    "DescribeDBClusterSnapshots": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBClusterIdentifier": {},
	          "DBClusterSnapshotIdentifier": {},
	          "SnapshotType": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "IncludeShared": {
	            "type": "boolean"
	          },
	          "IncludePublic": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBClusterSnapshotsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBClusterSnapshots": {
	            "type": "list",
	            "member": {
	              "shape": "S12",
	              "locationName": "DBClusterSnapshot"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBClusters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBClusterIdentifier": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "IncludeShared": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBClustersResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBClusters": {
	            "type": "list",
	            "member": {
	              "shape": "S2d",
	              "locationName": "DBCluster"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBEngineVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "DBParameterGroupFamily": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "DefaultOnly": {
	            "type": "boolean"
	          },
	          "ListSupportedCharacterSets": {
	            "type": "boolean"
	          },
	          "ListSupportedTimezones": {
	            "type": "boolean"
	          },
	          "IncludeAll": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBEngineVersionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBEngineVersions": {
	            "type": "list",
	            "member": {
	              "shape": "S1w",
	              "locationName": "DBEngineVersion"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBInstanceAutomatedBackups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DbiResourceId": {},
	          "DBInstanceIdentifier": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "DBInstanceAutomatedBackupsArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBInstanceAutomatedBackupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBInstanceAutomatedBackups": {
	            "type": "list",
	            "member": {
	              "shape": "S55",
	              "locationName": "DBInstanceAutomatedBackup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBInstanceIdentifier": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBInstancesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBInstances": {
	            "type": "list",
	            "member": {
	              "shape": "S33",
	              "locationName": "DBInstance"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBLogFiles": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "FilenameContains": {},
	          "FileLastWritten": {
	            "type": "long"
	          },
	          "FileSize": {
	            "type": "long"
	          },
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBLogFilesResult",
	        "type": "structure",
	        "members": {
	          "DescribeDBLogFiles": {
	            "type": "list",
	            "member": {
	              "locationName": "DescribeDBLogFilesDetails",
	              "type": "structure",
	              "members": {
	                "LogFileName": {},
	                "LastWritten": {
	                  "type": "long"
	                },
	                "Size": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBParameterGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBParameterGroupName": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBParameterGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBParameterGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S16",
	              "locationName": "DBParameterGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "Source": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBParametersResult",
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "shape": "S6a"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBProxies": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBProxyName": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBProxiesResult",
	        "type": "structure",
	        "members": {
	          "DBProxies": {
	            "type": "list",
	            "member": {
	              "shape": "S40"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBProxyEndpoints": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBProxyName": {},
	          "DBProxyEndpointName": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBProxyEndpointsResult",
	        "type": "structure",
	        "members": {
	          "DBProxyEndpoints": {
	            "type": "list",
	            "member": {
	              "shape": "S49"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBProxyTargetGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBProxyName"
	        ],
	        "members": {
	          "DBProxyName": {},
	          "TargetGroupName": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBProxyTargetGroupsResult",
	        "type": "structure",
	        "members": {
	          "TargetGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S7h"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBProxyTargets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBProxyName"
	        ],
	        "members": {
	          "DBProxyName": {},
	          "TargetGroupName": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBProxyTargetsResult",
	        "type": "structure",
	        "members": {
	          "Targets": {
	            "shape": "S7l"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDBSecurityGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBSecurityGroupName": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSecurityGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSecurityGroups": {
	            "type": "list",
	            "member": {
	              "shape": "Sl",
	              "locationName": "DBSecurityGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBSnapshotAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSnapshotAttributesResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshotAttributesResult": {
	            "shape": "S7x"
	          }
	        }
	      }
	    },
	    "DescribeDBSnapshots": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBInstanceIdentifier": {},
	          "DBSnapshotIdentifier": {},
	          "SnapshotType": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "IncludeShared": {
	            "type": "boolean"
	          },
	          "IncludePublic": {
	            "type": "boolean"
	          },
	          "DbiResourceId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSnapshotsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSnapshots": {
	            "type": "list",
	            "member": {
	              "shape": "S19",
	              "locationName": "DBSnapshot"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDBSubnetGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DBSubnetGroupName": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDBSubnetGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "DBSubnetGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S37",
	              "locationName": "DBSubnetGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEngineDefaultClusterParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupFamily"
	        ],
	        "members": {
	          "DBParameterGroupFamily": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEngineDefaultClusterParametersResult",
	        "type": "structure",
	        "members": {
	          "EngineDefaults": {
	            "shape": "S88"
	          }
	        }
	      }
	    },
	    "DescribeEngineDefaultParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupFamily"
	        ],
	        "members": {
	          "DBParameterGroupFamily": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEngineDefaultParametersResult",
	        "type": "structure",
	        "members": {
	          "EngineDefaults": {
	            "shape": "S88"
	          }
	        }
	      }
	    },
	    "DescribeEventCategories": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceType": {},
	          "Filters": {
	            "shape": "S5t"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventCategoriesResult",
	        "type": "structure",
	        "members": {
	          "EventCategoriesMapList": {
	            "type": "list",
	            "member": {
	              "locationName": "EventCategoriesMap",
	              "type": "structure",
	              "members": {
	                "SourceType": {},
	                "EventCategories": {
	                  "shape": "S8"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DescribeEventSubscriptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SubscriptionName": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventSubscriptionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "EventSubscriptionsList": {
	            "type": "list",
	            "member": {
	              "shape": "S6",
	              "locationName": "EventSubscription"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEvents": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceIdentifier": {},
	          "SourceType": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Duration": {
	            "type": "integer"
	          },
	          "EventCategories": {
	            "shape": "S8"
	          },
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Events": {
	            "type": "list",
	            "member": {
	              "locationName": "Event",
	              "type": "structure",
	              "members": {
	                "SourceIdentifier": {},
	                "SourceType": {},
	                "Message": {},
	                "EventCategories": {
	                  "shape": "S8"
	                },
	                "Date": {
	                  "type": "timestamp"
	                },
	                "SourceArn": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeExportTasks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ExportTaskIdentifier": {},
	          "SourceArn": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeExportTasksResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ExportTasks": {
	            "type": "list",
	            "member": {
	              "shape": "Su",
	              "locationName": "ExportTask"
	            }
	          }
	        }
	      }
	    },
	    "DescribeGlobalClusters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GlobalClusterIdentifier": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeGlobalClustersResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "GlobalClusters": {
	            "type": "list",
	            "member": {
	              "shape": "S4m",
	              "locationName": "GlobalClusterMember"
	            }
	          }
	        }
	      }
	    },
	    "DescribeOptionGroupOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EngineName"
	        ],
	        "members": {
	          "EngineName": {},
	          "MajorEngineVersion": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOptionGroupOptionsResult",
	        "type": "structure",
	        "members": {
	          "OptionGroupOptions": {
	            "type": "list",
	            "member": {
	              "locationName": "OptionGroupOption",
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Description": {},
	                "EngineName": {},
	                "MajorEngineVersion": {},
	                "MinimumRequiredMinorEngineVersion": {},
	                "PortRequired": {
	                  "type": "boolean"
	                },
	                "DefaultPort": {
	                  "type": "integer"
	                },
	                "OptionsDependedOn": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "OptionName"
	                  }
	                },
	                "OptionsConflictsWith": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "OptionConflictName"
	                  }
	                },
	                "Persistent": {
	                  "type": "boolean"
	                },
	                "Permanent": {
	                  "type": "boolean"
	                },
	                "RequiresAutoMinorEngineVersionUpgrade": {
	                  "type": "boolean"
	                },
	                "VpcOnly": {
	                  "type": "boolean"
	                },
	                "SupportsOptionVersionDowngrade": {
	                  "type": "boolean"
	                },
	                "OptionGroupOptionSettings": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "OptionGroupOptionSetting",
	                    "type": "structure",
	                    "members": {
	                      "SettingName": {},
	                      "SettingDescription": {},
	                      "DefaultValue": {},
	                      "ApplyType": {},
	                      "AllowedValues": {},
	                      "IsModifiable": {
	                        "type": "boolean"
	                      },
	                      "IsRequired": {
	                        "type": "boolean"
	                      },
	                      "MinimumEngineVersionPerAllowedValue": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "MinimumEngineVersionPerAllowedValue",
	                          "type": "structure",
	                          "members": {
	                            "AllowedValue": {},
	                            "MinimumEngineVersion": {}
	                          }
	                        }
	                      }
	                    }
	                  }
	                },
	                "OptionGroupOptionVersions": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "OptionVersion",
	                    "type": "structure",
	                    "members": {
	                      "Version": {},
	                      "IsDefault": {
	                        "type": "boolean"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeOptionGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OptionGroupName": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "EngineName": {},
	          "MajorEngineVersion": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOptionGroupsResult",
	        "type": "structure",
	        "members": {
	          "OptionGroupsList": {
	            "type": "list",
	            "member": {
	              "shape": "S1f",
	              "locationName": "OptionGroup"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeOrderableDBInstanceOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Engine"
	        ],
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "DBInstanceClass": {},
	          "LicenseModel": {},
	          "AvailabilityZoneGroup": {},
	          "Vpc": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
	        "type": "structure",
	        "members": {
	          "OrderableDBInstanceOptions": {
	            "type": "list",
	            "member": {
	              "locationName": "OrderableDBInstanceOption",
	              "type": "structure",
	              "members": {
	                "Engine": {},
	                "EngineVersion": {},
	                "DBInstanceClass": {},
	                "LicenseModel": {},
	                "AvailabilityZoneGroup": {},
	                "AvailabilityZones": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S3a",
	                    "locationName": "AvailabilityZone"
	                  }
	                },
	                "MultiAZCapable": {
	                  "type": "boolean"
	                },
	                "ReadReplicaCapable": {
	                  "type": "boolean"
	                },
	                "Vpc": {
	                  "type": "boolean"
	                },
	                "SupportsStorageEncryption": {
	                  "type": "boolean"
	                },
	                "StorageType": {},
	                "SupportsIops": {
	                  "type": "boolean"
	                },
	                "SupportsEnhancedMonitoring": {
	                  "type": "boolean"
	                },
	                "SupportsIAMDatabaseAuthentication": {
	                  "type": "boolean"
	                },
	                "SupportsPerformanceInsights": {
	                  "type": "boolean"
	                },
	                "MinStorageSize": {
	                  "type": "integer"
	                },
	                "MaxStorageSize": {
	                  "type": "integer"
	                },
	                "MinIopsPerDbInstance": {
	                  "type": "integer"
	                },
	                "MaxIopsPerDbInstance": {
	                  "type": "integer"
	                },
	                "MinIopsPerGib": {
	                  "type": "double"
	                },
	                "MaxIopsPerGib": {
	                  "type": "double"
	                },
	                "AvailableProcessorFeatures": {
	                  "shape": "S9d"
	                },
	                "SupportedEngineModes": {
	                  "shape": "S21"
	                },
	                "SupportsStorageAutoscaling": {
	                  "type": "boolean"
	                },
	                "SupportsKerberosAuthentication": {
	                  "type": "boolean"
	                },
	                "OutpostCapable": {
	                  "type": "boolean"
	                },
	                "SupportedActivityStreamModes": {
	                  "type": "list",
	                  "member": {}
	                },
	                "SupportsGlobalDatabases": {
	                  "type": "boolean"
	                },
	                "SupportsClusters": {
	                  "type": "boolean"
	                },
	                "SupportedNetworkTypes": {
	                  "shape": "Sv"
	                }
	              },
	              "wrapper": true
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribePendingMaintenanceActions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ResourceIdentifier": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribePendingMaintenanceActionsResult",
	        "type": "structure",
	        "members": {
	          "PendingMaintenanceActions": {
	            "type": "list",
	            "member": {
	              "shape": "Sf",
	              "locationName": "ResourcePendingMaintenanceActions"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeReservedDBInstances": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedDBInstanceId": {},
	          "ReservedDBInstancesOfferingId": {},
	          "DBInstanceClass": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "LeaseId": {},
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedDBInstancesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedDBInstances": {
	            "type": "list",
	            "member": {
	              "shape": "S9m",
	              "locationName": "ReservedDBInstance"
	            }
	          }
	        }
	      }
	    },
	    "DescribeReservedDBInstancesOfferings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedDBInstancesOfferingId": {},
	          "DBInstanceClass": {},
	          "Duration": {},
	          "ProductDescription": {},
	          "OfferingType": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "shape": "S5t"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedDBInstancesOfferings": {
	            "type": "list",
	            "member": {
	              "locationName": "ReservedDBInstancesOffering",
	              "type": "structure",
	              "members": {
	                "ReservedDBInstancesOfferingId": {},
	                "DBInstanceClass": {},
	                "Duration": {
	                  "type": "integer"
	                },
	                "FixedPrice": {
	                  "type": "double"
	                },
	                "UsagePrice": {
	                  "type": "double"
	                },
	                "CurrencyCode": {},
	                "ProductDescription": {},
	                "OfferingType": {},
	                "MultiAZ": {
	                  "type": "boolean"
	                },
	                "RecurringCharges": {
	                  "shape": "S9o"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DescribeSourceRegions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "RegionName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "Filters": {
	            "shape": "S5t"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeSourceRegionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "SourceRegions": {
	            "type": "list",
	            "member": {
	              "locationName": "SourceRegion",
	              "type": "structure",
	              "members": {
	                "RegionName": {},
	                "Endpoint": {},
	                "Status": {},
	                "SupportsDBInstanceAutomatedBackupsReplication": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeValidDBInstanceModifications": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeValidDBInstanceModificationsResult",
	        "type": "structure",
	        "members": {
	          "ValidDBInstanceModificationsMessage": {
	            "type": "structure",
	            "members": {
	              "Storage": {
	                "type": "list",
	                "member": {
	                  "locationName": "ValidStorageOptions",
	                  "type": "structure",
	                  "members": {
	                    "StorageType": {},
	                    "StorageSize": {
	                      "shape": "Sa3"
	                    },
	                    "ProvisionedIops": {
	                      "shape": "Sa3"
	                    },
	                    "IopsToStorageRatio": {
	                      "type": "list",
	                      "member": {
	                        "locationName": "DoubleRange",
	                        "type": "structure",
	                        "members": {
	                          "From": {
	                            "type": "double"
	                          },
	                          "To": {
	                            "type": "double"
	                          }
	                        }
	                      }
	                    },
	                    "SupportsStorageAutoscaling": {
	                      "type": "boolean"
	                    }
	                  }
	                }
	              },
	              "ValidProcessorFeatures": {
	                "shape": "S9d"
	              }
	            },
	            "wrapper": true
	          }
	        }
	      }
	    },
	    "DownloadDBLogFilePortion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "LogFileName"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "LogFileName": {},
	          "Marker": {},
	          "NumberOfLines": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DownloadDBLogFilePortionResult",
	        "type": "structure",
	        "members": {
	          "LogFileData": {},
	          "Marker": {},
	          "AdditionalDataPending": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "FailoverDBCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier"
	        ],
	        "members": {
	          "DBClusterIdentifier": {},
	          "TargetDBInstanceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "FailoverDBClusterResult",
	        "type": "structure",
	        "members": {
	          "DBCluster": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "FailoverGlobalCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GlobalClusterIdentifier",
	          "TargetDbClusterIdentifier"
	        ],
	        "members": {
	          "GlobalClusterIdentifier": {},
	          "TargetDbClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "FailoverGlobalClusterResult",
	        "type": "structure",
	        "members": {
	          "GlobalCluster": {
	            "shape": "S4m"
	          }
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName"
	        ],
	        "members": {
	          "ResourceName": {},
	          "Filters": {
	            "shape": "S5t"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTagsForResourceResult",
	        "type": "structure",
	        "members": {
	          "TagList": {
	            "shape": "Sb"
	          }
	        }
	      }
	    },
	    "ModifyCertificates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CertificateIdentifier": {},
	          "RemoveCustomerOverride": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyCertificatesResult",
	        "type": "structure",
	        "members": {
	          "Certificate": {
	            "shape": "S5y"
	          }
	        }
	      }
	    },
	    "ModifyCurrentDBClusterCapacity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier"
	        ],
	        "members": {
	          "DBClusterIdentifier": {},
	          "Capacity": {
	            "type": "integer"
	          },
	          "SecondsBeforeTimeout": {
	            "type": "integer"
	          },
	          "TimeoutAction": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyCurrentDBClusterCapacityResult",
	        "type": "structure",
	        "members": {
	          "DBClusterIdentifier": {},
	          "PendingCapacity": {
	            "type": "integer"
	          },
	          "CurrentCapacity": {
	            "type": "integer"
	          },
	          "SecondsBeforeTimeout": {
	            "type": "integer"
	          },
	          "TimeoutAction": {}
	        }
	      }
	    },
	    "ModifyCustomDBEngineVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Engine",
	          "EngineVersion"
	        ],
	        "members": {
	          "Engine": {},
	          "EngineVersion": {},
	          "Description": {},
	          "Status": {}
	        }
	      },
	      "output": {
	        "shape": "S1w",
	        "resultWrapper": "ModifyCustomDBEngineVersionResult"
	      }
	    },
	    "ModifyDBCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier"
	        ],
	        "members": {
	          "DBClusterIdentifier": {},
	          "NewDBClusterIdentifier": {},
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "DBClusterParameterGroupName": {},
	          "VpcSecurityGroupIds": {
	            "shape": "S27"
	          },
	          "Port": {
	            "type": "integer"
	          },
	          "MasterUserPassword": {},
	          "OptionGroupName": {},
	          "PreferredBackupWindow": {},
	          "PreferredMaintenanceWindow": {},
	          "EnableIAMDatabaseAuthentication": {
	            "type": "boolean"
	          },
	          "BacktrackWindow": {
	            "type": "long"
	          },
	          "CloudwatchLogsExportConfiguration": {
	            "shape": "Sao"
	          },
	          "EngineVersion": {},
	          "AllowMajorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "DBInstanceParameterGroupName": {},
	          "Domain": {},
	          "DomainIAMRoleName": {},
	          "ScalingConfiguration": {
	            "shape": "S29"
	          },
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "EnableHttpEndpoint": {
	            "type": "boolean"
	          },
	          "CopyTagsToSnapshot": {
	            "type": "boolean"
	          },
	          "EnableGlobalWriteForwarding": {
	            "type": "boolean"
	          },
	          "DBClusterInstanceClass": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "StorageType": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "MonitoringInterval": {
	            "type": "integer"
	          },
	          "MonitoringRoleArn": {},
	          "EnablePerformanceInsights": {
	            "type": "boolean"
	          },
	          "PerformanceInsightsKMSKeyId": {},
	          "PerformanceInsightsRetentionPeriod": {
	            "type": "integer"
	          },
	          "ServerlessV2ScalingConfiguration": {
	            "shape": "S2a"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBClusterResult",
	        "type": "structure",
	        "members": {
	          "DBCluster": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "ModifyDBClusterEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterEndpointIdentifier"
	        ],
	        "members": {
	          "DBClusterEndpointIdentifier": {},
	          "EndpointType": {},
	          "StaticMembers": {
	            "shape": "Sv"
	          },
	          "ExcludedMembers": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "shape": "S2v",
	        "resultWrapper": "ModifyDBClusterEndpointResult"
	      }
	    },
	    "ModifyDBClusterParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterParameterGroupName",
	          "Parameters"
	        ],
	        "members": {
	          "DBClusterParameterGroupName": {},
	          "Parameters": {
	            "shape": "S6a"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sas",
	        "resultWrapper": "ModifyDBClusterParameterGroupResult"
	      }
	    },
	    "ModifyDBClusterSnapshotAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterSnapshotIdentifier",
	          "AttributeName"
	        ],
	        "members": {
	          "DBClusterSnapshotIdentifier": {},
	          "AttributeName": {},
	          "ValuesToAdd": {
	            "shape": "S6i"
	          },
	          "ValuesToRemove": {
	            "shape": "S6i"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBClusterSnapshotAttributeResult",
	        "type": "structure",
	        "members": {
	          "DBClusterSnapshotAttributesResult": {
	            "shape": "S6f"
	          }
	        }
	      }
	    },
	    "ModifyDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "DBInstanceClass": {},
	          "DBSubnetGroupName": {},
	          "DBSecurityGroups": {
	            "shape": "S31"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "S27"
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "MasterUserPassword": {},
	          "DBParameterGroupName": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {},
	          "PreferredMaintenanceWindow": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AllowMajorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "NewDBInstanceIdentifier": {},
	          "StorageType": {},
	          "TdeCredentialArn": {},
	          "TdeCredentialPassword": {},
	          "CACertificateIdentifier": {},
	          "Domain": {},
	          "CopyTagsToSnapshot": {
	            "type": "boolean"
	          },
	          "MonitoringInterval": {
	            "type": "integer"
	          },
	          "DBPortNumber": {
	            "type": "integer"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "MonitoringRoleArn": {},
	          "DomainIAMRoleName": {},
	          "PromotionTier": {
	            "type": "integer"
	          },
	          "EnableIAMDatabaseAuthentication": {
	            "type": "boolean"
	          },
	          "EnablePerformanceInsights": {
	            "type": "boolean"
	          },
	          "PerformanceInsightsKMSKeyId": {},
	          "PerformanceInsightsRetentionPeriod": {
	            "type": "integer"
	          },
	          "CloudwatchLogsExportConfiguration": {
	            "shape": "Sao"
	          },
	          "ProcessorFeatures": {
	            "shape": "S1b"
	          },
	          "UseDefaultProcessorFeatures": {
	            "type": "boolean"
	          },
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "MaxAllocatedStorage": {
	            "type": "integer"
	          },
	          "CertificateRotationRestart": {
	            "type": "boolean"
	          },
	          "ReplicaMode": {},
	          "EnableCustomerOwnedIp": {
	            "type": "boolean"
	          },
	          "AwsBackupRecoveryPointArn": {},
	          "AutomationMode": {},
	          "ResumeFullAutomationModeMinutes": {
	            "type": "integer"
	          },
	          "NetworkType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "ModifyDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName",
	          "Parameters"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "Parameters": {
	            "shape": "S6a"
	          }
	        }
	      },
	      "output": {
	        "shape": "Saz",
	        "resultWrapper": "ModifyDBParameterGroupResult"
	      }
	    },
	    "ModifyDBProxy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBProxyName"
	        ],
	        "members": {
	          "DBProxyName": {},
	          "NewDBProxyName": {},
	          "Auth": {
	            "shape": "S3v"
	          },
	          "RequireTLS": {
	            "type": "boolean"
	          },
	          "IdleClientTimeout": {
	            "type": "integer"
	          },
	          "DebugLogging": {
	            "type": "boolean"
	          },
	          "RoleArn": {},
	          "SecurityGroups": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBProxyResult",
	        "type": "structure",
	        "members": {
	          "DBProxy": {
	            "shape": "S40"
	          }
	        }
	      }
	    },
	    "ModifyDBProxyEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBProxyEndpointName"
	        ],
	        "members": {
	          "DBProxyEndpointName": {},
	          "NewDBProxyEndpointName": {},
	          "VpcSecurityGroupIds": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBProxyEndpointResult",
	        "type": "structure",
	        "members": {
	          "DBProxyEndpoint": {
	            "shape": "S49"
	          }
	        }
	      }
	    },
	    "ModifyDBProxyTargetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetGroupName",
	          "DBProxyName"
	        ],
	        "members": {
	          "TargetGroupName": {},
	          "DBProxyName": {},
	          "ConnectionPoolConfig": {
	            "type": "structure",
	            "members": {
	              "MaxConnectionsPercent": {
	                "type": "integer"
	              },
	              "MaxIdleConnectionsPercent": {
	                "type": "integer"
	              },
	              "ConnectionBorrowTimeout": {
	                "type": "integer"
	              },
	              "SessionPinningFilters": {
	                "shape": "Sv"
	              },
	              "InitQuery": {}
	            }
	          },
	          "NewName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBProxyTargetGroupResult",
	        "type": "structure",
	        "members": {
	          "DBProxyTargetGroup": {
	            "shape": "S7h"
	          }
	        }
	      }
	    },
	    "ModifyDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {},
	          "EngineVersion": {},
	          "OptionGroupName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshot": {
	            "shape": "S19"
	          }
	        }
	      }
	    },
	    "ModifyDBSnapshotAttribute": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSnapshotIdentifier",
	          "AttributeName"
	        ],
	        "members": {
	          "DBSnapshotIdentifier": {},
	          "AttributeName": {},
	          "ValuesToAdd": {
	            "shape": "S6i"
	          },
	          "ValuesToRemove": {
	            "shape": "S6i"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBSnapshotAttributeResult",
	        "type": "structure",
	        "members": {
	          "DBSnapshotAttributesResult": {
	            "shape": "S7x"
	          }
	        }
	      }
	    },
	    "ModifyDBSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSubnetGroupName",
	          "SubnetIds"
	        ],
	        "members": {
	          "DBSubnetGroupName": {},
	          "DBSubnetGroupDescription": {},
	          "SubnetIds": {
	            "shape": "S4g"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyDBSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "DBSubnetGroup": {
	            "shape": "S37"
	          }
	        }
	      }
	    },
	    "ModifyEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "EventCategories": {
	            "shape": "S8"
	          },
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S6"
	          }
	        }
	      }
	    },
	    "ModifyGlobalCluster": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GlobalClusterIdentifier": {},
	          "NewGlobalClusterIdentifier": {},
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AllowMajorVersionUpgrade": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyGlobalClusterResult",
	        "type": "structure",
	        "members": {
	          "GlobalCluster": {
	            "shape": "S4m"
	          }
	        }
	      }
	    },
	    "ModifyOptionGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OptionGroupName"
	        ],
	        "members": {
	          "OptionGroupName": {},
	          "OptionsToInclude": {
	            "type": "list",
	            "member": {
	              "locationName": "OptionConfiguration",
	              "type": "structure",
	              "required": [
	                "OptionName"
	              ],
	              "members": {
	                "OptionName": {},
	                "Port": {
	                  "type": "integer"
	                },
	                "OptionVersion": {},
	                "DBSecurityGroupMemberships": {
	                  "shape": "S31"
	                },
	                "VpcSecurityGroupMemberships": {
	                  "shape": "S27"
	                },
	                "OptionSettings": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S1j",
	                    "locationName": "OptionSetting"
	                  }
	                }
	              }
	            }
	          },
	          "OptionsToRemove": {
	            "type": "list",
	            "member": {}
	          },
	          "ApplyImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyOptionGroupResult",
	        "type": "structure",
	        "members": {
	          "OptionGroup": {
	            "shape": "S1f"
	          }
	        }
	      }
	    },
	    "PromoteReadReplica": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "PromoteReadReplicaResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "PromoteReadReplicaDBCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier"
	        ],
	        "members": {
	          "DBClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "PromoteReadReplicaDBClusterResult",
	        "type": "structure",
	        "members": {
	          "DBCluster": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "PurchaseReservedDBInstancesOffering": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedDBInstancesOfferingId"
	        ],
	        "members": {
	          "ReservedDBInstancesOfferingId": {},
	          "ReservedDBInstanceId": {},
	          "DBInstanceCount": {
	            "type": "integer"
	          },
	          "Tags": {
	            "shape": "Sb"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
	        "type": "structure",
	        "members": {
	          "ReservedDBInstance": {
	            "shape": "S9m"
	          }
	        }
	      }
	    },
	    "RebootDBCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier"
	        ],
	        "members": {
	          "DBClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RebootDBClusterResult",
	        "type": "structure",
	        "members": {
	          "DBCluster": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "RebootDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "ForceFailover": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RebootDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "RegisterDBProxyTargets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBProxyName"
	        ],
	        "members": {
	          "DBProxyName": {},
	          "TargetGroupName": {},
	          "DBInstanceIdentifiers": {
	            "shape": "Sv"
	          },
	          "DBClusterIdentifiers": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RegisterDBProxyTargetsResult",
	        "type": "structure",
	        "members": {
	          "DBProxyTargets": {
	            "shape": "S7l"
	          }
	        }
	      }
	    },
	    "RemoveFromGlobalCluster": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GlobalClusterIdentifier": {},
	          "DbClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RemoveFromGlobalClusterResult",
	        "type": "structure",
	        "members": {
	          "GlobalCluster": {
	            "shape": "S4m"
	          }
	        }
	      }
	    },
	    "RemoveRoleFromDBCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier",
	          "RoleArn"
	        ],
	        "members": {
	          "DBClusterIdentifier": {},
	          "RoleArn": {},
	          "FeatureName": {}
	        }
	      }
	    },
	    "RemoveRoleFromDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "RoleArn",
	          "FeatureName"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "RoleArn": {},
	          "FeatureName": {}
	        }
	      }
	    },
	    "RemoveSourceIdentifierFromSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SourceIdentifier"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SourceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S6"
	          }
	        }
	      }
	    },
	    "RemoveTagsFromResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceName": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "ResetDBClusterParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterParameterGroupName"
	        ],
	        "members": {
	          "DBClusterParameterGroupName": {},
	          "ResetAllParameters": {
	            "type": "boolean"
	          },
	          "Parameters": {
	            "shape": "S6a"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sas",
	        "resultWrapper": "ResetDBClusterParameterGroupResult"
	      }
	    },
	    "ResetDBParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBParameterGroupName"
	        ],
	        "members": {
	          "DBParameterGroupName": {},
	          "ResetAllParameters": {
	            "type": "boolean"
	          },
	          "Parameters": {
	            "shape": "S6a"
	          }
	        }
	      },
	      "output": {
	        "shape": "Saz",
	        "resultWrapper": "ResetDBParameterGroupResult"
	      }
	    },
	    "RestoreDBClusterFromS3": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier",
	          "Engine",
	          "MasterUsername",
	          "MasterUserPassword",
	          "SourceEngine",
	          "SourceEngineVersion",
	          "S3BucketName",
	          "S3IngestionRoleArn"
	        ],
	        "members": {
	          "AvailabilityZones": {
	            "shape": "S13"
	          },
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "CharacterSetName": {},
	          "DatabaseName": {},
	          "DBClusterIdentifier": {},
	          "DBClusterParameterGroupName": {},
	          "VpcSecurityGroupIds": {
	            "shape": "S27"
	          },
	          "DBSubnetGroupName": {},
	          "Engine": {},
	          "EngineVersion": {},
	          "Port": {
	            "type": "integer"
	          },
	          "MasterUsername": {},
	          "MasterUserPassword": {},
	          "OptionGroupName": {},
	          "PreferredBackupWindow": {},
	          "PreferredMaintenanceWindow": {},
	          "Tags": {
	            "shape": "Sb"
	          },
	          "StorageEncrypted": {
	            "type": "boolean"
	          },
	          "KmsKeyId": {},
	          "EnableIAMDatabaseAuthentication": {
	            "type": "boolean"
	          },
	          "SourceEngine": {},
	          "SourceEngineVersion": {},
	          "S3BucketName": {},
	          "S3Prefix": {},
	          "S3IngestionRoleArn": {},
	          "BacktrackWindow": {
	            "type": "long"
	          },
	          "EnableCloudwatchLogsExports": {
	            "shape": "S24"
	          },
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "CopyTagsToSnapshot": {
	            "type": "boolean"
	          },
	          "Domain": {},
	          "DomainIAMRoleName": {},
	          "ServerlessV2ScalingConfiguration": {
	            "shape": "S2a"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBClusterFromS3Result",
	        "type": "structure",
	        "members": {
	          "DBCluster": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "RestoreDBClusterFromSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier",
	          "SnapshotIdentifier",
	          "Engine"
	        ],
	        "members": {
	          "AvailabilityZones": {
	            "shape": "S13"
	          },
	          "DBClusterIdentifier": {},
	          "SnapshotIdentifier": {},
	          "Engine": {},
	          "EngineVersion": {},
	          "Port": {
	            "type": "integer"
	          },
	          "DBSubnetGroupName": {},
	          "DatabaseName": {},
	          "OptionGroupName": {},
	          "VpcSecurityGroupIds": {
	            "shape": "S27"
	          },
	          "Tags": {
	            "shape": "Sb"
	          },
	          "KmsKeyId": {},
	          "EnableIAMDatabaseAuthentication": {
	            "type": "boolean"
	          },
	          "BacktrackWindow": {
	            "type": "long"
	          },
	          "EnableCloudwatchLogsExports": {
	            "shape": "S24"
	          },
	          "EngineMode": {},
	          "ScalingConfiguration": {
	            "shape": "S29"
	          },
	          "DBClusterParameterGroupName": {},
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "CopyTagsToSnapshot": {
	            "type": "boolean"
	          },
	          "Domain": {},
	          "DomainIAMRoleName": {},
	          "DBClusterInstanceClass": {},
	          "StorageType": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "ServerlessV2ScalingConfiguration": {
	            "shape": "S2a"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBClusterFromSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBCluster": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "RestoreDBClusterToPointInTime": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier",
	          "SourceDBClusterIdentifier"
	        ],
	        "members": {
	          "DBClusterIdentifier": {},
	          "RestoreType": {},
	          "SourceDBClusterIdentifier": {},
	          "RestoreToTime": {
	            "type": "timestamp"
	          },
	          "UseLatestRestorableTime": {
	            "type": "boolean"
	          },
	          "Port": {
	            "type": "integer"
	          },
	          "DBSubnetGroupName": {},
	          "OptionGroupName": {},
	          "VpcSecurityGroupIds": {
	            "shape": "S27"
	          },
	          "Tags": {
	            "shape": "Sb"
	          },
	          "KmsKeyId": {},
	          "EnableIAMDatabaseAuthentication": {
	            "type": "boolean"
	          },
	          "BacktrackWindow": {
	            "type": "long"
	          },
	          "EnableCloudwatchLogsExports": {
	            "shape": "S24"
	          },
	          "DBClusterParameterGroupName": {},
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "CopyTagsToSnapshot": {
	            "type": "boolean"
	          },
	          "Domain": {},
	          "DomainIAMRoleName": {},
	          "ScalingConfiguration": {
	            "shape": "S29"
	          },
	          "EngineMode": {},
	          "DBClusterInstanceClass": {},
	          "StorageType": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "Iops": {
	            "type": "integer"
	          },
	          "ServerlessV2ScalingConfiguration": {
	            "shape": "S2a"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBClusterToPointInTimeResult",
	        "type": "structure",
	        "members": {
	          "DBCluster": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "RestoreDBInstanceFromDBSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "DBSnapshotIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "DBSnapshotIdentifier": {},
	          "DBInstanceClass": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "DBName": {},
	          "Engine": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "Tags": {
	            "shape": "Sb"
	          },
	          "StorageType": {},
	          "TdeCredentialArn": {},
	          "TdeCredentialPassword": {},
	          "VpcSecurityGroupIds": {
	            "shape": "S27"
	          },
	          "Domain": {},
	          "CopyTagsToSnapshot": {
	            "type": "boolean"
	          },
	          "DomainIAMRoleName": {},
	          "EnableIAMDatabaseAuthentication": {
	            "type": "boolean"
	          },
	          "EnableCloudwatchLogsExports": {
	            "shape": "S24"
	          },
	          "ProcessorFeatures": {
	            "shape": "S1b"
	          },
	          "UseDefaultProcessorFeatures": {
	            "type": "boolean"
	          },
	          "DBParameterGroupName": {},
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "EnableCustomerOwnedIp": {
	            "type": "boolean"
	          },
	          "CustomIamInstanceProfile": {},
	          "BackupTarget": {},
	          "NetworkType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "RestoreDBInstanceFromS3": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier",
	          "DBInstanceClass",
	          "Engine",
	          "SourceEngine",
	          "SourceEngineVersion",
	          "S3BucketName",
	          "S3IngestionRoleArn"
	        ],
	        "members": {
	          "DBName": {},
	          "DBInstanceIdentifier": {},
	          "AllocatedStorage": {
	            "type": "integer"
	          },
	          "DBInstanceClass": {},
	          "Engine": {},
	          "MasterUsername": {},
	          "MasterUserPassword": {},
	          "DBSecurityGroups": {
	            "shape": "S31"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "S27"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "PreferredMaintenanceWindow": {},
	          "DBParameterGroupName": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredBackupWindow": {},
	          "Port": {
	            "type": "integer"
	          },
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "EngineVersion": {},
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "Sb"
	          },
	          "StorageType": {},
	          "StorageEncrypted": {
	            "type": "boolean"
	          },
	          "KmsKeyId": {},
	          "CopyTagsToSnapshot": {
	            "type": "boolean"
	          },
	          "MonitoringInterval": {
	            "type": "integer"
	          },
	          "MonitoringRoleArn": {},
	          "EnableIAMDatabaseAuthentication": {
	            "type": "boolean"
	          },
	          "SourceEngine": {},
	          "SourceEngineVersion": {},
	          "S3BucketName": {},
	          "S3Prefix": {},
	          "S3IngestionRoleArn": {},
	          "EnablePerformanceInsights": {
	            "type": "boolean"
	          },
	          "PerformanceInsightsKMSKeyId": {},
	          "PerformanceInsightsRetentionPeriod": {
	            "type": "integer"
	          },
	          "EnableCloudwatchLogsExports": {
	            "shape": "S24"
	          },
	          "ProcessorFeatures": {
	            "shape": "S1b"
	          },
	          "UseDefaultProcessorFeatures": {
	            "type": "boolean"
	          },
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "MaxAllocatedStorage": {
	            "type": "integer"
	          },
	          "NetworkType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBInstanceFromS3Result",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "RestoreDBInstanceToPointInTime": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetDBInstanceIdentifier"
	        ],
	        "members": {
	          "SourceDBInstanceIdentifier": {},
	          "TargetDBInstanceIdentifier": {},
	          "RestoreTime": {
	            "type": "timestamp"
	          },
	          "UseLatestRestorableTime": {
	            "type": "boolean"
	          },
	          "DBInstanceClass": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AvailabilityZone": {},
	          "DBSubnetGroupName": {},
	          "MultiAZ": {
	            "type": "boolean"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "AutoMinorVersionUpgrade": {
	            "type": "boolean"
	          },
	          "LicenseModel": {},
	          "DBName": {},
	          "Engine": {},
	          "Iops": {
	            "type": "integer"
	          },
	          "OptionGroupName": {},
	          "CopyTagsToSnapshot": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "Sb"
	          },
	          "StorageType": {},
	          "TdeCredentialArn": {},
	          "TdeCredentialPassword": {},
	          "VpcSecurityGroupIds": {
	            "shape": "S27"
	          },
	          "Domain": {},
	          "DomainIAMRoleName": {},
	          "EnableIAMDatabaseAuthentication": {
	            "type": "boolean"
	          },
	          "EnableCloudwatchLogsExports": {
	            "shape": "S24"
	          },
	          "ProcessorFeatures": {
	            "shape": "S1b"
	          },
	          "UseDefaultProcessorFeatures": {
	            "type": "boolean"
	          },
	          "DBParameterGroupName": {},
	          "DeletionProtection": {
	            "type": "boolean"
	          },
	          "SourceDbiResourceId": {},
	          "MaxAllocatedStorage": {
	            "type": "integer"
	          },
	          "SourceDBInstanceAutomatedBackupsArn": {},
	          "EnableCustomerOwnedIp": {
	            "type": "boolean"
	          },
	          "CustomIamInstanceProfile": {},
	          "BackupTarget": {},
	          "NetworkType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreDBInstanceToPointInTimeResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "RevokeDBSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBSecurityGroupName"
	        ],
	        "members": {
	          "DBSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupId": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RevokeDBSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroup": {
	            "shape": "Sl"
	          }
	        }
	      }
	    },
	    "StartActivityStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Mode",
	          "KmsKeyId"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Mode": {},
	          "KmsKeyId": {},
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "EngineNativeAuditFieldsIncluded": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "StartActivityStreamResult",
	        "type": "structure",
	        "members": {
	          "KmsKeyId": {},
	          "KinesisStreamName": {},
	          "Status": {},
	          "Mode": {},
	          "ApplyImmediately": {
	            "type": "boolean"
	          },
	          "EngineNativeAuditFieldsIncluded": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "StartDBCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier"
	        ],
	        "members": {
	          "DBClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "StartDBClusterResult",
	        "type": "structure",
	        "members": {
	          "DBCluster": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "StartDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "StartDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "StartDBInstanceAutomatedBackupsReplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBInstanceArn"
	        ],
	        "members": {
	          "SourceDBInstanceArn": {},
	          "BackupRetentionPeriod": {
	            "type": "integer"
	          },
	          "KmsKeyId": {},
	          "PreSignedUrl": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "StartDBInstanceAutomatedBackupsReplicationResult",
	        "type": "structure",
	        "members": {
	          "DBInstanceAutomatedBackup": {
	            "shape": "S55"
	          }
	        }
	      }
	    },
	    "StartExportTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ExportTaskIdentifier",
	          "SourceArn",
	          "S3BucketName",
	          "IamRoleArn",
	          "KmsKeyId"
	        ],
	        "members": {
	          "ExportTaskIdentifier": {},
	          "SourceArn": {},
	          "S3BucketName": {},
	          "IamRoleArn": {},
	          "KmsKeyId": {},
	          "S3Prefix": {},
	          "ExportOnly": {
	            "shape": "Sv"
	          }
	        }
	      },
	      "output": {
	        "shape": "Su",
	        "resultWrapper": "StartExportTaskResult"
	      }
	    },
	    "StopActivityStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "ApplyImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "StopActivityStreamResult",
	        "type": "structure",
	        "members": {
	          "KmsKeyId": {},
	          "KinesisStreamName": {},
	          "Status": {}
	        }
	      }
	    },
	    "StopDBCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBClusterIdentifier"
	        ],
	        "members": {
	          "DBClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "StopDBClusterResult",
	        "type": "structure",
	        "members": {
	          "DBCluster": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "StopDBInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DBInstanceIdentifier"
	        ],
	        "members": {
	          "DBInstanceIdentifier": {},
	          "DBSnapshotIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "StopDBInstanceResult",
	        "type": "structure",
	        "members": {
	          "DBInstance": {
	            "shape": "S33"
	          }
	        }
	      }
	    },
	    "StopDBInstanceAutomatedBackupsReplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceDBInstanceArn"
	        ],
	        "members": {
	          "SourceDBInstanceArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "StopDBInstanceAutomatedBackupsReplicationResult",
	        "type": "structure",
	        "members": {
	          "DBInstanceAutomatedBackup": {
	            "shape": "S55"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S6": {
	      "type": "structure",
	      "members": {
	        "CustomerAwsId": {},
	        "CustSubscriptionId": {},
	        "SnsTopicArn": {},
	        "Status": {},
	        "SubscriptionCreationTime": {},
	        "SourceType": {},
	        "SourceIdsList": {
	          "shape": "S7"
	        },
	        "EventCategoriesList": {
	          "shape": "S8"
	        },
	        "Enabled": {
	          "type": "boolean"
	        },
	        "EventSubscriptionArn": {}
	      },
	      "wrapper": true
	    },
	    "S7": {
	      "type": "list",
	      "member": {
	        "locationName": "SourceId"
	      }
	    },
	    "S8": {
	      "type": "list",
	      "member": {
	        "locationName": "EventCategory"
	      }
	    },
	    "Sb": {
	      "type": "list",
	      "member": {
	        "locationName": "Tag",
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sf": {
	      "type": "structure",
	      "members": {
	        "ResourceIdentifier": {},
	        "PendingMaintenanceActionDetails": {
	          "type": "list",
	          "member": {
	            "locationName": "PendingMaintenanceAction",
	            "type": "structure",
	            "members": {
	              "Action": {},
	              "AutoAppliedAfterDate": {
	                "type": "timestamp"
	              },
	              "ForcedApplyDate": {
	                "type": "timestamp"
	              },
	              "OptInStatus": {},
	              "CurrentApplyDate": {
	                "type": "timestamp"
	              },
	              "Description": {}
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "Sl": {
	      "type": "structure",
	      "members": {
	        "OwnerId": {},
	        "DBSecurityGroupName": {},
	        "DBSecurityGroupDescription": {},
	        "VpcId": {},
	        "EC2SecurityGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "EC2SecurityGroup",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "EC2SecurityGroupName": {},
	              "EC2SecurityGroupId": {},
	              "EC2SecurityGroupOwnerId": {}
	            }
	          }
	        },
	        "IPRanges": {
	          "type": "list",
	          "member": {
	            "locationName": "IPRange",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "CIDRIP": {}
	            }
	          }
	        },
	        "DBSecurityGroupArn": {}
	      },
	      "wrapper": true
	    },
	    "Ss": {
	      "type": "structure",
	      "members": {
	        "DBClusterIdentifier": {},
	        "BacktrackIdentifier": {},
	        "BacktrackTo": {
	          "type": "timestamp"
	        },
	        "BacktrackedFrom": {
	          "type": "timestamp"
	        },
	        "BacktrackRequestCreationTime": {
	          "type": "timestamp"
	        },
	        "Status": {}
	      }
	    },
	    "Su": {
	      "type": "structure",
	      "members": {
	        "ExportTaskIdentifier": {},
	        "SourceArn": {},
	        "ExportOnly": {
	          "shape": "Sv"
	        },
	        "SnapshotTime": {
	          "type": "timestamp"
	        },
	        "TaskStartTime": {
	          "type": "timestamp"
	        },
	        "TaskEndTime": {
	          "type": "timestamp"
	        },
	        "S3Bucket": {},
	        "S3Prefix": {},
	        "IamRoleArn": {},
	        "KmsKeyId": {},
	        "Status": {},
	        "PercentProgress": {
	          "type": "integer"
	        },
	        "TotalExtractedDataInGB": {
	          "type": "integer"
	        },
	        "FailureCause": {},
	        "WarningMessage": {}
	      }
	    },
	    "Sv": {
	      "type": "list",
	      "member": {}
	    },
	    "Sz": {
	      "type": "structure",
	      "members": {
	        "DBClusterParameterGroupName": {},
	        "DBParameterGroupFamily": {},
	        "Description": {},
	        "DBClusterParameterGroupArn": {}
	      },
	      "wrapper": true
	    },
	    "S12": {
	      "type": "structure",
	      "members": {
	        "AvailabilityZones": {
	          "shape": "S13"
	        },
	        "DBClusterSnapshotIdentifier": {},
	        "DBClusterIdentifier": {},
	        "SnapshotCreateTime": {
	          "type": "timestamp"
	        },
	        "Engine": {},
	        "EngineMode": {},
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "Status": {},
	        "Port": {
	          "type": "integer"
	        },
	        "VpcId": {},
	        "ClusterCreateTime": {
	          "type": "timestamp"
	        },
	        "MasterUsername": {},
	        "EngineVersion": {},
	        "LicenseModel": {},
	        "SnapshotType": {},
	        "PercentProgress": {
	          "type": "integer"
	        },
	        "StorageEncrypted": {
	          "type": "boolean"
	        },
	        "KmsKeyId": {},
	        "DBClusterSnapshotArn": {},
	        "SourceDBClusterSnapshotArn": {},
	        "IAMDatabaseAuthenticationEnabled": {
	          "type": "boolean"
	        },
	        "TagList": {
	          "shape": "Sb"
	        }
	      },
	      "wrapper": true
	    },
	    "S13": {
	      "type": "list",
	      "member": {
	        "locationName": "AvailabilityZone"
	      }
	    },
	    "S16": {
	      "type": "structure",
	      "members": {
	        "DBParameterGroupName": {},
	        "DBParameterGroupFamily": {},
	        "Description": {},
	        "DBParameterGroupArn": {}
	      },
	      "wrapper": true
	    },
	    "S19": {
	      "type": "structure",
	      "members": {
	        "DBSnapshotIdentifier": {},
	        "DBInstanceIdentifier": {},
	        "SnapshotCreateTime": {
	          "type": "timestamp"
	        },
	        "Engine": {},
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "Status": {},
	        "Port": {
	          "type": "integer"
	        },
	        "AvailabilityZone": {},
	        "VpcId": {},
	        "InstanceCreateTime": {
	          "type": "timestamp"
	        },
	        "MasterUsername": {},
	        "EngineVersion": {},
	        "LicenseModel": {},
	        "SnapshotType": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "OptionGroupName": {},
	        "PercentProgress": {
	          "type": "integer"
	        },
	        "SourceRegion": {},
	        "SourceDBSnapshotIdentifier": {},
	        "StorageType": {},
	        "TdeCredentialArn": {},
	        "Encrypted": {
	          "type": "boolean"
	        },
	        "KmsKeyId": {},
	        "DBSnapshotArn": {},
	        "Timezone": {},
	        "IAMDatabaseAuthenticationEnabled": {
	          "type": "boolean"
	        },
	        "ProcessorFeatures": {
	          "shape": "S1b"
	        },
	        "DbiResourceId": {},
	        "TagList": {
	          "shape": "Sb"
	        },
	        "OriginalSnapshotCreateTime": {
	          "type": "timestamp"
	        },
	        "SnapshotTarget": {}
	      },
	      "wrapper": true
	    },
	    "S1b": {
	      "type": "list",
	      "member": {
	        "locationName": "ProcessorFeature",
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Value": {}
	        }
	      }
	    },
	    "S1f": {
	      "type": "structure",
	      "members": {
	        "OptionGroupName": {},
	        "OptionGroupDescription": {},
	        "EngineName": {},
	        "MajorEngineVersion": {},
	        "Options": {
	          "type": "list",
	          "member": {
	            "locationName": "Option",
	            "type": "structure",
	            "members": {
	              "OptionName": {},
	              "OptionDescription": {},
	              "Persistent": {
	                "type": "boolean"
	              },
	              "Permanent": {
	                "type": "boolean"
	              },
	              "Port": {
	                "type": "integer"
	              },
	              "OptionVersion": {},
	              "OptionSettings": {
	                "type": "list",
	                "member": {
	                  "shape": "S1j",
	                  "locationName": "OptionSetting"
	                }
	              },
	              "DBSecurityGroupMemberships": {
	                "shape": "S1k"
	              },
	              "VpcSecurityGroupMemberships": {
	                "shape": "S1m"
	              }
	            }
	          }
	        },
	        "AllowsVpcAndNonVpcInstanceMemberships": {
	          "type": "boolean"
	        },
	        "VpcId": {},
	        "OptionGroupArn": {}
	      },
	      "wrapper": true
	    },
	    "S1j": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Value": {},
	        "DefaultValue": {},
	        "Description": {},
	        "ApplyType": {},
	        "DataType": {},
	        "AllowedValues": {},
	        "IsModifiable": {
	          "type": "boolean"
	        },
	        "IsCollection": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1k": {
	      "type": "list",
	      "member": {
	        "locationName": "DBSecurityGroup",
	        "type": "structure",
	        "members": {
	          "DBSecurityGroupName": {},
	          "Status": {}
	        }
	      }
	    },
	    "S1m": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroupMembership",
	        "type": "structure",
	        "members": {
	          "VpcSecurityGroupId": {},
	          "Status": {}
	        }
	      }
	    },
	    "S1w": {
	      "type": "structure",
	      "members": {
	        "Engine": {},
	        "EngineVersion": {},
	        "DBParameterGroupFamily": {},
	        "DBEngineDescription": {},
	        "DBEngineVersionDescription": {},
	        "DefaultCharacterSet": {
	          "shape": "S1x"
	        },
	        "SupportedCharacterSets": {
	          "shape": "S1y"
	        },
	        "SupportedNcharCharacterSets": {
	          "shape": "S1y"
	        },
	        "ValidUpgradeTarget": {
	          "type": "list",
	          "member": {
	            "locationName": "UpgradeTarget",
	            "type": "structure",
	            "members": {
	              "Engine": {},
	              "EngineVersion": {},
	              "Description": {},
	              "AutoUpgrade": {
	                "type": "boolean"
	              },
	              "IsMajorVersionUpgrade": {
	                "type": "boolean"
	              },
	              "SupportedEngineModes": {
	                "shape": "S21"
	              },
	              "SupportsParallelQuery": {
	                "type": "boolean"
	              },
	              "SupportsGlobalDatabases": {
	                "type": "boolean"
	              },
	              "SupportsBabelfish": {
	                "type": "boolean"
	              }
	            }
	          }
	        },
	        "SupportedTimezones": {
	          "type": "list",
	          "member": {
	            "locationName": "Timezone",
	            "type": "structure",
	            "members": {
	              "TimezoneName": {}
	            }
	          }
	        },
	        "ExportableLogTypes": {
	          "shape": "S24"
	        },
	        "SupportsLogExportsToCloudwatchLogs": {
	          "type": "boolean"
	        },
	        "SupportsReadReplica": {
	          "type": "boolean"
	        },
	        "SupportedEngineModes": {
	          "shape": "S21"
	        },
	        "SupportedFeatureNames": {
	          "type": "list",
	          "member": {}
	        },
	        "Status": {},
	        "SupportsParallelQuery": {
	          "type": "boolean"
	        },
	        "SupportsGlobalDatabases": {
	          "type": "boolean"
	        },
	        "MajorEngineVersion": {},
	        "DatabaseInstallationFilesS3BucketName": {},
	        "DatabaseInstallationFilesS3Prefix": {},
	        "DBEngineVersionArn": {},
	        "KMSKeyId": {},
	        "CreateTime": {
	          "type": "timestamp"
	        },
	        "TagList": {
	          "shape": "Sb"
	        },
	        "SupportsBabelfish": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1x": {
	      "type": "structure",
	      "members": {
	        "CharacterSetName": {},
	        "CharacterSetDescription": {}
	      }
	    },
	    "S1y": {
	      "type": "list",
	      "member": {
	        "shape": "S1x",
	        "locationName": "CharacterSet"
	      }
	    },
	    "S21": {
	      "type": "list",
	      "member": {}
	    },
	    "S24": {
	      "type": "list",
	      "member": {}
	    },
	    "S27": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroupId"
	      }
	    },
	    "S29": {
	      "type": "structure",
	      "members": {
	        "MinCapacity": {
	          "type": "integer"
	        },
	        "MaxCapacity": {
	          "type": "integer"
	        },
	        "AutoPause": {
	          "type": "boolean"
	        },
	        "SecondsUntilAutoPause": {
	          "type": "integer"
	        },
	        "TimeoutAction": {},
	        "SecondsBeforeTimeout": {
	          "type": "integer"
	        }
	      }
	    },
	    "S2a": {
	      "type": "structure",
	      "members": {
	        "MinCapacity": {
	          "type": "double"
	        },
	        "MaxCapacity": {
	          "type": "double"
	        }
	      }
	    },
	    "S2d": {
	      "type": "structure",
	      "members": {
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "AvailabilityZones": {
	          "shape": "S13"
	        },
	        "BackupRetentionPeriod": {
	          "type": "integer"
	        },
	        "CharacterSetName": {},
	        "DatabaseName": {},
	        "DBClusterIdentifier": {},
	        "DBClusterParameterGroup": {},
	        "DBSubnetGroup": {},
	        "Status": {},
	        "AutomaticRestartTime": {
	          "type": "timestamp"
	        },
	        "PercentProgress": {},
	        "EarliestRestorableTime": {
	          "type": "timestamp"
	        },
	        "Endpoint": {},
	        "ReaderEndpoint": {},
	        "CustomEndpoints": {
	          "shape": "Sv"
	        },
	        "MultiAZ": {
	          "type": "boolean"
	        },
	        "Engine": {},
	        "EngineVersion": {},
	        "LatestRestorableTime": {
	          "type": "timestamp"
	        },
	        "Port": {
	          "type": "integer"
	        },
	        "MasterUsername": {},
	        "DBClusterOptionGroupMemberships": {
	          "type": "list",
	          "member": {
	            "locationName": "DBClusterOptionGroup",
	            "type": "structure",
	            "members": {
	              "DBClusterOptionGroupName": {},
	              "Status": {}
	            }
	          }
	        },
	        "PreferredBackupWindow": {},
	        "PreferredMaintenanceWindow": {},
	        "ReplicationSourceIdentifier": {},
	        "ReadReplicaIdentifiers": {
	          "type": "list",
	          "member": {
	            "locationName": "ReadReplicaIdentifier"
	          }
	        },
	        "DBClusterMembers": {
	          "type": "list",
	          "member": {
	            "locationName": "DBClusterMember",
	            "type": "structure",
	            "members": {
	              "DBInstanceIdentifier": {},
	              "IsClusterWriter": {
	                "type": "boolean"
	              },
	              "DBClusterParameterGroupStatus": {},
	              "PromotionTier": {
	                "type": "integer"
	              }
	            },
	            "wrapper": true
	          }
	        },
	        "VpcSecurityGroups": {
	          "shape": "S1m"
	        },
	        "HostedZoneId": {},
	        "StorageEncrypted": {
	          "type": "boolean"
	        },
	        "KmsKeyId": {},
	        "DbClusterResourceId": {},
	        "DBClusterArn": {},
	        "AssociatedRoles": {
	          "type": "list",
	          "member": {
	            "locationName": "DBClusterRole",
	            "type": "structure",
	            "members": {
	              "RoleArn": {},
	              "Status": {},
	              "FeatureName": {}
	            }
	          }
	        },
	        "IAMDatabaseAuthenticationEnabled": {
	          "type": "boolean"
	        },
	        "CloneGroupId": {},
	        "ClusterCreateTime": {
	          "type": "timestamp"
	        },
	        "EarliestBacktrackTime": {
	          "type": "timestamp"
	        },
	        "BacktrackWindow": {
	          "type": "long"
	        },
	        "BacktrackConsumedChangeRecords": {
	          "type": "long"
	        },
	        "EnabledCloudwatchLogsExports": {
	          "shape": "S24"
	        },
	        "Capacity": {
	          "type": "integer"
	        },
	        "EngineMode": {},
	        "ScalingConfigurationInfo": {
	          "type": "structure",
	          "members": {
	            "MinCapacity": {
	              "type": "integer"
	            },
	            "MaxCapacity": {
	              "type": "integer"
	            },
	            "AutoPause": {
	              "type": "boolean"
	            },
	            "SecondsUntilAutoPause": {
	              "type": "integer"
	            },
	            "TimeoutAction": {},
	            "SecondsBeforeTimeout": {
	              "type": "integer"
	            }
	          }
	        },
	        "DeletionProtection": {
	          "type": "boolean"
	        },
	        "HttpEndpointEnabled": {
	          "type": "boolean"
	        },
	        "ActivityStreamMode": {},
	        "ActivityStreamStatus": {},
	        "ActivityStreamKmsKeyId": {},
	        "ActivityStreamKinesisStreamName": {},
	        "CopyTagsToSnapshot": {
	          "type": "boolean"
	        },
	        "CrossAccountClone": {
	          "type": "boolean"
	        },
	        "DomainMemberships": {
	          "shape": "S2o"
	        },
	        "TagList": {
	          "shape": "Sb"
	        },
	        "GlobalWriteForwardingStatus": {},
	        "GlobalWriteForwardingRequested": {
	          "type": "boolean"
	        },
	        "PendingModifiedValues": {
	          "type": "structure",
	          "members": {
	            "PendingCloudwatchLogsExports": {
	              "shape": "S2s"
	            },
	            "DBClusterIdentifier": {},
	            "MasterUserPassword": {},
	            "IAMDatabaseAuthenticationEnabled": {
	              "type": "boolean"
	            },
	            "EngineVersion": {}
	          }
	        },
	        "DBClusterInstanceClass": {},
	        "StorageType": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "PubliclyAccessible": {
	          "type": "boolean"
	        },
	        "AutoMinorVersionUpgrade": {
	          "type": "boolean"
	        },
	        "MonitoringInterval": {
	          "type": "integer"
	        },
	        "MonitoringRoleArn": {},
	        "PerformanceInsightsEnabled": {
	          "type": "boolean"
	        },
	        "PerformanceInsightsKMSKeyId": {},
	        "PerformanceInsightsRetentionPeriod": {
	          "type": "integer"
	        },
	        "ServerlessV2ScalingConfiguration": {
	          "type": "structure",
	          "members": {
	            "MinCapacity": {
	              "type": "double"
	            },
	            "MaxCapacity": {
	              "type": "double"
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "S2o": {
	      "type": "list",
	      "member": {
	        "locationName": "DomainMembership",
	        "type": "structure",
	        "members": {
	          "Domain": {},
	          "Status": {},
	          "FQDN": {},
	          "IAMRoleName": {}
	        }
	      }
	    },
	    "S2s": {
	      "type": "structure",
	      "members": {
	        "LogTypesToEnable": {
	          "shape": "S24"
	        },
	        "LogTypesToDisable": {
	          "shape": "S24"
	        }
	      }
	    },
	    "S2v": {
	      "type": "structure",
	      "members": {
	        "DBClusterEndpointIdentifier": {},
	        "DBClusterIdentifier": {},
	        "DBClusterEndpointResourceIdentifier": {},
	        "Endpoint": {},
	        "Status": {},
	        "EndpointType": {},
	        "CustomEndpointType": {},
	        "StaticMembers": {
	          "shape": "Sv"
	        },
	        "ExcludedMembers": {
	          "shape": "Sv"
	        },
	        "DBClusterEndpointArn": {}
	      }
	    },
	    "S31": {
	      "type": "list",
	      "member": {
	        "locationName": "DBSecurityGroupName"
	      }
	    },
	    "S33": {
	      "type": "structure",
	      "members": {
	        "DBInstanceIdentifier": {},
	        "DBInstanceClass": {},
	        "Engine": {},
	        "DBInstanceStatus": {},
	        "AutomaticRestartTime": {
	          "type": "timestamp"
	        },
	        "MasterUsername": {},
	        "DBName": {},
	        "Endpoint": {
	          "shape": "S34"
	        },
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "InstanceCreateTime": {
	          "type": "timestamp"
	        },
	        "PreferredBackupWindow": {},
	        "BackupRetentionPeriod": {
	          "type": "integer"
	        },
	        "DBSecurityGroups": {
	          "shape": "S1k"
	        },
	        "VpcSecurityGroups": {
	          "shape": "S1m"
	        },
	        "DBParameterGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "DBParameterGroup",
	            "type": "structure",
	            "members": {
	              "DBParameterGroupName": {},
	              "ParameterApplyStatus": {}
	            }
	          }
	        },
	        "AvailabilityZone": {},
	        "DBSubnetGroup": {
	          "shape": "S37"
	        },
	        "PreferredMaintenanceWindow": {},
	        "PendingModifiedValues": {
	          "type": "structure",
	          "members": {
	            "DBInstanceClass": {},
	            "AllocatedStorage": {
	              "type": "integer"
	            },
	            "MasterUserPassword": {},
	            "Port": {
	              "type": "integer"
	            },
	            "BackupRetentionPeriod": {
	              "type": "integer"
	            },
	            "MultiAZ": {
	              "type": "boolean"
	            },
	            "EngineVersion": {},
	            "LicenseModel": {},
	            "Iops": {
	              "type": "integer"
	            },
	            "DBInstanceIdentifier": {},
	            "StorageType": {},
	            "CACertificateIdentifier": {},
	            "DBSubnetGroupName": {},
	            "PendingCloudwatchLogsExports": {
	              "shape": "S2s"
	            },
	            "ProcessorFeatures": {
	              "shape": "S1b"
	            },
	            "IAMDatabaseAuthenticationEnabled": {
	              "type": "boolean"
	            },
	            "AutomationMode": {},
	            "ResumeFullAutomationModeTime": {
	              "type": "timestamp"
	            }
	          }
	        },
	        "LatestRestorableTime": {
	          "type": "timestamp"
	        },
	        "MultiAZ": {
	          "type": "boolean"
	        },
	        "EngineVersion": {},
	        "AutoMinorVersionUpgrade": {
	          "type": "boolean"
	        },
	        "ReadReplicaSourceDBInstanceIdentifier": {},
	        "ReadReplicaDBInstanceIdentifiers": {
	          "type": "list",
	          "member": {
	            "locationName": "ReadReplicaDBInstanceIdentifier"
	          }
	        },
	        "ReadReplicaDBClusterIdentifiers": {
	          "type": "list",
	          "member": {
	            "locationName": "ReadReplicaDBClusterIdentifier"
	          }
	        },
	        "ReplicaMode": {},
	        "LicenseModel": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "OptionGroupMemberships": {
	          "type": "list",
	          "member": {
	            "locationName": "OptionGroupMembership",
	            "type": "structure",
	            "members": {
	              "OptionGroupName": {},
	              "Status": {}
	            }
	          }
	        },
	        "CharacterSetName": {},
	        "NcharCharacterSetName": {},
	        "SecondaryAvailabilityZone": {},
	        "PubliclyAccessible": {
	          "type": "boolean"
	        },
	        "StatusInfos": {
	          "type": "list",
	          "member": {
	            "locationName": "DBInstanceStatusInfo",
	            "type": "structure",
	            "members": {
	              "StatusType": {},
	              "Normal": {
	                "type": "boolean"
	              },
	              "Status": {},
	              "Message": {}
	            }
	          }
	        },
	        "StorageType": {},
	        "TdeCredentialArn": {},
	        "DbInstancePort": {
	          "type": "integer"
	        },
	        "DBClusterIdentifier": {},
	        "StorageEncrypted": {
	          "type": "boolean"
	        },
	        "KmsKeyId": {},
	        "DbiResourceId": {},
	        "CACertificateIdentifier": {},
	        "DomainMemberships": {
	          "shape": "S2o"
	        },
	        "CopyTagsToSnapshot": {
	          "type": "boolean"
	        },
	        "MonitoringInterval": {
	          "type": "integer"
	        },
	        "EnhancedMonitoringResourceArn": {},
	        "MonitoringRoleArn": {},
	        "PromotionTier": {
	          "type": "integer"
	        },
	        "DBInstanceArn": {},
	        "Timezone": {},
	        "IAMDatabaseAuthenticationEnabled": {
	          "type": "boolean"
	        },
	        "PerformanceInsightsEnabled": {
	          "type": "boolean"
	        },
	        "PerformanceInsightsKMSKeyId": {},
	        "PerformanceInsightsRetentionPeriod": {
	          "type": "integer"
	        },
	        "EnabledCloudwatchLogsExports": {
	          "shape": "S24"
	        },
	        "ProcessorFeatures": {
	          "shape": "S1b"
	        },
	        "DeletionProtection": {
	          "type": "boolean"
	        },
	        "AssociatedRoles": {
	          "type": "list",
	          "member": {
	            "locationName": "DBInstanceRole",
	            "type": "structure",
	            "members": {
	              "RoleArn": {},
	              "FeatureName": {},
	              "Status": {}
	            }
	          }
	        },
	        "ListenerEndpoint": {
	          "shape": "S34"
	        },
	        "MaxAllocatedStorage": {
	          "type": "integer"
	        },
	        "TagList": {
	          "shape": "Sb"
	        },
	        "DBInstanceAutomatedBackupsReplications": {
	          "shape": "S3n"
	        },
	        "CustomerOwnedIpEnabled": {
	          "type": "boolean"
	        },
	        "AwsBackupRecoveryPointArn": {},
	        "ActivityStreamStatus": {},
	        "ActivityStreamKmsKeyId": {},
	        "ActivityStreamKinesisStreamName": {},
	        "ActivityStreamMode": {},
	        "ActivityStreamEngineNativeAuditFieldsIncluded": {
	          "type": "boolean"
	        },
	        "AutomationMode": {},
	        "ResumeFullAutomationModeTime": {
	          "type": "timestamp"
	        },
	        "CustomIamInstanceProfile": {},
	        "BackupTarget": {},
	        "NetworkType": {}
	      },
	      "wrapper": true
	    },
	    "S34": {
	      "type": "structure",
	      "members": {
	        "Address": {},
	        "Port": {
	          "type": "integer"
	        },
	        "HostedZoneId": {}
	      }
	    },
	    "S37": {
	      "type": "structure",
	      "members": {
	        "DBSubnetGroupName": {},
	        "DBSubnetGroupDescription": {},
	        "VpcId": {},
	        "SubnetGroupStatus": {},
	        "Subnets": {
	          "type": "list",
	          "member": {
	            "locationName": "Subnet",
	            "type": "structure",
	            "members": {
	              "SubnetIdentifier": {},
	              "SubnetAvailabilityZone": {
	                "shape": "S3a"
	              },
	              "SubnetOutpost": {
	                "type": "structure",
	                "members": {
	                  "Arn": {}
	                }
	              },
	              "SubnetStatus": {}
	            }
	          }
	        },
	        "DBSubnetGroupArn": {},
	        "SupportedNetworkTypes": {
	          "shape": "Sv"
	        }
	      },
	      "wrapper": true
	    },
	    "S3a": {
	      "type": "structure",
	      "members": {
	        "Name": {}
	      },
	      "wrapper": true
	    },
	    "S3n": {
	      "type": "list",
	      "member": {
	        "locationName": "DBInstanceAutomatedBackupsReplication",
	        "type": "structure",
	        "members": {
	          "DBInstanceAutomatedBackupsArn": {}
	        }
	      }
	    },
	    "S3v": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Description": {},
	          "UserName": {},
	          "AuthScheme": {},
	          "SecretArn": {},
	          "IAMAuth": {}
	        }
	      }
	    },
	    "S40": {
	      "type": "structure",
	      "members": {
	        "DBProxyName": {},
	        "DBProxyArn": {},
	        "Status": {},
	        "EngineFamily": {},
	        "VpcId": {},
	        "VpcSecurityGroupIds": {
	          "shape": "Sv"
	        },
	        "VpcSubnetIds": {
	          "shape": "Sv"
	        },
	        "Auth": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Description": {},
	              "UserName": {},
	              "AuthScheme": {},
	              "SecretArn": {},
	              "IAMAuth": {}
	            }
	          }
	        },
	        "RoleArn": {},
	        "Endpoint": {},
	        "RequireTLS": {
	          "type": "boolean"
	        },
	        "IdleClientTimeout": {
	          "type": "integer"
	        },
	        "DebugLogging": {
	          "type": "boolean"
	        },
	        "CreatedDate": {
	          "type": "timestamp"
	        },
	        "UpdatedDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S49": {
	      "type": "structure",
	      "members": {
	        "DBProxyEndpointName": {},
	        "DBProxyEndpointArn": {},
	        "DBProxyName": {},
	        "Status": {},
	        "VpcId": {},
	        "VpcSecurityGroupIds": {
	          "shape": "Sv"
	        },
	        "VpcSubnetIds": {
	          "shape": "Sv"
	        },
	        "Endpoint": {},
	        "CreatedDate": {
	          "type": "timestamp"
	        },
	        "TargetRole": {},
	        "IsDefault": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S4g": {
	      "type": "list",
	      "member": {
	        "locationName": "SubnetIdentifier"
	      }
	    },
	    "S4m": {
	      "type": "structure",
	      "members": {
	        "GlobalClusterIdentifier": {},
	        "GlobalClusterResourceId": {},
	        "GlobalClusterArn": {},
	        "Status": {},
	        "Engine": {},
	        "EngineVersion": {},
	        "DatabaseName": {},
	        "StorageEncrypted": {
	          "type": "boolean"
	        },
	        "DeletionProtection": {
	          "type": "boolean"
	        },
	        "GlobalClusterMembers": {
	          "type": "list",
	          "member": {
	            "locationName": "GlobalClusterMember",
	            "type": "structure",
	            "members": {
	              "DBClusterArn": {},
	              "Readers": {
	                "type": "list",
	                "member": {}
	              },
	              "IsWriter": {
	                "type": "boolean"
	              },
	              "GlobalWriteForwardingStatus": {}
	            },
	            "wrapper": true
	          }
	        },
	        "FailoverState": {
	          "type": "structure",
	          "members": {
	            "Status": {},
	            "FromDbClusterArn": {},
	            "ToDbClusterArn": {}
	          },
	          "wrapper": true
	        }
	      },
	      "wrapper": true
	    },
	    "S55": {
	      "type": "structure",
	      "members": {
	        "DBInstanceArn": {},
	        "DbiResourceId": {},
	        "Region": {},
	        "DBInstanceIdentifier": {},
	        "RestoreWindow": {
	          "type": "structure",
	          "members": {
	            "EarliestTime": {
	              "type": "timestamp"
	            },
	            "LatestTime": {
	              "type": "timestamp"
	            }
	          }
	        },
	        "AllocatedStorage": {
	          "type": "integer"
	        },
	        "Status": {},
	        "Port": {
	          "type": "integer"
	        },
	        "AvailabilityZone": {},
	        "VpcId": {},
	        "InstanceCreateTime": {
	          "type": "timestamp"
	        },
	        "MasterUsername": {},
	        "Engine": {},
	        "EngineVersion": {},
	        "LicenseModel": {},
	        "Iops": {
	          "type": "integer"
	        },
	        "OptionGroupName": {},
	        "TdeCredentialArn": {},
	        "Encrypted": {
	          "type": "boolean"
	        },
	        "StorageType": {},
	        "KmsKeyId": {},
	        "Timezone": {},
	        "IAMDatabaseAuthenticationEnabled": {
	          "type": "boolean"
	        },
	        "BackupRetentionPeriod": {
	          "type": "integer"
	        },
	        "DBInstanceAutomatedBackupsArn": {},
	        "DBInstanceAutomatedBackupsReplications": {
	          "shape": "S3n"
	        },
	        "BackupTarget": {}
	      },
	      "wrapper": true
	    },
	    "S5t": {
	      "type": "list",
	      "member": {
	        "locationName": "Filter",
	        "type": "structure",
	        "required": [
	          "Name",
	          "Values"
	        ],
	        "members": {
	          "Name": {},
	          "Values": {
	            "type": "list",
	            "member": {
	              "locationName": "Value"
	            }
	          }
	        }
	      }
	    },
	    "S5y": {
	      "type": "structure",
	      "members": {
	        "CertificateIdentifier": {},
	        "CertificateType": {},
	        "Thumbprint": {},
	        "ValidFrom": {
	          "type": "timestamp"
	        },
	        "ValidTill": {
	          "type": "timestamp"
	        },
	        "CertificateArn": {},
	        "CustomerOverride": {
	          "type": "boolean"
	        },
	        "CustomerOverrideValidTill": {
	          "type": "timestamp"
	        }
	      },
	      "wrapper": true
	    },
	    "S6a": {
	      "type": "list",
	      "member": {
	        "locationName": "Parameter",
	        "type": "structure",
	        "members": {
	          "ParameterName": {},
	          "ParameterValue": {},
	          "Description": {},
	          "Source": {},
	          "ApplyType": {},
	          "DataType": {},
	          "AllowedValues": {},
	          "IsModifiable": {
	            "type": "boolean"
	          },
	          "MinimumEngineVersion": {},
	          "ApplyMethod": {},
	          "SupportedEngineModes": {
	            "shape": "S21"
	          }
	        }
	      }
	    },
	    "S6f": {
	      "type": "structure",
	      "members": {
	        "DBClusterSnapshotIdentifier": {},
	        "DBClusterSnapshotAttributes": {
	          "type": "list",
	          "member": {
	            "locationName": "DBClusterSnapshotAttribute",
	            "type": "structure",
	            "members": {
	              "AttributeName": {},
	              "AttributeValues": {
	                "shape": "S6i"
	              }
	            }
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "S6i": {
	      "type": "list",
	      "member": {
	        "locationName": "AttributeValue"
	      }
	    },
	    "S7h": {
	      "type": "structure",
	      "members": {
	        "DBProxyName": {},
	        "TargetGroupName": {},
	        "TargetGroupArn": {},
	        "IsDefault": {
	          "type": "boolean"
	        },
	        "Status": {},
	        "ConnectionPoolConfig": {
	          "type": "structure",
	          "members": {
	            "MaxConnectionsPercent": {
	              "type": "integer"
	            },
	            "MaxIdleConnectionsPercent": {
	              "type": "integer"
	            },
	            "ConnectionBorrowTimeout": {
	              "type": "integer"
	            },
	            "SessionPinningFilters": {
	              "shape": "Sv"
	            },
	            "InitQuery": {}
	          }
	        },
	        "CreatedDate": {
	          "type": "timestamp"
	        },
	        "UpdatedDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S7l": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "TargetArn": {},
	          "Endpoint": {},
	          "TrackedClusterId": {},
	          "RdsResourceId": {},
	          "Port": {
	            "type": "integer"
	          },
	          "Type": {},
	          "Role": {},
	          "TargetHealth": {
	            "type": "structure",
	            "members": {
	              "State": {},
	              "Reason": {},
	              "Description": {}
	            }
	          }
	        }
	      }
	    },
	    "S7x": {
	      "type": "structure",
	      "members": {
	        "DBSnapshotIdentifier": {},
	        "DBSnapshotAttributes": {
	          "type": "list",
	          "member": {
	            "locationName": "DBSnapshotAttribute",
	            "type": "structure",
	            "members": {
	              "AttributeName": {},
	              "AttributeValues": {
	                "shape": "S6i"
	              }
	            },
	            "wrapper": true
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "S88": {
	      "type": "structure",
	      "members": {
	        "DBParameterGroupFamily": {},
	        "Marker": {},
	        "Parameters": {
	          "shape": "S6a"
	        }
	      },
	      "wrapper": true
	    },
	    "S9d": {
	      "type": "list",
	      "member": {
	        "locationName": "AvailableProcessorFeature",
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "DefaultValue": {},
	          "AllowedValues": {}
	        }
	      }
	    },
	    "S9m": {
	      "type": "structure",
	      "members": {
	        "ReservedDBInstanceId": {},
	        "ReservedDBInstancesOfferingId": {},
	        "DBInstanceClass": {},
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "Duration": {
	          "type": "integer"
	        },
	        "FixedPrice": {
	          "type": "double"
	        },
	        "UsagePrice": {
	          "type": "double"
	        },
	        "CurrencyCode": {},
	        "DBInstanceCount": {
	          "type": "integer"
	        },
	        "ProductDescription": {},
	        "OfferingType": {},
	        "MultiAZ": {
	          "type": "boolean"
	        },
	        "State": {},
	        "RecurringCharges": {
	          "shape": "S9o"
	        },
	        "ReservedDBInstanceArn": {},
	        "LeaseId": {}
	      },
	      "wrapper": true
	    },
	    "S9o": {
	      "type": "list",
	      "member": {
	        "locationName": "RecurringCharge",
	        "type": "structure",
	        "members": {
	          "RecurringChargeAmount": {
	            "type": "double"
	          },
	          "RecurringChargeFrequency": {}
	        },
	        "wrapper": true
	      }
	    },
	    "Sa3": {
	      "type": "list",
	      "member": {
	        "locationName": "Range",
	        "type": "structure",
	        "members": {
	          "From": {
	            "type": "integer"
	          },
	          "To": {
	            "type": "integer"
	          },
	          "Step": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "Sao": {
	      "type": "structure",
	      "members": {
	        "EnableLogTypes": {
	          "shape": "S24"
	        },
	        "DisableLogTypes": {
	          "shape": "S24"
	        }
	      }
	    },
	    "Sas": {
	      "type": "structure",
	      "members": {
	        "DBClusterParameterGroupName": {}
	      }
	    },
	    "Saz": {
	      "type": "structure",
	      "members": {
	        "DBParameterGroupName": {}
	      }
	    }
	  }
	}
	},{}],193:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeCertificates": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Certificates"
	    },
	    "DescribeDBClusterBacktracks": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBClusterBacktracks"
	    },
	    "DescribeDBClusterEndpoints": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBClusterEndpoints"
	    },
	    "DescribeDBClusterParameterGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBClusterParameterGroups"
	    },
	    "DescribeDBClusterParameters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Parameters"
	    },
	    "DescribeDBClusterSnapshots": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBClusterSnapshots"
	    },
	    "DescribeDBClusters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBClusters"
	    },
	    "DescribeDBEngineVersions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBEngineVersions"
	    },
	    "DescribeDBInstanceAutomatedBackups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBInstanceAutomatedBackups"
	    },
	    "DescribeDBInstances": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBInstances"
	    },
	    "DescribeDBLogFiles": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DescribeDBLogFiles"
	    },
	    "DescribeDBParameterGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBParameterGroups"
	    },
	    "DescribeDBParameters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Parameters"
	    },
	    "DescribeDBProxies": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBProxies"
	    },
	    "DescribeDBProxyEndpoints": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBProxyEndpoints"
	    },
	    "DescribeDBProxyTargetGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "TargetGroups"
	    },
	    "DescribeDBProxyTargets": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Targets"
	    },
	    "DescribeDBSecurityGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBSecurityGroups"
	    },
	    "DescribeDBSnapshots": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBSnapshots"
	    },
	    "DescribeDBSubnetGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DBSubnetGroups"
	    },
	    "DescribeEngineDefaultParameters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "EngineDefaults.Marker",
	      "result_key": "EngineDefaults.Parameters"
	    },
	    "DescribeEventSubscriptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "EventSubscriptionsList"
	    },
	    "DescribeEvents": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Events"
	    },
	    "DescribeExportTasks": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ExportTasks"
	    },
	    "DescribeGlobalClusters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "GlobalClusters"
	    },
	    "DescribeOptionGroupOptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "OptionGroupOptions"
	    },
	    "DescribeOptionGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "OptionGroupsList"
	    },
	    "DescribeOrderableDBInstanceOptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "OrderableDBInstanceOptions"
	    },
	    "DescribePendingMaintenanceActions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "PendingMaintenanceActions"
	    },
	    "DescribeReservedDBInstances": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedDBInstances"
	    },
	    "DescribeReservedDBInstancesOfferings": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedDBInstancesOfferings"
	    },
	    "DescribeSourceRegions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "SourceRegions"
	    },
	    "DownloadDBLogFilePortion": {
	      "input_token": "Marker",
	      "limit_key": "NumberOfLines",
	      "more_results": "AdditionalDataPending",
	      "output_token": "Marker",
	      "result_key": "LogFileData"
	    },
	    "ListTagsForResource": {
	      "result_key": "TagList"
	    }
	  }
	}
	},{}],194:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "DBInstanceAvailable": {
	      "delay": 30,
	      "operation": "DescribeDBInstances",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "deleted",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "deleting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "incompatible-restore",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "incompatible-parameters",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        }
	      ]
	    },
	    "DBInstanceDeleted": {
	      "delay": 30,
	      "operation": "DescribeDBInstances",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": true,
	          "matcher": "path",
	          "state": "success",
	          "argument": "length(DBInstances) == `0`"
	        },
	        {
	          "expected": "DBInstanceNotFound",
	          "matcher": "error",
	          "state": "success"
	        },
	        {
	          "expected": "creating",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "modifying",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "rebooting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        },
	        {
	          "expected": "resetting-master-credentials",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBInstances[].DBInstanceStatus"
	        }
	      ]
	    },
	    "DBSnapshotAvailable": {
	      "delay": 30,
	      "operation": "DescribeDBSnapshots",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "DBSnapshots[].Status"
	        },
	        {
	          "expected": "deleted",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBSnapshots[].Status"
	        },
	        {
	          "expected": "deleting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBSnapshots[].Status"
	        },
	        {
	          "expected": "failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBSnapshots[].Status"
	        },
	        {
	          "expected": "incompatible-restore",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBSnapshots[].Status"
	        },
	        {
	          "expected": "incompatible-parameters",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBSnapshots[].Status"
	        }
	      ]
	    },
	    "DBSnapshotDeleted": {
	      "delay": 30,
	      "operation": "DescribeDBSnapshots",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": true,
	          "matcher": "path",
	          "state": "success",
	          "argument": "length(DBSnapshots) == `0`"
	        },
	        {
	          "expected": "DBSnapshotNotFound",
	          "matcher": "error",
	          "state": "success"
	        },
	        {
	          "expected": "creating",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBSnapshots[].Status"
	        },
	        {
	          "expected": "modifying",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBSnapshots[].Status"
	        },
	        {
	          "expected": "rebooting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBSnapshots[].Status"
	        },
	        {
	          "expected": "resetting-master-credentials",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBSnapshots[].Status"
	        }
	      ]
	    },
	    "DBClusterSnapshotAvailable": {
	      "delay": 30,
	      "operation": "DescribeDBClusterSnapshots",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "DBClusterSnapshots[].Status"
	        },
	        {
	          "expected": "deleted",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBClusterSnapshots[].Status"
	        },
	        {
	          "expected": "deleting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBClusterSnapshots[].Status"
	        },
	        {
	          "expected": "failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBClusterSnapshots[].Status"
	        },
	        {
	          "expected": "incompatible-restore",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBClusterSnapshots[].Status"
	        },
	        {
	          "expected": "incompatible-parameters",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBClusterSnapshots[].Status"
	        }
	      ]
	    },
	    "DBClusterSnapshotDeleted": {
	      "delay": 30,
	      "operation": "DescribeDBClusterSnapshots",
	      "maxAttempts": 60,
	      "acceptors": [
	        {
	          "expected": true,
	          "matcher": "path",
	          "state": "success",
	          "argument": "length(DBClusterSnapshots) == `0`"
	        },
	        {
	          "expected": "DBClusterSnapshotNotFoundFault",
	          "matcher": "error",
	          "state": "success"
	        },
	        {
	          "expected": "creating",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBClusterSnapshots[].Status"
	        },
	        {
	          "expected": "modifying",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBClusterSnapshots[].Status"
	        },
	        {
	          "expected": "rebooting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBClusterSnapshots[].Status"
	        },
	        {
	          "expected": "resetting-master-credentials",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "DBClusterSnapshots[].Status"
	        }
	      ]
	    }
	  }
	}
	
	},{}],195:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2012-12-01",
	    "endpointPrefix": "redshift",
	    "protocol": "query",
	    "serviceFullName": "Amazon Redshift",
	    "serviceId": "Redshift",
	    "signatureVersion": "v4",
	    "uid": "redshift-2012-12-01",
	    "xmlNamespace": "http://redshift.amazonaws.com/doc/2012-12-01/"
	  },
	  "operations": {
	    "AcceptReservedNodeExchange": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedNodeId",
	          "TargetReservedNodeOfferingId"
	        ],
	        "members": {
	          "ReservedNodeId": {},
	          "TargetReservedNodeOfferingId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AcceptReservedNodeExchangeResult",
	        "type": "structure",
	        "members": {
	          "ExchangedReservedNode": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "AddPartner": {
	      "input": {
	        "shape": "Sb"
	      },
	      "output": {
	        "shape": "Sg",
	        "resultWrapper": "AddPartnerResult"
	      }
	    },
	    "AssociateDataShareConsumer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataShareArn"
	        ],
	        "members": {
	          "DataShareArn": {},
	          "AssociateEntireAccount": {
	            "type": "boolean"
	          },
	          "ConsumerArn": {},
	          "ConsumerRegion": {}
	        }
	      },
	      "output": {
	        "shape": "Sj",
	        "resultWrapper": "AssociateDataShareConsumerResult"
	      }
	    },
	    "AuthorizeClusterSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterSecurityGroupName"
	        ],
	        "members": {
	          "ClusterSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AuthorizeClusterSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "ClusterSecurityGroup": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "AuthorizeDataShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataShareArn",
	          "ConsumerIdentifier"
	        ],
	        "members": {
	          "DataShareArn": {},
	          "ConsumerIdentifier": {}
	        }
	      },
	      "output": {
	        "shape": "Sj",
	        "resultWrapper": "AuthorizeDataShareResult"
	      }
	    },
	    "AuthorizeEndpointAccess": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Account"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "Account": {},
	          "VpcIds": {
	            "shape": "Sz"
	          }
	        }
	      },
	      "output": {
	        "shape": "S10",
	        "resultWrapper": "AuthorizeEndpointAccessResult"
	      }
	    },
	    "AuthorizeSnapshotAccess": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotIdentifier",
	          "AccountWithRestoreAccess"
	        ],
	        "members": {
	          "SnapshotIdentifier": {},
	          "SnapshotClusterIdentifier": {},
	          "AccountWithRestoreAccess": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AuthorizeSnapshotAccessResult",
	        "type": "structure",
	        "members": {
	          "Snapshot": {
	            "shape": "S14"
	          }
	        }
	      }
	    },
	    "BatchDeleteClusterSnapshots": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Identifiers"
	        ],
	        "members": {
	          "Identifiers": {
	            "type": "list",
	            "member": {
	              "shape": "S1c",
	              "locationName": "DeleteClusterSnapshotMessage"
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "BatchDeleteClusterSnapshotsResult",
	        "type": "structure",
	        "members": {
	          "Resources": {
	            "shape": "S1e"
	          },
	          "Errors": {
	            "type": "list",
	            "member": {
	              "shape": "S1g",
	              "locationName": "SnapshotErrorMessage"
	            }
	          }
	        }
	      }
	    },
	    "BatchModifyClusterSnapshots": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotIdentifierList"
	        ],
	        "members": {
	          "SnapshotIdentifierList": {
	            "shape": "S1e"
	          },
	          "ManualSnapshotRetentionPeriod": {
	            "type": "integer"
	          },
	          "Force": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "BatchModifyClusterSnapshotsResult",
	        "type": "structure",
	        "members": {
	          "Resources": {
	            "shape": "S1e"
	          },
	          "Errors": {
	            "type": "list",
	            "member": {
	              "shape": "S1g",
	              "locationName": "SnapshotErrorMessage"
	            }
	          }
	        }
	      }
	    },
	    "CancelResize": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "shape": "S1l",
	        "resultWrapper": "CancelResizeResult"
	      }
	    },
	    "CopyClusterSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceSnapshotIdentifier",
	          "TargetSnapshotIdentifier"
	        ],
	        "members": {
	          "SourceSnapshotIdentifier": {},
	          "SourceSnapshotClusterIdentifier": {},
	          "TargetSnapshotIdentifier": {},
	          "ManualSnapshotRetentionPeriod": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CopyClusterSnapshotResult",
	        "type": "structure",
	        "members": {
	          "Snapshot": {
	            "shape": "S14"
	          }
	        }
	      }
	    },
	    "CreateAuthenticationProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AuthenticationProfileName",
	          "AuthenticationProfileContent"
	        ],
	        "members": {
	          "AuthenticationProfileName": {},
	          "AuthenticationProfileContent": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateAuthenticationProfileResult",
	        "type": "structure",
	        "members": {
	          "AuthenticationProfileName": {},
	          "AuthenticationProfileContent": {}
	        }
	      }
	    },
	    "CreateCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier",
	          "NodeType",
	          "MasterUsername",
	          "MasterUserPassword"
	        ],
	        "members": {
	          "DBName": {},
	          "ClusterIdentifier": {},
	          "ClusterType": {},
	          "NodeType": {},
	          "MasterUsername": {},
	          "MasterUserPassword": {},
	          "ClusterSecurityGroups": {
	            "shape": "S1x"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "S1y"
	          },
	          "ClusterSubnetGroupName": {},
	          "AvailabilityZone": {},
	          "PreferredMaintenanceWindow": {},
	          "ClusterParameterGroupName": {},
	          "AutomatedSnapshotRetentionPeriod": {
	            "type": "integer"
	          },
	          "ManualSnapshotRetentionPeriod": {
	            "type": "integer"
	          },
	          "Port": {
	            "type": "integer"
	          },
	          "ClusterVersion": {},
	          "AllowVersionUpgrade": {
	            "type": "boolean"
	          },
	          "NumberOfNodes": {
	            "type": "integer"
	          },
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "Encrypted": {
	            "type": "boolean"
	          },
	          "HsmClientCertificateIdentifier": {},
	          "HsmConfigurationIdentifier": {},
	          "ElasticIp": {},
	          "Tags": {
	            "shape": "St"
	          },
	          "KmsKeyId": {},
	          "EnhancedVpcRouting": {
	            "type": "boolean"
	          },
	          "AdditionalInfo": {},
	          "IamRoles": {
	            "shape": "S1z"
	          },
	          "MaintenanceTrackName": {},
	          "SnapshotScheduleIdentifier": {},
	          "AvailabilityZoneRelocation": {
	            "type": "boolean"
	          },
	          "AquaConfigurationStatus": {},
	          "DefaultIamRoleArn": {},
	          "LoadSampleData": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateClusterResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "CreateClusterParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ParameterGroupName",
	          "ParameterGroupFamily",
	          "Description"
	        ],
	        "members": {
	          "ParameterGroupName": {},
	          "ParameterGroupFamily": {},
	          "Description": {},
	          "Tags": {
	            "shape": "St"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateClusterParameterGroupResult",
	        "type": "structure",
	        "members": {
	          "ClusterParameterGroup": {
	            "shape": "S31"
	          }
	        }
	      }
	    },
	    "CreateClusterSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterSecurityGroupName",
	          "Description"
	        ],
	        "members": {
	          "ClusterSecurityGroupName": {},
	          "Description": {},
	          "Tags": {
	            "shape": "St"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateClusterSecurityGroupResult",
	        "type": "structure",
	        "members": {
	          "ClusterSecurityGroup": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "CreateClusterSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotIdentifier",
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "SnapshotIdentifier": {},
	          "ClusterIdentifier": {},
	          "ManualSnapshotRetentionPeriod": {
	            "type": "integer"
	          },
	          "Tags": {
	            "shape": "St"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateClusterSnapshotResult",
	        "type": "structure",
	        "members": {
	          "Snapshot": {
	            "shape": "S14"
	          }
	        }
	      }
	    },
	    "CreateClusterSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterSubnetGroupName",
	          "Description",
	          "SubnetIds"
	        ],
	        "members": {
	          "ClusterSubnetGroupName": {},
	          "Description": {},
	          "SubnetIds": {
	            "shape": "S37"
	          },
	          "Tags": {
	            "shape": "St"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateClusterSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "ClusterSubnetGroup": {
	            "shape": "S39"
	          }
	        }
	      }
	    },
	    "CreateEndpointAccess": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EndpointName",
	          "SubnetGroupName"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "ResourceOwner": {},
	          "EndpointName": {},
	          "SubnetGroupName": {},
	          "VpcSecurityGroupIds": {
	            "shape": "S1y"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3g",
	        "resultWrapper": "CreateEndpointAccessResult"
	      }
	    },
	    "CreateEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName",
	          "SnsTopicArn"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "SourceIds": {
	            "shape": "S3i"
	          },
	          "EventCategories": {
	            "shape": "S3j"
	          },
	          "Severity": {},
	          "Enabled": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "St"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S3l"
	          }
	        }
	      }
	    },
	    "CreateHsmClientCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HsmClientCertificateIdentifier"
	        ],
	        "members": {
	          "HsmClientCertificateIdentifier": {},
	          "Tags": {
	            "shape": "St"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateHsmClientCertificateResult",
	        "type": "structure",
	        "members": {
	          "HsmClientCertificate": {
	            "shape": "S3o"
	          }
	        }
	      }
	    },
	    "CreateHsmConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HsmConfigurationIdentifier",
	          "Description",
	          "HsmIpAddress",
	          "HsmPartitionName",
	          "HsmPartitionPassword",
	          "HsmServerPublicCertificate"
	        ],
	        "members": {
	          "HsmConfigurationIdentifier": {},
	          "Description": {},
	          "HsmIpAddress": {},
	          "HsmPartitionName": {},
	          "HsmPartitionPassword": {},
	          "HsmServerPublicCertificate": {},
	          "Tags": {
	            "shape": "St"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateHsmConfigurationResult",
	        "type": "structure",
	        "members": {
	          "HsmConfiguration": {
	            "shape": "S3r"
	          }
	        }
	      }
	    },
	    "CreateScheduledAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ScheduledActionName",
	          "TargetAction",
	          "Schedule",
	          "IamRole"
	        ],
	        "members": {
	          "ScheduledActionName": {},
	          "TargetAction": {
	            "shape": "S3t"
	          },
	          "Schedule": {},
	          "IamRole": {},
	          "ScheduledActionDescription": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Enable": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3x",
	        "resultWrapper": "CreateScheduledActionResult"
	      }
	    },
	    "CreateSnapshotCopyGrant": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotCopyGrantName"
	        ],
	        "members": {
	          "SnapshotCopyGrantName": {},
	          "KmsKeyId": {},
	          "Tags": {
	            "shape": "St"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateSnapshotCopyGrantResult",
	        "type": "structure",
	        "members": {
	          "SnapshotCopyGrant": {
	            "shape": "S42"
	          }
	        }
	      }
	    },
	    "CreateSnapshotSchedule": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ScheduleDefinitions": {
	            "shape": "S44"
	          },
	          "ScheduleIdentifier": {},
	          "ScheduleDescription": {},
	          "Tags": {
	            "shape": "St"
	          },
	          "DryRun": {
	            "type": "boolean"
	          },
	          "NextInvocations": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "shape": "S45",
	        "resultWrapper": "CreateSnapshotScheduleResult"
	      }
	    },
	    "CreateTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "Tags"
	        ],
	        "members": {
	          "ResourceName": {},
	          "Tags": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "CreateUsageLimit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier",
	          "FeatureType",
	          "LimitType",
	          "Amount"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "FeatureType": {},
	          "LimitType": {},
	          "Amount": {
	            "type": "long"
	          },
	          "Period": {},
	          "BreachAction": {},
	          "Tags": {
	            "shape": "St"
	          }
	        }
	      },
	      "output": {
	        "shape": "S4f",
	        "resultWrapper": "CreateUsageLimitResult"
	      }
	    },
	    "DeauthorizeDataShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataShareArn",
	          "ConsumerIdentifier"
	        ],
	        "members": {
	          "DataShareArn": {},
	          "ConsumerIdentifier": {}
	        }
	      },
	      "output": {
	        "shape": "Sj",
	        "resultWrapper": "DeauthorizeDataShareResult"
	      }
	    },
	    "DeleteAuthenticationProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AuthenticationProfileName"
	        ],
	        "members": {
	          "AuthenticationProfileName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteAuthenticationProfileResult",
	        "type": "structure",
	        "members": {
	          "AuthenticationProfileName": {}
	        }
	      }
	    },
	    "DeleteCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "SkipFinalClusterSnapshot": {
	            "type": "boolean"
	          },
	          "FinalClusterSnapshotIdentifier": {},
	          "FinalClusterSnapshotRetentionPeriod": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteClusterResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "DeleteClusterParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ParameterGroupName"
	        ],
	        "members": {
	          "ParameterGroupName": {}
	        }
	      }
	    },
	    "DeleteClusterSecurityGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterSecurityGroupName"
	        ],
	        "members": {
	          "ClusterSecurityGroupName": {}
	        }
	      }
	    },
	    "DeleteClusterSnapshot": {
	      "input": {
	        "shape": "S1c"
	      },
	      "output": {
	        "resultWrapper": "DeleteClusterSnapshotResult",
	        "type": "structure",
	        "members": {
	          "Snapshot": {
	            "shape": "S14"
	          }
	        }
	      }
	    },
	    "DeleteClusterSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterSubnetGroupName"
	        ],
	        "members": {
	          "ClusterSubnetGroupName": {}
	        }
	      }
	    },
	    "DeleteEndpointAccess": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EndpointName"
	        ],
	        "members": {
	          "EndpointName": {}
	        }
	      },
	      "output": {
	        "shape": "S3g",
	        "resultWrapper": "DeleteEndpointAccessResult"
	      }
	    },
	    "DeleteEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {}
	        }
	      }
	    },
	    "DeleteHsmClientCertificate": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HsmClientCertificateIdentifier"
	        ],
	        "members": {
	          "HsmClientCertificateIdentifier": {}
	        }
	      }
	    },
	    "DeleteHsmConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "HsmConfigurationIdentifier"
	        ],
	        "members": {
	          "HsmConfigurationIdentifier": {}
	        }
	      }
	    },
	    "DeletePartner": {
	      "input": {
	        "shape": "Sb"
	      },
	      "output": {
	        "shape": "Sg",
	        "resultWrapper": "DeletePartnerResult"
	      }
	    },
	    "DeleteScheduledAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ScheduledActionName"
	        ],
	        "members": {
	          "ScheduledActionName": {}
	        }
	      }
	    },
	    "DeleteSnapshotCopyGrant": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotCopyGrantName"
	        ],
	        "members": {
	          "SnapshotCopyGrantName": {}
	        }
	      }
	    },
	    "DeleteSnapshotSchedule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ScheduleIdentifier"
	        ],
	        "members": {
	          "ScheduleIdentifier": {}
	        }
	      }
	    },
	    "DeleteTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceName",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceName": {},
	          "TagKeys": {
	            "shape": "S4x"
	          }
	        }
	      }
	    },
	    "DeleteUsageLimit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UsageLimitId"
	        ],
	        "members": {
	          "UsageLimitId": {}
	        }
	      }
	    },
	    "DescribeAccountAttributes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AttributeNames": {
	            "type": "list",
	            "member": {
	              "locationName": "AttributeName"
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeAccountAttributesResult",
	        "type": "structure",
	        "members": {
	          "AccountAttributes": {
	            "type": "list",
	            "member": {
	              "locationName": "AccountAttribute",
	              "type": "structure",
	              "members": {
	                "AttributeName": {},
	                "AttributeValues": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "AttributeValueTarget",
	                    "type": "structure",
	                    "members": {
	                      "AttributeValue": {}
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeAuthenticationProfiles": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AuthenticationProfileName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeAuthenticationProfilesResult",
	        "type": "structure",
	        "members": {
	          "AuthenticationProfiles": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AuthenticationProfileName": {},
	                "AuthenticationProfileContent": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeClusterDbRevisions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterIdentifier": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeClusterDbRevisionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ClusterDbRevisions": {
	            "type": "list",
	            "member": {
	              "locationName": "ClusterDbRevision",
	              "type": "structure",
	              "members": {
	                "ClusterIdentifier": {},
	                "CurrentDatabaseRevision": {},
	                "DatabaseRevisionReleaseDate": {
	                  "type": "timestamp"
	                },
	                "RevisionTargets": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "RevisionTarget",
	                    "type": "structure",
	                    "members": {
	                      "DatabaseRevision": {},
	                      "Description": {},
	                      "DatabaseRevisionReleaseDate": {
	                        "type": "timestamp"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeClusterParameterGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ParameterGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeClusterParameterGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ParameterGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S31",
	              "locationName": "ClusterParameterGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeClusterParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ParameterGroupName"
	        ],
	        "members": {
	          "ParameterGroupName": {},
	          "Source": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeClusterParametersResult",
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "shape": "S5m"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeClusterSecurityGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterSecurityGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeClusterSecurityGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ClusterSecurityGroups": {
	            "type": "list",
	            "member": {
	              "shape": "Sq",
	              "locationName": "ClusterSecurityGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeClusterSnapshots": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterIdentifier": {},
	          "SnapshotIdentifier": {},
	          "SnapshotType": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "OwnerAccount": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          },
	          "ClusterExists": {
	            "type": "boolean"
	          },
	          "SortingEntities": {
	            "type": "list",
	            "member": {
	              "locationName": "SnapshotSortingEntity",
	              "type": "structure",
	              "required": [
	                "Attribute"
	              ],
	              "members": {
	                "Attribute": {},
	                "SortOrder": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeClusterSnapshotsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Snapshots": {
	            "type": "list",
	            "member": {
	              "shape": "S14",
	              "locationName": "Snapshot"
	            }
	          }
	        }
	      }
	    },
	    "DescribeClusterSubnetGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterSubnetGroupName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeClusterSubnetGroupsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ClusterSubnetGroups": {
	            "type": "list",
	            "member": {
	              "shape": "S39",
	              "locationName": "ClusterSubnetGroup"
	            }
	          }
	        }
	      }
	    },
	    "DescribeClusterTracks": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaintenanceTrackName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeClusterTracksResult",
	        "type": "structure",
	        "members": {
	          "MaintenanceTracks": {
	            "type": "list",
	            "member": {
	              "locationName": "MaintenanceTrack",
	              "type": "structure",
	              "members": {
	                "MaintenanceTrackName": {},
	                "DatabaseVersion": {},
	                "UpdateTargets": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "UpdateTarget",
	                    "type": "structure",
	                    "members": {
	                      "MaintenanceTrackName": {},
	                      "DatabaseVersion": {},
	                      "SupportedOperations": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "SupportedOperation",
	                          "type": "structure",
	                          "members": {
	                            "OperationName": {}
	                          }
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeClusterVersions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterVersion": {},
	          "ClusterParameterGroupFamily": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeClusterVersionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ClusterVersions": {
	            "type": "list",
	            "member": {
	              "locationName": "ClusterVersion",
	              "type": "structure",
	              "members": {
	                "ClusterVersion": {},
	                "ClusterParameterGroupFamily": {},
	                "Description": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeClusters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterIdentifier": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeClustersResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Clusters": {
	            "type": "list",
	            "member": {
	              "shape": "S22",
	              "locationName": "Cluster"
	            }
	          }
	        }
	      }
	    },
	    "DescribeDataShares": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DataShareArn": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDataSharesResult",
	        "type": "structure",
	        "members": {
	          "DataShares": {
	            "shape": "S6j"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDataSharesForConsumer": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ConsumerArn": {},
	          "Status": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDataSharesForConsumerResult",
	        "type": "structure",
	        "members": {
	          "DataShares": {
	            "shape": "S6j"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDataSharesForProducer": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ProducerArn": {},
	          "Status": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDataSharesForProducerResult",
	        "type": "structure",
	        "members": {
	          "DataShares": {
	            "shape": "S6j"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDefaultClusterParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ParameterGroupFamily"
	        ],
	        "members": {
	          "ParameterGroupFamily": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeDefaultClusterParametersResult",
	        "type": "structure",
	        "members": {
	          "DefaultClusterParameters": {
	            "type": "structure",
	            "members": {
	              "ParameterGroupFamily": {},
	              "Marker": {},
	              "Parameters": {
	                "shape": "S5m"
	              }
	            },
	            "wrapper": true
	          }
	        }
	      }
	    },
	    "DescribeEndpointAccess": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterIdentifier": {},
	          "ResourceOwner": {},
	          "EndpointName": {},
	          "VpcId": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEndpointAccessResult",
	        "type": "structure",
	        "members": {
	          "EndpointAccessList": {
	            "type": "list",
	            "member": {
	              "shape": "S3g"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeEndpointAuthorization": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterIdentifier": {},
	          "Account": {},
	          "Grantee": {
	            "type": "boolean"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEndpointAuthorizationResult",
	        "type": "structure",
	        "members": {
	          "EndpointAuthorizationList": {
	            "type": "list",
	            "member": {
	              "shape": "S10"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeEventCategories": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceType": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventCategoriesResult",
	        "type": "structure",
	        "members": {
	          "EventCategoriesMapList": {
	            "type": "list",
	            "member": {
	              "locationName": "EventCategoriesMap",
	              "type": "structure",
	              "members": {
	                "SourceType": {},
	                "Events": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "EventInfoMap",
	                    "type": "structure",
	                    "members": {
	                      "EventId": {},
	                      "EventCategories": {
	                        "shape": "S3j"
	                      },
	                      "EventDescription": {},
	                      "Severity": {}
	                    },
	                    "wrapper": true
	                  }
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "DescribeEventSubscriptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SubscriptionName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventSubscriptionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "EventSubscriptionsList": {
	            "type": "list",
	            "member": {
	              "shape": "S3l",
	              "locationName": "EventSubscription"
	            }
	          }
	        }
	      }
	    },
	    "DescribeEvents": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SourceIdentifier": {},
	          "SourceType": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Duration": {
	            "type": "integer"
	          },
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeEventsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Events": {
	            "type": "list",
	            "member": {
	              "locationName": "Event",
	              "type": "structure",
	              "members": {
	                "SourceIdentifier": {},
	                "SourceType": {},
	                "Message": {},
	                "EventCategories": {
	                  "shape": "S3j"
	                },
	                "Severity": {},
	                "Date": {
	                  "type": "timestamp"
	                },
	                "EventId": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeHsmClientCertificates": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "HsmClientCertificateIdentifier": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeHsmClientCertificatesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "HsmClientCertificates": {
	            "type": "list",
	            "member": {
	              "shape": "S3o",
	              "locationName": "HsmClientCertificate"
	            }
	          }
	        }
	      }
	    },
	    "DescribeHsmConfigurations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "HsmConfigurationIdentifier": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeHsmConfigurationsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "HsmConfigurations": {
	            "type": "list",
	            "member": {
	              "shape": "S3r",
	              "locationName": "HsmConfiguration"
	            }
	          }
	        }
	      }
	    },
	    "DescribeLoggingStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "shape": "S7k",
	        "resultWrapper": "DescribeLoggingStatusResult"
	      }
	    },
	    "DescribeNodeConfigurationOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ActionType"
	        ],
	        "members": {
	          "ActionType": {},
	          "ClusterIdentifier": {},
	          "SnapshotIdentifier": {},
	          "OwnerAccount": {},
	          "Filters": {
	            "locationName": "Filter",
	            "type": "list",
	            "member": {
	              "locationName": "NodeConfigurationOptionsFilter",
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Operator": {},
	                "Values": {
	                  "shape": "S7t",
	                  "locationName": "Value"
	                }
	              }
	            }
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeNodeConfigurationOptionsResult",
	        "type": "structure",
	        "members": {
	          "NodeConfigurationOptionList": {
	            "type": "list",
	            "member": {
	              "locationName": "NodeConfigurationOption",
	              "type": "structure",
	              "members": {
	                "NodeType": {},
	                "NumberOfNodes": {
	                  "type": "integer"
	                },
	                "EstimatedDiskUtilizationPercent": {
	                  "type": "double"
	                },
	                "Mode": {}
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeOrderableClusterOptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterVersion": {},
	          "NodeType": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeOrderableClusterOptionsResult",
	        "type": "structure",
	        "members": {
	          "OrderableClusterOptions": {
	            "type": "list",
	            "member": {
	              "locationName": "OrderableClusterOption",
	              "type": "structure",
	              "members": {
	                "ClusterVersion": {},
	                "ClusterType": {},
	                "NodeType": {},
	                "AvailabilityZones": {
	                  "type": "list",
	                  "member": {
	                    "shape": "S3c",
	                    "locationName": "AvailabilityZone"
	                  }
	                }
	              },
	              "wrapper": true
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribePartners": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccountId",
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "AccountId": {},
	          "ClusterIdentifier": {},
	          "DatabaseName": {},
	          "PartnerName": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribePartnersResult",
	        "type": "structure",
	        "members": {
	          "PartnerIntegrationInfoList": {
	            "type": "list",
	            "member": {
	              "locationName": "PartnerIntegrationInfo",
	              "type": "structure",
	              "members": {
	                "DatabaseName": {},
	                "PartnerName": {},
	                "Status": {},
	                "StatusMessage": {},
	                "CreatedAt": {
	                  "type": "timestamp"
	                },
	                "UpdatedAt": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeReservedNodeExchangeStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedNodeId": {},
	          "ReservedNodeExchangeRequestId": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedNodeExchangeStatusResult",
	        "type": "structure",
	        "members": {
	          "ReservedNodeExchangeStatusDetails": {
	            "type": "list",
	            "member": {
	              "shape": "S2x",
	              "locationName": "ReservedNodeExchangeStatus"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeReservedNodeOfferings": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedNodeOfferingId": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedNodeOfferingsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedNodeOfferings": {
	            "shape": "S8e"
	          }
	        }
	      }
	    },
	    "DescribeReservedNodes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ReservedNodeId": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeReservedNodesResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedNodes": {
	            "type": "list",
	            "member": {
	              "shape": "S4",
	              "locationName": "ReservedNode"
	            }
	          }
	        }
	      }
	    },
	    "DescribeResize": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "shape": "S1l",
	        "resultWrapper": "DescribeResizeResult"
	      }
	    },
	    "DescribeScheduledActions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ScheduledActionName": {},
	          "TargetActionType": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Active": {
	            "type": "boolean"
	          },
	          "Filters": {
	            "type": "list",
	            "member": {
	              "locationName": "ScheduledActionFilter",
	              "type": "structure",
	              "required": [
	                "Name",
	                "Values"
	              ],
	              "members": {
	                "Name": {},
	                "Values": {
	                  "shape": "S7t"
	                }
	              }
	            }
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeScheduledActionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ScheduledActions": {
	            "type": "list",
	            "member": {
	              "shape": "S3x",
	              "locationName": "ScheduledAction"
	            }
	          }
	        }
	      }
	    },
	    "DescribeSnapshotCopyGrants": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SnapshotCopyGrantName": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeSnapshotCopyGrantsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "SnapshotCopyGrants": {
	            "type": "list",
	            "member": {
	              "shape": "S42",
	              "locationName": "SnapshotCopyGrant"
	            }
	          }
	        }
	      }
	    },
	    "DescribeSnapshotSchedules": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterIdentifier": {},
	          "ScheduleIdentifier": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          },
	          "Marker": {},
	          "MaxRecords": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeSnapshotSchedulesResult",
	        "type": "structure",
	        "members": {
	          "SnapshotSchedules": {
	            "type": "list",
	            "member": {
	              "shape": "S45",
	              "locationName": "SnapshotSchedule"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeStorage": {
	      "output": {
	        "resultWrapper": "DescribeStorageResult",
	        "type": "structure",
	        "members": {
	          "TotalBackupSizeInMegaBytes": {
	            "type": "double"
	          },
	          "TotalProvisionedStorageInMegaBytes": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "DescribeTableRestoreStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterIdentifier": {},
	          "TableRestoreRequestId": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeTableRestoreStatusResult",
	        "type": "structure",
	        "members": {
	          "TableRestoreStatusDetails": {
	            "type": "list",
	            "member": {
	              "shape": "S91",
	              "locationName": "TableRestoreStatus"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeTags": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ResourceName": {},
	          "ResourceType": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeTagsResult",
	        "type": "structure",
	        "members": {
	          "TaggedResources": {
	            "type": "list",
	            "member": {
	              "locationName": "TaggedResource",
	              "type": "structure",
	              "members": {
	                "Tag": {
	                  "shape": "Su"
	                },
	                "ResourceName": {},
	                "ResourceType": {}
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeUsageLimits": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "UsageLimitId": {},
	          "ClusterIdentifier": {},
	          "FeatureType": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {},
	          "TagKeys": {
	            "shape": "S4x"
	          },
	          "TagValues": {
	            "shape": "S5h"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DescribeUsageLimitsResult",
	        "type": "structure",
	        "members": {
	          "UsageLimits": {
	            "type": "list",
	            "member": {
	              "shape": "S4f"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DisableLogging": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "shape": "S7k",
	        "resultWrapper": "DisableLoggingResult"
	      }
	    },
	    "DisableSnapshotCopy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DisableSnapshotCopyResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "DisassociateDataShareConsumer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataShareArn"
	        ],
	        "members": {
	          "DataShareArn": {},
	          "DisassociateEntireAccount": {
	            "type": "boolean"
	          },
	          "ConsumerArn": {},
	          "ConsumerRegion": {}
	        }
	      },
	      "output": {
	        "shape": "Sj",
	        "resultWrapper": "DisassociateDataShareConsumerResult"
	      }
	    },
	    "EnableLogging": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "BucketName": {},
	          "S3KeyPrefix": {},
	          "LogDestinationType": {},
	          "LogExports": {
	            "shape": "S7m"
	          }
	        }
	      },
	      "output": {
	        "shape": "S7k",
	        "resultWrapper": "EnableLoggingResult"
	      }
	    },
	    "EnableSnapshotCopy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier",
	          "DestinationRegion"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "DestinationRegion": {},
	          "RetentionPeriod": {
	            "type": "integer"
	          },
	          "SnapshotCopyGrantName": {},
	          "ManualSnapshotRetentionPeriod": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "EnableSnapshotCopyResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "GetClusterCredentials": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DbUser",
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "DbUser": {},
	          "DbName": {},
	          "ClusterIdentifier": {},
	          "DurationSeconds": {
	            "type": "integer"
	          },
	          "AutoCreate": {
	            "type": "boolean"
	          },
	          "DbGroups": {
	            "type": "list",
	            "member": {
	              "locationName": "DbGroup"
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetClusterCredentialsResult",
	        "type": "structure",
	        "members": {
	          "DbUser": {},
	          "DbPassword": {
	            "shape": "S9k"
	          },
	          "Expiration": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetClusterCredentialsWithIAM": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "DbName": {},
	          "ClusterIdentifier": {},
	          "DurationSeconds": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetClusterCredentialsWithIAMResult",
	        "type": "structure",
	        "members": {
	          "DbUser": {},
	          "DbPassword": {
	            "shape": "S9k"
	          },
	          "Expiration": {
	            "type": "timestamp"
	          },
	          "NextRefreshTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetReservedNodeExchangeConfigurationOptions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ActionType"
	        ],
	        "members": {
	          "ActionType": {},
	          "ClusterIdentifier": {},
	          "SnapshotIdentifier": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetReservedNodeExchangeConfigurationOptionsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedNodeConfigurationOptionList": {
	            "type": "list",
	            "member": {
	              "locationName": "ReservedNodeConfigurationOption",
	              "type": "structure",
	              "members": {
	                "SourceReservedNode": {
	                  "shape": "S4"
	                },
	                "TargetReservedNodeCount": {
	                  "type": "integer"
	                },
	                "TargetReservedNodeOffering": {
	                  "shape": "S8f"
	                }
	              },
	              "wrapper": true
	            }
	          }
	        }
	      }
	    },
	    "GetReservedNodeExchangeOfferings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedNodeId"
	        ],
	        "members": {
	          "ReservedNodeId": {},
	          "MaxRecords": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetReservedNodeExchangeOfferingsResult",
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "ReservedNodeOfferings": {
	            "shape": "S8e"
	          }
	        }
	      }
	    },
	    "ModifyAquaConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "AquaConfigurationStatus": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyAquaConfigurationResult",
	        "type": "structure",
	        "members": {
	          "AquaConfiguration": {
	            "shape": "S2v"
	          }
	        }
	      }
	    },
	    "ModifyAuthenticationProfile": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AuthenticationProfileName",
	          "AuthenticationProfileContent"
	        ],
	        "members": {
	          "AuthenticationProfileName": {},
	          "AuthenticationProfileContent": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyAuthenticationProfileResult",
	        "type": "structure",
	        "members": {
	          "AuthenticationProfileName": {},
	          "AuthenticationProfileContent": {}
	        }
	      }
	    },
	    "ModifyCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "ClusterType": {},
	          "NodeType": {},
	          "NumberOfNodes": {
	            "type": "integer"
	          },
	          "ClusterSecurityGroups": {
	            "shape": "S1x"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "S1y"
	          },
	          "MasterUserPassword": {},
	          "ClusterParameterGroupName": {},
	          "AutomatedSnapshotRetentionPeriod": {
	            "type": "integer"
	          },
	          "ManualSnapshotRetentionPeriod": {
	            "type": "integer"
	          },
	          "PreferredMaintenanceWindow": {},
	          "ClusterVersion": {},
	          "AllowVersionUpgrade": {
	            "type": "boolean"
	          },
	          "HsmClientCertificateIdentifier": {},
	          "HsmConfigurationIdentifier": {},
	          "NewClusterIdentifier": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "ElasticIp": {},
	          "EnhancedVpcRouting": {
	            "type": "boolean"
	          },
	          "MaintenanceTrackName": {},
	          "Encrypted": {
	            "type": "boolean"
	          },
	          "KmsKeyId": {},
	          "AvailabilityZoneRelocation": {
	            "type": "boolean"
	          },
	          "AvailabilityZone": {},
	          "Port": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyClusterResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "ModifyClusterDbRevision": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier",
	          "RevisionTarget"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "RevisionTarget": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyClusterDbRevisionResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "ModifyClusterIamRoles": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "AddIamRoles": {
	            "shape": "S1z"
	          },
	          "RemoveIamRoles": {
	            "shape": "S1z"
	          },
	          "DefaultIamRoleArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyClusterIamRolesResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "ModifyClusterMaintenance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "DeferMaintenance": {
	            "type": "boolean"
	          },
	          "DeferMaintenanceIdentifier": {},
	          "DeferMaintenanceStartTime": {
	            "type": "timestamp"
	          },
	          "DeferMaintenanceEndTime": {
	            "type": "timestamp"
	          },
	          "DeferMaintenanceDuration": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyClusterMaintenanceResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "ModifyClusterParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ParameterGroupName",
	          "Parameters"
	        ],
	        "members": {
	          "ParameterGroupName": {},
	          "Parameters": {
	            "shape": "S5m"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sa7",
	        "resultWrapper": "ModifyClusterParameterGroupResult"
	      }
	    },
	    "ModifyClusterSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotIdentifier"
	        ],
	        "members": {
	          "SnapshotIdentifier": {},
	          "ManualSnapshotRetentionPeriod": {
	            "type": "integer"
	          },
	          "Force": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyClusterSnapshotResult",
	        "type": "structure",
	        "members": {
	          "Snapshot": {
	            "shape": "S14"
	          }
	        }
	      }
	    },
	    "ModifyClusterSnapshotSchedule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "ScheduleIdentifier": {},
	          "DisassociateSchedule": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ModifyClusterSubnetGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterSubnetGroupName",
	          "SubnetIds"
	        ],
	        "members": {
	          "ClusterSubnetGroupName": {},
	          "Description": {},
	          "SubnetIds": {
	            "shape": "S37"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyClusterSubnetGroupResult",
	        "type": "structure",
	        "members": {
	          "ClusterSubnetGroup": {
	            "shape": "S39"
	          }
	        }
	      }
	    },
	    "ModifyEndpointAccess": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EndpointName"
	        ],
	        "members": {
	          "EndpointName": {},
	          "VpcSecurityGroupIds": {
	            "shape": "S1y"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3g",
	        "resultWrapper": "ModifyEndpointAccessResult"
	      }
	    },
	    "ModifyEventSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionName"
	        ],
	        "members": {
	          "SubscriptionName": {},
	          "SnsTopicArn": {},
	          "SourceType": {},
	          "SourceIds": {
	            "shape": "S3i"
	          },
	          "EventCategories": {
	            "shape": "S3j"
	          },
	          "Severity": {},
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifyEventSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "EventSubscription": {
	            "shape": "S3l"
	          }
	        }
	      }
	    },
	    "ModifyScheduledAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ScheduledActionName"
	        ],
	        "members": {
	          "ScheduledActionName": {},
	          "TargetAction": {
	            "shape": "S3t"
	          },
	          "Schedule": {},
	          "IamRole": {},
	          "ScheduledActionDescription": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Enable": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S3x",
	        "resultWrapper": "ModifyScheduledActionResult"
	      }
	    },
	    "ModifySnapshotCopyRetentionPeriod": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier",
	          "RetentionPeriod"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "RetentionPeriod": {
	            "type": "integer"
	          },
	          "Manual": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ModifySnapshotCopyRetentionPeriodResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "ModifySnapshotSchedule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ScheduleIdentifier",
	          "ScheduleDefinitions"
	        ],
	        "members": {
	          "ScheduleIdentifier": {},
	          "ScheduleDefinitions": {
	            "shape": "S44"
	          }
	        }
	      },
	      "output": {
	        "shape": "S45",
	        "resultWrapper": "ModifySnapshotScheduleResult"
	      }
	    },
	    "ModifyUsageLimit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UsageLimitId"
	        ],
	        "members": {
	          "UsageLimitId": {},
	          "Amount": {
	            "type": "long"
	          },
	          "BreachAction": {}
	        }
	      },
	      "output": {
	        "shape": "S4f",
	        "resultWrapper": "ModifyUsageLimitResult"
	      }
	    },
	    "PauseCluster": {
	      "input": {
	        "shape": "S3v"
	      },
	      "output": {
	        "resultWrapper": "PauseClusterResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "PurchaseReservedNodeOffering": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ReservedNodeOfferingId"
	        ],
	        "members": {
	          "ReservedNodeOfferingId": {},
	          "NodeCount": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PurchaseReservedNodeOfferingResult",
	        "type": "structure",
	        "members": {
	          "ReservedNode": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "RebootCluster": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RebootClusterResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "RejectDataShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DataShareArn"
	        ],
	        "members": {
	          "DataShareArn": {}
	        }
	      },
	      "output": {
	        "shape": "Sj",
	        "resultWrapper": "RejectDataShareResult"
	      }
	    },
	    "ResetClusterParameterGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ParameterGroupName"
	        ],
	        "members": {
	          "ParameterGroupName": {},
	          "ResetAllParameters": {
	            "type": "boolean"
	          },
	          "Parameters": {
	            "shape": "S5m"
	          }
	        }
	      },
	      "output": {
	        "shape": "Sa7",
	        "resultWrapper": "ResetClusterParameterGroupResult"
	      }
	    },
	    "ResizeCluster": {
	      "input": {
	        "shape": "S3u"
	      },
	      "output": {
	        "resultWrapper": "ResizeClusterResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "RestoreFromClusterSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier",
	          "SnapshotIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "SnapshotIdentifier": {},
	          "SnapshotClusterIdentifier": {},
	          "Port": {
	            "type": "integer"
	          },
	          "AvailabilityZone": {},
	          "AllowVersionUpgrade": {
	            "type": "boolean"
	          },
	          "ClusterSubnetGroupName": {},
	          "PubliclyAccessible": {
	            "type": "boolean"
	          },
	          "OwnerAccount": {},
	          "HsmClientCertificateIdentifier": {},
	          "HsmConfigurationIdentifier": {},
	          "ElasticIp": {},
	          "ClusterParameterGroupName": {},
	          "ClusterSecurityGroups": {
	            "shape": "S1x"
	          },
	          "VpcSecurityGroupIds": {
	            "shape": "S1y"
	          },
	          "PreferredMaintenanceWindow": {},
	          "AutomatedSnapshotRetentionPeriod": {
	            "type": "integer"
	          },
	          "ManualSnapshotRetentionPeriod": {
	            "type": "integer"
	          },
	          "KmsKeyId": {},
	          "NodeType": {},
	          "EnhancedVpcRouting": {
	            "type": "boolean"
	          },
	          "AdditionalInfo": {},
	          "IamRoles": {
	            "shape": "S1z"
	          },
	          "MaintenanceTrackName": {},
	          "SnapshotScheduleIdentifier": {},
	          "NumberOfNodes": {
	            "type": "integer"
	          },
	          "AvailabilityZoneRelocation": {
	            "type": "boolean"
	          },
	          "AquaConfigurationStatus": {},
	          "DefaultIamRoleArn": {},
	          "ReservedNodeId": {},
	          "TargetReservedNodeOfferingId": {},
	          "Encrypted": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreFromClusterSnapshotResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "RestoreTableFromClusterSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier",
	          "SnapshotIdentifier",
	          "SourceDatabaseName",
	          "SourceTableName",
	          "NewTableName"
	        ],
	        "members": {
	          "ClusterIdentifier": {},
	          "SnapshotIdentifier": {},
	          "SourceDatabaseName": {},
	          "SourceSchemaName": {},
	          "SourceTableName": {},
	          "TargetDatabaseName": {},
	          "TargetSchemaName": {},
	          "NewTableName": {},
	          "EnableCaseSensitiveIdentifier": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "RestoreTableFromClusterSnapshotResult",
	        "type": "structure",
	        "members": {
	          "TableRestoreStatus": {
	            "shape": "S91"
	          }
	        }
	      }
	    },
	    "ResumeCluster": {
	      "input": {
	        "shape": "S3w"
	      },
	      "output": {
	        "resultWrapper": "ResumeClusterResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "RevokeClusterSecurityGroupIngress": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterSecurityGroupName"
	        ],
	        "members": {
	          "ClusterSecurityGroupName": {},
	          "CIDRIP": {},
	          "EC2SecurityGroupName": {},
	          "EC2SecurityGroupOwnerId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RevokeClusterSecurityGroupIngressResult",
	        "type": "structure",
	        "members": {
	          "ClusterSecurityGroup": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "RevokeEndpointAccess": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "ClusterIdentifier": {},
	          "Account": {},
	          "VpcIds": {
	            "shape": "Sz"
	          },
	          "Force": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "shape": "S10",
	        "resultWrapper": "RevokeEndpointAccessResult"
	      }
	    },
	    "RevokeSnapshotAccess": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SnapshotIdentifier",
	          "AccountWithRestoreAccess"
	        ],
	        "members": {
	          "SnapshotIdentifier": {},
	          "SnapshotClusterIdentifier": {},
	          "AccountWithRestoreAccess": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RevokeSnapshotAccessResult",
	        "type": "structure",
	        "members": {
	          "Snapshot": {
	            "shape": "S14"
	          }
	        }
	      }
	    },
	    "RotateEncryptionKey": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClusterIdentifier"
	        ],
	        "members": {
	          "ClusterIdentifier": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "RotateEncryptionKeyResult",
	        "type": "structure",
	        "members": {
	          "Cluster": {
	            "shape": "S22"
	          }
	        }
	      }
	    },
	    "UpdatePartnerStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccountId",
	          "ClusterIdentifier",
	          "DatabaseName",
	          "PartnerName",
	          "Status"
	        ],
	        "members": {
	          "AccountId": {},
	          "ClusterIdentifier": {},
	          "DatabaseName": {},
	          "PartnerName": {},
	          "Status": {},
	          "StatusMessage": {}
	        }
	      },
	      "output": {
	        "shape": "Sg",
	        "resultWrapper": "UpdatePartnerStatusResult"
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "members": {
	        "ReservedNodeId": {},
	        "ReservedNodeOfferingId": {},
	        "NodeType": {},
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "Duration": {
	          "type": "integer"
	        },
	        "FixedPrice": {
	          "type": "double"
	        },
	        "UsagePrice": {
	          "type": "double"
	        },
	        "CurrencyCode": {},
	        "NodeCount": {
	          "type": "integer"
	        },
	        "State": {},
	        "OfferingType": {},
	        "RecurringCharges": {
	          "shape": "S8"
	        },
	        "ReservedNodeOfferingType": {}
	      },
	      "wrapper": true
	    },
	    "S8": {
	      "type": "list",
	      "member": {
	        "locationName": "RecurringCharge",
	        "type": "structure",
	        "members": {
	          "RecurringChargeAmount": {
	            "type": "double"
	          },
	          "RecurringChargeFrequency": {}
	        },
	        "wrapper": true
	      }
	    },
	    "Sb": {
	      "type": "structure",
	      "required": [
	        "AccountId",
	        "ClusterIdentifier",
	        "DatabaseName",
	        "PartnerName"
	      ],
	      "members": {
	        "AccountId": {},
	        "ClusterIdentifier": {},
	        "DatabaseName": {},
	        "PartnerName": {}
	      }
	    },
	    "Sg": {
	      "type": "structure",
	      "members": {
	        "DatabaseName": {},
	        "PartnerName": {}
	      }
	    },
	    "Sj": {
	      "type": "structure",
	      "members": {
	        "DataShareArn": {},
	        "ProducerArn": {},
	        "AllowPubliclyAccessibleConsumers": {
	          "type": "boolean"
	        },
	        "DataShareAssociations": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "ConsumerIdentifier": {},
	              "Status": {},
	              "ConsumerRegion": {},
	              "CreatedDate": {
	                "type": "timestamp"
	              },
	              "StatusChangeDate": {
	                "type": "timestamp"
	              }
	            }
	          }
	        },
	        "ManagedBy": {}
	      }
	    },
	    "Sq": {
	      "type": "structure",
	      "members": {
	        "ClusterSecurityGroupName": {},
	        "Description": {},
	        "EC2SecurityGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "EC2SecurityGroup",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "EC2SecurityGroupName": {},
	              "EC2SecurityGroupOwnerId": {},
	              "Tags": {
	                "shape": "St"
	              }
	            }
	          }
	        },
	        "IPRanges": {
	          "type": "list",
	          "member": {
	            "locationName": "IPRange",
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "CIDRIP": {},
	              "Tags": {
	                "shape": "St"
	              }
	            }
	          }
	        },
	        "Tags": {
	          "shape": "St"
	        }
	      },
	      "wrapper": true
	    },
	    "St": {
	      "type": "list",
	      "member": {
	        "shape": "Su",
	        "locationName": "Tag"
	      }
	    },
	    "Su": {
	      "type": "structure",
	      "members": {
	        "Key": {},
	        "Value": {}
	      }
	    },
	    "Sz": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcIdentifier"
	      }
	    },
	    "S10": {
	      "type": "structure",
	      "members": {
	        "Grantor": {},
	        "Grantee": {},
	        "ClusterIdentifier": {},
	        "AuthorizeTime": {
	          "type": "timestamp"
	        },
	        "ClusterStatus": {},
	        "Status": {},
	        "AllowedAllVPCs": {
	          "type": "boolean"
	        },
	        "AllowedVPCs": {
	          "shape": "Sz"
	        },
	        "EndpointCount": {
	          "type": "integer"
	        }
	      }
	    },
	    "S14": {
	      "type": "structure",
	      "members": {
	        "SnapshotIdentifier": {},
	        "ClusterIdentifier": {},
	        "SnapshotCreateTime": {
	          "type": "timestamp"
	        },
	        "Status": {},
	        "Port": {
	          "type": "integer"
	        },
	        "AvailabilityZone": {},
	        "ClusterCreateTime": {
	          "type": "timestamp"
	        },
	        "MasterUsername": {},
	        "ClusterVersion": {},
	        "EngineFullVersion": {},
	        "SnapshotType": {},
	        "NodeType": {},
	        "NumberOfNodes": {
	          "type": "integer"
	        },
	        "DBName": {},
	        "VpcId": {},
	        "Encrypted": {
	          "type": "boolean"
	        },
	        "KmsKeyId": {},
	        "EncryptedWithHSM": {
	          "type": "boolean"
	        },
	        "AccountsWithRestoreAccess": {
	          "type": "list",
	          "member": {
	            "locationName": "AccountWithRestoreAccess",
	            "type": "structure",
	            "members": {
	              "AccountId": {},
	              "AccountAlias": {}
	            }
	          }
	        },
	        "OwnerAccount": {},
	        "TotalBackupSizeInMegaBytes": {
	          "type": "double"
	        },
	        "ActualIncrementalBackupSizeInMegaBytes": {
	          "type": "double"
	        },
	        "BackupProgressInMegaBytes": {
	          "type": "double"
	        },
	        "CurrentBackupRateInMegaBytesPerSecond": {
	          "type": "double"
	        },
	        "EstimatedSecondsToCompletion": {
	          "type": "long"
	        },
	        "ElapsedTimeInSeconds": {
	          "type": "long"
	        },
	        "SourceRegion": {},
	        "Tags": {
	          "shape": "St"
	        },
	        "RestorableNodeTypes": {
	          "type": "list",
	          "member": {
	            "locationName": "NodeType"
	          }
	        },
	        "EnhancedVpcRouting": {
	          "type": "boolean"
	        },
	        "MaintenanceTrackName": {},
	        "ManualSnapshotRetentionPeriod": {
	          "type": "integer"
	        },
	        "ManualSnapshotRemainingDays": {
	          "type": "integer"
	        },
	        "SnapshotRetentionStartTime": {
	          "type": "timestamp"
	        }
	      },
	      "wrapper": true
	    },
	    "S1c": {
	      "type": "structure",
	      "required": [
	        "SnapshotIdentifier"
	      ],
	      "members": {
	        "SnapshotIdentifier": {},
	        "SnapshotClusterIdentifier": {}
	      }
	    },
	    "S1e": {
	      "type": "list",
	      "member": {
	        "locationName": "String"
	      }
	    },
	    "S1g": {
	      "type": "structure",
	      "members": {
	        "SnapshotIdentifier": {},
	        "SnapshotClusterIdentifier": {},
	        "FailureCode": {},
	        "FailureReason": {}
	      }
	    },
	    "S1l": {
	      "type": "structure",
	      "members": {
	        "TargetNodeType": {},
	        "TargetNumberOfNodes": {
	          "type": "integer"
	        },
	        "TargetClusterType": {},
	        "Status": {},
	        "ImportTablesCompleted": {
	          "type": "list",
	          "member": {}
	        },
	        "ImportTablesInProgress": {
	          "type": "list",
	          "member": {}
	        },
	        "ImportTablesNotStarted": {
	          "type": "list",
	          "member": {}
	        },
	        "AvgResizeRateInMegaBytesPerSecond": {
	          "type": "double"
	        },
	        "TotalResizeDataInMegaBytes": {
	          "type": "long"
	        },
	        "ProgressInMegaBytes": {
	          "type": "long"
	        },
	        "ElapsedTimeInSeconds": {
	          "type": "long"
	        },
	        "EstimatedTimeToCompletionInSeconds": {
	          "type": "long"
	        },
	        "ResizeType": {},
	        "Message": {},
	        "TargetEncryptionType": {},
	        "DataTransferProgressPercent": {
	          "type": "double"
	        }
	      }
	    },
	    "S1x": {
	      "type": "list",
	      "member": {
	        "locationName": "ClusterSecurityGroupName"
	      }
	    },
	    "S1y": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroupId"
	      }
	    },
	    "S1z": {
	      "type": "list",
	      "member": {
	        "locationName": "IamRoleArn"
	      }
	    },
	    "S22": {
	      "type": "structure",
	      "members": {
	        "ClusterIdentifier": {},
	        "NodeType": {},
	        "ClusterStatus": {},
	        "ClusterAvailabilityStatus": {},
	        "ModifyStatus": {},
	        "MasterUsername": {},
	        "DBName": {},
	        "Endpoint": {
	          "type": "structure",
	          "members": {
	            "Address": {},
	            "Port": {
	              "type": "integer"
	            },
	            "VpcEndpoints": {
	              "type": "list",
	              "member": {
	                "shape": "S25",
	                "locationName": "VpcEndpoint"
	              }
	            }
	          }
	        },
	        "ClusterCreateTime": {
	          "type": "timestamp"
	        },
	        "AutomatedSnapshotRetentionPeriod": {
	          "type": "integer"
	        },
	        "ManualSnapshotRetentionPeriod": {
	          "type": "integer"
	        },
	        "ClusterSecurityGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "ClusterSecurityGroup",
	            "type": "structure",
	            "members": {
	              "ClusterSecurityGroupName": {},
	              "Status": {}
	            }
	          }
	        },
	        "VpcSecurityGroups": {
	          "shape": "S2a"
	        },
	        "ClusterParameterGroups": {
	          "type": "list",
	          "member": {
	            "locationName": "ClusterParameterGroup",
	            "type": "structure",
	            "members": {
	              "ParameterGroupName": {},
	              "ParameterApplyStatus": {},
	              "ClusterParameterStatusList": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "ParameterName": {},
	                    "ParameterApplyStatus": {},
	                    "ParameterApplyErrorDescription": {}
	                  }
	                }
	              }
	            }
	          }
	        },
	        "ClusterSubnetGroupName": {},
	        "VpcId": {},
	        "AvailabilityZone": {},
	        "PreferredMaintenanceWindow": {},
	        "PendingModifiedValues": {
	          "type": "structure",
	          "members": {
	            "MasterUserPassword": {},
	            "NodeType": {},
	            "NumberOfNodes": {
	              "type": "integer"
	            },
	            "ClusterType": {},
	            "ClusterVersion": {},
	            "AutomatedSnapshotRetentionPeriod": {
	              "type": "integer"
	            },
	            "ClusterIdentifier": {},
	            "PubliclyAccessible": {
	              "type": "boolean"
	            },
	            "EnhancedVpcRouting": {
	              "type": "boolean"
	            },
	            "MaintenanceTrackName": {},
	            "EncryptionType": {}
	          }
	        },
	        "ClusterVersion": {},
	        "AllowVersionUpgrade": {
	          "type": "boolean"
	        },
	        "NumberOfNodes": {
	          "type": "integer"
	        },
	        "PubliclyAccessible": {
	          "type": "boolean"
	        },
	        "Encrypted": {
	          "type": "boolean"
	        },
	        "RestoreStatus": {
	          "type": "structure",
	          "members": {
	            "Status": {},
	            "CurrentRestoreRateInMegaBytesPerSecond": {
	              "type": "double"
	            },
	            "SnapshotSizeInMegaBytes": {
	              "type": "long"
	            },
	            "ProgressInMegaBytes": {
	              "type": "long"
	            },
	            "ElapsedTimeInSeconds": {
	              "type": "long"
	            },
	            "EstimatedTimeToCompletionInSeconds": {
	              "type": "long"
	            }
	          }
	        },
	        "DataTransferProgress": {
	          "type": "structure",
	          "members": {
	            "Status": {},
	            "CurrentRateInMegaBytesPerSecond": {
	              "type": "double"
	            },
	            "TotalDataInMegaBytes": {
	              "type": "long"
	            },
	            "DataTransferredInMegaBytes": {
	              "type": "long"
	            },
	            "EstimatedTimeToCompletionInSeconds": {
	              "type": "long"
	            },
	            "ElapsedTimeInSeconds": {
	              "type": "long"
	            }
	          }
	        },
	        "HsmStatus": {
	          "type": "structure",
	          "members": {
	            "HsmClientCertificateIdentifier": {},
	            "HsmConfigurationIdentifier": {},
	            "Status": {}
	          }
	        },
	        "ClusterSnapshotCopyStatus": {
	          "type": "structure",
	          "members": {
	            "DestinationRegion": {},
	            "RetentionPeriod": {
	              "type": "long"
	            },
	            "ManualSnapshotRetentionPeriod": {
	              "type": "integer"
	            },
	            "SnapshotCopyGrantName": {}
	          }
	        },
	        "ClusterPublicKey": {},
	        "ClusterNodes": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "NodeRole": {},
	              "PrivateIPAddress": {},
	              "PublicIPAddress": {}
	            }
	          }
	        },
	        "ElasticIpStatus": {
	          "type": "structure",
	          "members": {
	            "ElasticIp": {},
	            "Status": {}
	          }
	        },
	        "ClusterRevisionNumber": {},
	        "Tags": {
	          "shape": "St"
	        },
	        "KmsKeyId": {},
	        "EnhancedVpcRouting": {
	          "type": "boolean"
	        },
	        "IamRoles": {
	          "type": "list",
	          "member": {
	            "locationName": "ClusterIamRole",
	            "type": "structure",
	            "members": {
	              "IamRoleArn": {},
	              "ApplyStatus": {}
	            }
	          }
	        },
	        "PendingActions": {
	          "type": "list",
	          "member": {}
	        },
	        "MaintenanceTrackName": {},
	        "ElasticResizeNumberOfNodeOptions": {},
	        "DeferredMaintenanceWindows": {
	          "type": "list",
	          "member": {
	            "locationName": "DeferredMaintenanceWindow",
	            "type": "structure",
	            "members": {
	              "DeferMaintenanceIdentifier": {},
	              "DeferMaintenanceStartTime": {
	                "type": "timestamp"
	              },
	              "DeferMaintenanceEndTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        },
	        "SnapshotScheduleIdentifier": {},
	        "SnapshotScheduleState": {},
	        "ExpectedNextSnapshotScheduleTime": {
	          "type": "timestamp"
	        },
	        "ExpectedNextSnapshotScheduleTimeStatus": {},
	        "NextMaintenanceWindowStartTime": {
	          "type": "timestamp"
	        },
	        "ResizeInfo": {
	          "type": "structure",
	          "members": {
	            "ResizeType": {},
	            "AllowCancelResize": {
	              "type": "boolean"
	            }
	          }
	        },
	        "AvailabilityZoneRelocationStatus": {},
	        "ClusterNamespaceArn": {},
	        "TotalStorageCapacityInMegaBytes": {
	          "type": "long"
	        },
	        "AquaConfiguration": {
	          "shape": "S2v"
	        },
	        "DefaultIamRoleArn": {},
	        "ReservedNodeExchangeStatus": {
	          "shape": "S2x"
	        }
	      },
	      "wrapper": true
	    },
	    "S25": {
	      "type": "structure",
	      "members": {
	        "VpcEndpointId": {},
	        "VpcId": {},
	        "NetworkInterfaces": {
	          "type": "list",
	          "member": {
	            "locationName": "NetworkInterface",
	            "type": "structure",
	            "members": {
	              "NetworkInterfaceId": {},
	              "SubnetId": {},
	              "PrivateIpAddress": {},
	              "AvailabilityZone": {}
	            }
	          }
	        }
	      }
	    },
	    "S2a": {
	      "type": "list",
	      "member": {
	        "locationName": "VpcSecurityGroup",
	        "type": "structure",
	        "members": {
	          "VpcSecurityGroupId": {},
	          "Status": {}
	        }
	      }
	    },
	    "S2v": {
	      "type": "structure",
	      "members": {
	        "AquaStatus": {},
	        "AquaConfigurationStatus": {}
	      }
	    },
	    "S2x": {
	      "type": "structure",
	      "members": {
	        "ReservedNodeExchangeRequestId": {},
	        "Status": {},
	        "RequestTime": {
	          "type": "timestamp"
	        },
	        "SourceReservedNodeId": {},
	        "SourceReservedNodeType": {},
	        "SourceReservedNodeCount": {
	          "type": "integer"
	        },
	        "TargetReservedNodeOfferingId": {},
	        "TargetReservedNodeType": {},
	        "TargetReservedNodeCount": {
	          "type": "integer"
	        }
	      },
	      "wrapper": true
	    },
	    "S31": {
	      "type": "structure",
	      "members": {
	        "ParameterGroupName": {},
	        "ParameterGroupFamily": {},
	        "Description": {},
	        "Tags": {
	          "shape": "St"
	        }
	      },
	      "wrapper": true
	    },
	    "S37": {
	      "type": "list",
	      "member": {
	        "locationName": "SubnetIdentifier"
	      }
	    },
	    "S39": {
	      "type": "structure",
	      "members": {
	        "ClusterSubnetGroupName": {},
	        "Description": {},
	        "VpcId": {},
	        "SubnetGroupStatus": {},
	        "Subnets": {
	          "type": "list",
	          "member": {
	            "locationName": "Subnet",
	            "type": "structure",
	            "members": {
	              "SubnetIdentifier": {},
	              "SubnetAvailabilityZone": {
	                "shape": "S3c"
	              },
	              "SubnetStatus": {}
	            }
	          }
	        },
	        "Tags": {
	          "shape": "St"
	        }
	      },
	      "wrapper": true
	    },
	    "S3c": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "SupportedPlatforms": {
	          "type": "list",
	          "member": {
	            "locationName": "SupportedPlatform",
	            "type": "structure",
	            "members": {
	              "Name": {}
	            },
	            "wrapper": true
	          }
	        }
	      },
	      "wrapper": true
	    },
	    "S3g": {
	      "type": "structure",
	      "members": {
	        "ClusterIdentifier": {},
	        "ResourceOwner": {},
	        "SubnetGroupName": {},
	        "EndpointStatus": {},
	        "EndpointName": {},
	        "EndpointCreateTime": {
	          "type": "timestamp"
	        },
	        "Port": {
	          "type": "integer"
	        },
	        "Address": {},
	        "VpcSecurityGroups": {
	          "shape": "S2a"
	        },
	        "VpcEndpoint": {
	          "shape": "S25"
	        }
	      }
	    },
	    "S3i": {
	      "type": "list",
	      "member": {
	        "locationName": "SourceId"
	      }
	    },
	    "S3j": {
	      "type": "list",
	      "member": {
	        "locationName": "EventCategory"
	      }
	    },
	    "S3l": {
	      "type": "structure",
	      "members": {
	        "CustomerAwsId": {},
	        "CustSubscriptionId": {},
	        "SnsTopicArn": {},
	        "Status": {},
	        "SubscriptionCreationTime": {
	          "type": "timestamp"
	        },
	        "SourceType": {},
	        "SourceIdsList": {
	          "shape": "S3i"
	        },
	        "EventCategoriesList": {
	          "shape": "S3j"
	        },
	        "Severity": {},
	        "Enabled": {
	          "type": "boolean"
	        },
	        "Tags": {
	          "shape": "St"
	        }
	      },
	      "wrapper": true
	    },
	    "S3o": {
	      "type": "structure",
	      "members": {
	        "HsmClientCertificateIdentifier": {},
	        "HsmClientCertificatePublicKey": {},
	        "Tags": {
	          "shape": "St"
	        }
	      },
	      "wrapper": true
	    },
	    "S3r": {
	      "type": "structure",
	      "members": {
	        "HsmConfigurationIdentifier": {},
	        "Description": {},
	        "HsmIpAddress": {},
	        "HsmPartitionName": {},
	        "Tags": {
	          "shape": "St"
	        }
	      },
	      "wrapper": true
	    },
	    "S3t": {
	      "type": "structure",
	      "members": {
	        "ResizeCluster": {
	          "shape": "S3u"
	        },
	        "PauseCluster": {
	          "shape": "S3v"
	        },
	        "ResumeCluster": {
	          "shape": "S3w"
	        }
	      }
	    },
	    "S3u": {
	      "type": "structure",
	      "required": [
	        "ClusterIdentifier"
	      ],
	      "members": {
	        "ClusterIdentifier": {},
	        "ClusterType": {},
	        "NodeType": {},
	        "NumberOfNodes": {
	          "type": "integer"
	        },
	        "Classic": {
	          "type": "boolean"
	        },
	        "ReservedNodeId": {},
	        "TargetReservedNodeOfferingId": {}
	      }
	    },
	    "S3v": {
	      "type": "structure",
	      "required": [
	        "ClusterIdentifier"
	      ],
	      "members": {
	        "ClusterIdentifier": {}
	      }
	    },
	    "S3w": {
	      "type": "structure",
	      "required": [
	        "ClusterIdentifier"
	      ],
	      "members": {
	        "ClusterIdentifier": {}
	      }
	    },
	    "S3x": {
	      "type": "structure",
	      "members": {
	        "ScheduledActionName": {},
	        "TargetAction": {
	          "shape": "S3t"
	        },
	        "Schedule": {},
	        "IamRole": {},
	        "ScheduledActionDescription": {},
	        "State": {},
	        "NextInvocations": {
	          "type": "list",
	          "member": {
	            "locationName": "ScheduledActionTime",
	            "type": "timestamp"
	          }
	        },
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S42": {
	      "type": "structure",
	      "members": {
	        "SnapshotCopyGrantName": {},
	        "KmsKeyId": {},
	        "Tags": {
	          "shape": "St"
	        }
	      },
	      "wrapper": true
	    },
	    "S44": {
	      "type": "list",
	      "member": {
	        "locationName": "ScheduleDefinition"
	      }
	    },
	    "S45": {
	      "type": "structure",
	      "members": {
	        "ScheduleDefinitions": {
	          "shape": "S44"
	        },
	        "ScheduleIdentifier": {},
	        "ScheduleDescription": {},
	        "Tags": {
	          "shape": "St"
	        },
	        "NextInvocations": {
	          "type": "list",
	          "member": {
	            "locationName": "SnapshotTime",
	            "type": "timestamp"
	          }
	        },
	        "AssociatedClusterCount": {
	          "type": "integer"
	        },
	        "AssociatedClusters": {
	          "type": "list",
	          "member": {
	            "locationName": "ClusterAssociatedToSchedule",
	            "type": "structure",
	            "members": {
	              "ClusterIdentifier": {},
	              "ScheduleAssociationState": {}
	            }
	          }
	        }
	      }
	    },
	    "S4f": {
	      "type": "structure",
	      "members": {
	        "UsageLimitId": {},
	        "ClusterIdentifier": {},
	        "FeatureType": {},
	        "LimitType": {},
	        "Amount": {
	          "type": "long"
	        },
	        "Period": {},
	        "BreachAction": {},
	        "Tags": {
	          "shape": "St"
	        }
	      }
	    },
	    "S4x": {
	      "type": "list",
	      "member": {
	        "locationName": "TagKey"
	      }
	    },
	    "S5h": {
	      "type": "list",
	      "member": {
	        "locationName": "TagValue"
	      }
	    },
	    "S5m": {
	      "type": "list",
	      "member": {
	        "locationName": "Parameter",
	        "type": "structure",
	        "members": {
	          "ParameterName": {},
	          "ParameterValue": {},
	          "Description": {},
	          "Source": {},
	          "DataType": {},
	          "AllowedValues": {},
	          "ApplyType": {},
	          "IsModifiable": {
	            "type": "boolean"
	          },
	          "MinimumEngineVersion": {}
	        }
	      }
	    },
	    "S6j": {
	      "type": "list",
	      "member": {
	        "shape": "Sj"
	      }
	    },
	    "S7k": {
	      "type": "structure",
	      "members": {
	        "LoggingEnabled": {
	          "type": "boolean"
	        },
	        "BucketName": {},
	        "S3KeyPrefix": {},
	        "LastSuccessfulDeliveryTime": {
	          "type": "timestamp"
	        },
	        "LastFailureTime": {
	          "type": "timestamp"
	        },
	        "LastFailureMessage": {},
	        "LogDestinationType": {},
	        "LogExports": {
	          "shape": "S7m"
	        }
	      }
	    },
	    "S7m": {
	      "type": "list",
	      "member": {}
	    },
	    "S7t": {
	      "type": "list",
	      "member": {
	        "locationName": "item"
	      }
	    },
	    "S8e": {
	      "type": "list",
	      "member": {
	        "shape": "S8f",
	        "locationName": "ReservedNodeOffering"
	      }
	    },
	    "S8f": {
	      "type": "structure",
	      "members": {
	        "ReservedNodeOfferingId": {},
	        "NodeType": {},
	        "Duration": {
	          "type": "integer"
	        },
	        "FixedPrice": {
	          "type": "double"
	        },
	        "UsagePrice": {
	          "type": "double"
	        },
	        "CurrencyCode": {},
	        "OfferingType": {},
	        "RecurringCharges": {
	          "shape": "S8"
	        },
	        "ReservedNodeOfferingType": {}
	      },
	      "wrapper": true
	    },
	    "S91": {
	      "type": "structure",
	      "members": {
	        "TableRestoreRequestId": {},
	        "Status": {},
	        "Message": {},
	        "RequestTime": {
	          "type": "timestamp"
	        },
	        "ProgressInMegaBytes": {
	          "type": "long"
	        },
	        "TotalDataInMegaBytes": {
	          "type": "long"
	        },
	        "ClusterIdentifier": {},
	        "SnapshotIdentifier": {},
	        "SourceDatabaseName": {},
	        "SourceSchemaName": {},
	        "SourceTableName": {},
	        "TargetDatabaseName": {},
	        "TargetSchemaName": {},
	        "NewTableName": {}
	      },
	      "wrapper": true
	    },
	    "S9k": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Sa7": {
	      "type": "structure",
	      "members": {
	        "ParameterGroupName": {},
	        "ParameterGroupStatus": {}
	      }
	    }
	  }
	}
	},{}],196:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeClusterDbRevisions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ClusterDbRevisions"
	    },
	    "DescribeClusterParameterGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ParameterGroups"
	    },
	    "DescribeClusterParameters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Parameters"
	    },
	    "DescribeClusterSecurityGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ClusterSecurityGroups"
	    },
	    "DescribeClusterSnapshots": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Snapshots"
	    },
	    "DescribeClusterSubnetGroups": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ClusterSubnetGroups"
	    },
	    "DescribeClusterTracks": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "MaintenanceTracks"
	    },
	    "DescribeClusterVersions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ClusterVersions"
	    },
	    "DescribeClusters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Clusters"
	    },
	    "DescribeDataShares": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DataShares"
	    },
	    "DescribeDataSharesForConsumer": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DataShares"
	    },
	    "DescribeDataSharesForProducer": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "DataShares"
	    },
	    "DescribeDefaultClusterParameters": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "DefaultClusterParameters.Marker",
	      "result_key": "DefaultClusterParameters.Parameters"
	    },
	    "DescribeEndpointAccess": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "EndpointAccessList"
	    },
	    "DescribeEndpointAuthorization": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "EndpointAuthorizationList"
	    },
	    "DescribeEventSubscriptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "EventSubscriptionsList"
	    },
	    "DescribeEvents": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "Events"
	    },
	    "DescribeHsmClientCertificates": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "HsmClientCertificates"
	    },
	    "DescribeHsmConfigurations": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "HsmConfigurations"
	    },
	    "DescribeNodeConfigurationOptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "NodeConfigurationOptionList"
	    },
	    "DescribeOrderableClusterOptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "OrderableClusterOptions"
	    },
	    "DescribeReservedNodeExchangeStatus": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedNodeExchangeStatusDetails"
	    },
	    "DescribeReservedNodeOfferings": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedNodeOfferings"
	    },
	    "DescribeReservedNodes": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedNodes"
	    },
	    "DescribeScheduledActions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ScheduledActions"
	    },
	    "DescribeSnapshotCopyGrants": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "SnapshotCopyGrants"
	    },
	    "DescribeSnapshotSchedules": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "SnapshotSchedules"
	    },
	    "DescribeTableRestoreStatus": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "TableRestoreStatusDetails"
	    },
	    "DescribeTags": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "TaggedResources"
	    },
	    "DescribeUsageLimits": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "UsageLimits"
	    },
	    "GetReservedNodeExchangeConfigurationOptions": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedNodeConfigurationOptionList"
	    },
	    "GetReservedNodeExchangeOfferings": {
	      "input_token": "Marker",
	      "limit_key": "MaxRecords",
	      "output_token": "Marker",
	      "result_key": "ReservedNodeOfferings"
	    }
	  }
	}
	},{}],197:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "ClusterAvailable": {
	      "delay": 60,
	      "operation": "DescribeClusters",
	      "maxAttempts": 30,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Clusters[].ClusterStatus"
	        },
	        {
	          "expected": "deleting",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Clusters[].ClusterStatus"
	        },
	        {
	          "expected": "ClusterNotFound",
	          "matcher": "error",
	          "state": "retry"
	        }
	      ]
	    },
	    "ClusterDeleted": {
	      "delay": 60,
	      "operation": "DescribeClusters",
	      "maxAttempts": 30,
	      "acceptors": [
	        {
	          "expected": "ClusterNotFound",
	          "matcher": "error",
	          "state": "success"
	        },
	        {
	          "expected": "creating",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Clusters[].ClusterStatus"
	        },
	        {
	          "expected": "modifying",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Clusters[].ClusterStatus"
	        }
	      ]
	    },
	    "ClusterRestored": {
	      "operation": "DescribeClusters",
	      "maxAttempts": 30,
	      "delay": 60,
	      "acceptors": [
	        {
	          "state": "success",
	          "matcher": "pathAll",
	          "argument": "Clusters[].RestoreStatus.Status",
	          "expected": "completed"
	        },
	        {
	          "state": "failure",
	          "matcher": "pathAny",
	          "argument": "Clusters[].ClusterStatus",
	          "expected": "deleting"
	        }
	      ]
	    },
	    "SnapshotAvailable": {
	      "delay": 15,
	      "operation": "DescribeClusterSnapshots",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "expected": "available",
	          "matcher": "pathAll",
	          "state": "success",
	          "argument": "Snapshots[].Status"
	        },
	        {
	          "expected": "failed",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Snapshots[].Status"
	        },
	        {
	          "expected": "deleted",
	          "matcher": "pathAny",
	          "state": "failure",
	          "argument": "Snapshots[].Status"
	        }
	      ]
	    }
	  }
	}
	
	},{}],198:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2016-06-27",
	    "endpointPrefix": "rekognition",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Rekognition",
	    "serviceId": "Rekognition",
	    "signatureVersion": "v4",
	    "targetPrefix": "RekognitionService",
	    "uid": "rekognition-2016-06-27"
	  },
	  "operations": {
	    "CompareFaces": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceImage",
	          "TargetImage"
	        ],
	        "members": {
	          "SourceImage": {
	            "shape": "S2"
	          },
	          "TargetImage": {
	            "shape": "S2"
	          },
	          "SimilarityThreshold": {
	            "type": "float"
	          },
	          "QualityFilter": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SourceImageFace": {
	            "type": "structure",
	            "members": {
	              "BoundingBox": {
	                "shape": "Sc"
	              },
	              "Confidence": {
	                "type": "float"
	              }
	            }
	          },
	          "FaceMatches": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Similarity": {
	                  "type": "float"
	                },
	                "Face": {
	                  "shape": "Sg"
	                }
	              }
	            }
	          },
	          "UnmatchedFaces": {
	            "type": "list",
	            "member": {
	              "shape": "Sg"
	            }
	          },
	          "SourceImageOrientationCorrection": {},
	          "TargetImageOrientationCorrection": {}
	        }
	      }
	    },
	    "CreateCollection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionId"
	        ],
	        "members": {
	          "CollectionId": {},
	          "Tags": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StatusCode": {
	            "type": "integer"
	          },
	          "CollectionArn": {},
	          "FaceModelVersion": {}
	        }
	      }
	    },
	    "CreateDataset": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetType",
	          "ProjectArn"
	        ],
	        "members": {
	          "DatasetSource": {
	            "type": "structure",
	            "members": {
	              "GroundTruthManifest": {
	                "shape": "S14"
	              },
	              "DatasetArn": {}
	            }
	          },
	          "DatasetType": {},
	          "ProjectArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetArn": {}
	        }
	      }
	    },
	    "CreateProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProjectName"
	        ],
	        "members": {
	          "ProjectName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProjectArn": {}
	        }
	      }
	    },
	    "CreateProjectVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProjectArn",
	          "VersionName",
	          "OutputConfig"
	        ],
	        "members": {
	          "ProjectArn": {},
	          "VersionName": {},
	          "OutputConfig": {
	            "shape": "S1e"
	          },
	          "TrainingData": {
	            "shape": "S1g"
	          },
	          "TestingData": {
	            "shape": "S1j"
	          },
	          "Tags": {
	            "shape": "Sw"
	          },
	          "KmsKeyId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProjectVersionArn": {}
	        }
	      }
	    },
	    "CreateStreamProcessor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Input",
	          "Output",
	          "Name",
	          "Settings",
	          "RoleArn"
	        ],
	        "members": {
	          "Input": {
	            "shape": "S1o"
	          },
	          "Output": {
	            "shape": "S1r"
	          },
	          "Name": {},
	          "Settings": {
	            "shape": "S1w"
	          },
	          "RoleArn": {},
	          "Tags": {
	            "shape": "Sw"
	          },
	          "NotificationChannel": {
	            "shape": "S22"
	          },
	          "KmsKeyId": {},
	          "RegionsOfInterest": {
	            "shape": "S24"
	          },
	          "DataSharingPreference": {
	            "shape": "S28"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamProcessorArn": {}
	        }
	      }
	    },
	    "DeleteCollection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionId"
	        ],
	        "members": {
	          "CollectionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StatusCode": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "DeleteDataset": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetArn"
	        ],
	        "members": {
	          "DatasetArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteFaces": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionId",
	          "FaceIds"
	        ],
	        "members": {
	          "CollectionId": {},
	          "FaceIds": {
	            "shape": "S2g"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeletedFaces": {
	            "shape": "S2g"
	          }
	        }
	      }
	    },
	    "DeleteProject": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProjectArn"
	        ],
	        "members": {
	          "ProjectArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {}
	        }
	      }
	    },
	    "DeleteProjectVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProjectVersionArn"
	        ],
	        "members": {
	          "ProjectVersionArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {}
	        }
	      }
	    },
	    "DeleteStreamProcessor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeCollection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionId"
	        ],
	        "members": {
	          "CollectionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FaceCount": {
	            "type": "long"
	          },
	          "FaceModelVersion": {},
	          "CollectionARN": {},
	          "CreationTimestamp": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeDataset": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetArn"
	        ],
	        "members": {
	          "DatasetArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetDescription": {
	            "type": "structure",
	            "members": {
	              "CreationTimestamp": {
	                "type": "timestamp"
	              },
	              "LastUpdatedTimestamp": {
	                "type": "timestamp"
	              },
	              "Status": {},
	              "StatusMessage": {},
	              "StatusMessageCode": {},
	              "DatasetStats": {
	                "type": "structure",
	                "members": {
	                  "LabeledEntries": {
	                    "type": "integer"
	                  },
	                  "TotalEntries": {
	                    "type": "integer"
	                  },
	                  "TotalLabels": {
	                    "type": "integer"
	                  },
	                  "ErrorEntries": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeProjectVersions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProjectArn"
	        ],
	        "members": {
	          "ProjectArn": {},
	          "VersionNames": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProjectVersionDescriptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ProjectVersionArn": {},
	                "CreationTimestamp": {
	                  "type": "timestamp"
	                },
	                "MinInferenceUnits": {
	                  "type": "integer"
	                },
	                "Status": {},
	                "StatusMessage": {},
	                "BillableTrainingTimeInSeconds": {
	                  "type": "long"
	                },
	                "TrainingEndTimestamp": {
	                  "type": "timestamp"
	                },
	                "OutputConfig": {
	                  "shape": "S1e"
	                },
	                "TrainingDataResult": {
	                  "type": "structure",
	                  "members": {
	                    "Input": {
	                      "shape": "S1g"
	                    },
	                    "Output": {
	                      "shape": "S1g"
	                    },
	                    "Validation": {
	                      "shape": "S3b"
	                    }
	                  }
	                },
	                "TestingDataResult": {
	                  "type": "structure",
	                  "members": {
	                    "Input": {
	                      "shape": "S1j"
	                    },
	                    "Output": {
	                      "shape": "S1j"
	                    },
	                    "Validation": {
	                      "shape": "S3b"
	                    }
	                  }
	                },
	                "EvaluationResult": {
	                  "type": "structure",
	                  "members": {
	                    "F1Score": {
	                      "type": "float"
	                    },
	                    "Summary": {
	                      "type": "structure",
	                      "members": {
	                        "S3Object": {
	                          "shape": "S4"
	                        }
	                      }
	                    }
	                  }
	                },
	                "ManifestSummary": {
	                  "shape": "S14"
	                },
	                "KmsKeyId": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeProjects": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "ProjectNames": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProjectDescriptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ProjectArn": {},
	                "CreationTimestamp": {
	                  "type": "timestamp"
	                },
	                "Status": {},
	                "Datasets": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "CreationTimestamp": {
	                        "type": "timestamp"
	                      },
	                      "DatasetType": {},
	                      "DatasetArn": {},
	                      "Status": {},
	                      "StatusMessage": {},
	                      "StatusMessageCode": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeStreamProcessor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "StreamProcessorArn": {},
	          "Status": {},
	          "StatusMessage": {},
	          "CreationTimestamp": {
	            "type": "timestamp"
	          },
	          "LastUpdateTimestamp": {
	            "type": "timestamp"
	          },
	          "Input": {
	            "shape": "S1o"
	          },
	          "Output": {
	            "shape": "S1r"
	          },
	          "RoleArn": {},
	          "Settings": {
	            "shape": "S1w"
	          },
	          "NotificationChannel": {
	            "shape": "S22"
	          },
	          "KmsKeyId": {},
	          "RegionsOfInterest": {
	            "shape": "S24"
	          },
	          "DataSharingPreference": {
	            "shape": "S28"
	          }
	        }
	      }
	    },
	    "DetectCustomLabels": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProjectVersionArn",
	          "Image"
	        ],
	        "members": {
	          "ProjectVersionArn": {},
	          "Image": {
	            "shape": "S2"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "MinConfidence": {
	            "type": "float"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CustomLabels": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Confidence": {
	                  "type": "float"
	                },
	                "Geometry": {
	                  "shape": "S3u"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DetectFaces": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Image"
	        ],
	        "members": {
	          "Image": {
	            "shape": "S2"
	          },
	          "Attributes": {
	            "shape": "S3w"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FaceDetails": {
	            "type": "list",
	            "member": {
	              "shape": "S40"
	            }
	          },
	          "OrientationCorrection": {}
	        }
	      }
	    },
	    "DetectLabels": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Image"
	        ],
	        "members": {
	          "Image": {
	            "shape": "S2"
	          },
	          "MaxLabels": {
	            "type": "integer"
	          },
	          "MinConfidence": {
	            "type": "float"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Labels": {
	            "type": "list",
	            "member": {
	              "shape": "S4d"
	            }
	          },
	          "OrientationCorrection": {},
	          "LabelModelVersion": {}
	        }
	      }
	    },
	    "DetectModerationLabels": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Image"
	        ],
	        "members": {
	          "Image": {
	            "shape": "S2"
	          },
	          "MinConfidence": {
	            "type": "float"
	          },
	          "HumanLoopConfig": {
	            "type": "structure",
	            "required": [
	              "HumanLoopName",
	              "FlowDefinitionArn"
	            ],
	            "members": {
	              "HumanLoopName": {},
	              "FlowDefinitionArn": {},
	              "DataAttributes": {
	                "type": "structure",
	                "members": {
	                  "ContentClassifiers": {
	                    "type": "list",
	                    "member": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ModerationLabels": {
	            "type": "list",
	            "member": {
	              "shape": "S4r"
	            }
	          },
	          "ModerationModelVersion": {},
	          "HumanLoopActivationOutput": {
	            "type": "structure",
	            "members": {
	              "HumanLoopArn": {},
	              "HumanLoopActivationReasons": {
	                "type": "list",
	                "member": {}
	              },
	              "HumanLoopActivationConditionsEvaluationResults": {
	                "jsonvalue": true
	              }
	            }
	          }
	        }
	      }
	    },
	    "DetectProtectiveEquipment": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Image"
	        ],
	        "members": {
	          "Image": {
	            "shape": "S2"
	          },
	          "SummarizationAttributes": {
	            "type": "structure",
	            "required": [
	              "MinConfidence",
	              "RequiredEquipmentTypes"
	            ],
	            "members": {
	              "MinConfidence": {
	                "type": "float"
	              },
	              "RequiredEquipmentTypes": {
	                "type": "list",
	                "member": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProtectiveEquipmentModelVersion": {},
	          "Persons": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "BodyParts": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Name": {},
	                      "Confidence": {
	                        "type": "float"
	                      },
	                      "EquipmentDetections": {
	                        "type": "list",
	                        "member": {
	                          "type": "structure",
	                          "members": {
	                            "BoundingBox": {
	                              "shape": "Sc"
	                            },
	                            "Confidence": {
	                              "type": "float"
	                            },
	                            "Type": {},
	                            "CoversBodyPart": {
	                              "type": "structure",
	                              "members": {
	                                "Confidence": {
	                                  "type": "float"
	                                },
	                                "Value": {
	                                  "type": "boolean"
	                                }
	                              }
	                            }
	                          }
	                        }
	                      }
	                    }
	                  }
	                },
	                "BoundingBox": {
	                  "shape": "Sc"
	                },
	                "Confidence": {
	                  "type": "float"
	                },
	                "Id": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "Summary": {
	            "type": "structure",
	            "members": {
	              "PersonsWithRequiredEquipment": {
	                "shape": "S5b"
	              },
	              "PersonsWithoutRequiredEquipment": {
	                "shape": "S5b"
	              },
	              "PersonsIndeterminate": {
	                "shape": "S5b"
	              }
	            }
	          }
	        }
	      }
	    },
	    "DetectText": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Image"
	        ],
	        "members": {
	          "Image": {
	            "shape": "S2"
	          },
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "WordFilter": {
	                "shape": "S5e"
	              },
	              "RegionsOfInterest": {
	                "shape": "S24"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TextDetections": {
	            "type": "list",
	            "member": {
	              "shape": "S5j"
	            }
	          },
	          "TextModelVersion": {}
	        }
	      }
	    },
	    "DistributeDatasetEntries": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Datasets"
	        ],
	        "members": {
	          "Datasets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Arn"
	              ],
	              "members": {
	                "Arn": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "GetCelebrityInfo": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Urls": {
	            "shape": "S5s"
	          },
	          "Name": {},
	          "KnownGender": {
	            "shape": "S5u"
	          }
	        }
	      }
	    },
	    "GetCelebrityRecognition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "SortBy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobStatus": {},
	          "StatusMessage": {},
	          "VideoMetadata": {
	            "shape": "S63"
	          },
	          "NextToken": {},
	          "Celebrities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Timestamp": {
	                  "type": "long"
	                },
	                "Celebrity": {
	                  "type": "structure",
	                  "members": {
	                    "Urls": {
	                      "shape": "S5s"
	                    },
	                    "Name": {},
	                    "Id": {},
	                    "Confidence": {
	                      "type": "float"
	                    },
	                    "BoundingBox": {
	                      "shape": "Sc"
	                    },
	                    "Face": {
	                      "shape": "S40"
	                    },
	                    "KnownGender": {
	                      "shape": "S5u"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetContentModeration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "SortBy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobStatus": {},
	          "StatusMessage": {},
	          "VideoMetadata": {
	            "shape": "S63"
	          },
	          "ModerationLabels": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Timestamp": {
	                  "type": "long"
	                },
	                "ModerationLabel": {
	                  "shape": "S4r"
	                }
	              }
	            }
	          },
	          "NextToken": {},
	          "ModerationModelVersion": {}
	        }
	      }
	    },
	    "GetFaceDetection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobStatus": {},
	          "StatusMessage": {},
	          "VideoMetadata": {
	            "shape": "S63"
	          },
	          "NextToken": {},
	          "Faces": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Timestamp": {
	                  "type": "long"
	                },
	                "Face": {
	                  "shape": "S40"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetFaceSearch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "SortBy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobStatus": {},
	          "StatusMessage": {},
	          "NextToken": {},
	          "VideoMetadata": {
	            "shape": "S63"
	          },
	          "Persons": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Timestamp": {
	                  "type": "long"
	                },
	                "Person": {
	                  "shape": "S6n"
	                },
	                "FaceMatches": {
	                  "shape": "S6p"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetLabelDetection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "SortBy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobStatus": {},
	          "StatusMessage": {},
	          "VideoMetadata": {
	            "shape": "S63"
	          },
	          "NextToken": {},
	          "Labels": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Timestamp": {
	                  "type": "long"
	                },
	                "Label": {
	                  "shape": "S4d"
	                }
	              }
	            }
	          },
	          "LabelModelVersion": {}
	        }
	      }
	    },
	    "GetPersonTracking": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "SortBy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobStatus": {},
	          "StatusMessage": {},
	          "VideoMetadata": {
	            "shape": "S63"
	          },
	          "NextToken": {},
	          "Persons": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Timestamp": {
	                  "type": "long"
	                },
	                "Person": {
	                  "shape": "S6n"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetSegmentDetection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobStatus": {},
	          "StatusMessage": {},
	          "VideoMetadata": {
	            "type": "list",
	            "member": {
	              "shape": "S63"
	            }
	          },
	          "AudioMetadata": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Codec": {},
	                "DurationMillis": {
	                  "type": "long"
	                },
	                "SampleRate": {
	                  "type": "long"
	                },
	                "NumberOfChannels": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "NextToken": {},
	          "Segments": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Type": {},
	                "StartTimestampMillis": {
	                  "type": "long"
	                },
	                "EndTimestampMillis": {
	                  "type": "long"
	                },
	                "DurationMillis": {
	                  "type": "long"
	                },
	                "StartTimecodeSMPTE": {},
	                "EndTimecodeSMPTE": {},
	                "DurationSMPTE": {},
	                "TechnicalCueSegment": {
	                  "type": "structure",
	                  "members": {
	                    "Type": {},
	                    "Confidence": {
	                      "type": "float"
	                    }
	                  }
	                },
	                "ShotSegment": {
	                  "type": "structure",
	                  "members": {
	                    "Index": {
	                      "type": "long"
	                    },
	                    "Confidence": {
	                      "type": "float"
	                    }
	                  }
	                },
	                "StartFrameNumber": {
	                  "type": "long"
	                },
	                "EndFrameNumber": {
	                  "type": "long"
	                },
	                "DurationFrames": {
	                  "type": "long"
	                }
	              }
	            }
	          },
	          "SelectedSegmentTypes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Type": {},
	                "ModelVersion": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetTextDetection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobStatus": {},
	          "StatusMessage": {},
	          "VideoMetadata": {
	            "shape": "S63"
	          },
	          "TextDetections": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Timestamp": {
	                  "type": "long"
	                },
	                "TextDetection": {
	                  "shape": "S5j"
	                }
	              }
	            }
	          },
	          "NextToken": {},
	          "TextModelVersion": {}
	        }
	      }
	    },
	    "IndexFaces": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionId",
	          "Image"
	        ],
	        "members": {
	          "CollectionId": {},
	          "Image": {
	            "shape": "S2"
	          },
	          "ExternalImageId": {},
	          "DetectionAttributes": {
	            "shape": "S3w"
	          },
	          "MaxFaces": {
	            "type": "integer"
	          },
	          "QualityFilter": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FaceRecords": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Face": {
	                  "shape": "S6r"
	                },
	                "FaceDetail": {
	                  "shape": "S40"
	                }
	              }
	            }
	          },
	          "OrientationCorrection": {},
	          "FaceModelVersion": {},
	          "UnindexedFaces": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Reasons": {
	                  "type": "list",
	                  "member": {}
	                },
	                "FaceDetail": {
	                  "shape": "S40"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListCollections": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CollectionIds": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {},
	          "FaceModelVersions": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "ListDatasetEntries": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetArn"
	        ],
	        "members": {
	          "DatasetArn": {},
	          "ContainsLabels": {
	            "type": "list",
	            "member": {}
	          },
	          "Labeled": {
	            "type": "boolean"
	          },
	          "SourceRefContains": {},
	          "HasErrors": {
	            "type": "boolean"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetEntries": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListDatasetLabels": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetArn"
	        ],
	        "members": {
	          "DatasetArn": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DatasetLabelDescriptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "LabelName": {},
	                "LabelStats": {
	                  "type": "structure",
	                  "members": {
	                    "EntryCount": {
	                      "type": "integer"
	                    },
	                    "BoundingBoxCount": {
	                      "type": "integer"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListFaces": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionId"
	        ],
	        "members": {
	          "CollectionId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Faces": {
	            "type": "list",
	            "member": {
	              "shape": "S6r"
	            }
	          },
	          "NextToken": {},
	          "FaceModelVersion": {}
	        }
	      }
	    },
	    "ListStreamProcessors": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "StreamProcessors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Status": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "Sw"
	          }
	        }
	      }
	    },
	    "RecognizeCelebrities": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Image"
	        ],
	        "members": {
	          "Image": {
	            "shape": "S2"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CelebrityFaces": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Urls": {
	                  "shape": "S5s"
	                },
	                "Name": {},
	                "Id": {},
	                "Face": {
	                  "shape": "Sg"
	                },
	                "MatchConfidence": {
	                  "type": "float"
	                },
	                "KnownGender": {
	                  "shape": "S5u"
	                }
	              }
	            }
	          },
	          "UnrecognizedFaces": {
	            "type": "list",
	            "member": {
	              "shape": "Sg"
	            }
	          },
	          "OrientationCorrection": {}
	        }
	      }
	    },
	    "SearchFaces": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionId",
	          "FaceId"
	        ],
	        "members": {
	          "CollectionId": {},
	          "FaceId": {},
	          "MaxFaces": {
	            "type": "integer"
	          },
	          "FaceMatchThreshold": {
	            "type": "float"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SearchedFaceId": {},
	          "FaceMatches": {
	            "shape": "S6p"
	          },
	          "FaceModelVersion": {}
	        }
	      }
	    },
	    "SearchFacesByImage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionId",
	          "Image"
	        ],
	        "members": {
	          "CollectionId": {},
	          "Image": {
	            "shape": "S2"
	          },
	          "MaxFaces": {
	            "type": "integer"
	          },
	          "FaceMatchThreshold": {
	            "type": "float"
	          },
	          "QualityFilter": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SearchedFaceBoundingBox": {
	            "shape": "Sc"
	          },
	          "SearchedFaceConfidence": {
	            "type": "float"
	          },
	          "FaceMatches": {
	            "shape": "S6p"
	          },
	          "FaceModelVersion": {}
	        }
	      }
	    },
	    "StartCelebrityRecognition": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Video"
	        ],
	        "members": {
	          "Video": {
	            "shape": "S93"
	          },
	          "ClientRequestToken": {},
	          "NotificationChannel": {
	            "shape": "S95"
	          },
	          "JobTag": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StartContentModeration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Video"
	        ],
	        "members": {
	          "Video": {
	            "shape": "S93"
	          },
	          "MinConfidence": {
	            "type": "float"
	          },
	          "ClientRequestToken": {},
	          "NotificationChannel": {
	            "shape": "S95"
	          },
	          "JobTag": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StartFaceDetection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Video"
	        ],
	        "members": {
	          "Video": {
	            "shape": "S93"
	          },
	          "ClientRequestToken": {},
	          "NotificationChannel": {
	            "shape": "S95"
	          },
	          "FaceAttributes": {},
	          "JobTag": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StartFaceSearch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Video",
	          "CollectionId"
	        ],
	        "members": {
	          "Video": {
	            "shape": "S93"
	          },
	          "ClientRequestToken": {},
	          "FaceMatchThreshold": {
	            "type": "float"
	          },
	          "CollectionId": {},
	          "NotificationChannel": {
	            "shape": "S95"
	          },
	          "JobTag": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StartLabelDetection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Video"
	        ],
	        "members": {
	          "Video": {
	            "shape": "S93"
	          },
	          "ClientRequestToken": {},
	          "MinConfidence": {
	            "type": "float"
	          },
	          "NotificationChannel": {
	            "shape": "S95"
	          },
	          "JobTag": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StartPersonTracking": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Video"
	        ],
	        "members": {
	          "Video": {
	            "shape": "S93"
	          },
	          "ClientRequestToken": {},
	          "NotificationChannel": {
	            "shape": "S95"
	          },
	          "JobTag": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StartProjectVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProjectVersionArn",
	          "MinInferenceUnits"
	        ],
	        "members": {
	          "ProjectVersionArn": {},
	          "MinInferenceUnits": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {}
	        }
	      }
	    },
	    "StartSegmentDetection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Video",
	          "SegmentTypes"
	        ],
	        "members": {
	          "Video": {
	            "shape": "S93"
	          },
	          "ClientRequestToken": {},
	          "NotificationChannel": {
	            "shape": "S95"
	          },
	          "JobTag": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "TechnicalCueFilter": {
	                "type": "structure",
	                "members": {
	                  "MinSegmentConfidence": {
	                    "type": "float"
	                  },
	                  "BlackFrame": {
	                    "type": "structure",
	                    "members": {
	                      "MaxPixelThreshold": {
	                        "type": "float"
	                      },
	                      "MinCoveragePercentage": {
	                        "type": "float"
	                      }
	                    }
	                  }
	                }
	              },
	              "ShotFilter": {
	                "type": "structure",
	                "members": {
	                  "MinSegmentConfidence": {
	                    "type": "float"
	                  }
	                }
	              }
	            }
	          },
	          "SegmentTypes": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StartStreamProcessor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "StartSelector": {
	            "type": "structure",
	            "members": {
	              "KVSStreamStartSelector": {
	                "type": "structure",
	                "members": {
	                  "ProducerTimestamp": {
	                    "type": "long"
	                  },
	                  "FragmentNumber": {}
	                }
	              }
	            }
	          },
	          "StopSelector": {
	            "type": "structure",
	            "members": {
	              "MaxDurationInSeconds": {
	                "type": "long"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SessionId": {}
	        }
	      }
	    },
	    "StartTextDetection": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Video"
	        ],
	        "members": {
	          "Video": {
	            "shape": "S93"
	          },
	          "ClientRequestToken": {},
	          "NotificationChannel": {
	            "shape": "S95"
	          },
	          "JobTag": {},
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "WordFilter": {
	                "shape": "S5e"
	              },
	              "RegionsOfInterest": {
	                "shape": "S24"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {}
	        }
	      },
	      "idempotent": true
	    },
	    "StopProjectVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProjectVersionArn"
	        ],
	        "members": {
	          "ProjectVersionArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {}
	        }
	      }
	    },
	    "StopStreamProcessor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateDatasetEntries": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DatasetArn",
	          "Changes"
	        ],
	        "members": {
	          "DatasetArn": {},
	          "Changes": {
	            "type": "structure",
	            "required": [
	              "GroundTruth"
	            ],
	            "members": {
	              "GroundTruth": {
	                "type": "blob"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateStreamProcessor": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "SettingsForUpdate": {
	            "type": "structure",
	            "members": {
	              "ConnectedHomeForUpdate": {
	                "type": "structure",
	                "members": {
	                  "Labels": {
	                    "shape": "S1z"
	                  },
	                  "MinConfidence": {
	                    "type": "float"
	                  }
	                }
	              }
	            }
	          },
	          "RegionsOfInterestForUpdate": {
	            "shape": "S24"
	          },
	          "DataSharingPreferenceForUpdate": {
	            "shape": "S28"
	          },
	          "ParametersToDelete": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "structure",
	      "members": {
	        "Bytes": {
	          "type": "blob"
	        },
	        "S3Object": {
	          "shape": "S4"
	        }
	      }
	    },
	    "S4": {
	      "type": "structure",
	      "members": {
	        "Bucket": {},
	        "Name": {},
	        "Version": {}
	      }
	    },
	    "Sc": {
	      "type": "structure",
	      "members": {
	        "Width": {
	          "type": "float"
	        },
	        "Height": {
	          "type": "float"
	        },
	        "Left": {
	          "type": "float"
	        },
	        "Top": {
	          "type": "float"
	        }
	      }
	    },
	    "Sg": {
	      "type": "structure",
	      "members": {
	        "BoundingBox": {
	          "shape": "Sc"
	        },
	        "Confidence": {
	          "type": "float"
	        },
	        "Landmarks": {
	          "shape": "Sh"
	        },
	        "Pose": {
	          "shape": "Sk"
	        },
	        "Quality": {
	          "shape": "Sm"
	        },
	        "Emotions": {
	          "shape": "Sn"
	        },
	        "Smile": {
	          "shape": "Sq"
	        }
	      }
	    },
	    "Sh": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "X": {
	            "type": "float"
	          },
	          "Y": {
	            "type": "float"
	          }
	        }
	      }
	    },
	    "Sk": {
	      "type": "structure",
	      "members": {
	        "Roll": {
	          "type": "float"
	        },
	        "Yaw": {
	          "type": "float"
	        },
	        "Pitch": {
	          "type": "float"
	        }
	      }
	    },
	    "Sm": {
	      "type": "structure",
	      "members": {
	        "Brightness": {
	          "type": "float"
	        },
	        "Sharpness": {
	          "type": "float"
	        }
	      }
	    },
	    "Sn": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "Confidence": {
	            "type": "float"
	          }
	        }
	      }
	    },
	    "Sq": {
	      "type": "structure",
	      "members": {
	        "Value": {
	          "type": "boolean"
	        },
	        "Confidence": {
	          "type": "float"
	        }
	      }
	    },
	    "Sw": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S14": {
	      "type": "structure",
	      "members": {
	        "S3Object": {
	          "shape": "S4"
	        }
	      }
	    },
	    "S1e": {
	      "type": "structure",
	      "members": {
	        "S3Bucket": {},
	        "S3KeyPrefix": {}
	      }
	    },
	    "S1g": {
	      "type": "structure",
	      "members": {
	        "Assets": {
	          "shape": "S1h"
	        }
	      }
	    },
	    "S1h": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "GroundTruthManifest": {
	            "shape": "S14"
	          }
	        }
	      }
	    },
	    "S1j": {
	      "type": "structure",
	      "members": {
	        "Assets": {
	          "shape": "S1h"
	        },
	        "AutoCreate": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S1o": {
	      "type": "structure",
	      "members": {
	        "KinesisVideoStream": {
	          "type": "structure",
	          "members": {
	            "Arn": {}
	          }
	        }
	      }
	    },
	    "S1r": {
	      "type": "structure",
	      "members": {
	        "KinesisDataStream": {
	          "type": "structure",
	          "members": {
	            "Arn": {}
	          }
	        },
	        "S3Destination": {
	          "type": "structure",
	          "members": {
	            "Bucket": {},
	            "KeyPrefix": {}
	          }
	        }
	      }
	    },
	    "S1w": {
	      "type": "structure",
	      "members": {
	        "FaceSearch": {
	          "type": "structure",
	          "members": {
	            "CollectionId": {},
	            "FaceMatchThreshold": {
	              "type": "float"
	            }
	          }
	        },
	        "ConnectedHome": {
	          "type": "structure",
	          "required": [
	            "Labels"
	          ],
	          "members": {
	            "Labels": {
	              "shape": "S1z"
	            },
	            "MinConfidence": {
	              "type": "float"
	            }
	          }
	        }
	      }
	    },
	    "S1z": {
	      "type": "list",
	      "member": {}
	    },
	    "S22": {
	      "type": "structure",
	      "required": [
	        "SNSTopicArn"
	      ],
	      "members": {
	        "SNSTopicArn": {}
	      }
	    },
	    "S24": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "BoundingBox": {
	            "shape": "Sc"
	          },
	          "Polygon": {
	            "shape": "S26"
	          }
	        }
	      }
	    },
	    "S26": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "X": {
	            "type": "float"
	          },
	          "Y": {
	            "type": "float"
	          }
	        }
	      }
	    },
	    "S28": {
	      "type": "structure",
	      "required": [
	        "OptIn"
	      ],
	      "members": {
	        "OptIn": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S2g": {
	      "type": "list",
	      "member": {}
	    },
	    "S3b": {
	      "type": "structure",
	      "members": {
	        "Assets": {
	          "shape": "S1h"
	        }
	      }
	    },
	    "S3u": {
	      "type": "structure",
	      "members": {
	        "BoundingBox": {
	          "shape": "Sc"
	        },
	        "Polygon": {
	          "shape": "S26"
	        }
	      }
	    },
	    "S3w": {
	      "type": "list",
	      "member": {}
	    },
	    "S40": {
	      "type": "structure",
	      "members": {
	        "BoundingBox": {
	          "shape": "Sc"
	        },
	        "AgeRange": {
	          "type": "structure",
	          "members": {
	            "Low": {
	              "type": "integer"
	            },
	            "High": {
	              "type": "integer"
	            }
	          }
	        },
	        "Smile": {
	          "shape": "Sq"
	        },
	        "Eyeglasses": {
	          "type": "structure",
	          "members": {
	            "Value": {
	              "type": "boolean"
	            },
	            "Confidence": {
	              "type": "float"
	            }
	          }
	        },
	        "Sunglasses": {
	          "type": "structure",
	          "members": {
	            "Value": {
	              "type": "boolean"
	            },
	            "Confidence": {
	              "type": "float"
	            }
	          }
	        },
	        "Gender": {
	          "type": "structure",
	          "members": {
	            "Value": {},
	            "Confidence": {
	              "type": "float"
	            }
	          }
	        },
	        "Beard": {
	          "type": "structure",
	          "members": {
	            "Value": {
	              "type": "boolean"
	            },
	            "Confidence": {
	              "type": "float"
	            }
	          }
	        },
	        "Mustache": {
	          "type": "structure",
	          "members": {
	            "Value": {
	              "type": "boolean"
	            },
	            "Confidence": {
	              "type": "float"
	            }
	          }
	        },
	        "EyesOpen": {
	          "type": "structure",
	          "members": {
	            "Value": {
	              "type": "boolean"
	            },
	            "Confidence": {
	              "type": "float"
	            }
	          }
	        },
	        "MouthOpen": {
	          "type": "structure",
	          "members": {
	            "Value": {
	              "type": "boolean"
	            },
	            "Confidence": {
	              "type": "float"
	            }
	          }
	        },
	        "Emotions": {
	          "shape": "Sn"
	        },
	        "Landmarks": {
	          "shape": "Sh"
	        },
	        "Pose": {
	          "shape": "Sk"
	        },
	        "Quality": {
	          "shape": "Sm"
	        },
	        "Confidence": {
	          "type": "float"
	        }
	      }
	    },
	    "S4d": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Confidence": {
	          "type": "float"
	        },
	        "Instances": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "BoundingBox": {
	                "shape": "Sc"
	              },
	              "Confidence": {
	                "type": "float"
	              }
	            }
	          }
	        },
	        "Parents": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Name": {}
	            }
	          }
	        }
	      }
	    },
	    "S4r": {
	      "type": "structure",
	      "members": {
	        "Confidence": {
	          "type": "float"
	        },
	        "Name": {},
	        "ParentName": {}
	      }
	    },
	    "S5b": {
	      "type": "list",
	      "member": {
	        "type": "integer"
	      }
	    },
	    "S5e": {
	      "type": "structure",
	      "members": {
	        "MinConfidence": {
	          "type": "float"
	        },
	        "MinBoundingBoxHeight": {
	          "type": "float"
	        },
	        "MinBoundingBoxWidth": {
	          "type": "float"
	        }
	      }
	    },
	    "S5j": {
	      "type": "structure",
	      "members": {
	        "DetectedText": {},
	        "Type": {},
	        "Id": {
	          "type": "integer"
	        },
	        "ParentId": {
	          "type": "integer"
	        },
	        "Confidence": {
	          "type": "float"
	        },
	        "Geometry": {
	          "shape": "S3u"
	        }
	      }
	    },
	    "S5s": {
	      "type": "list",
	      "member": {}
	    },
	    "S5u": {
	      "type": "structure",
	      "members": {
	        "Type": {}
	      }
	    },
	    "S63": {
	      "type": "structure",
	      "members": {
	        "Codec": {},
	        "DurationMillis": {
	          "type": "long"
	        },
	        "Format": {},
	        "FrameRate": {
	          "type": "float"
	        },
	        "FrameHeight": {
	          "type": "long"
	        },
	        "FrameWidth": {
	          "type": "long"
	        },
	        "ColorRange": {}
	      }
	    },
	    "S6n": {
	      "type": "structure",
	      "members": {
	        "Index": {
	          "type": "long"
	        },
	        "BoundingBox": {
	          "shape": "Sc"
	        },
	        "Face": {
	          "shape": "S40"
	        }
	      }
	    },
	    "S6p": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Similarity": {
	            "type": "float"
	          },
	          "Face": {
	            "shape": "S6r"
	          }
	        }
	      }
	    },
	    "S6r": {
	      "type": "structure",
	      "members": {
	        "FaceId": {},
	        "BoundingBox": {
	          "shape": "Sc"
	        },
	        "ImageId": {},
	        "ExternalImageId": {},
	        "Confidence": {
	          "type": "float"
	        },
	        "IndexFacesModelVersion": {}
	      }
	    },
	    "S93": {
	      "type": "structure",
	      "members": {
	        "S3Object": {
	          "shape": "S4"
	        }
	      }
	    },
	    "S95": {
	      "type": "structure",
	      "required": [
	        "SNSTopicArn",
	        "RoleArn"
	      ],
	      "members": {
	        "SNSTopicArn": {},
	        "RoleArn": {}
	      }
	    }
	  }
	}
	},{}],199:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeProjectVersions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ProjectVersionDescriptions"
	    },
	    "DescribeProjects": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ProjectDescriptions"
	    },
	    "GetCelebrityRecognition": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetContentModeration": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetFaceDetection": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetFaceSearch": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetLabelDetection": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetPersonTracking": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetSegmentDetection": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetTextDetection": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListCollections": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "CollectionIds"
	    },
	    "ListDatasetEntries": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "DatasetEntries"
	    },
	    "ListDatasetLabels": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "DatasetLabelDescriptions"
	    },
	    "ListFaces": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Faces"
	    },
	    "ListStreamProcessors": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    }
	  }
	}
	},{}],200:[function(require,module,exports){
	module.exports={
	    "version": 2,
	    "waiters": {
	        "ProjectVersionTrainingCompleted": {
	            "description": "Wait until the ProjectVersion training completes.",
	            "operation": "DescribeProjectVersions",
	            "delay": 120,
	            "maxAttempts": 360,
	            "acceptors": [
	                {
	                    "state": "success",
	                    "matcher": "pathAll",
	                    "argument": "ProjectVersionDescriptions[].Status",
	                    "expected": "TRAINING_COMPLETED"
	                },
	                {
	                    "state": "failure",
	                    "matcher": "pathAny",
	                    "argument": "ProjectVersionDescriptions[].Status",
	                    "expected": "TRAINING_FAILED"
	                }
	            ]
	        },
	        "ProjectVersionRunning": {
	            "description": "Wait until the ProjectVersion is running.",
	            "delay": 30,
	            "maxAttempts": 40,
	            "operation": "DescribeProjectVersions",
	            "acceptors": [
	                {
	                    "state": "success",
	                    "matcher": "pathAll",
	                    "argument": "ProjectVersionDescriptions[].Status",
	                    "expected": "RUNNING"
	                },
	                {
	                    "state": "failure",
	                    "matcher": "pathAny",
	                    "argument": "ProjectVersionDescriptions[].Status",
	                    "expected": "FAILED"
	                }
	            ]
	        }
	    }
	}
	
	},{}],201:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-11-27",
	    "endpointPrefix": "resource-groups",
	    "protocol": "rest-json",
	    "serviceAbbreviation": "Resource Groups",
	    "serviceFullName": "AWS Resource Groups",
	    "serviceId": "Resource Groups",
	    "signatureVersion": "v4",
	    "signingName": "resource-groups",
	    "uid": "resource-groups-2017-11-27"
	  },
	  "operations": {
	    "CreateGroup": {
	      "http": {
	        "requestUri": "/groups"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "ResourceQuery": {
	            "shape": "S4"
	          },
	          "Tags": {
	            "shape": "S7"
	          },
	          "Configuration": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Group": {
	            "shape": "Sj"
	          },
	          "ResourceQuery": {
	            "shape": "S4"
	          },
	          "Tags": {
	            "shape": "S7"
	          },
	          "GroupConfiguration": {
	            "shape": "Sl"
	          }
	        }
	      }
	    },
	    "DeleteGroup": {
	      "http": {
	        "requestUri": "/delete-group"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "GroupName": {
	            "deprecated": true,
	            "deprecatedMessage": "This field is deprecated, use Group instead."
	          },
	          "Group": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Group": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "GetGroup": {
	      "http": {
	        "requestUri": "/get-group"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "GroupName": {
	            "deprecated": true,
	            "deprecatedMessage": "This field is deprecated, use Group instead."
	          },
	          "Group": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Group": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "GetGroupConfiguration": {
	      "http": {
	        "requestUri": "/get-group-configuration"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Group": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GroupConfiguration": {
	            "shape": "Sl"
	          }
	        }
	      }
	    },
	    "GetGroupQuery": {
	      "http": {
	        "requestUri": "/get-group-query"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "GroupName": {
	            "deprecated": true,
	            "deprecatedMessage": "This field is deprecated, use Group instead."
	          },
	          "Group": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GroupQuery": {
	            "shape": "Sx"
	          }
	        }
	      }
	    },
	    "GetTags": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/resources/{Arn}/tags"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Arn"
	        ],
	        "members": {
	          "Arn": {
	            "location": "uri",
	            "locationName": "Arn"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Arn": {},
	          "Tags": {
	            "shape": "S7"
	          }
	        }
	      }
	    },
	    "GroupResources": {
	      "http": {
	        "requestUri": "/group-resources"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Group",
	          "ResourceArns"
	        ],
	        "members": {
	          "Group": {},
	          "ResourceArns": {
	            "shape": "S11"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Succeeded": {
	            "shape": "S11"
	          },
	          "Failed": {
	            "shape": "S14"
	          },
	          "Pending": {
	            "shape": "S18"
	          }
	        }
	      }
	    },
	    "ListGroupResources": {
	      "http": {
	        "requestUri": "/list-group-resources"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "GroupName": {
	            "deprecated": true,
	            "deprecatedMessage": "This field is deprecated, use Group instead."
	          },
	          "Group": {},
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Name",
	                "Values"
	              ],
	              "members": {
	                "Name": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Resources": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Identifier": {
	                  "shape": "S1l"
	                },
	                "Status": {
	                  "type": "structure",
	                  "members": {
	                    "Name": {}
	                  }
	                }
	              }
	            }
	          },
	          "ResourceIdentifiers": {
	            "shape": "S1p",
	            "deprecated": true,
	            "deprecatedMessage": "This field is deprecated, use Resources instead."
	          },
	          "NextToken": {},
	          "QueryErrors": {
	            "shape": "S1q"
	          }
	        }
	      }
	    },
	    "ListGroups": {
	      "http": {
	        "requestUri": "/groups-list"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Name",
	                "Values"
	              ],
	              "members": {
	                "Name": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxResults",
	            "type": "integer"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nextToken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GroupIdentifiers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "GroupName": {},
	                "GroupArn": {}
	              }
	            }
	          },
	          "Groups": {
	            "deprecated": true,
	            "deprecatedMessage": "This field is deprecated, use GroupIdentifiers instead.",
	            "type": "list",
	            "member": {
	              "shape": "Sj"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PutGroupConfiguration": {
	      "http": {
	        "requestUri": "/put-group-configuration",
	        "responseCode": 202
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Group": {},
	          "Configuration": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SearchResources": {
	      "http": {
	        "requestUri": "/resources/search"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceQuery"
	        ],
	        "members": {
	          "ResourceQuery": {
	            "shape": "S4"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceIdentifiers": {
	            "shape": "S1p"
	          },
	          "NextToken": {},
	          "QueryErrors": {
	            "shape": "S1q"
	          }
	        }
	      }
	    },
	    "Tag": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/resources/{Arn}/tags"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Arn",
	          "Tags"
	        ],
	        "members": {
	          "Arn": {
	            "location": "uri",
	            "locationName": "Arn"
	          },
	          "Tags": {
	            "shape": "S7"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Arn": {},
	          "Tags": {
	            "shape": "S7"
	          }
	        }
	      }
	    },
	    "UngroupResources": {
	      "http": {
	        "requestUri": "/ungroup-resources"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Group",
	          "ResourceArns"
	        ],
	        "members": {
	          "Group": {},
	          "ResourceArns": {
	            "shape": "S11"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Succeeded": {
	            "shape": "S11"
	          },
	          "Failed": {
	            "shape": "S14"
	          },
	          "Pending": {
	            "shape": "S18"
	          }
	        }
	      }
	    },
	    "Untag": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/resources/{Arn}/tags"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Arn",
	          "Keys"
	        ],
	        "members": {
	          "Arn": {
	            "location": "uri",
	            "locationName": "Arn"
	          },
	          "Keys": {
	            "shape": "S2d"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Arn": {},
	          "Keys": {
	            "shape": "S2d"
	          }
	        }
	      }
	    },
	    "UpdateGroup": {
	      "http": {
	        "requestUri": "/update-group"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "GroupName": {
	            "deprecated": true,
	            "deprecatedMessage": "This field is deprecated, use Group instead."
	          },
	          "Group": {},
	          "Description": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Group": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "UpdateGroupQuery": {
	      "http": {
	        "requestUri": "/update-group-query"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceQuery"
	        ],
	        "members": {
	          "GroupName": {
	            "deprecated": true,
	            "deprecatedMessage": "This field is deprecated, use Group instead."
	          },
	          "Group": {},
	          "ResourceQuery": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GroupQuery": {
	            "shape": "Sx"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "required": [
	        "Type",
	        "Query"
	      ],
	      "members": {
	        "Type": {},
	        "Query": {}
	      }
	    },
	    "S7": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sa": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Type"
	        ],
	        "members": {
	          "Type": {},
	          "Parameters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Name"
	              ],
	              "members": {
	                "Name": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sj": {
	      "type": "structure",
	      "required": [
	        "GroupArn",
	        "Name"
	      ],
	      "members": {
	        "GroupArn": {},
	        "Name": {},
	        "Description": {}
	      }
	    },
	    "Sl": {
	      "type": "structure",
	      "members": {
	        "Configuration": {
	          "shape": "Sa"
	        },
	        "ProposedConfiguration": {
	          "shape": "Sa"
	        },
	        "Status": {},
	        "FailureReason": {}
	      }
	    },
	    "Sx": {
	      "type": "structure",
	      "required": [
	        "GroupName",
	        "ResourceQuery"
	      ],
	      "members": {
	        "GroupName": {},
	        "ResourceQuery": {
	          "shape": "S4"
	        }
	      }
	    },
	    "S11": {
	      "type": "list",
	      "member": {}
	    },
	    "S14": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ResourceArn": {},
	          "ErrorMessage": {},
	          "ErrorCode": {}
	        }
	      }
	    },
	    "S18": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ResourceArn": {}
	        }
	      }
	    },
	    "S1l": {
	      "type": "structure",
	      "members": {
	        "ResourceArn": {},
	        "ResourceType": {}
	      }
	    },
	    "S1p": {
	      "type": "list",
	      "member": {
	        "shape": "S1l"
	      }
	    },
	    "S1q": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ErrorCode": {},
	          "Message": {}
	        }
	      }
	    },
	    "S2d": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],202:[function(require,module,exports){
	module.exports={"pagination":{"ListGroupResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":["ResourceIdentifiers","Resources"]},"ListGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"GroupIdentifiers"},"SearchResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResourceIdentifiers"}}}
	},{}],203:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2013-04-01",
	    "endpointPrefix": "route53",
	    "globalEndpoint": "route53.amazonaws.com",
	    "protocol": "rest-xml",
	    "serviceAbbreviation": "Route 53",
	    "serviceFullName": "Amazon Route 53",
	    "serviceId": "Route 53",
	    "signatureVersion": "v4",
	    "uid": "route53-2013-04-01"
	  },
	  "operations": {
	    "ActivateKeySigningKey": {
	      "http": {
	        "requestUri": "/2013-04-01/keysigningkey/{HostedZoneId}/{Name}/activate"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "Name"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "HostedZoneId"
	          },
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ChangeInfo"
	        ],
	        "members": {
	          "ChangeInfo": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "AssociateVPCWithHostedZone": {
	      "http": {
	        "requestUri": "/2013-04-01/hostedzone/{Id}/associatevpc"
	      },
	      "input": {
	        "locationName": "AssociateVPCWithHostedZoneRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "VPC"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "VPC": {
	            "shape": "Sa"
	          },
	          "Comment": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ChangeInfo"
	        ],
	        "members": {
	          "ChangeInfo": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "ChangeCidrCollection": {
	      "http": {
	        "requestUri": "/2013-04-01/cidrcollection/{CidrCollectionId}"
	      },
	      "input": {
	        "locationName": "ChangeCidrCollectionRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "Id",
	          "Changes"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "CidrCollectionId"
	          },
	          "CollectionVersion": {
	            "type": "long"
	          },
	          "Changes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "LocationName",
	                "Action",
	                "CidrList"
	              ],
	              "members": {
	                "LocationName": {},
	                "Action": {},
	                "CidrList": {
	                  "type": "list",
	                  "member": {
	                    "locationName": "Cidr"
	                  }
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {}
	        }
	      }
	    },
	    "ChangeResourceRecordSets": {
	      "http": {
	        "requestUri": "/2013-04-01/hostedzone/{Id}/rrset/"
	      },
	      "input": {
	        "locationName": "ChangeResourceRecordSetsRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "ChangeBatch"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "ChangeBatch": {
	            "type": "structure",
	            "required": [
	              "Changes"
	            ],
	            "members": {
	              "Comment": {},
	              "Changes": {
	                "type": "list",
	                "member": {
	                  "locationName": "Change",
	                  "type": "structure",
	                  "required": [
	                    "Action",
	                    "ResourceRecordSet"
	                  ],
	                  "members": {
	                    "Action": {},
	                    "ResourceRecordSet": {
	                      "shape": "Sv"
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ChangeInfo"
	        ],
	        "members": {
	          "ChangeInfo": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "ChangeTagsForResource": {
	      "http": {
	        "requestUri": "/2013-04-01/tags/{ResourceType}/{ResourceId}"
	      },
	      "input": {
	        "locationName": "ChangeTagsForResourceRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "ResourceType",
	          "ResourceId"
	        ],
	        "members": {
	          "ResourceType": {
	            "location": "uri",
	            "locationName": "ResourceType"
	          },
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          },
	          "AddTags": {
	            "shape": "S1l"
	          },
	          "RemoveTagKeys": {
	            "type": "list",
	            "member": {
	              "locationName": "Key"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateCidrCollection": {
	      "http": {
	        "requestUri": "/2013-04-01/cidrcollection",
	        "responseCode": 201
	      },
	      "input": {
	        "locationName": "CreateCidrCollectionRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "Name",
	          "CallerReference"
	        ],
	        "members": {
	          "Name": {},
	          "CallerReference": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Collection": {
	            "type": "structure",
	            "members": {
	              "Arn": {},
	              "Id": {},
	              "Name": {},
	              "Version": {
	                "type": "long"
	              }
	            }
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          }
	        }
	      }
	    },
	    "CreateHealthCheck": {
	      "http": {
	        "requestUri": "/2013-04-01/healthcheck",
	        "responseCode": 201
	      },
	      "input": {
	        "locationName": "CreateHealthCheckRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "CallerReference",
	          "HealthCheckConfig"
	        ],
	        "members": {
	          "CallerReference": {},
	          "HealthCheckConfig": {
	            "shape": "S20"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HealthCheck",
	          "Location"
	        ],
	        "members": {
	          "HealthCheck": {
	            "shape": "S2n"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          }
	        }
	      }
	    },
	    "CreateHostedZone": {
	      "http": {
	        "requestUri": "/2013-04-01/hostedzone",
	        "responseCode": 201
	      },
	      "input": {
	        "locationName": "CreateHostedZoneRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "Name",
	          "CallerReference"
	        ],
	        "members": {
	          "Name": {},
	          "VPC": {
	            "shape": "Sa"
	          },
	          "CallerReference": {},
	          "HostedZoneConfig": {
	            "shape": "S34"
	          },
	          "DelegationSetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HostedZone",
	          "ChangeInfo",
	          "DelegationSet",
	          "Location"
	        ],
	        "members": {
	          "HostedZone": {
	            "shape": "S37"
	          },
	          "ChangeInfo": {
	            "shape": "S5"
	          },
	          "DelegationSet": {
	            "shape": "S39"
	          },
	          "VPC": {
	            "shape": "Sa"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          }
	        }
	      }
	    },
	    "CreateKeySigningKey": {
	      "http": {
	        "requestUri": "/2013-04-01/keysigningkey",
	        "responseCode": 201
	      },
	      "input": {
	        "locationName": "CreateKeySigningKeyRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "CallerReference",
	          "HostedZoneId",
	          "KeyManagementServiceArn",
	          "Name",
	          "Status"
	        ],
	        "members": {
	          "CallerReference": {},
	          "HostedZoneId": {},
	          "KeyManagementServiceArn": {},
	          "Name": {},
	          "Status": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ChangeInfo",
	          "KeySigningKey",
	          "Location"
	        ],
	        "members": {
	          "ChangeInfo": {
	            "shape": "S5"
	          },
	          "KeySigningKey": {
	            "shape": "S3f"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          }
	        }
	      }
	    },
	    "CreateQueryLoggingConfig": {
	      "http": {
	        "requestUri": "/2013-04-01/queryloggingconfig",
	        "responseCode": 201
	      },
	      "input": {
	        "locationName": "CreateQueryLoggingConfigRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "CloudWatchLogsLogGroupArn"
	        ],
	        "members": {
	          "HostedZoneId": {},
	          "CloudWatchLogsLogGroupArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "QueryLoggingConfig",
	          "Location"
	        ],
	        "members": {
	          "QueryLoggingConfig": {
	            "shape": "S3m"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          }
	        }
	      }
	    },
	    "CreateReusableDelegationSet": {
	      "http": {
	        "requestUri": "/2013-04-01/delegationset",
	        "responseCode": 201
	      },
	      "input": {
	        "locationName": "CreateReusableDelegationSetRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "CallerReference"
	        ],
	        "members": {
	          "CallerReference": {},
	          "HostedZoneId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "DelegationSet",
	          "Location"
	        ],
	        "members": {
	          "DelegationSet": {
	            "shape": "S39"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          }
	        }
	      }
	    },
	    "CreateTrafficPolicy": {
	      "http": {
	        "requestUri": "/2013-04-01/trafficpolicy",
	        "responseCode": 201
	      },
	      "input": {
	        "locationName": "CreateTrafficPolicyRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "Name",
	          "Document"
	        ],
	        "members": {
	          "Name": {},
	          "Document": {},
	          "Comment": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicy",
	          "Location"
	        ],
	        "members": {
	          "TrafficPolicy": {
	            "shape": "S3v"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          }
	        }
	      }
	    },
	    "CreateTrafficPolicyInstance": {
	      "http": {
	        "requestUri": "/2013-04-01/trafficpolicyinstance",
	        "responseCode": 201
	      },
	      "input": {
	        "locationName": "CreateTrafficPolicyInstanceRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "Name",
	          "TTL",
	          "TrafficPolicyId",
	          "TrafficPolicyVersion"
	        ],
	        "members": {
	          "HostedZoneId": {},
	          "Name": {},
	          "TTL": {
	            "type": "long"
	          },
	          "TrafficPolicyId": {},
	          "TrafficPolicyVersion": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicyInstance",
	          "Location"
	        ],
	        "members": {
	          "TrafficPolicyInstance": {
	            "shape": "S40"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          }
	        }
	      }
	    },
	    "CreateTrafficPolicyVersion": {
	      "http": {
	        "requestUri": "/2013-04-01/trafficpolicy/{Id}",
	        "responseCode": 201
	      },
	      "input": {
	        "locationName": "CreateTrafficPolicyVersionRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "Id",
	          "Document"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "Document": {},
	          "Comment": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicy",
	          "Location"
	        ],
	        "members": {
	          "TrafficPolicy": {
	            "shape": "S3v"
	          },
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          }
	        }
	      }
	    },
	    "CreateVPCAssociationAuthorization": {
	      "http": {
	        "requestUri": "/2013-04-01/hostedzone/{Id}/authorizevpcassociation"
	      },
	      "input": {
	        "locationName": "CreateVPCAssociationAuthorizationRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "VPC"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "VPC": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "VPC"
	        ],
	        "members": {
	          "HostedZoneId": {},
	          "VPC": {
	            "shape": "Sa"
	          }
	        }
	      }
	    },
	    "DeactivateKeySigningKey": {
	      "http": {
	        "requestUri": "/2013-04-01/keysigningkey/{HostedZoneId}/{Name}/deactivate"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "Name"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "HostedZoneId"
	          },
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ChangeInfo"
	        ],
	        "members": {
	          "ChangeInfo": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "DeleteCidrCollection": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2013-04-01/cidrcollection/{CidrCollectionId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "CidrCollectionId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteHealthCheck": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HealthCheckId"
	        ],
	        "members": {
	          "HealthCheckId": {
	            "location": "uri",
	            "locationName": "HealthCheckId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteHostedZone": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2013-04-01/hostedzone/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ChangeInfo"
	        ],
	        "members": {
	          "ChangeInfo": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "DeleteKeySigningKey": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2013-04-01/keysigningkey/{HostedZoneId}/{Name}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "Name"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "HostedZoneId"
	          },
	          "Name": {
	            "location": "uri",
	            "locationName": "Name"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ChangeInfo"
	        ],
	        "members": {
	          "ChangeInfo": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "DeleteQueryLoggingConfig": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2013-04-01/queryloggingconfig/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteReusableDelegationSet": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2013-04-01/delegationset/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteTrafficPolicy": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id",
	          "Version"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "Version": {
	            "location": "uri",
	            "locationName": "Version",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteTrafficPolicyInstance": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteVPCAssociationAuthorization": {
	      "http": {
	        "requestUri": "/2013-04-01/hostedzone/{Id}/deauthorizevpcassociation"
	      },
	      "input": {
	        "locationName": "DeleteVPCAssociationAuthorizationRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "VPC"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "VPC": {
	            "shape": "Sa"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DisableHostedZoneDNSSEC": {
	      "http": {
	        "requestUri": "/2013-04-01/hostedzone/{Id}/disable-dnssec"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ChangeInfo"
	        ],
	        "members": {
	          "ChangeInfo": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "DisassociateVPCFromHostedZone": {
	      "http": {
	        "requestUri": "/2013-04-01/hostedzone/{Id}/disassociatevpc"
	      },
	      "input": {
	        "locationName": "DisassociateVPCFromHostedZoneRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "VPC"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "VPC": {
	            "shape": "Sa"
	          },
	          "Comment": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ChangeInfo"
	        ],
	        "members": {
	          "ChangeInfo": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "EnableHostedZoneDNSSEC": {
	      "http": {
	        "requestUri": "/2013-04-01/hostedzone/{Id}/enable-dnssec"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ChangeInfo"
	        ],
	        "members": {
	          "ChangeInfo": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "GetAccountLimit": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/accountlimit/{Type}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Type"
	        ],
	        "members": {
	          "Type": {
	            "location": "uri",
	            "locationName": "Type"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Limit",
	          "Count"
	        ],
	        "members": {
	          "Limit": {
	            "type": "structure",
	            "required": [
	              "Type",
	              "Value"
	            ],
	            "members": {
	              "Type": {},
	              "Value": {
	                "type": "long"
	              }
	            }
	          },
	          "Count": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "GetChange": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/change/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ChangeInfo"
	        ],
	        "members": {
	          "ChangeInfo": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "GetCheckerIpRanges": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/checkeripranges"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "CheckerIpRanges"
	        ],
	        "members": {
	          "CheckerIpRanges": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "GetDNSSEC": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/hostedzone/{Id}/dnssec"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Status",
	          "KeySigningKeys"
	        ],
	        "members": {
	          "Status": {
	            "type": "structure",
	            "members": {
	              "ServeSignature": {},
	              "StatusMessage": {}
	            }
	          },
	          "KeySigningKeys": {
	            "type": "list",
	            "member": {
	              "shape": "S3f"
	            }
	          }
	        }
	      }
	    },
	    "GetGeoLocation": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/geolocation"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "ContinentCode": {
	            "location": "querystring",
	            "locationName": "continentcode"
	          },
	          "CountryCode": {
	            "location": "querystring",
	            "locationName": "countrycode"
	          },
	          "SubdivisionCode": {
	            "location": "querystring",
	            "locationName": "subdivisioncode"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "GeoLocationDetails"
	        ],
	        "members": {
	          "GeoLocationDetails": {
	            "shape": "S5h"
	          }
	        }
	      }
	    },
	    "GetHealthCheck": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HealthCheckId"
	        ],
	        "members": {
	          "HealthCheckId": {
	            "location": "uri",
	            "locationName": "HealthCheckId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HealthCheck"
	        ],
	        "members": {
	          "HealthCheck": {
	            "shape": "S2n"
	          }
	        }
	      }
	    },
	    "GetHealthCheckCount": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/healthcheckcount"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HealthCheckCount"
	        ],
	        "members": {
	          "HealthCheckCount": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "GetHealthCheckLastFailureReason": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/healthcheck/{HealthCheckId}/lastfailurereason"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HealthCheckId"
	        ],
	        "members": {
	          "HealthCheckId": {
	            "location": "uri",
	            "locationName": "HealthCheckId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HealthCheckObservations"
	        ],
	        "members": {
	          "HealthCheckObservations": {
	            "shape": "S5s"
	          }
	        }
	      }
	    },
	    "GetHealthCheckStatus": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/healthcheck/{HealthCheckId}/status"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HealthCheckId"
	        ],
	        "members": {
	          "HealthCheckId": {
	            "location": "uri",
	            "locationName": "HealthCheckId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HealthCheckObservations"
	        ],
	        "members": {
	          "HealthCheckObservations": {
	            "shape": "S5s"
	          }
	        }
	      }
	    },
	    "GetHostedZone": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/hostedzone/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HostedZone"
	        ],
	        "members": {
	          "HostedZone": {
	            "shape": "S37"
	          },
	          "DelegationSet": {
	            "shape": "S39"
	          },
	          "VPCs": {
	            "shape": "S60"
	          }
	        }
	      }
	    },
	    "GetHostedZoneCount": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/hostedzonecount"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HostedZoneCount"
	        ],
	        "members": {
	          "HostedZoneCount": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "GetHostedZoneLimit": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/hostedzonelimit/{Id}/{Type}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Type",
	          "HostedZoneId"
	        ],
	        "members": {
	          "Type": {
	            "location": "uri",
	            "locationName": "Type"
	          },
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Limit",
	          "Count"
	        ],
	        "members": {
	          "Limit": {
	            "type": "structure",
	            "required": [
	              "Type",
	              "Value"
	            ],
	            "members": {
	              "Type": {},
	              "Value": {
	                "type": "long"
	              }
	            }
	          },
	          "Count": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "GetQueryLoggingConfig": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/queryloggingconfig/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "QueryLoggingConfig"
	        ],
	        "members": {
	          "QueryLoggingConfig": {
	            "shape": "S3m"
	          }
	        }
	      }
	    },
	    "GetReusableDelegationSet": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/delegationset/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "DelegationSet"
	        ],
	        "members": {
	          "DelegationSet": {
	            "shape": "S39"
	          }
	        }
	      }
	    },
	    "GetReusableDelegationSetLimit": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/reusabledelegationsetlimit/{Id}/{Type}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Type",
	          "DelegationSetId"
	        ],
	        "members": {
	          "Type": {
	            "location": "uri",
	            "locationName": "Type"
	          },
	          "DelegationSetId": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Limit",
	          "Count"
	        ],
	        "members": {
	          "Limit": {
	            "type": "structure",
	            "required": [
	              "Type",
	              "Value"
	            ],
	            "members": {
	              "Type": {},
	              "Value": {
	                "type": "long"
	              }
	            }
	          },
	          "Count": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "GetTrafficPolicy": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id",
	          "Version"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "Version": {
	            "location": "uri",
	            "locationName": "Version",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicy"
	        ],
	        "members": {
	          "TrafficPolicy": {
	            "shape": "S3v"
	          }
	        }
	      }
	    },
	    "GetTrafficPolicyInstance": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicyInstance"
	        ],
	        "members": {
	          "TrafficPolicyInstance": {
	            "shape": "S40"
	          }
	        }
	      }
	    },
	    "GetTrafficPolicyInstanceCount": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/trafficpolicyinstancecount"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicyInstanceCount"
	        ],
	        "members": {
	          "TrafficPolicyInstanceCount": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "ListCidrBlocks": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/cidrcollection/{CidrCollectionId}/cidrblocks"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionId"
	        ],
	        "members": {
	          "CollectionId": {
	            "location": "uri",
	            "locationName": "CidrCollectionId"
	          },
	          "LocationName": {
	            "location": "querystring",
	            "locationName": "location"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nexttoken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxresults"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "CidrBlocks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "CidrBlock": {},
	                "LocationName": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListCidrCollections": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/cidrcollection"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nexttoken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxresults"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "CidrCollections": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Arn": {},
	                "Id": {},
	                "Name": {},
	                "Version": {
	                  "type": "long"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListCidrLocations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/cidrcollection/{CidrCollectionId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "CollectionId"
	        ],
	        "members": {
	          "CollectionId": {
	            "location": "uri",
	            "locationName": "CidrCollectionId"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nexttoken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxresults"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "CidrLocations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "LocationName": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListGeoLocations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/geolocations"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "StartContinentCode": {
	            "location": "querystring",
	            "locationName": "startcontinentcode"
	          },
	          "StartCountryCode": {
	            "location": "querystring",
	            "locationName": "startcountrycode"
	          },
	          "StartSubdivisionCode": {
	            "location": "querystring",
	            "locationName": "startsubdivisioncode"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "GeoLocationDetailsList",
	          "IsTruncated",
	          "MaxItems"
	        ],
	        "members": {
	          "GeoLocationDetailsList": {
	            "type": "list",
	            "member": {
	              "shape": "S5h",
	              "locationName": "GeoLocationDetails"
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "NextContinentCode": {},
	          "NextCountryCode": {},
	          "NextSubdivisionCode": {},
	          "MaxItems": {}
	        }
	      }
	    },
	    "ListHealthChecks": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/healthcheck"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HealthChecks",
	          "Marker",
	          "IsTruncated",
	          "MaxItems"
	        ],
	        "members": {
	          "HealthChecks": {
	            "type": "list",
	            "member": {
	              "shape": "S2n",
	              "locationName": "HealthCheck"
	            }
	          },
	          "Marker": {},
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "NextMarker": {},
	          "MaxItems": {}
	        }
	      }
	    },
	    "ListHostedZones": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/hostedzone"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          },
	          "DelegationSetId": {
	            "location": "querystring",
	            "locationName": "delegationsetid"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HostedZones",
	          "Marker",
	          "IsTruncated",
	          "MaxItems"
	        ],
	        "members": {
	          "HostedZones": {
	            "shape": "S7c"
	          },
	          "Marker": {},
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "NextMarker": {},
	          "MaxItems": {}
	        }
	      }
	    },
	    "ListHostedZonesByName": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/hostedzonesbyname"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "DNSName": {
	            "location": "querystring",
	            "locationName": "dnsname"
	          },
	          "HostedZoneId": {
	            "location": "querystring",
	            "locationName": "hostedzoneid"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HostedZones",
	          "IsTruncated",
	          "MaxItems"
	        ],
	        "members": {
	          "HostedZones": {
	            "shape": "S7c"
	          },
	          "DNSName": {},
	          "HostedZoneId": {},
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "NextDNSName": {},
	          "NextHostedZoneId": {},
	          "MaxItems": {}
	        }
	      }
	    },
	    "ListHostedZonesByVPC": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/hostedzonesbyvpc"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "VPCId",
	          "VPCRegion"
	        ],
	        "members": {
	          "VPCId": {
	            "location": "querystring",
	            "locationName": "vpcid"
	          },
	          "VPCRegion": {
	            "location": "querystring",
	            "locationName": "vpcregion"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nexttoken"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HostedZoneSummaries",
	          "MaxItems"
	        ],
	        "members": {
	          "HostedZoneSummaries": {
	            "type": "list",
	            "member": {
	              "locationName": "HostedZoneSummary",
	              "type": "structure",
	              "required": [
	                "HostedZoneId",
	                "Name",
	                "Owner"
	              ],
	              "members": {
	                "HostedZoneId": {},
	                "Name": {},
	                "Owner": {
	                  "type": "structure",
	                  "members": {
	                    "OwningAccount": {},
	                    "OwningService": {}
	                  }
	                }
	              }
	            }
	          },
	          "MaxItems": {},
	          "NextToken": {}
	        }
	      }
	    },
	    "ListQueryLoggingConfigs": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/queryloggingconfig"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "HostedZoneId": {
	            "location": "querystring",
	            "locationName": "hostedzoneid"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nexttoken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxresults"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "QueryLoggingConfigs"
	        ],
	        "members": {
	          "QueryLoggingConfigs": {
	            "type": "list",
	            "member": {
	              "shape": "S3m",
	              "locationName": "QueryLoggingConfig"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListResourceRecordSets": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/hostedzone/{Id}/rrset"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "StartRecordName": {
	            "location": "querystring",
	            "locationName": "name"
	          },
	          "StartRecordType": {
	            "location": "querystring",
	            "locationName": "type"
	          },
	          "StartRecordIdentifier": {
	            "location": "querystring",
	            "locationName": "identifier"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResourceRecordSets",
	          "IsTruncated",
	          "MaxItems"
	        ],
	        "members": {
	          "ResourceRecordSets": {
	            "type": "list",
	            "member": {
	              "shape": "Sv",
	              "locationName": "ResourceRecordSet"
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "NextRecordName": {},
	          "NextRecordType": {},
	          "NextRecordIdentifier": {},
	          "MaxItems": {}
	        }
	      }
	    },
	    "ListReusableDelegationSets": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/delegationset"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "DelegationSets",
	          "Marker",
	          "IsTruncated",
	          "MaxItems"
	        ],
	        "members": {
	          "DelegationSets": {
	            "type": "list",
	            "member": {
	              "shape": "S39",
	              "locationName": "DelegationSet"
	            }
	          },
	          "Marker": {},
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "NextMarker": {},
	          "MaxItems": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/tags/{ResourceType}/{ResourceId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceType",
	          "ResourceId"
	        ],
	        "members": {
	          "ResourceType": {
	            "location": "uri",
	            "locationName": "ResourceType"
	          },
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResourceTagSet"
	        ],
	        "members": {
	          "ResourceTagSet": {
	            "shape": "S7x"
	          }
	        }
	      }
	    },
	    "ListTagsForResources": {
	      "http": {
	        "requestUri": "/2013-04-01/tags/{ResourceType}"
	      },
	      "input": {
	        "locationName": "ListTagsForResourcesRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "ResourceType",
	          "ResourceIds"
	        ],
	        "members": {
	          "ResourceType": {
	            "location": "uri",
	            "locationName": "ResourceType"
	          },
	          "ResourceIds": {
	            "type": "list",
	            "member": {
	              "locationName": "ResourceId"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "ResourceTagSets"
	        ],
	        "members": {
	          "ResourceTagSets": {
	            "type": "list",
	            "member": {
	              "shape": "S7x",
	              "locationName": "ResourceTagSet"
	            }
	          }
	        }
	      }
	    },
	    "ListTrafficPolicies": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/trafficpolicies"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "TrafficPolicyIdMarker": {
	            "location": "querystring",
	            "locationName": "trafficpolicyid"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicySummaries",
	          "IsTruncated",
	          "TrafficPolicyIdMarker",
	          "MaxItems"
	        ],
	        "members": {
	          "TrafficPolicySummaries": {
	            "type": "list",
	            "member": {
	              "locationName": "TrafficPolicySummary",
	              "type": "structure",
	              "required": [
	                "Id",
	                "Name",
	                "Type",
	                "LatestVersion",
	                "TrafficPolicyCount"
	              ],
	              "members": {
	                "Id": {},
	                "Name": {},
	                "Type": {},
	                "LatestVersion": {
	                  "type": "integer"
	                },
	                "TrafficPolicyCount": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "TrafficPolicyIdMarker": {},
	          "MaxItems": {}
	        }
	      }
	    },
	    "ListTrafficPolicyInstances": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/trafficpolicyinstances"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "HostedZoneIdMarker": {
	            "location": "querystring",
	            "locationName": "hostedzoneid"
	          },
	          "TrafficPolicyInstanceNameMarker": {
	            "location": "querystring",
	            "locationName": "trafficpolicyinstancename"
	          },
	          "TrafficPolicyInstanceTypeMarker": {
	            "location": "querystring",
	            "locationName": "trafficpolicyinstancetype"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicyInstances",
	          "IsTruncated",
	          "MaxItems"
	        ],
	        "members": {
	          "TrafficPolicyInstances": {
	            "shape": "S88"
	          },
	          "HostedZoneIdMarker": {},
	          "TrafficPolicyInstanceNameMarker": {},
	          "TrafficPolicyInstanceTypeMarker": {},
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "MaxItems": {}
	        }
	      }
	    },
	    "ListTrafficPolicyInstancesByHostedZone": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/trafficpolicyinstances/hostedzone"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "TrafficPolicyInstanceNameMarker": {
	            "location": "querystring",
	            "locationName": "trafficpolicyinstancename"
	          },
	          "TrafficPolicyInstanceTypeMarker": {
	            "location": "querystring",
	            "locationName": "trafficpolicyinstancetype"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicyInstances",
	          "IsTruncated",
	          "MaxItems"
	        ],
	        "members": {
	          "TrafficPolicyInstances": {
	            "shape": "S88"
	          },
	          "TrafficPolicyInstanceNameMarker": {},
	          "TrafficPolicyInstanceTypeMarker": {},
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "MaxItems": {}
	        }
	      }
	    },
	    "ListTrafficPolicyInstancesByPolicy": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/trafficpolicyinstances/trafficpolicy"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicyId",
	          "TrafficPolicyVersion"
	        ],
	        "members": {
	          "TrafficPolicyId": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "TrafficPolicyVersion": {
	            "location": "querystring",
	            "locationName": "version",
	            "type": "integer"
	          },
	          "HostedZoneIdMarker": {
	            "location": "querystring",
	            "locationName": "hostedzoneid"
	          },
	          "TrafficPolicyInstanceNameMarker": {
	            "location": "querystring",
	            "locationName": "trafficpolicyinstancename"
	          },
	          "TrafficPolicyInstanceTypeMarker": {
	            "location": "querystring",
	            "locationName": "trafficpolicyinstancetype"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicyInstances",
	          "IsTruncated",
	          "MaxItems"
	        ],
	        "members": {
	          "TrafficPolicyInstances": {
	            "shape": "S88"
	          },
	          "HostedZoneIdMarker": {},
	          "TrafficPolicyInstanceNameMarker": {},
	          "TrafficPolicyInstanceTypeMarker": {},
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "MaxItems": {}
	        }
	      }
	    },
	    "ListTrafficPolicyVersions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/trafficpolicies/{Id}/versions"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "TrafficPolicyVersionMarker": {
	            "location": "querystring",
	            "locationName": "trafficpolicyversion"
	          },
	          "MaxItems": {
	            "location": "querystring",
	            "locationName": "maxitems"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicies",
	          "IsTruncated",
	          "TrafficPolicyVersionMarker",
	          "MaxItems"
	        ],
	        "members": {
	          "TrafficPolicies": {
	            "type": "list",
	            "member": {
	              "shape": "S3v",
	              "locationName": "TrafficPolicy"
	            }
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "TrafficPolicyVersionMarker": {},
	          "MaxItems": {}
	        }
	      }
	    },
	    "ListVPCAssociationAuthorizations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/hostedzone/{Id}/authorizevpcassociation"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "NextToken": {
	            "location": "querystring",
	            "locationName": "nexttoken"
	          },
	          "MaxResults": {
	            "location": "querystring",
	            "locationName": "maxresults"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "VPCs"
	        ],
	        "members": {
	          "HostedZoneId": {},
	          "NextToken": {},
	          "VPCs": {
	            "shape": "S60"
	          }
	        }
	      }
	    },
	    "TestDNSAnswer": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/2013-04-01/testdnsanswer"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "HostedZoneId",
	          "RecordName",
	          "RecordType"
	        ],
	        "members": {
	          "HostedZoneId": {
	            "location": "querystring",
	            "locationName": "hostedzoneid"
	          },
	          "RecordName": {
	            "location": "querystring",
	            "locationName": "recordname"
	          },
	          "RecordType": {
	            "location": "querystring",
	            "locationName": "recordtype"
	          },
	          "ResolverIP": {
	            "location": "querystring",
	            "locationName": "resolverip"
	          },
	          "EDNS0ClientSubnetIP": {
	            "location": "querystring",
	            "locationName": "edns0clientsubnetip"
	          },
	          "EDNS0ClientSubnetMask": {
	            "location": "querystring",
	            "locationName": "edns0clientsubnetmask"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Nameserver",
	          "RecordName",
	          "RecordType",
	          "RecordData",
	          "ResponseCode",
	          "Protocol"
	        ],
	        "members": {
	          "Nameserver": {},
	          "RecordName": {},
	          "RecordType": {},
	          "RecordData": {
	            "type": "list",
	            "member": {
	              "locationName": "RecordDataEntry"
	            }
	          },
	          "ResponseCode": {},
	          "Protocol": {}
	        }
	      }
	    },
	    "UpdateHealthCheck": {
	      "http": {
	        "requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
	      },
	      "input": {
	        "locationName": "UpdateHealthCheckRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "HealthCheckId"
	        ],
	        "members": {
	          "HealthCheckId": {
	            "location": "uri",
	            "locationName": "HealthCheckId"
	          },
	          "HealthCheckVersion": {
	            "type": "long"
	          },
	          "IPAddress": {},
	          "Port": {
	            "type": "integer"
	          },
	          "ResourcePath": {},
	          "FullyQualifiedDomainName": {},
	          "SearchString": {},
	          "FailureThreshold": {
	            "type": "integer"
	          },
	          "Inverted": {
	            "type": "boolean"
	          },
	          "Disabled": {
	            "type": "boolean"
	          },
	          "HealthThreshold": {
	            "type": "integer"
	          },
	          "ChildHealthChecks": {
	            "shape": "S2d"
	          },
	          "EnableSNI": {
	            "type": "boolean"
	          },
	          "Regions": {
	            "shape": "S2f"
	          },
	          "AlarmIdentifier": {
	            "shape": "S2h"
	          },
	          "InsufficientDataHealthStatus": {},
	          "ResetElements": {
	            "type": "list",
	            "member": {
	              "locationName": "ResettableElementName"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HealthCheck"
	        ],
	        "members": {
	          "HealthCheck": {
	            "shape": "S2n"
	          }
	        }
	      }
	    },
	    "UpdateHostedZoneComment": {
	      "http": {
	        "requestUri": "/2013-04-01/hostedzone/{Id}"
	      },
	      "input": {
	        "locationName": "UpdateHostedZoneCommentRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "Comment": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "HostedZone"
	        ],
	        "members": {
	          "HostedZone": {
	            "shape": "S37"
	          }
	        }
	      }
	    },
	    "UpdateTrafficPolicyComment": {
	      "http": {
	        "requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
	      },
	      "input": {
	        "locationName": "UpdateTrafficPolicyCommentRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "Id",
	          "Version",
	          "Comment"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "Version": {
	            "location": "uri",
	            "locationName": "Version",
	            "type": "integer"
	          },
	          "Comment": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicy"
	        ],
	        "members": {
	          "TrafficPolicy": {
	            "shape": "S3v"
	          }
	        }
	      }
	    },
	    "UpdateTrafficPolicyInstance": {
	      "http": {
	        "requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
	      },
	      "input": {
	        "locationName": "UpdateTrafficPolicyInstanceRequest",
	        "xmlNamespace": {
	          "uri": "https://route53.amazonaws.com/doc/2013-04-01/"
	        },
	        "type": "structure",
	        "required": [
	          "Id",
	          "TTL",
	          "TrafficPolicyId",
	          "TrafficPolicyVersion"
	        ],
	        "members": {
	          "Id": {
	            "location": "uri",
	            "locationName": "Id"
	          },
	          "TTL": {
	            "type": "long"
	          },
	          "TrafficPolicyId": {},
	          "TrafficPolicyVersion": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TrafficPolicyInstance"
	        ],
	        "members": {
	          "TrafficPolicyInstance": {
	            "shape": "S40"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S5": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "Status",
	        "SubmittedAt"
	      ],
	      "members": {
	        "Id": {},
	        "Status": {},
	        "SubmittedAt": {
	          "type": "timestamp"
	        },
	        "Comment": {}
	      }
	    },
	    "Sa": {
	      "type": "structure",
	      "members": {
	        "VPCRegion": {},
	        "VPCId": {}
	      }
	    },
	    "Sv": {
	      "type": "structure",
	      "required": [
	        "Name",
	        "Type"
	      ],
	      "members": {
	        "Name": {},
	        "Type": {},
	        "SetIdentifier": {},
	        "Weight": {
	          "type": "long"
	        },
	        "Region": {},
	        "GeoLocation": {
	          "type": "structure",
	          "members": {
	            "ContinentCode": {},
	            "CountryCode": {},
	            "SubdivisionCode": {}
	          }
	        },
	        "Failover": {},
	        "MultiValueAnswer": {
	          "type": "boolean"
	        },
	        "TTL": {
	          "type": "long"
	        },
	        "ResourceRecords": {
	          "type": "list",
	          "member": {
	            "locationName": "ResourceRecord",
	            "type": "structure",
	            "required": [
	              "Value"
	            ],
	            "members": {
	              "Value": {}
	            }
	          }
	        },
	        "AliasTarget": {
	          "type": "structure",
	          "required": [
	            "HostedZoneId",
	            "DNSName",
	            "EvaluateTargetHealth"
	          ],
	          "members": {
	            "HostedZoneId": {},
	            "DNSName": {},
	            "EvaluateTargetHealth": {
	              "type": "boolean"
	            }
	          }
	        },
	        "HealthCheckId": {},
	        "TrafficPolicyInstanceId": {},
	        "CidrRoutingConfig": {
	          "type": "structure",
	          "required": [
	            "CollectionId",
	            "LocationName"
	          ],
	          "members": {
	            "CollectionId": {},
	            "LocationName": {}
	          }
	        }
	      }
	    },
	    "S1l": {
	      "type": "list",
	      "member": {
	        "locationName": "Tag",
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S20": {
	      "type": "structure",
	      "required": [
	        "Type"
	      ],
	      "members": {
	        "IPAddress": {},
	        "Port": {
	          "type": "integer"
	        },
	        "Type": {},
	        "ResourcePath": {},
	        "FullyQualifiedDomainName": {},
	        "SearchString": {},
	        "RequestInterval": {
	          "type": "integer"
	        },
	        "FailureThreshold": {
	          "type": "integer"
	        },
	        "MeasureLatency": {
	          "type": "boolean"
	        },
	        "Inverted": {
	          "type": "boolean"
	        },
	        "Disabled": {
	          "type": "boolean"
	        },
	        "HealthThreshold": {
	          "type": "integer"
	        },
	        "ChildHealthChecks": {
	          "shape": "S2d"
	        },
	        "EnableSNI": {
	          "type": "boolean"
	        },
	        "Regions": {
	          "shape": "S2f"
	        },
	        "AlarmIdentifier": {
	          "shape": "S2h"
	        },
	        "InsufficientDataHealthStatus": {},
	        "RoutingControlArn": {}
	      }
	    },
	    "S2d": {
	      "type": "list",
	      "member": {
	        "locationName": "ChildHealthCheck"
	      }
	    },
	    "S2f": {
	      "type": "list",
	      "member": {
	        "locationName": "Region"
	      }
	    },
	    "S2h": {
	      "type": "structure",
	      "required": [
	        "Region",
	        "Name"
	      ],
	      "members": {
	        "Region": {},
	        "Name": {}
	      }
	    },
	    "S2n": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "CallerReference",
	        "HealthCheckConfig",
	        "HealthCheckVersion"
	      ],
	      "members": {
	        "Id": {},
	        "CallerReference": {},
	        "LinkedService": {
	          "shape": "S2o"
	        },
	        "HealthCheckConfig": {
	          "shape": "S20"
	        },
	        "HealthCheckVersion": {
	          "type": "long"
	        },
	        "CloudWatchAlarmConfiguration": {
	          "type": "structure",
	          "required": [
	            "EvaluationPeriods",
	            "Threshold",
	            "ComparisonOperator",
	            "Period",
	            "MetricName",
	            "Namespace",
	            "Statistic"
	          ],
	          "members": {
	            "EvaluationPeriods": {
	              "type": "integer"
	            },
	            "Threshold": {
	              "type": "double"
	            },
	            "ComparisonOperator": {},
	            "Period": {
	              "type": "integer"
	            },
	            "MetricName": {},
	            "Namespace": {},
	            "Statistic": {},
	            "Dimensions": {
	              "type": "list",
	              "member": {
	                "locationName": "Dimension",
	                "type": "structure",
	                "required": [
	                  "Name",
	                  "Value"
	                ],
	                "members": {
	                  "Name": {},
	                  "Value": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S2o": {
	      "type": "structure",
	      "members": {
	        "ServicePrincipal": {},
	        "Description": {}
	      }
	    },
	    "S34": {
	      "type": "structure",
	      "members": {
	        "Comment": {},
	        "PrivateZone": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S37": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "Name",
	        "CallerReference"
	      ],
	      "members": {
	        "Id": {},
	        "Name": {},
	        "CallerReference": {},
	        "Config": {
	          "shape": "S34"
	        },
	        "ResourceRecordSetCount": {
	          "type": "long"
	        },
	        "LinkedService": {
	          "shape": "S2o"
	        }
	      }
	    },
	    "S39": {
	      "type": "structure",
	      "required": [
	        "NameServers"
	      ],
	      "members": {
	        "Id": {},
	        "CallerReference": {},
	        "NameServers": {
	          "type": "list",
	          "member": {
	            "locationName": "NameServer"
	          }
	        }
	      }
	    },
	    "S3f": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "KmsArn": {},
	        "Flag": {
	          "type": "integer"
	        },
	        "SigningAlgorithmMnemonic": {},
	        "SigningAlgorithmType": {
	          "type": "integer"
	        },
	        "DigestAlgorithmMnemonic": {},
	        "DigestAlgorithmType": {
	          "type": "integer"
	        },
	        "KeyTag": {
	          "type": "integer"
	        },
	        "DigestValue": {},
	        "PublicKey": {},
	        "DSRecord": {},
	        "DNSKEYRecord": {},
	        "Status": {},
	        "StatusMessage": {},
	        "CreatedDate": {
	          "type": "timestamp"
	        },
	        "LastModifiedDate": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S3m": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "HostedZoneId",
	        "CloudWatchLogsLogGroupArn"
	      ],
	      "members": {
	        "Id": {},
	        "HostedZoneId": {},
	        "CloudWatchLogsLogGroupArn": {}
	      }
	    },
	    "S3v": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "Version",
	        "Name",
	        "Type",
	        "Document"
	      ],
	      "members": {
	        "Id": {},
	        "Version": {
	          "type": "integer"
	        },
	        "Name": {},
	        "Type": {},
	        "Document": {},
	        "Comment": {}
	      }
	    },
	    "S40": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "HostedZoneId",
	        "Name",
	        "TTL",
	        "State",
	        "Message",
	        "TrafficPolicyId",
	        "TrafficPolicyVersion",
	        "TrafficPolicyType"
	      ],
	      "members": {
	        "Id": {},
	        "HostedZoneId": {},
	        "Name": {},
	        "TTL": {
	          "type": "long"
	        },
	        "State": {},
	        "Message": {},
	        "TrafficPolicyId": {},
	        "TrafficPolicyVersion": {
	          "type": "integer"
	        },
	        "TrafficPolicyType": {}
	      }
	    },
	    "S5h": {
	      "type": "structure",
	      "members": {
	        "ContinentCode": {},
	        "ContinentName": {},
	        "CountryCode": {},
	        "CountryName": {},
	        "SubdivisionCode": {},
	        "SubdivisionName": {}
	      }
	    },
	    "S5s": {
	      "type": "list",
	      "member": {
	        "locationName": "HealthCheckObservation",
	        "type": "structure",
	        "members": {
	          "Region": {},
	          "IPAddress": {},
	          "StatusReport": {
	            "type": "structure",
	            "members": {
	              "Status": {},
	              "CheckedTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S60": {
	      "type": "list",
	      "member": {
	        "shape": "Sa",
	        "locationName": "VPC"
	      }
	    },
	    "S7c": {
	      "type": "list",
	      "member": {
	        "shape": "S37",
	        "locationName": "HostedZone"
	      }
	    },
	    "S7x": {
	      "type": "structure",
	      "members": {
	        "ResourceType": {},
	        "ResourceId": {},
	        "Tags": {
	          "shape": "S1l"
	        }
	      }
	    },
	    "S88": {
	      "type": "list",
	      "member": {
	        "shape": "S40",
	        "locationName": "TrafficPolicyInstance"
	      }
	    }
	  }
	}
	},{}],204:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListCidrBlocks": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "CidrBlocks"
	    },
	    "ListCidrCollections": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "CidrCollections"
	    },
	    "ListCidrLocations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "CidrLocations"
	    },
	    "ListHealthChecks": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "NextMarker",
	      "result_key": "HealthChecks"
	    },
	    "ListHostedZones": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": "NextMarker",
	      "result_key": "HostedZones"
	    },
	    "ListQueryLoggingConfigs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "QueryLoggingConfigs"
	    },
	    "ListResourceRecordSets": {
	      "input_token": [
	        "StartRecordName",
	        "StartRecordType",
	        "StartRecordIdentifier"
	      ],
	      "limit_key": "MaxItems",
	      "more_results": "IsTruncated",
	      "output_token": [
	        "NextRecordName",
	        "NextRecordType",
	        "NextRecordIdentifier"
	      ],
	      "result_key": "ResourceRecordSets"
	    }
	  }
	}
	},{}],205:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "ResourceRecordSetsChanged": {
	      "delay": 30,
	      "maxAttempts": 60,
	      "operation": "GetChange",
	      "acceptors": [
	        {
	          "matcher": "path",
	          "expected": "INSYNC",
	          "argument": "ChangeInfo.Status",
	          "state": "success"
	        }
	      ]
	    }
	  }
	}
	
	},{}],206:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-05-15",
	    "endpointPrefix": "route53domains",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Route 53 Domains",
	    "serviceId": "Route 53 Domains",
	    "signatureVersion": "v4",
	    "targetPrefix": "Route53Domains_v20140515",
	    "uid": "route53domains-2014-05-15"
	  },
	  "operations": {
	    "AcceptDomainTransferFromAnotherAwsAccount": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName",
	          "Password"
	        ],
	        "members": {
	          "DomainName": {},
	          "Password": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "CancelDomainTransferToAnotherAwsAccount": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "CheckDomainAvailability": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {},
	          "IdnLangCode": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Availability"
	        ],
	        "members": {
	          "Availability": {}
	        }
	      }
	    },
	    "CheckDomainTransferability": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {},
	          "AuthCode": {
	            "shape": "Sd"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Transferability"
	        ],
	        "members": {
	          "Transferability": {
	            "type": "structure",
	            "members": {
	              "Transferable": {}
	            }
	          }
	        }
	      }
	    },
	    "DeleteDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "DeleteTagsForDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName",
	          "TagsToDelete"
	        ],
	        "members": {
	          "DomainName": {},
	          "TagsToDelete": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DisableDomainAutoRenew": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DisableDomainTransferLock": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "OperationId"
	        ],
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "EnableDomainAutoRenew": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "EnableDomainTransferLock": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "OperationId"
	        ],
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "GetContactReachabilityStatus": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "domainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "domainName": {},
	          "status": {}
	        }
	      }
	    },
	    "GetDomainDetail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "DomainName",
	          "Nameservers",
	          "AdminContact",
	          "RegistrantContact",
	          "TechContact"
	        ],
	        "members": {
	          "DomainName": {},
	          "Nameservers": {
	            "shape": "S10"
	          },
	          "AutoRenew": {
	            "type": "boolean"
	          },
	          "AdminContact": {
	            "shape": "S16"
	          },
	          "RegistrantContact": {
	            "shape": "S16"
	          },
	          "TechContact": {
	            "shape": "S16"
	          },
	          "AdminPrivacy": {
	            "type": "boolean"
	          },
	          "RegistrantPrivacy": {
	            "type": "boolean"
	          },
	          "TechPrivacy": {
	            "type": "boolean"
	          },
	          "RegistrarName": {},
	          "WhoIsServer": {},
	          "RegistrarUrl": {},
	          "AbuseContactEmail": {},
	          "AbuseContactPhone": {},
	          "RegistryDomainId": {},
	          "CreationDate": {
	            "type": "timestamp"
	          },
	          "UpdatedDate": {
	            "type": "timestamp"
	          },
	          "ExpirationDate": {
	            "type": "timestamp"
	          },
	          "Reseller": {},
	          "DnsSec": {},
	          "StatusList": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "GetDomainSuggestions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName",
	          "SuggestionCount",
	          "OnlyAvailable"
	        ],
	        "members": {
	          "DomainName": {},
	          "SuggestionCount": {
	            "type": "integer"
	          },
	          "OnlyAvailable": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SuggestionsList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DomainName": {},
	                "Availability": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetOperationDetail": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OperationId"
	        ],
	        "members": {
	          "OperationId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OperationId": {},
	          "Status": {},
	          "Message": {},
	          "DomainName": {},
	          "Type": {},
	          "SubmittedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "ListDomains": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "FilterConditions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Name",
	                "Operator",
	                "Values"
	              ],
	              "members": {
	                "Name": {},
	                "Operator": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "SortCondition": {
	            "type": "structure",
	            "required": [
	              "Name",
	              "SortOrder"
	            ],
	            "members": {
	              "Name": {},
	              "SortOrder": {}
	            }
	          },
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Domains"
	        ],
	        "members": {
	          "Domains": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "DomainName"
	              ],
	              "members": {
	                "DomainName": {},
	                "AutoRenew": {
	                  "type": "boolean"
	                },
	                "TransferLock": {
	                  "type": "boolean"
	                },
	                "Expiry": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextPageMarker": {}
	        }
	      }
	    },
	    "ListOperations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SubmittedSince": {
	            "type": "timestamp"
	          },
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Operations"
	        ],
	        "members": {
	          "Operations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "OperationId",
	                "Status",
	                "Type",
	                "SubmittedDate"
	              ],
	              "members": {
	                "OperationId": {},
	                "Status": {},
	                "Type": {},
	                "SubmittedDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextPageMarker": {}
	        }
	      }
	    },
	    "ListPrices": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Tld": {},
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "Prices"
	        ],
	        "members": {
	          "Prices": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "RegistrationPrice": {
	                  "shape": "S2r"
	                },
	                "TransferPrice": {
	                  "shape": "S2r"
	                },
	                "RenewalPrice": {
	                  "shape": "S2r"
	                },
	                "ChangeOwnershipPrice": {
	                  "shape": "S2r"
	                },
	                "RestorationPrice": {
	                  "shape": "S2r"
	                }
	              }
	            }
	          },
	          "NextPageMarker": {}
	        }
	      }
	    },
	    "ListTagsForDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TagList"
	        ],
	        "members": {
	          "TagList": {
	            "shape": "S2w"
	          }
	        }
	      }
	    },
	    "RegisterDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName",
	          "DurationInYears",
	          "AdminContact",
	          "RegistrantContact",
	          "TechContact"
	        ],
	        "members": {
	          "DomainName": {},
	          "IdnLangCode": {},
	          "DurationInYears": {
	            "type": "integer"
	          },
	          "AutoRenew": {
	            "type": "boolean"
	          },
	          "AdminContact": {
	            "shape": "S16"
	          },
	          "RegistrantContact": {
	            "shape": "S16"
	          },
	          "TechContact": {
	            "shape": "S16"
	          },
	          "PrivacyProtectAdminContact": {
	            "type": "boolean"
	          },
	          "PrivacyProtectRegistrantContact": {
	            "type": "boolean"
	          },
	          "PrivacyProtectTechContact": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "OperationId"
	        ],
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "RejectDomainTransferFromAnotherAwsAccount": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "RenewDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName",
	          "CurrentExpiryYear"
	        ],
	        "members": {
	          "DomainName": {},
	          "DurationInYears": {
	            "type": "integer"
	          },
	          "CurrentExpiryYear": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "OperationId"
	        ],
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "ResendContactReachabilityEmail": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "domainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "domainName": {},
	          "emailAddress": {},
	          "isAlreadyVerified": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "RetrieveDomainAuthCode": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "AuthCode"
	        ],
	        "members": {
	          "AuthCode": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "TransferDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName",
	          "DurationInYears",
	          "AdminContact",
	          "RegistrantContact",
	          "TechContact"
	        ],
	        "members": {
	          "DomainName": {},
	          "IdnLangCode": {},
	          "DurationInYears": {
	            "type": "integer"
	          },
	          "Nameservers": {
	            "shape": "S10"
	          },
	          "AuthCode": {
	            "shape": "Sd"
	          },
	          "AutoRenew": {
	            "type": "boolean"
	          },
	          "AdminContact": {
	            "shape": "S16"
	          },
	          "RegistrantContact": {
	            "shape": "S16"
	          },
	          "TechContact": {
	            "shape": "S16"
	          },
	          "PrivacyProtectAdminContact": {
	            "type": "boolean"
	          },
	          "PrivacyProtectRegistrantContact": {
	            "type": "boolean"
	          },
	          "PrivacyProtectTechContact": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "OperationId"
	        ],
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "TransferDomainToAnotherAwsAccount": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName",
	          "AccountId"
	        ],
	        "members": {
	          "DomainName": {},
	          "AccountId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OperationId": {},
	          "Password": {}
	        }
	      }
	    },
	    "UpdateDomainContact": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {},
	          "AdminContact": {
	            "shape": "S16"
	          },
	          "RegistrantContact": {
	            "shape": "S16"
	          },
	          "TechContact": {
	            "shape": "S16"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "OperationId"
	        ],
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "UpdateDomainContactPrivacy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {},
	          "AdminPrivacy": {
	            "type": "boolean"
	          },
	          "RegistrantPrivacy": {
	            "type": "boolean"
	          },
	          "TechPrivacy": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "OperationId"
	        ],
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "UpdateDomainNameservers": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName",
	          "Nameservers"
	        ],
	        "members": {
	          "DomainName": {},
	          "FIAuthKey": {
	            "deprecated": true,
	            "type": "string",
	            "sensitive": true
	          },
	          "Nameservers": {
	            "shape": "S10"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "OperationId"
	        ],
	        "members": {
	          "OperationId": {}
	        }
	      }
	    },
	    "UpdateTagsForDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DomainName"
	        ],
	        "members": {
	          "DomainName": {},
	          "TagsToUpdate": {
	            "shape": "S2w"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ViewBilling": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Start": {
	            "type": "timestamp"
	          },
	          "End": {
	            "type": "timestamp"
	          },
	          "Marker": {},
	          "MaxItems": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextPageMarker": {},
	          "BillingRecords": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DomainName": {},
	                "Operation": {},
	                "InvoiceId": {},
	                "BillDate": {
	                  "type": "timestamp"
	                },
	                "Price": {
	                  "type": "double"
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sd": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S10": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "GlueIps": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "S16": {
	      "type": "structure",
	      "members": {
	        "FirstName": {},
	        "LastName": {},
	        "ContactType": {},
	        "OrganizationName": {},
	        "AddressLine1": {},
	        "AddressLine2": {},
	        "City": {},
	        "State": {},
	        "CountryCode": {},
	        "ZipCode": {},
	        "PhoneNumber": {},
	        "Email": {},
	        "Fax": {},
	        "ExtraParams": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Name",
	              "Value"
	            ],
	            "members": {
	              "Name": {},
	              "Value": {
	                "type": "string",
	                "sensitive": true
	              }
	            }
	          }
	        }
	      },
	      "sensitive": true
	    },
	    "S2r": {
	      "type": "structure",
	      "required": [
	        "Price",
	        "Currency"
	      ],
	      "members": {
	        "Price": {
	          "type": "double"
	        },
	        "Currency": {}
	      }
	    },
	    "S2w": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    }
	  }
	}
	},{}],207:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListDomains": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextPageMarker",
	      "result_key": "Domains"
	    },
	    "ListOperations": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextPageMarker",
	      "result_key": "Operations"
	    },
	    "ListPrices": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextPageMarker",
	      "result_key": "Prices"
	    },
	    "ViewBilling": {
	      "input_token": "Marker",
	      "limit_key": "MaxItems",
	      "output_token": "NextPageMarker",
	      "result_key": "BillingRecords"
	    }
	  }
	}
	},{}],208:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2016-11-28",
	    "endpointPrefix": "runtime.lex",
	    "jsonVersion": "1.1",
	    "protocol": "rest-json",
	    "serviceFullName": "Amazon Lex Runtime Service",
	    "serviceId": "Lex Runtime Service",
	    "signatureVersion": "v4",
	    "signingName": "lex",
	    "uid": "runtime.lex-2016-11-28"
	  },
	  "operations": {
	    "DeleteSession": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/session"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botName",
	          "botAlias",
	          "userId"
	        ],
	        "members": {
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          },
	          "botAlias": {
	            "location": "uri",
	            "locationName": "botAlias"
	          },
	          "userId": {
	            "location": "uri",
	            "locationName": "userId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "botName": {},
	          "botAlias": {},
	          "userId": {},
	          "sessionId": {}
	        }
	      }
	    },
	    "GetSession": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/session/"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botName",
	          "botAlias",
	          "userId"
	        ],
	        "members": {
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          },
	          "botAlias": {
	            "location": "uri",
	            "locationName": "botAlias"
	          },
	          "userId": {
	            "location": "uri",
	            "locationName": "userId"
	          },
	          "checkpointLabelFilter": {
	            "location": "querystring",
	            "locationName": "checkpointLabelFilter"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "recentIntentSummaryView": {
	            "shape": "Sa"
	          },
	          "sessionAttributes": {
	            "shape": "Sd"
	          },
	          "sessionId": {},
	          "dialogAction": {
	            "shape": "Sh"
	          },
	          "activeContexts": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "PostContent": {
	      "http": {
	        "requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/content"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botName",
	          "botAlias",
	          "userId",
	          "contentType",
	          "inputStream"
	        ],
	        "members": {
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          },
	          "botAlias": {
	            "location": "uri",
	            "locationName": "botAlias"
	          },
	          "userId": {
	            "location": "uri",
	            "locationName": "userId"
	          },
	          "sessionAttributes": {
	            "shape": "St",
	            "jsonvalue": true,
	            "location": "header",
	            "locationName": "x-amz-lex-session-attributes"
	          },
	          "requestAttributes": {
	            "shape": "St",
	            "jsonvalue": true,
	            "location": "header",
	            "locationName": "x-amz-lex-request-attributes"
	          },
	          "contentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "accept": {
	            "location": "header",
	            "locationName": "Accept"
	          },
	          "inputStream": {
	            "shape": "Sw"
	          },
	          "activeContexts": {
	            "shape": "Sx",
	            "jsonvalue": true,
	            "location": "header",
	            "locationName": "x-amz-lex-active-contexts"
	          }
	        },
	        "payload": "inputStream"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "contentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "intentName": {
	            "location": "header",
	            "locationName": "x-amz-lex-intent-name"
	          },
	          "nluIntentConfidence": {
	            "jsonvalue": true,
	            "location": "header",
	            "locationName": "x-amz-lex-nlu-intent-confidence"
	          },
	          "alternativeIntents": {
	            "jsonvalue": true,
	            "location": "header",
	            "locationName": "x-amz-lex-alternative-intents"
	          },
	          "slots": {
	            "jsonvalue": true,
	            "location": "header",
	            "locationName": "x-amz-lex-slots"
	          },
	          "sessionAttributes": {
	            "jsonvalue": true,
	            "location": "header",
	            "locationName": "x-amz-lex-session-attributes"
	          },
	          "sentimentResponse": {
	            "location": "header",
	            "locationName": "x-amz-lex-sentiment"
	          },
	          "message": {
	            "shape": "Si",
	            "deprecated": true,
	            "deprecatedMessage": "The message field is deprecated, use the encodedMessage field instead. The message field is available only in the de-DE, en-AU, en-GB, en-US, es-419, es-ES, es-US, fr-CA, fr-FR and it-IT locales.",
	            "location": "header",
	            "locationName": "x-amz-lex-message"
	          },
	          "encodedMessage": {
	            "shape": "Sz",
	            "location": "header",
	            "locationName": "x-amz-lex-encoded-message"
	          },
	          "messageFormat": {
	            "location": "header",
	            "locationName": "x-amz-lex-message-format"
	          },
	          "dialogState": {
	            "location": "header",
	            "locationName": "x-amz-lex-dialog-state"
	          },
	          "slotToElicit": {
	            "location": "header",
	            "locationName": "x-amz-lex-slot-to-elicit"
	          },
	          "inputTranscript": {
	            "deprecated": true,
	            "deprecatedMessage": "The inputTranscript field is deprecated, use the encodedInputTranscript field instead. The inputTranscript field is available only in the de-DE, en-AU, en-GB, en-US, es-419, es-ES, es-US, fr-CA, fr-FR and it-IT locales.",
	            "location": "header",
	            "locationName": "x-amz-lex-input-transcript"
	          },
	          "encodedInputTranscript": {
	            "location": "header",
	            "locationName": "x-amz-lex-encoded-input-transcript",
	            "type": "string",
	            "sensitive": true
	          },
	          "audioStream": {
	            "shape": "Sw"
	          },
	          "botVersion": {
	            "location": "header",
	            "locationName": "x-amz-lex-bot-version"
	          },
	          "sessionId": {
	            "location": "header",
	            "locationName": "x-amz-lex-session-id"
	          },
	          "activeContexts": {
	            "shape": "Sx",
	            "jsonvalue": true,
	            "location": "header",
	            "locationName": "x-amz-lex-active-contexts"
	          }
	        },
	        "payload": "audioStream"
	      },
	      "authtype": "v4-unsigned-body"
	    },
	    "PostText": {
	      "http": {
	        "requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/text"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botName",
	          "botAlias",
	          "userId",
	          "inputText"
	        ],
	        "members": {
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          },
	          "botAlias": {
	            "location": "uri",
	            "locationName": "botAlias"
	          },
	          "userId": {
	            "location": "uri",
	            "locationName": "userId"
	          },
	          "sessionAttributes": {
	            "shape": "Sd"
	          },
	          "requestAttributes": {
	            "shape": "Sd"
	          },
	          "inputText": {
	            "shape": "Si"
	          },
	          "activeContexts": {
	            "shape": "Sk"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "intentName": {},
	          "nluIntentConfidence": {
	            "shape": "S15"
	          },
	          "alternativeIntents": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "intentName": {},
	                "nluIntentConfidence": {
	                  "shape": "S15"
	                },
	                "slots": {
	                  "shape": "Sd"
	                }
	              }
	            }
	          },
	          "slots": {
	            "shape": "Sd"
	          },
	          "sessionAttributes": {
	            "shape": "Sd"
	          },
	          "message": {
	            "shape": "Si"
	          },
	          "sentimentResponse": {
	            "type": "structure",
	            "members": {
	              "sentimentLabel": {},
	              "sentimentScore": {}
	            }
	          },
	          "messageFormat": {},
	          "dialogState": {},
	          "slotToElicit": {},
	          "responseCard": {
	            "type": "structure",
	            "members": {
	              "version": {},
	              "contentType": {},
	              "genericAttachments": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "title": {},
	                    "subTitle": {},
	                    "attachmentLinkUrl": {},
	                    "imageUrl": {},
	                    "buttons": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "required": [
	                          "text",
	                          "value"
	                        ],
	                        "members": {
	                          "text": {},
	                          "value": {}
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "sessionId": {},
	          "botVersion": {},
	          "activeContexts": {
	            "shape": "Sk"
	          }
	        }
	      }
	    },
	    "PutSession": {
	      "http": {
	        "requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/session"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botName",
	          "botAlias",
	          "userId"
	        ],
	        "members": {
	          "botName": {
	            "location": "uri",
	            "locationName": "botName"
	          },
	          "botAlias": {
	            "location": "uri",
	            "locationName": "botAlias"
	          },
	          "userId": {
	            "location": "uri",
	            "locationName": "userId"
	          },
	          "sessionAttributes": {
	            "shape": "Sd"
	          },
	          "dialogAction": {
	            "shape": "Sh"
	          },
	          "recentIntentSummaryView": {
	            "shape": "Sa"
	          },
	          "accept": {
	            "location": "header",
	            "locationName": "Accept"
	          },
	          "activeContexts": {
	            "shape": "Sk"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "contentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "intentName": {
	            "location": "header",
	            "locationName": "x-amz-lex-intent-name"
	          },
	          "slots": {
	            "jsonvalue": true,
	            "location": "header",
	            "locationName": "x-amz-lex-slots"
	          },
	          "sessionAttributes": {
	            "jsonvalue": true,
	            "location": "header",
	            "locationName": "x-amz-lex-session-attributes"
	          },
	          "message": {
	            "shape": "Si",
	            "deprecated": true,
	            "deprecatedMessage": "The message field is deprecated, use the encodedMessage field instead. The message field is available only in the de-DE, en-AU, en-GB, en-US, es-419, es-ES, es-US, fr-CA, fr-FR and it-IT locales.",
	            "location": "header",
	            "locationName": "x-amz-lex-message"
	          },
	          "encodedMessage": {
	            "shape": "Sz",
	            "location": "header",
	            "locationName": "x-amz-lex-encoded-message"
	          },
	          "messageFormat": {
	            "location": "header",
	            "locationName": "x-amz-lex-message-format"
	          },
	          "dialogState": {
	            "location": "header",
	            "locationName": "x-amz-lex-dialog-state"
	          },
	          "slotToElicit": {
	            "location": "header",
	            "locationName": "x-amz-lex-slot-to-elicit"
	          },
	          "audioStream": {
	            "shape": "Sw"
	          },
	          "sessionId": {
	            "location": "header",
	            "locationName": "x-amz-lex-session-id"
	          },
	          "activeContexts": {
	            "shape": "Sx",
	            "jsonvalue": true,
	            "location": "header",
	            "locationName": "x-amz-lex-active-contexts"
	          }
	        },
	        "payload": "audioStream"
	      }
	    }
	  },
	  "shapes": {
	    "Sa": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "dialogActionType"
	        ],
	        "members": {
	          "intentName": {},
	          "checkpointLabel": {},
	          "slots": {
	            "shape": "Sd"
	          },
	          "confirmationStatus": {},
	          "dialogActionType": {},
	          "fulfillmentState": {},
	          "slotToElicit": {}
	        }
	      }
	    },
	    "Sd": {
	      "type": "map",
	      "key": {},
	      "value": {},
	      "sensitive": true
	    },
	    "Sh": {
	      "type": "structure",
	      "required": [
	        "type"
	      ],
	      "members": {
	        "type": {},
	        "intentName": {},
	        "slots": {
	          "shape": "Sd"
	        },
	        "slotToElicit": {},
	        "fulfillmentState": {},
	        "message": {
	          "shape": "Si"
	        },
	        "messageFormat": {}
	      }
	    },
	    "Si": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Sk": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "name",
	          "timeToLive",
	          "parameters"
	        ],
	        "members": {
	          "name": {},
	          "timeToLive": {
	            "type": "structure",
	            "members": {
	              "timeToLiveInSeconds": {
	                "type": "integer"
	              },
	              "turnsToLive": {
	                "type": "integer"
	              }
	            }
	          },
	          "parameters": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "shape": "Si"
	            }
	          }
	        }
	      },
	      "sensitive": true
	    },
	    "St": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Sw": {
	      "type": "blob",
	      "streaming": true
	    },
	    "Sx": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Sz": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S15": {
	      "type": "structure",
	      "members": {
	        "score": {
	          "type": "double"
	        }
	      }
	    }
	  }
	}
	},{}],209:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],210:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2020-08-07",
	    "endpointPrefix": "runtime-v2-lex",
	    "jsonVersion": "1.1",
	    "protocol": "rest-json",
	    "protocolSettings": {
	      "h2": "eventstream"
	    },
	    "serviceAbbreviation": "Lex Runtime V2",
	    "serviceFullName": "Amazon Lex Runtime V2",
	    "serviceId": "Lex Runtime V2",
	    "signatureVersion": "v4",
	    "signingName": "lex",
	    "uid": "runtime.lex.v2-2020-08-07"
	  },
	  "operations": {
	    "DeleteSession": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botId",
	          "botAliasId",
	          "sessionId",
	          "localeId"
	        ],
	        "members": {
	          "botId": {
	            "location": "uri",
	            "locationName": "botId"
	          },
	          "botAliasId": {
	            "location": "uri",
	            "locationName": "botAliasId"
	          },
	          "localeId": {
	            "location": "uri",
	            "locationName": "localeId"
	          },
	          "sessionId": {
	            "location": "uri",
	            "locationName": "sessionId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "botId": {},
	          "botAliasId": {},
	          "localeId": {},
	          "sessionId": {}
	        }
	      }
	    },
	    "GetSession": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botId",
	          "botAliasId",
	          "localeId",
	          "sessionId"
	        ],
	        "members": {
	          "botId": {
	            "location": "uri",
	            "locationName": "botId"
	          },
	          "botAliasId": {
	            "location": "uri",
	            "locationName": "botAliasId"
	          },
	          "localeId": {
	            "location": "uri",
	            "locationName": "localeId"
	          },
	          "sessionId": {
	            "location": "uri",
	            "locationName": "sessionId"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "sessionId": {},
	          "messages": {
	            "shape": "Sa"
	          },
	          "interpretations": {
	            "shape": "Sl"
	          },
	          "sessionState": {
	            "shape": "S11"
	          }
	        }
	      }
	    },
	    "PutSession": {
	      "http": {
	        "requestUri": "/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botId",
	          "botAliasId",
	          "localeId",
	          "sessionState",
	          "sessionId"
	        ],
	        "members": {
	          "botId": {
	            "location": "uri",
	            "locationName": "botId"
	          },
	          "botAliasId": {
	            "location": "uri",
	            "locationName": "botAliasId"
	          },
	          "localeId": {
	            "location": "uri",
	            "locationName": "localeId"
	          },
	          "sessionId": {
	            "location": "uri",
	            "locationName": "sessionId"
	          },
	          "messages": {
	            "shape": "Sa"
	          },
	          "sessionState": {
	            "shape": "S11"
	          },
	          "requestAttributes": {
	            "shape": "S1d"
	          },
	          "responseContentType": {
	            "location": "header",
	            "locationName": "ResponseContentType"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "contentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "messages": {
	            "location": "header",
	            "locationName": "x-amz-lex-messages"
	          },
	          "sessionState": {
	            "location": "header",
	            "locationName": "x-amz-lex-session-state"
	          },
	          "requestAttributes": {
	            "location": "header",
	            "locationName": "x-amz-lex-request-attributes"
	          },
	          "sessionId": {
	            "location": "header",
	            "locationName": "x-amz-lex-session-id"
	          },
	          "audioStream": {
	            "shape": "S1p"
	          }
	        },
	        "payload": "audioStream"
	      }
	    },
	    "RecognizeText": {
	      "http": {
	        "requestUri": "/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/text"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botId",
	          "botAliasId",
	          "localeId",
	          "text",
	          "sessionId"
	        ],
	        "members": {
	          "botId": {
	            "location": "uri",
	            "locationName": "botId"
	          },
	          "botAliasId": {
	            "location": "uri",
	            "locationName": "botAliasId"
	          },
	          "localeId": {
	            "location": "uri",
	            "locationName": "localeId"
	          },
	          "sessionId": {
	            "location": "uri",
	            "locationName": "sessionId"
	          },
	          "text": {
	            "shape": "Sc"
	          },
	          "sessionState": {
	            "shape": "S11"
	          },
	          "requestAttributes": {
	            "shape": "S1d"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "messages": {
	            "shape": "Sa"
	          },
	          "sessionState": {
	            "shape": "S11"
	          },
	          "interpretations": {
	            "shape": "Sl"
	          },
	          "requestAttributes": {
	            "shape": "S1d"
	          },
	          "sessionId": {}
	        }
	      }
	    },
	    "RecognizeUtterance": {
	      "http": {
	        "requestUri": "/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/utterance"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "botId",
	          "botAliasId",
	          "localeId",
	          "requestContentType",
	          "sessionId"
	        ],
	        "members": {
	          "botId": {
	            "location": "uri",
	            "locationName": "botId"
	          },
	          "botAliasId": {
	            "location": "uri",
	            "locationName": "botAliasId"
	          },
	          "localeId": {
	            "location": "uri",
	            "locationName": "localeId"
	          },
	          "sessionId": {
	            "location": "uri",
	            "locationName": "sessionId"
	          },
	          "sessionState": {
	            "shape": "S1t",
	            "location": "header",
	            "locationName": "x-amz-lex-session-state"
	          },
	          "requestAttributes": {
	            "shape": "S1t",
	            "location": "header",
	            "locationName": "x-amz-lex-request-attributes"
	          },
	          "requestContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "responseContentType": {
	            "location": "header",
	            "locationName": "Response-Content-Type"
	          },
	          "inputStream": {
	            "shape": "S1p"
	          }
	        },
	        "payload": "inputStream"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "inputMode": {
	            "location": "header",
	            "locationName": "x-amz-lex-input-mode"
	          },
	          "contentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "messages": {
	            "location": "header",
	            "locationName": "x-amz-lex-messages"
	          },
	          "interpretations": {
	            "location": "header",
	            "locationName": "x-amz-lex-interpretations"
	          },
	          "sessionState": {
	            "location": "header",
	            "locationName": "x-amz-lex-session-state"
	          },
	          "requestAttributes": {
	            "location": "header",
	            "locationName": "x-amz-lex-request-attributes"
	          },
	          "sessionId": {
	            "location": "header",
	            "locationName": "x-amz-lex-session-id"
	          },
	          "inputTranscript": {
	            "location": "header",
	            "locationName": "x-amz-lex-input-transcript"
	          },
	          "audioStream": {
	            "shape": "S1p"
	          }
	        },
	        "payload": "audioStream"
	      },
	      "authtype": "v4-unsigned-body"
	    }
	  },
	  "shapes": {
	    "Sa": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "contentType"
	        ],
	        "members": {
	          "content": {
	            "shape": "Sc"
	          },
	          "contentType": {},
	          "imageResponseCard": {
	            "type": "structure",
	            "required": [
	              "title"
	            ],
	            "members": {
	              "title": {},
	              "subtitle": {},
	              "imageUrl": {},
	              "buttons": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "text",
	                    "value"
	                  ],
	                  "members": {
	                    "text": {},
	                    "value": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sc": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Sl": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "nluConfidence": {
	            "type": "structure",
	            "members": {
	              "score": {
	                "type": "double"
	              }
	            }
	          },
	          "sentimentResponse": {
	            "type": "structure",
	            "members": {
	              "sentiment": {},
	              "sentimentScore": {
	                "type": "structure",
	                "members": {
	                  "positive": {
	                    "type": "double"
	                  },
	                  "negative": {
	                    "type": "double"
	                  },
	                  "neutral": {
	                    "type": "double"
	                  },
	                  "mixed": {
	                    "type": "double"
	                  }
	                }
	              }
	            }
	          },
	          "intent": {
	            "shape": "Ss"
	          }
	        }
	      }
	    },
	    "Ss": {
	      "type": "structure",
	      "required": [
	        "name"
	      ],
	      "members": {
	        "name": {},
	        "slots": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "shape": "Su"
	          }
	        },
	        "state": {},
	        "confirmationState": {}
	      }
	    },
	    "Su": {
	      "type": "structure",
	      "members": {
	        "value": {
	          "type": "structure",
	          "required": [
	            "interpretedValue"
	          ],
	          "members": {
	            "originalValue": {},
	            "interpretedValue": {},
	            "resolvedValues": {
	              "type": "list",
	              "member": {}
	            }
	          }
	        },
	        "shape": {},
	        "values": {
	          "type": "list",
	          "member": {
	            "shape": "Su"
	          }
	        }
	      }
	    },
	    "S11": {
	      "type": "structure",
	      "members": {
	        "dialogAction": {
	          "type": "structure",
	          "required": [
	            "type"
	          ],
	          "members": {
	            "type": {},
	            "slotToElicit": {},
	            "slotElicitationStyle": {}
	          }
	        },
	        "intent": {
	          "shape": "Ss"
	        },
	        "activeContexts": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "name",
	              "timeToLive",
	              "contextAttributes"
	            ],
	            "members": {
	              "name": {},
	              "timeToLive": {
	                "type": "structure",
	                "required": [
	                  "timeToLiveInSeconds",
	                  "turnsToLive"
	                ],
	                "members": {
	                  "timeToLiveInSeconds": {
	                    "type": "integer"
	                  },
	                  "turnsToLive": {
	                    "type": "integer"
	                  }
	                }
	              },
	              "contextAttributes": {
	                "type": "map",
	                "key": {},
	                "value": {
	                  "shape": "Sc"
	                }
	              }
	            }
	          }
	        },
	        "sessionAttributes": {
	          "shape": "S1d"
	        },
	        "originatingRequestId": {},
	        "runtimeHints": {
	          "type": "structure",
	          "members": {
	            "slotHints": {
	              "type": "map",
	              "key": {},
	              "value": {
	                "type": "map",
	                "key": {},
	                "value": {
	                  "type": "structure",
	                  "required": [
	                    "runtimeHintValues"
	                  ],
	                  "members": {
	                    "runtimeHintValues": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "required": [
	                          "phrase"
	                        ],
	                        "members": {
	                          "phrase": {}
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S1d": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S1p": {
	      "type": "blob",
	      "streaming": true
	    },
	    "S1t": {
	      "type": "string",
	      "sensitive": true
	    }
	  }
	}
	},{}],211:[function(require,module,exports){
	module.exports={
	  "pagination": {}
	}
	},{}],212:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2006-03-01",
	    "checksumFormat": "md5",
	    "endpointPrefix": "s3",
	    "globalEndpoint": "s3.amazonaws.com",
	    "protocol": "rest-xml",
	    "serviceAbbreviation": "Amazon S3",
	    "serviceFullName": "Amazon Simple Storage Service",
	    "serviceId": "S3",
	    "signatureVersion": "s3",
	    "uid": "s3-2006-03-01"
	  },
	  "operations": {
	    "AbortMultipartUpload": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}/{Key+}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key",
	          "UploadId"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "UploadId": {
	            "location": "querystring",
	            "locationName": "uploadId"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        }
	      }
	    },
	    "CompleteMultipartUpload": {
	      "http": {
	        "requestUri": "/{Bucket}/{Key+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key",
	          "UploadId"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "MultipartUpload": {
	            "locationName": "CompleteMultipartUpload",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "members": {
	              "Parts": {
	                "locationName": "Part",
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "ETag": {},
	                    "ChecksumCRC32": {},
	                    "ChecksumCRC32C": {},
	                    "ChecksumSHA1": {},
	                    "ChecksumSHA256": {},
	                    "PartNumber": {
	                      "type": "integer"
	                    }
	                  }
	                },
	                "flattened": true
	              }
	            }
	          },
	          "UploadId": {
	            "location": "querystring",
	            "locationName": "uploadId"
	          },
	          "ChecksumCRC32": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32"
	          },
	          "ChecksumCRC32C": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32c"
	          },
	          "ChecksumSHA1": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha1"
	          },
	          "ChecksumSHA256": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha256"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKey": {
	            "shape": "Sk",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          }
	        },
	        "payload": "MultipartUpload"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Location": {},
	          "Bucket": {},
	          "Key": {},
	          "Expiration": {
	            "location": "header",
	            "locationName": "x-amz-expiration"
	          },
	          "ETag": {},
	          "ChecksumCRC32": {},
	          "ChecksumCRC32C": {},
	          "ChecksumSHA1": {},
	          "ChecksumSHA256": {},
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption"
	          },
	          "VersionId": {
	            "location": "header",
	            "locationName": "x-amz-version-id"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        }
	      }
	    },
	    "CopyObject": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}/{Key+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "CopySource",
	          "Key"
	        ],
	        "members": {
	          "ACL": {
	            "location": "header",
	            "locationName": "x-amz-acl"
	          },
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "CacheControl": {
	            "location": "header",
	            "locationName": "Cache-Control"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-checksum-algorithm"
	          },
	          "ContentDisposition": {
	            "location": "header",
	            "locationName": "Content-Disposition"
	          },
	          "ContentEncoding": {
	            "location": "header",
	            "locationName": "Content-Encoding"
	          },
	          "ContentLanguage": {
	            "location": "header",
	            "locationName": "Content-Language"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "CopySource": {
	            "location": "header",
	            "locationName": "x-amz-copy-source"
	          },
	          "CopySourceIfMatch": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-if-match"
	          },
	          "CopySourceIfModifiedSince": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-if-modified-since",
	            "type": "timestamp"
	          },
	          "CopySourceIfNoneMatch": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-if-none-match"
	          },
	          "CopySourceIfUnmodifiedSince": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-if-unmodified-since",
	            "type": "timestamp"
	          },
	          "Expires": {
	            "location": "header",
	            "locationName": "Expires",
	            "type": "timestamp"
	          },
	          "GrantFullControl": {
	            "location": "header",
	            "locationName": "x-amz-grant-full-control"
	          },
	          "GrantRead": {
	            "location": "header",
	            "locationName": "x-amz-grant-read"
	          },
	          "GrantReadACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-read-acp"
	          },
	          "GrantWriteACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-write-acp"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "Metadata": {
	            "shape": "S1b",
	            "location": "headers",
	            "locationName": "x-amz-meta-"
	          },
	          "MetadataDirective": {
	            "location": "header",
	            "locationName": "x-amz-metadata-directive"
	          },
	          "TaggingDirective": {
	            "location": "header",
	            "locationName": "x-amz-tagging-directive"
	          },
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption"
	          },
	          "StorageClass": {
	            "location": "header",
	            "locationName": "x-amz-storage-class"
	          },
	          "WebsiteRedirectLocation": {
	            "location": "header",
	            "locationName": "x-amz-website-redirect-location"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKey": {
	            "shape": "Sk",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "SSEKMSEncryptionContext": {
	            "shape": "S1i",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-context"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          },
	          "CopySourceSSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
	          },
	          "CopySourceSSECustomerKey": {
	            "shape": "S1k",
	            "location": "header",
	            "locationName": "x-amz-copy-source-server-side-encryption-customer-key"
	          },
	          "CopySourceSSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "Tagging": {
	            "location": "header",
	            "locationName": "x-amz-tagging"
	          },
	          "ObjectLockMode": {
	            "location": "header",
	            "locationName": "x-amz-object-lock-mode"
	          },
	          "ObjectLockRetainUntilDate": {
	            "shape": "S1o",
	            "location": "header",
	            "locationName": "x-amz-object-lock-retain-until-date"
	          },
	          "ObjectLockLegalHoldStatus": {
	            "location": "header",
	            "locationName": "x-amz-object-lock-legal-hold"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "ExpectedSourceBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-source-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CopyObjectResult": {
	            "type": "structure",
	            "members": {
	              "ETag": {},
	              "LastModified": {
	                "type": "timestamp"
	              },
	              "ChecksumCRC32": {},
	              "ChecksumCRC32C": {},
	              "ChecksumSHA1": {},
	              "ChecksumSHA256": {}
	            }
	          },
	          "Expiration": {
	            "location": "header",
	            "locationName": "x-amz-expiration"
	          },
	          "CopySourceVersionId": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-version-id"
	          },
	          "VersionId": {
	            "location": "header",
	            "locationName": "x-amz-version-id"
	          },
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "SSEKMSEncryptionContext": {
	            "shape": "S1i",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-context"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        },
	        "payload": "CopyObjectResult"
	      },
	      "alias": "PutObjectCopy"
	    },
	    "CreateBucket": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "ACL": {
	            "location": "header",
	            "locationName": "x-amz-acl"
	          },
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "CreateBucketConfiguration": {
	            "locationName": "CreateBucketConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "members": {
	              "LocationConstraint": {}
	            }
	          },
	          "GrantFullControl": {
	            "location": "header",
	            "locationName": "x-amz-grant-full-control"
	          },
	          "GrantRead": {
	            "location": "header",
	            "locationName": "x-amz-grant-read"
	          },
	          "GrantReadACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-read-acp"
	          },
	          "GrantWrite": {
	            "location": "header",
	            "locationName": "x-amz-grant-write"
	          },
	          "GrantWriteACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-write-acp"
	          },
	          "ObjectLockEnabledForBucket": {
	            "location": "header",
	            "locationName": "x-amz-bucket-object-lock-enabled",
	            "type": "boolean"
	          },
	          "ObjectOwnership": {
	            "location": "header",
	            "locationName": "x-amz-object-ownership"
	          }
	        },
	        "payload": "CreateBucketConfiguration"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Location": {
	            "location": "header",
	            "locationName": "Location"
	          }
	        }
	      },
	      "alias": "PutBucket"
	    },
	    "CreateMultipartUpload": {
	      "http": {
	        "requestUri": "/{Bucket}/{Key+}?uploads"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "ACL": {
	            "location": "header",
	            "locationName": "x-amz-acl"
	          },
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "CacheControl": {
	            "location": "header",
	            "locationName": "Cache-Control"
	          },
	          "ContentDisposition": {
	            "location": "header",
	            "locationName": "Content-Disposition"
	          },
	          "ContentEncoding": {
	            "location": "header",
	            "locationName": "Content-Encoding"
	          },
	          "ContentLanguage": {
	            "location": "header",
	            "locationName": "Content-Language"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "Expires": {
	            "location": "header",
	            "locationName": "Expires",
	            "type": "timestamp"
	          },
	          "GrantFullControl": {
	            "location": "header",
	            "locationName": "x-amz-grant-full-control"
	          },
	          "GrantRead": {
	            "location": "header",
	            "locationName": "x-amz-grant-read"
	          },
	          "GrantReadACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-read-acp"
	          },
	          "GrantWriteACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-write-acp"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "Metadata": {
	            "shape": "S1b",
	            "location": "headers",
	            "locationName": "x-amz-meta-"
	          },
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption"
	          },
	          "StorageClass": {
	            "location": "header",
	            "locationName": "x-amz-storage-class"
	          },
	          "WebsiteRedirectLocation": {
	            "location": "header",
	            "locationName": "x-amz-website-redirect-location"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKey": {
	            "shape": "Sk",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "SSEKMSEncryptionContext": {
	            "shape": "S1i",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-context"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "Tagging": {
	            "location": "header",
	            "locationName": "x-amz-tagging"
	          },
	          "ObjectLockMode": {
	            "location": "header",
	            "locationName": "x-amz-object-lock-mode"
	          },
	          "ObjectLockRetainUntilDate": {
	            "shape": "S1o",
	            "location": "header",
	            "locationName": "x-amz-object-lock-retain-until-date"
	          },
	          "ObjectLockLegalHoldStatus": {
	            "location": "header",
	            "locationName": "x-amz-object-lock-legal-hold"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-checksum-algorithm"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AbortDate": {
	            "location": "header",
	            "locationName": "x-amz-abort-date",
	            "type": "timestamp"
	          },
	          "AbortRuleId": {
	            "location": "header",
	            "locationName": "x-amz-abort-rule-id"
	          },
	          "Bucket": {
	            "locationName": "Bucket"
	          },
	          "Key": {},
	          "UploadId": {},
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "SSEKMSEncryptionContext": {
	            "shape": "S1i",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-context"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-checksum-algorithm"
	          }
	        }
	      },
	      "alias": "InitiateMultipartUpload"
	    },
	    "DeleteBucket": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteBucketAnalyticsConfiguration": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?analytics",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteBucketCors": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?cors",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteBucketEncryption": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?encryption",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteBucketIntelligentTieringConfiguration": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?intelligent-tiering",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          }
	        }
	      }
	    },
	    "DeleteBucketInventoryConfiguration": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?inventory",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteBucketLifecycle": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?lifecycle",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteBucketMetricsConfiguration": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?metrics",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteBucketOwnershipControls": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?ownershipControls",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteBucketPolicy": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?policy",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteBucketReplication": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?replication",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteBucketTagging": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?tagging",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteBucketWebsite": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?website",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "DeleteObject": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}/{Key+}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "MFA": {
	            "location": "header",
	            "locationName": "x-amz-mfa"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "BypassGovernanceRetention": {
	            "location": "header",
	            "locationName": "x-amz-bypass-governance-retention",
	            "type": "boolean"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeleteMarker": {
	            "location": "header",
	            "locationName": "x-amz-delete-marker",
	            "type": "boolean"
	          },
	          "VersionId": {
	            "location": "header",
	            "locationName": "x-amz-version-id"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        }
	      }
	    },
	    "DeleteObjectTagging": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}/{Key+}?tagging",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VersionId": {
	            "location": "header",
	            "locationName": "x-amz-version-id"
	          }
	        }
	      }
	    },
	    "DeleteObjects": {
	      "http": {
	        "requestUri": "/{Bucket}?delete"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Delete"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Delete": {
	            "locationName": "Delete",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "required": [
	              "Objects"
	            ],
	            "members": {
	              "Objects": {
	                "locationName": "Object",
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "Key"
	                  ],
	                  "members": {
	                    "Key": {},
	                    "VersionId": {}
	                  }
	                },
	                "flattened": true
	              },
	              "Quiet": {
	                "type": "boolean"
	              }
	            }
	          },
	          "MFA": {
	            "location": "header",
	            "locationName": "x-amz-mfa"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "BypassGovernanceRetention": {
	            "location": "header",
	            "locationName": "x-amz-bypass-governance-retention",
	            "type": "boolean"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          }
	        },
	        "payload": "Delete"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Deleted": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Key": {},
	                "VersionId": {},
	                "DeleteMarker": {
	                  "type": "boolean"
	                },
	                "DeleteMarkerVersionId": {}
	              }
	            },
	            "flattened": true
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          },
	          "Errors": {
	            "locationName": "Error",
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Key": {},
	                "VersionId": {},
	                "Code": {},
	                "Message": {}
	              }
	            },
	            "flattened": true
	          }
	        }
	      },
	      "alias": "DeleteMultipleObjects",
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "DeletePublicAccessBlock": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/{Bucket}?publicAccessBlock",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "GetBucketAccelerateConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?accelerate"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {}
	        }
	      }
	    },
	    "GetBucketAcl": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?acl"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Owner": {
	            "shape": "S3d"
	          },
	          "Grants": {
	            "shape": "S3g",
	            "locationName": "AccessControlList"
	          }
	        }
	      }
	    },
	    "GetBucketAnalyticsConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?analytics"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AnalyticsConfiguration": {
	            "shape": "S3p"
	          }
	        },
	        "payload": "AnalyticsConfiguration"
	      }
	    },
	    "GetBucketCors": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?cors"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CORSRules": {
	            "shape": "S44",
	            "locationName": "CORSRule"
	          }
	        }
	      }
	    },
	    "GetBucketEncryption": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?encryption"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServerSideEncryptionConfiguration": {
	            "shape": "S4h"
	          }
	        },
	        "payload": "ServerSideEncryptionConfiguration"
	      }
	    },
	    "GetBucketIntelligentTieringConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?intelligent-tiering"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IntelligentTieringConfiguration": {
	            "shape": "S4n"
	          }
	        },
	        "payload": "IntelligentTieringConfiguration"
	      }
	    },
	    "GetBucketInventoryConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?inventory"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InventoryConfiguration": {
	            "shape": "S4x"
	          }
	        },
	        "payload": "InventoryConfiguration"
	      }
	    },
	    "GetBucketLifecycle": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?lifecycle"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Rules": {
	            "shape": "S5d",
	            "locationName": "Rule"
	          }
	        }
	      },
	      "deprecated": true
	    },
	    "GetBucketLifecycleConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?lifecycle"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Rules": {
	            "shape": "S5t",
	            "locationName": "Rule"
	          }
	        }
	      }
	    },
	    "GetBucketLocation": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?location"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LocationConstraint": {}
	        }
	      }
	    },
	    "GetBucketLogging": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?logging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LoggingEnabled": {
	            "shape": "S65"
	          }
	        }
	      }
	    },
	    "GetBucketMetricsConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?metrics"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "MetricsConfiguration": {
	            "shape": "S6d"
	          }
	        },
	        "payload": "MetricsConfiguration"
	      }
	    },
	    "GetBucketNotification": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?notification"
	      },
	      "input": {
	        "shape": "S6h"
	      },
	      "output": {
	        "shape": "S6i"
	      },
	      "deprecated": true
	    },
	    "GetBucketNotificationConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?notification"
	      },
	      "input": {
	        "shape": "S6h"
	      },
	      "output": {
	        "shape": "S6t"
	      }
	    },
	    "GetBucketOwnershipControls": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?ownershipControls"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OwnershipControls": {
	            "shape": "S7a"
	          }
	        },
	        "payload": "OwnershipControls"
	      }
	    },
	    "GetBucketPolicy": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?policy"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Policy": {}
	        },
	        "payload": "Policy"
	      }
	    },
	    "GetBucketPolicyStatus": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?policyStatus"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PolicyStatus": {
	            "type": "structure",
	            "members": {
	              "IsPublic": {
	                "locationName": "IsPublic",
	                "type": "boolean"
	              }
	            }
	          }
	        },
	        "payload": "PolicyStatus"
	      }
	    },
	    "GetBucketReplication": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?replication"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ReplicationConfiguration": {
	            "shape": "S7m"
	          }
	        },
	        "payload": "ReplicationConfiguration"
	      }
	    },
	    "GetBucketRequestPayment": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?requestPayment"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Payer": {}
	        }
	      }
	    },
	    "GetBucketTagging": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?tagging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TagSet"
	        ],
	        "members": {
	          "TagSet": {
	            "shape": "S3v"
	          }
	        }
	      }
	    },
	    "GetBucketVersioning": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?versioning"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Status": {},
	          "MFADelete": {
	            "locationName": "MfaDelete"
	          }
	        }
	      }
	    },
	    "GetBucketWebsite": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?website"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RedirectAllRequestsTo": {
	            "shape": "S8p"
	          },
	          "IndexDocument": {
	            "shape": "S8s"
	          },
	          "ErrorDocument": {
	            "shape": "S8u"
	          },
	          "RoutingRules": {
	            "shape": "S8v"
	          }
	        }
	      }
	    },
	    "GetObject": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}/{Key+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          },
	          "IfModifiedSince": {
	            "location": "header",
	            "locationName": "If-Modified-Since",
	            "type": "timestamp"
	          },
	          "IfNoneMatch": {
	            "location": "header",
	            "locationName": "If-None-Match"
	          },
	          "IfUnmodifiedSince": {
	            "location": "header",
	            "locationName": "If-Unmodified-Since",
	            "type": "timestamp"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "Range": {
	            "location": "header",
	            "locationName": "Range"
	          },
	          "ResponseCacheControl": {
	            "location": "querystring",
	            "locationName": "response-cache-control"
	          },
	          "ResponseContentDisposition": {
	            "location": "querystring",
	            "locationName": "response-content-disposition"
	          },
	          "ResponseContentEncoding": {
	            "location": "querystring",
	            "locationName": "response-content-encoding"
	          },
	          "ResponseContentLanguage": {
	            "location": "querystring",
	            "locationName": "response-content-language"
	          },
	          "ResponseContentType": {
	            "location": "querystring",
	            "locationName": "response-content-type"
	          },
	          "ResponseExpires": {
	            "location": "querystring",
	            "locationName": "response-expires",
	            "type": "timestamp",
	            "timestampFormat": "rfc822"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKey": {
	            "shape": "Sk",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "PartNumber": {
	            "location": "querystring",
	            "locationName": "partNumber",
	            "type": "integer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "ChecksumMode": {
	            "location": "header",
	            "locationName": "x-amz-checksum-mode"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Body": {
	            "streaming": true,
	            "type": "blob"
	          },
	          "DeleteMarker": {
	            "location": "header",
	            "locationName": "x-amz-delete-marker",
	            "type": "boolean"
	          },
	          "AcceptRanges": {
	            "location": "header",
	            "locationName": "accept-ranges"
	          },
	          "Expiration": {
	            "location": "header",
	            "locationName": "x-amz-expiration"
	          },
	          "Restore": {
	            "location": "header",
	            "locationName": "x-amz-restore"
	          },
	          "LastModified": {
	            "location": "header",
	            "locationName": "Last-Modified",
	            "type": "timestamp"
	          },
	          "ContentLength": {
	            "location": "header",
	            "locationName": "Content-Length",
	            "type": "long"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          },
	          "ChecksumCRC32": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32"
	          },
	          "ChecksumCRC32C": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32c"
	          },
	          "ChecksumSHA1": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha1"
	          },
	          "ChecksumSHA256": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha256"
	          },
	          "MissingMeta": {
	            "location": "header",
	            "locationName": "x-amz-missing-meta",
	            "type": "integer"
	          },
	          "VersionId": {
	            "location": "header",
	            "locationName": "x-amz-version-id"
	          },
	          "CacheControl": {
	            "location": "header",
	            "locationName": "Cache-Control"
	          },
	          "ContentDisposition": {
	            "location": "header",
	            "locationName": "Content-Disposition"
	          },
	          "ContentEncoding": {
	            "location": "header",
	            "locationName": "Content-Encoding"
	          },
	          "ContentLanguage": {
	            "location": "header",
	            "locationName": "Content-Language"
	          },
	          "ContentRange": {
	            "location": "header",
	            "locationName": "Content-Range"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "Expires": {
	            "location": "header",
	            "locationName": "Expires",
	            "type": "timestamp"
	          },
	          "WebsiteRedirectLocation": {
	            "location": "header",
	            "locationName": "x-amz-website-redirect-location"
	          },
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption"
	          },
	          "Metadata": {
	            "shape": "S1b",
	            "location": "headers",
	            "locationName": "x-amz-meta-"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          },
	          "StorageClass": {
	            "location": "header",
	            "locationName": "x-amz-storage-class"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          },
	          "ReplicationStatus": {
	            "location": "header",
	            "locationName": "x-amz-replication-status"
	          },
	          "PartsCount": {
	            "location": "header",
	            "locationName": "x-amz-mp-parts-count",
	            "type": "integer"
	          },
	          "TagCount": {
	            "location": "header",
	            "locationName": "x-amz-tagging-count",
	            "type": "integer"
	          },
	          "ObjectLockMode": {
	            "location": "header",
	            "locationName": "x-amz-object-lock-mode"
	          },
	          "ObjectLockRetainUntilDate": {
	            "shape": "S1o",
	            "location": "header",
	            "locationName": "x-amz-object-lock-retain-until-date"
	          },
	          "ObjectLockLegalHoldStatus": {
	            "location": "header",
	            "locationName": "x-amz-object-lock-legal-hold"
	          }
	        },
	        "payload": "Body"
	      },
	      "httpChecksum": {
	        "requestValidationModeMember": "ChecksumMode",
	        "responseAlgorithms": [
	          "CRC32",
	          "CRC32C",
	          "SHA256",
	          "SHA1"
	        ]
	      }
	    },
	    "GetObjectAcl": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}/{Key+}?acl"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Owner": {
	            "shape": "S3d"
	          },
	          "Grants": {
	            "shape": "S3g",
	            "locationName": "AccessControlList"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        }
	      }
	    },
	    "GetObjectAttributes": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}/{Key+}?attributes"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key",
	          "ObjectAttributes"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "MaxParts": {
	            "location": "header",
	            "locationName": "x-amz-max-parts",
	            "type": "integer"
	          },
	          "PartNumberMarker": {
	            "location": "header",
	            "locationName": "x-amz-part-number-marker",
	            "type": "integer"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKey": {
	            "shape": "Sk",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "ObjectAttributes": {
	            "location": "header",
	            "locationName": "x-amz-object-attributes",
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeleteMarker": {
	            "location": "header",
	            "locationName": "x-amz-delete-marker",
	            "type": "boolean"
	          },
	          "LastModified": {
	            "location": "header",
	            "locationName": "Last-Modified",
	            "type": "timestamp"
	          },
	          "VersionId": {
	            "location": "header",
	            "locationName": "x-amz-version-id"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          },
	          "ETag": {},
	          "Checksum": {
	            "type": "structure",
	            "members": {
	              "ChecksumCRC32": {},
	              "ChecksumCRC32C": {},
	              "ChecksumSHA1": {},
	              "ChecksumSHA256": {}
	            }
	          },
	          "ObjectParts": {
	            "type": "structure",
	            "members": {
	              "TotalPartsCount": {
	                "locationName": "PartsCount",
	                "type": "integer"
	              },
	              "PartNumberMarker": {
	                "type": "integer"
	              },
	              "NextPartNumberMarker": {
	                "type": "integer"
	              },
	              "MaxParts": {
	                "type": "integer"
	              },
	              "IsTruncated": {
	                "type": "boolean"
	              },
	              "Parts": {
	                "locationName": "Part",
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "PartNumber": {
	                      "type": "integer"
	                    },
	                    "Size": {
	                      "type": "integer"
	                    },
	                    "ChecksumCRC32": {},
	                    "ChecksumCRC32C": {},
	                    "ChecksumSHA1": {},
	                    "ChecksumSHA256": {}
	                  }
	                },
	                "flattened": true
	              }
	            }
	          },
	          "StorageClass": {},
	          "ObjectSize": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "GetObjectLegalHold": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}/{Key+}?legal-hold"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LegalHold": {
	            "shape": "Sa9"
	          }
	        },
	        "payload": "LegalHold"
	      }
	    },
	    "GetObjectLockConfiguration": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?object-lock"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ObjectLockConfiguration": {
	            "shape": "Sac"
	          }
	        },
	        "payload": "ObjectLockConfiguration"
	      }
	    },
	    "GetObjectRetention": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}/{Key+}?retention"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Retention": {
	            "shape": "Sak"
	          }
	        },
	        "payload": "Retention"
	      }
	    },
	    "GetObjectTagging": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}/{Key+}?tagging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TagSet"
	        ],
	        "members": {
	          "VersionId": {
	            "location": "header",
	            "locationName": "x-amz-version-id"
	          },
	          "TagSet": {
	            "shape": "S3v"
	          }
	        }
	      }
	    },
	    "GetObjectTorrent": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}/{Key+}?torrent"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Body": {
	            "streaming": true,
	            "type": "blob"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        },
	        "payload": "Body"
	      }
	    },
	    "GetPublicAccessBlock": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?publicAccessBlock"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PublicAccessBlockConfiguration": {
	            "shape": "Sar"
	          }
	        },
	        "payload": "PublicAccessBlockConfiguration"
	      }
	    },
	    "HeadBucket": {
	      "http": {
	        "method": "HEAD",
	        "requestUri": "/{Bucket}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      }
	    },
	    "HeadObject": {
	      "http": {
	        "method": "HEAD",
	        "requestUri": "/{Bucket}/{Key+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "IfMatch": {
	            "location": "header",
	            "locationName": "If-Match"
	          },
	          "IfModifiedSince": {
	            "location": "header",
	            "locationName": "If-Modified-Since",
	            "type": "timestamp"
	          },
	          "IfNoneMatch": {
	            "location": "header",
	            "locationName": "If-None-Match"
	          },
	          "IfUnmodifiedSince": {
	            "location": "header",
	            "locationName": "If-Unmodified-Since",
	            "type": "timestamp"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "Range": {
	            "location": "header",
	            "locationName": "Range"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKey": {
	            "shape": "Sk",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "PartNumber": {
	            "location": "querystring",
	            "locationName": "partNumber",
	            "type": "integer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "ChecksumMode": {
	            "location": "header",
	            "locationName": "x-amz-checksum-mode"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeleteMarker": {
	            "location": "header",
	            "locationName": "x-amz-delete-marker",
	            "type": "boolean"
	          },
	          "AcceptRanges": {
	            "location": "header",
	            "locationName": "accept-ranges"
	          },
	          "Expiration": {
	            "location": "header",
	            "locationName": "x-amz-expiration"
	          },
	          "Restore": {
	            "location": "header",
	            "locationName": "x-amz-restore"
	          },
	          "ArchiveStatus": {
	            "location": "header",
	            "locationName": "x-amz-archive-status"
	          },
	          "LastModified": {
	            "location": "header",
	            "locationName": "Last-Modified",
	            "type": "timestamp"
	          },
	          "ContentLength": {
	            "location": "header",
	            "locationName": "Content-Length",
	            "type": "long"
	          },
	          "ChecksumCRC32": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32"
	          },
	          "ChecksumCRC32C": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32c"
	          },
	          "ChecksumSHA1": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha1"
	          },
	          "ChecksumSHA256": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha256"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          },
	          "MissingMeta": {
	            "location": "header",
	            "locationName": "x-amz-missing-meta",
	            "type": "integer"
	          },
	          "VersionId": {
	            "location": "header",
	            "locationName": "x-amz-version-id"
	          },
	          "CacheControl": {
	            "location": "header",
	            "locationName": "Cache-Control"
	          },
	          "ContentDisposition": {
	            "location": "header",
	            "locationName": "Content-Disposition"
	          },
	          "ContentEncoding": {
	            "location": "header",
	            "locationName": "Content-Encoding"
	          },
	          "ContentLanguage": {
	            "location": "header",
	            "locationName": "Content-Language"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "Expires": {
	            "location": "header",
	            "locationName": "Expires",
	            "type": "timestamp"
	          },
	          "WebsiteRedirectLocation": {
	            "location": "header",
	            "locationName": "x-amz-website-redirect-location"
	          },
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption"
	          },
	          "Metadata": {
	            "shape": "S1b",
	            "location": "headers",
	            "locationName": "x-amz-meta-"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          },
	          "StorageClass": {
	            "location": "header",
	            "locationName": "x-amz-storage-class"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          },
	          "ReplicationStatus": {
	            "location": "header",
	            "locationName": "x-amz-replication-status"
	          },
	          "PartsCount": {
	            "location": "header",
	            "locationName": "x-amz-mp-parts-count",
	            "type": "integer"
	          },
	          "ObjectLockMode": {
	            "location": "header",
	            "locationName": "x-amz-object-lock-mode"
	          },
	          "ObjectLockRetainUntilDate": {
	            "shape": "S1o",
	            "location": "header",
	            "locationName": "x-amz-object-lock-retain-until-date"
	          },
	          "ObjectLockLegalHoldStatus": {
	            "location": "header",
	            "locationName": "x-amz-object-lock-legal-hold"
	          }
	        }
	      }
	    },
	    "ListBucketAnalyticsConfigurations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?analytics"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContinuationToken": {
	            "location": "querystring",
	            "locationName": "continuation-token"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "ContinuationToken": {},
	          "NextContinuationToken": {},
	          "AnalyticsConfigurationList": {
	            "locationName": "AnalyticsConfiguration",
	            "type": "list",
	            "member": {
	              "shape": "S3p"
	            },
	            "flattened": true
	          }
	        }
	      }
	    },
	    "ListBucketIntelligentTieringConfigurations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?intelligent-tiering"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContinuationToken": {
	            "location": "querystring",
	            "locationName": "continuation-token"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "ContinuationToken": {},
	          "NextContinuationToken": {},
	          "IntelligentTieringConfigurationList": {
	            "locationName": "IntelligentTieringConfiguration",
	            "type": "list",
	            "member": {
	              "shape": "S4n"
	            },
	            "flattened": true
	          }
	        }
	      }
	    },
	    "ListBucketInventoryConfigurations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?inventory"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContinuationToken": {
	            "location": "querystring",
	            "locationName": "continuation-token"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ContinuationToken": {},
	          "InventoryConfigurationList": {
	            "locationName": "InventoryConfiguration",
	            "type": "list",
	            "member": {
	              "shape": "S4x"
	            },
	            "flattened": true
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "NextContinuationToken": {}
	        }
	      }
	    },
	    "ListBucketMetricsConfigurations": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?metrics"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContinuationToken": {
	            "location": "querystring",
	            "locationName": "continuation-token"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "ContinuationToken": {},
	          "NextContinuationToken": {},
	          "MetricsConfigurationList": {
	            "locationName": "MetricsConfiguration",
	            "type": "list",
	            "member": {
	              "shape": "S6d"
	            },
	            "flattened": true
	          }
	        }
	      }
	    },
	    "ListBuckets": {
	      "http": {
	        "method": "GET"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Buckets": {
	            "type": "list",
	            "member": {
	              "locationName": "Bucket",
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "CreationDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "Owner": {
	            "shape": "S3d"
	          }
	        }
	      },
	      "alias": "GetService"
	    },
	    "ListMultipartUploads": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?uploads"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Delimiter": {
	            "location": "querystring",
	            "locationName": "delimiter"
	          },
	          "EncodingType": {
	            "location": "querystring",
	            "locationName": "encoding-type"
	          },
	          "KeyMarker": {
	            "location": "querystring",
	            "locationName": "key-marker"
	          },
	          "MaxUploads": {
	            "location": "querystring",
	            "locationName": "max-uploads",
	            "type": "integer"
	          },
	          "Prefix": {
	            "location": "querystring",
	            "locationName": "prefix"
	          },
	          "UploadIdMarker": {
	            "location": "querystring",
	            "locationName": "upload-id-marker"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Bucket": {},
	          "KeyMarker": {},
	          "UploadIdMarker": {},
	          "NextKeyMarker": {},
	          "Prefix": {},
	          "Delimiter": {},
	          "NextUploadIdMarker": {},
	          "MaxUploads": {
	            "type": "integer"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Uploads": {
	            "locationName": "Upload",
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "UploadId": {},
	                "Key": {},
	                "Initiated": {
	                  "type": "timestamp"
	                },
	                "StorageClass": {},
	                "Owner": {
	                  "shape": "S3d"
	                },
	                "Initiator": {
	                  "shape": "Sbr"
	                },
	                "ChecksumAlgorithm": {}
	              }
	            },
	            "flattened": true
	          },
	          "CommonPrefixes": {
	            "shape": "Sbs"
	          },
	          "EncodingType": {}
	        }
	      }
	    },
	    "ListObjectVersions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?versions"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Delimiter": {
	            "location": "querystring",
	            "locationName": "delimiter"
	          },
	          "EncodingType": {
	            "location": "querystring",
	            "locationName": "encoding-type"
	          },
	          "KeyMarker": {
	            "location": "querystring",
	            "locationName": "key-marker"
	          },
	          "MaxKeys": {
	            "location": "querystring",
	            "locationName": "max-keys",
	            "type": "integer"
	          },
	          "Prefix": {
	            "location": "querystring",
	            "locationName": "prefix"
	          },
	          "VersionIdMarker": {
	            "location": "querystring",
	            "locationName": "version-id-marker"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "KeyMarker": {},
	          "VersionIdMarker": {},
	          "NextKeyMarker": {},
	          "NextVersionIdMarker": {},
	          "Versions": {
	            "locationName": "Version",
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ETag": {},
	                "ChecksumAlgorithm": {
	                  "shape": "Sc1"
	                },
	                "Size": {
	                  "type": "integer"
	                },
	                "StorageClass": {},
	                "Key": {},
	                "VersionId": {},
	                "IsLatest": {
	                  "type": "boolean"
	                },
	                "LastModified": {
	                  "type": "timestamp"
	                },
	                "Owner": {
	                  "shape": "S3d"
	                }
	              }
	            },
	            "flattened": true
	          },
	          "DeleteMarkers": {
	            "locationName": "DeleteMarker",
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Owner": {
	                  "shape": "S3d"
	                },
	                "Key": {},
	                "VersionId": {},
	                "IsLatest": {
	                  "type": "boolean"
	                },
	                "LastModified": {
	                  "type": "timestamp"
	                }
	              }
	            },
	            "flattened": true
	          },
	          "Name": {},
	          "Prefix": {},
	          "Delimiter": {},
	          "MaxKeys": {
	            "type": "integer"
	          },
	          "CommonPrefixes": {
	            "shape": "Sbs"
	          },
	          "EncodingType": {}
	        }
	      },
	      "alias": "GetBucketObjectVersions"
	    },
	    "ListObjects": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Delimiter": {
	            "location": "querystring",
	            "locationName": "delimiter"
	          },
	          "EncodingType": {
	            "location": "querystring",
	            "locationName": "encoding-type"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "MaxKeys": {
	            "location": "querystring",
	            "locationName": "max-keys",
	            "type": "integer"
	          },
	          "Prefix": {
	            "location": "querystring",
	            "locationName": "prefix"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Marker": {},
	          "NextMarker": {},
	          "Contents": {
	            "shape": "Sca"
	          },
	          "Name": {},
	          "Prefix": {},
	          "Delimiter": {},
	          "MaxKeys": {
	            "type": "integer"
	          },
	          "CommonPrefixes": {
	            "shape": "Sbs"
	          },
	          "EncodingType": {}
	        }
	      },
	      "alias": "GetBucket"
	    },
	    "ListObjectsV2": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}?list-type=2"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Delimiter": {
	            "location": "querystring",
	            "locationName": "delimiter"
	          },
	          "EncodingType": {
	            "location": "querystring",
	            "locationName": "encoding-type"
	          },
	          "MaxKeys": {
	            "location": "querystring",
	            "locationName": "max-keys",
	            "type": "integer"
	          },
	          "Prefix": {
	            "location": "querystring",
	            "locationName": "prefix"
	          },
	          "ContinuationToken": {
	            "location": "querystring",
	            "locationName": "continuation-token"
	          },
	          "FetchOwner": {
	            "location": "querystring",
	            "locationName": "fetch-owner",
	            "type": "boolean"
	          },
	          "StartAfter": {
	            "location": "querystring",
	            "locationName": "start-after"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Contents": {
	            "shape": "Sca"
	          },
	          "Name": {},
	          "Prefix": {},
	          "Delimiter": {},
	          "MaxKeys": {
	            "type": "integer"
	          },
	          "CommonPrefixes": {
	            "shape": "Sbs"
	          },
	          "EncodingType": {},
	          "KeyCount": {
	            "type": "integer"
	          },
	          "ContinuationToken": {},
	          "NextContinuationToken": {},
	          "StartAfter": {}
	        }
	      }
	    },
	    "ListParts": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/{Bucket}/{Key+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key",
	          "UploadId"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "MaxParts": {
	            "location": "querystring",
	            "locationName": "max-parts",
	            "type": "integer"
	          },
	          "PartNumberMarker": {
	            "location": "querystring",
	            "locationName": "part-number-marker",
	            "type": "integer"
	          },
	          "UploadId": {
	            "location": "querystring",
	            "locationName": "uploadId"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKey": {
	            "shape": "Sk",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AbortDate": {
	            "location": "header",
	            "locationName": "x-amz-abort-date",
	            "type": "timestamp"
	          },
	          "AbortRuleId": {
	            "location": "header",
	            "locationName": "x-amz-abort-rule-id"
	          },
	          "Bucket": {},
	          "Key": {},
	          "UploadId": {},
	          "PartNumberMarker": {
	            "type": "integer"
	          },
	          "NextPartNumberMarker": {
	            "type": "integer"
	          },
	          "MaxParts": {
	            "type": "integer"
	          },
	          "IsTruncated": {
	            "type": "boolean"
	          },
	          "Parts": {
	            "locationName": "Part",
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PartNumber": {
	                  "type": "integer"
	                },
	                "LastModified": {
	                  "type": "timestamp"
	                },
	                "ETag": {},
	                "Size": {
	                  "type": "integer"
	                },
	                "ChecksumCRC32": {},
	                "ChecksumCRC32C": {},
	                "ChecksumSHA1": {},
	                "ChecksumSHA256": {}
	              }
	            },
	            "flattened": true
	          },
	          "Initiator": {
	            "shape": "Sbr"
	          },
	          "Owner": {
	            "shape": "S3d"
	          },
	          "StorageClass": {},
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          },
	          "ChecksumAlgorithm": {}
	        }
	      }
	    },
	    "PutBucketAccelerateConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?accelerate"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "AccelerateConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "AccelerateConfiguration": {
	            "locationName": "AccelerateConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "members": {
	              "Status": {}
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          }
	        },
	        "payload": "AccelerateConfiguration"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": false
	      }
	    },
	    "PutBucketAcl": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?acl"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "ACL": {
	            "location": "header",
	            "locationName": "x-amz-acl"
	          },
	          "AccessControlPolicy": {
	            "shape": "Scp",
	            "locationName": "AccessControlPolicy",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "GrantFullControl": {
	            "location": "header",
	            "locationName": "x-amz-grant-full-control"
	          },
	          "GrantRead": {
	            "location": "header",
	            "locationName": "x-amz-grant-read"
	          },
	          "GrantReadACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-read-acp"
	          },
	          "GrantWrite": {
	            "location": "header",
	            "locationName": "x-amz-grant-write"
	          },
	          "GrantWriteACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-write-acp"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "AccessControlPolicy"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketAnalyticsConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?analytics"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id",
	          "AnalyticsConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "AnalyticsConfiguration": {
	            "shape": "S3p",
	            "locationName": "AnalyticsConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "AnalyticsConfiguration"
	      }
	    },
	    "PutBucketCors": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?cors"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "CORSConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "CORSConfiguration": {
	            "locationName": "CORSConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "required": [
	              "CORSRules"
	            ],
	            "members": {
	              "CORSRules": {
	                "shape": "S44",
	                "locationName": "CORSRule"
	              }
	            }
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "CORSConfiguration"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketEncryption": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?encryption"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "ServerSideEncryptionConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "ServerSideEncryptionConfiguration": {
	            "shape": "S4h",
	            "locationName": "ServerSideEncryptionConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "ServerSideEncryptionConfiguration"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketIntelligentTieringConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?intelligent-tiering"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id",
	          "IntelligentTieringConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "IntelligentTieringConfiguration": {
	            "shape": "S4n",
	            "locationName": "IntelligentTieringConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          }
	        },
	        "payload": "IntelligentTieringConfiguration"
	      }
	    },
	    "PutBucketInventoryConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?inventory"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id",
	          "InventoryConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "InventoryConfiguration": {
	            "shape": "S4x",
	            "locationName": "InventoryConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "InventoryConfiguration"
	      }
	    },
	    "PutBucketLifecycle": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?lifecycle"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "LifecycleConfiguration": {
	            "locationName": "LifecycleConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "required": [
	              "Rules"
	            ],
	            "members": {
	              "Rules": {
	                "shape": "S5d",
	                "locationName": "Rule"
	              }
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "LifecycleConfiguration"
	      },
	      "deprecated": true,
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketLifecycleConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?lifecycle"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "LifecycleConfiguration": {
	            "locationName": "LifecycleConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "required": [
	              "Rules"
	            ],
	            "members": {
	              "Rules": {
	                "shape": "S5t",
	                "locationName": "Rule"
	              }
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "LifecycleConfiguration"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketLogging": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?logging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "BucketLoggingStatus"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "BucketLoggingStatus": {
	            "locationName": "BucketLoggingStatus",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "members": {
	              "LoggingEnabled": {
	                "shape": "S65"
	              }
	            }
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "BucketLoggingStatus"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketMetricsConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?metrics"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Id",
	          "MetricsConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Id": {
	            "location": "querystring",
	            "locationName": "id"
	          },
	          "MetricsConfiguration": {
	            "shape": "S6d",
	            "locationName": "MetricsConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "MetricsConfiguration"
	      }
	    },
	    "PutBucketNotification": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?notification"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "NotificationConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "NotificationConfiguration": {
	            "shape": "S6i",
	            "locationName": "NotificationConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "NotificationConfiguration"
	      },
	      "deprecated": true,
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketNotificationConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?notification"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "NotificationConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "NotificationConfiguration": {
	            "shape": "S6t",
	            "locationName": "NotificationConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "SkipDestinationValidation": {
	            "location": "header",
	            "locationName": "x-amz-skip-destination-validation",
	            "type": "boolean"
	          }
	        },
	        "payload": "NotificationConfiguration"
	      }
	    },
	    "PutBucketOwnershipControls": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?ownershipControls"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "OwnershipControls"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "OwnershipControls": {
	            "shape": "S7a",
	            "locationName": "OwnershipControls",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          }
	        },
	        "payload": "OwnershipControls"
	      },
	      "httpChecksum": {
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketPolicy": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?policy"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Policy"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "ConfirmRemoveSelfBucketAccess": {
	            "location": "header",
	            "locationName": "x-amz-confirm-remove-self-bucket-access",
	            "type": "boolean"
	          },
	          "Policy": {},
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "Policy"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketReplication": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?replication"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "ReplicationConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "ReplicationConfiguration": {
	            "shape": "S7m",
	            "locationName": "ReplicationConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "Token": {
	            "location": "header",
	            "locationName": "x-amz-bucket-object-lock-token"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "ReplicationConfiguration"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketRequestPayment": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?requestPayment"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "RequestPaymentConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "RequestPaymentConfiguration": {
	            "locationName": "RequestPaymentConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "required": [
	              "Payer"
	            ],
	            "members": {
	              "Payer": {}
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "RequestPaymentConfiguration"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketTagging": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?tagging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Tagging"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "Tagging": {
	            "shape": "Sdf",
	            "locationName": "Tagging",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "Tagging"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketVersioning": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?versioning"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "VersioningConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "MFA": {
	            "location": "header",
	            "locationName": "x-amz-mfa"
	          },
	          "VersioningConfiguration": {
	            "locationName": "VersioningConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "members": {
	              "MFADelete": {
	                "locationName": "MfaDelete"
	              },
	              "Status": {}
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "VersioningConfiguration"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutBucketWebsite": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?website"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "WebsiteConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "WebsiteConfiguration": {
	            "locationName": "WebsiteConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "members": {
	              "ErrorDocument": {
	                "shape": "S8u"
	              },
	              "IndexDocument": {
	                "shape": "S8s"
	              },
	              "RedirectAllRequestsTo": {
	                "shape": "S8p"
	              },
	              "RoutingRules": {
	                "shape": "S8v"
	              }
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "WebsiteConfiguration"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutObject": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}/{Key+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "ACL": {
	            "location": "header",
	            "locationName": "x-amz-acl"
	          },
	          "Body": {
	            "streaming": true,
	            "type": "blob"
	          },
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "CacheControl": {
	            "location": "header",
	            "locationName": "Cache-Control"
	          },
	          "ContentDisposition": {
	            "location": "header",
	            "locationName": "Content-Disposition"
	          },
	          "ContentEncoding": {
	            "location": "header",
	            "locationName": "Content-Encoding"
	          },
	          "ContentLanguage": {
	            "location": "header",
	            "locationName": "Content-Language"
	          },
	          "ContentLength": {
	            "location": "header",
	            "locationName": "Content-Length",
	            "type": "long"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "Content-Type"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "ChecksumCRC32": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32"
	          },
	          "ChecksumCRC32C": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32c"
	          },
	          "ChecksumSHA1": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha1"
	          },
	          "ChecksumSHA256": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha256"
	          },
	          "Expires": {
	            "location": "header",
	            "locationName": "Expires",
	            "type": "timestamp"
	          },
	          "GrantFullControl": {
	            "location": "header",
	            "locationName": "x-amz-grant-full-control"
	          },
	          "GrantRead": {
	            "location": "header",
	            "locationName": "x-amz-grant-read"
	          },
	          "GrantReadACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-read-acp"
	          },
	          "GrantWriteACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-write-acp"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "Metadata": {
	            "shape": "S1b",
	            "location": "headers",
	            "locationName": "x-amz-meta-"
	          },
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption"
	          },
	          "StorageClass": {
	            "location": "header",
	            "locationName": "x-amz-storage-class"
	          },
	          "WebsiteRedirectLocation": {
	            "location": "header",
	            "locationName": "x-amz-website-redirect-location"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKey": {
	            "shape": "Sk",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "SSEKMSEncryptionContext": {
	            "shape": "S1i",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-context"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "Tagging": {
	            "location": "header",
	            "locationName": "x-amz-tagging"
	          },
	          "ObjectLockMode": {
	            "location": "header",
	            "locationName": "x-amz-object-lock-mode"
	          },
	          "ObjectLockRetainUntilDate": {
	            "shape": "S1o",
	            "location": "header",
	            "locationName": "x-amz-object-lock-retain-until-date"
	          },
	          "ObjectLockLegalHoldStatus": {
	            "location": "header",
	            "locationName": "x-amz-object-lock-legal-hold"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "Body"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Expiration": {
	            "location": "header",
	            "locationName": "x-amz-expiration"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          },
	          "ChecksumCRC32": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32"
	          },
	          "ChecksumCRC32C": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32c"
	          },
	          "ChecksumSHA1": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha1"
	          },
	          "ChecksumSHA256": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha256"
	          },
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption"
	          },
	          "VersionId": {
	            "location": "header",
	            "locationName": "x-amz-version-id"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "SSEKMSEncryptionContext": {
	            "shape": "S1i",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-context"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        }
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": false
	      }
	    },
	    "PutObjectAcl": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}/{Key+}?acl"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "ACL": {
	            "location": "header",
	            "locationName": "x-amz-acl"
	          },
	          "AccessControlPolicy": {
	            "shape": "Scp",
	            "locationName": "AccessControlPolicy",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "GrantFullControl": {
	            "location": "header",
	            "locationName": "x-amz-grant-full-control"
	          },
	          "GrantRead": {
	            "location": "header",
	            "locationName": "x-amz-grant-read"
	          },
	          "GrantReadACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-read-acp"
	          },
	          "GrantWrite": {
	            "location": "header",
	            "locationName": "x-amz-grant-write"
	          },
	          "GrantWriteACP": {
	            "location": "header",
	            "locationName": "x-amz-grant-write-acp"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "AccessControlPolicy"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        }
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutObjectLegalHold": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}/{Key+}?legal-hold"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "LegalHold": {
	            "shape": "Sa9",
	            "locationName": "LegalHold",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "LegalHold"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        }
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutObjectLockConfiguration": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?object-lock"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ObjectLockConfiguration": {
	            "shape": "Sac",
	            "locationName": "ObjectLockConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "Token": {
	            "location": "header",
	            "locationName": "x-amz-bucket-object-lock-token"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "ObjectLockConfiguration"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        }
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutObjectRetention": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}/{Key+}?retention"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "Retention": {
	            "shape": "Sak",
	            "locationName": "Retention",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "BypassGovernanceRetention": {
	            "location": "header",
	            "locationName": "x-amz-bypass-governance-retention",
	            "type": "boolean"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "Retention"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        }
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutObjectTagging": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}/{Key+}?tagging"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key",
	          "Tagging"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "Tagging": {
	            "shape": "Sdf",
	            "locationName": "Tagging",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          }
	        },
	        "payload": "Tagging"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VersionId": {
	            "location": "header",
	            "locationName": "x-amz-version-id"
	          }
	        }
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "PutPublicAccessBlock": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}?publicAccessBlock"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "PublicAccessBlockConfiguration"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "PublicAccessBlockConfiguration": {
	            "shape": "Sar",
	            "locationName": "PublicAccessBlockConfiguration",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "PublicAccessBlockConfiguration"
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": true
	      }
	    },
	    "RestoreObject": {
	      "http": {
	        "requestUri": "/{Bucket}/{Key+}?restore"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "RestoreRequest": {
	            "locationName": "RestoreRequest",
	            "xmlNamespace": {
	              "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	            },
	            "type": "structure",
	            "members": {
	              "Days": {
	                "type": "integer"
	              },
	              "GlacierJobParameters": {
	                "type": "structure",
	                "required": [
	                  "Tier"
	                ],
	                "members": {
	                  "Tier": {}
	                }
	              },
	              "Type": {},
	              "Tier": {},
	              "Description": {},
	              "SelectParameters": {
	                "type": "structure",
	                "required": [
	                  "InputSerialization",
	                  "ExpressionType",
	                  "Expression",
	                  "OutputSerialization"
	                ],
	                "members": {
	                  "InputSerialization": {
	                    "shape": "Se5"
	                  },
	                  "ExpressionType": {},
	                  "Expression": {},
	                  "OutputSerialization": {
	                    "shape": "Sek"
	                  }
	                }
	              },
	              "OutputLocation": {
	                "type": "structure",
	                "members": {
	                  "S3": {
	                    "type": "structure",
	                    "required": [
	                      "BucketName",
	                      "Prefix"
	                    ],
	                    "members": {
	                      "BucketName": {},
	                      "Prefix": {},
	                      "Encryption": {
	                        "type": "structure",
	                        "required": [
	                          "EncryptionType"
	                        ],
	                        "members": {
	                          "EncryptionType": {},
	                          "KMSKeyId": {
	                            "shape": "Sr"
	                          },
	                          "KMSContext": {}
	                        }
	                      },
	                      "CannedACL": {},
	                      "AccessControlList": {
	                        "shape": "S3g"
	                      },
	                      "Tagging": {
	                        "shape": "Sdf"
	                      },
	                      "UserMetadata": {
	                        "type": "list",
	                        "member": {
	                          "locationName": "MetadataEntry",
	                          "type": "structure",
	                          "members": {
	                            "Name": {},
	                            "Value": {}
	                          }
	                        }
	                      },
	                      "StorageClass": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "RestoreRequest"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          },
	          "RestoreOutputPath": {
	            "location": "header",
	            "locationName": "x-amz-restore-output-path"
	          }
	        }
	      },
	      "alias": "PostObjectRestore",
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": false
	      }
	    },
	    "SelectObjectContent": {
	      "http": {
	        "requestUri": "/{Bucket}/{Key+}?select&select-type=2"
	      },
	      "input": {
	        "locationName": "SelectObjectContentRequest",
	        "xmlNamespace": {
	          "uri": "http://s3.amazonaws.com/doc/2006-03-01/"
	        },
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key",
	          "Expression",
	          "ExpressionType",
	          "InputSerialization",
	          "OutputSerialization"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKey": {
	            "shape": "Sk",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "Expression": {},
	          "ExpressionType": {},
	          "RequestProgress": {
	            "type": "structure",
	            "members": {
	              "Enabled": {
	                "type": "boolean"
	              }
	            }
	          },
	          "InputSerialization": {
	            "shape": "Se5"
	          },
	          "OutputSerialization": {
	            "shape": "Sek"
	          },
	          "ScanRange": {
	            "type": "structure",
	            "members": {
	              "Start": {
	                "type": "long"
	              },
	              "End": {
	                "type": "long"
	              }
	            }
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Payload": {
	            "type": "structure",
	            "members": {
	              "Records": {
	                "type": "structure",
	                "members": {
	                  "Payload": {
	                    "eventpayload": true,
	                    "type": "blob"
	                  }
	                },
	                "event": true
	              },
	              "Stats": {
	                "type": "structure",
	                "members": {
	                  "Details": {
	                    "eventpayload": true,
	                    "type": "structure",
	                    "members": {
	                      "BytesScanned": {
	                        "type": "long"
	                      },
	                      "BytesProcessed": {
	                        "type": "long"
	                      },
	                      "BytesReturned": {
	                        "type": "long"
	                      }
	                    }
	                  }
	                },
	                "event": true
	              },
	              "Progress": {
	                "type": "structure",
	                "members": {
	                  "Details": {
	                    "eventpayload": true,
	                    "type": "structure",
	                    "members": {
	                      "BytesScanned": {
	                        "type": "long"
	                      },
	                      "BytesProcessed": {
	                        "type": "long"
	                      },
	                      "BytesReturned": {
	                        "type": "long"
	                      }
	                    }
	                  }
	                },
	                "event": true
	              },
	              "Cont": {
	                "type": "structure",
	                "members": {},
	                "event": true
	              },
	              "End": {
	                "type": "structure",
	                "members": {},
	                "event": true
	              }
	            },
	            "eventstream": true
	          }
	        },
	        "payload": "Payload"
	      }
	    },
	    "UploadPart": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}/{Key+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "Key",
	          "PartNumber",
	          "UploadId"
	        ],
	        "members": {
	          "Body": {
	            "streaming": true,
	            "type": "blob"
	          },
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "ContentLength": {
	            "location": "header",
	            "locationName": "Content-Length",
	            "type": "long"
	          },
	          "ContentMD5": {
	            "location": "header",
	            "locationName": "Content-MD5"
	          },
	          "ChecksumAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-sdk-checksum-algorithm"
	          },
	          "ChecksumCRC32": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32"
	          },
	          "ChecksumCRC32C": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32c"
	          },
	          "ChecksumSHA1": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha1"
	          },
	          "ChecksumSHA256": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha256"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "PartNumber": {
	            "location": "querystring",
	            "locationName": "partNumber",
	            "type": "integer"
	          },
	          "UploadId": {
	            "location": "querystring",
	            "locationName": "uploadId"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKey": {
	            "shape": "Sk",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          }
	        },
	        "payload": "Body"
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "ETag"
	          },
	          "ChecksumCRC32": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32"
	          },
	          "ChecksumCRC32C": {
	            "location": "header",
	            "locationName": "x-amz-checksum-crc32c"
	          },
	          "ChecksumSHA1": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha1"
	          },
	          "ChecksumSHA256": {
	            "location": "header",
	            "locationName": "x-amz-checksum-sha256"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        }
	      },
	      "httpChecksum": {
	        "requestAlgorithmMember": "ChecksumAlgorithm",
	        "requestChecksumRequired": false
	      }
	    },
	    "UploadPartCopy": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/{Bucket}/{Key+}"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Bucket",
	          "CopySource",
	          "Key",
	          "PartNumber",
	          "UploadId"
	        ],
	        "members": {
	          "Bucket": {
	            "location": "uri",
	            "locationName": "Bucket"
	          },
	          "CopySource": {
	            "location": "header",
	            "locationName": "x-amz-copy-source"
	          },
	          "CopySourceIfMatch": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-if-match"
	          },
	          "CopySourceIfModifiedSince": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-if-modified-since",
	            "type": "timestamp"
	          },
	          "CopySourceIfNoneMatch": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-if-none-match"
	          },
	          "CopySourceIfUnmodifiedSince": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-if-unmodified-since",
	            "type": "timestamp"
	          },
	          "CopySourceRange": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-range"
	          },
	          "Key": {
	            "location": "uri",
	            "locationName": "Key"
	          },
	          "PartNumber": {
	            "location": "querystring",
	            "locationName": "partNumber",
	            "type": "integer"
	          },
	          "UploadId": {
	            "location": "querystring",
	            "locationName": "uploadId"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKey": {
	            "shape": "Sk",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "CopySourceSSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
	          },
	          "CopySourceSSECustomerKey": {
	            "shape": "S1k",
	            "location": "header",
	            "locationName": "x-amz-copy-source-server-side-encryption-customer-key"
	          },
	          "CopySourceSSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
	          },
	          "RequestPayer": {
	            "location": "header",
	            "locationName": "x-amz-request-payer"
	          },
	          "ExpectedBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-expected-bucket-owner"
	          },
	          "ExpectedSourceBucketOwner": {
	            "location": "header",
	            "locationName": "x-amz-source-expected-bucket-owner"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CopySourceVersionId": {
	            "location": "header",
	            "locationName": "x-amz-copy-source-version-id"
	          },
	          "CopyPartResult": {
	            "type": "structure",
	            "members": {
	              "ETag": {},
	              "LastModified": {
	                "type": "timestamp"
	              },
	              "ChecksumCRC32": {},
	              "ChecksumCRC32C": {},
	              "ChecksumSHA1": {},
	              "ChecksumSHA256": {}
	            }
	          },
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-request-charged"
	          }
	        },
	        "payload": "CopyPartResult"
	      }
	    },
	    "WriteGetObjectResponse": {
	      "http": {
	        "requestUri": "/WriteGetObjectResponse"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "RequestRoute",
	          "RequestToken"
	        ],
	        "members": {
	          "RequestRoute": {
	            "hostLabel": true,
	            "location": "header",
	            "locationName": "x-amz-request-route"
	          },
	          "RequestToken": {
	            "location": "header",
	            "locationName": "x-amz-request-token"
	          },
	          "Body": {
	            "streaming": true,
	            "type": "blob"
	          },
	          "StatusCode": {
	            "location": "header",
	            "locationName": "x-amz-fwd-status",
	            "type": "integer"
	          },
	          "ErrorCode": {
	            "location": "header",
	            "locationName": "x-amz-fwd-error-code"
	          },
	          "ErrorMessage": {
	            "location": "header",
	            "locationName": "x-amz-fwd-error-message"
	          },
	          "AcceptRanges": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-accept-ranges"
	          },
	          "CacheControl": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-Cache-Control"
	          },
	          "ContentDisposition": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-Content-Disposition"
	          },
	          "ContentEncoding": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-Content-Encoding"
	          },
	          "ContentLanguage": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-Content-Language"
	          },
	          "ContentLength": {
	            "location": "header",
	            "locationName": "Content-Length",
	            "type": "long"
	          },
	          "ContentRange": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-Content-Range"
	          },
	          "ContentType": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-Content-Type"
	          },
	          "ChecksumCRC32": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-checksum-crc32"
	          },
	          "ChecksumCRC32C": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-checksum-crc32c"
	          },
	          "ChecksumSHA1": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-checksum-sha1"
	          },
	          "ChecksumSHA256": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-checksum-sha256"
	          },
	          "DeleteMarker": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-delete-marker",
	            "type": "boolean"
	          },
	          "ETag": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-ETag"
	          },
	          "Expires": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-Expires",
	            "type": "timestamp"
	          },
	          "Expiration": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-expiration"
	          },
	          "LastModified": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-Last-Modified",
	            "type": "timestamp"
	          },
	          "MissingMeta": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-missing-meta",
	            "type": "integer"
	          },
	          "Metadata": {
	            "shape": "S1b",
	            "location": "headers",
	            "locationName": "x-amz-meta-"
	          },
	          "ObjectLockMode": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-object-lock-mode"
	          },
	          "ObjectLockLegalHoldStatus": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-object-lock-legal-hold"
	          },
	          "ObjectLockRetainUntilDate": {
	            "shape": "S1o",
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-object-lock-retain-until-date"
	          },
	          "PartsCount": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-mp-parts-count",
	            "type": "integer"
	          },
	          "ReplicationStatus": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-replication-status"
	          },
	          "RequestCharged": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-request-charged"
	          },
	          "Restore": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-restore"
	          },
	          "ServerSideEncryption": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-server-side-encryption"
	          },
	          "SSECustomerAlgorithm": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-server-side-encryption-customer-algorithm"
	          },
	          "SSEKMSKeyId": {
	            "shape": "Sr",
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-server-side-encryption-aws-kms-key-id"
	          },
	          "SSECustomerKeyMD5": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-server-side-encryption-customer-key-MD5"
	          },
	          "StorageClass": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-storage-class"
	          },
	          "TagCount": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-tagging-count",
	            "type": "integer"
	          },
	          "VersionId": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-version-id"
	          },
	          "BucketKeyEnabled": {
	            "location": "header",
	            "locationName": "x-amz-fwd-header-x-amz-server-side-encryption-bucket-key-enabled",
	            "type": "boolean"
	          }
	        },
	        "payload": "Body"
	      },
	      "authtype": "v4-unsigned-body",
	      "endpoint": {
	        "hostPrefix": "{RequestRoute}."
	      }
	    }
	  },
	  "shapes": {
	    "Sk": {
	      "type": "blob",
	      "sensitive": true
	    },
	    "Sr": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S1b": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S1i": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S1k": {
	      "type": "blob",
	      "sensitive": true
	    },
	    "S1o": {
	      "type": "timestamp",
	      "timestampFormat": "iso8601"
	    },
	    "S3d": {
	      "type": "structure",
	      "members": {
	        "DisplayName": {},
	        "ID": {}
	      }
	    },
	    "S3g": {
	      "type": "list",
	      "member": {
	        "locationName": "Grant",
	        "type": "structure",
	        "members": {
	          "Grantee": {
	            "shape": "S3i"
	          },
	          "Permission": {}
	        }
	      }
	    },
	    "S3i": {
	      "type": "structure",
	      "required": [
	        "Type"
	      ],
	      "members": {
	        "DisplayName": {},
	        "EmailAddress": {},
	        "ID": {},
	        "Type": {
	          "locationName": "xsi:type",
	          "xmlAttribute": true
	        },
	        "URI": {}
	      },
	      "xmlNamespace": {
	        "prefix": "xsi",
	        "uri": "http://www.w3.org/2001/XMLSchema-instance"
	      }
	    },
	    "S3p": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "StorageClassAnalysis"
	      ],
	      "members": {
	        "Id": {},
	        "Filter": {
	          "type": "structure",
	          "members": {
	            "Prefix": {},
	            "Tag": {
	              "shape": "S3s"
	            },
	            "And": {
	              "type": "structure",
	              "members": {
	                "Prefix": {},
	                "Tags": {
	                  "shape": "S3v",
	                  "flattened": true,
	                  "locationName": "Tag"
	                }
	              }
	            }
	          }
	        },
	        "StorageClassAnalysis": {
	          "type": "structure",
	          "members": {
	            "DataExport": {
	              "type": "structure",
	              "required": [
	                "OutputSchemaVersion",
	                "Destination"
	              ],
	              "members": {
	                "OutputSchemaVersion": {},
	                "Destination": {
	                  "type": "structure",
	                  "required": [
	                    "S3BucketDestination"
	                  ],
	                  "members": {
	                    "S3BucketDestination": {
	                      "type": "structure",
	                      "required": [
	                        "Format",
	                        "Bucket"
	                      ],
	                      "members": {
	                        "Format": {},
	                        "BucketAccountId": {},
	                        "Bucket": {},
	                        "Prefix": {}
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "S3s": {
	      "type": "structure",
	      "required": [
	        "Key",
	        "Value"
	      ],
	      "members": {
	        "Key": {},
	        "Value": {}
	      }
	    },
	    "S3v": {
	      "type": "list",
	      "member": {
	        "shape": "S3s",
	        "locationName": "Tag"
	      }
	    },
	    "S44": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "AllowedMethods",
	          "AllowedOrigins"
	        ],
	        "members": {
	          "ID": {},
	          "AllowedHeaders": {
	            "locationName": "AllowedHeader",
	            "type": "list",
	            "member": {},
	            "flattened": true
	          },
	          "AllowedMethods": {
	            "locationName": "AllowedMethod",
	            "type": "list",
	            "member": {},
	            "flattened": true
	          },
	          "AllowedOrigins": {
	            "locationName": "AllowedOrigin",
	            "type": "list",
	            "member": {},
	            "flattened": true
	          },
	          "ExposeHeaders": {
	            "locationName": "ExposeHeader",
	            "type": "list",
	            "member": {},
	            "flattened": true
	          },
	          "MaxAgeSeconds": {
	            "type": "integer"
	          }
	        }
	      },
	      "flattened": true
	    },
	    "S4h": {
	      "type": "structure",
	      "required": [
	        "Rules"
	      ],
	      "members": {
	        "Rules": {
	          "locationName": "Rule",
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "ApplyServerSideEncryptionByDefault": {
	                "type": "structure",
	                "required": [
	                  "SSEAlgorithm"
	                ],
	                "members": {
	                  "SSEAlgorithm": {},
	                  "KMSMasterKeyID": {
	                    "shape": "Sr"
	                  }
	                }
	              },
	              "BucketKeyEnabled": {
	                "type": "boolean"
	              }
	            }
	          },
	          "flattened": true
	        }
	      }
	    },
	    "S4n": {
	      "type": "structure",
	      "required": [
	        "Id",
	        "Status",
	        "Tierings"
	      ],
	      "members": {
	        "Id": {},
	        "Filter": {
	          "type": "structure",
	          "members": {
	            "Prefix": {},
	            "Tag": {
	              "shape": "S3s"
	            },
	            "And": {
	              "type": "structure",
	              "members": {
	                "Prefix": {},
	                "Tags": {
	                  "shape": "S3v",
	                  "flattened": true,
	                  "locationName": "Tag"
	                }
	              }
	            }
	          }
	        },
	        "Status": {},
	        "Tierings": {
	          "locationName": "Tiering",
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Days",
	              "AccessTier"
	            ],
	            "members": {
	              "Days": {
	                "type": "integer"
	              },
	              "AccessTier": {}
	            }
	          },
	          "flattened": true
	        }
	      }
	    },
	    "S4x": {
	      "type": "structure",
	      "required": [
	        "Destination",
	        "IsEnabled",
	        "Id",
	        "IncludedObjectVersions",
	        "Schedule"
	      ],
	      "members": {
	        "Destination": {
	          "type": "structure",
	          "required": [
	            "S3BucketDestination"
	          ],
	          "members": {
	            "S3BucketDestination": {
	              "type": "structure",
	              "required": [
	                "Bucket",
	                "Format"
	              ],
	              "members": {
	                "AccountId": {},
	                "Bucket": {},
	                "Format": {},
	                "Prefix": {},
	                "Encryption": {
	                  "type": "structure",
	                  "members": {
	                    "SSES3": {
	                      "locationName": "SSE-S3",
	                      "type": "structure",
	                      "members": {}
	                    },
	                    "SSEKMS": {
	                      "locationName": "SSE-KMS",
	                      "type": "structure",
	                      "required": [
	                        "KeyId"
	                      ],
	                      "members": {
	                        "KeyId": {
	                          "shape": "Sr"
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          }
	        },
	        "IsEnabled": {
	          "type": "boolean"
	        },
	        "Filter": {
	          "type": "structure",
	          "required": [
	            "Prefix"
	          ],
	          "members": {
	            "Prefix": {}
	          }
	        },
	        "Id": {},
	        "IncludedObjectVersions": {},
	        "OptionalFields": {
	          "type": "list",
	          "member": {
	            "locationName": "Field"
	          }
	        },
	        "Schedule": {
	          "type": "structure",
	          "required": [
	            "Frequency"
	          ],
	          "members": {
	            "Frequency": {}
	          }
	        }
	      }
	    },
	    "S5d": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Prefix",
	          "Status"
	        ],
	        "members": {
	          "Expiration": {
	            "shape": "S5f"
	          },
	          "ID": {},
	          "Prefix": {},
	          "Status": {},
	          "Transition": {
	            "shape": "S5k"
	          },
	          "NoncurrentVersionTransition": {
	            "shape": "S5m"
	          },
	          "NoncurrentVersionExpiration": {
	            "shape": "S5o"
	          },
	          "AbortIncompleteMultipartUpload": {
	            "shape": "S5p"
	          }
	        }
	      },
	      "flattened": true
	    },
	    "S5f": {
	      "type": "structure",
	      "members": {
	        "Date": {
	          "shape": "S5g"
	        },
	        "Days": {
	          "type": "integer"
	        },
	        "ExpiredObjectDeleteMarker": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S5g": {
	      "type": "timestamp",
	      "timestampFormat": "iso8601"
	    },
	    "S5k": {
	      "type": "structure",
	      "members": {
	        "Date": {
	          "shape": "S5g"
	        },
	        "Days": {
	          "type": "integer"
	        },
	        "StorageClass": {}
	      }
	    },
	    "S5m": {
	      "type": "structure",
	      "members": {
	        "NoncurrentDays": {
	          "type": "integer"
	        },
	        "StorageClass": {},
	        "NewerNoncurrentVersions": {
	          "type": "integer"
	        }
	      }
	    },
	    "S5o": {
	      "type": "structure",
	      "members": {
	        "NoncurrentDays": {
	          "type": "integer"
	        },
	        "NewerNoncurrentVersions": {
	          "type": "integer"
	        }
	      }
	    },
	    "S5p": {
	      "type": "structure",
	      "members": {
	        "DaysAfterInitiation": {
	          "type": "integer"
	        }
	      }
	    },
	    "S5t": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Status"
	        ],
	        "members": {
	          "Expiration": {
	            "shape": "S5f"
	          },
	          "ID": {},
	          "Prefix": {
	            "deprecated": true
	          },
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "Prefix": {},
	              "Tag": {
	                "shape": "S3s"
	              },
	              "ObjectSizeGreaterThan": {
	                "type": "long"
	              },
	              "ObjectSizeLessThan": {
	                "type": "long"
	              },
	              "And": {
	                "type": "structure",
	                "members": {
	                  "Prefix": {},
	                  "Tags": {
	                    "shape": "S3v",
	                    "flattened": true,
	                    "locationName": "Tag"
	                  },
	                  "ObjectSizeGreaterThan": {
	                    "type": "long"
	                  },
	                  "ObjectSizeLessThan": {
	                    "type": "long"
	                  }
	                }
	              }
	            }
	          },
	          "Status": {},
	          "Transitions": {
	            "locationName": "Transition",
	            "type": "list",
	            "member": {
	              "shape": "S5k"
	            },
	            "flattened": true
	          },
	          "NoncurrentVersionTransitions": {
	            "locationName": "NoncurrentVersionTransition",
	            "type": "list",
	            "member": {
	              "shape": "S5m"
	            },
	            "flattened": true
	          },
	          "NoncurrentVersionExpiration": {
	            "shape": "S5o"
	          },
	          "AbortIncompleteMultipartUpload": {
	            "shape": "S5p"
	          }
	        }
	      },
	      "flattened": true
	    },
	    "S65": {
	      "type": "structure",
	      "required": [
	        "TargetBucket",
	        "TargetPrefix"
	      ],
	      "members": {
	        "TargetBucket": {},
	        "TargetGrants": {
	          "type": "list",
	          "member": {
	            "locationName": "Grant",
	            "type": "structure",
	            "members": {
	              "Grantee": {
	                "shape": "S3i"
	              },
	              "Permission": {}
	            }
	          }
	        },
	        "TargetPrefix": {}
	      }
	    },
	    "S6d": {
	      "type": "structure",
	      "required": [
	        "Id"
	      ],
	      "members": {
	        "Id": {},
	        "Filter": {
	          "type": "structure",
	          "members": {
	            "Prefix": {},
	            "Tag": {
	              "shape": "S3s"
	            },
	            "AccessPointArn": {},
	            "And": {
	              "type": "structure",
	              "members": {
	                "Prefix": {},
	                "Tags": {
	                  "shape": "S3v",
	                  "flattened": true,
	                  "locationName": "Tag"
	                },
	                "AccessPointArn": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "S6h": {
	      "type": "structure",
	      "required": [
	        "Bucket"
	      ],
	      "members": {
	        "Bucket": {
	          "location": "uri",
	          "locationName": "Bucket"
	        },
	        "ExpectedBucketOwner": {
	          "location": "header",
	          "locationName": "x-amz-expected-bucket-owner"
	        }
	      }
	    },
	    "S6i": {
	      "type": "structure",
	      "members": {
	        "TopicConfiguration": {
	          "type": "structure",
	          "members": {
	            "Id": {},
	            "Events": {
	              "shape": "S6l",
	              "locationName": "Event"
	            },
	            "Event": {
	              "deprecated": true
	            },
	            "Topic": {}
	          }
	        },
	        "QueueConfiguration": {
	          "type": "structure",
	          "members": {
	            "Id": {},
	            "Event": {
	              "deprecated": true
	            },
	            "Events": {
	              "shape": "S6l",
	              "locationName": "Event"
	            },
	            "Queue": {}
	          }
	        },
	        "CloudFunctionConfiguration": {
	          "type": "structure",
	          "members": {
	            "Id": {},
	            "Event": {
	              "deprecated": true
	            },
	            "Events": {
	              "shape": "S6l",
	              "locationName": "Event"
	            },
	            "CloudFunction": {},
	            "InvocationRole": {}
	          }
	        }
	      }
	    },
	    "S6l": {
	      "type": "list",
	      "member": {},
	      "flattened": true
	    },
	    "S6t": {
	      "type": "structure",
	      "members": {
	        "TopicConfigurations": {
	          "locationName": "TopicConfiguration",
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "TopicArn",
	              "Events"
	            ],
	            "members": {
	              "Id": {},
	              "TopicArn": {
	                "locationName": "Topic"
	              },
	              "Events": {
	                "shape": "S6l",
	                "locationName": "Event"
	              },
	              "Filter": {
	                "shape": "S6w"
	              }
	            }
	          },
	          "flattened": true
	        },
	        "QueueConfigurations": {
	          "locationName": "QueueConfiguration",
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "QueueArn",
	              "Events"
	            ],
	            "members": {
	              "Id": {},
	              "QueueArn": {
	                "locationName": "Queue"
	              },
	              "Events": {
	                "shape": "S6l",
	                "locationName": "Event"
	              },
	              "Filter": {
	                "shape": "S6w"
	              }
	            }
	          },
	          "flattened": true
	        },
	        "LambdaFunctionConfigurations": {
	          "locationName": "CloudFunctionConfiguration",
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "LambdaFunctionArn",
	              "Events"
	            ],
	            "members": {
	              "Id": {},
	              "LambdaFunctionArn": {
	                "locationName": "CloudFunction"
	              },
	              "Events": {
	                "shape": "S6l",
	                "locationName": "Event"
	              },
	              "Filter": {
	                "shape": "S6w"
	              }
	            }
	          },
	          "flattened": true
	        },
	        "EventBridgeConfiguration": {
	          "type": "structure",
	          "members": {}
	        }
	      }
	    },
	    "S6w": {
	      "type": "structure",
	      "members": {
	        "Key": {
	          "locationName": "S3Key",
	          "type": "structure",
	          "members": {
	            "FilterRules": {
	              "locationName": "FilterRule",
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "Name": {},
	                  "Value": {}
	                }
	              },
	              "flattened": true
	            }
	          }
	        }
	      }
	    },
	    "S7a": {
	      "type": "structure",
	      "required": [
	        "Rules"
	      ],
	      "members": {
	        "Rules": {
	          "locationName": "Rule",
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "ObjectOwnership"
	            ],
	            "members": {
	              "ObjectOwnership": {}
	            }
	          },
	          "flattened": true
	        }
	      }
	    },
	    "S7m": {
	      "type": "structure",
	      "required": [
	        "Role",
	        "Rules"
	      ],
	      "members": {
	        "Role": {},
	        "Rules": {
	          "locationName": "Rule",
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Status",
	              "Destination"
	            ],
	            "members": {
	              "ID": {},
	              "Priority": {
	                "type": "integer"
	              },
	              "Prefix": {
	                "deprecated": true
	              },
	              "Filter": {
	                "type": "structure",
	                "members": {
	                  "Prefix": {},
	                  "Tag": {
	                    "shape": "S3s"
	                  },
	                  "And": {
	                    "type": "structure",
	                    "members": {
	                      "Prefix": {},
	                      "Tags": {
	                        "shape": "S3v",
	                        "flattened": true,
	                        "locationName": "Tag"
	                      }
	                    }
	                  }
	                }
	              },
	              "Status": {},
	              "SourceSelectionCriteria": {
	                "type": "structure",
	                "members": {
	                  "SseKmsEncryptedObjects": {
	                    "type": "structure",
	                    "required": [
	                      "Status"
	                    ],
	                    "members": {
	                      "Status": {}
	                    }
	                  },
	                  "ReplicaModifications": {
	                    "type": "structure",
	                    "required": [
	                      "Status"
	                    ],
	                    "members": {
	                      "Status": {}
	                    }
	                  }
	                }
	              },
	              "ExistingObjectReplication": {
	                "type": "structure",
	                "required": [
	                  "Status"
	                ],
	                "members": {
	                  "Status": {}
	                }
	              },
	              "Destination": {
	                "type": "structure",
	                "required": [
	                  "Bucket"
	                ],
	                "members": {
	                  "Bucket": {},
	                  "Account": {},
	                  "StorageClass": {},
	                  "AccessControlTranslation": {
	                    "type": "structure",
	                    "required": [
	                      "Owner"
	                    ],
	                    "members": {
	                      "Owner": {}
	                    }
	                  },
	                  "EncryptionConfiguration": {
	                    "type": "structure",
	                    "members": {
	                      "ReplicaKmsKeyID": {}
	                    }
	                  },
	                  "ReplicationTime": {
	                    "type": "structure",
	                    "required": [
	                      "Status",
	                      "Time"
	                    ],
	                    "members": {
	                      "Status": {},
	                      "Time": {
	                        "shape": "S88"
	                      }
	                    }
	                  },
	                  "Metrics": {
	                    "type": "structure",
	                    "required": [
	                      "Status"
	                    ],
	                    "members": {
	                      "Status": {},
	                      "EventThreshold": {
	                        "shape": "S88"
	                      }
	                    }
	                  }
	                }
	              },
	              "DeleteMarkerReplication": {
	                "type": "structure",
	                "members": {
	                  "Status": {}
	                }
	              }
	            }
	          },
	          "flattened": true
	        }
	      }
	    },
	    "S88": {
	      "type": "structure",
	      "members": {
	        "Minutes": {
	          "type": "integer"
	        }
	      }
	    },
	    "S8p": {
	      "type": "structure",
	      "required": [
	        "HostName"
	      ],
	      "members": {
	        "HostName": {},
	        "Protocol": {}
	      }
	    },
	    "S8s": {
	      "type": "structure",
	      "required": [
	        "Suffix"
	      ],
	      "members": {
	        "Suffix": {}
	      }
	    },
	    "S8u": {
	      "type": "structure",
	      "required": [
	        "Key"
	      ],
	      "members": {
	        "Key": {}
	      }
	    },
	    "S8v": {
	      "type": "list",
	      "member": {
	        "locationName": "RoutingRule",
	        "type": "structure",
	        "required": [
	          "Redirect"
	        ],
	        "members": {
	          "Condition": {
	            "type": "structure",
	            "members": {
	              "HttpErrorCodeReturnedEquals": {},
	              "KeyPrefixEquals": {}
	            }
	          },
	          "Redirect": {
	            "type": "structure",
	            "members": {
	              "HostName": {},
	              "HttpRedirectCode": {},
	              "Protocol": {},
	              "ReplaceKeyPrefixWith": {},
	              "ReplaceKeyWith": {}
	            }
	          }
	        }
	      }
	    },
	    "Sa9": {
	      "type": "structure",
	      "members": {
	        "Status": {}
	      }
	    },
	    "Sac": {
	      "type": "structure",
	      "members": {
	        "ObjectLockEnabled": {},
	        "Rule": {
	          "type": "structure",
	          "members": {
	            "DefaultRetention": {
	              "type": "structure",
	              "members": {
	                "Mode": {},
	                "Days": {
	                  "type": "integer"
	                },
	                "Years": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sak": {
	      "type": "structure",
	      "members": {
	        "Mode": {},
	        "RetainUntilDate": {
	          "shape": "S5g"
	        }
	      }
	    },
	    "Sar": {
	      "type": "structure",
	      "members": {
	        "BlockPublicAcls": {
	          "locationName": "BlockPublicAcls",
	          "type": "boolean"
	        },
	        "IgnorePublicAcls": {
	          "locationName": "IgnorePublicAcls",
	          "type": "boolean"
	        },
	        "BlockPublicPolicy": {
	          "locationName": "BlockPublicPolicy",
	          "type": "boolean"
	        },
	        "RestrictPublicBuckets": {
	          "locationName": "RestrictPublicBuckets",
	          "type": "boolean"
	        }
	      }
	    },
	    "Sbr": {
	      "type": "structure",
	      "members": {
	        "ID": {},
	        "DisplayName": {}
	      }
	    },
	    "Sbs": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Prefix": {}
	        }
	      },
	      "flattened": true
	    },
	    "Sc1": {
	      "type": "list",
	      "member": {},
	      "flattened": true
	    },
	    "Sca": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "LastModified": {
	            "type": "timestamp"
	          },
	          "ETag": {},
	          "ChecksumAlgorithm": {
	            "shape": "Sc1"
	          },
	          "Size": {
	            "type": "integer"
	          },
	          "StorageClass": {},
	          "Owner": {
	            "shape": "S3d"
	          }
	        }
	      },
	      "flattened": true
	    },
	    "Scp": {
	      "type": "structure",
	      "members": {
	        "Grants": {
	          "shape": "S3g",
	          "locationName": "AccessControlList"
	        },
	        "Owner": {
	          "shape": "S3d"
	        }
	      }
	    },
	    "Sdf": {
	      "type": "structure",
	      "required": [
	        "TagSet"
	      ],
	      "members": {
	        "TagSet": {
	          "shape": "S3v"
	        }
	      }
	    },
	    "Se5": {
	      "type": "structure",
	      "members": {
	        "CSV": {
	          "type": "structure",
	          "members": {
	            "FileHeaderInfo": {},
	            "Comments": {},
	            "QuoteEscapeCharacter": {},
	            "RecordDelimiter": {},
	            "FieldDelimiter": {},
	            "QuoteCharacter": {},
	            "AllowQuotedRecordDelimiter": {
	              "type": "boolean"
	            }
	          }
	        },
	        "CompressionType": {},
	        "JSON": {
	          "type": "structure",
	          "members": {
	            "Type": {}
	          }
	        },
	        "Parquet": {
	          "type": "structure",
	          "members": {}
	        }
	      }
	    },
	    "Sek": {
	      "type": "structure",
	      "members": {
	        "CSV": {
	          "type": "structure",
	          "members": {
	            "QuoteFields": {},
	            "QuoteEscapeCharacter": {},
	            "RecordDelimiter": {},
	            "FieldDelimiter": {},
	            "QuoteCharacter": {}
	          }
	        },
	        "JSON": {
	          "type": "structure",
	          "members": {
	            "RecordDelimiter": {}
	          }
	        }
	      }
	    }
	  }
	}
	},{}],213:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListBuckets": {
	      "result_key": "Buckets"
	    },
	    "ListMultipartUploads": {
	      "input_token": [
	        "KeyMarker",
	        "UploadIdMarker"
	      ],
	      "limit_key": "MaxUploads",
	      "more_results": "IsTruncated",
	      "output_token": [
	        "NextKeyMarker",
	        "NextUploadIdMarker"
	      ],
	      "result_key": [
	        "Uploads",
	        "CommonPrefixes"
	      ]
	    },
	    "ListObjectVersions": {
	      "input_token": [
	        "KeyMarker",
	        "VersionIdMarker"
	      ],
	      "limit_key": "MaxKeys",
	      "more_results": "IsTruncated",
	      "output_token": [
	        "NextKeyMarker",
	        "NextVersionIdMarker"
	      ],
	      "result_key": [
	        "Versions",
	        "DeleteMarkers",
	        "CommonPrefixes"
	      ]
	    },
	    "ListObjects": {
	      "input_token": "Marker",
	      "limit_key": "MaxKeys",
	      "more_results": "IsTruncated",
	      "output_token": "NextMarker || Contents[-1].Key",
	      "result_key": [
	        "Contents",
	        "CommonPrefixes"
	      ]
	    },
	    "ListObjectsV2": {
	      "input_token": "ContinuationToken",
	      "limit_key": "MaxKeys",
	      "output_token": "NextContinuationToken",
	      "result_key": [
	        "Contents",
	        "CommonPrefixes"
	      ]
	    },
	    "ListParts": {
	      "input_token": "PartNumberMarker",
	      "limit_key": "MaxParts",
	      "more_results": "IsTruncated",
	      "output_token": "NextPartNumberMarker",
	      "result_key": "Parts"
	    }
	  }
	}
	},{}],214:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "BucketExists": {
	      "delay": 5,
	      "operation": "HeadBucket",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "expected": 200,
	          "matcher": "status",
	          "state": "success"
	        },
	        {
	          "expected": 301,
	          "matcher": "status",
	          "state": "success"
	        },
	        {
	          "expected": 403,
	          "matcher": "status",
	          "state": "success"
	        },
	        {
	          "expected": 404,
	          "matcher": "status",
	          "state": "retry"
	        }
	      ]
	    },
	    "BucketNotExists": {
	      "delay": 5,
	      "operation": "HeadBucket",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "expected": 404,
	          "matcher": "status",
	          "state": "success"
	        }
	      ]
	    },
	    "ObjectExists": {
	      "delay": 5,
	      "operation": "HeadObject",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "expected": 200,
	          "matcher": "status",
	          "state": "success"
	        },
	        {
	          "expected": 404,
	          "matcher": "status",
	          "state": "retry"
	        }
	      ]
	    },
	    "ObjectNotExists": {
	      "delay": 5,
	      "operation": "HeadObject",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "expected": 404,
	          "matcher": "status",
	          "state": "success"
	        }
	      ]
	    }
	  }
	}
	
	},{}],215:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-10-17",
	    "endpointPrefix": "secretsmanager",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "AWS Secrets Manager",
	    "serviceId": "Secrets Manager",
	    "signatureVersion": "v4",
	    "signingName": "secretsmanager",
	    "targetPrefix": "secretsmanager",
	    "uid": "secretsmanager-2017-10-17"
	  },
	  "operations": {
	    "CancelRotateSecret": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {},
	          "VersionId": {}
	        }
	      }
	    },
	    "CreateSecret": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "Description": {},
	          "KmsKeyId": {},
	          "SecretBinary": {
	            "shape": "Sc"
	          },
	          "SecretString": {
	            "shape": "Sd"
	          },
	          "Tags": {
	            "shape": "Se"
	          },
	          "AddReplicaRegions": {
	            "shape": "Si"
	          },
	          "ForceOverwriteReplicaSecret": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {},
	          "VersionId": {},
	          "ReplicationStatus": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "DeleteResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {}
	        }
	      }
	    },
	    "DeleteSecret": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {},
	          "RecoveryWindowInDays": {
	            "type": "long"
	          },
	          "ForceDeleteWithoutRecovery": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {},
	          "DeletionDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeSecret": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {},
	          "Description": {},
	          "KmsKeyId": {},
	          "RotationEnabled": {
	            "type": "boolean"
	          },
	          "RotationLambdaARN": {},
	          "RotationRules": {
	            "shape": "S12"
	          },
	          "LastRotatedDate": {
	            "type": "timestamp"
	          },
	          "LastChangedDate": {
	            "type": "timestamp"
	          },
	          "LastAccessedDate": {
	            "type": "timestamp"
	          },
	          "DeletedDate": {
	            "type": "timestamp"
	          },
	          "Tags": {
	            "shape": "Se"
	          },
	          "VersionIdsToStages": {
	            "shape": "S19"
	          },
	          "OwningService": {},
	          "CreatedDate": {
	            "type": "timestamp"
	          },
	          "PrimaryRegion": {},
	          "ReplicationStatus": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "GetRandomPassword": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PasswordLength": {
	            "type": "long"
	          },
	          "ExcludeCharacters": {},
	          "ExcludeNumbers": {
	            "type": "boolean"
	          },
	          "ExcludePunctuation": {
	            "type": "boolean"
	          },
	          "ExcludeUppercase": {
	            "type": "boolean"
	          },
	          "ExcludeLowercase": {
	            "type": "boolean"
	          },
	          "IncludeSpace": {
	            "type": "boolean"
	          },
	          "RequireEachIncludedType": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RandomPassword": {
	            "type": "string",
	            "sensitive": true
	          }
	        }
	      }
	    },
	    "GetResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {},
	          "ResourcePolicy": {}
	        }
	      }
	    },
	    "GetSecretValue": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {},
	          "VersionId": {},
	          "VersionStage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {},
	          "VersionId": {},
	          "SecretBinary": {
	            "shape": "Sc"
	          },
	          "SecretString": {
	            "shape": "Sd"
	          },
	          "VersionStages": {
	            "shape": "S1a"
	          },
	          "CreatedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "ListSecretVersionIds": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "IncludeDeprecated": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Versions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "VersionId": {},
	                "VersionStages": {
	                  "shape": "S1a"
	                },
	                "LastAccessedDate": {
	                  "type": "timestamp"
	                },
	                "CreatedDate": {
	                  "type": "timestamp"
	                },
	                "KmsKeyIds": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "NextToken": {},
	          "ARN": {},
	          "Name": {}
	        }
	      }
	    },
	    "ListSecrets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Key": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "SortOrder": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SecretList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ARN": {},
	                "Name": {},
	                "Description": {},
	                "KmsKeyId": {},
	                "RotationEnabled": {
	                  "type": "boolean"
	                },
	                "RotationLambdaARN": {},
	                "RotationRules": {
	                  "shape": "S12"
	                },
	                "LastRotatedDate": {
	                  "type": "timestamp"
	                },
	                "LastChangedDate": {
	                  "type": "timestamp"
	                },
	                "LastAccessedDate": {
	                  "type": "timestamp"
	                },
	                "DeletedDate": {
	                  "type": "timestamp"
	                },
	                "Tags": {
	                  "shape": "Se"
	                },
	                "SecretVersionsToStages": {
	                  "shape": "S19"
	                },
	                "OwningService": {},
	                "CreatedDate": {
	                  "type": "timestamp"
	                },
	                "PrimaryRegion": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PutResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId",
	          "ResourcePolicy"
	        ],
	        "members": {
	          "SecretId": {},
	          "ResourcePolicy": {},
	          "BlockPublicPolicy": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {}
	        }
	      }
	    },
	    "PutSecretValue": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "SecretBinary": {
	            "shape": "Sc"
	          },
	          "SecretString": {
	            "shape": "Sd"
	          },
	          "VersionStages": {
	            "shape": "S1a"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {},
	          "VersionId": {},
	          "VersionStages": {
	            "shape": "S1a"
	          }
	        }
	      }
	    },
	    "RemoveRegionsFromReplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId",
	          "RemoveReplicaRegions"
	        ],
	        "members": {
	          "SecretId": {},
	          "RemoveReplicaRegions": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "ReplicationStatus": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "ReplicateSecretToRegions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId",
	          "AddReplicaRegions"
	        ],
	        "members": {
	          "SecretId": {},
	          "AddReplicaRegions": {
	            "shape": "Si"
	          },
	          "ForceOverwriteReplicaSecret": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "ReplicationStatus": {
	            "shape": "Sn"
	          }
	        }
	      }
	    },
	    "RestoreSecret": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {}
	        }
	      }
	    },
	    "RotateSecret": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "RotationLambdaARN": {},
	          "RotationRules": {
	            "shape": "S12"
	          },
	          "RotateImmediately": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {},
	          "VersionId": {}
	        }
	      }
	    },
	    "StopReplicationToReplica": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {}
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId",
	          "Tags"
	        ],
	        "members": {
	          "SecretId": {},
	          "Tags": {
	            "shape": "Se"
	          }
	        }
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId",
	          "TagKeys"
	        ],
	        "members": {
	          "SecretId": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "UpdateSecret": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId"
	        ],
	        "members": {
	          "SecretId": {},
	          "ClientRequestToken": {
	            "idempotencyToken": true
	          },
	          "Description": {},
	          "KmsKeyId": {},
	          "SecretBinary": {
	            "shape": "Sc"
	          },
	          "SecretString": {
	            "shape": "Sd"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {},
	          "VersionId": {}
	        }
	      }
	    },
	    "UpdateSecretVersionStage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SecretId",
	          "VersionStage"
	        ],
	        "members": {
	          "SecretId": {},
	          "VersionStage": {},
	          "RemoveFromVersionId": {},
	          "MoveToVersionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ARN": {},
	          "Name": {}
	        }
	      }
	    },
	    "ValidateResourcePolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourcePolicy"
	        ],
	        "members": {
	          "SecretId": {},
	          "ResourcePolicy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PolicyValidationPassed": {
	            "type": "boolean"
	          },
	          "ValidationErrors": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "CheckName": {},
	                "ErrorMessage": {}
	              }
	            }
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sc": {
	      "type": "blob",
	      "sensitive": true
	    },
	    "Sd": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Se": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Si": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Region": {},
	          "KmsKeyId": {}
	        }
	      }
	    },
	    "Sn": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Region": {},
	          "KmsKeyId": {},
	          "Status": {},
	          "StatusMessage": {},
	          "LastAccessedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "members": {
	        "AutomaticallyAfterDays": {
	          "type": "long"
	        },
	        "Duration": {},
	        "ScheduleExpression": {}
	      }
	    },
	    "S19": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "S1a"
	      }
	    },
	    "S1a": {
	      "type": "list",
	      "member": {}
	    }
	  }
	}
	},{}],216:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListSecretVersionIds": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    },
	    "ListSecrets": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "limit_key": "MaxResults"
	    }
	  }
	}
	
	},{}],217:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-12-10",
	    "endpointPrefix": "servicecatalog",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "AWS Service Catalog",
	    "serviceId": "Service Catalog",
	    "signatureVersion": "v4",
	    "targetPrefix": "AWS242ServiceCatalogService",
	    "uid": "servicecatalog-2015-12-10"
	  },
	  "operations": {
	    "AcceptPortfolioShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "PortfolioShareType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AssociateBudgetWithResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BudgetName",
	          "ResourceId"
	        ],
	        "members": {
	          "BudgetName": {},
	          "ResourceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AssociatePrincipalWithPortfolio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId",
	          "PrincipalARN",
	          "PrincipalType"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "PrincipalARN": {},
	          "PrincipalType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AssociateProductWithPortfolio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId",
	          "PortfolioId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProductId": {},
	          "PortfolioId": {},
	          "SourcePortfolioId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AssociateServiceActionWithProvisioningArtifact": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId",
	          "ProvisioningArtifactId",
	          "ServiceActionId"
	        ],
	        "members": {
	          "ProductId": {},
	          "ProvisioningArtifactId": {},
	          "ServiceActionId": {},
	          "AcceptLanguage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AssociateTagOptionWithResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "TagOptionId"
	        ],
	        "members": {
	          "ResourceId": {},
	          "TagOptionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "BatchAssociateServiceActionWithProvisioningArtifact": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceActionAssociations"
	        ],
	        "members": {
	          "ServiceActionAssociations": {
	            "shape": "Sm"
	          },
	          "AcceptLanguage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FailedServiceActionAssociations": {
	            "shape": "Sp"
	          }
	        }
	      }
	    },
	    "BatchDisassociateServiceActionFromProvisioningArtifact": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceActionAssociations"
	        ],
	        "members": {
	          "ServiceActionAssociations": {
	            "shape": "Sm"
	          },
	          "AcceptLanguage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FailedServiceActionAssociations": {
	            "shape": "Sp"
	          }
	        }
	      }
	    },
	    "CopyProduct": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SourceProductArn",
	          "IdempotencyToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "SourceProductArn": {},
	          "TargetProductId": {},
	          "TargetProductName": {},
	          "SourceProvisioningArtifactIdentifiers": {
	            "type": "list",
	            "member": {
	              "type": "map",
	              "key": {},
	              "value": {}
	            }
	          },
	          "CopyOptions": {
	            "type": "list",
	            "member": {}
	          },
	          "IdempotencyToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CopyProductToken": {}
	        }
	      }
	    },
	    "CreateConstraint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId",
	          "ProductId",
	          "Parameters",
	          "Type",
	          "IdempotencyToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "ProductId": {},
	          "Parameters": {},
	          "Type": {},
	          "Description": {},
	          "IdempotencyToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConstraintDetail": {
	            "shape": "S1b"
	          },
	          "ConstraintParameters": {},
	          "Status": {}
	        }
	      }
	    },
	    "CreatePortfolio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DisplayName",
	          "ProviderName",
	          "IdempotencyToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "DisplayName": {},
	          "Description": {},
	          "ProviderName": {},
	          "Tags": {
	            "shape": "S1i"
	          },
	          "IdempotencyToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PortfolioDetail": {
	            "shape": "S1n"
	          },
	          "Tags": {
	            "shape": "S1q"
	          }
	        }
	      }
	    },
	    "CreatePortfolioShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "AccountId": {},
	          "OrganizationNode": {
	            "shape": "S1s"
	          },
	          "ShareTagOptions": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PortfolioShareToken": {}
	        }
	      }
	    },
	    "CreateProduct": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Owner",
	          "ProductType",
	          "ProvisioningArtifactParameters",
	          "IdempotencyToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "Name": {},
	          "Owner": {},
	          "Description": {},
	          "Distributor": {},
	          "SupportDescription": {},
	          "SupportEmail": {},
	          "SupportUrl": {},
	          "ProductType": {},
	          "Tags": {
	            "shape": "S1i"
	          },
	          "ProvisioningArtifactParameters": {
	            "shape": "S24"
	          },
	          "IdempotencyToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProductViewDetail": {
	            "shape": "S2d"
	          },
	          "ProvisioningArtifactDetail": {
	            "shape": "S2i"
	          },
	          "Tags": {
	            "shape": "S1q"
	          }
	        }
	      }
	    },
	    "CreateProvisionedProductPlan": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlanName",
	          "PlanType",
	          "ProductId",
	          "ProvisionedProductName",
	          "ProvisioningArtifactId",
	          "IdempotencyToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PlanName": {},
	          "PlanType": {},
	          "NotificationArns": {
	            "shape": "S2o"
	          },
	          "PathId": {},
	          "ProductId": {},
	          "ProvisionedProductName": {},
	          "ProvisioningArtifactId": {},
	          "ProvisioningParameters": {
	            "shape": "S2r"
	          },
	          "IdempotencyToken": {
	            "idempotencyToken": true
	          },
	          "Tags": {
	            "shape": "S1q"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PlanName": {},
	          "PlanId": {},
	          "ProvisionProductId": {},
	          "ProvisionedProductName": {},
	          "ProvisioningArtifactId": {}
	        }
	      }
	    },
	    "CreateProvisioningArtifact": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId",
	          "Parameters",
	          "IdempotencyToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProductId": {},
	          "Parameters": {
	            "shape": "S24"
	          },
	          "IdempotencyToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisioningArtifactDetail": {
	            "shape": "S2i"
	          },
	          "Info": {
	            "shape": "S27"
	          },
	          "Status": {}
	        }
	      }
	    },
	    "CreateServiceAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "DefinitionType",
	          "Definition",
	          "IdempotencyToken"
	        ],
	        "members": {
	          "Name": {},
	          "DefinitionType": {},
	          "Definition": {
	            "shape": "S32"
	          },
	          "Description": {},
	          "AcceptLanguage": {},
	          "IdempotencyToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceActionDetail": {
	            "shape": "S37"
	          }
	        }
	      }
	    },
	    "CreateTagOption": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TagOptionDetail": {
	            "shape": "S3d"
	          }
	        }
	      }
	    },
	    "DeleteConstraint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeletePortfolio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeletePortfolioShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "AccountId": {},
	          "OrganizationNode": {
	            "shape": "S1s"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PortfolioShareToken": {}
	        }
	      }
	    },
	    "DeleteProduct": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteProvisionedProductPlan": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlanId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PlanId": {},
	          "IgnoreErrors": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteProvisioningArtifact": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId",
	          "ProvisioningArtifactId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProductId": {},
	          "ProvisioningArtifactId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteServiceAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {},
	          "AcceptLanguage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteTagOption": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DescribeConstraint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConstraintDetail": {
	            "shape": "S1b"
	          },
	          "ConstraintParameters": {},
	          "Status": {}
	        }
	      }
	    },
	    "DescribeCopyProductStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CopyProductToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "CopyProductToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CopyProductStatus": {},
	          "TargetProductId": {},
	          "StatusDetail": {}
	        }
	      }
	    },
	    "DescribePortfolio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PortfolioDetail": {
	            "shape": "S1n"
	          },
	          "Tags": {
	            "shape": "S1q"
	          },
	          "TagOptions": {
	            "shape": "S45"
	          },
	          "Budgets": {
	            "shape": "S46"
	          }
	        }
	      }
	    },
	    "DescribePortfolioShareStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioShareToken"
	        ],
	        "members": {
	          "PortfolioShareToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PortfolioShareToken": {},
	          "PortfolioId": {},
	          "OrganizationNodeValue": {},
	          "Status": {},
	          "ShareDetails": {
	            "type": "structure",
	            "members": {
	              "SuccessfulShares": {
	                "type": "list",
	                "member": {}
	              },
	              "ShareErrors": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "Accounts": {
	                      "type": "list",
	                      "member": {}
	                    },
	                    "Message": {},
	                    "Error": {}
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribePortfolioShares": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId",
	          "Type"
	        ],
	        "members": {
	          "PortfolioId": {},
	          "Type": {},
	          "PageToken": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextPageToken": {},
	          "PortfolioShareDetails": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PrincipalId": {},
	                "Type": {},
	                "Accepted": {
	                  "type": "boolean"
	                },
	                "ShareTagOptions": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeProduct": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {},
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProductViewSummary": {
	            "shape": "S2e"
	          },
	          "ProvisioningArtifacts": {
	            "shape": "S4r"
	          },
	          "Budgets": {
	            "shape": "S46"
	          },
	          "LaunchPaths": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeProductAsAdmin": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {},
	          "Name": {},
	          "SourcePortfolioId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProductViewDetail": {
	            "shape": "S2d"
	          },
	          "ProvisioningArtifactSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Name": {},
	                "Description": {},
	                "CreatedTime": {
	                  "type": "timestamp"
	                },
	                "ProvisioningArtifactMetadata": {
	                  "shape": "S27"
	                }
	              }
	            }
	          },
	          "Tags": {
	            "shape": "S1q"
	          },
	          "TagOptions": {
	            "shape": "S45"
	          },
	          "Budgets": {
	            "shape": "S46"
	          }
	        }
	      }
	    },
	    "DescribeProductView": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProductViewSummary": {
	            "shape": "S2e"
	          },
	          "ProvisioningArtifacts": {
	            "shape": "S4r"
	          }
	        }
	      }
	    },
	    "DescribeProvisionedProduct": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {},
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisionedProductDetail": {
	            "shape": "S55"
	          },
	          "CloudWatchDashboards": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeProvisionedProductPlan": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlanId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PlanId": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisionedProductPlanDetails": {
	            "type": "structure",
	            "members": {
	              "CreatedTime": {
	                "type": "timestamp"
	              },
	              "PathId": {},
	              "ProductId": {},
	              "PlanName": {},
	              "PlanId": {},
	              "ProvisionProductId": {},
	              "ProvisionProductName": {},
	              "PlanType": {},
	              "ProvisioningArtifactId": {},
	              "Status": {},
	              "UpdatedTime": {
	                "type": "timestamp"
	              },
	              "NotificationArns": {
	                "shape": "S2o"
	              },
	              "ProvisioningParameters": {
	                "shape": "S2r"
	              },
	              "Tags": {
	                "shape": "S1q"
	              },
	              "StatusMessage": {}
	            }
	          },
	          "ResourceChanges": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Action": {},
	                "LogicalResourceId": {},
	                "PhysicalResourceId": {},
	                "ResourceType": {},
	                "Replacement": {},
	                "Scope": {
	                  "type": "list",
	                  "member": {}
	                },
	                "Details": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Target": {
	                        "type": "structure",
	                        "members": {
	                          "Attribute": {},
	                          "Name": {},
	                          "RequiresRecreation": {}
	                        }
	                      },
	                      "Evaluation": {},
	                      "CausingEntity": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "DescribeProvisioningArtifact": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "ProvisioningArtifactId": {},
	          "ProductId": {},
	          "ProvisioningArtifactName": {},
	          "ProductName": {},
	          "Verbose": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisioningArtifactDetail": {
	            "shape": "S2i"
	          },
	          "Info": {
	            "shape": "S27"
	          },
	          "Status": {}
	        }
	      }
	    },
	    "DescribeProvisioningParameters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "ProductId": {},
	          "ProductName": {},
	          "ProvisioningArtifactId": {},
	          "ProvisioningArtifactName": {},
	          "PathId": {},
	          "PathName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisioningArtifactParameters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ParameterKey": {},
	                "DefaultValue": {},
	                "ParameterType": {},
	                "IsNoEcho": {
	                  "type": "boolean"
	                },
	                "Description": {},
	                "ParameterConstraints": {
	                  "type": "structure",
	                  "members": {
	                    "AllowedValues": {
	                      "type": "list",
	                      "member": {}
	                    },
	                    "AllowedPattern": {},
	                    "ConstraintDescription": {},
	                    "MaxLength": {},
	                    "MinLength": {},
	                    "MaxValue": {},
	                    "MinValue": {}
	                  }
	                }
	              }
	            }
	          },
	          "ConstraintSummaries": {
	            "shape": "S6h"
	          },
	          "UsageInstructions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Type": {},
	                "Value": {}
	              }
	            }
	          },
	          "TagOptions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Key": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "ProvisioningArtifactPreferences": {
	            "type": "structure",
	            "members": {
	              "StackSetAccounts": {
	                "shape": "S6r"
	              },
	              "StackSetRegions": {
	                "shape": "S6s"
	              }
	            }
	          },
	          "ProvisioningArtifactOutputs": {
	            "shape": "S6u",
	            "deprecated": true,
	            "deprecatedMessage": "This property is deprecated and returns the Id and Description of the Provisioning Artifact. Use ProvisioningArtifactOutputKeys instead to get the Keys and Descriptions of the outputs."
	          },
	          "ProvisioningArtifactOutputKeys": {
	            "shape": "S6u"
	          }
	        }
	      }
	    },
	    "DescribeRecord": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {},
	          "PageToken": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RecordDetail": {
	            "shape": "S70"
	          },
	          "RecordOutputs": {
	            "shape": "S7b"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "DescribeServiceAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {},
	          "AcceptLanguage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceActionDetail": {
	            "shape": "S37"
	          }
	        }
	      }
	    },
	    "DescribeServiceActionExecutionParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProvisionedProductId",
	          "ServiceActionId"
	        ],
	        "members": {
	          "ProvisionedProductId": {},
	          "ServiceActionId": {},
	          "AcceptLanguage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceActionParameters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Type": {},
	                "DefaultValues": {
	                  "shape": "S7n"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeTagOption": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TagOptionDetail": {
	            "shape": "S3d"
	          }
	        }
	      }
	    },
	    "DisableAWSOrganizationsAccess": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DisassociateBudgetFromResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BudgetName",
	          "ResourceId"
	        ],
	        "members": {
	          "BudgetName": {},
	          "ResourceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DisassociatePrincipalFromPortfolio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId",
	          "PrincipalARN"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "PrincipalARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DisassociateProductFromPortfolio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId",
	          "PortfolioId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProductId": {},
	          "PortfolioId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DisassociateServiceActionFromProvisioningArtifact": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId",
	          "ProvisioningArtifactId",
	          "ServiceActionId"
	        ],
	        "members": {
	          "ProductId": {},
	          "ProvisioningArtifactId": {},
	          "ServiceActionId": {},
	          "AcceptLanguage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DisassociateTagOptionFromResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "TagOptionId"
	        ],
	        "members": {
	          "ResourceId": {},
	          "TagOptionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "EnableAWSOrganizationsAccess": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ExecuteProvisionedProductPlan": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlanId",
	          "IdempotencyToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PlanId": {},
	          "IdempotencyToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RecordDetail": {
	            "shape": "S70"
	          }
	        }
	      }
	    },
	    "ExecuteProvisionedProductServiceAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProvisionedProductId",
	          "ServiceActionId",
	          "ExecuteToken"
	        ],
	        "members": {
	          "ProvisionedProductId": {},
	          "ServiceActionId": {},
	          "ExecuteToken": {
	            "idempotencyToken": true
	          },
	          "AcceptLanguage": {},
	          "Parameters": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "shape": "S7n"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RecordDetail": {
	            "shape": "S70"
	          }
	        }
	      }
	    },
	    "GetAWSOrganizationsAccessStatus": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AccessStatus": {}
	        }
	      }
	    },
	    "GetProvisionedProductOutputs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "ProvisionedProductId": {},
	          "ProvisionedProductName": {},
	          "OutputKeys": {
	            "type": "list",
	            "member": {}
	          },
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Outputs": {
	            "shape": "S7b"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ImportAsProvisionedProduct": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId",
	          "ProvisioningArtifactId",
	          "ProvisionedProductName",
	          "PhysicalId",
	          "IdempotencyToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProductId": {},
	          "ProvisioningArtifactId": {},
	          "ProvisionedProductName": {},
	          "PhysicalId": {},
	          "IdempotencyToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RecordDetail": {
	            "shape": "S70"
	          }
	        }
	      }
	    },
	    "ListAcceptedPortfolioShares": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "PageToken": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PortfolioShareType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PortfolioDetails": {
	            "shape": "S8l"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListBudgetsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ResourceId": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Budgets": {
	            "shape": "S46"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListConstraintsForPortfolio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "ProductId": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConstraintDetails": {
	            "type": "list",
	            "member": {
	              "shape": "S1b"
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListLaunchPaths": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProductId": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LaunchPathSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "ConstraintSummaries": {
	                  "shape": "S6h"
	                },
	                "Tags": {
	                  "shape": "S1q"
	                },
	                "Name": {}
	              }
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListOrganizationPortfolioAccess": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId",
	          "OrganizationNodeType"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "OrganizationNodeType": {},
	          "PageToken": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OrganizationNodes": {
	            "type": "list",
	            "member": {
	              "shape": "S1s"
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListPortfolioAccess": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "OrganizationParentId": {},
	          "PageToken": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AccountIds": {
	            "type": "list",
	            "member": {}
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListPortfolios": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "PageToken": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PortfolioDetails": {
	            "shape": "S8l"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListPortfoliosForProduct": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProductId": {},
	          "PageToken": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PortfolioDetails": {
	            "shape": "S8l"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListPrincipalsForPortfolio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Principals": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PrincipalARN": {},
	                "PrincipalType": {}
	              }
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListProvisionedProductPlans": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "ProvisionProductId": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {},
	          "AccessLevelFilter": {
	            "shape": "S9a"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisionedProductPlans": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PlanName": {},
	                "PlanId": {},
	                "ProvisionProductId": {},
	                "ProvisionProductName": {},
	                "PlanType": {},
	                "ProvisioningArtifactId": {}
	              }
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListProvisioningArtifacts": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProductId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisioningArtifactDetails": {
	            "type": "list",
	            "member": {
	              "shape": "S2i"
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListProvisioningArtifactsForServiceAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ServiceActionId"
	        ],
	        "members": {
	          "ServiceActionId": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {},
	          "AcceptLanguage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisioningArtifactViews": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ProductViewSummary": {
	                  "shape": "S2e"
	                },
	                "ProvisioningArtifact": {
	                  "shape": "S4s"
	                }
	              }
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListRecordHistory": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "AccessLevelFilter": {
	            "shape": "S9a"
	          },
	          "SearchFilter": {
	            "type": "structure",
	            "members": {
	              "Key": {},
	              "Value": {}
	            }
	          },
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RecordDetails": {
	            "type": "list",
	            "member": {
	              "shape": "S70"
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListResourcesForTagOption": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TagOptionId"
	        ],
	        "members": {
	          "TagOptionId": {},
	          "ResourceType": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceDetails": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "ARN": {},
	                "Name": {},
	                "Description": {},
	                "CreatedTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "PageToken": {}
	        }
	      }
	    },
	    "ListServiceActions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceActionSummaries": {
	            "shape": "Sa5"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListServiceActionsForProvisioningArtifact": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId",
	          "ProvisioningArtifactId"
	        ],
	        "members": {
	          "ProductId": {},
	          "ProvisioningArtifactId": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {},
	          "AcceptLanguage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceActionSummaries": {
	            "shape": "Sa5"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListStackInstancesForProvisionedProduct": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProvisionedProductId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProvisionedProductId": {},
	          "PageToken": {},
	          "PageSize": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StackInstances": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Account": {},
	                "Region": {},
	                "StackInstanceStatus": {}
	              }
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "ListTagOptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "structure",
	            "members": {
	              "Key": {},
	              "Value": {},
	              "Active": {
	                "type": "boolean"
	              }
	            }
	          },
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TagOptionDetails": {
	            "shape": "S45"
	          },
	          "PageToken": {}
	        }
	      }
	    },
	    "ProvisionProduct": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProvisionedProductName",
	          "ProvisionToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProductId": {},
	          "ProductName": {},
	          "ProvisioningArtifactId": {},
	          "ProvisioningArtifactName": {},
	          "PathId": {},
	          "PathName": {},
	          "ProvisionedProductName": {},
	          "ProvisioningParameters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Key": {},
	                "Value": {}
	              }
	            }
	          },
	          "ProvisioningPreferences": {
	            "type": "structure",
	            "members": {
	              "StackSetAccounts": {
	                "shape": "S6r"
	              },
	              "StackSetRegions": {
	                "shape": "S6s"
	              },
	              "StackSetFailureToleranceCount": {
	                "type": "integer"
	              },
	              "StackSetFailureTolerancePercentage": {
	                "type": "integer"
	              },
	              "StackSetMaxConcurrencyCount": {
	                "type": "integer"
	              },
	              "StackSetMaxConcurrencyPercentage": {
	                "type": "integer"
	              }
	            }
	          },
	          "Tags": {
	            "shape": "S1q"
	          },
	          "NotificationArns": {
	            "shape": "S2o"
	          },
	          "ProvisionToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RecordDetail": {
	            "shape": "S70"
	          }
	        }
	      }
	    },
	    "RejectPortfolioShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "PortfolioShareType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ScanProvisionedProducts": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "AccessLevelFilter": {
	            "shape": "S9a"
	          },
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisionedProducts": {
	            "type": "list",
	            "member": {
	              "shape": "S55"
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "SearchProducts": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "Filters": {
	            "shape": "Sav"
	          },
	          "PageSize": {
	            "type": "integer"
	          },
	          "SortBy": {},
	          "SortOrder": {},
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProductViewSummaries": {
	            "type": "list",
	            "member": {
	              "shape": "S2e"
	            }
	          },
	          "ProductViewAggregations": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "list",
	              "member": {
	                "type": "structure",
	                "members": {
	                  "Value": {},
	                  "ApproximateCount": {
	                    "type": "integer"
	                  }
	                }
	              }
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "SearchProductsAsAdmin": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "Filters": {
	            "shape": "Sav"
	          },
	          "SortBy": {},
	          "SortOrder": {},
	          "PageToken": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "ProductSource": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProductViewDetails": {
	            "type": "list",
	            "member": {
	              "shape": "S2d"
	            }
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "SearchProvisionedProducts": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AcceptLanguage": {},
	          "AccessLevelFilter": {
	            "shape": "S9a"
	          },
	          "Filters": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "list",
	              "member": {}
	            }
	          },
	          "SortBy": {},
	          "SortOrder": {},
	          "PageSize": {
	            "type": "integer"
	          },
	          "PageToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisionedProducts": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Arn": {},
	                "Type": {},
	                "Id": {},
	                "Status": {},
	                "StatusMessage": {},
	                "CreatedTime": {
	                  "type": "timestamp"
	                },
	                "IdempotencyToken": {},
	                "LastRecordId": {},
	                "LastProvisioningRecordId": {},
	                "LastSuccessfulProvisioningRecordId": {},
	                "Tags": {
	                  "shape": "S1q"
	                },
	                "PhysicalId": {},
	                "ProductId": {},
	                "ProductName": {},
	                "ProvisioningArtifactId": {},
	                "ProvisioningArtifactName": {},
	                "UserArn": {},
	                "UserArnSession": {}
	              }
	            }
	          },
	          "TotalResultsCount": {
	            "type": "integer"
	          },
	          "NextPageToken": {}
	        }
	      }
	    },
	    "TerminateProvisionedProduct": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TerminateToken"
	        ],
	        "members": {
	          "ProvisionedProductName": {},
	          "ProvisionedProductId": {},
	          "TerminateToken": {
	            "idempotencyToken": true
	          },
	          "IgnoreErrors": {
	            "type": "boolean"
	          },
	          "AcceptLanguage": {},
	          "RetainPhysicalResources": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RecordDetail": {
	            "shape": "S70"
	          }
	        }
	      }
	    },
	    "UpdateConstraint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {},
	          "Description": {},
	          "Parameters": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ConstraintDetail": {
	            "shape": "S1b"
	          },
	          "ConstraintParameters": {},
	          "Status": {}
	        }
	      }
	    },
	    "UpdatePortfolio": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {},
	          "DisplayName": {},
	          "Description": {},
	          "ProviderName": {},
	          "AddTags": {
	            "shape": "S1i"
	          },
	          "RemoveTags": {
	            "shape": "Sbw"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PortfolioDetail": {
	            "shape": "S1n"
	          },
	          "Tags": {
	            "shape": "S1q"
	          }
	        }
	      }
	    },
	    "UpdatePortfolioShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PortfolioId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "PortfolioId": {},
	          "AccountId": {},
	          "OrganizationNode": {
	            "shape": "S1s"
	          },
	          "ShareTagOptions": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PortfolioShareToken": {},
	          "Status": {}
	        }
	      }
	    },
	    "UpdateProduct": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "Id": {},
	          "Name": {},
	          "Owner": {},
	          "Description": {},
	          "Distributor": {},
	          "SupportDescription": {},
	          "SupportEmail": {},
	          "SupportUrl": {},
	          "AddTags": {
	            "shape": "S1i"
	          },
	          "RemoveTags": {
	            "shape": "Sbw"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProductViewDetail": {
	            "shape": "S2d"
	          },
	          "Tags": {
	            "shape": "S1q"
	          }
	        }
	      }
	    },
	    "UpdateProvisionedProduct": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UpdateToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProvisionedProductName": {},
	          "ProvisionedProductId": {},
	          "ProductId": {},
	          "ProductName": {},
	          "ProvisioningArtifactId": {},
	          "ProvisioningArtifactName": {},
	          "PathId": {},
	          "PathName": {},
	          "ProvisioningParameters": {
	            "shape": "S2r"
	          },
	          "ProvisioningPreferences": {
	            "type": "structure",
	            "members": {
	              "StackSetAccounts": {
	                "shape": "S6r"
	              },
	              "StackSetRegions": {
	                "shape": "S6s"
	              },
	              "StackSetFailureToleranceCount": {
	                "type": "integer"
	              },
	              "StackSetFailureTolerancePercentage": {
	                "type": "integer"
	              },
	              "StackSetMaxConcurrencyCount": {
	                "type": "integer"
	              },
	              "StackSetMaxConcurrencyPercentage": {
	                "type": "integer"
	              },
	              "StackSetOperationType": {}
	            }
	          },
	          "Tags": {
	            "shape": "S1q"
	          },
	          "UpdateToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RecordDetail": {
	            "shape": "S70"
	          }
	        }
	      }
	    },
	    "UpdateProvisionedProductProperties": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProvisionedProductId",
	          "ProvisionedProductProperties",
	          "IdempotencyToken"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProvisionedProductId": {},
	          "ProvisionedProductProperties": {
	            "shape": "Sc8"
	          },
	          "IdempotencyToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisionedProductId": {},
	          "ProvisionedProductProperties": {
	            "shape": "Sc8"
	          },
	          "RecordId": {},
	          "Status": {}
	        }
	      }
	    },
	    "UpdateProvisioningArtifact": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ProductId",
	          "ProvisioningArtifactId"
	        ],
	        "members": {
	          "AcceptLanguage": {},
	          "ProductId": {},
	          "ProvisioningArtifactId": {},
	          "Name": {},
	          "Description": {},
	          "Active": {
	            "type": "boolean"
	          },
	          "Guidance": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ProvisioningArtifactDetail": {
	            "shape": "S2i"
	          },
	          "Info": {
	            "shape": "S27"
	          },
	          "Status": {}
	        }
	      }
	    },
	    "UpdateServiceAction": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {},
	          "Name": {},
	          "Definition": {
	            "shape": "S32"
	          },
	          "Description": {},
	          "AcceptLanguage": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceActionDetail": {
	            "shape": "S37"
	          }
	        }
	      }
	    },
	    "UpdateTagOption": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Id"
	        ],
	        "members": {
	          "Id": {},
	          "Value": {},
	          "Active": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TagOptionDetail": {
	            "shape": "S3d"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sm": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "ServiceActionId",
	          "ProductId",
	          "ProvisioningArtifactId"
	        ],
	        "members": {
	          "ServiceActionId": {},
	          "ProductId": {},
	          "ProvisioningArtifactId": {}
	        }
	      }
	    },
	    "Sp": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ServiceActionId": {},
	          "ProductId": {},
	          "ProvisioningArtifactId": {},
	          "ErrorCode": {},
	          "ErrorMessage": {}
	        }
	      }
	    },
	    "S1b": {
	      "type": "structure",
	      "members": {
	        "ConstraintId": {},
	        "Type": {},
	        "Description": {},
	        "Owner": {},
	        "ProductId": {},
	        "PortfolioId": {}
	      }
	    },
	    "S1i": {
	      "type": "list",
	      "member": {
	        "shape": "S1j"
	      }
	    },
	    "S1j": {
	      "type": "structure",
	      "required": [
	        "Key",
	        "Value"
	      ],
	      "members": {
	        "Key": {},
	        "Value": {}
	      }
	    },
	    "S1n": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "ARN": {},
	        "DisplayName": {},
	        "Description": {},
	        "CreatedTime": {
	          "type": "timestamp"
	        },
	        "ProviderName": {}
	      }
	    },
	    "S1q": {
	      "type": "list",
	      "member": {
	        "shape": "S1j"
	      }
	    },
	    "S1s": {
	      "type": "structure",
	      "members": {
	        "Type": {},
	        "Value": {}
	      }
	    },
	    "S24": {
	      "type": "structure",
	      "required": [
	        "Info"
	      ],
	      "members": {
	        "Name": {},
	        "Description": {},
	        "Info": {
	          "shape": "S27"
	        },
	        "Type": {},
	        "DisableTemplateValidation": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S27": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S2d": {
	      "type": "structure",
	      "members": {
	        "ProductViewSummary": {
	          "shape": "S2e"
	        },
	        "Status": {},
	        "ProductARN": {},
	        "CreatedTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S2e": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "ProductId": {},
	        "Name": {},
	        "Owner": {},
	        "ShortDescription": {},
	        "Type": {},
	        "Distributor": {},
	        "HasDefaultPath": {
	          "type": "boolean"
	        },
	        "SupportEmail": {},
	        "SupportDescription": {},
	        "SupportUrl": {}
	      }
	    },
	    "S2i": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Name": {},
	        "Description": {},
	        "Type": {},
	        "CreatedTime": {
	          "type": "timestamp"
	        },
	        "Active": {
	          "type": "boolean"
	        },
	        "Guidance": {}
	      }
	    },
	    "S2o": {
	      "type": "list",
	      "member": {}
	    },
	    "S2r": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Value": {},
	          "UsePreviousValue": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "S32": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S37": {
	      "type": "structure",
	      "members": {
	        "ServiceActionSummary": {
	          "shape": "S38"
	        },
	        "Definition": {
	          "shape": "S32"
	        }
	      }
	    },
	    "S38": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Name": {},
	        "Description": {},
	        "DefinitionType": {}
	      }
	    },
	    "S3d": {
	      "type": "structure",
	      "members": {
	        "Key": {},
	        "Value": {},
	        "Active": {
	          "type": "boolean"
	        },
	        "Id": {},
	        "Owner": {}
	      }
	    },
	    "S45": {
	      "type": "list",
	      "member": {
	        "shape": "S3d"
	      }
	    },
	    "S46": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "BudgetName": {}
	        }
	      }
	    },
	    "S4r": {
	      "type": "list",
	      "member": {
	        "shape": "S4s"
	      }
	    },
	    "S4s": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Name": {},
	        "Description": {},
	        "CreatedTime": {
	          "type": "timestamp"
	        },
	        "Guidance": {}
	      }
	    },
	    "S55": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Arn": {},
	        "Type": {},
	        "Id": {},
	        "Status": {},
	        "StatusMessage": {},
	        "CreatedTime": {
	          "type": "timestamp"
	        },
	        "IdempotencyToken": {},
	        "LastRecordId": {},
	        "LastProvisioningRecordId": {},
	        "LastSuccessfulProvisioningRecordId": {},
	        "ProductId": {},
	        "ProvisioningArtifactId": {},
	        "LaunchRoleArn": {}
	      }
	    },
	    "S6h": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "Description": {}
	        }
	      }
	    },
	    "S6r": {
	      "type": "list",
	      "member": {}
	    },
	    "S6s": {
	      "type": "list",
	      "member": {}
	    },
	    "S6u": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Description": {}
	        }
	      }
	    },
	    "S70": {
	      "type": "structure",
	      "members": {
	        "RecordId": {},
	        "ProvisionedProductName": {},
	        "Status": {},
	        "CreatedTime": {
	          "type": "timestamp"
	        },
	        "UpdatedTime": {
	          "type": "timestamp"
	        },
	        "ProvisionedProductType": {},
	        "RecordType": {},
	        "ProvisionedProductId": {},
	        "ProductId": {},
	        "ProvisioningArtifactId": {},
	        "PathId": {},
	        "RecordErrors": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Code": {},
	              "Description": {}
	            }
	          }
	        },
	        "RecordTags": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Key": {},
	              "Value": {}
	            }
	          }
	        },
	        "LaunchRoleArn": {}
	      }
	    },
	    "S7b": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "OutputKey": {},
	          "OutputValue": {},
	          "Description": {}
	        }
	      }
	    },
	    "S7n": {
	      "type": "list",
	      "member": {}
	    },
	    "S8l": {
	      "type": "list",
	      "member": {
	        "shape": "S1n"
	      }
	    },
	    "S9a": {
	      "type": "structure",
	      "members": {
	        "Key": {},
	        "Value": {}
	      }
	    },
	    "Sa5": {
	      "type": "list",
	      "member": {
	        "shape": "S38"
	      }
	    },
	    "Sav": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "list",
	        "member": {}
	      }
	    },
	    "Sbw": {
	      "type": "list",
	      "member": {}
	    },
	    "Sc8": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    }
	  }
	}
	},{}],218:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribePortfolioShares": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "GetProvisionedProductOutputs": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListAcceptedPortfolioShares": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListBudgetsForResource": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListConstraintsForPortfolio": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListLaunchPaths": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListOrganizationPortfolioAccess": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListPortfolioAccess": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListPortfolios": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListPortfoliosForProduct": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListPrincipalsForPortfolio": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListProvisioningArtifactsForServiceAction": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListResourcesForTagOption": {
	      "input_token": "PageToken",
	      "output_token": "PageToken",
	      "limit_key": "PageSize"
	    },
	    "ListServiceActions": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListServiceActionsForProvisioningArtifact": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "ListTagOptions": {
	      "input_token": "PageToken",
	      "output_token": "PageToken",
	      "limit_key": "PageSize"
	    },
	    "SearchProducts": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "SearchProductsAsAdmin": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    },
	    "SearchProvisionedProducts": {
	      "input_token": "PageToken",
	      "output_token": "NextPageToken",
	      "limit_key": "PageSize"
	    }
	  }
	}
	
	},{}],219:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2010-03-31",
	    "endpointPrefix": "sns",
	    "protocol": "query",
	    "serviceAbbreviation": "Amazon SNS",
	    "serviceFullName": "Amazon Simple Notification Service",
	    "serviceId": "SNS",
	    "signatureVersion": "v4",
	    "uid": "sns-2010-03-31",
	    "xmlNamespace": "http://sns.amazonaws.com/doc/2010-03-31/"
	  },
	  "operations": {
	    "AddPermission": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TopicArn",
	          "Label",
	          "AWSAccountId",
	          "ActionName"
	        ],
	        "members": {
	          "TopicArn": {},
	          "Label": {},
	          "AWSAccountId": {
	            "type": "list",
	            "member": {}
	          },
	          "ActionName": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "CheckIfPhoneNumberIsOptedOut": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "phoneNumber"
	        ],
	        "members": {
	          "phoneNumber": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CheckIfPhoneNumberIsOptedOutResult",
	        "type": "structure",
	        "members": {
	          "isOptedOut": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "ConfirmSubscription": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TopicArn",
	          "Token"
	        ],
	        "members": {
	          "TopicArn": {},
	          "Token": {},
	          "AuthenticateOnUnsubscribe": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ConfirmSubscriptionResult",
	        "type": "structure",
	        "members": {
	          "SubscriptionArn": {}
	        }
	      }
	    },
	    "CreatePlatformApplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Platform",
	          "Attributes"
	        ],
	        "members": {
	          "Name": {},
	          "Platform": {},
	          "Attributes": {
	            "shape": "Sj"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreatePlatformApplicationResult",
	        "type": "structure",
	        "members": {
	          "PlatformApplicationArn": {}
	        }
	      }
	    },
	    "CreatePlatformEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlatformApplicationArn",
	          "Token"
	        ],
	        "members": {
	          "PlatformApplicationArn": {},
	          "Token": {},
	          "CustomUserData": {},
	          "Attributes": {
	            "shape": "Sj"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreatePlatformEndpointResult",
	        "type": "structure",
	        "members": {
	          "EndpointArn": {}
	        }
	      }
	    },
	    "CreateSMSSandboxPhoneNumber": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PhoneNumber"
	        ],
	        "members": {
	          "PhoneNumber": {},
	          "LanguageCode": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateSMSSandboxPhoneNumberResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateTopic": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Attributes": {
	            "shape": "St"
	          },
	          "Tags": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateTopicResult",
	        "type": "structure",
	        "members": {
	          "TopicArn": {}
	        }
	      }
	    },
	    "DeleteEndpoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EndpointArn"
	        ],
	        "members": {
	          "EndpointArn": {}
	        }
	      }
	    },
	    "DeletePlatformApplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlatformApplicationArn"
	        ],
	        "members": {
	          "PlatformApplicationArn": {}
	        }
	      }
	    },
	    "DeleteSMSSandboxPhoneNumber": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PhoneNumber"
	        ],
	        "members": {
	          "PhoneNumber": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteSMSSandboxPhoneNumberResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteTopic": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TopicArn"
	        ],
	        "members": {
	          "TopicArn": {}
	        }
	      }
	    },
	    "GetEndpointAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EndpointArn"
	        ],
	        "members": {
	          "EndpointArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetEndpointAttributesResult",
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "GetPlatformApplicationAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlatformApplicationArn"
	        ],
	        "members": {
	          "PlatformApplicationArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetPlatformApplicationAttributesResult",
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "GetSMSAttributes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "attributes": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetSMSAttributesResult",
	        "type": "structure",
	        "members": {
	          "attributes": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "GetSMSSandboxAccountStatus": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "resultWrapper": "GetSMSSandboxAccountStatusResult",
	        "type": "structure",
	        "required": [
	          "IsInSandbox"
	        ],
	        "members": {
	          "IsInSandbox": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "GetSubscriptionAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionArn"
	        ],
	        "members": {
	          "SubscriptionArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetSubscriptionAttributesResult",
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "S1h"
	          }
	        }
	      }
	    },
	    "GetTopicAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TopicArn"
	        ],
	        "members": {
	          "TopicArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetTopicAttributesResult",
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "St"
	          }
	        }
	      }
	    },
	    "ListEndpointsByPlatformApplication": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlatformApplicationArn"
	        ],
	        "members": {
	          "PlatformApplicationArn": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListEndpointsByPlatformApplicationResult",
	        "type": "structure",
	        "members": {
	          "Endpoints": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "EndpointArn": {},
	                "Attributes": {
	                  "shape": "Sj"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListOriginationNumbers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListOriginationNumbersResult",
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "PhoneNumbers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "CreatedAt": {
	                  "type": "timestamp"
	                },
	                "PhoneNumber": {},
	                "Status": {},
	                "Iso2CountryCode": {},
	                "RouteType": {},
	                "NumberCapabilities": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListPhoneNumbersOptedOut": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "nextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListPhoneNumbersOptedOutResult",
	        "type": "structure",
	        "members": {
	          "phoneNumbers": {
	            "type": "list",
	            "member": {}
	          },
	          "nextToken": {}
	        }
	      }
	    },
	    "ListPlatformApplications": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListPlatformApplicationsResult",
	        "type": "structure",
	        "members": {
	          "PlatformApplications": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PlatformApplicationArn": {},
	                "Attributes": {
	                  "shape": "Sj"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListSMSSandboxPhoneNumbers": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListSMSSandboxPhoneNumbersResult",
	        "type": "structure",
	        "required": [
	          "PhoneNumbers"
	        ],
	        "members": {
	          "PhoneNumbers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PhoneNumber": {},
	                "Status": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListSubscriptions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListSubscriptionsResult",
	        "type": "structure",
	        "members": {
	          "Subscriptions": {
	            "shape": "S2f"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListSubscriptionsByTopic": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TopicArn"
	        ],
	        "members": {
	          "TopicArn": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListSubscriptionsByTopicResult",
	        "type": "structure",
	        "members": {
	          "Subscriptions": {
	            "shape": "S2f"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTagsForResourceResult",
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "Sw"
	          }
	        }
	      }
	    },
	    "ListTopics": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListTopicsResult",
	        "type": "structure",
	        "members": {
	          "Topics": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TopicArn": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "OptInPhoneNumber": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "phoneNumber"
	        ],
	        "members": {
	          "phoneNumber": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "OptInPhoneNumberResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "Publish": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Message"
	        ],
	        "members": {
	          "TopicArn": {},
	          "TargetArn": {},
	          "PhoneNumber": {},
	          "Message": {},
	          "Subject": {},
	          "MessageStructure": {},
	          "MessageAttributes": {
	            "shape": "S2z"
	          },
	          "MessageDeduplicationId": {},
	          "MessageGroupId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "PublishResult",
	        "type": "structure",
	        "members": {
	          "MessageId": {},
	          "SequenceNumber": {}
	        }
	      }
	    },
	    "PublishBatch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TopicArn",
	          "PublishBatchRequestEntries"
	        ],
	        "members": {
	          "TopicArn": {},
	          "PublishBatchRequestEntries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Id",
	                "Message"
	              ],
	              "members": {
	                "Id": {},
	                "Message": {},
	                "Subject": {},
	                "MessageStructure": {},
	                "MessageAttributes": {
	                  "shape": "S2z"
	                },
	                "MessageDeduplicationId": {},
	                "MessageGroupId": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "PublishBatchResult",
	        "type": "structure",
	        "members": {
	          "Successful": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "MessageId": {},
	                "SequenceNumber": {}
	              }
	            }
	          },
	          "Failed": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Id",
	                "Code",
	                "SenderFault"
	              ],
	              "members": {
	                "Id": {},
	                "Code": {},
	                "Message": {},
	                "SenderFault": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "RemovePermission": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TopicArn",
	          "Label"
	        ],
	        "members": {
	          "TopicArn": {},
	          "Label": {}
	        }
	      }
	    },
	    "SetEndpointAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EndpointArn",
	          "Attributes"
	        ],
	        "members": {
	          "EndpointArn": {},
	          "Attributes": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "SetPlatformApplicationAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PlatformApplicationArn",
	          "Attributes"
	        ],
	        "members": {
	          "PlatformApplicationArn": {},
	          "Attributes": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "SetSMSAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "attributes"
	        ],
	        "members": {
	          "attributes": {
	            "shape": "Sj"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SetSMSAttributesResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SetSubscriptionAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionArn",
	          "AttributeName"
	        ],
	        "members": {
	          "SubscriptionArn": {},
	          "AttributeName": {},
	          "AttributeValue": {}
	        }
	      }
	    },
	    "SetTopicAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TopicArn",
	          "AttributeName"
	        ],
	        "members": {
	          "TopicArn": {},
	          "AttributeName": {},
	          "AttributeValue": {}
	        }
	      }
	    },
	    "Subscribe": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TopicArn",
	          "Protocol"
	        ],
	        "members": {
	          "TopicArn": {},
	          "Protocol": {},
	          "Endpoint": {},
	          "Attributes": {
	            "shape": "S1h"
	          },
	          "ReturnSubscriptionArn": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SubscribeResult",
	        "type": "structure",
	        "members": {
	          "SubscriptionArn": {}
	        }
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Tags"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Tags": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "TagResourceResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "Unsubscribe": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionArn"
	        ],
	        "members": {
	          "SubscriptionArn": {}
	        }
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "UntagResourceResult",
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "VerifySMSSandboxPhoneNumber": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PhoneNumber",
	          "OneTimePassword"
	        ],
	        "members": {
	          "PhoneNumber": {},
	          "OneTimePassword": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "VerifySMSSandboxPhoneNumberResult",
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "Sj": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "St": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sw": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S1h": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S2f": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "SubscriptionArn": {},
	          "Owner": {},
	          "Protocol": {},
	          "Endpoint": {},
	          "TopicArn": {}
	        }
	      }
	    },
	    "S2z": {
	      "type": "map",
	      "key": {
	        "locationName": "Name"
	      },
	      "value": {
	        "locationName": "Value",
	        "type": "structure",
	        "required": [
	          "DataType"
	        ],
	        "members": {
	          "DataType": {},
	          "StringValue": {},
	          "BinaryValue": {
	            "type": "blob"
	          }
	        }
	      }
	    }
	  }
	}
	},{}],220:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListEndpointsByPlatformApplication": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Endpoints"
	    },
	    "ListOriginationNumbers": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "PhoneNumbers"
	    },
	    "ListPhoneNumbersOptedOut": {
	      "input_token": "nextToken",
	      "output_token": "nextToken",
	      "result_key": "phoneNumbers"
	    },
	    "ListPlatformApplications": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "PlatformApplications"
	    },
	    "ListSMSSandboxPhoneNumbers": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "PhoneNumbers"
	    },
	    "ListSubscriptions": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Subscriptions"
	    },
	    "ListSubscriptionsByTopic": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Subscriptions"
	    },
	    "ListTopics": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Topics"
	    }
	  }
	}
	},{}],221:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2012-11-05",
	    "endpointPrefix": "sqs",
	    "protocol": "query",
	    "serviceAbbreviation": "Amazon SQS",
	    "serviceFullName": "Amazon Simple Queue Service",
	    "serviceId": "SQS",
	    "signatureVersion": "v4",
	    "uid": "sqs-2012-11-05",
	    "xmlNamespace": "http://queue.amazonaws.com/doc/2012-11-05/"
	  },
	  "operations": {
	    "AddPermission": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl",
	          "Label",
	          "AWSAccountIds",
	          "Actions"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "Label": {},
	          "AWSAccountIds": {
	            "type": "list",
	            "member": {
	              "locationName": "AWSAccountId"
	            },
	            "flattened": true
	          },
	          "Actions": {
	            "type": "list",
	            "member": {
	              "locationName": "ActionName"
	            },
	            "flattened": true
	          }
	        }
	      }
	    },
	    "ChangeMessageVisibility": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl",
	          "ReceiptHandle",
	          "VisibilityTimeout"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "ReceiptHandle": {},
	          "VisibilityTimeout": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "ChangeMessageVisibilityBatch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl",
	          "Entries"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "Entries": {
	            "type": "list",
	            "member": {
	              "locationName": "ChangeMessageVisibilityBatchRequestEntry",
	              "type": "structure",
	              "required": [
	                "Id",
	                "ReceiptHandle"
	              ],
	              "members": {
	                "Id": {},
	                "ReceiptHandle": {},
	                "VisibilityTimeout": {
	                  "type": "integer"
	                }
	              }
	            },
	            "flattened": true
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ChangeMessageVisibilityBatchResult",
	        "type": "structure",
	        "required": [
	          "Successful",
	          "Failed"
	        ],
	        "members": {
	          "Successful": {
	            "type": "list",
	            "member": {
	              "locationName": "ChangeMessageVisibilityBatchResultEntry",
	              "type": "structure",
	              "required": [
	                "Id"
	              ],
	              "members": {
	                "Id": {}
	              }
	            },
	            "flattened": true
	          },
	          "Failed": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "CreateQueue": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueName"
	        ],
	        "members": {
	          "QueueName": {},
	          "Attributes": {
	            "shape": "Sh",
	            "locationName": "Attribute"
	          },
	          "tags": {
	            "shape": "Sj",
	            "locationName": "Tag"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "CreateQueueResult",
	        "type": "structure",
	        "members": {
	          "QueueUrl": {}
	        }
	      }
	    },
	    "DeleteMessage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl",
	          "ReceiptHandle"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "ReceiptHandle": {}
	        }
	      }
	    },
	    "DeleteMessageBatch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl",
	          "Entries"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "Entries": {
	            "type": "list",
	            "member": {
	              "locationName": "DeleteMessageBatchRequestEntry",
	              "type": "structure",
	              "required": [
	                "Id",
	                "ReceiptHandle"
	              ],
	              "members": {
	                "Id": {},
	                "ReceiptHandle": {}
	              }
	            },
	            "flattened": true
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "DeleteMessageBatchResult",
	        "type": "structure",
	        "required": [
	          "Successful",
	          "Failed"
	        ],
	        "members": {
	          "Successful": {
	            "type": "list",
	            "member": {
	              "locationName": "DeleteMessageBatchResultEntry",
	              "type": "structure",
	              "required": [
	                "Id"
	              ],
	              "members": {
	                "Id": {}
	              }
	            },
	            "flattened": true
	          },
	          "Failed": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "DeleteQueue": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl"
	        ],
	        "members": {
	          "QueueUrl": {}
	        }
	      }
	    },
	    "GetQueueAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "AttributeNames": {
	            "shape": "Sw"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetQueueAttributesResult",
	        "type": "structure",
	        "members": {
	          "Attributes": {
	            "shape": "Sh",
	            "locationName": "Attribute"
	          }
	        }
	      }
	    },
	    "GetQueueUrl": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueName"
	        ],
	        "members": {
	          "QueueName": {},
	          "QueueOwnerAWSAccountId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetQueueUrlResult",
	        "type": "structure",
	        "members": {
	          "QueueUrl": {}
	        }
	      }
	    },
	    "ListDeadLetterSourceQueues": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListDeadLetterSourceQueuesResult",
	        "type": "structure",
	        "required": [
	          "queueUrls"
	        ],
	        "members": {
	          "queueUrls": {
	            "shape": "S14"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListQueueTags": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl"
	        ],
	        "members": {
	          "QueueUrl": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ListQueueTagsResult",
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "Sj",
	            "locationName": "Tag"
	          }
	        }
	      }
	    },
	    "ListQueues": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "QueueNamePrefix": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "ListQueuesResult",
	        "type": "structure",
	        "members": {
	          "QueueUrls": {
	            "shape": "S14"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PurgeQueue": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl"
	        ],
	        "members": {
	          "QueueUrl": {}
	        }
	      }
	    },
	    "ReceiveMessage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "AttributeNames": {
	            "shape": "Sw"
	          },
	          "MessageAttributeNames": {
	            "type": "list",
	            "member": {
	              "locationName": "MessageAttributeName"
	            },
	            "flattened": true
	          },
	          "MaxNumberOfMessages": {
	            "type": "integer"
	          },
	          "VisibilityTimeout": {
	            "type": "integer"
	          },
	          "WaitTimeSeconds": {
	            "type": "integer"
	          },
	          "ReceiveRequestAttemptId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "ReceiveMessageResult",
	        "type": "structure",
	        "members": {
	          "Messages": {
	            "type": "list",
	            "member": {
	              "locationName": "Message",
	              "type": "structure",
	              "members": {
	                "MessageId": {},
	                "ReceiptHandle": {},
	                "MD5OfBody": {},
	                "Body": {},
	                "Attributes": {
	                  "locationName": "Attribute",
	                  "type": "map",
	                  "key": {
	                    "locationName": "Name"
	                  },
	                  "value": {
	                    "locationName": "Value"
	                  },
	                  "flattened": true
	                },
	                "MD5OfMessageAttributes": {},
	                "MessageAttributes": {
	                  "shape": "S1i",
	                  "locationName": "MessageAttribute"
	                }
	              }
	            },
	            "flattened": true
	          }
	        }
	      }
	    },
	    "RemovePermission": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl",
	          "Label"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "Label": {}
	        }
	      }
	    },
	    "SendMessage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl",
	          "MessageBody"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "MessageBody": {},
	          "DelaySeconds": {
	            "type": "integer"
	          },
	          "MessageAttributes": {
	            "shape": "S1i",
	            "locationName": "MessageAttribute"
	          },
	          "MessageSystemAttributes": {
	            "shape": "S1p",
	            "locationName": "MessageSystemAttribute"
	          },
	          "MessageDeduplicationId": {},
	          "MessageGroupId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "SendMessageResult",
	        "type": "structure",
	        "members": {
	          "MD5OfMessageBody": {},
	          "MD5OfMessageAttributes": {},
	          "MD5OfMessageSystemAttributes": {},
	          "MessageId": {},
	          "SequenceNumber": {}
	        }
	      }
	    },
	    "SendMessageBatch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl",
	          "Entries"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "Entries": {
	            "type": "list",
	            "member": {
	              "locationName": "SendMessageBatchRequestEntry",
	              "type": "structure",
	              "required": [
	                "Id",
	                "MessageBody"
	              ],
	              "members": {
	                "Id": {},
	                "MessageBody": {},
	                "DelaySeconds": {
	                  "type": "integer"
	                },
	                "MessageAttributes": {
	                  "shape": "S1i",
	                  "locationName": "MessageAttribute"
	                },
	                "MessageSystemAttributes": {
	                  "shape": "S1p",
	                  "locationName": "MessageSystemAttribute"
	                },
	                "MessageDeduplicationId": {},
	                "MessageGroupId": {}
	              }
	            },
	            "flattened": true
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "SendMessageBatchResult",
	        "type": "structure",
	        "required": [
	          "Successful",
	          "Failed"
	        ],
	        "members": {
	          "Successful": {
	            "type": "list",
	            "member": {
	              "locationName": "SendMessageBatchResultEntry",
	              "type": "structure",
	              "required": [
	                "Id",
	                "MessageId",
	                "MD5OfMessageBody"
	              ],
	              "members": {
	                "Id": {},
	                "MessageId": {},
	                "MD5OfMessageBody": {},
	                "MD5OfMessageAttributes": {},
	                "MD5OfMessageSystemAttributes": {},
	                "SequenceNumber": {}
	              }
	            },
	            "flattened": true
	          },
	          "Failed": {
	            "shape": "Sd"
	          }
	        }
	      }
	    },
	    "SetQueueAttributes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl",
	          "Attributes"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "Attributes": {
	            "shape": "Sh",
	            "locationName": "Attribute"
	          }
	        }
	      }
	    },
	    "TagQueue": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl",
	          "Tags"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "Tags": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "UntagQueue": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "QueueUrl",
	          "TagKeys"
	        ],
	        "members": {
	          "QueueUrl": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {
	              "locationName": "TagKey"
	            },
	            "flattened": true
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sd": {
	      "type": "list",
	      "member": {
	        "locationName": "BatchResultErrorEntry",
	        "type": "structure",
	        "required": [
	          "Id",
	          "SenderFault",
	          "Code"
	        ],
	        "members": {
	          "Id": {},
	          "SenderFault": {
	            "type": "boolean"
	          },
	          "Code": {},
	          "Message": {}
	        }
	      },
	      "flattened": true
	    },
	    "Sh": {
	      "type": "map",
	      "key": {
	        "locationName": "Name"
	      },
	      "value": {
	        "locationName": "Value"
	      },
	      "flattened": true,
	      "locationName": "Attribute"
	    },
	    "Sj": {
	      "type": "map",
	      "key": {
	        "locationName": "Key"
	      },
	      "value": {
	        "locationName": "Value"
	      },
	      "flattened": true,
	      "locationName": "Tag"
	    },
	    "Sw": {
	      "type": "list",
	      "member": {
	        "locationName": "AttributeName"
	      },
	      "flattened": true
	    },
	    "S14": {
	      "type": "list",
	      "member": {
	        "locationName": "QueueUrl"
	      },
	      "flattened": true
	    },
	    "S1i": {
	      "type": "map",
	      "key": {
	        "locationName": "Name"
	      },
	      "value": {
	        "locationName": "Value",
	        "type": "structure",
	        "required": [
	          "DataType"
	        ],
	        "members": {
	          "StringValue": {},
	          "BinaryValue": {
	            "type": "blob"
	          },
	          "StringListValues": {
	            "shape": "S1l",
	            "flattened": true,
	            "locationName": "StringListValue"
	          },
	          "BinaryListValues": {
	            "shape": "S1m",
	            "flattened": true,
	            "locationName": "BinaryListValue"
	          },
	          "DataType": {}
	        }
	      },
	      "flattened": true
	    },
	    "S1l": {
	      "type": "list",
	      "member": {
	        "locationName": "StringListValue"
	      }
	    },
	    "S1m": {
	      "type": "list",
	      "member": {
	        "locationName": "BinaryListValue",
	        "type": "blob"
	      }
	    },
	    "S1p": {
	      "type": "map",
	      "key": {
	        "locationName": "Name"
	      },
	      "value": {
	        "locationName": "Value",
	        "type": "structure",
	        "required": [
	          "DataType"
	        ],
	        "members": {
	          "StringValue": {},
	          "BinaryValue": {
	            "type": "blob"
	          },
	          "StringListValues": {
	            "shape": "S1l",
	            "flattened": true,
	            "locationName": "StringListValue"
	          },
	          "BinaryListValues": {
	            "shape": "S1m",
	            "flattened": true,
	            "locationName": "BinaryListValue"
	          },
	          "DataType": {}
	        }
	      },
	      "flattened": true
	    }
	  }
	}
	},{}],222:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListDeadLetterSourceQueues": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "queueUrls"
	    },
	    "ListQueues": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "QueueUrls"
	    }
	  }
	}
	},{}],223:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2014-11-06",
	    "endpointPrefix": "ssm",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "Amazon SSM",
	    "serviceFullName": "Amazon Simple Systems Manager (SSM)",
	    "serviceId": "SSM",
	    "signatureVersion": "v4",
	    "targetPrefix": "AmazonSSM",
	    "uid": "ssm-2014-11-06"
	  },
	  "operations": {
	    "AddTagsToResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceType",
	          "ResourceId",
	          "Tags"
	        ],
	        "members": {
	          "ResourceType": {},
	          "ResourceId": {},
	          "Tags": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "AssociateOpsItemRelatedItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpsItemId",
	          "AssociationType",
	          "ResourceType",
	          "ResourceUri"
	        ],
	        "members": {
	          "OpsItemId": {},
	          "AssociationType": {},
	          "ResourceType": {},
	          "ResourceUri": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationId": {}
	        }
	      }
	    },
	    "CancelCommand": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CommandId"
	        ],
	        "members": {
	          "CommandId": {},
	          "InstanceIds": {
	            "shape": "Si"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CancelMaintenanceWindowExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowExecutionId"
	        ],
	        "members": {
	          "WindowExecutionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowExecutionId": {}
	        }
	      }
	    },
	    "CreateActivation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IamRole"
	        ],
	        "members": {
	          "Description": {},
	          "DefaultInstanceName": {},
	          "IamRole": {},
	          "RegistrationLimit": {
	            "type": "integer"
	          },
	          "ExpirationDate": {
	            "type": "timestamp"
	          },
	          "Tags": {
	            "shape": "S4"
	          },
	          "RegistrationMetadata": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Value"
	              ],
	              "members": {
	                "Key": {},
	                "Value": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ActivationId": {},
	          "ActivationCode": {}
	        }
	      }
	    },
	    "CreateAssociation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "DocumentVersion": {},
	          "InstanceId": {},
	          "Parameters": {
	            "shape": "S14"
	          },
	          "Targets": {
	            "shape": "S18"
	          },
	          "ScheduleExpression": {},
	          "OutputLocation": {
	            "shape": "S1e"
	          },
	          "AssociationName": {},
	          "AutomationTargetParameterName": {},
	          "MaxErrors": {},
	          "MaxConcurrency": {},
	          "ComplianceSeverity": {},
	          "SyncCompliance": {},
	          "ApplyOnlyAtCronInterval": {
	            "type": "boolean"
	          },
	          "CalendarNames": {
	            "shape": "S1q"
	          },
	          "TargetLocations": {
	            "shape": "S1s"
	          },
	          "ScheduleOffset": {
	            "type": "integer"
	          },
	          "TargetMaps": {
	            "shape": "S20"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationDescription": {
	            "shape": "S26"
	          }
	        }
	      }
	    },
	    "CreateAssociationBatch": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Entries"
	        ],
	        "members": {
	          "Entries": {
	            "type": "list",
	            "member": {
	              "shape": "S2k"
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Successful": {
	            "type": "list",
	            "member": {
	              "shape": "S26"
	            }
	          },
	          "Failed": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Entry": {
	                  "shape": "S2k"
	                },
	                "Message": {},
	                "Fault": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "CreateDocument": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Content",
	          "Name"
	        ],
	        "members": {
	          "Content": {},
	          "Requires": {
	            "shape": "S2t"
	          },
	          "Attachments": {
	            "shape": "S2v"
	          },
	          "Name": {},
	          "DisplayName": {},
	          "VersionName": {},
	          "DocumentType": {},
	          "DocumentFormat": {},
	          "TargetType": {},
	          "Tags": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DocumentDescription": {
	            "shape": "S38"
	          }
	        }
	      }
	    },
	    "CreateMaintenanceWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Schedule",
	          "Duration",
	          "Cutoff",
	          "AllowUnassociatedTargets"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {
	            "shape": "S42"
	          },
	          "StartDate": {},
	          "EndDate": {},
	          "Schedule": {},
	          "ScheduleTimezone": {},
	          "ScheduleOffset": {
	            "type": "integer"
	          },
	          "Duration": {
	            "type": "integer"
	          },
	          "Cutoff": {
	            "type": "integer"
	          },
	          "AllowUnassociatedTargets": {
	            "type": "boolean"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "Tags": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowId": {}
	        }
	      }
	    },
	    "CreateOpsItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Description",
	          "Source",
	          "Title"
	        ],
	        "members": {
	          "Description": {},
	          "OpsItemType": {},
	          "OperationalData": {
	            "shape": "S4g"
	          },
	          "Notifications": {
	            "shape": "S4l"
	          },
	          "Priority": {
	            "type": "integer"
	          },
	          "RelatedOpsItems": {
	            "shape": "S4p"
	          },
	          "Source": {},
	          "Title": {},
	          "Tags": {
	            "shape": "S4"
	          },
	          "Category": {},
	          "Severity": {},
	          "ActualStartTime": {
	            "type": "timestamp"
	          },
	          "ActualEndTime": {
	            "type": "timestamp"
	          },
	          "PlannedStartTime": {
	            "type": "timestamp"
	          },
	          "PlannedEndTime": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OpsItemId": {}
	        }
	      }
	    },
	    "CreateOpsMetadata": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId"
	        ],
	        "members": {
	          "ResourceId": {},
	          "Metadata": {
	            "shape": "S4y"
	          },
	          "Tags": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OpsMetadataArn": {}
	        }
	      }
	    },
	    "CreatePatchBaseline": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "OperatingSystem": {},
	          "Name": {},
	          "GlobalFilters": {
	            "shape": "S57"
	          },
	          "ApprovalRules": {
	            "shape": "S5d"
	          },
	          "ApprovedPatches": {
	            "shape": "S5k"
	          },
	          "ApprovedPatchesComplianceLevel": {},
	          "ApprovedPatchesEnableNonSecurity": {
	            "type": "boolean"
	          },
	          "RejectedPatches": {
	            "shape": "S5k"
	          },
	          "RejectedPatchesAction": {},
	          "Description": {},
	          "Sources": {
	            "shape": "S5o"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "Tags": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BaselineId": {}
	        }
	      }
	    },
	    "CreateResourceDataSync": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SyncName"
	        ],
	        "members": {
	          "SyncName": {},
	          "S3Destination": {
	            "shape": "S5y"
	          },
	          "SyncType": {},
	          "SyncSource": {
	            "shape": "S67"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteActivation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ActivationId"
	        ],
	        "members": {
	          "ActivationId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteAssociation": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "InstanceId": {},
	          "AssociationId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteDocument": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "DocumentVersion": {},
	          "VersionName": {},
	          "Force": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteInventory": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TypeName"
	        ],
	        "members": {
	          "TypeName": {},
	          "SchemaDeleteOption": {},
	          "DryRun": {
	            "type": "boolean"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeletionId": {},
	          "TypeName": {},
	          "DeletionSummary": {
	            "shape": "S6v"
	          }
	        }
	      }
	    },
	    "DeleteMaintenanceWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId"
	        ],
	        "members": {
	          "WindowId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowId": {}
	        }
	      }
	    },
	    "DeleteOpsMetadata": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpsMetadataArn"
	        ],
	        "members": {
	          "OpsMetadataArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteParameter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Names"
	        ],
	        "members": {
	          "Names": {
	            "shape": "S7a"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DeletedParameters": {
	            "shape": "S7a"
	          },
	          "InvalidParameters": {
	            "shape": "S7a"
	          }
	        }
	      }
	    },
	    "DeletePatchBaseline": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BaselineId"
	        ],
	        "members": {
	          "BaselineId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BaselineId": {}
	        }
	      }
	    },
	    "DeleteResourceDataSync": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SyncName"
	        ],
	        "members": {
	          "SyncName": {},
	          "SyncType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeregisterManagedInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeregisterPatchBaselineForPatchGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BaselineId",
	          "PatchGroup"
	        ],
	        "members": {
	          "BaselineId": {},
	          "PatchGroup": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BaselineId": {},
	          "PatchGroup": {}
	        }
	      }
	    },
	    "DeregisterTargetFromMaintenanceWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId",
	          "WindowTargetId"
	        ],
	        "members": {
	          "WindowId": {},
	          "WindowTargetId": {},
	          "Safe": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowId": {},
	          "WindowTargetId": {}
	        }
	      }
	    },
	    "DeregisterTaskFromMaintenanceWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId",
	          "WindowTaskId"
	        ],
	        "members": {
	          "WindowId": {},
	          "WindowTaskId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowId": {},
	          "WindowTaskId": {}
	        }
	      }
	    },
	    "DescribeActivations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FilterKey": {},
	                "FilterValues": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ActivationList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ActivationId": {},
	                "Description": {},
	                "DefaultInstanceName": {},
	                "IamRole": {},
	                "RegistrationLimit": {
	                  "type": "integer"
	                },
	                "RegistrationsCount": {
	                  "type": "integer"
	                },
	                "ExpirationDate": {
	                  "type": "timestamp"
	                },
	                "Expired": {
	                  "type": "boolean"
	                },
	                "CreatedDate": {
	                  "type": "timestamp"
	                },
	                "Tags": {
	                  "shape": "S4"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAssociation": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "InstanceId": {},
	          "AssociationId": {},
	          "AssociationVersion": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationDescription": {
	            "shape": "S26"
	          }
	        }
	      }
	    },
	    "DescribeAssociationExecutionTargets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationId",
	          "ExecutionId"
	        ],
	        "members": {
	          "AssociationId": {},
	          "ExecutionId": {},
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Value"
	              ],
	              "members": {
	                "Key": {},
	                "Value": {}
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationExecutionTargets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AssociationId": {},
	                "AssociationVersion": {},
	                "ExecutionId": {},
	                "ResourceId": {},
	                "ResourceType": {},
	                "Status": {},
	                "DetailedStatus": {},
	                "LastExecutionDate": {
	                  "type": "timestamp"
	                },
	                "OutputSource": {
	                  "type": "structure",
	                  "members": {
	                    "OutputSourceId": {},
	                    "OutputSourceType": {}
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAssociationExecutions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationId"
	        ],
	        "members": {
	          "AssociationId": {},
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Value",
	                "Type"
	              ],
	              "members": {
	                "Key": {},
	                "Value": {},
	                "Type": {}
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationExecutions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AssociationId": {},
	                "AssociationVersion": {},
	                "ExecutionId": {},
	                "Status": {},
	                "DetailedStatus": {},
	                "CreatedTime": {
	                  "type": "timestamp"
	                },
	                "LastExecutionDate": {
	                  "type": "timestamp"
	                },
	                "ResourceCountByStatus": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAutomationExecutions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Values"
	              ],
	              "members": {
	                "Key": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AutomationExecutionMetadataList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AutomationExecutionId": {},
	                "DocumentName": {},
	                "DocumentVersion": {},
	                "AutomationExecutionStatus": {},
	                "ExecutionStartTime": {
	                  "type": "timestamp"
	                },
	                "ExecutionEndTime": {
	                  "type": "timestamp"
	                },
	                "ExecutedBy": {},
	                "LogFile": {},
	                "Outputs": {
	                  "shape": "S95"
	                },
	                "Mode": {},
	                "ParentAutomationExecutionId": {},
	                "CurrentStepName": {},
	                "CurrentAction": {},
	                "FailureMessage": {},
	                "TargetParameterName": {},
	                "Targets": {
	                  "shape": "S18"
	                },
	                "TargetMaps": {
	                  "shape": "S20"
	                },
	                "ResolvedTargets": {
	                  "shape": "S9a"
	                },
	                "MaxConcurrency": {},
	                "MaxErrors": {},
	                "Target": {},
	                "AutomationType": {},
	                "AutomationSubtype": {},
	                "ScheduledTime": {
	                  "type": "timestamp"
	                },
	                "Runbooks": {
	                  "shape": "S9e"
	                },
	                "OpsItemId": {},
	                "AssociationId": {},
	                "ChangeRequestName": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAutomationStepExecutions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutomationExecutionId"
	        ],
	        "members": {
	          "AutomationExecutionId": {},
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Values"
	              ],
	              "members": {
	                "Key": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "ReverseOrder": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StepExecutions": {
	            "shape": "S9o"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeAvailablePatches": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "S9y"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Patches": {
	            "type": "list",
	            "member": {
	              "shape": "Sa6"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeDocument": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "DocumentVersion": {},
	          "VersionName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Document": {
	            "shape": "S38"
	          }
	        }
	      }
	    },
	    "DescribeDocumentPermission": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "PermissionType"
	        ],
	        "members": {
	          "Name": {},
	          "PermissionType": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AccountIds": {
	            "shape": "Sb1"
	          },
	          "AccountSharingInfoList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AccountId": {},
	                "SharedDocumentVersion": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeEffectiveInstanceAssociations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Associations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AssociationId": {},
	                "InstanceId": {},
	                "Content": {},
	                "AssociationVersion": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeEffectivePatchesForPatchBaseline": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BaselineId"
	        ],
	        "members": {
	          "BaselineId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EffectivePatches": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Patch": {
	                  "shape": "Sa6"
	                },
	                "PatchStatus": {
	                  "type": "structure",
	                  "members": {
	                    "DeploymentStatus": {},
	                    "ComplianceLevel": {},
	                    "ApprovalDate": {
	                      "type": "timestamp"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeInstanceAssociationsStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceAssociationStatusInfos": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AssociationId": {},
	                "Name": {},
	                "DocumentVersion": {},
	                "AssociationVersion": {},
	                "InstanceId": {},
	                "ExecutionDate": {
	                  "type": "timestamp"
	                },
	                "Status": {},
	                "DetailedStatus": {},
	                "ExecutionSummary": {},
	                "ErrorCode": {},
	                "OutputUrl": {
	                  "type": "structure",
	                  "members": {
	                    "S3OutputUrl": {
	                      "type": "structure",
	                      "members": {
	                        "OutputUrl": {}
	                      }
	                    }
	                  }
	                },
	                "AssociationName": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeInstanceInformation": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "InstanceInformationFilterList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "key",
	                "valueSet"
	              ],
	              "members": {
	                "key": {},
	                "valueSet": {
	                  "shape": "Sbu"
	                }
	              }
	            }
	          },
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Values"
	              ],
	              "members": {
	                "Key": {},
	                "Values": {
	                  "shape": "Sbu"
	                }
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceInformationList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "InstanceId": {},
	                "PingStatus": {},
	                "LastPingDateTime": {
	                  "type": "timestamp"
	                },
	                "AgentVersion": {},
	                "IsLatestVersion": {
	                  "type": "boolean"
	                },
	                "PlatformType": {},
	                "PlatformName": {},
	                "PlatformVersion": {},
	                "ActivationId": {},
	                "IamRole": {},
	                "RegistrationDate": {
	                  "type": "timestamp"
	                },
	                "ResourceType": {},
	                "Name": {},
	                "IPAddress": {},
	                "ComputerName": {},
	                "AssociationStatus": {},
	                "LastAssociationExecutionDate": {
	                  "type": "timestamp"
	                },
	                "LastSuccessfulAssociationExecutionDate": {
	                  "type": "timestamp"
	                },
	                "AssociationOverview": {
	                  "type": "structure",
	                  "members": {
	                    "DetailedStatus": {},
	                    "InstanceAssociationStatusAggregatedCount": {
	                      "type": "map",
	                      "key": {},
	                      "value": {
	                        "type": "integer"
	                      }
	                    }
	                  }
	                },
	                "SourceId": {},
	                "SourceType": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeInstancePatchStates": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceIds"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "Si"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstancePatchStates": {
	            "type": "list",
	            "member": {
	              "shape": "Scg"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeInstancePatchStatesForPatchGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PatchGroup"
	        ],
	        "members": {
	          "PatchGroup": {},
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Values",
	                "Type"
	              ],
	              "members": {
	                "Key": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                },
	                "Type": {}
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstancePatchStates": {
	            "type": "list",
	            "member": {
	              "shape": "Scg"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeInstancePatches": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "Filters": {
	            "shape": "S9y"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Patches": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Title",
	                "KBId",
	                "Classification",
	                "Severity",
	                "State",
	                "InstalledTime"
	              ],
	              "members": {
	                "Title": {},
	                "KBId": {},
	                "Classification": {},
	                "Severity": {},
	                "State": {},
	                "InstalledTime": {
	                  "type": "timestamp"
	                },
	                "CVEIds": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeInventoryDeletions": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DeletionId": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InventoryDeletions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DeletionId": {},
	                "TypeName": {},
	                "DeletionStartTime": {
	                  "type": "timestamp"
	                },
	                "LastStatus": {},
	                "LastStatusMessage": {},
	                "DeletionSummary": {
	                  "shape": "S6v"
	                },
	                "LastStatusUpdateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMaintenanceWindowExecutionTaskInvocations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowExecutionId",
	          "TaskId"
	        ],
	        "members": {
	          "WindowExecutionId": {},
	          "TaskId": {},
	          "Filters": {
	            "shape": "Sdm"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowExecutionTaskInvocationIdentities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "WindowExecutionId": {},
	                "TaskExecutionId": {},
	                "InvocationId": {},
	                "ExecutionId": {},
	                "TaskType": {},
	                "Parameters": {
	                  "shape": "Sdy"
	                },
	                "Status": {},
	                "StatusDetails": {},
	                "StartTime": {
	                  "type": "timestamp"
	                },
	                "EndTime": {
	                  "type": "timestamp"
	                },
	                "OwnerInformation": {
	                  "shape": "Scj"
	                },
	                "WindowTargetId": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMaintenanceWindowExecutionTasks": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowExecutionId"
	        ],
	        "members": {
	          "WindowExecutionId": {},
	          "Filters": {
	            "shape": "Sdm"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowExecutionTaskIdentities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "WindowExecutionId": {},
	                "TaskExecutionId": {},
	                "Status": {},
	                "StatusDetails": {},
	                "StartTime": {
	                  "type": "timestamp"
	                },
	                "EndTime": {
	                  "type": "timestamp"
	                },
	                "TaskArn": {},
	                "TaskType": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMaintenanceWindowExecutions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId"
	        ],
	        "members": {
	          "WindowId": {},
	          "Filters": {
	            "shape": "Sdm"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowExecutions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "WindowId": {},
	                "WindowExecutionId": {},
	                "Status": {},
	                "StatusDetails": {},
	                "StartTime": {
	                  "type": "timestamp"
	                },
	                "EndTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMaintenanceWindowSchedule": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "WindowId": {},
	          "Targets": {
	            "shape": "S18"
	          },
	          "ResourceType": {},
	          "Filters": {
	            "shape": "S9y"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ScheduledWindowExecutions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "WindowId": {},
	                "Name": {},
	                "ExecutionTime": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMaintenanceWindowTargets": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId"
	        ],
	        "members": {
	          "WindowId": {},
	          "Filters": {
	            "shape": "Sdm"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Targets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "WindowId": {},
	                "WindowTargetId": {},
	                "ResourceType": {},
	                "Targets": {
	                  "shape": "S18"
	                },
	                "OwnerInformation": {
	                  "shape": "Scj"
	                },
	                "Name": {},
	                "Description": {
	                  "shape": "S42"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMaintenanceWindowTasks": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId"
	        ],
	        "members": {
	          "WindowId": {},
	          "Filters": {
	            "shape": "Sdm"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tasks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "WindowId": {},
	                "WindowTaskId": {},
	                "TaskArn": {},
	                "Type": {},
	                "Targets": {
	                  "shape": "S18"
	                },
	                "TaskParameters": {
	                  "shape": "Sep"
	                },
	                "Priority": {
	                  "type": "integer"
	                },
	                "LoggingInfo": {
	                  "shape": "Sev"
	                },
	                "ServiceRoleArn": {},
	                "MaxConcurrency": {},
	                "MaxErrors": {},
	                "Name": {},
	                "Description": {
	                  "shape": "S42"
	                },
	                "CutoffBehavior": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMaintenanceWindows": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sdm"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowIdentities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "WindowId": {},
	                "Name": {},
	                "Description": {
	                  "shape": "S42"
	                },
	                "Enabled": {
	                  "type": "boolean"
	                },
	                "Duration": {
	                  "type": "integer"
	                },
	                "Cutoff": {
	                  "type": "integer"
	                },
	                "Schedule": {},
	                "ScheduleTimezone": {},
	                "ScheduleOffset": {
	                  "type": "integer"
	                },
	                "EndDate": {},
	                "StartDate": {},
	                "NextExecutionTime": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeMaintenanceWindowsForTarget": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Targets",
	          "ResourceType"
	        ],
	        "members": {
	          "Targets": {
	            "shape": "S18"
	          },
	          "ResourceType": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowIdentities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "WindowId": {},
	                "Name": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeOpsItems": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OpsItemFilters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Values",
	                "Operator"
	              ],
	              "members": {
	                "Key": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                },
	                "Operator": {}
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "OpsItemSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "CreatedBy": {},
	                "CreatedTime": {
	                  "type": "timestamp"
	                },
	                "LastModifiedBy": {},
	                "LastModifiedTime": {
	                  "type": "timestamp"
	                },
	                "Priority": {
	                  "type": "integer"
	                },
	                "Source": {},
	                "Status": {},
	                "OpsItemId": {},
	                "Title": {},
	                "OperationalData": {
	                  "shape": "S4g"
	                },
	                "Category": {},
	                "Severity": {},
	                "OpsItemType": {},
	                "ActualStartTime": {
	                  "type": "timestamp"
	                },
	                "ActualEndTime": {
	                  "type": "timestamp"
	                },
	                "PlannedStartTime": {
	                  "type": "timestamp"
	                },
	                "PlannedEndTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeParameters": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Values"
	              ],
	              "members": {
	                "Key": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "ParameterFilters": {
	            "shape": "Sfp"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Type": {},
	                "KeyId": {},
	                "LastModifiedDate": {
	                  "type": "timestamp"
	                },
	                "LastModifiedUser": {},
	                "Description": {},
	                "AllowedPattern": {},
	                "Version": {
	                  "type": "long"
	                },
	                "Tier": {},
	                "Policies": {
	                  "shape": "Sg4"
	                },
	                "DataType": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribePatchBaselines": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "S9y"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BaselineIdentities": {
	            "type": "list",
	            "member": {
	              "shape": "Sga"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribePatchGroupState": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PatchGroup"
	        ],
	        "members": {
	          "PatchGroup": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Instances": {
	            "type": "integer"
	          },
	          "InstancesWithInstalledPatches": {
	            "type": "integer"
	          },
	          "InstancesWithInstalledOtherPatches": {
	            "type": "integer"
	          },
	          "InstancesWithInstalledPendingRebootPatches": {
	            "type": "integer"
	          },
	          "InstancesWithInstalledRejectedPatches": {
	            "type": "integer"
	          },
	          "InstancesWithMissingPatches": {
	            "type": "integer"
	          },
	          "InstancesWithFailedPatches": {
	            "type": "integer"
	          },
	          "InstancesWithNotApplicablePatches": {
	            "type": "integer"
	          },
	          "InstancesWithUnreportedNotApplicablePatches": {
	            "type": "integer"
	          },
	          "InstancesWithCriticalNonCompliantPatches": {
	            "type": "integer"
	          },
	          "InstancesWithSecurityNonCompliantPatches": {
	            "type": "integer"
	          },
	          "InstancesWithOtherNonCompliantPatches": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "DescribePatchGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Filters": {
	            "shape": "S9y"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Mappings": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PatchGroup": {},
	                "BaselineIdentity": {
	                  "shape": "Sga"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribePatchProperties": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OperatingSystem",
	          "Property"
	        ],
	        "members": {
	          "OperatingSystem": {},
	          "Property": {},
	          "PatchSet": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Properties": {
	            "type": "list",
	            "member": {
	              "type": "map",
	              "key": {},
	              "value": {}
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DescribeSessions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "State"
	        ],
	        "members": {
	          "State": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "key",
	                "value"
	              ],
	              "members": {
	                "key": {},
	                "value": {}
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Sessions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "SessionId": {},
	                "Target": {},
	                "Status": {},
	                "StartDate": {
	                  "type": "timestamp"
	                },
	                "EndDate": {
	                  "type": "timestamp"
	                },
	                "DocumentName": {},
	                "Owner": {},
	                "Reason": {},
	                "Details": {},
	                "OutputUrl": {
	                  "type": "structure",
	                  "members": {
	                    "S3OutputUrl": {},
	                    "CloudWatchOutputUrl": {}
	                  }
	                },
	                "MaxSessionDuration": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "DisassociateOpsItemRelatedItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpsItemId",
	          "AssociationId"
	        ],
	        "members": {
	          "OpsItemId": {},
	          "AssociationId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "GetAutomationExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutomationExecutionId"
	        ],
	        "members": {
	          "AutomationExecutionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AutomationExecution": {
	            "type": "structure",
	            "members": {
	              "AutomationExecutionId": {},
	              "DocumentName": {},
	              "DocumentVersion": {},
	              "ExecutionStartTime": {
	                "type": "timestamp"
	              },
	              "ExecutionEndTime": {
	                "type": "timestamp"
	              },
	              "AutomationExecutionStatus": {},
	              "StepExecutions": {
	                "shape": "S9o"
	              },
	              "StepExecutionsTruncated": {
	                "type": "boolean"
	              },
	              "Parameters": {
	                "shape": "S95"
	              },
	              "Outputs": {
	                "shape": "S95"
	              },
	              "FailureMessage": {},
	              "Mode": {},
	              "ParentAutomationExecutionId": {},
	              "ExecutedBy": {},
	              "CurrentStepName": {},
	              "CurrentAction": {},
	              "TargetParameterName": {},
	              "Targets": {
	                "shape": "S18"
	              },
	              "TargetMaps": {
	                "shape": "S20"
	              },
	              "ResolvedTargets": {
	                "shape": "S9a"
	              },
	              "MaxConcurrency": {},
	              "MaxErrors": {},
	              "Target": {},
	              "TargetLocations": {
	                "shape": "S1s"
	              },
	              "ProgressCounters": {
	                "type": "structure",
	                "members": {
	                  "TotalSteps": {
	                    "type": "integer"
	                  },
	                  "SuccessSteps": {
	                    "type": "integer"
	                  },
	                  "FailedSteps": {
	                    "type": "integer"
	                  },
	                  "CancelledSteps": {
	                    "type": "integer"
	                  },
	                  "TimedOutSteps": {
	                    "type": "integer"
	                  }
	                }
	              },
	              "AutomationSubtype": {},
	              "ScheduledTime": {
	                "type": "timestamp"
	              },
	              "Runbooks": {
	                "shape": "S9e"
	              },
	              "OpsItemId": {},
	              "AssociationId": {},
	              "ChangeRequestName": {}
	            }
	          }
	        }
	      }
	    },
	    "GetCalendarState": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CalendarNames"
	        ],
	        "members": {
	          "CalendarNames": {
	            "shape": "S1q"
	          },
	          "AtTime": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "State": {},
	          "AtTime": {},
	          "NextTransitionTime": {}
	        }
	      }
	    },
	    "GetCommandInvocation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "CommandId",
	          "InstanceId"
	        ],
	        "members": {
	          "CommandId": {},
	          "InstanceId": {},
	          "PluginName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CommandId": {},
	          "InstanceId": {},
	          "Comment": {},
	          "DocumentName": {},
	          "DocumentVersion": {},
	          "PluginName": {},
	          "ResponseCode": {
	            "type": "integer"
	          },
	          "ExecutionStartDateTime": {},
	          "ExecutionElapsedTime": {},
	          "ExecutionEndDateTime": {},
	          "Status": {},
	          "StatusDetails": {},
	          "StandardOutputContent": {},
	          "StandardOutputUrl": {},
	          "StandardErrorContent": {},
	          "StandardErrorUrl": {},
	          "CloudWatchOutputConfig": {
	            "shape": "Shv"
	          }
	        }
	      }
	    },
	    "GetConnectionStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Target"
	        ],
	        "members": {
	          "Target": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Target": {},
	          "Status": {}
	        }
	      }
	    },
	    "GetDefaultPatchBaseline": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OperatingSystem": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BaselineId": {},
	          "OperatingSystem": {}
	        }
	      }
	    },
	    "GetDeployablePatchSnapshotForInstance": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "SnapshotId"
	        ],
	        "members": {
	          "InstanceId": {},
	          "SnapshotId": {},
	          "BaselineOverride": {
	            "type": "structure",
	            "members": {
	              "OperatingSystem": {},
	              "GlobalFilters": {
	                "shape": "S57"
	              },
	              "ApprovalRules": {
	                "shape": "S5d"
	              },
	              "ApprovedPatches": {
	                "shape": "S5k"
	              },
	              "ApprovedPatchesComplianceLevel": {},
	              "RejectedPatches": {
	                "shape": "S5k"
	              },
	              "RejectedPatchesAction": {},
	              "ApprovedPatchesEnableNonSecurity": {
	                "type": "boolean"
	              },
	              "Sources": {
	                "shape": "S5o"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InstanceId": {},
	          "SnapshotId": {},
	          "SnapshotDownloadUrl": {},
	          "Product": {}
	        }
	      }
	    },
	    "GetDocument": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "VersionName": {},
	          "DocumentVersion": {},
	          "DocumentFormat": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "CreatedDate": {
	            "type": "timestamp"
	          },
	          "DisplayName": {},
	          "VersionName": {},
	          "DocumentVersion": {},
	          "Status": {},
	          "StatusInformation": {},
	          "Content": {},
	          "DocumentType": {},
	          "DocumentFormat": {},
	          "Requires": {
	            "shape": "S2t"
	          },
	          "AttachmentsContent": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Size": {
	                  "type": "long"
	                },
	                "Hash": {},
	                "HashType": {},
	                "Url": {}
	              }
	            }
	          },
	          "ReviewStatus": {}
	        }
	      }
	    },
	    "GetInventory": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sih"
	          },
	          "Aggregators": {
	            "shape": "Sin"
	          },
	          "ResultAttributes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "TypeName"
	              ],
	              "members": {
	                "TypeName": {}
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Entities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Data": {
	                  "type": "map",
	                  "key": {},
	                  "value": {
	                    "type": "structure",
	                    "required": [
	                      "TypeName",
	                      "SchemaVersion",
	                      "Content"
	                    ],
	                    "members": {
	                      "TypeName": {},
	                      "SchemaVersion": {},
	                      "CaptureTime": {},
	                      "ContentHash": {},
	                      "Content": {
	                        "shape": "Sj4"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetInventorySchema": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TypeName": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "Aggregator": {
	            "type": "boolean"
	          },
	          "SubType": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Schemas": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "TypeName",
	                "Attributes"
	              ],
	              "members": {
	                "TypeName": {},
	                "Version": {},
	                "Attributes": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "required": [
	                      "Name",
	                      "DataType"
	                    ],
	                    "members": {
	                      "Name": {},
	                      "DataType": {}
	                    }
	                  }
	                },
	                "DisplayName": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetMaintenanceWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId"
	        ],
	        "members": {
	          "WindowId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowId": {},
	          "Name": {},
	          "Description": {
	            "shape": "S42"
	          },
	          "StartDate": {},
	          "EndDate": {},
	          "Schedule": {},
	          "ScheduleTimezone": {},
	          "ScheduleOffset": {
	            "type": "integer"
	          },
	          "NextExecutionTime": {},
	          "Duration": {
	            "type": "integer"
	          },
	          "Cutoff": {
	            "type": "integer"
	          },
	          "AllowUnassociatedTargets": {
	            "type": "boolean"
	          },
	          "Enabled": {
	            "type": "boolean"
	          },
	          "CreatedDate": {
	            "type": "timestamp"
	          },
	          "ModifiedDate": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetMaintenanceWindowExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowExecutionId"
	        ],
	        "members": {
	          "WindowExecutionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowExecutionId": {},
	          "TaskIds": {
	            "type": "list",
	            "member": {}
	          },
	          "Status": {},
	          "StatusDetails": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetMaintenanceWindowExecutionTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowExecutionId",
	          "TaskId"
	        ],
	        "members": {
	          "WindowExecutionId": {},
	          "TaskId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowExecutionId": {},
	          "TaskExecutionId": {},
	          "TaskArn": {},
	          "ServiceRole": {},
	          "Type": {},
	          "TaskParameters": {
	            "type": "list",
	            "member": {
	              "shape": "Sep"
	            },
	            "sensitive": true
	          },
	          "Priority": {
	            "type": "integer"
	          },
	          "MaxConcurrency": {},
	          "MaxErrors": {},
	          "Status": {},
	          "StatusDetails": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "GetMaintenanceWindowExecutionTaskInvocation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowExecutionId",
	          "TaskId",
	          "InvocationId"
	        ],
	        "members": {
	          "WindowExecutionId": {},
	          "TaskId": {},
	          "InvocationId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowExecutionId": {},
	          "TaskExecutionId": {},
	          "InvocationId": {},
	          "ExecutionId": {},
	          "TaskType": {},
	          "Parameters": {
	            "shape": "Sdy"
	          },
	          "Status": {},
	          "StatusDetails": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "OwnerInformation": {
	            "shape": "Scj"
	          },
	          "WindowTargetId": {}
	        }
	      }
	    },
	    "GetMaintenanceWindowTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId",
	          "WindowTaskId"
	        ],
	        "members": {
	          "WindowId": {},
	          "WindowTaskId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowId": {},
	          "WindowTaskId": {},
	          "Targets": {
	            "shape": "S18"
	          },
	          "TaskArn": {},
	          "ServiceRoleArn": {},
	          "TaskType": {},
	          "TaskParameters": {
	            "shape": "Sep"
	          },
	          "TaskInvocationParameters": {
	            "shape": "Sjv"
	          },
	          "Priority": {
	            "type": "integer"
	          },
	          "MaxConcurrency": {},
	          "MaxErrors": {},
	          "LoggingInfo": {
	            "shape": "Sev"
	          },
	          "Name": {},
	          "Description": {
	            "shape": "S42"
	          },
	          "CutoffBehavior": {}
	        }
	      }
	    },
	    "GetOpsItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpsItemId"
	        ],
	        "members": {
	          "OpsItemId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OpsItem": {
	            "type": "structure",
	            "members": {
	              "CreatedBy": {},
	              "OpsItemType": {},
	              "CreatedTime": {
	                "type": "timestamp"
	              },
	              "Description": {},
	              "LastModifiedBy": {},
	              "LastModifiedTime": {
	                "type": "timestamp"
	              },
	              "Notifications": {
	                "shape": "S4l"
	              },
	              "Priority": {
	                "type": "integer"
	              },
	              "RelatedOpsItems": {
	                "shape": "S4p"
	              },
	              "Status": {},
	              "OpsItemId": {},
	              "Version": {},
	              "Title": {},
	              "Source": {},
	              "OperationalData": {
	                "shape": "S4g"
	              },
	              "Category": {},
	              "Severity": {},
	              "ActualStartTime": {
	                "type": "timestamp"
	              },
	              "ActualEndTime": {
	                "type": "timestamp"
	              },
	              "PlannedStartTime": {
	                "type": "timestamp"
	              },
	              "PlannedEndTime": {
	                "type": "timestamp"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetOpsMetadata": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpsMetadataArn"
	        ],
	        "members": {
	          "OpsMetadataArn": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceId": {},
	          "Metadata": {
	            "shape": "S4y"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetOpsSummary": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SyncName": {},
	          "Filters": {
	            "shape": "Ski"
	          },
	          "Aggregators": {
	            "shape": "Sko"
	          },
	          "ResultAttributes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "TypeName"
	              ],
	              "members": {
	                "TypeName": {}
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Entities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Data": {
	                  "type": "map",
	                  "key": {},
	                  "value": {
	                    "type": "structure",
	                    "members": {
	                      "CaptureTime": {},
	                      "Content": {
	                        "type": "list",
	                        "member": {
	                          "type": "map",
	                          "key": {},
	                          "value": {}
	                        }
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetParameter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "WithDecryption": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Parameter": {
	            "shape": "Sla"
	          }
	        }
	      }
	    },
	    "GetParameterHistory": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "WithDecryption": {
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Type": {},
	                "KeyId": {},
	                "LastModifiedDate": {
	                  "type": "timestamp"
	                },
	                "LastModifiedUser": {},
	                "Description": {},
	                "Value": {
	                  "shape": "Slb"
	                },
	                "AllowedPattern": {},
	                "Version": {
	                  "type": "long"
	                },
	                "Labels": {
	                  "shape": "Slh"
	                },
	                "Tier": {},
	                "Policies": {
	                  "shape": "Sg4"
	                },
	                "DataType": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetParameters": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Names"
	        ],
	        "members": {
	          "Names": {
	            "shape": "S7a"
	          },
	          "WithDecryption": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "shape": "Sll"
	          },
	          "InvalidParameters": {
	            "shape": "S7a"
	          }
	        }
	      }
	    },
	    "GetParametersByPath": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Path"
	        ],
	        "members": {
	          "Path": {},
	          "Recursive": {
	            "type": "boolean"
	          },
	          "ParameterFilters": {
	            "shape": "Sfp"
	          },
	          "WithDecryption": {
	            "type": "boolean"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Parameters": {
	            "shape": "Sll"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetPatchBaseline": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BaselineId"
	        ],
	        "members": {
	          "BaselineId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BaselineId": {},
	          "Name": {},
	          "OperatingSystem": {},
	          "GlobalFilters": {
	            "shape": "S57"
	          },
	          "ApprovalRules": {
	            "shape": "S5d"
	          },
	          "ApprovedPatches": {
	            "shape": "S5k"
	          },
	          "ApprovedPatchesComplianceLevel": {},
	          "ApprovedPatchesEnableNonSecurity": {
	            "type": "boolean"
	          },
	          "RejectedPatches": {
	            "shape": "S5k"
	          },
	          "RejectedPatchesAction": {},
	          "PatchGroups": {
	            "type": "list",
	            "member": {}
	          },
	          "CreatedDate": {
	            "type": "timestamp"
	          },
	          "ModifiedDate": {
	            "type": "timestamp"
	          },
	          "Description": {},
	          "Sources": {
	            "shape": "S5o"
	          }
	        }
	      }
	    },
	    "GetPatchBaselineForPatchGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PatchGroup"
	        ],
	        "members": {
	          "PatchGroup": {},
	          "OperatingSystem": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BaselineId": {},
	          "PatchGroup": {},
	          "OperatingSystem": {}
	        }
	      }
	    },
	    "GetServiceSetting": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SettingId"
	        ],
	        "members": {
	          "SettingId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceSetting": {
	            "shape": "Slx"
	          }
	        }
	      }
	    },
	    "LabelParameterVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Labels"
	        ],
	        "members": {
	          "Name": {},
	          "ParameterVersion": {
	            "type": "long"
	          },
	          "Labels": {
	            "shape": "Slh"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InvalidLabels": {
	            "shape": "Slh"
	          },
	          "ParameterVersion": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "ListAssociationVersions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationId"
	        ],
	        "members": {
	          "AssociationId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationVersions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AssociationId": {},
	                "AssociationVersion": {},
	                "CreatedDate": {
	                  "type": "timestamp"
	                },
	                "Name": {},
	                "DocumentVersion": {},
	                "Parameters": {
	                  "shape": "S14"
	                },
	                "Targets": {
	                  "shape": "S18"
	                },
	                "ScheduleExpression": {},
	                "OutputLocation": {
	                  "shape": "S1e"
	                },
	                "AssociationName": {},
	                "MaxErrors": {},
	                "MaxConcurrency": {},
	                "ComplianceSeverity": {},
	                "SyncCompliance": {},
	                "ApplyOnlyAtCronInterval": {
	                  "type": "boolean"
	                },
	                "CalendarNames": {
	                  "shape": "S1q"
	                },
	                "TargetLocations": {
	                  "shape": "S1s"
	                },
	                "ScheduleOffset": {
	                  "type": "integer"
	                },
	                "TargetMaps": {
	                  "shape": "S20"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListAssociations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "AssociationFilterList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "key",
	                "value"
	              ],
	              "members": {
	                "key": {},
	                "value": {}
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Associations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "InstanceId": {},
	                "AssociationId": {},
	                "AssociationVersion": {},
	                "DocumentVersion": {},
	                "Targets": {
	                  "shape": "S18"
	                },
	                "LastExecutionDate": {
	                  "type": "timestamp"
	                },
	                "Overview": {
	                  "shape": "S2d"
	                },
	                "ScheduleExpression": {},
	                "AssociationName": {},
	                "ScheduleOffset": {
	                  "type": "integer"
	                },
	                "TargetMaps": {
	                  "shape": "S20"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListCommandInvocations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CommandId": {},
	          "InstanceId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "Filters": {
	            "shape": "Smf"
	          },
	          "Details": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CommandInvocations": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "CommandId": {},
	                "InstanceId": {},
	                "InstanceName": {},
	                "Comment": {},
	                "DocumentName": {},
	                "DocumentVersion": {},
	                "RequestedDateTime": {
	                  "type": "timestamp"
	                },
	                "Status": {},
	                "StatusDetails": {},
	                "TraceOutput": {},
	                "StandardOutputUrl": {},
	                "StandardErrorUrl": {},
	                "CommandPlugins": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Name": {},
	                      "Status": {},
	                      "StatusDetails": {},
	                      "ResponseCode": {
	                        "type": "integer"
	                      },
	                      "ResponseStartDateTime": {
	                        "type": "timestamp"
	                      },
	                      "ResponseFinishDateTime": {
	                        "type": "timestamp"
	                      },
	                      "Output": {},
	                      "StandardOutputUrl": {},
	                      "StandardErrorUrl": {},
	                      "OutputS3Region": {},
	                      "OutputS3BucketName": {},
	                      "OutputS3KeyPrefix": {}
	                    }
	                  }
	                },
	                "ServiceRole": {},
	                "NotificationConfig": {
	                  "shape": "Sjx"
	                },
	                "CloudWatchOutputConfig": {
	                  "shape": "Shv"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListCommands": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "CommandId": {},
	          "InstanceId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {},
	          "Filters": {
	            "shape": "Smf"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Commands": {
	            "type": "list",
	            "member": {
	              "shape": "Smv"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListComplianceItems": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sn2"
	          },
	          "ResourceIds": {
	            "type": "list",
	            "member": {}
	          },
	          "ResourceTypes": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComplianceItems": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ComplianceType": {},
	                "ResourceType": {},
	                "ResourceId": {},
	                "Id": {},
	                "Title": {},
	                "Status": {},
	                "Severity": {},
	                "ExecutionSummary": {
	                  "shape": "Snk"
	                },
	                "Details": {
	                  "shape": "Snn"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListComplianceSummaries": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sn2"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ComplianceSummaryItems": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ComplianceType": {},
	                "CompliantSummary": {
	                  "shape": "Sns"
	                },
	                "NonCompliantSummary": {
	                  "shape": "Snv"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListDocumentMetadataHistory": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Metadata"
	        ],
	        "members": {
	          "Name": {},
	          "DocumentVersion": {},
	          "Metadata": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "DocumentVersion": {},
	          "Author": {},
	          "Metadata": {
	            "type": "structure",
	            "members": {
	              "ReviewerResponse": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "CreateTime": {
	                      "type": "timestamp"
	                    },
	                    "UpdatedTime": {
	                      "type": "timestamp"
	                    },
	                    "ReviewStatus": {},
	                    "Comment": {
	                      "shape": "So2"
	                    },
	                    "Reviewer": {}
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListDocumentVersions": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DocumentVersions": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "DisplayName": {},
	                "DocumentVersion": {},
	                "VersionName": {},
	                "CreatedDate": {
	                  "type": "timestamp"
	                },
	                "IsDefaultVersion": {
	                  "type": "boolean"
	                },
	                "DocumentFormat": {},
	                "Status": {},
	                "StatusInformation": {},
	                "ReviewStatus": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListDocuments": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DocumentFilterList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "key",
	                "value"
	              ],
	              "members": {
	                "key": {},
	                "value": {}
	              }
	            }
	          },
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Key": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DocumentIdentifiers": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "CreatedDate": {
	                  "type": "timestamp"
	                },
	                "DisplayName": {},
	                "Owner": {},
	                "VersionName": {},
	                "PlatformTypes": {
	                  "shape": "S3m"
	                },
	                "DocumentVersion": {},
	                "DocumentType": {},
	                "SchemaVersion": {},
	                "DocumentFormat": {},
	                "TargetType": {},
	                "Tags": {
	                  "shape": "S4"
	                },
	                "Requires": {
	                  "shape": "S2t"
	                },
	                "ReviewStatus": {},
	                "Author": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListInventoryEntries": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "TypeName"
	        ],
	        "members": {
	          "InstanceId": {},
	          "TypeName": {},
	          "Filters": {
	            "shape": "Sih"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TypeName": {},
	          "InstanceId": {},
	          "SchemaVersion": {},
	          "CaptureTime": {},
	          "Entries": {
	            "shape": "Sj4"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListOpsItemEvents": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Values",
	                "Operator"
	              ],
	              "members": {
	                "Key": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                },
	                "Operator": {}
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "Summaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "OpsItemId": {},
	                "EventId": {},
	                "Source": {},
	                "DetailType": {},
	                "Detail": {},
	                "CreatedBy": {
	                  "shape": "Sp0"
	                },
	                "CreatedTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListOpsItemRelatedItems": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "OpsItemId": {},
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Values",
	                "Operator"
	              ],
	              "members": {
	                "Key": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                },
	                "Operator": {}
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "Summaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "OpsItemId": {},
	                "AssociationId": {},
	                "ResourceType": {},
	                "AssociationType": {},
	                "ResourceUri": {},
	                "CreatedBy": {
	                  "shape": "Sp0"
	                },
	                "CreatedTime": {
	                  "type": "timestamp"
	                },
	                "LastModifiedBy": {
	                  "shape": "Sp0"
	                },
	                "LastModifiedTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListOpsMetadata": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Key",
	                "Values"
	              ],
	              "members": {
	                "Key": {},
	                "Values": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OpsMetadataList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ResourceId": {},
	                "OpsMetadataArn": {},
	                "LastModifiedDate": {
	                  "type": "timestamp"
	                },
	                "LastModifiedUser": {},
	                "CreationDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListResourceComplianceSummaries": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filters": {
	            "shape": "Sn2"
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceComplianceSummaryItems": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ComplianceType": {},
	                "ResourceType": {},
	                "ResourceId": {},
	                "Status": {},
	                "OverallSeverity": {},
	                "ExecutionSummary": {
	                  "shape": "Snk"
	                },
	                "CompliantSummary": {
	                  "shape": "Sns"
	                },
	                "NonCompliantSummary": {
	                  "shape": "Snv"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListResourceDataSync": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "SyncType": {},
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceDataSyncItems": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "SyncName": {},
	                "SyncType": {},
	                "SyncSource": {
	                  "type": "structure",
	                  "members": {
	                    "SourceType": {},
	                    "AwsOrganizationsSource": {
	                      "shape": "S69"
	                    },
	                    "SourceRegions": {
	                      "shape": "S6e"
	                    },
	                    "IncludeFutureRegions": {
	                      "type": "boolean"
	                    },
	                    "State": {},
	                    "EnableAllOpsDataSources": {
	                      "type": "boolean"
	                    }
	                  }
	                },
	                "S3Destination": {
	                  "shape": "S5y"
	                },
	                "LastSyncTime": {
	                  "type": "timestamp"
	                },
	                "LastSuccessfulSyncTime": {
	                  "type": "timestamp"
	                },
	                "SyncLastModifiedTime": {
	                  "type": "timestamp"
	                },
	                "LastStatus": {},
	                "SyncCreatedTime": {
	                  "type": "timestamp"
	                },
	                "LastSyncStatusMessage": {}
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceType",
	          "ResourceId"
	        ],
	        "members": {
	          "ResourceType": {},
	          "ResourceId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TagList": {
	            "shape": "S4"
	          }
	        }
	      }
	    },
	    "ModifyDocumentPermission": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "PermissionType"
	        ],
	        "members": {
	          "Name": {},
	          "PermissionType": {},
	          "AccountIdsToAdd": {
	            "shape": "Sb1"
	          },
	          "AccountIdsToRemove": {
	            "shape": "Sb1"
	          },
	          "SharedDocumentVersion": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "PutComplianceItems": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "ResourceType",
	          "ComplianceType",
	          "ExecutionSummary",
	          "Items"
	        ],
	        "members": {
	          "ResourceId": {},
	          "ResourceType": {},
	          "ComplianceType": {},
	          "ExecutionSummary": {
	            "shape": "Snk"
	          },
	          "Items": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Severity",
	                "Status"
	              ],
	              "members": {
	                "Id": {},
	                "Title": {},
	                "Severity": {},
	                "Status": {},
	                "Details": {
	                  "shape": "Snn"
	                }
	              }
	            }
	          },
	          "ItemContentHash": {},
	          "UploadType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "PutInventory": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "Items"
	        ],
	        "members": {
	          "InstanceId": {},
	          "Items": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "TypeName",
	                "SchemaVersion",
	                "CaptureTime"
	              ],
	              "members": {
	                "TypeName": {},
	                "SchemaVersion": {},
	                "CaptureTime": {},
	                "ContentHash": {},
	                "Content": {
	                  "shape": "Sj4"
	                },
	                "Context": {
	                  "type": "map",
	                  "key": {},
	                  "value": {}
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Message": {}
	        }
	      }
	    },
	    "PutParameter": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Value"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "Value": {
	            "shape": "Slb"
	          },
	          "Type": {},
	          "KeyId": {},
	          "Overwrite": {
	            "type": "boolean"
	          },
	          "AllowedPattern": {},
	          "Tags": {
	            "shape": "S4"
	          },
	          "Tier": {},
	          "Policies": {},
	          "DataType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Version": {
	            "type": "long"
	          },
	          "Tier": {}
	        }
	      }
	    },
	    "RegisterDefaultPatchBaseline": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BaselineId"
	        ],
	        "members": {
	          "BaselineId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BaselineId": {}
	        }
	      }
	    },
	    "RegisterPatchBaselineForPatchGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BaselineId",
	          "PatchGroup"
	        ],
	        "members": {
	          "BaselineId": {},
	          "PatchGroup": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BaselineId": {},
	          "PatchGroup": {}
	        }
	      }
	    },
	    "RegisterTargetWithMaintenanceWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId",
	          "ResourceType",
	          "Targets"
	        ],
	        "members": {
	          "WindowId": {},
	          "ResourceType": {},
	          "Targets": {
	            "shape": "S18"
	          },
	          "OwnerInformation": {
	            "shape": "Scj"
	          },
	          "Name": {},
	          "Description": {
	            "shape": "S42"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowTargetId": {}
	        }
	      }
	    },
	    "RegisterTaskWithMaintenanceWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId",
	          "TaskArn",
	          "TaskType"
	        ],
	        "members": {
	          "WindowId": {},
	          "Targets": {
	            "shape": "S18"
	          },
	          "TaskArn": {},
	          "ServiceRoleArn": {},
	          "TaskType": {},
	          "TaskParameters": {
	            "shape": "Sep"
	          },
	          "TaskInvocationParameters": {
	            "shape": "Sjv"
	          },
	          "Priority": {
	            "type": "integer"
	          },
	          "MaxConcurrency": {},
	          "MaxErrors": {},
	          "LoggingInfo": {
	            "shape": "Sev"
	          },
	          "Name": {},
	          "Description": {
	            "shape": "S42"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "CutoffBehavior": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowTaskId": {}
	        }
	      }
	    },
	    "RemoveTagsFromResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceType",
	          "ResourceId",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceType": {},
	          "ResourceId": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "ResetServiceSetting": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SettingId"
	        ],
	        "members": {
	          "SettingId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ServiceSetting": {
	            "shape": "Slx"
	          }
	        }
	      }
	    },
	    "ResumeSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SessionId"
	        ],
	        "members": {
	          "SessionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SessionId": {},
	          "TokenValue": {},
	          "StreamUrl": {}
	        }
	      }
	    },
	    "SendAutomationSignal": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutomationExecutionId",
	          "SignalType"
	        ],
	        "members": {
	          "AutomationExecutionId": {},
	          "SignalType": {},
	          "Payload": {
	            "shape": "S95"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "SendCommand": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentName"
	        ],
	        "members": {
	          "InstanceIds": {
	            "shape": "Si"
	          },
	          "Targets": {
	            "shape": "S18"
	          },
	          "DocumentName": {},
	          "DocumentVersion": {},
	          "DocumentHash": {},
	          "DocumentHashType": {},
	          "TimeoutSeconds": {
	            "type": "integer"
	          },
	          "Comment": {},
	          "Parameters": {
	            "shape": "S14"
	          },
	          "OutputS3Region": {},
	          "OutputS3BucketName": {},
	          "OutputS3KeyPrefix": {},
	          "MaxConcurrency": {},
	          "MaxErrors": {},
	          "ServiceRoleArn": {},
	          "NotificationConfig": {
	            "shape": "Sjx"
	          },
	          "CloudWatchOutputConfig": {
	            "shape": "Shv"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Command": {
	            "shape": "Smv"
	          }
	        }
	      }
	    },
	    "StartAssociationsOnce": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationIds"
	        ],
	        "members": {
	          "AssociationIds": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "StartAutomationExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentName"
	        ],
	        "members": {
	          "DocumentName": {},
	          "DocumentVersion": {},
	          "Parameters": {
	            "shape": "S95"
	          },
	          "ClientToken": {},
	          "Mode": {},
	          "TargetParameterName": {},
	          "Targets": {
	            "shape": "S18"
	          },
	          "TargetMaps": {
	            "shape": "S20"
	          },
	          "MaxConcurrency": {},
	          "MaxErrors": {},
	          "TargetLocations": {
	            "shape": "S1s"
	          },
	          "Tags": {
	            "shape": "S4"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AutomationExecutionId": {}
	        }
	      }
	    },
	    "StartChangeRequestExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentName",
	          "Runbooks"
	        ],
	        "members": {
	          "ScheduledTime": {
	            "type": "timestamp"
	          },
	          "DocumentName": {},
	          "DocumentVersion": {},
	          "Parameters": {
	            "shape": "S95"
	          },
	          "ChangeRequestName": {},
	          "ClientToken": {},
	          "AutoApprove": {
	            "type": "boolean"
	          },
	          "Runbooks": {
	            "shape": "S9e"
	          },
	          "Tags": {
	            "shape": "S4"
	          },
	          "ScheduledEndTime": {
	            "type": "timestamp"
	          },
	          "ChangeDetails": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AutomationExecutionId": {}
	        }
	      }
	    },
	    "StartSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Target"
	        ],
	        "members": {
	          "Target": {},
	          "DocumentName": {},
	          "Reason": {},
	          "Parameters": {
	            "type": "map",
	            "key": {},
	            "value": {
	              "type": "list",
	              "member": {}
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SessionId": {},
	          "TokenValue": {},
	          "StreamUrl": {}
	        }
	      }
	    },
	    "StopAutomationExecution": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutomationExecutionId"
	        ],
	        "members": {
	          "AutomationExecutionId": {},
	          "Type": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TerminateSession": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SessionId"
	        ],
	        "members": {
	          "SessionId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SessionId": {}
	        }
	      }
	    },
	    "UnlabelParameterVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ParameterVersion",
	          "Labels"
	        ],
	        "members": {
	          "Name": {},
	          "ParameterVersion": {
	            "type": "long"
	          },
	          "Labels": {
	            "shape": "Slh"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RemovedLabels": {
	            "shape": "Slh"
	          },
	          "InvalidLabels": {
	            "shape": "Slh"
	          }
	        }
	      }
	    },
	    "UpdateAssociation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AssociationId"
	        ],
	        "members": {
	          "AssociationId": {},
	          "Parameters": {
	            "shape": "S14"
	          },
	          "DocumentVersion": {},
	          "ScheduleExpression": {},
	          "OutputLocation": {
	            "shape": "S1e"
	          },
	          "Name": {},
	          "Targets": {
	            "shape": "S18"
	          },
	          "AssociationName": {},
	          "AssociationVersion": {},
	          "AutomationTargetParameterName": {},
	          "MaxErrors": {},
	          "MaxConcurrency": {},
	          "ComplianceSeverity": {},
	          "SyncCompliance": {},
	          "ApplyOnlyAtCronInterval": {
	            "type": "boolean"
	          },
	          "CalendarNames": {
	            "shape": "S1q"
	          },
	          "TargetLocations": {
	            "shape": "S1s"
	          },
	          "ScheduleOffset": {
	            "type": "integer"
	          },
	          "TargetMaps": {
	            "shape": "S20"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationDescription": {
	            "shape": "S26"
	          }
	        }
	      }
	    },
	    "UpdateAssociationStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "InstanceId",
	          "AssociationStatus"
	        ],
	        "members": {
	          "Name": {},
	          "InstanceId": {},
	          "AssociationStatus": {
	            "shape": "S29"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AssociationDescription": {
	            "shape": "S26"
	          }
	        }
	      }
	    },
	    "UpdateDocument": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Content",
	          "Name"
	        ],
	        "members": {
	          "Content": {},
	          "Attachments": {
	            "shape": "S2v"
	          },
	          "Name": {},
	          "DisplayName": {},
	          "VersionName": {},
	          "DocumentVersion": {},
	          "DocumentFormat": {},
	          "TargetType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DocumentDescription": {
	            "shape": "S38"
	          }
	        }
	      }
	    },
	    "UpdateDocumentDefaultVersion": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "DocumentVersion"
	        ],
	        "members": {
	          "Name": {},
	          "DocumentVersion": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Description": {
	            "type": "structure",
	            "members": {
	              "Name": {},
	              "DefaultVersion": {},
	              "DefaultVersionName": {}
	            }
	          }
	        }
	      }
	    },
	    "UpdateDocumentMetadata": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "DocumentReviews"
	        ],
	        "members": {
	          "Name": {},
	          "DocumentVersion": {},
	          "DocumentReviews": {
	            "type": "structure",
	            "required": [
	              "Action"
	            ],
	            "members": {
	              "Action": {},
	              "Comment": {
	                "shape": "So2"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateMaintenanceWindow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId"
	        ],
	        "members": {
	          "WindowId": {},
	          "Name": {},
	          "Description": {
	            "shape": "S42"
	          },
	          "StartDate": {},
	          "EndDate": {},
	          "Schedule": {},
	          "ScheduleTimezone": {},
	          "ScheduleOffset": {
	            "type": "integer"
	          },
	          "Duration": {
	            "type": "integer"
	          },
	          "Cutoff": {
	            "type": "integer"
	          },
	          "AllowUnassociatedTargets": {
	            "type": "boolean"
	          },
	          "Enabled": {
	            "type": "boolean"
	          },
	          "Replace": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowId": {},
	          "Name": {},
	          "Description": {
	            "shape": "S42"
	          },
	          "StartDate": {},
	          "EndDate": {},
	          "Schedule": {},
	          "ScheduleTimezone": {},
	          "ScheduleOffset": {
	            "type": "integer"
	          },
	          "Duration": {
	            "type": "integer"
	          },
	          "Cutoff": {
	            "type": "integer"
	          },
	          "AllowUnassociatedTargets": {
	            "type": "boolean"
	          },
	          "Enabled": {
	            "type": "boolean"
	          }
	        }
	      }
	    },
	    "UpdateMaintenanceWindowTarget": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId",
	          "WindowTargetId"
	        ],
	        "members": {
	          "WindowId": {},
	          "WindowTargetId": {},
	          "Targets": {
	            "shape": "S18"
	          },
	          "OwnerInformation": {
	            "shape": "Scj"
	          },
	          "Name": {},
	          "Description": {
	            "shape": "S42"
	          },
	          "Replace": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowId": {},
	          "WindowTargetId": {},
	          "Targets": {
	            "shape": "S18"
	          },
	          "OwnerInformation": {
	            "shape": "Scj"
	          },
	          "Name": {},
	          "Description": {
	            "shape": "S42"
	          }
	        }
	      }
	    },
	    "UpdateMaintenanceWindowTask": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WindowId",
	          "WindowTaskId"
	        ],
	        "members": {
	          "WindowId": {},
	          "WindowTaskId": {},
	          "Targets": {
	            "shape": "S18"
	          },
	          "TaskArn": {},
	          "ServiceRoleArn": {},
	          "TaskParameters": {
	            "shape": "Sep"
	          },
	          "TaskInvocationParameters": {
	            "shape": "Sjv"
	          },
	          "Priority": {
	            "type": "integer"
	          },
	          "MaxConcurrency": {},
	          "MaxErrors": {},
	          "LoggingInfo": {
	            "shape": "Sev"
	          },
	          "Name": {},
	          "Description": {
	            "shape": "S42"
	          },
	          "Replace": {
	            "type": "boolean"
	          },
	          "CutoffBehavior": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WindowId": {},
	          "WindowTaskId": {},
	          "Targets": {
	            "shape": "S18"
	          },
	          "TaskArn": {},
	          "ServiceRoleArn": {},
	          "TaskParameters": {
	            "shape": "Sep"
	          },
	          "TaskInvocationParameters": {
	            "shape": "Sjv"
	          },
	          "Priority": {
	            "type": "integer"
	          },
	          "MaxConcurrency": {},
	          "MaxErrors": {},
	          "LoggingInfo": {
	            "shape": "Sev"
	          },
	          "Name": {},
	          "Description": {
	            "shape": "S42"
	          },
	          "CutoffBehavior": {}
	        }
	      }
	    },
	    "UpdateManagedInstanceRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InstanceId",
	          "IamRole"
	        ],
	        "members": {
	          "InstanceId": {},
	          "IamRole": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateOpsItem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpsItemId"
	        ],
	        "members": {
	          "Description": {},
	          "OperationalData": {
	            "shape": "S4g"
	          },
	          "OperationalDataToDelete": {
	            "type": "list",
	            "member": {}
	          },
	          "Notifications": {
	            "shape": "S4l"
	          },
	          "Priority": {
	            "type": "integer"
	          },
	          "RelatedOpsItems": {
	            "shape": "S4p"
	          },
	          "Status": {},
	          "OpsItemId": {},
	          "Title": {},
	          "Category": {},
	          "Severity": {},
	          "ActualStartTime": {
	            "type": "timestamp"
	          },
	          "ActualEndTime": {
	            "type": "timestamp"
	          },
	          "PlannedStartTime": {
	            "type": "timestamp"
	          },
	          "PlannedEndTime": {
	            "type": "timestamp"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateOpsMetadata": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "OpsMetadataArn"
	        ],
	        "members": {
	          "OpsMetadataArn": {},
	          "MetadataToUpdate": {
	            "shape": "S4y"
	          },
	          "KeysToDelete": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "OpsMetadataArn": {}
	        }
	      }
	    },
	    "UpdatePatchBaseline": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "BaselineId"
	        ],
	        "members": {
	          "BaselineId": {},
	          "Name": {},
	          "GlobalFilters": {
	            "shape": "S57"
	          },
	          "ApprovalRules": {
	            "shape": "S5d"
	          },
	          "ApprovedPatches": {
	            "shape": "S5k"
	          },
	          "ApprovedPatchesComplianceLevel": {},
	          "ApprovedPatchesEnableNonSecurity": {
	            "type": "boolean"
	          },
	          "RejectedPatches": {
	            "shape": "S5k"
	          },
	          "RejectedPatchesAction": {},
	          "Description": {},
	          "Sources": {
	            "shape": "S5o"
	          },
	          "Replace": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "BaselineId": {},
	          "Name": {},
	          "OperatingSystem": {},
	          "GlobalFilters": {
	            "shape": "S57"
	          },
	          "ApprovalRules": {
	            "shape": "S5d"
	          },
	          "ApprovedPatches": {
	            "shape": "S5k"
	          },
	          "ApprovedPatchesComplianceLevel": {},
	          "ApprovedPatchesEnableNonSecurity": {
	            "type": "boolean"
	          },
	          "RejectedPatches": {
	            "shape": "S5k"
	          },
	          "RejectedPatchesAction": {},
	          "CreatedDate": {
	            "type": "timestamp"
	          },
	          "ModifiedDate": {
	            "type": "timestamp"
	          },
	          "Description": {},
	          "Sources": {
	            "shape": "S5o"
	          }
	        }
	      }
	    },
	    "UpdateResourceDataSync": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SyncName",
	          "SyncType",
	          "SyncSource"
	        ],
	        "members": {
	          "SyncName": {},
	          "SyncType": {},
	          "SyncSource": {
	            "shape": "S67"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateServiceSetting": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SettingId",
	          "SettingValue"
	        ],
	        "members": {
	          "SettingId": {},
	          "SettingValue": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Si": {
	      "type": "list",
	      "member": {}
	    },
	    "S14": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "list",
	        "member": {}
	      },
	      "sensitive": true
	    },
	    "S18": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Values": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "S1e": {
	      "type": "structure",
	      "members": {
	        "S3Location": {
	          "type": "structure",
	          "members": {
	            "OutputS3Region": {},
	            "OutputS3BucketName": {},
	            "OutputS3KeyPrefix": {}
	          }
	        }
	      }
	    },
	    "S1q": {
	      "type": "list",
	      "member": {}
	    },
	    "S1s": {
	      "type": "list",
	      "member": {
	        "shape": "S1t"
	      }
	    },
	    "S1t": {
	      "type": "structure",
	      "members": {
	        "Accounts": {
	          "type": "list",
	          "member": {}
	        },
	        "Regions": {
	          "type": "list",
	          "member": {}
	        },
	        "TargetLocationMaxConcurrency": {},
	        "TargetLocationMaxErrors": {},
	        "ExecutionRoleName": {}
	      }
	    },
	    "S20": {
	      "type": "list",
	      "member": {
	        "type": "map",
	        "key": {},
	        "value": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S26": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "InstanceId": {},
	        "AssociationVersion": {},
	        "Date": {
	          "type": "timestamp"
	        },
	        "LastUpdateAssociationDate": {
	          "type": "timestamp"
	        },
	        "Status": {
	          "shape": "S29"
	        },
	        "Overview": {
	          "shape": "S2d"
	        },
	        "DocumentVersion": {},
	        "AutomationTargetParameterName": {},
	        "Parameters": {
	          "shape": "S14"
	        },
	        "AssociationId": {},
	        "Targets": {
	          "shape": "S18"
	        },
	        "ScheduleExpression": {},
	        "OutputLocation": {
	          "shape": "S1e"
	        },
	        "LastExecutionDate": {
	          "type": "timestamp"
	        },
	        "LastSuccessfulExecutionDate": {
	          "type": "timestamp"
	        },
	        "AssociationName": {},
	        "MaxErrors": {},
	        "MaxConcurrency": {},
	        "ComplianceSeverity": {},
	        "SyncCompliance": {},
	        "ApplyOnlyAtCronInterval": {
	          "type": "boolean"
	        },
	        "CalendarNames": {
	          "shape": "S1q"
	        },
	        "TargetLocations": {
	          "shape": "S1s"
	        },
	        "ScheduleOffset": {
	          "type": "integer"
	        },
	        "TargetMaps": {
	          "shape": "S20"
	        }
	      }
	    },
	    "S29": {
	      "type": "structure",
	      "required": [
	        "Date",
	        "Name",
	        "Message"
	      ],
	      "members": {
	        "Date": {
	          "type": "timestamp"
	        },
	        "Name": {},
	        "Message": {},
	        "AdditionalInfo": {}
	      }
	    },
	    "S2d": {
	      "type": "structure",
	      "members": {
	        "Status": {},
	        "DetailedStatus": {},
	        "AssociationStatusAggregatedCount": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S2k": {
	      "type": "structure",
	      "required": [
	        "Name"
	      ],
	      "members": {
	        "Name": {},
	        "InstanceId": {},
	        "Parameters": {
	          "shape": "S14"
	        },
	        "AutomationTargetParameterName": {},
	        "DocumentVersion": {},
	        "Targets": {
	          "shape": "S18"
	        },
	        "ScheduleExpression": {},
	        "OutputLocation": {
	          "shape": "S1e"
	        },
	        "AssociationName": {},
	        "MaxErrors": {},
	        "MaxConcurrency": {},
	        "ComplianceSeverity": {},
	        "SyncCompliance": {},
	        "ApplyOnlyAtCronInterval": {
	          "type": "boolean"
	        },
	        "CalendarNames": {
	          "shape": "S1q"
	        },
	        "TargetLocations": {
	          "shape": "S1s"
	        },
	        "ScheduleOffset": {
	          "type": "integer"
	        },
	        "TargetMaps": {
	          "shape": "S20"
	        }
	      }
	    },
	    "S2t": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Version": {}
	        }
	      }
	    },
	    "S2v": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Values": {
	            "type": "list",
	            "member": {}
	          },
	          "Name": {}
	        }
	      }
	    },
	    "S38": {
	      "type": "structure",
	      "members": {
	        "Sha1": {},
	        "Hash": {},
	        "HashType": {},
	        "Name": {},
	        "DisplayName": {},
	        "VersionName": {},
	        "Owner": {},
	        "CreatedDate": {
	          "type": "timestamp"
	        },
	        "Status": {},
	        "StatusInformation": {},
	        "DocumentVersion": {},
	        "Description": {},
	        "Parameters": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Name": {},
	              "Type": {},
	              "Description": {},
	              "DefaultValue": {}
	            }
	          }
	        },
	        "PlatformTypes": {
	          "shape": "S3m"
	        },
	        "DocumentType": {},
	        "SchemaVersion": {},
	        "LatestVersion": {},
	        "DefaultVersion": {},
	        "DocumentFormat": {},
	        "TargetType": {},
	        "Tags": {
	          "shape": "S4"
	        },
	        "AttachmentsInformation": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Name": {}
	            }
	          }
	        },
	        "Requires": {
	          "shape": "S2t"
	        },
	        "Author": {},
	        "ReviewInformation": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "ReviewedTime": {
	                "type": "timestamp"
	              },
	              "Status": {},
	              "Reviewer": {}
	            }
	          }
	        },
	        "ApprovedVersion": {},
	        "PendingReviewVersion": {},
	        "ReviewStatus": {},
	        "Category": {
	          "type": "list",
	          "member": {}
	        },
	        "CategoryEnum": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S3m": {
	      "type": "list",
	      "member": {}
	    },
	    "S42": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S4g": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "members": {
	          "Value": {},
	          "Type": {}
	        }
	      }
	    },
	    "S4l": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Arn": {}
	        }
	      }
	    },
	    "S4p": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "OpsItemId"
	        ],
	        "members": {
	          "OpsItemId": {}
	        }
	      }
	    },
	    "S4y": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "members": {
	          "Value": {}
	        }
	      }
	    },
	    "S57": {
	      "type": "structure",
	      "required": [
	        "PatchFilters"
	      ],
	      "members": {
	        "PatchFilters": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "Key",
	              "Values"
	            ],
	            "members": {
	              "Key": {},
	              "Values": {
	                "type": "list",
	                "member": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "S5d": {
	      "type": "structure",
	      "required": [
	        "PatchRules"
	      ],
	      "members": {
	        "PatchRules": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "PatchFilterGroup"
	            ],
	            "members": {
	              "PatchFilterGroup": {
	                "shape": "S57"
	              },
	              "ComplianceLevel": {},
	              "ApproveAfterDays": {
	                "type": "integer"
	              },
	              "ApproveUntilDate": {},
	              "EnableNonSecurity": {
	                "type": "boolean"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S5k": {
	      "type": "list",
	      "member": {}
	    },
	    "S5o": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "Products",
	          "Configuration"
	        ],
	        "members": {
	          "Name": {},
	          "Products": {
	            "type": "list",
	            "member": {}
	          },
	          "Configuration": {
	            "type": "string",
	            "sensitive": true
	          }
	        }
	      }
	    },
	    "S5y": {
	      "type": "structure",
	      "required": [
	        "BucketName",
	        "SyncFormat",
	        "Region"
	      ],
	      "members": {
	        "BucketName": {},
	        "Prefix": {},
	        "SyncFormat": {},
	        "Region": {},
	        "AWSKMSKeyARN": {},
	        "DestinationDataSharing": {
	          "type": "structure",
	          "members": {
	            "DestinationDataSharingType": {}
	          }
	        }
	      }
	    },
	    "S67": {
	      "type": "structure",
	      "required": [
	        "SourceType",
	        "SourceRegions"
	      ],
	      "members": {
	        "SourceType": {},
	        "AwsOrganizationsSource": {
	          "shape": "S69"
	        },
	        "SourceRegions": {
	          "shape": "S6e"
	        },
	        "IncludeFutureRegions": {
	          "type": "boolean"
	        },
	        "EnableAllOpsDataSources": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S69": {
	      "type": "structure",
	      "required": [
	        "OrganizationSourceType"
	      ],
	      "members": {
	        "OrganizationSourceType": {},
	        "OrganizationalUnits": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "OrganizationalUnitId": {}
	            }
	          }
	        }
	      }
	    },
	    "S6e": {
	      "type": "list",
	      "member": {}
	    },
	    "S6v": {
	      "type": "structure",
	      "members": {
	        "TotalCount": {
	          "type": "integer"
	        },
	        "RemainingCount": {
	          "type": "integer"
	        },
	        "SummaryItems": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Version": {},
	              "Count": {
	                "type": "integer"
	              },
	              "RemainingCount": {
	                "type": "integer"
	              }
	            }
	          }
	        }
	      }
	    },
	    "S7a": {
	      "type": "list",
	      "member": {}
	    },
	    "S95": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "list",
	        "member": {}
	      }
	    },
	    "S9a": {
	      "type": "structure",
	      "members": {
	        "ParameterValues": {
	          "type": "list",
	          "member": {}
	        },
	        "Truncated": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S9e": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "DocumentName"
	        ],
	        "members": {
	          "DocumentName": {},
	          "DocumentVersion": {},
	          "Parameters": {
	            "shape": "S95"
	          },
	          "TargetParameterName": {},
	          "Targets": {
	            "shape": "S18"
	          },
	          "TargetMaps": {
	            "shape": "S20"
	          },
	          "MaxConcurrency": {},
	          "MaxErrors": {},
	          "TargetLocations": {
	            "shape": "S1s"
	          }
	        }
	      }
	    },
	    "S9o": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "StepName": {},
	          "Action": {},
	          "TimeoutSeconds": {
	            "type": "long"
	          },
	          "OnFailure": {},
	          "MaxAttempts": {
	            "type": "integer"
	          },
	          "ExecutionStartTime": {
	            "type": "timestamp"
	          },
	          "ExecutionEndTime": {
	            "type": "timestamp"
	          },
	          "StepStatus": {},
	          "ResponseCode": {},
	          "Inputs": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          },
	          "Outputs": {
	            "shape": "S95"
	          },
	          "Response": {},
	          "FailureMessage": {},
	          "FailureDetails": {
	            "type": "structure",
	            "members": {
	              "FailureStage": {},
	              "FailureType": {},
	              "Details": {
	                "shape": "S95"
	              }
	            }
	          },
	          "StepExecutionId": {},
	          "OverriddenParameters": {
	            "shape": "S95"
	          },
	          "IsEnd": {
	            "type": "boolean"
	          },
	          "NextStep": {},
	          "IsCritical": {
	            "type": "boolean"
	          },
	          "ValidNextSteps": {
	            "type": "list",
	            "member": {}
	          },
	          "Targets": {
	            "shape": "S18"
	          },
	          "TargetLocation": {
	            "shape": "S1t"
	          }
	        }
	      }
	    },
	    "S9y": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Values": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "Sa6": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "ReleaseDate": {
	          "type": "timestamp"
	        },
	        "Title": {},
	        "Description": {},
	        "ContentUrl": {},
	        "Vendor": {},
	        "ProductFamily": {},
	        "Product": {},
	        "Classification": {},
	        "MsrcSeverity": {},
	        "KbNumber": {},
	        "MsrcNumber": {},
	        "Language": {},
	        "AdvisoryIds": {
	          "type": "list",
	          "member": {}
	        },
	        "BugzillaIds": {
	          "type": "list",
	          "member": {}
	        },
	        "CVEIds": {
	          "type": "list",
	          "member": {}
	        },
	        "Name": {},
	        "Epoch": {
	          "type": "integer"
	        },
	        "Version": {},
	        "Release": {},
	        "Arch": {},
	        "Severity": {},
	        "Repository": {}
	      }
	    },
	    "Sb1": {
	      "type": "list",
	      "member": {}
	    },
	    "Sbu": {
	      "type": "list",
	      "member": {}
	    },
	    "Scg": {
	      "type": "structure",
	      "required": [
	        "InstanceId",
	        "PatchGroup",
	        "BaselineId",
	        "OperationStartTime",
	        "OperationEndTime",
	        "Operation"
	      ],
	      "members": {
	        "InstanceId": {},
	        "PatchGroup": {},
	        "BaselineId": {},
	        "SnapshotId": {},
	        "InstallOverrideList": {},
	        "OwnerInformation": {
	          "shape": "Scj"
	        },
	        "InstalledCount": {
	          "type": "integer"
	        },
	        "InstalledOtherCount": {
	          "type": "integer"
	        },
	        "InstalledPendingRebootCount": {
	          "type": "integer"
	        },
	        "InstalledRejectedCount": {
	          "type": "integer"
	        },
	        "MissingCount": {
	          "type": "integer"
	        },
	        "FailedCount": {
	          "type": "integer"
	        },
	        "UnreportedNotApplicableCount": {
	          "type": "integer"
	        },
	        "NotApplicableCount": {
	          "type": "integer"
	        },
	        "OperationStartTime": {
	          "type": "timestamp"
	        },
	        "OperationEndTime": {
	          "type": "timestamp"
	        },
	        "Operation": {},
	        "LastNoRebootInstallOperationTime": {
	          "type": "timestamp"
	        },
	        "RebootOption": {},
	        "CriticalNonCompliantCount": {
	          "type": "integer"
	        },
	        "SecurityNonCompliantCount": {
	          "type": "integer"
	        },
	        "OtherNonCompliantCount": {
	          "type": "integer"
	        }
	      }
	    },
	    "Scj": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Sdm": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Values": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "Sdy": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Sep": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "type": "structure",
	        "members": {
	          "Values": {
	            "type": "list",
	            "member": {
	              "type": "string",
	              "sensitive": true
	            },
	            "sensitive": true
	          }
	        },
	        "sensitive": true
	      },
	      "sensitive": true
	    },
	    "Sev": {
	      "type": "structure",
	      "required": [
	        "S3BucketName",
	        "S3Region"
	      ],
	      "members": {
	        "S3BucketName": {},
	        "S3KeyPrefix": {},
	        "S3Region": {}
	      }
	    },
	    "Sfp": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key"
	        ],
	        "members": {
	          "Key": {},
	          "Option": {},
	          "Values": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "Sg4": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "PolicyText": {},
	          "PolicyType": {},
	          "PolicyStatus": {}
	        }
	      }
	    },
	    "Sga": {
	      "type": "structure",
	      "members": {
	        "BaselineId": {},
	        "BaselineName": {},
	        "OperatingSystem": {},
	        "BaselineDescription": {},
	        "DefaultBaseline": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Shv": {
	      "type": "structure",
	      "members": {
	        "CloudWatchLogGroupName": {},
	        "CloudWatchOutputEnabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Sih": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Values"
	        ],
	        "members": {
	          "Key": {},
	          "Values": {
	            "type": "list",
	            "member": {}
	          },
	          "Type": {}
	        }
	      }
	    },
	    "Sin": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Expression": {},
	          "Aggregators": {
	            "shape": "Sin"
	          },
	          "Groups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Name",
	                "Filters"
	              ],
	              "members": {
	                "Name": {},
	                "Filters": {
	                  "shape": "Sih"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "Sj4": {
	      "type": "list",
	      "member": {
	        "type": "map",
	        "key": {},
	        "value": {}
	      }
	    },
	    "Sjv": {
	      "type": "structure",
	      "members": {
	        "RunCommand": {
	          "type": "structure",
	          "members": {
	            "Comment": {},
	            "CloudWatchOutputConfig": {
	              "shape": "Shv"
	            },
	            "DocumentHash": {},
	            "DocumentHashType": {},
	            "DocumentVersion": {},
	            "NotificationConfig": {
	              "shape": "Sjx"
	            },
	            "OutputS3BucketName": {},
	            "OutputS3KeyPrefix": {},
	            "Parameters": {
	              "shape": "S14"
	            },
	            "ServiceRoleArn": {},
	            "TimeoutSeconds": {
	              "type": "integer"
	            }
	          }
	        },
	        "Automation": {
	          "type": "structure",
	          "members": {
	            "DocumentVersion": {},
	            "Parameters": {
	              "shape": "S95"
	            }
	          }
	        },
	        "StepFunctions": {
	          "type": "structure",
	          "members": {
	            "Input": {
	              "type": "string",
	              "sensitive": true
	            },
	            "Name": {}
	          }
	        },
	        "Lambda": {
	          "type": "structure",
	          "members": {
	            "ClientContext": {},
	            "Qualifier": {},
	            "Payload": {
	              "type": "blob",
	              "sensitive": true
	            }
	          }
	        }
	      }
	    },
	    "Sjx": {
	      "type": "structure",
	      "members": {
	        "NotificationArn": {},
	        "NotificationEvents": {
	          "type": "list",
	          "member": {}
	        },
	        "NotificationType": {}
	      }
	    },
	    "Ski": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Values"
	        ],
	        "members": {
	          "Key": {},
	          "Values": {
	            "type": "list",
	            "member": {}
	          },
	          "Type": {}
	        }
	      }
	    },
	    "Sko": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "AggregatorType": {},
	          "TypeName": {},
	          "AttributeName": {},
	          "Values": {
	            "type": "map",
	            "key": {},
	            "value": {}
	          },
	          "Filters": {
	            "shape": "Ski"
	          },
	          "Aggregators": {
	            "shape": "Sko"
	          }
	        }
	      }
	    },
	    "Sla": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Type": {},
	        "Value": {
	          "shape": "Slb"
	        },
	        "Version": {
	          "type": "long"
	        },
	        "Selector": {},
	        "SourceResult": {},
	        "LastModifiedDate": {
	          "type": "timestamp"
	        },
	        "ARN": {},
	        "DataType": {}
	      }
	    },
	    "Slb": {
	      "type": "string",
	      "sensitive": true
	    },
	    "Slh": {
	      "type": "list",
	      "member": {}
	    },
	    "Sll": {
	      "type": "list",
	      "member": {
	        "shape": "Sla"
	      }
	    },
	    "Slx": {
	      "type": "structure",
	      "members": {
	        "SettingId": {},
	        "SettingValue": {},
	        "LastModifiedDate": {
	          "type": "timestamp"
	        },
	        "LastModifiedUser": {},
	        "ARN": {},
	        "Status": {}
	      }
	    },
	    "Smf": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "key",
	          "value"
	        ],
	        "members": {
	          "key": {},
	          "value": {}
	        }
	      }
	    },
	    "Smv": {
	      "type": "structure",
	      "members": {
	        "CommandId": {},
	        "DocumentName": {},
	        "DocumentVersion": {},
	        "Comment": {},
	        "ExpiresAfter": {
	          "type": "timestamp"
	        },
	        "Parameters": {
	          "shape": "S14"
	        },
	        "InstanceIds": {
	          "shape": "Si"
	        },
	        "Targets": {
	          "shape": "S18"
	        },
	        "RequestedDateTime": {
	          "type": "timestamp"
	        },
	        "Status": {},
	        "StatusDetails": {},
	        "OutputS3Region": {},
	        "OutputS3BucketName": {},
	        "OutputS3KeyPrefix": {},
	        "MaxConcurrency": {},
	        "MaxErrors": {},
	        "TargetCount": {
	          "type": "integer"
	        },
	        "CompletedCount": {
	          "type": "integer"
	        },
	        "ErrorCount": {
	          "type": "integer"
	        },
	        "DeliveryTimedOutCount": {
	          "type": "integer"
	        },
	        "ServiceRole": {},
	        "NotificationConfig": {
	          "shape": "Sjx"
	        },
	        "CloudWatchOutputConfig": {
	          "shape": "Shv"
	        },
	        "TimeoutSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "Sn2": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Key": {},
	          "Values": {
	            "type": "list",
	            "member": {}
	          },
	          "Type": {}
	        }
	      }
	    },
	    "Snk": {
	      "type": "structure",
	      "required": [
	        "ExecutionTime"
	      ],
	      "members": {
	        "ExecutionTime": {
	          "type": "timestamp"
	        },
	        "ExecutionId": {},
	        "ExecutionType": {}
	      }
	    },
	    "Snn": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "Sns": {
	      "type": "structure",
	      "members": {
	        "CompliantCount": {
	          "type": "integer"
	        },
	        "SeveritySummary": {
	          "shape": "Snu"
	        }
	      }
	    },
	    "Snu": {
	      "type": "structure",
	      "members": {
	        "CriticalCount": {
	          "type": "integer"
	        },
	        "HighCount": {
	          "type": "integer"
	        },
	        "MediumCount": {
	          "type": "integer"
	        },
	        "LowCount": {
	          "type": "integer"
	        },
	        "InformationalCount": {
	          "type": "integer"
	        },
	        "UnspecifiedCount": {
	          "type": "integer"
	        }
	      }
	    },
	    "Snv": {
	      "type": "structure",
	      "members": {
	        "NonCompliantCount": {
	          "type": "integer"
	        },
	        "SeveritySummary": {
	          "shape": "Snu"
	        }
	      }
	    },
	    "So2": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Type": {},
	          "Content": {}
	        }
	      }
	    },
	    "Sp0": {
	      "type": "structure",
	      "members": {
	        "Arn": {}
	      }
	    }
	  }
	}
	},{}],224:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeActivations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ActivationList"
	    },
	    "DescribeAssociationExecutionTargets": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "AssociationExecutionTargets"
	    },
	    "DescribeAssociationExecutions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "AssociationExecutions"
	    },
	    "DescribeAutomationExecutions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "AutomationExecutionMetadataList"
	    },
	    "DescribeAutomationStepExecutions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "StepExecutions"
	    },
	    "DescribeAvailablePatches": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Patches"
	    },
	    "DescribeEffectiveInstanceAssociations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Associations"
	    },
	    "DescribeEffectivePatchesForPatchBaseline": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "EffectivePatches"
	    },
	    "DescribeInstanceAssociationsStatus": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InstanceAssociationStatusInfos"
	    },
	    "DescribeInstanceInformation": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InstanceInformationList"
	    },
	    "DescribeInstancePatchStates": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InstancePatchStates"
	    },
	    "DescribeInstancePatchStatesForPatchGroup": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InstancePatchStates"
	    },
	    "DescribeInstancePatches": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Patches"
	    },
	    "DescribeInventoryDeletions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "InventoryDeletions"
	    },
	    "DescribeMaintenanceWindowExecutionTaskInvocations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "WindowExecutionTaskInvocationIdentities"
	    },
	    "DescribeMaintenanceWindowExecutionTasks": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "WindowExecutionTaskIdentities"
	    },
	    "DescribeMaintenanceWindowExecutions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "WindowExecutions"
	    },
	    "DescribeMaintenanceWindowSchedule": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ScheduledWindowExecutions"
	    },
	    "DescribeMaintenanceWindowTargets": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Targets"
	    },
	    "DescribeMaintenanceWindowTasks": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Tasks"
	    },
	    "DescribeMaintenanceWindows": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "WindowIdentities"
	    },
	    "DescribeMaintenanceWindowsForTarget": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "WindowIdentities"
	    },
	    "DescribeOpsItems": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "OpsItemSummaries"
	    },
	    "DescribeParameters": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "DescribePatchBaselines": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "BaselineIdentities"
	    },
	    "DescribePatchGroups": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Mappings"
	    },
	    "DescribePatchProperties": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Properties"
	    },
	    "DescribeSessions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Sessions"
	    },
	    "GetInventory": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Entities"
	    },
	    "GetInventorySchema": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Schemas"
	    },
	    "GetOpsSummary": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Entities"
	    },
	    "GetParameterHistory": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetParametersByPath": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListAssociationVersions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "AssociationVersions"
	    },
	    "ListAssociations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Associations"
	    },
	    "ListCommandInvocations": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "CommandInvocations"
	    },
	    "ListCommands": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Commands"
	    },
	    "ListComplianceItems": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ComplianceItems"
	    },
	    "ListComplianceSummaries": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ComplianceSummaryItems"
	    },
	    "ListDocumentVersions": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "DocumentVersions"
	    },
	    "ListDocuments": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "DocumentIdentifiers"
	    },
	    "ListOpsItemEvents": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Summaries"
	    },
	    "ListOpsItemRelatedItems": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "Summaries"
	    },
	    "ListOpsMetadata": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "OpsMetadataList"
	    },
	    "ListResourceComplianceSummaries": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ResourceComplianceSummaryItems"
	    },
	    "ListResourceDataSync": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken",
	      "result_key": "ResourceDataSyncItems"
	    }
	  }
	}
	},{}],225:[function(require,module,exports){
	module.exports={
	  "version": 2,
	  "waiters": {
	    "CommandExecuted": {
	      "delay": 5,
	      "operation": "GetCommandInvocation",
	      "maxAttempts": 20,
	      "acceptors": [
	        {
	          "expected": "Pending",
	          "matcher": "path",
	          "state": "retry",
	          "argument": "Status"
	        },
	        {
	          "expected": "InProgress",
	          "matcher": "path",
	          "state": "retry",
	          "argument": "Status"
	        },
	        {
	          "expected": "Delayed",
	          "matcher": "path",
	          "state": "retry",
	          "argument": "Status"
	        },
	        {
	          "expected": "Success",
	          "matcher": "path",
	          "state": "success",
	          "argument": "Status"
	        },
	        {
	          "expected": "Cancelled",
	          "matcher": "path",
	          "state": "failure",
	          "argument": "Status"
	        },
	        {
	          "expected": "TimedOut",
	          "matcher": "path",
	          "state": "failure",
	          "argument": "Status"
	        },
	        {
	          "expected": "Failed",
	          "matcher": "path",
	          "state": "failure",
	          "argument": "Status"
	        },
	        {
	          "expected": "Cancelling",
	          "matcher": "path",
	          "state": "failure",
	          "argument": "Status"
	        },
		{
	          "state": "retry",
	          "matcher": "error",
	          "expected": "InvocationDoesNotExist"
	        }
	      ]
	    }
	  }
	}
	
	},{}],226:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2013-06-30",
	    "endpointPrefix": "storagegateway",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "AWS Storage Gateway",
	    "serviceId": "Storage Gateway",
	    "signatureVersion": "v4",
	    "targetPrefix": "StorageGateway_20130630",
	    "uid": "storagegateway-2013-06-30"
	  },
	  "operations": {
	    "ActivateGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ActivationKey",
	          "GatewayName",
	          "GatewayTimezone",
	          "GatewayRegion"
	        ],
	        "members": {
	          "ActivationKey": {},
	          "GatewayName": {},
	          "GatewayTimezone": {},
	          "GatewayRegion": {},
	          "GatewayType": {},
	          "TapeDriveType": {},
	          "MediumChangerType": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "AddCache": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "DiskIds"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "DiskIds": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "AddTagsToResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "Tags"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceARN": {}
	        }
	      }
	    },
	    "AddUploadBuffer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "DiskIds"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "DiskIds": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "AddWorkingStorage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "DiskIds"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "DiskIds": {
	            "shape": "Sg"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "AssignTapePool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TapeARN",
	          "PoolId"
	        ],
	        "members": {
	          "TapeARN": {},
	          "PoolId": {},
	          "BypassGovernanceRetention": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TapeARN": {}
	        }
	      }
	    },
	    "AssociateFileSystem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserName",
	          "Password",
	          "ClientToken",
	          "GatewayARN",
	          "LocationARN"
	        ],
	        "members": {
	          "UserName": {},
	          "Password": {
	            "shape": "Sx"
	          },
	          "ClientToken": {},
	          "GatewayARN": {},
	          "LocationARN": {},
	          "Tags": {
	            "shape": "S9"
	          },
	          "AuditDestinationARN": {},
	          "CacheAttributes": {
	            "shape": "S11"
	          },
	          "EndpointNetworkConfiguration": {
	            "shape": "S13"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileSystemAssociationARN": {}
	        }
	      }
	    },
	    "AttachVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "VolumeARN",
	          "NetworkInterfaceId"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "TargetName": {},
	          "VolumeARN": {},
	          "NetworkInterfaceId": {},
	          "DiskId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumeARN": {},
	          "TargetARN": {}
	        }
	      }
	    },
	    "CancelArchival": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "TapeARN"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "TapeARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TapeARN": {}
	        }
	      }
	    },
	    "CancelRetrieval": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "TapeARN"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "TapeARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TapeARN": {}
	        }
	      }
	    },
	    "CreateCachediSCSIVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "VolumeSizeInBytes",
	          "TargetName",
	          "NetworkInterfaceId",
	          "ClientToken"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "VolumeSizeInBytes": {
	            "type": "long"
	          },
	          "SnapshotId": {},
	          "TargetName": {},
	          "SourceVolumeARN": {},
	          "NetworkInterfaceId": {},
	          "ClientToken": {},
	          "KMSEncrypted": {
	            "type": "boolean"
	          },
	          "KMSKey": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumeARN": {},
	          "TargetARN": {}
	        }
	      }
	    },
	    "CreateNFSFileShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientToken",
	          "GatewayARN",
	          "Role",
	          "LocationARN"
	        ],
	        "members": {
	          "ClientToken": {},
	          "NFSFileShareDefaults": {
	            "shape": "S1p"
	          },
	          "GatewayARN": {},
	          "KMSEncrypted": {
	            "type": "boolean"
	          },
	          "KMSKey": {},
	          "Role": {},
	          "LocationARN": {},
	          "DefaultStorageClass": {},
	          "ObjectACL": {},
	          "ClientList": {
	            "shape": "S1w"
	          },
	          "Squash": {},
	          "ReadOnly": {
	            "type": "boolean"
	          },
	          "GuessMIMETypeEnabled": {
	            "type": "boolean"
	          },
	          "RequesterPays": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S9"
	          },
	          "FileShareName": {},
	          "CacheAttributes": {
	            "shape": "S11"
	          },
	          "NotificationPolicy": {},
	          "VPCEndpointDNSName": {},
	          "BucketRegion": {},
	          "AuditDestinationARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileShareARN": {}
	        }
	      }
	    },
	    "CreateSMBFileShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ClientToken",
	          "GatewayARN",
	          "Role",
	          "LocationARN"
	        ],
	        "members": {
	          "ClientToken": {},
	          "GatewayARN": {},
	          "KMSEncrypted": {
	            "type": "boolean"
	          },
	          "KMSKey": {},
	          "Role": {},
	          "LocationARN": {},
	          "DefaultStorageClass": {},
	          "ObjectACL": {},
	          "ReadOnly": {
	            "type": "boolean"
	          },
	          "GuessMIMETypeEnabled": {
	            "type": "boolean"
	          },
	          "RequesterPays": {
	            "type": "boolean"
	          },
	          "SMBACLEnabled": {
	            "type": "boolean"
	          },
	          "AccessBasedEnumeration": {
	            "type": "boolean"
	          },
	          "AdminUserList": {
	            "shape": "S25"
	          },
	          "ValidUserList": {
	            "shape": "S25"
	          },
	          "InvalidUserList": {
	            "shape": "S25"
	          },
	          "AuditDestinationARN": {},
	          "Authentication": {},
	          "CaseSensitivity": {},
	          "Tags": {
	            "shape": "S9"
	          },
	          "FileShareName": {},
	          "CacheAttributes": {
	            "shape": "S11"
	          },
	          "NotificationPolicy": {},
	          "VPCEndpointDNSName": {},
	          "BucketRegion": {},
	          "OplocksEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileShareARN": {}
	        }
	      }
	    },
	    "CreateSnapshot": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeARN",
	          "SnapshotDescription"
	        ],
	        "members": {
	          "VolumeARN": {},
	          "SnapshotDescription": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumeARN": {},
	          "SnapshotId": {}
	        }
	      }
	    },
	    "CreateSnapshotFromVolumeRecoveryPoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeARN",
	          "SnapshotDescription"
	        ],
	        "members": {
	          "VolumeARN": {},
	          "SnapshotDescription": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SnapshotId": {},
	          "VolumeARN": {},
	          "VolumeRecoveryPointTime": {}
	        }
	      }
	    },
	    "CreateStorediSCSIVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "DiskId",
	          "PreserveExistingData",
	          "TargetName",
	          "NetworkInterfaceId"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "DiskId": {},
	          "SnapshotId": {},
	          "PreserveExistingData": {
	            "type": "boolean"
	          },
	          "TargetName": {},
	          "NetworkInterfaceId": {},
	          "KMSEncrypted": {
	            "type": "boolean"
	          },
	          "KMSKey": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumeARN": {},
	          "VolumeSizeInBytes": {
	            "type": "long"
	          },
	          "TargetARN": {}
	        }
	      }
	    },
	    "CreateTapePool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PoolName",
	          "StorageClass"
	        ],
	        "members": {
	          "PoolName": {},
	          "StorageClass": {},
	          "RetentionLockType": {},
	          "RetentionLockTimeInDays": {
	            "type": "integer"
	          },
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PoolARN": {}
	        }
	      }
	    },
	    "CreateTapeWithBarcode": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "TapeSizeInBytes",
	          "TapeBarcode"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "TapeSizeInBytes": {
	            "type": "long"
	          },
	          "TapeBarcode": {},
	          "KMSEncrypted": {
	            "type": "boolean"
	          },
	          "KMSKey": {},
	          "PoolId": {},
	          "Worm": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TapeARN": {}
	        }
	      }
	    },
	    "CreateTapes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "TapeSizeInBytes",
	          "ClientToken",
	          "NumTapesToCreate",
	          "TapeBarcodePrefix"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "TapeSizeInBytes": {
	            "type": "long"
	          },
	          "ClientToken": {},
	          "NumTapesToCreate": {
	            "type": "integer"
	          },
	          "TapeBarcodePrefix": {},
	          "KMSEncrypted": {
	            "type": "boolean"
	          },
	          "KMSKey": {},
	          "PoolId": {},
	          "Worm": {
	            "type": "boolean"
	          },
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TapeARNs": {
	            "shape": "S2x"
	          }
	        }
	      }
	    },
	    "DeleteAutomaticTapeCreationPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "DeleteBandwidthRateLimit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "BandwidthType"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "BandwidthType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "DeleteChapCredentials": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetARN",
	          "InitiatorName"
	        ],
	        "members": {
	          "TargetARN": {},
	          "InitiatorName": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TargetARN": {},
	          "InitiatorName": {}
	        }
	      }
	    },
	    "DeleteFileShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileShareARN"
	        ],
	        "members": {
	          "FileShareARN": {},
	          "ForceDelete": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileShareARN": {}
	        }
	      }
	    },
	    "DeleteGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "DeleteSnapshotSchedule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeARN"
	        ],
	        "members": {
	          "VolumeARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumeARN": {}
	        }
	      }
	    },
	    "DeleteTape": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "TapeARN"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "TapeARN": {},
	          "BypassGovernanceRetention": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TapeARN": {}
	        }
	      }
	    },
	    "DeleteTapeArchive": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TapeARN"
	        ],
	        "members": {
	          "TapeARN": {},
	          "BypassGovernanceRetention": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TapeARN": {}
	        }
	      }
	    },
	    "DeleteTapePool": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "PoolARN"
	        ],
	        "members": {
	          "PoolARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PoolARN": {}
	        }
	      }
	    },
	    "DeleteVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeARN"
	        ],
	        "members": {
	          "VolumeARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumeARN": {}
	        }
	      }
	    },
	    "DescribeAvailabilityMonitorTest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "Status": {},
	          "StartTime": {
	            "type": "timestamp"
	          }
	        }
	      }
	    },
	    "DescribeBandwidthRateLimit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "AverageUploadRateLimitInBitsPerSec": {
	            "type": "long"
	          },
	          "AverageDownloadRateLimitInBitsPerSec": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "DescribeBandwidthRateLimitSchedule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "BandwidthRateLimitIntervals": {
	            "shape": "S3u"
	          }
	        }
	      }
	    },
	    "DescribeCache": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "DiskIds": {
	            "shape": "Sg"
	          },
	          "CacheAllocatedInBytes": {
	            "type": "long"
	          },
	          "CacheUsedPercentage": {
	            "type": "double"
	          },
	          "CacheDirtyPercentage": {
	            "type": "double"
	          },
	          "CacheHitPercentage": {
	            "type": "double"
	          },
	          "CacheMissPercentage": {
	            "type": "double"
	          }
	        }
	      }
	    },
	    "DescribeCachediSCSIVolumes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeARNs"
	        ],
	        "members": {
	          "VolumeARNs": {
	            "shape": "S44"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "CachediSCSIVolumes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "VolumeARN": {},
	                "VolumeId": {},
	                "VolumeType": {},
	                "VolumeStatus": {},
	                "VolumeAttachmentStatus": {},
	                "VolumeSizeInBytes": {
	                  "type": "long"
	                },
	                "VolumeProgress": {
	                  "type": "double"
	                },
	                "SourceSnapshotId": {},
	                "VolumeiSCSIAttributes": {
	                  "shape": "S4d"
	                },
	                "CreatedDate": {
	                  "type": "timestamp"
	                },
	                "VolumeUsedInBytes": {
	                  "type": "long"
	                },
	                "KMSKey": {},
	                "TargetName": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeChapCredentials": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetARN"
	        ],
	        "members": {
	          "TargetARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChapCredentials": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TargetARN": {},
	                "SecretToAuthenticateInitiator": {
	                  "shape": "S4m"
	                },
	                "InitiatorName": {},
	                "SecretToAuthenticateTarget": {
	                  "shape": "S4m"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeFileSystemAssociations": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemAssociationARNList"
	        ],
	        "members": {
	          "FileSystemAssociationARNList": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileSystemAssociationInfoList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FileSystemAssociationARN": {},
	                "LocationARN": {},
	                "FileSystemAssociationStatus": {},
	                "AuditDestinationARN": {},
	                "GatewayARN": {},
	                "Tags": {
	                  "shape": "S9"
	                },
	                "CacheAttributes": {
	                  "shape": "S11"
	                },
	                "EndpointNetworkConfiguration": {
	                  "shape": "S13"
	                },
	                "FileSystemAssociationStatusDetails": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "ErrorCode": {}
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeGatewayInformation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "GatewayId": {},
	          "GatewayName": {},
	          "GatewayTimezone": {},
	          "GatewayState": {},
	          "GatewayNetworkInterfaces": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Ipv4Address": {},
	                "MacAddress": {},
	                "Ipv6Address": {}
	              }
	            }
	          },
	          "GatewayType": {},
	          "NextUpdateAvailabilityDate": {},
	          "LastSoftwareUpdate": {},
	          "Ec2InstanceId": {},
	          "Ec2InstanceRegion": {},
	          "Tags": {
	            "shape": "S9"
	          },
	          "VPCEndpoint": {},
	          "CloudWatchLogGroupARN": {},
	          "HostEnvironment": {},
	          "EndpointType": {},
	          "SoftwareUpdatesEndDate": {},
	          "DeprecationDate": {},
	          "GatewayCapacity": {},
	          "SupportedGatewayCapacities": {
	            "type": "list",
	            "member": {}
	          },
	          "HostEnvironmentId": {}
	        }
	      }
	    },
	    "DescribeMaintenanceStartTime": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "HourOfDay": {
	            "type": "integer"
	          },
	          "MinuteOfHour": {
	            "type": "integer"
	          },
	          "DayOfWeek": {
	            "type": "integer"
	          },
	          "DayOfMonth": {
	            "type": "integer"
	          },
	          "Timezone": {}
	        }
	      }
	    },
	    "DescribeNFSFileShares": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileShareARNList"
	        ],
	        "members": {
	          "FileShareARNList": {
	            "shape": "S5i"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NFSFileShareInfoList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "NFSFileShareDefaults": {
	                  "shape": "S1p"
	                },
	                "FileShareARN": {},
	                "FileShareId": {},
	                "FileShareStatus": {},
	                "GatewayARN": {},
	                "KMSEncrypted": {
	                  "type": "boolean"
	                },
	                "KMSKey": {},
	                "Path": {},
	                "Role": {},
	                "LocationARN": {},
	                "DefaultStorageClass": {},
	                "ObjectACL": {},
	                "ClientList": {
	                  "shape": "S1w"
	                },
	                "Squash": {},
	                "ReadOnly": {
	                  "type": "boolean"
	                },
	                "GuessMIMETypeEnabled": {
	                  "type": "boolean"
	                },
	                "RequesterPays": {
	                  "type": "boolean"
	                },
	                "Tags": {
	                  "shape": "S9"
	                },
	                "FileShareName": {},
	                "CacheAttributes": {
	                  "shape": "S11"
	                },
	                "NotificationPolicy": {},
	                "VPCEndpointDNSName": {},
	                "BucketRegion": {},
	                "AuditDestinationARN": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeSMBFileShares": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileShareARNList"
	        ],
	        "members": {
	          "FileShareARNList": {
	            "shape": "S5i"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SMBFileShareInfoList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FileShareARN": {},
	                "FileShareId": {},
	                "FileShareStatus": {},
	                "GatewayARN": {},
	                "KMSEncrypted": {
	                  "type": "boolean"
	                },
	                "KMSKey": {},
	                "Path": {},
	                "Role": {},
	                "LocationARN": {},
	                "DefaultStorageClass": {},
	                "ObjectACL": {},
	                "ReadOnly": {
	                  "type": "boolean"
	                },
	                "GuessMIMETypeEnabled": {
	                  "type": "boolean"
	                },
	                "RequesterPays": {
	                  "type": "boolean"
	                },
	                "SMBACLEnabled": {
	                  "type": "boolean"
	                },
	                "AccessBasedEnumeration": {
	                  "type": "boolean"
	                },
	                "AdminUserList": {
	                  "shape": "S25"
	                },
	                "ValidUserList": {
	                  "shape": "S25"
	                },
	                "InvalidUserList": {
	                  "shape": "S25"
	                },
	                "AuditDestinationARN": {},
	                "Authentication": {},
	                "CaseSensitivity": {},
	                "Tags": {
	                  "shape": "S9"
	                },
	                "FileShareName": {},
	                "CacheAttributes": {
	                  "shape": "S11"
	                },
	                "NotificationPolicy": {},
	                "VPCEndpointDNSName": {},
	                "BucketRegion": {},
	                "OplocksEnabled": {
	                  "type": "boolean"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeSMBSettings": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "DomainName": {},
	          "ActiveDirectoryStatus": {},
	          "SMBGuestPasswordSet": {
	            "type": "boolean"
	          },
	          "SMBSecurityStrategy": {},
	          "FileSharesVisible": {
	            "type": "boolean"
	          },
	          "SMBLocalGroups": {
	            "shape": "S5y"
	          }
	        }
	      }
	    },
	    "DescribeSnapshotSchedule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeARN"
	        ],
	        "members": {
	          "VolumeARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumeARN": {},
	          "StartAt": {
	            "type": "integer"
	          },
	          "RecurrenceInHours": {
	            "type": "integer"
	          },
	          "Description": {},
	          "Timezone": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "DescribeStorediSCSIVolumes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeARNs"
	        ],
	        "members": {
	          "VolumeARNs": {
	            "shape": "S44"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StorediSCSIVolumes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "VolumeARN": {},
	                "VolumeId": {},
	                "VolumeType": {},
	                "VolumeStatus": {},
	                "VolumeAttachmentStatus": {},
	                "VolumeSizeInBytes": {
	                  "type": "long"
	                },
	                "VolumeProgress": {
	                  "type": "double"
	                },
	                "VolumeDiskId": {},
	                "SourceSnapshotId": {},
	                "PreservedExistingData": {
	                  "type": "boolean"
	                },
	                "VolumeiSCSIAttributes": {
	                  "shape": "S4d"
	                },
	                "CreatedDate": {
	                  "type": "timestamp"
	                },
	                "VolumeUsedInBytes": {
	                  "type": "long"
	                },
	                "KMSKey": {},
	                "TargetName": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "DescribeTapeArchives": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TapeARNs": {
	            "shape": "S2x"
	          },
	          "Marker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TapeArchives": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TapeARN": {},
	                "TapeBarcode": {},
	                "TapeCreatedDate": {
	                  "type": "timestamp"
	                },
	                "TapeSizeInBytes": {
	                  "type": "long"
	                },
	                "CompletionTime": {
	                  "type": "timestamp"
	                },
	                "RetrievedTo": {},
	                "TapeStatus": {},
	                "TapeUsedInBytes": {
	                  "type": "long"
	                },
	                "KMSKey": {},
	                "PoolId": {},
	                "Worm": {
	                  "type": "boolean"
	                },
	                "RetentionStartDate": {
	                  "type": "timestamp"
	                },
	                "PoolEntryDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeTapeRecoveryPoints": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "Marker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "TapeRecoveryPointInfos": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TapeARN": {},
	                "TapeRecoveryPointTime": {
	                  "type": "timestamp"
	                },
	                "TapeSizeInBytes": {
	                  "type": "long"
	                },
	                "TapeStatus": {}
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeTapes": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "TapeARNs": {
	            "shape": "S2x"
	          },
	          "Marker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tapes": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TapeARN": {},
	                "TapeBarcode": {},
	                "TapeCreatedDate": {
	                  "type": "timestamp"
	                },
	                "TapeSizeInBytes": {
	                  "type": "long"
	                },
	                "TapeStatus": {},
	                "VTLDevice": {},
	                "Progress": {
	                  "type": "double"
	                },
	                "TapeUsedInBytes": {
	                  "type": "long"
	                },
	                "KMSKey": {},
	                "PoolId": {},
	                "Worm": {
	                  "type": "boolean"
	                },
	                "RetentionStartDate": {
	                  "type": "timestamp"
	                },
	                "PoolEntryDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeUploadBuffer": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "DiskIds": {
	            "shape": "Sg"
	          },
	          "UploadBufferUsedInBytes": {
	            "type": "long"
	          },
	          "UploadBufferAllocatedInBytes": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "DescribeVTLDevices": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "VTLDeviceARNs": {
	            "type": "list",
	            "member": {}
	          },
	          "Marker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "VTLDevices": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "VTLDeviceARN": {},
	                "VTLDeviceType": {},
	                "VTLDeviceVendor": {},
	                "VTLDeviceProductIdentifier": {},
	                "DeviceiSCSIAttributes": {
	                  "type": "structure",
	                  "members": {
	                    "TargetARN": {},
	                    "NetworkInterfaceId": {},
	                    "NetworkInterfacePort": {
	                      "type": "integer"
	                    },
	                    "ChapEnabled": {
	                      "type": "boolean"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeWorkingStorage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "DiskIds": {
	            "shape": "Sg"
	          },
	          "WorkingStorageUsedInBytes": {
	            "type": "long"
	          },
	          "WorkingStorageAllocatedInBytes": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "DetachVolume": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeARN"
	        ],
	        "members": {
	          "VolumeARN": {},
	          "ForceDetach": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumeARN": {}
	        }
	      }
	    },
	    "DisableGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "DisassociateFileSystem": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemAssociationARN"
	        ],
	        "members": {
	          "FileSystemAssociationARN": {},
	          "ForceDelete": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileSystemAssociationARN": {}
	        }
	      }
	    },
	    "JoinDomain": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "DomainName",
	          "UserName",
	          "Password"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "DomainName": {},
	          "OrganizationalUnit": {},
	          "DomainControllers": {
	            "type": "list",
	            "member": {}
	          },
	          "TimeoutInSeconds": {
	            "type": "integer"
	          },
	          "UserName": {},
	          "Password": {
	            "shape": "Sx"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "ActiveDirectoryStatus": {}
	        }
	      }
	    },
	    "ListAutomaticTapeCreationPolicies": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "AutomaticTapeCreationPolicyInfos": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "AutomaticTapeCreationRules": {
	                  "shape": "S7i"
	                },
	                "GatewayARN": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListFileShares": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "NextMarker": {},
	          "FileShareInfoList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FileShareType": {},
	                "FileShareARN": {},
	                "FileShareId": {},
	                "FileShareStatus": {},
	                "GatewayARN": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListFileSystemAssociations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "Marker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "NextMarker": {},
	          "FileSystemAssociationSummaryList": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "FileSystemAssociationId": {},
	                "FileSystemAssociationARN": {},
	                "FileSystemAssociationStatus": {},
	                "GatewayARN": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListGateways": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Marker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Gateways": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "GatewayId": {},
	                "GatewayARN": {},
	                "GatewayType": {},
	                "GatewayOperationalState": {},
	                "GatewayName": {},
	                "Ec2InstanceId": {},
	                "Ec2InstanceRegion": {},
	                "HostEnvironment": {},
	                "HostEnvironmentId": {}
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListLocalDisks": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "Disks": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "DiskId": {},
	                "DiskPath": {},
	                "DiskNode": {},
	                "DiskStatus": {},
	                "DiskSizeInBytes": {
	                  "type": "long"
	                },
	                "DiskAllocationType": {},
	                "DiskAllocationResource": {},
	                "DiskAttributeList": {
	                  "type": "list",
	                  "member": {}
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "Marker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceARN": {},
	          "Marker": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "ListTapePools": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "PoolARNs": {
	            "type": "list",
	            "member": {}
	          },
	          "Marker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "PoolInfos": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PoolARN": {},
	                "PoolName": {},
	                "StorageClass": {},
	                "RetentionLockType": {},
	                "RetentionLockTimeInDays": {
	                  "type": "integer"
	                },
	                "PoolStatus": {}
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListTapes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TapeARNs": {
	            "shape": "S2x"
	          },
	          "Marker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TapeInfos": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "TapeARN": {},
	                "TapeBarcode": {},
	                "TapeSizeInBytes": {
	                  "type": "long"
	                },
	                "TapeStatus": {},
	                "GatewayARN": {},
	                "PoolId": {},
	                "RetentionStartDate": {
	                  "type": "timestamp"
	                },
	                "PoolEntryDate": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "ListVolumeInitiators": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeARN"
	        ],
	        "members": {
	          "VolumeARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Initiators": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      }
	    },
	    "ListVolumeRecoveryPoints": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "VolumeRecoveryPointInfos": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "VolumeARN": {},
	                "VolumeSizeInBytes": {
	                  "type": "long"
	                },
	                "VolumeUsageInBytes": {
	                  "type": "long"
	                },
	                "VolumeRecoveryPointTime": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListVolumes": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "Marker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "Marker": {},
	          "VolumeInfos": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "VolumeARN": {},
	                "VolumeId": {},
	                "GatewayARN": {},
	                "GatewayId": {},
	                "VolumeType": {},
	                "VolumeSizeInBytes": {
	                  "type": "long"
	                },
	                "VolumeAttachmentStatus": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "NotifyWhenUploaded": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileShareARN"
	        ],
	        "members": {
	          "FileShareARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileShareARN": {},
	          "NotificationId": {}
	        }
	      }
	    },
	    "RefreshCache": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileShareARN"
	        ],
	        "members": {
	          "FileShareARN": {},
	          "FolderList": {
	            "type": "list",
	            "member": {}
	          },
	          "Recursive": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileShareARN": {},
	          "NotificationId": {}
	        }
	      }
	    },
	    "RemoveTagsFromResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ResourceARN": {}
	        }
	      }
	    },
	    "ResetCache": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "RetrieveTapeArchive": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TapeARN",
	          "GatewayARN"
	        ],
	        "members": {
	          "TapeARN": {},
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TapeARN": {}
	        }
	      }
	    },
	    "RetrieveTapeRecoveryPoint": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TapeARN",
	          "GatewayARN"
	        ],
	        "members": {
	          "TapeARN": {},
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TapeARN": {}
	        }
	      }
	    },
	    "SetLocalConsolePassword": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "LocalConsolePassword"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "LocalConsolePassword": {
	            "type": "string",
	            "sensitive": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "SetSMBGuestPassword": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "Password"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "Password": {
	            "type": "string",
	            "sensitive": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "ShutdownGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "StartAvailabilityMonitorTest": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "StartGateway": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "UpdateAutomaticTapeCreationPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AutomaticTapeCreationRules",
	          "GatewayARN"
	        ],
	        "members": {
	          "AutomaticTapeCreationRules": {
	            "shape": "S7i"
	          },
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "UpdateBandwidthRateLimit": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "AverageUploadRateLimitInBitsPerSec": {
	            "type": "long"
	          },
	          "AverageDownloadRateLimitInBitsPerSec": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "UpdateBandwidthRateLimitSchedule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "BandwidthRateLimitIntervals"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "BandwidthRateLimitIntervals": {
	            "shape": "S3u"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "UpdateChapCredentials": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "TargetARN",
	          "SecretToAuthenticateInitiator",
	          "InitiatorName"
	        ],
	        "members": {
	          "TargetARN": {},
	          "SecretToAuthenticateInitiator": {
	            "shape": "S4m"
	          },
	          "InitiatorName": {},
	          "SecretToAuthenticateTarget": {
	            "shape": "S4m"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TargetARN": {},
	          "InitiatorName": {}
	        }
	      }
	    },
	    "UpdateFileSystemAssociation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileSystemAssociationARN"
	        ],
	        "members": {
	          "FileSystemAssociationARN": {},
	          "UserName": {},
	          "Password": {
	            "shape": "Sx"
	          },
	          "AuditDestinationARN": {},
	          "CacheAttributes": {
	            "shape": "S11"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileSystemAssociationARN": {}
	        }
	      }
	    },
	    "UpdateGatewayInformation": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "GatewayName": {},
	          "GatewayTimezone": {},
	          "CloudWatchLogGroupARN": {},
	          "GatewayCapacity": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {},
	          "GatewayName": {}
	        }
	      }
	    },
	    "UpdateGatewaySoftwareNow": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN"
	        ],
	        "members": {
	          "GatewayARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "UpdateMaintenanceStartTime": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "HourOfDay",
	          "MinuteOfHour"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "HourOfDay": {
	            "type": "integer"
	          },
	          "MinuteOfHour": {
	            "type": "integer"
	          },
	          "DayOfWeek": {
	            "type": "integer"
	          },
	          "DayOfMonth": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "UpdateNFSFileShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileShareARN"
	        ],
	        "members": {
	          "FileShareARN": {},
	          "KMSEncrypted": {
	            "type": "boolean"
	          },
	          "KMSKey": {},
	          "NFSFileShareDefaults": {
	            "shape": "S1p"
	          },
	          "DefaultStorageClass": {},
	          "ObjectACL": {},
	          "ClientList": {
	            "shape": "S1w"
	          },
	          "Squash": {},
	          "ReadOnly": {
	            "type": "boolean"
	          },
	          "GuessMIMETypeEnabled": {
	            "type": "boolean"
	          },
	          "RequesterPays": {
	            "type": "boolean"
	          },
	          "FileShareName": {},
	          "CacheAttributes": {
	            "shape": "S11"
	          },
	          "NotificationPolicy": {},
	          "AuditDestinationARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileShareARN": {}
	        }
	      }
	    },
	    "UpdateSMBFileShare": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "FileShareARN"
	        ],
	        "members": {
	          "FileShareARN": {},
	          "KMSEncrypted": {
	            "type": "boolean"
	          },
	          "KMSKey": {},
	          "DefaultStorageClass": {},
	          "ObjectACL": {},
	          "ReadOnly": {
	            "type": "boolean"
	          },
	          "GuessMIMETypeEnabled": {
	            "type": "boolean"
	          },
	          "RequesterPays": {
	            "type": "boolean"
	          },
	          "SMBACLEnabled": {
	            "type": "boolean"
	          },
	          "AccessBasedEnumeration": {
	            "type": "boolean"
	          },
	          "AdminUserList": {
	            "shape": "S25"
	          },
	          "ValidUserList": {
	            "shape": "S25"
	          },
	          "InvalidUserList": {
	            "shape": "S25"
	          },
	          "AuditDestinationARN": {},
	          "CaseSensitivity": {},
	          "FileShareName": {},
	          "CacheAttributes": {
	            "shape": "S11"
	          },
	          "NotificationPolicy": {},
	          "OplocksEnabled": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "FileShareARN": {}
	        }
	      }
	    },
	    "UpdateSMBFileShareVisibility": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "FileSharesVisible"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "FileSharesVisible": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "UpdateSMBLocalGroups": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "SMBLocalGroups"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "SMBLocalGroups": {
	            "shape": "S5y"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "UpdateSMBSecurityStrategy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GatewayARN",
	          "SMBSecurityStrategy"
	        ],
	        "members": {
	          "GatewayARN": {},
	          "SMBSecurityStrategy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GatewayARN": {}
	        }
	      }
	    },
	    "UpdateSnapshotSchedule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VolumeARN",
	          "StartAt",
	          "RecurrenceInHours"
	        ],
	        "members": {
	          "VolumeARN": {},
	          "StartAt": {
	            "type": "integer"
	          },
	          "RecurrenceInHours": {
	            "type": "integer"
	          },
	          "Description": {},
	          "Tags": {
	            "shape": "S9"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VolumeARN": {}
	        }
	      }
	    },
	    "UpdateVTLDeviceType": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "VTLDeviceARN",
	          "DeviceType"
	        ],
	        "members": {
	          "VTLDeviceARN": {},
	          "DeviceType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "VTLDeviceARN": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S9": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Sg": {
	      "type": "list",
	      "member": {}
	    },
	    "Sx": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S11": {
	      "type": "structure",
	      "members": {
	        "CacheStaleTimeoutInSeconds": {
	          "type": "integer"
	        }
	      }
	    },
	    "S13": {
	      "type": "structure",
	      "members": {
	        "IpAddresses": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S1p": {
	      "type": "structure",
	      "members": {
	        "FileMode": {},
	        "DirectoryMode": {},
	        "GroupId": {
	          "type": "long"
	        },
	        "OwnerId": {
	          "type": "long"
	        }
	      }
	    },
	    "S1w": {
	      "type": "list",
	      "member": {}
	    },
	    "S25": {
	      "type": "list",
	      "member": {}
	    },
	    "S2x": {
	      "type": "list",
	      "member": {}
	    },
	    "S3u": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "StartHourOfDay",
	          "StartMinuteOfHour",
	          "EndHourOfDay",
	          "EndMinuteOfHour",
	          "DaysOfWeek"
	        ],
	        "members": {
	          "StartHourOfDay": {
	            "type": "integer"
	          },
	          "StartMinuteOfHour": {
	            "type": "integer"
	          },
	          "EndHourOfDay": {
	            "type": "integer"
	          },
	          "EndMinuteOfHour": {
	            "type": "integer"
	          },
	          "DaysOfWeek": {
	            "type": "list",
	            "member": {
	              "type": "integer"
	            }
	          },
	          "AverageUploadRateLimitInBitsPerSec": {
	            "type": "long"
	          },
	          "AverageDownloadRateLimitInBitsPerSec": {
	            "type": "long"
	          }
	        }
	      }
	    },
	    "S44": {
	      "type": "list",
	      "member": {}
	    },
	    "S4d": {
	      "type": "structure",
	      "members": {
	        "TargetARN": {},
	        "NetworkInterfaceId": {},
	        "NetworkInterfacePort": {
	          "type": "integer"
	        },
	        "LunNumber": {
	          "type": "integer"
	        },
	        "ChapEnabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "S4m": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S5i": {
	      "type": "list",
	      "member": {}
	    },
	    "S5y": {
	      "type": "structure",
	      "members": {
	        "GatewayAdmins": {
	          "shape": "S25"
	        }
	      }
	    },
	    "S7i": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "TapeBarcodePrefix",
	          "PoolId",
	          "TapeSizeInBytes",
	          "MinimumNumTapes"
	        ],
	        "members": {
	          "TapeBarcodePrefix": {},
	          "PoolId": {},
	          "TapeSizeInBytes": {
	            "type": "long"
	          },
	          "MinimumNumTapes": {
	            "type": "integer"
	          },
	          "Worm": {
	            "type": "boolean"
	          }
	        }
	      }
	    }
	  }
	}
	},{}],227:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeCachediSCSIVolumes": {
	      "result_key": "CachediSCSIVolumes"
	    },
	    "DescribeStorediSCSIVolumes": {
	      "result_key": "StorediSCSIVolumes"
	    },
	    "DescribeTapeArchives": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "output_token": "Marker",
	      "result_key": "TapeArchives"
	    },
	    "DescribeTapeRecoveryPoints": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "output_token": "Marker",
	      "result_key": "TapeRecoveryPointInfos"
	    },
	    "DescribeTapes": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "output_token": "Marker",
	      "result_key": "Tapes"
	    },
	    "DescribeVTLDevices": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "output_token": "Marker",
	      "result_key": "VTLDevices"
	    },
	    "ListFileShares": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "non_aggregate_keys": [
	        "Marker"
	      ],
	      "output_token": "NextMarker",
	      "result_key": "FileShareInfoList"
	    },
	    "ListFileSystemAssociations": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "non_aggregate_keys": [
	        "Marker"
	      ],
	      "output_token": "NextMarker",
	      "result_key": "FileSystemAssociationSummaryList"
	    },
	    "ListGateways": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "output_token": "Marker",
	      "result_key": "Gateways"
	    },
	    "ListLocalDisks": {
	      "result_key": "Disks"
	    },
	    "ListTagsForResource": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "non_aggregate_keys": [
	        "ResourceARN"
	      ],
	      "output_token": "Marker",
	      "result_key": "Tags"
	    },
	    "ListTapePools": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "output_token": "Marker",
	      "result_key": "PoolInfos"
	    },
	    "ListTapes": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "output_token": "Marker",
	      "result_key": "TapeInfos"
	    },
	    "ListVolumeRecoveryPoints": {
	      "result_key": "VolumeRecoveryPointInfos"
	    },
	    "ListVolumes": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "output_token": "Marker",
	      "result_key": "VolumeInfos"
	    }
	  }
	}
	},{}],228:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2012-08-10",
	    "endpointPrefix": "streams.dynamodb",
	    "jsonVersion": "1.0",
	    "protocol": "json",
	    "serviceFullName": "Amazon DynamoDB Streams",
	    "serviceId": "DynamoDB Streams",
	    "signatureVersion": "v4",
	    "signingName": "dynamodb",
	    "targetPrefix": "DynamoDBStreams_20120810",
	    "uid": "streams-dynamodb-2012-08-10"
	  },
	  "operations": {
	    "DescribeStream": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamArn"
	        ],
	        "members": {
	          "StreamArn": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "ExclusiveStartShardId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StreamDescription": {
	            "type": "structure",
	            "members": {
	              "StreamArn": {},
	              "StreamLabel": {},
	              "StreamStatus": {},
	              "StreamViewType": {},
	              "CreationRequestDateTime": {
	                "type": "timestamp"
	              },
	              "TableName": {},
	              "KeySchema": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "required": [
	                    "AttributeName",
	                    "KeyType"
	                  ],
	                  "members": {
	                    "AttributeName": {},
	                    "KeyType": {}
	                  }
	                }
	              },
	              "Shards": {
	                "type": "list",
	                "member": {
	                  "type": "structure",
	                  "members": {
	                    "ShardId": {},
	                    "SequenceNumberRange": {
	                      "type": "structure",
	                      "members": {
	                        "StartingSequenceNumber": {},
	                        "EndingSequenceNumber": {}
	                      }
	                    },
	                    "ParentShardId": {}
	                  }
	                }
	              },
	              "LastEvaluatedShardId": {}
	            }
	          }
	        }
	      }
	    },
	    "GetRecords": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ShardIterator"
	        ],
	        "members": {
	          "ShardIterator": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Records": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "eventID": {},
	                "eventName": {},
	                "eventVersion": {},
	                "eventSource": {},
	                "awsRegion": {},
	                "dynamodb": {
	                  "type": "structure",
	                  "members": {
	                    "ApproximateCreationDateTime": {
	                      "type": "timestamp"
	                    },
	                    "Keys": {
	                      "shape": "Sr"
	                    },
	                    "NewImage": {
	                      "shape": "Sr"
	                    },
	                    "OldImage": {
	                      "shape": "Sr"
	                    },
	                    "SequenceNumber": {},
	                    "SizeBytes": {
	                      "type": "long"
	                    },
	                    "StreamViewType": {}
	                  }
	                },
	                "userIdentity": {
	                  "type": "structure",
	                  "members": {
	                    "PrincipalId": {},
	                    "Type": {}
	                  }
	                }
	              }
	            }
	          },
	          "NextShardIterator": {}
	        }
	      }
	    },
	    "GetShardIterator": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "StreamArn",
	          "ShardId",
	          "ShardIteratorType"
	        ],
	        "members": {
	          "StreamArn": {},
	          "ShardId": {},
	          "ShardIteratorType": {},
	          "SequenceNumber": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ShardIterator": {}
	        }
	      }
	    },
	    "ListStreams": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "TableName": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "ExclusiveStartStreamArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Streams": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "StreamArn": {},
	                "TableName": {},
	                "StreamLabel": {}
	              }
	            }
	          },
	          "LastEvaluatedStreamArn": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "Sr": {
	      "type": "map",
	      "key": {},
	      "value": {
	        "shape": "St"
	      }
	    },
	    "St": {
	      "type": "structure",
	      "members": {
	        "S": {},
	        "N": {},
	        "B": {
	          "type": "blob"
	        },
	        "SS": {
	          "type": "list",
	          "member": {}
	        },
	        "NS": {
	          "type": "list",
	          "member": {}
	        },
	        "BS": {
	          "type": "list",
	          "member": {
	            "type": "blob"
	          }
	        },
	        "M": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "shape": "St"
	          }
	        },
	        "L": {
	          "type": "list",
	          "member": {
	            "shape": "St"
	          }
	        },
	        "NULL": {
	          "type": "boolean"
	        },
	        "BOOL": {
	          "type": "boolean"
	        }
	      }
	    }
	  }
	}
	},{}],229:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],230:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2011-06-15",
	    "endpointPrefix": "sts",
	    "globalEndpoint": "sts.amazonaws.com",
	    "protocol": "query",
	    "serviceAbbreviation": "AWS STS",
	    "serviceFullName": "AWS Security Token Service",
	    "serviceId": "STS",
	    "signatureVersion": "v4",
	    "uid": "sts-2011-06-15",
	    "xmlNamespace": "https://sts.amazonaws.com/doc/2011-06-15/"
	  },
	  "operations": {
	    "AssumeRole": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleArn",
	          "RoleSessionName"
	        ],
	        "members": {
	          "RoleArn": {},
	          "RoleSessionName": {},
	          "PolicyArns": {
	            "shape": "S4"
	          },
	          "Policy": {},
	          "DurationSeconds": {
	            "type": "integer"
	          },
	          "Tags": {
	            "shape": "S8"
	          },
	          "TransitiveTagKeys": {
	            "type": "list",
	            "member": {}
	          },
	          "ExternalId": {},
	          "SerialNumber": {},
	          "TokenCode": {},
	          "SourceIdentity": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "AssumeRoleResult",
	        "type": "structure",
	        "members": {
	          "Credentials": {
	            "shape": "Si"
	          },
	          "AssumedRoleUser": {
	            "shape": "Sn"
	          },
	          "PackedPolicySize": {
	            "type": "integer"
	          },
	          "SourceIdentity": {}
	        }
	      }
	    },
	    "AssumeRoleWithSAML": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleArn",
	          "PrincipalArn",
	          "SAMLAssertion"
	        ],
	        "members": {
	          "RoleArn": {},
	          "PrincipalArn": {},
	          "SAMLAssertion": {},
	          "PolicyArns": {
	            "shape": "S4"
	          },
	          "Policy": {},
	          "DurationSeconds": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "AssumeRoleWithSAMLResult",
	        "type": "structure",
	        "members": {
	          "Credentials": {
	            "shape": "Si"
	          },
	          "AssumedRoleUser": {
	            "shape": "Sn"
	          },
	          "PackedPolicySize": {
	            "type": "integer"
	          },
	          "Subject": {},
	          "SubjectType": {},
	          "Issuer": {},
	          "Audience": {},
	          "NameQualifier": {},
	          "SourceIdentity": {}
	        }
	      }
	    },
	    "AssumeRoleWithWebIdentity": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RoleArn",
	          "RoleSessionName",
	          "WebIdentityToken"
	        ],
	        "members": {
	          "RoleArn": {},
	          "RoleSessionName": {},
	          "WebIdentityToken": {},
	          "ProviderId": {},
	          "PolicyArns": {
	            "shape": "S4"
	          },
	          "Policy": {},
	          "DurationSeconds": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "AssumeRoleWithWebIdentityResult",
	        "type": "structure",
	        "members": {
	          "Credentials": {
	            "shape": "Si"
	          },
	          "SubjectFromWebIdentityToken": {},
	          "AssumedRoleUser": {
	            "shape": "Sn"
	          },
	          "PackedPolicySize": {
	            "type": "integer"
	          },
	          "Provider": {},
	          "Audience": {},
	          "SourceIdentity": {}
	        }
	      }
	    },
	    "DecodeAuthorizationMessage": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "EncodedMessage"
	        ],
	        "members": {
	          "EncodedMessage": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "DecodeAuthorizationMessageResult",
	        "type": "structure",
	        "members": {
	          "DecodedMessage": {}
	        }
	      }
	    },
	    "GetAccessKeyInfo": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "AccessKeyId"
	        ],
	        "members": {
	          "AccessKeyId": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetAccessKeyInfoResult",
	        "type": "structure",
	        "members": {
	          "Account": {}
	        }
	      }
	    },
	    "GetCallerIdentity": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "resultWrapper": "GetCallerIdentityResult",
	        "type": "structure",
	        "members": {
	          "UserId": {},
	          "Account": {},
	          "Arn": {}
	        }
	      }
	    },
	    "GetFederationToken": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "Policy": {},
	          "PolicyArns": {
	            "shape": "S4"
	          },
	          "DurationSeconds": {
	            "type": "integer"
	          },
	          "Tags": {
	            "shape": "S8"
	          }
	        }
	      },
	      "output": {
	        "resultWrapper": "GetFederationTokenResult",
	        "type": "structure",
	        "members": {
	          "Credentials": {
	            "shape": "Si"
	          },
	          "FederatedUser": {
	            "type": "structure",
	            "required": [
	              "FederatedUserId",
	              "Arn"
	            ],
	            "members": {
	              "FederatedUserId": {},
	              "Arn": {}
	            }
	          },
	          "PackedPolicySize": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "GetSessionToken": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "DurationSeconds": {
	            "type": "integer"
	          },
	          "SerialNumber": {},
	          "TokenCode": {}
	        }
	      },
	      "output": {
	        "resultWrapper": "GetSessionTokenResult",
	        "type": "structure",
	        "members": {
	          "Credentials": {
	            "shape": "Si"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "arn": {}
	        }
	      }
	    },
	    "S8": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "Si": {
	      "type": "structure",
	      "required": [
	        "AccessKeyId",
	        "SecretAccessKey",
	        "SessionToken",
	        "Expiration"
	      ],
	      "members": {
	        "AccessKeyId": {},
	        "SecretAccessKey": {},
	        "SessionToken": {},
	        "Expiration": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "Sn": {
	      "type": "structure",
	      "required": [
	        "AssumedRoleId",
	        "Arn"
	      ],
	      "members": {
	        "AssumedRoleId": {},
	        "Arn": {}
	      }
	    }
	  }
	}
	},{}],231:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],232:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2017-07-01",
	    "endpointPrefix": "translate",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceFullName": "Amazon Translate",
	    "serviceId": "Translate",
	    "signatureVersion": "v4",
	    "signingName": "translate",
	    "targetPrefix": "AWSShineFrontendService_20170701",
	    "uid": "translate-2017-07-01"
	  },
	  "operations": {
	    "CreateParallelData": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ParallelDataConfig",
	          "ClientToken"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "ParallelDataConfig": {
	            "shape": "S4"
	          },
	          "EncryptionKey": {
	            "shape": "S7"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Status": {}
	        }
	      }
	    },
	    "DeleteParallelData": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Status": {}
	        }
	      }
	    },
	    "DeleteTerminology": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      }
	    },
	    "DescribeTextTranslationJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TextTranslationJobProperties": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "GetParallelData": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ParallelDataProperties": {
	            "shape": "S12"
	          },
	          "DataLocation": {
	            "shape": "S16"
	          },
	          "AuxiliaryDataLocation": {
	            "shape": "S16"
	          },
	          "LatestUpdateAttemptAuxiliaryDataLocation": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "GetTerminology": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name"
	        ],
	        "members": {
	          "Name": {},
	          "TerminologyDataFormat": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TerminologyProperties": {
	            "shape": "S1b"
	          },
	          "TerminologyDataLocation": {
	            "shape": "S1e"
	          },
	          "AuxiliaryDataLocation": {
	            "shape": "S1e"
	          }
	        }
	      }
	    },
	    "ImportTerminology": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "MergeStrategy",
	          "TerminologyData"
	        ],
	        "members": {
	          "Name": {},
	          "MergeStrategy": {},
	          "Description": {},
	          "TerminologyData": {
	            "type": "structure",
	            "required": [
	              "File",
	              "Format"
	            ],
	            "members": {
	              "File": {
	                "type": "blob",
	                "sensitive": true
	              },
	              "Format": {},
	              "Directionality": {}
	            }
	          },
	          "EncryptionKey": {
	            "shape": "S7"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TerminologyProperties": {
	            "shape": "S1b"
	          },
	          "AuxiliaryDataLocation": {
	            "shape": "S1e"
	          }
	        }
	      }
	    },
	    "ListParallelData": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ParallelDataPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S12"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTerminologies": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TerminologyPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "S1b"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTextTranslationJobs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "Filter": {
	            "type": "structure",
	            "members": {
	              "JobName": {},
	              "JobStatus": {},
	              "SubmittedBeforeTime": {
	                "type": "timestamp"
	              },
	              "SubmittedAfterTime": {
	                "type": "timestamp"
	              }
	            }
	          },
	          "NextToken": {},
	          "MaxResults": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TextTranslationJobPropertiesList": {
	            "type": "list",
	            "member": {
	              "shape": "Sj"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "StartTextTranslationJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "InputDataConfig",
	          "OutputDataConfig",
	          "DataAccessRoleArn",
	          "SourceLanguageCode",
	          "TargetLanguageCodes",
	          "ClientToken"
	        ],
	        "members": {
	          "JobName": {},
	          "InputDataConfig": {
	            "shape": "St"
	          },
	          "OutputDataConfig": {
	            "shape": "Sv"
	          },
	          "DataAccessRoleArn": {},
	          "SourceLanguageCode": {},
	          "TargetLanguageCodes": {
	            "shape": "Sp"
	          },
	          "TerminologyNames": {
	            "shape": "Sq"
	          },
	          "ParallelDataNames": {
	            "shape": "Sq"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          },
	          "Settings": {
	            "shape": "Sx"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "StopTextTranslationJob": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "JobId"
	        ],
	        "members": {
	          "JobId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "JobId": {},
	          "JobStatus": {}
	        }
	      }
	    },
	    "TranslateText": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Text",
	          "SourceLanguageCode",
	          "TargetLanguageCode"
	        ],
	        "members": {
	          "Text": {},
	          "TerminologyNames": {
	            "shape": "Sq"
	          },
	          "SourceLanguageCode": {},
	          "TargetLanguageCode": {},
	          "Settings": {
	            "shape": "Sx"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "TranslatedText",
	          "SourceLanguageCode",
	          "TargetLanguageCode"
	        ],
	        "members": {
	          "TranslatedText": {},
	          "SourceLanguageCode": {},
	          "TargetLanguageCode": {},
	          "AppliedTerminologies": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Name": {},
	                "Terms": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "SourceText": {},
	                      "TargetText": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "AppliedSettings": {
	            "shape": "Sx"
	          }
	        }
	      }
	    },
	    "UpdateParallelData": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ParallelDataConfig",
	          "ClientToken"
	        ],
	        "members": {
	          "Name": {},
	          "Description": {},
	          "ParallelDataConfig": {
	            "shape": "S4"
	          },
	          "ClientToken": {
	            "idempotencyToken": true
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Status": {},
	          "LatestUpdateAttemptStatus": {},
	          "LatestUpdateAttemptAt": {
	            "type": "timestamp"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S4": {
	      "type": "structure",
	      "required": [
	        "S3Uri",
	        "Format"
	      ],
	      "members": {
	        "S3Uri": {},
	        "Format": {}
	      }
	    },
	    "S7": {
	      "type": "structure",
	      "required": [
	        "Type",
	        "Id"
	      ],
	      "members": {
	        "Type": {},
	        "Id": {}
	      }
	    },
	    "Sj": {
	      "type": "structure",
	      "members": {
	        "JobId": {},
	        "JobName": {},
	        "JobStatus": {},
	        "JobDetails": {
	          "type": "structure",
	          "members": {
	            "TranslatedDocumentsCount": {
	              "type": "integer"
	            },
	            "DocumentsWithErrorsCount": {
	              "type": "integer"
	            },
	            "InputDocumentsCount": {
	              "type": "integer"
	            }
	          }
	        },
	        "SourceLanguageCode": {},
	        "TargetLanguageCodes": {
	          "shape": "Sp"
	        },
	        "TerminologyNames": {
	          "shape": "Sq"
	        },
	        "ParallelDataNames": {
	          "shape": "Sq"
	        },
	        "Message": {},
	        "SubmittedTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        },
	        "InputDataConfig": {
	          "shape": "St"
	        },
	        "OutputDataConfig": {
	          "shape": "Sv"
	        },
	        "DataAccessRoleArn": {},
	        "Settings": {
	          "shape": "Sx"
	        }
	      }
	    },
	    "Sp": {
	      "type": "list",
	      "member": {}
	    },
	    "Sq": {
	      "type": "list",
	      "member": {}
	    },
	    "St": {
	      "type": "structure",
	      "required": [
	        "S3Uri",
	        "ContentType"
	      ],
	      "members": {
	        "S3Uri": {},
	        "ContentType": {}
	      }
	    },
	    "Sv": {
	      "type": "structure",
	      "required": [
	        "S3Uri"
	      ],
	      "members": {
	        "S3Uri": {},
	        "EncryptionKey": {
	          "shape": "S7"
	        }
	      }
	    },
	    "Sx": {
	      "type": "structure",
	      "members": {
	        "Formality": {},
	        "Profanity": {}
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Arn": {},
	        "Description": {},
	        "Status": {},
	        "SourceLanguageCode": {},
	        "TargetLanguageCodes": {
	          "shape": "S14"
	        },
	        "ParallelDataConfig": {
	          "shape": "S4"
	        },
	        "Message": {},
	        "ImportedDataSize": {
	          "type": "long"
	        },
	        "ImportedRecordCount": {
	          "type": "long"
	        },
	        "FailedRecordCount": {
	          "type": "long"
	        },
	        "SkippedRecordCount": {
	          "type": "long"
	        },
	        "EncryptionKey": {
	          "shape": "S7"
	        },
	        "CreatedAt": {
	          "type": "timestamp"
	        },
	        "LastUpdatedAt": {
	          "type": "timestamp"
	        },
	        "LatestUpdateAttemptStatus": {},
	        "LatestUpdateAttemptAt": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S14": {
	      "type": "list",
	      "member": {}
	    },
	    "S16": {
	      "type": "structure",
	      "required": [
	        "RepositoryType",
	        "Location"
	      ],
	      "members": {
	        "RepositoryType": {},
	        "Location": {}
	      }
	    },
	    "S1b": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Description": {},
	        "Arn": {},
	        "SourceLanguageCode": {},
	        "TargetLanguageCodes": {
	          "shape": "S14"
	        },
	        "EncryptionKey": {
	          "shape": "S7"
	        },
	        "SizeBytes": {
	          "type": "integer"
	        },
	        "TermCount": {
	          "type": "integer"
	        },
	        "CreatedAt": {
	          "type": "timestamp"
	        },
	        "LastUpdatedAt": {
	          "type": "timestamp"
	        },
	        "Directionality": {},
	        "Message": {},
	        "SkippedTermCount": {
	          "type": "integer"
	        },
	        "Format": {}
	      }
	    },
	    "S1e": {
	      "type": "structure",
	      "required": [
	        "RepositoryType",
	        "Location"
	      ],
	      "members": {
	        "RepositoryType": {},
	        "Location": {}
	      }
	    }
	  }
	}
	},{}],233:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "ListParallelData": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListTerminologies": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "ListTextTranslationJobs": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    }
	  }
	}
	},{}],234:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2015-08-24",
	    "endpointPrefix": "waf",
	    "jsonVersion": "1.1",
	    "protocol": "json",
	    "serviceAbbreviation": "WAF",
	    "serviceFullName": "AWS WAF",
	    "serviceId": "WAF",
	    "signatureVersion": "v4",
	    "targetPrefix": "AWSWAF_20150824",
	    "uid": "waf-2015-08-24"
	  },
	  "operations": {
	    "CreateByteMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ByteMatchSet": {
	            "shape": "S5"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "CreateGeoMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GeoMatchSet": {
	            "shape": "Sh"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "CreateIPSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IPSet": {
	            "shape": "So"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "CreateRateBasedRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "MetricName",
	          "RateKey",
	          "RateLimit",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "MetricName": {},
	          "RateKey": {},
	          "RateLimit": {
	            "type": "long"
	          },
	          "ChangeToken": {},
	          "Tags": {
	            "shape": "Sx"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Rule": {
	            "shape": "S12"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "CreateRegexMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RegexMatchSet": {
	            "shape": "S19"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "CreateRegexPatternSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RegexPatternSet": {
	            "shape": "S1e"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "CreateRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "MetricName",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "MetricName": {},
	          "ChangeToken": {},
	          "Tags": {
	            "shape": "Sx"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Rule": {
	            "shape": "S1j"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "CreateRuleGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "MetricName",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "MetricName": {},
	          "ChangeToken": {},
	          "Tags": {
	            "shape": "Sx"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RuleGroup": {
	            "shape": "S1m"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "CreateSizeConstraintSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SizeConstraintSet": {
	            "shape": "S1p"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "CreateSqlInjectionMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SqlInjectionMatchSet": {
	            "shape": "S1w"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "CreateWebACL": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "MetricName",
	          "DefaultAction",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "MetricName": {},
	          "DefaultAction": {
	            "shape": "S20"
	          },
	          "ChangeToken": {},
	          "Tags": {
	            "shape": "Sx"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WebACL": {
	            "shape": "S23"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "CreateWebACLMigrationStack": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebACLId",
	          "S3BucketName",
	          "IgnoreUnsupportedType"
	        ],
	        "members": {
	          "WebACLId": {},
	          "S3BucketName": {},
	          "IgnoreUnsupportedType": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "required": [
	          "S3ObjectUrl"
	        ],
	        "members": {
	          "S3ObjectUrl": {}
	        }
	      }
	    },
	    "CreateXssMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "Name",
	          "ChangeToken"
	        ],
	        "members": {
	          "Name": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "XssMatchSet": {
	            "shape": "S2k"
	          },
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteByteMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ByteMatchSetId",
	          "ChangeToken"
	        ],
	        "members": {
	          "ByteMatchSetId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteGeoMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GeoMatchSetId",
	          "ChangeToken"
	        ],
	        "members": {
	          "GeoMatchSetId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteIPSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IPSetId",
	          "ChangeToken"
	        ],
	        "members": {
	          "IPSetId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteLoggingConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeletePermissionPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteRateBasedRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleId",
	          "ChangeToken"
	        ],
	        "members": {
	          "RuleId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteRegexMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RegexMatchSetId",
	          "ChangeToken"
	        ],
	        "members": {
	          "RegexMatchSetId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteRegexPatternSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RegexPatternSetId",
	          "ChangeToken"
	        ],
	        "members": {
	          "RegexPatternSetId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleId",
	          "ChangeToken"
	        ],
	        "members": {
	          "RuleId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteRuleGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleGroupId",
	          "ChangeToken"
	        ],
	        "members": {
	          "RuleGroupId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteSizeConstraintSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SizeConstraintSetId",
	          "ChangeToken"
	        ],
	        "members": {
	          "SizeConstraintSetId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteSqlInjectionMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SqlInjectionMatchSetId",
	          "ChangeToken"
	        ],
	        "members": {
	          "SqlInjectionMatchSetId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteWebACL": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebACLId",
	          "ChangeToken"
	        ],
	        "members": {
	          "WebACLId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "DeleteXssMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "XssMatchSetId",
	          "ChangeToken"
	        ],
	        "members": {
	          "XssMatchSetId": {},
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "GetByteMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ByteMatchSetId"
	        ],
	        "members": {
	          "ByteMatchSetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ByteMatchSet": {
	            "shape": "S5"
	          }
	        }
	      }
	    },
	    "GetChangeToken": {
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "GetChangeTokenStatus": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ChangeToken"
	        ],
	        "members": {
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeTokenStatus": {}
	        }
	      }
	    },
	    "GetGeoMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GeoMatchSetId"
	        ],
	        "members": {
	          "GeoMatchSetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "GeoMatchSet": {
	            "shape": "Sh"
	          }
	        }
	      }
	    },
	    "GetIPSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IPSetId"
	        ],
	        "members": {
	          "IPSetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "IPSet": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "GetLoggingConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LoggingConfiguration": {
	            "shape": "S3s"
	          }
	        }
	      }
	    },
	    "GetPermissionPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn"
	        ],
	        "members": {
	          "ResourceArn": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Policy": {}
	        }
	      }
	    },
	    "GetRateBasedRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleId"
	        ],
	        "members": {
	          "RuleId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Rule": {
	            "shape": "S12"
	          }
	        }
	      }
	    },
	    "GetRateBasedRuleManagedKeys": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleId"
	        ],
	        "members": {
	          "RuleId": {},
	          "NextMarker": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ManagedKeys": {
	            "type": "list",
	            "member": {}
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "GetRegexMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RegexMatchSetId"
	        ],
	        "members": {
	          "RegexMatchSetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RegexMatchSet": {
	            "shape": "S19"
	          }
	        }
	      }
	    },
	    "GetRegexPatternSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RegexPatternSetId"
	        ],
	        "members": {
	          "RegexPatternSetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RegexPatternSet": {
	            "shape": "S1e"
	          }
	        }
	      }
	    },
	    "GetRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleId"
	        ],
	        "members": {
	          "RuleId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Rule": {
	            "shape": "S1j"
	          }
	        }
	      }
	    },
	    "GetRuleGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleGroupId"
	        ],
	        "members": {
	          "RuleGroupId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "RuleGroup": {
	            "shape": "S1m"
	          }
	        }
	      }
	    },
	    "GetSampledRequests": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebAclId",
	          "RuleId",
	          "TimeWindow",
	          "MaxItems"
	        ],
	        "members": {
	          "WebAclId": {},
	          "RuleId": {},
	          "TimeWindow": {
	            "shape": "S4e"
	          },
	          "MaxItems": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SampledRequests": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Request",
	                "Weight"
	              ],
	              "members": {
	                "Request": {
	                  "type": "structure",
	                  "members": {
	                    "ClientIP": {},
	                    "Country": {},
	                    "URI": {},
	                    "Method": {},
	                    "HTTPVersion": {},
	                    "Headers": {
	                      "type": "list",
	                      "member": {
	                        "type": "structure",
	                        "members": {
	                          "Name": {},
	                          "Value": {}
	                        }
	                      }
	                    }
	                  }
	                },
	                "Weight": {
	                  "type": "long"
	                },
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "Action": {},
	                "RuleWithinRuleGroup": {}
	              }
	            }
	          },
	          "PopulationSize": {
	            "type": "long"
	          },
	          "TimeWindow": {
	            "shape": "S4e"
	          }
	        }
	      }
	    },
	    "GetSizeConstraintSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SizeConstraintSetId"
	        ],
	        "members": {
	          "SizeConstraintSetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SizeConstraintSet": {
	            "shape": "S1p"
	          }
	        }
	      }
	    },
	    "GetSqlInjectionMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SqlInjectionMatchSetId"
	        ],
	        "members": {
	          "SqlInjectionMatchSetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SqlInjectionMatchSet": {
	            "shape": "S1w"
	          }
	        }
	      }
	    },
	    "GetWebACL": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebACLId"
	        ],
	        "members": {
	          "WebACLId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "WebACL": {
	            "shape": "S23"
	          }
	        }
	      }
	    },
	    "GetXssMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "XssMatchSetId"
	        ],
	        "members": {
	          "XssMatchSetId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "XssMatchSet": {
	            "shape": "S2k"
	          }
	        }
	      }
	    },
	    "ListActivatedRulesInRuleGroup": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "RuleGroupId": {},
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "ActivatedRules": {
	            "shape": "S24"
	          }
	        }
	      }
	    },
	    "ListByteMatchSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "ByteMatchSets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "ByteMatchSetId",
	                "Name"
	              ],
	              "members": {
	                "ByteMatchSetId": {},
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListGeoMatchSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "GeoMatchSets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "GeoMatchSetId",
	                "Name"
	              ],
	              "members": {
	                "GeoMatchSetId": {},
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListIPSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "IPSets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "IPSetId",
	                "Name"
	              ],
	              "members": {
	                "IPSetId": {},
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListLoggingConfigurations": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LoggingConfigurations": {
	            "type": "list",
	            "member": {
	              "shape": "S3s"
	            }
	          },
	          "NextMarker": {}
	        }
	      }
	    },
	    "ListRateBasedRules": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Rules": {
	            "shape": "S5p"
	          }
	        }
	      }
	    },
	    "ListRegexMatchSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "RegexMatchSets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "RegexMatchSetId",
	                "Name"
	              ],
	              "members": {
	                "RegexMatchSetId": {},
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListRegexPatternSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "RegexPatternSets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "RegexPatternSetId",
	                "Name"
	              ],
	              "members": {
	                "RegexPatternSetId": {},
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListRuleGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "RuleGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "RuleGroupId",
	                "Name"
	              ],
	              "members": {
	                "RuleGroupId": {},
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListRules": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Rules": {
	            "shape": "S5p"
	          }
	        }
	      }
	    },
	    "ListSizeConstraintSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "SizeConstraintSets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "SizeConstraintSetId",
	                "Name"
	              ],
	              "members": {
	                "SizeConstraintSetId": {},
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListSqlInjectionMatchSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "SqlInjectionMatchSets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "SqlInjectionMatchSetId",
	                "Name"
	              ],
	              "members": {
	                "SqlInjectionMatchSetId": {},
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListSubscribedRuleGroups": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "RuleGroups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "RuleGroupId",
	                "Name",
	                "MetricName"
	              ],
	              "members": {
	                "RuleGroupId": {},
	                "Name": {},
	                "MetricName": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN"
	        ],
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          },
	          "ResourceARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "TagInfoForResource": {
	            "type": "structure",
	            "members": {
	              "ResourceARN": {},
	              "TagList": {
	                "shape": "Sx"
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListWebACLs": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "WebACLs": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "WebACLId",
	                "Name"
	              ],
	              "members": {
	                "WebACLId": {},
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "ListXssMatchSets": {
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "Limit": {
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "NextMarker": {},
	          "XssMatchSets": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "XssMatchSetId",
	                "Name"
	              ],
	              "members": {
	                "XssMatchSetId": {},
	                "Name": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "PutLoggingConfiguration": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "LoggingConfiguration"
	        ],
	        "members": {
	          "LoggingConfiguration": {
	            "shape": "S3s"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "LoggingConfiguration": {
	            "shape": "S3s"
	          }
	        }
	      }
	    },
	    "PutPermissionPolicy": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceArn",
	          "Policy"
	        ],
	        "members": {
	          "ResourceArn": {},
	          "Policy": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "TagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "Tags"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "Tags": {
	            "shape": "Sx"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateByteMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "ByteMatchSetId",
	          "ChangeToken",
	          "Updates"
	        ],
	        "members": {
	          "ByteMatchSetId": {},
	          "ChangeToken": {},
	          "Updates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Action",
	                "ByteMatchTuple"
	              ],
	              "members": {
	                "Action": {},
	                "ByteMatchTuple": {
	                  "shape": "S8"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "UpdateGeoMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "GeoMatchSetId",
	          "ChangeToken",
	          "Updates"
	        ],
	        "members": {
	          "GeoMatchSetId": {},
	          "ChangeToken": {},
	          "Updates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Action",
	                "GeoMatchConstraint"
	              ],
	              "members": {
	                "Action": {},
	                "GeoMatchConstraint": {
	                  "shape": "Sj"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "UpdateIPSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "IPSetId",
	          "ChangeToken",
	          "Updates"
	        ],
	        "members": {
	          "IPSetId": {},
	          "ChangeToken": {},
	          "Updates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Action",
	                "IPSetDescriptor"
	              ],
	              "members": {
	                "Action": {},
	                "IPSetDescriptor": {
	                  "shape": "Sq"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "UpdateRateBasedRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleId",
	          "ChangeToken",
	          "Updates",
	          "RateLimit"
	        ],
	        "members": {
	          "RuleId": {},
	          "ChangeToken": {},
	          "Updates": {
	            "shape": "S7f"
	          },
	          "RateLimit": {
	            "type": "long"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "UpdateRegexMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RegexMatchSetId",
	          "Updates",
	          "ChangeToken"
	        ],
	        "members": {
	          "RegexMatchSetId": {},
	          "Updates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Action",
	                "RegexMatchTuple"
	              ],
	              "members": {
	                "Action": {},
	                "RegexMatchTuple": {
	                  "shape": "S1b"
	                }
	              }
	            }
	          },
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "UpdateRegexPatternSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RegexPatternSetId",
	          "Updates",
	          "ChangeToken"
	        ],
	        "members": {
	          "RegexPatternSetId": {},
	          "Updates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Action",
	                "RegexPatternString"
	              ],
	              "members": {
	                "Action": {},
	                "RegexPatternString": {}
	              }
	            }
	          },
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "UpdateRule": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleId",
	          "ChangeToken",
	          "Updates"
	        ],
	        "members": {
	          "RuleId": {},
	          "ChangeToken": {},
	          "Updates": {
	            "shape": "S7f"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "UpdateRuleGroup": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "RuleGroupId",
	          "Updates",
	          "ChangeToken"
	        ],
	        "members": {
	          "RuleGroupId": {},
	          "Updates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Action",
	                "ActivatedRule"
	              ],
	              "members": {
	                "Action": {},
	                "ActivatedRule": {
	                  "shape": "S25"
	                }
	              }
	            }
	          },
	          "ChangeToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "UpdateSizeConstraintSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SizeConstraintSetId",
	          "ChangeToken",
	          "Updates"
	        ],
	        "members": {
	          "SizeConstraintSetId": {},
	          "ChangeToken": {},
	          "Updates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Action",
	                "SizeConstraint"
	              ],
	              "members": {
	                "Action": {},
	                "SizeConstraint": {
	                  "shape": "S1r"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "UpdateSqlInjectionMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "SqlInjectionMatchSetId",
	          "ChangeToken",
	          "Updates"
	        ],
	        "members": {
	          "SqlInjectionMatchSetId": {},
	          "ChangeToken": {},
	          "Updates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Action",
	                "SqlInjectionMatchTuple"
	              ],
	              "members": {
	                "Action": {},
	                "SqlInjectionMatchTuple": {
	                  "shape": "S1y"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "UpdateWebACL": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "WebACLId",
	          "ChangeToken"
	        ],
	        "members": {
	          "WebACLId": {},
	          "ChangeToken": {},
	          "Updates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Action",
	                "ActivatedRule"
	              ],
	              "members": {
	                "Action": {},
	                "ActivatedRule": {
	                  "shape": "S25"
	                }
	              }
	            }
	          },
	          "DefaultAction": {
	            "shape": "S20"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    },
	    "UpdateXssMatchSet": {
	      "input": {
	        "type": "structure",
	        "required": [
	          "XssMatchSetId",
	          "ChangeToken",
	          "Updates"
	        ],
	        "members": {
	          "XssMatchSetId": {},
	          "ChangeToken": {},
	          "Updates": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Action",
	                "XssMatchTuple"
	              ],
	              "members": {
	                "Action": {},
	                "XssMatchTuple": {
	                  "shape": "S2m"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ChangeToken": {}
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S5": {
	      "type": "structure",
	      "required": [
	        "ByteMatchSetId",
	        "ByteMatchTuples"
	      ],
	      "members": {
	        "ByteMatchSetId": {},
	        "Name": {},
	        "ByteMatchTuples": {
	          "type": "list",
	          "member": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "S8": {
	      "type": "structure",
	      "required": [
	        "FieldToMatch",
	        "TargetString",
	        "TextTransformation",
	        "PositionalConstraint"
	      ],
	      "members": {
	        "FieldToMatch": {
	          "shape": "S9"
	        },
	        "TargetString": {
	          "type": "blob"
	        },
	        "TextTransformation": {},
	        "PositionalConstraint": {}
	      }
	    },
	    "S9": {
	      "type": "structure",
	      "required": [
	        "Type"
	      ],
	      "members": {
	        "Type": {},
	        "Data": {}
	      }
	    },
	    "Sh": {
	      "type": "structure",
	      "required": [
	        "GeoMatchSetId",
	        "GeoMatchConstraints"
	      ],
	      "members": {
	        "GeoMatchSetId": {},
	        "Name": {},
	        "GeoMatchConstraints": {
	          "type": "list",
	          "member": {
	            "shape": "Sj"
	          }
	        }
	      }
	    },
	    "Sj": {
	      "type": "structure",
	      "required": [
	        "Type",
	        "Value"
	      ],
	      "members": {
	        "Type": {},
	        "Value": {}
	      }
	    },
	    "So": {
	      "type": "structure",
	      "required": [
	        "IPSetId",
	        "IPSetDescriptors"
	      ],
	      "members": {
	        "IPSetId": {},
	        "Name": {},
	        "IPSetDescriptors": {
	          "type": "list",
	          "member": {
	            "shape": "Sq"
	          }
	        }
	      }
	    },
	    "Sq": {
	      "type": "structure",
	      "required": [
	        "Type",
	        "Value"
	      ],
	      "members": {
	        "Type": {},
	        "Value": {}
	      }
	    },
	    "Sx": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "S12": {
	      "type": "structure",
	      "required": [
	        "RuleId",
	        "MatchPredicates",
	        "RateKey",
	        "RateLimit"
	      ],
	      "members": {
	        "RuleId": {},
	        "Name": {},
	        "MetricName": {},
	        "MatchPredicates": {
	          "shape": "S13"
	        },
	        "RateKey": {},
	        "RateLimit": {
	          "type": "long"
	        }
	      }
	    },
	    "S13": {
	      "type": "list",
	      "member": {
	        "shape": "S14"
	      }
	    },
	    "S14": {
	      "type": "structure",
	      "required": [
	        "Negated",
	        "Type",
	        "DataId"
	      ],
	      "members": {
	        "Negated": {
	          "type": "boolean"
	        },
	        "Type": {},
	        "DataId": {}
	      }
	    },
	    "S19": {
	      "type": "structure",
	      "members": {
	        "RegexMatchSetId": {},
	        "Name": {},
	        "RegexMatchTuples": {
	          "type": "list",
	          "member": {
	            "shape": "S1b"
	          }
	        }
	      }
	    },
	    "S1b": {
	      "type": "structure",
	      "required": [
	        "FieldToMatch",
	        "TextTransformation",
	        "RegexPatternSetId"
	      ],
	      "members": {
	        "FieldToMatch": {
	          "shape": "S9"
	        },
	        "TextTransformation": {},
	        "RegexPatternSetId": {}
	      }
	    },
	    "S1e": {
	      "type": "structure",
	      "required": [
	        "RegexPatternSetId",
	        "RegexPatternStrings"
	      ],
	      "members": {
	        "RegexPatternSetId": {},
	        "Name": {},
	        "RegexPatternStrings": {
	          "type": "list",
	          "member": {}
	        }
	      }
	    },
	    "S1j": {
	      "type": "structure",
	      "required": [
	        "RuleId",
	        "Predicates"
	      ],
	      "members": {
	        "RuleId": {},
	        "Name": {},
	        "MetricName": {},
	        "Predicates": {
	          "shape": "S13"
	        }
	      }
	    },
	    "S1m": {
	      "type": "structure",
	      "required": [
	        "RuleGroupId"
	      ],
	      "members": {
	        "RuleGroupId": {},
	        "Name": {},
	        "MetricName": {}
	      }
	    },
	    "S1p": {
	      "type": "structure",
	      "required": [
	        "SizeConstraintSetId",
	        "SizeConstraints"
	      ],
	      "members": {
	        "SizeConstraintSetId": {},
	        "Name": {},
	        "SizeConstraints": {
	          "type": "list",
	          "member": {
	            "shape": "S1r"
	          }
	        }
	      }
	    },
	    "S1r": {
	      "type": "structure",
	      "required": [
	        "FieldToMatch",
	        "TextTransformation",
	        "ComparisonOperator",
	        "Size"
	      ],
	      "members": {
	        "FieldToMatch": {
	          "shape": "S9"
	        },
	        "TextTransformation": {},
	        "ComparisonOperator": {},
	        "Size": {
	          "type": "long"
	        }
	      }
	    },
	    "S1w": {
	      "type": "structure",
	      "required": [
	        "SqlInjectionMatchSetId",
	        "SqlInjectionMatchTuples"
	      ],
	      "members": {
	        "SqlInjectionMatchSetId": {},
	        "Name": {},
	        "SqlInjectionMatchTuples": {
	          "type": "list",
	          "member": {
	            "shape": "S1y"
	          }
	        }
	      }
	    },
	    "S1y": {
	      "type": "structure",
	      "required": [
	        "FieldToMatch",
	        "TextTransformation"
	      ],
	      "members": {
	        "FieldToMatch": {
	          "shape": "S9"
	        },
	        "TextTransformation": {}
	      }
	    },
	    "S20": {
	      "type": "structure",
	      "required": [
	        "Type"
	      ],
	      "members": {
	        "Type": {}
	      }
	    },
	    "S23": {
	      "type": "structure",
	      "required": [
	        "WebACLId",
	        "DefaultAction",
	        "Rules"
	      ],
	      "members": {
	        "WebACLId": {},
	        "Name": {},
	        "MetricName": {},
	        "DefaultAction": {
	          "shape": "S20"
	        },
	        "Rules": {
	          "shape": "S24"
	        },
	        "WebACLArn": {}
	      }
	    },
	    "S24": {
	      "type": "list",
	      "member": {
	        "shape": "S25"
	      }
	    },
	    "S25": {
	      "type": "structure",
	      "required": [
	        "Priority",
	        "RuleId"
	      ],
	      "members": {
	        "Priority": {
	          "type": "integer"
	        },
	        "RuleId": {},
	        "Action": {
	          "shape": "S20"
	        },
	        "OverrideAction": {
	          "type": "structure",
	          "required": [
	            "Type"
	          ],
	          "members": {
	            "Type": {}
	          }
	        },
	        "Type": {},
	        "ExcludedRules": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "required": [
	              "RuleId"
	            ],
	            "members": {
	              "RuleId": {}
	            }
	          }
	        }
	      }
	    },
	    "S2k": {
	      "type": "structure",
	      "required": [
	        "XssMatchSetId",
	        "XssMatchTuples"
	      ],
	      "members": {
	        "XssMatchSetId": {},
	        "Name": {},
	        "XssMatchTuples": {
	          "type": "list",
	          "member": {
	            "shape": "S2m"
	          }
	        }
	      }
	    },
	    "S2m": {
	      "type": "structure",
	      "required": [
	        "FieldToMatch",
	        "TextTransformation"
	      ],
	      "members": {
	        "FieldToMatch": {
	          "shape": "S9"
	        },
	        "TextTransformation": {}
	      }
	    },
	    "S3s": {
	      "type": "structure",
	      "required": [
	        "ResourceArn",
	        "LogDestinationConfigs"
	      ],
	      "members": {
	        "ResourceArn": {},
	        "LogDestinationConfigs": {
	          "type": "list",
	          "member": {}
	        },
	        "RedactedFields": {
	          "type": "list",
	          "member": {
	            "shape": "S9"
	          }
	        }
	      }
	    },
	    "S4e": {
	      "type": "structure",
	      "required": [
	        "StartTime",
	        "EndTime"
	      ],
	      "members": {
	        "StartTime": {
	          "type": "timestamp"
	        },
	        "EndTime": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S5p": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "RuleId",
	          "Name"
	        ],
	        "members": {
	          "RuleId": {},
	          "Name": {}
	        }
	      }
	    },
	    "S7f": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Action",
	          "Predicate"
	        ],
	        "members": {
	          "Action": {},
	          "Predicate": {
	            "shape": "S14"
	          }
	        }
	      }
	    }
	  }
	}
	},{}],235:[function(require,module,exports){
	arguments[4][39][0].apply(exports,arguments)
	},{"dup":39}],236:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2016-05-01",
	    "endpointPrefix": "workdocs",
	    "jsonVersion": "1.1",
	    "protocol": "rest-json",
	    "serviceFullName": "Amazon WorkDocs",
	    "serviceId": "WorkDocs",
	    "signatureVersion": "v4",
	    "uid": "workdocs-2016-05-01"
	  },
	  "operations": {
	    "AbortDocumentVersionUpload": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentId",
	          "VersionId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "DocumentId": {
	            "location": "uri",
	            "locationName": "DocumentId"
	          },
	          "VersionId": {
	            "location": "uri",
	            "locationName": "VersionId"
	          }
	        }
	      }
	    },
	    "ActivateUser": {
	      "http": {
	        "requestUri": "/api/v1/users/{UserId}/activation",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserId"
	        ],
	        "members": {
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          },
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "User": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "AddResourcePermissions": {
	      "http": {
	        "requestUri": "/api/v1/resources/{ResourceId}/permissions",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "Principals"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          },
	          "Principals": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Id",
	                "Type",
	                "Role"
	              ],
	              "members": {
	                "Id": {},
	                "Type": {},
	                "Role": {}
	              }
	            }
	          },
	          "NotificationOptions": {
	            "type": "structure",
	            "members": {
	              "SendEmail": {
	                "type": "boolean"
	              },
	              "EmailMessage": {
	                "shape": "St"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "ShareResults": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "PrincipalId": {},
	                "InviteePrincipalId": {},
	                "Role": {},
	                "Status": {},
	                "ShareId": {},
	                "StatusMessage": {
	                  "shape": "St"
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    "CreateComment": {
	      "http": {
	        "requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comment",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentId",
	          "VersionId",
	          "Text"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "DocumentId": {
	            "location": "uri",
	            "locationName": "DocumentId"
	          },
	          "VersionId": {
	            "location": "uri",
	            "locationName": "VersionId"
	          },
	          "ParentId": {},
	          "ThreadId": {},
	          "Text": {
	            "shape": "S10"
	          },
	          "Visibility": {},
	          "NotifyCollaborators": {
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Comment": {
	            "shape": "S13"
	          }
	        }
	      }
	    },
	    "CreateCustomMetadata": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/api/v1/resources/{ResourceId}/customMetadata",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "CustomMetadata"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionid"
	          },
	          "CustomMetadata": {
	            "shape": "S16"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateFolder": {
	      "http": {
	        "requestUri": "/api/v1/folders",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ParentFolderId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "Name": {},
	          "ParentFolderId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Metadata": {
	            "shape": "S1d"
	          }
	        }
	      }
	    },
	    "CreateLabels": {
	      "http": {
	        "method": "PUT",
	        "requestUri": "/api/v1/resources/{ResourceId}/labels",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "Labels"
	        ],
	        "members": {
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          },
	          "Labels": {
	            "shape": "S1g"
	          },
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "CreateNotificationSubscription": {
	      "http": {
	        "requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "OrganizationId",
	          "Endpoint",
	          "Protocol",
	          "SubscriptionType"
	        ],
	        "members": {
	          "OrganizationId": {
	            "location": "uri",
	            "locationName": "OrganizationId"
	          },
	          "Endpoint": {},
	          "Protocol": {},
	          "SubscriptionType": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Subscription": {
	            "shape": "S1p"
	          }
	        }
	      }
	    },
	    "CreateUser": {
	      "http": {
	        "requestUri": "/api/v1/users",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Username",
	          "GivenName",
	          "Surname",
	          "Password"
	        ],
	        "members": {
	          "OrganizationId": {},
	          "Username": {},
	          "EmailAddress": {},
	          "GivenName": {},
	          "Surname": {},
	          "Password": {
	            "type": "string",
	            "sensitive": true
	          },
	          "TimeZoneId": {},
	          "StorageRule": {
	            "shape": "Sj"
	          },
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "User": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "DeactivateUser": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/users/{UserId}/activation",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserId"
	        ],
	        "members": {
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          },
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          }
	        }
	      }
	    },
	    "DeleteComment": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comment/{CommentId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentId",
	          "VersionId",
	          "CommentId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "DocumentId": {
	            "location": "uri",
	            "locationName": "DocumentId"
	          },
	          "VersionId": {
	            "location": "uri",
	            "locationName": "VersionId"
	          },
	          "CommentId": {
	            "location": "uri",
	            "locationName": "CommentId"
	          }
	        }
	      }
	    },
	    "DeleteCustomMetadata": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/resources/{ResourceId}/customMetadata",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          },
	          "VersionId": {
	            "location": "querystring",
	            "locationName": "versionId"
	          },
	          "Keys": {
	            "location": "querystring",
	            "locationName": "keys",
	            "type": "list",
	            "member": {}
	          },
	          "DeleteAll": {
	            "location": "querystring",
	            "locationName": "deleteAll",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteDocument": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/documents/{DocumentId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "DocumentId": {
	            "location": "uri",
	            "locationName": "DocumentId"
	          }
	        }
	      }
	    },
	    "DeleteFolder": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/folders/{FolderId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FolderId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "FolderId": {
	            "location": "uri",
	            "locationName": "FolderId"
	          }
	        }
	      }
	    },
	    "DeleteFolderContents": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/folders/{FolderId}/contents",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FolderId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "FolderId": {
	            "location": "uri",
	            "locationName": "FolderId"
	          }
	        }
	      }
	    },
	    "DeleteLabels": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/resources/{ResourceId}/labels",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId"
	        ],
	        "members": {
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          },
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "Labels": {
	            "shape": "S1g",
	            "location": "querystring",
	            "locationName": "labels"
	          },
	          "DeleteAll": {
	            "location": "querystring",
	            "locationName": "deleteAll",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteNotificationSubscription": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions/{SubscriptionId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SubscriptionId",
	          "OrganizationId"
	        ],
	        "members": {
	          "SubscriptionId": {
	            "location": "uri",
	            "locationName": "SubscriptionId"
	          },
	          "OrganizationId": {
	            "location": "uri",
	            "locationName": "OrganizationId"
	          }
	        }
	      }
	    },
	    "DeleteUser": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/users/{UserId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          }
	        }
	      }
	    },
	    "DescribeActivities": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/activities",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "StartTime": {
	            "location": "querystring",
	            "locationName": "startTime",
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "location": "querystring",
	            "locationName": "endTime",
	            "type": "timestamp"
	          },
	          "OrganizationId": {
	            "location": "querystring",
	            "locationName": "organizationId"
	          },
	          "ActivityTypes": {
	            "location": "querystring",
	            "locationName": "activityTypes"
	          },
	          "ResourceId": {
	            "location": "querystring",
	            "locationName": "resourceId"
	          },
	          "UserId": {
	            "location": "querystring",
	            "locationName": "userId"
	          },
	          "IncludeIndirectActivities": {
	            "location": "querystring",
	            "locationName": "includeIndirectActivities",
	            "type": "boolean"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UserActivities": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Type": {},
	                "TimeStamp": {
	                  "type": "timestamp"
	                },
	                "IsIndirectActivity": {
	                  "type": "boolean"
	                },
	                "OrganizationId": {},
	                "Initiator": {
	                  "shape": "S2d"
	                },
	                "Participants": {
	                  "type": "structure",
	                  "members": {
	                    "Users": {
	                      "type": "list",
	                      "member": {
	                        "shape": "S2d"
	                      }
	                    },
	                    "Groups": {
	                      "shape": "S2g"
	                    }
	                  }
	                },
	                "ResourceMetadata": {
	                  "shape": "S2j"
	                },
	                "OriginalParent": {
	                  "shape": "S2j"
	                },
	                "CommentMetadata": {
	                  "type": "structure",
	                  "members": {
	                    "CommentId": {},
	                    "Contributor": {
	                      "shape": "S8"
	                    },
	                    "CreatedTimestamp": {
	                      "type": "timestamp"
	                    },
	                    "CommentStatus": {},
	                    "RecipientId": {}
	                  }
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeComments": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comments",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentId",
	          "VersionId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "DocumentId": {
	            "location": "uri",
	            "locationName": "DocumentId"
	          },
	          "VersionId": {
	            "location": "uri",
	            "locationName": "VersionId"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Comments": {
	            "type": "list",
	            "member": {
	              "shape": "S13"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeDocumentVersions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/documents/{DocumentId}/versions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "DocumentId": {
	            "location": "uri",
	            "locationName": "DocumentId"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "Include": {
	            "location": "querystring",
	            "locationName": "include"
	          },
	          "Fields": {
	            "location": "querystring",
	            "locationName": "fields"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "DocumentVersions": {
	            "type": "list",
	            "member": {
	              "shape": "S2u"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeFolderContents": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/folders/{FolderId}/contents",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FolderId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "FolderId": {
	            "location": "uri",
	            "locationName": "FolderId"
	          },
	          "Sort": {
	            "location": "querystring",
	            "locationName": "sort"
	          },
	          "Order": {
	            "location": "querystring",
	            "locationName": "order"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "Type": {
	            "location": "querystring",
	            "locationName": "type"
	          },
	          "Include": {
	            "location": "querystring",
	            "locationName": "include"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Folders": {
	            "shape": "S37"
	          },
	          "Documents": {
	            "shape": "S38"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeGroups": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/groups",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SearchQuery"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "SearchQuery": {
	            "shape": "S3b",
	            "location": "querystring",
	            "locationName": "searchQuery"
	          },
	          "OrganizationId": {
	            "location": "querystring",
	            "locationName": "organizationId"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Groups": {
	            "shape": "S2g"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeNotificationSubscriptions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "OrganizationId"
	        ],
	        "members": {
	          "OrganizationId": {
	            "location": "uri",
	            "locationName": "OrganizationId"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Subscriptions": {
	            "type": "list",
	            "member": {
	              "shape": "S1p"
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeResourcePermissions": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/resources/{ResourceId}/permissions",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          },
	          "PrincipalId": {
	            "location": "querystring",
	            "locationName": "principalId"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Principals": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Type": {},
	                "Roles": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Role": {},
	                      "Type": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeRootFolders": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/me/root",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "AuthenticationToken"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Folders": {
	            "shape": "S37"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "DescribeUsers": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/users",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "OrganizationId": {
	            "location": "querystring",
	            "locationName": "organizationId"
	          },
	          "UserIds": {
	            "location": "querystring",
	            "locationName": "userIds"
	          },
	          "Query": {
	            "shape": "S3b",
	            "location": "querystring",
	            "locationName": "query"
	          },
	          "Include": {
	            "location": "querystring",
	            "locationName": "include"
	          },
	          "Order": {
	            "location": "querystring",
	            "locationName": "order"
	          },
	          "Sort": {
	            "location": "querystring",
	            "locationName": "sort"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "Fields": {
	            "location": "querystring",
	            "locationName": "fields"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Users": {
	            "type": "list",
	            "member": {
	              "shape": "S8"
	            }
	          },
	          "TotalNumberOfUsers": {
	            "deprecated": true,
	            "type": "long"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "GetCurrentUser": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/me",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "AuthenticationToken"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "User": {
	            "shape": "S8"
	          }
	        }
	      }
	    },
	    "GetDocument": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/documents/{DocumentId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "DocumentId": {
	            "location": "uri",
	            "locationName": "DocumentId"
	          },
	          "IncludeCustomMetadata": {
	            "location": "querystring",
	            "locationName": "includeCustomMetadata",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Metadata": {
	            "shape": "S39"
	          },
	          "CustomMetadata": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "GetDocumentPath": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/documents/{DocumentId}/path",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "DocumentId": {
	            "location": "uri",
	            "locationName": "DocumentId"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "Fields": {
	            "location": "querystring",
	            "locationName": "fields"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Path": {
	            "shape": "S42"
	          }
	        }
	      }
	    },
	    "GetDocumentVersion": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentId",
	          "VersionId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "DocumentId": {
	            "location": "uri",
	            "locationName": "DocumentId"
	          },
	          "VersionId": {
	            "location": "uri",
	            "locationName": "VersionId"
	          },
	          "Fields": {
	            "location": "querystring",
	            "locationName": "fields"
	          },
	          "IncludeCustomMetadata": {
	            "location": "querystring",
	            "locationName": "includeCustomMetadata",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Metadata": {
	            "shape": "S2u"
	          },
	          "CustomMetadata": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "GetFolder": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/folders/{FolderId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FolderId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "FolderId": {
	            "location": "uri",
	            "locationName": "FolderId"
	          },
	          "IncludeCustomMetadata": {
	            "location": "querystring",
	            "locationName": "includeCustomMetadata",
	            "type": "boolean"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Metadata": {
	            "shape": "S1d"
	          },
	          "CustomMetadata": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "GetFolderPath": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/folders/{FolderId}/path",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FolderId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "FolderId": {
	            "location": "uri",
	            "locationName": "FolderId"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "Fields": {
	            "location": "querystring",
	            "locationName": "fields"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Path": {
	            "shape": "S42"
	          }
	        }
	      }
	    },
	    "GetResources": {
	      "http": {
	        "method": "GET",
	        "requestUri": "/api/v1/resources",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "UserId": {
	            "location": "querystring",
	            "locationName": "userId"
	          },
	          "CollectionType": {
	            "location": "querystring",
	            "locationName": "collectionType"
	          },
	          "Limit": {
	            "location": "querystring",
	            "locationName": "limit",
	            "type": "integer"
	          },
	          "Marker": {
	            "location": "querystring",
	            "locationName": "marker"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Folders": {
	            "shape": "S37"
	          },
	          "Documents": {
	            "shape": "S38"
	          },
	          "Marker": {}
	        }
	      }
	    },
	    "InitiateDocumentVersionUpload": {
	      "http": {
	        "requestUri": "/api/v1/documents",
	        "responseCode": 201
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ParentFolderId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "Id": {},
	          "Name": {},
	          "ContentCreatedTimestamp": {
	            "type": "timestamp"
	          },
	          "ContentModifiedTimestamp": {
	            "type": "timestamp"
	          },
	          "ContentType": {},
	          "DocumentSizeInBytes": {
	            "type": "long"
	          },
	          "ParentFolderId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Metadata": {
	            "shape": "S39"
	          },
	          "UploadMetadata": {
	            "type": "structure",
	            "members": {
	              "UploadUrl": {
	                "shape": "S2z"
	              },
	              "SignedHeaders": {
	                "type": "map",
	                "key": {},
	                "value": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "RemoveAllResourcePermissions": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/resources/{ResourceId}/permissions",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          }
	        }
	      }
	    },
	    "RemoveResourcePermission": {
	      "http": {
	        "method": "DELETE",
	        "requestUri": "/api/v1/resources/{ResourceId}/permissions/{PrincipalId}",
	        "responseCode": 204
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceId",
	          "PrincipalId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "ResourceId": {
	            "location": "uri",
	            "locationName": "ResourceId"
	          },
	          "PrincipalId": {
	            "location": "uri",
	            "locationName": "PrincipalId"
	          },
	          "PrincipalType": {
	            "location": "querystring",
	            "locationName": "type"
	          }
	        }
	      }
	    },
	    "UpdateDocument": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/api/v1/documents/{DocumentId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "DocumentId": {
	            "location": "uri",
	            "locationName": "DocumentId"
	          },
	          "Name": {},
	          "ParentFolderId": {},
	          "ResourceState": {}
	        }
	      }
	    },
	    "UpdateDocumentVersion": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "DocumentId",
	          "VersionId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "DocumentId": {
	            "location": "uri",
	            "locationName": "DocumentId"
	          },
	          "VersionId": {
	            "location": "uri",
	            "locationName": "VersionId"
	          },
	          "VersionStatus": {}
	        }
	      }
	    },
	    "UpdateFolder": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/api/v1/folders/{FolderId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "FolderId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "FolderId": {
	            "location": "uri",
	            "locationName": "FolderId"
	          },
	          "Name": {},
	          "ParentFolderId": {},
	          "ResourceState": {}
	        }
	      }
	    },
	    "UpdateUser": {
	      "http": {
	        "method": "PATCH",
	        "requestUri": "/api/v1/users/{UserId}",
	        "responseCode": 200
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "UserId"
	        ],
	        "members": {
	          "AuthenticationToken": {
	            "shape": "S2",
	            "location": "header",
	            "locationName": "Authentication"
	          },
	          "UserId": {
	            "location": "uri",
	            "locationName": "UserId"
	          },
	          "GivenName": {},
	          "Surname": {},
	          "Type": {},
	          "StorageRule": {
	            "shape": "Sj"
	          },
	          "TimeZoneId": {},
	          "Locale": {},
	          "GrantPoweruserPrivileges": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "User": {
	            "shape": "S8"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S8": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Username": {},
	        "EmailAddress": {},
	        "GivenName": {},
	        "Surname": {},
	        "OrganizationId": {},
	        "RootFolderId": {},
	        "RecycleBinFolderId": {},
	        "Status": {},
	        "Type": {},
	        "CreatedTimestamp": {
	          "type": "timestamp"
	        },
	        "ModifiedTimestamp": {
	          "type": "timestamp"
	        },
	        "TimeZoneId": {},
	        "Locale": {},
	        "Storage": {
	          "type": "structure",
	          "members": {
	            "StorageUtilizedInBytes": {
	              "type": "long"
	            },
	            "StorageRule": {
	              "shape": "Sj"
	            }
	          }
	        }
	      }
	    },
	    "Sj": {
	      "type": "structure",
	      "members": {
	        "StorageAllocatedInBytes": {
	          "type": "long"
	        },
	        "StorageType": {}
	      }
	    },
	    "St": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S10": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S13": {
	      "type": "structure",
	      "required": [
	        "CommentId"
	      ],
	      "members": {
	        "CommentId": {},
	        "ParentId": {},
	        "ThreadId": {},
	        "Text": {
	          "shape": "S10"
	        },
	        "Contributor": {
	          "shape": "S8"
	        },
	        "CreatedTimestamp": {
	          "type": "timestamp"
	        },
	        "Status": {},
	        "Visibility": {},
	        "RecipientId": {}
	      }
	    },
	    "S16": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S1d": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Name": {},
	        "CreatorId": {},
	        "ParentFolderId": {},
	        "CreatedTimestamp": {
	          "type": "timestamp"
	        },
	        "ModifiedTimestamp": {
	          "type": "timestamp"
	        },
	        "ResourceState": {},
	        "Signature": {},
	        "Labels": {
	          "shape": "S1g"
	        },
	        "Size": {
	          "type": "long"
	        },
	        "LatestVersionSize": {
	          "type": "long"
	        }
	      }
	    },
	    "S1g": {
	      "type": "list",
	      "member": {}
	    },
	    "S1p": {
	      "type": "structure",
	      "members": {
	        "SubscriptionId": {},
	        "EndPoint": {},
	        "Protocol": {}
	      }
	    },
	    "S2d": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Username": {},
	        "GivenName": {},
	        "Surname": {},
	        "EmailAddress": {}
	      }
	    },
	    "S2g": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Id": {},
	          "Name": {}
	        }
	      }
	    },
	    "S2j": {
	      "type": "structure",
	      "members": {
	        "Type": {},
	        "Name": {},
	        "OriginalName": {},
	        "Id": {},
	        "VersionId": {},
	        "Owner": {
	          "shape": "S2d"
	        },
	        "ParentId": {}
	      }
	    },
	    "S2u": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "Name": {},
	        "ContentType": {},
	        "Size": {
	          "type": "long"
	        },
	        "Signature": {},
	        "Status": {},
	        "CreatedTimestamp": {
	          "type": "timestamp"
	        },
	        "ModifiedTimestamp": {
	          "type": "timestamp"
	        },
	        "ContentCreatedTimestamp": {
	          "type": "timestamp"
	        },
	        "ContentModifiedTimestamp": {
	          "type": "timestamp"
	        },
	        "CreatorId": {},
	        "Thumbnail": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "shape": "S2z"
	          }
	        },
	        "Source": {
	          "type": "map",
	          "key": {},
	          "value": {
	            "shape": "S2z"
	          }
	        }
	      }
	    },
	    "S2z": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S37": {
	      "type": "list",
	      "member": {
	        "shape": "S1d"
	      }
	    },
	    "S38": {
	      "type": "list",
	      "member": {
	        "shape": "S39"
	      }
	    },
	    "S39": {
	      "type": "structure",
	      "members": {
	        "Id": {},
	        "CreatorId": {},
	        "ParentFolderId": {},
	        "CreatedTimestamp": {
	          "type": "timestamp"
	        },
	        "ModifiedTimestamp": {
	          "type": "timestamp"
	        },
	        "LatestVersionMetadata": {
	          "shape": "S2u"
	        },
	        "ResourceState": {},
	        "Labels": {
	          "shape": "S1g"
	        }
	      }
	    },
	    "S3b": {
	      "type": "string",
	      "sensitive": true
	    },
	    "S42": {
	      "type": "structure",
	      "members": {
	        "Components": {
	          "type": "list",
	          "member": {
	            "type": "structure",
	            "members": {
	              "Id": {},
	              "Name": {}
	            }
	          }
	        }
	      }
	    }
	  }
	}
	},{}],237:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "DescribeDocumentVersions": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "output_token": "Marker",
	      "result_key": "DocumentVersions"
	    },
	    "DescribeFolderContents": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "output_token": "Marker",
	      "result_key": [
	        "Folders",
	        "Documents"
	      ]
	    },
	    "DescribeUsers": {
	      "input_token": "Marker",
	      "limit_key": "Limit",
	      "output_token": "Marker",
	      "result_key": "Users"
	    }
	  }
	}
	},{}],238:[function(require,module,exports){
	module.exports={
	  "version": "2.0",
	  "metadata": {
	    "apiVersion": "2016-04-12",
	    "endpointPrefix": "xray",
	    "protocol": "rest-json",
	    "serviceFullName": "AWS X-Ray",
	    "serviceId": "XRay",
	    "signatureVersion": "v4",
	    "uid": "xray-2016-04-12"
	  },
	  "operations": {
	    "BatchGetTraces": {
	      "http": {
	        "requestUri": "/Traces"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TraceIds"
	        ],
	        "members": {
	          "TraceIds": {
	            "shape": "S2"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Traces": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Duration": {
	                  "type": "double"
	                },
	                "LimitExceeded": {
	                  "type": "boolean"
	                },
	                "Segments": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Id": {},
	                      "Document": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "UnprocessedTraceIds": {
	            "type": "list",
	            "member": {}
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "CreateGroup": {
	      "http": {
	        "requestUri": "/CreateGroup"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "GroupName"
	        ],
	        "members": {
	          "GroupName": {},
	          "FilterExpression": {},
	          "InsightsConfiguration": {
	            "shape": "Si"
	          },
	          "Tags": {
	            "shape": "Sj"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Group": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "CreateSamplingRule": {
	      "http": {
	        "requestUri": "/CreateSamplingRule"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SamplingRule"
	        ],
	        "members": {
	          "SamplingRule": {
	            "shape": "Sq"
	          },
	          "Tags": {
	            "shape": "Sj"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SamplingRuleRecord": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "DeleteGroup": {
	      "http": {
	        "requestUri": "/DeleteGroup"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "GroupName": {},
	          "GroupARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "DeleteSamplingRule": {
	      "http": {
	        "requestUri": "/DeleteSamplingRule"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "RuleName": {},
	          "RuleARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SamplingRuleRecord": {
	            "shape": "S16"
	          }
	        }
	      }
	    },
	    "GetEncryptionConfig": {
	      "http": {
	        "requestUri": "/EncryptionConfig"
	      },
	      "input": {
	        "type": "structure",
	        "members": {}
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EncryptionConfig": {
	            "shape": "S1f"
	          }
	        }
	      }
	    },
	    "GetGroup": {
	      "http": {
	        "requestUri": "/GetGroup"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "GroupName": {},
	          "GroupARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Group": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "GetGroups": {
	      "http": {
	        "requestUri": "/Groups"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Groups": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "GroupName": {},
	                "GroupARN": {},
	                "FilterExpression": {},
	                "InsightsConfiguration": {
	                  "shape": "Si"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetInsight": {
	      "http": {
	        "requestUri": "/Insight"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InsightId"
	        ],
	        "members": {
	          "InsightId": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Insight": {
	            "type": "structure",
	            "members": {
	              "InsightId": {},
	              "GroupARN": {},
	              "GroupName": {},
	              "RootCauseServiceId": {
	                "shape": "S1t"
	              },
	              "Categories": {
	                "shape": "S1v"
	              },
	              "State": {},
	              "StartTime": {
	                "type": "timestamp"
	              },
	              "EndTime": {
	                "type": "timestamp"
	              },
	              "Summary": {},
	              "ClientRequestImpactStatistics": {
	                "shape": "S1z"
	              },
	              "RootCauseServiceRequestImpactStatistics": {
	                "shape": "S1z"
	              },
	              "TopAnomalousServices": {
	                "shape": "S21"
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetInsightEvents": {
	      "http": {
	        "requestUri": "/InsightEvents"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InsightId"
	        ],
	        "members": {
	          "InsightId": {},
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InsightEvents": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Summary": {},
	                "EventTime": {
	                  "type": "timestamp"
	                },
	                "ClientRequestImpactStatistics": {
	                  "shape": "S1z"
	                },
	                "RootCauseServiceRequestImpactStatistics": {
	                  "shape": "S1z"
	                },
	                "TopAnomalousServices": {
	                  "shape": "S21"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetInsightImpactGraph": {
	      "http": {
	        "requestUri": "/InsightImpactGraph"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "InsightId",
	          "StartTime",
	          "EndTime"
	        ],
	        "members": {
	          "InsightId": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InsightId": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "ServiceGraphStartTime": {
	            "type": "timestamp"
	          },
	          "ServiceGraphEndTime": {
	            "type": "timestamp"
	          },
	          "Services": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ReferenceId": {
	                  "type": "integer"
	                },
	                "Type": {},
	                "Name": {},
	                "Names": {
	                  "shape": "S1u"
	                },
	                "AccountId": {},
	                "Edges": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "ReferenceId": {
	                        "type": "integer"
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetInsightSummaries": {
	      "http": {
	        "requestUri": "/InsightSummaries"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StartTime",
	          "EndTime"
	        ],
	        "members": {
	          "States": {
	            "type": "list",
	            "member": {}
	          },
	          "GroupARN": {},
	          "GroupName": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "MaxResults": {
	            "type": "integer"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "InsightSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "InsightId": {},
	                "GroupARN": {},
	                "GroupName": {},
	                "RootCauseServiceId": {
	                  "shape": "S1t"
	                },
	                "Categories": {
	                  "shape": "S1v"
	                },
	                "State": {},
	                "StartTime": {
	                  "type": "timestamp"
	                },
	                "EndTime": {
	                  "type": "timestamp"
	                },
	                "Summary": {},
	                "ClientRequestImpactStatistics": {
	                  "shape": "S1z"
	                },
	                "RootCauseServiceRequestImpactStatistics": {
	                  "shape": "S1z"
	                },
	                "TopAnomalousServices": {
	                  "shape": "S21"
	                },
	                "LastUpdateTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetSamplingRules": {
	      "http": {
	        "requestUri": "/GetSamplingRules"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SamplingRuleRecords": {
	            "type": "list",
	            "member": {
	              "shape": "S16"
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetSamplingStatisticSummaries": {
	      "http": {
	        "requestUri": "/SamplingStatisticSummaries"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SamplingStatisticSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "RuleName": {},
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "RequestCount": {
	                  "type": "integer"
	                },
	                "BorrowCount": {
	                  "type": "integer"
	                },
	                "SampledCount": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetSamplingTargets": {
	      "http": {
	        "requestUri": "/SamplingTargets"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SamplingStatisticsDocuments"
	        ],
	        "members": {
	          "SamplingStatisticsDocuments": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "RuleName",
	                "ClientID",
	                "Timestamp",
	                "RequestCount",
	                "SampledCount"
	              ],
	              "members": {
	                "RuleName": {},
	                "ClientID": {},
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "RequestCount": {
	                  "type": "integer"
	                },
	                "SampledCount": {
	                  "type": "integer"
	                },
	                "BorrowCount": {
	                  "type": "integer"
	                }
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SamplingTargetDocuments": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "RuleName": {},
	                "FixedRate": {
	                  "type": "double"
	                },
	                "ReservoirQuota": {
	                  "type": "integer"
	                },
	                "ReservoirQuotaTTL": {
	                  "type": "timestamp"
	                },
	                "Interval": {
	                  "type": "integer"
	                }
	              }
	            }
	          },
	          "LastRuleModification": {
	            "type": "timestamp"
	          },
	          "UnprocessedStatistics": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "RuleName": {},
	                "ErrorCode": {},
	                "Message": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "GetServiceGraph": {
	      "http": {
	        "requestUri": "/ServiceGraph"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StartTime",
	          "EndTime"
	        ],
	        "members": {
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "GroupName": {},
	          "GroupARN": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Services": {
	            "shape": "S3a"
	          },
	          "ContainsOldGroupVersions": {
	            "type": "boolean"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetTimeSeriesServiceStatistics": {
	      "http": {
	        "requestUri": "/TimeSeriesServiceStatistics"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StartTime",
	          "EndTime"
	        ],
	        "members": {
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "GroupName": {},
	          "GroupARN": {},
	          "EntitySelectorExpression": {},
	          "Period": {
	            "type": "integer"
	          },
	          "ForecastStatistics": {
	            "type": "boolean"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TimeSeriesServiceStatistics": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "EdgeSummaryStatistics": {
	                  "shape": "S3e"
	                },
	                "ServiceSummaryStatistics": {
	                  "shape": "S3m"
	                },
	                "ServiceForecastStatistics": {
	                  "type": "structure",
	                  "members": {
	                    "FaultCountHigh": {
	                      "type": "long"
	                    },
	                    "FaultCountLow": {
	                      "type": "long"
	                    }
	                  }
	                },
	                "ResponseTimeHistogram": {
	                  "shape": "S3h"
	                }
	              }
	            }
	          },
	          "ContainsOldGroupVersions": {
	            "type": "boolean"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetTraceGraph": {
	      "http": {
	        "requestUri": "/TraceGraph"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TraceIds"
	        ],
	        "members": {
	          "TraceIds": {
	            "shape": "S2"
	          },
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Services": {
	            "shape": "S3a"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "GetTraceSummaries": {
	      "http": {
	        "requestUri": "/TraceSummaries"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "StartTime",
	          "EndTime"
	        ],
	        "members": {
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "TimeRangeType": {},
	          "Sampling": {
	            "type": "boolean"
	          },
	          "SamplingStrategy": {
	            "type": "structure",
	            "members": {
	              "Name": {},
	              "Value": {
	                "type": "double"
	              }
	            }
	          },
	          "FilterExpression": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "TraceSummaries": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "Duration": {
	                  "type": "double"
	                },
	                "ResponseTime": {
	                  "type": "double"
	                },
	                "HasFault": {
	                  "type": "boolean"
	                },
	                "HasError": {
	                  "type": "boolean"
	                },
	                "HasThrottle": {
	                  "type": "boolean"
	                },
	                "IsPartial": {
	                  "type": "boolean"
	                },
	                "Http": {
	                  "type": "structure",
	                  "members": {
	                    "HttpURL": {},
	                    "HttpStatus": {
	                      "type": "integer"
	                    },
	                    "HttpMethod": {},
	                    "UserAgent": {},
	                    "ClientIp": {}
	                  }
	                },
	                "Annotations": {
	                  "type": "map",
	                  "key": {},
	                  "value": {
	                    "type": "list",
	                    "member": {
	                      "type": "structure",
	                      "members": {
	                        "AnnotationValue": {
	                          "type": "structure",
	                          "members": {
	                            "NumberValue": {
	                              "type": "double"
	                            },
	                            "BooleanValue": {
	                              "type": "boolean"
	                            },
	                            "StringValue": {}
	                          }
	                        },
	                        "ServiceIds": {
	                          "shape": "S49"
	                        }
	                      }
	                    }
	                  }
	                },
	                "Users": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "UserName": {},
	                      "ServiceIds": {
	                        "shape": "S49"
	                      }
	                    }
	                  }
	                },
	                "ServiceIds": {
	                  "shape": "S49"
	                },
	                "ResourceARNs": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "ARN": {}
	                    }
	                  }
	                },
	                "InstanceIds": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Id": {}
	                    }
	                  }
	                },
	                "AvailabilityZones": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Name": {}
	                    }
	                  }
	                },
	                "EntryPoint": {
	                  "shape": "S1t"
	                },
	                "FaultRootCauses": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Services": {
	                        "type": "list",
	                        "member": {
	                          "type": "structure",
	                          "members": {
	                            "Name": {},
	                            "Names": {
	                              "shape": "S1u"
	                            },
	                            "Type": {},
	                            "AccountId": {},
	                            "EntityPath": {
	                              "type": "list",
	                              "member": {
	                                "type": "structure",
	                                "members": {
	                                  "Name": {},
	                                  "Exceptions": {
	                                    "shape": "S4o"
	                                  },
	                                  "Remote": {
	                                    "type": "boolean"
	                                  }
	                                }
	                              }
	                            },
	                            "Inferred": {
	                              "type": "boolean"
	                            }
	                          }
	                        }
	                      },
	                      "ClientImpacting": {
	                        "type": "boolean"
	                      }
	                    }
	                  }
	                },
	                "ErrorRootCauses": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Services": {
	                        "type": "list",
	                        "member": {
	                          "type": "structure",
	                          "members": {
	                            "Name": {},
	                            "Names": {
	                              "shape": "S1u"
	                            },
	                            "Type": {},
	                            "AccountId": {},
	                            "EntityPath": {
	                              "type": "list",
	                              "member": {
	                                "type": "structure",
	                                "members": {
	                                  "Name": {},
	                                  "Exceptions": {
	                                    "shape": "S4o"
	                                  },
	                                  "Remote": {
	                                    "type": "boolean"
	                                  }
	                                }
	                              }
	                            },
	                            "Inferred": {
	                              "type": "boolean"
	                            }
	                          }
	                        }
	                      },
	                      "ClientImpacting": {
	                        "type": "boolean"
	                      }
	                    }
	                  }
	                },
	                "ResponseTimeRootCauses": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Services": {
	                        "type": "list",
	                        "member": {
	                          "type": "structure",
	                          "members": {
	                            "Name": {},
	                            "Names": {
	                              "shape": "S1u"
	                            },
	                            "Type": {},
	                            "AccountId": {},
	                            "EntityPath": {
	                              "type": "list",
	                              "member": {
	                                "type": "structure",
	                                "members": {
	                                  "Name": {},
	                                  "Coverage": {
	                                    "type": "double"
	                                  },
	                                  "Remote": {
	                                    "type": "boolean"
	                                  }
	                                }
	                              }
	                            },
	                            "Inferred": {
	                              "type": "boolean"
	                            }
	                          }
	                        }
	                      },
	                      "ClientImpacting": {
	                        "type": "boolean"
	                      }
	                    }
	                  }
	                },
	                "Revision": {
	                  "type": "integer"
	                },
	                "MatchedEventTime": {
	                  "type": "timestamp"
	                }
	              }
	            }
	          },
	          "ApproximateTime": {
	            "type": "timestamp"
	          },
	          "TracesProcessedCount": {
	            "type": "long"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "ListTagsForResource": {
	      "http": {
	        "requestUri": "/ListTagsForResource"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "NextToken": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Tags": {
	            "shape": "Sj"
	          },
	          "NextToken": {}
	        }
	      }
	    },
	    "PutEncryptionConfig": {
	      "http": {
	        "requestUri": "/PutEncryptionConfig"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "Type"
	        ],
	        "members": {
	          "KeyId": {},
	          "Type": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "EncryptionConfig": {
	            "shape": "S1f"
	          }
	        }
	      }
	    },
	    "PutTelemetryRecords": {
	      "http": {
	        "requestUri": "/TelemetryRecords"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TelemetryRecords"
	        ],
	        "members": {
	          "TelemetryRecords": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "required": [
	                "Timestamp"
	              ],
	              "members": {
	                "Timestamp": {
	                  "type": "timestamp"
	                },
	                "SegmentsReceivedCount": {
	                  "type": "integer"
	                },
	                "SegmentsSentCount": {
	                  "type": "integer"
	                },
	                "SegmentsSpilloverCount": {
	                  "type": "integer"
	                },
	                "SegmentsRejectedCount": {
	                  "type": "integer"
	                },
	                "BackendConnectionErrors": {
	                  "type": "structure",
	                  "members": {
	                    "TimeoutCount": {
	                      "type": "integer"
	                    },
	                    "ConnectionRefusedCount": {
	                      "type": "integer"
	                    },
	                    "HTTPCode4XXCount": {
	                      "type": "integer"
	                    },
	                    "HTTPCode5XXCount": {
	                      "type": "integer"
	                    },
	                    "UnknownHostCount": {
	                      "type": "integer"
	                    },
	                    "OtherCount": {
	                      "type": "integer"
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "EC2InstanceId": {},
	          "Hostname": {},
	          "ResourceARN": {}
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "PutTraceSegments": {
	      "http": {
	        "requestUri": "/TraceSegments"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "TraceSegmentDocuments"
	        ],
	        "members": {
	          "TraceSegmentDocuments": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "UnprocessedTraceSegments": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "Id": {},
	                "ErrorCode": {},
	                "Message": {}
	              }
	            }
	          }
	        }
	      }
	    },
	    "TagResource": {
	      "http": {
	        "requestUri": "/TagResource"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "Tags"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "Tags": {
	            "shape": "Sj"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UntagResource": {
	      "http": {
	        "requestUri": "/UntagResource"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "ResourceARN",
	          "TagKeys"
	        ],
	        "members": {
	          "ResourceARN": {},
	          "TagKeys": {
	            "type": "list",
	            "member": {}
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {}
	      }
	    },
	    "UpdateGroup": {
	      "http": {
	        "requestUri": "/UpdateGroup"
	      },
	      "input": {
	        "type": "structure",
	        "members": {
	          "GroupName": {},
	          "GroupARN": {},
	          "FilterExpression": {},
	          "InsightsConfiguration": {
	            "shape": "Si"
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "Group": {
	            "shape": "So"
	          }
	        }
	      }
	    },
	    "UpdateSamplingRule": {
	      "http": {
	        "requestUri": "/UpdateSamplingRule"
	      },
	      "input": {
	        "type": "structure",
	        "required": [
	          "SamplingRuleUpdate"
	        ],
	        "members": {
	          "SamplingRuleUpdate": {
	            "type": "structure",
	            "members": {
	              "RuleName": {},
	              "RuleARN": {},
	              "ResourceARN": {},
	              "Priority": {
	                "type": "integer"
	              },
	              "FixedRate": {
	                "type": "double"
	              },
	              "ReservoirSize": {
	                "type": "integer"
	              },
	              "Host": {},
	              "ServiceName": {},
	              "ServiceType": {},
	              "HTTPMethod": {},
	              "URLPath": {},
	              "Attributes": {
	                "shape": "S12"
	              }
	            }
	          }
	        }
	      },
	      "output": {
	        "type": "structure",
	        "members": {
	          "SamplingRuleRecord": {
	            "shape": "S16"
	          }
	        }
	      }
	    }
	  },
	  "shapes": {
	    "S2": {
	      "type": "list",
	      "member": {}
	    },
	    "Si": {
	      "type": "structure",
	      "members": {
	        "InsightsEnabled": {
	          "type": "boolean"
	        },
	        "NotificationsEnabled": {
	          "type": "boolean"
	        }
	      }
	    },
	    "Sj": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "required": [
	          "Key",
	          "Value"
	        ],
	        "members": {
	          "Key": {},
	          "Value": {}
	        }
	      }
	    },
	    "So": {
	      "type": "structure",
	      "members": {
	        "GroupName": {},
	        "GroupARN": {},
	        "FilterExpression": {},
	        "InsightsConfiguration": {
	          "shape": "Si"
	        }
	      }
	    },
	    "Sq": {
	      "type": "structure",
	      "required": [
	        "ResourceARN",
	        "Priority",
	        "FixedRate",
	        "ReservoirSize",
	        "ServiceName",
	        "ServiceType",
	        "Host",
	        "HTTPMethod",
	        "URLPath",
	        "Version"
	      ],
	      "members": {
	        "RuleName": {},
	        "RuleARN": {},
	        "ResourceARN": {},
	        "Priority": {
	          "type": "integer"
	        },
	        "FixedRate": {
	          "type": "double"
	        },
	        "ReservoirSize": {
	          "type": "integer"
	        },
	        "ServiceName": {},
	        "ServiceType": {},
	        "Host": {},
	        "HTTPMethod": {},
	        "URLPath": {},
	        "Version": {
	          "type": "integer"
	        },
	        "Attributes": {
	          "shape": "S12"
	        }
	      }
	    },
	    "S12": {
	      "type": "map",
	      "key": {},
	      "value": {}
	    },
	    "S16": {
	      "type": "structure",
	      "members": {
	        "SamplingRule": {
	          "shape": "Sq"
	        },
	        "CreatedAt": {
	          "type": "timestamp"
	        },
	        "ModifiedAt": {
	          "type": "timestamp"
	        }
	      }
	    },
	    "S1f": {
	      "type": "structure",
	      "members": {
	        "KeyId": {},
	        "Status": {},
	        "Type": {}
	      }
	    },
	    "S1t": {
	      "type": "structure",
	      "members": {
	        "Name": {},
	        "Names": {
	          "shape": "S1u"
	        },
	        "AccountId": {},
	        "Type": {}
	      }
	    },
	    "S1u": {
	      "type": "list",
	      "member": {}
	    },
	    "S1v": {
	      "type": "list",
	      "member": {}
	    },
	    "S1z": {
	      "type": "structure",
	      "members": {
	        "FaultCount": {
	          "type": "long"
	        },
	        "OkCount": {
	          "type": "long"
	        },
	        "TotalCount": {
	          "type": "long"
	        }
	      }
	    },
	    "S21": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ServiceId": {
	            "shape": "S1t"
	          }
	        }
	      }
	    },
	    "S3a": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "ReferenceId": {
	            "type": "integer"
	          },
	          "Name": {},
	          "Names": {
	            "shape": "S1u"
	          },
	          "Root": {
	            "type": "boolean"
	          },
	          "AccountId": {},
	          "Type": {},
	          "State": {},
	          "StartTime": {
	            "type": "timestamp"
	          },
	          "EndTime": {
	            "type": "timestamp"
	          },
	          "Edges": {
	            "type": "list",
	            "member": {
	              "type": "structure",
	              "members": {
	                "ReferenceId": {
	                  "type": "integer"
	                },
	                "StartTime": {
	                  "type": "timestamp"
	                },
	                "EndTime": {
	                  "type": "timestamp"
	                },
	                "SummaryStatistics": {
	                  "shape": "S3e"
	                },
	                "ResponseTimeHistogram": {
	                  "shape": "S3h"
	                },
	                "Aliases": {
	                  "type": "list",
	                  "member": {
	                    "type": "structure",
	                    "members": {
	                      "Name": {},
	                      "Names": {
	                        "type": "list",
	                        "member": {}
	                      },
	                      "Type": {}
	                    }
	                  }
	                }
	              }
	            }
	          },
	          "SummaryStatistics": {
	            "shape": "S3m"
	          },
	          "DurationHistogram": {
	            "shape": "S3h"
	          },
	          "ResponseTimeHistogram": {
	            "shape": "S3h"
	          }
	        }
	      }
	    },
	    "S3e": {
	      "type": "structure",
	      "members": {
	        "OkCount": {
	          "type": "long"
	        },
	        "ErrorStatistics": {
	          "shape": "S3f"
	        },
	        "FaultStatistics": {
	          "shape": "S3g"
	        },
	        "TotalCount": {
	          "type": "long"
	        },
	        "TotalResponseTime": {
	          "type": "double"
	        }
	      }
	    },
	    "S3f": {
	      "type": "structure",
	      "members": {
	        "ThrottleCount": {
	          "type": "long"
	        },
	        "OtherCount": {
	          "type": "long"
	        },
	        "TotalCount": {
	          "type": "long"
	        }
	      }
	    },
	    "S3g": {
	      "type": "structure",
	      "members": {
	        "OtherCount": {
	          "type": "long"
	        },
	        "TotalCount": {
	          "type": "long"
	        }
	      }
	    },
	    "S3h": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Value": {
	            "type": "double"
	          },
	          "Count": {
	            "type": "integer"
	          }
	        }
	      }
	    },
	    "S3m": {
	      "type": "structure",
	      "members": {
	        "OkCount": {
	          "type": "long"
	        },
	        "ErrorStatistics": {
	          "shape": "S3f"
	        },
	        "FaultStatistics": {
	          "shape": "S3g"
	        },
	        "TotalCount": {
	          "type": "long"
	        },
	        "TotalResponseTime": {
	          "type": "double"
	        }
	      }
	    },
	    "S49": {
	      "type": "list",
	      "member": {
	        "shape": "S1t"
	      }
	    },
	    "S4o": {
	      "type": "list",
	      "member": {
	        "type": "structure",
	        "members": {
	          "Name": {},
	          "Message": {}
	        }
	      }
	    }
	  }
	}
	},{}],239:[function(require,module,exports){
	module.exports={
	  "pagination": {
	    "BatchGetTraces": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Traces"
	    },
	    "GetGroups": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Groups"
	    },
	    "GetInsightEvents": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetInsightSummaries": {
	      "input_token": "NextToken",
	      "limit_key": "MaxResults",
	      "output_token": "NextToken"
	    },
	    "GetSamplingRules": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "SamplingRuleRecords"
	    },
	    "GetSamplingStatisticSummaries": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "SamplingStatisticSummaries"
	    },
	    "GetServiceGraph": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Services"
	    },
	    "GetTimeSeriesServiceStatistics": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "TimeSeriesServiceStatistics"
	    },
	    "GetTraceGraph": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "Services"
	    },
	    "GetTraceSummaries": {
	      "input_token": "NextToken",
	      "output_token": "NextToken",
	      "result_key": "TraceSummaries"
	    }
	  }
	}
	},{}],240:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['acm'] = {};
	AWS.ACM = Service.defineService('acm', ['2015-12-08']);
	Object.defineProperty(apiLoader.services['acm'], '2015-12-08', {
	  get: function get() {
	    var model = require('../apis/acm-2015-12-08.min.json');
	    model.paginators = require('../apis/acm-2015-12-08.paginators.json').pagination;
	    model.waiters = require('../apis/acm-2015-12-08.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ACM;
	
	},{"../apis/acm-2015-12-08.min.json":1,"../apis/acm-2015-12-08.paginators.json":2,"../apis/acm-2015-12-08.waiters2.json":3,"../lib/core":342,"../lib/node_loader":338}],241:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['apigateway'] = {};
	AWS.APIGateway = Service.defineService('apigateway', ['2015-07-09']);
	require('../lib/services/apigateway');
	Object.defineProperty(apiLoader.services['apigateway'], '2015-07-09', {
	  get: function get() {
	    var model = require('../apis/apigateway-2015-07-09.min.json');
	    model.paginators = require('../apis/apigateway-2015-07-09.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.APIGateway;
	
	},{"../apis/apigateway-2015-07-09.min.json":4,"../apis/apigateway-2015-07-09.paginators.json":5,"../lib/core":342,"../lib/node_loader":338,"../lib/services/apigateway":394}],242:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['applicationautoscaling'] = {};
	AWS.ApplicationAutoScaling = Service.defineService('applicationautoscaling', ['2016-02-06']);
	Object.defineProperty(apiLoader.services['applicationautoscaling'], '2016-02-06', {
	  get: function get() {
	    var model = require('../apis/application-autoscaling-2016-02-06.min.json');
	    model.paginators = require('../apis/application-autoscaling-2016-02-06.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ApplicationAutoScaling;
	
	},{"../apis/application-autoscaling-2016-02-06.min.json":6,"../apis/application-autoscaling-2016-02-06.paginators.json":7,"../lib/core":342,"../lib/node_loader":338}],243:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['athena'] = {};
	AWS.Athena = Service.defineService('athena', ['2017-05-18']);
	Object.defineProperty(apiLoader.services['athena'], '2017-05-18', {
	  get: function get() {
	    var model = require('../apis/athena-2017-05-18.min.json');
	    model.paginators = require('../apis/athena-2017-05-18.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Athena;
	
	},{"../apis/athena-2017-05-18.min.json":8,"../apis/athena-2017-05-18.paginators.json":9,"../lib/core":342,"../lib/node_loader":338}],244:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['autoscaling'] = {};
	AWS.AutoScaling = Service.defineService('autoscaling', ['2011-01-01']);
	Object.defineProperty(apiLoader.services['autoscaling'], '2011-01-01', {
	  get: function get() {
	    var model = require('../apis/autoscaling-2011-01-01.min.json');
	    model.paginators = require('../apis/autoscaling-2011-01-01.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.AutoScaling;
	
	},{"../apis/autoscaling-2011-01-01.min.json":10,"../apis/autoscaling-2011-01-01.paginators.json":11,"../lib/core":342,"../lib/node_loader":338}],245:[function(require,module,exports){
	require('../lib/node_loader');
	module.exports = {
	  ACM: require('./acm'),
	  APIGateway: require('./apigateway'),
	  ApplicationAutoScaling: require('./applicationautoscaling'),
	  AutoScaling: require('./autoscaling'),
	  CloudFormation: require('./cloudformation'),
	  CloudFront: require('./cloudfront'),
	  CloudHSM: require('./cloudhsm'),
	  CloudTrail: require('./cloudtrail'),
	  CloudWatch: require('./cloudwatch'),
	  CloudWatchEvents: require('./cloudwatchevents'),
	  CloudWatchLogs: require('./cloudwatchlogs'),
	  CodeBuild: require('./codebuild'),
	  CodeCommit: require('./codecommit'),
	  CodeDeploy: require('./codedeploy'),
	  CodePipeline: require('./codepipeline'),
	  CognitoIdentity: require('./cognitoidentity'),
	  CognitoIdentityServiceProvider: require('./cognitoidentityserviceprovider'),
	  CognitoSync: require('./cognitosync'),
	  ConfigService: require('./configservice'),
	  CUR: require('./cur'),
	  DeviceFarm: require('./devicefarm'),
	  DirectConnect: require('./directconnect'),
	  DynamoDB: require('./dynamodb'),
	  DynamoDBStreams: require('./dynamodbstreams'),
	  EC2: require('./ec2'),
	  ECR: require('./ecr'),
	  ECS: require('./ecs'),
	  EFS: require('./efs'),
	  ElastiCache: require('./elasticache'),
	  ElasticBeanstalk: require('./elasticbeanstalk'),
	  ELB: require('./elb'),
	  ELBv2: require('./elbv2'),
	  EMR: require('./emr'),
	  ElasticTranscoder: require('./elastictranscoder'),
	  Firehose: require('./firehose'),
	  GameLift: require('./gamelift'),
	  IAM: require('./iam'),
	  Inspector: require('./inspector'),
	  Iot: require('./iot'),
	  IotData: require('./iotdata'),
	  Kinesis: require('./kinesis'),
	  KMS: require('./kms'),
	  Lambda: require('./lambda'),
	  LexRuntime: require('./lexruntime'),
	  MachineLearning: require('./machinelearning'),
	  MarketplaceCommerceAnalytics: require('./marketplacecommerceanalytics'),
	  MTurk: require('./mturk'),
	  MobileAnalytics: require('./mobileanalytics'),
	  OpsWorks: require('./opsworks'),
	  Polly: require('./polly'),
	  RDS: require('./rds'),
	  Redshift: require('./redshift'),
	  Rekognition: require('./rekognition'),
	  Route53: require('./route53'),
	  Route53Domains: require('./route53domains'),
	  S3: require('./s3'),
	  ServiceCatalog: require('./servicecatalog'),
	  SES: require('./ses'),
	  SNS: require('./sns'),
	  SQS: require('./sqs'),
	  SSM: require('./ssm'),
	  StorageGateway: require('./storagegateway'),
	  STS: require('./sts'),
	  XRay: require('./xray'),
	  WAF: require('./waf'),
	  WorkDocs: require('./workdocs'),
	  LexModelBuildingService: require('./lexmodelbuildingservice'),
	  Athena: require('./athena'),
	  CloudHSMV2: require('./cloudhsmv2'),
	  Pricing: require('./pricing'),
	  CostExplorer: require('./costexplorer'),
	  MediaStoreData: require('./mediastoredata'),
	  Comprehend: require('./comprehend'),
	  KinesisVideoArchivedMedia: require('./kinesisvideoarchivedmedia'),
	  KinesisVideoMedia: require('./kinesisvideomedia'),
	  KinesisVideo: require('./kinesisvideo'),
	  Translate: require('./translate'),
	  ResourceGroups: require('./resourcegroups'),
	  Connect: require('./connect'),
	  SecretsManager: require('./secretsmanager'),
	  IoTAnalytics: require('./iotanalytics'),
	  ComprehendMedical: require('./comprehendmedical'),
	  Personalize: require('./personalize'),
	  PersonalizeEvents: require('./personalizeevents'),
	  PersonalizeRuntime: require('./personalizeruntime'),
	  ForecastService: require('./forecastservice'),
	  ForecastQueryService: require('./forecastqueryservice'),
	  KinesisVideoSignalingChannels: require('./kinesisvideosignalingchannels'),
	  Location: require('./location'),
	  LexRuntimeV2: require('./lexruntimev2')
	};
	},{"../lib/node_loader":338,"./acm":240,"./apigateway":241,"./applicationautoscaling":242,"./athena":243,"./autoscaling":244,"./cloudformation":246,"./cloudfront":247,"./cloudhsm":248,"./cloudhsmv2":249,"./cloudtrail":250,"./cloudwatch":251,"./cloudwatchevents":252,"./cloudwatchlogs":253,"./codebuild":254,"./codecommit":255,"./codedeploy":256,"./codepipeline":257,"./cognitoidentity":258,"./cognitoidentityserviceprovider":259,"./cognitosync":260,"./comprehend":261,"./comprehendmedical":262,"./configservice":263,"./connect":264,"./costexplorer":265,"./cur":266,"./devicefarm":267,"./directconnect":268,"./dynamodb":269,"./dynamodbstreams":270,"./ec2":271,"./ecr":272,"./ecs":273,"./efs":274,"./elasticache":275,"./elasticbeanstalk":276,"./elastictranscoder":277,"./elb":278,"./elbv2":279,"./emr":280,"./firehose":281,"./forecastqueryservice":282,"./forecastservice":283,"./gamelift":284,"./iam":285,"./inspector":286,"./iot":287,"./iotanalytics":288,"./iotdata":289,"./kinesis":290,"./kinesisvideo":291,"./kinesisvideoarchivedmedia":292,"./kinesisvideomedia":293,"./kinesisvideosignalingchannels":294,"./kms":295,"./lambda":296,"./lexmodelbuildingservice":297,"./lexruntime":298,"./lexruntimev2":299,"./location":300,"./machinelearning":301,"./marketplacecommerceanalytics":302,"./mediastoredata":303,"./mobileanalytics":304,"./mturk":305,"./opsworks":306,"./personalize":307,"./personalizeevents":308,"./personalizeruntime":309,"./polly":310,"./pricing":311,"./rds":312,"./redshift":313,"./rekognition":314,"./resourcegroups":315,"./route53":316,"./route53domains":317,"./s3":318,"./secretsmanager":319,"./servicecatalog":320,"./ses":321,"./sns":322,"./sqs":323,"./ssm":324,"./storagegateway":325,"./sts":326,"./translate":327,"./waf":328,"./workdocs":329,"./xray":330}],246:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudformation'] = {};
	AWS.CloudFormation = Service.defineService('cloudformation', ['2010-05-15']);
	Object.defineProperty(apiLoader.services['cloudformation'], '2010-05-15', {
	  get: function get() {
	    var model = require('../apis/cloudformation-2010-05-15.min.json');
	    model.paginators = require('../apis/cloudformation-2010-05-15.paginators.json').pagination;
	    model.waiters = require('../apis/cloudformation-2010-05-15.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudFormation;
	
	},{"../apis/cloudformation-2010-05-15.min.json":14,"../apis/cloudformation-2010-05-15.paginators.json":15,"../apis/cloudformation-2010-05-15.waiters2.json":16,"../lib/core":342,"../lib/node_loader":338}],247:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudfront'] = {};
	AWS.CloudFront = Service.defineService('cloudfront', ['2013-05-12*', '2013-11-11*', '2014-05-31*', '2014-10-21*', '2014-11-06*', '2015-04-17*', '2015-07-27*', '2015-09-17*', '2016-01-13*', '2016-01-28*', '2016-08-01*', '2016-08-20*', '2016-09-07*', '2016-09-29*', '2016-11-25', '2016-11-25*', '2017-03-25', '2017-03-25*', '2017-10-30', '2017-10-30*', '2018-06-18', '2018-06-18*', '2018-11-05', '2018-11-05*', '2019-03-26', '2019-03-26*', '2020-05-31']);
	require('../lib/services/cloudfront');
	Object.defineProperty(apiLoader.services['cloudfront'], '2016-11-25', {
	  get: function get() {
	    var model = require('../apis/cloudfront-2016-11-25.min.json');
	    model.paginators = require('../apis/cloudfront-2016-11-25.paginators.json').pagination;
	    model.waiters = require('../apis/cloudfront-2016-11-25.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2017-03-25', {
	  get: function get() {
	    var model = require('../apis/cloudfront-2017-03-25.min.json');
	    model.paginators = require('../apis/cloudfront-2017-03-25.paginators.json').pagination;
	    model.waiters = require('../apis/cloudfront-2017-03-25.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2017-10-30', {
	  get: function get() {
	    var model = require('../apis/cloudfront-2017-10-30.min.json');
	    model.paginators = require('../apis/cloudfront-2017-10-30.paginators.json').pagination;
	    model.waiters = require('../apis/cloudfront-2017-10-30.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2018-06-18', {
	  get: function get() {
	    var model = require('../apis/cloudfront-2018-06-18.min.json');
	    model.paginators = require('../apis/cloudfront-2018-06-18.paginators.json').pagination;
	    model.waiters = require('../apis/cloudfront-2018-06-18.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2018-11-05', {
	  get: function get() {
	    var model = require('../apis/cloudfront-2018-11-05.min.json');
	    model.paginators = require('../apis/cloudfront-2018-11-05.paginators.json').pagination;
	    model.waiters = require('../apis/cloudfront-2018-11-05.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2019-03-26', {
	  get: function get() {
	    var model = require('../apis/cloudfront-2019-03-26.min.json');
	    model.paginators = require('../apis/cloudfront-2019-03-26.paginators.json').pagination;
	    model.waiters = require('../apis/cloudfront-2019-03-26.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2020-05-31', {
	  get: function get() {
	    var model = require('../apis/cloudfront-2020-05-31.min.json');
	    model.paginators = require('../apis/cloudfront-2020-05-31.paginators.json').pagination;
	    model.waiters = require('../apis/cloudfront-2020-05-31.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudFront;
	
	},{"../apis/cloudfront-2016-11-25.min.json":17,"../apis/cloudfront-2016-11-25.paginators.json":18,"../apis/cloudfront-2016-11-25.waiters2.json":19,"../apis/cloudfront-2017-03-25.min.json":20,"../apis/cloudfront-2017-03-25.paginators.json":21,"../apis/cloudfront-2017-03-25.waiters2.json":22,"../apis/cloudfront-2017-10-30.min.json":23,"../apis/cloudfront-2017-10-30.paginators.json":24,"../apis/cloudfront-2017-10-30.waiters2.json":25,"../apis/cloudfront-2018-06-18.min.json":26,"../apis/cloudfront-2018-06-18.paginators.json":27,"../apis/cloudfront-2018-06-18.waiters2.json":28,"../apis/cloudfront-2018-11-05.min.json":29,"../apis/cloudfront-2018-11-05.paginators.json":30,"../apis/cloudfront-2018-11-05.waiters2.json":31,"../apis/cloudfront-2019-03-26.min.json":32,"../apis/cloudfront-2019-03-26.paginators.json":33,"../apis/cloudfront-2019-03-26.waiters2.json":34,"../apis/cloudfront-2020-05-31.min.json":35,"../apis/cloudfront-2020-05-31.paginators.json":36,"../apis/cloudfront-2020-05-31.waiters2.json":37,"../lib/core":342,"../lib/node_loader":338,"../lib/services/cloudfront":395}],248:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudhsm'] = {};
	AWS.CloudHSM = Service.defineService('cloudhsm', ['2014-05-30']);
	Object.defineProperty(apiLoader.services['cloudhsm'], '2014-05-30', {
	  get: function get() {
	    var model = require('../apis/cloudhsm-2014-05-30.min.json');
	    model.paginators = require('../apis/cloudhsm-2014-05-30.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudHSM;
	
	},{"../apis/cloudhsm-2014-05-30.min.json":38,"../apis/cloudhsm-2014-05-30.paginators.json":39,"../lib/core":342,"../lib/node_loader":338}],249:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudhsmv2'] = {};
	AWS.CloudHSMV2 = Service.defineService('cloudhsmv2', ['2017-04-28']);
	Object.defineProperty(apiLoader.services['cloudhsmv2'], '2017-04-28', {
	  get: function get() {
	    var model = require('../apis/cloudhsmv2-2017-04-28.min.json');
	    model.paginators = require('../apis/cloudhsmv2-2017-04-28.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudHSMV2;
	
	},{"../apis/cloudhsmv2-2017-04-28.min.json":40,"../apis/cloudhsmv2-2017-04-28.paginators.json":41,"../lib/core":342,"../lib/node_loader":338}],250:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudtrail'] = {};
	AWS.CloudTrail = Service.defineService('cloudtrail', ['2013-11-01']);
	Object.defineProperty(apiLoader.services['cloudtrail'], '2013-11-01', {
	  get: function get() {
	    var model = require('../apis/cloudtrail-2013-11-01.min.json');
	    model.paginators = require('../apis/cloudtrail-2013-11-01.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudTrail;
	
	},{"../apis/cloudtrail-2013-11-01.min.json":42,"../apis/cloudtrail-2013-11-01.paginators.json":43,"../lib/core":342,"../lib/node_loader":338}],251:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudwatch'] = {};
	AWS.CloudWatch = Service.defineService('cloudwatch', ['2010-08-01']);
	Object.defineProperty(apiLoader.services['cloudwatch'], '2010-08-01', {
	  get: function get() {
	    var model = require('../apis/monitoring-2010-08-01.min.json');
	    model.paginators = require('../apis/monitoring-2010-08-01.paginators.json').pagination;
	    model.waiters = require('../apis/monitoring-2010-08-01.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudWatch;
	
	},{"../apis/monitoring-2010-08-01.min.json":165,"../apis/monitoring-2010-08-01.paginators.json":166,"../apis/monitoring-2010-08-01.waiters2.json":167,"../lib/core":342,"../lib/node_loader":338}],252:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudwatchevents'] = {};
	AWS.CloudWatchEvents = Service.defineService('cloudwatchevents', ['2014-02-03*', '2015-10-07']);
	Object.defineProperty(apiLoader.services['cloudwatchevents'], '2015-10-07', {
	  get: function get() {
	    var model = require('../apis/events-2015-10-07.min.json');
	    model.paginators = require('../apis/events-2015-10-07.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudWatchEvents;
	
	},{"../apis/events-2015-10-07.min.json":111,"../apis/events-2015-10-07.paginators.json":112,"../lib/core":342,"../lib/node_loader":338}],253:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudwatchlogs'] = {};
	AWS.CloudWatchLogs = Service.defineService('cloudwatchlogs', ['2014-03-28']);
	Object.defineProperty(apiLoader.services['cloudwatchlogs'], '2014-03-28', {
	  get: function get() {
	    var model = require('../apis/logs-2014-03-28.min.json');
	    model.paginators = require('../apis/logs-2014-03-28.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudWatchLogs;
	
	},{"../apis/logs-2014-03-28.min.json":154,"../apis/logs-2014-03-28.paginators.json":155,"../lib/core":342,"../lib/node_loader":338}],254:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['codebuild'] = {};
	AWS.CodeBuild = Service.defineService('codebuild', ['2016-10-06']);
	Object.defineProperty(apiLoader.services['codebuild'], '2016-10-06', {
	  get: function get() {
	    var model = require('../apis/codebuild-2016-10-06.min.json');
	    model.paginators = require('../apis/codebuild-2016-10-06.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CodeBuild;
	
	},{"../apis/codebuild-2016-10-06.min.json":44,"../apis/codebuild-2016-10-06.paginators.json":45,"../lib/core":342,"../lib/node_loader":338}],255:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['codecommit'] = {};
	AWS.CodeCommit = Service.defineService('codecommit', ['2015-04-13']);
	Object.defineProperty(apiLoader.services['codecommit'], '2015-04-13', {
	  get: function get() {
	    var model = require('../apis/codecommit-2015-04-13.min.json');
	    model.paginators = require('../apis/codecommit-2015-04-13.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CodeCommit;
	
	},{"../apis/codecommit-2015-04-13.min.json":46,"../apis/codecommit-2015-04-13.paginators.json":47,"../lib/core":342,"../lib/node_loader":338}],256:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['codedeploy'] = {};
	AWS.CodeDeploy = Service.defineService('codedeploy', ['2014-10-06']);
	Object.defineProperty(apiLoader.services['codedeploy'], '2014-10-06', {
	  get: function get() {
	    var model = require('../apis/codedeploy-2014-10-06.min.json');
	    model.paginators = require('../apis/codedeploy-2014-10-06.paginators.json').pagination;
	    model.waiters = require('../apis/codedeploy-2014-10-06.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CodeDeploy;
	
	},{"../apis/codedeploy-2014-10-06.min.json":48,"../apis/codedeploy-2014-10-06.paginators.json":49,"../apis/codedeploy-2014-10-06.waiters2.json":50,"../lib/core":342,"../lib/node_loader":338}],257:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['codepipeline'] = {};
	AWS.CodePipeline = Service.defineService('codepipeline', ['2015-07-09']);
	Object.defineProperty(apiLoader.services['codepipeline'], '2015-07-09', {
	  get: function get() {
	    var model = require('../apis/codepipeline-2015-07-09.min.json');
	    model.paginators = require('../apis/codepipeline-2015-07-09.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CodePipeline;
	
	},{"../apis/codepipeline-2015-07-09.min.json":51,"../apis/codepipeline-2015-07-09.paginators.json":52,"../lib/core":342,"../lib/node_loader":338}],258:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cognitoidentity'] = {};
	AWS.CognitoIdentity = Service.defineService('cognitoidentity', ['2014-06-30']);
	Object.defineProperty(apiLoader.services['cognitoidentity'], '2014-06-30', {
	  get: function get() {
	    var model = require('../apis/cognito-identity-2014-06-30.min.json');
	    model.paginators = require('../apis/cognito-identity-2014-06-30.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CognitoIdentity;
	
	},{"../apis/cognito-identity-2014-06-30.min.json":53,"../apis/cognito-identity-2014-06-30.paginators.json":54,"../lib/core":342,"../lib/node_loader":338}],259:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cognitoidentityserviceprovider'] = {};
	AWS.CognitoIdentityServiceProvider = Service.defineService('cognitoidentityserviceprovider', ['2016-04-18']);
	Object.defineProperty(apiLoader.services['cognitoidentityserviceprovider'], '2016-04-18', {
	  get: function get() {
	    var model = require('../apis/cognito-idp-2016-04-18.min.json');
	    model.paginators = require('../apis/cognito-idp-2016-04-18.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CognitoIdentityServiceProvider;
	
	},{"../apis/cognito-idp-2016-04-18.min.json":55,"../apis/cognito-idp-2016-04-18.paginators.json":56,"../lib/core":342,"../lib/node_loader":338}],260:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cognitosync'] = {};
	AWS.CognitoSync = Service.defineService('cognitosync', ['2014-06-30']);
	Object.defineProperty(apiLoader.services['cognitosync'], '2014-06-30', {
	  get: function get() {
	    var model = require('../apis/cognito-sync-2014-06-30.min.json');
	    model.paginators = require('../apis/cognito-sync-2014-06-30.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CognitoSync;
	
	},{"../apis/cognito-sync-2014-06-30.min.json":57,"../apis/cognito-sync-2014-06-30.paginators.json":58,"../lib/core":342,"../lib/node_loader":338}],261:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['comprehend'] = {};
	AWS.Comprehend = Service.defineService('comprehend', ['2017-11-27']);
	Object.defineProperty(apiLoader.services['comprehend'], '2017-11-27', {
	  get: function get() {
	    var model = require('../apis/comprehend-2017-11-27.min.json');
	    model.paginators = require('../apis/comprehend-2017-11-27.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Comprehend;
	
	},{"../apis/comprehend-2017-11-27.min.json":59,"../apis/comprehend-2017-11-27.paginators.json":60,"../lib/core":342,"../lib/node_loader":338}],262:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['comprehendmedical'] = {};
	AWS.ComprehendMedical = Service.defineService('comprehendmedical', ['2018-10-30']);
	Object.defineProperty(apiLoader.services['comprehendmedical'], '2018-10-30', {
	  get: function get() {
	    var model = require('../apis/comprehendmedical-2018-10-30.min.json');
	    model.paginators = require('../apis/comprehendmedical-2018-10-30.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ComprehendMedical;
	
	},{"../apis/comprehendmedical-2018-10-30.min.json":61,"../apis/comprehendmedical-2018-10-30.paginators.json":62,"../lib/core":342,"../lib/node_loader":338}],263:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['configservice'] = {};
	AWS.ConfigService = Service.defineService('configservice', ['2014-11-12']);
	Object.defineProperty(apiLoader.services['configservice'], '2014-11-12', {
	  get: function get() {
	    var model = require('../apis/config-2014-11-12.min.json');
	    model.paginators = require('../apis/config-2014-11-12.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ConfigService;
	
	},{"../apis/config-2014-11-12.min.json":63,"../apis/config-2014-11-12.paginators.json":64,"../lib/core":342,"../lib/node_loader":338}],264:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['connect'] = {};
	AWS.Connect = Service.defineService('connect', ['2017-08-08']);
	Object.defineProperty(apiLoader.services['connect'], '2017-08-08', {
	  get: function get() {
	    var model = require('../apis/connect-2017-08-08.min.json');
	    model.paginators = require('../apis/connect-2017-08-08.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Connect;
	
	},{"../apis/connect-2017-08-08.min.json":65,"../apis/connect-2017-08-08.paginators.json":66,"../lib/core":342,"../lib/node_loader":338}],265:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['costexplorer'] = {};
	AWS.CostExplorer = Service.defineService('costexplorer', ['2017-10-25']);
	Object.defineProperty(apiLoader.services['costexplorer'], '2017-10-25', {
	  get: function get() {
	    var model = require('../apis/ce-2017-10-25.min.json');
	    model.paginators = require('../apis/ce-2017-10-25.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CostExplorer;
	
	},{"../apis/ce-2017-10-25.min.json":12,"../apis/ce-2017-10-25.paginators.json":13,"../lib/core":342,"../lib/node_loader":338}],266:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cur'] = {};
	AWS.CUR = Service.defineService('cur', ['2017-01-06']);
	Object.defineProperty(apiLoader.services['cur'], '2017-01-06', {
	  get: function get() {
	    var model = require('../apis/cur-2017-01-06.min.json');
	    model.paginators = require('../apis/cur-2017-01-06.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CUR;
	
	},{"../apis/cur-2017-01-06.min.json":67,"../apis/cur-2017-01-06.paginators.json":68,"../lib/core":342,"../lib/node_loader":338}],267:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['devicefarm'] = {};
	AWS.DeviceFarm = Service.defineService('devicefarm', ['2015-06-23']);
	Object.defineProperty(apiLoader.services['devicefarm'], '2015-06-23', {
	  get: function get() {
	    var model = require('../apis/devicefarm-2015-06-23.min.json');
	    model.paginators = require('../apis/devicefarm-2015-06-23.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.DeviceFarm;
	
	},{"../apis/devicefarm-2015-06-23.min.json":69,"../apis/devicefarm-2015-06-23.paginators.json":70,"../lib/core":342,"../lib/node_loader":338}],268:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['directconnect'] = {};
	AWS.DirectConnect = Service.defineService('directconnect', ['2012-10-25']);
	Object.defineProperty(apiLoader.services['directconnect'], '2012-10-25', {
	  get: function get() {
	    var model = require('../apis/directconnect-2012-10-25.min.json');
	    model.paginators = require('../apis/directconnect-2012-10-25.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.DirectConnect;
	
	},{"../apis/directconnect-2012-10-25.min.json":71,"../apis/directconnect-2012-10-25.paginators.json":72,"../lib/core":342,"../lib/node_loader":338}],269:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['dynamodb'] = {};
	AWS.DynamoDB = Service.defineService('dynamodb', ['2011-12-05', '2012-08-10']);
	require('../lib/services/dynamodb');
	Object.defineProperty(apiLoader.services['dynamodb'], '2011-12-05', {
	  get: function get() {
	    var model = require('../apis/dynamodb-2011-12-05.min.json');
	    model.paginators = require('../apis/dynamodb-2011-12-05.paginators.json').pagination;
	    model.waiters = require('../apis/dynamodb-2011-12-05.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['dynamodb'], '2012-08-10', {
	  get: function get() {
	    var model = require('../apis/dynamodb-2012-08-10.min.json');
	    model.paginators = require('../apis/dynamodb-2012-08-10.paginators.json').pagination;
	    model.waiters = require('../apis/dynamodb-2012-08-10.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.DynamoDB;
	
	},{"../apis/dynamodb-2011-12-05.min.json":73,"../apis/dynamodb-2011-12-05.paginators.json":74,"../apis/dynamodb-2011-12-05.waiters2.json":75,"../apis/dynamodb-2012-08-10.min.json":76,"../apis/dynamodb-2012-08-10.paginators.json":77,"../apis/dynamodb-2012-08-10.waiters2.json":78,"../lib/core":342,"../lib/node_loader":338,"../lib/services/dynamodb":396}],270:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['dynamodbstreams'] = {};
	AWS.DynamoDBStreams = Service.defineService('dynamodbstreams', ['2012-08-10']);
	Object.defineProperty(apiLoader.services['dynamodbstreams'], '2012-08-10', {
	  get: function get() {
	    var model = require('../apis/streams.dynamodb-2012-08-10.min.json');
	    model.paginators = require('../apis/streams.dynamodb-2012-08-10.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.DynamoDBStreams;
	
	},{"../apis/streams.dynamodb-2012-08-10.min.json":228,"../apis/streams.dynamodb-2012-08-10.paginators.json":229,"../lib/core":342,"../lib/node_loader":338}],271:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['ec2'] = {};
	AWS.EC2 = Service.defineService('ec2', ['2013-06-15*', '2013-10-15*', '2014-02-01*', '2014-05-01*', '2014-06-15*', '2014-09-01*', '2014-10-01*', '2015-03-01*', '2015-04-15*', '2015-10-01*', '2016-04-01*', '2016-09-15*', '2016-11-15']);
	require('../lib/services/ec2');
	Object.defineProperty(apiLoader.services['ec2'], '2016-11-15', {
	  get: function get() {
	    var model = require('../apis/ec2-2016-11-15.min.json');
	    model.paginators = require('../apis/ec2-2016-11-15.paginators.json').pagination;
	    model.waiters = require('../apis/ec2-2016-11-15.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.EC2;
	
	},{"../apis/ec2-2016-11-15.min.json":79,"../apis/ec2-2016-11-15.paginators.json":80,"../apis/ec2-2016-11-15.waiters2.json":81,"../lib/core":342,"../lib/node_loader":338,"../lib/services/ec2":397}],272:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['ecr'] = {};
	AWS.ECR = Service.defineService('ecr', ['2015-09-21']);
	Object.defineProperty(apiLoader.services['ecr'], '2015-09-21', {
	  get: function get() {
	    var model = require('../apis/ecr-2015-09-21.min.json');
	    model.paginators = require('../apis/ecr-2015-09-21.paginators.json').pagination;
	    model.waiters = require('../apis/ecr-2015-09-21.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ECR;
	
	},{"../apis/ecr-2015-09-21.min.json":82,"../apis/ecr-2015-09-21.paginators.json":83,"../apis/ecr-2015-09-21.waiters2.json":84,"../lib/core":342,"../lib/node_loader":338}],273:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['ecs'] = {};
	AWS.ECS = Service.defineService('ecs', ['2014-11-13']);
	Object.defineProperty(apiLoader.services['ecs'], '2014-11-13', {
	  get: function get() {
	    var model = require('../apis/ecs-2014-11-13.min.json');
	    model.paginators = require('../apis/ecs-2014-11-13.paginators.json').pagination;
	    model.waiters = require('../apis/ecs-2014-11-13.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ECS;
	
	},{"../apis/ecs-2014-11-13.min.json":85,"../apis/ecs-2014-11-13.paginators.json":86,"../apis/ecs-2014-11-13.waiters2.json":87,"../lib/core":342,"../lib/node_loader":338}],274:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['efs'] = {};
	AWS.EFS = Service.defineService('efs', ['2015-02-01']);
	Object.defineProperty(apiLoader.services['efs'], '2015-02-01', {
	  get: function get() {
	    var model = require('../apis/elasticfilesystem-2015-02-01.min.json');
	    model.paginators = require('../apis/elasticfilesystem-2015-02-01.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.EFS;
	
	},{"../apis/elasticfilesystem-2015-02-01.min.json":94,"../apis/elasticfilesystem-2015-02-01.paginators.json":95,"../lib/core":342,"../lib/node_loader":338}],275:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['elasticache'] = {};
	AWS.ElastiCache = Service.defineService('elasticache', ['2012-11-15*', '2014-03-24*', '2014-07-15*', '2014-09-30*', '2015-02-02']);
	Object.defineProperty(apiLoader.services['elasticache'], '2015-02-02', {
	  get: function get() {
	    var model = require('../apis/elasticache-2015-02-02.min.json');
	    model.paginators = require('../apis/elasticache-2015-02-02.paginators.json').pagination;
	    model.waiters = require('../apis/elasticache-2015-02-02.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ElastiCache;
	
	},{"../apis/elasticache-2015-02-02.min.json":88,"../apis/elasticache-2015-02-02.paginators.json":89,"../apis/elasticache-2015-02-02.waiters2.json":90,"../lib/core":342,"../lib/node_loader":338}],276:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['elasticbeanstalk'] = {};
	AWS.ElasticBeanstalk = Service.defineService('elasticbeanstalk', ['2010-12-01']);
	Object.defineProperty(apiLoader.services['elasticbeanstalk'], '2010-12-01', {
	  get: function get() {
	    var model = require('../apis/elasticbeanstalk-2010-12-01.min.json');
	    model.paginators = require('../apis/elasticbeanstalk-2010-12-01.paginators.json').pagination;
	    model.waiters = require('../apis/elasticbeanstalk-2010-12-01.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ElasticBeanstalk;
	
	},{"../apis/elasticbeanstalk-2010-12-01.min.json":91,"../apis/elasticbeanstalk-2010-12-01.paginators.json":92,"../apis/elasticbeanstalk-2010-12-01.waiters2.json":93,"../lib/core":342,"../lib/node_loader":338}],277:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['elastictranscoder'] = {};
	AWS.ElasticTranscoder = Service.defineService('elastictranscoder', ['2012-09-25']);
	Object.defineProperty(apiLoader.services['elastictranscoder'], '2012-09-25', {
	  get: function get() {
	    var model = require('../apis/elastictranscoder-2012-09-25.min.json');
	    model.paginators = require('../apis/elastictranscoder-2012-09-25.paginators.json').pagination;
	    model.waiters = require('../apis/elastictranscoder-2012-09-25.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ElasticTranscoder;
	
	},{"../apis/elastictranscoder-2012-09-25.min.json":105,"../apis/elastictranscoder-2012-09-25.paginators.json":106,"../apis/elastictranscoder-2012-09-25.waiters2.json":107,"../lib/core":342,"../lib/node_loader":338}],278:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['elb'] = {};
	AWS.ELB = Service.defineService('elb', ['2012-06-01']);
	Object.defineProperty(apiLoader.services['elb'], '2012-06-01', {
	  get: function get() {
	    var model = require('../apis/elasticloadbalancing-2012-06-01.min.json');
	    model.paginators = require('../apis/elasticloadbalancing-2012-06-01.paginators.json').pagination;
	    model.waiters = require('../apis/elasticloadbalancing-2012-06-01.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ELB;
	
	},{"../apis/elasticloadbalancing-2012-06-01.min.json":96,"../apis/elasticloadbalancing-2012-06-01.paginators.json":97,"../apis/elasticloadbalancing-2012-06-01.waiters2.json":98,"../lib/core":342,"../lib/node_loader":338}],279:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['elbv2'] = {};
	AWS.ELBv2 = Service.defineService('elbv2', ['2015-12-01']);
	Object.defineProperty(apiLoader.services['elbv2'], '2015-12-01', {
	  get: function get() {
	    var model = require('../apis/elasticloadbalancingv2-2015-12-01.min.json');
	    model.paginators = require('../apis/elasticloadbalancingv2-2015-12-01.paginators.json').pagination;
	    model.waiters = require('../apis/elasticloadbalancingv2-2015-12-01.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ELBv2;
	
	},{"../apis/elasticloadbalancingv2-2015-12-01.min.json":99,"../apis/elasticloadbalancingv2-2015-12-01.paginators.json":100,"../apis/elasticloadbalancingv2-2015-12-01.waiters2.json":101,"../lib/core":342,"../lib/node_loader":338}],280:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['emr'] = {};
	AWS.EMR = Service.defineService('emr', ['2009-03-31']);
	Object.defineProperty(apiLoader.services['emr'], '2009-03-31', {
	  get: function get() {
	    var model = require('../apis/elasticmapreduce-2009-03-31.min.json');
	    model.paginators = require('../apis/elasticmapreduce-2009-03-31.paginators.json').pagination;
	    model.waiters = require('../apis/elasticmapreduce-2009-03-31.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.EMR;
	
	},{"../apis/elasticmapreduce-2009-03-31.min.json":102,"../apis/elasticmapreduce-2009-03-31.paginators.json":103,"../apis/elasticmapreduce-2009-03-31.waiters2.json":104,"../lib/core":342,"../lib/node_loader":338}],281:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['firehose'] = {};
	AWS.Firehose = Service.defineService('firehose', ['2015-08-04']);
	Object.defineProperty(apiLoader.services['firehose'], '2015-08-04', {
	  get: function get() {
	    var model = require('../apis/firehose-2015-08-04.min.json');
	    model.paginators = require('../apis/firehose-2015-08-04.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Firehose;
	
	},{"../apis/firehose-2015-08-04.min.json":113,"../apis/firehose-2015-08-04.paginators.json":114,"../lib/core":342,"../lib/node_loader":338}],282:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['forecastqueryservice'] = {};
	AWS.ForecastQueryService = Service.defineService('forecastqueryservice', ['2018-06-26']);
	Object.defineProperty(apiLoader.services['forecastqueryservice'], '2018-06-26', {
	  get: function get() {
	    var model = require('../apis/forecastquery-2018-06-26.min.json');
	    model.paginators = require('../apis/forecastquery-2018-06-26.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ForecastQueryService;
	
	},{"../apis/forecastquery-2018-06-26.min.json":117,"../apis/forecastquery-2018-06-26.paginators.json":118,"../lib/core":342,"../lib/node_loader":338}],283:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['forecastservice'] = {};
	AWS.ForecastService = Service.defineService('forecastservice', ['2018-06-26']);
	Object.defineProperty(apiLoader.services['forecastservice'], '2018-06-26', {
	  get: function get() {
	    var model = require('../apis/forecast-2018-06-26.min.json');
	    model.paginators = require('../apis/forecast-2018-06-26.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ForecastService;
	
	},{"../apis/forecast-2018-06-26.min.json":115,"../apis/forecast-2018-06-26.paginators.json":116,"../lib/core":342,"../lib/node_loader":338}],284:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['gamelift'] = {};
	AWS.GameLift = Service.defineService('gamelift', ['2015-10-01']);
	Object.defineProperty(apiLoader.services['gamelift'], '2015-10-01', {
	  get: function get() {
	    var model = require('../apis/gamelift-2015-10-01.min.json');
	    model.paginators = require('../apis/gamelift-2015-10-01.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.GameLift;
	
	},{"../apis/gamelift-2015-10-01.min.json":119,"../apis/gamelift-2015-10-01.paginators.json":120,"../lib/core":342,"../lib/node_loader":338}],285:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['iam'] = {};
	AWS.IAM = Service.defineService('iam', ['2010-05-08']);
	Object.defineProperty(apiLoader.services['iam'], '2010-05-08', {
	  get: function get() {
	    var model = require('../apis/iam-2010-05-08.min.json');
	    model.paginators = require('../apis/iam-2010-05-08.paginators.json').pagination;
	    model.waiters = require('../apis/iam-2010-05-08.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.IAM;
	
	},{"../apis/iam-2010-05-08.min.json":121,"../apis/iam-2010-05-08.paginators.json":122,"../apis/iam-2010-05-08.waiters2.json":123,"../lib/core":342,"../lib/node_loader":338}],286:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['inspector'] = {};
	AWS.Inspector = Service.defineService('inspector', ['2015-08-18*', '2016-02-16']);
	Object.defineProperty(apiLoader.services['inspector'], '2016-02-16', {
	  get: function get() {
	    var model = require('../apis/inspector-2016-02-16.min.json');
	    model.paginators = require('../apis/inspector-2016-02-16.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Inspector;
	
	},{"../apis/inspector-2016-02-16.min.json":124,"../apis/inspector-2016-02-16.paginators.json":125,"../lib/core":342,"../lib/node_loader":338}],287:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['iot'] = {};
	AWS.Iot = Service.defineService('iot', ['2015-05-28']);
	Object.defineProperty(apiLoader.services['iot'], '2015-05-28', {
	  get: function get() {
	    var model = require('../apis/iot-2015-05-28.min.json');
	    model.paginators = require('../apis/iot-2015-05-28.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Iot;
	
	},{"../apis/iot-2015-05-28.min.json":126,"../apis/iot-2015-05-28.paginators.json":127,"../lib/core":342,"../lib/node_loader":338}],288:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['iotanalytics'] = {};
	AWS.IoTAnalytics = Service.defineService('iotanalytics', ['2017-11-27']);
	Object.defineProperty(apiLoader.services['iotanalytics'], '2017-11-27', {
	  get: function get() {
	    var model = require('../apis/iotanalytics-2017-11-27.min.json');
	    model.paginators = require('../apis/iotanalytics-2017-11-27.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.IoTAnalytics;
	
	},{"../apis/iotanalytics-2017-11-27.min.json":130,"../apis/iotanalytics-2017-11-27.paginators.json":131,"../lib/core":342,"../lib/node_loader":338}],289:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['iotdata'] = {};
	AWS.IotData = Service.defineService('iotdata', ['2015-05-28']);
	require('../lib/services/iotdata');
	Object.defineProperty(apiLoader.services['iotdata'], '2015-05-28', {
	  get: function get() {
	    var model = require('../apis/iot-data-2015-05-28.min.json');
	    model.paginators = require('../apis/iot-data-2015-05-28.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.IotData;
	
	},{"../apis/iot-data-2015-05-28.min.json":128,"../apis/iot-data-2015-05-28.paginators.json":129,"../lib/core":342,"../lib/node_loader":338,"../lib/services/iotdata":398}],290:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kinesis'] = {};
	AWS.Kinesis = Service.defineService('kinesis', ['2013-12-02']);
	Object.defineProperty(apiLoader.services['kinesis'], '2013-12-02', {
	  get: function get() {
	    var model = require('../apis/kinesis-2013-12-02.min.json');
	    model.paginators = require('../apis/kinesis-2013-12-02.paginators.json').pagination;
	    model.waiters = require('../apis/kinesis-2013-12-02.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Kinesis;
	
	},{"../apis/kinesis-2013-12-02.min.json":132,"../apis/kinesis-2013-12-02.paginators.json":133,"../apis/kinesis-2013-12-02.waiters2.json":134,"../lib/core":342,"../lib/node_loader":338}],291:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kinesisvideo'] = {};
	AWS.KinesisVideo = Service.defineService('kinesisvideo', ['2017-09-30']);
	Object.defineProperty(apiLoader.services['kinesisvideo'], '2017-09-30', {
	  get: function get() {
	    var model = require('../apis/kinesisvideo-2017-09-30.min.json');
	    model.paginators = require('../apis/kinesisvideo-2017-09-30.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.KinesisVideo;
	
	},{"../apis/kinesisvideo-2017-09-30.min.json":141,"../apis/kinesisvideo-2017-09-30.paginators.json":142,"../lib/core":342,"../lib/node_loader":338}],292:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kinesisvideoarchivedmedia'] = {};
	AWS.KinesisVideoArchivedMedia = Service.defineService('kinesisvideoarchivedmedia', ['2017-09-30']);
	Object.defineProperty(apiLoader.services['kinesisvideoarchivedmedia'], '2017-09-30', {
	  get: function get() {
	    var model = require('../apis/kinesis-video-archived-media-2017-09-30.min.json');
	    model.paginators = require('../apis/kinesis-video-archived-media-2017-09-30.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.KinesisVideoArchivedMedia;
	
	},{"../apis/kinesis-video-archived-media-2017-09-30.min.json":135,"../apis/kinesis-video-archived-media-2017-09-30.paginators.json":136,"../lib/core":342,"../lib/node_loader":338}],293:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kinesisvideomedia'] = {};
	AWS.KinesisVideoMedia = Service.defineService('kinesisvideomedia', ['2017-09-30']);
	Object.defineProperty(apiLoader.services['kinesisvideomedia'], '2017-09-30', {
	  get: function get() {
	    var model = require('../apis/kinesis-video-media-2017-09-30.min.json');
	    model.paginators = require('../apis/kinesis-video-media-2017-09-30.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.KinesisVideoMedia;
	
	},{"../apis/kinesis-video-media-2017-09-30.min.json":137,"../apis/kinesis-video-media-2017-09-30.paginators.json":138,"../lib/core":342,"../lib/node_loader":338}],294:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kinesisvideosignalingchannels'] = {};
	AWS.KinesisVideoSignalingChannels = Service.defineService('kinesisvideosignalingchannels', ['2019-12-04']);
	Object.defineProperty(apiLoader.services['kinesisvideosignalingchannels'], '2019-12-04', {
	  get: function get() {
	    var model = require('../apis/kinesis-video-signaling-2019-12-04.min.json');
	    model.paginators = require('../apis/kinesis-video-signaling-2019-12-04.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.KinesisVideoSignalingChannels;
	
	},{"../apis/kinesis-video-signaling-2019-12-04.min.json":139,"../apis/kinesis-video-signaling-2019-12-04.paginators.json":140,"../lib/core":342,"../lib/node_loader":338}],295:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kms'] = {};
	AWS.KMS = Service.defineService('kms', ['2014-11-01']);
	Object.defineProperty(apiLoader.services['kms'], '2014-11-01', {
	  get: function get() {
	    var model = require('../apis/kms-2014-11-01.min.json');
	    model.paginators = require('../apis/kms-2014-11-01.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.KMS;
	
	},{"../apis/kms-2014-11-01.min.json":143,"../apis/kms-2014-11-01.paginators.json":144,"../lib/core":342,"../lib/node_loader":338}],296:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['lambda'] = {};
	AWS.Lambda = Service.defineService('lambda', ['2014-11-11', '2015-03-31']);
	require('../lib/services/lambda');
	Object.defineProperty(apiLoader.services['lambda'], '2014-11-11', {
	  get: function get() {
	    var model = require('../apis/lambda-2014-11-11.min.json');
	    model.paginators = require('../apis/lambda-2014-11-11.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['lambda'], '2015-03-31', {
	  get: function get() {
	    var model = require('../apis/lambda-2015-03-31.min.json');
	    model.paginators = require('../apis/lambda-2015-03-31.paginators.json').pagination;
	    model.waiters = require('../apis/lambda-2015-03-31.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Lambda;
	
	},{"../apis/lambda-2014-11-11.min.json":145,"../apis/lambda-2014-11-11.paginators.json":146,"../apis/lambda-2015-03-31.min.json":147,"../apis/lambda-2015-03-31.paginators.json":148,"../apis/lambda-2015-03-31.waiters2.json":149,"../lib/core":342,"../lib/node_loader":338,"../lib/services/lambda":399}],297:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['lexmodelbuildingservice'] = {};
	AWS.LexModelBuildingService = Service.defineService('lexmodelbuildingservice', ['2017-04-19']);
	Object.defineProperty(apiLoader.services['lexmodelbuildingservice'], '2017-04-19', {
	  get: function get() {
	    var model = require('../apis/lex-models-2017-04-19.min.json');
	    model.paginators = require('../apis/lex-models-2017-04-19.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.LexModelBuildingService;
	
	},{"../apis/lex-models-2017-04-19.min.json":150,"../apis/lex-models-2017-04-19.paginators.json":151,"../lib/core":342,"../lib/node_loader":338}],298:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['lexruntime'] = {};
	AWS.LexRuntime = Service.defineService('lexruntime', ['2016-11-28']);
	Object.defineProperty(apiLoader.services['lexruntime'], '2016-11-28', {
	  get: function get() {
	    var model = require('../apis/runtime.lex-2016-11-28.min.json');
	    model.paginators = require('../apis/runtime.lex-2016-11-28.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.LexRuntime;
	
	},{"../apis/runtime.lex-2016-11-28.min.json":208,"../apis/runtime.lex-2016-11-28.paginators.json":209,"../lib/core":342,"../lib/node_loader":338}],299:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['lexruntimev2'] = {};
	AWS.LexRuntimeV2 = Service.defineService('lexruntimev2', ['2020-08-07']);
	Object.defineProperty(apiLoader.services['lexruntimev2'], '2020-08-07', {
	  get: function get() {
	    var model = require('../apis/runtime.lex.v2-2020-08-07.min.json');
	    model.paginators = require('../apis/runtime.lex.v2-2020-08-07.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.LexRuntimeV2;
	
	},{"../apis/runtime.lex.v2-2020-08-07.min.json":210,"../apis/runtime.lex.v2-2020-08-07.paginators.json":211,"../lib/core":342,"../lib/node_loader":338}],300:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['location'] = {};
	AWS.Location = Service.defineService('location', ['2020-11-19']);
	Object.defineProperty(apiLoader.services['location'], '2020-11-19', {
	  get: function get() {
	    var model = require('../apis/location-2020-11-19.min.json');
	    model.paginators = require('../apis/location-2020-11-19.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Location;
	
	},{"../apis/location-2020-11-19.min.json":152,"../apis/location-2020-11-19.paginators.json":153,"../lib/core":342,"../lib/node_loader":338}],301:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['machinelearning'] = {};
	AWS.MachineLearning = Service.defineService('machinelearning', ['2014-12-12']);
	require('../lib/services/machinelearning');
	Object.defineProperty(apiLoader.services['machinelearning'], '2014-12-12', {
	  get: function get() {
	    var model = require('../apis/machinelearning-2014-12-12.min.json');
	    model.paginators = require('../apis/machinelearning-2014-12-12.paginators.json').pagination;
	    model.waiters = require('../apis/machinelearning-2014-12-12.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.MachineLearning;
	
	},{"../apis/machinelearning-2014-12-12.min.json":156,"../apis/machinelearning-2014-12-12.paginators.json":157,"../apis/machinelearning-2014-12-12.waiters2.json":158,"../lib/core":342,"../lib/node_loader":338,"../lib/services/machinelearning":400}],302:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['marketplacecommerceanalytics'] = {};
	AWS.MarketplaceCommerceAnalytics = Service.defineService('marketplacecommerceanalytics', ['2015-07-01']);
	Object.defineProperty(apiLoader.services['marketplacecommerceanalytics'], '2015-07-01', {
	  get: function get() {
	    var model = require('../apis/marketplacecommerceanalytics-2015-07-01.min.json');
	    model.paginators = require('../apis/marketplacecommerceanalytics-2015-07-01.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.MarketplaceCommerceAnalytics;
	
	},{"../apis/marketplacecommerceanalytics-2015-07-01.min.json":159,"../apis/marketplacecommerceanalytics-2015-07-01.paginators.json":160,"../lib/core":342,"../lib/node_loader":338}],303:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['mediastoredata'] = {};
	AWS.MediaStoreData = Service.defineService('mediastoredata', ['2017-09-01']);
	Object.defineProperty(apiLoader.services['mediastoredata'], '2017-09-01', {
	  get: function get() {
	    var model = require('../apis/mediastore-data-2017-09-01.min.json');
	    model.paginators = require('../apis/mediastore-data-2017-09-01.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.MediaStoreData;
	
	},{"../apis/mediastore-data-2017-09-01.min.json":161,"../apis/mediastore-data-2017-09-01.paginators.json":162,"../lib/core":342,"../lib/node_loader":338}],304:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['mobileanalytics'] = {};
	AWS.MobileAnalytics = Service.defineService('mobileanalytics', ['2014-06-05']);
	Object.defineProperty(apiLoader.services['mobileanalytics'], '2014-06-05', {
	  get: function get() {
	    var model = require('../apis/mobileanalytics-2014-06-05.min.json');
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.MobileAnalytics;
	
	},{"../apis/mobileanalytics-2014-06-05.min.json":164,"../lib/core":342,"../lib/node_loader":338}],305:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['mturk'] = {};
	AWS.MTurk = Service.defineService('mturk', ['2017-01-17']);
	Object.defineProperty(apiLoader.services['mturk'], '2017-01-17', {
	  get: function get() {
	    var model = require('../apis/mturk-requester-2017-01-17.min.json');
	    model.paginators = require('../apis/mturk-requester-2017-01-17.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.MTurk;
	
	},{"../apis/mturk-requester-2017-01-17.min.json":168,"../apis/mturk-requester-2017-01-17.paginators.json":169,"../lib/core":342,"../lib/node_loader":338}],306:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['opsworks'] = {};
	AWS.OpsWorks = Service.defineService('opsworks', ['2013-02-18']);
	Object.defineProperty(apiLoader.services['opsworks'], '2013-02-18', {
	  get: function get() {
	    var model = require('../apis/opsworks-2013-02-18.min.json');
	    model.paginators = require('../apis/opsworks-2013-02-18.paginators.json').pagination;
	    model.waiters = require('../apis/opsworks-2013-02-18.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.OpsWorks;
	
	},{"../apis/opsworks-2013-02-18.min.json":170,"../apis/opsworks-2013-02-18.paginators.json":171,"../apis/opsworks-2013-02-18.waiters2.json":172,"../lib/core":342,"../lib/node_loader":338}],307:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['personalize'] = {};
	AWS.Personalize = Service.defineService('personalize', ['2018-05-22']);
	Object.defineProperty(apiLoader.services['personalize'], '2018-05-22', {
	  get: function get() {
	    var model = require('../apis/personalize-2018-05-22.min.json');
	    model.paginators = require('../apis/personalize-2018-05-22.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Personalize;
	
	},{"../apis/personalize-2018-05-22.min.json":173,"../apis/personalize-2018-05-22.paginators.json":174,"../lib/core":342,"../lib/node_loader":338}],308:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['personalizeevents'] = {};
	AWS.PersonalizeEvents = Service.defineService('personalizeevents', ['2018-03-22']);
	Object.defineProperty(apiLoader.services['personalizeevents'], '2018-03-22', {
	  get: function get() {
	    var model = require('../apis/personalize-events-2018-03-22.min.json');
	    model.paginators = require('../apis/personalize-events-2018-03-22.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.PersonalizeEvents;
	
	},{"../apis/personalize-events-2018-03-22.min.json":175,"../apis/personalize-events-2018-03-22.paginators.json":176,"../lib/core":342,"../lib/node_loader":338}],309:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['personalizeruntime'] = {};
	AWS.PersonalizeRuntime = Service.defineService('personalizeruntime', ['2018-05-22']);
	Object.defineProperty(apiLoader.services['personalizeruntime'], '2018-05-22', {
	  get: function get() {
	    var model = require('../apis/personalize-runtime-2018-05-22.min.json');
	    model.paginators = require('../apis/personalize-runtime-2018-05-22.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.PersonalizeRuntime;
	
	},{"../apis/personalize-runtime-2018-05-22.min.json":177,"../apis/personalize-runtime-2018-05-22.paginators.json":178,"../lib/core":342,"../lib/node_loader":338}],310:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['polly'] = {};
	AWS.Polly = Service.defineService('polly', ['2016-06-10']);
	require('../lib/services/polly');
	Object.defineProperty(apiLoader.services['polly'], '2016-06-10', {
	  get: function get() {
	    var model = require('../apis/polly-2016-06-10.min.json');
	    model.paginators = require('../apis/polly-2016-06-10.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Polly;
	
	},{"../apis/polly-2016-06-10.min.json":179,"../apis/polly-2016-06-10.paginators.json":180,"../lib/core":342,"../lib/node_loader":338,"../lib/services/polly":401}],311:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['pricing'] = {};
	AWS.Pricing = Service.defineService('pricing', ['2017-10-15']);
	Object.defineProperty(apiLoader.services['pricing'], '2017-10-15', {
	  get: function get() {
	    var model = require('../apis/pricing-2017-10-15.min.json');
	    model.paginators = require('../apis/pricing-2017-10-15.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Pricing;
	
	},{"../apis/pricing-2017-10-15.min.json":181,"../apis/pricing-2017-10-15.paginators.json":182,"../lib/core":342,"../lib/node_loader":338}],312:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['rds'] = {};
	AWS.RDS = Service.defineService('rds', ['2013-01-10', '2013-02-12', '2013-09-09', '2014-09-01', '2014-09-01*', '2014-10-31']);
	require('../lib/services/rds');
	Object.defineProperty(apiLoader.services['rds'], '2013-01-10', {
	  get: function get() {
	    var model = require('../apis/rds-2013-01-10.min.json');
	    model.paginators = require('../apis/rds-2013-01-10.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2013-02-12', {
	  get: function get() {
	    var model = require('../apis/rds-2013-02-12.min.json');
	    model.paginators = require('../apis/rds-2013-02-12.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2013-09-09', {
	  get: function get() {
	    var model = require('../apis/rds-2013-09-09.min.json');
	    model.paginators = require('../apis/rds-2013-09-09.paginators.json').pagination;
	    model.waiters = require('../apis/rds-2013-09-09.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2014-09-01', {
	  get: function get() {
	    var model = require('../apis/rds-2014-09-01.min.json');
	    model.paginators = require('../apis/rds-2014-09-01.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2014-10-31', {
	  get: function get() {
	    var model = require('../apis/rds-2014-10-31.min.json');
	    model.paginators = require('../apis/rds-2014-10-31.paginators.json').pagination;
	    model.waiters = require('../apis/rds-2014-10-31.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.RDS;
	
	},{"../apis/rds-2013-01-10.min.json":183,"../apis/rds-2013-01-10.paginators.json":184,"../apis/rds-2013-02-12.min.json":185,"../apis/rds-2013-02-12.paginators.json":186,"../apis/rds-2013-09-09.min.json":187,"../apis/rds-2013-09-09.paginators.json":188,"../apis/rds-2013-09-09.waiters2.json":189,"../apis/rds-2014-09-01.min.json":190,"../apis/rds-2014-09-01.paginators.json":191,"../apis/rds-2014-10-31.min.json":192,"../apis/rds-2014-10-31.paginators.json":193,"../apis/rds-2014-10-31.waiters2.json":194,"../lib/core":342,"../lib/node_loader":338,"../lib/services/rds":402}],313:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['redshift'] = {};
	AWS.Redshift = Service.defineService('redshift', ['2012-12-01']);
	Object.defineProperty(apiLoader.services['redshift'], '2012-12-01', {
	  get: function get() {
	    var model = require('../apis/redshift-2012-12-01.min.json');
	    model.paginators = require('../apis/redshift-2012-12-01.paginators.json').pagination;
	    model.waiters = require('../apis/redshift-2012-12-01.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Redshift;
	
	},{"../apis/redshift-2012-12-01.min.json":195,"../apis/redshift-2012-12-01.paginators.json":196,"../apis/redshift-2012-12-01.waiters2.json":197,"../lib/core":342,"../lib/node_loader":338}],314:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['rekognition'] = {};
	AWS.Rekognition = Service.defineService('rekognition', ['2016-06-27']);
	Object.defineProperty(apiLoader.services['rekognition'], '2016-06-27', {
	  get: function get() {
	    var model = require('../apis/rekognition-2016-06-27.min.json');
	    model.paginators = require('../apis/rekognition-2016-06-27.paginators.json').pagination;
	    model.waiters = require('../apis/rekognition-2016-06-27.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Rekognition;
	
	},{"../apis/rekognition-2016-06-27.min.json":198,"../apis/rekognition-2016-06-27.paginators.json":199,"../apis/rekognition-2016-06-27.waiters2.json":200,"../lib/core":342,"../lib/node_loader":338}],315:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['resourcegroups'] = {};
	AWS.ResourceGroups = Service.defineService('resourcegroups', ['2017-11-27']);
	Object.defineProperty(apiLoader.services['resourcegroups'], '2017-11-27', {
	  get: function get() {
	    var model = require('../apis/resource-groups-2017-11-27.min.json');
	    model.paginators = require('../apis/resource-groups-2017-11-27.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ResourceGroups;
	
	},{"../apis/resource-groups-2017-11-27.min.json":201,"../apis/resource-groups-2017-11-27.paginators.json":202,"../lib/core":342,"../lib/node_loader":338}],316:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['route53'] = {};
	AWS.Route53 = Service.defineService('route53', ['2013-04-01']);
	require('../lib/services/route53');
	Object.defineProperty(apiLoader.services['route53'], '2013-04-01', {
	  get: function get() {
	    var model = require('../apis/route53-2013-04-01.min.json');
	    model.paginators = require('../apis/route53-2013-04-01.paginators.json').pagination;
	    model.waiters = require('../apis/route53-2013-04-01.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Route53;
	
	},{"../apis/route53-2013-04-01.min.json":203,"../apis/route53-2013-04-01.paginators.json":204,"../apis/route53-2013-04-01.waiters2.json":205,"../lib/core":342,"../lib/node_loader":338,"../lib/services/route53":404}],317:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['route53domains'] = {};
	AWS.Route53Domains = Service.defineService('route53domains', ['2014-05-15']);
	Object.defineProperty(apiLoader.services['route53domains'], '2014-05-15', {
	  get: function get() {
	    var model = require('../apis/route53domains-2014-05-15.min.json');
	    model.paginators = require('../apis/route53domains-2014-05-15.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Route53Domains;
	
	},{"../apis/route53domains-2014-05-15.min.json":206,"../apis/route53domains-2014-05-15.paginators.json":207,"../lib/core":342,"../lib/node_loader":338}],318:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['s3'] = {};
	AWS.S3 = Service.defineService('s3', ['2006-03-01']);
	require('../lib/services/s3');
	Object.defineProperty(apiLoader.services['s3'], '2006-03-01', {
	  get: function get() {
	    var model = require('../apis/s3-2006-03-01.min.json');
	    model.paginators = require('../apis/s3-2006-03-01.paginators.json').pagination;
	    model.waiters = require('../apis/s3-2006-03-01.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.S3;
	
	},{"../apis/s3-2006-03-01.min.json":212,"../apis/s3-2006-03-01.paginators.json":213,"../apis/s3-2006-03-01.waiters2.json":214,"../lib/core":342,"../lib/node_loader":338,"../lib/services/s3":405}],319:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['secretsmanager'] = {};
	AWS.SecretsManager = Service.defineService('secretsmanager', ['2017-10-17']);
	Object.defineProperty(apiLoader.services['secretsmanager'], '2017-10-17', {
	  get: function get() {
	    var model = require('../apis/secretsmanager-2017-10-17.min.json');
	    model.paginators = require('../apis/secretsmanager-2017-10-17.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.SecretsManager;
	
	},{"../apis/secretsmanager-2017-10-17.min.json":215,"../apis/secretsmanager-2017-10-17.paginators.json":216,"../lib/core":342,"../lib/node_loader":338}],320:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['servicecatalog'] = {};
	AWS.ServiceCatalog = Service.defineService('servicecatalog', ['2015-12-10']);
	Object.defineProperty(apiLoader.services['servicecatalog'], '2015-12-10', {
	  get: function get() {
	    var model = require('../apis/servicecatalog-2015-12-10.min.json');
	    model.paginators = require('../apis/servicecatalog-2015-12-10.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ServiceCatalog;
	
	},{"../apis/servicecatalog-2015-12-10.min.json":217,"../apis/servicecatalog-2015-12-10.paginators.json":218,"../lib/core":342,"../lib/node_loader":338}],321:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['ses'] = {};
	AWS.SES = Service.defineService('ses', ['2010-12-01']);
	Object.defineProperty(apiLoader.services['ses'], '2010-12-01', {
	  get: function get() {
	    var model = require('../apis/email-2010-12-01.min.json');
	    model.paginators = require('../apis/email-2010-12-01.paginators.json').pagination;
	    model.waiters = require('../apis/email-2010-12-01.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.SES;
	
	},{"../apis/email-2010-12-01.min.json":108,"../apis/email-2010-12-01.paginators.json":109,"../apis/email-2010-12-01.waiters2.json":110,"../lib/core":342,"../lib/node_loader":338}],322:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['sns'] = {};
	AWS.SNS = Service.defineService('sns', ['2010-03-31']);
	Object.defineProperty(apiLoader.services['sns'], '2010-03-31', {
	  get: function get() {
	    var model = require('../apis/sns-2010-03-31.min.json');
	    model.paginators = require('../apis/sns-2010-03-31.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.SNS;
	
	},{"../apis/sns-2010-03-31.min.json":219,"../apis/sns-2010-03-31.paginators.json":220,"../lib/core":342,"../lib/node_loader":338}],323:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['sqs'] = {};
	AWS.SQS = Service.defineService('sqs', ['2012-11-05']);
	require('../lib/services/sqs');
	Object.defineProperty(apiLoader.services['sqs'], '2012-11-05', {
	  get: function get() {
	    var model = require('../apis/sqs-2012-11-05.min.json');
	    model.paginators = require('../apis/sqs-2012-11-05.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.SQS;
	
	},{"../apis/sqs-2012-11-05.min.json":221,"../apis/sqs-2012-11-05.paginators.json":222,"../lib/core":342,"../lib/node_loader":338,"../lib/services/sqs":407}],324:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['ssm'] = {};
	AWS.SSM = Service.defineService('ssm', ['2014-11-06']);
	Object.defineProperty(apiLoader.services['ssm'], '2014-11-06', {
	  get: function get() {
	    var model = require('../apis/ssm-2014-11-06.min.json');
	    model.paginators = require('../apis/ssm-2014-11-06.paginators.json').pagination;
	    model.waiters = require('../apis/ssm-2014-11-06.waiters2.json').waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.SSM;
	
	},{"../apis/ssm-2014-11-06.min.json":223,"../apis/ssm-2014-11-06.paginators.json":224,"../apis/ssm-2014-11-06.waiters2.json":225,"../lib/core":342,"../lib/node_loader":338}],325:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['storagegateway'] = {};
	AWS.StorageGateway = Service.defineService('storagegateway', ['2013-06-30']);
	Object.defineProperty(apiLoader.services['storagegateway'], '2013-06-30', {
	  get: function get() {
	    var model = require('../apis/storagegateway-2013-06-30.min.json');
	    model.paginators = require('../apis/storagegateway-2013-06-30.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.StorageGateway;
	
	},{"../apis/storagegateway-2013-06-30.min.json":226,"../apis/storagegateway-2013-06-30.paginators.json":227,"../lib/core":342,"../lib/node_loader":338}],326:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['sts'] = {};
	AWS.STS = Service.defineService('sts', ['2011-06-15']);
	require('../lib/services/sts');
	Object.defineProperty(apiLoader.services['sts'], '2011-06-15', {
	  get: function get() {
	    var model = require('../apis/sts-2011-06-15.min.json');
	    model.paginators = require('../apis/sts-2011-06-15.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.STS;
	
	},{"../apis/sts-2011-06-15.min.json":230,"../apis/sts-2011-06-15.paginators.json":231,"../lib/core":342,"../lib/node_loader":338,"../lib/services/sts":408}],327:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['translate'] = {};
	AWS.Translate = Service.defineService('translate', ['2017-07-01']);
	Object.defineProperty(apiLoader.services['translate'], '2017-07-01', {
	  get: function get() {
	    var model = require('../apis/translate-2017-07-01.min.json');
	    model.paginators = require('../apis/translate-2017-07-01.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Translate;
	
	},{"../apis/translate-2017-07-01.min.json":232,"../apis/translate-2017-07-01.paginators.json":233,"../lib/core":342,"../lib/node_loader":338}],328:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['waf'] = {};
	AWS.WAF = Service.defineService('waf', ['2015-08-24']);
	Object.defineProperty(apiLoader.services['waf'], '2015-08-24', {
	  get: function get() {
	    var model = require('../apis/waf-2015-08-24.min.json');
	    model.paginators = require('../apis/waf-2015-08-24.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.WAF;
	
	},{"../apis/waf-2015-08-24.min.json":234,"../apis/waf-2015-08-24.paginators.json":235,"../lib/core":342,"../lib/node_loader":338}],329:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['workdocs'] = {};
	AWS.WorkDocs = Service.defineService('workdocs', ['2016-05-01']);
	Object.defineProperty(apiLoader.services['workdocs'], '2016-05-01', {
	  get: function get() {
	    var model = require('../apis/workdocs-2016-05-01.min.json');
	    model.paginators = require('../apis/workdocs-2016-05-01.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.WorkDocs;
	
	},{"../apis/workdocs-2016-05-01.min.json":236,"../apis/workdocs-2016-05-01.paginators.json":237,"../lib/core":342,"../lib/node_loader":338}],330:[function(require,module,exports){
	require('../lib/node_loader');
	var AWS = require('../lib/core');
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['xray'] = {};
	AWS.XRay = Service.defineService('xray', ['2016-04-12']);
	Object.defineProperty(apiLoader.services['xray'], '2016-04-12', {
	  get: function get() {
	    var model = require('../apis/xray-2016-04-12.min.json');
	    model.paginators = require('../apis/xray-2016-04-12.paginators.json').pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.XRay;
	
	},{"../apis/xray-2016-04-12.min.json":238,"../apis/xray-2016-04-12.paginators.json":239,"../lib/core":342,"../lib/node_loader":338}],331:[function(require,module,exports){
	function apiLoader(svc, version) {
	  if (!apiLoader.services.hasOwnProperty(svc)) {
	    throw new Error('InvalidService: Failed to load api for ' + svc);
	  }
	  return apiLoader.services[svc][version];
	}
	
	/**
	 * @api private
	 *
	 * This member of AWS.apiLoader is private, but changing it will necessitate a
	 * change to ../scripts/services-table-generator.ts
	 */
	apiLoader.services = {};
	
	/**
	 * @api private
	 */
	module.exports = apiLoader;
	
	},{}],332:[function(require,module,exports){
	var Hmac = require('./browserHmac');
	var Md5 = require('./browserMd5');
	var Sha1 = require('./browserSha1');
	var Sha256 = require('./browserSha256');
	
	/**
	 * @api private
	 */
	module.exports = exports = {
	    createHash: function createHash(alg) {
	      alg = alg.toLowerCase();
	      if (alg === 'md5') {
	        return new Md5();
	      } else if (alg === 'sha256') {
	        return new Sha256();
	      } else if (alg === 'sha1') {
	        return new Sha1();
	      }
	
	      throw new Error('Hash algorithm ' + alg + ' is not supported in the browser SDK');
	    },
	    createHmac: function createHmac(alg, key) {
	      alg = alg.toLowerCase();
	      if (alg === 'md5') {
	        return new Hmac(Md5, key);
	      } else if (alg === 'sha256') {
	        return new Hmac(Sha256, key);
	      } else if (alg === 'sha1') {
	        return new Hmac(Sha1, key);
	      }
	
	      throw new Error('HMAC algorithm ' + alg + ' is not supported in the browser SDK');
	    },
	    createSign: function() {
	      throw new Error('createSign is not implemented in the browser');
	    }
	  };
	
	},{"./browserHmac":334,"./browserMd5":335,"./browserSha1":336,"./browserSha256":337}],333:[function(require,module,exports){
	var Buffer = require('buffer/').Buffer;
	
	/**
	 * This is a polyfill for the static method `isView` of `ArrayBuffer`, which is
	 * e.g. missing in IE 10.
	 *
	 * @api private
	 */
	if (
	    typeof ArrayBuffer !== 'undefined' &&
	    typeof ArrayBuffer.isView === 'undefined'
	) {
	    ArrayBuffer.isView = function(arg) {
	        return viewStrings.indexOf(Object.prototype.toString.call(arg)) > -1;
	    };
	}
	
	/**
	 * @api private
	 */
	var viewStrings = [
	    '[object Int8Array]',
	    '[object Uint8Array]',
	    '[object Uint8ClampedArray]',
	    '[object Int16Array]',
	    '[object Uint16Array]',
	    '[object Int32Array]',
	    '[object Uint32Array]',
	    '[object Float32Array]',
	    '[object Float64Array]',
	    '[object DataView]',
	];
	
	/**
	 * @api private
	 */
	function isEmptyData(data) {
	    if (typeof data === 'string') {
	        return data.length === 0;
	    }
	    return data.byteLength === 0;
	}
	
	/**
	 * @api private
	 */
	function convertToBuffer(data) {
	    if (typeof data === 'string') {
	        data = new Buffer(data, 'utf8');
	    }
	
	    if (ArrayBuffer.isView(data)) {
	        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
	    }
	
	    return new Uint8Array(data);
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = {
	    isEmptyData: isEmptyData,
	    convertToBuffer: convertToBuffer,
	};
	
	},{"buffer/":427}],334:[function(require,module,exports){
	var hashUtils = require('./browserHashUtils');
	
	/**
	 * @api private
	 */
	function Hmac(hashCtor, secret) {
	    this.hash = new hashCtor();
	    this.outer = new hashCtor();
	
	    var inner = bufferFromSecret(hashCtor, secret);
	    var outer = new Uint8Array(hashCtor.BLOCK_SIZE);
	    outer.set(inner);
	
	    for (var i = 0; i < hashCtor.BLOCK_SIZE; i++) {
	        inner[i] ^= 0x36;
	        outer[i] ^= 0x5c;
	    }
	
	    this.hash.update(inner);
	    this.outer.update(outer);
	
	    // Zero out the copied key buffer.
	    for (var i = 0; i < inner.byteLength; i++) {
	        inner[i] = 0;
	    }
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Hmac;
	
	Hmac.prototype.update = function (toHash) {
	    if (hashUtils.isEmptyData(toHash) || this.error) {
	        return this;
	    }
	
	    try {
	        this.hash.update(hashUtils.convertToBuffer(toHash));
	    } catch (e) {
	        this.error = e;
	    }
	
	    return this;
	};
	
	Hmac.prototype.digest = function (encoding) {
	    if (!this.outer.finished) {
	        this.outer.update(this.hash.digest());
	    }
	
	    return this.outer.digest(encoding);
	};
	
	function bufferFromSecret(hashCtor, secret) {
	    var input = hashUtils.convertToBuffer(secret);
	    if (input.byteLength > hashCtor.BLOCK_SIZE) {
	        var bufferHash = new hashCtor;
	        bufferHash.update(input);
	        input = bufferHash.digest();
	    }
	    var buffer = new Uint8Array(hashCtor.BLOCK_SIZE);
	    buffer.set(input);
	    return buffer;
	}
	
	},{"./browserHashUtils":333}],335:[function(require,module,exports){
	var hashUtils = require('./browserHashUtils');
	var Buffer = require('buffer/').Buffer;
	
	var BLOCK_SIZE = 64;
	
	var DIGEST_LENGTH = 16;
	
	var INIT = [
	    0x67452301,
	    0xefcdab89,
	    0x98badcfe,
	    0x10325476,
	];
	
	/**
	 * @api private
	 */
	function Md5() {
	    this.state = [
	        0x67452301,
	        0xefcdab89,
	        0x98badcfe,
	        0x10325476,
	    ];
	    this.buffer = new DataView(new ArrayBuffer(BLOCK_SIZE));
	    this.bufferLength = 0;
	    this.bytesHashed = 0;
	    this.finished = false;
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Md5;
	
	Md5.BLOCK_SIZE = BLOCK_SIZE;
	
	Md5.prototype.update = function (sourceData) {
	    if (hashUtils.isEmptyData(sourceData)) {
	        return this;
	    } else if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }
	
	    var data = hashUtils.convertToBuffer(sourceData);
	    var position = 0;
	    var byteLength = data.byteLength;
	    this.bytesHashed += byteLength;
	    while (byteLength > 0) {
	        this.buffer.setUint8(this.bufferLength++, data[position++]);
	        byteLength--;
	        if (this.bufferLength === BLOCK_SIZE) {
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	    }
	
	    return this;
	};
	
	Md5.prototype.digest = function (encoding) {
	    if (!this.finished) {
	        var _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
	        var bitsHashed = bytesHashed * 8;
	        buffer.setUint8(this.bufferLength++, 128);
	        // Ensure the final block has enough room for the hashed length
	        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
	            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
	                buffer.setUint8(i, 0);
	            }
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
	            buffer.setUint8(i, 0);
	        }
	        buffer.setUint32(BLOCK_SIZE - 8, bitsHashed >>> 0, true);
	        buffer.setUint32(BLOCK_SIZE - 4, Math.floor(bitsHashed / 0x100000000), true);
	        this.hashBuffer();
	        this.finished = true;
	    }
	    var out = new DataView(new ArrayBuffer(DIGEST_LENGTH));
	    for (var i = 0; i < 4; i++) {
	        out.setUint32(i * 4, this.state[i], true);
	    }
	    var buff = new Buffer(out.buffer, out.byteOffset, out.byteLength);
	    return encoding ? buff.toString(encoding) : buff;
	};
	
	Md5.prototype.hashBuffer = function () {
	    var _a = this, buffer = _a.buffer, state = _a.state;
	    var a = state[0], b = state[1], c = state[2], d = state[3];
	    a = ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
	    d = ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
	    c = ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
	    b = ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
	    a = ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
	    d = ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
	    c = ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
	    b = ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
	    a = ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
	    d = ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
	    c = ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
	    b = ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
	    a = ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
	    d = ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
	    c = ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
	    b = ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
	    a = gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
	    d = gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
	    c = gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
	    b = gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
	    a = gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
	    d = gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
	    c = gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
	    b = gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
	    a = gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
	    d = gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
	    c = gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
	    b = gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
	    a = gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
	    d = gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
	    c = gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
	    b = gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
	    a = hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
	    d = hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
	    c = hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
	    b = hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
	    a = hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
	    d = hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
	    c = hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
	    b = hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
	    a = hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
	    d = hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
	    c = hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
	    b = hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
	    a = hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
	    d = hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
	    c = hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
	    b = hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
	    a = ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
	    d = ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
	    c = ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
	    b = ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
	    a = ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
	    d = ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
	    c = ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
	    b = ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
	    a = ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
	    d = ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
	    c = ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
	    b = ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
	    a = ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
	    d = ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
	    c = ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
	    b = ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
	    state[0] = (a + state[0]) & 0xFFFFFFFF;
	    state[1] = (b + state[1]) & 0xFFFFFFFF;
	    state[2] = (c + state[2]) & 0xFFFFFFFF;
	    state[3] = (d + state[3]) & 0xFFFFFFFF;
	};
	
	function cmn(q, a, b, x, s, t) {
	    a = (((a + q) & 0xFFFFFFFF) + ((x + t) & 0xFFFFFFFF)) & 0xFFFFFFFF;
	    return (((a << s) | (a >>> (32 - s))) + b) & 0xFFFFFFFF;
	}
	
	function ff(a, b, c, d, x, s, t) {
	    return cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	
	function gg(a, b, c, d, x, s, t) {
	    return cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	
	function hh(a, b, c, d, x, s, t) {
	    return cmn(b ^ c ^ d, a, b, x, s, t);
	}
	
	function ii(a, b, c, d, x, s, t) {
	    return cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	},{"./browserHashUtils":333,"buffer/":427}],336:[function(require,module,exports){
	var Buffer = require('buffer/').Buffer;
	var hashUtils = require('./browserHashUtils');
	
	var BLOCK_SIZE = 64;
	
	var DIGEST_LENGTH = 20;
	
	var KEY = new Uint32Array([
	    0x5a827999,
	    0x6ed9eba1,
	    0x8f1bbcdc | 0,
	    0xca62c1d6 | 0
	]);
	
	var INIT = [
	    0x6a09e667,
	    0xbb67ae85,
	    0x3c6ef372,
	    0xa54ff53a,
	    0x510e527f,
	    0x9b05688c,
	    0x1f83d9ab,
	    0x5be0cd19,
	];
	
	var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
	
	/**
	 * @api private
	 */
	function Sha1() {
	    this.h0 = 0x67452301;
	    this.h1 = 0xEFCDAB89;
	    this.h2 = 0x98BADCFE;
	    this.h3 = 0x10325476;
	    this.h4 = 0xC3D2E1F0;
	    // The first 64 bytes (16 words) is the data chunk
	    this.block = new Uint32Array(80);
	    this.offset = 0;
	    this.shift = 24;
	    this.totalLength = 0;
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Sha1;
	
	Sha1.BLOCK_SIZE = BLOCK_SIZE;
	
	Sha1.prototype.update = function (data) {
	    if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }
	
	    if (hashUtils.isEmptyData(data)) {
	        return this;
	    }
	
	    data = hashUtils.convertToBuffer(data);
	
	    var length = data.length;
	    this.totalLength += length * 8;
	    for (var i = 0; i < length; i++) {
	        this.write(data[i]);
	    }
	
	    return this;
	};
	
	Sha1.prototype.write = function write(byte) {
	    this.block[this.offset] |= (byte & 0xff) << this.shift;
	    if (this.shift) {
	        this.shift -= 8;
	    } else {
	        this.offset++;
	        this.shift = 24;
	    }
	
	    if (this.offset === 16) this.processBlock();
	};
	
	Sha1.prototype.digest = function (encoding) {
	    // Pad
	    this.write(0x80);
	    if (this.offset > 14 || (this.offset === 14 && this.shift < 24)) {
	      this.processBlock();
	    }
	    this.offset = 14;
	    this.shift = 24;
	
	    // 64-bit length big-endian
	    this.write(0x00); // numbers this big aren't accurate in javascript anyway
	    this.write(0x00); // ..So just hard-code to zero.
	    this.write(this.totalLength > 0xffffffffff ? this.totalLength / 0x10000000000 : 0x00);
	    this.write(this.totalLength > 0xffffffff ? this.totalLength / 0x100000000 : 0x00);
	    for (var s = 24; s >= 0; s -= 8) {
	        this.write(this.totalLength >> s);
	    }
	    // The value in state is little-endian rather than big-endian, so flip
	    // each word into a new Uint8Array
	    var out = new Buffer(DIGEST_LENGTH);
	    var outView = new DataView(out.buffer);
	    outView.setUint32(0, this.h0, false);
	    outView.setUint32(4, this.h1, false);
	    outView.setUint32(8, this.h2, false);
	    outView.setUint32(12, this.h3, false);
	    outView.setUint32(16, this.h4, false);
	
	    return encoding ? out.toString(encoding) : out;
	};
	
	Sha1.prototype.processBlock = function processBlock() {
	    // Extend the sixteen 32-bit words into eighty 32-bit words:
	    for (var i = 16; i < 80; i++) {
	      var w = this.block[i - 3] ^ this.block[i - 8] ^ this.block[i - 14] ^ this.block[i - 16];
	      this.block[i] = (w << 1) | (w >>> 31);
	    }
	
	    // Initialize hash value for this chunk:
	    var a = this.h0;
	    var b = this.h1;
	    var c = this.h2;
	    var d = this.h3;
	    var e = this.h4;
	    var f, k;
	
	    // Main loop:
	    for (i = 0; i < 80; i++) {
	      if (i < 20) {
	        f = d ^ (b & (c ^ d));
	        k = 0x5A827999;
	      }
	      else if (i < 40) {
	        f = b ^ c ^ d;
	        k = 0x6ED9EBA1;
	      }
	      else if (i < 60) {
	        f = (b & c) | (d & (b | c));
	        k = 0x8F1BBCDC;
	      }
	      else {
	        f = b ^ c ^ d;
	        k = 0xCA62C1D6;
	      }
	      var temp = (a << 5 | a >>> 27) + f + e + k + (this.block[i]|0);
	      e = d;
	      d = c;
	      c = (b << 30 | b >>> 2);
	      b = a;
	      a = temp;
	    }
	
	    // Add this chunk's hash to result so far:
	    this.h0 = (this.h0 + a) | 0;
	    this.h1 = (this.h1 + b) | 0;
	    this.h2 = (this.h2 + c) | 0;
	    this.h3 = (this.h3 + d) | 0;
	    this.h4 = (this.h4 + e) | 0;
	
	    // The block is now reusable.
	    this.offset = 0;
	    for (i = 0; i < 16; i++) {
	        this.block[i] = 0;
	    }
	};
	
	},{"./browserHashUtils":333,"buffer/":427}],337:[function(require,module,exports){
	var Buffer = require('buffer/').Buffer;
	var hashUtils = require('./browserHashUtils');
	
	var BLOCK_SIZE = 64;
	
	var DIGEST_LENGTH = 32;
	
	var KEY = new Uint32Array([
	    0x428a2f98,
	    0x71374491,
	    0xb5c0fbcf,
	    0xe9b5dba5,
	    0x3956c25b,
	    0x59f111f1,
	    0x923f82a4,
	    0xab1c5ed5,
	    0xd807aa98,
	    0x12835b01,
	    0x243185be,
	    0x550c7dc3,
	    0x72be5d74,
	    0x80deb1fe,
	    0x9bdc06a7,
	    0xc19bf174,
	    0xe49b69c1,
	    0xefbe4786,
	    0x0fc19dc6,
	    0x240ca1cc,
	    0x2de92c6f,
	    0x4a7484aa,
	    0x5cb0a9dc,
	    0x76f988da,
	    0x983e5152,
	    0xa831c66d,
	    0xb00327c8,
	    0xbf597fc7,
	    0xc6e00bf3,
	    0xd5a79147,
	    0x06ca6351,
	    0x14292967,
	    0x27b70a85,
	    0x2e1b2138,
	    0x4d2c6dfc,
	    0x53380d13,
	    0x650a7354,
	    0x766a0abb,
	    0x81c2c92e,
	    0x92722c85,
	    0xa2bfe8a1,
	    0xa81a664b,
	    0xc24b8b70,
	    0xc76c51a3,
	    0xd192e819,
	    0xd6990624,
	    0xf40e3585,
	    0x106aa070,
	    0x19a4c116,
	    0x1e376c08,
	    0x2748774c,
	    0x34b0bcb5,
	    0x391c0cb3,
	    0x4ed8aa4a,
	    0x5b9cca4f,
	    0x682e6ff3,
	    0x748f82ee,
	    0x78a5636f,
	    0x84c87814,
	    0x8cc70208,
	    0x90befffa,
	    0xa4506ceb,
	    0xbef9a3f7,
	    0xc67178f2
	]);
	
	var INIT = [
	    0x6a09e667,
	    0xbb67ae85,
	    0x3c6ef372,
	    0xa54ff53a,
	    0x510e527f,
	    0x9b05688c,
	    0x1f83d9ab,
	    0x5be0cd19,
	];
	
	var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
	
	/**
	 * @private
	 */
	function Sha256() {
	    this.state = [
	        0x6a09e667,
	        0xbb67ae85,
	        0x3c6ef372,
	        0xa54ff53a,
	        0x510e527f,
	        0x9b05688c,
	        0x1f83d9ab,
	        0x5be0cd19,
	    ];
	    this.temp = new Int32Array(64);
	    this.buffer = new Uint8Array(64);
	    this.bufferLength = 0;
	    this.bytesHashed = 0;
	    /**
	     * @private
	     */
	    this.finished = false;
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Sha256;
	
	Sha256.BLOCK_SIZE = BLOCK_SIZE;
	
	Sha256.prototype.update = function (data) {
	    if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }
	
	    if (hashUtils.isEmptyData(data)) {
	        return this;
	    }
	
	    data = hashUtils.convertToBuffer(data);
	
	    var position = 0;
	    var byteLength = data.byteLength;
	    this.bytesHashed += byteLength;
	    if (this.bytesHashed * 8 > MAX_HASHABLE_LENGTH) {
	        throw new Error('Cannot hash more than 2^53 - 1 bits');
	    }
	
	    while (byteLength > 0) {
	        this.buffer[this.bufferLength++] = data[position++];
	        byteLength--;
	        if (this.bufferLength === BLOCK_SIZE) {
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	    }
	
	    return this;
	};
	
	Sha256.prototype.digest = function (encoding) {
	    if (!this.finished) {
	        var bitsHashed = this.bytesHashed * 8;
	        var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
	        var undecoratedLength = this.bufferLength;
	        bufferView.setUint8(this.bufferLength++, 0x80);
	        // Ensure the final block has enough room for the hashed length
	        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
	            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
	                bufferView.setUint8(i, 0);
	            }
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
	            bufferView.setUint8(i, 0);
	        }
	        bufferView.setUint32(BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
	        bufferView.setUint32(BLOCK_SIZE - 4, bitsHashed);
	        this.hashBuffer();
	        this.finished = true;
	    }
	    // The value in state is little-endian rather than big-endian, so flip
	    // each word into a new Uint8Array
	    var out = new Buffer(DIGEST_LENGTH);
	    for (var i = 0; i < 8; i++) {
	        out[i * 4] = (this.state[i] >>> 24) & 0xff;
	        out[i * 4 + 1] = (this.state[i] >>> 16) & 0xff;
	        out[i * 4 + 2] = (this.state[i] >>> 8) & 0xff;
	        out[i * 4 + 3] = (this.state[i] >>> 0) & 0xff;
	    }
	    return encoding ? out.toString(encoding) : out;
	};
	
	Sha256.prototype.hashBuffer = function () {
	    var _a = this,
	        buffer = _a.buffer,
	        state = _a.state;
	    var state0 = state[0],
	        state1 = state[1],
	        state2 = state[2],
	        state3 = state[3],
	        state4 = state[4],
	        state5 = state[5],
	        state6 = state[6],
	        state7 = state[7];
	    for (var i = 0; i < BLOCK_SIZE; i++) {
	        if (i < 16) {
	            this.temp[i] = (((buffer[i * 4] & 0xff) << 24) |
	                ((buffer[(i * 4) + 1] & 0xff) << 16) |
	                ((buffer[(i * 4) + 2] & 0xff) << 8) |
	                (buffer[(i * 4) + 3] & 0xff));
	        }
	        else {
	            var u = this.temp[i - 2];
	            var t1_1 = (u >>> 17 | u << 15) ^
	                (u >>> 19 | u << 13) ^
	                (u >>> 10);
	            u = this.temp[i - 15];
	            var t2_1 = (u >>> 7 | u << 25) ^
	                (u >>> 18 | u << 14) ^
	                (u >>> 3);
	            this.temp[i] = (t1_1 + this.temp[i - 7] | 0) +
	                (t2_1 + this.temp[i - 16] | 0);
	        }
	        var t1 = (((((state4 >>> 6 | state4 << 26) ^
	            (state4 >>> 11 | state4 << 21) ^
	            (state4 >>> 25 | state4 << 7))
	            + ((state4 & state5) ^ (~state4 & state6))) | 0)
	            + ((state7 + ((KEY[i] + this.temp[i]) | 0)) | 0)) | 0;
	        var t2 = (((state0 >>> 2 | state0 << 30) ^
	            (state0 >>> 13 | state0 << 19) ^
	            (state0 >>> 22 | state0 << 10)) + ((state0 & state1) ^ (state0 & state2) ^ (state1 & state2))) | 0;
	        state7 = state6;
	        state6 = state5;
	        state5 = state4;
	        state4 = (state3 + t1) | 0;
	        state3 = state2;
	        state2 = state1;
	        state1 = state0;
	        state0 = (t1 + t2) | 0;
	    }
	    state[0] += state0;
	    state[1] += state1;
	    state[2] += state2;
	    state[3] += state3;
	    state[4] += state4;
	    state[5] += state5;
	    state[6] += state6;
	    state[7] += state7;
	};
	
	},{"./browserHashUtils":333,"buffer/":427}],338:[function(require,module,exports){
	(function (process){(function (){
	var util = require('./util');
	
	// browser specific modules
	util.crypto.lib = require('./browserCryptoLib');
	util.Buffer = require('buffer/').Buffer;
	util.url = require('url/');
	util.querystring = require('querystring/');
	util.realClock = require('./realclock/browserClock');
	util.environment = 'js';
	util.createEventStream = require('./event-stream/buffered-create-event-stream').createEventStream;
	util.isBrowser = function() { return true; };
	util.isNode = function() { return false; };
	
	var AWS = require('./core');
	
	/**
	 * @api private
	 */
	module.exports = AWS;
	
	require('./credentials');
	require('./credentials/credential_provider_chain');
	require('./credentials/temporary_credentials');
	require('./credentials/chainable_temporary_credentials');
	require('./credentials/web_identity_credentials');
	require('./credentials/cognito_identity_credentials');
	require('./credentials/saml_credentials');
	
	// Load the DOMParser XML parser
	AWS.XML.Parser = require('./xml/browser_parser');
	
	// Load the XHR HttpClient
	require('./http/xhr');
	
	if (typeof process === 'undefined') {
	  var process = {
	    browser: true
	  };
	}
	
	}).call(this)}).call(this,require('_process'))
	},{"./browserCryptoLib":332,"./core":342,"./credentials":343,"./credentials/chainable_temporary_credentials":344,"./credentials/cognito_identity_credentials":345,"./credentials/credential_provider_chain":346,"./credentials/saml_credentials":347,"./credentials/temporary_credentials":348,"./credentials/web_identity_credentials":349,"./event-stream/buffered-create-event-stream":357,"./http/xhr":365,"./realclock/browserClock":384,"./util":418,"./xml/browser_parser":419,"_process":432,"buffer/":427,"querystring/":439,"url/":441}],339:[function(require,module,exports){
	var AWS = require('../core'),
	    url = AWS.util.url,
	    crypto = AWS.util.crypto.lib,
	    base64Encode = AWS.util.base64.encode,
	    inherit = AWS.util.inherit;
	
	var queryEncode = function (string) {
	    var replacements = {
	        '+': '-',
	        '=': '_',
	        '/': '~'
	    };
	    return string.replace(/[\+=\/]/g, function (match) {
	        return replacements[match];
	    });
	};
	
	var signPolicy = function (policy, privateKey) {
	    var sign = crypto.createSign('RSA-SHA1');
	    sign.write(policy);
	    return queryEncode(sign.sign(privateKey, 'base64'));
	};
	
	var signWithCannedPolicy = function (url, expires, keyPairId, privateKey) {
	    var policy = JSON.stringify({
	        Statement: [
	            {
	                Resource: url,
	                Condition: { DateLessThan: { 'AWS:EpochTime': expires } }
	            }
	        ]
	    });
	
	    return {
	        Expires: expires,
	        'Key-Pair-Id': keyPairId,
	        Signature: signPolicy(policy.toString(), privateKey)
	    };
	};
	
	var signWithCustomPolicy = function (policy, keyPairId, privateKey) {
	    policy = policy.replace(/\s/mg, '');
	
	    return {
	        Policy: queryEncode(base64Encode(policy)),
	        'Key-Pair-Id': keyPairId,
	        Signature: signPolicy(policy, privateKey)
	    };
	};
	
	var determineScheme = function (url) {
	    var parts = url.split('://');
	    if (parts.length < 2) {
	        throw new Error('Invalid URL.');
	    }
	
	    return parts[0].replace('*', '');
	};
	
	var getRtmpUrl = function (rtmpUrl) {
	    var parsed = url.parse(rtmpUrl);
	    return parsed.path.replace(/^\//, '') + (parsed.hash || '');
	};
	
	var getResource = function (url) {
	    switch (determineScheme(url)) {
	        case 'http':
	        case 'https':
	            return url;
	        case 'rtmp':
	            return getRtmpUrl(url);
	        default:
	            throw new Error('Invalid URI scheme. Scheme must be one of'
	                + ' http, https, or rtmp');
	    }
	};
	
	var handleError = function (err, callback) {
	    if (!callback || typeof callback !== 'function') {
	        throw err;
	    }
	
	    callback(err);
	};
	
	var handleSuccess = function (result, callback) {
	    if (!callback || typeof callback !== 'function') {
	        return result;
	    }
	
	    callback(null, result);
	};
	
	AWS.CloudFront.Signer = inherit({
	    /**
	     * A signer object can be used to generate signed URLs and cookies for granting
	     * access to content on restricted CloudFront distributions.
	     *
	     * @see http://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/PrivateContent.html
	     *
	     * @param keyPairId [String]    (Required) The ID of the CloudFront key pair
	     *                              being used.
	     * @param privateKey [String]   (Required) A private key in RSA format.
	     */
	    constructor: function Signer(keyPairId, privateKey) {
	        if (keyPairId === void 0 || privateKey === void 0) {
	            throw new Error('A key pair ID and private key are required');
	        }
	
	        this.keyPairId = keyPairId;
	        this.privateKey = privateKey;
	    },
	
	    /**
	     * Create a signed Amazon CloudFront Cookie.
	     *
	     * @param options [Object]            The options to create a signed cookie.
	     * @option options url [String]     The URL to which the signature will grant
	     *                                  access. Required unless you pass in a full
	     *                                  policy.
	     * @option options expires [Number] A Unix UTC timestamp indicating when the
	     *                                  signature should expire. Required unless you
	     *                                  pass in a full policy.
	     * @option options policy [String]  A CloudFront JSON policy. Required unless
	     *                                  you pass in a url and an expiry time.
	     *
	     * @param cb [Function] if a callback is provided, this function will
	     *   pass the hash as the second parameter (after the error parameter) to
	     *   the callback function.
	     *
	     * @return [Object] if called synchronously (with no callback), returns the
	     *   signed cookie parameters.
	     * @return [null] nothing is returned if a callback is provided.
	     */
	    getSignedCookie: function (options, cb) {
	        var signatureHash = 'policy' in options
	            ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
	            : signWithCannedPolicy(options.url, options.expires, this.keyPairId, this.privateKey);
	
	        var cookieHash = {};
	        for (var key in signatureHash) {
	            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
	                cookieHash['CloudFront-' + key] = signatureHash[key];
	            }
	        }
	
	        return handleSuccess(cookieHash, cb);
	    },
	
	    /**
	     * Create a signed Amazon CloudFront URL.
	     *
	     * Keep in mind that URLs meant for use in media/flash players may have
	     * different requirements for URL formats (e.g. some require that the
	     * extension be removed, some require the file name to be prefixed
	     * - mp4:<path>, some require you to add "/cfx/st" into your URL).
	     *
	     * @param options [Object]          The options to create a signed URL.
	     * @option options url [String]     The URL to which the signature will grant
	     *                                  access. Any query params included with
	     *                                  the URL should be encoded. Required.
	     * @option options expires [Number] A Unix UTC timestamp indicating when the
	     *                                  signature should expire. Required unless you
	     *                                  pass in a full policy.
	     * @option options policy [String]  A CloudFront JSON policy. Required unless
	     *                                  you pass in a url and an expiry time.
	     *
	     * @param cb [Function] if a callback is provided, this function will
	     *   pass the URL as the second parameter (after the error parameter) to
	     *   the callback function.
	     *
	     * @return [String] if called synchronously (with no callback), returns the
	     *   signed URL.
	     * @return [null] nothing is returned if a callback is provided.
	     */
	    getSignedUrl: function (options, cb) {
	        try {
	            var resource = getResource(options.url);
	        } catch (err) {
	            return handleError(err, cb);
	        }
	
	        var parsedUrl = url.parse(options.url, true),
	            signatureHash = Object.prototype.hasOwnProperty.call(options, 'policy')
	                ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
	                : signWithCannedPolicy(resource, options.expires, this.keyPairId, this.privateKey);
	
	        parsedUrl.search = null;
	        for (var key in signatureHash) {
	            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
	                parsedUrl.query[key] = signatureHash[key];
	            }
	        }
	
	        try {
	            var signedUrl = determineScheme(options.url) === 'rtmp'
	                    ? getRtmpUrl(url.format(parsedUrl))
	                    : url.format(parsedUrl);
	        } catch (err) {
	            return handleError(err, cb);
	        }
	
	        return handleSuccess(signedUrl, cb);
	    }
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.CloudFront.Signer;
	
	},{"../core":342}],340:[function(require,module,exports){
	var AWS = require('./core');
	require('./credentials');
	require('./credentials/credential_provider_chain');
	var PromisesDependency;
	
	/**
	 * The main configuration class used by all service objects to set
	 * the region, credentials, and other options for requests.
	 *
	 * By default, credentials and region settings are left unconfigured.
	 * This should be configured by the application before using any
	 * AWS service APIs.
	 *
	 * In order to set global configuration options, properties should
	 * be assigned to the global {AWS.config} object.
	 *
	 * @see AWS.config
	 *
	 * @!group General Configuration Options
	 *
	 * @!attribute credentials
	 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
	 *
	 * @!attribute region
	 *   @example Set the global region setting to us-west-2
	 *     AWS.config.update({region: 'us-west-2'});
	 *   @return [AWS.Credentials] The region to send service requests to.
	 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
	 *     A list of available endpoints for each AWS service
	 *
	 * @!attribute maxRetries
	 *   @return [Integer] the maximum amount of retries to perform for a
	 *     service request. By default this value is calculated by the specific
	 *     service object that the request is being made to.
	 *
	 * @!attribute maxRedirects
	 *   @return [Integer] the maximum amount of redirects to follow for a
	 *     service request. Defaults to 10.
	 *
	 * @!attribute paramValidation
	 *   @return [Boolean|map] whether input parameters should be validated against
	 *     the operation description before sending the request. Defaults to true.
	 *     Pass a map to enable any of the following specific validation features:
	 *
	 *     * **min** [Boolean] &mdash; Validates that a value meets the min
	 *       constraint. This is enabled by default when paramValidation is set
	 *       to `true`.
	 *     * **max** [Boolean] &mdash; Validates that a value meets the max
	 *       constraint.
	 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
	 *       regular expression.
	 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
	 *       of the allowable enum values.
	 *
	 * @!attribute computeChecksums
	 *   @return [Boolean] whether to compute checksums for payload bodies when
	 *     the service accepts it (currently supported in S3 and SQS only).
	 *
	 * @!attribute convertResponseTypes
	 *   @return [Boolean] whether types are converted when parsing response data.
	 *     Currently only supported for JSON based services. Turning this off may
	 *     improve performance on large response payloads. Defaults to `true`.
	 *
	 * @!attribute correctClockSkew
	 *   @return [Boolean] whether to apply a clock skew correction and retry
	 *     requests that fail because of an skewed client clock. Defaults to
	 *     `false`.
	 *
	 * @!attribute sslEnabled
	 *   @return [Boolean] whether SSL is enabled for requests
	 *
	 * @!attribute s3ForcePathStyle
	 *   @return [Boolean] whether to force path style URLs for S3 objects
	 *
	 * @!attribute s3BucketEndpoint
	 *   @note Setting this configuration option requires an `endpoint` to be
	 *     provided explicitly to the service constructor.
	 *   @return [Boolean] whether the provided endpoint addresses an individual
	 *     bucket (false if it addresses the root API endpoint).
	 *
	 * @!attribute s3DisableBodySigning
	 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
	 *     Body signing can only be disabled when using https. Defaults to `true`.
	 *
	 * @!attribute s3UsEast1RegionalEndpoint
	 *   @return ['legacy'|'regional'] when region is set to 'us-east-1', whether to send s3
	 *     request to global endpoints or 'us-east-1' regional endpoints. This config is only
	 *     applicable to S3 client;
	 *     Defaults to 'legacy'
	 * @!attribute s3UseArnRegion
	 *   @return [Boolean] whether to override the request region with the region inferred
	 *     from requested resource's ARN. Only available for S3 buckets
	 *     Defaults to `true`
	 *
	 * @!attribute useAccelerateEndpoint
	 *   @note This configuration option is only compatible with S3 while accessing
	 *     dns-compatible buckets.
	 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
	 *     Defaults to `false`.
	 *
	 * @!attribute retryDelayOptions
	 *   @example Set the base retry delay for all services to 300 ms
	 *     AWS.config.update({retryDelayOptions: {base: 300}});
	 *     // Delays with maxRetries = 3: 300, 600, 1200
	 *   @example Set a custom backoff function to provide delay values on retries
	 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount, err) {
	 *       // returns delay in ms
	 *     }}});
	 *   @return [map] A set of options to configure the retry delay on retryable errors.
	 *     Currently supported options are:
	 *
	 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
	 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
	 *       DynamoDB, where it defaults to 50ms.
	 *
	 *     * **customBackoff ** [function] &mdash; A custom function that accepts a
	 *       retry count and error and returns the amount of time to delay in
	 *       milliseconds. If the result is a non-zero negative value, no further
	 *       retry attempts will be made. The `base` option will be ignored if this
	 *       option is supplied. The function is only called for retryable errors.
	 *
	 * @!attribute httpOptions
	 *   @return [map] A set of options to pass to the low-level HTTP request.
	 *     Currently supported options are:
	 *
	 *     * **proxy** [String] &mdash; the URL to proxy requests through
	 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
	 *       HTTP requests with. Used for connection pooling. Note that for
	 *       SSL connections, a special Agent object is used in order to enable
	 *       peer certificate verification. This feature is only supported in the
	 *       Node.js environment.
	 *     * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
	 *       failing to establish a connection with the server after
	 *       `connectTimeout` milliseconds. This timeout has no effect once a socket
	 *       connection has been established.
	 *     * **timeout** [Integer] &mdash; The number of milliseconds a request can
	 *       take before automatically being terminated.
	 *       Defaults to two minutes (120000).
	 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
	 *       HTTP requests. Used in the browser environment only. Set to false to
	 *       send requests synchronously. Defaults to true (async on).
	 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
	 *       property of an XMLHttpRequest object. Used in the browser environment
	 *       only. Defaults to false.
	 * @!attribute logger
	 *   @return [#write,#log] an object that responds to .write() (like a stream)
	 *     or .log() (like the console object) in order to log information about
	 *     requests
	 *
	 * @!attribute systemClockOffset
	 *   @return [Number] an offset value in milliseconds to apply to all signing
	 *     times. Use this to compensate for clock skew when your system may be
	 *     out of sync with the service time. Note that this configuration option
	 *     can only be applied to the global `AWS.config` object and cannot be
	 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
	 *
	 * @!attribute signatureVersion
	 *   @return [String] the signature version to sign requests with (overriding
	 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
	 *
	 * @!attribute signatureCache
	 *   @return [Boolean] whether the signature to sign requests with (overriding
	 *     the API configuration) is cached. Only applies to the signature version 'v4'.
	 *     Defaults to `true`.
	 *
	 * @!attribute endpointDiscoveryEnabled
	 *   @return [Boolean|undefined] whether to call operations with endpoints
	 *     given by service dynamically. Setting this config to `true` will enable
	 *     endpoint discovery for all applicable operations. Setting it to `false`
	 *     will explicitly disable endpoint discovery even though operations that
	 *     require endpoint discovery will presumably fail. Leaving it to
	 *     `undefined` means SDK only do endpoint discovery when it's required.
	 *     Defaults to `undefined`
	 *
	 * @!attribute endpointCacheSize
	 *   @return [Number] the size of the global cache storing endpoints from endpoint
	 *     discovery operations. Once endpoint cache is created, updating this setting
	 *     cannot change existing cache size.
	 *     Defaults to 1000
	 *
	 * @!attribute hostPrefixEnabled
	 *   @return [Boolean] whether to marshal request parameters to the prefix of
	 *     hostname. Defaults to `true`.
	 *
	 * @!attribute stsRegionalEndpoints
	 *   @return ['legacy'|'regional'] whether to send sts request to global endpoints or
	 *     regional endpoints.
	 *     Defaults to 'legacy'.
	 *
	 * @!attribute useFipsEndpoint
	 *   @return [Boolean] Enables FIPS compatible endpoints. Defaults to `false`.
	 *
	 * @!attribute useDualstackEndpoint
	 *   @return [Boolean] Enables IPv6 dualstack endpoint. Defaults to `false`.
	 */
	AWS.Config = AWS.util.inherit({
	  /**
	   * @!endgroup
	   */
	
	  /**
	   * Creates a new configuration object. This is the object that passes
	   * option data along to service requests, including credentials, security,
	   * region information, and some service specific settings.
	   *
	   * @example Creating a new configuration object with credentials and region
	   *   var config = new AWS.Config({
	   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
	   *   });
	   * @option options accessKeyId [String] your AWS access key ID.
	   * @option options secretAccessKey [String] your AWS secret access key.
	   * @option options sessionToken [AWS.Credentials] the optional AWS
	   *   session token to sign requests with.
	   * @option options credentials [AWS.Credentials] the AWS credentials
	   *   to sign requests with. You can either specify this object, or
	   *   specify the accessKeyId and secretAccessKey options directly.
	   * @option options credentialProvider [AWS.CredentialProviderChain] the
	   *   provider chain used to resolve credentials if no static `credentials`
	   *   property is set.
	   * @option options region [String] the region to send service requests to.
	   *   See {region} for more information.
	   * @option options maxRetries [Integer] the maximum amount of retries to
	   *   attempt with a request. See {maxRetries} for more information.
	   * @option options maxRedirects [Integer] the maximum amount of redirects to
	   *   follow with a request. See {maxRedirects} for more information.
	   * @option options sslEnabled [Boolean] whether to enable SSL for
	   *   requests.
	   * @option options paramValidation [Boolean|map] whether input parameters
	   *   should be validated against the operation description before sending
	   *   the request. Defaults to true. Pass a map to enable any of the
	   *   following specific validation features:
	   *
	   *   * **min** [Boolean] &mdash; Validates that a value meets the min
	   *     constraint. This is enabled by default when paramValidation is set
	   *     to `true`.
	   *   * **max** [Boolean] &mdash; Validates that a value meets the max
	   *     constraint.
	   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
	   *     regular expression.
	   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
	   *     of the allowable enum values.
	   * @option options computeChecksums [Boolean] whether to compute checksums
	   *   for payload bodies when the service accepts it (currently supported
	   *   in S3 only)
	   * @option options convertResponseTypes [Boolean] whether types are converted
	   *     when parsing response data. Currently only supported for JSON based
	   *     services. Turning this off may improve performance on large response
	   *     payloads. Defaults to `true`.
	   * @option options correctClockSkew [Boolean] whether to apply a clock skew
	   *     correction and retry requests that fail because of an skewed client
	   *     clock. Defaults to `false`.
	   * @option options s3ForcePathStyle [Boolean] whether to force path
	   *   style URLs for S3 objects.
	   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
	   *   addresses an individual bucket (false if it addresses the root API
	   *   endpoint). Note that setting this configuration option requires an
	   *   `endpoint` to be provided explicitly to the service constructor.
	   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
	   *   should be disabled when using signature version `v4`. Body signing
	   *   can only be disabled when using https. Defaults to `true`.
	   * @option options s3UsEast1RegionalEndpoint ['legacy'|'regional'] when region
	   *   is set to 'us-east-1', whether to send s3 request to global endpoints or
	   *   'us-east-1' regional endpoints. This config is only applicable to S3 client.
	   *   Defaults to `legacy`
	   * @option options s3UseArnRegion [Boolean] whether to override the request region
	   *   with the region inferred from requested resource's ARN. Only available for S3 buckets
	   *   Defaults to `true`
	   *
	   * @option options retryDelayOptions [map] A set of options to configure
	   *   the retry delay on retryable errors. Currently supported options are:
	   *
	   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
	   *     exponential backoff for operation retries. Defaults to 100 ms for all
	   *     services except DynamoDB, where it defaults to 50ms.
	   *   * **customBackoff ** [function] &mdash; A custom function that accepts a
	   *     retry count and error and returns the amount of time to delay in
	   *     milliseconds. If the result is a non-zero negative value, no further
	   *     retry attempts will be made. The `base` option will be ignored if this
	   *     option is supplied. The function is only called for retryable errors.
	   * @option options httpOptions [map] A set of options to pass to the low-level
	   *   HTTP request. Currently supported options are:
	   *
	   *   * **proxy** [String] &mdash; the URL to proxy requests through
	   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
	   *     HTTP requests with. Used for connection pooling. Defaults to the global
	   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
	   *     SSL connections, a special Agent object is used in order to enable
	   *     peer certificate verification. This feature is only available in the
	   *     Node.js environment.
	   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
	   *     failing to establish a connection with the server after
	   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
	   *     connection has been established.
	   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
	   *     milliseconds of inactivity on the socket. Defaults to two minutes
	   *     (120000).
	   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
	   *     HTTP requests. Used in the browser environment only. Set to false to
	   *     send requests synchronously. Defaults to true (async on).
	   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
	   *     property of an XMLHttpRequest object. Used in the browser environment
	   *     only. Defaults to false.
	   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
	   *   (or a date) that represents the latest possible API version that can be
	   *   used in all services (unless overridden by `apiVersions`). Specify
	   *   'latest' to use the latest possible version.
	   * @option options apiVersions [map<String, String|Date>] a map of service
	   *   identifiers (the lowercase service class name) with the API version to
	   *   use when instantiating a service. Specify 'latest' for each individual
	   *   that can use the latest available version.
	   * @option options logger [#write,#log] an object that responds to .write()
	   *   (like a stream) or .log() (like the console object) in order to log
	   *   information about requests
	   * @option options systemClockOffset [Number] an offset value in milliseconds
	   *   to apply to all signing times. Use this to compensate for clock skew
	   *   when your system may be out of sync with the service time. Note that
	   *   this configuration option can only be applied to the global `AWS.config`
	   *   object and cannot be overridden in service-specific configuration.
	   *   Defaults to 0 milliseconds.
	   * @option options signatureVersion [String] the signature version to sign
	   *   requests with (overriding the API configuration). Possible values are:
	   *   'v2', 'v3', 'v4'.
	   * @option options signatureCache [Boolean] whether the signature to sign
	   *   requests with (overriding the API configuration) is cached. Only applies
	   *   to the signature version 'v4'. Defaults to `true`.
	   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
	   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
	   * @option options useAccelerateEndpoint [Boolean] Whether to use the
	   *   S3 Transfer Acceleration endpoint with the S3 service. Default: `false`.
	   * @option options clientSideMonitoring [Boolean] whether to collect and
	   *   publish this client's performance metrics of all its API requests.
	   * @option options endpointDiscoveryEnabled [Boolean|undefined] whether to
	   *   call operations with endpoints given by service dynamically. Setting this
	   * config to `true` will enable endpoint discovery for all applicable operations.
	   *   Setting it to `false` will explicitly disable endpoint discovery even though
	   *   operations that require endpoint discovery will presumably fail. Leaving it
	   *   to `undefined` means SDK will only do endpoint discovery when it's required.
	   *   Defaults to `undefined`
	   * @option options endpointCacheSize [Number] the size of the global cache storing
	   *   endpoints from endpoint discovery operations. Once endpoint cache is created,
	   *   updating this setting cannot change existing cache size.
	   *   Defaults to 1000
	   * @option options hostPrefixEnabled [Boolean] whether to marshal request
	   *   parameters to the prefix of hostname.
	   *   Defaults to `true`.
	   * @option options stsRegionalEndpoints ['legacy'|'regional'] whether to send sts request
	   *   to global endpoints or regional endpoints.
	   *   Defaults to 'legacy'.
	   * @option options useFipsEndpoint [Boolean] Enables FIPS compatible endpoints.
	   *   Defaults to `false`.
	   * @option options useDualstackEndpoint [Boolean] Enables IPv6 dualstack endpoint.
	   *   Defaults to `false`.
	   */
	  constructor: function Config(options) {
	    if (options === undefined) options = {};
	    options = this.extractCredentials(options);
	
	    AWS.util.each.call(this, this.keys, function (key, value) {
	      this.set(key, options[key], value);
	    });
	  },
	
	  /**
	   * @!group Managing Credentials
	   */
	
	  /**
	   * Loads credentials from the configuration object. This is used internally
	   * by the SDK to ensure that refreshable {Credentials} objects are properly
	   * refreshed and loaded when sending a request. If you want to ensure that
	   * your credentials are loaded prior to a request, you can use this method
	   * directly to provide accurate credential data stored in the object.
	   *
	   * @note If you configure the SDK with static or environment credentials,
	   *   the credential data should already be present in {credentials} attribute.
	   *   This method is primarily necessary to load credentials from asynchronous
	   *   sources, or sources that can refresh credentials periodically.
	   * @example Getting your access key
	   *   AWS.config.getCredentials(function(err) {
	   *     if (err) console.log(err.stack); // credentials not loaded
	   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
	   *   })
	   * @callback callback function(err)
	   *   Called when the {credentials} have been properly set on the configuration
	   *   object.
	   *
	   *   @param err [Error] if this is set, credentials were not successfully
	   *     loaded and this error provides information why.
	   * @see credentials
	   * @see Credentials
	   */
	  getCredentials: function getCredentials(callback) {
	    var self = this;
	
	    function finish(err) {
	      callback(err, err ? null : self.credentials);
	    }
	
	    function credError(msg, err) {
	      return new AWS.util.error(err || new Error(), {
	        code: 'CredentialsError',
	        message: msg,
	        name: 'CredentialsError'
	      });
	    }
	
	    function getAsyncCredentials() {
	      self.credentials.get(function(err) {
	        if (err) {
	          var msg = 'Could not load credentials from ' +
	            self.credentials.constructor.name;
	          err = credError(msg, err);
	        }
	        finish(err);
	      });
	    }
	
	    function getStaticCredentials() {
	      var err = null;
	      if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) {
	        err = credError('Missing credentials');
	      }
	      finish(err);
	    }
	
	    if (self.credentials) {
	      if (typeof self.credentials.get === 'function') {
	        getAsyncCredentials();
	      } else { // static credentials
	        getStaticCredentials();
	      }
	    } else if (self.credentialProvider) {
	      self.credentialProvider.resolve(function(err, creds) {
	        if (err) {
	          err = credError('Could not load credentials from any providers', err);
	        }
	        self.credentials = creds;
	        finish(err);
	      });
	    } else {
	      finish(credError('No credentials to load'));
	    }
	  },
	
	  /**
	   * @!group Loading and Setting Configuration Options
	   */
	
	  /**
	   * @overload update(options, allowUnknownKeys = false)
	   *   Updates the current configuration object with new options.
	   *
	   *   @example Update maxRetries property of a configuration object
	   *     config.update({maxRetries: 10});
	   *   @param [Object] options a map of option keys and values.
	   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
	   *     the configuration object. Defaults to `false`.
	   *   @see constructor
	   */
	  update: function update(options, allowUnknownKeys) {
	    allowUnknownKeys = allowUnknownKeys || false;
	    options = this.extractCredentials(options);
	    AWS.util.each.call(this, options, function (key, value) {
	      if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) ||
	          AWS.Service.hasService(key)) {
	        this.set(key, value);
	      }
	    });
	  },
	
	  /**
	   * Loads configuration data from a JSON file into this config object.
	   * @note Loading configuration will reset all existing configuration
	   *   on the object.
	   * @!macro nobrowser
	   * @param path [String] the path relative to your process's current
	   *    working directory to load configuration from.
	   * @return [AWS.Config] the same configuration object
	   */
	  loadFromPath: function loadFromPath(path) {
	    this.clear();
	
	    var options = JSON.parse(AWS.util.readFileSync(path));
	    var fileSystemCreds = new AWS.FileSystemCredentials(path);
	    var chain = new AWS.CredentialProviderChain();
	    chain.providers.unshift(fileSystemCreds);
	    chain.resolve(function (err, creds) {
	      if (err) throw err;
	      else options.credentials = creds;
	    });
	
	    this.constructor(options);
	
	    return this;
	  },
	
	  /**
	   * Clears configuration data on this object
	   *
	   * @api private
	   */
	  clear: function clear() {
	    /*jshint forin:false */
	    AWS.util.each.call(this, this.keys, function (key) {
	      delete this[key];
	    });
	
	    // reset credential provider
	    this.set('credentials', undefined);
	    this.set('credentialProvider', undefined);
	  },
	
	  /**
	   * Sets a property on the configuration object, allowing for a
	   * default value
	   * @api private
	   */
	  set: function set(property, value, defaultValue) {
	    if (value === undefined) {
	      if (defaultValue === undefined) {
	        defaultValue = this.keys[property];
	      }
	      if (typeof defaultValue === 'function') {
	        this[property] = defaultValue.call(this);
	      } else {
	        this[property] = defaultValue;
	      }
	    } else if (property === 'httpOptions' && this[property]) {
	      // deep merge httpOptions
	      this[property] = AWS.util.merge(this[property], value);
	    } else {
	      this[property] = value;
	    }
	  },
	
	  /**
	   * All of the keys with their default values.
	   *
	   * @constant
	   * @api private
	   */
	  keys: {
	    credentials: null,
	    credentialProvider: null,
	    region: null,
	    logger: null,
	    apiVersions: {},
	    apiVersion: null,
	    endpoint: undefined,
	    httpOptions: {
	      timeout: 120000
	    },
	    maxRetries: undefined,
	    maxRedirects: 10,
	    paramValidation: true,
	    sslEnabled: true,
	    s3ForcePathStyle: false,
	    s3BucketEndpoint: false,
	    s3DisableBodySigning: true,
	    s3UsEast1RegionalEndpoint: 'legacy',
	    s3UseArnRegion: undefined,
	    computeChecksums: true,
	    convertResponseTypes: true,
	    correctClockSkew: false,
	    customUserAgent: null,
	    dynamoDbCrc32: true,
	    systemClockOffset: 0,
	    signatureVersion: null,
	    signatureCache: true,
	    retryDelayOptions: {},
	    useAccelerateEndpoint: false,
	    clientSideMonitoring: false,
	    endpointDiscoveryEnabled: undefined,
	    endpointCacheSize: 1000,
	    hostPrefixEnabled: true,
	    stsRegionalEndpoints: 'legacy',
	    useFipsEndpoint: false,
	    useDualstackEndpoint: false
	  },
	
	  /**
	   * Extracts accessKeyId, secretAccessKey and sessionToken
	   * from a configuration hash.
	   *
	   * @api private
	   */
	  extractCredentials: function extractCredentials(options) {
	    if (options.accessKeyId && options.secretAccessKey) {
	      options = AWS.util.copy(options);
	      options.credentials = new AWS.Credentials(options);
	    }
	    return options;
	  },
	
	  /**
	   * Sets the promise dependency the SDK will use wherever Promises are returned.
	   * Passing `null` will force the SDK to use native Promises if they are available.
	   * If native Promises are not available, passing `null` will have no effect.
	   * @param [Constructor] dep A reference to a Promise constructor
	   */
	  setPromisesDependency: function setPromisesDependency(dep) {
	    PromisesDependency = dep;
	    // if null was passed in, we should try to use native promises
	    if (dep === null && typeof Promise === 'function') {
	      PromisesDependency = Promise;
	    }
	    var constructors = [AWS.Request, AWS.Credentials, AWS.CredentialProviderChain];
	    if (AWS.S3) {
	      constructors.push(AWS.S3);
	      if (AWS.S3.ManagedUpload) {
	        constructors.push(AWS.S3.ManagedUpload);
	      }
	    }
	    AWS.util.addPromises(constructors, PromisesDependency);
	  },
	
	  /**
	   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
	   */
	  getPromisesDependency: function getPromisesDependency() {
	    return PromisesDependency;
	  }
	});
	
	/**
	 * @return [AWS.Config] The global configuration object singleton instance
	 * @readonly
	 * @see AWS.Config
	 */
	AWS.config = new AWS.Config();
	
	},{"./core":342,"./credentials":343,"./credentials/credential_provider_chain":346}],341:[function(require,module,exports){
	(function (process){(function (){
	var AWS = require('./core');
	/**
	 * @api private
	 */
	function validateRegionalEndpointsFlagValue(configValue, errorOptions) {
	  if (typeof configValue !== 'string') return undefined;
	  else if (['legacy', 'regional'].indexOf(configValue.toLowerCase()) >= 0) {
	    return configValue.toLowerCase();
	  } else {
	    throw AWS.util.error(new Error(), errorOptions);
	  }
	}
	
	/**
	 * Resolve the configuration value for regional endpoint from difference sources: client
	 * config, environmental variable, shared config file. Value can be case-insensitive
	 * 'legacy' or 'reginal'.
	 * @param originalConfig user-supplied config object to resolve
	 * @param options a map of config property names from individual configuration source
	 *  - env: name of environmental variable that refers to the config
	 *  - sharedConfig: name of shared configuration file property that refers to the config
	 *  - clientConfig: name of client configuration property that refers to the config
	 *
	 * @api private
	 */
	function resolveRegionalEndpointsFlag(originalConfig, options) {
	  originalConfig = originalConfig || {};
	  //validate config value
	  var resolved;
	  if (originalConfig[options.clientConfig]) {
	    resolved = validateRegionalEndpointsFlagValue(originalConfig[options.clientConfig], {
	      code: 'InvalidConfiguration',
	      message: 'invalid "' + options.clientConfig + '" configuration. Expect "legacy" ' +
	      ' or "regional". Got "' + originalConfig[options.clientConfig] + '".'
	    });
	    if (resolved) return resolved;
	  }
	  if (!AWS.util.isNode()) return resolved;
	  //validate environmental variable
	  if (Object.prototype.hasOwnProperty.call(process.env, options.env)) {
	    var envFlag = process.env[options.env];
	    resolved = validateRegionalEndpointsFlagValue(envFlag, {
	      code: 'InvalidEnvironmentalVariable',
	      message: 'invalid ' + options.env + ' environmental variable. Expect "legacy" ' +
	      ' or "regional". Got "' + process.env[options.env] + '".'
	    });
	    if (resolved) return resolved;
	  }
	  //validate shared config file
	  var profile = {};
	  try {
	    var profiles = AWS.util.getProfilesFromSharedConfig(AWS.util.iniLoader);
	    profile = profiles[process.env.AWS_PROFILE || AWS.util.defaultProfile];
	  } catch (e) {};
	  if (profile && Object.prototype.hasOwnProperty.call(profile, options.sharedConfig)) {
	    var fileFlag = profile[options.sharedConfig];
	    resolved = validateRegionalEndpointsFlagValue(fileFlag, {
	      code: 'InvalidConfiguration',
	      message: 'invalid ' + options.sharedConfig + ' profile config. Expect "legacy" ' +
	      ' or "regional". Got "' + profile[options.sharedConfig] + '".'
	    });
	    if (resolved) return resolved;
	  }
	  return resolved;
	}
	
	module.exports = resolveRegionalEndpointsFlag;
	
	}).call(this)}).call(this,require('_process'))
	},{"./core":342,"_process":432}],342:[function(require,module,exports){
	/**
	 * The main AWS namespace
	 */
	var AWS = { util: require('./util') };
	
	/**
	 * @api private
	 * @!macro [new] nobrowser
	 *   @note This feature is not supported in the browser environment of the SDK.
	 */
	var _hidden = {}; _hidden.toString(); // hack to parse macro
	
	/**
	 * @api private
	 */
	module.exports = AWS;
	
	AWS.util.update(AWS, {
	
	  /**
	   * @constant
	   */
	  VERSION: '2.1163.0',
	
	  /**
	   * @api private
	   */
	  Signers: {},
	
	  /**
	   * @api private
	   */
	  Protocol: {
	    Json: require('./protocol/json'),
	    Query: require('./protocol/query'),
	    Rest: require('./protocol/rest'),
	    RestJson: require('./protocol/rest_json'),
	    RestXml: require('./protocol/rest_xml')
	  },
	
	  /**
	   * @api private
	   */
	  XML: {
	    Builder: require('./xml/builder'),
	    Parser: null // conditionally set based on environment
	  },
	
	  /**
	   * @api private
	   */
	  JSON: {
	    Builder: require('./json/builder'),
	    Parser: require('./json/parser')
	  },
	
	  /**
	   * @api private
	   */
	  Model: {
	    Api: require('./model/api'),
	    Operation: require('./model/operation'),
	    Shape: require('./model/shape'),
	    Paginator: require('./model/paginator'),
	    ResourceWaiter: require('./model/resource_waiter')
	  },
	
	  /**
	   * @api private
	   */
	  apiLoader: require('./api_loader'),
	
	  /**
	   * @api private
	   */
	  EndpointCache: require('../vendor/endpoint-cache').EndpointCache
	});
	require('./sequential_executor');
	require('./service');
	require('./config');
	require('./http');
	require('./event_listeners');
	require('./request');
	require('./response');
	require('./resource_waiter');
	require('./signers/request_signer');
	require('./param_validator');
	
	/**
	 * @readonly
	 * @return [AWS.SequentialExecutor] a collection of global event listeners that
	 *   are attached to every sent request.
	 * @see AWS.Request AWS.Request for a list of events to listen for
	 * @example Logging the time taken to send a request
	 *   AWS.events.on('send', function startSend(resp) {
	 *     resp.startTime = new Date().getTime();
	 *   }).on('complete', function calculateTime(resp) {
	 *     var time = (new Date().getTime() - resp.startTime) / 1000;
	 *     console.log('Request took ' + time + ' seconds');
	 *   });
	 *
	 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
	 */
	AWS.events = new AWS.SequentialExecutor();
	
	//create endpoint cache lazily
	AWS.util.memoizedProperty(AWS, 'endpointCache', function() {
	  return new AWS.EndpointCache(AWS.config.endpointCacheSize);
	}, true);
	
	},{"../vendor/endpoint-cache":455,"./api_loader":331,"./config":340,"./event_listeners":363,"./http":364,"./json/builder":366,"./json/parser":367,"./model/api":368,"./model/operation":370,"./model/paginator":371,"./model/resource_waiter":372,"./model/shape":373,"./param_validator":374,"./protocol/json":377,"./protocol/query":378,"./protocol/rest":379,"./protocol/rest_json":380,"./protocol/rest_xml":381,"./request":388,"./resource_waiter":389,"./response":390,"./sequential_executor":392,"./service":393,"./signers/request_signer":410,"./util":418,"./xml/builder":420}],343:[function(require,module,exports){
	var AWS = require('./core');
	
	/**
	 * Represents your AWS security credentials, specifically the
	 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
	 * Creating a `Credentials` object allows you to pass around your
	 * security information to configuration and service objects.
	 *
	 * Note that this class typically does not need to be constructed manually,
	 * as the {AWS.Config} and {AWS.Service} classes both accept simple
	 * options hashes with the three keys. These structures will be converted
	 * into Credentials objects automatically.
	 *
	 * ## Expiring and Refreshing Credentials
	 *
	 * Occasionally credentials can expire in the middle of a long-running
	 * application. In this case, the SDK will automatically attempt to
	 * refresh the credentials from the storage location if the Credentials
	 * class implements the {refresh} method.
	 *
	 * If you are implementing a credential storage location, you
	 * will want to create a subclass of the `Credentials` class and
	 * override the {refresh} method. This method allows credentials to be
	 * retrieved from the backing store, be it a file system, database, or
	 * some network storage. The method should reset the credential attributes
	 * on the object.
	 *
	 * @!attribute expired
	 *   @return [Boolean] whether the credentials have been expired and
	 *     require a refresh. Used in conjunction with {expireTime}.
	 * @!attribute expireTime
	 *   @return [Date] a time when credentials should be considered expired. Used
	 *     in conjunction with {expired}.
	 * @!attribute accessKeyId
	 *   @return [String] the AWS access key ID
	 * @!attribute secretAccessKey
	 *   @return [String] the AWS secret access key
	 * @!attribute sessionToken
	 *   @return [String] an optional AWS session token
	 */
	AWS.Credentials = AWS.util.inherit({
	  /**
	   * A credentials object can be created using positional arguments or an options
	   * hash.
	   *
	   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
	   *   Creates a Credentials object with a given set of credential information
	   *   as positional arguments.
	   *   @param accessKeyId [String] the AWS access key ID
	   *   @param secretAccessKey [String] the AWS secret access key
	   *   @param sessionToken [String] the optional AWS session token
	   *   @example Create a credentials object with AWS credentials
	   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
	   * @overload AWS.Credentials(options)
	   *   Creates a Credentials object with a given set of credential information
	   *   as an options hash.
	   *   @option options accessKeyId [String] the AWS access key ID
	   *   @option options secretAccessKey [String] the AWS secret access key
	   *   @option options sessionToken [String] the optional AWS session token
	   *   @example Create a credentials object with AWS credentials
	   *     var creds = new AWS.Credentials({
	   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
	   *     });
	   */
	  constructor: function Credentials() {
	    // hide secretAccessKey from being displayed with util.inspect
	    AWS.util.hideProperties(this, ['secretAccessKey']);
	
	    this.expired = false;
	    this.expireTime = null;
	    this.refreshCallbacks = [];
	    if (arguments.length === 1 && typeof arguments[0] === 'object') {
	      var creds = arguments[0].credentials || arguments[0];
	      this.accessKeyId = creds.accessKeyId;
	      this.secretAccessKey = creds.secretAccessKey;
	      this.sessionToken = creds.sessionToken;
	    } else {
	      this.accessKeyId = arguments[0];
	      this.secretAccessKey = arguments[1];
	      this.sessionToken = arguments[2];
	    }
	  },
	
	  /**
	   * @return [Integer] the number of seconds before {expireTime} during which
	   *   the credentials will be considered expired.
	   */
	  expiryWindow: 15,
	
	  /**
	   * @return [Boolean] whether the credentials object should call {refresh}
	   * @note Subclasses should override this method to provide custom refresh
	   *   logic.
	   */
	  needsRefresh: function needsRefresh() {
	    var currentTime = AWS.util.date.getDate().getTime();
	    var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);
	
	    if (this.expireTime && adjustedTime > this.expireTime) {
	      return true;
	    } else {
	      return this.expired || !this.accessKeyId || !this.secretAccessKey;
	    }
	  },
	
	  /**
	   * Gets the existing credentials, refreshing them if they are not yet loaded
	   * or have expired. Users should call this method before using {refresh},
	   * as this will not attempt to reload credentials when they are already
	   * loaded into the object.
	   *
	   * @callback callback function(err)
	   *   When this callback is called with no error, it means either credentials
	   *   do not need to be refreshed or refreshed credentials information has
	   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
	   *   and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   */
	  get: function get(callback) {
	    var self = this;
	    if (this.needsRefresh()) {
	      this.refresh(function(err) {
	        if (!err) self.expired = false; // reset expired flag
	        if (callback) callback(err);
	      });
	    } else if (callback) {
	      callback();
	    }
	  },
	
	  /**
	   * @!method  getPromise()
	   *   Returns a 'thenable' promise.
	   *   Gets the existing credentials, refreshing them if they are not yet loaded
	   *   or have expired. Users should call this method before using {refresh},
	   *   as this will not attempt to reload credentials when they are already
	   *   loaded into the object.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function()
	   *     Called if the promise is fulfilled. When this callback is called, it
	   *     means either credentials do not need to be refreshed or refreshed
	   *     credentials information has been loaded into the object (as the
	   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `get` call.
	   *   @example Calling the `getPromise` method.
	   *     var promise = credProvider.getPromise();
	   *     promise.then(function() { ... }, function(err) { ... });
	   */
	
	  /**
	   * @!method  refreshPromise()
	   *   Returns a 'thenable' promise.
	   *   Refreshes the credentials. Users should call {get} before attempting
	   *   to forcibly refresh credentials.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function()
	   *     Called if the promise is fulfilled. When this callback is called, it
	   *     means refreshed credentials information has been loaded into the object
	   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `refresh` call.
	   *   @example Calling the `refreshPromise` method.
	   *     var promise = credProvider.refreshPromise();
	   *     promise.then(function() { ... }, function(err) { ... });
	   */
	
	  /**
	   * Refreshes the credentials. Users should call {get} before attempting
	   * to forcibly refresh credentials.
	   *
	   * @callback callback function(err)
	   *   When this callback is called with no error, it means refreshed
	   *   credentials information has been loaded into the object (as the
	   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @note Subclasses should override this class to reset the
	   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
	   *   on the credentials object and then call the callback with
	   *   any error information.
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.expired = false;
	    callback();
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  coalesceRefresh: function coalesceRefresh(callback, sync) {
	    var self = this;
	    if (self.refreshCallbacks.push(callback) === 1) {
	      self.load(function onLoad(err) {
	        AWS.util.arrayEach(self.refreshCallbacks, function(callback) {
	          if (sync) {
	            callback(err);
	          } else {
	            // callback could throw, so defer to ensure all callbacks are notified
	            AWS.util.defer(function () {
	              callback(err);
	            });
	          }
	        });
	        self.refreshCallbacks.length = 0;
	      });
	    }
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    callback();
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.getPromise = AWS.util.promisifyMethod('get', PromiseDependency);
	  this.prototype.refreshPromise = AWS.util.promisifyMethod('refresh', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.getPromise;
	  delete this.prototype.refreshPromise;
	};
	
	AWS.util.addPromises(AWS.Credentials);
	
	},{"./core":342}],344:[function(require,module,exports){
	var AWS = require('../core');
	var STS = require('../../clients/sts');
	
	/**
	 * Represents temporary credentials retrieved from {AWS.STS}. Without any
	 * extra parameters, credentials will be fetched from the
	 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
	 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
	 * role instead.
	 *
	 * AWS.ChainableTemporaryCredentials differs from AWS.TemporaryCredentials in
	 * the way masterCredentials and refreshes are handled.
	 * AWS.ChainableTemporaryCredentials refreshes expired credentials using the
	 * masterCredentials passed by the user to support chaining of STS credentials.
	 * However, AWS.TemporaryCredentials recursively collapses the masterCredentials
	 * during instantiation, precluding the ability to refresh credentials which
	 * require intermediate, temporary credentials.
	 *
	 * For example, if the application should use RoleA, which must be assumed from
	 * RoleB, and the environment provides credentials which can assume RoleB, then
	 * AWS.ChainableTemporaryCredentials must be used to support refreshing the
	 * temporary credentials for RoleA:
	 *
	 * ```javascript
	 * var roleACreds = new AWS.ChainableTemporaryCredentials({
	 *   params: {RoleArn: 'RoleA'},
	 *   masterCredentials: new AWS.ChainableTemporaryCredentials({
	 *     params: {RoleArn: 'RoleB'},
	 *     masterCredentials: new AWS.EnvironmentCredentials('AWS')
	 *   })
	 * });
	 * ```
	 *
	 * If AWS.TemporaryCredentials had been used in the previous example,
	 * `roleACreds` would fail to refresh because `roleACreds` would
	 * use the environment credentials for the AssumeRole request.
	 *
	 * Another difference is that AWS.ChainableTemporaryCredentials creates the STS
	 * service instance during instantiation while AWS.TemporaryCredentials creates
	 * the STS service instance during the first refresh. Creating the service
	 * instance during instantiation effectively captures the master credentials
	 * from the global config, so that subsequent changes to the global config do
	 * not affect the master credentials used to refresh the temporary credentials.
	 *
	 * This allows an instance of AWS.ChainableTemporaryCredentials to be assigned
	 * to AWS.config.credentials:
	 *
	 * ```javascript
	 * var envCreds = new AWS.EnvironmentCredentials('AWS');
	 * AWS.config.credentials = envCreds;
	 * // masterCredentials will be envCreds
	 * AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
	 *   params: {RoleArn: '...'}
	 * });
	 * ```
	 *
	 * Similarly, to use the CredentialProviderChain's default providers as the
	 * master credentials, simply create a new instance of
	 * AWS.ChainableTemporaryCredentials:
	 *
	 * ```javascript
	 * AWS.config.credentials = new ChainableTemporaryCredentials({
	 *   params: {RoleArn: '...'}
	 * });
	 * ```
	 *
	 * @!attribute service
	 *   @return [AWS.STS] the STS service instance used to
	 *     get and refresh temporary credentials from AWS STS.
	 * @note (see constructor)
	 */
	AWS.ChainableTemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new temporary credentials object.
	   *
	   * @param options [map] a set of options
	   * @option options params [map] ({}) a map of options that are passed to the
	   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
	   *   If a `RoleArn` parameter is passed in, credentials will be based on the
	   *   IAM role. If a `SerialNumber` parameter is passed in, {tokenCodeFn} must
	   *   also be passed in or an error will be thrown.
	   * @option options masterCredentials [AWS.Credentials] the master credentials
	   *   used to get and refresh temporary credentials from AWS STS. By default,
	   *   AWS.config.credentials or AWS.config.credentialProvider will be used.
	   * @option options tokenCodeFn [Function] (null) Function to provide
	   *   `TokenCode`, if `SerialNumber` is provided for profile in {params}. Function
	   *   is called with value of `SerialNumber` and `callback`, and should provide
	   *   the `TokenCode` or an error to the callback in the format
	   *   `callback(err, token)`.
	   * @example Creating a new credentials object for generic temporary credentials
	   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials();
	   * @example Creating a new credentials object for an IAM role
	   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
	   *     params: {
	   *       RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials'
	   *     }
	   *   });
	   * @see AWS.STS.assumeRole
	   * @see AWS.STS.getSessionToken
	   */
	  constructor: function ChainableTemporaryCredentials(options) {
	    AWS.Credentials.call(this);
	    options = options || {};
	    this.errorCode = 'ChainableTemporaryCredentialsProviderFailure';
	    this.expired = true;
	    this.tokenCodeFn = null;
	
	    var params = AWS.util.copy(options.params) || {};
	    if (params.RoleArn) {
	      params.RoleSessionName = params.RoleSessionName || 'temporary-credentials';
	    }
	    if (params.SerialNumber) {
	      if (!options.tokenCodeFn || (typeof options.tokenCodeFn !== 'function')) {
	        throw new AWS.util.error(
	          new Error('tokenCodeFn must be a function when params.SerialNumber is given'),
	          {code: this.errorCode}
	        );
	      } else {
	        this.tokenCodeFn = options.tokenCodeFn;
	      }
	    }
	    var config = AWS.util.merge(
	      {
	        params: params,
	        credentials: options.masterCredentials || AWS.config.credentials
	      },
	      options.stsConfig || {}
	    );
	    this.service = new STS(config);
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRole} or
	   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
	   * to the credentials {constructor}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see AWS.Credentials.get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    var self = this;
	    var operation = self.service.config.params.RoleArn ? 'assumeRole' : 'getSessionToken';
	    this.getTokenCode(function (err, tokenCode) {
	      var params = {};
	      if (err) {
	        callback(err);
	        return;
	      }
	      if (tokenCode) {
	        params.TokenCode = tokenCode;
	      }
	      self.service[operation](params, function (err, data) {
	        if (!err) {
	          self.service.credentialsFrom(data, self);
	        }
	        callback(err);
	      });
	    });
	  },
	
	  /**
	   * @api private
	   */
	  getTokenCode: function getTokenCode(callback) {
	    var self = this;
	    if (this.tokenCodeFn) {
	      this.tokenCodeFn(this.service.config.params.SerialNumber, function (err, token) {
	        if (err) {
	          var message = err;
	          if (err instanceof Error) {
	            message = err.message;
	          }
	          callback(
	            AWS.util.error(
	              new Error('Error fetching MFA token: ' + message),
	              { code: self.errorCode}
	            )
	          );
	          return;
	        }
	        callback(null, token);
	      });
	    } else {
	      callback(null);
	    }
	  }
	});
	
	},{"../../clients/sts":326,"../core":342}],345:[function(require,module,exports){
	var AWS = require('../core');
	var CognitoIdentity = require('../../clients/cognitoidentity');
	var STS = require('../../clients/sts');
	
	/**
	 * Represents credentials retrieved from STS Web Identity Federation using
	 * the Amazon Cognito Identity service.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
	 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
	 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
	 * obtain an `IdentityId`. If the identity or identity pool is not configured in
	 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
	 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
	 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
	 * is provided, then this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
	 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
	 *
	 * In addition, if this credential provider is used to provide authenticated
	 * login, the `Logins` map may be set to the tokens provided by the respective
	 * identity providers. See {constructor} for an example on creating a credentials
	 * object with proper property values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the WebIdentityToken, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.CognitoIdentity.getId},
	 *     {AWS.CognitoIdentity.getOpenIdToken}, and
	 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
	 *     `params.WebIdentityToken` property.
	 * @!attribute data
	 *   @return [map] the raw data response from the call to
	 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
	 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
	 *     access to other properties from the response.
	 * @!attribute identityId
	 *   @return [String] the Cognito ID returned by the last call to
	 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
	 *     final resolved identity ID from Amazon Cognito.
	 */
	AWS.CognitoIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * @api private
	   */
	  localStorageKey: {
	    id: 'aws.cognito.identity-id.',
	    providers: 'aws.cognito.identity-providers.'
	  },
	
	  /**
	   * Creates a new credentials object.
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
	   *
	   *     // either IdentityPoolId or IdentityId is required
	   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
	   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
	   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
	   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
	   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
	   *
	   *     // optional, only necessary when the identity pool is not configured
	   *     // to use IAM roles in the Amazon Cognito Console
	   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
	   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
	   *
	   *     // optional tokens, used for authenticated login
	   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
	   *     Logins: {
	   *       'graph.facebook.com': 'FBTOKEN',
	   *       'www.amazon.com': 'AMAZONTOKEN',
	   *       'accounts.google.com': 'GOOGLETOKEN',
	   *       'api.twitter.com': 'TWITTERTOKEN',
	   *       'www.digits.com': 'DIGITSTOKEN'
	   *     },
	   *
	   *     // optional name, defaults to web-identity
	   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
	   *     RoleSessionName: 'web',
	   *
	   *     // optional, only necessary when application runs in a browser
	   *     // and multiple users are signed in at once, used for caching
	   *     LoginId: 'example@gmail.com'
	   *
	   *   }, {
	   *      // optionally provide configuration to apply to the underlying service clients
	   *      // if configuration is not provided, then configuration will be pulled from AWS.config
	   *
	   *      // region should match the region your identity pool is located in
	   *      region: 'us-east-1',
	   *
	   *      // specify timeout options
	   *      httpOptions: {
	   *        timeout: 100
	   *      }
	   *   });
	   * @see AWS.CognitoIdentity.getId
	   * @see AWS.CognitoIdentity.getCredentialsForIdentity
	   * @see AWS.STS.assumeRoleWithWebIdentity
	   * @see AWS.CognitoIdentity.getOpenIdToken
	   * @see AWS.Config
	   * @note If a region is not provided in the global AWS.config, or
	   *   specified in the `clientConfig` to the CognitoIdentityCredentials
	   *   constructor, you may encounter a 'Missing credentials in config' error
	   *   when calling making a service call.
	   */
	  constructor: function CognitoIdentityCredentials(params, clientConfig) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	    this.data = null;
	    this._identityId = null;
	    this._clientConfig = AWS.util.copy(clientConfig || {});
	    this.loadCachedId();
	    var self = this;
	    Object.defineProperty(this, 'identityId', {
	      get: function() {
	        self.loadCachedId();
	        return self._identityId || self.params.IdentityId;
	      },
	      set: function(identityId) {
	        self._identityId = identityId;
	      }
	    });
	  },
	
	  /**
	   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
	   * or {AWS.STS.assumeRoleWithWebIdentity}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see AWS.Credentials.get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.data = null;
	    self._identityId = null;
	    self.getId(function(err) {
	      if (!err) {
	        if (!self.params.RoleArn) {
	          self.getCredentialsForIdentity(callback);
	        } else {
	          self.getCredentialsFromSTS(callback);
	        }
	      } else {
	        self.clearIdOnNotAuthorized(err);
	        callback(err);
	      }
	    });
	  },
	
	  /**
	   * Clears the cached Cognito ID associated with the currently configured
	   * identity pool ID. Use this to manually invalidate your cache if
	   * the identity pool ID was deleted.
	   */
	  clearCachedId: function clearCache() {
	    this._identityId = null;
	    delete this.params.IdentityId;
	
	    var poolId = this.params.IdentityPoolId;
	    var loginId = this.params.LoginId || '';
	    delete this.storage[this.localStorageKey.id + poolId + loginId];
	    delete this.storage[this.localStorageKey.providers + poolId + loginId];
	  },
	
	  /**
	   * @api private
	   */
	  clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
	    var self = this;
	    if (err.code == 'NotAuthorizedException') {
	      self.clearCachedId();
	    }
	  },
	
	  /**
	   * Retrieves a Cognito ID, loading from cache if it was already retrieved
	   * on this device.
	   *
	   * @callback callback function(err, identityId)
	   *   @param err [Error, null] an error object if the call failed or null if
	   *     it succeeded.
	   *   @param identityId [String, null] if successful, the callback will return
	   *     the Cognito ID.
	   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
	   *   localStorage in the browser environment of a device.
	   * @api private
	   */
	  getId: function getId(callback) {
	    var self = this;
	    if (typeof self.params.IdentityId === 'string') {
	      return callback(null, self.params.IdentityId);
	    }
	
	    self.cognito.getId(function(err, data) {
	      if (!err && data.IdentityId) {
	        self.params.IdentityId = data.IdentityId;
	        callback(null, data.IdentityId);
	      } else {
	        callback(err);
	      }
	    });
	  },
	
	
	  /**
	   * @api private
	   */
	  loadCredentials: function loadCredentials(data, credentials) {
	    if (!data || !credentials) return;
	    credentials.expired = false;
	    credentials.accessKeyId = data.Credentials.AccessKeyId;
	    credentials.secretAccessKey = data.Credentials.SecretKey;
	    credentials.sessionToken = data.Credentials.SessionToken;
	    credentials.expireTime = data.Credentials.Expiration;
	  },
	
	  /**
	   * @api private
	   */
	  getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
	    var self = this;
	    self.cognito.getCredentialsForIdentity(function(err, data) {
	      if (!err) {
	        self.cacheId(data);
	        self.data = data;
	        self.loadCredentials(self.data, self);
	      } else {
	        self.clearIdOnNotAuthorized(err);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
	    var self = this;
	    self.cognito.getOpenIdToken(function(err, data) {
	      if (!err) {
	        self.cacheId(data);
	        self.params.WebIdentityToken = data.Token;
	        self.webIdentityCredentials.refresh(function(webErr) {
	          if (!webErr) {
	            self.data = self.webIdentityCredentials.data;
	            self.sts.credentialsFrom(self.data, self);
	          }
	          callback(webErr);
	        });
	      } else {
	        self.clearIdOnNotAuthorized(err);
	        callback(err);
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  loadCachedId: function loadCachedId() {
	    var self = this;
	
	    // in the browser we source default IdentityId from localStorage
	    if (AWS.util.isBrowser() && !self.params.IdentityId) {
	      var id = self.getStorage('id');
	      if (id && self.params.Logins) {
	        var actualProviders = Object.keys(self.params.Logins);
	        var cachedProviders =
	          (self.getStorage('providers') || '').split(',');
	
	        // only load ID if at least one provider used this ID before
	        var intersect = cachedProviders.filter(function(n) {
	          return actualProviders.indexOf(n) !== -1;
	        });
	        if (intersect.length !== 0) {
	          self.params.IdentityId = id;
	        }
	      } else if (id) {
	        self.params.IdentityId = id;
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    var clientConfig = this._clientConfig;
	    this.webIdentityCredentials = this.webIdentityCredentials ||
	      new AWS.WebIdentityCredentials(this.params, clientConfig);
	    if (!this.cognito) {
	      var cognitoConfig = AWS.util.merge({}, clientConfig);
	      cognitoConfig.params = this.params;
	      this.cognito = new CognitoIdentity(cognitoConfig);
	    }
	    this.sts = this.sts || new STS(clientConfig);
	  },
	
	  /**
	   * @api private
	   */
	  cacheId: function cacheId(data) {
	    this._identityId = data.IdentityId;
	    this.params.IdentityId = this._identityId;
	
	    // cache this IdentityId in browser localStorage if possible
	    if (AWS.util.isBrowser()) {
	      this.setStorage('id', data.IdentityId);
	
	      if (this.params.Logins) {
	        this.setStorage('providers', Object.keys(this.params.Logins).join(','));
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getStorage: function getStorage(key) {
	    return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')];
	  },
	
	  /**
	   * @api private
	   */
	  setStorage: function setStorage(key, val) {
	    try {
	      this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')] = val;
	    } catch (_) {}
	  },
	
	  /**
	   * @api private
	   */
	  storage: (function() {
	    try {
	      var storage = AWS.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === 'object' ?
	          window.localStorage : {};
	
	      // Test set/remove which would throw an error in Safari's private browsing
	      storage['aws.test-storage'] = 'foobar';
	      delete storage['aws.test-storage'];
	
	      return storage;
	    } catch (_) {
	      return {};
	    }
	  })()
	});
	
	},{"../../clients/cognitoidentity":258,"../../clients/sts":326,"../core":342}],346:[function(require,module,exports){
	var AWS = require('../core');
	
	/**
	 * Creates a credential provider chain that searches for AWS credentials
	 * in a list of credential providers specified by the {providers} property.
	 *
	 * By default, the chain will use the {defaultProviders} to resolve credentials.
	 * These providers will look in the environment using the
	 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
	 *
	 * ## Setting Providers
	 *
	 * Each provider in the {providers} list should be a function that returns
	 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
	 * form allows for delayed execution of the credential construction.
	 *
	 * ## Resolving Credentials from a Chain
	 *
	 * Call {resolve} to return the first valid credential object that can be
	 * loaded by the provider chain.
	 *
	 * For example, to resolve a chain with a custom provider that checks a file
	 * on disk after the set of {defaultProviders}:
	 *
	 * ```javascript
	 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
	 * var chain = new AWS.CredentialProviderChain();
	 * chain.providers.push(diskProvider);
	 * chain.resolve();
	 * ```
	 *
	 * The above code will return the `diskProvider` object if the
	 * file contains credentials and the `defaultProviders` do not contain
	 * any credential settings.
	 *
	 * @!attribute providers
	 *   @return [Array<AWS.Credentials, Function>]
	 *     a list of credentials objects or functions that return credentials
	 *     objects. If the provider is a function, the function will be
	 *     executed lazily when the provider needs to be checked for valid
	 *     credentials. By default, this object will be set to the
	 *     {defaultProviders}.
	 *   @see defaultProviders
	 */
	AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {
	
	  /**
	   * Creates a new CredentialProviderChain with a default set of providers
	   * specified by {defaultProviders}.
	   */
	  constructor: function CredentialProviderChain(providers) {
	    if (providers) {
	      this.providers = providers;
	    } else {
	      this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
	    }
	    this.resolveCallbacks = [];
	  },
	
	  /**
	   * @!method  resolvePromise()
	   *   Returns a 'thenable' promise.
	   *   Resolves the provider chain by searching for the first set of
	   *   credentials in {providers}.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(credentials)
	   *     Called if the promise is fulfilled and the provider resolves the chain
	   *     to a credentials object
	   *     @param credentials [AWS.Credentials] the credentials object resolved
	   *       by the provider chain.
	   *   @callback rejectedCallback function(error)
	   *     Called if the promise is rejected.
	   *     @param err [Error] the error object returned if no credentials are found.
	   *   @return [Promise] A promise that represents the state of the `resolve` method call.
	   *   @example Calling the `resolvePromise` method.
	   *     var promise = chain.resolvePromise();
	   *     promise.then(function(credentials) { ... }, function(err) { ... });
	   */
	
	  /**
	   * Resolves the provider chain by searching for the first set of
	   * credentials in {providers}.
	   *
	   * @callback callback function(err, credentials)
	   *   Called when the provider resolves the chain to a credentials object
	   *   or null if no credentials can be found.
	   *
	   *   @param err [Error] the error object returned if no credentials are
	   *     found.
	   *   @param credentials [AWS.Credentials] the credentials object resolved
	   *     by the provider chain.
	   * @return [AWS.CredentialProviderChain] the provider, for chaining.
	   */
	  resolve: function resolve(callback) {
	    var self = this;
	    if (self.providers.length === 0) {
	      callback(new Error('No providers'));
	      return self;
	    }
	
	    if (self.resolveCallbacks.push(callback) === 1) {
	      var index = 0;
	      var providers = self.providers.slice(0);
	
	      function resolveNext(err, creds) {
	        if ((!err && creds) || index === providers.length) {
	          AWS.util.arrayEach(self.resolveCallbacks, function (callback) {
	            callback(err, creds);
	          });
	          self.resolveCallbacks.length = 0;
	          return;
	        }
	
	        var provider = providers[index++];
	        if (typeof provider === 'function') {
	          creds = provider.call();
	        } else {
	          creds = provider;
	        }
	
	        if (creds.get) {
	          creds.get(function (getErr) {
	            resolveNext(getErr, getErr ? null : creds);
	          });
	        } else {
	          resolveNext(null, creds);
	        }
	      }
	
	      resolveNext();
	    }
	
	    return self;
	  }
	});
	
	/**
	 * The default set of providers used by a vanilla CredentialProviderChain.
	 *
	 * In the browser:
	 *
	 * ```javascript
	 * AWS.CredentialProviderChain.defaultProviders = []
	 * ```
	 *
	 * In Node.js:
	 *
	 * ```javascript
	 * AWS.CredentialProviderChain.defaultProviders = [
	 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
	 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
	 *   function () { return new AWS.SsoCredentials(); },
	 *   function () { return new AWS.SharedIniFileCredentials(); },
	 *   function () { return new AWS.ECSCredentials(); },
	 *   function () { return new AWS.ProcessCredentials(); },
	 *   function () { return new AWS.TokenFileWebIdentityCredentials(); },
	 *   function () { return new AWS.EC2MetadataCredentials() }
	 * ]
	 * ```
	 */
	AWS.CredentialProviderChain.defaultProviders = [];
	
	/**
	 * @api private
	 */
	AWS.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.resolvePromise = AWS.util.promisifyMethod('resolve', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.resolvePromise;
	};
	
	AWS.util.addPromises(AWS.CredentialProviderChain);
	
	},{"../core":342}],347:[function(require,module,exports){
	var AWS = require('../core');
	var STS = require('../../clients/sts');
	
	/**
	 * Represents credentials retrieved from STS SAML support.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
	 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
	 * application for which credentials will be given, as well as a `PrincipalArn`
	 * representing the ARN for the SAML identity provider. In addition, the
	 * `SAMLAssertion` must be set to the token provided by the identity
	 * provider. See {constructor} for an example on creating a credentials
	 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the SAMLAssertion, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
	 *     `params.SAMLAssertion` property.
	 */
	AWS.SAMLCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new credentials object.
	   * @param (see AWS.STS.assumeRoleWithSAML)
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.SAMLCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
	   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
	   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
	   *   });
	   * @see AWS.STS.assumeRoleWithSAML
	   */
	  constructor: function SAMLCredentials(params) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.service.assumeRoleWithSAML(function (err, data) {
	      if (!err) {
	        self.service.credentialsFrom(data, self);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    this.service = this.service || new STS({params: this.params});
	  }
	
	});
	
	},{"../../clients/sts":326,"../core":342}],348:[function(require,module,exports){
	var AWS = require('../core');
	var STS = require('../../clients/sts');
	
	/**
	 * Represents temporary credentials retrieved from {AWS.STS}. Without any
	 * extra parameters, credentials will be fetched from the
	 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
	 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
	 * role instead.
	 *
	 * @note AWS.TemporaryCredentials is deprecated, but remains available for
	 *   backwards compatibility. {AWS.ChainableTemporaryCredentials} is the
	 *   preferred class for temporary credentials.
	 *
	 * To setup temporary credentials, configure a set of master credentials
	 * using the standard credentials providers (environment, EC2 instance metadata,
	 * or from the filesystem), then set the global credentials to a new
	 * temporary credentials object:
	 *
	 * ```javascript
	 * // Note that environment credentials are loaded by default,
	 * // the following line is shown for clarity:
	 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
	 *
	 * // Now set temporary credentials seeded from the master credentials
	 * AWS.config.credentials = new AWS.TemporaryCredentials();
	 *
	 * // subsequent requests will now use temporary credentials from AWS STS.
	 * new AWS.S3().listBucket(function(err, data) { ... });
	 * ```
	 *
	 * @!attribute masterCredentials
	 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
	 *     get and refresh temporary credentials from AWS STS.
	 * @note (see constructor)
	 */
	AWS.TemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new temporary credentials object.
	   *
	   * @note In order to create temporary credentials, you first need to have
	   *   "master" credentials configured in {AWS.Config.credentials}. These
	   *   master credentials are necessary to retrieve the temporary credentials,
	   *   as well as refresh the credentials when they expire.
	   * @param params [map] a map of options that are passed to the
	   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
	   *   If a `RoleArn` parameter is passed in, credentials will be based on the
	   *   IAM role.
	   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
	   *  used to get and refresh temporary credentials from AWS STS.
	   * @example Creating a new credentials object for generic temporary credentials
	   *   AWS.config.credentials = new AWS.TemporaryCredentials();
	   * @example Creating a new credentials object for an IAM role
	   *   AWS.config.credentials = new AWS.TemporaryCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
	   *   });
	   * @see AWS.STS.assumeRole
	   * @see AWS.STS.getSessionToken
	   */
	  constructor: function TemporaryCredentials(params, masterCredentials) {
	    AWS.Credentials.call(this);
	    this.loadMasterCredentials(masterCredentials);
	    this.expired = true;
	
	    this.params = params || {};
	    if (this.params.RoleArn) {
	      this.params.RoleSessionName =
	        this.params.RoleSessionName || 'temporary-credentials';
	    }
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRole} or
	   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
	   * to the credentials {constructor}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh (callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   */
	  load: function load (callback) {
	    var self = this;
	    self.createClients();
	    self.masterCredentials.get(function () {
	      self.service.config.credentials = self.masterCredentials;
	      var operation = self.params.RoleArn ?
	        self.service.assumeRole : self.service.getSessionToken;
	      operation.call(self.service, function (err, data) {
	        if (!err) {
	          self.service.credentialsFrom(data, self);
	        }
	        callback(err);
	      });
	    });
	  },
	
	  /**
	   * @api private
	   */
	  loadMasterCredentials: function loadMasterCredentials (masterCredentials) {
	    this.masterCredentials = masterCredentials || AWS.config.credentials;
	    while (this.masterCredentials.masterCredentials) {
	      this.masterCredentials = this.masterCredentials.masterCredentials;
	    }
	
	    if (typeof this.masterCredentials.get !== 'function') {
	      this.masterCredentials = new AWS.Credentials(this.masterCredentials);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function () {
	    this.service = this.service || new STS({params: this.params});
	  }
	
	});
	
	},{"../../clients/sts":326,"../core":342}],349:[function(require,module,exports){
	var AWS = require('../core');
	var STS = require('../../clients/sts');
	
	/**
	 * Represents credentials retrieved from STS Web Identity Federation support.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
	 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
	 * application for which credentials will be given. In addition, the
	 * `WebIdentityToken` must be set to the token provided by the identity
	 * provider. See {constructor} for an example on creating a credentials
	 * object with proper `RoleArn` and `WebIdentityToken` values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the WebIdentityToken, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
	 *     `params.WebIdentityToken` property.
	 * @!attribute data
	 *   @return [map] the raw data response from the call to
	 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
	 *     access to other properties from the response.
	 */
	AWS.WebIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new credentials object.
	   * @param (see AWS.STS.assumeRoleWithWebIdentity)
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
	   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
	   *     RoleSessionName: 'web' // optional name, defaults to web-identity
	   *   }, {
	   *     // optionally provide configuration to apply to the underlying AWS.STS service client
	   *     // if configuration is not provided, then configuration will be pulled from AWS.config
	   *
	   *     // specify timeout options
	   *     httpOptions: {
	   *       timeout: 100
	   *     }
	   *   });
	   * @see AWS.STS.assumeRoleWithWebIdentity
	   * @see AWS.Config
	   */
	  constructor: function WebIdentityCredentials(params, clientConfig) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	    this.params.RoleSessionName = this.params.RoleSessionName || 'web-identity';
	    this.data = null;
	    this._clientConfig = AWS.util.copy(clientConfig || {});
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.service.assumeRoleWithWebIdentity(function (err, data) {
	      self.data = null;
	      if (!err) {
	        self.data = data;
	        self.service.credentialsFrom(data, self);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    if (!this.service) {
	      var stsConfig = AWS.util.merge({}, this._clientConfig);
	      stsConfig.params = this.params;
	      this.service = new STS(stsConfig);
	    }
	  }
	
	});
	
	},{"../../clients/sts":326,"../core":342}],350:[function(require,module,exports){
	(function (process){(function (){
	var AWS = require('./core');
	var util = require('./util');
	var endpointDiscoveryEnabledEnvs = ['AWS_ENABLE_ENDPOINT_DISCOVERY', 'AWS_ENDPOINT_DISCOVERY_ENABLED'];
	
	/**
	 * Generate key (except resources and operation part) to index the endpoints in the cache
	 * If input shape has endpointdiscoveryid trait then use
	 *   accessKey + operation + resources + region + service as cache key
	 * If input shape doesn't have endpointdiscoveryid trait then use
	 *   accessKey + region + service as cache key
	 * @return [map<String,String>] object with keys to index endpoints.
	 * @api private
	 */
	function getCacheKey(request) {
	  var service = request.service;
	  var api = service.api || {};
	  var operations = api.operations;
	  var identifiers = {};
	  if (service.config.region) {
	    identifiers.region = service.config.region;
	  }
	  if (api.serviceId) {
	    identifiers.serviceId = api.serviceId;
	  }
	  if (service.config.credentials.accessKeyId) {
	    identifiers.accessKeyId = service.config.credentials.accessKeyId;
	  }
	  return identifiers;
	}
	
	/**
	 * Recursive helper for marshallCustomIdentifiers().
	 * Looks for required string input members that have 'endpointdiscoveryid' trait.
	 * @api private
	 */
	function marshallCustomIdentifiersHelper(result, params, shape) {
	  if (!shape || params === undefined || params === null) return;
	  if (shape.type === 'structure' && shape.required && shape.required.length > 0) {
	    util.arrayEach(shape.required, function(name) {
	      var memberShape = shape.members[name];
	      if (memberShape.endpointDiscoveryId === true) {
	        var locationName = memberShape.isLocationName ? memberShape.name : name;
	        result[locationName] = String(params[name]);
	      } else {
	        marshallCustomIdentifiersHelper(result, params[name], memberShape);
	      }
	    });
	  }
	}
	
	/**
	 * Get custom identifiers for cache key.
	 * Identifies custom identifiers by checking each shape's `endpointDiscoveryId` trait.
	 * @param [object] request object
	 * @param [object] input shape of the given operation's api
	 * @api private
	 */
	function marshallCustomIdentifiers(request, shape) {
	  var identifiers = {};
	  marshallCustomIdentifiersHelper(identifiers, request.params, shape);
	  return identifiers;
	}
	
	/**
	 * Call endpoint discovery operation when it's optional.
	 * When endpoint is available in cache then use the cached endpoints. If endpoints
	 * are unavailable then use regional endpoints and call endpoint discovery operation
	 * asynchronously. This is turned off by default.
	 * @param [object] request object
	 * @api private
	 */
	function optionalDiscoverEndpoint(request) {
	  var service = request.service;
	  var api = service.api;
	  var operationModel = api.operations ? api.operations[request.operation] : undefined;
	  var inputShape = operationModel ? operationModel.input : undefined;
	
	  var identifiers = marshallCustomIdentifiers(request, inputShape);
	  var cacheKey = getCacheKey(request);
	  if (Object.keys(identifiers).length > 0) {
	    cacheKey = util.update(cacheKey, identifiers);
	    if (operationModel) cacheKey.operation = operationModel.name;
	  }
	  var endpoints = AWS.endpointCache.get(cacheKey);
	  if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') {
	    //endpoint operation is being made but response not yet received
	    //or endpoint operation just failed in 1 minute
	    return;
	  } else if (endpoints && endpoints.length > 0) {
	    //found endpoint record from cache
	    request.httpRequest.updateEndpoint(endpoints[0].Address);
	  } else {
	    //endpoint record not in cache or outdated. make discovery operation
	    var endpointRequest = service.makeRequest(api.endpointOperation, {
	      Operation: operationModel.name,
	      Identifiers: identifiers,
	    });
	    addApiVersionHeader(endpointRequest);
	    endpointRequest.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	    endpointRequest.removeListener('retry', AWS.EventListeners.Core.RETRY_CHECK);
	    //put in a placeholder for endpoints already requested, prevent
	    //too much in-flight calls
	    AWS.endpointCache.put(cacheKey, [{
	      Address: '',
	      CachePeriodInMinutes: 1
	    }]);
	    endpointRequest.send(function(err, data) {
	      if (data && data.Endpoints) {
	        AWS.endpointCache.put(cacheKey, data.Endpoints);
	      } else if (err) {
	        AWS.endpointCache.put(cacheKey, [{
	          Address: '',
	          CachePeriodInMinutes: 1 //not to make more endpoint operation in next 1 minute
	        }]);
	      }
	    });
	  }
	}
	
	var requestQueue = {};
	
	/**
	 * Call endpoint discovery operation when it's required.
	 * When endpoint is available in cache then use cached ones. If endpoints are
	 * unavailable then SDK should call endpoint operation then use returned new
	 * endpoint for the api call. SDK will automatically attempt to do endpoint
	 * discovery. This is turned off by default
	 * @param [object] request object
	 * @api private
	 */
	function requiredDiscoverEndpoint(request, done) {
	  var service = request.service;
	  var api = service.api;
	  var operationModel = api.operations ? api.operations[request.operation] : undefined;
	  var inputShape = operationModel ? operationModel.input : undefined;
	
	  var identifiers = marshallCustomIdentifiers(request, inputShape);
	  var cacheKey = getCacheKey(request);
	  if (Object.keys(identifiers).length > 0) {
	    cacheKey = util.update(cacheKey, identifiers);
	    if (operationModel) cacheKey.operation = operationModel.name;
	  }
	  var cacheKeyStr = AWS.EndpointCache.getKeyString(cacheKey);
	  var endpoints = AWS.endpointCache.get(cacheKeyStr); //endpoint cache also accepts string keys
	  if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') {
	    //endpoint operation is being made but response not yet received
	    //push request object to a pending queue
	    if (!requestQueue[cacheKeyStr]) requestQueue[cacheKeyStr] = [];
	    requestQueue[cacheKeyStr].push({request: request, callback: done});
	    return;
	  } else if (endpoints && endpoints.length > 0) {
	    request.httpRequest.updateEndpoint(endpoints[0].Address);
	    done();
	  } else {
	    var endpointRequest = service.makeRequest(api.endpointOperation, {
	      Operation: operationModel.name,
	      Identifiers: identifiers,
	    });
	    endpointRequest.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	    addApiVersionHeader(endpointRequest);
	
	    //put in a placeholder for endpoints already requested, prevent
	    //too much in-flight calls
	    AWS.endpointCache.put(cacheKeyStr, [{
	      Address: '',
	      CachePeriodInMinutes: 60 //long-live cache
	    }]);
	    endpointRequest.send(function(err, data) {
	      if (err) {
	        request.response.error = util.error(err, { retryable: false });
	        AWS.endpointCache.remove(cacheKey);
	
	        //fail all the pending requests in batch
	        if (requestQueue[cacheKeyStr]) {
	          var pendingRequests = requestQueue[cacheKeyStr];
	          util.arrayEach(pendingRequests, function(requestContext) {
	            requestContext.request.response.error = util.error(err, { retryable: false });
	            requestContext.callback();
	          });
	          delete requestQueue[cacheKeyStr];
	        }
	      } else if (data) {
	        AWS.endpointCache.put(cacheKeyStr, data.Endpoints);
	        request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
	
	        //update the endpoint for all the pending requests in batch
	        if (requestQueue[cacheKeyStr]) {
	          var pendingRequests = requestQueue[cacheKeyStr];
	          util.arrayEach(pendingRequests, function(requestContext) {
	            requestContext.request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
	            requestContext.callback();
	          });
	          delete requestQueue[cacheKeyStr];
	        }
	      }
	      done();
	    });
	  }
	}
	
	/**
	 * add api version header to endpoint operation
	 * @api private
	 */
	function addApiVersionHeader(endpointRequest) {
	  var api = endpointRequest.service.api;
	  var apiVersion = api.apiVersion;
	  if (apiVersion && !endpointRequest.httpRequest.headers['x-amz-api-version']) {
	    endpointRequest.httpRequest.headers['x-amz-api-version'] = apiVersion;
	  }
	}
	
	/**
	 * If api call gets invalid endpoint exception, SDK should attempt to remove the invalid
	 * endpoint from cache.
	 * @api private
	 */
	function invalidateCachedEndpoints(response) {
	  var error = response.error;
	  var httpResponse = response.httpResponse;
	  if (error &&
	    (error.code === 'InvalidEndpointException' || httpResponse.statusCode === 421)
	  ) {
	    var request = response.request;
	    var operations = request.service.api.operations || {};
	    var inputShape = operations[request.operation] ? operations[request.operation].input : undefined;
	    var identifiers = marshallCustomIdentifiers(request, inputShape);
	    var cacheKey = getCacheKey(request);
	    if (Object.keys(identifiers).length > 0) {
	      cacheKey = util.update(cacheKey, identifiers);
	      if (operations[request.operation]) cacheKey.operation = operations[request.operation].name;
	    }
	    AWS.endpointCache.remove(cacheKey);
	  }
	}
	
	/**
	 * If endpoint is explicitly configured, SDK should not do endpoint discovery in anytime.
	 * @param [object] client Service client object.
	 * @api private
	 */
	function hasCustomEndpoint(client) {
	  //if set endpoint is set for specific client, enable endpoint discovery will raise an error.
	  if (client._originalConfig && client._originalConfig.endpoint && client._originalConfig.endpointDiscoveryEnabled === true) {
	    throw util.error(new Error(), {
	      code: 'ConfigurationException',
	      message: 'Custom endpoint is supplied; endpointDiscoveryEnabled must not be true.'
	    });
	  };
	  var svcConfig = AWS.config[client.serviceIdentifier] || {};
	  return Boolean(AWS.config.endpoint || svcConfig.endpoint || (client._originalConfig && client._originalConfig.endpoint));
	}
	
	/**
	 * @api private
	 */
	function isFalsy(value) {
	  return ['false', '0'].indexOf(value) >= 0;
	}
	
	/**
	 * If endpoint discovery should perform for this request when no operation requires endpoint
	 * discovery for the given service.
	 * SDK performs config resolution in order like below:
	 * 1. If set in client configuration.
	 * 2. If set in env AWS_ENABLE_ENDPOINT_DISCOVERY.
	 * 3. If set in shared ini config file with key 'endpoint_discovery_enabled'.
	 * @param [object] request request object.
	 * @returns [boolean|undefined] if endpoint discovery config is not set in any source, this
	 *  function returns undefined
	 * @api private
	 */
	function resolveEndpointDiscoveryConfig(request) {
	  var service = request.service || {};
	  if (service.config.endpointDiscoveryEnabled !== undefined) {
	    return service.config.endpointDiscoveryEnabled;
	  }
	
	  //shared ini file is only available in Node
	  //not to check env in browser
	  if (util.isBrowser()) return undefined;
	
	  // If any of recognized endpoint discovery config env is set
	  for (var i = 0; i < endpointDiscoveryEnabledEnvs.length; i++) {
	    var env = endpointDiscoveryEnabledEnvs[i];
	    if (Object.prototype.hasOwnProperty.call(process.env, env)) {
	      if (process.env[env] === '' || process.env[env] === undefined) {
	        throw util.error(new Error(), {
	          code: 'ConfigurationException',
	          message: 'environmental variable ' + env + ' cannot be set to nothing'
	        });
	      }
	      return !isFalsy(process.env[env]);
	    }
	  }
	
	  var configFile = {};
	  try {
	    configFile = AWS.util.iniLoader ? AWS.util.iniLoader.loadFrom({
	      isConfig: true,
	      filename: process.env[AWS.util.sharedConfigFileEnv]
	    }) : {};
	  } catch (e) {}
	  var sharedFileConfig = configFile[
	    process.env.AWS_PROFILE || AWS.util.defaultProfile
	  ] || {};
	  if (Object.prototype.hasOwnProperty.call(sharedFileConfig, 'endpoint_discovery_enabled')) {
	    if (sharedFileConfig.endpoint_discovery_enabled === undefined) {
	      throw util.error(new Error(), {
	        code: 'ConfigurationException',
	        message: 'config file entry \'endpoint_discovery_enabled\' cannot be set to nothing'
	      });
	    }
	    return !isFalsy(sharedFileConfig.endpoint_discovery_enabled);
	  }
	  return undefined;
	}
	
	/**
	 * attach endpoint discovery logic to request object
	 * @param [object] request
	 * @api private
	 */
	function discoverEndpoint(request, done) {
	  var service = request.service || {};
	  if (hasCustomEndpoint(service) || request.isPresigned()) return done();
	
	  var operations = service.api.operations || {};
	  var operationModel = operations[request.operation];
	  var isEndpointDiscoveryRequired = operationModel ? operationModel.endpointDiscoveryRequired : 'NULL';
	  var isEnabled = resolveEndpointDiscoveryConfig(request);
	  var hasRequiredEndpointDiscovery = service.api.hasRequiredEndpointDiscovery;
	  if (isEnabled || hasRequiredEndpointDiscovery) {
	    // Once a customer enables endpoint discovery, the SDK should start appending
	    // the string endpoint-discovery to the user-agent on all requests.
	    request.httpRequest.appendToUserAgent('endpoint-discovery');
	  }
	  switch (isEndpointDiscoveryRequired) {
	    case 'OPTIONAL':
	      if (isEnabled || hasRequiredEndpointDiscovery) {
	        // For a given service; if at least one operation requires endpoint discovery then the SDK must enable endpoint discovery
	        // by default for all operations of that service, including operations where endpoint discovery is optional.
	        optionalDiscoverEndpoint(request);
	        request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', invalidateCachedEndpoints);
	      }
	      done();
	      break;
	    case 'REQUIRED':
	      if (isEnabled === false) {
	        // For a given operation; if endpoint discovery is required and it has been disabled on the SDK client,
	        // then the SDK must return a clear and actionable exception.
	        request.response.error = util.error(new Error(), {
	          code: 'ConfigurationException',
	          message: 'Endpoint Discovery is disabled but ' + service.api.className + '.' + request.operation +
	                    '() requires it. Please check your configurations.'
	        });
	        done();
	        break;
	      }
	      request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', invalidateCachedEndpoints);
	      requiredDiscoverEndpoint(request, done);
	      break;
	    case 'NULL':
	    default:
	      done();
	      break;
	  }
	}
	
	module.exports = {
	  discoverEndpoint: discoverEndpoint,
	  requiredDiscoverEndpoint: requiredDiscoverEndpoint,
	  optionalDiscoverEndpoint: optionalDiscoverEndpoint,
	  marshallCustomIdentifiers: marshallCustomIdentifiers,
	  getCacheKey: getCacheKey,
	  invalidateCachedEndpoint: invalidateCachedEndpoints,
	};
	
	}).call(this)}).call(this,require('_process'))
	},{"./core":342,"./util":418,"_process":432}],351:[function(require,module,exports){
	var AWS = require('../core');
	var util = AWS.util;
	var typeOf = require('./types').typeOf;
	var DynamoDBSet = require('./set');
	var NumberValue = require('./numberValue');
	
	AWS.DynamoDB.Converter = {
	  /**
	   * Convert a JavaScript value to its equivalent DynamoDB AttributeValue type
	   *
	   * @param data [any] The data to convert to a DynamoDB AttributeValue
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   * @return [map] An object in the Amazon DynamoDB AttributeValue format
	   *
	   * @see AWS.DynamoDB.Converter.marshall AWS.DynamoDB.Converter.marshall to
	   *    convert entire records (rather than individual attributes)
	   */
	  input: function convertInput(data, options) {
	    options = options || {};
	    var type = typeOf(data);
	    if (type === 'Object') {
	      return formatMap(data, options);
	    } else if (type === 'Array') {
	      return formatList(data, options);
	    } else if (type === 'Set') {
	      return formatSet(data, options);
	    } else if (type === 'String') {
	      if (data.length === 0 && options.convertEmptyValues) {
	        return convertInput(null);
	      }
	      return { S: data };
	    } else if (type === 'Number' || type === 'NumberValue') {
	      return { N: data.toString() };
	    } else if (type === 'Binary') {
	      if (data.length === 0 && options.convertEmptyValues) {
	        return convertInput(null);
	      }
	      return { B: data };
	    } else if (type === 'Boolean') {
	      return { BOOL: data };
	    } else if (type === 'null') {
	      return { NULL: true };
	    } else if (type !== 'undefined' && type !== 'Function') {
	      // this value has a custom constructor
	      return formatMap(data, options);
	    }
	  },
	
	  /**
	   * Convert a JavaScript object into a DynamoDB record.
	   *
	   * @param data [any] The data to convert to a DynamoDB record
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   *
	   * @return [map] An object in the DynamoDB record format.
	   *
	   * @example Convert a JavaScript object into a DynamoDB record
	   *  var marshalled = AWS.DynamoDB.Converter.marshall({
	   *    string: 'foo',
	   *    list: ['fizz', 'buzz', 'pop'],
	   *    map: {
	   *      nestedMap: {
	   *        key: 'value',
	   *      }
	   *    },
	   *    number: 123,
	   *    nullValue: null,
	   *    boolValue: true,
	   *    stringSet: new DynamoDBSet(['foo', 'bar', 'baz'])
	   *  });
	   */
	  marshall: function marshallItem(data, options) {
	    return AWS.DynamoDB.Converter.input(data, options).M;
	  },
	
	  /**
	   * Convert a DynamoDB AttributeValue object to its equivalent JavaScript type.
	   *
	   * @param data [map] An object in the Amazon DynamoDB AttributeValue format
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   *
	   * @return [Object|Array|String|Number|Boolean|null]
	   *
	   * @see AWS.DynamoDB.Converter.unmarshall AWS.DynamoDB.Converter.unmarshall to
	   *    convert entire records (rather than individual attributes)
	   */
	  output: function convertOutput(data, options) {
	    options = options || {};
	    var list, map, i;
	    for (var type in data) {
	      var values = data[type];
	      if (type === 'M') {
	        map = {};
	        for (var key in values) {
	          map[key] = convertOutput(values[key], options);
	        }
	        return map;
	      } else if (type === 'L') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(convertOutput(values[i], options));
	        }
	        return list;
	      } else if (type === 'SS') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(values[i] + '');
	        }
	        return new DynamoDBSet(list);
	      } else if (type === 'NS') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(convertNumber(values[i], options.wrapNumbers));
	        }
	        return new DynamoDBSet(list);
	      } else if (type === 'BS') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(AWS.util.buffer.toBuffer(values[i]));
	        }
	        return new DynamoDBSet(list);
	      } else if (type === 'S') {
	        return values + '';
	      } else if (type === 'N') {
	        return convertNumber(values, options.wrapNumbers);
	      } else if (type === 'B') {
	        return util.buffer.toBuffer(values);
	      } else if (type === 'BOOL') {
	        return (values === 'true' || values === 'TRUE' || values === true);
	      } else if (type === 'NULL') {
	        return null;
	      }
	    }
	  },
	
	  /**
	   * Convert a DynamoDB record into a JavaScript object.
	   *
	   * @param data [any] The DynamoDB record
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   *
	   * @return [map] An object whose properties have been converted from
	   *    DynamoDB's AttributeValue format into their corresponding native
	   *    JavaScript types.
	   *
	   * @example Convert a record received from a DynamoDB stream
	   *  var unmarshalled = AWS.DynamoDB.Converter.unmarshall({
	   *    string: {S: 'foo'},
	   *    list: {L: [{S: 'fizz'}, {S: 'buzz'}, {S: 'pop'}]},
	   *    map: {
	   *      M: {
	   *        nestedMap: {
	   *          M: {
	   *            key: {S: 'value'}
	   *          }
	   *        }
	   *      }
	   *    },
	   *    number: {N: '123'},
	   *    nullValue: {NULL: true},
	   *    boolValue: {BOOL: true}
	   *  });
	   */
	  unmarshall: function unmarshall(data, options) {
	    return AWS.DynamoDB.Converter.output({M: data}, options);
	  }
	};
	
	/**
	 * @api private
	 * @param data [Array]
	 * @param options [map]
	 */
	function formatList(data, options) {
	  var list = {L: []};
	  for (var i = 0; i < data.length; i++) {
	    list['L'].push(AWS.DynamoDB.Converter.input(data[i], options));
	  }
	  return list;
	}
	
	/**
	 * @api private
	 * @param value [String]
	 * @param wrapNumbers [Boolean]
	 */
	function convertNumber(value, wrapNumbers) {
	  return wrapNumbers ? new NumberValue(value) : Number(value);
	}
	
	/**
	 * @api private
	 * @param data [map]
	 * @param options [map]
	 */
	function formatMap(data, options) {
	  var map = {M: {}};
	  for (var key in data) {
	    var formatted = AWS.DynamoDB.Converter.input(data[key], options);
	    if (formatted !== void 0) {
	      map['M'][key] = formatted;
	    }
	  }
	  return map;
	}
	
	/**
	 * @api private
	 */
	function formatSet(data, options) {
	  options = options || {};
	  var values = data.values;
	  if (options.convertEmptyValues) {
	    values = filterEmptySetValues(data);
	    if (values.length === 0) {
	      return AWS.DynamoDB.Converter.input(null);
	    }
	  }
	
	  var map = {};
	  switch (data.type) {
	    case 'String': map['SS'] = values; break;
	    case 'Binary': map['BS'] = values; break;
	    case 'Number': map['NS'] = values.map(function (value) {
	      return value.toString();
	    });
	  }
	  return map;
	}
	
	/**
	 * @api private
	 */
	function filterEmptySetValues(set) {
	    var nonEmptyValues = [];
	    var potentiallyEmptyTypes = {
	        String: true,
	        Binary: true,
	        Number: false
	    };
	    if (potentiallyEmptyTypes[set.type]) {
	        for (var i = 0; i < set.values.length; i++) {
	            if (set.values[i].length === 0) {
	                continue;
	            }
	            nonEmptyValues.push(set.values[i]);
	        }
	
	        return nonEmptyValues;
	    }
	
	    return set.values;
	}
	
	/**
	 * @api private
	 */
	module.exports = AWS.DynamoDB.Converter;
	
	},{"../core":342,"./numberValue":353,"./set":354,"./types":356}],352:[function(require,module,exports){
	var AWS = require('../core');
	var Translator = require('./translator');
	var DynamoDBSet = require('./set');
	
	/**
	 * The document client simplifies working with items in Amazon DynamoDB
	 * by abstracting away the notion of attribute values. This abstraction
	 * annotates native JavaScript types supplied as input parameters, as well
	 * as converts annotated response data to native JavaScript types.
	 *
	 * ## Marshalling Input and Unmarshalling Response Data
	 *
	 * The document client affords developers the use of native JavaScript types
	 * instead of `AttributeValue`s to simplify the JavaScript development
	 * experience with Amazon DynamoDB. JavaScript objects passed in as parameters
	 * are marshalled into `AttributeValue` shapes required by Amazon DynamoDB.
	 * Responses from DynamoDB are unmarshalled into plain JavaScript objects
	 * by the `DocumentClient`. The `DocumentClient`, does not accept
	 * `AttributeValue`s in favor of native JavaScript types.
	 *
	 * |                             JavaScript Type                            | DynamoDB AttributeValue |
	 * |:----------------------------------------------------------------------:|-------------------------|
	 * | String                                                                 | S                       |
	 * | Number                                                                 | N                       |
	 * | Boolean                                                                | BOOL                    |
	 * | null                                                                   | NULL                    |
	 * | Array                                                                  | L                       |
	 * | Object                                                                 | M                       |
	 * | Buffer, File, Blob, ArrayBuffer, DataView, and JavaScript typed arrays | B                       |
	 *
	 * ## Support for Sets
	 *
	 * The `DocumentClient` offers a convenient way to create sets from
	 * JavaScript Arrays. The type of set is inferred from the first element
	 * in the array. DynamoDB supports string, number, and binary sets. To
	 * learn more about supported types see the
	 * [Amazon DynamoDB Data Model Documentation](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html)
	 * For more information see {AWS.DynamoDB.DocumentClient.createSet}
	 *
	 */
	AWS.DynamoDB.DocumentClient = AWS.util.inherit({
	
	  /**
	   * Creates a DynamoDB document client with a set of configuration options.
	   *
	   * @option options params [map] An optional map of parameters to bind to every
	   *   request sent by this service object.
	   * @option options service [AWS.DynamoDB] An optional pre-configured instance
	   *  of the AWS.DynamoDB service object. This instance's config will be
	   *  copied to a new instance used by this client. You should not need to
	   *  retain a reference to the input object, and may destroy it or allow it
	   *  to be garbage collected.
	   * @option options convertEmptyValues [Boolean] set to true if you would like
	   *  the document client to convert empty values (0-length strings, binary
	   *  buffers, and sets) to be converted to NULL types when persisting to
	   *  DynamoDB.
	   * @option options wrapNumbers [Boolean] Set to true to return numbers as a
	   *  NumberValue object instead of converting them to native JavaScript numbers.
	   *  This allows for the safe round-trip transport of numbers of arbitrary size.
	   * @see AWS.DynamoDB.constructor
	   *
	   */
	  constructor: function DocumentClient(options) {
	    var self = this;
	    self.options = options || {};
	    self.configure(self.options);
	  },
	
	  /**
	   * @api private
	   */
	  configure: function configure(options) {
	    var self = this;
	    self.service = options.service;
	    self.bindServiceObject(options);
	    self.attrValue = options.attrValue =
	      self.service.api.operations.putItem.input.members.Item.value.shape;
	  },
	
	  /**
	   * @api private
	   */
	  bindServiceObject: function bindServiceObject(options) {
	    var self = this;
	    options = options || {};
	
	    if (!self.service) {
	      self.service = new AWS.DynamoDB(options);
	    } else {
	      var config = AWS.util.copy(self.service.config);
	      self.service = new self.service.constructor.__super__(config);
	      self.service.config.params =
	        AWS.util.merge(self.service.config.params || {}, options.params);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  makeServiceRequest: function(operation, params, callback) {
	    var self = this;
	    var request = self.service[operation](params);
	    self.setupRequest(request);
	    self.setupResponse(request);
	    if (typeof callback === 'function') {
	      request.send(callback);
	    }
	    return request;
	  },
	
	  /**
	   * @api private
	   */
	  serviceClientOperationsMap: {
	    batchGet: 'batchGetItem',
	    batchWrite: 'batchWriteItem',
	    delete: 'deleteItem',
	    get: 'getItem',
	    put: 'putItem',
	    query: 'query',
	    scan: 'scan',
	    update: 'updateItem',
	    transactGet: 'transactGetItems',
	    transactWrite: 'transactWriteItems'
	  },
	
	  /**
	   * Returns the attributes of one or more items from one or more tables
	   * by delegating to `AWS.DynamoDB.batchGetItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.batchGetItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.batchGetItem
	   * @example Get items from multiple tables
	   *  var params = {
	   *    RequestItems: {
	   *      'Table-1': {
	   *        Keys: [
	   *          {
	   *             HashKey: 'haskey',
	   *             NumberRangeKey: 1
	   *          }
	   *        ]
	   *      },
	   *      'Table-2': {
	   *        Keys: [
	   *          { foo: 'bar' },
	   *        ]
	   *      }
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.batchGet(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  batchGet: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['batchGet'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Puts or deletes multiple items in one or more tables by delegating
	   * to `AWS.DynamoDB.batchWriteItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.batchWriteItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.batchWriteItem
	   * @example Write to and delete from a table
	   *  var params = {
	   *    RequestItems: {
	   *      'Table-1': [
	   *        {
	   *          DeleteRequest: {
	   *            Key: { HashKey: 'someKey' }
	   *          }
	   *        },
	   *        {
	   *          PutRequest: {
	   *            Item: {
	   *              HashKey: 'anotherKey',
	   *              NumAttribute: 1,
	   *              BoolAttribute: true,
	   *              ListAttribute: [1, 'two', false],
	   *              MapAttribute: { foo: 'bar' }
	   *            }
	   *          }
	   *        }
	   *      ]
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.batchWrite(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  batchWrite: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['batchWrite'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Deletes a single item in a table by primary key by delegating to
	   * `AWS.DynamoDB.deleteItem()`
	   *
	   * Supply the same parameters as {AWS.DynamoDB.deleteItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.deleteItem
	   * @example Delete an item from a table
	   *  var params = {
	   *    TableName : 'Table',
	   *    Key: {
	   *      HashKey: 'hashkey',
	   *      NumberRangeKey: 1
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.delete(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  delete: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['delete'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Returns a set of attributes for the item with the given primary key
	   * by delegating to `AWS.DynamoDB.getItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.getItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.getItem
	   * @example Get an item from a table
	   *  var params = {
	   *    TableName : 'Table',
	   *    Key: {
	   *      HashKey: 'hashkey'
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.get(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  get: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['get'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Creates a new item, or replaces an old item with a new item by
	   * delegating to `AWS.DynamoDB.putItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.putItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.putItem
	   * @example Create a new item in a table
	   *  var params = {
	   *    TableName : 'Table',
	   *    Item: {
	   *       HashKey: 'haskey',
	   *       NumAttribute: 1,
	   *       BoolAttribute: true,
	   *       ListAttribute: [1, 'two', false],
	   *       MapAttribute: { foo: 'bar'},
	   *       NullAttribute: null
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.put(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  put: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['put'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Edits an existing item's attributes, or adds a new item to the table if
	   * it does not already exist by delegating to `AWS.DynamoDB.updateItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.updateItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.updateItem
	   * @example Update an item with expressions
	   *  var params = {
	   *    TableName: 'Table',
	   *    Key: { HashKey : 'hashkey' },
	   *    UpdateExpression: 'set #a = :x + :y',
	   *    ConditionExpression: '#a < :MAX',
	   *    ExpressionAttributeNames: {'#a' : 'Sum'},
	   *    ExpressionAttributeValues: {
	   *      ':x' : 20,
	   *      ':y' : 45,
	   *      ':MAX' : 100,
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.update(params, function(err, data) {
	   *     if (err) console.log(err);
	   *     else console.log(data);
	   *  });
	   *
	   */
	  update: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['update'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Returns one or more items and item attributes by accessing every item
	   * in a table or a secondary index.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.scan} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.scan
	   * @example Scan the table with a filter expression
	   *  var params = {
	   *    TableName : 'Table',
	   *    FilterExpression : 'Year = :this_year',
	   *    ExpressionAttributeValues : {':this_year' : 2015}
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.scan(params, function(err, data) {
	   *     if (err) console.log(err);
	   *     else console.log(data);
	   *  });
	   *
	   */
	  scan: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['scan'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	   /**
	    * Directly access items from a table by primary key or a secondary index.
	    *
	    * Supply the same parameters as {AWS.DynamoDB.query} with
	    * `AttributeValue`s substituted by native JavaScript types.
	    *
	    * @see AWS.DynamoDB.query
	    * @example Query an index
	    *  var params = {
	    *    TableName: 'Table',
	    *    IndexName: 'Index',
	    *    KeyConditionExpression: 'HashKey = :hkey and RangeKey > :rkey',
	    *    ExpressionAttributeValues: {
	    *      ':hkey': 'key',
	    *      ':rkey': 2015
	    *    }
	    *  };
	    *
	    *  var documentClient = new AWS.DynamoDB.DocumentClient();
	    *
	    *  documentClient.query(params, function(err, data) {
	    *     if (err) console.log(err);
	    *     else console.log(data);
	    *  });
	    *
	    */
	  query: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['query'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Synchronous write operation that groups up to 25 action requests.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.transactWriteItems} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.transactWriteItems
	   * @example Get items from multiple tables
	   *  var params = {
	   *    TransactItems: [{
	   *      Put: {
	   *        TableName : 'Table0',
	   *        Item: {
	   *          HashKey: 'haskey',
	   *          NumAttribute: 1,
	   *          BoolAttribute: true,
	   *          ListAttribute: [1, 'two', false],
	   *          MapAttribute: { foo: 'bar'},
	   *          NullAttribute: null
	   *        }
	   *      }
	   *    }, {
	   *      Update: {
	   *        TableName: 'Table1',
	   *        Key: { HashKey : 'hashkey' },
	   *        UpdateExpression: 'set #a = :x + :y',
	   *        ConditionExpression: '#a < :MAX',
	   *        ExpressionAttributeNames: {'#a' : 'Sum'},
	   *        ExpressionAttributeValues: {
	   *          ':x' : 20,
	   *          ':y' : 45,
	   *          ':MAX' : 100,
	   *        }
	   *      }
	   *    }]
	   *  };
	   *
	   *  documentClient.transactWrite(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   */
	  transactWrite: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['transactWrite'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Atomically retrieves multiple items from one or more tables (but not from indexes)
	   * in a single account and region.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.transactGetItems} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.transactGetItems
	   * @example Get items from multiple tables
	   *  var params = {
	   *    TransactItems: [{
	   *      Get: {
	   *        TableName : 'Table0',
	   *        Key: {
	   *          HashKey: 'hashkey0'
	   *        }
	   *      }
	   *    }, {
	   *      Get: {
	   *        TableName : 'Table1',
	   *        Key: {
	   *          HashKey: 'hashkey1'
	   *        }
	   *      }
	   *    }]
	   *  };
	   *
	   *  documentClient.transactGet(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   */
	  transactGet: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['transactGet'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Creates a set of elements inferring the type of set from
	   * the type of the first element. Amazon DynamoDB currently supports
	   * the number sets, string sets, and binary sets. For more information
	   * about DynamoDB data types see the documentation on the
	   * [Amazon DynamoDB Data Model](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html#DataModel.DataTypes).
	   *
	   * @param list [Array] Collection to represent your DynamoDB Set
	   * @param options [map]
	   *  * **validate** [Boolean] set to true if you want to validate the type
	   *    of each element in the set. Defaults to `false`.
	   * @example Creating a number set
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  var params = {
	   *    Item: {
	   *      hashkey: 'hashkey'
	   *      numbers: documentClient.createSet([1, 2, 3]);
	   *    }
	   *  };
	   *
	   *  documentClient.put(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  createSet: function(list, options) {
	    options = options || {};
	    return new DynamoDBSet(list, options);
	  },
	
	  /**
	   * @api private
	   */
	  getTranslator: function() {
	    return new Translator(this.options);
	  },
	
	  /**
	   * @api private
	   */
	  setupRequest: function setupRequest(request) {
	    var self = this;
	    var translator = self.getTranslator();
	    var operation = request.operation;
	    var inputShape = request.service.api.operations[operation].input;
	    request._events.validate.unshift(function(req) {
	      req.rawParams = AWS.util.copy(req.params);
	      req.params = translator.translateInput(req.rawParams, inputShape);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  setupResponse: function setupResponse(request) {
	    var self = this;
	    var translator = self.getTranslator();
	    var outputShape = self.service.api.operations[request.operation].output;
	    request.on('extractData', function(response) {
	      response.data = translator.translateOutput(response.data, outputShape);
	    });
	
	    var response = request.response;
	    response.nextPage = function(cb) {
	      var resp = this;
	      var req = resp.request;
	      var config;
	      var service = req.service;
	      var operation = req.operation;
	      try {
	        config = service.paginationConfig(operation, true);
	      } catch (e) { resp.error = e; }
	
	      if (!resp.hasNextPage()) {
	        if (cb) cb(resp.error, null);
	        else if (resp.error) throw resp.error;
	        return null;
	      }
	
	      var params = AWS.util.copy(req.rawParams);
	      if (!resp.nextPageTokens) {
	        return cb ? cb(null, null) : null;
	      } else {
	        var inputTokens = config.inputToken;
	        if (typeof inputTokens === 'string') inputTokens = [inputTokens];
	        for (var i = 0; i < inputTokens.length; i++) {
	          params[inputTokens[i]] = resp.nextPageTokens[i];
	        }
	        return self[operation](params, cb);
	      }
	    };
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.DynamoDB.DocumentClient;
	
	},{"../core":342,"./set":354,"./translator":355}],353:[function(require,module,exports){
	var util = require('../core').util;
	
	/**
	 * An object recognizable as a numeric value that stores the underlying number
	 * as a string.
	 *
	 * Intended to be a deserialization target for the DynamoDB Document Client when
	 * the `wrapNumbers` flag is set. This allows for numeric values that lose
	 * precision when converted to JavaScript's `number` type.
	 */
	var DynamoDBNumberValue = util.inherit({
	  constructor: function NumberValue(value) {
	    this.wrapperName = 'NumberValue';
	    this.value = value.toString();
	  },
	
	  /**
	   * Render the underlying value as a number when converting to JSON.
	   */
	  toJSON: function () {
	    return this.toNumber();
	  },
	
	  /**
	   * Convert the underlying value to a JavaScript number.
	   */
	  toNumber: function () {
	    return Number(this.value);
	  },
	
	  /**
	   * Return a string representing the unaltered value provided to the
	   * constructor.
	   */
	  toString: function () {
	    return this.value;
	  }
	});
	
	/**
	 * @api private
	 */
	module.exports = DynamoDBNumberValue;
	
	},{"../core":342}],354:[function(require,module,exports){
	var util = require('../core').util;
	var typeOf = require('./types').typeOf;
	
	/**
	 * @api private
	 */
	var memberTypeToSetType = {
	  'String': 'String',
	  'Number': 'Number',
	  'NumberValue': 'Number',
	  'Binary': 'Binary'
	};
	
	/**
	 * @api private
	 */
	var DynamoDBSet = util.inherit({
	
	  constructor: function Set(list, options) {
	    options = options || {};
	    this.wrapperName = 'Set';
	    this.initialize(list, options.validate);
	  },
	
	  initialize: function(list, validate) {
	    var self = this;
	    self.values = [].concat(list);
	    self.detectType();
	    if (validate) {
	      self.validate();
	    }
	  },
	
	  detectType: function() {
	    this.type = memberTypeToSetType[typeOf(this.values[0])];
	    if (!this.type) {
	      throw util.error(new Error(), {
	        code: 'InvalidSetType',
	        message: 'Sets can contain string, number, or binary values'
	      });
	    }
	  },
	
	  validate: function() {
	    var self = this;
	    var length = self.values.length;
	    var values = self.values;
	    for (var i = 0; i < length; i++) {
	      if (memberTypeToSetType[typeOf(values[i])] !== self.type) {
	        throw util.error(new Error(), {
	          code: 'InvalidType',
	          message: self.type + ' Set contains ' + typeOf(values[i]) + ' value'
	        });
	      }
	    }
	  },
	
	  /**
	   * Render the underlying values only when converting to JSON.
	   */
	  toJSON: function() {
	    var self = this;
	    return self.values;
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = DynamoDBSet;
	
	},{"../core":342,"./types":356}],355:[function(require,module,exports){
	var util = require('../core').util;
	var convert = require('./converter');
	
	var Translator = function(options) {
	  options = options || {};
	  this.attrValue = options.attrValue;
	  this.convertEmptyValues = Boolean(options.convertEmptyValues);
	  this.wrapNumbers = Boolean(options.wrapNumbers);
	};
	
	Translator.prototype.translateInput = function(value, shape) {
	  this.mode = 'input';
	  return this.translate(value, shape);
	};
	
	Translator.prototype.translateOutput = function(value, shape) {
	  this.mode = 'output';
	  return this.translate(value, shape);
	};
	
	Translator.prototype.translate = function(value, shape) {
	  var self = this;
	  if (!shape || value === undefined) return undefined;
	
	  if (shape.shape === self.attrValue) {
	    return convert[self.mode](value, {
	      convertEmptyValues: self.convertEmptyValues,
	      wrapNumbers: self.wrapNumbers,
	    });
	  }
	  switch (shape.type) {
	    case 'structure': return self.translateStructure(value, shape);
	    case 'map': return self.translateMap(value, shape);
	    case 'list': return self.translateList(value, shape);
	    default: return self.translateScalar(value, shape);
	  }
	};
	
	Translator.prototype.translateStructure = function(structure, shape) {
	  var self = this;
	  if (structure == null) return undefined;
	
	  var struct = {};
	  util.each(structure, function(name, value) {
	    var memberShape = shape.members[name];
	    if (memberShape) {
	      var result = self.translate(value, memberShape);
	      if (result !== undefined) struct[name] = result;
	    }
	  });
	  return struct;
	};
	
	Translator.prototype.translateList = function(list, shape) {
	  var self = this;
	  if (list == null) return undefined;
	
	  var out = [];
	  util.arrayEach(list, function(value) {
	    var result = self.translate(value, shape.member);
	    if (result === undefined) out.push(null);
	    else out.push(result);
	  });
	  return out;
	};
	
	Translator.prototype.translateMap = function(map, shape) {
	  var self = this;
	  if (map == null) return undefined;
	
	  var out = {};
	  util.each(map, function(key, value) {
	    var result = self.translate(value, shape.value);
	    if (result === undefined) out[key] = null;
	    else out[key] = result;
	  });
	  return out;
	};
	
	Translator.prototype.translateScalar = function(value, shape) {
	  return shape.toType(value);
	};
	
	/**
	 * @api private
	 */
	module.exports = Translator;
	
	},{"../core":342,"./converter":351}],356:[function(require,module,exports){
	var util = require('../core').util;
	
	function typeOf(data) {
	  if (data === null && typeof data === 'object') {
	    return 'null';
	  } else if (data !== undefined && isBinary(data)) {
	    return 'Binary';
	  } else if (data !== undefined && data.constructor) {
	    return data.wrapperName || util.typeName(data.constructor);
	  } else if (data !== undefined && typeof data === 'object') {
	    // this object is the result of Object.create(null), hence the absence of a
	    // defined constructor
	    return 'Object';
	  } else {
	    return 'undefined';
	  }
	}
	
	function isBinary(data) {
	  var types = [
	    'Buffer', 'File', 'Blob', 'ArrayBuffer', 'DataView',
	    'Int8Array', 'Uint8Array', 'Uint8ClampedArray',
	    'Int16Array', 'Uint16Array', 'Int32Array', 'Uint32Array',
	    'Float32Array', 'Float64Array'
	  ];
	  if (util.isNode()) {
	    var Stream = util.stream.Stream;
	    if (util.Buffer.isBuffer(data) || data instanceof Stream) {
	      return true;
	    }
	  }
	
	  for (var i = 0; i < types.length; i++) {
	    if (data !== undefined && data.constructor) {
	      if (util.isType(data, types[i])) return true;
	      if (util.typeName(data.constructor) === types[i]) return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  typeOf: typeOf,
	  isBinary: isBinary
	};
	
	},{"../core":342}],357:[function(require,module,exports){
	var eventMessageChunker = require('../event-stream/event-message-chunker').eventMessageChunker;
	var parseEvent = require('./parse-event').parseEvent;
	
	function createEventStream(body, parser, model) {
	    var eventMessages = eventMessageChunker(body);
	
	    var events = [];
	
	    for (var i = 0; i < eventMessages.length; i++) {
	        events.push(parseEvent(parser, eventMessages[i], model));
	    }
	
	    return events;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    createEventStream: createEventStream
	};
	
	},{"../event-stream/event-message-chunker":358,"./parse-event":360}],358:[function(require,module,exports){
	/**
	 * Takes in a buffer of event messages and splits them into individual messages.
	 * @param {Buffer} buffer
	 * @api private
	 */
	function eventMessageChunker(buffer) {
	    /** @type Buffer[] */
	    var messages = [];
	    var offset = 0;
	
	    while (offset < buffer.length) {
	        var totalLength = buffer.readInt32BE(offset);
	
	        // create new buffer for individual message (shares memory with original)
	        var message = buffer.slice(offset, totalLength + offset);
	        // increment offset to it starts at the next message
	        offset += totalLength;
	
	        messages.push(message);
	    }
	
	    return messages;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    eventMessageChunker: eventMessageChunker
	};
	
	},{}],359:[function(require,module,exports){
	var util = require('../core').util;
	var toBuffer = util.buffer.toBuffer;
	
	/**
	 * A lossless representation of a signed, 64-bit integer. Instances of this
	 * class may be used in arithmetic expressions as if they were numeric
	 * primitives, but the binary representation will be preserved unchanged as the
	 * `bytes` property of the object. The bytes should be encoded as big-endian,
	 * two's complement integers.
	 * @param {Buffer} bytes
	 *
	 * @api private
	 */
	function Int64(bytes) {
	    if (bytes.length !== 8) {
	        throw new Error('Int64 buffers must be exactly 8 bytes');
	    }
	    if (!util.Buffer.isBuffer(bytes)) bytes = toBuffer(bytes);
	
	    this.bytes = bytes;
	}
	
	/**
	 * @param {number} number
	 * @returns {Int64}
	 *
	 * @api private
	 */
	Int64.fromNumber = function(number) {
	    if (number > 9223372036854775807 || number < -9223372036854775808) {
	        throw new Error(
	            number + ' is too large (or, if negative, too small) to represent as an Int64'
	        );
	    }
	
	    var bytes = new Uint8Array(8);
	    for (
	        var i = 7, remaining = Math.abs(Math.round(number));
	        i > -1 && remaining > 0;
	        i--, remaining /= 256
	    ) {
	        bytes[i] = remaining;
	    }
	
	    if (number < 0) {
	        negate(bytes);
	    }
	
	    return new Int64(bytes);
	};
	
	/**
	 * @returns {number}
	 *
	 * @api private
	 */
	Int64.prototype.valueOf = function() {
	    var bytes = this.bytes.slice(0);
	    var negative = bytes[0] & 128;
	    if (negative) {
	        negate(bytes);
	    }
	
	    return parseInt(bytes.toString('hex'), 16) * (negative ? -1 : 1);
	};
	
	Int64.prototype.toString = function() {
	    return String(this.valueOf());
	};
	
	/**
	 * @param {Buffer} bytes
	 *
	 * @api private
	 */
	function negate(bytes) {
	    for (var i = 0; i < 8; i++) {
	        bytes[i] ^= 0xFF;
	    }
	    for (var i = 7; i > -1; i--) {
	        bytes[i]++;
	        if (bytes[i] !== 0) {
	            break;
	        }
	    }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    Int64: Int64
	};
	
	},{"../core":342}],360:[function(require,module,exports){
	var parseMessage = require('./parse-message').parseMessage;
	
	/**
	 *
	 * @param {*} parser
	 * @param {Buffer} message
	 * @param {*} shape
	 * @api private
	 */
	function parseEvent(parser, message, shape) {
	    var parsedMessage = parseMessage(message);
	
	    // check if message is an event or error
	    var messageType = parsedMessage.headers[':message-type'];
	    if (messageType) {
	        if (messageType.value === 'error') {
	            throw parseError(parsedMessage);
	        } else if (messageType.value !== 'event') {
	            // not sure how to parse non-events/non-errors, ignore for now
	            return;
	        }
	    }
	
	    // determine event type
	    var eventType = parsedMessage.headers[':event-type'];
	    // check that the event type is modeled
	    var eventModel = shape.members[eventType.value];
	    if (!eventModel) {
	        return;
	    }
	
	    var result = {};
	    // check if an event payload exists
	    var eventPayloadMemberName = eventModel.eventPayloadMemberName;
	    if (eventPayloadMemberName) {
	        var payloadShape = eventModel.members[eventPayloadMemberName];
	        // if the shape is binary, return the byte array
	        if (payloadShape.type === 'binary') {
	            result[eventPayloadMemberName] = parsedMessage.body;
	        } else {
	            result[eventPayloadMemberName] = parser.parse(parsedMessage.body.toString(), payloadShape);
	        }
	    }
	
	    // read event headers
	    var eventHeaderNames = eventModel.eventHeaderMemberNames;
	    for (var i = 0; i < eventHeaderNames.length; i++) {
	        var name = eventHeaderNames[i];
	        if (parsedMessage.headers[name]) {
	            // parse the header!
	            result[name] = eventModel.members[name].toType(parsedMessage.headers[name].value);
	        }
	    }
	
	    var output = {};
	    output[eventType.value] = result;
	    return output;
	}
	
	function parseError(message) {
	    var errorCode = message.headers[':error-code'];
	    var errorMessage = message.headers[':error-message'];
	    var error = new Error(errorMessage.value || errorMessage);
	    error.code = error.name = errorCode.value || errorCode;
	    return error;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    parseEvent: parseEvent
	};
	
	},{"./parse-message":361}],361:[function(require,module,exports){
	var Int64 = require('./int64').Int64;
	
	var splitMessage = require('./split-message').splitMessage;
	
	var BOOLEAN_TAG = 'boolean';
	var BYTE_TAG = 'byte';
	var SHORT_TAG = 'short';
	var INT_TAG = 'integer';
	var LONG_TAG = 'long';
	var BINARY_TAG = 'binary';
	var STRING_TAG = 'string';
	var TIMESTAMP_TAG = 'timestamp';
	var UUID_TAG = 'uuid';
	
	/**
	 * @api private
	 *
	 * @param {Buffer} headers
	 */
	function parseHeaders(headers) {
	    var out = {};
	    var position = 0;
	    while (position < headers.length) {
	        var nameLength = headers.readUInt8(position++);
	        var name = headers.slice(position, position + nameLength).toString();
	        position += nameLength;
	        switch (headers.readUInt8(position++)) {
	            case 0 /* boolTrue */:
	                out[name] = {
	                    type: BOOLEAN_TAG,
	                    value: true
	                };
	                break;
	            case 1 /* boolFalse */:
	                out[name] = {
	                    type: BOOLEAN_TAG,
	                    value: false
	                };
	                break;
	            case 2 /* byte */:
	                out[name] = {
	                    type: BYTE_TAG,
	                    value: headers.readInt8(position++)
	                };
	                break;
	            case 3 /* short */:
	                out[name] = {
	                    type: SHORT_TAG,
	                    value: headers.readInt16BE(position)
	                };
	                position += 2;
	                break;
	            case 4 /* integer */:
	                out[name] = {
	                    type: INT_TAG,
	                    value: headers.readInt32BE(position)
	                };
	                position += 4;
	                break;
	            case 5 /* long */:
	                out[name] = {
	                    type: LONG_TAG,
	                    value: new Int64(headers.slice(position, position + 8))
	                };
	                position += 8;
	                break;
	            case 6 /* byteArray */:
	                var binaryLength = headers.readUInt16BE(position);
	                position += 2;
	                out[name] = {
	                    type: BINARY_TAG,
	                    value: headers.slice(position, position + binaryLength)
	                };
	                position += binaryLength;
	                break;
	            case 7 /* string */:
	                var stringLength = headers.readUInt16BE(position);
	                position += 2;
	                out[name] = {
	                    type: STRING_TAG,
	                    value: headers.slice(
	                        position,
	                        position + stringLength
	                    ).toString()
	                };
	                position += stringLength;
	                break;
	            case 8 /* timestamp */:
	                out[name] = {
	                    type: TIMESTAMP_TAG,
	                    value: new Date(
	                        new Int64(headers.slice(position, position + 8))
	                            .valueOf()
	                    )
	                };
	                position += 8;
	                break;
	            case 9 /* uuid */:
	                var uuidChars = headers.slice(position, position + 16)
	                    .toString('hex');
	                position += 16;
	                out[name] = {
	                    type: UUID_TAG,
	                    value: uuidChars.substr(0, 8) + '-' +
	                        uuidChars.substr(8, 4) + '-' +
	                        uuidChars.substr(12, 4) + '-' +
	                        uuidChars.substr(16, 4) + '-' +
	                        uuidChars.substr(20)
	                };
	                break;
	            default:
	                throw new Error('Unrecognized header type tag');
	        }
	    }
	    return out;
	}
	
	function parseMessage(message) {
	    var parsed = splitMessage(message);
	    return { headers: parseHeaders(parsed.headers), body: parsed.body };
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    parseMessage: parseMessage
	};
	
	},{"./int64":359,"./split-message":362}],362:[function(require,module,exports){
	var util = require('../core').util;
	var toBuffer = util.buffer.toBuffer;
	
	// All prelude components are unsigned, 32-bit integers
	var PRELUDE_MEMBER_LENGTH = 4;
	// The prelude consists of two components
	var PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
	// Checksums are always CRC32 hashes.
	var CHECKSUM_LENGTH = 4;
	// Messages must include a full prelude, a prelude checksum, and a message checksum
	var MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;
	
	/**
	 * @api private
	 *
	 * @param {Buffer} message
	 */
	function splitMessage(message) {
	    if (!util.Buffer.isBuffer(message)) message = toBuffer(message);
	
	    if (message.length < MINIMUM_MESSAGE_LENGTH) {
	        throw new Error('Provided message too short to accommodate event stream message overhead');
	    }
	
	    if (message.length !== message.readUInt32BE(0)) {
	        throw new Error('Reported message length does not match received message length');
	    }
	
	    var expectedPreludeChecksum = message.readUInt32BE(PRELUDE_LENGTH);
	
	    if (
	        expectedPreludeChecksum !== util.crypto.crc32(
	            message.slice(0, PRELUDE_LENGTH)
	        )
	    ) {
	        throw new Error(
	            'The prelude checksum specified in the message (' +
	            expectedPreludeChecksum +
	            ') does not match the calculated CRC32 checksum.'
	        );
	    }
	
	    var expectedMessageChecksum = message.readUInt32BE(message.length - CHECKSUM_LENGTH);
	
	    if (
	        expectedMessageChecksum !== util.crypto.crc32(
	            message.slice(0, message.length - CHECKSUM_LENGTH)
	        )
	    ) {
	        throw new Error(
	            'The message checksum did not match the expected value of ' +
	                expectedMessageChecksum
	        );
	    }
	
	    var headersStart = PRELUDE_LENGTH + CHECKSUM_LENGTH;
	    var headersEnd = headersStart + message.readUInt32BE(PRELUDE_MEMBER_LENGTH);
	
	    return {
	        headers: message.slice(headersStart, headersEnd),
	        body: message.slice(headersEnd, message.length - CHECKSUM_LENGTH),
	    };
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    splitMessage: splitMessage
	};
	
	},{"../core":342}],363:[function(require,module,exports){
	(function (process){(function (){
	var AWS = require('./core');
	var SequentialExecutor = require('./sequential_executor');
	var DISCOVER_ENDPOINT = require('./discover_endpoint').discoverEndpoint;
	/**
	 * The namespace used to register global event listeners for request building
	 * and sending.
	 */
	AWS.EventListeners = {
	  /**
	   * @!attribute VALIDATE_CREDENTIALS
	   *   A request listener that validates whether the request is being
	   *   sent with credentials.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating credentials
	   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
	   *     request.removeListener('validate', listener);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute VALIDATE_REGION
	   *   A request listener that validates whether the region is set
	   *   for a request.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating region configuration
	   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
	   *     request.removeListener('validate', listener);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute VALIDATE_PARAMETERS
	   *   A request listener that validates input parameters in a request.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating parameters
	   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
	   *     request.removeListener('validate', listener);
	   *   @example Disable parameter validation globally
	   *     AWS.EventListeners.Core.removeListener('validate',
	   *       AWS.EventListeners.Core.VALIDATE_REGION);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute SEND
	   *   A request listener that initiates the HTTP connection for a
	   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
	   *   @example Replacing the HTTP handler
	   *     var listener = AWS.EventListeners.Core.SEND;
	   *     request.removeListener('send', listener);
	   *     request.on('send', function(response) {
	   *       customHandler.send(response);
	   *     });
	   *   @return [Function]
	   *   @readonly
	   * @!attribute HTTP_DATA
	   *   A request listener that reads data from the HTTP connection in order
	   *   to build the response data.
	   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
	   *   Remove this handler if you are overriding the 'httpData' event and
	   *   do not want extra data processing and buffering overhead.
	   *   @example Disabling default data processing
	   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
	   *     request.removeListener('httpData', listener);
	   *   @return [Function]
	   *   @readonly
	   */
	  Core: {} /* doc hack */
	};
	
	/**
	 * @api private
	 */
	function getOperationAuthtype(req) {
	  if (!req.service.api.operations) {
	    return '';
	  }
	  var operation = req.service.api.operations[req.operation];
	  return operation ? operation.authtype : '';
	}
	
	AWS.EventListeners = {
	  Core: new SequentialExecutor().addNamedListeners(function(add, addAsync) {
	    addAsync('VALIDATE_CREDENTIALS', 'validate',
	        function VALIDATE_CREDENTIALS(req, done) {
	      if (!req.service.api.signatureVersion && !req.service.config.signatureVersion) return done(); // none
	      req.service.config.getCredentials(function(err) {
	        if (err) {
	          req.response.error = AWS.util.error(err,
	            {code: 'CredentialsError', message: 'Missing credentials in config, if using AWS_CONFIG_FILE, set AWS_SDK_LOAD_CONFIG=1'});
	        }
	        done();
	      });
	    });
	
	    add('VALIDATE_REGION', 'validate', function VALIDATE_REGION(req) {
	      if (!req.service.isGlobalEndpoint) {
	        var dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
	        if (!req.service.config.region) {
	          req.response.error = AWS.util.error(new Error(),
	            {code: 'ConfigError', message: 'Missing region in config'});
	        } else if (!dnsHostRegex.test(req.service.config.region)) {
	          req.response.error = AWS.util.error(new Error(),
	            {code: 'ConfigError', message: 'Invalid region in config'});
	        }
	      }
	    });
	
	    add('BUILD_IDEMPOTENCY_TOKENS', 'validate', function BUILD_IDEMPOTENCY_TOKENS(req) {
	      if (!req.service.api.operations) {
	        return;
	      }
	      var operation = req.service.api.operations[req.operation];
	      if (!operation) {
	        return;
	      }
	      var idempotentMembers = operation.idempotentMembers;
	      if (!idempotentMembers.length) {
	        return;
	      }
	      // creates a copy of params so user's param object isn't mutated
	      var params = AWS.util.copy(req.params);
	      for (var i = 0, iLen = idempotentMembers.length; i < iLen; i++) {
	        if (!params[idempotentMembers[i]]) {
	          // add the member
	          params[idempotentMembers[i]] = AWS.util.uuid.v4();
	        }
	      }
	      req.params = params;
	    });
	
	    add('VALIDATE_PARAMETERS', 'validate', function VALIDATE_PARAMETERS(req) {
	      if (!req.service.api.operations) {
	        return;
	      }
	      var rules = req.service.api.operations[req.operation].input;
	      var validation = req.service.config.paramValidation;
	      new AWS.ParamValidator(validation).validate(rules, req.params);
	    });
	
	    add('COMPUTE_CHECKSUM', 'afterBuild', function COMPUTE_CHECKSUM(req) {
	      if (!req.service.api.operations) {
	        return;
	      }
	      var operation = req.service.api.operations[req.operation];
	      if (!operation) {
	        return;
	      }
	      var body = req.httpRequest.body;
	      var isNonStreamingPayload = body && (AWS.util.Buffer.isBuffer(body) || typeof body === 'string');
	      var headers = req.httpRequest.headers;
	      if (
	        operation.httpChecksumRequired &&
	        req.service.config.computeChecksums &&
	        isNonStreamingPayload &&
	        !headers['Content-MD5']
	      ) {
	        var md5 = AWS.util.crypto.md5(body, 'base64');
	        headers['Content-MD5'] = md5;
	      }
	    });
	
	    addAsync('COMPUTE_SHA256', 'afterBuild', function COMPUTE_SHA256(req, done) {
	      req.haltHandlersOnError();
	      if (!req.service.api.operations) {
	        return;
	      }
	      var operation = req.service.api.operations[req.operation];
	      var authtype = operation ? operation.authtype : '';
	      if (!req.service.api.signatureVersion && !authtype && !req.service.config.signatureVersion) return done(); // none
	      if (req.service.getSignerClass(req) === AWS.Signers.V4) {
	        var body = req.httpRequest.body || '';
	        if (authtype.indexOf('unsigned-body') >= 0) {
	          req.httpRequest.headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
	          return done();
	        }
	        AWS.util.computeSha256(body, function(err, sha) {
	          if (err) {
	            done(err);
	          }
	          else {
	            req.httpRequest.headers['X-Amz-Content-Sha256'] = sha;
	            done();
	          }
	        });
	      } else {
	        done();
	      }
	    });
	
	    add('SET_CONTENT_LENGTH', 'afterBuild', function SET_CONTENT_LENGTH(req) {
	      var authtype = getOperationAuthtype(req);
	      var payloadMember = AWS.util.getRequestPayloadShape(req);
	      if (req.httpRequest.headers['Content-Length'] === undefined) {
	        try {
	          var length = AWS.util.string.byteLength(req.httpRequest.body);
	          req.httpRequest.headers['Content-Length'] = length;
	        } catch (err) {
	          if (payloadMember && payloadMember.isStreaming) {
	            if (payloadMember.requiresLength) {
	              //streaming payload requires length(s3, glacier)
	              throw err;
	            } else if (authtype.indexOf('unsigned-body') >= 0) {
	              //unbounded streaming payload(lex, mediastore)
	              req.httpRequest.headers['Transfer-Encoding'] = 'chunked';
	              return;
	            } else {
	              throw err;
	            }
	          }
	          throw err;
	        }
	      }
	    });
	
	    add('SET_HTTP_HOST', 'afterBuild', function SET_HTTP_HOST(req) {
	      req.httpRequest.headers['Host'] = req.httpRequest.endpoint.host;
	    });
	
	    add('SET_TRACE_ID', 'afterBuild', function SET_TRACE_ID(req) {
	      var traceIdHeaderName = 'X-Amzn-Trace-Id';
	      if (AWS.util.isNode() && !Object.hasOwnProperty.call(req.httpRequest.headers, traceIdHeaderName)) {
	        var ENV_LAMBDA_FUNCTION_NAME = 'AWS_LAMBDA_FUNCTION_NAME';
	        var ENV_TRACE_ID = '_X_AMZN_TRACE_ID';
	        var functionName = process.env[ENV_LAMBDA_FUNCTION_NAME];
	        var traceId = process.env[ENV_TRACE_ID];
	        if (
	          typeof functionName === 'string' &&
	          functionName.length > 0 &&
	          typeof traceId === 'string' &&
	          traceId.length > 0
	        ) {
	          req.httpRequest.headers[traceIdHeaderName] = traceId;
	        }
	      }
	    });
	
	    add('RESTART', 'restart', function RESTART() {
	      var err = this.response.error;
	      if (!err || !err.retryable) return;
	
	      this.httpRequest = new AWS.HttpRequest(
	        this.service.endpoint,
	        this.service.region
	      );
	
	      if (this.response.retryCount < this.service.config.maxRetries) {
	        this.response.retryCount++;
	      } else {
	        this.response.error = null;
	      }
	    });
	
	    var addToHead = true;
	    addAsync('DISCOVER_ENDPOINT', 'sign', DISCOVER_ENDPOINT, addToHead);
	
	    addAsync('SIGN', 'sign', function SIGN(req, done) {
	      var service = req.service;
	      var operations = req.service.api.operations || {};
	      var operation = operations[req.operation];
	      var authtype = operation ? operation.authtype : '';
	      if (!service.api.signatureVersion && !authtype && !service.config.signatureVersion) return done(); // none
	
	      service.config.getCredentials(function (err, credentials) {
	        if (err) {
	          req.response.error = err;
	          return done();
	        }
	
	        try {
	          var date = service.getSkewCorrectedDate();
	          var SignerClass = service.getSignerClass(req);
	          var signer = new SignerClass(req.httpRequest,
	            service.getSigningName(req),
	            {
	              signatureCache: service.config.signatureCache,
	              operation: operation,
	              signatureVersion: service.api.signatureVersion
	            });
	          signer.setServiceClientId(service._clientId);
	
	          // clear old authorization headers
	          delete req.httpRequest.headers['Authorization'];
	          delete req.httpRequest.headers['Date'];
	          delete req.httpRequest.headers['X-Amz-Date'];
	
	          // add new authorization
	          signer.addAuthorization(credentials, date);
	          req.signedAt = date;
	        } catch (e) {
	          req.response.error = e;
	        }
	        done();
	      });
	    });
	
	    add('VALIDATE_RESPONSE', 'validateResponse', function VALIDATE_RESPONSE(resp) {
	      if (this.service.successfulResponse(resp, this)) {
	        resp.data = {};
	        resp.error = null;
	      } else {
	        resp.data = null;
	        resp.error = AWS.util.error(new Error(),
	          {code: 'UnknownError', message: 'An unknown error occurred.'});
	      }
	    });
	
	    addAsync('SEND', 'send', function SEND(resp, done) {
	      resp.httpResponse._abortCallback = done;
	      resp.error = null;
	      resp.data = null;
	
	      function callback(httpResp) {
	        resp.httpResponse.stream = httpResp;
	        var stream = resp.request.httpRequest.stream;
	        var service = resp.request.service;
	        var api = service.api;
	        var operationName = resp.request.operation;
	        var operation = api.operations[operationName] || {};
	
	        httpResp.on('headers', function onHeaders(statusCode, headers, statusMessage) {
	          resp.request.emit(
	            'httpHeaders',
	            [statusCode, headers, resp, statusMessage]
	          );
	
	          if (!resp.httpResponse.streaming) {
	            if (AWS.HttpClient.streamsApiVersion === 2) { // streams2 API check
	              // if we detect event streams, we're going to have to
	              // return the stream immediately
	              if (operation.hasEventOutput && service.successfulResponse(resp)) {
	                // skip reading the IncomingStream
	                resp.request.emit('httpDone');
	                done();
	                return;
	              }
	
	              httpResp.on('readable', function onReadable() {
	                var data = httpResp.read();
	                if (data !== null) {
	                  resp.request.emit('httpData', [data, resp]);
	                }
	              });
	            } else { // legacy streams API
	              httpResp.on('data', function onData(data) {
	                resp.request.emit('httpData', [data, resp]);
	              });
	            }
	          }
	        });
	
	        httpResp.on('end', function onEnd() {
	          if (!stream || !stream.didCallback) {
	            if (AWS.HttpClient.streamsApiVersion === 2 && (operation.hasEventOutput && service.successfulResponse(resp))) {
	              // don't concatenate response chunks when streaming event stream data when response is successful
	              return;
	            }
	            resp.request.emit('httpDone');
	            done();
	          }
	        });
	      }
	
	      function progress(httpResp) {
	        httpResp.on('sendProgress', function onSendProgress(value) {
	          resp.request.emit('httpUploadProgress', [value, resp]);
	        });
	
	        httpResp.on('receiveProgress', function onReceiveProgress(value) {
	          resp.request.emit('httpDownloadProgress', [value, resp]);
	        });
	      }
	
	      function error(err) {
	        if (err.code !== 'RequestAbortedError') {
	          var errCode = err.code === 'TimeoutError' ? err.code : 'NetworkingError';
	          err = AWS.util.error(err, {
	            code: errCode,
	            region: resp.request.httpRequest.region,
	            hostname: resp.request.httpRequest.endpoint.hostname,
	            retryable: true
	          });
	        }
	        resp.error = err;
	        resp.request.emit('httpError', [resp.error, resp], function() {
	          done();
	        });
	      }
	
	      function executeSend() {
	        var http = AWS.HttpClient.getInstance();
	        var httpOptions = resp.request.service.config.httpOptions || {};
	        try {
	          var stream = http.handleRequest(resp.request.httpRequest, httpOptions,
	                                          callback, error);
	          progress(stream);
	        } catch (err) {
	          error(err);
	        }
	      }
	      var timeDiff = (resp.request.service.getSkewCorrectedDate() - this.signedAt) / 1000;
	      if (timeDiff >= 60 * 10) { // if we signed 10min ago, re-sign
	        this.emit('sign', [this], function(err) {
	          if (err) done(err);
	          else executeSend();
	        });
	      } else {
	        executeSend();
	      }
	    });
	
	    add('HTTP_HEADERS', 'httpHeaders',
	        function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
	      resp.httpResponse.statusCode = statusCode;
	      resp.httpResponse.statusMessage = statusMessage;
	      resp.httpResponse.headers = headers;
	      resp.httpResponse.body = AWS.util.buffer.toBuffer('');
	      resp.httpResponse.buffers = [];
	      resp.httpResponse.numBytes = 0;
	      var dateHeader = headers.date || headers.Date;
	      var service = resp.request.service;
	      if (dateHeader) {
	        var serverTime = Date.parse(dateHeader);
	        if (service.config.correctClockSkew
	            && service.isClockSkewed(serverTime)) {
	          service.applyClockOffset(serverTime);
	        }
	      }
	    });
	
	    add('HTTP_DATA', 'httpData', function HTTP_DATA(chunk, resp) {
	      if (chunk) {
	        if (AWS.util.isNode()) {
	          resp.httpResponse.numBytes += chunk.length;
	
	          var total = resp.httpResponse.headers['content-length'];
	          var progress = { loaded: resp.httpResponse.numBytes, total: total };
	          resp.request.emit('httpDownloadProgress', [progress, resp]);
	        }
	
	        resp.httpResponse.buffers.push(AWS.util.buffer.toBuffer(chunk));
	      }
	    });
	
	    add('HTTP_DONE', 'httpDone', function HTTP_DONE(resp) {
	      // convert buffers array into single buffer
	      if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
	        var body = AWS.util.buffer.concat(resp.httpResponse.buffers);
	        resp.httpResponse.body = body;
	      }
	      delete resp.httpResponse.numBytes;
	      delete resp.httpResponse.buffers;
	    });
	
	    add('FINALIZE_ERROR', 'retry', function FINALIZE_ERROR(resp) {
	      if (resp.httpResponse.statusCode) {
	        resp.error.statusCode = resp.httpResponse.statusCode;
	        if (resp.error.retryable === undefined) {
	          resp.error.retryable = this.service.retryableError(resp.error, this);
	        }
	      }
	    });
	
	    add('INVALIDATE_CREDENTIALS', 'retry', function INVALIDATE_CREDENTIALS(resp) {
	      if (!resp.error) return;
	      switch (resp.error.code) {
	        case 'RequestExpired': // EC2 only
	        case 'ExpiredTokenException':
	        case 'ExpiredToken':
	          resp.error.retryable = true;
	          resp.request.service.config.credentials.expired = true;
	      }
	    });
	
	    add('EXPIRED_SIGNATURE', 'retry', function EXPIRED_SIGNATURE(resp) {
	      var err = resp.error;
	      if (!err) return;
	      if (typeof err.code === 'string' && typeof err.message === 'string') {
	        if (err.code.match(/Signature/) && err.message.match(/expired/)) {
	          resp.error.retryable = true;
	        }
	      }
	    });
	
	    add('CLOCK_SKEWED', 'retry', function CLOCK_SKEWED(resp) {
	      if (!resp.error) return;
	      if (this.service.clockSkewError(resp.error)
	          && this.service.config.correctClockSkew) {
	        resp.error.retryable = true;
	      }
	    });
	
	    add('REDIRECT', 'retry', function REDIRECT(resp) {
	      if (resp.error && resp.error.statusCode >= 300 &&
	          resp.error.statusCode < 400 && resp.httpResponse.headers['location']) {
	        this.httpRequest.endpoint =
	          new AWS.Endpoint(resp.httpResponse.headers['location']);
	        this.httpRequest.headers['Host'] = this.httpRequest.endpoint.host;
	        resp.error.redirect = true;
	        resp.error.retryable = true;
	      }
	    });
	
	    add('RETRY_CHECK', 'retry', function RETRY_CHECK(resp) {
	      if (resp.error) {
	        if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
	          resp.error.retryDelay = 0;
	        } else if (resp.retryCount < resp.maxRetries) {
	          resp.error.retryDelay = this.service.retryDelays(resp.retryCount, resp.error) || 0;
	        }
	      }
	    });
	
	    addAsync('RESET_RETRY_STATE', 'afterRetry', function RESET_RETRY_STATE(resp, done) {
	      var delay, willRetry = false;
	
	      if (resp.error) {
	        delay = resp.error.retryDelay || 0;
	        if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
	          resp.retryCount++;
	          willRetry = true;
	        } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
	          resp.redirectCount++;
	          willRetry = true;
	        }
	      }
	
	      // delay < 0 is a signal from customBackoff to skip retries
	      if (willRetry && delay >= 0) {
	        resp.error = null;
	        setTimeout(done, delay);
	      } else {
	        done();
	      }
	    });
	  }),
	
	  CorePost: new SequentialExecutor().addNamedListeners(function(add) {
	    add('EXTRACT_REQUEST_ID', 'extractData', AWS.util.extractRequestId);
	    add('EXTRACT_REQUEST_ID', 'extractError', AWS.util.extractRequestId);
	
	    add('ENOTFOUND_ERROR', 'httpError', function ENOTFOUND_ERROR(err) {
	      function isDNSError(err) {
	        return err.errno === 'ENOTFOUND' ||
	          typeof err.errno === 'number' &&
	          typeof AWS.util.getSystemErrorName === 'function' &&
	          ['EAI_NONAME', 'EAI_NODATA'].indexOf(AWS.util.getSystemErrorName(err.errno) >= 0);
	      }
	      if (err.code === 'NetworkingError' && isDNSError(err)) {
	        var message = 'Inaccessible host: `' + err.hostname + '\' at port `' + err.port +
	          '\'. This service may not be available in the `' + err.region +
	          '\' region.';
	        this.response.error = AWS.util.error(new Error(message), {
	          code: 'UnknownEndpoint',
	          region: err.region,
	          hostname: err.hostname,
	          retryable: true,
	          originalError: err
	        });
	      }
	    });
	  }),
	
	  Logger: new SequentialExecutor().addNamedListeners(function(add) {
	    add('LOG_REQUEST', 'complete', function LOG_REQUEST(resp) {
	      var req = resp.request;
	      var logger = req.service.config.logger;
	      if (!logger) return;
	      function filterSensitiveLog(inputShape, shape) {
	        if (!shape) {
	          return shape;
	        }
	        if (inputShape.isSensitive) {
	          return '***SensitiveInformation***';
	        }
	        switch (inputShape.type) {
	          case 'structure':
	            var struct = {};
	            AWS.util.each(shape, function(subShapeName, subShape) {
	              if (Object.prototype.hasOwnProperty.call(inputShape.members, subShapeName)) {
	                struct[subShapeName] = filterSensitiveLog(inputShape.members[subShapeName], subShape);
	              } else {
	                struct[subShapeName] = subShape;
	              }
	            });
	            return struct;
	          case 'list':
	            var list = [];
	            AWS.util.arrayEach(shape, function(subShape, index) {
	              list.push(filterSensitiveLog(inputShape.member, subShape));
	            });
	            return list;
	          case 'map':
	            var map = {};
	            AWS.util.each(shape, function(key, value) {
	              map[key] = filterSensitiveLog(inputShape.value, value);
	            });
	            return map;
	          default:
	            return shape;
	        }
	      }
	
	      function buildMessage() {
	        var time = resp.request.service.getSkewCorrectedDate().getTime();
	        var delta = (time - req.startTime.getTime()) / 1000;
	        var ansi = logger.isTTY ? true : false;
	        var status = resp.httpResponse.statusCode;
	        var censoredParams = req.params;
	        if (
	          req.service.api.operations &&
	              req.service.api.operations[req.operation] &&
	              req.service.api.operations[req.operation].input
	        ) {
	          var inputShape = req.service.api.operations[req.operation].input;
	          censoredParams = filterSensitiveLog(inputShape, req.params);
	        }
	        var params = require('util').inspect(censoredParams, true, null);
	        var message = '';
	        if (ansi) message += '\x1B[33m';
	        message += '[AWS ' + req.service.serviceIdentifier + ' ' + status;
	        message += ' ' + delta.toString() + 's ' + resp.retryCount + ' retries]';
	        if (ansi) message += '\x1B[0;1m';
	        message += ' ' + AWS.util.string.lowerFirst(req.operation);
	        message += '(' + params + ')';
	        if (ansi) message += '\x1B[0m';
	        return message;
	      }
	
	      var line = buildMessage();
	      if (typeof logger.log === 'function') {
	        logger.log(line);
	      } else if (typeof logger.write === 'function') {
	        logger.write(line + '\n');
	      }
	    });
	  }),
	
	  Json: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = require('./protocol/json');
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  Rest: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = require('./protocol/rest');
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  RestJson: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = require('./protocol/rest_json');
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  RestXml: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = require('./protocol/rest_xml');
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  Query: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = require('./protocol/query');
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  })
	};
	
	}).call(this)}).call(this,require('_process'))
	},{"./core":342,"./discover_endpoint":350,"./protocol/json":377,"./protocol/query":378,"./protocol/rest":379,"./protocol/rest_json":380,"./protocol/rest_xml":381,"./sequential_executor":392,"_process":432,"util":444}],364:[function(require,module,exports){
	var AWS = require('./core');
	var inherit = AWS.util.inherit;
	
	/**
	 * The endpoint that a service will talk to, for example,
	 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
	 * you need to override an endpoint for a service, you can
	 * set the endpoint on a service by passing the endpoint
	 * object with the `endpoint` option key:
	 *
	 * ```javascript
	 * var ep = new AWS.Endpoint('awsproxy.example.com');
	 * var s3 = new AWS.S3({endpoint: ep});
	 * s3.service.endpoint.hostname == 'awsproxy.example.com'
	 * ```
	 *
	 * Note that if you do not specify a protocol, the protocol will
	 * be selected based on your current {AWS.config} configuration.
	 *
	 * @!attribute protocol
	 *   @return [String] the protocol (http or https) of the endpoint
	 *     URL
	 * @!attribute hostname
	 *   @return [String] the host portion of the endpoint, e.g.,
	 *     example.com
	 * @!attribute host
	 *   @return [String] the host portion of the endpoint including
	 *     the port, e.g., example.com:80
	 * @!attribute port
	 *   @return [Integer] the port of the endpoint
	 * @!attribute href
	 *   @return [String] the full URL of the endpoint
	 */
	AWS.Endpoint = inherit({
	
	  /**
	   * @overload Endpoint(endpoint)
	   *   Constructs a new endpoint given an endpoint URL. If the
	   *   URL omits a protocol (http or https), the default protocol
	   *   set in the global {AWS.config} will be used.
	   *   @param endpoint [String] the URL to construct an endpoint from
	   */
	  constructor: function Endpoint(endpoint, config) {
	    AWS.util.hideProperties(this, ['slashes', 'auth', 'hash', 'search', 'query']);
	
	    if (typeof endpoint === 'undefined' || endpoint === null) {
	      throw new Error('Invalid endpoint: ' + endpoint);
	    } else if (typeof endpoint !== 'string') {
	      return AWS.util.copy(endpoint);
	    }
	
	    if (!endpoint.match(/^http/)) {
	      var useSSL = config && config.sslEnabled !== undefined ?
	        config.sslEnabled : AWS.config.sslEnabled;
	      endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
	    }
	
	    AWS.util.update(this, AWS.util.urlParse(endpoint));
	
	    // Ensure the port property is set as an integer
	    if (this.port) {
	      this.port = parseInt(this.port, 10);
	    } else {
	      this.port = this.protocol === 'https:' ? 443 : 80;
	    }
	  }
	
	});
	
	/**
	 * The low level HTTP request object, encapsulating all HTTP header
	 * and body data sent by a service request.
	 *
	 * @!attribute method
	 *   @return [String] the HTTP method of the request
	 * @!attribute path
	 *   @return [String] the path portion of the URI, e.g.,
	 *     "/list/?start=5&num=10"
	 * @!attribute headers
	 *   @return [map<String,String>]
	 *     a map of header keys and their respective values
	 * @!attribute body
	 *   @return [String] the request body payload
	 * @!attribute endpoint
	 *   @return [AWS.Endpoint] the endpoint for the request
	 * @!attribute region
	 *   @api private
	 *   @return [String] the region, for signing purposes only.
	 */
	AWS.HttpRequest = inherit({
	
	  /**
	   * @api private
	   */
	  constructor: function HttpRequest(endpoint, region) {
	    endpoint = new AWS.Endpoint(endpoint);
	    this.method = 'POST';
	    this.path = endpoint.path || '/';
	    this.headers = {};
	    this.body = '';
	    this.endpoint = endpoint;
	    this.region = region;
	    this._userAgent = '';
	    this.setUserAgent();
	  },
	
	  /**
	   * @api private
	   */
	  setUserAgent: function setUserAgent() {
	    this._userAgent = this.headers[this.getUserAgentHeaderName()] = AWS.util.userAgent();
	  },
	
	  getUserAgentHeaderName: function getUserAgentHeaderName() {
	    var prefix = AWS.util.isBrowser() ? 'X-Amz-' : '';
	    return prefix + 'User-Agent';
	  },
	
	  /**
	   * @api private
	   */
	  appendToUserAgent: function appendToUserAgent(agentPartial) {
	    if (typeof agentPartial === 'string' && agentPartial) {
	      this._userAgent += ' ' + agentPartial;
	    }
	    this.headers[this.getUserAgentHeaderName()] = this._userAgent;
	  },
	
	  /**
	   * @api private
	   */
	  getUserAgent: function getUserAgent() {
	    return this._userAgent;
	  },
	
	  /**
	   * @return [String] the part of the {path} excluding the
	   *   query string
	   */
	  pathname: function pathname() {
	    return this.path.split('?', 1)[0];
	  },
	
	  /**
	   * @return [String] the query string portion of the {path}
	   */
	  search: function search() {
	    var query = this.path.split('?', 2)[1];
	    if (query) {
	      query = AWS.util.queryStringParse(query);
	      return AWS.util.queryParamsToString(query);
	    }
	    return '';
	  },
	
	  /**
	   * @api private
	   * update httpRequest endpoint with endpoint string
	   */
	  updateEndpoint: function updateEndpoint(endpointStr) {
	    var newEndpoint = new AWS.Endpoint(endpointStr);
	    this.endpoint = newEndpoint;
	    this.path = newEndpoint.path || '/';
	    if (this.headers['Host']) {
	      this.headers['Host'] = newEndpoint.host;
	    }
	  }
	});
	
	/**
	 * The low level HTTP response object, encapsulating all HTTP header
	 * and body data returned from the request.
	 *
	 * @!attribute statusCode
	 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
	 * @!attribute headers
	 *   @return [map<String,String>]
	 *      a map of response header keys and their respective values
	 * @!attribute body
	 *   @return [String] the response body payload
	 * @!attribute [r] streaming
	 *   @return [Boolean] whether this response is being streamed at a low-level.
	 *     Defaults to `false` (buffered reads). Do not modify this manually, use
	 *     {createUnbufferedStream} to convert the stream to unbuffered mode
	 *     instead.
	 */
	AWS.HttpResponse = inherit({
	
	  /**
	   * @api private
	   */
	  constructor: function HttpResponse() {
	    this.statusCode = undefined;
	    this.headers = {};
	    this.body = undefined;
	    this.streaming = false;
	    this.stream = null;
	  },
	
	  /**
	   * Disables buffering on the HTTP response and returns the stream for reading.
	   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
	   *   Use this object to directly read data off of the stream.
	   * @note This object is only available after the {AWS.Request~httpHeaders}
	   *   event has fired. This method must be called prior to
	   *   {AWS.Request~httpData}.
	   * @example Taking control of a stream
	   *   request.on('httpHeaders', function(statusCode, headers) {
	   *     if (statusCode < 300) {
	   *       if (headers.etag === 'xyz') {
	   *         // pipe the stream, disabling buffering
	   *         var stream = this.response.httpResponse.createUnbufferedStream();
	   *         stream.pipe(process.stdout);
	   *       } else { // abort this request and set a better error message
	   *         this.abort();
	   *         this.response.error = new Error('Invalid ETag');
	   *       }
	   *     }
	   *   }).send(console.log);
	   */
	  createUnbufferedStream: function createUnbufferedStream() {
	    this.streaming = true;
	    return this.stream;
	  }
	});
	
	
	AWS.HttpClient = inherit({});
	
	/**
	 * @api private
	 */
	AWS.HttpClient.getInstance = function getInstance() {
	  if (this.singleton === undefined) {
	    this.singleton = new this();
	  }
	  return this.singleton;
	};
	
	},{"./core":342}],365:[function(require,module,exports){
	var AWS = require('../core');
	var EventEmitter = require('events').EventEmitter;
	require('../http');
	
	/**
	 * @api private
	 */
	AWS.XHRClient = AWS.util.inherit({
	  handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
	    var self = this;
	    var endpoint = httpRequest.endpoint;
	    var emitter = new EventEmitter();
	    var href = endpoint.protocol + '//' + endpoint.hostname;
	    if (endpoint.port !== 80 && endpoint.port !== 443) {
	      href += ':' + endpoint.port;
	    }
	    href += httpRequest.path;
	
	    var xhr = new XMLHttpRequest(), headersEmitted = false;
	    httpRequest.stream = xhr;
	
	    xhr.addEventListener('readystatechange', function() {
	      try {
	        if (xhr.status === 0) return; // 0 code is invalid
	      } catch (e) { return; }
	
	      if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
	        emitter.statusCode = xhr.status;
	        emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
	        emitter.emit(
	          'headers',
	          emitter.statusCode,
	          emitter.headers,
	          xhr.statusText
	        );
	        headersEmitted = true;
	      }
	      if (this.readyState === this.DONE) {
	        self.finishRequest(xhr, emitter);
	      }
	    }, false);
	    xhr.upload.addEventListener('progress', function (evt) {
	      emitter.emit('sendProgress', evt);
	    });
	    xhr.addEventListener('progress', function (evt) {
	      emitter.emit('receiveProgress', evt);
	    }, false);
	    xhr.addEventListener('timeout', function () {
	      errCallback(AWS.util.error(new Error('Timeout'), {code: 'TimeoutError'}));
	    }, false);
	    xhr.addEventListener('error', function () {
	      errCallback(AWS.util.error(new Error('Network Failure'), {
	        code: 'NetworkingError'
	      }));
	    }, false);
	    xhr.addEventListener('abort', function () {
	      errCallback(AWS.util.error(new Error('Request aborted'), {
	        code: 'RequestAbortedError'
	      }));
	    }, false);
	
	    callback(emitter);
	    xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
	    AWS.util.each(httpRequest.headers, function (key, value) {
	      if (key !== 'Content-Length' && key !== 'User-Agent' && key !== 'Host') {
	        xhr.setRequestHeader(key, value);
	      }
	    });
	
	    if (httpOptions.timeout && httpOptions.xhrAsync !== false) {
	      xhr.timeout = httpOptions.timeout;
	    }
	
	    if (httpOptions.xhrWithCredentials) {
	      xhr.withCredentials = true;
	    }
	    try { xhr.responseType = 'arraybuffer'; } catch (e) {}
	
	    try {
	      if (httpRequest.body) {
	        xhr.send(httpRequest.body);
	      } else {
	        xhr.send();
	      }
	    } catch (err) {
	      if (httpRequest.body && typeof httpRequest.body.buffer === 'object') {
	        xhr.send(httpRequest.body.buffer); // send ArrayBuffer directly
	      } else {
	        throw err;
	      }
	    }
	
	    return emitter;
	  },
	
	  parseHeaders: function parseHeaders(rawHeaders) {
	    var headers = {};
	    AWS.util.arrayEach(rawHeaders.split(/\r?\n/), function (line) {
	      var key = line.split(':', 1)[0];
	      var value = line.substring(key.length + 2);
	      if (key.length > 0) headers[key.toLowerCase()] = value;
	    });
	    return headers;
	  },
	
	  finishRequest: function finishRequest(xhr, emitter) {
	    var buffer;
	    if (xhr.responseType === 'arraybuffer' && xhr.response) {
	      var ab = xhr.response;
	      buffer = new AWS.util.Buffer(ab.byteLength);
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < buffer.length; ++i) {
	        buffer[i] = view[i];
	      }
	    }
	
	    try {
	      if (!buffer && typeof xhr.responseText === 'string') {
	        buffer = new AWS.util.Buffer(xhr.responseText);
	      }
	    } catch (e) {}
	
	    if (buffer) emitter.emit('data', buffer);
	    emitter.emit('end');
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.HttpClient.prototype = AWS.XHRClient.prototype;
	
	/**
	 * @api private
	 */
	AWS.HttpClient.streamsApiVersion = 1;
	
	},{"../core":342,"../http":364,"events":428}],366:[function(require,module,exports){
	var util = require('../util');
	
	function JsonBuilder() { }
	
	JsonBuilder.prototype.build = function(value, shape) {
	  return JSON.stringify(translate(value, shape));
	};
	
	function translate(value, shape) {
	  if (!shape || value === undefined || value === null) return undefined;
	
	  switch (shape.type) {
	    case 'structure': return translateStructure(value, shape);
	    case 'map': return translateMap(value, shape);
	    case 'list': return translateList(value, shape);
	    default: return translateScalar(value, shape);
	  }
	}
	
	function translateStructure(structure, shape) {
	  if (shape.isDocument) {
	    return structure;
	  }
	  var struct = {};
	  util.each(structure, function(name, value) {
	    var memberShape = shape.members[name];
	    if (memberShape) {
	      if (memberShape.location !== 'body') return;
	      var locationName = memberShape.isLocationName ? memberShape.name : name;
	      var result = translate(value, memberShape);
	      if (result !== undefined) struct[locationName] = result;
	    }
	  });
	  return struct;
	}
	
	function translateList(list, shape) {
	  var out = [];
	  util.arrayEach(list, function(value) {
	    var result = translate(value, shape.member);
	    if (result !== undefined) out.push(result);
	  });
	  return out;
	}
	
	function translateMap(map, shape) {
	  var out = {};
	  util.each(map, function(key, value) {
	    var result = translate(value, shape.value);
	    if (result !== undefined) out[key] = result;
	  });
	  return out;
	}
	
	function translateScalar(value, shape) {
	  return shape.toWireFormat(value);
	}
	
	/**
	 * @api private
	 */
	module.exports = JsonBuilder;
	
	},{"../util":418}],367:[function(require,module,exports){
	var util = require('../util');
	
	function JsonParser() { }
	
	JsonParser.prototype.parse = function(value, shape) {
	  return translate(JSON.parse(value), shape);
	};
	
	function translate(value, shape) {
	  if (!shape || value === undefined) return undefined;
	
	  switch (shape.type) {
	    case 'structure': return translateStructure(value, shape);
	    case 'map': return translateMap(value, shape);
	    case 'list': return translateList(value, shape);
	    default: return translateScalar(value, shape);
	  }
	}
	
	function translateStructure(structure, shape) {
	  if (structure == null) return undefined;
	  if (shape.isDocument) return structure;
	
	  var struct = {};
	  var shapeMembers = shape.members;
	  util.each(shapeMembers, function(name, memberShape) {
	    var locationName = memberShape.isLocationName ? memberShape.name : name;
	    if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
	      var value = structure[locationName];
	      var result = translate(value, memberShape);
	      if (result !== undefined) struct[name] = result;
	    }
	  });
	  return struct;
	}
	
	function translateList(list, shape) {
	  if (list == null) return undefined;
	
	  var out = [];
	  util.arrayEach(list, function(value) {
	    var result = translate(value, shape.member);
	    if (result === undefined) out.push(null);
	    else out.push(result);
	  });
	  return out;
	}
	
	function translateMap(map, shape) {
	  if (map == null) return undefined;
	
	  var out = {};
	  util.each(map, function(key, value) {
	    var result = translate(value, shape.value);
	    if (result === undefined) out[key] = null;
	    else out[key] = result;
	  });
	  return out;
	}
	
	function translateScalar(value, shape) {
	  return shape.toType(value);
	}
	
	/**
	 * @api private
	 */
	module.exports = JsonParser;
	
	},{"../util":418}],368:[function(require,module,exports){
	var Collection = require('./collection');
	var Operation = require('./operation');
	var Shape = require('./shape');
	var Paginator = require('./paginator');
	var ResourceWaiter = require('./resource_waiter');
	var metadata = require('../../apis/metadata.json');
	
	var util = require('../util');
	var property = util.property;
	var memoizedProperty = util.memoizedProperty;
	
	function Api(api, options) {
	  var self = this;
	  api = api || {};
	  options = options || {};
	  options.api = this;
	
	  api.metadata = api.metadata || {};
	
	  var serviceIdentifier = options.serviceIdentifier;
	  delete options.serviceIdentifier;
	
	  property(this, 'isApi', true, false);
	  property(this, 'apiVersion', api.metadata.apiVersion);
	  property(this, 'endpointPrefix', api.metadata.endpointPrefix);
	  property(this, 'signingName', api.metadata.signingName);
	  property(this, 'globalEndpoint', api.metadata.globalEndpoint);
	  property(this, 'signatureVersion', api.metadata.signatureVersion);
	  property(this, 'jsonVersion', api.metadata.jsonVersion);
	  property(this, 'targetPrefix', api.metadata.targetPrefix);
	  property(this, 'protocol', api.metadata.protocol);
	  property(this, 'timestampFormat', api.metadata.timestampFormat);
	  property(this, 'xmlNamespaceUri', api.metadata.xmlNamespace);
	  property(this, 'abbreviation', api.metadata.serviceAbbreviation);
	  property(this, 'fullName', api.metadata.serviceFullName);
	  property(this, 'serviceId', api.metadata.serviceId);
	  if (serviceIdentifier && metadata[serviceIdentifier]) {
	      property(this, 'xmlNoDefaultLists', metadata[serviceIdentifier].xmlNoDefaultLists, false);
	  }
	
	  memoizedProperty(this, 'className', function() {
	    var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
	    if (!name) return null;
	
	    name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, '');
	    if (name === 'ElasticLoadBalancing') name = 'ELB';
	    return name;
	  });
	
	  function addEndpointOperation(name, operation) {
	    if (operation.endpointoperation === true) {
	      property(self, 'endpointOperation', util.string.lowerFirst(name));
	    }
	    if (operation.endpointdiscovery && !self.hasRequiredEndpointDiscovery) {
	      property(
	        self,
	        'hasRequiredEndpointDiscovery',
	        operation.endpointdiscovery.required === true
	      );
	    }
	  }
	
	  property(this, 'operations', new Collection(api.operations, options, function(name, operation) {
	    return new Operation(name, operation, options);
	  }, util.string.lowerFirst, addEndpointOperation));
	
	  property(this, 'shapes', new Collection(api.shapes, options, function(name, shape) {
	    return Shape.create(shape, options);
	  }));
	
	  property(this, 'paginators', new Collection(api.paginators, options, function(name, paginator) {
	    return new Paginator(name, paginator, options);
	  }));
	
	  property(this, 'waiters', new Collection(api.waiters, options, function(name, waiter) {
	    return new ResourceWaiter(name, waiter, options);
	  }, util.string.lowerFirst));
	
	  if (options.documentation) {
	    property(this, 'documentation', api.documentation);
	    property(this, 'documentationUrl', api.documentationUrl);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = Api;
	
	},{"../../apis/metadata.json":163,"../util":418,"./collection":369,"./operation":370,"./paginator":371,"./resource_waiter":372,"./shape":373}],369:[function(require,module,exports){
	var memoizedProperty = require('../util').memoizedProperty;
	
	function memoize(name, value, factory, nameTr) {
	  memoizedProperty(this, nameTr(name), function() {
	    return factory(name, value);
	  });
	}
	
	function Collection(iterable, options, factory, nameTr, callback) {
	  nameTr = nameTr || String;
	  var self = this;
	
	  for (var id in iterable) {
	    if (Object.prototype.hasOwnProperty.call(iterable, id)) {
	      memoize.call(self, id, iterable[id], factory, nameTr);
	      if (callback) callback(id, iterable[id]);
	    }
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = Collection;
	
	},{"../util":418}],370:[function(require,module,exports){
	var Shape = require('./shape');
	
	var util = require('../util');
	var property = util.property;
	var memoizedProperty = util.memoizedProperty;
	
	function Operation(name, operation, options) {
	  var self = this;
	  options = options || {};
	
	  property(this, 'name', operation.name || name);
	  property(this, 'api', options.api, false);
	
	  operation.http = operation.http || {};
	  property(this, 'endpoint', operation.endpoint);
	  property(this, 'httpMethod', operation.http.method || 'POST');
	  property(this, 'httpPath', operation.http.requestUri || '/');
	  property(this, 'authtype', operation.authtype || '');
	  property(
	    this,
	    'endpointDiscoveryRequired',
	    operation.endpointdiscovery ?
	      (operation.endpointdiscovery.required ? 'REQUIRED' : 'OPTIONAL') :
	    'NULL'
	  );
	
	  // httpChecksum replaces usage of httpChecksumRequired, but some APIs
	  // (s3control) still uses old trait.
	  var httpChecksumRequired = operation.httpChecksumRequired
	    || (operation.httpChecksum && operation.httpChecksum.requestChecksumRequired);
	  property(this, 'httpChecksumRequired', httpChecksumRequired, false);
	
	  memoizedProperty(this, 'input', function() {
	    if (!operation.input) {
	      return new Shape.create({type: 'structure'}, options);
	    }
	    return Shape.create(operation.input, options);
	  });
	
	  memoizedProperty(this, 'output', function() {
	    if (!operation.output) {
	      return new Shape.create({type: 'structure'}, options);
	    }
	    return Shape.create(operation.output, options);
	  });
	
	  memoizedProperty(this, 'errors', function() {
	    var list = [];
	    if (!operation.errors) return null;
	
	    for (var i = 0; i < operation.errors.length; i++) {
	      list.push(Shape.create(operation.errors[i], options));
	    }
	
	    return list;
	  });
	
	  memoizedProperty(this, 'paginator', function() {
	    return options.api.paginators[name];
	  });
	
	  if (options.documentation) {
	    property(this, 'documentation', operation.documentation);
	    property(this, 'documentationUrl', operation.documentationUrl);
	  }
	
	  // idempotentMembers only tracks top-level input shapes
	  memoizedProperty(this, 'idempotentMembers', function() {
	    var idempotentMembers = [];
	    var input = self.input;
	    var members = input.members;
	    if (!input.members) {
	      return idempotentMembers;
	    }
	    for (var name in members) {
	      if (!members.hasOwnProperty(name)) {
	        continue;
	      }
	      if (members[name].isIdempotent === true) {
	        idempotentMembers.push(name);
	      }
	    }
	    return idempotentMembers;
	  });
	
	  memoizedProperty(this, 'hasEventOutput', function() {
	    var output = self.output;
	    return hasEventStream(output);
	  });
	}
	
	function hasEventStream(topLevelShape) {
	  var members = topLevelShape.members;
	  var payload = topLevelShape.payload;
	
	  if (!topLevelShape.members) {
	    return false;
	  }
	
	  if (payload) {
	    var payloadMember = members[payload];
	    return payloadMember.isEventStream;
	  }
	
	  // check if any member is an event stream
	  for (var name in members) {
	    if (!members.hasOwnProperty(name)) {
	      if (members[name].isEventStream === true) {
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	/**
	 * @api private
	 */
	module.exports = Operation;
	
	},{"../util":418,"./shape":373}],371:[function(require,module,exports){
	var property = require('../util').property;
	
	function Paginator(name, paginator) {
	  property(this, 'inputToken', paginator.input_token);
	  property(this, 'limitKey', paginator.limit_key);
	  property(this, 'moreResults', paginator.more_results);
	  property(this, 'outputToken', paginator.output_token);
	  property(this, 'resultKey', paginator.result_key);
	}
	
	/**
	 * @api private
	 */
	module.exports = Paginator;
	
	},{"../util":418}],372:[function(require,module,exports){
	var util = require('../util');
	var property = util.property;
	
	function ResourceWaiter(name, waiter, options) {
	  options = options || {};
	  property(this, 'name', name);
	  property(this, 'api', options.api, false);
	
	  if (waiter.operation) {
	    property(this, 'operation', util.string.lowerFirst(waiter.operation));
	  }
	
	  var self = this;
	  var keys = [
	    'type',
	    'description',
	    'delay',
	    'maxAttempts',
	    'acceptors'
	  ];
	
	  keys.forEach(function(key) {
	    var value = waiter[key];
	    if (value) {
	      property(self, key, value);
	    }
	  });
	}
	
	/**
	 * @api private
	 */
	module.exports = ResourceWaiter;
	
	},{"../util":418}],373:[function(require,module,exports){
	var Collection = require('./collection');
	
	var util = require('../util');
	
	function property(obj, name, value) {
	  if (value !== null && value !== undefined) {
	    util.property.apply(this, arguments);
	  }
	}
	
	function memoizedProperty(obj, name) {
	  if (!obj.constructor.prototype[name]) {
	    util.memoizedProperty.apply(this, arguments);
	  }
	}
	
	function Shape(shape, options, memberName) {
	  options = options || {};
	
	  property(this, 'shape', shape.shape);
	  property(this, 'api', options.api, false);
	  property(this, 'type', shape.type);
	  property(this, 'enum', shape.enum);
	  property(this, 'min', shape.min);
	  property(this, 'max', shape.max);
	  property(this, 'pattern', shape.pattern);
	  property(this, 'location', shape.location || this.location || 'body');
	  property(this, 'name', this.name || shape.xmlName || shape.queryName ||
	    shape.locationName || memberName);
	  property(this, 'isStreaming', shape.streaming || this.isStreaming || false);
	  property(this, 'requiresLength', shape.requiresLength, false);
	  property(this, 'isComposite', shape.isComposite || false);
	  property(this, 'isShape', true, false);
	  property(this, 'isQueryName', Boolean(shape.queryName), false);
	  property(this, 'isLocationName', Boolean(shape.locationName), false);
	  property(this, 'isIdempotent', shape.idempotencyToken === true);
	  property(this, 'isJsonValue', shape.jsonvalue === true);
	  property(this, 'isSensitive', shape.sensitive === true || shape.prototype && shape.prototype.sensitive === true);
	  property(this, 'isEventStream', Boolean(shape.eventstream), false);
	  property(this, 'isEvent', Boolean(shape.event), false);
	  property(this, 'isEventPayload', Boolean(shape.eventpayload), false);
	  property(this, 'isEventHeader', Boolean(shape.eventheader), false);
	  property(this, 'isTimestampFormatSet', Boolean(shape.timestampFormat) || shape.prototype && shape.prototype.isTimestampFormatSet === true, false);
	  property(this, 'endpointDiscoveryId', Boolean(shape.endpointdiscoveryid), false);
	  property(this, 'hostLabel', Boolean(shape.hostLabel), false);
	
	  if (options.documentation) {
	    property(this, 'documentation', shape.documentation);
	    property(this, 'documentationUrl', shape.documentationUrl);
	  }
	
	  if (shape.xmlAttribute) {
	    property(this, 'isXmlAttribute', shape.xmlAttribute || false);
	  }
	
	  // type conversion and parsing
	  property(this, 'defaultValue', null);
	  this.toWireFormat = function(value) {
	    if (value === null || value === undefined) return '';
	    return value;
	  };
	  this.toType = function(value) { return value; };
	}
	
	/**
	 * @api private
	 */
	Shape.normalizedTypes = {
	  character: 'string',
	  double: 'float',
	  long: 'integer',
	  short: 'integer',
	  biginteger: 'integer',
	  bigdecimal: 'float',
	  blob: 'binary'
	};
	
	/**
	 * @api private
	 */
	Shape.types = {
	  'structure': StructureShape,
	  'list': ListShape,
	  'map': MapShape,
	  'boolean': BooleanShape,
	  'timestamp': TimestampShape,
	  'float': FloatShape,
	  'integer': IntegerShape,
	  'string': StringShape,
	  'base64': Base64Shape,
	  'binary': BinaryShape
	};
	
	Shape.resolve = function resolve(shape, options) {
	  if (shape.shape) {
	    var refShape = options.api.shapes[shape.shape];
	    if (!refShape) {
	      throw new Error('Cannot find shape reference: ' + shape.shape);
	    }
	
	    return refShape;
	  } else {
	    return null;
	  }
	};
	
	Shape.create = function create(shape, options, memberName) {
	  if (shape.isShape) return shape;
	
	  var refShape = Shape.resolve(shape, options);
	  if (refShape) {
	    var filteredKeys = Object.keys(shape);
	    if (!options.documentation) {
	      filteredKeys = filteredKeys.filter(function(name) {
	        return !name.match(/documentation/);
	      });
	    }
	
	    // create an inline shape with extra members
	    var InlineShape = function() {
	      refShape.constructor.call(this, shape, options, memberName);
	    };
	    InlineShape.prototype = refShape;
	    return new InlineShape();
	  } else {
	    // set type if not set
	    if (!shape.type) {
	      if (shape.members) shape.type = 'structure';
	      else if (shape.member) shape.type = 'list';
	      else if (shape.key) shape.type = 'map';
	      else shape.type = 'string';
	    }
	
	    // normalize types
	    var origType = shape.type;
	    if (Shape.normalizedTypes[shape.type]) {
	      shape.type = Shape.normalizedTypes[shape.type];
	    }
	
	    if (Shape.types[shape.type]) {
	      return new Shape.types[shape.type](shape, options, memberName);
	    } else {
	      throw new Error('Unrecognized shape type: ' + origType);
	    }
	  }
	};
	
	function CompositeShape(shape) {
	  Shape.apply(this, arguments);
	  property(this, 'isComposite', true);
	
	  if (shape.flattened) {
	    property(this, 'flattened', shape.flattened || false);
	  }
	}
	
	function StructureShape(shape, options) {
	  var self = this;
	  var requiredMap = null, firstInit = !this.isShape;
	
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return {}; });
	    property(this, 'members', {});
	    property(this, 'memberNames', []);
	    property(this, 'required', []);
	    property(this, 'isRequired', function() { return false; });
	    property(this, 'isDocument', Boolean(shape.document));
	  }
	
	  if (shape.members) {
	    property(this, 'members', new Collection(shape.members, options, function(name, member) {
	      return Shape.create(member, options, name);
	    }));
	    memoizedProperty(this, 'memberNames', function() {
	      return shape.xmlOrder || Object.keys(shape.members);
	    });
	
	    if (shape.event) {
	      memoizedProperty(this, 'eventPayloadMemberName', function() {
	        var members = self.members;
	        var memberNames = self.memberNames;
	        // iterate over members to find ones that are event payloads
	        for (var i = 0, iLen = memberNames.length; i < iLen; i++) {
	          if (members[memberNames[i]].isEventPayload) {
	            return memberNames[i];
	          }
	        }
	      });
	
	      memoizedProperty(this, 'eventHeaderMemberNames', function() {
	        var members = self.members;
	        var memberNames = self.memberNames;
	        var eventHeaderMemberNames = [];
	        // iterate over members to find ones that are event headers
	        for (var i = 0, iLen = memberNames.length; i < iLen; i++) {
	          if (members[memberNames[i]].isEventHeader) {
	            eventHeaderMemberNames.push(memberNames[i]);
	          }
	        }
	        return eventHeaderMemberNames;
	      });
	    }
	  }
	
	  if (shape.required) {
	    property(this, 'required', shape.required);
	    property(this, 'isRequired', function(name) {
	      if (!requiredMap) {
	        requiredMap = {};
	        for (var i = 0; i < shape.required.length; i++) {
	          requiredMap[shape.required[i]] = true;
	        }
	      }
	
	      return requiredMap[name];
	    }, false, true);
	  }
	
	  property(this, 'resultWrapper', shape.resultWrapper || null);
	
	  if (shape.payload) {
	    property(this, 'payload', shape.payload);
	  }
	
	  if (typeof shape.xmlNamespace === 'string') {
	    property(this, 'xmlNamespaceUri', shape.xmlNamespace);
	  } else if (typeof shape.xmlNamespace === 'object') {
	    property(this, 'xmlNamespacePrefix', shape.xmlNamespace.prefix);
	    property(this, 'xmlNamespaceUri', shape.xmlNamespace.uri);
	  }
	}
	
	function ListShape(shape, options) {
	  var self = this, firstInit = !this.isShape;
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return []; });
	  }
	
	  if (shape.member) {
	    memoizedProperty(this, 'member', function() {
	      return Shape.create(shape.member, options);
	    });
	  }
	
	  if (this.flattened) {
	    var oldName = this.name;
	    memoizedProperty(this, 'name', function() {
	      return self.member.name || oldName;
	    });
	  }
	}
	
	function MapShape(shape, options) {
	  var firstInit = !this.isShape;
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return {}; });
	    property(this, 'key', Shape.create({type: 'string'}, options));
	    property(this, 'value', Shape.create({type: 'string'}, options));
	  }
	
	  if (shape.key) {
	    memoizedProperty(this, 'key', function() {
	      return Shape.create(shape.key, options);
	    });
	  }
	  if (shape.value) {
	    memoizedProperty(this, 'value', function() {
	      return Shape.create(shape.value, options);
	    });
	  }
	}
	
	function TimestampShape(shape) {
	  var self = this;
	  Shape.apply(this, arguments);
	
	  if (shape.timestampFormat) {
	    property(this, 'timestampFormat', shape.timestampFormat);
	  } else if (self.isTimestampFormatSet && this.timestampFormat) {
	    property(this, 'timestampFormat', this.timestampFormat);
	  } else if (this.location === 'header') {
	    property(this, 'timestampFormat', 'rfc822');
	  } else if (this.location === 'querystring') {
	    property(this, 'timestampFormat', 'iso8601');
	  } else if (this.api) {
	    switch (this.api.protocol) {
	      case 'json':
	      case 'rest-json':
	        property(this, 'timestampFormat', 'unixTimestamp');
	        break;
	      case 'rest-xml':
	      case 'query':
	      case 'ec2':
	        property(this, 'timestampFormat', 'iso8601');
	        break;
	    }
	  }
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    if (typeof value.toUTCString === 'function') return value;
	    return typeof value === 'string' || typeof value === 'number' ?
	           util.date.parseTimestamp(value) : null;
	  };
	
	  this.toWireFormat = function(value) {
	    return util.date.format(value, self.timestampFormat);
	  };
	}
	
	function StringShape() {
	  Shape.apply(this, arguments);
	
	  var nullLessProtocols = ['rest-xml', 'query', 'ec2'];
	  this.toType = function(value) {
	    value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ?
	      value || '' : value;
	    if (this.isJsonValue) {
	      return JSON.parse(value);
	    }
	
	    return value && typeof value.toString === 'function' ?
	      value.toString() : value;
	  };
	
	  this.toWireFormat = function(value) {
	    return this.isJsonValue ? JSON.stringify(value) : value;
	  };
	}
	
	function FloatShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    return parseFloat(value);
	  };
	  this.toWireFormat = this.toType;
	}
	
	function IntegerShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    return parseInt(value, 10);
	  };
	  this.toWireFormat = this.toType;
	}
	
	function BinaryShape() {
	  Shape.apply(this, arguments);
	  this.toType = function(value) {
	    var buf = util.base64.decode(value);
	    if (this.isSensitive && util.isNode() && typeof util.Buffer.alloc === 'function') {
	  /* Node.js can create a Buffer that is not isolated.
	   * i.e. buf.byteLength !== buf.buffer.byteLength
	   * This means that the sensitive data is accessible to anyone with access to buf.buffer.
	   * If this is the node shared Buffer, then other code within this process _could_ find this secret.
	   * Copy sensitive data to an isolated Buffer and zero the sensitive data.
	   * While this is safe to do here, copying this code somewhere else may produce unexpected results.
	   */
	      var secureBuf = util.Buffer.alloc(buf.length, buf);
	      buf.fill(0);
	      buf = secureBuf;
	    }
	    return buf;
	  };
	  this.toWireFormat = util.base64.encode;
	}
	
	function Base64Shape() {
	  BinaryShape.apply(this, arguments);
	}
	
	function BooleanShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (typeof value === 'boolean') return value;
	    if (value === null || value === undefined) return null;
	    return value === 'true';
	  };
	}
	
	/**
	 * @api private
	 */
	Shape.shapes = {
	  StructureShape: StructureShape,
	  ListShape: ListShape,
	  MapShape: MapShape,
	  StringShape: StringShape,
	  BooleanShape: BooleanShape,
	  Base64Shape: Base64Shape
	};
	
	/**
	 * @api private
	 */
	module.exports = Shape;
	
	},{"../util":418,"./collection":369}],374:[function(require,module,exports){
	var AWS = require('./core');
	
	/**
	 * @api private
	 */
	AWS.ParamValidator = AWS.util.inherit({
	  /**
	   * Create a new validator object.
	   *
	   * @param validation [Boolean|map] whether input parameters should be
	   *     validated against the operation description before sending the
	   *     request. Pass a map to enable any of the following specific
	   *     validation features:
	   *
	   *     * **min** [Boolean] &mdash; Validates that a value meets the min
	   *       constraint. This is enabled by default when paramValidation is set
	   *       to `true`.
	   *     * **max** [Boolean] &mdash; Validates that a value meets the max
	   *       constraint.
	   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
	   *       regular expression.
	   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
	   *       of the allowable enum values.
	   */
	  constructor: function ParamValidator(validation) {
	    if (validation === true || validation === undefined) {
	      validation = {'min': true};
	    }
	    this.validation = validation;
	  },
	
	  validate: function validate(shape, params, context) {
	    this.errors = [];
	    this.validateMember(shape, params || {}, context || 'params');
	
	    if (this.errors.length > 1) {
	      var msg = this.errors.join('\n* ');
	      msg = 'There were ' + this.errors.length +
	        ' validation errors:\n* ' + msg;
	      throw AWS.util.error(new Error(msg),
	        {code: 'MultipleValidationErrors', errors: this.errors});
	    } else if (this.errors.length === 1) {
	      throw this.errors[0];
	    } else {
	      return true;
	    }
	  },
	
	  fail: function fail(code, message) {
	    this.errors.push(AWS.util.error(new Error(message), {code: code}));
	  },
	
	  validateStructure: function validateStructure(shape, params, context) {
	    if (shape.isDocument) return true;
	
	    this.validateType(params, context, ['object'], 'structure');
	    var paramName;
	    for (var i = 0; shape.required && i < shape.required.length; i++) {
	      paramName = shape.required[i];
	      var value = params[paramName];
	      if (value === undefined || value === null) {
	        this.fail('MissingRequiredParameter',
	          'Missing required key \'' + paramName + '\' in ' + context);
	      }
	    }
	
	    // validate hash members
	    for (paramName in params) {
	      if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;
	
	      var paramValue = params[paramName],
	          memberShape = shape.members[paramName];
	
	      if (memberShape !== undefined) {
	        var memberContext = [context, paramName].join('.');
	        this.validateMember(memberShape, paramValue, memberContext);
	      } else if (paramValue !== undefined && paramValue !== null) {
	        this.fail('UnexpectedParameter',
	          'Unexpected key \'' + paramName + '\' found in ' + context);
	      }
	    }
	
	    return true;
	  },
	
	  validateMember: function validateMember(shape, param, context) {
	    switch (shape.type) {
	      case 'structure':
	        return this.validateStructure(shape, param, context);
	      case 'list':
	        return this.validateList(shape, param, context);
	      case 'map':
	        return this.validateMap(shape, param, context);
	      default:
	        return this.validateScalar(shape, param, context);
	    }
	  },
	
	  validateList: function validateList(shape, params, context) {
	    if (this.validateType(params, context, [Array])) {
	      this.validateRange(shape, params.length, context, 'list member count');
	      // validate array members
	      for (var i = 0; i < params.length; i++) {
	        this.validateMember(shape.member, params[i], context + '[' + i + ']');
	      }
	    }
	  },
	
	  validateMap: function validateMap(shape, params, context) {
	    if (this.validateType(params, context, ['object'], 'map')) {
	      // Build up a count of map members to validate range traits.
	      var mapCount = 0;
	      for (var param in params) {
	        if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
	        // Validate any map key trait constraints
	        this.validateMember(shape.key, param,
	                            context + '[key=\'' + param + '\']');
	        this.validateMember(shape.value, params[param],
	                            context + '[\'' + param + '\']');
	        mapCount++;
	      }
	      this.validateRange(shape, mapCount, context, 'map member count');
	    }
	  },
	
	  validateScalar: function validateScalar(shape, value, context) {
	    switch (shape.type) {
	      case null:
	      case undefined:
	      case 'string':
	        return this.validateString(shape, value, context);
	      case 'base64':
	      case 'binary':
	        return this.validatePayload(value, context);
	      case 'integer':
	      case 'float':
	        return this.validateNumber(shape, value, context);
	      case 'boolean':
	        return this.validateType(value, context, ['boolean']);
	      case 'timestamp':
	        return this.validateType(value, context, [Date,
	          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, 'number'],
	          'Date object, ISO-8601 string, or a UNIX timestamp');
	      default:
	        return this.fail('UnkownType', 'Unhandled type ' +
	                         shape.type + ' for ' + context);
	    }
	  },
	
	  validateString: function validateString(shape, value, context) {
	    var validTypes = ['string'];
	    if (shape.isJsonValue) {
	      validTypes = validTypes.concat(['number', 'object', 'boolean']);
	    }
	    if (value !== null && this.validateType(value, context, validTypes)) {
	      this.validateEnum(shape, value, context);
	      this.validateRange(shape, value.length, context, 'string length');
	      this.validatePattern(shape, value, context);
	      this.validateUri(shape, value, context);
	    }
	  },
	
	  validateUri: function validateUri(shape, value, context) {
	    if (shape['location'] === 'uri') {
	      if (value.length === 0) {
	        this.fail('UriParameterError', 'Expected uri parameter to have length >= 1,'
	          + ' but found "' + value +'" for ' + context);
	      }
	    }
	  },
	
	  validatePattern: function validatePattern(shape, value, context) {
	    if (this.validation['pattern'] && shape['pattern'] !== undefined) {
	      if (!(new RegExp(shape['pattern'])).test(value)) {
	        this.fail('PatternMatchError', 'Provided value "' + value + '" '
	          + 'does not match regex pattern /' + shape['pattern'] + '/ for '
	          + context);
	      }
	    }
	  },
	
	  validateRange: function validateRange(shape, value, context, descriptor) {
	    if (this.validation['min']) {
	      if (shape['min'] !== undefined && value < shape['min']) {
	        this.fail('MinRangeError', 'Expected ' + descriptor + ' >= '
	          + shape['min'] + ', but found ' + value + ' for ' + context);
	      }
	    }
	    if (this.validation['max']) {
	      if (shape['max'] !== undefined && value > shape['max']) {
	        this.fail('MaxRangeError', 'Expected ' + descriptor + ' <= '
	          + shape['max'] + ', but found ' + value + ' for ' + context);
	      }
	    }
	  },
	
	  validateEnum: function validateRange(shape, value, context) {
	    if (this.validation['enum'] && shape['enum'] !== undefined) {
	      // Fail if the string value is not present in the enum list
	      if (shape['enum'].indexOf(value) === -1) {
	        this.fail('EnumError', 'Found string value of ' + value + ', but '
	          + 'expected ' + shape['enum'].join('|') + ' for ' + context);
	      }
	    }
	  },
	
	  validateType: function validateType(value, context, acceptedTypes, type) {
	    // We will not log an error for null or undefined, but we will return
	    // false so that callers know that the expected type was not strictly met.
	    if (value === null || value === undefined) return false;
	
	    var foundInvalidType = false;
	    for (var i = 0; i < acceptedTypes.length; i++) {
	      if (typeof acceptedTypes[i] === 'string') {
	        if (typeof value === acceptedTypes[i]) return true;
	      } else if (acceptedTypes[i] instanceof RegExp) {
	        if ((value || '').toString().match(acceptedTypes[i])) return true;
	      } else {
	        if (value instanceof acceptedTypes[i]) return true;
	        if (AWS.util.isType(value, acceptedTypes[i])) return true;
	        if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
	        acceptedTypes[i] = AWS.util.typeName(acceptedTypes[i]);
	      }
	      foundInvalidType = true;
	    }
	
	    var acceptedType = type;
	    if (!acceptedType) {
	      acceptedType = acceptedTypes.join(', ').replace(/,([^,]+)$/, ', or$1');
	    }
	
	    var vowel = acceptedType.match(/^[aeiou]/i) ? 'n' : '';
	    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a' +
	              vowel + ' ' + acceptedType);
	    return false;
	  },
	
	  validateNumber: function validateNumber(shape, value, context) {
	    if (value === null || value === undefined) return;
	    if (typeof value === 'string') {
	      var castedValue = parseFloat(value);
	      if (castedValue.toString() === value) value = castedValue;
	    }
	    if (this.validateType(value, context, ['number'])) {
	      this.validateRange(shape, value, context, 'numeric value');
	    }
	  },
	
	  validatePayload: function validatePayload(value, context) {
	    if (value === null || value === undefined) return;
	    if (typeof value === 'string') return;
	    if (value && typeof value.byteLength === 'number') return; // typed arrays
	    if (AWS.util.isNode()) { // special check for buffer/stream in Node.js
	      var Stream = AWS.util.stream.Stream;
	      if (AWS.util.Buffer.isBuffer(value) || value instanceof Stream) return;
	    } else {
	      if (typeof Blob !== void 0 && value instanceof Blob) return;
	    }
	
	    var types = ['Buffer', 'Stream', 'File', 'Blob', 'ArrayBuffer', 'DataView'];
	    if (value) {
	      for (var i = 0; i < types.length; i++) {
	        if (AWS.util.isType(value, types[i])) return;
	        if (AWS.util.typeName(value.constructor) === types[i]) return;
	      }
	    }
	
	    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a ' +
	      'string, Buffer, Stream, Blob, or typed array object');
	  }
	});
	
	},{"./core":342}],375:[function(require,module,exports){
	var AWS = require('../core');
	var rest = AWS.Protocol.Rest;
	
	/**
	 * A presigner object can be used to generate presigned urls for the Polly service.
	 */
	AWS.Polly.Presigner = AWS.util.inherit({
	    /**
	     * Creates a presigner object with a set of configuration options.
	     *
	     * @option options params [map] An optional map of parameters to bind to every
	     *   request sent by this service object.
	     * @option options service [AWS.Polly] An optional pre-configured instance
	     *  of the AWS.Polly service object to use for requests. The object may
	     *  bound parameters used by the presigner.
	     * @see AWS.Polly.constructor
	     */
	    constructor: function Signer(options) {
	        options = options || {};
	        this.options = options;
	        this.service = options.service;
	        this.bindServiceObject(options);
	        this._operations = {};
	    },
	
	    /**
	     * @api private
	     */
	    bindServiceObject: function bindServiceObject(options) {
	        options = options || {};
	        if (!this.service) {
	            this.service = new AWS.Polly(options);
	        } else {
	            var config = AWS.util.copy(this.service.config);
	            this.service = new this.service.constructor.__super__(config);
	            this.service.config.params = AWS.util.merge(this.service.config.params || {}, options.params);
	        }
	    },
	
	    /**
	     * @api private
	     */
	    modifyInputMembers: function modifyInputMembers(input) {
	        // make copies of the input so we don't overwrite the api
	        // need to be careful to copy anything we access/modify
	        var modifiedInput = AWS.util.copy(input);
	        modifiedInput.members = AWS.util.copy(input.members);
	        AWS.util.each(input.members, function(name, member) {
	            modifiedInput.members[name] = AWS.util.copy(member);
	            // update location and locationName
	            if (!member.location || member.location === 'body') {
	                modifiedInput.members[name].location = 'querystring';
	                modifiedInput.members[name].locationName = name;
	            }
	        });
	        return modifiedInput;
	    },
	
	    /**
	     * @api private
	     */
	    convertPostToGet: function convertPostToGet(req) {
	        // convert method
	        req.httpRequest.method = 'GET';
	
	        var operation = req.service.api.operations[req.operation];
	        // get cached operation input first
	        var input = this._operations[req.operation];
	        if (!input) {
	            // modify the original input
	            this._operations[req.operation] = input = this.modifyInputMembers(operation.input);
	        }
	
	        var uri = rest.generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
	
	        req.httpRequest.path = uri;
	        req.httpRequest.body = '';
	
	        // don't need these headers on a GET request
	        delete req.httpRequest.headers['Content-Length'];
	        delete req.httpRequest.headers['Content-Type'];
	    },
	
	    /**
	     * @overload getSynthesizeSpeechUrl(params = {}, [expires = 3600], [callback])
	     *   Generate a presigned url for {AWS.Polly.synthesizeSpeech}.
	     *   @note You must ensure that you have static or previously resolved
	     *     credentials if you call this method synchronously (with no callback),
	     *     otherwise it may not properly sign the request. If you cannot guarantee
	     *     this (you are using an asynchronous credential provider, i.e., EC2
	     *     IAM roles), you should always call this method with an asynchronous
	     *     callback.
	     *   @param params [map] parameters to pass to the operation. See the {AWS.Polly.synthesizeSpeech}
	     *     operation for the expected operation parameters.
	     *   @param expires [Integer] (3600) the number of seconds to expire the pre-signed URL operation in.
	     *     Defaults to 1 hour.
	     *   @return [string] if called synchronously (with no callback), returns the signed URL.
	     *   @return [null] nothing is returned if a callback is provided.
	     *   @callback callback function (err, url)
	     *     If a callback is supplied, it is called when a signed URL has been generated.
	     *     @param err [Error] the error object returned from the presigner.
	     *     @param url [String] the signed URL.
	     *   @see AWS.Polly.synthesizeSpeech
	     */
	    getSynthesizeSpeechUrl: function getSynthesizeSpeechUrl(params, expires, callback) {
	        var self = this;
	        var request = this.service.makeRequest('synthesizeSpeech', params);
	        // remove existing build listeners
	        request.removeAllListeners('build');
	        request.on('build', function(req) {
	            self.convertPostToGet(req);
	        });
	        return request.presign(expires, callback);
	    }
	});
	
	},{"../core":342}],376:[function(require,module,exports){
	var util =  require('../util');
	var AWS = require('../core');
	
	/**
	 * Prepend prefix defined by API model to endpoint that's already
	 * constructed. This feature does not apply to operations using
	 * endpoint discovery and can be disabled.
	 * @api private
	 */
	function populateHostPrefix(request)  {
	  var enabled = request.service.config.hostPrefixEnabled;
	  if (!enabled) return request;
	  var operationModel = request.service.api.operations[request.operation];
	  //don't marshal host prefix when operation has endpoint discovery traits
	  if (hasEndpointDiscover(request)) return request;
	  if (operationModel.endpoint && operationModel.endpoint.hostPrefix) {
	    var hostPrefixNotation = operationModel.endpoint.hostPrefix;
	    var hostPrefix = expandHostPrefix(hostPrefixNotation, request.params, operationModel.input);
	    prependEndpointPrefix(request.httpRequest.endpoint, hostPrefix);
	    validateHostname(request.httpRequest.endpoint.hostname);
	  }
	  return request;
	}
	
	/**
	 * @api private
	 */
	function hasEndpointDiscover(request) {
	  var api = request.service.api;
	  var operationModel = api.operations[request.operation];
	  var isEndpointOperation = api.endpointOperation && (api.endpointOperation === util.string.lowerFirst(operationModel.name));
	  return (operationModel.endpointDiscoveryRequired !== 'NULL' || isEndpointOperation === true);
	}
	
	/**
	 * @api private
	 */
	function expandHostPrefix(hostPrefixNotation, params, shape) {
	  util.each(shape.members, function(name, member) {
	    if (member.hostLabel === true) {
	      if (typeof params[name] !== 'string' || params[name] === '') {
	        throw util.error(new Error(), {
	          message: 'Parameter ' + name + ' should be a non-empty string.',
	          code: 'InvalidParameter'
	        });
	      }
	      var regex = new RegExp('\\{' + name + '\\}', 'g');
	      hostPrefixNotation = hostPrefixNotation.replace(regex, params[name]);
	    }
	  });
	  return hostPrefixNotation;
	}
	
	/**
	 * @api private
	 */
	function prependEndpointPrefix(endpoint, prefix) {
	  if (endpoint.host) {
	    endpoint.host = prefix + endpoint.host;
	  }
	  if (endpoint.hostname) {
	    endpoint.hostname = prefix + endpoint.hostname;
	  }
	}
	
	/**
	 * @api private
	 */
	function validateHostname(hostname) {
	  var labels = hostname.split('.');
	  //Reference: https://tools.ietf.org/html/rfc1123#section-2
	  var hostPattern = /^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/;
	  util.arrayEach(labels, function(label) {
	    if (!label.length || label.length < 1 || label.length > 63) {
	      throw util.error(new Error(), {
	        code: 'ValidationError',
	        message: 'Hostname label length should be between 1 to 63 characters, inclusive.'
	      });
	    }
	    if (!hostPattern.test(label)) {
	      throw AWS.util.error(new Error(),
	        {code: 'ValidationError', message: label + ' is not hostname compatible.'});
	    }
	  });
	}
	
	module.exports = {
	  populateHostPrefix: populateHostPrefix
	};
	
	},{"../core":342,"../util":418}],377:[function(require,module,exports){
	var util = require('../util');
	var JsonBuilder = require('../json/builder');
	var JsonParser = require('../json/parser');
	var populateHostPrefix = require('./helpers').populateHostPrefix;
	
	function buildRequest(req) {
	  var httpRequest = req.httpRequest;
	  var api = req.service.api;
	  var target = api.targetPrefix + '.' + api.operations[req.operation].name;
	  var version = api.jsonVersion || '1.0';
	  var input = api.operations[req.operation].input;
	  var builder = new JsonBuilder();
	
	  if (version === 1) version = '1.0';
	  httpRequest.body = builder.build(req.params || {}, input);
	  httpRequest.headers['Content-Type'] = 'application/x-amz-json-' + version;
	  httpRequest.headers['X-Amz-Target'] = target;
	
	  populateHostPrefix(req);
	}
	
	function extractError(resp) {
	  var error = {};
	  var httpResponse = resp.httpResponse;
	
	  error.code = httpResponse.headers['x-amzn-errortype'] || 'UnknownError';
	  if (typeof error.code === 'string') {
	    error.code = error.code.split(':')[0];
	  }
	
	  if (httpResponse.body.length > 0) {
	    try {
	      var e = JSON.parse(httpResponse.body.toString());
	      var code = e.__type || e.code || e.Code;
	      if (code) {
	        error.code = code.split('#').pop();
	      }
	      if (error.code === 'RequestEntityTooLarge') {
	        error.message = 'Request body must be less than 1 MB';
	      } else {
	        error.message = (e.message || e.Message || null);
	      }
	    } catch (e) {
	      error.statusCode = httpResponse.statusCode;
	      error.message = httpResponse.statusMessage;
	    }
	  } else {
	    error.statusCode = httpResponse.statusCode;
	    error.message = httpResponse.statusCode.toString();
	  }
	
	  resp.error = util.error(new Error(), error);
	}
	
	function extractData(resp) {
	  var body = resp.httpResponse.body.toString() || '{}';
	  if (resp.request.service.config.convertResponseTypes === false) {
	    resp.data = JSON.parse(body);
	  } else {
	    var operation = resp.request.service.api.operations[resp.request.operation];
	    var shape = operation.output || {};
	    var parser = new JsonParser();
	    resp.data = parser.parse(body, shape);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};
	
	},{"../json/builder":366,"../json/parser":367,"../util":418,"./helpers":376}],378:[function(require,module,exports){
	var AWS = require('../core');
	var util = require('../util');
	var QueryParamSerializer = require('../query/query_param_serializer');
	var Shape = require('../model/shape');
	var populateHostPrefix = require('./helpers').populateHostPrefix;
	
	function buildRequest(req) {
	  var operation = req.service.api.operations[req.operation];
	  var httpRequest = req.httpRequest;
	  httpRequest.headers['Content-Type'] =
	    'application/x-www-form-urlencoded; charset=utf-8';
	  httpRequest.params = {
	    Version: req.service.api.apiVersion,
	    Action: operation.name
	  };
	
	  // convert the request parameters into a list of query params,
	  // e.g. Deeply.NestedParam.0.Name=value
	  var builder = new QueryParamSerializer();
	  builder.serialize(req.params, operation.input, function(name, value) {
	    httpRequest.params[name] = value;
	  });
	  httpRequest.body = util.queryParamsToString(httpRequest.params);
	
	  populateHostPrefix(req);
	}
	
	function extractError(resp) {
	  var data, body = resp.httpResponse.body.toString();
	  if (body.match('<UnknownOperationException')) {
	    data = {
	      Code: 'UnknownOperation',
	      Message: 'Unknown operation ' + resp.request.operation
	    };
	  } else {
	    try {
	      data = new AWS.XML.Parser().parse(body);
	    } catch (e) {
	      data = {
	        Code: resp.httpResponse.statusCode,
	        Message: resp.httpResponse.statusMessage
	      };
	    }
	  }
	
	  if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
	  if (data.Errors) data = data.Errors;
	  if (data.Error) data = data.Error;
	  if (data.Code) {
	    resp.error = util.error(new Error(), {
	      code: data.Code,
	      message: data.Message
	    });
	  } else {
	    resp.error = util.error(new Error(), {
	      code: resp.httpResponse.statusCode,
	      message: null
	    });
	  }
	}
	
	function extractData(resp) {
	  var req = resp.request;
	  var operation = req.service.api.operations[req.operation];
	  var shape = operation.output || {};
	  var origRules = shape;
	
	  if (origRules.resultWrapper) {
	    var tmp = Shape.create({type: 'structure'});
	    tmp.members[origRules.resultWrapper] = shape;
	    tmp.memberNames = [origRules.resultWrapper];
	    util.property(shape, 'name', shape.resultWrapper);
	    shape = tmp;
	  }
	
	  var parser = new AWS.XML.Parser();
	
	  // TODO: Refactor XML Parser to parse RequestId from response.
	  if (shape && shape.members && !shape.members._XAMZRequestId) {
	    var requestIdShape = Shape.create(
	      { type: 'string' },
	      { api: { protocol: 'query' } },
	      'requestId'
	    );
	    shape.members._XAMZRequestId = requestIdShape;
	  }
	
	  var data = parser.parse(resp.httpResponse.body.toString(), shape);
	  resp.requestId = data._XAMZRequestId || data.requestId;
	
	  if (data._XAMZRequestId) delete data._XAMZRequestId;
	
	  if (origRules.resultWrapper) {
	    if (data[origRules.resultWrapper]) {
	      util.update(data, data[origRules.resultWrapper]);
	      delete data[origRules.resultWrapper];
	    }
	  }
	
	  resp.data = data;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};
	
	},{"../core":342,"../model/shape":373,"../query/query_param_serializer":382,"../util":418,"./helpers":376}],379:[function(require,module,exports){
	var util = require('../util');
	var populateHostPrefix = require('./helpers').populateHostPrefix;
	
	function populateMethod(req) {
	  req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
	}
	
	function generateURI(endpointPath, operationPath, input, params) {
	  var uri = [endpointPath, operationPath].join('/');
	  uri = uri.replace(/\/+/g, '/');
	
	  var queryString = {}, queryStringSet = false;
	  util.each(input.members, function (name, member) {
	    var paramValue = params[name];
	    if (paramValue === null || paramValue === undefined) return;
	    if (member.location === 'uri') {
	      var regex = new RegExp('\\{' + member.name + '(\\+)?\\}');
	      uri = uri.replace(regex, function(_, plus) {
	        var fn = plus ? util.uriEscapePath : util.uriEscape;
	        return fn(String(paramValue));
	      });
	    } else if (member.location === 'querystring') {
	      queryStringSet = true;
	
	      if (member.type === 'list') {
	        queryString[member.name] = paramValue.map(function(val) {
	          return util.uriEscape(member.member.toWireFormat(val).toString());
	        });
	      } else if (member.type === 'map') {
	        util.each(paramValue, function(key, value) {
	          if (Array.isArray(value)) {
	            queryString[key] = value.map(function(val) {
	              return util.uriEscape(String(val));
	            });
	          } else {
	            queryString[key] = util.uriEscape(String(value));
	          }
	        });
	      } else {
	        queryString[member.name] = util.uriEscape(member.toWireFormat(paramValue).toString());
	      }
	    }
	  });
	
	  if (queryStringSet) {
	    uri += (uri.indexOf('?') >= 0 ? '&' : '?');
	    var parts = [];
	    util.arrayEach(Object.keys(queryString).sort(), function(key) {
	      if (!Array.isArray(queryString[key])) {
	        queryString[key] = [queryString[key]];
	      }
	      for (var i = 0; i < queryString[key].length; i++) {
	        parts.push(util.uriEscape(String(key)) + '=' + queryString[key][i]);
	      }
	    });
	    uri += parts.join('&');
	  }
	
	  return uri;
	}
	
	function populateURI(req) {
	  var operation = req.service.api.operations[req.operation];
	  var input = operation.input;
	
	  var uri = generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
	  req.httpRequest.path = uri;
	}
	
	function populateHeaders(req) {
	  var operation = req.service.api.operations[req.operation];
	  util.each(operation.input.members, function (name, member) {
	    var value = req.params[name];
	    if (value === null || value === undefined) return;
	
	    if (member.location === 'headers' && member.type === 'map') {
	      util.each(value, function(key, memberValue) {
	        req.httpRequest.headers[member.name + key] = memberValue;
	      });
	    } else if (member.location === 'header') {
	      value = member.toWireFormat(value).toString();
	      if (member.isJsonValue) {
	        value = util.base64.encode(value);
	      }
	      req.httpRequest.headers[member.name] = value;
	    }
	  });
	}
	
	function buildRequest(req) {
	  populateMethod(req);
	  populateURI(req);
	  populateHeaders(req);
	  populateHostPrefix(req);
	}
	
	function extractError() {
	}
	
	function extractData(resp) {
	  var req = resp.request;
	  var data = {};
	  var r = resp.httpResponse;
	  var operation = req.service.api.operations[req.operation];
	  var output = operation.output;
	
	  // normalize headers names to lower-cased keys for matching
	  var headers = {};
	  util.each(r.headers, function (k, v) {
	    headers[k.toLowerCase()] = v;
	  });
	
	  util.each(output.members, function(name, member) {
	    var header = (member.name || name).toLowerCase();
	    if (member.location === 'headers' && member.type === 'map') {
	      data[name] = {};
	      var location = member.isLocationName ? member.name : '';
	      var pattern = new RegExp('^' + location + '(.+)', 'i');
	      util.each(r.headers, function (k, v) {
	        var result = k.match(pattern);
	        if (result !== null) {
	          data[name][result[1]] = v;
	        }
	      });
	    } else if (member.location === 'header') {
	      if (headers[header] !== undefined) {
	        var value = member.isJsonValue ?
	          util.base64.decode(headers[header]) :
	          headers[header];
	        data[name] = member.toType(value);
	      }
	    } else if (member.location === 'statusCode') {
	      data[name] = parseInt(r.statusCode, 10);
	    }
	  });
	
	  resp.data = data;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData,
	  generateURI: generateURI
	};
	
	},{"../util":418,"./helpers":376}],380:[function(require,module,exports){
	var util = require('../util');
	var Rest = require('./rest');
	var Json = require('./json');
	var JsonBuilder = require('../json/builder');
	var JsonParser = require('../json/parser');
	
	function populateBody(req) {
	  var builder = new JsonBuilder();
	  var input = req.service.api.operations[req.operation].input;
	
	  if (input.payload) {
	    var params = {};
	    var payloadShape = input.members[input.payload];
	    params = req.params[input.payload];
	
	    if (payloadShape.type === 'structure') {
	      req.httpRequest.body = builder.build(params || {}, payloadShape);
	      applyContentTypeHeader(req);
	    } else if (params !== undefined) {
	      // non-JSON payload
	      req.httpRequest.body = params;
	      if (payloadShape.type === 'binary' || payloadShape.isStreaming) {
	        applyContentTypeHeader(req, true);
	      }
	    }
	  } else {
	    req.httpRequest.body = builder.build(req.params, input);
	    applyContentTypeHeader(req);
	  }
	}
	
	function applyContentTypeHeader(req, isBinary) {
	  if (!req.httpRequest.headers['Content-Type']) {
	    var type = isBinary ? 'binary/octet-stream' : 'application/json';
	    req.httpRequest.headers['Content-Type'] = type;
	  }
	}
	
	function buildRequest(req) {
	  Rest.buildRequest(req);
	
	  // never send body payload on GET/HEAD/DELETE
	  if (['GET', 'HEAD', 'DELETE'].indexOf(req.httpRequest.method) < 0) {
	    populateBody(req);
	  }
	}
	
	function extractError(resp) {
	  Json.extractError(resp);
	}
	
	function extractData(resp) {
	  Rest.extractData(resp);
	
	  var req = resp.request;
	  var operation = req.service.api.operations[req.operation];
	  var rules = req.service.api.operations[req.operation].output || {};
	  var parser;
	  var hasEventOutput = operation.hasEventOutput;
	
	  if (rules.payload) {
	    var payloadMember = rules.members[rules.payload];
	    var body = resp.httpResponse.body;
	    if (payloadMember.isEventStream) {
	      parser = new JsonParser();
	      resp.data[payload] = util.createEventStream(
	        AWS.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : body,
	        parser,
	        payloadMember
	      );
	    } else if (payloadMember.type === 'structure' || payloadMember.type === 'list') {
	      var parser = new JsonParser();
	      resp.data[rules.payload] = parser.parse(body, payloadMember);
	    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
	      resp.data[rules.payload] = body;
	    } else {
	      resp.data[rules.payload] = payloadMember.toType(body);
	    }
	  } else {
	    var data = resp.data;
	    Json.extractData(resp);
	    resp.data = util.merge(data, resp.data);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};
	
	},{"../json/builder":366,"../json/parser":367,"../util":418,"./json":377,"./rest":379}],381:[function(require,module,exports){
	var AWS = require('../core');
	var util = require('../util');
	var Rest = require('./rest');
	
	function populateBody(req) {
	  var input = req.service.api.operations[req.operation].input;
	  var builder = new AWS.XML.Builder();
	  var params = req.params;
	
	  var payload = input.payload;
	  if (payload) {
	    var payloadMember = input.members[payload];
	    params = params[payload];
	    if (params === undefined) return;
	
	    if (payloadMember.type === 'structure') {
	      var rootElement = payloadMember.name;
	      req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
	    } else { // non-xml payload
	      req.httpRequest.body = params;
	    }
	  } else {
	    req.httpRequest.body = builder.toXML(params, input, input.name ||
	      input.shape || util.string.upperFirst(req.operation) + 'Request');
	  }
	}
	
	function buildRequest(req) {
	  Rest.buildRequest(req);
	
	  // never send body payload on GET/HEAD
	  if (['GET', 'HEAD'].indexOf(req.httpRequest.method) < 0) {
	    populateBody(req);
	  }
	}
	
	function extractError(resp) {
	  Rest.extractError(resp);
	
	  var data;
	  try {
	    data = new AWS.XML.Parser().parse(resp.httpResponse.body.toString());
	  } catch (e) {
	    data = {
	      Code: resp.httpResponse.statusCode,
	      Message: resp.httpResponse.statusMessage
	    };
	  }
	
	  if (data.Errors) data = data.Errors;
	  if (data.Error) data = data.Error;
	  if (data.Code) {
	    resp.error = util.error(new Error(), {
	      code: data.Code,
	      message: data.Message
	    });
	  } else {
	    resp.error = util.error(new Error(), {
	      code: resp.httpResponse.statusCode,
	      message: null
	    });
	  }
	}
	
	function extractData(resp) {
	  Rest.extractData(resp);
	
	  var parser;
	  var req = resp.request;
	  var body = resp.httpResponse.body;
	  var operation = req.service.api.operations[req.operation];
	  var output = operation.output;
	
	  var hasEventOutput = operation.hasEventOutput;
	
	  var payload = output.payload;
	  if (payload) {
	    var payloadMember = output.members[payload];
	    if (payloadMember.isEventStream) {
	      parser = new AWS.XML.Parser();
	      resp.data[payload] = util.createEventStream(
	        AWS.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : resp.httpResponse.body,
	        parser,
	        payloadMember
	      );
	    } else if (payloadMember.type === 'structure') {
	      parser = new AWS.XML.Parser();
	      resp.data[payload] = parser.parse(body.toString(), payloadMember);
	    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
	      resp.data[payload] = body;
	    } else {
	      resp.data[payload] = payloadMember.toType(body);
	    }
	  } else if (body.length > 0) {
	    parser = new AWS.XML.Parser();
	    var data = parser.parse(body.toString(), output);
	    util.update(resp.data, data);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};
	
	},{"../core":342,"../util":418,"./rest":379}],382:[function(require,module,exports){
	var util = require('../util');
	
	function QueryParamSerializer() {
	}
	
	QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
	  serializeStructure('', params, shape, fn);
	};
	
	function ucfirst(shape) {
	  if (shape.isQueryName || shape.api.protocol !== 'ec2') {
	    return shape.name;
	  } else {
	    return shape.name[0].toUpperCase() + shape.name.substr(1);
	  }
	}
	
	function serializeStructure(prefix, struct, rules, fn) {
	  util.each(rules.members, function(name, member) {
	    var value = struct[name];
	    if (value === null || value === undefined) return;
	
	    var memberName = ucfirst(member);
	    memberName = prefix ? prefix + '.' + memberName : memberName;
	    serializeMember(memberName, value, member, fn);
	  });
	}
	
	function serializeMap(name, map, rules, fn) {
	  var i = 1;
	  util.each(map, function (key, value) {
	    var prefix = rules.flattened ? '.' : '.entry.';
	    var position = prefix + (i++) + '.';
	    var keyName = position + (rules.key.name || 'key');
	    var valueName = position + (rules.value.name || 'value');
	    serializeMember(name + keyName, key, rules.key, fn);
	    serializeMember(name + valueName, value, rules.value, fn);
	  });
	}
	
	function serializeList(name, list, rules, fn) {
	  var memberRules = rules.member || {};
	
	  if (list.length === 0) {
	    fn.call(this, name, null);
	    return;
	  }
	
	  util.arrayEach(list, function (v, n) {
	    var suffix = '.' + (n + 1);
	    if (rules.api.protocol === 'ec2') {
	      // Do nothing for EC2
	      suffix = suffix + ''; // make linter happy
	    } else if (rules.flattened) {
	      if (memberRules.name) {
	        var parts = name.split('.');
	        parts.pop();
	        parts.push(ucfirst(memberRules));
	        name = parts.join('.');
	      }
	    } else {
	      suffix = '.' + (memberRules.name ? memberRules.name : 'member') + suffix;
	    }
	    serializeMember(name + suffix, v, memberRules, fn);
	  });
	}
	
	function serializeMember(name, value, rules, fn) {
	  if (value === null || value === undefined) return;
	  if (rules.type === 'structure') {
	    serializeStructure(name, value, rules, fn);
	  } else if (rules.type === 'list') {
	    serializeList(name, value, rules, fn);
	  } else if (rules.type === 'map') {
	    serializeMap(name, value, rules, fn);
	  } else {
	    fn(name, rules.toWireFormat(value).toString());
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = QueryParamSerializer;
	
	},{"../util":418}],383:[function(require,module,exports){
	var AWS = require('../core');
	
	/**
	 * @api private
	 */
	var service = null;
	
	/**
	 * @api private
	 */
	var api = {
	    signatureVersion: 'v4',
	    signingName: 'rds-db',
	    operations: {}
	};
	
	/**
	 * @api private
	 */
	var requiredAuthTokenOptions = {
	    region: 'string',
	    hostname: 'string',
	    port: 'number',
	    username: 'string'
	};
	
	/**
	 * A signer object can be used to generate an auth token to a database.
	 */
	AWS.RDS.Signer = AWS.util.inherit({
	    /**
	     * Creates a signer object can be used to generate an auth token.
	     *
	     * @option options credentials [AWS.Credentials] the AWS credentials
	     *   to sign requests with. Uses the default credential provider chain
	     *   if not specified.
	     * @option options hostname [String] the hostname of the database to connect to.
	     * @option options port [Number] the port number the database is listening on.
	     * @option options region [String] the region the database is located in.
	     * @option options username [String] the username to login as.
	     * @example Passing in options to constructor
	     *   var signer = new AWS.RDS.Signer({
	     *     credentials: new AWS.SharedIniFileCredentials({profile: 'default'}),
	     *     region: 'us-east-1',
	     *     hostname: 'db.us-east-1.rds.amazonaws.com',
	     *     port: 8000,
	     *     username: 'name'
	     *   });
	     */
	    constructor: function Signer(options) {
	        this.options = options || {};
	    },
	
	    /**
	     * @api private
	     * Strips the protocol from a url.
	     */
	    convertUrlToAuthToken: function convertUrlToAuthToken(url) {
	        // we are always using https as the protocol
	        var protocol = 'https://';
	        if (url.indexOf(protocol) === 0) {
	            return url.substring(protocol.length);
	        }
	    },
	
	    /**
	     * @overload getAuthToken(options = {}, [callback])
	     *   Generate an auth token to a database.
	     *   @note You must ensure that you have static or previously resolved
	     *     credentials if you call this method synchronously (with no callback),
	     *     otherwise it may not properly sign the request. If you cannot guarantee
	     *     this (you are using an asynchronous credential provider, i.e., EC2
	     *     IAM roles), you should always call this method with an asynchronous
	     *     callback.
	     *
	     *   @param options [map] The fields to use when generating an auth token.
	     *     Any options specified here will be merged on top of any options passed
	     *     to AWS.RDS.Signer:
	     *
	     *     * **credentials** (AWS.Credentials) &mdash; the AWS credentials
	     *         to sign requests with. Uses the default credential provider chain
	     *         if not specified.
	     *     * **hostname** (String) &mdash; the hostname of the database to connect to.
	     *     * **port** (Number) &mdash; the port number the database is listening on.
	     *     * **region** (String) &mdash; the region the database is located in.
	     *     * **username** (String) &mdash; the username to login as.
	     *   @return [String] if called synchronously (with no callback), returns the
	     *     auth token.
	     *   @return [null] nothing is returned if a callback is provided.
	     *   @callback callback function (err, token)
	     *     If a callback is supplied, it is called when an auth token has been generated.
	     *     @param err [Error] the error object returned from the signer.
	     *     @param token [String] the auth token.
	     *
	     *   @example Generating an auth token synchronously
	     *     var signer = new AWS.RDS.Signer({
	     *       // configure options
	     *       region: 'us-east-1',
	     *       username: 'default',
	     *       hostname: 'db.us-east-1.amazonaws.com',
	     *       port: 8000
	     *     });
	     *     var token = signer.getAuthToken({
	     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
	     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
	     *       username: 'test' // overriding username
	     *     });
	     *   @example Generating an auth token asynchronously
	     *     var signer = new AWS.RDS.Signer({
	     *       // configure options
	     *       region: 'us-east-1',
	     *       username: 'default',
	     *       hostname: 'db.us-east-1.amazonaws.com',
	     *       port: 8000
	     *     });
	     *     signer.getAuthToken({
	     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
	     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
	     *       username: 'test' // overriding username
	     *     }, function(err, token) {
	     *       if (err) {
	     *         // handle error
	     *       } else {
	     *         // use token
	     *       }
	     *     });
	     *
	     */
	    getAuthToken: function getAuthToken(options, callback) {
	        if (typeof options === 'function' && callback === undefined) {
	            callback = options;
	            options = {};
	        }
	        var self = this;
	        var hasCallback = typeof callback === 'function';
	        // merge options with existing options
	        options = AWS.util.merge(this.options, options);
	        // validate options
	        var optionsValidation = this.validateAuthTokenOptions(options);
	        if (optionsValidation !== true) {
	            if (hasCallback) {
	                return callback(optionsValidation, null);
	            }
	            throw optionsValidation;
	        }
	
	        // 15 minutes
	        var expires = 900;
	        // create service to generate a request from
	        var serviceOptions = {
	            region: options.region,
	            endpoint: new AWS.Endpoint(options.hostname + ':' + options.port),
	            paramValidation: false,
	            signatureVersion: 'v4'
	        };
	        if (options.credentials) {
	            serviceOptions.credentials = options.credentials;
	        }
	        service = new AWS.Service(serviceOptions);
	        // ensure the SDK is using sigv4 signing (config is not enough)
	        service.api = api;
	
	        var request = service.makeRequest();
	        // add listeners to request to properly build auth token
	        this.modifyRequestForAuthToken(request, options);
	
	        if (hasCallback) {
	            request.presign(expires, function(err, url) {
	                if (url) {
	                    url = self.convertUrlToAuthToken(url);
	                }
	                callback(err, url);
	            });
	        } else {
	            var url = request.presign(expires);
	            return this.convertUrlToAuthToken(url);
	        }
	    },
	
	    /**
	     * @api private
	     * Modifies a request to allow the presigner to generate an auth token.
	     */
	    modifyRequestForAuthToken: function modifyRequestForAuthToken(request, options) {
	        request.on('build', request.buildAsGet);
	        var httpRequest = request.httpRequest;
	        httpRequest.body = AWS.util.queryParamsToString({
	            Action: 'connect',
	            DBUser: options.username
	        });
	    },
	
	    /**
	     * @api private
	     * Validates that the options passed in contain all the keys with values of the correct type that
	     *   are needed to generate an auth token.
	     */
	    validateAuthTokenOptions: function validateAuthTokenOptions(options) {
	        // iterate over all keys in options
	        var message = '';
	        options = options || {};
	        for (var key in requiredAuthTokenOptions) {
	            if (!Object.prototype.hasOwnProperty.call(requiredAuthTokenOptions, key)) {
	                continue;
	            }
	            if (typeof options[key] !== requiredAuthTokenOptions[key]) {
	                message += 'option \'' + key + '\' should have been type \'' + requiredAuthTokenOptions[key] + '\', was \'' + typeof options[key] + '\'.\n';
	            }
	        }
	        if (message.length) {
	            return AWS.util.error(new Error(), {
	                code: 'InvalidParameter',
	                message: message
	            });
	        }
	        return true;
	    }
	});
	
	},{"../core":342}],384:[function(require,module,exports){
	module.exports = {
	  //provide realtime clock for performance measurement
	  now: function now() {
	    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
	      return performance.now();
	    }
	    return Date.now();
	  }
	};
	
	},{}],385:[function(require,module,exports){
	function isFipsRegion(region) {
	  return typeof region === 'string' && (region.startsWith('fips-') || region.endsWith('-fips'));
	}
	
	function isGlobalRegion(region) {
	  return typeof region === 'string' && ['aws-global', 'aws-us-gov-global'].includes(region);
	}
	
	function getRealRegion(region) {
	  return ['fips-aws-global', 'aws-fips', 'aws-global'].includes(region)
	      ? 'us-east-1'
	      : ['fips-aws-us-gov-global', 'aws-us-gov-global'].includes(region)
	      ? 'us-gov-west-1'
	      : region.replace(/fips-(dkr-|prod-)?|-fips/, '');
	}
	
	module.exports = {
	  isFipsRegion: isFipsRegion,
	  isGlobalRegion: isGlobalRegion,
	  getRealRegion: getRealRegion
	};
	
	},{}],386:[function(require,module,exports){
	var util = require('./util');
	var regionConfig = require('./region_config_data.json');
	
	function generateRegionPrefix(region) {
	  if (!region) return null;
	  var parts = region.split('-');
	  if (parts.length < 3) return null;
	  return parts.slice(0, parts.length - 2).join('-') + '-*';
	}
	
	function derivedKeys(service) {
	  var region = service.config.region;
	  var regionPrefix = generateRegionPrefix(region);
	  var endpointPrefix = service.api.endpointPrefix;
	
	  return [
	    [region, endpointPrefix],
	    [regionPrefix, endpointPrefix],
	    [region, '*'],
	    [regionPrefix, '*'],
	    ['*', endpointPrefix],
	    ['*', '*']
	  ].map(function(item) {
	    return item[0] && item[1] ? item.join('/') : null;
	  });
	}
	
	function applyConfig(service, config) {
	  util.each(config, function(key, value) {
	    if (key === 'globalEndpoint') return;
	    if (service.config[key] === undefined || service.config[key] === null) {
	      service.config[key] = value;
	    }
	  });
	}
	
	function configureEndpoint(service) {
	  var keys = derivedKeys(service);
	  var useFipsEndpoint = service.config.useFipsEndpoint;
	  var useDualstackEndpoint = service.config.useDualstackEndpoint;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!key) continue;
	
	    var rules = useFipsEndpoint
	      ? useDualstackEndpoint
	        ? regionConfig.dualstackFipsRules
	        : regionConfig.fipsRules
	      : useDualstackEndpoint
	      ? regionConfig.dualstackRules
	      : regionConfig.rules;
	
	    if (Object.prototype.hasOwnProperty.call(rules, key)) {
	      var config = rules[key];
	      if (typeof config === 'string') {
	        config = regionConfig.patterns[config];
	      }
	
	      // set global endpoint
	      service.isGlobalEndpoint = !!config.globalEndpoint;
	      if (config.signingRegion) {
	        service.signingRegion = config.signingRegion;
	      }
	
	      // signature version
	      if (!config.signatureVersion) config.signatureVersion = 'v4';
	
	      // merge config
	      applyConfig(service, config);
	      return;
	    }
	  }
	}
	
	function getEndpointSuffix(region) {
	  var regionRegexes = {
	    '^(us|eu|ap|sa|ca|me)\\-\\w+\\-\\d+$': 'amazonaws.com',
	    '^cn\\-\\w+\\-\\d+$': 'amazonaws.com.cn',
	    '^us\\-gov\\-\\w+\\-\\d+$': 'amazonaws.com',
	    '^us\\-iso\\-\\w+\\-\\d+$': 'c2s.ic.gov',
	    '^us\\-isob\\-\\w+\\-\\d+$': 'sc2s.sgov.gov'
	  };
	  var defaultSuffix = 'amazonaws.com';
	  var regexes = Object.keys(regionRegexes);
	  for (var i = 0; i < regexes.length; i++) {
	    var regionPattern = RegExp(regexes[i]);
	    var dnsSuffix = regionRegexes[regexes[i]];
	    if (regionPattern.test(region)) return dnsSuffix;
	  }
	  return defaultSuffix;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  configureEndpoint: configureEndpoint,
	  getEndpointSuffix: getEndpointSuffix,
	};
	
	},{"./region_config_data.json":387,"./util":418}],387:[function(require,module,exports){
	module.exports={
	  "rules": {
	    "*/*": {
	      "endpoint": "{service}.{region}.amazonaws.com"
	    },
	    "cn-*/*": {
	      "endpoint": "{service}.{region}.amazonaws.com.cn"
	    },
	    "us-iso-*/*": "usIso",
	    "us-isob-*/*": "usIsob",
	    "*/budgets": "globalSSL",
	    "*/cloudfront": "globalSSL",
	    "*/sts": "globalSSL",
	    "*/importexport": {
	      "endpoint": "{service}.amazonaws.com",
	      "signatureVersion": "v2",
	      "globalEndpoint": true
	    },
	
	    "*/route53": "globalSSL",
	    "cn-*/route53": {
	      "endpoint": "{service}.amazonaws.com.cn",
	      "globalEndpoint": true,
	      "signingRegion": "cn-northwest-1"
	    },
	    "us-gov-*/route53": "globalGovCloud",
	    "us-iso-*/route53": {
	      "endpoint": "{service}.c2s.ic.gov",
	      "globalEndpoint": true,
	      "signingRegion": "us-iso-east-1"
	    },
	    "us-isob-*/route53": {
	      "endpoint": "{service}.sc2s.sgov.gov",
	      "globalEndpoint": true,
	      "signingRegion": "us-isob-east-1"
	    },
	
	    "*/waf": "globalSSL",
	
	    "*/iam": "globalSSL",
	    "cn-*/iam": {
	      "endpoint": "{service}.cn-north-1.amazonaws.com.cn",
	      "globalEndpoint": true,
	      "signingRegion": "cn-north-1"
	    },
	    "us-gov-*/iam": "globalGovCloud",
	
	    "us-gov-*/sts": {
	      "endpoint": "{service}.{region}.amazonaws.com"
	    },
	    "us-gov-west-1/s3": "s3signature",
	    "us-west-1/s3": "s3signature",
	    "us-west-2/s3": "s3signature",
	    "eu-west-1/s3": "s3signature",
	    "ap-southeast-1/s3": "s3signature",
	    "ap-southeast-2/s3": "s3signature",
	    "ap-northeast-1/s3": "s3signature",
	    "sa-east-1/s3": "s3signature",
	    "us-east-1/s3": {
	      "endpoint": "{service}.amazonaws.com",
	      "signatureVersion": "s3"
	    },
	    "us-east-1/sdb": {
	      "endpoint": "{service}.amazonaws.com",
	      "signatureVersion": "v2"
	    },
	    "*/sdb": {
	      "endpoint": "{service}.{region}.amazonaws.com",
	      "signatureVersion": "v2"
	    }
	  },
	
	  "fipsRules": {
	    "*/*": "fipsStandard",
	    "us-gov-*/*": "fipsStandard",
	    "us-iso-*/*": {
	      "endpoint": "{service}-fips.{region}.c2s.ic.gov"
	    },
	    "us-iso-*/dms": "usIso",
	    "us-isob-*/*": {
	      "endpoint": "{service}-fips.{region}.sc2s.sgov.gov"
	    },
	    "us-isob-*/dms": "usIsob",
	    "cn-*/*": {
	      "endpoint": "{service}-fips.{region}.amazonaws.com.cn"
	    },
	    "*/api.ecr": "fips.api.ecr",
	    "*/api.sagemaker": "fips.api.sagemaker",
	    "*/batch": "fipsDotPrefix",
	    "*/eks": "fipsDotPrefix",
	    "*/models.lex": "fips.models.lex",
	    "*/runtime.lex": "fips.runtime.lex",
	    "*/runtime.sagemaker": {
	      "endpoint": "runtime-fips.sagemaker.{region}.amazonaws.com"
	    },
	    "*/iam": "fipsWithoutRegion",
	    "*/route53": "fipsWithoutRegion",
	    "*/transcribe": "fipsDotPrefix",
	    "*/waf": "fipsWithoutRegion",
	
	    "us-gov-*/transcribe": "fipsDotPrefix",
	    "us-gov-*/api.ecr": "fips.api.ecr",
	    "us-gov-*/api.sagemaker": "fips.api.sagemaker",
	    "us-gov-*/models.lex": "fips.models.lex",
	    "us-gov-*/runtime.lex": "fips.runtime.lex",
	    "us-gov-*/acm-pca": "fipsWithServiceOnly",
	    "us-gov-*/batch": "fipsWithServiceOnly",
	    "us-gov-*/config": "fipsWithServiceOnly",
	    "us-gov-*/eks": "fipsWithServiceOnly",
	    "us-gov-*/elasticmapreduce": "fipsWithServiceOnly",
	    "us-gov-*/identitystore": "fipsWithServiceOnly",
	    "us-gov-*/dynamodb": "fipsWithServiceOnly",
	    "us-gov-*/elasticloadbalancing": "fipsWithServiceOnly",
	    "us-gov-*/guardduty": "fipsWithServiceOnly",
	    "us-gov-*/monitoring": "fipsWithServiceOnly",
	    "us-gov-*/resource-groups": "fipsWithServiceOnly",
	    "us-gov-*/runtime.sagemaker": "fipsWithServiceOnly",
	    "us-gov-*/servicecatalog-appregistry": "fipsWithServiceOnly",
	    "us-gov-*/servicequotas": "fipsWithServiceOnly",
	    "us-gov-*/ssm": "fipsWithServiceOnly",
	    "us-gov-*/sts": "fipsWithServiceOnly",
	    "us-gov-*/support": "fipsWithServiceOnly",
	    "us-gov-west-1/states": "fipsWithServiceOnly",
	    "us-iso-east-1/elasticfilesystem": {
	      "endpoint": "elasticfilesystem-fips.{region}.c2s.ic.gov"
	    },
	    "us-gov-west-1/organizations": "fipsWithServiceOnly",
	    "us-gov-west-1/route53": {
	      "endpoint": "route53.us-gov.amazonaws.com"
	    }
	  },
	
	  "dualstackRules": {
	    "*/*": {
	      "endpoint": "{service}.{region}.api.aws"
	    },
	    "cn-*/*": {
	      "endpoint": "{service}.{region}.api.amazonwebservices.com.cn"
	    },
	
	    "*/s3": "dualstackLegacy",
	    "cn-*/s3": "dualstackLegacyCn",
	    "*/s3-control": "dualstackLegacy",
	    "cn-*/s3-control": "dualstackLegacyCn",
	
	    "ap-south-1/ec2": "dualstackLegacyEc2",
	    "eu-west-1/ec2": "dualstackLegacyEc2",
	    "sa-east-1/ec2": "dualstackLegacyEc2",
	    "us-east-1/ec2": "dualstackLegacyEc2",
	    "us-east-2/ec2": "dualstackLegacyEc2",
	    "us-west-2/ec2": "dualstackLegacyEc2"
	  },
	
	  "dualstackFipsRules": {
	    "*/*": {
	      "endpoint": "{service}-fips.{region}.api.aws"
	    },
	    "cn-*/*": {
	      "endpoint": "{service}-fips.{region}.api.amazonwebservices.com.cn"
	    },
	    "*/s3": "dualstackFipsLegacy",
	    "cn-*/s3": "dualstackFipsLegacyCn",
	    "*/s3-control": "dualstackFipsLegacy",
	    "cn-*/s3-control": "dualstackFipsLegacyCn"
	  },
	
	  "patterns": {
	    "globalSSL": {
	      "endpoint": "https://{service}.amazonaws.com",
	      "globalEndpoint": true,
	      "signingRegion": "us-east-1"
	    },
	    "globalGovCloud": {
	      "endpoint": "{service}.us-gov.amazonaws.com",
	      "globalEndpoint": true,
	      "signingRegion": "us-gov-west-1"
	    },
	    "s3signature": {
	      "endpoint": "{service}.{region}.amazonaws.com",
	      "signatureVersion": "s3"
	    },
	    "usIso": {
	      "endpoint": "{service}.{region}.c2s.ic.gov"
	    },
	    "usIsob": {
	      "endpoint": "{service}.{region}.sc2s.sgov.gov"
	    },
	    "fipsStandard": {
	      "endpoint": "{service}-fips.{region}.amazonaws.com"
	    },
	    "fipsDotPrefix": {
	      "endpoint": "fips.{service}.{region}.amazonaws.com"
	    },
	    "fipsWithoutRegion": {
	      "endpoint": "{service}-fips.amazonaws.com"
	    },
	    "fips.api.ecr": {
	      "endpoint": "ecr-fips.{region}.amazonaws.com"
	    },
	    "fips.api.sagemaker": {
	      "endpoint": "api-fips.sagemaker.{region}.amazonaws.com"
	    },
	    "fips.models.lex": {
	      "endpoint": "models-fips.lex.{region}.amazonaws.com"
	    },
	    "fips.runtime.lex": {
	      "endpoint": "runtime-fips.lex.{region}.amazonaws.com"
	    },
	    "fipsWithServiceOnly": {
	      "endpoint": "{service}.{region}.amazonaws.com"
	    },
	    "dualstackLegacy": {
	      "endpoint": "{service}.dualstack.{region}.amazonaws.com"
	    },
	    "dualstackLegacyCn": {
	      "endpoint": "{service}.dualstack.{region}.amazonaws.com.cn"
	    },
	    "dualstackFipsLegacy": {
	      "endpoint": "{service}-fips.dualstack.{region}.amazonaws.com"
	    },
	    "dualstackFipsLegacyCn": {
	      "endpoint": "{service}-fips.dualstack.{region}.amazonaws.com.cn"
	    },
	    "dualstackLegacyEc2": {
	      "endpoint": "api.ec2.{region}.aws"
	    }
	  }
	}
	
	},{}],388:[function(require,module,exports){
	(function (process){(function (){
	var AWS = require('./core');
	var AcceptorStateMachine = require('./state_machine');
	var inherit = AWS.util.inherit;
	var domain = AWS.util.domain;
	var jmespath = require('jmespath');
	
	/**
	 * @api private
	 */
	var hardErrorStates = {success: 1, error: 1, complete: 1};
	
	function isTerminalState(machine) {
	  return Object.prototype.hasOwnProperty.call(hardErrorStates, machine._asm.currentState);
	}
	
	var fsm = new AcceptorStateMachine();
	fsm.setupStates = function() {
	  var transition = function(_, done) {
	    var self = this;
	    self._haltHandlersOnError = false;
	
	    self.emit(self._asm.currentState, function(err) {
	      if (err) {
	        if (isTerminalState(self)) {
	          if (domain && self.domain instanceof domain.Domain) {
	            err.domainEmitter = self;
	            err.domain = self.domain;
	            err.domainThrown = false;
	            self.domain.emit('error', err);
	          } else {
	            throw err;
	          }
	        } else {
	          self.response.error = err;
	          done(err);
	        }
	      } else {
	        done(self.response.error);
	      }
	    });
	
	  };
	
	  this.addState('validate', 'build', 'error', transition);
	  this.addState('build', 'afterBuild', 'restart', transition);
	  this.addState('afterBuild', 'sign', 'restart', transition);
	  this.addState('sign', 'send', 'retry', transition);
	  this.addState('retry', 'afterRetry', 'afterRetry', transition);
	  this.addState('afterRetry', 'sign', 'error', transition);
	  this.addState('send', 'validateResponse', 'retry', transition);
	  this.addState('validateResponse', 'extractData', 'extractError', transition);
	  this.addState('extractError', 'extractData', 'retry', transition);
	  this.addState('extractData', 'success', 'retry', transition);
	  this.addState('restart', 'build', 'error', transition);
	  this.addState('success', 'complete', 'complete', transition);
	  this.addState('error', 'complete', 'complete', transition);
	  this.addState('complete', null, null, transition);
	};
	fsm.setupStates();
	
	/**
	 * ## Asynchronous Requests
	 *
	 * All requests made through the SDK are asynchronous and use a
	 * callback interface. Each service method that kicks off a request
	 * returns an `AWS.Request` object that you can use to register
	 * callbacks.
	 *
	 * For example, the following service method returns the request
	 * object as "request", which can be used to register callbacks:
	 *
	 * ```javascript
	 * // request is an AWS.Request object
	 * var request = ec2.describeInstances();
	 *
	 * // register callbacks on request to retrieve response data
	 * request.on('success', function(response) {
	 *   console.log(response.data);
	 * });
	 * ```
	 *
	 * When a request is ready to be sent, the {send} method should
	 * be called:
	 *
	 * ```javascript
	 * request.send();
	 * ```
	 *
	 * Since registered callbacks may or may not be idempotent, requests should only
	 * be sent once. To perform the same operation multiple times, you will need to
	 * create multiple request objects, each with its own registered callbacks.
	 *
	 * ## Removing Default Listeners for Events
	 *
	 * Request objects are built with default listeners for the various events,
	 * depending on the service type. In some cases, you may want to remove
	 * some built-in listeners to customize behaviour. Doing this requires
	 * access to the built-in listener functions, which are exposed through
	 * the {AWS.EventListeners.Core} namespace. For instance, you may
	 * want to customize the HTTP handler used when sending a request. In this
	 * case, you can remove the built-in listener associated with the 'send'
	 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
	 *
	 * ## Multiple Callbacks and Chaining
	 *
	 * You can register multiple callbacks on any request object. The
	 * callbacks can be registered for different events, or all for the
	 * same event. In addition, you can chain callback registration, for
	 * example:
	 *
	 * ```javascript
	 * request.
	 *   on('success', function(response) {
	 *     console.log("Success!");
	 *   }).
	 *   on('error', function(error, response) {
	 *     console.log("Error!");
	 *   }).
	 *   on('complete', function(response) {
	 *     console.log("Always!");
	 *   }).
	 *   send();
	 * ```
	 *
	 * The above example will print either "Success! Always!", or "Error! Always!",
	 * depending on whether the request succeeded or not.
	 *
	 * @!attribute httpRequest
	 *   @readonly
	 *   @!group HTTP Properties
	 *   @return [AWS.HttpRequest] the raw HTTP request object
	 *     containing request headers and body information
	 *     sent by the service.
	 *
	 * @!attribute startTime
	 *   @readonly
	 *   @!group Operation Properties
	 *   @return [Date] the time that the request started
	 *
	 * @!group Request Building Events
	 *
	 * @!event validate(request)
	 *   Triggered when a request is being validated. Listeners
	 *   should throw an error if the request should not be sent.
	 *   @param request [Request] the request object being sent
	 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
	 *   @see AWS.EventListeners.Core.VALIDATE_REGION
	 *   @example Ensuring that a certain parameter is set before sending a request
	 *     var req = s3.putObject(params);
	 *     req.on('validate', function() {
	 *       if (!req.params.Body.match(/^Hello\s/)) {
	 *         throw new Error('Body must start with "Hello "');
	 *       }
	 *     });
	 *     req.send(function(err, data) { ... });
	 *
	 * @!event build(request)
	 *   Triggered when the request payload is being built. Listeners
	 *   should fill the necessary information to send the request
	 *   over HTTP.
	 *   @param (see AWS.Request~validate)
	 *   @example Add a custom HTTP header to a request
	 *     var req = s3.putObject(params);
	 *     req.on('build', function() {
	 *       req.httpRequest.headers['Custom-Header'] = 'value';
	 *     });
	 *     req.send(function(err, data) { ... });
	 *
	 * @!event sign(request)
	 *   Triggered when the request is being signed. Listeners should
	 *   add the correct authentication headers and/or adjust the body,
	 *   depending on the authentication mechanism being used.
	 *   @param (see AWS.Request~validate)
	 *
	 * @!group Request Sending Events
	 *
	 * @!event send(response)
	 *   Triggered when the request is ready to be sent. Listeners
	 *   should call the underlying transport layer to initiate
	 *   the sending of the request.
	 *   @param response [Response] the response object
	 *   @context [Request] the request object that was sent
	 *   @see AWS.EventListeners.Core.SEND
	 *
	 * @!event retry(response)
	 *   Triggered when a request failed and might need to be retried or redirected.
	 *   If the response is retryable, the listener should set the
	 *   `response.error.retryable` property to `true`, and optionally set
	 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
	 *   In the case of a redirect, `response.error.redirect` should be set to
	 *   `true` with `retryDelay` set to an optional delay on the next request.
	 *
	 *   If a listener decides that a request should not be retried,
	 *   it should set both `retryable` and `redirect` to false.
	 *
	 *   Note that a retryable error will be retried at most
	 *   {AWS.Config.maxRetries} times (based on the service object's config).
	 *   Similarly, a request that is redirected will only redirect at most
	 *   {AWS.Config.maxRedirects} times.
	 *
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @example Adding a custom retry for a 404 response
	 *     request.on('retry', function(response) {
	 *       // this resource is not yet available, wait 10 seconds to get it again
	 *       if (response.httpResponse.statusCode === 404 && response.error) {
	 *         response.error.retryable = true;   // retry this error
	 *         response.error.retryDelay = 10000; // wait 10 seconds
	 *       }
	 *     });
	 *
	 * @!group Data Parsing Events
	 *
	 * @!event extractError(response)
	 *   Triggered on all non-2xx requests so that listeners can extract
	 *   error details from the response body. Listeners to this event
	 *   should set the `response.error` property.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event extractData(response)
	 *   Triggered in successful requests to allow listeners to
	 *   de-serialize the response body into `response.data`.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!group Completion Events
	 *
	 * @!event success(response)
	 *   Triggered when the request completed successfully.
	 *   `response.data` will contain the response data and
	 *   `response.error` will be null.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event error(error, response)
	 *   Triggered when an error occurs at any point during the
	 *   request. `response.error` will contain details about the error
	 *   that occurred. `response.data` will be null.
	 *   @param error [Error] the error object containing details about
	 *     the error that occurred.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event complete(response)
	 *   Triggered whenever a request cycle completes. `response.error`
	 *   should be checked, since the request may have failed.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!group HTTP Events
	 *
	 * @!event httpHeaders(statusCode, headers, response, statusMessage)
	 *   Triggered when headers are sent by the remote server
	 *   @param statusCode [Integer] the HTTP response code
	 *   @param headers [map<String,String>] the response headers
	 *   @param (see AWS.Request~send)
	 *   @param statusMessage [String] A status message corresponding to the HTTP
	 *                                 response code
	 *   @context (see AWS.Request~send)
	 *
	 * @!event httpData(chunk, response)
	 *   Triggered when data is sent by the remote server
	 *   @param chunk [Buffer] the buffer data containing the next data chunk
	 *     from the server
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @see AWS.EventListeners.Core.HTTP_DATA
	 *
	 * @!event httpUploadProgress(progress, response)
	 *   Triggered when the HTTP request has uploaded more data
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *
	 * @!event httpDownloadProgress(progress, response)
	 *   Triggered when the HTTP request has downloaded more data
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *
	 * @!event httpError(error, response)
	 *   Triggered when the HTTP request failed
	 *   @param error [Error] the error object that was thrown
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event httpDone(response)
	 *   Triggered when the server is finished sending data
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @see AWS.Response
	 */
	AWS.Request = inherit({
	
	  /**
	   * Creates a request for an operation on a given service with
	   * a set of input parameters.
	   *
	   * @param service [AWS.Service] the service to perform the operation on
	   * @param operation [String] the operation to perform on the service
	   * @param params [Object] parameters to send to the operation.
	   *   See the operation's documentation for the format of the
	   *   parameters.
	   */
	  constructor: function Request(service, operation, params) {
	    var endpoint = service.endpoint;
	    var region = service.config.region;
	    var customUserAgent = service.config.customUserAgent;
	
	    if (service.signingRegion) {
	      region = service.signingRegion;
	    } else if (service.isGlobalEndpoint) {
	      region = 'us-east-1';
	    }
	
	    this.domain = domain && domain.active;
	    this.service = service;
	    this.operation = operation;
	    this.params = params || {};
	    this.httpRequest = new AWS.HttpRequest(endpoint, region);
	    this.httpRequest.appendToUserAgent(customUserAgent);
	    this.startTime = service.getSkewCorrectedDate();
	
	    this.response = new AWS.Response(this);
	    this._asm = new AcceptorStateMachine(fsm.states, 'validate');
	    this._haltHandlersOnError = false;
	
	    AWS.SequentialExecutor.call(this);
	    this.emit = this.emitEvent;
	  },
	
	  /**
	   * @!group Sending a Request
	   */
	
	  /**
	   * @overload send(callback = null)
	   *   Sends the request object.
	   *
	   *   @callback callback function(err, data)
	   *     If a callback is supplied, it is called when a response is returned
	   *     from the service.
	   *     @context [AWS.Request] the request object being sent.
	   *     @param err [Error] the error object returned from the request.
	   *       Set to `null` if the request is successful.
	   *     @param data [Object] the de-serialized data returned from
	   *       the request. Set to `null` if a request error occurs.
	   *   @example Sending a request with a callback
	   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     request.send(function(err, data) { console.log(err, data); });
	   *   @example Sending a request with no callback (using event handlers)
	   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     request.on('complete', function(response) { ... }); // register a callback
	   *     request.send();
	   */
	  send: function send(callback) {
	    if (callback) {
	      // append to user agent
	      this.httpRequest.appendToUserAgent('callback');
	      this.on('complete', function (resp) {
	        callback.call(resp, resp.error, resp.data);
	      });
	    }
	    this.runTo();
	
	    return this.response;
	  },
	
	  /**
	   * @!method  promise()
	   *   Sends the request and returns a 'thenable' promise.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(data)
	   *     Called if the promise is fulfilled.
	   *     @param data [Object] the de-serialized data returned from the request.
	   *   @callback rejectedCallback function(error)
	   *     Called if the promise is rejected.
	   *     @param error [Error] the error object returned from the request.
	   *   @return [Promise] A promise that represents the state of the request.
	   *   @example Sending a request using promises.
	   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     var result = request.promise();
	   *     result.then(function(data) { ... }, function(error) { ... });
	   */
	
	  /**
	   * @api private
	   */
	  build: function build(callback) {
	    return this.runTo('send', callback);
	  },
	
	  /**
	   * @api private
	   */
	  runTo: function runTo(state, done) {
	    this._asm.runTo(state, done, this);
	    return this;
	  },
	
	  /**
	   * Aborts a request, emitting the error and complete events.
	   *
	   * @!macro nobrowser
	   * @example Aborting a request after sending
	   *   var params = {
	   *     Bucket: 'bucket', Key: 'key',
	   *     Body: Buffer.alloc(1024 * 1024 * 5) // 5MB payload
	   *   };
	   *   var request = s3.putObject(params);
	   *   request.send(function (err, data) {
	   *     if (err) console.log("Error:", err.code, err.message);
	   *     else console.log(data);
	   *   });
	   *
	   *   // abort request in 1 second
	   *   setTimeout(request.abort.bind(request), 1000);
	   *
	   *   // prints "Error: RequestAbortedError Request aborted by user"
	   * @return [AWS.Request] the same request object, for chaining.
	   * @since v1.4.0
	   */
	  abort: function abort() {
	    this.removeAllListeners('validateResponse');
	    this.removeAllListeners('extractError');
	    this.on('validateResponse', function addAbortedError(resp) {
	      resp.error = AWS.util.error(new Error('Request aborted by user'), {
	         code: 'RequestAbortedError', retryable: false
	      });
	    });
	
	    if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) { // abort HTTP stream
	      this.httpRequest.stream.abort();
	      if (this.httpRequest._abortCallback) {
	         this.httpRequest._abortCallback();
	      } else {
	        this.removeAllListeners('send'); // haven't sent yet, so let's not
	      }
	    }
	
	    return this;
	  },
	
	  /**
	   * Iterates over each page of results given a pageable request, calling
	   * the provided callback with each page of data. After all pages have been
	   * retrieved, the callback is called with `null` data.
	   *
	   * @note This operation can generate multiple requests to a service.
	   * @example Iterating over multiple pages of objects in an S3 bucket
	   *   var pages = 1;
	   *   s3.listObjects().eachPage(function(err, data) {
	   *     if (err) return;
	   *     console.log("Page", pages++);
	   *     console.log(data);
	   *   });
	   * @example Iterating over multiple pages with an asynchronous callback
	   *   s3.listObjects(params).eachPage(function(err, data, done) {
	   *     doSomethingAsyncAndOrExpensive(function() {
	   *       // The next page of results isn't fetched until done is called
	   *       done();
	   *     });
	   *   });
	   * @callback callback function(err, data, [doneCallback])
	   *   Called with each page of resulting data from the request. If the
	   *   optional `doneCallback` is provided in the function, it must be called
	   *   when the callback is complete.
	   *
	   *   @param err [Error] an error object, if an error occurred.
	   *   @param data [Object] a single page of response data. If there is no
	   *     more data, this object will be `null`.
	   *   @param doneCallback [Function] an optional done callback. If this
	   *     argument is defined in the function declaration, it should be called
	   *     when the next page is ready to be retrieved. This is useful for
	   *     controlling serial pagination across asynchronous operations.
	   *   @return [Boolean] if the callback returns `false`, pagination will
	   *     stop.
	   *
	   * @see AWS.Request.eachItem
	   * @see AWS.Response.nextPage
	   * @since v1.4.0
	   */
	  eachPage: function eachPage(callback) {
	    // Make all callbacks async-ish
	    callback = AWS.util.fn.makeAsync(callback, 3);
	
	    function wrappedCallback(response) {
	      callback.call(response, response.error, response.data, function (result) {
	        if (result === false) return;
	
	        if (response.hasNextPage()) {
	          response.nextPage().on('complete', wrappedCallback).send();
	        } else {
	          callback.call(response, null, null, AWS.util.fn.noop);
	        }
	      });
	    }
	
	    this.on('complete', wrappedCallback).send();
	  },
	
	  /**
	   * Enumerates over individual items of a request, paging the responses if
	   * necessary.
	   *
	   * @api experimental
	   * @since v1.4.0
	   */
	  eachItem: function eachItem(callback) {
	    var self = this;
	    function wrappedCallback(err, data) {
	      if (err) return callback(err, null);
	      if (data === null) return callback(null, null);
	
	      var config = self.service.paginationConfig(self.operation);
	      var resultKey = config.resultKey;
	      if (Array.isArray(resultKey)) resultKey = resultKey[0];
	      var items = jmespath.search(data, resultKey);
	      var continueIteration = true;
	      AWS.util.arrayEach(items, function(item) {
	        continueIteration = callback(null, item);
	        if (continueIteration === false) {
	          return AWS.util.abort;
	        }
	      });
	      return continueIteration;
	    }
	
	    this.eachPage(wrappedCallback);
	  },
	
	  /**
	   * @return [Boolean] whether the operation can return multiple pages of
	   *   response data.
	   * @see AWS.Response.eachPage
	   * @since v1.4.0
	   */
	  isPageable: function isPageable() {
	    return this.service.paginationConfig(this.operation) ? true : false;
	  },
	
	  /**
	   * Sends the request and converts the request object into a readable stream
	   * that can be read from or piped into a writable stream.
	   *
	   * @note The data read from a readable stream contains only
	   *   the raw HTTP body contents.
	   * @example Manually reading from a stream
	   *   request.createReadStream().on('data', function(data) {
	   *     console.log("Got data:", data.toString());
	   *   });
	   * @example Piping a request body into a file
	   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
	   *   s3.service.getObject(params).createReadStream().pipe(out);
	   * @return [Stream] the readable stream object that can be piped
	   *   or read from (by registering 'data' event listeners).
	   * @!macro nobrowser
	   */
	  createReadStream: function createReadStream() {
	    var streams = AWS.util.stream;
	    var req = this;
	    var stream = null;
	
	    if (AWS.HttpClient.streamsApiVersion === 2) {
	      stream = new streams.PassThrough();
	      process.nextTick(function() { req.send(); });
	    } else {
	      stream = new streams.Stream();
	      stream.readable = true;
	
	      stream.sent = false;
	      stream.on('newListener', function(event) {
	        if (!stream.sent && event === 'data') {
	          stream.sent = true;
	          process.nextTick(function() { req.send(); });
	        }
	      });
	    }
	
	    this.on('error', function(err) {
	      stream.emit('error', err);
	    });
	
	    this.on('httpHeaders', function streamHeaders(statusCode, headers, resp) {
	      if (statusCode < 300) {
	        req.removeListener('httpData', AWS.EventListeners.Core.HTTP_DATA);
	        req.removeListener('httpError', AWS.EventListeners.Core.HTTP_ERROR);
	        req.on('httpError', function streamHttpError(error) {
	          resp.error = error;
	          resp.error.retryable = false;
	        });
	
	        var shouldCheckContentLength = false;
	        var expectedLen;
	        if (req.httpRequest.method !== 'HEAD') {
	          expectedLen = parseInt(headers['content-length'], 10);
	        }
	        if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
	          shouldCheckContentLength = true;
	          var receivedLen = 0;
	        }
	
	        var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
	          if (shouldCheckContentLength && receivedLen !== expectedLen) {
	            stream.emit('error', AWS.util.error(
	              new Error('Stream content length mismatch. Received ' +
	                receivedLen + ' of ' + expectedLen + ' bytes.'),
	              { code: 'StreamContentLengthMismatch' }
	            ));
	          } else if (AWS.HttpClient.streamsApiVersion === 2) {
	            stream.end();
	          } else {
	            stream.emit('end');
	          }
	        };
	
	        var httpStream = resp.httpResponse.createUnbufferedStream();
	
	        if (AWS.HttpClient.streamsApiVersion === 2) {
	          if (shouldCheckContentLength) {
	            var lengthAccumulator = new streams.PassThrough();
	            lengthAccumulator._write = function(chunk) {
	              if (chunk && chunk.length) {
	                receivedLen += chunk.length;
	              }
	              return streams.PassThrough.prototype._write.apply(this, arguments);
	            };
	
	            lengthAccumulator.on('end', checkContentLengthAndEmit);
	            stream.on('error', function(err) {
	              shouldCheckContentLength = false;
	              httpStream.unpipe(lengthAccumulator);
	              lengthAccumulator.emit('end');
	              lengthAccumulator.end();
	            });
	            httpStream.pipe(lengthAccumulator).pipe(stream, { end: false });
	          } else {
	            httpStream.pipe(stream);
	          }
	        } else {
	
	          if (shouldCheckContentLength) {
	            httpStream.on('data', function(arg) {
	              if (arg && arg.length) {
	                receivedLen += arg.length;
	              }
	            });
	          }
	
	          httpStream.on('data', function(arg) {
	            stream.emit('data', arg);
	          });
	          httpStream.on('end', checkContentLengthAndEmit);
	        }
	
	        httpStream.on('error', function(err) {
	          shouldCheckContentLength = false;
	          stream.emit('error', err);
	        });
	      }
	    });
	
	    return stream;
	  },
	
	  /**
	   * @param [Array,Response] args This should be the response object,
	   *   or an array of args to send to the event.
	   * @api private
	   */
	  emitEvent: function emit(eventName, args, done) {
	    if (typeof args === 'function') { done = args; args = null; }
	    if (!done) done = function() { };
	    if (!args) args = this.eventParameters(eventName, this.response);
	
	    var origEmit = AWS.SequentialExecutor.prototype.emit;
	    origEmit.call(this, eventName, args, function (err) {
	      if (err) this.response.error = err;
	      done.call(this, err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  eventParameters: function eventParameters(eventName) {
	    switch (eventName) {
	      case 'restart':
	      case 'validate':
	      case 'sign':
	      case 'build':
	      case 'afterValidate':
	      case 'afterBuild':
	        return [this];
	      case 'error':
	        return [this.response.error, this.response];
	      default:
	        return [this.response];
	    }
	  },
	
	  /**
	   * @api private
	   */
	  presign: function presign(expires, callback) {
	    if (!callback && typeof expires === 'function') {
	      callback = expires;
	      expires = null;
	    }
	    return new AWS.Signers.Presign().sign(this.toGet(), expires, callback);
	  },
	
	  /**
	   * @api private
	   */
	  isPresigned: function isPresigned() {
	    return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, 'presigned-expires');
	  },
	
	  /**
	   * @api private
	   */
	  toUnauthenticated: function toUnauthenticated() {
	    this._unAuthenticated = true;
	    this.removeListener('validate', AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
	    this.removeListener('sign', AWS.EventListeners.Core.SIGN);
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  toGet: function toGet() {
	    if (this.service.api.protocol === 'query' ||
	        this.service.api.protocol === 'ec2') {
	      this.removeListener('build', this.buildAsGet);
	      this.addListener('build', this.buildAsGet);
	    }
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  buildAsGet: function buildAsGet(request) {
	    request.httpRequest.method = 'GET';
	    request.httpRequest.path = request.service.endpoint.path +
	                               '?' + request.httpRequest.body;
	    request.httpRequest.body = '';
	
	    // don't need these headers on a GET request
	    delete request.httpRequest.headers['Content-Length'];
	    delete request.httpRequest.headers['Content-Type'];
	  },
	
	  /**
	   * @api private
	   */
	  haltHandlersOnError: function haltHandlersOnError() {
	    this._haltHandlersOnError = true;
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.promise = function promise() {
	    var self = this;
	    // append to user agent
	    this.httpRequest.appendToUserAgent('promise');
	    return new PromiseDependency(function(resolve, reject) {
	      self.on('complete', function(resp) {
	        if (resp.error) {
	          reject(resp.error);
	        } else {
	          // define $response property so that it is not enumerable
	          // this prevents circular reference errors when stringifying the JSON object
	          resolve(Object.defineProperty(
	            resp.data || {},
	            '$response',
	            {value: resp}
	          ));
	        }
	      });
	      self.runTo();
	    });
	  };
	};
	
	/**
	 * @api private
	 */
	AWS.Request.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.promise;
	};
	
	AWS.util.addPromises(AWS.Request);
	
	AWS.util.mixin(AWS.Request, AWS.SequentialExecutor);
	
	}).call(this)}).call(this,require('_process'))
	},{"./core":342,"./state_machine":417,"_process":432,"jmespath":431}],389:[function(require,module,exports){
	/**
	 * Copyright 2012-2013 Amazon.com, Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"). You
	 * may not use this file except in compliance with the License. A copy of
	 * the License is located at
	 *
	 *     http://aws.amazon.com/apache2.0/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific
	 * language governing permissions and limitations under the License.
	 */
	
	var AWS = require('./core');
	var inherit = AWS.util.inherit;
	var jmespath = require('jmespath');
	
	/**
	 * @api private
	 */
	function CHECK_ACCEPTORS(resp) {
	  var waiter = resp.request._waiter;
	  var acceptors = waiter.config.acceptors;
	  var acceptorMatched = false;
	  var state = 'retry';
	
	  acceptors.forEach(function(acceptor) {
	    if (!acceptorMatched) {
	      var matcher = waiter.matchers[acceptor.matcher];
	      if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
	        acceptorMatched = true;
	        state = acceptor.state;
	      }
	    }
	  });
	
	  if (!acceptorMatched && resp.error) state = 'failure';
	
	  if (state === 'success') {
	    waiter.setSuccess(resp);
	  } else {
	    waiter.setError(resp, state === 'retry');
	  }
	}
	
	/**
	 * @api private
	 */
	AWS.ResourceWaiter = inherit({
	  /**
	   * Waits for a given state on a service object
	   * @param service [Service] the service object to wait on
	   * @param state [String] the state (defined in waiter configuration) to wait
	   *   for.
	   * @example Create a waiter for running EC2 instances
	   *   var ec2 = new AWS.EC2;
	   *   var waiter = new AWS.ResourceWaiter(ec2, 'instanceRunning');
	   */
	  constructor: function constructor(service, state) {
	    this.service = service;
	    this.state = state;
	    this.loadWaiterConfig(this.state);
	  },
	
	  service: null,
	
	  state: null,
	
	  config: null,
	
	  matchers: {
	    path: function(resp, expected, argument) {
	      try {
	        var result = jmespath.search(resp.data, argument);
	      } catch (err) {
	        return false;
	      }
	
	      return jmespath.strictDeepEqual(result,expected);
	    },
	
	    pathAll: function(resp, expected, argument) {
	      try {
	        var results = jmespath.search(resp.data, argument);
	      } catch (err) {
	        return false;
	      }
	
	      if (!Array.isArray(results)) results = [results];
	      var numResults = results.length;
	      if (!numResults) return false;
	      for (var ind = 0 ; ind < numResults; ind++) {
	        if (!jmespath.strictDeepEqual(results[ind], expected)) {
	          return false;
	        }
	      }
	      return true;
	    },
	
	    pathAny: function(resp, expected, argument) {
	      try {
	        var results = jmespath.search(resp.data, argument);
	      } catch (err) {
	        return false;
	      }
	
	      if (!Array.isArray(results)) results = [results];
	      var numResults = results.length;
	      for (var ind = 0 ; ind < numResults; ind++) {
	        if (jmespath.strictDeepEqual(results[ind], expected)) {
	          return true;
	        }
	      }
	      return false;
	    },
	
	    status: function(resp, expected) {
	      var statusCode = resp.httpResponse.statusCode;
	      return (typeof statusCode === 'number') && (statusCode === expected);
	    },
	
	    error: function(resp, expected) {
	      if (typeof expected === 'string' && resp.error) {
	        return expected === resp.error.code;
	      }
	      // if expected is not string, can be boolean indicating presence of error
	      return expected === !!resp.error;
	    }
	  },
	
	  listeners: new AWS.SequentialExecutor().addNamedListeners(function(add) {
	    add('RETRY_CHECK', 'retry', function(resp) {
	      var waiter = resp.request._waiter;
	      if (resp.error && resp.error.code === 'ResourceNotReady') {
	        resp.error.retryDelay = (waiter.config.delay || 0) * 1000;
	      }
	    });
	
	    add('CHECK_OUTPUT', 'extractData', CHECK_ACCEPTORS);
	
	    add('CHECK_ERROR', 'extractError', CHECK_ACCEPTORS);
	  }),
	
	  /**
	   * @return [AWS.Request]
	   */
	  wait: function wait(params, callback) {
	    if (typeof params === 'function') {
	      callback = params; params = undefined;
	    }
	
	    if (params && params.$waiter) {
	      params = AWS.util.copy(params);
	      if (typeof params.$waiter.delay === 'number') {
	        this.config.delay = params.$waiter.delay;
	      }
	      if (typeof params.$waiter.maxAttempts === 'number') {
	        this.config.maxAttempts = params.$waiter.maxAttempts;
	      }
	      delete params.$waiter;
	    }
	
	    var request = this.service.makeRequest(this.config.operation, params);
	    request._waiter = this;
	    request.response.maxRetries = this.config.maxAttempts;
	    request.addListeners(this.listeners);
	
	    if (callback) request.send(callback);
	    return request;
	  },
	
	  setSuccess: function setSuccess(resp) {
	    resp.error = null;
	    resp.data = resp.data || {};
	    resp.request.removeAllListeners('extractData');
	  },
	
	  setError: function setError(resp, retryable) {
	    resp.data = null;
	    resp.error = AWS.util.error(resp.error || new Error(), {
	      code: 'ResourceNotReady',
	      message: 'Resource is not in the state ' + this.state,
	      retryable: retryable
	    });
	  },
	
	  /**
	   * Loads waiter configuration from API configuration
	   *
	   * @api private
	   */
	  loadWaiterConfig: function loadWaiterConfig(state) {
	    if (!this.service.api.waiters[state]) {
	      throw new AWS.util.error(new Error(), {
	        code: 'StateNotFoundError',
	        message: 'State ' + state + ' not found.'
	      });
	    }
	
	    this.config = AWS.util.copy(this.service.api.waiters[state]);
	  }
	});
	
	},{"./core":342,"jmespath":431}],390:[function(require,module,exports){
	var AWS = require('./core');
	var inherit = AWS.util.inherit;
	var jmespath = require('jmespath');
	
	/**
	 * This class encapsulates the response information
	 * from a service request operation sent through {AWS.Request}.
	 * The response object has two main properties for getting information
	 * back from a request:
	 *
	 * ## The `data` property
	 *
	 * The `response.data` property contains the serialized object data
	 * retrieved from the service request. For instance, for an
	 * Amazon DynamoDB `listTables` method call, the response data might
	 * look like:
	 *
	 * ```
	 * > resp.data
	 * { TableNames:
	 *    [ 'table1', 'table2', ... ] }
	 * ```
	 *
	 * The `data` property can be null if an error occurs (see below).
	 *
	 * ## The `error` property
	 *
	 * In the event of a service error (or transfer error), the
	 * `response.error` property will be filled with the given
	 * error data in the form:
	 *
	 * ```
	 * { code: 'SHORT_UNIQUE_ERROR_CODE',
	 *   message: 'Some human readable error message' }
	 * ```
	 *
	 * In the case of an error, the `data` property will be `null`.
	 * Note that if you handle events that can be in a failure state,
	 * you should always check whether `response.error` is set
	 * before attempting to access the `response.data` property.
	 *
	 * @!attribute data
	 *   @readonly
	 *   @!group Data Properties
	 *   @note Inside of a {AWS.Request~httpData} event, this
	 *     property contains a single raw packet instead of the
	 *     full de-serialized service response.
	 *   @return [Object] the de-serialized response data
	 *     from the service.
	 *
	 * @!attribute error
	 *   An structure containing information about a service
	 *   or networking error.
	 *   @readonly
	 *   @!group Data Properties
	 *   @note This attribute is only filled if a service or
	 *     networking error occurs.
	 *   @return [Error]
	 *     * code [String] a unique short code representing the
	 *       error that was emitted.
	 *     * message [String] a longer human readable error message
	 *     * retryable [Boolean] whether the error message is
	 *       retryable.
	 *     * statusCode [Numeric] in the case of a request that reached the service,
	 *       this value contains the response status code.
	 *     * time [Date] the date time object when the error occurred.
	 *     * hostname [String] set when a networking error occurs to easily
	 *       identify the endpoint of the request.
	 *     * region [String] set when a networking error occurs to easily
	 *       identify the region of the request.
	 *
	 * @!attribute requestId
	 *   @readonly
	 *   @!group Data Properties
	 *   @return [String] the unique request ID associated with the response.
	 *     Log this value when debugging requests for AWS support.
	 *
	 * @!attribute retryCount
	 *   @readonly
	 *   @!group Operation Properties
	 *   @return [Integer] the number of retries that were
	 *     attempted before the request was completed.
	 *
	 * @!attribute redirectCount
	 *   @readonly
	 *   @!group Operation Properties
	 *   @return [Integer] the number of redirects that were
	 *     followed before the request was completed.
	 *
	 * @!attribute httpResponse
	 *   @readonly
	 *   @!group HTTP Properties
	 *   @return [AWS.HttpResponse] the raw HTTP response object
	 *     containing the response headers and body information
	 *     from the server.
	 *
	 * @see AWS.Request
	 */
	AWS.Response = inherit({
	
	  /**
	   * @api private
	   */
	  constructor: function Response(request) {
	    this.request = request;
	    this.data = null;
	    this.error = null;
	    this.retryCount = 0;
	    this.redirectCount = 0;
	    this.httpResponse = new AWS.HttpResponse();
	    if (request) {
	      this.maxRetries = request.service.numRetries();
	      this.maxRedirects = request.service.config.maxRedirects;
	    }
	  },
	
	  /**
	   * Creates a new request for the next page of response data, calling the
	   * callback with the page data if a callback is provided.
	   *
	   * @callback callback function(err, data)
	   *   Called when a page of data is returned from the next request.
	   *
	   *   @param err [Error] an error object, if an error occurred in the request
	   *   @param data [Object] the next page of data, or null, if there are no
	   *     more pages left.
	   * @return [AWS.Request] the request object for the next page of data
	   * @return [null] if no callback is provided and there are no pages left
	   *   to retrieve.
	   * @since v1.4.0
	   */
	  nextPage: function nextPage(callback) {
	    var config;
	    var service = this.request.service;
	    var operation = this.request.operation;
	    try {
	      config = service.paginationConfig(operation, true);
	    } catch (e) { this.error = e; }
	
	    if (!this.hasNextPage()) {
	      if (callback) callback(this.error, null);
	      else if (this.error) throw this.error;
	      return null;
	    }
	
	    var params = AWS.util.copy(this.request.params);
	    if (!this.nextPageTokens) {
	      return callback ? callback(null, null) : null;
	    } else {
	      var inputTokens = config.inputToken;
	      if (typeof inputTokens === 'string') inputTokens = [inputTokens];
	      for (var i = 0; i < inputTokens.length; i++) {
	        params[inputTokens[i]] = this.nextPageTokens[i];
	      }
	      return service.makeRequest(this.request.operation, params, callback);
	    }
	  },
	
	  /**
	   * @return [Boolean] whether more pages of data can be returned by further
	   *   requests
	   * @since v1.4.0
	   */
	  hasNextPage: function hasNextPage() {
	    this.cacheNextPageTokens();
	    if (this.nextPageTokens) return true;
	    if (this.nextPageTokens === undefined) return undefined;
	    else return false;
	  },
	
	  /**
	   * @api private
	   */
	  cacheNextPageTokens: function cacheNextPageTokens() {
	    if (Object.prototype.hasOwnProperty.call(this, 'nextPageTokens')) return this.nextPageTokens;
	    this.nextPageTokens = undefined;
	
	    var config = this.request.service.paginationConfig(this.request.operation);
	    if (!config) return this.nextPageTokens;
	
	    this.nextPageTokens = null;
	    if (config.moreResults) {
	      if (!jmespath.search(this.data, config.moreResults)) {
	        return this.nextPageTokens;
	      }
	    }
	
	    var exprs = config.outputToken;
	    if (typeof exprs === 'string') exprs = [exprs];
	    AWS.util.arrayEach.call(this, exprs, function (expr) {
	      var output = jmespath.search(this.data, expr);
	      if (output) {
	        this.nextPageTokens = this.nextPageTokens || [];
	        this.nextPageTokens.push(output);
	      }
	    });
	
	    return this.nextPageTokens;
	  }
	
	});
	
	},{"./core":342,"jmespath":431}],391:[function(require,module,exports){
	var AWS = require('../core');
	var byteLength = AWS.util.string.byteLength;
	var Buffer = AWS.util.Buffer;
	
	/**
	 * The managed uploader allows for easy and efficient uploading of buffers,
	 * blobs, or streams, using a configurable amount of concurrency to perform
	 * multipart uploads where possible. This abstraction also enables uploading
	 * streams of unknown size due to the use of multipart uploads.
	 *
	 * To construct a managed upload object, see the {constructor} function.
	 *
	 * ## Tracking upload progress
	 *
	 * The managed upload object can also track progress by attaching an
	 * 'httpUploadProgress' listener to the upload manager. This event is similar
	 * to {AWS.Request~httpUploadProgress} but groups all concurrent upload progress
	 * into a single event. See {AWS.S3.ManagedUpload~httpUploadProgress} for more
	 * information.
	 *
	 * ## Handling Multipart Cleanup
	 *
	 * By default, this class will automatically clean up any multipart uploads
	 * when an individual part upload fails. This behavior can be disabled in order
	 * to manually handle failures by setting the `leavePartsOnError` configuration
	 * option to `true` when initializing the upload object.
	 *
	 * @!event httpUploadProgress(progress)
	 *   Triggered when the uploader has uploaded more data.
	 *   @note The `total` property may not be set if the stream being uploaded has
	 *     not yet finished chunking. In this case the `total` will be undefined
	 *     until the total stream size is known.
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request and the `key` of the S3 object. Note that `total` may be undefined until the payload
	 *     size is known.
	 *   @context (see AWS.Request~send)
	 */
	AWS.S3.ManagedUpload = AWS.util.inherit({
	  /**
	   * Creates a managed upload object with a set of configuration options.
	   *
	   * @note A "Body" parameter is required to be set prior to calling {send}.
	   * @note In Node.js, sending "Body" as {https://nodejs.org/dist/latest/docs/api/stream.html#stream_object_mode object-mode stream}
	   *   may result in upload hangs. Using buffer stream is preferable.
	   * @option options params [map] a map of parameters to pass to the upload
	   *   requests. The "Body" parameter is required to be specified either on
	   *   the service or in the params option.
	   * @note ContentMD5 should not be provided when using the managed upload object.
	   *   Instead, setting "computeChecksums" to true will enable automatic ContentMD5 generation
	   *   by the managed upload object.
	   * @option options queueSize [Number] (4) the size of the concurrent queue
	   *   manager to upload parts in parallel. Set to 1 for synchronous uploading
	   *   of parts. Note that the uploader will buffer at most queueSize * partSize
	   *   bytes into memory at any given time.
	   * @option options partSize [Number] (5mb) the size in bytes for each
	   *   individual part to be uploaded. Adjust the part size to ensure the number
	   *   of parts does not exceed {maxTotalParts}. See {minPartSize} for the
	   *   minimum allowed part size.
	   * @option options leavePartsOnError [Boolean] (false) whether to abort the
	   *   multipart upload if an error occurs. Set to true if you want to handle
	   *   failures manually.
	   * @option options service [AWS.S3] an optional S3 service object to use for
	   *   requests. This object might have bound parameters used by the uploader.
	   * @option options tags [Array<map>] The tags to apply to the uploaded object.
	   *   Each tag should have a `Key` and `Value` keys.
	   * @example Creating a default uploader for a stream object
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
	   *   });
	   * @example Creating an uploader with concurrency of 1 and partSize of 10mb
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     partSize: 10 * 1024 * 1024, queueSize: 1,
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
	   *   });
	   * @example Creating an uploader with tags
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream},
	   *     tags: [{Key: 'tag1', Value: 'value1'}, {Key: 'tag2', Value: 'value2'}]
	   *   });
	   * @see send
	   */
	  constructor: function ManagedUpload(options) {
	    var self = this;
	    AWS.SequentialExecutor.call(self);
	    self.body = null;
	    self.sliceFn = null;
	    self.callback = null;
	    self.parts = {};
	    self.completeInfo = [];
	    self.fillQueue = function() {
	      self.callback(new Error('Unsupported body payload ' + typeof self.body));
	    };
	
	    self.configure(options);
	  },
	
	  /**
	   * @api private
	   */
	  configure: function configure(options) {
	    options = options || {};
	    this.partSize = this.minPartSize;
	
	    if (options.queueSize) this.queueSize = options.queueSize;
	    if (options.partSize) this.partSize = options.partSize;
	    if (options.leavePartsOnError) this.leavePartsOnError = true;
	    if (options.tags) {
	      if (!Array.isArray(options.tags)) {
	        throw new Error('Tags must be specified as an array; ' +
	          typeof options.tags + ' provided.');
	      }
	      this.tags = options.tags;
	    }
	
	    if (this.partSize < this.minPartSize) {
	      throw new Error('partSize must be greater than ' +
	                      this.minPartSize);
	    }
	
	    this.service = options.service;
	    this.bindServiceObject(options.params);
	    this.validateBody();
	    this.adjustTotalBytes();
	  },
	
	  /**
	   * @api private
	   */
	  leavePartsOnError: false,
	
	  /**
	   * @api private
	   */
	  queueSize: 4,
	
	  /**
	   * @api private
	   */
	  partSize: null,
	
	  /**
	   * @readonly
	   * @return [Number] the minimum number of bytes for an individual part
	   *   upload.
	   */
	  minPartSize: 1024 * 1024 * 5,
	
	  /**
	   * @readonly
	   * @return [Number] the maximum allowed number of parts in a multipart upload.
	   */
	  maxTotalParts: 10000,
	
	  /**
	   * Initiates the managed upload for the payload.
	   *
	   * @callback callback function(err, data)
	   *   @param err [Error] an error or null if no error occurred.
	   *   @param data [map] The response data from the successful upload:
	   *     * `Location` (String) the URL of the uploaded object
	   *     * `ETag` (String) the ETag of the uploaded object
	   *     * `Bucket` (String) the bucket to which the object was uploaded
	   *     * `Key` (String) the key to which the object was uploaded
	   * @example Sending a managed upload object
	   *   var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *   var upload = new AWS.S3.ManagedUpload({params: params});
	   *   upload.send(function(err, data) {
	   *     console.log(err, data);
	   *   });
	   */
	  send: function(callback) {
	    var self = this;
	    self.failed = false;
	    self.callback = callback || function(err) { if (err) throw err; };
	
	    var runFill = true;
	    if (self.sliceFn) {
	      self.fillQueue = self.fillBuffer;
	    } else if (AWS.util.isNode()) {
	      var Stream = AWS.util.stream.Stream;
	      if (self.body instanceof Stream) {
	        runFill = false;
	        self.fillQueue = self.fillStream;
	        self.partBuffers = [];
	        self.body.
	          on('error', function(err) { self.cleanup(err); }).
	          on('readable', function() { self.fillQueue(); }).
	          on('end', function() {
	            self.isDoneChunking = true;
	            self.numParts = self.totalPartNumbers;
	            self.fillQueue.call(self);
	
	            if (self.isDoneChunking && self.totalPartNumbers >= 1 && self.doneParts === self.numParts) {
	              self.finishMultiPart();
	            }
	          });
	      }
	    }
	
	    if (runFill) self.fillQueue.call(self);
	  },
	
	  /**
	   * @!method  promise()
	   *   Returns a 'thenable' promise.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(data)
	   *     Called if the promise is fulfilled.
	   *     @param data [map] The response data from the successful upload:
	   *       `Location` (String) the URL of the uploaded object
	   *       `ETag` (String) the ETag of the uploaded object
	   *       `Bucket` (String) the bucket to which the object was uploaded
	   *       `Key` (String) the key to which the object was uploaded
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] an error or null if no error occurred.
	   *   @return [Promise] A promise that represents the state of the upload request.
	   *   @example Sending an upload request using promises.
	   *     var upload = s3.upload({Bucket: 'bucket', Key: 'key', Body: stream});
	   *     var promise = upload.promise();
	   *     promise.then(function(data) { ... }, function(err) { ... });
	   */
	
	  /**
	   * Aborts a managed upload, including all concurrent upload requests.
	   * @note By default, calling this function will cleanup a multipart upload
	   *   if one was created. To leave the multipart upload around after aborting
	   *   a request, configure `leavePartsOnError` to `true` in the {constructor}.
	   * @note Calling {abort} in the browser environment will not abort any requests
	   *   that are already in flight. If a multipart upload was created, any parts
	   *   not yet uploaded will not be sent, and the multipart upload will be cleaned up.
	   * @example Aborting an upload
	   *   var params = {
	   *     Bucket: 'bucket', Key: 'key',
	   *     Body: Buffer.alloc(1024 * 1024 * 25) // 25MB payload
	   *   };
	   *   var upload = s3.upload(params);
	   *   upload.send(function (err, data) {
	   *     if (err) console.log("Error:", err.code, err.message);
	   *     else console.log(data);
	   *   });
	   *
	   *   // abort request in 1 second
	   *   setTimeout(upload.abort.bind(upload), 1000);
	   */
	  abort: function() {
	    var self = this;
	    //abort putObject request
	    if (self.isDoneChunking === true && self.totalPartNumbers === 1 && self.singlePart) {
	      self.singlePart.abort();
	    } else {
	      self.cleanup(AWS.util.error(new Error('Request aborted by user'), {
	        code: 'RequestAbortedError', retryable: false
	      }));
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateBody: function validateBody() {
	    var self = this;
	    self.body = self.service.config.params.Body;
	    if (typeof self.body === 'string') {
	      self.body = AWS.util.buffer.toBuffer(self.body);
	    } else if (!self.body) {
	      throw new Error('params.Body is required');
	    }
	    self.sliceFn = AWS.util.arraySliceFn(self.body);
	  },
	
	  /**
	   * @api private
	   */
	  bindServiceObject: function bindServiceObject(params) {
	    params = params || {};
	    var self = this;
	    // bind parameters to new service object
	    if (!self.service) {
	      self.service = new AWS.S3({params: params});
	    } else {
	      // Create a new S3 client from the supplied client's constructor.
	      var service = self.service;
	      var config = AWS.util.copy(service.config);
	      config.signatureVersion = service.getSignatureVersion();
	      self.service = new service.constructor.__super__(config);
	      self.service.config.params =
	        AWS.util.merge(self.service.config.params || {}, params);
	      Object.defineProperty(self.service, '_originalConfig', {
	        get: function() { return service._originalConfig; },
	        enumerable: false,
	        configurable: true
	      });
	    }
	  },
	
	  /**
	   * @api private
	   */
	  adjustTotalBytes: function adjustTotalBytes() {
	    var self = this;
	    try { // try to get totalBytes
	      self.totalBytes = byteLength(self.body);
	    } catch (e) { }
	
	    // try to adjust partSize if we know payload length
	    if (self.totalBytes) {
	      var newPartSize = Math.ceil(self.totalBytes / self.maxTotalParts);
	      if (newPartSize > self.partSize) self.partSize = newPartSize;
	    } else {
	      self.totalBytes = undefined;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  isDoneChunking: false,
	
	  /**
	   * @api private
	   */
	  partPos: 0,
	
	  /**
	   * @api private
	   */
	  totalChunkedBytes: 0,
	
	  /**
	   * @api private
	   */
	  totalUploadedBytes: 0,
	
	  /**
	   * @api private
	   */
	  totalBytes: undefined,
	
	  /**
	   * @api private
	   */
	  numParts: 0,
	
	  /**
	   * @api private
	   */
	  totalPartNumbers: 0,
	
	  /**
	   * @api private
	   */
	  activeParts: 0,
	
	  /**
	   * @api private
	   */
	  doneParts: 0,
	
	  /**
	   * @api private
	   */
	  parts: null,
	
	  /**
	   * @api private
	   */
	  completeInfo: null,
	
	  /**
	   * @api private
	   */
	  failed: false,
	
	  /**
	   * @api private
	   */
	  multipartReq: null,
	
	  /**
	   * @api private
	   */
	  partBuffers: null,
	
	  /**
	   * @api private
	   */
	  partBufferLength: 0,
	
	  /**
	   * @api private
	   */
	  fillBuffer: function fillBuffer() {
	    var self = this;
	    var bodyLen = byteLength(self.body);
	
	    if (bodyLen === 0) {
	      self.isDoneChunking = true;
	      self.numParts = 1;
	      self.nextChunk(self.body);
	      return;
	    }
	
	    while (self.activeParts < self.queueSize && self.partPos < bodyLen) {
	      var endPos = Math.min(self.partPos + self.partSize, bodyLen);
	      var buf = self.sliceFn.call(self.body, self.partPos, endPos);
	      self.partPos += self.partSize;
	
	      if (byteLength(buf) < self.partSize || self.partPos === bodyLen) {
	        self.isDoneChunking = true;
	        self.numParts = self.totalPartNumbers + 1;
	      }
	      self.nextChunk(buf);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  fillStream: function fillStream() {
	    var self = this;
	    if (self.activeParts >= self.queueSize) return;
	
	    var buf = self.body.read(self.partSize - self.partBufferLength) ||
	              self.body.read();
	    if (buf) {
	      self.partBuffers.push(buf);
	      self.partBufferLength += buf.length;
	      self.totalChunkedBytes += buf.length;
	    }
	
	    if (self.partBufferLength >= self.partSize) {
	      // if we have single buffer we avoid copyfull concat
	      var pbuf = self.partBuffers.length === 1 ?
	        self.partBuffers[0] : Buffer.concat(self.partBuffers);
	      self.partBuffers = [];
	      self.partBufferLength = 0;
	
	      // if we have more than partSize, push the rest back on the queue
	      if (pbuf.length > self.partSize) {
	        var rest = pbuf.slice(self.partSize);
	        self.partBuffers.push(rest);
	        self.partBufferLength += rest.length;
	        pbuf = pbuf.slice(0, self.partSize);
	      }
	
	      self.nextChunk(pbuf);
	    }
	
	    if (self.isDoneChunking && !self.isDoneSending) {
	      // if we have single buffer we avoid copyfull concat
	      pbuf = self.partBuffers.length === 1 ?
	          self.partBuffers[0] : Buffer.concat(self.partBuffers);
	      self.partBuffers = [];
	      self.partBufferLength = 0;
	      self.totalBytes = self.totalChunkedBytes;
	      self.isDoneSending = true;
	
	      if (self.numParts === 0 || pbuf.length > 0) {
	        self.numParts++;
	        self.nextChunk(pbuf);
	      }
	    }
	
	    self.body.read(0);
	  },
	
	  /**
	   * @api private
	   */
	  nextChunk: function nextChunk(chunk) {
	    var self = this;
	    if (self.failed) return null;
	
	    var partNumber = ++self.totalPartNumbers;
	    if (self.isDoneChunking && partNumber === 1) {
	      var params = {Body: chunk};
	      if (this.tags) {
	        params.Tagging = this.getTaggingHeader();
	      }
	      var req = self.service.putObject(params);
	      req._managedUpload = self;
	      req.on('httpUploadProgress', self.progress).send(self.finishSinglePart);
	      self.singlePart = req; //save the single part request
	      return null;
	    } else if (self.service.config.params.ContentMD5) {
	      var err = AWS.util.error(new Error('The Content-MD5 you specified is invalid for multi-part uploads.'), {
	        code: 'InvalidDigest', retryable: false
	      });
	
	      self.cleanup(err);
	      return null;
	    }
	
	    if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) {
	      return null; // Already uploaded this part.
	    }
	
	    self.activeParts++;
	    if (!self.service.config.params.UploadId) {
	
	      if (!self.multipartReq) { // create multipart
	        self.multipartReq = self.service.createMultipartUpload();
	        self.multipartReq.on('success', function(resp) {
	          self.service.config.params.UploadId = resp.data.UploadId;
	          self.multipartReq = null;
	        });
	        self.queueChunks(chunk, partNumber);
	        self.multipartReq.on('error', function(err) {
	          self.cleanup(err);
	        });
	        self.multipartReq.send();
	      } else {
	        self.queueChunks(chunk, partNumber);
	      }
	    } else { // multipart is created, just send
	      self.uploadPart(chunk, partNumber);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getTaggingHeader: function getTaggingHeader() {
	    var kvPairStrings = [];
	    for (var i = 0; i < this.tags.length; i++) {
	      kvPairStrings.push(AWS.util.uriEscape(this.tags[i].Key) + '=' +
	        AWS.util.uriEscape(this.tags[i].Value));
	    }
	
	    return kvPairStrings.join('&');
	  },
	
	  /**
	   * @api private
	   */
	  uploadPart: function uploadPart(chunk, partNumber) {
	    var self = this;
	
	    var partParams = {
	      Body: chunk,
	      ContentLength: AWS.util.string.byteLength(chunk),
	      PartNumber: partNumber
	    };
	
	    var partInfo = {ETag: null, PartNumber: partNumber};
	    self.completeInfo[partNumber] = partInfo;
	
	    var req = self.service.uploadPart(partParams);
	    self.parts[partNumber] = req;
	    req._lastUploadedBytes = 0;
	    req._managedUpload = self;
	    req.on('httpUploadProgress', self.progress);
	    req.send(function(err, data) {
	      delete self.parts[partParams.PartNumber];
	      self.activeParts--;
	
	      if (!err && (!data || !data.ETag)) {
	        var message = 'No access to ETag property on response.';
	        if (AWS.util.isBrowser()) {
	          message += ' Check CORS configuration to expose ETag header.';
	        }
	
	        err = AWS.util.error(new Error(message), {
	          code: 'ETagMissing', retryable: false
	        });
	      }
	      if (err) return self.cleanup(err);
	      //prevent sending part being returned twice (https://github.com/aws/aws-sdk-js/issues/2304)
	      if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) return null;
	      partInfo.ETag = data.ETag;
	      self.doneParts++;
	      if (self.isDoneChunking && self.doneParts === self.numParts) {
	        self.finishMultiPart();
	      } else {
	        self.fillQueue.call(self);
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  queueChunks: function queueChunks(chunk, partNumber) {
	    var self = this;
	    self.multipartReq.on('success', function() {
	      self.uploadPart(chunk, partNumber);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  cleanup: function cleanup(err) {
	    var self = this;
	    if (self.failed) return;
	
	    // clean up stream
	    if (typeof self.body.removeAllListeners === 'function' &&
	        typeof self.body.resume === 'function') {
	      self.body.removeAllListeners('readable');
	      self.body.removeAllListeners('end');
	      self.body.resume();
	    }
	
	    // cleanup multipartReq listeners
	    if (self.multipartReq) {
	      self.multipartReq.removeAllListeners('success');
	      self.multipartReq.removeAllListeners('error');
	      self.multipartReq.removeAllListeners('complete');
	      delete self.multipartReq;
	    }
	
	    if (self.service.config.params.UploadId && !self.leavePartsOnError) {
	      self.service.abortMultipartUpload().send();
	    } else if (self.leavePartsOnError) {
	      self.isDoneChunking = false;
	    }
	
	    AWS.util.each(self.parts, function(partNumber, part) {
	      part.removeAllListeners('complete');
	      part.abort();
	    });
	
	    self.activeParts = 0;
	    self.partPos = 0;
	    self.numParts = 0;
	    self.totalPartNumbers = 0;
	    self.parts = {};
	    self.failed = true;
	    self.callback(err);
	  },
	
	  /**
	   * @api private
	   */
	  finishMultiPart: function finishMultiPart() {
	    var self = this;
	    var completeParams = { MultipartUpload: { Parts: self.completeInfo.slice(1) } };
	    self.service.completeMultipartUpload(completeParams, function(err, data) {
	      if (err) {
	        return self.cleanup(err);
	      }
	
	      if (data && typeof data.Location === 'string') {
	        data.Location = data.Location.replace(/%2F/g, '/');
	      }
	
	      if (Array.isArray(self.tags)) {
	        for (var i = 0; i < self.tags.length; i++) {
	          self.tags[i].Value = String(self.tags[i].Value);
	        }
	        self.service.putObjectTagging(
	          {Tagging: {TagSet: self.tags}},
	          function(e, d) {
	            if (e) {
	              self.callback(e);
	            } else {
	              self.callback(e, data);
	            }
	          }
	        );
	      } else {
	        self.callback(err, data);
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  finishSinglePart: function finishSinglePart(err, data) {
	    var upload = this.request._managedUpload;
	    var httpReq = this.request.httpRequest;
	    var endpoint = httpReq.endpoint;
	    if (err) return upload.callback(err);
	    data.Location =
	      [endpoint.protocol, '//', endpoint.host, httpReq.path].join('');
	    data.key = this.request.params.Key; // will stay undocumented
	    data.Key = this.request.params.Key;
	    data.Bucket = this.request.params.Bucket;
	    upload.callback(err, data);
	  },
	
	  /**
	   * @api private
	   */
	  progress: function progress(info) {
	    var upload = this._managedUpload;
	    if (this.operation === 'putObject') {
	      info.part = 1;
	      info.key = this.params.Key;
	    } else {
	      upload.totalUploadedBytes += info.loaded - this._lastUploadedBytes;
	      this._lastUploadedBytes = info.loaded;
	      info = {
	        loaded: upload.totalUploadedBytes,
	        total: upload.totalBytes,
	        part: this.params.PartNumber,
	        key: this.params.Key
	      };
	    }
	    upload.emit('httpUploadProgress', [info]);
	  }
	});
	
	AWS.util.mixin(AWS.S3.ManagedUpload, AWS.SequentialExecutor);
	
	/**
	 * @api private
	 */
	AWS.S3.ManagedUpload.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.promise = AWS.util.promisifyMethod('send', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.S3.ManagedUpload.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.promise;
	};
	
	AWS.util.addPromises(AWS.S3.ManagedUpload);
	
	/**
	 * @api private
	 */
	module.exports = AWS.S3.ManagedUpload;
	
	},{"../core":342}],392:[function(require,module,exports){
	var AWS = require('./core');
	
	/**
	 * @api private
	 * @!method on(eventName, callback)
	 *   Registers an event listener callback for the event given by `eventName`.
	 *   Parameters passed to the callback function depend on the individual event
	 *   being triggered. See the event documentation for those parameters.
	 *
	 *   @param eventName [String] the event name to register the listener for
	 *   @param callback [Function] the listener callback function
	 *   @param toHead [Boolean] attach the listener callback to the head of callback array if set to true.
	 *     Default to be false.
	 *   @return [AWS.SequentialExecutor] the same object for chaining
	 */
	AWS.SequentialExecutor = AWS.util.inherit({
	
	  constructor: function SequentialExecutor() {
	    this._events = {};
	  },
	
	  /**
	   * @api private
	   */
	  listeners: function listeners(eventName) {
	    return this._events[eventName] ? this._events[eventName].slice(0) : [];
	  },
	
	  on: function on(eventName, listener, toHead) {
	    if (this._events[eventName]) {
	      toHead ?
	        this._events[eventName].unshift(listener) :
	        this._events[eventName].push(listener);
	    } else {
	      this._events[eventName] = [listener];
	    }
	    return this;
	  },
	
	  onAsync: function onAsync(eventName, listener, toHead) {
	    listener._isAsync = true;
	    return this.on(eventName, listener, toHead);
	  },
	
	  removeListener: function removeListener(eventName, listener) {
	    var listeners = this._events[eventName];
	    if (listeners) {
	      var length = listeners.length;
	      var position = -1;
	      for (var i = 0; i < length; ++i) {
	        if (listeners[i] === listener) {
	          position = i;
	        }
	      }
	      if (position > -1) {
	        listeners.splice(position, 1);
	      }
	    }
	    return this;
	  },
	
	  removeAllListeners: function removeAllListeners(eventName) {
	    if (eventName) {
	      delete this._events[eventName];
	    } else {
	      this._events = {};
	    }
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  emit: function emit(eventName, eventArgs, doneCallback) {
	    if (!doneCallback) doneCallback = function() { };
	    var listeners = this.listeners(eventName);
	    var count = listeners.length;
	    this.callListeners(listeners, eventArgs, doneCallback);
	    return count > 0;
	  },
	
	  /**
	   * @api private
	   */
	  callListeners: function callListeners(listeners, args, doneCallback, prevError) {
	    var self = this;
	    var error = prevError || null;
	
	    function callNextListener(err) {
	      if (err) {
	        error = AWS.util.error(error || new Error(), err);
	        if (self._haltHandlersOnError) {
	          return doneCallback.call(self, error);
	        }
	      }
	      self.callListeners(listeners, args, doneCallback, error);
	    }
	
	    while (listeners.length > 0) {
	      var listener = listeners.shift();
	      if (listener._isAsync) { // asynchronous listener
	        listener.apply(self, args.concat([callNextListener]));
	        return; // stop here, callNextListener will continue
	      } else { // synchronous listener
	        try {
	          listener.apply(self, args);
	        } catch (err) {
	          error = AWS.util.error(error || new Error(), err);
	        }
	        if (error && self._haltHandlersOnError) {
	          doneCallback.call(self, error);
	          return;
	        }
	      }
	    }
	    doneCallback.call(self, error);
	  },
	
	  /**
	   * Adds or copies a set of listeners from another list of
	   * listeners or SequentialExecutor object.
	   *
	   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
	   *   a list of events and callbacks, or an event emitter object
	   *   containing listeners to add to this emitter object.
	   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
	   * @example Adding listeners from a map of listeners
	   *   emitter.addListeners({
	   *     event1: [function() { ... }, function() { ... }],
	   *     event2: [function() { ... }]
	   *   });
	   *   emitter.emit('event1'); // emitter has event1
	   *   emitter.emit('event2'); // emitter has event2
	   * @example Adding listeners from another emitter object
	   *   var emitter1 = new AWS.SequentialExecutor();
	   *   emitter1.on('event1', function() { ... });
	   *   emitter1.on('event2', function() { ... });
	   *   var emitter2 = new AWS.SequentialExecutor();
	   *   emitter2.addListeners(emitter1);
	   *   emitter2.emit('event1'); // emitter2 has event1
	   *   emitter2.emit('event2'); // emitter2 has event2
	   */
	  addListeners: function addListeners(listeners) {
	    var self = this;
	
	    // extract listeners if parameter is an SequentialExecutor object
	    if (listeners._events) listeners = listeners._events;
	
	    AWS.util.each(listeners, function(event, callbacks) {
	      if (typeof callbacks === 'function') callbacks = [callbacks];
	      AWS.util.arrayEach(callbacks, function(callback) {
	        self.on(event, callback);
	      });
	    });
	
	    return self;
	  },
	
	  /**
	   * Registers an event with {on} and saves the callback handle function
	   * as a property on the emitter object using a given `name`.
	   *
	   * @param name [String] the property name to set on this object containing
	   *   the callback function handle so that the listener can be removed in
	   *   the future.
	   * @param (see on)
	   * @return (see on)
	   * @example Adding a named listener DATA_CALLBACK
	   *   var listener = function() { doSomething(); };
	   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
	   *
	   *   // the following prints: true
	   *   console.log(emitter.DATA_CALLBACK == listener);
	   */
	  addNamedListener: function addNamedListener(name, eventName, callback, toHead) {
	    this[name] = callback;
	    this.addListener(eventName, callback, toHead);
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback, toHead) {
	    callback._isAsync = true;
	    return this.addNamedListener(name, eventName, callback, toHead);
	  },
	
	  /**
	   * Helper method to add a set of named listeners using
	   * {addNamedListener}. The callback contains a parameter
	   * with a handle to the `addNamedListener` method.
	   *
	   * @callback callback function(add)
	   *   The callback function is called immediately in order to provide
	   *   the `add` function to the block. This simplifies the addition of
	   *   a large group of named listeners.
	   *   @param add [Function] the {addNamedListener} function to call
	   *     when registering listeners.
	   * @example Adding a set of named listeners
	   *   emitter.addNamedListeners(function(add) {
	   *     add('DATA_CALLBACK', 'data', function() { ... });
	   *     add('OTHER', 'otherEvent', function() { ... });
	   *     add('LAST', 'lastEvent', function() { ... });
	   *   });
	   *
	   *   // these properties are now set:
	   *   emitter.DATA_CALLBACK;
	   *   emitter.OTHER;
	   *   emitter.LAST;
	   */
	  addNamedListeners: function addNamedListeners(callback) {
	    var self = this;
	    callback(
	      function() {
	        self.addNamedListener.apply(self, arguments);
	      },
	      function() {
	        self.addNamedAsyncListener.apply(self, arguments);
	      }
	    );
	    return this;
	  }
	});
	
	/**
	 * {on} is the prefered method.
	 * @api private
	 */
	AWS.SequentialExecutor.prototype.addListener = AWS.SequentialExecutor.prototype.on;
	
	/**
	 * @api private
	 */
	module.exports = AWS.SequentialExecutor;
	
	},{"./core":342}],393:[function(require,module,exports){
	(function (process){(function (){
	var AWS = require('./core');
	var Api = require('./model/api');
	var regionConfig = require('./region_config');
	
	var inherit = AWS.util.inherit;
	var clientCount = 0;
	var region_utils = require('./region/utils');
	
	/**
	 * The service class representing an AWS service.
	 *
	 * @class_abstract This class is an abstract class.
	 *
	 * @!attribute apiVersions
	 *   @return [Array<String>] the list of API versions supported by this service.
	 *   @readonly
	 */
	AWS.Service = inherit({
	  /**
	   * Create a new service object with a configuration object
	   *
	   * @param config [map] a map of configuration options
	   */
	  constructor: function Service(config) {
	    if (!this.loadServiceClass) {
	      throw AWS.util.error(new Error(),
	        'Service must be constructed with `new\' operator');
	    }
	
	    if (config) {
	      if (config.region) {
	        var region = config.region;
	        if (region_utils.isFipsRegion(region)) {
	          config.region = region_utils.getRealRegion(region);
	          config.useFipsEndpoint = true;
	        }
	        if (region_utils.isGlobalRegion(region)) {
	          config.region = region_utils.getRealRegion(region);
	        }
	      }
	      if (typeof config.useDualstack === 'boolean'
	        && typeof config.useDualstackEndpoint !== 'boolean') {
	        config.useDualstackEndpoint = config.useDualstack;
	      }
	    }
	
	    var ServiceClass = this.loadServiceClass(config || {});
	    if (ServiceClass) {
	      var originalConfig = AWS.util.copy(config);
	      var svc = new ServiceClass(config);
	      Object.defineProperty(svc, '_originalConfig', {
	        get: function() { return originalConfig; },
	        enumerable: false,
	        configurable: true
	      });
	      svc._clientId = ++clientCount;
	      return svc;
	    }
	    this.initialize(config);
	  },
	
	  /**
	   * @api private
	   */
	  initialize: function initialize(config) {
	    var svcConfig = AWS.config[this.serviceIdentifier];
	    this.config = new AWS.Config(AWS.config);
	    if (svcConfig) this.config.update(svcConfig, true);
	    if (config) this.config.update(config, true);
	
	    this.validateService();
	    if (!this.config.endpoint) regionConfig.configureEndpoint(this);
	
	    this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
	    this.setEndpoint(this.config.endpoint);
	    //enable attaching listeners to service client
	    AWS.SequentialExecutor.call(this);
	    AWS.Service.addDefaultMonitoringListeners(this);
	    if ((this.config.clientSideMonitoring || AWS.Service._clientSideMonitoring) && this.publisher) {
	      var publisher = this.publisher;
	      this.addNamedListener('PUBLISH_API_CALL', 'apiCall', function PUBLISH_API_CALL(event) {
	        process.nextTick(function() {publisher.eventHandler(event);});
	      });
	      this.addNamedListener('PUBLISH_API_ATTEMPT', 'apiCallAttempt', function PUBLISH_API_ATTEMPT(event) {
	        process.nextTick(function() {publisher.eventHandler(event);});
	      });
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateService: function validateService() {
	  },
	
	  /**
	   * @api private
	   */
	  loadServiceClass: function loadServiceClass(serviceConfig) {
	    var config = serviceConfig;
	    if (!AWS.util.isEmpty(this.api)) {
	      return null;
	    } else if (config.apiConfig) {
	      return AWS.Service.defineServiceApi(this.constructor, config.apiConfig);
	    } else if (!this.constructor.services) {
	      return null;
	    } else {
	      config = new AWS.Config(AWS.config);
	      config.update(serviceConfig, true);
	      var version = config.apiVersions[this.constructor.serviceIdentifier];
	      version = version || config.apiVersion;
	      return this.getLatestServiceClass(version);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getLatestServiceClass: function getLatestServiceClass(version) {
	    version = this.getLatestServiceVersion(version);
	    if (this.constructor.services[version] === null) {
	      AWS.Service.defineServiceApi(this.constructor, version);
	    }
	
	    return this.constructor.services[version];
	  },
	
	  /**
	   * @api private
	   */
	  getLatestServiceVersion: function getLatestServiceVersion(version) {
	    if (!this.constructor.services || this.constructor.services.length === 0) {
	      throw new Error('No services defined on ' +
	                      this.constructor.serviceIdentifier);
	    }
	
	    if (!version) {
	      version = 'latest';
	    } else if (AWS.util.isType(version, Date)) {
	      version = AWS.util.date.iso8601(version).split('T')[0];
	    }
	
	    if (Object.hasOwnProperty(this.constructor.services, version)) {
	      return version;
	    }
	
	    var keys = Object.keys(this.constructor.services).sort();
	    var selectedVersion = null;
	    for (var i = keys.length - 1; i >= 0; i--) {
	      // versions that end in "*" are not available on disk and can be
	      // skipped, so do not choose these as selectedVersions
	      if (keys[i][keys[i].length - 1] !== '*') {
	        selectedVersion = keys[i];
	      }
	      if (keys[i].substr(0, 10) <= version) {
	        return selectedVersion;
	      }
	    }
	
	    throw new Error('Could not find ' + this.constructor.serviceIdentifier +
	                    ' API to satisfy version constraint `' + version + '\'');
	  },
	
	  /**
	   * @api private
	   */
	  api: {},
	
	  /**
	   * @api private
	   */
	  defaultRetryCount: 3,
	
	  /**
	   * @api private
	   */
	  customizeRequests: function customizeRequests(callback) {
	    if (!callback) {
	      this.customRequestHandler = null;
	    } else if (typeof callback === 'function') {
	      this.customRequestHandler = callback;
	    } else {
	      throw new Error('Invalid callback type \'' + typeof callback + '\' provided in customizeRequests');
	    }
	  },
	
	  /**
	   * Calls an operation on a service with the given input parameters.
	   *
	   * @param operation [String] the name of the operation to call on the service.
	   * @param params [map] a map of input options for the operation
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  makeRequest: function makeRequest(operation, params, callback) {
	    if (typeof params === 'function') {
	      callback = params;
	      params = null;
	    }
	
	    params = params || {};
	    if (this.config.params) { // copy only toplevel bound params
	      var rules = this.api.operations[operation];
	      if (rules) {
	        params = AWS.util.copy(params);
	        AWS.util.each(this.config.params, function(key, value) {
	          if (rules.input.members[key]) {
	            if (params[key] === undefined || params[key] === null) {
	              params[key] = value;
	            }
	          }
	        });
	      }
	    }
	
	    var request = new AWS.Request(this, operation, params);
	    this.addAllRequestListeners(request);
	    this.attachMonitoringEmitter(request);
	    if (callback) request.send(callback);
	    return request;
	  },
	
	  /**
	   * Calls an operation on a service with the given input parameters, without
	   * any authentication data. This method is useful for "public" API operations.
	   *
	   * @param operation [String] the name of the operation to call on the service.
	   * @param params [map] a map of input options for the operation
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
	    if (typeof params === 'function') {
	      callback = params;
	      params = {};
	    }
	
	    var request = this.makeRequest(operation, params).toUnauthenticated();
	    return callback ? request.send(callback) : request;
	  },
	
	  /**
	   * Waits for a given state
	   *
	   * @param state [String] the state on the service to wait for
	   * @param params [map] a map of parameters to pass with each request
	   * @option params $waiter [map] a map of configuration options for the waiter
	   * @option params $waiter.delay [Number] The number of seconds to wait between
	   *                                       requests
	   * @option params $waiter.maxAttempts [Number] The maximum number of requests
	   *                                             to send while waiting
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  waitFor: function waitFor(state, params, callback) {
	    var waiter = new AWS.ResourceWaiter(this, state);
	    return waiter.wait(params, callback);
	  },
	
	  /**
	   * @api private
	   */
	  addAllRequestListeners: function addAllRequestListeners(request) {
	    var list = [AWS.events, AWS.EventListeners.Core, this.serviceInterface(),
	                AWS.EventListeners.CorePost];
	    for (var i = 0; i < list.length; i++) {
	      if (list[i]) request.addListeners(list[i]);
	    }
	
	    // disable parameter validation
	    if (!this.config.paramValidation) {
	      request.removeListener('validate',
	        AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	    }
	
	    if (this.config.logger) { // add logging events
	      request.addListeners(AWS.EventListeners.Logger);
	    }
	
	    this.setupRequestListeners(request);
	    // call prototype's customRequestHandler
	    if (typeof this.constructor.prototype.customRequestHandler === 'function') {
	      this.constructor.prototype.customRequestHandler(request);
	    }
	    // call instance's customRequestHandler
	    if (Object.prototype.hasOwnProperty.call(this, 'customRequestHandler') && typeof this.customRequestHandler === 'function') {
	      this.customRequestHandler(request);
	    }
	  },
	
	  /**
	   * Event recording metrics for a whole API call.
	   * @returns {object} a subset of api call metrics
	   * @api private
	   */
	  apiCallEvent: function apiCallEvent(request) {
	    var api = request.service.api.operations[request.operation];
	    var monitoringEvent = {
	      Type: 'ApiCall',
	      Api: api ? api.name : request.operation,
	      Version: 1,
	      Service: request.service.api.serviceId || request.service.api.endpointPrefix,
	      Region: request.httpRequest.region,
	      MaxRetriesExceeded: 0,
	      UserAgent: request.httpRequest.getUserAgent(),
	    };
	    var response = request.response;
	    if (response.httpResponse.statusCode) {
	      monitoringEvent.FinalHttpStatusCode = response.httpResponse.statusCode;
	    }
	    if (response.error) {
	      var error = response.error;
	      var statusCode = response.httpResponse.statusCode;
	      if (statusCode > 299) {
	        if (error.code) monitoringEvent.FinalAwsException = error.code;
	        if (error.message) monitoringEvent.FinalAwsExceptionMessage = error.message;
	      } else {
	        if (error.code || error.name) monitoringEvent.FinalSdkException = error.code || error.name;
	        if (error.message) monitoringEvent.FinalSdkExceptionMessage = error.message;
	      }
	    }
	    return monitoringEvent;
	  },
	
	  /**
	   * Event recording metrics for an API call attempt.
	   * @returns {object} a subset of api call attempt metrics
	   * @api private
	   */
	  apiAttemptEvent: function apiAttemptEvent(request) {
	    var api = request.service.api.operations[request.operation];
	    var monitoringEvent = {
	      Type: 'ApiCallAttempt',
	      Api: api ? api.name : request.operation,
	      Version: 1,
	      Service: request.service.api.serviceId || request.service.api.endpointPrefix,
	      Fqdn: request.httpRequest.endpoint.hostname,
	      UserAgent: request.httpRequest.getUserAgent(),
	    };
	    var response = request.response;
	    if (response.httpResponse.statusCode) {
	      monitoringEvent.HttpStatusCode = response.httpResponse.statusCode;
	    }
	    if (
	      !request._unAuthenticated &&
	      request.service.config.credentials &&
	      request.service.config.credentials.accessKeyId
	    ) {
	      monitoringEvent.AccessKey = request.service.config.credentials.accessKeyId;
	    }
	    if (!response.httpResponse.headers) return monitoringEvent;
	    if (request.httpRequest.headers['x-amz-security-token']) {
	      monitoringEvent.SessionToken = request.httpRequest.headers['x-amz-security-token'];
	    }
	    if (response.httpResponse.headers['x-amzn-requestid']) {
	      monitoringEvent.XAmznRequestId = response.httpResponse.headers['x-amzn-requestid'];
	    }
	    if (response.httpResponse.headers['x-amz-request-id']) {
	      monitoringEvent.XAmzRequestId = response.httpResponse.headers['x-amz-request-id'];
	    }
	    if (response.httpResponse.headers['x-amz-id-2']) {
	      monitoringEvent.XAmzId2 = response.httpResponse.headers['x-amz-id-2'];
	    }
	    return monitoringEvent;
	  },
	
	  /**
	   * Add metrics of failed request.
	   * @api private
	   */
	  attemptFailEvent: function attemptFailEvent(request) {
	    var monitoringEvent = this.apiAttemptEvent(request);
	    var response = request.response;
	    var error = response.error;
	    if (response.httpResponse.statusCode > 299 ) {
	      if (error.code) monitoringEvent.AwsException = error.code;
	      if (error.message) monitoringEvent.AwsExceptionMessage = error.message;
	    } else {
	      if (error.code || error.name) monitoringEvent.SdkException = error.code || error.name;
	      if (error.message) monitoringEvent.SdkExceptionMessage = error.message;
	    }
	    return monitoringEvent;
	  },
	
	  /**
	   * Attach listeners to request object to fetch metrics of each request
	   * and emit data object through \'ApiCall\' and \'ApiCallAttempt\' events.
	   * @api private
	   */
	  attachMonitoringEmitter: function attachMonitoringEmitter(request) {
	    var attemptTimestamp; //timestamp marking the beginning of a request attempt
	    var attemptStartRealTime; //Start time of request attempt. Used to calculating attemptLatency
	    var attemptLatency; //latency from request sent out to http response reaching SDK
	    var callStartRealTime; //Start time of API call. Used to calculating API call latency
	    var attemptCount = 0; //request.retryCount is not reliable here
	    var region; //region cache region for each attempt since it can be updated in plase (e.g. s3)
	    var callTimestamp; //timestamp when the request is created
	    var self = this;
	    var addToHead = true;
	
	    request.on('validate', function () {
	      callStartRealTime = AWS.util.realClock.now();
	      callTimestamp = Date.now();
	    }, addToHead);
	    request.on('sign', function () {
	      attemptStartRealTime = AWS.util.realClock.now();
	      attemptTimestamp = Date.now();
	      region = request.httpRequest.region;
	      attemptCount++;
	    }, addToHead);
	    request.on('validateResponse', function() {
	      attemptLatency = Math.round(AWS.util.realClock.now() - attemptStartRealTime);
	    });
	    request.addNamedListener('API_CALL_ATTEMPT', 'success', function API_CALL_ATTEMPT() {
	      var apiAttemptEvent = self.apiAttemptEvent(request);
	      apiAttemptEvent.Timestamp = attemptTimestamp;
	      apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
	      apiAttemptEvent.Region = region;
	      self.emit('apiCallAttempt', [apiAttemptEvent]);
	    });
	    request.addNamedListener('API_CALL_ATTEMPT_RETRY', 'retry', function API_CALL_ATTEMPT_RETRY() {
	      var apiAttemptEvent = self.attemptFailEvent(request);
	      apiAttemptEvent.Timestamp = attemptTimestamp;
	      //attemptLatency may not be available if fail before response
	      attemptLatency = attemptLatency ||
	        Math.round(AWS.util.realClock.now() - attemptStartRealTime);
	      apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
	      apiAttemptEvent.Region = region;
	      self.emit('apiCallAttempt', [apiAttemptEvent]);
	    });
	    request.addNamedListener('API_CALL', 'complete', function API_CALL() {
	      var apiCallEvent = self.apiCallEvent(request);
	      apiCallEvent.AttemptCount = attemptCount;
	      if (apiCallEvent.AttemptCount <= 0) return;
	      apiCallEvent.Timestamp = callTimestamp;
	      var latency = Math.round(AWS.util.realClock.now() - callStartRealTime);
	      apiCallEvent.Latency = latency >= 0 ? latency : 0;
	      var response = request.response;
	      if (
	        response.error &&
	        response.error.retryable &&
	        typeof response.retryCount === 'number' &&
	        typeof response.maxRetries === 'number' &&
	        (response.retryCount >= response.maxRetries)
	      ) {
	        apiCallEvent.MaxRetriesExceeded = 1;
	      }
	      self.emit('apiCall', [apiCallEvent]);
	    });
	  },
	
	  /**
	   * Override this method to setup any custom request listeners for each
	   * new request to the service.
	   *
	   * @method_abstract This is an abstract method.
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	  },
	
	  /**
	   * Gets the signing name for a given request
	   * @api private
	   */
	  getSigningName: function getSigningName() {
	    return this.api.signingName || this.api.endpointPrefix;
	  },
	
	  /**
	   * Gets the signer class for a given request
	   * @api private
	   */
	  getSignerClass: function getSignerClass(request) {
	    var version;
	    // get operation authtype if present
	    var operation = null;
	    var authtype = '';
	    if (request) {
	      var operations = request.service.api.operations || {};
	      operation = operations[request.operation] || null;
	      authtype = operation ? operation.authtype : '';
	    }
	    if (this.config.signatureVersion) {
	      version = this.config.signatureVersion;
	    } else if (authtype === 'v4' || authtype === 'v4-unsigned-body') {
	      version = 'v4';
	    } else {
	      version = this.api.signatureVersion;
	    }
	    return AWS.Signers.RequestSigner.getVersion(version);
	  },
	
	  /**
	   * @api private
	   */
	  serviceInterface: function serviceInterface() {
	    switch (this.api.protocol) {
	      case 'ec2': return AWS.EventListeners.Query;
	      case 'query': return AWS.EventListeners.Query;
	      case 'json': return AWS.EventListeners.Json;
	      case 'rest-json': return AWS.EventListeners.RestJson;
	      case 'rest-xml': return AWS.EventListeners.RestXml;
	    }
	    if (this.api.protocol) {
	      throw new Error('Invalid service `protocol\' ' +
	        this.api.protocol + ' in API config');
	    }
	  },
	
	  /**
	   * @api private
	   */
	  successfulResponse: function successfulResponse(resp) {
	    return resp.httpResponse.statusCode < 300;
	  },
	
	  /**
	   * How many times a failed request should be retried before giving up.
	   * the defaultRetryCount can be overriden by service classes.
	   *
	   * @api private
	   */
	  numRetries: function numRetries() {
	    if (this.config.maxRetries !== undefined) {
	      return this.config.maxRetries;
	    } else {
	      return this.defaultRetryCount;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  retryDelays: function retryDelays(retryCount, err) {
	    return AWS.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions, err);
	  },
	
	  /**
	   * @api private
	   */
	  retryableError: function retryableError(error) {
	    if (this.timeoutError(error)) return true;
	    if (this.networkingError(error)) return true;
	    if (this.expiredCredentialsError(error)) return true;
	    if (this.throttledError(error)) return true;
	    if (error.statusCode >= 500) return true;
	    return false;
	  },
	
	  /**
	   * @api private
	   */
	  networkingError: function networkingError(error) {
	    return error.code === 'NetworkingError';
	  },
	
	  /**
	   * @api private
	   */
	  timeoutError: function timeoutError(error) {
	    return error.code === 'TimeoutError';
	  },
	
	  /**
	   * @api private
	   */
	  expiredCredentialsError: function expiredCredentialsError(error) {
	    // TODO : this only handles *one* of the expired credential codes
	    return (error.code === 'ExpiredTokenException');
	  },
	
	  /**
	   * @api private
	   */
	  clockSkewError: function clockSkewError(error) {
	    switch (error.code) {
	      case 'RequestTimeTooSkewed':
	      case 'RequestExpired':
	      case 'InvalidSignatureException':
	      case 'SignatureDoesNotMatch':
	      case 'AuthFailure':
	      case 'RequestInTheFuture':
	        return true;
	      default: return false;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getSkewCorrectedDate: function getSkewCorrectedDate() {
	    return new Date(Date.now() + this.config.systemClockOffset);
	  },
	
	  /**
	   * @api private
	   */
	  applyClockOffset: function applyClockOffset(newServerTime) {
	    if (newServerTime) {
	      this.config.systemClockOffset = newServerTime - Date.now();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  isClockSkewed: function isClockSkewed(newServerTime) {
	    if (newServerTime) {
	      return Math.abs(this.getSkewCorrectedDate().getTime() - newServerTime) >= 300000;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  throttledError: function throttledError(error) {
	    // this logic varies between services
	    if (error.statusCode === 429) return true;
	    switch (error.code) {
	      case 'ProvisionedThroughputExceededException':
	      case 'Throttling':
	      case 'ThrottlingException':
	      case 'RequestLimitExceeded':
	      case 'RequestThrottled':
	      case 'RequestThrottledException':
	      case 'TooManyRequestsException':
	      case 'TransactionInProgressException': //dynamodb
	      case 'EC2ThrottledException':
	        return true;
	      default:
	        return false;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  endpointFromTemplate: function endpointFromTemplate(endpoint) {
	    if (typeof endpoint !== 'string') return endpoint;
	
	    var e = endpoint;
	    e = e.replace(/\{service\}/g, this.api.endpointPrefix);
	    e = e.replace(/\{region\}/g, this.config.region);
	    e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? 'https' : 'http');
	    return e;
	  },
	
	  /**
	   * @api private
	   */
	  setEndpoint: function setEndpoint(endpoint) {
	    this.endpoint = new AWS.Endpoint(endpoint, this.config);
	  },
	
	  /**
	   * @api private
	   */
	  paginationConfig: function paginationConfig(operation, throwException) {
	    var paginator = this.api.operations[operation].paginator;
	    if (!paginator) {
	      if (throwException) {
	        var e = new Error();
	        throw AWS.util.error(e, 'No pagination configuration for ' + operation);
	      }
	      return null;
	    }
	
	    return paginator;
	  }
	});
	
	AWS.util.update(AWS.Service, {
	
	  /**
	   * Adds one method for each operation described in the api configuration
	   *
	   * @api private
	   */
	  defineMethods: function defineMethods(svc) {
	    AWS.util.each(svc.prototype.api.operations, function iterator(method) {
	      if (svc.prototype[method]) return;
	      var operation = svc.prototype.api.operations[method];
	      if (operation.authtype === 'none') {
	        svc.prototype[method] = function (params, callback) {
	          return this.makeUnauthenticatedRequest(method, params, callback);
	        };
	      } else {
	        svc.prototype[method] = function (params, callback) {
	          return this.makeRequest(method, params, callback);
	        };
	      }
	    });
	  },
	
	  /**
	   * Defines a new Service class using a service identifier and list of versions
	   * including an optional set of features (functions) to apply to the class
	   * prototype.
	   *
	   * @param serviceIdentifier [String] the identifier for the service
	   * @param versions [Array<String>] a list of versions that work with this
	   *   service
	   * @param features [Object] an object to attach to the prototype
	   * @return [Class<Service>] the service class defined by this function.
	   */
	  defineService: function defineService(serviceIdentifier, versions, features) {
	    AWS.Service._serviceMap[serviceIdentifier] = true;
	    if (!Array.isArray(versions)) {
	      features = versions;
	      versions = [];
	    }
	
	    var svc = inherit(AWS.Service, features || {});
	
	    if (typeof serviceIdentifier === 'string') {
	      AWS.Service.addVersions(svc, versions);
	
	      var identifier = svc.serviceIdentifier || serviceIdentifier;
	      svc.serviceIdentifier = identifier;
	    } else { // defineService called with an API
	      svc.prototype.api = serviceIdentifier;
	      AWS.Service.defineMethods(svc);
	    }
	    AWS.SequentialExecutor.call(this.prototype);
	    //util.clientSideMonitoring is only available in node
	    if (!this.prototype.publisher && AWS.util.clientSideMonitoring) {
	      var Publisher = AWS.util.clientSideMonitoring.Publisher;
	      var configProvider = AWS.util.clientSideMonitoring.configProvider;
	      var publisherConfig = configProvider();
	      this.prototype.publisher = new Publisher(publisherConfig);
	      if (publisherConfig.enabled) {
	        //if csm is enabled in environment, SDK should send all metrics
	        AWS.Service._clientSideMonitoring = true;
	      }
	    }
	    AWS.SequentialExecutor.call(svc.prototype);
	    AWS.Service.addDefaultMonitoringListeners(svc.prototype);
	    return svc;
	  },
	
	  /**
	   * @api private
	   */
	  addVersions: function addVersions(svc, versions) {
	    if (!Array.isArray(versions)) versions = [versions];
	
	    svc.services = svc.services || {};
	    for (var i = 0; i < versions.length; i++) {
	      if (svc.services[versions[i]] === undefined) {
	        svc.services[versions[i]] = null;
	      }
	    }
	
	    svc.apiVersions = Object.keys(svc.services).sort();
	  },
	
	  /**
	   * @api private
	   */
	  defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
	    var svc = inherit(superclass, {
	      serviceIdentifier: superclass.serviceIdentifier
	    });
	
	    function setApi(api) {
	      if (api.isApi) {
	        svc.prototype.api = api;
	      } else {
	        svc.prototype.api = new Api(api, {
	          serviceIdentifier: superclass.serviceIdentifier
	        });
	      }
	    }
	
	    if (typeof version === 'string') {
	      if (apiConfig) {
	        setApi(apiConfig);
	      } else {
	        try {
	          setApi(AWS.apiLoader(superclass.serviceIdentifier, version));
	        } catch (err) {
	          throw AWS.util.error(err, {
	            message: 'Could not find API configuration ' +
	              superclass.serviceIdentifier + '-' + version
	          });
	        }
	      }
	      if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) {
	        superclass.apiVersions = superclass.apiVersions.concat(version).sort();
	      }
	      superclass.services[version] = svc;
	    } else {
	      setApi(version);
	    }
	
	    AWS.Service.defineMethods(svc);
	    return svc;
	  },
	
	  /**
	   * @api private
	   */
	  hasService: function(identifier) {
	    return Object.prototype.hasOwnProperty.call(AWS.Service._serviceMap, identifier);
	  },
	
	  /**
	   * @param attachOn attach default monitoring listeners to object
	   *
	   * Each monitoring event should be emitted from service client to service constructor prototype and then
	   * to global service prototype like bubbling up. These default monitoring events listener will transfer
	   * the monitoring events to the upper layer.
	   * @api private
	   */
	  addDefaultMonitoringListeners: function addDefaultMonitoringListeners(attachOn) {
	    attachOn.addNamedListener('MONITOR_EVENTS_BUBBLE', 'apiCallAttempt', function EVENTS_BUBBLE(event) {
	      var baseClass = Object.getPrototypeOf(attachOn);
	      if (baseClass._events) baseClass.emit('apiCallAttempt', [event]);
	    });
	    attachOn.addNamedListener('CALL_EVENTS_BUBBLE', 'apiCall', function CALL_EVENTS_BUBBLE(event) {
	      var baseClass = Object.getPrototypeOf(attachOn);
	      if (baseClass._events) baseClass.emit('apiCall', [event]);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  _serviceMap: {}
	});
	
	AWS.util.mixin(AWS.Service, AWS.SequentialExecutor);
	
	/**
	 * @api private
	 */
	module.exports = AWS.Service;
	
	}).call(this)}).call(this,require('_process'))
	},{"./core":342,"./model/api":368,"./region/utils":385,"./region_config":386,"_process":432}],394:[function(require,module,exports){
	var AWS = require('../core');
	
	AWS.util.update(AWS.APIGateway.prototype, {
	/**
	 * Sets the Accept header to application/json.
	 *
	 * @api private
	 */
	  setAcceptHeader: function setAcceptHeader(req) {
	    var httpRequest = req.httpRequest;
	    if (!httpRequest.headers.Accept) {
	      httpRequest.headers['Accept'] = 'application/json';
	    }
	  },
	
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('build', this.setAcceptHeader);
	    if (request.operation === 'getExport') {
	      var params = request.params || {};
	      if (params.exportType === 'swagger') {
	        request.addListener('extractData', AWS.util.convertPayloadToString);
	      }
	    }
	  }
	});
	
	
	},{"../core":342}],395:[function(require,module,exports){
	var AWS = require('../core');
	
	// pull in CloudFront signer
	require('../cloudfront/signer');
	
	AWS.util.update(AWS.CloudFront.prototype, {
	
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('extractData', AWS.util.hoistPayloadMember);
	  }
	
	});
	
	},{"../cloudfront/signer":339,"../core":342}],396:[function(require,module,exports){
	var AWS = require('../core');
	require('../dynamodb/document_client');
	
	AWS.util.update(AWS.DynamoDB.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (request.service.config.dynamoDbCrc32) {
	      request.removeListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
	      request.addListener('extractData', this.checkCrc32);
	      request.addListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  checkCrc32: function checkCrc32(resp) {
	    if (!resp.httpResponse.streaming && !resp.request.service.crc32IsValid(resp)) {
	      resp.data = null;
	      resp.error = AWS.util.error(new Error(), {
	        code: 'CRC32CheckFailed',
	        message: 'CRC32 integrity check failed',
	        retryable: true
	      });
	      resp.request.haltHandlersOnError();
	      throw (resp.error);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  crc32IsValid: function crc32IsValid(resp) {
	    var crc = resp.httpResponse.headers['x-amz-crc32'];
	    if (!crc) return true; // no (valid) CRC32 header
	    return parseInt(crc, 10) === AWS.util.crypto.crc32(resp.httpResponse.body);
	  },
	
	  /**
	   * @api private
	   */
	  defaultRetryCount: 10,
	
	  /**
	   * @api private
	   */
	  retryDelays: function retryDelays(retryCount, err) {
	    var retryDelayOptions = AWS.util.copy(this.config.retryDelayOptions);
	
	    if (typeof retryDelayOptions.base !== 'number') {
	        retryDelayOptions.base = 50; // default for dynamodb
	    }
	    var delay = AWS.util.calculateRetryDelay(retryCount, retryDelayOptions, err);
	    return delay;
	  }
	});
	
	},{"../core":342,"../dynamodb/document_client":352}],397:[function(require,module,exports){
	var AWS = require('../core');
	
	AWS.util.update(AWS.EC2.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.removeListener('extractError', AWS.EventListeners.Query.EXTRACT_ERROR);
	    request.addListener('extractError', this.extractError);
	
	    if (request.operation === 'copySnapshot') {
	      request.onAsync('validate', this.buildCopySnapshotPresignedUrl);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  buildCopySnapshotPresignedUrl: function buildCopySnapshotPresignedUrl(req, done) {
	    if (req.params.PresignedUrl || req._subRequest) {
	      return done();
	    }
	
	    req.params = AWS.util.copy(req.params);
	    req.params.DestinationRegion = req.service.config.region;
	
	    var config = AWS.util.copy(req.service.config);
	    delete config.endpoint;
	    config.region = req.params.SourceRegion;
	    var svc = new req.service.constructor(config);
	    var newReq = svc[req.operation](req.params);
	    newReq._subRequest = true;
	    newReq.presign(function(err, url) {
	      if (err) done(err);
	      else {
	        req.params.PresignedUrl = url;
	        done();
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  extractError: function extractError(resp) {
	    // EC2 nests the error code and message deeper than other AWS Query services.
	    var httpResponse = resp.httpResponse;
	    var data = new AWS.XML.Parser().parse(httpResponse.body.toString() || '');
	    if (data.Errors) {
	      resp.error = AWS.util.error(new Error(), {
	        code: data.Errors.Error.Code,
	        message: data.Errors.Error.Message
	      });
	    } else {
	      resp.error = AWS.util.error(new Error(), {
	        code: httpResponse.statusCode,
	        message: null
	      });
	    }
	    resp.error.requestId = data.RequestID || null;
	  }
	});
	
	},{"../core":342}],398:[function(require,module,exports){
	var AWS = require('../core');
	
	/**
	 * @api private
	 */
	var blobPayloadOutputOps = [
	  'deleteThingShadow',
	  'getThingShadow',
	  'updateThingShadow'
	];
	
	/**
	 * Constructs a service interface object. Each API operation is exposed as a
	 * function on service.
	 *
	 * ### Sending a Request Using IotData
	 *
	 * ```javascript
	 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
	 * iotdata.getThingShadow(params, function (err, data) {
	 *   if (err) console.log(err, err.stack); // an error occurred
	 *   else     console.log(data);           // successful response
	 * });
	 * ```
	 *
	 * ### Locking the API Version
	 *
	 * In order to ensure that the IotData object uses this specific API,
	 * you can construct the object by passing the `apiVersion` option to the
	 * constructor:
	 *
	 * ```javascript
	 * var iotdata = new AWS.IotData({
	 *   endpoint: 'my.host.tld',
	 *   apiVersion: '2015-05-28'
	 * });
	 * ```
	 *
	 * You can also set the API version globally in `AWS.config.apiVersions` using
	 * the **iotdata** service identifier:
	 *
	 * ```javascript
	 * AWS.config.apiVersions = {
	 *   iotdata: '2015-05-28',
	 *   // other service API versions
	 * };
	 *
	 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
	 * ```
	 *
	 * @note You *must* provide an `endpoint` configuration parameter when
	 *   constructing this service. See {constructor} for more information.
	 *
	 * @!method constructor(options = {})
	 *   Constructs a service object. This object has one method for each
	 *   API operation.
	 *
	 *   @example Constructing a IotData object
	 *     var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
	 *   @note You *must* provide an `endpoint` when constructing this service.
	 *   @option (see AWS.Config.constructor)
	 *
	 * @service iotdata
	 * @version 2015-05-28
	 */
	AWS.util.update(AWS.IotData.prototype, {
	    /**
	     * @api private
	     */
	    validateService: function validateService() {
	        if (!this.config.endpoint || this.config.endpoint.indexOf('{') >= 0) {
	            var msg = 'AWS.IotData requires an explicit ' +
	                '`endpoint\' configuration option.';
	            throw AWS.util.error(new Error(),
	                {name: 'InvalidEndpoint', message: msg});
	        }
	    },
	
	    /**
	     * @api private
	     */
	    setupRequestListeners: function setupRequestListeners(request) {
	        request.addListener('validateResponse', this.validateResponseBody);
	        if (blobPayloadOutputOps.indexOf(request.operation) > -1) {
	            request.addListener('extractData', AWS.util.convertPayloadToString);
	        }
	    },
	
	    /**
	     * @api private
	     */
	    validateResponseBody: function validateResponseBody(resp) {
	        var body = resp.httpResponse.body.toString() || '{}';
	        var bodyCheck = body.trim();
	        if (!bodyCheck || bodyCheck.charAt(0) !== '{') {
	            resp.httpResponse.body = '';
	        }
	    }
	
	});
	
	},{"../core":342}],399:[function(require,module,exports){
	var AWS = require('../core');
	
	AWS.util.update(AWS.Lambda.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (request.operation === 'invoke') {
	      request.addListener('extractData', AWS.util.convertPayloadToString);
	    }
	  }
	});
	
	
	},{"../core":342}],400:[function(require,module,exports){
	var AWS = require('../core');
	
	AWS.util.update(AWS.MachineLearning.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (request.operation === 'predict') {
	      request.addListener('build', this.buildEndpoint);
	    }
	  },
	
	  /**
	   * Updates request endpoint from PredictEndpoint
	   * @api private
	   */
	  buildEndpoint: function buildEndpoint(request) {
	    var url = request.params.PredictEndpoint;
	    if (url) {
	      request.httpRequest.endpoint = new AWS.Endpoint(url);
	    }
	  }
	
	});
	
	},{"../core":342}],401:[function(require,module,exports){
	require('../polly/presigner');
	
	},{"../polly/presigner":375}],402:[function(require,module,exports){
	var AWS = require('../core');
	var rdsutil = require('./rdsutil');
	require('../rds/signer');
	 /**
	  * @api private
	  */
	 var crossRegionOperations = ['copyDBSnapshot', 'createDBInstanceReadReplica', 'createDBCluster', 'copyDBClusterSnapshot', 'startDBInstanceAutomatedBackupsReplication'];
	
	 AWS.util.update(AWS.RDS.prototype, {
	   /**
	    * @api private
	    */
	   setupRequestListeners: function setupRequestListeners(request) {
	    rdsutil.setupRequestListeners(this, request, crossRegionOperations);
	   },
	 });
	
	},{"../core":342,"../rds/signer":383,"./rdsutil":403}],403:[function(require,module,exports){
	var AWS = require('../core');
	
	var rdsutil = {
	  /**
	    * @api private
	    */
	   setupRequestListeners: function setupRequestListeners(service, request, crossRegionOperations) {
	    if (crossRegionOperations.indexOf(request.operation) !== -1 &&
	        request.params.SourceRegion) {
	      request.params = AWS.util.copy(request.params);
	      if (request.params.PreSignedUrl ||
	          request.params.SourceRegion === service.config.region) {
	        delete request.params.SourceRegion;
	      } else {
	        var doesParamValidation = !!service.config.paramValidation;
	        // remove the validate parameters listener so we can re-add it after we build the URL
	        if (doesParamValidation) {
	          request.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	        }
	        request.onAsync('validate', rdsutil.buildCrossRegionPresignedUrl);
	        if (doesParamValidation) {
	          request.addListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	        }
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  buildCrossRegionPresignedUrl: function buildCrossRegionPresignedUrl(req, done) {
	    var config = AWS.util.copy(req.service.config);
	    config.region = req.params.SourceRegion;
	    delete req.params.SourceRegion;
	    delete config.endpoint;
	    // relevant params for the operation will already be in req.params
	    delete config.params;
	    config.signatureVersion = 'v4';
	    var destinationRegion = req.service.config.region;
	
	    var svc = new req.service.constructor(config);
	    var newReq = svc[req.operation](AWS.util.copy(req.params));
	    newReq.on('build', function addDestinationRegionParam(request) {
	      var httpRequest = request.httpRequest;
	      httpRequest.params.DestinationRegion = destinationRegion;
	      httpRequest.body = AWS.util.queryParamsToString(httpRequest.params);
	    });
	    newReq.presign(function(err, url) {
	      if (err) done(err);
	      else {
	        req.params.PreSignedUrl = url;
	        done();
	      }
	    });
	  }
	};
	
	/**
	 * @api private
	 */
	module.exports = rdsutil;
	
	},{"../core":342}],404:[function(require,module,exports){
	var AWS = require('../core');
	
	AWS.util.update(AWS.Route53.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.on('build', this.sanitizeUrl);
	  },
	
	  /**
	   * @api private
	   */
	  sanitizeUrl: function sanitizeUrl(request) {
	    var path = request.httpRequest.path;
	    request.httpRequest.path = path.replace(/\/%2F\w+%2F/, '/');
	  },
	
	  /**
	   * @return [Boolean] whether the error can be retried
	   * @api private
	   */
	  retryableError: function retryableError(error) {
	    if (error.code === 'PriorRequestNotComplete' &&
	        error.statusCode === 400) {
	      return true;
	    } else {
	      var _super = AWS.Service.prototype.retryableError;
	      return _super.call(this, error);
	    }
	  }
	});
	
	},{"../core":342}],405:[function(require,module,exports){
	var AWS = require('../core');
	var v4Credentials = require('../signers/v4_credentials');
	var resolveRegionalEndpointsFlag = require('../config_regional_endpoint');
	var s3util = require('./s3util');
	var regionUtil = require('../region_config');
	
	// Pull in managed upload extension
	require('../s3/managed_upload');
	
	/**
	 * @api private
	 */
	var operationsWith200StatusCodeError = {
	  'completeMultipartUpload': true,
	  'copyObject': true,
	  'uploadPartCopy': true
	};
	
	/**
	 * @api private
	 */
	 var regionRedirectErrorCodes = [
	  'AuthorizationHeaderMalformed', // non-head operations on virtual-hosted global bucket endpoints
	  'BadRequest', // head operations on virtual-hosted global bucket endpoints
	  'PermanentRedirect', // non-head operations on path-style or regional endpoints
	  301 // head operations on path-style or regional endpoints
	 ];
	
	var OBJECT_LAMBDA_SERVICE = 's3-object-lambda';
	
	AWS.util.update(AWS.S3.prototype, {
	  /**
	   * @api private
	   */
	  getSignatureVersion: function getSignatureVersion(request) {
	    var defaultApiVersion = this.api.signatureVersion;
	    var userDefinedVersion = this._originalConfig ? this._originalConfig.signatureVersion : null;
	    var regionDefinedVersion = this.config.signatureVersion;
	    var isPresigned = request ? request.isPresigned() : false;
	    /*
	      1) User defined version specified:
	        a) always return user defined version
	      2) No user defined version specified:
	        a) If not using presigned urls, default to V4
	        b) If using presigned urls, default to lowest version the region supports
	    */
	    if (userDefinedVersion) {
	      userDefinedVersion = userDefinedVersion === 'v2' ? 's3' : userDefinedVersion;
	      return userDefinedVersion;
	    }
	    if (isPresigned !== true) {
	      defaultApiVersion = 'v4';
	    } else if (regionDefinedVersion) {
	      defaultApiVersion = regionDefinedVersion;
	    }
	    return defaultApiVersion;
	  },
	
	  /**
	   * @api private
	   */
	  getSigningName: function getSigningName(req) {
	    if (req && req.operation === 'writeGetObjectResponse') {
	      return OBJECT_LAMBDA_SERVICE;
	    }
	
	    var _super = AWS.Service.prototype.getSigningName;
	    return (req && req._parsedArn && req._parsedArn.service)
	      ? req._parsedArn.service
	      : _super.call(this);
	  },
	
	  /**
	   * @api private
	   */
	  getSignerClass: function getSignerClass(request) {
	    var signatureVersion = this.getSignatureVersion(request);
	    return AWS.Signers.RequestSigner.getVersion(signatureVersion);
	  },
	
	  /**
	   * @api private
	   */
	  validateService: function validateService() {
	    var msg;
	    var messages = [];
	
	    // default to us-east-1 when no region is provided
	    if (!this.config.region) this.config.region = 'us-east-1';
	
	    if (!this.config.endpoint && this.config.s3BucketEndpoint) {
	      messages.push('An endpoint must be provided when configuring ' +
	                    '`s3BucketEndpoint` to true.');
	    }
	    if (messages.length === 1) {
	      msg = messages[0];
	    } else if (messages.length > 1) {
	      msg = 'Multiple configuration errors:\n' + messages.join('\n');
	    }
	    if (msg) {
	      throw AWS.util.error(new Error(),
	        {name: 'InvalidEndpoint', message: msg});
	    }
	  },
	
	  /**
	   * @api private
	   */
	  shouldDisableBodySigning: function shouldDisableBodySigning(request) {
	    var signerClass = this.getSignerClass();
	    if (this.config.s3DisableBodySigning === true && signerClass === AWS.Signers.V4
	        && request.httpRequest.endpoint.protocol === 'https:') {
	      return true;
	    }
	    return false;
	  },
	
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    var prependListener = true;
	    request.addListener('validate', this.validateScheme);
	    request.addListener('validate', this.validateBucketName, prependListener);
	    request.addListener('validate', this.optInUsEast1RegionalEndpoint, prependListener);
	
	    request.removeListener('validate',
	      AWS.EventListeners.Core.VALIDATE_REGION);
	    request.addListener('build', this.addContentType);
	    request.addListener('build', this.computeContentMd5);
	    request.addListener('build', this.computeSseCustomerKeyMd5);
	    request.addListener('build', this.populateURI);
	    request.addListener('afterBuild', this.addExpect100Continue);
	    request.addListener('extractError', this.extractError);
	    request.addListener('extractData', AWS.util.hoistPayloadMember);
	    request.addListener('extractData', this.extractData);
	    request.addListener('extractData', this.extractErrorFrom200Response);
	    request.addListener('beforePresign', this.prepareSignedUrl);
	    if (this.shouldDisableBodySigning(request))  {
	      request.removeListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
	      request.addListener('afterBuild', this.disableBodySigning);
	    }
	    //deal with ARNs supplied to Bucket
	    if (request.operation !== 'createBucket' && s3util.isArnInParam(request, 'Bucket')) {
	      // avoid duplicate parsing in the future
	      request._parsedArn = AWS.util.ARN.parse(request.params.Bucket);
	
	      request.removeListener('validate', this.validateBucketName);
	      request.removeListener('build', this.populateURI);
	      if (request._parsedArn.service === 's3') {
	        request.addListener('validate', s3util.validateS3AccessPointArn);
	        request.addListener('validate', this.validateArnResourceType);
	        request.addListener('validate', this.validateArnRegion);
	      } else if (request._parsedArn.service === 's3-outposts') {
	        request.addListener('validate', s3util.validateOutpostsAccessPointArn);
	        request.addListener('validate', s3util.validateOutpostsArn);
	        request.addListener('validate', s3util.validateArnRegion);
	      }
	      request.addListener('validate', s3util.validateArnAccount);
	      request.addListener('validate', s3util.validateArnService);
	      request.addListener('build', this.populateUriFromAccessPointArn);
	      request.addListener('build', s3util.validatePopulateUriFromArn);
	      return;
	    }
	    //listeners regarding region inference
	    request.addListener('validate', this.validateBucketEndpoint);
	    request.addListener('validate', this.correctBucketRegionFromCache);
	    request.onAsync('extractError', this.requestBucketRegion);
	    if (AWS.util.isBrowser()) {
	      request.onAsync('retry', this.reqRegionForNetworkingError);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateScheme: function(req) {
	    var params = req.params,
	        scheme = req.httpRequest.endpoint.protocol,
	        sensitive = params.SSECustomerKey || params.CopySourceSSECustomerKey;
	    if (sensitive && scheme !== 'https:') {
	      var msg = 'Cannot send SSE keys over HTTP. Set \'sslEnabled\'' +
	        'to \'true\' in your configuration';
	      throw AWS.util.error(new Error(),
	        { code: 'ConfigError', message: msg });
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateBucketEndpoint: function(req) {
	    if (!req.params.Bucket && req.service.config.s3BucketEndpoint) {
	      var msg = 'Cannot send requests to root API with `s3BucketEndpoint` set.';
	      throw AWS.util.error(new Error(),
	        { code: 'ConfigError', message: msg });
	    }
	  },
	
	  /**
	   * @api private
	   */
	   validateArnRegion: function validateArnRegion(req) {
	    s3util.validateArnRegion(req, { allowFipsEndpoint: true });
	  },
	
	  /**
	   * Validate resource-type supplied in S3 ARN
	   */
	  validateArnResourceType: function validateArnResourceType(req) {
	    var resource = req._parsedArn.resource;
	
	    if (
	      resource.indexOf('accesspoint:') !== 0 &&
	      resource.indexOf('accesspoint/') !== 0
	    ) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'ARN resource should begin with \'accesspoint/\''
	      });
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateBucketName: function validateBucketName(req) {
	    var service = req.service;
	    var signatureVersion = service.getSignatureVersion(req);
	    var bucket = req.params && req.params.Bucket;
	    var key = req.params && req.params.Key;
	    var slashIndex = bucket && bucket.indexOf('/');
	    if (bucket && slashIndex >= 0) {
	      if (typeof key === 'string' && slashIndex > 0) {
	        req.params = AWS.util.copy(req.params);
	        // Need to include trailing slash to match sigv2 behavior
	        var prefix = bucket.substr(slashIndex + 1) || '';
	        req.params.Key = prefix + '/' + key;
	        req.params.Bucket = bucket.substr(0, slashIndex);
	      } else if (signatureVersion === 'v4') {
	        var msg = 'Bucket names cannot contain forward slashes. Bucket: ' + bucket;
	        throw AWS.util.error(new Error(),
	          { code: 'InvalidBucket', message: msg });
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  isValidAccelerateOperation: function isValidAccelerateOperation(operation) {
	    var invalidOperations = [
	      'createBucket',
	      'deleteBucket',
	      'listBuckets'
	    ];
	    return invalidOperations.indexOf(operation) === -1;
	  },
	
	  /**
	   * When us-east-1 region endpoint configuration is set, in stead of sending request to
	   * global endpoint(e.g. 's3.amazonaws.com'), we will send request to
	   * 's3.us-east-1.amazonaws.com'.
	   * @api private
	   */
	  optInUsEast1RegionalEndpoint: function optInUsEast1RegionalEndpoint(req) {
	    var service = req.service;
	    var config = service.config;
	    config.s3UsEast1RegionalEndpoint = resolveRegionalEndpointsFlag(service._originalConfig, {
	      env: 'AWS_S3_US_EAST_1_REGIONAL_ENDPOINT',
	      sharedConfig: 's3_us_east_1_regional_endpoint',
	      clientConfig: 's3UsEast1RegionalEndpoint'
	    });
	    if (
	      !(service._originalConfig || {}).endpoint &&
	      req.httpRequest.region === 'us-east-1' &&
	      config.s3UsEast1RegionalEndpoint === 'regional' &&
	      req.httpRequest.endpoint.hostname.indexOf('s3.amazonaws.com') >= 0
	    ) {
	      var insertPoint = config.endpoint.indexOf('.amazonaws.com');
	      regionalEndpoint = config.endpoint.substring(0, insertPoint) +
	        '.us-east-1' + config.endpoint.substring(insertPoint);
	      req.httpRequest.updateEndpoint(regionalEndpoint);
	    }
	  },
	
	  /**
	   * S3 prefers dns-compatible bucket names to be moved from the uri path
	   * to the hostname as a sub-domain.  This is not possible, even for dns-compat
	   * buckets when using SSL and the bucket name contains a dot ('.').  The
	   * ssl wildcard certificate is only 1-level deep.
	   *
	   * @api private
	   */
	  populateURI: function populateURI(req) {
	    var httpRequest = req.httpRequest;
	    var b = req.params.Bucket;
	    var service = req.service;
	    var endpoint = httpRequest.endpoint;
	    if (b) {
	      if (!service.pathStyleBucketName(b)) {
	        if (service.config.useAccelerateEndpoint && service.isValidAccelerateOperation(req.operation)) {
	          if (service.config.useDualstackEndpoint) {
	            endpoint.hostname = b + '.s3-accelerate.dualstack.amazonaws.com';
	          } else {
	            endpoint.hostname = b + '.s3-accelerate.amazonaws.com';
	          }
	        } else if (!service.config.s3BucketEndpoint) {
	          endpoint.hostname =
	            b + '.' + endpoint.hostname;
	        }
	
	        var port = endpoint.port;
	        if (port !== 80 && port !== 443) {
	          endpoint.host = endpoint.hostname + ':' +
	            endpoint.port;
	        } else {
	          endpoint.host = endpoint.hostname;
	        }
	
	        httpRequest.virtualHostedBucket = b; // needed for signing the request
	        service.removeVirtualHostedBucketFromPath(req);
	      }
	    }
	  },
	
	  /**
	   * Takes the bucket name out of the path if bucket is virtual-hosted
	   *
	   * @api private
	   */
	  removeVirtualHostedBucketFromPath: function removeVirtualHostedBucketFromPath(req) {
	    var httpRequest = req.httpRequest;
	    var bucket = httpRequest.virtualHostedBucket;
	    if (bucket && httpRequest.path) {
	      if (req.params && req.params.Key) {
	        var encodedS3Key = '/' + AWS.util.uriEscapePath(req.params.Key);
	        if (httpRequest.path.indexOf(encodedS3Key) === 0 && (httpRequest.path.length === encodedS3Key.length || httpRequest.path[encodedS3Key.length] === '?')) {
	          //path only contains key or path contains only key and querystring
	          return;
	        }
	      }
	      httpRequest.path = httpRequest.path.replace(new RegExp('/' + bucket), '');
	      if (httpRequest.path[0] !== '/') {
	        httpRequest.path = '/' + httpRequest.path;
	      }
	    }
	  },
	
	  /**
	   * When user supply an access point ARN in the Bucket parameter, we need to
	   * populate the URI according to the ARN.
	   */
	  populateUriFromAccessPointArn: function populateUriFromAccessPointArn(req) {
	    var accessPointArn = req._parsedArn;
	
	    var isOutpostArn = accessPointArn.service === 's3-outposts';
	    var isObjectLambdaArn = accessPointArn.service === 's3-object-lambda';
	
	    var outpostsSuffix = isOutpostArn ? '.' + accessPointArn.outpostId: '';
	    var serviceName = isOutpostArn ? 's3-outposts': 's3-accesspoint';
	    var fipsSuffix = !isOutpostArn && req.service.config.useFipsEndpoint ? '-fips': '';
	    var dualStackSuffix = !isOutpostArn &&
	      req.service.config.useDualstackEndpoint ? '.dualstack' : '';
	
	    var endpoint = req.httpRequest.endpoint;
	    var dnsSuffix = regionUtil.getEndpointSuffix(accessPointArn.region);
	    var useArnRegion = req.service.config.s3UseArnRegion;
	
	    endpoint.hostname = [
	      accessPointArn.accessPoint + '-' + accessPointArn.accountId + outpostsSuffix,
	      serviceName + fipsSuffix + dualStackSuffix,
	      useArnRegion ? accessPointArn.region : req.service.config.region,
	      dnsSuffix
	    ].join('.');
	
	    if (isObjectLambdaArn) {
	      // should be in the format: "accesspoint/${accesspointName}"
	      var serviceName = 's3-object-lambda';
	      var accesspointName = accessPointArn.resource.split('/')[1];
	      var fipsSuffix = req.service.config.useFipsEndpoint ? '-fips': '';
	      endpoint.hostname = [
	        accesspointName + '-' + accessPointArn.accountId,
	        serviceName + fipsSuffix,
	        useArnRegion ? accessPointArn.region : req.service.config.region,
	        dnsSuffix
	      ].join('.');
	    }
	    endpoint.host = endpoint.hostname;
	    var encodedArn = AWS.util.uriEscape(req.params.Bucket);
	    var path = req.httpRequest.path;
	    //remove the Bucket value from path
	    req.httpRequest.path = path.replace(new RegExp('/' + encodedArn), '');
	    if (req.httpRequest.path[0] !== '/') {
	      req.httpRequest.path = '/' + req.httpRequest.path;
	    }
	    req.httpRequest.region = accessPointArn.region; //region used to sign
	  },
	
	  /**
	   * Adds Expect: 100-continue header if payload is greater-or-equal 1MB
	   * @api private
	   */
	  addExpect100Continue: function addExpect100Continue(req) {
	    var len = req.httpRequest.headers['Content-Length'];
	    if (AWS.util.isNode() && (len >= 1024 * 1024 || req.params.Body instanceof AWS.util.stream.Stream)) {
	      req.httpRequest.headers['Expect'] = '100-continue';
	    }
	  },
	
	  /**
	   * Adds a default content type if none is supplied.
	   *
	   * @api private
	   */
	  addContentType: function addContentType(req) {
	    var httpRequest = req.httpRequest;
	    if (httpRequest.method === 'GET' || httpRequest.method === 'HEAD') {
	      // Content-Type is not set in GET/HEAD requests
	      delete httpRequest.headers['Content-Type'];
	      return;
	    }
	
	    if (!httpRequest.headers['Content-Type']) { // always have a Content-Type
	      httpRequest.headers['Content-Type'] = 'application/octet-stream';
	    }
	
	    var contentType = httpRequest.headers['Content-Type'];
	    if (AWS.util.isBrowser()) {
	      if (typeof httpRequest.body === 'string' && !contentType.match(/;\s*charset=/)) {
	        var charset = '; charset=UTF-8';
	        httpRequest.headers['Content-Type'] += charset;
	      } else {
	        var replaceFn = function(_, prefix, charsetName) {
	          return prefix + charsetName.toUpperCase();
	        };
	
	        httpRequest.headers['Content-Type'] =
	          contentType.replace(/(;\s*charset=)(.+)$/, replaceFn);
	      }
	    }
	  },
	
	  /**
	   * Checks whether checksums should be computed for the request if it's not
	   * already set by {AWS.EventListeners.Core.COMPUTE_CHECKSUM}. It depends on
	   * whether {AWS.Config.computeChecksums} is set.
	   *
	   * @param req [AWS.Request] the request to check against
	   * @return [Boolean] whether to compute checksums for a request.
	   * @api private
	   */
	  willComputeChecksums: function willComputeChecksums(req) {
	    var rules = req.service.api.operations[req.operation].input.members;
	    var body = req.httpRequest.body;
	    var needsContentMD5 = req.service.config.computeChecksums &&
	      rules.ContentMD5 &&
	      !req.params.ContentMD5 &&
	      body &&
	      (AWS.util.Buffer.isBuffer(req.httpRequest.body) || typeof req.httpRequest.body === 'string');
	
	    // Sha256 signing disabled, and not a presigned url
	    if (needsContentMD5 && req.service.shouldDisableBodySigning(req) && !req.isPresigned()) {
	      return true;
	    }
	
	    // SigV2 and presign, for backwards compatibility purpose.
	    if (needsContentMD5 && this.getSignatureVersion(req) === 's3' && req.isPresigned()) {
	      return true;
	    }
	
	    return false;
	  },
	
	  /**
	   * A listener that computes the Content-MD5 and sets it in the header.
	   * This listener is to support S3-specific features like
	   * s3DisableBodySigning and SigV2 presign. Content MD5 logic for SigV4 is
	   * handled in AWS.EventListeners.Core.COMPUTE_CHECKSUM
	   *
	   * @api private
	   */
	  computeContentMd5: function computeContentMd5(req) {
	    if (req.service.willComputeChecksums(req)) {
	      var md5 = AWS.util.crypto.md5(req.httpRequest.body, 'base64');
	      req.httpRequest.headers['Content-MD5'] = md5;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  computeSseCustomerKeyMd5: function computeSseCustomerKeyMd5(req) {
	    var keys = {
	      SSECustomerKey: 'x-amz-server-side-encryption-customer-key-MD5',
	      CopySourceSSECustomerKey: 'x-amz-copy-source-server-side-encryption-customer-key-MD5'
	    };
	    AWS.util.each(keys, function(key, header) {
	      if (req.params[key]) {
	        var value = AWS.util.crypto.md5(req.params[key], 'base64');
	        req.httpRequest.headers[header] = value;
	      }
	    });
	  },
	
	  /**
	   * Returns true if the bucket name should be left in the URI path for
	   * a request to S3.  This function takes into account the current
	   * endpoint protocol (e.g. http or https).
	   *
	   * @api private
	   */
	  pathStyleBucketName: function pathStyleBucketName(bucketName) {
	    // user can force path style requests via the configuration
	    if (this.config.s3ForcePathStyle) return true;
	    if (this.config.s3BucketEndpoint) return false;
	
	    if (s3util.dnsCompatibleBucketName(bucketName)) {
	      return (this.config.sslEnabled && bucketName.match(/\./)) ? true : false;
	    } else {
	      return true; // not dns compatible names must always use path style
	    }
	  },
	
	  /**
	   * For COPY operations, some can be error even with status code 200.
	   * SDK treats the response as exception when response body indicates
	   * an exception or body is empty.
	   *
	   * @api private
	   */
	  extractErrorFrom200Response: function extractErrorFrom200Response(resp) {
	    if (!operationsWith200StatusCodeError[resp.request.operation]) return;
	    var httpResponse = resp.httpResponse;
	    if (httpResponse.body && httpResponse.body.toString().match('<Error>')) {
	      // Response body with '<Error>...</Error>' indicates an exception.
	      // Get S3 client object. In ManagedUpload, this.service refers to
	      // S3 client object.
	      resp.data = null;
	      var service = this.service ? this.service : this;
	      service.extractError(resp);
	      throw resp.error;
	    } else if (!httpResponse.body || !httpResponse.body.toString().match(/<[\w_]/)) {
	      // When body is empty or incomplete, S3 might stop the request on detecting client
	      // side aborting the request.
	      resp.data = null;
	      throw AWS.util.error(new Error(), {
	        code: 'InternalError',
	        message: 'S3 aborted request'
	      });
	    }
	  },
	
	  /**
	   * @return [Boolean] whether the error can be retried
	   * @api private
	   */
	  retryableError: function retryableError(error, request) {
	    if (operationsWith200StatusCodeError[request.operation] &&
	        error.statusCode === 200) {
	      return true;
	    } else if (request._requestRegionForBucket &&
	        request.service.bucketRegionCache[request._requestRegionForBucket]) {
	      return false;
	    } else if (error && error.code === 'RequestTimeout') {
	      return true;
	    } else if (error &&
	        regionRedirectErrorCodes.indexOf(error.code) != -1 &&
	        error.region && error.region != request.httpRequest.region) {
	      request.httpRequest.region = error.region;
	      if (error.statusCode === 301) {
	        request.service.updateReqBucketRegion(request);
	      }
	      return true;
	    } else {
	      var _super = AWS.Service.prototype.retryableError;
	      return _super.call(this, error, request);
	    }
	  },
	
	  /**
	   * Updates httpRequest with region. If region is not provided, then
	   * the httpRequest will be updated based on httpRequest.region
	   *
	   * @api private
	   */
	  updateReqBucketRegion: function updateReqBucketRegion(request, region) {
	    var httpRequest = request.httpRequest;
	    if (typeof region === 'string' && region.length) {
	      httpRequest.region = region;
	    }
	    if (!httpRequest.endpoint.host.match(/s3(?!-accelerate).*\.amazonaws\.com$/)) {
	      return;
	    }
	    var service = request.service;
	    var s3Config = service.config;
	    var s3BucketEndpoint = s3Config.s3BucketEndpoint;
	    if (s3BucketEndpoint) {
	      delete s3Config.s3BucketEndpoint;
	    }
	    var newConfig = AWS.util.copy(s3Config);
	    delete newConfig.endpoint;
	    newConfig.region = httpRequest.region;
	
	    httpRequest.endpoint = (new AWS.S3(newConfig)).endpoint;
	    service.populateURI(request);
	    s3Config.s3BucketEndpoint = s3BucketEndpoint;
	    httpRequest.headers.Host = httpRequest.endpoint.host;
	
	    if (request._asm.currentState === 'validate') {
	      request.removeListener('build', service.populateURI);
	      request.addListener('build', service.removeVirtualHostedBucketFromPath);
	    }
	  },
	
	  /**
	   * Provides a specialized parser for getBucketLocation -- all other
	   * operations are parsed by the super class.
	   *
	   * @api private
	   */
	  extractData: function extractData(resp) {
	    var req = resp.request;
	    if (req.operation === 'getBucketLocation') {
	      var match = resp.httpResponse.body.toString().match(/>(.+)<\/Location/);
	      delete resp.data['_'];
	      if (match) {
	        resp.data.LocationConstraint = match[1];
	      } else {
	        resp.data.LocationConstraint = '';
	      }
	    }
	    var bucket = req.params.Bucket || null;
	    if (req.operation === 'deleteBucket' && typeof bucket === 'string' && !resp.error) {
	      req.service.clearBucketRegionCache(bucket);
	    } else {
	      var headers = resp.httpResponse.headers || {};
	      var region = headers['x-amz-bucket-region'] || null;
	      if (!region && req.operation === 'createBucket' && !resp.error) {
	        var createBucketConfiguration = req.params.CreateBucketConfiguration;
	        if (!createBucketConfiguration) {
	          region = 'us-east-1';
	        } else if (createBucketConfiguration.LocationConstraint === 'EU') {
	          region = 'eu-west-1';
	        } else {
	          region = createBucketConfiguration.LocationConstraint;
	        }
	      }
	      if (region) {
	          if (bucket && region !== req.service.bucketRegionCache[bucket]) {
	            req.service.bucketRegionCache[bucket] = region;
	          }
	      }
	    }
	    req.service.extractRequestIds(resp);
	  },
	
	  /**
	   * Extracts an error object from the http response.
	   *
	   * @api private
	   */
	  extractError: function extractError(resp) {
	    var codes = {
	      304: 'NotModified',
	      403: 'Forbidden',
	      400: 'BadRequest',
	      404: 'NotFound'
	    };
	
	    var req = resp.request;
	    var code = resp.httpResponse.statusCode;
	    var body = resp.httpResponse.body || '';
	
	    var headers = resp.httpResponse.headers || {};
	    var region = headers['x-amz-bucket-region'] || null;
	    var bucket = req.params.Bucket || null;
	    var bucketRegionCache = req.service.bucketRegionCache;
	    if (region && bucket && region !== bucketRegionCache[bucket]) {
	      bucketRegionCache[bucket] = region;
	    }
	
	    var cachedRegion;
	    if (codes[code] && body.length === 0) {
	      if (bucket && !region) {
	        cachedRegion = bucketRegionCache[bucket] || null;
	        if (cachedRegion !== req.httpRequest.region) {
	          region = cachedRegion;
	        }
	      }
	      resp.error = AWS.util.error(new Error(), {
	        code: codes[code],
	        message: null,
	        region: region
	      });
	    } else {
	      var data = new AWS.XML.Parser().parse(body.toString());
	
	      if (data.Region && !region) {
	        region = data.Region;
	        if (bucket && region !== bucketRegionCache[bucket]) {
	          bucketRegionCache[bucket] = region;
	        }
	      } else if (bucket && !region && !data.Region) {
	        cachedRegion = bucketRegionCache[bucket] || null;
	        if (cachedRegion !== req.httpRequest.region) {
	          region = cachedRegion;
	        }
	      }
	
	      resp.error = AWS.util.error(new Error(), {
	        code: data.Code || code,
	        message: data.Message || null,
	        region: region
	      });
	    }
	    req.service.extractRequestIds(resp);
	  },
	
	  /**
	   * If region was not obtained synchronously, then send async request
	   * to get bucket region for errors resulting from wrong region.
	   *
	   * @api private
	   */
	  requestBucketRegion: function requestBucketRegion(resp, done) {
	    var error = resp.error;
	    var req = resp.request;
	    var bucket = req.params.Bucket || null;
	
	    if (!error || !bucket || error.region || req.operation === 'listObjects' ||
	        (AWS.util.isNode() && req.operation === 'headBucket') ||
	        (error.statusCode === 400 && req.operation !== 'headObject') ||
	        regionRedirectErrorCodes.indexOf(error.code) === -1) {
	      return done();
	    }
	    var reqOperation = AWS.util.isNode() ? 'headBucket' : 'listObjects';
	    var reqParams = {Bucket: bucket};
	    if (reqOperation === 'listObjects') reqParams.MaxKeys = 0;
	    var regionReq = req.service[reqOperation](reqParams);
	    regionReq._requestRegionForBucket = bucket;
	    regionReq.send(function() {
	      var region = req.service.bucketRegionCache[bucket] || null;
	      error.region = region;
	      done();
	    });
	  },
	
	   /**
	   * For browser only. If NetworkingError received, will attempt to obtain
	   * the bucket region.
	   *
	   * @api private
	   */
	   reqRegionForNetworkingError: function reqRegionForNetworkingError(resp, done) {
	    if (!AWS.util.isBrowser()) {
	      return done();
	    }
	    var error = resp.error;
	    var request = resp.request;
	    var bucket = request.params.Bucket;
	    if (!error || error.code !== 'NetworkingError' || !bucket ||
	        request.httpRequest.region === 'us-east-1') {
	      return done();
	    }
	    var service = request.service;
	    var bucketRegionCache = service.bucketRegionCache;
	    var cachedRegion = bucketRegionCache[bucket] || null;
	
	    if (cachedRegion && cachedRegion !== request.httpRequest.region) {
	      service.updateReqBucketRegion(request, cachedRegion);
	      done();
	    } else if (!s3util.dnsCompatibleBucketName(bucket)) {
	      service.updateReqBucketRegion(request, 'us-east-1');
	      if (bucketRegionCache[bucket] !== 'us-east-1') {
	        bucketRegionCache[bucket] = 'us-east-1';
	      }
	      done();
	    } else if (request.httpRequest.virtualHostedBucket) {
	      var getRegionReq = service.listObjects({Bucket: bucket, MaxKeys: 0});
	      service.updateReqBucketRegion(getRegionReq, 'us-east-1');
	      getRegionReq._requestRegionForBucket = bucket;
	
	      getRegionReq.send(function() {
	        var region = service.bucketRegionCache[bucket] || null;
	        if (region && region !== request.httpRequest.region) {
	          service.updateReqBucketRegion(request, region);
	        }
	        done();
	      });
	    } else {
	      // DNS-compatible path-style
	      // (s3ForcePathStyle or bucket name with dot over https)
	      // Cannot obtain region information for this case
	      done();
	    }
	   },
	
	  /**
	   * Cache for bucket region.
	   *
	   * @api private
	   */
	   bucketRegionCache: {},
	
	  /**
	   * Clears bucket region cache.
	   *
	   * @api private
	   */
	   clearBucketRegionCache: function(buckets) {
	    var bucketRegionCache = this.bucketRegionCache;
	    if (!buckets) {
	      buckets = Object.keys(bucketRegionCache);
	    } else if (typeof buckets === 'string') {
	      buckets = [buckets];
	    }
	    for (var i = 0; i < buckets.length; i++) {
	      delete bucketRegionCache[buckets[i]];
	    }
	    return bucketRegionCache;
	   },
	
	   /**
	    * Corrects request region if bucket's cached region is different
	    *
	    * @api private
	    */
	  correctBucketRegionFromCache: function correctBucketRegionFromCache(req) {
	    var bucket = req.params.Bucket || null;
	    if (bucket) {
	      var service = req.service;
	      var requestRegion = req.httpRequest.region;
	      var cachedRegion = service.bucketRegionCache[bucket];
	      if (cachedRegion && cachedRegion !== requestRegion) {
	        service.updateReqBucketRegion(req, cachedRegion);
	      }
	    }
	  },
	
	  /**
	   * Extracts S3 specific request ids from the http response.
	   *
	   * @api private
	   */
	  extractRequestIds: function extractRequestIds(resp) {
	    var extendedRequestId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-id-2'] : null;
	    var cfId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-cf-id'] : null;
	    resp.extendedRequestId = extendedRequestId;
	    resp.cfId = cfId;
	
	    if (resp.error) {
	      resp.error.requestId = resp.requestId || null;
	      resp.error.extendedRequestId = extendedRequestId;
	      resp.error.cfId = cfId;
	    }
	  },
	
	  /**
	   * Get a pre-signed URL for a given operation name.
	   *
	   * @note You must ensure that you have static or previously resolved
	   *   credentials if you call this method synchronously (with no callback),
	   *   otherwise it may not properly sign the request. If you cannot guarantee
	   *   this (you are using an asynchronous credential provider, i.e., EC2
	   *   IAM roles), you should always call this method with an asynchronous
	   *   callback.
	   * @note Not all operation parameters are supported when using pre-signed
	   *   URLs. Certain parameters, such as `SSECustomerKey`, `ACL`, `Expires`,
	   *   `ContentLength`, or `Tagging` must be provided as headers when sending a
	   *   request. If you are using pre-signed URLs to upload from a browser and
	   *   need to use these fields, see {createPresignedPost}.
	   * @note The default signer allows altering the request by adding corresponding
	   *   headers to set some parameters (e.g. Range) and these added parameters
	   *   won't be signed. You must use signatureVersion v4 to to include these
	   *   parameters in the signed portion of the URL and enforce exact matching
	   *   between headers and signed params in the URL.
	   * @note This operation cannot be used with a promise. See note above regarding
	   *   asynchronous credentials and use with a callback.
	   * @param operation [String] the name of the operation to call
	   * @param params [map] parameters to pass to the operation. See the given
	   *   operation for the expected operation parameters. In addition, you can
	   *   also pass the "Expires" parameter to inform S3 how long the URL should
	   *   work for.
	   * @option params Expires [Integer] (900) the number of seconds to expire
	   *   the pre-signed URL operation in. Defaults to 15 minutes.
	   * @param callback [Function] if a callback is provided, this function will
	   *   pass the URL as the second parameter (after the error parameter) to
	   *   the callback function.
	   * @return [String] if called synchronously (with no callback), returns the
	   *   signed URL.
	   * @return [null] nothing is returned if a callback is provided.
	   * @example Pre-signing a getObject operation (synchronously)
	   *   var params = {Bucket: 'bucket', Key: 'key'};
	   *   var url = s3.getSignedUrl('getObject', params);
	   *   console.log('The URL is', url);
	   * @example Pre-signing a putObject (asynchronously)
	   *   var params = {Bucket: 'bucket', Key: 'key'};
	   *   s3.getSignedUrl('putObject', params, function (err, url) {
	   *     console.log('The URL is', url);
	   *   });
	   * @example Pre-signing a putObject operation with a specific payload
	   *   var params = {Bucket: 'bucket', Key: 'key', Body: 'body'};
	   *   var url = s3.getSignedUrl('putObject', params);
	   *   console.log('The URL is', url);
	   * @example Passing in a 1-minute expiry time for a pre-signed URL
	   *   var params = {Bucket: 'bucket', Key: 'key', Expires: 60};
	   *   var url = s3.getSignedUrl('getObject', params);
	   *   console.log('The URL is', url); // expires in 60 seconds
	   */
	  getSignedUrl: function getSignedUrl(operation, params, callback) {
	    params = AWS.util.copy(params || {});
	    var expires = params.Expires || 900;
	
	    if (typeof expires !== 'number') {
	      throw AWS.util.error(new Error(),
	        { code: 'InvalidParameterException', message: 'The expiration must be a number, received ' + typeof expires });
	    }
	
	    delete params.Expires; // we can't validate this
	    var request = this.makeRequest(operation, params);
	
	    if (callback) {
	      AWS.util.defer(function() {
	        request.presign(expires, callback);
	      });
	    } else {
	      return request.presign(expires, callback);
	    }
	  },
	
	  /**
	   * @!method  getSignedUrlPromise()
	   *   Returns a 'thenable' promise that will be resolved with a pre-signed URL
	   *   for a given operation name.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @note Not all operation parameters are supported when using pre-signed
	   *      URLs. Certain parameters, such as `SSECustomerKey`, `ACL`, `Expires`,
	   *      `ContentLength`, or `Tagging` must be provided as headers when sending a
	   *      request. If you are using pre-signed URLs to upload from a browser and
	   *      need to use these fields, see {createPresignedPost}.
	   *   @param operation [String] the name of the operation to call
	   *   @param params [map] parameters to pass to the operation. See the given
	   *      operation for the expected operation parameters. In addition, you can
	   *      also pass the "Expires" parameter to inform S3 how long the URL should
	   *      work for.
	   *   @option params Expires [Integer] (900) the number of seconds to expire
	   *      the pre-signed URL operation in. Defaults to 15 minutes.
	   *   @callback fulfilledCallback function(url)
	   *     Called if the promise is fulfilled.
	   *     @param url [String] the signed url
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `refresh` call.
	   *   @example Pre-signing a getObject operation
	   *      var params = {Bucket: 'bucket', Key: 'key'};
	   *      var promise = s3.getSignedUrlPromise('getObject', params);
	   *      promise.then(function(url) {
	   *        console.log('The URL is', url);
	   *      }, function(err) { ... });
	   *   @example Pre-signing a putObject operation with a specific payload
	   *      var params = {Bucket: 'bucket', Key: 'key', Body: 'body'};
	   *      var promise = s3.getSignedUrlPromise('putObject', params);
	   *      promise.then(function(url) {
	   *        console.log('The URL is', url);
	   *      }, function(err) { ... });
	   *   @example Passing in a 1-minute expiry time for a pre-signed URL
	   *      var params = {Bucket: 'bucket', Key: 'key', Expires: 60};
	   *      var promise = s3.getSignedUrlPromise('getObject', params);
	   *      promise.then(function(url) {
	   *        console.log('The URL is', url);
	   *      }, function(err) { ... });
	   */
	
	  /**
	   * Get a pre-signed POST policy to support uploading to S3 directly from an
	   * HTML form.
	   *
	   * @param params [map]
	   * @option params Bucket [String]     The bucket to which the post should be
	   *                                    uploaded
	   * @option params Expires [Integer]   (3600) The number of seconds for which
	   *                                    the presigned policy should be valid.
	   * @option params Conditions [Array]  An array of conditions that must be met
	   *                                    for the presigned policy to allow the
	   *                                    upload. This can include required tags,
	   *                                    the accepted range for content lengths,
	   *                                    etc.
	   * @see http://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html
	   * @option params Fields [map]        Fields to include in the form. All
	   *                                    values passed in as fields will be
	   *                                    signed as exact match conditions.
	   * @param callback [Function]
	   *
	   * @note All fields passed in when creating presigned post data will be signed
	   *   as exact match conditions. Any fields that will be interpolated by S3
	   *   must be added to the fields hash after signing, and an appropriate
	   *   condition for such fields must be explicitly added to the Conditions
	   *   array passed to this function before signing.
	   *
	   * @example Presiging post data with a known key
	   *   var params = {
	   *     Bucket: 'bucket',
	   *     Fields: {
	   *       key: 'key'
	   *     }
	   *   };
	   *   s3.createPresignedPost(params, function(err, data) {
	   *     if (err) {
	   *       console.error('Presigning post data encountered an error', err);
	   *     } else {
	   *       console.log('The post data is', data);
	   *     }
	   *   });
	   *
	   * @example Presigning post data with an interpolated key
	   *   var params = {
	   *     Bucket: 'bucket',
	   *     Conditions: [
	   *       ['starts-with', '$key', 'path/to/uploads/']
	   *     ]
	   *   };
	   *   s3.createPresignedPost(params, function(err, data) {
	   *     if (err) {
	   *       console.error('Presigning post data encountered an error', err);
	   *     } else {
	   *       data.Fields.key = 'path/to/uploads/${filename}';
	   *       console.log('The post data is', data);
	   *     }
	   *   });
	   *
	   * @note You must ensure that you have static or previously resolved
	   *   credentials if you call this method synchronously (with no callback),
	   *   otherwise it may not properly sign the request. If you cannot guarantee
	   *   this (you are using an asynchronous credential provider, i.e., EC2
	   *   IAM roles), you should always call this method with an asynchronous
	   *   callback.
	   *
	   * @return [map]  If called synchronously (with no callback), returns a hash
	   *                with the url to set as the form action and a hash of fields
	   *                to include in the form.
	   * @return [null] Nothing is returned if a callback is provided.
	   *
	   * @callback callback function (err, data)
	   *  @param err [Error] the error object returned from the policy signer
	   *  @param data [map] The data necessary to construct an HTML form
	   *  @param data.url [String] The URL to use as the action of the form
	   *  @param data.fields [map] A hash of fields that must be included in the
	   *                           form for the upload to succeed. This hash will
	   *                           include the signed POST policy, your access key
	   *                           ID and security token (if present), etc. These
	   *                           may be safely included as input elements of type
	   *                           'hidden.'
	   */
	  createPresignedPost: function createPresignedPost(params, callback) {
	    if (typeof params === 'function' && callback === undefined) {
	      callback = params;
	      params = null;
	    }
	
	    params = AWS.util.copy(params || {});
	    var boundParams = this.config.params || {};
	    var bucket = params.Bucket || boundParams.Bucket,
	      self = this,
	      config = this.config,
	      endpoint = AWS.util.copy(this.endpoint);
	    if (!config.s3BucketEndpoint) {
	      endpoint.pathname = '/' + bucket;
	    }
	
	    function finalizePost() {
	      return {
	        url: AWS.util.urlFormat(endpoint),
	        fields: self.preparePostFields(
	          config.credentials,
	          config.region,
	          bucket,
	          params.Fields,
	          params.Conditions,
	          params.Expires
	        )
	      };
	    }
	
	    if (callback) {
	      config.getCredentials(function (err) {
	        if (err) {
	          callback(err);
	        } else {
	          try {
	            callback(null, finalizePost());
	          } catch (err) {
	            callback(err);
	          }
	        }
	      });
	    } else {
	      return finalizePost();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  preparePostFields: function preparePostFields(
	    credentials,
	    region,
	    bucket,
	    fields,
	    conditions,
	    expiresInSeconds
	  ) {
	    var now = this.getSkewCorrectedDate();
	    if (!credentials || !region || !bucket) {
	      throw new Error('Unable to create a POST object policy without a bucket,'
	        + ' region, and credentials');
	    }
	    fields = AWS.util.copy(fields || {});
	    conditions = (conditions || []).slice(0);
	    expiresInSeconds = expiresInSeconds || 3600;
	
	    var signingDate = AWS.util.date.iso8601(now).replace(/[:\-]|\.\d{3}/g, '');
	    var shortDate = signingDate.substr(0, 8);
	    var scope = v4Credentials.createScope(shortDate, region, 's3');
	    var credential = credentials.accessKeyId + '/' + scope;
	
	    fields['bucket'] = bucket;
	    fields['X-Amz-Algorithm'] = 'AWS4-HMAC-SHA256';
	    fields['X-Amz-Credential'] = credential;
	    fields['X-Amz-Date'] = signingDate;
	    if (credentials.sessionToken) {
	      fields['X-Amz-Security-Token'] = credentials.sessionToken;
	    }
	    for (var field in fields) {
	      if (fields.hasOwnProperty(field)) {
	        var condition = {};
	        condition[field] = fields[field];
	        conditions.push(condition);
	      }
	    }
	
	    fields.Policy = this.preparePostPolicy(
	      new Date(now.valueOf() + expiresInSeconds * 1000),
	      conditions
	    );
	    fields['X-Amz-Signature'] = AWS.util.crypto.hmac(
	      v4Credentials.getSigningKey(credentials, shortDate, region, 's3', true),
	      fields.Policy,
	      'hex'
	    );
	
	    return fields;
	  },
	
	  /**
	   * @api private
	   */
	  preparePostPolicy: function preparePostPolicy(expiration, conditions) {
	    return AWS.util.base64.encode(JSON.stringify({
	      expiration: AWS.util.date.iso8601(expiration),
	      conditions: conditions
	    }));
	  },
	
	  /**
	   * @api private
	   */
	  prepareSignedUrl: function prepareSignedUrl(request) {
	    request.addListener('validate', request.service.noPresignedContentLength);
	    request.removeListener('build', request.service.addContentType);
	    if (!request.params.Body) {
	      // no Content-MD5/SHA-256 if body is not provided
	      request.removeListener('build', request.service.computeContentMd5);
	    } else {
	      request.addListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
	    }
	  },
	
	  /**
	   * @api private
	   * @param request
	   */
	  disableBodySigning: function disableBodySigning(request) {
	    var headers = request.httpRequest.headers;
	    // Add the header to anything that isn't a presigned url, unless that presigned url had a body defined
	    if (!Object.prototype.hasOwnProperty.call(headers, 'presigned-expires')) {
	      headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
	    }
	  },
	
	  /**
	   * @api private
	   */
	  noPresignedContentLength: function noPresignedContentLength(request) {
	    if (request.params.ContentLength !== undefined) {
	      throw AWS.util.error(new Error(), {code: 'UnexpectedParameter',
	        message: 'ContentLength is not supported in pre-signed URLs.'});
	    }
	  },
	
	  createBucket: function createBucket(params, callback) {
	    // When creating a bucket *outside* the classic region, the location
	    // constraint must be set for the bucket and it must match the endpoint.
	    // This chunk of code will set the location constraint param based
	    // on the region (when possible), but it will not override a passed-in
	    // location constraint.
	    if (typeof params === 'function' || !params) {
	      callback = callback || params;
	      params = {};
	    }
	    var hostname = this.endpoint.hostname;
	    // copy params so that appending keys does not unintentioinallly
	    // mutate params object argument passed in by user
	    var copiedParams = AWS.util.copy(params);
	
	    if (hostname !== this.api.globalEndpoint && !params.CreateBucketConfiguration) {
	      copiedParams.CreateBucketConfiguration = { LocationConstraint: this.config.region };
	    }
	    return this.makeRequest('createBucket', copiedParams, callback);
	  },
	
	  writeGetObjectResponse: function writeGetObjectResponse(params, callback) {
	
	    var request = this.makeRequest('writeGetObjectResponse', AWS.util.copy(params), callback);
	    var hostname = this.endpoint.hostname;
	    if (hostname.indexOf(this.config.region) !== -1) {
	      // hostname specifies a region already
	      hostname = hostname.replace('s3.', OBJECT_LAMBDA_SERVICE + '.');
	    } else {
	      // Hostname doesn't have a region.
	      // Object Lambda requires an explicit region.
	      hostname = hostname.replace('s3.', OBJECT_LAMBDA_SERVICE + '.' + this.config.region + '.');
	    }
	
	    request.httpRequest.endpoint = new AWS.Endpoint(hostname, this.config);
	    return request;
	  },
	
	  /**
	   * @see AWS.S3.ManagedUpload
	   * @overload upload(params = {}, [options], [callback])
	   *   Uploads an arbitrarily sized buffer, blob, or stream, using intelligent
	   *   concurrent handling of parts if the payload is large enough. You can
	   *   configure the concurrent queue size by setting `options`. Note that this
	   *   is the only operation for which the SDK can retry requests with stream
	   *   bodies.
	   *
	   *   @param (see AWS.S3.putObject)
	   *   @option (see AWS.S3.ManagedUpload.constructor)
	   *   @return [AWS.S3.ManagedUpload] the managed upload object that can call
	   *     `send()` or track progress.
	   *   @example Uploading a stream object
	   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *     s3.upload(params, function(err, data) {
	   *       console.log(err, data);
	   *     });
	   *   @example Uploading a stream with concurrency of 1 and partSize of 10mb
	   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *     var options = {partSize: 10 * 1024 * 1024, queueSize: 1};
	   *     s3.upload(params, options, function(err, data) {
	   *       console.log(err, data);
	   *     });
	   * @callback callback function(err, data)
	   *   @param err [Error] an error or null if no error occurred.
	   *   @param data [map] The response data from the successful upload:
	   *   @param data.Location [String] the URL of the uploaded object
	   *   @param data.ETag [String] the ETag of the uploaded object
	   *   @param data.Bucket [String]  the bucket to which the object was uploaded
	   *   @param data.Key [String] the key to which the object was uploaded
	   */
	  upload: function upload(params, options, callback) {
	    if (typeof options === 'function' && callback === undefined) {
	      callback = options;
	      options = null;
	    }
	
	    options = options || {};
	    options = AWS.util.merge(options || {}, {service: this, params: params});
	
	    var uploader = new AWS.S3.ManagedUpload(options);
	    if (typeof callback === 'function') uploader.send(callback);
	    return uploader;
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.S3.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.getSignedUrlPromise = AWS.util.promisifyMethod('getSignedUrl', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.S3.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.getSignedUrlPromise;
	};
	
	AWS.util.addPromises(AWS.S3);
	
	},{"../config_regional_endpoint":341,"../core":342,"../region_config":386,"../s3/managed_upload":391,"../signers/v4_credentials":416,"./s3util":406}],406:[function(require,module,exports){
	(function (process){(function (){
	var AWS = require('../core');
	var regionUtil = require('../region_config');
	
	var s3util = {
	  /**
	   * @api private
	   */
	  isArnInParam: function isArnInParam(req, paramName) {
	    var inputShape = (req.service.api.operations[req.operation] || {}).input || {};
	    var inputMembers = inputShape.members || {};
	    if (!req.params[paramName] || !inputMembers[paramName]) return false;
	    return AWS.util.ARN.validate(req.params[paramName]);
	  },
	
	  /**
	   * Validate service component from ARN supplied in Bucket parameter
	   */
	  validateArnService: function validateArnService(req) {
	    var parsedArn = req._parsedArn;
	
	    if (parsedArn.service !== 's3'
	      && parsedArn.service !== 's3-outposts'
	      && parsedArn.service !== 's3-object-lambda') {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'expect \'s3\' or \'s3-outposts\' or \'s3-object-lambda\' in ARN service component'
	      });
	    }
	  },
	
	  /**
	   * Validate account ID from ARN supplied in Bucket parameter is a valid account
	   */
	  validateArnAccount: function validateArnAccount(req) {
	    var parsedArn = req._parsedArn;
	
	    if (!/[0-9]{12}/.exec(parsedArn.accountId)) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'ARN accountID does not match regex "[0-9]{12}"'
	      });
	    }
	  },
	
	  /**
	   * Validate ARN supplied in Bucket parameter is a valid access point ARN
	   */
	  validateS3AccessPointArn: function validateS3AccessPointArn(req) {
	    var parsedArn = req._parsedArn;
	
	    //can be ':' or '/'
	    var delimiter = parsedArn.resource['accesspoint'.length];
	
	    if (parsedArn.resource.split(delimiter).length !== 2) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Access Point ARN should have one resource accesspoint/{accesspointName}'
	      });
	    }
	
	    var accessPoint = parsedArn.resource.split(delimiter)[1];
	    var accessPointPrefix = accessPoint + '-' + parsedArn.accountId;
	    if (!s3util.dnsCompatibleBucketName(accessPointPrefix) || accessPointPrefix.match(/\./)) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Access point resource in ARN is not DNS compatible. Got ' + accessPoint
	      });
	    }
	
	    //set parsed valid access point
	    req._parsedArn.accessPoint = accessPoint;
	  },
	
	  /**
	   * Validate Outposts ARN supplied in Bucket parameter is a valid outposts ARN
	   */
	  validateOutpostsArn: function validateOutpostsArn(req) {
	    var parsedArn = req._parsedArn;
	
	    if (
	      parsedArn.resource.indexOf('outpost:') !== 0 &&
	      parsedArn.resource.indexOf('outpost/') !== 0
	    ) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'ARN resource should begin with \'outpost/\''
	      });
	    }
	
	    //can be ':' or '/'
	    var delimiter = parsedArn.resource['outpost'.length];
	    var outpostId = parsedArn.resource.split(delimiter)[1];
	    var dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
	    if (!dnsHostRegex.test(outpostId)) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Outpost resource in ARN is not DNS compatible. Got ' + outpostId
	      });
	    }
	    req._parsedArn.outpostId = outpostId;
	  },
	
	  /**
	   * Validate Outposts ARN supplied in Bucket parameter is a valid outposts ARN
	   */
	  validateOutpostsAccessPointArn: function validateOutpostsAccessPointArn(req) {
	    var parsedArn = req._parsedArn;
	
	    //can be ':' or '/'
	    var delimiter = parsedArn.resource['outpost'.length];
	
	    if (parsedArn.resource.split(delimiter).length !== 4) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Outposts ARN should have two resources outpost/{outpostId}/accesspoint/{accesspointName}'
	      });
	    }
	
	    var accessPoint = parsedArn.resource.split(delimiter)[3];
	    var accessPointPrefix = accessPoint + '-' + parsedArn.accountId;
	    if (!s3util.dnsCompatibleBucketName(accessPointPrefix) || accessPointPrefix.match(/\./)) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: 'Access point resource in ARN is not DNS compatible. Got ' + accessPoint
	      });
	    }
	
	    //set parsed valid access point
	    req._parsedArn.accessPoint = accessPoint;
	  },
	
	  /**
	   * Validate region field in ARN supplied in Bucket parameter is a valid region
	   */
	  validateArnRegion: function validateArnRegion(req, options) {
	    if (options === undefined) {
	      options = {};
	    }
	
	    var useArnRegion = s3util.loadUseArnRegionConfig(req);
	    var regionFromArn = req._parsedArn.region;
	    var clientRegion = req.service.config.region;
	    var useFipsEndpoint = req.service.config.useFipsEndpoint;
	    var allowFipsEndpoint = options.allowFipsEndpoint || false;
	
	    if (!regionFromArn) {
	      var message = 'ARN region is empty';
	      if (req._parsedArn.service === 's3') {
	        message = message + '\nYou may want to use multi-regional ARN. The feature is not supported in current SDK. ' +
	        'You should consider switching to V3(https://github.com/aws/aws-sdk-js-v3).';
	      }
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidARN',
	        message: message
	      });
	    }
	
	    if (useFipsEndpoint && !allowFipsEndpoint) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'ARN endpoint is not compatible with FIPS region'
	      });
	    }
	
	    if (regionFromArn.indexOf('fips') >= 0) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'FIPS region not allowed in ARN'
	      });
	    }
	
	    if (!useArnRegion && regionFromArn !== clientRegion) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'Configured region conflicts with access point region'
	      });
	    } else if (
	      useArnRegion &&
	      regionUtil.getEndpointSuffix(regionFromArn) !== regionUtil.getEndpointSuffix(clientRegion)
	    ) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'Configured region and access point region not in same partition'
	      });
	    }
	
	    if (req.service.config.useAccelerateEndpoint) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'useAccelerateEndpoint config is not supported with access point ARN'
	      });
	    }
	
	    if (req._parsedArn.service === 's3-outposts' && req.service.config.useDualstackEndpoint) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'Dualstack is not supported with outposts access point ARN'
	      });
	    }
	  },
	
	  loadUseArnRegionConfig: function loadUseArnRegionConfig(req) {
	    var envName = 'AWS_S3_USE_ARN_REGION';
	    var configName = 's3_use_arn_region';
	    var useArnRegion = true;
	    var originalConfig = req.service._originalConfig || {};
	    if (req.service.config.s3UseArnRegion !== undefined) {
	      return req.service.config.s3UseArnRegion;
	    } else if (originalConfig.s3UseArnRegion !== undefined) {
	      useArnRegion = originalConfig.s3UseArnRegion === true;
	    } else if (AWS.util.isNode()) {
	      //load from environmental variable AWS_USE_ARN_REGION
	      if (process.env[envName]) {
	        var value = process.env[envName].trim().toLowerCase();
	        if (['false', 'true'].indexOf(value) < 0) {
	          throw AWS.util.error(new Error(), {
	            code: 'InvalidConfiguration',
	            message: envName + ' only accepts true or false. Got ' + process.env[envName],
	            retryable: false
	          });
	        }
	        useArnRegion = value === 'true';
	      } else {  //load from shared config property use_arn_region
	        var profiles = {};
	        var profile = {};
	        try {
	          profiles = AWS.util.getProfilesFromSharedConfig(AWS.util.iniLoader);
	          profile = profiles[process.env.AWS_PROFILE || AWS.util.defaultProfile];
	        } catch (e) {}
	        if (profile[configName]) {
	          if (['false', 'true'].indexOf(profile[configName].trim().toLowerCase()) < 0) {
	            throw AWS.util.error(new Error(), {
	              code: 'InvalidConfiguration',
	              message: configName + ' only accepts true or false. Got ' + profile[configName],
	              retryable: false
	            });
	          }
	          useArnRegion = profile[configName].trim().toLowerCase() === 'true';
	        }
	      }
	    }
	    req.service.config.s3UseArnRegion = useArnRegion;
	    return useArnRegion;
	  },
	
	  /**
	   * Validations before URI can be populated
	   */
	  validatePopulateUriFromArn: function validatePopulateUriFromArn(req) {
	    if (req.service._originalConfig && req.service._originalConfig.endpoint) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'Custom endpoint is not compatible with access point ARN'
	      });
	    }
	
	    if (req.service.config.s3ForcePathStyle) {
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidConfiguration',
	        message: 'Cannot construct path-style endpoint with access point'
	      });
	    }
	  },
	
	  /**
	   * Returns true if the bucket name is DNS compatible.  Buckets created
	   * outside of the classic region MUST be DNS compatible.
	   *
	   * @api private
	   */
	  dnsCompatibleBucketName: function dnsCompatibleBucketName(bucketName) {
	    var b = bucketName;
	    var domain = new RegExp(/^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/);
	    var ipAddress = new RegExp(/(\d+\.){3}\d+/);
	    var dots = new RegExp(/\.\./);
	    return (b.match(domain) && !b.match(ipAddress) && !b.match(dots)) ? true : false;
	  },
	};
	
	/**
	 * @api private
	 */
	module.exports = s3util;
	
	}).call(this)}).call(this,require('_process'))
	},{"../core":342,"../region_config":386,"_process":432}],407:[function(require,module,exports){
	var AWS = require('../core');
	
	AWS.util.update(AWS.SQS.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('build', this.buildEndpoint);
	
	    if (request.service.config.computeChecksums) {
	      if (request.operation === 'sendMessage') {
	        request.addListener('extractData', this.verifySendMessageChecksum);
	      } else if (request.operation === 'sendMessageBatch') {
	        request.addListener('extractData', this.verifySendMessageBatchChecksum);
	      } else if (request.operation === 'receiveMessage') {
	        request.addListener('extractData', this.verifyReceiveMessageChecksum);
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  verifySendMessageChecksum: function verifySendMessageChecksum(response) {
	    if (!response.data) return;
	
	    var md5 = response.data.MD5OfMessageBody;
	    var body = this.params.MessageBody;
	    var calculatedMd5 = this.service.calculateChecksum(body);
	    if (calculatedMd5 !== md5) {
	      var msg = 'Got "' + response.data.MD5OfMessageBody +
	        '", expecting "' + calculatedMd5 + '".';
	      this.service.throwInvalidChecksumError(response,
	        [response.data.MessageId], msg);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  verifySendMessageBatchChecksum: function verifySendMessageBatchChecksum(response) {
	    if (!response.data) return;
	
	    var service = this.service;
	    var entries = {};
	    var errors = [];
	    var messageIds = [];
	    AWS.util.arrayEach(response.data.Successful, function (entry) {
	      entries[entry.Id] = entry;
	    });
	    AWS.util.arrayEach(this.params.Entries, function (entry) {
	      if (entries[entry.Id]) {
	        var md5 = entries[entry.Id].MD5OfMessageBody;
	        var body = entry.MessageBody;
	        if (!service.isChecksumValid(md5, body)) {
	          errors.push(entry.Id);
	          messageIds.push(entries[entry.Id].MessageId);
	        }
	      }
	    });
	
	    if (errors.length > 0) {
	      service.throwInvalidChecksumError(response, messageIds,
	        'Invalid messages: ' + errors.join(', '));
	    }
	  },
	
	  /**
	   * @api private
	   */
	  verifyReceiveMessageChecksum: function verifyReceiveMessageChecksum(response) {
	    if (!response.data) return;
	
	    var service = this.service;
	    var messageIds = [];
	    AWS.util.arrayEach(response.data.Messages, function(message) {
	      var md5 = message.MD5OfBody;
	      var body = message.Body;
	      if (!service.isChecksumValid(md5, body)) {
	        messageIds.push(message.MessageId);
	      }
	    });
	
	    if (messageIds.length > 0) {
	      service.throwInvalidChecksumError(response, messageIds,
	        'Invalid messages: ' + messageIds.join(', '));
	    }
	  },
	
	  /**
	   * @api private
	   */
	  throwInvalidChecksumError: function throwInvalidChecksumError(response, ids, message) {
	    response.error = AWS.util.error(new Error(), {
	      retryable: true,
	      code: 'InvalidChecksum',
	      messageIds: ids,
	      message: response.request.operation +
	               ' returned an invalid MD5 response. ' + message
	    });
	  },
	
	  /**
	   * @api private
	   */
	  isChecksumValid: function isChecksumValid(checksum, data) {
	    return this.calculateChecksum(data) === checksum;
	  },
	
	  /**
	   * @api private
	   */
	  calculateChecksum: function calculateChecksum(data) {
	    return AWS.util.crypto.md5(data, 'hex');
	  },
	
	  /**
	   * @api private
	   */
	  buildEndpoint: function buildEndpoint(request) {
	    var url = request.httpRequest.params.QueueUrl;
	    if (url) {
	      request.httpRequest.endpoint = new AWS.Endpoint(url);
	
	      // signature version 4 requires the region name to be set,
	      // sqs queue urls contain the region name
	      var matches = request.httpRequest.endpoint.host.match(/^sqs\.(.+?)\./);
	      if (matches) request.httpRequest.region = matches[1];
	    }
	  }
	});
	
	},{"../core":342}],408:[function(require,module,exports){
	var AWS = require('../core');
	var resolveRegionalEndpointsFlag = require('../config_regional_endpoint');
	var ENV_REGIONAL_ENDPOINT_ENABLED = 'AWS_STS_REGIONAL_ENDPOINTS';
	var CONFIG_REGIONAL_ENDPOINT_ENABLED = 'sts_regional_endpoints';
	
	AWS.util.update(AWS.STS.prototype, {
	  /**
	   * @overload credentialsFrom(data, credentials = null)
	   *   Creates a credentials object from STS response data containing
	   *   credentials information. Useful for quickly setting AWS credentials.
	   *
	   *   @note This is a low-level utility function. If you want to load temporary
	   *     credentials into your process for subsequent requests to AWS resources,
	   *     you should use {AWS.TemporaryCredentials} instead.
	   *   @param data [map] data retrieved from a call to {getFederatedToken},
	   *     {getSessionToken}, {assumeRole}, or {assumeRoleWithWebIdentity}.
	   *   @param credentials [AWS.Credentials] an optional credentials object to
	   *     fill instead of creating a new object. Useful when modifying an
	   *     existing credentials object from a refresh call.
	   *   @return [AWS.TemporaryCredentials] the set of temporary credentials
	   *     loaded from a raw STS operation response.
	   *   @example Using credentialsFrom to load global AWS credentials
	   *     var sts = new AWS.STS();
	   *     sts.getSessionToken(function (err, data) {
	   *       if (err) console.log("Error getting credentials");
	   *       else {
	   *         AWS.config.credentials = sts.credentialsFrom(data);
	   *       }
	   *     });
	   *   @see AWS.TemporaryCredentials
	   */
	  credentialsFrom: function credentialsFrom(data, credentials) {
	    if (!data) return null;
	    if (!credentials) credentials = new AWS.TemporaryCredentials();
	    credentials.expired = false;
	    credentials.accessKeyId = data.Credentials.AccessKeyId;
	    credentials.secretAccessKey = data.Credentials.SecretAccessKey;
	    credentials.sessionToken = data.Credentials.SessionToken;
	    credentials.expireTime = data.Credentials.Expiration;
	    return credentials;
	  },
	
	  assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
	    return this.makeUnauthenticatedRequest('assumeRoleWithWebIdentity', params, callback);
	  },
	
	  assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
	    return this.makeUnauthenticatedRequest('assumeRoleWithSAML', params, callback);
	  },
	
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('validate', this.optInRegionalEndpoint, true);
	  },
	
	  /**
	   * @api private
	   */
	  optInRegionalEndpoint: function optInRegionalEndpoint(req) {
	    var service = req.service;
	    var config = service.config;
	    config.stsRegionalEndpoints = resolveRegionalEndpointsFlag(service._originalConfig, {
	      env: ENV_REGIONAL_ENDPOINT_ENABLED,
	      sharedConfig: CONFIG_REGIONAL_ENDPOINT_ENABLED,
	      clientConfig: 'stsRegionalEndpoints'
	    });
	    if (
	      config.stsRegionalEndpoints === 'regional' &&
	      service.isGlobalEndpoint
	    ) {
	      //client will throw if region is not supplied; request will be signed with specified region
	      if (!config.region) {
	        throw AWS.util.error(new Error(),
	          {code: 'ConfigError', message: 'Missing region in config'});
	      }
	      var insertPoint = config.endpoint.indexOf('.amazonaws.com');
	      var regionalEndpoint = config.endpoint.substring(0, insertPoint) +
	        '.' + config.region + config.endpoint.substring(insertPoint);
	      req.httpRequest.updateEndpoint(regionalEndpoint);
	      req.httpRequest.region = config.region;
	    }
	  }
	
	});
	
	},{"../config_regional_endpoint":341,"../core":342}],409:[function(require,module,exports){
	var AWS = require('../core');
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	var expiresHeader = 'presigned-expires';
	
	/**
	 * @api private
	 */
	function signedUrlBuilder(request) {
	  var expires = request.httpRequest.headers[expiresHeader];
	  var signerClass = request.service.getSignerClass(request);
	
	  delete request.httpRequest.headers['User-Agent'];
	  delete request.httpRequest.headers['X-Amz-User-Agent'];
	
	  if (signerClass === AWS.Signers.V4) {
	    if (expires > 604800) { // one week expiry is invalid
	      var message = 'Presigning does not support expiry time greater ' +
	                    'than a week with SigV4 signing.';
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidExpiryTime', message: message, retryable: false
	      });
	    }
	    request.httpRequest.headers[expiresHeader] = expires;
	  } else if (signerClass === AWS.Signers.S3) {
	    var now = request.service ? request.service.getSkewCorrectedDate() : AWS.util.date.getDate();
	    request.httpRequest.headers[expiresHeader] = parseInt(
	      AWS.util.date.unixTimestamp(now) + expires, 10).toString();
	  } else {
	    throw AWS.util.error(new Error(), {
	      message: 'Presigning only supports S3 or SigV4 signing.',
	      code: 'UnsupportedSigner', retryable: false
	    });
	  }
	}
	
	/**
	 * @api private
	 */
	function signedUrlSigner(request) {
	  var endpoint = request.httpRequest.endpoint;
	  var parsedUrl = AWS.util.urlParse(request.httpRequest.path);
	  var queryParams = {};
	
	  if (parsedUrl.search) {
	    queryParams = AWS.util.queryStringParse(parsedUrl.search.substr(1));
	  }
	
	  var auth = request.httpRequest.headers['Authorization'].split(' ');
	  if (auth[0] === 'AWS') {
	    auth = auth[1].split(':');
	    queryParams['Signature'] = auth.pop();
	    queryParams['AWSAccessKeyId'] = auth.join(':');
	
	    AWS.util.each(request.httpRequest.headers, function (key, value) {
	      if (key === expiresHeader) key = 'Expires';
	      if (key.indexOf('x-amz-meta-') === 0) {
	        // Delete existing, potentially not normalized key
	        delete queryParams[key];
	        key = key.toLowerCase();
	      }
	      queryParams[key] = value;
	    });
	    delete request.httpRequest.headers[expiresHeader];
	    delete queryParams['Authorization'];
	    delete queryParams['Host'];
	  } else if (auth[0] === 'AWS4-HMAC-SHA256') { // SigV4 signing
	    auth.shift();
	    var rest = auth.join(' ');
	    var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
	    queryParams['X-Amz-Signature'] = signature;
	    delete queryParams['Expires'];
	  }
	
	  // build URL
	  endpoint.pathname = parsedUrl.pathname;
	  endpoint.search = AWS.util.queryParamsToString(queryParams);
	}
	
	/**
	 * @api private
	 */
	AWS.Signers.Presign = inherit({
	  /**
	   * @api private
	   */
	  sign: function sign(request, expireTime, callback) {
	    request.httpRequest.headers[expiresHeader] = expireTime || 3600;
	    request.on('build', signedUrlBuilder);
	    request.on('sign', signedUrlSigner);
	    request.removeListener('afterBuild',
	      AWS.EventListeners.Core.SET_CONTENT_LENGTH);
	    request.removeListener('afterBuild',
	      AWS.EventListeners.Core.COMPUTE_SHA256);
	
	    request.emit('beforePresign', [request]);
	
	    if (callback) {
	      request.build(function() {
	        if (this.response.error) callback(this.response.error);
	        else {
	          callback(null, AWS.util.urlFormat(request.httpRequest.endpoint));
	        }
	      });
	    } else {
	      request.build();
	      if (request.response.error) throw request.response.error;
	      return AWS.util.urlFormat(request.httpRequest.endpoint);
	    }
	  }
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.Presign;
	
	},{"../core":342}],410:[function(require,module,exports){
	var AWS = require('../core');
	
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.RequestSigner = inherit({
	  constructor: function RequestSigner(request) {
	    this.request = request;
	  },
	
	  setServiceClientId: function setServiceClientId(id) {
	    this.serviceClientId = id;
	  },
	
	  getServiceClientId: function getServiceClientId() {
	    return this.serviceClientId;
	  }
	});
	
	AWS.Signers.RequestSigner.getVersion = function getVersion(version) {
	  switch (version) {
	    case 'v2': return AWS.Signers.V2;
	    case 'v3': return AWS.Signers.V3;
	    case 's3v4': return AWS.Signers.V4;
	    case 'v4': return AWS.Signers.V4;
	    case 's3': return AWS.Signers.S3;
	    case 'v3https': return AWS.Signers.V3Https;
	  }
	  throw new Error('Unknown signing version ' + version);
	};
	
	require('./v2');
	require('./v3');
	require('./v3https');
	require('./v4');
	require('./s3');
	require('./presign');
	
	},{"../core":342,"./presign":409,"./s3":411,"./v2":412,"./v3":413,"./v3https":414,"./v4":415}],411:[function(require,module,exports){
	var AWS = require('../core');
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.S3 = inherit(AWS.Signers.RequestSigner, {
	  /**
	   * When building the stringToSign, these sub resource params should be
	   * part of the canonical resource string with their NON-decoded values
	   */
	  subResources: {
	    'acl': 1,
	    'accelerate': 1,
	    'analytics': 1,
	    'cors': 1,
	    'lifecycle': 1,
	    'delete': 1,
	    'inventory': 1,
	    'location': 1,
	    'logging': 1,
	    'metrics': 1,
	    'notification': 1,
	    'partNumber': 1,
	    'policy': 1,
	    'requestPayment': 1,
	    'replication': 1,
	    'restore': 1,
	    'tagging': 1,
	    'torrent': 1,
	    'uploadId': 1,
	    'uploads': 1,
	    'versionId': 1,
	    'versioning': 1,
	    'versions': 1,
	    'website': 1
	  },
	
	  // when building the stringToSign, these querystring params should be
	  // part of the canonical resource string with their NON-encoded values
	  responseHeaders: {
	    'response-content-type': 1,
	    'response-content-language': 1,
	    'response-expires': 1,
	    'response-cache-control': 1,
	    'response-content-disposition': 1,
	    'response-content-encoding': 1
	  },
	
	  addAuthorization: function addAuthorization(credentials, date) {
	    if (!this.request.headers['presigned-expires']) {
	      this.request.headers['X-Amz-Date'] = AWS.util.date.rfc822(date);
	    }
	
	    if (credentials.sessionToken) {
	      // presigned URLs require this header to be lowercased
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	
	    var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
	    var auth = 'AWS ' + credentials.accessKeyId + ':' + signature;
	
	    this.request.headers['Authorization'] = auth;
	  },
	
	  stringToSign: function stringToSign() {
	    var r = this.request;
	
	    var parts = [];
	    parts.push(r.method);
	    parts.push(r.headers['Content-MD5'] || '');
	    parts.push(r.headers['Content-Type'] || '');
	
	    // This is the "Date" header, but we use X-Amz-Date.
	    // The S3 signing mechanism requires us to pass an empty
	    // string for this Date header regardless.
	    parts.push(r.headers['presigned-expires'] || '');
	
	    var headers = this.canonicalizedAmzHeaders();
	    if (headers) parts.push(headers);
	    parts.push(this.canonicalizedResource());
	
	    return parts.join('\n');
	
	  },
	
	  canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {
	
	    var amzHeaders = [];
	
	    AWS.util.each(this.request.headers, function (name) {
	      if (name.match(/^x-amz-/i))
	        amzHeaders.push(name);
	    });
	
	    amzHeaders.sort(function (a, b) {
	      return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
	    });
	
	    var parts = [];
	    AWS.util.arrayEach.call(this, amzHeaders, function (name) {
	      parts.push(name.toLowerCase() + ':' + String(this.request.headers[name]));
	    });
	
	    return parts.join('\n');
	
	  },
	
	  canonicalizedResource: function canonicalizedResource() {
	
	    var r = this.request;
	
	    var parts = r.path.split('?');
	    var path = parts[0];
	    var querystring = parts[1];
	
	    var resource = '';
	
	    if (r.virtualHostedBucket)
	      resource += '/' + r.virtualHostedBucket;
	
	    resource += path;
	
	    if (querystring) {
	
	      // collect a list of sub resources and query params that need to be signed
	      var resources = [];
	
	      AWS.util.arrayEach.call(this, querystring.split('&'), function (param) {
	        var name = param.split('=')[0];
	        var value = param.split('=')[1];
	        if (this.subResources[name] || this.responseHeaders[name]) {
	          var subresource = { name: name };
	          if (value !== undefined) {
	            if (this.subResources[name]) {
	              subresource.value = value;
	            } else {
	              subresource.value = decodeURIComponent(value);
	            }
	          }
	          resources.push(subresource);
	        }
	      });
	
	      resources.sort(function (a, b) { return a.name < b.name ? -1 : 1; });
	
	      if (resources.length) {
	
	        querystring = [];
	        AWS.util.arrayEach(resources, function (res) {
	          if (res.value === undefined) {
	            querystring.push(res.name);
	          } else {
	            querystring.push(res.name + '=' + res.value);
	          }
	        });
	
	        resource += '?' + querystring.join('&');
	      }
	
	    }
	
	    return resource;
	
	  },
	
	  sign: function sign(secret, string) {
	    return AWS.util.crypto.hmac(secret, string, 'base64', 'sha1');
	  }
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.S3;
	
	},{"../core":342}],412:[function(require,module,exports){
	var AWS = require('../core');
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.V2 = inherit(AWS.Signers.RequestSigner, {
	  addAuthorization: function addAuthorization(credentials, date) {
	
	    if (!date) date = AWS.util.date.getDate();
	
	    var r = this.request;
	
	    r.params.Timestamp = AWS.util.date.iso8601(date);
	    r.params.SignatureVersion = '2';
	    r.params.SignatureMethod = 'HmacSHA256';
	    r.params.AWSAccessKeyId = credentials.accessKeyId;
	
	    if (credentials.sessionToken) {
	      r.params.SecurityToken = credentials.sessionToken;
	    }
	
	    delete r.params.Signature; // delete old Signature for re-signing
	    r.params.Signature = this.signature(credentials);
	
	    r.body = AWS.util.queryParamsToString(r.params);
	    r.headers['Content-Length'] = r.body.length;
	  },
	
	  signature: function signature(credentials) {
	    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
	  },
	
	  stringToSign: function stringToSign() {
	    var parts = [];
	    parts.push(this.request.method);
	    parts.push(this.request.endpoint.host.toLowerCase());
	    parts.push(this.request.pathname());
	    parts.push(AWS.util.queryParamsToString(this.request.params));
	    return parts.join('\n');
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V2;
	
	},{"../core":342}],413:[function(require,module,exports){
	var AWS = require('../core');
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.V3 = inherit(AWS.Signers.RequestSigner, {
	  addAuthorization: function addAuthorization(credentials, date) {
	
	    var datetime = AWS.util.date.rfc822(date);
	
	    this.request.headers['X-Amz-Date'] = datetime;
	
	    if (credentials.sessionToken) {
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	
	    this.request.headers['X-Amzn-Authorization'] =
	      this.authorization(credentials, datetime);
	
	  },
	
	  authorization: function authorization(credentials) {
	    return 'AWS3 ' +
	      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
	      'Algorithm=HmacSHA256,' +
	      'SignedHeaders=' + this.signedHeaders() + ',' +
	      'Signature=' + this.signature(credentials);
	  },
	
	  signedHeaders: function signedHeaders() {
	    var headers = [];
	    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
	      headers.push(h.toLowerCase());
	    });
	    return headers.sort().join(';');
	  },
	
	  canonicalHeaders: function canonicalHeaders() {
	    var headers = this.request.headers;
	    var parts = [];
	    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
	      parts.push(h.toLowerCase().trim() + ':' + String(headers[h]).trim());
	    });
	    return parts.sort().join('\n') + '\n';
	  },
	
	  headersToSign: function headersToSign() {
	    var headers = [];
	    AWS.util.each(this.request.headers, function iterator(k) {
	      if (k === 'Host' || k === 'Content-Encoding' || k.match(/^X-Amz/i)) {
	        headers.push(k);
	      }
	    });
	    return headers;
	  },
	
	  signature: function signature(credentials) {
	    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
	  },
	
	  stringToSign: function stringToSign() {
	    var parts = [];
	    parts.push(this.request.method);
	    parts.push('/');
	    parts.push('');
	    parts.push(this.canonicalHeaders());
	    parts.push(this.request.body);
	    return AWS.util.crypto.sha256(parts.join('\n'));
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V3;
	
	},{"../core":342}],414:[function(require,module,exports){
	var AWS = require('../core');
	var inherit = AWS.util.inherit;
	
	require('./v3');
	
	/**
	 * @api private
	 */
	AWS.Signers.V3Https = inherit(AWS.Signers.V3, {
	  authorization: function authorization(credentials) {
	    return 'AWS3-HTTPS ' +
	      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
	      'Algorithm=HmacSHA256,' +
	      'Signature=' + this.signature(credentials);
	  },
	
	  stringToSign: function stringToSign() {
	    return this.request.headers['X-Amz-Date'];
	  }
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V3Https;
	
	},{"../core":342,"./v3":413}],415:[function(require,module,exports){
	var AWS = require('../core');
	var v4Credentials = require('./v4_credentials');
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	var expiresHeader = 'presigned-expires';
	
	/**
	 * @api private
	 */
	AWS.Signers.V4 = inherit(AWS.Signers.RequestSigner, {
	  constructor: function V4(request, serviceName, options) {
	    AWS.Signers.RequestSigner.call(this, request);
	    this.serviceName = serviceName;
	    options = options || {};
	    this.signatureCache = typeof options.signatureCache === 'boolean' ? options.signatureCache : true;
	    this.operation = options.operation;
	    this.signatureVersion = options.signatureVersion;
	  },
	
	  algorithm: 'AWS4-HMAC-SHA256',
	
	  addAuthorization: function addAuthorization(credentials, date) {
	    var datetime = AWS.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, '');
	
	    if (this.isPresigned()) {
	      this.updateForPresigned(credentials, datetime);
	    } else {
	      this.addHeaders(credentials, datetime);
	    }
	
	    this.request.headers['Authorization'] =
	      this.authorization(credentials, datetime);
	  },
	
	  addHeaders: function addHeaders(credentials, datetime) {
	    this.request.headers['X-Amz-Date'] = datetime;
	    if (credentials.sessionToken) {
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	  },
	
	  updateForPresigned: function updateForPresigned(credentials, datetime) {
	    var credString = this.credentialString(datetime);
	    var qs = {
	      'X-Amz-Date': datetime,
	      'X-Amz-Algorithm': this.algorithm,
	      'X-Amz-Credential': credentials.accessKeyId + '/' + credString,
	      'X-Amz-Expires': this.request.headers[expiresHeader],
	      'X-Amz-SignedHeaders': this.signedHeaders()
	    };
	
	    if (credentials.sessionToken) {
	      qs['X-Amz-Security-Token'] = credentials.sessionToken;
	    }
	
	    if (this.request.headers['Content-Type']) {
	      qs['Content-Type'] = this.request.headers['Content-Type'];
	    }
	    if (this.request.headers['Content-MD5']) {
	      qs['Content-MD5'] = this.request.headers['Content-MD5'];
	    }
	    if (this.request.headers['Cache-Control']) {
	      qs['Cache-Control'] = this.request.headers['Cache-Control'];
	    }
	
	    // need to pull in any other X-Amz-* headers
	    AWS.util.each.call(this, this.request.headers, function(key, value) {
	      if (key === expiresHeader) return;
	      if (this.isSignableHeader(key)) {
	        var lowerKey = key.toLowerCase();
	        // Metadata should be normalized
	        if (lowerKey.indexOf('x-amz-meta-') === 0) {
	          qs[lowerKey] = value;
	        } else if (lowerKey.indexOf('x-amz-') === 0) {
	          qs[key] = value;
	        }
	      }
	    });
	
	    var sep = this.request.path.indexOf('?') >= 0 ? '&' : '?';
	    this.request.path += sep + AWS.util.queryParamsToString(qs);
	  },
	
	  authorization: function authorization(credentials, datetime) {
	    var parts = [];
	    var credString = this.credentialString(datetime);
	    parts.push(this.algorithm + ' Credential=' +
	      credentials.accessKeyId + '/' + credString);
	    parts.push('SignedHeaders=' + this.signedHeaders());
	    parts.push('Signature=' + this.signature(credentials, datetime));
	    return parts.join(', ');
	  },
	
	  signature: function signature(credentials, datetime) {
	    var signingKey = v4Credentials.getSigningKey(
	      credentials,
	      datetime.substr(0, 8),
	      this.request.region,
	      this.serviceName,
	      this.signatureCache
	    );
	    return AWS.util.crypto.hmac(signingKey, this.stringToSign(datetime), 'hex');
	  },
	
	  stringToSign: function stringToSign(datetime) {
	    var parts = [];
	    parts.push('AWS4-HMAC-SHA256');
	    parts.push(datetime);
	    parts.push(this.credentialString(datetime));
	    parts.push(this.hexEncodedHash(this.canonicalString()));
	    return parts.join('\n');
	  },
	
	  canonicalString: function canonicalString() {
	    var parts = [], pathname = this.request.pathname();
	    if (this.serviceName !== 's3' && this.signatureVersion !== 's3v4') pathname = AWS.util.uriEscapePath(pathname);
	
	    parts.push(this.request.method);
	    parts.push(pathname);
	    parts.push(this.request.search());
	    parts.push(this.canonicalHeaders() + '\n');
	    parts.push(this.signedHeaders());
	    parts.push(this.hexEncodedBodyHash());
	    return parts.join('\n');
	  },
	
	  canonicalHeaders: function canonicalHeaders() {
	    var headers = [];
	    AWS.util.each.call(this, this.request.headers, function (key, item) {
	      headers.push([key, item]);
	    });
	    headers.sort(function (a, b) {
	      return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
	    });
	    var parts = [];
	    AWS.util.arrayEach.call(this, headers, function (item) {
	      var key = item[0].toLowerCase();
	      if (this.isSignableHeader(key)) {
	        var value = item[1];
	        if (typeof value === 'undefined' || value === null || typeof value.toString !== 'function') {
	          throw AWS.util.error(new Error('Header ' + key + ' contains invalid value'), {
	            code: 'InvalidHeader'
	          });
	        }
	        parts.push(key + ':' +
	          this.canonicalHeaderValues(value.toString()));
	      }
	    });
	    return parts.join('\n');
	  },
	
	  canonicalHeaderValues: function canonicalHeaderValues(values) {
	    return values.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
	  },
	
	  signedHeaders: function signedHeaders() {
	    var keys = [];
	    AWS.util.each.call(this, this.request.headers, function (key) {
	      key = key.toLowerCase();
	      if (this.isSignableHeader(key)) keys.push(key);
	    });
	    return keys.sort().join(';');
	  },
	
	  credentialString: function credentialString(datetime) {
	    return v4Credentials.createScope(
	      datetime.substr(0, 8),
	      this.request.region,
	      this.serviceName
	    );
	  },
	
	  hexEncodedHash: function hash(string) {
	    return AWS.util.crypto.sha256(string, 'hex');
	  },
	
	  hexEncodedBodyHash: function hexEncodedBodyHash() {
	    var request = this.request;
	    if (this.isPresigned() && (['s3', 's3-object-lambda'].indexOf(this.serviceName) > -1) && !request.body) {
	      return 'UNSIGNED-PAYLOAD';
	    } else if (request.headers['X-Amz-Content-Sha256']) {
	      return request.headers['X-Amz-Content-Sha256'];
	    } else {
	      return this.hexEncodedHash(this.request.body || '');
	    }
	  },
	
	  unsignableHeaders: [
	    'authorization',
	    'content-type',
	    'content-length',
	    'user-agent',
	    expiresHeader,
	    'expect',
	    'x-amzn-trace-id'
	  ],
	
	  isSignableHeader: function isSignableHeader(key) {
	    if (key.toLowerCase().indexOf('x-amz-') === 0) return true;
	    return this.unsignableHeaders.indexOf(key) < 0;
	  },
	
	  isPresigned: function isPresigned() {
	    return this.request.headers[expiresHeader] ? true : false;
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V4;
	
	},{"../core":342,"./v4_credentials":416}],416:[function(require,module,exports){
	var AWS = require('../core');
	
	/**
	 * @api private
	 */
	var cachedSecret = {};
	
	/**
	 * @api private
	 */
	var cacheQueue = [];
	
	/**
	 * @api private
	 */
	var maxCacheEntries = 50;
	
	/**
	 * @api private
	 */
	var v4Identifier = 'aws4_request';
	
	/**
	 * @api private
	 */
	module.exports = {
	  /**
	   * @api private
	   *
	   * @param date [String]
	   * @param region [String]
	   * @param serviceName [String]
	   * @return [String]
	   */
	  createScope: function createScope(date, region, serviceName) {
	    return [
	      date.substr(0, 8),
	      region,
	      serviceName,
	      v4Identifier
	    ].join('/');
	  },
	
	  /**
	   * @api private
	   *
	   * @param credentials [Credentials]
	   * @param date [String]
	   * @param region [String]
	   * @param service [String]
	   * @param shouldCache [Boolean]
	   * @return [String]
	   */
	  getSigningKey: function getSigningKey(
	    credentials,
	    date,
	    region,
	    service,
	    shouldCache
	  ) {
	    var credsIdentifier = AWS.util.crypto
	      .hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
	    var cacheKey = [credsIdentifier, date, region, service].join('_');
	    shouldCache = shouldCache !== false;
	    if (shouldCache && (cacheKey in cachedSecret)) {
	      return cachedSecret[cacheKey];
	    }
	
	    var kDate = AWS.util.crypto.hmac(
	      'AWS4' + credentials.secretAccessKey,
	      date,
	      'buffer'
	    );
	    var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer');
	    var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer');
	
	    var signingKey = AWS.util.crypto.hmac(kService, v4Identifier, 'buffer');
	    if (shouldCache) {
	      cachedSecret[cacheKey] = signingKey;
	      cacheQueue.push(cacheKey);
	      if (cacheQueue.length > maxCacheEntries) {
	        // remove the oldest entry (not the least recently used)
	        delete cachedSecret[cacheQueue.shift()];
	      }
	    }
	
	    return signingKey;
	  },
	
	  /**
	   * @api private
	   *
	   * Empties the derived signing key cache. Made available for testing purposes
	   * only.
	   */
	  emptyCache: function emptyCache() {
	    cachedSecret = {};
	    cacheQueue = [];
	  }
	};
	
	},{"../core":342}],417:[function(require,module,exports){
	function AcceptorStateMachine(states, state) {
	  this.currentState = state || null;
	  this.states = states || {};
	}
	
	AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
	  if (typeof finalState === 'function') {
	    inputError = bindObject; bindObject = done;
	    done = finalState; finalState = null;
	  }
	
	  var self = this;
	  var state = self.states[self.currentState];
	  state.fn.call(bindObject || self, inputError, function(err) {
	    if (err) {
	      if (state.fail) self.currentState = state.fail;
	      else return done ? done.call(bindObject, err) : null;
	    } else {
	      if (state.accept) self.currentState = state.accept;
	      else return done ? done.call(bindObject) : null;
	    }
	    if (self.currentState === finalState) {
	      return done ? done.call(bindObject, err) : null;
	    }
	
	    self.runTo(finalState, done, bindObject, err);
	  });
	};
	
	AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
	  if (typeof acceptState === 'function') {
	    fn = acceptState; acceptState = null; failState = null;
	  } else if (typeof failState === 'function') {
	    fn = failState; failState = null;
	  }
	
	  if (!this.currentState) this.currentState = name;
	  this.states[name] = { accept: acceptState, fail: failState, fn: fn };
	  return this;
	};
	
	/**
	 * @api private
	 */
	module.exports = AcceptorStateMachine;
	
	},{}],418:[function(require,module,exports){
	(function (process,setImmediate){(function (){
	/* eslint guard-for-in:0 */
	var AWS;
	
	/**
	 * A set of utility methods for use with the AWS SDK.
	 *
	 * @!attribute abort
	 *   Return this value from an iterator function {each} or {arrayEach}
	 *   to break out of the iteration.
	 *   @example Breaking out of an iterator function
	 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
	 *       if (key == 'b') return AWS.util.abort;
	 *     });
	 *   @see each
	 *   @see arrayEach
	 * @api private
	 */
	var util = {
	  environment: 'nodejs',
	  engine: function engine() {
	    if (util.isBrowser() && typeof navigator !== 'undefined') {
	      return navigator.userAgent;
	    } else {
	      var engine = process.platform + '/' + process.version;
	      if (process.env.AWS_EXECUTION_ENV) {
	        engine += ' exec-env/' + process.env.AWS_EXECUTION_ENV;
	      }
	      return engine;
	    }
	  },
	
	  userAgent: function userAgent() {
	    var name = util.environment;
	    var agent = 'aws-sdk-' + name + '/' + require('./core').VERSION;
	    if (name === 'nodejs') agent += ' ' + util.engine();
	    return agent;
	  },
	
	  uriEscape: function uriEscape(string) {
	    var output = encodeURIComponent(string);
	    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);
	
	    // AWS percent-encodes some extra non-standard characters in a URI
	    output = output.replace(/[*]/g, function(ch) {
	      return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
	    });
	
	    return output;
	  },
	
	  uriEscapePath: function uriEscapePath(string) {
	    var parts = [];
	    util.arrayEach(string.split('/'), function (part) {
	      parts.push(util.uriEscape(part));
	    });
	    return parts.join('/');
	  },
	
	  urlParse: function urlParse(url) {
	    return util.url.parse(url);
	  },
	
	  urlFormat: function urlFormat(url) {
	    return util.url.format(url);
	  },
	
	  queryStringParse: function queryStringParse(qs) {
	    return util.querystring.parse(qs);
	  },
	
	  queryParamsToString: function queryParamsToString(params) {
	    var items = [];
	    var escape = util.uriEscape;
	    var sortedKeys = Object.keys(params).sort();
	
	    util.arrayEach(sortedKeys, function(name) {
	      var value = params[name];
	      var ename = escape(name);
	      var result = ename + '=';
	      if (Array.isArray(value)) {
	        var vals = [];
	        util.arrayEach(value, function(item) { vals.push(escape(item)); });
	        result = ename + '=' + vals.sort().join('&' + ename + '=');
	      } else if (value !== undefined && value !== null) {
	        result = ename + '=' + escape(value);
	      }
	      items.push(result);
	    });
	
	    return items.join('&');
	  },
	
	  readFileSync: function readFileSync(path) {
	    if (util.isBrowser()) return null;
	    return require('fs').readFileSync(path, 'utf-8');
	  },
	
	  base64: {
	    encode: function encode64(string) {
	      if (typeof string === 'number') {
	        throw util.error(new Error('Cannot base64 encode number ' + string));
	      }
	      if (string === null || typeof string === 'undefined') {
	        return string;
	      }
	      var buf = util.buffer.toBuffer(string);
	      return buf.toString('base64');
	    },
	
	    decode: function decode64(string) {
	      if (typeof string === 'number') {
	        throw util.error(new Error('Cannot base64 decode number ' + string));
	      }
	      if (string === null || typeof string === 'undefined') {
	        return string;
	      }
	      return util.buffer.toBuffer(string, 'base64');
	    }
	
	  },
	
	  buffer: {
	    /**
	     * Buffer constructor for Node buffer and buffer pollyfill
	     */
	    toBuffer: function(data, encoding) {
	      return (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ?
	        util.Buffer.from(data, encoding) : new util.Buffer(data, encoding);
	    },
	
	    alloc: function(size, fill, encoding) {
	      if (typeof size !== 'number') {
	        throw new Error('size passed to alloc must be a number.');
	      }
	      if (typeof util.Buffer.alloc === 'function') {
	        return util.Buffer.alloc(size, fill, encoding);
	      } else {
	        var buf = new util.Buffer(size);
	        if (fill !== undefined && typeof buf.fill === 'function') {
	          buf.fill(fill, undefined, undefined, encoding);
	        }
	        return buf;
	      }
	    },
	
	    toStream: function toStream(buffer) {
	      if (!util.Buffer.isBuffer(buffer)) buffer =  util.buffer.toBuffer(buffer);
	
	      var readable = new (util.stream.Readable)();
	      var pos = 0;
	      readable._read = function(size) {
	        if (pos >= buffer.length) return readable.push(null);
	
	        var end = pos + size;
	        if (end > buffer.length) end = buffer.length;
	        readable.push(buffer.slice(pos, end));
	        pos = end;
	      };
	
	      return readable;
	    },
	
	    /**
	     * Concatenates a list of Buffer objects.
	     */
	    concat: function(buffers) {
	      var length = 0,
	          offset = 0,
	          buffer = null, i;
	
	      for (i = 0; i < buffers.length; i++) {
	        length += buffers[i].length;
	      }
	
	      buffer = util.buffer.alloc(length);
	
	      for (i = 0; i < buffers.length; i++) {
	        buffers[i].copy(buffer, offset);
	        offset += buffers[i].length;
	      }
	
	      return buffer;
	    }
	  },
	
	  string: {
	    byteLength: function byteLength(string) {
	      if (string === null || string === undefined) return 0;
	      if (typeof string === 'string') string = util.buffer.toBuffer(string);
	
	      if (typeof string.byteLength === 'number') {
	        return string.byteLength;
	      } else if (typeof string.length === 'number') {
	        return string.length;
	      } else if (typeof string.size === 'number') {
	        return string.size;
	      } else if (typeof string.path === 'string') {
	        return require('fs').lstatSync(string.path).size;
	      } else {
	        throw util.error(new Error('Cannot determine length of ' + string),
	          { object: string });
	      }
	    },
	
	    upperFirst: function upperFirst(string) {
	      return string[0].toUpperCase() + string.substr(1);
	    },
	
	    lowerFirst: function lowerFirst(string) {
	      return string[0].toLowerCase() + string.substr(1);
	    }
	  },
	
	  ini: {
	    parse: function string(ini) {
	      var currentSection, map = {};
	      util.arrayEach(ini.split(/\r?\n/), function(line) {
	        line = line.split(/(^|\s)[;#]/)[0].trim(); // remove comments and trim
	        var isSection = line[0] === '[' && line[line.length - 1] === ']';
	        if (isSection) {
	          currentSection = line.substring(1, line.length - 1);
	          if (currentSection === '__proto__' || currentSection.split(/\s/)[1] === '__proto__') {
	            throw util.error(
	              new Error('Cannot load profile name \'' + currentSection + '\' from shared ini file.')
	            );
	          }
	        } else if (currentSection) {
	          var indexOfEqualsSign = line.indexOf('=');
	          var start = 0;
	          var end = line.length - 1;
	          var isAssignment =
	            indexOfEqualsSign !== -1 && indexOfEqualsSign !== start && indexOfEqualsSign !== end;
	
	          if (isAssignment) {
	            var name = line.substring(0, indexOfEqualsSign).trim();
	            var value = line.substring(indexOfEqualsSign + 1).trim();
	
	            map[currentSection] = map[currentSection] || {};
	            map[currentSection][name] = value;
	          }
	        }
	      });
	
	      return map;
	    }
	  },
	
	  fn: {
	    noop: function() {},
	    callback: function (err) { if (err) throw err; },
	
	    /**
	     * Turn a synchronous function into as "async" function by making it call
	     * a callback. The underlying function is called with all but the last argument,
	     * which is treated as the callback. The callback is passed passed a first argument
	     * of null on success to mimick standard node callbacks.
	     */
	    makeAsync: function makeAsync(fn, expectedArgs) {
	      if (expectedArgs && expectedArgs <= fn.length) {
	        return fn;
	      }
	
	      return function() {
	        var args = Array.prototype.slice.call(arguments, 0);
	        var callback = args.pop();
	        var result = fn.apply(null, args);
	        callback(result);
	      };
	    }
	  },
	
	  /**
	   * Date and time utility functions.
	   */
	  date: {
	
	    /**
	     * @return [Date] the current JavaScript date object. Since all
	     *   AWS services rely on this date object, you can override
	     *   this function to provide a special time value to AWS service
	     *   requests.
	     */
	    getDate: function getDate() {
	      if (!AWS) AWS = require('./core');
	      if (AWS.config.systemClockOffset) { // use offset when non-zero
	        return new Date(new Date().getTime() + AWS.config.systemClockOffset);
	      } else {
	        return new Date();
	      }
	    },
	
	    /**
	     * @return [String] the date in ISO-8601 format
	     */
	    iso8601: function iso8601(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
	    },
	
	    /**
	     * @return [String] the date in RFC 822 format
	     */
	    rfc822: function rfc822(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.toUTCString();
	    },
	
	    /**
	     * @return [Integer] the UNIX timestamp value for the current time
	     */
	    unixTimestamp: function unixTimestamp(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.getTime() / 1000;
	    },
	
	    /**
	     * @param [String,number,Date] date
	     * @return [Date]
	     */
	    from: function format(date) {
	      if (typeof date === 'number') {
	        return new Date(date * 1000); // unix timestamp
	      } else {
	        return new Date(date);
	      }
	    },
	
	    /**
	     * Given a Date or date-like value, this function formats the
	     * date into a string of the requested value.
	     * @param [String,number,Date] date
	     * @param [String] formatter Valid formats are:
	     #   * 'iso8601'
	     #   * 'rfc822'
	     #   * 'unixTimestamp'
	     * @return [String]
	     */
	    format: function format(date, formatter) {
	      if (!formatter) formatter = 'iso8601';
	      return util.date[formatter](util.date.from(date));
	    },
	
	    parseTimestamp: function parseTimestamp(value) {
	      if (typeof value === 'number') { // unix timestamp (number)
	        return new Date(value * 1000);
	      } else if (value.match(/^\d+$/)) { // unix timestamp
	        return new Date(value * 1000);
	      } else if (value.match(/^\d{4}/)) { // iso8601
	        return new Date(value);
	      } else if (value.match(/^\w{3},/)) { // rfc822
	        return new Date(value);
	      } else {
	        throw util.error(
	          new Error('unhandled timestamp format: ' + value),
	          {code: 'TimestampParserError'});
	      }
	    }
	
	  },
	
	  crypto: {
	    crc32Table: [
	     0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419,
	     0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4,
	     0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07,
	     0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	     0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856,
	     0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9,
	     0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4,
	     0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3,
	     0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A,
	     0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599,
	     0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	     0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190,
	     0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F,
	     0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E,
	     0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED,
	     0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950,
	     0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3,
	     0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	     0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A,
	     0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5,
	     0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010,
	     0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17,
	     0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6,
	     0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615,
	     0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	     0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344,
	     0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB,
	     0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A,
	     0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1,
	     0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C,
	     0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF,
	     0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	     0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE,
	     0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31,
	     0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C,
	     0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B,
	     0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242,
	     0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1,
	     0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	     0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278,
	     0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7,
	     0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66,
	     0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605,
	     0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8,
	     0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B,
	     0x2D02EF8D],
	
	    crc32: function crc32(data) {
	      var tbl = util.crypto.crc32Table;
	      var crc = 0 ^ -1;
	
	      if (typeof data === 'string') {
	        data = util.buffer.toBuffer(data);
	      }
	
	      for (var i = 0; i < data.length; i++) {
	        var code = data.readUInt8(i);
	        crc = (crc >>> 8) ^ tbl[(crc ^ code) & 0xFF];
	      }
	      return (crc ^ -1) >>> 0;
	    },
	
	    hmac: function hmac(key, string, digest, fn) {
	      if (!digest) digest = 'binary';
	      if (digest === 'buffer') { digest = undefined; }
	      if (!fn) fn = 'sha256';
	      if (typeof string === 'string') string = util.buffer.toBuffer(string);
	      return util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
	    },
	
	    md5: function md5(data, digest, callback) {
	      return util.crypto.hash('md5', data, digest, callback);
	    },
	
	    sha256: function sha256(data, digest, callback) {
	      return util.crypto.hash('sha256', data, digest, callback);
	    },
	
	    hash: function(algorithm, data, digest, callback) {
	      var hash = util.crypto.createHash(algorithm);
	      if (!digest) { digest = 'binary'; }
	      if (digest === 'buffer') { digest = undefined; }
	      if (typeof data === 'string') data = util.buffer.toBuffer(data);
	      var sliceFn = util.arraySliceFn(data);
	      var isBuffer = util.Buffer.isBuffer(data);
	      //Identifying objects with an ArrayBuffer as buffers
	      if (util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;
	
	      if (callback && typeof data === 'object' &&
	          typeof data.on === 'function' && !isBuffer) {
	        data.on('data', function(chunk) { hash.update(chunk); });
	        data.on('error', function(err) { callback(err); });
	        data.on('end', function() { callback(null, hash.digest(digest)); });
	      } else if (callback && sliceFn && !isBuffer &&
	                 typeof FileReader !== 'undefined') {
	        // this might be a File/Blob
	        var index = 0, size = 1024 * 512;
	        var reader = new FileReader();
	        reader.onerror = function() {
	          callback(new Error('Failed to read data.'));
	        };
	        reader.onload = function() {
	          var buf = new util.Buffer(new Uint8Array(reader.result));
	          hash.update(buf);
	          index += buf.length;
	          reader._continueReading();
	        };
	        reader._continueReading = function() {
	          if (index >= data.size) {
	            callback(null, hash.digest(digest));
	            return;
	          }
	
	          var back = index + size;
	          if (back > data.size) back = data.size;
	          reader.readAsArrayBuffer(sliceFn.call(data, index, back));
	        };
	
	        reader._continueReading();
	      } else {
	        if (util.isBrowser() && typeof data === 'object' && !isBuffer) {
	          data = new util.Buffer(new Uint8Array(data));
	        }
	        var out = hash.update(data).digest(digest);
	        if (callback) callback(null, out);
	        return out;
	      }
	    },
	
	    toHex: function toHex(data) {
	      var out = [];
	      for (var i = 0; i < data.length; i++) {
	        out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
	      }
	      return out.join('');
	    },
	
	    createHash: function createHash(algorithm) {
	      return util.crypto.lib.createHash(algorithm);
	    }
	
	  },
	
	  /** @!ignore */
	
	  /* Abort constant */
	  abort: {},
	
	  each: function each(object, iterFunction) {
	    for (var key in object) {
	      if (Object.prototype.hasOwnProperty.call(object, key)) {
	        var ret = iterFunction.call(this, key, object[key]);
	        if (ret === util.abort) break;
	      }
	    }
	  },
	
	  arrayEach: function arrayEach(array, iterFunction) {
	    for (var idx in array) {
	      if (Object.prototype.hasOwnProperty.call(array, idx)) {
	        var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
	        if (ret === util.abort) break;
	      }
	    }
	  },
	
	  update: function update(obj1, obj2) {
	    util.each(obj2, function iterator(key, item) {
	      obj1[key] = item;
	    });
	    return obj1;
	  },
	
	  merge: function merge(obj1, obj2) {
	    return util.update(util.copy(obj1), obj2);
	  },
	
	  copy: function copy(object) {
	    if (object === null || object === undefined) return object;
	    var dupe = {};
	    // jshint forin:false
	    for (var key in object) {
	      dupe[key] = object[key];
	    }
	    return dupe;
	  },
	
	  isEmpty: function isEmpty(obj) {
	    for (var prop in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
	        return false;
	      }
	    }
	    return true;
	  },
	
	  arraySliceFn: function arraySliceFn(obj) {
	    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
	    return typeof fn === 'function' ? fn : null;
	  },
	
	  isType: function isType(obj, type) {
	    // handle cross-"frame" objects
	    if (typeof type === 'function') type = util.typeName(type);
	    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
	  },
	
	  typeName: function typeName(type) {
	    if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
	    var str = type.toString();
	    var match = str.match(/^\s*function (.+)\(/);
	    return match ? match[1] : str;
	  },
	
	  error: function error(err, options) {
	    var originalError = null;
	    if (typeof err.message === 'string' && err.message !== '') {
	      if (typeof options === 'string' || (options && options.message)) {
	        originalError = util.copy(err);
	        originalError.message = err.message;
	      }
	    }
	    err.message = err.message || null;
	
	    if (typeof options === 'string') {
	      err.message = options;
	    } else if (typeof options === 'object' && options !== null) {
	      util.update(err, options);
	      if (options.message)
	        err.message = options.message;
	      if (options.code || options.name)
	        err.code = options.code || options.name;
	      if (options.stack)
	        err.stack = options.stack;
	    }
	
	    if (typeof Object.defineProperty === 'function') {
	      Object.defineProperty(err, 'name', {writable: true, enumerable: false});
	      Object.defineProperty(err, 'message', {enumerable: true});
	    }
	
	    err.name = String(options && options.name || err.name || err.code || 'Error');
	    err.time = new Date();
	
	    if (originalError) err.originalError = originalError;
	
	    return err;
	  },
	
	  /**
	   * @api private
	   */
	  inherit: function inherit(klass, features) {
	    var newObject = null;
	    if (features === undefined) {
	      features = klass;
	      klass = Object;
	      newObject = {};
	    } else {
	      var ctor = function ConstructorWrapper() {};
	      ctor.prototype = klass.prototype;
	      newObject = new ctor();
	    }
	
	    // constructor not supplied, create pass-through ctor
	    if (features.constructor === Object) {
	      features.constructor = function() {
	        if (klass !== Object) {
	          return klass.apply(this, arguments);
	        }
	      };
	    }
	
	    features.constructor.prototype = newObject;
	    util.update(features.constructor.prototype, features);
	    features.constructor.__super__ = klass;
	    return features.constructor;
	  },
	
	  /**
	   * @api private
	   */
	  mixin: function mixin() {
	    var klass = arguments[0];
	    for (var i = 1; i < arguments.length; i++) {
	      // jshint forin:false
	      for (var prop in arguments[i].prototype) {
	        var fn = arguments[i].prototype[prop];
	        if (prop !== 'constructor') {
	          klass.prototype[prop] = fn;
	        }
	      }
	    }
	    return klass;
	  },
	
	  /**
	   * @api private
	   */
	  hideProperties: function hideProperties(obj, props) {
	    if (typeof Object.defineProperty !== 'function') return;
	
	    util.arrayEach(props, function (key) {
	      Object.defineProperty(obj, key, {
	        enumerable: false, writable: true, configurable: true });
	    });
	  },
	
	  /**
	   * @api private
	   */
	  property: function property(obj, name, value, enumerable, isValue) {
	    var opts = {
	      configurable: true,
	      enumerable: enumerable !== undefined ? enumerable : true
	    };
	    if (typeof value === 'function' && !isValue) {
	      opts.get = value;
	    }
	    else {
	      opts.value = value; opts.writable = true;
	    }
	
	    Object.defineProperty(obj, name, opts);
	  },
	
	  /**
	   * @api private
	   */
	  memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
	    var cachedValue = null;
	
	    // build enumerable attribute for each value with lazy accessor.
	    util.property(obj, name, function() {
	      if (cachedValue === null) {
	        cachedValue = get();
	      }
	      return cachedValue;
	    }, enumerable);
	  },
	
	  /**
	   * TODO Remove in major version revision
	   * This backfill populates response data without the
	   * top-level payload name.
	   *
	   * @api private
	   */
	  hoistPayloadMember: function hoistPayloadMember(resp) {
	    var req = resp.request;
	    var operationName = req.operation;
	    var operation = req.service.api.operations[operationName];
	    var output = operation.output;
	    if (output.payload && !operation.hasEventOutput) {
	      var payloadMember = output.members[output.payload];
	      var responsePayload = resp.data[output.payload];
	      if (payloadMember.type === 'structure') {
	        util.each(responsePayload, function(key, value) {
	          util.property(resp.data, key, value, false);
	        });
	      }
	    }
	  },
	
	  /**
	   * Compute SHA-256 checksums of streams
	   *
	   * @api private
	   */
	  computeSha256: function computeSha256(body, done) {
	    if (util.isNode()) {
	      var Stream = util.stream.Stream;
	      var fs = require('fs');
	      if (typeof Stream === 'function' && body instanceof Stream) {
	        if (typeof body.path === 'string') { // assume file object
	          var settings = {};
	          if (typeof body.start === 'number') {
	            settings.start = body.start;
	          }
	          if (typeof body.end === 'number') {
	            settings.end = body.end;
	          }
	          body = fs.createReadStream(body.path, settings);
	        } else { // TODO support other stream types
	          return done(new Error('Non-file stream objects are ' +
	                                'not supported with SigV4'));
	        }
	      }
	    }
	
	    util.crypto.sha256(body, 'hex', function(err, sha) {
	      if (err) done(err);
	      else done(null, sha);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  isClockSkewed: function isClockSkewed(serverTime) {
	    if (serverTime) {
	      util.property(AWS.config, 'isClockSkewed',
	        Math.abs(new Date().getTime() - serverTime) >= 300000, false);
	      return AWS.config.isClockSkewed;
	    }
	  },
	
	  applyClockOffset: function applyClockOffset(serverTime) {
	    if (serverTime)
	      AWS.config.systemClockOffset = serverTime - new Date().getTime();
	  },
	
	  /**
	   * @api private
	   */
	  extractRequestId: function extractRequestId(resp) {
	    var requestId = resp.httpResponse.headers['x-amz-request-id'] ||
	                     resp.httpResponse.headers['x-amzn-requestid'];
	
	    if (!requestId && resp.data && resp.data.ResponseMetadata) {
	      requestId = resp.data.ResponseMetadata.RequestId;
	    }
	
	    if (requestId) {
	      resp.requestId = requestId;
	    }
	
	    if (resp.error) {
	      resp.error.requestId = requestId;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  addPromises: function addPromises(constructors, PromiseDependency) {
	    var deletePromises = false;
	    if (PromiseDependency === undefined && AWS && AWS.config) {
	      PromiseDependency = AWS.config.getPromisesDependency();
	    }
	    if (PromiseDependency === undefined && typeof Promise !== 'undefined') {
	      PromiseDependency = Promise;
	    }
	    if (typeof PromiseDependency !== 'function') deletePromises = true;
	    if (!Array.isArray(constructors)) constructors = [constructors];
	
	    for (var ind = 0; ind < constructors.length; ind++) {
	      var constructor = constructors[ind];
	      if (deletePromises) {
	        if (constructor.deletePromisesFromClass) {
	          constructor.deletePromisesFromClass();
	        }
	      } else if (constructor.addPromisesToClass) {
	        constructor.addPromisesToClass(PromiseDependency);
	      }
	    }
	  },
	
	  /**
	   * @api private
	   * Return a function that will return a promise whose fate is decided by the
	   * callback behavior of the given method with `methodName`. The method to be
	   * promisified should conform to node.js convention of accepting a callback as
	   * last argument and calling that callback with error as the first argument
	   * and success value on the second argument.
	   */
	  promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
	    return function promise() {
	      var self = this;
	      var args = Array.prototype.slice.call(arguments);
	      return new PromiseDependency(function(resolve, reject) {
	        args.push(function(err, data) {
	          if (err) {
	            reject(err);
	          } else {
	            resolve(data);
	          }
	        });
	        self[methodName].apply(self, args);
	      });
	    };
	  },
	
	  /**
	   * @api private
	   */
	  isDualstackAvailable: function isDualstackAvailable(service) {
	    if (!service) return false;
	    var metadata = require('../apis/metadata.json');
	    if (typeof service !== 'string') service = service.serviceIdentifier;
	    if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
	    return !!metadata[service].dualstackAvailable;
	  },
	
	  /**
	   * @api private
	   */
	  calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions, err) {
	    if (!retryDelayOptions) retryDelayOptions = {};
	    var customBackoff = retryDelayOptions.customBackoff || null;
	    if (typeof customBackoff === 'function') {
	      return customBackoff(retryCount, err);
	    }
	    var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
	    var delay = Math.random() * (Math.pow(2, retryCount) * base);
	    return delay;
	  },
	
	  /**
	   * @api private
	   */
	  handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
	    if (!options) options = {};
	    var http = AWS.HttpClient.getInstance();
	    var httpOptions = options.httpOptions || {};
	    var retryCount = 0;
	
	    var errCallback = function(err) {
	      var maxRetries = options.maxRetries || 0;
	      if (err && err.code === 'TimeoutError') err.retryable = true;
	
	      // Call `calculateRetryDelay()` only when relevant, see #3401
	      if (err && err.retryable && retryCount < maxRetries) {
	        var delay = util.calculateRetryDelay(retryCount, options.retryDelayOptions, err);
	        if (delay >= 0) {
	          retryCount++;
	          setTimeout(sendRequest, delay + (err.retryAfter || 0));
	          return;
	        }
	      }
	      cb(err);
	    };
	
	    var sendRequest = function() {
	      var data = '';
	      http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
	        httpResponse.on('data', function(chunk) { data += chunk.toString(); });
	        httpResponse.on('end', function() {
	          var statusCode = httpResponse.statusCode;
	          if (statusCode < 300) {
	            cb(null, data);
	          } else {
	            var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
	            var err = util.error(new Error(),
	              {
	                statusCode: statusCode,
	                retryable: statusCode >= 500 || statusCode === 429
	              }
	            );
	            if (retryAfter && err.retryable) err.retryAfter = retryAfter;
	            errCallback(err);
	          }
	        });
	      }, errCallback);
	    };
	
	    AWS.util.defer(sendRequest);
	  },
	
	  /**
	   * @api private
	   */
	  uuid: {
	    v4: function uuidV4() {
	      return require('uuid').v4();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  convertPayloadToString: function convertPayloadToString(resp) {
	    var req = resp.request;
	    var operation = req.operation;
	    var rules = req.service.api.operations[operation].output || {};
	    if (rules.payload && resp.data[rules.payload]) {
	      resp.data[rules.payload] = resp.data[rules.payload].toString();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  defer: function defer(callback) {
	    if (typeof process === 'object' && typeof process.nextTick === 'function') {
	      process.nextTick(callback);
	    } else if (typeof setImmediate === 'function') {
	      setImmediate(callback);
	    } else {
	      setTimeout(callback, 0);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getRequestPayloadShape: function getRequestPayloadShape(req) {
	    var operations = req.service.api.operations;
	    if (!operations) return undefined;
	    var operation = (operations || {})[req.operation];
	    if (!operation || !operation.input || !operation.input.payload) return undefined;
	    return operation.input.members[operation.input.payload];
	  },
	
	  getProfilesFromSharedConfig: function getProfilesFromSharedConfig(iniLoader, filename) {
	    var profiles = {};
	    var profilesFromConfig = {};
	    if (process.env[util.configOptInEnv]) {
	      var profilesFromConfig = iniLoader.loadFrom({
	        isConfig: true,
	        filename: process.env[util.sharedConfigFileEnv]
	      });
	    }
	    var profilesFromCreds= {};
	    try {
	      var profilesFromCreds = iniLoader.loadFrom({
	        filename: filename ||
	          (process.env[util.configOptInEnv] && process.env[util.sharedCredentialsFileEnv])
	      });
	    } catch (error) {
	      // if using config, assume it is fully descriptive without a credentials file:
	      if (!process.env[util.configOptInEnv]) throw error;
	    }
	    for (var i = 0, profileNames = Object.keys(profilesFromConfig); i < profileNames.length; i++) {
	      profiles[profileNames[i]] = objectAssign(profiles[profileNames[i]] || {}, profilesFromConfig[profileNames[i]]);
	    }
	    for (var i = 0, profileNames = Object.keys(profilesFromCreds); i < profileNames.length; i++) {
	      profiles[profileNames[i]] = objectAssign(profiles[profileNames[i]] || {}, profilesFromCreds[profileNames[i]]);
	    }
	    return profiles;
	
	    /**
	     * Roughly the semantics of `Object.assign(target, source)`
	     */
	    function objectAssign(target, source) {
	      for (var i = 0, keys = Object.keys(source); i < keys.length; i++) {
	        target[keys[i]] = source[keys[i]];
	      }
	      return target;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  ARN: {
	    validate: function validateARN(str) {
	      return str && str.indexOf('arn:') === 0 && str.split(':').length >= 6;
	    },
	    parse: function parseARN(arn) {
	      var matched = arn.split(':');
	      return {
	        partition: matched[1],
	        service: matched[2],
	        region: matched[3],
	        accountId: matched[4],
	        resource: matched.slice(5).join(':')
	      };
	    },
	    build: function buildARN(arnObject) {
	      if (
	        arnObject.service === undefined ||
	        arnObject.region === undefined ||
	        arnObject.accountId === undefined ||
	        arnObject.resource === undefined
	      ) throw util.error(new Error('Input ARN object is invalid'));
	      return 'arn:'+ (arnObject.partition || 'aws') + ':' + arnObject.service +
	        ':' + arnObject.region + ':' + arnObject.accountId + ':' + arnObject.resource;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  defaultProfile: 'default',
	
	  /**
	   * @api private
	   */
	  configOptInEnv: 'AWS_SDK_LOAD_CONFIG',
	
	  /**
	   * @api private
	   */
	  sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',
	
	  /**
	   * @api private
	   */
	  sharedConfigFileEnv: 'AWS_CONFIG_FILE',
	
	  /**
	   * @api private
	   */
	  imdsDisabledEnv: 'AWS_EC2_METADATA_DISABLED'
	};
	
	/**
	 * @api private
	 */
	module.exports = util;
	
	}).call(this)}).call(this,require('_process'),require("timers").setImmediate)
	},{"../apis/metadata.json":163,"./core":342,"_process":432,"fs":426,"timers":440,"uuid":446}],419:[function(require,module,exports){
	var util = require('../util');
	var Shape = require('../model/shape');
	
	function DomXmlParser() { }
	
	DomXmlParser.prototype.parse = function(xml, shape) {
	  if (xml.replace(/^\s+/, '') === '') return {};
	
	  var result, error;
	  try {
	    if (window.DOMParser) {
	      try {
	        var parser = new DOMParser();
	        result = parser.parseFromString(xml, 'text/xml');
	      } catch (syntaxError) {
	        throw util.error(new Error('Parse error in document'),
	          {
	            originalError: syntaxError,
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	
	      if (result.documentElement === null) {
	        throw util.error(new Error('Cannot parse empty document.'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	
	      var isError = result.getElementsByTagName('parsererror')[0];
	      if (isError && (isError.parentNode === result ||
	          isError.parentNode.nodeName === 'body' ||
	          isError.parentNode.parentNode === result ||
	          isError.parentNode.parentNode.nodeName === 'body')) {
	        var errorElement = isError.getElementsByTagName('div')[0] || isError;
	        throw util.error(new Error(errorElement.textContent || 'Parser error in document'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	    } else if (window.ActiveXObject) {
	      result = new window.ActiveXObject('Microsoft.XMLDOM');
	      result.async = false;
	
	      if (!result.loadXML(xml)) {
	        throw util.error(new Error('Parse error in document'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	    } else {
	      throw new Error('Cannot load XML parser');
	    }
	  } catch (e) {
	    error = e;
	  }
	
	  if (result && result.documentElement && !error) {
	    var data = parseXml(result.documentElement, shape);
	    var metadata = getElementByTagName(result.documentElement, 'ResponseMetadata');
	    if (metadata) {
	      data.ResponseMetadata = parseXml(metadata, {});
	    }
	    return data;
	  } else if (error) {
	    throw util.error(error || new Error(), {code: 'XMLParserError', retryable: true});
	  } else { // empty xml document
	    return {};
	  }
	};
	
	function getElementByTagName(xml, tag) {
	  var elements = xml.getElementsByTagName(tag);
	  for (var i = 0, iLen = elements.length; i < iLen; i++) {
	    if (elements[i].parentNode === xml) {
	      return elements[i];
	    }
	  }
	}
	
	function parseXml(xml, shape) {
	  if (!shape) shape = {};
	  switch (shape.type) {
	    case 'structure': return parseStructure(xml, shape);
	    case 'map': return parseMap(xml, shape);
	    case 'list': return parseList(xml, shape);
	    case undefined: case null: return parseUnknown(xml);
	    default: return parseScalar(xml, shape);
	  }
	}
	
	function parseStructure(xml, shape) {
	  var data = {};
	  if (xml === null) return data;
	
	  util.each(shape.members, function(memberName, memberShape) {
	    if (memberShape.isXmlAttribute) {
	      if (Object.prototype.hasOwnProperty.call(xml.attributes, memberShape.name)) {
	        var value = xml.attributes[memberShape.name].value;
	        data[memberName] = parseXml({textContent: value}, memberShape);
	      }
	    } else {
	      var xmlChild = memberShape.flattened ? xml :
	        getElementByTagName(xml, memberShape.name);
	      if (xmlChild) {
	        data[memberName] = parseXml(xmlChild, memberShape);
	      } else if (
	        !memberShape.flattened &&
	        memberShape.type === 'list' &&
	        !shape.api.xmlNoDefaultLists) {
	        data[memberName] = memberShape.defaultValue;
	      }
	    }
	  });
	
	  return data;
	}
	
	function parseMap(xml, shape) {
	  var data = {};
	  var xmlKey = shape.key.name || 'key';
	  var xmlValue = shape.value.name || 'value';
	  var tagName = shape.flattened ? shape.name : 'entry';
	
	  var child = xml.firstElementChild;
	  while (child) {
	    if (child.nodeName === tagName) {
	      var key = getElementByTagName(child, xmlKey).textContent;
	      var value = getElementByTagName(child, xmlValue);
	      data[key] = parseXml(value, shape.value);
	    }
	    child = child.nextElementSibling;
	  }
	  return data;
	}
	
	function parseList(xml, shape) {
	  var data = [];
	  var tagName = shape.flattened ? shape.name : (shape.member.name || 'member');
	
	  var child = xml.firstElementChild;
	  while (child) {
	    if (child.nodeName === tagName) {
	      data.push(parseXml(child, shape.member));
	    }
	    child = child.nextElementSibling;
	  }
	  return data;
	}
	
	function parseScalar(xml, shape) {
	  if (xml.getAttribute) {
	    var encoding = xml.getAttribute('encoding');
	    if (encoding === 'base64') {
	      shape = new Shape.create({type: encoding});
	    }
	  }
	
	  var text = xml.textContent;
	  if (text === '') text = null;
	  if (typeof shape.toType === 'function') {
	    return shape.toType(text);
	  } else {
	    return text;
	  }
	}
	
	function parseUnknown(xml) {
	  if (xml === undefined || xml === null) return '';
	
	  // empty object
	  if (!xml.firstElementChild) {
	    if (xml.parentNode.parentNode === null) return {};
	    if (xml.childNodes.length === 0) return '';
	    else return xml.textContent;
	  }
	
	  // object, parse as structure
	  var shape = {type: 'structure', members: {}};
	  var child = xml.firstElementChild;
	  while (child) {
	    var tag = child.nodeName;
	    if (Object.prototype.hasOwnProperty.call(shape.members, tag)) {
	      // multiple tags of the same name makes it a list
	      shape.members[tag].type = 'list';
	    } else {
	      shape.members[tag] = {name: tag};
	    }
	    child = child.nextElementSibling;
	  }
	  return parseStructure(xml, shape);
	}
	
	/**
	 * @api private
	 */
	module.exports = DomXmlParser;
	
	},{"../model/shape":373,"../util":418}],420:[function(require,module,exports){
	var util = require('../util');
	var XmlNode = require('./xml-node').XmlNode;
	var XmlText = require('./xml-text').XmlText;
	
	function XmlBuilder() { }
	
	XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
	  var xml = new XmlNode(rootElement);
	  applyNamespaces(xml, shape, true);
	  serialize(xml, params, shape);
	  return xml.children.length > 0 || noEmpty ? xml.toString() : '';
	};
	
	function serialize(xml, value, shape) {
	  switch (shape.type) {
	    case 'structure': return serializeStructure(xml, value, shape);
	    case 'map': return serializeMap(xml, value, shape);
	    case 'list': return serializeList(xml, value, shape);
	    default: return serializeScalar(xml, value, shape);
	  }
	}
	
	function serializeStructure(xml, params, shape) {
	  util.arrayEach(shape.memberNames, function(memberName) {
	    var memberShape = shape.members[memberName];
	    if (memberShape.location !== 'body') return;
	
	    var value = params[memberName];
	    var name = memberShape.name;
	    if (value !== undefined && value !== null) {
	      if (memberShape.isXmlAttribute) {
	        xml.addAttribute(name, value);
	      } else if (memberShape.flattened) {
	        serialize(xml, value, memberShape);
	      } else {
	        var element = new XmlNode(name);
	        xml.addChildNode(element);
	        applyNamespaces(element, memberShape);
	        serialize(element, value, memberShape);
	      }
	    }
	  });
	}
	
	function serializeMap(xml, map, shape) {
	  var xmlKey = shape.key.name || 'key';
	  var xmlValue = shape.value.name || 'value';
	
	  util.each(map, function(key, value) {
	    var entry = new XmlNode(shape.flattened ? shape.name : 'entry');
	    xml.addChildNode(entry);
	
	    var entryKey = new XmlNode(xmlKey);
	    var entryValue = new XmlNode(xmlValue);
	    entry.addChildNode(entryKey);
	    entry.addChildNode(entryValue);
	
	    serialize(entryKey, key, shape.key);
	    serialize(entryValue, value, shape.value);
	  });
	}
	
	function serializeList(xml, list, shape) {
	  if (shape.flattened) {
	    util.arrayEach(list, function(value) {
	      var name = shape.member.name || shape.name;
	      var element = new XmlNode(name);
	      xml.addChildNode(element);
	      serialize(element, value, shape.member);
	    });
	  } else {
	    util.arrayEach(list, function(value) {
	      var name = shape.member.name || 'member';
	      var element = new XmlNode(name);
	      xml.addChildNode(element);
	      serialize(element, value, shape.member);
	    });
	  }
	}
	
	function serializeScalar(xml, value, shape) {
	  xml.addChildNode(
	    new XmlText(shape.toWireFormat(value))
	  );
	}
	
	function applyNamespaces(xml, shape, isRoot) {
	  var uri, prefix = 'xmlns';
	  if (shape.xmlNamespaceUri) {
	    uri = shape.xmlNamespaceUri;
	    if (shape.xmlNamespacePrefix) prefix += ':' + shape.xmlNamespacePrefix;
	  } else if (isRoot && shape.api.xmlNamespaceUri) {
	    uri = shape.api.xmlNamespaceUri;
	  }
	
	  if (uri) xml.addAttribute(prefix, uri);
	}
	
	/**
	 * @api private
	 */
	module.exports = XmlBuilder;
	
	},{"../util":418,"./xml-node":423,"./xml-text":424}],421:[function(require,module,exports){
	/**
	 * Escapes characters that can not be in an XML attribute.
	 */
	function escapeAttribute(value) {
	    return value.replace(/&/g, '&amp;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    escapeAttribute: escapeAttribute
	};
	
	},{}],422:[function(require,module,exports){
	/**
	 * Escapes characters that can not be in an XML element.
	 */
	function escapeElement(value) {
	    return value.replace(/&/g, '&amp;')
	                .replace(/</g, '&lt;')
	                .replace(/>/g, '&gt;')
	                .replace(/\r/g, '&#x0D;')
	                .replace(/\n/g, '&#x0A;')
	                .replace(/\u0085/g, '&#x85;')
	                .replace(/\u2028/, '&#x2028;');
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    escapeElement: escapeElement
	};
	
	},{}],423:[function(require,module,exports){
	var escapeAttribute = require('./escape-attribute').escapeAttribute;
	
	/**
	 * Represents an XML node.
	 * @api private
	 */
	function XmlNode(name, children) {
	    if (children === void 0) { children = []; }
	    this.name = name;
	    this.children = children;
	    this.attributes = {};
	}
	XmlNode.prototype.addAttribute = function (name, value) {
	    this.attributes[name] = value;
	    return this;
	};
	XmlNode.prototype.addChildNode = function (child) {
	    this.children.push(child);
	    return this;
	};
	XmlNode.prototype.removeAttribute = function (name) {
	    delete this.attributes[name];
	    return this;
	};
	XmlNode.prototype.toString = function () {
	    var hasChildren = Boolean(this.children.length);
	    var xmlText = '<' + this.name;
	    // add attributes
	    var attributes = this.attributes;
	    for (var i = 0, attributeNames = Object.keys(attributes); i < attributeNames.length; i++) {
	        var attributeName = attributeNames[i];
	        var attribute = attributes[attributeName];
	        if (typeof attribute !== 'undefined' && attribute !== null) {
	            xmlText += ' ' + attributeName + '=\"' + escapeAttribute('' + attribute) + '\"';
	        }
	    }
	    return xmlText += !hasChildren ? '/>' : '>' + this.children.map(function (c) { return c.toString(); }).join('') + '</' + this.name + '>';
	};
	
	/**
	 * @api private
	 */
	module.exports = {
	    XmlNode: XmlNode
	};
	
	},{"./escape-attribute":421}],424:[function(require,module,exports){
	var escapeElement = require('./escape-element').escapeElement;
	
	/**
	 * Represents an XML text value.
	 * @api private
	 */
	function XmlText(value) {
	    this.value = value;
	}
	
	XmlText.prototype.toString = function () {
	    return escapeElement('' + this.value);
	};
	
	/**
	 * @api private
	 */
	module.exports = {
	    XmlText: XmlText
	};
	
	},{"./escape-element":422}],425:[function(require,module,exports){
	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}
	
	},{}],426:[function(require,module,exports){
	
	},{}],427:[function(require,module,exports){
	(function (global,Buffer){(function (){
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = require('base64-js')
	var ieee754 = require('ieee754')
	var isArray = require('isarray')
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer)
	},{"base64-js":425,"buffer":427,"ieee754":429,"isarray":430}],428:[function(require,module,exports){
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	
	},{}],429:[function(require,module,exports){
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}
	
	},{}],430:[function(require,module,exports){
	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};
	
	},{}],431:[function(require,module,exports){
	(function(exports) {
	  "use strict";
	
	  function isArray(obj) {
	    if (obj !== null) {
	      return Object.prototype.toString.call(obj) === "[object Array]";
	    } else {
	      return false;
	    }
	  }
	
	  function isObject(obj) {
	    if (obj !== null) {
	      return Object.prototype.toString.call(obj) === "[object Object]";
	    } else {
	      return false;
	    }
	  }
	
	  function strictDeepEqual(first, second) {
	    // Check the scalar case first.
	    if (first === second) {
	      return true;
	    }
	
	    // Check if they are the same type.
	    var firstType = Object.prototype.toString.call(first);
	    if (firstType !== Object.prototype.toString.call(second)) {
	      return false;
	    }
	    // We know that first and second have the same type so we can just check the
	    // first type from now on.
	    if (isArray(first) === true) {
	      // Short circuit if they're not the same length;
	      if (first.length !== second.length) {
	        return false;
	      }
	      for (var i = 0; i < first.length; i++) {
	        if (strictDeepEqual(first[i], second[i]) === false) {
	          return false;
	        }
	      }
	      return true;
	    }
	    if (isObject(first) === true) {
	      // An object is equal if it has the same key/value pairs.
	      var keysSeen = {};
	      for (var key in first) {
	        if (hasOwnProperty.call(first, key)) {
	          if (strictDeepEqual(first[key], second[key]) === false) {
	            return false;
	          }
	          keysSeen[key] = true;
	        }
	      }
	      // Now check that there aren't any keys in second that weren't
	      // in first.
	      for (var key2 in second) {
	        if (hasOwnProperty.call(second, key2)) {
	          if (keysSeen[key2] !== true) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	    return false;
	  }
	
	  function isFalse(obj) {
	    // From the spec:
	    // A false value corresponds to the following values:
	    // Empty list
	    // Empty object
	    // Empty string
	    // False boolean
	    // null value
	
	    // First check the scalar values.
	    if (obj === "" || obj === false || obj === null) {
	        return true;
	    } else if (isArray(obj) && obj.length === 0) {
	        // Check for an empty array.
	        return true;
	    } else if (isObject(obj)) {
	        // Check for an empty object.
	        for (var key in obj) {
	            // If there are any keys, then
	            // the object is not empty so the object
	            // is not false.
	            if (obj.hasOwnProperty(key)) {
	              return false;
	            }
	        }
	        return true;
	    } else {
	        return false;
	    }
	  }
	
	  function objValues(obj) {
	    var keys = Object.keys(obj);
	    var values = [];
	    for (var i = 0; i < keys.length; i++) {
	      values.push(obj[keys[i]]);
	    }
	    return values;
	  }
	
	  function merge(a, b) {
	      var merged = {};
	      for (var key in a) {
	          merged[key] = a[key];
	      }
	      for (var key2 in b) {
	          merged[key2] = b[key2];
	      }
	      return merged;
	  }
	
	  var trimLeft;
	  if (typeof String.prototype.trimLeft === "function") {
	    trimLeft = function(str) {
	      return str.trimLeft();
	    };
	  } else {
	    trimLeft = function(str) {
	      return str.match(/^\s*(.*)/)[1];
	    };
	  }
	
	  // Type constants used to define functions.
	  var TYPE_NUMBER = 0;
	  var TYPE_ANY = 1;
	  var TYPE_STRING = 2;
	  var TYPE_ARRAY = 3;
	  var TYPE_OBJECT = 4;
	  var TYPE_BOOLEAN = 5;
	  var TYPE_EXPREF = 6;
	  var TYPE_NULL = 7;
	  var TYPE_ARRAY_NUMBER = 8;
	  var TYPE_ARRAY_STRING = 9;
	  var TYPE_NAME_TABLE = {
	    0: 'number',
	    1: 'any',
	    2: 'string',
	    3: 'array',
	    4: 'object',
	    5: 'boolean',
	    6: 'expression',
	    7: 'null',
	    8: 'Array<number>',
	    9: 'Array<string>'
	  };
	
	  var TOK_EOF = "EOF";
	  var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
	  var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
	  var TOK_RBRACKET = "Rbracket";
	  var TOK_RPAREN = "Rparen";
	  var TOK_COMMA = "Comma";
	  var TOK_COLON = "Colon";
	  var TOK_RBRACE = "Rbrace";
	  var TOK_NUMBER = "Number";
	  var TOK_CURRENT = "Current";
	  var TOK_EXPREF = "Expref";
	  var TOK_PIPE = "Pipe";
	  var TOK_OR = "Or";
	  var TOK_AND = "And";
	  var TOK_EQ = "EQ";
	  var TOK_GT = "GT";
	  var TOK_LT = "LT";
	  var TOK_GTE = "GTE";
	  var TOK_LTE = "LTE";
	  var TOK_NE = "NE";
	  var TOK_FLATTEN = "Flatten";
	  var TOK_STAR = "Star";
	  var TOK_FILTER = "Filter";
	  var TOK_DOT = "Dot";
	  var TOK_NOT = "Not";
	  var TOK_LBRACE = "Lbrace";
	  var TOK_LBRACKET = "Lbracket";
	  var TOK_LPAREN= "Lparen";
	  var TOK_LITERAL= "Literal";
	
	  // The "&", "[", "<", ">" tokens
	  // are not in basicToken because
	  // there are two token variants
	  // ("&&", "[?", "<=", ">=").  This is specially handled
	  // below.
	
	  var basicTokens = {
	    ".": TOK_DOT,
	    "*": TOK_STAR,
	    ",": TOK_COMMA,
	    ":": TOK_COLON,
	    "{": TOK_LBRACE,
	    "}": TOK_RBRACE,
	    "]": TOK_RBRACKET,
	    "(": TOK_LPAREN,
	    ")": TOK_RPAREN,
	    "@": TOK_CURRENT
	  };
	
	  var operatorStartToken = {
	      "<": true,
	      ">": true,
	      "=": true,
	      "!": true
	  };
	
	  var skipChars = {
	      " ": true,
	      "\t": true,
	      "\n": true
	  };
	
	
	  function isAlpha(ch) {
	      return (ch >= "a" && ch <= "z") ||
	             (ch >= "A" && ch <= "Z") ||
	             ch === "_";
	  }
	
	  function isNum(ch) {
	      return (ch >= "0" && ch <= "9") ||
	             ch === "-";
	  }
	  function isAlphaNum(ch) {
	      return (ch >= "a" && ch <= "z") ||
	             (ch >= "A" && ch <= "Z") ||
	             (ch >= "0" && ch <= "9") ||
	             ch === "_";
	  }
	
	  function Lexer() {
	  }
	  Lexer.prototype = {
	      tokenize: function(stream) {
	          var tokens = [];
	          this._current = 0;
	          var start;
	          var identifier;
	          var token;
	          while (this._current < stream.length) {
	              if (isAlpha(stream[this._current])) {
	                  start = this._current;
	                  identifier = this._consumeUnquotedIdentifier(stream);
	                  tokens.push({type: TOK_UNQUOTEDIDENTIFIER,
	                               value: identifier,
	                               start: start});
	              } else if (basicTokens[stream[this._current]] !== undefined) {
	                  tokens.push({type: basicTokens[stream[this._current]],
	                              value: stream[this._current],
	                              start: this._current});
	                  this._current++;
	              } else if (isNum(stream[this._current])) {
	                  token = this._consumeNumber(stream);
	                  tokens.push(token);
	              } else if (stream[this._current] === "[") {
	                  // No need to increment this._current.  This happens
	                  // in _consumeLBracket
	                  token = this._consumeLBracket(stream);
	                  tokens.push(token);
	              } else if (stream[this._current] === "\"") {
	                  start = this._current;
	                  identifier = this._consumeQuotedIdentifier(stream);
	                  tokens.push({type: TOK_QUOTEDIDENTIFIER,
	                               value: identifier,
	                               start: start});
	              } else if (stream[this._current] === "'") {
	                  start = this._current;
	                  identifier = this._consumeRawStringLiteral(stream);
	                  tokens.push({type: TOK_LITERAL,
	                               value: identifier,
	                               start: start});
	              } else if (stream[this._current] === "`") {
	                  start = this._current;
	                  var literal = this._consumeLiteral(stream);
	                  tokens.push({type: TOK_LITERAL,
	                               value: literal,
	                               start: start});
	              } else if (operatorStartToken[stream[this._current]] !== undefined) {
	                  tokens.push(this._consumeOperator(stream));
	              } else if (skipChars[stream[this._current]] !== undefined) {
	                  // Ignore whitespace.
	                  this._current++;
	              } else if (stream[this._current] === "&") {
	                  start = this._current;
	                  this._current++;
	                  if (stream[this._current] === "&") {
	                      this._current++;
	                      tokens.push({type: TOK_AND, value: "&&", start: start});
	                  } else {
	                      tokens.push({type: TOK_EXPREF, value: "&", start: start});
	                  }
	              } else if (stream[this._current] === "|") {
	                  start = this._current;
	                  this._current++;
	                  if (stream[this._current] === "|") {
	                      this._current++;
	                      tokens.push({type: TOK_OR, value: "||", start: start});
	                  } else {
	                      tokens.push({type: TOK_PIPE, value: "|", start: start});
	                  }
	              } else {
	                  var error = new Error("Unknown character:" + stream[this._current]);
	                  error.name = "LexerError";
	                  throw error;
	              }
	          }
	          return tokens;
	      },
	
	      _consumeUnquotedIdentifier: function(stream) {
	          var start = this._current;
	          this._current++;
	          while (this._current < stream.length && isAlphaNum(stream[this._current])) {
	              this._current++;
	          }
	          return stream.slice(start, this._current);
	      },
	
	      _consumeQuotedIdentifier: function(stream) {
	          var start = this._current;
	          this._current++;
	          var maxLength = stream.length;
	          while (stream[this._current] !== "\"" && this._current < maxLength) {
	              // You can escape a double quote and you can escape an escape.
	              var current = this._current;
	              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
	                                               stream[current + 1] === "\"")) {
	                  current += 2;
	              } else {
	                  current++;
	              }
	              this._current = current;
	          }
	          this._current++;
	          return JSON.parse(stream.slice(start, this._current));
	      },
	
	      _consumeRawStringLiteral: function(stream) {
	          var start = this._current;
	          this._current++;
	          var maxLength = stream.length;
	          while (stream[this._current] !== "'" && this._current < maxLength) {
	              // You can escape a single quote and you can escape an escape.
	              var current = this._current;
	              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
	                                               stream[current + 1] === "'")) {
	                  current += 2;
	              } else {
	                  current++;
	              }
	              this._current = current;
	          }
	          this._current++;
	          var literal = stream.slice(start + 1, this._current - 1);
	          return literal.replace("\\'", "'");
	      },
	
	      _consumeNumber: function(stream) {
	          var start = this._current;
	          this._current++;
	          var maxLength = stream.length;
	          while (isNum(stream[this._current]) && this._current < maxLength) {
	              this._current++;
	          }
	          var value = parseInt(stream.slice(start, this._current));
	          return {type: TOK_NUMBER, value: value, start: start};
	      },
	
	      _consumeLBracket: function(stream) {
	          var start = this._current;
	          this._current++;
	          if (stream[this._current] === "?") {
	              this._current++;
	              return {type: TOK_FILTER, value: "[?", start: start};
	          } else if (stream[this._current] === "]") {
	              this._current++;
	              return {type: TOK_FLATTEN, value: "[]", start: start};
	          } else {
	              return {type: TOK_LBRACKET, value: "[", start: start};
	          }
	      },
	
	      _consumeOperator: function(stream) {
	          var start = this._current;
	          var startingChar = stream[start];
	          this._current++;
	          if (startingChar === "!") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_NE, value: "!=", start: start};
	              } else {
	                return {type: TOK_NOT, value: "!", start: start};
	              }
	          } else if (startingChar === "<") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_LTE, value: "<=", start: start};
	              } else {
	                  return {type: TOK_LT, value: "<", start: start};
	              }
	          } else if (startingChar === ">") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_GTE, value: ">=", start: start};
	              } else {
	                  return {type: TOK_GT, value: ">", start: start};
	              }
	          } else if (startingChar === "=") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_EQ, value: "==", start: start};
	              }
	          }
	      },
	
	      _consumeLiteral: function(stream) {
	          this._current++;
	          var start = this._current;
	          var maxLength = stream.length;
	          var literal;
	          while(stream[this._current] !== "`" && this._current < maxLength) {
	              // You can escape a literal char or you can escape the escape.
	              var current = this._current;
	              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
	                                               stream[current + 1] === "`")) {
	                  current += 2;
	              } else {
	                  current++;
	              }
	              this._current = current;
	          }
	          var literalString = trimLeft(stream.slice(start, this._current));
	          literalString = literalString.replace("\\`", "`");
	          if (this._looksLikeJSON(literalString)) {
	              literal = JSON.parse(literalString);
	          } else {
	              // Try to JSON parse it as "<literal>"
	              literal = JSON.parse("\"" + literalString + "\"");
	          }
	          // +1 gets us to the ending "`", +1 to move on to the next char.
	          this._current++;
	          return literal;
	      },
	
	      _looksLikeJSON: function(literalString) {
	          var startingChars = "[{\"";
	          var jsonLiterals = ["true", "false", "null"];
	          var numberLooking = "-0123456789";
	
	          if (literalString === "") {
	              return false;
	          } else if (startingChars.indexOf(literalString[0]) >= 0) {
	              return true;
	          } else if (jsonLiterals.indexOf(literalString) >= 0) {
	              return true;
	          } else if (numberLooking.indexOf(literalString[0]) >= 0) {
	              try {
	                  JSON.parse(literalString);
	                  return true;
	              } catch (ex) {
	                  return false;
	              }
	          } else {
	              return false;
	          }
	      }
	  };
	
	      var bindingPower = {};
	      bindingPower[TOK_EOF] = 0;
	      bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
	      bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
	      bindingPower[TOK_RBRACKET] = 0;
	      bindingPower[TOK_RPAREN] = 0;
	      bindingPower[TOK_COMMA] = 0;
	      bindingPower[TOK_RBRACE] = 0;
	      bindingPower[TOK_NUMBER] = 0;
	      bindingPower[TOK_CURRENT] = 0;
	      bindingPower[TOK_EXPREF] = 0;
	      bindingPower[TOK_PIPE] = 1;
	      bindingPower[TOK_OR] = 2;
	      bindingPower[TOK_AND] = 3;
	      bindingPower[TOK_EQ] = 5;
	      bindingPower[TOK_GT] = 5;
	      bindingPower[TOK_LT] = 5;
	      bindingPower[TOK_GTE] = 5;
	      bindingPower[TOK_LTE] = 5;
	      bindingPower[TOK_NE] = 5;
	      bindingPower[TOK_FLATTEN] = 9;
	      bindingPower[TOK_STAR] = 20;
	      bindingPower[TOK_FILTER] = 21;
	      bindingPower[TOK_DOT] = 40;
	      bindingPower[TOK_NOT] = 45;
	      bindingPower[TOK_LBRACE] = 50;
	      bindingPower[TOK_LBRACKET] = 55;
	      bindingPower[TOK_LPAREN] = 60;
	
	  function Parser() {
	  }
	
	  Parser.prototype = {
	      parse: function(expression) {
	          this._loadTokens(expression);
	          this.index = 0;
	          var ast = this.expression(0);
	          if (this._lookahead(0) !== TOK_EOF) {
	              var t = this._lookaheadToken(0);
	              var error = new Error(
	                  "Unexpected token type: " + t.type + ", value: " + t.value);
	              error.name = "ParserError";
	              throw error;
	          }
	          return ast;
	      },
	
	      _loadTokens: function(expression) {
	          var lexer = new Lexer();
	          var tokens = lexer.tokenize(expression);
	          tokens.push({type: TOK_EOF, value: "", start: expression.length});
	          this.tokens = tokens;
	      },
	
	      expression: function(rbp) {
	          var leftToken = this._lookaheadToken(0);
	          this._advance();
	          var left = this.nud(leftToken);
	          var currentToken = this._lookahead(0);
	          while (rbp < bindingPower[currentToken]) {
	              this._advance();
	              left = this.led(currentToken, left);
	              currentToken = this._lookahead(0);
	          }
	          return left;
	      },
	
	      _lookahead: function(number) {
	          return this.tokens[this.index + number].type;
	      },
	
	      _lookaheadToken: function(number) {
	          return this.tokens[this.index + number];
	      },
	
	      _advance: function() {
	          this.index++;
	      },
	
	      nud: function(token) {
	        var left;
	        var right;
	        var expression;
	        switch (token.type) {
	          case TOK_LITERAL:
	            return {type: "Literal", value: token.value};
	          case TOK_UNQUOTEDIDENTIFIER:
	            return {type: "Field", name: token.value};
	          case TOK_QUOTEDIDENTIFIER:
	            var node = {type: "Field", name: token.value};
	            if (this._lookahead(0) === TOK_LPAREN) {
	                throw new Error("Quoted identifier not allowed for function names.");
	            }
	            return node;
	          case TOK_NOT:
	            right = this.expression(bindingPower.Not);
	            return {type: "NotExpression", children: [right]};
	          case TOK_STAR:
	            left = {type: "Identity"};
	            right = null;
	            if (this._lookahead(0) === TOK_RBRACKET) {
	                // This can happen in a multiselect,
	                // [a, b, *]
	                right = {type: "Identity"};
	            } else {
	                right = this._parseProjectionRHS(bindingPower.Star);
	            }
	            return {type: "ValueProjection", children: [left, right]};
	          case TOK_FILTER:
	            return this.led(token.type, {type: "Identity"});
	          case TOK_LBRACE:
	            return this._parseMultiselectHash();
	          case TOK_FLATTEN:
	            left = {type: TOK_FLATTEN, children: [{type: "Identity"}]};
	            right = this._parseProjectionRHS(bindingPower.Flatten);
	            return {type: "Projection", children: [left, right]};
	          case TOK_LBRACKET:
	            if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
	                right = this._parseIndexExpression();
	                return this._projectIfSlice({type: "Identity"}, right);
	            } else if (this._lookahead(0) === TOK_STAR &&
	                       this._lookahead(1) === TOK_RBRACKET) {
	                this._advance();
	                this._advance();
	                right = this._parseProjectionRHS(bindingPower.Star);
	                return {type: "Projection",
	                        children: [{type: "Identity"}, right]};
	            }
	            return this._parseMultiselectList();
	          case TOK_CURRENT:
	            return {type: TOK_CURRENT};
	          case TOK_EXPREF:
	            expression = this.expression(bindingPower.Expref);
	            return {type: "ExpressionReference", children: [expression]};
	          case TOK_LPAREN:
	            var args = [];
	            while (this._lookahead(0) !== TOK_RPAREN) {
	              if (this._lookahead(0) === TOK_CURRENT) {
	                expression = {type: TOK_CURRENT};
	                this._advance();
	              } else {
	                expression = this.expression(0);
	              }
	              args.push(expression);
	            }
	            this._match(TOK_RPAREN);
	            return args[0];
	          default:
	            this._errorToken(token);
	        }
	      },
	
	      led: function(tokenName, left) {
	        var right;
	        switch(tokenName) {
	          case TOK_DOT:
	            var rbp = bindingPower.Dot;
	            if (this._lookahead(0) !== TOK_STAR) {
	                right = this._parseDotRHS(rbp);
	                return {type: "Subexpression", children: [left, right]};
	            }
	            // Creating a projection.
	            this._advance();
	            right = this._parseProjectionRHS(rbp);
	            return {type: "ValueProjection", children: [left, right]};
	          case TOK_PIPE:
	            right = this.expression(bindingPower.Pipe);
	            return {type: TOK_PIPE, children: [left, right]};
	          case TOK_OR:
	            right = this.expression(bindingPower.Or);
	            return {type: "OrExpression", children: [left, right]};
	          case TOK_AND:
	            right = this.expression(bindingPower.And);
	            return {type: "AndExpression", children: [left, right]};
	          case TOK_LPAREN:
	            var name = left.name;
	            var args = [];
	            var expression, node;
	            while (this._lookahead(0) !== TOK_RPAREN) {
	              if (this._lookahead(0) === TOK_CURRENT) {
	                expression = {type: TOK_CURRENT};
	                this._advance();
	              } else {
	                expression = this.expression(0);
	              }
	              if (this._lookahead(0) === TOK_COMMA) {
	                this._match(TOK_COMMA);
	              }
	              args.push(expression);
	            }
	            this._match(TOK_RPAREN);
	            node = {type: "Function", name: name, children: args};
	            return node;
	          case TOK_FILTER:
	            var condition = this.expression(0);
	            this._match(TOK_RBRACKET);
	            if (this._lookahead(0) === TOK_FLATTEN) {
	              right = {type: "Identity"};
	            } else {
	              right = this._parseProjectionRHS(bindingPower.Filter);
	            }
	            return {type: "FilterProjection", children: [left, right, condition]};
	          case TOK_FLATTEN:
	            var leftNode = {type: TOK_FLATTEN, children: [left]};
	            var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
	            return {type: "Projection", children: [leftNode, rightNode]};
	          case TOK_EQ:
	          case TOK_NE:
	          case TOK_GT:
	          case TOK_GTE:
	          case TOK_LT:
	          case TOK_LTE:
	            return this._parseComparator(left, tokenName);
	          case TOK_LBRACKET:
	            var token = this._lookaheadToken(0);
	            if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
	                right = this._parseIndexExpression();
	                return this._projectIfSlice(left, right);
	            }
	            this._match(TOK_STAR);
	            this._match(TOK_RBRACKET);
	            right = this._parseProjectionRHS(bindingPower.Star);
	            return {type: "Projection", children: [left, right]};
	          default:
	            this._errorToken(this._lookaheadToken(0));
	        }
	      },
	
	      _match: function(tokenType) {
	          if (this._lookahead(0) === tokenType) {
	              this._advance();
	          } else {
	              var t = this._lookaheadToken(0);
	              var error = new Error("Expected " + tokenType + ", got: " + t.type);
	              error.name = "ParserError";
	              throw error;
	          }
	      },
	
	      _errorToken: function(token) {
	          var error = new Error("Invalid token (" +
	                                token.type + "): \"" +
	                                token.value + "\"");
	          error.name = "ParserError";
	          throw error;
	      },
	
	
	      _parseIndexExpression: function() {
	          if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) {
	              return this._parseSliceExpression();
	          } else {
	              var node = {
	                  type: "Index",
	                  value: this._lookaheadToken(0).value};
	              this._advance();
	              this._match(TOK_RBRACKET);
	              return node;
	          }
	      },
	
	      _projectIfSlice: function(left, right) {
	          var indexExpr = {type: "IndexExpression", children: [left, right]};
	          if (right.type === "Slice") {
	              return {
	                  type: "Projection",
	                  children: [indexExpr, this._parseProjectionRHS(bindingPower.Star)]
	              };
	          } else {
	              return indexExpr;
	          }
	      },
	
	      _parseSliceExpression: function() {
	          // [start:end:step] where each part is optional, as well as the last
	          // colon.
	          var parts = [null, null, null];
	          var index = 0;
	          var currentToken = this._lookahead(0);
	          while (currentToken !== TOK_RBRACKET && index < 3) {
	              if (currentToken === TOK_COLON) {
	                  index++;
	                  this._advance();
	              } else if (currentToken === TOK_NUMBER) {
	                  parts[index] = this._lookaheadToken(0).value;
	                  this._advance();
	              } else {
	                  var t = this._lookahead(0);
	                  var error = new Error("Syntax error, unexpected token: " +
	                                        t.value + "(" + t.type + ")");
	                  error.name = "Parsererror";
	                  throw error;
	              }
	              currentToken = this._lookahead(0);
	          }
	          this._match(TOK_RBRACKET);
	          return {
	              type: "Slice",
	              children: parts
	          };
	      },
	
	      _parseComparator: function(left, comparator) {
	        var right = this.expression(bindingPower[comparator]);
	        return {type: "Comparator", name: comparator, children: [left, right]};
	      },
	
	      _parseDotRHS: function(rbp) {
	          var lookahead = this._lookahead(0);
	          var exprTokens = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER, TOK_STAR];
	          if (exprTokens.indexOf(lookahead) >= 0) {
	              return this.expression(rbp);
	          } else if (lookahead === TOK_LBRACKET) {
	              this._match(TOK_LBRACKET);
	              return this._parseMultiselectList();
	          } else if (lookahead === TOK_LBRACE) {
	              this._match(TOK_LBRACE);
	              return this._parseMultiselectHash();
	          }
	      },
	
	      _parseProjectionRHS: function(rbp) {
	          var right;
	          if (bindingPower[this._lookahead(0)] < 10) {
	              right = {type: "Identity"};
	          } else if (this._lookahead(0) === TOK_LBRACKET) {
	              right = this.expression(rbp);
	          } else if (this._lookahead(0) === TOK_FILTER) {
	              right = this.expression(rbp);
	          } else if (this._lookahead(0) === TOK_DOT) {
	              this._match(TOK_DOT);
	              right = this._parseDotRHS(rbp);
	          } else {
	              var t = this._lookaheadToken(0);
	              var error = new Error("Sytanx error, unexpected token: " +
	                                    t.value + "(" + t.type + ")");
	              error.name = "ParserError";
	              throw error;
	          }
	          return right;
	      },
	
	      _parseMultiselectList: function() {
	          var expressions = [];
	          while (this._lookahead(0) !== TOK_RBRACKET) {
	              var expression = this.expression(0);
	              expressions.push(expression);
	              if (this._lookahead(0) === TOK_COMMA) {
	                  this._match(TOK_COMMA);
	                  if (this._lookahead(0) === TOK_RBRACKET) {
	                    throw new Error("Unexpected token Rbracket");
	                  }
	              }
	          }
	          this._match(TOK_RBRACKET);
	          return {type: "MultiSelectList", children: expressions};
	      },
	
	      _parseMultiselectHash: function() {
	        var pairs = [];
	        var identifierTypes = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER];
	        var keyToken, keyName, value, node;
	        for (;;) {
	          keyToken = this._lookaheadToken(0);
	          if (identifierTypes.indexOf(keyToken.type) < 0) {
	            throw new Error("Expecting an identifier token, got: " +
	                            keyToken.type);
	          }
	          keyName = keyToken.value;
	          this._advance();
	          this._match(TOK_COLON);
	          value = this.expression(0);
	          node = {type: "KeyValuePair", name: keyName, value: value};
	          pairs.push(node);
	          if (this._lookahead(0) === TOK_COMMA) {
	            this._match(TOK_COMMA);
	          } else if (this._lookahead(0) === TOK_RBRACE) {
	            this._match(TOK_RBRACE);
	            break;
	          }
	        }
	        return {type: "MultiSelectHash", children: pairs};
	      }
	  };
	
	
	  function TreeInterpreter(runtime) {
	    this.runtime = runtime;
	  }
	
	  TreeInterpreter.prototype = {
	      search: function(node, value) {
	          return this.visit(node, value);
	      },
	
	      visit: function(node, value) {
	          var matched, current, result, first, second, field, left, right, collected, i;
	          switch (node.type) {
	            case "Field":
	              if (value !== null && isObject(value)) {
	                  field = value[node.name];
	                  if (field === undefined) {
	                      return null;
	                  } else {
	                      return field;
	                  }
	              }
	              return null;
	            case "Subexpression":
	              result = this.visit(node.children[0], value);
	              for (i = 1; i < node.children.length; i++) {
	                  result = this.visit(node.children[1], result);
	                  if (result === null) {
	                      return null;
	                  }
	              }
	              return result;
	            case "IndexExpression":
	              left = this.visit(node.children[0], value);
	              right = this.visit(node.children[1], left);
	              return right;
	            case "Index":
	              if (!isArray(value)) {
	                return null;
	              }
	              var index = node.value;
	              if (index < 0) {
	                index = value.length + index;
	              }
	              result = value[index];
	              if (result === undefined) {
	                result = null;
	              }
	              return result;
	            case "Slice":
	              if (!isArray(value)) {
	                return null;
	              }
	              var sliceParams = node.children.slice(0);
	              var computed = this.computeSliceParams(value.length, sliceParams);
	              var start = computed[0];
	              var stop = computed[1];
	              var step = computed[2];
	              result = [];
	              if (step > 0) {
	                  for (i = start; i < stop; i += step) {
	                      result.push(value[i]);
	                  }
	              } else {
	                  for (i = start; i > stop; i += step) {
	                      result.push(value[i]);
	                  }
	              }
	              return result;
	            case "Projection":
	              // Evaluate left child.
	              var base = this.visit(node.children[0], value);
	              if (!isArray(base)) {
	                return null;
	              }
	              collected = [];
	              for (i = 0; i < base.length; i++) {
	                current = this.visit(node.children[1], base[i]);
	                if (current !== null) {
	                  collected.push(current);
	                }
	              }
	              return collected;
	            case "ValueProjection":
	              // Evaluate left child.
	              base = this.visit(node.children[0], value);
	              if (!isObject(base)) {
	                return null;
	              }
	              collected = [];
	              var values = objValues(base);
	              for (i = 0; i < values.length; i++) {
	                current = this.visit(node.children[1], values[i]);
	                if (current !== null) {
	                  collected.push(current);
	                }
	              }
	              return collected;
	            case "FilterProjection":
	              base = this.visit(node.children[0], value);
	              if (!isArray(base)) {
	                return null;
	              }
	              var filtered = [];
	              var finalResults = [];
	              for (i = 0; i < base.length; i++) {
	                matched = this.visit(node.children[2], base[i]);
	                if (!isFalse(matched)) {
	                  filtered.push(base[i]);
	                }
	              }
	              for (var j = 0; j < filtered.length; j++) {
	                current = this.visit(node.children[1], filtered[j]);
	                if (current !== null) {
	                  finalResults.push(current);
	                }
	              }
	              return finalResults;
	            case "Comparator":
	              first = this.visit(node.children[0], value);
	              second = this.visit(node.children[1], value);
	              switch(node.name) {
	                case TOK_EQ:
	                  result = strictDeepEqual(first, second);
	                  break;
	                case TOK_NE:
	                  result = !strictDeepEqual(first, second);
	                  break;
	                case TOK_GT:
	                  result = first > second;
	                  break;
	                case TOK_GTE:
	                  result = first >= second;
	                  break;
	                case TOK_LT:
	                  result = first < second;
	                  break;
	                case TOK_LTE:
	                  result = first <= second;
	                  break;
	                default:
	                  throw new Error("Unknown comparator: " + node.name);
	              }
	              return result;
	            case TOK_FLATTEN:
	              var original = this.visit(node.children[0], value);
	              if (!isArray(original)) {
	                return null;
	              }
	              var merged = [];
	              for (i = 0; i < original.length; i++) {
	                current = original[i];
	                if (isArray(current)) {
	                  merged.push.apply(merged, current);
	                } else {
	                  merged.push(current);
	                }
	              }
	              return merged;
	            case "Identity":
	              return value;
	            case "MultiSelectList":
	              if (value === null) {
	                return null;
	              }
	              collected = [];
	              for (i = 0; i < node.children.length; i++) {
	                  collected.push(this.visit(node.children[i], value));
	              }
	              return collected;
	            case "MultiSelectHash":
	              if (value === null) {
	                return null;
	              }
	              collected = {};
	              var child;
	              for (i = 0; i < node.children.length; i++) {
	                child = node.children[i];
	                collected[child.name] = this.visit(child.value, value);
	              }
	              return collected;
	            case "OrExpression":
	              matched = this.visit(node.children[0], value);
	              if (isFalse(matched)) {
	                  matched = this.visit(node.children[1], value);
	              }
	              return matched;
	            case "AndExpression":
	              first = this.visit(node.children[0], value);
	
	              if (isFalse(first) === true) {
	                return first;
	              }
	              return this.visit(node.children[1], value);
	            case "NotExpression":
	              first = this.visit(node.children[0], value);
	              return isFalse(first);
	            case "Literal":
	              return node.value;
	            case TOK_PIPE:
	              left = this.visit(node.children[0], value);
	              return this.visit(node.children[1], left);
	            case TOK_CURRENT:
	              return value;
	            case "Function":
	              var resolvedArgs = [];
	              for (i = 0; i < node.children.length; i++) {
	                  resolvedArgs.push(this.visit(node.children[i], value));
	              }
	              return this.runtime.callFunction(node.name, resolvedArgs);
	            case "ExpressionReference":
	              var refNode = node.children[0];
	              // Tag the node with a specific attribute so the type
	              // checker verify the type.
	              refNode.jmespathType = TOK_EXPREF;
	              return refNode;
	            default:
	              throw new Error("Unknown node type: " + node.type);
	          }
	      },
	
	      computeSliceParams: function(arrayLength, sliceParams) {
	        var start = sliceParams[0];
	        var stop = sliceParams[1];
	        var step = sliceParams[2];
	        var computed = [null, null, null];
	        if (step === null) {
	          step = 1;
	        } else if (step === 0) {
	          var error = new Error("Invalid slice, step cannot be 0");
	          error.name = "RuntimeError";
	          throw error;
	        }
	        var stepValueNegative = step < 0 ? true : false;
	
	        if (start === null) {
	            start = stepValueNegative ? arrayLength - 1 : 0;
	        } else {
	            start = this.capSliceRange(arrayLength, start, step);
	        }
	
	        if (stop === null) {
	            stop = stepValueNegative ? -1 : arrayLength;
	        } else {
	            stop = this.capSliceRange(arrayLength, stop, step);
	        }
	        computed[0] = start;
	        computed[1] = stop;
	        computed[2] = step;
	        return computed;
	      },
	
	      capSliceRange: function(arrayLength, actualValue, step) {
	          if (actualValue < 0) {
	              actualValue += arrayLength;
	              if (actualValue < 0) {
	                  actualValue = step < 0 ? -1 : 0;
	              }
	          } else if (actualValue >= arrayLength) {
	              actualValue = step < 0 ? arrayLength - 1 : arrayLength;
	          }
	          return actualValue;
	      }
	
	  };
	
	  function Runtime(interpreter) {
	    this._interpreter = interpreter;
	    this.functionTable = {
	        // name: [function, <signature>]
	        // The <signature> can be:
	        //
	        // {
	        //   args: [[type1, type2], [type1, type2]],
	        //   variadic: true|false
	        // }
	        //
	        // Each arg in the arg list is a list of valid types
	        // (if the function is overloaded and supports multiple
	        // types.  If the type is "any" then no type checking
	        // occurs on the argument.  Variadic is optional
	        // and if not provided is assumed to be false.
	        abs: {_func: this._functionAbs, _signature: [{types: [TYPE_NUMBER]}]},
	        avg: {_func: this._functionAvg, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
	        ceil: {_func: this._functionCeil, _signature: [{types: [TYPE_NUMBER]}]},
	        contains: {
	            _func: this._functionContains,
	            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]},
	                        {types: [TYPE_ANY]}]},
	        "ends_with": {
	            _func: this._functionEndsWith,
	            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
	        floor: {_func: this._functionFloor, _signature: [{types: [TYPE_NUMBER]}]},
	        length: {
	            _func: this._functionLength,
	            _signature: [{types: [TYPE_STRING, TYPE_ARRAY, TYPE_OBJECT]}]},
	        map: {
	            _func: this._functionMap,
	            _signature: [{types: [TYPE_EXPREF]}, {types: [TYPE_ARRAY]}]},
	        max: {
	            _func: this._functionMax,
	            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
	        "merge": {
	            _func: this._functionMerge,
	            _signature: [{types: [TYPE_OBJECT], variadic: true}]
	        },
	        "max_by": {
	          _func: this._functionMaxBy,
	          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
	        },
	        sum: {_func: this._functionSum, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
	        "starts_with": {
	            _func: this._functionStartsWith,
	            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
	        min: {
	            _func: this._functionMin,
	            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
	        "min_by": {
	          _func: this._functionMinBy,
	          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
	        },
	        type: {_func: this._functionType, _signature: [{types: [TYPE_ANY]}]},
	        keys: {_func: this._functionKeys, _signature: [{types: [TYPE_OBJECT]}]},
	        values: {_func: this._functionValues, _signature: [{types: [TYPE_OBJECT]}]},
	        sort: {_func: this._functionSort, _signature: [{types: [TYPE_ARRAY_STRING, TYPE_ARRAY_NUMBER]}]},
	        "sort_by": {
	          _func: this._functionSortBy,
	          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
	        },
	        join: {
	            _func: this._functionJoin,
	            _signature: [
	                {types: [TYPE_STRING]},
	                {types: [TYPE_ARRAY_STRING]}
	            ]
	        },
	        reverse: {
	            _func: this._functionReverse,
	            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]}]},
	        "to_array": {_func: this._functionToArray, _signature: [{types: [TYPE_ANY]}]},
	        "to_string": {_func: this._functionToString, _signature: [{types: [TYPE_ANY]}]},
	        "to_number": {_func: this._functionToNumber, _signature: [{types: [TYPE_ANY]}]},
	        "not_null": {
	            _func: this._functionNotNull,
	            _signature: [{types: [TYPE_ANY], variadic: true}]
	        }
	    };
	  }
	
	  Runtime.prototype = {
	    callFunction: function(name, resolvedArgs) {
	      var functionEntry = this.functionTable[name];
	      if (functionEntry === undefined) {
	          throw new Error("Unknown function: " + name + "()");
	      }
	      this._validateArgs(name, resolvedArgs, functionEntry._signature);
	      return functionEntry._func.call(this, resolvedArgs);
	    },
	
	    _validateArgs: function(name, args, signature) {
	        // Validating the args requires validating
	        // the correct arity and the correct type of each arg.
	        // If the last argument is declared as variadic, then we need
	        // a minimum number of args to be required.  Otherwise it has to
	        // be an exact amount.
	        var pluralized;
	        if (signature[signature.length - 1].variadic) {
	            if (args.length < signature.length) {
	                pluralized = signature.length === 1 ? " argument" : " arguments";
	                throw new Error("ArgumentError: " + name + "() " +
	                                "takes at least" + signature.length + pluralized +
	                                " but received " + args.length);
	            }
	        } else if (args.length !== signature.length) {
	            pluralized = signature.length === 1 ? " argument" : " arguments";
	            throw new Error("ArgumentError: " + name + "() " +
	                            "takes " + signature.length + pluralized +
	                            " but received " + args.length);
	        }
	        var currentSpec;
	        var actualType;
	        var typeMatched;
	        for (var i = 0; i < signature.length; i++) {
	            typeMatched = false;
	            currentSpec = signature[i].types;
	            actualType = this._getTypeName(args[i]);
	            for (var j = 0; j < currentSpec.length; j++) {
	                if (this._typeMatches(actualType, currentSpec[j], args[i])) {
	                    typeMatched = true;
	                    break;
	                }
	            }
	            if (!typeMatched) {
	                var expected = currentSpec
	                    .map(function(typeIdentifier) {
	                        return TYPE_NAME_TABLE[typeIdentifier];
	                    })
	                    .join(',');
	                throw new Error("TypeError: " + name + "() " +
	                                "expected argument " + (i + 1) +
	                                " to be type " + expected +
	                                " but received type " +
	                                TYPE_NAME_TABLE[actualType] + " instead.");
	            }
	        }
	    },
	
	    _typeMatches: function(actual, expected, argValue) {
	        if (expected === TYPE_ANY) {
	            return true;
	        }
	        if (expected === TYPE_ARRAY_STRING ||
	            expected === TYPE_ARRAY_NUMBER ||
	            expected === TYPE_ARRAY) {
	            // The expected type can either just be array,
	            // or it can require a specific subtype (array of numbers).
	            //
	            // The simplest case is if "array" with no subtype is specified.
	            if (expected === TYPE_ARRAY) {
	                return actual === TYPE_ARRAY;
	            } else if (actual === TYPE_ARRAY) {
	                // Otherwise we need to check subtypes.
	                // I think this has potential to be improved.
	                var subtype;
	                if (expected === TYPE_ARRAY_NUMBER) {
	                  subtype = TYPE_NUMBER;
	                } else if (expected === TYPE_ARRAY_STRING) {
	                  subtype = TYPE_STRING;
	                }
	                for (var i = 0; i < argValue.length; i++) {
	                    if (!this._typeMatches(
	                            this._getTypeName(argValue[i]), subtype,
	                                             argValue[i])) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	        } else {
	            return actual === expected;
	        }
	    },
	    _getTypeName: function(obj) {
	        switch (Object.prototype.toString.call(obj)) {
	            case "[object String]":
	              return TYPE_STRING;
	            case "[object Number]":
	              return TYPE_NUMBER;
	            case "[object Array]":
	              return TYPE_ARRAY;
	            case "[object Boolean]":
	              return TYPE_BOOLEAN;
	            case "[object Null]":
	              return TYPE_NULL;
	            case "[object Object]":
	              // Check if it's an expref.  If it has, it's been
	              // tagged with a jmespathType attr of 'Expref';
	              if (obj.jmespathType === TOK_EXPREF) {
	                return TYPE_EXPREF;
	              } else {
	                return TYPE_OBJECT;
	              }
	        }
	    },
	
	    _functionStartsWith: function(resolvedArgs) {
	        return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
	    },
	
	    _functionEndsWith: function(resolvedArgs) {
	        var searchStr = resolvedArgs[0];
	        var suffix = resolvedArgs[1];
	        return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
	    },
	
	    _functionReverse: function(resolvedArgs) {
	        var typeName = this._getTypeName(resolvedArgs[0]);
	        if (typeName === TYPE_STRING) {
	          var originalStr = resolvedArgs[0];
	          var reversedStr = "";
	          for (var i = originalStr.length - 1; i >= 0; i--) {
	              reversedStr += originalStr[i];
	          }
	          return reversedStr;
	        } else {
	          var reversedArray = resolvedArgs[0].slice(0);
	          reversedArray.reverse();
	          return reversedArray;
	        }
	    },
	
	    _functionAbs: function(resolvedArgs) {
	      return Math.abs(resolvedArgs[0]);
	    },
	
	    _functionCeil: function(resolvedArgs) {
	        return Math.ceil(resolvedArgs[0]);
	    },
	
	    _functionAvg: function(resolvedArgs) {
	        var sum = 0;
	        var inputArray = resolvedArgs[0];
	        for (var i = 0; i < inputArray.length; i++) {
	            sum += inputArray[i];
	        }
	        return sum / inputArray.length;
	    },
	
	    _functionContains: function(resolvedArgs) {
	        return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
	    },
	
	    _functionFloor: function(resolvedArgs) {
	        return Math.floor(resolvedArgs[0]);
	    },
	
	    _functionLength: function(resolvedArgs) {
	       if (!isObject(resolvedArgs[0])) {
	         return resolvedArgs[0].length;
	       } else {
	         // As far as I can tell, there's no way to get the length
	         // of an object without O(n) iteration through the object.
	         return Object.keys(resolvedArgs[0]).length;
	       }
	    },
	
	    _functionMap: function(resolvedArgs) {
	      var mapped = [];
	      var interpreter = this._interpreter;
	      var exprefNode = resolvedArgs[0];
	      var elements = resolvedArgs[1];
	      for (var i = 0; i < elements.length; i++) {
	          mapped.push(interpreter.visit(exprefNode, elements[i]));
	      }
	      return mapped;
	    },
	
	    _functionMerge: function(resolvedArgs) {
	      var merged = {};
	      for (var i = 0; i < resolvedArgs.length; i++) {
	        var current = resolvedArgs[i];
	        for (var key in current) {
	          merged[key] = current[key];
	        }
	      }
	      return merged;
	    },
	
	    _functionMax: function(resolvedArgs) {
	      if (resolvedArgs[0].length > 0) {
	        var typeName = this._getTypeName(resolvedArgs[0][0]);
	        if (typeName === TYPE_NUMBER) {
	          return Math.max.apply(Math, resolvedArgs[0]);
	        } else {
	          var elements = resolvedArgs[0];
	          var maxElement = elements[0];
	          for (var i = 1; i < elements.length; i++) {
	              if (maxElement.localeCompare(elements[i]) < 0) {
	                  maxElement = elements[i];
	              }
	          }
	          return maxElement;
	        }
	      } else {
	          return null;
	      }
	    },
	
	    _functionMin: function(resolvedArgs) {
	      if (resolvedArgs[0].length > 0) {
	        var typeName = this._getTypeName(resolvedArgs[0][0]);
	        if (typeName === TYPE_NUMBER) {
	          return Math.min.apply(Math, resolvedArgs[0]);
	        } else {
	          var elements = resolvedArgs[0];
	          var minElement = elements[0];
	          for (var i = 1; i < elements.length; i++) {
	              if (elements[i].localeCompare(minElement) < 0) {
	                  minElement = elements[i];
	              }
	          }
	          return minElement;
	        }
	      } else {
	        return null;
	      }
	    },
	
	    _functionSum: function(resolvedArgs) {
	      var sum = 0;
	      var listToSum = resolvedArgs[0];
	      for (var i = 0; i < listToSum.length; i++) {
	        sum += listToSum[i];
	      }
	      return sum;
	    },
	
	    _functionType: function(resolvedArgs) {
	        switch (this._getTypeName(resolvedArgs[0])) {
	          case TYPE_NUMBER:
	            return "number";
	          case TYPE_STRING:
	            return "string";
	          case TYPE_ARRAY:
	            return "array";
	          case TYPE_OBJECT:
	            return "object";
	          case TYPE_BOOLEAN:
	            return "boolean";
	          case TYPE_EXPREF:
	            return "expref";
	          case TYPE_NULL:
	            return "null";
	        }
	    },
	
	    _functionKeys: function(resolvedArgs) {
	        return Object.keys(resolvedArgs[0]);
	    },
	
	    _functionValues: function(resolvedArgs) {
	        var obj = resolvedArgs[0];
	        var keys = Object.keys(obj);
	        var values = [];
	        for (var i = 0; i < keys.length; i++) {
	            values.push(obj[keys[i]]);
	        }
	        return values;
	    },
	
	    _functionJoin: function(resolvedArgs) {
	        var joinChar = resolvedArgs[0];
	        var listJoin = resolvedArgs[1];
	        return listJoin.join(joinChar);
	    },
	
	    _functionToArray: function(resolvedArgs) {
	        if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) {
	            return resolvedArgs[0];
	        } else {
	            return [resolvedArgs[0]];
	        }
	    },
	
	    _functionToString: function(resolvedArgs) {
	        if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) {
	            return resolvedArgs[0];
	        } else {
	            return JSON.stringify(resolvedArgs[0]);
	        }
	    },
	
	    _functionToNumber: function(resolvedArgs) {
	        var typeName = this._getTypeName(resolvedArgs[0]);
	        var convertedValue;
	        if (typeName === TYPE_NUMBER) {
	            return resolvedArgs[0];
	        } else if (typeName === TYPE_STRING) {
	            convertedValue = +resolvedArgs[0];
	            if (!isNaN(convertedValue)) {
	                return convertedValue;
	            }
	        }
	        return null;
	    },
	
	    _functionNotNull: function(resolvedArgs) {
	        for (var i = 0; i < resolvedArgs.length; i++) {
	            if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) {
	                return resolvedArgs[i];
	            }
	        }
	        return null;
	    },
	
	    _functionSort: function(resolvedArgs) {
	        var sortedArray = resolvedArgs[0].slice(0);
	        sortedArray.sort();
	        return sortedArray;
	    },
	
	    _functionSortBy: function(resolvedArgs) {
	        var sortedArray = resolvedArgs[0].slice(0);
	        if (sortedArray.length === 0) {
	            return sortedArray;
	        }
	        var interpreter = this._interpreter;
	        var exprefNode = resolvedArgs[1];
	        var requiredType = this._getTypeName(
	            interpreter.visit(exprefNode, sortedArray[0]));
	        if ([TYPE_NUMBER, TYPE_STRING].indexOf(requiredType) < 0) {
	            throw new Error("TypeError");
	        }
	        var that = this;
	        // In order to get a stable sort out of an unstable
	        // sort algorithm, we decorate/sort/undecorate (DSU)
	        // by creating a new list of [index, element] pairs.
	        // In the cmp function, if the evaluated elements are
	        // equal, then the index will be used as the tiebreaker.
	        // After the decorated list has been sorted, it will be
	        // undecorated to extract the original elements.
	        var decorated = [];
	        for (var i = 0; i < sortedArray.length; i++) {
	          decorated.push([i, sortedArray[i]]);
	        }
	        decorated.sort(function(a, b) {
	          var exprA = interpreter.visit(exprefNode, a[1]);
	          var exprB = interpreter.visit(exprefNode, b[1]);
	          if (that._getTypeName(exprA) !== requiredType) {
	              throw new Error(
	                  "TypeError: expected " + requiredType + ", received " +
	                  that._getTypeName(exprA));
	          } else if (that._getTypeName(exprB) !== requiredType) {
	              throw new Error(
	                  "TypeError: expected " + requiredType + ", received " +
	                  that._getTypeName(exprB));
	          }
	          if (exprA > exprB) {
	            return 1;
	          } else if (exprA < exprB) {
	            return -1;
	          } else {
	            // If they're equal compare the items by their
	            // order to maintain relative order of equal keys
	            // (i.e. to get a stable sort).
	            return a[0] - b[0];
	          }
	        });
	        // Undecorate: extract out the original list elements.
	        for (var j = 0; j < decorated.length; j++) {
	          sortedArray[j] = decorated[j][1];
	        }
	        return sortedArray;
	    },
	
	    _functionMaxBy: function(resolvedArgs) {
	      var exprefNode = resolvedArgs[1];
	      var resolvedArray = resolvedArgs[0];
	      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
	      var maxNumber = -Infinity;
	      var maxRecord;
	      var current;
	      for (var i = 0; i < resolvedArray.length; i++) {
	        current = keyFunction(resolvedArray[i]);
	        if (current > maxNumber) {
	          maxNumber = current;
	          maxRecord = resolvedArray[i];
	        }
	      }
	      return maxRecord;
	    },
	
	    _functionMinBy: function(resolvedArgs) {
	      var exprefNode = resolvedArgs[1];
	      var resolvedArray = resolvedArgs[0];
	      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
	      var minNumber = Infinity;
	      var minRecord;
	      var current;
	      for (var i = 0; i < resolvedArray.length; i++) {
	        current = keyFunction(resolvedArray[i]);
	        if (current < minNumber) {
	          minNumber = current;
	          minRecord = resolvedArray[i];
	        }
	      }
	      return minRecord;
	    },
	
	    createKeyFunction: function(exprefNode, allowedTypes) {
	      var that = this;
	      var interpreter = this._interpreter;
	      var keyFunc = function(x) {
	        var current = interpreter.visit(exprefNode, x);
	        if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
	          var msg = "TypeError: expected one of " + allowedTypes +
	                    ", received " + that._getTypeName(current);
	          throw new Error(msg);
	        }
	        return current;
	      };
	      return keyFunc;
	    }
	
	  };
	
	  function compile(stream) {
	    var parser = new Parser();
	    var ast = parser.parse(stream);
	    return ast;
	  }
	
	  function tokenize(stream) {
	      var lexer = new Lexer();
	      return lexer.tokenize(stream);
	  }
	
	  function search(data, expression) {
	      var parser = new Parser();
	      // This needs to be improved.  Both the interpreter and runtime depend on
	      // each other.  The runtime needs the interpreter to support exprefs.
	      // There's likely a clean way to avoid the cyclic dependency.
	      var runtime = new Runtime();
	      var interpreter = new TreeInterpreter(runtime);
	      runtime._interpreter = interpreter;
	      var node = parser.parse(expression);
	      return interpreter.search(node, data);
	  }
	
	  exports.tokenize = tokenize;
	  exports.compile = compile;
	  exports.search = search;
	  exports.strictDeepEqual = strictDeepEqual;
	})(typeof exports === "undefined" ? this.jmespath = {} : exports);
	
	},{}],432:[function(require,module,exports){
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	},{}],433:[function(require,module,exports){
	(function (global){(function (){
	/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			typeof define == 'function' &&
			typeof define.amd == 'object' &&
			define.amd
		) {
			define('punycode', function() {
				return punycode;
			});
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],434:[function(require,module,exports){
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	},{}],435:[function(require,module,exports){
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return map(objectKeys(obj), function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (isArray(obj[k])) {
	        return map(obj[k], function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	function map (xs, f) {
	  if (xs.map) return xs.map(f);
	  var res = [];
	  for (var i = 0; i < xs.length; i++) {
	    res.push(f(xs[i], i));
	  }
	  return res;
	}
	
	var objectKeys = Object.keys || function (obj) {
	  var res = [];
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
	  }
	  return res;
	};
	
	},{}],436:[function(require,module,exports){
	'use strict';
	
	exports.decode = exports.parse = require('./decode');
	exports.encode = exports.stringify = require('./encode');
	
	},{"./decode":434,"./encode":435}],437:[function(require,module,exports){
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};
	
	},{}],438:[function(require,module,exports){
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};
	
	},{}],439:[function(require,module,exports){
	arguments[4][436][0].apply(exports,arguments)
	},{"./decode":437,"./encode":438,"dup":436}],440:[function(require,module,exports){
	(function (setImmediate,clearImmediate){(function (){
	var nextTick = require('process/browser.js').nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
	},{"process/browser.js":432,"timers":440}],441:[function(require,module,exports){
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var punycode = require('punycode');
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = require('querystring');
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};
	
	function isString(arg) {
	  return typeof arg === "string";
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}
	
	},{"punycode":433,"querystring":436}],442:[function(require,module,exports){
	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}
	
	},{}],443:[function(require,module,exports){
	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}
	},{}],444:[function(require,module,exports){
	(function (process,global){(function (){
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = require('./support/isBuffer');
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = require('inherits');
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"./support/isBuffer":443,"_process":432,"inherits":442}],445:[function(require,module,exports){
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	
	  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
	}
	
	var _default = bytesToUuid;
	exports.default = _default;
	},{}],446:[function(require,module,exports){
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "v1", {
	  enumerable: true,
	  get: function () {
	    return _v.default;
	  }
	});
	Object.defineProperty(exports, "v3", {
	  enumerable: true,
	  get: function () {
	    return _v2.default;
	  }
	});
	Object.defineProperty(exports, "v4", {
	  enumerable: true,
	  get: function () {
	    return _v3.default;
	  }
	});
	Object.defineProperty(exports, "v5", {
	  enumerable: true,
	  get: function () {
	    return _v4.default;
	  }
	});
	
	var _v = _interopRequireDefault(require("./v1.js"));
	
	var _v2 = _interopRequireDefault(require("./v3.js"));
	
	var _v3 = _interopRequireDefault(require("./v4.js"));
	
	var _v4 = _interopRequireDefault(require("./v5.js"));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	},{"./v1.js":450,"./v3.js":451,"./v4.js":453,"./v5.js":454}],447:[function(require,module,exports){
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/*
	 * Browser-compatible JavaScript MD5
	 *
	 * Modification of JavaScript MD5
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	function md5(bytes) {
	  if (typeof bytes == 'string') {
	    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
	
	    bytes = new Array(msg.length);
	
	    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
	  }
	
	  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
	}
	/*
	 * Convert an array of little-endian words to an array of bytes
	 */
	
	
	function md5ToHexEncodedArray(input) {
	  var i;
	  var x;
	  var output = [];
	  var length32 = input.length * 32;
	  var hexTab = '0123456789abcdef';
	  var hex;
	
	  for (i = 0; i < length32; i += 8) {
	    x = input[i >> 5] >>> i % 32 & 0xff;
	    hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
	    output.push(hex);
	  }
	
	  return output;
	}
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length.
	 */
	
	
	function wordsToMd5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << len % 32;
	  x[(len + 64 >>> 9 << 4) + 14] = len;
	  var i;
	  var olda;
	  var oldb;
	  var oldc;
	  var oldd;
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (i = 0; i < x.length; i += 16) {
	    olda = a;
	    oldb = b;
	    oldc = c;
	    oldd = d;
	    a = md5ff(a, b, c, d, x[i], 7, -680876936);
	    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
	    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5gg(b, c, d, a, x[i], 20, -373897302);
	    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
	    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5hh(d, a, b, c, x[i], 11, -358537222);
	    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
	    a = md5ii(a, b, c, d, x[i], 6, -198630844);
	    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
	    a = safeAdd(a, olda);
	    b = safeAdd(b, oldb);
	    c = safeAdd(c, oldc);
	    d = safeAdd(d, oldd);
	  }
	
	  return [a, b, c, d];
	}
	/*
	 * Convert an array bytes to an array of little-endian words
	 * Characters >255 have their high-byte silently ignored.
	 */
	
	
	function bytesToWords(input) {
	  var i;
	  var output = [];
	  output[(input.length >> 2) - 1] = undefined;
	
	  for (i = 0; i < output.length; i += 1) {
	    output[i] = 0;
	  }
	
	  var length8 = input.length * 8;
	
	  for (i = 0; i < length8; i += 8) {
	    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
	  }
	
	  return output;
	}
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	
	
	function safeAdd(x, y) {
	  var lsw = (x & 0xffff) + (y & 0xffff);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return msw << 16 | lsw & 0xffff;
	}
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	
	
	function bitRotateLeft(num, cnt) {
	  return num << cnt | num >>> 32 - cnt;
	}
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	
	
	function md5cmn(q, a, b, x, s, t) {
	  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
	}
	
	function md5ff(a, b, c, d, x, s, t) {
	  return md5cmn(b & c | ~b & d, a, b, x, s, t);
	}
	
	function md5gg(a, b, c, d, x, s, t) {
	  return md5cmn(b & d | c & ~d, a, b, x, s, t);
	}
	
	function md5hh(a, b, c, d, x, s, t) {
	  return md5cmn(b ^ c ^ d, a, b, x, s, t);
	}
	
	function md5ii(a, b, c, d, x, s, t) {
	  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
	}
	
	var _default = md5;
	exports.default = _default;
	},{}],448:[function(require,module,exports){
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rng;
	// Unique ID creation requires a high quality random # generator. In the browser we therefore
	// require the crypto API and do not support built-in fallback to lower quality random number
	// generators (like Math.random()).
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
	// find the complete implementation of crypto (msCrypto) on IE11.
	var getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
	var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	function rng() {
	  if (!getRandomValues) {
	    throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
	  }
	
	  return getRandomValues(rnds8);
	}
	},{}],449:[function(require,module,exports){
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	// Adapted from Chris Veness' SHA1 code at
	// http://www.movable-type.co.uk/scripts/sha1.html
	function f(s, x, y, z) {
	  switch (s) {
	    case 0:
	      return x & y ^ ~x & z;
	
	    case 1:
	      return x ^ y ^ z;
	
	    case 2:
	      return x & y ^ x & z ^ y & z;
	
	    case 3:
	      return x ^ y ^ z;
	  }
	}
	
	function ROTL(x, n) {
	  return x << n | x >>> 32 - n;
	}
	
	function sha1(bytes) {
	  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
	  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
	
	  if (typeof bytes == 'string') {
	    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
	
	    bytes = new Array(msg.length);
	
	    for (var i = 0; i < msg.length; i++) bytes[i] = msg.charCodeAt(i);
	  }
	
	  bytes.push(0x80);
	  var l = bytes.length / 4 + 2;
	  var N = Math.ceil(l / 16);
	  var M = new Array(N);
	
	  for (var i = 0; i < N; i++) {
	    M[i] = new Array(16);
	
	    for (var j = 0; j < 16; j++) {
	      M[i][j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
	    }
	  }
	
	  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
	  M[N - 1][14] = Math.floor(M[N - 1][14]);
	  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
	
	  for (var i = 0; i < N; i++) {
	    var W = new Array(80);
	
	    for (var t = 0; t < 16; t++) W[t] = M[i][t];
	
	    for (var t = 16; t < 80; t++) {
	      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
	    }
	
	    var a = H[0];
	    var b = H[1];
	    var c = H[2];
	    var d = H[3];
	    var e = H[4];
	
	    for (var t = 0; t < 80; t++) {
	      var s = Math.floor(t / 20);
	      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
	      e = d;
	      d = c;
	      c = ROTL(b, 30) >>> 0;
	      b = a;
	      a = T;
	    }
	
	    H[0] = H[0] + a >>> 0;
	    H[1] = H[1] + b >>> 0;
	    H[2] = H[2] + c >>> 0;
	    H[3] = H[3] + d >>> 0;
	    H[4] = H[4] + e >>> 0;
	  }
	
	  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
	}
	
	var _default = sha1;
	exports.default = _default;
	},{}],450:[function(require,module,exports){
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rng = _interopRequireDefault(require("./rng.js"));
	
	var _bytesToUuid = _interopRequireDefault(require("./bytesToUuid.js"));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	var _nodeId;
	
	var _clockseq; // Previous uuid creation time
	
	
	var _lastMSecs = 0;
	var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
	
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	
	  if (node == null || clockseq == null) {
	    var seedBytes = options.random || (options.rng || _rng.default)();
	
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
	    }
	
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	
	
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime(); // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
	
	  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
	
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	
	
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  } // Per 4.2.1.2 Throw error if too many uuids are requested
	
	
	  if (nsecs >= 10000) {
	    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	
	  msecs += 12219292800000; // `time_low`
	
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff; // `time_mid`
	
	  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff; // `time_high_and_version`
	
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	
	  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	
	  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
	
	  b[i++] = clockseq & 0xff; // `node`
	
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : (0, _bytesToUuid.default)(b);
	}
	
	var _default = v1;
	exports.default = _default;
	},{"./bytesToUuid.js":445,"./rng.js":448}],451:[function(require,module,exports){
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _v = _interopRequireDefault(require("./v35.js"));
	
	var _md = _interopRequireDefault(require("./md5.js"));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	const v3 = (0, _v.default)('v3', 0x30, _md.default);
	var _default = v3;
	exports.default = _default;
	},{"./md5.js":447,"./v35.js":452}],452:[function(require,module,exports){
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	exports.URL = exports.DNS = void 0;
	
	var _bytesToUuid = _interopRequireDefault(require("./bytesToUuid.js"));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function uuidToBytes(uuid) {
	  // Note: We assume we're being passed a valid uuid string
	  var bytes = [];
	  uuid.replace(/[a-fA-F0-9]{2}/g, function (hex) {
	    bytes.push(parseInt(hex, 16));
	  });
	  return bytes;
	}
	
	function stringToBytes(str) {
	  str = unescape(encodeURIComponent(str)); // UTF8 escape
	
	  var bytes = new Array(str.length);
	
	  for (var i = 0; i < str.length; i++) {
	    bytes[i] = str.charCodeAt(i);
	  }
	
	  return bytes;
	}
	
	const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
	exports.DNS = DNS;
	const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
	exports.URL = URL;
	
	function _default(name, version, hashfunc) {
	  var generateUUID = function (value, namespace, buf, offset) {
	    var off = buf && offset || 0;
	    if (typeof value == 'string') value = stringToBytes(value);
	    if (typeof namespace == 'string') namespace = uuidToBytes(namespace);
	    if (!Array.isArray(value)) throw TypeError('value must be an array of bytes');
	    if (!Array.isArray(namespace) || namespace.length !== 16) throw TypeError('namespace must be uuid string or an Array of 16 byte values'); // Per 4.3
	
	    var bytes = hashfunc(namespace.concat(value));
	    bytes[6] = bytes[6] & 0x0f | version;
	    bytes[8] = bytes[8] & 0x3f | 0x80;
	
	    if (buf) {
	      for (var idx = 0; idx < 16; ++idx) {
	        buf[off + idx] = bytes[idx];
	      }
	    }
	
	    return buf || (0, _bytesToUuid.default)(bytes);
	  }; // Function#name is not settable on some platforms (#270)
	
	
	  try {
	    generateUUID.name = name;
	  } catch (err) {} // For CommonJS default export support
	
	
	  generateUUID.DNS = DNS;
	  generateUUID.URL = URL;
	  return generateUUID;
	}
	},{"./bytesToUuid.js":445}],453:[function(require,module,exports){
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rng = _interopRequireDefault(require("./rng.js"));
	
	var _bytesToUuid = _interopRequireDefault(require("./bytesToUuid.js"));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof options == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	
	  options = options || {};
	
	  var rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	
	
	  rnds[6] = rnds[6] & 0x0f | 0x40;
	  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
	
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || (0, _bytesToUuid.default)(rnds);
	}
	
	var _default = v4;
	exports.default = _default;
	},{"./bytesToUuid.js":445,"./rng.js":448}],454:[function(require,module,exports){
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _v = _interopRequireDefault(require("./v35.js"));
	
	var _sha = _interopRequireDefault(require("./sha1.js"));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	const v5 = (0, _v.default)('v5', 0x50, _sha.default);
	var _default = v5;
	exports.default = _default;
	},{"./sha1.js":449,"./v35.js":452}],455:[function(require,module,exports){
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var LRU_1 = require("./utils/LRU");
	var CACHE_SIZE = 1000;
	/**
	 * Inspired node-lru-cache[https://github.com/isaacs/node-lru-cache]
	 */
	var EndpointCache = /** @class */ (function () {
	    function EndpointCache(maxSize) {
	        if (maxSize === void 0) { maxSize = CACHE_SIZE; }
	        this.maxSize = maxSize;
	        this.cache = new LRU_1.LRUCache(maxSize);
	    }
	    ;
	    Object.defineProperty(EndpointCache.prototype, "size", {
	        get: function () {
	            return this.cache.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    EndpointCache.prototype.put = function (key, value) {
	      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
	        var endpointRecord = this.populateValue(value);
	        this.cache.put(keyString, endpointRecord);
	    };
	    EndpointCache.prototype.get = function (key) {
	      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
	        var now = Date.now();
	        var records = this.cache.get(keyString);
	        if (records) {
	            for (var i = records.length-1; i >= 0; i--) {
	                var record = records[i];
	                if (record.Expire < now) {
	                    records.splice(i, 1);
	                }
	            }
	            if (records.length === 0) {
	                this.cache.remove(keyString);
	                return undefined;
	            }
	        }
	        return records;
	    };
	    EndpointCache.getKeyString = function (key) {
	        var identifiers = [];
	        var identifierNames = Object.keys(key).sort();
	        for (var i = 0; i < identifierNames.length; i++) {
	            var identifierName = identifierNames[i];
	            if (key[identifierName] === undefined)
	                continue;
	            identifiers.push(key[identifierName]);
	        }
	        return identifiers.join(' ');
	    };
	    EndpointCache.prototype.populateValue = function (endpoints) {
	        var now = Date.now();
	        return endpoints.map(function (endpoint) { return ({
	            Address: endpoint.Address || '',
	            Expire: now + (endpoint.CachePeriodInMinutes || 1) * 60 * 1000
	        }); });
	    };
	    EndpointCache.prototype.empty = function () {
	        this.cache.empty();
	    };
	    EndpointCache.prototype.remove = function (key) {
	      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
	        this.cache.remove(keyString);
	    };
	    return EndpointCache;
	}());
	exports.EndpointCache = EndpointCache;
	},{"./utils/LRU":456}],456:[function(require,module,exports){
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var LinkedListNode = /** @class */ (function () {
	    function LinkedListNode(key, value) {
	        this.key = key;
	        this.value = value;
	    }
	    return LinkedListNode;
	}());
	var LRUCache = /** @class */ (function () {
	    function LRUCache(size) {
	        this.nodeMap = {};
	        this.size = 0;
	        if (typeof size !== 'number' || size < 1) {
	            throw new Error('Cache size can only be positive number');
	        }
	        this.sizeLimit = size;
	    }
	    Object.defineProperty(LRUCache.prototype, "length", {
	        get: function () {
	            return this.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    LRUCache.prototype.prependToList = function (node) {
	        if (!this.headerNode) {
	            this.tailNode = node;
	        }
	        else {
	            this.headerNode.prev = node;
	            node.next = this.headerNode;
	        }
	        this.headerNode = node;
	        this.size++;
	    };
	    LRUCache.prototype.removeFromTail = function () {
	        if (!this.tailNode) {
	            return undefined;
	        }
	        var node = this.tailNode;
	        var prevNode = node.prev;
	        if (prevNode) {
	            prevNode.next = undefined;
	        }
	        node.prev = undefined;
	        this.tailNode = prevNode;
	        this.size--;
	        return node;
	    };
	    LRUCache.prototype.detachFromList = function (node) {
	        if (this.headerNode === node) {
	            this.headerNode = node.next;
	        }
	        if (this.tailNode === node) {
	            this.tailNode = node.prev;
	        }
	        if (node.prev) {
	            node.prev.next = node.next;
	        }
	        if (node.next) {
	            node.next.prev = node.prev;
	        }
	        node.next = undefined;
	        node.prev = undefined;
	        this.size--;
	    };
	    LRUCache.prototype.get = function (key) {
	        if (this.nodeMap[key]) {
	            var node = this.nodeMap[key];
	            this.detachFromList(node);
	            this.prependToList(node);
	            return node.value;
	        }
	    };
	    LRUCache.prototype.remove = function (key) {
	        if (this.nodeMap[key]) {
	            var node = this.nodeMap[key];
	            this.detachFromList(node);
	            delete this.nodeMap[key];
	        }
	    };
	    LRUCache.prototype.put = function (key, value) {
	        if (this.nodeMap[key]) {
	            this.remove(key);
	        }
	        else if (this.size === this.sizeLimit) {
	            var tailNode = this.removeFromTail();
	            var key_1 = tailNode.key;
	            delete this.nodeMap[key_1];
	        }
	        var newNode = new LinkedListNode(key, value);
	        this.nodeMap[key] = newNode;
	        this.prependToList(newNode);
	    };
	    LRUCache.prototype.empty = function () {
	        var keys = Object.keys(this.nodeMap);
	        for (var i = 0; i < keys.length; i++) {
	            var key = keys[i];
	            var node = this.nodeMap[key];
	            this.detachFromList(node);
	            delete this.nodeMap[key];
	        }
	    };
	    return LRUCache;
	}());
	exports.LRUCache = LRUCache;
	},{}],457:[function(require,module,exports){
	// AWS SDK for JavaScript v2.1163.0
	// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
	// License at https://sdk.amazonaws.com/js/BUNDLE_LICENSE.txt
	require('./browser_loader');
	
	var AWS = require('./core');
	
	if (typeof window !== 'undefined') window.AWS = AWS;
	if (typeof module !== 'undefined') {
	    /**
	     * @api private
	     */
	    module.exports = AWS;
	}
	if (typeof self !== 'undefined') self.AWS = AWS;
	
	/**
	 * @private
	 * DO NOT REMOVE
	 * browser builder will strip out this line if services are supplied on the command line.
	 */
	require('../clients/browser_default');
	
	},{"../clients/browser_default":245,"./browser_loader":338,"./core":342}]},{},[457]);
	


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ManifestService = function () {
	    /* @ngInject */
	    function ManifestService() {
	        (0, _classCallCheck3.default)(this, ManifestService);
	
	        this.manifest = window.manifest;
	    }
	
	    (0, _createClass3.default)(ManifestService, [{
	        key: "getManifest",
	        value: function getManifest() {
	            return this.manifest;
	        }
	    }, {
	        key: "getValue",
	        value: function getValue(key) {
	            return this.manifest[key];
	        }
	    }, {
	        key: "region",
	        value: function region() {
	            return this.manifest.Region;
	        }
	    }, {
	        key: "userPool",
	        value: function userPool() {
	            return this.manifest.UserPool;
	        }
	    }, {
	        key: "identityPool",
	        value: function identityPool() {
	            return this.manifest.IdentityPool;
	        }
	    }, {
	        key: "authLamda",
	        value: function authLamda() {
	            return this.manifest.AuthLamda;
	        }
	    }, {
	        key: "iotEndpointATS",
	        value: function iotEndpointATS() {
	            return this.manifest.IotEndpointATS;
	        }
	    }]);
	    return ManifestService;
	}();
	
	exports.default = ManifestService;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _leaflet = __webpack_require__(49);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapService = function () {
	    /* @ngInject */
	    function MapService($window, $log, $translate, AuthService) {
	        (0, _classCallCheck3.default)(this, MapService);
	
	        this.$log = $log;
	        this.$translate = $translate;
	        this.leaflet = $window.leaflet;
	        this.AuthService = AuthService;
	        this.showDetailsLink = true;
	
	        this.redIcon = new _leaflet2.default.Icon({
	            iconUrl: 'assets/red-marker.png',
	            iconRetinaUrl: 'assets/red-marker-2x.png',
	            shadowUrl: __webpack_require__(55),
	            iconSize: [25, 41],
	            iconAnchor: [12, 41],
	            popupAnchor: [1, -34],
	            shadowSize: [41, 41]
	        });
	        this.blackIcon = new _leaflet2.default.Icon({
	            iconUrl: 'assets/black-marker.png',
	            iconRetinaUrl: 'assets/black-marker-2x.png',
	            shadowUrl: __webpack_require__(55),
	            iconSize: [25, 41],
	            iconAnchor: [12, 41],
	            popupAnchor: [1, -34],
	            shadowSize: [41, 41]
	        });
	        this.greenIcon = new _leaflet2.default.Icon({
	            iconUrl: 'assets/green-marker.png',
	            iconRetinaUrl: 'assets/green-marker-2x.png',
	            shadowUrl: __webpack_require__(55),
	            iconSize: [25, 41],
	            iconAnchor: [12, 41],
	            popupAnchor: [1, -34],
	            shadowSize: [41, 41]
	        });
	
	        this.map = null;
	        this.featureGroup = null;
	        this.traceLayer = null;
	        this.traceStartMarker = null;
	
	        // Synchronous translation lookups
	        this.door_open = this.$translate.instant('IOF.DOOR_OPEN');
	        this.door_closed = this.$translate.instant('IOF.DOOR_CLOSED');
	        this.power_on = this.$translate.instant('IOF.POWER_ON');
	        this.power_off = this.$translate.instant('IOF.POWER_OFF');
	        this.details = this.$translate.instant('MAP.DETAILS');
	        this.legendNormal = this.$translate.instant('MAP.LEGEND.NORMAL');
	        this.legendAlarm = this.$translate.instant('MAP.LEGEND.ALARM');
	        this.legendFirst = this.$translate.instant('MAP.LEGEND.FIRST');
	
	        if (this.AuthService.isTransportChief()) {
	            this.showDetailsLink = false;
	        }
	    }
	
	    (0, _createClass3.default)(MapService, [{
	        key: 'setupMap',
	        value: function setupMap(mapId) {
	            if (this.map === undefined || this.map === null) {
	                this.map = _leaflet2.default.map(mapId, {
	                    center: [56.30913, 15.46578],
	                    zoom: 10
	                });
	
	                _leaflet2.default.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
	                    attribution: '&copy; <a href="http://openstreetmap.org/copyright">OpenStreetMap</a> contributors'
	                }).addTo(this.map);
	
	                this.featureGroup = new _leaflet2.default.featureGroup();
	                this.traceLayer = new _leaflet2.default.featureGroup();
	                this.traceStartMarker = new _leaflet2.default.featureGroup();
	            }
	        }
	    }, {
	        key: 'setupLegend',
	        value: function setupLegend() {
	            var _this = this;
	
	            var legend = _leaflet2.default.control({ position: 'bottomleft' });
	            legend.onAdd = function () {
	                var div = _leaflet2.default.DomUtil.create('div', 'sb-legend');
	                div.innerHTML += '<div><img src="assets/black-marker.png" /> ' + _this.legendNormal + '</div>';
	                div.innerHTML += '<div><img src="assets/red-marker.png" /> ' + _this.legendAlarm + '</div>';
	                return div;
	            };
	            legend.addTo(this.map);
	        }
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            if (this.map !== undefined && this.map !== null) {
	                this.map.remove();
	                this.map = null;
	            }
	        }
	    }, {
	        key: 'showPopup',
	        value: function showPopup(thingId) {
	            this.featureGroup.eachLayer(function (l) {
	                // eslint-disable-next-line
	                if (l._id === thingId) {
	                    l.openPopup();
	                }
	            });
	        }
	    }, {
	        key: 'showCartsOnMap',
	        value: function showCartsOnMap(carts, mapId) {
	            var _this2 = this;
	
	            var showPopup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	            var showLegend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	            if (this.map === null) {
	                this.setupMap(mapId);
	                if (showLegend) {
	                    this.setupLegend();
	                }
	            }
	
	            this.featureGroup.clearLayers();
	            var markers = [];
	
	            /* eslint-disable */
	            carts.map(function (c) {
	
	                if (!c._source.state) {
	                    return;
	                }
	
	                var latlng = c._source.state.latlng;
	
	                var door = c._source.state.door_open === 1 ? _this2.door_open : _this2.door_closed;
	                var power = c._source.state.mains_powered === 1 ? _this2.power_on : _this2.power_off;
	
	                var customPopup = '<div>\n                    <h4><strong>' + c._source.label + '</strong></h4>\n                    <h5>' + c._source.state.box_temperature + '&#8451;</h5>\n                    <h5>' + door + '</h5>\n                    <h5>' + power + '</h5>';
	                if (_this2.showDetailsLink) {
	                    customPopup = customPopup + ('<a class="btn btn-primary btn-block" href="#!/detail/' + c._id + '" style="text-decoration:none;">' + _this2.details + '</a>\n                <a class="leaflet-popup-close-button sb-close-overide btn btn-default btn-block" href="#close">St\xE4ng</a></div>');
	                } else {
	                    customPopup = customPopup + '<a class="leaflet-popup-close-button sb-close-overide btn btn-default btn-block" href="#close">St\xE4ng</a></div>';
	                }
	
	                var customPopupOptions = {
	                    minWidth: '250',
	                    className: 'customPopupClass'
	                };
	
	                if (latlng) {
	                    var lat = latlng.split(',')[0].trim();
	                    var lng = latlng.split(',')[1].trim();
	
	                    var marker = null;
	                    if (showPopup) {
	                        marker = _leaflet2.default.marker([lat, lng], { icon: c.hasAlarms ? _this2.redIcon : _this2.blackIcon }).bindPopup(customPopup, customPopupOptions).addTo(_this2.map);
	                    } else {
	                        marker = _leaflet2.default.marker([lat, lng], { icon: _this2.blackIcon }).addTo(_this2.map);
	                    }
	                    marker._id = c._id !== undefined ? c._id : '';
	                    markers.push(marker);
	                }
	            }
	            /* eslint-enable */
	            );
	
	            if (markers.length > 0) {
	                this.featureGroup = new _leaflet2.default.featureGroup(markers);
	                this.map.addLayer(this.featureGroup);
	                this.map.fitBounds(this.featureGroup.getBounds().pad(0.05), { maxZoom: 18 });
	            }
	        }
	    }, {
	        key: 'showCartTrace',
	        value: function showCartTrace(data, mapId) {
	            if (this.map === null) {
	                this.setupMap(mapId);
	                this.setupLegend(true);
	            }
	
	            this.traceLayer.clearLayers();
	            this.traceStartMarker.clearLayers();
	
	            /* eslint-disable */
	            var pointList = [];
	            var startMarker = null;
	            var first = true;
	
	            for (var i = 0; i < data.length; i++) {
	
	                if (data[i].latlng && data[i].latlng !== undefined) {
	                    // ensure correct data
	                    if (typeof data[i].latlng === 'string') {
	                        try {
	                            var A1 = parseFloat(data[i].latlng.split(',')[0].trim());
	                            var A2 = parseFloat(data[i].latlng.split(',')[1].trim());
	
	                            var pointA = new _leaflet2.default.LatLng(A1, A2);
	                            pointList.push(pointA);
	
	                            if (first === true) {
	                                startMarker = new _leaflet2.default.marker(pointA, { icon: this.greenIcon }).addTo(this.map);
	                                first = false;
	                            }
	                        } catch (error) {
	                            console.log(error);
	                        }
	                    }
	                }
	            }
	            /* eslint-enable */
	
	            if (startMarker !== null) {
	                // // this.map.addLayer(startMarker);
	                this.traceStartMarker = new _leaflet2.default.featureGroup(startMarker);
	                this.map.addLayer(this.traceStartMarker);
	            }
	
	            if (pointList.length > 0) {
	                var polyLine = new _leaflet2.default.Polyline(pointList, {
	                    color: 'black',
	                    weight: 7,
	                    opacity: 0.5,
	                    smoothFactor: 1
	                });
	
	                this.map.addLayer(polyLine);
	                this.map.fitBounds(polyLine.getBounds().pad(0.02), { maxZoom: 18 });
	            }
	        }
	    }, {
	        key: 'clearMap',
	        value: function clearMap() {
	            /* eslint-disable */
	            if (this.map) {
	                for (var i in this.map._layers) {
	                    if (this.map._layers[i]._path != undefined) {
	                        try {
	                            this.map.removeLayer(this.map._layers[i]);
	                        } catch (e) {
	                            console.log("problem with " + e + this.map._layers[i]);
	                        }
	                    }
	                }
	            }
	
	            /* eslint-enable */
	        }
	    }]);
	    return MapService;
	}();
	
	exports.default = MapService;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/* @preserve
	 * Leaflet 1.8.0, a JS library for interactive maps. https://leafletjs.com
	 * (c) 2010-2022 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	 */
	!function(t,i){ true?i(exports):"function"==typeof define&&define.amd?define(["exports"],i):i((t="undefined"!=typeof globalThis?globalThis:t||self).leaflet={})}(this,function(t){"use strict";function l(t){for(var i,e,n=1,o=arguments.length;n<o;n++)for(i in e=arguments[n])t[i]=e[i];return t}var R=Object.create||function(t){return N.prototype=t,new N};function N(){}function a(t,i){var e=Array.prototype.slice;if(t.bind)return t.bind.apply(t,e.call(arguments,1));var n=e.call(arguments,2);return function(){return t.apply(i,n.length?n.concat(e.call(arguments)):arguments)}}var D=0;function h(t){return"_leaflet_id"in t||(t._leaflet_id=++D),t._leaflet_id}function j(t,i,e){var n,o,s=function(){n=!1,o&&(r.apply(e,o),o=!1)},r=function(){n?o=arguments:(t.apply(e,arguments),setTimeout(s,i),n=!0)};return r}function H(t,i,e){var n=i[1],i=i[0],o=n-i;return t===n&&e?t:((t-i)%o+o)%o+i}function u(){return!1}function e(t,i){if(!1===i)return t;i=Math.pow(10,void 0===i?6:i);return Math.round(t*i)/i}function W(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}function F(t){return W(t).split(/\s+/)}function c(t,i){for(var e in Object.prototype.hasOwnProperty.call(t,"options")||(t.options=t.options?R(t.options):{}),i)t.options[e]=i[e];return t.options}function U(t,i,e){var n,o=[];for(n in t)o.push(encodeURIComponent(e?n.toUpperCase():n)+"="+encodeURIComponent(t[n]));return(i&&-1!==i.indexOf("?")?"&":"?")+o.join("&")}var V=/\{ *([\w_ -]+) *\}/g;function q(t,e){return t.replace(V,function(t,i){i=e[i];if(void 0===i)throw new Error("No value provided for variable "+t);return i="function"==typeof i?i(e):i})}var d=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)};function G(t,i){for(var e=0;e<t.length;e++)if(t[e]===i)return e;return-1}var K="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";function Y(t){return window["webkit"+t]||window["moz"+t]||window["ms"+t]}var X=0;function J(t){var i=+new Date,e=Math.max(0,16-(i-X));return X=i+e,window.setTimeout(t,e)}var $=window.requestAnimationFrame||Y("RequestAnimationFrame")||J,Q=window.cancelAnimationFrame||Y("CancelAnimationFrame")||Y("CancelRequestAnimationFrame")||function(t){window.clearTimeout(t)};function x(t,i,e){if(!e||$!==J)return $.call(window,a(t,i));t.call(i)}function r(t){t&&Q.call(window,t)}var tt={__proto__:null,extend:l,create:R,bind:a,get lastId(){return D},stamp:h,throttle:j,wrapNum:H,falseFn:u,formatNum:e,trim:W,splitWords:F,setOptions:c,getParamString:U,template:q,isArray:d,indexOf:G,emptyImageUrl:K,requestFn:$,cancelFn:Q,requestAnimFrame:x,cancelAnimFrame:r};function it(){}it.extend=function(t){function i(){c(this),this.initialize&&this.initialize.apply(this,arguments),this.callInitHooks()}var e,n=i.__super__=this.prototype,o=R(n);for(e in(o.constructor=i).prototype=o,this)Object.prototype.hasOwnProperty.call(this,e)&&"prototype"!==e&&"__super__"!==e&&(i[e]=this[e]);if(t.statics&&l(i,t.statics),t.includes){var s=t.includes;if("undefined"!=typeof L&&L&&L.Mixin){s=d(s)?s:[s];for(var r=0;r<s.length;r++)s[r]===L.Mixin.Events&&console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.",(new Error).stack)}l.apply(null,[o].concat(t.includes))}return l(o,t),delete o.statics,delete o.includes,o.options&&(o.options=n.options?R(n.options):{},l(o.options,t.options)),o._initHooks=[],o.callInitHooks=function(){if(!this._initHooksCalled){n.callInitHooks&&n.callInitHooks.call(this),this._initHooksCalled=!0;for(var t=0,i=o._initHooks.length;t<i;t++)o._initHooks[t].call(this)}},i},it.include=function(t){var i=this.prototype.options;return l(this.prototype,t),t.options&&(this.prototype.options=i,this.mergeOptions(t.options)),this},it.mergeOptions=function(t){return l(this.prototype.options,t),this},it.addInitHook=function(t){var i=Array.prototype.slice.call(arguments,1),e="function"==typeof t?t:function(){this[t].apply(this,i)};return this.prototype._initHooks=this.prototype._initHooks||[],this.prototype._initHooks.push(e),this};var i={on:function(t,i,e){if("object"==typeof t)for(var n in t)this._on(n,t[n],i);else for(var o=0,s=(t=F(t)).length;o<s;o++)this._on(t[o],i,e);return this},off:function(t,i,e){if(arguments.length)if("object"==typeof t)for(var n in t)this._off(n,t[n],i);else{t=F(t);for(var o=1===arguments.length,s=0,r=t.length;s<r;s++)o?this._off(t[s]):this._off(t[s],i,e)}else delete this._events;return this},_on:function(t,i,e){if("function"!=typeof i)console.warn("wrong listener type: "+typeof i);else{this._events=this._events||{};for(var n=this._events[t],t=(n||(this._events[t]=n=[]),{fn:i,ctx:e=e===this?void 0:e}),o=n,s=0,r=o.length;s<r;s++)if(o[s].fn===i&&o[s].ctx===e)return;o.push(t)}},_off:function(t,i,e){var n,o,s;if(this._events&&(n=this._events[t]))if(1===arguments.length){if(this._firingCount)for(o=0,s=n.length;o<s;o++)n[o].fn=u;delete this._events[t]}else if(e===this&&(e=void 0),"function"!=typeof i)console.warn("wrong listener type: "+typeof i);else{for(o=0,s=n.length;o<s;o++){var r=n[o];if(r.ctx===e&&r.fn===i)return this._firingCount&&(r.fn=u,this._events[t]=n=n.slice()),void n.splice(o,1)}console.warn("listener not found")}},fire:function(t,i,e){if(!this.listens(t,e))return this;var n=l({},i,{type:t,target:this,sourceTarget:i&&i.sourceTarget||this});if(this._events){var o=this._events[t];if(o){this._firingCount=this._firingCount+1||1;for(var s=0,r=o.length;s<r;s++){var a=o[s];a.fn.call(a.ctx||this,n)}this._firingCount--}}return e&&this._propagateEvent(n),this},listens:function(t,i){"string"!=typeof t&&console.warn('"string" type argument expected');var e=this._events&&this._events[t];if(e&&e.length)return!0;if(i)for(var n in this._eventParents)if(this._eventParents[n].listens(t,i))return!0;return!1},once:function(t,i,e){if("object"==typeof t){for(var n in t)this.once(n,t[n],i);return this}var o=a(function(){this.off(t,i,e).off(t,o,e)},this);return this.on(t,i,e).on(t,o,e)},addEventParent:function(t){return this._eventParents=this._eventParents||{},this._eventParents[h(t)]=t,this},removeEventParent:function(t){return this._eventParents&&delete this._eventParents[h(t)],this},_propagateEvent:function(t){for(var i in this._eventParents)this._eventParents[i].fire(t.type,l({layer:t.target,propagatedFrom:t.target},t),!0)}},et=(i.addEventListener=i.on,i.removeEventListener=i.clearAllEventListeners=i.off,i.addOneTimeEventListener=i.once,i.fireEvent=i.fire,i.hasEventListeners=i.listens,it.extend(i));function p(t,i,e){this.x=e?Math.round(t):t,this.y=e?Math.round(i):i}var nt=Math.trunc||function(t){return 0<t?Math.floor(t):Math.ceil(t)};function _(t,i,e){return t instanceof p?t:d(t)?new p(t[0],t[1]):null==t?t:"object"==typeof t&&"x"in t&&"y"in t?new p(t.x,t.y):new p(t,i,e)}function m(t,i){if(t)for(var e=i?[t,i]:t,n=0,o=e.length;n<o;n++)this.extend(e[n])}function f(t,i){return!t||t instanceof m?t:new m(t,i)}function s(t,i){if(t)for(var e=i?[t,i]:t,n=0,o=e.length;n<o;n++)this.extend(e[n])}function g(t,i){return t instanceof s?t:new s(t,i)}function v(t,i,e){if(isNaN(t)||isNaN(i))throw new Error("Invalid LatLng object: ("+t+", "+i+")");this.lat=+t,this.lng=+i,void 0!==e&&(this.alt=+e)}function w(t,i,e){return t instanceof v?t:d(t)&&"object"!=typeof t[0]?3===t.length?new v(t[0],t[1],t[2]):2===t.length?new v(t[0],t[1]):null:null==t?t:"object"==typeof t&&"lat"in t?new v(t.lat,"lng"in t?t.lng:t.lon,t.alt):void 0===i?null:new v(t,i,e)}p.prototype={clone:function(){return new p(this.x,this.y)},add:function(t){return this.clone()._add(_(t))},_add:function(t){return this.x+=t.x,this.y+=t.y,this},subtract:function(t){return this.clone()._subtract(_(t))},_subtract:function(t){return this.x-=t.x,this.y-=t.y,this},divideBy:function(t){return this.clone()._divideBy(t)},_divideBy:function(t){return this.x/=t,this.y/=t,this},multiplyBy:function(t){return this.clone()._multiplyBy(t)},_multiplyBy:function(t){return this.x*=t,this.y*=t,this},scaleBy:function(t){return new p(this.x*t.x,this.y*t.y)},unscaleBy:function(t){return new p(this.x/t.x,this.y/t.y)},round:function(){return this.clone()._round()},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this},floor:function(){return this.clone()._floor()},_floor:function(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this},ceil:function(){return this.clone()._ceil()},_ceil:function(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this},trunc:function(){return this.clone()._trunc()},_trunc:function(){return this.x=nt(this.x),this.y=nt(this.y),this},distanceTo:function(t){var i=(t=_(t)).x-this.x,t=t.y-this.y;return Math.sqrt(i*i+t*t)},equals:function(t){return(t=_(t)).x===this.x&&t.y===this.y},contains:function(t){return t=_(t),Math.abs(t.x)<=Math.abs(this.x)&&Math.abs(t.y)<=Math.abs(this.y)},toString:function(){return"Point("+e(this.x)+", "+e(this.y)+")"}},m.prototype={extend:function(t){return t=_(t),this.min||this.max?(this.min.x=Math.min(t.x,this.min.x),this.max.x=Math.max(t.x,this.max.x),this.min.y=Math.min(t.y,this.min.y),this.max.y=Math.max(t.y,this.max.y)):(this.min=t.clone(),this.max=t.clone()),this},getCenter:function(t){return new p((this.min.x+this.max.x)/2,(this.min.y+this.max.y)/2,t)},getBottomLeft:function(){return new p(this.min.x,this.max.y)},getTopRight:function(){return new p(this.max.x,this.min.y)},getTopLeft:function(){return this.min},getBottomRight:function(){return this.max},getSize:function(){return this.max.subtract(this.min)},contains:function(t){var i,e;return(t=("number"==typeof t[0]||t instanceof p?_:f)(t))instanceof m?(i=t.min,e=t.max):i=e=t,i.x>=this.min.x&&e.x<=this.max.x&&i.y>=this.min.y&&e.y<=this.max.y},intersects:function(t){t=f(t);var i=this.min,e=this.max,n=t.min,t=t.max,o=t.x>=i.x&&n.x<=e.x,t=t.y>=i.y&&n.y<=e.y;return o&&t},overlaps:function(t){t=f(t);var i=this.min,e=this.max,n=t.min,t=t.max,o=t.x>i.x&&n.x<e.x,t=t.y>i.y&&n.y<e.y;return o&&t},isValid:function(){return!(!this.min||!this.max)}},s.prototype={extend:function(t){var i,e,n=this._southWest,o=this._northEast;if(t instanceof v)e=i=t;else{if(!(t instanceof s))return t?this.extend(w(t)||g(t)):this;if(i=t._southWest,e=t._northEast,!i||!e)return this}return n||o?(n.lat=Math.min(i.lat,n.lat),n.lng=Math.min(i.lng,n.lng),o.lat=Math.max(e.lat,o.lat),o.lng=Math.max(e.lng,o.lng)):(this._southWest=new v(i.lat,i.lng),this._northEast=new v(e.lat,e.lng)),this},pad:function(t){var i=this._southWest,e=this._northEast,n=Math.abs(i.lat-e.lat)*t,t=Math.abs(i.lng-e.lng)*t;return new s(new v(i.lat-n,i.lng-t),new v(e.lat+n,e.lng+t))},getCenter:function(){return new v((this._southWest.lat+this._northEast.lat)/2,(this._southWest.lng+this._northEast.lng)/2)},getSouthWest:function(){return this._southWest},getNorthEast:function(){return this._northEast},getNorthWest:function(){return new v(this.getNorth(),this.getWest())},getSouthEast:function(){return new v(this.getSouth(),this.getEast())},getWest:function(){return this._southWest.lng},getSouth:function(){return this._southWest.lat},getEast:function(){return this._northEast.lng},getNorth:function(){return this._northEast.lat},contains:function(t){t=("number"==typeof t[0]||t instanceof v||"lat"in t?w:g)(t);var i,e,n=this._southWest,o=this._northEast;return t instanceof s?(i=t.getSouthWest(),e=t.getNorthEast()):i=e=t,i.lat>=n.lat&&e.lat<=o.lat&&i.lng>=n.lng&&e.lng<=o.lng},intersects:function(t){t=g(t);var i=this._southWest,e=this._northEast,n=t.getSouthWest(),t=t.getNorthEast(),o=t.lat>=i.lat&&n.lat<=e.lat,t=t.lng>=i.lng&&n.lng<=e.lng;return o&&t},overlaps:function(t){t=g(t);var i=this._southWest,e=this._northEast,n=t.getSouthWest(),t=t.getNorthEast(),o=t.lat>i.lat&&n.lat<e.lat,t=t.lng>i.lng&&n.lng<e.lng;return o&&t},toBBoxString:function(){return[this.getWest(),this.getSouth(),this.getEast(),this.getNorth()].join(",")},equals:function(t,i){return!!t&&(t=g(t),this._southWest.equals(t.getSouthWest(),i)&&this._northEast.equals(t.getNorthEast(),i))},isValid:function(){return!(!this._southWest||!this._northEast)}};var ot={latLngToPoint:function(t,i){t=this.projection.project(t),i=this.scale(i);return this.transformation._transform(t,i)},pointToLatLng:function(t,i){i=this.scale(i),t=this.transformation.untransform(t,i);return this.projection.unproject(t)},project:function(t){return this.projection.project(t)},unproject:function(t){return this.projection.unproject(t)},scale:function(t){return 256*Math.pow(2,t)},zoom:function(t){return Math.log(t/256)/Math.LN2},getProjectedBounds:function(t){if(this.infinite)return null;var i=this.projection.bounds,t=this.scale(t);return new m(this.transformation.transform(i.min,t),this.transformation.transform(i.max,t))},infinite:!(v.prototype={equals:function(t,i){return!!t&&(t=w(t),Math.max(Math.abs(this.lat-t.lat),Math.abs(this.lng-t.lng))<=(void 0===i?1e-9:i))},toString:function(t){return"LatLng("+e(this.lat,t)+", "+e(this.lng,t)+")"},distanceTo:function(t){return st.distance(this,w(t))},wrap:function(){return st.wrapLatLng(this)},toBounds:function(t){var t=180*t/40075017,i=t/Math.cos(Math.PI/180*this.lat);return g([this.lat-t,this.lng-i],[this.lat+t,this.lng+i])},clone:function(){return new v(this.lat,this.lng,this.alt)}}),wrapLatLng:function(t){var i=this.wrapLng?H(t.lng,this.wrapLng,!0):t.lng;return new v(this.wrapLat?H(t.lat,this.wrapLat,!0):t.lat,i,t.alt)},wrapLatLngBounds:function(t){var i=t.getCenter(),e=this.wrapLatLng(i),n=i.lat-e.lat,i=i.lng-e.lng;if(0==n&&0==i)return t;e=t.getSouthWest(),t=t.getNorthEast();return new s(new v(e.lat-n,e.lng-i),new v(t.lat-n,t.lng-i))}},st=l({},ot,{wrapLng:[-180,180],R:6371e3,distance:function(t,i){var e=Math.PI/180,n=t.lat*e,o=i.lat*e,s=Math.sin((i.lat-t.lat)*e/2),i=Math.sin((i.lng-t.lng)*e/2),t=s*s+Math.cos(n)*Math.cos(o)*i*i,e=2*Math.atan2(Math.sqrt(t),Math.sqrt(1-t));return this.R*e}}),rt=6378137,rt={R:rt,MAX_LATITUDE:85.0511287798,project:function(t){var i=Math.PI/180,e=this.MAX_LATITUDE,e=Math.max(Math.min(e,t.lat),-e),e=Math.sin(e*i);return new p(this.R*t.lng*i,this.R*Math.log((1+e)/(1-e))/2)},unproject:function(t){var i=180/Math.PI;return new v((2*Math.atan(Math.exp(t.y/this.R))-Math.PI/2)*i,t.x*i/this.R)},bounds:new m([-(rt=rt*Math.PI),-rt],[rt,rt])};function at(t,i,e,n){if(d(t))return this._a=t[0],this._b=t[1],this._c=t[2],void(this._d=t[3]);this._a=t,this._b=i,this._c=e,this._d=n}function ht(t,i,e,n){return new at(t,i,e,n)}at.prototype={transform:function(t,i){return this._transform(t.clone(),i)},_transform:function(t,i){return t.x=(i=i||1)*(this._a*t.x+this._b),t.y=i*(this._c*t.y+this._d),t},untransform:function(t,i){return new p((t.x/(i=i||1)-this._b)/this._a,(t.y/i-this._d)/this._c)}};var lt=l({},st,{code:"EPSG:3857",projection:rt,transformation:ht(lt=.5/(Math.PI*rt.R),.5,-lt,.5)}),ut=l({},lt,{code:"EPSG:900913"});function ct(t){return document.createElementNS("http://www.w3.org/2000/svg",t)}function dt(t,i){for(var e,n,o,s,r="",a=0,h=t.length;a<h;a++){for(e=0,n=(o=t[a]).length;e<n;e++)r+=(e?"L":"M")+(s=o[e]).x+" "+s.y;r+=i?P.svg?"z":"x":""}return r||"M0 0"}var _t=document.documentElement.style,pt="ActiveXObject"in window,mt=pt&&!document.addEventListener,n="msLaunchUri"in navigator&&!("documentMode"in document),ft=y("webkit"),gt=y("android"),vt=y("android 2")||y("android 3"),yt=parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1],10),yt=gt&&y("Google")&&yt<537&&!("AudioNode"in window),xt=!!window.opera,wt=!n&&y("chrome"),Pt=y("gecko")&&!ft&&!xt&&!pt,bt=!wt&&y("safari"),Lt=y("phantom"),o="OTransition"in _t,Tt=0===navigator.platform.indexOf("Win"),zt=pt&&"transition"in _t,Mt="WebKitCSSMatrix"in window&&"m11"in new window.WebKitCSSMatrix&&!vt,_t="MozPerspective"in _t,Ct=!window.L_DISABLE_3D&&(zt||Mt||_t)&&!o&&!Lt,Zt="undefined"!=typeof orientation||y("mobile"),St=Zt&&ft,kt=Zt&&Mt,Et=!window.PointerEvent&&window.MSPointerEvent,Bt=!(!window.PointerEvent&&!Et),At="ontouchstart"in window||!!window.TouchEvent,It=!window.L_NO_TOUCH&&(At||Bt),Ot=Zt&&xt,Rt=Zt&&Pt,Nt=1<(window.devicePixelRatio||window.screen.deviceXDPI/window.screen.logicalXDPI),Dt=function(){var t=!1;try{var i=Object.defineProperty({},"passive",{get:function(){t=!0}});window.addEventListener("testPassiveEventSupport",u,i),window.removeEventListener("testPassiveEventSupport",u,i)}catch(t){}return t}(),jt=!!document.createElement("canvas").getContext,Ht=!(!document.createElementNS||!ct("svg").createSVGRect),Wt=!!Ht&&((Wt=document.createElement("div")).innerHTML="<svg/>","http://www.w3.org/2000/svg"===(Wt.firstChild&&Wt.firstChild.namespaceURI));function y(t){return 0<=navigator.userAgent.toLowerCase().indexOf(t)}var P={ie:pt,ielt9:mt,edge:n,webkit:ft,android:gt,android23:vt,androidStock:yt,opera:xt,chrome:wt,gecko:Pt,safari:bt,phantom:Lt,opera12:o,win:Tt,ie3d:zt,webkit3d:Mt,gecko3d:_t,any3d:Ct,mobile:Zt,mobileWebkit:St,mobileWebkit3d:kt,msPointer:Et,pointer:Bt,touch:It,touchNative:At,mobileOpera:Ot,mobileGecko:Rt,retina:Nt,passiveEvents:Dt,canvas:jt,svg:Ht,vml:!Ht&&function(){try{var t=document.createElement("div"),i=(t.innerHTML='<v:shape adj="1"/>',t.firstChild);return i.style.behavior="url(#default#VML)",i&&"object"==typeof i.adj}catch(t){return!1}}(),inlineSvg:Wt},Ft=P.msPointer?"MSPointerDown":"pointerdown",Ut=P.msPointer?"MSPointerMove":"pointermove",Vt=P.msPointer?"MSPointerUp":"pointerup",qt=P.msPointer?"MSPointerCancel":"pointercancel",Gt={touchstart:Ft,touchmove:Ut,touchend:Vt,touchcancel:qt},Kt={touchstart:function(t,i){i.MSPOINTER_TYPE_TOUCH&&i.pointerType===i.MSPOINTER_TYPE_TOUCH&&B(i);ii(t,i)},touchmove:ii,touchend:ii,touchcancel:ii},Yt={},Xt=!1;function Jt(t,i,e){return"touchstart"!==i||Xt||(document.addEventListener(Ft,$t,!0),document.addEventListener(Ut,Qt,!0),document.addEventListener(Vt,ti,!0),document.addEventListener(qt,ti,!0),Xt=!0),Kt[i]?(e=Kt[i].bind(this,e),t.addEventListener(Gt[i],e,!1),e):(console.warn("wrong event specified:",i),L.Util.falseFn)}function $t(t){Yt[t.pointerId]=t}function Qt(t){Yt[t.pointerId]&&(Yt[t.pointerId]=t)}function ti(t){delete Yt[t.pointerId]}function ii(t,i){if(i.pointerType!==(i.MSPOINTER_TYPE_MOUSE||"mouse")){for(var e in i.touches=[],Yt)i.touches.push(Yt[e]);i.changedTouches=[i],t(i)}}var ei=200;function ni(t,e){t.addEventListener("dblclick",e);var n,o=0;function i(t){var i;1!==t.detail?n=t.detail:"mouse"===t.pointerType||t.sourceCapabilities&&!t.sourceCapabilities.firesTouchEvents||((i=Date.now())-o<=ei?2===++n&&e(function(t){var i,e,n={};for(e in t)i=t[e],n[e]=i&&i.bind?i.bind(t):i;return(t=n).type="dblclick",n.detail=2,n.isTrusted=!1,n._simulated=!0,n}(t)):n=1,o=i)}return t.addEventListener("click",i),{dblclick:e,simDblclick:i}}var oi,si,ri,ai,hi,li,ui=wi(["transform","webkitTransform","OTransform","MozTransform","msTransform"]),ci=wi(["webkitTransition","transition","OTransition","MozTransition","msTransition"]),di="webkitTransition"===ci||"OTransition"===ci?ci+"End":"transitionend";function _i(t){return"string"==typeof t?document.getElementById(t):t}function pi(t,i){var e=t.style[i]||t.currentStyle&&t.currentStyle[i];return"auto"===(e=e&&"auto"!==e||!document.defaultView?e:(t=document.defaultView.getComputedStyle(t,null))?t[i]:null)?null:e}function b(t,i,e){t=document.createElement(t);return t.className=i||"",e&&e.appendChild(t),t}function T(t){var i=t.parentNode;i&&i.removeChild(t)}function mi(t){for(;t.firstChild;)t.removeChild(t.firstChild)}function fi(t){var i=t.parentNode;i&&i.lastChild!==t&&i.appendChild(t)}function gi(t){var i=t.parentNode;i&&i.firstChild!==t&&i.insertBefore(t,i.firstChild)}function vi(t,i){if(void 0!==t.classList)return t.classList.contains(i);t=xi(t);return 0<t.length&&new RegExp("(^|\\s)"+i+"(\\s|$)").test(t)}function z(t,i){var e;if(void 0!==t.classList)for(var n=F(i),o=0,s=n.length;o<s;o++)t.classList.add(n[o]);else vi(t,i)||yi(t,((e=xi(t))?e+" ":"")+i)}function M(t,i){void 0!==t.classList?t.classList.remove(i):yi(t,W((" "+xi(t)+" ").replace(" "+i+" "," ")))}function yi(t,i){void 0===t.className.baseVal?t.className=i:t.className.baseVal=i}function xi(t){return void 0===(t=t.correspondingElement?t.correspondingElement:t).className.baseVal?t.className:t.className.baseVal}function C(t,i){if("opacity"in t.style)t.style.opacity=i;else if("filter"in t.style){var e=!1,n="DXImageTransform.Microsoft.Alpha";try{e=t.filters.item(n)}catch(t){if(1===i)return}i=Math.round(100*i),e?(e.Enabled=100!==i,e.Opacity=i):t.style.filter+=" progid:"+n+"(opacity="+i+")"}}function wi(t){for(var i=document.documentElement.style,e=0;e<t.length;e++)if(t[e]in i)return t[e];return!1}function Pi(t,i,e){i=i||new p(0,0);t.style[ui]=(P.ie3d?"translate("+i.x+"px,"+i.y+"px)":"translate3d("+i.x+"px,"+i.y+"px,0)")+(e?" scale("+e+")":"")}function Z(t,i){t._leaflet_pos=i,P.any3d?Pi(t,i):(t.style.left=i.x+"px",t.style.top=i.y+"px")}function bi(t){return t._leaflet_pos||new p(0,0)}function Li(){S(window,"dragstart",B)}function Ti(){E(window,"dragstart",B)}function zi(t){for(;-1===t.tabIndex;)t=t.parentNode;t.style&&(Mi(),li=(hi=t).style.outline,t.style.outline="none",S(window,"keydown",Mi))}function Mi(){hi&&(hi.style.outline=li,li=hi=void 0,E(window,"keydown",Mi))}function Ci(t){for(;!((t=t.parentNode).offsetWidth&&t.offsetHeight||t===document.body););return t}function Zi(t){var i=t.getBoundingClientRect();return{x:i.width/t.offsetWidth||1,y:i.height/t.offsetHeight||1,boundingClientRect:i}}ai="onselectstart"in document?(ri=function(){S(window,"selectstart",B)},function(){E(window,"selectstart",B)}):(si=wi(["userSelect","WebkitUserSelect","OUserSelect","MozUserSelect","msUserSelect"]),ri=function(){var t;si&&(t=document.documentElement.style,oi=t[si],t[si]="none")},function(){si&&(document.documentElement.style[si]=oi,oi=void 0)});pt={__proto__:null,TRANSFORM:ui,TRANSITION:ci,TRANSITION_END:di,get:_i,getStyle:pi,create:b,remove:T,empty:mi,toFront:fi,toBack:gi,hasClass:vi,addClass:z,removeClass:M,setClass:yi,getClass:xi,setOpacity:C,testProp:wi,setTransform:Pi,setPosition:Z,getPosition:bi,get disableTextSelection(){return ri},get enableTextSelection(){return ai},disableImageDrag:Li,enableImageDrag:Ti,preventOutline:zi,restoreOutline:Mi,getSizedParentNode:Ci,getScale:Zi};function S(t,i,e,n){if(i&&"object"==typeof i)for(var o in i)Ei(t,o,i[o],e);else for(var s=0,r=(i=F(i)).length;s<r;s++)Ei(t,i[s],e,n);return this}var k="_leaflet_events";function E(t,i,e,n){if(1===arguments.length)Si(t),delete t[k];else if(i&&"object"==typeof i)for(var o in i)Bi(t,o,i[o],e);else if(i=F(i),2===arguments.length)Si(t,function(t){return-1!==G(i,t)});else for(var s=0,r=i.length;s<r;s++)Bi(t,i[s],e,n);return this}function Si(t,i){for(var e in t[k]){var n=e.split(/\d/)[0];i&&!i(n)||Bi(t,n,null,null,e)}}var ki={mouseenter:"mouseover",mouseleave:"mouseout",wheel:!("onwheel"in window)&&"mousewheel"};function Ei(i,t,e,n){var o,s,r=t+h(e)+(n?"_"+h(n):"");i[k]&&i[k][r]||(s=o=function(t){return e.call(n||i,t||window.event)},!P.touchNative&&P.pointer&&0===t.indexOf("touch")?o=Jt(i,t,o):P.touch&&"dblclick"===t?o=ni(i,o):"addEventListener"in i?"touchstart"===t||"touchmove"===t||"wheel"===t||"mousewheel"===t?i.addEventListener(ki[t]||t,o,!!P.passiveEvents&&{passive:!1}):"mouseenter"===t||"mouseleave"===t?i.addEventListener(ki[t],o=function(t){t=t||window.event,Hi(i,t)&&s(t)},!1):i.addEventListener(t,s,!1):i.attachEvent("on"+t,o),i[k]=i[k]||{},i[k][r]=o)}function Bi(t,i,e,n,o){o=o||i+h(e)+(n?"_"+h(n):"");var s,r,e=t[k]&&t[k][o];e&&(!P.touchNative&&P.pointer&&0===i.indexOf("touch")?(n=t,r=e,Gt[s=i]?n.removeEventListener(Gt[s],r,!1):console.warn("wrong event specified:",s)):P.touch&&"dblclick"===i?(n=e,(r=t).removeEventListener("dblclick",n.dblclick),r.removeEventListener("click",n.simDblclick)):"removeEventListener"in t?t.removeEventListener(ki[i]||i,e,!1):t.detachEvent("on"+i,e),t[k][o]=null)}function Ai(t){return t.stopPropagation?t.stopPropagation():t.originalEvent?t.originalEvent._stopped=!0:t.cancelBubble=!0,this}function Ii(t){return Ei(t,"wheel",Ai),this}function Oi(t){return S(t,"mousedown touchstart dblclick contextmenu",Ai),t._leaflet_disable_click=!0,this}function B(t){return t.preventDefault?t.preventDefault():t.returnValue=!1,this}function Ri(t){return B(t),Ai(t),this}function Ni(t,i){if(!i)return new p(t.clientX,t.clientY);var e=Zi(i),n=e.boundingClientRect;return new p((t.clientX-n.left)/e.x-i.clientLeft,(t.clientY-n.top)/e.y-i.clientTop)}var Di=P.win&&P.chrome?2*window.devicePixelRatio:P.gecko?window.devicePixelRatio:1;function ji(t){return P.edge?t.wheelDeltaY/2:t.deltaY&&0===t.deltaMode?-t.deltaY/Di:t.deltaY&&1===t.deltaMode?20*-t.deltaY:t.deltaY&&2===t.deltaMode?60*-t.deltaY:t.deltaX||t.deltaZ?0:t.wheelDelta?(t.wheelDeltaY||t.wheelDelta)/2:t.detail&&Math.abs(t.detail)<32765?20*-t.detail:t.detail?t.detail/-32765*60:0}function Hi(t,i){var e=i.relatedTarget;if(!e)return!0;try{for(;e&&e!==t;)e=e.parentNode}catch(t){return!1}return e!==t}var mt={__proto__:null,on:S,off:E,stopPropagation:Ai,disableScrollPropagation:Ii,disableClickPropagation:Oi,preventDefault:B,stop:Ri,getMousePosition:Ni,getWheelDelta:ji,isExternalTarget:Hi,addListener:S,removeListener:E},Wi=et.extend({run:function(t,i,e,n){this.stop(),this._el=t,this._inProgress=!0,this._duration=e||.25,this._easeOutPower=1/Math.max(n||.5,.2),this._startPos=bi(t),this._offset=i.subtract(this._startPos),this._startTime=+new Date,this.fire("start"),this._animate()},stop:function(){this._inProgress&&(this._step(!0),this._complete())},_animate:function(){this._animId=x(this._animate,this),this._step()},_step:function(t){var i=+new Date-this._startTime,e=1e3*this._duration;i<e?this._runFrame(this._easeOut(i/e),t):(this._runFrame(1),this._complete())},_runFrame:function(t,i){t=this._startPos.add(this._offset.multiplyBy(t));i&&t._round(),Z(this._el,t),this.fire("step")},_complete:function(){r(this._animId),this._inProgress=!1,this.fire("end")},_easeOut:function(t){return 1-Math.pow(1-t,this._easeOutPower)}}),A=et.extend({options:{crs:lt,center:void 0,zoom:void 0,minZoom:void 0,maxZoom:void 0,layers:[],maxBounds:void 0,renderer:void 0,zoomAnimation:!0,zoomAnimationThreshold:4,fadeAnimation:!0,markerZoomAnimation:!0,transform3DLimit:8388608,zoomSnap:1,zoomDelta:1,trackResize:!0},initialize:function(t,i){i=c(this,i),this._handlers=[],this._layers={},this._zoomBoundLayers={},this._sizeChanged=!0,this._initContainer(t),this._initLayout(),this._onResize=a(this._onResize,this),this._initEvents(),i.maxBounds&&this.setMaxBounds(i.maxBounds),void 0!==i.zoom&&(this._zoom=this._limitZoom(i.zoom)),i.center&&void 0!==i.zoom&&this.setView(w(i.center),i.zoom,{reset:!0}),this.callInitHooks(),this._zoomAnimated=ci&&P.any3d&&!P.mobileOpera&&this.options.zoomAnimation,this._zoomAnimated&&(this._createAnimProxy(),S(this._proxy,di,this._catchTransitionEnd,this)),this._addLayers(this.options.layers)},setView:function(t,i,e){if((i=void 0===i?this._zoom:this._limitZoom(i),t=this._limitCenter(w(t),i,this.options.maxBounds),e=e||{},this._stop(),this._loaded&&!e.reset&&!0!==e)&&(void 0!==e.animate&&(e.zoom=l({animate:e.animate},e.zoom),e.pan=l({animate:e.animate,duration:e.duration},e.pan)),this._zoom!==i?this._tryAnimatedZoom&&this._tryAnimatedZoom(t,i,e.zoom):this._tryAnimatedPan(t,e.pan)))return clearTimeout(this._sizeTimer),this;return this._resetView(t,i),this},setZoom:function(t,i){return this._loaded?this.setView(this.getCenter(),t,{zoom:i}):(this._zoom=t,this)},zoomIn:function(t,i){return t=t||(P.any3d?this.options.zoomDelta:1),this.setZoom(this._zoom+t,i)},zoomOut:function(t,i){return t=t||(P.any3d?this.options.zoomDelta:1),this.setZoom(this._zoom-t,i)},setZoomAround:function(t,i,e){var n=this.getZoomScale(i),o=this.getSize().divideBy(2),t=(t instanceof p?t:this.latLngToContainerPoint(t)).subtract(o).multiplyBy(1-1/n),n=this.containerPointToLatLng(o.add(t));return this.setView(n,i,{zoom:e})},_getBoundsCenterZoom:function(t,i){i=i||{},t=t.getBounds?t.getBounds():g(t);var e=_(i.paddingTopLeft||i.padding||[0,0]),n=_(i.paddingBottomRight||i.padding||[0,0]),o=this.getBoundsZoom(t,!1,e.add(n));if((o="number"==typeof i.maxZoom?Math.min(i.maxZoom,o):o)===1/0)return{center:t.getCenter(),zoom:o};i=n.subtract(e).divideBy(2),n=this.project(t.getSouthWest(),o),e=this.project(t.getNorthEast(),o);return{center:this.unproject(n.add(e).divideBy(2).add(i),o),zoom:o}},fitBounds:function(t,i){if(!(t=g(t)).isValid())throw new Error("Bounds are not valid.");t=this._getBoundsCenterZoom(t,i);return this.setView(t.center,t.zoom,i)},fitWorld:function(t){return this.fitBounds([[-90,-180],[90,180]],t)},panTo:function(t,i){return this.setView(t,this._zoom,{pan:i})},panBy:function(t,i){return i=i||{},(t=_(t).round()).x||t.y?(!0===i.animate||this.getSize().contains(t)?(this._panAnim||(this._panAnim=new Wi,this._panAnim.on({step:this._onPanTransitionStep,end:this._onPanTransitionEnd},this)),i.noMoveStart||this.fire("movestart"),!1!==i.animate?(z(this._mapPane,"leaflet-pan-anim"),e=this._getMapPanePos().subtract(t).round(),this._panAnim.run(this._mapPane,e,i.duration||.25,i.easeLinearity)):(this._rawPanBy(t),this.fire("move").fire("moveend"))):this._resetView(this.unproject(this.project(this.getCenter()).add(t)),this.getZoom()),this):this.fire("moveend");var e},flyTo:function(n,o,t){if(!1===(t=t||{}).animate||!P.any3d)return this.setView(n,o,t);this._stop();var s=this.project(this.getCenter()),r=this.project(n),i=this.getSize(),a=this._zoom,h=(n=w(n),o=void 0===o?a:o,Math.max(i.x,i.y)),e=h*this.getZoomScale(a,o),l=r.distanceTo(s)||1,u=1.42,c=u*u;function d(t){t=(e*e-h*h+(t?-1:1)*c*c*l*l)/(2*(t?e:h)*c*l),t=Math.sqrt(t*t+1)-t;return t<1e-9?-18:Math.log(t)}function _(t){return(Math.exp(t)-Math.exp(-t))/2}function p(t){return(Math.exp(t)+Math.exp(-t))/2}var m=d(0);function f(t){return h*(p(m)*(_(t=m+u*t)/p(t))-_(m))/c}var g=Date.now(),v=(d(1)-m)/u,y=t.duration?1e3*t.duration:1e3*v*.8;return this._moveStart(!0,t.noMoveStart),function t(){var i=(Date.now()-g)/y,e=(1-Math.pow(1-i,1.5))*v;i<=1?(this._flyToFrame=x(t,this),this._move(this.unproject(s.add(r.subtract(s).multiplyBy(f(e)/l)),a),this.getScaleZoom(h/(i=e,h*(p(m)/p(m+u*i))),a),{flyTo:!0})):this._move(n,o)._moveEnd(!0)}.call(this),this},flyToBounds:function(t,i){t=this._getBoundsCenterZoom(t,i);return this.flyTo(t.center,t.zoom,i)},setMaxBounds:function(t){return(t=g(t)).isValid()?(this.options.maxBounds&&this.off("moveend",this._panInsideMaxBounds),this.options.maxBounds=t,this._loaded&&this._panInsideMaxBounds(),this.on("moveend",this._panInsideMaxBounds)):(this.options.maxBounds=null,this.off("moveend",this._panInsideMaxBounds))},setMinZoom:function(t){var i=this.options.minZoom;return this.options.minZoom=t,this._loaded&&i!==t&&(this.fire("zoomlevelschange"),this.getZoom()<this.options.minZoom)?this.setZoom(t):this},setMaxZoom:function(t){var i=this.options.maxZoom;return this.options.maxZoom=t,this._loaded&&i!==t&&(this.fire("zoomlevelschange"),this.getZoom()>this.options.maxZoom)?this.setZoom(t):this},panInsideBounds:function(t,i){this._enforcingBounds=!0;var e=this.getCenter(),t=this._limitCenter(e,this._zoom,g(t));return e.equals(t)||this.panTo(t,i),this._enforcingBounds=!1,this},panInside:function(t,i){var e=_((i=i||{}).paddingTopLeft||i.padding||[0,0]),n=_(i.paddingBottomRight||i.padding||[0,0]),o=this.project(this.getCenter()),t=this.project(t),s=this.getPixelBounds(),e=f([s.min.add(e),s.max.subtract(n)]),s=e.getSize();return e.contains(t)||(this._enforcingBounds=!0,n=t.subtract(e.getCenter()),e=e.extend(t).getSize().subtract(s),o.x+=n.x<0?-e.x:e.x,o.y+=n.y<0?-e.y:e.y,this.panTo(this.unproject(o),i),this._enforcingBounds=!1),this},invalidateSize:function(t){if(!this._loaded)return this;t=l({animate:!1,pan:!0},!0===t?{animate:!0}:t);var i=this.getSize(),e=(this._sizeChanged=!0,this._lastCenter=null,this.getSize()),n=i.divideBy(2).round(),o=e.divideBy(2).round(),n=n.subtract(o);return n.x||n.y?(t.animate&&t.pan?this.panBy(n):(t.pan&&this._rawPanBy(n),this.fire("move"),t.debounceMoveend?(clearTimeout(this._sizeTimer),this._sizeTimer=setTimeout(a(this.fire,this,"moveend"),200)):this.fire("moveend")),this.fire("resize",{oldSize:i,newSize:e})):this},stop:function(){return this.setZoom(this._limitZoom(this._zoom)),this.options.zoomSnap||this.fire("viewreset"),this._stop()},locate:function(t){if(t=this._locateOptions=l({timeout:1e4,watch:!1},t),!("geolocation"in navigator))return this._handleGeolocationError({code:0,message:"Geolocation not supported."}),this;var i=a(this._handleGeolocationResponse,this),e=a(this._handleGeolocationError,this);return t.watch?this._locationWatchId=navigator.geolocation.watchPosition(i,e,t):navigator.geolocation.getCurrentPosition(i,e,t),this},stopLocate:function(){return navigator.geolocation&&navigator.geolocation.clearWatch&&navigator.geolocation.clearWatch(this._locationWatchId),this._locateOptions&&(this._locateOptions.setView=!1),this},_handleGeolocationError:function(t){var i;this._container._leaflet_id&&(i=t.code,t=t.message||(1===i?"permission denied":2===i?"position unavailable":"timeout"),this._locateOptions.setView&&!this._loaded&&this.fitWorld(),this.fire("locationerror",{code:i,message:"Geolocation error: "+t+"."}))},_handleGeolocationResponse:function(t){if(this._container._leaflet_id){var i,e,n=new v(t.coords.latitude,t.coords.longitude),o=n.toBounds(2*t.coords.accuracy),s=this._locateOptions,r=(s.setView&&(i=this.getBoundsZoom(o),this.setView(n,s.maxZoom?Math.min(i,s.maxZoom):i)),{latlng:n,bounds:o,timestamp:t.timestamp});for(e in t.coords)"number"==typeof t.coords[e]&&(r[e]=t.coords[e]);this.fire("locationfound",r)}},addHandler:function(t,i){if(!i)return this;i=this[t]=new i(this);return this._handlers.push(i),this.options[t]&&i.enable(),this},remove:function(){if(this._initEvents(!0),this.options.maxBounds&&this.off("moveend",this._panInsideMaxBounds),this._containerId!==this._container._leaflet_id)throw new Error("Map container is being reused by another instance");try{delete this._container._leaflet_id,delete this._containerId}catch(t){this._container._leaflet_id=void 0,this._containerId=void 0}for(var t in void 0!==this._locationWatchId&&this.stopLocate(),this._stop(),T(this._mapPane),this._clearControlPos&&this._clearControlPos(),this._resizeRequest&&(r(this._resizeRequest),this._resizeRequest=null),this._clearHandlers(),this._loaded&&this.fire("unload"),this._layers)this._layers[t].remove();for(t in this._panes)T(this._panes[t]);return this._layers=[],this._panes=[],delete this._mapPane,delete this._renderer,this},createPane:function(t,i){i=b("div","leaflet-pane"+(t?" leaflet-"+t.replace("Pane","")+"-pane":""),i||this._mapPane);return t&&(this._panes[t]=i),i},getCenter:function(){return this._checkIfLoaded(),this._lastCenter&&!this._moved()?this._lastCenter:this.layerPointToLatLng(this._getCenterLayerPoint())},getZoom:function(){return this._zoom},getBounds:function(){var t=this.getPixelBounds();return new s(this.unproject(t.getBottomLeft()),this.unproject(t.getTopRight()))},getMinZoom:function(){return void 0===this.options.minZoom?this._layersMinZoom||0:this.options.minZoom},getMaxZoom:function(){return void 0===this.options.maxZoom?void 0===this._layersMaxZoom?1/0:this._layersMaxZoom:this.options.maxZoom},getBoundsZoom:function(t,i,e){t=g(t),e=_(e||[0,0]);var n=this.getZoom()||0,o=this.getMinZoom(),s=this.getMaxZoom(),r=t.getNorthWest(),t=t.getSouthEast(),e=this.getSize().subtract(e),t=f(this.project(t,n),this.project(r,n)).getSize(),r=P.any3d?this.options.zoomSnap:1,a=e.x/t.x,e=e.y/t.y,t=i?Math.max(a,e):Math.min(a,e),n=this.getScaleZoom(t,n);return r&&(n=Math.round(n/(r/100))*(r/100),n=i?Math.ceil(n/r)*r:Math.floor(n/r)*r),Math.max(o,Math.min(s,n))},getSize:function(){return this._size&&!this._sizeChanged||(this._size=new p(this._container.clientWidth||0,this._container.clientHeight||0),this._sizeChanged=!1),this._size.clone()},getPixelBounds:function(t,i){t=this._getTopLeftPoint(t,i);return new m(t,t.add(this.getSize()))},getPixelOrigin:function(){return this._checkIfLoaded(),this._pixelOrigin},getPixelWorldBounds:function(t){return this.options.crs.getProjectedBounds(void 0===t?this.getZoom():t)},getPane:function(t){return"string"==typeof t?this._panes[t]:t},getPanes:function(){return this._panes},getContainer:function(){return this._container},getZoomScale:function(t,i){var e=this.options.crs;return i=void 0===i?this._zoom:i,e.scale(t)/e.scale(i)},getScaleZoom:function(t,i){var e=this.options.crs,t=(i=void 0===i?this._zoom:i,e.zoom(t*e.scale(i)));return isNaN(t)?1/0:t},project:function(t,i){return i=void 0===i?this._zoom:i,this.options.crs.latLngToPoint(w(t),i)},unproject:function(t,i){return i=void 0===i?this._zoom:i,this.options.crs.pointToLatLng(_(t),i)},layerPointToLatLng:function(t){t=_(t).add(this.getPixelOrigin());return this.unproject(t)},latLngToLayerPoint:function(t){return this.project(w(t))._round()._subtract(this.getPixelOrigin())},wrapLatLng:function(t){return this.options.crs.wrapLatLng(w(t))},wrapLatLngBounds:function(t){return this.options.crs.wrapLatLngBounds(g(t))},distance:function(t,i){return this.options.crs.distance(w(t),w(i))},containerPointToLayerPoint:function(t){return _(t).subtract(this._getMapPanePos())},layerPointToContainerPoint:function(t){return _(t).add(this._getMapPanePos())},containerPointToLatLng:function(t){t=this.containerPointToLayerPoint(_(t));return this.layerPointToLatLng(t)},latLngToContainerPoint:function(t){return this.layerPointToContainerPoint(this.latLngToLayerPoint(w(t)))},mouseEventToContainerPoint:function(t){return Ni(t,this._container)},mouseEventToLayerPoint:function(t){return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t))},mouseEventToLatLng:function(t){return this.layerPointToLatLng(this.mouseEventToLayerPoint(t))},_initContainer:function(t){t=this._container=_i(t);if(!t)throw new Error("Map container not found.");if(t._leaflet_id)throw new Error("Map container is already initialized.");S(t,"scroll",this._onScroll,this),this._containerId=h(t)},_initLayout:function(){var t=this._container,i=(this._fadeAnimated=this.options.fadeAnimation&&P.any3d,z(t,"leaflet-container"+(P.touch?" leaflet-touch":"")+(P.retina?" leaflet-retina":"")+(P.ielt9?" leaflet-oldie":"")+(P.safari?" leaflet-safari":"")+(this._fadeAnimated?" leaflet-fade-anim":"")),pi(t,"position"));"absolute"!==i&&"relative"!==i&&"fixed"!==i&&(t.style.position="relative"),this._initPanes(),this._initControlPos&&this._initControlPos()},_initPanes:function(){var t=this._panes={};this._paneRenderers={},this._mapPane=this.createPane("mapPane",this._container),Z(this._mapPane,new p(0,0)),this.createPane("tilePane"),this.createPane("overlayPane"),this.createPane("shadowPane"),this.createPane("markerPane"),this.createPane("tooltipPane"),this.createPane("popupPane"),this.options.markerZoomAnimation||(z(t.markerPane,"leaflet-zoom-hide"),z(t.shadowPane,"leaflet-zoom-hide"))},_resetView:function(t,i){Z(this._mapPane,new p(0,0));var e=!this._loaded,n=(this._loaded=!0,i=this._limitZoom(i),this.fire("viewprereset"),this._zoom!==i);this._moveStart(n,!1)._move(t,i)._moveEnd(n),this.fire("viewreset"),e&&this.fire("load")},_moveStart:function(t,i){return t&&this.fire("zoomstart"),i||this.fire("movestart"),this},_move:function(t,i,e,n){void 0===i&&(i=this._zoom);var o=this._zoom!==i;return this._zoom=i,this._lastCenter=t,this._pixelOrigin=this._getNewPixelOrigin(t),n?e&&e.pinch&&this.fire("zoom",e):((o||e&&e.pinch)&&this.fire("zoom",e),this.fire("move",e)),this},_moveEnd:function(t){return t&&this.fire("zoomend"),this.fire("moveend")},_stop:function(){return r(this._flyToFrame),this._panAnim&&this._panAnim.stop(),this},_rawPanBy:function(t){Z(this._mapPane,this._getMapPanePos().subtract(t))},_getZoomSpan:function(){return this.getMaxZoom()-this.getMinZoom()},_panInsideMaxBounds:function(){this._enforcingBounds||this.panInsideBounds(this.options.maxBounds)},_checkIfLoaded:function(){if(!this._loaded)throw new Error("Set map center and zoom first.")},_initEvents:function(t){this._targets={};var i=t?E:S;i((this._targets[h(this._container)]=this)._container,"click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup",this._handleDOMEvent,this),this.options.trackResize&&i(window,"resize",this._onResize,this),P.any3d&&this.options.transform3DLimit&&(t?this.off:this.on).call(this,"moveend",this._onMoveEnd)},_onResize:function(){r(this._resizeRequest),this._resizeRequest=x(function(){this.invalidateSize({debounceMoveend:!0})},this)},_onScroll:function(){this._container.scrollTop=0,this._container.scrollLeft=0},_onMoveEnd:function(){var t=this._getMapPanePos();Math.max(Math.abs(t.x),Math.abs(t.y))>=this.options.transform3DLimit&&this._resetView(this.getCenter(),this.getZoom())},_findEventTargets:function(t,i){for(var e,n=[],o="mouseout"===i||"mouseover"===i,s=t.target||t.srcElement,r=!1;s;){if((e=this._targets[h(s)])&&("click"===i||"preclick"===i)&&this._draggableMoved(e)){r=!0;break}if(e&&e.listens(i,!0)){if(o&&!Hi(s,t))break;if(n.push(e),o)break}if(s===this._container)break;s=s.parentNode}return n=n.length||r||o||!this.listens(i,!0)?n:[this]},_isClickDisabled:function(t){for(;t!==this._container;){if(t._leaflet_disable_click)return!0;t=t.parentNode}},_handleDOMEvent:function(t){var i,e=t.target||t.srcElement;!this._loaded||e._leaflet_disable_events||"click"===t.type&&this._isClickDisabled(e)||("mousedown"===(i=t.type)&&zi(e),this._fireDOMEvent(t,i))},_mouseEvents:["click","dblclick","mouseover","mouseout","contextmenu"],_fireDOMEvent:function(t,i,e){"click"===t.type&&((a=l({},t)).type="preclick",this._fireDOMEvent(a,a.type,e));var n=this._findEventTargets(t,i);if(e){for(var o=[],s=0;s<e.length;s++)e[s].listens(i,!0)&&o.push(e[s]);n=o.concat(n)}if(n.length){"contextmenu"===i&&B(t);var r,a=n[0],h={originalEvent:t};for("keypress"!==t.type&&"keydown"!==t.type&&"keyup"!==t.type&&(r=a.getLatLng&&(!a._radius||a._radius<=10),h.containerPoint=r?this.latLngToContainerPoint(a.getLatLng()):this.mouseEventToContainerPoint(t),h.layerPoint=this.containerPointToLayerPoint(h.containerPoint),h.latlng=r?a.getLatLng():this.layerPointToLatLng(h.layerPoint)),s=0;s<n.length;s++)if(n[s].fire(i,h,!0),h.originalEvent._stopped||!1===n[s].options.bubblingMouseEvents&&-1!==G(this._mouseEvents,i))return}},_draggableMoved:function(t){return(t=t.dragging&&t.dragging.enabled()?t:this).dragging&&t.dragging.moved()||this.boxZoom&&this.boxZoom.moved()},_clearHandlers:function(){for(var t=0,i=this._handlers.length;t<i;t++)this._handlers[t].disable()},whenReady:function(t,i){return this._loaded?t.call(i||this,{target:this}):this.on("load",t,i),this},_getMapPanePos:function(){return bi(this._mapPane)||new p(0,0)},_moved:function(){var t=this._getMapPanePos();return t&&!t.equals([0,0])},_getTopLeftPoint:function(t,i){return(t&&void 0!==i?this._getNewPixelOrigin(t,i):this.getPixelOrigin()).subtract(this._getMapPanePos())},_getNewPixelOrigin:function(t,i){var e=this.getSize()._divideBy(2);return this.project(t,i)._subtract(e)._add(this._getMapPanePos())._round()},_latLngToNewLayerPoint:function(t,i,e){e=this._getNewPixelOrigin(e,i);return this.project(t,i)._subtract(e)},_latLngBoundsToNewLayerBounds:function(t,i,e){e=this._getNewPixelOrigin(e,i);return f([this.project(t.getSouthWest(),i)._subtract(e),this.project(t.getNorthWest(),i)._subtract(e),this.project(t.getSouthEast(),i)._subtract(e),this.project(t.getNorthEast(),i)._subtract(e)])},_getCenterLayerPoint:function(){return this.containerPointToLayerPoint(this.getSize()._divideBy(2))},_getCenterOffset:function(t){return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint())},_limitCenter:function(t,i,e){if(!e)return t;var n=this.project(t,i),o=this.getSize().divideBy(2),o=new m(n.subtract(o),n.add(o)),o=this._getBoundsOffset(o,e,i);return o.round().equals([0,0])?t:this.unproject(n.add(o),i)},_limitOffset:function(t,i){if(!i)return t;var e=this.getPixelBounds(),e=new m(e.min.add(t),e.max.add(t));return t.add(this._getBoundsOffset(e,i))},_getBoundsOffset:function(t,i,e){i=f(this.project(i.getNorthEast(),e),this.project(i.getSouthWest(),e)),e=i.min.subtract(t.min),i=i.max.subtract(t.max);return new p(this._rebound(e.x,-i.x),this._rebound(e.y,-i.y))},_rebound:function(t,i){return 0<t+i?Math.round(t-i)/2:Math.max(0,Math.ceil(t))-Math.max(0,Math.floor(i))},_limitZoom:function(t){var i=this.getMinZoom(),e=this.getMaxZoom(),n=P.any3d?this.options.zoomSnap:1;return n&&(t=Math.round(t/n)*n),Math.max(i,Math.min(e,t))},_onPanTransitionStep:function(){this.fire("move")},_onPanTransitionEnd:function(){M(this._mapPane,"leaflet-pan-anim"),this.fire("moveend")},_tryAnimatedPan:function(t,i){t=this._getCenterOffset(t)._trunc();return!(!0!==(i&&i.animate)&&!this.getSize().contains(t))&&(this.panBy(t,i),!0)},_createAnimProxy:function(){var t=this._proxy=b("div","leaflet-proxy leaflet-zoom-animated");this._panes.mapPane.appendChild(t),this.on("zoomanim",function(t){var i=ui,e=this._proxy.style[i];Pi(this._proxy,this.project(t.center,t.zoom),this.getZoomScale(t.zoom,1)),e===this._proxy.style[i]&&this._animatingZoom&&this._onZoomTransitionEnd()},this),this.on("load moveend",this._animMoveEnd,this),this._on("unload",this._destroyAnimProxy,this)},_destroyAnimProxy:function(){T(this._proxy),this.off("load moveend",this._animMoveEnd,this),delete this._proxy},_animMoveEnd:function(){var t=this.getCenter(),i=this.getZoom();Pi(this._proxy,this.project(t,i),this.getZoomScale(i,1))},_catchTransitionEnd:function(t){this._animatingZoom&&0<=t.propertyName.indexOf("transform")&&this._onZoomTransitionEnd()},_nothingToAnimate:function(){return!this._container.getElementsByClassName("leaflet-zoom-animated").length},_tryAnimatedZoom:function(t,i,e){if(this._animatingZoom)return!0;if(e=e||{},!this._zoomAnimated||!1===e.animate||this._nothingToAnimate()||Math.abs(i-this._zoom)>this.options.zoomAnimationThreshold)return!1;var n=this.getZoomScale(i),n=this._getCenterOffset(t)._divideBy(1-1/n);return!(!0!==e.animate&&!this.getSize().contains(n))&&(x(function(){this._moveStart(!0,!1)._animateZoom(t,i,!0)},this),!0)},_animateZoom:function(t,i,e,n){this._mapPane&&(e&&(this._animatingZoom=!0,this._animateToCenter=t,this._animateToZoom=i,z(this._mapPane,"leaflet-zoom-anim")),this.fire("zoomanim",{center:t,zoom:i,noUpdate:n}),this._tempFireZoomEvent||(this._tempFireZoomEvent=this._zoom!==this._animateToZoom),this._move(this._animateToCenter,this._animateToZoom,void 0,!0),setTimeout(a(this._onZoomTransitionEnd,this),250))},_onZoomTransitionEnd:function(){this._animatingZoom&&(this._mapPane&&M(this._mapPane,"leaflet-zoom-anim"),this._animatingZoom=!1,this._move(this._animateToCenter,this._animateToZoom,void 0,!0),this._tempFireZoomEvent&&this.fire("zoom"),delete this._tempFireZoomEvent,this.fire("move"),this._moveEnd(!0))}});function Fi(t){return new I(t)}var Ui,I=it.extend({options:{position:"topright"},initialize:function(t){c(this,t)},getPosition:function(){return this.options.position},setPosition:function(t){var i=this._map;return i&&i.removeControl(this),this.options.position=t,i&&i.addControl(this),this},getContainer:function(){return this._container},addTo:function(t){this.remove(),this._map=t;var i=this._container=this.onAdd(t),e=this.getPosition(),t=t._controlCorners[e];return z(i,"leaflet-control"),-1!==e.indexOf("bottom")?t.insertBefore(i,t.firstChild):t.appendChild(i),this._map.on("unload",this.remove,this),this},remove:function(){return this._map&&(T(this._container),this.onRemove&&this.onRemove(this._map),this._map.off("unload",this.remove,this),this._map=null),this},_refocusOnMap:function(t){this._map&&t&&0<t.screenX&&0<t.screenY&&this._map.getContainer().focus()}}),Vi=(A.include({addControl:function(t){return t.addTo(this),this},removeControl:function(t){return t.remove(),this},_initControlPos:function(){var e=this._controlCorners={},n="leaflet-",o=this._controlContainer=b("div",n+"control-container",this._container);function t(t,i){e[t+i]=b("div",n+t+" "+n+i,o)}t("top","left"),t("top","right"),t("bottom","left"),t("bottom","right")},_clearControlPos:function(){for(var t in this._controlCorners)T(this._controlCorners[t]);T(this._controlContainer),delete this._controlCorners,delete this._controlContainer}}),I.extend({options:{collapsed:!0,position:"topright",autoZIndex:!0,hideSingleBase:!1,sortLayers:!1,sortFunction:function(t,i,e,n){return e<n?-1:n<e?1:0}},initialize:function(t,i,e){for(var n in c(this,e),this._layerControlInputs=[],this._layers=[],this._lastZIndex=0,this._handlingClick=!1,t)this._addLayer(t[n],n);for(n in i)this._addLayer(i[n],n,!0)},onAdd:function(t){this._initLayout(),this._update(),(this._map=t).on("zoomend",this._checkDisabledLayers,this);for(var i=0;i<this._layers.length;i++)this._layers[i].layer.on("add remove",this._onLayerChange,this);return this._container},addTo:function(t){return I.prototype.addTo.call(this,t),this._expandIfNotCollapsed()},onRemove:function(){this._map.off("zoomend",this._checkDisabledLayers,this);for(var t=0;t<this._layers.length;t++)this._layers[t].layer.off("add remove",this._onLayerChange,this)},addBaseLayer:function(t,i){return this._addLayer(t,i),this._map?this._update():this},addOverlay:function(t,i){return this._addLayer(t,i,!0),this._map?this._update():this},removeLayer:function(t){t.off("add remove",this._onLayerChange,this);t=this._getLayer(h(t));return t&&this._layers.splice(this._layers.indexOf(t),1),this._map?this._update():this},expand:function(){z(this._container,"leaflet-control-layers-expanded"),this._section.style.height=null;var t=this._map.getSize().y-(this._container.offsetTop+50);return t<this._section.clientHeight?(z(this._section,"leaflet-control-layers-scrollbar"),this._section.style.height=t+"px"):M(this._section,"leaflet-control-layers-scrollbar"),this._checkDisabledLayers(),this},collapse:function(){return M(this._container,"leaflet-control-layers-expanded"),this},_initLayout:function(){var t="leaflet-control-layers",i=this._container=b("div",t),e=this.options.collapsed,n=(i.setAttribute("aria-haspopup",!0),Oi(i),Ii(i),this._section=b("section",t+"-list")),o=(e&&(this._map.on("click",this.collapse,this),S(i,{mouseenter:function(){S(n,"click",B),this.expand(),setTimeout(function(){E(n,"click",B)})},mouseleave:this.collapse},this)),this._layersLink=b("a",t+"-toggle",i));o.href="#",o.title="Layers",o.setAttribute("role","button"),S(o,"click",B),S(o,"focus",this.expand,this),e||this.expand(),this._baseLayersList=b("div",t+"-base",n),this._separator=b("div",t+"-separator",n),this._overlaysList=b("div",t+"-overlays",n),i.appendChild(n)},_getLayer:function(t){for(var i=0;i<this._layers.length;i++)if(this._layers[i]&&h(this._layers[i].layer)===t)return this._layers[i]},_addLayer:function(t,i,e){this._map&&t.on("add remove",this._onLayerChange,this),this._layers.push({layer:t,name:i,overlay:e}),this.options.sortLayers&&this._layers.sort(a(function(t,i){return this.options.sortFunction(t.layer,i.layer,t.name,i.name)},this)),this.options.autoZIndex&&t.setZIndex&&(this._lastZIndex++,t.setZIndex(this._lastZIndex)),this._expandIfNotCollapsed()},_update:function(){if(!this._container)return this;mi(this._baseLayersList),mi(this._overlaysList),this._layerControlInputs=[];for(var t,i,e,n=0,o=0;o<this._layers.length;o++)e=this._layers[o],this._addItem(e),i=i||e.overlay,t=t||!e.overlay,n+=e.overlay?0:1;return this.options.hideSingleBase&&(this._baseLayersList.style.display=(t=t&&1<n)?"":"none"),this._separator.style.display=i&&t?"":"none",this},_onLayerChange:function(t){this._handlingClick||this._update();var i=this._getLayer(h(t.target)),t=i.overlay?"add"===t.type?"overlayadd":"overlayremove":"add"===t.type?"baselayerchange":null;t&&this._map.fire(t,i)},_createRadioElement:function(t,i){t='<input type="radio" class="leaflet-control-layers-selector" name="'+t+'"'+(i?' checked="checked"':"")+"/>",i=document.createElement("div");return i.innerHTML=t,i.firstChild},_addItem:function(t){var i,e=document.createElement("label"),n=this._map.hasLayer(t.layer),n=(t.overlay?((i=document.createElement("input")).type="checkbox",i.className="leaflet-control-layers-selector",i.defaultChecked=n):i=this._createRadioElement("leaflet-base-layers_"+h(this),n),this._layerControlInputs.push(i),i.layerId=h(t.layer),S(i,"click",this._onInputClick,this),document.createElement("span")),o=(n.innerHTML=" "+t.name,document.createElement("span"));return e.appendChild(o),o.appendChild(i),o.appendChild(n),(t.overlay?this._overlaysList:this._baseLayersList).appendChild(e),this._checkDisabledLayers(),e},_onInputClick:function(){var t,i,e=this._layerControlInputs,n=[],o=[];this._handlingClick=!0;for(var s=e.length-1;0<=s;s--)t=e[s],i=this._getLayer(t.layerId).layer,t.checked?n.push(i):t.checked||o.push(i);for(s=0;s<o.length;s++)this._map.hasLayer(o[s])&&this._map.removeLayer(o[s]);for(s=0;s<n.length;s++)this._map.hasLayer(n[s])||this._map.addLayer(n[s]);this._handlingClick=!1,this._refocusOnMap()},_checkDisabledLayers:function(){for(var t,i,e=this._layerControlInputs,n=this._map.getZoom(),o=e.length-1;0<=o;o--)t=e[o],i=this._getLayer(t.layerId).layer,t.disabled=void 0!==i.options.minZoom&&n<i.options.minZoom||void 0!==i.options.maxZoom&&n>i.options.maxZoom},_expandIfNotCollapsed:function(){return this._map&&!this.options.collapsed&&this.expand(),this}})),qi=I.extend({options:{position:"topleft",zoomInText:'<span aria-hidden="true">+</span>',zoomInTitle:"Zoom in",zoomOutText:'<span aria-hidden="true">&#x2212;</span>',zoomOutTitle:"Zoom out"},onAdd:function(t){var i="leaflet-control-zoom",e=b("div",i+" leaflet-bar"),n=this.options;return this._zoomInButton=this._createButton(n.zoomInText,n.zoomInTitle,i+"-in",e,this._zoomIn),this._zoomOutButton=this._createButton(n.zoomOutText,n.zoomOutTitle,i+"-out",e,this._zoomOut),this._updateDisabled(),t.on("zoomend zoomlevelschange",this._updateDisabled,this),e},onRemove:function(t){t.off("zoomend zoomlevelschange",this._updateDisabled,this)},disable:function(){return this._disabled=!0,this._updateDisabled(),this},enable:function(){return this._disabled=!1,this._updateDisabled(),this},_zoomIn:function(t){!this._disabled&&this._map._zoom<this._map.getMaxZoom()&&this._map.zoomIn(this._map.options.zoomDelta*(t.shiftKey?3:1))},_zoomOut:function(t){!this._disabled&&this._map._zoom>this._map.getMinZoom()&&this._map.zoomOut(this._map.options.zoomDelta*(t.shiftKey?3:1))},_createButton:function(t,i,e,n,o){e=b("a",e,n);return e.innerHTML=t,e.href="#",e.title=i,e.setAttribute("role","button"),e.setAttribute("aria-label",i),Oi(e),S(e,"click",Ri),S(e,"click",o,this),S(e,"click",this._refocusOnMap,this),e},_updateDisabled:function(){var t=this._map,i="leaflet-disabled";M(this._zoomInButton,i),M(this._zoomOutButton,i),this._zoomInButton.setAttribute("aria-disabled","false"),this._zoomOutButton.setAttribute("aria-disabled","false"),!this._disabled&&t._zoom!==t.getMinZoom()||(z(this._zoomOutButton,i),this._zoomOutButton.setAttribute("aria-disabled","true")),!this._disabled&&t._zoom!==t.getMaxZoom()||(z(this._zoomInButton,i),this._zoomInButton.setAttribute("aria-disabled","true"))}}),Gi=(A.mergeOptions({zoomControl:!0}),A.addInitHook(function(){this.options.zoomControl&&(this.zoomControl=new qi,this.addControl(this.zoomControl))}),I.extend({options:{position:"bottomleft",maxWidth:100,metric:!0,imperial:!0},onAdd:function(t){var i="leaflet-control-scale",e=b("div",i),n=this.options;return this._addScales(n,i+"-line",e),t.on(n.updateWhenIdle?"moveend":"move",this._update,this),t.whenReady(this._update,this),e},onRemove:function(t){t.off(this.options.updateWhenIdle?"moveend":"move",this._update,this)},_addScales:function(t,i,e){t.metric&&(this._mScale=b("div",i,e)),t.imperial&&(this._iScale=b("div",i,e))},_update:function(){var t=this._map,i=t.getSize().y/2,t=t.distance(t.containerPointToLatLng([0,i]),t.containerPointToLatLng([this.options.maxWidth,i]));this._updateScales(t)},_updateScales:function(t){this.options.metric&&t&&this._updateMetric(t),this.options.imperial&&t&&this._updateImperial(t)},_updateMetric:function(t){var i=this._getRoundNum(t);this._updateScale(this._mScale,i<1e3?i+" m":i/1e3+" km",i/t)},_updateImperial:function(t){var i,e,t=3.2808399*t;5280<t?(e=this._getRoundNum(i=t/5280),this._updateScale(this._iScale,e+" mi",e/i)):(e=this._getRoundNum(t),this._updateScale(this._iScale,e+" ft",e/t))},_updateScale:function(t,i,e){t.style.width=Math.round(this.options.maxWidth*e)+"px",t.innerHTML=i},_getRoundNum:function(t){var i=Math.pow(10,(Math.floor(t)+"").length-1),t=t/i;return i*(t=10<=t?10:5<=t?5:3<=t?3:2<=t?2:1)}})),Ki=I.extend({options:{position:"bottomright",prefix:'<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">'+(P.inlineSvg?'<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg> ':"")+"Leaflet</a>"},initialize:function(t){c(this,t),this._attributions={}},onAdd:function(t){for(var i in(t.attributionControl=this)._container=b("div","leaflet-control-attribution"),Oi(this._container),t._layers)t._layers[i].getAttribution&&this.addAttribution(t._layers[i].getAttribution());return this._update(),t.on("layeradd",this._addAttribution,this),this._container},onRemove:function(t){t.off("layeradd",this._addAttribution,this)},_addAttribution:function(t){t.layer.getAttribution&&(this.addAttribution(t.layer.getAttribution()),t.layer.once("remove",function(){this.removeAttribution(t.layer.getAttribution())},this))},setPrefix:function(t){return this.options.prefix=t,this._update(),this},addAttribution:function(t){return t&&(this._attributions[t]||(this._attributions[t]=0),this._attributions[t]++,this._update()),this},removeAttribution:function(t){return t&&this._attributions[t]&&(this._attributions[t]--,this._update()),this},_update:function(){if(this._map){var t,i=[];for(t in this._attributions)this._attributions[t]&&i.push(t);var e=[];this.options.prefix&&e.push(this.options.prefix),i.length&&e.push(i.join(", ")),this._container.innerHTML=e.join(' <span aria-hidden="true">|</span> ')}}}),n=(A.mergeOptions({attributionControl:!0}),A.addInitHook(function(){this.options.attributionControl&&(new Ki).addTo(this)}),I.Layers=Vi,I.Zoom=qi,I.Scale=Gi,I.Attribution=Ki,Fi.layers=function(t,i,e){return new Vi(t,i,e)},Fi.zoom=function(t){return new qi(t)},Fi.scale=function(t){return new Gi(t)},Fi.attribution=function(t){return new Ki(t)},it.extend({initialize:function(t){this._map=t},enable:function(){return this._enabled||(this._enabled=!0,this.addHooks()),this},disable:function(){return this._enabled&&(this._enabled=!1,this.removeHooks()),this},enabled:function(){return!!this._enabled}})),ft=(n.addTo=function(t,i){return t.addHandler(i,this),this},{Events:i}),Yi=P.touch?"touchstart mousedown":"mousedown",Xi=et.extend({options:{clickTolerance:3},initialize:function(t,i,e,n){c(this,n),this._element=t,this._dragStartTarget=i||t,this._preventOutline=e},enable:function(){this._enabled||(S(this._dragStartTarget,Yi,this._onDown,this),this._enabled=!0)},disable:function(){this._enabled&&(Xi._dragging===this&&this.finishDrag(!0),E(this._dragStartTarget,Yi,this._onDown,this),this._enabled=!1,this._moved=!1)},_onDown:function(t){var i,e;this._enabled&&(this._moved=!1,vi(this._element,"leaflet-zoom-anim")||(t.touches&&1!==t.touches.length?Xi._dragging===this&&this.finishDrag():Xi._dragging||t.shiftKey||1!==t.which&&1!==t.button&&!t.touches||((Xi._dragging=this)._preventOutline&&zi(this._element),Li(),ri(),this._moving||(this.fire("down"),e=t.touches?t.touches[0]:t,i=Ci(this._element),this._startPoint=new p(e.clientX,e.clientY),this._startPos=bi(this._element),this._parentScale=Zi(i),e="mousedown"===t.type,S(document,e?"mousemove":"touchmove",this._onMove,this),S(document,e?"mouseup":"touchend touchcancel",this._onUp,this)))))},_onMove:function(t){var i;this._enabled&&(t.touches&&1<t.touches.length?this._moved=!0:!(i=new p((i=t.touches&&1===t.touches.length?t.touches[0]:t).clientX,i.clientY)._subtract(this._startPoint)).x&&!i.y||Math.abs(i.x)+Math.abs(i.y)<this.options.clickTolerance||(i.x/=this._parentScale.x,i.y/=this._parentScale.y,B(t),this._moved||(this.fire("dragstart"),this._moved=!0,z(document.body,"leaflet-dragging"),this._lastTarget=t.target||t.srcElement,window.SVGElementInstance&&this._lastTarget instanceof window.SVGElementInstance&&(this._lastTarget=this._lastTarget.correspondingUseElement),z(this._lastTarget,"leaflet-drag-target")),this._newPos=this._startPos.add(i),this._moving=!0,this._lastEvent=t,this._updatePosition()))},_updatePosition:function(){var t={originalEvent:this._lastEvent};this.fire("predrag",t),Z(this._element,this._newPos),this.fire("drag",t)},_onUp:function(){this._enabled&&this.finishDrag()},finishDrag:function(t){M(document.body,"leaflet-dragging"),this._lastTarget&&(M(this._lastTarget,"leaflet-drag-target"),this._lastTarget=null),E(document,"mousemove touchmove",this._onMove,this),E(document,"mouseup touchend touchcancel",this._onUp,this),Ti(),ai(),this._moved&&this._moving&&this.fire("dragend",{noInertia:t,distance:this._newPos.distanceTo(this._startPos)}),this._moving=!1,Xi._dragging=!1}});function Ji(t,i){if(!i||!t.length)return t.slice();i*=i;return t=function(t,i){var e=t.length,n=new(typeof Uint8Array!=void 0+""?Uint8Array:Array)(e);n[0]=n[e-1]=1,function t(i,e,n,o,s){var r,a,h,l=0;for(a=o+1;a<=s-1;a++)h=ee(i[a],i[o],i[s],!0),l<h&&(r=a,l=h);n<l&&(e[r]=1,t(i,e,n,o,r),t(i,e,n,r,s))}(t,n,i,0,e-1);var o,s=[];for(o=0;o<e;o++)n[o]&&s.push(t[o]);return s}(t=function(t,i){for(var e=[t[0]],n=1,o=0,s=t.length;n<s;n++)(function(t,i){var e=i.x-t.x,i=i.y-t.y;return e*e+i*i})(t[n],t[o])>i&&(e.push(t[n]),o=n);o<s-1&&e.push(t[s-1]);return e}(t,i),i)}function $i(t,i,e){return Math.sqrt(ee(t,i,e,!0))}function Qi(t,i,e,n,o){var s,r,a,h=n?Ui:ie(t,e),l=ie(i,e);for(Ui=l;;){if(!(h|l))return[t,i];if(h&l)return!1;a=ie(r=te(t,i,s=h||l,e,o),e),s===h?(t=r,h=a):(i=r,l=a)}}function te(t,i,e,n,o){var s,r,a=i.x-t.x,i=i.y-t.y,h=n.min,n=n.max;return 8&e?(s=t.x+a*(n.y-t.y)/i,r=n.y):4&e?(s=t.x+a*(h.y-t.y)/i,r=h.y):2&e?(s=n.x,r=t.y+i*(n.x-t.x)/a):1&e&&(s=h.x,r=t.y+i*(h.x-t.x)/a),new p(s,r,o)}function ie(t,i){var e=0;return t.x<i.min.x?e|=1:t.x>i.max.x&&(e|=2),t.y<i.min.y?e|=4:t.y>i.max.y&&(e|=8),e}function ee(t,i,e,n){var o=i.x,i=i.y,s=e.x-o,r=e.y-i,a=s*s+r*r;return 0<a&&(1<(a=((t.x-o)*s+(t.y-i)*r)/a)?(o=e.x,i=e.y):0<a&&(o+=s*a,i+=r*a)),s=t.x-o,r=t.y-i,n?s*s+r*r:new p(o,i)}function ne(t){return!d(t[0])||"object"!=typeof t[0][0]&&void 0!==t[0][0]}function oe(t){return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."),ne(t)}gt={__proto__:null,simplify:Ji,pointToSegmentDistance:$i,closestPointOnSegment:function(t,i,e){return ee(t,i,e)},clipSegment:Qi,_getEdgeIntersection:te,_getBitCode:ie,_sqClosestPointOnSegment:ee,isFlat:ne,_flat:oe};function se(t,i,e){for(var n,o,s,r,a,h,l,u=[1,4,2,8],c=0,d=t.length;c<d;c++)t[c]._code=ie(t[c],i);for(s=0;s<4;s++){for(h=u[s],n=[],c=0,o=(d=t.length)-1;c<d;o=c++)r=t[c],a=t[o],r._code&h?a._code&h||((l=te(a,r,h,i,e))._code=ie(l,i),n.push(l)):(a._code&h&&((l=te(a,r,h,i,e))._code=ie(l,i),n.push(l)),n.push(r));t=n}return t}var vt={__proto__:null,clipPolygon:se},yt={project:function(t){return new p(t.lng,t.lat)},unproject:function(t){return new v(t.y,t.x)},bounds:new m([-180,-90],[180,90])},xt={R:6378137,R_MINOR:6356752.314245179,bounds:new m([-20037508.34279,-15496570.73972],[20037508.34279,18764656.23138]),project:function(t){var i=Math.PI/180,e=this.R,n=t.lat*i,o=this.R_MINOR/e,o=Math.sqrt(1-o*o),s=o*Math.sin(n),s=Math.tan(Math.PI/4-n/2)/Math.pow((1-s)/(1+s),o/2),n=-e*Math.log(Math.max(s,1e-10));return new p(t.lng*i*e,n)},unproject:function(t){for(var i,e=180/Math.PI,n=this.R,o=this.R_MINOR/n,s=Math.sqrt(1-o*o),r=Math.exp(-t.y/n),a=Math.PI/2-2*Math.atan(r),h=0,l=.1;h<15&&1e-7<Math.abs(l);h++)i=s*Math.sin(a),i=Math.pow((1-i)/(1+i),s/2),a+=l=Math.PI/2-2*Math.atan(r*i)-a;return new v(a*e,t.x*e/n)}},wt={__proto__:null,LonLat:yt,Mercator:xt,SphericalMercator:rt},bt=l({},st,{code:"EPSG:3395",projection:xt,transformation:ht(Pt=.5/(Math.PI*xt.R),.5,-Pt,.5)}),re=l({},st,{code:"EPSG:4326",projection:yt,transformation:ht(1/180,1,-1/180,.5)}),Lt=l({},ot,{projection:yt,transformation:ht(1,0,-1,0),scale:function(t){return Math.pow(2,t)},zoom:function(t){return Math.log(t)/Math.LN2},distance:function(t,i){var e=i.lng-t.lng,i=i.lat-t.lat;return Math.sqrt(e*e+i*i)},infinite:!0}),o=(ot.Earth=st,ot.EPSG3395=bt,ot.EPSG3857=lt,ot.EPSG900913=ut,ot.EPSG4326=re,ot.Simple=Lt,et.extend({options:{pane:"overlayPane",attribution:null,bubblingMouseEvents:!0},addTo:function(t){return t.addLayer(this),this},remove:function(){return this.removeFrom(this._map||this._mapToAdd)},removeFrom:function(t){return t&&t.removeLayer(this),this},getPane:function(t){return this._map.getPane(t?this.options[t]||t:this.options.pane)},addInteractiveTarget:function(t){return this._map._targets[h(t)]=this},removeInteractiveTarget:function(t){return delete this._map._targets[h(t)],this},getAttribution:function(){return this.options.attribution},_layerAdd:function(t){var i,e=t.target;e.hasLayer(this)&&(this._map=e,this._zoomAnimated=e._zoomAnimated,this.getEvents&&(i=this.getEvents(),e.on(i,this),this.once("remove",function(){e.off(i,this)},this)),this.onAdd(e),this.fire("add"),e.fire("layeradd",{layer:this}))}})),ae=(A.include({addLayer:function(t){if(!t._layerAdd)throw new Error("The provided object is not a Layer.");var i=h(t);return this._layers[i]||((this._layers[i]=t)._mapToAdd=this,t.beforeAdd&&t.beforeAdd(this),this.whenReady(t._layerAdd,t)),this},removeLayer:function(t){var i=h(t);return this._layers[i]&&(this._loaded&&t.onRemove(this),delete this._layers[i],this._loaded&&(this.fire("layerremove",{layer:t}),t.fire("remove")),t._map=t._mapToAdd=null),this},hasLayer:function(t){return h(t)in this._layers},eachLayer:function(t,i){for(var e in this._layers)t.call(i,this._layers[e]);return this},_addLayers:function(t){for(var i=0,e=(t=t?d(t)?t:[t]:[]).length;i<e;i++)this.addLayer(t[i])},_addZoomLimit:function(t){isNaN(t.options.maxZoom)&&isNaN(t.options.minZoom)||(this._zoomBoundLayers[h(t)]=t,this._updateZoomLevels())},_removeZoomLimit:function(t){t=h(t);this._zoomBoundLayers[t]&&(delete this._zoomBoundLayers[t],this._updateZoomLevels())},_updateZoomLevels:function(){var t,i=1/0,e=-1/0,n=this._getZoomSpan();for(t in this._zoomBoundLayers)var o=this._zoomBoundLayers[t].options,i=void 0===o.minZoom?i:Math.min(i,o.minZoom),e=void 0===o.maxZoom?e:Math.max(e,o.maxZoom);this._layersMaxZoom=e===-1/0?void 0:e,this._layersMinZoom=i===1/0?void 0:i,n!==this._getZoomSpan()&&this.fire("zoomlevelschange"),void 0===this.options.maxZoom&&this._layersMaxZoom&&this.getZoom()>this._layersMaxZoom&&this.setZoom(this._layersMaxZoom),void 0===this.options.minZoom&&this._layersMinZoom&&this.getZoom()<this._layersMinZoom&&this.setZoom(this._layersMinZoom)}}),o.extend({initialize:function(t,i){var e,n;if(c(this,i),this._layers={},t)for(e=0,n=t.length;e<n;e++)this.addLayer(t[e])},addLayer:function(t){var i=this.getLayerId(t);return this._layers[i]=t,this._map&&this._map.addLayer(t),this},removeLayer:function(t){t=t in this._layers?t:this.getLayerId(t);return this._map&&this._layers[t]&&this._map.removeLayer(this._layers[t]),delete this._layers[t],this},hasLayer:function(t){return("number"==typeof t?t:this.getLayerId(t))in this._layers},clearLayers:function(){return this.eachLayer(this.removeLayer,this)},invoke:function(t){var i,e,n=Array.prototype.slice.call(arguments,1);for(i in this._layers)(e=this._layers[i])[t]&&e[t].apply(e,n);return this},onAdd:function(t){this.eachLayer(t.addLayer,t)},onRemove:function(t){this.eachLayer(t.removeLayer,t)},eachLayer:function(t,i){for(var e in this._layers)t.call(i,this._layers[e]);return this},getLayer:function(t){return this._layers[t]},getLayers:function(){var t=[];return this.eachLayer(t.push,t),t},setZIndex:function(t){return this.invoke("setZIndex",t)},getLayerId:h})),he=ae.extend({addLayer:function(t){return this.hasLayer(t)?this:(t.addEventParent(this),ae.prototype.addLayer.call(this,t),this.fire("layeradd",{layer:t}))},removeLayer:function(t){return this.hasLayer(t)?((t=t in this._layers?this._layers[t]:t).removeEventParent(this),ae.prototype.removeLayer.call(this,t),this.fire("layerremove",{layer:t})):this},setStyle:function(t){return this.invoke("setStyle",t)},bringToFront:function(){return this.invoke("bringToFront")},bringToBack:function(){return this.invoke("bringToBack")},getBounds:function(){var t,i=new s;for(t in this._layers){var e=this._layers[t];i.extend(e.getBounds?e.getBounds():e.getLatLng())}return i}}),le=it.extend({options:{popupAnchor:[0,0],tooltipAnchor:[0,0],crossOrigin:!1},initialize:function(t){c(this,t)},createIcon:function(t){return this._createIcon("icon",t)},createShadow:function(t){return this._createIcon("shadow",t)},_createIcon:function(t,i){var e=this._getIconUrl(t);if(!e){if("icon"===t)throw new Error("iconUrl not set in Icon options (see the docs).");return null}e=this._createImg(e,i&&"IMG"===i.tagName?i:null);return this._setIconStyles(e,t),!this.options.crossOrigin&&""!==this.options.crossOrigin||(e.crossOrigin=!0===this.options.crossOrigin?"":this.options.crossOrigin),e},_setIconStyles:function(t,i){var e=this.options,n=e[i+"Size"],n=_(n="number"==typeof n?[n,n]:n),o=_("shadow"===i&&e.shadowAnchor||e.iconAnchor||n&&n.divideBy(2,!0));t.className="leaflet-marker-"+i+" "+(e.className||""),o&&(t.style.marginLeft=-o.x+"px",t.style.marginTop=-o.y+"px"),n&&(t.style.width=n.x+"px",t.style.height=n.y+"px")},_createImg:function(t,i){return(i=i||document.createElement("img")).src=t,i},_getIconUrl:function(t){return P.retina&&this.options[t+"RetinaUrl"]||this.options[t+"Url"]}});var ue=le.extend({options:{iconUrl:"marker-icon.png",iconRetinaUrl:"marker-icon-2x.png",shadowUrl:"marker-shadow.png",iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],tooltipAnchor:[16,-28],shadowSize:[41,41]},_getIconUrl:function(t){return"string"!=typeof ue.imagePath&&(ue.imagePath=this._detectIconPath()),(this.options.imagePath||ue.imagePath)+le.prototype._getIconUrl.call(this,t)},_stripUrl:function(t){function i(t,i,e){return(i=i.exec(t))&&i[e]}return(t=i(t,/^url\((['"])?(.+)\1\)$/,2))&&i(t,/^(.*)marker-icon\.png$/,1)},_detectIconPath:function(){var t=b("div","leaflet-default-icon-path",document.body),i=pi(t,"background-image")||pi(t,"backgroundImage");if(document.body.removeChild(t),i=this._stripUrl(i))return i;t=document.querySelector('link[href$="leaflet.css"]');return t?t.href.substring(0,t.href.length-"leaflet.css".length-1):""}}),ce=n.extend({initialize:function(t){this._marker=t},addHooks:function(){var t=this._marker._icon;this._draggable||(this._draggable=new Xi(t,t,!0)),this._draggable.on({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).enable(),z(t,"leaflet-marker-draggable")},removeHooks:function(){this._draggable.off({dragstart:this._onDragStart,predrag:this._onPreDrag,drag:this._onDrag,dragend:this._onDragEnd},this).disable(),this._marker._icon&&M(this._marker._icon,"leaflet-marker-draggable")},moved:function(){return this._draggable&&this._draggable._moved},_adjustPan:function(t){var i=this._marker,e=i._map,n=this._marker.options.autoPanSpeed,o=this._marker.options.autoPanPadding,s=bi(i._icon),r=e.getPixelBounds(),a=e.getPixelOrigin(),a=f(r.min._subtract(a).add(o),r.max._subtract(a).subtract(o));a.contains(s)||(o=_((Math.max(a.max.x,s.x)-a.max.x)/(r.max.x-a.max.x)-(Math.min(a.min.x,s.x)-a.min.x)/(r.min.x-a.min.x),(Math.max(a.max.y,s.y)-a.max.y)/(r.max.y-a.max.y)-(Math.min(a.min.y,s.y)-a.min.y)/(r.min.y-a.min.y)).multiplyBy(n),e.panBy(o,{animate:!1}),this._draggable._newPos._add(o),this._draggable._startPos._add(o),Z(i._icon,this._draggable._newPos),this._onDrag(t),this._panRequest=x(this._adjustPan.bind(this,t)))},_onDragStart:function(){this._oldLatLng=this._marker.getLatLng(),this._marker.closePopup&&this._marker.closePopup(),this._marker.fire("movestart").fire("dragstart")},_onPreDrag:function(t){this._marker.options.autoPan&&(r(this._panRequest),this._panRequest=x(this._adjustPan.bind(this,t)))},_onDrag:function(t){var i=this._marker,e=i._shadow,n=bi(i._icon),o=i._map.layerPointToLatLng(n);e&&Z(e,n),i._latlng=o,t.latlng=o,t.oldLatLng=this._oldLatLng,i.fire("move",t).fire("drag",t)},_onDragEnd:function(t){r(this._panRequest),delete this._oldLatLng,this._marker.fire("moveend").fire("dragend",t)}}),de=o.extend({options:{icon:new ue,interactive:!0,keyboard:!0,title:"",alt:"Marker",zIndexOffset:0,opacity:1,riseOnHover:!1,riseOffset:250,pane:"markerPane",shadowPane:"shadowPane",bubblingMouseEvents:!1,autoPanOnFocus:!0,draggable:!1,autoPan:!1,autoPanPadding:[50,50],autoPanSpeed:10},initialize:function(t,i){c(this,i),this._latlng=w(t)},onAdd:function(t){this._zoomAnimated=this._zoomAnimated&&t.options.markerZoomAnimation,this._zoomAnimated&&t.on("zoomanim",this._animateZoom,this),this._initIcon(),this.update()},onRemove:function(t){this.dragging&&this.dragging.enabled()&&(this.options.draggable=!0,this.dragging.removeHooks()),delete this.dragging,this._zoomAnimated&&t.off("zoomanim",this._animateZoom,this),this._removeIcon(),this._removeShadow()},getEvents:function(){return{zoom:this.update,viewreset:this.update}},getLatLng:function(){return this._latlng},setLatLng:function(t){var i=this._latlng;return this._latlng=w(t),this.update(),this.fire("move",{oldLatLng:i,latlng:this._latlng})},setZIndexOffset:function(t){return this.options.zIndexOffset=t,this.update()},getIcon:function(){return this.options.icon},setIcon:function(t){return this.options.icon=t,this._map&&(this._initIcon(),this.update()),this._popup&&this.bindPopup(this._popup,this._popup.options),this},getElement:function(){return this._icon},update:function(){var t;return this._icon&&this._map&&(t=this._map.latLngToLayerPoint(this._latlng).round(),this._setPos(t)),this},_initIcon:function(){var t=this.options,i="leaflet-zoom-"+(this._zoomAnimated?"animated":"hide"),e=t.icon.createIcon(this._icon),n=!1,e=(e!==this._icon&&(this._icon&&this._removeIcon(),n=!0,t.title&&(e.title=t.title),"IMG"===e.tagName&&(e.alt=t.alt||"")),z(e,i),t.keyboard&&(e.tabIndex="0",e.setAttribute("role","button")),this._icon=e,t.riseOnHover&&this.on({mouseover:this._bringToFront,mouseout:this._resetZIndex}),this.options.autoPanOnFocus&&S(e,"focus",this._panOnFocus,this),t.icon.createShadow(this._shadow)),o=!1;e!==this._shadow&&(this._removeShadow(),o=!0),e&&(z(e,i),e.alt=""),this._shadow=e,t.opacity<1&&this._updateOpacity(),n&&this.getPane().appendChild(this._icon),this._initInteraction(),e&&o&&this.getPane(t.shadowPane).appendChild(this._shadow)},_removeIcon:function(){this.options.riseOnHover&&this.off({mouseover:this._bringToFront,mouseout:this._resetZIndex}),this.options.autoPanOnFocus&&E(this._icon,"focus",this._panOnFocus,this),T(this._icon),this.removeInteractiveTarget(this._icon),this._icon=null},_removeShadow:function(){this._shadow&&T(this._shadow),this._shadow=null},_setPos:function(t){this._icon&&Z(this._icon,t),this._shadow&&Z(this._shadow,t),this._zIndex=t.y+this.options.zIndexOffset,this._resetZIndex()},_updateZIndex:function(t){this._icon&&(this._icon.style.zIndex=this._zIndex+t)},_animateZoom:function(t){t=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center).round();this._setPos(t)},_initInteraction:function(){var t;this.options.interactive&&(z(this._icon,"leaflet-interactive"),this.addInteractiveTarget(this._icon),ce&&(t=this.options.draggable,this.dragging&&(t=this.dragging.enabled(),this.dragging.disable()),this.dragging=new ce(this),t&&this.dragging.enable()))},setOpacity:function(t){return this.options.opacity=t,this._map&&this._updateOpacity(),this},_updateOpacity:function(){var t=this.options.opacity;this._icon&&C(this._icon,t),this._shadow&&C(this._shadow,t)},_bringToFront:function(){this._updateZIndex(this.options.riseOffset)},_resetZIndex:function(){this._updateZIndex(0)},_panOnFocus:function(){var t,i,e=this._map;e&&(t=(i=this.options.icon.options).iconSize?_(i.iconSize):_(0,0),i=i.iconAnchor?_(i.iconAnchor):_(0,0),e.panInside(this._latlng,{paddingTopLeft:i,paddingBottomRight:t.subtract(i)}))},_getPopupAnchor:function(){return this.options.icon.options.popupAnchor},_getTooltipAnchor:function(){return this.options.icon.options.tooltipAnchor}});var _e=o.extend({options:{stroke:!0,color:"#3388ff",weight:3,opacity:1,lineCap:"round",lineJoin:"round",dashArray:null,dashOffset:null,fill:!1,fillColor:null,fillOpacity:.2,fillRule:"evenodd",interactive:!0,bubblingMouseEvents:!0},beforeAdd:function(t){this._renderer=t.getRenderer(this)},onAdd:function(){this._renderer._initPath(this),this._reset(),this._renderer._addPath(this)},onRemove:function(){this._renderer._removePath(this)},redraw:function(){return this._map&&this._renderer._updatePath(this),this},setStyle:function(t){return c(this,t),this._renderer&&(this._renderer._updateStyle(this),this.options.stroke&&t&&Object.prototype.hasOwnProperty.call(t,"weight")&&this._updateBounds()),this},bringToFront:function(){return this._renderer&&this._renderer._bringToFront(this),this},bringToBack:function(){return this._renderer&&this._renderer._bringToBack(this),this},getElement:function(){return this._path},_reset:function(){this._project(),this._update()},_clickTolerance:function(){return(this.options.stroke?this.options.weight/2:0)+(this._renderer.options.tolerance||0)}}),pe=_e.extend({options:{fill:!0,radius:10},initialize:function(t,i){c(this,i),this._latlng=w(t),this._radius=this.options.radius},setLatLng:function(t){var i=this._latlng;return this._latlng=w(t),this.redraw(),this.fire("move",{oldLatLng:i,latlng:this._latlng})},getLatLng:function(){return this._latlng},setRadius:function(t){return this.options.radius=this._radius=t,this.redraw()},getRadius:function(){return this._radius},setStyle:function(t){var i=t&&t.radius||this._radius;return _e.prototype.setStyle.call(this,t),this.setRadius(i),this},_project:function(){this._point=this._map.latLngToLayerPoint(this._latlng),this._updateBounds()},_updateBounds:function(){var t=this._radius,i=this._radiusY||t,e=this._clickTolerance(),t=[t+e,i+e];this._pxBounds=new m(this._point.subtract(t),this._point.add(t))},_update:function(){this._map&&this._updatePath()},_updatePath:function(){this._renderer._updateCircle(this)},_empty:function(){return this._radius&&!this._renderer._bounds.intersects(this._pxBounds)},_containsPoint:function(t){return t.distanceTo(this._point)<=this._radius+this._clickTolerance()}});var me=pe.extend({initialize:function(t,i,e){if(c(this,i="number"==typeof i?l({},e,{radius:i}):i),this._latlng=w(t),isNaN(this.options.radius))throw new Error("Circle radius cannot be NaN");this._mRadius=this.options.radius},setRadius:function(t){return this._mRadius=t,this.redraw()},getRadius:function(){return this._mRadius},getBounds:function(){var t=[this._radius,this._radiusY||this._radius];return new s(this._map.layerPointToLatLng(this._point.subtract(t)),this._map.layerPointToLatLng(this._point.add(t)))},setStyle:_e.prototype.setStyle,_project:function(){var t,i,e,n,o,s=this._latlng.lng,r=this._latlng.lat,a=this._map,h=a.options.crs;h.distance===st.distance?(n=Math.PI/180,o=this._mRadius/st.R/n,t=a.project([r+o,s]),i=a.project([r-o,s]),i=t.add(i).divideBy(2),e=a.unproject(i).lat,n=Math.acos((Math.cos(o*n)-Math.sin(r*n)*Math.sin(e*n))/(Math.cos(r*n)*Math.cos(e*n)))/n,!isNaN(n)&&0!==n||(n=o/Math.cos(Math.PI/180*r)),this._point=i.subtract(a.getPixelOrigin()),this._radius=isNaN(n)?0:i.x-a.project([e,s-n]).x,this._radiusY=i.y-t.y):(o=h.unproject(h.project(this._latlng).subtract([this._mRadius,0])),this._point=a.latLngToLayerPoint(this._latlng),this._radius=this._point.x-a.latLngToLayerPoint(o).x),this._updateBounds()}});var fe=_e.extend({options:{smoothFactor:1,noClip:!1},initialize:function(t,i){c(this,i),this._setLatLngs(t)},getLatLngs:function(){return this._latlngs},setLatLngs:function(t){return this._setLatLngs(t),this.redraw()},isEmpty:function(){return!this._latlngs.length},closestLayerPoint:function(t){for(var i=1/0,e=null,n=ee,o=0,s=this._parts.length;o<s;o++)for(var r=this._parts[o],a=1,h=r.length;a<h;a++){var l,u,c=n(t,l=r[a-1],u=r[a],!0);c<i&&(i=c,e=n(t,l,u))}return e&&(e.distance=Math.sqrt(i)),e},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,i,e,n,o,s,r=this._rings[0],a=r.length;if(!a)return null;for(i=t=0;t<a-1;t++)i+=r[t].distanceTo(r[t+1])/2;if(0===i)return this._map.layerPointToLatLng(r[0]);for(e=t=0;t<a-1;t++)if(n=r[t],o=r[t+1],i<(e+=s=n.distanceTo(o)))return this._map.layerPointToLatLng([o.x-(s=(e-i)/s)*(o.x-n.x),o.y-s*(o.y-n.y)])},getBounds:function(){return this._bounds},addLatLng:function(t,i){return i=i||this._defaultShape(),t=w(t),i.push(t),this._bounds.extend(t),this.redraw()},_setLatLngs:function(t){this._bounds=new s,this._latlngs=this._convertLatLngs(t)},_defaultShape:function(){return ne(this._latlngs)?this._latlngs:this._latlngs[0]},_convertLatLngs:function(t){for(var i=[],e=ne(t),n=0,o=t.length;n<o;n++)e?(i[n]=w(t[n]),this._bounds.extend(i[n])):i[n]=this._convertLatLngs(t[n]);return i},_project:function(){var t=new m;this._rings=[],this._projectLatlngs(this._latlngs,this._rings,t),this._bounds.isValid()&&t.isValid()&&(this._rawPxBounds=t,this._updateBounds())},_updateBounds:function(){var t=this._clickTolerance(),t=new p(t,t);this._rawPxBounds&&(this._pxBounds=new m([this._rawPxBounds.min.subtract(t),this._rawPxBounds.max.add(t)]))},_projectLatlngs:function(t,i,e){var n,o,s=t[0]instanceof v,r=t.length;if(s){for(o=[],n=0;n<r;n++)o[n]=this._map.latLngToLayerPoint(t[n]),e.extend(o[n]);i.push(o)}else for(n=0;n<r;n++)this._projectLatlngs(t[n],i,e)},_clipPoints:function(){var t=this._renderer._bounds;if(this._parts=[],this._pxBounds&&this._pxBounds.intersects(t))if(this.options.noClip)this._parts=this._rings;else for(var i,e,n,o,s=this._parts,r=0,a=0,h=this._rings.length;r<h;r++)for(i=0,e=(o=this._rings[r]).length;i<e-1;i++)(n=Qi(o[i],o[i+1],t,i,!0))&&(s[a]=s[a]||[],s[a].push(n[0]),n[1]===o[i+1]&&i!==e-2||(s[a].push(n[1]),a++))},_simplifyPoints:function(){for(var t=this._parts,i=this.options.smoothFactor,e=0,n=t.length;e<n;e++)t[e]=Ji(t[e],i)},_update:function(){this._map&&(this._clipPoints(),this._simplifyPoints(),this._updatePath())},_updatePath:function(){this._renderer._updatePoly(this)},_containsPoint:function(t,i){var e,n,o,s,r,a,h=this._clickTolerance();if(!this._pxBounds||!this._pxBounds.contains(t))return!1;for(e=0,s=this._parts.length;e<s;e++)for(n=0,o=(r=(a=this._parts[e]).length)-1;n<r;o=n++)if((i||0!==n)&&$i(t,a[o],a[n])<=h)return!0;return!1}});fe._flat=oe;var ge=fe.extend({options:{fill:!0},isEmpty:function(){return!this._latlngs.length||!this._latlngs[0].length},getCenter:function(){if(!this._map)throw new Error("Must add layer to map before using getCenter()");var t,i,e,n,o,s,r,a,h,l=this._rings[0],u=l.length;if(!u)return null;for(t=s=r=a=0,i=u-1;t<u;i=t++)e=l[t],n=l[i],o=e.y*n.x-n.y*e.x,r+=(e.x+n.x)*o,a+=(e.y+n.y)*o,s+=3*o;return h=0===s?l[0]:[r/s,a/s],this._map.layerPointToLatLng(h)},_convertLatLngs:function(t){var t=fe.prototype._convertLatLngs.call(this,t),i=t.length;return 2<=i&&t[0]instanceof v&&t[0].equals(t[i-1])&&t.pop(),t},_setLatLngs:function(t){fe.prototype._setLatLngs.call(this,t),ne(this._latlngs)&&(this._latlngs=[this._latlngs])},_defaultShape:function(){return(ne(this._latlngs[0])?this._latlngs:this._latlngs[0])[0]},_clipPoints:function(){var t=this._renderer._bounds,i=this.options.weight,i=new p(i,i),t=new m(t.min.subtract(i),t.max.add(i));if(this._parts=[],this._pxBounds&&this._pxBounds.intersects(t))if(this.options.noClip)this._parts=this._rings;else for(var e,n=0,o=this._rings.length;n<o;n++)(e=se(this._rings[n],t,!0)).length&&this._parts.push(e)},_updatePath:function(){this._renderer._updatePoly(this,!0)},_containsPoint:function(t){var i,e,n,o,s,r,a,h,l=!1;if(!this._pxBounds||!this._pxBounds.contains(t))return!1;for(o=0,a=this._parts.length;o<a;o++)for(s=0,r=(h=(i=this._parts[o]).length)-1;s<h;r=s++)e=i[s],n=i[r],e.y>t.y!=n.y>t.y&&t.x<(n.x-e.x)*(t.y-e.y)/(n.y-e.y)+e.x&&(l=!l);return l||fe.prototype._containsPoint.call(this,t,!0)}});var ve=he.extend({initialize:function(t,i){c(this,i),this._layers={},t&&this.addData(t)},addData:function(t){var i,e,n,o=d(t)?t:t.features;if(o){for(i=0,e=o.length;i<e;i++)((n=o[i]).geometries||n.geometry||n.features||n.coordinates)&&this.addData(n);return this}var s=this.options;if(s.filter&&!s.filter(t))return this;var r=ye(t,s);return r?(r.feature=ze(t),r.defaultOptions=r.options,this.resetStyle(r),s.onEachFeature&&s.onEachFeature(t,r),this.addLayer(r)):this},resetStyle:function(t){return void 0===t?this.eachLayer(this.resetStyle,this):(t.options=l({},t.defaultOptions),this._setLayerStyle(t,this.options.style),this)},setStyle:function(i){return this.eachLayer(function(t){this._setLayerStyle(t,i)},this)},_setLayerStyle:function(t,i){t.setStyle&&("function"==typeof i&&(i=i(t.feature)),t.setStyle(i))}});function ye(t,i){var e,n,o,s,r="Feature"===t.type?t.geometry:t,a=r?r.coordinates:null,h=[],l=i&&i.pointToLayer,u=i&&i.coordsToLatLng||we;if(!a&&!r)return null;switch(r.type){case"Point":return xe(l,t,e=u(a),i);case"MultiPoint":for(o=0,s=a.length;o<s;o++)e=u(a[o]),h.push(xe(l,t,e,i));return new he(h);case"LineString":case"MultiLineString":return n=Pe(a,"LineString"===r.type?0:1,u),new fe(n,i);case"Polygon":case"MultiPolygon":return n=Pe(a,"Polygon"===r.type?1:2,u),new ge(n,i);case"GeometryCollection":for(o=0,s=r.geometries.length;o<s;o++){var c=ye({geometry:r.geometries[o],type:"Feature",properties:t.properties},i);c&&h.push(c)}return new he(h);default:throw new Error("Invalid GeoJSON object.")}}function xe(t,i,e,n){return t?t(i,e):new de(e,n&&n.markersInheritOptions&&n)}function we(t){return new v(t[1],t[0],t[2])}function Pe(t,i,e){for(var n,o=[],s=0,r=t.length;s<r;s++)n=i?Pe(t[s],i-1,e):(e||we)(t[s]),o.push(n);return o}function be(t,i){return void 0!==(t=w(t)).alt?[e(t.lng,i),e(t.lat,i),e(t.alt,i)]:[e(t.lng,i),e(t.lat,i)]}function Le(t,i,e,n){for(var o=[],s=0,r=t.length;s<r;s++)o.push(i?Le(t[s],i-1,e,n):be(t[s],n));return!i&&e&&o.push(o[0]),o}function Te(t,i){return t.feature?l({},t.feature,{geometry:i}):ze(i)}function ze(t){return"Feature"===t.type||"FeatureCollection"===t.type?t:{type:"Feature",properties:{},geometry:t}}Tt={toGeoJSON:function(t){return Te(this,{type:"Point",coordinates:be(this.getLatLng(),t)})}};function Me(t,i){return new ve(t,i)}de.include(Tt),me.include(Tt),pe.include(Tt),fe.include({toGeoJSON:function(t){var i=!ne(this._latlngs);return Te(this,{type:(i?"Multi":"")+"LineString",coordinates:Le(this._latlngs,i?1:0,!1,t)})}}),ge.include({toGeoJSON:function(t){var i=!ne(this._latlngs),e=i&&!ne(this._latlngs[0]),t=Le(this._latlngs,e?2:i?1:0,!0,t);return Te(this,{type:(e?"Multi":"")+"Polygon",coordinates:t=i?t:[t]})}}),ae.include({toMultiPoint:function(i){var e=[];return this.eachLayer(function(t){e.push(t.toGeoJSON(i).geometry.coordinates)}),Te(this,{type:"MultiPoint",coordinates:e})},toGeoJSON:function(i){var t=this.feature&&this.feature.geometry&&this.feature.geometry.type;if("MultiPoint"===t)return this.toMultiPoint(i);var e="GeometryCollection"===t,n=[];return this.eachLayer(function(t){t.toGeoJSON&&(t=t.toGeoJSON(i),e?n.push(t.geometry):"FeatureCollection"===(t=ze(t)).type?n.push.apply(n,t.features):n.push(t))}),e?Te(this,{geometries:n,type:"GeometryCollection"}):{type:"FeatureCollection",features:n}}});var zt=Me,Ce=o.extend({options:{opacity:1,alt:"",interactive:!1,crossOrigin:!1,errorOverlayUrl:"",zIndex:1,className:""},initialize:function(t,i,e){this._url=t,this._bounds=g(i),c(this,e)},onAdd:function(){this._image||(this._initImage(),this.options.opacity<1&&this._updateOpacity()),this.options.interactive&&(z(this._image,"leaflet-interactive"),this.addInteractiveTarget(this._image)),this.getPane().appendChild(this._image),this._reset()},onRemove:function(){T(this._image),this.options.interactive&&this.removeInteractiveTarget(this._image)},setOpacity:function(t){return this.options.opacity=t,this._image&&this._updateOpacity(),this},setStyle:function(t){return t.opacity&&this.setOpacity(t.opacity),this},bringToFront:function(){return this._map&&fi(this._image),this},bringToBack:function(){return this._map&&gi(this._image),this},setUrl:function(t){return this._url=t,this._image&&(this._image.src=t),this},setBounds:function(t){return this._bounds=g(t),this._map&&this._reset(),this},getEvents:function(){var t={zoom:this._reset,viewreset:this._reset};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},getBounds:function(){return this._bounds},getElement:function(){return this._image},_initImage:function(){var t="IMG"===this._url.tagName,i=this._image=t?this._url:b("img");z(i,"leaflet-image-layer"),this._zoomAnimated&&z(i,"leaflet-zoom-animated"),this.options.className&&z(i,this.options.className),i.onselectstart=u,i.onmousemove=u,i.onload=a(this.fire,this,"load"),i.onerror=a(this._overlayOnError,this,"error"),!this.options.crossOrigin&&""!==this.options.crossOrigin||(i.crossOrigin=!0===this.options.crossOrigin?"":this.options.crossOrigin),this.options.zIndex&&this._updateZIndex(),t?this._url=i.src:(i.src=this._url,i.alt=this.options.alt)},_animateZoom:function(t){var i=this._map.getZoomScale(t.zoom),t=this._map._latLngBoundsToNewLayerBounds(this._bounds,t.zoom,t.center).min;Pi(this._image,t,i)},_reset:function(){var t=this._image,i=new m(this._map.latLngToLayerPoint(this._bounds.getNorthWest()),this._map.latLngToLayerPoint(this._bounds.getSouthEast())),e=i.getSize();Z(t,i.min),t.style.width=e.x+"px",t.style.height=e.y+"px"},_updateOpacity:function(){C(this._image,this.options.opacity)},_updateZIndex:function(){this._image&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._image.style.zIndex=this.options.zIndex)},_overlayOnError:function(){this.fire("error");var t=this.options.errorOverlayUrl;t&&this._url!==t&&(this._url=t,this._image.src=t)},getCenter:function(){return this._bounds.getCenter()}}),Ze=Ce.extend({options:{autoplay:!0,loop:!0,keepAspectRatio:!0,muted:!1,playsInline:!0},_initImage:function(){var t="VIDEO"===this._url.tagName,i=this._image=t?this._url:b("video");if(z(i,"leaflet-image-layer"),this._zoomAnimated&&z(i,"leaflet-zoom-animated"),this.options.className&&z(i,this.options.className),i.onselectstart=u,i.onmousemove=u,i.onloadeddata=a(this.fire,this,"load"),t){for(var e=i.getElementsByTagName("source"),n=[],o=0;o<e.length;o++)n.push(e[o].src);this._url=0<e.length?n:[i.src]}else{d(this._url)||(this._url=[this._url]),!this.options.keepAspectRatio&&Object.prototype.hasOwnProperty.call(i.style,"objectFit")&&(i.style.objectFit="fill"),i.autoplay=!!this.options.autoplay,i.loop=!!this.options.loop,i.muted=!!this.options.muted,i.playsInline=!!this.options.playsInline;for(var s=0;s<this._url.length;s++){var r=b("source");r.src=this._url[s],i.appendChild(r)}}}});var Se=Ce.extend({_initImage:function(){var t=this._image=this._url;z(t,"leaflet-image-layer"),this._zoomAnimated&&z(t,"leaflet-zoom-animated"),this.options.className&&z(t,this.options.className),t.onselectstart=u,t.onmousemove=u}});var O=o.extend({options:{interactive:!1,offset:[0,0],className:"",pane:void 0},initialize:function(t,i){c(this,t),this._source=i},openOn:function(t){return(t=arguments.length?t:this._source._map).hasLayer(this)||t.addLayer(this),this},close:function(){return this._map&&this._map.removeLayer(this),this},toggle:function(t){return this._map?this.close():(arguments.length?this._source=t:t=this._source,this._prepareOpen(),this.openOn(t._map)),this},onAdd:function(t){this._zoomAnimated=t._zoomAnimated,this._container||this._initLayout(),t._fadeAnimated&&C(this._container,0),clearTimeout(this._removeTimeout),this.getPane().appendChild(this._container),this.update(),t._fadeAnimated&&C(this._container,1),this.bringToFront(),this.options.interactive&&(z(this._container,"leaflet-interactive"),this.addInteractiveTarget(this._container))},onRemove:function(t){t._fadeAnimated?(C(this._container,0),this._removeTimeout=setTimeout(a(T,void 0,this._container),200)):T(this._container),this.options.interactive&&(M(this._container,"leaflet-interactive"),this.removeInteractiveTarget(this._container))},getLatLng:function(){return this._latlng},setLatLng:function(t){return this._latlng=w(t),this._map&&(this._updatePosition(),this._adjustPan()),this},getContent:function(){return this._content},setContent:function(t){return this._content=t,this.update(),this},getElement:function(){return this._container},update:function(){this._map&&(this._container.style.visibility="hidden",this._updateContent(),this._updateLayout(),this._updatePosition(),this._container.style.visibility="",this._adjustPan())},getEvents:function(){var t={zoom:this._updatePosition,viewreset:this._updatePosition};return this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},isOpen:function(){return!!this._map&&this._map.hasLayer(this)},bringToFront:function(){return this._map&&fi(this._container),this},bringToBack:function(){return this._map&&gi(this._container),this},_prepareOpen:function(t){if(!(e=this._source)._map)return!1;if(e instanceof he){var i,e=null,n=this._source._layers;for(i in n)if(n[i]._map){e=n[i];break}if(!e)return!1;this._source=e}if(!t)if(e.getCenter)t=e.getCenter();else if(e.getLatLng)t=e.getLatLng();else{if(!e.getBounds)throw new Error("Unable to get source layer LatLng.");t=e.getBounds().getCenter()}return this.setLatLng(t),this._map&&this.update(),!0},_updateContent:function(){if(this._content){var t=this._contentNode,i="function"==typeof this._content?this._content(this._source||this):this._content;if("string"==typeof i)t.innerHTML=i;else{for(;t.hasChildNodes();)t.removeChild(t.firstChild);t.appendChild(i)}this.fire("contentupdate")}},_updatePosition:function(){var t,i,e;this._map&&(i=this._map.latLngToLayerPoint(this._latlng),t=_(this.options.offset),e=this._getAnchor(),this._zoomAnimated?Z(this._container,i.add(e)):t=t.add(i).add(e),i=this._containerBottom=-t.y,e=this._containerLeft=-Math.round(this._containerWidth/2)+t.x,this._container.style.bottom=i+"px",this._container.style.left=e+"px")},_getAnchor:function(){return[0,0]}}),ke=(A.include({_initOverlay:function(t,i,e,n){var o=i;return o instanceof t||(o=new t(n).setContent(i)),e&&o.setLatLng(e),o}}),o.include({_initOverlay:function(t,i,e,n){var o=e;return o instanceof t?(c(o,n),o._source=this):(o=i&&!n?i:new t(n,this)).setContent(e),o}}),O.extend({options:{pane:"popupPane",offset:[0,7],maxWidth:300,minWidth:50,maxHeight:null,autoPan:!0,autoPanPaddingTopLeft:null,autoPanPaddingBottomRight:null,autoPanPadding:[5,5],keepInView:!1,closeButton:!0,autoClose:!0,closeOnEscapeKey:!0,className:""},openOn:function(t){return!(t=arguments.length?t:this._source._map).hasLayer(this)&&t._popup&&t._popup.options.autoClose&&t.removeLayer(t._popup),t._popup=this,O.prototype.openOn.call(this,t)},onAdd:function(t){O.prototype.onAdd.call(this,t),t.fire("popupopen",{popup:this}),this._source&&(this._source.fire("popupopen",{popup:this},!0),this._source instanceof _e||this._source.on("preclick",Ai))},onRemove:function(t){O.prototype.onRemove.call(this,t),t.fire("popupclose",{popup:this}),this._source&&(this._source.fire("popupclose",{popup:this},!0),this._source instanceof _e||this._source.off("preclick",Ai))},getEvents:function(){var t=O.prototype.getEvents.call(this);return(void 0!==this.options.closeOnClick?this.options.closeOnClick:this._map.options.closePopupOnClick)&&(t.preclick=this.close),this.options.keepInView&&(t.moveend=this._adjustPan),t},_initLayout:function(){var t="leaflet-popup",i=this._container=b("div",t+" "+(this.options.className||"")+" leaflet-zoom-animated"),e=this._wrapper=b("div",t+"-content-wrapper",i);this._contentNode=b("div",t+"-content",e),Oi(i),Ii(this._contentNode),S(i,"contextmenu",Ai),this._tipContainer=b("div",t+"-tip-container",i),this._tip=b("div",t+"-tip",this._tipContainer),this.options.closeButton&&((e=this._closeButton=b("a",t+"-close-button",i)).setAttribute("role","button"),e.setAttribute("aria-label","Close popup"),e.href="#close",e.innerHTML='<span aria-hidden="true">&#215;</span>',S(e,"click",this.close,this))},_updateLayout:function(){var t=this._contentNode,i=t.style,e=(i.width="",i.whiteSpace="nowrap",t.offsetWidth),e=Math.min(e,this.options.maxWidth),e=(e=Math.max(e,this.options.minWidth),i.width=e+1+"px",i.whiteSpace="",i.height="",t.offsetHeight),n=this.options.maxHeight,o="leaflet-popup-scrolled";n&&n<e?(i.height=n+"px",z(t,o)):M(t,o),this._containerWidth=this._container.offsetWidth},_animateZoom:function(t){var t=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center),i=this._getAnchor();Z(this._container,t.add(i))},_adjustPan:function(t){var i,e,n,o,s,r,a,h;this.options.autoPan&&(this._map._panAnim&&this._map._panAnim.stop(),i=this._map,e=parseInt(pi(this._container,"marginBottom"),10)||0,e=this._container.offsetHeight+e,h=this._containerWidth,(n=new p(this._containerLeft,-e-this._containerBottom))._add(bi(this._container)),n=i.layerPointToContainerPoint(n),s=_(this.options.autoPanPadding),o=_(this.options.autoPanPaddingTopLeft||s),s=_(this.options.autoPanPaddingBottomRight||s),r=i.getSize(),a=0,n.x+h+s.x>r.x&&(a=n.x+h-r.x+s.x),n.x-a-o.x<(h=0)&&(a=n.x-o.x),n.y+e+s.y>r.y&&(h=n.y+e-r.y+s.y),n.y-h-o.y<0&&(h=n.y-o.y),(a||h)&&i.fire("autopanstart").panBy([a,h],{animate:t&&"moveend"===t.type}))},_getAnchor:function(){return _(this._source&&this._source._getPopupAnchor?this._source._getPopupAnchor():[0,0])}})),Ee=(A.mergeOptions({closePopupOnClick:!0}),A.include({openPopup:function(t,i,e){return this._initOverlay(ke,t,i,e).openOn(this),this},closePopup:function(t){return(t=arguments.length?t:this._popup)&&t.close(),this}}),o.include({bindPopup:function(t,i){return this._popup=this._initOverlay(ke,this._popup,t,i),this._popupHandlersAdded||(this.on({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!0),this},unbindPopup:function(){return this._popup&&(this.off({click:this._openPopup,keypress:this._onKeyPress,remove:this.closePopup,move:this._movePopup}),this._popupHandlersAdded=!1,this._popup=null),this},openPopup:function(t){return this._popup&&this._popup._prepareOpen(t)&&this._popup.openOn(this._map),this},closePopup:function(){return this._popup&&this._popup.close(),this},togglePopup:function(){return this._popup&&this._popup.toggle(this),this},isPopupOpen:function(){return!!this._popup&&this._popup.isOpen()},setPopupContent:function(t){return this._popup&&this._popup.setContent(t),this},getPopup:function(){return this._popup},_openPopup:function(t){var i;this._popup&&this._map&&(Ri(t),i=t.layer||t.target,this._popup._source!==i||i instanceof _e?(this._popup._source=i,this.openPopup(t.latlng)):this._map.hasLayer(this._popup)?this.closePopup():this.openPopup(t.latlng))},_movePopup:function(t){this._popup.setLatLng(t.latlng)},_onKeyPress:function(t){13===t.originalEvent.keyCode&&this._openPopup(t)}}),O.extend({options:{pane:"tooltipPane",offset:[0,0],direction:"auto",permanent:!1,sticky:!1,opacity:.9},onAdd:function(t){O.prototype.onAdd.call(this,t),this.setOpacity(this.options.opacity),t.fire("tooltipopen",{tooltip:this}),this._source&&(this.addEventParent(this._source),this._source.fire("tooltipopen",{tooltip:this},!0))},onRemove:function(t){O.prototype.onRemove.call(this,t),t.fire("tooltipclose",{tooltip:this}),this._source&&(this.removeEventParent(this._source),this._source.fire("tooltipclose",{tooltip:this},!0))},getEvents:function(){var t=O.prototype.getEvents.call(this);return this.options.permanent||(t.preclick=this.close),t},_initLayout:function(){var t="leaflet-tooltip "+(this.options.className||"")+" leaflet-zoom-"+(this._zoomAnimated?"animated":"hide");this._contentNode=this._container=b("div",t)},_updateLayout:function(){},_adjustPan:function(){},_setPosition:function(t){var i,e=this._map,n=this._container,o=e.latLngToContainerPoint(e.getCenter()),e=e.layerPointToContainerPoint(t),s=this.options.direction,r=n.offsetWidth,a=n.offsetHeight,h=_(this.options.offset),l=this._getAnchor(),e="top"===s?(i=r/2,a):"bottom"===s?(i=r/2,0):(i="center"===s?r/2:"right"===s?0:"left"===s?r:e.x<o.x?(s="right",0):(s="left",r+2*(h.x+l.x)),a/2);t=t.subtract(_(i,e,!0)).add(h).add(l),M(n,"leaflet-tooltip-right"),M(n,"leaflet-tooltip-left"),M(n,"leaflet-tooltip-top"),M(n,"leaflet-tooltip-bottom"),z(n,"leaflet-tooltip-"+s),Z(n,t)},_updatePosition:function(){var t=this._map.latLngToLayerPoint(this._latlng);this._setPosition(t)},setOpacity:function(t){this.options.opacity=t,this._container&&C(this._container,t)},_animateZoom:function(t){t=this._map._latLngToNewLayerPoint(this._latlng,t.zoom,t.center);this._setPosition(t)},_getAnchor:function(){return _(this._source&&this._source._getTooltipAnchor&&!this.options.sticky?this._source._getTooltipAnchor():[0,0])}})),Be=(A.include({openTooltip:function(t,i,e){return this._initOverlay(Ee,t,i,e).openOn(this),this},closeTooltip:function(t){return t.close(),this}}),o.include({bindTooltip:function(t,i){return this._tooltip&&this.isTooltipOpen()&&this.unbindTooltip(),this._tooltip=this._initOverlay(Ee,this._tooltip,t,i),this._initTooltipInteractions(),this._tooltip.options.permanent&&this._map&&this._map.hasLayer(this)&&this.openTooltip(),this},unbindTooltip:function(){return this._tooltip&&(this._initTooltipInteractions(!0),this.closeTooltip(),this._tooltip=null),this},_initTooltipInteractions:function(t){var i,e;!t&&this._tooltipHandlersAdded||(i=t?"off":"on",e={remove:this.closeTooltip,move:this._moveTooltip},this._tooltip.options.permanent?e.add=this._openTooltip:(e.mouseover=this._openTooltip,e.mouseout=this.closeTooltip,e.click=this._openTooltip),this._tooltip.options.sticky&&(e.mousemove=this._moveTooltip),this[i](e),this._tooltipHandlersAdded=!t)},openTooltip:function(t){return this._tooltip&&this._tooltip._prepareOpen(t)&&this._tooltip.openOn(this._map),this},closeTooltip:function(){if(this._tooltip)return this._tooltip.close()},toggleTooltip:function(){return this._tooltip&&this._tooltip.toggle(this),this},isTooltipOpen:function(){return this._tooltip.isOpen()},setTooltipContent:function(t){return this._tooltip&&this._tooltip.setContent(t),this},getTooltip:function(){return this._tooltip},_openTooltip:function(t){!this._tooltip||!this._map||this._map.dragging&&this._map.dragging.moving()||(this._tooltip._source=t.layer||t.target,this.openTooltip(this._tooltip.options.sticky?t.latlng:void 0))},_moveTooltip:function(t){var i=t.latlng;this._tooltip.options.sticky&&t.originalEvent&&(t=this._map.mouseEventToContainerPoint(t.originalEvent),t=this._map.containerPointToLayerPoint(t),i=this._map.layerPointToLatLng(t)),this._tooltip.setLatLng(i)}}),le.extend({options:{iconSize:[12,12],html:!1,bgPos:null,className:"leaflet-div-icon"},createIcon:function(t){var t=t&&"DIV"===t.tagName?t:document.createElement("div"),i=this.options;return i.html instanceof Element?(mi(t),t.appendChild(i.html)):t.innerHTML=!1!==i.html?i.html:"",i.bgPos&&(i=_(i.bgPos),t.style.backgroundPosition=-i.x+"px "+-i.y+"px"),this._setIconStyles(t,"icon"),t},createShadow:function(){return null}}));le.Default=ue;var Ae=o.extend({options:{tileSize:256,opacity:1,updateWhenIdle:P.mobile,updateWhenZooming:!0,updateInterval:200,zIndex:1,bounds:null,minZoom:0,maxZoom:void 0,maxNativeZoom:void 0,minNativeZoom:void 0,noWrap:!1,pane:"tilePane",className:"",keepBuffer:2},initialize:function(t){c(this,t)},onAdd:function(){this._initContainer(),this._levels={},this._tiles={},this._resetView()},beforeAdd:function(t){t._addZoomLimit(this)},onRemove:function(t){this._removeAllTiles(),T(this._container),t._removeZoomLimit(this),this._container=null,this._tileZoom=void 0},bringToFront:function(){return this._map&&(fi(this._container),this._setAutoZIndex(Math.max)),this},bringToBack:function(){return this._map&&(gi(this._container),this._setAutoZIndex(Math.min)),this},getContainer:function(){return this._container},setOpacity:function(t){return this.options.opacity=t,this._updateOpacity(),this},setZIndex:function(t){return this.options.zIndex=t,this._updateZIndex(),this},isLoading:function(){return this._loading},redraw:function(){var t;return this._map&&(this._removeAllTiles(),(t=this._clampZoom(this._map.getZoom()))!==this._tileZoom&&(this._tileZoom=t,this._updateLevels()),this._update()),this},getEvents:function(){var t={viewprereset:this._invalidateAll,viewreset:this._resetView,zoom:this._resetView,moveend:this._onMoveEnd};return this.options.updateWhenIdle||(this._onMove||(this._onMove=j(this._onMoveEnd,this.options.updateInterval,this)),t.move=this._onMove),this._zoomAnimated&&(t.zoomanim=this._animateZoom),t},createTile:function(){return document.createElement("div")},getTileSize:function(){var t=this.options.tileSize;return t instanceof p?t:new p(t,t)},_updateZIndex:function(){this._container&&void 0!==this.options.zIndex&&null!==this.options.zIndex&&(this._container.style.zIndex=this.options.zIndex)},_setAutoZIndex:function(t){for(var i,e=this.getPane().children,n=-t(-1/0,1/0),o=0,s=e.length;o<s;o++)i=e[o].style.zIndex,e[o]!==this._container&&i&&(n=t(n,+i));isFinite(n)&&(this.options.zIndex=n+t(-1,1),this._updateZIndex())},_updateOpacity:function(){if(this._map&&!P.ielt9){C(this._container,this.options.opacity);var t,i=+new Date,e=!1,n=!1;for(t in this._tiles){var o,s=this._tiles[t];s.current&&s.loaded&&(o=Math.min(1,(i-s.loaded)/200),C(s.el,o),o<1?e=!0:(s.active?n=!0:this._onOpaqueTile(s),s.active=!0))}n&&!this._noPrune&&this._pruneTiles(),e&&(r(this._fadeFrame),this._fadeFrame=x(this._updateOpacity,this))}},_onOpaqueTile:u,_initContainer:function(){this._container||(this._container=b("div","leaflet-layer "+(this.options.className||"")),this._updateZIndex(),this.options.opacity<1&&this._updateOpacity(),this.getPane().appendChild(this._container))},_updateLevels:function(){var t=this._tileZoom,i=this.options.maxZoom;if(void 0!==t){for(var e in this._levels)e=Number(e),this._levels[e].el.children.length||e===t?(this._levels[e].el.style.zIndex=i-Math.abs(t-e),this._onUpdateLevel(e)):(T(this._levels[e].el),this._removeTilesAtZoom(e),this._onRemoveLevel(e),delete this._levels[e]);var n=this._levels[t],o=this._map;return n||((n=this._levels[t]={}).el=b("div","leaflet-tile-container leaflet-zoom-animated",this._container),n.el.style.zIndex=i,n.origin=o.project(o.unproject(o.getPixelOrigin()),t).round(),n.zoom=t,this._setZoomTransform(n,o.getCenter(),o.getZoom()),u(n.el.offsetWidth),this._onCreateLevel(n)),this._level=n}},_onUpdateLevel:u,_onRemoveLevel:u,_onCreateLevel:u,_pruneTiles:function(){if(this._map){var t,i,e,n=this._map.getZoom();if(n>this.options.maxZoom||n<this.options.minZoom)this._removeAllTiles();else{for(t in this._tiles)(e=this._tiles[t]).retain=e.current;for(t in this._tiles)(e=this._tiles[t]).current&&!e.active&&(i=e.coords,this._retainParent(i.x,i.y,i.z,i.z-5)||this._retainChildren(i.x,i.y,i.z,i.z+2));for(t in this._tiles)this._tiles[t].retain||this._removeTile(t)}}},_removeTilesAtZoom:function(t){for(var i in this._tiles)this._tiles[i].coords.z===t&&this._removeTile(i)},_removeAllTiles:function(){for(var t in this._tiles)this._removeTile(t)},_invalidateAll:function(){for(var t in this._levels)T(this._levels[t].el),this._onRemoveLevel(Number(t)),delete this._levels[t];this._removeAllTiles(),this._tileZoom=void 0},_retainParent:function(t,i,e,n){var t=Math.floor(t/2),i=Math.floor(i/2),e=e-1,o=new p(+t,+i),o=(o.z=e,this._tileCoordsToKey(o)),o=this._tiles[o];return o&&o.active?o.retain=!0:(o&&o.loaded&&(o.retain=!0),n<e&&this._retainParent(t,i,e,n))},_retainChildren:function(t,i,e,n){for(var o=2*t;o<2*t+2;o++)for(var s=2*i;s<2*i+2;s++){var r=new p(o,s),r=(r.z=e+1,this._tileCoordsToKey(r)),r=this._tiles[r];r&&r.active?r.retain=!0:(r&&r.loaded&&(r.retain=!0),e+1<n&&this._retainChildren(o,s,e+1,n))}},_resetView:function(t){t=t&&(t.pinch||t.flyTo);this._setView(this._map.getCenter(),this._map.getZoom(),t,t)},_animateZoom:function(t){this._setView(t.center,t.zoom,!0,t.noUpdate)},_clampZoom:function(t){var i=this.options;return void 0!==i.minNativeZoom&&t<i.minNativeZoom?i.minNativeZoom:void 0!==i.maxNativeZoom&&i.maxNativeZoom<t?i.maxNativeZoom:t},_setView:function(t,i,e,n){var o=Math.round(i),o=void 0!==this.options.maxZoom&&o>this.options.maxZoom||void 0!==this.options.minZoom&&o<this.options.minZoom?void 0:this._clampZoom(o),s=this.options.updateWhenZooming&&o!==this._tileZoom;n&&!s||(this._tileZoom=o,this._abortLoading&&this._abortLoading(),this._updateLevels(),this._resetGrid(),void 0!==o&&this._update(t),e||this._pruneTiles(),this._noPrune=!!e),this._setZoomTransforms(t,i)},_setZoomTransforms:function(t,i){for(var e in this._levels)this._setZoomTransform(this._levels[e],t,i)},_setZoomTransform:function(t,i,e){var n=this._map.getZoomScale(e,t.zoom),i=t.origin.multiplyBy(n).subtract(this._map._getNewPixelOrigin(i,e)).round();P.any3d?Pi(t.el,i,n):Z(t.el,i)},_resetGrid:function(){var t=this._map,i=t.options.crs,e=this._tileSize=this.getTileSize(),n=this._tileZoom,o=this._map.getPixelWorldBounds(this._tileZoom);o&&(this._globalTileRange=this._pxBoundsToTileRange(o)),this._wrapX=i.wrapLng&&!this.options.noWrap&&[Math.floor(t.project([0,i.wrapLng[0]],n).x/e.x),Math.ceil(t.project([0,i.wrapLng[1]],n).x/e.y)],this._wrapY=i.wrapLat&&!this.options.noWrap&&[Math.floor(t.project([i.wrapLat[0],0],n).y/e.x),Math.ceil(t.project([i.wrapLat[1],0],n).y/e.y)]},_onMoveEnd:function(){this._map&&!this._map._animatingZoom&&this._update()},_getTiledPixelBounds:function(t){var i=this._map,e=i._animatingZoom?Math.max(i._animateToZoom,i.getZoom()):i.getZoom(),e=i.getZoomScale(e,this._tileZoom),t=i.project(t,this._tileZoom).floor(),i=i.getSize().divideBy(2*e);return new m(t.subtract(i),t.add(i))},_update:function(t){var i=this._map;if(i){var e=this._clampZoom(i.getZoom());if(void 0===t&&(t=i.getCenter()),void 0!==this._tileZoom){var n,i=this._getTiledPixelBounds(t),o=this._pxBoundsToTileRange(i),s=o.getCenter(),r=[],i=this.options.keepBuffer,a=new m(o.getBottomLeft().subtract([i,-i]),o.getTopRight().add([i,-i]));if(!(isFinite(o.min.x)&&isFinite(o.min.y)&&isFinite(o.max.x)&&isFinite(o.max.y)))throw new Error("Attempted to load an infinite number of tiles");for(n in this._tiles){var h=this._tiles[n].coords;h.z===this._tileZoom&&a.contains(new p(h.x,h.y))||(this._tiles[n].current=!1)}if(1<Math.abs(e-this._tileZoom))this._setView(t,e);else{for(var l=o.min.y;l<=o.max.y;l++)for(var u=o.min.x;u<=o.max.x;u++){var c,d=new p(u,l);d.z=this._tileZoom,this._isValidTile(d)&&((c=this._tiles[this._tileCoordsToKey(d)])?c.current=!0:r.push(d))}if(r.sort(function(t,i){return t.distanceTo(s)-i.distanceTo(s)}),0!==r.length){this._loading||(this._loading=!0,this.fire("loading"));for(var _=document.createDocumentFragment(),u=0;u<r.length;u++)this._addTile(r[u],_);this._level.el.appendChild(_)}}}}},_isValidTile:function(t){var i=this._map.options.crs;if(!i.infinite){var e=this._globalTileRange;if(!i.wrapLng&&(t.x<e.min.x||t.x>e.max.x)||!i.wrapLat&&(t.y<e.min.y||t.y>e.max.y))return!1}if(!this.options.bounds)return!0;i=this._tileCoordsToBounds(t);return g(this.options.bounds).overlaps(i)},_keyToBounds:function(t){return this._tileCoordsToBounds(this._keyToTileCoords(t))},_tileCoordsToNwSe:function(t){var i=this._map,e=this.getTileSize(),n=t.scaleBy(e),e=n.add(e);return[i.unproject(n,t.z),i.unproject(e,t.z)]},_tileCoordsToBounds:function(t){t=this._tileCoordsToNwSe(t),t=new s(t[0],t[1]);return t=this.options.noWrap?t:this._map.wrapLatLngBounds(t)},_tileCoordsToKey:function(t){return t.x+":"+t.y+":"+t.z},_keyToTileCoords:function(t){var t=t.split(":"),i=new p(+t[0],+t[1]);return i.z=+t[2],i},_removeTile:function(t){var i=this._tiles[t];i&&(T(i.el),delete this._tiles[t],this.fire("tileunload",{tile:i.el,coords:this._keyToTileCoords(t)}))},_initTile:function(t){z(t,"leaflet-tile");var i=this.getTileSize();t.style.width=i.x+"px",t.style.height=i.y+"px",t.onselectstart=u,t.onmousemove=u,P.ielt9&&this.options.opacity<1&&C(t,this.options.opacity)},_addTile:function(t,i){var e=this._getTilePos(t),n=this._tileCoordsToKey(t),o=this.createTile(this._wrapCoords(t),a(this._tileReady,this,t));this._initTile(o),this.createTile.length<2&&x(a(this._tileReady,this,t,null,o)),Z(o,e),this._tiles[n]={el:o,coords:t,current:!0},i.appendChild(o),this.fire("tileloadstart",{tile:o,coords:t})},_tileReady:function(t,i,e){i&&this.fire("tileerror",{error:i,tile:e,coords:t});var n=this._tileCoordsToKey(t);(e=this._tiles[n])&&(e.loaded=+new Date,this._map._fadeAnimated?(C(e.el,0),r(this._fadeFrame),this._fadeFrame=x(this._updateOpacity,this)):(e.active=!0,this._pruneTiles()),i||(z(e.el,"leaflet-tile-loaded"),this.fire("tileload",{tile:e.el,coords:t})),this._noTilesToLoad()&&(this._loading=!1,this.fire("load"),P.ielt9||!this._map._fadeAnimated?x(this._pruneTiles,this):setTimeout(a(this._pruneTiles,this),250)))},_getTilePos:function(t){return t.scaleBy(this.getTileSize()).subtract(this._level.origin)},_wrapCoords:function(t){var i=new p(this._wrapX?H(t.x,this._wrapX):t.x,this._wrapY?H(t.y,this._wrapY):t.y);return i.z=t.z,i},_pxBoundsToTileRange:function(t){var i=this.getTileSize();return new m(t.min.unscaleBy(i).floor(),t.max.unscaleBy(i).ceil().subtract([1,1]))},_noTilesToLoad:function(){for(var t in this._tiles)if(!this._tiles[t].loaded)return!1;return!0}});var Ie=Ae.extend({options:{minZoom:0,maxZoom:18,subdomains:"abc",errorTileUrl:"",zoomOffset:0,tms:!1,zoomReverse:!1,detectRetina:!1,crossOrigin:!1,referrerPolicy:!1},initialize:function(t,i){this._url=t,(i=c(this,i)).detectRetina&&P.retina&&0<i.maxZoom&&(i.tileSize=Math.floor(i.tileSize/2),i.zoomReverse?(i.zoomOffset--,i.minZoom++):(i.zoomOffset++,i.maxZoom--),i.minZoom=Math.max(0,i.minZoom)),"string"==typeof i.subdomains&&(i.subdomains=i.subdomains.split("")),this.on("tileunload",this._onTileRemove)},setUrl:function(t,i){return this._url===t&&void 0===i&&(i=!0),this._url=t,i||this.redraw(),this},createTile:function(t,i){var e=document.createElement("img");return S(e,"load",a(this._tileOnLoad,this,i,e)),S(e,"error",a(this._tileOnError,this,i,e)),!this.options.crossOrigin&&""!==this.options.crossOrigin||(e.crossOrigin=!0===this.options.crossOrigin?"":this.options.crossOrigin),"string"==typeof this.options.referrerPolicy&&(e.referrerPolicy=this.options.referrerPolicy),e.alt="",e.setAttribute("role","presentation"),e.src=this.getTileUrl(t),e},getTileUrl:function(t){var i={r:P.retina?"@2x":"",s:this._getSubdomain(t),x:t.x,y:t.y,z:this._getZoomForUrl()};return this._map&&!this._map.options.crs.infinite&&(t=this._globalTileRange.max.y-t.y,this.options.tms&&(i.y=t),i["-y"]=t),q(this._url,l(i,this.options))},_tileOnLoad:function(t,i){P.ielt9?setTimeout(a(t,this,null,i),0):t(null,i)},_tileOnError:function(t,i,e){var n=this.options.errorTileUrl;n&&i.getAttribute("src")!==n&&(i.src=n),t(e,i)},_onTileRemove:function(t){t.tile.onload=null},_getZoomForUrl:function(){var t=this._tileZoom,i=this.options.maxZoom;return(t=this.options.zoomReverse?i-t:t)+this.options.zoomOffset},_getSubdomain:function(t){t=Math.abs(t.x+t.y)%this.options.subdomains.length;return this.options.subdomains[t]},_abortLoading:function(){var t,i,e;for(t in this._tiles)this._tiles[t].coords.z!==this._tileZoom&&((e=this._tiles[t].el).onload=u,e.onerror=u,e.complete||(e.src=K,i=this._tiles[t].coords,T(e),delete this._tiles[t],this.fire("tileabort",{tile:e,coords:i})))},_removeTile:function(t){var i=this._tiles[t];if(i)return i.el.setAttribute("src",K),Ae.prototype._removeTile.call(this,t)},_tileReady:function(t,i,e){if(this._map&&(!e||e.getAttribute("src")!==K))return Ae.prototype._tileReady.call(this,t,i,e)}});function Oe(t,i){return new Ie(t,i)}var Re=Ie.extend({defaultWmsParams:{service:"WMS",request:"GetMap",layers:"",styles:"",format:"image/jpeg",transparent:!1,version:"1.1.1"},options:{crs:null,uppercase:!1},initialize:function(t,i){this._url=t;var e,n=l({},this.defaultWmsParams);for(e in i)e in this.options||(n[e]=i[e]);var t=(i=c(this,i)).detectRetina&&P.retina?2:1,o=this.getTileSize();n.width=o.x*t,n.height=o.y*t,this.wmsParams=n},onAdd:function(t){this._crs=this.options.crs||t.options.crs,this._wmsVersion=parseFloat(this.wmsParams.version);var i=1.3<=this._wmsVersion?"crs":"srs";this.wmsParams[i]=this._crs.code,Ie.prototype.onAdd.call(this,t)},getTileUrl:function(t){var i=this._tileCoordsToNwSe(t),e=this._crs,e=f(e.project(i[0]),e.project(i[1])),i=e.min,e=e.max,i=(1.3<=this._wmsVersion&&this._crs===re?[i.y,i.x,e.y,e.x]:[i.x,i.y,e.x,e.y]).join(","),e=Ie.prototype.getTileUrl.call(this,t);return e+U(this.wmsParams,e,this.options.uppercase)+(this.options.uppercase?"&BBOX=":"&bbox=")+i},setParams:function(t,i){return l(this.wmsParams,t),i||this.redraw(),this}});Ie.WMS=Re,Oe.wms=function(t,i){return new Re(t,i)};var Ne=o.extend({options:{padding:.1},initialize:function(t){c(this,t),h(this),this._layers=this._layers||{}},onAdd:function(){this._container||(this._initContainer(),this._zoomAnimated&&z(this._container,"leaflet-zoom-animated")),this.getPane().appendChild(this._container),this._update(),this.on("update",this._updatePaths,this)},onRemove:function(){this.off("update",this._updatePaths,this),this._destroyContainer()},getEvents:function(){var t={viewreset:this._reset,zoom:this._onZoom,moveend:this._update,zoomend:this._onZoomEnd};return this._zoomAnimated&&(t.zoomanim=this._onAnimZoom),t},_onAnimZoom:function(t){this._updateTransform(t.center,t.zoom)},_onZoom:function(){this._updateTransform(this._map.getCenter(),this._map.getZoom())},_updateTransform:function(t,i){var e=this._map.getZoomScale(i,this._zoom),n=this._map.getSize().multiplyBy(.5+this.options.padding),o=this._map.project(this._center,i),n=n.multiplyBy(-e).add(o).subtract(this._map._getNewPixelOrigin(t,i));P.any3d?Pi(this._container,n,e):Z(this._container,n)},_reset:function(){for(var t in this._update(),this._updateTransform(this._center,this._zoom),this._layers)this._layers[t]._reset()},_onZoomEnd:function(){for(var t in this._layers)this._layers[t]._project()},_updatePaths:function(){for(var t in this._layers)this._layers[t]._update()},_update:function(){var t=this.options.padding,i=this._map.getSize(),e=this._map.containerPointToLayerPoint(i.multiplyBy(-t)).round();this._bounds=new m(e,e.add(i.multiplyBy(1+2*t)).round()),this._center=this._map.getCenter(),this._zoom=this._map.getZoom()}}),De=Ne.extend({options:{tolerance:0},getEvents:function(){var t=Ne.prototype.getEvents.call(this);return t.viewprereset=this._onViewPreReset,t},_onViewPreReset:function(){this._postponeUpdatePaths=!0},onAdd:function(){Ne.prototype.onAdd.call(this),this._draw()},_initContainer:function(){var t=this._container=document.createElement("canvas");S(t,"mousemove",this._onMouseMove,this),S(t,"click dblclick mousedown mouseup contextmenu",this._onClick,this),S(t,"mouseout",this._handleMouseOut,this),t._leaflet_disable_events=!0,this._ctx=t.getContext("2d")},_destroyContainer:function(){r(this._redrawRequest),delete this._ctx,T(this._container),E(this._container),delete this._container},_updatePaths:function(){if(!this._postponeUpdatePaths){for(var t in this._redrawBounds=null,this._layers)this._layers[t]._update();this._redraw()}},_update:function(){var t,i,e,n;this._map._animatingZoom&&this._bounds||(Ne.prototype._update.call(this),t=this._bounds,i=this._container,e=t.getSize(),n=P.retina?2:1,Z(i,t.min),i.width=n*e.x,i.height=n*e.y,i.style.width=e.x+"px",i.style.height=e.y+"px",P.retina&&this._ctx.scale(2,2),this._ctx.translate(-t.min.x,-t.min.y),this.fire("update"))},_reset:function(){Ne.prototype._reset.call(this),this._postponeUpdatePaths&&(this._postponeUpdatePaths=!1,this._updatePaths())},_initPath:function(t){this._updateDashArray(t);t=(this._layers[h(t)]=t)._order={layer:t,prev:this._drawLast,next:null};this._drawLast&&(this._drawLast.next=t),this._drawLast=t,this._drawFirst=this._drawFirst||this._drawLast},_addPath:function(t){this._requestRedraw(t)},_removePath:function(t){var i=t._order,e=i.next,i=i.prev;e?e.prev=i:this._drawLast=i,i?i.next=e:this._drawFirst=e,delete t._order,delete this._layers[h(t)],this._requestRedraw(t)},_updatePath:function(t){this._extendRedrawBounds(t),t._project(),t._update(),this._requestRedraw(t)},_updateStyle:function(t){this._updateDashArray(t),this._requestRedraw(t)},_updateDashArray:function(t){if("string"==typeof t.options.dashArray){for(var i,e=t.options.dashArray.split(/[, ]+/),n=[],o=0;o<e.length;o++){if(i=Number(e[o]),isNaN(i))return;n.push(i)}t.options._dashArray=n}else t.options._dashArray=t.options.dashArray},_requestRedraw:function(t){this._map&&(this._extendRedrawBounds(t),this._redrawRequest=this._redrawRequest||x(this._redraw,this))},_extendRedrawBounds:function(t){var i;t._pxBounds&&(i=(t.options.weight||0)+1,this._redrawBounds=this._redrawBounds||new m,this._redrawBounds.extend(t._pxBounds.min.subtract([i,i])),this._redrawBounds.extend(t._pxBounds.max.add([i,i])))},_redraw:function(){this._redrawRequest=null,this._redrawBounds&&(this._redrawBounds.min._floor(),this._redrawBounds.max._ceil()),this._clear(),this._draw(),this._redrawBounds=null},_clear:function(){var t,i=this._redrawBounds;i?(t=i.getSize(),this._ctx.clearRect(i.min.x,i.min.y,t.x,t.y)):(this._ctx.save(),this._ctx.setTransform(1,0,0,1,0,0),this._ctx.clearRect(0,0,this._container.width,this._container.height),this._ctx.restore())},_draw:function(){var t,i,e=this._redrawBounds;this._ctx.save(),e&&(i=e.getSize(),this._ctx.beginPath(),this._ctx.rect(e.min.x,e.min.y,i.x,i.y),this._ctx.clip()),this._drawing=!0;for(var n=this._drawFirst;n;n=n.next)t=n.layer,(!e||t._pxBounds&&t._pxBounds.intersects(e))&&t._updatePath();this._drawing=!1,this._ctx.restore()},_updatePoly:function(t,i){if(this._drawing){var e,n,o,s,r=t._parts,a=r.length,h=this._ctx;if(a){for(h.beginPath(),e=0;e<a;e++){for(n=0,o=r[e].length;n<o;n++)s=r[e][n],h[n?"lineTo":"moveTo"](s.x,s.y);i&&h.closePath()}this._fillStroke(h,t)}}},_updateCircle:function(t){var i,e,n,o;this._drawing&&!t._empty()&&(i=t._point,e=this._ctx,n=Math.max(Math.round(t._radius),1),1!=(o=(Math.max(Math.round(t._radiusY),1)||n)/n)&&(e.save(),e.scale(1,o)),e.beginPath(),e.arc(i.x,i.y/o,n,0,2*Math.PI,!1),1!=o&&e.restore(),this._fillStroke(e,t))},_fillStroke:function(t,i){var e=i.options;e.fill&&(t.globalAlpha=e.fillOpacity,t.fillStyle=e.fillColor||e.color,t.fill(e.fillRule||"evenodd")),e.stroke&&0!==e.weight&&(t.setLineDash&&t.setLineDash(i.options&&i.options._dashArray||[]),t.globalAlpha=e.opacity,t.lineWidth=e.weight,t.strokeStyle=e.color,t.lineCap=e.lineCap,t.lineJoin=e.lineJoin,t.stroke())},_onClick:function(t){for(var i,e,n=this._map.mouseEventToLayerPoint(t),o=this._drawFirst;o;o=o.next)(i=o.layer).options.interactive&&i._containsPoint(n)&&(("click"===t.type||"preclick"===t.type)&&this._map._draggableMoved(i)||(e=i));this._fireEvent(!!e&&[e],t)},_onMouseMove:function(t){var i;!this._map||this._map.dragging.moving()||this._map._animatingZoom||(i=this._map.mouseEventToLayerPoint(t),this._handleMouseHover(t,i))},_handleMouseOut:function(t){var i=this._hoveredLayer;i&&(M(this._container,"leaflet-interactive"),this._fireEvent([i],t,"mouseout"),this._hoveredLayer=null,this._mouseHoverThrottled=!1)},_handleMouseHover:function(t,i){if(!this._mouseHoverThrottled){for(var e,n,o=this._drawFirst;o;o=o.next)(e=o.layer).options.interactive&&e._containsPoint(i)&&(n=e);n!==this._hoveredLayer&&(this._handleMouseOut(t),n&&(z(this._container,"leaflet-interactive"),this._fireEvent([n],t,"mouseover"),this._hoveredLayer=n)),this._fireEvent(!!this._hoveredLayer&&[this._hoveredLayer],t),this._mouseHoverThrottled=!0,setTimeout(a(function(){this._mouseHoverThrottled=!1},this),32)}},_fireEvent:function(t,i,e){this._map._fireDOMEvent(i,e||i.type,t)},_bringToFront:function(t){var i,e,n=t._order;n&&(i=n.next,e=n.prev,i&&((i.prev=e)?e.next=i:i&&(this._drawFirst=i),n.prev=this._drawLast,(this._drawLast.next=n).next=null,this._drawLast=n,this._requestRedraw(t)))},_bringToBack:function(t){var i,e,n=t._order;n&&(i=n.next,(e=n.prev)&&((e.next=i)?i.prev=e:e&&(this._drawLast=e),n.prev=null,n.next=this._drawFirst,this._drawFirst.prev=n,this._drawFirst=n,this._requestRedraw(t)))}});function je(t){return P.canvas?new De(t):null}var He=function(){try{return document.namespaces.add("lvml","urn:schemas-microsoft-com:vml"),function(t){return document.createElement("<lvml:"+t+' class="lvml">')}}catch(t){}return function(t){return document.createElement("<"+t+' xmlns="urn:schemas-microsoft.com:vml" class="lvml">')}}(),Mt={_initContainer:function(){this._container=b("div","leaflet-vml-container")},_update:function(){this._map._animatingZoom||(Ne.prototype._update.call(this),this.fire("update"))},_initPath:function(t){var i=t._container=He("shape");z(i,"leaflet-vml-shape "+(this.options.className||"")),i.coordsize="1 1",t._path=He("path"),i.appendChild(t._path),this._updateStyle(t),this._layers[h(t)]=t},_addPath:function(t){var i=t._container;this._container.appendChild(i),t.options.interactive&&t.addInteractiveTarget(i)},_removePath:function(t){var i=t._container;T(i),t.removeInteractiveTarget(i),delete this._layers[h(t)]},_updateStyle:function(t){var i=t._stroke,e=t._fill,n=t.options,o=t._container;o.stroked=!!n.stroke,o.filled=!!n.fill,n.stroke?(i=i||(t._stroke=He("stroke")),o.appendChild(i),i.weight=n.weight+"px",i.color=n.color,i.opacity=n.opacity,n.dashArray?i.dashStyle=d(n.dashArray)?n.dashArray.join(" "):n.dashArray.replace(/( *, *)/g," "):i.dashStyle="",i.endcap=n.lineCap.replace("butt","flat"),i.joinstyle=n.lineJoin):i&&(o.removeChild(i),t._stroke=null),n.fill?(e=e||(t._fill=He("fill")),o.appendChild(e),e.color=n.fillColor||n.color,e.opacity=n.fillOpacity):e&&(o.removeChild(e),t._fill=null)},_updateCircle:function(t){var i=t._point.round(),e=Math.round(t._radius),n=Math.round(t._radiusY||e);this._setPath(t,t._empty()?"M0 0":"AL "+i.x+","+i.y+" "+e+","+n+" 0,23592600")},_setPath:function(t,i){t._path.v=i},_bringToFront:function(t){fi(t._container)},_bringToBack:function(t){gi(t._container)}},We=P.vml?He:ct,Fe=Ne.extend({_initContainer:function(){this._container=We("svg"),this._container.setAttribute("pointer-events","none"),this._rootGroup=We("g"),this._container.appendChild(this._rootGroup)},_destroyContainer:function(){T(this._container),E(this._container),delete this._container,delete this._rootGroup,delete this._svgSize},_update:function(){var t,i,e;this._map._animatingZoom&&this._bounds||(Ne.prototype._update.call(this),i=(t=this._bounds).getSize(),e=this._container,this._svgSize&&this._svgSize.equals(i)||(this._svgSize=i,e.setAttribute("width",i.x),e.setAttribute("height",i.y)),Z(e,t.min),e.setAttribute("viewBox",[t.min.x,t.min.y,i.x,i.y].join(" ")),this.fire("update"))},_initPath:function(t){var i=t._path=We("path");t.options.className&&z(i,t.options.className),t.options.interactive&&z(i,"leaflet-interactive"),this._updateStyle(t),this._layers[h(t)]=t},_addPath:function(t){this._rootGroup||this._initContainer(),this._rootGroup.appendChild(t._path),t.addInteractiveTarget(t._path)},_removePath:function(t){T(t._path),t.removeInteractiveTarget(t._path),delete this._layers[h(t)]},_updatePath:function(t){t._project(),t._update()},_updateStyle:function(t){var i=t._path,t=t.options;i&&(t.stroke?(i.setAttribute("stroke",t.color),i.setAttribute("stroke-opacity",t.opacity),i.setAttribute("stroke-width",t.weight),i.setAttribute("stroke-linecap",t.lineCap),i.setAttribute("stroke-linejoin",t.lineJoin),t.dashArray?i.setAttribute("stroke-dasharray",t.dashArray):i.removeAttribute("stroke-dasharray"),t.dashOffset?i.setAttribute("stroke-dashoffset",t.dashOffset):i.removeAttribute("stroke-dashoffset")):i.setAttribute("stroke","none"),t.fill?(i.setAttribute("fill",t.fillColor||t.color),i.setAttribute("fill-opacity",t.fillOpacity),i.setAttribute("fill-rule",t.fillRule||"evenodd")):i.setAttribute("fill","none"))},_updatePoly:function(t,i){this._setPath(t,dt(t._parts,i))},_updateCircle:function(t){var i=t._point,e=Math.max(Math.round(t._radius),1),n="a"+e+","+(Math.max(Math.round(t._radiusY),1)||e)+" 0 1,0 ",i=t._empty()?"M0 0":"M"+(i.x-e)+","+i.y+n+2*e+",0 "+n+2*-e+",0 ";this._setPath(t,i)},_setPath:function(t,i){t._path.setAttribute("d",i)},_bringToFront:function(t){fi(t._path)},_bringToBack:function(t){gi(t._path)}});function Ue(t){return P.svg||P.vml?new Fe(t):null}P.vml&&Fe.include(Mt),A.include({getRenderer:function(t){t=(t=t.options.renderer||this._getPaneRenderer(t.options.pane)||this.options.renderer||this._renderer)||(this._renderer=this._createRenderer());return this.hasLayer(t)||this.addLayer(t),t},_getPaneRenderer:function(t){if("overlayPane"===t||void 0===t)return!1;var i=this._paneRenderers[t];return void 0===i&&(i=this._createRenderer({pane:t}),this._paneRenderers[t]=i),i},_createRenderer:function(t){return this.options.preferCanvas&&je(t)||Ue(t)}});var Ve=ge.extend({initialize:function(t,i){ge.prototype.initialize.call(this,this._boundsToLatLngs(t),i)},setBounds:function(t){return this.setLatLngs(this._boundsToLatLngs(t))},_boundsToLatLngs:function(t){return[(t=g(t)).getSouthWest(),t.getNorthWest(),t.getNorthEast(),t.getSouthEast()]}});Fe.create=We,Fe.pointsToPath=dt,ve.geometryToLayer=ye,ve.coordsToLatLng=we,ve.coordsToLatLngs=Pe,ve.latLngToCoords=be,ve.latLngsToCoords=Le,ve.getFeature=Te,ve.asFeature=ze,A.mergeOptions({boxZoom:!0});var _t=n.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane,this._resetStateTimeout=0,t.on("unload",this._destroy,this)},addHooks:function(){S(this._container,"mousedown",this._onMouseDown,this)},removeHooks:function(){E(this._container,"mousedown",this._onMouseDown,this)},moved:function(){return this._moved},_destroy:function(){T(this._pane),delete this._pane},_resetState:function(){this._resetStateTimeout=0,this._moved=!1},_clearDeferredResetState:function(){0!==this._resetStateTimeout&&(clearTimeout(this._resetStateTimeout),this._resetStateTimeout=0)},_onMouseDown:function(t){if(!t.shiftKey||1!==t.which&&1!==t.button)return!1;this._clearDeferredResetState(),this._resetState(),ri(),Li(),this._startPoint=this._map.mouseEventToContainerPoint(t),S(document,{contextmenu:Ri,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseMove:function(t){this._moved||(this._moved=!0,this._box=b("div","leaflet-zoom-box",this._container),z(this._container,"leaflet-crosshair"),this._map.fire("boxzoomstart")),this._point=this._map.mouseEventToContainerPoint(t);var t=new m(this._point,this._startPoint),i=t.getSize();Z(this._box,t.min),this._box.style.width=i.x+"px",this._box.style.height=i.y+"px"},_finish:function(){this._moved&&(T(this._box),M(this._container,"leaflet-crosshair")),ai(),Ti(),E(document,{contextmenu:Ri,mousemove:this._onMouseMove,mouseup:this._onMouseUp,keydown:this._onKeyDown},this)},_onMouseUp:function(t){1!==t.which&&1!==t.button||(this._finish(),this._moved&&(this._clearDeferredResetState(),this._resetStateTimeout=setTimeout(a(this._resetState,this),0),t=new s(this._map.containerPointToLatLng(this._startPoint),this._map.containerPointToLatLng(this._point)),this._map.fitBounds(t).fire("boxzoomend",{boxZoomBounds:t})))},_onKeyDown:function(t){27===t.keyCode&&(this._finish(),this._clearDeferredResetState(),this._resetState())}}),Ct=(A.addInitHook("addHandler","boxZoom",_t),A.mergeOptions({doubleClickZoom:!0}),n.extend({addHooks:function(){this._map.on("dblclick",this._onDoubleClick,this)},removeHooks:function(){this._map.off("dblclick",this._onDoubleClick,this)},_onDoubleClick:function(t){var i=this._map,e=i.getZoom(),n=i.options.zoomDelta,e=t.originalEvent.shiftKey?e-n:e+n;"center"===i.options.doubleClickZoom?i.setZoom(e):i.setZoomAround(t.containerPoint,e)}})),Zt=(A.addInitHook("addHandler","doubleClickZoom",Ct),A.mergeOptions({dragging:!0,inertia:!0,inertiaDeceleration:3400,inertiaMaxSpeed:1/0,easeLinearity:.2,worldCopyJump:!1,maxBoundsViscosity:0}),n.extend({addHooks:function(){var t;this._draggable||(t=this._map,this._draggable=new Xi(t._mapPane,t._container),this._draggable.on({dragstart:this._onDragStart,drag:this._onDrag,dragend:this._onDragEnd},this),this._draggable.on("predrag",this._onPreDragLimit,this),t.options.worldCopyJump&&(this._draggable.on("predrag",this._onPreDragWrap,this),t.on("zoomend",this._onZoomEnd,this),t.whenReady(this._onZoomEnd,this))),z(this._map._container,"leaflet-grab leaflet-touch-drag"),this._draggable.enable(),this._positions=[],this._times=[]},removeHooks:function(){M(this._map._container,"leaflet-grab"),M(this._map._container,"leaflet-touch-drag"),this._draggable.disable()},moved:function(){return this._draggable&&this._draggable._moved},moving:function(){return this._draggable&&this._draggable._moving},_onDragStart:function(){var t,i=this._map;i._stop(),this._map.options.maxBounds&&this._map.options.maxBoundsViscosity?(t=g(this._map.options.maxBounds),this._offsetLimit=f(this._map.latLngToContainerPoint(t.getNorthWest()).multiplyBy(-1),this._map.latLngToContainerPoint(t.getSouthEast()).multiplyBy(-1).add(this._map.getSize())),this._viscosity=Math.min(1,Math.max(0,this._map.options.maxBoundsViscosity))):this._offsetLimit=null,i.fire("movestart").fire("dragstart"),i.options.inertia&&(this._positions=[],this._times=[])},_onDrag:function(t){var i,e;this._map.options.inertia&&(i=this._lastTime=+new Date,e=this._lastPos=this._draggable._absPos||this._draggable._newPos,this._positions.push(e),this._times.push(i),this._prunePositions(i)),this._map.fire("move",t).fire("drag",t)},_prunePositions:function(t){for(;1<this._positions.length&&50<t-this._times[0];)this._positions.shift(),this._times.shift()},_onZoomEnd:function(){var t=this._map.getSize().divideBy(2),i=this._map.latLngToLayerPoint([0,0]);this._initialWorldOffset=i.subtract(t).x,this._worldWidth=this._map.getPixelWorldBounds().getSize().x},_viscousLimit:function(t,i){return t-(t-i)*this._viscosity},_onPreDragLimit:function(){var t,i;this._viscosity&&this._offsetLimit&&(t=this._draggable._newPos.subtract(this._draggable._startPos),i=this._offsetLimit,t.x<i.min.x&&(t.x=this._viscousLimit(t.x,i.min.x)),t.y<i.min.y&&(t.y=this._viscousLimit(t.y,i.min.y)),t.x>i.max.x&&(t.x=this._viscousLimit(t.x,i.max.x)),t.y>i.max.y&&(t.y=this._viscousLimit(t.y,i.max.y)),this._draggable._newPos=this._draggable._startPos.add(t))},_onPreDragWrap:function(){var t=this._worldWidth,i=Math.round(t/2),e=this._initialWorldOffset,n=this._draggable._newPos.x,o=(n-i+e)%t+i-e,n=(n+i+e)%t-i-e,t=Math.abs(o+e)<Math.abs(n+e)?o:n;this._draggable._absPos=this._draggable._newPos.clone(),this._draggable._newPos.x=t},_onDragEnd:function(t){var i,e,n,o,s=this._map,r=s.options,a=!r.inertia||t.noInertia||this._times.length<2;s.fire("dragend",t),a?s.fire("moveend"):(this._prunePositions(+new Date),t=this._lastPos.subtract(this._positions[0]),a=(this._lastTime-this._times[0])/1e3,i=r.easeLinearity,a=(t=t.multiplyBy(i/a)).distanceTo([0,0]),e=Math.min(r.inertiaMaxSpeed,a),t=t.multiplyBy(e/a),n=e/(r.inertiaDeceleration*i),(o=t.multiplyBy(-n/2).round()).x||o.y?(o=s._limitOffset(o,s.options.maxBounds),x(function(){s.panBy(o,{duration:n,easeLinearity:i,noMoveStart:!0,animate:!0})})):s.fire("moveend"))}})),St=(A.addInitHook("addHandler","dragging",Zt),A.mergeOptions({keyboard:!0,keyboardPanDelta:80}),n.extend({keyCodes:{left:[37],right:[39],down:[40],up:[38],zoomIn:[187,107,61,171],zoomOut:[189,109,54,173]},initialize:function(t){this._map=t,this._setPanDelta(t.options.keyboardPanDelta),this._setZoomDelta(t.options.zoomDelta)},addHooks:function(){var t=this._map._container;t.tabIndex<=0&&(t.tabIndex="0"),S(t,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.on({focus:this._addHooks,blur:this._removeHooks},this)},removeHooks:function(){this._removeHooks(),E(this._map._container,{focus:this._onFocus,blur:this._onBlur,mousedown:this._onMouseDown},this),this._map.off({focus:this._addHooks,blur:this._removeHooks},this)},_onMouseDown:function(){var t,i,e;this._focused||(e=document.body,t=document.documentElement,i=e.scrollTop||t.scrollTop,e=e.scrollLeft||t.scrollLeft,this._map._container.focus(),window.scrollTo(e,i))},_onFocus:function(){this._focused=!0,this._map.fire("focus")},_onBlur:function(){this._focused=!1,this._map.fire("blur")},_setPanDelta:function(t){for(var i=this._panKeys={},e=this.keyCodes,n=0,o=e.left.length;n<o;n++)i[e.left[n]]=[-1*t,0];for(n=0,o=e.right.length;n<o;n++)i[e.right[n]]=[t,0];for(n=0,o=e.down.length;n<o;n++)i[e.down[n]]=[0,t];for(n=0,o=e.up.length;n<o;n++)i[e.up[n]]=[0,-1*t]},_setZoomDelta:function(t){for(var i=this._zoomKeys={},e=this.keyCodes,n=0,o=e.zoomIn.length;n<o;n++)i[e.zoomIn[n]]=t;for(n=0,o=e.zoomOut.length;n<o;n++)i[e.zoomOut[n]]=-t},_addHooks:function(){S(document,"keydown",this._onKeyDown,this)},_removeHooks:function(){E(document,"keydown",this._onKeyDown,this)},_onKeyDown:function(t){if(!(t.altKey||t.ctrlKey||t.metaKey)){var i,e=t.keyCode,n=this._map;if(e in this._panKeys)n._panAnim&&n._panAnim._inProgress||(i=this._panKeys[e],t.shiftKey&&(i=_(i).multiplyBy(3)),n.panBy(i),n.options.maxBounds&&n.panInsideBounds(n.options.maxBounds));else if(e in this._zoomKeys)n.setZoom(n.getZoom()+(t.shiftKey?3:1)*this._zoomKeys[e]);else{if(27!==e||!n._popup||!n._popup.options.closeOnEscapeKey)return;n.closePopup()}Ri(t)}}})),kt=(A.addInitHook("addHandler","keyboard",St),A.mergeOptions({scrollWheelZoom:!0,wheelDebounceTime:40,wheelPxPerZoomLevel:60}),n.extend({addHooks:function(){S(this._map._container,"wheel",this._onWheelScroll,this),this._delta=0},removeHooks:function(){E(this._map._container,"wheel",this._onWheelScroll,this)},_onWheelScroll:function(t){var i=ji(t),e=this._map.options.wheelDebounceTime,i=(this._delta+=i,this._lastMousePos=this._map.mouseEventToContainerPoint(t),this._startTime||(this._startTime=+new Date),Math.max(e-(+new Date-this._startTime),0));clearTimeout(this._timer),this._timer=setTimeout(a(this._performZoom,this),i),Ri(t)},_performZoom:function(){var t=this._map,i=t.getZoom(),e=this._map.options.zoomSnap||0,n=(t._stop(),this._delta/(4*this._map.options.wheelPxPerZoomLevel)),n=4*Math.log(2/(1+Math.exp(-Math.abs(n))))/Math.LN2,e=e?Math.ceil(n/e)*e:n,n=t._limitZoom(i+(0<this._delta?e:-e))-i;this._delta=0,this._startTime=null,n&&("center"===t.options.scrollWheelZoom?t.setZoom(i+n):t.setZoomAround(this._lastMousePos,i+n))}})),Et=(A.addInitHook("addHandler","scrollWheelZoom",kt),A.mergeOptions({tapHold:P.touchNative&&P.safari&&P.mobile,tapTolerance:15}),n.extend({addHooks:function(){S(this._map._container,"touchstart",this._onDown,this)},removeHooks:function(){E(this._map._container,"touchstart",this._onDown,this)},_onDown:function(t){var i;clearTimeout(this._holdTimeout),1===t.touches.length&&(i=t.touches[0],this._startPos=this._newPos=new p(i.clientX,i.clientY),this._holdTimeout=setTimeout(a(function(){this._cancel(),this._isTapValid()&&(S(document,"touchend",B),S(document,"touchend touchcancel",this._cancelClickPrevent),this._simulateEvent("contextmenu",i))},this),600),S(document,"touchend touchcancel contextmenu",this._cancel,this),S(document,"touchmove",this._onMove,this))},_cancelClickPrevent:function t(){E(document,"touchend",B),E(document,"touchend touchcancel",t)},_cancel:function(){clearTimeout(this._holdTimeout),E(document,"touchend touchcancel contextmenu",this._cancel,this),E(document,"touchmove",this._onMove,this)},_onMove:function(t){t=t.touches[0];this._newPos=new p(t.clientX,t.clientY)},_isTapValid:function(){return this._newPos.distanceTo(this._startPos)<=this._map.options.tapTolerance},_simulateEvent:function(t,i){t=new MouseEvent(t,{bubbles:!0,cancelable:!0,view:window,screenX:i.screenX,screenY:i.screenY,clientX:i.clientX,clientY:i.clientY});t._simulated=!0,i.target.dispatchEvent(t)}})),Bt=(A.addInitHook("addHandler","tapHold",Et),A.mergeOptions({touchZoom:P.touch,bounceAtZoomLimits:!0}),n.extend({addHooks:function(){z(this._map._container,"leaflet-touch-zoom"),S(this._map._container,"touchstart",this._onTouchStart,this)},removeHooks:function(){M(this._map._container,"leaflet-touch-zoom"),E(this._map._container,"touchstart",this._onTouchStart,this)},_onTouchStart:function(t){var i,e,n=this._map;!t.touches||2!==t.touches.length||n._animatingZoom||this._zooming||(i=n.mouseEventToContainerPoint(t.touches[0]),e=n.mouseEventToContainerPoint(t.touches[1]),this._centerPoint=n.getSize()._divideBy(2),this._startLatLng=n.containerPointToLatLng(this._centerPoint),"center"!==n.options.touchZoom&&(this._pinchStartLatLng=n.containerPointToLatLng(i.add(e)._divideBy(2))),this._startDist=i.distanceTo(e),this._startZoom=n.getZoom(),this._moved=!1,this._zooming=!0,n._stop(),S(document,"touchmove",this._onTouchMove,this),S(document,"touchend touchcancel",this._onTouchEnd,this),B(t))},_onTouchMove:function(t){if(t.touches&&2===t.touches.length&&this._zooming){var i=this._map,e=i.mouseEventToContainerPoint(t.touches[0]),n=i.mouseEventToContainerPoint(t.touches[1]),o=e.distanceTo(n)/this._startDist;if(this._zoom=i.getScaleZoom(o,this._startZoom),!i.options.bounceAtZoomLimits&&(this._zoom<i.getMinZoom()&&o<1||this._zoom>i.getMaxZoom()&&1<o)&&(this._zoom=i._limitZoom(this._zoom)),"center"===i.options.touchZoom){if(this._center=this._startLatLng,1==o)return}else{e=e._add(n)._divideBy(2)._subtract(this._centerPoint);if(1==o&&0===e.x&&0===e.y)return;this._center=i.unproject(i.project(this._pinchStartLatLng,this._zoom).subtract(e),this._zoom)}this._moved||(i._moveStart(!0,!1),this._moved=!0),r(this._animRequest);n=a(i._move,i,this._center,this._zoom,{pinch:!0,round:!1});this._animRequest=x(n,this,!0),B(t)}},_onTouchEnd:function(){this._moved&&this._zooming?(this._zooming=!1,r(this._animRequest),E(document,"touchmove",this._onTouchMove,this),E(document,"touchend touchcancel",this._onTouchEnd,this),this._map.options.zoomAnimation?this._map._animateZoom(this._center,this._map._limitZoom(this._zoom),!0,this._map.options.zoomSnap):this._map._resetView(this._center,this._map._limitZoom(this._zoom))):this._zooming=!1}})),qe=(A.addInitHook("addHandler","touchZoom",Bt),A.BoxZoom=_t,A.DoubleClickZoom=Ct,A.Drag=Zt,A.Keyboard=St,A.ScrollWheelZoom=kt,A.TapHold=Et,A.TouchZoom=Bt,t.Bounds=m,t.Browser=P,t.CRS=ot,t.Canvas=De,t.Circle=me,t.CircleMarker=pe,t.Class=it,t.Control=I,t.DivIcon=Be,t.DivOverlay=O,t.DomEvent=mt,t.DomUtil=pt,t.Draggable=Xi,t.Evented=et,t.FeatureGroup=he,t.GeoJSON=ve,t.GridLayer=Ae,t.Handler=n,t.Icon=le,t.ImageOverlay=Ce,t.LatLng=v,t.LatLngBounds=s,t.Layer=o,t.LayerGroup=ae,t.LineUtil=gt,t.Map=A,t.Marker=de,t.Mixin=ft,t.Path=_e,t.Point=p,t.PolyUtil=vt,t.Polygon=ge,t.Polyline=fe,t.Popup=ke,t.PosAnimation=Wi,t.Projection=wt,t.Rectangle=Ve,t.Renderer=Ne,t.SVG=Fe,t.SVGOverlay=Se,t.TileLayer=Ie,t.Tooltip=Ee,t.Transformation=at,t.Util=tt,t.VideoOverlay=Ze,t.bind=a,t.bounds=f,t.canvas=je,t.circle=function(t,i,e){return new me(t,i,e)},t.circleMarker=function(t,i){return new pe(t,i)},t.control=Fi,t.divIcon=function(t){return new Be(t)},t.extend=l,t.featureGroup=function(t,i){return new he(t,i)},t.geoJSON=Me,t.geoJson=zt,t.gridLayer=function(t){return new Ae(t)},t.icon=function(t){return new le(t)},t.imageOverlay=function(t,i,e){return new Ce(t,i,e)},t.latLng=w,t.latLngBounds=g,t.layerGroup=function(t,i){return new ae(t,i)},t.map=function(t,i){return new A(t,i)},t.marker=function(t,i){return new de(t,i)},t.point=_,t.polygon=function(t,i){return new ge(t,i)},t.polyline=function(t,i){return new fe(t,i)},t.popup=function(t,i){return new ke(t,i)},t.rectangle=function(t,i){return new Ve(t,i)},t.setOptions=c,t.stamp=h,t.svg=Ue,t.svgOverlay=function(t,i,e){return new Se(t,i,e)},t.tileLayer=Oe,t.tooltip=function(t,i){return new Ee(t,i)},t.transformation=ht,t.version="1.8.0",t.videoOverlay=function(t,i,e){return new Ze(t,i,e)},window.L);t.noConflict=function(){return window.L=qe,this},window.L=t});
	//# sourceMappingURL=leaflet.js.map

/***/ }),
/* 50 */
3,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC"

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AWS_ALGORITHM = 'AWS4-HMAC-SHA256';
	
	/**
	 * Utility service for setting up MQTT connections to a Thing and thereby
	 * accessing the /Shadow Document/ via the publish and subscribe operations
	 * supported by the `Paho.MQTT` interface.
	 *
	 * The code related to setting up and signing the MQTT URL is straight from
	 * Amazon documentation:
	 *   http://docs.aws.amazon.com/iot/latest/developerguide/protocols.html
	 */
	
	var ShadowService = function () {
	    /* @ngInject */
	    function ShadowService($log, $q, AwsService, ManifestService, AuthService) {
	        (0, _classCallCheck3.default)(this, ShadowService);
	
	        this.$log = $log;
	        this.$q = $q;
	        this.AwsService = AwsService;
	        this.ManifestService = ManifestService;
	        this.AuthService = AuthService;
	
	        this.cryptoUtil = this.AwsService.AWS.util.crypto;
	
	        this.selectedDomain = undefined;
	    }
	
	    /**
	     * Generate a URL for connecting with Amazon IoT MQTT Broker using
	     * cognito credentials for the currently logged in user.
	     */
	
	
	    (0, _createClass3.default)(ShadowService, [{
	        key: 'connectionUrl',
	        value: function connectionUrl() {
	            var credentials = this.AwsService.AWS.config.credentials;
	            return this.generateMqttUrl(credentials);
	        }
	    }, {
	        key: 'getSignatureKey',
	        value: function getSignatureKey(key, date, region, service) {
	            var kDate = this.cryptoUtil.hmac('AWS4' + key, date, 'buffer');
	            var kRegion = this.cryptoUtil.hmac(kDate, region, 'buffer');
	            var kService = this.cryptoUtil.hmac(kRegion, service, 'buffer');
	            var kCredentials = this.cryptoUtil.hmac(kService, 'aws4_request', 'buffer');
	            return kCredentials;
	        }
	    }, {
	        key: 'generateMqttUrl',
	        value: function generateMqttUrl() {
	            var _AuthService$getLocal = this.AuthService.getLocalCredentials(),
	                AccessKeyId = _AuthService$getLocal.AccessKeyId,
	                SecretKey = _AuthService$getLocal.SecretKey,
	                SessionToken = _AuthService$getLocal.SessionToken;
	
	            var datetime = this.AwsService.AWS.util.date.iso8601(new Date()).replace(/[:-]|\.\d{3}/g, '');
	            var date = datetime.substr(0, 8);
	
	            var method = 'GET';
	            var uri = '/mqtt';
	            var service = 'iotdevicegateway';
	
	            var credentialScope = date + '/' + this.ManifestService.region() + '/' + service + '/aws4_request';
	
	            var canonicalQuerystring = 'X-Amz-Algorithm=' + AWS_ALGORITHM;
	            canonicalQuerystring += '&X-Amz-Credential=' + encodeURIComponent(AccessKeyId + '/' + credentialScope);
	            canonicalQuerystring += '&X-Amz-Date=' + datetime;
	            canonicalQuerystring += '&X-Amz-SignedHeaders=host';
	
	            var canonicalHeaders = 'host:' + this.ManifestService.iotEndpointATS() + '\n';
	            var payloadHash = this.cryptoUtil.sha256('', 'hex');
	            // eslint-disable-next-line max-len
	            var canonicalRequest = method + '\n' + uri + '\n' + canonicalQuerystring + '\n' + canonicalHeaders + '\nhost\n' + payloadHash;
	
	            var stringToSign = AWS_ALGORITHM + '\n' + datetime + '\n' + credentialScope + '\n' + this.cryptoUtil.sha256(canonicalRequest, 'hex');
	            var signingKey = this.getSignatureKey(SecretKey, date, this.ManifestService.region(), service);
	            var signature = this.cryptoUtil.hmac(signingKey, stringToSign, 'hex');
	
	            canonicalQuerystring += '&X-Amz-Signature=' + signature;
	            canonicalQuerystring += '&X-Amz-Security-Token=' + encodeURIComponent(SessionToken);
	
	            return 'wss://' + this.ManifestService.manifest.IotEndpointATS + uri + '?' + canonicalQuerystring;
	        }
	    }, {
	        key: 'connect',
	        value: function connect(thingName) {
	            var _this = this;
	
	            return this.$q(function (resolve, reject) {
	                var url = _this.generateMqttUrl();
	                var client = new window.Paho.MQTT.Client(url, thingName);
	                var connectOptions = {
	                    onSuccess: function onSuccess() {
	                        _this.$log.log('MQTT connection setup successfully.');
	                        resolve(client);
	                    },
	                    useSSL: true,
	                    timeout: 3,
	                    mqttVersion: 3,
	                    onFailure: function onFailure() {
	                        _this.$log.log('Failed to setup MQTT connection.');
	                        reject();
	                    }
	                };
	                client.connect(connectOptions);
	            });
	        }
	    }]);
	    return ShadowService;
	}();
	
	exports.default = ShadowService;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventsService = function () {
	    /* @ngInject */
	    function EventsService($q, AxiosService, AuthService) {
	        (0, _classCallCheck3.default)(this, EventsService);
	
	        this.$q = $q;
	        this.AxiosService = AxiosService;
	        this.AuthService = AuthService;
	    }
	
	    /**
	     * Retrieves a list of events for a given thing
	     *
	     * @param {object} params - The parameters used to query for events
	     * @param {Date} params.sortOrder - Optional sortorder. Default 'desc'
	     * @param {Date} params.fromDate - The date to start the selection with
	     * @param {Date} params.endDate - The date to end the selection with
	     * @param {String} params.thingId - The ID of the thing to include events for
	     */
	
	
	    (0, _createClass3.default)(EventsService, [{
	        key: 'getEvents',
	        value: function getEvents(params) {
	            var _this = this;
	
	            return this.$q(function (resolve, reject) {
	                var query = {
	                    size: 500,
	                    sort: [{ timestamp: params.sortOrder || 'desc' }],
	                    query: {
	                        bool: {
	                            must: [{
	                                range: {
	                                    timestamp: {
	                                        gte: params.fromDate.valueOf(),
	                                        lte: params.toDate.valueOf()
	                                    }
	                                }
	                            }, {
	                                term: { 'source.thingName': params.thingId }
	                            }, {
	                                term: {
	                                    classification: 'ALARM'
	                                }
	                            }]
	                        }
	                    }
	                };
	
	                _this.AxiosService.http.post('events/find', { query: query }, { headers: { authorization: _this.AuthService.getToken() } }).then(function (response) {
	                    return response.data;
	                }).then(function (data) {
	                    return resolve(data);
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	
	        /**
	         * Retrieves a list of events for a given domain
	         *
	         * @param {object} params - The parameters used to query for events
	         * @param {Date} params.fromDate - The date to start the selection with
	         * @param {Date} params.endDate - The date to end the selection with
	         * @param {String} [params.domainId] - The ID of the domain to include events for
	         */
	
	    }, {
	        key: 'getEventsForDomain',
	        value: function getEventsForDomain(params) {
	            var _this2 = this;
	
	            return this.$q(function (resolve, reject) {
	                var query = {
	                    size: 500,
	                    sort: [{
	                        timestamp: 'desc'
	                    }],
	                    query: {
	                        bool: {
	                            must: [{
	                                range: {
	                                    timestamp: {
	                                        gte: params.fromDate.valueOf(),
	                                        lte: params.toDate.valueOf()
	                                    }
	                                }
	                            }, {
	                                term: {
	                                    classification: 'ALARM'
	                                }
	                            }]
	                        }
	                    }
	                };
	                // The domain id is optional, if no given all events for the logged
	                // in user will be returned.
	                if (params.domainId) {
	                    query.query.bool.must.push({
	                        term: {
	                            'source.domain': params.domainId
	                        }
	                    });
	                }
	
	                _this2.AxiosService.http.post('events/find', { query: query }, { headers: { authorization: _this2.AuthService.getToken() } }).then(function (response) {
	                    return response.data;
	                }).then(function (data) {
	                    return resolve(data);
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'getEventsToAcknowledge',
	        value: function getEventsToAcknowledge(params) {
	            var _this3 = this;
	
	            return this.$q(function (resolve, reject) {
	                var query = {
	                    size: 500,
	                    sort: {
	                        timestamp: {
	                            order: 'desc'
	                        }
	                    },
	                    query: {
	                        bool: {
	                            must: [{
	                                range: {
	                                    timestamp: {
	                                        gte: params.fromDate.valueOf(),
	                                        lte: params.toDate.valueOf()
	                                    }
	                                }
	                            }, {
	                                term: {
	                                    acknowledgmentRequired: true
	                                }
	                            }],
	                            must_not: [{
	                                exists: {
	                                    field: 'acknowledgedBy'
	                                }
	                            }]
	                        }
	                    }
	                };
	                // The thingId is optional, if not given all unacknowledged alarms is returned
	                if (params.thingId) {
	                    query.query.bool.must.push({
	                        term: {
	                            'source.thingName': params.thingId
	                        }
	                    });
	                }
	
	                return _this3.AxiosService.http.post('events/find', { query: query }, { headers: { authorization: _this3.AuthService.getToken() } }).then(function (response) {
	                    return response.data;
	                }).then(function (data) {
	                    return resolve(data);
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'acknowledgeEvent',
	        value: function acknowledgeEvent(event) {
	            var _this4 = this;
	
	            return this.$q(function (resolve, reject) {
	                var eventId = event._source.id;
	
	                return _this4.AxiosService.http.post('events/' + eventId + '/acknowledge', {}, {
	                    headers: { authorization: _this4.AuthService.getToken() },
	                    params: { id: eventId }
	                }).then(function (response) {
	                    return response.data;
	                }).then(function (data) {
	                    return resolve(data);
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	    }]);
	    return EventsService;
	}();
	
	exports.default = EventsService;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(59);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MomentService = function () {
	    /* @ngInject */
	    function MomentService() {
	        (0, _classCallCheck3.default)(this, MomentService);
	
	        this.moment = _moment2.default;
	        this.moment.locale('en');
	    }
	
	    (0, _createClass3.default)(MomentService, [{
	        key: 'startOfWeek',
	        value: function startOfWeek() {
	            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	
	            return this.moment(date).startOf('week').toDate();
	        }
	    }, {
	        key: 'endOfDay',
	        value: function endOfDay() {
	            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	            // eslint-disable-line class-methods-use-this
	            date.setHours(23, 59, 59);
	            return date;
	        }
	    }]);
	    return MomentService;
	}();
	
	exports.default = MomentService;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.3
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(61)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.3';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)(module)))

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 62,
		"./af.js": 62,
		"./ar": 63,
		"./ar-dz": 64,
		"./ar-dz.js": 64,
		"./ar-kw": 65,
		"./ar-kw.js": 65,
		"./ar-ly": 66,
		"./ar-ly.js": 66,
		"./ar-ma": 67,
		"./ar-ma.js": 67,
		"./ar-sa": 68,
		"./ar-sa.js": 68,
		"./ar-tn": 69,
		"./ar-tn.js": 69,
		"./ar.js": 63,
		"./az": 70,
		"./az.js": 70,
		"./be": 71,
		"./be.js": 71,
		"./bg": 72,
		"./bg.js": 72,
		"./bm": 73,
		"./bm.js": 73,
		"./bn": 74,
		"./bn-bd": 75,
		"./bn-bd.js": 75,
		"./bn.js": 74,
		"./bo": 76,
		"./bo.js": 76,
		"./br": 77,
		"./br.js": 77,
		"./bs": 78,
		"./bs.js": 78,
		"./ca": 79,
		"./ca.js": 79,
		"./cs": 80,
		"./cs.js": 80,
		"./cv": 81,
		"./cv.js": 81,
		"./cy": 82,
		"./cy.js": 82,
		"./da": 83,
		"./da.js": 83,
		"./de": 84,
		"./de-at": 85,
		"./de-at.js": 85,
		"./de-ch": 86,
		"./de-ch.js": 86,
		"./de.js": 84,
		"./dv": 87,
		"./dv.js": 87,
		"./el": 88,
		"./el.js": 88,
		"./en-au": 89,
		"./en-au.js": 89,
		"./en-ca": 90,
		"./en-ca.js": 90,
		"./en-gb": 91,
		"./en-gb.js": 91,
		"./en-ie": 92,
		"./en-ie.js": 92,
		"./en-il": 93,
		"./en-il.js": 93,
		"./en-in": 94,
		"./en-in.js": 94,
		"./en-nz": 95,
		"./en-nz.js": 95,
		"./en-sg": 96,
		"./en-sg.js": 96,
		"./eo": 97,
		"./eo.js": 97,
		"./es": 98,
		"./es-do": 99,
		"./es-do.js": 99,
		"./es-mx": 100,
		"./es-mx.js": 100,
		"./es-us": 101,
		"./es-us.js": 101,
		"./es.js": 98,
		"./et": 102,
		"./et.js": 102,
		"./eu": 103,
		"./eu.js": 103,
		"./fa": 104,
		"./fa.js": 104,
		"./fi": 105,
		"./fi.js": 105,
		"./fil": 106,
		"./fil.js": 106,
		"./fo": 107,
		"./fo.js": 107,
		"./fr": 108,
		"./fr-ca": 109,
		"./fr-ca.js": 109,
		"./fr-ch": 110,
		"./fr-ch.js": 110,
		"./fr.js": 108,
		"./fy": 111,
		"./fy.js": 111,
		"./ga": 112,
		"./ga.js": 112,
		"./gd": 113,
		"./gd.js": 113,
		"./gl": 114,
		"./gl.js": 114,
		"./gom-deva": 115,
		"./gom-deva.js": 115,
		"./gom-latn": 116,
		"./gom-latn.js": 116,
		"./gu": 117,
		"./gu.js": 117,
		"./he": 118,
		"./he.js": 118,
		"./hi": 119,
		"./hi.js": 119,
		"./hr": 120,
		"./hr.js": 120,
		"./hu": 121,
		"./hu.js": 121,
		"./hy-am": 122,
		"./hy-am.js": 122,
		"./id": 123,
		"./id.js": 123,
		"./is": 124,
		"./is.js": 124,
		"./it": 125,
		"./it-ch": 126,
		"./it-ch.js": 126,
		"./it.js": 125,
		"./ja": 127,
		"./ja.js": 127,
		"./jv": 128,
		"./jv.js": 128,
		"./ka": 129,
		"./ka.js": 129,
		"./kk": 130,
		"./kk.js": 130,
		"./km": 131,
		"./km.js": 131,
		"./kn": 132,
		"./kn.js": 132,
		"./ko": 133,
		"./ko.js": 133,
		"./ku": 134,
		"./ku.js": 134,
		"./ky": 135,
		"./ky.js": 135,
		"./lb": 136,
		"./lb.js": 136,
		"./lo": 137,
		"./lo.js": 137,
		"./lt": 138,
		"./lt.js": 138,
		"./lv": 139,
		"./lv.js": 139,
		"./me": 140,
		"./me.js": 140,
		"./mi": 141,
		"./mi.js": 141,
		"./mk": 142,
		"./mk.js": 142,
		"./ml": 143,
		"./ml.js": 143,
		"./mn": 144,
		"./mn.js": 144,
		"./mr": 145,
		"./mr.js": 145,
		"./ms": 146,
		"./ms-my": 147,
		"./ms-my.js": 147,
		"./ms.js": 146,
		"./mt": 148,
		"./mt.js": 148,
		"./my": 149,
		"./my.js": 149,
		"./nb": 150,
		"./nb.js": 150,
		"./ne": 151,
		"./ne.js": 151,
		"./nl": 152,
		"./nl-be": 153,
		"./nl-be.js": 153,
		"./nl.js": 152,
		"./nn": 154,
		"./nn.js": 154,
		"./oc-lnc": 155,
		"./oc-lnc.js": 155,
		"./pa-in": 156,
		"./pa-in.js": 156,
		"./pl": 157,
		"./pl.js": 157,
		"./pt": 158,
		"./pt-br": 159,
		"./pt-br.js": 159,
		"./pt.js": 158,
		"./ro": 160,
		"./ro.js": 160,
		"./ru": 161,
		"./ru.js": 161,
		"./sd": 162,
		"./sd.js": 162,
		"./se": 163,
		"./se.js": 163,
		"./si": 164,
		"./si.js": 164,
		"./sk": 165,
		"./sk.js": 165,
		"./sl": 166,
		"./sl.js": 166,
		"./sq": 167,
		"./sq.js": 167,
		"./sr": 168,
		"./sr-cyrl": 169,
		"./sr-cyrl.js": 169,
		"./sr.js": 168,
		"./ss": 170,
		"./ss.js": 170,
		"./sv": 171,
		"./sv.js": 171,
		"./sw": 172,
		"./sw.js": 172,
		"./ta": 173,
		"./ta.js": 173,
		"./te": 174,
		"./te.js": 174,
		"./tet": 175,
		"./tet.js": 175,
		"./tg": 176,
		"./tg.js": 176,
		"./th": 177,
		"./th.js": 177,
		"./tk": 178,
		"./tk.js": 178,
		"./tl-ph": 179,
		"./tl-ph.js": 179,
		"./tlh": 180,
		"./tlh.js": 180,
		"./tr": 181,
		"./tr.js": 181,
		"./tzl": 182,
		"./tzl.js": 182,
		"./tzm": 183,
		"./tzm-latn": 184,
		"./tzm-latn.js": 184,
		"./tzm.js": 183,
		"./ug-cn": 185,
		"./ug-cn.js": 185,
		"./uk": 186,
		"./uk.js": 186,
		"./ur": 187,
		"./ur.js": 187,
		"./uz": 188,
		"./uz-latn": 189,
		"./uz-latn.js": 189,
		"./uz.js": 188,
		"./vi": 190,
		"./vi.js": 190,
		"./x-pseudo": 191,
		"./x-pseudo.js": 191,
		"./yo": 192,
		"./yo.js": 192,
		"./zh-cn": 193,
		"./zh-cn.js": 193,
		"./zh-hk": 194,
		"./zh-hk.js": 194,
		"./zh-mo": 195,
		"./zh-mo.js": 195,
		"./zh-tw": 196,
		"./zh-tw.js": 196
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 61;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                '_'
	            ),
	            standalone:
	                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                    '_'
	                ),
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(59)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _routes = __webpack_require__(198);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _translations = __webpack_require__(199);
	
	var _translations2 = _interopRequireDefault(_translations);
	
	var _auth = __webpack_require__(200);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _datepicker = __webpack_require__(201);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('app.config', []).config(_routes2.default).config(_translations2.default).config(_datepicker2.default).run(_auth2.default);
	
	exports.default = _module.name;

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	/* @ngInject */
	function routes($routeProvider) {
	    $routeProvider.when('/', {
	        redirectTo: '/login'
	    }).when('/login', {
	        template: '<sb-login></sb-login>',
	        public: true
	    }).when('/home', {
	        template: '<sb-home></sb-home>'
	    }).when('/transports', {
	        template: '<sb-transports></sb-transports>'
	    }).when('/detail/:id', {
	        template: '<sb-detail></sb-detail>'
	    }).when('/report/carts', {
	        template: '<sb-carts-report></sb-carts-report>'
	    }).otherwise({
	        redirectTo: '/'
	    });
	}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = translations;
	/* @ngInject */
	function translations($translateProvider) {
	    $translateProvider.useSanitizeValueStrategy(null);
	    $translateProvider.useStaticFilesLoader({ prefix: 'assets/i18n/', suffix: '.json' });
	    $translateProvider.preferredLanguage('en'); // pick key from localStorage if any
	}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($rootScope, $location, $route, AuthService) {
	    var deregister = $rootScope.$on('$routeChangeStart', function (event, next) {
	        var publicRoute = next.public !== undefined ? next.public : false;
	
	        if (!publicRoute && AuthService.hasCredentials() === false) {
	            event.preventDefault();
	            AuthService.refreshCredentials().then(function () {
	                // trigger reload with fresh credentials
	                $route.reload();
	            }).catch(function () {
	                var currentUrl = $location.url();
	
	                if (currentUrl !== undefined && currentUrl.length > 0 && !currentUrl.startsWith('/login')) {
	                    $location.url('/login?next=' + currentUrl);
	                } else {
	                    $location.url('/login');
	                }
	            });
	        }
	    });
	
	    $rootScope.$on('$destroy', deregister);
	};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function ($datepickerProvider) {
	    _angular2.default.extend($datepickerProvider.defaults, {
	        dateFormat: 'yyyy-MM-dd',
	        startWeek: 1,
	        iconLeft: 'fa fa-chevron-left',
	        iconRight: 'fa fa-chevron-right'
	    });
	};
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _applicationPage = __webpack_require__(203);
	
	var _applicationPage2 = _interopRequireDefault(_applicationPage);
	
	var _pageHeader = __webpack_require__(207);
	
	var _pageHeader2 = _interopRequireDefault(_pageHeader);
	
	var _pageFooter = __webpack_require__(212);
	
	var _pageFooter2 = _interopRequireDefault(_pageFooter);
	
	var _pageContext = __webpack_require__(216);
	
	var _pageContext2 = _interopRequireDefault(_pageContext);
	
	var _domainSelector = __webpack_require__(220);
	
	var _domainSelector2 = _interopRequireDefault(_domainSelector);
	
	var _modal = __webpack_require__(225);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _cartSettings = __webpack_require__(229);
	
	var _cartSettings2 = _interopRequireDefault(_cartSettings);
	
	var _alarmNotifications = __webpack_require__(232);
	
	var _alarmNotifications2 = _interopRequireDefault(_alarmNotifications);
	
	var _emptyBox = __webpack_require__(237);
	
	var _emptyBox2 = _interopRequireDefault(_emptyBox);
	
	var _transports = __webpack_require__(241);
	
	var _transports2 = _interopRequireDefault(_transports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('app.components', []).component(_applicationPage2.default.selector, _applicationPage2.default).component(_pageHeader2.default.selector, _pageHeader2.default).component(_pageFooter2.default.selector, _pageFooter2.default).component(_pageContext2.default.selector, _pageContext2.default).component(_domainSelector2.default.selector, _domainSelector2.default).component(_modal2.default.selector, _modal2.default).component(_alarmNotifications2.default.selector, _alarmNotifications2.default).component(_cartSettings2.default.selector, _cartSettings2.default).component(_emptyBox2.default.selector, _emptyBox2.default).component(_transports2.default.selector, _transports2.default);
	
	exports.default = _module.name;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	__webpack_require__(204);
	
	var ApplicationPageComponent = {
	    selector: 'sbApplicationPage',
	    template: __webpack_require__(206),
	    transclude: {
	        content: 'sbApplicationContent'
	    }
	};
	
	exports.default = ApplicationPageComponent;

/***/ }),
/* 204 */
3,
/* 205 */,
/* 206 */
/***/ (function(module, exports) {

	module.exports = "<sb-page-header></sb-page-header> <div class=sb-application-page ng-transclude=content></div> <sb-page-footer></sb-page-footer> ";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _pageHeader = __webpack_require__(208);
	
	var _pageHeader2 = _interopRequireDefault(_pageHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(209);
	
	var PageHeaderComponent = {
	    selector: 'sbPageHeader',
	    controller: _pageHeader2.default,
	    template: __webpack_require__(211)
	};
	
	exports.default = PageHeaderComponent;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageHeaderController = function () {
	    /* @ngInject */
	    function PageHeaderController($window, $rootScope, AuthService) {
	        (0, _classCallCheck3.default)(this, PageHeaderController);
	
	        this.$window = $window;
	        this.$rootScope = $rootScope;
	        this.AuthService = AuthService;
	        this.username = undefined;
	        this.showTransportLink = false;
	        this.showReportsLink = true;
	    }
	
	    (0, _createClass3.default)(PageHeaderController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var account = this.$window.localStorage.getItem('account');
	            if (account) {
	                this.username = JSON.parse(account).user.userName;
	            }
	
	            if (this.AuthService.isTransportChief()) {
	                this.showTransportLink = true;
	                this.showReportsLink = false;
	            }
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            this.AuthService.logout();
	        }
	    }, {
	        key: 'toggle',
	        value: function toggle() {
	            this.menuOpen = !this.menuOpen;
	            this.$rootScope.$emit('sb.page.menu', { open: this.menuOpen });
	        }
	    }]);
	    return PageHeaderController;
	}();
	
	exports.default = PageHeaderController;

/***/ }),
/* 209 */
3,
/* 210 */,
/* 211 */
/***/ (function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-default\"> <div class=container> <div class=\"navbar-header navbar-right\"> <button type=button class=\"navbar-toggle collapsed\" ng-click=$ctrl.toggle()> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span> </button> <a class=navbar-brand href=#!/home> <img class=sb-page-header-logo src=/assets/logotype_white.svg /> </a> </div> <div class=\"navbar-collapse collapse\" ng-show=$ctrl.menuOpen> <ul class=\"nav navbar-nav\"> <li><a href=#!/home translate>NAVIGATION.HOME</a></li> <li ng-if=$ctrl.showReportsLink><a href=#!/report/carts translate>NAVIGATION.REPORT</a></li> <li ng-if=$ctrl.showTransportLink><a href=#!/transports translate>NAVIGATION.TRANSPORTS</a></li> <li role=separator class=divider></li> <li><a href=#!/report/carts ng-click=$ctrl.logout(); translate>NAGIVATION.LOGOUT</a></li> </ul> </div> </div> </nav> ";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	__webpack_require__(213);
	
	var PageFooterComponent = {
	    selector: 'sbPageFooter',
	    template: __webpack_require__(215)
	};
	
	exports.default = PageFooterComponent;

/***/ }),
/* 213 */
3,
/* 214 */,
/* 215 */
/***/ (function(module, exports) {

	module.exports = "<footer class=sb-page-footer> <div class=container> <div class=row> <div class=col-xs-12> <h4 translate>FOOTER.SUPPORT</h4> </div> </div> <div class=row> <div class=col-md-2> <a href=tel:+46>+46 (0)454 30 83 00</a> </div> <div class=col-md-10> <a href=mailto:info@scanbox.se>info@scanbox.se</a> </div> </div> </div> </footer> <div class=sb-page-footer-copy> <div class=container> <div class=row> <div class=col-xs-12> <span class=pull-right translate>FOOTER.COPYRIGHT</span> </div> </div> </div> </div> ";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	__webpack_require__(217);
	
	var PageContextComponent = {
	    selector: 'sbPageContext',
	    template: __webpack_require__(219),
	    transclude: true
	};
	
	exports.default = PageContextComponent;

/***/ }),
/* 217 */
3,
/* 218 */,
/* 219 */
/***/ (function(module, exports) {

	module.exports = "<div class=sb-view-context> <div ng-transclude></div> </div> ";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _domainSelector = __webpack_require__(221);
	
	var _domainSelector2 = _interopRequireDefault(_domainSelector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(222);
	
	var DomainSelectorComponent = {
	    selector: 'sbDomainSelector',
	    controller: _domainSelector2.default,
	    template: __webpack_require__(224),
	    bindings: {
	        onSelect: '&'
	    }
	};
	
	exports.default = DomainSelectorComponent;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DomainSelectorController = function () {
	    /* @ngInject */
	    function DomainSelectorController($log, $location, ThingsService) {
	        (0, _classCallCheck3.default)(this, DomainSelectorController);
	
	        this.$log = $log;
	        this.$location = $location;
	        this.ThingsService = ThingsService;
	        this.domain = {};
	        this.selectedDomainId = undefined;
	        this.selectedDomainName = undefined;
	        this.isLoading = true;
	    }
	
	    (0, _createClass3.default)(DomainSelectorController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.isLoading = true;
	            this.ThingsService.getDomains().then(function (rootDomain) {
	                _this.domain = rootDomain;
	
	                // Select any already selected domain, this needs to be done
	                // after the domains are retrieved to use the correct name
	                _this.selectedDomainId = _this.ThingsService.selectedDomain;
	                _this.selectedDomainName = _this.resolveDomainName();
	            }).catch(function (error) {
	                _this.$log.info('Error getting domains: ' + error);
	            }).finally(function () {
	                _this.isLoading = false;
	            });
	        }
	    }, {
	        key: 'select',
	        value: function select(domainId) {
	            this.selectedDomainId = domainId;
	            this.selectedDomainName = this.resolveDomainName();
	            this.onSelect({ domainId: domainId });
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            this.selectedDomainId = undefined;
	            this.onSelect({ domainId: undefined });
	        }
	    }, {
	        key: 'resolveDomainName',
	        value: function resolveDomainName() {
	            var _this2 = this;
	
	            var domain = this.domain.allChildren().filter(function (d) {
	                return d.id === _this2.selectedDomainId;
	            }).shift();
	            return domain !== undefined ? domain.name : '';
	        }
	    }]);
	    return DomainSelectorController;
	}();
	
	exports.default = DomainSelectorController;

/***/ }),
/* 222 */
3,
/* 223 */,
/* 224 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"dropdown sb-domain-selector\"> <button class=\"btn btn-default dropdown-toggle\" type=button id=dropdownMenu1 data-toggle=dropdown aria-haspopup=true aria-expanded=true bs-dropdown> <span ng-if=$ctrl.selectedDomainId class=sb-domain-selector-name>{{ $ctrl.selectedDomainName }}</span> <span ng-if=!$ctrl.selectedDomainId class=sb-domain-selector-name translate>DOMAINS.ALL</span> <span class=caret></span> </button> <ul class=dropdown-menu> <li> <a ng-click=$ctrl.reset(); ng-class=\"{ 'sb-is-selected': !c.id }\" translate>All domains</a></li> <li role=separator class=divider></li> <li ng-if=$ctrl.isLoading ng-class=\"{ 'sb-is-loading' : $ctrl.isLoading }\"> <span translate>DOMAIN.SELECTOR.LOADING</span> </li> <li ng-repeat=\"c in $ctrl.domain.allChildren();\"> <a class=\"sb-domain-level{{ c.level }}\" ng-click=$ctrl.select(c.id); ng-class=\"{ 'sb-is-selected': c.id === $ctrl.selectedDomainId }\">{{ c.name }}</a> </li> </ul> </div> ";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	__webpack_require__(226);
	
	//
	// NOTE:
	// In order to close the modal the using component controller needs
	// to access the scope function `$hide()` (or improve the code to be
	// able to give a onClose callback as binding).
	//
	var ModalComponent = {
	    selector: 'sbModal',
	    template: __webpack_require__(228),
	    bindings: {
	        title: '@'
	    },
	    transclude: {
	        header: '?sbModalHeader',
	        content: '?sbModalContent',
	        actions: '?sbModalActions'
	    }
	};
	
	exports.default = ModalComponent;

/***/ }),
/* 226 */
3,
/* 227 */,
/* 228 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal sb-modal\" tabindex=-1 role=dialog> <div class=modal-dialog> <div class=\"modal-content panel\"> <div class=\"panel-header modal-header\"> <div class=row> <div class=col-md-9> <h3 class=panel-title style=text-align:left>{{ ::$ctrl.title }}</h3> </div> <div class=col-md-3> <div ng-transclude=header></div> </div> </div> </div> <div class=\"panel-body modal-body\"> <div ng-transclude=content></div> </div> <div class=\"panel-footer modal-footer\"> <div ng-transclude=actions></div> </div> </div> </div> </div> ";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _cartSettings = __webpack_require__(230);
	
	var _cartSettings2 = _interopRequireDefault(_cartSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CartSettingsComponent = {
	    selector: 'sbCartSettings',
	    template: __webpack_require__(231),
	    controller: _cartSettings2.default,
	    bindings: {
	        cartId: '<'
	    }
	};
	
	exports.default = CartSettingsComponent;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(24);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Regular expression used to identify the message sent by this
	// modal. Builds on the assumption that no one else edit these
	// properties.
	var OUR_MESSAGE_REGEXP = new RegExp(/name|serial|modal/);
	
	var CartSettingsController = function () {
	    /* @ngInject */
	    function CartSettingsController($log, $scope, $rootScope, $timeout, ThingsService, ShadowService) {
	        (0, _classCallCheck3.default)(this, CartSettingsController);
	
	        this.$log = $log;
	        this.$scope = $scope;
	        this.$rootScope = $rootScope;
	        this.$timeout = $timeout;
	        this.ThingsService = ThingsService;
	        this.ShadowService = ShadowService;
	
	        this.errorReading = false;
	        this.errorWriting = false;
	        this.errorConnection = false;
	        this.client = undefined;
	        this.isClosing = false;
	        this.isSaving = false;
	        this.currentThingName = '';
	        // The settings displayed in the  UI
	        this.settings = {
	            label: undefined,
	            serial: undefined,
	            modal: undefined
	        };
	        // The Thing properties needed in order to save settings
	        this.thing = {
	            thingName: undefined,
	            domainId: undefined,
	            domainPath: undefined
	        };
	    }
	
	    (0, _createClass3.default)(CartSettingsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.ThingsService.getThing(this.cartId).then(function (thing) {
	                _this.settings.label = thing.label;
	                _this.currentThingName = thing.label;
	                _this.settings.serial = thing.shadow.state.reported.serial;
	                _this.settings.model = thing.shadow.state.reported.model;
	                _this.thing.domainId = thing.domain.id;
	                _this.thing.thingName = thing.thingName;
	            }).then(function () {
	                return _this.ThingsService.getDomains();
	            }).then(function (rootDomain) {
	                _this.$log.log('Connecting...');
	                _this.thing.domainPath = rootDomain.resolvePath(_this.thing.domainId);
	                // The MQTT topic's exposed does not use root as part of the domain path
	                _this.thing.domainPath = _this.thing.domainPath.replace('root/', '');
	                return _this.ShadowService.connect(_this.thing.thingName);
	            }).then(function (client) {
	                _this.$log.log('Connected!');
	                _this.client = client;
	                _this.client.onMessageArrived = _this.onMessage.bind(_this);
	                _this.client.onConnectionLost = _this.onConnectionLost.bind(_this);
	                _this.client.subscribe('thing-update/' + _this.thing.domainPath + '/' + _this.thing.thingName);
	            }).catch(function (error) {
	                _this.$log.info('Error getting thing: ' + error);
	                _this.errorReading = true;
	            });
	        }
	
	        /**
	         * Called from the UI in order to close the modal.
	         */
	
	    }, {
	        key: 'onClose',
	        value: function onClose() {
	            this.isClosing = true;
	            // This is quite ugly but seems impossible to give the `$hide`
	            // method as a binding.
	            this.$scope.$parent.$parent.$hide();
	            if (this.client !== undefined) {
	                try {
	                    this.client.disconnect();
	                } catch (e) {
	                    this.$log.log('Error closing connection, most likely already closed');
	                }
	            }
	        }
	
	        /**
	         * Called from the UI in order to save the cart settings.
	         */
	
	    }, {
	        key: 'save',
	        value: function save() {
	            var _this2 = this;
	
	            this.isSaving = true;
	            try {
	                if (this.currentThingName !== this.settings.label) {
	                    // call ThingService (Lambda) to rename
	                    var params = {
	                        thingId: this.cartId,
	                        domain: this.thing.domainId,
	                        label: this.settings.label
	                    };
	                    this.ThingsService.updateThing(params).then(function () {
	                        // Continue to publish virtual resources to 'thing-update' topic
	                        _this2.sendMessage(angular.copy(_this2.settings)); // eslint-disable-line
	                    }).catch(function (error) {
	                        _this2.$log.error('Error renaming cart', error);
	                    });
	                } else {
	                    this.sendMessage(angular.copy(this.settings)); // eslint-disable-line
	                }
	            } catch (e) {
	                this.$log.error('Could not write settings');
	                this.errorWriting = true;
	            }
	        }
	    }, {
	        key: 'sendMessage',
	        value: function sendMessage(settings) {
	            delete settings.label;
	            var message = new Paho.MQTT.Message('{ "state": { "reported": ' + (0, _stringify2.default)(settings) + '}}'); // eslint-disable-line
	            message.destinationName = 'thing-update/' + this.thing.domainPath + '/' + this.thing.thingName;
	            this.client.send(message);
	        }
	    }, {
	        key: 'onConnectionLost',
	        value: function onConnectionLost() {
	            if (!this.isClosing) {
	                this.$log.error('Connection lost!');
	                this.errorConnection = true;
	            }
	        }
	    }, {
	        key: 'onMessage',
	        value: function onMessage(message) {
	            var _this3 = this;
	
	            // If the message received is accepted write on our request we should close the modal
	            this.$log.log('Received message ' + message.payloadString + ' on topic ' + message.destinationName);
	
	            if (this.isSaving) {
	                if (OUR_MESSAGE_REGEXP.test(message.payloadString)) {
	                    this.$log.log('Looks like our request...');
	
	                    if (message.destinationName.startsWith('thing-update')) {
	                        this.$timeout(function () {
	                            // Not clear why this timeout is needed? Without it, the updates are not shown in the UI.
	                            _this3.$rootScope.$emit('cartSettingsUpdated');
	                            _this3.onClose();
	                        }, 500);
	                    } else {
	                        this.errorWriting = true;
	                    }
	                    this.$scope.$apply(); // Callback originates from socket so we need to manually invoke a digest
	                }
	            }
	        }
	    }]);
	    return CartSettingsController;
	}();
	
	exports.default = CartSettingsController;

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	module.exports = "<sb-modal title=\"{{ 'Cart settings' | translate }}\"> <sb-modal-content> <form name=$ctrl.form ng-model-options=\"{ updateOn: 'blur' }\" ng-submit=$ctrl.submit() novalidate> <div class=form-group ng-class=\"{ 'has-error': ($ctrl.form.label.$invalid && $ctrl.form.label.$touched) }\"> <label for=label translate>Name</label> <input type=text class=form-control id=label name=label placeholder=\"Cart name\" ng-model=$ctrl.settings.label required=required ng-required=true /> <span class=text-danger ng-messages=$ctrl.form.label.$error ng-show=\"$ctrl.form.label.$invalid && $ctrl.form.label.$touched\"> <div class=sb-error-message ng-message=required translate>Name is required</div> </span> </div> <div class=form-group> <label for=cart-settings-serial translate>Serial number</label> <input type=text class=form-control id=cart-settings-name placeholder=\"123 456 798\" name=serial ng-model=$ctrl.settings.serial /> </div> <div class=form-group> <label for=cart-settings-model translate>Model</label> <input type=text class=form-control id=cart-settings-model placeholder=\"Ergo line\" ng-model=$ctrl.settings.model /> </div> </form> <div class=\"alert alert-danger\" role=alert ng-if=$ctrl.errorReading translate> Unable to retrieve cart settings, please try again! </div> <div class=\"alert alert-danger\" role=alert ng-if=$ctrl.errorWriting translate> Unable to save the cart settings, please try again! </div> <div class=\"alert alert-danger\" role=alert ng-if=$ctrl.errorConnection translate> Connection to server lost, please reopen settings! </div> </sb-modal-content> <sb-modal-actions> <i ng-show=$ctrl.isSaving class=\"fa fa-spinner fa-spin fa-2x fa-fw\" style=vertical-align:middle></i> <button type=button class=\"btn btn-default\" ng-click=$ctrl.onClose() translate>Close</button> <button type=button class=\"btn btn-primary\" ng-click=$ctrl.save() ng-disabled=\"$ctrl.form.$invalid || $ctrl.isSaving\" translate>Save</button> </sb-modal-actions> </sb-modal> ";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _alarmNotifications = __webpack_require__(233);
	
	var _alarmNotifications2 = _interopRequireDefault(_alarmNotifications);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(234);
	
	var AlarmNotificationsComponent = {
	    selector: 'sbAlarmNotifications',
	    controller: _alarmNotifications2.default,
	    template: __webpack_require__(236)
	};
	
	exports.default = AlarmNotificationsComponent;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlarmDialogController = function () {
	    /* @ngInject */
	    function AlarmDialogController($log, $routeParams, $q, EventsService) {
	        (0, _classCallCheck3.default)(this, AlarmDialogController);
	
	        this.$log = $log;
	        this.$routeParams = $routeParams;
	        this.$q = $q;
	        this.EventsService = EventsService;
	        this.alarms = [];
	        this.latestUniqueAlarms = [];
	    }
	
	    (0, _createClass3.default)(AlarmDialogController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.getAlarmsToAcknowledge();
	        }
	    }, {
	        key: "getAlarmsToAcknowledge",
	        value: function getAlarmsToAcknowledge() {
	            var _this = this;
	
	            // Get thing's all un-acknowledged alarms from a year back
	            var params = {
	                thingId: this.$routeParams.id,
	                fromDate: new Date().setMonth(-12),
	                toDate: new Date().valueOf()
	            };
	
	            this.EventsService.getEventsToAcknowledge(params).then(function (response) {
	                if (response.hits.hits.length !== 0) {
	                    _this.alarms = response.hits.hits;
	
	                    // Pick first alarm for unique rules. Response assumed ordered on timestamp descending
	                    _this.latestUniqueAlarms = _this.alarms.filter(function (alarm, index, self) {
	                        return self.findIndex(function (t) {
	                            return t._source.source.rule === alarm._source.source.rule;
	                        }) === index;
	                    });
	
	                    // Add boolean to each unigue alarm. Used by spinner when acknowledging.
	                    _this.latestUniqueAlarms.forEach(function (l) {
	                        l.isAcknowledging = false;
	                    });
	                } else {
	                    _this.alarms = [];
	                }
	            });
	        }
	    }, {
	        key: "acknowledgeAlarmsForRule",
	        value: function acknowledgeAlarmsForRule(alarmEvent) {
	            var _this2 = this;
	
	            alarmEvent.isAcknowledging = true;
	
	            // Filter out all alarms for current rule
	            var ruleAlarms = this.alarms.filter(function (a) {
	                return a._source.source.rule === alarmEvent._source.source.rule;
	            });
	
	            // Acknowledge the events and resolve the promises
	            var promises = [];
	            ruleAlarms.map(function (alarm) {
	                return promises.push(_this2.EventsService.acknowledgeEvent(alarm));
	            });
	
	            this.$q.all(promises).then(function () {
	                // 'refresh' list of alarms to acknowledge
	                _this2.getAlarmsToAcknowledge();
	            }).catch(function (error) {
	                _this2.$log.info("Failed to acknowledge alarms: " + error);
	            });
	        }
	    }]);
	    return AlarmDialogController;
	}();
	
	exports.default = AlarmDialogController;

/***/ }),
/* 234 */
3,
/* 235 */,
/* 236 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"$ctrl.alarms.length > 0\"> <div ng-repeat=\"alarm in $ctrl.latestUniqueAlarms\" class=\"alert alert-danger\"> <div class=container> <div class=row> <div class=\"col-sm-10 col-xs-7\"> <h6>{{alarm._source.timestamp | date:'yyyy-MM-dd HH:mm:ss'}}</h6> <h5><strong>{{alarm._source.message}}</strong></h5> </div> <div class=\"col-sm-2 col-xs-5\"> <button class=\"btn btn-danger pull-right sb-check\" ng-click=$ctrl.acknowledgeAlarmsForRule(alarm)> <span ng-show=!alarm.isAcknowledging><i class=\"fa fa-check fa-lg\" aria-hidden=true></i> {{ 'ALARMS.ACKNOWLEDGE' | translate }}</span> <span ng-show=alarm.isAcknowledging><i class=\"fa fa-spinner fa-lg fa-spin\" aria-hidden=true></i> {{ 'ALARMS.ACKNOWLEDGING' | translate }}</span> </button> </div> </div> </div> </div> </div> ";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	__webpack_require__(238);
	
	var EmptyBoxComponent = {
	    selector: 'sbEmptyBox',
	    template: __webpack_require__(240),
	    bindings: {
	        title: '@',
	        message: '@',
	        iconCss: '@'
	    }
	};
	
	exports.default = EmptyBoxComponent;

/***/ }),
/* 238 */
3,
/* 239 */,
/* 240 */
/***/ (function(module, exports) {

	module.exports = "<div class=sb-empty-box> <i class=\"fa fa-3x {{ $ctrl.iconCss }}\" aria-hidden=true></i> <h1 translate>{{ $ctrl.title }}</h1> <p class=text-muted translate>{{ $ctrl.message }}</p> </div> ";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _transports = __webpack_require__(242);
	
	var _transports2 = _interopRequireDefault(_transports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(305);
	
	var TransportsComponent = {
	    selector: 'sbTransports',
	    controller: _transports2.default,
	    template: __webpack_require__(307)
	};
	
	exports.default = TransportsComponent;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getPrototypeOf = __webpack_require__(243);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _create = __webpack_require__(254);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _assign = __webpack_require__(270);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(276);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(297);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _transportsUtil = __webpack_require__(301);
	
	var _transportsUtil2 = _interopRequireDefault(_transportsUtil);
	
	var _Transport = __webpack_require__(302);
	
	var _Transport2 = _interopRequireDefault(_Transport);
	
	var _ComplianceState = __webpack_require__(303);
	
	var _ComplianceState2 = _interopRequireDefault(_ComplianceState);
	
	var _Warning = __webpack_require__(304);
	
	var _Warning2 = _interopRequireDefault(_Warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransportsController = function () {
	    /* @ngInject */
	    function TransportsController($log, $modal, $scope, AuthService, ThingsService) {
	        (0, _classCallCheck3.default)(this, TransportsController);
	
	        this.$log = $log;
	        this.$modal = $modal;
	        this.$scope = $scope;
	        this.AuthService = AuthService;
	        this.ThingsService = ThingsService;
	        this.showingModal = false;
	        this.transports = [];
	        this.modalTransport = null;
	
	        this.things = [];
	        this.showGraph = true;
	
	        this.toDate = new Date();
	        this.toDate.setHours(0, 0, 0);
	        this.fromDate = new Date(this.toDate);
	        this.fromDate.setDate(this.toDate.getDate() - 3);
	        this.toDate.setHours(23, 59, 59);
	    }
	
	    (0, _createClass3.default)(TransportsController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            // const account = this.AuthService.getLocalAccount();
	            // console.log(account);
	            // this.ThingsService.selectedDomain = account.user.domainPath;
	
	            this.findThingsAndLoadTransports();
	
	            if (this.AuthService.isTransportChief()) {
	                this.showGraph = false;
	            }
	
	            this.dateWatcher = this.$scope.$watchGroup(['$ctrl.fromDate', '$ctrl.toDate'], function (newValue, oldValue) {
	                if (newValue[0] !== oldValue[0] || newValue[1] !== oldValue[1]) {
	                    _this.loadTransports(_this.fromDate, _this.toDate);
	                }
	            });
	        }
	    }, {
	        key: 'loadTransports',
	        value: function loadTransports(fromDate, toDate) {
	            var _this2 = this;
	
	            this.transports = [];
	            this.things.forEach(function (thing) {
	                var thingId = thing._source.thingName;
	                var params = {
	                    fromDate: fromDate,
	                    toDate: toDate,
	                    thingId: thingId
	                };
	
	                _this2.ThingsService.getRawHACCPObservations(params).then(function (data) {
	                    var transport = new _Transport2.default();
	                    var doorOpenDuringTransportTimestamp = void 0;
	                    var tempBadTimestamp = void 0;
	                    var lastDoorCloseTimestamp = void 0;
	                    var previousDoorOpenState = void 0;
	                    // let okTempTimestamp;
	                    var oldTransportInProgress = true;
	
	                    var state = {};
	
	                    data.hits.hits.forEach(function (rawObservation) {
	                        var observation = rawObservation._source;
	                        var observationTimestamp = Math.round(observation.timestamp / 1000); // Timestamp in seconds
	
	                        // Aggregate state to keep all data in one state variable.
	                        (0, _entries2.default)(observation.state).forEach(function (_ref) {
	                            var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	                                key = _ref2[0],
	                                val = _ref2[1];
	
	                            state[key] = val;
	                        });
	
	                        // Handle door close
	                        if (previousDoorOpenState === 1 && state.door_open === 0) {
	                            // Last door close is used for haccp compliance start
	                            lastDoorCloseTimestamp = observationTimestamp;
	                        } else if (state.door_open === 0 && !lastDoorCloseTimestamp) {
	                            lastDoorCloseTimestamp = observationTimestamp;
	                        }
	                        previousDoorOpenState = state.door_open;
	
	                        // --- Verkar inte användas.  Kommenterar ut
	                        // Handle timestamp for initial reaching of OK temp
	                        // if (!okTempTimestamp && (state.box_temperature >= 60 || state.box_temperature <= 8)) {
	                        //     okTempTimestamp = observationTimestamp;
	                        // } else if (okTempTimestamp && state.box_temperature < 60 && state.box_temperature > 8) {
	                        //     okTempTimestamp = null;
	                        // }
	
	                        // Ignore further logic for transports that started before start of observation period.
	                        if (oldTransportInProgress) {
	                            if (state.Virtual_In_Transport === 0) {
	                                oldTransportInProgress = false;
	                            } else {
	                                return;
	                            }
	                        }
	
	                        // Handle alarms and end of compliance
	                        if (transport.start) {
	                            if (state.door_open === 1 && _transportsUtil2.default.complianceStartedNotEnded(transport)) {
	                                if (!doorOpenDuringTransportTimestamp && !transport.end) {
	                                    var warning = new _Warning2.default('door', observationTimestamp, true, 'TRANSPORTS.DOOR.OPENED', state.latlng);
	                                    transport.applyWarningIfNotPresent(warning);
	                                    transport.complianceEnd = observationTimestamp;
	                                    transport.setComplianceState(_ComplianceState2.default.Alarm);
	                                } else if (!doorOpenDuringTransportTimestamp && transport.end) {
	                                    // Transport stopped. Open door ends compliance period
	                                    transport.complianceEnd = observationTimestamp;
	                                } else if (observationTimestamp > doorOpenDuringTransportTimestamp + 15) {
	                                    var _warning = new _Warning2.default('door', observationTimestamp, true, 'TRANSPORTS.DOOR.OPEN.TOO.LONG', state.latlng);
	                                    transport.applyWarningIfNotPresent(_warning);
	                                    transport.complianceEnd = observationTimestamp;
	
	                                    transport.setComplianceState(_ComplianceState2.default.NoneCompliant);
	                                }
	                            }
	
	                            if (_transportsUtil2.default.badTemperature(state) && !transport.end && _transportsUtil2.default.complianceStartedNotEnded(transport)) {
	                                if (!tempBadTimestamp) {
	                                    var _warning2 = new _Warning2.default('temp', observationTimestamp, true, 'TRANSPORTS.TEMP.NOT.OK', state.latlng);
	                                    transport.applyWarningIfNotPresent(_warning2);
	                                    transport.complianceEnd = observationTimestamp;
	                                    transport.setComplianceState(_ComplianceState2.default.Alarm);
	                                } else if (_transportsUtil2.default.badTemperature(state) && transport.end) {
	                                    // Transport stopped. Bad temp ends compliance period
	                                    transport.complianceEnd = observationTimestamp;
	                                } else if (observationTimestamp > tempBadTimestamp + 30) {
	                                    var _warning3 = new _Warning2.default('temp', observationTimestamp, true, 'TRANSPORTS.TEMP.BAD.TOO.LONG', state.latlng);
	                                    transport.applyWarningIfNotPresent(_warning3);
	                                    transport.complianceEnd = observationTimestamp;
	                                    transport.setComplianceState(_ComplianceState2.default.NoneCompliant);
	                                }
	                            }
	                        }
	
	                        // Handle return to compliance (with warning) for door open state
	                        if (doorOpenDuringTransportTimestamp) {
	                            if (state.door_open === 0 && observationTimestamp < doorOpenDuringTransportTimestamp + 15) {
	                                var _warning4 = new _Warning2.default('door', observationTimestamp, false, 'TRANSPORTS.DOOR.OPEN.OK', state.latlng);
	                                transport.applyWarningIfNotPresent(_warning4);
	                                transport.setComplianceState(_ComplianceState2.default.CompliantWithWarnings);
	
	                                transport.complianceStart = lastDoorCloseTimestamp;
	                                doorOpenDuringTransportTimestamp = null;
	                            } else if (state.door_open === 0 && observationTimestamp > doorOpenDuringTransportTimestamp + 15 && _transportsUtil2.default.complianceStartedNotEnded(transport)) {
	                                var _warning5 = new _Warning2.default('door', observationTimestamp, true, 'TRANSPORTS.DOOR.OPEN.NOT.OK', state.latlng);
	                                transport.applyWarningIfNotPresent(_warning5);
	                                transport.complianceEnd = observationTimestamp;
	                                transport.setComplianceState(_ComplianceState2.default.NoneCompliant);
	                                doorOpenDuringTransportTimestamp = null;
	                            }
	                        }
	
	                        // Handle return to compliance (with warning) for temp bad state
	                        // TODO: This doesn't catch if temperature should be > 60 but is actually < 8, etc.
	                        // TODO: ... But there is no data for what temp the box should be during transport.
	                        if (tempBadTimestamp) {
	                            if (observationTimestamp < tempBadTimestamp + 30 && (state.box_temperature < 8 || state.box_temperature > 60)) {
	                                var _warning6 = new _Warning2.default('temp', observationTimestamp, false, 'TRANSPORTS.TEMP.BAD.OK', state.latlng);
	                                transport.applyWarningIfNotPresent(_warning6);
	                                transport.complianceStart = lastDoorCloseTimestamp;
	                                tempBadTimestamp = null;
	                                transport.setComplianceState(_ComplianceState2.default.CompliantWithWarnings);
	                            } else if (observationTimestamp > tempBadTimestamp + 30 && (state.box_temperature < 8 || state.box_temperature > 60) && _transportsUtil2.default.complianceStartedNotEnded(transport)) {
	                                var _warning7 = new _Warning2.default('temp', observationTimestamp, true, 'TRANSPORTS.TEMP.BAD.NOT.OK', state.latlng);
	                                transport.applyWarningIfNotPresent(_warning7);
	                                transport.complianceEnd = observationTimestamp;
	                                tempBadTimestamp = null;
	                                transport.setComplianceState(_ComplianceState2.default.NoneCompliant);
	                            }
	                        }
	
	                        // Handle start & end of transport
	                        if (state.Virtual_In_Transport === 1) {
	                            if (!transport.start) {
	                                // this.$log.log('transport.start', thingId, observationTimestamp);
	                                transport.unitId = thingId;
	                                transport.start = observationTimestamp;
	                                transport.startTemp = state.box_temperature;
	
	                                if (state.door_open === 1) {
	                                    doorOpenDuringTransportTimestamp = observationTimestamp;
	                                }
	
	                                if (_transportsUtil2.default.badTemperature(state)) {
	                                    tempBadTimestamp = observationTimestamp;
	                                }
	
	                                if (!doorOpenDuringTransportTimestamp && !tempBadTimestamp) {
	                                    // Villkor för haccp_start (sista dörrstängningen innan start av transport)
	                                    transport.complianceStart = lastDoorCloseTimestamp;
	                                    transport.setComplianceState(_ComplianceState2.default.Compliant);
	                                }
	                            }
	                        } else if (state.Virtual_In_Transport === 0 && transport.start && !transport.end && state.door_open === 0) {
	                            transport.end = observationTimestamp;
	                        } else if (state.Virtual_In_Transport === 0 && transport.end) {
	                            // If not compliance ended by any warning, end the compliance period when Door opens after transport ended.
	                            if (_transportsUtil2.default.complianceStartedNotEnded(transport) && state.door_open === 0) {
	                                transport.complianceEnd = observationTimestamp;
	                            }
	
	                            // Check duration compliance
	                            if (_transportsUtil2.default.haccpCompliantWarningDuration(lastDoorCloseTimestamp, transport.complianceEnd)) {
	                                var _warning8 = new _Warning2.default('door', observationTimestamp, false, 'TRANSPORTS.LONG.OK', state.latlng);
	                                transport.applyWarningIfNotPresent(_warning8);
	                                transport.setComplianceState(_ComplianceState2.default.CompliantWithWarnings);
	                            }
	                            if (_transportsUtil2.default.haccpNotCompliantDuration(lastDoorCloseTimestamp, transport.complianceEnd)) {
	                                var _warning9 = new _Warning2.default('door', observationTimestamp, true, 'TRANSPORTS.LONG.NOT.OK', state.latlng);
	                                transport.applyWarningIfNotPresent(_warning9);
	                                transport.setComplianceState(_ComplianceState2.default.NoneCompliant);
	                            }
	
	                            // Add transport when within limits
	                            if (_transportsUtil2.default.isTransportDurationWithinLimits(transport)) {
	                                _this2.transports.push((0, _assign2.default)((0, _create2.default)((0, _getPrototypeOf2.default)(transport)), transport));
	                            }
	
	                            transport = new _Transport2.default();
	                            doorOpenDuringTransportTimestamp = null;
	                            tempBadTimestamp = null;
	                            lastDoorCloseTimestamp = null;
	                            previousDoorOpenState = null;
	                            // okTempTimestamp = null;
	                            oldTransportInProgress = true;
	                        }
	                    });
	                }).then(function () {
	                    // TODO: This should be done just once after all transports are loaded, but couldn't get it to work.
	                    _this2.transports = _this2.transports.sort(function (a, b) {
	                        return a.start < b.start ? 1 : -1;
	                    });
	
	                    _this2.transports.forEach(function (t) {
	                        t.unitName = _this2.things.find(function (s) {
	                            return s._id === t.unitId;
	                        })._source.label;
	                    });
	                });
	            });
	        }
	    }, {
	        key: 'filterOnDomain',
	        value: function filterOnDomain(domainId) {
	            this.transports = [];
	            this.things = [];
	            this.ThingsService.selectedDomain = domainId;
	            this.findThingsAndLoadTransports();
	        }
	    }, {
	        key: 'findThingsAndLoadTransports',
	        value: function findThingsAndLoadTransports() {
	            var _this3 = this;
	
	            this.transports = [];
	            this.ThingsService.getThings().then(function (response) {
	                _this3.things = response.hits.hits;
	            }).then(function () {
	                _this3.loadTransports(new Date(_this3.fromDate), new Date(_this3.toDate));
	            });
	        }
	    }, {
	        key: 'getThings',
	        value: function getThings() {
	            var _this4 = this;
	
	            this.transports = [];
	            this.things = [];
	            this.ThingsService.getThings().then(function (response) {
	                _this4.things = response.hits.hits;
	            });
	        }
	    }, {
	        key: 'showModal',
	        value: function showModal(transport) {
	            this.modalTransport = transport;
	            this.showingModal = true;
	        }
	    }, {
	        key: 'hideModal',
	        value: function hideModal() {
	            this.showingModal = false;
	        }
	    }]);
	    return TransportsController;
	}();
	
	exports.default = TransportsController;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(244), __esModule: true };

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(245);
	module.exports = __webpack_require__(26).Object.getPrototypeOf;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(246);
	var $getPrototypeOf = __webpack_require__(248);
	
	__webpack_require__(253)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(247);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 247 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(45);
	var toObject = __webpack_require__(246);
	var IE_PROTO = __webpack_require__(249)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(250)('keys');
	var uid = __webpack_require__(252);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(26);
	var global = __webpack_require__(32);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(251) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(31);
	var core = __webpack_require__(26);
	var fails = __webpack_require__(41);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(255), __esModule: true };

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(256);
	var $Object = __webpack_require__(26).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(31);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(257) });


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(37);
	var dPs = __webpack_require__(258);
	var enumBugKeys = __webpack_require__(268);
	var IE_PROTO = __webpack_require__(249)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(42)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(269).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(36);
	var anObject = __webpack_require__(37);
	var getKeys = __webpack_require__(259);
	
	module.exports = __webpack_require__(40) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(260);
	var enumBugKeys = __webpack_require__(268);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(45);
	var toIObject = __webpack_require__(261);
	var arrayIndexOf = __webpack_require__(264)(false);
	var IE_PROTO = __webpack_require__(249)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(262);
	var defined = __webpack_require__(247);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(263);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(261);
	var toLength = __webpack_require__(265);
	var toAbsoluteIndex = __webpack_require__(267);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(266);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 266 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(266);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(32).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(271), __esModule: true };

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(272);
	module.exports = __webpack_require__(26).Object.assign;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(31);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(273) });


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(40);
	var getKeys = __webpack_require__(259);
	var gOPS = __webpack_require__(274);
	var pIE = __webpack_require__(275);
	var toObject = __webpack_require__(246);
	var IObject = __webpack_require__(262);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(41)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 275 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(277);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(293);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(278), __esModule: true };

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(279);
	__webpack_require__(289);
	module.exports = __webpack_require__(291);


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(280);
	var global = __webpack_require__(32);
	var hide = __webpack_require__(35);
	var Iterators = __webpack_require__(283);
	var TO_STRING_TAG = __webpack_require__(288)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(281);
	var step = __webpack_require__(282);
	var Iterators = __webpack_require__(283);
	var toIObject = __webpack_require__(261);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(284)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 281 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 282 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 283 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(251);
	var $export = __webpack_require__(31);
	var redefine = __webpack_require__(285);
	var hide = __webpack_require__(35);
	var Iterators = __webpack_require__(283);
	var $iterCreate = __webpack_require__(286);
	var setToStringTag = __webpack_require__(287);
	var getPrototypeOf = __webpack_require__(248);
	var ITERATOR = __webpack_require__(288)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(35);


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(257);
	var descriptor = __webpack_require__(44);
	var setToStringTag = __webpack_require__(287);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(35)(IteratorPrototype, __webpack_require__(288)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(36).f;
	var has = __webpack_require__(45);
	var TAG = __webpack_require__(288)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(250)('wks');
	var uid = __webpack_require__(252);
	var Symbol = __webpack_require__(32).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(290)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(284)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(266);
	var defined = __webpack_require__(247);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(292);
	var ITERATOR = __webpack_require__(288)('iterator');
	var Iterators = __webpack_require__(283);
	module.exports = __webpack_require__(26).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(263);
	var TAG = __webpack_require__(288)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(294), __esModule: true };

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(279);
	__webpack_require__(289);
	module.exports = __webpack_require__(295);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(37);
	var get = __webpack_require__(296);
	module.exports = __webpack_require__(26).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(292);
	var ITERATOR = __webpack_require__(288)('iterator');
	var Iterators = __webpack_require__(283);
	module.exports = __webpack_require__(26).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(298), __esModule: true };

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299);
	module.exports = __webpack_require__(26).Object.entries;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(31);
	var $entries = __webpack_require__(300)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(40);
	var getKeys = __webpack_require__(259);
	var toIObject = __webpack_require__(261);
	var isEnum = __webpack_require__(275).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransportsUtil = function () {
	    function TransportsUtil() {
	        (0, _classCallCheck3.default)(this, TransportsUtil);
	    }
	
	    (0, _createClass3.default)(TransportsUtil, null, [{
	        key: 'isTransportDurationWithinLimits',
	
	
	        // <6h && >6min
	        value: function isTransportDurationWithinLimits(transport) {
	            if (transport.end - transport.start > 6 * 60 && transport.end - transport.start < 6 * 60 * 60) {
	                return true;
	            }
	
	            return false;
	        }
	
	        // <2h
	
	    }, {
	        key: 'haccpCompliantDuration',
	        value: function haccpCompliantDuration(doorClosedTimeStamp, doorOpenedTimeStamp) {
	            if (doorOpenedTimeStamp - doorClosedTimeStamp < 2 * 60 * 60) {
	                return true;
	            }
	            return false;
	        }
	
	        // >2h && <2.5h
	
	    }, {
	        key: 'haccpCompliantWarningDuration',
	        value: function haccpCompliantWarningDuration(doorClosedTimeStamp, doorOpenedTimeStamp) {
	            if (doorOpenedTimeStamp - doorClosedTimeStamp > 2 * 60 * 60 && doorOpenedTimeStamp - doorClosedTimeStamp < 2 * 60 * 60 + 30 * 60) {
	                return true;
	            }
	            return false;
	        }
	
	        // >= 2.5h
	
	    }, {
	        key: 'haccpNotCompliantDuration',
	        value: function haccpNotCompliantDuration(doorClosedTimeStamp, doorOpenedTimeStamp) {
	            if (doorOpenedTimeStamp - doorClosedTimeStamp >= 2 * 60 * 60 + 30 * 60) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'unixToLocalTime',
	        value: function unixToLocalTime(unixTime) {
	            return new Date(unixTime * 1000).toLocaleString('sv-SE');
	        }
	    }, {
	        key: 'badTemperature',
	        value: function badTemperature(state) {
	            return state.box_temperature > 8 && state.box_temperature < 60;
	        }
	    }, {
	        key: 'complianceStartedNotEnded',
	        value: function complianceStartedNotEnded(transport) {
	            return transport.complianceStart && !transport.complianceEnd;
	        }
	    }, {
	        key: 'graphStart',
	        value: function graphStart(transport) {
	            // Earliest of powerOff and complianceStart (door_close), but max 3h before powerOff
	            var begin = 0;
	            if (!transport.complianceStart) {
	                begin = transport.start;
	            } else {
	                begin = transport.complianceStart < transport.start - 3 * 60 * 60 ? transport.start - 3 * 60 * 60 : transport.complianceStart;
	            }
	            return Math.min(transport.start, begin) * 1000 - 60000 * 5; // -5min
	        }
	    }, {
	        key: 'graphEnd',
	        value: function graphEnd(transport) {
	            // Latest of powerOn and complianceEnd (door_open), but max 3h after powerOn
	            var finish = 0;
	            if (!transport.complianceEnd) {
	                finish = transport.end;
	            } else {
	                finish = transport.complianceEnd > transport.end + 3 * 60 * 60 ? transport.end + 3 * 60 * 60 : transport.complianceEnd;
	            }
	            return Math.max(transport.end, finish) * 1000 + 60000 * 5; // +5min
	        }
	    }]);
	    return TransportsUtil;
	}();
	
	exports.default = TransportsUtil;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _transportsUtil = __webpack_require__(301);
	
	var _transportsUtil2 = _interopRequireDefault(_transportsUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComplianceState = {
	    Compliant: 1,
	    CompliantWithWarnings: 2,
	    NoneCompliant: 3,
	    Alarm: 4
	};
	
	var Transports = function () {
	    function Transports() {
	        (0, _classCallCheck3.default)(this, Transports);
	
	        this.unitId = null;
	        this.unitName = null;
	        this.start = null;
	        this.end = null;
	        this.startTemp = null;
	        this.complianceStart = null;
	        this.complianceEnd = null;
	        this.warnings = [];
	        this.complianceState = null;
	    }
	
	    (0, _createClass3.default)(Transports, [{
	        key: 'setComplianceState',
	        value: function setComplianceState(state) {
	            // Higher numbers = higher state severity. You can never downgrade.
	            if (!this.complianceState || this.complianceState < state) {
	                this.complianceState = state;
	            }
	        }
	    }, {
	        key: 'applyWarningIfNotPresent',
	        value: function applyWarningIfNotPresent(warning) {
	            var warningExists = false;
	            for (var i = 0; i < this.warnings.length; i += 1) {
	                if (this.warnings[i].type === warning.type && this.warnings[i].critical === warning.critical) {
	                    warningExists = true;
	                }
	            }
	
	            if (!warningExists) {
	                this.warnings.push(warning);
	            }
	        }
	    }, {
	        key: 'style',
	        value: function style() {
	            var style = {};
	            if (this.complianceState === ComplianceState.Compliant) {
	                style.color = 'green';
	            } else if (this.complianceState === ComplianceState.CompliantWithWarnings) {
	                style.color = 'orange';
	            } else if (this.complianceState === ComplianceState.NoneCompliant) {
	                style.color = 'grey';
	            } else if (this.complianceState === ComplianceState.Alarm) {
	                style.color = 'red';
	            }
	
	            return style;
	        }
	    }, {
	        key: 'statusTooltip',
	        value: function statusTooltip() {
	            if (this.complianceState === ComplianceState.Compliant) {
	                return 'TRANSPORT.COMPLIANT';
	            } else if (this.complianceState === ComplianceState.CompliantWithWarnings) {
	                return 'TRANSPORT.COMPLIANTWITHWARNINGS';
	            } else if (this.complianceState === ComplianceState.NoneCompliant) {
	                return 'TRANSPORT.NONECOMPLIANT';
	            } else if (this.complianceState === ComplianceState.Alarm) {
	                return 'TRANSPORT.ALARM';
	            }
	
	            return 'Status never set';
	        }
	    }, {
	        key: 'startLocal',
	        value: function startLocal() {
	            return _transportsUtil2.default.unixToLocalTime(this.start);
	        }
	    }, {
	        key: 'endLocal',
	        value: function endLocal() {
	            return _transportsUtil2.default.unixToLocalTime(this.end);
	        }
	    }, {
	        key: 'compliancePeriod',
	        value: function compliancePeriod() {
	            if (this.complianceStart && !this.complianceEnd) {
	                return 'TRANSPORTS.ONGOING';
	            } else if (!this.complianceStart && this.complianceEnd) {
	                return 'TRANSPORT.NEVEROK';
	            } else if (this.complianceStart && this.complianceEnd) {
	                return _transportsUtil2.default.unixToLocalTime(this.complianceStart) + ' - ' + _transportsUtil2.default.unixToLocalTime(this.complianceEnd);
	            }
	            return '';
	        }
	    }, {
	        key: 'firstWarning',
	        value: function firstWarning() {
	            return this.warnings.length > 0 ? this.warnings[0].message : '';
	        }
	    }, {
	        key: 'graphStart',
	        value: function graphStart() {
	            return _transportsUtil2.default.graphStart(this);
	        }
	    }, {
	        key: 'graphEnd',
	        value: function graphEnd() {
	            return _transportsUtil2.default.graphEnd(this);
	        }
	    }]);
	    return Transports;
	}();
	
	exports.default = Transports;

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var ComplianceState = {
	    Compliant: 1,
	    CompliantWithWarnings: 2,
	    NoneCompliant: 3,
	    Alarm: 4
	};
	
	exports.default = ComplianceState;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _transportsUtil = __webpack_require__(301);
	
	var _transportsUtil2 = _interopRequireDefault(_transportsUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Warning = function () {
	    function Warning(type, time, critical, message, latlng) {
	        (0, _classCallCheck3.default)(this, Warning);
	
	        this.type = type; // temp / door
	        this.time = time;
	        this.critical = critical; // Critical == HACCP no longer compliant
	        this.message = message;
	        this.latlng = latlng;
	    }
	
	    (0, _createClass3.default)(Warning, [{
	        key: 'typeString',
	        value: function typeString() {
	            if (this.type === 'temp') {
	                return 'TRANSPORTS.TEMP';
	            } else if (this.type === 'door') {
	                return 'TRANSPORTS.DOOR';
	            }
	            return '-';
	        }
	    }, {
	        key: 'timeLocal',
	        value: function timeLocal() {
	            return _transportsUtil2.default.unixToLocalTime(this.time);
	        }
	    }]);
	    return Warning;
	}();
	
	exports.default = Warning;

/***/ }),
/* 305 */
3,
/* 306 */,
/* 307 */
/***/ (function(module, exports) {

	module.exports = "<sb-application-page> <sb-application-content> <sb-page-context> <div class=\"container landscape-hide portrait-show\"> <h1 translate>TRANSPORTS.TRANSPORTS</h1> <div class=row> <div class=col-md-5> <form class=form-horizontal> <div class=form-group> <div class=\"col-sm-6 col-xs-12\"> <div class=\"input-group sb-date-picker\"> <input type=text id=startDate class=form-control ng-model=$ctrl.fromDate date-format=yyyy-MM-dd data-autoclose=1 bs-datepicker/> <label for=startDate class=input-group-addon> <i class=\"fa fa-calendar\" aria-hidden=true></i> </label> </div> </div> <div class=\"col-sm-6 col-xs-12\"> <div class=\"input-group sb-date-picker\"> <input type=text id=toDate class=form-control ng-model=$ctrl.toDate date-format=yyyy-MM-dd data-autoclose=1 icon-right bs-datepicker/> <label for=toDate class=input-group-addon> <i class=\"fa fa-calendar\" aria-hidden=true></i> </label> </div> </div> </div> </form> </div> <div class=col-md-3> <sb-domain-selector on-select=$ctrl.filterOnDomain(domainId);></sb-domain-selector> </div> </div> </div> </sb-page-context> <div class=\"container landscape-hide portrait-show\"> <table class=\"table table-hover sb-cart-table\"> <thead> <tr> <th translate>TRANSPORTS.TABLE.UNIT</th> <th translate>TRANSPORTS.TABLE.START</th> <th translate>TRANSPORTS.TABLE.END</th> <th translate>TRANSPORTS.TABLE.HACCPSTATUS</th> <th translate>TRANSPORTS.TABLE.HACCPPERIOD</th> <th translate>TRANSPORTS.WARNINGS.MESSAGE</th> </tr> </thead> <tbody> <tr ng-repeat=\"transport in $ctrl.transports\" ng-click=$ctrl.showModal(transport)> <td>{{transport.unitName}}<br/>{{transport.unitId}}</td> <td>{{transport.startLocal()}}</td> <td>{{transport.endLocal()}}</td> <td class=status> <i ng-style=transport.style() class=\"fa fa-circle\" aria-hidden=true> <span translate class=status-tooltip>{{transport.statusTooltip()}}</span> </i> </td> <td translate>{{transport.compliancePeriod()}}</td> <td translate>{{transport.firstWarning()}}</td> </tr> </tbody> </table> <sb-modal title=\"{{ 'TRANSPORTS.DETAILS' | translate }}\" ng-show=$ctrl.showingModal> <sb-modal-header> <sb-modal-actions ng-if=$ctrl.showGraph> <button type=button class=\"btn btn-default\" ng-click=$ctrl.hideModal() translate>Close</button> </sb-modal-actions> </sb-modal-header> <sb-modal-content> <div class=row ng-if=$ctrl.showGraph> <div class=\"col-xs-12 col-sm-8 landscape-show portrait-hide\"> <sb-graph thing-id=$ctrl.modalTransport.unitId from-date=$ctrl.modalTransport.graphStart() to-date=$ctrl.modalTransport.graphEnd() show-transport=true> </sb-graph> </div> <div class=\"col-xs-12 col-sm-4 landscape-hide portrait-show\"> <sb-map-position thing=$ctrl.thing></sb-map-position> </div> </div> <div class=row> <div class=col-md-3> <b translate>TRANSPORTS.TABLE.UNIT</b><b>: </b> {{$ctrl.modalTransport.unitName}} ({{$ctrl.modalTransport.unitId}}) </div> <div class=col-md-3> <b translate>TRANSPORTS.TABLE.HACCPSTATUS</b><b>: </b> <i ng-style=$ctrl.modalTransport.style() class=\"fa fa-circle status\" aria-hidden=true> <span translate class=status-tooltip>{{$ctrl.modalTransport.statusTooltip()}}</span> </i> </div> <div class=col-md-3> <b translate>TRANSPORTS.TABLE.START</b><b>: </b> {{$ctrl.modalTransport.startLocal()}} </div> <div class=col-md-3> <b translate>TRANSPORTS.TABLE.END</b><b>: </b> {{$ctrl.modalTransport.endLocal()}} </div> </div> <br/> <div class=row> <div class=col-md-8> <b translate>TRANSPORTS.TABLE.HACCPPERIOD</b><b>: </b> {{$ctrl.modalTransport.compliancePeriod() | translate}} </div> </div> <br/> <h5><u translate>TRANSPORTS.WARNINGALARM</u></h5> <table class=\"table table-condensed modal-table\"> <thead> <th translate>TRANSPORTS.WARNINGS.TYPE</th> <th translate>TRANSPORTS.WARNINGS.ISSUE</th> <th translate>TRANSPORTS.WARNINGS.TIMESTAMP</th> <th translate>TRANSPORTS.WARNINGS.MESSAGE</th> <th translate>TRANSPORTS.WARNINGS.POSITION</th> </thead> <tbody> <tr ng-repeat=\"warning in $ctrl.modalTransport.warnings\"> <td translate>{{warning.critical ? 'TRANSPORTS.ALARM' : 'TRANSPORTS.WARNING'}}</td> <td translate>{{warning.typeString()}}</td> <td>{{warning.timeLocal()}}</td> <td translate>{{warning.message}}</td> <td>{{warning.latlng}}</td> </tr> </tbody> </table> </sb-modal-content> <sb-modal-actions> <button type=button class=\"btn btn-default\" ng-click=$ctrl.hideModal() translate>Close</button> </sb-modal-actions> </sb-modal> </div> </sb-application-content> </sb-application-page> ";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _auth = __webpack_require__(309);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _loginView = __webpack_require__(311);
	
	var _loginView2 = _interopRequireDefault(_loginView);
	
	var _access = __webpack_require__(317);
	
	var _access2 = _interopRequireDefault(_access);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('app.auth', []).service('AuthService', _auth2.default).component(_loginView2.default.selector, _loginView2.default).directive('sbAccess', function () {
	    return new _access2.default();
	});
	
	exports.default = _module.name;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(310);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(24);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthService = function () {
	    /* @ngInject */
	    function AuthService($log, $q, AwsService, ManifestService, AxiosService) {
	        (0, _classCallCheck3.default)(this, AuthService);
	
	        this.$log = $log;
	        this.$q = $q;
	        this.ManifestService = ManifestService;
	        this.AxiosService = AxiosService;
	
	        this.AWS = AwsService.AWS;
	        this.setupUnauthenticatedRole();
	
	        this.accountKey = 'account';
	        this.credentialsKey = 'credentials';
	    }
	
	    (0, _createClass3.default)(AuthService, [{
	        key: 'getLocalAccount',
	        value: function getLocalAccount() {
	            var json = localStorage.getItem(this.accountKey);
	            return json ? JSON.parse(json) : null;
	        }
	    }, {
	        key: 'setLocalAccount',
	        value: function setLocalAccount(data) {
	            localStorage.setItem(this.accountKey, (0, _stringify2.default)(data));
	        }
	    }, {
	        key: 'removeLocalAccount',
	        value: function removeLocalAccount() {
	            localStorage.removeItem(this.accountKey);
	        }
	    }, {
	        key: 'getLocalCredentials',
	        value: function getLocalCredentials() {
	            var json = localStorage.getItem(this.credentialsKey);
	            return json ? JSON.parse(json) : null;
	        }
	    }, {
	        key: 'setLocalCredentials',
	        value: function setLocalCredentials(data) {
	            localStorage.setItem(this.credentialsKey, (0, _stringify2.default)(data));
	        }
	    }, {
	        key: 'removeLocalCredentials',
	        value: function removeLocalCredentials() {
	            localStorage.removeItem(this.credentialsKey);
	        }
	    }, {
	        key: 'getToken',
	        value: function getToken() {
	            var account = this.getLocalAccount();
	            if (account) return account.credentials.token;
	            return null;
	        }
	    }, {
	        key: 'cognitoPath',
	        value: function cognitoPath() {
	            var region = this.ManifestService.region();
	            var userPool = this.ManifestService.userPool();
	            var cognitoPath = 'cognito-idp.' + region + '.amazonaws.com/' + userPool;
	            return cognitoPath;
	        }
	    }, {
	        key: 'setupUnauthenticatedRole',
	        value: function setupUnauthenticatedRole() {
	            this.AWS.config.region = this.ManifestService.region();
	            // Setting up an unauthenticated role
	            this.AWS.config.credentials = new this.AWS.CognitoIdentityCredentials({
	                IdentityPoolId: this.ManifestService.identityPool()
	            });
	            this.AWS.config.credentials.clearCachedId();
	        }
	    }, {
	        key: 'hasCredentials',
	        value: function hasCredentials() {
	            var account = this.getLocalAccount();
	            var credentials = this.getLocalCredentials();
	            return Boolean(account) && Boolean(account.credentials.token) && Boolean(account.credentials.refreshToken) && Boolean(credentials.SessionToken) && Boolean(credentials.AccessKeyId);
	        }
	    }, {
	        key: 'updateAWSCredentials',
	        value: function updateAWSCredentials(credentials) {
	            this.AWS.config.credentials.params.Logins = (0, _defineProperty3.default)({}, this.cognitoPath(), credentials.token);
	            this.AWS.config.credentials.expired = true;
	        }
	    }, {
	        key: 'isTransportChief',
	        value: function isTransportChief() {
	            var CHIEF_ROLE_ID = 'dd5b4805-38d5-4c91-8d98-d9d0776ef451';
	            var account = this.getLocalAccount();
	            if (account.permissions.roles.indexOf(CHIEF_ROLE_ID) !== -1) {
	                return true;
	            }
	            return false;
	        }
	
	        /**
	         * @private
	         */
	
	    }, {
	        key: 'login',
	        value: function login(userName, password) {
	            return this.AxiosService.http.post('auth/login', { userName: userName, password: password }).then(function (response) {
	                if (response.errorMessage) {
	                    throw new Error(response.errorMessage);
	                }
	                return response.data;
	            });
	        }
	
	        /**
	         * @private
	         */
	
	    }, {
	        key: 'credentials',
	        value: function credentials(identityId, token) {
	            var identity = new this.AWS.CognitoIdentity({
	                region: this.ManifestService.region()
	            });
	
	            return identity.getCredentialsForIdentity({
	                IdentityId: identityId,
	                Logins: (0, _defineProperty3.default)({}, this.cognitoPath(), token)
	            }).promise().then(function (response) {
	                return response.Credentials;
	            });
	        }
	
	        /**
	         * @private
	         */
	
	    }, {
	        key: 'refresh',
	        value: function refresh(refreshToken) {
	            return this.AxiosService.http.post('auth/refresh', { refreshToken: refreshToken }).then(function (response) {
	                if (response.errorMessage) {
	                    throw new Error(response.errorMessage);
	                }
	                return response.data;
	            });
	        }
	    }, {
	        key: 'authenticate',
	        value: function authenticate(userName, password) {
	            var _this = this;
	
	            return this.$q(function (resolve, reject) {
	                _this.login(userName, password).then(function (account) {
	                    _this.updateAWSCredentials(account.credentials);
	                    _this.setLocalAccount(account);
	                    return account;
	                }).then(function (account) {
	                    return _this.credentials(account.credentials.identityId, account.credentials.token);
	                }).then(function (credentials) {
	                    return _this.setLocalCredentials(credentials);
	                }).then(function (account) {
	                    return resolve(account);
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'refreshCredentials',
	        value: function refreshCredentials() {
	            var _this2 = this;
	
	            this.setupUnauthenticatedRole();
	
	            return this.$q(function (resolve, reject) {
	                var localAccount = _this2.getLocalAccount();
	                if (!localAccount) {
	                    reject();
	                    return;
	                }
	                var refreshToken = localAccount.credentials.refreshToken;
	
	                _this2.refresh(refreshToken).then(function (account) {
	                    _this2.updateAWSCredentials(account.credentials);
	                    _this2.setLocalAccount(account);
	                    return account;
	                }).then(function (account) {
	                    return _this2.credentials(account.credentials.identityId, account.credentials.token);
	                }).then(function (credentials) {
	                    return _this2.setLocalCredentials(credentials);
	                }).then(function () {
	                    return resolve();
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'logout',
	        value: function logout() {
	            this.removeLocalAccount();
	            this.removeLocalCredentials();
	
	            if (this.AWS.config.credentials) {
	                this.AWS.config.credentials.clearCachedId();
	            }
	            this.setupUnauthenticatedRole();
	        }
	    }]);
	    return AuthService;
	}();
	
	exports.default = AuthService;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(28);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loginView = __webpack_require__(312);
	
	var _loginView2 = _interopRequireDefault(_loginView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(313);
	
	var LoginComponent = {
	    selector: 'sbLogin',
	    controller: _loginView2.default,
	    template: __webpack_require__(315)
	};
	
	exports.default = LoginComponent;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(24);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginController = function () {
	    /* @ngInject */
	    function LoginController($log, $location, $routeParams, $translate, AuthService, MomentService) {
	        (0, _classCallCheck3.default)(this, LoginController);
	
	        this.$log = $log;
	        this.AuthService = AuthService;
	        this.MomentService = MomentService;
	        this.$location = $location;
	        this.$routeParams = $routeParams;
	        this.$translate = $translate;
	
	        this.failed = undefined;
	        this.loading = false;
	    }
	
	    (0, _createClass3.default)(LoginController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.AuthService.logout();
	        }
	    }, {
	        key: 'changeLanguage',
	        value: function changeLanguage(langKey) {
	            this.$translate.use(langKey);
	            this.MomentService.moment.locale(langKey);
	        }
	    }, {
	        key: 'submit',
	        value: function submit(username, password) {
	            var _this = this;
	
	            this.loading = true;
	            this.AuthService.authenticate(username, password).then(function () {
	                // TODO: account is undefined. Not returned from authenticate..
	                if (_this.$routeParams.next !== undefined) {
	                    _this.$location.path(_this.$routeParams.next);
	                    _this.$location.search({}); // Remove all parameters
	                } else if (_this.AuthService.isTransportChief()) {
	                    _this.$location.path('/transports');
	                } else {
	                    _this.$location.path('/home');
	                }
	            }).catch(function (error) {
	                _this.$log.info('Error logging in: ' + (0, _stringify2.default)(error));
	                _this.failed = JSON.parse(error).message;
	            }).finally(function () {
	                _this.loading = false;
	            });
	        }
	    }]);
	    return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 313 */
3,
/* 314 */,
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=sb-login-view> <div class=row> <div class=\"col-md-3 col-md-offset-5 col-sm-4 col-sm-offset-4 col-xs-6 col-xs-offset-3\"> <div class=sc-logo> <img src=" + __webpack_require__(316) + "> </div> <h3 translate>LANGUAGE.SELECTION</h3> <button class=\"btn btn-primary\" ng-click=\"$ctrl.changeLanguage('en')\">EN</button> <button class=\"btn btn-primary\" ng-click=\"$ctrl.changeLanguage('sv')\">SV</button> <form class=form-horizontal ng-submit=\"$ctrl.submit(username, password)\"> <div class=form-group> <label for=username class=control-label translate></label> <input id=username type=text class=form-control ng-required=true placeholder=Username ng-model=username autofocus/> </div> <div class=form-group> <label for=password class=control-label translate></label> <input id=password type=password class=form-control ng-required=true placeholder=Password ng-model=password /> <div ng-show=\"$ctrl.failed !== undefined\"> <div class=\"text-danger sb-error-message\">{{$ctrl.failed}}</div>  </div> </div> <div class=form-group> <div class=pull-right> <i ng-show=$ctrl.loading class=\"fa fa-spinner fa-spin fa-2x fa-fw\" style=vertical-align:middle></i> <button type=submit class=\"btn btn-primary\">Login</button> </div> </div> </form> </div> </div> </div> ";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "484e2ae370fc3b769f7e9483bed6ae79.svg";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccessDirective = function () {
	    /* @ngInject */
	    function AccessDirective() {
	        (0, _classCallCheck3.default)(this, AccessDirective);
	
	        this.restrict = 'A';
	    }
	
	    /* eslint-disable */
	
	
	    (0, _createClass3.default)(AccessDirective, [{
	        key: 'link',
	        value: function link($scope, $element, $attr) {
	            var account = JSON.parse(localStorage.getItem('account'));
	
	            if (account.user && account.user.roleName !== 'ReadWrite') {
	                $element.replaceWith(document.createComment(' sbAccess: ' + $attr.sbAccess + ' '));
	            }
	        }
	        /* eslint-enable */
	
	    }]);
	    return AccessDirective;
	}();
	
	exports.default = AccessDirective;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _things = __webpack_require__(319);
	
	var _things2 = _interopRequireDefault(_things);
	
	var _map = __webpack_require__(48);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _homeView = __webpack_require__(324);
	
	var _homeView2 = _interopRequireDefault(_homeView);
	
	var _overviewList = __webpack_require__(329);
	
	var _overviewList2 = _interopRequireDefault(_overviewList);
	
	var _cartTable = __webpack_require__(334);
	
	var _cartTable2 = _interopRequireDefault(_cartTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('app.home', []).service(_things2.default.name, _things2.default).service(_map2.default.name, _map2.default).component(_homeView2.default.selector, _homeView2.default).component(_overviewList2.default.selector, _overviewList2.default).component(_cartTable2.default.selector, _cartTable2.default);
	
	exports.default = _module.name;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _keys = __webpack_require__(320);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Domain = __webpack_require__(323);
	
	var _Domain2 = _interopRequireDefault(_Domain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var extractId = function extractId(o) {
	    return (0, _keys2.default)(o)[0];
	};
	
	var ThingsService = function () {
	    /* @ngInject */
	    function ThingsService($q, AxiosService, AuthService) {
	        (0, _classCallCheck3.default)(this, ThingsService);
	
	        this.$q = $q;
	        this.AxiosService = AxiosService;
	        this.AuthService = AuthService;
	
	        this.selectedDomain = undefined;
	    }
	
	    (0, _createClass3.default)(ThingsService, [{
	        key: 'getThings',
	        value: function getThings() {
	            var query = {
	                size: 5000,
	                from: 0,
	                sort: { thingName: { order: 'asc' } },
	                query: { match_all: {} }
	            };
	
	            if (this.selectedDomain) {
	                query.query.bool = {
	                    filter: {
	                        bool: {
	                            should: [{ term: { domain: this.selectedDomain } }]
	                        }
	                    }
	                };
	            }
	
	            return this.AxiosService.http.post('things/find', { query: query }, { headers: { authorization: this.AuthService.getToken() } }).then(function (response) {
	                return response.data;
	            });
	        }
	    }, {
	        key: 'getThing',
	        value: function getThing(thingId) {
	            var _this = this;
	
	            return this.$q(function (resolve, reject) {
	                _this.AxiosService.http.get('things', {
	                    params: { thingName: thingId },
	                    headers: { authorization: _this.AuthService.getToken() }
	                }).then(function (response) {
	                    return response.data;
	                }).then(function (data) {
	                    return resolve(data);
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	    }, {
	        key: 'updateThing',
	        value: function updateThing() {
	            var _this2 = this;
	
	            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                thingId = _ref.thingId,
	                label = _ref.label,
	                domain = _ref.domain;
	
	            return this.$q(function (resolve, reject) {
	                _this2.AxiosService.http.patch('things/' + thingId, { label: label, domain: domain }, { headers: { authorization: _this2.AuthService.getToken() } }).then(function (response) {
	                    return response.data;
	                }).then(function (data) {
	                    return resolve(data);
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	
	        /**
	         * Returns a promise that might resolve into a list
	         * of Domain objects.
	         */
	
	    }, {
	        key: 'getDomains',
	        value: function getDomains() {
	            var _this3 = this;
	
	            return this.$q(function (resolve, reject) {
	                _this3.AxiosService.http.get('domains', {
	                    headers: { authorization: _this3.AuthService.getToken() }
	                }).then(function (response) {
	                    return response.data;
	                }).then(function (data) {
	                    var rootId = extractId(data);
	                    var rootData = data[rootId];
	                    var domain = new _Domain2.default(rootId, rootData);
	                    resolve(domain);
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	
	        /**
	         *
	         * @param {{
	         *   fromDate: Date;
	         *   toDate: Date;
	         *   thingId: string;
	         * }} params
	         *
	         * @returns
	         */
	
	    }, {
	        key: 'getObservations',
	        value: function getObservations(params) {
	            var _this4 = this;
	
	            return this.$q(function (resolve, reject) {
	                var aggregationResolution = '';
	                var diff = params.toDate - params.fromDate;
	                var aDay = 24 * 3600 * 1000;
	                var aWeek = 7 * 24 * 3600 * 1000;
	
	                if (diff <= aDay) {
	                    aggregationResolution = '1s';
	                } else if (diff > aDay && diff <= aWeek) {
	                    aggregationResolution = '1m';
	                } else {
	                    aggregationResolution = '30m';
	                }
	
	                var query = {
	                    size: 1,
	                    trackScores: false,
	                    query: {
	                        bool: {
	                            must: [{
	                                range: {
	                                    timestamp: {
	                                        gte: params.fromDate.valueOf(),
	                                        lte: params.toDate.valueOf()
	                                    }
	                                }
	                            }, { term: { thingName: params.thingId } }]
	                        }
	                    },
	                    aggs: {
	                        hist: {
	                            date_histogram: {
	                                field: 'timestamp',
	                                interval: aggregationResolution,
	                                time_zone: '+01:00',
	                                min_doc_count: 1,
	                                extended_bounds: {
	                                    min: params.fromDate.valueOf(),
	                                    max: params.toDate.valueOf()
	                                },
	                                order: { _key: 'asc' }
	                            },
	                            aggs: {
	                                box_temperature: {
	                                    max: { field: 'state.box_temperature' }
	                                },
	                                ambient_temperature: {
	                                    max: { field: 'state.ambient_temperature' }
	                                },
	                                door: {
	                                    max: { field: 'state.door_open' }
	                                },
	                                power: {
	                                    max: { field: 'state.mains_powered' }
	                                },
	                                moving: {
	                                    max: { field: 'state.moving' }
	                                },
	                                latlng: {
	                                    geo_centroid: { field: 'state.latlng' }
	                                }
	                            }
	                        }
	                    }
	                };
	
	                _this4.AxiosService.http.post('observations/find', { query: query }, { headers: { authorization: _this4.AuthService.getToken() } }).then(function (response) {
	                    return response.data;
	                }).then(function (data) {
	                    return resolve(data);
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	
	        /**
	         *
	         * @param {{
	         *   fromDate: Date;
	         *   toDate: Date;
	         *   thingId: string;
	         * }} params
	         *
	         * @returns
	         */
	
	    }, {
	        key: 'getRawObservations',
	        value: function getRawObservations(params) {
	            var _this5 = this;
	
	            return this.$q(function (resolve, reject) {
	                var query = {
	                    size: 5000,
	                    _source: ['state.mains_powered', 'state.moving', 'state.door_open', 'state.box_temperature', 'state.ambient_temperature', 'state.latlng', 'timestamp', 'state.Virtual_In_Transport'],
	                    sort: {
	                        timestamp: {
	                            order: 'asc'
	                        }
	                    },
	                    query: {
	                        bool: {
	                            filter: {
	                                bool: {
	                                    must: [{ term: { thingName: params.thingId } }, {
	                                        range: {
	                                            timestamp: {
	                                                gte: params.fromDate.valueOf(),
	                                                lte: params.toDate.valueOf()
	                                            }
	                                        }
	                                    }],
	                                    // minimum_should_match: 1,
	                                    should: [{
	                                        exists: { field: 'state.mains_powered' }
	                                    }, {
	                                        exists: { field: 'state.moving' }
	                                    }, {
	                                        exists: { field: 'state.door_open' }
	                                    }, {
	                                        exists: { field: 'state.box_temperature' }
	                                    }, {
	                                        exists: { field: 'state.ambient_temperature' }
	                                    }, {
	                                        exists: { field: 'state.latlng' }
	                                    }, {
	                                        exists: { field: 'state.Virtual_In_Transport' }
	                                    }]
	                                }
	                            }
	                        }
	                    }
	                };
	
	                _this5.AxiosService.http.post('observations/find', { query: query }, { headers: { authorization: _this5.AuthService.getToken() } }).then(function (response) {
	                    return response.data;
	                }).then(function (data) {
	                    return resolve(data);
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	
	        /**
	         *
	         * @param {{
	         *   fromDate: Date;
	         *   toDate: Date;
	         *   thingId: string;
	         * }} params
	         *
	         * @returns
	         */
	
	    }, {
	        key: 'getRawHACCPObservations',
	        value: function getRawHACCPObservations(params) {
	            var _this6 = this;
	
	            return this.$q(function (resolve, reject) {
	                var query = {
	                    size: 5000,
	                    _source: ['state.mains_powered', 'state.moving', 'state.door_open', 'state.box_temperature', 'state.ambient_temperature', 'state.latlng', 'timestamp', 'state.rd_state', 'state.Virtual_In_Transport'],
	                    sort: {
	                        timestamp: {
	                            order: 'asc'
	                        }
	                    },
	                    query: {
	                        bool: {
	                            filter: {
	                                bool: {
	                                    must: [{ term: { thingName: params.thingId } }, {
	                                        range: {
	                                            timestamp: {
	                                                gte: params.fromDate.valueOf(),
	                                                lte: params.toDate.valueOf()
	                                            }
	                                        }
	                                    }],
	                                    // minimum_should_match: 1,
	                                    should: [{
	                                        exists: { field: 'state.rd_state' }
	                                    }, {
	                                        exists: { field: 'state.mains_powered' }
	                                    }, {
	                                        exists: { field: 'state.moving' }
	                                    }, {
	                                        exists: { field: 'state.door_open' }
	                                    }, {
	                                        exists: { field: 'state.box_temperature' }
	                                    }, {
	                                        exists: { field: 'state.ambient_temperature' }
	                                    }, {
	                                        exists: { field: 'state.latlng' }
	                                    }, {
	                                        exists: { field: 'state.Virtual_In_Transport' }
	                                    }]
	                                }
	                            }
	                        }
	                    }
	                };
	
	                _this6.AxiosService.http.post('observations/find', { query: query }, { headers: { authorization: _this6.AuthService.getToken() } }).then(function (response) {
	                    return response.data;
	                }).then(function (data) {
	                    return resolve(data);
	                }).catch(function (error) {
	                    return reject(error);
	                });
	            });
	        }
	    }]);
	    return ThingsService;
	}();
	
	exports.default = ThingsService;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(321), __esModule: true };

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(322);
	module.exports = __webpack_require__(26).Object.keys;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(246);
	var $keys = __webpack_require__(259);
	
	__webpack_require__(253)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var extractDomainName = function extractDomainName(o) {
	    try {
	        return o.attributes.name;
	    } catch (e) {
	        return undefined;
	    }
	};
	
	var extractChildren = function extractChildren(o, level) {
	    var children = [];
	    /* eslint-disable */
	    for (var name in o) {
	        if (o.hasOwnProperty(name) && name !== "attributes") {
	            children.push(new Domain(name, o[name], level));
	        }
	    }
	    /* eslint-enable */
	    return children;
	};
	
	/**
	 * Represents a Domain node in the Cloud Connect domain tree.
	 * Each node has an id an optional name and zero or more children
	 * nodes.
	 *
	 * The level is the level from the root node.
	 */
	
	var Domain = function () {
	    function Domain(domainId, domainData) {
	        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        (0, _classCallCheck3.default)(this, Domain);
	
	        this.id = domainId;
	        this.level = level;
	        this.name = extractDomainName(domainData) || this.id;
	        this.children = extractChildren(domainData, level + 1);
	    }
	
	    /**
	     * Get a list of all domains from this node and any descendants
	     */
	
	
	    (0, _createClass3.default)(Domain, [{
	        key: "allChildren",
	        value: function allChildren() {
	            return this.children.reduce(function (prev, current) {
	                prev.push(current);
	                return prev.concat(current.allChildren());
	            }, []);
	        }
	
	        /**
	         * Resolve the domain name based on the domain id within this
	         * domains children, if no domain is found undefined is returned.
	         *
	         * @param {*} domainId The id of the domain
	         */
	
	    }, {
	        key: "resolveName",
	        value: function resolveName(domainId) {
	            if (domainId === undefined) return domainId;
	            if (this.id === domainId) return this.name;
	
	            for (var i = 0; i < this.children.length; i += 1) {
	                var childResult = this.children[i].resolveName(domainId);
	                if (childResult !== undefined) return childResult;
	            }
	            return undefined;
	        }
	
	        /**
	         * Resolves the domain path `domain/domain/domain` up to the given
	         * domain id.
	         *
	         * If the given domain name is not found, undefined is returned.
	         *
	         * @param {*} domainId  The id of the domain to resolve path to
	         */
	
	    }, {
	        key: "resolvePath",
	        value: function resolvePath(domainId) {
	            if (domainId === undefined) return domainId;
	            if (this.id === domainId) return this.id;
	
	            for (var i = 0; i < this.children.length; i += 1) {
	                var childResult = this.children[i].resolvePath(domainId);
	                if (childResult !== undefined) {
	                    return this.id + "/" + childResult;
	                }
	            }
	
	            return undefined;
	        }
	
	        /**
	         * Resolves a trail of objects used when creating a breadcrumb in the
	         * UI.
	         *
	         * @param {*} domainId  The id of the domain to resolve path to
	         * @return An array of all domain objects for the resulting path. E.g.
	         * [{id, name}, {id, name}]
	         */
	
	    }, {
	        key: "trail",
	        value: function trail(domainId) {
	            if (this.id === domainId) return [{ id: this.id, name: this.name }];
	
	            for (var i = 0; i < this.children.length; i += 1) {
	                var childResult = this.children[i].trail(domainId);
	                if (childResult !== undefined) {
	                    return [{ id: this.id, name: this.name }].concat(childResult);
	                }
	            }
	
	            return undefined;
	        }
	
	        /**
	         * Get a list of all domain ID's for the current domain node and all its
	         * children.
	         */
	
	    }, {
	        key: "getAllIds",
	        value: function getAllIds() {
	            var ids = [this.id];
	            var children = this.allChildren().map(function (c) {
	                return c.id;
	            });
	            return ids.concat(children);
	        }
	
	        /**
	         * Find the domain with the given Id or return undefined.
	         */
	
	    }, {
	        key: "find",
	        value: function find(domainId) {
	            if (this.id === domainId) return this;
	
	            for (var i = 0; i < this.children.length; i += 1) {
	                var childResult = this.children[i].find(domainId);
	                if (childResult !== undefined) {
	                    return childResult;
	                }
	            }
	            return undefined;
	        }
	    }]);
	    return Domain;
	}();
	
	exports.default = Domain;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _homeView = __webpack_require__(325);
	
	var _homeView2 = _interopRequireDefault(_homeView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(326);
	
	var HomeComponent = {
	    selector: 'sbHome',
	    controller: _homeView2.default,
	    template: __webpack_require__(328)
	};
	
	exports.default = HomeComponent;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAP_VIEW = 'map';
	var LIST_VIEW = 'list';
	
	var HomeController = function () {
	    /* @ngInject */
	    function HomeController($log, $location, $interval, $timeout, $routeParams, AuthService, ThingsService, MapService, EventsService) {
	        (0, _classCallCheck3.default)(this, HomeController);
	
	        this.$log = $log;
	        this.$location = $location;
	        this.$interval = $interval;
	        this.$timeout = $timeout;
	        this.$routeParams = $routeParams;
	        this.AuthService = AuthService;
	        this.ThingsService = ThingsService;
	        this.MapService = MapService;
	        this.EventsService = EventsService;
	        this.view = MAP_VIEW;
	        this.things = [];
	        this.alarms = [];
	        this.rootDomain = undefined;
	        this.periodicMapRefresh = undefined;
	        this.selectedDomainId = undefined;
	        this.query = undefined;
	        this.contextOpen = false;
	        this.isLoading = true;
	        this.showListView = true;
	    }
	
	    (0, _createClass3.default)(HomeController, [{
	        key: 'isMapView',
	        value: function isMapView() {
	            return this.view === MAP_VIEW;
	        }
	    }, {
	        key: 'isListView',
	        value: function isListView() {
	            return this.view === LIST_VIEW;
	        }
	    }, {
	        key: 'activateMapView',
	        value: function activateMapView() {
	            var _this = this;
	
	            this.view = MAP_VIEW;
	            localStorage.setItem('VIEW', MAP_VIEW);
	
	            // Wait a cycle in order to let the view know its map-div extent
	            this.$timeout(function () {
	                _this.MapService.showCartsOnMap(_this.things, 'mapid');
	            }, 0);
	        }
	    }, {
	        key: 'activateListView',
	        value: function activateListView() {
	            this.view = LIST_VIEW;
	            localStorage.setItem('VIEW', LIST_VIEW);
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var _this2 = this;
	
	            this.view = localStorage.getItem('VIEW') === null ? MAP_VIEW : localStorage.getItem('VIEW');
	
	            if (this.$routeParams.domain) {
	                this.ThingsService.selectedDomain = this.$routeParams.domain;
	            }
	
	            this.getThings();
	            this.getDomains();
	
	            // Refresh map every 3 minutes
	            this.periodicMapRefresh = this.$interval(function () {
	                _this2.getThings();
	            }, 3 * 60000);
	
	            if (this.AuthService.isTransportChief()) {
	                this.showListView = false;
	            }
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.MapService.destroy();
	            this.$interval.cancel(this.periodicMapRefresh);
	            this.periodicMapRefresh = undefined;
	        }
	    }, {
	        key: 'getThings',
	        value: function getThings() {
	            var _this3 = this;
	
	            this.ThingsService.getThings().then(function (response) {
	                _this3.things = response.hits.hits;
	
	                var params = {
	                    fromDate: new Date().setMonth(-12),
	                    toDate: new Date().valueOf()
	                };
	                _this3.EventsService.getEventsToAcknowledge(params).then(function (events) {
	                    _this3.alarms = events.hits.hits;
	
	                    _this3.alarms.forEach(function (a) {
	                        _this3.things.forEach(function (t) {
	                            if (a._source.source.thingName === t._source.thingName) {
	                                t.hasAlarms = true;
	                            }
	                        });
	                    });
	
	                    // To prevent problem with map-extent -> Only init map when map-view is visible
	                    if (_this3.view === MAP_VIEW) {
	                        _this3.MapService.showCartsOnMap(_this3.things, 'mapid');
	                    }
	                }).catch(function (error) {
	                    _this3.$log.info('Error getting events: ' + error);
	                });
	            }).catch(function (error) {
	                _this3.$log.info('Error getting things: ' + error);
	                _this3.$location.path('/login');
	            }).finally(function () {
	                _this3.isLoading = false;
	            });
	        }
	    }, {
	        key: 'getDomains',
	        value: function getDomains() {
	            var _this4 = this;
	
	            this.ThingsService.getDomains().then(function (rootDomain) {
	                _this4.rootDomain = rootDomain;
	            }).catch(function (error) {
	                _this4.$log.info('Error getting domains: ' + error);
	            });
	        }
	    }, {
	        key: 'filterOnDomain',
	        value: function filterOnDomain(domainId) {
	            this.ThingsService.selectedDomain = domainId;
	            this.getThings();
	        }
	    }, {
	        key: 'isEmpty',
	        value: function isEmpty() {
	            return this.things && this.things.length === 0;
	        }
	    }]);
	    return HomeController;
	}();
	
	exports.default = HomeController;

/***/ }),
/* 326 */
3,
/* 327 */,
/* 328 */
/***/ (function(module, exports) {

	module.exports = "<sb-application-page> <sb-application-content> <sb-page-context> <div class=container> <div class=row> <div class=col-md-5 ng-class=\"$ctrl.contextOpen ? '' : 'hidden-sm hidden-xs'\"> <input type=text class=form-control placeholder=\"{{ 'MANAGE.CONTEXT.FILTER.PLACEHOLDER' | translate }}\" ng-model=$ctrl.query /> </div> <div class=col-md-3 ng-class=\"$ctrl.contextOpen ? '': 'hidden-sm hidden-xs'\"> <sb-domain-selector on-select=$ctrl.filterOnDomain(domainId);></sb-domain-selector> </div> <div class=\"col-md-2 col-md-offset-2\"> <div ng-if=$ctrl.showListView class=\"btn-group sb-map-list-toggle\"> <a class=\"btn sb-toggle-map\" ng-class=\"$ctrl.isMapView() ? 'btn-primary' : 'btn-default'\" ng-click=\"$ctrl.activateMapView(); $event.stopPropagation();\" translate>MANAGE.CONTEXT.MAP</a> <a class=\"btn sb-toggle-list\" ng-class=\"$ctrl.isListView() ? 'btn-primary' : 'btn-default'\" ng-click=\"$ctrl.activateListView(); $event.stopPropagation();\" translate>MANAGE.CONTEXT.LIST</a> </div> </div> </div> <div class=\"row hidden-md hidden-lg\"> <div class=col-md-12> <div class=sb-context-action ng-click=\"$ctrl.contextOpen = !$ctrl.contextOpen\"> <i ng-show=$ctrl.contextOpen class=\"fa fa-2x fa-angle-up\" aria-hidden=true></i> <i ng-hide=$ctrl.contextOpen class=\"fa fa-2x fa-angle-down\" aria-hidden=true></i> </div> </div> </div> </div> </sb-page-context> <div class=container-fluid ng-show=$ctrl.isMapView()> <div class=row> <div class=\"col-md-8 col-sm-12 sb-map-no-padding\"> <div id=mapid style=height:70vh></div> </div> <div class=\"col-md-4 hidden-sm hidden-xs col-no-padding\"> <sb-overview-list carts=$ctrl.things query=$ctrl.query></sb-overview-list> </div> </div> </div> <div class=container ng-show=$ctrl.isListView()> <div class=\"row sb-margin-top sb-margin-bottom hidden-sm hidden-xs\"> <div class=col-md-12> <div ng-if=$ctrl.isLoading> <sb-empty-box icon-css=\"fa-spinner fa-spin fa-fw\" title=\"\" message=CARTS.LOADING.MESSAGE> </sb-empty-box> </div> <div ng-if=\"!$ctrl.isLoading && $ctrl.isEmpty()\"> <sb-empty-box icon-css=fa-list-alt title=CARTS.EMPTY.HEADER message=CARTS.EMPTY.MESSAGE> </sb-empty-box> </div> <div ng-if=\"!$ctrl.isLoading && !$ctrl.isEmpty()\"> <sb-cart-table icon-css=fa-list-alt carts=$ctrl.things query=$ctrl.query root-domain=$ctrl.rootDomain> </sb-cart-table> </div> </div> </div> <div class=\"row hidden-md hidden-lg\"> <div class=\"col-md-12 col-no-padding\"> <sb-overview-list carts=$ctrl.things query=$ctrl.query></sb-overview-list> </div> </div> </div> </sb-application-content> </sb-application-page> ";

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _overviewList = __webpack_require__(330);
	
	var _overviewList2 = _interopRequireDefault(_overviewList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(331);
	
	var OverviewComponent = {
	    selector: 'sbOverviewList',
	    controller: _overviewList2.default,
	    template: __webpack_require__(333),
	    bindings: {
	        carts: '<',
	        query: '<'
	    }
	};
	
	exports.default = OverviewComponent;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OverviewController = function () {
	    /* @ngInject */
	    function OverviewController(MapService, AuthService) {
	        (0, _classCallCheck3.default)(this, OverviewController);
	
	        this.MapService = MapService;
	        this.AuthService = AuthService;
	        this.showDetailsLink = true;
	    }
	
	    (0, _createClass3.default)(OverviewController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            if (this.AuthService.isTransportChief()) {
	                this.showDetailsLink = false;
	            }
	        }
	    }, {
	        key: "focused",
	        value: function focused(thingId) {
	            this.MapService.showPopup(thingId);
	        }
	    }]);
	    return OverviewController;
	}();
	
	exports.default = OverviewController;

/***/ }),
/* 331 */
3,
/* 332 */,
/* 333 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table sb-table-hover-hand\"> <tr ng-repeat=\"t in $ctrl.carts | filter: $ctrl.query | orderBy:['hasAlarms','_source.thingName']\" ng-click=$ctrl.focused(t._id) ng-class=\"t.hasAlarms ? 'sb-cart-has-alarms' : '' \"> <td> <h4><strong>{{ t._source.label }}</strong></h4> <h5>{{ t._id }}</h5> </td> <td class=sb-valign-middle> <h3 class=pull-right>{{ t._source.state.box_temperature }}&#8451;</h3> </td> <td class=sb-valign-middle> <a ng-if=$ctrl.showDetailsLink class=pull-right href=#!/detail/{{t._id}}> <div class=sb-details-link></div> </a> </td> </tr> </table> ";

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _cartTable = __webpack_require__(335);
	
	var _cartTable2 = _interopRequireDefault(_cartTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(336);
	
	var CartTableComponent = {
	    selector: 'sbCartTable',
	    template: __webpack_require__(338),
	    controller: _cartTable2.default,
	    bindings: {
	        carts: '<',
	        rootDomain: '<',
	        query: '<'
	    }
	};
	
	exports.default = CartTableComponent;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CartTableController = function () {
	    /* @ngInject */
	    function CartTableController($modal, $location) {
	        (0, _classCallCheck3.default)(this, CartTableController);
	
	        this.$location = $location;
	    }
	
	    (0, _createClass3.default)(CartTableController, [{
	        key: "showDetails",
	        value: function showDetails(id) {
	            this.$location.path("/detail/" + id);
	        }
	    }]);
	    return CartTableController;
	}();
	
	exports.default = CartTableController;

/***/ }),
/* 336 */
3,
/* 337 */,
/* 338 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table table-hover sb-cart-table\"> <thead> <tr> <th translate>TABLE.NAME</th> <th translate>IOF.SERIAL</th> <th translate>TABLE.DOMAIN</th> <th class=sb-cart-column-center translate>IOF.NETWORK</th> <th class=sb-cart-column-center translate>IOF.POWER</th> <th class=sb-cart-column-center translate>IOF.DOOR</th> <th class=sb-cart-column-center translate>IOF.TEMPERATURE</th> </tr> </thead> <tbody> <tr ng-repeat=\"cart in $ctrl.carts | filter: $ctrl.query | orderBy: ['hasAlarms', '_source.thingName']\" ng-click=$ctrl.showDetails(cart._id) ng-class=\"cart.hasAlarms ? 'sb-cart-table-has-alarms' : ''\"> <td> {{ cart._source.label }} </td> <td> {{ cart._source.state.serial }} </td> <td> {{ $ctrl.rootDomain.resolveName(cart._source.domain) }} </td> <td class=sb-cart-column-center ng-switch=cart._source.state.tcxn.connection_status> <span ng-switch-when=0 class=sb-cart-table-offline translate>CART.STATE.OFFLINE</span> <span ng-switch-when=2 class=sb-cart-table-online translate>CART.STATE.ONLINE</span> <span ng-switch-default class=sb-cart-table-unknown translate>-</span> </td> <td class=sb-cart-column-center ng-switch=cart._source.state.mains_powered> <span ng-switch-when=0 class=sb-cart-table-power-off translate>IOF.POWER.OFF</span> <span ng-switch-when=1 class=sb-cart-table-power-on translate>IOF.POWER.ON</span> <span ng-switch-default class=sb-cart-table-unknown translate>-</span> </td> <td class=sb-cart-column-center ng-switch=cart._source.state.door_open> <span ng-switch-when=0 class=sb-cart-table-door-closed translate>CART.STATE.CLOSED</span> <span ng-switch-when=1 class=sb-cart-table-door-open translate>CART.STATE.OPEN</span> <span ng-switch-default class=sb-cart-table-unknown translate>-</span> </td> <td class=sb-cart-column-center> {{ cart._source.state.box_temperature }} </td> </tr> </tbody> </table> ";

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _things = __webpack_require__(319);
	
	var _things2 = _interopRequireDefault(_things);
	
	var _detailView = __webpack_require__(340);
	
	var _detailView2 = _interopRequireDefault(_detailView);
	
	var _graphComponent = __webpack_require__(345);
	
	var _graphComponent2 = _interopRequireDefault(_graphComponent);
	
	var _notificationsTable = __webpack_require__(348);
	
	var _notificationsTable2 = _interopRequireDefault(_notificationsTable);
	
	var _knownStateComponent = __webpack_require__(353);
	
	var _knownStateComponent2 = _interopRequireDefault(_knownStateComponent);
	
	var _mapPosition = __webpack_require__(357);
	
	var _mapPosition2 = _interopRequireDefault(_mapPosition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('app.detail', []).service('ThingsService', _things2.default).component(_detailView2.default.selector, _detailView2.default).component(_graphComponent2.default.selector, _graphComponent2.default).component(_notificationsTable2.default.selector, _notificationsTable2.default).component(_knownStateComponent2.default.selector, _knownStateComponent2.default).component(_mapPosition2.default.selector, _mapPosition2.default);
	
	exports.default = _module.name;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _detailView = __webpack_require__(341);
	
	var _detailView2 = _interopRequireDefault(_detailView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(342);
	
	var DetailComponent = {
	    selector: 'sbDetail',
	    controller: _detailView2.default,
	    template: __webpack_require__(344)
	};
	
	exports.default = DetailComponent;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailController = function () {
	    /* @ngInject */
	    function DetailController($log, $location, $routeParams, $scope, $modal, $rootScope, ThingsService, MomentService) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, DetailController);
	
	        this.$log = $log;
	        this.$location = $location;
	        this.$routeParams = $routeParams;
	        this.$scope = $scope;
	        this.$modal = $modal;
	        this.$rootScope = $rootScope;
	        this.ThingsService = ThingsService;
	        this.MomentService = MomentService;
	
	        this.thing = {};
	        this.thingId = this.$routeParams.id;
	
	        this.fromDate = this.MomentService.startOfWeek();
	        this.toDate = this.MomentService.endOfDay();
	        this.lastUpdated = null;
	        this.settingsModal = undefined;
	        this.domain = undefined;
	        this.domainTrail = [];
	
	        this.$rootScope.$on('cartSettingsUpdated', function () {
	            _this.getThing(_this.thingId);
	        });
	    }
	
	    (0, _createClass3.default)(DetailController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.getThing(this.thingId);
	        }
	    }, {
	        key: 'getThing',
	        value: function getThing(id) {
	            var _this2 = this;
	
	            this.ThingsService.getThing(id).then(function (response) {
	                _this2.thing = response;
	                _this2.timeSinceLastUpdate();
	                return _this2.ThingsService.getDomains();
	            }).then(function (rootDomain) {
	                _this2.domain = rootDomain;
	                _this2.domainTrail = _this2.domain.trail(_this2.thing.domain.id);
	            }).catch(function (error) {
	                _this2.$log.info('Error getting things: ' + error);
	                _this2.$location.path('/login');
	            });
	        }
	    }, {
	        key: 'timeSinceLastUpdate',
	        value: function timeSinceLastUpdate() {
	            // unix-timestamp === timestamp * 1000
	            var lastReported = this.MomentService.moment.unix(this.thing.shadow.metadata.reported.box_temperature.timestamp);
	            this.lastUpdated = this.MomentService.moment(lastReported).fromNow();
	        }
	    }, {
	        key: 'showSettings',
	        value: function showSettings(cartId) {
	            if (this.settingsModal) {
	                this.settingsModal.hide();
	            }
	            this.settingsModal = this.$modal({
	                template: '<sb-cart-settings cart-id="\'' + cartId + '\'"></sb-cart-settings>',
	                placement: 'center',
	                show: true
	            });
	        }
	    }]);
	    return DetailController;
	}();
	
	exports.default = DetailController;

/***/ }),
/* 342 */
3,
/* 343 */,
/* 344 */
/***/ (function(module, exports) {

	module.exports = "<sb-application-page> <sb-application-content> <sb-page-context> <div class=\"container landscape-hide portrait-show\"> <div class=row> <div class=col-md-12> <h2>{{ $ctrl.thing.label }}</h2> </div> </div> <div class=row> <div class=col-md-8> <ol class=sb-breadcrumb> <li ng-repeat=\"d in $ctrl.domainTrail\" ng-if=\"$index > 0\"> <a href=\"#!/home?domain={{ d.id }}\">{{ d.name }}</a> </li> </ol> </div> <div class=col-md-4> <span class=pull-right ng-show=\"$ctrl.lastUpdate !== null\">{{ 'IOF.UPDATED' | translate }} {{ $ctrl.lastUpdated }}</span> </div> </div> <div class=row> <div class=col-md-5> <form class=form-horizontal> <div class=form-group> <div class=\"col-sm-6 col-xs-12\"> <div class=\"input-group sb-date-picker\"> <input type=text id=startDate class=form-control ng-model=$ctrl.fromDate date-format=yyyy-MM-dd data-autoclose=1 bs-datepicker> <label for=startDate class=input-group-addon> <i class=\"fa fa-calendar\" aria-hidden=true></i> </label> </div> </div> <div class=\"col-sm-6 col-xs-12\"> <div class=\"input-group sb-date-picker\"> <input type=text id=toDate class=form-control ng-model=$ctrl.toDate date-format=yyyy-MM-dd data-autoclose=1 icon-right bs-datepicker> <label for=toDate class=input-group-addon> <i class=\"fa fa-calendar\" aria-hidden=true></i> </label> </div> </div> </div> </form> </div> </div> </div> </sb-page-context> <sb-alarm-notifications></sb-alarm-notifications> <div class=container> <div class=\"row sb-margin-top\"> <div class=\"col-xs-12 col-sm-8 landscape-show portrait-hide\"> <sb-graph thing-id=$ctrl.thingId from-date=$ctrl.fromDate to-date=$ctrl.toDate show-transport=false></sb-graph> </div> <div class=\"col-xs-12 col-sm-4 landscape-hide portrait-show\"> <sb-map-position thing=$ctrl.thing></sb-map-position> </div> </div> <div class=\"row landscape-hide portrait-show\"> <div class=\"col-xs-12 col-md-12\"> <sb-notifications-table thingid=$ctrl.thingId from-date=$ctrl.fromDate to-date=$ctrl.toDate></sb-notifications-table> </div> </div> <div class=\"row sb-margin-bottom landscape-hide portrait-show\"> <div class=\"col-xs-12 col-sm-6\"> <h3 class=sb-detail-heading translate>STATE.KNOWN_STATE</h3> <sb-known-state thing=$ctrl.thing></sb-known-state> </div> <div class=\"col-xs-12 col-sm-6\"> <div sb-access=\"not authorized\"> <h3 class=sb-detail-heading translate>DETAILS.SETTINGS.HEADER</h3> <p translate>DETAILS.SETTINGS.MESSAGE</p> <button type=button class=\"btn btn-default btn-sm pull-right\" ng-click=$ctrl.showSettings($ctrl.thingId)> <i class=\"fa fa-pencil fa-lg\" aria-hidden=true></i> <span translate>DETAILS.SETTINGS.ACTION</span> </button> </div> </div> </div> </div> </sb-application-content> </sb-application-page> ";

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _graph = __webpack_require__(346);
	
	var _graph2 = _interopRequireDefault(_graph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GraphComponent = {
	    selector: 'sbGraph',
	    template: __webpack_require__(347),
	    controller: _graph2.default,
	    bindings: {
	        thingId: '<',
	        fromDate: '<',
	        toDate: '<',
	        showTransport: '<'
	    }
	};
	
	exports.default = GraphComponent;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _getIterator2 = __webpack_require__(293);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var defaultOptions = {
	    'type': 'serial',
	    'theme': 'light',
	    'marginTop': 0,
	    'marginRight': 20,
	    'marginLeft': 80,
	    "valueAxes": [{
	        "ignoreAxisWidth": true
	    }],
	    "startDuration": 0,
	    "chartCursor": {
	        "categoryBalloonEnabled": false
	    },
	    'dataDateFormat': 'YYYY-MM-DD HH:NN',
	    'categoryField': 'timestamp',
	    'categoryAxis': {
	        'minPeriod': 'ss',
	        'parseDates': true,
	        'dateFormats': [{ period: 'ss', format: 'JJ:NN:SS' }, { period: 'mm', format: 'JJ:NN' }, { period: 'hh', format: 'JJ:NN' }, { period: 'DD', format: 'YYYY-MM-DD' }, { period: 'WW', format: 'YYYY-MM-DD' }, { period: 'MM', format: 'MMM' }, { period: 'YYYY', format: 'YYYY' }]
	    }
	};
	
	var GraphController = function () {
	    /* @ngInject */
	    function GraphController($log, $rootScope, $translate, ThingsService, EventsService) {
	        (0, _classCallCheck3.default)(this, GraphController);
	
	        this.$log = $log;
	        this.$rootScope = $rootScope;
	        this.$translate = $translate;
	        this.ThingsService = ThingsService;
	        this.EventsService = EventsService;
	        this.dataProvider = [];
	        this.charts = [];
	    }
	
	    (0, _createClass3.default)(GraphController, [{
	        key: '$onChanges',
	        value: function $onChanges() {
	            this.charts = [];
	
	            // onChanges is triggered when bindings are changed
	            this.getData();
	        }
	    }, {
	        key: 'getData',
	        value: function getData() {
	            var _this = this;
	
	            var params = {
	                thingId: this.thingId,
	                fromDate: this.fromDate,
	                toDate: this.toDate
	            };
	
	            this.ThingsService.getRawObservations(params).then(function (response) {
	                _this.dataProvider = [];
	                /* eslint-disable */
	
	                var lastKnownPosition = '';
	
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = (0, _getIterator3.default)(response.hits.hits), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var h = _step.value;
	
	                        var k = h;
	                        h = h._source.state;
	
	                        var point = {
	                            'timestamp': new Date(k._source.timestamp)
	                        };
	
	                        if (h.latlng && h.latlng.length > 0) {
	                            lastKnownPosition = h.latlng;
	                        }
	
	                        if (h.mains_powered) {
	                            point['power'] = h.mains_powered + 2;
	                        }
	                        if (h.mains_powered === 0) {
	                            point['power'] = 0;
	                        }
	
	                        if (h.door_open) {
	                            point['door'] = h.door_open + 1;
	                        }
	                        if (h.door_open === 0) {
	                            point['door'] = 0;
	                        }
	
	                        if (_this.showTransport === true) {
	                            if (h.Virtual_In_Transport) {
	                                point['in_transport'] = h.Virtual_In_Transport;
	                            }
	                            if (h.Virtual_In_Transport === 0) {
	                                point['in_transport'] = 0;
	                            }
	                        } else {
	                            if (h.moving) {
	                                point['moving'] = h.moving;
	                            }
	                        }
	
	                        if (h.box_temperature) point['box_temperature'] = h.box_temperature;
	                        if (h.box_temperature) point['latlng'] = lastKnownPosition;
	                        if (h.ambient_temperature) point['ambient_temperature'] = h.ambient_temperature;
	
	                        _this.dataProvider.push(point);
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }).then(function () {
	                params['sortOrder'] = 'asc';
	
	                _this.EventsService.getEvents(params).then(function (response) {
	                    var _iteratorNormalCompletion2 = true;
	                    var _didIteratorError2 = false;
	                    var _iteratorError2 = undefined;
	
	                    try {
	                        for (var _iterator2 = (0, _getIterator3.default)(response.hits.hits), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                            var e = _step2.value;
	
	                            _this.dataProvider.push({
	                                'timestamp': new Date(e._source.timestamp),
	                                'eventMessage': e._source.message,
	                                'eventValue': 0
	
	                            });
	                        }
	
	                        // Having both temperature and events reading in the same array. Sort on the common property 'timestamp'
	                    } catch (err) {
	                        _didIteratorError2 = true;
	                        _iteratorError2 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                _iterator2.return();
	                            }
	                        } finally {
	                            if (_didIteratorError2) {
	                                throw _iteratorError2;
	                            }
	                        }
	                    }
	
	                    _this.dataProvider.sort(function (a, b) {
	                        return a.timestamp > b.timestamp ? 1 : b.timestamp > a.timestamp ? -1 : 0;
	                    });
	                }).then(function () {
	                    _this.addTempChart();
	                    _this.addSensorChart();
	                    _this.setupSynchronization();
	                    _this.$rootScope.$emit('chartDataPrepared', _this.dataProvider);
	                }).catch(function (err) {
	                    _this.$log.info(err);
	                });
	            }).catch(function (error) {
	                _this.$log.info(error);
	            });
	
	            // this.ThingsService.getObservations(params)
	            //     .then((response) => {
	            //         this.dataProvider = [];
	            //         /* eslint-disable */
	
	            //         let lastKnownPosition = '';
	            //         let lastKnownDoor = undefined;
	            //         let lastKnownPower = undefined;
	            //         let lastKnownMoving = undefined;
	
	            //         for (let h of response.aggregations.hist.buckets) {
	
	            //             /*  Fill up data to make temperature and location always occur in pairs. This
	            //                 because the temperature graph is clickable to show corresponding location */
	
	            //             let point = {
	            //                 'timestamp': new Date(h.key),
	            //             };
	
	            //             if (h.latlng.location && (h.latlng.location.lat > 0 && h.latlng.location.lon > 0)) {
	            //                 lastKnownPosition = h.latlng.location.lat + ', ' + h.latlng.location.lon;
	            //             }
	
	            //             /*  "h.door.value", "h.power.value", "h.moving.value" can have 3 states: "1", "0" or "undefined".
	            //                 "undefined" is not valid and will leave gaps in the graph.
	            //             */
	
	            //             if (h.door.value != undefined) lastKnownDoor = h.door.value + 2;
	            //             if (h.power.value != undefined) lastKnownPower = h.power.value + 4;
	
	            //             point['door'] = lastKnownDoor;
	            //             point['power'] = lastKnownPower;
	            //             if (h.moving.value === 1) point['moving'] = 1;
	
	            //             if (h.box_temperature.value) point['box_temperature'] = h.box_temperature.value;
	            //             if (h.box_temperature.value) point['latlng'] = lastKnownPosition;
	            //             if (h.ambient_temperature.value) point['ambient_temperature'] = h.ambient_temperature.value;
	            //             this.dataProvider.push(point);
	            //         }
	            //         /* eslint-enable */
	            //     })
	            //     .then(() => {
	            //         params['sortOrder'] = 'asc';
	
	            //         this.EventsService.getEvents(params)
	            //             .then((response) => {
	            //                 for (let e of response.hits.hits) {
	            //                     this.dataProvider.push({
	            //                         'timestamp': new Date(e._source.timestamp),
	            //                         'eventMessage': e._source.message,
	            //                         'eventValue': 0
	            //                         ,
	            //                     });
	            //                 }
	
	            //                 // Having both temperature and events reading in the same array. Sort on the common property 'timestamp'
	            //                 this.dataProvider.sort((a, b) => { return (a.timestamp > b.timestamp) ? 1 : ((b.timestamp > a.timestamp) ? -1 : 0); });
	            //             })
	            //             .then(() => {
	            //                 this.addTempChart();
	            //                 this.addSensorChart();
	            //                 this.setupSynchronization();
	            //                 this.$rootScope.$emit('chartDataPrepared', this.dataProvider);
	            //             })
	            //             .catch((err) => {
	            //                 this.$log.info(err);
	            //             });
	            //     })
	        }
	    }, {
	        key: 'boxTemperatureBallonText',
	        value: function boxTemperatureBallonText(graphDataItem, graph) {
	            return graphDataItem.dataContext.box_temperature + ' &#8451;';
	        }
	    }, {
	        key: 'ambientTemperatureBallonText',
	        value: function ambientTemperatureBallonText(graphDataItem, graph) {
	            return graphDataItem.dataContext.ambient_temperature + ' &#8451;';
	        }
	    }, {
	        key: 'eventMessageBallonText',
	        value: function eventMessageBallonText(graphDataItem, graph) {
	            return graphDataItem.dataContext.eventMessage;
	        }
	    }, {
	        key: 'addTempChart',
	        value: function addTempChart() {
	            var _this2 = this;
	
	            var options = angular.merge({}, defaultOptions);
	            options.dataProvider = this.dataProvider;
	            options.legend = {
	                'useGraphSettings': true,
	                'equalWidths': false,
	                'position': 'top'
	            };
	
	            options.graphs = [{
	                'id': 'box_temp',
	                'title': this.$translate.instant('IOF.COMPARTMENT.TEMPERATURE'),
	                'balloonFunction': this.boxTemperatureBallonText,
	                'bullet': 'round',
	                'bulletSize': 6,
	                'lineColor': '#ff9800',
	                'lineThickness': 2,
	                'type': 'line',
	                'valueField': 'box_temperature',
	                'valueAxis': 'temperatureAxis',
	                'connect': true
	            }, {
	                'id': 'ambient_temp',
	                'title': this.$translate.instant('IOF.COMPARTMENT2.TEMPERATURE'),
	                'balloonFunction': this.ambientTemperatureBallonText,
	                'bullet': 'round',
	                'bulletSize': 6,
	                'lineColor': '#1086ca',
	                'lineThickness': 2,
	                'type': 'line',
	                'valueField': 'ambient_temperature',
	                'valueAxis': 'temperatureAxis',
	                'connect': true,
	                'hidden': true
	            }, {
	                'id': 'event',
	                'title': this.$translate.instant('NOTIFICATIONS.EVENT'),
	                'balloonFunction': this.eventMessageBallonText,
	                'bullet': 'triangleUp',
	                'bulletSize': 16,
	                'lineColor': '#ff0000',
	                'type': 'line',
	                'valueField': 'eventValue',
	                'connect': false
	            }];
	
	            options.chartScrollbar = {
	                'graph': 'box_temp',
	                'gridAlpha': 0,
	                'color': '#343434',
	                'scrollbarHeight': 55,
	                'backgroundAlpha': 0,
	                'selectedBackgroundAlpha': 0.25,
	                'selectedBackgroundColor': '#DEDEDE',
	                'graphFillAlpha': 0,
	                'selectedGraphFillAlpha': 0,
	                'graphLineAlpha': 1,
	                'graphLineColor': '#343434',
	                'selectedGraphLineColor': '#343434',
	                'selectedGraphLineAlpha': 1,
	                'offset': 20
	            };
	
	            options.export = {
	                'enabled': true,
	                'position': 'top-left',
	                'offset': 40
	            };
	
	            this.charts.push(AmCharts.makeChart('temp-chart', options));
	
	            this.charts[0].addListener("clickGraphItem", function (event) {
	                _this2.$rootScope.$emit('graphClicked', event.item.dataContext);
	            });
	        }
	    }, {
	        key: 'powerBalloon',
	        value: function powerBalloon(graphDataItem, graph) {
	            var status = graphDataItem.dataContext.power === 3 ? this.$translate.instant('IOF.POWER_ON') : this.$translate.instant('IOF.POWER_OFF');
	            return '<span style="font-size:14px;">' + status + '</span>';
	        }
	    }, {
	        key: 'doorBalloon',
	        value: function doorBalloon(graphDataItem, graph) {
	            var status = graphDataItem.dataContext.door === 2 ? this.$translate.instant('IOF.DOOR_OPEN') : this.$translate.instant('IOF.DOOR_CLOSED');
	            return '<span style="font-size:14px;">' + status + '</span>';
	        }
	    }, {
	        key: 'movingBalloon',
	        value: function movingBalloon(graphDataItem, graph) {
	            var status = '';
	            if (this.showTransport === false) {
	                status = graphDataItem.dataContext.moving === 1 ? this.$translate.instant('IOF.MOVEMENT.MOVING') : this.$translate.instant('IOF.MOVEMENT.STILL');
	            } else {
	                status = graphDataItem.dataContext.in_transport === 1 ? 'In transport' : 'Not in transport';
	            }
	            return '<span style="font-size:14px;">' + status + '</span>';
	        }
	    }, {
	        key: 'addSensorChart',
	        value: function addSensorChart() {
	            var options = angular.merge({}, defaultOptions);
	            options.dataProvider = this.dataProvider;
	            options.valueAxes = [{ ignoreAxisWidth: true, labelsEnabled: false }];
	            options.graphs = [{
	                'id': 'door',
	                'title': 'Door status',
	                'balloonFunction': this.doorBalloon.bind(this),
	                "balloon": {
	                    "drop": false,
	                    "adjustBorderColor": false,
	                    "color": "#ffffff"
	                },
	                'lineColor': '#1086ca',
	                'lineThickness': 2,
	                'bullet': 'square',
	                'bulletSize': 5,
	                'type': 'step',
	                'valueField': 'door'
	            }, {
	                'id': 'power',
	                'title': 'Power status',
	                'balloonFunction': this.powerBalloon.bind(this),
	                "balloon": {
	                    "drop": false,
	                    "adjustBorderColor": false,
	                    "color": "#ffffff"
	                },
	                'lineColor': '#4CAF50',
	                'lineThickness': 2,
	                'bullet': 'square',
	                'bulletSize': 5,
	                'type': 'step',
	                'valueField': 'power'
	            }, {
	                'id': 'moving',
	                'title': 'Movement status',
	                'balloonFunction': this.movingBalloon.bind(this),
	                "balloon": {
	                    "drop": false,
	                    "adjustBorderColor": false,
	                    "color": "#ffffff"
	                },
	                'lineColor': '#343434',
	                'lineThickness': 0,
	                'type': 'line',
	                'bullet': 'square',
	                'bulletSize': 5,
	                'valueField': 'moving'
	            }, {
	                'id': 'in_transport',
	                'title': 'Movement status',
	                'balloonFunction': this.movingBalloon.bind(this),
	                "balloon": {
	                    "drop": false,
	                    "adjustBorderColor": false,
	                    "color": "#ffffff"
	                },
	                'lineColor': '#343434',
	                'lineThickness': 2,
	                'type': 'step',
	                'bullet': 'square',
	                'bulletSize': 5,
	                'valueField': 'in_transport'
	            }];
	            this.charts.push(AmCharts.makeChart('sensor-chart', options));
	        }
	    }, {
	        key: 'setupSynchronization',
	        value: function setupSynchronization() {
	            // Synchronized scrolling based on this example:
	            // https://www.amcharts.com/kbase/syncing-zoom-across-several-date-based-serial-charts/
	            var charts = this.charts;
	            var syncZoom = function syncZoom(event) {
	                for (x in charts) {
	                    if (charts[x].ignoreZoom) {
	                        charts[x].ignoreZoom = false;
	                    }
	                    if (event.chart !== charts[x]) {
	                        charts[x].ignoreZoom = true;
	                        if ('zoomToDates' in charts[x]) {
	                            charts[x].zoomToDates(event.startDate, event.endDate);
	                        }
	                    }
	                }
	            };
	
	            var handleCursorChange = function handleCursorChange(event) {
	                for (var x in charts) {
	                    if (event.chart !== charts[x]) {
	                        charts[x].chartCursor.syncWithCursor(event.chart.chartCursor);
	                        debugger;
	                    }
	                }
	            };
	
	            var handleHideCursor = function handleHideCursor() {
	                for (var x in charts) {
	                    if (charts[x].chartCursor.hideCursor) {
	                        charts[x].chartCursor.forceShow = false;
	                        charts[x].chartCursor.hideCursor(false);
	                    }
	                }
	            };
	
	            for (var x in charts) {
	                charts[x].addListener('zoomed', syncZoom);
	                charts[x].addListener("init", function (event) {
	                    event.chart.chartCursor.addListener('changed', handleCursorChange);
	                    event.chart.chartCursor.addListener('onHideCursor', handleHideCursor);
	                });
	            }
	        }
	    }]);
	    return GraphController;
	}();
	
	exports.default = GraphController;

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports = "<div id=temp-chart class=sb-graph-temp-chart></div> <div id=sensor-chart class=sb-graph-sensor-chart></div> ";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _notificationsTable = __webpack_require__(349);
	
	var _notificationsTable2 = _interopRequireDefault(_notificationsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(350);
	
	var NotificationsTableComponent = {
	    selector: 'sbNotificationsTable',
	    template: __webpack_require__(352),
	    controller: _notificationsTable2.default,
	    bindings: {
	        thingId: '<',
	        fromDate: '<',
	        toDate: '<'
	    }
	};
	
	exports.default = NotificationsTableComponent;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationsTableController = function () {
	    /* @ngInject */
	    function NotificationsTableController($log, $location, $routeParams, EventsService) {
	        (0, _classCallCheck3.default)(this, NotificationsTableController);
	
	        this.$log = $log;
	        this.$location = $location;
	        this.$routeParams = $routeParams;
	        this.EventsService = EventsService;
	
	        this.events = [];
	        this.currentPage = 0;
	        this.itemsPerPage = 7;
	        this.isLoading = true;
	    }
	
	    (0, _createClass3.default)(NotificationsTableController, [{
	        key: '$onChanges',
	        value: function $onChanges() {
	            this.getEvents();
	        }
	    }, {
	        key: 'getEvents',
	        value: function getEvents() {
	            var _this = this;
	
	            var params = {
	                thingId: this.$routeParams.id,
	                fromDate: this.fromDate,
	                toDate: this.toDate
	            };
	            this.isLoading = true;
	            this.EventsService.getEvents(params).then(function (response) {
	                _this.events = response.hits.hits;
	            }).catch(function (error) {
	                _this.$log.info('Error getting events: ' + error);
	                _this.$location.path('/login');
	            }).finally(function () {
	                _this.isLoading = false;
	            });
	        }
	    }, {
	        key: 'isEmpty',
	        value: function isEmpty() {
	            return this.events && this.events.length === 0;
	        }
	    }, {
	        key: 'eventsForCurrentPage',
	        value: function eventsForCurrentPage() {
	            return this.events.slice(this.currentPage * this.itemsPerPage, this.currentPage * this.itemsPerPage + this.itemsPerPage);
	        }
	    }, {
	        key: 'numberOfPages',
	        value: function numberOfPages() {
	            return Math.ceil(this.events.length / this.itemsPerPage);
	        }
	    }, {
	        key: 'previousPage',
	        value: function previousPage() {
	            if (this.currentPage > 0) {
	                this.currentPage = this.currentPage - 1;
	            }
	        }
	    }, {
	        key: 'nextPage',
	        value: function nextPage() {
	            if (this.currentPage < this.numberOfPages() - 1) {
	                this.currentPage = this.currentPage + 1;
	            }
	        }
	    }]);
	    return NotificationsTableController;
	}();
	
	exports.default = NotificationsTableController;

/***/ }),
/* 350 */
3,
/* 351 */,
/* 352 */
/***/ (function(module, exports) {

	module.exports = "<div class=row> <div class=\"col-xs-12 col-md-12\"> <h3 class=sb-detail-heading translate>NOTIFICATIONS.NOTIFICATIONS</h3> </div> </div> <div class=row> <div class=\"col-xs-12 col-md-12\"> <div ng-if=$ctrl.isLoading class=sb-notifications> <sb-empty-box icon-css=\"fa-spinner fa-spin fa-fw\" title=\"\" message=CART.NOTIFICATIONS.LOADING.MESSAGE> </sb-empty-box> </div> <div ng-if=\"!$ctrl.isLoading && $ctrl.isEmpty()\" class=sb-notifications> <sb-empty-box icon-css=fa-list-alt title=CART.NOTIFICATIONS.EMPTY.HEADER message=CART.NOTIFICATIONS.EMPTY.MESSAGE> </sb-empty-box> </div> <div ng-if=\"!$ctrl.isLoading && !$ctrl.isEmpty()\" class=sb-notifications> <table class=table> <thead> <tr> <th></th> <th translate>NOTIFICATIONS.DATE</th> <th translate>NOTIFICATIONS.EVENT</th> </tr> </thead> <tbody> <tr ng-repeat=\"event in $ctrl.eventsForCurrentPage()\"> <td> <i ng-if=\"event._source.classification === 'WARNING'\" class=\"fa fa-exclamation-triangle warning\" aria-hidden=true></i> <i ng-if=\"event._source.classification === 'ALARM'\" class=\"fa fa-exclamation-triangle alarm\" aria-hidden=true></i> </td> <td> {{ event._source.timestamp | date:'yyyy-MM-dd HH:mm:ss'}} </td> <td> {{ event._source.message }} </td>  </tr> </tbody> </table> </div> </div> </div> <div class=row> <div class=\"col-xs-12 col-md-12 text-center text-muted\"> <span translate>PAGINATION.SHOWING</span> {{ $ctrl.currentPage + 1 }} <span translate>PAGINATION.OF</span> {{ $ctrl.numberOfPages() }} </div> </div> <div class=\"row sb-margin-top\"> <div class=\"col-xs-6 col-md-6\"> <button type=button class=\"btn btn-default btn-sm pull-right\" ng-show=\"$ctrl.numberOfPages() > 1\" ng-click=\"$ctrl.previousPage(); $event.stopPropagation();\"> <span translate>PAGINATION.PREVIOUS</span> </button> </div> <div class=\"col-xs-6 col-md-6\"> <button type=button class=\"btn btn-default btn-sm\" ng-show=\"$ctrl.numberOfPages() > 1\" ng-click=\"$ctrl.nextPage(); $event.stopPropagation();\"> <span translate>PAGINATION.NEXT</span> </button> </div> </div> ";

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	__webpack_require__(354);
	
	var KnownStateComponent = {
	    selector: 'sbKnownState',
	    template: __webpack_require__(356),
	    bindings: {
	        thing: '<'
	    }
	};
	
	exports.default = KnownStateComponent;

/***/ }),
/* 354 */
3,
/* 355 */,
/* 356 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table sb-table-no-header\"> <tbody> <tr> <td translate>STATE.LAST_UPDATE</td> <td>{{$ctrl.thing.shadow.metadata.reported.box_temperature.timestamp * 1000 | date:'yyyy-MM-dd HH:mm:ss'}}</td> </tr> <tr> <td translate>IOF.MODEL</td> <td>{{$ctrl.thing.shadow.state.reported.model}}</td> </tr> <tr> <td translate>IOF.SERIAL</td> <td>{{$ctrl.thing.shadow.state.reported.serial}}</td> </tr> <tr> <td translate>IOF.NETWORK</td> <td ng-switch=$ctrl.thing.shadow.state.reported.tcxn.connection_status> <span ng-switch-when=0 class=sb-known-state-offline translate>IOF.OFFLINE</span> <span ng-switch-when=2 class=sb-known-state-online translate>IOF.ONLINE</span> <span ng-switch-default class=sb-known-state-unknown translate>-</span> </td> </tr> <tr> <td translate>IOF.TEMPERATURE</td> <td>{{$ctrl.thing.shadow.state.reported.box_temperature}}</td> </tr> <tr> <td translate>IOF.DOOR</td> <td ng-switch=$ctrl.thing.shadow.state.reported.door_open> <span ng-switch-when=0 class=sb-known-state-door-closed translate>IOF.CLOSED</span> <span ng-switch-when=1 class=sb-known-state-door-open translate>IOF.OPEN</span> <span ng-switch-default class=sb-known-state-unknown translate>-</span> </td> </tr> <tr> <td translate>IOF.POWER</td> <td ng-switch=$ctrl.thing.shadow.state.reported.mains_powered> <span ng-switch-when=0 class=sb-cart-table-power-off translate>IOF.POWER.OFF</span> <span ng-switch-when=1 class=sb-cart-table-power-on translate>IOF.POWER.ON</span> <span ng-switch-default class=sb-cart-table-unknown translate>-</span> </td> </tr> <tr ng-if=\"showAll===true\"> <td translate>IOF.LOCATION</td> <td>{{$ctrl.thing.shadow.state.reported.latlng}}</td> </tr> <tr ng-if=\"showAll===true\"> <td translate>STATE.BATTERY</td> <td>{{$ctrl.thing.shadow.state.reported.battery}}</td> </tr> <tr ng-if=\"showAll===true\"> <td translate>STATE.AMBIENT_TEMPERATURE</td> <td>{{$ctrl.thing.shadow.state.reported.ambient_temperature}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>feedback</td> <td>{{$ctrl.thing.shadow.state.reported.feedack}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>fw_version</td> <td>{{$ctrl.thing.shadow.state.reported.fw_version}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>uptime</td> <td>{{$ctrl.thing.shadow.state.reported.uptime}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>rssi</td> <td>{{$ctrl.thing.shadow.state.reported.Network_info.net_rssi}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>sleeping</td> <td>{{$ctrl.thing.shadow.state.reported.sleeping}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>gps_position</td> <td>{{$ctrl.thing.shadow.state.reported.gps_position}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>gps_ok</td> <td>{{$ctrl.thing.shadow.state.reported.gps_ok}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>net_rssi</td> <td>{{$ctrl.thing.shadow.state.reported.Network_info.net_rssi}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>net_type</td> <td>{{$ctrl.thing.shadow.state.reported.Network_info.net_type}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>net_mcc</td> <td>{{$ctrl.thing.shadow.state.reported.Network_info.net_mcc}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>net_mnc</td> <td>{{$ctrl.thing.shadow.state.reported.Network_info.net_mnc}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>net_lac</td> <td>{{$ctrl.thing.shadow.state.reported.Network_info.net_lac}}</td> </tr> <tr ng-if=\"showAll===true\"> <td>net_cellid</td> <td>{{$ctrl.thing.shadow.state.reported.Network_info.net_cellid}}</td> </tr> </tbody> </table> <div class=text-center> <button class=\"btn btn-default btn-sm\" ng-click=\"showAll = showAll === true ? false : true;\"> <span ng-show=\"showAll===false || showAll===undefined\" translate>STATE.SHOW_MORE</span> <span ng-show=\"showAll===true\" translate>STATE.SHOW_LESS</span> </button> </div> ";

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mapPosition = __webpack_require__(358);
	
	var _mapPosition2 = _interopRequireDefault(_mapPosition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapPositionComponent = {
	    selector: 'sbMapPosition',
	    template: __webpack_require__(359),
	    controller: _mapPosition2.default,
	    bindings: {
	        thing: '<'
	    }
	};
	
	exports.default = MapPositionComponent;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapPositionController = function () {
	    /* @ngInject */
	    function MapPositionController($rootScope, MapService) {
	        var _this = this;
	
	        (0, _classCallCheck3.default)(this, MapPositionController);
	
	        this.$rootScope = $rootScope;
	        this.MapService = MapService;
	
	        this.$rootScope.$on('graphClicked', function (event, data) {
	            _this.showOnMap(data.latlng);
	        });
	
	        this.$rootScope.$on('chartDataPrepared', function (event, data) {
	            _this.MapService.clearMap();
	            _this.MapService.showCartTrace(data, 'mapDetailDivId');
	        });
	    }
	
	    (0, _createClass3.default)(MapPositionController, [{
	        key: 'showOnMap',
	        value: function showOnMap(latlng) {
	            var cart = { _source: { state: { latlng: latlng } } };
	            this.MapService.showCartsOnMap([cart], 'mapDetailDivId', false, false);
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges() {
	            if (this.thing.shadow) {
	                this.showOnMap(this.thing.shadow.state.reported.latlng);
	                // this.MapService.clearMap();
	            }
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.MapService.destroy();
	        }
	    }]);
	    return MapPositionController;
	}();
	
	exports.default = MapPositionController;

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	module.exports = "<div id=mapDetailDivId class=sb-map-position></div> <ul class=sb-map-legend> <li class=sb-map-legend-marker> <img src=/assets/black-marker.png /> <span translate=MAP.LEGEND.NORMAL></span> </li> <li class=sb-map-legend-marker> <img src=/assets/red-marker.png /> <span translate=MAP.LEGEND.ALARM></span> </li> <li class=sb-map-legend-marker> <img src=/assets/green-marker.png /> <span translate=MAP.LEGEND.FIRST></span> </li> </ul> ";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _cartsReportView = __webpack_require__(361);
	
	var _cartsReportView2 = _interopRequireDefault(_cartsReportView);
	
	var _eventsTable = __webpack_require__(364);
	
	var _eventsTable2 = _interopRequireDefault(_eventsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('app.reports', []).component(_cartsReportView2.default.selector, _cartsReportView2.default).component(_eventsTable2.default.selector, _eventsTable2.default);
	
	exports.default = _module.name;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _cartsReportView = __webpack_require__(362);
	
	var _cartsReportView2 = _interopRequireDefault(_cartsReportView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CartsReportViewComponent = {
	    selector: 'sbCartsReport',
	    controller: _cartsReportView2.default,
	    template: __webpack_require__(363)
	};
	
	exports.default = CartsReportViewComponent;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass2 = __webpack_require__(27);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Event = function Event(timestamp, message, name, serial, domainName, domainId) {
	    (0, _classCallCheck3.default)(this, Event);
	
	    this.timestamp = timestamp;
	    this.message = message;
	    this.cartName = name;
	    this.cartSerial = serial;
	    this.domainName = domainName;
	    this.domainId = domainId;
	};
	
	var CartsReportViewController = function () {
	    /* @ngInject */
	    function CartsReportViewController($log, $location, $scope, ThingsService, EventsService, MomentService) {
	        (0, _classCallCheck3.default)(this, CartsReportViewController);
	
	        this.$log = $log;
	        this.$location = $location;
	        this.$scope = $scope;
	        this.ThingsService = ThingsService;
	        this.EventsService = EventsService;
	        this.MomentService = MomentService;
	
	        this.rootDomain = undefined;
	        this.fromDate = this.MomentService.startOfWeek();
	        this.toDate = this.MomentService.endOfDay();
	        this.events = [];
	        this.allEvents = [];
	        this.isLoading = true;
	    }
	
	    (0, _createClass3.default)(CartsReportViewController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.getDomains();
	            this.getAlarms().then(function () {
	                _this.filterOnDomain(_this.ThingsService.selectedDomain);
	            });
	            this.dateWatcher = this.$scope.$watchGroup(['$ctrl.fromDate', '$ctrl.toDate'], function (newValue, oldValue) {
	                if (newValue[0] !== oldValue[0] || newValue[1] !== oldValue[1]) {
	                    _this.getAlarms().then(function () {
	                        _this.filterOnDomain();
	                    });
	                }
	            });
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            if (this.dateWatcher !== undefined) this.dateWatcher();
	        }
	    }, {
	        key: 'getDomains',
	        value: function getDomains() {
	            var _this2 = this;
	
	            this.ThingsService.getDomains().then(function (rootDomain) {
	                _this2.rootDomain = rootDomain;
	            }).catch(function (error) {
	                _this2.$log.info('Error getting domains: ' + error);
	            });
	        }
	    }, {
	        key: 'doFilterOnDomain',
	        value: function doFilterOnDomain(domainId) {
	            this.ThingsService.selectedDomain = domainId;
	            this.filterOnDomain(this.ThingsService.selectedDomain);
	        }
	    }, {
	        key: 'filterOnDomain',
	        value: function filterOnDomain(domainId) {
	            // The original list of events contains events for all domains so
	            // we only need to filter that list, no subsequent request is needed.
	            if (domainId === undefined) {
	                this.events = this.allEvents;
	            } else {
	                var ids = this.rootDomain.find(domainId).getAllIds();
	                this.events = this.allEvents.filter(function (event) {
	                    return ids.includes(event.domainId);
	                });
	            }
	        }
	    }, {
	        key: 'getAlarms',
	        value: function getAlarms() {
	            var _this3 = this;
	
	            var fieldOrEmpty = function fieldOrEmpty(thing, field) {
	                if (thing._source.state === undefined) return '';
	                return thing._source.state[field];
	            };
	            /* eslint-disable no-underscore-dangle */
	            var params = {
	                domainId: this.ThingsService.selectedDomain,
	                fromDate: this.fromDate,
	                toDate: this.toDate
	            };
	            var events = [];
	            var cachedNames = {};
	
	            // Start a sequential operation in order to produce a list
	            // of all alarms for the current domain.
	            this.isLoading = true;
	            return this.EventsService.getEventsForDomain(params).then(function (result) {
	                events = result.hits.hits;
	                return _this3.ThingsService.getDomains();
	            }).then(function (domains) {
	                // Go through all events and resolve domain name by id and
	                // store that in a lookup object for later use.
	                cachedNames = events.filter(function (event) {
	                    return event._source.source.domain;
	                }).reduce(function (map, event) {
	                    if (!(event._source.source.domain in map)) {
	                        map[event._source.source.domain] = domains.resolveName(event._source.source.domain);
	                    }
	                    return map;
	                }, {});
	
	                return _this3.ThingsService.getThings();
	            }).then(function (things) {
	                // Convert the list of things to a object where details
	                // can be looked up based on thingName / thingID.
	                var thingData = things.hits.hits.reduce(function (map, thing) {
	                    map[thing._id] = {
	                        id: thing._id,
	                        name: thing._source.label,
	                        serial: fieldOrEmpty(thing, 'serial')
	                    };
	                    return map;
	                }, {});
	
	                // Construct the Alarm objects based on the event data and the resolved
	                // information regarding thing and domain
	                _this3.allEvents = events.map(function (event) {
	                    return new Event(event._source.timestamp, event._source.message, thingData[event._source.source.thingName].name, thingData[event._source.source.thingName].serial, cachedNames[event._source.source.domain], event._source.source.domain);
	                });
	            }).catch(function (error) {
	                _this3.$log.info('Error getting events: ' + error);
	                _this3.$location.path('/login');
	            }).finally(function () {
	                _this3.isLoading = false;
	            });
	            /* eslint-enable no-underscore-dangle */
	        }
	    }, {
	        key: 'isEmpty',
	        value: function isEmpty() {
	            return this.events && this.events.length === 0;
	        }
	    }]);
	    return CartsReportViewController;
	}();
	
	exports.default = CartsReportViewController;

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	module.exports = "<sb-application-page> <sb-application-content> <sb-page-context> <div class=container> <div class=\"row hidden-sm hidden-xs\"> <div class=col-md-12> <h2 translate>REPORTS.CONTEXT.HEADER</h2> </div> </div> <div class=row> <div class=col-md-5> <form class=form-horizontal> <div class=form-group> <div class=\"col-sm-6 col-xs-12\"> <div class=\"input-group sb-date-picker\"> <input type=text id=startDate class=form-control ng-model=$ctrl.fromDate date-format=yyyy-MM-dd data-autoclose=1 bs-datepicker> <label for=startDate class=input-group-addon> <i class=\"fa fa-calendar\" aria-hidden=true></i> </label> </div> </div> <div class=\"col-sm-6 col-xs-12\"> <div class=\"input-group sb-date-picker\"> <input type=text id=toDate class=form-control ng-model=$ctrl.toDate date-format=yyyy-MM-dd data-autoclose=1 icon-right bs-datepicker> <label for=toDate class=input-group-addon> <i class=\"fa fa-calendar\" aria-hidden=true></i> </label> </div> </div> </div> </form> </div> <div class=col-md-3> <sb-domain-selector on-select=$ctrl.doFilterOnDomain(domainId);></sb-domain-selector> </div> <div class=\"col-md-2 col-md-offset-2\"> </div> </div> </div> </sb-page-context> <div class=container> <div class=\"row sb-margin-top sb-margin-bottom\"> <div class=col-md-12> <div ng-if=$ctrl.isLoading> <sb-empty-box icon-css=\"fa-spinner fa-spin fa-fw\" title=\"\" message=REPORT.LOADING.MESSAGE> </sb-empty-box> </div> <div ng-if=\"!$ctrl.isLoading && $ctrl.isEmpty()\"> <sb-empty-box icon-css=fa-list-alt title=REPORT.EMPTY.HEADER message=REPORT.EMPTY.MESSAGE> </sb-empty-box> </div> <div ng-if=\"!$ctrl.isLoading && !$ctrl.isEmpty()\"> <sb-events-table events=$ctrl.events></sb-events-table> </div> </div> </div> </div> </sb-application-content> </sb-application-page> ";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var EventsTableComponent = {
	    selector: 'sbEventsTable',
	    template: __webpack_require__(365),
	    bindings: {
	        events: '<'
	    }
	};
	
	exports.default = EventsTableComponent;

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	module.exports = "<table class=\"table table-striped table-hover sb-cart-table\"> <thead> <tr> <th translate>REPORT.TABLE.EVENT.CART</th> <th translate>REPORT.TABLE.EVENT.SERIAL</th> <th translate>REPORT.TABLE.EVENT.DOMAIN</th> <th translate>REPORT.TABLE.EVENT.TIMESTAMP</th> <th translate>REPORT.TABLE.EVENT.NAME</th> </tr> </thead> <tbody> <tr ng-repeat=\"event in $ctrl.events\"> <td>{{ event.cartName }}</td> <td>{{ event.cartSerial }}</td> <td>{{ event.domainName }}</td> <td> {{ event.timestamp | date:'yyyy-MM-dd HH:mm:ss'}} </td> <td>{{ event.message }}</td> </tr> </tbody> </table> ";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(367);
	__webpack_require__(368);
	module.exports = 'mgcrea.ngStrap';


/***/ }),
/* 367 */
/***/ (function(module, exports) {

	/**
	 * angular-strap
	 * @version v2.3.12 - 2017-01-26
	 * @link http://mgcrea.github.io/angular-strap
	 * @author Olivier Louvignes <olivier@mg-crea.com> (https://github.com/mgcrea)
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, document, undefined) {
	  'use strict';
	  bsCompilerService.$inject = [ '$q', '$http', '$injector', '$compile', '$controller', '$templateCache' ];
	  angular.module('mgcrea.ngStrap.typeahead', [ 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.helpers.parseOptions' ]).provider('$typeahead', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'typeahead',
	      prefixEvent: '$typeahead',
	      placement: 'bottom-left',
	      templateUrl: 'typeahead/typeahead.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      minLength: 1,
	      filter: 'bsAsyncFilter',
	      limit: 6,
	      autoSelect: false,
	      comparator: '',
	      trimValue: true
	    };
	    this.$get = [ '$window', '$rootScope', '$tooltip', '$$rAF', '$timeout', function($window, $rootScope, $tooltip, $$rAF, $timeout) {
	      function TypeaheadFactory(element, controller, config) {
	        var $typeahead = {};
	        var options = angular.extend({}, defaults, config);
	        $typeahead = $tooltip(element, options);
	        var parentScope = config.scope;
	        var scope = $typeahead.$scope;
	        scope.$resetMatches = function() {
	          scope.$matches = [];
	          scope.$activeIndex = options.autoSelect ? 0 : -1;
	        };
	        scope.$resetMatches();
	        scope.$activate = function(index) {
	          scope.$$postDigest(function() {
	            $typeahead.activate(index);
	          });
	        };
	        scope.$select = function(index, evt) {
	          scope.$$postDigest(function() {
	            $typeahead.select(index);
	          });
	        };
	        scope.$isVisible = function() {
	          return $typeahead.$isVisible();
	        };
	        $typeahead.update = function(matches) {
	          scope.$matches = matches;
	          if (scope.$activeIndex >= matches.length) {
	            scope.$activeIndex = options.autoSelect ? 0 : -1;
	          }
	          safeDigest(scope);
	          $$rAF($typeahead.$applyPlacement);
	        };
	        $typeahead.activate = function(index) {
	          scope.$activeIndex = index;
	        };
	        $typeahead.select = function(index) {
	          if (index === -1) return;
	          var value = scope.$matches[index].value;
	          controller.$setViewValue(value);
	          controller.$render();
	          scope.$resetMatches();
	          if (parentScope) parentScope.$digest();
	          scope.$emit(options.prefixEvent + '.select', value, index, $typeahead);
	          if (angular.isDefined(options.onSelect) && angular.isFunction(options.onSelect)) {
	            options.onSelect(value, index, $typeahead);
	          }
	        };
	        $typeahead.$isVisible = function() {
	          if (!options.minLength || !controller) {
	            return !!scope.$matches.length;
	          }
	          return scope.$matches.length && angular.isString(controller.$viewValue) && controller.$viewValue.length >= options.minLength;
	        };
	        $typeahead.$getIndex = function(value) {
	          var index;
	          for (index = scope.$matches.length; index--; ) {
	            if (angular.equals(scope.$matches[index].value, value)) break;
	          }
	          return index;
	        };
	        $typeahead.$onMouseDown = function(evt) {
	          evt.preventDefault();
	          evt.stopPropagation();
	        };
	        $typeahead.$$updateScrollTop = function(container, index) {
	          if (index > -1 && index < container.children.length) {
	            var active = container.children[index];
	            var clientTop = active.offsetTop;
	            var clientBottom = active.offsetTop + active.clientHeight;
	            var highWatermark = container.scrollTop;
	            var lowWatermark = container.scrollTop + container.clientHeight;
	            if (clientBottom >= highWatermark && clientTop < highWatermark) {
	              container.scrollTop = Math.max(0, container.scrollTop - container.clientHeight);
	            } else if (clientBottom > lowWatermark) {
	              container.scrollTop = clientTop;
	            }
	          }
	        };
	        $typeahead.$onKeyDown = function(evt) {
	          if (!/(38|40|13)/.test(evt.keyCode)) return;
	          if ($typeahead.$isVisible() && !(evt.keyCode === 13 && scope.$activeIndex === -1)) {
	            evt.preventDefault();
	            evt.stopPropagation();
	          }
	          if (evt.keyCode === 13 && scope.$matches.length) {
	            $typeahead.select(scope.$activeIndex);
	          } else if (evt.keyCode === 38 && scope.$activeIndex > 0) {
	            scope.$activeIndex--;
	          } else if (evt.keyCode === 40 && scope.$activeIndex < scope.$matches.length - 1) {
	            scope.$activeIndex++;
	          } else if (angular.isUndefined(scope.$activeIndex)) {
	            scope.$activeIndex = 0;
	          }
	          $typeahead.$$updateScrollTop($typeahead.$element[0], scope.$activeIndex);
	          scope.$digest();
	        };
	        var show = $typeahead.show;
	        $typeahead.show = function() {
	          show();
	          $timeout(function() {
	            if ($typeahead.$element) {
	              $typeahead.$element.on('mousedown', $typeahead.$onMouseDown);
	              if (options.keyboard) {
	                if (element) element.on('keydown', $typeahead.$onKeyDown);
	              }
	            }
	          }, 0, false);
	        };
	        var hide = $typeahead.hide;
	        $typeahead.hide = function() {
	          if ($typeahead.$element) $typeahead.$element.off('mousedown', $typeahead.$onMouseDown);
	          if (options.keyboard) {
	            if (element) element.off('keydown', $typeahead.$onKeyDown);
	          }
	          if (!options.autoSelect) {
	            $typeahead.activate(-1);
	          }
	          hide();
	        };
	        return $typeahead;
	      }
	      function safeDigest(scope) {
	        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
	      }
	      TypeaheadFactory.defaults = defaults;
	      return TypeaheadFactory;
	    } ];
	  }).filter('bsAsyncFilter', [ '$filter', function($filter) {
	    return function(array, expression, comparator) {
	      if (array && angular.isFunction(array.then)) {
	        return array.then(function(results) {
	          return $filter('filter')(results, expression, comparator);
	        });
	      }
	      return $filter('filter')(array, expression, comparator);
	    };
	  } ]).directive('bsTypeahead', [ '$window', '$parse', '$q', '$typeahead', '$parseOptions', function($window, $parse, $q, $typeahead, $parseOptions) {
	    var defaults = $typeahead.defaults;
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        element.off('change');
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'filter', 'limit', 'minLength', 'watchOptions', 'selectMode', 'autoSelect', 'comparator', 'id', 'prefixEvent', 'prefixClass' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'trimValue', 'filter' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide', 'onSelect' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        if (!element.attr('autocomplete')) element.attr('autocomplete', 'off');
	        var filter = angular.isDefined(options.filter) ? options.filter : defaults.filter;
	        var limit = options.limit || defaults.limit;
	        var comparator = options.comparator || defaults.comparator;
	        var bsOptions = attr.bsOptions;
	        if (filter) {
	          bsOptions += ' | ' + filter + ':$viewValue';
	          if (comparator) bsOptions += ':' + comparator;
	        }
	        if (limit) bsOptions += ' | limitTo:' + limit;
	        var parsedOptions = $parseOptions(bsOptions);
	        var typeahead = $typeahead(element, controller, options);
	        if (options.watchOptions) {
	          var watchedOptions = parsedOptions.$match[7].replace(/\|.+/, '').replace(/\(.*\)/g, '').trim();
	          scope.$watchCollection(watchedOptions, function(newValue, oldValue) {
	            parsedOptions.valuesFn(scope, controller).then(function(values) {
	              typeahead.update(values);
	              controller.$render();
	            });
	          });
	        }
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          scope.$modelValue = newValue;
	          parsedOptions.valuesFn(scope, controller).then(function(values) {
	            if (options.selectMode && !values.length && newValue.length > 0) {
	              controller.$setViewValue(controller.$viewValue.substring(0, controller.$viewValue.length - 1));
	              return;
	            }
	            if (values.length > limit) values = values.slice(0, limit);
	            typeahead.update(values);
	            controller.$render();
	          });
	        });
	        controller.$formatters.push(function(modelValue) {
	          var displayValue = parsedOptions.displayValue(modelValue);
	          if (displayValue) {
	            return displayValue;
	          }
	          if (angular.isDefined(modelValue) && typeof modelValue !== 'object') {
	            return modelValue;
	          }
	          return '';
	        });
	        controller.$render = function() {
	          if (controller.$isEmpty(controller.$viewValue)) {
	            return element.val('');
	          }
	          var index = typeahead.$getIndex(controller.$modelValue);
	          var selected = index !== -1 ? typeahead.$scope.$matches[index].label : controller.$viewValue;
	          selected = angular.isObject(selected) ? parsedOptions.displayValue(selected) : selected;
	          var value = selected ? selected.toString().replace(/<(?:.|\n)*?>/gm, '') : '';
	          var ss = element[0].selectionStart;
	          var sd = element[0].selectionEnd;
	          element.val(options.trimValue === false ? value : value.trim());
	          element[0].setSelectionRange(ss, sd);
	        };
	        scope.$on('$destroy', function() {
	          if (typeahead) typeahead.destroy();
	          options = null;
	          typeahead = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.tooltip', [ 'mgcrea.ngStrap.core', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$tooltip', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      customClass: '',
	      prefixClass: 'tooltip',
	      prefixEvent: 'tooltip',
	      container: false,
	      target: false,
	      placement: 'top',
	      templateUrl: 'tooltip/tooltip.tpl.html',
	      template: '',
	      titleTemplate: false,
	      trigger: 'hover focus',
	      keyboard: false,
	      html: false,
	      show: false,
	      title: '',
	      type: '',
	      delay: 0,
	      autoClose: false,
	      bsEnabled: true,
	      mouseDownPreventDefault: true,
	      mouseDownStopPropagation: true,
	      viewport: {
	        selector: 'body',
	        padding: 0
	      }
	    };
	    this.$get = [ '$window', '$rootScope', '$bsCompiler', '$q', '$templateCache', '$http', '$animate', '$sce', 'dimensions', '$$rAF', '$timeout', function($window, $rootScope, $bsCompiler, $q, $templateCache, $http, $animate, $sce, dimensions, $$rAF, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      var $body = angular.element($window.document);
	      function TooltipFactory(element, config) {
	        var $tooltip = {};
	        var options = $tooltip.$options = angular.extend({}, defaults, config);
	        var promise = $tooltip.$promise = $bsCompiler.compile(options);
	        var scope = $tooltip.$scope = options.scope && options.scope.$new() || $rootScope.$new();
	        var nodeName = element[0].nodeName.toLowerCase();
	        if (options.delay && angular.isString(options.delay)) {
	          var split = options.delay.split(',').map(parseFloat);
	          options.delay = split.length > 1 ? {
	            show: split[0],
	            hide: split[1]
	          } : split[0];
	        }
	        $tooltip.$id = options.id || element.attr('id') || '';
	        if (options.title) {
	          scope.title = $sce.trustAsHtml(options.title);
	        }
	        scope.$setEnabled = function(isEnabled) {
	          scope.$$postDigest(function() {
	            $tooltip.setEnabled(isEnabled);
	          });
	        };
	        scope.$hide = function() {
	          scope.$$postDigest(function() {
	            $tooltip.hide();
	          });
	        };
	        scope.$show = function() {
	          scope.$$postDigest(function() {
	            $tooltip.show();
	          });
	        };
	        scope.$toggle = function() {
	          scope.$$postDigest(function() {
	            $tooltip.toggle();
	          });
	        };
	        $tooltip.$isShown = scope.$isShown = false;
	        var timeout;
	        var hoverState;
	        var compileData;
	        var tipElement;
	        var tipContainer;
	        var tipScope;
	        promise.then(function(data) {
	          compileData = data;
	          $tooltip.init();
	        });
	        $tooltip.init = function() {
	          if (options.delay && angular.isNumber(options.delay)) {
	            options.delay = {
	              show: options.delay,
	              hide: options.delay
	            };
	          }
	          if (options.container === 'self') {
	            tipContainer = element;
	          } else if (angular.isElement(options.container)) {
	            tipContainer = options.container;
	          } else if (options.container) {
	            tipContainer = findElement(options.container);
	          }
	          bindTriggerEvents();
	          if (options.target) {
	            options.target = angular.isElement(options.target) ? options.target : findElement(options.target);
	          }
	          if (options.show) {
	            scope.$$postDigest(function() {
	              if (options.trigger === 'focus') {
	                element[0].focus();
	              } else {
	                $tooltip.show();
	              }
	            });
	          }
	        };
	        $tooltip.destroy = function() {
	          unbindTriggerEvents();
	          destroyTipElement();
	          scope.$destroy();
	        };
	        $tooltip.enter = function() {
	          clearTimeout(timeout);
	          hoverState = 'in';
	          if (!options.delay || !options.delay.show) {
	            return $tooltip.show();
	          }
	          timeout = setTimeout(function() {
	            if (hoverState === 'in') $tooltip.show();
	          }, options.delay.show);
	        };
	        $tooltip.show = function() {
	          if (!options.bsEnabled || $tooltip.$isShown) return;
	          scope.$emit(options.prefixEvent + '.show.before', $tooltip);
	          if (angular.isDefined(options.onBeforeShow) && angular.isFunction(options.onBeforeShow)) {
	            options.onBeforeShow($tooltip);
	          }
	          var parent;
	          var after;
	          if (options.container) {
	            parent = tipContainer;
	            if (tipContainer[0].lastChild) {
	              after = angular.element(tipContainer[0].lastChild);
	            } else {
	              after = null;
	            }
	          } else {
	            parent = null;
	            after = element;
	          }
	          if (tipElement) destroyTipElement();
	          tipScope = $tooltip.$scope.$new();
	          tipElement = $tooltip.$element = compileData.link(tipScope, function(clonedElement, scope) {});
	          tipElement.css({
	            top: '-9999px',
	            left: '-9999px',
	            right: 'auto',
	            display: 'block',
	            visibility: 'hidden'
	          });
	          if (options.animation) tipElement.addClass(options.animation);
	          if (options.type) tipElement.addClass(options.prefixClass + '-' + options.type);
	          if (options.customClass) tipElement.addClass(options.customClass);
	          if (after) {
	            after.after(tipElement);
	          } else {
	            parent.prepend(tipElement);
	          }
	          $tooltip.$isShown = scope.$isShown = true;
	          safeDigest(scope);
	          $tooltip.$applyPlacement();
	          if (angular.version.minor <= 2) {
	            $animate.enter(tipElement, parent, after, enterAnimateCallback);
	          } else {
	            $animate.enter(tipElement, parent, after).then(enterAnimateCallback);
	          }
	          safeDigest(scope);
	          $$rAF(function() {
	            if (tipElement) tipElement.css({
	              visibility: 'visible'
	            });
	            if (options.keyboard) {
	              if (options.trigger !== 'focus') {
	                $tooltip.focus();
	              }
	              bindKeyboardEvents();
	            }
	          });
	          if (options.autoClose) {
	            bindAutoCloseEvents();
	          }
	        };
	        function enterAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.show', $tooltip);
	          if (angular.isDefined(options.onShow) && angular.isFunction(options.onShow)) {
	            options.onShow($tooltip);
	          }
	        }
	        $tooltip.leave = function() {
	          clearTimeout(timeout);
	          hoverState = 'out';
	          if (!options.delay || !options.delay.hide) {
	            return $tooltip.hide();
	          }
	          timeout = setTimeout(function() {
	            if (hoverState === 'out') {
	              $tooltip.hide();
	            }
	          }, options.delay.hide);
	        };
	        var _blur;
	        var _tipToHide;
	        $tooltip.hide = function(blur) {
	          if (!$tooltip.$isShown) return;
	          scope.$emit(options.prefixEvent + '.hide.before', $tooltip);
	          if (angular.isDefined(options.onBeforeHide) && angular.isFunction(options.onBeforeHide)) {
	            options.onBeforeHide($tooltip);
	          }
	          _blur = blur;
	          _tipToHide = tipElement;
	          if (tipElement !== null) {
	            if (angular.version.minor <= 2) {
	              $animate.leave(tipElement, leaveAnimateCallback);
	            } else {
	              $animate.leave(tipElement).then(leaveAnimateCallback);
	            }
	          }
	          $tooltip.$isShown = scope.$isShown = false;
	          safeDigest(scope);
	          if (options.keyboard && tipElement !== null) {
	            unbindKeyboardEvents();
	          }
	          if (options.autoClose && tipElement !== null) {
	            unbindAutoCloseEvents();
	          }
	        };
	        function leaveAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.hide', $tooltip);
	          if (angular.isDefined(options.onHide) && angular.isFunction(options.onHide)) {
	            options.onHide($tooltip);
	          }
	          if (tipElement === _tipToHide) {
	            if (_blur && options.trigger === 'focus') {
	              return element[0].blur();
	            }
	            destroyTipElement();
	          }
	        }
	        $tooltip.toggle = function(evt) {
	          if (evt) {
	            evt.preventDefault();
	          }
	          if ($tooltip.$isShown) {
	            $tooltip.leave();
	          } else {
	            $tooltip.enter();
	          }
	        };
	        $tooltip.focus = function() {
	          tipElement[0].focus();
	        };
	        $tooltip.setEnabled = function(isEnabled) {
	          options.bsEnabled = isEnabled;
	        };
	        $tooltip.setViewport = function(viewport) {
	          options.viewport = viewport;
	        };
	        $tooltip.$applyPlacement = function() {
	          if (!tipElement) return;
	          var placement = options.placement;
	          var autoToken = /\s?auto?\s?/i;
	          var autoPlace = autoToken.test(placement);
	          if (autoPlace) {
	            placement = placement.replace(autoToken, '') || defaults.placement;
	          }
	          tipElement.addClass(options.placement);
	          var elementPosition = getPosition();
	          var tipWidth = tipElement.prop('offsetWidth');
	          var tipHeight = tipElement.prop('offsetHeight');
	          $tooltip.$viewport = options.viewport && findElement(options.viewport.selector || options.viewport);
	          if (autoPlace) {
	            var originalPlacement = placement;
	            var viewportPosition = getPosition($tooltip.$viewport);
	            if (/bottom/.test(originalPlacement) && elementPosition.bottom + tipHeight > viewportPosition.bottom) {
	              placement = originalPlacement.replace('bottom', 'top');
	            } else if (/top/.test(originalPlacement) && elementPosition.top - tipHeight < viewportPosition.top) {
	              placement = originalPlacement.replace('top', 'bottom');
	            }
	            if (/left/.test(originalPlacement) && elementPosition.left - tipWidth < viewportPosition.left) {
	              placement = placement.replace('left', 'right');
	            } else if (/right/.test(originalPlacement) && elementPosition.right + tipWidth > viewportPosition.width) {
	              placement = placement.replace('right', 'left');
	            }
	            tipElement.removeClass(originalPlacement).addClass(placement);
	          }
	          var tipPosition = getCalculatedOffset(placement, elementPosition, tipWidth, tipHeight);
	          applyPlacement(tipPosition, placement);
	        };
	        $tooltip.$onKeyUp = function(evt) {
	          if (evt.which === 27 && $tooltip.$isShown) {
	            $tooltip.hide();
	            evt.stopPropagation();
	          }
	        };
	        $tooltip.$onFocusKeyUp = function(evt) {
	          if (evt.which === 27) {
	            element[0].blur();
	            evt.stopPropagation();
	          }
	        };
	        $tooltip.$onFocusElementMouseDown = function(evt) {
	          if (options.mouseDownPreventDefault) {
	            evt.preventDefault();
	          }
	          if (options.mouseDownStopPropagation) {
	            evt.stopPropagation();
	          }
	          if ($tooltip.$isShown) {
	            element[0].blur();
	          } else {
	            element[0].focus();
	          }
	        };
	        function bindTriggerEvents() {
	          var triggers = options.trigger.split(' ');
	          angular.forEach(triggers, function(trigger) {
	            if (trigger === 'click' || trigger === 'contextmenu') {
	              element.on(trigger, $tooltip.toggle);
	            } else if (trigger !== 'manual') {
	              element.on(trigger === 'hover' ? 'mouseenter' : 'focus', $tooltip.enter);
	              element.on(trigger === 'hover' ? 'mouseleave' : 'blur', $tooltip.leave);
	              if (nodeName === 'button' && trigger !== 'hover') {
	                element.on(isTouch ? 'touchstart' : 'mousedown', $tooltip.$onFocusElementMouseDown);
	              }
	            }
	          });
	        }
	        function unbindTriggerEvents() {
	          var triggers = options.trigger.split(' ');
	          for (var i = triggers.length; i--; ) {
	            var trigger = triggers[i];
	            if (trigger === 'click' || trigger === 'contextmenu') {
	              element.off(trigger, $tooltip.toggle);
	            } else if (trigger !== 'manual') {
	              element.off(trigger === 'hover' ? 'mouseenter' : 'focus', $tooltip.enter);
	              element.off(trigger === 'hover' ? 'mouseleave' : 'blur', $tooltip.leave);
	              if (nodeName === 'button' && trigger !== 'hover') {
	                element.off(isTouch ? 'touchstart' : 'mousedown', $tooltip.$onFocusElementMouseDown);
	              }
	            }
	          }
	        }
	        function bindKeyboardEvents() {
	          if (options.trigger !== 'focus') {
	            tipElement.on('keyup', $tooltip.$onKeyUp);
	          } else {
	            element.on('keyup', $tooltip.$onFocusKeyUp);
	          }
	        }
	        function unbindKeyboardEvents() {
	          if (options.trigger !== 'focus') {
	            tipElement.off('keyup', $tooltip.$onKeyUp);
	          } else {
	            element.off('keyup', $tooltip.$onFocusKeyUp);
	          }
	        }
	        var _autoCloseEventsBinded = false;
	        function bindAutoCloseEvents() {
	          $timeout(function() {
	            tipElement.on('click', stopEventPropagation);
	            $body.on('click', $tooltip.hide);
	            _autoCloseEventsBinded = true;
	          }, 0, false);
	        }
	        function unbindAutoCloseEvents() {
	          if (_autoCloseEventsBinded) {
	            tipElement.off('click', stopEventPropagation);
	            $body.off('click', $tooltip.hide);
	            _autoCloseEventsBinded = false;
	          }
	        }
	        function stopEventPropagation(event) {
	          event.stopPropagation();
	        }
	        function getPosition($element) {
	          $element = $element || (options.target || element);
	          var el = $element[0];
	          var isBody = el.tagName === 'BODY';
	          var elRect = el.getBoundingClientRect();
	          var rect = {};
	          for (var p in elRect) {
	            rect[p] = elRect[p];
	          }
	          if (rect.width === null) {
	            rect = angular.extend({}, rect, {
	              width: elRect.right - elRect.left,
	              height: elRect.bottom - elRect.top
	            });
	          }
	          var elOffset = isBody ? {
	            top: 0,
	            left: 0
	          } : dimensions.offset(el);
	          var scroll = {
	            scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.prop('scrollTop') || 0
	          };
	          var outerDims = isBody ? {
	            width: document.documentElement.clientWidth,
	            height: $window.innerHeight
	          } : null;
	          return angular.extend({}, rect, scroll, outerDims, elOffset);
	        }
	        function getCalculatedOffset(placement, position, actualWidth, actualHeight) {
	          var offset;
	          var split = placement.split('-');
	          switch (split[0]) {
	           case 'right':
	            offset = {
	              top: position.top + position.height / 2 - actualHeight / 2,
	              left: position.left + position.width
	            };
	            break;
	
	           case 'bottom':
	            offset = {
	              top: position.top + position.height,
	              left: position.left + position.width / 2 - actualWidth / 2
	            };
	            break;
	
	           case 'left':
	            offset = {
	              top: position.top + position.height / 2 - actualHeight / 2,
	              left: position.left - actualWidth
	            };
	            break;
	
	           default:
	            offset = {
	              top: position.top - actualHeight,
	              left: position.left + position.width / 2 - actualWidth / 2
	            };
	            break;
	          }
	          if (!split[1]) {
	            return offset;
	          }
	          if (split[0] === 'top' || split[0] === 'bottom') {
	            switch (split[1]) {
	             case 'left':
	              offset.left = position.left;
	              break;
	
	             case 'right':
	              offset.left = position.left + position.width - actualWidth;
	              break;
	
	             default:
	              break;
	            }
	          } else if (split[0] === 'left' || split[0] === 'right') {
	            switch (split[1]) {
	             case 'top':
	              offset.top = position.top - actualHeight + position.height;
	              break;
	
	             case 'bottom':
	              offset.top = position.top;
	              break;
	
	             default:
	              break;
	            }
	          }
	          return offset;
	        }
	        function applyPlacement(offset, placement) {
	          var tip = tipElement[0];
	          var width = tip.offsetWidth;
	          var height = tip.offsetHeight;
	          var marginTop = parseInt(dimensions.css(tip, 'margin-top'), 10);
	          var marginLeft = parseInt(dimensions.css(tip, 'margin-left'), 10);
	          if (isNaN(marginTop)) marginTop = 0;
	          if (isNaN(marginLeft)) marginLeft = 0;
	          offset.top = offset.top + marginTop;
	          offset.left = offset.left + marginLeft;
	          dimensions.setOffset(tip, angular.extend({
	            using: function(props) {
	              tipElement.css({
	                top: Math.round(props.top) + 'px',
	                left: Math.round(props.left) + 'px',
	                right: ''
	              });
	            }
	          }, offset), 0);
	          var actualWidth = tip.offsetWidth;
	          var actualHeight = tip.offsetHeight;
	          if (placement === 'top' && actualHeight !== height) {
	            offset.top = offset.top + height - actualHeight;
	          }
	          if (/top-left|top-right|bottom-left|bottom-right/.test(placement)) return;
	          var delta = getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
	          if (delta.left) {
	            offset.left += delta.left;
	          } else {
	            offset.top += delta.top;
	          }
	          dimensions.setOffset(tip, offset);
	          if (/top|right|bottom|left/.test(placement)) {
	            var isVertical = /top|bottom/.test(placement);
	            var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
	            var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';
	            replaceArrow(arrowDelta, tip[arrowOffsetPosition], isVertical);
	          }
	        }
	        function getViewportAdjustedDelta(placement, position, actualWidth, actualHeight) {
	          var delta = {
	            top: 0,
	            left: 0
	          };
	          if (!$tooltip.$viewport) return delta;
	          var viewportPadding = options.viewport && options.viewport.padding || 0;
	          var viewportDimensions = getPosition($tooltip.$viewport);
	          if (/right|left/.test(placement)) {
	            var topEdgeOffset = position.top - viewportPadding - viewportDimensions.scroll;
	            var bottomEdgeOffset = position.top + viewportPadding - viewportDimensions.scroll + actualHeight;
	            if (topEdgeOffset < viewportDimensions.top) {
	              delta.top = viewportDimensions.top - topEdgeOffset;
	            } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
	              delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
	            }
	          } else {
	            var leftEdgeOffset = position.left - viewportPadding;
	            var rightEdgeOffset = position.left + viewportPadding + actualWidth;
	            if (leftEdgeOffset < viewportDimensions.left) {
	              delta.left = viewportDimensions.left - leftEdgeOffset;
	            } else if (rightEdgeOffset > viewportDimensions.right) {
	              delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
	            }
	          }
	          return delta;
	        }
	        function replaceArrow(delta, dimension, isHorizontal) {
	          var $arrow = findElement('.tooltip-arrow, .arrow', tipElement[0]);
	          $arrow.css(isHorizontal ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isHorizontal ? 'top' : 'left', '');
	        }
	        function destroyTipElement() {
	          clearTimeout(timeout);
	          if ($tooltip.$isShown && tipElement !== null) {
	            if (options.autoClose) {
	              unbindAutoCloseEvents();
	            }
	            if (options.keyboard) {
	              unbindKeyboardEvents();
	            }
	          }
	          if (tipScope) {
	            tipScope.$destroy();
	            tipScope = null;
	          }
	          if (tipElement) {
	            tipElement.remove();
	            tipElement = $tooltip.$element = null;
	          }
	        }
	        return $tooltip;
	      }
	      function safeDigest(scope) {
	        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
	      }
	      function findElement(query, element) {
	        return angular.element((element || document).querySelectorAll(query));
	      }
	      return TooltipFactory;
	    } ];
	  }).directive('bsTooltip', [ '$window', '$location', '$sce', '$parse', '$tooltip', '$$rAF', function($window, $location, $sce, $parse, $tooltip, $$rAF) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var tooltip;
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'titleTemplate', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'backdropAnimation', 'type', 'customClass', 'id' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var dataTarget = element.attr('data-target');
	        if (angular.isDefined(dataTarget)) {
	          if (falseValueRegExp.test(dataTarget)) {
	            options.target = false;
	          } else {
	            options.target = dataTarget;
	          }
	        }
	        if (!scope.hasOwnProperty('title')) {
	          scope.title = '';
	        }
	        attr.$observe('title', function(newValue) {
	          if (angular.isDefined(newValue) || !scope.hasOwnProperty('title')) {
	            var oldValue = scope.title;
	            scope.title = $sce.trustAsHtml(newValue);
	            if (angular.isDefined(oldValue)) {
	              $$rAF(function() {
	                if (tooltip) tooltip.$applyPlacement();
	              });
	            }
	          }
	        });
	        attr.$observe('disabled', function(newValue) {
	          if (newValue && tooltip.$isShown) {
	            tooltip.hide();
	          }
	        });
	        if (attr.bsTooltip) {
	          scope.$watch(attr.bsTooltip, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.title = newValue;
	            }
	            if (angular.isDefined(oldValue)) {
	              $$rAF(function() {
	                if (tooltip) tooltip.$applyPlacement();
	              });
	            }
	          }, true);
	        }
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!tooltip || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(tooltip),?/i);
	            if (newValue === true) {
	              tooltip.show();
	            } else {
	              tooltip.hide();
	            }
	          });
	        }
	        if (attr.bsEnabled) {
	          scope.$watch(attr.bsEnabled, function(newValue, oldValue) {
	            if (!tooltip || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|1|,?(tooltip),?/i);
	            if (newValue === false) {
	              tooltip.setEnabled(false);
	            } else {
	              tooltip.setEnabled(true);
	            }
	          });
	        }
	        if (attr.viewport) {
	          scope.$watch(attr.viewport, function(newValue) {
	            if (!tooltip || !angular.isDefined(newValue)) return;
	            tooltip.setViewport(newValue);
	          });
	        }
	        tooltip = $tooltip(element, options);
	        scope.$on('$destroy', function() {
	          if (tooltip) tooltip.destroy();
	          options = null;
	          tooltip = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.timepicker', [ 'mgcrea.ngStrap.helpers.dateParser', 'mgcrea.ngStrap.helpers.dateFormatter', 'mgcrea.ngStrap.tooltip' ]).provider('$timepicker', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      defaultDate: 'auto',
	      prefixClass: 'timepicker',
	      placement: 'bottom-left',
	      templateUrl: 'timepicker/timepicker.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      useNative: true,
	      timeType: 'date',
	      timeFormat: 'shortTime',
	      timezone: null,
	      modelTimeFormat: null,
	      autoclose: false,
	      minTime: -Infinity,
	      maxTime: +Infinity,
	      length: 5,
	      hourStep: 1,
	      minuteStep: 5,
	      secondStep: 5,
	      roundDisplay: false,
	      iconUp: 'glyphicon glyphicon-chevron-up',
	      iconDown: 'glyphicon glyphicon-chevron-down',
	      arrowBehavior: 'pager'
	    };
	    this.$get = [ '$window', '$document', '$rootScope', '$sce', '$dateFormatter', '$tooltip', '$timeout', function($window, $document, $rootScope, $sce, $dateFormatter, $tooltip, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      if (!defaults.lang) {
	        defaults.lang = $dateFormatter.getDefaultLocale();
	      }
	      function timepickerFactory(element, controller, config) {
	        var $timepicker = $tooltip(element, angular.extend({}, defaults, config));
	        var parentScope = config.scope;
	        var options = $timepicker.$options;
	        var scope = $timepicker.$scope;
	        var lang = options.lang;
	        var formatDate = function(date, format, timezone) {
	          return $dateFormatter.formatDate(date, format, lang, timezone);
	        };
	        function floorMinutes(time) {
	          var coeff = 1e3 * 60 * options.minuteStep;
	          return new Date(Math.floor(time.getTime() / coeff) * coeff);
	        }
	        var selectedIndex = 0;
	        var defaultDate = options.roundDisplay ? floorMinutes(new Date()) : new Date();
	        var startDate = controller.$dateValue || defaultDate;
	        var viewDate = {
	          hour: startDate.getHours(),
	          meridian: startDate.getHours() < 12,
	          minute: startDate.getMinutes(),
	          second: startDate.getSeconds(),
	          millisecond: startDate.getMilliseconds()
	        };
	        var format = $dateFormatter.getDatetimeFormat(options.timeFormat, lang);
	        var hoursFormat = $dateFormatter.hoursFormat(format);
	        var timeSeparator = $dateFormatter.timeSeparator(format);
	        var minutesFormat = $dateFormatter.minutesFormat(format);
	        var secondsFormat = $dateFormatter.secondsFormat(format);
	        var showSeconds = $dateFormatter.showSeconds(format);
	        var showAM = $dateFormatter.showAM(format);
	        scope.$iconUp = options.iconUp;
	        scope.$iconDown = options.iconDown;
	        scope.$select = function(date, index) {
	          $timepicker.select(date, index);
	        };
	        scope.$moveIndex = function(value, index) {
	          $timepicker.$moveIndex(value, index);
	        };
	        scope.$switchMeridian = function(date) {
	          $timepicker.switchMeridian(date);
	        };
	        $timepicker.update = function(date) {
	          if (angular.isDate(date) && !isNaN(date.getTime())) {
	            $timepicker.$date = date;
	            angular.extend(viewDate, {
	              hour: date.getHours(),
	              minute: date.getMinutes(),
	              second: date.getSeconds(),
	              millisecond: date.getMilliseconds()
	            });
	            $timepicker.$build();
	          } else if (!$timepicker.$isBuilt) {
	            $timepicker.$build();
	          }
	        };
	        $timepicker.select = function(date, index, keep) {
	          if (!controller.$dateValue || isNaN(controller.$dateValue.getTime())) {
	            controller.$dateValue = options.defaultDate === 'today' ? new Date() : new Date(1970, 0, 1);
	          }
	          if (!angular.isDate(date)) date = new Date(date);
	          if (index === 0) controller.$dateValue.setHours(date.getHours()); else if (index === 1) controller.$dateValue.setMinutes(date.getMinutes()); else if (index === 2) controller.$dateValue.setSeconds(date.getSeconds());
	          controller.$setViewValue(angular.copy(controller.$dateValue));
	          controller.$render();
	          if (options.autoclose && !keep) {
	            $timeout(function() {
	              $timepicker.hide(true);
	            });
	          }
	        };
	        $timepicker.switchMeridian = function(date) {
	          if (!controller.$dateValue || isNaN(controller.$dateValue.getTime())) {
	            return;
	          }
	          var hours = (date || controller.$dateValue).getHours();
	          controller.$dateValue.setHours(hours < 12 ? hours + 12 : hours - 12);
	          controller.$setViewValue(angular.copy(controller.$dateValue));
	          controller.$render();
	        };
	        $timepicker.$build = function() {
	          var i;
	          var midIndex = scope.midIndex = parseInt(options.length / 2, 10);
	          var hours = [];
	          var hour;
	          for (i = 0; i < options.length; i++) {
	            hour = new Date(1970, 0, 1, viewDate.hour - (midIndex - i) * options.hourStep);
	            hours.push({
	              date: hour,
	              label: formatDate(hour, hoursFormat),
	              selected: $timepicker.$date && $timepicker.$isSelected(hour, 0),
	              disabled: $timepicker.$isDisabled(hour, 0)
	            });
	          }
	          var minutes = [];
	          var minute;
	          for (i = 0; i < options.length; i++) {
	            minute = new Date(1970, 0, 1, 0, viewDate.minute - (midIndex - i) * options.minuteStep);
	            minutes.push({
	              date: minute,
	              label: formatDate(minute, minutesFormat),
	              selected: $timepicker.$date && $timepicker.$isSelected(minute, 1),
	              disabled: $timepicker.$isDisabled(minute, 1)
	            });
	          }
	          var seconds = [];
	          var second;
	          for (i = 0; i < options.length; i++) {
	            second = new Date(1970, 0, 1, 0, 0, viewDate.second - (midIndex - i) * options.secondStep);
	            seconds.push({
	              date: second,
	              label: formatDate(second, secondsFormat),
	              selected: $timepicker.$date && $timepicker.$isSelected(second, 2),
	              disabled: $timepicker.$isDisabled(second, 2)
	            });
	          }
	          var rows = [];
	          for (i = 0; i < options.length; i++) {
	            if (showSeconds) {
	              rows.push([ hours[i], minutes[i], seconds[i] ]);
	            } else {
	              rows.push([ hours[i], minutes[i] ]);
	            }
	          }
	          scope.rows = rows;
	          scope.showSeconds = showSeconds;
	          scope.showAM = showAM;
	          scope.isAM = ($timepicker.$date || hours[midIndex].date).getHours() < 12;
	          scope.timeSeparator = timeSeparator;
	          $timepicker.$isBuilt = true;
	        };
	        $timepicker.$isSelected = function(date, index) {
	          if (!$timepicker.$date) return false; else if (index === 0) {
	            return date.getHours() === $timepicker.$date.getHours();
	          } else if (index === 1) {
	            return date.getMinutes() === $timepicker.$date.getMinutes();
	          } else if (index === 2) {
	            return date.getSeconds() === $timepicker.$date.getSeconds();
	          }
	        };
	        $timepicker.$isDisabled = function(date, index) {
	          var selectedTime;
	          if (index === 0) {
	            selectedTime = date.getTime() + viewDate.minute * 6e4 + viewDate.second * 1e3;
	          } else if (index === 1) {
	            selectedTime = date.getTime() + viewDate.hour * 36e5 + viewDate.second * 1e3;
	          } else if (index === 2) {
	            selectedTime = date.getTime() + viewDate.hour * 36e5 + viewDate.minute * 6e4;
	          }
	          return selectedTime < options.minTime * 1 || selectedTime > options.maxTime * 1;
	        };
	        scope.$arrowAction = function(value, index) {
	          if (options.arrowBehavior === 'picker') {
	            $timepicker.$setTimeByStep(value, index);
	          } else {
	            $timepicker.$moveIndex(value, index);
	          }
	        };
	        $timepicker.$setTimeByStep = function(value, index) {
	          var newDate = new Date($timepicker.$date || startDate);
	          var hours = newDate.getHours();
	          var minutes = newDate.getMinutes();
	          var seconds = newDate.getSeconds();
	          if (index === 0) {
	            newDate.setHours(hours - parseInt(options.hourStep, 10) * value);
	          } else if (index === 1) {
	            newDate.setMinutes(minutes - parseInt(options.minuteStep, 10) * value);
	          } else if (index === 2) {
	            newDate.setSeconds(seconds - parseInt(options.secondStep, 10) * value);
	          }
	          $timepicker.select(newDate, index, true);
	        };
	        $timepicker.$moveIndex = function(value, index) {
	          var targetDate;
	          if (index === 0) {
	            targetDate = new Date(1970, 0, 1, viewDate.hour + value * options.length, viewDate.minute, viewDate.second);
	            angular.extend(viewDate, {
	              hour: targetDate.getHours()
	            });
	          } else if (index === 1) {
	            targetDate = new Date(1970, 0, 1, viewDate.hour, viewDate.minute + value * options.length * options.minuteStep, viewDate.second);
	            angular.extend(viewDate, {
	              minute: targetDate.getMinutes()
	            });
	          } else if (index === 2) {
	            targetDate = new Date(1970, 0, 1, viewDate.hour, viewDate.minute, viewDate.second + value * options.length * options.secondStep);
	            angular.extend(viewDate, {
	              second: targetDate.getSeconds()
	            });
	          }
	          $timepicker.$build();
	        };
	        $timepicker.$onMouseDown = function(evt) {
	          if (evt.target.nodeName.toLowerCase() !== 'input') evt.preventDefault();
	          evt.stopPropagation();
	          if (isTouch) {
	            var targetEl = angular.element(evt.target);
	            if (targetEl[0].nodeName.toLowerCase() !== 'button') {
	              targetEl = targetEl.parent();
	            }
	            targetEl.triggerHandler('click');
	          }
	        };
	        $timepicker.$onKeyDown = function(evt) {
	          if (!/(38|37|39|40|13)/.test(evt.keyCode) || evt.shiftKey || evt.altKey) return;
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (evt.keyCode === 13) {
	            $timepicker.hide(true);
	            return;
	          }
	          var newDate = new Date($timepicker.$date);
	          var hours = newDate.getHours();
	          var hoursLength = formatDate(newDate, hoursFormat).length;
	          var minutes = newDate.getMinutes();
	          var minutesLength = formatDate(newDate, minutesFormat).length;
	          var seconds = newDate.getSeconds();
	          var secondsLength = formatDate(newDate, secondsFormat).length;
	          var sepLength = 1;
	          var lateralMove = /(37|39)/.test(evt.keyCode);
	          var count = 2 + showSeconds * 1 + showAM * 1;
	          if (lateralMove) {
	            if (evt.keyCode === 37) selectedIndex = selectedIndex < 1 ? count - 1 : selectedIndex - 1; else if (evt.keyCode === 39) selectedIndex = selectedIndex < count - 1 ? selectedIndex + 1 : 0;
	          }
	          var selectRange = [ 0, hoursLength ];
	          var incr = 0;
	          if (evt.keyCode === 38) incr = -1;
	          if (evt.keyCode === 40) incr = +1;
	          var isSeconds = selectedIndex === 2 && showSeconds;
	          var isMeridian = selectedIndex === 2 && !showSeconds || selectedIndex === 3 && showSeconds;
	          if (selectedIndex === 0) {
	            newDate.setHours(hours + incr * parseInt(options.hourStep, 10));
	            hoursLength = formatDate(newDate, hoursFormat).length;
	            selectRange = [ 0, hoursLength ];
	          } else if (selectedIndex === 1) {
	            newDate.setMinutes(minutes + incr * parseInt(options.minuteStep, 10));
	            minutesLength = formatDate(newDate, minutesFormat).length;
	            selectRange = [ hoursLength + sepLength, minutesLength ];
	          } else if (isSeconds) {
	            newDate.setSeconds(seconds + incr * parseInt(options.secondStep, 10));
	            secondsLength = formatDate(newDate, secondsFormat).length;
	            selectRange = [ hoursLength + sepLength + minutesLength + sepLength, secondsLength ];
	          } else if (isMeridian) {
	            if (!lateralMove) $timepicker.switchMeridian();
	            selectRange = [ hoursLength + sepLength + minutesLength + sepLength + (secondsLength + sepLength) * showSeconds, 2 ];
	          }
	          $timepicker.select(newDate, selectedIndex, true);
	          createSelection(selectRange[0], selectRange[1]);
	          parentScope.$digest();
	        };
	        function createSelection(start, length) {
	          var end = start + length;
	          if (element[0].createTextRange) {
	            var selRange = element[0].createTextRange();
	            selRange.collapse(true);
	            selRange.moveStart('character', start);
	            selRange.moveEnd('character', end);
	            selRange.select();
	          } else if (element[0].setSelectionRange) {
	            element[0].setSelectionRange(start, end);
	          } else if (angular.isUndefined(element[0].selectionStart)) {
	            element[0].selectionStart = start;
	            element[0].selectionEnd = end;
	          }
	        }
	        function focusElement() {
	          element[0].focus();
	        }
	        var _init = $timepicker.init;
	        $timepicker.init = function() {
	          if (isNative && options.useNative) {
	            element.prop('type', 'time');
	            element.css('-webkit-appearance', 'textfield');
	            return;
	          } else if (isTouch) {
	            element.prop('type', 'text');
	            element.attr('readonly', 'true');
	            element.on('click', focusElement);
	          }
	          _init();
	        };
	        var _destroy = $timepicker.destroy;
	        $timepicker.destroy = function() {
	          if (isNative && options.useNative) {
	            element.off('click', focusElement);
	          }
	          _destroy();
	        };
	        var _show = $timepicker.show;
	        $timepicker.show = function() {
	          if (!isTouch && element.attr('readonly') || element.attr('disabled')) return;
	          _show();
	          $timeout(function() {
	            if ($timepicker.$element) $timepicker.$element.on(isTouch ? 'touchstart' : 'mousedown', $timepicker.$onMouseDown);
	            if (options.keyboard) {
	              if (element) element.on('keydown', $timepicker.$onKeyDown);
	            }
	          }, 0, false);
	        };
	        var _hide = $timepicker.hide;
	        $timepicker.hide = function(blur) {
	          if (!$timepicker.$isShown) return;
	          if ($timepicker.$element) $timepicker.$element.off(isTouch ? 'touchstart' : 'mousedown', $timepicker.$onMouseDown);
	          if (options.keyboard) {
	            if (element) element.off('keydown', $timepicker.$onKeyDown);
	          }
	          _hide(blur);
	        };
	        return $timepicker;
	      }
	      timepickerFactory.defaults = defaults;
	      return timepickerFactory;
	    } ];
	  }).directive('bsTimepicker', [ '$window', '$parse', '$q', '$dateFormatter', '$dateParser', '$timepicker', function($window, $parse, $q, $dateFormatter, $dateParser, $timepicker) {
	    var defaults = $timepicker.defaults;
	    var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'autoclose', 'timeType', 'timeFormat', 'timezone', 'modelTimeFormat', 'useNative', 'hourStep', 'minuteStep', 'secondStep', 'length', 'arrowBehavior', 'iconUp', 'iconDown', 'roundDisplay', 'id', 'prefixClass', 'prefixEvent', 'defaultDate' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'autoclose', 'useNative', 'roundDisplay' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        if (isNative && (options.useNative || defaults.useNative)) options.timeFormat = 'HH:mm';
	        var timepicker = $timepicker(element, controller, options);
	        options = timepicker.$options;
	        var lang = options.lang;
	        var formatDate = function(date, format, timezone) {
	          return $dateFormatter.formatDate(date, format, lang, timezone);
	        };
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!timepicker || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(timepicker),?/i);
	            if (newValue === true) {
	              timepicker.show();
	            } else {
	              timepicker.hide();
	            }
	          });
	        }
	        var dateParser = $dateParser({
	          format: options.timeFormat,
	          lang: lang
	        });
	        angular.forEach([ 'minTime', 'maxTime' ], function(key) {
	          if (angular.isDefined(attr[key])) {
	            attr.$observe(key, function(newValue) {
	              timepicker.$options[key] = dateParser.getTimeForAttribute(key, newValue);
	              if (!isNaN(timepicker.$options[key])) timepicker.$build();
	              validateAgainstMinMaxTime(controller.$dateValue);
	            });
	          }
	        });
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          timepicker.update(controller.$dateValue);
	        }, true);
	        function validateAgainstMinMaxTime(parsedTime) {
	          if (!angular.isDate(parsedTime)) return;
	          var isMinValid = isNaN(options.minTime) || new Date(parsedTime.getTime()).setFullYear(1970, 0, 1) >= options.minTime;
	          var isMaxValid = isNaN(options.maxTime) || new Date(parsedTime.getTime()).setFullYear(1970, 0, 1) <= options.maxTime;
	          var isValid = isMinValid && isMaxValid;
	          controller.$setValidity('date', isValid);
	          controller.$setValidity('min', isMinValid);
	          controller.$setValidity('max', isMaxValid);
	          if (!isValid) {
	            return;
	          }
	          controller.$dateValue = parsedTime;
	        }
	        controller.$parsers.unshift(function(viewValue) {
	          var date;
	          if (!viewValue) {
	            controller.$setValidity('date', true);
	            return null;
	          }
	          var parsedTime = angular.isDate(viewValue) ? viewValue : dateParser.parse(viewValue, controller.$dateValue);
	          if (!parsedTime || isNaN(parsedTime.getTime())) {
	            controller.$setValidity('date', false);
	            return undefined;
	          }
	          validateAgainstMinMaxTime(parsedTime);
	          if (options.timeType === 'string') {
	            date = dateParser.timezoneOffsetAdjust(parsedTime, options.timezone, true);
	            return formatDate(date, options.modelTimeFormat || options.timeFormat);
	          }
	          date = dateParser.timezoneOffsetAdjust(controller.$dateValue, options.timezone, true);
	          if (options.timeType === 'number') {
	            return date.getTime();
	          } else if (options.timeType === 'unix') {
	            return date.getTime() / 1e3;
	          } else if (options.timeType === 'iso') {
	            return date.toISOString();
	          }
	          return new Date(date);
	        });
	        controller.$formatters.push(function(modelValue) {
	          var date;
	          if (angular.isUndefined(modelValue) || modelValue === null) {
	            date = NaN;
	          } else if (angular.isDate(modelValue)) {
	            date = modelValue;
	          } else if (options.timeType === 'string') {
	            date = dateParser.parse(modelValue, null, options.modelTimeFormat);
	          } else if (options.timeType === 'unix') {
	            date = new Date(modelValue * 1e3);
	          } else {
	            date = new Date(modelValue);
	          }
	          controller.$dateValue = dateParser.timezoneOffsetAdjust(date, options.timezone);
	          return getTimeFormattedString();
	        });
	        controller.$render = function() {
	          element.val(getTimeFormattedString());
	        };
	        function getTimeFormattedString() {
	          return !controller.$dateValue || isNaN(controller.$dateValue.getTime()) ? '' : formatDate(controller.$dateValue, options.timeFormat);
	        }
	        scope.$on('$destroy', function() {
	          if (timepicker) timepicker.destroy();
	          options = null;
	          timepicker = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.tab', []).provider('$tab', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      template: 'tab/tab.tpl.html',
	      navClass: 'nav-tabs',
	      activeClass: 'active'
	    };
	    var controller = this.controller = function($scope, $element, $attrs) {
	      var self = this;
	      self.$options = angular.copy(defaults);
	      angular.forEach([ 'animation', 'navClass', 'activeClass' ], function(key) {
	        if (angular.isDefined($attrs[key])) self.$options[key] = $attrs[key];
	      });
	      $scope.$navClass = self.$options.navClass;
	      $scope.$activeClass = self.$options.activeClass;
	      self.$panes = $scope.$panes = [];
	      self.$activePaneChangeListeners = self.$viewChangeListeners = [];
	      self.$push = function(pane) {
	        if (angular.isUndefined(self.$panes.$active)) {
	          $scope.$setActive(pane.name || 0);
	        }
	        self.$panes.push(pane);
	      };
	      self.$remove = function(pane) {
	        var index = self.$panes.indexOf(pane);
	        var active = self.$panes.$active;
	        var activeIndex;
	        if (angular.isString(active)) {
	          activeIndex = self.$panes.map(function(pane) {
	            return pane.name;
	          }).indexOf(active);
	        } else {
	          activeIndex = self.$panes.$active;
	        }
	        self.$panes.splice(index, 1);
	        if (index < activeIndex) {
	          activeIndex--;
	        } else if (index === activeIndex && activeIndex === self.$panes.length) {
	          activeIndex--;
	        }
	        if (activeIndex >= 0 && activeIndex < self.$panes.length) {
	          self.$setActive(self.$panes[activeIndex].name || activeIndex);
	        } else {
	          self.$setActive();
	        }
	      };
	      self.$setActive = $scope.$setActive = function(value) {
	        self.$panes.$active = value;
	        self.$activePaneChangeListeners.forEach(function(fn) {
	          fn();
	        });
	      };
	      self.$isActive = $scope.$isActive = function($pane, $index) {
	        return self.$panes.$active === $pane.name || self.$panes.$active === $index;
	      };
	    };
	    this.$get = function() {
	      var $tab = {};
	      $tab.defaults = defaults;
	      $tab.controller = controller;
	      return $tab;
	    };
	  }).directive('bsTabs', [ '$window', '$animate', '$tab', '$parse', function($window, $animate, $tab, $parse) {
	    var defaults = $tab.defaults;
	    return {
	      require: [ '?ngModel', 'bsTabs' ],
	      transclude: true,
	      scope: true,
	      controller: [ '$scope', '$element', '$attrs', $tab.controller ],
	      templateUrl: function(element, attr) {
	        return attr.template || defaults.template;
	      },
	      link: function postLink(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var bsTabsCtrl = controllers[1];
	        if (ngModelCtrl) {
	          bsTabsCtrl.$activePaneChangeListeners.push(function() {
	            ngModelCtrl.$setViewValue(bsTabsCtrl.$panes.$active);
	          });
	          ngModelCtrl.$formatters.push(function(modelValue) {
	            bsTabsCtrl.$setActive(modelValue);
	            return modelValue;
	          });
	        }
	        if (attrs.bsActivePane) {
	          var parsedBsActivePane = $parse(attrs.bsActivePane);
	          bsTabsCtrl.$activePaneChangeListeners.push(function() {
	            parsedBsActivePane.assign(scope, bsTabsCtrl.$panes.$active);
	          });
	          scope.$watch(attrs.bsActivePane, function(newValue, oldValue) {
	            bsTabsCtrl.$setActive(newValue);
	          }, true);
	        }
	      }
	    };
	  } ]).directive('bsPane', [ '$window', '$animate', '$sce', function($window, $animate, $sce) {
	    return {
	      require: [ '^?ngModel', '^bsTabs' ],
	      scope: true,
	      link: function postLink(scope, element, attrs, controllers) {
	        var bsTabsCtrl = controllers[1];
	        element.addClass('tab-pane');
	        attrs.$observe('title', function(newValue, oldValue) {
	          scope.title = $sce.trustAsHtml(newValue);
	        });
	        scope.name = attrs.name;
	        if (bsTabsCtrl.$options.animation) {
	          element.addClass(bsTabsCtrl.$options.animation);
	        }
	        attrs.$observe('disabled', function(newValue, oldValue) {
	          scope.disabled = scope.$eval(newValue);
	        });
	        bsTabsCtrl.$push(scope);
	        scope.$on('$destroy', function() {
	          bsTabsCtrl.$remove(scope);
	        });
	        function render() {
	          var index = bsTabsCtrl.$panes.indexOf(scope);
	          $animate[bsTabsCtrl.$isActive(scope, index) ? 'addClass' : 'removeClass'](element, bsTabsCtrl.$options.activeClass);
	        }
	        bsTabsCtrl.$activePaneChangeListeners.push(function() {
	          render();
	        });
	        render();
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.select', [ 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.helpers.parseOptions' ]).provider('$select', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'select',
	      prefixEvent: '$select',
	      placement: 'bottom-left',
	      templateUrl: 'select/select.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      multiple: false,
	      allNoneButtons: false,
	      sort: true,
	      caretHtml: '&nbsp;<span class="caret"></span>',
	      placeholder: 'Choose among the following...',
	      allText: 'All',
	      noneText: 'None',
	      maxLength: 3,
	      maxLengthHtml: 'selected',
	      iconCheckmark: 'glyphicon glyphicon-ok',
	      toggle: false
	    };
	    this.$get = [ '$window', '$document', '$rootScope', '$tooltip', '$timeout', function($window, $document, $rootScope, $tooltip, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      function SelectFactory(element, controller, config) {
	        var $select = {};
	        var options = angular.extend({}, defaults, config);
	        $select = $tooltip(element, options);
	        var scope = $select.$scope;
	        scope.$matches = [];
	        if (options.multiple) {
	          scope.$activeIndex = [];
	        } else {
	          scope.$activeIndex = -1;
	        }
	        scope.$isMultiple = options.multiple;
	        scope.$showAllNoneButtons = options.allNoneButtons && options.multiple;
	        scope.$iconCheckmark = options.iconCheckmark;
	        scope.$allText = options.allText;
	        scope.$noneText = options.noneText;
	        scope.$activate = function(index) {
	          scope.$$postDigest(function() {
	            $select.activate(index);
	          });
	        };
	        scope.$select = function(index, evt) {
	          scope.$$postDigest(function() {
	            $select.select(index);
	          });
	        };
	        scope.$isVisible = function() {
	          return $select.$isVisible();
	        };
	        scope.$isActive = function(index) {
	          return $select.$isActive(index);
	        };
	        scope.$selectAll = function() {
	          for (var i = 0; i < scope.$matches.length; i++) {
	            if (!scope.$isActive(i)) {
	              scope.$select(i);
	            }
	          }
	        };
	        scope.$selectNone = function() {
	          for (var i = 0; i < scope.$matches.length; i++) {
	            if (scope.$isActive(i)) {
	              scope.$select(i);
	            }
	          }
	        };
	        $select.update = function(matches) {
	          scope.$matches = matches;
	          $select.$updateActiveIndex();
	        };
	        $select.activate = function(index) {
	          if (options.multiple) {
	            if ($select.$isActive(index)) {
	              scope.$activeIndex.splice(scope.$activeIndex.indexOf(index), 1);
	            } else {
	              scope.$activeIndex.push(index);
	            }
	            if (options.sort) scope.$activeIndex.sort(function(a, b) {
	              return a - b;
	            });
	          } else {
	            scope.$activeIndex = index;
	          }
	          return scope.$activeIndex;
	        };
	        $select.select = function(index) {
	          if (angular.isUndefined(index) || index < 0 || index >= scope.$matches.length) {
	            return;
	          }
	          var value = scope.$matches[index].value;
	          scope.$apply(function() {
	            $select.activate(index);
	            if (options.multiple) {
	              controller.$setViewValue(scope.$activeIndex.map(function(index) {
	                if (angular.isUndefined(scope.$matches[index])) {
	                  return null;
	                }
	                return scope.$matches[index].value;
	              }));
	            } else {
	              if (options.toggle) {
	                controller.$setViewValue(value === controller.$modelValue ? undefined : value);
	              } else {
	                controller.$setViewValue(value);
	              }
	              $select.hide();
	            }
	          });
	          scope.$emit(options.prefixEvent + '.select', value, index, $select);
	          if (angular.isDefined(options.onSelect) && angular.isFunction(options.onSelect)) {
	            options.onSelect(value, index, $select);
	          }
	        };
	        $select.$updateActiveIndex = function() {
	          if (options.multiple) {
	            if (angular.isArray(controller.$modelValue)) {
	              scope.$activeIndex = controller.$modelValue.map(function(value) {
	                return $select.$getIndex(value);
	              });
	            } else {
	              scope.$activeIndex = [];
	            }
	          } else {
	            if (angular.isDefined(controller.$modelValue) && scope.$matches.length) {
	              scope.$activeIndex = $select.$getIndex(controller.$modelValue);
	            } else {
	              scope.$activeIndex = -1;
	            }
	          }
	        };
	        $select.$isVisible = function() {
	          if (!options.minLength || !controller) {
	            return scope.$matches.length;
	          }
	          return scope.$matches.length && controller.$viewValue.length >= options.minLength;
	        };
	        $select.$isActive = function(index) {
	          if (options.multiple) {
	            return scope.$activeIndex.indexOf(index) !== -1;
	          }
	          return scope.$activeIndex === index;
	        };
	        $select.$getIndex = function(value) {
	          var index;
	          for (index = scope.$matches.length; index--; ) {
	            if (angular.equals(scope.$matches[index].value, value)) break;
	          }
	          return index;
	        };
	        $select.$onMouseDown = function(evt) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (isTouch) {
	            var targetEl = angular.element(evt.target);
	            var anchor;
	            if (evt.target.nodeName !== 'A') {
	              var anchorCandidate = targetEl.parent();
	              while (!anchor && anchorCandidate.length > 0) {
	                if (anchorCandidate[0].nodeName === 'A') {
	                  anchor = anchorCandidate;
	                }
	                anchorCandidate = anchorCandidate.parent();
	              }
	            }
	            if (anchor) {
	              angular.element(anchor).triggerHandler('click');
	            } else {
	              targetEl.triggerHandler('click');
	            }
	          }
	        };
	        $select.$onKeyDown = function(evt) {
	          if (!/(9|13|38|40)/.test(evt.keyCode)) return;
	          if (evt.keyCode !== 9) {
	            evt.preventDefault();
	            evt.stopPropagation();
	          }
	          if (options.multiple && evt.keyCode === 9) {
	            return $select.hide();
	          }
	          if (!options.multiple && (evt.keyCode === 13 || evt.keyCode === 9)) {
	            return $select.select(scope.$activeIndex);
	          }
	          if (!options.multiple) {
	            if (evt.keyCode === 38 && scope.$activeIndex > 0) scope.$activeIndex--; else if (evt.keyCode === 38 && scope.$activeIndex < 0) scope.$activeIndex = scope.$matches.length - 1; else if (evt.keyCode === 40 && scope.$activeIndex < scope.$matches.length - 1) scope.$activeIndex++; else if (angular.isUndefined(scope.$activeIndex)) scope.$activeIndex = 0;
	            scope.$digest();
	          }
	        };
	        $select.$isIE = function() {
	          var ua = $window.navigator.userAgent;
	          return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0;
	        };
	        $select.$selectScrollFix = function(e) {
	          if ($document[0].activeElement.tagName === 'UL') {
	            e.preventDefault();
	            e.stopImmediatePropagation();
	            e.target.focus();
	          }
	        };
	        var _show = $select.show;
	        $select.show = function() {
	          _show();
	          if (options.multiple) {
	            $select.$element.addClass('select-multiple');
	          }
	          $timeout(function() {
	            $select.$element.on(isTouch ? 'touchstart' : 'mousedown', $select.$onMouseDown);
	            if (options.keyboard) {
	              element.on('keydown', $select.$onKeyDown);
	            }
	          }, 0, false);
	        };
	        var _hide = $select.hide;
	        $select.hide = function() {
	          if (!options.multiple && angular.isUndefined(controller.$modelValue)) {
	            scope.$activeIndex = -1;
	          }
	          $select.$element.off(isTouch ? 'touchstart' : 'mousedown', $select.$onMouseDown);
	          if (options.keyboard) {
	            element.off('keydown', $select.$onKeyDown);
	          }
	          _hide(true);
	        };
	        return $select;
	      }
	      SelectFactory.defaults = defaults;
	      return SelectFactory;
	    } ];
	  }).directive('bsSelect', [ '$window', '$parse', '$q', '$select', '$parseOptions', function($window, $parse, $q, $select, $parseOptions) {
	    var defaults = $select.defaults;
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = {
	          scope: scope,
	          placeholder: defaults.placeholder
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'placeholder', 'allNoneButtons', 'maxLength', 'maxLengthHtml', 'allText', 'noneText', 'iconCheckmark', 'autoClose', 'id', 'sort', 'caretHtml', 'prefixClass', 'prefixEvent', 'toggle' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'allNoneButtons', 'sort' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide', 'onSelect' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var dataMultiple = element.attr('data-multiple');
	        if (angular.isDefined(dataMultiple)) {
	          if (falseValueRegExp.test(dataMultiple)) {
	            options.multiple = false;
	          } else {
	            options.multiple = dataMultiple;
	          }
	        }
	        if (element[0].nodeName.toLowerCase() === 'select') {
	          var inputEl = element;
	          inputEl.css('display', 'none');
	          element = angular.element('<button type="button" class="btn btn-default"></button>');
	          inputEl.after(element);
	        }
	        var parsedOptions = $parseOptions(attr.bsOptions);
	        var select = $select(element, controller, options);
	        if (select.$isIE()) {
	          element[0].addEventListener('blur', select.$selectScrollFix);
	        }
	        var watchedOptions = parsedOptions.$match[7].replace(/\|.+/, '').trim();
	        scope.$watch(watchedOptions, function(newValue, oldValue) {
	          parsedOptions.valuesFn(scope, controller).then(function(values) {
	            select.update(values);
	            controller.$render();
	          });
	        }, true);
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          select.$updateActiveIndex();
	          controller.$render();
	        }, true);
	        controller.$render = function() {
	          var selected;
	          var index;
	          if (options.multiple && angular.isArray(controller.$modelValue)) {
	            selected = controller.$modelValue.map(function(value) {
	              index = select.$getIndex(value);
	              return index !== -1 ? select.$scope.$matches[index].label : false;
	            }).filter(angular.isDefined);
	            if (selected.length > (options.maxLength || defaults.maxLength)) {
	              selected = selected.length + ' ' + (options.maxLengthHtml || defaults.maxLengthHtml);
	            } else {
	              selected = selected.join(', ');
	            }
	          } else {
	            index = select.$getIndex(controller.$modelValue);
	            selected = index !== -1 ? select.$scope.$matches[index].label : false;
	          }
	          element.html((selected || options.placeholder) + (options.caretHtml || defaults.caretHtml));
	        };
	        if (options.multiple) {
	          controller.$isEmpty = function(value) {
	            return !value || value.length === 0;
	          };
	        }
	        scope.$on('$destroy', function() {
	          if (select) select.destroy();
	          options = null;
	          select = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.scrollspy', [ 'mgcrea.ngStrap.helpers.debounce', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$scrollspy', function() {
	    var spies = this.$$spies = {};
	    var defaults = this.defaults = {
	      debounce: 150,
	      throttle: 100,
	      offset: 100
	    };
	    this.$get = [ '$window', '$document', '$rootScope', 'dimensions', 'debounce', 'throttle', function($window, $document, $rootScope, dimensions, debounce, throttle) {
	      var windowEl = angular.element($window);
	      var docEl = angular.element($document.prop('documentElement'));
	      var bodyEl = angular.element($window.document.body);
	      function nodeName(element, name) {
	        return element[0].nodeName && element[0].nodeName.toLowerCase() === name.toLowerCase();
	      }
	      function ScrollSpyFactory(config) {
	        var options = angular.extend({}, defaults, config);
	        if (!options.element) options.element = bodyEl;
	        var isWindowSpy = nodeName(options.element, 'body');
	        var scrollEl = isWindowSpy ? windowEl : options.element;
	        var scrollId = isWindowSpy ? 'window' : options.id;
	        if (spies[scrollId]) {
	          spies[scrollId].$$count++;
	          return spies[scrollId];
	        }
	        var $scrollspy = {};
	        var unbindViewContentLoaded;
	        var unbindIncludeContentLoaded;
	        var trackedElements = $scrollspy.$trackedElements = [];
	        var sortedElements = [];
	        var activeTarget;
	        var debouncedCheckPosition;
	        var throttledCheckPosition;
	        var debouncedCheckOffsets;
	        var viewportHeight;
	        var scrollTop;
	        $scrollspy.init = function() {
	          this.$$count = 1;
	          debouncedCheckPosition = debounce(this.checkPosition, options.debounce);
	          throttledCheckPosition = throttle(this.checkPosition, options.throttle);
	          scrollEl.on('click', this.checkPositionWithEventLoop);
	          windowEl.on('resize', debouncedCheckPosition);
	          scrollEl.on('scroll', throttledCheckPosition);
	          debouncedCheckOffsets = debounce(this.checkOffsets, options.debounce);
	          unbindViewContentLoaded = $rootScope.$on('$viewContentLoaded', debouncedCheckOffsets);
	          unbindIncludeContentLoaded = $rootScope.$on('$includeContentLoaded', debouncedCheckOffsets);
	          debouncedCheckOffsets();
	          if (scrollId) {
	            spies[scrollId] = $scrollspy;
	          }
	        };
	        $scrollspy.destroy = function() {
	          this.$$count--;
	          if (this.$$count > 0) {
	            return;
	          }
	          scrollEl.off('click', this.checkPositionWithEventLoop);
	          windowEl.off('resize', debouncedCheckPosition);
	          scrollEl.off('scroll', throttledCheckPosition);
	          unbindViewContentLoaded();
	          unbindIncludeContentLoaded();
	          if (scrollId) {
	            delete spies[scrollId];
	          }
	        };
	        $scrollspy.checkPosition = function() {
	          if (!sortedElements.length) return;
	          scrollTop = (isWindowSpy ? $window.pageYOffset : scrollEl.prop('scrollTop')) || 0;
	          viewportHeight = Math.max($window.innerHeight, docEl.prop('clientHeight'));
	          if (scrollTop < sortedElements[0].offsetTop && activeTarget !== sortedElements[0].target) {
	            return $scrollspy.$activateElement(sortedElements[0]);
	          }
	          for (var i = sortedElements.length; i--; ) {
	            if (angular.isUndefined(sortedElements[i].offsetTop) || sortedElements[i].offsetTop === null) continue;
	            if (activeTarget === sortedElements[i].target) continue;
	            if (scrollTop < sortedElements[i].offsetTop) continue;
	            if (sortedElements[i + 1] && scrollTop > sortedElements[i + 1].offsetTop) continue;
	            return $scrollspy.$activateElement(sortedElements[i]);
	          }
	        };
	        $scrollspy.checkPositionWithEventLoop = function() {
	          setTimeout($scrollspy.checkPosition, 1);
	        };
	        $scrollspy.$activateElement = function(element) {
	          if (activeTarget) {
	            var activeElement = $scrollspy.$getTrackedElement(activeTarget);
	            if (activeElement) {
	              activeElement.source.removeClass('active');
	              if (nodeName(activeElement.source, 'li') && nodeName(activeElement.source.parent().parent(), 'li')) {
	                activeElement.source.parent().parent().removeClass('active');
	              }
	            }
	          }
	          activeTarget = element.target;
	          element.source.addClass('active');
	          if (nodeName(element.source, 'li') && nodeName(element.source.parent().parent(), 'li')) {
	            element.source.parent().parent().addClass('active');
	          }
	        };
	        $scrollspy.$getTrackedElement = function(target) {
	          return trackedElements.filter(function(obj) {
	            return obj.target === target;
	          })[0];
	        };
	        $scrollspy.checkOffsets = function() {
	          angular.forEach(trackedElements, function(trackedElement) {
	            var targetElement = document.querySelector(trackedElement.target);
	            trackedElement.offsetTop = targetElement ? dimensions.offset(targetElement).top : null;
	            if (options.offset && trackedElement.offsetTop !== null) trackedElement.offsetTop -= options.offset * 1;
	          });
	          sortedElements = trackedElements.filter(function(el) {
	            return el.offsetTop !== null;
	          }).sort(function(a, b) {
	            return a.offsetTop - b.offsetTop;
	          });
	          debouncedCheckPosition();
	        };
	        $scrollspy.trackElement = function(target, source) {
	          trackedElements.push({
	            target: target,
	            source: source
	          });
	        };
	        $scrollspy.untrackElement = function(target, source) {
	          var toDelete;
	          for (var i = trackedElements.length; i--; ) {
	            if (trackedElements[i].target === target && trackedElements[i].source === source) {
	              toDelete = i;
	              break;
	            }
	          }
	          trackedElements.splice(toDelete, 1);
	        };
	        $scrollspy.activate = function(i) {
	          trackedElements[i].addClass('active');
	        };
	        $scrollspy.init();
	        return $scrollspy;
	      }
	      return ScrollSpyFactory;
	    } ];
	  }).directive('bsScrollspy', [ '$rootScope', 'debounce', 'dimensions', '$scrollspy', function($rootScope, debounce, dimensions, $scrollspy) {
	    return {
	      restrict: 'EAC',
	      link: function postLink(scope, element, attr) {
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'offset', 'target' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var scrollspy = $scrollspy(options);
	        scrollspy.trackElement(options.target, element);
	        scope.$on('$destroy', function() {
	          if (scrollspy) {
	            scrollspy.untrackElement(options.target, element);
	            scrollspy.destroy();
	          }
	          options = null;
	          scrollspy = null;
	        });
	      }
	    };
	  } ]).directive('bsScrollspyList', [ '$rootScope', 'debounce', 'dimensions', '$scrollspy', function($rootScope, debounce, dimensions, $scrollspy) {
	    return {
	      restrict: 'A',
	      compile: function postLink(element, attr) {
	        var children = element[0].querySelectorAll('li > a[href]');
	        angular.forEach(children, function(child) {
	          var childEl = angular.element(child);
	          childEl.parent().attr('bs-scrollspy', '').attr('data-target', childEl.attr('href'));
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.popover', [ 'mgcrea.ngStrap.tooltip' ]).provider('$popover', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      customClass: '',
	      container: false,
	      target: false,
	      placement: 'right',
	      templateUrl: 'popover/popover.tpl.html',
	      contentTemplate: false,
	      trigger: 'click',
	      keyboard: true,
	      html: false,
	      title: '',
	      content: '',
	      delay: 0,
	      autoClose: false
	    };
	    this.$get = [ '$tooltip', function($tooltip) {
	      function PopoverFactory(element, config) {
	        var options = angular.extend({}, defaults, config);
	        var $popover = $tooltip(element, options);
	        if (options.content) {
	          $popover.$scope.content = options.content;
	        }
	        return $popover;
	      }
	      return PopoverFactory;
	    } ];
	  }).directive('bsPopover', [ '$window', '$sce', '$popover', function($window, $sce, $popover) {
	    var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr) {
	        var popover;
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'customClass', 'autoClose', 'id', 'prefixClass', 'prefixEvent', 'bsEnabled' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'autoClose' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var dataTarget = element.attr('data-target');
	        if (angular.isDefined(dataTarget)) {
	          if (falseValueRegExp.test(dataTarget)) {
	            options.target = false;
	          } else {
	            options.target = dataTarget;
	          }
	        }
	        angular.forEach([ 'title', 'content' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	              if (angular.isDefined(oldValue)) {
	                requestAnimationFrame(function() {
	                  if (popover) popover.$applyPlacement();
	                });
	              }
	            });
	          }
	        });
	        if (attr.bsPopover) {
	          scope.$watch(attr.bsPopover, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	            if (angular.isDefined(oldValue)) {
	              requestAnimationFrame(function() {
	                if (popover) popover.$applyPlacement();
	              });
	            }
	          }, true);
	        }
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!popover || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(popover),?/i);
	            if (newValue === true) {
	              popover.show();
	            } else {
	              popover.hide();
	            }
	          });
	        }
	        if (attr.bsEnabled) {
	          scope.$watch(attr.bsEnabled, function(newValue) {
	            if (!popover || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|1|,?(popover),?/i);
	            if (newValue === false) {
	              popover.setEnabled(false);
	            } else {
	              popover.setEnabled(true);
	            }
	          });
	        }
	        if (attr.viewport) {
	          scope.$watch(attr.viewport, function(newValue) {
	            if (!popover || !angular.isDefined(newValue)) return;
	            popover.setViewport(newValue);
	          });
	        }
	        popover = $popover(element, options);
	        scope.$on('$destroy', function() {
	          if (popover) popover.destroy();
	          options = null;
	          popover = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.navbar', []).provider('$navbar', function() {
	    var defaults = this.defaults = {
	      activeClass: 'active',
	      routeAttr: 'data-match-route',
	      strict: false
	    };
	    this.$get = function() {
	      return {
	        defaults: defaults
	      };
	    };
	  }).directive('bsNavbar', [ '$window', '$location', '$navbar', function($window, $location, $navbar) {
	    var defaults = $navbar.defaults;
	    return {
	      restrict: 'A',
	      link: function postLink(scope, element, attr, controller) {
	        var options = angular.copy(defaults);
	        angular.forEach(Object.keys(defaults), function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        scope.$watch(function() {
	          return $location.path();
	        }, function(newValue, oldValue) {
	          var liElements = element[0].querySelectorAll('li[' + options.routeAttr + ']');
	          angular.forEach(liElements, function(li) {
	            var liElement = angular.element(li);
	            var pattern = liElement.attr(options.routeAttr).replace('/', '\\/');
	            if (options.strict) {
	              pattern = '^' + pattern + '$';
	            }
	            var regexp = new RegExp(pattern, 'i');
	            if (regexp.test(newValue)) {
	              liElement.addClass(options.activeClass);
	            } else {
	              liElement.removeClass(options.activeClass);
	            }
	          });
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.modal', [ 'mgcrea.ngStrap.core', 'mgcrea.ngStrap.helpers.dimensions' ]).provider('$modal', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      backdropAnimation: 'am-fade',
	      customClass: '',
	      prefixClass: 'modal',
	      prefixEvent: 'modal',
	      placement: 'top',
	      templateUrl: 'modal/modal.tpl.html',
	      template: '',
	      contentTemplate: false,
	      container: false,
	      element: null,
	      backdrop: true,
	      keyboard: true,
	      html: false,
	      show: true,
	      size: null,
	      zIndex: null
	    };
	    this.$get = [ '$window', '$rootScope', '$bsCompiler', '$animate', '$timeout', '$sce', 'dimensions', function($window, $rootScope, $bsCompiler, $animate, $timeout, $sce, dimensions) {
	      var forEach = angular.forEach;
	      var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
	      var bodyElement = angular.element($window.document.body);
	      var backdropCount = 0;
	      var dialogBaseZindex = 1050;
	      var backdropBaseZindex = 1040;
	      var validSizes = {
	        lg: 'modal-lg',
	        sm: 'modal-sm'
	      };
	      function ModalFactory(config) {
	        var $modal = {};
	        var options = $modal.$options = angular.extend({}, defaults, config);
	        var promise = $modal.$promise = $bsCompiler.compile(options);
	        var scope = $modal.$scope = options.scope && options.scope.$new() || $rootScope.$new();
	        if (!options.element && !options.container) {
	          options.container = 'body';
	        }
	        if (options.zIndex) {
	          dialogBaseZindex = parseInt(options.zIndex, 10);
	          backdropBaseZindex = dialogBaseZindex - 10;
	        }
	        $modal.$id = options.id || options.element && options.element.attr('id') || '';
	        forEach([ 'title', 'content' ], function(key) {
	          if (options[key]) scope[key] = $sce.trustAsHtml(options[key]);
	        });
	        scope.$hide = function() {
	          scope.$$postDigest(function() {
	            $modal.hide();
	          });
	        };
	        scope.$show = function() {
	          scope.$$postDigest(function() {
	            $modal.show();
	          });
	        };
	        scope.$toggle = function() {
	          scope.$$postDigest(function() {
	            $modal.toggle();
	          });
	        };
	        $modal.$isShown = scope.$isShown = false;
	        var compileData;
	        var modalElement;
	        var modalScope;
	        var backdropElement = angular.element('<div class="' + options.prefixClass + '-backdrop"/>');
	        backdropElement.css({
	          position: 'fixed',
	          top: '0px',
	          left: '0px',
	          bottom: '0px',
	          right: '0px'
	        });
	        promise.then(function(data) {
	          compileData = data;
	          $modal.init();
	        });
	        $modal.init = function() {
	          if (options.show) {
	            scope.$$postDigest(function() {
	              $modal.show();
	            });
	          }
	        };
	        $modal.destroy = function() {
	          destroyModalElement();
	          if (backdropElement) {
	            backdropElement.remove();
	            backdropElement = null;
	          }
	          scope.$destroy();
	        };
	        $modal.show = function() {
	          if ($modal.$isShown) return;
	          var parent;
	          var after;
	          if (angular.isElement(options.container)) {
	            parent = options.container;
	            after = options.container[0].lastChild ? angular.element(options.container[0].lastChild) : null;
	          } else {
	            if (options.container) {
	              parent = findElement(options.container);
	              after = parent[0] && parent[0].lastChild ? angular.element(parent[0].lastChild) : null;
	            } else {
	              parent = null;
	              after = options.element;
	            }
	          }
	          if (modalElement) destroyModalElement();
	          modalScope = $modal.$scope.$new();
	          modalElement = $modal.$element = compileData.link(modalScope, function(clonedElement, scope) {});
	          if (options.backdrop) {
	            modalElement.css({
	              'z-index': dialogBaseZindex + backdropCount * 20
	            });
	            backdropElement.css({
	              'z-index': backdropBaseZindex + backdropCount * 20
	            });
	            backdropCount++;
	          }
	          if (scope.$emit(options.prefixEvent + '.show.before', $modal).defaultPrevented) {
	            return;
	          }
	          if (angular.isDefined(options.onBeforeShow) && angular.isFunction(options.onBeforeShow)) {
	            options.onBeforeShow($modal);
	          }
	          modalElement.css({
	            display: 'block'
	          }).addClass(options.placement);
	          if (options.customClass) {
	            modalElement.addClass(options.customClass);
	          }
	          if (options.size && validSizes[options.size]) {
	            angular.element(findElement('.modal-dialog', modalElement[0])).addClass(validSizes[options.size]);
	          }
	          if (options.animation) {
	            if (options.backdrop) {
	              backdropElement.addClass(options.backdropAnimation);
	            }
	            modalElement.addClass(options.animation);
	          }
	          if (options.backdrop) {
	            $animate.enter(backdropElement, bodyElement, null);
	          }
	          if (angular.version.minor <= 2) {
	            $animate.enter(modalElement, parent, after, enterAnimateCallback);
	          } else {
	            $animate.enter(modalElement, parent, after).then(enterAnimateCallback);
	          }
	          $modal.$isShown = scope.$isShown = true;
	          safeDigest(scope);
	          var el = modalElement[0];
	          requestAnimationFrame(function() {
	            el.focus();
	          });
	          bodyElement.addClass(options.prefixClass + '-open');
	          if (options.animation) {
	            bodyElement.addClass(options.prefixClass + '-with-' + options.animation);
	          }
	          bindBackdropEvents();
	          bindKeyboardEvents();
	        };
	        function enterAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.show', $modal);
	          if (angular.isDefined(options.onShow) && angular.isFunction(options.onShow)) {
	            options.onShow($modal);
	          }
	        }
	        $modal.hide = function() {
	          if (!$modal.$isShown) return;
	          if (scope.$emit(options.prefixEvent + '.hide.before', $modal).defaultPrevented) {
	            return;
	          }
	          if (angular.isDefined(options.onBeforeHide) && angular.isFunction(options.onBeforeHide)) {
	            options.onBeforeHide($modal);
	          }
	          if (angular.version.minor <= 2) {
	            $animate.leave(modalElement, leaveAnimateCallback);
	          } else {
	            $animate.leave(modalElement).then(leaveAnimateCallback);
	          }
	          if (options.backdrop) {
	            backdropCount--;
	            $animate.leave(backdropElement);
	          }
	          $modal.$isShown = scope.$isShown = false;
	          safeDigest(scope);
	          unbindBackdropEvents();
	          unbindKeyboardEvents();
	        };
	        function leaveAnimateCallback() {
	          scope.$emit(options.prefixEvent + '.hide', $modal);
	          if (angular.isDefined(options.onHide) && angular.isFunction(options.onHide)) {
	            options.onHide($modal);
	          }
	          if (findElement('.modal').length <= 0) {
	            bodyElement.removeClass(options.prefixClass + '-open');
	          }
	          if (options.animation) {
	            bodyElement.removeClass(options.prefixClass + '-with-' + options.animation);
	          }
	        }
	        $modal.toggle = function() {
	          if ($modal.$isShown) {
	            $modal.hide();
	          } else {
	            $modal.show();
	          }
	        };
	        $modal.focus = function() {
	          modalElement[0].focus();
	        };
	        $modal.$onKeyUp = function(evt) {
	          if (evt.which === 27 && $modal.$isShown) {
	            $modal.hide();
	            evt.stopPropagation();
	          }
	        };
	        function bindBackdropEvents() {
	          if (options.backdrop) {
	            modalElement.on('click', hideOnBackdropClick);
	            backdropElement.on('click', hideOnBackdropClick);
	            backdropElement.on('wheel', preventEventDefault);
	          }
	        }
	        function unbindBackdropEvents() {
	          if (options.backdrop) {
	            modalElement.off('click', hideOnBackdropClick);
	            backdropElement.off('click', hideOnBackdropClick);
	            backdropElement.off('wheel', preventEventDefault);
	          }
	        }
	        function bindKeyboardEvents() {
	          if (options.keyboard) {
	            modalElement.on('keyup', $modal.$onKeyUp);
	          }
	        }
	        function unbindKeyboardEvents() {
	          if (options.keyboard) {
	            modalElement.off('keyup', $modal.$onKeyUp);
	          }
	        }
	        function hideOnBackdropClick(evt) {
	          if (evt.target !== evt.currentTarget) return;
	          if (options.backdrop === 'static') {
	            $modal.focus();
	          } else {
	            $modal.hide();
	          }
	        }
	        function preventEventDefault(evt) {
	          evt.preventDefault();
	        }
	        function destroyModalElement() {
	          if ($modal.$isShown && modalElement !== null) {
	            unbindBackdropEvents();
	            unbindKeyboardEvents();
	          }
	          if (modalScope) {
	            modalScope.$destroy();
	            modalScope = null;
	          }
	          if (modalElement) {
	            modalElement.remove();
	            modalElement = $modal.$element = null;
	          }
	        }
	        return $modal;
	      }
	      function safeDigest(scope) {
	        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
	      }
	      function findElement(query, element) {
	        return angular.element((element || document).querySelectorAll(query));
	      }
	      return ModalFactory;
	    } ];
	  }).directive('bsModal', [ '$window', '$sce', '$parse', '$modal', function($window, $sce, $parse, $modal) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var options = {
	          scope: scope,
	          element: element,
	          show: false
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'backdrop', 'keyboard', 'html', 'container', 'animation', 'backdropAnimation', 'id', 'prefixEvent', 'prefixClass', 'customClass', 'modalClass', 'size', 'zIndex' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        if (options.modalClass) {
	          options.customClass = options.modalClass;
	        }
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'backdrop', 'keyboard', 'html', 'container' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        angular.forEach([ 'title', 'content' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	            });
	          }
	        });
	        if (attr.bsModal) {
	          scope.$watch(attr.bsModal, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	          }, true);
	        }
	        var modal = $modal(options);
	        element.on(attr.trigger || 'click', modal.toggle);
	        scope.$on('$destroy', function() {
	          if (modal) modal.destroy();
	          options = null;
	          modal = null;
	        });
	      }
	    };
	  } ]);
	  if (angular.version.minor < 3 && angular.version.dot < 14) {
	    angular.module('ng').factory('$$rAF', [ '$window', '$timeout', function($window, $timeout) {
	      var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame || $window.mozRequestAnimationFrame;
	      var cancelAnimationFrame = $window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.mozCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;
	      var rafSupported = !!requestAnimationFrame;
	      var raf = rafSupported ? function(fn) {
	        var id = requestAnimationFrame(fn);
	        return function() {
	          cancelAnimationFrame(id);
	        };
	      } : function(fn) {
	        var timer = $timeout(fn, 16.66, false);
	        return function() {
	          $timeout.cancel(timer);
	        };
	      };
	      raf.supported = rafSupported;
	      return raf;
	    } ]);
	  }
	  angular.module('mgcrea.ngStrap.helpers.parseOptions', []).provider('$parseOptions', function() {
	    var defaults = this.defaults = {
	      regexp: /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(.*?)(?:\s+track\s+by\s+(.*?))?$/
	    };
	    this.$get = [ '$parse', '$q', function($parse, $q) {
	      function ParseOptionsFactory(attr, config) {
	        var $parseOptions = {};
	        var options = angular.extend({}, defaults, config);
	        $parseOptions.$values = [];
	        var match;
	        var displayFn;
	        var valueName;
	        var keyName;
	        var groupByFn;
	        var valueFn;
	        var valuesFn;
	        $parseOptions.init = function() {
	          $parseOptions.$match = match = attr.match(options.regexp);
	          displayFn = $parse(match[2] || match[1]);
	          valueName = match[4] || match[6];
	          keyName = match[5];
	          groupByFn = $parse(match[3] || '');
	          valueFn = $parse(match[2] ? match[1] : valueName);
	          valuesFn = $parse(match[7]);
	        };
	        $parseOptions.valuesFn = function(scope, controller) {
	          return $q.when(valuesFn(scope, controller)).then(function(values) {
	            if (!angular.isArray(values)) {
	              values = [];
	            }
	            $parseOptions.$values = values.length ? parseValues(values, scope) : [];
	            return $parseOptions.$values;
	          });
	        };
	        $parseOptions.displayValue = function(modelValue) {
	          var scope = {};
	          scope[valueName] = modelValue;
	          return displayFn(scope);
	        };
	        function parseValues(values, scope) {
	          return values.map(function(match, index) {
	            var locals = {};
	            var label;
	            var value;
	            locals[valueName] = match;
	            label = displayFn(scope, locals);
	            value = valueFn(scope, locals);
	            return {
	              label: label,
	              value: value,
	              index: index
	            };
	          });
	        }
	        $parseOptions.init();
	        return $parseOptions;
	      }
	      return ParseOptionsFactory;
	    } ];
	  });
	  angular.module('mgcrea.ngStrap.helpers.dimensions', []).factory('dimensions', function() {
	    var fn = {};
	    var nodeName = fn.nodeName = function(element, name) {
	      return element.nodeName && element.nodeName.toLowerCase() === name.toLowerCase();
	    };
	    fn.css = function(element, prop, extra) {
	      var value;
	      if (element.currentStyle) {
	        value = element.currentStyle[prop];
	      } else if (window.getComputedStyle) {
	        value = window.getComputedStyle(element)[prop];
	      } else {
	        value = element.style[prop];
	      }
	      return extra === true ? parseFloat(value) || 0 : value;
	    };
	    fn.offset = function(element) {
	      var boxRect = element.getBoundingClientRect();
	      var docElement = element.ownerDocument;
	      return {
	        width: boxRect.width || element.offsetWidth,
	        height: boxRect.height || element.offsetHeight,
	        top: boxRect.top + (window.pageYOffset || docElement.documentElement.scrollTop) - (docElement.documentElement.clientTop || 0),
	        left: boxRect.left + (window.pageXOffset || docElement.documentElement.scrollLeft) - (docElement.documentElement.clientLeft || 0)
	      };
	    };
	    fn.setOffset = function(element, options, i) {
	      var curPosition;
	      var curLeft;
	      var curCSSTop;
	      var curTop;
	      var curOffset;
	      var curCSSLeft;
	      var calculatePosition;
	      var position = fn.css(element, 'position');
	      var curElem = angular.element(element);
	      var props = {};
	      if (position === 'static') {
	        element.style.position = 'relative';
	      }
	      curOffset = fn.offset(element);
	      curCSSTop = fn.css(element, 'top');
	      curCSSLeft = fn.css(element, 'left');
	      calculatePosition = (position === 'absolute' || position === 'fixed') && (curCSSTop + curCSSLeft).indexOf('auto') > -1;
	      if (calculatePosition) {
	        curPosition = fn.position(element);
	        curTop = curPosition.top;
	        curLeft = curPosition.left;
	      } else {
	        curTop = parseFloat(curCSSTop) || 0;
	        curLeft = parseFloat(curCSSLeft) || 0;
	      }
	      if (angular.isFunction(options)) {
	        options = options.call(element, i, curOffset);
	      }
	      if (options.top !== null) {
	        props.top = options.top - curOffset.top + curTop;
	      }
	      if (options.left !== null) {
	        props.left = options.left - curOffset.left + curLeft;
	      }
	      if ('using' in options) {
	        options.using.call(curElem, props);
	      } else {
	        curElem.css({
	          top: props.top + 'px',
	          left: props.left + 'px'
	        });
	      }
	    };
	    fn.position = function(element) {
	      var offsetParentRect = {
	        top: 0,
	        left: 0
	      };
	      var offsetParentEl;
	      var offset;
	      if (fn.css(element, 'position') === 'fixed') {
	        offset = element.getBoundingClientRect();
	      } else {
	        offsetParentEl = offsetParentElement(element);
	        offset = fn.offset(element);
	        if (!nodeName(offsetParentEl, 'html')) {
	          offsetParentRect = fn.offset(offsetParentEl);
	        }
	        offsetParentRect.top += fn.css(offsetParentEl, 'borderTopWidth', true);
	        offsetParentRect.left += fn.css(offsetParentEl, 'borderLeftWidth', true);
	      }
	      return {
	        width: element.offsetWidth,
	        height: element.offsetHeight,
	        top: offset.top - offsetParentRect.top - fn.css(element, 'marginTop', true),
	        left: offset.left - offsetParentRect.left - fn.css(element, 'marginLeft', true)
	      };
	    };
	    function offsetParentElement(element) {
	      var docElement = element.ownerDocument;
	      var offsetParent = element.offsetParent || docElement;
	      if (nodeName(offsetParent, '#document')) return docElement.documentElement;
	      while (offsetParent && !nodeName(offsetParent, 'html') && fn.css(offsetParent, 'position') === 'static') {
	        offsetParent = offsetParent.offsetParent;
	      }
	      return offsetParent || docElement.documentElement;
	    }
	    fn.height = function(element, outer) {
	      var value = element.offsetHeight;
	      if (outer) {
	        value += fn.css(element, 'marginTop', true) + fn.css(element, 'marginBottom', true);
	      } else {
	        value -= fn.css(element, 'paddingTop', true) + fn.css(element, 'paddingBottom', true) + fn.css(element, 'borderTopWidth', true) + fn.css(element, 'borderBottomWidth', true);
	      }
	      return value;
	    };
	    fn.width = function(element, outer) {
	      var value = element.offsetWidth;
	      if (outer) {
	        value += fn.css(element, 'marginLeft', true) + fn.css(element, 'marginRight', true);
	      } else {
	        value -= fn.css(element, 'paddingLeft', true) + fn.css(element, 'paddingRight', true) + fn.css(element, 'borderLeftWidth', true) + fn.css(element, 'borderRightWidth', true);
	      }
	      return value;
	    };
	    return fn;
	  });
	  angular.module('mgcrea.ngStrap.helpers.debounce', []).factory('debounce', [ '$timeout', function($timeout) {
	    return function(func, wait, immediate) {
	      var timeout = null;
	      return function() {
	        var context = this;
	        var args = arguments;
	        var callNow = immediate && !timeout;
	        if (timeout) {
	          $timeout.cancel(timeout);
	        }
	        timeout = $timeout(function later() {
	          timeout = null;
	          if (!immediate) {
	            func.apply(context, args);
	          }
	        }, wait, false);
	        if (callNow) {
	          func.apply(context, args);
	        }
	        return timeout;
	      };
	    };
	  } ]).factory('throttle', [ '$timeout', function($timeout) {
	    return function(func, wait, options) {
	      var timeout = null;
	      if (!options) options = {};
	      return function() {
	        var context = this;
	        var args = arguments;
	        if (!timeout) {
	          if (options.leading !== false) {
	            func.apply(context, args);
	          }
	          timeout = $timeout(function later() {
	            timeout = null;
	            if (options.trailing !== false) {
	              func.apply(context, args);
	            }
	          }, wait, false);
	        }
	      };
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.helpers.dateParser', []).provider('$dateParser', [ '$localeProvider', function($localeProvider) {
	    function ParseDate() {
	      this.year = 1970;
	      this.month = 0;
	      this.day = 1;
	      this.hours = 0;
	      this.minutes = 0;
	      this.seconds = 0;
	      this.milliseconds = 0;
	    }
	    ParseDate.prototype.setMilliseconds = function(value) {
	      this.milliseconds = value;
	    };
	    ParseDate.prototype.setSeconds = function(value) {
	      this.seconds = value;
	    };
	    ParseDate.prototype.setMinutes = function(value) {
	      this.minutes = value;
	    };
	    ParseDate.prototype.setHours = function(value) {
	      this.hours = value;
	    };
	    ParseDate.prototype.getHours = function() {
	      return this.hours;
	    };
	    ParseDate.prototype.setDate = function(value) {
	      this.day = value;
	    };
	    ParseDate.prototype.setMonth = function(value) {
	      this.month = value;
	    };
	    ParseDate.prototype.setFullYear = function(value) {
	      this.year = value;
	    };
	    ParseDate.prototype.fromDate = function(value) {
	      this.year = value.getFullYear();
	      this.month = value.getMonth();
	      this.day = value.getDate();
	      this.hours = value.getHours();
	      this.minutes = value.getMinutes();
	      this.seconds = value.getSeconds();
	      this.milliseconds = value.getMilliseconds();
	      return this;
	    };
	    ParseDate.prototype.toDate = function() {
	      return new Date(this.year, this.month, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
	    };
	    var proto = ParseDate.prototype;
	    function noop() {}
	    function isNumeric(n) {
	      return !isNaN(parseFloat(n)) && isFinite(n);
	    }
	    function indexOfCaseInsensitive(array, value) {
	      var len = array.length;
	      var str = value.toString().toLowerCase();
	      for (var i = 0; i < len; i++) {
	        if (array[i].toLowerCase() === str) {
	          return i;
	        }
	      }
	      return -1;
	    }
	    var defaults = this.defaults = {
	      format: 'shortDate',
	      strict: false
	    };
	    this.$get = [ '$locale', 'dateFilter', function($locale, dateFilter) {
	      var DateParserFactory = function(config) {
	        var options = angular.extend({}, defaults, config);
	        var $dateParser = {};
	        var regExpMap = {
	          sss: '[0-9]{3}',
	          ss: '[0-5][0-9]',
	          s: options.strict ? '[1-5]?[0-9]' : '[0-9]|[0-5][0-9]',
	          mm: '[0-5][0-9]',
	          m: options.strict ? '[1-5]?[0-9]' : '[0-9]|[0-5][0-9]',
	          HH: '[01][0-9]|2[0-3]',
	          H: options.strict ? '1?[0-9]|2[0-3]' : '[01]?[0-9]|2[0-3]',
	          hh: '[0][1-9]|[1][012]',
	          h: options.strict ? '[1-9]|1[012]' : '0?[1-9]|1[012]',
	          a: 'AM|PM',
	          EEEE: $locale.DATETIME_FORMATS.DAY.join('|'),
	          EEE: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	          dd: '0[1-9]|[12][0-9]|3[01]',
	          d: options.strict ? '[1-9]|[1-2][0-9]|3[01]' : '0?[1-9]|[1-2][0-9]|3[01]',
	          MMMM: $locale.DATETIME_FORMATS.MONTH.join('|'),
	          MMM: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	          MM: '0[1-9]|1[012]',
	          M: options.strict ? '[1-9]|1[012]' : '0?[1-9]|1[012]',
	          yyyy: '[1]{1}[0-9]{3}|[2]{1}[0-9]{3}',
	          yy: '[0-9]{2}',
	          y: options.strict ? '-?(0|[1-9][0-9]{0,3})' : '-?0*[0-9]{1,4}'
	        };
	        var setFnMap = {
	          sss: proto.setMilliseconds,
	          ss: proto.setSeconds,
	          s: proto.setSeconds,
	          mm: proto.setMinutes,
	          m: proto.setMinutes,
	          HH: proto.setHours,
	          H: proto.setHours,
	          hh: proto.setHours,
	          h: proto.setHours,
	          EEEE: noop,
	          EEE: noop,
	          dd: proto.setDate,
	          d: proto.setDate,
	          a: function(value) {
	            var hours = this.getHours() % 12;
	            return this.setHours(value.match(/pm/i) ? hours + 12 : hours);
	          },
	          MMMM: function(value) {
	            return this.setMonth(indexOfCaseInsensitive($locale.DATETIME_FORMATS.MONTH, value));
	          },
	          MMM: function(value) {
	            return this.setMonth(indexOfCaseInsensitive($locale.DATETIME_FORMATS.SHORTMONTH, value));
	          },
	          MM: function(value) {
	            return this.setMonth(1 * value - 1);
	          },
	          M: function(value) {
	            return this.setMonth(1 * value - 1);
	          },
	          yyyy: proto.setFullYear,
	          yy: function(value) {
	            return this.setFullYear(2e3 + 1 * value);
	          },
	          y: function(value) {
	            return 1 * value <= 50 && value.length === 2 ? this.setFullYear(2e3 + 1 * value) : this.setFullYear(1 * value);
	          }
	        };
	        var regex;
	        var setMap;
	        $dateParser.init = function() {
	          $dateParser.$format = $locale.DATETIME_FORMATS[options.format] || options.format;
	          regex = regExpForFormat($dateParser.$format);
	          setMap = setMapForFormat($dateParser.$format);
	        };
	        $dateParser.isValid = function(date) {
	          if (angular.isDate(date)) return !isNaN(date.getTime());
	          return regex.test(date);
	        };
	        $dateParser.parse = function(value, baseDate, format, timezone) {
	          if (format) format = $locale.DATETIME_FORMATS[format] || format;
	          if (angular.isDate(value)) value = dateFilter(value, format || $dateParser.$format, timezone);
	          var formatRegex = format ? regExpForFormat(format) : regex;
	          var formatSetMap = format ? setMapForFormat(format) : setMap;
	          var matches = formatRegex.exec(value);
	          if (!matches) return false;
	          var date = baseDate && !isNaN(baseDate.getTime()) ? new ParseDate().fromDate(baseDate) : new ParseDate().fromDate(new Date(1970, 0, 1, 0));
	          for (var i = 0; i < matches.length - 1; i++) {
	            if (formatSetMap[i]) formatSetMap[i].call(date, matches[i + 1]);
	          }
	          var newDate = date.toDate();
	          if (parseInt(date.day, 10) !== newDate.getDate()) {
	            return false;
	          }
	          return newDate;
	        };
	        $dateParser.getDateForAttribute = function(key, value) {
	          var date;
	          if (value === 'today') {
	            var today = new Date();
	            date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (key === 'maxDate' ? 1 : 0), 0, 0, 0, key === 'minDate' ? 0 : -1);
	          } else if (angular.isString(value) && value.match(/^".+"$/)) {
	            date = new Date(value.substr(1, value.length - 2));
	          } else if (isNumeric(value)) {
	            date = new Date(parseInt(value, 10));
	          } else if (angular.isString(value) && value.length === 0) {
	            date = key === 'minDate' ? -Infinity : +Infinity;
	          } else {
	            date = new Date(value);
	          }
	          return date;
	        };
	        $dateParser.getTimeForAttribute = function(key, value) {
	          var time;
	          if (value === 'now') {
	            time = new Date().setFullYear(1970, 0, 1);
	          } else if (angular.isString(value) && value.match(/^".+"$/)) {
	            time = new Date(value.substr(1, value.length - 2)).setFullYear(1970, 0, 1);
	          } else if (isNumeric(value)) {
	            time = new Date(parseInt(value, 10)).setFullYear(1970, 0, 1);
	          } else if (angular.isString(value) && value.length === 0) {
	            time = key === 'minTime' ? -Infinity : +Infinity;
	          } else {
	            time = $dateParser.parse(value, new Date(1970, 0, 1, 0));
	          }
	          return time;
	        };
	        $dateParser.daylightSavingAdjust = function(date) {
	          if (!date) {
	            return null;
	          }
	          date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
	          return date;
	        };
	        $dateParser.timezoneOffsetAdjust = function(date, timezone, undo) {
	          if (!date) {
	            return null;
	          }
	          if (timezone && timezone === 'UTC') {
	            date = new Date(date.getTime());
	            date.setMinutes(date.getMinutes() + (undo ? -1 : 1) * date.getTimezoneOffset());
	          }
	          return date;
	        };
	        function regExpForFormat(format) {
	          var re = buildDateAbstractRegex(format);
	          return buildDateParseRegex(re);
	        }
	        function buildDateAbstractRegex(format) {
	          var escapedFormat = escapeReservedSymbols(format);
	          var escapedLiteralFormat = escapedFormat.replace(/''/g, '\\\'');
	          var literalRegex = /('(?:\\'|.)*?')/;
	          var formatParts = escapedLiteralFormat.split(literalRegex);
	          var dateElements = Object.keys(regExpMap);
	          var dateRegexParts = [];
	          angular.forEach(formatParts, function(part) {
	            if (isFormatStringLiteral(part)) {
	              part = trimLiteralEscapeChars(part);
	            } else {
	              for (var i = 0; i < dateElements.length; i++) {
	                part = part.split(dateElements[i]).join('${' + i + '}');
	              }
	            }
	            dateRegexParts.push(part);
	          });
	          return dateRegexParts.join('');
	        }
	        function escapeReservedSymbols(text) {
	          return text.replace(/\\/g, '[\\\\]').replace(/-/g, '[-]').replace(/\./g, '[.]').replace(/\*/g, '[*]').replace(/\+/g, '[+]').replace(/\?/g, '[?]').replace(/\$/g, '[$]').replace(/\^/g, '[^]').replace(/\//g, '[/]').replace(/\\s/g, '[\\s]');
	        }
	        function isFormatStringLiteral(text) {
	          return /^'.*'$/.test(text);
	        }
	        function trimLiteralEscapeChars(text) {
	          return text.replace(/^'(.*)'$/, '$1');
	        }
	        function buildDateParseRegex(abstractRegex) {
	          var dateElements = Object.keys(regExpMap);
	          var re = abstractRegex;
	          for (var i = 0; i < dateElements.length; i++) {
	            re = re.split('${' + i + '}').join('(' + regExpMap[dateElements[i]] + ')');
	          }
	          return new RegExp('^' + re + '$', [ 'i' ]);
	        }
	        function setMapForFormat(format) {
	          var re = buildDateAbstractRegex(format);
	          return buildDateParseValuesMap(re);
	        }
	        function buildDateParseValuesMap(abstractRegex) {
	          var dateElements = Object.keys(regExpMap);
	          var valuesRegex = new RegExp('\\${(\\d+)}', 'g');
	          var valuesMatch;
	          var keyIndex;
	          var valueKey;
	          var valueFunction;
	          var valuesFunctionMap = [];
	          while ((valuesMatch = valuesRegex.exec(abstractRegex)) !== null) {
	            keyIndex = valuesMatch[1];
	            valueKey = dateElements[keyIndex];
	            valueFunction = setFnMap[valueKey];
	            valuesFunctionMap.push(valueFunction);
	          }
	          return valuesFunctionMap;
	        }
	        $dateParser.init();
	        return $dateParser;
	      };
	      return DateParserFactory;
	    } ];
	  } ]);
	  angular.module('mgcrea.ngStrap.helpers.dateFormatter', []).service('$dateFormatter', [ '$locale', 'dateFilter', function($locale, dateFilter) {
	    this.getDefaultLocale = function() {
	      return $locale.id;
	    };
	    this.getDatetimeFormat = function(format, lang) {
	      return $locale.DATETIME_FORMATS[format] || format;
	    };
	    this.weekdaysShort = function(lang) {
	      return $locale.DATETIME_FORMATS.SHORTDAY;
	    };
	    function splitTimeFormat(format) {
	      return /(h+)([:\.])?(m+)([:\.])?(s*)[ ]?(a?)/i.exec(format).slice(1);
	    }
	    this.hoursFormat = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[0];
	    };
	    this.minutesFormat = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[2];
	    };
	    this.secondsFormat = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[4];
	    };
	    this.timeSeparator = function(timeFormat) {
	      return splitTimeFormat(timeFormat)[1];
	    };
	    this.showSeconds = function(timeFormat) {
	      return !!splitTimeFormat(timeFormat)[4];
	    };
	    this.showAM = function(timeFormat) {
	      return !!splitTimeFormat(timeFormat)[5];
	    };
	    this.formatDate = function(date, format, lang, timezone) {
	      return dateFilter(date, format, timezone);
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.core', []).service('$bsCompiler', bsCompilerService);
	  function bsCompilerService($q, $http, $injector, $compile, $controller, $templateCache) {
	    this.compile = function(options) {
	      if (options.template && /\.html$/.test(options.template)) {
	        console.warn('Deprecated use of `template` option to pass a file. Please use the `templateUrl` option instead.');
	        options.templateUrl = options.template;
	        options.template = '';
	      }
	      var templateUrl = options.templateUrl;
	      var template = options.template || '';
	      var controller = options.controller;
	      var controllerAs = options.controllerAs;
	      var resolve = options.resolve || {};
	      var locals = options.locals || {};
	      var transformTemplate = options.transformTemplate || angular.identity;
	      var bindToController = options.bindToController;
	      angular.forEach(resolve, function(value, key) {
	        if (angular.isString(value)) {
	          resolve[key] = $injector.get(value);
	        } else {
	          resolve[key] = $injector.invoke(value);
	        }
	      });
	      angular.extend(resolve, locals);
	      if (template) {
	        resolve.$template = $q.when(template);
	      } else if (templateUrl) {
	        resolve.$template = fetchTemplate(templateUrl);
	      } else {
	        throw new Error('Missing `template` / `templateUrl` option.');
	      }
	      if (options.titleTemplate) {
	        resolve.$template = $q.all([ resolve.$template, fetchTemplate(options.titleTemplate) ]).then(function(templates) {
	          var templateEl = angular.element(templates[0]);
	          findElement('[ng-bind="title"]', templateEl[0]).removeAttr('ng-bind').html(templates[1]);
	          return templateEl[0].outerHTML;
	        });
	      }
	      if (options.contentTemplate) {
	        resolve.$template = $q.all([ resolve.$template, fetchTemplate(options.contentTemplate) ]).then(function(templates) {
	          var templateEl = angular.element(templates[0]);
	          var contentEl = findElement('[ng-bind="content"]', templateEl[0]).removeAttr('ng-bind').html(templates[1]);
	          if (!options.templateUrl) contentEl.next().remove();
	          return templateEl[0].outerHTML;
	        });
	      }
	      return $q.all(resolve).then(function(locals) {
	        var template = transformTemplate(locals.$template);
	        if (options.html) {
	          template = template.replace(/ng-bind="/gi, 'ng-bind-html="');
	        }
	        var element = angular.element('<div>').html(template.trim()).contents();
	        var linkFn = $compile(element);
	        return {
	          locals: locals,
	          element: element,
	          link: function link(scope) {
	            locals.$scope = scope;
	            if (controller) {
	              var invokeCtrl = $controller(controller, locals, true);
	              if (bindToController) {
	                angular.extend(invokeCtrl.instance, locals);
	              }
	              var ctrl = angular.isObject(invokeCtrl) ? invokeCtrl : invokeCtrl();
	              element.data('$ngControllerController', ctrl);
	              element.children().data('$ngControllerController', ctrl);
	              if (controllerAs) {
	                scope[controllerAs] = ctrl;
	              }
	            }
	            return linkFn.apply(null, arguments);
	          }
	        };
	      });
	    };
	    function findElement(query, element) {
	      return angular.element((element || document).querySelectorAll(query));
	    }
	    var fetchPromises = {};
	    function fetchTemplate(template) {
	      if (fetchPromises[template]) return fetchPromises[template];
	      return fetchPromises[template] = $http.get(template, {
	        cache: $templateCache
	      }).then(function(res) {
	        return res.data;
	      });
	    }
	  }
	  angular.module('mgcrea.ngStrap.dropdown', [ 'mgcrea.ngStrap.tooltip' ]).provider('$dropdown', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'dropdown',
	      prefixEvent: 'dropdown',
	      placement: 'bottom-left',
	      templateUrl: 'dropdown/dropdown.tpl.html',
	      trigger: 'click',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0
	    };
	    this.$get = [ '$window', '$rootScope', '$tooltip', '$timeout', function($window, $rootScope, $tooltip, $timeout) {
	      var bodyEl = angular.element($window.document.body);
	      var matchesSelector = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector;
	      function DropdownFactory(element, config) {
	        var $dropdown = {};
	        var options = angular.extend({}, defaults, config);
	        $dropdown.$scope = options.scope && options.scope.$new() || $rootScope.$new();
	        $dropdown = $tooltip(element, options);
	        var parentEl = element.parent();
	        $dropdown.$onKeyDown = function(evt) {
	          if (!/(38|40)/.test(evt.keyCode)) return;
	          evt.preventDefault();
	          evt.stopPropagation();
	          var items = angular.element($dropdown.$element[0].querySelectorAll('li:not(.divider) a'));
	          if (!items.length) return;
	          var index;
	          angular.forEach(items, function(el, i) {
	            if (matchesSelector && matchesSelector.call(el, ':focus')) index = i;
	          });
	          if (evt.keyCode === 38 && index > 0) index--; else if (evt.keyCode === 40 && index < items.length - 1) index++; else if (angular.isUndefined(index)) index = 0;
	          items.eq(index)[0].focus();
	        };
	        var show = $dropdown.show;
	        $dropdown.show = function() {
	          show();
	          $timeout(function() {
	            if (options.keyboard && $dropdown.$element) $dropdown.$element.on('keydown', $dropdown.$onKeyDown);
	            bodyEl.on('click', onBodyClick);
	          }, 0, false);
	          if (parentEl.hasClass('dropdown')) parentEl.addClass('open');
	        };
	        var hide = $dropdown.hide;
	        $dropdown.hide = function() {
	          if (!$dropdown.$isShown) return;
	          if (options.keyboard && $dropdown.$element) $dropdown.$element.off('keydown', $dropdown.$onKeyDown);
	          bodyEl.off('click', onBodyClick);
	          if (parentEl.hasClass('dropdown')) parentEl.removeClass('open');
	          hide();
	        };
	        var destroy = $dropdown.destroy;
	        $dropdown.destroy = function() {
	          bodyEl.off('click', onBodyClick);
	          destroy();
	        };
	        function onBodyClick(evt) {
	          if (evt.target === element[0]) return;
	          return evt.target !== element[0] && $dropdown.hide();
	        }
	        return $dropdown;
	      }
	      return DropdownFactory;
	    } ];
	  }).directive('bsDropdown', [ '$window', '$sce', '$dropdown', function($window, $sce, $dropdown) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      compile: function(tElement, tAttrs) {
	        if (!tAttrs.bsDropdown) {
	          var nextSibling = tElement[0].nextSibling;
	          while (nextSibling && nextSibling.nodeType !== 1) {
	            nextSibling = nextSibling.nextSibling;
	          }
	          if (nextSibling && nextSibling.className.split(' ').indexOf('dropdown-menu') >= 0) {
	            tAttrs.template = nextSibling.outerHTML;
	            tAttrs.templateUrl = undefined;
	            nextSibling.parentNode.removeChild(nextSibling);
	          }
	        }
	        return function postLink(scope, element, attr) {
	          var options = {
	            scope: scope
	          };
	          angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'keyboard', 'html', 'animation', 'id', 'autoClose' ], function(key) {
	            if (angular.isDefined(tAttrs[key])) options[key] = tAttrs[key];
	          });
	          var falseValueRegExp = /^(false|0|)$/i;
	          angular.forEach([ 'html', 'container' ], function(key) {
	            if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	          });
	          angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	            var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	            if (angular.isDefined(attr[bsKey])) {
	              options[key] = scope.$eval(attr[bsKey]);
	            }
	          });
	          if (attr.bsDropdown) {
	            scope.$watch(attr.bsDropdown, function(newValue, oldValue) {
	              scope.content = newValue;
	            }, true);
	          }
	          var dropdown = $dropdown(element, options);
	          if (attr.bsShow) {
	            scope.$watch(attr.bsShow, function(newValue, oldValue) {
	              if (!dropdown || !angular.isDefined(newValue)) return;
	              if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(dropdown),?/i);
	              if (newValue === true) {
	                dropdown.show();
	              } else {
	                dropdown.hide();
	              }
	            });
	          }
	          scope.$on('$destroy', function() {
	            if (dropdown) dropdown.destroy();
	            options = null;
	            dropdown = null;
	          });
	        };
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.button', []).provider('$button', function() {
	    var defaults = this.defaults = {
	      activeClass: 'active',
	      toggleEvent: 'click'
	    };
	    this.$get = function() {
	      return {
	        defaults: defaults
	      };
	    };
	  }).directive('bsCheckboxGroup', function() {
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      compile: function postLink(element, attr) {
	        element.attr('data-toggle', 'buttons');
	        element.removeAttr('ng-model');
	        var children = element[0].querySelectorAll('input[type="checkbox"]');
	        angular.forEach(children, function(child) {
	          var childEl = angular.element(child);
	          childEl.attr('bs-checkbox', '');
	          childEl.attr('ng-model', attr.ngModel + '.' + childEl.attr('value'));
	        });
	      }
	    };
	  }).directive('bsCheckbox', [ '$button', '$$rAF', function($button, $$rAF) {
	    var defaults = $button.defaults;
	    var constantValueRegExp = /^(true|false|\d+)$/;
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = defaults;
	        var isInput = element[0].nodeName === 'INPUT';
	        var activeElement = isInput ? element.parent() : element;
	        var trueValue = angular.isDefined(attr.trueValue) ? attr.trueValue : true;
	        if (constantValueRegExp.test(attr.trueValue)) {
	          trueValue = scope.$eval(attr.trueValue);
	        }
	        var falseValue = angular.isDefined(attr.falseValue) ? attr.falseValue : false;
	        if (constantValueRegExp.test(attr.falseValue)) {
	          falseValue = scope.$eval(attr.falseValue);
	        }
	        var hasExoticValues = typeof trueValue !== 'boolean' || typeof falseValue !== 'boolean';
	        if (hasExoticValues) {
	          controller.$parsers.push(function(viewValue) {
	            return viewValue ? trueValue : falseValue;
	          });
	          controller.$formatters.push(function(modelValue) {
	            return angular.equals(modelValue, trueValue);
	          });
	        }
	        controller.$render = function() {
	          var isActive = !!controller.$viewValue;
	          $$rAF(function() {
	            if (isInput) element[0].checked = isActive;
	            activeElement.toggleClass(options.activeClass, isActive);
	          });
	        };
	        element.bind(options.toggleEvent, function() {
	          scope.$apply(function() {
	            if (!isInput) {
	              controller.$setViewValue(!activeElement.hasClass('active'));
	            }
	            controller.$render();
	          });
	        });
	      }
	    };
	  } ]).directive('bsRadioGroup', function() {
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      compile: function postLink(element, attr) {
	        element.attr('data-toggle', 'buttons');
	        element.removeAttr('ng-model');
	        var children = element[0].querySelectorAll('input[type="radio"]');
	        angular.forEach(children, function(child) {
	          angular.element(child).attr('bs-radio', '');
	          angular.element(child).attr('ng-model', attr.ngModel);
	        });
	      }
	    };
	  }).directive('bsRadio', [ '$button', '$$rAF', function($button, $$rAF) {
	    var defaults = $button.defaults;
	    var constantValueRegExp = /^(true|false|\d+)$/;
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = defaults;
	        var isInput = element[0].nodeName === 'INPUT';
	        var activeElement = isInput ? element.parent() : element;
	        var value;
	        attr.$observe('value', function(v) {
	          if (typeof v !== 'boolean' && constantValueRegExp.test(v)) {
	            value = scope.$eval(v);
	          } else {
	            value = v;
	          }
	          controller.$render();
	        });
	        controller.$render = function() {
	          var isActive = angular.equals(controller.$viewValue, value);
	          $$rAF(function() {
	            if (isInput) element[0].checked = isActive;
	            activeElement.toggleClass(options.activeClass, isActive);
	          });
	        };
	        element.bind(options.toggleEvent, function() {
	          scope.$apply(function() {
	            controller.$setViewValue(value);
	            controller.$render();
	          });
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.datepicker', [ 'mgcrea.ngStrap.helpers.dateParser', 'mgcrea.ngStrap.helpers.dateFormatter', 'mgcrea.ngStrap.tooltip' ]).provider('$datepicker', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'datepicker',
	      placement: 'bottom-left',
	      templateUrl: 'datepicker/datepicker.tpl.html',
	      trigger: 'focus',
	      container: false,
	      keyboard: true,
	      html: false,
	      delay: 0,
	      useNative: false,
	      dateType: 'date',
	      dateFormat: 'shortDate',
	      timezone: null,
	      modelDateFormat: null,
	      dayFormat: 'dd',
	      monthFormat: 'MMM',
	      yearFormat: 'yyyy',
	      monthTitleFormat: 'MMMM yyyy',
	      yearTitleFormat: 'yyyy',
	      strictFormat: false,
	      autoclose: false,
	      minDate: -Infinity,
	      maxDate: +Infinity,
	      startView: 0,
	      minView: 0,
	      startWeek: 0,
	      daysOfWeekDisabled: '',
	      hasToday: false,
	      hasClear: false,
	      iconLeft: 'glyphicon glyphicon-chevron-left',
	      iconRight: 'glyphicon glyphicon-chevron-right'
	    };
	    this.$get = [ '$window', '$document', '$rootScope', '$sce', '$dateFormatter', 'datepickerViews', '$tooltip', '$timeout', function($window, $document, $rootScope, $sce, $dateFormatter, datepickerViews, $tooltip, $timeout) {
	      var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	      var isTouch = 'createTouch' in $window.document && isNative;
	      if (!defaults.lang) defaults.lang = $dateFormatter.getDefaultLocale();
	      function DatepickerFactory(element, controller, config) {
	        var $datepicker = $tooltip(element, angular.extend({}, defaults, config));
	        var parentScope = config.scope;
	        var options = $datepicker.$options;
	        var scope = $datepicker.$scope;
	        if (options.startView) options.startView -= options.minView;
	        var pickerViews = datepickerViews($datepicker);
	        $datepicker.$views = pickerViews.views;
	        var viewDate = pickerViews.viewDate;
	        scope.$mode = options.startView;
	        scope.$iconLeft = options.iconLeft;
	        scope.$iconRight = options.iconRight;
	        scope.$hasToday = options.hasToday;
	        scope.$hasClear = options.hasClear;
	        var $picker = $datepicker.$views[scope.$mode];
	        scope.$select = function(date, disabled) {
	          if (disabled) return;
	          $datepicker.select(date);
	        };
	        scope.$selectPane = function(value) {
	          $datepicker.$selectPane(value);
	        };
	        scope.$toggleMode = function() {
	          $datepicker.setMode((scope.$mode + 1) % $datepicker.$views.length);
	        };
	        scope.$setToday = function() {
	          if (options.autoclose) {
	            $datepicker.setMode(0);
	            $datepicker.select(new Date());
	          } else {
	            $datepicker.select(new Date(), true);
	          }
	        };
	        scope.$clear = function() {
	          if (options.autoclose) {
	            $datepicker.setMode(0);
	            $datepicker.select(null);
	          } else {
	            $datepicker.select(null, true);
	          }
	        };
	        $datepicker.update = function(date) {
	          if (angular.isDate(date) && !isNaN(date.getTime())) {
	            $datepicker.$date = date;
	            $picker.update.call($picker, date);
	          }
	          $datepicker.$build(true);
	        };
	        $datepicker.updateDisabledDates = function(dateRanges) {
	          options.disabledDateRanges = dateRanges;
	          for (var i = 0, l = scope.rows.length; i < l; i++) {
	            angular.forEach(scope.rows[i], $datepicker.$setDisabledEl);
	          }
	        };
	        $datepicker.select = function(date, keep) {
	          if (angular.isDate(date)) {
	            if (!angular.isDate(controller.$dateValue) || isNaN(controller.$dateValue.getTime())) {
	              controller.$dateValue = new Date(date);
	            }
	          } else {
	            controller.$dateValue = null;
	          }
	          if (!scope.$mode || keep) {
	            controller.$setViewValue(angular.copy(date));
	            controller.$render();
	            if (options.autoclose && !keep) {
	              $timeout(function() {
	                $datepicker.hide(true);
	              });
	            }
	          } else {
	            angular.extend(viewDate, {
	              year: date.getFullYear(),
	              month: date.getMonth(),
	              date: date.getDate()
	            });
	            $datepicker.setMode(scope.$mode - 1);
	            $datepicker.$build();
	          }
	        };
	        $datepicker.setMode = function(mode) {
	          scope.$mode = mode;
	          $picker = $datepicker.$views[scope.$mode];
	          $datepicker.$build();
	        };
	        $datepicker.$build = function(pristine) {
	          if (pristine === true && $picker.built) return;
	          if (pristine === false && !$picker.built) return;
	          $picker.build.call($picker);
	        };
	        $datepicker.$updateSelected = function() {
	          for (var i = 0, l = scope.rows.length; i < l; i++) {
	            angular.forEach(scope.rows[i], updateSelected);
	          }
	        };
	        $datepicker.$isSelected = function(date) {
	          return $picker.isSelected(date);
	        };
	        $datepicker.$setDisabledEl = function(el) {
	          el.disabled = $picker.isDisabled(el.date);
	        };
	        $datepicker.$selectPane = function(value) {
	          var steps = $picker.steps;
	          var targetDate = new Date(Date.UTC(viewDate.year + (steps.year || 0) * value, viewDate.month + (steps.month || 0) * value, 1));
	          angular.extend(viewDate, {
	            year: targetDate.getUTCFullYear(),
	            month: targetDate.getUTCMonth(),
	            date: targetDate.getUTCDate()
	          });
	          $datepicker.$build();
	        };
	        $datepicker.$onMouseDown = function(evt) {
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (isTouch) {
	            var targetEl = angular.element(evt.target);
	            if (targetEl[0].nodeName.toLowerCase() !== 'button') {
	              targetEl = targetEl.parent();
	            }
	            targetEl.triggerHandler('click');
	          }
	        };
	        $datepicker.$onKeyDown = function(evt) {
	          if (!/(38|37|39|40|13)/.test(evt.keyCode) || evt.shiftKey || evt.altKey) return;
	          evt.preventDefault();
	          evt.stopPropagation();
	          if (evt.keyCode === 13) {
	            if (!scope.$mode) {
	              $datepicker.hide(true);
	            } else {
	              scope.$apply(function() {
	                $datepicker.setMode(scope.$mode - 1);
	              });
	            }
	            return;
	          }
	          $picker.onKeyDown(evt);
	          parentScope.$digest();
	        };
	        function updateSelected(el) {
	          el.selected = $datepicker.$isSelected(el.date);
	        }
	        function focusElement() {
	          element[0].focus();
	        }
	        var _init = $datepicker.init;
	        $datepicker.init = function() {
	          if (isNative && options.useNative) {
	            element.prop('type', 'date');
	            element.css('-webkit-appearance', 'textfield');
	            return;
	          } else if (isTouch) {
	            element.prop('type', 'text');
	            element.attr('readonly', 'true');
	            element.on('click', focusElement);
	          }
	          _init();
	        };
	        var _destroy = $datepicker.destroy;
	        $datepicker.destroy = function() {
	          if (isNative && options.useNative) {
	            element.off('click', focusElement);
	          }
	          _destroy();
	        };
	        var _show = $datepicker.show;
	        $datepicker.show = function() {
	          if (!isTouch && element.attr('readonly') || element.attr('disabled')) return;
	          _show();
	          $timeout(function() {
	            if (!$datepicker.$isShown) return;
	            $datepicker.$element.on(isTouch ? 'touchstart' : 'mousedown', $datepicker.$onMouseDown);
	            if (options.keyboard) {
	              element.on('keydown', $datepicker.$onKeyDown);
	            }
	          }, 0, false);
	        };
	        var _hide = $datepicker.hide;
	        $datepicker.hide = function(blur) {
	          if (!$datepicker.$isShown) return;
	          $datepicker.$element.off(isTouch ? 'touchstart' : 'mousedown', $datepicker.$onMouseDown);
	          if (options.keyboard) {
	            element.off('keydown', $datepicker.$onKeyDown);
	          }
	          _hide(blur);
	        };
	        return $datepicker;
	      }
	      DatepickerFactory.defaults = defaults;
	      return DatepickerFactory;
	    } ];
	  }).directive('bsDatepicker', [ '$window', '$parse', '$q', '$dateFormatter', '$dateParser', '$datepicker', function($window, $parse, $q, $dateFormatter, $dateParser, $datepicker) {
	    var isNative = /(ip[ao]d|iphone|android)/gi.test($window.navigator.userAgent);
	    return {
	      restrict: 'EAC',
	      require: 'ngModel',
	      link: function postLink(scope, element, attr, controller) {
	        var options = {
	          scope: scope
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'container', 'delay', 'trigger', 'html', 'animation', 'autoclose', 'dateType', 'dateFormat', 'timezone', 'modelDateFormat', 'dayFormat', 'strictFormat', 'startWeek', 'startDate', 'useNative', 'lang', 'startView', 'minView', 'iconLeft', 'iconRight', 'daysOfWeekDisabled', 'id', 'prefixClass', 'prefixEvent', 'hasToday', 'hasClear' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'html', 'container', 'autoclose', 'useNative', 'hasToday', 'hasClear' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) {
	            options[key] = false;
	          }
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        var datepicker = $datepicker(element, controller, options);
	        options = datepicker.$options;
	        if (isNative && options.useNative) options.dateFormat = 'yyyy-MM-dd';
	        var lang = options.lang;
	        var formatDate = function(date, format) {
	          return $dateFormatter.formatDate(date, format, lang);
	        };
	        var dateParser = $dateParser({
	          format: options.dateFormat,
	          lang: lang,
	          strict: options.strictFormat
	        });
	        if (attr.bsShow) {
	          scope.$watch(attr.bsShow, function(newValue, oldValue) {
	            if (!datepicker || !angular.isDefined(newValue)) return;
	            if (angular.isString(newValue)) newValue = !!newValue.match(/true|,?(datepicker),?/i);
	            if (newValue === true) {
	              datepicker.show();
	            } else {
	              datepicker.hide();
	            }
	          });
	        }
	        angular.forEach([ 'minDate', 'maxDate' ], function(key) {
	          if (angular.isDefined(attr[key])) {
	            attr.$observe(key, function(newValue) {
	              datepicker.$options[key] = dateParser.getDateForAttribute(key, newValue);
	              if (!isNaN(datepicker.$options[key])) datepicker.$build(false);
	              validateAgainstMinMaxDate(controller.$dateValue);
	            });
	          }
	        });
	        if (angular.isDefined(attr.dateFormat)) {
	          attr.$observe('dateFormat', function(newValue) {
	            datepicker.$options.dateFormat = newValue;
	          });
	        }
	        scope.$watch(attr.ngModel, function(newValue, oldValue) {
	          datepicker.update(controller.$dateValue);
	        }, true);
	        function normalizeDateRanges(ranges) {
	          if (!ranges || !ranges.length) return null;
	          return ranges;
	        }
	        if (angular.isDefined(attr.disabledDates)) {
	          scope.$watch(attr.disabledDates, function(disabledRanges, previousValue) {
	            disabledRanges = normalizeDateRanges(disabledRanges);
	            previousValue = normalizeDateRanges(previousValue);
	            if (disabledRanges) {
	              datepicker.updateDisabledDates(disabledRanges);
	            }
	          });
	        }
	        function validateAgainstMinMaxDate(parsedDate) {
	          if (!angular.isDate(parsedDate)) return;
	          var isMinValid = isNaN(datepicker.$options.minDate) || parsedDate.getTime() >= datepicker.$options.minDate;
	          var isMaxValid = isNaN(datepicker.$options.maxDate) || parsedDate.getTime() <= datepicker.$options.maxDate;
	          var isValid = isMinValid && isMaxValid;
	          controller.$setValidity('date', isValid);
	          controller.$setValidity('min', isMinValid);
	          controller.$setValidity('max', isMaxValid);
	          if (isValid) controller.$dateValue = parsedDate;
	        }
	        controller.$parsers.unshift(function(viewValue) {
	          var date;
	          if (!viewValue) {
	            controller.$setValidity('date', true);
	            return null;
	          }
	          var parsedDate = dateParser.parse(viewValue, controller.$dateValue);
	          if (!parsedDate || isNaN(parsedDate.getTime())) {
	            controller.$setValidity('date', false);
	            return;
	          }
	          validateAgainstMinMaxDate(parsedDate);
	          if (options.dateType === 'string') {
	            date = dateParser.timezoneOffsetAdjust(parsedDate, options.timezone, true);
	            return formatDate(date, options.modelDateFormat || options.dateFormat);
	          }
	          date = dateParser.timezoneOffsetAdjust(controller.$dateValue, options.timezone, true);
	          if (options.dateType === 'number') {
	            return date.getTime();
	          } else if (options.dateType === 'unix') {
	            return date.getTime() / 1e3;
	          } else if (options.dateType === 'iso') {
	            return date.toISOString();
	          }
	          return new Date(date);
	        });
	        controller.$formatters.push(function(modelValue) {
	          var date;
	          if (angular.isUndefined(modelValue) || modelValue === null) {
	            date = NaN;
	          } else if (angular.isDate(modelValue)) {
	            date = modelValue;
	          } else if (options.dateType === 'string') {
	            date = dateParser.parse(modelValue, null, options.modelDateFormat);
	          } else if (options.dateType === 'unix') {
	            date = new Date(modelValue * 1e3);
	          } else {
	            date = new Date(modelValue);
	          }
	          controller.$dateValue = dateParser.timezoneOffsetAdjust(date, options.timezone);
	          return getDateFormattedString();
	        });
	        controller.$render = function() {
	          element.val(getDateFormattedString());
	        };
	        function getDateFormattedString() {
	          return !controller.$dateValue || isNaN(controller.$dateValue.getTime()) ? '' : formatDate(controller.$dateValue, options.dateFormat);
	        }
	        scope.$on('$destroy', function() {
	          if (datepicker) datepicker.destroy();
	          options = null;
	          datepicker = null;
	        });
	      }
	    };
	  } ]).provider('datepickerViews', function() {
	    function split(arr, size) {
	      var arrays = [];
	      while (arr.length > 0) {
	        arrays.push(arr.splice(0, size));
	      }
	      return arrays;
	    }
	    function mod(n, m) {
	      return (n % m + m) % m;
	    }
	    this.$get = [ '$dateFormatter', '$dateParser', '$sce', function($dateFormatter, $dateParser, $sce) {
	      return function(picker) {
	        var scope = picker.$scope;
	        var options = picker.$options;
	        var lang = options.lang;
	        var formatDate = function(date, format) {
	          return $dateFormatter.formatDate(date, format, lang);
	        };
	        var dateParser = $dateParser({
	          format: options.dateFormat,
	          lang: lang,
	          strict: options.strictFormat
	        });
	        var weekDaysMin = $dateFormatter.weekdaysShort(lang);
	        var weekDaysLabels = weekDaysMin.slice(options.startWeek).concat(weekDaysMin.slice(0, options.startWeek));
	        var weekDaysLabelsHtml = $sce.trustAsHtml('<th class="dow text-center">' + weekDaysLabels.join('</th><th class="dow text-center">') + '</th>');
	        var startDate = picker.$date || (options.startDate ? dateParser.getDateForAttribute('startDate', options.startDate) : new Date());
	        var viewDate = {
	          year: startDate.getFullYear(),
	          month: startDate.getMonth(),
	          date: startDate.getDate()
	        };
	        var views = [ {
	          format: options.dayFormat,
	          split: 7,
	          steps: {
	            month: 1
	          },
	          update: function(date, force) {
	            if (!this.built || force || date.getFullYear() !== viewDate.year || date.getMonth() !== viewDate.month) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$build();
	            } else if (date.getDate() !== viewDate.date || date.getDate() === 1) {
	              viewDate.date = picker.$date.getDate();
	              picker.$updateSelected();
	            }
	          },
	          build: function() {
	            var firstDayOfMonth = new Date(viewDate.year, viewDate.month, 1);
	            var firstDayOfMonthOffset = firstDayOfMonth.getTimezoneOffset();
	            var firstDate = new Date(+firstDayOfMonth - mod(firstDayOfMonth.getDay() - options.startWeek, 7) * 864e5);
	            var firstDateOffset = firstDate.getTimezoneOffset();
	            var today = dateParser.timezoneOffsetAdjust(new Date(), options.timezone).toDateString();
	            if (firstDateOffset !== firstDayOfMonthOffset) firstDate = new Date(+firstDate + (firstDateOffset - firstDayOfMonthOffset) * 6e4);
	            var days = [];
	            var day;
	            for (var i = 0; i < 42; i++) {
	              day = dateParser.daylightSavingAdjust(new Date(firstDate.getFullYear(), firstDate.getMonth(), firstDate.getDate() + i));
	              days.push({
	                date: day,
	                isToday: day.toDateString() === today,
	                label: formatDate(day, this.format),
	                selected: picker.$date && this.isSelected(day),
	                muted: day.getMonth() !== viewDate.month,
	                disabled: this.isDisabled(day)
	              });
	            }
	            scope.title = formatDate(firstDayOfMonth, options.monthTitleFormat);
	            scope.showLabels = true;
	            scope.labels = weekDaysLabelsHtml;
	            scope.rows = split(days, this.split);
	            scope.isTodayDisabled = this.isDisabled(new Date());
	            this.built = true;
	          },
	          isSelected: function(date) {
	            return picker.$date && date.getFullYear() === picker.$date.getFullYear() && date.getMonth() === picker.$date.getMonth() && date.getDate() === picker.$date.getDate();
	          },
	          isDisabled: function(date) {
	            var time = date.getTime();
	            if (time < options.minDate || time > options.maxDate) return true;
	            if (options.daysOfWeekDisabled.indexOf(date.getDay()) !== -1) return true;
	            if (options.disabledDateRanges) {
	              for (var i = 0; i < options.disabledDateRanges.length; i++) {
	                if (time >= options.disabledDateRanges[i].start && time <= options.disabledDateRanges[i].end) {
	                  return true;
	                }
	              }
	            }
	            return false;
	          },
	          onKeyDown: function(evt) {
	            if (!picker.$date) {
	              return;
	            }
	            var actualTime = picker.$date.getTime();
	            var newDate;
	            if (evt.keyCode === 37) newDate = new Date(actualTime - 1 * 864e5); else if (evt.keyCode === 38) newDate = new Date(actualTime - 7 * 864e5); else if (evt.keyCode === 39) newDate = new Date(actualTime + 1 * 864e5); else if (evt.keyCode === 40) newDate = new Date(actualTime + 7 * 864e5);
	            if (!this.isDisabled(newDate)) picker.select(newDate, true);
	          }
	        }, {
	          name: 'month',
	          format: options.monthFormat,
	          split: 4,
	          steps: {
	            year: 1
	          },
	          update: function(date, force) {
	            if (!this.built || date.getFullYear() !== viewDate.year) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$build();
	            } else if (date.getMonth() !== viewDate.month) {
	              angular.extend(viewDate, {
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$updateSelected();
	            }
	          },
	          build: function() {
	            var months = [];
	            var month;
	            for (var i = 0; i < 12; i++) {
	              month = new Date(viewDate.year, i, 1);
	              months.push({
	                date: month,
	                label: formatDate(month, this.format),
	                selected: picker.$isSelected(month),
	                disabled: this.isDisabled(month)
	              });
	            }
	            scope.title = formatDate(month, options.yearTitleFormat);
	            scope.showLabels = false;
	            scope.rows = split(months, this.split);
	            this.built = true;
	          },
	          isSelected: function(date) {
	            return picker.$date && date.getFullYear() === picker.$date.getFullYear() && date.getMonth() === picker.$date.getMonth();
	          },
	          isDisabled: function(date) {
	            var lastDate = +new Date(date.getFullYear(), date.getMonth() + 1, 0);
	            return lastDate < options.minDate || date.getTime() > options.maxDate;
	          },
	          onKeyDown: function(evt) {
	            if (!picker.$date) {
	              return;
	            }
	            var actualMonth = picker.$date.getMonth();
	            var newDate = new Date(picker.$date);
	            if (evt.keyCode === 37) newDate.setMonth(actualMonth - 1); else if (evt.keyCode === 38) newDate.setMonth(actualMonth - 4); else if (evt.keyCode === 39) newDate.setMonth(actualMonth + 1); else if (evt.keyCode === 40) newDate.setMonth(actualMonth + 4);
	            if (!this.isDisabled(newDate)) picker.select(newDate, true);
	          }
	        }, {
	          name: 'year',
	          format: options.yearFormat,
	          split: 4,
	          steps: {
	            year: 12
	          },
	          update: function(date, force) {
	            if (!this.built || force || parseInt(date.getFullYear() / 20, 10) !== parseInt(viewDate.year / 20, 10)) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$build();
	            } else if (date.getFullYear() !== viewDate.year) {
	              angular.extend(viewDate, {
	                year: picker.$date.getFullYear(),
	                month: picker.$date.getMonth(),
	                date: picker.$date.getDate()
	              });
	              picker.$updateSelected();
	            }
	          },
	          build: function() {
	            var firstYear = viewDate.year - viewDate.year % (this.split * 3);
	            var years = [];
	            var year;
	            for (var i = 0; i < 12; i++) {
	              year = new Date(firstYear + i, 0, 1);
	              years.push({
	                date: year,
	                label: formatDate(year, this.format),
	                selected: picker.$isSelected(year),
	                disabled: this.isDisabled(year)
	              });
	            }
	            scope.title = years[0].label + '-' + years[years.length - 1].label;
	            scope.showLabels = false;
	            scope.rows = split(years, this.split);
	            this.built = true;
	          },
	          isSelected: function(date) {
	            return picker.$date && date.getFullYear() === picker.$date.getFullYear();
	          },
	          isDisabled: function(date) {
	            var lastDate = +new Date(date.getFullYear() + 1, 0, 0);
	            return lastDate < options.minDate || date.getTime() > options.maxDate;
	          },
	          onKeyDown: function(evt) {
	            if (!picker.$date) {
	              return;
	            }
	            var actualYear = picker.$date.getFullYear();
	            var newDate = new Date(picker.$date);
	            if (evt.keyCode === 37) newDate.setYear(actualYear - 1); else if (evt.keyCode === 38) newDate.setYear(actualYear - 4); else if (evt.keyCode === 39) newDate.setYear(actualYear + 1); else if (evt.keyCode === 40) newDate.setYear(actualYear + 4);
	            if (!this.isDisabled(newDate)) picker.select(newDate, true);
	          }
	        } ];
	        return {
	          views: options.minView ? Array.prototype.slice.call(views, options.minView) : views,
	          viewDate: viewDate
	        };
	      };
	    } ];
	  });
	  angular.module('mgcrea.ngStrap.collapse', []).provider('$collapse', function() {
	    var defaults = this.defaults = {
	      animation: 'am-collapse',
	      disallowToggle: false,
	      activeClass: 'in',
	      startCollapsed: false,
	      allowMultiple: false
	    };
	    var controller = this.controller = function($scope, $element, $attrs) {
	      var self = this;
	      self.$options = angular.copy(defaults);
	      angular.forEach([ 'animation', 'disallowToggle', 'activeClass', 'startCollapsed', 'allowMultiple' ], function(key) {
	        if (angular.isDefined($attrs[key])) self.$options[key] = $attrs[key];
	      });
	      var falseValueRegExp = /^(false|0|)$/i;
	      angular.forEach([ 'disallowToggle', 'startCollapsed', 'allowMultiple' ], function(key) {
	        if (angular.isDefined($attrs[key]) && falseValueRegExp.test($attrs[key])) {
	          self.$options[key] = false;
	        }
	      });
	      self.$toggles = [];
	      self.$targets = [];
	      self.$viewChangeListeners = [];
	      self.$registerToggle = function(element) {
	        self.$toggles.push(element);
	      };
	      self.$registerTarget = function(element) {
	        self.$targets.push(element);
	      };
	      self.$unregisterToggle = function(element) {
	        var index = self.$toggles.indexOf(element);
	        self.$toggles.splice(index, 1);
	      };
	      self.$unregisterTarget = function(element) {
	        var index = self.$targets.indexOf(element);
	        self.$targets.splice(index, 1);
	        if (self.$options.allowMultiple) {
	          deactivateItem(element);
	        }
	        fixActiveItemIndexes(index);
	        self.$viewChangeListeners.forEach(function(fn) {
	          fn();
	        });
	      };
	      self.$targets.$active = !self.$options.startCollapsed ? [ 0 ] : [];
	      self.$setActive = $scope.$setActive = function(value) {
	        if (angular.isArray(value)) {
	          self.$targets.$active = value;
	        } else if (!self.$options.disallowToggle && isActive(value)) {
	          deactivateItem(value);
	        } else {
	          activateItem(value);
	        }
	        self.$viewChangeListeners.forEach(function(fn) {
	          fn();
	        });
	      };
	      self.$activeIndexes = function() {
	        if (self.$options.allowMultiple) {
	          return self.$targets.$active;
	        }
	        return self.$targets.$active.length === 1 ? self.$targets.$active[0] : -1;
	      };
	      function fixActiveItemIndexes(index) {
	        var activeIndexes = self.$targets.$active;
	        for (var i = 0; i < activeIndexes.length; i++) {
	          if (index < activeIndexes[i]) {
	            activeIndexes[i] = activeIndexes[i] - 1;
	          }
	          if (activeIndexes[i] === self.$targets.length) {
	            activeIndexes[i] = self.$targets.length - 1;
	          }
	        }
	      }
	      function isActive(value) {
	        var activeItems = self.$targets.$active;
	        return activeItems.indexOf(value) !== -1;
	      }
	      function deactivateItem(value) {
	        var index = self.$targets.$active.indexOf(value);
	        if (index !== -1) {
	          self.$targets.$active.splice(index, 1);
	        }
	      }
	      function activateItem(value) {
	        if (!self.$options.allowMultiple) {
	          self.$targets.$active.splice(0, 1);
	        }
	        if (self.$targets.$active.indexOf(value) === -1) {
	          self.$targets.$active.push(value);
	        }
	      }
	    };
	    this.$get = function() {
	      var $collapse = {};
	      $collapse.defaults = defaults;
	      $collapse.controller = controller;
	      return $collapse;
	    };
	  }).directive('bsCollapse', [ '$window', '$animate', '$collapse', function($window, $animate, $collapse) {
	    return {
	      require: [ '?ngModel', 'bsCollapse' ],
	      controller: [ '$scope', '$element', '$attrs', $collapse.controller ],
	      link: function postLink(scope, element, attrs, controllers) {
	        var ngModelCtrl = controllers[0];
	        var bsCollapseCtrl = controllers[1];
	        if (ngModelCtrl) {
	          bsCollapseCtrl.$viewChangeListeners.push(function() {
	            ngModelCtrl.$setViewValue(bsCollapseCtrl.$activeIndexes());
	          });
	          ngModelCtrl.$formatters.push(function(modelValue) {
	            if (angular.isArray(modelValue)) {
	              bsCollapseCtrl.$setActive(modelValue);
	            } else {
	              var activeIndexes = bsCollapseCtrl.$activeIndexes();
	              if (angular.isArray(activeIndexes)) {
	                if (activeIndexes.indexOf(modelValue * 1) === -1) {
	                  bsCollapseCtrl.$setActive(modelValue * 1);
	                }
	              } else if (activeIndexes !== modelValue * 1) {
	                bsCollapseCtrl.$setActive(modelValue * 1);
	              }
	            }
	            return modelValue;
	          });
	        }
	      }
	    };
	  } ]).directive('bsCollapseToggle', function() {
	    return {
	      require: [ '^?ngModel', '^bsCollapse' ],
	      link: function postLink(scope, element, attrs, controllers) {
	        var bsCollapseCtrl = controllers[1];
	        element.attr('data-toggle', 'collapse');
	        bsCollapseCtrl.$registerToggle(element);
	        scope.$on('$destroy', function() {
	          bsCollapseCtrl.$unregisterToggle(element);
	        });
	        element.on('click', function() {
	          if (!attrs.disabled) {
	            var index = attrs.bsCollapseToggle && attrs.bsCollapseToggle !== 'bs-collapse-toggle' ? attrs.bsCollapseToggle : bsCollapseCtrl.$toggles.indexOf(element);
	            bsCollapseCtrl.$setActive(index * 1);
	            scope.$apply();
	          }
	        });
	      }
	    };
	  }).directive('bsCollapseTarget', [ '$animate', function($animate) {
	    return {
	      require: [ '^?ngModel', '^bsCollapse' ],
	      link: function postLink(scope, element, attrs, controllers) {
	        var bsCollapseCtrl = controllers[1];
	        element.addClass('collapse');
	        if (bsCollapseCtrl.$options.animation) {
	          element.addClass(bsCollapseCtrl.$options.animation);
	        }
	        bsCollapseCtrl.$registerTarget(element);
	        scope.$on('$destroy', function() {
	          bsCollapseCtrl.$unregisterTarget(element);
	        });
	        function render() {
	          var index = bsCollapseCtrl.$targets.indexOf(element);
	          var active = bsCollapseCtrl.$activeIndexes();
	          var action = 'removeClass';
	          if (angular.isArray(active)) {
	            if (active.indexOf(index) !== -1) {
	              action = 'addClass';
	            }
	          } else if (index === active) {
	            action = 'addClass';
	          }
	          $animate[action](element, bsCollapseCtrl.$options.activeClass);
	        }
	        bsCollapseCtrl.$viewChangeListeners.push(function() {
	          render();
	        });
	        render();
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.aside', [ 'mgcrea.ngStrap.modal' ]).provider('$aside', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade-and-slide-right',
	      prefixClass: 'aside',
	      prefixEvent: 'aside',
	      placement: 'right',
	      templateUrl: 'aside/aside.tpl.html',
	      contentTemplate: false,
	      container: false,
	      element: null,
	      backdrop: true,
	      keyboard: true,
	      html: false,
	      show: true
	    };
	    this.$get = [ '$modal', function($modal) {
	      function AsideFactory(config) {
	        var $aside = {};
	        var options = angular.extend({}, defaults, config);
	        $aside = $modal(options);
	        return $aside;
	      }
	      return AsideFactory;
	    } ];
	  }).directive('bsAside', [ '$window', '$sce', '$aside', function($window, $sce, $aside) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var options = {
	          scope: scope,
	          element: element,
	          show: false
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'contentTemplate', 'placement', 'backdrop', 'keyboard', 'html', 'container', 'animation' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'backdrop', 'keyboard', 'html', 'container' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        angular.forEach([ 'title', 'content' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	            });
	          }
	        });
	        if (attr.bsAside) {
	          scope.$watch(attr.bsAside, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	          }, true);
	        }
	        var aside = $aside(options);
	        element.on(attr.trigger || 'click', aside.toggle);
	        scope.$on('$destroy', function() {
	          if (aside) aside.destroy();
	          options = null;
	          aside = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.alert', [ 'mgcrea.ngStrap.modal' ]).provider('$alert', function() {
	    var defaults = this.defaults = {
	      animation: 'am-fade',
	      prefixClass: 'alert',
	      prefixEvent: 'alert',
	      placement: null,
	      templateUrl: 'alert/alert.tpl.html',
	      container: false,
	      element: null,
	      backdrop: false,
	      keyboard: true,
	      show: true,
	      duration: false,
	      type: false,
	      dismissable: true
	    };
	    this.$get = [ '$modal', '$timeout', function($modal, $timeout) {
	      function AlertFactory(config) {
	        var $alert = {};
	        var options = angular.extend({}, defaults, config);
	        $alert = $modal(options);
	        $alert.$scope.dismissable = !!options.dismissable;
	        if (options.type) {
	          $alert.$scope.type = options.type;
	        }
	        var show = $alert.show;
	        if (options.duration) {
	          $alert.show = function() {
	            show();
	            $timeout(function() {
	              $alert.hide();
	            }, options.duration * 1e3);
	          };
	        }
	        return $alert;
	      }
	      return AlertFactory;
	    } ];
	  }).directive('bsAlert', [ '$window', '$sce', '$alert', function($window, $sce, $alert) {
	    return {
	      restrict: 'EAC',
	      scope: true,
	      link: function postLink(scope, element, attr, transclusion) {
	        var options = {
	          scope: scope,
	          element: element,
	          show: false
	        };
	        angular.forEach([ 'template', 'templateUrl', 'controller', 'controllerAs', 'placement', 'keyboard', 'html', 'container', 'animation', 'duration', 'dismissable' ], function(key) {
	          if (angular.isDefined(attr[key])) options[key] = attr[key];
	        });
	        var falseValueRegExp = /^(false|0|)$/i;
	        angular.forEach([ 'keyboard', 'html', 'container', 'dismissable' ], function(key) {
	          if (angular.isDefined(attr[key]) && falseValueRegExp.test(attr[key])) options[key] = false;
	        });
	        angular.forEach([ 'onBeforeShow', 'onShow', 'onBeforeHide', 'onHide' ], function(key) {
	          var bsKey = 'bs' + key.charAt(0).toUpperCase() + key.slice(1);
	          if (angular.isDefined(attr[bsKey])) {
	            options[key] = scope.$eval(attr[bsKey]);
	          }
	        });
	        if (!scope.hasOwnProperty('title')) {
	          scope.title = '';
	        }
	        angular.forEach([ 'title', 'content', 'type' ], function(key) {
	          if (attr[key]) {
	            attr.$observe(key, function(newValue, oldValue) {
	              scope[key] = $sce.trustAsHtml(newValue);
	            });
	          }
	        });
	        if (attr.bsAlert) {
	          scope.$watch(attr.bsAlert, function(newValue, oldValue) {
	            if (angular.isObject(newValue)) {
	              angular.extend(scope, newValue);
	            } else {
	              scope.content = newValue;
	            }
	          }, true);
	        }
	        var alert = $alert(options);
	        element.on(attr.trigger || 'click', alert.toggle);
	        scope.$on('$destroy', function() {
	          if (alert) alert.destroy();
	          options = null;
	          alert = null;
	        });
	      }
	    };
	  } ]);
	  angular.module('mgcrea.ngStrap.affix', [ 'mgcrea.ngStrap.helpers.dimensions', 'mgcrea.ngStrap.helpers.debounce' ]).provider('$affix', function() {
	    var defaults = this.defaults = {
	      offsetTop: 'auto',
	      inlineStyles: true,
	      setWidth: true
	    };
	    this.$get = [ '$window', 'debounce', 'dimensions', function($window, debounce, dimensions) {
	      var bodyEl = angular.element($window.document.body);
	      var windowEl = angular.element($window);
	      function AffixFactory(element, config) {
	        var $affix = {};
	        var options = angular.extend({}, defaults, config);
	        var targetEl = options.target;
	        var reset = 'affix affix-top affix-bottom';
	        var setWidth = false;
	        var initialAffixTop = 0;
	        var initialOffsetTop = 0;
	        var offsetTop = 0;
	        var offsetBottom = 0;
	        var affixed = null;
	        var unpin = null;
	        var parent = element.parent();
	        if (options.offsetParent) {
	          if (options.offsetParent.match(/^\d+$/)) {
	            for (var i = 0; i < options.offsetParent * 1 - 1; i++) {
	              parent = parent.parent();
	            }
	          } else {
	            parent = angular.element(options.offsetParent);
	          }
	        }
	        $affix.init = function() {
	          this.$parseOffsets();
	          initialOffsetTop = dimensions.offset(element[0]).top + initialAffixTop;
	          setWidth = options.setWidth && !element[0].style.width;
	          targetEl.on('scroll', this.checkPosition);
	          targetEl.on('click', this.checkPositionWithEventLoop);
	          windowEl.on('resize', this.$debouncedOnResize);
	          this.checkPosition();
	          this.checkPositionWithEventLoop();
	        };
	        $affix.destroy = function() {
	          targetEl.off('scroll', this.checkPosition);
	          targetEl.off('click', this.checkPositionWithEventLoop);
	          windowEl.off('resize', this.$debouncedOnResize);
	        };
	        $affix.checkPositionWithEventLoop = function() {
	          setTimeout($affix.checkPosition, 1);
	        };
	        $affix.checkPosition = function() {
	          var scrollTop = getScrollTop();
	          var position = dimensions.offset(element[0]);
	          var elementHeight = dimensions.height(element[0]);
	          var affix = getRequiredAffixClass(unpin, position, elementHeight);
	          if (affixed === affix) return;
	          affixed = affix;
	          if (affix === 'top') {
	            unpin = null;
	            if (setWidth) {
	              element.css('width', '');
	            }
	            if (options.inlineStyles) {
	              element.css('position', options.offsetParent ? '' : 'relative');
	              element.css('top', '');
	            }
	          } else if (affix === 'bottom') {
	            if (options.offsetUnpin) {
	              unpin = -(options.offsetUnpin * 1);
	            } else {
	              unpin = position.top - scrollTop;
	            }
	            if (setWidth) {
	              element.css('width', '');
	            }
	            if (options.inlineStyles) {
	              element.css('position', options.offsetParent ? '' : 'relative');
	              element.css('top', options.offsetParent ? '' : bodyEl[0].offsetHeight - offsetBottom - elementHeight - initialOffsetTop + 'px');
	            }
	          } else {
	            unpin = null;
	            if (setWidth) {
	              element.css('width', element[0].offsetWidth + 'px');
	            }
	            if (options.inlineStyles) {
	              element.css('position', 'fixed');
	              element.css('top', initialAffixTop + 'px');
	            }
	          }
	          element.removeClass(reset).addClass('affix' + (affix !== 'middle' ? '-' + affix : ''));
	        };
	        $affix.$onResize = function() {
	          $affix.$parseOffsets();
	          $affix.checkPosition();
	        };
	        $affix.$debouncedOnResize = debounce($affix.$onResize, 50);
	        $affix.$parseOffsets = function() {
	          var initialPosition = element[0].style.position;
	          var initialTop = element[0].style.top;
	          if (options.inlineStyles) {
	            element.css('position', options.offsetParent ? '' : 'relative');
	            element.css('top', '');
	          }
	          if (options.offsetTop) {
	            if (options.offsetTop === 'auto') {
	              options.offsetTop = '+0';
	            }
	            if (options.offsetTop.match(/^[-+]\d+$/)) {
	              initialAffixTop = -options.offsetTop * 1;
	              if (options.offsetParent) {
	                offsetTop = dimensions.offset(parent[0]).top + options.offsetTop * 1;
	              } else {
	                offsetTop = dimensions.offset(element[0]).top - dimensions.css(element[0], 'marginTop', true) + options.offsetTop * 1;
	              }
	            } else {
	              offsetTop = options.offsetTop * 1;
	            }
	          }
	          if (options.offsetBottom) {
	            if (options.offsetParent && options.offsetBottom.match(/^[-+]\d+$/)) {
	              offsetBottom = getScrollHeight() - (dimensions.offset(parent[0]).top + dimensions.height(parent[0])) + options.offsetBottom * 1 + 1;
	            } else {
	              offsetBottom = options.offsetBottom * 1;
	            }
	          }
	          if (options.inlineStyles) {
	            element.css('position', initialPosition);
	            element.css('top', initialTop);
	          }
	        };
	        function getRequiredAffixClass(_unpin, position, elementHeight) {
	          var scrollTop = getScrollTop();
	          var scrollHeight = getScrollHeight();
	          if (scrollTop <= offsetTop) {
	            return 'top';
	          } else if (_unpin !== null) {
	            return scrollTop + _unpin <= position.top ? 'middle' : 'bottom';
	          } else if (offsetBottom !== null && position.top + elementHeight + initialAffixTop >= scrollHeight - offsetBottom) {
	            return 'bottom';
	          }
	          return 'middle';
	        }
	        function getScrollTop() {
	          return targetEl[0] === $window ? $window.pageYOffset : targetEl[0].scrollTop;
	        }
	        function getScrollHeight() {
	          return targetEl[0] === $window ? $window.document.body.scrollHeight : targetEl[0].scrollHeight;
	        }
	        $affix.init();
	        return $affix;
	      }
	      return AffixFactory;
	    } ];
	  }).directive('bsAffix', [ '$affix', '$window', '$timeout', function($affix, $window, $timeout) {
	    return {
	      restrict: 'EAC',
	      require: '^?bsAffixTarget',
	      link: function postLink(scope, element, attr, affixTarget) {
	        var options = {
	          scope: scope,
	          target: affixTarget ? affixTarget.$element : angular.element($window)
	        };
	        angular.forEach([ 'offsetTop', 'offsetBottom', 'offsetParent', 'offsetUnpin', 'inlineStyles', 'setWidth' ], function(key) {
	          if (angular.isDefined(attr[key])) {
	            var option = attr[key];
	            if (/true/i.test(option)) option = true;
	            if (/false/i.test(option)) option = false;
	            options[key] = option;
	          }
	        });
	        var affix;
	        $timeout(function() {
	          affix = $affix(element, options);
	        });
	        scope.$on('$destroy', function() {
	          if (affix) affix.destroy();
	          options = null;
	          affix = null;
	        });
	      }
	    };
	  } ]).directive('bsAffixTarget', function() {
	    return {
	      controller: [ '$element', function($element) {
	        this.$element = $element;
	      } ]
	    };
	  });
	  angular.module('mgcrea.ngStrap', [ 'mgcrea.ngStrap.modal', 'mgcrea.ngStrap.aside', 'mgcrea.ngStrap.alert', 'mgcrea.ngStrap.button', 'mgcrea.ngStrap.select', 'mgcrea.ngStrap.datepicker', 'mgcrea.ngStrap.timepicker', 'mgcrea.ngStrap.navbar', 'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.popover', 'mgcrea.ngStrap.dropdown', 'mgcrea.ngStrap.typeahead', 'mgcrea.ngStrap.scrollspy', 'mgcrea.ngStrap.affix', 'mgcrea.ngStrap.tab', 'mgcrea.ngStrap.collapse' ]);
	})(window, document);

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	/**
	 * angular-strap
	 * @version v2.3.12 - 2017-01-26
	 * @link http://mgcrea.github.io/angular-strap
	 * @author Olivier Louvignes <olivier@mg-crea.com> (https://github.com/mgcrea)
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	!function(t,e,n){'use strict';angular.module('mgcrea.ngStrap.alert').run(['$templateCache',function(t){t.put('alert/alert.tpl.html','<div class="alert" ng-class="[type ? \'alert-\' + type : null]"><button type="button" class="close" ng-if="dismissable" ng-click="$hide()">&times;</button> <span ng-if="title"><strong ng-bind="title"></strong>&nbsp;<span ng-bind-html="content"></span> </span><span ng-if="!title" ng-bind-html="content"></span></div>')}]),angular.module('mgcrea.ngStrap.aside').run(['$templateCache',function(t){t.put('aside/aside.tpl.html','<div class="aside" tabindex="-1" role="dialog"><div class="aside-dialog"><div class="aside-content"><div class="aside-header" ng-show="title"><button type="button" class="close" ng-click="$hide()">&times;</button><h4 class="aside-title" ng-bind="title"></h4></div><div class="aside-body" ng-bind="content"></div><div class="aside-footer"><button type="button" class="btn btn-default" ng-click="$hide()">Close</button></div></div></div></div>')}]),angular.module('mgcrea.ngStrap.datepicker').run(['$templateCache',function(t){t.put('datepicker/datepicker.tpl.html','<div class="dropdown-menu datepicker" ng-class="\'datepicker-mode-\' + $mode" style="max-width: 320px"><table style="table-layout: fixed; height: 100%; width: 100%"><thead><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$selectPane(-1)"><i class="{{$iconLeft}}"></i></button></th><th colspan="{{ rows[0].length - 2 }}"><button tabindex="-1" type="button" class="btn btn-default btn-block text-strong" ng-click="$toggleMode()"><strong style="text-transform: capitalize" ng-bind="title"></strong></button></th><th><button tabindex="-1" type="button" class="btn btn-default pull-right" ng-click="$selectPane(+1)"><i class="{{$iconRight}}"></i></button></th></tr><tr ng-if="showLabels" ng-bind-html="labels"></tr></thead><tbody><tr ng-repeat="(i, row) in rows" height="{{ 100 / rows.length }}%"><td class="text-center" ng-repeat="(j, el) in row"><button tabindex="-1" type="button" class="btn btn-default" style="width: 100%" ng-class="{\'btn-primary\': el.selected, \'btn-info btn-today\': el.isToday && !el.selected}" ng-click="$select(el.date, el.disabled)" ng-disabled="el.disabled"><span ng-class="{\'text-muted\': el.muted}" ng-bind="el.label"></span></button></td></tr></tbody><tfoot><tr><td colspan="{{ rows[0].length }}"><div class="btn-group btn-group-justified" role="group"><div class="btn-group" role="group" ng-if="$hasToday"><button type="button" class="btn btn-default today" ng-click="$setToday()" ng-disabled="isTodayDisabled"><strong style="text-transform: capitalize">Today</strong></button></div><div class="btn-group" role="group" ng-if="$hasClear"><button type="button" class="btn btn-default clear" ng-click="$clear()"><strong style="text-transform: capitalize">Clear</strong></button></div></div></td></tr></tfoot></table></div>')}]),angular.module('mgcrea.ngStrap.dropdown').run(['$templateCache',function(t){t.put('dropdown/dropdown.tpl.html','<ul tabindex="-1" class="dropdown-menu" role="menu" ng-show="content && content.length"><li role="presentation" ng-class="{divider: item.divider, active: item.active}" ng-repeat="item in content"><a role="menuitem" tabindex="-1" ng-href="{{item.href}}" ng-if="!item.divider && item.href" target="{{item.target || \'\'}}" ng-bind="item.text"></a> <a role="menuitem" tabindex="-1" href="javascript:void(0)" ng-if="!item.divider && item.click" ng-click="$eval(item.click);$hide()" ng-bind="item.text"></a></li></ul>')}]),angular.module('mgcrea.ngStrap.modal').run(['$templateCache',function(t){t.put('modal/modal.tpl.html','<div class="modal" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header" ng-show="title"><button type="button" class="close" aria-label="Close" ng-click="$hide()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" ng-bind="title"></h4></div><div class="modal-body" ng-bind="content"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$hide()">Close</button></div></div></div></div>')}]),angular.module('mgcrea.ngStrap.popover').run(['$templateCache',function(t){t.put('popover/popover.tpl.html','<div class="popover" tabindex="-1"><div class="arrow"></div><h3 class="popover-title" ng-bind="title" ng-show="title"></h3><div class="popover-content" ng-bind="content"></div></div>')}]),angular.module('mgcrea.ngStrap.select').run(['$templateCache',function(t){t.put('select/select.tpl.html','<ul tabindex="-1" class="select dropdown-menu" ng-show="$isVisible()" role="select"><li ng-if="$showAllNoneButtons"><div class="btn-group" style="margin-bottom: 5px; margin-left: 5px"><button type="button" class="btn btn-default btn-xs" ng-click="$selectAll()">{{$allText}}</button> <button type="button" class="btn btn-default btn-xs" ng-click="$selectNone()">{{$noneText}}</button></div></li><li role="presentation" ng-repeat="match in $matches" ng-class="{active: $isActive($index)}"><a style="cursor: default" role="menuitem" tabindex="-1" ng-click="$select($index, $event)"><i class="{{$iconCheckmark}} pull-right" ng-if="$isMultiple && $isActive($index)"></i> <span ng-bind="match.label"></span></a></li></ul>')}]),angular.module('mgcrea.ngStrap.tab').run(['$templateCache',function(t){t.put('tab/tab.tpl.html','<ul class="nav" ng-class="$navClass" role="tablist"><li role="presentation" ng-repeat="$pane in $panes track by $index" ng-class="[ $isActive($pane, $index) ? $activeClass : \'\', $pane.disabled ? \'disabled\' : \'\' ]"><a role="tab" data-toggle="tab" ng-click="!$pane.disabled && $setActive($pane.name || $index)" data-index="{{ $index }}" ng-bind-html="$pane.title" aria-controls="$pane.title" href=""></a></li></ul><div ng-transclude class="tab-content"></div>')}]),angular.module('mgcrea.ngStrap.timepicker').run(['$templateCache',function(t){t.put('timepicker/timepicker.tpl.html','<div class="dropdown-menu timepicker" style="min-width: 0px;width: auto"><table height="100%"><thead><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 0)"><i class="{{ $iconUp }}"></i></button></th><th>&nbsp;</th><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 1)"><i class="{{ $iconUp }}"></i></button></th><th ng-if="showSeconds">&nbsp;</th><th ng-if="showSeconds"><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 2)"><i class="{{ $iconUp }}"></i></button></th></tr></thead><tbody><tr ng-repeat="(i, row) in rows"><td class="text-center"><button tabindex="-1" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[0].selected}" ng-click="$select(row[0].date, 0)" ng-disabled="row[0].disabled"><span ng-class="{\'text-muted\': row[0].muted}" ng-bind="row[0].label"></span></button></td><td><span ng-bind="i == midIndex ? timeSeparator : \' \'"></span></td><td class="text-center"><button tabindex="-1" ng-if="row[1].date" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[1].selected}" ng-click="$select(row[1].date, 1)" ng-disabled="row[1].disabled"><span ng-class="{\'text-muted\': row[1].muted}" ng-bind="row[1].label"></span></button></td><td ng-if="showSeconds"><span ng-bind="i == midIndex ? timeSeparator : \' \'"></span></td><td ng-if="showSeconds" class="text-center"><button tabindex="-1" ng-if="row[2].date" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[2].selected}" ng-click="$select(row[2].date, 2)" ng-disabled="row[2].disabled"><span ng-class="{\'text-muted\': row[2].muted}" ng-bind="row[2].label"></span></button></td><td ng-if="showAM">&nbsp;</td><td ng-if="showAM"><button tabindex="-1" ng-show="i == midIndex - !isAM * 1" style="width: 100%" type="button" ng-class="{\'btn-primary\': !!isAM}" class="btn btn-default" ng-click="$switchMeridian()" ng-disabled="el.disabled">AM</button> <button tabindex="-1" ng-show="i == midIndex + 1 - !isAM * 1" style="width: 100%" type="button" ng-class="{\'btn-primary\': !isAM}" class="btn btn-default" ng-click="$switchMeridian()" ng-disabled="el.disabled">PM</button></td></tr></tbody><tfoot><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 0)"><i class="{{ $iconDown }}"></i></button></th><th>&nbsp;</th><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 1)"><i class="{{ $iconDown }}"></i></button></th><th ng-if="showSeconds">&nbsp;</th><th ng-if="showSeconds"><button ng-if="showSeconds" tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 2)"><i class="{{ $iconDown }}"></i></button></th></tr></tfoot></table></div>')}]),angular.module('mgcrea.ngStrap.tooltip').run(['$templateCache',function(t){t.put('tooltip/tooltip.tpl.html','<div class="tooltip in" ng-show="title"><div class="tooltip-arrow"></div><div class="tooltip-inner" ng-bind="title"></div></div>')}]),angular.module('mgcrea.ngStrap.typeahead').run(['$templateCache',function(t){t.put('typeahead/typeahead.tpl.html','<ul tabindex="-1" class="typeahead dropdown-menu" ng-show="$isVisible()" role="select"><li role="presentation" ng-repeat="match in $matches" ng-class="{active: $index == $activeIndex}"><a role="menuitem" tabindex="-1" ng-click="$select($index, $event)" ng-bind="match.label"></a></li></ul>')}])}(window,document);

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	/**
	 * angular-strap
	 * @version v2.3.12 - 2017-01-26
	 * @link http://mgcrea.github.io/angular-strap
	 * @author Olivier Louvignes <olivier@mg-crea.com> (https://github.com/mgcrea)
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, document, undefined) {
	  'use strict';
	  angular.module('mgcrea.ngStrap.alert').run([ '$templateCache', function($templateCache) {
	    $templateCache.put('alert/alert.tpl.html', '<div class="alert" ng-class="[type ? \'alert-\' + type : null]"><button type="button" class="close" ng-if="dismissable" ng-click="$hide()">&times;</button> <span ng-if="title"><strong ng-bind="title"></strong>&nbsp;<span ng-bind-html="content"></span> </span><span ng-if="!title" ng-bind-html="content"></span></div>');
	  } ]);
	  angular.module('mgcrea.ngStrap.aside').run([ '$templateCache', function($templateCache) {
	    $templateCache.put('aside/aside.tpl.html', '<div class="aside" tabindex="-1" role="dialog"><div class="aside-dialog"><div class="aside-content"><div class="aside-header" ng-show="title"><button type="button" class="close" ng-click="$hide()">&times;</button><h4 class="aside-title" ng-bind="title"></h4></div><div class="aside-body" ng-bind="content"></div><div class="aside-footer"><button type="button" class="btn btn-default" ng-click="$hide()">Close</button></div></div></div></div>');
	  } ]);
	  angular.module('mgcrea.ngStrap.datepicker').run([ '$templateCache', function($templateCache) {
	    $templateCache.put('datepicker/datepicker.tpl.html', '<div class="dropdown-menu datepicker" ng-class="\'datepicker-mode-\' + $mode" style="max-width: 320px"><table style="table-layout: fixed; height: 100%; width: 100%"><thead><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$selectPane(-1)"><i class="{{$iconLeft}}"></i></button></th><th colspan="{{ rows[0].length - 2 }}"><button tabindex="-1" type="button" class="btn btn-default btn-block text-strong" ng-click="$toggleMode()"><strong style="text-transform: capitalize" ng-bind="title"></strong></button></th><th><button tabindex="-1" type="button" class="btn btn-default pull-right" ng-click="$selectPane(+1)"><i class="{{$iconRight}}"></i></button></th></tr><tr ng-if="showLabels" ng-bind-html="labels"></tr></thead><tbody><tr ng-repeat="(i, row) in rows" height="{{ 100 / rows.length }}%"><td class="text-center" ng-repeat="(j, el) in row"><button tabindex="-1" type="button" class="btn btn-default" style="width: 100%" ng-class="{\'btn-primary\': el.selected, \'btn-info btn-today\': el.isToday && !el.selected}" ng-click="$select(el.date, el.disabled)" ng-disabled="el.disabled"><span ng-class="{\'text-muted\': el.muted}" ng-bind="el.label"></span></button></td></tr></tbody><tfoot><tr><td colspan="{{ rows[0].length }}"><div class="btn-group btn-group-justified" role="group"><div class="btn-group" role="group" ng-if="$hasToday"><button type="button" class="btn btn-default today" ng-click="$setToday()" ng-disabled="isTodayDisabled"><strong style="text-transform: capitalize">Today</strong></button></div><div class="btn-group" role="group" ng-if="$hasClear"><button type="button" class="btn btn-default clear" ng-click="$clear()"><strong style="text-transform: capitalize">Clear</strong></button></div></div></td></tr></tfoot></table></div>');
	  } ]);
	  angular.module('mgcrea.ngStrap.dropdown').run([ '$templateCache', function($templateCache) {
	    $templateCache.put('dropdown/dropdown.tpl.html', '<ul tabindex="-1" class="dropdown-menu" role="menu" ng-show="content && content.length"><li role="presentation" ng-class="{divider: item.divider, active: item.active}" ng-repeat="item in content"><a role="menuitem" tabindex="-1" ng-href="{{item.href}}" ng-if="!item.divider && item.href" target="{{item.target || \'\'}}" ng-bind="item.text"></a> <a role="menuitem" tabindex="-1" href="javascript:void(0)" ng-if="!item.divider && item.click" ng-click="$eval(item.click);$hide()" ng-bind="item.text"></a></li></ul>');
	  } ]);
	  angular.module('mgcrea.ngStrap.modal').run([ '$templateCache', function($templateCache) {
	    $templateCache.put('modal/modal.tpl.html', '<div class="modal" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="modal-header" ng-show="title"><button type="button" class="close" aria-label="Close" ng-click="$hide()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" ng-bind="title"></h4></div><div class="modal-body" ng-bind="content"></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="$hide()">Close</button></div></div></div></div>');
	  } ]);
	  angular.module('mgcrea.ngStrap.popover').run([ '$templateCache', function($templateCache) {
	    $templateCache.put('popover/popover.tpl.html', '<div class="popover" tabindex="-1"><div class="arrow"></div><h3 class="popover-title" ng-bind="title" ng-show="title"></h3><div class="popover-content" ng-bind="content"></div></div>');
	  } ]);
	  angular.module('mgcrea.ngStrap.select').run([ '$templateCache', function($templateCache) {
	    $templateCache.put('select/select.tpl.html', '<ul tabindex="-1" class="select dropdown-menu" ng-show="$isVisible()" role="select"><li ng-if="$showAllNoneButtons"><div class="btn-group" style="margin-bottom: 5px; margin-left: 5px"><button type="button" class="btn btn-default btn-xs" ng-click="$selectAll()">{{$allText}}</button> <button type="button" class="btn btn-default btn-xs" ng-click="$selectNone()">{{$noneText}}</button></div></li><li role="presentation" ng-repeat="match in $matches" ng-class="{active: $isActive($index)}"><a style="cursor: default" role="menuitem" tabindex="-1" ng-click="$select($index, $event)"><i class="{{$iconCheckmark}} pull-right" ng-if="$isMultiple && $isActive($index)"></i> <span ng-bind="match.label"></span></a></li></ul>');
	  } ]);
	  angular.module('mgcrea.ngStrap.tab').run([ '$templateCache', function($templateCache) {
	    $templateCache.put('tab/tab.tpl.html', '<ul class="nav" ng-class="$navClass" role="tablist"><li role="presentation" ng-repeat="$pane in $panes track by $index" ng-class="[ $isActive($pane, $index) ? $activeClass : \'\', $pane.disabled ? \'disabled\' : \'\' ]"><a role="tab" data-toggle="tab" ng-click="!$pane.disabled && $setActive($pane.name || $index)" data-index="{{ $index }}" ng-bind-html="$pane.title" aria-controls="$pane.title" href=""></a></li></ul><div ng-transclude class="tab-content"></div>');
	  } ]);
	  angular.module('mgcrea.ngStrap.timepicker').run([ '$templateCache', function($templateCache) {
	    $templateCache.put('timepicker/timepicker.tpl.html', '<div class="dropdown-menu timepicker" style="min-width: 0px;width: auto"><table height="100%"><thead><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 0)"><i class="{{ $iconUp }}"></i></button></th><th>&nbsp;</th><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 1)"><i class="{{ $iconUp }}"></i></button></th><th ng-if="showSeconds">&nbsp;</th><th ng-if="showSeconds"><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(-1, 2)"><i class="{{ $iconUp }}"></i></button></th></tr></thead><tbody><tr ng-repeat="(i, row) in rows"><td class="text-center"><button tabindex="-1" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[0].selected}" ng-click="$select(row[0].date, 0)" ng-disabled="row[0].disabled"><span ng-class="{\'text-muted\': row[0].muted}" ng-bind="row[0].label"></span></button></td><td><span ng-bind="i == midIndex ? timeSeparator : \' \'"></span></td><td class="text-center"><button tabindex="-1" ng-if="row[1].date" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[1].selected}" ng-click="$select(row[1].date, 1)" ng-disabled="row[1].disabled"><span ng-class="{\'text-muted\': row[1].muted}" ng-bind="row[1].label"></span></button></td><td ng-if="showSeconds"><span ng-bind="i == midIndex ? timeSeparator : \' \'"></span></td><td ng-if="showSeconds" class="text-center"><button tabindex="-1" ng-if="row[2].date" style="width: 100%" type="button" class="btn btn-default" ng-class="{\'btn-primary\': row[2].selected}" ng-click="$select(row[2].date, 2)" ng-disabled="row[2].disabled"><span ng-class="{\'text-muted\': row[2].muted}" ng-bind="row[2].label"></span></button></td><td ng-if="showAM">&nbsp;</td><td ng-if="showAM"><button tabindex="-1" ng-show="i == midIndex - !isAM * 1" style="width: 100%" type="button" ng-class="{\'btn-primary\': !!isAM}" class="btn btn-default" ng-click="$switchMeridian()" ng-disabled="el.disabled">AM</button> <button tabindex="-1" ng-show="i == midIndex + 1 - !isAM * 1" style="width: 100%" type="button" ng-class="{\'btn-primary\': !isAM}" class="btn btn-default" ng-click="$switchMeridian()" ng-disabled="el.disabled">PM</button></td></tr></tbody><tfoot><tr class="text-center"><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 0)"><i class="{{ $iconDown }}"></i></button></th><th>&nbsp;</th><th><button tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 1)"><i class="{{ $iconDown }}"></i></button></th><th ng-if="showSeconds">&nbsp;</th><th ng-if="showSeconds"><button ng-if="showSeconds" tabindex="-1" type="button" class="btn btn-default pull-left" ng-click="$arrowAction(1, 2)"><i class="{{ $iconDown }}"></i></button></th></tr></tfoot></table></div>');
	  } ]);
	  angular.module('mgcrea.ngStrap.tooltip').run([ '$templateCache', function($templateCache) {
	    $templateCache.put('tooltip/tooltip.tpl.html', '<div class="tooltip in" ng-show="title"><div class="tooltip-arrow"></div><div class="tooltip-inner" ng-bind="title"></div></div>');
	  } ]);
	  angular.module('mgcrea.ngStrap.typeahead').run([ '$templateCache', function($templateCache) {
	    $templateCache.put('typeahead/typeahead.tpl.html', '<ul tabindex="-1" class="typeahead dropdown-menu" ng-show="$isVisible()" role="select"><li role="presentation" ng-repeat="match in $matches" ng-class="{active: $index == $activeIndex}"><a role="menuitem" tabindex="-1" ng-click="$select($index, $event)" ng-bind="match.label"></a></li></ul>');
	  } ]);
	})(window, document);

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(371);
	module.exports = 'ngCookies';


/***/ }),
/* 371 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  info({ angularVersion: '1.8.3' }).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [/** @this */function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     * - **samesite** - `{string}` - prevents the browser from sending the cookie along with cross-site requests.
	     *   Accepts the values `lax` and `strict`. See the [OWASP Wiki](https://www.owasp.org/index.php/SameSite)
	     *   for more info. Note that as of May 2018, not all browsers support `SameSite`,
	     *   so it cannot be used as a single measure against Cross-Site-Request-Forgery (CSRF) attacks.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesProviderExample', ['ngCookies'])
	     *   .config(['$cookiesProvider', function($cookiesProvider) {
	     *     // Setting default options
	     *     $cookiesProvider.defaults.domain = 'foo.com';
	     *     $cookiesProvider.defaults.secure = true;
	     *   }]);
	     * ```
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	    str += options.samesite ? ';samesite=' + options.samesite : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn('Cookie \'' + name +
	        '\' possibly not set or overflowed because it was too large (' +
	        cookieLength + ' > 4096 bytes)!');
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', /** @this */ function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(373);
	module.exports = 'ngRoute';


/***/ }),
/* 373 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.8.3
	 * (c) 2010-2020 Google LLC. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* global routeToRegExp: true */
	
	/**
	 * @param {string} path - The path to parse. (It is assumed to have query and hash stripped off.)
	 * @param {Object} opts - Options.
	 * @return {Object} - An object containing an array of path parameter names (`keys`) and a regular
	 *     expression (`regexp`) that can be used to identify a matching URL and extract the path
	 *     parameter values.
	 *
	 * @description
	 * Parses the given path, extracting path parameter names and a regular expression to match URLs.
	 *
	 * Originally inspired by `pathRexp` in `visionmedia/express/lib/utils.js`.
	 */
	function routeToRegExp(path, opts) {
	  var keys = [];
	
	  var pattern = path
	    .replace(/([().])/g, '\\$1')
	    .replace(/(\/)?:(\w+)(\*\?|[?*])?/g, function(_, slash, key, option) {
	      var optional = option === '?' || option === '*?';
	      var star = option === '*' || option === '*?';
	      keys.push({name: key, optional: optional});
	      slash = slash || '';
	      return (
	        (optional ? '(?:' + slash : slash + '(?:') +
	        (star ? '(.+?)' : '([^/]+)') +
	        (optional ? '?)?' : ')')
	      );
	    })
	    .replace(/([/$*])/g, '\\$1');
	
	  if (opts.ignoreTrailingSlashes) {
	    pattern = pattern.replace(/\/+$/, '') + '/*';
	  }
	
	  return {
	    keys: keys,
	    regexp: new RegExp(
	      '^' + pattern + '(?:[?#]|$)',
	      opts.caseInsensitiveMatch ? 'i' : ''
	    )
	  };
	}
	
	/* global routeToRegExp: false */
	/* global shallowCopy: false */
	
	// `isArray` and `isObject` are necessary for `shallowCopy()` (included via `src/shallowCopy.js`).
	// They are initialized inside the `$RouteProvider`, to ensure `window.angular` is available.
	var isArray;
	var isObject;
	var isDefined;
	var noop;
	
	/**
	 * @ngdoc module
	 * @name ngRoute
	 * @description
	 *
	 * The `ngRoute` module provides routing and deeplinking services and directives for AngularJS apps.
	 *
	 * ## Example
	 * See {@link ngRoute.$route#examples $route} for an example of configuring and using `ngRoute`.
	 *
	 */
	/* global -ngRouteModule */
	var ngRouteModule = angular.
	  module('ngRoute', []).
	  info({ angularVersion: '1.8.3' }).
	  provider('$route', $RouteProvider).
	  // Ensure `$route` will be instantiated in time to capture the initial `$locationChangeSuccess`
	  // event (unless explicitly disabled). This is necessary in case `ngView` is included in an
	  // asynchronously loaded template.
	  run(instantiateRoute);
	var $routeMinErr = angular.$$minErr('ngRoute');
	var isEagerInstantiationEnabled;
	
	
	/**
	 * @ngdoc provider
	 * @name $routeProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring routes.
	 *
	 * ## Example
	 * See {@link ngRoute.$route#examples $route} for an example of configuring and using `ngRoute`.
	 *
	 * ## Dependencies
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 */
	function $RouteProvider() {
	  isArray = angular.isArray;
	  isObject = angular.isObject;
	  isDefined = angular.isDefined;
	  noop = angular.noop;
	
	  function inherit(parent, extra) {
	    return angular.extend(Object.create(parent), extra);
	  }
	
	  var routes = {};
	
	  /**
	   * @ngdoc method
	   * @name $routeProvider#when
	   *
	   * @param {string} path Route path (matched against `$location.path`). If `$location.path`
	   *    contains redundant trailing slash or is missing one, the route will still match and the
	   *    `$location.path` will be updated to add or drop the trailing slash to exactly match the
	   *    route definition.
	   *
	   *    * `path` can contain named groups starting with a colon: e.g. `:name`. All characters up
	   *        to the next slash are matched and stored in `$routeParams` under the given `name`
	   *        when the route matches.
	   *    * `path` can contain named groups starting with a colon and ending with a star:
	   *        e.g.`:name*`. All characters are eagerly stored in `$routeParams` under the given `name`
	   *        when the route matches.
	   *    * `path` can contain optional named groups with a question mark: e.g.`:name?`.
	   *
	   *    For example, routes like `/color/:color/largecode/:largecode*\/edit` will match
	   *    `/color/brown/largecode/code/with/slashes/edit` and extract:
	   *
	   *    * `color: brown`
	   *    * `largecode: code/with/slashes`.
	   *
	   *
	   * @param {Object} route Mapping information to be assigned to `$route.current` on route
	   *    match.
	   *
	   *    Object properties:
	   *
	   *    - `controller` – `{(string|Function)=}` – Controller fn that should be associated with
	   *      newly created scope or the name of a {@link angular.Module#controller registered
	   *      controller} if passed as a string.
	   *    - `controllerAs` – `{string=}` – An identifier name for a reference to the controller.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *    - `template` – `{(string|Function)=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used by {@link
	   *      ngRoute.directive:ngView ngView} or {@link ng.directive:ngInclude ngInclude} directives.
	   *      This property takes precedence over `templateUrl`.
	   *
	   *      If `template` is a function, it will be called with the following parameters:
	   *
	   *      - `{Array.<Object>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route
	   *
	   *      One of `template` or `templateUrl` is required.
	   *
	   *    - `templateUrl` – `{(string|Function)=}` – path or function that returns a path to an html
	   *      template that should be used by {@link ngRoute.directive:ngView ngView}.
	   *
	   *      If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *      - `{Array.<Object>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route
	   *
	   *      One of `templateUrl` or `template` is required.
	   *
	   *    - `resolve` - `{Object.<string, Function>=}` - An optional map of dependencies which should
	   *      be injected into the controller. If any of these dependencies are promises, the router
	   *      will wait for them all to be resolved or one to be rejected before the controller is
	   *      instantiated.
	   *      If all the promises are resolved successfully, the values of the resolved promises are
	   *      injected and {@link ngRoute.$route#$routeChangeSuccess $routeChangeSuccess} event is
	   *      fired. If any of the promises are rejected the
	   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event is fired.
	   *      For easier access to the resolved dependencies from the template, the `resolve` map will
	   *      be available on the scope of the route, under `$resolve` (by default) or a custom name
	   *      specified by the `resolveAs` property (see below). This can be particularly useful, when
	   *      working with {@link angular.Module#component components} as route templates.<br />
	   *      <div class="alert alert-warning">
	   *        **Note:** If your scope already contains a property with this name, it will be hidden
	   *        or overwritten. Make sure, you specify an appropriate name for this property, that
	   *        does not collide with other properties on the scope.
	   *      </div>
	   *      The map object is:
	   *
	   *      - `key` – `{string}`: a name of a dependency to be injected into the controller.
	   *      - `factory` - `{string|Function}`: If `string` then it is an alias for a service.
	   *        Otherwise if function, then it is {@link auto.$injector#invoke injected}
	   *        and the return value is treated as the dependency. If the result is a promise, it is
	   *        resolved before its value is injected into the controller. Be aware that
	   *        `ngRoute.$routeParams` will still refer to the previous route within these resolve
	   *        functions.  Use `$route.current.params` to access the new route parameters, instead.
	   *
	   *    - `resolveAs` - `{string=}` - The name under which the `resolve` map will be available on
	   *      the scope of the route. If omitted, defaults to `$resolve`.
	   *
	   *    - `redirectTo` – `{(string|Function)=}` – value to update
	   *      {@link ng.$location $location} path with and trigger route redirection.
	   *
	   *      If `redirectTo` is a function, it will be called with the following parameters:
	   *
	   *      - `{Object.<string>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route templateUrl.
	   *      - `{string}` - current `$location.path()`
	   *      - `{Object}` - current `$location.search()`
	   *
	   *      The custom `redirectTo` function is expected to return a string which will be used
	   *      to update `$location.url()`. If the function throws an error, no further processing will
	   *      take place and the {@link ngRoute.$route#$routeChangeError $routeChangeError} event will
	   *      be fired.
	   *
	   *      Routes that specify `redirectTo` will not have their controllers, template functions
	   *      or resolves called, the `$location` will be changed to the redirect url and route
	   *      processing will stop. The exception to this is if the `redirectTo` is a function that
	   *      returns `undefined`. In this case the route transition occurs as though there was no
	   *      redirection.
	   *
	   *    - `resolveRedirectTo` – `{Function=}` – a function that will (eventually) return the value
	   *      to update {@link ng.$location $location} URL with and trigger route redirection. In
	   *      contrast to `redirectTo`, dependencies can be injected into `resolveRedirectTo` and the
	   *      return value can be either a string or a promise that will be resolved to a string.
	   *
	   *      Similar to `redirectTo`, if the return value is `undefined` (or a promise that gets
	   *      resolved to `undefined`), no redirection takes place and the route transition occurs as
	   *      though there was no redirection.
	   *
	   *      If the function throws an error or the returned promise gets rejected, no further
	   *      processing will take place and the
	   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event will be fired.
	   *
	   *      `redirectTo` takes precedence over `resolveRedirectTo`, so specifying both on the same
	   *      route definition, will cause the latter to be ignored.
	   *
	   *    - `[reloadOnUrl=true]` - `{boolean=}` - reload route when any part of the URL changes
	   *      (including the path) even if the new URL maps to the same route.
	   *
	   *      If the option is set to `false` and the URL in the browser changes, but the new URL maps
	   *      to the same route, then a `$routeUpdate` event is broadcasted on the root scope (without
	   *      reloading the route).
	   *
	   *    - `[reloadOnSearch=true]` - `{boolean=}` - reload route when only `$location.search()`
	   *      or `$location.hash()` changes.
	   *
	   *      If the option is set to `false` and the URL in the browser changes, then a `$routeUpdate`
	   *      event is broadcasted on the root scope (without reloading the route).
	   *
	   *      <div class="alert alert-warning">
	   *        **Note:** This option has no effect if `reloadOnUrl` is set to `false`.
	   *      </div>
	   *
	   *    - `[caseInsensitiveMatch=false]` - `{boolean=}` - match routes without being case sensitive
	   *
	   *      If the option is set to `true`, then the particular route can be matched without being
	   *      case sensitive
	   *
	   * @returns {Object} self
	   *
	   * @description
	   * Adds a new route definition to the `$route` service.
	   */
	  this.when = function(path, route) {
	    //copy original route object to preserve params inherited from proto chain
	    var routeCopy = shallowCopy(route);
	    if (angular.isUndefined(routeCopy.reloadOnUrl)) {
	      routeCopy.reloadOnUrl = true;
	    }
	    if (angular.isUndefined(routeCopy.reloadOnSearch)) {
	      routeCopy.reloadOnSearch = true;
	    }
	    if (angular.isUndefined(routeCopy.caseInsensitiveMatch)) {
	      routeCopy.caseInsensitiveMatch = this.caseInsensitiveMatch;
	    }
	    routes[path] = angular.extend(
	      routeCopy,
	      {originalPath: path},
	      path && routeToRegExp(path, routeCopy)
	    );
	
	    // create redirection for trailing slashes
	    if (path) {
	      var redirectPath = (path[path.length - 1] === '/')
	            ? path.substr(0, path.length - 1)
	            : path + '/';
	
	      routes[redirectPath] = angular.extend(
	        {originalPath: path, redirectTo: path},
	        routeToRegExp(redirectPath, routeCopy)
	      );
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $routeProvider#caseInsensitiveMatch
	   * @description
	   *
	   * A boolean property indicating if routes defined
	   * using this provider should be matched using a case insensitive
	   * algorithm. Defaults to `false`.
	   */
	  this.caseInsensitiveMatch = false;
	
	  /**
	   * @ngdoc method
	   * @name $routeProvider#otherwise
	   *
	   * @description
	   * Sets route definition that will be used on route change when no other route definition
	   * is matched.
	   *
	   * @param {Object|string} params Mapping information to be assigned to `$route.current`.
	   * If called with a string, the value maps to `redirectTo`.
	   * @returns {Object} self
	   */
	  this.otherwise = function(params) {
	    if (typeof params === 'string') {
	      params = {redirectTo: params};
	    }
	    this.when(null, params);
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $routeProvider#eagerInstantiationEnabled
	   * @kind function
	   *
	   * @description
	   * Call this method as a setter to enable/disable eager instantiation of the
	   * {@link ngRoute.$route $route} service upon application bootstrap. You can also call it as a
	   * getter (i.e. without any arguments) to get the current value of the
	   * `eagerInstantiationEnabled` flag.
	   *
	   * Instantiating `$route` early is necessary for capturing the initial
	   * {@link ng.$location#$locationChangeStart $locationChangeStart} event and navigating to the
	   * appropriate route. Usually, `$route` is instantiated in time by the
	   * {@link ngRoute.ngView ngView} directive. Yet, in cases where `ngView` is included in an
	   * asynchronously loaded template (e.g. in another directive's template), the directive factory
	   * might not be called soon enough for `$route` to be instantiated _before_ the initial
	   * `$locationChangeSuccess` event is fired. Eager instantiation ensures that `$route` is always
	   * instantiated in time, regardless of when `ngView` will be loaded.
	   *
	   * The default value is true.
	   *
	   * **Note**:<br />
	   * You may want to disable the default behavior when unit-testing modules that depend on
	   * `ngRoute`, in order to avoid an unexpected request for the default route's template.
	   *
	   * @param {boolean=} enabled - If provided, update the internal `eagerInstantiationEnabled` flag.
	   *
	   * @returns {*} The current value of the `eagerInstantiationEnabled` flag if used as a getter or
	   *     itself (for chaining) if used as a setter.
	   */
	  isEagerInstantiationEnabled = true;
	  this.eagerInstantiationEnabled = function eagerInstantiationEnabled(enabled) {
	    if (isDefined(enabled)) {
	      isEagerInstantiationEnabled = enabled;
	      return this;
	    }
	
	    return isEagerInstantiationEnabled;
	  };
	
	
	  this.$get = ['$rootScope',
	               '$location',
	               '$routeParams',
	               '$q',
	               '$injector',
	               '$templateRequest',
	               '$sce',
	               '$browser',
	      function($rootScope, $location, $routeParams, $q, $injector, $templateRequest, $sce, $browser) {
	
	    /**
	     * @ngdoc service
	     * @name $route
	     * @requires $location
	     * @requires $routeParams
	     *
	     * @property {Object} current Reference to the current route definition.
	     * The route definition contains:
	     *
	     *   - `controller`: The controller constructor as defined in the route definition.
	     *   - `locals`: A map of locals which is used by {@link ng.$controller $controller} service for
	     *     controller instantiation. The `locals` contain
	     *     the resolved values of the `resolve` map. Additionally the `locals` also contain:
	     *
	     *     - `$scope` - The current route scope.
	     *     - `$template` - The current route template HTML.
	     *
	     *     The `locals` will be assigned to the route scope's `$resolve` property. You can override
	     *     the property name, using `resolveAs` in the route definition. See
	     *     {@link ngRoute.$routeProvider $routeProvider} for more info.
	     *
	     * @property {Object} routes Object with all route configuration Objects as its properties.
	     *
	     * @description
	     * `$route` is used for deep-linking URLs to controllers and views (HTML partials).
	     * It watches `$location.url()` and tries to map the path to an existing route definition.
	     *
	     * Requires the {@link ngRoute `ngRoute`} module to be installed.
	     *
	     * You can define routes through {@link ngRoute.$routeProvider $routeProvider}'s API.
	     *
	     * The `$route` service is typically used in conjunction with the
	     * {@link ngRoute.directive:ngView `ngView`} directive and the
	     * {@link ngRoute.$routeParams `$routeParams`} service.
	     *
	     * @example
	     * This example shows how changing the URL hash causes the `$route` to match a route against the
	     * URL, and the `ngView` pulls in the partial.
	     *
	     * <example name="$route-service" module="ngRouteExample"
	     *          deps="angular-route.js" fixBase="true">
	     *   <file name="index.html">
	     *     <div ng-controller="MainController">
	     *       Choose:
	     *       <a href="Book/Moby">Moby</a> |
	     *       <a href="Book/Moby/ch/1">Moby: Ch1</a> |
	     *       <a href="Book/Gatsby">Gatsby</a> |
	     *       <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
	     *       <a href="Book/Scarlet">Scarlet Letter</a><br/>
	     *
	     *       <div ng-view></div>
	     *
	     *       <hr />
	     *
	     *       <pre>$location.path() = {{$location.path()}}</pre>
	     *       <pre>$route.current.templateUrl = {{$route.current.templateUrl}}</pre>
	     *       <pre>$route.current.params = {{$route.current.params}}</pre>
	     *       <pre>$route.current.scope.name = {{$route.current.scope.name}}</pre>
	     *       <pre>$routeParams = {{$routeParams}}</pre>
	     *     </div>
	     *   </file>
	     *
	     *   <file name="book.html">
	     *     controller: {{name}}<br />
	     *     Book Id: {{params.bookId}}<br />
	     *   </file>
	     *
	     *   <file name="chapter.html">
	     *     controller: {{name}}<br />
	     *     Book Id: {{params.bookId}}<br />
	     *     Chapter Id: {{params.chapterId}}
	     *   </file>
	     *
	     *   <file name="script.js">
	     *     angular.module('ngRouteExample', ['ngRoute'])
	     *
	     *      .controller('MainController', function($scope, $route, $routeParams, $location) {
	     *          $scope.$route = $route;
	     *          $scope.$location = $location;
	     *          $scope.$routeParams = $routeParams;
	     *      })
	     *
	     *      .controller('BookController', function($scope, $routeParams) {
	     *          $scope.name = 'BookController';
	     *          $scope.params = $routeParams;
	     *      })
	     *
	     *      .controller('ChapterController', function($scope, $routeParams) {
	     *          $scope.name = 'ChapterController';
	     *          $scope.params = $routeParams;
	     *      })
	     *
	     *     .config(function($routeProvider, $locationProvider) {
	     *       $routeProvider
	     *        .when('/Book/:bookId', {
	     *         templateUrl: 'book.html',
	     *         controller: 'BookController',
	     *         resolve: {
	     *           // I will cause a 1 second delay
	     *           delay: function($q, $timeout) {
	     *             var delay = $q.defer();
	     *             $timeout(delay.resolve, 1000);
	     *             return delay.promise;
	     *           }
	     *         }
	     *       })
	     *       .when('/Book/:bookId/ch/:chapterId', {
	     *         templateUrl: 'chapter.html',
	     *         controller: 'ChapterController'
	     *       });
	     *
	     *       // configure html5 to get links working on jsfiddle
	     *       $locationProvider.html5Mode(true);
	     *     });
	     *
	     *   </file>
	     *
	     *   <file name="protractor.js" type="protractor">
	     *     it('should load and compile correct template', function() {
	     *       element(by.linkText('Moby: Ch1')).click();
	     *       var content = element(by.css('[ng-view]')).getText();
	     *       expect(content).toMatch(/controller: ChapterController/);
	     *       expect(content).toMatch(/Book Id: Moby/);
	     *       expect(content).toMatch(/Chapter Id: 1/);
	     *
	     *       element(by.partialLinkText('Scarlet')).click();
	     *
	     *       content = element(by.css('[ng-view]')).getText();
	     *       expect(content).toMatch(/controller: BookController/);
	     *       expect(content).toMatch(/Book Id: Scarlet/);
	     *     });
	     *   </file>
	     * </example>
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeStart
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted before a route change. At this  point the route services starts
	     * resolving all of the dependencies needed for the route change to occur.
	     * Typically this involves fetching the view template as well as any dependencies
	     * defined in `resolve` route property. Once  all of the dependencies are resolved
	     * `$routeChangeSuccess` is fired.
	     *
	     * The route change (and the `$location` change that triggered it) can be prevented
	     * by calling `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on}
	     * for more details about event object.
	     *
	     * @param {Object} angularEvent Synthetic event object.
	     * @param {Route} next Future route information.
	     * @param {Route} current Current route information.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeSuccess
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted after a route change has happened successfully.
	     * The `resolve` dependencies are now available in the `current.locals` property.
	     *
	     * {@link ngRoute.directive:ngView ngView} listens for the directive
	     * to instantiate the controller and render the view.
	     *
	     * @param {Object} angularEvent Synthetic event object.
	     * @param {Route} current Current route information.
	     * @param {Route|Undefined} previous Previous route information, or undefined if current is
	     * first route entered.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeError
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted if a redirection function fails or any redirection or resolve promises are
	     * rejected.
	     *
	     * @param {Object} angularEvent Synthetic event object
	     * @param {Route} current Current route information.
	     * @param {Route} previous Previous route information.
	     * @param {Route} rejection The thrown error or the rejection reason of the promise. Usually
	     * the rejection reason is the error that caused the promise to get rejected.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeUpdate
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted if the same instance of a route (including template, controller instance,
	     * resolved dependencies, etc.) is being reused. This can happen if either `reloadOnSearch` or
	     * `reloadOnUrl` has been set to `false`.
	     *
	     * @param {Object} angularEvent Synthetic event object
	     * @param {Route} current Current/previous route information.
	     */
	
	    var forceReload = false,
	        preparedRoute,
	        preparedRouteIsUpdateOnly,
	        $route = {
	          routes: routes,
	
	          /**
	           * @ngdoc method
	           * @name $route#reload
	           *
	           * @description
	           * Causes `$route` service to reload the current route even if
	           * {@link ng.$location $location} hasn't changed.
	           *
	           * As a result of that, {@link ngRoute.directive:ngView ngView}
	           * creates new scope and reinstantiates the controller.
	           */
	          reload: function() {
	            forceReload = true;
	
	            var fakeLocationEvent = {
	              defaultPrevented: false,
	              preventDefault: function fakePreventDefault() {
	                this.defaultPrevented = true;
	                forceReload = false;
	              }
	            };
	
	            $rootScope.$evalAsync(function() {
	              prepareRoute(fakeLocationEvent);
	              if (!fakeLocationEvent.defaultPrevented) commitRoute();
	            });
	          },
	
	          /**
	           * @ngdoc method
	           * @name $route#updateParams
	           *
	           * @description
	           * Causes `$route` service to update the current URL, replacing
	           * current route parameters with those specified in `newParams`.
	           * Provided property names that match the route's path segment
	           * definitions will be interpolated into the location's path, while
	           * remaining properties will be treated as query params.
	           *
	           * @param {!Object<string, string>} newParams mapping of URL parameter names to values
	           */
	          updateParams: function(newParams) {
	            if (this.current && this.current.$$route) {
	              newParams = angular.extend({}, this.current.params, newParams);
	              $location.path(interpolate(this.current.$$route.originalPath, newParams));
	              // interpolate modifies newParams, only query params are left
	              $location.search(newParams);
	            } else {
	              throw $routeMinErr('norout', 'Tried updating route with no current route');
	            }
	          }
	        };
	
	    $rootScope.$on('$locationChangeStart', prepareRoute);
	    $rootScope.$on('$locationChangeSuccess', commitRoute);
	
	    return $route;
	
	    /////////////////////////////////////////////////////
	
	    /**
	     * @param on {string} current url
	     * @param route {Object} route regexp to match the url against
	     * @return {?Object}
	     *
	     * @description
	     * Check if the route matches the current url.
	     *
	     * Inspired by match in
	     * visionmedia/express/lib/router/router.js.
	     */
	    function switchRouteMatcher(on, route) {
	      var keys = route.keys,
	          params = {};
	
	      if (!route.regexp) return null;
	
	      var m = route.regexp.exec(on);
	      if (!m) return null;
	
	      for (var i = 1, len = m.length; i < len; ++i) {
	        var key = keys[i - 1];
	
	        var val = m[i];
	
	        if (key && val) {
	          params[key.name] = val;
	        }
	      }
	      return params;
	    }
	
	    function prepareRoute($locationEvent) {
	      var lastRoute = $route.current;
	
	      preparedRoute = parseRoute();
	      preparedRouteIsUpdateOnly = isNavigationUpdateOnly(preparedRoute, lastRoute);
	
	      if (!preparedRouteIsUpdateOnly && (lastRoute || preparedRoute)) {
	        if ($rootScope.$broadcast('$routeChangeStart', preparedRoute, lastRoute).defaultPrevented) {
	          if ($locationEvent) {
	            $locationEvent.preventDefault();
	          }
	        }
	      }
	    }
	
	    function commitRoute() {
	      var lastRoute = $route.current;
	      var nextRoute = preparedRoute;
	
	      if (preparedRouteIsUpdateOnly) {
	        lastRoute.params = nextRoute.params;
	        angular.copy(lastRoute.params, $routeParams);
	        $rootScope.$broadcast('$routeUpdate', lastRoute);
	      } else if (nextRoute || lastRoute) {
	        forceReload = false;
	        $route.current = nextRoute;
	
	        var nextRoutePromise = $q.resolve(nextRoute);
	
	        $browser.$$incOutstandingRequestCount('$route');
	
	        nextRoutePromise.
	          then(getRedirectionData).
	          then(handlePossibleRedirection).
	          then(function(keepProcessingRoute) {
	            return keepProcessingRoute && nextRoutePromise.
	              then(resolveLocals).
	              then(function(locals) {
	                // after route change
	                if (nextRoute === $route.current) {
	                  if (nextRoute) {
	                    nextRoute.locals = locals;
	                    angular.copy(nextRoute.params, $routeParams);
	                  }
	                  $rootScope.$broadcast('$routeChangeSuccess', nextRoute, lastRoute);
	                }
	              });
	          }).catch(function(error) {
	            if (nextRoute === $route.current) {
	              $rootScope.$broadcast('$routeChangeError', nextRoute, lastRoute, error);
	            }
	          }).finally(function() {
	            // Because `commitRoute()` is called from a `$rootScope.$evalAsync` block (see
	            // `$locationWatch`), this `$$completeOutstandingRequest()` call will not cause
	            // `outstandingRequestCount` to hit zero.  This is important in case we are redirecting
	            // to a new route which also requires some asynchronous work.
	
	            $browser.$$completeOutstandingRequest(noop, '$route');
	          });
	      }
	    }
	
	    function getRedirectionData(route) {
	      var data = {
	        route: route,
	        hasRedirection: false
	      };
	
	      if (route) {
	        if (route.redirectTo) {
	          if (angular.isString(route.redirectTo)) {
	            data.path = interpolate(route.redirectTo, route.params);
	            data.search = route.params;
	            data.hasRedirection = true;
	          } else {
	            var oldPath = $location.path();
	            var oldSearch = $location.search();
	            var newUrl = route.redirectTo(route.pathParams, oldPath, oldSearch);
	
	            if (angular.isDefined(newUrl)) {
	              data.url = newUrl;
	              data.hasRedirection = true;
	            }
	          }
	        } else if (route.resolveRedirectTo) {
	          return $q.
	            resolve($injector.invoke(route.resolveRedirectTo)).
	            then(function(newUrl) {
	              if (angular.isDefined(newUrl)) {
	                data.url = newUrl;
	                data.hasRedirection = true;
	              }
	
	              return data;
	            });
	        }
	      }
	
	      return data;
	    }
	
	    function handlePossibleRedirection(data) {
	      var keepProcessingRoute = true;
	
	      if (data.route !== $route.current) {
	        keepProcessingRoute = false;
	      } else if (data.hasRedirection) {
	        var oldUrl = $location.url();
	        var newUrl = data.url;
	
	        if (newUrl) {
	          $location.
	            url(newUrl).
	            replace();
	        } else {
	          newUrl = $location.
	            path(data.path).
	            search(data.search).
	            replace().
	            url();
	        }
	
	        if (newUrl !== oldUrl) {
	          // Exit out and don't process current next value,
	          // wait for next location change from redirect
	          keepProcessingRoute = false;
	        }
	      }
	
	      return keepProcessingRoute;
	    }
	
	    function resolveLocals(route) {
	      if (route) {
	        var locals = angular.extend({}, route.resolve);
	        angular.forEach(locals, function(value, key) {
	          locals[key] = angular.isString(value) ?
	              $injector.get(value) :
	              $injector.invoke(value, null, null, key);
	        });
	        var template = getTemplateFor(route);
	        if (angular.isDefined(template)) {
	          locals['$template'] = template;
	        }
	        return $q.all(locals);
	      }
	    }
	
	    function getTemplateFor(route) {
	      var template, templateUrl;
	      if (angular.isDefined(template = route.template)) {
	        if (angular.isFunction(template)) {
	          template = template(route.params);
	        }
	      } else if (angular.isDefined(templateUrl = route.templateUrl)) {
	        if (angular.isFunction(templateUrl)) {
	          templateUrl = templateUrl(route.params);
	        }
	        if (angular.isDefined(templateUrl)) {
	          route.loadedTemplateUrl = $sce.valueOf(templateUrl);
	          template = $templateRequest(templateUrl);
	        }
	      }
	      return template;
	    }
	
	    /**
	     * @returns {Object} the current active route, by matching it against the URL
	     */
	    function parseRoute() {
	      // Match a route
	      var params, match;
	      angular.forEach(routes, function(route, path) {
	        if (!match && (params = switchRouteMatcher($location.path(), route))) {
	          match = inherit(route, {
	            params: angular.extend({}, $location.search(), params),
	            pathParams: params});
	          match.$$route = route;
	        }
	      });
	      // No route matched; fallback to "otherwise" route
	      return match || routes[null] && inherit(routes[null], {params: {}, pathParams:{}});
	    }
	
	    /**
	     * @param {Object} newRoute - The new route configuration (as returned by `parseRoute()`).
	     * @param {Object} oldRoute - The previous route configuration (as returned by `parseRoute()`).
	     * @returns {boolean} Whether this is an "update-only" navigation, i.e. the URL maps to the same
	     *                    route and it can be reused (based on the config and the type of change).
	     */
	    function isNavigationUpdateOnly(newRoute, oldRoute) {
	      // IF this is not a forced reload
	      return !forceReload
	          // AND both `newRoute`/`oldRoute` are defined
	          && newRoute && oldRoute
	          // AND they map to the same Route Definition Object
	          && (newRoute.$$route === oldRoute.$$route)
	          // AND `reloadOnUrl` is disabled
	          && (!newRoute.reloadOnUrl
	              // OR `reloadOnSearch` is disabled
	              || (!newRoute.reloadOnSearch
	                  // AND both routes have the same path params
	                  && angular.equals(newRoute.pathParams, oldRoute.pathParams)
	              )
	          );
	    }
	
	    /**
	     * @returns {string} interpolation of the redirect path with the parameters
	     */
	    function interpolate(string, params) {
	      var result = [];
	      angular.forEach((string || '').split(':'), function(segment, i) {
	        if (i === 0) {
	          result.push(segment);
	        } else {
	          var segmentMatch = segment.match(/(\w+)(?:[?*])?(.*)/);
	          var key = segmentMatch[1];
	          result.push(params[key]);
	          result.push(segmentMatch[2] || '');
	          delete params[key];
	        }
	      });
	      return result.join('');
	    }
	  }];
	}
	
	instantiateRoute.$inject = ['$injector'];
	function instantiateRoute($injector) {
	  if (isEagerInstantiationEnabled) {
	    // Instantiate `$route`
	    $injector.get('$route');
	  }
	}
	
	ngRouteModule.provider('$routeParams', $RouteParamsProvider);
	
	
	/**
	 * @ngdoc service
	 * @name $routeParams
	 * @requires $route
	 * @this
	 *
	 * @description
	 * The `$routeParams` service allows you to retrieve the current set of route parameters.
	 *
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 *
	 * The route parameters are a combination of {@link ng.$location `$location`}'s
	 * {@link ng.$location#search `search()`} and {@link ng.$location#path `path()`}.
	 * The `path` parameters are extracted when the {@link ngRoute.$route `$route`} path is matched.
	 *
	 * In case of parameter name collision, `path` params take precedence over `search` params.
	 *
	 * The service guarantees that the identity of the `$routeParams` object will remain unchanged
	 * (but its properties will likely change) even when a route change occurs.
	 *
	 * Note that the `$routeParams` are only updated *after* a route change completes successfully.
	 * This means that you cannot rely on `$routeParams` being correct in route resolve functions.
	 * Instead you can use `$route.current.params` to access the new route's parameters.
	 *
	 * @example
	 * ```js
	 *  // Given:
	 *  // URL: http://server.com/index.html#/Chapter/1/Section/2?search=moby
	 *  // Route: /Chapter/:chapterId/Section/:sectionId
	 *  //
	 *  // Then
	 *  $routeParams ==> {chapterId:'1', sectionId:'2', search:'moby'}
	 * ```
	 */
	function $RouteParamsProvider() {
	  this.$get = function() { return {}; };
	}
	
	ngRouteModule.directive('ngView', ngViewFactory);
	ngRouteModule.directive('ngView', ngViewFillContentFactory);
	
	
	/**
	 * @ngdoc directive
	 * @name ngView
	 * @restrict ECA
	 *
	 * @description
	 * `ngView` is a directive that complements the {@link ngRoute.$route $route} service by
	 * including the rendered template of the current route into the main layout (`index.html`) file.
	 * Every time the current route changes, the included view changes with it according to the
	 * configuration of the `$route` service.
	 *
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from to the DOM  |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 *
	 * @param {string=} autoscroll Whether `ngView` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the view is updated.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the `autoscroll` attribute value evaluated
	 *                    as an expression yields a truthy value.
	 * @example
	    <example name="ngView-directive" module="ngViewExample"
	             deps="angular-route.js;angular-animate.js"
	             animations="true" fixBase="true">
	      <file name="index.html">
	        <div ng-controller="MainCtrl as main">
	          Choose:
	          <a href="Book/Moby">Moby</a> |
	          <a href="Book/Moby/ch/1">Moby: Ch1</a> |
	          <a href="Book/Gatsby">Gatsby</a> |
	          <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
	          <a href="Book/Scarlet">Scarlet Letter</a><br/>
	
	          <div class="view-animate-container">
	            <div ng-view class="view-animate"></div>
	          </div>
	          <hr />
	
	          <pre>$location.path() = {{main.$location.path()}}</pre>
	          <pre>$route.current.templateUrl = {{main.$route.current.templateUrl}}</pre>
	          <pre>$route.current.params = {{main.$route.current.params}}</pre>
	          <pre>$routeParams = {{main.$routeParams}}</pre>
	        </div>
	      </file>
	
	      <file name="book.html">
	        <div>
	          controller: {{book.name}}<br />
	          Book Id: {{book.params.bookId}}<br />
	        </div>
	      </file>
	
	      <file name="chapter.html">
	        <div>
	          controller: {{chapter.name}}<br />
	          Book Id: {{chapter.params.bookId}}<br />
	          Chapter Id: {{chapter.params.chapterId}}
	        </div>
	      </file>
	
	      <file name="animations.css">
	        .view-animate-container {
	          position:relative;
	          height:100px!important;
	          background:white;
	          border:1px solid black;
	          height:40px;
	          overflow:hidden;
	        }
	
	        .view-animate {
	          padding:10px;
	        }
	
	        .view-animate.ng-enter, .view-animate.ng-leave {
	          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 1.5s;
	
	          display:block;
	          width:100%;
	          border-left:1px solid black;
	
	          position:absolute;
	          top:0;
	          left:0;
	          right:0;
	          bottom:0;
	          padding:10px;
	        }
	
	        .view-animate.ng-enter {
	          left:100%;
	        }
	        .view-animate.ng-enter.ng-enter-active {
	          left:0;
	        }
	        .view-animate.ng-leave.ng-leave-active {
	          left:-100%;
	        }
	      </file>
	
	      <file name="script.js">
	        angular.module('ngViewExample', ['ngRoute', 'ngAnimate'])
	          .config(['$routeProvider', '$locationProvider',
	            function($routeProvider, $locationProvider) {
	              $routeProvider
	                .when('/Book/:bookId', {
	                  templateUrl: 'book.html',
	                  controller: 'BookCtrl',
	                  controllerAs: 'book'
	                })
	                .when('/Book/:bookId/ch/:chapterId', {
	                  templateUrl: 'chapter.html',
	                  controller: 'ChapterCtrl',
	                  controllerAs: 'chapter'
	                });
	
	              $locationProvider.html5Mode(true);
	          }])
	          .controller('MainCtrl', ['$route', '$routeParams', '$location',
	            function MainCtrl($route, $routeParams, $location) {
	              this.$route = $route;
	              this.$location = $location;
	              this.$routeParams = $routeParams;
	          }])
	          .controller('BookCtrl', ['$routeParams', function BookCtrl($routeParams) {
	            this.name = 'BookCtrl';
	            this.params = $routeParams;
	          }])
	          .controller('ChapterCtrl', ['$routeParams', function ChapterCtrl($routeParams) {
	            this.name = 'ChapterCtrl';
	            this.params = $routeParams;
	          }]);
	
	      </file>
	
	      <file name="protractor.js" type="protractor">
	        it('should load and compile correct template', function() {
	          element(by.linkText('Moby: Ch1')).click();
	          var content = element(by.css('[ng-view]')).getText();
	          expect(content).toMatch(/controller: ChapterCtrl/);
	          expect(content).toMatch(/Book Id: Moby/);
	          expect(content).toMatch(/Chapter Id: 1/);
	
	          element(by.partialLinkText('Scarlet')).click();
	
	          content = element(by.css('[ng-view]')).getText();
	          expect(content).toMatch(/controller: BookCtrl/);
	          expect(content).toMatch(/Book Id: Scarlet/);
	        });
	      </file>
	    </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngView#$viewContentLoaded
	 * @eventType emit on the current ngView scope
	 * @description
	 * Emitted every time the ngView content is reloaded.
	 */
	ngViewFactory.$inject = ['$route', '$anchorScroll', '$animate'];
	function ngViewFactory($route, $anchorScroll, $animate) {
	  return {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    link: function(scope, $element, attr, ctrl, $transclude) {
	        var currentScope,
	            currentElement,
	            previousLeaveAnimation,
	            autoScrollExp = attr.autoscroll,
	            onloadExp = attr.onload || '';
	
	        scope.$on('$routeChangeSuccess', update);
	        update();
	
	        function cleanupLastView() {
	          if (previousLeaveAnimation) {
	            $animate.cancel(previousLeaveAnimation);
	            previousLeaveAnimation = null;
	          }
	
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            previousLeaveAnimation = $animate.leave(currentElement);
	            previousLeaveAnimation.done(function(response) {
	              if (response !== false) previousLeaveAnimation = null;
	            });
	            currentElement = null;
	          }
	        }
	
	        function update() {
	          var locals = $route.current && $route.current.locals,
	              template = locals && locals.$template;
	
	          if (angular.isDefined(template)) {
	            var newScope = scope.$new();
	            var current = $route.current;
	
	            // Note: This will also link all children of ng-view that were contained in the original
	            // html. If that content contains controllers, ... they could pollute/change the scope.
	            // However, using ng-view on an element with additional content does not make sense...
	            // Note: We can't remove them in the cloneAttchFn of $transclude as that
	            // function is called before linking the content, which would apply child
	            // directives to non existing elements.
	            var clone = $transclude(newScope, function(clone) {
	              $animate.enter(clone, null, currentElement || $element).done(function onNgViewEnter(response) {
	                if (response !== false && angular.isDefined(autoScrollExp)
	                  && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                  $anchorScroll();
	                }
	              });
	              cleanupLastView();
	            });
	
	            currentElement = clone;
	            currentScope = current.scope = newScope;
	            currentScope.$emit('$viewContentLoaded');
	            currentScope.$eval(onloadExp);
	          } else {
	            cleanupLastView();
	          }
	        }
	    }
	  };
	}
	
	// This directive is called during the $transclude call of the first `ngView` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngView
	// is called.
	ngViewFillContentFactory.$inject = ['$compile', '$controller', '$route'];
	function ngViewFillContentFactory($compile, $controller, $route) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    link: function(scope, $element) {
	      var current = $route.current,
	          locals = current.locals;
	
	      $element.html(locals.$template);
	
	      var link = $compile($element.contents());
	
	      if (current.controller) {
	        locals.$scope = scope;
	        var controller = $controller(current.controller, locals);
	        if (current.controllerAs) {
	          scope[current.controllerAs] = controller;
	        }
	        $element.data('$ngControllerController', controller);
	        $element.children().data('$ngControllerController', controller);
	      }
	      scope[current.resolveAs || '$resolve'] = locals;
	
	      link(scope);
	    }
	  };
	}
	
	
	})(window, window.angular);


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.19.0 - 2021-09-02
	 * 
	 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	runTranslate.$inject = ['$translate'];
	$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
	translateAttrDirective.$inject = ['$translate', '$rootScope'];
	translateCloakDirective.$inject = ['$translate', '$rootScope'];
	translateFilterFactory.$inject = ['$parse', '$translate'];
	$translationCache.$inject = ['$cacheFactory'];
	angular.module('pascalprecht.translate', ['ng'])
	  .run(runTranslate);
	
	function runTranslate($translate) {
	
	  'use strict';
	
	  var key = $translate.storageKey(),
	    storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function () {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}
	
	runTranslate.displayName = 'runTranslate';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */
	angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	function $translateSanitizationProvider () {
	
	  'use strict';
	
	  var $sanitize,
	      $sce,
	      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	      hasConfiguredStrategy = false,
	      hasShownNoStrategyConfiguredWarning = false,
	      strategies;
	
	  /**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   */
	
	  /**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */
	
	  strategies = {
	    sanitize: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlSanitizeValue(value);
	      }
	      return value;
	    },
	    escape: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlEscapeValue(value);
	      }
	      return value;
	    },
	    sanitizeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlSanitizeValue);
	      }
	      return value;
	    },
	    escapeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlEscapeValue);
	      }
	      return value;
	    },
	    sce: function (value, mode, context) {
	      if (mode === 'text') {
	        value = htmlTrustValue(value);
	      } else if (mode === 'params') {
	        if (context !== 'filter') {
	          // do html escape in filter context #1101
	          value = mapInterpolationParameters(value, htmlEscapeValue);
	        }
	      }
	      return value;
	    },
	    sceParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlTrustValue);
	      }
	      return value;
	    }
	  };
	  // Support legacy strategy name 'escaped' for backwards compatibility.
	  // TODO should be removed in 3.0
	  strategies.escaped = strategies.escapeParameters;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */
	  this.addStrategy = function (strategyName, strategyFunction) {
	    strategies[strategyName] = strategyFunction;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */
	  this.removeStrategy = function (strategyName) {
	    delete strategies[strategyName];
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */
	  this.useStrategy = function (strategy) {
	    hasConfiguredStrategy = true;
	    currentStrategy = strategy;
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */
	  this.$get = ['$injector', '$log', function ($injector, $log) {
	
	    var cachedStrategyMap = {};
	
	    var applyStrategies = function (value, mode, context, selectedStrategies) {
	      angular.forEach(selectedStrategies, function (selectedStrategy) {
	        if (angular.isFunction(selectedStrategy)) {
	          value = selectedStrategy(value, mode, context);
	        } else if (angular.isFunction(strategies[selectedStrategy])) {
	          value = strategies[selectedStrategy](value, mode, context);
	        } else if (angular.isString(strategies[selectedStrategy])) {
	          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	            try {
	              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	            } catch (e) {
	              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
	              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	            }
	          }
	          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
	        } else {
	          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	        }
	      });
	      return value;
	    };
	
	    // TODO: should be removed in 3.0
	    var showNoStrategyConfiguredWarning = function () {
	      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	        hasShownNoStrategyConfiguredWarning = true;
	      }
	    };
	
	    if ($injector.has('$sanitize')) {
	      $sanitize = $injector.get('$sanitize');
	    }
	    if ($injector.has('$sce')) {
	      $sce = $injector.get('$sce');
	    }
	
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */
	      useStrategy: (function (self) {
	        return function (strategy) {
	          self.useStrategy(strategy);
	        };
	      })(this),
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @param {string} [context] The context of this call: filter, service. Default is service
	       * @returns {string|object} sanitized value
	       */
	      sanitize: function (value, mode, strategy, context) {
	        if (!currentStrategy) {
	          showNoStrategyConfiguredWarning();
	        }
	
	        if (!strategy && strategy !== null) {
	          strategy = currentStrategy;
	        }
	
	        if (!strategy) {
	          return value;
	        }
	
	        if (!context) {
	          context = 'service';
	        }
	
	        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	        return applyStrategies(value, mode, context, selectedStrategies);
	      }
	    };
	  }];
	
	  var htmlEscapeValue = function (value) {
	    var element = angular.element('<div></div>');
	    element.text(value); // not chainable, see #1044
	    return element.html();
	  };
	
	  var htmlSanitizeValue = function (value) {
	    if (!$sanitize) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	    }
	    return $sanitize(value);
	  };
	
	  var htmlTrustValue = function (value) {
	    if (!$sce) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
	    }
	    return $sce.trustAsHtml(value);
	  };
	
	  var mapInterpolationParameters = function (value, iteratee, stack) {
	    if (angular.isDate(value)) {
	      return value;
	    } else if (angular.isObject(value)) {
	      var result = angular.isArray(value) ? [] : {};
	
	      if (!stack) {
	        stack = [];
	      } else {
	        if (stack.indexOf(value) > -1) {
	          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
	        }
	      }
	
	      stack.push(value);
	      angular.forEach(value, function (propertyValue, propertyKey) {
	
	        /* Skipping function properties. */
	        if (angular.isFunction(propertyValue)) {
	          return;
	        }
	
	        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
	      });
	      stack.splice(-1, 1); // remove last
	
	      return result;
	    } else if (angular.isNumber(value)) {
	      return value;
	    } else if (value === true || value === false) {
	      return value;
	    } else if (!angular.isUndefined(value) && value !== null) {
	      return iteratee(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate')
	  .constant('pascalprechtTranslateOverrider', {})
	  .provider('$translate', $translate);
	
	function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	  'use strict';
	
	  var $translationTable = {},
	    $preferredLanguage,
	    $availableLanguageKeys = [],
	    $languageKeyAliases,
	    $fallbackLanguage,
	    $fallbackWasString,
	    $uses,
	    $nextLang,
	    $storageFactory,
	    $storageKey = $STORAGE_KEY,
	    $storagePrefix,
	    $missingTranslationHandlerFactory,
	    $interpolationFactory,
	    $interpolatorFactories = [],
	    $loaderFactory,
	    $cloakClassName = 'translate-cloak',
	    $loaderOptions,
	    $notFoundIndicatorLeft,
	    $notFoundIndicatorRight,
	    $postCompilingEnabled = false,
	    $forceAsyncReloadEnabled = false,
	    $allowNamespaces = true,
	    $nestedObjectDelimeter = '.',
	    $isReady = false,
	    $keepContent = false,
	    loaderCache,
	    directivePriority = 0,
	    statefulFilter = true,
	    postProcessFn,
	    uniformLanguageTagResolver = 'default',
	    languageTagResolver = {
	      'default' : function (tag) {
	        return (tag || '').split('-').join('_');
	      },
	      java : function (tag) {
	        var temp = (tag || '').split('-').join('_');
	        var parts = temp.split('_');
	        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
	      },
	      bcp47 : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	
	        switch (parts.length) {
	          case 1: // language only
	            parts[0] = parts[0].toLowerCase();
	            break;
	          case 2: // language-script or language-region
	            parts[0] = parts[0].toLowerCase();
	            if (parts[1].length === 4) { // parts[1] is script
	              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            } else { // parts[1] is region
	              parts[1] = parts[1].toUpperCase();
	            }
	            break;
	          case 3: // language-script-region
	            parts[0] = parts[0].toLowerCase();
	            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            parts[2] = parts[2].toUpperCase();
	            break;
	          default:
	            return temp;
	        }
	
	        return parts.join('-');
	      },
	      'iso639-1' : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	        return parts[0].toLowerCase();
	      }
	    };
	
	  var version = '2.19.0';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	
	    // internal purpose only
	    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	      return pascalprechtTranslateOverrider.getLocale();
	    }
	
	    var nav = $windowProvider.$get().navigator,
	      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	      i,
	      language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    var locale = getFirstBrowserLanguage() || '';
	    if (languageTagResolver[uniformLanguageTagResolver]) {
	      locale = languageTagResolver[uniformLanguageTagResolver](locale);
	    }
	    return locale;
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function (array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function () {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  var negotiateLocale = function (preferred) {
	    if (!preferred) {
	      return;
	    }
	
	    var avail = [],
	      locale = lowercase(preferred),
	      i = 0,
	      n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(lowercase($availableLanguageKeys[i]));
	    }
	
	    // Check for an exact match in our list of available keys
	    i = indexOf(avail, locale);
	    if (i > -1) {
	      return $availableLanguageKeys[i];
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
	          var hasWildcardKey = false;
	          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	            lowercase(langKeyAlias) === lowercase(preferred);
	
	          if (langKeyAlias.slice(-1) === '*') {
	            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
	          }
	          if (hasExactKey || hasWildcardKey) {
	            alias = $languageKeyAliases[langKeyAlias];
	            if (indexOf(avail, lowercase(alias)) > -1) {
	              return alias;
	            }
	          }
	        }
	      }
	    }
	
	    // Check for a language code without region
	    var parts = preferred.split('_');
	
	    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
	      return parts[0];
	    }
	
	    // If everything fails, return undefined.
	    return;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} langKey A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#allowNamespaces
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Let's you disable namespaces, if you don't need nested translation
	   * object files. Disabling namespaces can improve performance.
	   *
	   * Default value is `true`. Namespaces are enabled by default.
	   *
	   * @param {boolean} namespacesEnabled - namespaces are enabled or not
	   */
	  this.allowNamespaces = function (namespacesEnabled) {
	    if (namespacesEnabled === undefined) {
	      return $allowNamespaces;
	    }
	    $allowNamespaces = namespacesEnabled;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */
	  this.nestedObjectDelimeter = function (delimiter) {
	    if (!delimiter) {
	      return $nestedObjectDelimeter;
	    }
	    $nestedObjectDelimeter = delimiter;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    if (!$allowNamespaces) {
	      return data;
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
	        if (path.length && key === prevKey) {
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	  flatObject.displayName = 'flatObject';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $translateSanitizationProvider.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.preferredLanguage = function (langKey) {
	    if (langKey) {
	      setupPreferredLanguage(langKey);
	      return this;
	    }
	    return $preferredLanguage;
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [langKey];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	   *
	   * @returns {string} the current client/browser language key
	   */
	  this.resolveClientLocale = function () {
	    return getLocale();
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function (key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	    return this;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.forceAsyncReload = function (value) {
	    $forceAsyncReloadEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     EN => en
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *     sr-latn => sr-Latn
	   *     sr-latn-rs => sr-Latn-RS
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */
	  this.uniformLanguageTag = function (options) {
	
	    if (!options) {
	      options = {};
	    } else if (angular.isString(options)) {
	      options = {
	        standard : options
	      };
	    }
	
	    uniformLanguageTagResolver = options.standard;
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale) || locale;
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */
	  this.directivePriority = function (priority) {
	    if (priority === undefined) {
	      // getter
	      return directivePriority;
	    } else {
	      // setter with chaining
	      directivePriority = priority;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */
	  this.statefulFilter = function (state) {
	    if (state === undefined) {
	      // getter
	      return statefulFilter;
	    } else {
	      // setter with chaining
	      statefulFilter = state;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#postProcess
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * The post processor will be intercept right after the translation result. It can modify the result.
	   *
	   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
	   */
	  this.postProcess = function (fn) {
	    if (fn) {
	      postProcessFn = fn;
	    } else {
	      postProcessFn = undefined;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#keepContent
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If keepContent is set to true than translate directive will always use innerHTML
	   * as a default translation
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.keepContent(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.keepContent = function (value) {
	    $keepContent = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} [interpolateParams={}] An object hash for dynamic values
	   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
	   *                                        as default text in case it is not found in any configured language
	   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	   * @returns {object} promise
	   */
	  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {
	
	    var Storage,
	      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	      pendingLoader = false,
	      interpolatorHashMap = {},
	      langPromises = {},
	      fallbackIndex,
	      startFallbackIteration;
	
	    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
	      if (!$uses && $preferredLanguage) {
	        $uses = $preferredLanguage;
	      }
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        // Inspired by Q.allSettled by Kris Kowal
	        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	        // This transforms all promises regardless resolved or rejected
	        var translateAll = function (translationIds) {
	          var results = {}; // storing the actual results
	          var promises = []; // promises to wait for
	          // Wraps the promise a) being always resolved and b) storing the link id->value
	          var translate = function (translationId) {
	            var deferred = $q.defer();
	            var regardless = function (value) {
	              results[translationId] = value;
	              deferred.resolve([translationId, value]);
	            };
	            // we don't care whether the promise was resolved or rejected; just store the values
	            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
	            return deferred.promise;
	          };
	          for (var i = 0, c = translationIds.length; i < c; i++) {
	            promises.push(translate(translationIds[i]));
	          }
	          // wait for all (including storing to results)
	          return $q.all(promises).then(function () {
	            // return the results
	            return results;
	          });
	        };
	        return translateAll(translationId);
	      }
	
	      var deferred = $q.defer();
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      } else {
	        throw new TypeError('translationId must be a not empty string');
	      }
	
	      var promiseToWaitFor = (function () {
	        var promise = langPromises[uses] || langPromises[$preferredLanguage];
	
	        fallbackIndex = 0;
	
	        if ($storageFactory && !promise) {
	          // looks like there's no pending promise for $preferredLanguage or
	          // $uses. Maybe there's one pending for a language that comes from
	          // storage.
	          var langKey = Storage.get($storageKey);
	          promise = langPromises[langKey];
	
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            var index = indexOf($fallbackLanguage, langKey);
	            // maybe the language from storage is also defined as fallback language
	            // we increase the fallback language index to not search in that language
	            // as fallback, since it's probably the first used language
	            // in that case the index starts after the first element
	            fallbackIndex = (index === 0) ? 1 : 0;
	
	            // but we can make sure to ALWAYS fallback to preferred language at least
	            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	              $fallbackLanguage.push($preferredLanguage);
	            }
	          }
	        }
	        return promise;
	      }());
	
	      if (!promiseToWaitFor) {
	        // no promise to wait for? okay. Then there's no loader registered
	        // nor is a one pending for language that comes from storage.
	        // We can just translate.
	        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	      } else {
	        var promiseResolved = function () {
	          // $uses may have changed while waiting
	          if (!forceLanguage) {
	            uses = $uses;
	          }
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	        };
	        promiseResolved.displayName = 'promiseResolved';
	
	        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name applyNotFoundIndicators
	     * @private
	     *
	     * @description
	     * Applies not fount indicators to given translation id, if needed.
	     * This function gets only executed, if a translation id doesn't exist,
	     * which is why a translation id is expected as argument.
	     *
	     * @param {string} translationId Translation id.
	     * @returns {string} Same as given translation id but applied with not found
	     * indicators.
	     */
	    var applyNotFoundIndicators = function (translationId) {
	      // applying notFoundIndicators
	      if ($notFoundIndicatorLeft) {
	        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	      }
	      if ($notFoundIndicatorRight) {
	        translationId = [translationId, $notFoundIndicatorRight].join(' ');
	      }
	      return translationId;
	    };
	
	    /**
	     * @name useLanguage
	     * @private
	     *
	     * @description
	     * Makes actual use of a language by setting a given language key as used
	     * language and informs registered interpolators to also use the given
	     * key as locale.
	     *
	     * @param {string} key Locale key.
	     */
	    var useLanguage = function (key) {
	      $uses = key;
	
	      // make sure to store new language key before triggering success event
	      if ($storageFactory) {
	        Storage.put($translate.storageKey(), $uses);
	      }
	
	      $rootScope.$emit('$translateChangeSuccess', {language : key});
	
	      // inform default interpolator
	      defaultInterpolator.setLocale($uses);
	
	      var eachInterpolator = function (interpolator, id) {
	        interpolatorHashMap[id].setLocale($uses);
	      };
	      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	      // inform all others too!
	      angular.forEach(interpolatorHashMap, eachInterpolator);
	      $rootScope.$emit('$translateChangeEnd', {language : key});
	    };
	
	    /**
	     * @name loadAsync
	     * @private
	     *
	     * @description
	     * Kicks off registered async loader using `$injector` and applies existing
	     * loader options. When resolved, it updates translation tables accordingly
	     * or rejects with given language key.
	     *
	     * @param {string} key Language key.
	     * @return {Promise} A promise.
	     */
	    var loadAsync = function (key) {
	      if (!key) {
	        throw 'No language key specified for loading.';
	      }
	
	      var deferred = $q.defer();
	
	      $rootScope.$emit('$translateLoadingStart', {language : key});
	      pendingLoader = true;
	
	      var cache = loaderCache;
	      if (typeof(cache) === 'string') {
	        // getting on-demand instance of loader
	        cache = $injector.get(cache);
	      }
	
	      var loaderOptions = angular.extend({}, $loaderOptions, {
	        key : key,
	        $http : angular.extend({}, {
	          cache : cache
	        }, $loaderOptions.$http)
	      });
	
	      var onLoaderSuccess = function (data) {
	        var translationTable = {};
	        $rootScope.$emit('$translateLoadingSuccess', {language : key});
	
	        if (angular.isArray(data)) {
	          angular.forEach(data, function (table) {
	            angular.extend(translationTable, flatObject(table));
	          });
	        } else {
	          angular.extend(translationTable, flatObject(data));
	        }
	        pendingLoader = false;
	        deferred.resolve({
	          key : key,
	          table : translationTable
	        });
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	      var onLoaderError = function (key) {
	        $rootScope.$emit('$translateLoadingError', {language : key});
	        deferred.reject(key);
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderError.displayName = 'onLoaderError';
	
	      $injector.get($loaderFactory)(loaderOptions)
	        .then(onLoaderSuccess, onLoaderError);
	
	      return deferred.promise;
	    };
	
	    if ($storageFactory) {
	      Storage = $injector.get($storageFactory);
	
	      if (!Storage.get || !Storage.put) {
	        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	      }
	    }
	
	    // if we have additional interpolations that were added via
	    // $translateProvider.addInterpolation(), we have to map'em
	    if ($interpolatorFactories.length) {
	      var eachInterpolationFactory = function (interpolatorFactory) {
	        var interpolator = $injector.get(interpolatorFactory);
	        // setting initial locale for each interpolation service
	        interpolator.setLocale($preferredLanguage || $uses);
	        // make'em recognizable through id
	        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	      };
	      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	      angular.forEach($interpolatorFactories, eachInterpolationFactory);
	    }
	
	    /**
	     * @name getTranslationTable
	     * @private
	     *
	     * @description
	     * Returns a promise that resolves to the translation table
	     * or is rejected if an error occurred.
	     *
	     * @param langKey
	     * @returns {Q.promise}
	     */
	    var getTranslationTable = function (langKey) {
	      var deferred = $q.defer();
	      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	        deferred.resolve($translationTable[langKey]);
	      } else if (langPromises[langKey]) {
	        var onResolve = function (data) {
	          translations(data.key, data.table);
	          deferred.resolve(data.table);
	        };
	        onResolve.displayName = 'translationTableResolver';
	        langPromises[langKey].then(onResolve, deferred.reject);
	      } else {
	        deferred.reject();
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslation
	     * @private
	     *
	     * @description
	     * Returns a promise that will resolve to the translation
	     * or be rejected if no translation was found for the language.
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {Q.promise}
	     */
	    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      var onResolve = function (translationTable) {
	        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	          Interpolator.setLocale(langKey);
	          var translation = translationTable[translationId];
	          if (translation.substr(0, 2) === '@:') {
	            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
	            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);
	
	            deferred.resolve(interpolatedValue);
	
	          }
	          Interpolator.setLocale($uses);
	        } else {
	          deferred.reject();
	        }
	      };
	      onResolve.displayName = 'fallbackTranslationResolver';
	
	      getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslationInstant
	     * @private
	     *
	     * @description
	     * Returns a translation
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns {string} translation
	     */
	    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result, translationTable = $translationTable[langKey];
	
	      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	        Interpolator.setLocale(langKey);
	        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
	        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
	        // workaround for TrustedValueHolderType
	        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
	          var result2 = result.$$unwrapTrustedValue();
	          if (result2.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	          }
	        } else if (result.substr(0, 2) === '@:') {
	          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	        }
	        Interpolator.setLocale($uses);
	      }
	
	      return result;
	    };
	
	
	    /**
	     * @name translateByHandler
	     * @private
	     *
	     * Translate by missing translation handler.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param defaultTranslationText
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	     * absent
	     */
	    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
	      // If we have a handler factory - we might also call it here to determine if it provides
	      // a default text for a translationid that can't be found anywhere in our tables
	      if ($missingTranslationHandlerFactory) {
	        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
	      } else {
	        return translationId;
	      }
	    };
	
	    /**
	     * @name resolveForFallbackLanguage
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise that will resolve to the translation.
	     */
	    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
	          function (data) {
	            deferred.resolve(data);
	          },
	          function () {
	            // Look in the next fallback language for a translation.
	            // It delays the resolving by passing another promise to resolve.
	            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          }
	        );
	      } else {
	        // No translation found in any fallback language
	        // if a default translation text is set in the directive, then return this as a result
	        if (defaultTranslationText) {
	          deferred.resolve(defaultTranslationText);
	        } else {
	          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	
	          // if no default translation is set and an error handler is defined, send it to the handler
	          // and then return the result if it isn't undefined
	          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name resolveForFallbackLanguageInstant
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {string} translation
	     */
	    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result;
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        if (!result && result !== '') {
	          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	        }
	      }
	      return result;
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise, that resolves to the translation.
	     */
	    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {String} translation
	     */
	    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
	    };
	
	    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {
	
	      var deferred = $q.defer();
	
	      var table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	
	          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
	            .then(deferred.resolve, deferred.reject);
	        } else {
	          //
	          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
	          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
	          deferred.resolve(resolvedTranslation);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
	            .then(function (translation) {
	              deferred.resolve(translation);
	            }, function (_translationId) {
	              deferred.reject(applyNotFoundIndicators(_translationId));
	            });
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          }
	        } else {
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {
	
	      var result, table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = defaultInterpolator;
	
	      // if the interpolation id exists use custom interpolator
	      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	        Interpolator = interpolatorHashMap[interpolationId];
	      }
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
	        } else {
	          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
	          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackIndex = 0;
	          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          result = missingTranslationHandlerTranslation;
	        } else {
	          result = applyNotFoundIndicators(translationId);
	        }
	      }
	
	      return result;
	    };
	
	    var clearNextLangAndPromise = function (key) {
	      if ($nextLang === key) {
	        $nextLang = undefined;
	      }
	      langPromises[key] = undefined;
	    };
	
	    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
	      var fn = postProcessFn;
	
	      if (fn) {
	
	        if (typeof(fn) === 'string') {
	          // getting on-demand instance
	          fn = $injector.get(fn);
	        }
	        if (fn) {
	          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
	        }
	      }
	
	      return resolvedTranslation;
	    };
	
	    var loadTranslationsIfMissing = function (key) {
	      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          return translation;
	        });
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#preferredLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the preferred language.
	     *
	     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	     *
	     * @return {string} preferred language key
	     */
	    $translate.preferredLanguage = function (langKey) {
	      if (langKey) {
	        setupPreferredLanguage(langKey);
	      }
	      return $preferredLanguage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#cloakClassName
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured class name for `translate-cloak` directive.
	     *
	     * @return {string} cloakClassName
	     */
	    $translate.cloakClassName = function () {
	      return $cloakClassName;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#allowNamespaces
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns if namespaces are enabled
	     *
	     * @return {boolean} allowNamespaces value
	     */
	    $translate.allowNamespaces = function () {
	      return $allowNamespaces;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured delimiter for nested namespaces.
	     *
	     * @return {string} nestedObjectDelimeter
	     */
	    $translate.nestedObjectDelimeter = function () {
	      return $nestedObjectDelimeter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#fallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the fallback languages or sets a new fallback stack.
	     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
	     *
	     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	     *
	     * @return {string||array} fallback language key
	     */
	    $translate.fallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        fallbackStack(langKey);
	
	        // as we might have an async loader initiated and a new translation language might have been defined
	        // we need to add the promise to the stack also. So - iterate.
	        if ($loaderFactory) {
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              if (!langPromises[$fallbackLanguage[i]]) {
	                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	              }
	            }
	          }
	        }
	        $translate.use($translate.use());
	      }
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#useFallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Sets the first key of the fallback language stack to be used for translation.
	     * Therefore all languages in the fallback array BEFORE this key will be skipped!
	     *
	     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	     * get back to the whole stack
	     */
	    $translate.useFallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        if (!langKey) {
	          startFallbackIteration = 0;
	        } else {
	          var langKeyPosition = indexOf($fallbackLanguage, langKey);
	          if (langKeyPosition > -1) {
	            startFallbackIteration = langKeyPosition;
	          }
	        }
	
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#proposedLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key of language that is currently loaded asynchronously.
	     *
	     * @return {string} language key
	     */
	    $translate.proposedLanguage = function () {
	      return $nextLang;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns registered storage.
	     *
	     * @return {object} Storage
	     */
	    $translate.storage = function () {
	      return Storage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#negotiateLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a language key based on available languages and language aliases. If a
	     * language key cannot be resolved, returns undefined.
	     *
	     * If no or a falsy key is given, returns undefined.
	     *
	     * @param {string} [key] Language key
	     * @return {string|undefined} Language key or undefined if no language key is found.
	     */
	    $translate.negotiateLocale = negotiateLocale;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#use
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Tells angular-translate which language to use by given language key. This method is
	     * used to change language at runtime. It also takes care of storing the language
	     * key in a configured store to let your app remember the choosed language.
	     *
	     * When trying to 'use' a language which isn't available it tries to load it
	     * asynchronously with registered loaders.
	     *
	     * Returns promise object with loaded language file data or string of the currently used language.
	     *
	     * If no or a falsy key is given it returns the currently used language key.
	     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	     * @example
	     * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	     *
	     * @param {string=} key Language key
	     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	     */
	    $translate.use = function (key) {
	      if (!key) {
	        return $uses;
	      }
	
	      var deferred = $q.defer();
	      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"
	
	      $rootScope.$emit('$translateChangeStart', {language : key});
	
	      // Try to get the aliased language key
	      var aliasedKey = negotiateLocale(key);
	      // Ensure only registered language keys will be loaded
	      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
	        return $q.reject(key);
	      }
	
	      if (aliasedKey) {
	        key = aliasedKey;
	      }
	
	      // if there isn't a translation table for the language we've requested,
	      // we load it asynchronously
	      $nextLang = key;
	      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          deferred.resolve(translation.key);
	          if ($nextLang === key) {
	            useLanguage(translation.key);
	          }
	          return translation;
	        }, function (key) {
	          $rootScope.$emit('$translateChangeError', {language : key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateChangeEnd', {language : key});
	          return $q.reject(key);
	        });
	        langPromises[key]['finally'](function () {
	          clearNextLangAndPromise(key);
	        })['catch'](angular.noop); // we don't care about errors (clearing)
	      } else if (langPromises[key]) {
	        // we are already loading this asynchronously
	        // resolve our new deferred when the old langPromise is resolved
	        langPromises[key].then(function (translation) {
	          if ($nextLang === translation.key) {
	            useLanguage(translation.key);
	          }
	          deferred.resolve(translation.key);
	          return translation;
	        }, function (key) {
	          // find first available fallback language if that request has failed
	          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
	            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
	          } else {
	            return deferred.reject(key);
	          }
	        });
	      } else {
	        deferred.resolve(key);
	        useLanguage(key);
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#resolveClientLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	     *
	     * @returns {string} the current client/browser language key
	     */
	    $translate.resolveClientLocale = function () {
	      return getLocale();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storageKey
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the key for the storage.
	     *
	     * @return {string} storage key
	     */
	    $translate.storageKey = function () {
	      return storageKey();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether post compiling is enabled or not
	     *
	     * @return {bool} storage key
	     */
	    $translate.isPostCompilingEnabled = function () {
	      return $postCompilingEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether force async reload is enabled or not
	     *
	     * @return {boolean} forceAsyncReload value
	     */
	    $translate.isForceAsyncReloadEnabled = function () {
	      return $forceAsyncReloadEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isKeepContent
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether keepContent or not
	     *
	     * @return {boolean} keepContent value
	     */
	    $translate.isKeepContent = function () {
	      return $keepContent;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#refresh
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	     * the module will drop all existent translation tables and load new version of those which
	     * are currently in use.
	     *
	     * Refresh means that the module will drop target translation table and try to load it again.
	     *
	     * In case there are no loaders registered the refresh() method will throw an Error.
	     *
	     * If the module is able to refresh translation tables refresh() method will broadcast
	     * $translateRefreshStart and $translateRefreshEnd events.
	     *
	     * @example
	     * // this will drop all currently existent translation tables and reload those which are
	     * // currently in use
	     * $translate.refresh();
	     * // this will refresh a translation table for the en_US language
	     * $translate.refresh('en_US');
	     *
	     * @param {string} langKey A language key of the table, which has to be refreshed
	     *
	     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	     * process is finished successfully, and reject if not.
	     */
	    $translate.refresh = function (langKey) {
	      if (!$loaderFactory) {
	        throw new Error('Couldn\'t refresh translation table, no loader registered!');
	      }
	
	      $rootScope.$emit('$translateRefreshStart', {language : langKey});
	
	      var deferred = $q.defer(), updatedLanguages = {};
	
	      //private helper
	      function loadNewData(languageKey) {
	        var promise = loadAsync(languageKey);
	        //update the load promise cache for this language
	        langPromises[languageKey] = promise;
	        //register a data handler for the promise
	        promise.then(function (data) {
	            //clear the cache for this language
	            $translationTable[languageKey] = {};
	            //add the new data for this language
	            translations(languageKey, data.table);
	            //track that we updated this language
	            updatedLanguages[languageKey] = true;
	          },
	          //handle rejection to appease the $q validation
	          angular.noop);
	        return promise;
	      }
	
	      //set up post-processing
	      deferred.promise.then(
	        function () {
	          for (var key in $translationTable) {
	            if ($translationTable.hasOwnProperty(key)) {
	              //delete cache entries that were not updated
	              if (!(key in updatedLanguages)) {
	                delete $translationTable[key];
	              }
	            }
	          }
	          if ($uses) {
	            useLanguage($uses);
	          }
	        },
	        //handle rejection to appease the $q validation
	        angular.noop
	      )['finally'](
	        function () {
	          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
	        }
	      );
	
	      if (!langKey) {
	        // if there's no language key specified we refresh ALL THE THINGS!
	        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
	        if ($uses && languagesToReload.indexOf($uses) === -1) {
	          languagesToReload.push($uses);
	        }
	        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
	
	      } else if ($translationTable[langKey]) {
	        //just refresh the specified language cache
	        loadNewData(langKey).then(deferred.resolve, deferred.reject);
	
	      } else {
	        deferred.reject();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#instant
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a translation instantly from the internal state of loaded translation. All rules
	     * regarding the current language, the preferred language of even fallback languages will be
	     * used except any promise handling. If a language was not found, an asynchronous loading
	     * will be invoked in the background.
	     *
	     * @param {string|array} translationId A token which represents a translation id
	     *                                     This can be optionally an array of translation ids which
	     *                                     results that the function's promise returns an object where
	     *                                     each key is the translation id and the value the translation.
	     * @param {object=} [interpolateParams={}] Params
	     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	     *
	     * @return {string|object} translation
	     */
	    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
	
	      // we don't want to re-negotiate $uses
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Detect undefined and null values to shorten the execution and prevent exceptions
	      if (translationId === null || angular.isUndefined(translationId)) {
	        return translationId;
	      }
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        var results = {};
	        for (var i = 0, c = translationId.length; i < c; i++) {
	          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
	        }
	        return results;
	      }
	
	      // We discarded unacceptable values. So we just need to verify if translationId is empty String
	      if (angular.isString(translationId) && translationId.length < 1) {
	        return translationId;
	      }
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var result, possibleLangKeys = [];
	      if ($preferredLanguage) {
	        possibleLangKeys.push($preferredLanguage);
	      }
	      if (uses) {
	        possibleLangKeys.push(uses);
	      }
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	      }
	      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	        var possibleLangKey = possibleLangKeys[j];
	        if ($translationTable[possibleLangKey]) {
	          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
	          }
	        }
	        if (typeof result !== 'undefined') {
	          break;
	        }
	      }
	
	      if (!result && result !== '') {
	        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	          result = applyNotFoundIndicators(translationId);
	        } else {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);
	
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          var missingTranslationHandlerTranslation;
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	          }
	
	          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            result = missingTranslationHandlerTranslation;
	          }
	        }
	      }
	
	      return result;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#versionInfo
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the current version information for the angular-translate library
	     *
	     * @return {string} angular-translate version
	     */
	    $translate.versionInfo = function () {
	      return version;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#loaderCache
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the defined loaderCache.
	     *
	     * @return {boolean|string|object} current value of loaderCache
	     */
	    $translate.loaderCache = function () {
	      return loaderCache;
	    };
	
	    // internal purpose only
	    $translate.directivePriority = function () {
	      return directivePriority;
	    };
	
	    // internal purpose only
	    $translate.statefulFilter = function () {
	      return statefulFilter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	     *
	     * @return {boolean} current value of ready
	     */
	    $translate.isReady = function () {
	      return $isReady;
	    };
	
	    var $onReadyDeferred = $q.defer();
	    $onReadyDeferred.promise.then(function () {
	      $isReady = true;
	    });
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#onReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	     *
	     * @param {Function=} fn Function to invoke when service is ready
	     * @return {object} Promise resolved when service is ready
	     */
	    $translate.onReady = function (fn) {
	      var deferred = $q.defer();
	      if (angular.isFunction(fn)) {
	        deferred.promise.then(fn);
	      }
	      if ($isReady) {
	        deferred.resolve();
	      } else {
	        $onReadyDeferred.promise.then(deferred.resolve);
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This function simply returns the registered language keys being defined before in the config phase
	     * With this, an application can use the array to provide a language selection dropdown or similar
	     * without any additional effort
	     *
	     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
	     */
	    $translate.getAvailableLanguageKeys = function () {
	      if ($availableLanguageKeys.length > 0) {
	        return $availableLanguageKeys;
	      }
	      return null;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getTranslationTable
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns translation table by the given language key.
	     *
	     * Unless a language is provided it returns a translation table of the current one.
	     * Note: If translation dictionary is currently downloading or in progress
	     * it will return null.
	     *
	     * @param {string} langKey A token which represents a translation id
	     *
	     * @return {object} a copy of angular-translate $translationTable
	     */
	    $translate.getTranslationTable = function (langKey) {
	      langKey = langKey || $translate.use();
	      if (langKey && $translationTable[langKey]) {
	        return angular.copy($translationTable[langKey]);
	      }
	      return null;
	    };
	
	    // Whenever $translateReady is being fired, this will ensure the state of $isReady
	    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	      $onReadyDeferred.resolve();
	      globalOnReadyListener(); // one time only
	      globalOnReadyListener = null;
	    });
	    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	      $onReadyDeferred.resolve();
	      globalOnChangeListener(); // one time only
	      globalOnChangeListener = null;
	    });
	
	    if ($loaderFactory) {
	
	      // If at least one async loader is defined and there are no
	      // (default) translations available we should try to load them.
	      if (angular.equals($translationTable, {})) {
	        if ($translate.use()) {
	          $translate.use($translate.use());
	        }
	      }
	
	      // Also, if there are any fallback language registered, we start
	      // loading them asynchronously as soon as we can.
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        var processAsyncResult = function (translation) {
	          translations(translation.key, translation.table);
	          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
	          return translation;
	        };
	        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	          var fallbackLanguageId = $fallbackLanguage[i];
	          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	          }
	        }
	      }
	    } else {
	      $rootScope.$emit('$translateReady', {language : $translate.use()});
	    }
	
	    return $translate;
	  }];
	}
	
	$translate.displayName = 'displayName';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	function $translateDefaultInterpolation ($interpolate, $translateSanitization) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given value agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
	   *
	   * @param {string} value translation
	   * @param {object} [interpolationParams={}] interpolation params
	   * @param {string} [context=undefined] current context (filter, directive, service)
	   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
	   * @param {string} translationId current translationId
	   *
	   * @returns {string} interpolated string
	   */
	  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);
	
	    var interpolatedText;
	    if (angular.isNumber(value)) {
	      // numbers are safe
	      interpolatedText = '' + value;
	    } else if (angular.isString(value)) {
	      // strings must be interpolated (that's the job here)
	      interpolatedText = $interpolate(value)(interpolationParams);
	      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
	    } else {
	      // neither a number or a string, cant interpolate => empty string
	      interpolatedText = '';
	    }
	
	    return interpolatedText;
	  };
	
	  return $translateInterpolator;
	}
	
	$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $interpolate,
	 * @requires $compile,
	 * @requires $parse,
	 * @requires $rootScope
	 * @restrict AE
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses $translate service to translate the translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	
	          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', translateDirective);
	function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {
	
	  'use strict';
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    priority: $translate.directivePriority(),
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
	        tAttr.translateSanitizeStrategy : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = '';
	        scope.postText = '';
	        scope.translateNamespace = getTranslateNamespace(scope);
	        var translationIds = {};
	
	        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
	          // initial setup
	          if (iAttr.translateValues) {
	            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	          }
	          // initially fetch all attributes if existing and fill the params
	          if (translateValueExist) {
	            for (var attr in tAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
	                interpolateParams[attributeName] = tAttr[attr];
	              }
	            }
	          }
	        };
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	
	          // Remove any old watcher
	          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	            observeElementTranslation._unwatchOld();
	            observeElementTranslation._unwatchOld = undefined;
	          }
	
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            var iElementText = trim.apply(iElement.text()).replace(/\n/g, ' ');
	
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElementText.match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              var watcherMatches = iElementText.match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              // do not assigne the translation id if it is empty.
	              translationIds.translate = !iElementText ? undefined : iElementText;
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        // initial setup with values
	        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	        var firstAttributeChangedEvent = true;
	        iAttr.$observe('translate', function (translationId) {
	          if (typeof translationId === 'undefined') {
	            // case of element "<translate>xyz</translate>"
	            observeElementTranslation('');
	          } else {
	            // case of regular attribute
	            if (translationId !== '' || !firstAttributeChangedEvent) {
	              translationIds.translate = translationId;
	              updateTranslations();
	            }
	          }
	          firstAttributeChangedEvent = false;
	        });
	
	        for (var translateAttr in iAttr) {
	          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	          updateTranslations();
	        });
	
	        if (translateSanitizeStrategyExist) {
	          iAttr.$observe('translateSanitizeStrategy', function (value) {
	            scope.sanitizeStrategy = $parse(value)(scope.$parent);
	            updateTranslations();
	          });
	        }
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	          if (translationId) {
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (translateNamespace && translationId.charAt(0) === '.') {
	              translationId = translateNamespace + translationId;
	            }
	
	            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
	              .then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	          } else {
	            // as an empty string cannot be translated, we can solve this using successful=false
	            applyTranslation(translationId, scope, false, translateAttr);
	          }
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (!successful) {
	            if (typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	          }
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
	              iElement.empty().append(scope.preText + value + scope.postText);
	            }
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            var attributeName = iAttr.$attr[translateAttr];
	            if (attributeName.substr(0, 5) === 'data-') {
	              // ensure html5 data prefix is stripped
	              attributeName = attributeName.substr(5);
	            }
	            attributeName = attributeName.substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	          scope.$watch('interpolateParams', updateTranslations, true);
	        }
	
	        // Replaced watcher on translateLanguage with event listener
	        scope.$on('translateLanguageChanged', updateTranslations);
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          if (iAttr.translate) {
	            observeElementTranslation(iAttr.translate);
	          } else {
	            observeElementTranslation('');
	          }
	        } else if (iAttr.translate) {
	          // ensure attribute will be not skipped
	          observeElementTranslation(iAttr.translate);
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateDirective.displayName = 'translateDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate-attr
	 * @restrict A
	 *
	 * @description
	 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
	 * Internally it uses `translate` service to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
	 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('placeholder)).toBe('Hello there!');
	          expect(element.attr('title)).toBe('The following value is dynamic: 5');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translateAttr', translateAttrDirective);
	function translateAttrDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    priority: $translate.directivePriority(),
	    link: function linkFn(scope, element, attr) {
	
	      var translateAttr,
	          translateValues,
	          translateSanitizeStrategy,
	          previousAttributes = {};
	
	      // Main update translations function
	      var updateTranslations = function () {
	        angular.forEach(translateAttr, function (translationId, attributeName) {
	          if (!translationId) {
	            return;
	          }
	          previousAttributes[attributeName] = true;
	
	          // if translation id starts with '.' and translateNamespace given, prepend namespace
	          if (scope.translateNamespace && translationId.charAt(0) === '.') {
	            translationId = scope.translateNamespace + translationId;
	          }
	          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
	            .then(function (translation) {
	              element.attr(attributeName, translation);
	            }, function (translationId) {
	              element.attr(attributeName, translationId);
	            });
	        });
	
	        // Removing unused attributes that were previously used
	        angular.forEach(previousAttributes, function (flag, attributeName) {
	          if (!translateAttr[attributeName]) {
	            element.removeAttr(attributeName);
	            delete previousAttributes[attributeName];
	          }
	        });
	      };
	
	      // Watch for attribute changes
	      watchAttribute(
	        scope,
	        attr.translateAttr,
	        function (newValue) { translateAttr = newValue; },
	        updateTranslations
	      );
	      // Watch for value changes
	      watchAttribute(
	        scope,
	        attr.translateValues,
	        function (newValue) { translateValues = newValue; },
	        updateTranslations
	      );
	      // Watch for sanitize strategy changes
	      watchAttribute(
	        scope,
	        attr.translateSanitizeStrategy,
	        function (newValue) { translateSanitizeStrategy = newValue; },
	        updateTranslations
	      );
	
	      if (attr.translateValues) {
	        scope.$watch(attr.translateValues, updateTranslations, true);
	      }
	
	      // Replaced watcher on translateLanguage with event listener
	      scope.$on('translateLanguageChanged', updateTranslations);
	
	      // Ensures the text will be refreshed after the current language was changed
	      // w/ $translate.use(...)
	      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	      updateTranslations();
	      scope.$on('$destroy', unbind);
	    }
	  };
	}
	
	function watchAttribute(scope, attribute, valueCallback, changeCallback) {
	  'use strict';
	  if (!attribute) {
	    return;
	  }
	  if (attribute.substr(0, 2) === '::') {
	    attribute = attribute.substr(2);
	  } else {
	    scope.$watch(attribute, function(newValue) {
	      valueCallback(newValue);
	      changeCallback();
	    }, true);
	  }
	  valueCallback(scope.$eval(attribute));
	}
	
	translateAttrDirective.displayName = 'translateAttrDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', translateCloakDirective);
	
	function translateCloakDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    compile : function (tElement) {
	      var applyCloak = function (element) {
	          element.addClass($translate.cloakClassName());
	        },
	        removeCloak = function (element) {
	          element.removeClass($translate.cloakClassName());
	        };
	      applyCloak(tElement);
	
	      return function linkFn(scope, iElement, iAttr) {
	        //Create bound functions that incorporate the active DOM element.
	        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          // Register a watcher for the defined translation allowing a fine tuned cloak
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(iRemoveCloak, iApplyCloak);
	          });
	          $rootScope.$on('$translateChangeSuccess', function () {
	            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
	          });
	        } else {
	          $translate.onReady(iRemoveCloak);
	        }
	      };
	    }
	  };
	}
	
	translateCloakDirective.displayName = 'translateCloakDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It is possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateNamespace', translateNamespaceDirective);
	
	function translateNamespaceDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return {
	        pre: function (scope, iElement, iAttrs) {
	          scope.translateNamespace = _getTranslateNamespace(scope);
	
	          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	            scope.translateNamespace += iAttrs.translateNamespace;
	          } else {
	            scope.translateNamespace = iAttrs.translateNamespace;
	          }
	        }
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function _getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return _getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateLanguage
	 * @restrict A
	 *
	 * @description
	 * Forces the language to the directives in the underlying scope.
	 *
	 * @param {string=} translate language that will be negotiated.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div>
	
	        <div>
	            <h1 translate>HELLO</h1>
	        </div>
	
	        <div translate-language="de">
	            <h1 translate>HELLO</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider
	          .translations('en',{
	            'HELLO': 'Hello world!'
	          })
	          .translations('de',{
	            'HELLO': 'Hallo Welt!'
	          })
	          .preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateLanguage', translateLanguageDirective);
	
	function translateLanguageDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return function linkFn(scope, iElement, iAttrs) {
	
	        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
	          scope.translateLanguage = newTranslateLanguage;
	        });
	
	        scope.$watch('translateLanguage', function(){
	          scope.$broadcast('translateLanguageChanged');
	        });
	      };
	    }
	  };
	}
	
	translateLanguageDirective.displayName = 'translateLanguageDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', translateFilterFactory);
	
	function translateFilterFactory($parse, $translate) {
	
	  'use strict';
	
	  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
	    if (!angular.isObject(interpolateParams)) {
	      var ctx = this || {
	        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
	        };
	      interpolateParams = $parse(interpolateParams)(ctx);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
	  };
	
	  if ($translate.statefulFilter()) {
	    translateFilter.$stateful = true;
	  }
	
	  return translateFilter;
	}
	
	translateFilterFactory.displayName = 'translateFilterFactory';
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */
	  .factory('$translationCache', $translationCache);
	
	function $translationCache($cacheFactory) {
	
	  'use strict';
	
	  return $cacheFactory('translations');
	}
	
	$translationCache.displayName = '$translationCache';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.19.0 - 2021-09-02
	 * 
	 * Copyright (c) 2021 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	$translateStaticFilesLoader.$inject = ['$q', '$http'];
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateStaticFilesLoader
	 * @requires $q
	 * @requires $http
	 *
	 * @description
	 * Creates a loading function for a typical static file url pattern:
	 * "lang-en_US.json", "lang-de_DE.json", etc. Using this builder,
	 * the response of these urls must be an object of key-value pairs.
	 *
	 * @param {object} options Options object, which gets prefix, suffix, key, and fileMap
	 */
	.factory('$translateStaticFilesLoader', $translateStaticFilesLoader);
	
	function $translateStaticFilesLoader($q, $http) {
	
	  'use strict';
	
	  return function (options) {
	
	    if (!options || (!angular.isArray(options.files) && (!angular.isString(options.prefix) || !angular.isString(options.suffix)))) {
	      throw new Error('Couldn\'t load static files, no files and prefix or suffix specified!');
	    }
	
	    if (!options.files) {
	      options.files = [{
	        prefix: options.prefix,
	        suffix: options.suffix
	      }];
	    }
	
	    var load = function (file) {
	      if (!file || (!angular.isString(file.prefix) || !angular.isString(file.suffix))) {
	        throw new Error('Couldn\'t load static file, no prefix or suffix specified!');
	      }
	
	      var fileUrl = [
	        file.prefix,
	        options.key,
	        file.suffix
	      ].join('');
	
	      if (angular.isObject(options.fileMap) && options.fileMap[fileUrl]) {
	        fileUrl = options.fileMap[fileUrl];
	      }
	
	      return $http(angular.extend({
	        url: fileUrl,
	        method: 'GET'
	      }, options.$http))
	        .then(function(result) {
	          return result.data;
	        }, function () {
	          return $q.reject(options.key);
	        });
	    };
	
	    var promises = [],
	        length = options.files.length;
	
	    for (var i = 0; i < length; i++) {
	      promises.push(load({
	        prefix: options.files[i].prefix,
	        key: options.key,
	        suffix: options.files[i].suffix
	      }));
	    }
	
	    return $q.all(promises)
	      .then(function (data) {
	        var length = data.length,
	            mergedData = {};
	
	        for (var i = 0; i < length; i++) {
	          for (var key in data[i]) {
	            mergedData[key] = data[i][key];
	          }
	        }
	
	        return mergedData;
	      });
	  };
	}
	
	$translateStaticFilesLoader.displayName = '$translateStaticFilesLoader';
	return 'pascalprecht.translate';
	
	}));


/***/ })
/******/ ])));


// WEBPACK FOOTER //
// app.9215c9294bef15a322a0.js